(function () {
	'use strict';

	angular
		.module('trakeyeApp', [
			'ngStorage',
			'cp.ngConfirm',
			'tmh.dynamicLocale',
			'pascalprecht.translate',
			'ngResource',
			'ngCookies',
			'ngAria',
			'ngCacheBuster',
			'ngFileUpload',
			'ui.bootstrap',
			'ui.bootstrap.datetimepicker',
			'ui.router',
			"isteven-multi-select",
			'infinite-scroll',
			// jhipster-needle-angularjs-add-module JHipster will add new module here
			'angular-loading-bar',
			'angularUtils.directives.dirPagination'
			//            'uiGmapgoogle-maps'
		])
		.run(run)
		//Added for Before and After login design changes
		.run([
			'$log', '$rootScope', '$window', '$state', '$location', '$timeout',
			function ($log, $rootScope, $window, $state, $location, $timeout) {
				$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
					$(window).resize(function () {
						if ($(window).height() <= 250) {
							$rootScope.mapHeight = ($(window).height() + 262);
							$rootScope.userMapHeight = ($(window).height() + 262);
						}
						else {
							$rootScope.mapHeight = ($(window).height() - 220);
							$rootScope.userMapHeight = ($(window).height() - 262);
						}
					});
					$(window).trigger('resize');
					$(".select2-container").hide();//Added to hide select2 search box
					if (toState.url == "/") {
						$('body').addClass('layout-top-nav').removeClass('sidebar-mini tryitbg');
						$('.main-footer').addClass('home-footer');
					} else {
						$('body').removeClass('layout-top-nav').addClass('sidebar-mini');
						$('.content-wrapper').removeClass('home-container tryitbg');
						$('.main-footer').removeClass('home-footer');
					}
					if (toState.url == "/login" || toState.url == "/reset/request" || toState.url == "/reset/finish?key" || toState.url == "/accessdenied") {
						$('body').addClass('layout-top-nav').removeClass('sidebar-mini');
						$('.content-wrapper').addClass('main-wrapper');
						$('.main-footer').addClass('login-footer');
					} else {
						$('.content-wrapper').removeClass('main-wrapper tryitbg').addClass('sidebar-mini');
						$('.main-footer').removeClass('login-footer');
					}
					if (toState.url == "/register") {
						$('body').addClass('layout-top-nav tryitbg').removeClass('sidebar-mini');
						$('.content-wrapper').addClass('main-wrapper tryitbg');
						$('.main-footer').addClass('home-footer');
					} else {
						$('body').removeClass('tryitbg').addClass('sidebar-mini');
						$('.content-wrapper').removeClass('main-wrapper tryittrans').addClass('sidebar-mini');
						$('.main-footer').removeClass('home-footer');
					}

					if (toState.url == "/feasibilityverify/finish?key") {
						$('body').addClass('layout-top-nav remove-header');
						$('.main-footer').addClass('home-footer');

					}
					//Added for redirecting to login page
					if (toState.url == "/accessdenied") {
						$timeout(function () {
							$state.go('login');
						}, 5000);
					}

				});
			}
		])
		//Added for upload required functionality
		.directive('validFile', function () {
			return {
				require: 'ngModel',
				link: function (scope, el, attrs, ngModel) {
					//change event is fired when file is selected
					el.bind('change', function () {
						scope.$apply(function () {
							ngModel.$setViewValue(el.val());
							ngModel.$render();
						})
					})
				}
			}
		});


	run.$inject = ['stateHandler', 'translationHandler'];

	function run(stateHandler, translationHandler) {
		stateHandler.initialize();
		translationHandler.initialize();
	}
})();
/* window.addEventListener('load', function () {

	var script = document.createElement('script');
	script.type = 'text/javascript';
	//script.src = '//maps.googleapis.com/maps/api/js?key=AIzaSyBQkX1R_APZPjwrgt5h0UsVXga2EoXNJ5c&libraries=geometry,drawing';
	document.body.appendChild(script);
}); */

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('upload', {
                parent: 'app',
                url: '/upload',
                data: {
                    authorities: ['ROLE_SUPER_ADMIN', 'ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER'],
                    pageTitle: 'global.menu.admin.upload'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/upload/uploadagent.html',
                        controller: 'UploadController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }


            })
    }
})();
(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('Upload', Upload);

    Upload.$inject = ['$http'];

    function Upload ($http) {
       
        var service ={};
    	service.upload = function (data,callback){
    		
    		$http.post('api/upload',data,{
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
             }).then(function(response){
    			
        		callback(response,response.headers);
        	}, function(error){
        		callback(error, error.headers);
        	});
    	};
    	
    	 service.findAllFiles= function (callback){
    			$http.get('api/listfiles').then(function(response){
    	    	    callback(response.data);
    	    	});
    		};
    		
         service.findAllIosFiles= function (callback){
    				$http.get('api/listfiles-ios').then(function(response){
    		    	    callback(response.data);
    		    	});
         };		
    	return service;
    }
    
})();


(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('UploadController', UploadController)
        .directive('agentFile', [function() {
        'use strict';

        return {
            restrict: "A",

            link: function($scope, element){

                element.change(function(event){
                    $scope.$apply(function(){
                      $scope.myFile =element[0].files[0];
                      $scope.versionNo = $scope.version;
                      
                    });
                });
            }

        };
    }]);

    UploadController.$inject = ['$scope', '$state', 'Auth', 'Principal','Upload' ,'ProfileService', 'LoginService','$rootScope','$timeout','$window'];

    function UploadController ($scope, $state, Auth, Principal,Upload, ProfileService, LoginService, $rootScope,$timeout, $window) {
    	$scope.FILE_EXT_REGEXP =/^(.*?)\.(apk||ipa)$/;
    	
        var vm = this;
        vm.upload = upload;
        vm.success= null;
        vm.fileempty = null;
        vm.error = null;
        vm.files=[];
        vm.iosfiles=[];
        vm.showiosfiles=showiosfiles;
        vm.showandroidfiles=showandroidfiles;
        
      
//        vm.changedFile =fileselected;
        var formData;
        function upload () {
        formData=new FormData();
       
        formData.append("version", $scope.version);
        formData.append('file',$scope.myFile);
        
               Upload.upload(formData,function(response,headers){
            	    if(response.status == 200){
                		vm.error=null;
                		vm.success='OK';
                		$scope.version='';
                		
               		$timeout(function(){
               			vm.success= '';
               		},4000);
               		
               		Upload.findAllFiles(function(data){
                        	vm.files=data;
                        });
                		
               		Upload.findAllIosFiles(function(data){
                			vm.iosfiles=data;
                		});
                	} 
                	if(response.status == 400){
                		vm.success=null;
                		vm.error='error';
                			
                	} 
                });
        
        }   
        //Added for upload styles
        $(":file").filestyle({buttonBefore: true});      
        //$(":file").filestyle('placeholder', 'Choose File');
        $(":file").filestyle('buttonText', 'Browse File');
        
        function showiosfiles(){
          Upload.findAllIosFiles(function(data){
        	  vm.iosfiles=data;
          });
        }
        
        vm.showandroidfiles();
        
        function showandroidfiles(){
        	Upload.findAllFiles(function(data){
          	  vm.files=data;
            });
        }
        $scope.tab = 1;

		$scope.setTab = function(newTab){
		  $scope.tab = newTab;
		  if( $scope.tab==1){
			  vm.showandroidfiles();
		  }
		  if( $scope.tab==2){
			  vm.showiosfiles();
		  }
		};

		$scope.isSet = function(tabNum){
		  return $scope.tab === tabNum;
		};
    }
   
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('User', User);

	User.$inject = ['$resource'];

	function User($resource) {
		var service = $resource('api/users/:login', {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'save': {
				method: 'POST'
			},
			'update': {
				method: 'PUT'
			},
			'delete': {
				method: 'DELETE'
			}
		});

		return service;
	}
})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserSearch', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getuserbyname = function (data, callback) {
			$http.get('api/users-details/' + data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadUsers', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-users').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserById', UserById);

	UserById.$inject = ['$resource'];

	function UserById($resource) {
		var service = $resource('api/user-data/:userId', {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UsersByVendorId', UsersByVendorId);

	UsersByVendorId.$inject = ['$resource'];

	function UsersByVendorId($resource) {
		var service = $resource('api/vendor-users/:userId', {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
		});

		return service;
	}
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UsersByVendorId', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (vendorId, callback) {
            $http.get('api/vendor-users/' + vendorId).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserDetails', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getuserbystatus = function (data, callback) {
			$http.get('api/user/userdetails/' + data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserIDs', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/userslist').then(function (response) {
				callback(response.data);
			});
		};

		service.getAdminAll = function (callback) {
			$http.get('api/adminuserslist').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ActivatedUsers', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getactivatedusers = function (callback) {
			$http.get('api/activateduserlist').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UsersByGeo', UsersByGeo);

	UsersByGeo.$inject = ['$resource'];

	function UsersByGeo($resource) {
		var service = $resource('/api/geousers/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserValueSearch', UserValueSearch);

	UserValueSearch.$inject = ['$resource'];

	function UserValueSearch($resource) {
		var service = $resource('/api/users/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserValueGeofenceSearch', UserValueGeofenceSearch);

	UserValueGeofenceSearch.$inject = ['$resource'];

	function UserValueGeofenceSearch($resource) {
		var service = $resource('/api/users/geosearchvalue/:geofenceId/:search/:columnNames', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UsersStatusService', UsersStatusService);

	UsersStatusService.$inject = ['$resource'];

	function UsersStatusService($resource) {
		var service = $resource('api/userdetails/:status/:geofenceId', {geofenceId : '@geofenceId'}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserStatusSearch', UserStatusSearch);

	UserStatusSearch.$inject = ['$resource'];

	function UserStatusSearch($resource) {
		var service = $resource('/api/userdetails/statussearch/:status/:searchtext', {
			status: '@status',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ActivatedUserSearch', ActivatedUserSearch);

	ActivatedUserSearch.$inject = ['$resource'];

	function ActivatedUserSearch($resource) {
		var service = $resource('/api/users/searchactivatedusers/:userId/:user', {
			userId: '@id'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AssocitedVendorSearch', AssocitedVendorSearch);

	AssocitedVendorSearch.$inject = ['$resource'];

	function AssocitedVendorSearch($resource) {
		var service = $resource('/api/users/searchvendors/:userId/:user', {
			userId: '@id'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UserHierarchy', UserHierarchy);

	UserHierarchy.$inject = ['$resource'];

	function UserHierarchy($resource) {
		var service = $resource('api/users/reporties/:login', {
			login: 'bang_south'
		}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UsersHierarchy', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		/*
		 * service.getUserHierarchy = function (callback){
		 * $http.get('api/users/reporties').then(function(response){
		 * callback(response.data); }); };
		 */

		service.getUsersHierarchy = function (login, callback) {
			var url = 'api/users/reporties/';
			if (login != null) {
				url = url + login
			}
			$http.get(url).then(function (response) {
				callback(response.data);
			});

		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('BaseUrl', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getBaseUrl = function (callback) {
            $http.get('api/base-url').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource'];

    function Customer ($resource) {
        var service = $resource('api/customers', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CustomerValueSearch', CustomerValueSearch);

    CustomerValueSearch.$inject = ['$resource'];

    function CustomerValueSearch ($resource) {
    	var service = $resource('/api/customers/searchvalue/:customerId',{customerId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CustomerDetails', CustomerDetails);

    CustomerDetails.$inject = ['$resource'];

    function CustomerDetails ($resource) {
    	var service = $resource('/api/customer/:customerId',{customerId:'@id'},{},{
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
}) ();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CustomerUpdate', CustomerUpdate);

    CustomerUpdate.$inject = ['$resource'];

    function CustomerUpdate ($resource) {
    	var service = $resource('/api/customer',{},{
            'update': { method:'PUT' },
            'save': { method:'POST' },
        });

        return service;
    }
})();


(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        var service = $resource('api/customer', {}, {
            'save': { method:'POST' }
        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account','$rootScope','Configs'];

    function Principal ($q, Account,$rootScope,Configs) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                $rootScope.loginUserId = account.data.id 
                $rootScope.rolloutMapInitZoom = 15
                $rootScope.loginUserName = account.data.login 
               /*  $rootScope.isVendorAdmin = account.data.authorities.find(function (each){
                    if(each == "ROLE_VENDOR_ADMIN" || each == "ROLE_ROLLOUT_MANAGER" || each == "ROLE_ROLLOUT_ADMIN" ) {return true} 
                })  */

                
                    Configs.rolloutFeatures(function (response) {
                        $rootScope.Roles = {}
                        if (response && response.length) {
                            response.forEach(function (value) {
                                $rootScope.Roles[value.configKey] = true 
    
                                if(value.configKey == "noOfWorkingHours"){
                                    $rootScope.maxNoOfWorkingHours = parseInt(value.configValue)
                                }
                            });
                            if($rootScope.Roles){
                                for (var key in $rootScope.Roles) {
                                    if ($rootScope.Roles.hasOwnProperty(key)) {
                                        account.data.authorities.push(key);
                                    }
                                  }
                            }
                        }
                        _identity = account.data;
                        _authenticated = true;
                        deferred.resolve(_identity);
                    },function (err){
                        $rootScope.Roles = {}
                    
                        _identity = account.data;
                        _authenticated = true;
                        deferred.resolve(_identity);
                    });
                   
                

                $rootScope.isVendorAdmin = account.data.authorities.find(function (each){
                    if(each == "ROLE_VENDOR_ADMIN") {return true} 
                })
                $rootScope.isRolloutAdmin = account.data.authorities.find(function (each){
                    if(each == "ROLE_ROLLOUT_ADMIN") {return true} 
                })
                $rootScope.isManager = account.data.authorities.find(function (each){
                    if(each == "ROLE_ROLLOUT_MANAGER") {return true} 
                })
                $rootScope.isVendor = account.data.authorities.find(function (each){
                    if(each == "ROLE_ROLLOUT_VENDOR") {return true} 
                })

        var appOwner = null;
        Configs.get("AppOwner", function (response) {
            appOwner = response[0].configValue;
            if(appOwner!=null){
                $rootScope.APP_NAME=appOwner;
            }
        });

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    var userLatitude = position.coords.latitude;
                    var userLongitude = position.coords.longitude;
                    
                    getLatLng(userLatitude, userLongitude);
                },
                function () {
                    callConfigLatLng()
                    console.error("Error: The Geolocation service failed.");
                }
            );
        } else {
            callConfigLatLng()
            console.error("Error: Your browser doesn't support geolocation.");
        }

        function getLatLng(lat, lng) {
            $rootScope.DEFAULT_LATITUDE = lat;
            $rootScope.DEFAULT_LONGITUDE = lng;
        }

        function callConfigLatLng(){
            var tempLat = "32.77059340204903";
            var tempLng = "-96.83874469246176"
            Configs.getLatLng(function(lat,lng){
                if(lat != null && lng != null){
                    $rootScope.DEFAULT_LATITUDE = lat;
                    $rootScope.DEFAULT_LONGITUDE = lng;
                }else{
                    getLatLng(tempLat, tempLng)
                }
                
            },function (error){
                getLatLng(tempLat,tempLng)
            })
        }
              

                //switch
               /*  Configs.get("Features", function (response) {
                    response.filter(function (value){

                        if(value.configKey == "ProjectExplorer"){
                            if(value.configValue == "True"){
                                $rootScope.showProjectExplorer = true
                            }else{
                                $rootScope.showProjectExplorer = false
                            }
                        } })}) */
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$http','$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $http,$state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            verify: verify
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
        	AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
        
        function verify(data,callback){
        	/*AuthServerProvider.logout();
            Principal.authenticate(null);*/
        	$http.post('api/account/verify',data,{
                
             }).then(function(response){
            	callback(response);
        	}, function(error){
        		callback(error);
        	});
    	};
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UserLogout', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.post = function ( data, callback) {
            $http.post("api/logout", data).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q','Configs','$rootScope'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q,Configs,$rootScope) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                   /*  Configs.rolloutFeatures(function (response) {
                        $rootScope.Roles = {}
                        if (response && response.length) {
                            response.forEach(function (value) {
                                $rootScope.Roles[value.configKey] = true 
                            });
                        }
                    }); */

                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }

                
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
        	
            /*var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
              
                $http.post('api/logout',$.param(""),
                		{
                	      headers:
                	    	  {
                	    	  'Content-Type' : 'application/json',
                	    	  'Authorization' : 'Bearer ' + token

                	    	  }
                		}
                		
                ).then(function(response){
            	    callback(response.data);
            	});
            }*/
            
        	
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Account', Account);

    Account.$inject = ['$resource','Configs','$rootScope'];

    function Account ($resource,Configs,$rootScope) {
        
       /*  Configs.rolloutFeatures(function (response) {
                $rootScope.Roles = {}
                if (response && response.length) {
                    response.forEach(function (value) {
                        $rootScope.Roles[value.configKey] = true 
                    });
                }
        }); */


        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('VehicleDistanceController', VehicleDistanceController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	VehicleDistanceController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function VehicleDistanceController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadVehicleDistanceReport = downloadVehicleDistanceReport;
		vm.report = report;
		vm.reporthide = false;
		vm.sortResponse = sortResponse;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "gpsUser";
		vm.selecterange = selectRange;

		vm.select2();

		vm.vehicles = loadPage();

		function loadPage() {
			Report.getVehicles('', function (response) {
				vm.vehicles = response;
			})
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadVehicleDistanceReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getVehicleDistanceReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "vehicle_distance_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getVehicleDistanceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getVehicleDistanceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('UserStatsController', UserStatsController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	UserStatsController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function UserStatsController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadUserStatsReport = downloadUserStatsReport;
		vm.report = report;
		vm.sortResponse = sortResponse;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "gpsUser";
		vm.selecterange = selectRange;

		vm.select2();

		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
			})
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadUserStatsReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserDistanceStatsReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "user_distance_statistics_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserStatsReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserStatsReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

	}
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("UserReportingController", UserReportingController);
    angular.module("trakeyeApp").filter("trustFilter", [
        "$sce",
        function ($sce) {
            return function (text) {
                return $sce.trustAsHtml(text);
            };
        },
    ]);

    UserReportingController.$inject = ["$scope", "$sce", "$state", "Report"];

    function UserReportingController($scope, $sce, $state, Report) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.downloadAttendenceReport = downloadAttendenceReport;
        vm.report = report;
        vm.reporthide = false;
        vm.select2 = select2;
        var date = "dd EEE";
        vm.today = today();
        vm.reportRecords = [];
        vm.select2();

        vm.users = loadPage();

        vm.img;
        var zoomImage;

        function enable() {
            zoomImage = new ZoomNPan(imgZoom);
            zoomImage.minScale = 100;
        }
        enable();

        function loadPage() {
            Report.getUsers("", function (response) {
                vm.users = response;
            });
        }

        function today() {
            var today = new Date();
            vm.currentDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate()
            );
            vm.currentDate.setHours(0, 0, 0, 0);
            vm.currentTime = vm.currentDate.getTime();
        }

        function downloadAttendenceReport() {
            Report.downloadReportingReport(
                {
                    id: vm.id,
                    fromTime: vm.currentTime,
                    toTime: vm.currentTime,
                },
                function (response) {
                    var a = document.createElement("a");
                    a.style = "display: none";
                    var file = new Blob([response], {
                        type: "application/csv",
                    });
                    var fileURL = URL.createObjectURL(file);
                    a.href = fileURL;
                    a.download = "user_reporting_status_report.csv";
                    a.click();
                    window.URL.revokeObjectURL(fileURL);
                }
            );
        }

        function report() {
            Report.getReportingReport(
                {
                    id: vm.id,
                    fromTime: vm.currentTime,
                    toTime: vm.currentTime,
                },
                function (response) {
                    vm.reportRecords = response;
                }
            );
        }

        $scope.getImage = function (img) {
            vm.img = img;
        };

        function select2() {
            $(".select2").select2();
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.calculateDate = calculateDate;
        function calculateDate() {
            vm.currentDate.setHours(0, 0, 0, 0);
            vm.currentTime = vm.currentDate.getTime();
        }

        function ZoomNPan(elm) {
            var that = this;

            /** minimum zoom allowed (in percent) */
            this.minScale = 30;
            /** maximun zoom allowed (in percent) */
            this.maxScale = 300;
            /** Snap to 100% if the zoom is in +- this amount (in percent) */
            this.snap = 9;
            /** invert the direction on MacOS */
            this.invertOnMac = false;

            if (elm.hasAttribute("data-zoom-and-pan"))
                return console.error(
                    "ZoomNPan This element is already initialized"
                );
            elm.setAttribute("data-zoom-and-pan", "");

            var currentScale = 100;
            elm.addEventListener("wheel", zoom);
            elm.addEventListener("mousemove", pan);

            function zoom(e) {
                e.preventDefault();
                var y = normalizeWheel(e);

                var step = y * (that.maxScale / 500);
                currentScale += step * -1;
                if (currentScale > that.maxScale) currentScale = that.maxScale;
                if (currentScale < that.minScale) currentScale = that.minScale;

                var s =
                    Math.abs(100 - currentScale) > that.snap
                        ? currentScale
                        : 100; //snap to 100%
                elm.classList.toggle("zoomed-in", s > 100);
                elm.classList.toggle("zoomed-out", s < 100);
                elm.style.backgroundSize = s + "%";
            }

            function pan(e) {
                var panX,
                    panY,
                    pad = 20;
                if (currentScale >= 100) {
                    panX = (e.offsetX - pad) / (e.target.clientWidth - pad * 2);
                    panY =
                        (e.offsetY - pad) / (e.target.clientHeight - pad * 2);
                } else {
                    panX = 0.5;
                    panY = 0.5;
                }
                elm.style.backgroundPositionX = panX * 100 + "%";
                elm.style.backgroundPositionY = panY * 100 + "%";
            }

            function normalizeWheel(ev) {
                var sY = 0;
                if ("detail" in ev) sY = ev.detail;
                if ("wheelDelta" in ev) sY = -ev.wheelDelta / 120;
                if ("wheelDeltaY" in ev) sY = -ev.wheelDeltaY / 120;
                var pY = 10 * sY;
                if ("deltaY" in ev) pY = ev.deltaY;
                if (pY && ev.deltaMode) pY *= ev.deltaMode === 1 ? 40 : 800;
                if (pY && !sY) sY = 1 > pY ? -1 : 1;
                that.invertOnMac &&
                    navigator.platform.match(/mac/i) &&
                    ((sY *= -1), (pY *= -1)); //invert direction on MacOS
                return pY;
            }

            /**
             * theardown the events and remove styles, call this when you don't need it anymore.
             * @public
             */
            this.destroy = function () {
                elm.removeEventListener("wheel", zoom);
                elm.removeEventListener("mousemove", pan);
                elm.removeAttribute("data-zoom-and-pan");
                elm.className = "zoom"; //remove zoomed-in and zoomed-out
                elm.style.backgroundSize = ""; //reset zoom
                elm.style.backgroundPosition = ""; //reset position
            };
        }
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('UserLoginHistoryReportController', UserLoginHistoryReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);
	angular.module('trakeyeApp').filter('startFrom', function () {
		return function (input, start) {
				if (!input) return [];
				start = +start;
				return input.slice(start);
			};
		});

	UserLoginHistoryReportController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function UserLoginHistoryReportController($scope, $sce, $state, Report) {
		var vm = this;
		vm.itemsPerPage = 10;
		vm.totalItems=0
		vm.currentPage = 1;
		vm.report = report;
		vm.reporthide = false;
		vm.select2 = select2;
		vm.select2();
		vm.sortResponse = sortResponse;
		vm.downloadUserLastLoginReport = downloadUserLastLoginReport;
		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
			})
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserLastLoginReport({
				id: vm.id
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.totalItems = vm.reportRecords.length;
				vm.currentPage = 1;
				vm.search = "";
				vm.reporthide = true;
			})
		}
		
		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getUserLastLoginReport({
				id: vm.id,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc'
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.totalItems = vm.reportRecords.length;
				vm.currentPage = 1;
				vm.search = "";
				vm.reporthide = true;
			});
		}

		function downloadUserLastLoginReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.downloadUserLastLoginReport({
				id: vm.id
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "user_last_log_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}
		
		function select2() {
			$(".select2").select2();
		}
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('UserGeofenceReportController', UserGeofenceReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	UserGeofenceReportController.$inject = ['$scope', '$sce', '$state', 'Report', 'UserGeofences'];

	function UserGeofenceReportController($scope, $sce, $state, Report, UserGeofences) {
		var vm = this;
		vm.select2 = select2;
		vm.select2();
		vm.downloadUserGeofenceReport = downloadUserGeofenceReport;
		vm.userGeofences = [];
		vm.users = loadPage();
		vm.userAgent ="username";

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
				$(".select2").select2();
			})
			UserGeofences.getAll(function (response) {
				response.forEach(function(geofence){
					if(geofence.geofenceType == "MINI"){
						vm.userGeofences.push(geofence);
					}
				});
				$(".select2").select2();
			});
		}

		function downloadUserGeofenceReport() {
				if(vm.userAgent == 'username'){
					vm.id=vm.userid;
				} else {
					vm.id=vm.geofenceid;
				}
				Report.downloadUserGeofenceReport({
					id: vm.id,
					reportType: vm.userAgent
				}, function (response) {
					var a = document.createElement("a");
					a.style = "display: none";
					var file = new Blob([(response)], { type: 'application/csv' });
					var fileURL = URL.createObjectURL(file);
					// window.open(fileURL, "_blank");
					a.href = fileURL;
					a.download = "user_geofences_report.csv";
					a.click();
					window.URL.revokeObjectURL(fileURL);
				});
			
		}
		
		function select2() {
			$(".select2").select2();
		}
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('UserAttendaceController', UserAttendaceController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	UserAttendaceController.$inject = ['$scope', '$sce', '$state', "Report"];

	function UserAttendaceController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadAttendenceReport = downloadAttendenceReport;
		vm.report = report;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "gpsUser";
		vm.selecterange = selectRange;

		vm.select2();

		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
			})
			vm.reportType = 'gpsUser';
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadAttendenceReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "user_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} 
		}

	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('UserAgentReportController', UserAgentReportController)

	UserAgentReportController.$inject = [ '$scope', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval' ];

	function UserAgentReportController($scope, $state, Report, $rootScope, $timeout, $window, $filter, $interval) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.batteryusers = [];
		$scope.reporthide = false;
		vm.select2 = select2;
		var dateFormat = 'dd EEE hh:mm a';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.sortResponse = sortResponse;
		vm.today = today();
		vm.downloadUserAgentReport = downloadUserAgentReport;
		vm.select2();

		Report.getUsers('', function(response) {
			vm.batteryusers = response;

		})
		
		vm.users = loadPage();
		function loadPage(){
			Report.getUsers('', function(response) {
				vm.users = response;
			})
			vm.reportType = 'agent';
		}
		
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		$scope.report = function() {
			if (vm.reportType == 'agent' && vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getReport({
				id : vm.id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				$scope.search = "";
				$scope.reporthide = true;
			})

		}

		function sortResponse() {
			if (vm.reportType == 'agent' && vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getReport({
				id : vm.id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				reportType : vm.reportType
			}, function(response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				$scope.search = "";
				$scope.reporthide = true;
			})
		}

		function downloadUserAgentReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.downloadUserAgentReport({
				id : vm.id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
			a.download = "users_agent_view_reportp.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}
		vm.detailedReport = detailedReport;

		vm.selecterange = selectRange;
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		function selectRange(range) {
			
               if (range == 'week') {   
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} else if (range == 'year') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setYear(date.getFullYear() - 1);
				vm.fromTime = date.getTime();
			}
		}
		function select2() {
			$(".select2").select2();
		}

		// Added for generating pdf start
		$scope.close = function() {
			$('#genericReport').show();
			$scope.reporthide = true;
			$('#report').hide();
		}
		$scope.loader = false;
		$(function() {
			$scope.getPdf = function() {
				$scope.loader = true;
				html2canvas(reportpdf, {
					onrendered : function(canvas) {
						var img = canvas.toDataURL("image/png");
						var pdf = new jsPDF('landscape', 'mm', 'a2');
						pdf.addImage(img, 'JPEG', 0, 0);
						pdf.save($scope.pdftype);
						$scope.loader = false;
					}
				});
				$interval(function() {
				}, 1000);
			}
		});
		// Added for generating pdf end
		function detailedReport(id) {
			Report.getDetailedReport({
				id : id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {
				vm.detailedReportCounts = response;

				$('#report').show();
				$scope.reporthide = false;
				$('#genericReport').hide();

				if (vm.reportType == 'agent') {
					$scope.pdftype = 'Agent.pdf';

				}

			})
		}

		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		$scope.batteryreport = function() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			Report.getbatteryReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
				$scope.batteryline = response;
				$scope.battery = [];
				$scope.createTime = [];
				angular.forEach($scope.batteryline, function(value, key) {
					$scope.battery.push(value.batteryValue);
					$scope.createTime.push($filter('date')(value.createTime, dateFormat));
				});

				Highcharts.chart('battery_graph', {

					title : {
						text : 'Battery Usage Report'
					},

					subtitle : {
						text : ''
					},

					yAxis : {
						title : {
							text : 'Battery Percentage'
						}
					},
					legend : {
						layout : 'vertical',
						align : 'right',
						verticalAlign : 'middle'
					},
					xAxis : {
						categories : $scope.createTime
					},

					series : [ {
						name : ' ',
						data : $scope.battery
					} ],
					credits : {
						enabled : false
					},
					exporting : {
						buttons : {
							contextButton : {
								menuItems : [ {
									textKey : 'downloadPNG',
									onclick : function() {
										var fileName = "battery_report";
										this.exportChart({
											filename : fileName
										});
									}
								}, {
									textKey : 'downloadPDF',
									onclick : function() {
										this.exportChart({
											type : 'application/pdf'
										});
									}
								} ]
							}
						}
					}

				});

			})
		}

		$scope.distancereport = function() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			Report.getDistanceReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
				$scope.distanceData = response;
				$scope.distance = [];
				$scope.date = [];

				angular.forEach($scope.distanceData, function(value, key) {
					$scope.distance.push(value.distance);
					$scope.date.push(value.date);
				});

				Highcharts.chart('distance_graph', {

					title : {
						text : 'Distance Travelled Report'
					},

					subtitle : {
						text : ''
					},

					yAxis : {
						title : {
							text : 'Distance Travelled in KM'
						}
					},
					legend : {
						layout : 'vertical',
						align : 'right',
						verticalAlign : 'middle'
					},
					xAxis : {
						categories : $scope.date
					},
					series : [ {
						name : 'Distance in km',
						data : $scope.distance
					} ],
					credits : {
						enabled : false
					},
					exporting : {
						buttons : {
							contextButton : {
								menuItems : [ {
									textKey : 'downloadPNG',
									onclick : function() {
										var fileName = "distance_report";
										this.exportChart({
											filename : fileName
										});
									}
								}, {
									textKey : 'downloadPDF',
									onclick : function() {
										this.exportChart({
											type : 'application/pdf'
										});
									}
								} ]
							}
						}
					}

				});

			})
		}				
 }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('TeamReportController', TeamReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function($sce){
    return function(text) {
        return $sce.trustAsHtml(text);
    	};
	}]);

	TeamReportController.$inject = [ '$scope','$sce' ,'$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval','Principal' ];

	function TeamReportController($scope, $sce,$state, Report, $rootScope, $timeout, $window, $filter, $interval,Principal) {
		var vm = this;
		vm.users = [];
		
		var dateFormat = 'dd EEE hh:mm a';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		vm.openCalendar = openCalendar;
		vm.reportGenerated = false;
		vm.reportGeneratedFileName='';
		
		vm.datePickerOpenStatus = {};
		$scope.reporthide = false;
		vm.reportUser = $rootScope.userName;
		vm.users = loadPage();
		function loadPage(){
			Report.getUsers('', function(response) {
				vm.users = response;
			})
		}
		$scope.loader = false;
		
		$(".select2").select2(); // Added search for select box
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		
		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		
		
		$scope.report = function() {
		
			Report.getTeamReport({
					"fromDateTime":vm.fromTime,
					"toDateTime":vm.toTime,
					"login":vm.reportUser,
				}, function(response) {
					$scope.myhtml = response;
				});
			vm.reportGenerated = true;
		}
		
		$scope.download = function() {
			window.location.href = "/images/TeamReport.xls";
		}
		
	}

})();

(function () {
	"use strict";

	angular
		.module("trakeyeApp")
		.controller("TaskLogReportController", TaskLogReportController);
	angular.module("trakeyeApp").filter("trustFilter", [
		"$sce",
		function ($sce) {
			return function (text) {
				return $sce.trustAsHtml(text);
			};
		},
	]);

	TaskLogReportController.$inject = [
		"$scope",
		"$sce",
		"$state",
		"$localStorage",
		"$interval",
		"Report",
		"BaseUrl",
		"TrProjectListIdName",
		"TrRouteListByProjectId",
		"TrSectionListIdByRouteId",
		"TrTaskListIdBySectionId",
		"TaskLogReportData",
		"ValidationLogsBySectionId"
	];

	function TaskLogReportController(
		$scope,
		$sce,
		$state,
		$localStorage,
		$interval,
		Report,
		BaseUrl,
		TrProjectListIdName,
		TrRouteListByProjectId,
		TrSectionListIdByRouteId,
		TrTaskListIdBySectionId,
		TaskLogReportData,
		ValidationLogsBySectionId
	) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.userAgent = "username";
		vm.selectedReport = selectedReport;
		var date = "dd EEE";
		vm.today = today();
		vm.selecterange = selectRange;
		vm.downloadTaskLogReport = downloadTaskLogReport;
		vm.showTaskLogReport = showTaskLogReport;
		vm.isReportGenerated = false;
		$('.select2').select2();

		$(function () {
			$scope.getPdf = function () {
				$scope.loader = true;


				// Store the current zoom level of the browser
				var currentZoomLevel = document.body.style.zoom;

				// Set the zoom level to 100% (or any desired zoom level) to ensure accurate rendering
				document.body.style.zoom = '100%';

				var contentDiv = document.getElementById('generatedHtmlContainer');

				// Temporarily set the height of the div to auto to ensure all content is rendered
				var originalHeight = contentDiv.style.height;
				contentDiv.style.height = 'auto';

				// Scroll to the content
				contentDiv.scrollIntoView();

				// Get the dimensions of the div
				var width = contentDiv.scrollWidth + 200; // Use scrollWidth to capture entire content width
				var height = contentDiv.scrollHeight + 100; // Use scrollHeight to capture entire content height

				// Use html2canvas to capture the content of the div
				html2canvas(contentDiv, {
					width: width,
					height: height
				}).then(function (canvas) {
					// Restore the original height of the div
					contentDiv.style.height = originalHeight;

					// Create a PDF from the captured content
					var imgData = canvas.toDataURL('image/png');

					// Create PDF instance with landscape orientation
					var pdf = new jsPDF({
						orientation: 'landscape',
						unit: 'px',
						format: [height, width] // Set format to match landscape orientation
					});

					pdf.addImage(imgData, 'PNG', 50, 50, width, height);

					// Save the PDF
					pdf.save('report.pdf');

					// Restore the browser's zoom level
					document.body.style.zoom = currentZoomLevel;
				});





				$interval(function () {
				}, 1000);
			}
		});

		function downloadTaskLogReport() {
			BaseUrl.getBaseUrl(function (baseurl) {
				var url = "";
				url = baseurl.stringValue + "api/task-log-export-excel/" + vm.fromTime + "/" + vm.toTime + "/" + vm.reportType + "/" + vm.selectedProjectId + "/" + vm.selectedRouteId;
				if (vm.selectedSectionId > 0) {
					url = baseurl.stringValue + "api/task-log-export-excel/" + vm.fromTime + "/" + vm.toTime + "/" + vm.reportType + "/" + vm.selectedProjectId + "/" + vm.selectedRouteId + "/" + vm.selectedSectionId;
				}
				var request = new XMLHttpRequest();
				request.open('GET', url, true);
				request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
				request.responseType = 'blob';

				request.onload = function (e) {
					if (this.status === 200) {
						var blob = this.response;
						if (blob.size > 0) {
							if (window.navigator.msSaveOrOpenBlob) {
								window.navigator.msSaveBlob(blob, 'test.xlsx');
							}
							else {
								var downloadLink = window.document.createElement('a');
								var contentTypeHeader = request.getResponseHeader("Content-Type");
								downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
									type: contentTypeHeader
								}));
								downloadLink.download = 'Report.xlsx';
								if (vm.reportType == 'daily') {
									downloadLink.download = 'DailyTaskLogReport.xlsx';
								} else if (vm.reportType == 'measurement') {
									downloadLink.download = 'MeasurementReport.xlsx';
								}

								document.body.appendChild(downloadLink);
								downloadLink.click();
								document.body.removeChild(downloadLink);
							}
						}
					}
				};
				request.send();
			});
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(
				today.getFullYear(),
				today.getMonth(),
				today.getDate()
			);
			vm.fromDate = new Date(
				today.getFullYear(),
				today.getMonth(),
				today.getDate()
			);
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {
			if (range == "day") {
				var today = new Date();
				vm.toDate = new Date(
					today.getFullYear(),
					today.getMonth(),
					today.getDate()
				);
				vm.fromDate = new Date(
					today.getFullYear(),
					today.getMonth(),
					today.getDate()
				);
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();
			} else if (range == "week") {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7);
				vm.fromTime = date.getTime();
			} else if (range == "month") {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

		function selectedReport() {
			if (vm.reportType == 'daily') {
				vm.selectedSectionId = "";
			}
			TrProjectListIdName.get(function (response) {
				vm.projects = response;
				if (vm.projects.length) {
					vm.projects.sort(function (a, b) {
						var nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
						var nameB = b.name.toUpperCase();

						if (nameA < nameB) {
							return -1;
						}
						if (nameA > nameB) {
							return 1;
						}
						return 0; // Names are equal
					});
				}
			});
		}

		$scope.onProjectChange = function () {
			TrRouteListByProjectId.get(
				vm.selectedProjectId,
				function (response) {
					vm.routes = response;
				}
			);
		};

		$scope.onRouteChange = function () {
			TrSectionListIdByRouteId.get(
				vm.selectedRouteId,
				function (response) {
					vm.sections = response;
				}
			);
		};

		$scope.onSectionChange = function () {
			TrTaskListIdBySectionId.get(
				vm.selectedSectionId,
				function (response) {
					vm.tasks = response;
				}
			);
		};

		$scope.onTaskChange = function () {
			console.log(vm.selectedTaskId);
		};

		function createMetaTag(attrName, attrValue, content) {
			var meta = document.createElement('meta');
			meta.setAttribute(attrName, attrValue);
			meta.setAttribute('content', content);
			return meta;
		}

		function createTable(classNames) {
			var table = document.createElement('table');
			table.setAttribute('border', '1');
			table.setAttribute('cellpadding', '5');
			table.setAttribute('cellspacing', '0');
			table.setAttribute('id', 'sheet0');
			table.setAttribute('class', classNames);
			return table;
		}

		function createTableCell(tagName, textContent) {
			var cell = document.createElement(tagName);
			cell.textContent = textContent;
			return cell;
		}


		function showTaskLogReport() {
			vm.isReportGenerated = false;
			TaskLogReportData.query(
				{
					fromDate: vm.fromTime,
					toDate: vm.toTime,
					reportType: vm.reportType,
					projectId: vm.selectedProjectId,
					routeId: vm.selectedRouteId,
					sectionId: vm.selectedSectionId,
					taskId: vm.selectedTaskId
				},
				onSuccess,
				onError
			);

			function onSuccess(data) {
				if (vm.reportType == 'daily') {
					var htmlDoc = document.createElement('html');
					var head = document.createElement('head');
					var meta1 = createMetaTag('http-equiv', 'Content-Type', 'text/html; charset=utf-8');
					var meta2 = createMetaTag('name', 'generator', 'PhpSpreadsheet, https://github.com/PHPOffice/PhpSpreadsheet');
					var meta3 = createMetaTag('name', 'author', 'Apache POI');
					var meta4 = createMetaTag('name', 'company', 'Microsoft Corporation');
					head.appendChild(meta1);
					head.appendChild(meta2);
					head.appendChild(meta3);
					head.appendChild(meta4);
					var body = document.createElement('body');
					var table = createTable('sheet0 gridlines');
					var thead = document.createElement('thead');
					var tbody = document.createElement('tbody');

					function createTable(classNames) {
						var table = document.createElement('table');
						table.setAttribute('border', '1');
						table.setAttribute('cellpadding', '5');
						table.setAttribute('cellspacing', '0');
						table.setAttribute('id', 'sheet0');
						table.setAttribute('class', classNames);
						return table;
					}

					function createMetaTag(attrName, attrValue, content) {
						var meta = document.createElement('meta');
						meta.setAttribute(attrName, attrValue);
						meta.setAttribute('content', content);
						return meta;
					}

					function createTableCell(tag, content) {
						var cell = document.createElement(tag);
						cell.textContent = content;
						cell.style.fontSize = "13px";
						return cell;
					}

					thead.className = 'thReport';
					table.appendChild(thead);
					tbody.className = 'tdReport';
					table.appendChild(tbody);
					var styleElement = document.createElement('style');
					styleElement.textContent = "\
                .subheader {\
                    margin: auto;\
                }\
                .thReport > tr > th{\
                    text-align: center;\
                    padding: 10px;\
                }\
                .tdReport > tr > td {\
                    text-align: center; \
                    padding: 10px;\
                }\
                ";
					document.head.appendChild(styleElement);

					var colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2',];
					function getRandomColor() {
						if (colors.length === 0) {
							colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2'];
						}
						var index = Math.floor(Math.random() * colors.length);
						var color = colors[index];
						colors.splice(index, 1);
						return color;
					}


					var groupedData = {};
					data.forEach(function (item) {
						if (!groupedData[item.date]) {
							groupedData[item.date] = [];
						}
						groupedData[item.date].push(item);
					});
					var names = getUniqueNames(data);
					var nameHeaderRow = document.createElement('tr');
					var serialNumberHeader = createTableCell('th', 'S.No');
					serialNumberHeader.style.fontWeight = 'bold';
					serialNumberHeader.style.backgroundColor = '#7dcfb6';
					serialNumberHeader.rowSpan = 2;
					nameHeaderRow.appendChild(serialNumberHeader);
					var dateHeader = createTableCell('th', 'Date');
					dateHeader.style.backgroundColor = '#7dcfb6';
					dateHeader.style.fontWeight = 'bold';
					dateHeader.rowSpan = 2;
					nameHeaderRow.appendChild(dateHeader);
					var typeHeaderRow = document.createElement('tr');

					names.forEach(function (name, index) {
						var nameData = data.filter(function (item) { return item.name === name; });
						var availableTypes = getUniqueTypes(nameData);
						var nameHeaderCell = createTableCell('th', name);
						nameHeaderCell.style.backgroundColor = getRandomColor();
						nameHeaderCell.style.fontWeight = 'bold';
						nameHeaderCell.colSpan = availableTypes.length;
						nameHeaderRow.appendChild(nameHeaderCell);
						availableTypes.forEach(function (type) {
							var typeHeaderCell = createTableCell('th', type);
							typeHeaderCell.style.backgroundColor = nameHeaderCell.style.backgroundColor;
							typeHeaderCell.style.fontWeight = 'bold';
							typeHeaderRow.appendChild(typeHeaderCell);
						});
					});
					var totalProgressHeader = createTableCell('th', 'Total Progress');
					totalProgressHeader.style.backgroundColor = '#cfe0c3';
					totalProgressHeader.style.fontWeight = 'bold';
					totalProgressHeader.colSpan = 3;
					nameHeaderRow.appendChild(totalProgressHeader);
					var subHeaders = [
						{
							type: 'Total',
						},
						{
							type: "Ducting",
						}, {
							type: "Validation",

						}
					];
					subHeaders.forEach(function (subHeader) {
						var subHeaderCell = createTableCell('th', subHeader.type);
						subHeaderCell.style.backgroundColor = '#cfe0c3';
						subHeaderCell.style.fontWeight = 'bold';
						typeHeaderRow.appendChild(subHeaderCell);
					});
					thead.appendChild(nameHeaderRow);
					thead.appendChild(typeHeaderRow);
					var totals = {};

					Object.keys(groupedData)
						.sort(function (a, b) {
							var dateA = a.split('-').reverse().join('-');
							var dateB = b.split('-').reverse().join('-');
							return new Date(dateA) - new Date(dateB);
						})
						.forEach(function (date, index) {
							var totalLength = 0;
							var totalValidation = 0;
							names.forEach(function (name) {
								var nameData = data.filter(function (item) { return item.name === name && item.date === date; });
								var ductingLength = 0;
								var hddLength = 0;
								var horizontalDirectionalDrilling = 0
								var validationLength = 0;
								nameData.forEach(function (item) {
									if (item.type === 'Ducting') {
										ductingLength += item.length;
									}
									else if (item.type === 'HDD') {
										hddLength += item.length;

									}
									else if (item.type === 'HDD ( Horizontal Directional Drilling )') {
										horizontalDirectionalDrilling += item.length;
										console.log(horizontalDirectionalDrilling)
									}
									else if (item.type === 'Validation' || item.type === 'Validation (T&D)') {
										validationLength += item.length;
									}
								});
								console.log(totalLength)
								totalLength += (ductingLength + hddLength + horizontalDirectionalDrilling);
								totalValidation += validationLength;

							});
							var tr = document.createElement('tr');
							var serialNumberCell = createTableCell('td', index + 1);
							serialNumberCell.style.fontSize = "13px";
							tr.appendChild(serialNumberCell);
							var dateCell = createTableCell('td', date);
							dateCell.style.width = '77px'
							dateCell.style.whiteSpace = 'nowrap';
							dateCell.style.fontSize = "13px";
							tr.appendChild(dateCell);
							names.forEach(function (name) {
								var nameData = data.filter(function (item) { return item.name === name; });
								var availableTypes = getUniqueTypes(nameData);

								availableTypes.forEach(function (type) {
									var item = groupedData[date].find(function (item) {
										return item.name === name && item.type === type;
									});
									var lengthValue = item ? item.length : 0;
									var td = createTableCell('td', lengthValue);

									tr.appendChild(td);
									if (!totals[type]) {
										totals[type] = 0;
									}
									totals[type] += lengthValue;
								});
							});
							var total = 0;
							for (var i = 2; i < tr.cells.length; i++) {
								total += parseInt(tr.cells[i].textContent);
							}
							var columnValueCell = createTableCell('td', total);
							columnValueCell.colSpan = 1;
							tr.appendChild(columnValueCell);
							var remainingDuctingCell = createTableCell('td', totalLength);
							tr.appendChild(remainingDuctingCell);
							var remainingValidationCell = createTableCell('td', totalValidation);
							tr.appendChild(remainingValidationCell);
							if (index === 0) {
								totals['Total Progress Ducting'] = 0;
								totals['Total Progress Validation'] = 0;
							}
							totals['Total Progress Ducting'] += totalLength;
							totals['Total Progress Validation'] += totalValidation;
							tbody.appendChild(tr);
						});

					var staticColumns = ['Total', 'Balance Validation', 'Balance Ducting'];
					var allAvailableTypes = [];
					names.forEach(function (name) {
						var nameData = data.filter(function (item) { return item.name === name; });
						allAvailableTypes.push.apply(allAvailableTypes, getUniqueTypes(nameData));
					});
					var availableTypes = allAvailableTypes;
					var maxUniqueTypesCount = availableTypes.length;
					var totalLength = maxUniqueTypesCount + subHeaders.length;

					var columnTotals = {};
					for (var i = 2; i < totalLength; i++) {
						var total = 0;
						for (var j = 0; j < tbody.rows.length; j++) {
							var cellValue = parseInt(tbody.rows[j].cells[i].textContent) || 0;
							total += cellValue;
						}
						columnTotals[i] = total;
					}
					staticColumns.forEach(function (column) {
						var staticRow = document.createElement('tr');
						var columnNameCell = createTableCell('td', column);
						columnNameCell.colSpan = 2;
						columnNameCell.style.backgroundColor = '#cfe0c3';
						columnNameCell.style.fontSize = "13px";
						columnNameCell.style.fontWeight = 'bold';
						staticRow.appendChild(columnNameCell);
						if (column == 'Total') {
							for (var i = 2; i < totalLength; i++) {
								var columnValueCell = createTableCell('td', columnTotals[i].toString());
								columnValueCell.colSpan = 1;
								staticRow.appendChild(columnValueCell);
							}
							var columnValueCell = createTableCell('td', totals['Total Progress Ducting']);
							columnValueCell.colSpan = 1;
							staticRow.appendChild(columnValueCell);
							var columnValueCell = createTableCell('td', totals['Total Progress Validation']);
							columnValueCell.colSpan = 1;
							staticRow.appendChild(columnValueCell);
						} else {
							for (var i = 0; i < totalLength; i++) {
								var columnValueCell = createTableCell('td', '0');
								columnValueCell.colSpan = 1;
								staticRow.appendChild(columnValueCell);
							}
						}
						tbody.appendChild(staticRow);
					});
					table.appendChild(thead);
					table.appendChild(tbody);
					body.appendChild(table);
					htmlDoc.appendChild(body);
					htmlDoc.appendChild(head);
					var htmlString = htmlDoc.outerHTML;
					var containerDiv = document.getElementById("generatedHtmlContainer");
					containerDiv.innerHTML = htmlString;

					function getUniqueNames(data) {
						var uniqueNames = [];
						data.forEach(function (item) {
							if (uniqueNames.indexOf(item.name) === -1) {
								uniqueNames.push(item.name);
							}
						});
						return uniqueNames;
					}
					function getUniqueTypes(data) {
						var uniqueTypes = [];
						data.forEach(function (item) {
							if (uniqueTypes.indexOf(item.type) === -1) {
								uniqueTypes.push(item.type);
							}
						});
						return uniqueTypes;
					}

					// Set background color for specified cells
					var jcbCells = document.querySelectorAll('.row1 .column0'); // Select cells in row 1, column 0 (JCB)
					var hddCells = document.querySelectorAll('.row1 .column1'); // Select cells in row 1, column 1 (HDD)

					// Loop through JCB cells and set background color to light green
					jcbCells.forEach(function (cell) {
						cell.style.backgroundColor = 'lightgreen';
					});

					// Loop through HDD cells and set background color to light green
					hddCells.forEach(function (cell) {
						cell.style.backgroundColor = 'lightgreen';
					});

					// Get the Total row
					// Select all relevant rows
					var relevantRows = ['.row2', '.row3', '.row5', '.row6'];

					// Loop through each relevant row
					relevantRows.forEach(function (rowClass) {
						var cells = document.querySelectorAll(rowClass + ' td');

						// Loop through the cells in the row
						cells.forEach(function (cell) {
							// Check if the content of the cell is '0' or empty
							if (cell.textContent.trim() === '0' || cell.textContent.trim() === '') {
								// Set background color to white
								cell.style.backgroundColor = 'white';
							}
						});
					});

					vm.isReportGenerated = true;
				} else {

					ValidationLogsBySectionId.query(
						{
							sectionId: vm.selectedSectionId
						},
						onSuccess,
						onError
					);
					function onSuccess(data) {
						console.log(data);
					}

					function onError(error) {
						AlertService.error(error.data.message);
					}

					var htmlDoc = document.createElement('html');
					var head = document.createElement('head');
					var meta1 = document.createElement('meta');
					meta1.setAttribute('http-equiv', 'Content-Type');
					meta1.setAttribute('content', 'text/html; charset=utf-8');
					var meta2 = document.createElement('meta');
					meta2.setAttribute('name', 'generator');
					meta2.setAttribute('content', 'PhpSpreadsheet, https://github.com/PHPOffice/PhpSpreadsheet');
					var meta3 = document.createElement('meta');
					meta3.setAttribute('name', 'author');
					meta3.setAttribute('content', 'Apache POI');
					var meta4 = document.createElement('meta');
					meta4.setAttribute('name', 'company');
					meta4.setAttribute('content', 'Microsoft Corporation');
					head.appendChild(meta1);
					head.appendChild(meta2);
					head.appendChild(meta3);
					head.appendChild(meta4);

					var body = document.createElement('body');
					var table = document.createElement('table');
					table.setAttribute('border', '0');
					table.setAttribute('cellpadding', '0');
					table.setAttribute('cellspacing', '0');
					table.setAttribute('id', 'sheet0');
					table.setAttribute('class', 'sheet0 gridlines');

					var projectName = "";
					var sectionName = "";
					vm.projects.forEach(function (value) {
						if (value.id == vm.selectedProjectId) {
							projectName = value.name;
						}
					});
					vm.sections.forEach(function (value) {
						if (value.id == vm.selectedSectionId) {
							sectionName = value.name;
						}
					});

					var specialRows = [
						{ class: 'row0', content: ['NHLML- National Highways Management Limited'], },
						{ class: 'row1', content: ['Trenching & Ducting Validation Sheet For Open Trench'] },
						{ class: 'row2', content: ['projectName', projectName] },
						{ class: 'row3', content: ['Contactor', ''] },
						{ class: 'row4', content: ['Date', ''] },
						{ class: 'row5', content: ['Measurement Book Number(MBN)', ''] },
						{ class: 'row6', content: ['Sheet No', '1'] },
						{ class: 'row7', content: ['Section Name', sectionName] },
						{ class: 'row8', content: ['State Name', ''] },
						{ class: 'row9', content: ['PIU', ''] },
						{ class: 'row10', content: ['Package', ''] },
						{ class: 'row11', content: [''] },
					];

					specialRows.forEach(function (rowData, rowIndex) {
						var tr = document.createElement('tr');
						tr.setAttribute('class', rowData.class);

						rowData.content.forEach(function (cellData, index) {
							var td = document.createElement('td');
							td.setAttribute('class', 'column' + index);
							td.textContent = cellData;
							td.style.border = '1px solid black';
							td.style.fontSize = "14px";
							td.style.fontWeight = 'bold';
							if (rowIndex === 11 && index === 0) {
								td.colSpan = 27;
								var br = document.createElement('br');
								td.appendChild(br);
							}
							if (rowIndex < 2) {
								td.colSpan = 27;
								td.style.textAlign = 'center';
							}
							if (rowIndex >= 2 && rowIndex <= 10 && index === 1) {
								td.colSpan = 26;
								td.style.textAlign = 'left';
							}
							if (cellData === 'projectName' || cellData === 'Contactor' || cellData === 'Date' || cellData === 'Measurement Book Number(MBN)' || cellData === 'Sheet No' || cellData === 'Section Name' || cellData === 'State Name' || cellData === 'PIU' || cellData === 'Package') {
								td.style.backgroundColor = 'yellow';
							}
							tr.appendChild(td);
						});

						table.appendChild(tr);
					});

					var rowTags = [
						{ class: 'row0', content: ['SL', 'Chainage', 'Actual Length', 'Row Ref', 'Approved Rows', 'width', 'Actual Ref Available', 'Trench Details', 'Bidding Details', 'Bend Details', 'Duct Joint Details', 'No of Duct Laid', 'Duct Protection', 'End Caps Req', 'Coupling Point location', 'Remarks'], bgColor: 'yellow' }, // Added 4 empty columns after 'CH 10 TO 20'
						{ class: 'row1', content: ['From', 'To', 'Methodology Open trench(OT)', 'Crossing by Hume Pipe on Interchange(y/n)', 'X (Offset)in (Mtr)', 'D(Depth) in (Mtr)', 'Top width in MM', 'Bottom Width In MM', 'Strata', 'Height mm', 'Ramming', 'Check cleanliness of duct at either end', 'visual check for tightness of  coupler', '63/50 mm(violet,Grey,Red)', '40/33 mm(Blue,yellow,Brown)', 'PCC/RCC/GI/DWC/Tiles', 'Length(Mtr)',], bgColor: 'yellow' },
						{ class: 'row2', content: ['Particulars', 'Contractor representative', 'Authority Engineer representative', 'NHLML Representative',] },
						{ class: 'row3', content: ['Signature', '', '', ''] },
						{ class: 'row4', content: ['Name', '', '', ''] },
						{ class: 'row5', content: ['Designation', '', '', ''] },
						{ class: 'row6', content: ['Date', '', '', ''] }
					];
					var loopCounter = 0;

					data.forEach(function (item, index) {
						rowTags.splice(2 + index, 0, {
							class: 'row2',
							content: [
								index + 1,
								item.chainageFrom || '',
								item.chainageTo || '',
								item.actualLengthMeters || '',
								item.rowRefLhsRhs || '',
								item.approvedRowAsPerRefMeters || '',
								item.widthAvailableInUtilityCorridorFromRowBoundaryWall || '',
								item.actualRowAvailableMeters || '',
								item.methodologyOpenTrench || '',
								item.crossingByHumePipeOnInterchange || '',
								item.xOffsetMeters || '',
								item.dOffsetMeters || '',
								item.topWidthMm || '',
								item.bottomWidthMm || '',
								item.strata || '',
								item.heightMm || '',
								item.ramming || '',
								item.bendDetails || '',
								item.checkCleanlinessOfDuctAtEitherEnd || '',
								item.visualCheckForTightnessOfCoupler || '',
								item.mm63_50VioletGreyRed || '',
								item.mm40_33BlueYellowBrown || '',
								item.pccRccGiDwcTiles || '',
								item.lengthMeters || '',
								item.endCapsProvided || '',
								item.couplingPointLocation || '',
								item.remarks || ''
							]
						});

						loopCounter++;
					});

					rowTags.forEach(function (rowData, rowIndex) {
						var tr = document.createElement('tr');
						tr.setAttribute('class', rowData.class);
						tr.style.backgroundColor = rowData.bgColor || 'transparent';
						tr.style.textAlign = 'center';
						rowData.content.forEach(function (cellData, index) {
							var td = document.createElement('td');
							td.setAttribute('class', 'column' + index);
							if (Array.isArray(cellData)) {
								cellData.forEach(function (subCellData) {
									var subTd = document.createElement('td');
									subTd.textContent = subCellData;
									subTd.style.border = '1px solid black';
									tr.appendChild(subTd);
								});
							} else {
								td.textContent = cellData;
								td.style.border = '1px solid black';
								td.style.fontSize = "12px";
								if (rowIndex === 0 && index <= 0) {
									td.rowSpan = 2;
								}
								if (rowIndex === 0 && index >= 2 && index <= 6) {
									td.rowSpan = 2;
								}
								if (rowIndex === 0 && index >= 7 && index <= 7) {
									td.colSpan = 7;
								}
								if (rowIndex === 0 && index >= 8 && index <= 8) {
									td.colSpan = 2;
								}
								if (rowIndex === 0 && index >= 10 && index <= 10) {
									td.colSpan = 2;
								}
								if (rowIndex === 0 && index >= 11 && index <= 11) {
									td.colSpan = 2;
								}
								if (rowIndex === 0 && index >= 9 && index <= 9) {
									td.rowSpan = 2;
								}
								if (rowIndex === 0 && index >= 12 && index <= 12) {
									td.colSpan = 2;
								}
								if (rowIndex === 0 && index >= 13 && index <= 15) {
									td.rowSpan = 2;
								}
								if (rowIndex === 0 && index >= 1 && index <= 1) {
									td.colSpan = 2;
								}
								if (rowIndex === 0 && index >= 2 && index <= 2) {
									td.colSpan = 1;
								}
								if (rowIndex === loopCounter + 2 && index >= 1 && index <= 3) {
									td.colSpan = 9;
								}
								if (rowIndex === loopCounter + 3 && index >= 1 && index <= 3) {
									td.colSpan = 9;
								}
								if (rowIndex === loopCounter + 4 && index >= 1 && index <= 3) {
									td.colSpan = 9;
								}
								if (rowIndex === loopCounter + 5 && index >= 1 && index <= 3) {
									td.colSpan = 9;
								}
								if (rowIndex === loopCounter + 6 && index >= 1 && index <= 3) {
									td.colSpan = 9;
								}

								if ((rowIndex === 0 && index === 2) || (rowIndex === 0 && index === 2)) {
									td.style.backgroundColor = 'yellow';
								}

								if (rowIndex === 1 && (index === 0 || index === 1)) {
									td.style.backgroundColor = 'yellow';
								}
								tr.appendChild(td);
							}
							if (index < 1) {
								if (rowIndex === 14 || rowIndex === 16) {
									td.style.backgroundColor = 'yellow';
								} else {
									td.style.backgroundColor = 'yellow';
								}
							}
						});
						table.appendChild(tr);
					});

					body.appendChild(table);
					htmlDoc.appendChild(head);
					htmlDoc.appendChild(body);
					var htmlString = htmlDoc.outerHTML;

					var generatedHtml = htmlString;

					var containerDiv = document.getElementById(
						"generatedHtmlContainer"
					);
					containerDiv.innerHTML = generatedHtml;

					vm.isReportGenerated = true;
				}
			}
		}

		function onError(error) {
			AlertService.error(error.data.message);
		}

	}


})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("SurveyReportController", SurveyReportController);

    SurveyReportController.$inject = ["UserMasterGeofences","MiniGeofencesByMasterID","Report","CustomAssetTypeAttribute"
    ];

    function SurveyReportController(UserMasterGeofences,MiniGeofencesByMasterID,Report,CustomAssetTypeAttribute
    ) {
        var vm = this;
        $(".select2").select2();
        load();
        vm.statuslabel = {
            search          : "Search",
            nothingSelected : "Select",
            selectAll       : "All",
            selectNone      : "None", 
            Done : "Done" 
        }
        vm.statusType = []
        vm.selectedstatusType = null
        var authoritiesList,activityTypeList,terrainTypeList,existingInfraList,mappedAttributes
        var storeAuthority = [], storeactivity = [], storeterrain = [], storeexisting = []

        function load() {
            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                vm.userMasterGeofences = response;
                vm.selectedMasterGeofenceId = vm.userMasterGeofences[0].id.toString();
                vm.geofenceMini = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                        });
                    }
                );
            });

            CustomAssetTypeAttribute.query({
                page: 0,
                size: 100,
                sort: 'id,asc'
            }, onSuccess, onError);
            function onSuccess(data) {
                data.forEach(function(item){
                    if(item.name == "Authority"){
                        vm.statusType.push( {   value: '<strong>Authority</strong>' , msGroup: true })
                        item.customAssetTypeAttributeValues.forEach(function(attribute){
                            vm.statusType.push(attribute)
                            storeAuthority.push(attribute.id)
                        })
                        vm.statusType.push( {   msGroup: false })
                    }

                    if(item.name == "Terrain Type"){
                        vm.statusType.push( {   value: '<strong>Terrain Type</strong>' , msGroup: true })
                        item.customAssetTypeAttributeValues.forEach(function(attribute){
                            vm.statusType.push(attribute)
                            storeterrain.push(attribute.id)
                        })
                        vm.statusType.push( {   msGroup: false })
                    }

                    if(item.name == "Activity Type"){
                        vm.statusType.push( {   value: '<strong>Activity Type</strong>' , msGroup: true })
                        item.customAssetTypeAttributeValues.forEach(function(attribute){
                            vm.statusType.push(attribute)
                            storeactivity.push(attribute.id)
                        })
                        vm.statusType.push( {   msGroup: false })
                    }

                    if(item.name == "Existing Infra"){
                        vm.statusType.push( {   value: '<strong>Existing Infra</strong>' , msGroup: true })
                        item.customAssetTypeAttributeValues.forEach(function(attribute){
                            vm.statusType.push(attribute)
                            storeexisting.push(attribute.id)
                        })
                        vm.statusType.push( {   msGroup: false })
                    }
                })
            
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            vm.selectedGeofenceId="";
            vm.geofenceMini = [];
            MiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );
        };

        vm.downloadSurveyReport = function (){
            Report.getSurveyReportDownload({
                id: vm.selectedGeofenceId,
                "attributeMap": mappedAttributes
            }, function (response) {
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([(response)], { type: 'application/csv' });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "survey_report.csv";
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
        }

        vm.savePriorityStatusFilter = function(){
            authoritiesList = [],activityTypeList = [],terrainTypeList = [],existingInfraList = []
            authoritiesList = vm.selectedstatusType.filter(function(item) {
                return storeAuthority.indexOf(item.id) !== -1;
            }).map(function(item) {
                return item.value;
            });

            activityTypeList = vm.selectedstatusType.filter(function(item) {
                return storeactivity.indexOf(item.id) !== -1;
            }).map(function(item) {
                return item.value;
            });

            terrainTypeList = vm.selectedstatusType.filter(function(item) {
                return storeterrain.indexOf(item.id) !== -1;
            }).map(function(item) {
                return item.value;
            });

            existingInfraList = vm.selectedstatusType.filter(function(item) {
                return storeexisting.indexOf(item.id) !== -1;
            }).map(function(item) {
                return item.value;
            });

            mappedAttributes = {}
        if(authoritiesList.length > 0){
            mappedAttributes.Authority = authoritiesList
        }
        if(activityTypeList.length > 0){
            mappedAttributes["Activity Type"] = activityTypeList
        }
        if(terrainTypeList.length > 0){
            mappedAttributes["Terrain Type"] = terrainTypeList
        }
        if(existingInfraList.length > 0){
            mappedAttributes["Existing Type"] = existingInfraList
        }
        }

        vm.surveyReport = function(){
            vm.surveyTotalLength = 0
            Report.getSurveyReportList({
                id: vm.selectedGeofenceId,
                "attributeMap": mappedAttributes
            },function (response){
                vm.surveyReportList = response
                if(vm.surveyReportList.length > 0){
                    vm.surveyReportList.forEach(function(item){
                        vm.surveyTotalLength += item.asset_length
                    })
                }
            }) 
        }
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('SplicingReportController', SplicingReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	SplicingReportController.$inject = ['$scope', '$sce', '$state', '$localStorage', 'AlertService', 'AllCaseTypes', 'TrCasesForType', 'Report', 'BaseUrl'];

	function SplicingReportController($scope, $sce, $state, $localStorage, AlertService, AllCaseTypes, TrCasesForType, Report, BaseUrl) {
		var vm = this;
		vm.downloadSplicingReport = downloadSplicingReport;
		vm.selectedCaseTypeId = null;
		vm.selectedCaseId = null;
		vm.select2 = select2;
		vm.select2();
		vm.caseTypes = [];
		vm.cases = [];

		AllCaseTypes.getAll(function (response) {
			response.forEach(function(caseType){
				if(caseType.name == "Splicing Details" || caseType.name == "Termination Details" ) {
					vm.caseTypes.push(caseType);
				}
			});
		});

		$scope.onCaseTypeChange = function () {
			vm.cases = [];
			TrCasesForType.query(
				{
					caseTypeId: vm.selectedCaseTypeId,
				},
				onSuccess,
				onError
			);

			function onSuccess(data, headers) {
				vm.cases = data;
			}

			function onError(error) {
				AlertService.error(error.data.message);
			}
        };

		function downloadSplicingReport() {
			BaseUrl.getBaseUrl(function(baseurl){
				var request = new XMLHttpRequest();
				request.open('GET', baseurl.stringValue+"api/download-splicing-pdf/"+vm.selectedCaseId, true);
				request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
				request.responseType = 'blob';
				
				request.onload = function(e) {
					if (this.status === 200) {
						var blob = this.response;
						if(blob.size > 0){
							var blob = new Blob([this.response], {type: 'application/pdf'});
							var link = document.createElement('a');
							link.href = window.URL.createObjectURL(blob);
							link.download = "document.pdf";
							vm.caseTypes.forEach(function(value){
								if(value.id == vm.selectedCaseTypeId){
									link.download = value.name + ".pdf";
								}
							});
							
							link.click();
							
						}
					}
				};
				request.send();
			});

		}

		function select2() {
			$(".select2").select2();
		}

	}
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').controller('SiteStatusReportController', SiteStatusReportController)

    SiteStatusReportController.$inject = ['$scope', 'UsersList', 'TrCaseForMap', 'CasesForMapByAdmin', 'Principal'];

    function SiteStatusReportController($scope, UsersList, TrCaseForMap, CasesForMapByAdmin, Principal) {
        var vm = this;
        vm.userlist = [];
        $scope.reporthide = false;
        vm.select2 = select2;
        vm.select2();
        vm.users = loadPage();
        vm.multiassets = [];
        vm.selectedVendor = "";

        function loadPage() {
            var loggedInUserId = 0;
  
            Principal.identity().then(function (identity) {
                if (identity) {
                    loggedInUserId = identity.id;
                }
            })
            UsersList.getusers(function (response) {
                var users = [];
                response.forEach(function (item, index) {
                    if (item.authorities.includes("ROLE_USER_ADMIN") && (item.id != loggedInUserId)) {
                        users.push(item)
                    }
                });
                vm.userlist = users;
                var vendorData = [];
                vm.userlist.forEach(function (item) {

                    CasesForMapByAdmin.casesformapbyadmin(item.id, function (response) {
                        var OnAirCaseCount = 0;
                        response.forEach(function (item1, index) {
                            var caseAV = item1.caseTypeAttributeValues;
                            caseAV.forEach(function (item2) {
                                if (item2.caseDataTypeName == 'Fiber Status') {
                                    if (item2.attributeValue == 'On Air') {
                                        OnAirCaseCount++;
                                    }
                                }
                            });
                        });
                        vendorData.push({
                            label: item.firstName + " " + item.lastName,
                            value: OnAirCaseCount
                        });

                        var donut = new Morris.Donut({
                            element: 'vendor-chart',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });
                        
                        var donut1 = new Morris.Donut({
                            element: 'vendor-chart1',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });
                        $scope.reporthide = true;
                    });

                });

            });

            vm.reportType = 'agent';
        }

		     

//        vm.caseTypeClick = function (caseTypeName) {
//            if (vm.selectedVendor != "") {
//            	
//            	
//                var vendorName = "";
//
//                vm.userlist.forEach(function (userVal) {
//                    if (userVal.id == vm.selectedVendor) {
//                        vendorName = userVal.firstName + " " + userVal.lastName;
//                    }
//                });
//
//                var vendorData = [];
//                CasesForMapByAdmin.casesformapbyadmin(vm.selectedVendor, function (response) {
//                	
//	                    var OnAirCaseCount = 0;
//	                    var result = [];
//	                    var grouped = {};
//	
//	                    response.forEach(function (item) {
//	                    	if(item.caseTypeName == caseTypeName){
//		                        var caseAV = item.caseTypeAttributeValues;
//		                        var onAirCount = 0;
//		                        var underDeploymentCount = 0;
//		                        var plannedCount = 0;
//		                        caseAV.forEach(function (item1) {
//		                            if (item1.caseDataTypeName == 'Fiber Status') {
//		                                if (item1.attributeValue == 'On Air') {
//		                                    onAirCount++;
//		                                    OnAirCaseCount++;
//		                                } else if (item1.attributeValue == 'Under Deployment') {
//		                                    underDeploymentCount++;
//		                                } else if (item1.attributeValue == 'Planned') {
//		                                    plannedCount++;
//		                                }
//		                            }
//		                        });
//		                        result.push({
//		                            name: item.caseTypeName,
//		                            onair: onAirCount,
//		                            deployed: underDeploymentCount,
//		                            planned: plannedCount
//		                        });
//	                    	}
//	                    });
//	
//	                    result.forEach(function (a) {
//	                        grouped[a.name] = grouped[a.name] || [];
//	                        grouped[a.name].push({
//	                            name: a.name,
//	                            onair: a.onair,
//	                            deployed: a.deployed,
//	                            planned: a.planned
//	                        });
//	                    });
//	                    result = Object.values(grouped);
//	                    result.forEach(function (item) {
//	                        var name = "";
//	                        var onAirVal = 0;
//	                        var deployedVal = 0;
//	                        var plannedVal = 0;
//	                        item.forEach(function (item1) {
//	                            name = item1.name;
//	                            onAirVal += item1.onair;
//	                            deployedVal += item1.deployed;
//	                            plannedVal += item1.planned;
//	                        });
//	                        vm.multiassets.push({
//	                            name: name,
//	                            onair: onAirVal,
//	                            deployed: deployedVal,
//	                            planned: plannedVal
//	                        });
//	                    });
//	                    vendorData.push({
//	                        label: vendorName,
//	                        value: OnAirCaseCount
//	                    });
//	
//	                    var donut = new Morris.Donut({
//	                        element: 'vendor-chart',
//	                        resize: true,
//	                        colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
//	                        data: vendorData,
//	                        hideHover: 'auto'
//	                    });
//                });
//            }else{
//              	vm.selectedVendor = "";
//                var vendorData = [];
//                vm.userlist.forEach(function (item) {
//                    CasesForMapByAdmin.casesformapbyadmin(item.id, function (response) {
//                        var OnAirCaseCount = 0;
//                        response.forEach(function (item1, index) {
//                        	if(item1.caseTypeName == caseTypeName){
//	                            var caseAV = item1.caseTypeAttributeValues;
//	                            caseAV.forEach(function (item2) {
//	                                if (item2.caseDataTypeName == 'Fiber Status') {
//	                                    if (item2.attributeValue == 'On Air') {
//	                                        OnAirCaseCount++;
//	                                    }
//	                                }
//	                            });
//                        	}
//                        });
//                        vendorData.push({
//                            label: item.firstName + " " + item.lastName,
//                            value: OnAirCaseCount
//                        });
//
//                        var donut = new Morris.Donut({
//                            element: 'vendor-chart',
//                            resize: true,
//                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
//                            data: vendorData,
//                            hideHover: 'auto'
//                        });
//                    });
//                });
//                TrCaseForMap.getAllCases(function (response) {
//                    var result = [];
//                    var grouped = {};
//
//                    response.forEach(function (item) {
//                    	if(item.caseTypeName == caseTypeName){
//	                        var caseAV = item.caseTypeAttributeValues;
//	                        var onAirCount = 0;
//	                        var underDeploymentCount = 0;
//	                        var plannedCount = 0;
//	                        caseAV.forEach(function (item1) {
//	                            if (item1.caseDataTypeName == 'Fiber Status') {
//	                                if (item1.attributeValue == 'On Air') {
//	                                    onAirCount++;
//	                                } else if (item1.attributeValue == 'Under Deployment') {
//	                                    underDeploymentCount++;
//	                                } else if (item1.attributeValue == 'Planned') {
//	                                    plannedCount++;
//	                                }
//	                            }
//	                        });
//	                        result.push({
//	                            name: item.caseTypeName,
//	                            onair: onAirCount,
//	                            deployed: underDeploymentCount,
//	                            planned: plannedCount
//	                        });
//                    	}
//                    });
//
//                    result.forEach(function (a) {
//                        grouped[a.name] = grouped[a.name] || [];
//                        grouped[a.name].push({
//                            name: a.name,
//                            onair: a.onair,
//                            deployed: a.deployed,
//                            planned: a.planned
//                        });
//                    });
//                    result = Object.values(grouped);
//                    result.forEach(function (item) {
//                        var name = "";
//                        var onAirVal = 0;
//                        var deployedVal = 0;
//                        var plannedVal = 0;
//                        item.forEach(function (item1) {
//                            name = item1.name;
//                            onAirVal += item1.onair;
//                            deployedVal += item1.deployed;
//                            plannedVal += item1.planned;
//                        });
//                        vm.multiassets.push({
//                            name: name,
//                            onair: onAirVal,
//                            deployed: deployedVal,
//                            planned: plannedVal
//                        });
//                    });
//                });
//            }
//        };

        function select2() {
            $(".select2").select2();
        }


        $("#userlist").change(function () {
            vm.multiassets = [];
            var result = $("#userlist").val();
            if (result != "") {
            	vm.selectedVendor = result;
                var vendorName = "";

                vm.userlist.forEach(function (userVal) {
                    if (userVal.id == result) {
                        vendorName = userVal.firstName + " " + userVal.lastName;
                    }
                });

                var vendorData = [];
                CasesForMapByAdmin.casesformapbyadmin(result, function (response) {
                    var OnAirCaseCount = 0;
                    var result = [];
                    var grouped = {};

                    response.forEach(function (item) {
                        var caseAV = item.caseTypeAttributeValues;
                        var onAirCount = 0;
                        var underDeploymentCount = 0;
                        var plannedCount = 0;
                        caseAV.forEach(function (item1) {
                            if (item1.caseDataTypeName == 'Fiber Status') {
                                if (item1.attributeValue == 'On Air') {
                                    onAirCount++;
                                    OnAirCaseCount++;
                                } else if (item1.attributeValue == 'Under Deployment') {
                                    underDeploymentCount++;
                                } else if (item1.attributeValue == 'Planned') {
                                    plannedCount++;
                                }
                            }
                        });
                        result.push({
                            name: item.caseTypeName,
                            onair: onAirCount,
                            deployed: underDeploymentCount,
                            planned: plannedCount
                        });
                    });

                    result.forEach(function (a) {
                        grouped[a.name] = grouped[a.name] || [];
                        grouped[a.name].push({
                            name: a.name,
                            onair: a.onair,
                            deployed: a.deployed,
                            planned: a.planned
                        });
                    });
                    result = Object.values(grouped);
                    result.forEach(function (item) {
                        var name = "";
                        var onAirVal = 0;
                        var deployedVal = 0;
                        var plannedVal = 0;
                        item.forEach(function (item1) {
                            name = item1.name;
                            onAirVal += item1.onair;
                            deployedVal += item1.deployed;
                            plannedVal += item1.planned;
                        });
                        vm.multiassets.push({
                            name: name,
                            onair: onAirVal,
                            deployed: deployedVal,
                            planned: plannedVal
                        });
                    });
                    vendorData.push({
                        label: vendorName,
                        value: OnAirCaseCount
                    });

                    var donut = new Morris.Donut({
                        element: 'vendor-chart',
                        resize: true,
                        colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                        data: vendorData,
                        hideHover: 'auto'
                    });
                    var donut1 = new Morris.Donut({
                        element: 'vendor-chart1',
                        resize: true,
                        colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                        data: vendorData,
                        hideHover: 'auto'
                    });
                });
            } else {
            	vm.selectedVendor = "";
                var vendorData = [];
                vm.userlist.forEach(function (item) {
                    CasesForMapByAdmin.casesformapbyadmin(item.id, function (response) {
                        var OnAirCaseCount = 0;
                        response.forEach(function (item1, index) {
                            var caseAV = item1.caseTypeAttributeValues;
                            caseAV.forEach(function (item2) {
                                if (item2.caseDataTypeName == 'Fiber Status') {
                                    if (item2.attributeValue == 'On Air') {
                                        OnAirCaseCount++;
                                    }
                                }
                            });
                        });
                        vendorData.push({
                            label: item.firstName + " " + item.lastName,
                            value: OnAirCaseCount
                        });

                        var donut = new Morris.Donut({
                            element: 'vendor-chart',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });
                        
                        var donut1 = new Morris.Donut({
                            element: 'vendor-chart1',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });
                    });
                });
                TrCaseForMap.getAllCases(function (response) {
                    var result = [];
                    var grouped = {};

                    response.forEach(function (item) {
                        var caseAV = item.caseTypeAttributeValues;
                        var onAirCount = 0;
                        var underDeploymentCount = 0;
                        var plannedCount = 0;
                        caseAV.forEach(function (item1) {
                            if (item1.caseDataTypeName == 'Fiber Status') {
                                if (item1.attributeValue == 'On Air') {
                                    onAirCount++;
                                } else if (item1.attributeValue == 'Under Deployment') {
                                    underDeploymentCount++;
                                } else if (item1.attributeValue == 'Planned') {
                                    plannedCount++;
                                }
                            }
                        });
                        result.push({
                            name: item.caseTypeName,
                            onair: onAirCount,
                            deployed: underDeploymentCount,
                            planned: plannedCount
                        });
                    });

                    result.forEach(function (a) {
                        grouped[a.name] = grouped[a.name] || [];
                        grouped[a.name].push({
                            name: a.name,
                            onair: a.onair,
                            deployed: a.deployed,
                            planned: a.planned
                        });
                    });
                    result = Object.values(grouped);
                    result.forEach(function (item) {
                        var name = "";
                        var onAirVal = 0;
                        var deployedVal = 0;
                        var plannedVal = 0;
                        item.forEach(function (item1) {
                            name = item1.name;
                            onAirVal += item1.onair;
                            deployedVal += item1.deployed;
                            plannedVal += item1.planned;
                        });
                        vm.multiassets.push({
                            name: name,
                            onair: onAirVal,
                            deployed: deployedVal,
                            planned: plannedVal
                        });
                    });
                });
            }
        });

        $('#userlist').trigger('change');

        // Added for generating pdf start
        $scope.close = function () {
            $('#genericReport').show();
            $scope.reporthide = true;
            $('#report').hide();
        }
        $scope.loader = false;


    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("report", {
                abstract: true,
                parent: "app",
            })
            .state("generic-report", {
                parent: "report",
                url: "/generic-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/report.html",
                        controller: "ReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("geofence-report", {
                parent: "report",
                url: "/geofence-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.geofence-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/geofence-report.html",
                        controller: "GeofenceReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            /*   
               .state('asset-type-site-report', {
                   parent: 'report',
                   url: '/asset-type-site-report',
                   data: {
                       authorities: ['ROLE_USER', 'ROLE_USER_ADMIN'],
                       pageTitle: 'trakeyeApp.report.asset-type-site-report'
                   },
                   views: {
                       'content@': {
                           templateUrl: 'app/report/asset-type-site-report.html',
                           controller: 'AssetTypeSiteReportController',
                           controllerAs: 'vm'
                       }
                   },
                   resolve: {
                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                           $translatePartialLoader.addPart('reports');
                           $translatePartialLoader.addPart('logSource');
                           $translatePartialLoader.addPart('global');
                           return $translate.refresh();
                   }]
                   }
               })*/

            .state("case-report", {
                parent: "report",
                url: "/case-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-report.html",
                        controller: "CaseReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("case-type-report", {
                parent: "report",
                url: "/case-type-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-type-report.html",
                        controller: "CaseReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("entity-dump", {
                parent: "report",
                url: "/entity-dump",
                data: {
                    pageTitle: "trakeyeApp.report.entity-dump",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/entity-dump.html",
                        controller: "EntityDumpController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state('entity-dump.new', {
                parent: 'entity-dump',
                url: '/create',
                views: {
                    'content@': {
                        templateUrl: 'app/report/entity-dump-dialog.html',
                        controller: 'EntityDumpDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("asset-health-report", {
                parent: "report",
                url: "/asset-health",
                data: {
                    pageTitle: "trakeyeApp.report.asset-health-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-health-report.html",
                        controller: "AssetHealthController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("asset-health-status-report", {
                parent: "report",
                url: "/asset-health-status",
                data: {
                    pageTitle: "trakeyeApp.report.asset-health-status-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-health-status-report.html",
                        controller: "AssetHealthStatusController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("asset-geofence-mapping", {
                parent: "report",
                url: "/asset-geofence-mapping",
                data: {
                    pageTitle: "trakeyeApp.report.asset-geofence-mapping",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-geofence-mapping.html",
                        controller: "AssetGeofenceMappingController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("geofence-dump", {
                parent: "report",
                url: "/geofence-dump",
                data: {
                    authorities: ["ROLE_USER_ADMIN"],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/geofence-dump.html",
                        controller: "GeofenceDumpController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("splicing-report", {
                parent: "report",
                url: "/splicing-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/splicing-report.html",
                        controller: "SplicingReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-agent-report", {
                parent: "report",
                url: "/user-agent-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.user-agent-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/user-agent-report.html",
                        controller: "UserAgentReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("fiber-status-report", {
                parent: "report",
                url: "/fiber-status-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.fiber-status-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/fiber-status-report.html",
                        controller: "FiberStatusReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("site-status-report", {
                parent: "report",
                url: "/site-status-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.site-status-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/site-status-report.html",
                        controller: "SiteStatusReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("case-aging-report", {
                parent: "report",
                url: "/case-aging-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-aging-report.html",
                        controller: "CaseAgingReportController",
                        controllerAs: "vm"
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            $translatePartialLoader.addPart("caseAgingReport");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("noc-alerts-report", {
                parent: "report",
                url: "/noc-alerts-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN"
                    ],
                    pageTitle: "Noc Alerts Report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/noc-alerts-report.html",
                        controller: "NocAlertsReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            $translatePartialLoader.addPart("NocAlertsReport");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            
            .state("incidents-report", {
                parent: "report",
                url: "/incidents-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN"
                    ],
                    pageTitle: "Incidents Report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/incidents-report.html",
                        controller: "IncidentsReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            $translatePartialLoader.addPart("IncidentsReport");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("distance-report", {
                parent: "report",
                url: "/distance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.distance-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/distance-report.html",
                        controller: "DistanceReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("battery-report", {
                parent: "report",
                url: "/battery-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.battery-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/battery-report.html",
                        controller: "ReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("distance-travelled", {
                parent: "report",
                url: "/distance-travelled",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.distance-travelled",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/distance-travelled.html",
                        controller: "ReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("asset-report", {
                parent: "report",
                url: "/asset-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.asset-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-report.html",
                        controller: "AssetReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("asset-case-report", {
                parent: "report",
                url: "/asset-case-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.asset-case-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/asset-case-report.html",
                        controller: "AssetCaseReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("case-tat-report", {
                parent: "report",
                url: "/case-tat-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.tat.tat-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-tat-report.html",
                        controller: "CaseTatReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            $translatePartialLoader.addPart("caseTatReport");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("team-report", {
                parent: "report",
                url: "/team-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.teamreport.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/team-report.html",
                        controller: "TeamReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            $translatePartialLoader.addPart("teamReport");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("field-user-report", {
                parent: "report",
                url: "/field-user-report",
                data: {
                    authorities: ["ROLE_USER", "ROLE_USER_ADMIN"],
                    pageTitle: "trakeyeApp.report.distance-travelled",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/field-user-report.html",
                        controller: "UserAgentReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("case-user-report", {
                parent: "report",
                url: "/case-user-report",
                data: {
                    authorities: ["ROLE_USER", "ROLE_USER_ADMIN"],
                    pageTitle: "trakeyeApp.report.distance-travelled",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/case-user-report.html",
                        controller: "CaseAgingReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-attendance-report", {
                parent: "report",
                url: "/user-attendance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_USER_ADMIN",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/user-attendance-report.html",
                        controller: "UserAttendaceController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("mobile-user-attendance-report", {
                parent: "report",
                url: "/mobile-user-attendance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/mobile-user-attendance-report.html",
                        controller: "MobileUserAttendaceController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("gps-user-attendance-report", {
                parent: "report",
                url: "/gps-user-attendance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/gps-user-attendance-report.html",
                        controller: "GpsUserAttendaceController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-login-history-report", {
                parent: "report",
                url: "/user-login-history-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/user-login-history-report.html",
                        controller: "UserLoginHistoryReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("user-geofence-report", {
                parent: "report",
                url: "/user-geofence-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/user-geofence-report.html",
                        controller: "UserGeofenceReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("vehicle-distance-report", {
                parent: "report",
                url: "/vehicle-distance-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/vehicle-distance-report.html",
                        controller: "VehicleDistanceController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-stats-report", {
                parent: "report",
                url: "/user-stats-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/user-stats-report.html",
                        controller: "UserStatsController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("cases-dump-report", {
                parent: "report",
                url: "/cases-dump-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/cases-dump-report.html",
                        controller: "CasesDumpController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("user-reporting-report", {
                parent: "report",
                url: "/user-reporting-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/user-reporting-report.html",
                        controller: "UserReportingController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("survey-report", {
                parent: "report",
                url: "/survey-report",
                data: {
                    pageTitle: "trakeyeApp.report.survey-report",
                },
                views: {
                    "content@": {
                        templateUrl: "app/report/survey-report.html",
                        controller: "SurveyReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("task-log-report", {
                parent: "report",
                url: "/task-log-report",
                data: {
                    authorities: ['ENTITY_CONFIGURATION'],
                    pageTitle: "trakeyeApp.report.task-log-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/task-log-report.html",
                        controller: "TaskLogReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            }).state("daily-survey-report", {
                parent: "report",
                url: "/daily-survey-report",
                data: {
                    authorities: [
                        "ROLE_USER",
                        "ROLE_USER_ADMIN",
                        "ROLE_VENDOR",
                        "ROLE_HOD",
                        "ROLE_CITY_MANAGER","ROLE_BA",
                        "ROLE_CITY_PLANNER",
                        "ROLE_ASSISTANT_MANAGER","ROLE_OA",
                        "ROLE_TEAM_LEADER",
                    ],
                    pageTitle: "trakeyeApp.report.generic-report",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/report/daily-survey-report.html",
                        controller: "DailySurveyReportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("reports");
                            $translatePartialLoader.addPart("logSource");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("Report", [
        "$rootScope",
        "$http",

        function ($rootScope, $http) {
            var service = {};
            
            service.getListEntity = function (callback) {
                $http.get("api/reports/email-report").then(function (response) {
                    callback(response.data);
                });
            };

            service.getUsers = function (name, callback) {
                $http.get("api/userslist").then(function (response) {
                    callback(response.data);
                });
            };
            service.getVehicles = function (name, callback) {
                $http.get("api/vehicleslist").then(function (response) {
                    callback(response.data);
                });
            };
            service.getGeofences = function (name, callback) {
                $http.get("api/geofenceslist").then(function (response) {
                    callback(response.data);
                });
            };
            service.getReport = function (data, callback) {
                $http.post("api/reports/view", data).then(function (response) {
                    callback(response.data);
                });
            };
            service.downloadUserAgentReport = function (data, callback) {
                $http
                    .post("api/reports/download-user-agent-view-report", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getIncidentsReportDownload = function (data, callback) {
                $http
                    .post("api/reports/download-incidents-report", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getIncidentsAlarmQueueReportDownload = function (data, callback) {
                $http
                    .post("api/reports/download-incidents_alarm_queue", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.downloadPdfReport = function (data, callback) {
                $http
                    .post("api/download-splicing-pdf", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAttendenceReport = function (data, callback) {
                $http
                    .post("api/reports/attendence-view", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getNocAlertsReport = function (data, callback) {
                $http
                    .post("api/reports/incidents-report", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            

            service.getAssetHealthListWithGeoReport = function (data, callback) {
                $http
                    .post("api/asset-health-list-with-geofence", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getUserLastLoginReport = function (data, callback) {
                $http
                    .post("api/reports/user-last-login", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadUserLastLoginReport = function (data, callback) {
                $http
                    .post("api/reports/download-user-last-login", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadUserGeofenceReport = function (data, callback) {
                $http
                    .post("api/reports/download-user-geofence", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadTaskLogReport = function (data, callback) {
                $http
                    .post("api/task-log-export-excel", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            
            service.downloadGeofenceDump = function (data, callback) {
                $http
                    .post("api/reports/download-geofence", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.emailReport = function (
                data,
                successCallback,
                errorCallback
            ) {
                $http
                    .post("api/reports/email-report", data)

                    .then(
                        function (response) {
                            successCallback(response.data);
                        },
                        function (response) {
                            // this function handles error
                            errorCallback(response);
                        }
                    );
            };

            service.downloadGeofenceDumpKml = function (data, callback) {
                $http
                    .post("api/reports/download-geofence-kml", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadRouteKml = function (data, callback) {
                $http
                    .post("api/download-route-kml", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadRouteBundleKml = function (data, callback) {
                $http
                    .post("api/download-route-bundle-kml", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadRouteExcel = function (data, callback) {
                $http
                    .get("api/download-route-Excel", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };


            service.getVehicleDistanceReport = function (data, callback) {
                $http
                    .post("api/reports/vehicleDistanceReport", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getUserStatsReport = function (data, callback) {
                $http
                    .post("api/reports/userDistStats", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getUsersAroundCase = function (data, callback) {
                $http
                    .post("api/reports/viewUsersArounCase", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAttendenceReportDownload = function (data, callback) {
                $http
                    .post("api/reports/download-attendence-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getVehicleDistanceReportDownload = function (
                data,
                callback
            ) {
                $http
                    .post("api/reports/download-vehicle-distance-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getUserDistanceStatsReportDownload = function (
                data,
                callback
            ) {
                $http
                    .post("api/reports/download-user-dist-stats-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getOpenCasesReportDownload = function (data, callback) {
                $http
                    .post("api/download-opencases-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAssetHealthStatusReportDownload = function (data, callback) {
                $http
                    .post("api/download-assethealthstatus-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getClosedCasesReportDownload = function (data, callback) {
                $http
                    .post("api/download-closedcases-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getReportingReport = function (data, callback) {
                $http
                    .post("api/reports/user-reporting-report", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadReportingReport = function (data, callback) {
                $http
                    .post("api/reports/download-user-reporting-report", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getCaseReport = function (data, callback) {
                $http
                    .post("api/download-cases-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getCaseReportList = function (data, callback) {
                $http
                    .post("api/cases-reports-list", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getDetailedReport = function (data, callback) {
                $http.post("api/reports/detailed-report", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getbatteryReport = function (
                login,
                fromtime,
                totime,
                callback
            ) {
                $http
                    .get(
                        "api/reports/batteryreport/" +
                            login +
                            "/" +
                            fromtime +
                            "/" +
                            totime
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getDistanceReport = function (
                login,
                fromtime,
                totime,
                callback
            ) {
                $http
                    .get(
                        "api/reports/distancereport/" +
                            login +
                            "/" +
                            fromtime +
                            "/" +
                            totime
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getCasesReport = function (data, callback) {
                $http.post("api/reports/cases", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getCasesAgingReport = function (data, callback) {
                $http.post("api/reports/caseagingreport", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getCasesTatReport = function (data, callback) {
                $http.post("api/reports/casetatreport", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getIncidentsReport = function (data, callback) {
                $http.post("api/reports/incidents-report", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };   

            service.getIncidentsAlarmQueueReport = function (data, callback) {
                $http.post("api/reports/incidents_alarm_queue", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            }; 

            service.getCasesMttrReport = function (
                ageType,
                fromDate,
                toDate,
                callback
            ) {
                $http
                    .get(
                        "api/tr-cases-report/" +
                            ageType +
                            "/" +
                            fromDate +
                            "/" +
                            toDate
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getTeamReport = function (data, callback) {
                $http.post("api/reports/teamreport", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

            service.getDistReport = function (data, callback) {
                $http.post("api/reports/distance", data).then(
                    function (response) {
                        callback(response.data);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };

			service.getpresentDayCheckinUserSummary = function ( callback) {
                $http.get("api/dashboard/presentDayCheckinUser").then(
                    function (response) {
                        callback(response);
                    },
                    function (error) {
                        callback({ counts: {} });
                    }
                );
            };
            service.getAssetReport = function (
                assetIdReport,
                casetypeid,
                attname,
                fromDate,
                toDate,
                callback
            ) {
                $http
                    .get(
                        "api/reports/assetreport/" +
                            assetIdReport +
                            "/" +
                            casetypeid +
                            "/" +
                            attname +
                            "/" +
                            fromDate +
                            "/" +
                            toDate
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getAssetCaseTypeReport = function (
                assetIdReport,
                fromDate,
                toDate,
                callback
            ) {
                $http
                    .get(
                        "api/reports/assetcasetypereport/" +
                            assetIdReport +
                            "/" +
                            fromDate +
                            "/" +
                            toDate
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAssetCaseReport = function (
                casetypeid,
                fromDate,
                toDate,
                callback
            ) {
                $http
                    .get(
                        "api/reports/assetcasereport/" +
                            casetypeid +
                            "/" +
                            fromDate +
                            "/" +
                            toDate
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAssetCaseReportSearch = function (
                casetypeid,
                fromDate,
                toDate,
                searchText,
                callback
            ) {
                $http
                    .get(
                        "api/reports/assetcasereport/" +
                            casetypeid +
                            "/" +
                            fromDate +
                            "/" +
                            toDate +
                            "/" +
                            searchText
                    )
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getSurveyReportDownload = function (data, callback) {
                $http
                    .post("api/download-assetsurvey-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getSurveyReportList = function (data, callback) {
                $http
                    .post("api/assetsurvey-reports", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getEntityDetails = function (id, callback) {
                $http
                    .get("api/reports/trakeyereport/"+id)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.downloadZip = function (id, imgId, callback) {
               /*  $http
                    .get("api/reports/trakeyereport/"+id+"/"+imgId)
                    .then(function (response) {
                        callback(response.data);
                    }); */
                    $http({
                        method: 'GET',
                        url: "api/reports/trakeyereport/"+id+"/"+imgId,
                        responseType: 'arraybuffer',
                    }).then(function (response) {
                        callback(response.data);
                    }).catch(function (error) {
                        console.error('Error during download:', error);
                    });
                    
                    
            };

service.getDailyAssetSurveyReport = function (data, callback) {
    var url = "api/reports/survey-asset-report"
        + "?startDate=" + data.startDate
        + "&endDate=" + data.endDate
        + "&page=" + data.page
        + "&size=" + data.size;

    $http.post(url).then(function (response) {
        callback(response.data, response.headers);
    }, function (error) {
        console.error("API error:", error);
    });
};


            return service;
        },
    ]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TaskLogReportData', TaskLogReportData);

	TaskLogReportData.$inject = ['$resource'];

	function TaskLogReportData($resource) {
		var service = $resource('/api/task-log-report-data/:fromDate/:toDate/:reportType/:projectId/:routeId/:sectionId/:taskId', {},{},{},{},{}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TaskLogProjectReportData', TaskLogProjectReportData);

	TaskLogProjectReportData.$inject = ['$resource'];

	function TaskLogProjectReportData($resource) {
		var service = $resource('/api/task-log-report-data/project/:projectId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TaskLogRouteReportData', TaskLogRouteReportData);

	TaskLogRouteReportData.$inject = ['$resource'];

	function TaskLogRouteReportData($resource) {
		var service = $resource('/api/task-log-report-data/route/:routeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TaskLogSectionReportData', TaskLogSectionReportData);

	TaskLogSectionReportData.$inject = ['$resource'];

	function TaskLogSectionReportData($resource) {
		var service = $resource('/api/task-log-report-data/section/:sectionId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TaskLogTaskReportData', TaskLogTaskReportData);

	TaskLogTaskReportData.$inject = ['$resource'];

	function TaskLogTaskReportData($resource) {
		var service = $resource('/api/task-log-report-data/task/:taskId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function() {
    'use strict';

    angular.module('trakeyeApp').controller('ReportController', ReportController)

    ReportController.$inject = ['$scope', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval'];

    function ReportController($scope, $state, Report, $rootScope, $timeout, $window, $filter, $interval) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.reportTypeChange = reportTypeChanged;
        vm.users = [];
        vm.batteryusers = [];
        vm.geofences = [];
        $scope.reporthide = false;
        vm.select2 = select2;
        var dateFormat = 'dd EEE hh:mm a';
        var date = "dd EEE";
        vm.fromTime = 0;
        vm.toTime = 0;
        vm.today = today();
        // vm.today();
        vm.select2();
        Report.getUsers('', function(response) {
            vm.batteryusers = response;

        })
        vm.appName = $rootScope.APP_NAME;

        function today() {
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }

        $scope.report = function() {
            if ((vm.reportType == 'geofence' && vm.geofence == 'all') || (vm.reportType == 'agent' && vm.userAgent == 'all')) {
                vm.id = 0;
            }
            Report.getReport({
                id: vm.id,
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                reportType: vm.reportType
            }, function(response) {

                if (response instanceof Array) {
                    vm.reportRecords = response;
                } else {
                    vm.reportRecords = [];
                    vm.reportRecords.push(response);
                }
                $scope.search = "";
                $scope.reporthide = true;
            })

        }
        vm.detailedReport = detailedReport;

        vm.selecterange = selectRange;
        vm.calculateToDate = calculateToDate;
        vm.calculateFromDate = calculateFromDate;

        function calculateFromDate() {

            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
        }

        function calculateToDate() {

            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }

        function selectRange(range) {
            if (range == 'week') {
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setDate(date.getDate() - 7)
                vm.fromTime = date.getTime();

            } else if (range == 'month') {

                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setMonth(date.getMonth() - 1);
                vm.fromTime = date.getTime();
            } else if (range == 'year') {

                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setYear(date.getFullYear() - 1);
                vm.fromTime = date.getTime();
            }
        }

        function select2() {
            $(".select2").select2();
        }

        function reportTypeChanged() {
            $scope.reporthide = false;
            if (vm.reportType == 'agent') {
                if (vm.users.length == 0) {
                    Report.getUsers('', function(response) {
                        vm.users = response;
                    })
                }
            } else if (vm.reportType == 'geofence') {
                if (vm.geofences.length == 0) {
                    Report.getGeofences('', function(response) {
                        vm.geofences = response;
                    })
                }
            }

        }
        // Added for generating pdf start
        $scope.close = function() {
            $('#genericReport').show();
            $scope.reporthide = true;
            $('#report').hide();
        }
        $scope.loader = false;
        $(function() {
            $scope.getPdf = function() {
                $scope.loader = true;
                html2canvas(reportpdf, {
                    onrendered: function(canvas) {
                        var img = canvas.toDataURL("image/png");
                        var pdf = new jsPDF('landscape', 'mm', 'a2');
                        pdf.addImage(img, 'JPEG', 0, 0);
                        pdf.save($scope.pdftype);
                        $scope.loader = false;
                    }
                });
                $interval(function() {}, 1000);
            }
        });
        // Added for generating pdf end
        function detailedReport(id) {
            Report.getDetailedReport({
                id: id,
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                reportType: vm.reportType
            }, function(response) {
                vm.detailedReportCounts = response;

                $('#report').show();
                $scope.reporthide = false;
                $('#genericReport').hide();

                if (vm.reportType == 'agent') {
                    $scope.pdftype = 'Agent.pdf';
                    /*var map = new google.maps.Map(document.getElementById('map_canvas'), {
                    	zoom : 13,
                    	center : new google.maps.LatLng(response.locations[0].lat, response.locations[0].lng)
                    });
                    var flightPath = new google.maps.Polyline({
                    	path : response.locations,
                    	geodesic : true,
                    	strokeColor : "#425cf4",
                    	strokeOpacity : 1,
                    	strokeWeight : 2,
                    	icons : [ {
                    		icon : {
                    			path : google.maps.SymbolPath.FORWARD_CLOSED_ARROW
                    		},
                    		offset : '25px',
                    		repeat : '50px'
                    	} ]
                    });
                    var startMarker = new google.maps.Marker({
                    	map : map,
                    	position : new google.maps.LatLng(response.locations[0].lat, response.locations[0].lng),
                    	title : 'Started here'
                    });
                    startMarker.setIcon('http://maps.google.com/mapfiles/ms/icons/green-dot.png');
                    var endMarker = new google.maps.Marker({
                    	map : map,
                    	position : new google.maps.LatLng(response.locations[response.locations.length - 1].lat, response.locations[response.locations.length - 1].lng),
                    	title : 'Ended here'
                    });
                    endMarker.setIcon('http://maps.google.com/mapfiles/ms/icons/red-dot.png');
                    flightPath.setMap(map);
                    setTimeout(function() {
                    	google.maps.event.trigger(map, "resize");
                    	map.setCenter(new google.maps.LatLng(response.locations[0].lat, response.locations[0].lng));
                    }, 100);*/

                } else if (vm.reportType == 'geofence') {
                    $scope.pdftype = 'Geofence.pdf';
                    var coordicates = JSON.parse(response.coordinates);
                    var map = new google.maps.Map(document.getElementById('map_canvas'), {
                        zoom: 13,
                        center: new google.maps.LatLng(coordicates[0].lat, coordicates[0].lng)
                    });

                    var polygon = new google.maps.Polygon({
                        path: coordicates,
                        strokeColor: "#ff0000",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#ff0000",
                        fillOpacity: 0.3,
                        editable: true
                    })
                    polygon.setMap(map);
                    setTimeout(function() {
                        google.maps.event.trigger(map, "resize");
                        map.setCenter(new google.maps.LatLng(coordicates[0].lat, coordicates[0].lng));
                    }, 100);
                }

            })
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;
        vm.datePickerOpenStatus.serviceDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $scope.batteryreport = function() {
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();

            Report.getbatteryReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
                $scope.batteryline = response;
                $scope.battery = [];
                $scope.createTime = [];
                angular.forEach($scope.batteryline, function(value, key) {
                    $scope.battery.push(value.batteryValue);
                    $scope.createTime.push($filter('date')(value.createTime, dateFormat));
                });

                Highcharts.chart('battery_graph', {

                    title: {
                        text: 'Battery Usage Report'
                    },

                    subtitle: {
                        text: ''
                    },

                    yAxis: {
                        title: {
                            text: 'Battery Percentage'
                        }
                    },
                    legend: {
                        layout: 'vertical',
                        align: 'right',
                        verticalAlign: 'middle'
                    },
                    xAxis: {
                        categories: $scope.createTime
                    },

                    series: [{
                        name: ' ',
                        data: $scope.battery
                    }],
                    credits: {
                        enabled: false
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                menuItems: [{
                                    textKey: 'downloadPNG',
                                    onclick: function() {
                                        var fileName = "battery_report";
                                        this.exportChart({
                                            filename: fileName
                                        });
                                    }
                                }, {
                                    textKey: 'downloadPDF',
                                    onclick: function() {
                                        this.exportChart({
                                            type: 'application/pdf'
                                        });
                                    }
                                }]
                            }
                        }
                    }

                });

            })
        }

        $scope.distancereport = function() {
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();

            Report.getDistanceReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
                $scope.distanceData = response;
                $scope.distance = [];
                $scope.date = [];

                angular.forEach($scope.distanceData, function(value, key) {
                    $scope.distance.push(value.distance);

                    // $scope.date.push($filter('date')(value.date,"dd EEE"));
                    $scope.date.push(value.date);
                });

                Highcharts.chart('distance_graph', {

                    title: {
                        text: 'Distance Travelled Report'
                    },

                    subtitle: {
                        text: ''
                    },

                    yAxis: {
                        title: {
                            text: 'Distance Travelled in KM'
                        }
                    },
                    legend: {
                        layout: 'vertical',
                        align: 'right',
                        verticalAlign: 'middle'
                    },
                    xAxis: {
                        categories: $scope.date
                    },
                    series: [{
                        name: 'Distance in km',
                        data: $scope.distance
                    }],
                    credits: {
                        enabled: false
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                menuItems: [{
                                    textKey: 'downloadPNG',
                                    onclick: function() {
                                        var fileName = "distance_report";
                                        this.exportChart({
                                            filename: fileName
                                        });
                                    }
                                }, {
                                    textKey: 'downloadPDF',
                                    onclick: function() {
                                        this.exportChart({
                                            type: 'application/pdf'
                                        });
                                    }
                                }]
                            }
                        }
                    }

                });

            })
        }


        var data = [
            { "date": "2012-01-01", "value": 4.13 },
            { "date": "2012-01-02", "value": 4.88 },
            { "date": "2012-01-03", "value": 5.89 },
            { "date": "2012-01-04", "value": 5.87 },
            { "date": "2012-01-05", "value": 8.54 },
            { "date": "2012-01-06", "value": 4.41 },
            { "date": "2012-01-07", "value": 8.56 },
            { "date": "2012-01-08", "value": 8.05 },
            { "date": "2012-01-09", "value": 8.13 },
            { "date": "2012-01-10", "value": 5.86 }
        ]

        /* Monday 2012 */
        var data1 = data;
        // var title1 = "Line graph";
        var dateformat = "%Y-%m-%d";
        //drawTimeSeriesGraph(data1, dateformat);

        /* 
        Tooltip from: http://bl.ocks.org/d3noob/6eb506b129f585ce5c8a
        line graph from here: http://www.d3noob.org/2012/12/starting-with-basic-d3-line-graph.html
        */

        function drawTimeSeriesGraph(data, dateformat) {

            //Set bounds for red dots
            var lbound = 0.045,
                ubound = 0.075;

            // Set the dimensions of the canvas / graph
            var margin = { top: 50, right: 200, bottom: 30, left: 20 },
                width = document.getElementById('line-chart').offsetWidth - margin.left - margin.right,
                height = document.getElementById('line-chart').offsetHeight - margin.top - margin.bottom;

            // Parse the date / time
            var parseDate = d3.time.format(dateformat).parse,
                formatDate = d3.time.format(dateformat),
                bisectDate = d3.bisector(function(d) { return d.date; }).left;

            // Set the ranges
            var x = d3.time.scale().range([0, width]);
            var y = d3.scale.linear().range([height, 0]);

            // Define the axes
            var xAxis = d3.svg.axis().scale(x)
                .orient("bottom").ticks(10);

            var yAxis = d3.svg.axis().scale(y)
                .orient("left").ticks(10);

            // Define the line
            var valueline = d3.svg.line()
                .x(function(d) { return x(d.date); })
                .y(function(d) { return y(d.value); });

            // Adds the svg canvas
            var svg = d3.select("#line-chart")
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr("transform",
                    "translate(" + margin.left + "," + margin.top + ")");

            var lineSvg = svg.append("g")
                .attr("shape-rendering", "geometricPrecision");

            var focus = svg.append("g")
                .style("display", "none");

            // Get the data

            data.forEach(function(d) {
                d.date = parseDate(d.date);
                d.value = +d.value;
            });

            // Scale the range of the data
            x.domain(d3.extent(data, function(d) { return d.date; }));
            y.domain([0, d3.max(data, function(d) { return d.value; })]);
            //Use below if instead you want to define the y limits:
            //y.domain([0, 0.11]);

            // Add the valueline path.
            lineSvg.append("path")
                .attr("class", "line")
                .attr("d", valueline(data))
                .attr("stroke", "steelblue")
                .attr("stroke-width", 2)
                .attr("fill", "none")


            // Add the X Axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxis);

            // Add the Y Axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxis);

            // append the x line
            focus.append("line")
                .attr("class", "x")
                .style("stroke", "blue")
                .style("stroke-dasharray", "3,3")
                .style("opacity", 0.5)
                .attr("y1", 0)
                .attr("y2", height)
                .attr("fill", "none");

            // append the y line
            focus.append("line")
                .attr("class", "y")
                .style("stroke", "blue")
                .style("stroke-dasharray", "3,3")
                .style("opacity", 0.5)
                .attr("x1", width)
                .attr("x2", width)
                .attr("fill", "none");

            // append the circle at the intersection
            focus.append("circle")
                .attr("class", "y")
                .style("fill", "blue")
                .style("stroke", "blue")
                .attr("r", 4);

            // place the value at the intersection
            focus.append("text")
                .attr("class", "y1")
                .style("stroke", "white")
                .style("stroke-width", "3.5px")
                .style("opacity", 0.8)
                .attr("dx", 8)
                .attr("dy", "-.3em");
            focus.append("text")
                .attr("class", "y2")
                .attr("dx", 8)
                .attr("dy", "-.3em");

            // place the date at the intersection
            focus.append("text")
                .attr("class", "y3")
                .style("stroke", "white")
                .style("stroke-width", "3.5px")
                .style("opacity", 0.8)
                .attr("dx", 8)
                .attr("dy", "1em");
            focus.append("text")
                .attr("class", "y4")
                .attr("dx", 8)
                .attr("dy", "1em");

            // append the rectangle to capture mouse
            svg.append("rect")
                .attr("width", width)
                .attr("height", height)
                .style("fill", "none")
                .style("pointer-events", "all")
                .on("mouseover", function() { focus.style("display", null); })
                .on("mouseout", function() { focus.style("display", "none"); })
                .on("mousemove", mousemove);

            function mousemove() {
                var x0 = x.invert(d3.mouse(this)[0]),
                    i = bisectDate(data, x0, 1),
                    d0 = data[i - 1],
                    d1 = data[i],
                    d = x0 - d0.date > d1.date - x0 ? d1 : d0;

                focus.select("circle.y")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")");

                focus.select("text.y1")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")")
                    .text(d.value.toFixed(2));

                focus.select("text.y2")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")")
                    .text(d.value.toFixed(2));

                focus.select("text.y3")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")")
                    .text(formatDate(d.date));

                focus.select("text.y4")
                    .attr("transform",
                        "translate(" + x(d.date) + "," +
                        y(d.value) + ")")
                    .text(formatDate(d.date));

                // focus.select(".x")
                // 	.attr("transform",
                // 		  "translate(" + x(d.date) + "," +
                // 						 y(d.value) + ")")
                // 			   .attr("y2", height - y(d.value));

                // focus.select(".y")
                // 	.attr("transform",
                // 		  "translate(" + width * -1 + "," +
                // 						 y(d.value) + ")")
                // 			   .attr("x2", width + width);
            };

            // svg.append("text")
            // 	.attr("x", (width / 2))             
            // 	.attr("y", 0 - (margin.top / 2))
            // 	.attr("text-anchor", "middle")  
            // 	.style("font-size", "16px") 
            // 	.style("text-decoration", "underline")  
            // 	.text(title);
        };


    }

})();
(function () {
	'use strict';

	angular.module('trakeyeApp').controller('NocAlertsReportController', NocAlertsReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	NocAlertsReportController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function NocAlertsReportController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadIncidentsAlarmQueueReport = downloadIncidentsAlarmQueueReport;
		vm.report = report;
		vm.sortResponse = sortResponse;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.selecterange = selectRange;

		vm.select2();

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadIncidentsAlarmQueueReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getIncidentsAlarmQueueReportDownload({
				fromTime: vm.fromTime,
				toTime: vm.toTime
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "incidents_alarm_queue_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getIncidentsAlarmQueueReport({
				fromTime: vm.fromTime,
				toTime: vm.toTime
			}, function (response) {
				if (response instanceof Array) {
					vm.reportRecords = response;
					console.log(vm.reportRecords);
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getIncidentsAlarmQueueReport({
				fromTime: vm.fromTime,
				toTime: vm.toTime,
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('MobileUserAttendaceController', MobileUserAttendaceController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function($sce) {
		return function(text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	MobileUserAttendaceController.$inject = ['$scope', '$sce', '$state', "Report"];

	function MobileUserAttendaceController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadAttendenceReport = downloadAttendenceReport;
		vm.report = report;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "mobileUser";
		vm.selecterange = selectRange;
		vm.sortResponse = sortResponse;

		vm.maxDate = new Date();
		vm.maxDate.setHours(23, 59, 59, 999);

		vm.select2();

		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function(response) {
				vm.users = response;
			})
			getPresentDayCheckedInUserSummary();
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadAttendenceReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function(response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "user_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function(response) {
				var diffMillis = vm.toTime - vm.fromTime;
				var diffDays = diffMillis / (1000 * 60 * 60 * 24);

				console.log("Days between:", Math.ceil(diffDays));
				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				reportType: vm.userType
			}, function(response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

		function getPresentDayCheckedInUserSummary() {
			Report.getpresentDayCheckinUserSummary(function(response) {
				vm.summary = response.data;
			})
		}
		function calculateFromDate() {

			if (vm.fromDate > vm.toDate) {
				alert("From Date cannot be greater than To Date");
				vm.fromDate = new Date(vm.toDate);
			}

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}

		function calculateToDate() {

			var today = new Date();
			today.setHours(23, 59, 59, 999);

			// Prevent future dates
			if (vm.toDate > today) {
				alert("To Date cannot be a future date");
				vm.toDate = new Date(today);
			}

			// Prevent To Date < From Date
			if (vm.toDate < vm.fromDate) {
				alert("To Date cannot be less than From Date");
				vm.toDate = new Date(vm.fromDate);
			}

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('IncidentsReportController', IncidentsReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	IncidentsReportController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function IncidentsReportController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadIncidentsReport = downloadIncidentsReport;
		vm.report = report;
		vm.sortResponse = sortResponse;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.selecterange = selectRange;

		vm.select2();

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadIncidentsReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getIncidentsReportDownload({
				fromTime: vm.fromTime,
				toTime: vm.toTime
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "incidents_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getIncidentsReport({
				fromTime: vm.fromTime,
				toTime: vm.toTime
			}, function (response) {
				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getIncidentsReport({
				fromTime: vm.fromTime,
				toTime: vm.toTime,
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('GpsUserAttendaceController', GpsUserAttendaceController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	GpsUserAttendaceController.$inject = ['$scope', '$sce', '$state', 'Report'];

	function GpsUserAttendaceController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadAttendenceReport = downloadAttendenceReport;
		vm.report = report;
		vm.sortResponse = sortResponse;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "gpsUser";
		vm.selecterange = selectRange;

		vm.select2();

		vm.users = loadPage();
		
		vm.maxDate = new Date();
		vm.maxDate.setHours(23, 59, 59, 999);

		function loadPage() {
			Report.getUsers('', function (response) {
				vm.users = response;
			})
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadAttendenceReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "gps_user_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				toTime: vm.toTime,
				reportType: vm.userType
			}, function (response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

		function getPresentDayCheckedInUserSummary() {
			Report.getpresentDayCheckinUserSummary(function(response) {
				vm.summary = response.data;
			})
		}
		function calculateFromDate() {

			if (vm.fromDate > vm.toDate) {
				alert("From Date cannot be greater than To Date");
				vm.fromDate = new Date(vm.toDate);
			}

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}

		function calculateToDate() {

			var today = new Date();
			today.setHours(23, 59, 59, 999);

			// Prevent future dates
			if (vm.toDate > today) {
				alert("To Date cannot be a future date");
				vm.toDate = new Date(today);
			}

			// Prevent To Date < From Date
			if (vm.toDate < vm.fromDate) {
				alert("To Date cannot be less than From Date");
				vm.toDate = new Date(vm.fromDate);
			}

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('GeofenceDumpController', GeofenceDumpController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	GeofenceDumpController.$inject = ['$scope', '$sce', '$state', 'AllGeofenceIDs', 'Report'];

	function GeofenceDumpController($scope, $sce, $state, AllGeofenceIDs, Report) {
		var vm = this;
		vm.downloadAttendenceReport = downloadAttendenceReport;
		vm.downloadAttendenceReportKml = downloadAttendenceReportKml;
		vm.select2 = select2;
		vm.select2();
		vm.geofences = [];
		vm.selectedGeofenceId = 0;
		vm.users = loadPage();

		function loadPage() {
			AllGeofenceIDs.getAll(function (response) {
                response.forEach(function (geofence) {
                    vm.geofences.push({ name: geofence.name, id: geofence.id, nameZone: geofence.name + " - " + geofence.geofenceType});
                });
            });
		}

		function downloadAttendenceReport() {
			Report.downloadGeofenceDump({
				id: vm.selectedGeofenceId
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "geofence.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function downloadAttendenceReportKml() {
			Report.downloadGeofenceDumpKml({
				id: vm.selectedGeofenceId
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/text' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "geofence.kml";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function select2() {
			$(".select2").select2();
		}

	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('GeofenceReportController', GeofenceReportController)

	GeofenceReportController.$inject = [ '$scope', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval' ];

	function GeofenceReportController($scope, $state, Report, $rootScope, $timeout, $window, $filter, $interval) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.batteryusers = [];
		$scope.reporthide = false;
		vm.select2 = select2;
		var dateFormat = 'dd EEE hh:mm a';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		vm.appName = $rootScope.APP_NAME;
		// vm.today();
		vm.select2();
		Report.getUsers('', function(response) {
			vm.batteryusers = response;

		})

		vm.geofences = loadPage();
		function loadPage(){
			Report.getGeofences('', function(response) {
				vm.geofences = response;
			})
			vm.reportType = 'geofence';
		}
		
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		$scope.report = function() {
			if (vm.reportType == 'geofence' && vm.geofence == 'all') {
				vm.id = 0;
			}
			Report.getReport({
				id : vm.id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				$scope.search = "";
				$scope.reporthide = true;
			})

		}
		vm.detailedReport = detailedReport;

		vm.selecterange = selectRange;
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		function selectRange(range) {
			if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} else if (range == 'year') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setYear(date.getFullYear() - 1);
				vm.fromTime = date.getTime();
			}
		}
		function select2() {
			$(".select2").select2();
		}

		// Added for generating pdf start
		$scope.close = function() {
			$('#genericReport').show();
			$scope.reporthide = true;
			$('#report').hide();
		}
		$scope.loader = false;
		$(function() {
			$scope.getPdf = function() {
				$scope.loader = true;
				html2canvas(reportpdf, {
					onrendered : function(canvas) {
						var img = canvas.toDataURL("image/png");
						var pdf = new jsPDF('landscape', 'mm', 'a2');
						pdf.addImage(img, 'JPEG', 0, 0);
						pdf.save($scope.pdftype);
						$scope.loader = false;
					}
				});
				$interval(function() {
				}, 1000);
			}
		});
		// Added for generating pdf end
		function detailedReport(id) {
			Report.getDetailedReport({
				id : id,
				fromTime : vm.fromTime,
				toTime : vm.toTime,
				reportType : vm.reportType
			}, function(response) {
				vm.detailedReportCounts = response;

				$('#report').show();
				$scope.reporthide = false;
				$('#genericReport').hide();

				if (vm.reportType == 'geofence') {
					$scope.pdftype = 'Geofence.pdf';
					var coordicates = JSON.parse(response.coordinates);
					var map = new google.maps.Map(document.getElementById('map_canvas'), {
						zoom : 13,
						center : new google.maps.LatLng(coordicates[0].lat, coordicates[0].lng)
					});

					var polygon = new google.maps.Polygon({
						path : coordicates,
						strokeColor : "#ff0000",
						strokeOpacity : 0.8,
						strokeWeight : 2,
						fillColor : "#ff0000",
						fillOpacity : 0.3,
						editable : true
					})
					polygon.setMap(map);
					setTimeout(function() {
						google.maps.event.trigger(map, "resize");
						map.setCenter(new google.maps.LatLng(coordicates[0].lat, coordicates[0].lng));
					}, 100);
				}

			})
		}

		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		$scope.batteryreport = function() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			Report.getbatteryReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
				$scope.batteryline = response;
				$scope.battery = [];
				$scope.createTime = [];
				angular.forEach($scope.batteryline, function(value, key) {
					$scope.battery.push(value.batteryValue);
					$scope.createTime.push($filter('date')(value.createTime, dateFormat));
				});

				Highcharts.chart('battery_graph', {

					title : {
						text : 'Battery Usage Report'
					},

					subtitle : {
						text : ''
					},

					yAxis : {
						title : {
							text : 'Battery Percentage'
						}
					},
					legend : {
						layout : 'vertical',
						align : 'right',
						verticalAlign : 'middle'
					},
					xAxis : {
						categories : $scope.createTime
					},

					series : [ {
						name : ' ',
						data : $scope.battery
					} ],
					credits : {
						enabled : false
					},
					exporting : {
						buttons : {
							contextButton : {
								menuItems : [ {
									textKey : 'downloadPNG',
									onclick : function() {
										var fileName = "battery_report";
										this.exportChart({
											filename : fileName
										});
									}
								}, {
									textKey : 'downloadPDF',
									onclick : function() {
										this.exportChart({
											type : 'application/pdf'
										});
									}
								} ]
							}
						}
					}

				});

			})
		}

		$scope.distancereport = function() {
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			Report.getDistanceReport(vm.userid, vm.fromTime, vm.toTime, function(response) {
				$scope.distanceData = response;
				$scope.distance = [];
				$scope.date = [];

				angular.forEach($scope.distanceData, function(value, key) {
					$scope.distance.push(value.distance);

					// $scope.date.push($filter('date')(value.date,"dd EEE"));
					$scope.date.push(value.date);
				});

				Highcharts.chart('distance_graph', {

					title : {
						text : 'Distance Travelled Report'
					},

					subtitle : {
						text : ''
					},

					yAxis : {
						title : {
							text : 'Distance Travelled in KM'
						}
					},
					legend : {
						layout : 'vertical',
						align : 'right',
						verticalAlign : 'middle'
					},
					xAxis : {
						categories : $scope.date
					},
					series : [ {
						name : 'Distance in km',
						data : $scope.distance
					} ],
					credits : {
						enabled : false
					},
					exporting : {
						buttons : {
							contextButton : {
								menuItems : [ {
									textKey : 'downloadPNG',
									onclick : function() {
										var fileName = "distance_report";
										this.exportChart({
											filename : fileName
										});
									}
								}, {
									textKey : 'downloadPDF',
									onclick : function() {
										this.exportChart({
											type : 'application/pdf'
										});
									}
								} ]
							}
						}
					}

				});

			})
		}

	}

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').controller('FiberStatusReportController', FiberStatusReportController)

    FiberStatusReportController.$inject = ['$scope', 'UsersList', 'Principal', 'AssetsForMap', 'AssetsForMapByAdmin'];

    function FiberStatusReportController($scope, UsersList, Principal, AssetsForMap, AssetsForMapByAdmin) {
        var vm = this;
        vm.userlist = [];
        $scope.reporthide = false;
        vm.select2 = select2;
        vm.select2();
        vm.users = loadPage();
        vm.multiassets = [];
        vm.assets = [];

    	var result = [];

        function loadPage() {
            var loggedInUserId = 0;
            Principal.identity().then(function (identity) {
                if (identity) {
                    loggedInUserId = identity.id;
                }
            })
            UsersList.getusers(function (response) {
                var users = [];
                response.forEach(function (item, index) {
                    if (item.authorities.includes("ROLE_USER_ADMIN") && (item.id != loggedInUserId)) {
                        users.push(item)
                    }
                });
                vm.userlist = users;

                vm.userlist.forEach(function (item, index) {
                    var vendorName = item.firstName + ' ' + item.lastName;
                    AssetsForMapByAdmin.assetsformapbyadmin(item.id, function (response) {
                    	var onAirDis = 0.0,
                            deployedDis = 0.0,
                            plannedDis = 0.0;
                        response.forEach(function (item) {
                        	
                            var disVal = 0.0;
                            var assetLocations = item.assetCoordinates;
                            if (assetLocations.length > 1) {
                                for (var index in assetLocations) {
                                    if (index >= 1) {
                                        var disCal = distanceCal(assetLocations[index].latitude, assetLocations[index].longitude, assetLocations[index - 1].latitude, assetLocations[index - 1].longitude);
                                        if (disCal > 0) {
                                            disVal += disCal;
                                        }
                                    }
                                }
                            }
                            var assetAV = item.assetTypeAttributeValues;
                            assetAV.forEach(function (item1) {
                                if (item1.assetDataTypeName == 'Fiber Status') {
                                    if (item1.attributeValue == 'On Air') {
                                        onAirDis = onAirDis + disVal;
                                    } else if (item1.attributeValue == 'Under Deployment') {
                                        deployedDis = deployedDis + disVal;
                                    } else if (item1.attributeValue == 'Planned') {
                                        plannedDis = plannedDis + disVal;
                                    }
                                }
                            });
                        });
                        vm.multiassets.push({
                            name: vendorName,
                            onair: onAirDis.toFixed(2),
                            deployed: deployedDis.toFixed(2),
                            planned: plannedDis.toFixed(2)
                        });

                        var vendorData = [];
                        var fiberStatusData = [];
                        var onAirDis = 0.0,
                            deployedDis = 0.0,
                            plannedDis = 0.0;
                        vm.multiassets.forEach(function (item2) {
                            vendorData.push({
                                label: item2.name,
                                value: item2.onair
                            })
                            onAirDis += parseFloat(item2.onair);
                            deployedDis += parseFloat(item2.deployed);
                            plannedDis += parseFloat(item2.planned);

                        });

                        fiberStatusData.push({
                            label: "ON AIR",
                            value: onAirDis.toFixed(2)
                        });
                        fiberStatusData.push({
                            label: "UNDER DEPLOYMENT",
                            value: deployedDis.toFixed(2)
                        });
                        fiberStatusData.push({
                            label: "PLANNED",
                            value: plannedDis.toFixed(2)
                        });
                        var donut = new Morris.Donut({
                            element: 'vendor-chart',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });

                        var donut1 = new Morris.Donut({
                            element: 'fiber-chart',
                            resize: true,
                            colors: ["#5668e2", "#56aee2", "#56e2cf", "#56e289", "#68e256", "#aee256", "#e2cf56", "#e28956", "#e25668", "#e256ae", "#cf56e2", "#8a56e2"],
                            data: fiberStatusData,
                            hideHover: 'auto'
                        });
                    });


                });
            });
            vm.reportType = 'agent';
        }
        
        vm.caseTypeClick = function (caseTypeName, value) {
        	vm.assets = [];
        	
        	 vm.userlist.forEach(function (item, index) {
                 var vendorName = item.firstName + ' ' + item.lastName;
                 if(caseTypeName == vendorName){
	                 AssetsForMapByAdmin.assetsformapbyadmin(item.id, function (response) {
	                     response.forEach(function (item) {
	                    	 if(item.assetType.layout == "SPREAD"){
	                    		 var isFiberStatusVal = false; 
	                    		 item.assetTypeAttributeValues.forEach(function(item1){
	                    			 if(item1.assetDataTypeName == "Fiber Status" && item1.attributeValue == value){
	                    				 isFiberStatusVal = true;
	                    			 }
	                    		 });
	                    		 if(isFiberStatusVal){
	                    			 result.push(item);
	                    		 }
	                    	 }
	                     });
	                    
	                 });
                 }
             });
        	 
        	 result.forEach(function(item2){
        		 var disVal = 0.0;
                 var assetLocations = item2.assetCoordinates;
                 if (assetLocations.length > 1) {
                     for (var index in assetLocations) {
                         if (index >= 1) {
                             var disCal = distanceCal(assetLocations[index].latitude, assetLocations[index].longitude, assetLocations[index - 1].latitude, assetLocations[index - 1].longitude);
                             if (disCal > 0) {
                                 disVal += disCal;
                             }
                         }
                     }
                 }
                 var linkStatusVal = '';
                 item2.assetTypeAttributeValues.forEach(function(item3){
        			 if(item3.name == "Link Status"){
        				 if(item3.attributeValue == "True"){
        					 linkStatusVal = "Active";
        				 }else{
        					 linkStatusVal = "Inactive";
        				 }
        			 }
        		 });
                 vm.assets.push({name:item2.name,status:value, distance:disVal.toFixed(2), linkstatus:linkStatusVal });
        	 });
  
        	 result = [];
        };

        function select2() {
            $(".select2").select2();
        }


        $("#userlist").change(function () {
        	vm.assets = [];
            vm.multiassets = [];
            var result = $("#userlist").val();
            if (result != "") {
                vm.multiassets = getAssetObj(result);
            } else {
                vm.userlist.forEach(function (item, index) {
                    var vendorName = item.firstName + ' ' + item.lastName;
                    AssetsForMapByAdmin.assetsformapbyadmin(item.id, function (response) {
                        var onAirDis = 0.0,
                            deployedDis = 0.0,
                            plannedDis = 0.0;
                        response.forEach(function (item) {
                            var disVal = 0.0;
                            var assetLocations = item.assetCoordinates;
                            if (assetLocations.length > 1) {
                                for (var index in assetLocations) {
                                    if (index >= 1) {
                                        var disCal = distanceCal(assetLocations[index].latitude, assetLocations[index].longitude, assetLocations[index - 1].latitude, assetLocations[index - 1].longitude);
                                        if (disCal > 0) {
                                            disVal += disCal;
                                        }
                                    }
                                }
                            }
                            var assetAV = item.assetTypeAttributeValues;
                            assetAV.forEach(function (item1) {
                                if (item1.assetDataTypeName == 'Fiber Status') {
                                    if (item1.attributeValue == 'On Air') {
                                        onAirDis = onAirDis + disVal;
                                    } else if (item1.attributeValue == 'Under Deployment') {
                                        deployedDis = deployedDis + disVal;
                                    } else if (item1.attributeValue == 'Planned') {
                                        plannedDis = plannedDis + disVal;
                                    }
                                }
                            });
                        });
                        vm.multiassets.push({
                            name: vendorName,
                            onair: onAirDis.toFixed(2),
                            deployed: deployedDis.toFixed(2),
                            planned: plannedDis.toFixed(2)
                        });

                        var vendorData = [];
                        var fiberStatusData = [];
                        var onAirDis = 0.0,
                            deployedDis = 0.0,
                            plannedDis = 0.0;
                        vm.multiassets.forEach(function (item1) {
                            vendorData.push({
                                label: item1.name,
                                value: item1.onair
                            })
                            onAirDis += parseFloat(item1.onair);
                            deployedDis += parseFloat(item1.deployed);
                            plannedDis += parseFloat(item1.planned);

                        });

                        fiberStatusData.push({
                            label: "ON AIR",
                            value: onAirDis.toFixed(2)
                        });
                        fiberStatusData.push({
                            label: "UNDER DEPLOYMENT",
                            value: deployedDis.toFixed(2)
                        });
                        fiberStatusData.push({
                            label: "PLANNED",
                            value: plannedDis.toFixed(2)
                        });
                        var donut = new Morris.Donut({
                            element: 'vendor-chart',
                            resize: true,
                            colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                            data: vendorData,
                            hideHover: 'auto'
                        });

                        var donut1 = new Morris.Donut({
                            element: 'fiber-chart',
                            resize: true,
                            colors: ["#5668e2", "#56aee2", "#56e2cf", "#56e289", "#68e256", "#aee256", "#e2cf56", "#e28956", "#e25668", "#e256ae", "#cf56e2", "#8a56e2"],
                            data: fiberStatusData,
                            hideHover: 'auto'
                        });
                    });
                });
            }
        });

        $('#userlist').trigger('change');
        
        function getAssetObj(adminId) {
            var vendorName = "";
            var assetObj = [];
            vm.userlist.forEach(function (item, index) {
                if (item.id == adminId) {
                    vendorName = item.login;
                }
            });
            AssetsForMapByAdmin.assetsformapbyadmin(adminId, function (response) {
                var onAirDis = 0.0,
                    deployedDis = 0.0,
                    plannedDis = 0.0;
                response.forEach(function (item) {
                    var disVal = 0.0;
                    var assetLocations = item.assetCoordinates;
                    if (assetLocations.length > 1) {
                        for (var index in assetLocations) {
                            if (index >= 1) {
                                var disCal = distanceCal(assetLocations[index].latitude, assetLocations[index].longitude, assetLocations[index - 1].latitude, assetLocations[index - 1].longitude);
                                if (disCal > 0) {
                                    disVal += disCal;
                                }
                            }
                        }
                    }
                    var assetAV = item.assetTypeAttributeValues;
                    assetAV.forEach(function (item1) {
                        if (item1.assetDataTypeName == 'Fiber Status') {
                            if (item1.attributeValue == 'On Air') {
                                onAirDis = onAirDis + disVal;
                            } else if (item1.attributeValue == 'Under Deployment') {
                                deployedDis = deployedDis + disVal;
                            } else if (item1.attributeValue == 'Planned') {
                                plannedDis = plannedDis + disVal;
                            }
                        }
                    });
                });
                assetObj.push({
                    name: vendorName,
                    onair: onAirDis.toFixed(2),
                    deployed: deployedDis.toFixed(2),
                    planned: plannedDis.toFixed(2)
                });

                var vendorData = [];
                var fiberStatusData = [];
                var onAirDis = 0.0,
                    deployedDis = 0.0,
                    plannedDis = 0.0;
                vm.multiassets.forEach(function (item1) {
                    vendorData.push({
                        label: item1.name,
                        value: item1.onair
                    })
                    onAirDis += parseFloat(item1.onair);
                    deployedDis += parseFloat(item1.deployed);
                    plannedDis += parseFloat(item1.planned);

                });

                fiberStatusData.push({
                    label: "ON AIR",
                    value: onAirDis.toFixed(2)
                });
                fiberStatusData.push({
                    label: "UNDER DEPLOYMENT",
                    value: deployedDis.toFixed(2)
                });
                fiberStatusData.push({
                    label: "PLANNED",
                    value: plannedDis.toFixed(2)
                });
                var donut = new Morris.Donut({
                    element: 'vendor-chart',
                    resize: true,
                    colors: ["#8a56e2", "#cf56e2", "#e256ae", "#e25668", "#e28956", "#e2cf56", "#aee256", "#68e256", "#56e289", "#56e2cf", "#56aee2", "#5668e2"],
                    data: vendorData,
                    hideHover: 'auto'
                });

                var donut1 = new Morris.Donut({
                    element: 'fiber-chart',
                    resize: true,
                    colors: ["#5668e2", "#56aee2", "#56e2cf", "#56e289", "#68e256", "#aee256", "#e2cf56", "#e28956", "#e25668", "#e256ae", "#cf56e2", "#8a56e2"],
                    data: fiberStatusData,
                    hideHover: 'auto'
                });
            });
            return assetObj;
        }

        

        // Added for generating pdf start
        $scope.close = function () {
            $('#genericReport').show();
            $scope.reporthide = true;
            $('#report').hide();
        }
        $scope.loader = false;



    }

    function distanceCal(lat1, lon1, lat2, lon2) {
        var theta = lon1 - lon2;
        var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
            Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
        dist = Math.acos(dist);
        dist = radians_to_degrees(dist);
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        if (isNaN(dist)) {
            return 0.0;
        } else {
            return (dist);
        }
    }

    function degrees_to_radians(degrees) {
        var pi = Math.PI;
        return degrees * (pi / 180);
    }

    function radians_to_degrees(radians) {
        var pi = Math.PI;
        return radians * (180 / pi);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("EntityDumpController", EntityDumpController);

    EntityDumpController.$inject = [
        "Report",
        "myservice",
        "$interval",
        "$scope"
    ];

    function EntityDumpController(
        Report,
        myservice,
        $interval,
        $scope
    ) {
        var vm = this;
        vm.highlightRow = false
        if(myservice.getValue() == 'true'){
            vm.highlightRow = true;
        }
       
        
        callReportApi()

        vm.refresh = function(){
            callReportApi()
        }

        function callReportApi(){
            Report.getListEntity(function (response){
                if(response.length){
                    vm.displayList = response.reverse()
                }
            })
        }

        var myInterval = $interval(function() {
            // Code to be executed periodically
            callReportApi()
          }, 15000); // Interval duration in milliseconds
        
          // Listen for the $destroy event to clear the interval when the controller is destroyed
          $scope.$on('$destroy', function() {
            // Clear the interval when the controller is destroyed
            if (angular.isDefined(myInterval)) {
              $interval.cancel(myInterval);
            }
          });
        
        vm.expand = function(entity) {
            vm.displayList.forEach(function (item) {
                item.expand = false;
            });

            if (vm.toggle == entity.id) {
                vm.toggle = undefined;
            } else {
                entity.expand = true;
                vm.toggle = entity.id;

                Report.getEntityDetails(entity.id,function (response){
                    vm.expandResponse = response
                })

            }


        }

        vm.download = function(imgId,id,name){
            var temp = "Report"
            Report.downloadZip(id,imgId,function (data){
                var a = document.createElement("a");
               var file = new Blob([data], { type: 'application/zip' });

               var fileURL = URL.createObjectURL(file);
               a.href = fileURL;
               a.download = name ? name + ".zip" : temp + ".zip";
               a.click();
               window.URL.revokeObjectURL(fileURL);
            })
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("EntityDumpDialogController", EntityDumpDialogController);

        EntityDumpDialogController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "$localStorage",
        "Report",
        "AllGeofenceIDs",
        "AllCaseTypes",
        "UserMasterGeofences",
        "MiniGeofencesByMasterID",
        "AssetType",
        "BaseUrl",
        "myservice"
    ];
    
    function EntityDumpDialogController(
        $timeout,
        $state,
        $scope,
        $localStorage,
        Report,
        AllGeofenceIDs,
        AllCaseTypes,
        UserMasterGeofences,
        MiniGeofencesByMasterID,
        AssetType,
        BaseUrl,
        myservice
    ) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        var dateFormat = "dd EEE hh:mm a";
        var date = "dd EEE";
        vm.fromTime = 0;
        vm.toTime = 0;
        //vm.today = today();
        vm.searchMini = "";
        vm.report;
        vm.geofences = [];
        vm.userMasterGeofences = [];
        vm.geofenceMini;
        vm.selectedMasterGeofenceId = 0;
        vm.selectedGeofenceId;
        vm.entity;
        vm.showMessage = false;
        vm.showMessageError = false;
        vm.selecterange = selectRange;
        vm.calculateToDate = calculateToDate;
        vm.calculateFromDate = calculateFromDate;
        vm.trackingId;
        //vm.submit = true;
        var date = new Date();
        $scope.optionsTo = {
			maxDate: date.setDate(date.getDate())
		};
        $scope.optionsFrom = {
			maxDate: date.setDate(date.getDate())
		};

        $(".select2").select2(); // Added search for select box
        function today() {
            var today = new Date();
            vm.toDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate()
            );
            vm.fromDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate()
            );
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }
        vm.users = loadPage();
        vm.toDate = null
        vm.fromDate = null
        $(".select2").change(function () {
            vm.showMessage = false;
            vm.showMessageError = false;
            //vm.submit = true;
        });

        function loadPage() {
            // AllGeofenceIDs.getAll(function (response) {
            // response.forEach(function (geofence) {
            // vm.geofences.push({
            // name: geofence.name,
            // id: geofence.id,
            // geofenceTypeMini: geofence.geofenceType,
            // nameZone: geofence.name + " - " + geofence.geofenceType,
            // });

            // vm.geofenceMini = vm.geofences.filter(function onlyMINI(a) {
            // return a.geofenceTypeMini == "MINI";
            // });
            // });
            // });

            AssetType.query(
                {
                    page: 0,
                    size: 100,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
            }
            function onSuccess(data, headers) {
                vm.assetTypesData = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                vm.userMasterGeofences = response;
                vm.selectedMasterGeofenceId = vm.userMasterGeofences[0].id.toString();
                vm.geofenceMini = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                        });
                    }
                );
            });
            AllCaseTypes.getAll(function (response) {
                vm.caseTypes = response;
            });
        }

        /* $scope.submitChange = function(){
//vm.submit = true;
vm.showMessageError= false
vm.showMessage= false
} */

        function openCalendar(date) {
            //vm.submit = true;
            vm.showMessageError = false;
            vm.showMessage = false;
            vm.datePickerOpenStatus[date] = true;
        }

        function selectRange(range) {
            if (range == "week") {
                vm.showMessageError = false;
                vm.showMessage = false;
                //vm.submit = true;
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setDate(date.getDate() - 7);
                vm.fromTime = date.getTime();
            } else if (range == "month") {
                vm.showMessageError = false;
                vm.showMessage = false;
                //vm.submit = true;
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setMonth(date.getMonth() - 1);
                vm.fromTime = date.getTime();
            } else if (range == "year") {
                vm.showMessageError = false;
                vm.showMessage = false;
                //vm.submit = true;
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setYear(date.getFullYear() - 1);
                vm.fromTime = date.getTime();
            }
        }

        function calculateFromDate() {
            $scope.optionsTo = {
                minDate: vm.fromDate.setDate(vm.fromDate.getDate()),
                maxDate: date.setDate(date.getDate())
            };
           vm.fromDate.setHours(0, 0, 0, 0);
           vm.fromTime = vm.fromDate.getTime();
        }

        $scope.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            //vm.submit = true;
            vm.geofenceMini = [];
            MiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );
        };

        vm.assetTypes = []
        $scope.assetLayoutChange = function (){
            if(vm.entityLayout == "FIXED"){
                vm.assetTypes = []
                vm.assetTypesData.filter(function(val){
                    if(val.layout  == "FIXED"){
                        vm.assetTypes.push({name: val.name, id: val.id})
                    }
                })
            }else{
                vm.assetTypes = []
                vm.assetTypesData.filter(function(val){
                    if(val.layout  == "SPREAD"){
                        vm.assetTypes.push({name: val.name, id: val.id})
                    }
                })
            }
        }

        function calculateToDate() {
            $scope.optionsFrom = {
                maxDate: vm.toDate.setDate(vm.toDate.getDate())
            };
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }

        $scope.entityDump = function () {
            //vm.submit = false;
            if (vm.entity == "Assets") {
                var geofenceDTO = vm.selectedGeofenceId;
                /*var geoList = [];
                geoList.push(geofenceDTO);*/
                if(vm.entityFileFormat == "EXCEL"){
                    BaseUrl.getBaseUrl(function(baseurl){
                        var request = new XMLHttpRequest();
                        request.open('GET', baseurl.stringValue+"api/assets-export-excel/"+geofenceDTO[0].id+"/"+vm.selectedAssettypeId[0].id, true);
                        request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
                        request.responseType = 'blob';
            
                        request.onload = function(e) {
                            if (this.status === 200) {
                                var blob = this.response;
                                if(blob.size > 0){
                                    if(window.navigator.msSaveOrOpenBlob) {
                                        window.navigator.msSaveBlob(blob, 'test.xlsx');
                                    }
                                    else{
                                        var downloadLink = window.document.createElement('a');
                                        var contentTypeHeader = request.getResponseHeader("Content-Type");
                                        downloadLink.href = window.URL.createObjectURL(new Blob([blob], { 
                                        type: contentTypeHeader }));
                                        downloadLink.download = 'AssetExportExcel.xlsx';
                                        document.body.appendChild(downloadLink);
                                        downloadLink.click();
                                        document.body.removeChild(downloadLink);
                                    }
                                }
                            }
                        };
                        request.send();
                    });
                } else {
                    Report.emailReport(
                        {
                            entityName: vm.entity,
                            geofences: geofenceDTO,
                            entityLayout : vm.entityLayout,
                            entityTypeId : vm.selectedAssettypeId[0].id,
                            fileFormat : vm.entityFileFormat
                        },
                        function (response) {
                            vm.showMessageError = false;
                            vm.showMessage = true;
                            vm.trackingId = response.id
                            $timeout(function () {
                                $state.go('entity-dump');
                            }, 2000);  
                            myservice.setValue("true");
                        },
                        function (e) {
                            vm.errorMessage = e.data.message;
                            vm.showMessage = false;
                            vm.showMessageError = true;
                            $timeout(function () {
                                vm.showMessageError = false;
                            }, 4000);
                        }
                    );
                }
            } else if (vm.entity == "Cases") {
                var selectedCaseType = 0;
                if (
                    vm.selectedCaseType != undefined &&
                    vm.selectCaseType != "all"
                ) {
                    selectedCaseType = vm.selectedCaseType.id;
                }

                Report.emailReport(
                    {
                        entityName: vm.entity,
                        entityStatus: vm.entityStatus,
                        caseTypeId: selectedCaseType,
                        entityTypeId: selectedCaseType,
                        reqFromDate: vm.fromTime,
                        reqToDate: vm.toTime,
                    },
                    function (response) {
                        vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id
                        $timeout(function () {
                            $state.go('entity-dump');
                        }, 2000); 
                        myservice.setValue("true");
                    },
                    function (e) {
                        vm.errorMessage = e.data.message;
                        vm.showMessage = false;
                        vm.showMessageError = true;
                        $timeout(function () {
                            vm.showMessageError = false;
                        }, 4000);
                    }
                );
            } else if (vm.entity == "Users") {
                Report.emailReport(
                    {
                        entityName: vm.entity,
                    },
                    function (response) {
                        vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id
                        $timeout(function () {
                            $state.go('entity-dump');
                        }, 2000);  
                        myservice.setValue("true");
                    },
                    function (e) {
                        vm.errorMessage = e.data.message;
                        vm.showMessage = false;
                        vm.showMessageError = true;
                        $timeout(function () {
                            vm.showMessageError = false;
                        }, 4000);
                    }
                );
            } else {
                alert("Please select valid entity!");
            }
        };
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('DistanceReportController', DistanceReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function($sce){
    return function(text) {
        return $sce.trustAsHtml(text);
    	};
	}]);

	DistanceReportController.$inject = [ '$scope','$sce' ,'$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval' ];

	function DistanceReportController($scope, $sce,$state, Report, $rootScope, $timeout, $window, $filter, $interval) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.reportTypeChange = reportTypeChanged;
		vm.users = [];
		
		vm.geofences = [];
		$scope.reporthide = false;
		vm.select2 = select2;
		var dateFormat = 'dd EEE hh:mm a';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		// vm.today();
		vm.select2();
		Report.getUsers('', function(response) {
			vm.users = response;

		})

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		
		//vm.detailedReport = detailedReport;

		vm.selecterange = selectRange;
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		function selectRange(range) {
			if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} else if (range == 'year') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setYear(date.getFullYear() - 1);
				vm.fromTime = date.getTime();
			}
		}
		function select2() {
			$(".select2").select2();
		}
		function reportTypeChanged() {
			$scope.reporthide = false;
			
				if (vm.users.length == 0) {
					Report.getUsers('', function(response) {
						vm.users = response;
					})
				}
			

		}
		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		
		
		$scope.report = function() {
			
				Report.getDistReport({
					"fromDateTime":vm.fromTime,
					"toDateTime":vm.toTime,
					"login":vm.userid
				}, function(response) {
					
					$scope.myhtml = response;
					
							
				});
				
			

		}
		
	}

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').controller('DailySurveyReportController', DailySurveyReportController)
    angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
        return function (text) {
            return $sce.trustAsHtml(text);
        };
    }]);

    DailySurveyReportController.$inject = ['$scope', '$sce', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval'];

    function DailySurveyReportController($scope, $sce, $state, Report, $rootScope, $timeout, $window, $filter, $interval) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.reportTypeChange = reportTypeChanged;
        vm.users = [];

        vm.geofences = [];
        $scope.reporthide = false;
        vm.select2 = select2;
        var dateFormat = 'dd EEE hh:mm a';
        var date = "dd EEE";
        vm.fromTime = 0;
        vm.toTime = 0;
        vm.today = today();
        $scope.dailySurveyData = [];
        // vm.today();
        vm.select2();
        Report.getUsers('', function (response) {
            vm.users = response;

        })

        function today() {
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }


        //vm.detailedReport = detailedReport;

        vm.selecterange = selectRange;
        vm.calculateToDate = calculateToDate;
        vm.calculateFromDate = calculateFromDate;
        function calculateFromDate() {

            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
        }
        function calculateToDate() {

            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }
        function selectRange(range) {
            if (range == 'week') {
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setDate(date.getDate() - 7)
                vm.fromTime = date.getTime();

            } else if (range == 'month') {

                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setMonth(date.getMonth() - 1);
                vm.fromTime = date.getTime();
            } else if (range == 'year') {

                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setYear(date.getFullYear() - 1);
                vm.fromTime = date.getTime();
            }
        }
        function select2() {
            $(".select2").select2();
        }
        function reportTypeChanged() {
            $scope.reporthide = false;

            if (vm.users.length == 0) {
                Report.getUsers('', function (response) {
                    vm.users = response;
                })
            }


        }
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;
        vm.datePickerOpenStatus.serviceDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.page = 1;
        vm.itemsPerPage = 25;
        vm.totalItems = 0;

        $scope.report = function (resetPage) {
            if (resetPage) {
                vm.page = 1;
            }

            var requestData = {
                startDate: vm.fromTime,
                endDate: vm.toTime,
                page: vm.page - 1,
                size: vm.itemsPerPage
            };

            Report.getDailyAssetSurveyReport(requestData, function (response, headers) {
                $scope.dailySurveyData = response.data;
                vm.totalItems = response.totalRecords;
            });
        };
        $scope.download = function () {
            $scope.loader = true;

            var allData = [];
            var page = 0;
            var size = vm.itemsPerPage;
            var firstRequestData = {
                startDate: vm.fromTime,
                endDate: vm.toTime,
                page: page,
                size: size
            };

            Report.getDailyAssetSurveyReport(firstRequestData, function (response) {
                var totalRecords = response.totalRecords;
                var totalPages = Math.ceil(totalRecords / size);

                allData = allData.concat(response.data);

                if (totalPages <= 1) {
                    createCSV(allData);
                    return;
                }
                fetchNextPage(page + 1, totalPages, allData);
            });

            function fetchNextPage(currentPage, totalPages, collectedData) {
                if (currentPage >= totalPages) {
                    createCSV(collectedData);
                    return;
                }

                var requestData = {
                    startDate: vm.fromTime,
                    endDate: vm.toTime,
                    page: currentPage,
                    size: vm.itemsPerPage
                };

                Report.getDailyAssetSurveyReport(requestData, function (response) {
                    collectedData = collectedData.concat(response.data);
                    fetchNextPage(currentPage + 1, totalPages, collectedData);
                });
            }
            function createCSV(data) {
                $scope.loader = false;

                if (!data || data.length === 0) {
                    alert("No data found for the selected range.");
                    return;
                }

                var csvRows = [];
                var headers = [
                    "Sl No",
                    "Created Date",
                    "Updated Date",
                    "Asset Name",
                    "Asset Type Name",
                    "First Name",
                    "Last Name",
                    "Block Name",
                    "District Name",
                    "Status",
                    "Progress"
                ];
                csvRows.push(headers.join(","));

                for (var i = 0; i < data.length; i++) {
                    var asset = data[i];
                    var progress = "N/A";
                    if (asset.status === "Completed") progress = "100%";
                    else if (asset.status === "In Progress") progress = "50%";
                    else if (asset.status === "Not Started") progress = "0%";

                    var createdDate = formatDate(asset.createDate);
                    var updatedDate = formatDate(asset.updateDate);
                    var row = [
                        (i + 1),
                        escapeCSV(createdDate),
                        escapeCSV(updatedDate),
                        escapeCSV(asset.assetName),
                        escapeCSV(asset.assetTypeName),
                        escapeCSV(asset.firstName),
                        escapeCSV(asset.lastName),
                        escapeCSV(asset.blockName),
                        escapeCSV(asset.district),
                        escapeCSV(asset.status),
                        escapeCSV(progress)
                    ];
                    csvRows.push(row.join(","));
                }

                var csvString = csvRows.join("\n");
                var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
                var link = document.createElement("a");
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", "DailySurveyReport.csv");
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            function escapeCSV(value) {
                if (value == null) return "";
                var str = value.toString().replace(/"/g, '""');
                if (str.search(/("|,|\n)/g) >= 0)
                    str = '"' + str + '"';
                return str;
            }
            function formatDate(epoch) {
                if (!epoch) return "";
                var date = new Date(epoch);
                var day = ("0" + date.getDate()).slice(-2);
                var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                var month = monthNames[date.getMonth()];
                var year = date.getFullYear();
                var hours = ("0" + date.getHours()).slice(-2);
                var minutes = ("0" + date.getMinutes()).slice(-2);
                var seconds = ("0" + date.getSeconds()).slice(-2);
                return day + "-" + month + "-" + year + " " + hours + ":" + minutes + ":" + seconds;
            }
        };
 

    }

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('CasesDumpController', CasesDumpController)

	CasesDumpController.$inject = ['$scope', '$state', 'Report'];

	function CasesDumpController($scope, $state, Report) {
		var vm = this;
		vm.downloadType = "";
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.downloadCaseDumpReport = downloadCaseDumpReport;
		vm.showMessage = false;
		vm.selecterange = selectRange;
		vm.select2();

		$('input[type=radio][name=type]').change(function() {
			vm.showMessage = false;
		});

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

		function downloadCaseDumpReport() {
			if((vm.toTime-vm.fromDate) > 2592000000){
				alert("Date Range exceeded month limit");
			}else{
				vm.showMessage = true;
				if (vm.downloadType == 'opencases') {
					Report.getOpenCasesReportDownload({
						id: 0,
						ageType: vm.dateRange,
						fromTime: vm.fromTime,
						toTime: vm.toTime,
						reportType: 'open'
					}, function (response) {
						var a = document.createElement("a");
						a.style = "display: none";
						var file = new Blob([(response)], { type: 'application/csv' });
						var fileURL = URL.createObjectURL(file);
						a.href = fileURL;
						a.download = "open_cases_report.csv";
						a.click();
						window.URL.revokeObjectURL(fileURL);
					});
				} else if (vm.downloadType == 'closedcases') {
					Report.getClosedCasesReportDownload({
						id: 0,
						ageType: vm.dateRange,
						fromTime: vm.fromTime,
						toTime: vm.toTime,
						reportType: 'closed'
					}, function (response) {
						var a = document.createElement("a");
						a.style = "display: none";
						var file = new Blob([(response)], { type: 'application/csv' });
						var fileURL = URL.createObjectURL(file);
						a.href = fileURL;
						a.download = "closed_cases_report.csv";
						a.click();
						window.URL.revokeObjectURL(fileURL);
					});
				}
			}

		}
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('CaseTatReportController', CaseTatReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function($sce){
    return function(text) {
        return $sce.trustAsHtml(text);
    	};
	}]);

	CaseTatReportController.$inject = [ '$scope','$sce' ,'$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval','Principal' ];

	function CaseTatReportController($scope, $sce,$state, Report, $rootScope, $timeout, $window, $filter, $interval,Principal) {
		var vm = this;
		vm.users = [];
		$scope.reporthide = false;
		vm.reportUser = $rootScope.userName;
		vm.openCalendar = openCalendar;
		var dateFormat = 'dd EEE hh:mm a';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		vm.datePickerOpenStatus = {};
		vm.tat = 5;
		vm.users = loadPage();
		$scope.loader = false;
		vm.search='';
		
		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		$(".select2").select2(); // Added search for select box
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		
		function loadPage(){
			Report.getUsers('', function(response) {
				vm.users = response;
			})
		}
		
		
		$scope.report = function() {
		 
			Report.getCasesTatReport({
					reportType:"USER",
					ageType:vm.dateRange,
					login:vm.reportUser,
					 tat : vm.tat,
					 fromDateTime : vm.fromTime,
					 toDateTime : vm.toTime
				}, function(response) {
					$scope.myhtml = response;
				});

		}
		var strokeWidth = 1.5;
		var margin = { top: 20, bottom: 20, left: 30, right: 20 };
		var width = 600 - margin.left - margin.right - (strokeWidth * 2);
		var height = 200 - margin.top - margin.bottom;

		var x0 = d3.scale.ordinal()
			.rangeRoundBands([0, width], .1);

		var x1 = d3.scale.ordinal();

		var y = d3.scale.linear()
			.range([height, 0]);

		var color = d3.scale.ordinal()
		.range(["#00FF00", "#000080", "#FFA500", "#FF0000"]);

		var xAxis = d3.svg.axis()
			.scale(x0)
			.orient("bottom");

		var yAxis = d3.svg.axis()
			.scale(y)
			.orient("left")
			.tickFormat(d3.format(".2s"));

		var svg = d3.select("#verticalBarChart").append("svg")
			.attr("viewBox", "0 0 600 200")
			// .attr("width", width + margin.left + margin.right)
			// .attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		// d3.csv("data.csv", function(error, data) {
		var data = [
			{
				"State": 0,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 1,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 2,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 3,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 4,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 5,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},


		]

		var ageNames = d3.keys(data[0]).filter(function (key) { return key !== "State"; });

		data.forEach(function (d) {
			d.ages = ageNames.map(function (name) { return { name: name, value: +d[name] }; });
		});

		x0.domain(data.map(function (d) { return d.State; }));
		x1.domain(ageNames).rangeRoundBands([0, x0.rangeBand()]);
		y.domain([0, d3.max(data, function (d) { return d3.max(d.ages, function (d) { return d.value; }); })]);

		svg.append("g")
			.attr("class", "x axis")
			.attr("transform", "translate(0," + height + ")")
			.call(xAxis)
			.append("text")
			.attr("text-anchor", "end")
			.attr("x", 560)
			.attr("dx", ".71em")
			.text("Weeks")
			;

		svg.append("g")
			.attr("class", "y axis")
			.call(yAxis)
			.append("text")
			.attr("transform", "rotate(-90)")
			.attr("y", 4)
			.attr("dy", ".71em")
			.style("text-anchor", "end")
			.text("Cases");

		var state = svg.selectAll(".state")
			.data(data)
			.enter().append("g")
			.attr("class", "g")
			.attr("transform", function (d) { return "translate(" + x0(d.State) + ",0)"; });

		state.selectAll("rect")
			.data(function (d) { return d.ages; })
			.enter().append("rect")
			.attr("class", "bars")
			.attr("width", x1.rangeBand())
			.attr("x", function (d) { return x1(d.name); })
			.attr("y", function (d) { return y(d.value); })
			.attr("height", function (d) { return height - y(d.value); })
			.style("fill", function (d) { return color(d.name); });

		state.selectAll("text")
			.data(function (d) { return d.ages; })
			.enter().append("text")
			.attr("class", "barstext")
			.attr("x", function (d) { return x1(d.name); })
			.attr("y", function (d) { return y(d.value); })
			.text(function (d) { return (d.value) })
		// .text(function (d) { console.log(d.value / 1000000); return (d.value / 1000000).toFixed(2)})

		var legend = svg.selectAll(".legend")
			.data(ageNames.slice().reverse())
			.enter().append("g")
			.attr("class", "legend")
			.attr("transform", function (d, i) { return "translate(0," + i * 20 + ")"; });

		legend.append("rect")
			.attr("x", width - 22)
			.attr("width", 10)
			.attr("height", 10)
			.style("fill", color);

		legend.append("text")
			.attr("x", width - 12)
			.attr("y", 5)
			.attr("dy", ".20em")
			// .style("text-anchor", "end")
			.text(function (d) { return d; });

		// });
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('CaseReportController', CaseReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	CaseReportController.$inject = ['$scope', '$sce', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval', 'AllCaseTypes', 'DownloadCaseReports'];

	function CaseReportController($scope, $sce, $state, Report, $rootScope, $timeout, $window, $filter, $interval, AllCaseTypes, DownloadCaseReports) {
		var vm = this;
		vm.sortResponse = sortResponse;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.reportTypeChange = reportTypeChanged;
		vm.downloadCaseReport = downloadCaseReport;
		vm.submitCaseReport = submitCaseReport;
		vm.users = [];
		vm.batteryusers = [];
		vm.geofences = [];
		$scope.reporthide = false;
		vm.select2 = select2;
		// vm.selectshow = selectshow;
		var dateFormat = 'dd EEE hh:mm a';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		// vm.caseReport = true;
		vm.selectCaseType = 1;
		$scope.reporthide = false;
		// vm.today();
		vm.select2();
		Report.getUsers('', function (response) {
			vm.batteryusers = response;

		})

		AllCaseTypes.getAll(function (response) {
			vm.caseTypes = response;
		});

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		
		function downloadCaseReport() {
			var caseTypeId = 0;
			if (vm.selectCaseType != 'all') {
				caseTypeId = vm.selectedCaseType.id;
			}
			Report.getCaseReport({
				id: caseTypeId,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.caseType
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "case_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function submitCaseReport() {
			var caseTypeId = 0;
			if (vm.selectCaseType != 'all') {
				caseTypeId = vm.selectedCaseType.id;
			}
			Report.getCaseReportList({
				id: caseTypeId,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.caseType
			}, function (response) {
				vm.reportRecords = response;
				$scope.reporthide = true;
			});
		}

		function sortResponse() {
			var caseTypeId = 0;
			if (vm.selectCaseType != 'all') {
				caseTypeId = vm.selectedCaseType.id;
			}
			Report.getCaseReportList({
				id: caseTypeId,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				reportType: vm.caseType
			}, function (response) {
				vm.reportRecords = response;
				$scope.reporthide = true;
			});
		}

		//vm.detailedReport = detailedReport;

		vm.selecterange = selectRange;
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		function selectRange(range) {
			if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			} else if (range == 'year') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				date.setHours(0, 0, 0, 0);
				date.setYear(date.getFullYear() - 1);
				vm.fromTime = date.getTime();
			}
		}
		function select2() {
			$(".select2").select2();
			vm.caseReport = true;
		}
		function reportTypeChanged() {
			$scope.reporthide = false;
			if (vm.reportType == 'AGENT') {
				if (vm.users.length == 0) {
					Report.getUsers('', function (response) {
						vm.users = response;
					})
				}
			} else if (vm.reportType == 'GEOFENCE') {
				if (vm.geofences.length == 0) {
					Report.getGeofences('', function (response) {
						vm.geofences = response;
					})
				}
			}

		}
		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		$scope.report = function () {
			Report.getCasesReport({
				"fromDateTime": vm.fromTime,
				"toDateTime": vm.toTime,
				"caseReportType": vm.reportType
			}, function (response) {
				$scope.myhtml = response;
			});
		}
	}

})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('CaseAgingReportController', CaseAgingReportController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function($sce){
    return function(text) {
        return $sce.trustAsHtml(text);
    	};
	}]);

	CaseAgingReportController.$inject = [ '$scope','$sce' ,'$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval','Principal' ];

	function CaseAgingReportController($scope, $sce,$state, Report, $rootScope, $timeout, $window, $filter, $interval,Principal) {
		var vm = this;
		vm.users = [];
		$scope.reporthide = false;
		vm.reportUser = $rootScope.userName;
		vm.openCalendar = openCalendar;
		vm.users = loadPage();
		var dateFormat = 'dd EEE hh:mm a';
		var date = "dd EEE";
		vm.fromTime = 0;
		vm.toTime = 0;
		vm.today = today();
		vm.datePickerOpenStatus = {};
		vm.reportGenerated = false;
		vm.reportGeneratedFileName='';
		
		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		
		$(".select2").select2(); // Added search for select box
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}
		
		function loadPage(){
			Report.getUsers('', function(response) {
				vm.users = response;
			})
		}
		$scope.loader = false;
		$(function() {
			$scope.getPdf = function() {
				$scope.loader = true;
				html2canvas(reportpdf, {
					onrendered : function(canvas) {
						var img = canvas.toDataURL("image/png");
						var pdf = new jsPDF('landscape', 'mm', 'a2');
						pdf.addImage(img, 'JPEG', 0, 0);
						pdf.save($scope.pdftype);
						$scope.loader = false;
					}
				});
				$interval(function() {
				}, 1000);
			}
		});
		function select2() {
			$(".select2").select2();
		}
		$scope.report = function() {
				Report.getCasesAgingReport({
					reportType:"USER",
					ageType:vm.dateRange,
					login:vm.reportUser,
					fromDateTime : vm.fromTime,
					toDateTime : vm.toTime
				}, function(response) {
					$scope.myhtml = response;
				});
				
				vm.reportGenerated = true;


		}
		
		
		
		$scope.download = function() {
		       // $window.open("/images/CaseAgingReportByYears.xls");
				if(vm.dateRange === 'DAYS'){
				 window.location.href = "/images/CaseAgingReportByDays.xls";
			 	}else if(vm.dateRange === 'WEEKS'){
			 		window.location.href = "/images/CaseAgingReportByWeeks.xls";
				}else if(vm.dateRange === 'MONTHS'){
					window.location.href = "/images/CaseAgingReportByMonths.xls";
				}else if(vm.dateRange === 'YEARS'){
					window.location.href = "/images/CaseAgingReportByYears.xls";
				}
		    }

		var strokeWidth = 1.5;
		var margin = { top: 20, bottom: 20, left: 30, right: 20 };
		var width = 600 - margin.left - margin.right - (strokeWidth * 2);
		var height = 200 - margin.top - margin.bottom;

		var x0 = d3.scale.ordinal()
			.rangeRoundBands([0, width], .1);

		var x1 = d3.scale.ordinal();

		var y = d3.scale.linear()
			.range([height, 0]);

		var color = d3.scale.ordinal()
		.range(["#00FF00", "#000080", "#FFA500", "#FF0000"]);
			// .range(["#FF0000", "#FFA500", "#000080", "#00FF00"]);

		var xAxis = d3.svg.axis()
			.scale(x0)
			.orient("bottom");

		var yAxis = d3.svg.axis()
			.scale(y)
			.orient("left")
			.tickFormat(d3.format(".2s"));

		var svg = d3.select("#verticalBarChart").append("svg")
			.attr("viewBox", "0 0 600 200")
			// .attr("width", width + margin.left + margin.right)
			// .attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		// d3.csv("data.csv", function(error, data) {
		var data = [
			{
				"State": 0,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 1,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 2,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 3,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 4,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},
			{
				"State": 5,
				"Low": 38,
				"Medium": 10,
				"High": 88,
				"Critical": 41
			},


		]

		var ageNames = d3.keys(data[0]).filter(function (key) { return key !== "State"; });

		data.forEach(function (d) {
			d.ages = ageNames.map(function (name) { return { name: name, value: +d[name] }; });
		});

		x0.domain(data.map(function (d) { return d.State; }));
		x1.domain(ageNames).rangeRoundBands([0, x0.rangeBand()]);
		y.domain([0, d3.max(data, function (d) { return d3.max(d.ages, function (d) { return d.value; }); })]);

		svg.append("g")
			.attr("class", "x axis")
			.attr("transform", "translate(0," + height + ")")
			.call(xAxis)
			.append("text")
			.attr("text-anchor", "end")
			.attr("x", 560)
			.attr("dx", ".71em")
			.text("Weeks")
			;

		svg.append("g")
			.attr("class", "y axis")
			.call(yAxis)
			.append("text")
			.attr("transform", "rotate(-90)")
			.attr("y", 4)
			.attr("dy", ".71em")
			.style("text-anchor", "end")
			.text("Cases");

		var state = svg.selectAll(".state")
			.data(data)
			.enter().append("g")
			.attr("class", "g")
			.attr("transform", function (d) { return "translate(" + x0(d.State) + ",0)"; });

		state.selectAll("rect")
			.data(function (d) { return d.ages; })
			.enter().append("rect")
			.attr("class", "bars")
			.attr("width", x1.rangeBand())
			.attr("x", function (d) { return x1(d.name); })
			.attr("y", function (d) { return y(d.value); })
			.attr("height", function (d) { return height - y(d.value); })
			.style("fill", function (d) { return color(d.name); });

		state.selectAll("text")
			.data(function (d) { return d.ages; })
			.enter().append("text")
			.attr("class", "barstext")
			.attr("x", function (d) { return x1(d.name); })
			.attr("y", function (d) { return y(d.value); })
			.text(function (d) { return (d.value) })
		// .text(function (d) { console.log(d.value / 1000000); return (d.value / 1000000).toFixed(2)})

		var legend = svg.selectAll(".legend")
			.data(ageNames.slice().reverse())
			.enter().append("g")
			.attr("class", "legend")
			.attr("transform", function (d, i) { return "translate(0," + i * 20 + ")"; });

		legend.append("rect")
			.attr("x", width - 22)
			.attr("width", 10)
			.attr("height", 10)
			.style("fill", color);

		legend.append("text")
			.attr("x", width - 12)
			.attr("y", 5)
			.attr("dy", ".20em")
			// .style("text-anchor", "end")
			.text(function (d) { return d; });

		// });
		
	}

})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetHealthStatusController", AssetHealthStatusController);

    AssetHealthStatusController.$inject = [
        "$scope",
        "AlertService",
        "UserMasterGeofences",
        "MiniGeofencesByMasterID",
        "AssetStatusListWithGeofence",
        "CasesForAsset",
        "Report"
    ];

    function AssetHealthStatusController(
        $scope,
        AlertService,
        UserMasterGeofences,
        MiniGeofencesByMasterID,
        AssetStatusListWithGeofence,
        CasesForAsset,
        Report
    ) {
        var vm = this;
        
        vm.userMasterGeofences = [];
        vm.geofenceMini = [];
        vm.caseTable = caseTable;
        vm.downloadAssetHealthStatusReport = downloadAssetHealthStatusReport;
        vm.sortResponse = sortResponse;

        load();
        

        function load() {
            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                vm.userMasterGeofences = response;
                vm.selectedMasterGeofenceId = vm.userMasterGeofences[0].id.toString();
                vm.geofenceMini = [];
                MiniGeofencesByMasterID.get(
                    vm.selectedMasterGeofenceId,
                    function (response) {
                        response.forEach(function (value) {
                            vm.geofenceMini.push(value);
                        });
                    }
                );
            });
        }

        $scope.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            vm.selectedGeofenceId="";
            vm.geofenceMini = [];
            MiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );
        };
        vm.predicate = 'assetId';
        $scope.onMiniChange = function () {
            Report.getAssetHealthListWithGeoReport({
				id: vm.selectedGeofenceId,
                sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
			}, function (response) {
                vm.assetRecords = response;
			});
        };

        function caseTable(assetRecord) {
            vm.assetRecords.forEach(function (item) {
                item.isExpanded = false;
            });
            if (vm.toggle == assetRecord.assetId) {
                vm.toggle = undefined;
            } else {
                assetRecord.isExpanded = true;
                vm.toggle = assetRecord.assetId;
            }
            CasesForAsset.query(
                {
                    assetId: assetRecord.assetId
                },
                onSuccessList,
                onErrorList
            );
            function onSuccessList(data) {
                vm.caseRecords = data;
            }

            function onErrorList(error) {
                AlertService.error(error.data.message);
            }
        }
        function downloadAssetHealthStatusReport() {
            Report.getAssetHealthStatusReportDownload({
                id: vm.selectedGeofenceId
            }, function (response) {
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([(response)], { type: 'application/csv' });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "asset_health_status_report.csv";
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
		}

        function sortResponse() {
			Report.getAssetHealthListWithGeoReport({
				id: vm.selectedGeofenceId,
                sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
			}, function (response) {
                vm.assetRecords = response;
			});
		}
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetHealthController", AssetHealthController);

    AssetHealthController.$inject = [
        "$scope",
        "$rootScope",
        "AlertService",
        "UserAccount",
        "UserGeofences",
        "GeofenceIDs",
        "AssetByID",
        "AssetType",
        "BufferGeofencesByMiniID",
        "AssetGroupByBufferGeo",
    ];

    function AssetHealthController(
        $scope,
        $rootScope,
        AlertService,
        UserAccount,
        UserGeofences,
        GeofenceIDs,
        AssetByID,
        AssetType,
        BufferGeofencesByMiniID,
        AssetGroupByBufferGeo
    ) {
        var vm = this;

        var locations = {};
        var isAdmin = false;
        vm.userGeofences = [];
        vm.selectedGeofenceId = 0;
        var markers = [];
        var polylines = [];
        vm.mapAssets = [];
        var latlng = null;
        var activeInfo;
        vm.selectedGeofence = {};
        vm.assetTypes = [];
        vm.previousPolygons = [];
        vm.select2 = select2;
        vm.closeAssetAttributesModal = closeAssetAttributesModal;
        vm.closeThreePointReference = closeThreePointReference;
        vm.saveGeofenceFilter = saveGeofenceFilter;
        vm.showAssetHealth = showAssetHealth;
        var openedInfoWindow = null;
        var prevInfoWindow = null;
        vm.bufferGeoAssets = [];
        var polylines = [];
        vm.assetHealthDistance = [];
        vm.select2();
        load();

        function select2() {
            $(".select2").select2();
        }

        function load() {
            document.getElementById("myspan").textContent = " ";
            /*  var myOptions = {
                zoom: 12,
                center: new google.maps.LatLng(
                    $rootScope.DEFAULT_LATITUDE,
                    $rootScope.DEFAULT_LONGITUDE
                ),
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */

            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(
                    12,
                    new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE)
                )
            );
            geoLocation(locations.map);
            vm.userGeofences = [];
            UserAccount.get(function (data) {
                isAdmin = false;
                data.authorities.forEach(function (val) {
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }
                });
                if (isAdmin) {
                    GeofenceIDs.getAll(function (response) {
                        response.forEach(function (geofence) {
                            vm.userGeofences.push(geofence);

                            if (vm.selectedGeofenceId == null) {
                                vm.selectedGeofenceId = geofence.id;
                            }
                        });
                        vm.countLength = vm.userGeofences.length;
                    });
                } else {
                    UserGeofences.getAll(function (response) {
                        response.forEach(function (geofence) {
                            vm.userGeofences.push(geofence);

                            if (vm.selectedGeofenceId == null) {
                                vm.selectedGeofenceId = geofence.id;
                            }
                        });
                        vm.countLength = vm.userGeofences.length;
                    });
                }
            });
            AssetType.query(
                {
                    page: 0,
                    size: 100,
                },
                onSuccess,
                onError
            );
            function onSuccess(data, headers) {
                vm.assetTypes = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function showAssetHealth() {
            vm.mapAssets = [];
            markers = [];
            polylines = [];
            vm.assetHealthDistance = [];

            var myOptions = {
                zoom: 12,
                center: new google.maps.LatLng(
                    $rootScope.DEFAULT_LATITUDE,
                    $rootScope.DEFAULT_LONGITUDE
                ),
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };

            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(
                    12,
                    new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE)
                )
            );
            geoLocation(locations.map);
            document.getElementById("myspan").textContent = "";
            saveGeofenceFilter();

            AssetGroupByBufferGeo.get(
                vm.selectedGeofenceId,
                function (response) {
                    vm.bufferGeoAssets = Object.values(response);
                    var geofenceIds = Object.keys(response);
                    vm.bufferGeoAssets.forEach(function (assetList, index) {
                        drawAssets(assetList, geofenceIds[index]);
                    });
                }
            );
        }

        function drawAssets(response, geofenceId) {
            var normalDistance = 0;
            var okDistance = 0;
            var notOkDistance = 0;
            if (response) {
                var assetList = [];
                $.each(response, function (index, value) {
                    if (value.assetTypeLayout == null) {
                        value.assetTypeName = value.assetType.name;
                        value.assetTypeLayout = value.assetType.layout;
                        value.assetTypeImagePath = value.assetType.imagePath;
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "FIXED"
                    ) {
                        if (value.assetCoordinates.length > 1) {
                            var value1 = value;
                            value1.assetCoordinates = [
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ],
                            ];

                            // drawFixedAsset(value1);
                            assetList.push(value1);
                        } else {
                            // drawFixedAsset(value);
                            assetList.push(value);
                        }
                    }
                });
                assetList.forEach(function (value) {
                    drawFixedAsset(value);
                });
                var previousAsset = null;
                assetList.forEach(function (assetVal) {
                    if (previousAsset != null) {
                        if (previousAsset.assetCoordinates != undefined) {
                            var pathColor = "blue";
                            if (
                                previousAsset.healthIndicator == null ||
                                assetVal.healthIndicator == null
                            ) {
                                pathColor = "blue";
                            } else if (
                                previousAsset.healthIndicator &&
                                assetVal.healthIndicator
                            ) {
                                pathColor = "green";
                            } else if (
                                !previousAsset.healthIndicator ||
                                !assetVal.healthIndicator
                            ) {
                                pathColor = "red";
                            }

                            var path = [];

                            path.push({
                                lat: previousAsset.assetCoordinates[0].latitude,
                                lng:
                                    previousAsset.assetCoordinates[0].longitude,
                            });
                            path.push({
                                lat: assetVal.assetCoordinates[0].latitude,
                                lng: assetVal.assetCoordinates[0].longitude,
                            });
                            var dis = distanceCal(
                                path[0].lat,
                                path[0].lng,
                                path[1].lat,
                                path[1].lng
                            );
                            switch (pathColor) {
                                case "green":
                                    okDistance += dis;
                                    break;
                                case "red":
                                    notOkDistance += dis;
                                    break;
                                case "blue":
                                    normalDistance += dis;
                                    break;
                                default:
                                    normalDistance += dis;
                                    break;
                            }
                            drawHealthPolyline(path, pathColor);
                        }
                    }
                    previousAsset = assetVal;
                });
            }
            for (var i = 0; i < vm.assetHealthDistance.length; i++) {
                if (vm.assetHealthDistance[i].id == geofenceId) {
                    vm.assetHealthDistance[i].okDistance = okDistance.toFixed(
                        2
                    );
                    vm.assetHealthDistance[
                        i
                    ].notOkDistance = notOkDistance.toFixed(2);
                    vm.assetHealthDistance[
                        i
                    ].normalDistance = normalDistance.toFixed(2);
                }
            }
        }

        function saveGeofenceFilter() {
            vm.previousPolygons.forEach(function (polygon) {
                polygon.setMap(null);
            });
            vm.previousPolygons = [];
            var canZoomToLocation = true;
            BufferGeofencesByMiniID.get(
                vm.selectedGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.assetHealthDistance.push({
                            id: value.id,
                            name: value.name,
                        });
                        vm.previousPolygons.push(
                            drawPolygon(value, locations.latlng, "blue", 3)
                        );
                        if (canZoomToLocation) {
                            var path = JSON.parse(value.coordinates);
                            locations.map.setZoom(14);
                            if (path.length > 0) {
                                locations.map.setCenter(path[0]);
                            }
                            canZoomToLocation = false;
                        }
                    });
                }
            );
        }

        function drawPolygon(value, latlang, color, zIndex) {
            var path = JSON.parse(value.coordinates);
            // drawPolylineForGeoFence(path, locations.map, value.name);
            var infowindow = new google.maps.InfoWindow({
                content:
                    '<div class="infoWindowhead">' +
                    "name" +
                    '<div class="infoWindowContent"> <b>Description :</b> ' +
                    "des" +
                    "</div></div>",
                minWidth: 160,
            });

            infowindow.setPosition(latlang);
            var strokeColor = "#ff0000";

            if (color == "green") {
                strokeColor = "#ff0025";
            } else if (color == "blue") {
                strokeColor = "#0066CC";
            }

            var tempPolygon = new google.maps.Polygon({
                paths: path,
                strokeColor: strokeColor,
                strokeOpacity: 0.5,
                strokeWeight: 1.2,
                fillColor: strokeColor,
                fillOpacity: 0.1,
                zIndex: zIndex,
            });
            google.maps.event.addListener(
                tempPolygon,
                "mouseout",
                function (event) {
                    infowindow.close();
                }
            );

            google.maps.event.addListener(
                tempPolygon,
                "click",
                function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent(
                        '<div class="infoWindowhead">' +
                            "<b>Geofence Name : </b><br><br>" +
                            value.name +
                            "</br></div>"
                    );

                    infowindow.mousemove;
                    infowindow.open(locations.map);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;
                }
            );
            tempPolygon.setMap(locations.map);
            return tempPolygon;
        }

        function drawFixedAsset(fixed) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";

                var isFixedAsset = false;
                if ($scope.variableHealth) {
                    if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Chamber"
                    ) {
                        iconUrl = "content/images/chamber_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Chamber"
                    ) {
                        iconUrl = "content/images/chamber_red.png";
                    } else if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Coupler"
                    ) {
                        iconUrl = "content/images/coupler_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Coupler"
                    ) {
                        iconUrl = "content/images/coupler_red.png";
                    } else if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Pole"
                    ) {
                        iconUrl = "content/images/pole_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Pole"
                    ) {
                        iconUrl = "content/images/pole_red.png";
                    } else {
                        iconUrl = fixed.assetTypeImagePath;
                    }
                } else {
                    iconUrl = fixed.assetTypeImagePath;
                }

                iconUrl = fixed.assetTypeImagePath;

                var health = "Medium";
                var healthColor = "#0096FF";

                if (fixed.healthIndicator == true) {
                    health = "Good";
                    healthColor = "#00FF7F";
                } else if (fixed.healthIndicator == false) {
                    health = "Bad";
                    healthColor = "#FF5733";
                }

                var iconSize = 36;

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(18, -3),
                    },
                    label: {
                        text: ".",
                        color: healthColor,
                        fontWeight: "bold",
                        fontSize: "40px",
                        opacity: 0.25,
                    },
                });

                var infoWindow2 = new google.maps.InfoWindow();
                var infoStr = "";
                var otdr = "";

                var userContent = document.createElement("div"),
                    button;

                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    "<b>Asset Name</b> : " +
                    startMarker.title +
                    '</div><div class="infoWindowContent">' +
                    "<b>Lat</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .latitude +
                    "<br><b>Long</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .longitude +
                    "<br><b>Health</b> :" +
                    health +
                    "<br>" +
                    infoStr +
                    "</div>";

                google.maps.event.addListener(
                    startMarker,
                    "dblclick",
                    function () {
                        infoWindow2.close();
                    }
                );

                var activeInfoWindow;
                var infoWindow2 = new google.maps.InfoWindow({
                    content: userContent,
                });
                // add listener on InfoWindow for click
                // event
                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function () {
                        if (activeInfo != null) {
                            activeInfo.close();
                        }
                        AssetByID.get(fixed.id, function (response) {
                            vm.assetToEdit = response;
                            var infoWindow2 = new google.maps.InfoWindow();
                            var infoStr = "";
                            var otdr = "";
                            var assetTypeAttributeValuesList =
                                response.assetTypeAttributeValues;
                            assetTypeAttributeValuesList.sort(function (a, b) {
                                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                    nameB = a.assetTypeAttribute.name.toLowerCase();
                                if (nameA < nameB)
                                    // sort string ascending
                                    return -1;
                                if (nameA > nameB) return 1;
                                return 0; // default return value (no sorting)
                            });
                            for (
                                var i = 0;
                                i < assetTypeAttributeValuesList.length;
                                i++
                            ) {
                                var home = assetTypeAttributeValuesList[i];
                                infoStr +=
                                    "<br><b>" +
                                    home.assetTypeAttribute.name +
                                    "</b> : " +
                                    home.attributeValue;
                                otdr = home;
                            }

                            var userContent = document.createElement("div"),
                                btnShowAttributes,
                                btnThreePointRef;

                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                "<b>Asset Name</b> : " +
                                startMarker.title +
                                '</div><div class="infoWindowContent">' +
                                "<b>Lat</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].latitude +
                                "<br><b>Long</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].longitude +
                                "<br><b>Health</b> : " +
                                health +
                                "</div><br>";

                            vm.assetTitle = startMarker.title;

                            var attr = document.createAttribute("data-toggle");
                            attr.value = "modal";
                            var attr1 = document.createAttribute("data-target");
                            attr1.value = "#myModalMap";

                            btnShowAttributes = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnShowAttributes.type = "button";
                            btnShowAttributes.value = "More Details";
                            btnShowAttributes.className = "button";

                            btnThreePointRef = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnThreePointRef.type = "button";
                            btnThreePointRef.value = "3 Point Reference";
                            btnThreePointRef.className = "button";

                            google.maps.event.addDomListener(
                                btnShowAttributes,
                                "click",
                                function () {
                                    showAssetAttributesModal(response);
                                }
                            );

                            google.maps.event.addDomListener(
                                btnThreePointRef,
                                "click",
                                function () {
                                    showThreePontReferenceModal(response);
                                }
                            );

                            var infoWindow2 = new google.maps.InfoWindow({
                                content: userContent,
                                minWidth: 350,
                            });
                            if (prevInfoWindow != null) prevInfoWindow.close();
                            infoWindow2.open(locations.map, startMarker);
                            setTimeout(function () {
                                infoWindow2.close();
                            }, 10000);

                            activeInfoWindow = infoWindow2;
                            prevInfoWindow = infoWindow2;
                        });
                    }
                );
                openedInfoWindow = infoWindow2;
            });
        }

        function showAssetAttributesModal(assetVal) {
            $("#modalAssetAttributes").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues;
            document.getElementById("assetAttributeTable").innerHTML = "";

            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Name</th><th style='border: 1px solid black;text-align: center;'>Value</th></tr>";

            assetTypeAttributeValuesList.forEach(function (value) {
                if (
                    value.assetTypeAttribute.assetAttributeTypes ==
                    "NON_REFERENCE"
                ) {
                    newTable +=
                        "<tr><td style='border: 1px solid black;text-align: center;'>" +
                        value.assetTypeAttribute.name +
                        "</td><td style='border: 1px solid black;text-align: center;'>" +
                        value.attributeValue +
                        "</td></tr>";
                }
            });
            newTable += "</table>";
            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }

        function showThreePontReferenceModal(assetVal) {
            $("#modalThreePointReference").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues;
            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Object</th><th style='border: 1px solid black;text-align: center;'>Distance (mtr)</th></tr>";
            var ref = ["", "", ""];
            var dist = [0, 0, 0];
            assetTypeAttributeValuesList.forEach(function (value) {
                if (
                    value.assetTypeAttribute.assetAttributeTypes ==
                    "THREE_PNT_REFERENCE"
                ) {
                    if (value.assetTypeAttribute.name == "3 Point Reference1") {
                        ref[0] = value.attributeValue;
                    } else if (
                        value.assetTypeAttribute.name == "3 Point Reference2"
                    ) {
                        ref[1] = value.attributeValue;
                    } else if (
                        value.assetTypeAttribute.name == "3 Point Reference3"
                    ) {
                        ref[2] = value.attributeValue;
                    } else if (value.assetTypeAttribute.name == "Distance1") {
                        dist[0] = value.attributeValue;
                    } else if (value.assetTypeAttribute.name == "Distance2") {
                        dist[1] = value.attributeValue;
                    } else if (value.assetTypeAttribute.name == "Distance3") {
                        dist[2] = value.attributeValue;
                    }
                }
            });

            for (var i = 0; i < 3; i++) {
                newTable +=
                    "<tr><td style='border: 1px solid black;text-align: center;'>" +
                    ref[i] +
                    "</td><td style='border: 1px solid black;text-align: center;'>" +
                    dist[i] +
                    "</td></tr>";
            }
            newTable += "</table>";
            document.getElementById(
                "assetNameThreePointReference"
            ).textContent = assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById(
                "threePointReferenceTable"
            ).innerHTML = newTable;
        }

        function closeAssetAttributesModal() {
            $("#modalAssetAttributes").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalAssetAttributes").hide();
        }

        function closeThreePointReference() {
            $("#modalThreePointReference").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalThreePointReference").hide();
        }

        function drawHealthPolyline(path, color) {
            var strokeColor = "#0000FF";
            if (color == "green") {
                strokeColor = "#008000";
            } else if (color == "red") {
                strokeColor = "#FF0000";
            } else if (color == "blue") {
                strokeColor = "#fd7a24";
            }

            var polyline = new google.maps.Polyline({
                path: path,
                geodesic: true,
                strokeColor: strokeColor,
                strokeOpacity: 0.5,
                strokeWeight: 10,
                fillColor: strokeColor,
                fillOpacity: 0.4,
            });
            polyline.setMap(locations.map);
            polylines.push(polyline);
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                    Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                    Math.cos(degrees_to_radians(lat2)) *
                    Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "AssetGeofenceMappingController",
            AssetGeofenceMappingController
        );

    AssetGeofenceMappingController.$inject = [
        "$scope",
        "AllMiniGeofencesByMasterID",
        "AllTenant",
        "MasterGeofencesByTenantID",
        "AssetsGeofenceMapping"
    ];

    function AssetGeofenceMappingController(
        $scope,
        AllMiniGeofencesByMasterID,
        AllTenant,
        MasterGeofencesByTenantID,
        AssetsGeofenceMapping
    ) {
        var vm = this;

        vm.userMasterGeofences = [];
        vm.geofenceMini = [];
        vm.associateAssetsToGeofence = associateAssetsToGeofence;
        

        load();

        function load() {
            AllTenant.getAll(function (response) {
                vm.tenants = response;
            });
        }

        $scope.onTenantChange = function () {
            vm.userMasterGeofences = [];
            MasterGeofencesByTenantID.get(
                vm.selectedTenantId,
                function (response) {
                    vm.userMasterGeofences = response;
                }
            );
        };

        $scope.onMasterChange = function () {
            vm.showMessageError = false;
            vm.showMessage = false;
            vm.selectedGeofenceId = "";
            vm.geofenceMini = [];
            AllMiniGeofencesByMasterID.get(
                vm.selectedMasterGeofenceId,
                function (response) {
                    response.forEach(function (value) {
                        vm.geofenceMini.push(value);
                    });
                }
            );
        };

        function associateAssetsToGeofence() {
            AssetsGeofenceMapping.query(
                {
                    geofenceId: vm.selectedGeofenceId,
                },
                onSuccess,
                onError
            );
            function onSuccess(data, headers) {
                console.log(data);
                console.log(headers);
            }

            function onError(error) {
                console.log(error);
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetReportController', AssetReportController)

	AssetReportController.$inject = [ '$timeout', '$scope', 'Report', '$stateParams', '$q', '$filter', 'CaseType', 'AssetSearchForMap', 'AllCaseTypes' ];

	function AssetReportController($timeout, $scope, Report, $stateParams, $q, $filter, CaseType, AssetSearchForMap, AllCaseTypes) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		var dateFormat = 'dd EEE hh:mm a';
		var date = "dd EEE";
		vm.today = today;
		vm.today();
		vm.assetList = "";
		var usersMap = {};
		vm.caseType = "";

		vm.filterAssetsList = filterAssetsList;

		$(".select2").select2(); // Added search for select box
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
		}
		vm.caseTypes = loadPage();// CaseType.query();

		function loadPage() {
			AllCaseTypes.getAll(function(response) {
				vm.caseTypes = response;
			});
		}

		// Added for asset search start
		function filterAssetsList() {
			if (vm.assetType != null && vm.assetType != "" && !angular.isUndefined(vm.assetType)) {
				AssetSearchForMap.searchassetsformap(vm.assetType, function(response) {
					vm.assetList = response;
				});
			}
		}
		;
		// Added for asset search end ////

		// Added for caseType Attribute start /////
		// vm.caseType = vm.caseTypes;
		vm.selectattributes = function() {
			if (vm.caseType) {
				vm.attributeValues = [];
				$.each(vm.caseType.caseTypeAttribute, function(key, value) {
					if (vm.caseType.caseTypeAttribute[key].dataType === 'INTEGER' || vm.caseType.caseTypeAttribute[key].dataType === 'FLOAT')
						vm.attributeValues.push({
							caseTypeAttribute : vm.caseType.caseTypeAttribute[key]
						});
				});
			}

		}
		// clear search fields
		$scope.clearSearch = function() {
			vm.caseType = "";
			vm.attribute = "";
		};
		// Added for caseType Attribute end ////////
		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;
		
		if (vm.fromDate > vm.toDate) {
             return false;
         }

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		$scope.assetReport = function() {

			// vm.caseType = vm.caseType.id;
			// vm.attribute = vm.attribute.caseTypeAttribute.name;
			angular.forEach(vm.assetList, function(value, key) {
				if (vm.assetType === value.name) {
					vm.assetIdReport = value.id;
				}
			});

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();

			if (vm.assetIdReport != null && vm.caseType.id == null) {
				Report.getAssetCaseTypeReport(vm.assetIdReport, vm.fromTime, vm.toTime, function(response) {
					$scope.assetBar = response;
					$scope.assetCaseCount = [];
					$scope.caseType = [];

					angular.forEach($scope.assetBar, function(value, key) {
						$scope.assetCaseCount.push(value.count);
						$scope.caseType.push(value.caseType);

					});
					// $scope.assetValue = [10, 15, 20, 25];
					// $scope.createTime = ['2017-3-9', '2017-3-10',
					// '2017-3-11', '2017-3-12' ];

					Highcharts.chart('asset_graph', {
						chart : {
							type : 'column'
						},
						title : {
							text : 'Asset Usage Report'
						},

						subtitle : {
							text : vm.assetType
						},

						yAxis : {
							title : {
								text : "Task Count"
							}
						},
						legend : {
							layout : 'vertical',
							align : 'right',
							verticalAlign : 'middle'
						},
						xAxis : {
							categories : $scope.caseType
						},

						series : [ {
							name : ' ',
							data : $scope.assetCaseCount
						} ],
						credits : {
							enabled : false
						},
						exporting : {
							buttons : {
								contextButton : {
									menuItems : [ {
										textKey : 'downloadPNG',
										onclick : function() {
											var fileName = "Asset_report";
											this.exportChart({
												filename : fileName
											});
										}
									}, {
										textKey : 'downloadPDF',
										onclick : function() {
											this.exportChart({
												type : 'application/pdf'
											});
										}
									} ]
								}
							}
						}

					});

				})
			}
			// if end
			else if (vm.assetIdReport != null && vm.caseType.id != null) {
				Report.getAssetReport(vm.assetIdReport, vm.caseType.id, vm.attribute.caseTypeAttribute.name, vm.fromTime, vm.toTime, function(response) {
					$scope.assetLine = response;
					$scope.assetValue = [];
					vm.totalcount = null;
					$scope.createTime = [];
					angular.forEach($scope.assetLine, function(value, key) {
						;
						vm.totalcount += value.value;
						$scope.assetValue.push(value.value);
						$scope.createTime.push($filter('date')(value.datetime, dateFormat));

					});
					// $scope.assetValue = [10, 15, 20, 25];
					// $scope.createTime = ['2017-3-9', '2017-3-10',
					// '2017-3-11', '2017-3-12' ];

					Highcharts.chart('asset_graph', {

						title : {
							text : 'Asset Usage Report'
						},

						subtitle : {
							text : vm.assetType
						},

						yAxis : {
							title : {
								text : vm.attribute.caseTypeAttribute.name
							}
						},
						legend : {
							title : {
								text : 'Total :' + vm.totalcount
							},
							layout : 'vertical',
							align : 'right',
							verticalAlign : 'middle'
						},
						xAxis : {
							categories : $scope.createTime
						},

						series : [ {
							name : ' ',
							data : $scope.assetValue
						} ],
						credits : {
							enabled : false
						},
						exporting : {
							buttons : {
								contextButton : {
									menuItems : [ {
										textKey : 'downloadPNG',
										onclick : function() {
											var fileName = "Asset_report";
											this.exportChart({
												filename : fileName
											});
										}
									}, {
										textKey : 'downloadPDF',
										onclick : function() {
											this.exportChart({
												type : 'application/pdf'
											});
										}
									} ]
								}
							}
						}

					});

				})
			}// else end

		}

	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetCaseReportController', AssetCaseReportController)

	AssetCaseReportController.$inject = [ '$timeout', '$scope', 'Report', '$stateParams', '$q', '$filter', 'CaseType', 'AssetSearchForMap', 'AllCaseTypes' ];

	function AssetCaseReportController($timeout, $scope, Report, $stateParams, $q, $filter, CaseType, AssetSearchForMap, AllCaseTypes) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		var dateFormat = 'dd EEE hh:mm a';
		var date = "dd EEE";
		vm.today = today;
		vm.today();
		vm.assetList = "";
		var usersMap = {};
		vm.caseType = "";
		$scope.reporthide = false;
		vm.search='';
		vm.report;

		$(".select2").select2(); // Added search for select box
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
		}
		vm.caseTypes = loadPage();// CaseType.query();

		function loadPage() {
			AllCaseTypes.getAll(function(response) {
				vm.caseTypes = response;
			});
		}
		

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
		$scope.assetReport = function() {
			
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
			$scope.reporthide = true;
			vm.search='';
				Report.getAssetCaseReport(vm.caseType, vm.fromTime, vm.toTime, function(response) {
					vm.reportRecords = response;
				});
		
			
		}
		
		$scope.assetReportSearch = function() {
			if (vm.search != null && vm.search != "" && !angular.isUndefined(vm.search)) {
				Report.getAssetCaseReportSearch(vm.caseType, vm.fromTime, vm.toTime,vm.search, function(response) {
					vm.reportRecords = response;
				});
			}else{
				Report.getAssetCaseReport(vm.caseType, vm.fromTime, vm.toTime, function(response) {
					vm.reportRecords = response;
				});
		}
			
		}

	}
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("NavbarController", NavbarController);

    NavbarController.$inject = [
        "$state",
        "Auth",
        "Principal",
        "ProfileService",
        "LoginService",
        "$rootScope",
        "UserLogout",
        "Configs"
    ];

    function NavbarController(
        $state,
        Auth,
        Principal,
        ProfileService,
        LoginService,
        $rootScope,
        UserLogout,
        Configs
    ) {
        var vm = this;

        vm.isAuthenticated = Principal.isAuthenticated;
        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        var prev = [];
        var prevPlus = [];
        vm.accessRolePlanning = false
        vm.accessRoleRollout = false
        vm.currYear = new Date().getFullYear();
        vm.showRolloutDashboard = true;
        vm.showMonitoringSurveyReport = true;
        vm.showMonitoringGeofenceDump = true;
        vm.showMonitoringSplicingReport = true;
        vm.showMonitoringUserGeofenceDump = true;
        vm.showRolloutTaskLogReport = true;
        vm.showRolloutReport = true;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            UserLogout.post(
                {
                    username: $rootScope.userName,
                    password: "password",
                },
                function (data) {
                    Auth.logout();
                    $rootScope.listAuthorities();
                    $state.go("home");
                }
            );
        }

        vm.isNavbarCollapsed = true;
        function toggleNavbar(id) {
            if (document.getElementById("dashboardtitle")) {
                var getUrl = window.location.hash;
                if (getUrl != "#/login" && getUrl != "#/dashboard") {
                    document.getElementById("dashboardtitle").style.visibility =
                        "hidden";
                }
            }
            
            $(".fa-plus").removeClass("fa-minus");
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
            $(".treeview-menu").removeClass("menu-close").addClass("menu-open");
            /* $("#" + id + " > span.pull-right-container > i").toggleClass(
                "down"
            ); */
            prev.unshift(id);
            if (prev[0] != prev[1]) {
                $(
                    "#" + prev[1] + " > span.pull-right-container > i"
                ).removeClass("down");
                prev.length = 2;
            }
        }

        function collapseNavbar(id) {
            if (document.getElementById("dashboardtitle")) {
                if (typeof id === "undefined") {
                    document.getElementById("dashboardtitle").style.visibility =
                        "hidden";
                } else {
                    document.getElementById("dashboardtitle").style.visibility =
                        "visible";
                }
            }

            vm.isNavbarCollapsed = false;
            //$(".fa-plus").removeClass("fa-minus");
            $(".rotate").removeClass("down");
            $(".treeview").removeClass("active");
            $(".treeview-menu").addClass("menu-close").removeClass("menu-open");
            $rootScope.close = {
                display: "none",
            };
        }

        $rootScope.listAuthorities = function () {
            $rootScope.has_ROLE_SUPER_ADMIN = false;
            $rootScope.has_ROLE_USER_ADMIN = false;
            $rootScope.has_ROLE_USER = false;
            $rootScope.has_ROLE_VENDOR_ADMIN = false;
            $rootScope.has_ROLE_HOD = false;
            $rootScope.has_ROLE_CITY_MANAGER = false;
            $rootScope.has_ROLE_CITY_PLANNER = false;
            $rootScope.has_ROLE_ASSISTANT_MANAGER = false;
            $rootScope.has_ROLE_TEAM_LEADER = false;
            $rootScope.has_ROLE_NETWORK_ENGINEER = false;
            $rootScope.has_ROLE_FRT = false;
            $rootScope.has_ROLE_PATROLLER = false;

            $rootScope.has_ROLE_PLAN_ADMIN = false;
            $rootScope.has_ROLE_ROLLOUT_ADMIN = false;
            $rootScope.has_ROLE_ROLLOUT_FE = false;
            $rootScope.has_ROLE_ROLLOUT_MANAGER = false;

            $rootScope.has_ROLE_PMO = false;
            $rootScope.has_ROLE_RH = false;
            $rootScope.has_ROLE_BA = false;
            $rootScope.has_ROLE_OA = false;
            $rootScope.has_ROLE_FE = false;



            Principal.identity().then(function (identity) {
                vm.accessRolePlanning = vm.accessRoleRollout = vm.accessRoleRollout = vm.accessRolePlanningAdmin = vm.accessRoleRolloutAdmin = vm.groupRollout = vm.groupPlan = false
                
                if(identity != null) {
                    //Checking group  
                    identity.groups.forEach(function (val){
                        var convert = val.name.toLowerCase()
                        var res = convert.replace(/[^a-zA-Z]/g, "");
                        if(res.includes("planning")){
                        vm.groupPlan = true
                    }else if(res.includes("rollout")){
                        vm.groupRollout = true
                    }
                    })

                    identity.authorities.forEach(function (val){
                        if((vm.groupPlan && val.includes("ROLE_PLAN_"))){
                        vm.accessRolePlanning = true
                    }else if( (vm.groupRollout && val.includes("ROLE_ROLLOUT_")) || (vm.groupPlan && val.includes("ROLE_ROLLOUT_")) || (vm.groupRollout && val.includes("ROLE_PLAN_"))){
                        vm.accessRoleRollout = true
                    }
                    })

                    //Access for Entity Configuration
                    identity.authorities.forEach(function (val){
                        if(vm.accessRolePlanning && val == "ROLE_PLAN_ADMIN"){
                        vm.accessRolePlanningAdmin = true
                        vm.accessRoleRolloutAdmin = true
                    }/* else if(vm.accessRoleRollout && val == "ROLE_ROLLOUT_ADMIN"){
                        vm.accessRoleRolloutAdmin = true
                    } */
                    })
                }
                if(identity != null) {
                Configs.get("Features", function (response) {
                    response.filter(function (value){

                        if(value.configKey == "SurveyReport"){
                            if(value.configValue == "True"){
                                vm.showSurveyReport = true
                            }else{
                                vm.showSurveyReport = false
                            }
                        }

                        if(value.configKey == "PatrollingReport"){
                            if(value.configValue == "True"){
                                vm.showAssetHealthStatus = true
                            }else{
                                vm.showAssetHealthStatus = false
                            }
                        }

                        if(value.configKey == "EntityImport"){
                            if(value.configValue == "True"){
                                vm.showEntityImport = true
                            }else{
                                vm.showEntityImport = false
                            }
                        }
                        
                        if(value.configKey == "CaseImport"){
                            if(value.configValue == "True"){
                                vm.showCaseImport = true
                            }else{
                                vm.showCaseImport = false
                            }
                        }

                        if(value.configKey == "AssetLinkRequest"){
                            if(value.configValue == "True"){
                                vm.showAssetLinkRequest = true
                            }else{
                                vm.showAssetLinkRequest = false
                            }
                        }

                        if(value.configKey == "AssetLinkRequest"){
                            if(value.configValue == "True"){
                                vm.showAssetLinkRequest = true
                            }else{
                                vm.showAssetLinkRequest = false
                            }
                        }

                        if(value.configKey == "RolloutDashboard"){
                            if(value.configValue == "True"){
                                vm.showRolloutDashboard = true
                            }else{
                                vm.showRolloutDashboard = false
                            }
                        }

                        if(value.configKey == "MonitoringSurveyReport"){
                            if(value.configValue == "True"){
                                vm.showMonitoringSurveyReport = true
                            }else{
                                vm.showMonitoringSurveyReport = false
                            }
                        }
                        
                        if(value.configKey == "MonitoringGeofenceDump"){
                            if(value.configValue == "True"){
                                vm.showMonitoringGeofenceDump = true
                            }else{
                                vm.showMonitoringGeofenceDump = false
                            }
                        }
                        
                        if(value.configKey == "MonitoringSplicingReport"){
                            if(value.configValue == "True"){
                                vm.showMonitoringSplicingReport = true
                            }else{
                                vm.showMonitoringSplicingReport = false
                            }
                        }
                        
                        if(value.configKey == "MonitoringUserGeofenceDump"){
                            if(value.configValue == "True"){
                                vm.showMonitoringUserGeofenceDump = true
                            }else{
                                vm.showMonitoringUserGeofenceDump = false
                            }
                        }
                        
                        if(value.configKey == "RolloutTaskLogReport"){
                            if(value.configValue == "True"){
                                vm.showRolloutTaskLogReport = true
                            }else{
                                vm.showRolloutTaskLogReport = false
                            }
                        }
                        
                        if(value.configKey == "RolloutReport"){
                            if(value.configValue == "True"){
                                vm.showRolloutReport = true
                            }else{
                                vm.showRolloutReport = false
                            }
                        }
                    })
                });

                
              /* Configs.rolloutFeatures(function (response) {
                $rootScope.storeTemp = response
                        $rootScope.showRolloutProject = false;
                        $rootScope.showRolloutRoute = false;
                        $rootScope.showRolloutTask = false;
                        $rootScope.showRolloutSection = false;
                        $rootScope.showRolloutWorkOrder = false;
                        $rootScope.showRolloutResource = false;
                        $rootScope.showRolloutMaterial = false;
                    
                        if (response && response.length) {
                            response.forEach(function (value) {
                                switch (value.configKey) {
                                    case "PROJECT_SIDEBAR":
                                        $rootScope.showRolloutProject = value.configValue === "TRUE";
                                        break;
                                    case "ROUTE_SIDEBAR":
                                        $rootScope.showRolloutRoute = value.configValue === "TRUE";
                                        break;
                                    case "TASK_SIDEBAR":
                                        $rootScope.showRolloutTask = value.configValue === "TRUE";
                                        break;
                                    case "SECTION_SIDEBAR":
                                        $rootScope.showRolloutSection = value.configValue === "TRUE";
                                        break;
                                    case "WORKORDER_SIDEBAR":
                                        $rootScope.showRolloutWorkOrder = value.configValue === "TRUE";
                                        break; 
                                    case "RESOURCE_SIDEBAR":
                                        $rootScope.showRolloutResource = value.configValue === "TRUE";
                                        break;
                                    case "MATERIAL_SIDEBAR":
                                        $rootScope.showRolloutMaterial = value.configValue === "TRUE";
                                        break;

                                    default: console.log(value.configKey,"Access Denied")
                                }
                            });
                        }
                });  */
                    
               
            }

                if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_SUPER_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_SUPER_ADMIN = true;
                    // $state.go('tenant');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_VENDOR") !== -1
                ) {
                    $rootScope.has_ROLE_VENDOR = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_USER_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_USER_ADMIN = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_HOD") !== -1
                ) {
                    $rootScope.has_ROLE_HOD = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_CITY_MANAGER") !== -1
                ) {
                    $rootScope.has_ROLE_CITY_MANAGER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_BA") !== -1
                ) {
                    $rootScope.has_ROLE_BA = true;
                    //$state.go('dashboard');                    
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_CITY_PLANNER") !== -1
                ) {
                    $rootScope.has_ROLE_CITY_PLANNER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_ASSISTANT_MANAGER") !==
                        -1
                ) {
                    $rootScope.has_ROLE_ASSISTANT_MANAGER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_OA") !==
                        -1
                ) {
                    $rootScope.has_ROLE_OA = true;
                    //$state.go('dashboard');                    
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_TEAM_LEADER") !== -1
                ) {
                    $rootScope.has_ROLE_TEAM_LEADER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_NETWORK_ENGINEER") !== -1
                ) {
                    $rootScope.has_ROLE_NETWORK_ENGINEER = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_FE") !== -1
                ) {
                    $rootScope.has_ROLE_FE = true;
                    //$state.go('dashboard');                    
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_FRT") !== -1
                ) {
                    $rootScope.has_ROLE_FRT = true;
                    //$state.go('dashboard');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_PATROLLER") !== -1
                ) {
                    $rootScope.has_ROLE_PATROLLER = true;
                    //$state.go('location-log');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_USER") !== -1
                ) {
                    $rootScope.has_ROLE_USER = true;
                    //$state.go('location-log');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_VENDOR_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_VENDOR_ADMIN = true;
                    //$state.go('location-log');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_PLAN_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_PLAN_ADMIN = true;
                    //$state.go('location-log');
                }  if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_ROLLOUT_ADMIN") !== -1
                ) {
                    $rootScope.has_ROLE_ROLLOUT_ADMIN = true;
                    //$state.go('location-log');
                }

                if (
                    identity &&
                    identity.authorities &&
                    identity.authorities.indexOf("ROLE_ROLLOUT_FE") !== -1
                ) {
                    $rootScope.has_ROLE_ROLLOUT_FE = true;
                    //$state.go('location-log');
                }

                if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ROLLOUT_MANAGER') !== -1) {
                    $rootScope.has_ROLE_ROLLOUT_MANAGER = true;
                    //$state.go('tr-project');
                }


                if (identity) {
                    $rootScope.userName = identity.login;
                    $rootScope.image = identity.userImage;
                }
            });
        };
        $rootScope.getLocalhour = function (hour) {
            var d = new Date();
            d.setUTCHours(hour);
            d.setUTCMinutes(30);
            return d.getHours();
        };

        $rootScope.getUTChour = function (hour) {
            var d = new Date();
            d.setHours(hour);
            d.setMinutes(0);
            return d.getUTCHours();
        };
        $rootScope.listAuthorities();

        $(document).ready(function () {
            $(window)
                .resize(function () {
                    var width = $(window).width();
                    if (width <= 770) {
                        $(".sidebar-menu>li > a").attr(
                            "data-toggle",
                            "offcanvas"
                        );
                    } else {
                        $(".sidebar-menu>li > a").attr("data-toggle", "");
                    }
                })
                .resize(); //trigger the resize event on page load.
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('HomeController', HomeController)
        /* .constant('DEFAULT_LATITUDE', "32.77059340204903")
        .constant('DEFAULT_LONGITUDE', "-96.83874469246176") */;

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$rootScope'];

    function HomeController($scope, Principal, LoginService, $state, $rootScope) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.appName = 'Fiberify';
        $rootScope.$on('authenticationSuccess', function () {
            getAccount();
            $rootScope.listAuthorities();
            //  validateStates();
        });

        vm.appName = $rootScope.APP_NAME;

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if (vm.isAuthenticated() == true) {
                    validateStates();
                }
            });
        }

        function validateStates() {
            if ($rootScope.has_ROLE_SUPER_ADMIN == true) {
                //$state.go('user-management');
                $state.go('tenant');
            } else if ($rootScope.has_ROLE_USER_ADMIN === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_VENDOR === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_HOD === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_CITY_MANAGER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_BA === true) {
                $state.go('incident-dashboard');                
            } else if ($rootScope.has_ROLE_CITY_PLANNER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_ASSISTANT_MANAGER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_OA === true) {
                $state.go('incident-dashboard');                
            } else if ($rootScope.has_ROLE_TEAM_LEADER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_NETWORK_ENGINEER === true) {
                $state.go('incident-dashboard');
            } else if ($rootScope.has_ROLE_FE === true) {
                $state.go('incident-dashboard');                
            } else if ($rootScope.has_ROLE_FRT == true) {
                $state.go('tr-case');
            }  else if ($rootScope.has_ROLE_PATROLLER == true) {
                $state.go('tr-case');
                /* }else if($rootScope.has_ROLE_USER ==true){
                //$state.go('location-log');
                $state.go('tr-case'); */
            }/*  else if ($rootScope.has_ROLE_ROLLOUT_ADMIN == true) {
                $state.go('tr-project');
            } else if ($rootScope.has_ROLE_PLAN_ADMIN == true) {
                $state.go('tr-project');
            } */
        }


        function register() {
            $state.go('register');
        }

    }

})();
(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("history", {
                abstract: true,
                parent: "app",
            })
            .state("asset-history", {
                parent: "history",
                url: "/asset-changelog",
                data: {
                    pageTitle: "trakeyeApp.asset.home.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/history/asset-history.html",
                        controller: "AssetHistory",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("asset");
                            return $translate.refresh();
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("History", History);

    History.$inject = ["$resource"];

    function History($resource) {
        var resourceUrl = "api/asset-changelog";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('HistorySearch', HistorySearch);

	HistorySearch.$inject = ['$resource'];

	function HistorySearch($resource) {
		var service = $resource('/api/asset-changelog-search/:searchtext', {
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").controller("AssetHistory", AssetHistory);

    AssetHistory.$inject = [
        "History",
        "$state",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$scope",
        "HistorySearch"
    ];

    function AssetHistory(
        History,
        $state,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $scope,
        HistorySearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.goToPage = goToPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterAssetHistorySearch = filterAssetHistorySearch;

        $("#pagenum").val(pagingParams.page + "");

        loadAll();

        $scope.orderProperty = "assetName";

        $scope.setOrderProperty = function (propertyName) {
            if ($scope.orderProperty === propertyName) {
                $scope.orderProperty = "-" + propertyName;
            } else if ($scope.orderProperty === "-" + propertyName) {
                $scope.orderProperty = propertyName;
            } else {
                $scope.orderProperty = propertyName;
            }
        };

        function loadAll() {
            History.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                },
                onSuccess,
                onError
            );

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;

                vm.page = pagingParams.page;
                getData(data);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        function padTo2Digits(num) {
            return num.toString().padStart(2, "0");
        }

        function formatDate(date) {
            return [
                padTo2Digits(date.getDate()),
                padTo2Digits(date.getMonth() + 1),
                date.getFullYear(),
            ].join("/");
        }

        function getData(data) {
            vm.assetHistory = [];
            data.forEach(function (asset) {
                var cdate = formatDate(new Date(asset.createdDate));
                var ldate = formatDate(new Date(asset.lastModifiedDate));

                vm.assetHistory.push({
                    assetId: asset.assetId,
                    assetName: asset.assetName,
                    assetTypeName: asset.assetTypeName,
                    createdBy: asset.createdBy,
                    cdate: cdate,
                    lastModifiedBy: asset.lastModifiedBy,
                    ldate: ldate,
                    modeName: asset.modeName,
                    newValue: asset.newValue,
                    oldValue: asset.oldValue,
                    propertyName: asset.propertyName,
                });
            });
        }

        function goToPage() {
            vm.page = parseInt(document.getElementById("pagenum").value);
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                pagesize: vm.itemsPerPage,
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function filterAssetHistorySearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                HistorySearch.query(
                    {
                        searchtext: $scope.search,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
    
                    vm.page = pagingParams.page;
                    getData(data);
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkOrderTypeDialogController",
            WorkOrderTypeDialogController
        );

    WorkOrderTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "WorkOrderType",
        "User",
        "WorkOrderTypeSearch",
        "AllCustomWorkOrderTypeAttribute",
    ];

    function WorkOrderTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        WorkOrderType,
        User,
        WorkOrderTypeSearch,
        AllCustomWorkOrderTypeAttribute
    ) {
        var vm = this;
        //workOrdertype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.workOrderType = entity;
        vm.workOrderTypeImageName = workOrderTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customWorkOrderTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        function workOrderTypeImageName(image) {
            vm.workOrderType.image = image;
        }

        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomWorkOrderTypeAttribute.getAll(function (response) {
                vm.customWorkOrderTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customWorkOrderTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.workOrderType.workOrderTypeAttribute != null &&
            vm.workOrderType.workOrderTypeAttribute.length != 0
        ) {
            vm.items = vm.workOrderType.workOrderTypeAttribute;
        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.workOrderType.id !== null) {
                vm.workOrderType.workOrderTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.workOrderType.workOrderTypeAttribute.push({
                        id: vm.items[i].id,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                    });
                }
                WorkOrderType.update(
                    vm.workOrderType,
                    onSaveSuccess,
                    onSaveError
                );
            } else {
                vm.workOrderType.workOrderTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.workOrderType.workOrderTypeAttribute.push({
                        id: vm.items[i].id,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                    });
                }
                WorkOrderType.save(
                    vm.workOrderType,
                    onSaveSuccess,
                    onSaveError
                );
            }
        }

        $("#workOrderTypeImage").change(function () {
            var filesSelected =
                document.getElementById("workOrderTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.workOrderType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:workOrderTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "work-order.new") {
                $state.go("work-order.new");
            } else {
                $state.go("workorder-type");
            }
            // sessionStorage.removeItem('prevPage');
            // $state.go('workorder-type');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.addmore = function () {
            vm.items.push({ name: "", attributeDataType: {}, value: "" });
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkOrderTypeDetailController",
            WorkOrderTypeDetailController
        );

    WorkOrderTypeDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "WorkOrderType",
        "User",
    ];

    function WorkOrderTypeDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        WorkOrderType,
        User
    ) {
        var vm = this;

        vm.workOrderType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on(
            "trakeyeApp:workOrderTypeUpdate",
            function (event, result) {
                vm.workOrderType = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkOrderTypeDeleteController",
            WorkOrderTypeDeleteController
        );

    WorkOrderTypeDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "WorkOrderType",
    ];

    function WorkOrderTypeDeleteController(
        $uibModalInstance,
        entity,
        WorkOrderType
    ) {
        var vm = this;

        vm.workOrderType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            WorkOrderType.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("workorder-type", {
                parent: "entity",
                url: "/workorder-type",
                data: {
                    authorities:["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle: "trakeyeApp.workOrderType.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-types.html",
                        controller: "WorkOrderTypeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrderType");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("workorder-type-detail", {
                parent: "workorder-type",
                url: "/workorder-type/{id}",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle: "trakeyeApp.workOrderType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-type-detail.html",
                        controller: "WorkOrderTypeDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrderType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkOrderType",
                        function ($stateParams, WorkOrderType) {
                            return WorkOrderType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "workorder-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("workorder-type.new", {
                parent: "workorder-type",
                url: "/create",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-type-dialog.html",
                        controller: "WorkOrderTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            description: null,
                            createdDate: null,
                            updateDate: null,
                            id: null,
                        };
                    },
                },
            })
            .state("workorder-type.edit", {
                parent: "workorder-type",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle: "trakeyeApp.workOrderType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/workorder-type/workorder-type-dialog.html",
                        controller: "WorkOrderTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrderType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkOrderType",
                        function ($stateParams, WorkOrderType) {
                            return WorkOrderType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "workorder-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("workorder-type.delete", {
                parent: "workorder-type",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/workorder-type/workorder-type-delete-dialog.html",
                                controller: "WorkOrderTypeDeleteController",
                                controllerAs: "vm",
                                size: "sm",
                                resolve: {
                                    entity: [
                                        "WorkOrderType",
                                        function (WorkOrderType) {
                                            return WorkOrderType.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("workorder-type", null, {
                                        reload: "workorder-type",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkOrderType", WorkOrderType);

    WorkOrderType.$inject = ["$resource", "DateUtils"];

    function WorkOrderType($resource, DateUtils) {
        var resourceUrl = "api/workorder-types/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );
    }
})();
(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderTypeSearch", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getworkOrdertypebyname = function (data, callback) {
                $http
                    .get("api/workorder-types-details/" + data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderTypeSearch", WorkOrderTypeSearch);

    WorkOrderTypeSearch.$inject = ["$resource"];

    function WorkOrderTypeSearch($resource) {
        var service = $resource(
            "/api/workorder-types/searchvalue/:userId",
            { userId: "@id" },
            {},
            {
                query: { method: "GET", isArray: true },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllCustomWorkOrderTypeAttribute", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/all-custom-workorder-type-attributes")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderTypeController", WorkOrderTypeController);

    WorkOrderTypeController.$inject = [
        "$scope",
        "$state",
        "WorkOrderType",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "WorkOrderTypeSearch",
    ];

    function WorkOrderTypeController(
        $scope,
        $state,
        WorkOrderType,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        WorkOrderTypeSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                WorkOrderTypeSearch.query(
                    {
                        userId: $scope.search,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        //  result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.workOrderTypes = data;
                    vm.page = pagingParams.page;
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        loadAll();

        function loadAll() {
            WorkOrderType.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.workOrderTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderDialogController", WorkOrderDialogController)
        .directive("mySrc", function () {
            return {
                restrict: "A",
                scope: {
                    callback: "&",
                },
                link: function (scope, elem, attrs) {
                    elem.attr("src", scope.callback());
                },
            };
        });
    WorkOrderDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$q",
        "AssetByID",
        "TrUnresolvedGroupWorkFlowForMap",
        "WorkFlowById",
        "UnresolvedLocGroupWorkFlowForMap",
        "pagingParams",
        "entity",
        "WorkOrder",
        "UserGroupIDs",
        "User",
        "WorkOrderType",
        "Principal",
        "Asset",
        "$state",
        "ActivatedUsers",
        "UserValueSearch",
        "AlertService",
        "ActivatedUserSearch",
        "WorkOrderUpload",
        "AssetSearchForMap",
        "AssetSearch",
        "AllWorkOrderTypes",
        "AllCustomWorkOrderTypeAttribute",
        "$ngConfirm",
        "Configs",
        "UserAccount",
        "$rootScope"

    ];

    function WorkOrderDialogController(
        $timeout,
        $scope,
        $stateParams,
        $q,
        AssetByID,
        TrUnresolvedGroupWorkFlowForMap,
        WorkFlowById,
        UnresolvedLocGroupWorkFlowForMap,
        pagingParams,
        entity,
        WorkOrder,
        UserGroupIDs,
        User,
        WorkOrderType,
        Principal,
        Asset,
        $state,
        ActivatedUsers,
        UserValueSearch,
        AlertService,
        ActivatedUserSearch,
        WorkOrderUpload,
        AssetSearchForMap,
        AssetSearch,
        AllWorkOrderTypes,
        AllCustomWorkOrderTypeAttribute,
        $ngConfirm,
        Configs,
        UserAccount,
        $rootScope
    ) {
        var vm = this;

        vm.workOrder = entity;

        var entity_old = angular.copy(vm.workOrder);
        vm.datePickerOpenStatus = {};
        vm.save = save;
        vm.assetList = "";
        vm.customAttributesMap = {};
        var usersMap = {};
        $scope.model = {};
        vm.selectedWorkFlows = [];
        var map = null;
        var markers = [];
        var polylines = [];
        var workFlowLat = null;
        var workFlowLng = null;
        var workFlowDistance = null;
        var openedInfoWindow = null;
        vm.resolved = 0.0;
        vm.unresolved = 0.0;
        vm.navigateGroupfromWorkOrder = navigateGroupfromWorkOrder;
        vm.navigateWorkOrderTypefromWorkOrder = navigateWorkOrderTypefromWorkOrder;
        vm.phaseAccess = true

        $(".select2").select2();

        $(":file").filestyle({
            buttonBefore: true,
        });

        $(":file").filestyle("buttonText", "Browse File");

        vm.workOrderTypes = loadPage();
        vm.selectattributes = selectedWorkOrderTypeAttributes;

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        vm.workOrderType = entity.workOrderType;

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        function selectedWorkOrderTypeAttributes() {
            if (vm.workOrderType) {
                vm.workOrder.workOrderType = vm.workOrderType;
                if (
                    entity_old.workOrderType &&
                    vm.workOrderType.id === entity_old.workOrderType.id
                ) {
                    vm.workOrder.workOrderTypeAttributeValues = [];
                    vm.workOrder.workOrderTypeAttributeValues =
                        entity_old.workOrderTypeAttributeValues;
                } else {
                    vm.workOrder.workOrderTypeAttributeValues = [];
                    $.each(
                        vm.workOrderType.workOrderTypeAttribute,
                        function (key, value) {
                            vm.workOrder.workOrderTypeAttributeValues.push({
                                workOrderTypeAttribute:
                                    vm.workOrderType.workOrderTypeAttribute[
                                        key
                                    ],
                            });
                        }
                    );
                }
            }
        }

        function loadPage() {
            vm.multgroup = [];
            var selectedGroups = [];
            var workOrderWorkFlowsList = [];

            if(vm.workOrder.id){
                Configs.get("WorkOrderStatus",function(response){
                    vm.workOrderStatus = response
                })
    
                Configs.get("Phases",function(response){
                    vm.phases = response
                })
            }

            if (vm.workOrder.id != null) {
                vm.workOrder.groups.forEach(function (group) {
                    selectedGroups.push(group.id);
                });
                vm.workOrder.workFlows.forEach(function (workFlowVal) {
                    workOrderWorkFlowsList.push(workFlowVal);
                });
            }

            AllWorkOrderTypes.getAll(function (response) {
                vm.workOrderTypes = response;
            });

            UserGroupIDs.getAll(function (response) {
                vm.multigroup = response
                response.forEach(function(val){
                    if(val.name == "Planning Group"){
                        val.ticked = true
                    }
                })
            });

            if(vm.workOrder.id){
                UserAccount.get(function (data) { 
                    data.authorities.find(function (val) { 
                        if(val == "ROLE_PLAN_ADMIN" || val == "ROLE_ROLLOUT_ADMIN" ){
                            vm.phaseAccess = false
                        }
                    })
                })
            }

            AllCustomWorkOrderTypeAttribute.getAll(function (response) {
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customWorkOrderTypeAttributeValues;
                });
            });

            TrUnresolvedGroupWorkFlowForMap.getAllWorkFlows(function (
                response
            ) {
                vm.workFlows = [];
                response.forEach(function (workFlowVal) {
                    workOrderWorkFlowsList.forEach(function (
                        workFlowValChecked
                    ) {
                        if (workFlowValChecked.id == workFlowVal.id) {
                            workFlowVal.isChecked = true;
                            workFlowValChecked.isChecked = true;

                            vm.selectedWorkFlows.push(workFlowValChecked);
                            showWorkFlowAssetsOnMap(workFlowValChecked);
                        }
                    });
                    vm.workFlows.push(workFlowVal);
                });
            });
            /* var myOptions = {
                zoom: 10,
                center: new google.maps.LatLng("5.431587", "101.128162"),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */
            var center = new google.maps.LatLng($rootScope.DEFAULT_LATITUDE,
                $rootScope.DEFAULT_LONGITUDE)
            map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(10,center)
            );
            if (map != null) {
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
        }
        // This executes when workflow checkbox checked/unchecked
        $scope.selectEntity = function () {
            if (map != null) {
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            vm.resolved = 0.0;
            vm.unresolved = 0.0;
            vm.selectedWorkFlows = [];
            vm.workFlows.forEach(function (workFlowVal) {
                if (workFlowVal.isChecked) {
                    if (workFlowVal.status == "Lighting") {
                        vm.resolved += parseFloat(workFlowVal.fiberDistance);
                    } else {
                        vm.unresolved += parseFloat(workFlowVal.fiberDistance);
                    }
                    WorkFlowById.get(workFlowVal.id, function (workFlowVal) {
                        workFlowVal.groups = vm.workOrder.groups;
                        vm.selectedWorkFlows.push(workFlowVal);
                        if (workFlowVal.workFlowAssets.length > 0) {
                            showWorkFlowAssetsOnMap(workFlowVal);
                        }
                    });
                }
            });

            var totalDistance = vm.resolved + vm.unresolved;
            var workOrderAV = vm.workOrder.workOrderTypeAttributeValues;
            for (
                var workOrderIndex = 0;
                workOrderIndex < workOrderAV.length;
                workOrderIndex++
            ) {
                if (
                    workOrderAV[workOrderIndex].workOrderTypeAttribute.name ===
                    "Fiber Distance"
                ) {
                    workOrderAV[
                        workOrderIndex
                    ].attributeValue = totalDistance.toFixed(2);
                } else if (
                    workOrderAV[workOrderIndex].workOrderTypeAttribute.name ===
                    "Unresolved Distance"
                ) {
                    workOrderAV[
                        workOrderIndex
                    ].attributeValue = vm.unresolved.toFixed(2);
                } else if (
                    workOrderAV[workOrderIndex].workOrderTypeAttribute.name ===
                    "Resolved Distance"
                ) {
                    workOrderAV[
                        workOrderIndex
                    ].attributeValue = vm.resolved.toFixed(2);
                }
            }
            vm.workOrder.workOrderTypeAttributeValues = workOrderAV;
        };

        function showWorkFlowAssetsOnMap(workFlowVal) {
            workFlowVal.workFlowAssets.forEach(function (assetVal) {
                if (
                    assetVal.assetType.layout == "SPREAD" &&
                    assetVal.assetCoordinates != null
                ) {
                    var spreadAssetCoordinates = [];
                    assetVal.assetCoordinates.forEach(function (loc) {
                        spreadAssetCoordinates.push({
                            lat: loc.latitude,
                            lng: loc.longitude,
                        });
                    });
                    var polylineColor = "#000000";
                    var polylinepath = new google.maps.Polyline({
                        path: spreadAssetCoordinates,
                        geodesic: true,
                        strokeColor: polylineColor,
                        strokeOpacity: 1.0,
                        strokeWeight: 2.5,
                        fillColor: polylineColor,
                        fillOpacity: 0.3,
                        editable: false,
                    });

                    polylinepath.setMap(map);

                    polylines.push(polylinepath);
                    try {
                        var pos = {
                            lat: assetVal.assetCoordinates[0].latitude,
                            lng: assetVal.assetCoordinates[0].longitude,
                        };
                        map.setCenter(pos);

                        var midLatLng = {
                            lat:
                                spreadAssetCoordinates[
                                    spreadAssetCoordinates.length - 1
                                ].lat,
                            lng:
                                spreadAssetCoordinates[
                                    spreadAssetCoordinates.length - 1
                                ].lng,
                        };
                        var infowindow = new google.maps.InfoWindow({
                            content:
                                '<div class="infoWindowhead">' +
                                "name" +
                                '<div class="infoWindowContent"> <b>Name :</b> ' +
                                assetVal.name +
                                "</div></div>",
                        });

                        infowindow.setPosition(midLatLng);
                        google.maps.event.addListener(
                            polylinepath,
                            "mouseout",
                            function (event) {
                                infowindow.close();
                            }
                        );

                        google.maps.event.addListener(
                            polylinepath,
                            "mouseover",
                            function (event) {
                                if (openedInfoWindow != null) {
                                    openedInfoWindow.close();
                                }
                                infowindow.setContent(
                                    '<div class="infoWindowhead">' +
                                        "<b></b>" +
                                        assetVal.name +
                                        "</br></div>"
                                );

                                infowindow.mousemove;
                                infowindow.open(map);
                                infowindow.setPosition(event.latLng);
                                openedInfoWindow = infowindow;
                            }
                        );
                    } catch (err) {}
                } else if (
                    assetVal.assetType.layout == "FIXED" &&
                    assetVal.assetCoordinates != null
                ) {
                    try {
                        createMarker(assetVal.assetCoordinates[0], map);
                        var pos = {
                            lat: assetVal.assetCoordinates[0].latitude,
                            lng: assetVal.assetCoordinates[0].longitude,
                        };
                        map.setCenter(pos);
                    } catch (err) {}
                }
            });
        }

        function createMarker(latlngs, map) {
            try {
                var pos = {
                    lat: latlngs.latitude,
                    lng: latlngs.longitude,
                };

                var marker = new google.maps.Marker({
                    position: pos,
                    map: map,
                    icon:
                        "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                });

                marker.setMap(map);
                markers.push(marker);

                var infowindow = new google.maps.InfoWindow({
                    content:
                        '<div class="infoWindowhead">' +
                        "name" +
                        '<div class="infoWindowContent"> <b>Name :</b> ' +
                        assetVal.name +
                        "</div></div>",
                });

                infowindow.setPosition(pos);
                google.maps.event.addListener(
                    marker,
                    "mouseout",
                    function (event) {
                        infowindow.close();
                    }
                );

                google.maps.event.addListener(
                    marker,
                    "mouseover",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead">' +
                                "<b></b>" +
                                assetVal.name +
                                "</br></div>"
                        );

                        infowindow.mousemove;
                        infowindow.open(map);
                        infowindow.setPosition(event.latLng);
                        openedInfoWindow = infowindow;
                    }
                );
                // markers.push(marker);
            } catch (err) {}
        }

        vm.createfence = function () {
            $("#workflowsModal").show();
            var myCenter = new google.maps.LatLng($rootScope.DEFAULT_LATITUDE,
                $rootScope.DEFAULT_LONGITUDE);
            var ele = document.getElementById("workflowsModal");
            $(ele).modal("show");
            //
            var locMap = new google.maps.Map(
                document.getElementById("map_canvas_workflows"),
                myOption(12,myCenter)
            );
            var address = new google.maps.Geocoder();

            google.maps.event.addListener(locMap, "click", function (event) {
                address.geocode(
                    {
                        latLng: event.latLng,
                    },
                    function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            if (results[0]) {
                                $ngConfirm({
                                    title:
                                        "Are you sure you want to select this address?",
                                    content:
                                        "<strong>Address: </strong>" +
                                        results[0].formatted_address +
                                        "<br/>" +
                                        "<strong>Latitude: </strong>" +
                                        event.latLng.lat() +
                                        "</br>" +
                                        "<strong>Longitude: </strong>" +
                                        event.latLng.lng(),
                                    type: "blue",
                                    typeAnimated: true,
                                    buttons: {
                                        OK: {
                                            text: "OK",
                                            btnClass: "btn-primary",
                                            action: function () {
                                                $scope.$apply(function () {
                                                    workFlowLat = event.latLng.lat();
                                                    workFlowLng = event.latLng.lng();
                                                    workFlowDistance = document.getElementById(
                                                        "workflow_distance"
                                                    ).value;
                                                    UnresolvedLocGroupWorkFlowForMap.query(
                                                        {
                                                            lat: workFlowLat,
                                                            lng: workFlowLng,
                                                            dis: workFlowDistance,
                                                        },
                                                        function (response) {
                                                            vm.workFlows = response;

                                                            var workOrderWorkFlowsList =
                                                                vm.workOrder
                                                                    .workFlows;

                                                            if (
                                                                workOrderWorkFlowsList !==
                                                                undefined
                                                            ) {
                                                                workOrderWorkFlowsList.forEach(
                                                                    function (
                                                                        workFlow
                                                                    ) {
                                                                        for (
                                                                            var i = 0;
                                                                            i <
                                                                            vm
                                                                                .workFlows
                                                                                .length;
                                                                            i++
                                                                        ) {
                                                                            if (
                                                                                workFlow.id ==
                                                                                vm
                                                                                    .workFlows[
                                                                                    i
                                                                                ]
                                                                                    .id
                                                                            ) {
                                                                                vm.workFlows[
                                                                                    i
                                                                                ].isChecked = true;
                                                                            }
                                                                        }
                                                                    }
                                                                );
                                                            }

                                                            /* var myOptions = {
                                                                zoom: 10,
                                                                center:new google.maps.LatLng($rootScope.DEFAULT_LATITUDE,
                                                                    $rootScope.DEFAULT_LONGITUDE),
                                                                mapTypeId:
                                                                    google.maps
                                                                        .MapTypeId
                                                                        .ROADMAP,
                                                            }; */
                                                            var center = new google.maps.LatLng($rootScope.DEFAULT_LATITUDE,
                                                                $rootScope.DEFAULT_LONGITUDE)
                                                            map = new google.maps.Map(
                                                                document.getElementById(
                                                                    "map_canvas"
                                                                ),
                                                                myOption(10,center)
                                                            );
                                                        }
                                                    );
                                                    hideModal();
                                                });
                                            },
                                        },
                                        Cancel: {
                                            text: "Cancel",
                                            btnClass: "btn-danger",
                                            action: function () {},
                                        },
                                    },
                                });
                            }
                        }
                    }
                );
            });
            $("#workflowsModal").on("show.bs.modal", function (event) {
                $("#location-map-workflows").css("width", "100%");
                $("#map_canvas_workflows").css("width", "100%");
            });
        };
        function hideModal() {
            $("#workflowsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#workflowsModal").hide();
        }

        function save() {
            vm.isSaving = true;

            vm.workOrder.workFlows = [];
            vm.selectedWorkFlows.forEach(function (workflow) {
                workflow.groups = vm.workOrder.groups;
                vm.workOrder.workFlows.push(workflow);
            });
            if (vm.workOrder.workFlows.length > 0) {
                try {
                    vm.workOrder.pinLat =
                        vm.workOrder.workFlows[0].workFlowAssets[0].assetCoordinates[0].latitude;
                    vm.workOrder.pinLong =
                        vm.workOrder.workFlows[0].workFlowAssets[0].assetCoordinates[0].longitude;
                } catch (error) {
                    vm.isSaving = false;
                }
                if (vm.workOrder.id !== null) {
                    WorkOrder.update(vm.workOrder, onSaveSuccess, onSaveError);
                } else {
                    WorkOrder.save(vm.workOrder, onSaveSuccess, onSaveError);
                }
            } else {
                alert("Please select atleast one work flow");
                vm.isSaving = false;
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:workOrderUpdate", result);
            $state.go("work-order");
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function navigateGroupfromWorkOrder() {
            sessionStorage.setItem("prevPage", "work-order.new");
            $state.go("group.new");
        }

        function navigateWorkOrderTypefromWorkOrder() {
            sessionStorage.setItem("prevPage", "work-order.new");
            $state.go("workorder-type.new");
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderDetailController", WorkOrderDetailController);

    WorkOrderDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "WorkOrder",
        "User",
        "CaseType",
        "$window",
    ];

    function WorkOrderDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        WorkOrder,
        User,
        CaseType,
        $window
    ) {
        var vm = this;

        if (entity.status) {
            entity.status = entity.status.replace("NEW", "PLANNING PHASE");
            entity.status = entity.status.replace(
                "INPROGRESS",
                "ROLL-OUT PHASE"
            );
            entity.status = entity.status.replace(
                "RESOLVED",
                "OPERATION PHASE"
            );
        }
        if (
            entity.createDate == "0" ||
            entity.createDate == undefined ||
            entity.createDate == null
        ) {
            entity.createDate = "";
        }
        vm.workOrder = entity;
        vm.previousState = previousState.name;
        var unsubscribe = $rootScope.$on(
            "trakeyeApp:workOrderUpdate",
            function (event, result) {
                vm.workOrder = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderDeleteController", WorkOrderDeleteController);

    WorkOrderDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "WorkOrder",
        "$scope",
    ];

    function WorkOrderDeleteController(
        $uibModalInstance,
        entity,
        WorkOrder,
        $scope
    ) {
        var vm = this;

        vm.workOrder = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            $scope.deletefail = true;
            WorkOrder.delete({ id: id }, function () {
                $scope.deletefail = false;
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("work-order", {
                parent: "app",
                url: "/work-order",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workOrder.home.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/work-order/work-orders.html",
                        controller: "WorkOrderController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrder");
                            $translatePartialLoader.addPart("workOrderStatus");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("work-order-detail", {
                parent: "work-order",
                url: "/work-order/{id}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workOrder.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-order/work-order-detail.html",
                        controller: "WorkOrderDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrder");
                            $translatePartialLoader.addPart("workOrderStatus");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkOrder",
                        function ($stateParams, WorkOrder) {
                            return WorkOrder.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-order",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-order.priority", {
                parent: "work-order",
                url: "/work-order/{priority}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workOrder.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/work-order/work-orders.html",
                        controller: "WorkOrderController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                                priority: $stateParams.priority,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workOrder");
                            $translatePartialLoader.addPart("workOrderStatus");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })

            .state("work-order.new", {
                parent: "work-order",
                url: "/create/{lat}/{lng}/{assetdetails}/{desc}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-order/work-order-dialog.html",
                        controller: "WorkOrderDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                description: $stateParams.desc,
                                createDate: null,
                                updateDate: null,
                                pinLat: parseFloat($stateParams.lat),
                                pinLong: parseFloat($stateParams.lng),
                                address: null,
                                escalated: null,
                                status: null,
                                id: null,
                                workOrderImages: [],
                                // ,
                                // asset: {name: $stateParams.assetdetails}
                            };
                        },
                    ],
                },
            })

            .state("work-order.import", {
                parent: "work-order",
                url: "/import",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-order/work-order-import.html",
                        controller: "WorkOrderImportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            workOrderImages: [],
                        };
                    },
                },
            })
            .state("work-order.edit", {
                parent: "work-order",
                url: "/Edit/{id}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workOrder.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-order/work-order-dialog.html",
                        controller: "WorkOrderDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "WorkOrder",
                        function ($stateParams, WorkOrder) {
                            return WorkOrder.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],

                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-order",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-order.delete", {
                parent: "work-order",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/work-order/work-order-delete-dialog.html",
                                controller: "WorkOrderDeleteController",
                                controllerAs: "vm",
                                size: "md",
                                resolve: {
                                    entity: [
                                        "WorkOrder",
                                        function (WorkOrder) {
                                            return WorkOrder.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("work-order", null, {
                                        reload: "work-order",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkOrder", WorkOrder);

    WorkOrder.$inject = ["$resource", "DateUtils"];

    function WorkOrder($resource, DateUtils) {
        var resourceUrl = "api/work-orders/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderPriority", WorkOrderPriority);

    WorkOrderPriority.$inject = ["$resource"];

    function WorkOrderPriority($resource) {
        var service = $resource(
            "/api/work-orders/priority/:priority",
            {
                priority: "@priorirty",
            },
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderSearch", WorkOrderSearch);

    WorkOrderSearch.$inject = ["$resource"];

    function WorkOrderSearch($resource) {
        var service = $resource(
            "/api/work-orders/searchvalue/:search",
            {},
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkorderCountByGroup", [
        "$http",
        function ($http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/workordercountbygroup")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkorderCountByStatus", [
        "$http",
        function ($http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/workordercountbystatus")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkOrderGroup", WorkOrderGroup);

    WorkOrderGroup.$inject = ["$resource", "DateUtils"];

    function WorkOrderGroup($resource, DateUtils) {
        var resourceUrl = "api/work-orders-group";

        return $resource(resourceUrl, {
            query: {
                method: "GET",
                isArray: true,
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderGroupSearch", WorkOrderGroupSearch);

    WorkOrderGroupSearch.$inject = ["$resource"];

    function WorkOrderGroupSearch($resource) {
        var service = $resource(
            "/api/work-orders-group/searchvalue/:search",
            {},
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderGroupPrioritySearch", WorkOrderGroupPrioritySearch);

    WorkOrderGroupPrioritySearch.$inject = ["$resource"];

    function WorkOrderGroupPrioritySearch($resource) {
        var service = $resource(
            "/api/work-orders-group/prioritysearch/:priority/:searchtext",
            {
                priority: "@priorirty",
                searchtext: "@searchtext",
            },
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderGroupPriority", WorkOrderGroupPriority);

    WorkOrderGroupPriority.$inject = ["$resource"];

    function WorkOrderGroupPriority($resource) {
        var service = $resource(
            "/api/work-orders-group/priority/:priority",
            {
                priority: "@priorirty",
            },
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllWorkOrderTypes", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http.get("api/workorder-alltypes").then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkOrderPrioritySearch", WorkOrderPrioritySearch);

    WorkOrderPrioritySearch.$inject = ["$resource"];

    function WorkOrderPrioritySearch($resource) {
        var service = $resource(
            "/api/work-orders/prioritysearch/:priority/:searchtext",
            {
                priority: "@priorirty",
                searchtext: "@searchtext",
            },
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("WorkOrderUpdateGroup", WorkOrderUpdateGroup);

    WorkOrderUpdateGroup.$inject = ["$resource"];

    function WorkOrderUpdateGroup($resource) {
        var resourceUrl = "api/work-orders/groups";

        return $resource(
            resourceUrl,
            {},
            {
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("WorkOrderBulkDelete", WorkOrderBulkDelete);

    WorkOrderBulkDelete.$inject = ["$resource"];

    function WorkOrderBulkDelete($resource) {
        var resourceUrl = "api/work-orders/bulk/delete";

        return $resource(
            resourceUrl,
            {},
            {
                save: {
                    method: "POST",
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderUser", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getworkordersuser = function (callback) {
                $http
                    .get("api/work-orders/live-logs")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getworkordersuserbyid = function (id, callback) {
                $http
                    .get("api/work-orders/live-logs/" + id)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.searchworkordersuserbyvalue = function (id, callback) {
                $http
                    .get("api/work-orders/search/" + id)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            service.getworkordersanduserbypriority = function (
                priority,
                callback
            ) {
                $http
                    .get("api/work-orders/live-logs/priority/" + priority)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.getAgents = function (callback) {
                $http
                    .get("api/dashboard/agentdashboard")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderEdit", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getallworkorders = function (callback) {
                $http.get("api/tr-allworkorders").then(function (response) {
                    callback(response.data);
                });
            };

            service.editworkorder = function (data, callback) {
                $http
                    .post(
                        "api/work-orderedit/" +
                            data.userId +
                            "/" +
                            data.workorderId,
                        {}
                    )
                    .then(
                        function (response) {
                            callback(response, response.headers);
                        },
                        function (error) {
                            callback(error, error.headers);
                        }
                    );

                /*
                 * $http.post('api/work-orderedit/'+data.userId+'/'+data.workorderId).then(function(response){
                 * callback(response.data); });
                 */
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkOrderUpload", WorkOrderUpload);

    WorkOrderUpload.$inject = ["$http"];

    function WorkOrderUpload($http) {
        var service = {};
        service.workorderupload = function (data, callback) {
            $http
                .post("api/workorderimport", data, {
                    transformRequest: angular.identity,
                    headers: {
                        "Content-Type": undefined,
                    },
                })
                .then(
                    function (response) {
                        callback(response, response.headers);
                    },
                    function (error) {
                        callback(error, error.headers);
                    }
                );
        };

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrGroupWorkOrderSearchForMap", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.searchworkorderformap = function (search, callback) {
                $http
                    .get("api/tr-groupworkordersformap/searchvalue/" + search)
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrGroupWorkOrderForMap", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAllWorkOrders = function (callback) {
                $http
                    .get("api/tr-groupworkordersformap")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderSearchForMap", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.searchworkorderformap = function (search, callback) {
                $http
                    .get("api/work-ordersformap/searchvalue/" + search)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            service.prioritysearchworkorderformap = function (
                priority,
                callback
            ) {
                $http
                    .get("api/work-ordersformap/priority/" + priority)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderLastLocation", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};

            service.getlastlogs = function (callback) {
                $http
                    .get("api/location-logs/lastuserpath")
                    .then(function (response) {
                        callback(response.data);
                    });
            };
            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrdersForMapByAdmin", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.workordersformapbyadmin = function (adminid, callback) {
                $http
                    .get("api/work-ordersformap/" + adminid)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkOrderForMap", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAllWorkOrders = function (callback) {
                $http.get("api/work-ordersformap").then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("ChildWorkflows", ChildWorkflows);

    ChildWorkflows.$inject = ["$resource"];

    function ChildWorkflows($resource) {
        var resourceUrl = "api/linkedWorkFlows/:parentId";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("ChildServices", ChildServices);

    ChildServices.$inject = ["$resource"];

    function ChildServices($resource) {
        var resourceUrl = "api/linkedServices/:parentId";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("WorkOrderWorkflowAssets", WorkOrderWorkflowAssets);

    WorkOrderWorkflowAssets.$inject = ["$resource"];

    function WorkOrderWorkflowAssets($resource) {
        var resourceUrl = "api/linkedAssets/:parentId";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderImportController", WorkOrderImportController)
        .directive("fileread", [
            function () {
                "use strict";

                return {
                    restrict: "A",

                    link: function ($scope, element) {
                        element.change(function (event) {
                            $scope.$apply(function () {
                                $scope.myFile = element[0].files[0];
                            });
                        });
                    },
                };
            },
        ]);

    WorkOrderImportController.$inject = [
        "$timeout",
        "$scope",
        "WorkOrderUpload",
    ];

    function WorkOrderImportController($timeout, $scope, WorkOrderUpload) {
        var vm = this;

        vm.upload = upload;

        var formData;
        function upload() {
            formData = new FormData();
            formData.append("file", $scope.myFile);

            WorkOrderUpload.workorderupload(
                formData,
                function (response, headers) {
                    if (response.status == 200) {
                        vm.error = null;
                        vm.success = "OK";

                        $timeout(function () {
                            vm.success = "";
                        }, 4000);
                    }
                    if (response.status == 400) {
                        vm.success = null;
                        vm.error = "error";
                    }
                }
            );
        }
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkOrderController", WorkOrderController);

    WorkOrderController.$inject = [
        "$filter",
        "$scope",
        "$state",
        "$compile",
        "$stateParams",
        "pagingParams",
        "paginationConstants",
        "WorkOrder",
        "WorkOrderGroup",
        "WorkOrderUpdateGroup",
        "WorkOrderBulkDelete",
        "TrCaseById",
        "AssetByID",
        "UserGroupIDs",
        "ParseLinks",
        "AlertService",
        "WorkOrderSearch",
        "WorkOrderGroupSearch",
        "WorkOrderPriority",
        "WorkOrderGroupPriority",
        "WorkOrderPrioritySearch",
        "WorkOrderGroupPrioritySearch",
        "WorkOrderForMap",
        "WorkOrderSearchForMap",
        "WorkOrderLastLocation",
        "ChildWorkflows",
        "WorkOrderWorkflowAssets",
        "UserAccount",
    ];

    function WorkOrderController(
        $filter,
        $scope,
        $state,
        $compile,
        $stateParams,
        pagingParams,
        paginationConstants,
        WorkOrder,
        WorkOrderGroup,
        WorkOrderUpdateGroup,
        WorkOrderBulkDelete,
        TrCaseById,
        AssetByID,
        UserGroupIDs,
        ParseLinks,
        AlertService,
        WorkOrderSearch,
        WorkOrderGroupSearch,
        WorkOrderPriority,
        WorkOrderGroupPriority,
        WorkOrderPrioritySearch,
        WorkOrderGroupPrioritySearch,
        WorkOrderForMap,
        WorkOrderSearchForMap,
        WorkOrderLastLocation,
        ChildWorkflows,
        WorkOrderWorkflowAssets,
        UserAccount
    ) {
        var vm = this;
        $scope.search = pagingParams.search;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterWorkOrderSearch = filterWorkOrderSearch;
        vm.filterSearchMap = filterSearchMap;
        vm.showWorkOrderBreakUps = showWorkOrderBreakUps;
        // vm.showWorkflowBOQBreakUp = showWorkflowBOQBreakUp;
        // vm.showWorkflowPBBreakUp = showWorkflowPBBreakUp;
        vm.showWorkOrderPowerBudgetBreakUps = showWorkOrderPowerBudgetBreakUps;
        vm.selectedWorkOrders = selectedWorkOrders;
        vm.selectWorkOrderEntity = selectWorkOrderEntity;
        vm.selectAllWorkOrder = selectAllWorkOrder;
        vm.updateWorkOrderGroup = updateWorkOrderGroup;
        vm.hideWorkOrderModal = hideWorkOrderModal;
        vm.hideWorkOrderPBModal = hideWorkOrderPBModal;
        // vm.hideWorkflowboqModal = hideWorkflowboqModal;
        // vm.hideWorkflowPBModal = hideWorkflowPBModal;
        vm.searchWorkOrders = searchWorkOrders;
        var latlng;
        var userPaths = {};
        var locations = {};
        var nearbyAgentsMarkers = [];
        var openedInfoWindow = null;
        vm.resolved = [];
        vm.unresolved = [];

        vm.selectWorkOrders = [];
        vm.multgroup = [];
        var selctedGroup = [];
        vm.groupOrders = true;
        vm.showActions = true;
        vm.totalSelected = 0;
        vm.assetsTable = assetsTable;
        vm.workflowTable = workflowTable;
        vm.createAccess = false;
        // vm.serviceTable = serviceTable;

        vm.items = [
            {
                name: "Update Group Mapping",
            },
            {
                name: "Delete Multiple WorkOrders",
            },
        ];

        UserAccount.get(function (data) {
            data.authorities.find(function (val) {
                if (
                    val == "ROLE_PLAN_ADMIN" ||
                    val == "ROLE_PLAN_INFRA" ||
                    val == "ROLE_PLAN_SURVEY"
                ) {
                    vm.createAccess = true;
                }
            });
        });

        $scope.tab = 4;
        $scope.$on("$destroy", function () {});
        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        if ($scope.tab == 4) {
            UserGroupIDs.getAll(function (response) {
                response.forEach(function (group) {
                    if (selctedGroup.indexOf(group.id) !== -1) {
                        vm.multgroup.push({
                            name: group.name,
                            id: group.id,
                            ticked: true,
                        });
                    } else {
                        vm.multgroup.push({
                            name: group.name,
                            id: group.id,
                            ticked: false,
                        });
                    }
                });
            });
            filterGroupSearch();
        }

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 4) {
                vm.itemsPerPage = paginationConstants.itemsPerPage;
                filterGroupSearch();
            }
        };

        function workflowTable(workOrder) {
            vm.workOrders.forEach(function (item) {
                item.isExpanded = false;
            });
            if (vm.toggle == workOrder.id) {
                vm.toggle = undefined;
            } else {
                workOrder.isExpanded = true;
                vm.toggle = workOrder.id;
            }
            ChildWorkflows.query(
                {
                    parentId: workOrder.id,
                },
                onSuccess
            );

            function onSuccess(data, headers) {
                var workFlowsRes = [];
                var Cost = "";
                var pb = "";
                var totalDis = 0.0;
                data.forEach(function (values) {
                    vm.parentGroup = values.groups[0].name;
                    /* if (values.status) {
                        values.status = values.status.replace(
                            "NEW",
                            "PLANNING PHASE"
                        );
                        values.status = values.status.replace(
                            "INPROGRESS",
                            "ROLL-OUT PHASE"
                        );
                        values.status = values.status.replace(
                            "RESOLVED",
                            "OPERATION PHASE"
                        );
                    } */
                    var caseTypeTypeAttrVal =
                        values.workFlowTypeAttributeValues;
                    caseTypeTypeAttrVal.forEach(function (item) {
                        if (item.workFlowTypeAttribute.name == "Cost") {
                            Cost = item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Power Budget"
                        ) {
                            pb = item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Fiber Distance"
                        ) {
                            totalDis = item.attributeValue;
                        }
                    });
                    var res = {
                        id: values.id,
                        description: values.description,
                        status: values.status,
                        phase: values.phase,
                        // fiberStatus: FiberStatus,
                        groups: values.groups,
                        Cost: "$" + Cost,
                        pb: "$" + pb,
                        totalDistance: totalDis,
                    };

                    workFlowsRes.push(res);
                });
                vm.workflowAssets = workFlowsRes;
            }
        }
        // function serviceTable(value) {
        // 	ChildServices.query({
        // 		parentId: value.id
        // 	}, onSuccess);

        // 	function onSuccess(data, headers) {

        // 		var servicesRes = [];
        // 		data.forEach(function (values) {
        // 			if (values.status) {
        // 				values.status = values.status.replace("NEW", "PLANNING PHASE");
        // 				values.status = values.status.replace("INPROGRESS", "ROLL-OUT PHASE");
        // 				values.status = values.status.replace("RESOLVED", "OPERATION PHASE");
        // 			}
        // 			var res = {
        // 				id: values.id,
        // 				description: values.description,
        // 				status: values.status,
        // 				reportedByUser: values.reportedByUser,
        // 				assignedToUser: values.assignedToUser,
        // 				// fiberStatus: FiberStatus,
        // 				groups: values.groups,
        // 			};

        // 			servicesRes.push(res);
        // 		});
        // 		vm.serviceAssets = servicesRes;
        // 	}
        // }
        function assetsTable(value) {
            WorkOrderWorkflowAssets.query(
                {
                    parentId: value.id,
                },
                onSuccess
            );

            function onSuccess(data, headers) {
                var servicesRes = [];
                var Cost = "";
                var pb = "";
                var totalDistance = 0.0;
                data.forEach(function (values) {
                    // if (values.status) {
                    // 	values.status = values.status.replace("NEW", "PLANNING PHASE");
                    // 	values.status = values.status.replace("INPROGRESS", "ROLL-OUT PHASE");
                    // 	values.status = values.status.replace("RESOLVED", "OPERATION PHASE");
                    // }
                    var assetAttrVal = values.assetTypeAttributeValues;

                    assetAttrVal.forEach(function (item) {
                        if (item.assetTypeAttribute.name == "Cost") {
                            Cost = item.attributeValue;
                        } else if (
                            item.assetTypeAttribute.name == "Power Budget"
                        ) {
                            pb = item.attributeValue;
                        } else if (
                            item.assetTypeAttribute.name == "Fiber Distance"
                        ) {
                            totalDis = item.attributeValue;
                        }
                    });
                    if ((values.status = "true") || (values.status = "false")) {
                        values.status = "";
                    }
                    var res = {
                        id: values.id,
                        description: values.description,
                        status: values.status,
                        phase: values.phase,
                        // reportedByUser: values.reportedByUser,
                        // assignedToUser: values.assignedToUser,
                        // fiberStatus: FiberStatus,
                        groups: values.groups,
                        Cost: "$" + Cost,
                        pb: "$" + pb,
                        totalDistance: totalDistance,
                    };

                    servicesRes.push(res);
                });
                vm.serviceAssets = servicesRes;
            }
        }
        function searchWorkOrders() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search) &&
                $scope.search.length != 1 &&
                $scope.search.length != 2 &&
                $scope.search.length != 3 &&
                $scope.search.length != 4
            ) {
                if ($stateParams.priority == undefined) {
                    WorkOrderSearch.query(
                        {
                            search: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrderPrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    var workOrdersRes = [];
                    data.forEach(function (values) {
                        var workFlows = values.workOrderCases;
                        var disVal = 0.0;
                        var Cost = "";
                        var pb = "";
                        var totalDis = 0.0;

                        var FiberStatus = "";
                        var workOrderTypeAttrVal =
                            values.workOrderTypeAttributeValues;

                        workOrderTypeAttrVal.forEach(function (item) {
                            if (item.workOrderDataTypeName == "Fiber Status") {
                                FiberStatus = item.attributeValue;
                            }

                            if (item.name == "Cost") {
                                Cost = item.attributeValue;
                            } else if (item.name == "Power Budget") {
                                pb = item.attributeValue;
                            } else if (item.name == "Fiber Distance") {
                                totalDis = item.attributeValue;
                            }
                        });
                        /*  if (values.status) {
                            values.status = values.status.replace(
                                "NEW",
                                "PLANNING PHASE"
                            );
                            values.status = values.status.replace(
                                "INPROGRESS",
                                "ROLL-OUT PHASE"
                            );
                            values.status = values.status.replace(
                                "RESOLVED",
                                "OPERATION PHASE"
                            );
                        } */
                        var res = {
                            id: values.id,
                            description: values.description,
                            address: values.address,
                            escalated: values.escalated,
                            status: values.status,
                            phase: values.phase,
                            reportedByUser: values.reportedByUser,
                            assignedToUser: values.assignedToUser,
                            workOrderTypeName: values.workOrderTypeName,
                            pinLat: values.pinLat,
                            pinLong: values.pinLong,
                            workOrderType: values.workOrderType,
                            priority: values.priority,
                            fiberStatus: FiberStatus,
                            groups: values.groups,
                            workOrderCases: values.workOrderCases,
                            geofenceName: values.geofenceName,
                            workOrderTypeAttributeValues:
                                values.workOrderTypeAttributeValues,
                            Cost: "$" + Cost,
                            pb: "$" + pb,
                            totalDistance: totalDistance,
                        };

                        workOrdersRes.push(res);
                    });
                    vm.page = pagingParams.page;
                    vm.workOrders = [];
                    workOrdersRes.forEach(function (workOrderVal) {
                        workOrderVal.workOrderTypeAttributeValues.forEach(
                            function (val) {
                                if (val.name == "Resolved Distance") {
                                    workOrderVal.resolved = val.attributeValue;
                                }
                                if (val.name == "Unresolved Distance") {
                                    workOrderVal.unresolved =
                                        val.attributeValue;
                                }
                            }
                        );
                        var total =
                            parseFloat(workOrderVal.unresolved) +
                            parseFloat(workOrderVal.resolved);
                        var percent =
                            (parseFloat(workOrderVal.resolved) * 100) / total;
                        workOrderVal.totaldistance = total.toFixed(2);
                        if (
                            total > 0 &&
                            parseFloat(workOrderVal.resolved) > 0
                        ) {
                            workOrderVal.percentdistance = percent.toFixed(0);
                        } else {
                            workOrderVal.percentdistance = 0;
                        }
                        vm.workOrders.push(workOrderVal);
                    });
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function filterWorkOrderSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                if ($stateParams.priority == undefined) {
                    WorkOrderSearch.query(
                        {
                            search: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrderPrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    vm.workOrders = [];
                    data.forEach(function (workOrderVal) {
                        workOrderVal.workOrderTypeAttributeValues.forEach(
                            function (val) {
                                if (val.name == "Resolved Distance") {
                                    workOrderVal.resolved = val.attributeValue;
                                }
                                if (val.name == "Unresolved Distance") {
                                    workOrderVal.unresolved =
                                        val.attributeValue;
                                }
                            }
                        );
                        var total =
                            parseFloat(workOrderVal.unresolved) +
                            parseFloat(workOrderVal.resolved);
                        var percent =
                            (parseFloat(workOrderVal.resolved) * 100) / total;
                        workOrderVal.totaldistance = total.toFixed(2);
                        if (
                            total > 0 &&
                            parseFloat(workOrderVal.resolved) > 0
                        ) {
                            workOrderVal.percentdistance = percent.toFixed(0);
                        } else {
                            workOrderVal.percentdistance = 0;
                        }
                        vm.workOrders.push(workOrderVal);
                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function filterGroupSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                if ($stateParams.priority == undefined) {
                    WorkOrderGroupSearch.query(
                        {
                            search: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrderGroupPrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    vm.workOrders = [];
                    data.forEach(function (workOrderVal) {
                        workOrderVal.workOrderTypeAttributeValues.forEach(
                            function (val) {
                                if (val.name == "Resolved Distance") {
                                    workOrderVal.resolved = val.attributeValue;
                                }
                                if (val.name == "Unresolved Distance") {
                                    workOrderVal.unresolved =
                                        val.attributeValue;
                                }
                            }
                        );
                        var total =
                            parseFloat(workOrderVal.unresolved) +
                            parseFloat(workOrderVal.resolved);
                        var percent =
                            (parseFloat(workOrderVal.resolved) * 100) / total;
                        workOrderVal.totaldistance = total.toFixed(2);
                        if (
                            total > 0 &&
                            parseFloat(workOrderVal.resolved) > 0
                        ) {
                            workOrderVal.percentdistance = percent.toFixed(0);
                        } else {
                            workOrderVal.percentdistance = 0;
                        }
                        vm.workOrders.push(workOrderVal);
                        vm.workOrders.push(workOrderVal);
                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            if ($stateParams.priority == undefined) {
                if ($scope.tab == 4) {
                    WorkOrderGroup.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrder.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            } else {
                if ($scope.tab == 4) {
                    WorkOrderGroupPriority.query(
                        {
                            priority: $stateParams.priority,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    WorkOrderPriority.query(
                        {
                            priority: $stateParams.priority,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            }

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    // result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                var workOrdersRes = [];
                data.forEach(function (values) {
                    var workFlows = values.workOrderCases;
                    var disVal = 0.0;
                    var Cost = "";
                    var pb = "";
                    var totalDistance = 0.0;

                    var FiberStatus = "";
                    var workOrderTypeAttrVal =
                        values.workOrderTypeAttributeValues;

                    workOrderTypeAttrVal.forEach(function (item) {
                        if (item.workOrderDataTypeName == "Fiber Status") {
                            FiberStatus = item.attributeValue;
                        }

                        if (item.name == "Cost") {
                            Cost = item.attributeValue;
                        } else if (item.name == "Power Budget") {
                            pb = item.attributeValue;
                        } else if (item.name == "Fiber Distance") {
                            totalDistance = item.attributeValue;
                        }
                    });
                    /* if (values.status) {
                        values.status = values.status.replace(
                            "NEW",
                            "PLANNING PHASE"
                        );
                        values.status = values.status.replace(
                            "INPROGRESS",
                            "ROLL-OUT PHASE"
                        );
                        values.status = values.status.replace(
                            "RESOLVED",
                            "OPERATION PHASE"
                        );
                    } */
                    var res = {
                        id: values.id,
                        description: values.description,
                        address: values.address,
                        escalated: values.escalated,
                        status: values.status,
                        phase: values.phase,
                        reportedByUser: values.reportedByUser,
                        assignedToUser: values.assignedToUser,
                        workOrderTypeName: values.workOrderTypeName,
                        pinLat: values.pinLat,
                        pinLong: values.pinLong,
                        workOrderType: values.workOrderType,
                        priority: values.priority,
                        fiberStatus: FiberStatus,
                        groups: values.groups,
                        workOrderCases: values.workOrderCases,
                        geofenceName: values.geofenceName,
                        workOrderTypeAttributeValues:
                            values.workOrderTypeAttributeValues,
                        Cost: "$" + Cost,
                        pb: pb,
                        totalDistance: totalDistance,
                    };

                    workOrdersRes.push(res);
                });
                vm.page = pagingParams.page;
                vm.workOrders = [];
                workOrdersRes.forEach(function (workOrderVal) {
                    workOrderVal.workOrderTypeAttributeValues.forEach(function (
                        val
                    ) {
                        if (val.name == "Resolved Distance") {
                            workOrderVal.resolved = val.attributeValue;
                        }
                        if (val.name == "Unresolved Distance") {
                            workOrderVal.unresolved = val.attributeValue;
                        }
                    });
                    var total =
                        parseFloat(workOrderVal.unresolved) +
                        parseFloat(workOrderVal.resolved);
                    var percent =
                        (parseFloat(workOrderVal.resolved) * 100) / total;
                    workOrderVal.totaldistance = total.toFixed(2);
                    if (total > 0 && parseFloat(workOrderVal.resolved) > 0) {
                        workOrderVal.percentdistance = percent.toFixed(0);
                    } else {
                        workOrderVal.percentdistance = 0;
                    }
                    vm.workOrders.push(workOrderVal);
                });
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function filterSearchMap() {
            var data;
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                WorkOrderSearchForMap.searchtrworkOrderformap(
                    $scope.search,
                    function (response) {
                        drawResponseMap(response);
                    }
                );
            } else {
                if ($stateParams.priority == undefined) {
                    WorkOrderForMap.getAllCases(function (response) {
                        drawResponseMap(response);
                    });
                } else {
                    WorkOrderSearchForMap.prioritysearchtrworkOrderformap(
                        $stateParams.priority,
                        function (response) {
                            drawResponseMap(response);
                        }
                    );
                }
            }
            $scope.search = "";
        }
        function showWorkOrderBreakUps(workCost) {
            vm.workOrderName = workCost.description;
            vm.workBreakUps = [];
            var dateFormat = "yyyy-MM-dd";
            WorkOrder.get({ id: workCost.id }, function (workCase) {
                workCase.workOrderCases.forEach(function (data) {
                    var orderCost = 0.0;
                    var orderPb = 0.0;
                    var orderDis = 0.0;
                    data.workFlowTypeAttributeValues.forEach(function (item) {
                        if (item.workFlowTypeAttribute.name == "Cost") {
                            orderCost = "$" + item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Power Budget"
                        ) {
                            orderPb = item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Fiber Distance"
                        ) {
                            orderDis = item.attributeValue;
                        }
                    });

                    var orders = {
                        id: data.id,
                        description: data.description,
                        createDate: $filter("date")(
                            data.createDate,
                            dateFormat
                        ),
                        Cost: orderCost,
                        pb: orderPb,
                        totalDistance: orderDis,
                    };
                    vm.workBreakUps.push(orders);
                });
            });
            $("#workOrderBreakUpModal").show();
        }

        function showWorkOrderPowerBudgetBreakUps(workPB) {
            vm.workOrderName = workPB.description;
            vm.workBreakUps = [];
            var dateFormat = "yyyy-MM-dd";
            WorkOrder.get({ id: workPB.id }, function (workCase) {
                workCase.workOrderCases.forEach(function (data) {
                    var orderCost = 0.0;
                    var orderPb = 0.0;
                    var orderDis = 0.0;
                    data.workFlowTypeAttributeValues.forEach(function (item) {
                        if (item.workFlowTypeAttribute.name == "Cost") {
                            orderCost = "$" + item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Power Budget"
                        ) {
                            orderPb = item.attributeValue;
                        } else if (
                            item.workFlowTypeAttribute.name == "Fiber Distance"
                        ) {
                            orderDis = item.attributeValue;
                        }
                    });

                    var orders = {
                        id: data.id,
                        description: data.description,
                        createDate: $filter("date")(
                            data.createDate,
                            dateFormat
                        ),
                        Cost: orderCost,
                        pb: orderPb,
                        totalDistance: orderDis,
                    };
                    vm.workBreakUps.push(orders);
                });
            });
            $("#PBWorkOrderBreakUp").show();
        }

        // function showWorkflowBOQBreakUp(boqBreak) {
        // 	vm.workflowBoq = [];
        // 	var res = {
        // 		description: boqBreak.description,
        // 		group: boqBreak.groups[0].name,
        // 		boq: boqBreak.Cost,
        // 		totalDistance: boqBreak.totalDistance
        // 	};
        // 	vm.workflowBoq.push(res);
        // 	$("#WorkflowboqBreakUp").show();
        // }
        function showWorkflowPBBreakUp(pbBreak) {
            vm.workflowPB = [];
            var res = {
                description: pbBreak.description,
                group: pbBreak.groups[0].name,
                pb: pbBreak.pb,
                totalDistance: pbBreak.totalDistance,
            };
            vm.workflowPB.push(res);
            $("#WorkflowPBBreakUp").show();
        }

        function hideWorkOrderModal() {
            $("#workOrderBreakUpModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#workOrderBreakUpModal").hide();
        }

        function hideWorkOrderPBModal() {
            $("#PBWorkOrderBreakUp").removeClass("in");
            $(".modal-backdrop").remove();
            $("#PBWorkOrderBreakUp").hide();
        }
        // function hideWorkflowboqModal() {
        // 	$("#WorkflowboqBreakUp").hide();
        // }
        // function hideWorkflowPBModal() {
        // 	$("#WorkflowPBBreakUp").hide();
        // }

        function selectWorkOrderEntity(workOrder) {
            if (workOrder.id != null) {
                if (workOrder.isChecked == true) {
                    vm.totalSelected++;
                    vm.showActions = false;
                    vm.isAllSelected = vm.workOrders.every(function (itm) {
                        return itm.isChecked;
                    });
                    vm.selectWorkOrders.push(workOrder.id);
                } else {
                    vm.totalSelected--;
                }
                if (vm.totalSelected == 0) {
                    vm.groupAssets = true;
                    vm.showActions = true;
                    loadAll();
                }
            }
        }

        function selectAllWorkOrder() {
            var toggleStatus = vm.isAllSelected;
            if (toggleStatus) {
                vm.showActions = false;
                vm.selectWorkOrders = [];
                vm.workOrders.forEach(function (workOrder) {
                    vm.selectWorkOrders.push(workOrder.id);
                });
                vm.showActions = true;
                vm.selectWorkOrders = [];
            }
            angular.forEach(vm.workOrders, function (itm) {
                itm.isChecked = toggleStatus;
            });
        }

        function updateWorkOrderGroup(name) {
            vm.multgroup.forEach(function (group) {
                if (group.name == name) {
                    if (vm.selectWorkOrders.length > 0) {
                        var workFlowGroupArray = [];
                        vm.selectWorkOrders.forEach(function (workOrderId) {
                            workFlowGroupArray.push({
                                workOrderId: workOrderId,
                                groupId: group.id,
                            });
                        });
                        WorkOrderUpdateGroup.update(
                            workFlowGroupArray,
                            onSuccess,
                            onError
                        );
                        function onSuccess() {
                            vm.groupOrders = true;
                            vm.showActions = true;
                            loadAll();
                            // $state.go('work-order');
                        }
                        function onError() {}
                    } else {
                        alert("Please select Work Order to update group");
                    }
                }
            });
        }

        function selectedWorkOrders(name) {
            if (name == "Update Group Mapping") {
                vm.groupOrders = false;
            } else if (name == "Delete Multiple WorkOrders") {
                vm.groupOrders = true;
                if (vm.selectWorkOrders.length > 0) {
                    var workOrderGroupArray = [];
                    vm.selectWorkOrders.forEach(function (workOrderId) {
                        workOrderGroupArray.push({ id: workOrderId });
                    });
                    WorkOrderBulkDelete.save(
                        workOrderGroupArray,
                        onSuccess,
                        onError
                    );
                    function onSuccess() {
                        vm.groupOrders = true;
                        vm.showActions = true;
                        loadAll();
                        // $state.go('work-order');
                    }
                    function onError(error) {
                        var msg =
                            "Work Order deletion failed, Work Order has some dependent data";
                        if (error.status == 400) {
                            AlertService.error(msg);
                        } else {
                            AlertService.error(error.data.message);
                        }
                    }
                } else {
                    alert("Please select Work Order to delete list");
                }
            }
        }

        function animatedMove(marker, t, current, moveto) {
            var lat = current.lat();
            var lng = current.lng();

            var deltalat = (moveto.lat() - current.lat()) / 100;
            var deltalng = (moveto.lng() - current.lng()) / 100;

            var delay = 10 * t;
            for (var i = 0; i < 100; i++) {
                (function (ind) {
                    setTimeout(function () {
                        var lat = marker.position.lat();
                        var lng = marker.position.lng();
                        lat += deltalat;
                        lng += deltalng;
                        latlng = new google.maps.LatLng(lat, lng);
                        marker.setPosition(latlng);
                    }, delay * ind);
                })(i);
            }
        }

        function drawResponseMap(data) {
            var myOptions = {
                zoom: 10,
                center: new google.maps.LatLng("5.431587", "101.128162"),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };

            if ($scope.tab == 2 || $scope.tab == 5) {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas1"),
                    myOptions
                );
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () {};
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById("map_canvas1");
                drawLatestWorkOrders(data);
            } else if ($scope.tab == 3) {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas2"),
                    myOptions
                );
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () {};
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById("map_canvas2");
                drawCasesAndNearByAgents(data);
                WorkOrderLastLocation.getlastlogs(function (response) {
                    var lastLocByAgents = response;
                    var markerIcon = "inactive";
                    var imageUrl = "";
                    switch (markerIcon) {
                        case "inactive":
                            imageUrl = "content/images/marker_inactive.png";
                            break;
                        case "idle":
                            imageUrl = "content/images/marker_idle.png";
                            break;
                        case "active":
                            imageUrl = "content/images/marker_active.png";
                            break;
                        case "active_case":
                            imageUrl = "content/images/marker_active_case.png";
                            break;
                        default:
                            imageUrl = "content/images/green.png";
                            break;
                    }

                    var lastLocVal = [];
                    removeMarkers();
                    for (var i = 0; i < lastLocByAgents.length; i++) {
                        var path = lastLocByAgents[i].path;
                        if (path.length > 1) {
                            var marker = new google.maps.Marker({
                                position: new google.maps.LatLng(
                                    path[0].lat,
                                    path[0].lng
                                ),
                                map: locations.map,
                                icon: {
                                    scaledSize: new google.maps.Size(42, 40),
                                    origin: new google.maps.Point(0, 0),
                                    url: imageUrl,
                                    anchor: new google.maps.Point(16, 16),
                                },
                                label: {
                                    color: "#000000",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    text: lastLocByAgents[i].userName,
                                    backgroundcolor: "#ff9800",
                                },
                                title: lastLocByAgents[i].userName,
                            });
                            var markerContent =
                                '<div class="infoWindowhead">' +
                                name +
                                '</div><div class="infoWindowContent"> <br> <b> Lat  :</b> ' +
                                "<br> <b>Lng :</b> " +
                                "</div>";
                            var infowindow = new google.maps.InfoWindow({
                                content: markerContent,
                            });
                            marker.addListener("click", function () {
                                infowindow.open(locations.map, marker);
                            });

                            animatedMove(
                                marker,
                                50,
                                marker.position,
                                new google.maps.LatLng(path[1].lat, path[1].lng)
                            );
                            nearbyAgentsMarkers.push(marker);
                        }
                    }
                });
            }
        }
        function removeMarkers() {
            for (var i = 0; i < nearbyAgentsMarkers.length; i++) {
                nearbyAgentsMarkers[i].setMap(null);
            }
            nearbyAgentsMarkers = [];
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                priority: pagingParams.priority,
            });
        }

        $scope.openInfoWindow = function (e, selectedMarker) {
            e.preventDefault();
            google.maps.event.trigger(selectedMarker, "click");
        };

        function drawLatestWorkOrders(response) {
            if (response) {
                initializeWorkOrderMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // function() {
                    $.each(response, function (index, value) {
                        var infoWindow = new google.maps.InfoWindow();
                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });

                        var infoWindow2 = new google.maps.InfoWindow();
                        if (value.priority == "LOW") {
                            startMarker.setIcon(
                                "content/images/Pointers-L4.png"
                            );
                        } else if (value.priority == "MEDIUM") {
                            startMarker.setIcon(
                                "content/images/Pointers-M4.png"
                            );
                        } else if (value.priority == "HIGH") {
                            startMarker.setIcon(
                                "content/images/Pointers-H4.png"
                            );
                        } else if (value.priority == "CRITICAL") {
                            startMarker.setIcon(
                                "content/images/Pointer-C4.png"
                            );
                        }
                        var span =
                            '<a userId="' +
                            value.geofenceName +
                            '" class="userpath" >Load travelled path</a>';
                        startMarker.content =
                            '<div class="infoWindowContent"> <b>Incident Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b>Address :</b> " +
                            value.address +
                            "</div>";
                        $compile(startMarker.content)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "mouseover",
                            function () {
                                infoWindow.setContent(
                                    '<div class="infoWindowhead">' +
                                        startMarker.title +
                                        "</div>" +
                                        startMarker.content
                                );
                                infoWindow.open(locations.map, startMarker);
                            }
                        );

                        google.maps.event.addListener(
                            startMarker,
                            "mouseout",
                            function () {
                                infoWindow.close();
                            }
                        );
                    });
                });
            }
        }

        function initializeWorkOrderMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        function drawCasesAndNearByAgents(response) {
            if (response) {
                initializeMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // setupMap(function() {
                    $.each(response, function (index, value) {
                        var infoWindow = new google.maps.InfoWindow();
                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });

                        var infoWindow2 = new google.maps.InfoWindow();

                        if (value.priority == "LOW") {
                            startMarker.setIcon(
                                "content/images/Pointers-L4.png"
                            );
                        } else if (value.priority == "MEDIUM") {
                            startMarker.setIcon(
                                "content/images/Pointers-M4.png"
                            );
                        } else if (value.priority == "HIGH") {
                            startMarker.setIcon(
                                "content/images/Pointers-H4.png"
                            );
                        } else if (value.priority == "CRITICAL") {
                            startMarker.setIcon(
                                "content/images/Pointer-C4.png"
                            );
                        }
                        var span =
                            '<a userId="' +
                            value.geofenceName +
                            '" class="userpath" >Load travelled path</a>';
                        startMarker.content =
                            '<div class="infoWindowContent"><b>Incident Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b>Address :</b> " +
                            value.address +
                            "</div>";

                        $compile(startMarker.content)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "mouseover",
                            function () {
                                infoWindow.setContent(
                                    '<div class="infoWindowhead">' +
                                        startMarker.title +
                                        "</div>" +
                                        startMarker.content
                                );
                                infoWindow.open(locations.map, startMarker);
                            }
                        );

                        // on mouseout
                        google.maps.event.addListener(
                            startMarker,
                            "mouseout",
                            function () {
                                infoWindow.close();
                            }
                        );

                        resizeMap();
                    });
                    // });
                });
            }
        }

        $scope.workOrderLocation = function (selectedCase) {
            $("#workOrderLocationModal").show();
            var myCenter = new google.maps.LatLng(
                selectedCase.pinLat,
                selectedCase.pinLong
            );
            var ele = document.getElementById("workOrderLocationModal");
            $(ele).modal("show");

            var map = new google.maps.Map(
                document.getElementById("map_canvas_workorder_location"),
                {
                    center: myCenter,
                    zoom: 12,
                }
            );
            selectedCase.workOrderCases.forEach(function (caseVal) {
                TrCaseById.get(caseVal.id, function (caseDetails) {
                    caseDetails.caseAssets.forEach(function (assetVal) {
                        if (assetVal.assetType.layout == "SPREAD") {
                            AssetByID.get(assetVal.id, function (assetVal1) {
                                var spreadAssetCoordinates = [];

                                assetVal1.assetCoordinates.forEach(function (
                                    loc
                                ) {
                                    spreadAssetCoordinates.push({
                                        lat: loc.latitude,
                                        lng: loc.longitude,
                                    });
                                });
                                var polylineColor = "#000000";
                                var polylinepath = new google.maps.Polyline({
                                    path: spreadAssetCoordinates,
                                    geodesic: true,
                                    strokeColor: polylineColor,
                                    strokeOpacity: 1.0,
                                    strokeWeight: 2.5,
                                    fillColor: polylineColor,
                                    fillOpacity: 0.3,
                                    editable: false,
                                });

                                polylinepath.setMap(map);

                                var pos = {
                                    lat: assetVal1.assetCoordinates[0].latitude,
                                    lng:
                                        assetVal1.assetCoordinates[0].longitude,
                                };
                                map.setCenter(pos);

                                var midLatLng = {
                                    lat:
                                        spreadAssetCoordinates[
                                            spreadAssetCoordinates.length - 1
                                        ].lat,
                                    lng:
                                        spreadAssetCoordinates[
                                            spreadAssetCoordinates.length - 1
                                        ].lng,
                                };
                                var infowindow = new google.maps.InfoWindow({
                                    content:
                                        '<div class="infoWindowhead">' +
                                        "name" +
                                        '<div class="infoWindowContent"> <b>Name :</b> ' +
                                        assetVal1.name +
                                        "</div></div>",
                                });

                                infowindow.setPosition(midLatLng);
                                google.maps.event.addListener(
                                    polylinepath,
                                    "mouseout",
                                    function (event) {
                                        infowindow.close();
                                    }
                                );

                                google.maps.event.addListener(
                                    polylinepath,
                                    "mouseover",
                                    function (event) {
                                        if (openedInfoWindow != null) {
                                            openedInfoWindow.close();
                                        }
                                        infowindow.setContent(
                                            '<div class="infoWindowhead">' +
                                                "<b></b>" +
                                                assetVal1.name +
                                                "</br></div>"
                                        );

                                        infowindow.mousemove;
                                        infowindow.open(map);
                                        infowindow.setPosition(event.latLng);
                                        openedInfoWindow = infowindow;
                                    }
                                );
                            });
                        } else if (assetVal.assetType.layout == "FIXED") {
                            AssetByID.get(assetVal.id, function (assetVal1) {
                                createMarker(
                                    assetVal1.assetCoordinates[0],
                                    map
                                );
                                var pos = {
                                    lat: assetVal1.assetCoordinates[0].latitude,
                                    lng:
                                        assetVal1.assetCoordinates[0].longitude,
                                };
                                map.setCenter(pos);
                            });
                        }
                    });
                });
            });

            $("#workOrderLocationModal").on("show.bs.modal", function (event) {
                $("#location-map-workorder-location").css("width", "100%");
                $("#map_canvas_workorder_location").css("width", "100%");
            });
        };

        function createMarker(latlngs, map) {
            try {
                var pos = {
                    lat: latlngs.latitude,
                    lng: latlngs.longitude,
                };

                var marker = new google.maps.Marker({
                    position: pos,
                    map: map,
                    icon:
                        "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                });
            } catch (err) {}
        }

        function resizeMap() {
            setTimeout(function () {
                google.maps.event.trigger(locations.map, "resize");
                locations.map.setCenter(locations.latlng);
            }, 1000);
        }

        function initializeMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        $(".select2").select2();

        vm.success = null;
        vm.error = null;
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkFlowTypeDialogController",
            WorkFlowTypeDialogController
        );

    WorkFlowTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "WorkFlowType",
        "User",
        "WorkFlowTypeSearch",
        "AllCustomWorkFlowTypeAttribute",
    ];

    function WorkFlowTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        WorkFlowType,
        User,
        WorkFlowTypeSearch,
        AllCustomWorkFlowTypeAttribute
    ) {
        var vm = this;
        //workFlowtype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.workFlowType = entity;
        vm.workFlowTypeImageName = workFlowTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customWorkFlowTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        vm.checkNumber;

        function workFlowTypeImageName(image) {
            vm.workFlowType.image = image;
        }

        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomWorkFlowTypeAttribute.getAll(function (response) {
                vm.customWorkFlowTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customWorkFlowTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.workFlowType.workFlowTypeAttribute != null &&
            vm.workFlowType.workFlowTypeAttribute.length != 0
        ) {
            vm.items = vm.workFlowType.workFlowTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.workFlowCategory == null) {
                value.workFlowCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.workFlowType.id !== null) {
                vm.workFlowType.workFlowTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.workFlowType.workFlowTypeAttribute.push({
                        workFlowCategory: vm.items[i].workFlowCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        workFlowTypeAttribOrder:
                            vm.items[i].workFlowTypeAttribOrder,
                    });
                }
                WorkFlowType.update(
                    vm.workFlowType,
                    onSaveSuccess,
                    onSaveError
                );
            } else {
                vm.workFlowType.workFlowTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.workFlowType.workFlowTypeAttribute.push({
                        workFlowCategory: vm.items[i].workFlowCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        workFlowTypeAttribOrder:
                            vm.items[i].workFlowTypeAttribOrder,
                    });
                }
                WorkFlowType.save(vm.workFlowType, onSaveSuccess, onSaveError);
            }
        }

        $("#workFlowTypeImage").change(function () {
            var filesSelected =
                document.getElementById("workFlowTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.workFlowType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:workFlowTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("work-flow-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.addmore = function (index) {
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice(index + 1, 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkFlowTypeDetailController",
            WorkFlowTypeDetailController
        );

    WorkFlowTypeDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "WorkFlowType",
        "User",
    ];

    function WorkFlowTypeDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        WorkFlowType,
        User
    ) {
        var vm = this;

        vm.workFlowType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on(
            "trakeyeApp:workFlowTypeUpdate",
            function (event, result) {
                vm.workFlowType = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "WorkFlowTypeDeleteController",
            WorkFlowTypeDeleteController
        );

    WorkFlowTypeDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "CaseType",
    ];

    function WorkFlowTypeDeleteController($uibModalInstance, entity, CaseType) {
        var vm = this;

        vm.caseType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            CaseType.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("work-flow-type", {
                parent: "entity",
                url: "/work-flow-type",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                    pageTitle: "trakeyeApp.workflowType.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-types.html",
                        controller: "WorkFlowTypeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "update_date,desc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlowType");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("work-flow-type-detail", {
                parent: "work-flow-type",
                url: "/work-flow-type/{id}",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                    pageTitle: "trakeyeApp.workflowType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-type-detail.html",
                        controller: "WorkFlowTypeDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlowType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkFlowType",
                        function ($stateParams, WorkFlowType) {
                            return WorkFlowType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-flow-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-flow-type.new", {
                parent: "work-flow-type",
                url: "/create",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-type-dialog.html",
                        controller: "WorkFlowTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            description: null,
                            createdDate: null,
                            updateDate: null,
                            id: null,
                        };
                    },
                },
            })
            .state("work-flow-type.edit", {
                parent: "work-flow-type",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                    pageTitle: "trakeyeApp.workflowType.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow-type/work-flow-type-dialog.html",
                        controller: "WorkFlowTypeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlowType");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkFlowType",
                        function ($stateParams, WorkFlowType) {
                            return WorkFlowType.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-flow-type",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("work-flow-type.delete", {
                parent: "work-flow-type",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/work-flow-type/work-flow-type-delete-dialog.html",
                                controller: "WorkFlowTypeDeleteController",
                                controllerAs: "vm",
                                size: "sm",
                                resolve: {
                                    entity: [
                                        "WorkFlowType",
                                        function (WorkFlowType) {
                                            return WorkFlowType.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("work-flow-type", null, {
                                        reload: "work-flow-type",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkFlowType", WorkFlowType);

    WorkFlowType.$inject = ["$resource", "DateUtils"];

    function WorkFlowType($resource, DateUtils) {
        var resourceUrl = "api/work-flow-types/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );
    }
})();
(function () {
    "use strict";

    angular.module("trakeyeApp").factory("WorkFlowTypeSearch", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getworkflowtypebyname = function (data, callback) {
                $http
                    .get("api/work-flow-types-details/" + data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .factory("WorkFlowTypeSearch", WorkFlowTypeSearch);

    WorkFlowTypeSearch.$inject = ["$resource"];

    function WorkFlowTypeSearch($resource) {
        var service = $resource(
            "/api/work-flow-types/searchvalue/:userId",
            { userId: "@id" },
            {},
            {
                query: { method: "GET", isArray: true },
            }
        );

        return service;
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllCustomWorkFlowTypeAttribute", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/all-custom-workflow-type-attributes")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowTypeController", WorkFlowTypeController);

    WorkFlowTypeController.$inject = [
        "$scope",
        "$state",
        "WorkFlowType",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "WorkFlowTypeSearch",
    ];

    function WorkFlowTypeController(
        $scope,
        $state,
        WorkFlowType,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        WorkFlowTypeSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                WorkFlowTypeSearch.query(
                    {
                        userId: $scope.search,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        //  result.push('id');
                    }
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.workFlowTypes = data;
                    vm.page = pagingParams.page;
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        loadAll();

        function loadAll() {
            WorkFlowType.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.workFlowTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowDialogController", WorkFlowDialogController);

    WorkFlowDialogController.$inject = [
        "$scope",
        "$state",
        "$stateParams",
        "entity",
        "AlertService",
        "WorkFlow",
        "AssetGroupSearch",
        "AssetGroup",
        "AllWorkFlowTypes",
        "AllCustomWorkFlowTypeAttribute",
        "AllCustomAssetTypeAttribute",
        "UserGroupIDs",
        "ActivatedUserSearch",
        "AllAssetsTypes",
        "WorkFlowCheckAsset",
        "Configs",
        "UserAccount",
        "$rootScope"
    ];

    function WorkFlowDialogController(
        $scope,
        $state,
        $stateParams,
        entity,
        AlertService,
        WorkFlow,
        AssetGroupSearch,
        AssetGroup,
        AllWorkFlowTypes,
        AllCustomWorkFlowTypeAttribute,
        AllCustomAssetTypeAttribute,
        UserGroupIDs,
        ActivatedUserSearch,
        AllAssetsTypes,
        WorkFlowCheckAsset,
        Configs,
        UserAccount,
        $rootScope
    ) {
        var vm = this;

        vm.workFlow = entity;
        var entity_old = angular.copy(vm.workFlow);
        vm.filterActivatedUser = filterActivatedUser;
        vm.selectattributes = selectedWorkFlowTypeAttributes;
        vm.saveEditAsset = saveEditAsset;
        vm.selectedGroup = selectedGroup;
        var openedInfoWindow = null;
        vm.connectSelectedAssets = connectSelectedAssets;
        vm.saveLinkPits = saveLinkPits;
        vm.connectMultipleAssets = connectMultipleAssets;
        vm.hideConnectMultipleAssetsModal = hideConnectMultipleAssetsModal;
        vm.searchAssetName = searchAssetName;
        vm.refreshPage = refreshPage;
        vm.connectAssets = connectAssets;
        vm.recalculate = recalculate;
        vm.isSiteASelected = false;
        vm.isSiteBSelected = false;
        vm.selectedSiteA = {};
        vm.selectedSiteB = {};
        vm.linkAssetType = null;
        vm.manholeAssetType = null;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.showZoomLocation = showZoomLocation

        vm.editAsset = editAsset;
        vm.workFlowTypes = [];
        vm.multigroup = [];
        vm.assetType = [];
        var parentSite = [];

        vm.deleteAssetModal = deleteAssetModal;
        vm.confirmDeleteAsset = confirmDeleteAsset;
        vm.cleardeleteAsset = cleardeleteAsset;
        vm.clearCreateAsset = clearCreateAsset;
        var deleteAssetName = null;
        vm.createAssetModal = createAssetModal;
        vm.createAsset = createAsset;
        vm.assetNameVal = null;
        /* vm.assetLat = null;
        vm.assetLong = null; */
        vm.getLocationCoordinate = null
        var createAssetData = {};

        vm.customAttributesMap = {};
        var usersMap = {};
        var mappedAssetTemp = {};
        vm.mappedAssetsList = [];
        vm.tempLinkWithPits = [];
        vm.deletedAssetsList = [];
        var selectedGroup = [];
        var assetsPlanningMap = null;
        var assetsDeployedMap = null;
        vm.isShowing = true;
        vm.save = save;
        vm.handleTabClick = handleTabClick;
        vm.assetExisting = false;
        $scope.search = null;
        vm.assets = [];
        vm.showAssetCreation = false;
        vm.showAssetName = false;
        var centerlatlng = null;
        vm.hideUser = true;
        var marker = null;
        //        vm.searchAssets = searchAssets;
        var editAssetMap = null;
        vm.validUser = true;
        vm.assignedUsers = [];
        vm.validUser = true;
        vm.hideConnectSitesModal = hideConnectSitesModal;
        vm.previousId = sessionStorage.getItem("prevEditId");
        if (vm.previousId) {
            vm.validUser = false;
        }
        $scope.tab = 1;
        vm.siteAssets = [];
        vm.phaseAccess = true;
        jQuery(document).ready(function () {
            var back = jQuery(".prev");
            var next = jQuery(".next");
            var steps = jQuery(".step");

            next.bind("click", function () {
                jQuery.each(steps, function (i) {
                    if (
                        !jQuery(steps[i]).hasClass("current") &&
                        !jQuery(steps[i]).hasClass("done")
                    ) {
                        jQuery(steps[i]).addClass("current");
                        jQuery(steps[i - 1])
                            .removeClass("current")
                            .addClass("done");
                        return false;
                    }
                });
            });
            back.bind("click", function () {
                jQuery.each(steps, function (i) {
                    if (
                        jQuery(steps[i]).hasClass("done") &&
                        jQuery(steps[i + 1]).hasClass("current")
                    ) {
                        jQuery(steps[i + 1]).removeClass("current");
                        jQuery(steps[i])
                            .removeClass("done")
                            .addClass("current");
                        return false;
                    }
                });
            });
        });

        $scope.assetTypeLabel = {
            search: "Search",
            nothingSelected: "Select Asset Type",
        };

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                disableDoubleClickZoom: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    },
                ],
            });
        }

        var latlngs = new google.maps.LatLng(
            $rootScope.DEFAULT_LATITUDE,
            $rootScope.DEFAULT_LONGITUDE
        );

        if ($scope.tab == 1) {
            vm.toggleFirst = true;
            vm.toggleSecond = false;
            vm.toggleThird = false;
            AllWorkFlowTypes.getAll(function (response) {
                vm.workFlowTypes = response;
            });

            Configs.get("Phases", function (response) {
                vm.workFlowPhase = response;
                //vm.workFlow.phase = "Planning Phase"
                /*  if(vm.workFlow.id == null){
                    response.forEach(function(val){
                        if(val.configValue == '01'){
                            vm.workFlow.phase = val.configKey
                        }
                    })
                }*/
            });

            if (vm.workFlow.id) {
                Configs.get("WorkFlowStatus", function (response) {
                    vm.workFlowStatus=[];
                    var workFlowStatusList = response[0].configValue.split(",");
                    workFlowStatusList.forEach(function(value){
                        if(value.length > 0){
                            vm.workFlowStatus.push({"configKey":value,"configValue":value});
                        }
                    });
                });
                
            }

            AllCustomWorkFlowTypeAttribute.getAll(function (response) {
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customWorkFlowTypeAttributeValues;
                });
            });

            if (vm.workFlow.id != null) {
                vm.hideUser = false;
                vm.workFlow.groups.forEach(function (group) {
                    selectedGroup.push(group.id);
                });
            }

            UserGroupIDs.getAll(function (response) {
                vm.multigroup = response;
                response.forEach(function (val) {
                    if (val.name == "Planning Group") {
                        val.ticked = true;
                    }
                });
            });

            UserAccount.get(function (data) {
                data.authorities.find(function (val) {
                    if (
                        val == "ROLE_PLAN_ADMIN" ||
                        val == "ROLE_ROLLOUT_ADMIN"
                    ) {
                        vm.phaseAccess = false;
                    }
                });
            });

            AllAssetsTypes.getAll(function (response) {
                vm.assetTypeResponse = []
                response.filter(function (eachElement){
                    if(eachElement.layout == "SPREAD"){
                        vm.assetTypeResponse.push(eachElement)
                    }
                })
                response.forEach(function (assettype) {
                    if (assettype.layout == "FIXED") {
                        assettype.icon =
                            '<img  src="' +
                            assettype.imagePath +
                            '"style="width: 24px; height: 24px;">';
                    } else {
                        assettype.icon =
                            '<img class="square" style="background-color:' +
                            assettype.colorcode +
                            ';">';
                    }
                    vm.assetType.push(assettype);
                });
            });

            AllCustomAssetTypeAttribute.getAll(function (response) {
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customAssetTypeAttributeValues;
                });
            });

            if (vm.workFlow.id != null) {
                if (vm.workFlow.workFlowAssets != null) {
                    vm.workFlow.workFlowAssets.forEach(function (asset) {
                        asset.isChecked = true;
                        vm.mappedAssetsList.push(asset);
                        vm.isShowing = false;
                        $scope.toggle = true;
                    });
                }
                vm.workFlowType = entity.workFlowType;
            }
        }

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            $scope.search = "";

            if ($scope.tab == 1) {
                vm.toggleFirst = true;
                vm.toggleSecond = false;
                vm.toggleThird = false;
            } else if ($scope.tab == 2) {
                vm.toggleFirst = false;
                vm.toggleSecond = true;
                vm.toggleThird = false;
                initPlanningMap();
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                        createMarkerForSelectedAsset(
                            vm.mappedAssetsList[i],
                            assetsPlanningMap
                        );
                    } else if (
                        vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                    ) {
                        var assetCoordinateValues =
                            vm.mappedAssetsList[i].assetCoordinates;
                        drawPolylineForGeneratedLoc(
                            vm.mappedAssetsList[i],
                            assetCoordinateValues,
                            assetsPlanningMap,
                            "yellow"
                        );
                    }
                }

                AllAssetsTypes.getAll(function (data) {
                    data.forEach(function (item) {
                        if (item.name == "Link") {
                            vm.linkAssetType = {};
                            vm.linkAssetType.assetType = item;
                            vm.linkAssetType.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                vm.linkAssetType.assetType
                            );
                            //                            $.each(vm.linkAssetType.assetType.assetTypeAttributes,function(key, value) {
                            //                                vm.linkAssetType.assetTypeAttributeValues.push({
                            //                                        assetTypeAttribute: vm.linkAssetType.assetType.assetTypeAttributes[key]
                            //                                    });
                            //                            });
                        } else if (item.name == "Manhole") {
                            vm.manholeAssetType = {};
                            vm.manholeAssetType.assetType = item;
                            vm.manholeAssetType.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                vm.manholeAssetType.assetType
                            );
                            //                            $.each(vm.manholeAssetType.assetType.assetTypeAttributes,function(key, value) {
                            //                                vm.manholeAssetType.assetTypeAttributeValues.push({
                            //                                        assetTypeAttribute: vm.manholeAssetType.assetType.assetTypeAttributes[key]
                            //                                    });
                            //                            });
                        }
                    });
                });

            } else if ($scope.tab == 3) {
                vm.toggleFirst = false;
                vm.toggleSecond = false;
                vm.toggleThird = true;
                var totalCost = 0;
                var totalPowerBudget = 0;
                var totalFiberDistance = 0.0;
                for (
                    var assetIndex = 0;
                    assetIndex < vm.mappedAssetsList.length;
                    assetIndex++
                ) {
                    if (vm.mappedAssetsList[assetIndex].name != null) {
                        var assetAV =
                            vm.mappedAssetsList[assetIndex]
                                .assetTypeAttributeValues;
                        var isSpread = false;
                        var fiberDistance = 0.0;

                        if (
                            vm.mappedAssetsList[assetIndex].assetType.layout ==
                            "SPREAD"
                        ) {
                            isSpread = true;
                            var spreadAV =
                                vm.mappedAssetsList[assetIndex]
                                    .assetTypeAttributeValues;
                            for (
                                var spreadAssetIndex = 0;
                                spreadAssetIndex < spreadAV.length;
                                spreadAssetIndex++
                            ) {
                                if (
                                    spreadAV[spreadAssetIndex]
                                        .assetTypeAttribute.name ===
                                    "Fiber Distance (km)"
                                ) {
                                    fiberDistance = parseFloat(
                                        "0" +
                                            spreadAV[spreadAssetIndex]
                                                .attributeValue
                                    );
                                }
                            }
                        }

                        assetAV.forEach(function (item) {
                            var value = 0;
                            if (item.attributeValue != null) {
                                value = parseFloat(item.attributeValue);
                            } else {
                                value = parseFloat(
                                    item.assetTypeAttribute.defaultValue
                                );
                            }

                            if (item.assetTypeAttribute.name == "Cost") {
                                var tempCost = parseFloat(value);
                                if (isSpread) {
                                    tempCost =
                                        parseFloat(value) * fiberDistance;
                                }
                                if (tempCost > 0) {
                                    totalCost += tempCost;
                                }
                            }
                            if (
                                item.assetTypeAttribute.name == "Power Budget"
                            ) {
                                var tempPowerBudget = parseFloat(value);
                                if (isSpread) {
                                    tempPowerBudget =
                                        parseFloat(value) * fiberDistance;
                                }
                                if (tempPowerBudget > 0) {
                                    totalPowerBudget += tempPowerBudget;
                                }
                            }
                        });
                        totalFiberDistance += fiberDistance;
                    }
                }

                var workFlowAV = vm.workFlow.workFlowTypeAttributeValues;
                for (
                    var workFlowIndex = 0;
                    workFlowIndex < workFlowAV.length;
                    workFlowIndex++
                ) {
                    if (
                        workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                        "Cost"
                    ) {
                        workFlowAV[
                            workFlowIndex
                        ].attributeValue = totalCost.toFixed(2);
                    }
                    if (
                        workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                        "Power Budget"
                    ) {
                        workFlowAV[
                            workFlowIndex
                        ].attributeValue = totalPowerBudget.toFixed(2);
                    }
                    if (
                        workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                        "Fiber Distance"
                    ) {
                        workFlowAV[
                            workFlowIndex
                        ].attributeValue = totalFiberDistance.toFixed(2);
                    }
                }
                vm.workFlow.workFlowTypeAttributeValues = workFlowAV;

                assetsDeployedMap = new google.maps.Map(
                    document.getElementById("map_canvas_deployed"),
                    myOption(11, latlngs)
                    /* {
                        center: {
                            lat: 5.431587,
                            lng: 101.128162,
                        },
                        zoom: 13,
                        fullscreenControl: true,
                    } */
                );

                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                        createMarkerForSelectedAsset(
                            vm.mappedAssetsList[i],
                            assetsDeployedMap
                        );
                    } else if (
                        vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                    ) {
                        var assetCoordinateValues =
                            vm.mappedAssetsList[i].assetCoordinates;
                        drawPolylineForGeneratedLoc(
                            vm.mappedAssetsList[i],
                            assetCoordinateValues,
                            assetsDeployedMap,
                            "yellow"
                        );
                    }
                }

                if (vm.mappedAssetsList.length > 0) {
                    vm.workFlow.pinLat =
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude;
                    vm.workFlow.pinLong =
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude;
                    vm.workFlow.address = "";
                    if (vm.workFlow.id == null) {
                        vm.workFlow.status = "NEW";
                    }
                }
                if (vm.mappedAssetsList.length > 0) {
                    assetsDeployedMap.setCenter(
                        new google.maps.LatLng(
                            vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                            vm.mappedAssetsList[0].assetCoordinates[0].longitude
                        )
                    );
                }
                //
                //				var pointA = new google.maps.LatLng(12.917358683134225,77.62311194634297);
                //            	var pointB = new google.maps.LatLng(12.915999226925456,77.63823960497554);
                //
                //				getPointsRoute(pointA, pointB, assetsDeployedMap, 200);
            }
        };

        function handleTabClick($event) {
            $event.preventDefault();
            $event.stopImmediatePropagation();
        }

        function clearCreateAsset() {
            $("#create-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#create-asset").hide();
        }

        function createAssetModal(item) {
            vm.tempItem = item
            vm.assetExisting = false;
            if (item.name == "LINK_WITH_MH") {
                connectMultipleAssets();
            } else {
                vm.CreateAssetName = item.name;
                vm.assetNameVal = null;
                /* vm.assetLat = null;
                vm.assetLong = null; */
                vm.getLocationCoordinate = null
                $("#create-asset").show();
                createAssetData = item;
                vm.showAssetName = false;
                vm.parentAsset = null;
            }
        }

        function getConsolidatedAssetTypeAttributeValue(assetType) {
            var assetTypeAttributeValuesList = [];

            for (var index in assetType.assetTypeAttributes) {
                var assetTypeAttribute1 = assetType.assetTypeAttributes[index];
                assetTypeAttributeValuesList.push({
                    assetTypeAttribute: assetTypeAttribute1,
                    attributeValue:
                        assetType.assetTypeAttributes[index].defaultValue,
                });
            }

            assetTypeAttributeValuesList.sort(function (a, b) {
                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                    nameB = b.assetTypeAttribute.name.toLowerCase();
                if (nameA < nameB)
                    // sort string ascending
                    return -1;
                if (nameA > nameB) return 1;
                return 0; // default return value (no sorting)
            });
            return assetTypeAttributeValuesList;
        }

        function searchAssetName() {
            // vm.assetExisting = false;
            // var searchName = vm.assetNameVal;
            // vm.showAssetCreation = false;
            // if (searchName != undefined && searchName.length > 2) {
            //     WorkFlowCheckAsset.get(
            //         { name: searchName },
            //         function (checkAsset) {
            //             if (checkAsset.name == searchName) {
            //                 vm.assetExisting = true;
            //                 vm.showAssetCreation = true;
            //             } else if (vm.mappedAssetsList.length > 0) {
            //                 vm.mappedAssetsList.forEach(function (maplist) {
            //                     if (maplist.name == searchName) {
            //                         vm.assetExisting = true;
            //                         vm.showAssetCreation = true;
            //                     }
            //                 });
            //             }
            //         }
            //     );
            // }
        }

        function refreshPage() {
            if (marker != null) {
                marker.setMap(null);
            }

            initPlanningMap();

            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(
                        vm.mappedAssetsList[i],
                        assetsPlanningMap
                    );
                } else if (
                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                ) {
                    var assetCoordinateValues =
                        vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        assetsPlanningMap,
                        "yellow"
                    );
                }
            }
        }

        function createAsset() {
            var assetName = vm.assetNameVal;
            vm.assetExisting = false;
            var coOrdinate = [];
            parentSite = [];
            if (marker != null) {
                marker.setMap(null);
            }
            if (vm.parentAsset != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.parentAsset == vm.mappedAssetsList[i].name) {
                        parentSite.push(vm.mappedAssetsList[i]);
                        coOrdinate.push({
                            lat:
                                vm.mappedAssetsList[i].assetCoordinates[0]
                                    .latitude,
                            lng:
                                vm.mappedAssetsList[i].assetCoordinates[0]
                                    .longitude,
                        });
                        assetsPlanningMap = new google.maps.Map(
                            document.getElementById("map_canvas_planning"),
                            myOption(13, coOrdinate[0])
                            /* {
                                center: coOrdinate[0],
                                zoom: 13,
                                fullscreenControl: true,
                            } */
                        );
                        geoLocation(assetsPlanningMap)
                    }
                }
            } else {
               /*  assetsPlanningMap = new google.maps.Map(
                    document.getElementById("map_canvas_planning"),
                    myOption(13, latlngs)
                );
                geoLocation(assetsPlanningMap) */
            }
            if (assetName && assetName.length > 2) {
                if (!isAssetAvailable(assetName)) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (
                            vm.mappedAssetsList[i].assetType.layout == "FIXED"
                        ) {
                            createMarkerForSelectedAsset(
                                vm.mappedAssetsList[i],
                                assetsPlanningMap
                            );
                        } else if (
                            vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                        ) {
                            var assetCoordinateValues =
                                vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(
                                vm.mappedAssetsList[i],
                                assetCoordinateValues,
                                assetsPlanningMap,
                                "yellow"
                            );
                        }
                    }
                    mappedAssetTemp = {};
                    mappedAssetTemp.name = assetName;
                    mappedAssetTemp.description = assetName;
                    mappedAssetTemp.assetType = createAssetData;
                    // mappedAssetTemp.ownedBy = parentSite;
                    mappedAssetTemp.parentAsset = parentSite;
                    var date = new Date();
                    mappedAssetTemp.createDate = date.getTime();
                    mappedAssetTemp.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                        createAssetData
                    );
                    //                    createAssetData.assetTypeAttributeValues = [];
                    //                    $.each(createAssetData.assetTypeAttributes,function (key) {
                    //                            mappedAssetTemp.assetTypeAttributeValues.push({
                    //                                assetTypeAttribute: createAssetData.assetTypeAttributes[key]
                    //                            });
                    //                        });
                    //
                    if (createAssetData.layout == "SPREAD") {
                        drawingManagerSpread();
                        drawingManagerValue(
                            "polylinecomplete",
                            assetsPlanningMap,
                            false
                        );
                    } else if (createAssetData.layout == "FIXED") {
                        if (vm.getLocationCoordinate) {
                            vm.fixedArray = [];
                            var coordinates = {};
                            var latlng = vm.getLocationCoordinate.split(",");
                            coordinates.latitude = latlng[0];
                            coordinates.longitude = latlng[1];

                            vm.fixedArray.push(coordinates);
                            mappedAssetTemp.assetCoordinates = vm.fixedArray;
                            addMappedAssets(mappedAssetTemp);
                            vm.isShowing = false;
                            initPlanningMap();
                            for (
                                var i = 0;
                                i < vm.mappedAssetsList.length;
                                i++
                            ) {
                                if (
                                    vm.mappedAssetsList[i].assetType.layout ==
                                    "FIXED"
                                ) {
                                    createMarkerForSelectedAsset(
                                        vm.mappedAssetsList[i],
                                        assetsPlanningMap
                                    );
                                } else if (
                                    vm.mappedAssetsList[i].assetType.layout ==
                                    "SPREAD"
                                ) {
                                    var assetCoordinateValues =
                                        vm.mappedAssetsList[i].assetCoordinates;
                                    drawPolylineForGeneratedLoc(
                                        vm.mappedAssetsList[i],
                                        assetCoordinateValues,
                                        assetsPlanningMap,
                                        "yellow"
                                    );
                                }
                            }
                            var centerlatlng = {
                                lat: parseFloat(latlng[0]),
                                lng: parseFloat(latlng[1]),
                            };
                            assetsPlanningMap.setCenter(centerlatlng);
                        } else if (vm.parentAsset != null) {
                            // setValues();
                            drawingManagerFixed();
                            drawMarker(
                                assetsPlanningMap,
                                JSON.stringify(coOrdinate)
                            );
                        } else {
                            drawingManagerFixed();
                            drawingManagerValue("click", assetsPlanningMap);
                        }
                    }
                } else {
                    initPlanningMap();
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (
                            vm.mappedAssetsList[i].assetType.layout == "FIXED"
                        ) {
                            createMarkerForSelectedAsset(
                                vm.mappedAssetsList[i],
                                assetsPlanningMap
                            );
                        } else if (
                            vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                        ) {
                            var assetCoordinateValues =
                                vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(
                                vm.mappedAssetsList[i],
                                assetCoordinateValues,
                                assetsPlanningMap,
                                "yellow"
                            );
                        }
                    }
                }
                $("#create-asset").removeClass("in");
                $(".modal-backdrop").remove();
                $("#create-asset").hide();
            }
        }

        function initPlanningMap() {
            assetsPlanningMap = new google.maps.Map(
                document.getElementById("map_canvas_planning"),
                myOption(15, latlngs)
                /* {
                    center: {
                        lat: 5.431587,
                        lng: 101.128162,
                    },
                    zoom: 13,
                    fullscreenControl: true,
                } */
            );
            geoLocation(assetsPlanningMap)
            
            google.maps.event.addListener(assetsPlanningMap,"dblclick", function () {
                if(vm.tempItem){
                    createAssetModal(vm.tempItem)
                }
             })
            if (vm.mappedAssetsList.length > 0) {
                assetsPlanningMap.setCenter(
                    new google.maps.LatLng(
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude
                    )
                );
            }
        }

        function geoLocation(map) { 
            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(
                goTo
            ); 
            goTo.addEventListener("click", function () {
                vm.getLocationCoordinates = null
                gotoLatitute()
             }) 
        }

        
        function showZoomLocation() {
            var latlng = vm.getLocationCoordinates.split(","),gotoMarker = null;;
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinates != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };

                assetsPlanningMap.setCenter(assetCenterLatLng);
                assetsPlanningMap.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: assetsPlanningMap,
                        position: assetCenterLatLng,
                    });

                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }
        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
        }
        
        function closeGotoLatitute(id) {
            $("#"+id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#"+id).hide();
        }

        function getPointsRoute(assetA, assetB, map, dist) {
            var pointA = new google.maps.LatLng(
                assetA.assetCoordinates[0].latitude,
                assetA.assetCoordinates[0].longitude
            );
            var pointB = new google.maps.LatLng(
                assetB.assetCoordinates[0].latitude,
                assetB.assetCoordinates[0].longitude
            );

            var directionsService = new google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: pointA,
                    destination: pointB,
                    travelMode: google.maps.TravelMode.DRIVING,
                },
                function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        var route = response.routes[0];
                        var az = 0;
                        for (var i = 0; i < route.legs.length; ++i) {
                            if (route.legs[i].distance) {
                                az += route.legs[i].distance.value;
                            }
                        }
                        dist = Math.max(dist, Math.round(az / 100));
                        var markerPoints = gMilestone(route, dist);
                        var polylinePathPoints = gMilestone(route, 100);
                        var responsePaths = response.routes;
                        vm.spreadArray = [];
                        var overViewPath = route.overview_path;
                        polylinePathPoints.forEach(function (value) {
                            var coordinates = {};
                            coordinates.latitude = value.lat();
                            coordinates.longitude = value.lng();
                            vm.spreadArray.push(coordinates);
                        });
                        var newLinkAsset = {};
                        newLinkAsset.name = assetA.name + "-" + assetB.name;
                        newLinkAsset.description = newLinkAsset.name;
                        newLinkAsset.assetCoordinates = vm.spreadArray;
                        newLinkAsset.assetType = vm.linkAssetType.assetType;
                        var fiberDistance = 0.0;
                        var spreadCoordinates = newLinkAsset.assetCoordinates;
                        if (spreadCoordinates.length > 0) {
                            for (var index in spreadCoordinates) {
                                if (index > 0) {
                                    fiberDistance += distanceCal(
                                        spreadCoordinates[index].latitude,
                                        spreadCoordinates[index].longitude,
                                        spreadCoordinates[index - 1].latitude,
                                        spreadCoordinates[index - 1].longitude
                                    );
                                }
                            }
                        }
                        fiberDistance = fiberDistance.toFixed(2);
                        var spreadAV =
                            vm.linkAssetType.assetTypeAttributeValues;
                        for (
                            var spreadAssetIndex = 0;
                            spreadAssetIndex < spreadAV.length;
                            spreadAssetIndex++
                        ) {
                            if (
                                spreadAV[spreadAssetIndex].assetTypeAttribute
                                    .name === "Fiber Distance (km)"
                            ) {
                                spreadAV[
                                    spreadAssetIndex
                                ].attributeValue = fiberDistance;
                            }
                        }
                        newLinkAsset.assetTypeAttributeValues = spreadAV;
                        newLinkAsset.isChecked = true;
                        vm.tempLinkWithPits.push(newLinkAsset);
                        //drawPolylineForSelectedPath(assetA.name + "-"+ assetB.name, vm.fixedArray, map, 0);
                        markerPoints.forEach(function (point, index) {
                            var newManholeAsset = {};
                            newManholeAsset.name =
                                assetA.name +
                                "-" +
                                assetB.name +
                                " Pit" +
                                (index + 1);
                            newManholeAsset.description = newManholeAsset.name;
                            newManholeAsset.assetType =
                                vm.manholeAssetType.assetType;
                            newManholeAsset.assetTypeAttributeValues =
                                vm.manholeAssetType.assetTypeAttributeValues;
                            vm.fixedArray = [];
                            var coordinates = {};
                            coordinates.latitude = point.lat();
                            coordinates.longitude = point.lng();
                            vm.fixedArray.push(coordinates);
                            newManholeAsset.assetCoordinates = vm.fixedArray;
                            newManholeAsset.isChecked = true;
                            vm.tempLinkWithPits.push(newManholeAsset);
                        });
                        //					map.clear();
                        for (var i = 0; i < vm.tempLinkWithPits.length; i++) {
                            if (
                                vm.tempLinkWithPits[i].assetType.layout ==
                                "FIXED"
                            ) {
                                createMarkerForSelectedAsset(
                                    vm.tempLinkWithPits[i],
                                    map
                                );
                            } else if (
                                vm.tempLinkWithPits[i].assetType.layout ==
                                "SPREAD"
                            ) {
                                var assetCoordinateValues =
                                    vm.tempLinkWithPits[i].assetCoordinates;
                                drawPolylineForGeneratedLoc(
                                    vm.tempLinkWithPits[i],
                                    assetCoordinateValues,
                                    map,
                                    "yellow"
                                );
                            }
                        }
                    } else {
                        window.alert(
                            "Directions request failed due to " + status
                        );
                    }
                }
            );
        }

        function saveLinkPits() {
            vm.tempLinkWithPits.forEach(function (asset) {
                vm.mappedAssetsList.push(asset);
            });
            hideConnectMultipleAssetsModal();
        }
        function gMilestone(route, dist) {
            var path = route.overview_path;
            var geo = google.maps.geometry.spherical;
            var point = path[0];
            var distance = 0;
            var overflow = null;
            var pos = null;
            var leg = null;
            var pointsPosition = [];
            var d1 = 0;

            for (var p = 1; p < path.length; ++p) {
                leg = Math.round(geo.computeDistanceBetween(point, path[p]));
                d1 = distance + 0;
                distance += leg;
                overflow = dist - (d1 % dist);

                if (distance >= dist && leg >= overflow) {
                    if (overflow && leg >= overflow) {
                        pos = geo.computeOffset(
                            point,
                            overflow,
                            geo.computeHeading(point, path[p])
                        );
                        pointsPosition.push(pos);
                        distance -= dist;
                    }

                    while (distance >= dist) {
                        pos = geo.computeOffset(
                            point,
                            dist + overflow,
                            geo.computeHeading(point, path[p])
                        );
                        pointsPosition.push(pos);
                        distance -= dist;
                    }
                }
                point = path[p];
            }
            return pointsPosition;
        }

        function createMarkerForSelectedAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = {
                    lat: parseFloat(asset.assetCoordinates[0].latitude),
                    lng: parseFloat(asset.assetCoordinates[0].longitude),
                };
                if (asset.assetType.name == "Manhole") {
                    var iconSize = 4;
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: {
                            scaledSize: new google.maps.Size(
                                iconSize,
                                iconSize
                            ),
                            url: "content/images/green_circle.png",
                            anchor: new google.maps.Point(
                                iconSize / 2,
                                iconSize / 2
                            ),
                        },
                    });
                } else {
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: {
                            url: "content/images/yellow.png",
                        },
                        label: {
                            color: "black",
                            fontWeight: "medium",
                            fontSize: "12px",
                            text: asset.name,
                            backgroundcolor: "#ff9800",
                        },
                    });
                }
            }
        }

        function createMarkerForSiteAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = {
                    lat: parseFloat(asset.assetCoordinates[0].latitude),
                    lng: parseFloat(asset.assetCoordinates[0].longitude),
                };
                if (asset.assetType.name == "Manhole") {
                    var iconSize = 4;
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: {
                            scaledSize: new google.maps.Size(
                                iconSize,
                                iconSize
                            ),
                            url: "content/images/green_circle.png",
                            anchor: new google.maps.Point(
                                iconSize / 2,
                                iconSize / 2
                            ),
                        },
                    });
                } else {
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon:
                            "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png",
                        label: {
                            color: "black",
                            fontWeight: "medium",
                            fontSize: "12px",
                            text: asset.name,
                            backgroundcolor: "#ff9800",
                        },
                    });
                }
            }
        }

        function drawPolylineForGeneratedLoc(asset, latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];

            latlngsToDraw.forEach(function (value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var ColorValue = "#ff0000";
                if (color == "red") {
                    ColorValue = "#ff0000";
                } else if (color == "black") {
                    ColorValue = "#000000";
                } else if (color == "yellow") {
                    ColorValue = "#F4A500";
                } else {
                    ColorValue = "#208000";
                }
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue,
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(
                    polylinepath,
                    "mouseover",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var infoStr = "";
                        var otdr = "";
                        var infoWindowContent = "";
                        var assetTypeAttributeValuesList =
                            asset.assetTypeAttributeValues;
                        assetTypeAttributeValuesList.forEach(function (
                            attrValues
                        ) {
                            if (attrValues.attributeValue != undefined) {
                                vm.fiberLength = attrValues.attributeValue;
                            }
                            var home = attrValues;
                            var value = null;
                            if (home.attributeValue != undefined) {
                                value = home.attributeValue;
                            } else {
                                value = home.assetTypeAttribute.defaultValue;
                            }
                            infoStr +=
                                "<br><b>" +
                                home.assetTypeAttribute.name +
                                "</b> : " +
                                value;
                            otdr = home;

                            infoWindowContent =
                                '<div class="info_content">' +
                                "<b>" +
                                "Name" +
                                "</b> : " +
                                asset.name +
                                "<br><b>" +
                                "<hr></div><div>" +
                                infoStr +
                                "</div>";
                        });

                        var infoWindow2 = new google.maps.InfoWindow({
                            content: infoWindowContent,
                        });
                        infoWindow2.open(map);
                        infoWindow2.setPosition(event.latLng);
                        openedInfoWindow = infoWindow2;
                    }
                );
            }
        }

        function drawingManagerSpread() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYLINE,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["polyline"],
                },
                polylineOptions: {
                    fillColor: "#ffff00",
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: true,

                    editable: true,
                    zIndex: 1,
                    geodesic: true,
                },
            });
        }

        function drawingManagerFixed() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.MARKER,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["marker"],
                },
            });
        }

        function drawingManagerValue(option, map, isEdit) {
            if (option == "polylinecomplete") {
                vm.isShowing = false;
                google.maps.event.addListener(
                    vm.drawingManager,
                    option,
                    function (event) {
                        google.maps.event.addListener(
                            event.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(event, isEdit);
                            }
                        );
                        google.maps.event.addListener(
                            event.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(event, isEdit);
                            }
                        );
                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                        setGoefenceCoordinate(event, isEdit);
                        if (mappedAssetTemp.assetType.layout == "SPREAD") {
                            var fiberDistance = 0.0;
                            var spreadCoordinates =
                                mappedAssetTemp.assetCoordinates;
                            if (spreadCoordinates.length > 0) {
                                for (var index in spreadCoordinates) {
                                    if (index > 0) {
                                        fiberDistance += distanceCal(
                                            spreadCoordinates[index].latitude,
                                            spreadCoordinates[index].longitude,
                                            spreadCoordinates[index - 1]
                                                .latitude,
                                            spreadCoordinates[index - 1]
                                                .longitude
                                        );
                                    }
                                }
                            }
                            fiberDistance = fiberDistance.toFixed(2);
                            var spreadAV =
                                mappedAssetTemp.assetTypeAttributeValues;
                            for (
                                var spreadAssetIndex = 0;
                                spreadAssetIndex < spreadAV.length;
                                spreadAssetIndex++
                            ) {
                                if (
                                    spreadAV[spreadAssetIndex]
                                        .assetTypeAttribute.name ===
                                    "Fiber Distance (km)"
                                ) {
                                    spreadAV[
                                        spreadAssetIndex
                                    ].attributeValue = fiberDistance;
                                }
                            }
                            mappedAssetTemp.assetTypeAttributeValues = spreadAV;
                        }
                        addMappedAssets(mappedAssetTemp);
                    }
                );
                vm.drawingManager.setMap(map);
            } else if (option == "click") {
                vm.isShowing = false;
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                });

                google.maps.event.addListener(map, "click", function (e) {
                    placeMarker(e.latLng, map);
                    vm.fixedArray = [];
                    var coordinates = {};
                    coordinates.latitude = e.latLng.lat();
                    coordinates.longitude = e.latLng.lng();
                    vm.fixedArray.push(coordinates);
                    mappedAssetTemp.assetCoordinates = vm.fixedArray;
                    addMappedAssets(mappedAssetTemp);
                });
            }
        }

        function placeMarker(location, map) {
            if (marker) {
                if (location.lat != null && location.lng != null) {
                    marker.setPosition(location);
                }
            } else {
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                });
            }
        }

        function addMappedAssets(newAsset) {
            if (!isAssetAvailable(newAsset.name)) {
                newAsset.isChecked = true;
                vm.mappedAssetsList.push(newAsset);
            }
            // initPlanningMap();
            // for (var i = 0; i < vm.mappedAssetsList.length; i++) {
            //     if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
            //         createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
            //     } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
            //         var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
            //         drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
            //     }
            // }
        }

        function isAssetAvailable(assetName) {
            var isAssetAvailable = false;

            vm.mappedAssetsList.forEach(function (assetVal) {
                if (assetVal.name === assetName) {
                    isAssetAvailable = true;
                }
            });
            return isAssetAvailable;
        }

        function selectedWorkFlowTypeAttributes() {
            if (vm.workFlowType) {
                vm.workFlow.workFlowType = vm.workFlowType;
                if (
                    entity_old.workFlowType &&
                    vm.workFlowType.id === entity_old.workFlowType.id
                ) {
                    vm.workFlow.workFlowTypeAttributeValues = [];
                    vm.workFlow.workFlowTypeAttributeValues =
                        entity_old.workFlowTypeAttributeValues;
                } else {
                    vm.workFlow.workFlowTypeAttributeValues = [];
                    $.each(
                        vm.workFlowType.workFlowTypeAttribute,
                        function (key, value) {
                            vm.workFlow.workFlowTypeAttributeValues.push({
                                workFlowTypeAttribute:
                                    vm.workFlowType.workFlowTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        function deleteAssetModal(name) {
            $("#delete-asset").show();
            deleteAssetName = name;
        }

        function confirmDeleteAsset() {
            var assetArray = vm.mappedAssetsList;
            for (var i = assetArray.length - 1; i >= 0; --i) {
                if (assetArray[i].name == deleteAssetName) {
                    vm.deletedAssetsList.push(assetArray[i]);
                    assetArray.splice(i, 1);
                }
            }
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(
                        vm.mappedAssetsList[i],
                        assetsPlanningMap
                    );
                } else if (
                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                ) {
                    var assetCoordinateValues =
                        vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        assetsPlanningMap,
                        "yellow"
                    );
                }
            }
            vm.mappedAssetsList = [];
            assetArray.forEach(function (asset) {
                vm.mappedAssetsList.push(asset);
            });
            $("#delete-asset").hide();
        }

        function cleardeleteAsset() {
            $("#delete-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#delete-asset").hide();
        }

        function setGoefenceCoordinate(event, isEdit) {
            vm.assetCoordinateValues = [];
            var tempAsset = {};
            tempAsset.assetCoordinates = [];
            var radius = event.getPath();
            for (var i = 0; i < radius.getLength(); i++) {
                var coordinates = {};
                coordinates.latitude = radius.getAt(i).lat();
                coordinates.longitude = radius.getAt(i).lng();
                tempAsset.assetCoordinates.push(coordinates);
            }
            if (isEdit) {
                vm.asset.assetCoordinates = tempAsset.assetCoordinates;
            } else {
                mappedAssetTemp.assetCoordinates = tempAsset.assetCoordinates;
            }
        }

        function saveEditAsset() {
            //vm.tempAssetArray.push(vm.asset);
            vm.mappedAssetsList = [];
            vm.tempAssetArray.forEach(function (assetVal) {
                vm.mappedAssetsList.push(assetVal);
            });
            vm.asset = [];
            vm.tempAssetArray = [];
            hideUserEditModal();
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(
                        vm.mappedAssetsList[i],
                        assetsPlanningMap
                    );
                } else if (
                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                ) {
                    var assetCoordinateValues =
                        vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        assetsPlanningMap,
                        "yellow"
                    );
                }
            }
        }

        function hideUserEditModal() {
            $("#userPathModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#userPathModal").hide();
        }

        function editAsset(asset) {
            vm.tempAssetArray = [];

            vm.mappedAssetsList.forEach(function (assetVal) {
                vm.tempAssetArray.push(assetVal);
            });
            for (var i = 0; i >= vm.tempAssetArray.length; --i) {
                if (vm.tempAssetArray[i].name == asset.name) {
                    vm.tempAssetArray.splice(i, 1);
                }
            }

            vm.asset = asset;
            var maplatlng = {
                lat: parseFloat(asset.assetCoordinates[0].latitude),
                lng: parseFloat(asset.assetCoordinates[0].longitude),
            };
            editAssetMap = new google.maps.Map(
                document.getElementById("map_canvas_edit_asset"),
                myOption(13, maplatlng)
                /* {
                    center: maplatlng,
                    zoom: 13,
                    fullscreenControl: true,
                } */
            );

            if (asset.assetType.layout == "SPREAD") {
                drawingManagerSpread();
                drawingManagerValue("polylinecomplete", editAssetMap);
            } else if (asset.assetType.layout == "FIXED") {
                drawingManagerFixed();
                drawingManagerValue("click", editAssetMap);
            }
            if (asset.name && asset.name != null) {
                if (asset.assetType.layout == "SPREAD") {
                    drawPolyline(function (polyline) {
                        polyline.setMap(editAssetMap);
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(polyline, true);
                            }
                        );
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(polyline, true);
                            }
                        );

                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                    });
                } else if (asset.assetType.layout == "FIXED") {
                    setValues();
                    drawingManagerFixed();
                    drawMarker(editAssetMap, vm.coOrdinate);
                }

                function drawPolyline(callback) {
                    setValues();
                    var centerlatlng = {};
                    if (vm.coOrdinates.length > 1) {
                        vm.coOrdinates.forEach(function (value) {
                            centerlatlng = {
                                lat: value.lat,
                                lng: value.lng,
                            };
                        });

                        callback(
                            new google.maps.Polyline({
                                path: vm.coOrdinates,
                                geodesic: true,
                                strokeColor: vm.asset.assetType.colorcode,
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: vm.asset.assetType.colorcode,
                                fillOpacity: 0.3,
                                editable: true,
                            })
                        );
                        editAssetMap.setCenter(centerlatlng);
                    }
                }
            }
            var ele = document.getElementById("userPathModal");
            $(ele).modal("show");
            $("#userPathModal").show();

            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_edit_asset").css("width", "100%");
        }

        function hideConnectAssetsModal() {
            $("#connectAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectAssetsModal").hide();
        }

        function hideConnectSitesModal() {
            $("#connectAssetsModal").hide();
        }

        var input = document.getElementById('field_pinLat');
            input.addEventListener('input', function() {
            this.value = this.value.replace(/[^-0-9\,\.]/, '');
            });
        
        $('#spreadType').select2({
            dropdownParent: $('#connectAssetsModal')
          });

        function connectSelectedAssets() {
            var ele = document.getElementById("connectAssetsModal");
            $(ele).modal("show");
            $("#connectAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_assets").css("width", "100%");
        }

        function hideConnectMultipleAssetsModal() {
            $("#connectMultipleAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectMultipleAssetsModal").hide();
            vm.tempLinkWithPits = [];
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(
                        vm.mappedAssetsList[i],
                        assetsPlanningMap
                    );
                } else if (
                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                ) {
                    var assetCoordinateValues =
                        vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        assetsPlanningMap,
                        "yellow"
                    );
                }
            }
        }

        function connectMultipleAssets() {
            vm.siteAssets = [];
            vm.tempLinkWithPits = [];

            var ele = document.getElementById("connectMultipleAssetsModal");
            $(ele).modal("show");
            $("#connectMultipleAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_multiple_assets").css("width", "100%");
            var multipleSiteMap = new google.maps.Map(
                document.getElementById("map_canvas_connect_multiple_assets"),
                {
                    center: new google.maps.LatLng(
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude
                    ),
                    zoom: 12,
                    fullscreenControl: true,
                }
            );
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (
                    vm.mappedAssetsList[i].assetType.layout == "FIXED" &&
                    vm.mappedAssetsList[i].assetType.name == "Site" &&
                    vm.mappedAssetsList[i].id == null
                ) {
                    vm.siteAssets.push(vm.mappedAssetsList[i]);
                    createMarkerForSiteAsset(
                        vm.mappedAssetsList[i],
                        multipleSiteMap
                    );
                }
            }

            vm.siteAssets.sort(function (assetA, assetB) {
                var assetATime = assetA.createDate,
                    assetBTime = assetB.createDate;
                if (assetATime < assetBTime)
                    // sort string ascending
                    return -1;
                if (assetATime > assetBTime) return 1;
                return 0; // default return value (no sorting)
            });
            for (
                var siteIndex = 1;
                siteIndex < vm.siteAssets.length;
                siteIndex++
            ) {
                getPointsRoute(
                    vm.siteAssets[siteIndex - 1],
                    vm.siteAssets[siteIndex],
                    multipleSiteMap,
                    200
                );
            }
        }

        function recalculate() {
            var totalCost = 0;
            var totalPowerBudget = 0;
            var totalFiberDistance = 0.0;
            for (
                var assetIndex = 0;
                assetIndex < vm.mappedAssetsList.length;
                assetIndex++
            ) {
                var isSpread = false;
                var fiberDistance = 0.0;

                if (
                    vm.mappedAssetsList[assetIndex].assetType.layout == "SPREAD"
                ) {
                    isSpread = true;
                    var spreadAV =
                        vm.mappedAssetsList[assetIndex]
                            .assetTypeAttributeValues;
                    for (
                        var spreadAssetIndex = 0;
                        spreadAssetIndex < spreadAV.length;
                        spreadAssetIndex++
                    ) {
                        if (
                            spreadAV[spreadAssetIndex].assetTypeAttribute
                                .name === "Fiber Distance (km)"
                        ) {
                            fiberDistance = parseFloat(
                                "0" + spreadAV[spreadAssetIndex].attributeValue
                            );
                        }
                    }
                }

                for (
                    var attrIndex = 0;
                    attrIndex <
                    vm.mappedAssetsList[assetIndex].assetTypeAttributeValues
                        .length;
                    attrIndex++
                ) {
                    var item =
                        vm.mappedAssetsList[assetIndex]
                            .assetTypeAttributeValues[attrIndex];
                    var value = parseFloat(
                        item.assetTypeAttribute.defaultValue
                    );

                    if (item.assetTypeAttribute.name == "Cost") {
                        var tempCost = parseFloat(value);
                        if (isSpread) {
                            tempCost = parseFloat(value) * fiberDistance;
                        }
                        if (tempCost > 0) {
                            totalCost += tempCost;
                        }
                        item.attributeValue = value;
                    }
                    if (item.assetTypeAttribute.name == "Power Budget") {
                        var tempPowerBudget = parseFloat(value);
                        if (isSpread) {
                            tempPowerBudget = parseFloat(value) * fiberDistance;
                        }
                        if (tempPowerBudget > 0) {
                            totalPowerBudget += tempPowerBudget;
                        }
                        item.attributeValue = value;
                    }
                    vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[
                        attrIndex
                    ] = item;
                }
                totalFiberDistance += fiberDistance;
            }

            var workFlowAV = vm.workFlow.workFlowTypeAttributeValues;
            for (
                var workFlowIndex = 0;
                workFlowIndex < workFlowAV.length;
                workFlowIndex++
            ) {
                if (
                    workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                    "Cost"
                ) {
                    workFlowAV[
                        workFlowIndex
                    ].attributeValue = totalCost.toFixed(2);
                }
                if (
                    workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                    "Power Budget"
                ) {
                    workFlowAV[
                        workFlowIndex
                    ].attributeValue = totalPowerBudget.toFixed(2);
                }
                if (
                    workFlowAV[workFlowIndex].workFlowTypeAttribute.name ===
                    "Fiber Distance"
                ) {
                    workFlowAV[
                        workFlowIndex
                    ].attributeValue = totalFiberDistance.toFixed(2);
                }
            }
            vm.workFlow.workFlowTypeAttributeValues = workFlowAV;
        }

        function connectAssets() {
            if (vm.isSiteASelected == false && vm.isSiteBSelected == false) {
                alert("Please Select Site A");
            } else if (
                vm.isSiteASelected == true &&
                vm.isSiteBSelected == false
            ) {
                alert("Please Select Site B");
            } else {
                var siteALatLng = new google.maps.LatLng(
                    vm.selectedSiteA.assetCoordinates[0].latitude,
                    vm.selectedSiteA.assetCoordinates[0].longitude
                );
                var siteBLatLng = new google.maps.LatLng(
                    vm.selectedSiteB.assetCoordinates[0].latitude,
                    vm.selectedSiteB.assetCoordinates[0].longitude
                );
                var map = new google.maps.Map(
                    document.getElementById("map_canvas_connect_assets"),
                    myOption(16, siteALatLng)
                    /* {
                        center: siteALatLng,
                        zoom: 16,
                        fullscreenControl: true,
                    } */
                );
                createMarker(map, vm.selectedSiteA.name, siteALatLng);
                createMarker(map, vm.selectedSiteB.name, siteBLatLng);

                getShortestRoute(vm.selectedSiteA, vm.selectedSiteB, map);
            }
        }

        function setValues() {
            vm.coOrdinates = [];
            for (var i = 0; i < vm.asset.assetCoordinates.length; i++) {
                vm.coOrdinates.push({
                    lat: vm.asset.assetCoordinates[i].latitude,
                    lng: vm.asset.assetCoordinates[i].longitude,
                });
                if (i == vm.asset.assetCoordinates.length - 1) {
                    vm.coOrdinate = JSON.stringify(vm.coOrdinates);
                }
            }
        }

        $("#fromAssetsView").change(function () {
            $("#toAssetsView")[0].selectedIndex = 0;
            var result = $("#fromAssetsView").val();
            if (result != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].name == result) {
                        vm.selectedSiteA = vm.mappedAssetsList[i];
                    }
                }
                vm.isSiteASelected = true;
            }
        });

        $("#toAssetsView").change(function () {
            if (vm.isSiteASelected == true) {
                var result = $("#toAssetsView").val();
                if (result != null) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].name == result) {
                            vm.selectedSiteB = vm.mappedAssetsList[i];
                        }
                    }
                    vm.isSiteBSelected = true;
                }
            } else {
                $("#toAssetsView")[0].selectedIndex = 0;
                alert("Please Select Site A");
            }
        });

        function createMarker(map, assetName, myLatLng) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: {
                    scaledSize: new google.maps.Size(24, 24),
                    origin: new google.maps.Point(0, 0),
                    url: "content/images/yellow.png",
                    anchor: new google.maps.Point(16, 16),
                },
                label: {
                    color: "black",
                    fontWeight: "medium",
                    fontSize: "12px",
                    text: assetName,
                    backgroundcolor: "#ff9800",
                },
            });
        }

        function drawMarker(map, response) {
            $.each(JSON.parse(response), function (index, value) {
                centerlatlng = {
                    lat: value.lat,
                    lng: value.lng,
                };

                if (marker) {
                    marker.setMap(null);
                }
                marker = new google.maps.Marker({
                    position: centerlatlng,
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(16, 16),
                    },
                });

                marker.setMap(map);
                vm.fixedArray = [];
                var coordinates = {};
                coordinates.latitude = centerlatlng.lat;
                coordinates.longitude = centerlatlng.lng;
                vm.fixedArray.push(coordinates);
                mappedAssetTemp.assetCoordinates = vm.fixedArray;
                //addMappedAssets(mappedAssetTemp);
            });
        }

        function getShortestRoute(SiteA, SiteB, map) {
            var pointA = new google.maps.LatLng(
                SiteA.assetCoordinates[0].latitude,
                SiteA.assetCoordinates[0].longitude
            );
            var pointB = new google.maps.LatLng(
                SiteB.assetCoordinates[0].latitude,
                SiteB.assetCoordinates[0].longitude
            );

            var newAsset = {
                name: "",
                assetCoordinates: [],
            };
            newAsset.name = SiteA.name + "-" + SiteB.name;

            var directionsService = new google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: pointA,
                    destination: pointB,
                    avoidTolls: true,
                    avoidHighways: false,
                    provideRouteAlternatives: true,
                    travelMode: google.maps.TravelMode.DRIVING,
                },
                function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = response.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                vm.fixedArray = [];
                                var route = pathVal;
                                var legs = route.legs;
                                
                                var polylinePathPoints = [];
                                for (var i = 0; i < legs.length; i++) {
                                    var steps = legs[i].steps;
                                    for (var j = 0; j < steps.length; j++) {
                                        var nextSegment = steps[j].path;
                                        for (
                                            var k = 0;
                                            k < nextSegment.length;
                                            k++
                                        ) {
                                            polylinePathPoints.push(
                                                nextSegment[k]
                                            );
                                        }
                                    }
                                }
                                // var az = 0;
                                // for (var i = 0; i < route.legs.length; ++i) {
                                //     if (route.legs[i].distance) {
                                //         az += route.legs[i].distance.value;
                                //     }
                                // }
                                // var polylinePathPoints = gMilestone(route, 100);
                                //                            var overViewPath = pathVal.overview_path;
                                polylinePathPoints.forEach(function (value) {
                                    var coordinates = {};
                                    coordinates.lat = value.lat();
                                    coordinates.lng = value.lng();
                                    vm.fixedArray.push(coordinates);
                                });
                                drawPolylineForSelectedPath(
                                    SiteA.name + "-" + SiteB.name,
                                    vm.fixedArray,
                                    map,
                                    index
                                );
                            }
                        });
                    } else {
                        window.alert(
                            "Directions request failed due to " + status
                        );
                    }
                }
            );
            return newAsset;
        }

        function drawPolylineForSelectedPath(
            assetName,
            spreadAssetCoordinates,
            map,
            index
        ) {
            if (spreadAssetCoordinates.length > 0) {
                map.setZoom(14);

                var ColorValue = "#ff0000";
                if (index == 0) {
                    ColorValue = "#ff0000";
                } else if (index == 1) {
                    ColorValue = "#000000";
                } else {
                    ColorValue = "#208000";
                }

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue,
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(
                    polylinepath,
                    "mouseover",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var pointContent = document.createElement("div"),
                            button;

                        pointContent.innerHTML =
                            '<div class="infoWindowhead">Point ' +
                            (index + 1) +
                            "</div>";
                        button = pointContent.appendChild(
                            document.createElement("input")
                        );
                        button.type = "button";
                        button.value = "Click to select";
                        button.className = "button";
                        google.maps.event.addDomListener(
                            button,
                            "click",
                            function () {
                                var newAsset = {};
                                newAsset.name = assetName;
                                newAsset.assetCoordinates = [];
                                spreadAssetCoordinates.forEach(function (
                                    assetCoor
                                ) {
                                    newAsset.assetCoordinates.push({
                                        latitude: assetCoor.lat,
                                        longitude: assetCoor.lng,
                                    });
                                });

                                    vm.assetTypeResponse.forEach(function (item) {
                                            if(item.name == vm.selectedAssetType){
                                                vm.isShowing = false;
                                            newAsset.assetType = item;
                                            newAsset.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                                newAsset.assetType
                                            );
                                            //	                                $.each(newAsset.assetType.assetTypeAttributes,function(key, value) {
                                            //	                                    newAsset.assetTypeAttributeValues.push({
                                            //	                                            assetTypeAttribute: newAsset.assetType.assetTypeAttributes[key]
                                            //	                                        });
                                            //	                                });
                                            if (
                                                newAsset.assetType.layout ==
                                                "SPREAD"
                                            ) {
                                                var fiberDistance = 0.0;
                                                var spreadCoordinates =
                                                    newAsset.assetCoordinates;
                                                if (
                                                    spreadCoordinates.length > 0
                                                ) {
                                                    for (var index in spreadCoordinates) {
                                                        if (index > 0) {
                                                            fiberDistance += distanceCal(
                                                                spreadCoordinates[
                                                                    index
                                                                ].latitude,
                                                                spreadCoordinates[
                                                                    index
                                                                ].longitude,
                                                                spreadCoordinates[
                                                                    index - 1
                                                                ].latitude,
                                                                spreadCoordinates[
                                                                    index - 1
                                                                ].longitude
                                                            );
                                                        }
                                                    }
                                                }
                                                fiberDistance = fiberDistance.toFixed(
                                                    2
                                                );
                                                var spreadAV =
                                                    newAsset.assetTypeAttributeValues;
                                                for (
                                                    var spreadAssetIndex = 0;
                                                    spreadAssetIndex <
                                                    spreadAV.length;
                                                    spreadAssetIndex++
                                                ) {
                                                    if (
                                                        spreadAV[
                                                            spreadAssetIndex
                                                        ].assetTypeAttribute
                                                            .name ===
                                                        "Fiber Distance (km)"
                                                    ) {
                                                        spreadAV[
                                                            spreadAssetIndex
                                                        ].attributeValue = fiberDistance;
                                                    }
                                                }
                                                newAsset.assetTypeAttributeValues = spreadAV;
                                            }
                                            newAsset.isChecked = true;
                                            vm.mappedAssetsList.push(newAsset);
                                            initPlanningMap();
                                            for (
                                                var i = 0;
                                                i < vm.mappedAssetsList.length;
                                                i++
                                            ) {
                                                if (
                                                    vm.mappedAssetsList[i]
                                                        .assetType.layout ==
                                                    "FIXED"
                                                ) {
                                                    createMarkerForSelectedAsset(
                                                        vm.mappedAssetsList[i],
                                                        assetsPlanningMap
                                                    );
                                                } else if (
                                                    vm.mappedAssetsList[i]
                                                        .assetType.layout ==
                                                    "SPREAD"
                                                ) {
                                                    var assetCoordinateValues =
                                                        vm.mappedAssetsList[i]
                                                            .assetCoordinates;
                                                    drawPolylineForGeneratedLoc(
                                                        vm.mappedAssetsList[i],
                                                        assetCoordinateValues,
                                                        assetsPlanningMap,
                                                        "yellow"
                                                    );
                                                }
                                            }
                                        
                                            }
                                    });
                                
                                hideConnectAssetsModal();
                            }
                        );

                        var infoWindow2 = new google.maps.InfoWindow({
                            content: pointContent,
                        });
                        infoWindow2.open(map);
                        infoWindow2.setPosition(event.latLng);
                        openedInfoWindow = infoWindow2;
                    }
                );
            }
        }

        function save() {
            vm.isShowing = false;
            vm.workFlow.workFlowAssets = [];
            vm.workFlow.deletedAssets = [];

            vm.mappedAssetsList.forEach(function (workFlowAssetVal) {
                // workFlowAssetVal.phase = vm.workFlow.phase
                if (workFlowAssetVal.isChecked) {
                    vm.workFlow.workFlowAssets.push(workFlowAssetVal);
                }
            });

            vm.deletedAssetsList.forEach(function (asset) {
                vm.workFlow.deletedAssets.push(asset);
            });

            if (vm.workFlow.workFlowAssets.length > 0) {
                vm.isShowing = true;
                vm.isSaving = true;
                var assignedToUser = $("#field_assignedToUser").val();
                vm.workFlow.assignedTo = usersMap[assignedToUser];
                angular.forEach(vm.assetList, function (value, key) {
                    if (vm.workFlow.asset.name === value.name) {
                        vm.workFlow.asset = value;
                    }
                });

                if (vm.workFlow.id !== null) {
                    WorkFlow.update(vm.workFlow, onSaveSuccess, onSaveError);
                } else {
                    WorkFlow.save(vm.workFlow, onSaveSuccess, onSaveError);
                }
            } else {
                alert("No assets are mapped to this work flow");
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:workFlowUpdate", result);
            $state.go("work-flow");
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function selectedGroup(value) {
            var input = document.getElementById("field_assignedToUser");
            input.value = "";
            vm.hideUser = false;
        }
        function filterActivatedUser() {
            if (
                vm.workFlow.assignedToUser != null &&
                vm.workFlow.assignedToUser != "" &&
                vm.workFlow.assignedToUser != "." &&
                !angular.isUndefined(vm.workFlow.assignedToUser)
            ) {
                $('input[name="assignedToUser"]').keyup(function () {
                    vm.user = $(this).val();
                });
                ActivatedUserSearch.query(
                    {
                        // userId: vm.workFlow.assignedToUser,
                        userId: vm.workFlow.groups[0].id,
                        user: vm.user,
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    data.forEach(function (users) {
                        vm.assignedUsers.push(users.login);
                    });
                    vm.activatedusers = data;

                    angular.forEach(vm.activatedusers, function (value, key) {
                        usersMap[value.login] = value.id;
                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                    Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                    Math.cos(degrees_to_radians(lat2)) *
                    Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }
        $(document).on("change", "input", function () {
            var options = $("datalist")[0].options;
            for (var i = 0; i < options.length; i++) {
                if (options[i].value == $(this).val()) {
                    if (vm.assignedUsers.includes($(this).val())) {
                        vm.validUser = false;
                    } else {
                        vm.validUser = true;
                    }
                    break;
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowDetailController", WorkFlowDetailController);

    WorkFlowDetailController.$inject = [
        "$scope",
        "$rootScope",
        "previousState",
        "entity",
        "$window",
        "Configs"
    ];

    function WorkFlowDetailController(
        $scope,
        $rootScope,
        previousState,
        entity,
        $window,
        Configs
    ) {
        var vm = this;

        vm.workFlow = entity;
        vm.previousState = previousState.name;
        Configs.get("WorkFlowStatus", function (response) {
            response.forEach(function (status) {
                if (status.configKey == vm.workFlow.status) {
                    vm.workFlow.status = status.configValue;
                }
            });
        });
        var unsubscribe = $rootScope.$on(
            "trakeyeApp:workFlowUpdate",
            function (event, result) {
                vm.workFlow = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowDeleteController", WorkFlowDeleteController);

    WorkFlowDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "WorkFlow",
    ];

    function WorkFlowDeleteController($uibModalInstance, entity, WorkFlow) {
        var vm = this;

        vm.workFlow = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            WorkFlow.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("work-flow", {
                parent: "entity",
                url: "/work-flow?page&sort&search",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workFlow.home.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/work-flow/work-flows.html",
                        controller: "WorkFlowController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlow");
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("work-flow-detail", {
                parent: "work-flow",
                url: "/work-flow/{id}",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: "trakeyeApp.workFlow.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow/work-flow-detail.html",
                        controller: "WorkFlowDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("workFlow");
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "WorkFlow",
                        function ($stateParams, WorkFlow) {
                            return WorkFlow.get({ id: $stateParams.id })
                                .$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "work-flow",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("work-flow.new", {
                url: "/work-flow",
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/work-flow/work-flow-dialog.html",
                        controller: "WorkFlowDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                description: $stateParams.desc,
                                createDate: null,
                                updateDate: null,
                                pinLat: parseFloat($stateParams.lat),
                                pinLong: parseFloat($stateParams.lng),
                                address: null,
                                escalated: null,
                                status: null,
                                id: null,
                                caseImages: [],
                            };
                        },
                    ],
                },
            })
            .state('work-flow.edit', {
                parent: 'work-flow',
                url: '/Edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_INFRA', 'ROLE_PLAN_SURVEY', 'ROLE_ROLLOUT_ADMIN', 'ROLE_ROLLOUT_INFRA', 'ROLE_ROLLOUT_SURVEY'],
                    pageTitle: 'trakeyeApp.workFlow.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/work-flow/work-flow-dialog.html',
                        controller: 'WorkFlowDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'WorkFlow', function ($stateParams, WorkFlow) {
                        return WorkFlow.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'work-flow',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state("work-flow.delete", {
                parent: "work-flow",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/work-flow/work-flow-delete-dialog.html",
                                controller: "WorkFlowDeleteController",
                                controllerAs: "vm",
                                size: "md",
                                resolve: {
                                    entity: [
                                        "WorkFlow",
                                        function (WorkFlow) {
                                            return WorkFlow.get({
                                                id: $stateParams.id,
                                            }).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go("work-flow", null, {
                                        reload: "work-flow",
                                    });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkFlow", WorkFlow);

    WorkFlow.$inject = ["$resource", "DateUtils"];

    function WorkFlow($resource, DateUtils) {
        var resourceUrl = "api/work-flows/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("WorkFlowCheckAsset", WorkFlowCheckAsset);

    WorkFlowCheckAsset.$inject = ["$resource", "DateUtils"];

    function WorkFlowCheckAsset($resource, DateUtils) {
        var resourceUrl = "api/assets/search/:name";

        return $resource(
            resourceUrl,
            {},
            {
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllWorkFlowTypes", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http.get("api/work-flow-types").then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();


(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrUnresolvedGroupWorkFlowForMap', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAllWorkFlows = function(callback) {
			$http.get('api/unresolvedgroupworkflowsformap').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

// (function() {
// 	'use strict';

// 	angular.module('trakeyeApp').factory('UnresolvedLocGroupWorkFlowForMap', UnresolvedLocGroupWorkFlowForMap);

// 	UnresolvedLocGroupWorkFlowForMap.$inject = [ '$resource' ];

// 	function UnresolvedLocGroupWorkFlowForMap($resource) {
// 		var service = $resource('/api/unresolvedgroupbasednearestworkflowsformap/:lat/:lng/:dis', {},{},{},{}, {
// 			'query' : {
// 				method : 'GET',
// 				isArray : true
// 			},
// 		});

// 		return service;
// 	}

// })();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('UnresolvedLocGroupWorkFlowForMap', UnresolvedLocGroupWorkFlowForMap);

	UnresolvedLocGroupWorkFlowForMap.$inject = ['$resource'];

	function UnresolvedLocGroupWorkFlowForMap($resource) {
		var service = $resource('/api/unresolvedgroupbasednearestworkflowsformap/:lat/:lng/:dis', {
			lat: '@lat',
            lng: '@lng',
			dis: '@dis'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('WorkFlowById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/work-flows/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('WorkFlowSearch', WorkFlowSearch);

	WorkFlowSearch.$inject = ['$resource'];

	function WorkFlowSearch($resource) {
		var service = $resource('/api/work-flows/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("WorkFlowController", WorkFlowController);

    WorkFlowController.$inject = [
        "$state",
        "$scope",
        "$stateParams",
        "WorkFlow",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "WorkFlowSearch",
        "Configs"
    ];

    function WorkFlowController(
        $state,
        $scope,
        $stateParams,
        WorkFlow,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        WorkFlowSearch,
        Configs
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterWorkFlowSearch = filterWorkFlowSearch;
        
        loadAll();

        function loadAll() {
            WorkFlow.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                var tempWorkFlows = data;
                vm.workFlows = [];
                vm.page = pagingParams.page;
                Configs.get("WorkFlowStatus", function (response) {
                    tempWorkFlows.forEach(function (val) {
                        response.forEach(function (status) {
                            if (status.configKey == val.status) {
                                val.status = status.configValue;
                            }
                        });
                        val.workFlowTypeAttributeValues.forEach(function (item) {
                            if (item.name == "Fiber Distance")
                                val.distance = item.attributeValue
                        })
                        vm.workFlows.push(val);
                    });
                });

            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function filterWorkFlowSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                
                WorkFlowSearch.query(
                    {
                        search: $scope.search,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );

                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    var tempWorkFlows = data;
                    vm.workFlows = [];
                    vm.page = pagingParams.page;
                    tempWorkFlows.forEach(function (val){
                        val.workFlowTypeAttributeValues.forEach(function (item){
                            if(item.name == "Fiber Distance")
                            val.distance = item.attributeValue
                         })
                         vm.workFlows.push(val);
                    });
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrWorkOrderTypeDialogController", TrWorkOrderTypeDialogController);

    TrWorkOrderTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "TrWorkOrderType",
        "User",
        "TrWorkOrderTypeSearch",
        "AllCustomTrWorkOrderTypeAttribute",
    ];

    
    function TrWorkOrderTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        TrWorkOrderType,
        User,
        TrWorkOrderTypeSearch,
        AllCustomTrWorkOrderTypeAttribute
    ) {
        var vm = this;
        //trWorkOrdertype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.trWorkOrderType = entity;
        vm.trWorkOrderTypeImageName = trWorkOrderTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customTrWorkOrderTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function trWorkOrderTypeImageName(image) {
            vm.trWorkOrderType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomTrWorkOrderTypeAttribute.getAll(function (response) {
                vm.customTrWorkOrderTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customTrWorkOrderTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.trWorkOrderType.trWorkOrderTypeAttribute != null &&
            vm.trWorkOrderType.trWorkOrderTypeAttribute.length != 0
        ) {
            vm.items = vm.trWorkOrderType.trWorkOrderTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.trWorkOrderCategory == null) {
                value.trWorkOrderCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.trWorkOrderType.id !== null) {
                vm.trWorkOrderType.trWorkOrderTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.trWorkOrderType.trWorkOrderTypeAttribute.push({
                        trWorkOrderCategory: vm.items[i].trWorkOrderCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        trWorkOrderTypeAttribOrder: vm.items[i].trWorkOrderTypeAttribOrder
                    });
                }
                TrWorkOrderType.update(vm.trWorkOrderType, onSaveSuccess, onSaveError);
            } else {
                vm.trWorkOrderType.trWorkOrderTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.trWorkOrderType.trWorkOrderTypeAttribute.push({
                        trWorkOrderCategory: vm.items[i].trWorkOrderCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        trWorkOrderTypeAttribOrder: vm.items[i].trWorkOrderTypeAttribOrder
                    });
                }
                TrWorkOrderType.save(vm.trWorkOrderType, onSaveSuccess, onSaveError);
            }
        }

        $("#trWorkOrderTypeImage").change(function () {
            var filesSelected = document.getElementById("trWorkOrderTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.trWorkOrderType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:trWorkOrderTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("trworkorder-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrWorkOrderTypeDetailController', TrWorkOrderTypeDetailController);

    TrWorkOrderTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrWorkOrderType', 'User'];

    function TrWorkOrderTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TrWorkOrderType, User) {
        var vm = this;

        vm.trWorkOrderType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:trWorkOrderTypeUpdate', function(event, result) {
            vm.trWorkOrderType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrWorkOrderTypeDeleteController',TrWorkOrderTypeDeleteController);

    TrWorkOrderTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrWorkOrderType'];

    function TrWorkOrderTypeDeleteController($uibModalInstance, entity, TrWorkOrderType) {
        var vm = this;

        vm.trWorkOrderType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TrWorkOrderType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trworkorder-type', {
            parent: 'entity',
            url: '/trworkorder-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.trWorkOrderType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trworkorder-type/trworkorder-types.html',
                    controller: 'TrWorkOrderTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trWorkOrderType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trworkorder-type-detail', {
            parent: 'trworkorder-type',
            url: '/trworkorder-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.trWorkOrderType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trworkorder-type/trworkorder-type-detail.html',
                    controller: 'TrWorkOrderTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trWorkOrderType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrWorkOrderType', function($stateParams, TrWorkOrderType) {
                    return TrWorkOrderType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trworkorder-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('trworkorder-type.new', {
            parent: 'trworkorder-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/trworkorder-type/trworkorder-type-dialog.html',
                    controller: 'TrWorkOrderTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('trworkorder-type.edit', {
            parent: 'trworkorder-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.trWorkOrderType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trworkorder-type/trworkorder-type-dialog.html',
                    controller: 'TrWorkOrderTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trWorkOrderType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrWorkOrderType', function($stateParams, TrWorkOrderType) {
                    return TrWorkOrderType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trworkorder-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('trworkorder-type.delete', {
            parent: 'trworkorder-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trworkorder-type/trworkorder-type-delete-dialog.html',
                    controller: 'TrWorkOrderTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['TrWorkOrderType', function(TrWorkOrderType) {
                            return TrWorkOrderType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('trworkorder-type', null, { reload: 'trworkorder-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('TrWorkOrderType', TrWorkOrderType);

    TrWorkOrderType.$inject = ['$resource', 'DateUtils'];

    function TrWorkOrderType ($resource, DateUtils) {
        var resourceUrl =  'api/trworkorder-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TrWorkOrderTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getTrWorkOrderTypebyname = function (data,callback){
		$http.get('api/trworkorder-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TrWorkOrderTypeSearch', TrWorkOrderTypeSearch);

    TrWorkOrderTypeSearch.$inject = ['$resource'];

    function TrWorkOrderTypeSearch ($resource) {
        var service = $resource('/api/trworkorder-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomTrWorkOrderTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-trworkorder-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrWorkOrderTypeController', TrWorkOrderTypeController);

    TrWorkOrderTypeController.$inject = ['$scope', '$state', 'TrWorkOrderType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','TrWorkOrderTypeSearch'];

    function TrWorkOrderTypeController ($scope, $state, TrWorkOrderType, ParseLinks, AlertService, pagingParams, paginationConstants,TrWorkOrderTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			TrWorkOrderTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trWorkOrderTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            TrWorkOrderType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trWorkOrderTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrakeyeTypeDialogController', TrakeyeTypeDialogController);

    TrakeyeTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state', 'entity', 'TrakeyeType', 'User'];

    function TrakeyeTypeDialogController ($timeout, $scope, $stateParams, $state, entity, TrakeyeType, User) {
        var vm = this;

        vm.trakeyeType = entity;  
        $scope.attributetypes = ['INTEGER', 'FLOAT', 'STRING','BOOLEAN'];
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.items=[{name: '',dataType: '',defaultValue :''}];
        
        if(vm.trakeyeType.trakeyeTypeAttribute!=null && vm.trakeyeType.trakeyeTypeAttribute.length!=0){
        	vm.items=vm.trakeyeType.trakeyeTypeAttribute;
        }
        
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
       
        function save () {
            vm.isSaving = true;
        	vm.trakeyeType.trakeyeTypeAttribute=[];
            if (vm.trakeyeType.id !== null) {
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            	    //vm.trakeyeType.trakeyeTypeAttribute.push({"name" :  vm.items[i].name});
            		vm.trakeyeType.trakeyeTypeAttribute.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,  "dataType" :  vm.items[i].dataType,"defaultValue" :  vm.items[i].defaultValue});
            	}
            	TrakeyeType.update(vm.trakeyeType, onSaveSuccess, onSaveError);
            } else {
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            	    //vm.trakeyeType.trakeyeTypeAttribute.push({"name" :  vm.items[i].name});
            		vm.trakeyeType.trakeyeTypeAttribute.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,  "dataType" :  vm.items[i].dataType,"defaultValue" :  vm.items[i].defaultValue});
            	}
            	TrakeyeType.save(vm.trakeyeType, onSaveSuccess, onSaveError);
            }
        }
       

        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:trakeyeTypeUpdate', result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == 'user-management.new') {
                $state.go('user-management.new');
            } else {
                $state.go('trakeye-type');
            }
            // sessionStorage.removeItem('prevPage');
            // $state.go('trakeye-type');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updatedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
       /* vm.addmore = function() {
            var newItemNo = vm.items.length+1;
            vm.items.push({'id':newItemNo});
          };
            
       vm.remove = function() {
            var lastItem = vm.items.length-1;
            vm.items.splice(lastItem);
          };*/
        
        vm.addmore = function() {
            vm.items.push({name: '',dataType:'', defaultValue:''});
          };
            
       vm.remove = function(index) {
            vm.items.splice(index, 1);
          };
        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrakeyeTypeDetailController', TrakeyeTypeDetailController);

    TrakeyeTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrakeyeType', 'User'];

    function TrakeyeTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TrakeyeType, User) {
        var vm = this;

        vm.trakeyeType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:trakeyeTypeUpdate', function(event, result) {
            vm.trakeyeType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrakeyeTypeDeleteController',TrakeyeTypeDeleteController);

    TrakeyeTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrakeyeType'];

    function TrakeyeTypeDeleteController($uibModalInstance, entity, TrakeyeType) {
        var vm = this;

        vm.trakeyeType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TrakeyeType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trakeye-type', {
            parent: 'entity',
            url: '/trakeye-type',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.trakeyeType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trakeye-type/trakeye-types.html',
                    controller: 'TrakeyeTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'updated_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trakeyeType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trakeye-type-detail', {
            parent: 'entity',
            url: '/trakeye-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.trakeyeType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trakeye-type/trakeye-type-detail.html',
                    controller: 'TrakeyeTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trakeyeType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrakeyeType', function($stateParams, TrakeyeType) {
                    return TrakeyeType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trakeye-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
       
        .state('trakeye-type.new', {
            parent: 'trakeye-type',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            views:{
            	'content@':{
            		 templateUrl: 'app/entities/trakeye-type/trakeye-type-dialog.html',
                     controller: 'TrakeyeTypeDialogController',
                     controllerAs: 'vm'
            	}
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        createdDate: null,
                        updatedDate: null,
                        id: null
                    };
                }
            }          
        })
        .state('trakeye-type.edit', {
            parent: 'entity',
            url: '/trakeye-type/Edit/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.trakeyeType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/trakeye-type/trakeye-type-dialog.html',
                    controller: 'TrakeyeTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trakeyeType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrakeyeType', function($stateParams, TrakeyeType) {
                    return TrakeyeType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trakeye-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('trakeye-type.delete', {
            parent: 'trakeye-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trakeye-type/trakeye-type-delete-dialog.html',
                    controller: 'TrakeyeTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['TrakeyeType', function(TrakeyeType) {
                            return TrakeyeType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('trakeye-type', null, { reload: 'trakeye-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
	'use strict';
	angular.module('trakeyeApp').factory('TrakeyeType', TrakeyeType);

	TrakeyeType.$inject = [ '$resource', 'DateUtils' ];

	function TrakeyeType($resource, DateUtils) {
		var resourceUrl = 'api/trakeye-types/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrakeyeTypeSearch', TrakeyeTypeSearch);

	TrakeyeTypeSearch.$inject = [ '$resource' ];

	function TrakeyeTypeSearch($resource) {
		var service = $resource('/api/trakeye-types/searchvalue/:userId', {
			userId : '@id'
		}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllTrakeyeTypes', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/trakeye-alltypes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrakeyeTypeController', TrakeyeTypeController);

    TrakeyeTypeController.$inject = ['$scope', '$state', 'TrakeyeType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','TrakeyeTypeSearch'];

    function TrakeyeTypeController ($scope, $state, TrakeyeType, ParseLinks, AlertService, pagingParams, paginationConstants,TrakeyeTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        
        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
				TrakeyeTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trakeyeTypes= data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            TrakeyeType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trakeyeTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrWorkOrderDialogController", TrWorkOrderDialogController);

    TrWorkOrderDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrWorkOrder",
        "AllWorkOrderTypes",
        "AllCustomWorkOrderTypeAttribute",
        "WorkOrderAttributeMappingId",
        "Configs",
        "ProjectByID",
        "RouteByID",
        "TrProjectListIdName",
        "TrRouteListByProjectId",
        "TrSectionListByRouteId",
        "AllVendorIds"
    ];

    function TrWorkOrderDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrWorkOrder,
        AllWorkOrderTypes,
        AllCustomWorkOrderTypeAttribute,
        WorkOrderAttributeMappingId,
        Configs,
        ProjectByID,
        RouteByID,
        TrProjectListIdName,
        TrRouteListByProjectId,
        TrSectionListByRouteId,
        AllVendorIds
    ) {
        var vm = this;
        vm.trWorkOrder = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trWorkOrder);
        vm.selectAttributes = selectedTrWorkOrderTypeAttributes;
        vm.trWorkOrderType = entity.trWorkOrderType;
        vm.selectedProjectId = "";
        if(entity.project != null){
            vm.selectedProjectId = entity.project.id;
        }
        vm.selectedRouteId = "";
        if(entity.route != null){
            vm.selectedRouteId = entity.route.id;
        }
        


        if ($state.params.routeId) {
            vm.trWorkOrder.routeId = parseInt($state.params.routeId, 10);
        }

        if ($state.params.sectionId) {
            vm.trWorkOrder.sectionId = parseInt($state.params.sectionId, 10);
        }

        vm.customAttributesMap = {};
        vm.customAttributesMapp = [];
        loadPage();

        $scope.onProjectChange = function () {
            //console.log("project click");
            TrRouteListByProjectId.get(vm.selectedProjectId, function (response) {
                vm.routes=response;
            });
        };
        
        if (vm.trWorkOrder.id != null) {
            vm.trWorkOrderType = vm.trWorkOrder.trWorkOrderType;
            $scope.onProjectChange()
            //$scope.onRouteChange()
        }

       

        $scope.onRouteChange = function () {
            //console.log("route click");
            TrSectionListByRouteId.get(vm.selectedRouteId, function (response) {
                vm.sections=response;
                vm.sections = []
                if(vm.trWorkOrder.id && vm.trWorkOrder.sections.length){
                    response.forEach(function (eachData) {
                        vm.trWorkOrder.sections.forEach(function (
                            eachdataChecked
                        ) {
                            if (eachdataChecked.id == eachData.id) {
                                eachData.isChecked = true;
                            }
                        });
                        vm.sections.push(eachData);
                    });
                    vm.sections.sort(function(a, b) {
                        // Convert boolean values to numbers (true to 1, false to 0)
                        var isCheckedA = a.isChecked ? 1 : 0;
                        var isCheckedB = b.isChecked ? 1 : 0;

                        // Compare the values
                        return isCheckedB - isCheckedA;
                      });
                }else{
                    vm.sections = response;
                }
            });
        };

        function loadPage() {
            if(vm.selectedProjectId != null){
                ProjectByID.get(vm.selectedProjectId,function(response) {
                    vm.project = response;
                });
            }
            
            if(vm.selectedRouteId != null && vm.selectedRouteId != ""){
                RouteByID.get(vm.selectedRouteId,function(response) {
                    vm.route = response;
                });
            }
            
            TrProjectListIdName.get(function (response) {
                vm.projects = response;
                if(vm.projects.length){
                    vm.projects.sort(function(a, b)  {
                        var nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
                        var nameB = b.name.toUpperCase();
                      
                        if (nameA < nameB) {
                          return -1;
                        }
                        if (nameA > nameB) {
                          return 1;
                        }
                        return 0; // Names are equal
                      });
                }
               
            });

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
                );
                imgWindow.document.close();
            };

            var trWorkOrderTypeAttributeValuesList =
                vm.trWorkOrder.trWorkOrderTypeAttributeValues;

            try {
                for (var index in vm.trWorkOrder.trWorkOrderType
                    .trWorkOrderTypeAttribute) {
                    if (
                        !checkIfTrWorkOrderTypeExists(
                            vm.trWorkOrder.trWorkOrderType
                                .trWorkOrderTypeAttribute[index],
                            vm.trWorkOrder.trWorkOrderTypeAttributeValues
                        )
                    ) {
                        var trWorkOrderTypeAttribute1 =
                            vm.trWorkOrder.trWorkOrderType
                                .trWorkOrderTypeAttribute[index];
                        trWorkOrderTypeAttributeValuesList.push({
                            trWorkOrderTypeAttribute: trWorkOrderTypeAttribute1,
                            attributeValue:
                                vm.trWorkOrder.trWorkOrderType
                                    .trWorkOrderTypeAttribute[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) { }

            function checkIfTrWorkOrderTypeExists(
                trWorkOrderType,
                trWorkOrderTypeAttrVal
            ) {
                var hasTrWorkOrderType = false;
                for (var i = 0; i < trWorkOrderTypeAttrVal.length; i++) {
                    var name
                    trWorkOrderTypeAttrVal[i].trWorkOrderTypeAttribute.name;
                    if (name == trWorkOrderType.name) {
                        hasTrWorkOrderType = true;
                        break;
                    }
                }
                return hasTrWorkOrderType;
            }
            AllWorkOrderTypes.getAll(function (response) {
                vm.trWorkOrderTypes = response;
            });

            AllCustomWorkOrderTypeAttribute.getAll(function (response) {
                //vm.customTrWorkOrderTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if (
                        arrayItem.customTrWorkOrderTypeAttributeValues !=
                        undefined
                    ) {
                        vm.customAttributesMap[arrayItem.name] =
                            arrayItem.customTrWorkOrderTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }
                });
                if (vm.trWorkOrder.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });

            AllVendorIds.getAll(function (response) {

                if(response.length){
                    vm.vendorList = response.sort(function(a, b) {
                        var nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
                        var nameB = b.name.toUpperCase();
                      
                        if (nameA < nameB) {
                          return -1;
                        }
                        if (nameA > nameB) {
                          return 1;
                        }
                        return 0; // Names are equal
                      });
                   
                      if(vm.trWorkOrder.vendor != null){
                        vm.vendorList.forEach(function(value){
                            if(vm.trWorkOrder.vendor.id==value.id){
                                vm.selectedVendor=value.id
                            }
                        });
                      } else {
                        vm.selectedVendor = "";
                      }
                      
                    vm.trWorkOrder.vendor = {id:vm.selectedVendor};
    
                } 
                
               
              
                
            });
        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function selectedTrWorkOrderTypeAttributes() {
            vm.showFilter = true;
            if (vm.trWorkOrderType) {
                vm.trWorkOrder.trWorkOrderType = vm.trWorkOrderType;
                if (
                    entity_old.trWorkOrderType &&
                    vm.trWorkOrderType.id === entity_old.trWorkOrderType.id
                ) {
                    vm.trWorkOrder.trWorkOrderTypeAttributeValues = [];
                    vm.trWorkOrder.trWorkOrderTypeAttributeValues =
                        entity_old.trWorkOrderTypeAttributeValues;
                } else {
                    vm.trWorkOrder.trWorkOrderTypeAttributeValues = [];
                    $.each(
                        vm.trWorkOrderType.trWorkOrderTypeAttribute,
                        function (key, value) {
                            vm.trWorkOrder.trWorkOrderTypeAttributeValues.push({
                                trWorkOrderTypeAttribute:
                                    vm.trWorkOrderType
                                        .trWorkOrderTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        function save() {
            //vm.isSaving = true;
            /* var spreadAV = vm.trWorkOrder.trWorkOrderTypeAttributeValues;
            for (
                var spreadAssetIndex = 0;
                spreadAssetIndex < spreadAV.length;
                spreadAssetIndex++
            ) {
                if (
                    spreadAV[spreadAssetIndex].trWorkOrderTypeAttribute.name ===
                    "Fiber Distance (km)"
                ) {
                    spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
                }
            }
            vm.trWorkOrder.trWorkOrderTypeAttributeValues = spreadAV; */
            vm.trWorkOrder.projectId = vm.selectedProjectId;
            vm.trWorkOrder.routeId = vm.selectedRouteId;
            vm.trWorkOrder.vendor = {id:vm.selectedVendor};
            if (vm.trWorkOrder.id !== null) {
                TrWorkOrder.update(vm.trWorkOrder, onSaveSuccess, onSaveError);
            } else {
                TrWorkOrder.save(vm.trWorkOrder, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:trWorkOrderUpdate", result);
            //vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "user-management.new") {
                $state.go("user-management.new");
            } else {
                $state.go("tr-workorder");
            }
        }

        function onSaveError() {
            //vm.isSaving = false;
        }

        Configs.get("WorkFlowStatus", function (response) {
            vm.workFlowStatus = [];
            var workFlowStatusList = response[0].configValue.split(",");
            workFlowStatusList.forEach(function (value) {
                if (value.length > 0) {
                    vm.workFlowStatus.push({
                        configKey: value,
                        configValue: value,
                    });
                }
            });
        });

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = response;
            //vm.workFlow.phase = "Planning Phase"
            /*  if(vm.workFlow.id == null){
                response.forEach(function(val){
                    if(val.configValue == '01'){
                        vm.workFlow.phase = val.configKey
                    }
                })
            }*/
        });

        /*  ActivatedUserSearch.query(
             {
                 // userId: vm.workFlow.assignedToUser,
                 userId: vm.workFlow.groups[0].id,
                 user: vm.user,
             },
             onSuccess,
             onError
         );
 
         function onSuccess(data, headers) {
             data.forEach(function (users) {
                 vm.assignedUsers.push(users.login);
             });
             vm.activatedusers = data;
 
             angular.forEach(vm.activatedusers, function (value, key) {
                 usersMap[value.login] = value.id;
             });
         }
         function onError(error) {
             AlertService.error(error.data.message);
         } */

        /*  RouteTypeSearch.query({userId:$scope.search,
             page: pagingParams.page - 1,
             size: vm.itemsPerPage,
             sort: sort()
         }, onSuccess, onError);
         function sort() {
             var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
             if (vm.predicate !== 'id') {
               //  result.push('id');
             }
             return result;
         }
         function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.routeTypes = data;
             vm.page = pagingParams.page;
     
         }
         function onError(error) {
             AlertService.error(error.data.message);
         } */

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        $scope.selectEntity = function () {
            vm.trWorkOrder.sections = [];
            vm.sections.forEach(function (section) {
                if (section.isChecked) {
                    vm.trWorkOrder.sections.push(section)
                }
            });
        };

        $('.select2').select2();

    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrWorkOrderDetailController', TrWorkOrderDetailController);

    TrWorkOrderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrWorkOrder', 'User', 'TrWorkOrderType', 'TrWorkOrderImages', 'TrWorkOrderRecordings','AlertService','$window','$localStorage','Configs'];

    function TrWorkOrderDetailController($scope, $rootScope, $stateParams, previousState, entity, TrWorkOrder, User, TrWorkOrderType,TrWorkOrderImages,TrWorkOrderRecordings,AlertService, $window,$localStorage,Configs) {
		var vm = this;
		
        vm.trWorkOrder = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        var unsubscribe = $rootScope.$on('trakeyeApp:trWorkOrderUpdate', function(event, result) {
            vm.trWorkOrder = result;
        });
		vm.showTrWorkOrderAttachment = false

		Configs.get("TrWorkOrderImage",function(response){
            if(response.length > 0){
				if(response[0].configValue == "True"){
					vm.showTrWorkOrderAttachment = true
				}
			}
        })
		
        vm.imageInNewTab = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
            );
            imgWindow.document.close(); 
		};

		$scope.newTabDisplay = function(id){
            var request = new XMLHttpRequest();
            request.open('GET',"api/trakeyetrWorkOrderimages/"+vm.trWorkOrder.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                window.open(imageUrl, "_blank")}
            } 
            request.send();
        } 

        $scope.$on('$destroy', unsubscribe);
        
          $scope.go_back = function() { 
        	  $window.history.back();
        	};
        
        $scope.allimages = false;
//		$scope

		$scope.toggle = function(id) {
			switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrWorkOrderImages.query(
                            {
                                trWorkOrderId: vm.trWorkOrder.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.trWorkOrderImages = data.filter(function(trWorkOrderImages){
                                return trWorkOrderImages.image
                             });
                        
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;

                    break;

                default:
                    console.log("");
            }


			
			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/trWorkOrder_"+vm.trWorkOrder.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrWorkOrderImages.query({
					trWorkOrderId : vm.trWorkOrder.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.trWorkOrderImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

//		$scope.playAudio = function() {
////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/trWorkOrder_"+vm.trWorkOrder.id+".mp3";
//            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/trWorkOrder_15570572.mp3";
//	        var audio = new Audio(urlStr);
//	        audio.play();
//	    };
		
		
        function decodeImage(img){
     	   return window.atob(img);
        }
       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrWorkOrderDeleteController',TrWorkOrderDeleteController);

    TrWorkOrderDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrWorkOrder','$scope'];

    function TrWorkOrderDeleteController($uibModalInstance, entity, TrWorkOrder,$scope) {
        var vm = this;

        vm.trtrWorkOrder = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrWorkOrder.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-workorder', {
                parent: 'app',
                url: '/tr-workorder',
                data: {
                    authorities: ['WORKORDER_SIDEBAR'],                    
                    pageTitle: 'trakeyeApp.trWorkOrder.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-workorder/tr-workorders.html',
                        controller: 'TrWorkOrderController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trWorkOrder');
                        $translatePartialLoader.addPart('trWorkOrderStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-workorder-detail', {
                parent: 'tr-workorder',
                url: '/tr-workorder/{id}',
                data: {
                    authorities: ['WORKORDER_DETAIL'],
                    pageTitle: 'trakeyeApp.trWorkOrder.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-workorder/tr-workorder-detail.html',
                        controller: 'TrWorkOrderDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trWorkOrder');
                        $translatePartialLoader.addPart('trWorkOrderStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrWorkOrder', function ($stateParams, TrWorkOrder) {
                        return TrWorkOrder.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-workorder',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-workorder.priority', {
                parent: 'tr-workorder',
                url: '/tr-workorders/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trWorkOrder.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-workorder/tr-workorders.html',
                        controller: 'TrWorkOrderController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trWorkOrder');
                        $translatePartialLoader.addPart('trWorkOrderStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-workorder.attendance', {
                parent: 'tr-workorder',
                url: '/tr-workorders/attendance/{login}/{fromTime}/{toTime}/{trWorkOrderStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trWorkOrder.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-workorder/tr-workorders.html',
                        controller: 'TrWorkOrderController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            trWorkOrderStatus: $stateParams.trWorkOrderStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trWorkOrder');
                        $translatePartialLoader.addPart('trWorkOrderStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-workorder.new', {
                parent: 'tr-workorder',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}/{routeId}/{sectionId}',
                data: {
                    authorities: ['ROLE_ROLLOUT_MANAGER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-workorder/tr-workorder-dialog.html',
                        controller: 'TrWorkOrderDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            trWorkOrderImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })

        .state('tr-workorder.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-workorder/tr-workorder-work-flow.html',
                    controller: 'TrWorkOrderWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        trWorkOrderImages: []
                    };
                }]
            }
        })

        .state('tr-workorder.import', {
                parent: 'tr-workorder',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-workorder/tr-workorder-import.html',
                        controller: 'TrWorkOrderImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            trWorkOrderImages: []
                        };
                    }
                }

            })
            .state('tr-workorder.edit', {
                parent: 'tr-workorder',
                url: '/Edit/{id}',
                data: {
                    authorities: ['WORKORDER_EDIT'],
                    pageTitle: 'trakeyeApp.trWorkOrder.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-workorder/tr-workorder-dialog.html',
                        controller: 'TrWorkOrderDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrWorkOrder', function ($stateParams, TrWorkOrder) {
                        return TrWorkOrder.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-workorder',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-workorder.delete', {
                parent: 'tr-workorder',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-workorder/tr-workorder-delete-dialog.html',
                        controller: 'TrWorkOrderDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrWorkOrder', function (TrWorkOrder) {
                                return TrWorkOrder.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-workorder', null, { reload: 'tr-workorder' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-workorder.fibercore', {
                parent: 'tr-workorder',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-workorder/tr-workorder-fiber-core.html',
                        controller: 'TrWorkOrderFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            trWorkOrderImages: []
                        };
                    }
                }

            })

            .state('show-hide-workorder', {
                parent: 'report',
                url: '/show-hide-workorder',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-workorder/show-hide-workorder.html',
                        controller: 'ShowHideTrWorkOrderController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrWorkOrder', TrWorkOrder);

	TrWorkOrder.$inject = ['$resource', 'DateUtils'];

	function TrWorkOrder($resource, DateUtils) {
		var resourceUrl = 'api/tr-workorders/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderGeofence', TrWorkOrderGeofence);

	TrWorkOrderGeofence.$inject = ['$resource'];

	function TrWorkOrderGeofence($resource) {
		var service = $resource('/api/tr-workorders/geofence/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderCustomTime', TrWorkOrderCustomTime);

	TrWorkOrderCustomTime.$inject = ['$resource'];

	function TrWorkOrderCustomTime($resource) {
		var service = $resource('/api/tr-workorders-custom/:fromDate/:toDate', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderGeofenceCustomTime', TrWorkOrderGeofenceCustomTime);

	TrWorkOrderGeofenceCustomTime.$inject = ['$resource'];

	function TrWorkOrderGeofenceCustomTime($resource) {
		var service = $resource('/api/tr-workorders-custom/geofence/:geofenceId/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrWorkOrderCheckAsset', TrWorkOrderCheckAsset);

	TrWorkOrderCheckAsset.$inject = ['$resource', 'DateUtils'];

	function TrWorkOrderCheckAsset($resource, DateUtils) {
		var resourceUrl = 'api/assets/search/:name';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
		});
	}
})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('WorkOrdersForAsset', WorkOrdersForAsset);

    WorkOrdersForAsset.$inject = ['$resource'];

    function WorkOrdersForAsset($resource) {
        var resourceUrl = 'api/workOrders-for-asset/:assetId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-workorders/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getWorkOrderImage', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/trakeyeworkOrderimages/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getNearbyFixed', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id,data,callback) {
			$http.post('api/assets/nearby-fixed/' + id,data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderAssetsById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-workorders-assets/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('WorkOrderAttributeMappingId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/custom-workorder-type-mapper/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

/*
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderById', TrWorkOrderById);

	TrWorkOrderById.$inject = [ '$resource' ];

	function TrWorkOrderById($resource) {
		var service = $resource('/api/tr-workorders/:id', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();*/

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderCountByGroup', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/workOrdercountbygroup').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadWorkOrderReports', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-workorders').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderCountByStatus', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/workOrdercountbystatus').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderPriority', TrWorkOrderPriority);

	TrWorkOrderPriority.$inject = ['$resource'];

	function TrWorkOrderPriority($resource) {
		var service = $resource('/api/tr-workorders/priority/:priority/:geofenceId', {
			priority: '@priorirty'
		}, {geofenceId : '@geofenceId'},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderAttendance', TrWorkOrderAttendance);

	TrWorkOrderAttendance.$inject = ['$resource'];

	function TrWorkOrderAttendance($resource) {
		var service = $resource('/api/tr-workorders/attendance/:login/:fromTime/:toTime/:workOrderStatus',
			{}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderSearch', TrWorkOrderSearch);

	TrWorkOrderSearch.$inject = ['$resource'];

	function TrWorkOrderSearch($resource) {
		var service = $resource('/api/tr-workorders/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderSearchCustom', TrWorkOrderSearchCustom);

	TrWorkOrderSearchCustom.$inject = ['$resource'];

	function TrWorkOrderSearchCustom($resource) {
		var service = $resource('/api/tr-workorders-custom/searchvalue/:search/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderGeofenceSearch', TrWorkOrderGeofenceSearch);

	TrWorkOrderGeofenceSearch.$inject = ['$resource'];

	function TrWorkOrderGeofenceSearch($resource) {
		var service = $resource('/api/tr-workorders/geofence-searchvalue/:geofenceId/:search', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderGeofenceSearchCustom', TrWorkOrderGeofenceSearchCustom);

	TrWorkOrderGeofenceSearchCustom.$inject = ['$resource'];

	function TrWorkOrderGeofenceSearchCustom($resource) {
		var service = $resource('/api/tr-workorders-custom/geofence-searchvalue/:geofenceId/:search/:fromDate/:toDate', {}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrWorkOrderGroup', TrWorkOrderGroup);

	TrWorkOrderGroup.$inject = ['$resource', 'DateUtils'];

	function TrWorkOrderGroup($resource, DateUtils) {
		var resourceUrl = 'api/tr-workorders-group';

		return $resource(resourceUrl, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderGroupSearch', TrWorkOrderGroupSearch);

	TrWorkOrderGroupSearch.$inject = ['$resource'];

	function TrWorkOrderGroupSearch($resource) {
		var service = $resource('/api/tr-workorders-group/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderGroupPrioritySearch', TrWorkOrderGroupPrioritySearch);

	TrWorkOrderGroupPrioritySearch.$inject = ['$resource'];

	function TrWorkOrderGroupPrioritySearch($resource) {
		var service = $resource('/api/tr-workorders-group/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderGroupPriority', TrWorkOrderGroupPriority);

	TrWorkOrderGroupPriority.$inject = ['$resource'];

	function TrWorkOrderGroupPriority($resource) {
		var service = $resource('/api/tr-workorders-group/priority/:priority', {
			priority: '@priorirty'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderImages', TrWorkOrderImages);

	TrWorkOrderImages.$inject = ['$resource'];

	function TrWorkOrderImages($resource) {
		var service = $resource('/api/workOrder-images/:workOrderId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrdersForType', TrWorkOrdersForType);

	TrWorkOrdersForType.$inject = ['$resource'];

	function TrWorkOrdersForType($resource) {
		var service = $resource('/api/trworkOrdersbytype/:workOrderTypeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}

})();
 (function () {
	'use strict';

	angular.module('trakeyeApp').factory('NearByBGOH', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (data,success,error) {
			$http.post('api/tr-workorders/nearby-bgoh-assets',data).then(function (response) {
				success(response.data);
			},function (response) {
				error(response.status);
			});
		};

		return service;
	}]);
})();  

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderRecordings', TrWorkOrderRecordings);

	TrWorkOrderRecordings.$inject = ['$resource'];

	function TrWorkOrderRecordings($resource) {
		var service = $resource('/api/workOrder-recordings/:workOrderId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllWorkOrderTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/trworkorder-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderPrioritySearch', TrWorkOrderPrioritySearch);

	TrWorkOrderPrioritySearch.$inject = ['$resource'];

	function TrWorkOrderPrioritySearch($resource) {
		var service = $resource('/api/tr-workorders/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrWorkOrderUpdateGroup', TrWorkOrderUpdateGroup);

	TrWorkOrderUpdateGroup.$inject = ['$resource'];

	function TrWorkOrderUpdateGroup($resource) {
		var resourceUrl = 'api/tr-workorders/groups';

		return $resource(resourceUrl, {}, {
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrWorkOrderBulkDelete', TrWorkOrderBulkDelete);

	TrWorkOrderBulkDelete.$inject = ['$resource'];

	function TrWorkOrderBulkDelete($resource) {
		var resourceUrl = 'api/tr-workorders/bulk/delete';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderUser', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.gettrworkOrdersuser = function (callback) {
			$http.get('api/tr-workorders/live-logs').then(function (response) {
				callback(response.data);
			});
		};

		service.gettrworkOrdersuserbyid = function (id, callback) {
			$http.get('api/tr-workorders/live-logs/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.searchtrworkOrdersuserbyvalue = function (id, callback) {
			$http.get('api/tr-workorders/search/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.gettrworkOrdersanduserbypriority = function (priority, callback) {
			$http.get('api/tr-workorders/live-logs/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		service.getAgents = function (callback) {
			$http.get('api/dashboard/agentdashboard').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderEdit', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getalltrworkOrders = function (callback) {
			$http.get('api/tr-allworkOrders').then(function (response) {
				callback(response.data);
			});
		};

		service.edittrworkOrder = function (data, callback) {
			$http.post('api/tr-workorderedit/' + data.userId + '/' + data.workOrderId, {

			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {

				callback(error, error.headers);
			});

			/*
			 * $http.post('api/tr-workorderedit/'+data.userId+'/'+data.workOrderId).then(function(response){
			 * callback(response.data); });
			 */
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrWorkOrderUpload', TrWorkOrderUpload);

	TrWorkOrderUpload.$inject = ['$http'];

	function TrWorkOrderUpload($http) {

		var service = {};
		service.trworkOrderupload = function (data, callback) {

			$http.post('api/workOrderimport', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupWorkOrderSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrworkOrderformap = function (search, callback) {
			$http.get('api/tr-groupworkOrdersformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupWorkOrderForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllWorkOrders = function (callback) {
			$http.get('api/tr-groupworkOrdersformap').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrworkOrderformap = function (search, callback) {
			$http.get('api/tr-workordersformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};

		service.prioritysearchtrworkOrderformap = function (priority, callback) {
			$http.get('api/tr-workordersformap/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('TrWorkOrderLastLocation', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			service.getlastlogs = function (callback) {
				$http.get('api/location-logs/lastuserpath').then(function (response) {
					callback(response.data);
				});
			};
			return service;
		}]);



})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('WorkOrdersForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.workOrdersformapbyadmin = function (adminid, callback) {
			$http.get('api/tr-workordersformap/' + adminid).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrWorkOrderForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllWorkOrders = function (data, callback) {
			// $http.get('api/tr-workordersformap').then(function (response) {
			// 	callback(response.data);
			// });
			$http.post('api/tr-workordersformap', data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ShowWorkOrderById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (workOrderid, callback) {
            $http.put('api/show-workorder/' + workOrderid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('HideWorkOrderById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (workOrderid, callback) {
            $http.put('api/hide-workorder/' + workOrderid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

/* (function () {
    'use strict';

    angular.module('trakeyeApp').factory('assignTasks', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};

        service.post = function (payload, callback) {
            $http.post('api/tr-user-bulk-tasks' , payload)
			.success(function (response) {
				callback(response.data);
            })
            .error(function (err) {
				callback(err);
            });
        };

        return service;
    }]);
})(); */

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrWorkOrderController", TrWorkOrderController);

    TrWorkOrderController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$compile",
        "TrWorkOrder",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "TrWorkOrderSearch"
    ];

    function TrWorkOrderController(
        $scope,
        $rootScope,
        $state,
        $compile,
        TrWorkOrder,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        TrWorkOrderSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var searchVal = $scope.search.replace(/[^\w\s]/g, '_');
                TrWorkOrderSearch.query(
                    {
                        search: searchVal,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.trWorkOrders = [];
                    data.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.trWorkOrders.push(value);
                    });
                    vm.page = pagingParams.page;
                }
    
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            TrWorkOrder.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.trWorkOrders = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.trWorkOrders.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                //  result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ){
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrVendorDialogController", TrVendorDialogController);

    TrVendorDialogController.$inject = [
        "$timeout",
        "entity",
        "TrVendor",
        "$window",
        "AlertService",
    ];

    function TrVendorDialogController(
        $timeout,
        entity,
        TrVendor,
        $window,
        AlertService
    ) {
        var vm = this;
        vm.trVendor = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trVendor);
        loadPage();

        function loadPage() {
        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function save() {
            if(vm.trVendor.id){
                TrVendor.update(vm.trVendor, onSaveSuccess, onSaveError)
            }else{
                TrVendor.save(vm.trVendor, onSaveSuccess, onSaveError)
            }
        }
        function onSaveSuccess(result) {
            $window.history.back();
        }

        function onSaveError() {
            AlertService.error(error.data.message);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrVendorDetailController', TrVendorDetailController);

    TrVendorDetailController.$inject = ['$stateParams', 'TrVendor', '$scope', 'SummaryPost', 'MaterialDates', 'MaterialByDates', 'ParseLinks'];

    function TrVendorDetailController($stateParams, TrVendor, $scope, SummaryPost, MaterialDates, MaterialByDates, ParseLinks) {
        var vm = this;
        vm.load = load;
        //vm.trVendor = {};
        vm.groupedMaterialTxn = []
        vm.groupedResourceTxn = []
       
        vm.load($stateParams.id);

        function load (id) {
            TrVendor.get({id: id}, function(result) {
                vm.trVendor = result;
            });
        }

        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            if (newTab == 1) {
                vm.load($stateParams.id);
            }

            if(newTab == 2){
                SummaryPost.mtrlTx({vendorIds : [ $stateParams.id ]}, function (response) {
                    if(response.length){
                            vm.groupedMaterialTxn = response.reduce(function(acc, obj)  {
                                var entry = acc.find(function(item) { return  item.projectId === obj.projectId && item.projectName === obj.projectName} );
                            
                                if (!entry) {
                                    entry = {
                                        projectId: obj.projectId,
                                        projectName: obj.projectName,
                                        details: []
                                    };
                                    acc.push(entry);
                                }
                    
                                entry.details.push(obj);
                            
                                return acc;
                            }, []);
                    }
                  })
            }

            if(newTab == 3){
                SummaryPost.resTx({vendorIds : [ $stateParams.id ]}, function (response) {
                    if(response.length){
                            vm.groupedResourceTxn = response.reduce(function(acc, obj)  {
                                var entry = acc.find(function(item) { return  item.projectId === obj.projectId && item.projectName === obj.projectName} );

                                if (!entry) {
                                    entry = {
                                        projectId: obj.projectId,
                                        projectName: obj.projectName,
                                        details: []
                                    };
                                    acc.push(entry);
                                }

                                entry.details.push(obj);

                                return acc;
                            }, []);
                    }
                  })
            }

            $scope.tab = newTab;
        }

        vm.expand = function (task,id) {

            if(id == 'material'){
                vm.groupedMaterialTxn.forEach(function (item) {
                    item.expand = false;
                });
            }else if(id == 'resource'){
                vm.groupedResourceTxn.forEach(function (item) {
                    item.expand = false;
                });
            }

            if (vm.toggle == task.projectId) {
                vm.toggle = undefined;
            } else {
                task.expand = true;
                vm.toggle = task.projectId;
            }
        }
        vm.page = 1;
        vm.predicate = 'modified_date';
        vm.itemsPerPage = 10;
        vm.materialTxnByDates = [];
        vm.materialByDate = [];
        vm.loadMaterialTxnDate = function () {
            MaterialDates.query({
                type: "vendor",
                id: $stateParams.id,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materialByDate = data.map(function (item) {
                    return {
                        timestamp: item[0],
                        total: item[1],
                        isExpand: false
                    };
                });

            });
        };

        vm.loadMaterialTxnDate();

        vm.loadMaterialTxnByDates = function (date) {
            MaterialByDates.query({
                type: 'vendor',
                id: $stateParams.id,
                date: date,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materialTxnByDates = data.map(function (item) {
                    return {
                        transactionId: item[0],
                        timestamp: item[4],
                        transactionName: item[1],
                        transactionType: item[2],
                        count: item[3],
                        status: item[5],
                    };
                });
            });
        };
        vm.toggleExpand = function (selectedTask) {
            angular.forEach(vm.materialByDate, function (task) {
                if (task === selectedTask) {
                    task.isExpand = !task.isExpand;
                    if (task.isExpand) {
                        vm.loadMaterialTxnByDates(task.timestamp);
                    } else {
                        vm.materialTxnByDates = [];
                    }
                } else {
                    task.isExpand = false;
                }
            });
        };
        vm.transitionMainMateril = function () {
            vm.loadMaterialTxnDate()
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-vendor', {
                parent: 'app',
                url: '/tr-vendor',
                data: {
                    authorities: ['PROJECT_SIDEBAR'],
                    pageTitle: 'trakeyeApp.vendor.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-vendor/tr-vendors.html',
                        controller: 'TrVendorController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    projectId: null,
                    routeId : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            projectId: $stateParams.projectId,
                            routeId :  $stateParams.routeId,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trVendor');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-vendor-detail', {
                parent: 'tr-vendor',
                url: '/tr-vendor/{id}',
                data: {
                    authorities: ['PROJECT_DETAIL'],
                    pageTitle: 'trakeyeApp.vendor.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-vendor/tr-vendor-detail.html',
                        controller: 'TrVendorDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trVendor');
                        return $translate.refresh();
                    }],
                   /*  entity: ['$stateParams', 'TrVendor', function ($stateParams, TrVendor) {
                        return TrVendor.get({ id: $stateParams.id }).$promise;
                    }], */
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-vendor',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('tr-vendor.new', {
                parent: 'tr-vendor',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}/{routeId}/{sectionId}',
                data: {
                    authorities: ['PROJECT_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-vendor/tr-vendor-dialog.html',
                        controller: 'TrVendorDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            vendorImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

        .state('tr-vendor.import', {
                parent: 'tr-vendor',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-vendor/tr-vendor-import.html',
                        controller: 'TrVendorImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            vendorImages: []
                        };
                    }
                }

            })
            .state('tr-vendor.edit', {
                parent: 'tr-vendor',
                url: '/Edit/{id}/{routeId}/{sectionId}',
                data: {
                    authorities: ['PROJECT_EDIT'],
                    pageTitle: 'trakeyeApp.vendor.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-vendor/tr-vendor-dialog.html',
                        controller: 'TrVendorDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrVendor', function ($stateParams, TrVendor) {
                        return TrVendor.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-vendor',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })
    }
})();
(function () {
    "use strict";
    angular.module("trakeyeApp").factory("TrVendor", TrVendor);

    TrVendor.$inject = ["$resource", "DateUtils"];

    function TrVendor($resource, DateUtils) {
        var resourceUrl = "api/tr-vendors/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrVendorById", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.get = function (id, callback) {
                $http.get("api/tr-vendors/" + id).then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrVendorSearch", TrVendorSearch);

    TrVendorSearch.$inject = ["$resource"];

    function TrVendorSearch($resource) {
        var service = $resource(
            "/api/tr-vendors/searchvalue/:search",
            {},
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllVendorIds', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/tr-vendor-ids').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrVendorController", TrVendorController);

    TrVendorController.$inject = [
        "$scope",
        "$state",
        "TrVendor",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants"
    ];

    function TrVendorController(
        $scope,
        $state,
        TrVendor,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        vm.createVendor = createVendor;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            loadAll();
        }

        function createVendor() {
            $state.go("tr-vendor.new");
        }

        function loadAll() {
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }
            TrVendor.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.vendors = [];
                    vm.vendors = data;
                    vm.page = pagingParams.page;
                },
                onError
            );
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ){
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrTerrainDialogController", TrTerrainDialogController);

    TrTerrainDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrTerrain",
        "Configs",
        "route",
        "postRoutePoints",
        "AlertService",
        "$window",
        "TrRouteListIdName",
        "RoutePathById",
        "AllTerrainTypes",
        "AllCustomTerrainTypeAttribute",
        "$rootScope"
    ];

    function TrTerrainDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrTerrain,
        Configs,
        route,
        postRoutePoints,
        AlertService,
        $window,
        TrRouteListIdName,
        RoutePathById,
        AllTerrainTypes,
        AllCustomTerrainTypeAttribute,
        $rootScope
    ) {
        var vm = this;
        vm.trTerrain = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trTerrain);
        vm.terrainType = entity.terrainType;
        var markers = []
        var coordinateList = []
        var chainageList = []
        var markerList = []
        var iconSize = 20
        var labelFrom, labelTo
        labelFrom = 'From Terrain'
        labelTo = 'To Terrain'
        vm.routeName = route
        vm.selectRoute = selectRoute;
        vm.selectAttributes = selectedTerrainTypeAttributes;
        vm.isSetUpdate = false;
        var coordinateList = [];
        var chainageList = [];
        var markerList = [];
        vm.terrainType = entity.terrainType;

        if ($state.params.routeId) {
            vm.trTerrain.routeId = parseInt($state.params.routeId, 10);
        }

        vm.customAttributesMap = {};
        vm.customAttributesMapp = [];
        loadPage();
        var locations = {};
        var locationsEnd = {};


        function loadPage() {

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
                );
                imgWindow.document.close();
            };
            TrRouteListIdName.get(function (response) {
                vm.routes = response;
            });


            var terrainTypeAttributeValuesList =
                vm.trTerrain.terrainTypeAttributeValues;

            try {
                for (var index in vm.trTerrain.terrainType.terrainTypeAttribute) {
                    if (
                        !checkIfTerrainTypeExists(
                            vm.trTerrain.terrainType.terrainTypeAttribute[index],
                            vm.trTerrain.terrainTypeAttributeValues
                        )
                    ) {
                        var terrainTypeAttribute1 =
                            vm.trTerrain.terrainType.terrainTypeAttribute[index];
                        terrainTypeAttributeValuesList.push({
                            terrainTypeAttribute: terrainTypeAttribute1,
                            attributeValue:
                                vm.trTerrain.terrainType.terrainTypeAttribute[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) { }

            function checkIfTerrainTypeExists(terrainType, terrainTypeAttrVal) {
                var hasTerrainType = false;
                for (var i = 0; i < terrainTypeAttrVal.length; i++) {
                    var name = terrainTypeAttrVal[i].terrainTypeAttribute.name;
                    if (name == terrainType.name) {
                        hasTerrainType = true;
                        break;
                    }
                }
                return hasTerrainType;
            }
            AllTerrainTypes.getAll(function (response) {
                vm.terrainTypes = response;
            });

            AllCustomTerrainTypeAttribute.getAll(function (response) {
                //vm.customTerrainTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if (arrayItem.customTerrainTypeAttributeValues != undefined) {
                        vm.customAttributesMap[arrayItem.name] =
                            arrayItem.customTerrainTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }

                });
                if (vm.trTerrain.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });

        }
        // $timeout(function () {
        //     angular.element(".form-group:eq(1)>input").focus();
        // });

        function selectedTerrainTypeAttributes() {
            vm.showFilter = true;
            if (vm.terrainType) {
                vm.trTerrain.terrainType = vm.terrainType;
                if (
                    entity_old.terrainType &&
                    vm.terrainType.id === entity_old.terrainType.id
                ) {
                    vm.trTerrain.terrainTypeAttributeValues = [];
                    vm.trTerrain.terrainTypeAttributeValues =
                        entity_old.terrainTypeAttributeValues;
                } else {
                    vm.trTerrain.terrainTypeAttributeValues = [];
                    $.each(
                        vm.terrainType.terrainTypeAttribute,
                        function (key, value) {
                            vm.trTerrain.terrainTypeAttributeValues.push({
                                terrainTypeAttribute:
                                    vm.terrainType.terrainTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        } 

        function selectRoute() {
            markers.forEach(function(marker){
                marker.setMap(null);
            });
            coordinateList = [];
            chainageList = [];
            markerList = [];
            locations.map
            initMap();
            RoutePathById.get(vm.trTerrain.routeId, function (response) {
                var groupedSessions = {};
                if (response.COORDINATE) {
                    response.COORDINATE.forEach(function (value) {
                        if(value.sessionNumber!=null){
                        if (!groupedSessions[value.sessionNumber]) {
                            groupedSessions[value.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                        }
                        groupedSessions[value.sessionNumber].coordinates.push({ lat: value.latitude, lng: value.longitude , routePointNumber: value.routePointNumber });
                   }
                    });
                }
                if (response.CHAINAGE) {
                    response.CHAINAGE.forEach(function (value) {
                        if (!groupedSessions[value.sessionNumber]) {
                            groupedSessions[value.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                        }
                        groupedSessions[value.sessionNumber].chainages.push({ lat: value.latitude, lng: value.longitude , routePointNumber: value.routePointNumber });
                    });
                }
                
                if(response.MARKER){
                    response.MARKER.forEach(function (value) {
                        if (!groupedSessions[value.sessionNumber]) {
                            groupedSessions[value.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                        }
                        groupedSessions[value.sessionNumber].markers.push({ lat: value.latitude, lng: value.longitude , routePointNumber: value.routePointNumber });
                    });
                }
                Object.keys(groupedSessions).forEach(function (sessionNumber) {
                    var sessionData = groupedSessions[sessionNumber];
                    sessionData.coordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                    if (sessionData.coordinates.length) {
                        var polyline = new google.maps.Polyline({
                            path: sessionData.coordinates,
                            geodesic: true,
                            strokeColor: '#FD7A24',
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                        });
                        polyline.setMap(locations.map);
                        addClick(polyline);
                        var bounds = new google.maps.LatLngBounds();
                        sessionData.coordinates.forEach(function (coord) {
                            bounds.extend(coord);
                        });
                        locations.map.fitBounds(bounds);
                    }
                    if (sessionData.chainages.length) {
                        createMarkers(sessionData.chainages, 'content/images/chainagePoints.png', locations.map);
                    }
                    if (sessionData.markers.length) {
                        createMarkers(sessionData.markers, 'content/images/markersPoint.png', locations.map);
                    }
                });
            });
        }

        function addClick(item) {
            // Add a click event listener to the map
            item.addListener("click", function (event) {
                if (markers.length < 2) {
                    // Add a marker to the map
                    addMarker(event.latLng);

                    // Get the latitude and longitude of the clicked point
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }

        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                addClick(marker)
                arr.push(marker);
            })
        }

        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = labelFrom
            } else if (markers.length == 1) {
                markerText = labelTo
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: markerText,
                }
            });

            // Add the marker to the markers array
            markers.push(marker);
        }

        function save() {
            if (markers.length == 2) {
                var payload
                markers.forEach(function (item) {
                    if (item.label.text == labelFrom || item.label.text == labelTo) {
                        if (item.label.text == labelFrom) {
                            vm.trTerrain.fromRoutePoint = {};
                            vm.trTerrain.fromRoutePoint.latitude = item.position.lat();
                            vm.trTerrain.fromRoutePoint.longitude = item.position.lng();
                        }
                        if (item.label.text == labelTo) {
                            vm.trTerrain.toRoutePoint = {};
                            vm.trTerrain.toRoutePoint.latitude = item.position.lat();
                            vm.trTerrain.toRoutePoint.longitude = item.position.lng();
                            if(vm.trTerrain.id != null){
                                TrTerrain.update(vm.trTerrain, onSaveSuccess, onSaveError);
                            } else {
                                TrTerrain.save(vm.trTerrain, onSaveSuccess, onSaveError);
                            }
                            
                        }
                    }
                })
            } else {
                alert("Terrain From or To Points are Empty")
            }

        }
		
		
		vm.closeModal = function(id) {
		          vm.getLocationCoordinateA = null
		          vm.getLocationCoordinateB = null

		          $("#" + id).removeClass("in");
		          $(".modal-backdrop").remove();
		          $("#" + id).hide();
		      }
			  
			  vm.onLocationCoordinates = function() {
			             var latlngA = vm.getLocationCoordinateA.split(",");
			             var latlngB = vm.getLocationCoordinateB.split(",");

			             addMarker({lat: parseFloat(latlngA[0]),lng: parseFloat(latlngA[1])})
			             addMarker({lat: parseFloat(latlngB[0]),lng: parseFloat(latlngB[1])})

			             locations.map.setCenter({lat: parseFloat(latlngB[0]),lng: parseFloat(latlngB[1])})
			             vm.closeModal('modalLatLongs')
			         }
        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:terrainUpdate", result);
            //vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "user-management.new") {
                $state.go("user-management.new");
            } else {
                $window.history.back();
            }
        }

        function onSaveError() {
            //vm.isSaving = false;
        }

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = response;
            //vm.workFlow.phase = "Planning Phase"
            /*  if(vm.workFlow.id == null){
                response.forEach(function(val){
                    if(val.configValue == '01'){
                        vm.workFlow.phase = val.configKey
                    }
                })
            }*/
        });

        //start
        initMap();
        function initMap(){
            locations.map = new google.maps.Map(
                document.getElementById("map_canvasStart"),
                {
                    center: {
                        lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                        lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                    },
                    zoom: 13,
                    fullscreenControl: true,
                    styles: mapStyles(),
                }
            );


            geoLocation(locations.map);
        }

        if (vm.trTerrain.id == null) {
            selectRoute();
        }
        if (vm.trTerrain.id != null) {
            selectRoute();
        } else {
            vm.trTerrain.phase = "PLANNING"
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );
			
			var goTo = document.createElement("span");
			            goTo.setAttribute("title", "Location Coordinates");
			            goTo.classList.add("custom-map-control-button");
			            var gotoIcon = document.createElement("i");
			            gotoIcon.classList.add("fa");
			            gotoIcon.classList.add("fa-location-arrow");
			            gotoIcon.classList.add("geo");
			            gotoIcon.classList.add("mt-5");
			            goTo.appendChild(gotoIcon);
			            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);
			            goTo.addEventListener("click", function () {
			                vm.removeMarker()
			                $("#modalLatLongs").show();
			     });

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        vm.removeMarker = function () {
            markers.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the markers array
            markers = [];

            if (vm.trTerrain.id) {
                vm.isSetUpdate = true
            }

        }

        // if (route && route.routePoints != null && route.routePoints.length) {
        //     route.routePoints.forEach(function (each) {
        //         if (each.routePointType == "COORDINATE") {
        //             coordinateList.push({ lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber })
        //         } else if (each.routePointType == "MARKER") {
        //             markerList.push({ lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber })
        //         } else if (each.routePointType == "CHAINAGE") {
        //             chainageList.push({ lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber })
        //         }
        //     })
        //     coordinateList.sort(function(a, b) { return a.routePointNumber - b.routePointNumber});
        //     if (coordinateList.length) {
        //         locations.map.setCenter(coordinateList[0]);
        //         var polyline = new google.maps.Polyline({
        //             path: coordinateList,
        //             geodesic: true,
        //             strokeColor: '#FD7A24',
        //             strokeOpacity: 1.0,
        //             strokeWeight: 4,
        //         });

        //         // Set the map to display the polyline
        //         polyline.setMap(locations.map);
        //         addClick(polyline)
        //     }
        //     markerList.sort(function(a, b) { return a.routePointNumber - b.routePointNumber});
        //     if (markerList.length) {
        //         locations.map.setCenter(markerList[0]);
        //         createMarkers(markerList, 'content/images/markersPoint.png', locations.map)
        //     }
        //     chainageList.sort(function(a, b) { return a.routePointNumber - b.routePointNumber});
        //     if (chainageList.length) {
        //         locations.map.setCenter(chainageList[0]);
        //         createMarkers(chainageList, 'content/images/chainagePoints.png', locations.map)
        //     }
        // }


        //Functions

        function addClick(item) {
            // Add a click event listener to the map
            item.addListener("click", function (event) {
                if (markers.length < 2) {
                    // Add a marker to the map
                    addMarker(event.latLng);

                    // Get the latitude and longitude of the clicked point
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }


        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                addClick(marker)
                arr.push(marker);
            })
        }

        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = labelFrom
            } else if (markers.length == 1) {
                markerText = labelTo
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: "content/images/sections.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        -4
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
                label: {
                    text: markerText,
                }
            });

            // Add the marker to the markers array
            markers.push(marker);
        }


        if (vm.trTerrain.id && vm.trTerrain.fromRoutePoint && vm.trTerrain.toRoutePoint) {
            addMarker({ lat: vm.trTerrain.fromRoutePoint.latitude, lng: vm.trTerrain.fromRoutePoint.longitude })
            addMarker({ lat: vm.trTerrain.toRoutePoint.latitude, lng: vm.trTerrain.toRoutePoint.longitude })
            locations.map.setCenter({ lat: vm.trTerrain.fromRoutePoint.latitude, lng: vm.trTerrain.fromRoutePoint.longitude });
        }

        $('.select2').select2();
    }
})();


(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrTerrainDetailController', TrTerrainDetailController);

    TrTerrainDetailController.$inject = ['$scope', '$rootScope', 'entity', '$window', '$localStorage'];

    function TrTerrainDetailController($scope, $rootScope, entity, $window, $localStorage) {
        var vm = this;

        vm.trTerrain = entity;
        var unsubscribe = $rootScope.$on('trakeyeApp:trTerrainUpdate', function (event, result) {
            vm.trTerrain = result;
        });

        $scope.$on('$destroy', unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };

        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };
        $scope.setTab = function (newTab) {
            if(newTab == 2){
                //Comment Box
            vm.objectComments = {}
            vm.objectComments.entityId = entity.id
            vm.objectComments.entityName = "TERRAIN"
            } 
            $scope.tab = newTab;
        };

       /*  vm.objectComments = {}
        vm.objectComments.entityId = entity.id
        vm.objectComments.entityName = "TERRAIN" */

    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-terrain', {
                parent: 'app',
                url: '/tr-terrain',
                data: {
                    authorities: ['SECTION_SIDEBAR'],
                    pageTitle: 'trakeyeApp.terrain.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrains.html',
                        controller: 'TrTerrainController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    projectId: null,
                    routeId : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            projectId: $stateParams.projectId,
                            routeId :  $stateParams.routeId,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trTerrain');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-terrain-detail', {
                parent: 'tr-terrain',
                url: '/tr-terrain/{id}',
                data: {
                    authorities: ['SECTION_DETAIL'],
                    pageTitle: 'trakeyeApp.terrain.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrain-detail.html',
                        controller: 'TrTerrainDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trTerrain');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrTerrain', function ($stateParams, TrTerrain) {
                        return TrTerrain.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-terrain',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('tr-terrain.new', {
                parent: 'tr-terrain',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}/{routeId}/{sectionId}',
                data: {
                    authorities: ['SECTION_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrain-dialog.html',
                        controller: 'TrTerrainDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            terrainImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

        .state('tr-terrain.import', {
                parent: 'tr-terrain',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrain-import.html',
                        controller: 'TrTerrainImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            terrainImages: []
                        };
                    }
                }

            })
            .state('tr-terrain.edit', {
                parent: 'tr-terrain',
                url: '/Edit/{id}/{routeId}/{sectionId}',
                data: {
                    authorities: ['SECTION_EDIT'],
                    pageTitle: 'trakeyeApp.terrain.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-terrain/tr-terrain-dialog.html',
                        controller: 'TrTerrainDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrTerrain', function ($stateParams, TrTerrain) {
                        return TrTerrain.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-terrain',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })
    }
})();
(function () {
    "use strict";
    angular.module("trakeyeApp").factory("TrTerrain", TrTerrain);

    TrTerrain.$inject = ["$resource", "DateUtils"];

    function TrTerrain($resource, DateUtils) {
        var resourceUrl = "api/tr-terrains/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrTerrainById", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.get = function (id, callback) {
                $http.get("api/tr-terrains/" + id).then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrTerrainSearch", TrTerrainSearch);

    TrTerrainSearch.$inject = ["$resource"];

    function TrTerrainSearch($resource) {
        var service = $resource(
            "/api/tr-terrains/searchvalue/:search",
            {},
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllTerrainTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/terrain-alltypes').then(function (response) {
				callback(response.data);
			});
		};
		
		service.saveTerrainWithRoutepoints = function (terraintWithRoutePoints, callback) {
			$http.post('api/tr-terrains/newSurvey',terraintWithRoutePoints).then(function (response) {
				callback(response.data);
			});
		};
		service.saveRowWithRoutepoints = function (rowWithRoutePoints, callback) {
			$http.post('api/tr-rows/newSurvey',rowWithRoutePoints).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrTerrainController", TrTerrainController);

    TrTerrainController.$inject = [
        "$scope",
        "$state",
        "TrTerrain",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "TrTerrainSearch"
    ];

    function TrTerrainController(
        $scope,
        $state,
        TrTerrain,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        TrTerrainSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        vm.createTerrain = createTerrain;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var searchVal = $scope.search.replace(/[^\w\s]/g, '_');
                TrTerrainSearch.query(
                    {
                        search: searchVal,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.terrains = data;
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function createTerrain() {
            $state.go("tr-terrain.new");
        }

        function loadAll() {
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }
            TrTerrain.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.terrains = data;
                    vm.page = pagingParams.page;
                },
                onError
            );
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                //  result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ){
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrTaskDialogController", TrTaskDialogController);

    TrTaskDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrTask",
        "AllTaskTypes",
        "AllCustomTaskTypeAttribute",
        "TaskAttributeMappingId",
        "Configs",
        "RouteTypeSearch",
        "ActivatedUserSearch",
        "$window",
        "AlertService",
        "$rootScope",
        "TaskSectionById",
        "TaskRouteById",
        "TrUserTask",
        "AllVendorIds",
        "UsersByVendorId",
        "section",
        "TaskPathById"
    ];

    function TrTaskDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrTask,
        AllTaskTypes,
        AllCustomTaskTypeAttribute,
        TaskAttributeMappingId,
        Configs,
        RouteTypeSearch,
        ActivatedUserSearch,
        $window,
        AlertService,
        $rootScope,
        TaskSectionById,
        TaskRouteById,
        TrUserTask,
        AllVendorIds,
        UsersByVendorId,
        section,
        TaskPathById
    ) {
        var vm = this;
        vm.trTask = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trTask);
        vm.selectAttributes = selectedTaskTypeAttributes;
        vm.taskType = entity.taskType;
        vm.filterActivatedUser = filterActivatedUser;
        var usersMap = {};
        vm.findUsers = findUsers;

        var infowindow = new google.maps.InfoWindow();
        var openedInfoWindow = null;
        var btnAddSection;

        if ($state.params.routeId) {
            vm.trTask.routeId = parseInt($state.params.routeId, 10);
        }

        if ($state.params.sectionId) {
            vm.trTask.sectionId = parseInt($state.params.sectionId, 10);
            vm.trTask.routeId = null; // If section Id is available task is created using Section
        }

        vm.customAttributesMap = {};
        vm.customAttributesMapp = [];
        loadPage();
        var markersSection = []

        if (!vm.trTask.id) {
            vm.trTask.status = "NEW"
        }

        Configs.get("RolloutTaskStatus", function (response) {
            vm.rolloutTaskStatus = response;
        });


        AllVendorIds.getAll(function (response) {
            if (response.length) {
                vm.vendorList = response.sort(function (a, b) {
                    var nameA = a.name.toUpperCase();
                    var nameB = b.name.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0; // Names are equal
                });

                if (vm.trTask.id && vm.trTask.assignedUserId) {
                    vm.userList = [];
                    response.forEach(function (item) {
                        UsersByVendorId.get(item.id, function (response) {
                            response.forEach(function (user) {
                                if (vm.trTask.assignedUserId == user.id) {
                                    vm.trTask.assignedUserId = user.id;
                                    vm.selectedVendor = item.id;
									$timeout(function () {
    									$('.select2').trigger('change.select2');
									});
                                }
                                var hasRequiredRole = user.authorities.some(function (userAuth) {
                                    return userAuth === 'ROLE_PLAN_SURVEY' || userAuth === 'ROLE_PLAN_ADMIN';
                                });

                                if (hasRequiredRole) {
                                    // Push the user details to the list
                                    vm.userList.push({ name: user.login + " - " + user.authorities.join(', '), id: user.id });
                                }
                            });
                        });
                    })
                }else{
					vm.userList = [];
                    response.forEach(function (item) {
                        UsersByVendorId.get(item.id, function (response) {
                            response.forEach(function (user) {
                                var hasRequiredRole = user.authorities.some(function (userAuth) {
                                    return userAuth === 'ROLE_PLAN_SURVEY' || userAuth === 'ROLE_PLAN_ADMIN';
                                });

                                if (hasRequiredRole) {
                                    vm.userList.push({ name: user.login + " - " + user.authorities.join(', '), id: user.id });
                                }
                            });
                        });
                    })
					}
            }
        });

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        if (vm.trTask.id != null) {
            vm.trTaskType = vm.trTask.taskType;
        }

        function loadPage() {

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
                );
                imgWindow.document.close();
            };

            var taskTypeAttributeValuesList =
                vm.trTask.taskTypeAttributeValues;

            try {
                for (var index in vm.trTask.taskType.taskTypeAttributes) {
                    if (
                        !checkIfTaskTypeExists(
                            vm.trTask.taskType.taskTypeAttributes[index],
                            vm.trTask.taskTypeAttributeValues
                        )
                    ) {
                        var taskTypeAttribute1 =
                            vm.trTask.taskType.taskTypeAttributes[index];
                        taskTypeAttributeValuesList.push({
                            taskTypeAttribute: taskTypeAttribute1,
                            attributeValue:
                                vm.trTask.taskType.taskTypeAttributes[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) { }

            function checkIfTaskTypeExists(taskType, taskTypeAttrVal) {
                var hasTaskType = false;
                for (var i = 0; i < taskTypeAttrVal.length; i++) {
                    var name = taskTypeAttrVal[i].taskTypeAttribute.name;
                    if (name == taskType.name) {
                        hasTaskType = true;
                        break;
                    }
                }
                return hasTaskType;
            }
            AllTaskTypes.getAll(function (response) {
                vm.taskTypes = response;
            });

            AllCustomTaskTypeAttribute.getAll(function (response) {
                //vm.customTaskTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if (arrayItem.customTaskTypeAttributeValues != undefined) {
                        vm.customAttributesMap[arrayItem.name] =
                            arrayItem.customTaskTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }

                });
                if (vm.trTask.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });


        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function selectedTaskTypeAttributes() {
            vm.showFilter = true;
            if (vm.taskType) {
                vm.trTask.taskType = vm.taskType;
                if (
                    entity_old.taskType &&
                    vm.taskType.id === entity_old.taskType.id
                ) {
                    vm.trTask.taskTypeAttributeValues = [];
                    vm.trTask.taskTypeAttributeValues =
                        entity_old.taskTypeAttributeValues;
                } else {
                    vm.trTask.taskTypeAttributeValues = [];
                    $.each(
                        vm.taskType.taskTypeAttribute,
                        function (key, value) {
                            vm.trTask.taskTypeAttributeValues.push({
                                taskTypeAttribute:
                                    vm.taskType.taskTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        function filterActivatedUser() {
            if (vm.trTask.assignedToUser != null && vm.trTask.assignedToUser != "" && !angular.isUndefined(vm.trTask.assignedToUser)) {
                ActivatedUserSearch.query({
                    userId: vm.trTask.assignedToUser,
                }, onSuccess, onError);

                function onSuccess(data, headers) {
                    vm.activatedusers = [];
                    data.forEach(function (dataVal) {
                        vm.activatedusers.push(dataVal);
                    });
                    $scope.showResults = true;

                    angular.forEach(vm.activatedusers, function (value, key) {
                        usersMap[value.login] = value.id;
                    });
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }
        }

        $scope.assignUser = function (user) {
            // Implement the logic to assign the selected user
            vm.trTask.assignedToUser = user
            $scope.showResults = false;
            vm.assignToModified = true
        };


        function save() {
            var spreadAV = vm.trTask.taskTypeAttributeValues;
            for (
                var spreadAssetIndex = 0;
                spreadAssetIndex < spreadAV.length;
                spreadAssetIndex++
            ) {
                if (
                    spreadAV[spreadAssetIndex].taskTypeAttribute
                        .name === "Fiber Distance (km)"
                ) {
                    spreadAV[
                        spreadAssetIndex
                    ].attributeValue = fiberDistance;
                }
            }
            vm.trTask.taskTypeAttributeValues = spreadAV;
            var assignedToUser = $("#field_assignedToUser").val();
            vm.trTask.assignedToUser = assignedToUser;

            callTask()
        }

        function callTask() {
            if (markers.length == 2) {
                markers.forEach(function (item) {
                    if (item.label.text == labelFrom || item.label.text == labelTo) {
                        if (item.label.text == labelFrom) {
                            if (vm.trTask.id) {
                                vm.trTask.fromRoutePoint.latitude = item.position.lat()
                                vm.trTask.fromRoutePoint.longitude = item.position.lng()
                            } else {
                                vm.trTask.fromRoutePoint = {
                                    "latitude": item.position.lat(), "longitude": item.position.lng()
                                };
                            }
                        }

                        if (item.label.text == labelTo) {
                            if (vm.trTask.id) {
                                vm.trTask.toRoutePoint.latitude = item.position.lat()
                                vm.trTask.toRoutePoint.longitude = item.position.lng()
                            } else {
                                vm.trTask.toRoutePoint = {
                                    "latitude": item.position.lat(), "longitude": item.position.lng()
                                };
                            }
                        }
                    }
                });
                if (vm.trTask.id) {
                    if (vm.trTask.verified) {
                        vm.trTask.approvedByUserId = $rootScope.loginUserId
                    }

                    /*  if(vm.assignToModified){
                         var projectId,routeId,sectionId
                         if(vm.trTask.sectionTask.length){
                             projectId = vm.trTask.sectionTask[0].projectId;
                             routeId = vm.trTask.sectionTask[0].routeId;
                             sectionId = vm.trTask.sectionTask[0].sectionId;
 
                         }else if(vm.trTask.routeTask.length){
                             projectId = vm.trTask.routeTask[0].projectId;
                             routeId = vm.trTask.routeTask[0].routeId;
                             sectionId = vm.trTask.routeTask[0].sectionId;
                         }
                         var data = {
                             "id": null,
                             "task":{
                                 "id": vm.trTask.id
                             
                             },
                           "userId": $rootScope.loginUserId,
                           "tenantId": vm.trTask.tenantId,
                             "project":{
                                 "id": projectId
                             
                             },
                             "route":{
                                 "id": routeId
                             
                             },
                             "section":{
                                 "id": sectionId
                             
                             }
                         }
                         TrUserTask.update(data)
                     } */
                    TrTask.update(vm.trTask, onSaveSuccess, onSaveError)
                } else {
                    // $scope.uuid = generateUUID();
                    // vm.trTask.sessionNumber = $scope.uuid;
                    TrTask.save(vm.trTask, onSaveSuccess, onSaveError);
                }
            } else {
                  //alert("Please select Task From and To Points on the Map")
				markers.forEach(function (item) {
                    if (item.label.text == labelFrom || item.label.text == labelTo) {
                        if (item.label.text == labelFrom) {
                            if (vm.trTask.id) {
                                vm.trTask.fromRoutePoint.latitude = item.position.lat()
                                vm.trTask.fromRoutePoint.longitude = item.position.lng()
                            } else {
                                vm.trTask.fromRoutePoint = {
                                    "latitude": item.position.lat(), "longitude": item.position.lng()
                                };
                            }
                        }

                        if (item.label.text == labelTo) {
                            if (vm.trTask.id) {
                                vm.trTask.toRoutePoint.latitude = item.position.lat()
                                vm.trTask.toRoutePoint.longitude = item.position.lng()
                            } else {
                                vm.trTask.toRoutePoint = {
                                    "latitude": item.position.lat(), "longitude": item.position.lng()
                                };
                            }
                        }
                    }
                });
				if (vm.trTask.id) {
					TrTask.update(vm.trTask, onSaveSuccess, onSaveError)
				}else{
					TrTask.save(vm.trTask, onSaveSuccess, onSaveError);
				}
				
            }
        }

        function onSaveSuccess(result) {
            $window.history.back();
        }

        function onSaveError() {
        }


        Configs.get("WorkFlowStatus", function (response) {
            vm.workFlowStatus = [];
            var workFlowStatusList = response[0].configValue.split(",");
            workFlowStatusList.forEach(function (value) {
                if (value.length > 0) {
                    vm.workFlowStatus.push({ "configKey": value, "configValue": value });
                }
            });
        });

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = response;
            //vm.workFlow.phase = "Planning Phase"
            /*  if(vm.workFlow.id == null){
                response.forEach(function(val){
                    if(val.configValue == '01'){
                        vm.workFlow.phase = val.configKey
                    }
                })
            }*/
        });


        /*  ActivatedUserSearch.query(
             {
                 // userId: vm.workFlow.assignedToUser,
                 userId: vm.workFlow.groups[0].id,
                 user: vm.user,
             },
             onSuccess,
             onError
         );
 
         function onSuccess(data, headers) {
             data.forEach(function (users) {
                 vm.assignedUsers.push(users.login);
             });
             vm.activatedusers = data;
 
             angular.forEach(vm.activatedusers, function (value, key) {
                 usersMap[value.login] = value.id;
             });
         }
         function onError(error) {
             AlertService.error(error.data.message);
         } */

        /*  RouteTypeSearch.query({userId:$scope.search,
             page: pagingParams.page - 1,
             size: vm.itemsPerPage,
             sort: sort()
         }, onSuccess, onError);
         function sort() {
             var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
             if (vm.predicate !== 'id') {
               //  result.push('id');
             }
             return result;
         }
         function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.routeTypes = data;
             vm.page = pagingParams.page;
     
         }
         function onError(error) {
             AlertService.error(error.data.message);
         } */

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        //Task Map 
        var markers = []
        var coordinateList = []
        var chainageList = []
        var markerList = []
        var iconSize = 20
        var labelFrom, labelTo
        labelFrom = 'A'
        labelTo = 'B'
        var locations = {};

        locations.map = new google.maps.Map(
            document.getElementById("map_canvasStart"),
            {
                center: {
                    lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                    lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                },
                zoom: $rootScope.rolloutMapInitZoom,
                fullscreenControl: true,
                styles: mapStyles(),
            }
            //myOption(16, vm.getCenterStart)
        );

        vm.removeMarker = function () {
            markers.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the markers array
            markers = [];

        }

        function addClick(item) {
            // Add a click event listener to the map
            item.addListener("click", function (event) {
                if (markers.length < 2) {
                    // Add a marker to the map
                    addMarker(event.latLng);

                    // Get the latitude and longitude of the clicked point
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }


        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                google.maps.event.addListener(
                    marker,
                    "click",
                    (function () {
                        //var name = (each.name == (undefined || null)) ? " " : each.name
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var userContent = document.createElement("div")

                        userContent.innerHTML = '<div class="infoWindowhead"></br></br>' +
                            /* "<b>Name : "+name+"</b></br>"+ */
                            "<b>Latitude : " + each.lat + "</b></br>" +
                            "<b>Longitude : " + each.lng + "</b></br>" +
                            "<b>Type : " + each.type + "</b></br>" +
                            "<b>Number : " + each.number + "</b></br>" +
                            "</br></div>"
                        infowindow.setContent(
                            userContent
                        );

                        infowindow.open(map);
                        infowindow.setPosition({
                            lat: each.lat,
                            lng: each.lng,
                        });
                        openedInfoWindow = infowindow;

                        if (markers.length < 2) {
                            btnAddSection = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnAddSection.type = "button";

                            btnAddSection.value = "Add Task Point";

                            btnAddSection.className = "button";

                            btnAddSection.addEventListener("click", function () {
                                if (markers.length < 2) {
                                    // Add a marker to the map
                                    addMarker({
                                        lat: each.lat,
                                        lng: each.lng,
                                    });
                                    // Get the latitude and longitude of the clicked point
                                    vm.pinLat = each.lat;
                                    vm.pinLong = each.lng;
                                    openedInfoWindow.close();
                                } else {
                                    alert("From and To Task Exists");
                                }
                            })
                        }
                    }))

                //addClick(marker)
                arr.push(marker);
            })
        }

        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = labelFrom
            } else if (markers.length == 1) {
                markerText = labelTo
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: markerText,
                },
                draggable: true
            });

            // Add the marker to the markers array
            markers.push(marker);
        }

        if (vm.trTask.sectionId != null) {
            TaskSectionById.get(vm.trTask.sectionId, function (sectionVal) {
                showPathOnMap(sectionVal, coordinateList, chainageList, locations, addClick, createMarkers);
            });
        }

        if (vm.trTask.sectionId == null && vm.trTask.routeId != null) {
            TaskRouteById.get(vm.trTask.routeId, function (routeVal) {
                showPathOnMap(routeVal, coordinateList, chainageList, locations, addClick, createMarkers);
            });
        }

        function showPathOnMap(sectionVal, coordinateList, chainageList, locations, addClick, createMarkers) {
			var groupedRoutePoints = {};           
            if (sectionVal.COORDINATE != null) {
				var sortedCoordinate= sectionVal.COORDINATE.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
				  sortedCoordinate.forEach(function (coor) {
					
					if (coor.routePointType == "COORDINATE" && coor.phase != null) {
					                    if (coor.sessionNumber) {
					                        if (!groupedRoutePoints[coor.sessionNumber]) {
					                            groupedRoutePoints[coor.sessionNumber] = [];
					                        }
					                        groupedRoutePoints[coor.sessionNumber].push(coor);
					                    }
                }
            });
			}
			Object.keys(groupedRoutePoints).forEach(function (sessionNumber) {
				coordinateList=[];
			              var sessionPoints = groupedRoutePoints[sessionNumber];
			              sessionPoints.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
			              if (sessionPoints.length > 1) {
			                  sessionPoints.forEach(function (each) {
								coordinateList.push({ lat: each.latitude, lng: each.longitude });
							  });
							}  
							if (coordinateList.length) {
							               locations.map.setCenter(coordinateList[0]);
							               var polyline = new google.maps.Polyline({
							                   path: coordinateList,
							                   geodesic: true,
							                   strokeColor: '#FD7A24',
							                   strokeOpacity: 1.0,
							                   strokeWeight: 4,
							               });

							               // Set the map to display the polyline
							               polyline.setMap(locations.map);
							               addClick(polyline);
							           }
			});
            if (sectionVal.CHAINAGE != null) {
                sectionVal.CHAINAGE.forEach(function (chainageVal) {
                    chainageList.push({ lat: chainageVal.latitude, lng: chainageVal.longitude, type: chainageVal.routePointType, number: chainageVal.routePointNumber });
                });
            }
            if (chainageList.length) {
                locations.map.setCenter(chainageList[0]);
                createMarkers(chainageList, 'content/images/chainagePoints.png', locations.map);
            }
        }


        // if (section && section.id && section.fromRoutePoint && section.toRoutePoint) {
        //     addMarkerSection({ lat: section.fromRoutePoint.latitude, lng: section.fromRoutePoint.longitude }, "From Section")
        //     addMarkerSection({ lat: section.toRoutePoint.latitude, lng: section.toRoutePoint.longitude }, "To Section")
        //     locations.map.setCenter({ lat: section.fromRoutePoint.latitude, lng: section.fromRoutePoint.longitude });
        // }

        if (vm.trTask && vm.trTask.id && vm.trTask.fromRoutePoint && vm.trTask.toRoutePoint) {
            addMarker({ lat: vm.trTask.fromRoutePoint.latitude, lng: vm.trTask.fromRoutePoint.longitude })
            addMarker({ lat: vm.trTask.toRoutePoint.latitude, lng: vm.trTask.toRoutePoint.longitude })
            locations.map.setCenter({ lat: vm.trTask.fromRoutePoint.latitude, lng: vm.trTask.fromRoutePoint.longitude });
        }

        function findUsers() {
            UsersByVendorId.get(vm.selectedVendor, function (response) {
                vm.userList = [];
                response.forEach(function (user) {
                    var hasRequiredRole = user.authorities.some(function (userAuth) {
                        return userAuth === 'ROLE_PLAN_SURVEY' || userAuth === 'ROLE_PLAN_ADMIN';
                    });

                    if (hasRequiredRole) {
                        // Push the user details to the list
                        vm.userList.push({ name: user.login + " - " + user.authorities.join(', '), id: user.id });
                    }


                });
            });
        }

        function addMarkerSection(location, text) {
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: "content/images/sections.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        -4
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
                label: {
                    text: text,
                }
            });

            // Add the marker to the markers array
            markersSection.push(marker);
        }

        vm.objectRouteImg = {}
        vm.objectRouteImg.routeId = $state.params.routeId
        vm.objectRouteImg.map = locations.map

        $('.select2').select2();

        geoLocation(locations.map);

        function geoLocation(map) {
            var goTo = document.createElement("span");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            gotoIcon.classList.add("mt-5");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);
            goTo.addEventListener("click", function () {
                vm.removeMarker()
                $("#modalLatLongs").show();
            });
        }

        vm.closeModal = function (id) {
            vm.getLocationCoordinateA = null
            vm.getLocationCoordinateB = null

            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

        vm.onLocationCoordinates = function () {
            var latlngA = vm.getLocationCoordinateA.split(",");
            var latlngB = vm.getLocationCoordinateB.split(",");

            addMarker({ lat: parseFloat(latlngA[0]), lng: parseFloat(latlngA[1]) })
            addMarker({ lat: parseFloat(latlngB[0]), lng: parseFloat(latlngB[1]) })

            locations.map.setCenter({ lat: parseFloat(latlngB[0]), lng: parseFloat(latlngB[1]) })
            vm.closeModal('modalLatLongs')
        }

        google.maps.event.addListener(locations.map, "click", function (event) {
            if (markers.length < 2) {
                // Add a marker to the map
                addMarker(event.latLng);
            } else {
                console.log("Maximum 2 markers allowed.");
            }
        });
    }
})();



(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrTaskDetailController", TrTaskDetailController);

    TrTaskDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "TrTask",
        "User",
        "TaskType",
        "TrTaskImages",
        "TrTaskRecordings",
        "AlertService",
        "$window",
        "$localStorage",
        "getTaskImage",
        "Configs",
        "dailyLogByTaskId",
        "taskComment",
        "DailyLogs",
        "SummaryPost",
        "TaskPathById",
        "pagingParams",
        "paginationConstants",
        "ParseLinks",
        "$state",
        "assignee",
        "TaskLogTaskReportData",
        "DailyLogByTaskIdWithType",
        "imageRoutePoint",
        "DailyLogByTaskIdWithTypePagination"
    ];

    function TrTaskDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        TrTask,
        User,
        TaskType,
        TrTaskImages,
        TrTaskRecordings,
        AlertService,
        $window,
        $localStorage,
        getTaskImage,
        Configs,
        dailyLogByTaskId,
        taskComment,
        DailyLogs,
        SummaryPost,
        TaskPathById,
        pagingParams,
        paginationConstants,
        ParseLinks,
        $state,
        assignee,
        TaskLogTaskReportData,
        DailyLogByTaskIdWithType,
        imageRoutePoint,
        DailyLogByTaskIdWithTypePagination
    ) {
        var vm = this;

        vm.trTask = entity;
        vm.trTask.assignee = assignee;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        //vm.transition = transition;
        vm.progresstransition = progresstransition;
        vm.obstacletransition = obstacletransition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.progressitemsPerPage = paginationConstants.progressitemsPerPage;
        vm.obstacleitemsPerPage = paginationConstants.obstacleitemsPerPage;
        vm.showTaskLogReport = showTaskLogReport;
        var unsubscribe = $rootScope.$on(
            "trakeyeApp:trTaskUpdate",
            function (event, result) {
                vm.trTask = result;
            }
        );
        vm.showTaskAttachment = false;
        var locations = {};
        var openedInfoWindow = null;
        var markers = [];
        var coordinateList = [];
        var chainageList = [];
        var markerList = [];
        var iconSize = 20;
        var hexColors = [
            "#FF5733",
            "#45B39D",
            "#9B59B6",
            "#F4D03F",
            "#3498DB",
            "#E74C3C",
            "#2ECC71",
            "#1ABC9C",
            "#D35400",
            "#8E44AD",
            "#27AE60",
            "#2980B9",
            "#C0392B",
            "#16A085",
            "#9B59B6",
            "#7F8C8D",
            "#F39C12",
        ];
        var center = {
            lat: parseFloat($rootScope.DEFAULT_LATITUDE),
            lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
        };

        locations.map = new google.maps.Map(
            document.getElementById("map_canvasStart"),
            myOption(16, center)
        );

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }
        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        vm.dailyLogs = [];
        vm.obstacleLogs = []

        callLogs()
        function callLogs() {
            // dailyLogByTaskId.query(
            //     {
            //         search: $scope.search,
            //         page: 0,
            //         size: 65, //vm.itemsPerPage
            //         sort: sort(),
            //         id: entity.id
            //     },
            //     function (response, headers) {
            //         vm.links = ParseLinks.parse(headers("Link"));
            //         vm.totalItems = headers("X-Total-Count");
            //         vm.queryCount = vm.totalItems;
            //         //vm.page = pagingParams.page;

            //         if (response.length) {
            //             vm.obstacleLogs = response.filter(function (each) {
            //                 return each.taskLogType == "OBSTACLE"
            //             })

            //             vm.dailyLogs = response.filter(function (each) {
            //                 return each.taskLogType == "PROGRESS"
            //             })
            //             showMapData();
            //         }
            //     }
            // );

            DailyLogByTaskIdWithType.query(
                {
                    id: entity.id,
                    type: 'PROGRESS'

                },
                onProgressSuccess,
                onProgressError
            );

            function onProgressSuccess(response) {
                vm.dailyLogs = response;

                if (vm.dailyLogs.length) {
                    callRouteImage(vm.dailyLogs, locations.map)
                    /* vm.dailyLogs.forEach(function(item){
                    imageRoutePoint.getUserTaskLogImages(item.id,function(){
                        callRouteImage(item,locations.map)
                    })
                    }) */
                }
                vm.dailyLog_map = new google.maps.Map(
                    document.getElementById("map_canvasStart1"),
                    myOption(16, center)
                )
                vm.dailyLogPolyline = {}
                var bounds = new google.maps.LatLngBounds();

                vm.dailyLogs.forEach(function (coor, index) {

                    var fromLatLng = { lat: coor.fromRoutePointLat, lng: coor.fromRoutePointLng };
                    var toLatLng = { lat: coor.toRoutePointLat, lng: coor.toRoutePointLng };
                    bounds.extend(fromLatLng);
                    bounds.extend(toLatLng);
                    var polyline = new google.maps.Polyline({
                        path: [fromLatLng, toLatLng],
                        geodesic: true,
                        strokeColor: '#00e658',
                        strokeOpacity: 1.0,
                        strokeWeight: 5,
                        zIndex: 2
                    });
                    polyline.setMap(vm.dailyLog_map);
                    vm.dailyLogPolyline[coor.id] = polyline;
                });
                vm.dailyLog_map.fitBounds(bounds);
                vm.startPoint = null;
                vm.endPoint = null;
                vm.highlightLog = function (id) {
                    var polyline = vm.dailyLogPolyline[id];
                    if (polyline) {
                        polyline.setOptions({
                            strokeWeight: 14
                        });
                        var path = polyline.getPath().getArray();
                        var fromLatLng = path[0];
                        var toLatLng = path[path.length - 1];
                        if (vm.startPoint) {
                            vm.startPoint.setMap(null);
                        }
                        if (vm.endPoint) {
                            vm.endPoint.setMap(null);
                        }
                        vm.startPoint = new google.maps.Marker({
                            position: fromLatLng,
                            map: vm.dailyLog_map,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/sections.png",
                                anchor: new google.maps.Point(
                                    iconSize / 2,
                                    -4
                                ),
                                labelOrigin: new google.maps.Point(25, 22)
                            },
                            label: {
                                text: 'Start',
                                color: '#000000',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }
                        });
                        vm.endPoint = new google.maps.Marker({
                            position: toLatLng,
                            map: vm.dailyLog_map,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/sections.png",
                                anchor: new google.maps.Point(
                                    iconSize / 2,
                                    -4
                                ),
                                labelOrigin: new google.maps.Point(25, 22)
                            },
                            label: {
                                text: 'End',
                                color: '#000000',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }
                        });
                    }
                };
                vm.resetLog = function () {
                    Object.keys(vm.dailyLogPolyline).forEach(function (key) {
                        var polyline = vm.dailyLogPolyline[key];
                        if (polyline) {
                            polyline.setOptions({
                                strokeWeight: 5
                            });
                        }
                    });
                    if (vm.startPoint) {
                        vm.startPoint.setMap(null);
                        vm.startPoint = null;
                    }
                    if (vm.endPoint) {
                        vm.endPoint.setMap(null);
                        vm.endPoint = null;
                    }
                };
                TaskPathById.get(entity.id, function (response) {
                    if (response.COORDINATE !== undefined) {
                        var polylineCoordinates = [];
                        response.COORDINATE.forEach(function (coordinate) {
                            if (coordinate.routePointType === 'COORDINATE') {
                                var latLng = {
                                    lat: coordinate.latitude,
                                    lng: coordinate.longitude
                                };
                                polylineCoordinates.push(latLng);
                            }
                        });
                        var polyline = new google.maps.Polyline({
                            path: polylineCoordinates,
                            geodesic: true,
                            strokeColor: '#ff9a8a',
                            strokeOpacity: 0.5,
                            strokeWeight: 4,
                            zIndex: 1
                        });
                        polyline.setMap(vm.dailyLog_map);
                    }
                });
                DailyLogByTaskIdWithType.query(
                    {
                        id: entity.id,
                        type: 'OBSTACLE'

                    },
                    onObstacleSuccess,
                    onObstacleError
                );

                function onObstacleSuccess(response) {
                    vm.obstacleLogs = response;

                    if (vm.obstacleLogs.length) {
                        callRouteImage(vm.obstacleLogs, locations.map)
                        /*  vm.obstacleLogs.forEach(function(item){
                             imageRoutePoint.getUserTaskLogImages(item.id,function(){
               zz                  callRouteImage(item,locations.map)
                             })
                         }) */
                    }

                    showMapData();
                }
                function onObstacleError(error) {
                    AlertService.error(error.data.message);
                }
            }
            function onProgressError(error) {
                AlertService.error(error.data.message);
            }



            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            TaskPathById.get(entity.id, function (response) {
                drawPolygon(entity.id, response, {}, 10, 1, "task", false, 1);
                if (response.COORDINATE != undefined) {
                    if (response.COORDINATE.length > 0) {
                        locations.map.setCenter({ lat: response.COORDINATE[0].latitude, lng: response.COORDINATE[0].longitude });
                    }
                }
            });
        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }


        Configs.get("TaskImage", function (response) {
            if (response.length > 0) {
                if (response[0].configValue == "True") {
                    vm.showTaskAttachment = true;
                }
            }
        });

        vm.imageInNewTab = function (img) {
            var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' + img + '">'
            );
            imgWindow.document.close();
        };

        $scope.newTabDisplay = function (id) {
            var request = new XMLHttpRequest();
            request.open(
                "GET",
                "api/trakeyetaskimages/" + vm.trTask.id + "/" + id,
                true
            );
            request.setRequestHeader(
                "Authorization",
                "Bearer " + $localStorage.authenticationToken
            );
            request.responseType = "blob";
            request.onload = response;

            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    window.open(imageUrl, "_blank");
                }
            }
            request.send();
        };

        $scope.$on("$destroy", unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };

        $scope.allimages = false;
        //		$scope

        function getRandomString(arr) {
            var randomIndex = Math.floor(Math.random() * arr.length);
            return arr[randomIndex];
        }

        function drawPolygon(id, value, details, zIndex, strokeWeight, type, canClick, zIndexVal) {

            var verified = details.verified ? "<b>Verified : " + details.verified + "</b></br>" : ""
            if (value.COORDINATE == undefined) {
                value = value.value;
            }
            if (value == undefined) {
                return;
            }
            if(value.COORDINATE.length){
             var latlng = {
                       lat: value.COORDINATE[0].latitude,
                       lng: value.COORDINATE[0].longitude,
             };
            }else{
              var latlng = {
                      lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                      lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
             };
            }
           
            // value.COORDINATE.sort(function (a, b) { return a.id - b.id });
            var path = [];
            if (value.COORDINATE != null) {
                value.COORDINATE.forEach(function (location) {
                    path.push({ lat: location.latitude, lng: location.longitude });
                });
            }

            var infowindow = new google.maps.InfoWindow({
                content:
                    '<div class="infoWindowhead">' +
                    "name" +
                    '<div class="infoWindowContent"> <b>ID :</b> ' +
                    id +
                    "</div></div>",
            });

            infowindow.setPosition(latlng);

            var marker = new google.maps.Marker({
                position: latlng,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(20, 20),
                    url: "content/images/dot_marker.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        iconSize / 2
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
            });
            // var strokeColor = "#ff6a08";

            // if (color == "green") {
            //     strokeColor = "#00e658";
            // } else if (color == "blue") {
            //     strokeColor = "#0066CC";
            // }
            var strokeOpacity = 1.0;
            var strokeColor = "#00e658";
            strokeColor = getRandomString(hexColors);
            if (type == "task") {
                //strokeColor = "#0066CC";
                strokeColor = "#8a0101";
                strokeOpacity = 0.3;
            } else if (type == "PROGRESS") {
                strokeColor = "#00e658";
            } else if (type == "OBSTACLE") {
                strokeColor = "#ff0000";
            } else {
                strokeColor = "#b5b0b0"
            }
            var polyline = new google.maps.Polyline({
                path: path,
                geodesic: true,
                strokeColor: strokeColor,
                strokeOpacity: strokeOpacity,
                strokeWeight: 4,
                zIndex: zIndexVal
            });
            var disVal = 0;
            if (path.length > 0) {
                for (var index in path) {
                    if (index > 0) {
                        disVal += distanceCal(path[index].lat, path[index].lng, path[index - 1].lat, path[index - 1].lng);
                    }
                }
            }
            // Set the map to display the polyline
            polyline.setMap(locations.map);

            google.maps.event.addListener(
                polyline,
                "mouseout",
                function (event) {
                    infowindow.close();
                }
            );


            if (canClick) {
                google.maps.event.addListener(
                    polyline,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead"></br></br>' +
                            "<b>Date : " + new Date(details.workDate).toString("yyyy-MM-dd HH:mm") + "</b></br>" +
                            "<b>Length : " + details.workLength + "</b></br>" +
                            "<b>Hours : " + details.numberOfHours + "</b><br>" +
                            "<b>Created by : " + details.createdBy + "</b></br>" +
                            "<b>Type : " + details.taskLogType + "</b></br>" +
                            verified +
                            "</br></div>"
                        );

                        infowindow.mousemove;
                        infowindow.open(locations.map);
                        infowindow.setPosition(latlng);
                        openedInfoWindow = infowindow;

                    }
                );
            }

            if (canClick) {
                google.maps.event.addListener(
                    polyline,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead"><b>' +
                            'Task Log'
                            +
                            "</b></br></br><b>Date : " + new Date(details.workDate).toString("yyyy-MM-dd HH:mm") + "</b></br>" +
                            "<b>Length : " + details.workLength + "</b></br>" +
                            "<b>Hours : " + details.numberOfHours + "</b><br>" +
                            "<b>Created by : " + details.createdBy + "</b></br>" +
                            "<b>Type : " + details.taskLogType + "</b></br>" +
                            verified +
                            "</br></div>"
                        );

                        infowindow.mousemove;
                        infowindow.open(locations.map);
                        infowindow.setPosition(latlng);
                        openedInfoWindow = infowindow;

                    }
                );
            }

            // tempPolygon.setMap(locations.map);
            locations.map.setCenter(latlng);
            // locations.map.setZoom($rootScope.rolloutMapInitZoom);
            return polyline;
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return (dist);
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

        $scope.toggle = function (id) {
            switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrTaskImages.query(
                            {
                                taskId: vm.trTask.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.taskImages = data.filter(function (taskImages) {
                                return taskImages.image;
                            });
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getTaskImage.get(vm.trTask.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                case "log":
                    $scope.showLog = !$scope.showLog;
                    vm.showLog = !vm.showLog;
                    break;

                default:
                    console.log("");
            }

            /*
        	
            $scope.allimages = !$scope.allimages;
        	
            var audioTag = document.createElement("AUDIO");
            audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/task_"+vm.trTask.id+".mp3");
            audioTag.setAttribute("controls", "controls");
            audioTag.setAttribute("controlsList", "nodownload");

            var mydiv = document.getElementById("audioLayout");
        	
            if ($scope.allimages) {
                TrTaskImages.query({
                    taskId : vm.trTask.id

                }, onSuccess, onError);

                function onSuccess(data, headers) {
                    // console.log('Recived data-----------');
                    vm.taskImages = data;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
                var mydivChild = document.createElement('div');
                mydivChild.setAttribute("id", "audioChild");
                mydiv.appendChild(mydivChild);
                mydivChild.appendChild(audioTag);
            }else{
                var mydivChild = document.getElementById("audioChild");
                mydivChild.remove();
            }
        */
        };

        //		$scope.playAudio = function() {
        ////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/task_"+vm.trTask.id+".mp3";
        //            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/task_15570572.mp3";
        //	        var audio = new Audio(urlStr);
        //	        audio.play();
        //	    };

        function decodeImage(img) {
            return window.atob(img);
        }

        /*  vm.toggleAccordion = function(item) {
             if (item.active) {
                 item.active = false;
             } else {
                 // Close all other items
                 vm.dailyLogs.forEach(function (otherItem) {
                     otherItem.active = false;
                 });
                 item.active = true;
             }
         }; */
        function createMetaTag(attrName, attrValue, content) {
            var meta = document.createElement('meta');
            meta.setAttribute(attrName, attrValue);
            meta.setAttribute('content', content);
            return meta;
        }

        function createTable(classNames) {
            var table = document.createElement('table');
            table.setAttribute('border', '1');
            table.setAttribute('cellpadding', '5');
            table.setAttribute('cellspacing', '0');
            table.setAttribute('id', 'sheet0');
            table.setAttribute('class', classNames);
            return table;
        }

        function createTableCell(tagName, textContent) {
            var cell = document.createElement(tagName);
            cell.textContent = textContent;
            return cell;
        }

        function showTaskLogReport(taskId) {
            console.log(taskId)
            vm.isReportGenerated = false;
            TaskLogTaskReportData.query(
                {
                    reportType: "daily",
                    taskId: taskId
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                var htmlDoc = document.createElement('html');
                var head = document.createElement('head');
                var meta1 = createMetaTag('http-equiv', 'Content-Type', 'text/html; charset=utf-8');
                var meta2 = createMetaTag('name', 'generator', 'PhpSpreadsheet, https://github.com/PHPOffice/PhpSpreadsheet');
                var meta3 = createMetaTag('name', 'author', 'Apache POI');
                var meta4 = createMetaTag('name', 'company', 'Microsoft Corporation');
                head.appendChild(meta1);
                head.appendChild(meta2);
                head.appendChild(meta3);
                head.appendChild(meta4);
                var body = document.createElement('body');
                var table = createTable('sheet0 gridlines');
                var thead = document.createElement('thead');
                var tbody = document.createElement('tbody');

                function createTable(classNames) {
                    var table = document.createElement('table');
                    table.setAttribute('border', '1');
                    table.setAttribute('cellpadding', '5');
                    table.setAttribute('cellspacing', '0');
                    table.setAttribute('id', 'sheet0');
                    table.setAttribute('class', classNames);
                    return table;
                }

                function createMetaTag(attrName, attrValue, content) {
                    var meta = document.createElement('meta');
                    meta.setAttribute(attrName, attrValue);
                    meta.setAttribute('content', content);
                    return meta;
                }

                function createTableCell(tag, content) {
                    var cell = document.createElement(tag);
                    cell.textContent = content;
                    cell.style.fontSize = "13px";
                    return cell;
                }

                thead.className = 'thReport';
                table.appendChild(thead);
                tbody.className = 'tdReport';
                table.appendChild(tbody);
                var styleElement = document.createElement('style');
                styleElement.textContent = "\
                .subheader {\
                    margin: auto;\
                }\
                .thReport > tr > th{\
                    text-align: center;\
                    padding: 10px;\
                }\
                .tdReport > tr > td {\
                    text-align: center; \
                    padding: 10px;\
                }\
                ";
                document.head.appendChild(styleElement);

                var colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2',];
                function getRandomColor() {
                    if (colors.length === 0) {
                        colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2'];
                    }
                    var index = Math.floor(Math.random() * colors.length);
                    var color = colors[index];
                    colors.splice(index, 1);
                    return color;
                }


                var groupedData = {};
                data.forEach(function (item) {
                    if (!groupedData[item.date]) {
                        groupedData[item.date] = [];
                    }
                    groupedData[item.date].push(item);
                });
                var names = getUniqueNames(data);
                var nameHeaderRow = document.createElement('tr');
                var serialNumberHeader = createTableCell('th', 'S.No');
                serialNumberHeader.style.fontWeight = 'bold';
                serialNumberHeader.style.backgroundColor = '#7dcfb6';
                serialNumberHeader.rowSpan = 2;
                nameHeaderRow.appendChild(serialNumberHeader);
                var dateHeader = createTableCell('th', 'Date');
                dateHeader.style.backgroundColor = '#7dcfb6';
                dateHeader.style.fontWeight = 'bold';
                dateHeader.rowSpan = 2;
                nameHeaderRow.appendChild(dateHeader);
                var typeHeaderRow = document.createElement('tr');

                names.forEach(function (name, index) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    var availableTypes = getUniqueTypes(nameData);
                    var nameHeaderCell = createTableCell('th', name);
                    nameHeaderCell.style.backgroundColor = getRandomColor();
                    nameHeaderCell.style.fontWeight = 'bold';
                    nameHeaderCell.colSpan = availableTypes.length;
                    nameHeaderRow.appendChild(nameHeaderCell);
                    availableTypes.forEach(function (type) {
                        var typeHeaderCell = createTableCell('th', type);
                        typeHeaderCell.style.backgroundColor = nameHeaderCell.style.backgroundColor;
                        typeHeaderCell.style.fontWeight = 'bold';
                        typeHeaderRow.appendChild(typeHeaderCell);
                    });
                });
                var totalProgressHeader = createTableCell('th', 'Total Progress');
                totalProgressHeader.style.backgroundColor = '#cfe0c3';
                totalProgressHeader.style.fontWeight = 'bold';
                totalProgressHeader.colSpan = 3;
                nameHeaderRow.appendChild(totalProgressHeader);
                var subHeaders = [
                    {
                        type: 'Total',
                    },
                    {
                        type: "Ducting",
                    }, {
                        type: "Validation",

                    }
                ];
                subHeaders.forEach(function (subHeader) {
                    var subHeaderCell = createTableCell('th', subHeader.type);
                    subHeaderCell.style.backgroundColor = '#cfe0c3';
                    subHeaderCell.style.fontWeight = 'bold';
                    typeHeaderRow.appendChild(subHeaderCell);
                });
                thead.appendChild(nameHeaderRow);
                thead.appendChild(typeHeaderRow);
                var totals = {};

                Object.keys(groupedData)
                    .sort(function (a, b) {
                        var dateA = a.split('-').reverse().join('-');
                        var dateB = b.split('-').reverse().join('-');
                        return new Date(dateA) - new Date(dateB);
                    })
                    .forEach(function (date, index) {
                        var totalLength = 0;
                        var totalValidation = 0;
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name && item.date === date; });
                            var ductingLength = 0;
                            var hddLength = 0;
                            var horizontalDirectionalDrilling = 0
                            var validationLength = 0;
                            nameData.forEach(function (item) {
                                if (item.type === 'Ducting') {
                                    ductingLength += item.length;
                                }
                                else if (item.type === 'HDD') {
                                    hddLength += item.length;

                                }
                                else if (item.type === 'HDD ( Horizontal Directional Drilling )') {
                                    horizontalDirectionalDrilling += item.length;
                                    console.log(horizontalDirectionalDrilling)
                                }
                                else if (item.type === 'Validation' || item.type === 'Validation (T&D)') {
                                    validationLength += item.length;
                                }
                            });
                            console.log(totalLength)
                            totalLength += (ductingLength + hddLength + horizontalDirectionalDrilling);
                            totalValidation += validationLength;

                        });
                        var tr = document.createElement('tr');
                        var serialNumberCell = createTableCell('td', index + 1);
                        serialNumberCell.style.fontSize = "13px";
                        tr.appendChild(serialNumberCell);
                        var dateCell = createTableCell('td', date);
                        dateCell.style.width = '77px'
                        dateCell.style.whiteSpace = 'nowrap';
                        dateCell.style.fontSize = "13px";
                        tr.appendChild(dateCell);
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name; });
                            var availableTypes = getUniqueTypes(nameData);

                            availableTypes.forEach(function (type) {
                                var item = groupedData[date].find(function (item) {
                                    return item.name === name && item.type === type;
                                });
                                var lengthValue = item ? item.length : 0;
                                var td = createTableCell('td', lengthValue);

                                tr.appendChild(td);
                                if (!totals[type]) {
                                    totals[type] = 0;
                                }
                                totals[type] += lengthValue;
                            });
                        });
                        var total = 0;
                        for (var i = 2; i < tr.cells.length; i++) {
                            total += parseInt(tr.cells[i].textContent);
                        }
                        var columnValueCell = createTableCell('td', total);
                        columnValueCell.colSpan = 1;
                        tr.appendChild(columnValueCell);
                        var remainingDuctingCell = createTableCell('td', totalLength);
                        tr.appendChild(remainingDuctingCell);
                        var remainingValidationCell = createTableCell('td', totalValidation);
                        tr.appendChild(remainingValidationCell);
                        if (index === 0) {
                            totals['Total Progress Ducting'] = 0;
                            totals['Total Progress Validation'] = 0;
                        }
                        totals['Total Progress Ducting'] += totalLength;
                        totals['Total Progress Validation'] += totalValidation;
                        tbody.appendChild(tr);
                    });

                var staticColumns = ['Total', 'Balance Validation', 'Balance Ducting'];
                var allAvailableTypes = [];
                names.forEach(function (name) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    allAvailableTypes.push.apply(allAvailableTypes, getUniqueTypes(nameData));
                });
                var availableTypes = allAvailableTypes;
                var maxUniqueTypesCount = availableTypes.length;
                var totalLength = maxUniqueTypesCount + subHeaders.length;

                var columnTotals = {};
                for (var i = 2; i < totalLength; i++) {
                    var total = 0;
                    for (var j = 0; j < tbody.rows.length; j++) {
                        var cellValue = parseInt(tbody.rows[j].cells[i].textContent) || 0;
                        total += cellValue;
                    }
                    columnTotals[i] = total;
                }
                staticColumns.forEach(function (column) {
                    var staticRow = document.createElement('tr');
                    var columnNameCell = createTableCell('td', column);
                    columnNameCell.colSpan = 2;
                    columnNameCell.style.backgroundColor = '#cfe0c3';
                    columnNameCell.style.fontSize = "13px";
                    columnNameCell.style.fontWeight = 'bold';
                    staticRow.appendChild(columnNameCell);
                    if (column == 'Total') {
                        for (var i = 2; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', columnTotals[i].toString());
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                        var columnValueCell = createTableCell('td', totals['Total Progress Ducting']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                        var columnValueCell = createTableCell('td', totals['Total Progress Validation']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                    } else {
                        for (var i = 0; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', '0');
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                    }
                    tbody.appendChild(staticRow);
                });
                table.appendChild(thead);
                table.appendChild(tbody);
                body.appendChild(table);
                htmlDoc.appendChild(body);
                htmlDoc.appendChild(head);
                var htmlString = htmlDoc.outerHTML;
                var containerDiv = document.getElementById("generatedHtmlContainer");
                containerDiv.innerHTML = htmlString;

                function getUniqueNames(data) {
                    var uniqueNames = [];
                    data.forEach(function (item) {
                        if (uniqueNames.indexOf(item.name) === -1) {
                            uniqueNames.push(item.name);
                        }
                    });
                    return uniqueNames;
                }
                function getUniqueTypes(data) {
                    var uniqueTypes = [];
                    data.forEach(function (item) {
                        if (uniqueTypes.indexOf(item.type) === -1) {
                            uniqueTypes.push(item.type);
                        }
                    });
                    return uniqueTypes;
                }
                // Set background color for specified cells
                var jcbCells = document.querySelectorAll('.row1 .column0'); // Select cells in row 1, column 0 (JCB)
                var hddCells = document.querySelectorAll('.row1 .column1'); // Select cells in row 1, column 1 (HDD)

                // Loop through JCB cells and set background color to light green
                jcbCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Loop through HDD cells and set background color to light green
                hddCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Get the Total row
                // Select all relevant rows
                var relevantRows = ['.row2', '.row3', '.row5', '.row6'];

                // Loop through each relevant row
                relevantRows.forEach(function (rowClass) {
                    var cells = document.querySelectorAll(rowClass + ' td');

                    // Loop through the cells in the row
                    cells.forEach(function (cell) {
                        // Check if the content of the cell is '0' or empty
                        if (cell.textContent.trim() === '0' || cell.textContent.trim() === '') {
                            // Set background color to white
                            cell.style.backgroundColor = 'white';
                        }
                    });
                });

                vm.isReportGenerated = true;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function showMapData() {
            taskComment.getTaskLogsPaths(entity.id, function (response) {
                var logCoorList = [];
                var keys = Object.keys(response);
                keys.forEach(function (value) {
                    logCoorList.push(response[value]);
                });
                logCoorList.forEach(function (value, index) {
                    var logType = "";
                    vm.dailyLogs.forEach(function (logs) {
                        if (value.id == logs.id && logs.taskLogType == "PROGRESS") {
                            logType = logs.taskLogType;
                            //console.log(logs);
                            drawPolygon(keys[index], value, logs, 1, 6, logType, true, 2);
                        }
                    });
                    vm.obstacleLogs.forEach(function (logs) {
                        if (value.id == logs.id && logs.taskLogType == "OBSTACLE") {
                            logType = logs.taskLogType;
                            //console.log(logs);
                            drawPolygon(keys[index], value, logs, 1, 6, logType, true, 2);
                        }
                    });

                });
            });
        }

        vm.closeModal = function (id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        };

        $scope.tab = 6;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };
        $scope.setTab = function (newTab) {

            vm.isShowComment = false
            if (newTab == 1 || newTab == 5) {
                vm.itemsPerPage = 10
                vm.page = 1

                vm.progresspage = 0;
                vm.obstaclepage = 0;

                if (newTab == 1) {
                    vm.dailyLogsList = []
                    callLogsPagination("PROGRESS")
                }
                if (newTab == 5) {
                    vm.obstacleLogsList = []
                    callLogsPagination("OBSTACLE")
                }

            }

            /*  if(newTab == 2){
                 //Comment Box
             vm.objectComments = {}
             vm.objectComments.entityId = entity.id
             vm.objectComments.entityName = "TASK"
             } */
            if (newTab == 4) {
                showTaskLogReport(vm.trTask.id);
            }

            if (newTab == 7) {
                vm.objectMaterialTxnTab = {}
                vm.objectMaterialTxnTab.id = vm.trTask.id
                vm.objectMaterialTxnTab.name = "taskId"
                vm.objectMaterialTxnTab.sectionId = vm.trTask.sectionTask.length ? vm.trTask.sectionTask[0].sectionId : null
            }

            if (newTab == 8) {
                vm.objectResourceTxnTab = {}
                vm.objectResourceTxnTab.id = vm.trTask.id
                vm.objectResourceTxnTab.name = "taskId"
                vm.objectResourceTxnTab.sectionId = vm.trTask.sectionTask.length ? vm.trTask.sectionTask[0].sectionId : null
            }

            $scope.tab = newTab;
        };

        vm.showModal = function (id) {
            $("#deleteLogs").show();
            vm.dailyLogid = id;
        };

        vm.deleteLogs = function () {
            DailyLogs.delete({ id: vm.dailyLogid }, function () {
                callLogs()
                $("#deleteLogs").hide();
            });
        };

        SummaryPost.dailyLogsTx(
            {
                taskIds: [vm.trTask.id],
            },
            function (response) {
                vm.dailyLogsTxSummary = response;
            }
        );

        vm.objectRouteImg = {}

        if (vm.trTask.routeTask.length) {
            vm.objectRouteImg.routeId = vm.trTask.routeTask[0].routeId
        } else if (vm.trTask.sectionTask.length) {
            vm.objectRouteImg.routeId = vm.trTask.sectionTask[0].routeId
        }

        vm.objectRouteImg.map = locations.map

        function progresstransition() {
            /* $state.transitionTo($state.$current, {
                page: vm.progresspage,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search
            }); */
            if ($scope.tab == 1) {
                callLogsPagination("PROGRESS")
            }
            if ($scope.tab == 5) {
                callLogsPagination("OBSTACLE")
            }
        }

        function obstacletransition() {
            $state.transitionTo($state.$current, {
                page: vm.obstaclepage,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search
            });
        }


        vm.logComment = function (id, str) {
            vm.isShowComment = true

            vm.objectComments = {}
            vm.objectComments.entityId = id
            vm.objectComments.entityName = str

            $scope.tab = 2
        }

        function callRouteImage(arr, map) {
            arr.forEach(function (each) {
                if (each.isImageAttached) {
                    var iconImage = "content/images/routePointImage.png"
                    var markerImage = new google.maps.Marker({
                        position: { lat: each.fromRoutePointLat, lng: each.fromRoutePointLng },
                        map: map,
                        icon: {
                            scaledSize: new google.maps.Size(24, 24),
                            url: iconImage,
                            anchor: new google.maps.Point(
                                24 / 2 + 25,
                                24 / 2
                            ),
                            labelOrigin: new google.maps.Point(25, 22),
                        },
                    });

                    google.maps.event.addListener(
                        markerImage,
                        "click",
                        (function () {
                            if (each && each.id) {
                                vm.nameImages = []
                                //scope.$apply(); 
                                imageRoutePoint.getUserTaskLogImages(each.id, function (item) {
                                    if (item.length >= 2) {
                                        item.forEach(function (logs) {
                                            logs.rID = each.id
                                            vm.nameImages.push(logs)
                                        })
                                        $("#modalAttachmentLogImage").show();
                                    } else {
                                        item.map(function (media) {
                                            vm.newTabDisplayLogs(each.id, media.imageId, media.imageType)
                                        })
                                    }
                                    //$scope.$apply()
                                })
                            }
                        })
                    );
                }
                //logImageMarkers.push(markerImage);
            })

            vm.newTabDisplayLogs = function (id, imgid, str) {
                var request = new XMLHttpRequest()
                request.open(
                    "GET",
                    'api/rollout/user-task-log-images/' + id + '/' + imgid,
                    true
                );
                request.setRequestHeader(
                    "Authorization",
                    "Bearer " + $localStorage.authenticationToken
                );
                request.responseType = "blob";
                request.onload = response;
                function response(e) {
                    if (this.status === 200) {
                        var urlCreator = window.URL || window.webkitURL;
                        if (str == "MP4") {
                            var videoUrl = urlCreator.createObjectURL(this.response);
                            var video = document.createElement('video');
                            video.src = videoUrl;
                            video.controls = true;
                            video.autoplay = true;
                            video.style.maxHeight = '80vh';

                            var videoWindow = window.open("", "_blank");
                            videoWindow.document.body.appendChild(video);
                        } else {
                            var imageUrl = urlCreator.createObjectURL(this.response);
                            window.open(imageUrl, "_blank");
                        }
                    } else {
                        alert("Error " + this.status)
                    }
                }
                request.send();
            }

        }

        function callLogsPagination(type) {
            DailyLogByTaskIdWithTypePagination.get(
                {
                    id: entity.id,
                    type: type,
                    page: vm.page - 1,
                    size: vm.itemsPerPage,
                    sort: "lastModifiedDate,desc"
                },
                function Success(response) {
                    if (response.content.length) {
                        vm.totalItems = response.totalElements;
                        vm.queryCount = response.totalElements;

                        if (type == 'PROGRESS') {
                            vm.dailyLogsList = response.content
                        } else if (type == 'OBSTACLE') {
                            vm.obstacleLogsList = response.content
                        }

                    }
                }
                ,
                function Error(error) {
                    AlertService.error(error.data.message);
                }
            );
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrTaskDeleteController',TrTaskDeleteController);

    TrTaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrTask','$scope'];

    function TrTaskDeleteController($uibModalInstance, entity, TrTask,$scope) {
        var vm = this;

        vm.trTask = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrTask.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-task', {
                parent: 'app',
                url: '/tr-task',
                data: {
                    authorities: ['TASK_SIDEBAR'],                    
                    pageTitle: 'trakeyeApp.task.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-task/tr-tasks.html',
                        controller: 'TrTaskController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    projectId: null,
                    routeId : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            projectId: $stateParams.projectId,
                            routeId :  $stateParams.routeId,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trTask');
                        $translatePartialLoader.addPart('taskStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-task-detail', {
                parent: 'tr-task',
                url: '/tr-task/{id}/{assignee}',
                data: {
                    authorities: ['TASK_DETAIL'],
                    pageTitle: 'trakeyeApp.task.detail.title'
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-task/tr-task-detail.html',
                        controller: 'TrTaskDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trTask');
                        $translatePartialLoader.addPart('taskStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrTask', function ($stateParams, TrTask) {
                        return TrTask.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-task',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],

                    assignee : ['$stateParams', function ($stateParams) {
                        return  $stateParams.assignee
                    }]
                }
            })

            .state('tr-task.priority', {
                parent: 'tr-task',
                url: '/tr-tasks/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.task.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-task/tr-tasks.html',
                        controller: 'TrTaskController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trTask');
                        $translatePartialLoader.addPart('taskStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-task.attendance', {
                parent: 'tr-task',
                url: '/tr-tasks/attendance/{login}/{fromTime}/{toTime}/{taskStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.task.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-task/tr-tasks.html',
                        controller: 'TrTaskController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            taskStatus: $stateParams.taskStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trTask');
                        $translatePartialLoader.addPart('taskStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-task.new', {
                parent: 'tr-task',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}/{routeId}/{sectionId}',
                data: {
                    authorities: ['TASK_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-task/tr-task-dialog.html',
                        controller: 'TrTaskDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            taskImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }],
                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

        .state('tr-task.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-task/tr-task-work-flow.html',
                    controller: 'TrTaskWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        taskImages: []
                    };
                }]
            }
        })

        .state('tr-task.import', {
                parent: 'tr-task',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-task/tr-task-import.html',
                        controller: 'TrTaskImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            taskImages: []
                        };
                    }
                }

            })
            .state('tr-task.edit', {
                parent: 'tr-task',
                url: '/Edit/{id}/{routeId}/{sectionId}',
                data: {
                    authorities: ['TASK_EDIT'],
                    pageTitle: 'trakeyeApp.task.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-task/tr-task-dialog.html',
                        controller: 'TrTaskDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrTask', function ($stateParams, TrTask) {
                        return TrTask.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-task',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

            .state('tr-task.delete', {
                parent: 'tr-task',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-task/tr-task-delete-dialog.html',
                        controller: 'TrTaskDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrTask', function (TrTask) {
                                return TrTask.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-task', null, { reload: 'tr-task' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-task.fibercore', {
                parent: 'tr-task',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-task/tr-task-fiber-core.html',
                        controller: 'TrTaskFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            taskImages: []
                        };
                    }
                }

            })

            .state('show-hide-task', {
                parent: 'report',
                url: '/show-hide-task',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-task/show-hide-task.html',
                        controller: 'ShowHideTaskController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })



            .state('task-log', {
                parent: 'app',
                url: '/task-logs',
                data: {
                    authorities: ['DAILYLOG_SIDEBAR'],
                    pageTitle: 'dailyTaskLogs.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/task-log/task-log.html',
                        controller: 'TaskLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('task-log.dialog', {
                parent: 'task-log',
                url: '/{id}/{taskId}/{sectionId}/{routeId}/{str}',
                data: {
                    authorities: ['DAILYLOG_CREATE','DAILYLOG_EDIT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/task-log/task-log.dialog.html',
                        controller: 'TaskLogDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    task : ['$stateParams','TrTask', function ($stateParams,TrTask) {
                        if($stateParams.taskId){ 
                            return TrTask.get({ id: $stateParams.taskId }).$promise;
                        }else{
                            return null
                        }
                    }],

                    taskLog : ['$stateParams','DailyLogs', function ($stateParams,DailyLogs) {

                            if($stateParams.id){
                                return DailyLogs.get({id:$stateParams.id}).$promise;
                            }else{
                                return {
                                    id : null
                                }
                            }
                            
                    }] ,

                    section : ['$stateParams','TrSection', function ($stateParams,TrSection) {
                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    str : ['$stateParams', function ($stateParams) {

                        if($stateParams.str){
                            return $stateParams.str
                        }else{
                            return null
                        }
                        
                    }],

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trTask');
                        return $translate.refresh();
                    }]
                    /* entity: ['$stateParams', 'DailyLogs', function ($stateParams, DailyLogs) {
                        return DailyLogs.get($stateParams.id).$promise;
                    }],  */

                }
            })

            .state('task-log.delete', {
                parent: 'task-log',
                url: '/{id}',
                data: {
                    authorities: ['DAILYLOG_DELETE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/task-log/task-log.dialog.html',
                        controller: 'TaskLogDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    taskLog : ['$stateParams','DailyLogs', function ($stateParams,DailyLogs) {

                            if($stateParams.id){
                                return DailyLogs.delete({id:$stateParams.id}).$promise;
                            }
                            
                    }] ,
                }
            })
            
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrTask', TrTask);

	TrTask.$inject = ['$resource', 'DateUtils'];

	function TrTask($resource, DateUtils) {
		var resourceUrl = 'api/tr-tasks/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskGeofence', TrTaskGeofence);

	TrTaskGeofence.$inject = ['$resource'];

	function TrTaskGeofence($resource) {
		var service = $resource('/api/tr-tasks/geofence/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskCustomTime', TrTaskCustomTime);

	TrTaskCustomTime.$inject = ['$resource'];

	function TrTaskCustomTime($resource) {
		var service = $resource('/api/tr-tasks-custom/:fromDate/:toDate', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskGeofenceCustomTime', TrTaskGeofenceCustomTime);

	TrTaskGeofenceCustomTime.$inject = ['$resource'];

	function TrTaskGeofenceCustomTime($resource) {
		var service = $resource('/api/tr-tasks-custom/geofence/:geofenceId/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrTaskCheckAsset', TrTaskCheckAsset);

	TrTaskCheckAsset.$inject = ['$resource', 'DateUtils'];

	function TrTaskCheckAsset($resource, DateUtils) {
		var resourceUrl = 'api/assets/search/:name';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
		});
	}
})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('TasksForAsset', TasksForAsset);

    TasksForAsset.$inject = ['$resource'];

    function TasksForAsset($resource) {
        var resourceUrl = 'api/tasks-for-asset/:assetId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-tasks/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getTaskImage', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/trakeyetaskimages/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getNearbyFixed', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id,data,callback) {
			$http.post('api/assets/nearby-fixed/' + id,data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskAssetsById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-tasks-assets/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TaskAttributeMappingId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/custom-task-type-mapper/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

/*
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskById', TrTaskById);

	TrTaskById.$inject = [ '$resource' ];

	function TrTaskById($resource) {
		var service = $resource('/api/tr-tasks/:id', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();*/

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskCountByGroup', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/taskcountbygroup').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadTaskReports', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-tasks').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskCountByStatus', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/taskcountbystatus').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskPriority', TrTaskPriority);

	TrTaskPriority.$inject = ['$resource'];

	function TrTaskPriority($resource) {
		var service = $resource('/api/tr-tasks/priority/:priority/:geofenceId', {
			priority: '@priorirty'
		}, {geofenceId : '@geofenceId'},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskAttendance', TrTaskAttendance);

	TrTaskAttendance.$inject = ['$resource'];

	function TrTaskAttendance($resource) {
		var service = $resource('/api/tr-tasks/attendance/:login/:fromTime/:toTime/:taskStatus',
			{}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskSearch', TrTaskSearch);

	TrTaskSearch.$inject = ['$resource'];

	function TrTaskSearch($resource) {
		var service = $resource('/api/tr-tasks/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskSearchCustom', TrTaskSearchCustom);

	TrTaskSearchCustom.$inject = ['$resource'];

	function TrTaskSearchCustom($resource) {
		var service = $resource('/api/tr-tasks-custom/searchvalue/:search/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskGeofenceSearch', TrTaskGeofenceSearch);

	TrTaskGeofenceSearch.$inject = ['$resource'];

	function TrTaskGeofenceSearch($resource) {
		var service = $resource('/api/tr-tasks/geofence-searchvalue/:geofenceId/:search', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskGeofenceSearchCustom', TrTaskGeofenceSearchCustom);

	TrTaskGeofenceSearchCustom.$inject = ['$resource'];

	function TrTaskGeofenceSearchCustom($resource) {
		var service = $resource('/api/tr-tasks-custom/geofence-searchvalue/:geofenceId/:search/:fromDate/:toDate', {}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrTaskGroup', TrTaskGroup);

	TrTaskGroup.$inject = ['$resource', 'DateUtils'];

	function TrTaskGroup($resource, DateUtils) {
		var resourceUrl = 'api/tr-tasks-group';

		return $resource(resourceUrl, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskGroupSearch', TrTaskGroupSearch);

	TrTaskGroupSearch.$inject = ['$resource'];

	function TrTaskGroupSearch($resource) {
		var service = $resource('/api/tr-tasks-group/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskGroupPrioritySearch', TrTaskGroupPrioritySearch);

	TrTaskGroupPrioritySearch.$inject = ['$resource'];

	function TrTaskGroupPrioritySearch($resource) {
		var service = $resource('/api/tr-tasks-group/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskGroupPriority', TrTaskGroupPriority);

	TrTaskGroupPriority.$inject = ['$resource'];

	function TrTaskGroupPriority($resource) {
		var service = $resource('/api/tr-tasks-group/priority/:priority', {
			priority: '@priorirty'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskImages', TrTaskImages);

	TrTaskImages.$inject = ['$resource'];

	function TrTaskImages($resource) {
		var service = $resource('/api/task-images/:taskId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTasksForType', TrTasksForType);

	TrTasksForType.$inject = ['$resource'];

	function TrTasksForType($resource) {
		var service = $resource('/api/trtasksbytype/:taskTypeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}

})();
 (function () {
	'use strict';

	angular.module('trakeyeApp').factory('NearByBGOH', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (data,success,error) {
			$http.post('api/tr-tasks/nearby-bgoh-assets',data).then(function (response) {
				success(response.data);
			},function (response) {
				error(response.status);
			});
		};

		return service;
	}]);
})();  

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskRecordings', TrTaskRecordings);

	TrTaskRecordings.$inject = ['$resource'];

	function TrTaskRecordings($resource) {
		var service = $resource('/api/task-recordings/:taskId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllTaskTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/task-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskPrioritySearch', TrTaskPrioritySearch);

	TrTaskPrioritySearch.$inject = ['$resource'];

	function TrTaskPrioritySearch($resource) {
		var service = $resource('/api/tr-tasks/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrTaskUpdateGroup', TrTaskUpdateGroup);

	TrTaskUpdateGroup.$inject = ['$resource'];

	function TrTaskUpdateGroup($resource) {
		var resourceUrl = 'api/tr-tasks/groups';

		return $resource(resourceUrl, {}, {
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrTaskBulkDelete', TrTaskBulkDelete);

	TrTaskBulkDelete.$inject = ['$resource'];

	function TrTaskBulkDelete($resource) {
		var resourceUrl = 'api/tr-tasks/bulk/delete';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskListByRouteId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-tasks-by-sectionId/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskListIdBySectionId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-tasks-list-by-sectionId/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ValidationLogsBySectionId', ValidationLogsBySectionId);

    ValidationLogsBySectionId.$inject = ['$resource'];

    function ValidationLogsBySectionId($resource) {
        var service = $resource('/api/rollout/get-validation-logs-by-sectionid/:sectionId/', {}, {}, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskUser', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.gettrtasksuser = function (callback) {
			$http.get('api/tr-tasks/live-logs').then(function (response) {
				callback(response.data);
			});
		};

		service.gettrtasksuserbyid = function (id, callback) {
			$http.get('api/tr-tasks/live-logs/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.searchtrtasksuserbyvalue = function (id, callback) {
			$http.get('api/tr-tasks/search/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.gettrtasksanduserbypriority = function (priority, callback) {
			$http.get('api/tr-tasks/live-logs/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		service.getAgents = function (callback) {
			$http.get('api/dashboard/agentdashboard').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskEdit', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getalltrtasks = function (callback) {
			$http.get('api/tr-alltasks').then(function (response) {
				callback(response.data);
			});
		};

		service.edittrtask = function (data, callback) {
			$http.post('api/tr-taskedit/' + data.userId + '/' + data.taskId, {

			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {

				callback(error, error.headers);
			});

			/*
			 * $http.post('api/tr-taskedit/'+data.userId+'/'+data.taskId).then(function(response){
			 * callback(response.data); });
			 */
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrTaskUpload', TrTaskUpload);

	TrTaskUpload.$inject = ['$http'];

	function TrTaskUpload($http) {

		var service = {};
		service.trtaskupload = function (data, callback) {

			$http.post('api/taskimport', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupTaskSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrtaskformap = function (search, callback) {
			$http.get('api/tr-grouptasksformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupTaskForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllTasks = function (callback) {
			$http.get('api/tr-grouptasksformap').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrtaskformap = function (search, callback) {
			$http.get('api/tr-tasksformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};

		service.prioritysearchtrtaskformap = function (priority, callback) {
			$http.get('api/tr-tasksformap/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('TrTaskLastLocation', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			service.getlastlogs = function (callback) {
				$http.get('api/location-logs/lastuserpath').then(function (response) {
					callback(response.data);
				});
			};
			return service;
		}]);



})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TasksForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.tasksformapbyadmin = function (adminid, callback) {
			$http.get('api/tr-tasksformap/' + adminid).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrTaskForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllTasks = function (data, callback) {
			// $http.get('api/tr-tasksformap').then(function (response) {
			// 	callback(response.data);
			// });
			$http.post('api/tr-tasksformap', data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ShowTaskById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (taskid, callback) {
            $http.put('api/show-task/' + taskid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('HideTaskById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (taskid, callback) {
            $http.put('api/hide-task/' + taskid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('getTask', [ '$http', function ($http) {
		
        var service, apiSectionId, apiRouteId;
        service = {};
        apiSectionId = "api/tr-tasks/section/";
        apiRouteId = "api/tr-tasks/route/";

        // Common function for fetching data by ID
        function fetchDataById(endpoint, id, callback) {
            $http
                .get(endpoint + id)
                .then(function (response) {
                    callback(response);
                })
                .catch(function (error) {
                    callback(error);
                });
        }

        // Get Section by ID
        service.bySectionId = function (id, callback) {
            fetchDataById(apiSectionId, id, callback);
        };

        // Get Task by Route ID
        service.byRouteId = function (id, callback) {
            fetchDataById(apiRouteId, id, callback);
        };

        return service;
    }]);
})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('TaskLog', [ '$http', function ($http) {
		
        var service, apiCreateDailyLog, createDailyResourceTxn,createDailyMaterialTxn,apiEditDailyLog;
        service = {};
        //apiCreateDailyLog = "api/rollout/bulk-log-daily-task";
		apiCreateDailyLog = "api/rollout/log-daily-task"
		createDailyResourceTxn = "api/rollout/log-res-tx"
		createDailyMaterialTxn = "api/rollout/log-mtrl-tx"
		apiEditDailyLog = "api/rollout/log-daily-task"

        // Common function for fetching data by ID
        function fetchData(endpoint, payload, logId, success,error, str) {

			switch(str) {
				case 'POST' : $http
                .post(endpoint,payload)
                .then(function (response) {
                    success(response);
                })
                .catch(function (er) {
                    error(er);
                })
				break;

				case 'PUT' : $http
                .put(endpoint,payload)
                .then(function (response) {
                    success(response);
                })
                .catch(function (er) {
                    error(er);
                })
				break;

				default : console.log("DailyTaskLog Default Executed")
			}
            
        }

        service.post = function (payload, callback,err) {
            fetchData(apiCreateDailyLog, payload,null, callback,err,'POST');
        };

		service.update = function (payload, callback,err) {
            fetchData(apiEditDailyLog, payload,null, callback,err,'PUT');
        };

		service.postMaterialTxn = function (payload, callback) {
            fetchData(createDailyMaterialTxn, payload,null, callback,null,'POST');
        };

		service.postResourceTxn = function (payload, callback) {
            fetchData(createDailyResourceTxn, payload,null, callback,null,'POST');
        };

        return service;
    }]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('dailyTaskLog', dailyTaskLog);

	dailyTaskLog.$inject = ['$resource', 'DateUtils'];

	function dailyTaskLog($resource, DateUtils) {
		var resourceUrl = 'api/rollout/get-daily-task-logs/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('postRoutePoints', ['$http', function ($http) {

		var service = {};
		service.post = function (data,callback) {
			$http.post('api/routepoints',data).then(function (response) {
				callback(response.data);
			}).catch(function (err){
				callback(err)
			});
		};
		return service;
	}]);
})(); 


/* (function () {
	'use strict';

	angular.module('trakeyeApp').factory('dailyLogByTaskId', ['$http', function ($http) {

		var service = {};
		service.get = function (taskId,page,size,callback) {
			$http.get('api/rollout/get-daily-task-logs/'+taskId,{
				params: {
					page: page,
					size: size
				}}).then(function (response) {
				callback(response.data);
			}).catch(function (err){
				callback(err)
			});
		};
		
		return service;
	}]);
})();
 */

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DailyLogByTaskIdWithType', DailyLogByTaskIdWithType);

	DailyLogByTaskIdWithType.$inject = ['$resource'];

	function DailyLogByTaskIdWithType($resource) {
		var service = $resource('/api/rollout/get-daily-task-logs/:id/type/:type', {
			id: '@id'
		}, {type : '@type'},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		}); 

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DailyLogByTaskIdWithTypePagination', DailyLogByTaskIdWithTypePagination);

	DailyLogByTaskIdWithTypePagination.$inject = ['$resource'];

	function DailyLogByTaskIdWithTypePagination($resource) {
		
		var service = $resource('/api/rollout/get-daily-task-logs-page/:id/type/:type', {
			id: '@id'
		}, {type : '@type'},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('dailyLogByTaskId', dailyLogByTaskId);

	dailyLogByTaskId.$inject = ['$resource'];

	function dailyLogByTaskId($resource) {
		var resourceUrl = 'api/rollout/get-daily-task-logs/:id'

		return $resource(resourceUrl, {},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('taskComment', ['$http', function ($http) {

		var service = {};

		service.post = function (payload,callback) {
			$http.post('api/tr-user-comments',payload).then(function (response) {
				callback(response.data);
			}).catch(function (err){
				callback(err)
			});
		};

		service.put = function (payload,callback) {
			$http.put('api/tr-user-comments',payload).then(function (response) {
				callback(response.data);
			}).catch(function (err){
				callback(err)
			});
		};

		service.getTaskLogsPaths = function (taskId,callback) {
			$http.get('api/rollout/daily-task-log-path/task/'+taskId).then(function (response) {
				callback(response.data);
			}).catch(function (err){
				callback(err)
			});
		};

		service.get = function (entityId,entityName,callback) {
			$http.get('api/tr-user-comments/'+entityId+'/'+entityName).then(function (response) {
				callback(response.data);
			}).catch(function (err){
				callback(err)
			});
		};

		service.delete = function (commentId,callback) {
			$http.delete('api/tr-user-comments/'+commentId).then(function (response) {
				callback(response.data);
			}).catch(function (err){
				callback(err)
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('filterTask', ['$http', function ($http) {
		
		var service = {};
		service.routeFilter = function (page,size,payload,callback) {
			$http.post('api/tr-route-tasks',payload,{
				params: {
					page: page,
					size: size
				}
			}).then(function (response) {
				callback(response.data,response.headers);
			}).catch(function (err){
				callback(err)
			});
		};

		service.sectionFilter = function (payload,callback) {
			$http.post('api/tr-section-tasks',payload).then(function (response) {
				callback(response.data,response.headers);
			}).catch(function (err){
				callback(err)
			});
		};
		
		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('DailyLogs', DailyLogs);

	DailyLogs.$inject = ['$resource'];

	function DailyLogs($resource) {
		var resourceUrl = 'api/rollout/log-daily-task/:id';

		return $resource(resourceUrl, {}, {
			'delete': {
				method: 'DELETE'
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TaskPathById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-tasks-path/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrUserTask', TrUserTask);

	TrUserTask.$inject = ['$resource'];

	function TrUserTask($resource, DateUtils) {
		var resourceUrl = 'api/tr-user-tasks'

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('FixedTaskLogExcelUpload', FixedTaskLogExcelUpload);

    FixedTaskLogExcelUpload.$inject = ['$http'];

    function FixedTaskLogExcelUpload($http) {

        var service = {};
        service.logupload = function (data, callback) {

            $http.post('api/importDailyLogsFromExcel', data, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {
                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

        return service;
    }

})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrTaskController", TrTaskController);

    TrTaskController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$compile",
        "TrTask",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "TrProject",
        "filterTask",
        "TrRouteListByProjectId",
        "TrSectionListByRouteId",
        "dailyLogByTaskId",
        "TrTaskSearch",
        "TrUserTask",
        "ActivatedUserSearch",
        "FixedTaskLogExcelUpload"
    ];

    function TrTaskController(
        $scope,
        $rootScope,
        $state,
        $compile,
        TrTask,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        TrProject,
        filterTask,
        TrRouteListByProjectId,
        TrSectionListByRouteId,
        dailyLogByTaskId,
        TrTaskSearch,
        TrUserTask,
        ActivatedUserSearch,
        FixedTaskLogExcelUpload
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        $scope.tab = 1;
        var listRouteId = []
        var listSectionId = []
        vm.sections = []
        vm.selectedProjectId = parseInt(pagingParams.projectId);
        vm.expandResponse = []

        vm.filterActivatedUser = filterActivatedUser;
        //vm.selectedRouteId = pagingParams.routeId;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                TrTaskSearch.query(
                    {
                        search: $scope.search,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.tasks = [];
                    vm.tasks = data
                    vm.headers = [
                        { key: "name", display: "Name" },
                        { key: "routeName", display: "Ring" },
                        { key: "routeBundleName", display: "Route" },
                        { key: "sectionName", display: "Section" },
                        { key: "userLogin", display: "Assigned To" },
                        { key: "taskLength", display: "Task Length (mtrs)" },
                        { key: "taskTypeName", display: "Task Type" },
                        { key: "status", display: "Status" }, { display: "Task Log " }, { display: "Created Date" }, { display: "Actions" }
                    ]
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }

                TrProject.query(
                    {
                        page: 0,
                        size: 500,
                        sort: sort(),
                    },

                    function onSuccess(data, headers) {
                        vm.projects = [];
                        vm.projects = data

                        if (vm.selectedProjectId) {
                            vm.projects.forEach(function (item) {
                                if (item.id == vm.selectedProjectId) {
                                    item.ticked = true;
                                } else {
                                    item.ticked = false;
                                }
                            });
                            vm.clickProject(vm.selectedProjectId)
                        }

                        //vm.page = pagingParams.page;
                    },
                    onError
                );
            } else {
                loadAll();
            }
        }

        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                //  result.push('id');
            }
            return result;
        }

        function loadAll() {

            TrTask.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.tasks = [];
                    vm.headers = [
                        { key: "name", display: "Name" },
                        { key: "routeName", display: "Ring" },
                        { key: "routeBundleName", display: "Route" },
                        { key: "sectionName", display: "Section" },
                        { key: "userLogin", display: "Assigned To" },
                        { key: "taskLength", display: "Task Length (mtrs)" },
                        { key: "taskTypeName", display: "Task Type" },
                        { key: "status", display: "Status" }, { display: "Task Log " }, { display: "Created Date" }, { display: "Actions" }
                    ]
                    vm.tasks = data
                    vm.page = pagingParams.page;
                },
                onError

            );



            TrProject.query(
                {
                    page: 0,
                    size: 500,
                    sort: sort(),
                },

                function onSuccess(data, headers) {
                    vm.projects = [];
                    vm.projects = data

                    if (vm.selectedProjectId) {
                        vm.projects.forEach(function (item) {
                            if (item.id == vm.selectedProjectId) {
                                item.ticked = true;
                            } else {
                                item.ticked = false;
                            }
                        });
                        vm.clickProject(vm.selectedProjectId)
                    }

                    //vm.page = pagingParams.page;
                },
                onError
            );

        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                projectId: (vm.selectedProject.length) ? vm.selectedProject[0].id : null,
                routeId: (listRouteId.length) ? listRouteId : null,
            });
        }

        $scope.type = {
            project: {
                search: "Search",
                nothingSelected: "Project",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            },
            route: {
                search: "Search",
                nothingSelected: "Route",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            },
            section: {
                search: "Search",
                nothingSelected: "Section",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            }
        };

        vm.clickProject = function (id) {
            //vm.tasks = []
            if (vm.selectedProjectId) {
                TrRouteListByProjectId.get(id, function (response) {
                    vm.routes = response;

                    /* if(vm.selectedRouteId.length){
                        for (var i = 0; i < vm.routes.length; i++) {
                            var item1 = vm.routes[i];
                          
                            // Iterate through arr2
                            for (var j = 0; j < vm.selectedRouteId.length; j++) {
                              var item2 = vm.selectedRouteId[j];
                          
                              // Check if IDs match
                              if (item1.id === item2.id) {
                                // Match found, enable the tick variable
                                item1.tick = true;
                                break; // Break out of the inner loop since we found a match
                              }
                            }
                        }
                    } */
                });
            } else {
                TrRouteListByProjectId.get(vm.selectedProject[0].id, function (response) {
                    vm.routes = response;
                });
            }
            vm.sections.length = 0

        };


        vm.clickRoute = function () {
            callRouteSelect()
        }

        function callRouteSelect() {
            listRouteId = []
            if (vm.selectedRoute.length && vm.selectedProject.length) {
                vm.selectedRoute.forEach(function (item) {
                    listRouteId.push(item.id)
                })

                vm.sections.length = 0
                vm.selectedRoute.forEach(function (each) {
                    TrSectionListByRouteId.get(each.id, function (response) {
                        response.forEach(function (item) {
                            vm.sections.push({ name: item.name, id: item.id })
                        })

                    });
                })

                filterTask.routeFilter(pagingParams.page - 1,
                    vm.itemsPerPage, {
                    "routeIds": listRouteId,
                    "projectIds": [vm.selectedProject[0].id]
                }, function (data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.tasks = [];
                    vm.page = pagingParams.page;
                    vm.tasks = data
                })
            }
        }
        vm.clickSection = function () {
            listSectionId = []

            if (vm.selectedSection.length) {
                vm.selectedSection.forEach(function (item) {
                    listSectionId.push(item.id)
                })
            } else {
                callRouteSelect()
            }

            if (vm.selectedRoute.length && vm.selectedSection.length) {
                filterTask.sectionFilter({
                    "sectionIds": listSectionId,
                    "routeIds": listRouteId,
                    "projectIds": [vm.selectedProject[0].id]
                }, function (data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.tasks = [];
                    vm.page = pagingParams.page;
                    vm.tasks = data
                })
            }

        }

        vm.expand = function (task, id) {
            vm.tasks.forEach(function (item) {
                item.expand = false;
            });

            if (vm.toggle == task.id) {
                vm.toggle = undefined;
            } else {
                task.expand = true;
                vm.toggle = task.id;

                dailyLogByTaskId.query({
                    search: $scope.search,
                    page: 0,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    id: id
                }, function (response) {
                    vm.expandResponse = response
                })
            }

        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }

        vm.taskUserAssign = function (task) {
            vm.trTask = task
            $("#markerUploadModal").show();
        };

        vm.closeAssetMarkerModal = function () {
            $("#markerUploadModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#markerUploadModal").hide();
        };

        function filterActivatedUser() {
            if (vm.trTask.userLogin) {
                ActivatedUserSearch.query({
                    userId: vm.trTask.userLogin,
                }, onSuccess, onError);
            }


            function onSuccess(data, headers) {
                vm.trTask.userId = null
                vm.activatedusers = [];
                data.forEach(function (dataVal) {
                    vm.activatedusers.push(dataVal);
                });
                $scope.showResults = true;
                /* 
                                    angular.forEach(vm.activatedusers, function (value, key) {
                                        usersMap[value.login] = value.id;
                                    }); */
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        }


        $scope.assignUser = function (user, id) {
            // Implement the logic to assign the selected user
            vm.trTask.userLogin = user
            vm.trTask.userId = id
            $scope.showResults = false;
            vm.assignToModified = true
        };

        vm.saveAssignTo = function () {
            var data = {
                "id": vm.trTask.userTaskId,
                "task": {
                    "id": vm.trTask.id

                },
                "userId": vm.trTask.userId,
                "tenantId": vm.trTask.tenantId,
                "project": {
                    "id": vm.trTask.projectId

                },
                "route": {
                    "id": vm.trTask.routeId

                },
                "section": {
                    "id": vm.trTask.sectionId

                }
            }
            TrUserTask.update(data, function success() {
                TrTask.query(
                    {
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    function onSuccess(data, headers) {
                        vm.links = ParseLinks.parse(headers("link"));
                        vm.totalItems = headers("X-Total-Count");
                        vm.queryCount = vm.totalItems;
                        vm.tasks = data
                        vm.headers = [
                            { key: "name", display: "Name" },
                            { key: "routeName", display: "Route" },
                            { key: "sectionName", display: "Section" },
                            { key: "userLogin", display: "Assigned To" },
                            { key: "taskLength", display: "Task Length (mtrs)" },
                            { key: "taskTypeName", display: "Task Type" },
                            { key: "status", display: "Status" }, { display: "Task Log " }, { display: "Created Date" }, { display: "Actions" }
                        ]
                        vm.page = pagingParams.page;
                    },
                    onError

                );
                vm.closeAssetMarkerModal()
            }, onError)

        }
        vm.openLogs = function () {
            
            $(":file").filestyle({
                buttonBefore: true,
                buttonText: "Browse File",
            });

            vm.importxl = /^(.*?)\.(xlsx)$/;
            $("#importTaskLogs").show();
            $(":file").filestyle("clear");
        };

        vm.closeModal = function (id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        };

        var getFile, formData;
        vm.uploadTaskLogs = function () {
            getFile = document.getElementById("uploadfileTaskLog").files[0];
            formData = new FormData();
            formData.append("file", getFile);

            FixedTaskLogExcelUpload.logupload(formData, function (response) {
                vm.success = response.status == 200 ? "success" : "";
                if (vm.success) {
                    setTimeout(function () {
                        vm.success = "";
                        vm.closeModal("importTaskLogs");
                        vm.isSaving = false;
                    }, 500);
                }

                if (response.data.length) {
                    console.log(response.data);
                }
            });
        };
    }
})();

(function() {
    'use strict';

    angular.module('trakeyeApp').controller('TrServiceDialogController', TrServiceDialogController);

    TrServiceDialogController.$inject = ['$timeout', '$scope', '$http', '$stateParams', 'entity', '$state', 'TrService', 'User', 'TrCase', 'ServiceType', 'AllServiceTypes', 'TrServiceImages', 'AllCustomServiceTypeAttribute',
        'UserSearch', '$sce', '$q', '$rootScope', 'TrCaseUser'
    ];

    function TrServiceDialogController($timeout, $scope, $http, $stateParams, entity, $state, TrService, User, TrCase, ServiceType, AllServiceTypes, TrServiceImages, AllCustomServiceTypeAttribute, UserSearch, $sce, $q, $rootScope,
        TrCaseUser) {
        var vm = this;

        vm.trService = entity;
        var entity_old = angular.copy(vm.trService)
            // vm.serviceImages = entity_old.serviceImages;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.checkDate = checkDate;
        vm.save = save;
        vm.errorDate = false;
        vm.filtertrcasesid = filtertrcasesid;
        vm.customAttributesMap = {};
        // if ($rootScope.has_ROLE_USER_ADMIN == true) {
        //     vm.users = User.query();
        // }
        // // vm.trcases = TrCase.query();
        // if ($rootScope.has_ROLE_USER_ADMIN == true) {
        vm.serviceTypes = loadPage(); // ServiceType.query();
        // }
        vm.selectattributes = selectedServiceTypeAttributes;

        var serviceTypeAttributeValuesList = vm.trService.serviceTypeAttributeValues;

        try {
            for (var index in vm.trService.serviceType.serviceTypeAttribute) {
                if (!checkIfServiceTypeExists(vm.trService.serviceType.serviceTypeAttribute[index], vm.trService.serviceTypeAttributeValues)) {
                    var serviceTypeAttribute1 = vm.trService.serviceType.serviceTypeAttribute[index];
                    serviceTypeAttributeValuesList.push({ 'serviceTypeAttribute': serviceTypeAttribute1, 'attributeValue': vm.trService.serviceType.serviceTypeAttribute[index].defaultValue });
                }
            }
        } catch (e) {}

        function checkIfServiceTypeExists(serviceType, serviceTypeAttrVal) {
            var hasServiceType = false;
            for (var i = 0; i < serviceTypeAttrVal.length; i++) {
                var name = serviceTypeAttrVal[i].serviceTypeAttribute.name;
                if (name == serviceType.name) {
                    hasServiceType = true;
                    break;
                }
            }
            return hasServiceType;
        }

        serviceTypeAttributeValuesList
            .sort(function(a, b) {
                var nameA = a.serviceTypeAttribute.name.toLowerCase(),
                    nameB = b.serviceTypeAttribute.name
                    .toLowerCase()
                if (nameA < nameB) // sort string ascending
                    return -1
                if (nameA > nameB)
                    return 1
                return 0 // default return value (no sorting)
            });
        vm.trService.serviceTypeAttributeValues = serviceTypeAttributeValuesList;

        vm.serviceType = {};
        vm.trService.serviceImages = [];
        $scope.allimages = false;

        $scope.toggle = function() {
            $scope.allimages = !$scope.allimages;

            if ($scope.allimages) {

                TrServiceImages.query({
                    caseId: vm.trService.id

                }, onSuccess, onError);

                function onSuccess(data, headers) {
                    // console.log('Received data-----------');
                    vm.serviceImages = data;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }

            }

        };

        $('.select2').select2(); // Added for selectbox search

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });
        if (vm.trService.id && vm.trService.id != null) {
            vm.serviceType = vm.trService.serviceType;
            var date = vm.trService.serviceDate;
            var newdate = new Date(date);
            vm.trService.serviceDate = newdate;
        }

        function loadPage() {
            AllServiceTypes.getAll(function(response) {
                vm.serviceTypes = response;
            });

            AllCustomServiceTypeAttribute.getAll(function(response) {
                //vm.customCaseTypeAttributes = response;
                response.forEach(function(arrayItem) {
                    vm.customAttributesMap[arrayItem.name] = arrayItem.customServiceTypeAttributeValues;
                });

            });
        }

        function save() {
            vm.isSaving = true;
            if (vm.trService.id !== null) {
                var date = vm.trService.serviceDate;
                vm.trService.serviceDate = date.getTime();
                TrService.update(vm.trService, onSaveSuccess, onSaveError);
            } else {
                $scope.date = vm.trService.serviceDate.getTime();
                vm.trService.serviceDate = $scope.date;
                TrService.save(vm.trService, onSaveSuccess, onSaveError);
            }
        }

        $("#serviceImages").change(function() {

            var filesSelected = document.getElementById("serviceImages").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();

                fileReader.onload = function(fileLoadedEvent) {
                    vm.trService.serviceImages.push({
                        image: window.btoa(fileLoadedEvent.target.result),
                        trService: {
                            id: entity_old.id
                        }
                    });
                }
                fileReader.readAsBinaryString(filesSelected[i]);
            }

        });

        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:trServiceUpdate', result);
            // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('tr-service');
        }
        vm.serviceType = entity.serviceType;

        function selectedServiceTypeAttributes() {
            if (vm.serviceType) {
                vm.trService.serviceType = vm.serviceType;
                if (entity_old.serviceType && vm.serviceType.id === entity_old.serviceType.id) {
                    vm.trService.serviceTypeAttributeValues = [];
                    vm.trService.serviceTypeAttributeValues = entity_old.serviceTypeAttributeValues;
                } else {
                    vm.trService.serviceTypeAttributeValues = [];
                    $.each(vm.serviceType.serviceTypeAttribute, function(key, value) {
                        vm.trService.serviceTypeAttributeValues.push({
                            serviceTypeAttribute: vm.serviceType.serviceTypeAttribute[key]
                        });
                    });
                }
            }

        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function filtertrcasesid() {
            if (vm.trService.trCase.id != null && !angular.isUndefined(vm.trService.trCase.id)) {

                TrCaseUser.searchtrcasesuserbyvalue(vm.trService.trCase.id, function(response) {
                    vm.caseids = response;
                    vm.trcaseDate = response[0].createDate;
                });
            }
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;
        vm.datePickerOpenStatus.serviceDate = false;

        function checkDate() {
            var sdate = new Date(vm.trService.serviceDate).getTime();
            if (sdate > vm.trcaseDate) {
                vm.errorDate = false;
            } else {
                vm.errorDate = true;
            }
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;



        }


        // Added for upload styles
        $(":file").filestyle({
            buttonBefore: true
        });
        // $(":file").filestyle('placeholder', 'Choose File');
        $(":file").filestyle('buttonText', 'Browse File');

    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrServiceDetailController', TrServiceDetailController);

    TrServiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity'];

    function TrServiceDetailController($scope, $rootScope, $stateParams, previousState, entity) {
        var vm = this;

        vm.trService = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        var unsubscribe = $rootScope.$on('trakeyeApp:trServiceUpdate', function(event, result) {
            vm.trService = result;
        });
        $scope.$on('$destroy', unsubscribe);
        
        
        function decodeImage(img){
      	   return window.atob(img);
         }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrServiceDeleteController',TrServiceDeleteController);

    TrServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrService','$scope'];

    function TrServiceDeleteController($uibModalInstance, entity, TrService,$scope) {
        var vm = this;

        vm.trService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrService.delete({id: id},
                function () {
            	
           	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-service', {
                parent: 'app',
                url: '/tr-service',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trService.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-service/tr-services.html',
                        controller: 'TrServiceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'modified_date,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trService');
                        $translatePartialLoader.addPart('serviceStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tr-service-detail', {
                parent: 'tr-service',
                url: '/tr-service/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trService.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-service/tr-service-detail.html',
                        controller: 'TrServiceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trService');
                        $translatePartialLoader.addPart('serviceStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrService', function($stateParams, TrService) {
                        return TrService.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-service',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

        .state('tr-service.new', {
            parent: 'tr-service',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-service/tr-service-dialog.html',
                    controller: 'TrServiceDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function() {
                    return {
                        createdDate: null,
                        modifiedDate: null,
                        description: null,
                        serviceDate: null,
                        status: null,
                        notes: null,
                        id: null,
                        serviceTypeAttributeValues: [],
                        serviceImages: []

                    };
                }
            }

        })

        .state('tr-service.edit', {
            parent: 'tr-service',
            url: '/Edit/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                pageTitle: 'trakeyeApp.trService.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-service/tr-service-dialog.html',
                    controller: 'TrServiceDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trService');
                    $translatePartialLoader.addPart('serviceStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrService', function($stateParams, TrService) {
                    return TrService.get({ id: $stateParams.id }).$promise;
                }],
                previousState: ["$state", function($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tr-service',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })


        .state('tr-service.delete', {
            parent: 'tr-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tr-service/tr-service-delete-dialog.html',
                    controller: 'TrServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',

                    resolve: {
                        entity: ['TrService', function(TrService) {
                            return TrService.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tr-service', null, { reload: 'tr-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
(function() {
	'use strict';
	angular.module('trakeyeApp').factory('TrService', TrService);

	TrService.$inject = [ '$resource', 'DateUtils' ];

	function TrService($resource, DateUtils) {
		var resourceUrl = 'api/tr-services/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrServiceSearch', TrServiceSearch);

	TrServiceSearch.$inject = [ '$resource' ];

	function TrServiceSearch($resource) {

		var service = $resource('/api/tr-services/searchvalue/:search', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrServiceImages', TrServiceImages);

	TrServiceImages.$inject = [ '$resource' ];

	function TrServiceImages($resource) {
		var service = $resource('/api/service-images/:caseId', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrServiceSearchForMap', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.searchserviceinmap = function(serviceId, callback) {

			$http.get('api/tr-services/searchinmap/' + serviceId).then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllServiceTypes', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/service-alltypes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('TrServiceController', TrServiceController);

	TrServiceController.$inject = [ '$scope', '$state', '$compile', 'TrService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TrCaseUser', 'TrServiceSearch',
			'TrServiceSearchForMap','$rootScope' ];

	function TrServiceController($scope, $state, $compile, TrService, ParseLinks, AlertService, pagingParams, paginationConstants, TrCaseUser, TrServiceSearch, TrServiceSearchForMap,$rootScope) {
		var vm = this;
		$scope.search = pagingParams.search;
		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.drawservice = drawservice;
		// vm.filterUsers = filterUsers;
		vm.filterSearch = filterSearch;
		vm.filterTrSevices = filterTrSevices;
		vm.selectAllAssets = selectAllAssets;

		var latlng;
		var userPaths = {};
		var locations = {};

		// loadAll();

		$scope.tab = 1;

		$scope.setTab = function(newTab) {
			$scope.tab = newTab;
			if ($scope.tab == 2) {
				// vm.drawservice();
				filterTrSevices();
			}
		};

		$scope.isSet = function(tabNum) {
			return $scope.tab === tabNum;
		};

		if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
			filterSearch();
		} else {
			loadAll();
		}

		function loadAll() {
			TrService.query({
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort()
			}, onSuccess, onError);
			function sort() {
				var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					// result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.trServices = data;
				vm.trServicesbackup = data;
				vm.page = pagingParams.page;
			}
			function onError(error) {
				AlertService.error(error.data.message);
			}
		}

		function filterSearch() {
			if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
				TrServiceSearch.query({
					search : $scope.search,
					page : pagingParams.page - 1,
					size : vm.itemsPerPage,
					sort : sort()
				}, onSuccess, onError);
				function sort() {
					var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
					if (vm.predicate !== 'id') {
						// result.push('id');
					}
					return result;
				}
				function onSuccess(data, headers) {
					vm.links = ParseLinks.parse(headers('link'));
					vm.totalItems = headers('X-Total-Count');
					vm.queryCount = vm.totalItems;
					vm.trServices = data;
					vm.page = pagingParams.page;

				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
			} else {
				loadAll();
			}
		}

		

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search : $scope.search
			});
		}

		/*
		 * function filterUsers(){ if(vm.seachCase!=null &&
		 * !angular.isUndefined(vm.seachCase)){
		 * TrCaseUser.gettrcasesuserbyid(vm.seachCase,function(response){
		 * $scope.trcaseuser=response; drawLatestCases($scope.trcaseuser); }); } }
		 */

		function selectAllAssets() {
            var toggleStatus = vm.isAllAssetSelected;
            if (toggleStatus) {
                vm.showAssetActions = true;
                vm.selectedAssets = [];
                vm.trServices.forEach(function (asset) {
                    vm.selectedAssets.push(asset.id);
                });
            } else {
                vm.showAssetActions = false;
                vm.selectedAssets = [];
            }
            angular.forEach(vm.trServices, function (item) { item.isChecked = toggleStatus; });
        }



		function filterTrSevices() {
			if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
				TrServiceSearchForMap.searchserviceinmap($scope.search, function(response) {
					var searchArray = [];
					response.forEach(function(ele){
						if($scope.search == ele.id ){
							searchArray.push(ele)
						}
					})
					drawLatestlocations(searchArray);
				});
			} else {
				drawLatestlocations(vm.trServicesbackup);
			}
		}

		function drawservice() {
			drawLatestlocations(vm.trServices);
		}

		function drawLatestlocations(response) {
			if (response) {
				initializeMap(response, function(latlang) {
					locations.latlng = latlang;
					setupMap(function() {
						$.each(response, function(index, value) {
							var infoWindow = new google.maps.InfoWindow();
							var startMarker = new google.maps.Marker({
								map : locations.map,
								position : new google.maps.LatLng(value.trCase.pinLat, value.trCase.pinLong),
								title : value.description,

							});

							var infoWindow2 = new google.maps.InfoWindow();

							if (value.trCase.priority == 'LOW') {
								startMarker.setIcon('content/images/Pointers-L4.png');
							} else if (value.trCase.priority == 'MEDIUM') {
								startMarker.setIcon('content/images/Pointers-M4.png');
							} else if (value.trCase.priority == 'HIGH') {
								startMarker.setIcon('content/images/Pointers-H4.png');
							} else if (value.trCase.priority == 'CRITICAL') {
								startMarker.setIcon('content/images/Pointer-C4.png');
							}
							var span = '<a userId="' + value.trCase.geofenceName + '" class="userpath" >Load travelled path</a>';
							startMarker.content = '<div class="infoWindowContent">' + value.trCase.address + '<br></div>';
							$compile(startMarker.content)($scope);

							google.maps.event.addListener(startMarker, 'mouseover', function() {
								infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
								infoWindow.open(locations.map, startMarker);

							});

							// on mouseout
							google.maps.event.addListener(startMarker, 'mouseout', function() {
								infoWindow.close();
							});

							var activeInfoWindow;
							// add content to InfoWindow for click event
							infoWindow2.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);

							// add listener on InfoWindow for click event
							google.maps.event.addListener(startMarker, 'click', function() {

								if (activeInfoWindow != null)
									activeInfoWindow.close();
								// Open InfoWindow - on click
								infoWindow2.open(locations.map, startMarker);
								$(".userpath").click(function() {
									var ele = document.getElementById("userPathModal");
									$(ele).modal('show');
									vm.drawUserPath($(this).attr('userid'));
								});

								// Store new open InfoWindow in global variable
								activeInfoWindow = infoWindow2;
							});

							// resizeMap();
						});

					});
				});
			}
			function setupMap(callback) {
				var myOptions = {
					zoom : 10,
					center : locations.latlng,
					mapTypeId : google.maps.MapTypeId.ROADMAP
				};
				locations.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
				locations.overlay = new google.maps.OverlayView();
				locations.overlay.draw = function() {
				};
				locations.overlay.setMap($scope.map);
				locations.element = document.getElementById('map_canvas');
				callback();
			}
		}

//		function resizeMap() {
//			setTimeout(function() {
//				google.maps.event.trigger(locations.map, "resize");
//				locations.map.setCenter(locations.latlng);
//			}, 1000);
//		}

		function initializeMap(latlangs, callback) {
			if (latlangs && latlangs.length > 0) {
				latlng = new google.maps.LatLng(latlangs[0].trCase.pinLat, latlangs[0].trCase.pinLong);
				callback(latlng);
			} else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function(position) {

						latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
						callback(latlng);
					}, function() {

						callback(new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE));
					});
				} else {
					callback(new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE));
				}
			}
		}
	}
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrSectionDialogController", TrSectionDialogController);

    TrSectionDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrSection",
        "AllSectionTypes",
        "AllCustomSectionTypeAttribute",
        "Configs",
        "route",
        "postRoutePoints",
        "AlertService",
        "$window",
        "$rootScope"
    ];

    function TrSectionDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrSection,
        AllSectionTypes,
        AllCustomSectionTypeAttribute,
        Configs,
        route,
        postRoutePoints,
        AlertService,
        $window,
        $rootScope
    ) {
        var vm = this;
        vm.trSection = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trSection);
        vm.selectAttributes = selectedSectionTypeAttributes;
        vm.sectionType = entity.sectionType;
        var markers = []
        var coordinateList = []
        var chainageList = []
        var markerList = []
        var iconSize = 20
        var labelFrom, labelTo
        labelFrom = 'From Section'
        labelTo = 'To Section'
        vm.isSetUpdate = false
        var infowindow = new google.maps.InfoWindow();
        var openedInfoWindow = null;
        var btnAddSection;

        if ($state.params.routeId) {
            vm.trSection.routeId = parseInt($state.params.routeId, 10);
        }

        vm.customAttributesMap = {};
        vm.customAttributesMapp = [];
        loadPage();
        var locations = {};
        var locationsEnd = {};


        if (vm.trSection.id != null) {
            vm.trSectionType = vm.trSection.sectionType;
        }

        if (!vm.trSection.id) {
            vm.trSection.routeName = route.name
            vm.trSection.status = "NEW"
            //vm.trSection.phase = "PLANNING"
        }


        Configs.get("RolloutTaskStatus", function (response) {
            vm.rolloutTaskStatus = response;
        });

        function loadPage() {

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
                );
                imgWindow.document.close();
            };

            var sectionTypeAttributeValuesList =
                vm.trSection.sectionTypeAttributeValues;

            try {
                for (var index in vm.trSection.sectionType.sectionTypeAttribute) {
                    if (
                        !checkIfSectionTypeExists(
                            vm.trSection.sectionType.sectionTypeAttribute[index],
                            vm.trSection.sectionTypeAttributeValues
                        )
                    ) {
                        var sectionTypeAttribute1 =
                            vm.trSection.sectionType.sectionTypeAttribute[index];
                        sectionTypeAttributeValuesList.push({
                            sectionTypeAttribute: sectionTypeAttribute1,
                            attributeValue:
                                vm.trSection.sectionType.sectionTypeAttribute[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) { }

            function checkIfSectionTypeExists(sectionType, sectionTypeAttrVal) {
                var hasSectionType = false;
                for (var i = 0; i < sectionTypeAttrVal.length; i++) {
                    var name = sectionTypeAttrVal[i].sectionTypeAttribute.name;
                    if (name == sectionType.name) {
                        hasSectionType = true;
                        break;
                    }
                }
                return hasSectionType;
            }
            AllSectionTypes.getAll(function (response) {
                vm.sectionTypes = response;
            });

            AllCustomSectionTypeAttribute.getAll(function (response) {
                //vm.customSectionTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if (arrayItem.customSectionTypeAttributeValues != undefined) {
                        vm.customAttributesMap[arrayItem.name] =
                            arrayItem.customSectionTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }

                });
                if (vm.trSection.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });


        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function selectedSectionTypeAttributes() {
            vm.showFilter = true;
            if (vm.sectionType) {
                vm.trSection.sectionType = vm.sectionType;
                if (
                    entity_old.sectionType &&
                    vm.sectionType.id === entity_old.sectionType.id
                ) {
                    vm.trSection.sectionTypeAttributeValues = [];
                    vm.trSection.sectionTypeAttributeValues =
                        entity_old.sectionTypeAttributeValues;
                } else {
                    vm.trSection.sectionTypeAttributeValues = [];
                    $.each(
                        vm.sectionType.sectionTypeAttribute,
                        function (key, value) {
                            vm.trSection.sectionTypeAttributeValues.push({
                                sectionTypeAttribute:
                                    vm.sectionType.sectionTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        function save() {
            //vm.isSaving = true;
            //var spreadAV = vm.trSection.sectionTypeAttributeValues;
            /*  for (
                 var spreadAssetIndex = 0;
                 spreadAssetIndex < spreadAV.length;
                 spreadAssetIndex++
             ) {
                 if (
                     spreadAV[spreadAssetIndex].sectionTypeAttribute
                         .name === "Fiber Distance (km)"
                 ) {
                     spreadAV[
                         spreadAssetIndex
                     ].attributeValue = fiberDistance;
                 }
             }
             vm.trSection.sectionTypeAttributeValues = spreadAV; */
            callTask()
            /*   if (vm.trSection.id !== null) {
  
                  if(vm.isSetUpdate){
                      if(markers.length == 2){
                          var payload
                          markers.forEach(function (item){
          
                              if(item.label.text == labelFrom || item.label.text == labelTo){
                                  payload = { "latitude" : item.position.lat(), "longitude" : item.position.lng()}
                                  postRoutePoints.post(payload,function(response){
          
                                      if(item.label.text == labelFrom){
                                          vm.trSection.fromRoutePoint = {
                                              id: response.id,
                                          };
                                      }
          
                                      if(item.label.text == labelTo){
                                          vm.trSection.toRoutePoint = {
                                              id: response.id,
                                          };
          
                                          if(vm.trSection.fromRoutePoint && vm.trSection.toRoutePoint){
                                              setTimeout(function(){ TrSection.update(vm.trSection, onSaveSuccess, onSaveError); }, 1500);
                                              
                                          }else{
                                              AlertService.error("Error");
                                          }
                                          
                                      }
                                     
          
                                     
                                  },function(error){
                                      AlertService.error(error.data.message);
                                  })
                              }
                          })
                      }else{
                          alert("Section From or To Points are Empty")
                      }
                  }else{
                      if(markers.length == 2){
                          TrSection.update(vm.trSection, onSaveSuccess, onSaveError);
                      }else{
                         alert("Section From or To Points are Empty")
                      }
                  }
                  
              } else{
                  if(markers.length == 2){
                      var payload
                      markers.forEach(function (item){
      
                          if(item.label.text == labelFrom || item.label.text == labelTo){
                              payload = { "latitude" : item.position.lat(), "longitude" : item.position.lng()}
                              postRoutePoints.post(payload,function(response){
      
                                  if(item.label.text == labelFrom){
                                      vm.trSection.fromRoutePoint = {
                                          id: response.id,
                                      };
                                  }
      
                                  if(item.label.text == labelTo){
                                      vm.trSection.toRoutePoint = {
                                          id: response.id,
                                      };
                                      callTrsectionSave()
                                  }
                                 
      
                                 
                              },function(error){
                                  AlertService.error(error.data.message);
                              })
                          }
                      })
                  }else{
                      alert("Section From or To Points are Empty")
                  }
              } */


        }

        /*   function callTrsectionSave(){
              if(vm.trSection.fromRoutePoint && vm.trSection.toRoutePoint){
                  setTimeout(function(){ TrSection.save(vm.trSection, onSaveSuccess, onSaveError); }, 2500);
              }else{
                  AlertService.error("Error");
              }
          }
  
          function onSaveSuccess(result) {
              $scope.$emit("trakeyeApp:sectionUpdate", result);
              //vm.isSaving = false;
  
              var pageValue = sessionStorage.getItem("prevPage");
              if (pageValue == "user-management.new") {
                  $state.go("user-management.new");
              } else {
                  $window.history.back();
              }
          }
  
          function onSaveError() {
              //vm.isSaving = false;
          } */

        function callTask() {
            if (markers.length == 2) {
                markers.forEach(function (item) {
                    if (item.label.text == labelFrom || item.label.text == labelTo) {
                        if (item.label.text == labelFrom) {
                            if (vm.trSection.id) {
                                vm.trSection.fromRoutePoint.latitude = item.position.lat()
                                vm.trSection.fromRoutePoint.longitude = item.position.lng()
                            } else {
                                vm.trSection.fromRoutePoint = {
                                    "latitude": item.position.lat(), "longitude": item.position.lng()
                                };
                            }
                        }

                        if (item.label.text == labelTo) {
                            if (vm.trSection.id) {
                                vm.trSection.toRoutePoint.latitude = item.position.lat()
                                vm.trSection.toRoutePoint.longitude = item.position.lng()
                            } else {
                                vm.trSection.toRoutePoint = {
                                    "latitude": item.position.lat(), "longitude": item.position.lng()
                                };
                            }
                        }
                    }
                })

                markersNearby.forEach(function (item) {
                    if (item.label.text == 'From Nearby') {
                        if (vm.trSection.id) {
                            vm.trSection.fromNearestPoint.latitude = item.position.lat()
                            vm.trSection.toNearestPoint.longitude = item.position.lng()
                        } else {
                            vm.trSection.fromNearestPoint = {
                                "latitude": item.position.lat(), "longitude": item.position.lng()
                            };
                        }
                    }

                    if (item.label.text == 'To Nearby') {
                        if (vm.trSection.id) {
                            vm.trSection.fromNearestPoint.latitude = item.position.lat()
                            vm.trSection.toNearestPoint.longitude = item.position.lng()
                        } else {
                            vm.trSection.toNearestPoint = {
                                "latitude": item.position.lat(), "longitude": item.position.lng()
                            };
                        }
                    }
                })
                if (vm.trSection.id) {
                    TrSection.update(vm.trSection, onSaveSuccess, onSaveError)
                } else {
                    TrSection.save(vm.trSection, onSaveSuccess, onSaveError)
                }
            } else {
                alert("Section From or To Points are Empty")
            }
        }

        function onSaveSuccess(result) {
            $window.history.back();
        }

        function onSaveError() {
        }

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = response;
            //vm.workFlow.phase = "Planning Phase"
            /*  if(vm.workFlow.id == null){
                response.forEach(function(val){
                    if(val.configValue == '01'){
                        vm.workFlow.phase = val.configKey
                    }
                })
            }*/
        });

        //start

        locations.map = new google.maps.Map(
            document.getElementById("map_canvasStart"),
            {
                center: {
                    lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                    lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                },
                zoom: $rootScope.rolloutMapInitZoom,
                fullscreenControl: true,
                styles: mapStyles(),
            }
            //myOption(16, vm.getCenterStart)
        );


        google.maps.event.addListener(locations.map, "click", function (event) {
            if (markers.length < 2) {
                // Add a marker to the map
                addMarker(event.latLng);
                console.log(event.latLng)
            } else {
                console.log("Maximum 2 markers allowed.");
            }
        });
        //geoLocation(locations.map);

        //vm.getCenterStart = locations.map.center;

        //end
        /* 
        locationsEnd.map = new google.maps.Map(
            document.getElementById("map_canvasEnd"),
            {
                center: {
                    lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                    lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                },
                zoom: 13,
                fullscreenControl: true,
                styles: mapStyles(),
            }
            //myOption(16, vm.getCenterEnd)
        );
        geoLocation(locationsEnd.map); */
        //vm.getCenterEnd = locationsEnd.map.center;

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            var goTo = document.createElement("span");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            gotoIcon.classList.add("mt-5");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);
            goTo.addEventListener("click", function () {
                vm.removeMarker()
                $("#modalLatLongs").show();
            });

            var goToNearBy = document.createElement("span");
            goToNearBy.setAttribute("title", "Add Nearby Points");
            goToNearBy.classList.add("custom-map-control-button");
            var goToNearByIcon = document.createElement("i");
            goToNearByIcon.classList.add("fa");
            goToNearByIcon.classList.add("fa-thumb-tack");
            goToNearByIcon.classList.add("geo");
            goToNearByIcon.classList.add("mt-10");
            goToNearBy.appendChild(goToNearByIcon);
            map.controls[google.maps.ControlPosition.LEFT_TOP].push(goToNearBy);
            goToNearBy.addEventListener("click", function () {
                //vm.removeMarker()
                vm.isShowNearbyAdd = true
            });

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        vm.removeMarker = function () {
            markers.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the markers array
            markers = [];

            markersNearby.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the markers array
            markersNearby = [];

            vm.isShowNearbyAdd = false
            if (vm.trSection.id) {
                vm.isSetUpdate = true
            }

        }

        if (route && route.routePoints != null && route.routePoints.length) {
            route.routePoints.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
            var groupedRoutePoints = {}
            route.routePoints.forEach(function (each) {
                if (each.sessionNumber) {
                    if (!groupedRoutePoints[each.sessionNumber]) {
                        groupedRoutePoints[each.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                    }
                    if (each.routePointType === "COORDINATE" && each.phase === "PLANNING") {
                        groupedRoutePoints[each.sessionNumber].coordinates.push({ lat: each.latitude, lng: each.longitude });
                    } else if (each.routePointType === "MARKER") {
                        groupedRoutePoints[each.sessionNumber].markers.push({ lat: each.latitude, lng: each.longitude });
                    } else if (each.routePointType === "CHAINAGE") {
                        groupedRoutePoints[each.sessionNumber].chainages.push({ lat: each.latitude, lng: each.longitude });
                    }
                }
            })

            Object.keys(groupedRoutePoints).forEach(function (sessionNumber) {
                var sessionData = groupedRoutePoints[sessionNumber];
                if (sessionData.coordinates.length) {
                    locations.map.setCenter(sessionData.coordinates[0]);
                    var polyline = new google.maps.Polyline({
                        path: sessionData.coordinates,
                        geodesic: true,
                        strokeColor: '#FD7A24',
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                    });
                    polyline.setMap(locations.map);
                    addClick(polyline);
                }
                if (sessionData.markers.length) {
                    locations.map.setCenter(sessionData.markers[0]);
                    createMarkers(sessionData.markers, 'content/images/markersPoint.png', locations.map);
                }
                if (sessionData.chainages.length) {
                    locations.map.setCenter(sessionData.chainages[0]);
                    createMarkers(sessionData.chainages, 'content/images/chainagePoints.png', locations.map);
                }
            });
        }


        //Distance Calculate Function
        function distanceCal(lat1, lng1, lat2, lng2) {
            var R = 6371;
            var dLat = degreesToRadians(lat2 - lat1);
            var dLng = degreesToRadians(lng2 - lng1);
            var a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(degreesToRadians(lat1)) *
                Math.cos(degreesToRadians(lat2)) *
                Math.sin(dLng / 2) * Math.sin(dLng / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c;
        }

        function degreesToRadians(degrees) {
            return degrees * (Math.PI / 180);
        }

        function addClick(item) {
            item.addListener("click", function (event) {
                if (markers.length < 2) {
                    addMarker(event.latLng);
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                    if (markers.length === 2) {
                        var lat1 = markers[0].position.lat();
                        var lng1 = markers[0].position.lng();
                        var lat2 = markers[1].position.lat();
                        var lng2 = markers[1].position.lng();
                        var distance = distanceCal(lat1, lng1, lat2, lng2);
                        vm.sectionDistance = parseInt(distance * 1000)
                        vm.trSection.sectionLength = vm.sectionDistance
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    }
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
                if (vm.isShowNearbyAdd && markersNearby.length < 2 && markers.length == 2) {
                    addMarkerNearBy(event.latLng)
                }
            })
        }


        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.latitude, lng: each.longitude },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                google.maps.event.addListener(
                    marker,
                    "click",
                    (function () {
                        //var name = (each.name == (undefined || null)) ? " " : each.name
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var userContent = document.createElement("div")

                        userContent.innerHTML = '<div class="infoWindowhead"></br></br>' +
                            /* "<b>Name : "+name+"</b></br>"+ */
                            "<b>Latitude : " + each.latitude + "</b></br>" +
                            "<b>Longitude : " + each.longitude + "</b></br>" +
                            "<b>Type : " + each.type + "</b></br>" +
                            "<b>Number : " + each.number + "</b></br>" +
                            "</br></div>"
                        infowindow.setContent(
                            userContent
                        );
                        infowindow.open(map);
                        infowindow.setPosition({
                            lat: each.latitude,
                            lng: each.longitude,
                        });
                        openedInfoWindow = infowindow;


                        if (markers.length < 2) {
                            btnAddSection = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnAddSection.type = "button";

                            btnAddSection.value = "Add Section Point";

                            btnAddSection.className = "button";

                            btnAddSection.addEventListener("click", function () {
                                if (markers.length < 2) {
                                    // Add a marker to the map
                                    addMarker({
                                        lat: each.latitude,
                                        lng: each.longitude,
                                    });

                                    // Get the latitude and longitude of the clicked point
                                    vm.pinLat = each.latitude;
                                    vm.pinLong = each.longitude;
                                    openedInfoWindow.close();
                                } else {
                                    alert("From and To Section Exists");
                                }
                            })
                        }

                    }))


                arr.push(marker);
            })
        }

        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = labelFrom
            } else if (markers.length == 1) {
                markerText = labelTo
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: "content/images/sections.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        -4
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
                label: {
                    text: markerText,
                },
                draggable: true
            });

            // Add the marker to the markers array
            markers.push(marker);
        }


        if (vm.trSection.id && vm.trSection.fromRoutePoint && vm.trSection.toRoutePoint) {
            addMarker({ lat: vm.trSection.fromRoutePoint.latitude, lng: vm.trSection.fromRoutePoint.longitude })
            addMarker({ lat: vm.trSection.toRoutePoint.latitude, lng: vm.trSection.toRoutePoint.longitude })
            locations.map.setCenter({ lat: vm.trSection.fromRoutePoint.latitude, lng: vm.trSection.fromRoutePoint.longitude });
        }

        vm.objectRouteImg = {}
        vm.objectRouteImg.routeId = vm.trSection.routeId
        vm.objectRouteImg.map = locations.map

        geoLocation(locations.map);

        vm.closeModal = function (id) {
            vm.getLocationCoordinateA = null
            vm.getLocationCoordinateB = null

            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

        vm.onLocationCoordinates = function () {
            var latlngA = vm.getLocationCoordinateA.split(",");
            var latlngB = vm.getLocationCoordinateB.split(",");

            addMarker({ lat: parseFloat(latlngA[0]), lng: parseFloat(latlngA[1]) })
            addMarker({ lat: parseFloat(latlngB[0]), lng: parseFloat(latlngB[1]) })

            locations.map.setCenter({ lat: parseFloat(latlngB[0]), lng: parseFloat(latlngB[1]) })
            vm.closeModal('modalLatLongs')
        }

        var markersNearby = []
        function addMarkerNearBy(location) {
            var markerText
            if (markersNearby.length == 0) {
                markerText = "From Nearby"
            } else if (markersNearby.length == 1) {
                markerText = "To Nearby"
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: "content/images/pin24.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        -4
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
                label: {
                    text: markerText,
                },
                draggable: true
            });

            // Add the marker to the markers array
            markersNearby.push(marker);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrSectionDetailController', TrSectionDetailController);

    TrSectionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrSection', 'User', 'SectionType', 'TrSectionImages', 'TrSectionRecordings', 'AlertService', '$window', '$localStorage', 'getSectionImage', 'Configs', 'Inventory', 'SummaryPost', 'imageRoutePoint', 'TaskRouteById', 'TaskSectionById', 'TaskLogSectionReportData', 'Summary', 'MaterialByDates', 'MaterialDates', 'ParseLinks', 'DailyLogByTaskIdWithType'];

    function TrSectionDetailController($scope, $rootScope, $stateParams, previousState, entity, TrSection, User, SectionType, TrSectionImages, TrSectionRecordings, AlertService, $window, $localStorage, getSectionImage, Configs, Inventory, SummaryPost, imageRoutePoint, TaskRouteById, TaskSectionById, TaskLogSectionReportData, Summary, MaterialByDates, MaterialDates, ParseLinks, DailyLogByTaskIdWithType) {
        var vm = this;

        vm.trSection = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        var unsubscribe = $rootScope.$on('trakeyeApp:trSectionUpdate', function (event, result) {
            vm.trSection = result;
        });
        vm.showSectionAttachment = false
        vm.sectionResource = []
        vm.sectionMaterial = []
        var labelFrom, labelTo
        labelFrom = 'From Section'
        labelTo = 'To Section'
        vm.dailyLogsTxSummary = []
        vm.mtrlTxSummary = []
        vm.resTxSummary = []
        var routePath = {};
        vm.showTaskLogReport = showTaskLogReport;
        var sectionPath = {};
        var infowindow = new google.maps.InfoWindow();
        var openedInfoWindow = null;
		vm.gotoLatitute = gotoLatitute;
		vm.gotoLatituteCity = gotoLatituteCity;
		vm.closeGotoLatitute = closeGotoLatitute;
		vm.closeGotoLatituteCity = closeGotoLatituteCity;
		var measureTool = document.createElement("button");
		var measureToolIcon = document.createElement("i");
		var measureEnabled = false
		var polyMeasureTool, segmentDistance, midpoint
		     var totalDistance = 0
		     var distanceMarkers = []
		     var totalDistanceMarkers = []
		     var pointerMarkers = []
		     var arrpolyMeasureTool = []
		
        Configs.get("SectionImage", function (response) {
            if (response.length > 0) {
                if (response[0].configValue == "True") {
                    vm.showSectionAttachment = true
                }
            }
        })

        vm.imageInNewTab = function (img) {
            var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                img +
                '">'
            );
            imgWindow.document.close();
        };

        $scope.newTabDisplay = function (id) {
            var request = new XMLHttpRequest();
            request.open('GET', "api/trakeyesectionimages/" + vm.trSection.id + "/" + id, true);
            request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;

            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    window.open(imageUrl, "_blank")
                }
            }
            request.send();
        }

        $scope.$on('$destroy', unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };

        $scope.allimages = false;
        //		$scope

        $scope.toggle = function (id) {
            switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrSectionImages.query(
                            {
                                sectionId: vm.trSection.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.sectionImages = data.filter(function (sectionImages) {
                                return sectionImages.image
                            });

                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getSectionImage.get(vm.trSection.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                case "resource":
                    vm.showResource = !vm.showResource;
                    break;

                case "material":
                    vm.showMaterial = !vm.showMaterial;
                    break;

                case "task":
                    vm.showTask = !vm.showTask;
                    break;

                default:
                    console.log("");
            }



			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/section_"+vm.trSection.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrSectionImages.query({
					sectionId : vm.trSection.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.sectionImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

        //		$scope.playAudio = function() {
        ////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/section_"+vm.trSection.id+".mp3";
        //            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/section_15570572.mp3";
        //	        var audio = new Audio(urlStr);
        //	        audio.play();
        //	    };


        function decodeImage(img) {
            return window.atob(img);
        }


        /* //Get Tasks by Section Id
        getTask.bySectionId(entity.id,onSuccess,onError)

        function onSuccess(response){
            
        }

        function onError(error){
            AlertService.error(error.data.message);
        }  */


        Inventory.materialTxn(entity.id, function (response) {
            vm.sectionMaterial = response
        })

        Inventory.resourceTxn(entity.id, function (response) {
            vm.sectionResource = response
        })

        Inventory.taskBySection(entity.id, function (response) {
            vm.taskResponse = response
        })


        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };


        $scope.setTab = function (newTab) {
            if (newTab == 2) {
                //Comment Box
                vm.objectComments = {}
                vm.objectComments.entityId = entity.id
                vm.objectComments.entityName = "SECTION"
            }
            if (newTab == 3) {
                showTaskLogReport(vm.trSection.id);
            }
            $scope.tab = newTab;

        }


        var locations = {};
        var markers = [];
        var coordinateList = []
        var routeCoordinateList = []
        var chainageList = []
        var markerList = []
        var iconSize = 20
        var center = {
            lat: parseFloat($rootScope.DEFAULT_LATITUDE),
            lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
        };

        locations.map = new google.maps.Map(
            document.getElementById("map_canvasStart"),
            myOption($rootScope.rolloutMapInitZoom, center)
        );
		geoLocation(locations.map);
        if (vm.trSection.route != null) {
            TaskRouteById.get(vm.trSection.route.id, function (routeVal) {
                routePath = routeVal;
                if (routePath.COORDINATE != null) {
                    routePath.COORDINATE.forEach(function (coor) {
                        routeCoordinateList.push({ lat: coor.latitude, lng: coor.longitude });
                    });
                }

                if (routeCoordinateList.length) {
                    locations.map.setCenter(routeCoordinateList[0]);
                    var strokeColor = "#0066CC";

                    strokeColor = "#8a0101";

                    var polyline = new google.maps.Polyline({
                        path: routeCoordinateList,
                        geodesic: true,
                        strokeColor: strokeColor,
                        strokeOpacity: 0.3,
                        strokeWeight: 6,
                        zIndex: 1
                    });

                    // Set the map to display the polyline
                    polyline.setMap(locations.map);
                }
            });
        }
        if (vm.trSection != null) {
            TaskSectionById.get(vm.trSection.id, function (sectionVal) {
                sectionPath = sectionVal;
                if (sectionPath.COORDINATE != null) {
                    sectionPath.COORDINATE.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                    sectionPath.COORDINATE.forEach(function (coor) {
                        if (coor.routePointNumber) {
                            coordinateList.push({ latitude: coor.latitude, longitude: coor.longitude,sort:coor.routePointNumberDouble,sessionNumber:coor.sessionNumber });
                        }
                    });
                }

                if (sectionPath.CHAINAGE != null) {
                    sectionPath.CHAINAGE.forEach(function (chainageVal) {
                        chainageList.push({ latitude: chainageVal.latitude, longitude: chainageVal.longitude, type: chainageVal.routePointType });
                    });
                }

                if (sectionPath.MARKER != null) {
                    sectionPath.MARKER.forEach(function (markerVal) {
                        markerList.push({ lat: markerVal.latitude, lng: markerVal.longitude });
                    });
                }

                if (coordinateList.length) {
                    locations.map.setCenter({lat:coordinateList[0].latitude,lng:coordinateList[0].longitude});
                    var groupedBySessionNumber = {};
                    for (var i = 0; i < coordinateList.length; i++) {
                        var item = coordinateList[i];
                        var session = item.sessionNumber;

                        if (!groupedBySessionNumber[session]) {
                            groupedBySessionNumber[session] = [];
                        }

                        groupedBySessionNumber[session].push(item);
                    }

                    // Initialize groupedRoutePaths
                    var groupedRoutePaths = {};

                    // Populate groupedRoutePaths with session data
                    Object.keys(groupedBySessionNumber).forEach(function (sessionNumber) {
                        var sessionData = groupedBySessionNumber[sessionNumber];

                        // Map session data to lat/lng pairs
                        if (sessionData) {
                            groupedRoutePaths[sessionNumber] = sessionData.map(function (point) {
                                return { lat: point.latitude, lng: point.longitude,sort:point.sort,sessionNumber:point.sessionNumber };
                            });
                        }
                    });

                    // Now use groupedRoutePaths to create polylines
                    Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                        if(sessionNumber!="null"){
                            var sectionPath = [];
                            sectionPath = groupedRoutePaths[sessionNumber];
                            sectionPath.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
                            if (sectionPath) {
                                var polyline = new google.maps.Polyline({
                                    path: sectionPath,
                                    geodesic: true,
                                    strokeColor: '#FD7A24',
                                    strokeOpacity: 1.0,
                                    strokeWeight: 4,
                                });
                                polyline.setMap(locations.map);
                            }
                        }
                    });
                }

                if (chainageList.length) {
                    createMarkers(chainageList, 'content/images/chainagePoints.png', locations.map)
                }
            });
        }


        function createMetaTag(attrName, attrValue, content) {
            var meta = document.createElement('meta');
            meta.setAttribute(attrName, attrValue);
            meta.setAttribute('content', content);
            return meta;
        }

        function createTable(classNames) {
            var table = document.createElement('table');
            table.setAttribute('border', '1');
            table.setAttribute('cellpadding', '5');
            table.setAttribute('cellspacing', '0');
            table.setAttribute('id', 'sheet0');
            table.setAttribute('class', classNames);
            return table;
        }

        function createTableCell(tagName, textContent) {
            var cell = document.createElement(tagName);
            cell.textContent = textContent;
            return cell;
        }

		function gotoLatitute() {
		         $("#modalLatLongs").show();
		         /* noDataText = document.getElementById("noData");
		         noDataText.style.display = "none"; */
		     }

		     function gotoLatituteCity() {
		         $("#modalLatLongs").show();
		         /* noDataText = document.getElementById("noData");
		         noDataText.style.display = "none"; */
		     }

		     function closeGotoLatitute(id) {
		         $("#" + id).removeClass("in");
		         $(".modal-backdrop").remove();
		         $("#" + id).hide();
		     }
		     function closeGotoLatituteCity() {
		         $("#modalLatLongs").removeClass("in");
		         $(".modal-backdrop").remove();
		         $("#modalLatLongs").hide();
		     }
			 
        function showTaskLogReport(sectionId) {
            vm.isReportGenerated = false;
            TaskLogSectionReportData.query(
                {
                    reportType: "daily",
                    sectionId: sectionId
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                var htmlDoc = document.createElement('html');
                var head = document.createElement('head');
                var meta1 = createMetaTag('http-equiv', 'Content-Type', 'text/html; charset=utf-8');
                var meta2 = createMetaTag('name', 'generator', 'PhpSpreadsheet, https://github.com/PHPOffice/PhpSpreadsheet');
                var meta3 = createMetaTag('name', 'author', 'Apache POI');
                var meta4 = createMetaTag('name', 'company', 'Microsoft Corporation');
                head.appendChild(meta1);
                head.appendChild(meta2);
                head.appendChild(meta3);
                head.appendChild(meta4);
                var body = document.createElement('body');
                var table = createTable('sheet0 gridlines');
                var thead = document.createElement('thead');
                var tbody = document.createElement('tbody');

                function createTable(classNames) {
                    var table = document.createElement('table');
                    table.setAttribute('border', '1');
                    table.setAttribute('cellpadding', '5');
                    table.setAttribute('cellspacing', '0');
                    table.setAttribute('id', 'sheet0');
                    table.setAttribute('class', classNames);
                    return table;
                }

                function createMetaTag(attrName, attrValue, content) {
                    var meta = document.createElement('meta');
                    meta.setAttribute(attrName, attrValue);
                    meta.setAttribute('content', content);
                    return meta;
                }

                function createTableCell(tag, content) {
                    var cell = document.createElement(tag);
                    cell.textContent = content;
                    cell.style.fontSize = "13px";
                    return cell;
                }

                thead.className = 'thReport';
                table.appendChild(thead);
                tbody.className = 'tdReport';
                table.appendChild(tbody);
                var styleElement = document.createElement('style');
                styleElement.textContent = "\
                .subheader {\
                    margin: auto;\
                }\
                .thReport > tr > th{\
                    text-align: center;\
                    padding: 10px;\
                }\
                .tdReport > tr > td {\
                    text-align: center; \
                    padding: 10px;\
                }\
                ";
                document.head.appendChild(styleElement);

                var colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2',];
                function getRandomColor() {
                    if (colors.length === 0) {
                        colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2'];
                    }
                    var index = Math.floor(Math.random() * colors.length);
                    var color = colors[index];
                    colors.splice(index, 1);
                    return color;
                }


                var groupedData = {};
                data.forEach(function (item) {
                    if (!groupedData[item.date]) {
                        groupedData[item.date] = [];
                    }
                    groupedData[item.date].push(item);
                });
                var names = getUniqueNames(data);
                var nameHeaderRow = document.createElement('tr');
                var serialNumberHeader = createTableCell('th', 'S.No');
                serialNumberHeader.style.fontWeight = 'bold';
                serialNumberHeader.style.backgroundColor = '#7dcfb6';
                serialNumberHeader.rowSpan = 2;
                nameHeaderRow.appendChild(serialNumberHeader);
                var dateHeader = createTableCell('th', 'Date');
                dateHeader.style.backgroundColor = '#7dcfb6';
                dateHeader.style.fontWeight = 'bold';
                dateHeader.rowSpan = 2;
                nameHeaderRow.appendChild(dateHeader);
                var typeHeaderRow = document.createElement('tr');

                names.forEach(function (name, index) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    var availableTypes = getUniqueTypes(nameData);
                    var nameHeaderCell = createTableCell('th', name);
                    nameHeaderCell.style.backgroundColor = getRandomColor();
                    nameHeaderCell.style.fontWeight = 'bold';
                    nameHeaderCell.colSpan = availableTypes.length;
                    nameHeaderRow.appendChild(nameHeaderCell);
                    availableTypes.forEach(function (type) {
                        var typeHeaderCell = createTableCell('th', type);
                        typeHeaderCell.style.backgroundColor = nameHeaderCell.style.backgroundColor;
                        typeHeaderCell.style.fontWeight = 'bold';
                        typeHeaderRow.appendChild(typeHeaderCell);
                    });
                });
                var totalProgressHeader = createTableCell('th', 'Total Progress');
                totalProgressHeader.style.backgroundColor = '#cfe0c3';
                totalProgressHeader.style.fontWeight = 'bold';
                totalProgressHeader.colSpan = 3;
                nameHeaderRow.appendChild(totalProgressHeader);
                var subHeaders = [
                    {
                        type: 'Total',
                    },
                    {
                        type: "Ducting",
                    }, {
                        type: "Validation",

                    }
                ];
                subHeaders.forEach(function (subHeader) {
                    var subHeaderCell = createTableCell('th', subHeader.type);
                    subHeaderCell.style.backgroundColor = '#cfe0c3';
                    subHeaderCell.style.fontWeight = 'bold';
                    typeHeaderRow.appendChild(subHeaderCell);
                });
                thead.appendChild(nameHeaderRow);
                thead.appendChild(typeHeaderRow);
                var totals = {};

                Object.keys(groupedData)
                    .sort(function (a, b) {
                        var dateA = a.split('-').reverse().join('-');
                        var dateB = b.split('-').reverse().join('-');
                        return new Date(dateA) - new Date(dateB);
                    })
                    .forEach(function (date, index) {
                        var totalLength = 0;
                        var totalValidation = 0;
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name && item.date === date; });
                            var ductingLength = 0;
                            var hddLength = 0;
                            var horizontalDirectionalDrilling = 0
                            var validationLength = 0;
                            nameData.forEach(function (item) {
                                if (item.type === 'Ducting') {
                                    ductingLength += item.length;
                                }
                                else if (item.type === 'HDD') {
                                    hddLength += item.length;

                                }
                                else if (item.type === 'HDD ( Horizontal Directional Drilling )') {
                                    horizontalDirectionalDrilling += item.length;
                                    console.log(horizontalDirectionalDrilling)
                                }
                                else if (item.type === 'Validation' || item.type === 'Validation (T&D)') {
                                    validationLength += item.length;
                                }
                            });
                            console.log(totalLength)
                            totalLength += (ductingLength + hddLength + horizontalDirectionalDrilling);
                            totalValidation += validationLength;

                        });
                        var tr = document.createElement('tr');
                        var serialNumberCell = createTableCell('td', index + 1);
                        serialNumberCell.style.fontSize = "13px";
                        tr.appendChild(serialNumberCell);
                        var dateCell = createTableCell('td', date);
                        dateCell.style.width = '77px'
                        dateCell.style.whiteSpace = 'nowrap';
                        dateCell.style.fontSize = "13px";
                        tr.appendChild(dateCell);
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name; });
                            var availableTypes = getUniqueTypes(nameData);

                            availableTypes.forEach(function (type) {
                                var item = groupedData[date].find(function (item) {
                                    return item.name === name && item.type === type;
                                });
                                var lengthValue = item ? item.length : 0;
                                var td = createTableCell('td', lengthValue);

                                tr.appendChild(td);
                                if (!totals[type]) {
                                    totals[type] = 0;
                                }
                                totals[type] += lengthValue;
                            });
                        });
                        var total = 0;
                        for (var i = 2; i < tr.cells.length; i++) {
                            total += parseInt(tr.cells[i].textContent);
                        }
                        var columnValueCell = createTableCell('td', total);
                        columnValueCell.colSpan = 1;
                        tr.appendChild(columnValueCell);
                        var remainingDuctingCell = createTableCell('td', totalLength);
                        tr.appendChild(remainingDuctingCell);
                        var remainingValidationCell = createTableCell('td', totalValidation);
                        tr.appendChild(remainingValidationCell);
                        if (index === 0) {
                            totals['Total Progress Ducting'] = 0;
                            totals['Total Progress Validation'] = 0;
                        }
                        totals['Total Progress Ducting'] += totalLength;
                        totals['Total Progress Validation'] += totalValidation;
                        tbody.appendChild(tr);
                    });

                var staticColumns = ['Total', 'Balance Validation', 'Balance Ducting'];
                var allAvailableTypes = [];
                names.forEach(function (name) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    allAvailableTypes.push.apply(allAvailableTypes, getUniqueTypes(nameData));
                });
                var availableTypes = allAvailableTypes;
                var maxUniqueTypesCount = availableTypes.length;
                var totalLength = maxUniqueTypesCount + subHeaders.length;

                var columnTotals = {};
                for (var i = 2; i < totalLength; i++) {
                    var total = 0;
                    for (var j = 0; j < tbody.rows.length; j++) {
                        var cellValue = parseInt(tbody.rows[j].cells[i].textContent) || 0;
                        total += cellValue;
                    }
                    columnTotals[i] = total;
                }
                staticColumns.forEach(function (column) {
                    var staticRow = document.createElement('tr');
                    var columnNameCell = createTableCell('td', column);
                    columnNameCell.colSpan = 2;
                    columnNameCell.style.backgroundColor = '#cfe0c3';
                    columnNameCell.style.fontSize = "13px";
                    columnNameCell.style.fontWeight = 'bold';
                    staticRow.appendChild(columnNameCell);
                    if (column == 'Total') {
                        for (var i = 2; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', columnTotals[i].toString());
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                        var columnValueCell = createTableCell('td', totals['Total Progress Ducting']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                        var columnValueCell = createTableCell('td', totals['Total Progress Validation']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                    } else {
                        for (var i = 0; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', '0');
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                    }
                    tbody.appendChild(staticRow);
                });
                table.appendChild(thead);
                table.appendChild(tbody);
                body.appendChild(table);
                htmlDoc.appendChild(body);
                htmlDoc.appendChild(head);
                var htmlString = htmlDoc.outerHTML;
                var containerDiv = document.getElementById("generatedHtmlContainer");
                containerDiv.innerHTML = htmlString;

                function getUniqueNames(data) {
                    var uniqueNames = [];
                    data.forEach(function (item) {
                        if (uniqueNames.indexOf(item.name) === -1) {
                            uniqueNames.push(item.name);
                        }
                    });
                    return uniqueNames;
                }
                function getUniqueTypes(data) {
                    var uniqueTypes = [];
                    data.forEach(function (item) {
                        if (uniqueTypes.indexOf(item.type) === -1) {
                            uniqueTypes.push(item.type);
                        }
                    });
                    return uniqueTypes;
                }

                // Set background color for specified cells
                var jcbCells = document.querySelectorAll('.row1 .column0'); // Select cells in row 1, column 0 (JCB)
                var hddCells = document.querySelectorAll('.row1 .column1'); // Select cells in row 1, column 1 (HDD)

                // Loop through JCB cells and set background color to light green
                jcbCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Loop through HDD cells and set background color to light green
                hddCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Get the Total row
                // Select all relevant rows
                var relevantRows = ['.row2', '.row3', '.row5', '.row6'];

                // Loop through each relevant row
                relevantRows.forEach(function (rowClass) {
                    var cells = document.querySelectorAll(rowClass + ' td');

                    // Loop through the cells in the row
                    cells.forEach(function (cell) {
                        // Check if the content of the cell is '0' or empty
                        if (cell.textContent.trim() === '0' || cell.textContent.trim() === '') {
                            // Set background color to white
                            cell.style.backgroundColor = 'white';
                        }
                    });
                });

                vm.isReportGenerated = true;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.latitude, lng: each.longitude },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                google.maps.event.addListener(
                    marker,
                    "click",
                    (function () {
                        //var name = (each.name == (undefined || null)) ? " " : each.name
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead"></br></br>' +
                            /* "<b>Name : "+name+"</b></br>"+ */
                            "<b>Latitude : " + each.latitude + "</b></br>" +
                            "<b>Longitude : " + each.longitude + "</b></br>" +
                            "<b>Type : " + each.type + "</b></br>" +
                            "</br></div>"
                        );
                        infowindow.open(map);
                        infowindow.setPosition({
                            lat: each.latitude,
                            lng: each.longitude,
                        });
                        openedInfoWindow = infowindow;
                    }))

                arr.push(marker);
            })
        }


        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
            {
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#EFEFEF",
                    },
                ],
            }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = labelFrom
            } else if (markers.length == 1) {
                markerText = labelTo
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: "content/images/sections.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        -4
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
                label: {
                    text: markerText,
                }
            });

            // Add the marker to the markers array
            markers.push(marker);
        }

        /*  Summary.resTx(entity.id, function (response) {
             vm.resTxSummary = response
         })
 
         Summary.mtrlTx(entity.id, function (response) {
             vm.mtrlTxSummary = response
         })
 
         SummaryPost.dailyLogsTx({
             "projectIds": [vm.trSection.projectId],
             "routeIds": [vm.trSection.routeId],
             "sectionIds": [vm.trSection.id]
         }, function (response) {
             vm.dailyLogsTxSummary = response
         })
 
          */

        Summary.dailyLogsTx(entity.id, function (response) {
            vm.dailyLogsTxSummary = response
        })

        SummaryPost.mtrlTx({
            "projectIds": [vm.trSection.projectId],
            "routeIds": [vm.trSection.routeId],
            "sectionIds": [vm.trSection.id]
        }, function (response) {
            vm.mtrlTxSummary = response
        })

        SummaryPost.resTx({
            "projectIds": [vm.trSection.projectId],
            "routeIds": [vm.trSection.routeId],
            "sectionIds": [vm.trSection.id]
        }, function (response) {
            vm.resTxSummary = response
        })

        vm.objectRouteImg = {}
        vm.objectRouteImg.routeId = vm.trSection.routeId
        vm.objectRouteImg.map = locations.map

        vm.autoGenerateTask = function () {
            TaskSectionById.postAutoGenerateTasks(entity, function () {
                Inventory.taskBySection(entity.id, function (response) {
                    vm.taskResponse = response
                })
            })
        }

        if ((vm.trSection.fromRoutePoint != null && vm.trSection.toRoutePoint != null)) {
            locations.map.setCenter({ lat: vm.trSection.fromRoutePoint.latitude, lng: vm.trSection.fromRoutePoint.longitude })
            addMarker({ lat: vm.trSection.fromRoutePoint.latitude, lng: vm.trSection.fromRoutePoint.longitude })
            addMarker({ lat: vm.trSection.toRoutePoint.latitude, lng: vm.trSection.toRoutePoint.longitude })
        }

        vm.page = 1;
        vm.predicate = 'modified_date';
        vm.itemsPerPage = 10;
        vm.mtrpage = 1;
        vm.mtrPerPage = 10;
        vm.materialTxnByDates = [];
        vm.materialByDate = [];
        vm.loadMaterialTxnDate = function () {
            MaterialDates.query({
                type: "section",
                id: entity.id,
                page: vm.mtrpage - 1,
                size: vm.mtrPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.TotalItems = headers('X-Total-Count');
                vm.QueryCount = vm.TotalItems;
                vm.materialByDate = data.map(function (item) {
                    return {
                        timestamp: item[0],
                        total: item[1],
                        isExpand: false
                    };
                });

            });
        };

        vm.loadMaterialTxnDate();

        vm.loadMaterialTxnByDates = function (date) {
            MaterialByDates.query({
                type: 'section',
                id: entity.id,
                date: date,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materialTxnByDates = data.map(function (item) {
                    return {
                        materialId: item[0] || "NA",
                        timestamp: item[4] || "NA",
                        materialName: item[1] || "NA",
                        transactionType: item[2] || "NA",
                        mtrlTxNumber: item[6] || "NA",
                        count: item[3] || "NA",
                        status: item[5] || "NA",
                    };
                });
            });
        };
        vm.materialTxnByDates = [];
        var today = new Date();
        today.setHours(23, 59, 59);
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.options = {
            maxDate: today
        };
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }



        function epoch(date) {
            return Date.parse(date)
        }
        vm.isModalOpen = false;
        vm.selectedTransaction = {};
        vm.openTransactionModal = function (transaction) {
            vm.selectedTransaction = angular.copy(transaction);
            vm.isModalOpen = true;
        };

        vm.saveTransaction = function () {
            var transactionData = {
                materialId: vm.selectedTransaction.materialId,
                unitOfMeasurement: vm.selectedTransaction.unitOfMeasurement,
                noOfUnits: vm.selectedTransaction.noOfUnits,
                transactionDate: epoch(vm.selectedTransaction.transactionDate),
                transactionType: vm.selectedTransaction.transactionType,
                mtrlTxNumber: vm.selectedTransaction.mtrlTxNumber,
                invoiceNumber: vm.selectedTransaction.invoiceNumber || null,
                remarks: vm.selectedTransaction.remarks || null,
                sectionId: vm.trSection.id
            };
            Inventory.postBulkMaterialTxn([transactionData], function () {
                $window.history.back();
            }, function (error) {
                console.error('Error saving transaction:', error)
            });
            vm.isModalOpen = false;
        };

        vm.cancelTransaction = function () {
            vm.selectedTransaction = {};
            vm.isModalOpen = false;
        };

        vm.transactionType = ["RECEIVED", "UTILIZED", "RECONCILED"]
        vm.toggleExpand = function (selectedTask) {
            angular.forEach(vm.materialByDate, function (task) {
                if (task === selectedTask) {
                    task.isExpand = !task.isExpand;
                    if (task.isExpand) {
                        vm.loadMaterialTxnByDates(task.timestamp);
                    } else {
                        vm.materialTxnByDates = [];
                    }
                } else {
                    task.isExpand = false;
                }
            });
        };
        vm.transitionMainMateril = function () {
            vm.loadMaterialTxnDate()
        }
        vm.getSectionPath = function () {
            vm.dailyLog_map = new google.maps.Map(
                document.getElementById("map_canvasStart1"),
                myOption(16, center)
            )
            if (vm.trSection != null) {
                TaskSectionById.get(vm.trSection.id, function (sectionVal) {
                    var sectionPathResponse = sectionVal;
                    var polylineCoordinates = []
                    var bounds = new google.maps.LatLngBounds();
                    sectionPathResponse.COORDINATE.forEach(function (coordinate) {
                        var latLng = {
                            lat: coordinate.latitude,
                            lng: coordinate.longitude
                        };
                        polylineCoordinates.push(latLng);
                        bounds.extend(latLng);
                        var polyline = new google.maps.Polyline({
                            path: polylineCoordinates,
                            geodesic: true,
                            strokeColor: '#FD7A24',
                            strokeOpacity: 0.5,
                            strokeWeight: 5
                        });
                        polyline.setMap(vm.dailyLog_map);
                    });
                    vm.dailyLog_map.fitBounds(bounds);
                })
            }
            vm.dailyLogPolyline = {}
            vm.taskPolyline = {}
            Inventory.taskBySection(entity.id, function (response) {
                vm.taskLogResponse = response;
                vm.taskLogResponse.forEach(function (task) {
                    Inventory.taskPathByID(task.id, function (response) {
                        if (response.COORDINATE !== undefined) {
                            var polylineCoordinates = [];
                            response.COORDINATE.forEach(function (coordinate) {
                                if (coordinate.routePointType === 'COORDINATE') {
                                    var latLng = {
                                        lat: coordinate.latitude,
                                        lng: coordinate.longitude
                                    };
                                    polylineCoordinates.push(latLng);
                                }
                            });
                            var polyline = new google.maps.Polyline({
                                path: polylineCoordinates,
                                geodesic: true,
                                strokeColor: '#ff9a8a',
                                strokeOpacity: 0.8,
                                strokeWeight: 4
                            });
                            polyline.setMap(vm.dailyLog_map);
                            vm.taskPolyline[task.id] = polyline
                        }
                    });
                });
            });
        }

        vm.getSectionPath()
        vm.expand = function (task) {
            vm.dailyLogs = [];
            vm.taskLogResponse.forEach(function (t) {
                if (t !== task) {
                    t.isExpanded = false;
                }
            });
            task.isExpanded = !task.isExpanded;
            if (task.isExpanded) {
                DailyLogByTaskIdWithType.query(
                    {
                        id: task.id,
                        type: 'PROGRESS'
                    },
                    function onSuccess(response) {
                        vm.dailyLogs = response;
                        Object.values(vm.dailyLogPolyline).forEach(function (polyline) {
                            polyline.setMap(null);
                        });
                        vm.dailyLogPolyline = {};
                        // var colors = ['#fe9ebc', '#8338ec', '#fe6259', '#fe2400', '#00658d', '#ff66d8', '#4cc9f0'];
                        vm.dailyLogs.forEach(function (coor, index) {
                            // var pathColor = colors[index % colors.length];
                            var fromLatLng = new google.maps.LatLng(coor.fromRoutePointLat, coor.fromRoutePointLng);
                            var toLatLng = new google.maps.LatLng(coor.toRoutePointLat, coor.toRoutePointLng);

                            var polyline = new google.maps.Polyline({
                                path: [fromLatLng, toLatLng],
                                geodesic: true,
                                strokeColor: '#06d6a0',
                                strokeOpacity: 1.0,
                                strokeWeight: 5
                            });
                            polyline.setMap(vm.dailyLog_map);
                            vm.dailyLogPolyline[coor.id] = polyline;
                        });
                    }
                );
            }
        };
        vm.startPoint = null;
        vm.endPoint = null;
        vm.highlightLog = function (id) {
            var polyline = vm.dailyLogPolyline[id];
            if (polyline) {
                polyline.setOptions({
                    strokeWeight: 16
                });
                var path = polyline.getPath().getArray();
                var fromLatLng = path[0];
                var toLatLng = path[path.length - 1];
                if (vm.startPoint) {
                    vm.startPoint.setMap(null);
                }
                if (vm.endPoint) {
                    vm.endPoint.setMap(null);
                }
                vm.startPoint = new google.maps.Marker({
                    position: fromLatLng,
                    map: vm.dailyLog_map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: "content/images/sections.png",
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            -4
                        ),
                        labelOrigin: new google.maps.Point(25, 22)
                    },
                    label: {
                        text: 'Start',
                        color: '#000000',
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }
                });
                vm.endPoint = new google.maps.Marker({
                    position: toLatLng,
                    map: vm.dailyLog_map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: "content/images/sections.png",
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            -4
                        ),
                        labelOrigin: new google.maps.Point(25, 22)
                    },
                    label: {
                        text: 'End',
                        color: '#000000',
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }
                });
            }
        };
        vm.resetLog = function () {
            Object.keys(vm.dailyLogPolyline).forEach(function (key) {
                var polyline = vm.dailyLogPolyline[key];
                if (polyline) {
                    polyline.setOptions({
                        strokeWeight: 5
                    });
                }
            });
            if (vm.startPoint) {
                vm.startPoint.setMap(null);
                vm.startPoint = null;
            }
            if (vm.endPoint) {
                vm.endPoint.setMap(null);
                vm.endPoint = null;
            }
        };
        vm.highlightTask = function (taskId) {
            for (var id in vm.taskPolyline) {
                if (id == taskId) {
                    vm.taskPolyline[id].setOptions({ strokeWeight: 12 });
                } else {
                    vm.taskPolyline[id].setOptions({ strokeWeight: 5 });
                }
            }
        }
        vm.resetTask = function () {
            for (var id in vm.taskPolyline) {
                if (vm.taskPolyline.hasOwnProperty(id)) {
                    vm.taskPolyline[id].setOptions({ strokeWeight: 5 });
                }
            }
        }
		 function addPointer(location, map) {
		        var pointerIcon = {
		            path: google.maps.SymbolPath.CIRCLE,
		            scale: 5,
		            strokeColor: 'black',
		            fillColor: 'white',
		            fillOpacity: 1,
		            strokeWeight: 2
		        };

		        var pointer = new google.maps.Marker({
		            position: location,
		            map: map,
		            icon: pointerIcon
		        });
		        pointerMarkers.push(pointer);
		    }
		    function formatDistance(distance) {
		        // Convert meters to kilometers
		        var km = distance / 1000;

		        // Show in meters if less than 1 km, otherwise show in kilometers
		        if (km < 1) {
		            return distance.toFixed(0) + ' m';
		        } else {
		            return km.toFixed(2) + ' km';
		        }
		    }

		    function clearMeasureTool(arr) {
		        for (var i = 0; i < arr.length; i++) {
		            arr[i].setMap(null)
		        }
		    }
		
		
		
		
		function addLatLng(event, map) {
		            var path = polyMeasureTool.getPath();
		            path.push(event.latLng);


		            addPointer(event.latLng, map);

		            var point1, point2
		            for (var i = 0; i < path.getLength() - 1; i++) {
		                point1 = path.getAt(i);
		                point2 = path.getAt(i + 1);
		                segmentDistance = google.maps.geometry.spherical.computeDistanceBetween(point1, point2);


		                // Add distance marker
		                midpoint = google.maps.geometry.spherical.interpolate(point1, point2, 0.5);

		            }


		            if (path.getLength() > 1) {
		                totalDistance += segmentDistance;
		                var marker = new google.maps.Marker({
		                    position: midpoint,
		                    map: map,
		                    icon: {
		                        url: 'content/images/iconTransparent.png',
		                    },
		                    label: {
		                        color: "black",
		                        fontWeight: "bold",
		                        fontSize: "14px",
		                        text: formatDistance(segmentDistance),
		                    },
		                });
		                distanceMarkers.push(marker);

		                var totalDistanceMarker = new google.maps.Marker({
		                    position: point2,
		                    map: map,
		                    icon: {
		                        url: 'content/images/iconTransparent.png',
		                    },
		                    label: {
		                        color: "black",
		                        fontWeight: "bold",
		                        fontSize: "14px",
		                        text: "Total : " + formatDistance(totalDistance),
		                    },
		                });
		                totalDistanceMarkers.push(totalDistanceMarker);
		            }

		        }
		
		function geoLocation(map) {
		           var infoWindow = new google.maps.InfoWindow();
		           var locationButton = document.createElement("button");
		           locationButton.setAttribute("title", "Locate Me");
		           locationButton.classList.add("custom-map-control-button");
		           var geoIcon = document.createElement("i");
		           geoIcon.classList.add("fa");
		           geoIcon.classList.add("fa-crosshairs");
		           geoIcon.classList.add("geo");
		           locationButton.appendChild(geoIcon);
		           map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
		               locationButton
		           );

		           var goTo = document.createElement("button");
		           goTo.setAttribute("title", "Location Coordinates");
		           goTo.classList.add("custom-map-control-button");
		           var gotoIcon = document.createElement("i");
		           gotoIcon.classList.add("fa");
		           gotoIcon.classList.add("fa-location-arrow");
		           gotoIcon.classList.add("geo");
		           goTo.appendChild(gotoIcon);
		           map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);

		           /* var zoomLabel = document.createElement("span");
		           zoomLabel.setAttribute("title", "Zoom");
		           zoomLabel.classList.add("custom-map-control-button");
		           var textnode = document.createTextNode("Zoom :"+vm.zoomLevel);
		           zoomLabel.appendChild(textnode);
		           map.controls[google.maps.ControlPosition.LEFT_TOP].push(
		               zoomLabel
		           );  */

		           goTo.addEventListener("click", function () {
		               gotoLatitute();
		           });


		           measureTool = document.createElement("button");
		           measureTool.setAttribute("title", "Measure Distance");
		           measureTool.classList.add("custom-map-control-button");
		           measureTool.id = "measureDistance";
		           measureToolIcon.classList.add("fa");
		           measureToolIcon.classList.add("fa-arrows-h");
		           measureToolIcon.classList.add("ruler");
		           measureTool.appendChild(measureToolIcon);
		           map.controls[google.maps.ControlPosition.RIGHT_TOP].push(measureTool);
		           measureTool.addEventListener("click", function () {

		               if (measureEnabled) {
		                   google.maps.event.removeListener(vm.clickListener);

		                   totalDistance = 0
		                   clearMeasureTool(distanceMarkers)
		                   clearMeasureTool(pointerMarkers)
		                   clearMeasureTool(arrpolyMeasureTool)
		                   clearMeasureTool(totalDistanceMarkers)
		                   distanceMarkers = []
		                   totalDistanceMarkers = []
		                   pointerMarkers = []
		                   arrpolyMeasureTool = []


		                   measureEnabled = false

		                   measureTool.setAttribute("title", "Measure Distance");
		                   measureToolIcon.classList.remove("fa-times");
		                   measureToolIcon.classList.add("fa-arrows-h");


		               } else {
		                   measureEnabled = true
		                   polyMeasureTool = new google.maps.Polyline({
		                       strokeColor: 'black',
		                       strokeOpacity: 1.0,
		                       strokeWeight: 3
		                   });
		                   polyMeasureTool.setMap(map);
		                   arrpolyMeasureTool.push(polyMeasureTool)

		                   vm.clickListener = map.addListener('click', function (event) {
		                       addLatLng(event, map)
		                   });


		                   measureTool.setAttribute("title", "Clear Distance");
		                   measureToolIcon.classList.remove("fa-arrows-h");
		                   measureToolIcon.classList.add("fa-times");
		               }
		           });

		           locationButton.addEventListener("click", function () {
		               // Try HTML5 geolocation.
		               if (navigator.geolocation) {
		                   navigator.geolocation.getCurrentPosition(
		                       function (position) {
		                           var pos = {
		                               lat: position.coords.latitude,
		                               lng: position.coords.longitude,
		                           };

		                           infoWindow.setPosition(pos);
		                           infoWindow.setContent("Location found.");
		                           infoWindow.open(map);
		                           // var image = {
		                           //     url: "content/images/geoLocation.png", // url
		                           //     scaledSize: new google.maps.Size(25, 25), // scaled size
		                           //     origin: new google.maps.Point(0, 0), // origin
		                           //     anchor: new google.maps.Point(0, 0), // anchor
		                           // };
		                           // var markerGeo = new google.maps.Marker({
		                           //     position: pos,
		                           //     icon: image,
		                           // });
		                           // map.setZoom(20);
		                           // markerGeo.setMap(map);
		                           map.setZoom(18);
		                           map.setCenter(pos);
		                       },
		                       function () {
		                           handleLocationError(
		                               true,
		                               infoWindow,
		                               map.getCenter()
		                           );
		                       },
		                       {
		                           enableHighAccuracy: true,
		                           timeout: 5000,
		                           maximumAge: 0,
		                       }
		                   );
		               } else {
		                   // Browser doesn't support Geolocation
		                   handleLocationError(false, infoWindow, map.getCenter());
		               }
		           });

		           function handleLocationError(
		               browserHasGeolocation,
		               infoWindow,
		               pos
		           ) {
		               infoWindow.setPosition(pos);
		               infoWindow.setContent(
		                   browserHasGeolocation
		                       ? "Error: The Geolocation service failed."
		                       : "Error: Your browser doesn't support geolocation."
		               );
		               infoWindow.open(map);
		           }
		       }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrSectionDeleteController',TrSectionDeleteController);

    TrSectionDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrSection','$scope'];

    function TrSectionDeleteController($uibModalInstance, entity, TrSection,$scope) {
        var vm = this;

        vm.trSection = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrSection.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-section', {
                parent: 'app',
                url: '/tr-section',
                data: {
                    authorities: ['SECTION_SIDEBAR'],                    
                    pageTitle: 'trakeyeApp.section.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-sections.html',
                        controller: 'TrSectionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trSection');
                        $translatePartialLoader.addPart('sectionStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-section-detail', {
                parent: 'tr-section',
                url: '/tr-section/{id}/{routeId}',
                data: {
                    authorities: ['SECTION_DETAIL'],
                    pageTitle: 'trakeyeApp.section.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-detail.html',
                        controller: 'TrSectionDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trSection');
                        $translatePartialLoader.addPart('sectionStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrSection', function ($stateParams, TrSection) {
                        return TrSection.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-section',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-section.priority', {
                parent: 'tr-section',
                url: '/tr-sections/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.section.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-sections.html',
                        controller: 'TrSectionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trSection');
                        $translatePartialLoader.addPart('sectionStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-section.attendance', {
                parent: 'tr-section',
                url: '/tr-sections/attendance/{login}/{fromTime}/{toTime}/{sectionStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.section.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-sections.html',
                        controller: 'TrSectionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            sectionStatus: $stateParams.sectionStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trSection');
                        $translatePartialLoader.addPart('sectionStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-section.new', {
                parent: 'tr-section',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}/{routeId}',
                data: {
                    authorities: ['SECTION_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-dialog.html',
                        controller: 'TrSectionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            sectionImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

        .state('tr-section.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-section/tr-section-work-flow.html',
                    controller: 'TrSectionWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        sectionImages: []
                    };
                }]
            }
        })

        .state('tr-section.import', {
                parent: 'tr-section',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-import.html',
                        controller: 'TrSectionImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            sectionImages: []
                        };
                    }
                }

            })
            .state('tr-section.edit', {
                parent: 'tr-section',
                url: '/Edit/{id}/{routeId}',
                data: {
                    authorities: ['SECTION_EDIT'],
                    pageTitle: 'trakeyeApp.section.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-dialog.html',
                        controller: 'TrSectionDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrSection', function ($stateParams, TrSection) {
                        return TrSection.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-section',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

            .state('tr-section.delete', {
                parent: 'tr-section',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-section/tr-section-delete-dialog.html',
                        controller: 'TrSectionDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrSection', function (TrSection) {
                                return TrSection.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-section', null, { reload: 'tr-section' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-section.fibercore', {
                parent: 'tr-section',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-fiber-core.html',
                        controller: 'TrSectionFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            sectionImages: []
                        };
                    }
                }

            })

            .state('show-hide-section', {
                parent: 'report',
                url: '/show-hide-section',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/show-hide-section.html',
                        controller: 'ShowHideSectionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })


            .state('tr-section.materialTxndialog', {
                parent: 'tr-section',
                url: '/materialTxn/{entityName}/{entityId}/{id}/{sectionId}',
                data: {
                    authorities: ['MATERIALTX_CREATE','MATERIALTX_EDIT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/material-txn.dialog.html',
                        controller: 'MaterialTxnDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    
                    entityId :  ['$stateParams', function ($stateParams) {
                        if($stateParams.entityId){ 
                            return $stateParams.entityId
                        }else{
                            return null
                        }
                    }],

                    entity: ['$stateParams', function ($stateParams) {
                        return $stateParams.id 
                    }]  
                }
            })

            .state('tr-section.resourceTxndialog', {
                parent: 'tr-section',
                url: '/resourceTxn/{entityName}/{entityId}/{id}/{sectionId}',
                data: {
                    authorities: ['RESOURCETX_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/resource-txn.dialog.html',
                        controller: 'ResourceTxnDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entityId :  ['$stateParams', function ($stateParams) {
                        if($stateParams.entityId){ 
                            return $stateParams.entityId
                        }else{
                            return null
                        }
                    }],

                    entity: ['$stateParams', function ($stateParams) {
                        return $stateParams.id 
                    }]    
                }
            });
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrSection', TrSection);

	TrSection.$inject = ['$resource', 'DateUtils'];

	function TrSection($resource, DateUtils) {
		var resourceUrl = 'api/tr-sections/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionListByRouteId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-sections-by-routeId/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionListIdByRouteId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-sections-list-by-routeId/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionListIdName', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (callback) {
			$http.get('api/tr-sections-list').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionGeofence', TrSectionGeofence);

	TrSectionGeofence.$inject = ['$resource'];

	function TrSectionGeofence($resource) {
		var service = $resource('/api/tr-sections/geofence/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionCustomTime', TrSectionCustomTime);

	TrSectionCustomTime.$inject = ['$resource'];

	function TrSectionCustomTime($resource) {
		var service = $resource('/api/tr-sections-custom/:fromDate/:toDate', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionGeofenceCustomTime', TrSectionGeofenceCustomTime);

	TrSectionGeofenceCustomTime.$inject = ['$resource'];

	function TrSectionGeofenceCustomTime($resource) {
		var service = $resource('/api/tr-sections-custom/geofence/:geofenceId/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrSectionCheckAsset', TrSectionCheckAsset);

	TrSectionCheckAsset.$inject = ['$resource', 'DateUtils'];

	function TrSectionCheckAsset($resource, DateUtils) {
		var resourceUrl = 'api/assets/search/:name';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
		});
	}
})();


(function () {
	'use strict';
	angular.module('trakeyeApp').factory('SectionsForAsset', SectionsForAsset);

	SectionsForAsset.$inject = ['$resource'];

	function SectionsForAsset($resource) {
		var resourceUrl = 'api/sections-for-asset/:assetId';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-sections/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('SectionPathById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-sections-path/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getSectionImage', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/trakeyesectionimages/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getNearbyFixed', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, data, callback) {
			$http.post('api/assets/nearby-fixed/' + id, data).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionAssetsById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-sections-assets/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('SectionAttributeMappingId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/custom-section-type-mapper/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

/*
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionById', TrSectionById);

	TrSectionById.$inject = [ '$resource' ];

	function TrSectionById($resource) {
		var service = $resource('/api/tr-sections/:id', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();*/

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionCountByGroup', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/sectioncountbygroup').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadSectionReports', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-sections').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionCountByStatus', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/sectioncountbystatus').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionPriority', TrSectionPriority);

	TrSectionPriority.$inject = ['$resource'];

	function TrSectionPriority($resource) {
		var service = $resource('/api/tr-sections/priority/:priority/:geofenceId', {
			priority: '@priorirty'
		}, { geofenceId: '@geofenceId' }, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionAttendance', TrSectionAttendance);

	TrSectionAttendance.$inject = ['$resource'];

	function TrSectionAttendance($resource) {
		var service = $resource('/api/tr-sections/attendance/:login/:fromTime/:toTime/:sectionStatus',
			{}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionSearch', TrSectionSearch);

	TrSectionSearch.$inject = ['$resource'];

	function TrSectionSearch($resource) {
		var service = $resource('/api/tr-sections/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionSearchCustom', TrSectionSearchCustom);

	TrSectionSearchCustom.$inject = ['$resource'];

	function TrSectionSearchCustom($resource) {
		var service = $resource('/api/tr-sections-custom/searchvalue/:search/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionGeofenceSearch', TrSectionGeofenceSearch);

	TrSectionGeofenceSearch.$inject = ['$resource'];

	function TrSectionGeofenceSearch($resource) {
		var service = $resource('/api/tr-sections/geofence-searchvalue/:geofenceId/:search', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionGeofenceSearchCustom', TrSectionGeofenceSearchCustom);

	TrSectionGeofenceSearchCustom.$inject = ['$resource'];

	function TrSectionGeofenceSearchCustom($resource) {
		var service = $resource('/api/tr-sections-custom/geofence-searchvalue/:geofenceId/:search/:fromDate/:toDate', {}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrSectionGroup', TrSectionGroup);

	TrSectionGroup.$inject = ['$resource', 'DateUtils'];

	function TrSectionGroup($resource, DateUtils) {
		var resourceUrl = 'api/tr-sections-group';

		return $resource(resourceUrl, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionGroupSearch', TrSectionGroupSearch);

	TrSectionGroupSearch.$inject = ['$resource'];

	function TrSectionGroupSearch($resource) {
		var service = $resource('/api/tr-sections-group/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionGroupPrioritySearch', TrSectionGroupPrioritySearch);

	TrSectionGroupPrioritySearch.$inject = ['$resource'];

	function TrSectionGroupPrioritySearch($resource) {
		var service = $resource('/api/tr-sections-group/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionGroupPriority', TrSectionGroupPriority);

	TrSectionGroupPriority.$inject = ['$resource'];

	function TrSectionGroupPriority($resource) {
		var service = $resource('/api/tr-sections-group/priority/:priority', {
			priority: '@priorirty'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionImages', TrSectionImages);

	TrSectionImages.$inject = ['$resource'];

	function TrSectionImages($resource) {
		var service = $resource('/api/section-images/:sectionId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionsForType', TrSectionsForType);

	TrSectionsForType.$inject = ['$resource'];

	function TrSectionsForType($resource) {
		var service = $resource('/api/trsectionsbytype/:sectionTypeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}

})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('NearByBGOH', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (data, success, error) {
			$http.post('api/tr-sections/nearby-bgoh-assets', data).then(function (response) {
				success(response.data);
			}, function (response) {
				error(response.status);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionRecordings', TrSectionRecordings);

	TrSectionRecordings.$inject = ['$resource'];

	function TrSectionRecordings($resource) {
		var service = $resource('/api/section-recordings/:sectionId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllSectionTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/section-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionPrioritySearch', TrSectionPrioritySearch);

	TrSectionPrioritySearch.$inject = ['$resource'];

	function TrSectionPrioritySearch($resource) {
		var service = $resource('/api/tr-sections/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrSectionUpdateGroup', TrSectionUpdateGroup);

	TrSectionUpdateGroup.$inject = ['$resource'];

	function TrSectionUpdateGroup($resource) {
		var resourceUrl = 'api/tr-sections/groups';

		return $resource(resourceUrl, {}, {
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrSectionBulkDelete', TrSectionBulkDelete);

	TrSectionBulkDelete.$inject = ['$resource'];

	function TrSectionBulkDelete($resource) {
		var resourceUrl = 'api/tr-sections/bulk/delete';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionUser', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.gettrsectionsuser = function (callback) {
			$http.get('api/tr-sections/live-logs').then(function (response) {
				callback(response.data);
			});
		};

		service.gettrsectionsuserbyid = function (id, callback) {
			$http.get('api/tr-sections/live-logs/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.searchtrsectionsuserbyvalue = function (id, callback) {
			$http.get('api/tr-sections/search/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.gettrsectionsanduserbypriority = function (priority, callback) {
			$http.get('api/tr-sections/live-logs/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		service.getAgents = function (callback) {
			$http.get('api/dashboard/agentdashboard').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionEdit', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getalltrsections = function (callback) {
			$http.get('api/tr-allsections').then(function (response) {
				callback(response.data);
			});
		};

		service.edittrsection = function (data, callback) {
			$http.post('api/tr-sectionedit/' + data.userId + '/' + data.sectionId, {

			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {

				callback(error, error.headers);
			});

			/*
			 * $http.post('api/tr-sectionedit/'+data.userId+'/'+data.sectionId).then(function(response){
			 * callback(response.data); });
			 */
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrSectionUpload', TrSectionUpload);

	TrSectionUpload.$inject = ['$http'];

	function TrSectionUpload($http) {

		var service = {};
		service.trsectionupload = function (data, callback) {

			$http.post('api/sectionimport', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupSectionSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrsectionformap = function (search, callback) {
			$http.get('api/tr-groupsectionsformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupSectionForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllSections = function (callback) {
			$http.get('api/tr-groupsectionsformap').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrsectionformap = function (search, callback) {
			$http.get('api/tr-sectionsformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};

		service.prioritysearchtrsectionformap = function (priority, callback) {
			$http.get('api/tr-sectionsformap/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('TrSectionLastLocation', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			service.getlastlogs = function (callback) {
				$http.get('api/location-logs/lastuserpath').then(function (response) {
					callback(response.data);
				});
			};
			return service;
		}]);



})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('SectionsForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.sectionsformapbyadmin = function (adminid, callback) {
			$http.get('api/tr-sectionsformap/' + adminid).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrSectionForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllSections = function (data, callback) {
			// $http.get('api/tr-sectionsformap').then(function (response) {
			// 	callback(response.data);
			// });
			$http.post('api/tr-sectionsformap', data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ShowSectionById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.update = function (sectionid, callback) {
			$http.put('api/show-section/' + sectionid)
				.success(function (data, status, headers, config) {
					callback(status);
				})
				.error(function (data, status, header, config) {
					callback(status);
				});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('HideSectionById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.update = function (sectionid, callback) {
			$http.put('api/hide-section/' + sectionid)
				.success(function (data, status, headers, config) {
					callback(status);
				})
				.error(function (data, status, header, config) {
					callback(status);
				});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('Inventory', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};

		//GET
		service.materialTxn = function (id, callback) {
			$http.get('api/rollout/mtrl-tx/' + id).then(function (response) {
				callback(response.data);
			})
		};

		service.getMaterialTxn = function (id, materialId, callback) {
			$http.get('api/rollout/mtrl-tx/' + id + '/' + materialId).then(function (response) {
				callback(response.data);
			})
		};

		service.resourceTxn = function (id, callback) {
			$http.get('api/rollout/res-tx/' + id).then(function (response) {
				callback(response.data);
			})
		};

		service.getResourceTxn = function (id, resourceId, callback) {
			$http.get('api/rollout/res-tx/' + id + '/' + resourceId).then(function (response) {
				callback(response.data);
			})
		};

		//POST
		service.postMaterialTxn = function (payload, callback) {
			$http.post('api/rollout/log-mtrl-tx', payload).then(function (response) {
				callback(response.data);
			})
		};

		service.v1postBulkMaterialTxn = function (payload, callback) {
			$http.post('api/rollout/v1/bulk-log-mtrl-tx', payload).then(function (response) {
				callback(response.data);
			})
		};
		service.postBulkMaterialTxn = function (payload, callback) {
			$http.post('api/rollout/bulk-log-mtrl-tx', payload).then(function (response) {
				callback(response.data);
			})
		};

		service.postResourceTxn = function (payload, callback) {
			$http.post('api/rollout/log-res-tx', payload).then(function (response) {
				callback(response.data);
			})
		};

		service.postBulkResourceTxn = function (payload, callback) {
			$http.post('api/rollout/bulk-log-res-tx', payload).then(function (response) {
				callback(response.data);
			})
		};

		//PUT

		service.putMaterialTxn = function (payload, callback) {
			$http.put('api/rollout/log-mtrl-tx', payload).then(function (response) {
				callback(response.data);
			})
		};

		service.putResourceTxn = function (payload, callback) {
			$http.put('api/rollout/log-res-tx', payload).then(function (response) {
				callback(response.data);
			})
		};

		//GET Task by Section Id
		service.taskBySection = function (id, callback) {
			$http.get('api/tr-tasks-by-section-list/' + id).then(function (response) {
				callback(response.data);
			})
		};
		service.taskPathByID = function (id, callback) {
			$http.get('api/tr-tasks-path/' + id).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('Summary', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};

		//GET
		service.resTx = function (id, callback) {
			$http.get('api/rollout/res-tx-summary/' + id).then(function (response) {
				callback(response.data);
			})
		};

		service.mtrlTx = function (id, callback) {
			$http.get('api/rollout/mtrl-tx-summary/' + id).then(function (response) {
				callback(response.data);
			})
		};

		service.dailyLogsTx = function (id, callback) {
			$http.get('api/rollout/daily-task-logs-summary/' + id).then(function (response) {
				callback(response.data);
			})
		};


		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TaskSectionById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-sections-path/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.postAutoGenerateTasks = function (payload, callback) {
			$http.post('api/tr-sections/auto-generate-tasks', payload).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrSectionController", TrSectionController);

    TrSectionController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$compile",
        "TrSection",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "Inventory",
        "TrSectionSearch"
    ];

    function TrSectionController(
        $scope,
        $rootScope,
        $state,
        $compile,
        TrSection,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        Inventory,
        TrSectionSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        $scope.tab = 1;
        vm.expandResponse = []

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var searchVal = $scope.search.replace(/[^\w\s]/g, '_');
                TrSectionSearch.query(
                    {
                        search: searchVal,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.sections = [];
                    data.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.sections.push(value);
                    });
                    vm.page = pagingParams.page;
                }
    
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            TrSection.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.sections = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.sections.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ){
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal,
            });
        }


        vm.expand = function (section, str) {
            vm.sections.forEach(function (item) {
                item.material = false;
                item.tasks = false;
                item.resource = false;
            });

            if (vm.toggle == str) {
                vm.toggle = undefined;
                
            } else {
                switch (str) {
                    case "material":
                        vm.expandResponse = null
                        vm.headers = null
                        Inventory.materialTxn(section.id, function (response) {
                            vm.headers = [
                                { key: "materialName", display: "Material Name" },
                                { key: "unitOfMeasurement", display: "Units of Measurement" },
                                { key: "noOfUnits", display: "Quantity" },
                                { key: "transactionType", display: "Transaction Type" },
                                { key: "transactionDate", display: "Transaction Date" },
                            ]
                            vm.expandResponse = response
                        })
                        section.material = true;
                        vm.toggle = str;
                        break;

                    case "resource":
                        vm.expandResponse = null
                        vm.headers = null
                        Inventory.resourceTxn(section.id, function (response) {
                            vm.headers = [
                                { key: "resourceName", display: "Resource Name" },
                                { key: "noOfResources", display: "No of Resource" },
                                { key: "numberOfHours", display: "No of Work Hours" },
                                { key: "transactionType", display: "Transaction Type" },
                                { key: "transactionDate", display: "Transaction Date" },
                            ]
                            vm.expandResponse = response
                        })
                        section.resource = true;
                        vm.toggle = str;
                        break;

                    case "tasks":
                        vm.expandResponse = null
                        vm.headers = null
                        Inventory.taskBySection(section.id, function (response) {
                            vm.headers = [
                                { key: "name", display: "Name" }
                            ]
                            vm.expandResponse = response
                        })
                        section.tasks = true;
                        vm.toggle = str;
                        break;

                    default: console.log("default")
                }
            }

        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ResourceTxnDialogController", ResourceTxnDialogController);

    ResourceTxnDialogController.$inject = ['$state','Inventory','TrResource','$scope','ParseLinks','AlertService',
    'pagingParams','$timeout','$window','entity','entityId'];

    function ResourceTxnDialogController($state,Inventory,TrResource,
        $scope,
        ParseLinks,
        AlertService,
        pagingParams,
        $timeout,
        $window,
        entity,
        entityId
        ) {
        var vm = this;
        vm.resourceTxn = {}
        vm.transactionType = ["REQUESTED","UTILIZED"]
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        var objName = $state.params.entityName
        vm.isSaving = true
        vm.selectedResource = []

        /* var today = new Date();
        var todayFormatted = today.toISOString().split("T")[0];
        document.getElementById("dateInput").max = todayFormatted; */


       /*  if($state.params.entityId){
            vm.resourceTxn.entityId  = parseInt($state.params.entityId, 10)
        } */

        TrResource.query(
            {
                page: 0,
                size: 100,
                sort: sort(),
            },
            onSuccess,
            onError
        );

        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                //  result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers("link"));
            vm.totalItems = headers("X-Total-Count");
            vm.queryCount = vm.totalItems;
            vm.resources = data
            
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        if(entity){
            Inventory.getResourceTxn(entityId,entity,function(response){
                vm.resourceTxn = response
                if(vm.resourceTxn[0].id){
                    vm.resourceTxn[0].transactionDate = new Date(vm.resourceTxn[0].transactionDate);
                }
            })
            vm.isShow = true
            vm.isSaving = false
        }else{
            vm.resourceTxn = []
            /* if($state.params.entityId){
                vm.resourceTxn.entityId  = parseInt($state.params.entityId, 10)
            } */
           
        }

        vm.save = function(){
            //vm.resourceTxn.resourceId = parseInt(vm.resourceTxn.resource)

            /* if(vm.resourceTxn.transactionDate){
                vm.resourceTxn.transactionDate = epoch(vm.resourceTxn.transactionDate)
            } */
            
            if(vm.resourceTxn[0].id){
                vm.dateChanged(0)
                Inventory.putResourceTxn(vm.resourceTxn[0],function(){
                        $window.history.back();
                })
             }else{
                vm.resourceTxn.forEach(function (each){
                    each.transactionDate =  epoch(each.transactionDate)
                })
                Inventory.postBulkResourceTxn(vm.resourceTxn,function(){
                        $window.history.back();
                })

            }
            
        }

        var today = new Date();
        today.setHours(23, 59, 59);
        vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar; 
        vm.options = {
                maxDate: today
            };

            function openCalendar(date) {
                vm.datePickerOpenStatus[date] = true;
            }

           
            
            function epoch (date) {
                return Date.parse(date)
              }


              $scope.addDetails = function () { 
                //vm.resourceTxn.push({entityId:$state.params.entityId})
              }

              vm.dateChanged = function(index){
                if(vm.resourceTxn[index].transactionDate){
                    vm.resourceTxn[index].transactionDate = epoch(vm.resourceTxn[index].transactionDate)
                }  
              }

              $scope.removeDetails = function (id) {
                vm.resourceTxn.splice(id, 1);

                if(!vm.resourceTxn.length){
                    vm.isSaving = true
                }
            };

            $('.select2').select2();
    
             $scope.type = {
                resources: {
                    search: "Search",
                    nothingSelected: "Resources",
                    selectAll: "All",
                    selectNone: "None",
                    Done: "Done",
                }
            };
    
            vm.onSelectedResource = function (){
                if(vm.selectedResource.length && vm.selectTransactionType && vm.selectDate){
                    //vm.resourceTxn = []
                    vm.selectedResource.forEach(function (each,index){
                        var exists = vm.resourceTxn.some(function(element) { 
                            element.transactionDate = vm.selectDate
                            element.transactionType = vm.selectTransactionType
                            return (element.resourceId === each.id)
                        } ); 
    
                        var temp  = vm.resources.find(function (eachElement){
                            return eachElement.id == each.id
                        })
     
                         if (!exists) {
                            vm.resourceTxn.push({
                                "resourceId": each.id,
                                "unitOfMeasurement": temp.unitOfMeasurement,
                                "noOfUnits": null,
                                "transactionDate": vm.selectDate,
                                "transactionType": vm.selectTransactionType,
                                "invoiceNumber": null,
                                "remarks": null
                            })
    
                         vm.resourceTxn[index][objName] = $state.params.entityId
                        
                        }  
    
                     /*     vm.resourceTxn.push({
                            "resourceId": each.id,
                            "noOfResources": null,
                            "numberOfHours": null,
                            "transactionDate": vm.selectDate,
                            "transactionType": vm.selectTransactionType,
                            'sectionId' : $state.params.sectionId
                        })
    
                     vm.resourceTxn[index][objName] = parseInt($state.params.entityId) */
                        
                    })
    
                    vm.isSaving = false
                    //$scope.$apply()
                }
            }
       
    }
})();
 
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("MaterialTxnDialogController", MaterialTxnDialogController);

    MaterialTxnDialogController.$inject = ['$state','Inventory','TrMaterial','$scope','ParseLinks','AlertService',
    'pagingParams','$timeout','$window','entity','entityId'];

    function MaterialTxnDialogController($state,Inventory,TrMaterial,
        $scope,
        ParseLinks,
        AlertService,
        pagingParams,
        $timeout,
        $window,
        entity,
        entityId
    ) {
        var vm = this;
        //vm.transactionType = ["PLANNED","REQUESTED","RECEIVED","UTILIZED","RECONCILED"]
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        var objName = $state.params.entityName
        vm.isSaving = true
        vm.selectedMaterial = []
        switch (objName) {
            case "taskId": vm.transactionType = ["REQUESTED"]
                break;

            case "sectionId": vm.transactionType = ["REQUESTED"]
                break;

            default: console.log("other")
        }


        TrMaterial.query(
            {
                page: 0,
                size: 100,
                sort: sort(),
            },
            onSuccess,
            onError
        );

        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                //  result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers("link"));
            vm.totalItems = headers("X-Total-Count");
            vm.queryCount = vm.totalItems;
            vm.materials = [];
            data.forEach(function (value) {
                if (value.zone) {
                    value.type = "MASTER";
                } else {
                    value.type = "MINI";
                }
                vm.materials.push(value);
            });
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        if(entity){
            Inventory.getMaterialTxn(entityId,entity,function(response){
                vm.materialTxn = response
                if(vm.materialTxn[0].id){
                    vm.materialTxn[0].transactionDate = new Date(vm.materialTxn[0].transactionDate);
                }
            })
            vm.isShow = true
            vm.isSaving = false
        }else{
            vm.materialTxn = []
            //vm.materialTxn = [{ }]
            //vm.materialTxn[0][objName] = $state.params.entityId 
            //
        }

        /* var today = new Date();
        var todayFormatted = today.toISOString().split("T")[0];
        document.getElementById("dateInput").max = todayFormatted; */


        

      

        vm.save = function(){
            //vm.materialTxn.materialId = parseInt(vm.materialTxn.materialId)
            
           /*  if(vm.materialTxn.txnDate){
                vm.materialTxn.transactionDate = epoch(vm.materialTxn.txnDate)
            }  */
            
           if(vm.materialTxn[0].id){
            vm.dateChanged(0)
                Inventory.putMaterialTxn(vm.materialTxn[0],function(){
                    $window.history.back();
                })
            }else{
                vm.materialTxn.forEach(function (each){
                    each.transactionDate =  epoch(each.transactionDate)
                })
                Inventory.v1postBulkMaterialTxn(vm.materialTxn, function () {
                    $window.history.back();
                })
            } 
            
        }

        var today = new Date();
        today.setHours(23, 59, 59);
        vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar; 
        vm.options = {
                maxDate: today
            };

            function openCalendar(date) {
                vm.datePickerOpenStatus[date] = true;
            }

           
            
            function epoch (date) {
                return Date.parse(date)
              }
       
              $scope.addDetails = function () { 
                //vm.materialTxn.push({ objName : $state.params.entityId})
              }

              vm.dateChanged = function(index){
                if(vm.materialTxn[index].transactionDate){
                    vm.materialTxn[index].transactionDate = epoch(vm.materialTxn[index].transactionDate)
                }  
              }

              $scope.removeDetails = function (id) {
                vm.materialTxn.splice(id, 1);

                if(!vm.materialTxn.length){
                    vm.isSaving = true
                }
            };

            $('.select2').select2();

            vm.onChangeUom = function(id,index){
            
            var temp  = vm.materials.find(function (eachElement){
                return eachElement.id == id
            })

            vm.materialTxn[index].unitOfMeasurement = temp.unitOfMeasurement
         }

         $scope.type = {
            materials: {
                search: "Search",
                nothingSelected: "Materials",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            }
        };

        vm.onSelectedMaterial = function (){
            if(vm.selectedMaterial.length && vm.selectTransactionType && vm.selectDate){
                //vm.materialTxn = []
                vm.selectedMaterial.forEach(function (each,index){
                   var exists = vm.materialTxn.some(function(element) { 
                        element.transactionDate = vm.selectDate
                        element.transactionType = vm.selectTransactionType
                        return (element.materialId === each.id )
                    } ); 

                    var temp  = vm.materials.find(function (eachElement){
                        return eachElement.id == each.id
                    })

                     if (!exists) {
                        vm.materialTxn.push({
                            "materialId": each.id,
                            "unitOfMeasurement": temp.unitOfMeasurement,
                            "noOfUnits": null,
                            "transactionDate": vm.selectDate,
                            "transactionType": vm.selectTransactionType,
                            "invoiceNumber": null,
                            "remarks": null,
                            'sectionId': $state.params.sectionId
                        })

                        vm.materialTxn[index][objName] = parseInt($state.params.entityId)

                    }
                })

                vm.isSaving = false
                //$scope.$apply()
            }
        }
    }
})();
 
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrRowDialogController", TrRowDialogController);

    TrRowDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrRow",
        "Configs",
        "route",
        "postRoutePoints",
        "AlertService",
        "$window",
        "TrRouteListIdName",
        "RoutePathById",
        "AllRowTypes",
        "AllCustomRowTypeAttribute",
        "$rootScope"
    ];

    function TrRowDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrRow,
        Configs,
        route,
        postRoutePoints,
        AlertService,
        $window,
        TrRouteListIdName,
        RoutePathById,
        AllRowTypes,
        AllCustomRowTypeAttribute,
        $rootScope
    ) {
        var vm = this;
        vm.trRow = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trRow);
        vm.rowType = entity.rowType;
        var markers = []
        var coordinateList = []
        var chainageList = []
        var markerList =[]
        var iconSize = 20
        var labelFrom, labelTo
        labelFrom = 'From Row'
        labelTo = 'To Row'
        vm.routeName = route
        vm.selectRoute = selectRoute;
        vm.selectAttributes = selectedRowTypeAttributes;
        vm.isSetUpdate = false;
        var coordinateList = [];
        var chainageList = [];
        var markerList = [];
        vm.rowType = entity.rowType;

        if ($state.params.routeId) {
            vm.trRow.routeId = parseInt($state.params.routeId, 10);
        }

        if(!vm.trRow.id){
            //vm.trRow.status = "NEW"
            vm.trRow.phase = "PLANNING"
        }
        vm.customAttributesMap = {};
        vm.customAttributesMapp = [];
        loadPage();
        var locations = {};
        var locationsEnd = {};


        function loadPage() {

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
                );
                imgWindow.document.close();
            };
            TrRouteListIdName.get(function (response) {
                vm.routes = response;
            });


            var rowTypeAttributeValuesList =
                vm.trRow.rowTypeAttributeValues;

            try {
                for (var index in vm.trRow.rowType.rowTypeAttribute) {
                    if (
                        !checkIfRowTypeExists(
                            vm.trRow.rowType.rowTypeAttribute[index],
                            vm.trRow.rowTypeAttributeValues
                        )
                    ) {
                        var rowTypeAttribute1 =
                            vm.trRow.rowType.rowTypeAttribute[index];
                        rowTypeAttributeValuesList.push({
                            rowTypeAttribute: rowTypeAttribute1,
                            attributeValue:
                                vm.trRow.rowType.rowTypeAttribute[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) { }

            function checkIfRowTypeExists(rowType, rowTypeAttrVal) {
                var hasRowType = false;
                for (var i = 0; i < rowTypeAttrVal.length; i++) {
                    var name = rowTypeAttrVal[i].rowTypeAttribute.name;
                    if (name == rowType.name) {
                        hasRowType = true;
                        break;
                    }
                }
                return hasRowType;
            }
            AllRowTypes.getAll(function (response) {
                vm.rowTypes = response;
            });

            AllCustomRowTypeAttribute.getAll(function (response) {
                //vm.customRowTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if (arrayItem.customRowTypeAttributeValues != undefined) {
                        vm.customAttributesMap[arrayItem.name] =
                            arrayItem.customRowTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }

                });
                if (vm.trRow.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });

        }
        // $timeout(function () {
        //     angular.element(".form-group:eq(1)>input").focus();
        // });

        function selectedRowTypeAttributes() {
            vm.showFilter = true;
            if (vm.rowType) {
                vm.trRow.rowType = vm.rowType;
                if (
                    entity_old.rowType &&
                    vm.rowType.id === entity_old.rowType.id
                ) {
                    vm.trRow.rowTypeAttributeValues = [];
                    vm.trRow.rowTypeAttributeValues =
                        entity_old.rowTypeAttributeValues;
                } else {
                    vm.trRow.rowTypeAttributeValues = [];
                    $.each(
                        vm.rowType.rowTypeAttribute,
                        function (key, value) {
                            vm.trRow.rowTypeAttributeValues.push({
                                rowTypeAttribute:
                                    vm.rowType.rowTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        } 

        function selectRoute() {
            markers.forEach(function(marker){
                marker.setMap(null);
            });
            coordinateList = [];
            chainageList = [];
            markerList = [];
            locations.map
            initMap();
            RoutePathById.get(vm.trRow.routeId, function (response) {
                var groupedSessions = {};
                if (response.COORDINATE) {
                    response.COORDINATE.forEach(function (value) {
                     if(value.sessionNumber!=null){
                         if (!groupedSessions[value.sessionNumber]) {
                            groupedSessions[value.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                        }
                        groupedSessions[value.sessionNumber].coordinates.push({ lat: value.latitude, lng: value.longitude , routePointNumber: value.routePointNumber });
                     }   
                    });
                }
                
                if(response.CHAINAGE){
                    response.CHAINAGE.forEach(function (value) {
                        if (!groupedSessions[value.sessionNumber]) {
                            groupedSessions[value.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                        }
                        groupedSessions[value.sessionNumber].chainages.push({ lat: value.latitude, lng: value.longitude , routePointNumber: value.routePointNumber });
                    });
                }
                
                if(response.MARKER){
                    response.MARKER.forEach(function (value) {
                        if (!groupedSessions[value.sessionNumber]) {
                            groupedSessions[value.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                        }
                        groupedSessions[value.sessionNumber].markers.push({ lat: value.latitude, lng: value.longitude , routePointNumber: value.routePointNumber });
                    });
                }
                Object.keys(groupedSessions).forEach(function (sessionNumber) {
                    var sessionData = groupedSessions[sessionNumber];
                    sessionData.coordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                    if (sessionData.coordinates.length) {
                        var polyline = new google.maps.Polyline({
                            path: sessionData.coordinates,
                            geodesic: true,
                            strokeColor: '#FD7A24',
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                        });
                        polyline.setMap(locations.map);
                        addClick(polyline);
                        var bounds = new google.maps.LatLngBounds();
                        sessionData.coordinates.forEach(function (coord) {
                            bounds.extend(coord);
                        });
                        locations.map.fitBounds(bounds);
                    }
                    if (sessionData.chainages.length) {
                        createMarkers(sessionData.chainages, 'content/images/chainagePoints.png', locations.map);
                    }
                    if (sessionData.markers.length) {
                        createMarkers(sessionData.markers, 'content/images/markersPoint.png', locations.map);
                    }
                });
            });
        }

        function addClick(item) {
            // Add a click event listener to the map
            item.addListener("click", function (event) {
                if (markers.length < 2) {
                    // Add a marker to the map
                    addMarker(event.latLng);

                    // Get the latitude and longitude of the clicked point
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }

        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                addClick(marker)
                arr.push(marker);
            })
        }

        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = labelFrom
            } else if (markers.length == 1) {
                markerText = labelTo
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: markerText,
                }
            });

            // Add the marker to the markers array
            markers.push(marker);
        }

        function save() {
            if (markers.length == 2) {
                var payload
                markers.forEach(function (item) {
                    if (item.label.text == labelFrom || item.label.text == labelTo) {
                        if (item.label.text == labelFrom) {
                            vm.trRow.fromRoutePoint = {};
                            vm.trRow.fromRoutePoint.latitude = item.position.lat();
                            vm.trRow.fromRoutePoint.longitude = item.position.lng();
                        }
                        if (item.label.text == labelTo) {
                            vm.trRow.toRoutePoint = {};
                            vm.trRow.toRoutePoint.latitude = item.position.lat();
                            vm.trRow.toRoutePoint.longitude = item.position.lng();
                            if(vm.trRow.id != null){
                                TrRow.update(vm.trRow, onSaveSuccess, onSaveError);
                            } else {
                                TrRow.save(vm.trRow, onSaveSuccess, onSaveError);
                            }
                            
                        }
                    }
                })
            } else {
                alert("Row From or To Points are Empty")
            }

        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:rowUpdate", result);
            //vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "user-management.new") {
                $state.go("user-management.new");
            } else {
                $window.history.back();
            }
        }

        function onSaveError() {
            //vm.isSaving = false;
        }

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = response;
            //vm.workFlow.phase = "Planning Phase"
            /*  if(vm.workFlow.id == null){
                response.forEach(function(val){
                    if(val.configValue == '01'){
                        vm.workFlow.phase = val.configKey
                    }
                })
            }*/
        });

        //start
        initMap();
        function initMap(){
            locations.map = new google.maps.Map(
                document.getElementById("map_canvasStart"),
                {
                    center: {
                        lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                        lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                    },
                    zoom: 13,
                    fullscreenControl: true,
                    styles: mapStyles(),
                }
            );
			
			geoLocation(locations.map);
        }
        
        if(vm.trRow.id == null) {
            selectRoute();
        }else if(vm.trRow.id != null) {
            selectRoute();
        }
        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );
			
			var goTo = document.createElement("span");
						            goTo.setAttribute("title", "Location Coordinates");
						            goTo.classList.add("custom-map-control-button");
						            var gotoIcon = document.createElement("i");
						            gotoIcon.classList.add("fa");
						            gotoIcon.classList.add("fa-location-arrow");
						            gotoIcon.classList.add("geo");
						            gotoIcon.classList.add("mt-5");
						            goTo.appendChild(gotoIcon);
						            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);
						            goTo.addEventListener("click", function () {
						                vm.removeMarker()
						                $("#modalLatLongs").show();
						     });

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        vm.removeMarker = function () {
            markers.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the markers array
            markers = [];

            if (vm.trRow.id) {
                vm.isSetUpdate = true
            }

        }

        // if (route && route.routePoints != null && route.routePoints.length) {
        //     route.routePoints.sort(function(a, b) { return a.routePointNumber - b.routePointNumber});

        //     route.routePoints.forEach(function (each) {
        //         if (each.routePointType == "COORDINATE") {
        //             coordinateList.push({ lat: each.latitude, lng: each.longitude })
        //         } else if (each.routePointType == "MARKER") {
        //             markerList.push({ lat: each.latitude, lng: each.longitude })
        //         } else if (each.routePointType == "CHAINAGE") {
        //             chainageList.push({ lat: each.latitude, lng: each.longitude })
        //         }
        //     })

        //     if (coordinateList.length) {
        //         locations.map.setCenter(coordinateList[0]);
        //         var polyline = new google.maps.Polyline({
        //             path: coordinateList,
        //             geodesic: true,
        //             strokeColor: '#FD7A24',
        //             strokeOpacity: 1.0,
        //             strokeWeight: 4,
        //         });

        //         // Set the map to display the polyline
        //         polyline.setMap(locations.map);
        //         addClick(polyline)
        //     }

        //     if (markerList.length) {
        //         locations.map.setCenter(markerList[0]);
        //         createMarkers(markerList, 'content/images/markersPoint.png', locations.map)
        //     }

        //     if (chainageList.length) {
        //         locations.map.setCenter(chainageList[0]);
        //         createMarkers(chainageList, 'content/images/chainagePoints.png', locations.map)
        //     }
        // }


        //Functions

        function addClick(item) {
            // Add a click event listener to the map
            item.addListener("click", function (event) {
                if (markers.length < 2) {
                    // Add a marker to the map
                    addMarker(event.latLng);

                    // Get the latitude and longitude of the clicked point
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }


        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                addClick(marker)
                arr.push(marker);
            })
        }

		vm.onLocationCoordinates = function() {
				             var latlngA = vm.getLocationCoordinateA.split(",");
				             var latlngB = vm.getLocationCoordinateB.split(",");

				             addMarker({lat: parseFloat(latlngA[0]),lng: parseFloat(latlngA[1])})
				             addMarker({lat: parseFloat(latlngB[0]),lng: parseFloat(latlngB[1])})

				             locations.map.setCenter({lat: parseFloat(latlngB[0]),lng: parseFloat(latlngB[1])})
				             vm.closeModal('modalLatLongs')
				         }
						 
						 vm.closeModal = function(id) {
						 		          vm.getLocationCoordinateA = null
						 		          vm.getLocationCoordinateB = null

						 		          $("#" + id).removeClass("in");
						 		          $(".modal-backdrop").remove();
						 		          $("#" + id).hide();
						 		      }
        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = labelFrom
            } else if (markers.length == 1) {
                markerText = labelTo
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: "content/images/sections.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        -4
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
                label: {
                    text: markerText,
                }
            });

            // Add the marker to the markers array
            markers.push(marker);
        }


        if (vm.trRow.id && vm.trRow.fromRoutePoint && vm.trRow.toRoutePoint) {
            addMarker({ lat: vm.trRow.fromRoutePoint.latitude, lng: vm.trRow.fromRoutePoint.longitude })
            addMarker({ lat: vm.trRow.toRoutePoint.latitude, lng: vm.trRow.toRoutePoint.longitude })
            locations.map.setCenter({ lat: vm.trRow.fromRoutePoint.latitude, lng: vm.trRow.fromRoutePoint.longitude });
        }

        $('.select2').select2();
    }
})();


(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrRowDetailController', TrRowDetailController);

    TrRowDetailController.$inject = ['$scope', '$rootScope', 'entity', '$window', '$localStorage'];

    function TrRowDetailController($scope, $rootScope, entity, $window, $localStorage) {
        var vm = this;

        vm.trRow = entity;
        var unsubscribe = $rootScope.$on('trakeyeApp:trRowUpdate', function (event, result) {
            vm.trRow = result;
        });

        $scope.$on('$destroy', unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-row', {
                parent: 'app',
                url: '/tr-row',
                data: {
                    authorities: ['SECTION_SIDEBAR'],
                    pageTitle: 'trakeyeApp.row.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-row/tr-rows.html',
                        controller: 'TrRowController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    projectId: null,
                    routeId : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            projectId: $stateParams.projectId,
                            routeId :  $stateParams.routeId,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trRow');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-row-detail', {
                parent: 'tr-row',
                url: '/tr-row/{id}',
                data: {
                    authorities: ['SECTION_DETAIL'],
                    pageTitle: 'trakeyeApp.row.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-row/tr-row-detail.html',
                        controller: 'TrRowDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trRow');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrRow', function ($stateParams, TrRow) {
                        return TrRow.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-row',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('tr-row.new', {
                parent: 'tr-row',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}/{routeId}/{sectionId}',
                data: {
                    authorities: ['SECTION_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-row/tr-row-dialog.html',
                        controller: 'TrRowDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            rowImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

        .state('tr-row.import', {
                parent: 'tr-row',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-row/tr-row-import.html',
                        controller: 'TrRowImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            rowImages: []
                        };
                    }
                }

            })
            .state('tr-row.edit', {
                parent: 'tr-row',
                url: '/Edit/{id}/{routeId}/{sectionId}',
                data: {
                    authorities: ['SECTION_EDIT'],
                    pageTitle: 'trakeyeApp.row.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-row/tr-row-dialog.html',
                        controller: 'TrRowDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrRow', function ($stateParams, TrRow) {
                        return TrRow.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-row',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }],

                    section : ['$stateParams', 'TrSection', function ($stateParams, TrSection) {

                        if($stateParams.sectionId){
                            return TrSection.get({ id: $stateParams.sectionId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })
    }
})();
(function () {
    "use strict";
    angular.module("trakeyeApp").factory("TrRow", TrRow);

    TrRow.$inject = ["$resource", "DateUtils"];

    function TrRow($resource, DateUtils) {
        var resourceUrl = "api/tr-rows/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrRowById", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.get = function (id, callback) {
                $http.get("api/tr-rows/" + id).then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrRowSearch", TrRowSearch);

    TrRowSearch.$inject = ["$resource"];

    function TrRowSearch($resource) {
        var service = $resource(
            "/api/tr-rows/searchvalue/:search",
            {},
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllRowTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/row-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrRowController", TrRowController);

    TrRowController.$inject = [
        "$scope",
        "$state",
        "TrRow",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "TrRowSearch"
    ];

    function TrRowController(
        $scope,
        $state,
        TrRow,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        TrRowSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        vm.createRow = createRow;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var searchVal = $scope.search.replace(/[^\w\s]/g, '_');
                TrRowSearch.query(
                    {
                        search: searchVal,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.rows = data;
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function createRow() {
            $state.go("tr-row.new");
        }

        function loadAll() {
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }
            TrRow.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.rows = data;
                    vm.page = pagingParams.page;
                },
                onError
            );
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                //  result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ){
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrRoutePlanDialogController", TrRoutePlanDialogController);

    TrRoutePlanDialogController.$inject = [
        "$scope",
        "$state",
        "$rootScope",
        "entity",
        "AlertService",
        "pagingParams",
        "TrProject",
        "TrRouteBundle",
        "AllWorkFlowTypes",
        "AllCustomWorkFlowTypeAttribute",
        "AllCustomAssetTypeAttribute",
        "UserGroupIDs",
        "ActivatedUserSearch",
        "AllAssetsTypes",
        "Configs",
        "UserAccount",
        "FixedAssetExcelUpload",
        "SpreadAssetExcelUpload",
        "getConnectedNodes",
        "KmlToCoordinates",
        "$timeout",
        "assetsByRouteBundleId",
        "assetsLinking",
        "AssetDeleteByID",
        "Asset",
        "MappedAssets",
        "createSection",
        "RouteBundleByID",
        "TrRoute",
        "TrSection",
        "AssetByID",
        "routeDetail",
        "TrSectionById",
        "imageRoutePoint",
        "AssetUpload"
    ];

    function TrRoutePlanDialogController(
        $scope,
        $state,
        $rootScope,
        entity,
        AlertService,
        pagingParams,
        TrProject,
        TrRouteBundle,
        AllWorkFlowTypes,
        AllCustomWorkFlowTypeAttribute,
        AllCustomAssetTypeAttribute,
        UserGroupIDs,
        ActivatedUserSearch,
        AllAssetsTypes,
        Configs,
        UserAccount,
        FixedAssetExcelUpload,
        SpreadAssetExcelUpload,
        getConnectedNodes,
        KmlToCoordinates,
        $timeout,
        assetsByRouteBundleId,
        assetsLinking,
        AssetDeleteByID,
        Asset,
        MappedAssets,
        createSection,
        RouteBundleByID,
        TrRoute,
        TrSection,
        AssetByID,
        routeDetail,
        TrSectionById,
        imageRoutePoint,
        AssetUpload
    ) {
        var vm = this;
        var storeAssets = [];
        vm.mappedAssetsList = [];
        vm.importedSpread = [];
        vm.trRoute = [];
        vm.trRoute = entity;
        var entity_old = angular.copy(vm.trRoute);
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        initPage();
        vm.filterActivatedUser = filterActivatedUser;
        vm.saveEditAsset = saveEditAsset;
        vm.selectedGroup = selectedGroup;
        var openedInfoWindow = null;
        vm.connectSelectedAssets = connectSelectedAssets;
        vm.saveLinkPits = saveLinkPits;
        vm.connectMultipleAssets = connectMultipleAssets;
        vm.hideConnectMultipleAssetsModal = hideConnectMultipleAssetsModal;
        vm.refreshPage = refreshPage;
        vm.connectAssets = connectAssets;
        vm.recalculate = recalculate;
        vm.isSiteASelected = false;
        vm.isSiteBSelected = false;
        vm.selectedSiteA = {};
        vm.selectedSiteB = {};
        vm.linkAssetType = null;
        vm.manholeAssetType = null;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.showZoomLocation = showZoomLocation;
        vm.labelSaveNext = "Next";
        var tempSize = 11;
        vm.blockFilter = [];
        var blockPolyLine, blockMarker;
        var polylines = [];
        vm.editAsset = editAsset;
        vm.multigroup = [];
        vm.assetType = [];
        vm.mappedAssetsListImport = [];
        var storeRingOptions = [];
        var callAssets = false;
        var tempRingAssetStore = [];
        vm.deleteAssetModal = deleteAssetModal;
        vm.addExistAssetModal = addExistAssetModal;
        vm.closeAssetExistRing = closeAssetExistRing;
        vm.closeRingNameAlreadyExist = closeRingNameAlreadyExist;
        vm.closeUpdateRingNameModel = closeUpdateRingNameModel;
        vm.closeRingModal = closeRingModal;
        vm.confirmDeleteAsset = confirmDeleteAsset;
        vm.cleardeleteAsset = cleardeleteAsset;
        vm.clearCreateAsset = clearCreateAsset;
        var deleteAssetName = null;
        vm.createAssetModal = createAssetModal;
        vm.createAsset = createAsset;
        vm.assetNameVal = null;
        vm.getLocationCoordinate = null;
        var createAssetData = {};
        var tempCount = 0;
        var tempCountCycle = 0;
        vm.progressIsEnabled = true;
        vm.optimalTotalLength = 0;
        vm.routePlanningTotalLength = 0;
        vm.minCostTotalLength = 0;
        vm.isShowTotalLengthImport = false;
        vm.closeAssetAttributesModal = closeAssetAttributesModal;
        vm.closeEditAssetAttributeModal = closeEditAssetAttributeModal;
        vm.editAssetOnMapView = editAssetOnMapView;
        vm.closeEditAssetModal = closeEditAssetModal;
        vm.showAssetImage = false;
        var noDataText = null;
        vm.closeThreePointReference = closeThreePointReference;
        vm.saveEditAssetModal = saveEditAssetModal;
        vm.customAttributesMap = {};
        var usersMap = {};
        var mappedAssetTemp = {};
        vm.mappedAssetsList = [];
        vm.tempLinkWithPits = [];
        vm.deletedAssetsList = [];
        var selectedGroup = [];
        var assetsDeployedMap = null;
        vm.isShowing = true;
        vm.save = save;
        vm.handleTabClick = handleTabClick;
        vm.assetExisting = false;
        $scope.search = null;
        vm.assets = [];
        vm.showAssetName = false;
        var centerlatlng = null;
        vm.hideUser = true;
        var marker = null;
        var editAssetMap = null;
        vm.validUser = true;
        vm.assignedUsers = [];
        vm.validUser = true;
        vm.hideConnectSitesModal = hideConnectSitesModal;
        vm.previousId = sessionStorage.getItem("prevEditId");
        if (vm.previousId) {
            vm.validUser = false;
        }
        $scope.tab = 1;
        vm.siteAssets = [];
        vm.phaseAccess = true;
        vm.updateProgress = 0;
        vm.connectedLength = 0;
        vm.commonPathLength = 0;
        var storeAssets = [];
        var tempPayloadSection = [];
        var newSizeLevel;
        var CHAINAGE_ID = 1;
        var MARKER_ID = 2;
        var COORDINATE_ID = 3;
        vm.storeFixedResponse = [];
        vm.storeSpreadResponse = [];
        var infowindow = new google.maps.InfoWindow();
        var polylineTimer, spreadPoly, existingHighlightFixed;
        var labelFrom, labelTo;
        labelFrom = "A";
        labelTo = "B";
        var markersConnect = [];
        var tempObject = {};
        var tempRingAssetStoreInGraph = [];
        var storeMarkers = [];
        var commonPathMarkers = [];
        var ringId = 0;
        var tempGeofenceId,
            coordinatesSpread,
            markersPoints,
            tempPointNumber,
            chainagePoints;
        tempPointNumber = 0;
        var locations = {};
        var coordinateList = [];
        var markerList = [];
        var chainageList = [];
        var assetPoints = [];
        var iconSize = 20;
        var disVal = 0;
        var mappedAssetTemp = {};
        var cyclePolylines = [];
        var minCostPolylines = [];
        var anomalyPolylines = [];
        var moreThan10KmPolylines = [];
        vm.ringSize = [];
        vm.tempStoreNodes = [];
        vm.SpreadDataDuplicateCheck = [];
        vm.storeSpreadresponse = [];
        vm.routeFixedAssets = [];
        vm.totalLength = 0;
        vm.assetsLoaded = true;
        for (var i = 2; i <= 15; i++) {
            vm.ringSize.push({ name: i });
        }
        vm.displayRingDetails = "false";
        vm.popupMenuShow = true;
        vm.importkmlexisting = "false";
        vm.selectedAssetsToHighlightMultiRing = [];
        var markers = []
        var editPathMarkers = [];
        $scope.type = {
            block: {
                search: "Search",
                nothingSelected: "Block Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            },
        };

        vm.selectedAssetId = null;

        // Method to select an asset and highlight the row
        vm.selectAsset = function (asset) {
            if (vm.selectedAssetId === asset.id) {
                // If clicking the same row, unselect it (toggle)
                vm.selectedAssetId = null;
            } else {
                // Set the selected asset id
                vm.selectedAssetId = asset.id;
            }
        };
        if (!vm.trRoute.id) {
            vm.trRoute.routePoints = [];
            vm.isSaving = true;

            vm.trRoute.status = "NEW";
        }

        function steps() {
            var back = jQuery(".prev");
            var next = jQuery(".next");
            var steps = jQuery(".step");

            if (vm.trRoute.id) {
                steps.splice(1, 1);
            }

            next.bind("click", function () {
                jQuery.each(steps, function (i) {
                    if (
                        !jQuery(steps[i]).hasClass("current") &&
                        !jQuery(steps[i]).hasClass("done")
                    ) {
                        jQuery(steps[i]).addClass("current");
                        jQuery(steps[i - 1])
                            .removeClass("current")
                            .addClass("done");
                        return false;
                    }
                });
            });
            back.bind("click", function () {
                jQuery.each(steps, function (i) {
                    if (
                        jQuery(steps[i]).hasClass("done") &&
                        jQuery(steps[i + 1]).hasClass("current")
                    ) {
                        jQuery(steps[i + 1]).removeClass("current");
                        jQuery(steps[i]).removeClass("done").addClass("current");
                        return false;
                    }
                });
            });
        }
        function initPage() {
            TrProject.query(
                {
                    page: 0,
                    size: 300,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
                if (vm.predicate !== "id") {
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.projects = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        $scope.label = {
            assetTypeLabel: {
                search: "Search",
                nothingSelected: "Select Asset Type",
            },
            ringSizeLabel: {
                search: "Search",
                nothingSelected: "Ring Topology Size",
            },
        };

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                disableDoubleClickZoom: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    },
                ],
            });
        }

        var latlngs = new google.maps.LatLng(
            $rootScope.DEFAULT_LATITUDE,
            $rootScope.DEFAULT_LONGITUDE
        );

        if ($scope.tab == 1) {


            vm.toggleFirst = true;
            vm.toggleSecond = false;
            vm.toggleThird = false;

            if (vm.trRoute.id != null) {
                vm.hideUser = false;
            }

            UserGroupIDs.getAll(function (response) {
                vm.multigroup = response;
                response.forEach(function (val) {
                    if (val.name == "Planning Group") {
                        val.ticked = true;
                    }
                });
            });

            UserAccount.get(function (data) {
                vm.userId = data.id;
                data.authorities.find(function (val) {
                    if (val == "ROLE_PLAN_ADMIN" || val == "ROLE_ROLLOUT_ADMIN") {
                        vm.phaseAccess = false;
                    }
                });
            });

            AllAssetsTypes.getAll(function (response) {
                vm.storeAssetTypes = response.length ? response : null;

                vm.types = [];
                vm.types.push({ id: CHAINAGE_ID, name: "CHAINAGE" });
                vm.types.push({ id: MARKER_ID, name: "MARKER" });
                vm.types.push({ id: COORDINATE_ID, name: "COORDINATE" });

                vm.tempAssetDetail = null;
                vm.assetTypeResponse = [];

                response.filter(function (eachElement) {
                    if (eachElement.layout == "SPREAD") {
                        vm.assetTypeResponse.push(eachElement);
                    }

                    if (eachElement.name == "Planned Route") {
                        vm.tempAssetDetail = eachElement;
                    }
                });
                response.forEach(function (assettype) {
                    if (assettype.layout == "FIXED") {
                        assettype.icon =
                            '<img  src="' +
                            assettype.imagePath +
                            '"style="width: 24px; height: 24px;">';
                    } else {
                        assettype.icon = "";
                    }
                    vm.assetType.push(assettype);
                });
            });

        }

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            $scope.search = "";

            if ($scope.tab == 1) {
                vm.toggleFirst = true;
                vm.toggleSecond = false;
                vm.toggleThird = false;

            } else if ($scope.tab == 2) {
                $scope.tabTable = 10;
                callAssetLink();
                vm.routePayload = {
                    status: "NEW",
                    routeBundleId: vm.trRoute.id,
                    routeBundleName: vm.trRoute.name,
                    phase: "PLANNING",
                    name: null,
                    assets: [],
                    projectId: vm.trRoute.projectId,
                };
				vm.getRouteSections();
                $scope.isShowMinCost = false;
                $scope.isShowMinCostText = "Show";

                $scope.isAnomaly = false;
                $scope.isAnomalyText = "Show";

                vm.ringSize.forEach(function (item) {
                    item.ticked = false;
                });

                vm.toggleFirst = false;
                vm.toggleSecond = true;
                vm.toggleThird = false;
                initPlanningMap();

                drawExistingkmlImports(locations.map);

                if (coordinatesSpread) {
                    locations.map.setCenter(coordinatesSpread[0]);

                    var polyline = new google.maps.Polyline({
                        path: coordinatesSpread,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });

                    // Set the map to display the polyline
                    polyline.setMap(locations.map);
                }

                if (chainagePoints) {
                    locations.map.setCenter(chainagePoints[0]);
                    chainagePoints.forEach(function (each) {
                        var marker = new google.maps.Marker({
                            position: { lat: each.lat, lng: each.lng },
                            map: locations.map,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/chainagePoints.png",
                                anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });
                    });
                }

                vm.minCostTotalLength = 0;
                vm.routePlanningTotalLength = 0;
                vm.connectedLength = 0;

                vm.mappedAssetsList = [];
                callAssetsRouteByID(vm.trRoute.id, null);
                if (vm.storeRingPolylines.length) {
                    for (var i = 0; i < vm.storeRingPolylines.length; i++) {
                        vm.storeRingPolylines[i].polyline.setMap(null);
                    }
                }
                if (storeRingOptions.length) {
                    if (storeRingOptions.length) {
                        storeRingOptions.forEach(function (item) {
                            vm.mappedAssetsList.unshift(item);
                            vm.onChangeTopology(item);
                        });
                    }
                }

                vm.newOFCLength = 0;
                vm.ExistingUsed = 0;
                vm.ExistingUnused = 0;
                routeDetail.getNewAssetLengthByRouteBundleId(vm.trRoute.id, function (response) {
                    if (response !== null) {
                        vm.newOFCLength = response;
                    }

                });

                routeDetail.getexistingUnusedLengthByRouteBundleId(vm.trRoute.id, function (response) {
                    if (response !== null) {
                        vm.ExistingUnused = response;
                    }
                });

                routeDetail.getexistingUsedLengthByRouteBundleId(vm.trRoute.id, function (response) {
                    if (response !== null) {
                        vm.ExistingUsed = response;
                    }
                });


            } else if ($scope.tab == 3) {
                if (vm.storeRingPolylines.length) {
                    for (var i = 0; i < vm.storeRingPolylines.length; i++) {
                        vm.storeRingPolylines[i].polyline.setMap(null);
                    }
                }
                $scope.isShowMinCost = false;
                $scope.isShowMinCostText = "Show";
                $scope.isAnomaly = false;
                $scope.isAnomalyText = "Show";

                vm.toggleFirst = false;
                vm.toggleSecond = false;
                vm.toggleThird = true;
                var totalCost = 0;
                var totalPowerBudget = 0;
                var totalFiberDistance = 0.0;
                vm.mappedAssetsList.forEach(function (asset) {
                    if (asset.id == null) {
                        //asset.routeId = vm.trRoute.id;
                        asset.routeBundleId = vm.trRoute.id;
                        Asset.save(asset, onSaveSuccess, onSaveError);
                    }
                });

                assetsDeployedMap = new google.maps.Map(
                    document.getElementById("map_canvas_deployed"),
                    myOption(11, latlngs)

                );

                drawExistingkmlImports(assetsDeployedMap);

                if (coordinatesSpread) {
                    assetsDeployedMap.setCenter(coordinatesSpread[0]);

                    var polyline = new google.maps.Polyline({
                        path: coordinatesSpread,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });

                    // Set the map to display the polyline
                    polyline.setMap(assetsDeployedMap);
                }

                if (chainagePoints) {
                    assetsDeployedMap.setCenter(chainagePoints[0]);
                    chainagePoints.forEach(function (each) {
                        var marker = new google.maps.Marker({
                            position: { lat: each.lat, lng: each.lng },
                            map: assetsDeployedMap,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/chainagePoints.png",
                                anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });
                    });
                }

                vm.mappedAssetsList = vm.mappedAssetsList.filter(function (item) {
                    return item.id != "True";
                });
                iterateMappedAssetsList(assetsDeployedMap, vm.mappedAssetsList);

                if (vm.mappedAssetsList.length > 0) {
                    vm.trRoute.pinLat =
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude;
                    vm.trRoute.pinLong =
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude;
                    vm.trRoute.address = "";
                    if (vm.trRoute.id == null) {
                        vm.trRoute.status = "NEW";
                    }
                }
                if (vm.mappedAssetsList.length > 0) {
                    assetsDeployedMap.setCenter(
                        new google.maps.LatLng(
                            vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                            vm.mappedAssetsList[0].assetCoordinates[0].longitude
                        )
                    );
                }
            } else if ($scope.tab == 4) {
                if (vm.storeRingPolylines.length) {
                    for (var i = 0; i < vm.storeRingPolylines.length; i++) {
                        vm.storeRingPolylines[i].polyline.setMap(null);
                    }
                }

                locations.importMap = new google.maps.Map(
                    document.getElementById("map_import_planning"),
                    myOption(10, latlngs)
                );
                var legend = document.createElement("div");
                legend.id = "map-legend";
                legend.style.position = "absolute";
                legend.style.background = "#f3f3f3";
                legend.style.padding = "4px";
                legend.style.border = "1px solid rgb(204, 204, 204)";
                legend.style.fontFamily = "Arial, sans-serif";
                legend.style.borderRadius = "5px";
                legend.style.boxShadow = "1px 1px 1px 0px";
                legend.style.color = "black";

                // Using string concatenation instead of template literals
                legend.innerHTML =
                    '<div style="display: flex; align-items: center;">' +
                    '<div style="display: flex; align-items: center; margin-right: 15px;">' +
                    '<div style="width: 12px; height: 12px; background: #ff0025; margin-right: 5px;"></div>' +
                    '<span>NEW</span>' +
                    '</div>' +
                    '<div style="display: flex; align-items: center;">' +
                    '<div style="width: 12px; height: 12px; background: #00A36C; margin-right: 5px;"></div>' +
                    '<span>EXISTING</span>' +
                    '</div>' +
                    '</div>';

                locations.importMap.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(legend);

                if (coordinatesSpread) {
                    locations.importMap.setCenter(coordinatesSpread[0]);

                    var polyline = new google.maps.Polyline({
                        path: coordinatesSpread,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });

                    // Set the map to display the polyline
                    polyline.setMap(locations.importMap);
                }

                if (chainagePoints) {
                    locations.importMap.setCenter(chainagePoints[0]);
                    chainagePoints.forEach(function (each) {
                        var marker = new google.maps.Marker({
                            position: { lat: each.lat, lng: each.lng },
                            map: locations.importMap,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/chainagePoints.png",
                                anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });
                    });
                }

                vm.optimalTotalLength = 0;
                for (var i = 0; i < vm.mappedAssetsListImport.length; i++) {
                    if (vm.mappedAssetsListImport[i].assetType.layout == "FIXED") {
                        drawMarkers(vm.mappedAssetsListImport[i], locations.importMap, i);
                    } else if (
                        vm.mappedAssetsListImport[i].assetType.layout == "SPREAD"
                    ) {
                        if (vm.mappedAssetsListImport[i].assetCoordinates) {
                            var assetCoordinateValues = [];
                            vm.mappedAssetsListImport[i].assetCoordinates.forEach(function (
                                each
                            ) {
                                assetCoordinateValues.push({
                                    lat: each.latitude,
                                    lng: each.longitude,
                                    id: each.id,
                                });
                            });
                        }

                        var tmpColor = "#00A36C"; //var tmpColor = "red";
                        if (vm.mappedAssetsListImport[i].isCycle) {
                            tmpColor = "#FFD700";
                            // } else if (!vm.mappedAssetsListImport[i].isConnected) {
                        } else if (!vm.mappedAssetsListImport[i].isExisting) {
                            tmpColor = "#ff0025"; //tmpColor = "blue";
                        }

                        if(!vm.mappedAssetsListImport[i].isUsed && vm.mappedAssetsListImport[i].isExisting){
                            tmpColor = "#FFAE42"
                        }
                        // assetCoordinateValues.sort(function (a, b) {
                        //     return a.id - b.id; // Ascending order
                        // });
                        if (assetCoordinateValues[0].sortOrder != null) {
                            assetCoordinateValues.sort(function (a, b) {
                                return a.sortOrder - b.sortOrder; // Ascending order
                            });
                            // } else {
                            //     assetCoordinateValues.sort(function (a, b) {
                            //         return a.id - b.id; // Ascending order
                            //     });
                        }

                        if (!vm.mappedAssetsListImport[i].isCycle) {
                            drawPolyLines(
                                vm.mappedAssetsListImport[i],
                                tmpColor,
                                assetCoordinateValues,
                                locations.importMap
                            );
                        }

                    }
                }

                if (vm.mappedAssetsListImport.length > 0) {
                    var len = Math.floor(vm.mappedAssetsListImport.length / 2);
                    locations.importMap.setCenter(
                        new google.maps.LatLng(
                            vm.mappedAssetsListImport[len].assetCoordinates[0].latitude,
                            vm.mappedAssetsListImport[len].assetCoordinates[0].longitude
                        )
                    );
                }
            }
        };

        vm.processing = function () {
            vm.isDisableNext = true;
            vm.showSaveButton = false;

            vm.mappedAssetsList.forEach(function (assetVal) {
                if (assetVal.assetType.layout == "SPREAD") {
                    var fromFixedAsset = vm.mappedAssetsList.find(function (asset) {
                        return asset.name === assetVal.connectedNode1;
                    });
                    var toFixedAsset = vm.mappedAssetsList.find(function (asset) {
                        return asset.name === assetVal.connectedNode2;
                    });

                    assetVal.userId = vm.userId;
                    assetVal.ownedBy = [];

                    if (assetVal.isConnected == null) {
                        assetVal.isConnected = false;
                    }

                    assetVal.mappedAssets = [];
                    if (fromFixedAsset) {
                        assetVal.mappedAssets.push(fromFixedAsset);
                    }
                    if (toFixedAsset) {
                        assetVal.mappedAssets.push(toFixedAsset);
                    }
                    var assetCoordinatesValues = assetVal.assetCoordinates;
                    var assetCoordinatesSort = [];
                    for (var index = 0; index < assetCoordinatesValues.length; index++) {
                        var assetCoorByIndex = assetCoordinatesValues[index];
                        assetCoorByIndex.sortOrder = index;
                        assetCoordinatesSort.push(assetCoorByIndex);
                    }
                    assetVal.assetCoordinates = assetCoordinatesSort;
                    storeAssets.push(assetVal);
                }
            });
            var uniqueAssets = storeAssets.reduce(function (acc, asset) {
                var existingAsset = null;

                for (var i = 0; i < acc.length; i++) {
                    if (acc[i].name === asset.name) {
                        existingAsset = acc[i];
                        break;
                    }
                }

                if (!existingAsset || (asset["min-cost"] === true && !existingAsset["min-cost"])) {
                    acc = acc.filter(function (a) { return a.name !== asset.name; });
                    acc.push(asset);
                }

                return acc;
            }, []);
            RouteBundleByID.postBulkAssets(vm.trRoute.id, uniqueAssets, function () {

                vm.labelSaveNext = "Next";
                vm.isDisableNext = false;
                vm.updateProgress = 1;

            });
        };

        function handleTabClick($event) {
            $event.preventDefault();
            $event.stopImmediatePropagation();
        }

        function clearCreateAsset() {
            $("#create-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#create-asset").hide();
        }

        vm.isShowRefresh = true;
        function createAssetModal(item) {
            vm.isShowRefresh = false;
            vm.assetNameVal = null;
            vm.tempItem = item;
            vm.assetExisting = false;
            if (item.name == "LINK_WITH_MH") {
                connectMultipleAssets();
            } else {
                vm.CreateAssetName = item.name;
                vm.getLocationCoordinate = null;
                $("#create-asset").show();
                createAssetData = item;
                vm.showAssetName = false;
            }
        }

        function getConsolidatedAssetTypeAttributeValue(assetType) {
            var assetTypeAttributeValuesList = [];

            for (var index in assetType.assetTypeAttributes) {
                var assetTypeAttribute1 = assetType.assetTypeAttributes[index];
                assetTypeAttributeValuesList.push({
                    assetTypeAttribute: assetTypeAttribute1,
                    attributeValue: assetType.assetTypeAttributes[index].defaultValue,
                });
            }

            assetTypeAttributeValuesList.sort(function (a, b) {
                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                    nameB = b.assetTypeAttribute.name.toLowerCase();
                if (nameA < nameB)
                    // sort string ascending
                    return -1;
                if (nameA > nameB) return 1;
                return 0; // default return value (no sorting)
            });
            return assetTypeAttributeValuesList;
        }

        function createAsset() {
            var assetName = vm.assetNameVal;
            vm.assetExisting = false;
            var coOrdinate = [];
            if (marker != null) {
                marker.setMap(null);
            }

            if (assetName && assetName.length > 2) {
                if (!isAssetAvailable(assetName)) {
                    iterateMappedAssetsList(locations.map, vm.mappedAssetsList);
                    mappedAssetTemp = {};
                    mappedAssetTemp.name = assetName;
                    mappedAssetTemp.inGraph = true;
                    mappedAssetTemp.assetColor = "BLUE";
                    mappedAssetTemp.transparency = null;
                    mappedAssetTemp.lineWidth = null;
                    mappedAssetTemp.healthIndicator = null;
                    mappedAssetTemp.healthRemarks = null;
                    mappedAssetTemp.burried = null;
                    mappedAssetTemp.minCost = null;
                    mappedAssetTemp.phase = "PLANNING";
                    mappedAssetTemp.description = assetName;
                    mappedAssetTemp.assetType = createAssetData;
                    mappedAssetTemp.routeBundleId= vm.trRoute.id
                    var date = new Date();
                    mappedAssetTemp.createDate = date.getTime();
                    mappedAssetTemp.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                        createAssetData
                    );
                    mappedAssetTemp.isConnected = false;
                    mappedAssetTemp.isExisting = false;
                    mappedAssetTemp.isUsed = false;
                    if (createAssetData.layout == "SPREAD") {
                        drawingManagerSpread();
                        drawingManagerValue("polylinecomplete", locations.map, false);
                    } else if (createAssetData.layout == "FIXED") {
                        if (vm.getLocationCoordinate) {
                            vm.fixedArray = [];
                            var coordinates = {};
                            var latlng = vm.getLocationCoordinate.split(",");
                            coordinates.latitude = latlng[0];
                            coordinates.longitude = latlng[1];
                            vm.fixedArray.push(coordinates);
                            mappedAssetTemp.assetCoordinates = vm.fixedArray;
                            addMappedAssets(mappedAssetTemp);
                            vm.isShowing = false;
                            initPlanningMap();
                            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                                    drawMarkers(vm.mappedAssetsList[i], locations.map, i);
                                } else if (
                                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                                ) {
                                    if (vm.mappedAssetsList[i].assetCoordinates) {
                                        var assetCoordinateValues = [];
                                        vm.mappedAssetsList[i].assetCoordinates.forEach(function (
                                            each
                                        ) {
                                            assetCoordinateValues.push({
                                                lat: each.latitude,
                                                lng: each.longitude,
                                                id: each.id,
                                            });
                                        });
                                    }

                                    var tmpColor = "#00A36C"; //var tmpColor = "red";
                                    if (vm.mappedAssetsList[i].isCycle) {
                                        tmpColor = "#FFD700";
                                        // } else if (!vm.mappedAssetsList[i].isConnected) {
                                    } else if (!vm.mappedAssetsList[i].isExisting) {
                                        tmpColor = "#ff0025"; //tmpColor = "blue";
                                    }

                                    if(!vm.mappedAssetsList[i].isUsed && vm.mappedAssetsList[i].isExisting){
                                        tmpColor = "#FFAE42";
                                    }
                                    // assetCoordinateValues.sort(function (a, b) {
                                    //     return a.id - b.id; // Ascending order
                                    // });
                                    if (assetCoordinateValues[0].sortOrder != null) {
                                        assetCoordinateValues.sort(function (a, b) {
                                            return a.sortOrder - b.sortOrder; // Ascending order
                                        });
                                        // } else {
                                        //     assetCoordinateValues.sort(function (a, b) {
                                        //         return a.id - b.id; // Ascending order
                                        //     });
                                    }

                                    drawPolyLines(
                                        vm.mappedAssetsList[i],
                                        tmpColor,
                                        assetCoordinateValues,
                                        locations.map
                                    );


                                }
                            }
                            var centerlatlng = {
                                lat: parseFloat(latlng[0]),
                                lng: parseFloat(latlng[1]),
                            };
                            locations.map.setCenter(centerlatlng);
                        } else {
                            drawingManagerFixed();
                            drawingManagerValue("click", locations.map);
                        }
                    }
                } else {
                    initPlanningMap();
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                            createMarkerForSelectedAsset(
                                vm.mappedAssetsList[i],
                                locations.map
                            );
                        } else if (vm.mappedAssetsList[i].assetType.layout == "SPREAD") {
                            var assetCoordinateValues =
                                vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(
                                vm.mappedAssetsList[i],
                                assetCoordinateValues,
                                locations.map,
                                "yellow"
                            );
                        }
                    }
                }

                drawExistingkmlImports(locations.map);

                if (storeRingOptions.length) {
                    storeRingOptions.forEach(function (item) {
                        vm.onChangeTopology(item);
                    });
                }
                $("#create-asset").removeClass("in");
                $(".modal-backdrop").remove();
                $("#create-asset").hide();
            }
        }

        function drawExistingkmlImports(map) {
            if (
                vm.trRoute.id &&
                vm.trRoute.routePoints != null &&
                vm.trRoute.routePoints.length
            ) {
                vm.isShowing = false;
                vm.trRoute.routePoints.forEach(function (each) {
                    if (each.routePointType == "COORDINATE") {
                        coordinateList.push({ lat: each.latitude, lng: each.longitude });
                    } else if (each.routePointType == "MARKER") {
                        markerList.push({ lat: each.latitude, lng: each.longitude });
                    } else if (each.routePointType == "CHAINAGE") {
                        chainageList.push({ lat: each.latitude, lng: each.longitude });
                    }
                });

                if (coordinateList.length) {
                    map.setCenter(coordinateList[0]);
                    var polyline = new google.maps.Polyline({
                        path: coordinateList,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });

                    // Set the map to display the polyline
                    polyline.setMap(map);
                }

                if (markerList.length) {
                    map.setCenter(markerList[0]);
                    createMarkers(markerList, "content/images/markersPoint.png", map);
                }

                if (chainageList.length) {
                    map.setCenter(chainageList[0]);
                    createMarkers(chainageList, "content/images/chainagePoints.png", map);
                }
            }
        }
        function initPlanningMap() {
            if ($scope.tab == 4) {
                vm.getCenter = locations.importMap.center;
                vm.currentZoom1 = locations.importMap.getZoom();
            } else if ($scope.tab == 2) {
                vm.getCenter = locations.map.center;
                vm.currentZoom1 = locations.map.getZoom();
            }

            locations.map = new google.maps.Map(
                document.getElementById("map_canvas_planning"),
                myOption(vm.currentZoom1, vm.getCenter)

            );
            var legend = document.createElement("div");
            legend.id = "map-legend";
            legend.style.position = "absolute";
            legend.style.background = "#f3f3f3";
            legend.style.padding = "4px";
            legend.style.border = "1px solid rgb(204, 204, 204)";
            legend.style.fontFamily = "Arial, sans-serif";
            legend.style.borderRadius = "5px";
            legend.style.boxShadow = "1px 1px 1px 0px";
            legend.style.color = "black";

            // Using string concatenation instead of template literals
            legend.innerHTML =
                '<div style="display: flex; align-items: center;">' +
                '<div style="display: flex; align-items: center; margin-right: 15px;">' +
                '<div style="width: 12px; height: 12px; background: #ff0025; margin-right: 5px;"></div>' +
                '<span>NEW</span>' +
                '</div>' +
                '<div style="display: flex; align-items: center;">' +
                '<div style="width: 12px; height: 12px; background: #00A36C; margin-right: 5px;"></div>' +
                '<span>EXISTING</span>' +
                '</div>' +
                '</div>';

            locations.map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(legend);
            var drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: null,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: [google.maps.drawing.OverlayType.POLYGON],
                },
                polygonOptions: {
                    fillColor: "#ff0000",
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    clickable: true,
                    editable: true,
                    zIndex: 1,
                },
            });

            drawingManager.setMap(locations.map);

            function isPointInPolygon(point, polygon) {
                var paths = polygon.getPath();
                return google.maps.geometry.poly.containsLocation(point, polygon);
            }

            function isAssetInPolygon(asset, polygon) {
                return asset.assetCoordinates.some(function (coordinate) {
                    var point = new google.maps.LatLng(coordinate.latitude, coordinate.longitude);
                    return isPointInPolygon(point, polygon);
                });
            }

            google.maps.event.addListener(drawingManager, "overlaycomplete", function (event) {
                if (event.type === "polygon") {
                    var polygon = event.overlay;

                    // Filter assets inside the polygon
                    vm.selectedAssets = [];
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        var asset = vm.mappedAssetsList[i];
                        if (isAssetInPolygon(asset, polygon)) {
                            vm.selectedAssets.push(asset);
                        }
                    }

                    vm.totalLengthPolygon = 0;
                    for (var j = 0; j < vm.selectedAssets.length; j++) {
                        var asset = vm.selectedAssets[j];
                        vm.addAssetToRingStack(asset);
                        vm.highlightSelectedSpan(asset);
                    }
                    event.overlay.setMap(null);
                }
            });

            var toggleMenuButton = document.getElementById("togglePopup");
            var popup = document.getElementById("popupMenu");
            popup.style.display = "block";
            vm.isSidebarVisible = true;
            toggleMenuButton.addEventListener("click", function () {
                if (popup.style.display === "block" || popup.style.display === "") {
                    popup.style.display = "none";
                    vm.popupMenuShow = false;
                } else {
                    popup.style.display = "block";
                    vm.popupMenuShow = true;
                }
            });

            geoLocation(locations.map);

            google.maps.event.addListener(locations.map, "dblclick", function () {
                if (vm.tempItem) {
                    createAssetModal(vm.tempItem);
                }
            });

        }

        function geoLocation(map) {
            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);
            goTo.addEventListener("click", function () {
                vm.getLocationCoordinates = null;
                gotoLatitute();
            });
        }

        function refreshPage() {
            $scope.isAnomaly = false;
            $scope.isAnomalyText = "Show";

            $scope.isShowMinCost = false;
            $scope.isShowMinCostText = "Show";

            if (marker != null) {
                marker.setMap(null);
            }

            initPlanningMap();

            if (coordinatesSpread) {
                locations.map.setCenter(coordinatesSpread[0]);

                var polyline = new google.maps.Polyline({
                    path: coordinatesSpread,
                    geodesic: true,
                    strokeColor: "#FD7A24",
                    strokeOpacity: 1.0,
                    strokeWeight: 3,
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
            }

            if (chainagePoints) {
                locations.map.setCenter(chainagePoints[0]);
                chainagePoints.forEach(function (each) {
                    var marker = new google.maps.Marker({
                        position: { lat: each.lat, lng: each.lng },
                        map: locations.map,
                        icon: {
                            scaledSize: new google.maps.Size(iconSize, iconSize),
                            url: "content/images/chainagePoints.png",
                            anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                            labelOrigin: new google.maps.Point(25, 22),
                        },
                    });
                });
            }

            drawExistingkmlImports(locations.map);

            vm.selectedAssetsToHighlightMultiRing = [];
            angular.forEach(vm.ringRouteAssets, function (asset) {
                asset.isOption = false;
            });
            vm.routeFixedAssets = [];
            vm.sectionAssetDetails = [];
            vm.sectionAssetCount = [];
            vm.minCostTotalLength = 0;
            vm.routePlanningTotalLength = 0;
            vm.connectedLength = 0;
            iterateMappedAssetsList(locations.map, vm.mappedAssetsList);

            if (storeRingOptions.length) {
                storeRingOptions.forEach(function (item) {
                    vm.onChangeTopology(item);
                });
            }
        }

        function showZoomLocation() {
            var latlng = vm.getLocationCoordinates.split(","),
                gotoMarker = null;
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinates != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };

                locations.map.setCenter(assetCenterLatLng);
                locations.map.setZoom(14);
                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: assetCenterLatLng,
                });

                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }
        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
        }

        function closeGotoLatitute(id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

        function getPointsRoute(assetA, assetB, map, dist) {
            var pointA = new google.maps.LatLng(
                assetA.assetCoordinates[0].latitude,
                assetA.assetCoordinates[0].longitude
            );
            var pointB = new google.maps.LatLng(
                assetB.assetCoordinates[0].latitude,
                assetB.assetCoordinates[0].longitude
            );

            var directionsService = new google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: pointA,
                    destination: pointB,
                    travelMode: google.maps.TravelMode.DRIVING,
                },
                function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        var route = response.routes[0];
                        var az = 0;
                        for (var i = 0; i < route.legs.length; ++i) {
                            if (route.legs[i].distance) {
                                az += route.legs[i].distance.value;
                            }
                        }
                        dist = Math.max(dist, Math.round(az / 100));
                        var markerPoints = gMilestone(route, dist);
                        var polylinePathPoints = gMilestone(route, 100);
                        var responsePaths = response.routes;
                        vm.spreadArray = [];
                        var overViewPath = route.overview_path;
                        polylinePathPoints.forEach(function (value, index) {
                            var coordinates = {};
                            coordinates.latitude = value.lat();
                            coordinates.longitude = value.lng();
                            vm.spreadArray.push(coordinates);
                        });
                        var newLinkAsset = {};
                        newLinkAsset.name = assetA.name + " To " + assetB.name;
                        newLinkAsset.description = newLinkAsset.name;
                        newLinkAsset.assetCoordinates = vm.spreadArray;
                        newLinkAsset.assetType = vm.linkAssetType.assetType;
                        var fiberDistance = 0.0;
                        var spreadCoordinates = newLinkAsset.assetCoordinates;
                        if (spreadCoordinates.length > 0) {
                            for (var index in spreadCoordinates) {
                                if (index > 0) {
                                    fiberDistance += distanceCal(
                                        spreadCoordinates[index].latitude,
                                        spreadCoordinates[index].longitude,
                                        spreadCoordinates[index - 1].latitude,
                                        spreadCoordinates[index - 1].longitude
                                    );
                                }
                            }
                        }
                        fiberDistance = fiberDistance.toFixed(2);
                        var spreadAV = vm.linkAssetType.assetTypeAttributeValues;
                        for (
                            var spreadAssetIndex = 0;
                            spreadAssetIndex < spreadAV.length;
                            spreadAssetIndex++
                        ) {
                            if (
                                spreadAV[spreadAssetIndex].assetTypeAttribute.name ===
                                "Fiber Distance (km)"
                            ) {
                                spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
                            }
                        }
                        newLinkAsset.assetTypeAttributeValues = spreadAV;
                        newLinkAsset.isChecked = true;
                        vm.tempLinkWithPits.push(newLinkAsset);
                        markerPoints.forEach(function (point, index) {
                            var newManholeAsset = {};
                            newManholeAsset.name =
                                assetA.name + " To " + assetB.name + " Pit" + (index + 1);
                            newManholeAsset.description = newManholeAsset.name;
                            newManholeAsset.assetType = vm.manholeAssetType.assetType;
                            newManholeAsset.assetTypeAttributeValues =
                                vm.manholeAssetType.assetTypeAttributeValues;
                            vm.fixedArray = [];
                            var coordinates = {};
                            coordinates.latitude = point.lat();
                            coordinates.longitude = point.lng();
                            vm.fixedArray.push(coordinates);
                            newManholeAsset.assetCoordinates = vm.fixedArray;
                            newManholeAsset.isChecked = true;
                            vm.tempLinkWithPits.push(newManholeAsset);
                        });
                        for (var i = 0; i < vm.tempLinkWithPits.length; i++) {
                            if (vm.tempLinkWithPits[i].assetType.layout == "FIXED") {
                                createMarkerForSelectedAsset(vm.tempLinkWithPits[i], map);
                            } else if (vm.tempLinkWithPits[i].assetType.layout == "SPREAD") {
                                var assetCoordinateValues =
                                    vm.tempLinkWithPits[i].assetCoordinates;
                                drawPolylineForGeneratedLoc(
                                    vm.tempLinkWithPits[i],
                                    assetCoordinateValues,
                                    map,
                                    "yellow"
                                );
                            }
                        }
                    } else {
                        window.alert("Directions request failed due to " + status);
                    }
                }
            );
        }

        function saveLinkPits() {
            vm.tempLinkWithPits.forEach(function (asset) {
                vm.mappedAssetsList.push(asset);
            });
            hideConnectMultipleAssetsModal();
        }
        function gMilestone(route, dist) {
            var path = route.overview_path;
            var geo = google.maps.geometry.spherical;
            var point = path[0];
            var distance = 0;
            var overflow = null;
            var pos = null;
            var leg = null;
            var pointsPosition = [];
            var d1 = 0;

            for (var p = 1; p < path.length; ++p) {
                leg = Math.round(geo.computeDistanceBetween(point, path[p]));
                d1 = distance + 0;
                distance += leg;
                overflow = dist - (d1 % dist);

                if (distance >= dist && leg >= overflow) {
                    if (overflow && leg >= overflow) {
                        pos = geo.computeOffset(
                            point,
                            overflow,
                            geo.computeHeading(point, path[p])
                        );
                        pointsPosition.push(pos);
                        distance -= dist;
                    }

                    while (distance >= dist) {
                        pos = geo.computeOffset(
                            point,
                            dist + overflow,
                            geo.computeHeading(point, path[p])
                        );
                        pointsPosition.push(pos);
                        distance -= dist;
                    }
                }
                point = path[p];
            }
            return pointsPosition;
        }

        function createMarkerForSelectedAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = {
                    lat: parseFloat(asset.assetCoordinates[0].latitude),
                    lng: parseFloat(asset.assetCoordinates[0].longitude),
                };
                var iconSize = 24;
                var marker = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: asset.assetType.imagePath,
                        anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                        labelOrigin: new google.maps.Point(24, 0),
                    }
                });
            }
        }

        function createMarkerForSiteAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = {
                    lat: parseFloat(asset.assetCoordinates[0].latitude),
                    lng: parseFloat(asset.assetCoordinates[0].longitude),
                };
                if (asset.assetType.name == "Manhole") {
                    var iconSize = 4;
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: {
                            scaledSize: new google.maps.Size(iconSize, iconSize),
                            url: "content/images/green_circle.png",
                            anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                        },
                    });
                } else {
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                    });
                }
            }
        }

        function drawPolylineForGeneratedLoc(asset, latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];

            latlngsToDraw.forEach(function (value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });

            if (asset.assetType.name == "GP") {
                asset.assetTypeAttributeValues.forEach(function (value, index) {
                    if (value.assetTypeAttribute.name == "GP Status") {
                        if (value.attributeValue == "Not Connected") {
                            asset.isConnected = false;
                        }
                    }
                });
            }

            if (spreadAssetCoordinates.length > 0) {

                var ColorValue = "red";
                // if (!asset.isConnected) {
                if (!asset.isExisting) {
                    ColorValue = "blue";
                }

                if (asset.isCycle) {
                    ColorValue = "#FFD700";
                }
                // spreadAssetCoordinates.sort(function (a, b) {
                //     return a.id - b.id; // Ascending order
                // });
                if (spreadAssetCoordinates[0].sortOrder != null) {
                    spreadAssetCoordinates.sort(function (a, b) {
                        return a.sortOrder - b.sortOrder; // Ascending order
                    });
                    // } else {
                    //     spreadAssetCoordinates.sort(function (a, b) {
                    //         return a.id - b.id; // Ascending order
                    //     });
                }
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(map);

            }
        }

        function drawingManagerSpread() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYLINE,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["polyline"],
                },
                polylineOptions: {
                    fillColor: "#ffff00",
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: true,

                    editable: true,
                    zIndex: 1,
                    geodesic: true,
                },
            });
        }

        function drawingManagerFixed() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.MARKER,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["marker"],
                },
            });
        }

        function drawingManagerValue(option, map, isEdit) {
            if (option == "polylinecomplete") {
                vm.isShowing = false;
                google.maps.event.addListener(
                    vm.drawingManager,
                    option,
                    function (event) {
                        google.maps.event.addListener(
                            event.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(event, isEdit);
                            }
                        );
                        google.maps.event.addListener(
                            event.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(event, isEdit);
                            }
                        );
                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                        setGoefenceCoordinate(event, isEdit);
                        if (mappedAssetTemp.assetType.layout == "SPREAD") {
                            var fiberDistance = 0.0;
                            var spreadCoordinates = mappedAssetTemp.assetCoordinates;
                            if (spreadCoordinates.length > 0) {
                                for (var index in spreadCoordinates) {
                                    if (index > 0) {
                                        fiberDistance += distanceCal(
                                            spreadCoordinates[index].latitude,
                                            spreadCoordinates[index].longitude,
                                            spreadCoordinates[index - 1].latitude,
                                            spreadCoordinates[index - 1].longitude
                                        );
                                    }
                                }
                            }
                            fiberDistance = fiberDistance.toFixed(2);
                            mappedAssetTemp.assetLength = parseFloat(fiberDistance);
                            vm.routePlanningTotalLength += parseFloat(fiberDistance);
                            var spreadAV = mappedAssetTemp.assetTypeAttributeValues;
                            for (
                                var spreadAssetIndex = 0;
                                spreadAssetIndex < spreadAV.length;
                                spreadAssetIndex++
                            ) {
                                if (
                                    spreadAV[spreadAssetIndex].assetTypeAttribute.name ===
                                    "Fiber Distance (km)"
                                ) {
                                    spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
                                }
                            }
                            mappedAssetTemp.assetTypeAttributeValues = spreadAV;
                        }
                        addMappedAssets(mappedAssetTemp);
                    }
                );
                vm.drawingManager.setMap(map);
            } else if (option == "click") {
                vm.isShowing = false;
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                });

                google.maps.event.addListener(map, "click", function (e) {
                    placeMarker(e.latLng, map);
                    vm.fixedArray = [];
                    var coordinates = {};
                    coordinates.latitude = e.latLng.lat();
                    coordinates.longitude = e.latLng.lng();
                    vm.fixedArray.push(coordinates);
                    mappedAssetTemp.assetCoordinates = vm.fixedArray;
                    addMappedAssets(mappedAssetTemp);
                });
            }
        }

        function placeMarker(location, map) {
            if (marker) {
                if (location.lat != null && location.lng != null) {
                    marker.setPosition(location);
                }
            } else {
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                });
            }
        }

        function addMappedAssets(newAsset) {
            if (!isAssetAvailable(newAsset.name)) {
                newAsset.isChecked = true;
                // vm.mappedAssetsList.push(newAsset);
                Asset.save(newAsset, function(response){
					newAsset.id = response.id;
					vm.mappedAssetsList.push(newAsset);
					initPlanningMap();
					iterateMappedAssetsList(locations.map, vm.mappedAssetsList);
				});

            }
        }

        function isAssetAvailable(assetName) {
            var isAssetAvailable = false;

            vm.mappedAssetsList.forEach(function (assetVal) {
                if (assetVal.name === assetName) {
                    isAssetAvailable = true;
                }
            });
            return isAssetAvailable;
        }

        function deleteAssetModal(name, id) {
            $("#delete-asset").show();
            deleteAssetName = name;
            vm.assetId = id;
        }

        function confirmDeleteAsset() {
            if (vm.assetId && (vm.trRoute.id || vm.trRoute.tempId)) {
                AssetDeleteByID.delete(vm.assetId, function () { });
            }

            var assetArray = vm.mappedAssetsList;
            for (var i = assetArray.length - 1; i >= 0; --i) {
                if (assetArray[i].name == deleteAssetName) {
                    vm.deletedAssetsList.push(assetArray[i]);
                    vm.routePlanningTotalLength -= assetArray[i].assetLength;
                    assetArray.splice(i, 1);
                }
            }

            for (var i = vm.tempCycleAssets.length - 1; i >= 0; --i) {
                if (vm.tempCycleAssets[i].name == deleteAssetName) {
                    vm.tempCycleAssets.splice(i, 1);
                }
            }

            vm.mappedAssetsList = [];
            assetArray.forEach(function (asset) {
                vm.mappedAssetsList.push(asset);
            });

            initPlanningMap();

            drawExistingkmlImports(locations.map);

            locations.map.setCenter(vm.getCenter);
            locations.map.setZoom(vm.currentZoom1);

            iterateMappedAssetsList(locations.map, vm.mappedAssetsList);

            if (storeRingOptions.length) {
                storeRingOptions.forEach(function (item) {
                    vm.onChangeTopology(item);
                });
            }
            $("#delete-asset").hide();
        }

        function cleardeleteAsset() {
            $("#delete-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#delete-asset").hide();
        }

        function setGoefenceCoordinate(event, isEdit) {
            vm.assetCoordinateValues = [];
            var tempAsset = {};
            tempAsset.assetCoordinates = [];
            var radius = event.getPath();
            for (var i = 0; i < radius.getLength(); i++) {
                var coordinates = {};
                coordinates.latitude = radius.getAt(i).lat();
                coordinates.longitude = radius.getAt(i).lng();
                tempAsset.assetCoordinates.push(coordinates);
            }
            if (isEdit) {
                vm.asset.assetCoordinates = tempAsset.assetCoordinates;
            } else {
                mappedAssetTemp.assetCoordinates = tempAsset.assetCoordinates;
                mappedAssetTemp.routeBundleId = vm.trRoute.id
                    ? vm.trRoute.id
                    : vm.trRoute.tempId;
                (mappedAssetTemp.userId = vm.userId), (mappedAssetTemp.ownedBy = []);
            }
        }

        function saveEditAsset() {
            var rId = vm.trRoute.id ? vm.trRoute.id : vm.trRoute.tempId;

            if (vm.assetId && rId) {
                var temp = vm.storeAssetTypes.find(function (item) {
                    return item.name == vm.asset.assetType.name;
                });
                vm.asset.assetType = temp;
                /* vm.asset.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                     temp
                 );*/
                // vm.asset.routeId = rId;
                vm.asset.routeBundleId = rId;
                var assetCoordinatesValues = vm.asset.assetCoordinates;
                var assetCoordinatesSort = [];
                for (var index = 0; index < assetCoordinatesValues.length; index++) {
                    var assetCoorByIndex = assetCoordinatesValues[index];
                    assetCoorByIndex.sortOrder = index;
                    assetCoordinatesSort.push(assetCoorByIndex);
                }
                vm.asset.assetCoordinates = assetCoordinatesSort;
                (vm.asset.userId = vm.userId), (vm.asset.ownedBy = []);
                var fixedAssets = [];
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                        fixedAssets.push(vm.mappedAssetsList[i]);
                    }
                }
                if (vm.asset.assetCoordinates.length > 1) {
                    var firstCoord = vm.asset.assetCoordinates[0];
                    var lastCoord = vm.asset.assetCoordinates[vm.asset.assetCoordinates.length - 1];
                
                    var minFirstDist = 20; // meters
                    var minLastDist = 20; // meters
                
                    var nearestFirst = null;
                    var nearestLast = null;
                
                    for (var i = 0; i < fixedAssets.length; i++) {
                        var mappedAssetCoor = fixedAssets[i].assetCoordinates[0];
                        if(mappedAssetCoor){
                        var mappedLat = mappedAssetCoor.latitude;
                        var mappedLon = mappedAssetCoor.longitude;
                        }
                
                        var distToFirst = getDistanceMeters(firstCoord.latitude, firstCoord.longitude, mappedLat, mappedLon);
                        if (distToFirst <= minFirstDist) {
                            minFirstDist = distToFirst;
                            nearestFirst = mappedAssetCoor;
                        }
                
                        var distToLast = getDistanceMeters(lastCoord.latitude, lastCoord.longitude, mappedLat, mappedLon);
                        if (distToLast <= minLastDist) {
                            minLastDist = distToLast;
                            nearestLast = mappedAssetCoor;
                        }
                    }
                
                    if (nearestFirst) {
                        firstCoord.latitude = nearestFirst.latitude;
                        firstCoord.longitude = nearestFirst.longitude;
                    }
                
                    if (nearestLast) {
                        lastCoord.latitude = nearestLast.latitude;
                        lastCoord.longitude = nearestLast.longitude;
                    }
                    if (firstCoord != null && firstCoord != undefined) {
                        vm.asset.assetCoordinates[0].latitude = firstCoord.latitude;
                        vm.asset.assetCoordinates[0].longitude = firstCoord.longitude;
                    }
                    if (lastCoord != null && lastCoord != undefined) {
                        vm.asset.assetCoordinates[vm.asset.assetCoordinates.length - 1].latitude = lastCoord.latitude;
                        vm.asset.assetCoordinates[vm.asset.assetCoordinates.length - 1].longitude = lastCoord.longitude;
                    }

                }


                Asset.update(vm.asset, function (response) { 
                vm.mappedAssetsList.find(function(asset){
                  if(asset.id==response.id){
                    asset.assetCoordinates=[]
                    asset.assetCoordinates=response.assetCoordinates
                   }
                   })
                   vm.asset = [];
                   hideUserEditModal();
                   initPlanningMap();
                   iterateMappedAssetsList(locations.map, vm.mappedAssetsList);
                   if (storeRingOptions.length) {
                       storeRingOptions.forEach(function (item) {
                           vm.onChangeTopology(item);
                       });
                   }
                });
            }
            // vm.mappedAssetsList = [];
            // vm.tempAssetArray.forEach(function (assetVal) {
            //     if (vm.assetId == assetVal.id) {
            //         assetVal.isChecked = true;
            //         var spreadCoordinates = assetVal.assetCoordinates;
            //         var fiberDistance = 0;
            //         for (var index in spreadCoordinates) {
            //             if (index > 0) {
            //                 fiberDistance += distanceCal(
            //                     spreadCoordinates[index].latitude,
            //                     spreadCoordinates[index].longitude,
            //                     spreadCoordinates[index - 1].latitude,
            //                     spreadCoordinates[index - 1].longitude
            //                 );
            //             }
            //         }
            //         vm.routePlanningTotalLength -= assetVal.assetLength;
            //         assetVal.assetLength = fiberDistance.toFixed(2);
            //         vm.routePlanningTotalLength += parseFloat(fiberDistance.toFixed(2));
            //     }
            //     vm.mappedAssetsList.push(assetVal);
            // });
       
        }

        // Helper to calculate distance between two lat/lon points in meters
        function getDistanceMeters(lat1, lon1, lat2, lon2) {
            var R = 6371000; // Radius of Earth in meters
            var dLat = (lat2 - lat1) * Math.PI / 180;
            var dLon = (lon2 - lon1) * Math.PI / 180;
            var a = 
                Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon/2) * Math.sin(dLon/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            return R * c;
        }


        function hideUserEditModal() {
            $("#userPathModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#userPathModal").hide();
        }
        vm.assetattributevaluesDisplay = [];
        function editAsset(asset) {
            for (var i = 0; i < editPathMarkers.length; i++) {
                editPathMarkers[i].setMap(null);
            }
            vm.tempAssetArray = [];

            vm.mappedAssetsList.forEach(function (assetVal) {
                vm.tempAssetArray.push(assetVal);
            });
            for (var i = 0; i >= vm.tempAssetArray.length; --i) {
                if (vm.tempAssetArray[i].name == asset.name) {
                    vm.tempAssetArray.splice(i, 1);
                }
            }

            vm.asset = asset;
            vm.assetId = asset.id;
            var maplatlng = {
                lat: parseFloat(asset.assetCoordinates[0].latitude),
                lng: parseFloat(asset.assetCoordinates[0].longitude),
            };
            editAssetMap = new google.maps.Map(
                document.getElementById("map_canvas_edit_asset"),
                myOption(13, maplatlng)
            );

            if (asset.assetType.layout == "SPREAD") {
                drawingManagerSpread();
                drawingManagerValue("polylinecomplete", editAssetMap);
            } else if (asset.assetType.layout == "FIXED") {
                drawingManagerFixed();
                drawingManagerValue("click", editAssetMap);
            }

            editPathMarkers = [];
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
               if(vm.mappedAssetsList[i].assetCoordinates[0]){
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    (function(asset){
                    var myLatLng = {
                        lat: parseFloat(vm.mappedAssetsList[i].assetCoordinates[0].latitude),
                        lng: parseFloat(vm.mappedAssetsList[i].assetCoordinates[0].longitude),
                    };

                    var marker = new google.maps.Marker(
                        {
                            position: myLatLng,
                            map: editAssetMap,
                            label: vm.mappedAssetsList[i].name,
                            icon: {
                                scaledSize: new google.maps.Size(24, 24),
                                url: vm.mappedAssetsList[i].assetType.imagePath,
                                anchor: new google.maps.Point(
                                    12, 24
                                ),
                                labelOrigin: new google.maps.Point(25, 40),
                            },
                        });
                    marker.setLabel({
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "12px",
                        text: vm.mappedAssetsList[i].name,
                    });

                    var contentString =
                        '<div class="infoWindowhead">' +
                        asset.id +
                        "<br><b>Name </b> : " +
                        asset.name +
                        '</div><div class="infoWindowContent">' +
                        "<b>Asset Type </b> : " +
                        asset.assetType.name +
                        "<br><b>Latitude </b> : " +
                        asset.assetCoordinates[0].latitude +
                        "<br><b>Longitude </b> : " +
                        asset.assetCoordinates[0].longitude +
                        "<br></div>";

                    var infoWindow = new google.maps.InfoWindow({
                        content: contentString,
                    });

                    google.maps.event.addListener(marker, "click", function () {
                        infoWindow.open(editAssetMap, marker);
                    });


                    editPathMarkers.push(marker);
                })(vm.mappedAssetsList[i])
                }
               }
            }
            if (asset.name && asset.name != null) {
                if (asset.assetType.layout == "SPREAD") {
                    drawPolyline(function (polyline) {
                        polyline.setMap(editAssetMap);
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(polyline, true);
                            }
                        );
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(polyline, true);
                            }
                        );

                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                    });
                } else if (asset.assetType.layout == "FIXED") {
                    setValues();
                    drawingManagerFixed();
                    drawMarker(editAssetMap, vm.coOrdinate);
                }
 
                function drawPolyline(callback) {
                    setValues();
                    var centerlatlng = {};
                    if (vm.coOrdinates.length > 1) {
                        vm.coOrdinates.forEach(function (value) {
                            centerlatlng = {
                                lat: value.lat,
                                lng: value.lng,
                            };
                        });
                        if(vm.coOrdinates[0].sortOrder!=null){
                            vm.coOrdinates.sort(function (a, b) {
                                return a.sortOrder - b.sortOrder;
                            });
                        }

                        callback(
                            new google.maps.Polyline({
                                path: vm.coOrdinates,
                                geodesic: true,
                                strokeColor: vm.asset.assetType.colorcode,
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: vm.asset.assetType.colorcode,
                                fillOpacity: 0.3,
                                editable: true,
                            })
                        );
                        editAssetMap.setCenter(centerlatlng);
                    }
                }
            }
            var ele = document.getElementById("userPathModal");
            $(ele).modal("show");
            $("#userPathModal").show();

            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_edit_asset").css("width", "100%");
        }

        function hideConnectAssetsModal() {
            $("#connectAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectAssetsModal").hide();
        }

        function hideConnectSitesModal() {
            $("#connectAssetsModal").hide();
        }

        var input = document.getElementById("field_pinLat");
        input.addEventListener("input", function () {
            this.value = this.value.replace(/[^-0-9\,\.]/, "");
        });

        $(".select2").select2();

        $("#toAssetsView").select2({
            dropdownParent: $("#connectAssetsModal"),
        });
        $("#spreadType").select2({
            dropdownParent: $("#connectAssetsModal"),
        });
        $("#fromAssetsView").select2({
            dropdownParent: $("#connectAssetsModal"),
        });
        $("#ringDropdown").select2({
            dropdownParent: $("#ringTopology"),
        });
        $("#assettypeDropdown").select2({
            dropdownParent: $("#importKml"),
            width: '100%'
        });

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = []; // Response need to be changed
            vm.workFlowPhase.push({ id: "PLANNING", configKey: "PLANNING" });
            vm.workFlowPhase.push({ id: "PROPOSED", configKey: "PROPOSED" });
            vm.workFlowPhase.push({ id: "ROLLOUT", configKey: "ROLLOUT" });
            vm.workFlowPhase.push({ id: "MAINTENANCE", configKey: "MAINTENANCE" });
        });

        Configs.get("RolloutTaskStatus", function (response) {
            vm.rolloutTaskStatus = response;
        });

        function connectSelectedAssets() {
            locations.mapConnect = new google.maps.Map(
                document.getElementById("map_canvas_connect_assets"),
                myOption(14, latlngs)
            );
            $("#fromAssetsView").val(null).trigger("change.select2");
            $("#toAssetsView").val(null).trigger("change.select2");
            $("#spreadType").val(null).trigger("change.select2");

            vm.connectTwoAssets = vm.mappedAssetsList.filter(function (item) {
                return item.id != "True" && item.assetType.layout == "FIXED";
            });
            var ele = document.getElementById("connectAssetsModal");
            $(ele).modal("show");
            $("#connectAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_assets").css("width", "100%");
        }

        function hideConnectMultipleAssetsModal() {
            $("#connectMultipleAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectMultipleAssetsModal").hide();
            vm.tempLinkWithPits = [];
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], locations.map);
                } else if (vm.mappedAssetsList[i].assetType.layout == "SPREAD") {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        locations.map,
                        "yellow"
                    );
                }
            }
        }

        function connectMultipleAssets() {
            vm.siteAssets = [];
            vm.tempLinkWithPits = [];

            var ele = document.getElementById("connectMultipleAssetsModal");
            $(ele).modal("show");
            $("#connectMultipleAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_multiple_assets").css("width", "100%");
            var multipleSiteMap = new google.maps.Map(
                document.getElementById("map_canvas_connect_multiple_assets"),
                {
                    center: new google.maps.LatLng(
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude
                    ),
                    zoom: 12,
                    fullscreenControl: true,
                }
            );
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (
                    vm.mappedAssetsList[i].assetType.layout == "FIXED" &&
                    vm.mappedAssetsList[i].assetType.name == "Site" &&
                    vm.mappedAssetsList[i].id == null
                ) {
                    vm.siteAssets.push(vm.mappedAssetsList[i]);
                    createMarkerForSiteAsset(vm.mappedAssetsList[i], multipleSiteMap);
                }
            }

            vm.siteAssets.sort(function (assetA, assetB) {
                var assetATime = assetA.createDate,
                    assetBTime = assetB.createDate;
                if (assetATime < assetBTime)
                    // sort string ascending
                    return -1;
                if (assetATime > assetBTime) return 1;
                return 0; // default return value (no sorting)
            });
            for (var siteIndex = 1; siteIndex < vm.siteAssets.length; siteIndex++) {
                getPointsRoute(
                    vm.siteAssets[siteIndex - 1],
                    vm.siteAssets[siteIndex],
                    multipleSiteMap,
                    200
                );
            }
        }

        function recalculate() {
            var totalCost = 0;
            var totalPowerBudget = 0;
            var totalFiberDistance = 0.0;
            for (
                var assetIndex = 0;
                assetIndex < vm.mappedAssetsList.length;
                assetIndex++
            ) {
                var isSpread = false;
                var fiberDistance = 0.0;

                if (vm.mappedAssetsList[assetIndex].assetType.layout == "SPREAD") {
                    isSpread = true;
                    var spreadAV =
                        vm.mappedAssetsList[assetIndex].assetTypeAttributeValues;
                    for (
                        var spreadAssetIndex = 0;
                        spreadAssetIndex < spreadAV.length;
                        spreadAssetIndex++
                    ) {
                        if (
                            spreadAV[spreadAssetIndex].assetTypeAttribute.name ===
                            "Fiber Distance (km)"
                        ) {
                            fiberDistance = parseFloat(
                                "0" + spreadAV[spreadAssetIndex].attributeValue
                            );
                        }
                    }
                }

                for (
                    var attrIndex = 0;
                    attrIndex <
                    vm.mappedAssetsList[assetIndex].assetTypeAttributeValues.length;
                    attrIndex++
                ) {
                    var item =
                        vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[attrIndex];
                    var value = parseFloat(item.assetTypeAttribute.defaultValue);

                    if (item.assetTypeAttribute.name == "Cost") {
                        var tempCost = parseFloat(value);
                        if (isSpread) {
                            tempCost = parseFloat(value) * fiberDistance;
                        }
                        if (tempCost > 0) {
                            totalCost += tempCost;
                        }
                        item.attributeValue = value;
                    }
                    if (item.assetTypeAttribute.name == "Power Budget") {
                        var tempPowerBudget = parseFloat(value);
                        if (isSpread) {
                            tempPowerBudget = parseFloat(value) * fiberDistance;
                        }
                        if (tempPowerBudget > 0) {
                            totalPowerBudget += tempPowerBudget;
                        }
                        item.attributeValue = value;
                    }
                    vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[
                        attrIndex
                    ] = item;
                }
                totalFiberDistance += fiberDistance;
            }
        }

        function connectAssets() {
            if (!vm.isSiteASelected) {
                alert("Please select Site A");
                return;
            }
            if (!vm.isSiteBSelected) {
                alert("Please select Site B");
                return;
            }
            var siteALatLng = new google.maps.LatLng(
                vm.selectedSiteA.assetCoordinates[0].latitude,
                vm.selectedSiteA.assetCoordinates[0].longitude
            );
            var siteBLatLng = new google.maps.LatLng(
                vm.selectedSiteB.assetCoordinates[0].latitude,
                vm.selectedSiteB.assetCoordinates[0].longitude
            );
            var mapOptions = {
                center: siteALatLng,
                zoom: 16,
                fullscreenControl: true,
            };
            var map = new google.maps.Map(
                document.getElementById("map_canvas_connect_assets"),
                mapOptions
            );
            createMarker(map, vm.selectedSiteA.name, siteALatLng);
            createMarker(map, vm.selectedSiteB.name, siteBLatLng);
            var selectedTravelMode =
                document.getElementById("travelMode").value || "DRIVING";
            var fromAssetName = document.getElementById("fromAssetsView").value;
            var toAssetName = document.getElementById("toAssetsView").value;

            if (!fromAssetName || !toAssetName) {
                alert("Please select both Site A and Site B.");
                return;
            }
            var fromAsset = vm.connectTwoAssets.find(function (asset) {
                return asset.name === fromAssetName;
            });
            var toAsset = vm.connectTwoAssets.find(function (asset) {
                return asset.name === toAssetName;
            });

            if (!fromAsset || !toAsset) {
                alert("Selected assets not found.");
                return;
            }
            getShortestRoute(fromAsset, toAsset, map, selectedTravelMode);
        }
        function setValues() {
            vm.coOrdinates = [];
            for (var i = 0; i < vm.asset.assetCoordinates.length; i++) {
                vm.coOrdinates.push({
                    lat: vm.asset.assetCoordinates[i].latitude,
                    lng: vm.asset.assetCoordinates[i].longitude,
                    sortOrder:vm.asset.assetCoordinates[i].sortOrder,
                });
                if (i == vm.asset.assetCoordinates.length - 1) {
                    vm.coOrdinate = JSON.stringify(vm.coOrdinates);
                }
            }
        }

        $("#fromAssetsView").change(function () {
            $("#toAssetsView")[0].selectedIndex = 0;
            var result = $("#fromAssetsView").val();
            if (result != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].name == result) {
                        vm.selectedSiteA = vm.mappedAssetsList[i];
                    }
                }
                vm.isSiteASelected = true;
            }
        });

        $("#toAssetsView").change(function () {
            if (vm.isSiteASelected == true) {
                var result = $("#toAssetsView").val();
                if (result != null) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].name == result) {
                            vm.selectedSiteB = vm.mappedAssetsList[i];
                        }
                    }
                    vm.isSiteBSelected = true;
                }
            } else {
                $("#toAssetsView")[0].selectedIndex = 0;
                alert("Please Select Site A");
            }
        });

        function createMarker(map, assetName, myLatLng) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: {
                    scaledSize: new google.maps.Size(24, 24),
                    origin: new google.maps.Point(0, 0),
                    url: "content/images/yellow.png",
                    anchor: new google.maps.Point(16, 16),
                }
            });
        }

        function drawMarker(map, response) {
            $.each(JSON.parse(response), function (index, value) {
                centerlatlng = {
                    lat: value.lat,
                    lng: value.lng,
                };

                if (marker) {
                    marker.setMap(null);
                }
                marker = new google.maps.Marker({
                    position: centerlatlng,
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(16, 16),
                    },
                });

                marker.setMap(map);
                vm.fixedArray = [];
                var coordinates = {};
                coordinates.latitude = centerlatlng.lat;
                coordinates.longitude = centerlatlng.lng;
                vm.fixedArray.push(coordinates);
                mappedAssetTemp.assetCoordinates = vm.fixedArray;
            });
        }

        function getShortestRoute(SiteA, SiteB, map, travelMode) {
            var pointA = new google.maps.LatLng(
                SiteA.assetCoordinates[0].latitude,
                SiteA.assetCoordinates[0].longitude
            );
            var pointB = new google.maps.LatLng(
                SiteB.assetCoordinates[0].latitude,
                SiteB.assetCoordinates[0].longitude
            );

            var newAsset = {
                name: "",
                assetCoordinates: [],
            };
            newAsset.name = SiteA.name + " To " + SiteB.name;

            var directionsService = new google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: pointA,
                    destination: pointB,
                    avoidTolls: true,
                    avoidHighways: true,
                    provideRouteAlternatives: true,
                    travelMode: google.maps.TravelMode[travelMode.toUpperCase()],
                },
                function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = response.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                vm.fixedArray = [];
                                var route = pathVal;
                                var legs = route.legs;

                                var polylinePathPoints = [];
                                for (var i = 0; i < legs.length; i++) {
                                    var steps = legs[i].steps;
                                    for (var j = 0; j < steps.length; j++) {
                                        var nextSegment = steps[j].path;
                                        for (var k = 0; k < nextSegment.length; k++) {
                                            polylinePathPoints.push(nextSegment[k]);
                                        }
                                    }
                                }
                                vm.fixedArray.push({ lat: SiteA.assetCoordinates[0].latitude, lng: SiteA.assetCoordinates[0].longitude });
                                polylinePathPoints.forEach(function (value) {
                                    var coordinates = {};
                                    coordinates.lat = value.lat();
                                    coordinates.lng = value.lng();
                                    vm.fixedArray.push(coordinates);
                                });
                                vm.fixedArray.push({ lat: SiteB.assetCoordinates[0].latitude, lng: SiteB.assetCoordinates[0].longitude });
                                drawPolylineForSelectedPath(
                                    SiteA.name + " To " + SiteB.name,
                                    vm.fixedArray,
                                    map,
                                    index
                                );
                            }
                        });
                    } else {
                        window.alert("Directions request failed due to " + status);
                    }
                }
            );
            return newAsset;
        }
        function drawPolylineForSelectedPath(
            assetName,
            spreadAssetCoordinates,
            map,
            index
        ) {
            if (spreadAssetCoordinates.length > 0) {
                map.setZoom(14);

                var ColorValue = "#ff0000";
                if (index == 0) {
                    ColorValue = "#ff0000";
                } else if (index == 1) {
                    ColorValue = "#000000";
                } else {
                    ColorValue = "#208000";
                }
                map.setCenter(spreadAssetCoordinates[0])
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue || "#ff0000",
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false,
                    zIndex: 2
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue,
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(
                    polylinepath,
                    "mouseover",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var pointContent = document.createElement("div"),
                            button,
                            clearButton;

                        pointContent.innerHTML =
                            '<div class="infoWindowhead">Point ' + (index + 1) + "</div>";
                        button = pointContent.appendChild(document.createElement("input"));
                        button.type = "button";
                        button.value = "Click to select";
                        button.className = "button";
                        clearButton = pointContent.appendChild(document.createElement("input"));
                        clearButton.type = "button";
                        clearButton.value = "Clear";
                        clearButton.className = "button";
                        clearButton.style.marginLeft = "5px";
                        google.maps.event.addDomListener(button, "click", function () {
                            var newAsset = {};
                            newAsset.name = assetName;
                            newAsset.assetCoordinates = [];
                            newAsset.phase = "PLANNING";
                            spreadAssetCoordinates.forEach(function (assetCoor, index) {
                                newAsset.assetCoordinates.push({
                                    latitude: assetCoor.lat,
                                    longitude: assetCoor.lng,
                                    sortOrder: index + 1
                                });
                            });

                            vm.assetTypeResponse.forEach(function (item) {
                                if (item.name == "Planned Route") {
                                    vm.isShowing = false;
                                    newAsset.assetType = item;
                                    newAsset.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                        newAsset.assetType
                                    );
                                    if (newAsset.assetType.layout == "SPREAD") {
                                        var fiberDistance = 0.0;
                                        var spreadCoordinates = newAsset.assetCoordinates;
                                        if (spreadCoordinates.length > 0) {
                                            for (var index in spreadCoordinates) {
                                                if (index > 0) {
                                                    fiberDistance += distanceCal(
                                                        spreadCoordinates[index].latitude,
                                                        spreadCoordinates[index].longitude,
                                                        spreadCoordinates[index - 1].latitude,
                                                        spreadCoordinates[index - 1].longitude
                                                    );
                                                }
                                            }
                                        }
                                        fiberDistance = fiberDistance.toFixed(2);
                                        newAsset.assetLength = parseFloat(fiberDistance);
                                        vm.routePlanningTotalLength += parseFloat(fiberDistance);
                                        $scope.$apply();
                                        var spreadAV = newAsset.assetTypeAttributeValues;
                                        for (
                                            var spreadAssetIndex = 0;
                                            spreadAssetIndex < spreadAV.length;
                                            spreadAssetIndex++
                                        ) {
                                            if (
                                                spreadAV[spreadAssetIndex].assetTypeAttribute.name ===
                                                "Fiber Distance (km)"
                                            ) {
                                                spreadAV[
                                                    spreadAssetIndex
                                                ].attributeValue = fiberDistance;
                                            }
                                        }
                                        newAsset.assetTypeAttributeValues = spreadAV;
                                    }
                                    newAsset.isChecked = true;
                                    newAsset.inGraph = true;
                                    newAsset.block = vm.blockName;
                                    newAsset.state = vm.stateName;
                                    newAsset.district = vm.districtName;
                                    newAsset.routeBundleId = vm.trRoute.id ? vm.trRoute.id: vm.trRoute.tempId;			
                					(newAsset.userId = vm.userId), (newAsset.ownedBy = []);
                                    Asset.save(newAsset, function(response){
									newAsset.id = response.id;
									vm.mappedAssetsList.push(newAsset);
									 initPlanningMap();

                                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                                        if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                                            drawMarkers(
                                                vm.mappedAssetsList[i],
                                                locations.map,i
                                            );
                                        } else if (
                                            vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                                        ) {
                                            if (vm.mappedAssetsList[i].name == assetName) {
                                                vm.mappedAssetsList[i].isConnected = false;
                                            }

                                            if (vm.mappedAssetsList[i].assetCoordinates) {
                                                var assetCoordinateValues = [];
                                                vm.mappedAssetsList[i].assetCoordinates.forEach(
                                                    function (each, index) {
                                                        assetCoordinateValues.push({
                                                            lat: each.latitude,
                                                            lng: each.longitude,
                                                        });
                                                    }
                                                );
                                            }
                                            var tmpColor = "#00A36C"; //var tmpColor = "red";
                                            if (vm.mappedAssetsList[i].isCycle) {
                                                tmpColor = "#FFD700";
                                                // } else if (!vm.mappedAssetsList[i].isConnected) {
                                            } else if (!vm.mappedAssetsList[i].isExisting) {
                                                tmpColor = "#ff0025"; //tmpColor = "blue";
                                            }

                                            if(!vm.mappedAssetsList[i].isUsed && vm.mappedAssetsList[i].isExisting){
                                                tmpColor = "#FFAE42"
                                            }
                                            // assetCoordinateValues.sort(function (a, b) {
                                            //     return a.id - b.id; // Ascending order
                                            // });
                                            if (assetCoordinateValues[0].sortOrder != null) {
                                                assetCoordinateValues.sort(function (a, b) {
                                                    return a.sortOrder - b.sortOrder; // Ascending order
                                                });
                                                // } else {
                                                //     assetCoordinateValues.sort(function (a, b) {
                                                //         return a.id - b.id; // Ascending order
                                                //     });
                                            }
                                            drawPolyLines(
                                                vm.mappedAssetsList[i],
                                                tmpColor,
                                                assetCoordinateValues,
                                                locations.map
                                            );
                                        }
                                    }
                                })
                                }
                            });

                            vm.ringSize.forEach(function (item) {
                                item.ticked = false;
                            });
                            drawExistingkmlImports(locations.map);
                            hideConnectAssetsModal();
                            vm.refreshPage();
                        });
                        google.maps.event.addDomListener(clearButton, "click", function () {
                            polylinepath.setMap(null);
                            if (openedInfoWindow != undefined) {
                                openedInfoWindow.close();
                            };
                        });

                        var infoWindow2 = new google.maps.InfoWindow({
                            content: pointContent,
                        });
                        infoWindow2.open(map);
                        infoWindow2.setPosition(event.latLng);
                        openedInfoWindow = infoWindow2;
                    }
                );
            }
        }

        function save(bool) {
            vm.isShowing = false;
            vm.trRoute.assets = [];
            vm.trRoute.deletedAssets = [];


            vm.deletedAssetsList.forEach(function (asset) {
                vm.trRoute.deletedAssets.push(asset);
            });

            if (!vm.trRoute.id && (markerList || coordinateList || chainageList)) {
                vm.trRoute.routePoints = (coordinateList || []).concat(
                    markerList || [],
                    chainageList || []
                );
            }


            vm.isShowing = true;
            vm.isSaving = true;

            if (vm.trRoute.tempId || vm.trRoute.id) {
                vm.trRoute.id = vm.trRoute.tempId ? vm.trRoute.tempId : vm.trRoute.id;

                function onMappedAssetsSuccess(data) {
                    if (data.length > 0) {
                        var assets = vm.trRoute.assets;
                        var mappingData = [];
                        data.forEach(function (value) {
                            mappingData.push(value);
                        });

                        // Create a lookup object for assets by ID
                        var assetLookup = {};
                        for (var i = 0; i < assets.length; i++) {
                            var asset = assets[i];
                            assetLookup[asset.id] = asset;
                        }

                        // Create a mapping object for quick lookup of mappedIds by ID
                        var mapping = {};
                        for (var j = 0; j < mappingData.length; j++) {
                            try {
                                var item = mappingData[j];

                                var str = item.mappedIds.slice(1, -1);

                                // Split the string by comma and trim each element
                                var strArray = str.split(",").map(function (element) {
                                    return element.trim();
                                });

                                // Convert each element to a number
                                var numArray = strArray.map(function (element) {
                                    return Number(element);
                                });
                                mapping[item.id] = numArray;
                            } catch (error) {
                                console.error(error);
                            }
                        }

                        // Augment each asset object with its corresponding mappedAssets
                        var mappedAssetsList = assets.map(function (asset) {
                            var mappedIds = mapping[asset.id] || [];
                            var mappedAssetsList = mappedIds.map(function (mappedId) {
                                return assetLookup[mappedId];
                            });
                            // Clone the asset object and add the mappedAssets property
                            var mappedAsset = Object.assign({}, asset, {
                                mappedAssets: mappedAssetsList,
                            });
                            return mappedAsset;
                        });
                        vm.trRoute.assets = mappedAssetsList;
                    }
                }
                onSaveSuccess();
            } else {
                TrRouteBundle.save(
                    vm.trRoute,
                    function (response) {
                        vm.isUpdateProgress = true;
                        if (bool) {
                            vm.updateProgress = 1;
                            assetsLinking.postLinkAsset(
                                {
                                    entityName: "ROUTE",
                                    entityLayout: "SPREAD",
                                    entityTypeId: response.id,
                                    reqByUserId: vm.userId,
                                    messageType: "ASSET_LINK",
                                },
                                function (responseLink) {
                                    vm.trRoute.tempId = response.id;
                                    vm.entityId = responseLink.id;

                                    vm.updateProgress = 12;

                                },
                                function (err) {
                                    clearInterval(vm.assetLinkInterval);
                                }
                            );
                        } else {
                            $state.go("tr-route-plan");
                            vm.isSaving = false;
                        }
                    },
                    onSaveError
                );
            }
        }

        function onSaveSuccess(result) {
            $state.go("tr-route-plan");
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.showRingCreation = false;
        function callAssetLink() {
            assetsLinking.linkAsset(
                function (responseLink) {
                    var temp = responseLink.find(function (item) {
                        return item.entityTypeId == vm.trRoute.id;
                    });

                    if (temp != undefined) {
                        if (temp.messageStatus == "COMPLETE") {
                            vm.showRingCreation = true;
                        }
                    }
                },
                function (err) { }
            );
        }

        function selectedGroup(value) {
            var input = document.getElementById("field_assignedToUser");
            input.value = "";
            vm.hideUser = false;
        }
        function filterActivatedUser() {
            if (
                vm.trRoute.assignedToUser != null &&
                vm.trRoute.assignedToUser != "" &&
                vm.trRoute.assignedToUser != "." &&
                !angular.isUndefined(vm.trRoute.assignedToUser)
            ) {
                $('input[name="assignedToUser"]').keyup(function () {
                    vm.user = $(this).val();
                });
                ActivatedUserSearch.query(
                    {
                        userId: vm.trRoute.groups[0].id,
                        user: vm.user,
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    data.forEach(function (users) {
                        vm.assignedUsers.push(users.login);
                    });
                    vm.activatedusers = data;

                    angular.forEach(vm.activatedusers, function (value, key) {
                        usersMap[value.login] = value.id;
                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                Math.cos(degrees_to_radians(lat2)) *
                Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }
        $(document).on("change", "input", function () {
            var dataList = $("datalist");
            if (dataList.length > 0) {
                var options = dataList[0].options;
                for (var i = 0; i < options.length; i++) {
                    if (options[i].value == $(this).val()) {
                        if (vm.assignedUsers.includes($(this).val())) {
                            vm.validUser = false;
                        } else {
                            vm.validUser = true;
                        }
                        break;
                    }
                }
            }
        });

        vm.openImportExcel = function () {
            $(":file").filestyle({
                buttonBefore: true,
                buttonText: "Browse File",
            });

            vm.importxl = /^(.*?)\.(xlsx)$/;
            $("#importExcelFixed").show();
            $(":file").filestyle("clear");
        };

        vm.closeImportExcelFixedModal = function () {
            $("#importExcelFixed").removeClass("in");
            $(".modal-backdrop").remove();
            $("#importExcelFixed").hide();
        }

        vm.openImportKml = function () {
            $(":file").filestyle({
                buttonBefore: true,
                buttonText: "Browse File",
            });

            vm.importkml = /^(.*?)\.(kml)$/;
            $("#importKml").show();
            $(":file").filestyle("clear");
        };

        vm.closeImportKmlModal = function () {
            $("#importKml").removeClass("in");
            $(".modal-backdrop").remove();
            $("#importKml").hide();
        }

        var getFile, formData;
        vm.uploadFixedAssets = function () {
            getFile = document.getElementById("uploadfileAssetFixed").files[0];
            formData = new FormData();
            formData.append("file", getFile);

            FixedAssetExcelUpload.assetupload(
                vm.trRoute.id,
                formData,
                function (response) {
                    storeAssets = [];
                    vm.mappedAssetsList = [];
                    vm.success = response.status == 200 ? "success" : "";
                    if (vm.success) {
                        setTimeout(function () {
                            vm.success = "";
                            vm.closeImportExcelFixedModal();
                            // vm.closeModal("importExcelFixed");
                            vm.isSaving = false;
                        }, 500);
                    }

                    if (response.data.length) {
                        vm.showSaveButton = true;
                        vm.isDisableNext = true;

                        vm.tempStoreNodes = [];
                        vm.storeFixedResponse = response.data;
                        locations.importMap.setCenter({
                            lat: vm.storeFixedResponse[0].assetCoordinates[0].latitude,
                            lng: vm.storeFixedResponse[0].assetCoordinates[0].longitude,
                        });

                        vm.storeFixedResponse.forEach(function (each, index) {
                            each.isChecked = true;
                            each.inGraph = true;
                            each.minCost = true;

                            vm.mappedAssetsList.push(each);
                            vm.mappedAssetsListImport.push(each);

                            if (each.name && each.assetCoordinates) {
                                if (each.assetType.name == "GP") {
                                    each.assetTypeAttributeValues.forEach(function (
                                        value,
                                        index
                                    ) {
                                        if (value.assetTypeAttribute.name == "GP Status") {
                                            if (value.attributeValue == "Not Connected") {
                                                each.isConnected = false;
                                            }
                                        }
                                    });
                                } else {
                                    each.isConnected = true;
                                }
                                if (each.isConnected == null) {
                                    each.isConnected = false;
                                }
                                vm.tempStoreNodes.push({
                                    name: each.name,
                                    assetCoordinates: [
                                        {
                                            latitude: each.assetCoordinates[0].latitude,
                                            longitude: each.assetCoordinates[0].longitude,
                                        },
                                    ],
                                    isConnected: each.isConnected,
                                    assetTypeName: each.assetType.name,
                                    block: each.block,
                                    district: each.district,
                                    state: each.state,
                                    isBlockHQ: each.isBlockHQ,
                                });

                                drawMarkers(each, locations.importMap, index);
                            }
                        });
                    }
                }
            );
        };

        var getKmlFile, formKmlData;
        vm.uploadKmlAssets = function () {
            getKmlFile = document.getElementById("uploadkmlfileAsset").files[0];
            formKmlData = new FormData();
            formKmlData.append("assettype", vm.importkmlassettype.name);
            formKmlData.append("isexisting", vm.importkmlexisting);
            formKmlData.append("routeBundleId", vm.trRoute.id);
            formKmlData.append("file", getKmlFile);

            AssetUpload.assetupload(formKmlData, function (response, headers) {
                if (response.status == 200) {
                    setTimeout(function () {
                        vm.success = "";
                        vm.closeImportKmlModal();
                        // vm.closeModal("importExcelFixed");
                        vm.isSaving = false;
                    }, 1000);
                    if (vm.importkmlassettype.layout == 'FIXED') {


                        if (response.data.length) {
                            vm.showSaveButton = true;
                            vm.isDisableNext = true;


                            vm.storeFixedResponse = response.data;
                            locations.importMap.setCenter({
                                lat: vm.storeFixedResponse[0].assetCoordinates[0].latitude,
                                lng: vm.storeFixedResponse[0].assetCoordinates[0].longitude,
                            });

                            vm.storeFixedResponse.forEach(function (each, index) {
                                each.isChecked = true;
                                each.inGraph = true;
                                each.minCost = true;
                                if (each.assetType.name == "OLT") {
                                    each.isBlockHQ = true;
                                    each.isConnected = true;
                                }
                                vm.mappedAssetsList.push(each);
                                vm.mappedAssetsListImport.push(each);
                                if (each.assetType.name == "GP") {
                                    each.assetTypeAttributeValues.forEach(function (
                                        value,
                                        index
                                    ) {
                                        if (value.assetTypeAttribute.name == "GP Status") {
                                            if (value.attributeValue == "Not Connected") {
                                                each.isConnected = false;
                                            }
                                        }
                                    });
                                } else if (each.assetType.name == "OLT") {
                                    each.isBlockHQ = true;
                                    each.isConnected = true;
                                } else {
                                    each.isConnected = true;
                                }

                                if (each.isConnected == null) {
                                    each.isConnected = false;
                                }
                                each.isConnected = vm.importkmlexisting;
                                if (each.name && each.assetCoordinates) {
                                    vm.tempStoreNodes.push({
                                        name: each.name,
                                        assetCoordinates: [
                                            {
                                                latitude: each.assetCoordinates[0].latitude,
                                                longitude: each.assetCoordinates[0].longitude,
                                            },
                                        ],
                                        isConnected: each.isConnected,
                                        assetTypeName: each.assetType.name,
                                        block: each.block,
                                        district: each.district,
                                        state: each.state,
                                        isBlockHQ: true,
                                    });

                                    drawMarkers(each, locations.importMap, index);
                                }
                            });
                        }
                    } else if (vm.importkmlassettype.layout == 'SPREAD') {
                        if (response.data.length) {
                            vm.showSaveButton = true;
                            vm.isDisableNext = true;

                            // vm.tempStoreNodes = [];
                            vm.storeSpreadresponse = response.data;
                            locations.importMap.setCenter({
                                lat: vm.storeSpreadresponse[0].assetCoordinates[0].latitude,
                                lng: vm.storeSpreadresponse[0].assetCoordinates[0].longitude,
                            });

                            vm.storeSpreadresponse.forEach(function (each, index) {
                                each.isChecked = true;
                                each.inGraph = true;
                                each.minCost = true;
                                vm.mappedAssetsList.push(each);
                                vm.mappedAssetsListImport.push(each);
                                each.isConnected = vm.importkmlexisting;
                                var assetCoor = [];
                                each.assetCoordinates.forEach(function (latlng) {
                                    assetCoor.push({ lat: latlng.latitude, lng: latlng.longitude });
                                });
                                if (each.name && each.assetCoordinates) {
                                    try {
                                        var polyline = new google.maps.Polyline({
                                            path: assetCoor,
                                            geodesic: true,
                                            strokeColor: '#ff0025',
                                            strokeOpacity: 1.0,
                                            strokeWeight: 2
                                        });
                                        polyline.setMap(locations.importMap);
                                        vm.importedSpread.push(polyline);
                                    } catch (error) {
                                        console.log(error);
                                    }

                                }
                            });
                        }
                    }
                }
                if (response.status == 400) {
                    vm.success = null;
                    vm.error = 'error';
                    vm.closeImportKmlModal();
                }
            });
        };

        function addMarker(location, name, isConnected) {
            infowindow.close();
            var markerText;

            if (markersConnect.length == 0) {
                tempObject.source = location;
                tempObject.srcName = name;
                markerText = labelFrom;

            } else if (markersConnect.length == 1) {
                markerText = labelTo;
                tempObject.destination = location;
                tempObject.desName = name;

                callDirectionApi(
                    {
                        source: tempObject.source,
                        destination: tempObject.destination,
                        sourceName: tempObject.srcName,
                        destinationName: tempObject.desName,
                        isConnected: false,
                    },
                    true
                );
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: markerText,
                },
            });

            // Add the marker to the markers array
            markersConnect.push(marker);
        }

        function clearMarkers() {
            markersConnect.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the markers array
            markersConnect = [];
        }

        var directionsService;
        vm.storeDirectionLatlngs = [];
        vm.tempCycleAssets = [];
        directionsService = new google.maps.DirectionsService();
        vm.storeLocations = [];
        var num = 0;
        var tempShortestPath = [];

        vm.showPathsClicked = false;

        vm.showPaths = function () {
            if (!vm.showPathsClicked) {

                getConnectedNodes.postAdjacency(
                    vm.tempStoreNodes,
                    function (response) {
                        if (response.length) {
                            vm.storeLocations = [];
                            response.forEach(function (item) {
                                item.destinationNode.forEach(function (eachDestination) {
                                    var isConnected = false;

                                    if (
                                        item.sourceNode.isConnected &&
                                        eachDestination.isConnected
                                    ) {
                                        isConnected = true;
                                    }
                                    if (vm.storeSpreadresponse.length > 0) {
                                        var storeSpreadFound = false;
                                        for (var i = 0; i < vm.storeSpreadresponse.length; i++) {
                                            var existingSpread = vm.storeSpreadresponse[i].name;
                                            vm.SpreadDataDuplicateCheck.push(existingSpread);
                                            var assetName = existingSpread.split(" TO ");
                                            var assetSourceName = assetName[0];
                                            var assetDestName = assetName[1];
                                            if (
                                                (assetSourceName === item.sourceNode.name && assetDestName === eachDestination.name) ||
                                                (assetSourceName === eachDestination.name && assetDestName === item.sourceNode.name)
                                            ) {
                                                storeSpreadFound = true;
                                                break;
                                            }
                                        }
                                        if (!storeSpreadFound) {
                                            vm.SpreadDataDuplicateCheck.push(item.sourceNode.name + " TO " + eachDestination.name);
                                            vm.storeLocations.push({
                                                source: new google.maps.LatLng(
                                                    item.sourceNode.assetCoordinates[0].latitude,
                                                    item.sourceNode.assetCoordinates[0].longitude
                                                ),
                                                destination: new google.maps.LatLng(
                                                    eachDestination.assetCoordinates[0].latitude,
                                                    eachDestination.assetCoordinates[0].longitude
                                                ),
                                                sourceName: item.sourceNode.name,
                                                destinationName: eachDestination.name,
                                                isConnected: isConnected,
                                                inGraph: true,
                                                minCost: true,
                                                block: item.sourceNode.block,
                                                district: item.sourceNode.district,
                                                state: item.sourceNode.state,
                                            });
                                        }
                                    } else {
                                        vm.storeLocations.push({
                                            source: new google.maps.LatLng(
                                                item.sourceNode.assetCoordinates[0].latitude,
                                                item.sourceNode.assetCoordinates[0].longitude
                                            ),
                                            destination: new google.maps.LatLng(
                                                eachDestination.assetCoordinates[0].latitude,
                                                eachDestination.assetCoordinates[0].longitude
                                            ),
                                            sourceName: item.sourceNode.name,
                                            destinationName: eachDestination.name,
                                            isConnected: isConnected,
                                            inGraph: true,
                                            minCost: true,
                                            block: item.sourceNode.block,
                                            district: item.sourceNode.district,
                                            state: item.sourceNode.state,
                                        });
                                    }

                                });
                            });

                            vm.storeLocations.forEach(function (location) {
                                callDirectionApi1(location);
                            });
                        }
                    });
                vm.showPathsClicked = true;
            }
        };
        vm.showLinerPths = false;
        vm.showLinerPaths = function () {
            if (!vm.showLinerPths) {
                getConnectedNodes.postAdjacency(
                    vm.tempStoreNodes,
                    function (response) {
                        if (response.length) {
                            vm.storePoints = [];
                            response.forEach(function (item) {
                                item.destinationNode.forEach(function (eachDestination) {
                                    var isConnected = false;

                                    if (
                                        item.sourceNode.isConnected &&
                                        eachDestination.isConnected
                                    ) {
                                        isConnected = true;
                                    }

                                    vm.storePoints.push({
                                        source: new google.maps.LatLng(
                                            item.sourceNode.assetCoordinates[0].latitude,
                                            item.sourceNode.assetCoordinates[0].longitude
                                        ),
                                        destination: new google.maps.LatLng(
                                            eachDestination.assetCoordinates[0].latitude,
                                            eachDestination.assetCoordinates[0].longitude
                                        ),
                                        sourceName: item.sourceNode.name,
                                        destinationName: eachDestination.name,
                                        isConnected: isConnected,
                                        inGraph: true,
                                        minCost: true,
                                        block: item.sourceNode.block,
                                        district: item.sourceNode.district,
                                        state: item.sourceNode.state,
                                    });
                                });
                            });
                            vm.storePoints.forEach(function (location) {
                                callDirectionApi2(location);
                            });
                        }
                    });
                vm.showLinerPths = true
            }
        }


        vm.showDirection = function () {
            var OltData = [];
            OltData.push(vm.oltAssetDetails);
            if (!vm.showDirectionClicked && OltData.length > 0) {
                OltData.forEach(function (asset) {
                    getConnectedNodes.postSuggestPlan(asset.name, vm.tempStoreNodes, function (Response) {
                        if (Response.length) {
                            vm.storePlanLocations = [];
                            Response.forEach(function (itemPlan) {
                                if (itemPlan.destinationNode.length) {
                                    itemPlan.destinationNode.forEach(function (eachDestination) {
                                        var found1 = false;
                                        for (var i = 0; i < vm.SpreadDataDuplicateCheck.length; i++) {
                                            var existingLocation = vm.SpreadDataDuplicateCheck[i];
                                            var assetName = existingLocation.split(" TO ");
                                            var assetSourceName = assetName[0];
                                            var assetDestName = assetName[1];
                                            if (
                                                (assetSourceName === itemPlan.sourceNode.name && assetDestName === eachDestination.name) ||
                                                (assetSourceName === eachDestination.name && assetDestName === itemPlan.sourceNode.name)
                                            ) {
                                                found1 = true;
                                                break;
                                            }
                                        }
                                        if (!found1) {
                                            vm.storePlanLocations.push({
                                                source: new google.maps.LatLng(
                                                    itemPlan.sourceNode.assetCoordinates[0].latitude,
                                                    itemPlan.sourceNode.assetCoordinates[0].longitude),
                                                destination: new google.maps.LatLng(
                                                    eachDestination.assetCoordinates[0].latitude,
                                                    eachDestination.assetCoordinates[0].longitude),
                                                sourceName: itemPlan.sourceNode.name,
                                                destinationName: eachDestination.name,
                                                isConnected: false,
                                                inGraph: false,
                                                block: eachDestination.block,
                                                district: eachDestination.district,
                                                state: eachDestination.state,
                                            });

                                        }
                                    });
                                }
                            });
                            vm.storePlanLocations.forEach(function (location) {
                                callDirectionApi1(location, false, false);

                            });



                        }
                    });
                });
                vm.showDirectionClicked = true;
            } else {
                alert("please select  OLT")
            }
        }

        vm.notConnectedPaths = [];
        vm.loactionNot = [];
        vm.dropdownItems = [];
        vm.activeRoutes = [];

        function processDestination(eachDestination, source) {
            if (!eachDestination.assetCoordinates || eachDestination.assetCoordinates.length === 0) {
                return;
            }

            var destinationName = eachDestination.name || "Unknown";
            var destination = {
                name: destinationName,
                lat: parseFloat(eachDestination.assetCoordinates[0].latitude),
                lng: parseFloat(eachDestination.assetCoordinates[0].longitude)
            };

            var locationObj = {
                source: source,
                destination: destination,
                isConnected: false,
                inGraph: true,
                minCost: true,
                block: eachDestination.block,
                district: eachDestination.district,
                state: eachDestination.state
            };
            vm.loactionNot.push(locationObj);

            vm.dropdownItems.push({
                display: source.name + " → " + destination.name,
                source: source,
                destination: destination,
                selected: false
            });
        }
        function processSource(sourceKey, destinations) {
            var sourceNameMatch = sourceKey.match(/name=([^,]+)/);
            var sourceMatch = sourceKey.match(/latitude=([\d.]+), longitude=([\d.]+)/);

            if (!sourceMatch) {
                return; // Skip this source entirely.
            }

            var sourceName = sourceNameMatch ? sourceNameMatch[1].trim() : "Unknown";
            var source = {
                name: sourceName,
                lat: parseFloat(sourceMatch[1]),
                lng: parseFloat(sourceMatch[2])
            };

            if (!destinations || destinations.length === 0) {
                return;
            }

            for (var j = 0; j < destinations.length; j++) {
                processDestination(destinations[j], source);
            }
        }

        vm.showNotConnected = function () {
            if (vm.tempStoreNodes.length > 0) {
                getConnectedNodes.postSuggestNotConnectedPath(vm.trRoute.id, vm.tempStoreNodes, function (response) {
                    if (!response || typeof response !== "object") {
                        return;
                    }
                    if (vm.dropdownItems.length !== 0) {
                        return;
                    }
                    vm.notConnectedPaths = [];
                    for (var key in response) {
                        if (response.hasOwnProperty(key)) {
                            vm.notConnectedPaths.push([key, response[key]]);
                        }
                    }

                    if (vm.notConnectedPaths.length === 0) {
                        return;
                    }

                    vm.loactionNot = [];
                    vm.dropdownItems = [];
                    for (var i = 0; i < vm.notConnectedPaths.length; i++) {
                        var pair = vm.notConnectedPaths[i];
                        var sourceKey = pair[0];
                        var destinations = pair[1];
                        processSource(sourceKey, destinations);
                    }
                });
            }
        };

        vm.showNotConnected();
        vm.clearConnected = function () {
            vm.refreshPage()
        };


        vm.connectSelectedPaths = function () {
            vm.nearByDestination = {}
            vm.nearBySource = {}
            vm.clearConnected();
            for (var i = 0; i < vm.dropdownItems.length; i++) {
                var item = vm.dropdownItems[i];
                if (item.selected) {
                    vm.fetchRoute(item.source, item.destination);
                }
            }
        };

        vm.reverseSelected = function () {
            vm.clearConnected();
            for (var i = 0; i < vm.dropdownItems.length; i++) {
                var item = vm.dropdownItems[i];
                if (item.selected) {
                    vm.fetchRoute(item.destination, item.source);
                }
            }
        };

        vm.fetchRoute = function (source, destination) {
            var request = {
                origin: new google.maps.LatLng(source.lat, source.lng),
                destination: new google.maps.LatLng(destination.lat, destination.lng),
                travelMode: google.maps.TravelMode.DRIVING,
                avoidTolls: true,
                avoidHighways: true,
                provideRouteAlternatives: true
            };

            directionsService.route(request, function (response, status) {
                if (status === google.maps.DirectionsStatus.OK) {
                    var responsePaths = response.routes;
                    responsePaths.forEach(function (pathVal, index) {
                        if (index < 3) {
                            vm.fixedAssets = [];
                            var route = pathVal;
                            var legs = route.legs;

                            var polylinePathPoints = [];
                            for (var i = 0; i < legs.length; i++) {
                                var steps = legs[i].steps;
                                for (var j = 0; j < steps.length; j++) {
                                    var nextSegment = steps[j].path;
                                    for (var k = 0; k < nextSegment.length; k++) {
                                        polylinePathPoints.push(nextSegment[k]);
                                    }
                                }
                            }
                            polylinePathPoints.forEach(function (value) {
                                var coordinates = {};
                                coordinates.lat = value.lat();
                                coordinates.lng = value.lng();
                                vm.fixedAssets.push(coordinates);
                            });
                            drawPolylineForSelectedPath(
                                source.name + " To " + destination.name,
                                vm.fixedAssets,
                                locations.map,
                                index
                            );
                        }
                    });
                } else {
                    console.error("Directions request failed due to " + status);
                }
            });
        };


        function callDirectionApi(location, isSwitch, isCycle) {
            var assetDetails = JSON.parse(
                '{"id":null,"name":"PlannnedRoute1","description":"","createDate":null,"updateDate":null,"userId":null,"assetType":{"id":14463282,"name":"Planned Route","description":"Planned Route","layout":"SPREAD","colorcode":"BLUE","userId":10008413,"createDate":1742368347206,"updateDate":1742906068596,"createdBy":"fiberifyinc","transparency":100,"lineWidth":100,"authorities":["ROLE_ASSISTANT_MANAGER","ROLE_PATROLLER","ROLE_USER_ADMIN","ROLE_CITY_MANAGER","ROLE_FRT","ROLE_CITY_PLANNER","ROLE_NETWORK_ENGINEER"],"assetTypeAttributes":[{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false}],"assetTypeReferenceAttributes":[],"imagePath":null,"zoomLevel":12,"zoomLevelLabel":null,"isSeniorElement":null},"assetTypeAttributeValues":[{"assetTypeAttribute":{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""}],"assetCoordinates":[{"latitude":12.967849262505046,"longitude":77.5883731118908},{"latitude":12.965841854217818,"longitude":77.59008972566033},{"latitude":12.961994276406937,"longitude":77.59208869746462}],"assetImport":false,"phase":"ROLLOUT","assetImages":[],"groups":[{"id":10008423}],"ownedBy":[],"assetReferenceAttributes":[]}'
            );

            var request = {
                origin: location.source,
                destination: location.destination,
                travelMode: "DRIVING",
                avoidTolls: true,
                avoidHighways: true,
            };

            if (isSwitch) {
                request.provideRouteAlternatives = true;
            }
            vm.allPaths = [];
            directionsService
                .route(request)
                .then(function (result) {
                    if (result.status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = result.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                var distance = pathVal.legs[0].distance.value;
                                distance = distance / 1000;

                                var tempColor = "red";
                                var tempConnected = "Connected";

                                if (isCycle) {
                                    tempColor = "#FFD700";
                                    tempConnected = "Not Connected";
                                    location.isConnected = false;
                                    // } else if (!location.isConnected) {
                                } else if (!location.isExisting) {
                                    tempColor = "#00A36C";
                                    tempConnected = "Not Connected";
                                }

                                if(!location.isUsed && location.isExisting){
                                    tempColor = "#FFAE42"
                                }
                                if (pathVal.overview_path.length > 0) {
                                    var assetValue = assetDetails;
                                    assetValue.name =
                                        location.sourceName + " to " + location.destinationName;
                                    var assetCoor = [];
                                    pathVal.overview_path.forEach(function (val, index) {
                                        assetCoor.push({
                                            latitude: val.lat(),
                                            longitude: val.lng(),
                                        });
                                    });

                                    assetValue.assetCoordinates = assetCoor;
                                    assetValue.isChecked = true;
                                    assetValue.isConnected = location.isConnected;
                                    assetValue.isCycle = false;
                                    assetValue.inGraph = location.inGraph;
                                    assetValue.minCost = location.minCost;
                                    assetValue.block = location.block;
                                    assetValue.state = location.state;
                                    assetValue.district = location.district;

                                    assetValue.strStatus = tempConnected;
                                    assetValue.assetLength = distance;

                                    if (isCycle) {
                                        assetValue.isCycle = true;
                                        vm.tempCycleAssets.push(assetValue);
                                    }

                                    vm.mappedAssetsList.push(assetValue);
                                    vm.mappedAssetsListImport.push(assetValue);
                                }

                                if (markersConnect.length == 2) {
                                    clearMarkers();
                                }

                                vm.allPaths.push({
                                    assetValue: assetValue,
                                    tempColor: tempColor,
                                    path: pathVal.overview_path,
                                });
                            }
                        });
                    }
                })
                .catch(function (e) {
                    console.log("Directions request failed due to " + e);
                });
        }

        function callDirectionApi1(location, isSwitch, isCycle) {
            var assetDetails = JSON.parse(
                '{"id":null,"name":"PlannnedRoute1","description":"","createDate":null,"updateDate":null,"userId":null,"assetType":{"id":14463282,"name":"Planned Route","description":"Planned Route","layout":"SPREAD","colorcode":"BLUE","userId":10008413,"createDate":1742368347206,"updateDate":1742906068596,"createdBy":"fiberifyinc","transparency":100,"lineWidth":100,"authorities":["ROLE_ASSISTANT_MANAGER","ROLE_PATROLLER","ROLE_USER_ADMIN","ROLE_CITY_MANAGER","ROLE_FRT","ROLE_CITY_PLANNER","ROLE_NETWORK_ENGINEER"],"assetTypeAttributes":[{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false}],"assetTypeReferenceAttributes":[],"imagePath":null,"zoomLevel":12,"zoomLevelLabel":null,"isSeniorElement":null},"assetTypeAttributeValues":[{"assetTypeAttribute":{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""}],"assetCoordinates":[{"latitude":12.967849262505046,"longitude":77.5883731118908},{"latitude":12.965841854217818,"longitude":77.59008972566033},{"latitude":12.961994276406937,"longitude":77.59208869746462}],"assetImport":false,"phase":"ROLLOUT","assetImages":[],"groups":[{"id":10008423}],"ownedBy":[],"assetReferenceAttributes":[]}'
            );
            var request = {
                origin: location.source,
                destination: location.destination,
                travelMode: "DRIVING",
                avoidTolls: true,
                avoidHighways: true,
            };

            if (isSwitch) {
                request.provideRouteAlternatives = true;
            }
            vm.allPath = [];
            directionsService
                .route(request)
                .then(function (result) {
                    if (result.status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = result.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                var distance = pathVal.legs[0].distance.value;
                                distance = distance / 1000;

                                var tempColor = "#00A36C";
                                var tempConnected = "Connected";

                                if (isCycle) {
                                    tempColor = "#FFD700";
                                    tempConnected = "Not Connected";
                                    location.isConnected = false;
                                    // } else if (!location.isConnected) {
                                } else if (!location.isExisting) {
                                    tempColor = "#00A36C";
                                    tempConnected = "Not Connected";
                                }
                                if(!location.isUsed && location.isExisting){
                                    tempColor = "#FFAE42"
                                }
                                if (pathVal.overview_path.length > 0) {
                                    var assetValue = assetDetails;
                                    assetValue.name =
                                        location.sourceName + " to " + location.destinationName;
                                    var assetCoor = [];
                                    pathVal.overview_path.forEach(function (val, index) {
                                        assetCoor.push({
                                            latitude: val.lat(),
                                            longitude: val.lng(),
                                        });

                                    });
                                    assetValue.connectedNode1 = location.sourceName;
                                    assetValue.connectedNode2 = location.destinationName;
                                    assetValue.assetCoordinates = assetCoor;
                                    assetValue.isChecked = true;
                                    assetValue.isConnected = location.isConnected;
                                    assetValue.isCycle = false;
                                    assetValue.inGraph = location.inGraph;
                                    assetValue.minCost = location.minCost;
                                    assetValue.block = location.block;
                                    assetValue.state = location.state;
                                    assetValue.district = location.district;

                                    assetValue.strStatus = tempConnected;
                                    assetValue.assetLength = distance;

                                    if (isCycle) {
                                        assetValue.isCycle = true;
                                        vm.tempCycleAssets.push(assetValue);
                                    }

                                    vm.mappedAssetsList.push(assetValue);
                                    vm.mappedAssetsListImport.push(assetValue);
                                }

                                if (markersConnect.length == 2) {
                                    clearMarkers();
                                }
                                drawPolyLines(
                                    assetValue,
                                    tempColor,
                                    pathVal.overview_path,
                                    locations.importMap
                                );
                                vm.allPath.push({
                                    assetValue: assetValue,
                                    tempColor: tempColor,
                                    path: pathVal.overview_path,
                                })
                            }
                        });
                    }
                })
                .catch(function (e) {
                    console.log("Directions request failed due to " + e);
                });
        }
        function callDirectionApi2(location, isSwitch, isCycle) {
            var assetDetails = JSON.parse(
                '{"id":null,"name":"PlannnedRoute1","description":"","createDate":null,"updateDate":null,"userId":null,"assetType":{"id":14463282,"name":"Planned Route","description":"Planned Route","layout":"SPREAD","colorcode":"BLUE","userId":10008413,"createDate":1742368347206,"updateDate":1742906068596,"createdBy":"fiberifyinc","transparency":100,"lineWidth":100,"authorities":["ROLE_ASSISTANT_MANAGER","ROLE_PATROLLER","ROLE_USER_ADMIN","ROLE_CITY_MANAGER","ROLE_FRT","ROLE_CITY_PLANNER","ROLE_NETWORK_ENGINEER"],"assetTypeAttributes":[{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false}],"assetTypeReferenceAttributes":[],"imagePath":null,"zoomLevel":12,"zoomLevelLabel":null,"isSeniorElement":null},"assetTypeAttributeValues":[{"assetTypeAttribute":{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""}],"assetCoordinates":[{"latitude":12.967849262505046,"longitude":77.5883731118908},{"latitude":12.965841854217818,"longitude":77.59008972566033},{"latitude":12.961994276406937,"longitude":77.59208869746462}],"assetImport":false,"phase":"ROLLOUT","assetImages":[],"groups":[{"id":10008423}],"ownedBy":[],"assetReferenceAttributes":[]}'
            );
            var request = {
                origin: location.source,
                destination: location.destination,
                travelMode: "DRIVING",
                avoidTolls: true,
                avoidHighways: true,
            };

            if (isSwitch) {
                request.provideRouteAlternatives = true;
            }
            vm.allPath = [];
            directionsService
                .route(request)
                .then(function (result) {
                    if (result.status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = result.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                var distance = pathVal.legs[0].distance.value;
                                distance = distance / 1000;

                                var tempColor = "#00A36C";
                                var tempConnected = "Connected";

                                if (isCycle) {
                                    tempColor = "#FFD700";
                                    tempConnected = "Not Connected";
                                    location.isConnected = false;
                                    // } else if (!location.isConnected) {
                                } else if (!location.isExisting) {
                                    tempColor = "#00A36C";
                                    tempConnected = "Not Connected";
                                }
                                if(!location.isUsed && location.isExisting){
                                    tempColor = "#FFAE42"
                                }
                                if (pathVal.overview_path.length > 0) {
                                    var assetValue = assetDetails;
                                    assetValue.name =
                                        location.sourceName + " to " + location.destinationName;
                                    var assetCoor = [];
                                    pathVal.overview_path.forEach(function (val, index) {
                                        assetCoor.push({
                                            latitude: val.lat(),
                                            longitude: val.lng(),
                                        });

                                    });
                                    assetValue.connectedNode1 = location.sourceName;
                                    assetValue.connectedNode2 = location.destinationName;
                                    assetValue.assetCoordinates = assetCoor;
                                    assetValue.isChecked = true;
                                    assetValue.isConnected = location.isConnected;
                                    assetValue.isCycle = false;
                                    assetValue.inGraph = location.inGraph;
                                    assetValue.minCost = location.minCost;
                                    assetValue.block = location.block;
                                    assetValue.state = location.state;
                                    assetValue.district = location.district;

                                    assetValue.strStatus = tempConnected;
                                    assetValue.assetLength = distance;

                                    if (isCycle) {
                                        assetValue.isCycle = true;
                                        vm.tempCycleAssets.push(assetValue);
                                    }

                                    vm.mappedAssetsList.push(assetValue);
                                    vm.mappedAssetsListImport.push(assetValue);
                                }

                                if (markersConnect.length == 2) {
                                    clearMarkers();
                                }

                                drawPolyLines(
                                    assetValue,
                                    tempColor,
                                    pathVal.overview_path,
                                    locations.map
                                );
                                vm.allPath.push({
                                    assetValue: assetValue,
                                    tempColor: tempColor,
                                    path: pathVal.overview_path,
                                })
                            }
                        });
                    }
                })
                .catch(function (e) {
                    console.log("Directions request failed due to " + e);
                });
        }
        function simplify(path, tolerance) {
            if (!path || path.length < 3) return path;

            // Find the point with the maximum distance
            var maxDistance = 0;
            var maxIndex = 0;
            var end = path.length - 1;

            for (var i = 1; i < end; i++) {
                var distance = perpendicularDistance(path[i], path[0], path[end]);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    maxIndex = i;
                }
            }

            var simplified;

            // If the maximum distance is greater than the tolerance, recursively simplify
            if (maxDistance > tolerance) {
                var simplified1 = simplify(path.slice(0, maxIndex + 1), tolerance);
                var simplified2 = simplify(
                    path.slice(maxIndex, path.length),
                    tolerance
                );

                // Concatenate the two simplified lists (excluding the duplicated point)
                simplified = simplified1.concat(simplified2.slice(1));
            } else {
                simplified = [path[0], path[end]];
            }

            return simplified;
        }

        // Calculate the perpendicular distance from a point to a line segment
        function perpendicularDistance(point, start, end) {
            var x = point.lng();
            var y = point.lat();
            var x1 = start.lng();
            var y1 = start.lat();
            var x2 = end.lng();
            var y2 = end.lat();

            var A = x - x1;
            var B = y - y1;
            var C = x2 - x1;
            var D = y2 - y1;

            var dot = A * C + B * D;
            var len_sq = C * C + D * D;
            var param = dot / len_sq;

            var xx, yy;

            if (param < 0 || (x1 == x2 && y1 == y2)) {
                xx = x1;
                yy = y1;
            } else if (param > 1) {
                xx = x2;
                yy = y2;
            } else {
                xx = x1 + param * C;
                yy = y1 + param * D;
            }

            var dx = x - xx;
            var dy = y - yy;
            return Math.sqrt(dx * dx + dy * dy);
        }

        locations.map = new google.maps.Map(
            document.getElementById("map_canvas_planning"),
            myOption(10, latlngs)
        );

        function getRandomColor() {
            var letters = "0123456789ABCDEF";
            var color = "#";
            do {
                color = "#";
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
            } while (color === "#FFFFFF"); // Exclude white color

            return color;
        }

        $scope.togglePolylines = function () {
            var temp = cyclePolylines;
            if ($scope.isShowCycles) {
                for (var i = 0; i < temp.length; i++) {
                    temp[i].setOptions({
                        strokeColor: "#FFD700",
                    });
                    temp[i].setMap(locations.importMap);
                }
                vm.mappedAssetsListImport = vm.mappedAssetsListImport.concat(
                    vm.tempCycleAssets
                );

                if (!vm.trRoute.tempId) {
                    vm.mappedAssetsList = vm.mappedAssetsListImport;
                }

                refreshPage();
            } else {
                vm.mappedAssetsListImport = vm.mappedAssetsListImport.filter(function (
                    element
                ) {
                    return !element.isCycle;
                });

                if (!vm.trRoute.tempId) {
                    vm.mappedAssetsList = vm.mappedAssetsListImport;
                }

                clearPolylines(cyclePolylines);
                refreshPage();
            }
        };

        $scope.isShowMinCost = false;
        $scope.isShowMinCostText = "Show";
        $scope.toggleMinCost = function () {
            $scope.isAnomaly = false;
            $scope.isAnomalyText = "Show";

            $scope.isShowMinCost = !$scope.isShowMinCost;
            if ($scope.isShowMinCost) {
                $scope.isShowMinCostText = "Hide";
                for (var i = 0; i < vm.layerItems.length; i++) {
                    vm.layerItems[i].selected = true;
                    vm.selectedLayers[vm.layerItems[i].name] = true;
                }
                var temp = minCostPolylines;
                initPlanningMap();
                for (var i = 0; i < temp.length; i++) {
                    temp[i].setMap(locations.map);
                }
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                        drawMarkers(vm.mappedAssetsList[i], locations.map, i);
                    }
                }
            } else {
                $scope.isShowMinCostText = "Show";
                minCostPolylines = [];
                refreshPage();
            }
        };

        function clearPolylines(arr) {
            for (var i = 0; i < arr.length; i++) {
                arr[i].setMap(null);
            }
        }

        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                arr.push(marker);
            });
        }
        var polyLines = []
        function drawPolyLines(asset, color, path, map, isRingTopology) {
            tempCount++;
            var polyline;
            var tmpStatus = asset.strStatus
                ? "<br><b> Status </b><br>" + asset.strStatus
                : "";

            var distance = asset.assetLength
                ? "<br><b> Distance </b><br>" + Number(asset.assetLength).toFixed(2) + " km"
                : "";

            blockPolyLine = asset.block ? "<br><b> Block </b><br>" + asset.block : "";

            var strokeWeight = asset.isCycle ? 2 : 3;
            var strokeOpacity = asset.isCycle ? 0.7 : 0.7;

            if (color == "#0050B5") {
                strokeWeight = 3;
                strokeOpacity = 0.2;
            }
            if (color == "red") {
                strokeWeight = 15;
                strokeOpacity = 0.6;
            }

            if (color == "#000000") {
                var lineSymbol = {
                    path: "M 0,-1 0,1",
                    strokeOpacity: 1,
                    scale: 4,
                    strokeColor: "#000000",
                };
                polyline = new google.maps.Polyline({
                    path: path,
                    strokeOpacity: 0,
                    icons: [
                        {
                            icon: lineSymbol,
                            offset: "0",
                            repeat: "20px",
                        },
                    ],
                });
                polyLines.push(polyline);
            } else {
                polyline = new google.maps.Polyline({
                    path: path,
                    geodesic: true,
                    strokeColor: color,
                    strokeOpacity: strokeOpacity,
                    strokeWeight: strokeWeight,
                    block: asset.block,
                });
                polyLines.push(polyline);
            }

            if (isRingTopology) {
                vm.storeRingPolylines.push({
                    polyline: polyline,
                    index: asset.index + 1,
                });
            }

            google.maps.event.addListener(polyline, "click", function (event) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                    if (spreadPoly != null) {
                        spreadPoly.setMap(null);
                    }
                }

                clearTimeout(polylineTimer);

                spreadPoly = new google.maps.Polyline({
                    path: path,
                    strokeColor: "#A938F3",
                    strokeOpacity: 0.6,
                    strokeWeight: 3,
                });

                spreadPoly.setMap(map);

                polylineTimer = setTimeout(function () {
                    if (spreadPoly != null) {
                        spreadPoly.setMap(null);
                        spreadPoly = null;
                    }
                }, 5000);

                var userContent = document.createElement("div"),
                    btnEditAsset,
                    brBreak,
                    btnDeleteAsset,
                    btnCreateSection,
                    btnCommonPath,
                    btnUpdateRoute,
                    btnShowAsset,
                    btnEditAttribute;


                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    "<b> Name </b><br>" +
                    asset.name +
                    tmpStatus +
                    distance +
                    blockPolyLine;
                ("</br></div>");

                if (vm.trRoute.id || vm.trRoute.tempId) {
                    btnDeleteAsset = userContent.appendChild(
                        document.createElement("input")
                    );

                    btnDeleteAsset.type = "button";
                    btnDeleteAsset.value = "Delete";
                    btnDeleteAsset.className = "button";

                    google.maps.event.addDomListener(
                        btnDeleteAsset,
                        "click",
                        function () {
                            vm.deleteAssetModal(asset.name, asset.id);
                        }
                    );

                    btnEditAsset = userContent.appendChild(
                        document.createElement("input")
                    );

                    btnEditAsset.type = "button";
                    btnEditAsset.value = "Edit Asset";
                    btnEditAsset.className = "button";

                    google.maps.event.addDomListener(btnEditAsset, "click", function () {
                        $(":file").filestyle("clear");
                        AssetByID.get(asset.id, function (response) {
                            vm.assetattributevaluesDisplay = response;
                            vm.editAsset(vm.assetattributevaluesDisplay);
                        });
                        //vm.editAsset(asset);
                        //console.log(asset);
                        $scope.$apply();
                    });

                    if ((vm.trRoute.id || vm.trRoute.tempId) && asset.id) {
                        btnCreateSection = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnCreateSection.type = "button";
                        btnCreateSection.value = "Add To Ring";
                        btnCreateSection.className = "button";

                        google.maps.event.addDomListener(
                            btnCreateSection,
                            "click",
                            function () {

                               /* if (!vm.ringRouteAssets.length) {
                                    vm.getRouteSections();
                                }*/
                                vm.addAssetToRingStack(asset);
                                if (openedInfoWindow != undefined) {
                                    openedInfoWindow.close();
                                }
                            }
                        );
                    }
                    if (vm.trRoute.id || vm.trRoute.tempId) {
                        btnShowAsset = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnShowAsset.type = "button";
                        btnShowAsset.value = "Show attributes";
                        btnShowAsset.className = "button";

                        google.maps.event.addDomListener(
                            btnShowAsset,
                            "click",
                            function () {
                                AssetByID.get(asset.id, function (response) {
                                    showAssetAttributesModal(response);
                                });
                            }
                        );
                    }

                    if (vm.trRoute.id || vm.trRoute.tempId) {
                        btnEditAttribute = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnEditAttribute.type = "button";
                        btnEditAttribute.value = "Edit attributes";
                        btnEditAttribute.className = "button";

                        google.maps.event.addDomListener(
                            btnEditAttribute,
                            "click",
                            function () {
                                AssetByID.get(asset.id, function (response) {
                                    vm.editAssetAttributesModal(response);
                                    if (openedInfoWindow != undefined) {
                                        openedInfoWindow.close();
                                    }
                                });
                            }
                        );
                    }
                    if ((vm.trRoute.id || vm.trRoute.tempId) && asset.id) {
                        btnUpdateRoute = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnUpdateRoute.type = "button";
                        btnUpdateRoute.value = "Add to Exist Ring";
                        btnUpdateRoute.className = "button";

                        google.maps.event.addDomListener(
                            btnUpdateRoute,
                            "click",
                            function () {
                                vm.addExistAssetModal(asset);
                                if (openedInfoWindow != undefined) {
                                    openedInfoWindow.close();
                                }
                            }
                        );
                    }
                }
                infowindow.setContent(userContent);

                infowindow.open(map);
                infowindow.setPosition(event.latLng);
                openedInfoWindow = infowindow;
            });

            if (asset.isCycle) {
                cyclePolylines.push(polyline);
            }

            if (asset.minCost) {
                vm.optimalTotalLength += parseFloat(asset.assetLength);
                minCostPolylines.push(polyline);
            }

            if (color == "#000000") {
                anomalyPolylines.push(polyline);
            }

            if (asset.assetLength >= 10) {
                moreThan10KmPolylines.push(polyline);
            }

            polyline.setMap(map);

            if (tempCount == vm.storeLocations.length) {
                vm.isDisableNext = false;
                vm.isShowTotalLengthImport = true;
            }
        }

        function drawMarkers(asset, map, index) {
            if (asset.assetCoordinates.length > 0) {
                var tmpStatus = asset.isConnected
                    ? "<br><b> Status : </b>" + asset.isConnected
                    : "";
                var tempPhase = asset.phase ? "<br><b> Phase : </b>" + asset.phase : "";
                blockMarker = asset.block ? "<br><b> Block : </b>" + asset.block : "";
                vm.blockName = asset.block;
                vm.stateName = asset.state;
                vm.districtName = asset.district;
                iconSize = 27;
               var latitude = parseFloat(asset.assetCoordinates[0].latitude);
               var longitude = parseFloat(asset.assetCoordinates[0].longitude);  
                // var marker = new google.maps.Marker({
                //   position: { lat: latitude, lng: longitude },
                //   map: map,
                //   title: asset.name,
                //   icon: {
                //     scaledSize: new google.maps.Size(iconSize, iconSize),
                //     url: asset.assetType.imagePath,
                //     labelOrigin: new google.maps.Point(25, 40),
                //   },
                // });
                var marker = new google.maps.Marker({
                    position: { lat: latitude, lng: longitude },
                    map: map,
                    title: asset.name,
                    icon: {
                      scaledSize: new google.maps.Size(24, 24),
                      url: asset.assetType.imagePath,
                      anchor: new google.maps.Point(
                          12,24
                      ),
                      labelOrigin: new google.maps.Point(25, 40),
                    },
                  });
                markers.push(marker);
                if (asset.assetType.name === "OLT") {
                    marker.setZIndex(2000);
                } else {
                    marker.setZIndex(1000);
                }
                marker.assetDetails = asset;
                
                // var updateIconSize = function () {
                //     var zoom = map.getZoom();
                //     var newSize = zoom * 2;
                //     var icon = marker.getIcon();
                //     icon.scaledSize = new google.maps.Size(newSize, newSize);
                //     icon.anchor = new google.maps.Point(newSize / 2, newSize / 2);
                //     marker.setIcon(icon);
                // };
function updateMarkerLabelVisibility() {
                    var currentZoom = locations.map.getZoom();
                    if (currentZoom > 12) {
                        if(asset.assetType.name=="GP" || asset.assetType.name=="ONT"){
                            marker.setLabel({
                            color: "red",
                            fontWeight: "bold",
                            fontSize: "12px",
                            text: asset.name,
                            className: "asset_label top-label"
                        });
                        }
                    } else {
                        marker.setLabel(null);
                    }
                    var style = document.createElement('style');
                    style.innerHTML = '.top-label {' +
                        '    position: relative; /* Needed for top positioning */' +
                        '    top: 30px; /* Adjust this value to move the label higher */' +
                        '    left: 0;' +
                        '    transform: translateX(10%); /*center the label*/' +
                        '    white-space: nowrap; /*prevent wrapping*/' +
                        '}';
                    document.head.appendChild(style);
                }
                var updateIconSize = function () {
                    var zoom = map.getZoom();

                    // Define minimum and maximum zoom levels
                    var minZoom = 8;
                    var maxZoom = 21;

                    // Define minimum and maximum icon sizes
                    var minSize = 6;  // Smallest size at zoom 8
                    var maxSize = 60;  // Full size at zoom 21

                    // Compute new size based on zoom level
                    newSizeLevel = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);
                    var assetId = marker.assetDetails.id;

                    if (!assetId) return;

                    var isHighlighted = highlightedMarkers[assetId];
                    var newSize = isHighlighted ? newSizeLevel + 15 : newSizeLevel;
                    var icon = {
                        url: marker.getIcon().url,  // Keep the existing marker image
                        scaledSize: new google.maps.Size(newSize, newSize),  // Only use scaledSize
                    };

                    marker.setIcon(icon);
                };

                // Run updateIconSize once to initialize
                updateIconSize();

                // Listen for zoom changes
                google.maps.event.addListener(map, "zoom_changed", function () {
                    updateIconSize();
                    updateMarkerLabelVisibility()
                });


                google.maps.event.addListener(
                    marker,
                    "click",
                    (function (marker) {
                        var assetDetails = marker.assetDetails;
                        var userContent = document.createElement("div"),
                            btnEditAsset,
                            btnDeleteAsset,
                            btnShowAsset,
                            btnEditAttribute,
                            btnAssetAttach,
                            btnThreePointRef,
                            ADDTORing,
                            btnHighLightOlt,
                            btnSelectOlt,
                            btnNearBy,
                            btnUpdateRoute

                        userContent.innerHTML =
                            '<div class="infoWindowhead">' +
                            assetDetails.id +
                            "<br><b>Name </b> : " +
                            assetDetails.name +
                            '</div><div class="infoWindowContent">' +
                            "<b>Asset Type </b> : " +
                            assetDetails.assetType.name +
                            "<br><b>Latitude </b> : " +
                            assetDetails.assetCoordinates[0].latitude +
                            "<br><b>Longitude </b> : " +
                            assetDetails.assetCoordinates[0].longitude +
                            blockMarker +
                            tempPhase +
                            tmpStatus;
                        "<br>" + "</div><br>";

                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnEditAsset = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnEditAsset.type = "button";
                            btnEditAsset.value = "Edit asset";
                            btnEditAsset.className = "button";

                            google.maps.event.addDomListener(
                                btnEditAsset,
                                "click",
                                function () {
                                    AssetByID.get(assetDetails.id, function (response) {
                                        vm.assetToEdit = response;
                                        document.getElementById("assetEditName").textContent =
                                            "Asset - " + vm.assetToEdit.name;
                                        editAssetOnMapView(assetDetails);
                                    });
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnShowAsset = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnShowAsset.type = "button";
                            btnShowAsset.value = "Show attributes";
                            btnShowAsset.className = "button";

                            google.maps.event.addDomListener(
                                btnShowAsset,
                                "click",
                                function () {
                                    AssetByID.get(assetDetails.id, function (response) {
                                        showAssetAttributesModal(response);
                                    });
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnEditAttribute = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnEditAttribute.type = "button";
                            btnEditAttribute.value = "Edit attributes";
                            btnEditAttribute.className = "button";

                            google.maps.event.addDomListener(
                                btnEditAttribute,
                                "click",
                                function () {
                                    AssetByID.get(asset.id, function (response) {
                                        vm.editAssetAttributesModal(response);
                                        if (openedInfoWindow != undefined) {
                                            openedInfoWindow.close();
                                        }
                                    });
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnThreePointRef = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnThreePointRef.type = "button";
                            btnThreePointRef.value = "3 Point Reference";
                            btnThreePointRef.className = "button";

                            google.maps.event.addDomListener(
                                btnThreePointRef,
                                "click",
                                function () {
                                    AssetByID.get(assetDetails.id, function (response) {
                                        showThreePontReferenceModal(response);
                                    });
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnAssetAttach = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnAssetAttach.type = "button";
                            btnAssetAttach.value = "Attachments";
                            btnAssetAttach.className = "button";

                            google.maps.event.addDomListener(
                                btnAssetAttach,
                                "click",
                                function () {
                                    vm.assetAttachments.assetImages = [];
                                    $("#modalAttachment").show();
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnDeleteAsset = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnDeleteAsset.type = "button";
                            btnDeleteAsset.value = "Delete";
                            btnDeleteAsset.className = "button";

                            google.maps.event.addDomListener(
                                btnDeleteAsset,
                                "click",
                                function () {
                                    vm.deleteAssetModal(assetDetails.name, assetDetails.id);
                                }
                            );
                        }
                        if (asset.assetType.name === "OLT") {
                            btnHighLightOlt = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnHighLightOlt.type = "button";
                            btnHighLightOlt.value = "Show Rings";
                            btnHighLightOlt.className = "button";
                            google.maps.event.addDomListener(btnHighLightOlt, "click", function () {
                                vm.getOltRingsData(asset.id);
                                if (openedInfoWindow != undefined) {
                                    openedInfoWindow.close();
                                };
                            });
                        }
                        if (asset.assetType.name === "OLT") {
                            btnSelectOlt = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnSelectOlt.type = "button";
                            btnSelectOlt.value = "Select";
                            btnSelectOlt.className = "button";
                            google.maps.event.addDomListener(btnSelectOlt, "click", function () {
                                vm.oltAssetDetails = asset;
                                vm.showDirectionClicked = false;
                                if (openedInfoWindow !== null) {
                                    openedInfoWindow.close();
                                };
                            });
                        }
                        if ((vm.trRoute.id || vm.trRoute.tempId) && asset.id) {
                            ADDTORing = userContent.appendChild(
                                document.createElement("input")
                            );

                            ADDTORing.type = "button";
                            ADDTORing.value = "Add To Ring";
                            ADDTORing.className = "button";

                            google.maps.event.addDomListener(
                                ADDTORing,
                                "click",
                                function () {
                                    var found = vm.routePayload.assets.find(function (item) {
                                        return item.id === asset.id;
                                    });

                                    if ($scope.tabTable != 11) {
                                        $scope.tabTable = 11;
                                    }

                                   /* if (vm.ringRouteAssets.length ===0) {
                                        vm.getRouteSections();
                                    }*/
                                    $scope.$apply(function () {
                                        if (!found) {
                                            vm.routePayload.assets.push(asset);
                                            vm.highlightSelectedSpan(asset);
                                        }
                                    });

                                    if (openedInfoWindow != undefined) {
                                        openedInfoWindow.close();
                                    }
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnNearBy = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnNearBy.type = "button";
                            btnNearBy.value = "Near By GP";
                            btnNearBy.className = "button";
                            google.maps.event.addDomListener(btnNearBy, "click", function () {
                                var nearByGpLatLng = new google.maps.LatLng(
                                    assetDetails.assetCoordinates[0].latitude,
                                    assetDetails.assetCoordinates[0].longitude
                                );
                                nearByAssets(vm.trRoute.id, nearByGpLatLng)
                                vm.nearBySource = {
                                    lat: nearByGpLatLng.lat(),
                                    lng: nearByGpLatLng.lng(),
                                    block: vm.blockName,
                                    state: vm.stateName,
                                    district: vm.districtName
                                };
                            });

                        }
                        if ((vm.trRoute.id || vm.trRoute.tempId) && asset.id) {
                            btnUpdateRoute = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnUpdateRoute.type = "button";
                            btnUpdateRoute.value = "Add to Exist Ring";
                            btnUpdateRoute.className = "button";

                            google.maps.event.addDomListener(
                                btnUpdateRoute,
                                "click",
                                function () {
                                    vm.addExistAssetModal(asset);
                                    if (openedInfoWindow != undefined) {
                                        openedInfoWindow.close();
                                    };
                                }
                            );
                        }
                      /*  vm.getAssets = function (assetDetails) {
                            AssetByID.get(assetDetails, function (response) { });
                        };*/

                        return function () {
                            infowindow.setContent(userContent);
                            infowindow.open(locations.map, marker);
                            infowindow.setPosition(
                                new google.maps.LatLng(
                                    marker.getPosition().lat(),
                                    marker.getPosition().lng()
                                )
                            );
                            openedInfoWindow = infowindow;
                            setTimeout(function () {
                                infowindow.close();
                            }, 15000);
                        };

                    })(marker, index)
                );
            }
        
        }
        Configs.get("AssetImage", function (response) {
            if (response.length > 0) {
                if (response[0].configValue == "True") {
                    vm.showAssetImage = true;
                }
            }
        });
        $("#assetImages").change(function () {
            filesSelected = document.getElementById("assetImages").files;
            for (var i = 0; i < filesSelected.length; i++) {
                if (
                    (filesSelected[i].type == "image/png" ||
                        filesSelected[i].type == "image/jpg" ||
                        filesSelected[i].type == "image/jpeg" ||
                        filesSelected[i].type == "application/pdf") &&
                    filesSelected[i].size <= 2621440
                ) {
                    vm.fileWarning = false;
                    var fileReader = new FileReader();
                    fileReader.onload = function (fileLoadedEvent) {
                        vm.assetAttachments.assetImages.push({
                            image: window.btoa(fileLoadedEvent.target.result),
                            asset: {
                                id: vm.assetIdImg,
                            },
                            imageName: fileLoadedEvent.target.name,
                            imageType: fileLoadedEvent.target.type,
                        });
                    };
                    fileReader.name = filesSelected[i].name.split(".")[0];
                    fileReader.type = filesSelected[i].type.split("/")[1].toUpperCase();
                    fileReader.readAsBinaryString(filesSelected[i]);
                } else {
                    filesSelected = null;
                    vm.fileWarning = true;
                }
            }
        });
        function showAssetAttributesModal(assetVal) {
            $("#modalAssetAttributes").show();
            var assetTypeAttributeValuesList = assetVal.assetTypeAttributeValues;
            document.getElementById("assetAttributeTable").innerHTML = "";

            var newTable =
                "<table align='center' style='border: 1px solid black; width: 50%;'>" +
                "<tr><th style='border: 1px solid black; text-align: center;'>Name</th>" +
                "<th style='border: 1px solid black; text-align: center;'>Attribute Value</th></tr>";
            var filteredAndSortedList = [];
            for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
                var value = assetTypeAttributeValuesList[i];
                filteredAndSortedList.push(value);
            }

            filteredAndSortedList.sort(function (a, b) {
                return (
                    a.assetTypeAttribute.assetTypeAttribOrder -
                    b.assetTypeAttribute.assetTypeAttribOrder
                );
            });

            for (var j = 0; j < filteredAndSortedList.length; j++) {
                var item = filteredAndSortedList[j];
                newTable +=
                    "<tr><td style='border: 1px solid black; text-align: center;'>" +
                    (item.assetTypeAttribute.name || "N/A") +
                    "</td><td style='border: 1px solid black; text-align: center; color:" +
                    (item.attributeValue === 'INCREMENTAL' ? '#00A36C' : item.attributeValue === 'NEW' ? '#ff0025' : 'black') +
                    "'>" + (item.attributeValue || "N/A") +
                    "</td></tr>"
            }

            newTable += "</table>";

            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }

        function showThreePontReferenceModal(assetVal) {
            $("#modalThreePointReference").show();
            var assetTypeAttributeValuesList = assetVal.assetTypeAttributeValues,
                assetReferenceAttributesList = assetVal.assetReferenceAttributes,
                referenceAttribute = [];
            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Object</th><th style='border: 1px solid black;text-align: center;'>Distance (mtr)</th></tr>";
            var ref = [];
            var dist = [];
            if (assetVal.assetReferenceAttributes.length) {
                assetReferenceAttributesList.forEach(function (val) {
                    referenceAttribute.push(val["assetAttributeName"]);
                    referenceAttribute.push(val["assetAttributeValue"]);
                });
                referenceAttribute.forEach(function (val) {
                    if (
                        val.assetTypeAttribute.assetAttributeTypes == "THREE_PNT_REFERENCE"
                    ) {
                        if (
                            val.assetTypeAttribute.name == "3 Point Reference1" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "3 Point Reference2" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "3 Point Reference3" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance1" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance2" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance3" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        }
                    }
                });
            } else {
                assetTypeAttributeValuesList.forEach(function (value) {
                    if (
                        value.assetTypeAttribute.assetAttributeTypes ==
                        "THREE_PNT_REFERENCE"
                    ) {
                        if (value.assetTypeAttribute.name == "3 Point Reference1") {
                            ref.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "3 Point Reference2") {
                            ref.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "3 Point Reference3") {
                            ref.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "Distance1") {
                            dist.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "Distance2") {
                            dist.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "Distance3") {
                            dist.push(value.attributeValue);
                        }
                    }
                });
            }

            for (var i = 0; i < 3; i++) {
                if (ref[i] || dist[i]) {
                    newTable +=
                        "<tr><td style='border: 1px solid black;text-align: center;'>" +
                        ref[i] +
                        "</td><td style='border: 1px solid black;text-align: center;'>" +
                        dist[i] +
                        "</td></tr>";
                }
            }
            newTable += "</table>";
            document.getElementById("assetNameThreePointReference").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("threePointReferenceTable").innerHTML = newTable;
        }
        function editAssetOnMapView(fixed) {
            $("#assetEditModal").show();
        }
        function closeEditAssetModal() {
            document.getElementById("assetEditName").textContent = "Asset";
            $("#assetEditModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#assetEditModal").hide();
        }

        function closeAssetAttributesModal() {
            $("#modalAssetAttributes").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalAssetAttributes").hide();
            $("#modalNeaeBy").removeClass("in");
            $("#modalNearBy").hide();
        }
        function closeAssetExistRing() {
            $("#Exist-Ring").removeClass("in");
            $(".modal-backdrop").remove();
            $("#Exist-Ring").hide();
        }
        function closeEditAssetAttributeModal() {
            $("#editAssetAttributeModal").removeClass("in");
            $(".modal-backdrop").remove();
            $('#editAssetAttributeModal').hide();
        }

        function closeRingNameAlreadyExist() {
            $("#Exist-Ring-name").removeClass("in");
            $(".modal-backdrop").remove();
            $("#Exist-Ring-name").hide();
        }
        function closeUpdateRingNameModel() {
            $("#updateRingNameModel").removeClass("in");
            $(".modal-backdrop").remove();
            $("#updateRingNameModel").hide();
        }

        function closeRingModal() {
            $("#ringTopology").removeClass("in");
            $(".modal-backdrop").remove();
            $("#ringTopology").hide();
        }

        function saveEditAssetModal() {
            Asset.update(vm.assetToEdit , function () {
				vm.closeEditAssetModal();
			});
        }
        function closeThreePointReference() {
            $("#modalThreePointReference").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalThreePointReference").hide();
        }
        function nearByAssets(id, payload) {
            getConnectedNodes.postNeighbouringFixed(id, payload, function (response) {
                vm.nearByGps = response;
                showNearByGpsModal()
            })
        }
        function showNearByGpsModal() {
            $("#modalNearBy").show();
        }
        vm.connectSelected = function () {

            angular.forEach(vm.nearByGps, function (item) {
                if (item.selected) {
                    vm.nearByDestination = {
                        lat: item.latitude,
                        lng: item.longitude,
                        name: item.name
                    };
                    vm.fetchRoute(vm.nearBySource, vm.nearByDestination);
                }
            });
            $("#modalNearBy").removeClass("in");
            $("#modalNearBy").hide();
        };

        vm.clearSelected = function () {
            vm.refreshPage();
        };
        function callAssetsRouteByID(routeId, lastId) {
            callAssets = true;
            vm.tempStoreAssetsList = [];
            assetsByRouteBundleId.get(routeId, lastId, function (data) {
                if (data.assets.length) {
                    vm.isShowing = false;
                    vm.tempStoreAssets = data.assets;

                    vm.tempStoreAssets.forEach(function (item) {

                        if (item.block) {
                            var isDuplicate = false;
                            for (var i = 0; i < vm.blockFilter.length; i++) {
                                if (vm.blockFilter[i].name === item.block) {
                                    isDuplicate = true;
                                    break;
                                }
                            }
                            if (!isDuplicate) {
                                vm.blockFilter.push({ name: item.block, selected: true });
                            }
                        }

                        item.assetType = {};
                        item.assetType.layout = item.assetTypeLayout;
                        item.assetType.imagePath = item.assetTypeImagePath;
                        item.assetType.name = item.assetTypeName;

                        var assetType = vm.storeAssetTypes.find(function (each) {
                            return each.name == item.assetTypeName;
                        });
                        item.assetType.id = assetType.id;

                        if (vm.storeAssetTypes.length) {
                            vm.storeAssetTypes.filter(function (eachElement) {
                                if (item.assetTypeName == eachElement.name) {
                                    item.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                        eachElement.assetTypeAttributes
                                    );
                                }
                            });
                        }

                        delete item.assetTypeName;
                        delete item.assetTypeImagePath;
                        delete item.assetTypeLayout;

                        vm.mappedAssetsList.push(item);
                        vm.tempStoreAssetsList.push(item);
                    });

                    iterateMappedAssetsList(locations.map, vm.tempStoreAssetsList);

                    if (vm.mappedAssetsList.length > 0) {
                        var len = Math.floor(vm.mappedAssetsList.length / 2);
                        locations.map.setCenter(
                            new google.maps.LatLng(
                                vm.mappedAssetsList[len].assetCoordinates[0].latitude,
                                vm.mappedAssetsList[len].assetCoordinates[0].longitude
                            )
                        );
                    }
                }

                if (data.assets.length >= 100) {
                    callAssetsRouteByID(
                        vm.trRoute.id,
                        data.assets[data.assets.length - 1].id
                    );
                } else {
                    vm.assetsLoaded = false;
                }

                if (vm.mappedAssetsList.length) {
                    vm.legend = [];
                    vm.legend.push(
                        { name: "Not Connected", code: "#ff0025" },
                        { name: "Connected", code: "#00A36C" }
                    );
                }
            });
        }

        vm.navigate = function (asset) {
            clearPolylines();
            if (asset.assetType.layout == "SPREAD" && asset.assetCoordinates.length >0 ) {
                var path = [];

                asset.assetCoordinates.forEach(function (each) {
					if(each.latitude != null && each.longitude != null ){
						path.push({ lat: each.latitude, lng: each.longitude, id: each.id });
					}
                    
                });
                // path.sort(function (a, b) {
                //     return a.id - b.id;
                // });
                if (path[0].sortOrder != null) {
                    path.sort(function (a, b) {
                        return a.sortOrder - b.sortOrder; // Ascending order
                    });
                    // } else {
                    //     path.sort(function (a, b) {
                    //         return a.id - b.id; // Ascending order
                    //     });
                }

                spreadPoly = new google.maps.Polyline({
                    path: path,
                    strokeColor: "#A938F3",
                    strokeOpacity: 0.6,
                    strokeWeight: 19,
                });
                spreadPoly.setMap(locations.map);
                locations.map.setZoom(12);
                locations.map.setCenter(path[0]);
                polylineTimer = function () {
                    if (spreadPoly != null) {
                        spreadPoly.setMap(null);
                        spreadPoly = null;
                    }
                }
            } else if (asset.assetType.layout == "FIXED" && asset.assetCoordinates.length >0) {
                locations.map.setZoom(16);
                locations.map.setCenter({
                    lat: asset.assetCoordinates[0].latitude,
                    lng: asset.assetCoordinates[0].longitude,
                });
            }
        };
        function clearPolylines() {
            if (spreadPoly) {
                spreadPoly.setMap(null);
                spreadPoly = null;
            }

            polylines.forEach(function (poly) {
                poly.setMap(null);
            });
            polylines = [];

            if (polylineTimer) {
                clearTimeout(polylineTimer);
            }
        }
        var ringTopology = [];
        vm.storeRingPolylines = [];
        vm.onSelectedRingSize = function () {
            $scope.isShowMinCost = false;
            $scope.isShowMinCostText = "Show";

            if (vm.storeRingPolylines.length) {
                for (var i = 0; i < vm.storeRingPolylines.length; i++) {
                    vm.storeRingPolylines[i].polyline.setMap(null);
                }
            }

            vm.mappedAssetsList = vm.mappedAssetsList.filter(function (item) {
                return item.id != "True";
            });

            var tempId = vm.trRoute.id ? vm.trRoute.id : vm.trRoute.tempId;

            if (tempId) {
                assetsLinking.assetRings(
                    tempId,
                    vm.selectedRingSize,
                    function (ringResponse) {
                        if (ringResponse.length) {
                            vm.storeRingPolylines = [];
                            ringTopology = [];
                            vm.ringList = []
                            storeRingOptions = [];
                            tempRingAssetStore = [];
                            tempRingAssetStoreInGraph = [];

                            vm.ringResponse = ringResponse;

                            var latlng, spreadCoordinates, fiberDistance;
                            vm.ringResponse.forEach(function (each, index) {
                                vm.ringTotalDistance = 0;

                                each.forEach(function (eachInner) {
                                    if (eachInner.sourceNode.assetCoordinates.length > 2) {
                                        latlng = [];
                                        fiberDistance = 0;
                                        spreadCoordinates = eachInner.sourceNode.assetCoordinates;
                                        for (var i in spreadCoordinates) {
                                            if (i > 0) {
                                                fiberDistance += distanceCal(
                                                    spreadCoordinates[i].latitude,
                                                    spreadCoordinates[i].longitude,
                                                    spreadCoordinates[i - 1].latitude,
                                                    spreadCoordinates[i - 1].longitude
                                                );
                                                latlng.push({
                                                    lat: spreadCoordinates[i].latitude,
                                                    lng: spreadCoordinates[i].longitude,
                                                });
                                                fiberDistance = parseFloat(fiberDistance.toFixed(2));
                                            }
                                        }

                                        vm.ringTotalDistance += parseFloat(
                                            fiberDistance.toFixed(2)
                                        );

                                        ringTopology.push({
                                            name: eachInner.sourceNode.name,
                                            assetCoordinates: eachInner.sourceNode.assetCoordinates,
                                            assetType: {
                                                layout: "SPREAD",
                                                name: "Planned Route",
                                                id: vm.tempAssetDetail.id,
                                            },
                                            latlng: latlng,
                                            isChecked: false,
                                            isCycle: true,
                                            inGraph: true,
                                            index: index,
                                            id: null,
                                            assetColor: null,
                                            transparency: null,
                                            lineWidth: null,
                                            healthIndicator: null,
                                            healthRemarks: null,
                                            burried: null,
                                            minCost: null,
                                            phase: "PLANNING",
                                            assetLength: fiberDistance,
                                        });
                                    }
                                });

                                var temp = {
                                    name: "Ring Option " + (index + 1),
                                    index: index + 1,
                                    id: "True",
                                    assetType: {
                                        layout: " ",
                                        name: " ",
                                    },
                                    inGraph: true,
                                    isOption: true,
                                    assetLength: vm.ringTotalDistance,
                                };
                                // vm.mappedAssetsList.unshift(temp);
                                vm.ringList.push(temp)
                                if ($scope.tabTable != 12) {
                                    $scope.tabTable = 12;
                                }
                                storeRingOptions.push(temp);
                            });

                            vm.storeRingTopology = ringTopology;

                            vm.storeRingTopology.forEach(function (each) {
                                var index = vm.mappedAssetsList.findIndex(function (item) {
                                    return (
                                        each.name === item.name &&
                                        item.assetCoordinates &&
                                        each.assetCoordinates[0].latLong ===
                                        item.assetCoordinates[0].latLong &&
                                        each.assetCoordinates[each.assetCoordinates.length - 1]
                                            .latLong ===
                                        item.assetCoordinates[item.assetCoordinates.length - 1]
                                            .latLong
                                    );
                                });

                                if (index === -1) {
                                    tempRingAssetStore.push(each.name);
                                    vm.mappedAssetsList.push(each);
                                }
                            });

                            ringTopology.forEach(function (item) {
                                drawPolyLines(
                                    item,
                                    "red",
                                    item.latlng,
                                    locations.map,
                                    true
                                );
                            });
                        } else {
                            alert("Ring Topology Not Detected");
                        }
                    }
                );
            }

            $timeout(function () {
                closeRingModal();
            }, 500);
        };

        vm.ringModal = function () {
            $("#ringTopology").show();
        };

        vm.onChangeTopology = function (asset) {
            var temp = [];

            if (vm.storeRingPolylines.length) {
                temp = vm.storeRingPolylines;

                var tempPoly = temp.filter(function (item) {
                    return asset.index == item.index;
                });

                if (asset.isOption) {
                    for (var i = 0; i < tempPoly.length; i++) {
                        tempPoly[i].polyline.setMap(locations.map);
                    }
                } else if (!asset.isOption) {
                    for (var i = 0; i < tempPoly.length; i++) {
                        tempPoly[i].polyline.setMap(null);
                    }
                }
            }
        };

        Configs.get("Ring_Topology", function (response) {
            if (response.length) {
                response.forEach(function (item) {
                    if (item.configKey == "Ring_Size") {
                        tempSize = item.configValue;
                    }
                });
            }
        });

        function tenGps() {
            var tempId = vm.trRoute.id ? vm.trRoute.id : vm.trRoute.tempId;
            if (tempId) {
                assetsLinking.assetRings(tempId, tempSize, function (ringResponse) {
                    if (ringResponse.length) {
                        ringTopology = [];

                        vm.ringResponse = ringResponse;

                        vm.ringResponse.forEach(function (each, index) {
                            each.forEach(function (eachInner) {
                                var latlng;
                                if (eachInner.sourceNode.assetCoordinates.length > 2) {
                                    latlng = [];
                                    eachInner.sourceNode.assetCoordinates.forEach(function (
                                        item
                                    ) {
                                        latlng.push({ lat: item.latitude, lng: item.longitude });
                                    });
                                    ringTopology.push({
                                        name: eachInner.sourceNode.name,
                                        assetCoordinates: eachInner.sourceNode.assetCoordinates,
                                        assetType: {
                                            layout: "SPREAD",
                                            name: "Planned Route",
                                            id: vm.tempAssetDetail.id,
                                        },
                                        latlng: latlng,
                                        isChecked: false,
                                        isCycle: true,
                                        inGraph: true,
                                        index: index,
                                        id: null,
                                        assetColor: null,
                                        transparency: null,
                                        lineWidth: null,
                                        healthIndicator: null,
                                        healthRemarks: null,
                                        burried: null,
                                        minCost: null,
                                        phase: "PLANNING",
                                    });
                                }
                            });
                        });

                        vm.storeRingTopology = ringTopology;

                        vm.storeRingTopology.forEach(function (each) {
                            var index = vm.mappedAssetsList.findIndex(function (item) {
                                return (
                                    each.name === item.name &&
                                    item.assetCoordinates &&
                                    each.assetCoordinates[0].latLong ===
                                    item.assetCoordinates[0].latLong &&
                                    each.assetCoordinates[each.assetCoordinates.length - 1]
                                        .latLong ===
                                    item.assetCoordinates[item.assetCoordinates.length - 1]
                                        .latLong
                                );
                            });

                            if (vm.mappedAssetsList[index]) {
                                vm.mappedAssetsList[index].inAnomaly = true;
                            }

                            if (index === -1) {
                                vm.mappedAssetsList.push(each);
                            }
                        });

                        ringTopology.forEach(function (item) {
                            drawPolyLines(item, "#000000", item.latlng, locations.map, null);
                        });
                    }
                });
            }
        }

        $scope.isAnomaly = false;
        $scope.isAnomalyText = "Show";
        $scope.toggleAnomaly = function () {
            for (var i = 0; i < vm.layerItems.length; i++) {
                vm.layerItems[i].selected = true;
                vm.selectedLayers[vm.layerItems[i].name] = true;
            }
            $scope.isAnomaly = !$scope.isAnomaly;

            $scope.isShowMinCost = false;
            $scope.isShowMinCostText = "Show";
            if ($scope.isAnomaly) {
                $scope.isAnomalyText = "Hide";

                if (anomalyPolylines.length) {
                    var temp = moreThan10KmPolylines.concat(anomalyPolylines);

                    for (var i = 0; i < temp.length; i++) {
                        temp[i].setMap(locations.map);
                    }
                } else {
                    anomalyPolylines = [];
                    moreThan10KmPolylines = [];
                    tenGps();
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].assetType.layout == "SPREAD") {
                            if (vm.mappedAssetsList[i].assetCoordinates) {
                                var assetCoordinateValues = [];
                                vm.mappedAssetsList[i].assetCoordinates.forEach(function (
                                    each
                                ) {
                                    assetCoordinateValues.push({
                                        lat: each.latitude,
                                        lng: each.longitude,
                                    });
                                });
                            }
                            if (vm.mappedAssetsList[i].assetLength >= 10) {
                                drawPolyLines(
                                    vm.mappedAssetsList[i],
                                    "#0050B5",
                                    assetCoordinateValues,
                                    locations.map
                                );
                            }
                        }
                    }
                }
            } else {
                $scope.isAnomalyText = "Show";
                refreshPage();
            }
        };

        vm.getProgressBarColor = function () {
            return vm.updateProgress >= 99 ? "#0BDA51" : "#FFC300";
        };

        function iterateMappedAssetsList(map, arr) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].assetType.layout == "FIXED") {
                    drawMarkers(arr[i], map, i);
                } else if (arr[i].assetType.layout == "SPREAD") {
                    vm.routePlanningTotalLength += arr[i].assetLength
                        ? arr[i].assetLength
                        : 0;
                    if (arr[i].assetCoordinates) {
                        var assetCoordinateValues = [];
                        if (arr[i].minCost) {
                            vm.minCostTotalLength += arr[i].assetLength
                                ? arr[i].assetLength
                                : 0;
                            for (var index in arr[i].assetCoordinates) {
                                assetCoordinateValues.push({
                                    lat: arr[i].assetCoordinates[index].latitude,
                                    lng: arr[i].assetCoordinates[index].longitude,
                                    id: arr[i].assetCoordinates[index].id
                                });
                            }
                        } else {
                            arr[i].assetCoordinates.forEach(function (each) {
                                assetCoordinateValues.push({
                                    lat: each.latitude,
                                    lng: each.longitude,
                                    id: each.id,
                                });
                            });
                        }
                    }
                    // if (assetCoordinateValues[0].sortOrder != null) {
                    //     assetCoordinateValues.sort(function (a, b) {
                    //         return a.sortOrder - b.sortOrder; // Ascending order
                    //     });
                    //     // } else {
                    //     //     assetCoordinateValues.sort(function (a, b) {
                    //     //         return a.id - b.id; // Ascending order
                    //     //     });
                    // }

                    var tmpColor = "#00A36C";
                    if (arr[i].assetType.name != 'Planned Route') {
                        tmpColor = "#00A36C";
                    } else {
                        if (arr[i].isCycle) {
                            tmpColor = "#FFD700";
                            // } else if (!arr[i].isConnected) {
                        } else if (!arr[i].isExisting || arr[i].isExisting==null) {
                            tmpColor = "#ff0025"; //tmpColor = "blue";
                        }
                    }
  
                    // if (arr[i].isConnected) {
                    if (arr[i].isExisting) {
                        tmpColor = "#00A36C";
                        vm.connectedLength += arr[i].assetLength;
                    }
                    
                    if(!arr[i].isUsed && arr[i].isExisting){
                        tmpColor = "#FFAE42"
                    }
                    if (!arr[i].isCycle) {
                        drawPolyLines(arr[i], tmpColor, assetCoordinateValues, map);
                    }
                }
            }
        }

        vm.layerItems = [];
        vm.selectedLayers = {};
        vm.filteredAssetsList = [];
        vm.layersInitialized = false;

        vm.showLayers = function () {
            if (!vm.layersInitialized) {
                vm.layerItems = [];
                var uniqueAssetTypeNames = {};

                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    var item = vm.mappedAssetsList[i];

                    var temp = vm.storeAssetTypes.find(function (storedAsset) {
                        return storedAsset.name == item.assetType.name;
                    });
                    item.assetType = temp;
                    item.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                        temp
                    );
                    var assetType = item.assetType.name.trim().toUpperCase();
                    var assetTypeName = ['OLT'].includes(assetType)
                        ? 'BLOCK'
                        : assetType === 'JOINT KIT'
                            ? 'JUNCTION POINT'
                            : assetType === 'GP'
                                ? 'GP Router'
                                : item.assetType.name;

                    if (assetTypeName === "Planned Route" || assetTypeName === "Planned_Route") {
                      if (item.isExisting === true && item.isUsed === true) {
                            if (!uniqueAssetTypeNames["Existing"]) {
                                uniqueAssetTypeNames["Existing"] = true;
                                var existingSelected = vm.selectedLayers["Existing"] !== undefined ? vm.selectedLayers["Existing"] : true;
                                vm.layerItems.push({ name: "Existing", selected: existingSelected });
                                vm.selectedLayers["Existing"] = existingSelected;
                            }
                        }
                        if (item.isExisting === true && item.isUsed === false) {
                            if (!uniqueAssetTypeNames["Unused"]) {
                                uniqueAssetTypeNames["Unused"] = true;
                                var unusedSelected = vm.selectedLayers["Unused"] !== undefined ? vm.selectedLayers["Unused"] : true;
                                vm.layerItems.push({ name: "Unused", selected: unusedSelected });
                                vm.selectedLayers["Unused"] = unusedSelected;
                            }
                        }
                        if (item.isExisting === false) {
                            if (!uniqueAssetTypeNames["New OFC"]) {
                                uniqueAssetTypeNames["New OFC"] = true;
                                var newSelected = vm.selectedLayers["New OFC"] !== undefined ? vm.selectedLayers["New OFC"] : true;
                                vm.layerItems.push({ name: "New OFC", selected: newSelected });
                                vm.selectedLayers["New OFC"] = newSelected;
                            }
                        }

                    
                    } else {
                        if (!uniqueAssetTypeNames[assetTypeName]) {
                            uniqueAssetTypeNames[assetTypeName] = true;
                            var layerSelected = vm.selectedLayers[assetTypeName] !== undefined ? vm.selectedLayers[assetTypeName] : true;
                            vm.layerItems.push({
                                name: assetTypeName,
                                selected: layerSelected
                            });
                            vm.selectedLayers[assetTypeName] = layerSelected;
                        }
                    }

                }
                vm.layersInitialized = true;
            }
        };

        vm.updateSelectedLayers = function () {
            vm.selectedLayers = {};
            for (var i = 0; i < vm.layerItems.length; i++) {
                var layer = vm.layerItems[i];
                if (layer.selected) {
                    vm.selectedLayers[layer.name] = true;
                }
            }
            vm.filterMapByLayers();
        };

        vm.filterMapByLayers = function () {
            clearMarkersPolyLine()
            vm.filteredAssetsList = vm.mappedAssetsList.filter(function (item) {
                var assetType = item.assetType.name.trim().toUpperCase();
                var assetTypeName = ['OLT'].includes(assetType)
                    ? 'BLOCK'
                    : assetType === 'JOINT KIT'
                        ? 'JUNCTION POINT'
                        : assetType === 'GP'
                            ? 'GP Router'
                            : item.assetType.name;
                if (assetTypeName === "Planned Route" || assetTypeName === "Planned_Route") {
                    var attrType = item.assetTypeAttributeValues[0] &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute.assetAttributeTypes;


                     if (assetTypeName === "Planned Route" || assetTypeName === "Planned_Route") {
                        if (item.isExisting && item.isUsed && vm.selectedLayers["Existing"]) {
                            return true;
                        }
                        if (item.isExisting && item.isUsed === false && vm.selectedLayers["Unused"]) {
                            return true;
                        }
                        if (!item.isExisting && vm.selectedLayers["New OFC"]) {
                            return true;
                        }

                        return false;
                    }
                    return false;
                }

                return vm.selectedLayers[assetTypeName];
            });


            for (var k = 0; k < vm.filteredAssetsList.length; k++) {
                var asset = vm.filteredAssetsList[k];

                var tmpColor = "#ff0025";
                if (asset.isCycle) {
                    tmpColor = "#FFD700";
                } else if (!asset.isExisting) {
                    tmpColor = "#ff0025";
                } else if (asset.isExisting) {
                    tmpColor = "#00A36C";
                }

                if(!asset.isUsed && asset.isExisting){
                    tmpColor = "#FFAE42";
                }

                if (asset.assetCoordinates) {
                    var assetCoordinateValues = asset.assetCoordinates.map(function (each) {
                        return { lat: each.latitude, lng: each.longitude };
                    });

                    if (assetCoordinateValues.length > 0) {
                        if (assetCoordinateValues[0].sortOrder != null) {
                            assetCoordinateValues.sort(function (a, b) {
                                return a.sortOrder - b.sortOrder;
                            });
                        }
                    }

                    if (asset.assetType.layout === "SPREAD") {
                        drawPolyLines(asset, tmpColor, assetCoordinateValues, locations.map);
                    } else if (asset.assetType.layout === "FIXED") {
                        drawMarkers(asset, locations.map, k);
                    }
                }
            }

        };

        function clearMarkersPolyLine() {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
            markers = [];
            for (var j = 0; j < polyLines.length; j++) {
                polyLines[j].setMap(null);
            }
            polyLines = [];
        }
        $scope.toggleBlock = function () {
            if (vm.selectedBlock.length) {
                clearPhase();
                vm.selectedBlock.forEach(function (each) {
                    for (var i = 0; i < phasePolylines.length; i++) {
                        if (
                            phasePolylines[i].block ===
                            each.name
                        ) {
                            if (each.selected) {
                                phasePolylines[i].setMap(locations.map);
                            }
                        }
                    }
                    for (var i = 0; i < phaseMarkers.length; i++) {
                        if (
                            phaseMarkers[i].block ===
                            each.name
                        ) {
                            if (each.selected) {
                                phaseMarkers[i].setMap(locations.map);
                            }
                        }
                    }
                });
            } else {
                clearPhase();
            }
        };

        vm.removeMarker = function () {
            commonPathMarkers.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the commonPathMarkers array
            commonPathMarkers = [];
        };

        function addMarker(location) {
            var markerText;
            if (commonPathMarkers.length == 0) {
                markerText = "from";
            } else if (commonPathMarkers.length == 1) {
                markerText = "to";
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: markerText,
                },
            });

            // Add the marker to the commonPathMarkers array
            commonPathMarkers.push(marker);
        }

        vm.saveRoute = function () {
            if (!vm.trRoute.id) {
                TrRouteBundle.save(vm.trRoute, function (response) {
                    $scope.setTab(4);
                    vm.trRoute.id = response.id;
                });
            } else if (vm.trRoute.id) {
                $scope.setTab(4);
                TrRouteBundle.update(vm.trRoute, function (response) { });
            }
        };

        $scope.setTabTable = function (newTab) {
            $scope.tabTable = newTab;
        };

        $scope.isSetTable = function (tabNum) {
            return $scope.tabTable === tabNum;
        };

        vm.ringSaveValidation = function () {
            var newRingName = vm.routePayload.name;

            var ringNameExist = vm.ringRouteAssets.some(function (ringItem) {
                return ringItem.name === newRingName;
            });

            if (ringNameExist) {
                $("#Exist-Ring-name").show();
            } else {
                vm.ringSave();
            }
        };

        vm.ringSave = function () {
            vm.closeRingNameAlreadyExist();
            TrRoute.save(
                vm.routePayload,
                function () {
                    alert("Ring Created");
                    clearPolylines();
                    vm.routePayload.name = null;
                    vm.routePayload.assets = [];
                    $scope.tabTable = 10;
                },
                function (err) {
                    console.log(err);
                }
            );
        };


        vm.deleteSpanOrGpAsset = function (index, asset) {
            clearPolylines();
            if (asset.assetType.layout == "SPREAD") {
                vm.totalLength -= parseFloat(asset.assetLength);
            }
            vm.routePayload.assets.splice(index, 1);
            vm.routePayload.assets.forEach(function (item) {
                vm.highlightSelectedSpan(item);
            });
        };

        vm.ringRouteAssets = [];
        vm.getRouteSections = function () {
            routeDetail.getRingsByRoute(vm.trRoute.id, function (response) {
                clearPolylines();
                highlightedMarkers = {};
                vm.highLightMarkers([]);
                var ringResponse = response;
                ringResponse.sort(function (a, b) {
                    return a.name - b.name;
                });
                vm.ringRouteAssets = ringResponse;
            });
        };

        vm.getSecAssetDetails = function (routeId) {
            routeDetail.getAssetsBySections(routeId, function (response) {
                vm.displayRingDetails = "true";
                vm.sectionAssetDetails = response;
                ringId = routeId;
                var itemIds = vm.sectionAssetDetails.map(function (item) {
                    return item.id;
                });
                vm.highlight(itemIds);
            });
        };

        vm.getFixedAssets = function (routeId) {
            vm.routeFixedAssets = [];
            routeDetail.getFixedAssetsByRouteId(routeId, function (response) {

                vm.routeFixedAssets = response;
                var itemIds = vm.routeFixedAssets.map(function (item) {
                    return item.id;
                });

                vm.highLightMarkers(itemIds);

            })
        };

        vm.getSecAssetCount = function (sectionId) {
            routeDetail.getAssetsCount(sectionId, function (response) {
                vm.sectionAssetCount = response;
            });
        };

        vm.deleteRingAssetas = function (assetId) {

            var assetDetails;
            var routePointData = [];
            var uuid = generateUUID();
            assetDetails = vm.mappedAssetsList.find(function (item) {
                return item.id === assetId;
            });
            assetDetails.assetCoordinates.forEach(function (assetCoord, index) {
                var routepoints = {
                    "routePointType": "COORDINATE",
                    "phase": "PLANNING",
                    "sessionNumber": uuid,
                    "routePointNumber": index,
                    "routeId": ringId,
                    "latitude": assetCoord.latitude,
                    "longitude": assetCoord.longitude
                };
                routePointData.push(routepoints);
            })
            //routeDetail.removeBulkRoutePoints(routePointData, function (response) {
            //console.log(response);
            routeDetail.removeAssetFromRing(ringId, assetId, function () {
                alert("Asset Removed From Ring");
                vm.getSecAssetDetails(ringId);
                vm.getSecAssetCount(ringId);
            });
            //});

        };

        var highlightedMarkers = {};

        vm.highLightMarkers = function (Ids) {
            var highlightedSize = 40;

            markers.forEach(function (marker) {
                var assetId = marker.assetDetails ? marker.assetDetails.id : null;

                if (!assetId) {
                    return;
                }

                var isHighlighted = Ids.indexOf(assetId) !== -1;
                var newSize = isHighlighted ? newSizeLevel + 15 : newSizeLevel;
                var currentIcon = marker.getIcon();

                if (currentIcon) {
                    if (isHighlighted) {
                        highlightedMarkers[assetId] = true;
                    } else {
                        delete highlightedMarkers[assetId];
                    }

                    setTimeout(function () {
                        marker.setIcon({
                            url: currentIcon.url,
                            scaledSize: new google.maps.Size(newSize, newSize),
                            anchor: new google.maps.Point(newSize / 2, newSize / 2),
                            labelOrigin: currentIcon.labelOrigin
                        });
                    }, 50);
                }
            });
        };
        vm.highlight = function (Ids) {
            clearPolylines();

            var path = {};

            if (Ids.length !== 0) {
                Ids.forEach(function (Id) {
                    var polyline = vm.mappedAssetsList.find(function (p) {
                        return p.id === Id;
                    });
                    if (polyline) {
                        if (!path[polyline.id]) {
                            path[polyline.id] = { coordinates: [] };
                        }
                        polyline.assetCoordinates.forEach(function (each) {
                            path[polyline.id].coordinates.push({
                                lat: each.latitude,
                                lng: each.longitude,
                                id: each.id,
                                sortOrder: each.sortOrder
                            });
                        });
                    }
                });

                Object.keys(path).forEach(function (id) {
                    var sessionData = path[id];
                    // sessionData.coordinates.sort(function (a, b) {
                    //     return a.id - b.id;
                    // });
                    if (sessionData.coordinates[0].sortOrder != null) {
                        sessionData.coordinates.sort(function (a, b) {
                            return a.sortOrder - b.sortOrder; // Ascending order
                        });
                        // } else {
                        //     sessionData.coordinates.sort(function (a, b) {
                        //         return a.id - b.id; // Ascending order
                        //     });
                    }
                    if (sessionData.coordinates.length !== 0) {
                        var newPolyline = new google.maps.Polyline({
                            path: sessionData.coordinates,
                            strokeColor: "#A938F3",
                            strokeOpacity: 0.6,
                            strokeWeight: 16
                        });
                        newPolyline.setMap(locations.map);
                        polylines.push(newPolyline);
                    }
                });
                // locations.map.setZoom(12);
                if (path[0]) {
                    locations.map.setCenter(path[0].coordinates[0]);
                }
                polylineTimer = setTimeout(function () {
                    clearPolylines();
                }, 100000);
            }
        };

        function addExistAssetModal(asset) {
            $("#Exist-Ring").show();

            vm.assetId = asset;
            var routeResponse = [];

            routeDetail.getRingsByRoute(vm.trRoute.id, function (response) {
                routeResponse = response;

                document.getElementById("existRingTable").innerHTML = "";

                var newTable =
                    "<table align='center' class='jh-table table table-responsive table-hover' style='border: 1px solid black; width: 40%;'>" +
                    "<tr><th style='border: 1px solid black; text-align: center;'>Rings</th></tr>";

                for (var j = 0; j < routeResponse.length; j++) {
                    var item = routeResponse[j];
                    newTable +=
                        "<tr class='ring-row' data-index='" +
                        j +
                        "'>" +
                        "<td style='text-align: center;'>" +
                        (item.name || "N/A") +
                        "</td>" +
                        "</tr>";
                }

                newTable += "</table>";

                document.getElementById("addAssetExistRing").textContent = asset.name;

                document.getElementById("existRingTable").innerHTML = newTable;

                var rows = document.querySelectorAll(".ring-row");
                rows.forEach(function (row, index) {
                    row.addEventListener("click", function () {
                        vm.SaveToExitingRing(routeResponse[index], asset);
                    });
                });
            });
        }

        vm.SaveToExitingRing = function (route, asset) {
            closeAssetExistRing();
            var routePointData = [];
            var uuid = generateUUID();
            asset.assetCoordinates.forEach(function (assetCoord, index) {
                var routepoints = {
                    "routePointType": "COORDINATE",
                    "phase": "PLANNING",
                    "sessionNumber": uuid,
                    "routePointNumber": index,
                    "routeId": route.id,
                    "latitude": assetCoord.latitude,
                    "longitude": assetCoord.longitude
                };
                routePointData.push(routepoints);
            });

            asset.routeId = route.id;
            (asset.userId = vm.userId), (asset.ownedBy = []);
            routeDetail.saveBulkRoutePoints(routePointData, function (response) {
                if (response.length > 0) {
                    routeDetail.addAseetsToExistingRing(route.id, asset.id, function () {
                        alert("Asset Added To Ring");
                        vm.getSecAssetDetails(ringId);
                        vm.getSecAssetCount(ringId);
                        vm.getRouteSections();
                    });

                } else {
                    alert("Unable to save routepoints");
                }
            });
        };

        vm.getOltRingsData = function (assetId) {
            var assetDetailsEachRings = {};
            var itemIds = [];
            var remainingCalls = 0;

            var predefinedColors = [
                "#FF5733",
                "#33FF57",
                "#3357FF",
                "#F1C40F",
                "#9B59B6",
                "#E74C3C",
                "#1ABC9C",
                "#34495E"
            ];

            var ringColors = {};
            var colorIndex = 0;

            routeDetail.getSectionByRouteIdAssetId(vm.trRoute.id, assetId, function (sectionResponse) {
                if (!sectionResponse || sectionResponse.length === 0) {
                    return;
                }
                remainingCalls = sectionResponse.length;

                sectionResponse.forEach(function (ringId) {
                    if (!ringColors[ringId.id]) {
                        ringColors[ringId.id] = predefinedColors[colorIndex];
                        colorIndex = (colorIndex + 1) % predefinedColors.length;
                    }

                    routeDetail.getAssetsBySections(ringId.id, function (assetResponse) {
                        if (assetResponse) {
                            assetDetailsEachRings[ringId.id] = assetResponse;
                        } else {
                            console.error('No assets found for ringId:', ringId.id);
                        }
                        remainingCalls--;

                        if (remainingCalls === 0) {
                            Object.keys(assetDetailsEachRings).forEach(function (ringId) {
                                var assetData = assetDetailsEachRings[ringId];
                                var color = ringColors[ringId];

                                itemIds = itemIds.concat(assetData.map(function (item) {
                                    return {
                                        id: item.id,
                                        color: color
                                    };
                                }));
                            });
                            vm.highlightOltRings(itemIds);
                        }
                    });
                });
            });
        };

        vm.highlightOltRings = function (itemIds) {
            var path = {};

            if (itemIds.length !== 0) {
                itemIds.forEach(function (item) {
                    var polyline = vm.mappedAssetsList.find(function (p) {
                        return p.id === item.id;
                    });

                    if (polyline) {

                        if (!path[polyline.id]) {
                            path[polyline.id] = { coordinates: [], color: item.color };
                        }

                        polyline.assetCoordinates.forEach(function (each) {
                            path[polyline.id].coordinates.push({
                                lat: each.latitude,
                                lng: each.longitude,
                                id: each.id,
                            });
                        });
                    }
                });

                polylines.forEach(function (poly) {
                    poly.setMap(null);
                });
                polylines = [];

                Object.keys(path).forEach(function (id) {
                    var sessionData = path[id];
                    if (sessionData.coordinates[0].sortOrder != null) {
                        sessionData.coordinates.sort(function (a, b) {
                            return a.sortOrder - b.sortOrder; // Ascending order
                        });
                        // } else {
                        //     sessionData.coordinates.sort(function (a, b) {
                        //         return a.id - b.id; // Ascending order
                        //     });
                    }
                    if (sessionData.coordinates.length !== 0) {
                        var newPolyline = new google.maps.Polyline({
                            path: sessionData.coordinates,
                            strokeColor: sessionData.color,
                            strokeOpacity: 0.6,
                            strokeWeight: 16,
                        });

                        newPolyline.setMap(locations.map);
                        polylines.push(newPolyline);
                    }
                });

                locations.map.setZoom(11);
                locations.map.setCenter(path[0]);
            } else {
                polylines.forEach(function (poly) {
                    poly.setMap(null);
                });
                polylines = [];
            }
        };
        vm.highlightSelectedSpan = function (asset) {
            if (asset.assetType.layout == "SPREAD") {
                var path = [];
                asset.assetCoordinates.forEach(function (each) {
                    path.push({ lat: each.latitude, lng: each.longitude, id: each.id,sortOrder:each.sortOrder });
                });

                if (path[0].sortOrder != null) {
                    path.sort(function (a, b) {
                        return a.sortOrder - b.sortOrder;
                    });
                    // } else {
                    //     path.sort(function (a, b) {
                    //         return a.id - b.id;
                    //     });
                }
                var newPolyline = new google.maps.Polyline({
                    path: path,
                    strokeColor: "#A938F3",
                    strokeOpacity: 0.6,
                    strokeWeight: 19,
                });

                newPolyline.setMap(locations.map);
                polylines.push(newPolyline);

            }
        };

        function generateUUID() {
            var d = new Date().getTime(); // Timestamp
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        }
        vm.addAssetToRingStack = function (asset) {
            var found = vm.routePayload.assets.find(function (item) {
                return item.id === asset.id;
            });

            if ($scope.tabTable != 11) {
                $scope.tabTable = 11;
            }
          /*  if (vm.ringRouteAssets.length ===0) {
                vm.getRouteSections();
            }*/
            $scope.$apply(function () {
                if (!found) {
                    var assetCoordinatesValues = asset.assetCoordinates;
                    var assetCoordinatesSort = [];
                    for (var index = 0; index < assetCoordinatesValues.length; index++) {
                        var assetCoorByIndex = assetCoordinatesValues[index];
                        assetCoorByIndex.sortOrder = index;
                        assetCoordinatesSort.push(assetCoorByIndex);
                    }
                    asset.assetCoordinates = assetCoordinatesSort;
                    vm.routePayload.assets.push(asset);
                    vm.totalLength += parseFloat(asset.assetLength);
                    setTimeout(function () {
                        vm.highlightSelectedSpan(asset);
                    }, 100);
                }
            });
        }



        vm.updateSelectedAssets = function (asset) {
            var index = -1;
            for (var i = 0; i < vm.selectedAssetsToHighlightMultiRing.length; i++) {
                if (vm.selectedAssetsToHighlightMultiRing[i].id === asset.id) {
                    index = i;
                    break;
                }
            }

            if (asset.isOption) {
                if (index === -1) {
                    vm.selectedAssetsToHighlightMultiRing.push(asset);
                }
            } else {
                if (index !== -1) {
                    vm.selectedAssetsToHighlightMultiRing.splice(index, 1);
                }
            }
            if (vm.selectedAssetsToHighlightMultiRing.length === 0) {
                vm.routeFixedAssets = [];
                vm.sectionAssetDetails = [];
                vm.sectionAssetCount = [];
                clearPolylines();
            } else if (vm.selectedAssetsToHighlightMultiRing.length > 1) {
                vm.displayRingDetails = "false";
            }


            var polyItemIds = [];
            var markerItemIds = [];
            var pendingRequests = vm.selectedAssetsToHighlightMultiRing.length * 2;

            vm.selectedAssetsToHighlightMultiRing.forEach(function (ringId) {
                routeDetail.getAssetsBySections(ringId.id, function (response) {

                    for (var j = 0; j < response.length; j++) {
                        polyItemIds.push(response[j].id);
                    }
                    checkAndExecuteHighlight();
                });

                routeDetail.getFixedAssetsByRouteId(ringId.id, function (response) {
                    for (var k = 0; k < response.length; k++) {
                        markerItemIds.push(response[k].id);
                    }
                    checkAndExecuteHighlight();
                });
            });

            function checkAndExecuteHighlight() {
                pendingRequests--;
                if (pendingRequests === 0) {
                    vm.highlight(polyItemIds);
                    vm.highLightMarkers(markerItemIds);
                }
            }
        };
        vm.selectOnlyThisAsset = function (selectedAsset) {
            vm.selectedAssetsToHighlightMultiRing = [];
            angular.forEach(vm.ringRouteAssets, function (asset) {
                asset.isOption = (asset.id === selectedAsset.id);
            });

            vm.updateSelectedAssets(selectedAsset);
        };

        vm.editAssetAttributesModal = function (asset) {
            vm.asset = asset;
            vm.assetId = asset.id;
            $('#editAssetAttributeModal').show();
        }

        vm.saveEditAssetAttribute = function () {
            if (vm.assetId) {
                var assetCoordinatesValues = vm.asset.assetCoordinates;
                var assetCoordinatesSort = [];
                for (var index = 0; index < assetCoordinatesValues.length; index++) {
                    var assetCoorByIndex = assetCoordinatesValues[index];
                    assetCoorByIndex.sortOrder = index;
                    assetCoordinatesSort.push(assetCoorByIndex);
                }
                vm.asset.assetCoordinates = assetCoordinatesSort;
                (vm.asset.userId = vm.userId),
                    Asset.update(vm.asset, function () { });
                $('#editAssetAttributeModal').hide();
            }

        }
        vm.updateRingName = function (routeId) {
            $('#updateRingNameModel').show();
            vm.updateRingNameRingId = routeId;
        }


        vm.updateRingNameValidation = function () {
            vm.duplicateName = false;

            var newRingName = vm.newRingName;
            //var newRingNameTrim =newRingName.trim(); 
            var ringNameExist = vm.ringRouteAssets.some(function (ringItem) {
                return ringItem.name === newRingName;
            });

            if (!ringNameExist) {
                $('#updateRingNameModel').hide();
                routeDetail.updateRingName(vm.trRoute.id, vm.updateRingNameRingId, newRingName, function (response) {
                    if (response === 1) {
                        clearPolylines();
                        vm.newRingName = "";
                        $scope.tabTable = 10;
                    } else {
                        alert("Update Failed.")
                    }

                });

            } else {
                vm.duplicateName = true;
                $('#updateRingNameModel').show();
            }
        };
     
        vm.toggleAssetTable=function(){
            vm.isSidebarVisible = !vm.isSidebarVisible;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrRoutePlanDetailController', TrRoutePlanDetailController);

    TrRoutePlanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrRouteBundle', 'User', 'RouteType', 'TrRouteImages', 'TrRouteRecordings', 'AlertService', '$window', '$localStorage', 'getRouteImage', 'Configs', 'routeDetail', 'Inventory', 'SummaryPost', 'imageRoutePoint', 'TrRouteForMap', 'TaskLogRouteReportData', 'assetsByRouteBundleId', 'AllAssetsTypes', 'Report', 'AssetByID', '$state', 'BaseUrl', '$http', 'RouteGeofence'];

    function TrRoutePlanDetailController($scope, $rootScope, $stateParams, previousState, entity, TrRouteBundle, User, RouteType, TrRouteImages, TrRouteRecordings, AlertService, $window, $localStorage, getRouteImage, Configs, routeDetail, Inventory, SummaryPost, imageRoutePoint, TrRouteForMap, TaskLogRouteReportData, assetsByRouteBundleId, AllAssetsTypes, Report, AssetByID, $state, BaseUrl, $http, RouteGeofence) {
        var vm = this;

        vm.trRoute = entity;
        vm.previousState = previousState.name;
        vm.downloadRouteBundleKml = downloadRouteBundleKml;
        vm.decodeImage = decodeImage;
        vm.showTaskLogReport = showTaskLogReport;
        var unsubscribe = $rootScope.$on('trakeyeApp:trRouteUpdate', function (event, result) {
            vm.trRoute = result;
        });
        var latlng = null;
        vm.mapAssets = [];
        vm.showRouteAttachment = false
        vm.expandResponse = []
        var existingHighlight;
        var existingHighlightFixed;
        var activeInfo;
        var colors = [];
        vm.showAssetAttributesModal = showAssetAttributesModal;
        vm.closeAssetAttributesModal = closeAssetAttributesModal;
        vm.closeThreePointReference = closeThreePointReference;
        var infowindow = new google.maps.InfoWindow();
        var openedInfoWindow = null;
        var lastOpenedInfoWindow = null;
        var polylineTimer, spreadPoly;

        var uniqueColors = [
            "#FF0000", "#0000FF", "#008000", "#FFFF00", "#FFA500", "#800080", "#FFC0CB", "#00FFFF", "#FF00FF",
            "#008080", "#E6E6FA", "#A52A2A", "#800000", "#000080", "#808000", "#00FF00", "#FFDAB9", "#000000",
            "#808080", "#C0C0C0", "#FFD700", "#4B0082", "#EE82EE", "#40E0D0", "#D2B48C", "#FA8072", "#FF7F50",
            "#F0E68C", "#DC143C", "#7CFC00"
        ];
        var phasePolylines = []
        var phaseMarkers = []
        var coordinateListMaintenance = []
        var coordinateListRollout = []
        var coordinateListPlanSurvey = []
        var coordinateListPlanning = []
        var assetSpreadListPlanning = []
        var assetSpreadListMaintenance = []
        var assetSpreadListRollout = []
        var assetSpreadListPlanSurvey = []

        vm.showRouteDetailBoQSoQ = true;
        vm.showRouteDetailLinkBudget = true;
        vm.showRouteDetailSectionTab = true;
        vm.showRouteDetailRowsTab = true;
        vm.showRouteDetailTerrainsTab = true;
        vm.showRouteDetailTasksTab = true;
        vm.showRouteDetailSummaryTab = true;
        vm.showRouteDetailCommentsTab = true;

        var colors = uniqueColors.map(function (color) {
            return { color: color, used: false };
        });

        AllAssetsTypes.getAll(function (response) {
            vm.assetTypeValues = response.length ? response : null
        });

        Configs.get("RouteImage", function (response) {
            if (response.length > 0) {
                if (response[0].configValue == "True") {
                    vm.showRouteAttachment = true
                }
            }
        })

        Configs.get("Features", function (response) {
            response.filter(function (value) {
                if (value.configKey == "RouteDetailBoQSoQ") {
                    if (value.configValue == "True") {
                        vm.showRouteDetailBoQSoQ = true
                    } else {
                        vm.showRouteDetailBoQSoQ = false
                    }
                }
                if (value.configKey == "RouteDetailLinkBudget") {
                    if (value.configValue == "True") {
                        vm.showRouteDetailLinkBudget = true
                    } else {
                        vm.showRouteDetailLinkBudget = false
                    }
                }
                if (value.configKey == "RouteDetailSectionTab") {
                    if (value.configValue == "True") {
                        vm.showRouteDetailSectionTab = true
                    } else {
                        vm.showRouteDetailSectionTab = false
                    }
                }
                if (value.configKey == "RouteDetailTerrainsTab") {
                    if (value.configValue == "True") {
                        vm.showRouteDetailTerrainsTab = true
                    } else {
                        vm.showRouteDetailTerrainsTab = false
                    }
                }

                if (value.configKey == "RouteDetailRowsTab") {
                    if (value.configValue == "True") {
                        vm.showRouteDetailRowsTab = true
                    } else {
                        vm.showRouteDetailRowsTab = false
                    }
                }

                if (value.configKey == "RouteDetailTasksTab") {
                    if (value.configValue == "True") {
                        vm.showRouteDetailTasksTab = true
                    } else {
                        vm.showRouteDetailTasksTab = false
                    }
                }

                if (value.configKey == "RouteDetailSummaryTab") {
                    if (value.configValue == "True") {
                        vm.showRouteDetailSummaryTab = true
                    } else {
                        vm.showRouteDetailSummaryTab = false
                    }
                }

                if (value.configKey == "RouteDetailCommentsTab") {
                    if (value.configValue == "True") {
                        vm.showRouteDetailCommentsTab = true
                    } else {
                        vm.showRouteDetailCommentsTab = false
                    }
                }
            })
        });

        vm.imageInNewTab = function (img) {
            var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                img +
                '">'
            );
            imgWindow.document.close();
        };


        /* $scope.newTabDisplay = function(id,imgid){
            var request = new XMLHttpRequest()
                
                request.open(
                        "GET",
                        'api/routepoint-images/'+id+'/'+imgid,
                        true
                );
                
                request.setRequestHeader(
                    "Authorization",
                    "Bearer " + $localStorage.authenticationToken
                );
                request.responseType = "blob";
                request.onload = response;
    
                function response(e) {
                    if (this.status === 200) {
                        var urlCreator = window.URL || window.webkitURL;
                        var imageUrl = urlCreator.createObjectURL(this.response);
                        window.open(imageUrl, "_blank");
                    }
                }
                request.send();
        }  */

        $scope.$on('$destroy', unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };

        $scope.allimages = false;
        //		$scope

        $scope.toggle = function (id) {
            switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrRouteImages.query(
                            {
                                routeId: vm.trRoute.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.routeImages = data.filter(function (routeImages) {
                                return routeImages.image
                            });

                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getRouteImage.get(vm.trRoute.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }



			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/route_"+vm.trRoute.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrRouteImages.query({
					routeId : vm.trRoute.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.routeImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

        //		$scope.playAudio = function() {
        ////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/route_"+vm.trRoute.id+".mp3";
        //            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/route_15570572.mp3";
        //	        var audio = new Audio(urlStr);
        //	        audio.play();
        //	    };


        function decodeImage(img) {
            return window.atob(img);
        }

        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };


        $scope.setTab = function (newTab) {

            if (newTab == 8) {
                //Comment Box
                vm.objectComments = {}
                vm.objectComments.entityId = entity.id
                vm.objectComments.entityName = "ROUTE"
            }
            if (newTab == 1) {
                getRouteSections();
            }

            if (newTab == 3) {
                if (vm.dailyLogsTxSummary.routeTasks.length) {
                    $scope.tab = 4;
                    showTaskLogReport(vm.trRoute.id);
                } else if (vm.dailyLogsTxSummary.sectionTasks.length) {
                    $scope.tab = 7;
                    showTaskLogReport(vm.trRoute.id);
                } else {
                    $scope.tab = 11;
                }
            }

            $scope.tab = newTab;

        }


        /*  routeDetail.getSection(entity.id,function(response){
             vm.sectionResponse = response
         })
          */
        routeDetail.getTask(entity.id, function (response) {
            vm.taskResponse = response
        })

        routeDetail.getRoutesDetails(entity.id, function (response) {
            vm.sectionResponse = response
        })

        var locations = {};
        var markers = [];
        var coordinateList = []
        var chainageList = []
        var markerList = []
        var iconSize = 24
        var center = {
            lat: parseFloat($rootScope.DEFAULT_LATITUDE),
            lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
        };

        locations.map = new google.maps.Map(
            document.getElementById("map_canvasStart"),
            myOption(15, center)
        );

        function templateBg(color) {
            return '<img class="square" style="background-color:' +
                color +
                ';">'
        }

        vm.phaseFilter = []
        vm.blockFilter = []
        var tempColor = {
            "PLANNING": "#FD7A24",
            "PROPOSED": "#0096FF",
            "ROLLOUT": "#7FFF00",
            "MAINTENANCE": "#DE3163"
        }

        var isObjBool = {
            "PLANNING": false,
            "PROPOSED": false,
            "ROLLOUT": false,
            "MAINTENANCE": false
        }


        if (vm.trRoute && vm.trRoute.routePoints != null && vm.trRoute.routePoints.length) {


            vm.trRoute.routePoints.forEach(function (each) {

                if (each.routePointType == "COORDINATE" && each.phase != null) {

                    callSwitchPhaseCoordinate(each, each.phase)
                    isObjBool[each.phase] = true

                }/* else if(each.routePointType == "MARKER"){
                   markerList.push({lat:each.latitude,lng:each.longitude})
               } */else if (each.routePointType == "CHAINAGE" && each.phase != null) {
                    isObjBool[each.phase] = true
                    chainageList.push({ latitude: each.latitude, longitude: each.longitude, type: each.routePointType, number: each.routePointNumber, phase: each.phase })
                }
            })

            callPhaseCoordinate()

            /* if(markerList.length){
                locations.map.setCenter(markerList[0]);
                createMarkers(markerList,'content/images/markersPoint.png',locations.map,null)
            }  */

            if (chainageList.length) {

                locations.map.setCenter(chainageList[0]);
                createMarkers(chainageList, 'content/images/chainagePoints.png', locations.map, null)

            }

            callObjPhases()

        }

        function callObjPhases() {
            if (isObjBool["PLANNING"]) {
                vm.phaseFilter.push({ name: "PLANNING", selected: true, strokeColor: templateBg("#FD7A24") })
            }

            if (isObjBool["PROPOSED"]) {
                vm.phaseFilter.push({ name: "PROPOSED", selected: true, strokeColor: templateBg("#0096FF") })

            }

            if (isObjBool["ROLLOUT"]) {
                vm.phaseFilter.push({ name: "ROLLOUT", selected: true, strokeColor: templateBg("#7FFF00"), color: "#7FFF00" })

            }

            if (isObjBool["MAINTENANCE"]) {
                vm.phaseFilter.push({ name: "MAINTENANCE", selected: true, strokeColor: templateBg("#DE3163"), color: "#DE3163" })

            }
        }

        function callPhaseCoordinate() {
            if (coordinateListPlanning.length) {

                locations.map.setCenter(coordinateListPlanning[0]);
                var polyline = new google.maps.Polyline({
                    path: coordinateListPlanning,
                    geodesic: true,
                    strokeColor: tempColor["PLANNING"],
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                    name: "PLANNING"
                });

                coordinateListPlanning.forEach(function (each) {
                    createInfoWindow(polyline, each)
                })

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (coordinateListPlanSurvey.length) {
                //vm.phaseFilter.push({name:"PROPOSED",selected:true,strokeColor:templateBg("#0096FF")})

                locations.map.setCenter(coordinateListPlanSurvey[0]);
                var polyline = new google.maps.Polyline({
                    path: coordinateListPlanSurvey,
                    geodesic: true,
                    strokeColor: tempColor["PROPOSED"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "PROPOSED"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (coordinateListRollout.length) {
                //vm.phaseFilter.push({name:"ROLLOUT",selected:true,strokeColor:templateBg("#7FFF00"), color:"#7FFF00"})

                locations.map.setCenter(coordinateListRollout[0]);
                var polyline = new google.maps.Polyline({
                    path: coordinateListRollout,
                    geodesic: true,
                    strokeColor: tempColor["ROLLOUT"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "ROLLOUT"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (coordinateListMaintenance.length) {
                //vm.phaseFilter.push({name:"MAINTENANCE",selected:true,strokeColor:templateBg("#DE3163"), color :"#DE3163"})

                locations.map.setCenter(coordinateListMaintenance[0]);
                var polyline = new google.maps.Polyline({
                    path: coordinateListMaintenance,
                    geodesic: true,
                    strokeColor: tempColor["MAINTENANCE"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "MAINTENANCE"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }
        }

        function callPhaseSpread() {
            if (assetSpreadListPlanning.length) {
                //vm.phaseFilter.push({name:"PLANNING",selected:true,strokeColor:templateBg("#FD7A24")})
                locations.map.setCenter(assetSpreadListPlanning[0]);

                var polyline = new google.maps.Polyline({
                    path: assetSpreadListPlanning,
                    geodesic: true,
                    strokeColor: tempColor["PLANNING"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "PLANNING"
                });

                // Set the map to display the polyline
                assetSpreadListPlanning.forEach(function (each) {
                    createInfoWindow(polyline, each)
                    polyline.set('block', each.block);
                })
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }


            if (assetSpreadListPlanSurvey.length) {
                //vm.phaseFilter.push({name:"PROPOSED",selected:true,strokeColor:templateBg("#0096FF")})

                locations.map.setCenter(assetSpreadListPlanSurvey[0]);
                var polyline = new google.maps.Polyline({
                    path: assetSpreadListPlanSurvey,
                    geodesic: true,
                    strokeColor: tempColor["PROPOSED"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "PROPOSED"
                });

                assetSpreadListPlanSurvey.forEach(function (each) {
                    createInfoWindow(polyline, each)
                    polyline.set('block', each.block);
                })
                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (assetSpreadListRollout.length) {
                //vm.phaseFilter.push({name:"ROLLOUT",selected:true,strokeColor:templateBg("#7FFF00"), color:"#7FFF00"})

                locations.map.setCenter(assetSpreadListRollout[0]);
                var polyline = new google.maps.Polyline({
                    path: assetSpreadListRollout,
                    geodesic: true,
                    strokeColor: tempColor["ROLLOUT"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "ROLLOUT"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (assetSpreadListMaintenance.length) {
                //vm.phaseFilter.push({name:"MAINTENANCE",selected:true,strokeColor:templateBg("#DE3163"), color :"#DE3163"})

                locations.map.setCenter(assetSpreadListMaintenance[0]);
                var polyline = new google.maps.Polyline({
                    path: assetSpreadListMaintenance,
                    geodesic: true,
                    strokeColor: tempColor["MAINTENANCE"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "MAINTENANCE"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }
        }

        function callSwitchPhaseCoordinate(each, ph) {
            switch (ph) {
                case "PLANNING":
                    coordinateListPlanning.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;

                case "PROPOSED":
                    coordinateListPlanSurvey.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;

                case "ROLLOUT":
                    coordinateListRollout.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;

                case "MAINTENANCE":
                    coordinateListMaintenance.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;
            }
        }

        function callSwitchPhaseSpread(each, ph, name, block) {
            switch (ph) {
                case "PLANNING":
                    assetSpreadListPlanning.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, name: name, block: block })
                    break;

                case "PROPOSED":
                    assetSpreadListPlanSurvey.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, name: name, block: block })
                    break;

                case "ROLLOUT":
                    assetSpreadListRollout.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, block: block })
                    break;

                case "MAINTENANCE":
                    assetSpreadListMaintenance.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, block: block })
                    break;
            }
        }

        $scope.togglePhase = function () {
            if (vm.selectedPhase.length) {
                clearPhase()
                vm.selectedPhase.forEach(function (each) {
                    for (var i = 0; i < phasePolylines.length; i++) {
                        if (phasePolylines[i].name === each.name) {
                            if (each.selected) {
                                phasePolylines[i].setMap(locations.map);
                            }
                        }
                    }
                    for (var i = 0; i < phaseMarkers.length; i++) {
                        if (phaseMarkers[i].name === each.name) {
                            if (each.selected) {
                                phaseMarkers[i].setMap(locations.map);
                            }
                        }
                    }
                })
            } else {
                clearPhase()
            }
        };

        $scope.toggleBlock = function () {
            if (vm.selectedBlock.length) {
                clearPhase()
                vm.selectedBlock.forEach(function (each) {
                    for (var i = 0; i < phasePolylines.length; i++) {
                        if (phasePolylines[i].block === each.name /* || phasePolylines[i].block == null */) {
                            if (each.selected) {
                                phasePolylines[i].setMap(locations.map);
                            }
                        }
                    }
                    for (var i = 0; i < phaseMarkers.length; i++) {
                        if (phaseMarkers[i].block === each.name /* || phasePolylines[i].block == null */) {
                            if (each.selected) {
                                phaseMarkers[i].setMap(locations.map);
                            }
                        }
                    }
                })
            } else {
                clearPhase()
                vm.phaseFilter.forEach(function (item) {
                    item.selected = false
                })
            }
        };

        function createMarkers(arr, img, map, str) {
            var marker, markerSymbol
            arr.forEach(function (each) {
                marker = new google.maps.Marker({
                    position: { lat: each.latitude, lng: each.longitude },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                    name: each.phase
                });


                google.maps.event.addListener(
                    marker,
                    "click",
                    (function () {
                        //var name = (each.name == (undefined || null)) ? " " : each.name
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }


                        infowindow.setContent(
                            '<div class="infoWindowhead"></br></br>' +
                            /* "<b>Name : "+name+"</b></br>"+ */
                            "<b>Latitude : " + each.latitude + "</b></br>" +
                            "<b>Longitude : " + each.longitude + "</b></br>" +
                            "<b>Type : " + each.type + "</b></br>" +
                            "<b>Number : " + each.number + "</b></br>" +
                            "</br></div>"
                        );


                        infowindow.open(map);
                        infowindow.setPosition({
                            lat: each.latitude,
                            lng: each.longitude,
                        });
                        openedInfoWindow = infowindow;
                    }))



                /*   markerSymbol = new google.maps.Marker({
                     icon:  {
                         path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                         strokeColor: tempColor[each.phase],
                         fillColor: tempColor[each.phase],
                         fillOpacity:1,
                         scale: 1,
                         labelOrigin: new google.maps.Point(-1, 7)
                     },
                     map: locations.map,
                     position:  { lat: each.latitude, lng: each.longitude },
                     name:each.phase
                 });  */
                phaseMarkers.push(marker);
                //phaseMarkers.push(markerSymbol);


            })
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
            {
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#EFEFEF",
                    },
                ],
            }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        /* vm.expand = function(section,str) {
            vm.sectionResponse.forEach(function (item) {
                item.material = false;
                item.tasks = false;
                item.resource = false;
            });
            
            if (vm.toggle == section.id) {
                vm.toggle = undefined;
            } else {
                switch(str){
                    case "material":
                        vm.expandResponse = null
                        vm.headers = null
                        Inventory.materialTxn(section.id,function(response){
                            vm.headers = [ 
                            { key: "materialName", display: "Material Name" },
                            { key: "noOfUnits", display: "No of Units" },
                            { key: "transactionType", display: "Transaction Type" },
                            { key: "transactionDate", display: "Transaction Date" },
                        ]
                            vm.expandResponse = response
                        }) 
                        section.material = true;
                        vm.toggle = section.id;
                        break;
        
                    case "resource":
                        vm.expandResponse = null
                        vm.headers = null
                        Inventory.resourceTxn(section.id,function(response){
                            vm.headers = [ 
                                { key: "resourceName", display: "Resource Name" },
                                { key: "noOfResources", display: "No of Resource" },
                                { key: "transactionType", display: "Transaction Type" },
                                { key: "transactionDate", display: "Transaction Date" },
                            ]
                            vm.expandResponse = response
                        })
                        section.resource = true;
                        vm.toggle = section.id;
                        break;
        
                    case "tasks":
                        vm.expandResponse = null
                        vm.headers = null
                        Inventory.taskBySection(section.id,function(response){
                            vm.headers = [ 
                                { key: "name", display: "Name" },
                                { key: "taskType", display: "Task Type" }
                            ]
                            vm.expandResponse = response
                        })
                        section.tasks = true;
                        vm.toggle = section.id;
                         break; 
                    
                    default : console.log("default")
                   }
             }
        } */


        vm.expand = function (section, str) {
            vm.sectionResponse.forEach(function (item) {
                item.tasks = false;
            });

            if (vm.toggle == section.sectionId) {
                vm.toggle = undefined;
            } else {
                switch (str) {
                    case "tasks":
                        vm.expandResponse = null
                        vm.headers = null
                        routeDetail.postSectionsDetails({ "sectionIds": [section.sectionId] }, function (response) {
                            vm.headers = [
                                { key: "taskName", display: "Task Name" },
                                { key: "userLogin", display: "Assigned To" }
                            ]
                            vm.expandResponse = response
                        })
                        section.tasks = true;
                        vm.toggle = section.sectionId;
                        break;

                    default: console.log("default")
                }
            }
        }

        SummaryPost.dailyLogsTx({
            "projectIds": [vm.trRoute.projectId],
            "routeIds": [vm.trRoute.id]
        }, function (response) {
            vm.dailyLogsTxSummary = response
        })

        SummaryPost.mtrlTx({
            "projectIds": [vm.trRoute.projectId],
            "routeIds": [vm.trRoute.id]
        }, function (response) {
            vm.mtrlTxSummary = response
        })

        SummaryPost.resTx({
            "projectIds": [vm.trRoute.projectId],
            "routeIds": [vm.trRoute.id]
        }, function (response) {
            vm.resTxSummary = response
        })

        vm.objectRouteImg = {}
        vm.objectRouteImg.routeId = vm.trRoute.id
        vm.objectRouteImg.map = locations.map

        vm.mapFilterList = [];
        var polylines = []
        var tempPath = []


        TrRouteForMap.getTerrainPathByRoute(
            vm.trRoute.id,
            function (response) {
                vm.terrainPathResponse = response

                callTerrainPath()

            }, function (err) {
                /* vm.mapFilterList.push({
                    name:
                        '<strong>' + vm.trRoute.name + '</strong>',
                    path: coordinateList,
                    visible: true,
                    strokeColor: '<img class="square" style="background-color:#' +
                        'FD7A24' +
                        ';">',
                    colorCode: 'FD7A24',
                    routeDisable: true
                })

                for (var i = 0; i < vm.mapFilterList.length; i++) {
                    var line = new google.maps.Polyline({
                        path: vm.mapFilterList[i].path,
                        visible: vm.mapFilterList[i].visible,
                        strokeColor: '#' + vm.mapFilterList[i].colorCode,
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                        name: vm.mapFilterList[i].name
                    });
                    line.setMap(locations.map);
                    polylines.push(line);
                } */

                TrRouteForMap.getRoWPathByRoute(
                    vm.trRoute.id,
                    function (response) {
                        vm.rowPathResponse = response
                        if (response.length) {
                            vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                            callRowPath()
                        }

                    }
                );
            }
        );

        function callTerrainPath() {

            TrRouteForMap.getTerrainByRoute(
                vm.trRoute.id,
                function (nameResponse) {
                    vm.terrainListResponse = nameResponse
                    if (nameResponse.length) {
                        vm.isShowFilter = true
                        /* vm.mapFilterList.push({
                            name:
                                '<strong>' + vm.trRoute.name + '</strong>',
                            path: coordinateList,
                            visible: true,
                            strokeColor: '<img class="square" style="background-color:#' +
                                'FD7A24' +
                                ';">',
                            colorCode: 'FD7A24',
                            routeDisable: true,

                        }) */
                        vm.mapFilterList.push({ name: '<strong>Terrain</strong>', msGroup: true })
                        nameResponse.forEach(function (nameEach, indexName) {
                            if (vm.terrainPathResponse.length) {
                                vm.terrainPathResponse.forEach(function (item, indexPath) {
                                    if (nameEach.id == item.id) {
                                        if (
                                            item.value["COORDINATE"]
                                        ) {
                                            item.value["COORDINATE"].forEach(function (cord) {
                                                tempPath.push({ lat: cord.latitude, lng: cord.longitude })
                                            })

                                            var colorCode = randomColor()
                                            vm.mapFilterList.push({
                                                name:
                                                    nameEach.name,
                                                path: tempPath,
                                                visible: true,
                                                strokeColor: '<img class="square" style="background-color:' +
                                                    colorCode +
                                                    ';">',
                                                colorCode: colorCode
                                            });
                                            tempPath = []
                                        }
                                    }
                                });
                            }

                            for (var i = 0; i < vm.mapFilterList.length; i++) {
                                var line = new google.maps.Polyline({
                                    path: vm.mapFilterList[i].path,
                                    visible: vm.mapFilterList[i].visible,
                                    strokeColor: vm.mapFilterList[i].colorCode,
                                    strokeOpacity: 1.0,
                                    strokeWeight: 2.5,
                                    name: vm.mapFilterList[i].name
                                });
                                line.setMap(locations.map);
                                polylines.push(line);
                            }
                        });
                        vm.mapFilterList.push({ msGroup: false })

                        TrRouteForMap.getRoWPathByRoute(
                            vm.trRoute.id,
                            function (response) {
                                vm.rowPathResponse = response
                                if (response.length) {
                                    vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                    callRowPath()
                                }

                            }
                        );
                    } else {
                        /* vm.mapFilterList.push({
                            name:
                                '<strong>' + vm.trRoute.name + '</strong>',
                            path: coordinateList,
                            visible: true,
                            strokeColor: '<img class="square" style="background-color:#' +
                                'FD7A24' +
                                ';">',
                            colorCode: 'FD7A24',
                            routeDisable: true
                        })

                        for (var i = 0; i < vm.mapFilterList.length; i++) {
                            var line = new google.maps.Polyline({
                                path: vm.mapFilterList[i].path,
                                visible: vm.mapFilterList[i].visible,
                                strokeColor: '#' + vm.mapFilterList[i].colorCode,
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                                name: vm.mapFilterList[i].name
                            });
                            line.setMap(locations.map);
                            polylines.push(line);
                        } */

                        TrRouteForMap.getRoWPathByRoute(
                            vm.trRoute.id,
                            function (response) {
                                vm.rowPathResponse = response
                                if (response.length) {
                                    vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                    callRowPath()
                                }

                            }
                        );
                    }
                },
                function (error) {
                    /* vm.mapFilterList.push({
                        name:
                            '<strong>' + vm.trRoute.name + '</strong>',
                        path: coordinateList,
                        visible: true,
                        strokeColor: '<img class="square" style="background-color:#' +
                            'FD7A24' +
                            ';">',
                        colorCode: 'FD7A24',
                        routeDisable: true
                    })

                    for (var i = 0; i < vm.mapFilterList.length; i++) {
                        var line = new google.maps.Polyline({
                            path: vm.mapFilterList[i].path,
                            visible: vm.mapFilterList[i].visible,
                            strokeColor: '#' + vm.mapFilterList[i].colorCode,
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                            name: vm.mapFilterList[i].name
                        });
                        line.setMap(locations.map);
                        polylines.push(line);
                    } */

                    TrRouteForMap.getRoWPathByRoute(
                        vm.trRoute.id,
                        function (response) {
                            vm.rowPathResponse = response
                            if (response.length) {
                                vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                callRowPath()
                            }

                        }
                    );
                }
            );
        }

        function callRowPath() {

            TrRouteForMap.getRoWByRoute(
                vm.trRoute.id,
                function (nameResponse) {
                    vm.rowListResponse = nameResponse
                    if (nameResponse.length) {
                        nameResponse.forEach(function (nameEach, indexName) {
                            if (vm.rowPathResponse.length) {
                                vm.rowPathResponse.forEach(function (item, indexPath) {
                                    if (nameEach.id == item.id) {
                                        if (
                                            item.value["COORDINATE"]
                                        ) {
                                            item.value["COORDINATE"].forEach(function (cord) {
                                                tempPath.push({ lat: cord.latitude, lng: cord.longitude })
                                            })

                                            var colorCode = randomColor()
                                            vm.mapFilterList.push({
                                                name:
                                                    nameEach.name,
                                                path: tempPath,
                                                visible: true,
                                                strokeColor: '<img class="square" style="background-color:' +
                                                    colorCode +
                                                    ';">',
                                                colorCode: colorCode
                                            });
                                            tempPath = []
                                        }
                                    }
                                });
                            }

                            for (var i = 0; i < vm.mapFilterList.length; i++) {
                                var line = new google.maps.Polyline({
                                    path: vm.mapFilterList[i].path,
                                    visible: vm.mapFilterList[i].visible,
                                    strokeColor: vm.mapFilterList[i].colorCode,
                                    strokeOpacity: 1.0,
                                    strokeWeight: 2.5,
                                    name: vm.mapFilterList[i].name
                                });
                                line.setMap(locations.map);
                                polylines.push(line);
                            }
                        });
                        vm.mapFilterList.push({ msGroup: false })
                    }
                }
            );
        }
        $scope.togglePolyline = function () {
            if (vm.selectedTerrainName.length) {
                clearPolyLines()
                vm.selectedTerrainName.forEach(function (each) {
                    for (var i = 0; i < polylines.length; i++) {
                        if (polylines[i].name === each.name) {
                            if (each.visible) {
                                polylines[i].setMap(locations.map);
                            }
                        }
                    }
                })
            } else {
                clearPolyLines()
            }
        };


        function clearPolyLines() {
            for (var i = 0; i < polylines.length; i++) {

                polylines[i].setMap(null);

            }
        }


        /*  vm.closeModal = function(id) {
          vm.nameImages = null
          $("#" + id).removeClass("in");
          $(".modal-backdrop").remove();
          $("#" + id).hide();
      } */

        $scope.type = {
            terrain: {
                search: "Search",
                nothingSelected: "Map Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            },
            phase: {
                search: "Search",
                nothingSelected: "Phase Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            },
            block: {
                search: "Search",
                nothingSelected: "Block Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            }
        };

        function randomColor() {
            var unusedColors = colors.filter(function (color) {
                return !color.used;
            });
            if (unusedColors.length === 0) return null;
            var randomIndex = Math.floor(Math.random() * unusedColors.length);
            var randomColor = unusedColors[randomIndex];
            randomColor.used = true;
            return randomColor.color;
        }

        function createMetaTag(attrName, attrValue, content) {
            var meta = document.createElement('meta');
            meta.setAttribute(attrName, attrValue);
            meta.setAttribute('content', content);
            return meta;
        }

        function createTable(classNames) {
            var table = document.createElement('table');
            table.setAttribute('border', '1');
            table.setAttribute('cellpadding', '5');
            table.setAttribute('cellspacing', '0');
            table.setAttribute('id', 'sheet0');
            table.setAttribute('class', classNames);
            return table;
        }

        function createTableCell(tagName, textContent) {
            var cell = document.createElement(tagName);
            cell.textContent = textContent;
            return cell;
        }

        function showTaskLogReport(routeId) {
            vm.isReportGenerated = false;
            TaskLogRouteReportData.query(
                {
                    reportType: "daily",
                    routeId: routeId
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                var htmlDoc = document.createElement('html');
                var head = document.createElement('head');
                var meta1 = createMetaTag('http-equiv', 'Content-Type', 'text/html; charset=utf-8');
                var meta2 = createMetaTag('name', 'generator', 'PhpSpreadsheet, https://github.com/PHPOffice/PhpSpreadsheet');
                var meta3 = createMetaTag('name', 'author', 'Apache POI');
                var meta4 = createMetaTag('name', 'company', 'Microsoft Corporation');
                head.appendChild(meta1);
                head.appendChild(meta2);
                head.appendChild(meta3);
                head.appendChild(meta4);
                var body = document.createElement('body');
                var table = createTable('sheet0 gridlines');
                var thead = document.createElement('thead');
                var tbody = document.createElement('tbody');

                function createTable(classNames) {
                    var table = document.createElement('table');
                    table.setAttribute('border', '1');
                    table.setAttribute('cellpadding', '5');
                    table.setAttribute('cellspacing', '0');
                    table.setAttribute('id', 'sheet0');
                    table.setAttribute('class', classNames);
                    return table;
                }

                function createMetaTag(attrName, attrValue, content) {
                    var meta = document.createElement('meta');
                    meta.setAttribute(attrName, attrValue);
                    meta.setAttribute('content', content);
                    return meta;
                }

                function createTableCell(tag, content) {
                    var cell = document.createElement(tag);
                    cell.textContent = content;
                    return cell;
                }

                thead.className = 'thReport';
                table.appendChild(thead);
                tbody.className = 'tdReport';
                table.appendChild(tbody);
                var styleElement = document.createElement('style');
                styleElement.textContent = "\
        .subheader {\
            margin: auto;\
        }\
        .thReport > tr > th{\
            text-align: center;\
            padding: 10px;\
        }\
        .tdReport > tr > td {\
            text-align: center; \
            padding: 10px; \
        }\
    ";
                document.head.appendChild(styleElement);

                var groupedData = {};
                data.forEach(function (item) {
                    if (!groupedData[item.date]) {
                        groupedData[item.date] = [];
                    }
                    groupedData[item.date].push(item);
                });
                var names = data.map(function (item) { return item.name; }).filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                });
                var nameHeaderRow = document.createElement('tr');
                var serialNumberHeader = createTableCell('th', 'S.No');
                serialNumberHeader.style.backgroundColor = 'orange';
                serialNumberHeader.rowSpan = 2;
                nameHeaderRow.appendChild(serialNumberHeader);
                var dateHeader = createTableCell('th', 'Date');
                dateHeader.style.backgroundColor = 'orange';
                dateHeader.rowSpan = 2;
                nameHeaderRow.appendChild(dateHeader);
                var typeHeaderRow = document.createElement('tr');

                names.forEach(function (name, index) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    var availableTypes = nameData.map(function (item) { return item.type; }).filter(function (value, index, self) {
                        return self.indexOf(value) === index;
                    });
                    var nameHeaderCell = createTableCell('th', name);
                    nameHeaderCell.style.backgroundColor = 'lightgreen';
                    nameHeaderCell.colSpan = availableTypes.length;
                    nameHeaderRow.appendChild(nameHeaderCell);
                    availableTypes.forEach(function (type) {
                        var typeHeaderCell = createTableCell('th', type);
                        typeHeaderCell.style.backgroundColor = 'lightgreen';
                        typeHeaderRow.appendChild(typeHeaderCell);
                    });
                });
                var totalProgressHeader = createTableCell('th', 'Total Progress');
                totalProgressHeader.style.backgroundColor = 'lightgray';
                totalProgressHeader.colSpan = 3;
                nameHeaderRow.appendChild(totalProgressHeader);
                var subHeaders = [
                    {
                        type: 'Total',
                    },
                    {
                        type: "Ducting",
                    }, {
                        type: "Validation",

                    }
                ];
                subHeaders.forEach(function (subHeader) {
                    var subHeaderCell = createTableCell('th', subHeader.type);
                    subHeaderCell.style.backgroundColor = 'lightgray';
                    typeHeaderRow.appendChild(subHeaderCell);
                });
                thead.appendChild(nameHeaderRow);
                thead.appendChild(typeHeaderRow);
                var totals = {};
                Object.keys(groupedData)
                    .sort(function (a, b) { return new Date(a) - new Date(b); })
                    .forEach(function (date, index) {
                        var tr = document.createElement('tr');
                        var serialNumberCell = createTableCell('td', index + 1);
                        serialNumberCell.style.backgroundColor = 'orange';
                        tr.appendChild(serialNumberCell);
                        var dateCell = createTableCell('td', date);
                        dateCell.style.backgroundColor = 'orange';
                        tr.appendChild(dateCell);
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name; });
                            var availableTypes = nameData.map(function (item) { return item.type; }).filter(function (value, index, self) {
                                return self.indexOf(value) === index;
                            });

                            availableTypes.forEach(function (type) {
                                var item = groupedData[date].find(function (item) {
                                    return item.name === name && item.type === type;
                                });
                                var lengthValue = item ? item.length : 0;
                                var td = createTableCell('td', lengthValue);
                                tr.appendChild(td);
                                if (!totals[type]) {
                                    totals[type] = 0;
                                }
                                totals[type] += lengthValue;
                            })
                        });
                        var total = 0;
                        for (var i = 2; i < tr.cells.length; i++) {
                            total += parseInt(tr.cells[i].textContent);
                        }
                        var columnValueCell = createTableCell('td', total);
                        columnValueCell.colSpan = 1;
                        tr.appendChild(columnValueCell);

                        var remainingDuctingCell = createTableCell('td', 0);
                        tr.appendChild(remainingDuctingCell);

                        var remainingValidationCell = createTableCell('td', 0);
                        tr.appendChild(remainingValidationCell);
                        tbody.appendChild(tr);
                    });

                var staticColumns = ['Total', 'Balance Validation', 'Balance Ducting', 'Material Issued', 'Wastage', 'Stock at Site'];
                var allAvailableTypes = [];
                names.forEach(function (name) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    allAvailableTypes.push.apply(allAvailableTypes, nameData.map(function (item) { return item.type; }).filter(function (value, index, self) {
                        return self.indexOf(value) === index;
                    }));
                });
                var availableTypes = allAvailableTypes.filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                });
                var maxUniqueTypesCount = availableTypes.length;
                var totalLength = maxUniqueTypesCount + subHeaders.length + 2;

                var columnTotals = {};
                for (var i = 2; i < totalLength; i++) {
                    var total = 0;
                    for (var j = 0; j < tbody.rows.length; j++) {
                        var cellValue = parseInt(tbody.rows[j].cells[i].textContent) || 0;
                        total += cellValue;
                    }
                    columnTotals[i] = total;
                }

                staticColumns.forEach(function (column) {
                    var staticRow = document.createElement('tr');
                    var columnNameCell = createTableCell('td', column);
                    columnNameCell.colSpan = 2;
                    columnNameCell.style.backgroundColor = 'lightblue';
                    columnNameCell.style.fontSize = "14px";
                    columnNameCell.style.fontWeight = 'bold';
                    staticRow.appendChild(columnNameCell);

                    if (column == 'Total') {
                        for (var i = 2; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', columnTotals[i].toString());
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                    } else {
                        for (var i = 0; i < totalLength - 2; i++) {
                            var columnValueCell = createTableCell('td', '0');
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                    }
                    tbody.appendChild(staticRow);
                });

                table.appendChild(thead);
                table.appendChild(tbody);
                body.appendChild(table);
                htmlDoc.appendChild(body);
                htmlDoc.appendChild(head);
                var htmlString = htmlDoc.outerHTML;
                var containerDiv = document.getElementById("generatedHtmlContainer");
                containerDiv.innerHTML = htmlString;

                // Set background color for specified cells
                var jcbCells = document.querySelectorAll('.row1 .column0'); // Select cells in row 1, column 0 (JCB)
                var hddCells = document.querySelectorAll('.row1 .column1'); // Select cells in row 1, column 1 (HDD)

                // Loop through JCB cells and set background color to light green
                jcbCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Loop through HDD cells and set background color to light green
                hddCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Get the Total row
                // Select all relevant rows
                var relevantRows = ['.row2', '.row3', '.row5', '.row6'];

                // Loop through each relevant row
                relevantRows.forEach(function (rowClass) {
                    var cells = document.querySelectorAll(rowClass + ' td');

                    // Loop through the cells in the row
                    cells.forEach(function (cell) {
                        // Check if the content of the cell is '0' or empty
                        if (cell.textContent.trim() === '0' || cell.textContent.trim() === '') {
                            // Set background color to white
                            cell.style.backgroundColor = 'white';
                        }
                    });
                });

                vm.isReportGenerated = true;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function clearPhase() {
            for (var i = 0; i < phasePolylines.length; i++) {

                phasePolylines[i].setMap(null);

            }

            for (var i = 0; i < phaseMarkers.length; i++) {

                phaseMarkers[i].setMap(null);

            }
        }


        function createInfoWindow(polyline, each) {
            google.maps.event.addListener(
                polyline,
                "click",
                (function () {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                        /* if (spreadPoly != null) {
                            spreadPoly.setMap(null);
                        } */
                    }

                    /*   clearTimeout(polylineTimer);
  
                      spreadPoly = new google.maps.Polyline({
                          path: {
                              lat: each.lat,
                              lng: each.lng,
                          },
                          strokeColor: "#FFFF00",
                          strokeOpacity: 0.6,
                          strokeWeight: 19,
                      });
  
                      spreadPoly.setMap(locations.map);
  
                      polylineTimer = setTimeout(function () {
                          if (spreadPoly != null) {
                              spreadPoly.setMap(null);
                              spreadPoly = null;
                          }
                      }, 5000); */

                    var name = each.name ? "<b>Name : " + each.name + "</b></br>" : ""
                    var block = each.block ? "<b>Block : " + each.block + "</b></br>" : ""
                    /*  if (openedInfoWindow != null) {
                         openedInfoWindow.close();
                     } */


                    infowindow.setContent(
                        '<div class="infoWindowhead"></br></br>' +
                        name +
                        "<b>Latitude : " + each.lat + "</b></br>" +
                        "<b>Longitude : " + each.lng + "</b></br>" +
                        block +
                        "</br></div>"
                    );


                    infowindow.open(locations.map);
                    infowindow.setPosition({
                        lat: each.lat,
                        lng: each.lng,
                    });
                    openedInfoWindow = infowindow;
                }))
        }
        vm.mapAssets = [];
        callAssetsRouteByID(vm.trRoute.id, null);
        getRouteSections();
        function callAssetsRouteByID(routeId, lastId) {
            assetsByRouteBundleId.get(routeId, lastId, function (data) {
                data.assets.forEach(function (asset) {
                    var tmpAsset = {};

                    tmpAsset.assetCoordinates = asset.assetCoordinates;
                    tmpAsset.assetTypeName = asset.assetTypeName;
                    tmpAsset.assetTypeColor = asset.assetColor;
                    tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                    tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                    tmpAsset.id = asset.id;
                    tmpAsset.name = asset.name;
                    tmpAsset.burried = asset.burried;
                    tmpAsset.isExisting = asset.isExisting;
                    tmpAsset.isUsed = asset.isUsed;
                    vm.mapAssets.push(tmpAsset);
                });

                if (data.assets.length >= 100) {
                    callAssetsRouteByID(
                        vm.trRoute.id,
                        data.assets[data.assets.length - 1].id
                    );
                } else {
                    if(vm.mapAssets.length>0){
                        drawLatestAssets(vm.mapAssets);

                        if(vm.mapAssets[0].assetCoordinates.length >0){
                            locations.map.setCenter({ lat: vm.mapAssets[0].assetCoordinates[0].latitude, lng: vm.mapAssets[0].assetCoordinates[0].longitude });
                            locations.map.setZoom(11);
                        }

                        var searchInput = document.createElement("input");
                        searchInput.type = "text";
                        searchInput.placeholder = "Search asset...";
                        searchInput.style.position = "absolute";
                        searchInput.style.top = "10px";
                        searchInput.style.left = "50%";
                        searchInput.style.transform = "translateX(-50%)";
                        searchInput.style.zIndex = "5";
                        searchInput.style.padding = "5px";
                        searchInput.style.border = "1px solid #ccc";
                        searchInput.style.borderRadius = "4px";
                        document.getElementById("map_canvasStart").appendChild(searchInput);
                        searchInput.addEventListener("input", function () {
                            var searchTerm = searchInput.value.toLowerCase();
                            var foundAsset = null;
                            vm.mapAssets.forEach(function (asset) {
                                if (asset.name.toLowerCase().includes(searchTerm)) {
                                    foundAsset = asset;
                                }
                            })
                            if (foundAsset) {
                                var coordinates = foundAsset.assetCoordinates.map(function (coord) {
                                    return { lat: coord.latitude, lng: coord.longitude };
                                });
                                if (coordinates.length > 0) {
                                    locations.map.setCenter(coordinates[0]);
                                    locations.map.setZoom(15);
                                }
                            }
                        });
                    }
                }
            });
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 12,
                    center: locations.latlng,
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(12, locations.latlng)
                );
                geoLocation(locations.map);
                document.getElementById("myspan").textContent = "";
                /* var measureTool = new MeasureTool(locations.map, {
                    contextMenu: true,
                    unit: MeasureTool.UnitTypeId.METRIC,
                }); */
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () { };
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById("map_canvas");

            callback();
        }

        function drawLatestAssets(response) {
            if (response) {
                setupAssetMap(function () {
                    $.each(response, function (index, value) {
                        if (value.assetTypeLayout == null) {
                            value.assetTypeName = value.assetType.name;
                            value.assetTypeLayout = value.assetType.layout;
                            value.assetTypeImagePath =
                                value.assetType.imagePath;
                        }
                        if (
                            value.assetTypeLayout != null &&
                            value.assetTypeLayout == "FIXED"
                        ) {
                            if (value.assetCoordinates.length > 1) {
                                // drawPolyline(value);
                                var value1 = value;
                                value1.assetCoordinates = [
                                    value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                    ],
                                ];

                                if (
                                    $scope.selectedFilterAssetTypes.length >
                                    0
                                ) {
                                    $scope.selectedFilterAssetTypes.forEach(
                                        function (assetTypeVal) {
                                            if (
                                                assetTypeVal.name ==
                                                value1.assetTypeName
                                            ) {
                                                drawFixedAsset(
                                                    value1
                                                );
                                            }
                                        }
                                    );
                                } else {
                                    drawFixedAsset(value1);
                                }
                            } else {
                                drawFixedAsset(value);
                            }
                        }
                        if (
                            value.assetTypeLayout != null &&
                            value.assetTypeLayout == "SPREAD"
                        ) {
                            drawPolyline(
                                value
                            );
                        }
                    });
                });
            }
        }
        function drawFixedAsset(fixed) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var iconUrl = fixed.assetTypeImagePath;
                iconSize = 24;
                if (fixed.assetCoordinates.length > 0) {
                    var latitude = fixed.assetCoordinates[0].latitude
                    var longitude = fixed.assetCoordinates[0].longitude
                    var startMarker = new google.maps.Marker({
                        map: locations.map,
                        position: { lat: latitude, lng: longitude },
                        title: fixed.name,
                        icon: {
                            scaledSize: new google.maps.Size(24, 24),
                            url: iconUrl,
                            anchor: new google.maps.Point(
                                12 / 24,
                                12 / 24
                            ),
                            labelOrigin: new google.maps.Point(25, 22),
                        },
                    });

                    markers.push(startMarker);


                    var infoWindow2 = new google.maps.InfoWindow();
                    var infoStr = "";
                    var otdr = "";

                    var userContent = document.createElement("div"),
                        button;

                    userContent.innerHTML =
                        '<div class="infoWindowhead">' +
                        startMarker.title +
                        '</div><div class="infoWindowContent">' +
                        "<b>Lat</b> :" +
                        fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                            .latitude +
                        "<br><b>Long</b> :" +
                        fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                            .longitude +
                        "<br>" +
                        infoStr +
                        "</div>";
                    google.maps.event.addListener(
                        startMarker,
                        "dblclick",
                        function () {
                            infoWindow2.close();
                        }
                    );

                    var activeInfoWindow;
                    var prevInfoWindow;
                    var infoWindow2 = new google.maps.InfoWindow({
                        content: userContent,
                    });
                    function updateMarkerLabelVisibility() {
                        var currentZoom = locations.map.getZoom();
                        if (currentZoom > 12) {
                            if (fixed.assetTypeName == "GP"||fixed.assetTypeName == "ONT") {
                                startMarker.setLabel({
                                    color: "red",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                    text: fixed.name,
                                    className: "asset_label top-label"
                                });
                            }
                        } else {
                            startMarker.setLabel(null);
                        }
                        var style = document.createElement('style');
                        style.innerHTML = '.top-label {' +
                            '    position: relative; /* Needed for top positioning */' +
                            '    top: 30px; /* Adjust this value to move the label higher */' +
                            '    left: 0;' +
                            '    transform: translateX(10%); /*center the label*/' +
                            '    white-space: nowrap; /*prevent wrapping*/' +
                            '}';
                        document.head.appendChild(style);
                    }
                    var updateIconSize = function () {
                        var zoom = locations.map.getZoom();

                        // Define minimum and maximum zoom levels
                        var minZoom = 8;
                        var maxZoom = 21;

                        // Define minimum and maximum icon sizes
                        var minSize = 6;  // Smallest size at zoom 8
                        var maxSize = 60;  // Full size at zoom 21

                        // Compute new size based on zoom level
                        var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);

                        var icon = {
                            url: startMarker.getIcon().url,  // Keep the existing marker image
                            scaledSize: new google.maps.Size(newSize, newSize),  // Only use scaledSize
                            anchor: new google.maps.Point(newSize / 2, newSize), // Adjust anchor to prevent clipping
                        };

                        startMarker.setIcon(icon);
                    };

                    // Run updateIconSize once to initialize
                    updateIconSize();

                    // Listen for zoom changes
                    google.maps.event.addListener(locations.map, "zoom_changed", function () {
                        updateIconSize();
                        updateMarkerLabelVisibility()
                    });
                    // add listener on InfoWindow for click
                    // event
                    google.maps.event.addListener(
                        startMarker,
                        "click",
                        function () {
                            if (existingHighlightFixed != null) {
                                existingHighlightFixed.setMap(null);
                                existingHighlightFixed = null;
                            }

                            var circle = new google.maps.Circle({
                                map: locations.map, // The map object
                                center: { lat: startMarker.map.center.lat(), lng: startMarker.map.center.lng() }, // Center of the circle (same as the marker)
                                radius: 2, // Radius in meters (1000 meters = 1 kilometer)
                                strokeColor: '#fd7a24', // Color of the circle's border
                                strokeOpacity: 0.8, // Opacity of the circle's border
                                strokeWeight: 2, // Width of the circle's border
                                fillColor: '#fd7a24', // Fill color of the circle
                                fillOpacity: 1, // Opacity of the circle's fill color
                            });

                            // Bind the circle to the marker so it moves with the marker if the marker is draggable
                            circle.bindTo('center', startMarker, 'position');
                            existingHighlightFixed = circle;

                            var fixedHighlightTimer = setTimeout(function () {
                                if (circle != null) {
                                    circle.setMap(null);
                                    circle = null;
                                }
                            }, 6000);

                            if (activeInfo != null) {
                                activeInfo.close();
                            }
                            closeLastOpenedInfoWindow();

                            AssetByID.get(fixed.id, function (response) {
                                vm.assetRefAttributes = [];
                                if (response.assetReferenceAttributes.length) {
                                    response.assetReferenceAttributes.forEach(
                                        function (get) {
                                            get[
                                                "assetAttributeName"
                                            ].assetTypeAttribute.attributeValue =
                                                get[
                                                    "assetAttributeName"
                                                ].attributeValue;
                                            vm.assetRefAttributes.push(
                                                get["assetAttributeName"]
                                                    .assetTypeAttribute
                                            );
                                            get[
                                                "assetAttributeValue"
                                            ].assetTypeAttribute.attributeValue =
                                                get[
                                                    "assetAttributeValue"
                                                ].attributeValue;
                                            vm.assetRefAttributes.push(
                                                get["assetAttributeValue"]
                                                    .assetTypeAttribute
                                            );
                                            get[
                                                "assetAttributeImage"
                                            ].assetTypeAttribute.attributeValue =
                                                get["assetAttributeImage"].image;
                                            get[
                                                "assetAttributeImage"
                                            ].assetTypeAttribute.attributeName =
                                                get["assetAttributeImage"].imageName;
                                            get[
                                                "assetAttributeImage"
                                            ].assetTypeAttribute.imageId =
                                                get["assetAttributeImage"].imageId;
                                            get[
                                                "assetAttributeImage"
                                            ].assetTypeAttribute.attributeType =
                                                get["assetAttributeImage"].imageType;
                                            vm.assetRefAttributes.push(
                                                get["assetAttributeImage"]
                                                    .assetTypeAttribute
                                            );
                                        }
                                    );
                                }
                                vm.assetToEdit = {};
                                vm.assetToEdit = response;
                                vm.assetAttachments = response;
                                var infoWindow2 = new google.maps.InfoWindow();
                                var infoStr = "";
                                var otdr = "";
                                var assetTypeAttributeValuesList =
                                    response.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (a, b) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = a.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        home.attributeValue;
                                    otdr = home;
                                }

                                var userContent = document.createElement("div"),
                                    btnShowAttributes,
                                    btnThreePointRef

                                var url = $state.href('asset-detail', { id: response.id });

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' + /* 
                                "<b>Id</b> : <a target='_blank' href='" + url + "'>" + */ response.id +
                                    "</a><br><b>Name</b>" +
                                    response.name +
                                    '</div><div class="infoWindowContent">' +
                                    "<b>Asset Type</b> : " +
                                    fixed.assetTypeName +
                                    "<br><b>Latitude</b> :" +
                                    fixed.assetCoordinates[
                                        fixed.assetCoordinates.length - 1
                                    ].latitude +
                                    "<br><b>Longitude</b> :" +
                                    fixed.assetCoordinates[
                                        fixed.assetCoordinates.length - 1
                                    ].longitude +
                                    "</div>";

                                vm.assetTitle = response.name;

                                var attr = document.createAttribute("data-toggle");
                                attr.value = "modal";
                                var attr1 = document.createAttribute("data-target");
                                attr1.value = "#myModalMap";


                                btnShowAttributes = userContent.appendChild(
                                    document.createElement("input")
                                );

                                btnShowAttributes.type = "button";
                                btnShowAttributes.value = "Show Attributes";
                                btnShowAttributes.className = "button";

                                btnThreePointRef = userContent.appendChild(
                                    document.createElement("input")
                                );
                                btnThreePointRef.type = "button";
                                btnThreePointRef.value = "3 Point Reference";
                                btnThreePointRef.className = "button";

                                google.maps.event.addDomListener(
                                    btnShowAttributes,
                                    "click",
                                    function () {
                                        showAssetAttributesModal(response);
                                    }
                                );

                                google.maps.event.addDomListener(
                                    btnThreePointRef,
                                    "click",
                                    function () {
                                        showThreePontReferenceModal(response);
                                    }
                                );

                                vm.closeInfoWindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });
                                if (prevInfoWindow != null) prevInfoWindow.close();
                                vm.closeInfoWindow.open(locations.map, startMarker);
                                setTimeout(function () {
                                    vm.closeInfoWindow.close();
                                }, 10000);

                                activeInfoWindow = vm.closeInfoWindow;
                                prevInfoWindow = vm.closeInfoWindow;
                            });
                        }
                    );
                    openedInfoWindow = infoWindow2;
                }
            });
        }

        var polyLines = []
        function drawPolyline(spread) {
            var spreadAssetCoordinates = [];
            var spreadColor = 0;
            var spreadWidth = 0;
            var spreadOpacity = 0;

            if(Array.isArray(vm.assetTypeValues) && vm.assetTypeValues.length > 0){
                vm.assetTypeValues.forEach(function (assetType) {
                if (assetType.name == spread.assetTypeName) {
                    spreadColor = assetType.colorcode;
                    spreadWidth = assetType.lineWidth * 0.05;
                    spreadOpacity = assetType.transparency * 0.01;
                }
            });
            }
            // spread.assetCoordinates.sort(function (a, b) {
            //     return a.id - b.id; // Ascending order
            // });
            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var infowindow = null;
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spreadColor;
                }
                var polylineWeight = spreadWidth;
                var strokeOpacityVal = spreadOpacity;

                polylineColor = "#00A36C";

                if (spread.isCycle) {
                    polylineColor = "#FFD700";
                    // } else if (!spread.isConnected) {
                } else if (!spread.isExisting) {
                    polylineColor = "#ff0025"; //tmpColor = "blue";
                }
                if(!spread.isUsed && spread.isExisting){
                    polylineColor = "#FFAE42";
                }
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                    zIndex: 2
                });
                polyLines.push(polylinepath);
                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {

                        if (existingHighlight != null) {
                            existingHighlight.setMap(null);
                            existingHighlight = null;
                        }

                        var polylinepathHighlight = new google.maps.Polyline({
                            path: spreadAssetCoordinates,
                            strokeColor: "#FFFF00",
                            strokeOpacity: 0.6,
                            strokeWeight: 19,
                        });


                        polylinepathHighlight.setMap(locations.map);
                        existingHighlight = polylinepathHighlight;

                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        closeLastOpenedInfoWindow();
                        var disVal = 0;

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD" || spread.assetType.layout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                vm.assetToEdit = {};
                                vm.assetToEdit = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }
                                var assetTypeAttrPopupNames = [];
                                assetVal.assetType.assetTypeAttributes.forEach(
                                    function (assetTypeAttrVal) {
                                        if (
                                            assetTypeAttrVal.assetTypePopupDisplay ==
                                            true
                                        ) {
                                            assetTypeAttrPopupNames.push(
                                                assetTypeAttrVal.name
                                            );
                                        }
                                    }
                                );
                                var getAttribute =
                                    assetVal.assetTypeAttributeValues;
                                var userContent = document.createElement("div"),
                                    btnShowAttributes,
                                    btnEditAssets;

                                var url = $state.href('asset-detail', { id: spread.id });

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' + "<b>Id</b> : <a target='_blank' href='" + url + "'>" + spread.id +
                                    "</a><br><b>Name : </b> " +
                                    spread.name +
                                    "<br><b>Asset Type : </b> " +
                                    spread.assetType.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km";

                                for (i = 0; i < getAttribute.length; i++) {
                                    if (
                                        assetTypeAttrPopupNames.includes(
                                            getAttribute[i].assetTypeAttribute
                                                .name
                                        )
                                    ) {
                                        userContent.innerHTML +=
                                            "<b>" +
                                            getAttribute[i].assetTypeAttribute
                                                .name +
                                            "</b>" +
                                            " : " +
                                            getAttribute[i].attributeValue +
                                            "</br>";
                                    }
                                }

                                btnShowAttributes = userContent.appendChild(
                                    document.createElement("input")
                                );

                                btnShowAttributes.type = "button";
                                btnShowAttributes.value = "Show Attributes";
                                btnShowAttributes.className = "button";

                                google.maps.event.addDomListener(
                                    btnShowAttributes,
                                    "click",
                                    function () {
                                        showAssetAttributesModal(assetVal);
                                    }
                                );
                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });

                                if (infowindow != null) {
                                    infowindow.setPosition(event.latLng);
                                    infowindow.open(locations.map);
                                    openedInfoWindow = infowindow;
                                }
                            });
                        }

                    }
                );

                polylinepath.setMap(locations.map);
                polylines.push(polylinepath);
            }
        }

        function closeLastOpenedInfoWindow() {
            if (lastOpenedInfoWindow) {
                lastOpenedInfoWindow.close();
            }
            if (vm.closeInfoWindow) {
                vm.closeInfoWindow.close();
            }
            if (openedInfoWindow) {
                openedInfoWindow.close();
            }
        }

        function showAssetAttributesModal(assetVal) {
            $("#modalAssetAttributes").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues;
            document.getElementById("assetAttributeTable").innerHTML = "";

            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Name</th><th style='border: 1px solid black;text-align: center;'>Value</th></tr>";

            assetTypeAttributeValuesList.forEach(function (value) {
                // if (
                //     value.assetTypeAttribute.assetAttributeTypes ==
                //     "NON_REFERENCE"
                // ) {
                //     newTable +=
                //         "<tr><td style='border: 1px solid black;text-align: center;'>" +
                //         (value.assetTypeAttribute.name || "N/A") +
                //         "</td><td style='border: 1px solid black;text-align: center;'>" +
                //         (value.attributeValue || "NA") +
                //         "</td></tr>";
                // }
                newTable +=
                    "<tr><td style='border: 1px solid black;text-align: center;'>" +
                    (value.assetTypeAttribute.name || "N/A") +
                    "</td><td style='border: 1px solid black;text-align: center;'>" +
                    (value.attributeValue || "NA") +
                    "</td></tr>";
            });
            newTable += "</table>";
            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }

        function showThreePontReferenceModal(assetVal) {
            $("#modalThreePointReference").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues,
                assetReferenceAttributesList =
                    assetVal.assetReferenceAttributes,
                referenceAttribute = [];
            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Object</th><th style='border: 1px solid black;text-align: center;'>Distance (mtr)</th></tr>";
            var ref = [];
            var dist = [];
            if (assetVal.assetReferenceAttributes.length) {
                assetReferenceAttributesList.forEach(function (val) {
                    referenceAttribute.push(val["assetAttributeName"]);
                    referenceAttribute.push(val["assetAttributeValue"]);
                });
                referenceAttribute.forEach(function (val) {
                    if (
                        val.assetTypeAttribute.assetAttributeTypes ==
                        "THREE_PNT_REFERENCE"
                    ) {
                        if (
                            val.assetTypeAttribute.name ==
                            "3 Point Reference1" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name ==
                            "3 Point Reference2" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name ==
                            "3 Point Reference3" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance1" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance2" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance3" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        }
                    }
                });
            } else {
                assetTypeAttributeValuesList.forEach(function (value) {
                    if (
                        value.assetTypeAttribute.assetAttributeTypes ==
                        "THREE_PNT_REFERENCE"
                    ) {
                        if (
                            value.assetTypeAttribute.name ==
                            "3 Point Reference1"
                        ) {
                            ref.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name ==
                            "3 Point Reference2"
                        ) {
                            ref.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name ==
                            "3 Point Reference3"
                        ) {
                            ref.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name == "Distance1"
                        ) {
                            dist.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name == "Distance2"
                        ) {
                            dist.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name == "Distance3"
                        ) {
                            dist.push(value.attributeValue);
                        }
                    }
                });
            }

            for (var i = 0; i < 3; i++) {
                if (ref[i] || dist[i]) {
                    newTable +=
                        "<tr><td style='border: 1px solid black;text-align: center;'>" +
                        ref[i] +
                        "</td><td style='border: 1px solid black;text-align: center;'>" +
                        dist[i] +
                        "</td></tr>";
                }
            }
            newTable += "</table>";
            document.getElementById(
                "assetNameThreePointReference"
            ).textContent = assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById(
                "threePointReferenceTable"
            ).innerHTML = newTable;
        }

        function closeAssetAttributesModal() {
            $("#modalAssetAttributes").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalAssetAttributes").hide();
        }

        function closeThreePointReference() {
            $("#modalThreePointReference").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalThreePointReference").hide();
        }
        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                Math.cos(degrees_to_radians(lat2)) *
                Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }
        function downloadRouteBundleKml() {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block";
            }
            Report.downloadRouteBundleKml({
                id: vm.trRoute.id
            }, function (response) {
                if (spinner) {
                    spinner.style.display = "none"
                }
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([(response)], { type: 'application/text' });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = vm.trRoute.name + ".kml"; BaseUrl
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
        }

        BaseUrl.getBaseUrl(function (baseurl) {

            $scope.downloadExcelBoqSoq = function () {
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) {
                    spinner.style.display = "block";
                }
                var apiUrl = baseurl.stringValue + "api/boq-soq-report-download?routeBundleId=" + vm.trRoute.id;
                $http({
                    method: "GET",
                    url: apiUrl,
                    responseType: "arraybuffer" // Important for binary data
                }).then(function (response) {
                    if (spinner) {
                        spinner.style.display = "none";
                    }
                    var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    var link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "BoQAndSoQ.xlsx"; // File name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(function (error) {
                    console.error("Error downloading Excel file:", error);
                });
            };
        });

        BaseUrl.getBaseUrl(function (baseurl) {
            $scope.downloadLinkBudgetReport = function () {
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) {
                    spinner.style.display = "block";
                }
                var apiUrl = baseurl.stringValue + "api/link-budget-report-download?routeBundleId=" + vm.trRoute.id;

                $http({
                    method: "GET",
                    url: apiUrl,
                    responseType: "arraybuffer" // Important for binary data
                }).then(function (response) {
                    if (spinner) {
                        spinner.style.display = "none";
                    }
                    var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    var link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "LinkBudget.xlsx"; // File name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(function (error) {
                    console.error("Error downloading Excel file:", error);
                });
            };
        });
        vm.layerItems = [];
        vm.selectedLayers = {};
        vm.filteredAssetsList = [];
        vm.layersInitialized = false;
        vm.showLayers = function () {
            if (!vm.layersInitialized) {
                vm.layerItems = [];
                var uniqueAssetTypeNames = {};
                for (var i = 0; i < vm.mapAssets.length; i++) {
                    var item = vm.mapAssets[i];
                    var temp = null;
                    for (var j = 0; j < vm.assetTypeValues.length; j++) {
                        if (vm.assetTypeValues[j].name == item.assetTypeName) {
                            temp = vm.assetTypeValues[j];
                            break;
                        }
                    }
                    item.assetType = temp;
                    item.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(temp);
                    var assetType = item.assetTypeName.trim().toUpperCase();
                    var mapAssetsTypeName = ['OLT'].includes(assetType)
                        ? 'BLOCK'
                        : assetType === 'JOINT KIT'
                            ? 'JUNCTION POINT'
                            : assetType === 'GP'
                                ? 'GP Router'
                                : item.assetTypeName;

                    if (mapAssetsTypeName === "Planned Route" || mapAssetsTypeName === "Planned_Route") {
                        var attrType = item.assetTypeAttributeValues[0] &&
                            item.assetTypeAttributeValues[0].assetTypeAttribute &&
                            item.assetTypeAttributeValues[0].assetTypeAttribute.assetAttributeTypes;
                        if (attrType === "OFC_LAYER" && !uniqueAssetTypeNames["OFC"] || attrType === "NON_REFERENCE" && !uniqueAssetTypeNames["OFC"]) {
                            uniqueAssetTypeNames["OFC"] = true;
                            var ofcSelected = vm.selectedLayers["OFC"] !== undefined ? vm.selectedLayers["OFC"] : true;
                            vm.layerItems.push({
                                name: "OFC",
                                selected: ofcSelected
                            });
                            vm.selectedLayers["OFC"] = ofcSelected;
                        } else if (attrType === "SPAN_LAYER" && !uniqueAssetTypeNames["SPAN"]) {
                            uniqueAssetTypeNames["SPAN"] = true;
                            var spanSelected = vm.selectedLayers["SPAN"] !== undefined ? vm.selectedLayers["SPAN"] : true;
                            vm.layerItems.push({
                                name: "SPAN",
                                selected: spanSelected
                            });
                            vm.selectedLayers["SPAN"] = spanSelected;
                        }
                    } else {
                        if (!uniqueAssetTypeNames[mapAssetsTypeName]) {
                            uniqueAssetTypeNames[mapAssetsTypeName] = true;
                            var layerSelected = vm.selectedLayers[mapAssetsTypeName] !== undefined ? vm.selectedLayers[mapAssetsTypeName] : true;
                            vm.layerItems.push({
                                name: mapAssetsTypeName,
                                selected: layerSelected
                            });
                            vm.selectedLayers[mapAssetsTypeName] = layerSelected;
                        }
                    }
                }
                vm.layersInitialized = true;
            }
        };
        vm.updateSelectedLayers = function () {
            vm.selectedLayers = {};
            for (var i = 0; i < vm.layerItems.length; i++) {
                var layer = vm.layerItems[i];
                if (layer.selected) {
                    vm.selectedLayers[layer.name] = true;
                }
            }
            vm.filterMapByLayers();
        };

        vm.filterMapByLayers = function () {
            clearMarkersPolyLine()
            vm.filteredAssetsList = vm.mapAssets.filter(function (item) {
                var assetType = item.assetTypeName.trim().toUpperCase();
                var mapAssetsTypeName = ['OLT'].includes(assetType)
                    ? 'BLOCK'
                    : assetType === 'JOINT KIT'
                        ? 'JUNCTION POINT'
                        : assetType === 'GP'
                            ? 'GP Router'
                            : item.assetTypeName;

                if (mapAssetsTypeName === "Planned Route" || mapAssetsTypeName === "Planned_Route") {
                    var attrType = item.assetTypeAttributeValues[0] &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute.assetAttributeTypes;
                    if (attrType === "OFC_LAYER" && vm.selectedLayers["OFC"] || attrType === "NON_REFERENCE" && vm.selectedLayers["OFC"]) {
                        return true;
                    }
                    if (attrType === "SPAN_LAYER" && vm.selectedLayers["SPAN"]) {
                        return true;
                    }
                    return false;
                }

                return vm.selectedLayers[mapAssetsTypeName];
            });

            for (var k = 0; k < vm.filteredAssetsList.length; k++) {
                var asset = vm.filteredAssetsList[k];

                if (asset.assetCoordinates) {
                    var assetCoordinateValues = asset.assetCoordinates.map(function (each) {
                        return { lat: each.latitude, lng: each.longitude };
                    });

                    if (assetCoordinateValues.length > 0) {
                        if (assetCoordinateValues[0].sortOrder != null) {
                            assetCoordinateValues.sort(function (a, b) {
                                return a.sortOrder - b.sortOrder;
                            });
                            //     } else if (assetCoordinateValues[0].id != null) {
                            //         assetCoordinateValues.sort(function (a, b) {
                            //             return a.id - b.id;
                            //         });
                        }
                    }

                    if (asset.assetTypeLayout === "SPREAD") {
                        drawPolyline(asset);
                    } else if (asset.assetTypeLayout === "FIXED") {
                        drawFixedAsset(asset);
                    }
                }
            }
        };
        function clearMarkersPolyLine() {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
            markers = [];
            for (var j = 0; j < polyLines.length; j++) {
                polyLines[j].setMap(null);
            }
            polyLines = [];
        }

        function getConsolidatedAssetTypeAttributeValue(assetType) {
            var assetTypeAttributeValuesList = [];

            for (var index in assetType.assetTypeAttributes) {
                var assetTypeAttribute1 = assetType.assetTypeAttributes[index];
                assetTypeAttributeValuesList.push({
                    assetTypeAttribute: assetTypeAttribute1,
                    attributeValue: assetType.assetTypeAttributes[index].defaultValue,
                });
            }

            assetTypeAttributeValuesList.sort(function (a, b) {
                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                    nameB = b.assetTypeAttribute.name.toLowerCase();
                if (nameA < nameB)
                    // sort string ascending
                    return -1;
                if (nameA > nameB) return 1;
                return 0; // default return value (no sorting)
            });
            return assetTypeAttributeValuesList;
        }
        vm.geofenceCoordinates = [];
        RouteGeofence.query(
            {
                routeBundle_id: vm.trRoute.id,
            },
            onSuccess,
            onError
        );
        
        function onSuccess(response, headers) {
            if (Array.isArray(response) && response.length > 0) {
                response.forEach(function (item) {
                    if (item && item.coordinates && typeof item.coordinates === 'string' && item.coordinates.trim() !== "") {
                        try {
                            var coordinates = JSON.parse(item.coordinates);
                            var polygonCoords = coordinates.map(function (coord) {
                                return {
                                    lat: coord.lat,
                                    lng: coord.lng
                                };
                            });
                            var geofencePolygon = new google.maps.Polygon({
                                paths: polygonCoords,
                                strokeColor: "#fd7a24",
                                strokeOpacity: 1,
                                strokeWeight: 1,
                                fillColor: '#fd7a24',
                                fillOpacity: 0.20,
                                zIndex: 1
                            });
                            geofencePolygon.setMap(locations.map);
                        } catch (e) {
                            console.error("Error parsing coordinates:", e);
                            console.error("Raw coordinates string:", item.coordinates);
                        }
                    } else {
                        console.error("Error: Coordinates are undefined, null, empty, or not a string for item:", item);
                    }
                });
            } else {
                console.log("No Geofence");
            }
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
       

        vm.ringRouteAssets = [];
        function getRouteSections() {
            routeDetail.getRingsByRoute(vm.trRoute.id, function (response) {
                var ringResponse = response;
                ringResponse.sort(function (a, b) {
                    return a.name - b.name;
                });
                vm.ringRouteAssets = ringResponse;
            });
        };
        vm.selectedAssetsToHighlightMultiRing = [];
        vm.updateSelectedAssets = function (asset) {
            var index = -1;
            for (var i = 0; i < vm.selectedAssetsToHighlightMultiRing.length; i++) {
                if (vm.selectedAssetsToHighlightMultiRing[i].id === asset.id) {
                    index = i;
                    break;
                }
            }

            if (asset.isOption) {
                if (index === -1) {
                    vm.selectedAssetsToHighlightMultiRing.push(asset);
                }
            } else {
                if (index !== -1) {
                    vm.selectedAssetsToHighlightMultiRing.splice(index, 1);
                }
            }
            if (vm.selectedAssetsToHighlightMultiRing.length === 0) {
                clearRingPolylines();
            }


            var polyItemIds = [];
            var markerItemIds = [];
            var pendingRequests = vm.selectedAssetsToHighlightMultiRing.length * 2;

            vm.selectedAssetsToHighlightMultiRing.forEach(function (ringId) {
                routeDetail.getAssetsBySections(ringId.id, function (response) {

                    for (var j = 0; j < response.length; j++) {
                        polyItemIds.push(response[j].id);
                    }
                    checkAndExecuteHighlight();
                });

                routeDetail.getFixedAssetsByRouteId(ringId.id, function (response) {
                    for (var k = 0; k < response.length; k++) {
                        markerItemIds.push(response[k].id);
                    }
                    checkAndExecuteHighlight();
                });
            });

            function checkAndExecuteHighlight() {
                pendingRequests--;
                if (pendingRequests === 0) {
                    vm.highlight(polyItemIds);
                    vm.highLightMarkers(markerItemIds);
                }
            }
        };
        var ringPolylines = [];
        vm.highlight = function (Ids) {
            clearRingPolylines();

            var path = {};

            if (Ids.length !== 0) {
                Ids.forEach(function (Id) {
                    var polyline = vm.mapAssets.find(function (p) {
                        return p.id === Id;
                    });
                    if (polyline) {
                        if (!path[polyline.id]) {
                            path[polyline.id] = { coordinates: [] };
                        }
                        polyline.assetCoordinates.forEach(function (each) {
                            path[polyline.id].coordinates.push({
                                lat: each.latitude,
                                lng: each.longitude,
                                id: each.id,
                            });
                        });
                    }
                });

                Object.keys(path).forEach(function (id) {
                    var sessionData = path[id];
                    if (sessionData.coordinates[0].sortOrder != null) {
                        sessionData.coordinates.sort(function (a, b) {
                            return a.sortOrder - b.sortOrder; // Ascending order
                        });
                    }
                    if (sessionData.coordinates.length !== 0) {
                        var newPolyline = new google.maps.Polyline({
                            path: sessionData.coordinates,
                            strokeColor: "#A938F3",
                            strokeOpacity: 0.6,
                            strokeWeight: 16
                        });
                        newPolyline.setMap(locations.map);
                        ringPolylines.push(newPolyline);
                    }
                });
                locations.map.setZoom(12);
                if (path[0]) {
                    locations.map.setCenter(path[0].coordinates[0]);
                }
                polylineTimer = setTimeout(function () {
                    clearRingPolylines();
                }, 100000);
            }
        };

        function clearRingPolylines() {

            ringPolylines.forEach(function (poly) {
                poly.setMap(null);
            });
            ringPolylines = [];

            if (polylineTimer) {
                clearTimeout(polylineTimer);
            }
        }


        var highlightedMarkers = {};

        vm.highLightMarkers = function (Ids) {
            var highlightedSize = 40;

            markers.forEach(function (marker) {
                console.log(marker);
                var assetId = marker.assetDetails ? marker.assetDetails.id : null;

                if (!assetId) {
                    return;
                }

                var isHighlighted = Ids.indexOf(assetId) !== -1;
                var newSize = isHighlighted ? newSizeLevel + 15 : newSizeLevel;
                var currentIcon = marker.getIcon();

                if (currentIcon) {
                    if (isHighlighted) {
                        highlightedMarkers[assetId] = true;
                    } else {
                        delete highlightedMarkers[assetId];
                    }

                    setTimeout(function () {
                        marker.setIcon({
                            url: currentIcon.url,
                            scaledSize: new google.maps.Size(newSize, newSize),
                            anchor: new google.maps.Point(newSize / 2, newSize / 2),
                            labelOrigin: currentIcon.labelOrigin
                        });
                    }, 50);
                }
            });
        };


        vm.activeSection = 'route';

        vm.toggleSection = function (section) {
            if (vm.activeSection === section) {
                vm.activeSection = '';
            } else {
                vm.activeSection = section;
            }
        };

        vm.isSectionVisible = function (section) {
            return vm.activeSection === section;
        };

    vm.downloadSurveyReportExcel = function () {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block";
            }
            BaseUrl.getBaseUrl(function (baseurl) {
                var url = "";
                url = baseurl.stringValue + "api/route-bundle-survey-reportv1/" + vm.trRoute.id + "/"+"SURVEY";
                var request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';
                request.onload = function (e) {
                    if (spinner) {
                        spinner.style.display = "none";
                    }
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'report.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));
                                downloadLink.download = 'Route - ' + vm.trRoute.name + '.xlsx';
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    } else {
                        alert("No data found");
                    }
                };

                request.send();
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrRoutePlanDeleteController',TrRoutePlanDeleteController);

    TrRoutePlanDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrRouteBundle','$scope'];

    function TrRoutePlanDeleteController($uibModalInstance, entity, TrRouteBundle,$scope) {
        var vm = this;

        vm.trRoute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrRouteBundle.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-route-plan', {
                parent: 'app',
                url: '/tr-route-plan',
                data: {
                    authorities: ['ROUTE_SIDEBAR'],
                    pageTitle: 'trakeyeApp.route.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route-plan/tr-routes-plan.html',
                        controller: 'TrRoutePlanController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption: { value: 'day' },
                    fromTime: null,
                    toTime: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption: $stateParams.rangeOption,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trRoute');
                        $translatePartialLoader.addPart('routeStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-route-plan-detail', {
                parent: 'tr-route-plan',
                url: '/tr-route-plan/{id}',
                data: {
                    authorities: ['ROUTE_DETAIL'],
                    pageTitle: 'trakeyeApp.route.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route-plan/tr-route-plan-detail.html',
                        controller: 'TrRoutePlanDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trRoute');
                        $translatePartialLoader.addPart('routeStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrRouteBundle', function ($stateParams, TrRouteBundle) {
                        return TrRouteBundle.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-route',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('tr-route-plan.edit', {
                parent: 'tr-route-plan',
                url: '/Edit/{id}',
                data: {
                    authorities: ['ROUTE_EDIT'],
                    pageTitle: 'trakeyeApp.route.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route-plan/tr-route-plan-dialog.html',
                        controller: 'TrRoutePlanDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrRouteBundle', function ($stateParams, TrRouteBundle) {
                        return TrRouteBundle.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-route',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-route-plan.new', {
                parent: 'tr-route-plan',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}',
                data: {
                    authorities: ['ROUTE_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route-plan/tr-route-plan-dialog.html',
                        controller: 'TrRoutePlanDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            routeImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })
           
            .state('tr-route-plan.delete', {
                parent: 'tr-route-plan',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-route-plan/tr-route-plan-delete-dialog.html',
                        controller: 'TrRoutePlanDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrRouteBundle', function (TrRouteBundle) {
                                return TrRouteBundle.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-route-plan', null, { reload: 'tr-route-plan' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrRouteBundle', TrRouteBundle);

	TrRouteBundle.$inject = ['$resource', 'DateUtils'];

	function TrRouteBundle($resource, DateUtils) {
		var resourceUrl = 'api/tr-routebundles/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			},
			'save': {
				method: 'POST',
				interceptor: {
					responseError: function (response) {
						// Handle error here
						console.error('Error:', response);
					}
				}
			},
		});
	}
})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('RouteBundleByID', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-routebundles/' + id).then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};
		service.postBulkAssets = function (id, data, callback) {
			$http.post('api/v1/bulk-asset-save/' + id, data).then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getConnectedNodes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.postAdjacency = function (payload, callback) {

			$http.post('api/assets/min-cost-path', payload).then(function (response) {
				callback(response.data);
			});
		};

		service.postSuggestcycles = function (payload, callback) {

			$http.post('api/assets/sngl-edge-nodes', payload).then(function (response) {
				callback(response.data);
			});
		};

		service.postSuggestPlan = function (assetName, payload, callback) {
			$http.post('api/assets/bfs-sngl-edge-nodes/' + assetName, payload).then(function (response) {
				callback(response.data);
			});
		};
		service.postSuggestNotConnectedPath = function (id, payload, callback) {
			$http.post('api/assets/path-sngl-edge-nodes/' + id, payload).then(function (response) {
				callback(response.data);
			});
		};
		service.postNeighbouringFixed= function (id, payload, callback) {
			$http.post('api/assets/neighbouring-fixed/' + id, payload).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('SectionSelect', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};

		service.create = function (payload, callback) {
			$http.post('api/tr-section-by-select', payload).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('assetsByRouteBundleId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, lastId, callback) {
			$http.get('api/assets-route-bundle-db/' + id + '/' + lastId).then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('assetsByRouteGeo', ['$rootScope', '$http', function ($rootScope, $http) {
		var service = {};
		service.get = function (geofenceId, state, district, block, lastId, callback) {
			$http.get('api/assets-route-es-geo/' + geofenceId + '/' + state + '/' + district + '/' + block + '/' + lastId).then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('assetsLinking', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.linkAsset = function (callback, errback) {
			$http.get('api/link-assets').then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};

		service.postLinkAsset = function (payload, callback, errback) {
			$http.post('api/link-assets', payload).then(function (response) {
				callback(response.data);
			}, function (err) {
				errback(err)
			});
		};

		service.relinkAsset = function (id, callback) {
			$http.get('api/tr-routes/relink-assets/' + id).then(function (response) {
				callback(response);
			}, function (err) {
				callback(err)
			});
		};

		service.assetRings = function (routeId, size, callback) {
			$http.get('api/asset-rings/' + routeId + '/' + size).then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};
		// service.postSuggestNotConnected = function (id, payload, callback) {
		// 	$http.post('api/assets/path-sngl-edge-nodes/' + id, payload).then(function (response) {
		// 		callback(response.data);
		// 	});
		// };
		return service;
	}]);
})();

(function () {
	"use strict";
	angular.module("trakeyeApp").factory("MappedAssets", MappedAssets);

	MappedAssets.$inject = ["$resource"];

	function MappedAssets($resource) {
		var resourceUrl = "api/mapped-assets/:routeId";

		return $resource(
			resourceUrl,
			{},
			{
				query: {
					method: "GET",
					isArray: true,
				},
			}
		);
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('createSection', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, routeid, callback) {
			$http.get('api/transform-asset/' + id + '/route/' + routeid).then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('StateListByGeo', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (geofenceId, callback) {
			$http.get('api/tr-routes/state-list/' + geofenceId).then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DistrictListByStateGeo', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (geofenceId, state, callback) {
			$http.get('api/tr-routes/district-list/' + geofenceId + '/' + state).then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('BlockListByStateGeo', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (geofenceId, state, district, callback) {
			$http.get('api/tr-routes/block-list/' + geofenceId + '/' + state + '/' + district).then(function (response) {
				callback(response.data);
			}, function (err) {
				callback(err)
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteBundleSearch', TrRouteBundleSearch);

	TrRouteBundleSearch.$inject = ['$resource'];

	function TrRouteBundleSearch($resource) {
		var service = $resource('/api/tr-routebundles/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('RouteGeofence', RouteGeofence);

    RouteGeofence.$inject = ['$resource'];

    function RouteGeofence($resource) {
        var resourceUrl = 'api/geofences/routeBundle/:routeBundle_id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrRoutePlanController", TrRoutePlanController);

    TrRoutePlanController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$compile",
        "BaseUrl",
        "$localStorage",
        "TrRouteBundle",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "TrRouteBundleSearch",
        "assetsLinking"
    ];

    function TrRoutePlanController(
        $scope,
        $rootScope,
        $state,
        $compile,
        BaseUrl,
        $localStorage,
        TrRouteBundle,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        TrRouteBundleSearch,
        assetsLinking
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        vm.downloadSurveyReport = downloadSurveyReport;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var searchVal = $scope.search.replace(/[^\w\s]/g, '_');
                TrRouteBundleSearch.query(
                    {
                        search: searchVal,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.routes = [];
                    data.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.routes.push(value);
                    });
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            TrRouteBundle.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.routes = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.routes.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal,
            });
        }

        function downloadSurveyReport(routeId) {
            BaseUrl.getBaseUrl(function (baseurl) {
                var url = "";
                url = baseurl.stringValue + "api/route-survey-report-excel/" + routeId;
                if (vm.selectedSectionId > 0) {
                    url = baseurl.stringValue + "api/route-survey-report-excel/" + routeId;
                }
                var request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';

                request.onload = function (e) {
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'test.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));
                                downloadLink.download = 'SurveyReport.xlsx';

                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    }
                };
                request.send();
            });
        }

        vm.closeModal = function (id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
            clearInterval(vm.assetLinkInterval);
        };

        vm.showLinkAsset = function (id) {
            vm.labelStatus = "OPEN"
            clearInterval(vm.assetLinkInterval);
            vm.updateProgress = 1
            vm.routeId = id
            callAssetLink()
            vm.assetLinkInterval = setInterval(callAssetLink, 10000);
            $("#linkasset").show();
        }

        vm.getProgressBarColor = function () {
            var attribute
            var borderColor;

            if (vm.labelStatus) {

                switch (vm.labelStatus) {
                    case 'OPEN':
                        borderColor = '#3498db';
                        attribute = 'border-top'
                        // Red for open status
                        break;
                    case 'INPROGRESS':
                        borderColor = '#FFC300';
                        attribute = 'border-top' // Orange for progress status
                        break;
                    case 'COMPLETE':
                        borderColor = '#0BDA51';
                        attribute = 'border' // Green for complete status
                        break;
                    default:
                        borderColor = '#3498db'; // Default color
                        break;
                }

                if (vm.labelStatus == 'COMPLETE') {
                    setTimeout(function () {
                        vm.closeModal("linkasset")
                    }, 1000)
                    return {
                        'border': '10px solid ' + borderColor
                    };
                } else {
                    return {
                        'border': '10px solid ' + borderColor
                    };
                }

            }
        }

        function callAssetLink() {
            assetsLinking.linkAsset(function (responseLink) {

                /* vm.updateProgress += 1

                if (vm.updateProgress >= 98) {
                    vm.updateProgress = 90
                } */

                var temp = responseLink.find(function (item) {
                    return item.entityTypeId == vm.routeId
                })

                if (temp === undefined) {
                    assetsLinking.postLinkAsset({
                        "entityName": "ROUTE",
                        "entityLayout": "SPREAD",
                        "entityTypeId": vm.routeId,
                        "reqByUserId": null,
                        "messageType": "ASSET_LINK",
                    }, function (responseLink) {
                        vm.updateProgress = 10
                        vm.isUpdateProgress = true
                        //vm.assetLinkInterval = setInterval(callAssetLink, 5000);
                    }, function (err) {
                        clearInterval(vm.assetLinkInterval);
                        //vm.closeModal('processing')
                    })
                } else if (temp) {
                    vm.labelStatus = temp.messageStatus
                }



                if (temp && temp.messageStatus == "COMPLETE") {
                    //vm.updateProgress = 100

                    clearInterval(vm.assetLinkInterval);
                }


            }, function (err) {
                clearInterval(vm.assetLinkInterval);
            })

        }

    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrRouteDialogController", TrRouteDialogController);

    TrRouteDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrRoute",
        "AllRouteTypes",
        "AllCustomRouteTypeAttribute",
        "RouteAttributeMappingId",
        "GeofenceIDs",
        'TrProject',
        'ParseLinks', 'AlertService',
        'pagingParams',
        'KmlToCoordinates',
        '$rootScope',
        'Configs',
        'routeDetail'
    ];

    function TrRouteDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrRoute,
        AllRouteTypes,
        AllCustomRouteTypeAttribute,
        RouteAttributeMappingId,
        GeofenceIDs,
        TrProject,
        ParseLinks,
        AlertService,
        pagingParams,
        KmlToCoordinates,
        $rootScope,
        Configs,
        routeDetail
    ) {
        var vm = this;
        vm.trRoute = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trRoute);
        vm.selectAttributes = selectedRouteTypeAttributes;
        vm.routeType = entity.routeType;
        vm.importRouteType = "";
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        var formData;
        vm.customAttributesMap = {};
        vm.customAttributesMapp = [];
        if(vm.trRoute.id!=null){
            loadAssets(vm.trRoute.id, null);
        }
        loadPage();
        var tempGeofenceId, coordinatesSpread, markersPoints, tempPointNumber, chainagePoints
        tempPointNumber = 0
        var locations = {};
        var coordinateList = []
        var markerList = []
        var chainageList = []
        var iconSize = 20
        var disVal = 0;

        if (!vm.trRoute.id) {
            vm.trRoute.routePoints = [];
            vm.isSaving = true


            vm.trRoute.status = "NEW"
            vm.trRoute.phase = "PLANNING"
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        vm.closeModal = function (id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

        vm.openImport = function () {
            $(":file").filestyle({
                buttonBefore: true,
                buttonText: "Browse File",
            });

            vm.importxlsx = /^(.*?)\.(xlsx|kml)$/;
            $("#importRouter").show();
            vm.importRouteType = "";
        }


        function generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0; // Random number between 0 and 15
                var v = c === 'x' ? r : (r & 0x3 | 0x8); // 'y' is set to 8, 9, A, or B
                return v.toString(16); // Convert to hexadecimal
            });
        }

        vm.loadKmlOnMap = function (id) {
            formData = new FormData();

            formData.append("routename", vm.importRouteType);
            formData.append('file', $scope.myFile);

            KmlToCoordinates.getLatLng(formData, function (response, headers) {

                if (response.status == 200) {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.trRoute.routeLength = 0;

                    //vm.trRoute.routePoints = pointList
                    //vm.importRouteType = "";

                    if (vm.importRouteType == "COORDINATE") {
                        var spreadCoordinatesList = [];
                        response.data.forEach(function (path) {
                            var spreadCoordinates = path;
                            $scope.uuid = generateUUID();  // Call custom UUID generation function
                            spreadCoordinates.forEach(function (latlng, index) {
                                tempPointNumber++
                                coordinateList.push({ routePointNumber: tempPointNumber, routePointType: vm.importRouteType, latitude: latlng.lat, longitude: latlng.lng, phase: "PLANNING", sessionNumber: $scope.uuid });

                            });
                            var groupedBySession = {};

                            for (var i = 0; i < spreadCoordinates.length; i++) {
                                var coordinate = spreadCoordinates[i];
                                var session = coordinate.sessionNumber;

                                if (!groupedBySession[session]) {
                                    groupedBySession[session] = [];
                                }

                                groupedBySession[session].push(coordinate);
                            }

                            for (var session in groupedBySession) {
                                groupedBySession[session].sort(function (a, b) {
                                    return a.sortOrder - b.sortOrder; // Sort in ascending order
                                });
                                var spreadCoordinates = groupedBySession[session];
                                var disValPath = 0;

                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disValPath += distanceCal(
                                                spreadCoordinates[index].lat,
                                                spreadCoordinates[index].lng,
                                                spreadCoordinates[index - 1].lat,
                                                spreadCoordinates[index - 1].lng
                                            );
                                        }
                                    }
                                }
                                disVal += disValPath;
                            }
                            vm.trRoute.routeLength = parseInt(disVal * 1000);
                            spreadCoordinatesList.push(spreadCoordinates);
                        });
                        vm.isSaving = false


                    }

                    if (vm.importRouteType == "MARKER") {
                        markersPoints = response.data;
                        response.data.forEach(function (data, index) {
                            var latlng = data[0];
                            $scope.uuid = generateUUID();  // Call custom UUID generation function
                            tempPointNumber++;
                            markerList.push({ routePointNumber: tempPointNumber, routePointType: vm.importRouteType, latitude: latlng.lat, longitude: latlng.lng, phase: vm.trRoute.phase, sessionNumber: $scope.uuid });

                        });
                    }

                    if (vm.importRouteType == "CHAINAGE") {
                        chainagePoints = response.data;
                        response.data.forEach(function (data, index) {
                            var latlng = data[0];
                            $scope.uuid = generateUUID();  // Call custom UUID generation function
                            tempPointNumber++;
                            chainageList.push({ routePointNumber: tempPointNumber, routePointType: vm.importRouteType, latitude: latlng.lat, longitude: latlng.lng, phase: vm.trRoute.phase, sessionNumber: $scope.uuid });

                        });
                    }

                    // $timeout(function () {
                    //     vm.success = '';
                    // }, 4000);

                }
                if (response.status == 400) {
                    vm.success = null;
                    vm.error = 'error';

                }

                if (vm.importRouteType == "COORDINATE" && spreadCoordinatesList) {

                    locations.map.setCenter(spreadCoordinatesList[0][0]);

                    spreadCoordinatesList.forEach(function (coor) {
                        var polyline = new google.maps.Polyline({
                            path: coor,
                            geodesic: true,
                            strokeColor: '#FD7A24',
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                        });

                        // Set the map to display the polyline
                        polyline.setMap(locations.map);
                    });

                }

                if (vm.importRouteType == "MARKER" && markersPoints) {

                    locations.map.setCenter(markersPoints[0][0]);
                    markersPoints.forEach(function (each) {
                        var latlngs = each[0];
                        var marker = new google.maps.Marker({
                            position: { lat: latlngs.lat, lng: latlngs.lng },
                            map: locations.map,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/markersPoint.png",
                                anchor: new google.maps.Point(
                                    iconSize / 2,
                                    iconSize / 2
                                ),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });

                        markersPoints.push(marker);
                    })

                }

                if (vm.importRouteType == "CHAINAGE" && chainagePoints) {


                    locations.map.setCenter(chainagePoints[0][0]);
                    chainagePoints.forEach(function (each) {
                        var latlngs = each[0];
                        var marker = new google.maps.Marker({
                            position: { lat: latlngs.lat, lng: latlngs.lng },
                            map: locations.map,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/chainagePoints.png",
                                anchor: new google.maps.Point(
                                    iconSize / 2,
                                    iconSize / 2
                                ),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });

                        chainagePoints.push(marker);
                    })

                }

            });
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

        if (vm.trRoute.id != null) {
            vm.trRouteType = vm.trRoute.routeType;
        }
        function loadAssets(routeId, lastId) {
            routeDetail.getAssetsById(routeId, lastId, function (response) {
                if (response.assets.length) {
                    vm.assets = response.assets;
                    for (var i = 0; i < vm.assets.length; i++) {
                        vm.trRoute.assets.push(vm.assets[i]);
                        vm.trRoute.routeAssets.push(vm.assets[i]);
                    }
                    vm.assets.forEach(function (asset) {
                        var coordinates = asset.assetCoordinates.map(function (coord) {
                            return { lat: coord.latitude, lng: coord.longitude };
                        });
                        if (asset.assetTypeLayout === 'FIXED') {
                            var marker = new google.maps.Marker({
                                position: coordinates[0],
                                map: locations.map,
                                title: asset.name,
                                icon: {
                                    url: asset.assetTypeImagePath,
                                    scaledSize: new google.maps.Size(32, 32)
                                }
                            });
                            var infowindow = new google.maps.InfoWindow();

                            var updateIconSize = function () {
                                var zoom = locations.map.getZoom();

                                // Define minimum and maximum zoom levels
                                var minZoom = 8;
                                var maxZoom = 21;

                                // Define minimum and maximum icon sizes
                                var minSize = 6;  // Smallest size at zoom 8
                                var maxSize = 60;  // Full size at zoom 21

                                // Compute new size based on zoom level
                                var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);

                                var icon = {
                                    url: marker.getIcon().url,  // Keep the existing marker image
                                    scaledSize: new google.maps.Size(newSize, newSize),  // Only use scaledSize
                                    anchor: new google.maps.Point(newSize / 2, newSize), // Adjust anchor to prevent clipping
                                };

                                marker.setIcon(icon);
                            };

                            // Run updateIconSize once to initialize
                            updateIconSize();

                            // Listen for zoom changes
                            google.maps.event.addListener(locations.map, "zoom_changed", function () {
                                updateIconSize();
                            });

                            google.maps.event.addListener(marker, 'click', function () {
                                if (openedInfoWindow !== null) {
                                    openedInfoWindow.close();
                                }
                                var contentString = document.createElement("div"),
                                    btnShowImage,
                                    btnShowAsset
                                contentString.innerHTML = '<div class="infoWindowhead">' +
                                    "<b>ID: " + asset.id + "</b><br>" +
                                    "<b>Name: " + asset.name + "</b><br>" +
                                    "<b>AssetTypeName: " + asset.assetTypeName + "</b><br>" +
                                    "<b>Latitude: " + coordinates[0].lat + "</b><br>" +
                                    "<b>Longitude: " + coordinates[0].lng + "</b><br>" +
                                    "</div>";
                                infowindow.setContent(contentString);
                                infowindow.open(locations.map, marker);
                                openedInfoWindow = infowindow;
                                if (vm.trRoute.id) {
                                    btnShowImage = contentString.appendChild(
                                        document.createElement("input")
                                    );

                                    btnShowImage.type = "button";
                                    btnShowImage.value = "Show Images";
                                    btnShowImage.className = "button";
                                    google.maps.event.addDomListener(
                                        btnShowImage,
                                        "click",
                                        function () {
                                            AssetByID.get(asset.id, function (imageResponse) {
                                                if (imageResponse && imageResponse.assetImages.length) {
                                                    var imageListDiv = document.createElement("div");
                                                    imageListDiv.className = "image-list";
                                                    imageListDiv.style.marginTop = "10px";
                                                    imageResponse.assetImages.forEach(function (image) {
                                                        var imageLink = document.createElement("div");
                                                        imageLink.innerHTML = image.imageName;
                                                        imageLink.className = "image-name";
                                                        imageLink.style.cursor = "pointer";
                                                        imageLink.style.color = "blue";
                                                        imageLink.style.textDecoration = "underline";
                                                        imageLink.style.marginBottom = "5px";
                                                        imageLink.addEventListener("click", function () {
                                                            $scope.newTabDisplay(asset.id, image.imageId);
                                                        });

                                                        imageListDiv.appendChild(imageLink);
                                                    });
                                                    contentString.appendChild(imageListDiv);
                                                    infowindow.setContent(contentString);
                                                } else {
                                                    alert("No images found.");
                                                }
                                            });
                                        }
                                    );
                                }
                                if (vm.trRoute.id) {
                                    btnShowAsset = contentString.appendChild(
                                        document.createElement("input")
                                    );
                                    btnShowAsset.type = "button";
                                    btnShowAsset.value = "Show attributes";
                                    btnShowAsset.className = "button";
                                    google.maps.event.addDomListener(
                                        btnShowAsset,
                                        "click",
                                        function () {
                                            AssetByID.get(asset.id, function (response) {
                                                showAssetAttributesModal(response);
                                            });
                                        }
                                    );
                                }

                            });

                        } else if (asset.assetTypeLayout === 'SPREAD') {
                            var polylineColor = '#0000FF';
                            var drawPolyline = new google.maps.Polyline({
                                path: coordinates,
                                geodesic: true,
                                strokeColor: polylineColor,
                                strokeOpacity: 0.9,
                                strokeWeight: 3
                            });
                            drawPolyline.setMap(locations.map);
                            var polylineInfoWindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(drawPolyline, 'click', function (event) {
                                if (openedInfoWindow !== null) {
                                    openedInfoWindow.close();
                                }
                                var contentString = '<div class="infoWindowhead">' +
                                    "<b>ID: " + asset.id + "</b><br>" +
                                    "<b>Name: " + asset.name + "</b><br>" +
                                    "<b>AssetTypeName: " + asset.assetTypeName + "</b><br>"
                                contentString += "</div>";
                                polylineInfoWindow.setContent(contentString);
                                polylineInfoWindow.setPosition(event.latLng);
                                polylineInfoWindow.open(locations.map);
                                openedInfoWindow = polylineInfoWindow;
                            });
                        }
                    });

                }
                if (response.assets.length >= 200) {
                    loadAssets(
                        vm.trRoute.id,
                        response.assets[response.assets.length - 1].id
                    );
                }


            });
        }
        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                Math.cos(degrees_to_radians(lat2)) *
                Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

        function loadPage() {

            TrProject.query(
                {
                    page: 0,
                    size: 100,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.projects = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.projects.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
                );
                imgWindow.document.close();
            };

            var routeTypeAttributeValuesList =
                vm.trRoute.routeTypeAttributeValues;

            try {
                for (var index in vm.trRoute.routeType.routeTypeAttribute) {
                    if (
                        !checkIfRouteTypeExists(
                            vm.trRoute.routeType.routeTypeAttribute[index],
                            vm.trRoute.routeTypeAttributeValues
                        )
                    ) {
                        var routeTypeAttribute1 =
                            vm.trRoute.routeType.routeTypeAttribute[index];
                        routeTypeAttributeValuesList.push({
                            routeTypeAttribute: routeTypeAttribute1,
                            attributeValue:
                                vm.trRoute.routeType.routeTypeAttribute[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) { }

            function checkIfRouteTypeExists(routeType, routeTypeAttrVal) {
                var hasRouteType = false;
                for (var i = 0; i < routeTypeAttrVal.length; i++) {
                    var name = routeTypeAttrVal[i].routeTypeAttribute.name;
                    if (name == routeType.name) {
                        hasRouteType = true;
                        break;
                    }
                }
                return hasRouteType;
            }
            AllRouteTypes.getAll(function (response) {
                vm.routeTypes = response;
            });

            AllCustomRouteTypeAttribute.getAll(function (response) {
                //vm.customRouteTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if (arrayItem.customRouteTypeAttributeValues != undefined) {
                        vm.customAttributesMap[arrayItem.name] =
                            arrayItem.customRouteTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }

                });
                if (vm.trRoute.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });


        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function selectedRouteTypeAttributes() {
            vm.showFilter = true;
            if (vm.routeType) {
                vm.trRoute.routeType = vm.routeType;
                if (
                    entity_old.routeType &&
                    vm.routeType.id === entity_old.routeType.id
                ) {
                    vm.trRoute.routeTypeAttributeValues = [];
                    vm.trRoute.routeTypeAttributeValues =
                        entity_old.routeTypeAttributeValues;
                } else {
                    vm.trRoute.routeTypeAttributeValues = [];
                    $.each(
                        vm.routeType.routeTypeAttribute,
                        function (key, value) {
                            vm.trRoute.routeTypeAttributeValues.push({
                                routeTypeAttribute:
                                    vm.routeType.routeTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        function save() {
            //vm.isSaving = true;
            /* vm.trRoute.routePoints = path.getArray().map(function(latLng) {
                return {
                  latitude: latLng.lat(),
                  longitude: latLng.lng()
                };
              }); */
            /* var spreadAV = vm.trRoute.routeTypeAttributeValues;
            for (
                var spreadAssetIndex = 0;
                spreadAssetIndex < spreadAV.length;
                spreadAssetIndex++
            ) {
                if (
                    spreadAV[spreadAssetIndex].routeTypeAttribute
                        .name === "Fiber Distance (km)"
                ) {
                    spreadAV[
                        spreadAssetIndex
                    ].attributeValue = fiberDistance;
                }
            }
            vm.trRoute.routeTypeAttributeValues = spreadAV; */

            if ((!vm.trRoute.id) && (markerList || coordinateList || chainageList)) {
                vm.trRoute.routePoints = (coordinateList || []).concat(markerList || [], chainageList || []);
            }


            if (vm.trRoute.id !== null) {
                TrRoute.update(vm.trRoute, onSaveSuccess, onSaveError);
            } else {
                TrRoute.save(vm.trRoute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:routeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "user-management.new") {
                $state.go("user-management.new");
            } else {
                $state.go("tr-route");
            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        $scope.geofencelabel = {
            search: "Search",
            nothingSelected: "Geofence",
        };

        /*  GeofenceIDs.getAll(function (response) {
             vm.geofencesListView = []
             if ($scope.tab == 1) {
                 if (response.length >= 2) {
                     vm.geofencesListView.push({
                         id: 0,
                         name: "All",
                         label: "All",
                     });
                 }
             }
             response.forEach(function (geofence) {
                 geofence.label = geofence.name.substring(0, 15) + "..";
                 geofence.ticked =
                     tempGeofenceId == geofence.id ? true : false;
                 vm.geofencesListView.push(geofence);
                 if (vm.selectedMapGeofenceId == null) {
                     vm.selectedMapGeofenceId = geofence.id;
                 }
             });
             vm.countLength = vm.geofencesListView.length;
         }); */

        locations.map = new google.maps.Map(
            document.getElementById("map_canvas"),
            {
                center: {
                    lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                    lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                },
                zoom: 13,
                fullscreenControl: true,
                styles: mapStyles(),
            }
            //myOption(16, vm.getCenterEnd)
        );
        //geoLocation(locations.map);
        //vm.getCenterEnd = locationsEnd.map.center;

        /* vm.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYLINE,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: ["polyline"],
            },
            polylineOptions: {
                fillColor: "#ffff00",
                fillOpacity: 1,
                strokeWeight: 5,
                clickable: true,

                editable: true,
                zIndex: 1,
                geodesic: true,
            },
        });

        

        var polyline,path
        google.maps.event.addListener(vm.drawingManager, 'overlaycomplete', function(event) {
            if (event.type == google.maps.drawing.OverlayType.POLYLINE) {
              // Get the path of the drawn polyline
              polyline = event.overlay;
              path = polyline.getPath();
          
              
            }
          });

          vm.drawingManager.setMap(locations.map);
      
        vm.createfence = function(){
            if (polyline) {
                path = polyline.getPath();
          
                var coordinates = path.getArray().map(function(latLng) {
                  return {
                    lat: latLng.lat(),
                    lng: latLng.lng()
                  };
                });
          
                console.log('Polyline coordinates:', coordinates);
                // You can use the coordinates in any way you need here
              } 
        } */


        if (vm.trRoute.id && vm.trRoute.routePoints != null && vm.trRoute.routePoints.length) {
            vm.trRoute.routePoints.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
            var groupedRoutePoints = {};
            vm.trRoute.routePoints.forEach(function (each) {
                if (each.sessionNumber) {
                    if (!groupedRoutePoints[each.sessionNumber]) {
                        groupedRoutePoints[each.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                    }
                    if (each.routePointType === "COORDINATE" && each.phase === "PLANNING") {
                        groupedRoutePoints[each.sessionNumber].coordinates.push({ lat: each.latitude, lng: each.longitude });
                    } else if (each.routePointType === "MARKER") {
                        groupedRoutePoints[each.sessionNumber].markers.push({ lat: each.latitude, lng: each.longitude });
                    } else if (each.routePointType === "CHAINAGE") {
                        groupedRoutePoints[each.sessionNumber].chainages.push({ lat: each.latitude, lng: each.longitude });
                    }
                }
            });
            Object.keys(groupedRoutePoints).forEach(function (sessionNumber) {
                var sessionData = groupedRoutePoints[sessionNumber];
                if (sessionData.coordinates.length) {
                    locations.map.setCenter(sessionData.coordinates[0]);
                    var polyline = new google.maps.Polyline({
                        path: sessionData.coordinates,
                        geodesic: true,
                        strokeColor: '#FD7A24',
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                    });
                    polyline.setMap(locations.map);
                }
                if (sessionData.markers.length) {
                    locations.map.setCenter(sessionData.markers[0]);
                    createMarkers(sessionData.markers, 'content/images/markersPoint.png', locations.map);
                }
                if (sessionData.chainages.length) {
                    locations.map.setCenter(sessionData.chainages[0]);
                    createMarkers(sessionData.chainages, 'content/images/chainagePoints.png', locations.map);
                }
            });
        }

        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                arr.push(marker);
            })
        }

        $('.select2').select2();

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = response;
        });

        Configs.get("RolloutTaskStatus", function (response) {
            vm.rolloutTaskStatus = response;
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrRouteDetailController', TrRouteDetailController);

    TrRouteDetailController.$inject = ['$scope', '$http', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrRoute', 'User', 'RouteType', 'TrRouteImages', 'TrRouteRecordings', 'AlertService', '$window', '$localStorage', 'getRouteImage', 'Configs', 'routeDetail', 'Inventory', 'SummaryPost', 'imageRoutePoint', 'TrRouteForMap', 'TaskLogRouteReportData', 'MaterialByDates', 'MaterialDates', 'ParseLinks', 'RouteByID', 'Report', 'dailyLogByTaskId', 'TaskSectionById', 'TaskStatusById', 'taskComment', 'dailyLog', 'BaseUrl', 'DailyLogByTaskIdWithType', 'AssetByID', 'RouteImageMeta', 'RingGeofence', 'SectionSelect', 'AllAssetsTypes', 'UserAccount', 'AllTerrainTypes', 'TrTerrain', 'AllRowTypes', 'TrRow', 'RouteStatus', '$timeout'];

    function TrRouteDetailController($scope, $http, $rootScope, $stateParams, previousState, entity, TrRoute, User, RouteType, TrRouteImages, TrRouteRecordings, AlertService, $window, $localStorage, getRouteImage, Configs, routeDetail, Inventory, SummaryPost, imageRoutePoint, TrRouteForMap, TaskLogRouteReportData, MaterialByDates, MaterialDates, ParseLinks, RouteByID, Report, dailyLogByTaskId, TaskSectionById, TaskStatusById, taskComment, dailyLog, BaseUrl, DailyLogByTaskIdWithType, AssetByID, RouteImageMeta, RingGeofence, SectionSelect, AllAssetsTypes, UserAccount, AllTerrainTypes, TrTerrain, AllRowTypes, TrRow, RouteStatus, $timeout) {
        var vm = this;
        vm.tabNum = 0;
        vm.trRoute = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        vm.showTaskLogReport = showTaskLogReport;
        vm.downloadRouteKml = downloadRouteKml;
        vm.downloadGpReport = downloadGpReport;
        vm.downloadJointReport = downloadJointReport;
        var unsubscribe = $rootScope.$on('trakeyeApp:trRouteUpdate', function (event, result) {
            vm.trRoute = result;
        });
        vm.showRouteAttachment = false
        vm.expandResponse = []
        vm.storeMaterialTransactionName = []
        vm.activeTab = 'material';
        var colors = [];
        loadAssets(vm.trRoute.id, null);
        var infowindow = new google.maps.InfoWindow();
        var openedInfoWindow = null;
        vm.selectedPaths = [];
        vm.sectionSave = sectionSave;
        var labelFrom, labelTo
        labelFrom = 'From Terrain'
        labelTo = 'To Terrain'
        vm.gpAssets = [];
        var Trmarkers = [];
        var uniqueColors = [
            "#FF0000", "#0000FF", "#008000", "#FFFF00", "#FFA500", "#800080", "#FFC0CB", "#00FFFF", "#FF00FF",
            "#008080", "#E6E6FA", "#A52A2A", "#800000", "#000080", "#808000", "#00FF00", "#FFDAB9", "#000000",
            "#808080", "#C0C0C0", "#FFD700", "#4B0082", "#EE82EE", "#40E0D0", "#D2B48C", "#FA8072", "#FF7F50",
            "#F0E68C", "#DC143C", "#7CFC00"
        ];
        var phasePolylines = []
        var phaseMarkers = []
        var coordinateListMaintenance = []
        var coordinateListRollout = []
        var coordinateListPlanSurvey = []
        var coordinateListPlanning = []
        var assetSpreadListPlanning = []
        var assetSpreadListMaintenance = []
        var assetSpreadListRollout = []
        var assetSpreadListPlanSurvey = []

        //measure tool
        var measureEnabled = false
        var polyMeasureTool, segmentDistance, midpoint
        var totalDistance = 0
        var distanceMarkers = []
        var totalDistanceMarkers = []
        var pointerMarkers = []
        var arrpolyMeasureTool = []
        vm.gotoLatitute = gotoLatitute;
        vm.gotoLatituteCity = gotoLatituteCity;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.closeGotoLatituteCity = closeGotoLatituteCity;
        vm.showZoomLocation = showZoomLocation;
        var gotoMarker = null;
        var measureTool = document.createElement("button");
        var measureToolIcon = document.createElement("i");
        vm.closeAssetAttributesModal = closeAssetAttributesModal;

        vm.showRingDetailGpReport = true;
        vm.showRingDetailJointReport = true;
        vm.showRingDetailSurveyReport = true;
        vm.showRingDetailWorkProgressTab = true;
        vm.showRingDetailSummaryTabMxDownload = true;
        vm.showRingDetailSummaryTabRxDownload = true;

        vm.updatedSurveyPath = [];
        vm.assets = []
        vm.fromToIntersectingPoints = [];
        var colors = uniqueColors.map(function (color) {
            return { color: color, used: false };
        });

        Configs.get("RouteImage", function (response) {
            if (response.length > 0) {
                if (response[0].configValue == "True") {
                    vm.showRouteAttachment = true
                }
            }
        })

        Configs.get("Features", function (response) {
            response.filter(function (value) {

                if (value.configKey == "RingDetailGpReport") {
                    if (value.configValue == "True") {
                        vm.showRingDetailGpReport = true;
                    } else {
                        vm.showRingDetailGpReport = false;
                    }
                }

                if(value.configKey == "RingDetailJointReport") {
                    if(value.configValue == "True") {
                        vm.showRingDetailJointReport = true;
                    } else {
                        vm.showRingDetailJointReport = false;
                    }
                }

                if (value.configKey == "RingDetailSurveyReport") {
                    if (value.configValue == "True") {
                        vm.showRingDetailSurveyReport = true
                    } else {
                        vm.showRingDetailSurveyReport = false
                    }
                }

                if (value.configKey == "RingDetailWorkProgressTab") {
                    if (value.configValue == "True") {
                        vm.showRingDetailWorkProgressTab = true
                    } else {
                        vm.showRingDetailWorkProgressTab = false
                    }
                }

                if (value.configKey == "RingDetailSummaryTabMxDownload") {
                    if (value.configValue == "True") {
                        vm.showRingDetailSummaryTabMxDownload = true
                    } else {
                        vm.showRingDetailSummaryTabMxDownload = false
                    }
                }

                if (value.configKey == "RingDetailSummaryTabRxDownload") {
                    if (value.configValue == "True") {
                        vm.showRingDetailSummaryTabRxDownload = true
                    } else {
                        vm.showRingDetailSummaryTabRxDownload = false
                    }
                }
            })
        });

        vm.imageInNewTab = function (img) {
            var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                img +
                '">'
            );
            imgWindow.document.close();
        };



        function getPolylineMidpoint(polyline) {
            var path = polyline.getPath();

            if (!path || path.getLength() < 2) {
                console.warn("Polyline must have at least two points.");
                return null;
            }

            var firstLatLng = path.getAt(0);
            var lastLatLng = path.getAt(path.getLength() - 1);

            var midpointLat = (firstLatLng.lat() + lastLatLng.lat()) / 2;
            var midpointLng = (firstLatLng.lng() + lastLatLng.lng()) / 2;

            return new google.maps.LatLng(midpointLat, midpointLng);
        }

        function downloadRouteKml() {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block"; // Show the spinner
            }
            Report.downloadRouteKml({
                id: vm.trRoute.id
            }, function (response) {
                if (spinner) {
                    spinner.style.display = "none"; // Show the spinner
                }
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([(response)], { type: 'application/text' });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = vm.trRoute.name + ".kml";
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
        }

        function downloadGpReport() {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block"; // Show the spinner
            }
            BaseUrl.getBaseUrl(function (baseurl) {
                var url = "";
                url = baseurl.stringValue + "api/gp-ring-report/" + vm.trRoute.id;
                var request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';

                request.onload = function (e) {
                    if (spinner) {
                        spinner.style.display = "none"; // Show the spinner
                    }
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'test.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));

                                downloadLink.download = vm.trRoute.name + ' GP_Report.xlsx';

                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    } else if (this.status == 404) { alert("No Data Available") }
                };
                request.send();
            });
        }

        function downloadJointReport() {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block"; // Show the spinner
            }
            BaseUrl.getBaseUrl(function (baseurl) {
                var url = "";
                url = baseurl.stringValue + "api/joint-ring-report/" + vm.trRoute.id;
                var request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';

                request.onload = function (e) {
                    if (spinner) {
                        spinner.style.display = "none"; // Show the spinner
                    }
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'test.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));

                                downloadLink.download = vm.trRoute.name + ' Joint_Report.xlsx';

                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    } else if (this.status == 404) { alert("No Data Available") }
                };
                request.send();
            });
        }


        $scope.$on('$destroy', unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };

        $scope.allimages = false;
        //		$scope

        $scope.toggle = function (id) {
            switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrRouteImages.query(
                            {
                                routeId: vm.trRoute.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.routeImages = data.filter(function (routeImages) {
                                return routeImages.image
                            });

                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getRouteImage.get(vm.trRoute.id, function (res) {
                            vm.attachments = res;
                        });
                    }
                case "section":
                    vm.showSection = !vm.showSection;
                    break;
                    break;

                default:
                    console.log("");
            }
        };


        function decodeImage(img) {
            return window.atob(img);
        }

        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };


        $scope.setTab = function (newTab) {
            vm.tabNum = newTab;
            if (newTab == 8) {
                //Comment Box
                vm.objectComments = {}
                vm.objectComments.entityId = entity.id
                vm.objectComments.entityName = "ROUTE"
            }
            if (vm.tabNum == 4) {
                SummaryPost.dailyLogsTx({
                    "projectIds": [vm.trRoute.projectId],
                    "routeIds": [vm.trRoute.id]
                }, function (response) {
                    vm.dailyLogsTxSummary = response
                })

                SummaryPost.mtrlTx({
                    "projectIds": [vm.trRoute.projectId],
                    "routeIds": [vm.trRoute.id]
                }, function (response) {
                    vm.mtrlTxSummary = response
                })

                SummaryPost.resTx({
                    "projectIds": [vm.trRoute.projectId],
                    "routeIds": [vm.trRoute.id]
                }, function (response) {
                    vm.resTxSummary = response
                })
            }

            if (newTab == 4 && vm.dailyLogsTxSummary.sectionTasks.length) {
                $scope.tab = 7
                showTaskLogReport(vm.trRoute.id);
            } else {
                $scope.tab = newTab;
            }
        }

        routeDetail.getRoutesDetails(entity.id, function (response) {
            vm.sectionResponse = response;
        })
        var locations = {};
        var markers = [];
        var coordinateList = []
        var chainageList = []
        var markerList = []
        var iconSize = 24
        var center = {
            lat: parseFloat($rootScope.DEFAULT_LATITUDE),
            lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
        };

        locations.map = new google.maps.Map(
            document.getElementById("map_canvasStart"),
            myOption($rootScope.rolloutMapInitZoom, center)
        );
        var infoWindow = new google.maps.InfoWindow();
        google.maps.event.addListener(locations.map, "click", function (event) {
            var latitude = event.latLng.lat();
            var longitude = event.latLng.lng();

            var contentDiv = document.createElement("div");
            contentDiv.className = "infoWindowhead";
            contentDiv.innerHTML =
                "<b>Latitude : " + latitude + "</b><br>" +
                "<b>Longitude : " + longitude + "</b><br>";

            var btnCreateMarker = document.createElement("input");
            btnCreateMarker.type = "button";
            btnCreateMarker.value = "Create Marker";
            btnCreateMarker.className = "button";

            google.maps.event.addDomListener(btnCreateMarker, "click", function () {
                var routeMarkerPayload = [{
                    "latitude": latitude,
                    "longitude": longitude,
                    "id": null,
                    "sessionNumber": generateUUID(),
                    "routeId": vm.trRoute.id,
                    "routePointNumber": 100,
                    "routePointType": "MARKER",
                    "lhsOffset": 3,
                    "rhsOffset": 3,
                    "rodometerLength": 3,
                    "roadWidth": 3,
                    "distance": 0,
                    "landMark": "",
                    "phase": "SURVEY"
                }];

                routeDetail.saveBulkRoutePoints(routeMarkerPayload, function (response) {
                    infoWindow.close()
                    alert("Marker Created")
                    vm.refreshMarkers();
                });
            });
            contentDiv.appendChild(btnCreateMarker);
            infoWindow.setContent(contentDiv);
            infoWindow.setPosition(event.latLng);
            infoWindow.open(locations.map);
        });
        vm.refreshMarkers = function () {
            vm.objectRouteImg.refreshMarkersFn();
        };


        function templateBg(color) {
            return '<img class="square" style="background-color:' +
                color +
                ';">'
        }

        vm.phaseFilter = []
        vm.blockFilter = []
        var tempColor = {
            "PLANNING": "#FD7A24",
            "SURVEY": "#0096FF",
            "ROLLOUT": "#7FFF00",
            "MAINTENANCE": "#DE3163"
        }

        var isObjBool = {
            "PLANNING": false,
            "SURVEY": false,
            "ROLLOUT": false,
            "MAINTENANCE": false
        }

        if (vm.trRoute && vm.trRoute.routePoints != null && vm.trRoute.routePoints.length) {
            vm.trRoute.routePoints.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
            var groupedRoutePoints = {};
            vm.trRoute.routePoints.forEach(function (each) {
                if (each.routePointType == "COORDINATE" && each.phase != null) {
                    if (each.sessionNumber) {
                        if (!groupedRoutePoints[each.sessionNumber]) {
                            groupedRoutePoints[each.sessionNumber] = [];
                        }
                        groupedRoutePoints[each.sessionNumber].push(each);
                    }
                } else if (each.routePointType == "CHAINAGE" && each.phase != null) {
                    isObjBool[each.phase] = true;
                    chainageList.push({ latitude: each.latitude, longitude: each.longitude, type: each.routePointType, number: each.routePointNumber, phase: each.phase });
                }
            });
            Object.keys(groupedRoutePoints).forEach(function (sessionNumber) {
                var sessionPoints = groupedRoutePoints[sessionNumber];
                sessionPoints.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
                if (sessionPoints.length > 1) {
                    sessionPoints.forEach(function (each) {
                        callSwitchPhaseCoordinate(each, each.phase);
                        isObjBool[each.phase] = true;
                        var coordinate = { lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber, sessionNumber: each.sessionNumber };
                        if (each.phase === "PLANNING") {
                            coordinateListPlanning.push(coordinate);
                            vm.plannedCoordinats = coordinateListPlanning
                        } else if (each.phase === "SURVEY") {
                            vm.surveyPhase = "SURVEY"
                            coordinateListPlanSurvey.push(coordinate);
                        } else if (each.phase === "ROLLOUT") {
                            coordinateListRollout.push(coordinate);
                        } else if (each.phase === "MAINTENANCE") {
                            coordinateListMaintenance.push(coordinate);
                        }
                    });
                    callPhaseCoordinate();
                    coordinateListPlanning = [];
                    coordinateListPlanSurvey = [];
                    coordinateListRollout = [];
                    coordinateListMaintenance = [];
                }
            });
            callPhaseCoordinate();
            if (chainageList.length) {

                locations.map.setCenter(chainageList[0]);
                createMarkers(chainageList, 'content/images/chainagePoints.png', locations.map, null);
            }
            callObjPhases();
        }

        function callObjPhases() {
            if (isObjBool["PLANNING"]) {
                vm.phaseFilter.push({ name: "PLANNING", selected: true, strokeColor: templateBg("#FD7A24") })
            }
            if (isObjBool["SURVEY"]) {
                vm.phaseFilter.push({ name: "SURVEY", selected: true, strokeColor: templateBg("#0096FF") })
            }
        }
        var plannigCoordinate = coordinateListPlanning
        var polyLine = []
        function callPhaseCoordinate() {
            if (coordinateListPlanning.length) {
                coordinateListPlanning.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
                locations.map.setCenter(coordinateListPlanning[0]);
                var polyline = new google.maps.Polyline({
                    path: coordinateListPlanning,
                    geodesic: true,
                    strokeColor: tempColor["PLANNING"],
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                    name: "PLANNING",
                    zIndex: 1
                });
                coordinateListPlanning.forEach(function (each) {
                    createInfoWindow(polyline, each)
                })
                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }
            if (coordinateListPlanSurvey.length) {
                //vm.phaseFilter.push({name:"PROPOSED",selected:true,strokeColor:templateBg("#0096FF")})
                coordinateListPlanSurvey.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                locations.map.setCenter(coordinateListPlanSurvey[0]);
                var surveyCoord = coordinateListPlanSurvey;
                var polyline = new google.maps.Polyline({
                    path: coordinateListPlanSurvey,
                    geodesic: true,
                    strokeColor: tempColor["SURVEY"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "SURVEY",
                    zIndex: 1
                });
                polyline.setMap(locations.map);

                var polylineInfoWindowsurvey = new google.maps.InfoWindow();
                google.maps.event.addListener(polyline, 'click', function (event) {
                    var contentString = document.createElement("div"),
                        btnEditSurveyPath
                    contentString.innerHTML = '<div class="infoWindowhead">'
                    "</div>";
                    polylineInfoWindowsurvey.setContent(contentString);
                    polylineInfoWindowsurvey.setPosition(event.latLng);
                    polylineInfoWindowsurvey.open(locations.map);
                    openedInfoWindow = polylineInfoWindowsurvey;
                    var originalOptions = {
                        strokeColor: polyline.get("strokeColor"),
                        strokeWeight: polyline.get("strokeWeight"),
                        strokeOpacity: polyline.get("strokeOpacity")
                    };
                    polyline.setOptions({
                        strokeColor: "#A938F3",
                        strokeWeight: 12,
                        strokeOpacity: 0.6,
                    });
                    setTimeout(function () {
                        polyline.setOptions(originalOptions);
                    }, 10000);
                    if (vm.trRoute.id) {
                        btnEditSurveyPath = contentString.appendChild(
                            document.createElement("input")
                        );

                        btnEditSurveyPath.type = "button";
                        btnEditSurveyPath.value = "Edit Path";
                        btnEditSurveyPath.className = "button";
                        google.maps.event.addDomListener(
                            btnEditSurveyPath,
                            "click",
                            function () {
                                vm.editSurveyPath(surveyCoord);
                                polylineInfoWindowsurvey.close()
                            }
                        );
                    }
                });
                google.maps.event.addListener(
                    polyline,
                    "click",
                    (function (event) {
                        vm.SuveryMapCenter = {
                            lat: event.latLng.lat(),
                            lng: event.latLng.lng()
                        }
                    }))
                phasePolylines.push(polyline)
            }

            if (coordinateListRollout.length) {
                //vm.phaseFilter.push({name:"ROLLOUT",selected:true,strokeColor:templateBg("#7FFF00"), color:"#7FFF00"})
                locations.map.setCenter(coordinateListRollout[0]);
                coordinateListRollout.sort(function (a, b) { return a.routePointNumberDouble - b.routePointNumberDouble });
                var polyline = new google.maps.Polyline({
                    path: coordinateListRollout,
                    geodesic: true,
                    strokeColor: tempColor["ROLLOUT"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "ROLLOUT"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (coordinateListMaintenance.length) {
                //vm.phaseFilter.push({name:"MAINTENANCE",selected:true,strokeColor:templateBg("#DE3163"), color :"#DE3163"})
                coordinateListMaintenance.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                locations.map.setCenter(coordinateListMaintenance[0]);
                var polyline = new google.maps.Polyline({
                    path: coordinateListMaintenance,
                    geodesic: true,
                    strokeColor: tempColor["MAINTENANCE"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "MAINTENANCE"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }
        }
        function callPhaseSpread() {
            if (assetSpreadListPlanning.length) {
                //vm.phaseFilter.push({name:"PLANNING",selected:true,strokeColor:templateBg("#FD7A24")})
                locations.map.setCenter(assetSpreadListPlanning[0]);

                var polyline = new google.maps.Polyline({
                    path: assetSpreadListPlanning,
                    geodesic: true,
                    strokeColor: tempColor["PLANNING"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "PLANNING",
                    zIndex: 1
                });
                // Set the map to display the polyline
                assetSpreadListPlanning.forEach(function (each) {
                    createInfoWindow(polyline, each)
                    polyline.set('block', each.block);
                })
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (assetSpreadListPlanSurvey.length) {
                //vm.phaseFilter.push({name:"PROPOSED",selected:true,strokeColor:templateBg("#0096FF")})
                locations.map.setCenter(assetSpreadListPlanSurvey[0]);
                var polyline = new google.maps.Polyline({
                    path: assetSpreadListPlanSurvey,
                    geodesic: true,
                    strokeColor: tempColor["SURVEY"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "SURVEY",
                    zIndex: 1
                });

                assetSpreadListPlanSurvey.forEach(function (each) {
                    createInfoWindow(polyline, each)
                    polyline.set('block', each.block);
                })
                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (assetSpreadListRollout.length) {
                //vm.phaseFilter.push({name:"ROLLOUT",selected:true,strokeColor:templateBg("#7FFF00"), color:"#7FFF00"})

                locations.map.setCenter(assetSpreadListRollout[0]);
                var polyline = new google.maps.Polyline({
                    path: assetSpreadListRollout,
                    geodesic: true,
                    strokeColor: tempColor["ROLLOUT"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "ROLLOUT"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }

            if (assetSpreadListMaintenance.length) {
                //vm.phaseFilter.push({name:"MAINTENANCE",selected:true,strokeColor:templateBg("#DE3163"), color :"#DE3163"})
                locations.map.setCenter(assetSpreadListMaintenance[0]);
                var polyline = new google.maps.Polyline({
                    path: assetSpreadListMaintenance,
                    geodesic: true,
                    strokeColor: tempColor["MAINTENANCE"],
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    name: "MAINTENANCE"
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                phasePolylines.push(polyline)
            }
        }

        function callSwitchPhaseCoordinate(each, ph) {
            switch (ph) {
                case "PLANNING":
                    coordinateListPlanning.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;

                case "SURVEY":
                    coordinateListPlanSurvey.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, sessionNumber: each.sessionNumber })
                    break;

                case "ROLLOUT":
                    coordinateListRollout.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;

                case "MAINTENANCE":
                    coordinateListMaintenance.push({ lat: each.latitude, lng: each.longitude, phase: each.phase })
                    break;
            }
        }

        function callSwitchPhaseSpread(each, ph, name, block) {
            switch (ph) {
                case "PLANNING":
                    assetSpreadListPlanning.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, name: name, block: block })
                    break;

                case "SURVEY":
                    assetSpreadListPlanSurvey.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, name: name, block: block })
                    break;

                case "ROLLOUT":
                    assetSpreadListRollout.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, block: block })
                    break;

                case "MAINTENANCE":
                    assetSpreadListMaintenance.push({ lat: each.latitude, lng: each.longitude, phase: each.phase, block: block })
                    break;
            }
        }

        $scope.togglePhase = function () {
            if (vm.selectedPhase.length) {
                clearPhase()
                vm.selectedPhase.forEach(function (each) {
                    for (var i = 0; i < phasePolylines.length; i++) {
                        if (phasePolylines[i].name === each.name) {
                            if (each.selected) {
                                phasePolylines[i].setMap(locations.map);
                            }
                        }
                    }
                    for (var i = 0; i < phaseMarkers.length; i++) {
                        if (phaseMarkers[i].name === each.name) {
                            if (each.selected) {
                                phaseMarkers[i].setMap(locations.map);
                            }
                        }
                    }
                })
            } else {
                clearPhase()
            }
        };

        $scope.toggleBlock = function () {
            if (vm.selectedBlock.length) {
                clearPhase()
                vm.selectedBlock.forEach(function (each) {
                    for (var i = 0; i < phasePolylines.length; i++) {
                        if (phasePolylines[i].block === each.name /* || phasePolylines[i].block == null */) {
                            if (each.selected) {
                                phasePolylines[i].setMap(locations.map);
                            }
                        }
                    }
                    for (var i = 0; i < phaseMarkers.length; i++) {
                        if (phaseMarkers[i].block === each.name /* || phasePolylines[i].block == null */) {
                            if (each.selected) {
                                phaseMarkers[i].setMap(locations.map);
                            }
                        }
                    }
                })
            } else {
                clearPhase()
                vm.phaseFilter.forEach(function (item) {
                    item.selected = false
                })
            }
        };

        function createMarkers(arr, img, map, str) {
            var marker, markerSymbol
            arr.forEach(function (each) {

                marker = new google.maps.Marker({
                    position: { lat: each.latitude, lng: each.longitude },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                    name: each.phase
                });

                google.maps.event.addListener(
                    marker,
                    "click",
                    (function () {
                        //var name = (each.name == (undefined || null)) ? " " : each.name
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead"></br></br>' +
                            /* "<b>Name : "+name+"</b></br>"+ */
                            "<b>Latitude : " + each.latitude + "</b></br>" +
                            "<b>Longitude : " + each.longitude + "</b></br>" +
                            "<b>Type : " + each.type + "</b></br>" +
                            "<b>Number : " + each.number + "</b></br>" +
                            "</br></div>"
                        );
                        infowindow.open(map);
                        infowindow.setPosition({
                            lat: each.latitude,
                            lng: each.longitude,
                        });
                        openedInfoWindow = infowindow;
                    }))

                phaseMarkers.push(marker);

            })
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
            {
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#EFEFEF",
                    },
                ],
            }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        vm.expand = function (section, str) {
            vm.sectionResponse.forEach(function (item) {
                item.tasks = true;
            });

            if (vm.toggle == section.sectionId) {
                vm.toggle = undefined;
            } else {
                switch (str) {
                    case "tasks":
                        vm.expandResponse = null
                        vm.headers = null
                        routeDetail.postSectionsDetails({ "sectionIds": [section.sectionId] }, function (response) {
                            vm.headers = [
                                { key: "logs", display: "Logs" },
                                { key: "taskName", display: "Task Name" },
                                { key: "userLogin", display: "Assigned To" }
                            ]
                            vm.expandResponse = response
                        })
                        section.tasks = true;
                        vm.toggle = section.sectionId;
                        break;

                    default: console.log("default")
                }
            }
        }




        vm.objectRouteImg = {}
        vm.objectRouteImg.hidemarker = true
        vm.objectRouteImg.hideRoutemarker = true
        vm.objectRouteImg.routeId = vm.trRoute.id
        vm.objectRouteImg.routeName = vm.trRoute.name
        vm.objectRouteImg.plannedPath = vm.plannedCoordinats
        vm.objectRouteImg.map = locations.map
        vm.objectRouteImg.hidesurveyRoutemarker = true;
        vm.mapFilterList = [];
        var polylines = []
        var tempPath = []

        TrRouteForMap.getTerrainPathByRoute(
            vm.trRoute.id,
            function (response) {
                vm.terrainPathResponse = response

                callTerrainPath()

            }, function (err) {
                vm.mapFilterList.push({
                    name:
                        '<strong>' + vm.trRoute.name + '</strong>',
                    path: coordinateList,
                    visible: true,
                    strokeColor: '<img class="square" style="background-color:#' +
                        'FD7A24' +
                        ';">',
                    colorCode: 'FD7A24',
                    routeDisable: true
                })

                for (var i = 0; i < vm.mapFilterList.length; i++) {
                    var filteredPath = vm.mapFilterList[i].path;
                    filteredPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                    var line = new google.maps.Polyline({
                        path: filteredPath,
                        visible: vm.mapFilterList[i].visible,
                        strokeColor: '#' + vm.mapFilterList[i].colorCode,
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                        name: vm.mapFilterList[i].name
                    });
                    line.setMap(locations.map);
                    polylines.push(line);
                }

                TrRouteForMap.getRoWPathByRoute(
                    vm.trRoute.id,
                    function (response) {
                        vm.rowPathResponse = response
                        if (response.length) {
                            vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                            callRowPath()
                        }
                    }
                );
            }
        );

        function callTerrainPath() {

            TrRouteForMap.getTerrainByRoute(
                vm.trRoute.id,
                function (nameResponse) {
                    polylines = []
                    vm.terrainListResponse = nameResponse
                    vm.totalTerrain = 0;
                    vm.terrainListResponse.forEach(function (terrain) {
                        vm.totalTerrain += terrain.length;
                    });
                    if (nameResponse.length) {
                        vm.isShowFilter = true
                        vm.mapFilterList.push({
                            name:
                                '<strong>' + vm.trRoute.name + '</strong>',
                            path: coordinateList,
                            visible: true,
                            strokeColor: '<img class="square" style="background-color:#' +
                                'FD7A24' +
                                ';">',
                            colorCode: 'FD7A24',
                            routeDisable: true,

                        })
                        vm.mapFilterList.push({ name: '<strong>Terrain</strong>', msGroup: true })
                        nameResponse.forEach(function (nameEach, indexName) {
                            if (vm.terrainPathResponse.length) {
                                vm.terrainPathResponse.forEach(function (item, indexPath) {
                                    if (nameEach.id == item.id) {
                                        if (
                                            item.value["COORDINATE"]
                                        ) {
                                            item.value["COORDINATE"].forEach(function (cord) {
                                                tempPath.push({ lat: cord.latitude, lng: cord.longitude, routePointNumber: parseFloat(cord.routePointNumber) })
                                            })
                                            tempPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                                            var colorCode = randomColor()
                                            vm.mapFilterList.push({
                                                name:
                                                    nameEach.name,
                                                path: tempPath,
                                                visible: true,
                                                strokeColor: '<img class="square" style="background-color:' +
                                                    colorCode +
                                                    ';">',
                                                colorCode: colorCode
                                            });
                                            tempPath = []
                                        }
                                    }
                                });
                            }
                        });
                        vm.mapFilterList.push({ msGroup: false })
                        TrRouteForMap.getRoWPathByRoute(
                            vm.trRoute.id,
                            function (response) {
                                vm.rowPathResponse = response
                                callRowPath()
                            }
                        );
                    } else {
                        vm.mapFilterList.push({
                            name:
                                '<strong>' + vm.trRoute.name + '</strong>',
                            path: coordinateList,
                            visible: true,
                            strokeColor: '<img class="square" style="background-color:#' +
                                'FD7A24' +
                                ';">',
                            colorCode: 'FD7A24',
                            routeDisable: true
                        })

                        for (var i = 0; i < vm.mapFilterList.length; i++) {
                            var filteredPath = vm.mapFilterList[i].path;
                            filteredPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                            var line = new google.maps.Polyline({
                                path: filteredPath,
                                visible: vm.mapFilterList[i].visible,
                                strokeColor: '#' + vm.mapFilterList[i].colorCode,
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                                name: vm.mapFilterList[i].name
                            });
                            line.setMap(locations.map);
                            polylines.push(line);
                        }

                        TrRouteForMap.getRoWPathByRoute(
                            vm.trRoute.id,
                            function (response) {
                                vm.rowPathResponse = response
                                if (response.length) {
                                    vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                    callRowPath()
                                }

                            }
                        );
                    }
                },
                function (error) {
                    vm.mapFilterList.push({
                        name:
                            '<strong>' + vm.trRoute.name + '</strong>',
                        path: coordinateList,
                        visible: true,
                        strokeColor: '<img class="square" style="background-color:#' +
                            'FD7A24' +
                            ';">',
                        colorCode: 'FD7A24',
                        routeDisable: true
                    })

                    for (var i = 0; i < vm.mapFilterList.length; i++) {
                        var filteredPath = vm.mapFilterList[i].path;
                        filteredPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                        var line = new google.maps.Polyline({
                            path: filteredPath,
                            visible: vm.mapFilterList[i].visible,
                            strokeColor: '#' + vm.mapFilterList[i].colorCode,
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                            name: vm.mapFilterList[i].name
                        });
                        line.setMap(locations.map);
                        // polylines.push(line);
                    }

                    TrRouteForMap.getRoWPathByRoute(
                        vm.trRoute.id,
                        function (response) {
                            vm.rowPathResponse = response
                            if (response.length) {
                                vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                callRowPath()
                            }

                        }
                    );
                }
            );
        }
        function callRowPath() {

            TrRouteForMap.getRoWByRoute(
                vm.trRoute.id,
                function (nameResponse) {
                    vm.rowListResponse = nameResponse
                    vm.totalRow = 0;
                    vm.rowListResponse.forEach(function (row) {
                        vm.totalRow += row.length;
                    });
                    if (nameResponse.length) {
                        nameResponse.forEach(function (nameEach, indexName) {
                            if (vm.rowPathResponse.length) {
                                vm.rowPathResponse.forEach(function (item, indexPath) {
                                    if (nameEach.id == item.id) {
                                        if (
                                            item.value["COORDINATE"]
                                        ) {
                                            item.value["COORDINATE"].forEach(function (cord) {
                                                tempPath.push({ lat: cord.latitude, lng: cord.longitude, routePointNumber: parseFloat(cord.routePointNumber) })
                                            })
                                            tempPath.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                                            var colorCode = randomColor()
                                            vm.mapFilterList.push({
                                                name:
                                                    nameEach.name,
                                                path: tempPath,
                                                visible: true,
                                                strokeColor: '<img class="square" style="background-color:' +
                                                    colorCode +
                                                    ';">',
                                                colorCode: colorCode
                                            });
                                            tempPath = []
                                        }
                                    }
                                });
                            }
                        });
                        vm.mapFilterList.push({ msGroup: false })
                    }
                }
            );
        }
        $scope.togglePolyline = function () {
            if (vm.selectedTerrainName.length) {
                clearPolyLines()
                vm.selectedTerrainName.forEach(function (each) {
                    for (var i = 0; i < polylines.length; i++) {
                        if (polylines[i].name === each.name) {
                            if (each.visible) {
                                polylines[i].setMap(locations.map);
                            }
                        } else {
                            polylines[i].setMap(null)
                        }
                    }
                })
            } else {
                clearPolyLines()
            }
        };
        function clearPolyLines() {
            for (var i = 0; i < polylines.length; i++) {

                polylines[i].setMap(null);

            }
        }
        $scope.type = {
            terrain: {
                search: "Search",
                nothingSelected: "Map Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            },
            phase: {
                search: "Search",
                nothingSelected: "Phase Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            },
            block: {
                search: "Search",
                nothingSelected: "Block Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            }
        };
        vm.sectionNameResponse = [];
        vm.getSections = function () {
            routeDetail.getSection(vm.trRoute.id, function (response) {
                vm.sectionNameResponse = response;
            });
            $('#showRingsSections').modal('show');
        }
        function randomColor() {
            var unusedColors = colors.filter(function (color) {
                return !color.used;
            });
            if (unusedColors.length === 0) return null;
            var randomIndex = Math.floor(Math.random() * unusedColors.length);
            var randomColor = unusedColors[randomIndex];
            randomColor.used = true;
            return randomColor.color;
        }

        function createMetaTag(attrName, attrValue, content) {
            var meta = document.createElement('meta');
            meta.setAttribute(attrName, attrValue);
            meta.setAttribute('content', content);
            return meta;
        }

        function createTable(classNames) {
            var table = document.createElement('table');
            table.setAttribute('border', '1');
            table.setAttribute('cellpadding', '5');
            table.setAttribute('cellspacing', '0');
            table.setAttribute('id', 'sheet0');
            table.setAttribute('class', classNames);
            return table;
        }

        function createTableCell(tagName, textContent) {
            var cell = document.createElement(tagName);
            cell.textContent = textContent;
            return cell;
        }

        function showTaskLogReport(routeId) {
            vm.isReportGenerated = false;
            TaskLogRouteReportData.query(
                {
                    reportType: "daily",
                    routeId: routeId
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                var htmlDoc = document.createElement('html');
                var head = document.createElement('head');
                var meta1 = createMetaTag('http-equiv', 'Content-Type', 'text/html; charset=utf-8');
                var meta2 = createMetaTag('name', 'generator', 'PhpSpreadsheet, https://github.com/PHPOffice/PhpSpreadsheet');
                var meta3 = createMetaTag('name', 'author', 'Apache POI');
                var meta4 = createMetaTag('name', 'company', 'Microsoft Corporation');
                head.appendChild(meta1);
                head.appendChild(meta2);
                head.appendChild(meta3);
                head.appendChild(meta4);
                var body = document.createElement('body');
                var table = createTable('sheet0 gridlines');
                var thead = document.createElement('thead');
                var tbody = document.createElement('tbody');

                function createTable(classNames) {
                    var table = document.createElement('table');
                    table.setAttribute('border', '1');
                    table.setAttribute('cellpadding', '5');
                    table.setAttribute('cellspacing', '0');
                    table.setAttribute('id', 'sheet0');
                    table.setAttribute('class', classNames);
                    return table;
                }

                function createMetaTag(attrName, attrValue, content) {
                    var meta = document.createElement('meta');
                    meta.setAttribute(attrName, attrValue);
                    meta.setAttribute('content', content);
                    return meta;
                }

                function createTableCell(tag, content) {
                    var cell = document.createElement(tag);
                    cell.textContent = content;
                    cell.style.fontSize = "13px";
                    return cell;
                }

                thead.className = 'thReport';
                table.appendChild(thead);
                tbody.className = 'tdReport';
                table.appendChild(tbody);
                var styleElement = document.createElement('style');
                styleElement.textContent = "\
                .subheader {\
                    margin: auto;\
                }\
                .thReport > tr > th{\
                    text-align: center;\
                    padding: 10px;\
                }\
                .tdReport > tr > td {\
                    text-align: center; \
                    padding: 10px;\
                }\
                ";
                document.head.appendChild(styleElement);

                var colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2',];
                function getRandomColor() {
                    if (colors.length === 0) {
                        colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2'];
                    }
                    var index = Math.floor(Math.random() * colors.length);
                    var color = colors[index];
                    colors.splice(index, 1);
                    return color;
                }


                var groupedData = {};
                data.forEach(function (item) {
                    if (!groupedData[item.date]) {
                        groupedData[item.date] = [];
                    }
                    groupedData[item.date].push(item);
                });
                var names = getUniqueNames(data);
                var nameHeaderRow = document.createElement('tr');
                var serialNumberHeader = createTableCell('th', 'S.No');
                serialNumberHeader.style.fontWeight = 'bold';
                serialNumberHeader.style.backgroundColor = '#7dcfb6';
                serialNumberHeader.rowSpan = 2;
                nameHeaderRow.appendChild(serialNumberHeader);
                var dateHeader = createTableCell('th', 'Date');
                dateHeader.style.backgroundColor = '#7dcfb6';
                dateHeader.style.fontWeight = 'bold';
                dateHeader.rowSpan = 2;
                nameHeaderRow.appendChild(dateHeader);
                var typeHeaderRow = document.createElement('tr');

                names.forEach(function (name, index) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    var availableTypes = getUniqueTypes(nameData);
                    var nameHeaderCell = createTableCell('th', name);
                    nameHeaderCell.style.backgroundColor = getRandomColor();
                    nameHeaderCell.style.fontWeight = 'bold';
                    nameHeaderCell.colSpan = availableTypes.length;
                    nameHeaderRow.appendChild(nameHeaderCell);
                    availableTypes.forEach(function (type) {
                        var typeHeaderCell = createTableCell('th', type);
                        typeHeaderCell.style.backgroundColor = nameHeaderCell.style.backgroundColor;
                        typeHeaderCell.style.fontWeight = 'bold';
                        typeHeaderRow.appendChild(typeHeaderCell);
                    });
                });
                var totalProgressHeader = createTableCell('th', 'Total Progress');
                totalProgressHeader.style.backgroundColor = '#cfe0c3';
                totalProgressHeader.style.fontWeight = 'bold';
                totalProgressHeader.colSpan = 3;
                nameHeaderRow.appendChild(totalProgressHeader);
                var subHeaders = [
                    {
                        type: 'Total',
                    },
                    {
                        type: "Ducting",
                    }, {
                        type: "Validation",

                    }
                ];
                subHeaders.forEach(function (subHeader) {
                    var subHeaderCell = createTableCell('th', subHeader.type);
                    subHeaderCell.style.backgroundColor = '#cfe0c3';
                    subHeaderCell.style.fontWeight = 'bold';
                    typeHeaderRow.appendChild(subHeaderCell);
                });
                thead.appendChild(nameHeaderRow);
                thead.appendChild(typeHeaderRow);
                var totals = {};

                Object.keys(groupedData)
                    .sort(function (a, b) {
                        var dateA = a.split('-').reverse().join('-');
                        var dateB = b.split('-').reverse().join('-');
                        return new Date(dateA) - new Date(dateB);
                    })
                    .forEach(function (date, index) {
                        var totalLength = 0;
                        var totalValidation = 0;
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name && item.date === date; });
                            var ductingLength = 0;
                            var hddLength = 0;
                            var horizontalDirectionalDrilling = 0
                            var validationLength = 0;
                            nameData.forEach(function (item) {
                                if (item.type === 'Ducting') {
                                    ductingLength += item.length;
                                }
                                else if (item.type === 'HDD') {
                                    hddLength += item.length;

                                }
                                else if (item.type === 'HDD ( Horizontal Directional Drilling )') {
                                    horizontalDirectionalDrilling += item.length;
                                }
                                else if (item.type === 'Validation' || item.type === 'Validation (T&D)') {
                                    validationLength += item.length;
                                }
                            });
                            totalLength += (ductingLength + hddLength + horizontalDirectionalDrilling);
                            totalValidation += validationLength;

                        });
                        var tr = document.createElement('tr');
                        var serialNumberCell = createTableCell('td', index + 1);
                        serialNumberCell.style.fontSize = "13px";
                        tr.appendChild(serialNumberCell);
                        var dateCell = createTableCell('td', date);
                        dateCell.style.width = '77px'
                        dateCell.style.whiteSpace = 'nowrap';
                        dateCell.style.fontSize = "13px";
                        tr.appendChild(dateCell);
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name; });
                            var availableTypes = getUniqueTypes(nameData);

                            availableTypes.forEach(function (type) {
                                var item = groupedData[date].find(function (item) {
                                    return item.name === name && item.type === type;
                                });
                                var lengthValue = item ? item.length : 0;
                                var td = createTableCell('td', lengthValue);

                                tr.appendChild(td);
                                if (!totals[type]) {
                                    totals[type] = 0;
                                }
                                totals[type] += lengthValue;
                            });
                        });
                        var total = 0;
                        for (var i = 2; i < tr.cells.length; i++) {
                            total += parseInt(tr.cells[i].textContent);
                        }
                        var columnValueCell = createTableCell('td', total);
                        columnValueCell.colSpan = 1;
                        tr.appendChild(columnValueCell);
                        var remainingDuctingCell = createTableCell('td', totalLength);
                        tr.appendChild(remainingDuctingCell);
                        var remainingValidationCell = createTableCell('td', totalValidation);
                        tr.appendChild(remainingValidationCell);
                        if (index === 0) {
                            totals['Total Progress Ducting'] = 0;
                            totals['Total Progress Validation'] = 0;
                        }
                        totals['Total Progress Ducting'] += totalLength;
                        totals['Total Progress Validation'] += totalValidation;
                        tbody.appendChild(tr);
                    });

                var staticColumns = ['Total', 'Balance Validation', 'Balance Ducting'];
                var allAvailableTypes = [];
                names.forEach(function (name) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    allAvailableTypes.push.apply(allAvailableTypes, getUniqueTypes(nameData));
                });
                var availableTypes = allAvailableTypes;
                var maxUniqueTypesCount = availableTypes.length;
                var totalLength = maxUniqueTypesCount + subHeaders.length;

                var columnTotals = {};
                for (var i = 2; i < totalLength; i++) {
                    var total = 0;
                    for (var j = 0; j < tbody.rows.length; j++) {
                        var cellValue = parseInt(tbody.rows[j].cells[i].textContent) || 0;
                        total += cellValue;
                    }
                    columnTotals[i] = total;
                }
                staticColumns.forEach(function (column) {
                    var staticRow = document.createElement('tr');
                    var columnNameCell = createTableCell('td', column);
                    columnNameCell.colSpan = 2;
                    columnNameCell.style.backgroundColor = '#cfe0c3';
                    columnNameCell.style.fontSize = "13px";
                    columnNameCell.style.fontWeight = 'bold';
                    staticRow.appendChild(columnNameCell);
                    if (column == 'Total') {
                        for (var i = 2; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', columnTotals[i].toString());
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                        var columnValueCell = createTableCell('td', totals['Total Progress Ducting']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                        var columnValueCell = createTableCell('td', totals['Total Progress Validation']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                    } else {
                        for (var i = 0; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', '0');
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                    }
                    tbody.appendChild(staticRow);
                });
                table.appendChild(thead);
                table.appendChild(tbody);
                body.appendChild(table);
                htmlDoc.appendChild(body);
                htmlDoc.appendChild(head);
                var htmlString = htmlDoc.outerHTML;
                var containerDiv = document.getElementById("generatedHtmlContainer");
                containerDiv.innerHTML = htmlString;

                function getUniqueNames(data) {
                    var uniqueNames = [];
                    data.forEach(function (item) {
                        if (uniqueNames.indexOf(item.name) === -1) {
                            uniqueNames.push(item.name);
                        }
                    });
                    return uniqueNames;
                }
                function getUniqueTypes(data) {
                    var uniqueTypes = [];
                    data.forEach(function (item) {
                        if (uniqueTypes.indexOf(item.type) === -1) {
                            uniqueTypes.push(item.type);
                        }
                    });
                    return uniqueTypes;
                }

                // Set background color for specified cells
                var jcbCells = document.querySelectorAll('.row1 .column0'); // Select cells in row 1, column 0 (JCB)
                var hddCells = document.querySelectorAll('.row1 .column1'); // Select cells in row 1, column 1 (HDD)

                // Loop through JCB cells and set background color to light green
                jcbCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Loop through HDD cells and set background color to light green
                hddCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                var relevantRows = ['.row2', '.row3', '.row5', '.row6'];

                // Loop through each relevant row
                relevantRows.forEach(function (rowClass) {
                    var cells = document.querySelectorAll(rowClass + ' td');

                    // Loop through the cells in the row
                    cells.forEach(function (cell) {
                        // Check if the content of the cell is '0' or empty
                        if (cell.textContent.trim() === '0' || cell.textContent.trim() === '') {
                            // Set background color to white
                            cell.style.backgroundColor = 'white';
                        }
                    });
                });

                vm.isReportGenerated = true;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function clearPhase() {
            for (var k = 0; k < phasePolylines.length; k++) {
                phasePolylines[k].setMap(null);
            }
            for (var j = 0; j < phaseMarkers.length; j++) {
                phaseMarkers[j].setMap(null);
            }
        }

        function createInfoWindow(polyline, each) {
            google.maps.event.addListener(
                polyline,
                "click",
                (function () {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    var name = each.name ? "<b>Name : " + each.name + "</b></br>" : ""
                    var block = each.block ? "<b>Block : " + each.block + "</b></br>" : ""
                    infowindow.setContent(
                        '<div class="infoWindowhead"></br></br>' +
                        name +
                        "<b>Latitude : " + each.lat + "</b></br>" +
                        "<b>Longitude : " + each.lng + "</b></br>" +
                        block +
                        "</br></div>"
                    );
                    infowindow.open(locations.map);
                    infowindow.setPosition({
                        lat: each.lat,
                        lng: each.lng,
                    });
                    openedInfoWindow = infowindow;
                }))
        }

        //callAssetsRouteByID(vm.trRoute.id,null)
        function callAssetsRouteByID(routeId, lastId) {
            assetsByRouteId.get(routeId, lastId, function (data) {
                if (data.assets.length) {
                    var markerSymbol, marker
                    data.assets.forEach(function (item) {
                        if (item.block) {
                            var isDuplicate = false;
                            for (var i = 0; i < vm.blockFilter.length; i++) {
                                if (vm.blockFilter[i].name === item.block) {
                                    isDuplicate = true;
                                    break;
                                }
                            }
                            if (!isDuplicate) {
                                vm.blockFilter.push({ name: item.block, selected: true });
                            }
                        }
                        if (item.assetCoordinates.length) {
                            if (item.assetTypeLayout == "FIXED" && item.phase != null) {
                                isObjBool[item.phase] = true
                                locations.map.setCenter({ lat: item.assetCoordinates[0].latitude, lng: item.assetCoordinates[0].longitude });
                                var imagePath = item.assetTypeImagePath;
                                item.assetCoordinates.forEach(function (each, index) {
                                    marker = new google.maps.Marker({
                                        position: { lat: each.latitude, lng: each.longitude },
                                        map: locations.map,
                                        icon: {
                                            scaledSize: new google.maps.Size(iconSize, iconSize),
                                            url: imagePath,
                                            anchor: new google.maps.Point(
                                                iconSize / 2,
                                                iconSize / 2
                                            ),
                                            labelOrigin: new google.maps.Point(25, 22),
                                        },
                                        name: item.phase,
                                        block: item.block
                                    });
                                    google.maps.event.addListener(
                                        marker,
                                        "click",
                                        (function (marker) {
                                            var assetDetails = item;
                                            var userContent = document.createElement("div"),
                                                btnShowAttributes,
                                                btnCr,
                                                btnText,
                                                btnEditAsset,
                                                btnCreateCase,
                                                btnThreePointRef,
                                                brBreak;
                                            var otdr = "";
                                            var infoStr = "";
                                            userContent.innerHTML =
                                                '<div class="infoWindowhead">' +
                                                assetDetails.name +
                                                '</div><div class="infoWindowContent">' +
                                                "<b>Asset Type </b> : " +
                                                assetDetails.assetTypeName +
                                                "<br><b>Phase </b> : " +
                                                assetDetails.phase +
                                                "<br>" +
                                                infoStr +
                                                "</div><br>";

                                            return function () {
                                                infowindow.setContent(userContent);
                                                infowindow.open(locations.map, marker);
                                                infowindow.setPosition(
                                                    new google.maps.LatLng(
                                                        marker.getPosition().lat(),
                                                        marker.getPosition().lng()
                                                    )
                                                );
                                                setTimeout(function () {
                                                    infowindow.close();
                                                }, 50000);
                                            };
                                        })(marker, index)
                                    );
                                    phaseMarkers.push(marker);
                                    // phaseMarkers.push(markerSymbol);
                                })

                            }

                            if (item.assetTypeLayout == "SPREAD" && item.phase != null) {
                                isObjBool[item.phase] = true
                                assetSpreadListPlanning = []
                                assetSpreadListMaintenance = []
                                assetSpreadListRollout = []
                                assetSpreadListPlanSurvey = []
                                item.assetCoordinates.forEach(function (each) {
                                    callSwitchPhaseSpread(each, item.phase, item.name, item.block)
                                })
                                callPhaseSpread()
                            }
                        }

                    })

                    callObjPhases()
                }
                if (data.assets.length >= 50) {
                    callAssetsRouteByID(vm.trRoute.id, data.assets[data.assets.length - 1].id)
                }
            })
        }
        vm.page = 1;
        vm.predicate = 'modified_date';
        vm.itemsPerPage = 10;
        vm.mtrpage = 1;
        vm.mtrPerPage = 10;
        vm.materialTxnByDates = [];
        vm.materialByDate = [];
        vm.loadMaterialTxnDate = function () {
            MaterialDates.query({
                type: "route",
                id: entity.id,
                page: vm.mtrpage - 1,
                size: vm.mtrPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.TotalItems = headers('X-Total-Count');
                vm.QueryCount = vm.TotalItems;
                vm.materialByDate = data.map(function (item) {
                    return {
                        timestamp: item[0],
                        total: item[1],
                        isExpand: false
                    };
                });

            });
        };
        if (vm.tabNum === 4) {
            vm.loadMaterialTxnDate();
        }
        vm.loadMaterialTxnByDates = function (date) {
            MaterialByDates.query({
                type: 'route',
                id: entity.id,
                date: date,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materialTxnByDates = data.map(function (item) {
                    return {
                        materialId: item[0] || "NA",
                        timestamp: item[4] || "NA",
                        transactionName: item[1] || "NA",
                        transactionType: item[2] || "NA",
                        count: item[3] || "NA",
                        status: item[5] || "NA",
                        transactionId: item[6] || "NA",
                    };
                });
            });
        };
        vm.toggleExpand = function (selectedTask) {
            angular.forEach(vm.materialByDate, function (task) {
                if (task === selectedTask) {
                    task.isExpand = !task.isExpand;
                    if (task.isExpand) {
                        vm.loadMaterialTxnByDates(task.timestamp);
                    } else {
                        vm.materialTxnByDates = [];
                    }
                } else {
                    task.isExpand = false;
                }
            });
        };
        vm.transitionMainMateril = function () {
            vm.loadMaterialTxnDate()
        }
        vm.fetchTerrain = function () {
            RouteByID.get(vm.trRoute.id, function (response) {
                vm.routePathResponse = response;
                callRoutePath(vm.routePathResponse.routePoints);
            });
            function callRoutePath(routePaths) {
                var colors = ['#FD7A24', '#0096FF'];
                var pathColor = colors[0];
                var proposedPathColor = colors[1];
                var groupedRoutePaths = {};
                var bounds = new google.maps.LatLngBounds();

                routePaths.forEach(function (coord) {
                    if (coord.sessionNumber) {
                        if (!groupedRoutePaths[coord.sessionNumber]) {
                            groupedRoutePaths[coord.sessionNumber] = { planned: [], proposed: [] };
                        }

                        if (coord.routePointType === 'COORDINATE') {
                            if (coord.phase === 'PLANNING') {
                                groupedRoutePaths[coord.sessionNumber].planned.push(coord);
                            } else if (coord.phase === 'SURVEY') {
                                groupedRoutePaths[coord.sessionNumber].proposed.push(coord);
                            }
                        }
                    }
                });


                Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                    var sessionData = groupedRoutePaths[sessionNumber];
                    var pathData = [];
                    if (vm.trRoute.phase == 'PLANNING') {
                        pathData = sessionData.planned;
                    } else {
                        pathData = sessionData.proposed;
                    }
                    if (pathData.length) {
                        var pathCoordinates = pathData.map(function (coord) {
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                        var pathPolyline = new google.maps.Polyline({
                            path: pathCoordinates,
                            geodesic: true,
                            strokeColor: pathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                            zIndex: 1
                        });
                        pathPolyline.setMap(vm.newMap);
                    }

                    if (sessionData.proposed.length) {
                        var proposedPathCoordinates = sessionData.proposed.map(function (coord) {
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        proposedPathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                        var proposedPathPolyline = new google.maps.Polyline({
                            path: proposedPathCoordinates,
                            geodesic: true,
                            strokeColor: proposedPathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 3,
                            zIndex: 1
                        });
                        proposedPathPolyline.setMap(vm.newMap);
                    }
                });
            }
            var bounds = new google.maps.LatLngBounds();
            vm.newMap = new google.maps.Map(
                document.getElementById("map_canvasStarts"),
                myOption($rootScope.rolloutMapInitZoom, center)
            );
            geoLocation(vm.newMap);
            TrRouteForMap.getTerrainPathByRoute(vm.trRoute.id, function (response) {
                vm.terrainPathResponse = response;
                callTerrainPath(vm.terrainPathResponse);
            });
            function callTerrainPath(terrainPaths) {
                vm.terrainPolylines = {};
                vm.terrainMarkers = {};
                terrainPaths.forEach(function (pathGroup) {
                    vm.terrainColorMap = {};
                    vm.terrainListResponse.forEach(function (terrain) {
                        vm.terrainColorMap[terrain.id] = terrain.colorcode;
                    });
                    var pathColor = vm.terrainColorMap[pathGroup.id];

                    if (pathGroup.value && Array.isArray(pathGroup.value.COORDINATE)) {
                        var pathCoordinates = pathGroup.value.COORDINATE.map(function (coord) {
                            if (Array.isArray(coord.routePointNumber)) {
                                coord.routePointNumber.sort(function (a, b) {
                                    return a - b;
                                });
                            }
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                        var pathPolyline = new google.maps.Polyline({
                            path: pathCoordinates,
                            geodesic: true,
                            strokeColor: pathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 3,
                            zIndex: 2
                        });
                        pathPolyline.setMap(vm.newMap);
                        vm.terrainPolylines[pathGroup.id] = pathPolyline;
                        google.maps.event.addListener(pathPolyline, 'click', function (event) {
                            if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }

                            var terrain = vm.terrainListResponse.find(function (terrain) {
                                return terrain.id === pathGroup.id;
                            });
                            if (terrain) {
                                var contentString = '<div class="infoWindowhead">' +
                                    "<b>Terrain Name: " + terrain.name + "</b></br>" +
                                    "<b>Terrain-Type: " + terrain.typeName + "</b></br>" +
                                    "<b>Length: " + terrain.length + "</b></br>" +
                                    "<b>Phase: " + terrain.phase + "</b></br>" +
                                    "</div>";

                                infowindow.setContent(contentString);
                                infowindow.setPosition(event.latLng);
                                infowindow.open(vm.newMap);
                                openedInfoWindow = infowindow;
                            }
                        })
                        var tooltip = new google.maps.InfoWindow();
                        google.maps.event.addListener(pathPolyline, 'mouseover', function (event) {
                            var terrain = vm.terrainListResponse.find(function (terrain) {
                                return terrain.id === pathGroup.id;
                            });
                            if (terrain) {
                                tooltip.setContent("<b>" + terrain.name + "</b>");
                                tooltip.setPosition(event.latLng);
                                tooltip.open(vm.newMap);
                            }
                        });

                        // Close tooltip when mouse leaves
                        google.maps.event.addListener(pathPolyline, 'mouseout', function () {
                            tooltip.close();
                        });
                        google.maps.event.addListener(pathPolyline, 'mouseover', function () {
                            vm.highlightTableTerrain(pathGroup.id);
                        });
                        google.maps.event.addListener(pathPolyline, 'mouseout', function () {
                            vm.resetTableRowHighlight(pathGroup.id);
                        });
                    }
                });
                vm.newMap.fitBounds(bounds);
            }
            vm.terrainListResponse;
            vm.uniquePhases = [];
            var phasesMap = {};
            vm.isVerifiedFilter = false;
            vm.isNotVerifiedFilter = false;
            vm.isDeviatedFilter = false;
            for (var i = 0; i < vm.terrainListResponse.length; i++) {
                var phase = vm.terrainListResponse[i].phase;
                if (!phasesMap[phase]) {
                    vm.uniquePhases.push({ phase: phase, selected: false });
                    phasesMap[phase] = true;
                }
            }

            vm.uniqueTerrainTypes = [];
            vm.filteredTerrainList = vm.terrainListResponse;
            vm.updateTerrainTypes = function () {
                var selectedPhases = [];

                for (var j = 0; j < vm.uniquePhases.length; j++) {
                    if (vm.uniquePhases[j].selected) {
                        selectedPhases.push(vm.uniquePhases[j].phase);
                    }
                }
                if (selectedPhases.length === 0) {
                    vm.uniqueTerrainTypes = [];
                }

                vm.uniqueTerrainTypes = [];
                var terrainTypesMap = {};
                for (var k = 0; k < vm.terrainListResponse.length; k++) {
                    var terrain = vm.terrainListResponse[k];

                    var isPhaseMatched = selectedPhases.indexOf(terrain.phase) !== -1;
                    var isVerifiedMatch = (vm.isVerifiedFilter && terrain.isVerified === true) ||
                        (vm.isNotVerifiedFilter && terrain.isVerified === false) ||
                        (!vm.isVerifiedFilter && !vm.isNotVerifiedFilter);

                    var isDeviatedMatch = (vm.isDeviatedFilter && terrain.isDeviated === true) ||
                        (!vm.isDeviatedFilter);

                    if (isPhaseMatched && isVerifiedMatch && isDeviatedMatch) {
                        if (!terrainTypesMap[terrain.typeName]) {
                            vm.uniqueTerrainTypes.push({
                                typeName: terrain.typeName,
                                colorcode: terrain.colorcode,
                                selected: false
                            });
                            terrainTypesMap[terrain.typeName] = true;
                        }
                    }
                }

                for (var id in vm.terrainPolylines) {
                    if (vm.terrainPolylines.hasOwnProperty(id)) {
                        vm.terrainPolylines[id].setOptions({ strokeWeight: 3 });
                    }
                }

                vm.areFiltersSelected = function () {
                    var selectedPhases = vm.uniquePhases.some(function (phase) {
                        return phase.selected;
                    });
                    var selectedTerrainTypes = vm.uniqueTerrainTypes.some(function (terrain) {
                        return terrain.selected;
                    });
                    var selectedVerification = vm.isVerifiedFilter || vm.isNotVerifiedFilter || vm.isDeviatedFilter;
                    return selectedPhases || selectedTerrainTypes || selectedVerification;
                };
            };

            vm.applyFilters = function () {
                var selectedPhases = [];
                var selectedTerrainTypes = [];

                for (var l = 0; l < vm.uniquePhases.length; l++) {
                    if (vm.uniquePhases[l].selected) {
                        selectedPhases.push(vm.uniquePhases[l].phase);
                    }
                }

                var filteredList = vm.terrainListResponse.filter(function (terrain) {
                    return selectedPhases.length === 0 || selectedPhases.indexOf(terrain.phase) !== -1;
                });

                var isVerifiedOrNotChecked = vm.isVerifiedFilter || vm.isNotVerifiedFilter;
                var isDeviatedChecked = vm.isDeviatedFilter;

                filteredList = filteredList.filter(function (terrain) {
                    return (!isVerifiedOrNotChecked) ||
                        (vm.isVerifiedFilter && terrain.isVerified === true) ||
                        (vm.isNotVerifiedFilter && (terrain.isVerified === false || terrain.isVerified === null));
                });

                filteredList = filteredList.filter(function (terrain) {
                    return (!isDeviatedChecked) || (vm.isDeviatedFilter && terrain.isDeviated === true);
                });

                var availableTerrainTypes = [];
                filteredList.forEach(function (terrain) {
                    if (availableTerrainTypes.indexOf(terrain.typeName) === -1) {
                        availableTerrainTypes.push(terrain.typeName);
                    }
                });

                vm.uniqueTerrainTypes.forEach(function (terrainType) {
                    terrainType.isAvailable = availableTerrainTypes.indexOf(terrainType.typeName) !== -1;
                });

                for (var m = 0; m < vm.uniqueTerrainTypes.length; m++) {
                    if (vm.uniqueTerrainTypes[m].selected) {
                        selectedTerrainTypes.push(vm.uniqueTerrainTypes[m].typeName);
                    }
                }

                filteredList = filteredList.filter(function (terrain) {
                    return selectedTerrainTypes.length === 0 || selectedTerrainTypes.indexOf(terrain.typeName) !== -1;
                });

                for (var id in vm.terrainPolylines) {
                    if (vm.terrainPolylines.hasOwnProperty(id)) {
                        vm.terrainPolylines[id].setOptions({ strokeWeight: 0 });
                    }
                }

                filteredList.forEach(function (terrain) {
                    var terrainId = terrain.id;
                    if (vm.terrainPolylines[terrainId]) {
                        vm.terrainPolylines[terrainId].setOptions({ strokeWeight: 6, strokeColor: terrain.colorcode });
                    }
                });

                vm.filteredTerrainList = filteredList;
                vm.isFilterMenuOpen = false;
            };

            vm.resetFilters = function () {
                for (var o = 0; o < vm.uniquePhases.length; o++) {
                    vm.uniquePhases[o].selected = false;
                }
                for (var p = 0; p < vm.uniqueTerrainTypes.length; p++) {
                    vm.uniqueTerrainTypes[p].selected = false;
                }
                vm.isVerifiedFilter = false;
                vm.isNotVerifiedFilter = false;
                vm.isDeviatedFilter = false;
                for (var id in vm.terrainPolylines) {
                    if (vm.terrainPolylines.hasOwnProperty(id)) {
                        vm.terrainPolylines[id].setOptions({ strokeWeight: 3 });
                    }
                }
                vm.uniqueTerrainTypes = []
                vm.filteredTerrainList = vm.terrainListResponse;
            };
            vm.closeFilters = function () {
                vm.isFilterMenuOpen = false;

            };
        };
        var flyAnimation = null;
        vm.highlightTerrain = function (terrainId) {
            if (flyAnimation) {
                clearInterval(flyAnimation);
                flyAnimation = null;
            }
            for (var id in vm.terrainPolylines) {
                vm.terrainPolylines[id].setOptions({ strokeWeight: 2 });
            }
            var polyline = vm.terrainPolylines[terrainId];
            if (!polyline) {
                return;
            }
            polyline.setOptions({ strokeWeight: 8 });
            var path = polyline.getPath().getArray();
            if (!path || path.length === 0) {
                return;
            }
            var index = 0;
            flyAnimation = setInterval(function () {
                if (index >= path.length) {
                    clearInterval(flyAnimation);
                    flyAnimation = null;
                    return;
                }
                var latLng = path[index];
                vm.newMap.panTo(latLng);
                index++;
            }, 100);
        };


        vm.resetTerrain = function () {
            if (flyAnimation) {
                clearInterval(flyAnimation);
                flyAnimation = null;
            }
            for (var id in vm.terrainPolylines) {
                vm.terrainPolylines[id].setOptions({ strokeWeight: 3 });
            }
        };

        var flyAnimationRow = null

        vm.highlightRow = function (rowId) {
            if (flyAnimationRow) {
                clearInterval(flyAnimationRow);
                flyAnimationRow = null;
            }
            for (var id in vm.rowPolylines) {
                vm.rowPolylines[id].setOptions({ strokeWeight: 2 });
            }
            var polyline = vm.rowPolylines[rowId];
            if (!polyline) {
                return;
            }
            polyline.setOptions({ strokeWeight: 8 });
            var path = polyline.getPath().getArray();
            if (!path || path.length === 0) {
                return;
            }
            var index = 0;
            flyAnimationRow = setInterval(function () {
                if (index >= path.length) {
                    clearInterval(flyAnimationRow);
                    flyAnimationRow = null;
                    return;
                }
                var latLng = path[index];
                vm.newMaps.panTo(latLng);
                index++;
            }, 100);
        };

        vm.resetRow = function () {
            if (flyAnimationRow) {
                clearInterval(flyAnimationRow);
                flyAnimationRow = null;
            }
            for (var id in vm.rowPolylines) {
                if (vm.rowPolylines.hasOwnProperty(id)) {
                    vm.rowPolylines[id].setOptions({ strokeWeight: 3 });
                }
            }
        };

        vm.highlightTableTerrain = function (id) {
            var terrains = document.querySelectorAll('.highlighted-terrain');
            terrains.forEach(function (terrain) {
                terrain.classList.remove('highlighted-terrain');
            });
            var terrainRow = document.getElementById('terrain-' + id);
            if (terrainRow) {
                terrainRow.classList.add('highlighted-terrain');
                var tableContainer = terrainRow.closest('.scroll_table');
                if (tableContainer) {
                    var containerHeight = tableContainer.clientHeight;
                    var rowOffsetTop = terrainRow.offsetTop;
                    var rowHeight = terrainRow.clientHeight;
                    tableContainer.scrollTo({
                        top: rowOffsetTop - containerHeight / 2 + rowHeight / 2,
                        behavior: 'smooth',
                    });
                }
            }
        };

        vm.highlightTableRow = function (id) {
            var rows = document.querySelectorAll('.highlighted-row');
            rows.forEach(function (row) {
                row.classList.remove('highlighted-row');
            });
            var row = document.getElementById('row-' + id);
            if (row) {
                row.classList.add('highlighted-row');
                var tableContainer = row.closest('.scroll_table');
                if (tableContainer) {
                    var containerHeight = tableContainer.clientHeight;
                    var rowOffsetTop = row.offsetTop;
                    var rowHeight = row.clientHeight;
                    tableContainer.scrollTo({
                        top: rowOffsetTop - containerHeight / 2 + rowHeight / 2,
                        behavior: 'smooth',
                    });
                }
            }
        };

        vm.resetTableRowHighlight = function (id) {
            var terrain = document.getElementById('terrain-' + id)
            var row = document.getElementById('row-' + id);
            if (row) {
                row.classList.remove('highlighted-row');
            }
            if (terrain) {
                terrain.classList.remove('highlighted-terrain');
            }
        };
        vm.isFilterMenuOpen = false;
        vm.toggleFilterMenu = function () {
            vm.isFilterMenuOpen = !vm.isFilterMenuOpen;
        };
        vm.fetchRow = function () {
            RouteByID.get(vm.trRoute.id, function (response) {
                vm.routePathResponse = response;
                callRoutePath(vm.routePathResponse.routePoints);
            });
            function callRoutePath(routePaths) {
                var colors = ['#FD7A24', '#0096FF'];
                var pathColor = colors[0];
                var proposedPathColor = colors[1];
                var groupedRoutePaths = {};
                var bounds = new google.maps.LatLngBounds();
                routePaths.forEach(function (coord) {
                    if (coord.sessionNumber) {
                        if (!groupedRoutePaths[coord.sessionNumber]) {
                            groupedRoutePaths[coord.sessionNumber] = { planned: [], proposed: [] };
                        }
                        if (coord.routePointType === 'COORDINATE') {
                            if (coord.phase === 'PLANNING') {
                                groupedRoutePaths[coord.sessionNumber].planned.push(coord);
                            } else if (coord.phase === 'SURVEY') {
                                groupedRoutePaths[coord.sessionNumber].proposed.push(coord);
                            }
                        }
                    }
                });
                Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                    var sessionData = groupedRoutePaths[sessionNumber];
                    var pathData = [];
                    if (vm.trRoute.phase == 'PLANNING') {
                        pathData = sessionData.planned;
                    } else {
                        pathData = sessionData.proposed;
                    }
                    if (pathData.length) {
                        var pathCoordinates = pathData.map(function (coord) {
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                        var pathPolyline = new google.maps.Polyline({
                            path: pathCoordinates,
                            geodesic: true,
                            strokeColor: pathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                            zIndex: 1
                        });
                        pathPolyline.setMap(vm.newMaps);
                    }

                    if (sessionData.proposed.length) {
                        var proposedPathCoordinates = sessionData.proposed.map(function (coord) {
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        proposedPathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                        var proposedPathPolyline = new google.maps.Polyline({
                            path: proposedPathCoordinates,
                            geodesic: true,
                            strokeColor: proposedPathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 3,
                            zIndex: 1
                        });
                        proposedPathPolyline.setMap(vm.newMaps);
                    }
                });
            }
            var markers = [];
            var openedInfoWindow = null;
            var bounds = new google.maps.LatLngBounds();
            vm.newMaps = new google.maps.Map(
                document.getElementById("map_canvasStartss"),
                myOption($rootScope.rolloutMapInitZoom, center)
            );
            geoLocation(vm.newMaps)
            TrRouteForMap.getRoWPathByRoute(vm.trRoute.id, function (response) {
                vm.rowPathResponse = response;
                callRowPath(vm.rowPathResponse);
            });
            function callRowPath(rowPaths) {
                vm.rowPolylines = {};
                vm.rowMarkers = {};
                rowPaths.forEach(function (pathGroup) {
                    vm.rowColorMap = {};
                    vm.rowListResponse.forEach(function (row) {
                        vm.rowColorMap[row.id] = row.colorcode;
                    });
                    var pathColor = vm.rowColorMap[pathGroup.id]
                    if (pathGroup.value && Array.isArray(pathGroup.value.COORDINATE)) {
                        var pathCoordinates = pathGroup.value.COORDINATE.map(function (coord) {
                            if (Array.isArray(coord.routePointNumber)) {
                                coord.routePointNumber.sort(function (a, b) {
                                    return a - b;
                                });
                            }
                            var latLng = { lat: coord.latitude, lng: coord.longitude, routePointNumber: parseFloat(coord.routePointNumber) };
                            bounds.extend(latLng);
                            return latLng;
                        });
                        pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                        var pathPolyline = new google.maps.Polyline({
                            path: pathCoordinates,
                            geodesic: true,
                            strokeColor: pathColor,
                            strokeOpacity: 1.0,
                            strokeWeight: 3,
                            zIndex: 2
                        });
                        pathPolyline.setMap(vm.newMaps);
                        vm.rowPolylines[pathGroup.id] = pathPolyline;
                        var infowindow = new google.maps.InfoWindow();
                        google.maps.event.addListener(pathPolyline, 'click', function (event) {
                            if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }
                            var row = vm.rowListResponse.find(function (row) {
                                return row.id === pathGroup.id;
                            });
                            if (row) {
                                var contentString = '<div class="infoWindowhead">' +
                                    "<b>Terrain Name: " + row.name + "</b></br>" +
                                    "<b>Row-Type: " + row.typeName + "</b></br>" +
                                    "<b>Length: " + row.length + "</b></br>" +
                                    "<b>Phase: " + row.phase + "</b></br>" +
                                    "</div>";

                                infowindow.setContent(contentString);
                                infowindow.setPosition(event.latLng);
                                infowindow.open(vm.newMaps);
                                openedInfoWindow = infowindow;
                            }
                        });
                        var tooltip = new google.maps.InfoWindow();
                        google.maps.event.addListener(pathPolyline, 'mouseover', function (event) {
                            var row = vm.rowListResponse.find(function (row) {
                                return row.id === pathGroup.id;
                            });
                            if (row) {
                                tooltip.setContent("<b>" + row.name + "</b>");
                                tooltip.setPosition(event.latLng);
                                tooltip.open(vm.newMaps);
                            }
                        });

                        // Close tooltip when mouse leaves
                        google.maps.event.addListener(pathPolyline, 'mouseout', function () {
                            tooltip.close();
                        });
                        google.maps.event.addListener(pathPolyline, 'mouseover', function () {
                            vm.highlightTableRow(pathGroup.id);
                        });
                        google.maps.event.addListener(pathPolyline, 'mouseout', function () {
                            vm.resetTableRowHighlight(pathGroup.id);
                        });
                    }
                    if (pathGroup.value && Array.isArray(pathGroup.value.MARKER)) {
                        pathGroup.value.MARKER.forEach(function (coord) {
                            var markerPosition = { lat: coord.latitude, lng: coord.longitude };
                            bounds.extend(markerPosition);
                            var marker = new google.maps.Marker({
                                position: markerPosition,
                                map: vm.newMaps,
                                icon: {
                                    url: 'content/images/markersPoint.png',
                                    scaledSize: new google.maps.Size(iconSize, iconSize),
                                    anchor: new google.maps.Point(
                                        iconSize / 2,
                                        iconSize / 2
                                    ),
                                }
                            });
                            markers.push(marker);
                            markerList.push(marker);

                        });
                        vm.rowMarkers[pathGroup.id] = markerList;
                    }
                    vm.newMaps.fitBounds(bounds);
                });
            }

            vm.rowListResponse;
            vm.uniquePhases = [];
            var phasesMap = {};
            for (var i = 0; i < vm.rowListResponse.length; i++) {
                var phase = vm.rowListResponse[i].phase;
                if (!phasesMap[phase]) {
                    vm.uniquePhases.push({ phase: phase, selected: false });
                    phasesMap[phase] = true;
                }
            }
            vm.uniqueRowTypes = [];
            vm.filteredRowList = vm.rowListResponse;
            vm.updateRowTypes = function () {
                var selectedPhases = [];
                for (var j = 0; j < vm.uniquePhases.length; j++) {
                    if (vm.uniquePhases[j].selected) {
                        selectedPhases.push(vm.uniquePhases[j].phase);
                    }
                }
                if (selectedPhases.length === 0) {
                    vm.uniqueRowTypes = [];

                }
                vm.uniqueRowTypes = [];
                var rowTypesMap = {};
                for (var k = 0; k < vm.rowListResponse.length; k++) {
                    var row = vm.rowListResponse[k];
                    var isPhaseMatched = selectedPhases.indexOf(row.phase) !== -1;
                    var isVerifiedMatch = (vm.isVerifiedFilter && row.isVerified === true) ||
                        (vm.isNotVerifiedFilter && row.isVerified === false) ||
                        (!vm.isVerifiedFilter && !vm.isNotVerifiedFilter);

                    var isDeviatedMatch = (vm.isDeviatedFilter && row.isDeviated === true) ||
                        (!vm.isDeviatedFilter);

                    if (isPhaseMatched && isVerifiedMatch && isDeviatedMatch) {
                        if (!rowTypesMap[row.typeName]) {
                            vm.uniqueRowTypes.push({
                                typeName: row.typeName,
                                colorcode: row.colorcode,
                                selected: false
                            });
                            rowTypesMap[row.typeName] = true;
                        }
                    }
                }
                for (var id in vm.rowPolylines) {
                    if (vm.rowPolylines.hasOwnProperty(id)) {
                        vm.rowPolylines[id].setOptions({ strokeWeight: 3 });
                    }
                }
                vm.areFiltersSelected = function () {
                    var selectedPhases = vm.uniquePhases.some(function (phase) {
                        return phase.selected;
                    });
                    var selectedRowTypes = vm.uniqueRowTypes.some(function (row) {
                        return row.selected;
                    });
                    var selectedVerification = vm.isVerifiedFilter || vm.isNotVerifiedFilter || vm.isDeviatedFilter;
                    return selectedPhases || selectedRowTypes || selectedVerification;
                };

            };
            vm.applyFilters = function () {
                var selectedPhases = [];
                var selectedRowTypes = [];
                for (var l = 0; l < vm.uniquePhases.length; l++) {
                    if (vm.uniquePhases[l].selected) {
                        selectedPhases.push(vm.uniquePhases[l].phase);
                    }
                }
                var filteredList = vm.rowListResponse.filter(function (row) {
                    return selectedPhases.length === 0 || selectedPhases.indexOf(row.phase) !== -1;
                });

                var isVerifiedOrNotChecked = vm.isVerifiedFilter || vm.isNotVerifiedFilter;
                var isDeviatedChecked = vm.isDeviatedFilter;

                filteredList = filteredList.filter(function (row) {
                    return (!isVerifiedOrNotChecked) ||
                        (vm.isVerifiedFilter && row.isVerified === true) ||
                        (vm.isNotVerifiedFilter && (row.isVerified === false || row.isVerified === null));
                });

                filteredList = filteredList.filter(function (row) {
                    return (!isDeviatedChecked) || (vm.isDeviatedFilter && row.isDeviated === true);
                });

                var availableRowTypes = [];
                filteredList.forEach(function (row) {
                    if (availableRowTypes.indexOf(row.typeName) === -1) {
                        availableRowTypes.push(row.typeName);
                    }
                });

                vm.uniqueRowTypes.forEach(function (rowType) {
                    rowType.isAvailable = availableRowTypes.indexOf(rowType.typeName) !== -1;
                });

                for (var m = 0; m < vm.uniqueRowTypes.length; m++) {
                    if (vm.uniqueRowTypes[m].selected) {
                        selectedRowTypes.push(vm.uniqueRowTypes[m].typeName);
                    }
                }

                filteredList = filteredList.filter(function (row) {
                    return selectedRowTypes.length === 0 || selectedRowTypes.indexOf(row.typeName) !== -1;
                });
                for (var id in vm.rowPolylines) {
                    if (vm.rowPolylines.hasOwnProperty(id)) {
                        vm.rowPolylines[id].setOptions({ strokeWeight: 0 });
                    }
                }
                filteredList.forEach(function (row) {
                    var rowId = row.id;
                    if (vm.rowPolylines[rowId]) {
                        vm.rowPolylines[rowId].setOptions({ strokeWeight: 6, strokeColor: row.colorcode });
                    }
                });
                vm.filteredRowList = filteredList;
                vm.isFilterMenuOpen = false;
            };
            vm.resetFilters = function () {
                for (var o = 0; o < vm.uniquePhases.length; o++) {
                    vm.uniquePhases[o].selected = false;
                }
                for (var p = 0; p < vm.uniqueRowTypes.length; p++) {
                    vm.uniqueRowTypes[p].selected = false;
                }
                vm.isVerifiedFilter = false;
                vm.isNotVerifiedFilter = false;
                vm.isDeviatedFilter = false;
                for (var id in vm.rowPolylines) {
                    if (vm.rowPolylines.hasOwnProperty(id)) {
                        vm.rowPolylines[id].setOptions({ strokeWeight: 6 });
                    }
                }

                vm.uniqueRowTypes = []
                vm.filteredRowList = vm.rowListResponse;
            };
            vm.closeFilters = function () {
                vm.isFilterMenuOpen = false;
            };
        };
        vm.SectionMap = new google.maps.Map(
            document.getElementById("SectionMap_canvasStart"),
            myOption($rootScope.rolloutMapInitZoom, center)
        );
        vm.objectSectionImg = {
            hidemarker: false,
            routeId: vm.trRoute ? vm.trRoute.id : null,
            map: vm.SectionMap || null
        };

        if (!vm.objectSectionImg.map) {
            console.error("SectionMap is not defined.");
        }
        var routeMarkers = []
        google.maps.event.addListener(
            vm.SectionMap,
            "dragend",
            function () {
                var center = vm.SectionMap.getCenter();
                imageRoutePoint.postCenterLatLng(vm.trRoute.id, { lat: center.lat(), lng: center.lng() }, function (data) {
                    if (data.length) {
                        for (var i = 0; i < routeMarkers.length; i++) {
                            routeMarkers[i].setMap(null);
                        }
                        routeMarkers = [];
                        callRouteImage(data, vm.SectionMap)
                    }
                })
            }
        );
        function callRouteImage(arr, map) {
            var markerImage, iconImg
            var iconSize = 20
            var iconMarker = "content/images/sm_marker_transparent.png"
            var iconImage = "content/images/routePointImage.png"
            arr.forEach(function (each) {
                iconImg = (each.imageAttached) ? iconImage : iconMarker
                markerImage = new google.maps.Marker({
                    position: { lat: each.latitude, lng: each.longitude },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconImg,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                var infowindow = new google.maps.InfoWindow({
                    content:
                        '',
                });

                google.maps.event.addListener(
                    markerImage,
                    "click",
                    (function () {
                        if (each && each.id && each.imageAttached) {
                            $scope.imgName = (each.name == null) ? "Marker" : each.name
                            $scope.imgLatitude = each.latitude
                            $scope.imgLongitude = each.longitude
                            $scope.$apply();
                            imageRoutePoint.getImagesList(each.id, function (item) {
                                if (item.length >= 2) {
                                    item.forEach(function (i) {
                                        i.rID = each.id
                                    })
                                    $scope.nameImages = item;
                                    $("#modalAttachments").show();

                                } else {
                                    item.map(function (media) {
                                        vm.newTabDisplay(each.id, media.imageId, media.imageType, media.imgDescription)
                                    })
                                }
                                // $scope.$apply()
                            })
                        } else {
                            if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }
                            var contentString = document.createElement("div");
                            contentString.innerHTML =
                                '<div class="infoWindowhead">' +
                                "<br><br>" +
                                "<b>Name : " + each.type + "_" + each.id + "</b><br>" +
                                "<b>Latitude : " + each.latitude + "</b><br>" +
                                "<b>Longitude : " + each.longitude + "</b><br>" +
                                "<b>Type : " + each.type + "</b><br>" +
                                "<br></div>";

                            infowindow.setContent(contentString);
                            infowindow.setPosition({
                                lat: each.latitude,
                                lng: each.longitude
                            });
                            infowindow.open(scope.obj.map);
                            openedInfoWindow = infowindow;

                            if (!each.imageAttached) {
                                var btnShowAsset = document.createElement("input");
                                btnShowAsset.type = "button";
                                btnShowAsset.value = "Show attributes";
                                btnShowAsset.className = "button";

                                google.maps.event.addDomListener(btnShowAsset, "click", function () {
                                    imageRoutePoint.getRouteMarkerDetails(each.id, function (response) {
                                        showAssetAttributesModals(response);
                                    });
                                });

                                contentString.appendChild(btnShowAsset);
                            }

                        }
                    })
                );

                routeMarkers.push(markerImage);
            })


        }
        vm.newTabDisplay = function (id, imgid, str, imgDescription) {
            if (vm.tabNum == 2) {
                $scope.routePointId = id
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) {
                    spinner.style.display = "block";
                }

                var request = new XMLHttpRequest();
                request.open("GET", 'api/routepoint-images/' + id + '/' + imgid, true);
                request.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
                request.responseType = "blob";
                request.onload = function () {
                    if (spinner) {
                        spinner.style.display = "none";
                    }
                    if (request.status === 200) {
                        var urlCreator = window.URL || window.webkitURL;
                        var mediaUrl = urlCreator.createObjectURL(request.response);
                        if (imgDescription == '360') {
                            var modalContent = document.getElementById("mediaModalContent");
                            var videoHTML = '<div class="video-container style="flex: 0 0 70%; height: 500px; position: relative;">' +
                                '<a-scene embedded vr-mode-ui="enabled: true" style="width: 100%; height: 100%; position: absolute;">' +
                                '<a-assets>' +
                                '<video id="video360" loop playsinline webkit-playsinline crossorigin="anonymous" style="width: 100%; height: 100%; object-fit: cover;">' +
                                '<source src="' + mediaUrl + '" type="video/mp4">' +
                                '</video>' +
                                '</a-assets>' +
                                '<a-videosphere src="#video360"></a-videosphere>' +
                                '<a-entity camera position="0 1.6 0" look-controls wasd-controls></a-entity>' +
                                '</a-scene>' +
                                '<div class="controls" style="position: absolute; bottom: 10px; left: 10px; background: rgba(0,0,0,0.5); padding: 10px;">' +
                                '<button id="playPauseBtn">Pause</button>' +
                                '<button id="muteBtn">Mute</button>' +
                                '<input type="range" id="seekBar" min="0" value="0" step="1">' +
                                '</div>' +
                                '</div>';

                            var mapHTML = '<div class="map-container" style="flex: 0 0 30%; height: 379px;">' +
                                '<div id="map" style="width: 100%; height: 100%;"></div>' +
                                '</div>';

                            modalContent.innerHTML = '<div style="display: flex; width: 100%; height: 390px;justify-content: space-between;">' +
                                videoHTML + mapHTML + '</div>';

                            $("#mediaModal").modal("show");
                            $("#mediaModal").on("shown.bs.modal", function () {
                                setTimeout(function () {
                                    var video = document.getElementById("video360");
                                    var playPauseBtn = document.getElementById("playPauseBtn")
                                    var muteBtn = document.getElementById("muteBtn");
                                    var seekBar = document.getElementById("seekBar");
                                    var scene = document.querySelector("a-scene");

                                    if (video) {
                                        video.play();
                                        // Play/Pause
                                        playPauseBtn.addEventListener("click", function () {
                                            if (video.paused) {
                                                video.play();
                                                playPauseBtn.textContent = "Pause";
                                            } else {
                                                video.pause();
                                                playPauseBtn.textContent = "Play";
                                            }
                                        });

                                        // Mute/Unmute
                                        muteBtn.addEventListener("click", function () {
                                            video.muted = !video.muted;
                                            muteBtn.textContent = video.muted ? "Unmute" : "Mute";
                                        });

                                        // Seek Bar Update
                                        video.addEventListener("loadedmetadata", function () {
                                            seekBar.max = video.duration;
                                            var durationInSeconds = video.duration;
                                            var minutes = Math.floor(durationInSeconds / 60);
                                            var seconds = Math.floor(durationInSeconds % 60).toString().padStart(2, '0');
                                        });

                                        video.addEventListener("timeupdate", function () {
                                            seekBar.value = video.currentTime;
                                        });

                                        seekBar.addEventListener("input", function () {
                                            video.currentTime = seekBar.value;
                                        });

                                        // Prevent automatic fullscreen issue
                                        scene.setAttribute("gesture-detector", "enabled: true");

                                        // Keep Modal Open on VR Exit
                                        scene.addEventListener("exit-vr", function () {
                                            $("#mediaModal").modal("show");
                                        });

                                    } else {
                                        console.log("Video element not found.");
                                    }
                                }, 1000);
                            });

                            // Clear modal content when closed
                            $("#mediaModal").on("hidden.bs.modal", function () {
                                modalContent.innerHTML = "";
                            });
                        } else if (str === "MP4") {
                            RouteImageMeta.getData(id, function (response) {
                                var metaCoordinates;
                                metaCoordinates = Array.isArray(response) ? response : [];
                                if (metaCoordinates.length > 0) {
                                    var modalContent = document.getElementById("mediaModalContent");
                                    // Ensure mediaUrl is properly defined before this block
                                    var videoHTML = '<div class="video-container style="flex: 0 0 70%; height: 500px; position: relative;">' +
                                        '<video id="videoPlayer" controls autoplay style="max-width: 99%; max-height: 100vh; object-fit: contain;">' +
                                        '<source src="' + mediaUrl + '" type="video/mp4">' +
                                        'Your browser does not support the video tag.' +
                                        '</video>' +
                                        '</div>';
                                    var mapHTML = '<div class="map-container" style="flex: 0 0 30%; height: 379px;"">' +
                                        '<div id="map" style="width: 100%; height: 100%;"></div>' +
                                        '</div>';

                                    modalContent.innerHTML = '<div  style="display: flex; width: 100%; height: 390px;justify-content: space-between;">' +
                                        videoHTML + mapHTML + '</div>';

                                    $("#mediaModal").modal("show");

                                    $("#mediaModal").on("shown.bs.modal", function () {
                                        setTimeout(function () {
                                            var video = document.getElementById("videoPlayer");
                                            if (!video) return;
                                            video.onpause = function () {
                                                pauseMarkerAnimation();
                                            };
                                            video.onplay = function () {
                                                resumeMarkerAnimation();
                                            };

                                            var lastTime = 0;

                                            video.addEventListener('canplay', function () {
                                                var givenTime = video.currentTime;
                                                var direction = givenTime >= lastTime ? 'forward' : 'backward'; // Determine playback direction

                                                var nearestIndex = $scope.coordinates.findIndex(function (coord) {
                                                    return coord.timeInSec >= givenTime;
                                                });

                                                if (nearestIndex === -1) {
                                                    nearestIndex = $scope.coordinates.length - 1;
                                                }
                                                $scope.nearestObject = $scope.coordinates[nearestIndex];

                                                if (direction === 'backward') {
                                                    clearPolylines();
                                                    drawBackwardPolyline(nearestIndex);
                                                } else if (direction === 'forward') {
                                                    drawForwardPolyline(nearestIndex);
                                                }

                                                clearTimeout(animationTimeout);
                                                animatedMove($scope.usermarker, $scope.coordinates, nearestIndex);
                                                lastTime = givenTime;
                                            });
                                            function clearPolylines() {
                                                if ($scope.polyline) {
                                                    $scope.polyline.setMap(null);
                                                    $scope.polyline = null;
                                                }
                                            }
                                            function drawForwardPolyline(nearestIndex) {
                                                var pathCoordinates = $scope.coordinates.slice(0, nearestIndex + 1).map(function (coord) {
                                                    return { lat: coord.lat, lng: coord.lng }
                                                });

                                                if ($scope.polyline) {
                                                    $scope.polyline.setPath(pathCoordinates);
                                                } else {
                                                    $scope.polyline = new google.maps.Polyline({
                                                        path: pathCoordinates,
                                                        geodesic: true,
                                                        strokeColor: '#0000FF',
                                                        strokeOpacity: 0.8,
                                                        strokeWeight: 16,
                                                    });
                                                    $scope.polyline.setMap(scope.map);
                                                }
                                            }

                                            function drawBackwardPolyline(nearestIndex) {
                                                var pathCoordinates = $scope.coordinates.slice(0, nearestIndex - 1).map(function (coord) {
                                                    return { lat: coord.lat, lng: coord.lng }
                                                });

                                                clearPolylines();
                                                if ($scope.polyline) {
                                                    $scope.polyline.setPath(pathCoordinates);
                                                } else {
                                                    $scope.polyline = new google.maps.Polyline({
                                                        path: pathCoordinates,
                                                        geodesic: true,
                                                        strokeColor: '#0000FF',
                                                        strokeOpacity: 0.8,
                                                        strokeWeight: 16,
                                                    });
                                                    $scope.polyline.setMap(scope.map);
                                                }
                                            }

                                            clearTimeout(animationTimeout);
                                            isPaused = false;
                                            currentIndex = 0;
                                            animatedMove($scope.usermarker, $scope.coordinates, 0);

                                        }, 100);
                                    });

                                    // **Clear modal content when hidden**
                                    $("#mediaModal").on("hidden.bs.modal", function () {
                                        modalContent.innerHTML = "";
                                        if ($scope.polyline) {
                                            $scope.polyline.setMap(null);
                                            $scope.polyline = null;
                                        }
                                        $scope.usermarker = null;
                                        clearTimeout(animationTimeout);
                                        isPaused = false;
                                        animationTimeout = null;
                                        currentIndex = 0;
                                    });

                                } else if (metaCoordinates.length === 0) {
                                    var modalContent = document.getElementById("mediaModalContent");
                                    var videoHTML =
                                        '<div class="video-container" style="width: 100%; height: 600px; position: relative;">' +
                                        '<video id="videoPlayer" controls autoplay style="max-width: 100%; max-height: 100vh; object-fit: contain;">' +
                                        '<source src="' + mediaUrl + '" type="video/mp4">' +
                                        'Your browser does not support the video tag.' +
                                        '</video>' +
                                        '</div>';

                                    modalContent.innerHTML = videoHTML;

                                    $("#mediaModal").modal("show");

                                    $("#mediaModal").on("hidden.bs.modal", function () {
                                        modalContent.innerHTML = "";
                                    });

                                    return;
                                }
                            })
                        } else {
                            var modalContent = document.getElementById("mediaModalContent");
                            // modalContent.innerHTML = '<img src="' + mediaUrl + '" style="max-width: 90%; max-height: 60vh; width: 800px; height: 700px;" alt="Image">';
                            modalContent.innerHTML = '<img id="zoomableImage" src="' + mediaUrl + '" ' +
                                'style="max-height: 60vh; height: 700px; width: auto; display: block; margin: auto; ' +
                                'object-fit: contain; transition: transform 0.1s ease;" ' +
                                'alt="Image">';

                            var img = document.getElementById("zoomableImage");
                            var scale = 1;

                            img.onmousewheel = function (event) {
                                event = event || window.event; // Support for older browsers
                                event.preventDefault(); // Prevent page scrolling

                                if (event.wheelDelta > 0) {
                                    // Zoom in
                                    scale += 0.1;
                                } else {
                                    // Zoom out (minimum scale of 1)
                                    scale = Math.max(1, scale - 0.1);
                                }

                                img.style.transform = "scale(" + scale + ")";
                            };


                            $("#mediaModal").modal("show");

                            $("#mediaModal").on("hidden.bs.modal", function () {
                                modalContent.innerHTML = "";
                            });
                        }
                    } else {
                        alert("Error loading media: " + request.status);
                    }
                };

                request.onerror = function () {
                    alert("Network error while fetching media.");
                };

                request.send();
            }
        };
        var minRouteMetaUtcTime = 0;
        var metaCoordinates = []
        var customControlDiv = document.createElement('div');
        var customControlText = document.createElement('div');
        // var geocoder = new google.maps.Geocoder();

        $scope.initializeMap = function () {
            if (vm.tabNum == 2) {
                if (!document.getElementById("map")) {
                    console.error("Map element not found!");
                    return;
                }
                $scope.map = new google.maps.Map(document.getElementById("map"), {
                    center: { lat: 13.027893369650114, lng: 77.59144741784749 },
                    zoom: 18,
                    tilt: 45, // Enable 3D mode for rotation
                    heading: 0,
                    // mapId: "90f87356969d889c", // Vector map ID required for tilt and rotation
                    mapTypeControl: false,
                    disableDefaultUI: true,
                    cameraControl: true,
                    fullscreenControl: true
                });
                coordinateListPlanSurvey.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                $scope.polyline = new google.maps.Polyline({
                    path: coordinateListPlanSurvey,
                    geodesic: true,
                    strokeColor: '#0000FF', // Set polyline color
                    strokeOpacity: 0.4,
                    strokeWeight: 32,
                    map: $scope.map
                });

                customControlText.style.backgroundColor = 'rgba(211, 211, 211, 0.7)';
                customControlText.style.color = '#1a237e';
                customControlText.style.fontSize = '12px';
                customControlText.style.fontWeight = 'bold';
                customControlText.style.padding = '12px';
                customControlText.style.margin = '10px';
                customControlText.style.borderRadius = '5px';
                customControlText.style.boxShadow = '0px 2px 5px rgba(0, 0, 0, 0.3)';
                customControlDiv.appendChild(customControlText);
                $scope.map.controls[google.maps.ControlPosition.TOP_LEFT].push(customControlDiv);

                $scope.polyline = new google.maps.Polyline({
                    path: [],
                    geodesic: true,
                    strokeColor: '#0000FF',
                    strokeOpacity: 0.8,
                    strokeWeight: 16,
                    map: $scope.map
                });

                RouteImageMeta.getData($scope.routePointId, function (response) {
                    $scope.metaCoordinates = Array.isArray(response) ? response : [];
                    if (!response || response.length === 0) {
                        console.warn("No coordinates received.");
                        return;
                    }
                    minRouteMetaUtcTime = $scope.metaCoordinates.reduce(function (min, current) {
                        return current.coordinateDate < min ? current.coordinateDate : min;
                    }, $scope.metaCoordinates[0].coordinateDate);

                    $scope.metaCoordinates.sort(function (a, b) { return a.sortOrder - b.sortOrder; });
                    // Extract the coordinates and their corresponding coordinateDate
                    $scope.coordinates = $scope.metaCoordinates.map(function (coord) {
                        return { lat: coord.latitude, lng: coord.longitude, coordinateDate: coord.coordinateDate, gpsAccuracy: coord.gpsAccuracy, timeInSec: (coord.coordinateDate - minRouteMetaUtcTime) / 1000 };
                    });
                    $scope.usermarker = new google.maps.Marker({
                        position: $scope.coordinates[0],
                        map: $scope.map,
                        icon: {
                            url: 'content/images/geoLocationAnim.gif',
                            scaledSize: new google.maps.Size(24, 24),
                            anchor: new google.maps.Point(12, 12)
                        }
                    });
                    animatedMove($scope.usermarker, $scope.coordinates, 0);
                });
            }
        };
        var animationTimeout;
        var isPaused = false;
        var currentStep = 0;
        var currentIndex = 0;

        function animatedMove(usermarker, coords, index) {
            currentIndex = index; // Save the current coordinate index
            var moveto = new google.maps.LatLng(coords[index].lat, coords[index].lng);

            $scope.moveMarker(usermarker, coords, index, moveto); // Start animation
        }

        $scope.moveMarker = function (usermarker, coords, index, moveto) {
            if (isPaused) return; // Exit if paused
            usermarker.setPosition(moveto);
            $scope.map.setCenter(moveto);
            $scope.polyline.getPath().push(moveto);
            showLatLngOnMapForVideo(moveto.lat(), moveto.lng(), coords[index].gpsAccuracy);
            if (index < coords.length - 1) {
                var nextPoint = coords[index + 1];
                var bearing = getBearing(moveto.lat(), moveto.lng(), nextPoint.lat, nextPoint.lng);
                $scope.map.setHeading(bearing);
            }
            animationTimeout = setTimeout(function () {
                animatedMove(usermarker, coords, index + 1);
            }, 1000);
        }
        function pauseMarkerAnimation() {
            isPaused = true;
            clearTimeout(animationTimeout); // Stop the ongoing movement
        }
        function resumeMarkerAnimation() {
            if (!isPaused) return;
            isPaused = false;
            if (!$scope.usermarker || !$scope.coordinates) {
                console.error("usermarker or coordinates are not defined");
                return;
            }
            animatedMove($scope.usermarker, $scope.coordinates, currentIndex);
        }

        function showLatLngOnMapForVideo(lat, lng, gpsAccuracy) {
            var accuracy = gpsAccuracy;
            if (gpsAccuracy == null) {
                accuracy = "";
            } else {
                accuracy.toFixed(2);
            }
            // var latLng = new google.maps.LatLng(lat, lng);
            customControlText.innerHTML = 'Location: ' + lat.toFixed(8) + ', ' + lng.toFixed(8);
            // geocoder.geocode({ 'location': latLng }, function (results, status) {
            //     if (status === google.maps.GeocoderStatus.OK) {
            //         if (results[0]) {
            //             customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>' + results[0].formatted_address;
            //         } else {
            //             customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>No address found.';
            //         }
            //     } else {
            //         customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>Geocode failed: ' + status;
            //     }
            // });
        }

        function getBearing(lat1, lng1, lat2, lng2) {
            var dLon = (lng2 - lng1) * (Math.PI / 180);
            lat1 = lat1 * (Math.PI / 180);
            lat2 = lat2 * (Math.PI / 180);

            var y = Math.sin(dLon) * Math.cos(lat2);
            var x = Math.cos(lat1) * Math.sin(lat2) -
                Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
            var brng = Math.atan2(y, x) * (180 / Math.PI);
            return (brng + 360) % 360; // Normalize to 0-360 degrees
        }

        $("#mediaModal").on("shown.bs.modal", function () {
            setTimeout(function () {
                $scope.initializeMap();
            }, 2000);
        });
        $scope.closeModal = function (id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }
        function showAssetAttributesModals(assetVal) {
            var AttributeValues = []
            $("#modalAssetAttributes").show();
            AttributeValues.push({
                "Id": assetVal.id,
                "Depth": assetVal.depth,
                "Distance": assetVal.distance,
                "Latitude": assetVal.latitude,
                "Longitude": assetVal.longitude,
                "LHS Offset": assetVal.lhsOffset,
                "Land Mark": assetVal.landMark,
                "Height": assetVal.height,
                "RHS Offset": assetVal.rhsOffset,
                "Route Offset": assetVal.routeOffset,
                "Road Width": assetVal.roadWidth,
                "RodoMeter Length": assetVal.rodometerLength,
                "Route Point Type": assetVal.routePointType,
                "Road Type": assetVal.roadType,
                "Placement Level": assetVal.placementLevel,
                "Phase": assetVal.phase,
                "Status": assetVal.status,
                "Surrounding Type": assetVal.surroundingType,
                "Soil Type": assetVal.soilType,
                "Terrain Area": assetVal.terrainArea,
            })
            var attributes = AttributeValues[0];
            document.getElementById("assetAttributeTable").innerHTML = "";
            var newTable =
                "<table align='center' style='border: 1px solid black; width: 80%;'>" +
                "<tr><th style='border: 1px solid black; text-align: center;'>Attribute</th>" +
                "<th style='border: 1px solid black; text-align: center;'>Attribute Value</th></tr>";

            for (var key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    newTable +=
                        "<tr><td style='border: 1px solid black; text-align: center;'>" +
                        key +
                        "</td><td style='border: 1px solid black; text-align: center;'>" +
                        (attributes[key] !== null ? attributes[key] : "N/A") +
                        "</td></tr>";
                }
            }

            newTable += "</table>";

            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.id + " - " + (assetVal.routePointType || "Unknown");
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }


        document.getElementById("maximizeBtn").addEventListener("click", function () {
            var modalDialog = document.querySelector("#mediaModal .modal-dialog");
            var videoContainer = document.querySelector("#mediaModalContent .video-container");
            var modalContent = document.getElementById("mediaModalContent");
            if (metaCoordinates.length > 0) {
                var mapContainer = document.querySelector("#mediaModalContent .map-container");
                mapContainer.style.flex = "0 0 25%";
                mapContainer.style.height = "86vh";
                videoContainer.style.height = '400px'
            }
            if (metaCoordinates.length == 0) {
                videoContainer.style.height = '610px'
            }


            modalDialog.style.width = "100%";
            modalDialog.style.height = "100vh";
            modalDialog.style.maxWidth = "100%";
            modalDialog.style.margin = "0";
            modalDialog.style.paddingLeft = "0";
            modalDialog.style.top = "0px";
            modalContent.style.height = "100vh";
            videoContainer.style.flex = "0 0 75%";
            document.getElementById("maximizeBtn").style.display = "none";
            document.getElementById("minimizeBtn").style.display = "inline-block";
        });

        document.getElementById("minimizeBtn").addEventListener("click", function () {
            var modalDialog = document.querySelector("#mediaModal .modal-dialog");
            var videoContainer = document.querySelector("#mediaModalContent .video-container");
            var zoomableImage = document.querySelector("#mediaModalContent .zoomableImage");
            var modalContent = document.getElementById("mediaModalContent");
            if (metaCoordinates.length > 0) {
                var mapContainer = document.querySelector("#mediaModalContent .map-container");
                mapContainer.style.flex = "0 0 30%";
                mapContainer.style.height = "379px";
                modalContent.style.height = "400px";
                modalDialog.style.paddingLeft = "0";
            }
            if (metaCoordinates.length == 0) {
                modalDialog.style.paddingLeft = "0";
                modalContent.style.height = "615px";
            }
            modalDialog.style.width = "auto";
            modalDialog.style.height = "auto";
            modalDialog.style.maxWidth = "80%";
            modalDialog.style.margin = "auto";
            modalDialog.style.paddingLeft = "0";
            modalDialog.style.top = "50px";
            videoContainer.style.flex = "0 0 70%";
            videoContainer.style.height = "600px";
            document.getElementById("maximizeBtn").style.display = "inline-block";
            document.getElementById("minimizeBtn").style.display = "none";
        });

        $("#mediaModal").on("hidden.bs.modal", function () {
            var modalDialog = document.querySelector("#mediaModal .modal-dialog");
            var videoContainer = document.querySelector("#mediaModalContent .video-container");
            var mapContainer = document.querySelector("#mediaModalContent .map-container");
            var modalContent = document.getElementById("mediaModalContent");

            modalDialog.style.width = "auto";
            modalDialog.style.height = "auto";
            modalDialog.style.maxWidth = "80%";
            modalDialog.style.margin = "auto";
            modalDialog.style.paddingLeft = "0";
            modalDialog.style.top = "50px";

            if (videoContainer) {
                videoContainer.style.flex = "0 0 70%";
                videoContainer.style.height = "500px";
            }
            if (mapContainer) {
                mapContainer.style.flex = "0 0 30%";
                mapContainer.style.height = "379px";
            }
            if (modalContent) {
                modalContent.style.height = "400px";
                modalContent.innerHTML = "";
            }
            if (modalContent && metaCoordinates.length === 0) {
                modalContent.style.height = "610px";
                modalContent.innerHTML = "";
            }

            document.getElementById("maximizeBtn").style.display = "inline-block";
            document.getElementById("minimizeBtn").style.display = "none";

            var videoElement = document.querySelector("#mediaModalContent video");
            if (videoElement) {
                videoElement.pause();
                videoElement.src = "";
                videoElement.load();
            }

            var aScene = document.querySelector("a-scene");
            if (aScene) {
                aScene.innerHTML = "";
            }
            if (metaCoordinates.length > 0) {
                var mapElement = document.getElementById("map");
                if (mapElement) {
                    mapElement.innerHTML = "";
                }
            }
        });

        geoLocation(vm.SectionMap)
        if (vm.trRoute && vm.trRoute.routePoints != null && vm.trRoute.routePoints.length) {
            vm.trRoute.routePoints.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

            var groupedRoutePoints = {};
            vm.trRoute.routePoints.forEach(function (each) {
                if (each.routePointType == "COORDINATE" && each.phase != null) {
                    if (!groupedRoutePoints[each.sessionNumber]) {
                        groupedRoutePoints[each.sessionNumber] = [];
                    }
                    groupedRoutePoints[each.sessionNumber].push({ lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber });
                }
            });

            Object.keys(groupedRoutePoints).forEach(function (sessionNumber) {
                var sessionCoordinates = groupedRoutePoints[sessionNumber];
                var bounds = new google.maps.LatLngBounds();

                if (sessionCoordinates.length) {
                    sessionCoordinates.forEach(function (coord) {
                        bounds.extend(coord);
                    });
                    sessionCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                    var polyline = new google.maps.Polyline({
                        path: sessionCoordinates,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                        zIndex: 1
                    });
                    polyline.setMap(vm.SectionMap);
                }
                vm.SectionMap.fitBounds(bounds);
            });
        }

        var sectionPath = {};
        vm.getSectionPath = function () {
            //section path

            vm.sectionPolyline = {}
            routeDetail.getRoutesDetails(entity.id, function (response) {
                vm.sectionResponse = response
                vm.sectionResponse.forEach(function (section) {
                    TaskSectionById.get(section.sectionId, function (sectionVal) {
                        sectionPath = sectionVal;
                        if (sectionPath.COORDINATE != null) {
                            sectionPath.COORDINATE.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });

                            sectionPath.COORDINATE.forEach(function (coor) {
                                if (coor.routePointNumber) {
                                    coordinateList.push({ latitude: coor.latitude, longitude: coor.longitude, sort: coor.routePointNumberDouble, sessionNumber: coor.sessionNumber });
                                }
                            });
                        }

                    })
                })
                if (coordinateList.length) {
                    vm.SectionMap.setCenter({ lat: coordinateList[0].latitude, lng: coordinateList[0].longitude });
                    var groupedBySessionNumber = {};
                    for (var i = 0; i < coordinateList.length; i++) {
                        var item = coordinateList[i];
                        var session = item.sessionNumber;

                        if (!groupedBySessionNumber[session]) {
                            groupedBySessionNumber[session] = [];
                        }

                        groupedBySessionNumber[session].push(item);
                    }

                    // Initialize groupedRoutePaths
                    var groupedRoutePaths = {};

                    // Populate groupedRoutePaths with session data
                    Object.keys(groupedBySessionNumber).forEach(function (sessionNumber) {
                        var sessionData = groupedBySessionNumber[sessionNumber];

                        // Map session data to lat/lng pairs
                        if (sessionData) {
                            groupedRoutePaths[sessionNumber] = sessionData.map(function (point) {
                                return { lat: point.latitude, lng: point.longitude, sort: point.sort, sessionNumber: point.sessionNumber };
                            });
                        }
                    });
                    Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                        if (sessionNumber !== "null") {
                            var paths = groupedRoutePaths[sessionNumber];
                            paths.sort(function (a, b) {
                                return a.sort - b.sort;
                            });
                            var polylines = new google.maps.Polyline({
                                path: paths,
                                geodesic: true,
                                strokeColor: 'red',
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                                zIndex: 2
                            });
                            polylines.setMap(vm.SectionMap);
                        }
                    });

                }

            })
            vm.taskPolyline = vm.taskPolyline || {};
            vm.dailyLogPolyline = vm.dailyLogPolyline || {};
            vm.obstaclePolyline = vm.obstaclePolyline || {};
            vm.sectionResponse.forEach(function (task) {
                Inventory.taskBySection(task.sectionId, function (response) {
                    vm.taskLogResponse = response;
                    vm.taskLogResponse.forEach(function (task) {
                        Inventory.taskPathByID(task.id, function (response) {
                            if (response.COORDINATE !== undefined) {
                                var polylineCoordinates = [];
                                response.COORDINATE.forEach(function (coordinate) {
                                    if (coordinate.routePointType === 'COORDINATE') {
                                        var latLng = {
                                            lat: coordinate.latitude,
                                            lng: coordinate.longitude
                                        };
                                        polylineCoordinates.push(latLng);
                                    }
                                });
                                var taskPolyline = new google.maps.Polyline({
                                    path: polylineCoordinates,
                                    geodesic: true,
                                    strokeColor: '#c89f9c',
                                    strokeOpacity: 0.4,
                                    strokeWeight: 4,
                                    zIndex: 2
                                });
                                taskPolyline.setMap(vm.SectionMap);
                                vm.taskPolyline[task.id] = taskPolyline;
                            }
                        });
                        taskComment.getTaskLogsPaths(task.id, function (response) {
                            function drawPath(logType, color, zIndex) {
                                var segmentCoordinates = [];
                                DailyLogByTaskIdWithType.query({ id: task.id, type: logType }, function (logs) {
                                    response.forEach(function (item) {
                                        logs.forEach(function (log) {
                                            if (item.id == log.id) {
                                                var sortedCoordinates = item.value.COORDINATE.filter(function (coord) {
                                                    return coord.routePointType === "COORDINATE" && coord.latitude && coord.longitude
                                                })
                                                    .sort(function (a, b) {
                                                        var numA = parseFloat(a.routePointNumber) || 0;
                                                        var numB = parseFloat(b.routePointNumber) || 0;
                                                        return numA - numB;
                                                    });
                                                sortedCoordinates.forEach(function (coord) {
                                                    segmentCoordinates.push({
                                                        lat: coord.latitude,
                                                        lng: coord.longitude,
                                                        routePointNumber: parseFloat(coord.routePointNumber),
                                                    });
                                                });
                                                if (segmentCoordinates.length > 1) {
                                                    drawPolyline(segmentCoordinates, color, zIndex);
                                                }
                                                segmentCoordinates = [];
                                            }
                                        });
                                    });
                                });
                                var pathPolyline = new google.maps.Polyline({
                                    path: segmentCoordinates,
                                    geodesic: true,
                                    strokeColor: color,
                                    strokeOpacity: 0.4,
                                    strokeWeight: 4,
                                    zIndex: zIndex
                                });
                                pathPolyline.setMap(vm.SectionMap);
                            }
                            function drawPolyline(coordinates, color, zIndex, bounds) {
                                var polyline = new google.maps.Polyline({
                                    path: coordinates.map(function (latLng) {
                                        return new google.maps.LatLng(latLng.lat, latLng.lng);
                                    }),
                                    geodesic: true,
                                    strokeColor: color,
                                    strokeOpacity: 1.0,
                                    strokeWeight: 4,
                                    zIndex: zIndex,
                                });
                                polyline.setMap(vm.SectionMap);
                            }
                            drawPath("OBSTACLE", "#ff0000", 4);
                            drawPath("PROGRESS", "#00e658", 3);
                        });
                    });
                });
            });
            vm.taskCombinedData = [];
            vm.sectionCombinedData = [];
            var taskDataLoaded = false;
            var sectionDataLoaded = false;

            function checkAndMergeData() {
                if (taskDataLoaded && sectionDataLoaded) {
                    var taskLengths = {};
                    var obstacleLengths = {};
                    var taskLengthsLoadedCount = 0;
                    var obstacleLengthsLoadedCount = 0;

                    vm.taskCombinedData.forEach(function (task) {
                        dailyLog.query({ id: task.taskId }, function (response) {
                            var totalLength = 0;
                            angular.forEach(response, function (log) {
                                totalLength += log.workLength;
                            });
                            taskLengths[task.taskId] = totalLength;
                            taskLengthsLoadedCount++;
                            if (taskLengthsLoadedCount === vm.taskCombinedData.length && obstacleLengthsLoadedCount === vm.taskCombinedData.length) {
                                mergeTaskSectionData(taskLengths, obstacleLengths);
                            }
                        });
                        dailyLogByTaskId.query({ id: task.taskId }, function onSuccess(response) {
                            var obstacleLength = 0;
                            angular.forEach(response, function (log) {
                                obstacleLength += log.workLength;
                            });
                            obstacleLengths[task.taskId] = obstacleLength;
                            obstacleLengthsLoadedCount++;
                            if (taskLengthsLoadedCount === vm.taskCombinedData.length && obstacleLengthsLoadedCount === vm.taskCombinedData.length) {
                                mergeTaskSectionData(taskLengths, obstacleLengths);
                            }
                        });
                    });
                    vm.updateTasksWithMaterials()
                }
            }

            function mergeTaskSectionData(taskLengths, obstacleLengths) {
                vm.mergedArray = vm.taskCombinedData.map(function (task) {
                    var matchingSection = vm.sectionCombinedData.find(function (section) {
                        return section.sectionId === task.sectionId;
                    });
                    return {
                        TaskName: task.TaskName,
                        taskId: task.taskId,
                        taskLength: task.taskLength || "N/A",
                        fromLatlng: task.fromLatlng || 'N/A',
                        toLatlng: task.toLatlng || "N/A",
                        routeId: task.routeId,
                        sectionId: task.sectionId,
                        sectionName: matchingSection ? matchingSection.sectionName : "Unknown Section",
                        vendorName: matchingSection ? matchingSection.vendorName : "Unknown Vendor",
                        totalLength: taskLengths[task.taskId] || 0,
                        obstacleLength: obstacleLengths[task.taskId] || 0,
                        isExpanded: false
                    };
                });

                vm.uniqueMaterials = [];
                vm.mtrlTxSummaries = {};

                angular.forEach(vm.mergedArray, function (item) {
                    SummaryPost.mtrlTx({ taskIds: [item.taskId] }, function (response) {
                        vm.mtrlTxSummaries[item.taskId] = response;
                        angular.forEach(response, function (material) {
                            var existing = vm.uniqueMaterials.find(function (m) {
                                return m.materialName === material.materialName && m.transactionType === material.transactionType;
                            });
                            if (existing) {
                                existing.totalNoOfUnits += material.totalNoOfUnits;
                            } else {
                                vm.uniqueMaterials.push({
                                    materialName: material.materialName,
                                    transactionType: material.transactionType,
                                    totalNoOfUnits: material.totalNoOfUnits,
                                    length: material.unitOfMeasurementName
                                });
                            }
                        });
                        vm.updateTasksWithMaterials();
                    });
                });
                loadMaterialsForTasks();
            }
            routeDetail.getRoutesDetails(entity.id, function (response) {
                vm.sectionResponse = response;
                angular.forEach(vm.sectionResponse, function (section) {
                    vm.sectionCombinedData.push({
                        sectionId: section.sectionId,
                        routeId: section.routeId,
                        sectionName: section.sectionName,
                        vendorName: section.vendorName || 'N/A',
                    });
                });
                sectionDataLoaded = true;
                function loadTasksSequentially(index) {
                    if (index >= vm.sectionResponse.length) {
                        taskDataLoaded = true;
                        checkAndMergeData();
                        return;
                    }

                    var section = vm.sectionResponse[index];
                    routeDetail.taskBySection(section.sectionId, function (taskResponse) {
                        angular.forEach(taskResponse, function (task) {
                            vm.taskCombinedData.push({
                                TaskName: task.name,
                                taskId: task.id,
                                taskLength: task.length || 'N/A',
                                fromLatlng: task.fromLatlng || 'N/A',
                                toLatlng: task.toLatLng || "N/A",
                                routeId: section.routeId,
                                sectionId: section.sectionId
                            });
                        });
                        loadTasksSequentially(index + 1);
                    });
                }
                loadTasksSequentially(0);
                vm.updateTasksWithMaterials();
            });

            vm.toggleSection = function (item) {
                vm.mergedArray.forEach(function (otherItem) {
                    if (otherItem !== item) {
                        otherItem.isExpand = false;
                    }
                });
                item.isExpand = !item.isExpand;
                if (item.isExpand) {
                    SummaryPost.mtrlTx({ taskIds: [item.taskId] }, function (response) {
                        vm.mtrlTxSummary = response;
                    });
                }
            };
            vm.tasksWithMaterials = [];
            function allMaterialsLoaded() {
                return vm.mergedArray.every(function (item) { return vm.mtrlTxSummaries && vm.mtrlTxSummaries[item.taskId] });
            }
            vm.updateTasksWithMaterials = function () {
                vm.tasksWithMaterials = [];
                if (vm.mergedArray && vm.mergedArray.length > 0) {
                    vm.mergedArray.forEach(function (item) {
                        if (vm.mtrlTxSummaries && vm.mtrlTxSummaries[item.taskId]) {
                            var materialMap = {};
                            vm.mtrlTxSummaries[item.taskId].forEach(function (material) {
                                var uniqueKey = material.materialName;
                                if (!materialMap[uniqueKey]) {
                                    materialMap[uniqueKey] = {
                                        sectionName: item.sectionName,
                                        TaskName: item.TaskName,
                                        materialName: material.materialName,
                                        unitOfMeasurementName: material.unitOfMeasurementName,
                                        Requested: 0,
                                        Received: 0,
                                        Utilized: 0,
                                        Reconciled: 0
                                    };
                                }
                                switch (material.transactionType) {
                                    case 'REQUESTED':
                                        materialMap[uniqueKey].Requested += material.totalNoOfUnits;
                                        break;
                                    case 'RECEIVED':
                                        materialMap[uniqueKey].Received += material.totalNoOfUnits;
                                        break;
                                    case 'UTILIZED':
                                        materialMap[uniqueKey].Utilized += material.totalNoOfUnits;
                                        break;
                                    case 'RECONCILED':
                                        materialMap[uniqueKey].Reconciled += material.totalNoOfUnits;
                                        break;
                                }
                            });
                            for (var key in materialMap) {
                                vm.tasksWithMaterials.push(materialMap[key]);
                            }
                        }
                    });
                }
            };
            function loadMaterialsForTasks() {
                angular.forEach(vm.mergedArray, function (item) {
                    if (!vm.mtrlTxSummaries) {
                        vm.mtrlTxSummaries = {};
                    }

                    SummaryPost.mtrlTx({ taskIds: [item.taskId] }, function (response) {
                        vm.mtrlTxSummaries[item.taskId] = response;
                        if (allMaterialsLoaded()) {
                            vm.updateTasksWithMaterials();
                        }
                    });
                });
            }
        }
        vm.downloadMaterialTnx = function () {
            var csvContent = "data:text/csv;charset=utf-8,";
            csvContent += "Sl No,Section Name,Task Name,Material Name,Unit,Requested,Received,Utilized,Reconciled\n";
            vm.tasksWithMaterials.forEach(function (material, index) {
                var row = [
                    index + 1,
                    material.sectionName,
                    material.TaskName,
                    material.materialName,
                    material.unitOfMeasurementName || 0,
                    material.Requested || 0,
                    material.Received || 0,
                    material.Utilized || 0,
                    material.Reconciled || 0
                ].join(",");
                csvContent += row + "\n";
            });

            var encodedUri = encodeURI(csvContent);
            var downloadLink = document.createElement("a");
            downloadLink.href = encodedUri;
            downloadLink.download = entity.name + "_Material_List.csv";
            downloadLink.click();
        };

        vm.startPoint = null;
        vm.endPoint = null;
        vm.highlightLog = function (id) {
            var polyline = vm.dailyLogPolyline[id];
            if (polyline) {
                polyline.setOptions({
                    strokeWeight: 16
                });
                var path = polyline.getPath().getArray();
                var fromLatLng = path[0];
                var toLatLng = path[path.length - 1];
                if (vm.startPoint) {
                    vm.startPoint.setMap(null);
                }
                if (vm.endPoint) {
                    vm.endPoint.setMap(null);
                }
                vm.startPoint = new google.maps.Marker({
                    position: fromLatLng,
                    map: vm.SectionMap,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: "content/images/sections.png",
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            -4
                        ),
                        labelOrigin: new google.maps.Point(25, 22)
                    },
                    label: {
                        text: 'Start',
                        color: '#000000',
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }
                });
                vm.endPoint = new google.maps.Marker({
                    position: toLatLng,
                    map: vm.SectionMap,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: "content/images/sections.png",
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            -4
                        ),
                        labelOrigin: new google.maps.Point(25, 22)
                    },
                    label: {
                        text: 'End',
                        color: '#000000',
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }
                });
            }
        };
        vm.resetLog = function () {
            Object.keys(vm.dailyLogPolyline).forEach(function (key) {
                var polyline = vm.dailyLogPolyline[key];
                if (polyline) {
                    polyline.setOptions({
                        strokeWeight: 6
                    });
                }
            });
            if (vm.startPoint) {
                vm.startPoint.setMap(null);
                vm.startPoint = null;
            }
            if (vm.endPoint) {
                vm.endPoint.setMap(null);
                vm.endPoint = null;
            }
        };
        vm.highlightTask = function (taskId) {
            for (var id in vm.taskPolyline) {
                if (id == taskId) {
                    vm.taskPolyline[id].setOptions({ strokeWeight: 12 });
                } else {
                    vm.taskPolyline[id].setOptions({ strokeWeight: 7 });
                }
            }
        }
        vm.resetTask = function () {
            for (var id in vm.taskPolyline) {
                if (vm.taskPolyline.hasOwnProperty(id)) {
                    vm.taskPolyline[id].setOptions({ strokeWeight: 7 });
                }
            }
        }
        vm.highlightSection = function (sectionId) {
            var iconSize = 30;
            for (var id in vm.sectionPolyline) {
                if (vm.sectionPolyline.hasOwnProperty(id)) {
                    if (id == sectionId) {
                        vm.sectionPolyline[id].setOptions({
                            strokeWeight: 7
                        });
                    }
                }
            }
        };
        vm.resetRoute = function () {
            for (var id in vm.sectionPolyline) {
                if (vm.sectionPolyline.hasOwnProperty(id)) {
                    vm.sectionPolyline[id].setOptions({ strokeWeight: 5 });
                }
            }
        }
        setTimeout(function () {
            TaskStatusById.post(
                { routeIds: [entity.id] },
                function (statusresponse) {
                    vm.taskstatus = statusresponse;
                    if (vm.taskstatus.length) {
                        callTaskStatusByStagCat()
                    }
                }
            );
        }, 5000)
        function callTaskStatusByStagCat() {
            vm.objectTaskStatus = {}
            vm.taskstatus.forEach(function (eachElement) {
                if (eachElement.taskCategory == "Route-Task") {
                    createObjMapping(eachElement)
                } else if (eachElement.taskCategory == "Section-Task") {
                    createObjMapping(eachElement)
                }
            })
        }
        function createObjMapping(eachElement) {
            if (!vm.objectTaskStatus[eachElement.taskCategory]) {
                vm.objectTaskStatus[eachElement.taskCategory] = {};
            }
            if (!vm.objectTaskStatus[eachElement.taskCategory][eachElement.taskStage]) {
                vm.objectTaskStatus[eachElement.taskCategory][eachElement.taskStage] = []
            }
            if (eachElement.totalWorkLength && eachElement.taskLength) {
                vm.objectTaskStatus[eachElement.taskCategory][eachElement.taskStage].push({
                    taskTypeName: eachElement.taskTypeName,
                    totalWorkLength: eachElement.totalWorkLength,
                    taskLength: eachElement.taskLength,
                    percentage: eachElement.percentage
                });
            }
        }
        vm.taskColors = {
            'Machinery Trenching': '#33FF57',
            'HDD ( Horizontal Directional Drilling )': '#33FF57',
            'Validation': '#3357FF'
        };

        if (vm.tabNum === 4) {
            setTimeout(function () {
                callTransaction("Material")
            }, 7000)
            setTimeout(function () {
                callTransaction("Resource")
            }, 8000)
        }
        function callTransaction(str) {

            if (str == "Resource") {
                SummaryPost.resTx({
                    "projectIds": [entity.projectId],
                    "routeIds": [entity.id]
                }, function (response) {
                    if (response.length) {
                        vm.resTxSummary = response
                        var data = [];
                        vm.mapResourceTransaction = {};

                        response.forEach(function (item) {
                            if (!vm.mapResourceTransaction[item.resourceName]) {
                                vm.mapResourceTransaction[item.resourceName] = {
                                    item: item.resourceName,
                                    PLANNED: 0,
                                    REQUESTED: 0,
                                    RECEIVED: 0,
                                    UTILIZED: 0,
                                    RECONCILED: 0
                                };
                                data.push(vm.mapResourceTransaction[item.resourceName]);
                            }
                            vm.mapResourceTransaction[item.resourceName][item.transactionType] += item.totalNoOfResources;
                        });

                        d3.selectAll("#RESOURCES > *").remove();
                        showDashboardData(data, 'RESOURCES')
                    }
                })
            } else if (str == "Material") {
                SummaryPost.mtrlTx(
                    {
                        projectIds: [entity.projectId],
                        routeIds: [entity.id],
                    },
                    function (response) {
                        vm.mtrlTxSummary = response;
                        if (response.length) {
                            var data = [];
                            var map = {};

                            response.forEach(function (item) {
                                if (!map[item.materialName]) {
                                    map[item.materialName] = {
                                        item: item.materialName,
                                        PLANNED: 0,
                                        REQUESTED: 0,
                                        RECEIVED: 0,
                                        UTILIZED: 0,
                                        RECONCILED: 0,
                                    };
                                    data.push(map[item.materialName]);
                                }
                                map[item.materialName][item.transactionType] +=
                                    item.totalNoOfUnits;
                            });

                            //console.log(data)

                            d3.selectAll("#materialChart > *").remove();
                            callUOM(data)
                            showDashboardData(data, "materialChart");
                        }
                    })
            }

        }

        function callUOM(data) {
            vm.uomMaterialTransaction = {}
            data.forEach(function (item) {
                if (item.UOM != null) {
                    if (!vm.uomMaterialTransaction[item.UOM]) {
                        vm.uomMaterialTransaction[item.UOM] = []
                    }
                    vm.uomMaterialTransaction[item.UOM].push(item)
                }
            })

            if (vm.uomMaterialTransaction) {
                if (vm.storeMaterialTransactionName.length) {
                    vm.storeMaterialTransactionName.forEach(function (eachElement) {
                        d3.selectAll("#" + eachElement + " > *").remove();
                    })
                }
                var parentContainer = document.getElementById(
                    "parentMaterial"
                );
                var newDiv = document.createElement(
                    "div"
                );
                Object.keys(vm.uomMaterialTransaction).forEach(function (key) {
                    vm.storeMaterialTransactionName.push(key)
                    newDiv.id = key
                    parentContainer.appendChild(newDiv);
                    showDashboardData(
                        vm.uomMaterialTransaction[key],
                        key
                    );
                })
            }
        }
        function showDashboardData(data, id) {
            var margin, width, height, svg, x, y, xAxis, yAxis;
            // Your existing code for setting up the c
            margin = { top: 20, right: 30, bottom: 85, left: 40 };

            // Get the current width and height of the window
            width = window.innerWidth * 0.8 - margin.left - margin.right;
            height =
                window.innerHeight * 0.5 - margin.top - margin.bottom - 100;

            x = d3.scale
                .ordinal()
                .rangeRoundBands([0, width], 0.1)
                .domain(
                    data.map(function (d) {
                        return d.item;
                    })
                );

            y = d3.scale
                .linear()
                .range([height, 0])
                .domain([
                    0,
                    d3.max(data, function (d) {
                        return d3.max([
                            d.PLANNED,
                            d.REQUESTED,
                            d.RECEIVED,
                            d.UTILIZED,
                            d.RECONCILED,
                        ]);
                    }),
                ]);

            xAxis = d3.svg.axis().scale(x).orient("bottom");
            yAxis = d3.svg.axis()
                .scale(y)
                .orient("left")
                .ticks(5) // Set the number of ticks
                .tickFormat(d3.format("d")); // Use a format that removes decimals


            svg = d3
                .select("#" + id)
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr(
                    "transform",
                    "translate(" + margin.left + "," + margin.top + ")"
                );

            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxis)
                .selectAll("text")
                .style("text-anchor", "end")
                .style("font-family", "sans-serif")
                .style("font-size", "11px")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", "rotate(-35)");

            svg.append("g").attr("class", "y axis").call(yAxis);

            // Add text next to the y-axis
            svg.append("text")
                .attr("transform", "rotate(-90)")
                .attr("y", 0 - margin.left)
                .attr("x", 0 - height / 2 - (margin.right + 40))
                .attr("dy", "1em")
                .style("text-anchor", "middle")
                .text(id);

            var colors = [
                "#AF7AC5",
                "#7FB3D5",
                "#76D7C4",
                "#E59866",
                "#ffdcf1",
            ];

            var categories = [
                "PLANNED",
                "REQUESTED",
                "RECEIVED",
                "UTILIZED",
                "RECONCILED",
            ];

            var tooltip1 = d3
                .select("body")
                .append("div")
                .attr("class", "toolTipA");



            categories.forEach(function (category, i) {
                svg.selectAll(".bar-" + category)
                    .data(data)
                    .enter()
                    .append("rect")
                    .attr("class", "bar-" + category)
                    .attr("x", function (d) {
                        return (
                            x(d.item) + (x.rangeBand() / categories.length) * i
                        );
                    })
                    .attr("width", x.rangeBand() / categories.length)
                    .attr("y", function (d) {
                        return y(Math.max(0.1, d[category]));
                    })
                    .attr("height", function (d) {
                        return Math.max(1, height - y(Math.max(0.1, d[category])));
                    })
                    .style("fill", colors[i])

                    .on("mouseover", function (d) {

                        if (d[category] != 0) {
                            tooltip1
                                .style("left", d3.event.pageX - 50 + "px")
                                .style("top", d3.event.pageY - 50 + "px")
                                .style("display", "inline-block")
                                .style("fill", "black")
                                .html(category + ' - ' + d[category]);
                            return tooltip1.style("visibility", "visible");
                        }

                    })
                    .on("mousemove", function () {
                        return tooltip1
                            .style("top", d3.event.pageY - 10 + "px")
                            .style("left", d3.event.pageX + 10 + "px");
                    })
                    .on("mouseout", function () {
                        return tooltip1.style("visibility", "hidden");
                    });
            });

        }

        $scope.names = ['PLANNED', 'REQUESTED', 'RECEIVED', 'UTILIZED', 'RECONCILED'];
        $scope.legends = [
            { name: 'PLANNED', color: '#AF7AC5' },
            { name: 'REQUESTED', color: '#7FB3D5' },
            { name: 'RECEIVED', color: '#76D7C4' },
            { name: 'UTILIZED', color: '#E59866' },
            { name: 'RECONCILED', color: '#ffdcf1' }
        ];

        function addLatLng(event, map) {
            var path = polyMeasureTool.getPath();
            path.push(event.latLng);
            addPointer(event.latLng, map);
            var point1, point2
            for (var i = 0; i < path.getLength() - 1; i++) {
                point1 = path.getAt(i);
                point2 = path.getAt(i + 1);
                segmentDistance = google.maps.geometry.spherical.computeDistanceBetween(point1, point2);
                // Add distance marker
                midpoint = google.maps.geometry.spherical.interpolate(point1, point2, 0.5);

            }

            if (path.getLength() > 1) {
                totalDistance += segmentDistance;
                var marker = new google.maps.Marker({
                    position: midpoint,
                    map: map,
                    icon: {
                        url: 'content/images/iconTransparent.png',
                    },
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "14px",
                        text: formatDistance(segmentDistance),
                    },
                });
                distanceMarkers.push(marker);

                var totalDistanceMarker = new google.maps.Marker({
                    position: point2,
                    map: map,
                    icon: {
                        url: 'content/images/iconTransparent.png',
                    },
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "14px",
                        text: "Total : " + formatDistance(totalDistance),
                    },
                });
                totalDistanceMarkers.push(totalDistanceMarker);
            }

        }

        function addPointer(location, map) {
            var pointerIcon = {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 5,
                strokeColor: 'black',
                fillColor: 'white',
                fillOpacity: 1,
                strokeWeight: 2
            };

            var pointer = new google.maps.Marker({
                position: location,
                map: map,
                icon: pointerIcon
            });
            pointerMarkers.push(pointer);
        }
        function formatDistance(distance) {
            // Convert meters to kilometers
            var km = distance / 1000;

            // Show in meters if less than 1 km, otherwise show in kilometers
            if (km < 1) {
                return distance.toFixed(0) + ' m';
            } else {
                return km.toFixed(2) + ' km';
            }
        }

        function clearMeasureTool(arr) {
            for (var i = 0; i < arr.length; i++) {
                arr[i].setMap(null)
            }
        }

        function geoLocation(map) {
            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);

            goTo.addEventListener("click", function () {
                gotoLatitute();
            });
            measureTool = document.createElement("button");
            measureTool.setAttribute("title", "Measure Distance");
            measureTool.classList.add("custom-map-control-button");
            measureTool.id = "measureDistance";
            measureToolIcon.classList.add("fa");
            measureToolIcon.classList.add("fa-arrows-h");
            measureToolIcon.classList.add("ruler");
            measureTool.appendChild(measureToolIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(measureTool);
            measureTool.addEventListener("click", function () {

                if (measureEnabled) {
                    google.maps.event.removeListener(vm.clickListener);

                    totalDistance = 0
                    clearMeasureTool(distanceMarkers)
                    clearMeasureTool(pointerMarkers)
                    clearMeasureTool(arrpolyMeasureTool)
                    clearMeasureTool(totalDistanceMarkers)
                    distanceMarkers = []
                    totalDistanceMarkers = []
                    pointerMarkers = []
                    arrpolyMeasureTool = []
                    measureEnabled = false
                    measureTool.setAttribute("title", "Measure Distance");
                    measureToolIcon.classList.remove("fa-times");
                    measureToolIcon.classList.add("fa-arrows-h");
                } else {
                    measureEnabled = true
                    polyMeasureTool = new google.maps.Polyline({
                        strokeColor: 'black',
                        strokeOpacity: 1.0,
                        strokeWeight: 3
                    });
                    polyMeasureTool.setMap(map);
                    arrpolyMeasureTool.push(polyMeasureTool)

                    vm.clickListener = map.addListener('click', function (event) {
                        addLatLng(event, map)
                    });
                    measureTool.setAttribute("title", "Clear Distance");
                    measureToolIcon.classList.remove("fa-arrows-h");
                    measureToolIcon.classList.add("fa-times");
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }
        var input = document.getElementById("field_pinLat");
        input.addEventListener("input", function () {
            this.value = this.value.replace(/[^-0-9\,\.]/, "");
        });

        function showZoomLocation() {
            var latlng = vm.getLocationCoordinate.split(",");
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinate != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };

                if ($scope.tab == 10) {
                    vm.newMaps.setCenter(assetCenterLatLng);
                    vm.newMaps.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: vm.newMaps,
                        position: assetCenterLatLng,
                    });
                    input.value = ''
                }
                if ($scope.tab == 9) {
                    vm.newMap.setCenter(assetCenterLatLng);
                    vm.newMap.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: vm.newMap,
                        position: assetCenterLatLng,
                    });
                    input.value = ''
                }
                if ($scope.tab == 1) {
                    locations.map.setCenter(assetCenterLatLng);
                    // locations.map.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: locations.map,
                        position: assetCenterLatLng,
                    });
                    input.value = ''
                }
                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }

        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
        }

        function gotoLatituteCity() {
            $("#modalLatLongs").show();
        }

        function closeGotoLatitute(id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }
        function closeGotoLatituteCity() {
            $("#modalLatLongs").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalLatLongs").hide();
        }

        vm.downloadMaterial = function () {
            BaseUrl.getBaseUrl(function (baseurl) {
                var request = new XMLHttpRequest();
                request.open('GET', baseurl.stringValue + "api/rollout/mtrl-tx-summary-export-excel/" + vm.trRoute.projectId + "/" + vm.trRoute.id, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';
                request.onload = function (e) {
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'test.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));
                                downloadLink.download = 'MtrlTxSummaryExportExcel.xlsx';
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    }
                };
                request.send();
            });
        }

        vm.downloadResource = function () {
            BaseUrl.getBaseUrl(function (baseurl) {
                var request = new XMLHttpRequest();
                request.open('GET', baseurl.stringValue + "api/rollout/res-tx-summary-export-excel/" + vm.trRoute.projectId + "/" + vm.trRoute.id, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';

                request.onload = function (e) {
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'test.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));
                                downloadLink.download = 'ResTxSummaryExportExcel.xlsx';
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    }
                };
                request.send();
            });
        }

        BaseUrl.getBaseUrl(function (baseurl) {
            $scope.downloadExcelBoqSoq = function () {
                var apiUrl = baseurl.stringValue + "api/report-download";

                $http({
                    method: "GET",
                    url: apiUrl,
                    responseType: "arraybuffer" // Important for binary data
                }).then(function (response) {
                    var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    var link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "BoQAndSoQ.xlsx"; // File name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(function (error) {
                    console.error("Error downloading Excel file:", error);
                });
            };
        });



        BaseUrl.getBaseUrl(function (baseurl) {
            $scope.downloadExcelSurveyReport = function () {
                var apiUrl = baseurl.stringValue + "api/survey-report-download";

                $http({
                    method: "GET",
                    url: apiUrl,
                    responseType: "arraybuffer" // Important for binary data
                }).then(function (response) {
                    var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    var link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "SurveyReport.xlsx"; // File name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(function (error) {
                    console.error("Error downloading Excel file:", error);
                });
            };
        });


        vm.updateMarkerVisibility = function () {
            if (vm.objectRouteImg && typeof vm.objectRouteImg.toggleMarkers === 'function') {
                vm.objectRouteImg.toggleMarkers();
            }
        };
        vm.updateImageMarkerVisibility = function () {
            if (vm.objectRouteImg && typeof vm.objectRouteImg.toggleRouteMarkers === 'function') {
                vm.objectRouteImg.toggleRouteMarkers();
            }
        };
        var assetMarker = []
        var spreadPolyline = []
        vm.routeAsset = []
        vm.assets = [];
        $scope.showDropDown = true
        function loadAssets(routeId, lastId) {
            routeDetail.getAssetsById(routeId, lastId, function (response) {
                vm.routeAsset = response.assets

                if (vm.routeAsset.length >= 200) {
                    vm.routeAsset.forEach(function (asset) {
                        vm.assets.push(asset);
                    });
                    loadAssets(
                        vm.trRoute.id,
                        vm.routeAsset[vm.routeAsset.length - 1].id
                    );
                } else {
                    vm.routeAsset.forEach(function (asset) {
                        vm.assets.push(asset);
                    });
                    vm.assets.forEach(function (asset) {
                        var coordinates = asset.assetCoordinates.map(function (coord) {
                            return { lat: coord.latitude, lng: coord.longitude };
                        });
                        drawAssetMarker(asset)
                        if (asset.assetTypeLayout === 'SPREAD') {
                            var polylineColor = "#00A36C";
                            if (!asset.isExisting) {
                                polylineColor = "#ff0025"; //tmpColor = "blue";
                            } else if (!asset.isUsed && asset.isExisting) {
                                polylineColor = "#FFAE42";
                            }
                            var drawPolyline = new google.maps.Polyline({
                                path: coordinates,
                                geodesic: true,
                                strokeColor: polylineColor,
                                strokeOpacity: 0.9,
                                strokeWeight: 3,
                                zIndex: 2
                            });
                            drawPolyline.setMap(locations.map);
                            spreadPolyline.push(drawPolyline);
                            var polylineInfoWindow = new google.maps.InfoWindow();

                            (function (currentAsset) {
                                google.maps.event.addListener(drawPolyline, 'click', function (event) {
                                    if (openedInfoWindow !== null) {
                                        openedInfoWindow.close();
                                    }

                                    var infoWindowContent = document.createElement('div');
                                    infoWindowContent.className = "infoWindowhead";

                                    infoWindowContent.innerHTML = "<b>ID: " + currentAsset.id + "</b><br>" +
                                        "<b>Name: " + currentAsset.name + "</b><br>" +
                                        "<b>AssetTypeName: " + currentAsset.assetTypeName + "</b><br>";

                                    if (vm.trRoute.id) {
                                        var btnShowAsset = document.createElement("input");
                                        btnShowAsset.type = "button";
                                        btnShowAsset.value = "Show attributes";
                                        btnShowAsset.className = "button";

                                        infoWindowContent.appendChild(btnShowAsset);

                                        google.maps.event.addDomListener(btnShowAsset, "click", function () {
                                            AssetByID.get(currentAsset.id, function (response) {
                                                showAssetAttributesModal(response);
                                            });
                                        });
                                    }

                                    polylineInfoWindow.setContent(infoWindowContent);
                                    polylineInfoWindow.setPosition(event.latLng);
                                    polylineInfoWindow.open(locations.map);
                                    openedInfoWindow = polylineInfoWindow;
                                });
                            })(asset); // IIFE passing current asset
                        }
                    });
                    var searchInput = document.createElement("input");
                    searchInput.type = "text";
                    searchInput.placeholder = "Search asset...";
                    searchInput.style.position = "absolute";
                    searchInput.style.top = "10px";
                    searchInput.style.left = "50%";
                    searchInput.style.transform = "translateX(-50%)";
                    searchInput.style.zIndex = "5";
                    searchInput.style.padding = "5px";
                    searchInput.style.border = "1px solid #ccc";
                    searchInput.style.borderRadius = "4px";
                    document.getElementById("map_canvasStart").appendChild(searchInput);
                    searchInput.addEventListener("input", function () {
                        var searchTerm = searchInput.value.toLowerCase();
                        var foundAsset = null;
                        vm.assets.forEach(function (asset) {
                            if (asset.name.toLowerCase().includes(searchTerm)) {
                                foundAsset = asset;
                            }
                        })
                        if (foundAsset) {
                            var coordinates = foundAsset.assetCoordinates.map(function (coord) {
                                return { lat: coord.latitude, lng: coord.longitude };
                            });
                            if (coordinates.length > 0) {
                                locations.map.setCenter(coordinates[0]);
                                locations.map.setZoom(15);
                            }
                        }
                    });
                }
            });
        }
        function getConsolidatedAssetTypeAttributeValue(assetType) {
            var assetTypeAttributeValuesList = [];

            for (var index in assetType.assetTypeAttributes) {
                var assetTypeAttribute1 = assetType.assetTypeAttributes[index];
                assetTypeAttributeValuesList.push({
                    assetTypeAttribute: assetTypeAttribute1,
                    attributeValue: assetType.assetTypeAttributes[index].defaultValue,
                });
            }

            assetTypeAttributeValuesList.sort(function (a, b) {
                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                    nameB = b.assetTypeAttribute.name.toLowerCase();
                if (nameA < nameB)
                    // sort string ascending
                    return -1;
                if (nameA > nameB) return 1;
                return 0; // default return value (no sorting)
            });
            return assetTypeAttributeValuesList;
        }
        AllAssetsTypes.getAll(function (response) {
            vm.assetTypeValues = response.length ? response : null;
        });

        vm.layerItems = [];
        vm.selectedLayers = {};
        vm.filteredAssetsList = [];
        vm.layersInitialized = false;

        vm.showLayers = function () {
            if (!vm.layersInitialized) {
                if (vm.layerItems.length > 0) return;
                vm.layerItems = [];
                var uniqueAssetTypeNames = {};
                for (var i = 0; i < vm.assets.length; i++) {
                    var item = vm.assets[i];
                    var temp = vm.assetTypeValues.find(function (storedAsset) {
                        return storedAsset.name === item.assetTypeName;
                    });
                    item.assetType = temp;
                    item.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(temp);
                    var assetType = item.assetTypeName.trim().toUpperCase();
                    var mapAssetsTypeName = ['OLT'].includes(assetType)
                        ? 'BLOCK'
                        : assetType === 'JOINT KIT'
                            ? 'JUNCTION POINT' : assetType === 'GP'
                                ? 'GP Router' : item.assetTypeName;
                    if (mapAssetsTypeName === "Planned Route" || mapAssetsTypeName === "Planned_Route") {
                        if (item.isExisting === true && item.isUsed === true) {
                            if (!uniqueAssetTypeNames["Existing"]) {
                                uniqueAssetTypeNames["Existing"] = true;
                                var existingSelected = vm.selectedLayers["Existing"] !== undefined ? vm.selectedLayers["Existing"] : true;
                                vm.layerItems.push({ name: "Existing", selected: existingSelected });
                                vm.selectedLayers["Existing"] = existingSelected;
                            }
                        }
                        if (item.isExisting === true && item.isUsed === false) {
                            if (!uniqueAssetTypeNames["Unused"]) {
                                uniqueAssetTypeNames["Unused"] = true;
                                var unusedSelected = vm.selectedLayers["Unused"] !== undefined ? vm.selectedLayers["Unused"] : true;
                                vm.layerItems.push({ name: "Unused", selected: unusedSelected });
                                vm.selectedLayers["Unused"] = unusedSelected;
                            }
                        }
                        if (item.isExisting === false) {
                            if (!uniqueAssetTypeNames["New OFC"]) {
                                uniqueAssetTypeNames["New OFC"] = true;
                                var newSelected = vm.selectedLayers["New OFC"] !== undefined ? vm.selectedLayers["New OFC"] : true;
                                vm.layerItems.push({ name: "New OFC", selected: newSelected });
                                vm.selectedLayers["New OFC"] = newSelected;
                            }
                        }

                    }

                    else {
                        if (!uniqueAssetTypeNames[mapAssetsTypeName]) {
                            uniqueAssetTypeNames[mapAssetsTypeName] = true;
                            var layerSelected = vm.selectedLayers[mapAssetsTypeName] !== undefined ? vm.selectedLayers[mapAssetsTypeName] : true;
                            vm.layerItems.push({
                                name: mapAssetsTypeName,
                                selected: layerSelected
                            });
                            vm.selectedLayers[mapAssetsTypeName] = layerSelected;
                        }
                    }
                }
                vm.layersInitialized = true;
            }
        };

        vm.updateSelectedLayers = function () {
            vm.selectedLayers = {};
            for (var i = 0; i < vm.layerItems.length; i++) {
                var layer = vm.layerItems[i];
                if (layer.selected) {
                    vm.selectedLayers[layer.name] = true;
                }
            }
            vm.filterMapByLayers();
        };

        var assetPolyline = [];

        vm.filterMapByLayers = function () {
            clearMarkersPolyLine();
            vm.filteredAssetsList = vm.assets.filter(function (item) {
                var assetType = item.assetTypeName.trim().toUpperCase();
                var mapAssetsTypeName = ['OLT'].includes(assetType)
                    ? 'BLOCK'
                    : assetType === 'JOINT KIT'
                        ? 'JUNCTION POINT' : assetType === 'GP'
                            ? 'GP Router' : item.assetTypeName;
                if (mapAssetsTypeName === "Planned Route" || mapAssetsTypeName === "Planned_Route") {
                    var attrType = item.assetTypeAttributeValues[0] &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute.assetAttributeTypes;
                    if (mapAssetsTypeName === "Planned Route" || mapAssetsTypeName === "Planned_Route") {
                        if (item.isExisting && item.isUsed && vm.selectedLayers["Existing"]) {
                            return true;
                        }
                        if (item.isExisting && item.isUsed === false && vm.selectedLayers["Unused"]) {
                            return true;
                        }
                        if (!item.isExisting && vm.selectedLayers["New OFC"]) {
                            return true;
                        }

                        return false;
                    }
                    return false;
                }

                return vm.selectedLayers[mapAssetsTypeName];
            });

            for (var k = 0; k < vm.filteredAssetsList.length; k++) {
                var asset = vm.filteredAssetsList[k];
                if (asset.assetCoordinates) {
                    var assetCoordinateValues = [];
                    for (var j = 0; j < asset.assetCoordinates.length; j++) {
                        assetCoordinateValues.push({ lat: asset.assetCoordinates[j].latitude, lng: asset.assetCoordinates[j].longitude });
                    }
                    if (assetCoordinateValues.length > 0 && assetCoordinateValues[0].sortOrder != null) {
                        assetCoordinateValues.sort(function (a, b) { return a.sortOrder - b.sortOrder; });
                    }
                    if (asset.assetTypeLayout === "SPREAD") {
                        var polylineColor = "";
                        polylineColor = "#00A36C";
                        if (!asset.isExisting) {
                            polylineColor = "#ff0025"; //tmpColor = "blue";
                        }
                        if (!asset.isUsed && asset.isExisting) {
                            polylineColor = "#FFAE42";
                        }
                        var polyline = new google.maps.Polyline({
                            path: assetCoordinateValues,
                            geodesic: true,
                            strokeColor: polylineColor,
                            strokeOpacity: 0.9,
                            strokeWeight: 3,
                            zIndex: 2
                        });
                        polyline.setMap(locations.map);
                        assetPolyline.push(polyline);
                        (function (currentAsset) {
                            var polylineInfoWindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(polyline, 'click', function (event) {
                                if (openedInfoWindow !== null) {
                                    openedInfoWindow.close();
                                }

                                var infoWindowContent = document.createElement('div');
                                infoWindowContent.className = "infoWindowhead";

                                infoWindowContent.innerHTML = "<b>ID: " + currentAsset.id + "</b><br>" +
                                    "<b>Name: " + currentAsset.name + "</b><br>" +
                                    "<b>AssetTypeName: " + currentAsset.assetTypeName + "</b><br>";

                                if (vm.trRoute.id) {
                                    var btnShowAsset = document.createElement("input");
                                    btnShowAsset.type = "button";
                                    btnShowAsset.value = "Show attributes";
                                    btnShowAsset.className = "button";

                                    infoWindowContent.appendChild(btnShowAsset);

                                    google.maps.event.addDomListener(btnShowAsset, "click", function () {
                                        AssetByID.get(currentAsset.id, function (response) {
                                            showAssetAttributesModal(response);
                                        });
                                    });
                                }

                                polylineInfoWindow.setContent(infoWindowContent);
                                polylineInfoWindow.setPosition(event.latLng);
                                polylineInfoWindow.open(locations.map);
                                openedInfoWindow = polylineInfoWindow;
                            });
                        })(asset);
                    } else if (asset.assetTypeLayout === "FIXED") {
                        drawAssetMarker(asset);
                    }
                }
            }
        };
        vm.toggleCheckAll = false;

        vm.toggleAllLayers = function () {
            var checkAll = vm.toggleCheckAll;
            for (var i = 0; i < vm.layerItems.length; i++) {
                vm.layerItems[i].selected = checkAll;
            }
            vm.objectRouteImg = vm.objectRouteImg || {};
            vm.objectRouteImg.hideRoutemarker = checkAll;
            vm.objectRouteImg.hidemarker = checkAll;
            vm.updateSelectedLayers();
            if (typeof vm.updateImageMarkerVisibility === 'function') {
                vm.updateImageMarkerVisibility();
            }
            if (typeof vm.updateMarkerVisibility === 'function') {
                vm.updateMarkerVisibility();
            }
            vm.toggleCheckAll = !vm.toggleCheckAll;
        };

        function recolorPngHue(url, hueShiftDeg, callback) {
            var img = new Image();
            img.crossOrigin = 'Anonymous';

            img.onload = function () {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;

                // Draw original image
                ctx.drawImage(img, 0, 0);

                // Apply hue-rotation filter
                ctx.filter = 'hue-rotate(' + hueShiftDeg + 'deg) saturate(1.0) brightness(1.4)';
                ctx.drawImage(img, 0, 0);

                callback(canvas.toDataURL());
            };

            img.src = url;
        }

        function drawAssetMarker(asset) {
            var coordinates = asset.assetCoordinates.map(function (coord) {
                return { lat: coord.latitude, lng: coord.longitude };
            });
            if (asset.assetTypeLayout === 'FIXED') {

                vm.gpAssets.push(asset);
                if ((asset.phase == "SURVEY")) {
                    var baseIconUrl = asset.assetTypeImagePath;

                    var hueShift = 280; // try 60 for yellow, 120 for cyan, 180 for blue, 300 for magenta

                    recolorPngHue(baseIconUrl, hueShift, function (newIconUrl) {
                        marker = new google.maps.Marker({
                            position: coordinates[0],
                            map: locations.map,
                            icon: {
                                url: newIconUrl,
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                labelOrigin: new google.maps.Point(25, 22)
                            },
                            name: asset.name
                        });

                        function updateMarkerLabelVisibility() {
                            var currentZoom = locations.map.getZoom();
                            if (currentZoom > 10) {
                                if (asset.assetTypeName == "GP" || asset.assetTypeName == "ONT") {
                                    marker.setLabel({
                                        color: "#FF7276",
                                        fontWeight: "bold",
                                        fontSize: "12px",
                                        text: asset.name,
                                        className: "asset_label top-label"
                                    });
                                }
                            } else {
                                marker.setLabel(null);
                            }
                            var style = document.createElement('style');
                            style.innerHTML = '.top-label {' +
                                '    position: relative;' +
                                '    top: 30px;' +
                                '    left: 0;' +
                                '    transform: translateX(10%);' +
                                '    white-space: nowrap;' +
                                '}';
                            document.head.appendChild(style);
                        }
                        assetMarker.push(marker)
                        var infowindow = new google.maps.InfoWindow();

                        var updateIconSize = function () {
                            var zoom = locations.map.getZoom();

                            // Define minimum and maximum zoom levels
                            var minZoom = 8;
                            var maxZoom = 21;

                            // Define minimum and maximum icon sizes
                            var minSize = 6;  // Smallest size at zoom 8
                            var maxSize = 60;  // Full size at zoom 21

                            // Compute new size based on zoom level
                            var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);

                            var icon = {
                                url: marker.getIcon().url,  // Keep the existing marker image
                                scaledSize: new google.maps.Size(newSize, newSize),  // Only use scaledSize
                                anchor: new google.maps.Point(newSize / 2, newSize / 2), // Adjust anchor to prevent clipping
                            };

                            marker.setIcon(icon);
                        };

                        // Run updateIconSize once to initialize
                        updateIconSize();

                        // Listen for zoom changes
                        google.maps.event.addListener(locations.map, "zoom_changed", function () {
                            updateIconSize();
                            updateMarkerLabelVisibility()
                        });

                        google.maps.event.addListener(marker, 'click', function () {
                            if (openedInfoWindow !== null) {
                                openedInfoWindow.close();
                            }
                            var contentString = document.createElement("div"),
                                btnShowImage,
                                btnShowAsset
                            contentString.innerHTML =
                                '<div class="infoWindowhead">' +
                                '<b>ID: ' + asset.id + '</b><br>' +
                                '<b>Name: ' + asset.name + '</b><br>' +
                                '<b>AssetTypeName: ' + asset.assetTypeName + '</b><br>' +
                                '<b>Latitude: ' + coordinates[0].lat + '</b><br>' +
                                '<b>Longitude: ' + coordinates[0].lng + '</b>' +
                                '<button onclick="copyToClipboard(\'' + coordinates[0].lat + ',' + coordinates[0].lng + '\', this)" ' +
                                'style="font-size:10px; padding:2px 5px; margin-left:5px; cursor:pointer;">Copy</button>' +
                                '</div>';

                            infowindow.setContent(contentString);
                            infowindow.open(locations.map, marker);
                            openedInfoWindow = infowindow;
                            if (vm.trRoute.id) {
                                btnShowImage = contentString.appendChild(document.createElement("input"));
                                btnShowImage.type = "button";
                                btnShowImage.value = "Show Media";
                                btnShowImage.className = "button";

                                google.maps.event.addDomListener(btnShowImage, "click", function () {
                                    AssetByID.get(asset.id, function (imageResponse) {
                                        vm.assetName = asset.name;
                                        vm.assetTypeName = asset.assetTypeName
                                        vm.assetIdDownload = asset.id;
                                        if (imageResponse && imageResponse.assetImages.length) {
                                            var token = $localStorage.authenticationToken;
                                            gpName = imageResponse.name || "Images";
                                            var validTypes = ['.PNG', 'PNG', 'PDF', '.PDF', 'JPEG', '.JPEG', 'JPG', '.JPG', 'MP4', '.MP4'];
                                            var imageMetaList = imageResponse.assetImages.filter(function (img) {
                                                var type = img.imageType ? img.imageType.toUpperCase() : '';
                                                return validTypes.indexOf(type) !== -1;
                                            }).sort(function (a, b) {
                                                return a.createdDate - b.createdDate;
                                            }).map(function (img) {
                                                return {
                                                    url: img.imageUrl || ('/api/trakeyeassetimages/' + asset.id + '/' + img.imageId),
                                                    type: img.imageType ? img.imageType.toUpperCase() : 'PNG',
                                                    createdDate: img.createdDate
                                                };
                                            });
                                            if (imageMetaList.length) {
                                                preloadImagesWithToken(imageMetaList, token);
                                            } else {
                                                alert("No images or PDFs found.");
                                            }
                                        } else {
                                            alert("No images or PDFs found.");
                                        }
                                    });
                                });
                            }
                            if (vm.trRoute.id) {
                                btnShowAsset = contentString.appendChild(
                                    document.createElement("input")
                                );
                                btnShowAsset.type = "button";
                                btnShowAsset.value = "Show attributes";
                                btnShowAsset.className = "button";
                                google.maps.event.addDomListener(
                                    btnShowAsset,
                                    "click",
                                    function () {
                                        AssetByID.get(asset.id, function (response) {
                                            showAssetAttributesModal(response);
                                        });
                                    }
                                );
                            }
                        });
                        $scope.showDropDown = false
                    });
                    if (!marker || !marker.getIcon) {
                        console.warn('Marker not ready yet.');
                        return;
                    }
                    var icon = marker.getIcon();
                    icon.scaledSize = new google.maps.Size(48, 48);
                    marker.setIcon(icon);


                } else {
                    var marker = new google.maps.Marker({
                        position: coordinates[0],
                        map: locations.map,
                        title: asset.name,
                        icon: {
                            url: asset.assetTypeImagePath,
                            scaledSize: new google.maps.Size(32, 32)
                        }
                    });

                    function updateMarkerLabelVisibility() {
                        var currentZoom = locations.map.getZoom();
                        if (currentZoom > 10) {
                            if (asset.assetTypeName == "GP" || asset.assetTypeName == "ONT") {
                                marker.setLabel({
                                    color: "red",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                    text: asset.name,
                                    className: "asset_label top-label"
                                });
                            }
                        } else {
                            marker.setLabel(null);
                        }
                        var style = document.createElement('style');
                        style.innerHTML = '.top-label {' +
                            '    position: relative;' +
                            '    top: 30px;' +
                            '    left: 0;' +
                            '    transform: translateX(10%);' +
                            '    white-space: nowrap;' +
                            '}';
                        document.head.appendChild(style);
                    }
                    assetMarker.push(marker)
                    var infowindow = new google.maps.InfoWindow();

                    var updateIconSize = function () {
                        var zoom = locations.map.getZoom();

                        // Define minimum and maximum zoom levels
                        var minZoom = 8;
                        var maxZoom = 21;

                        // Define minimum and maximum icon sizes
                        var minSize = 6;  // Smallest size at zoom 8
                        var maxSize = 60;  // Full size at zoom 21

                        // Compute new size based on zoom level
                        var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);

                        var icon = {
                            url: marker.getIcon().url,  // Keep the existing marker image
                            scaledSize: new google.maps.Size(newSize, newSize),  // Only use scaledSize
                            anchor: new google.maps.Point(newSize / 2, newSize / 2), // Adjust anchor to prevent clipping
                        };

                        marker.setIcon(icon);
                    };

                    // Run updateIconSize once to initialize
                    updateIconSize();

                    // Listen for zoom changes
                    google.maps.event.addListener(locations.map, "zoom_changed", function () {
                        updateIconSize();
                        updateMarkerLabelVisibility()
                    });

                    google.maps.event.addListener(marker, 'click', function () {
                        if (openedInfoWindow !== null) {
                            openedInfoWindow.close();
                        }
                        var contentString = document.createElement("div"),
                            btnShowImage,
                            btnShowAsset
                        contentString.innerHTML =
                            '<div class="infoWindowhead">' +
                            '<b>ID: ' + asset.id + '</b><br>' +
                            '<b>Name: ' + asset.name + '</b><br>' +
                            '<b>AssetTypeName: ' + asset.assetTypeName + '</b><br>' +
                            '<b>Latitude: ' + coordinates[0].lat + '</b><br>' +
                            '<b>Longitude: ' + coordinates[0].lng + '</b>' +
                            '<button onclick="copyToClipboard(\'' + coordinates[0].lat + ',' + coordinates[0].lng + '\', this)" ' +
                            'style="font-size:10px; padding:2px 5px; margin-left:5px; cursor:pointer;">Copy</button>' +
                            '</div>';

                        infowindow.setContent(contentString);
                        infowindow.open(locations.map, marker);
                        openedInfoWindow = infowindow;
                        if (vm.trRoute.id) {
                            btnShowImage = contentString.appendChild(document.createElement("input"));
                            btnShowImage.type = "button";
                            btnShowImage.value = "Show Media";
                            btnShowImage.className = "button";

                            google.maps.event.addDomListener(btnShowImage, "click", function () {
                                AssetByID.get(asset.id, function (imageResponse) {
                                    vm.assetName = asset.name;
                                    vm.assetTypeName = asset.assetTypeName
                                    vm.assetIdDownload = asset.id;
                                    if (imageResponse && imageResponse.assetImages.length) {
                                        var token = $localStorage.authenticationToken;
                                        gpName = imageResponse.name || "Images";
                                        var validTypes = ['.PNG', 'PNG', 'PDF', '.PDF', 'JPEG', '.JPEG', 'JPG', '.JPG', 'MP4', '.MP4'];
                                        var imageMetaList = imageResponse.assetImages.filter(function (img) {
                                            var type = img.imageType ? img.imageType.toUpperCase() : '';
                                            return validTypes.indexOf(type) !== -1;
                                        }).sort(function (a, b) {
                                            return a.createdDate - b.createdDate;
                                        }).map(function (img) {
                                            return {
                                                url: img.imageUrl || ('/api/trakeyeassetimages/' + asset.id + '/' + img.imageId),
                                                type: img.imageType ? img.imageType.toUpperCase() : 'PNG',
                                                createdDate: img.createdDate
                                            };
                                        });
                                        if (imageMetaList.length) {
                                            preloadImagesWithToken(imageMetaList, token);
                                        } else {
                                            alert("No images or PDFs found.");
                                        }
                                    } else {
                                        alert("No images or PDFs found.");
                                    }
                                });
                            });
                        }
                        if (vm.trRoute.id) {
                            btnShowAsset = contentString.appendChild(
                                document.createElement("input")
                            );
                            btnShowAsset.type = "button";
                            btnShowAsset.value = "Show attributes";
                            btnShowAsset.className = "button";
                            google.maps.event.addDomListener(
                                btnShowAsset,
                                "click",
                                function () {
                                    AssetByID.get(asset.id, function (response) {
                                        showAssetAttributesModal(response);
                                    });
                                }
                            );
                        }
                    });
                    $scope.showDropDown = false
                }


            }
        }
        window.copyToClipboard = function (text) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text).then(function () {
                }).catch(function (err) {
                    console.error("Clipboard copy failed: ", err);
                });
            } else {
                var tempInput = document.createElement("input");
                tempInput.value = text;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand("copy");
                document.body.removeChild(tempInput);
            }
        };
        var carouselImages = [];
        var currentImageIndex = 0;
        var gpName = 'images';
        function preloadImagesWithToken(imageMetaList, token) {
            var blobUrls = [];
            var remaining = imageMetaList.length;
            var hasError = false;

            for (var i = 0; i < imageMetaList.length; i++) {
                (function (img, index) {
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', img.url, true);
                    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                        if (xhr.status === 200 && xhr.response) {
                            var metaType = img.type ? img.type.toUpperCase() : '';
                            var type = metaType.includes("PDF") ? "PDF" :
                                metaType.includes("MP4") ? "VIDEO" :
                                    "IMAGE";
                            blobUrls[index] = {
                                url: URL.createObjectURL(xhr.response),
                                type: type
                            };
                        } else {
                            hasError = true;
                        }
                        remaining--;
                        if (remaining === 0) {
                            if (hasError) alert("Failed to load one or more files.");
                            var finalBlobUrls = blobUrls.filter(function (item) { return !!item; });
                            openCarousel(finalBlobUrls);
                        }
                    };
                    xhr.onerror = function () {
                        hasError = true;
                        remaining--;
                        if (remaining === 0) {
                            alert("Failed to load one or more files.");
                            var finalBlobUrls = blobUrls.filter(function (item) { return !!item; });
                            openCarousel(finalBlobUrls);
                        }
                    };
                    xhr.send();
                })(imageMetaList[i], i);
            }
        }

        function openCarousel(images) {
            carouselImages = images;
            currentImageIndex = 0;
            document.getElementById("imageCarouselModal").style.display = "flex";
            updateCarouselImage();
            generateThumbnails();
        }

        function updateCarouselImage() {
            var container = document.getElementById("carouselDisplayContainers");
            container.innerHTML = "";
            if (!carouselImages.length || !carouselImages[currentImageIndex]) {
                console.warn("No valid media found at index:", currentImageIndex);
                return;
            }
            var current = carouselImages[currentImageIndex];
            if (current.type === "PDF") {
                var iframe = document.createElement("iframe");
                iframe.src = current.url;
                iframe.className = "carousel-pdf";
                container.appendChild(iframe);
            } else if (current.type === "VIDEO") {
                var video = document.createElement("video");
                video.src = current.url;
                video.controls = true;
                video.autoplay = true;
                video.className = "carousel-video";
                container.appendChild(video);
            } else {
                var img = document.createElement("img");
                img.className = "carousel-image";
                img.src = current.url;
                img.id = "carouselImage";
                img.style.cursor = "grab";
                img.setAttribute("draggable", "false");
                container.appendChild(img);

                // Zoom + Drag behavior
                var zoom = 1;
                var minZoom = 1;
                var maxZoom = 5;
                var imgOffsetX = 0;
                var imgOffsetY = 0;

                function applyTransform() {
                    img.style.transform = 'translate(' + imgOffsetX + 'px, ' + imgOffsetY + 'px) scale(' + zoom + ')';
                    img.style.transition = "transform 0.1s ease-out";
                }

                applyTransform();

                container.addEventListener("wheel", function (e) {
                    e.preventDefault();
                    var delta = Math.sign(e.deltaY);
                    var zoomAmount = 0.10;
                    var newZoom = zoom;

                    if (delta < 0) {
                        newZoom = Math.min(maxZoom, zoom + zoomAmount);
                    } else {
                        newZoom = Math.max(minZoom, zoom - zoomAmount);
                    }

                    var scaleFactor = newZoom / zoom;
                    var rect = img.getBoundingClientRect();
                    var mouseX = e.clientX - rect.left;
                    var mouseY = e.clientY - rect.top;

                    if (newZoom === minZoom) {
                        imgOffsetX = 0;
                        imgOffsetY = 0;
                    } else {
                        imgOffsetX -= mouseX * scaleFactor - mouseX;
                        imgOffsetY -= mouseY * scaleFactor - mouseY;
                    }

                    zoom = newZoom;
                    applyTransform();
                });

                var isDragging = false;
                var startCursorX, startCursorY;
                var startImgOffsetX, startImgOffsetY;

                img.addEventListener("mousedown", function (e) {
                    isDragging = true;
                    img.style.cursor = "grabbing";
                    startCursorX = e.clientX;
                    startCursorY = e.clientY;
                    startImgOffsetX = imgOffsetX;
                    startImgOffsetY = imgOffsetY;
                    img.style.transition = "none";
                });

                document.addEventListener("mouseup", function () {
                    isDragging = false;
                    img.style.cursor = "grab";
                });

                document.addEventListener("mousemove", function (e) {
                    if (!isDragging) return;
                    e.preventDefault();
                    var dx = e.clientX - startCursorX;
                    var dy = e.clientY - startCursorY;
                    imgOffsetX = startImgOffsetX + dx;
                    imgOffsetY = startImgOffsetY + dy;
                    applyTransform();
                });
            }
        }

        function generateThumbnails() {
            var container = document.getElementById("carouselThumbnails");
            container.innerHTML = "";

            for (var i = 0; i < carouselImages.length; i++) {
                (function (index) {
                    var current = carouselImages[index];
                    var thumb = document.createElement("img");

                    thumb.src = current.type === "PDF"
                        ? "content/images/pdf_file_icon.png"
                        : current.type === "VIDEO"
                            ? "content/images/video_icon.png"
                            : current.url;
                    thumb.className = "carousel-thumbnail";
                    if (index === currentImageIndex) {
                        thumb.classList.add("selected");
                    }

                    thumb.onclick = function () {
                        currentImageIndex = index;
                        updateCarouselImage();
                        generateThumbnails();
                    };

                    container.appendChild(thumb);
                })(i);
            }
        }

        window.closeCarousel = function () {
            document.getElementById("imageCarouselModal").style.display = "none";
            var container = document.getElementById("carouselDisplayContainers");
            if (container) {
                var video = container.querySelector("video");
                if (video) {
                    video.pause();
                    video.src = "";
                    video.load();
                }
                container.innerHTML = "";
            }
            var thumbContainer = document.getElementsByClassName("carousel-thumbnails");
            if (thumbContainer) {
                thumbContainer.innerHTML = "";
            }
        };

        window.changeImage = function (n) {
            currentImageIndex += n;
            if (currentImageIndex < 0) currentImageIndex = carouselImages.length - 1;
            if (currentImageIndex >= carouselImages.length) currentImageIndex = 0;
            updateCarouselImage();
            generateThumbnails();
        };

        window.downloadCurrentImage = function () {
            var current = carouselImages[currentImageIndex];
            var link = document.createElement('a');
            link.href = current.url;
            var extension = current.type === "PDF" ? ".pdf" :
                current.type === "VIDEO" ? ".mp4" :
                    ".png";
            link.download = gpName + "_gpfile_" + (currentImageIndex + 1) + extension;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        window.downloadAllImages = function () {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block";
            }
            var xhr = new XMLHttpRequest();
            xhr.open('GET', '/api/assets/downloadFiles/' + vm.assetIdDownload, true);
            xhr.setRequestHeader('Accept', 'application/zip');
            xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
            xhr.responseType = 'blob';

            xhr.onload = function () {
                if (spinner) {
                    spinner.style.display = "none"; // Show the spinner
                }
                if (xhr.status === 200) {
                    var blob = new Blob([xhr.response], { type: 'application/zip' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = vm.assetName + '.zip';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    alert('Download failed. Status: ' + xhr.status);
                }
            };

            xhr.onerror = function () {
                alert('Request error.');
            };

            xhr.send();
        }
        vm.modalClosing = false;
        $('#imageCarouselModal').on('hide.bs.modal', function () {
            vm.modalClosing = true;
        });
        $('#imageCarouselModal').on('hidden.bs.modal', function () {
            vm.modalClosing = false;
            var container = document.getElementById("carouselDisplayContainers");
            if (container) {
                var video = container.querySelector("video");
                if (video) {
                    video.pause();
                    video.src = "";
                }
                container.innerHTML = "";
            }
        });

        document.addEventListener("keydown", function (e) {
            if (document.getElementById("imageCarouselModal").style.display === "flex") {
                if (e.key === "ArrowRight") changeImage(1);
                if (e.key === "ArrowLeft") changeImage(-1);
                if (e.key === "Escape") closeCarousel();
            }
        });
        function clearMarkersPolyLine() {
            for (var i = 0; i < assetMarker.length; i++) {
                assetMarker[i].setMap(null);
            }
            assetMarker = [];
            for (var k = 0; k < assetPolyline.length; k++) {
                assetPolyline[k].setMap(null);
            }
            assetPolyline = [];
            for (var l = 0; l < spreadPolyline.length; l++) {
                spreadPolyline[l].setMap(null);
            }
            spreadPolyline = [];
        }


        $scope.newTabDisplay = function (id, imageId) {
            var request = new XMLHttpRequest(), apiImage = "api/trakeyeassetimages/";
            request.open(
                "GET",
                apiImage + id + "/" + imageId,
                true
            );
            request.setRequestHeader(
                "Authorization",
                "Bearer " + $localStorage.authenticationToken
            );
            request.responseType = "blob";
            request.onload = response;

            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    window.open(imageUrl, "_blank");
                } else {
                    alert("Error loading media: " + request.status);
                }
            }
            request.send();
        };
        function closeAssetAttributesModal() {
            console.log("closed")
            $("#modalAssetAttributes").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalAssetAttributes").hide();
        }
        function showAssetAttributesModal(assetVal) {
            $("#modalAssetAttributes").show();
            var assetTypeAttributeValuesList = assetVal.assetTypeAttributeValues;
            document.getElementById("assetAttributeTable").innerHTML = "";
            var newTable =
                "<table align='center' style='border: 1px solid black; width: 50%;'>" +
                "<tr><th style='border: 1px solid black; text-align: center;'>Attribute</th>" +
                "<th style='border: 1px solid black; text-align: center;'>Attribute Value</th></tr>";
            var filteredAndSortedList = [];
            for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
                var value = assetTypeAttributeValuesList[i];
                filteredAndSortedList.push(value);
            }

            filteredAndSortedList.sort(function (a, b) {
                return (
                    a.assetTypeAttribute.assetTypeAttribOrder -
                    b.assetTypeAttribute.assetTypeAttribOrder
                );
            });

            for (var j = 0; j < filteredAndSortedList.length; j++) {
                var item = filteredAndSortedList[j];
                newTable +=
                    "<tr><td style='border: 1px solid black; text-align: center;'>" +
                    (item.assetTypeAttribute.name || "N/A") +
                    "</td><td style='border: 1px solid black; text-align: center;'>" +
                    (item.attributeValue || "N/A") +
                    "</td></tr>";
            }

            newTable += "</table>";

            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }
        vm.geofenceCoordinates = [];
        RingGeofence.getGeofence(vm.trRoute.id, function (response) {
            if (Array.isArray(response) && response.length > 0) {
                response.forEach(function (item) {
                    if (item && item.coordinates && typeof item.coordinates === 'string' && item.coordinates.trim() !== "") {
                        try {
                            var coordinates = JSON.parse(item.coordinates);
                            var polygonCoords = coordinates.map(function (coord) {
                                return {
                                    lat: coord.lat,
                                    lng: coord.lng
                                };
                            });
                            var geofencePolygon = new google.maps.Polygon({
                                paths: polygonCoords,
                                strokeColor: "#fd7a24",
                                strokeOpacity: 1,
                                strokeWeight: 1,
                                fillColor: '#fd7a24',
                                fillOpacity: 0.20,
                                clickable: false,
                            });
                            geofencePolygon.setMap(locations.map);
                        } catch (e) {
                            console.error("Error parsing coordinates:", e);
                        }
                    }
                });
            }
        });
        var gpSelected = false;
        vm.highLightedSectionPath = []
        vm.surveyOFCPolylines = [];
        vm.createSection = function () {
            vm.selectedPaths = [];
            RouteByID.get(vm.trRoute.id, function (response) {
                vm.routePath = response;
                callRoutePath(vm.routePath.routePoints);
                var bounds = new google.maps.LatLngBounds();
                function callRoutePath(routePaths) {
                    var colors = ['#FD7A24', '#0096FF'];
                    var pathColor = colors[0];
                    var proposedPathColor = colors[1];
                    var groupedRoutePaths = {};
                    routePaths.forEach(function (coord) {
                        if (coord.sessionNumber) {
                            if (!groupedRoutePaths[coord.sessionNumber]) {
                                groupedRoutePaths[coord.sessionNumber] = { planned: [], proposed: [] };
                            }
                            if (coord.routePointType === 'COORDINATE') {
                                if (coord.phase === 'PLANNING') {
                                    groupedRoutePaths[coord.sessionNumber].planned.push(coord);
                                } else if (coord.phase === 'SURVEY') {
                                    groupedRoutePaths[coord.sessionNumber].proposed.push(coord);
                                }
                            }
                        }
                    })

                    Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                        var sessionData = groupedRoutePaths[sessionNumber];
                        if (sessionData.proposed.length) {
                            var pathCoordinates = sessionData.proposed.map(function (coord) {
                                var latLng = { lat: coord.latitude, lng: coord.longitude, id: coord.id, routePointNumber: parseFloat(coord.routePointNumber) };
                                return latLng;
                            });
                            pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                            vm.sectionCreate.setCenter(pathCoordinates[0])
                            var pathPolyline = new google.maps.Polyline({
                                path: pathCoordinates,
                                geodesic: true,
                                strokeColor: pathColor,
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                                zIndex: 1,
                            });
                            pathPolyline.setMap(vm.sectionCreate);
                            vm.surveyOFCPolylines.push(pathPolyline);
                            var polylineInfoWindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(pathPolyline, 'click', function (event) {
                                var contentString = document.createElement("div"),
                                    // btnAddSection,
                                    btnAddPortion
                                contentString.innerHTML = '<div class="infoWindowhead">'
                                "</div>";
                                polylineInfoWindow.setContent(contentString);
                                polylineInfoWindow.setPosition(event.latLng);
                                polylineInfoWindow.open(vm.sectionCreate);
                                openedInfoWindow = polylineInfoWindow;
                                var originalOptions = {
                                    strokeColor: pathPolyline.get("strokeColor"),
                                    strokeWeight: pathPolyline.get("strokeWeight"),
                                    strokeOpacity: pathPolyline.get("strokeOpacity")
                                };
                                pathPolyline.setOptions({
                                    strokeColor: "#A938F3",
                                    strokeWeight: 12,
                                    strokeOpacity: 0.6,
                                });
                                setTimeout(function () {
                                    pathPolyline.setOptions(originalOptions);
                                }, 10000);
                                // if (vm.trRoute.id) {
                                //     btnAddSection = contentString.appendChild(
                                //         document.createElement("input")
                                //     );

                                //     btnAddSection.type = "button";
                                //     btnAddSection.value = "Add to Section";
                                //     btnAddSection.className = "button";
                                //     google.maps.event.addDomListener(
                                //         btnAddSection,
                                //         "click",
                                //         function () {
                                //             vm.selectedPaths.push({
                                //                 id: vm.trRoute.id,
                                //                 name: sessionNumber,
                                //                 phase: vm.trRoute.phase,
                                //                 type: "SPREAD",
                                //                 latlngs: pathCoordinates,
                                //                 uid: sessionNumber
                                //             });
                                //             polylineInfoWindow.close()
                                //         }
                                //     );
                                // }
                                if (vm.trRoute.id) {
                                    btnAddPortion = contentString.appendChild(
                                        document.createElement("input")
                                    );
                                    btnAddPortion.type = "button";
                                    btnAddPortion.value = "draw fence to select path";
                                    btnAddPortion.className = "button";
                                    google.maps.event.addDomListener(
                                        btnAddPortion,
                                        "click",
                                        function () {
                                            polylineInfoWindow.close()
                                            var drawingManager = new google.maps.drawing.DrawingManager({
                                                drawingMode: google.maps.drawing.OverlayType.POLYGON,
                                                drawingControl: false,
                                                polygonOptions: {
                                                    fillColor: "#FD7A24",
                                                    fillOpacity: 0.2,
                                                    strokeWeight: 2,
                                                    clickable: true,
                                                    editable: true,
                                                    zIndex: 1,
                                                },
                                            });
                                            drawingManager.setMap(vm.sectionCreate);

                                            google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
                                                if (event.type === google.maps.drawing.OverlayType.POLYGON) {

                                                    var polygon = event.overlay;
                                                    var polygonPath = polygon.getPath().getArray();

                                                    Object.keys(groupedRoutePaths).forEach(function (sessionNumberTemp) {
                                                        var sessionDataTemp = groupedRoutePaths[sessionNumberTemp];
                                                        if (sessionDataTemp.proposed.length) {
                                                            var pathCoordinatesTemp = sessionDataTemp.proposed.map(function (coord) {
                                                                var latLng = { lat: coord.latitude, lng: coord.longitude, id: coord.id, routePointNumber: parseFloat(coord.routePointNumber) };
                                                                return latLng;
                                                            });
                                                            pathCoordinatesTemp.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                                                            for (var i = 0; i < pathCoordinatesTemp.length - 1; i++) {
                                                                var p1 = pathCoordinatesTemp[i];
                                                                var p2 = pathCoordinatesTemp[i + 1];
                                                                for (var j = 0; j < polygonPath.length; j++) {
                                                                    var p3 = toPlainCoord(polygonPath[j]);
                                                                    var p4 = toPlainCoord(polygonPath[(j + 1) % polygonPath.length]);
                                                                    var inter = getLineIntersection(p1, p2, p3, p4);
                                                                    if (inter) {
                                                                        vm.fromToIntersectingPoints.push(inter);
                                                                    }
                                                                }
                                                            }

                                                            var highlightedPath = [];
                                                            pathCoordinatesTemp.forEach(function (point) {
                                                                var latLng = new google.maps.LatLng(point.lat, point.lng);
                                                                if (google.maps.geometry.poly.containsLocation(latLng, polygon)) {
                                                                    highlightedPath.push(latLng);
                                                                }
                                                            });

                                                            if (highlightedPath.length > 1) {
                                                                var highlightPolyline = new google.maps.Polyline({
                                                                    path: highlightedPath,
                                                                    geodesic: true,
                                                                    strokeColor: "#0096FF",
                                                                    strokeOpacity: 0.8,
                                                                    strokeWeight: 6,
                                                                    zIndex: 10,
                                                                });
                                                                highlightPolyline.setMap(vm.sectionCreate);
                                                                vm.highLightedSectionPath.push(highlightPolyline)
                                                            }
                                                        }
                                                    });


                                                    var newPath = {
                                                        id: vm.trRoute.id,
                                                        name: sessionNumber,
                                                        phase: vm.trRoute.phase,
                                                        type: "POLYGON",
                                                        latlngs: polygonPath,
                                                        uid: sessionNumber
                                                    };

                                                    if (!isDuplicatePath(newPath)) {
                                                        vm.selectedPaths.push(newPath);
                                                    }

                                                    polygon.setMap(null);
                                                    drawingManager.setDrawingMode(null);
                                                    drawingManager.setMap(null);
                                                }
                                            });
                                        }
                                    );
                                }
                            });
                        }
                    });
                    vm.newOFCPolylines = [];
                    vm.existingOFCPolylines = [];
                    vm.unusedOFCPolylines = [];
                    vm.assets.forEach(function (asset) {
                        var coordinates = asset.assetCoordinates.map(function (coord) {
                            return { lat: coord.latitude, lng: coord.longitude };
                        });
                        if (asset.assetTypeLayout === 'SPREAD') {
                            var polylineColor = "";
                            polylineColor = "#00A36C";
                            if (!asset.isExisting) {
                                polylineColor = "#ff0025"; //tmpColor = "blue";
                            }
                            if (!asset.isUsed && asset.isExisting) {
                                polylineColor = "#FFAE42";
                            }
                            var drawPolyline = new google.maps.Polyline({
                                path: coordinates,
                                geodesic: true,
                                strokeColor: polylineColor,
                                strokeOpacity: 0.9,
                                strokeWeight: 3,
                                zIndex: 1
                            });
                            drawPolyline.setMap(vm.sectionCreate);
                            if (!asset.isExisting) {
                                vm.newOFCPolylines.push(drawPolyline);
                            } else if (!asset.isUsed && asset.isExisting) {
                                vm.unusedOFCPolylines.push(drawPolyline);
                            } else {
                                vm.existingOFCPolylines.push(drawPolyline);
                            }
                        }
                    });
                }
                vm.gpAssets.forEach(function (asset) {
                    var coordinates = asset.assetCoordinates.map(function (coord) {
                        return { lat: coord.latitude, lng: coord.longitude, id: coord.id, sortOrder: coord.sortOrder };
                    });
                    if (asset.assetTypeLayout === 'FIXED') {
                        vm.sectionCreate.setCenter(coordinates[0])
                        var marker = new google.maps.Marker({
                            position: coordinates[0],
                            map: vm.sectionCreate,
                            title: asset.name,
                            icon: {
                                url: asset.assetTypeImagePath,
                                scaledSize: new google.maps.Size(32, 32)
                            },
                            label: {
                                color: "black",
                                fontWeight: "bold",
                                fontSize: "9px",
                                text: asset.name
                            }
                        });
                        var infowindow = new google.maps.InfoWindow();
                        var updateIconSize = function () {
                            var zoom = locations.map.getZoom();
                            var minZoom = 8;
                            var maxZoom = 21;
                            var minSize = 6;
                            var maxSize = 60;
                            var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);
                            var icon = {
                                url: marker.getIcon().url,
                                scaledSize: new google.maps.Size(newSize, newSize),
                                anchor: new google.maps.Point(newSize / 2, newSize),
                            };

                            marker.setIcon(icon);
                        };
                        updateIconSize();
                        google.maps.event.addListener(locations.map, "zoom_changed", function () {
                            updateIconSize();
                        });

                        google.maps.event.addListener(marker, 'click', function () {
                            if (openedInfoWindow !== null) {
                                openedInfoWindow.close();
                            }
                            var contentString = document.createElement("div"),
                                btnAddSection
                            contentString.innerHTML = '<div class="infoWindowhead">' +
                                "<b>ID: " + asset.id + "</b><br>" +
                                "<b>Name: " + asset.name + "</b><br>" +
                                "<b>AssetTypeName: " + asset.assetTypeName + "</b><br>" +
                                "<b>Latitude: " + coordinates[0].lat + "</b><br>" +
                                "<b>Longitude: " + coordinates[0].lng + "</b><br>" +
                                "</div>";
                            infowindow.setContent(contentString);
                            infowindow.open(vm.sectionCreate, marker);
                            openedInfoWindow = infowindow;
                            if (vm.trRoute.id) {
                                btnAddSection = contentString.appendChild(
                                    document.createElement("input")
                                );
                                btnAddSection.type = "button";
                                btnAddSection.value = "Add to section";
                                btnAddSection.className = "button";
                                google.maps.event.addDomListener(
                                    btnAddSection,
                                    "click",
                                    function () {
                                        vm.selectedPaths.push({
                                            id: vm.trRoute.id,
                                            name: asset.name,
                                            type: asset.assetTypeLayout,
                                            phase: vm.trRoute.phase,
                                            latlngs: coordinates
                                        });
                                        gpSelected = true
                                        openedInfoWindow.close();
                                    }
                                );
                            }
                        });
                    }
                });
                var searchInput = document.createElement("input");
                searchInput.type = "text";
                searchInput.placeholder = "Search asset...";
                searchInput.style.position = "absolute";
                searchInput.style.top = "10px";
                searchInput.style.left = "50%";
                searchInput.style.transform = "translateX(-50%)";
                searchInput.style.zIndex = "5";
                searchInput.style.padding = "5px";
                searchInput.style.border = "1px solid #ccc";
                searchInput.style.borderRadius = "4px";
                document.getElementById("create_section_map").appendChild(searchInput);
                searchInput.addEventListener("input", function () {
                    var searchTerm = searchInput.value.toLowerCase();
                    var foundAsset = null;
                    vm.gpAssets.forEach(function (asset) {
                        if (asset.name.toLowerCase().includes(searchTerm)) {
                            foundAsset = asset;
                        }
                    });
                    if (foundAsset) {
                        var coordinates = foundAsset.assetCoordinates.map(function (coord) {
                            return { lat: coord.latitude, lng: coord.longitude };
                        });
                        if (coordinates.length > 0) {
                            vm.sectionCreate.setCenter(coordinates[0]);
                            vm.sectionCreate.setZoom(15);
                        }
                    }
                });
            });
        }
        vm.ofcFilterOptions = [
            { name: "New OFC", value: "new", selected: true },
            { name: "Existing OFC", value: "existing", selected: true },
            { name: "Unused OFC", value: "Unused", selected: true },
            { name: "Survey Route", value: "survey", selected: true }
        ];
        vm.selectedOFCFilters = angular.copy(vm.ofcFilterOptions);
        vm.applyOFCFilter = function () {
            vm.newOFCPolylines.forEach(function (poly) { poly.setMap(null); });
            vm.existingOFCPolylines.forEach(function (poly) { poly.setMap(null); });
            vm.unusedOFCPolylines.forEach(function (poly) { poly.setMap(null); });
            vm.surveyOFCPolylines.forEach(function (poly) { poly.setMap(null); });
            vm.selectedOFCFilters.forEach(function (filter) {
                if (filter.selected) {
                    if (filter.value === "new") {
                        vm.newOFCPolylines.forEach(function (poly) { poly.setMap(vm.sectionCreate); });
                    }
                    if (filter.value === "existing") {
                        vm.existingOFCPolylines.forEach(function (poly) { poly.setMap(vm.sectionCreate); });
                    }
                    if (filter.value === "Unused") {
                        vm.unusedOFCPolylines.forEach(function (poly) { poly.setMap(vm.sectionCreate); });
                    }
                    if (filter.value === "survey") {
                        vm.surveyOFCPolylines.forEach(function (poly) { poly.setMap(vm.sectionCreate); });
                    }

                }
            });
        };

        setTimeout(function () {
            vm.sectionCreate = new google.maps.Map(
                document.getElementById("create_section_map"),
                {
                    zoom: $rootScope.rolloutMapInitZoom || 10,
                    center: {
                        lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                        lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                    }
                }
            );
        }, 500);


        function toLatLng(coord) {
            return (coord instanceof google.maps.LatLng) ? coord : new google.maps.LatLng(coord.lat, coord.lng);
        }

        function toPlainCoord(latLng) {
            return { lat: latLng.lat(), lng: latLng.lng() };
        }

        function getLineIntersection(p1, p2, p3, p4) {
            p1 = toLatLng(p1); p2 = toLatLng(p2);
            p3 = toLatLng(p3); p4 = toLatLng(p4);
            var x1 = p1.lng(), y1 = p1.lat();
            var x2 = p2.lng(), y2 = p2.lat();
            var x3 = p3.lng(), y3 = p3.lat();
            var x4 = p4.lng(), y4 = p4.lat();

            var denom = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
            if (denom === 0) return null;

            var t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denom;
            var u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / denom;

            if (t >= 0 && t <= 1 && u >= 0 && u <= 1) {
                return {
                    lat: y1 + t * (y2 - y1),
                    lng: x1 + t * (x2 - x1)
                };
            }
            return null;
        }

        function findClosestCoord(target, coords) {
            var minDist = Infinity, closest = null;
            var targetLatLng = toLatLng(target);
            for (var i = 0; i < coords.length; i++) {
                var current = toLatLng(coords[i]);
                var dist = google.maps.geometry.spherical.computeDistanceBetween(targetLatLng, current);
                if (dist < minDist) {
                    minDist = dist;
                    closest = coords[i];
                }
            }
            return closest;
        }

        function enrichWithMeta(interPoint, originalCoords) {
            var closest = findClosestCoord(interPoint, originalCoords);
            return {
                lat: interPoint.lat,
                lng: interPoint.lng,
                id: closest.id || null,
                routePointNumber: closest.routePointNumber || null
            };
        }

        function areCoordsSame(p1, p2) {
            return (
                toLatLng(p1).lat().toFixed(7) === toLatLng(p2).lat().toFixed(7) &&
                toLatLng(p1).lng().toFixed(7) === toLatLng(p2).lng().toFixed(7)
            );
        }

        function isDuplicatePath(newPathObj) {
            return vm.selectedPaths.some(function (existingPath) {
                if (existingPath.id !== newPathObj.id) return false;
                var a = existingPath.latlngs, b = newPathObj.latlngs;
                if (a.length !== b.length) return false;
                for (var i = 0; i < a.length; i++) {
                    if (!areCoordsSame(a[i], b[i])) return false;
                }
                return true;
            });
        }

        function sectionSave() {
            var fixedAssets = vm.selectedPaths.filter(function (item) {
                return item.type === "FIXED" && item.name && item.name.trim() !== "";
            });
            if (fixedAssets.length < 2) {
                alert("Both FROM and TO fixed assets must be selected before saving.");
                return;
            }
            var fixedFrom = fixedAssets[0];
            var fixedTo = fixedAssets[1];
            if (fixedFrom.name === fixedTo.name) {
                vm.selectedPaths = []
                for (var i = 0; i < vm.highLightedSectionPath.length; i++) {
                    vm.highLightedSectionPath[i].setMap(null)
                    vm.highLightedSectionPath = []
                }
                alert("FROM and TO assets are the same. Please select different assets.");
                return;
            }
            if (vm.fromToIntersectingPoints.length > 1) {
                vm.selectedPaths.push({
                    id: vm.trRoute.id,
                    name: "from",
                    phase: vm.trRoute.phase,
                    type: "FROM",
                    latlngs: [{ lat: vm.fromToIntersectingPoints[0].lat, lng: vm.fromToIntersectingPoints[0].lng }],
                    uid: "from"
                });

                vm.selectedPaths.push({
                    id: vm.trRoute.id,
                    name: "to",
                    phase: vm.trRoute.phase,
                    type: "TO",
                    latlngs: [{ lat: vm.fromToIntersectingPoints[1].lat, lng: vm.fromToIntersectingPoints[1].lng }],
                    uid: "to"
                });
                SectionSelect.create(vm.selectedPaths, function (response) {
                    if (response) {
                        vm.selectedPaths = [];
                        vm.fromToIntersectingPoints = [];
                        for (var i = 0; i < vm.highLightedSectionPath.length; i++) {
                            vm.highLightedSectionPath[i].setMap(null)
                            vm.highLightedSectionPath = []
                        }
                        alert("Section '" + response.name + "' is created successfully");
                    }
                });
            } else {
                vm.fromToIntersectingPoints = [];
                SectionSelect.create(vm.selectedPaths, function (response) {
                    if (response) {
                        vm.selectedPaths = [];
                        vm.fromToIntersectingPoints = [];
                        for (var i = 0; i < vm.highLightedSectionPath.length; i++) {
                            vm.highLightedSectionPath[i].setMap(null)
                            vm.highLightedSectionPath = []
                        }
                        alert("Section '" + response.name + "' is created successfully");
                    }
                });
            }

        }
        vm.downloadProjectSurveyExcel = function (canAggregate) {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block";
            }
            BaseUrl.getBaseUrl(function (baseurl) {
                var url = "";
                url = baseurl.stringValue + "api/route-survey-reportv1/" + vm.trRoute.id + "/" + vm.trRoute.phase + "/" + canAggregate;
                var request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';
                request.onload = function (e) {
                    if (spinner) {
                        spinner.style.display = "none";
                    }
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'report.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));
                                downloadLink.download = 'Rings - ' + vm.trRoute.name + '.xlsx';
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    } else {
                        alert("No data found");
                    }
                };

                request.send();
            });
        }
        geoLocation(locations.map);
        vm.gpAssetsVisible = true;
        vm.gpAssetMarkers = [];
        vm.planpathPolyline = [];
        vm.planpathPolylineVisible = true;
        vm.routeMarkerssurveyVisible = true;
        vm.routeMarkerssurveyMap = [];
        vm.editSurveyPath = function (coordsurvey) {
            vm.updatedSurveyPath = [];
            vm.editSurveyMap = new google.maps.Map(
                document.getElementById("map_canvas_edit_survey_path"),
                {
                    zoom: $rootScope.rolloutMapInitZoom || 10,
                    center: {
                        lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                        lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                    }
                }
            );

            var legend = document.createElement("div");
            legend.id = "map-legend";
            legend.style.position = "absolute";
            legend.style.background = "#f3f3f3";
            legend.style.padding = "4px";
            legend.style.border = "1px solid rgb(204, 204, 204)";
            legend.style.fontFamily = "Arial, sans-serif";
            legend.style.borderRadius = "5px";
            legend.style.boxShadow = "1px 1px 1px 0px";
            legend.style.color = "black";

            legend.innerHTML =
                '<div style="display: flex; align-items: center;">' +
                '<div style="display: flex; align-items: center; margin-right: 15px;">' +
                '<div style="width: 12px; height: 12px; background: #FD7A24; margin-right: 5px;"></div>' +
                '<span>PLANNED</span>' +
                '</div>' +
                '<div style="display: flex; align-items: center;">' +
                '<div style="width: 12px; height: 12px; background: #0096FF; margin-right: 5px;"></div>' +
                '<span>SURVEY</span>' +
                '</div>' +
                '</div>';

            vm.editSurveyMap.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(legend);
            var center = vm.editSurveyMap.getCenter();
            imageRoutePoint.postCenterLatLng(vm.trRoute.id, { lat: center.lat(), lng: center.lng() }, function (data) {
                if (data && data.length) {
                    for (var i = 0; i < vm.routeMarkerssurveyMap.length; i++) {
                        vm.routeMarkerssurveyMap[i].setMap(null);
                    }
                    vm.routeMarkerssurveyMap = [];
                    var markerImage, iconImg
                    var iconSize = 20
                    var iconMarker = "content/images/sm_marker_transparent.png"
                    var iconImage = "content/images/routePointImage.png"
                    data.forEach(function (each) {
                        iconImg = (each.imageAttached) ? iconImage : iconMarker
                        markerImage = new google.maps.Marker({
                            position: { lat: each.latitude, lng: each.longitude },
                            map: vm.editSurveyMap,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: iconImg,
                                anchor: new google.maps.Point(
                                    iconSize / 2,
                                    iconSize / 2
                                ),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });
                        vm.routeMarkerssurveyMap.push(markerImage);
                    });
                }
            });

            RouteByID.get(vm.trRoute.id, function (response) {
                vm.routePathforSurevey = response;
                callRoutePath(vm.routePathforSurevey.routePoints);
                var bounds = new google.maps.LatLngBounds();

                vm.gpAssets.forEach(function (asset) {
                    var coordinates = [];
                    for (var i = 0; i < asset.assetCoordinates.length; i++) {
                        var coord = asset.assetCoordinates[i];
                        coordinates.push({
                            lat: coord.latitude,
                            lng: coord.longitude,
                            id: coord.id,
                            sortOrder: coord.sortOrder
                        });
                    }

                    if (asset.assetTypeLayout === 'FIXED') {
                        var marker = new google.maps.Marker({
                            map: vm.editSurveyMap,
                            position: coordinates[0],
                            title: asset.name,
                            icon: {
                                scaledSize: new google.maps.Size(24, 24),
                                url: asset.assetTypeImagePath,
                                anchor: new google.maps.Point(12, 24),
                                labelOrigin: new google.maps.Point(25, 22)
                            }
                        });
                        vm.gpAssetMarkers.push(marker)
                        // Define marker label visibility function
                        var updateMarkerLabelVisibility = function () {
                            var currentZoom = vm.editSurveyMap.getZoom();
                            if (currentZoom > 17) {
                                marker.setLabel({
                                    color: "black",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                    text: asset.name,
                                    className: "asset_label top-label"
                                });
                            } else {
                                marker.setLabel(null);
                            }
                        };

                        // Inject CSS for label only once
                        if (!document.getElementById('top-label-style')) {
                            var style = document.createElement('style');
                            style.id = 'top-label-style';
                            style.innerHTML = '.top-label {' +
                                'position: relative;' +
                                'top: 30px;' +
                                'left: 0;' +
                                'transform: translateX(10%);' +
                                'white-space: nowrap;' +
                                '}';
                            document.head.appendChild(style);
                        }

                        var infowindow = new google.maps.InfoWindow();
                        var updateIconSize = function () {
                            var zoom = vm.editSurveyMap.getZoom();
                            var minZoom = 8;
                            var maxZoom = 21;
                            var minSize = 6;
                            var maxSize = 60;
                            var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);
                            var icon = {
                                url: marker.getIcon().url,
                                scaledSize: new google.maps.Size(newSize, newSize),
                                anchor: new google.maps.Point(newSize / 2, newSize),
                            };

                            marker.setIcon(icon);
                        };
                        updateIconSize();
                        google.maps.event.addListener(vm.editSurveyMap, "zoom_changed", function () {
                            updateIconSize();
                        });
                    }
                });

                function callRoutePath(routePaths) {
                    var colors = ['#FD7A24', '#0096FF'];
                    var pathColor = colors[0];
                    var proposedPathColor = colors[1];
                    var groupedRoutePaths = {};
                    routePaths.forEach(function (coord) {
                        if (coord.sessionNumber) {
                            if (!groupedRoutePaths[coord.sessionNumber]) {
                                groupedRoutePaths[coord.sessionNumber] = { planned: [], proposed: [] };
                            }
                            if (coord.routePointType === 'COORDINATE') {
                                if (coord.phase === 'PLANNING') {
                                    groupedRoutePaths[coord.sessionNumber].planned.push(coord);
                                } else if (coord.phase === 'SURVEY') {
                                    groupedRoutePaths[coord.sessionNumber].proposed.push(coord);
                                }
                            }
                        }
                    })
                    Object.keys(groupedRoutePaths).forEach(function (sessionNumber) {
                        var sessionData = groupedRoutePaths[sessionNumber];
                        if (sessionData.proposed.length) {
                            var pathCoordinates = sessionData.proposed.map(function (coord) {
                                return {
                                    lat: coord.latitude,
                                    lng: coord.longitude,
                                    id: coord.id,
                                    sessionNumber: coord.sessionNumber,
                                    routeId: coord.routeId,
                                    routePointNumber: parseFloat(coord.routePointNumber)
                                };
                            });

                            pathCoordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                            var isEditable = (sessionNumber === coordsurvey[0].sessionNumber);
                            var googlePath = new google.maps.MVCArray();
                            var pathMetaMap = new Map();
                            pathCoordinates.forEach(function (coord, index) {
                                var latLng = new google.maps.LatLng(coord.lat, coord.lng);
                                googlePath.push(latLng);
                                pathMetaMap.set(index, {
                                    id: coord.id,
                                    sessionNumber: coord.sessionNumber,
                                    routeId: coord.routeId
                                });
                            });

                            var pathPolyline = new google.maps.Polyline({
                                path: googlePath,
                                geodesic: true,
                                strokeColor: proposedPathColor,
                                strokeWeight: isEditable ? 6 : 4,
                                zIndex: isEditable ? 2 : 1,
                                editable: isEditable
                            });
                            pathPolyline.setMap(vm.editSurveyMap);

                            if (isEditable) {
                                google.maps.event.addListener(pathPolyline.getPath(), "insert_at", function () {
                                    updateSurveyCoordinates(pathPolyline, sessionNumber, pathMetaMap);
                                    snapEndsToNearest(pathPolyline, sessionNumber);
                                });

                                google.maps.event.addListener(pathPolyline.getPath(), "set_at", function () {
                                    updateSurveyCoordinates(pathPolyline, sessionNumber, pathMetaMap);
                                    snapEndsToNearest(pathPolyline, sessionNumber);
                                });
                                vm.editSurveyMap.setCenter(vm.SuveryMapCenter);
                            }
                        }

                        if (sessionData.planned.length) {
                            var pathCoordinatesplan = sessionData.planned.map(function (coord) {
                                return {
                                    lat: coord.latitude,
                                    lng: coord.longitude,
                                    id: coord.id,
                                    sessionNumber: coord.sessionNumber,
                                    routeId: coord.routeId,
                                    routePointNumber: parseFloat(coord.routePointNumber)
                                };
                            });

                            pathCoordinatesplan.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                            var Path = new google.maps.MVCArray();
                            pathCoordinatesplan.forEach(function (coord) {
                                var latLng = new google.maps.LatLng(coord.lat, coord.lng);
                                Path.push(latLng);
                            });

                            var planpathPolyline = new google.maps.Polyline({
                                path: Path,
                                geodesic: true,
                                strokeColor: pathColor,
                                strokeWeight: 4,
                                zIndex: 1,

                            });
                            planpathPolyline.setMap(vm.editSurveyMap);
                            vm.planpathPolyline.push(planpathPolyline);
                        }
                    });
                }

            });
            var ele = document.getElementById("editSurveyPath");
            $(ele).modal("show");
            $("#editSurveyPath").show();

            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_edit_survey_path").css("width", "100%");

        }
        var isSnapping = false
        function snapEndsToNearest(pathPolyline, sessionNumber) {
            var path = pathPolyline.getPath();
            if (path.getLength() > 1) {
                if (isSnapping) return;
                isSnapping = true;
                var firstCoord = { lat: path.getAt(0).lat(), lng: path.getAt(0).lng() };
                var lastCoord = { lat: path.getAt(path.getLength() - 1).lat(), lng: path.getAt(path.getLength() - 1).lng() };

                var minFirstDist = 5; // meters
                var minLastDist = 5;  // meters
                var nearestFirst = null;
                var nearestLast = null;

                vm.routePathforSurevey.routePoints.forEach(function (coord) {
                    if (coord.sessionNumber !== sessionNumber &&
                        coord.routePointType === "COORDINATE" &&
                        coord.phase == "SURVEY") {
                        var mappedLat = coord.latitude;
                        var mappedLon = coord.longitude;

                        var distToFirst = getDistanceMeters(firstCoord.lat, firstCoord.lng, mappedLat, mappedLon);
                        if (distToFirst <= minFirstDist) {
                            minFirstDist = distToFirst;
                            nearestFirst = { lat: mappedLat, lng: mappedLon };
                        }

                        var distToLast = getDistanceMeters(lastCoord.lat, lastCoord.lng, mappedLat, mappedLon);
                        if (distToLast <= minLastDist) {
                            minLastDist = distToLast;
                            nearestLast = { lat: mappedLat, lng: mappedLon };
                        }
                    }
                });

                if (nearestFirst) {
                    path.setAt(0, new google.maps.LatLng(nearestFirst.lat, nearestFirst.lng));
                }
                if (nearestLast) {
                    path.setAt(path.getLength() - 1, new google.maps.LatLng(nearestLast.lat, nearestLast.lng));
                }

                isSnapping = false;
            }
        }

        function getDistanceMeters(lat1, lon1, lat2, lon2) {
            var R = 6371000; // Radius of Earth in meters
            var dLat = (lat2 - lat1) * Math.PI / 180;
            var dLon = (lon2 - lon1) * Math.PI / 180;
            var a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c;
        }


        vm.updatePlanedPathVisibilitysuveyEdit = function () {
            vm.gpAssetsVisible = !vm.gpAssetsVisible;
            if (vm.gpAssetMarkers && vm.gpAssetMarkers.length) {
                for (var i = 0; i < vm.gpAssetMarkers.length; i++) {
                    vm.gpAssetMarkers[i].setMap(vm.gpAssetsVisible ? vm.editSurveyMap : null);
                }
            }
        };
        vm.updateMarkerVisibilitySurveyEdit = function () {
            vm.planpathPolylineVisible = !vm.planpathPolylineVisible;
            if (vm.planpathPolyline && vm.planpathPolyline.length) {
                for (var i = 0; i < vm.planpathPolyline.length; i++) {
                    vm.planpathPolyline[i].setMap(vm.planpathPolylineVisible ? vm.editSurveyMap : null);
                }
            }
        };
        function hideSuveryEditModal() {
            $("#editSurveyPath").removeClass("in");
            $(".modal-backdrop").remove();
            $("#editSurveyPath").hide();
        }

        function updateSurveyCoordinates(polyline, sessionNumber, pathMetaMap) {
            var path = polyline.getPath();
            var newCoordinates = [];
            vm.updatedSurveyPath = [];

            for (var i = 0; i < path.getLength(); i++) {
                var latLng = path.getAt(i);
                var meta = pathMetaMap.get(i) || {
                    id: null,
                    sessionNumber: sessionNumber,
                    routeId: vm.trRoute.id
                };

                var isValidId = (typeof meta.id === 'number' && meta.id > 0);

                newCoordinates.push({
                    latitude: latLng.lat(),
                    longitude: latLng.lng(),
                    id: isValidId ? meta.id : null,
                    sessionNumber: meta.sessionNumber || sessionNumber,
                    routeId: meta.routeId || vm.trRoute.id,
                    routePointNumber: i + 1.0,
                    routePointType: "COORDINATE"
                });
            }

            vm.updatedSurveyPath = newCoordinates;
        }
        vm.saveEditSurveyPath = function () {
            if (vm.updatedSurveyPath != null && vm.updatedSurveyPath.length > 0) {
                routeDetail.saveEditedRoutepoints(vm.updatedSurveyPath, function (response) {
                    if (response.status == '201 OK') {
                        alert("Survey path updated sucessful.");
                        hideSuveryEditModal();
                        if (!(vm.drawMarkers != null && vm.drawingPolyline != null)) {
                            window.location.reload();
                        }
                    } else {
                        alert("Something went wrong!.");
                    }
                });
            }
            if (vm.drawMarkers != null && vm.drawingPolyline != null) {
                vm.createSurveyPath();
            }


        }

        vm.drawSurveyPath = function () {
            vm.drawingPolyline = new google.maps.Polyline({
                map: vm.editSurveyMap,
                path: [],
                strokeColor: '#007bff',
                strokeOpacity: 1.0,
                strokeWeight: 3,
                editable: true
            });

            vm.drawCoordinates = [];
            vm.drawMarkers = [];
            vm.drawingListeners = [];

            var path = vm.drawingPolyline.getPath();

            function addDrawMarker(latLng) {
                var index = vm.drawCoordinates.length + 1;
                vm.drawCoordinates.push({ lat: latLng.lat(), lng: latLng.lng() });
                path.push(latLng);

                var marker = new google.maps.Marker({
                    position: latLng,
                    map: vm.editSurveyMap,
                    clickable: false,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 6,
                        fillColor: "#ff0000",
                        fillOpacity: 1,
                        strokeWeight: 1,
                        strokeColor: "#fff"
                    },
                    label: {
                        text: index.toString(),
                        color: "#000",
                        fontSize: "10px",
                        fontWeight: "bold"
                    }
                });

                vm.drawMarkers.push(marker);

            }

            var mapClickListener = google.maps.event.addListener(vm.editSurveyMap, 'click', function (e) {
                addDrawMarker(e.latLng);
            });
            vm.drawingListeners.push(mapClickListener);

            alert("Drawing tool activated! Click to add points, click the last marker to finish.");
        };

        vm.stopDrawingPolyline = function () {
            vm.drawingListeners.forEach(function (listener) {
                google.maps.event.removeListener(listener);
            });
            vm.drawingListeners = [];

            if (vm.drawingPolyline) {
                vm.drawingPolyline.setEditable(true);
            }
        };
        vm.toggleDrawingPath = function () {
            if (!vm.drawingPolyline) {
                vm.drawSurveyPath();
            } else {
                vm.stopDrawingPolyline();
            }
        };

        vm.stopDrawingPolyline = function () {
            vm.drawingListeners.forEach(function (listener) {
                google.maps.event.removeListener(listener);
            });
            vm.drawingListeners = [];

            if (vm.drawingPolyline) {
                vm.drawingPolyline.setEditable(true);
            }
        };

        vm.undoLastPoint = function () {
            if (vm.drawCoordinates.length > 0) {
                vm.drawCoordinates.pop();

                if (vm.drawingPolyline) {
                    var path = vm.drawingPolyline.getPath();
                    path.pop();
                }

                var marker = vm.drawMarkers.pop();
                if (marker) {
                    marker.setMap(null);
                }
            }
        };

        vm.resetDrawing = function () {
            vm.stopDrawingPolyline();

            vm.drawMarkers.forEach(function (marker) {
                marker.setMap(null);
            });
            vm.drawMarkers = [];

            vm.drawCoordinates = [];

            if (vm.drawingPolyline) {
                vm.drawingPolyline.setMap(null);
                vm.drawingPolyline = null;
            }
        };

        vm.createSurveyPath = function () {
            var markerFormattedPath = vm.drawMarkers.map(function (marker, i) {
                var latLng = marker.getPosition();
                return {
                    latitude: latLng.lat(),
                    longitude: latLng.lng(),
                    id: null,
                    sessionNumber: generateUUID(),
                    routeId: vm.trRoute.id,
                    routePointNumber: i + 1.0,
                    routePointType: "MARKER",
                    // lhsOffset: 3,
                    // rhsOffset: 3,
                    // rodometerLength: 3,
                    // roadWidth: 3,
                    //  distance: 0,
                    //  landMark: "",
                    phase: "SURVEY"
                };
            });

            var pathCoords = vm.drawingPolyline.getPath().getArray().map(function (latLng) {
                return {
                    lat: latLng.lat(),
                    lng: latLng.lng()
                };
            });
            var sessionNumber = generateUUID();
            var formattedPath = pathCoords.map(function (coord, i) {
                return {
                    latitude: coord.lat,
                    longitude: coord.lng,
                    id: null,
                    sessionNumber: sessionNumber,
                    routeId: vm.trRoute.id,
                    routePointNumber: i + 1.0,
                    routePointType: "COORDINATE",
                    phase: "SURVEY"
                };
            });
            var combinedPath = markerFormattedPath.concat(formattedPath);
            routeDetail.saveBulkRoutePoints(combinedPath, function (response) {
                if (response != null) {
                    vm.routePointData = [];
                    vm.resetDrawing();
                    var routeMarkerData = [];
                    var routesurveypathData = [];
                    vm.routePointData = response;
                    vm.routePointData.forEach(function (route) {
                        if (route.routePointType == "COORDINATE") {
                            routesurveypathData.push(route);
                        } else {
                            routeMarkerData.push(route);
                        }
                    });
                    //callRouteImage(routeMarkerData,vm.editSurveyMap);
                    routesurveypathData.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                    var newSurevyPath = [];
                    routesurveypathData.forEach(function (coord) {
                        var latLng = new google.maps.LatLng(coord.latitude, coord.longitude);
                        newSurevyPath.push(latLng);
                    });

                    var pathPolyline = new google.maps.Polyline({
                        path: newSurevyPath,
                        geodesic: true,
                        strokeColor: '#0096FF',
                        strokeWeight: 4,
                        zIndex: 1,
                    });
                    pathPolyline.setMap(vm.editSurveyMap);
                    Trmarkers = [];
                    addClick(pathPolyline);
                    $('#confirmModal').modal('show');
                    vm.combinedPathToSave = combinedPath;
                }
            });

        }

        function addClick(item) {
            item.addListener("click", function (event) {
                if (Trmarkers.length < 2) {
                    addMarker(event.latLng);
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }
        function addMarker(location) {
            var markerText
            if (Trmarkers.length == 0) {
                markerText = labelFrom
            } else if (Trmarkers.length == 1) {
                markerText = labelTo;
                $('#terrainRow').modal('show');
            }

            var marker = new google.maps.Marker({
                position: location,
                map: vm.editSurveyMap,
                label: {
                    text: markerText,
                }
            });
            Trmarkers.push(marker);
        }

        function generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now();
            }

            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }

        vm.createTerrainRow = function () {
            $('#confirmModal').modal('hide');
            Trmarkers = [];
            alert("please select from and to point to create terrain and row");
        }

        vm.saveTerrainRow = function () {
            vm.trTerrain = vm.trTerrain || {};
            vm.trTerrain.terrainType = vm.terrainType;
            vm.trTerrain.phase = "SURVEY";
            vm.trTerrain.routeId = vm.trRoute.id;
            vm.trTerrain.name = vm.terrainType.name + "_0";

            vm.trRow = vm.trRow || {};
            vm.trRow.rowType = vm.rowType;
            vm.trRow.phase = "SURVEY";
            vm.trRow.routeId = vm.trRoute.id;
            vm.trRow.name = vm.rowType.name + "_0";
            if (Trmarkers.length === 2) {
                Trmarkers.forEach(function (item) {
                    if (item.label.text === labelFrom) {
                        vm.trTerrain.fromRoutePoint = {
                            latitude: item.position.lat(),
                            longitude: item.position.lng()
                        };
                        vm.trRow.fromRoutePoint = angular.copy(vm.trTerrain.fromRoutePoint);
                    }
                    if (item.label.text === labelTo) {
                        vm.trTerrain.toRoutePoint = {
                            latitude: item.position.lat(),
                            longitude: item.position.lng()
                        };
                        vm.trRow.toRoutePoint = angular.copy(vm.trTerrain.toRoutePoint);
                    }
                });

                var terrainSaved = false;
                var rowSaved = false;
                var terrainPathDrawn = false;
                var terraintWithRoutePoints = {
                    terrainDTO: vm.trTerrain,
                    routePoints: vm.routePointData
                }
                AllTerrainTypes.saveTerrainWithRoutepoints(terraintWithRoutePoints, function (response) {
                    terrainSaved = true;

                    routeDetail.getTerrainPathByTerrainId(response.id, function (terrainPath) {
                        var terrrainCoords = terrainPath.COORDINATE;
                        var newterrainPath = [];

                        if (terrrainCoords.length > 2) {

                            terrrainCoords.sort(function (a, b) {
                                return a.routePointNumber - b.routePointNumber;
                            });

                            terrrainCoords.forEach(function (coord) {
                                var latLng = new google.maps.LatLng(coord.latitude, coord.longitude);
                                newterrainPath.push(latLng);
                            });

                            var pathterrain = new google.maps.Polyline({
                                path: newterrainPath,
                                geodesic: true,
                                strokeColor: 'red',
                                strokeWeight: 9,
                                zIndex: 1
                            });

                            pathterrain.setMap(vm.editSurveyMap);
                        }

                        terrainPathDrawn = true;
                        checkSaveCompletion();
                    });
                });
                var rowWithRoutePoints = {
                    rowDTO: vm.trRow,
                    routePoints: vm.routePointData
                }
                AllTerrainTypes.saveRowWithRoutepoints(rowWithRoutePoints, function (rowResponse) {
                    rowSaved = true;
                    checkSaveCompletion();
                });

                function checkSaveCompletion() {
                    if (terrainSaved && rowSaved && terrainPathDrawn) {
                        for (var i = 0; i < Trmarkers.length; i++) {
                            Trmarkers[i].setMap(null);
                        }
                        Trmarkers = [];
                        vm.trTerrain = {};
                        vm.trRow = {};

                        $('#terrainRow').modal('hide');
                        $('#confirmModal').modal('show');
                    }
                }
            } else {
                vm.infoMessage = "Please select both From and To points to create Terrain and ROW.";
                $timeout(function () {
                    vm.infoMessage = '';
                }, 5000);
            }
        };


        vm.returnToHome = function () {
            window.location.reload();
        }

        vm.updateRouteMarkerVisibilitySurveyEdit = function () {
            vm.routeMarkerssurveyVisible = !vm.routeMarkerssurveyVisible;
            if (vm.routeMarkerssurveyMap && vm.routeMarkerssurveyMap.length) {
                for (var i = 0; i < vm.routeMarkerssurveyMap.length; i++) {
                    vm.routeMarkerssurveyMap[i].setMap(vm.routeMarkerssurveyVisible ? vm.editSurveyMap : null);
                }
            }
        };
        var fullData = [];
        var selectedUser = "All";

        function getRouteStatus() {
            RouteStatus.getRouteStatus(vm.trRoute.id, function (response) {
                if (response && response.length > 0) {
                    fullData = response;
                    var usersMap = {};
                    var users = [];
                    for (var i = 0; i < response.length; i++) {
                        var u = response[i].createdBy;
                        if (!usersMap[u]) {
                            usersMap[u] = true;
                            users.push(u);
                        }
                    }

                    var select = document.getElementById("userFilter");
                    select.innerHTML = "";
                    var defaultOpt = document.createElement("option");
                    defaultOpt.value = "All";
                    defaultOpt.text = "All";
                    select.appendChild(defaultOpt);

                    for (var j = 0; j < users.length; j++) {
                        var opt = document.createElement("option");
                        opt.value = users[j];
                        opt.text = users[j];
                        select.appendChild(opt);
                    }


                    showRouteStatus(fullData, selectedUser);
                } else {
                    fullData = [];
                    showRouteStatus([], selectedUser);
                }
            });
        }

        vm.filterRouteStatus = function () {
            selectedUser = document.getElementById("userFilter").value;
            showRouteStatus(fullData, selectedUser);
        };

        function showRouteStatus(dataArray, selectedUser) {
            var svgtemp = d3.select("#sync-chart");
            svgtemp.selectAll("*").remove();

            if (!dataArray || dataArray.length === 0) return;

            var filteredData;
            if (selectedUser === "All") {
                var entityMap = {};
                dataArray.forEach(function (d) {
                    if (!entityMap[d.entityName]) {
                        entityMap[d.entityName] = {
                            entityName: d.entityName,
                            openCount: 0, inProgressCount: 0, failedCount: 0, doneCount: 0
                        };
                    }
                    entityMap[d.entityName].openCount += d.openCount;
                    entityMap[d.entityName].inProgressCount += d.inProgressCount;
                    entityMap[d.entityName].failedCount += d.failedCount;
                    entityMap[d.entityName].doneCount += d.doneCount;
                });
                filteredData = [];
                for (var k in entityMap) {
                    if (entityMap.hasOwnProperty(k)) {
                        filteredData.push(entityMap[k]);
                    }
                }
            } else {
                filteredData = dataArray.filter(function (d) {
                    return d.createdBy === selectedUser;
                });
            }

            var statusKeys = ["Open", "In Progress", "Failed", "Done"];
            var color = d3.scale.ordinal()
                .domain(statusKeys)
                .range(["#FD7A24", "#82eedd", "#f70303ff", "#00e658"]);

            var width = document.getElementById("sync-chart").offsetWidth || 500;
            var height = 300;
            var margin = { top: 40, right: 150, bottom: 80, left: 60 };

            var svg = d3.select("#sync-chart")
                .append("svg")
                .attr("width", width)
                .attr("height", height);

            var chartWidth = width - margin.left - margin.right;
            var chartHeight = height - margin.top - margin.bottom;

            var g = svg.append("g")
                .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

            var maxBarWidth = 100;
            var bandWidth = Math.min(chartWidth / filteredData.length, maxBarWidth);

            var x = d3.scale.ordinal()
                .domain(filteredData.map(function (d) { return d.entityName; }))
                .rangeBands([0, filteredData.length * bandWidth], 0.3);

            var totalChartWidth = filteredData.length * bandWidth;
            svg.attr("width", totalChartWidth + margin.left + margin.right);

            var stackedData = filteredData.map(function (d) {
                var y0 = 0;
                return statusKeys.map(function (key) {
                    var count = 0;
                    if (key === "Open") count = d.openCount;
                    else if (key === "In Progress") count = d.inProgressCount;
                    else if (key === "Failed") count = d.failedCount;
                    else if (key === "Done") count = d.doneCount;
                    var result = { key: key, y0: y0, y1: y0 + count, entityName: d.entityName, count: count };
                    y0 += count;
                    return result;
                });
            });

            var maxCount = d3.max(stackedData, function (d) { return d[d.length - 1].y1; });

            var y = d3.scale.linear()
                .domain([0, maxCount || 1])
                .range([chartHeight, 0]);

            var yAxis = d3.svg.axis().scale(y).orient("left").ticks(5);
            g.append("g").attr("class", "y axis").call(yAxis);

            var tooltip = d3.select("body").append("div")
                .attr("class", "chart-tooltip")
                .style("position", "absolute")
                .style("background", "white")
                .style("border", "1px solid #ccc")
                .style("padding", "6px 8px")
                .style("font-size", "12px")
                .style("border-radius", "4px")
                .style("pointer-events", "none")
                .style("opacity", 0);

            var entityGroups = g.selectAll(".entityGroup")
                .data(stackedData)
                .enter().append("g")
                .attr("transform", function (d) { return "translate(" + x(d[0].entityName) + ",0)"; });

            entityGroups.selectAll("rect")
                .data(function (d) { return d; })
                .enter().append("rect")
                .attr("width", x.rangeBand())
                .attr("y", function (d) { return y(d.y1); })
                .attr("height", function (d) { return y(d.y0) - y(d.y1); })
                .style("fill", function (d) { return color(d.key); })
                .on("mouseover", function (d) {
                    tooltip.transition().duration(200).style("opacity", 0.9);
                    tooltip.html(
                        "<b>" + d.entityName + "</b><br/>" +
                        d.key + ": " + d.count
                    );
                })
                .on("mousemove", function () {
                    tooltip.style("left", (d3.event.pageX + 10) + "px")
                        .style("top", (d3.event.pageY - 28) + "px");
                })
                .on("mouseout", function () {
                    tooltip.transition().duration(500).style("opacity", 0);
                });

            // Totals above bars
            entityGroups.append("text")
                .attr("x", x.rangeBand() / 2)
                .attr("y", function (d) { return y(d[d.length - 1].y1) - 5; })
                .attr("text-anchor", "middle")
                .style("font-size", "12px")
                .style("font-weight", "bold")
                .text(function (d) { return d[d.length - 1].y1; });

            // X Axis
            var xAxis = d3.svg.axis().scale(x).orient("bottom");
            g.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + chartHeight + ")")
                .call(xAxis)
                .selectAll("text")
                .style("text-anchor", "end")
                .attr("dx", "-0.8em")
                .attr("dy", "0.15em")
                .attr("transform", "rotate(-40)");

            // Legend
            var legend = g.selectAll(".legend")
                .data(statusKeys)
                .enter().append("g")
                .attr("class", "legend")
                .attr("transform", function (d, i) { return "translate(0," + i * 20 + ")"; });

            legend.append("rect")
                .attr("x", totalChartWidth + 20)
                .attr("width", 14)
                .attr("height", 14)
                .style("fill", color);

            legend.append("text")
                .attr("x", totalChartWidth + 40)
                .attr("y", 7)
                .attr("dy", ".35em")
                .style("font-size", "12px")
                .text(function (d) { return d; });
        }
        vm.showStatistics = false;

        vm.toggleStatistics = function () {
            vm.showStatistics = !vm.showStatistics;
            if (vm.showStatistics) {
                getRouteStatus();
            }
        };

vm.taskResponse=[]
vm.getRouteTask=function(){
    routeDetail.getTask(vm.trRoute.id,function(response){
        vm.taskResponse=response
    })
}
    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrRouteDeleteController',TrRouteDeleteController);

    TrRouteDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrRoute','$scope'];

    function TrRouteDeleteController($uibModalInstance, entity, TrRoute,$scope) {
        var vm = this;

        vm.trRoute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrRoute.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-route', {
                parent: 'app',
                url: '/tr-route',
                data: {
                    authorities: ['ROUTE_SIDEBAR'],
                    pageTitle: 'trakeyeApp.route.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route/tr-routes.html',
                        controller: 'TrRouteController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trRoute');
                        $translatePartialLoader.addPart('routeStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-route-detail', {
                parent: 'tr-route',
                url: '/tr-route/{id}',
                data: {
                    authorities: ['ROUTE_DETAIL'],
                    pageTitle: 'trakeyeApp.route.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route/tr-route-detail.html',
                        controller: 'TrRouteDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trRoute');
                        $translatePartialLoader.addPart('routeStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {
                        return TrRoute.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-route',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-route.priority', {
                parent: 'tr-route',
                url: '/tr-routes/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.route.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route/tr-routes.html',
                        controller: 'TrRouteController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trRoute');
                        $translatePartialLoader.addPart('routeStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-route.attendance', {
                parent: 'tr-route',
                url: '/tr-routes/attendance/{login}/{fromTime}/{toTime}/{routeStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.route.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route/tr-routes.html',
                        controller: 'TrRouteController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            routeStatus: $stateParams.routeStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trRoute');
                        $translatePartialLoader.addPart('routeStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-route.new', {
                parent: 'tr-route',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}',
                data: {
                    authorities: ['ROUTE_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route/tr-route-dialog.html',
                        controller: 'TrRouteDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            routeImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })

        .state('tr-route.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-route/tr-route-work-flow.html',
                    controller: 'TrRouteWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        routeImages: []
                    };
                }]
            }
        })

        .state('tr-route.import', {
                parent: 'tr-route',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route/tr-route-import.html',
                        controller: 'TrRouteImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            routeImages: []
                        };
                    }
                }

            })
            .state('tr-route.edit', {
                parent: 'tr-route',
                url: '/Edit/{id}',
                data: {
                    authorities: ['ROUTE_EDIT'],
                    pageTitle: 'trakeyeApp.route.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route/tr-route-dialog.html',
                        controller: 'TrRouteDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {
                        return TrRoute.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-route',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-route.delete', {
                parent: 'tr-route',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-route/tr-route-delete-dialog.html',
                        controller: 'TrRouteDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrRoute', function (TrRoute) {
                                return TrRoute.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-route', null, { reload: 'tr-route' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-route.fibercore', {
                parent: 'tr-route',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route/tr-route-fiber-core.html',
                        controller: 'TrRouteFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            routeImages: []
                        };
                    }
                }

            })

            .state('show-hide-route', {
                parent: 'report',
                url: '/show-hide-route',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-route/show-hide-route.html',
                        controller: 'ShowHideRouteController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrRoute', TrRoute);

	TrRoute.$inject = ['$resource', 'DateUtils'];

	function TrRoute($resource, DateUtils) {
		var resourceUrl = 'api/tr-routes/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('RouteByID', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-routes/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteListByProjectId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-routes-list-by-projectid/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.routeBundleByProjectId = function (id, callback) {
			$http.get('api/tr-routes-bundle-list-by-projectid/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.routesByRouteBundleId = function (id, callback) {
			$http.get('api/tr-routes-list-by-route-bundle-id/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteGeofence', TrRouteGeofence);

	TrRouteGeofence.$inject = ['$resource'];

	function TrRouteGeofence($resource) {
		var service = $resource('/api/tr-routes/geofence/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteCustomTime', TrRouteCustomTime);

	TrRouteCustomTime.$inject = ['$resource'];

	function TrRouteCustomTime($resource) {
		var service = $resource('/api/tr-routes-custom/:fromDate/:toDate', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteGeofenceCustomTime', TrRouteGeofenceCustomTime);

	TrRouteGeofenceCustomTime.$inject = ['$resource'];

	function TrRouteGeofenceCustomTime($resource) {
		var service = $resource('/api/tr-routes-custom/geofence/:geofenceId/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrRouteCheckAsset', TrRouteCheckAsset);

	TrRouteCheckAsset.$inject = ['$resource', 'DateUtils'];

	function TrRouteCheckAsset($resource, DateUtils) {
		var resourceUrl = 'api/assets/search/:name';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
		});
	}
})();


(function () {
	'use strict';
	angular.module('trakeyeApp').factory('RoutesForAsset', RoutesForAsset);

	RoutesForAsset.$inject = ['$resource'];

	function RoutesForAsset($resource) {
		var resourceUrl = 'api/routes-for-asset/:assetId';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-routes/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getRouteImage', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/trakeyerouteimages/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getNearbyFixed', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, data, callback) {
			$http.post('api/assets/nearby-fixed/' + id, data).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteAssetsById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-routes-assets/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('RouteAttributeMappingId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/custom-route-type-mapper/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

/*
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteById', TrRouteById);

	TrRouteById.$inject = [ '$resource' ];

	function TrRouteById($resource) {
		var service = $resource('/api/tr-routes/:id', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();*/

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteCountByGroup', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/routecountbygroup').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadRouteReports', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-routes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteCountByStatus', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/routecountbystatus').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRoutePriority', TrRoutePriority);

	TrRoutePriority.$inject = ['$resource'];

	function TrRoutePriority($resource) {
		var service = $resource('/api/tr-routes/priority/:priority/:geofenceId', {
			priority: '@priorirty'
		}, { geofenceId: '@geofenceId' }, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteAttendance', TrRouteAttendance);

	TrRouteAttendance.$inject = ['$resource'];

	function TrRouteAttendance($resource) {
		var service = $resource('/api/tr-routes/attendance/:login/:fromTime/:toTime/:routeStatus',
			{}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteSearch', TrRouteSearch);

	TrRouteSearch.$inject = ['$resource'];

	function TrRouteSearch($resource) {
		var service = $resource('/api/tr-routes/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('RoutePathById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-routes-path/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteListIdName', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (callback) {
			$http.get('api/tr-routes-list').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteSearchCustom', TrRouteSearchCustom);

	TrRouteSearchCustom.$inject = ['$resource'];

	function TrRouteSearchCustom($resource) {
		var service = $resource('/api/tr-routes-custom/searchvalue/:search/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteGeofenceSearch', TrRouteGeofenceSearch);

	TrRouteGeofenceSearch.$inject = ['$resource'];

	function TrRouteGeofenceSearch($resource) {
		var service = $resource('/api/tr-routes/geofence-searchvalue/:geofenceId/:search', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteGeofenceSearchCustom', TrRouteGeofenceSearchCustom);

	TrRouteGeofenceSearchCustom.$inject = ['$resource'];

	function TrRouteGeofenceSearchCustom($resource) {
		var service = $resource('/api/tr-routes-custom/geofence-searchvalue/:geofenceId/:search/:fromDate/:toDate', {}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrRouteGroup', TrRouteGroup);

	TrRouteGroup.$inject = ['$resource', 'DateUtils'];

	function TrRouteGroup($resource, DateUtils) {
		var resourceUrl = 'api/tr-routes-group';

		return $resource(resourceUrl, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteGroupSearch', TrRouteGroupSearch);

	TrRouteGroupSearch.$inject = ['$resource'];

	function TrRouteGroupSearch($resource) {
		var service = $resource('/api/tr-routes-group/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteGroupPrioritySearch', TrRouteGroupPrioritySearch);

	TrRouteGroupPrioritySearch.$inject = ['$resource'];

	function TrRouteGroupPrioritySearch($resource) {
		var service = $resource('/api/tr-routes-group/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteGroupPriority', TrRouteGroupPriority);

	TrRouteGroupPriority.$inject = ['$resource'];

	function TrRouteGroupPriority($resource) {
		var service = $resource('/api/tr-routes-group/priority/:priority', {
			priority: '@priorirty'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteImages', TrRouteImages);

	TrRouteImages.$inject = ['$resource'];

	function TrRouteImages($resource) {
		var service = $resource('/api/route-images/:routeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRoutesForType', TrRoutesForType);

	TrRoutesForType.$inject = ['$resource'];

	function TrRoutesForType($resource) {
		var service = $resource('/api/trroutesbytype/:routeTypeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}

})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('NearByBGOH', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (data, success, error) {
			$http.post('api/tr-routes/nearby-bgoh-assets', data).then(function (response) {
				success(response.data);
			}, function (response) {
				error(response.status);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteRecordings', TrRouteRecordings);

	TrRouteRecordings.$inject = ['$resource'];

	function TrRouteRecordings($resource) {
		var service = $resource('/api/route-recordings/:routeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllRouteTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/route-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRoutePrioritySearch', TrRoutePrioritySearch);

	TrRoutePrioritySearch.$inject = ['$resource'];

	function TrRoutePrioritySearch($resource) {
		var service = $resource('/api/tr-routes/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrRouteUpdateGroup', TrRouteUpdateGroup);

	TrRouteUpdateGroup.$inject = ['$resource'];

	function TrRouteUpdateGroup($resource) {
		var resourceUrl = 'api/tr-routes/groups';

		return $resource(resourceUrl, {}, {
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrRouteBulkDelete', TrRouteBulkDelete);

	TrRouteBulkDelete.$inject = ['$resource'];

	function TrRouteBulkDelete($resource) {
		var resourceUrl = 'api/tr-routes/bulk/delete';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('KmlToCoordinates', KmlToCoordinates);

	KmlToCoordinates.$inject = ['$http'];

	function KmlToCoordinates($http) {

		var service = {};
		service.getLatLng = function (data, callback) {

			$http.post('api/kmltocoordinates', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {
				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteUser', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.gettrroutesuser = function (callback) {
			$http.get('api/tr-routes/live-logs').then(function (response) {
				callback(response.data);
			});
		};

		service.gettrroutesuserbyid = function (id, callback) {
			$http.get('api/tr-routes/live-logs/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.searchtrroutesuserbyvalue = function (id, callback) {
			$http.get('api/tr-routes/search/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.gettrroutesanduserbypriority = function (priority, callback) {
			$http.get('api/tr-routes/live-logs/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		service.getAgents = function (callback) {
			$http.get('api/dashboard/agentdashboard').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteEdit', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getalltrroutes = function (callback) {
			$http.get('api/tr-allroutes').then(function (response) {
				callback(response.data);
			});
		};

		service.edittrroute = function (data, callback) {
			$http.post('api/tr-routeedit/' + data.userId + '/' + data.routeId, {

			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {

				callback(error, error.headers);
			});

			/*
			 * $http.post('api/tr-routeedit/'+data.userId+'/'+data.routeId).then(function(response){
			 * callback(response.data); });
			 */
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrRouteUpload', TrRouteUpload);

	TrRouteUpload.$inject = ['$http'];

	function TrRouteUpload($http) {

		var service = {};
		service.trrouteupload = function (data, callback) {

			$http.post('api/routeimport', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupRouteSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrrouteformap = function (search, callback) {
			$http.get('api/tr-grouproutesformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupRouteForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllRoutes = function (callback) {
			$http.get('api/tr-grouproutesformap').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrrouteformap = function (search, callback) {
			$http.get('api/tr-routesformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};

		service.prioritysearchtrrouteformap = function (priority, callback) {
			$http.get('api/tr-routesformap/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('TrRouteLastLocation', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			service.getlastlogs = function (callback) {
				$http.get('api/location-logs/lastuserpath').then(function (response) {
					callback(response.data);
				});
			};
			return service;
		}]);



})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('RoutesForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.routesformapbyadmin = function (adminid, callback) {
			$http.get('api/tr-routesformap/' + adminid).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrRouteForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllRoutes = function (data, callback) {
			// $http.get('api/tr-routesformap').then(function (response) {
			// 	callback(response.data);
			// });
			$http.post('api/tr-routesformap', data).then(function (response) {
				callback(response.data);
			});
		};

		service.getTerrainPathByRoute = function (routeId, callback) {
			$http.get('api/terrain-paths/route/' + routeId).then(function (response) {
				callback(response.data);
			}, function (error) {
				callback(error);
			});
		};

		service.getRoWPathByRoute = function (routeId, callback) {
			$http.get('api/row-paths/route/' + routeId).then(function (response) {
				callback(response.data);
			});
		};

		service.getTerrainByRoute = function (routeId, callback) {
			$http.get('api/tr-terrains-id-name-by-route-id/' + routeId).then(function (response) {
				callback(response.data);
			}, function (error) {
				callback(error);
			});
		};

		service.getRoWByRoute = function (routeId, callback) {
			$http.get('api/tr-rows-id-name-by-route-id/' + routeId).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ShowRouteById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.update = function (routeid, callback) {
			$http.put('api/show-route/' + routeid)
				.success(function (data, status, headers, config) {
					callback(status);
				})
				.error(function (data, status, header, config) {
					callback(status);
				});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('HideRouteById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.update = function (routeid, callback) {
			$http.put('api/hide-route/' + routeid)
				.success(function (data, status, headers, config) {
					callback(status);
				})
				.error(function (data, status, header, config) {
					callback(status);
				});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('routeDetail', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};

		//Section
		service.getSection = function (routeId, callback) {
			$http.get('api/tr-sections/route/' + routeId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};


		//Tasks
		service.getTask = function (routeId, callback) {
			$http.get('api/tr-tasks/route/' + routeId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};
		service.taskBySection = function (id, callback) {
			$http.get('api/tr-tasks-by-section-list/' + id).then(function (response) {
				callback(response.data);
			})
		};

		//Section
		service.getRoutesDetails = function (routeId, callback) {
			$http.get('api/tr-routes/detail/' + routeId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};

		service.postSectionsDetails = function (payload, callback) {
			$http.post('api/tr-sections/detail', payload)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};

		service.getRingsByRoute = function (routeId, callback) {
			$http.get('api/ringslength-route/' + routeId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};

		service.getSectionByRouteIdAssetId = function (routeId, assetId, callback) {
			$http.get('api/sectionslength-route/' + routeId + '/' + assetId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};

		service.getAssetsBySections = function (sectionId, callback) {
			$http.get('api/spread-details-section/' + sectionId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};
		service.updateRingName = function (routeBundleId,ringId,ringName, callback) {
			$http.put('api/update-ring-name-byRouteId/' + routeBundleId +'/'+ringId+'/'+ringName)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};
		
		service.getNewAssetLengthByRouteBundleId = function (RouteBundleId, callback) {
				$http.get('api/routeBundle/newAssetLength/' + RouteBundleId)
					.success(function (response) {
						callback(response);
					})
					.error(function (err) {
						callback(err);
					});
			};
			
			service.getexistingUnusedLengthByRouteBundleId = function (RouteBundleId, callback) {
							$http.get('api/routeBundle/existingUnused/' + RouteBundleId)
								.success(function (response) {
									callback(response);
								})
								.error(function (err) {
									callback(err);
								});
						};
			service.getexistingUsedLengthByRouteBundleId = function (RouteBundleId, callback) {
					$http.get('api/routeBundle/existingUsed/' + RouteBundleId)
						.success(function (response) {
							callback(response);
						})
							.error(function (err) {
							callback(err);
						});
			};
			service.saveBulkRoutePoints = function (routePointData, callback) {
								$http.post('api/save-bulk-routepoints',routePointData)
									.success(function (response) {
										callback(response);
									})
										.error(function (err) {
										callback(err);
									});
						};	
						service.removeBulkRoutePoints = function (routePointData, callback) {
								$http.post('api/remove-bulk-routepoints',routePointData)
									.success(function (response) {
										callback(response);
									})
										.error(function (err) {
										callback(err);
									});
						};	
		service.getFixedAssetsByRouteId = function (routeId, callback) {
					$http.get('api/fixed-detailsByRouteId/' + routeId)
						.success(function (response) {
							callback(response);
						})
						.error(function (err) {
							callback(err);
						});
				};
		
		service.removeAssetFromRing = function (routeId,assetId, callback) {
				$http.delete('api/removeAseetsFromRing/' + routeId+'/'+assetId)
					.success(function (response) {
						callback(response);
					})
					.error(function (err) {
						callback(err);
					});
			};
			service.addAseetsToExistingRing = function (routeId,assetId, callback) {
					$http.put('api/addAseetsToExistingRing/' + routeId+'/'+assetId)
						.success(function (response) {
							callback(response);
						})
						.error(function (err) {
							callback(err);
						});
				};

		service.getAssetsCount = function (routeId, callback) {
			$http.get('api/asset-count-route/' + routeId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};
		service.getAllAssetsByRouteId = function (routeId, callback) {
				$http.get('api/allAssetsByRouteId/' + routeId)
					.success(function (response) {
						callback(response);
					})
					.error(function (err) {
						callback(err);
					});
			};
			
				service.getTerrainPathByTerrainId = function (terrainId, callback) {
				$http.get('api/tr-terrains-path/' + terrainId)
					.success(function (response) {
						callback(response);
					})
					.error(function (err) {
						callback(err);
					});
			};
		
		service.getAssetsById = function (routeId, lastId, callback) {
			$http.get('api/assets-route-db/' + routeId + '/' + lastId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};

		service.getRouteById = function (routeId, callback) {
			$http.get('api/tr-routes/' + routeId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};
		
		service.saveEditedRoutepoints = function (payload, callback) {
			$http.put('api/update-bulk-routepoints', payload)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('imageRoutePoint', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};

		//Section
		/* service.getCenterLatLng = function (routeId,latitude,longitude,callback) {
			$http.get('api/routepoints/'+routeId+'/'+latitude+'/'+longitude)
			.success(function (response) {
				callback(response);
			})
			.error(function (err) {
				callback(err);
			});
		}; */

		service.postCenterLatLng = function (routeId, payload, callback) {
			$http.post('api/routepoints/' + routeId, payload)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};

		service.getImagesList = function (routePointId, callback) {
			$http.get('api/routepoint-images/' + routePointId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};

		service.openImage = function (routePointId, imgid, callback) {
			$http.get('api/routepoint-images/' + routePointId + '/' + imgid)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};

		service.getUserTaskLogImages = function (logId, callback) {
			$http.get('api/rollout/user-task-log-images/' + logId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};

		/* service.openLogImage = function (logId,imgId,callback) {
			$http.get('api/rollout/user-task-log-images/'+logId+'/'+imgId)
			.success(function (response) {
				callback(response);
			})
			.error(function (err) {
				callback(err);
			});
		}; */
		service.getRouteMarkerDetails = function (markerId, callback) {
			$http.get('api/routepointDetailById/' + markerId)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};
		service.updateRouteMarkerAttributs = function (payload, callback) {
			$http.put('api/update-marker-routepoints',payload)
				.success(function (response) {
					callback(response);
				})
				.error(function (err) {
					callback(err);
				});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TaskRouteById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-routes-path/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('dailyLogByTaskId', dailyLogByTaskId);

	dailyLogByTaskId.$inject = ['$resource'];

	function dailyLogByTaskId($resource) {
		var resourceUrl = 'api/rollout/get-daily-task-logs/:id/type/OBSTACLE'

		return $resource(resourceUrl, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('dailyLog', dailyLog);

	dailyLog.$inject = ['$resource', 'DateUtils'];

	function dailyLog($resource, DateUtils) {
		var resourceUrl = 'api/rollout/get-daily-task-logs/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('taskComment', ['$http', function ($http) {

		var service = {};

		service.getTaskLogsPaths = function (taskId, callback) {
			$http.get('api/rollout/daily-task-log-path/task/' + taskId).then(function (response) {
				callback(response.data);
			}).catch(function (err) {
				callback(err)
			});

		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('RouteImageMeta', ['$http', function ($http) {

		var service = {};

		service.getData = function (routePointId, callback) {
			$http.get('api/routepoints/image/meta/' + routePointId).then(function (response) {
				callback(response.data);
			}).catch(function (err) {
				callback(err)
			});

		};
		return service;
	}]);
})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('RingGeofence', ['$http', function ($http) {
		var service = {};
		service.getGeofence = function (ringId, callback) {
			$http.get('api/geofences/ring/' + ringId).then(function (response) {
				callback(response.data);
			}).catch(function (err) {
				callback(err)
			});

		};
		return service;
	}]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('FileUploadService', ['$http', '$timeout', function ($http, $timeout) {
        var service = {};
        var MAX_RETRIES = 3;
        var RETRY_DELAY_MS = 3000;
        var retryCounts = {};

        service.uploadFile = function (file, routePointId, fileType,finalFileName, callback) {
            var fileKey = file.name + "_" + file.size;
            var currentRetryCount = retryCounts[fileKey] || 0;

            if (currentRetryCount >= MAX_RETRIES) {
                console.error("Max retries reached for file upload:", file.name);
                callback(false);
                return;
            }

            var CHUNK_SIZE = (fileType.toUpperCase() === "MP4") ? (2 * 1024 * 1024) : (1 * 1024 * 1024);
            var totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            var chunkNumber = 0;

            function uploadNextChunk() {
                var start = chunkNumber * CHUNK_SIZE;
                var end = Math.min(start + CHUNK_SIZE, file.size);
                var isLastChunk = (chunkNumber === totalChunks - 1);

                var chunkBlob = file.slice(start, end);
                var formData = new FormData();
                formData.append("file", chunkBlob, file.name);

                var uploadUrl =
                    "api/routepoints/uploadFiles/" +
                    routePointId + "/" +
                    chunkNumber + "/" +
                    totalChunks + "/" +
                    isLastChunk + "/" +
                    fileType + "/" +
                    encodeURIComponent(finalFileName);

                $http.post(uploadUrl, formData, { headers: { 'Content-Type': undefined } })
                    .then(function () {
                        chunkNumber++;
                        if (chunkNumber < totalChunks) {
                            uploadNextChunk();
                        } else {
                            delete retryCounts[fileKey];
                            callback(true);
                        }
                    })
                    .catch(function (error) {
                        console.error("Error uploading chunk", chunkNumber, file.name, error);
                        if (error.status === 0 && currentRetryCount < MAX_RETRIES) {
                            console.warn("Retrying chunk", chunkNumber, "... Attempt:", currentRetryCount + 1);
                            retryCounts[fileKey] = currentRetryCount + 1;
                            $timeout(uploadNextChunk, RETRY_DELAY_MS);
                        } else {
                            callback(false);
                        }
                    });
            }

            uploadNextChunk();
        };

        return service;
    }]);
})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('RouteStatus', ['$http', function ($http) {
		var service = {};
		service.getRouteStatus = function (ringId, callback) {
			$http.get('api/tr-data-synch/route/' + ringId).then(function (response) {
				callback(response.data);
			}).catch(function (err) {
				callback(err)
			});

		};
		return service;
	}]);
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrRouteController", TrRouteController);

    TrRouteController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$compile",
        "TrRoute",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "TrRouteSearch"
    ];

    function TrRouteController(
        $scope,
        $rootScope,
        $state,
        $compile,
        TrRoute,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        TrRouteSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var searchVal = $scope.search.replace(/[^\w\s]/g, '_');
                TrRouteSearch.query(
                    {
                        search: searchVal,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.routes = [];
                    data.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.routes.push(value);
                    });
                    vm.page = pagingParams.page;
                }
    
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            TrRoute.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.routes = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.routes.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ){
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal,
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrResourceDialogController", TrResourceDialogController);

    TrResourceDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrResource",
        "AllResourceTypes",
        "AllCustomResourceTypeAttribute",
        "ResourceAttributeMappingId"
    ];

    function TrResourceDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrResource,
        AllResourceTypes,
        AllCustomResourceTypeAttribute,
        ResourceAttributeMappingId
    ) {
        var vm = this;
        vm.trResource = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trResource);
        vm.selectAttributes = selectedResourceTypeAttributes;
        vm.resourceType = entity.resourceType;
        
		vm.customAttributesMap = {};
		vm.customAttributesMapp = [];
        loadPage();


        if (vm.trResource.id != null) {
            vm.trResourceType = vm.trResource.resourceType;
        }

        function loadPage() {

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                        img +
                        '">'
                );
                imgWindow.document.close();
            };

            var resourceTypeAttributeValuesList =
                vm.trResource.resourceTypeAttributeValues;

            try {
                for (var index in vm.trResource.resourceType.resourceTypeAttribute) {
                    if (
                        !checkIfResourceTypeExists(
                            vm.trResource.resourceType.resourceTypeAttribute[index],
                            vm.trResource.resourceTypeAttributeValues
                        )
                    ) {
                        var resourceTypeAttribute1 =
                            vm.trResource.resourceType.resourceTypeAttribute[index];
                        resourceTypeAttributeValuesList.push({
                            resourceTypeAttribute: resourceTypeAttribute1,
                            attributeValue:
                                vm.trResource.resourceType.resourceTypeAttribute[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) {}

            function checkIfResourceTypeExists(resourceType, resourceTypeAttrVal) {
                var hasResourceType = false;
                for (var i = 0; i < resourceTypeAttrVal.length; i++) {
                    var name = resourceTypeAttrVal[i].resourceTypeAttribute.name;
                    if (name == resourceType.name) {
                        hasResourceType = true;
                        break;
                    }
                }
                return hasResourceType;
            }
            AllResourceTypes.getAll(function (response) {
                vm.resourceTypes = response;
            });

            AllCustomResourceTypeAttribute.getAll(function (response) {
                //vm.customResourceTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if(arrayItem.customResourceTypeAttributeValues != undefined){
                        vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customResourceTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }
                  
                });
                if (vm.trResource.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });
            
            
        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function selectedResourceTypeAttributes() {
            vm.showFilter = true;
            if (vm.resourceType) {
                vm.trResource.resourceType = vm.resourceType;
                if (
                    entity_old.resourceType &&
                    vm.resourceType.id === entity_old.resourceType.id
                ) {
                    vm.trResource.resourceTypeAttributeValues = [];
                    vm.trResource.resourceTypeAttributeValues =
                        entity_old.resourceTypeAttributeValues;
                } else {
                    vm.trResource.resourceTypeAttributeValues = [];
                    $.each(
                        vm.resourceType.resourceTypeAttribute,
                        function (key, value) {
                            vm.trResource.resourceTypeAttributeValues.push({
                                resourceTypeAttribute:
                                    vm.resourceType.resourceTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        function save() {
            vm.isSaving = true;
            var spreadAV = vm.trResource.resourceTypeAttributeValues;
            for (
                var spreadAssetIndex = 0;
                spreadAssetIndex < spreadAV.length;
                spreadAssetIndex++
            ) {
                if (
                    spreadAV[spreadAssetIndex].resourceTypeAttribute
                        .name === "Fiber Distance (km)"
                ) {
                    spreadAV[
                        spreadAssetIndex
                    ].attributeValue = fiberDistance;
                }
            }
            vm.trResource.resourceTypeAttributeValues = spreadAV;
                
            if (vm.trResource.id !== null) {
                TrResource.update(vm.trResource, onSaveSuccess, onSaveError);
            } else {
                TrResource.save(vm.trResource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:resourceUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "user-management.new") {
                $state.go("user-management.new");
            } else {
                $state.go("tr-resource");
            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        $('.select2').select2();
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrResourceDetailController', TrResourceDetailController);

    TrResourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrResource', 'User', 'ResourceType', 'TrResourceImages', 'TrResourceRecordings','AlertService','$window','$localStorage','getResourceImage','Configs'];

    function TrResourceDetailController($scope, $rootScope, $stateParams, previousState, entity, TrResource, User, ResourceType,TrResourceImages,TrResourceRecordings,AlertService, $window,$localStorage,getResourceImage,Configs) {
		var vm = this;
		
        vm.trResource = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        var unsubscribe = $rootScope.$on('trakeyeApp:trResourceUpdate', function(event, result) {
            vm.trResource = result;
        });
		vm.showResourceAttachment = false

		Configs.get("ResourceImage",function(response){
            if(response.length > 0){
				if(response[0].configValue == "True"){
					vm.showResourceAttachment = true
				}
			}
        })
		
        vm.imageInNewTab = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
            );
            imgWindow.document.close(); 
		};

		$scope.newTabDisplay = function(id){
            var request = new XMLHttpRequest();
            request.open('GET',"api/trakeyeresourceimages/"+vm.trResource.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                window.open(imageUrl, "_blank")}
            } 
            request.send();
        } 

        $scope.$on('$destroy', unsubscribe);
        
          $scope.go_back = function() { 
        	  $window.history.back();
        	};
        
        $scope.allimages = false;
//		$scope

		$scope.toggle = function(id) {
			switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrResourceImages.query(
                            {
                                resourceId: vm.trResource.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.resourceImages = data.filter(function(resourceImages){
                                return resourceImages.image
                             });
                        
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getResourceImage.get(vm.trResource.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }


			
			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/resource_"+vm.trResource.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrResourceImages.query({
					resourceId : vm.trResource.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.resourceImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

//		$scope.playAudio = function() {
////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/resource_"+vm.trResource.id+".mp3";
//            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/resource_15570572.mp3";
//	        var audio = new Audio(urlStr);
//	        audio.play();
//	    };
		
		
        function decodeImage(img){
     	   return window.atob(img);
        }
       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrResourceDeleteController',TrResourceDeleteController);

    TrResourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrResource','$scope'];

    function TrResourceDeleteController($uibModalInstance, entity, TrResource,$scope) {
        var vm = this;

        vm.trResource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrResource.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-resource', {
                parent: 'app',
                url: '/tr-resource',
                data: {
                    authorities: ['RESOURCE_SIDEBAR'],                    
                    pageTitle: 'trakeyeApp.resource.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-resource/tr-resources.html',
                        controller: 'TrResourceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trResource');
                        $translatePartialLoader.addPart('resourceStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-resource-detail', {
                parent: 'tr-resource',
                url: '/tr-resource/{id}',
                data: {
                    authorities: ['RESOURCE_DETAIL'],
                    pageTitle: 'trakeyeApp.resource.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-resource/tr-resource-detail.html',
                        controller: 'TrResourceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trResource');
                        $translatePartialLoader.addPart('resourceStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrResource', function ($stateParams, TrResource) {
                        return TrResource.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-resource',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-resource.priority', {
                parent: 'tr-resource',
                url: '/tr-resources/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.resource.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-resource/tr-resources.html',
                        controller: 'TrResourceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trResource');
                        $translatePartialLoader.addPart('resourceStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-resource.attendance', {
                parent: 'tr-resource',
                url: '/tr-resources/attendance/{login}/{fromTime}/{toTime}/{resourceStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.resource.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-resource/tr-resources.html',
                        controller: 'TrResourceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            resourceStatus: $stateParams.resourceStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trResource');
                        $translatePartialLoader.addPart('resourceStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-resource.new', {
                parent: 'tr-resource',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}',
                data: {
                    authorities: ['RESOURCE_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-resource/tr-resource-dialog.html',
                        controller: 'TrResourceDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            resourceImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })

        .state('tr-resource.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-resource/tr-resource-work-flow.html',
                    controller: 'TrResourceWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        resourceImages: []
                    };
                }]
            }
        })

        .state('tr-resource.import', {
                parent: 'tr-resource',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-resource/tr-resource-import.html',
                        controller: 'TrResourceImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            resourceImages: []
                        };
                    }
                }

            })
            .state('tr-resource.edit', {
                parent: 'tr-resource',
                url: '/Edit/{id}',
                data: {
                    authorities: ['RESOURCE_EDIT'],
                    pageTitle: 'trakeyeApp.resource.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-resource/tr-resource-dialog.html',
                        controller: 'TrResourceDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrResource', function ($stateParams, TrResource) {
                        return TrResource.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-resource',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-resource.delete', {
                parent: 'tr-resource',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-resource/tr-resource-delete-dialog.html',
                        controller: 'TrResourceDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrResource', function (TrResource) {
                                return TrResource.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-resource', null, { reload: 'tr-resource' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-resource.fibercore', {
                parent: 'tr-resource',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-resource/tr-resource-fiber-core.html',
                        controller: 'TrResourceFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            resourceImages: []
                        };
                    }
                }

            })

            .state('show-hide-resource', {
                parent: 'report',
                url: '/show-hide-resource',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-resource/show-hide-resource.html',
                        controller: 'ShowHideResourceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrResource', TrResource);

	TrResource.$inject = ['$resource', 'DateUtils'];

	function TrResource($resource, DateUtils) {
		var resourceUrl = 'api/tr-resources/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceGeofence', TrResourceGeofence);

	TrResourceGeofence.$inject = ['$resource'];

	function TrResourceGeofence($resource) {
		var service = $resource('/api/tr-resources/geofence/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceCustomTime', TrResourceCustomTime);

	TrResourceCustomTime.$inject = ['$resource'];

	function TrResourceCustomTime($resource) {
		var service = $resource('/api/tr-resources-custom/:fromDate/:toDate', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceGeofenceCustomTime', TrResourceGeofenceCustomTime);

	TrResourceGeofenceCustomTime.$inject = ['$resource'];

	function TrResourceGeofenceCustomTime($resource) {
		var service = $resource('/api/tr-resources-custom/geofence/:geofenceId/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrResourceCheckAsset', TrResourceCheckAsset);

	TrResourceCheckAsset.$inject = ['$resource', 'DateUtils'];

	function TrResourceCheckAsset($resource, DateUtils) {
		var resourceUrl = 'api/assets/search/:name';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
		});
	}
})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ResourcesForAsset', ResourcesForAsset);

    ResourcesForAsset.$inject = ['$resource'];

    function ResourcesForAsset($resource) {
        var resourceUrl = 'api/resources-for-asset/:assetId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-resources/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getResourceImage', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/trakeyeresourceimages/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getNearbyFixed', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id,data,callback) {
			$http.post('api/assets/nearby-fixed/' + id,data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceAssetsById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-resources-assets/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ResourceAttributeMappingId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/custom-resource-type-mapper/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

/*
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceById', TrResourceById);

	TrResourceById.$inject = [ '$resource' ];

	function TrResourceById($resource) {
		var service = $resource('/api/tr-resources/:id', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();*/

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceCountByGroup', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/resourcecountbygroup').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadResourceReports', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-resources').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceCountByStatus', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/resourcecountbystatus').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourcePriority', TrResourcePriority);

	TrResourcePriority.$inject = ['$resource'];

	function TrResourcePriority($resource) {
		var service = $resource('/api/tr-resources/priority/:priority/:geofenceId', {
			priority: '@priorirty'
		}, {geofenceId : '@geofenceId'},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceAttendance', TrResourceAttendance);

	TrResourceAttendance.$inject = ['$resource'];

	function TrResourceAttendance($resource) {
		var service = $resource('/api/tr-resources/attendance/:login/:fromTime/:toTime/:resourceStatus',
			{}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceSearch', TrResourceSearch);

	TrResourceSearch.$inject = ['$resource'];

	function TrResourceSearch($resource) {
		var service = $resource('/api/tr-resources/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceSearchCustom', TrResourceSearchCustom);

	TrResourceSearchCustom.$inject = ['$resource'];

	function TrResourceSearchCustom($resource) {
		var service = $resource('/api/tr-resources-custom/searchvalue/:search/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceGeofenceSearch', TrResourceGeofenceSearch);

	TrResourceGeofenceSearch.$inject = ['$resource'];

	function TrResourceGeofenceSearch($resource) {
		var service = $resource('/api/tr-resources/geofence-searchvalue/:geofenceId/:search', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceGeofenceSearchCustom', TrResourceGeofenceSearchCustom);

	TrResourceGeofenceSearchCustom.$inject = ['$resource'];

	function TrResourceGeofenceSearchCustom($resource) {
		var service = $resource('/api/tr-resources-custom/geofence-searchvalue/:geofenceId/:search/:fromDate/:toDate', {}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrResourceGroup', TrResourceGroup);

	TrResourceGroup.$inject = ['$resource', 'DateUtils'];

	function TrResourceGroup($resource, DateUtils) {
		var resourceUrl = 'api/tr-resources-group';

		return $resource(resourceUrl, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceGroupSearch', TrResourceGroupSearch);

	TrResourceGroupSearch.$inject = ['$resource'];

	function TrResourceGroupSearch($resource) {
		var service = $resource('/api/tr-resources-group/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceGroupPrioritySearch', TrResourceGroupPrioritySearch);

	TrResourceGroupPrioritySearch.$inject = ['$resource'];

	function TrResourceGroupPrioritySearch($resource) {
		var service = $resource('/api/tr-resources-group/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceGroupPriority', TrResourceGroupPriority);

	TrResourceGroupPriority.$inject = ['$resource'];

	function TrResourceGroupPriority($resource) {
		var service = $resource('/api/tr-resources-group/priority/:priority', {
			priority: '@priorirty'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceImages', TrResourceImages);

	TrResourceImages.$inject = ['$resource'];

	function TrResourceImages($resource) {
		var service = $resource('/api/resource-images/:resourceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourcesForType', TrResourcesForType);

	TrResourcesForType.$inject = ['$resource'];

	function TrResourcesForType($resource) {
		var service = $resource('/api/trresourcesbytype/:resourceTypeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}

})();
 (function () {
	'use strict';

	angular.module('trakeyeApp').factory('NearByBGOH', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (data,success,error) {
			$http.post('api/tr-resources/nearby-bgoh-assets',data).then(function (response) {
				success(response.data);
			},function (response) {
				error(response.status);
			});
		};

		return service;
	}]);
})();  

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceRecordings', TrResourceRecordings);

	TrResourceRecordings.$inject = ['$resource'];

	function TrResourceRecordings($resource) {
		var service = $resource('/api/resource-recordings/:resourceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllResourceTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/resource-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourcePrioritySearch', TrResourcePrioritySearch);

	TrResourcePrioritySearch.$inject = ['$resource'];

	function TrResourcePrioritySearch($resource) {
		var service = $resource('/api/tr-resources/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrResourceUpdateGroup', TrResourceUpdateGroup);

	TrResourceUpdateGroup.$inject = ['$resource'];

	function TrResourceUpdateGroup($resource) {
		var resourceUrl = 'api/tr-resources/groups';

		return $resource(resourceUrl, {}, {
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrResourceBulkDelete', TrResourceBulkDelete);

	TrResourceBulkDelete.$inject = ['$resource'];

	function TrResourceBulkDelete($resource) {
		var resourceUrl = 'api/tr-resources/bulk/delete';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceUser', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.gettrresourcesuser = function (callback) {
			$http.get('api/tr-resources/live-logs').then(function (response) {
				callback(response.data);
			});
		};

		service.gettrresourcesuserbyid = function (id, callback) {
			$http.get('api/tr-resources/live-logs/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.searchtrresourcesuserbyvalue = function (id, callback) {
			$http.get('api/tr-resources/search/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.gettrresourcesanduserbypriority = function (priority, callback) {
			$http.get('api/tr-resources/live-logs/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		service.getAgents = function (callback) {
			$http.get('api/dashboard/agentdashboard').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceEdit', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getalltrresources = function (callback) {
			$http.get('api/tr-allresources').then(function (response) {
				callback(response.data);
			});
		};

		service.edittrresource = function (data, callback) {
			$http.post('api/tr-resourceedit/' + data.userId + '/' + data.resourceId, {

			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {

				callback(error, error.headers);
			});

			/*
			 * $http.post('api/tr-resourceedit/'+data.userId+'/'+data.resourceId).then(function(response){
			 * callback(response.data); });
			 */
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrResourceUpload', TrResourceUpload);

	TrResourceUpload.$inject = ['$http'];

	function TrResourceUpload($http) {

		var service = {};
		service.trresourceupload = function (data, callback) {

			$http.post('api/resourceimport', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupResourceSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrresourceformap = function (search, callback) {
			$http.get('api/tr-groupresourcesformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupResourceForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllResources = function (callback) {
			$http.get('api/tr-groupresourcesformap').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrresourceformap = function (search, callback) {
			$http.get('api/tr-resourcesformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};

		service.prioritysearchtrresourceformap = function (priority, callback) {
			$http.get('api/tr-resourcesformap/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('TrResourceLastLocation', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			service.getlastlogs = function (callback) {
				$http.get('api/location-logs/lastuserpath').then(function (response) {
					callback(response.data);
				});
			};
			return service;
		}]);



})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ResourcesForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.resourcesformapbyadmin = function (adminid, callback) {
			$http.get('api/tr-resourcesformap/' + adminid).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrResourceForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllResources = function (data, callback) {
			// $http.get('api/tr-resourcesformap').then(function (response) {
			// 	callback(response.data);
			// });
			$http.post('api/tr-resourcesformap', data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ShowResourceById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (resourceid, callback) {
            $http.put('api/show-resource/' + resourceid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('HideResourceById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (resourceid, callback) {
            $http.put('api/hide-resource/' + resourceid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ResourceInventory', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};


		service.getResourceTxnsDates = function (id, type, callback) {
			$http.get('api/resourcedates-by-entity/' + type + '/' + id).then(function (response) {
				callback(response.data)
			})
		}
		service.getResouceTxnsByDate = function (id, type, date, callback) {
			$http.get('api/resources-by-entity-date/' + type + '/' + id + '/date/' + date).then(function (response) {
				callback(response.data)
			})
		}


		return service;
	}]);
})();

(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('ResourceByDates', ResourceByDates)
		.factory('ResourceDates', ResourceDates);

		
		ResourceDates.$inject = ["$resource"];

	function ResourceDates($resource) {
		var resourceUrl = "api/resourcedates-by-entity/:type/:id";

		return $resource(
			resourceUrl,
			{ type: '@type', id: '@id' },
			{
				query: {
					method: "GET",
					isArray: true
				}
			}
		);
	}

	ResourceByDates.$inject = ["$resource", "DateUtils"];

	function ResourceByDates($resource, DateUtils) {
		var resourceUrl = "api/resources-by-entity-date/:type/:id/date/:date";

		return $resource(
			resourceUrl,
			{ type: '@type', id: '@id', date: '@date' },
			{
				query: {
					method: "GET",
					isArray: true,
				},
				get: {
					method: "GET",
					transformResponse: function (data) {
						if (data) {
							data = angular.fromJson(data);
						}
						console.log(data);
						return data;
					},
				}
			}
		);
	}

	
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrResourceController", TrResourceController);

    TrResourceController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$compile",
        "TrResource",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "TrResourceSearch"
    ];

    function TrResourceController(
        $scope,
        $rootScope,
        $state,
        $compile,
        TrResource,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        TrResourceSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var searchVal = $scope.search.replace(/[^\w\s]/g, '_');
                TrResourceSearch.query(
                    {
                        search: searchVal,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.resources = [];
                    data.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.resources.push(value);
                    });
                    vm.page = pagingParams.page;
                }
    
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            TrResource.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.resources = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.resources.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                //  result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ){
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal,
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrProjectDialogController", TrProjectDialogController);

    TrProjectDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrProject",
        "AllProjectTypes",
        "AllCustomProjectTypeAttribute",
        "ProjectAttributeMappingId",
        "Configs",
        "pagingParams",
        "AlertService",
        "ParseLinks",
        "$rootScope"
    ];

    function TrProjectDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrProject,
        AllProjectTypes,
        AllCustomProjectTypeAttribute,
        ProjectAttributeMappingId,
        Configs,
        pagingParams,
        AlertService,
        ParseLinks,
        $rootScope
    ) {
        var vm = this;
        vm.trProject = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trProject);
        vm.selectAttributes = selectedProjectTypeAttributes;
        vm.projectType = entity.projectType;
        vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.calculateToDate = calculateToDate;
        vm.calculateFromDate = calculateFromDate;
        var locations = {};
        var marker
        var markersStore = []
        var today = new Date();
        
        function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}
        
		vm.customAttributesMap = {};
		vm.customAttributesMapp = [];
        loadPage();
        if(!vm.trProject.id){
            vm.trProject.status = "NEW"
            //vm.trProject.phase = "PLANNING"
            vm.trProject.ragStatus = "GREEN"
            vm.isSaving = true
        }

        function loadPage() {
            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                        img +
                        '">'
                );
                imgWindow.document.close();
            };

            var projectTypeAttributeValuesList =
                vm.trProject.projectTypeAttributeValues;

            try {
                for (var index in vm.trProject.projectType.projectTypeAttribute) {
                    if (
                        !checkIfProjectTypeExists(
                            vm.trProject.projectType.projectTypeAttribute[index],
                            vm.trProject.projectTypeAttributeValues
                        )
                    ) {
                        var projectTypeAttribute1 =
                            vm.trProject.projectType.projectTypeAttribute[index];
                        projectTypeAttributeValuesList.push({
                            projectTypeAttribute: projectTypeAttribute1,
                            attributeValue:
                                vm.trProject.projectType.projectTypeAttribute[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) {}

            function checkIfProjectTypeExists(projectType, projectTypeAttrVal) {
                var hasProjectType = false;
                for (var i = 0; i < projectTypeAttrVal.length; i++) {
                    var name = projectTypeAttrVal[i].projectTypeAttribute.name;
                    if (name == projectType.name) {
                        hasProjectType = true;
                        break;
                    }
                }
                return hasProjectType;
            }

            AllProjectTypes.getAll(function (response) {
                vm.projectTypes = response;
            });

            AllCustomProjectTypeAttribute.getAll(function (response) {
                //vm.customProjectTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if(arrayItem.customProjectTypeAttributeValues != undefined){
                        vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customProjectTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }
                  
                });
                if (vm.trProject.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });
            
            
        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function selectedProjectTypeAttributes() {
            vm.showFilter = true;
            if (vm.projectType) {
                vm.trProject.projectType = vm.projectType;
                if (
                    entity_old.projectType &&
                    vm.projectType.id === entity_old.projectType.id
                ) {
                    vm.trProject.projectTypeAttributeValues = [];
                    vm.trProject.projectTypeAttributeValues =
                        entity_old.projectTypeAttributeValues;
                } else {
                    vm.trProject.projectTypeAttributeValues = [];
                    $.each(
                        vm.projectType.projectTypeAttribute,
                        function (key, value) {
                            vm.trProject.projectTypeAttributeValues.push({
                                projectTypeAttribute:
                                    vm.projectType.projectTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        function save() {
            //vm.isSaving = true;
            /* var spreadAV = vm.trProject.projectTypeAttributeValues;
            for (
                var spreadAssetIndex = 0;
                spreadAssetIndex < spreadAV.length;
                spreadAssetIndex++
            ) {
                if (
                    spreadAV[spreadAssetIndex].projectTypeAttribute
                        .name === "Fiber Distance (km)"
                ) {
                    spreadAV[
                        spreadAssetIndex
                    ].attributeValue = fiberDistance;
                }
            }
            vm.trProject.projectTypeAttributeValues = spreadAV; */
                
            if (vm.trProject.id !== null) {
                TrProject.update(vm.trProject, onSaveSuccess, onSaveError);
            } else {
                TrProject.save(vm.trProject, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:projectUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "user-management.new") {
                $state.go("user-management.new");
            } else {
                $state.go("tr-project");
            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }


       /*  Configs.get("WorkFlowStatus", function (response) {
            vm.workFlowStatus=[];
            var workFlowStatusList = response[0].configValue.split(",");
            workFlowStatusList.forEach(function(value){
                if(value.length > 0){
                    vm.workFlowStatus.push({"configKey":value,"configValue":value});
                }
            });
            //console.log(vm.workFlowStatus);
        }); */

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = response;
            //vm.workFlow.phase = "Planning Phase"
            /*  if(vm.workFlow.id == null){
                response.forEach(function(val){
                    if(val.configValue == '01'){
                        vm.workFlow.phase = val.configKey
                    }
                })
            }*/
        });

        Configs.get("RolloutTaskStatus", function (response) {
            vm.rolloutTaskStatus = response;
        });

       /*  vm.trProject.routes = []
        vm.selectEntity = function(route){
            if(route.isChecked){
                vm.trProject.routes.push(route)
            }
        }

        if(vm.trProject.id){
            if(vm.trProject.routes){
                    vm.trProject.routes.forEach(function(trEach){
                        vm.routes.filter(function (each){
                            if(trEach.id == each.id){
                                each.isChecked = true
                            }
                    })
                })
            }
        } */

       
        today.setHours(23, 59, 59);
        vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar; 
        $scope.optionsTo = {
			maxDate: today.setDate(today.getDate())
		};
        $scope.optionsFrom = {
			maxDate: today.setDate(today.getDate())
		};
        function openCalendar(date) {
             vm.datePickerOpenStatus[date] = true;
        }
        function calculateFromDate() {
            $scope.optionsTo = {
                minDate: vm.startDate.setDate(vm.startDate.getDate()),
                maxDate: today.setDate(today.getDate())
            };
            vm.startDate.setHours(0, 0, 0, 0);
            vm.trProject.startDate = vm.startDate.getTime();
        }

        function calculateToDate() {
            $scope.optionsFrom = {
                maxDate: vm.endDate.setDate(vm.endDate.getDate())
            };
            vm.endDate.setHours(23, 59, 59, 999);
            vm.trProject.endDate = vm.endDate.getTime();
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        locations.map = new google.maps.Map(
            document.getElementById("map_canvas"),
            {
                center: {
                    lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                    lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                },
                zoom: 13,
                fullscreenControl: true,
                styles: mapStyles(),
            }
            //myOption(16, vm.getCenterEnd)
        );

        locations.map.addListener("click", function(event) {
            if (markersStore.length < 1) {
                // Add a marker to the map
                addMarker(event.latLng);

                // Get the latitude and longitude of the clicked point
                vm.trProject.latitude = event.latLng.lat();
                vm.trProject.longitude = event.latLng.lng();
            } else {
                console.log("Maximum 1 marker allowed.");
            }
        });

        function addMarker(location) {
            // Create a marker
             marker = new google.maps.Marker({
                position: location,
                map: locations.map
            });
            
            // Add the marker to the markers array
            markersStore.push(marker);
            var myButton = document.getElementById('disableBtn');
            myButton.disabled = false;
        }

        vm.removeMarker = function() {
            markersStore.forEach(function(marker) {
                marker.setMap(null);
              });
              
              // Clear the markers array
            markersStore.length = 0

            var myButton = document.getElementById('disableBtn');
            myButton.disabled = true;
        } 

        if (vm.trProject.id != null) {
            vm.trProjectType = vm.trProject.projectType;

            if(vm.trProject.startDate != null && vm.trProject.endDate != null){
                vm.startDate = new Date(vm.trProject.startDate)
                vm.endDate = new Date(vm.trProject.endDate)
            }
            
            if(vm.trProject.latitude != null && vm.trProject.longitude != null){
                locations.map.setCenter({lat:vm.trProject.latitude,lng:vm.trProject.longitude});
                addMarker({lat:vm.trProject.latitude,lng:vm.trProject.longitude})
            }
           
        }

        vm.colorcode = function (str){
            vm.trProject.ragStatus = str
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrProjectDetailController', TrProjectDetailController);

    TrProjectDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrProject', 'User', 'ProjectType', 'TrProjectImages', 'TrProjectRecordings', 'AlertService', '$window', '$localStorage', 'getProjectImage', 'Configs', 'SummaryPost', 'TrRouteListByProjectId', 'TerrainType', 'TaskType', 'TaskLogProjectReportData', 'taskConfiguration', 'RowType', 'MaterialDates', 'MaterialByDates', 'ParseLinks','BaseUrl'];

    function TrProjectDetailController($scope, $rootScope, $stateParams, previousState, entity, TrProject, User, ProjectType, TrProjectImages, TrProjectRecordings, AlertService, $window, $localStorage, getProjectImage, Configs, SummaryPost, TrRouteListByProjectId, TerrainType, TaskType, TaskLogProjectReportData, taskConfiguration, RowType, MaterialDates, MaterialByDates, ParseLinks,BaseUrl) {
        var vm = this;

        vm.trProject = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        vm.showTaskLogReport = showTaskLogReport;
		vm.downloadProjectSurveyExcel = downloadProjectSurveyExcel;
        var unsubscribe = $rootScope.$on('trakeyeApp:trProjectUpdate', function (event, result) {
            vm.trProject = result;
        });
        vm.showProjectAttachment = false
        var locations = {}

        Configs.get("ProjectImage", function (response) {
            if (response.length > 0) {
                if (response[0].configValue == "True") {
                    vm.showProjectAttachment = true
                }
            }
        })

        vm.imageInNewTab = function (img) {
            var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                img +
                '">'
            );
            imgWindow.document.close();
        };

        $scope.newTabDisplay = function (id) {
            var request = new XMLHttpRequest();
            request.open('GET', "api/trakeyeprojectimages/" + vm.trProject.id + "/" + id, true);
            request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;

            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    window.open(imageUrl, "_blank")
                }
            }
            request.send();
        }

        $scope.$on('$destroy', unsubscribe);

        $scope.go_back = function () {
            $window.history.back();
        };

        $scope.allimages = false;
        //		$scope

        $scope.toggle = function (id) {
            switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrProjectImages.query(
                            {
                                projectId: vm.trProject.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.projectImages = data.filter(function (projectImages) {
                                return projectImages.image
                            });

                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getProjectImage.get(vm.trProject.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }



			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/project_"+vm.trProject.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrProjectImages.query({
					projectId : vm.trProject.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.projectImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

        //		$scope.playAudio = function() {
        ////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/project_"+vm.trProject.id+".mp3";
        //            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/project_15570572.mp3";
        //	        var audio = new Audio(urlStr);
        //	        audio.play();
        //	    };


        function decodeImage(img) {
            return window.atob(img);
        }

        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };


        $scope.setTab = function (newTab) {


            if (newTab == 2) {
                //Comment Box
                vm.objectComments = {}
                vm.objectComments.entityId = entity.id
                vm.objectComments.entityName = "PROJECT"
            }



            if (newTab == 8) {
                vm.existingMap = []
                vm.existingMapRow = []

                taskConfiguration.getTerrainConfiguration(vm.trProject.id, function (data) {
                    vm.existingMap = data

                    $scope.groupedData = {};

                    // Group data based on tree
                    data.forEach(function (item) {
                        var treeName = item.terrainType.name;
                        if (!$scope.groupedData[treeName]) {
                            $scope.groupedData[treeName] = [];
                        }
                        $scope.groupedData[treeName].push(item.taskType.name);
                    });
                    //console.log($scope.groupedData)
                    /*  if(data.length){
                         data.forEach(function(item){

                             if(item.terrainType.id)
                             vm.existingMap.push({terrain:item.terrainType,task:item.taskType})
                         })
                     } */
                })

                taskConfiguration.getRoWConfiguration(vm.trProject.id, function (data) {
                    vm.existingMapRow = data

                    $scope.groupedDataRow = {};

                    // Group data based on tree
                    data.forEach(function (item) {
                        var treeName = item.rowType.name;
                        if (!$scope.groupedDataRow[treeName]) {
                            $scope.groupedDataRow[treeName] = [];
                        }
                        $scope.groupedDataRow[treeName].push(item.taskType.name);
                    });
                })
                vm.selectedTerrain = null
                vm.mappedTypes = []
                vm.selectedRow = null
                vm.mappedTypesRow = []

                TerrainType.query({
                    page: 0,
                    size: 100,
                    sort: 'update_date,desc'
                }, function onSuccess(data, headers) {
                    vm.terrainTypes = data;
                }, onError);

                TaskType.query({
                    page: 0,
                    size: vm.itemsPerPage,
                    sort: 'update_date,desc'
                }, function onSuccess(data, headers) {
                    vm.taskTypes = data;
                    vm.taskTypesRow = data
                }, onError);

                RowType.query({
                    page: 0,
                    size: 100,
                    sort: 'update_date,desc'
                }, function onSuccess(data, headers) {
                    vm.rowTypes = data;
                }, onError);
            }

            if (newTab == 3) {
                if (vm.dailyLogsTxSummary.routeTasks.length) {
                    $scope.tab = 4;
                    showTaskLogReport(vm.trProject.id);
                } else if (vm.dailyLogsTxSummary.sectionTasks.length) {
                    $scope.tab = 7;
                    showTaskLogReport(vm.trProject.id);
                }
            }

            $scope.tab = newTab;


        }

        SummaryPost.dailyLogsTx({
            "projectIds": [vm.trProject.id]
        }, function (response) {
            vm.dailyLogsTxSummary = response
        })

        SummaryPost.mtrlTx({
            "projectIds": [vm.trProject.id]
        }, function (response) {
            vm.mtrlTxSummary = response
        })

        SummaryPost.resTx({
            "projectIds": [vm.trProject.id]
        }, function (response) {
            vm.resTxSummary = response
        })



        function onError(error) {
            AlertService.error(error.data.message);
        }

        $scope.terrain = {
            taskType: {
                search: "Search",
                nothingSelected: "Select Task Type",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            }
        };

        $scope.row = {
            taskType: {
                search: "Search",
                nothingSelected: "Select Task Type",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            }
        };


        vm.clickSection = function (str) {

            if (str == 'terrain') {
                if (vm.mappedTypes.length) {
                    vm.mappedTypes.forEach(function (item, index) {
                        if (item.terrain.id == vm.selectedTerrain.id) {
                            vm.mappedTypes.splice(index, 1)
                        }
                    })
                    vm.mappedTypes.push({ terrain: vm.selectedTerrain, task: vm.selectedTaskType })
                } else {
                    vm.mappedTypes.push({ terrain: vm.selectedTerrain, task: vm.selectedTaskType })

                }
            }

            if (str == 'row') {
                if (vm.mappedTypesRow.length) {
                    vm.mappedTypesRow.forEach(function (item, index) {
                        if (item.row.id == vm.selectedRoW.id) {
                            vm.mappedTypesRow.splice(index, 1)
                        }
                    })
                    vm.mappedTypesRow.push({ row: vm.selectedRoW, task: vm.selectedTaskTypeRow })
                } else {
                    vm.mappedTypesRow.push({ row: vm.selectedRoW, task: vm.selectedTaskTypeRow })

                }
            }

        }

        vm.terrainChange = function () {
            vm.taskTypes.forEach(function (t) {
                t.ticked = false
            })

            vm.mappedTypes.forEach(function (item) {
                if (item.terrain.id == vm.selectedTerrain.id) {
                    item.task.forEach(function (e) {
                        vm.taskTypes.forEach(function (t) {
                            if (e.id == t.id) {
                                t.ticked = true
                            }
                        })
                    })
                }
            })
        }
        $scope.deleteMap = function (id, str) {

            if (str == 'row') {
                vm.mappedTypesRow.splice(id, 1)
                $('#selectRow').val(null).trigger('change.select2');


                vm.taskTypesRow.forEach(function (t) {
                    t.selected = false
                })
            }

            if (str == 'terrain') {
                vm.mappedTypes.splice(id, 1)
                $('#selectedTerrain').val(null).trigger('change.select2');
                vm.taskTypes.forEach(function (t) {
                    t.ticked = false
                })
            }

        }
        $(".select2").select2();

        function createMetaTag(attrName, attrValue, content) {
            var meta = document.createElement('meta');
            meta.setAttribute(attrName, attrValue);
            meta.setAttribute('content', content);
            return meta;
        }

        function createTable(classNames) {
            var table = document.createElement('table');
            table.setAttribute('border', '1');
            table.setAttribute('cellpadding', '5');
            table.setAttribute('cellspacing', '0');
            table.setAttribute('id', 'sheet0');
            table.setAttribute('class', classNames);
            return table;
        }

        function createTableCell(tagName, textContent) {
            var cell = document.createElement(tagName);
            cell.textContent = textContent;
            return cell;
        }

        function showTaskLogReport(projectId) {
            vm.isReportGenerated = false;
            TaskLogProjectReportData.query(
                {
                    reportType: "daily",
                    projectId: projectId
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                var htmlDoc = document.createElement('html');
                var head = document.createElement('head');
                var meta1 = createMetaTag('http-equiv', 'Content-Type', 'text/html; charset=utf-8');
                var meta2 = createMetaTag('name', 'generator', 'PhpSpreadsheet, https://github.com/PHPOffice/PhpSpreadsheet');
                var meta3 = createMetaTag('name', 'author', 'Apache POI');
                var meta4 = createMetaTag('name', 'company', 'Microsoft Corporation');
                head.appendChild(meta1);
                head.appendChild(meta2);
                head.appendChild(meta3);
                head.appendChild(meta4);
                var body = document.createElement('body');
                var table = createTable('sheet0 gridlines');
                var thead = document.createElement('thead');
                var tbody = document.createElement('tbody');

                function createTable(classNames) {
                    var table = document.createElement('table');
                    table.setAttribute('border', '1');
                    table.setAttribute('cellpadding', '5');
                    table.setAttribute('cellspacing', '0');
                    table.setAttribute('id', 'sheet0');
                    table.setAttribute('class', classNames);
                    return table;
                }

                function createMetaTag(attrName, attrValue, content) {
                    var meta = document.createElement('meta');
                    meta.setAttribute(attrName, attrValue);
                    meta.setAttribute('content', content);
                    return meta;
                }

                function createTableCell(tag, content) {
                    var cell = document.createElement(tag);
                    cell.textContent = content;
                    cell.style.fontSize = "13px";
                    return cell;
                }

                thead.className = 'thReport';
                table.appendChild(thead);
                tbody.className = 'tdReport';
                table.appendChild(tbody);
                var styleElement = document.createElement('style');
                styleElement.textContent = "\
                .subheader {\
                    margin: auto;\
                }\
                .thReport > tr > th{\
                    text-align: center;\
                    padding: 10px;\
                }\
                .tdReport > tr > td {\
                    text-align: center; \
                    padding: 10px;\
                }\
                ";
                document.head.appendChild(styleElement);

                var colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2',];
                function getRandomColor() {
                    if (colors.length === 0) {
                        colors = ['#d6d5c9', '#ff9b85', '#ffcccc', '#ccccff', '#fae588', '#b0f2b4', '#abd3ff', '#d0b17a', '#eacdc2'];
                    }
                    var index = Math.floor(Math.random() * colors.length);
                    var color = colors[index];
                    colors.splice(index, 1);
                    return color;
                }


                var groupedData = {};
                data.forEach(function (item) {
                    if (!groupedData[item.date]) {
                        groupedData[item.date] = [];
                    }
                    groupedData[item.date].push(item);
                });
                var names = getUniqueNames(data);
                var nameHeaderRow = document.createElement('tr');
                var serialNumberHeader = createTableCell('th', 'S.No');
                serialNumberHeader.style.fontWeight = 'bold';
                serialNumberHeader.style.backgroundColor = '#7dcfb6';
                serialNumberHeader.rowSpan = 2;
                nameHeaderRow.appendChild(serialNumberHeader);
                var dateHeader = createTableCell('th', 'Date');
                dateHeader.style.backgroundColor = '#7dcfb6';
                dateHeader.style.fontWeight = 'bold';
                dateHeader.rowSpan = 2;
                nameHeaderRow.appendChild(dateHeader);
                var typeHeaderRow = document.createElement('tr');

                names.forEach(function (name, index) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    var availableTypes = getUniqueTypes(nameData);
                    var nameHeaderCell = createTableCell('th', name);
                    nameHeaderCell.style.backgroundColor = getRandomColor();
                    nameHeaderCell.style.fontWeight = 'bold';
                    nameHeaderCell.colSpan = availableTypes.length;
                    nameHeaderRow.appendChild(nameHeaderCell);
                    availableTypes.forEach(function (type) {
                        var typeHeaderCell = createTableCell('th', type);
                        typeHeaderCell.style.backgroundColor = nameHeaderCell.style.backgroundColor;
                        typeHeaderCell.style.fontWeight = 'bold';
                        typeHeaderRow.appendChild(typeHeaderCell);
                    });
                });
                var totalProgressHeader = createTableCell('th', 'Total Progress');
                totalProgressHeader.style.backgroundColor = '#cfe0c3';
                totalProgressHeader.style.fontWeight = 'bold';
                totalProgressHeader.colSpan = 3;
                nameHeaderRow.appendChild(totalProgressHeader);
                var subHeaders = [
                    {
                        type: 'Total',
                    },
                    {
                        type: "Ducting",
                    }, {
                        type: "Validation",

                    }
                ];
                subHeaders.forEach(function (subHeader) {
                    var subHeaderCell = createTableCell('th', subHeader.type);
                    subHeaderCell.style.backgroundColor = '#cfe0c3';
                    subHeaderCell.style.fontWeight = 'bold';
                    typeHeaderRow.appendChild(subHeaderCell);
                });
                thead.appendChild(nameHeaderRow);
                thead.appendChild(typeHeaderRow);
                var totals = {};

                Object.keys(groupedData)
                    .sort(function (a, b) {
                        var dateA = a.split('-').reverse().join('-');
                        var dateB = b.split('-').reverse().join('-');
                        return new Date(dateA) - new Date(dateB);
                    })
                    .forEach(function (date, index) {
                        var totalLength = 0;
                        var totalValidation = 0;
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name && item.date === date; });
                            var ductingLength = 0;
                            var hddLength = 0;
                            var horizontalDirectionalDrilling = 0
                            var validationLength = 0;
                            nameData.forEach(function (item) {
                                if (item.type === 'Ducting') {
                                    ductingLength += item.length;
                                }
                                else if (item.type === 'HDD') {
                                    hddLength += item.length;

                                }
                                else if (item.type === 'HDD ( Horizontal Directional Drilling )') {
                                    horizontalDirectionalDrilling += item.length;
                                    console.log(horizontalDirectionalDrilling)
                                }
                                else if (item.type === 'Validation' || item.type === 'Validation (T&D)') {
                                    validationLength += item.length;
                                }
                            });
                            console.log(totalLength)
                            totalLength += (ductingLength + hddLength + horizontalDirectionalDrilling);
                            totalValidation += validationLength;

                        });
                        var tr = document.createElement('tr');
                        var serialNumberCell = createTableCell('td', index + 1);
                        serialNumberCell.style.fontSize = "13px";
                        tr.appendChild(serialNumberCell);
                        var dateCell = createTableCell('td', date);
                        dateCell.style.width = '77px'
                        dateCell.style.whiteSpace = 'nowrap';
                        dateCell.style.fontSize = "13px";
                        tr.appendChild(dateCell);
                        names.forEach(function (name) {
                            var nameData = data.filter(function (item) { return item.name === name; });
                            var availableTypes = getUniqueTypes(nameData);

                            availableTypes.forEach(function (type) {
                                var item = groupedData[date].find(function (item) {
                                    return item.name === name && item.type === type;
                                });
                                var lengthValue = item ? item.length : 0;
                                var td = createTableCell('td', lengthValue);

                                tr.appendChild(td);
                                if (!totals[type]) {
                                    totals[type] = 0;
                                }
                                totals[type] += lengthValue;
                            });
                        });
                        var total = 0;
                        for (var i = 2; i < tr.cells.length; i++) {
                            total += parseInt(tr.cells[i].textContent);
                        }
                        var columnValueCell = createTableCell('td', total);
                        columnValueCell.colSpan = 1;
                        tr.appendChild(columnValueCell);
                        var remainingDuctingCell = createTableCell('td', totalLength);
                        tr.appendChild(remainingDuctingCell);
                        var remainingValidationCell = createTableCell('td', totalValidation);
                        tr.appendChild(remainingValidationCell);
                        if (index === 0) {
                            totals['Total Progress Ducting'] = 0;
                            totals['Total Progress Validation'] = 0;
                        }
                        totals['Total Progress Ducting'] += totalLength;
                        totals['Total Progress Validation'] += totalValidation;
                        tbody.appendChild(tr);
                    });

                var staticColumns = ['Total', 'Balance Validation', 'Balance Ducting'];
                var allAvailableTypes = [];
                names.forEach(function (name) {
                    var nameData = data.filter(function (item) { return item.name === name; });
                    allAvailableTypes.push.apply(allAvailableTypes, getUniqueTypes(nameData));
                });
                var availableTypes = allAvailableTypes;
                var maxUniqueTypesCount = availableTypes.length;
                var totalLength = maxUniqueTypesCount + subHeaders.length;

                var columnTotals = {};
                for (var i = 2; i < totalLength; i++) {
                    var total = 0;
                    for (var j = 0; j < tbody.rows.length; j++) {
                        var cellValue = parseInt(tbody.rows[j].cells[i].textContent) || 0;
                        total += cellValue;
                    }
                    columnTotals[i] = total;
                }
                staticColumns.forEach(function (column) {
                    var staticRow = document.createElement('tr');
                    var columnNameCell = createTableCell('td', column);
                    columnNameCell.colSpan = 2;
                    columnNameCell.style.backgroundColor = '#cfe0c3';
                    columnNameCell.style.fontSize = "13px";
                    columnNameCell.style.fontWeight = 'bold';
                    staticRow.appendChild(columnNameCell);
                    if (column == 'Total') {
                        for (var i = 2; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', columnTotals[i].toString());
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                        var columnValueCell = createTableCell('td', totals['Total Progress Ducting']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                        var columnValueCell = createTableCell('td', totals['Total Progress Validation']);
                        columnValueCell.colSpan = 1;
                        staticRow.appendChild(columnValueCell);
                    } else {
                        for (var i = 0; i < totalLength; i++) {
                            var columnValueCell = createTableCell('td', '0');
                            columnValueCell.colSpan = 1;
                            staticRow.appendChild(columnValueCell);
                        }
                    }
                    tbody.appendChild(staticRow);
                });
                table.appendChild(thead);
                table.appendChild(tbody);
                body.appendChild(table);
                htmlDoc.appendChild(body);
                htmlDoc.appendChild(head);
                var htmlString = htmlDoc.outerHTML;
                var containerDiv = document.getElementById("generatedHtmlContainer");
                containerDiv.innerHTML = htmlString;

                function getUniqueNames(data) {
                    var uniqueNames = [];
                    data.forEach(function (item) {
                        if (uniqueNames.indexOf(item.name) === -1) {
                            uniqueNames.push(item.name);
                        }
                    });
                    return uniqueNames;
                }
                function getUniqueTypes(data) {
                    var uniqueTypes = [];
                    data.forEach(function (item) {
                        if (uniqueTypes.indexOf(item.type) === -1) {
                            uniqueTypes.push(item.type);
                        }
                    });
                    return uniqueTypes;
                }


                // Set background color for specified cells
                var jcbCells = document.querySelectorAll('.row1 .column0'); // Select cells in row 1, column 0 (JCB)
                var hddCells = document.querySelectorAll('.row1 .column1'); // Select cells in row 1, column 1 (HDD)

                // Loop through JCB cells and set background color to light green
                jcbCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Loop through HDD cells and set background color to light green
                hddCells.forEach(function (cell) {
                    cell.style.backgroundColor = 'lightgreen';
                });

                // Get the Total row
                // Select all relevant rows
                var relevantRows = ['.row2', '.row3', '.row5', '.row6'];

                // Loop through each relevant row
                relevantRows.forEach(function (rowClass) {
                    var cells = document.querySelectorAll(rowClass + ' td');

                    // Loop through the cells in the row
                    cells.forEach(function (cell) {
                        // Check if the content of the cell is '0' or empty
                        if (cell.textContent.trim() === '0' || cell.textContent.trim() === '') {
                            // Set background color to white
                            cell.style.backgroundColor = 'white';
                        }
                    });
                });

                vm.isReportGenerated = true;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        vm.submitMap = function (str) {
            var payload = []

            if (str == 'terrain') {
                vm.mappedTypes.forEach(function (item) {
                    item.task.forEach(function (task) {
                        payload.push({
                            "taskType": {
                                "id": task.id
                            },
                            "tenant": {
                                "id": vm.trProject.tenantId
                            },
                            "terrainType": {
                                "id": item.terrain.id
                            },
                            "project": {
                                "id": vm.trProject.id
                            }
                        })
                    })

                })
                taskConfiguration.postTerrainConfiguration(payload, function () {
                    taskConfiguration.getTerrainConfiguration(vm.trProject.id, function (data) {
                        vm.existingMap = data

                        $scope.groupedData = {};

                        // Group data based on tree
                        data.forEach(function (item) {
                            var treeName = item.terrainType.name;
                            if (!$scope.groupedData[treeName]) {
                                $scope.groupedData[treeName] = [];
                            }
                            $scope.groupedData[treeName].push(item.taskType.name);
                        });
                    })
                    // $scope.setTab(8)
                    vm.mappedTypes = []
                    $('#selectedTerrain').val(null).trigger('change.select2');
                    vm.taskTypes.forEach(function (t) {
                        t.ticked = false
                    })
                })
            }

            if (str == 'row') {
                vm.mappedTypesRow.forEach(function (item) {
                    item.task.forEach(function (task) {
                        payload.push({
                            "taskType": {
                                "id": task.id
                            },
                            "tenant": {
                                "id": vm.trProject.tenantId
                            },
                            "rowType": {
                                "id": item.row.id
                            },
                            "project": {
                                "id": vm.trProject.id
                            }
                        })
                    })

                })
                taskConfiguration.postRoWConfiguration(payload, function () {
                    //$scope.setTab(8)

                    taskConfiguration.getRoWConfiguration(vm.trProject.id, function (data) {
                        vm.existingMapRow = data

                        $scope.groupedDataRow = {};

                        // Group data based on tree
                        data.forEach(function (item) {
                            var treeName = item.rowType.name;
                            if (!$scope.groupedDataRow[treeName]) {
                                $scope.groupedDataRow[treeName] = [];
                            }
                            $scope.groupedDataRow[treeName].push(item.taskType.name);
                        });
                    })
                    vm.mappedTypesRow = []
                    $('#selectRow').val(null).trigger('change.select2');


                    vm.taskTypesRow.forEach(function (t) {
                        t.selected = false
                    })
                })
            }

        }

        vm.rowChange = function () {
            vm.taskTypesRow.forEach(function (t) {
                t.selected = false
            })

            vm.mappedTypesRow.forEach(function (item) {
                if (item.row.id == vm.selectedRoW.id) {
                    item.task.forEach(function (e) {
                        vm.taskTypesRow.forEach(function (t) {
                            if (e.id == t.id) {
                                t.selected = true
                            }
                        })
                    })
                }
            })
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        locations.map = new google.maps.Map(
            document.getElementById("map_canvas"),
            {
                center: {
                    lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                    lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                },
                zoom: 13,
                fullscreenControl: true,
                styles: mapStyles(),
            }
            //myOption(16, vm.getCenterEnd)
        );

        if (vm.trProject.latitude != null && vm.trProject.longitude != null) {
            locations.map.setCenter({ lat: vm.trProject.latitude, lng: vm.trProject.longitude });
            addMarker({ lat: vm.trProject.latitude, lng: vm.trProject.longitude })
        }

        function addMarker(location) {
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map
            });
        }
        //TrRouteListByProjectId.get(vm.trProject.id,function(data){})
        vm.page = 1;
        vm.predicate = 'modified_date';
        vm.itemsPerPage = 10;
        vm.mtrpage = 1;
        vm.mtrPerPage = 10;
        vm.materialTxnByDates = [];
        vm.materialByDate = [];
        vm.loadMaterialTxnDate = function () {
            MaterialDates.query({
                type: "project",
                id: entity.id,
                page: vm.mtrpage - 1,
                size: vm.mtrPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.TotalItems = headers('X-Total-Count');
                vm.QueryCount = vm.TotalItems;
                vm.materialByDate = data.map(function (item) {
                    return {
                        timestamp: item[0],
                        total: item[1],
                        isExpand: false
                    };
                });

            });
        };
        vm.loadMaterialTxnDate();
        vm.loadMaterialTxnByDates = function (date) {
            MaterialByDates.query({
                type: 'project',
                id: entity.id,
                date: date,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materialTxnByDates = data.map(function (item) {
                    return {
                        transactionId: item[0],
                        timestamp: item[4],
                        transactionName: item[1],
                        transactionType: item[2],
                        count: item[3],
                        status: item[5],
                    };
                });
            });
        };
        vm.toggleExpand = function (selectedTask) {
            angular.forEach(vm.materialByDate, function (task) {
                if (task === selectedTask) {
                    task.isExpand = !task.isExpand;
                    if (task.isExpand) {
                        vm.loadMaterialTxnByDates(task.timestamp);
                    } else {
                        vm.materialTxnByDates = [];
                    }
                } else {
                    task.isExpand = false;
                }
            });
        };
        vm.transitionMainMateril = function () {
            vm.loadMaterialTxnDate()
        }

		function downloadProjectSurveyExcel() {		
					BaseUrl.getBaseUrl(function (baseurl) {
									var url = "";
									url = baseurl.stringValue + "api/route-survey-reportNew/" + vm.trProject.id + "/" + vm.trProject.name + "/" + vm.trProject.phase;
									console.log("url : "+url);
									var request = new XMLHttpRequest();
									request.open('GET', url, true);
									request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
									request.responseType = 'blob';

									request.onload = function (e) {
										if (this.status === 200) {
											var blob = this.response;
											if (blob.size > 0) {
												if (window.navigator.msSaveOrOpenBlob) {
													window.navigator.msSaveBlob(blob, 'test.xlsx');
												}
												else {
													var downloadLink = window.document.createElement('a');
													var contentTypeHeader = request.getResponseHeader("Content-Type");
													downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
														type: contentTypeHeader
													}));
													downloadLink.download = 'Route-'+vm.trProject.name+'.xlsx';
													document.body.appendChild(downloadLink);
													downloadLink.click();
													document.body.removeChild(downloadLink);
												}
											}
										}
									};
									request.send();
								});
		        }


        vm.downloadSurveyReport = function () {
            BaseUrl.getBaseUrl(function (baseurl) {
                var url = "";
                url = baseurl.stringValue + "api/route-survey-report/" + vm.trProject.id + "/" + vm.trProject.name + "/" + vm.trProject.phase;
                var request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                request.responseType = 'blob';

                request.onload = function (e) {
                    if (this.status === 200) {
                        var blob = this.response;
                        if (blob.size > 0) {
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveBlob(blob, 'test.xlsx');
                            }
                            else {
                                var downloadLink = window.document.createElement('a');
                                var contentTypeHeader = request.getResponseHeader("Content-Type");
                                downloadLink.href = window.URL.createObjectURL(new Blob([blob], {
                                    type: contentTypeHeader
                                }));
                                downloadLink.download = 'Report.xlsx';

                                downloadLink.download = 'SurveyReport.xlsx';

                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                            }
                        }
                    }else if(this.status == 404){alert("No Data Available")}
                };
                request.send();
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrProjectDeleteController',TrProjectDeleteController);

    TrProjectDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrProject','$scope'];

    function TrProjectDeleteController($uibModalInstance, entity, TrProject,$scope) {
        var vm = this;

        vm.trProject = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrProject.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-project', {
                parent: 'app',
                url: '/tr-project',
                data: {
                    authorities: ['PROJECT_SIDEBAR'],            
                    pageTitle: 'trakeyeApp.project.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-projects.html',
                        controller: 'TrProjectController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-project-detail', {
                parent: 'tr-project',
                url: '/tr-project/{id}',
                data: {
                    authorities: ["PROJECT_DETAIL"],
                    pageTitle: 'trakeyeApp.project.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-detail.html',
                        controller: 'TrProjectDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrProject', function ($stateParams, TrProject) {
                        return TrProject.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-project',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-project.priority', {
                parent: 'tr-project',
                url: '/tr-projects/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.project.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-projects.html',
                        controller: 'TrProjectController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-project.attendance', {
                parent: 'tr-project',
                url: '/tr-projects/attendance/{login}/{fromTime}/{toTime}/{projectStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.project.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-projects.html',
                        controller: 'TrProjectController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            projectStatus: $stateParams.projectStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-project.new', {
                parent: 'tr-project',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}',
                data: {
                    authorities: ['PROJECT_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-dialog.html',
                        controller: 'TrProjectDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            projectImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })

        .state('tr-project.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-project/tr-project-work-flow.html',
                    controller: 'TrProjectWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        projectImages: []
                    };
                }]
            }
        })

        .state('tr-project.import', {
                parent: 'tr-project',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-import.html',
                        controller: 'TrProjectImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            projectImages: []
                        };
                    }
                }

            })
            .state('tr-project.edit', {
                parent: 'tr-project',
                url: '/Edit/{id}',
                data: {
                    authorities: ['PROJECT_EDIT'],
                    pageTitle: 'trakeyeApp.project.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-dialog.html',
                        controller: 'TrProjectDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrProject', function ($stateParams, TrProject) {
                        return TrProject.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-project',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-project.delete', {
                parent: 'tr-project',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-project/tr-project-delete-dialog.html',
                        controller: 'TrProjectDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrProject', function (TrProject) {
                                return TrProject.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-project', null, { reload: 'tr-project' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-project.fibercore', {
                parent: 'tr-project',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/tr-project-fiber-core.html',
                        controller: 'TrProjectFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            projectImages: []
                        };
                    }
                }

            })

            .state('show-hide-project', {
                parent: 'report',
                url: '/show-hide-project',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/show-hide-project.html',
                        controller: 'ShowHideProjectController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('project-tree', {
                parent: 'app',
                url: '/project-tree',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_ROLLOUT_ADMIN'],
                    pageTitle: 'trakeyeApp.asset.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-project/project-tree.html',
                        controller: 'ProjectTreeController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trProject');
                        $translatePartialLoader.addPart('projectStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrProject', TrProject);

	TrProject.$inject = ['$resource', 'DateUtils'];

	function TrProject($resource, DateUtils) {
		var resourceUrl = 'api/tr-projects/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ProjectByID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/tr-projects/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectGeofence', TrProjectGeofence);

	TrProjectGeofence.$inject = ['$resource'];

	function TrProjectGeofence($resource) {
		var service = $resource('/api/tr-projects/geofence/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectCustomTime', TrProjectCustomTime);

	TrProjectCustomTime.$inject = ['$resource'];

	function TrProjectCustomTime($resource) {
		var service = $resource('/api/tr-projects-custom/:fromDate/:toDate', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectGeofenceCustomTime', TrProjectGeofenceCustomTime);

	TrProjectGeofenceCustomTime.$inject = ['$resource'];

	function TrProjectGeofenceCustomTime($resource) {
		var service = $resource('/api/tr-projects-custom/geofence/:geofenceId/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrProjectCheckAsset', TrProjectCheckAsset);

	TrProjectCheckAsset.$inject = ['$resource', 'DateUtils'];

	function TrProjectCheckAsset($resource, DateUtils) {
		var resourceUrl = 'api/assets/search/:name';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
		});
	}
})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ProjectsForAsset', ProjectsForAsset);

    ProjectsForAsset.$inject = ['$resource'];

    function ProjectsForAsset($resource) {
        var resourceUrl = 'api/projects-for-asset/:assetId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-projects/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getProjectImage', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/trakeyeprojectimages/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectListIdName', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (callback) {
			$http.get('api/tr-projects-list').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getNearbyFixed', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id,data,callback) {
			$http.post('api/assets/nearby-fixed/' + id,data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectAssetsById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-projects-assets/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ProjectAttributeMappingId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/custom-project-type-mapper/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

/*
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectById', TrProjectById);

	TrProjectById.$inject = [ '$resource' ];

	function TrProjectById($resource) {
		var service = $resource('/api/tr-projects/:id', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();*/

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectCountByGroup', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/projectcountbygroup').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadProjectReports', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-projects').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectCountByStatus', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/projectcountbystatus').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectPriority', TrProjectPriority);

	TrProjectPriority.$inject = ['$resource'];

	function TrProjectPriority($resource) {
		var service = $resource('/api/tr-projects/priority/:priority/:geofenceId', {
			priority: '@priorirty'
		}, {geofenceId : '@geofenceId'},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectAttendance', TrProjectAttendance);

	TrProjectAttendance.$inject = ['$resource'];

	function TrProjectAttendance($resource) {
		var service = $resource('/api/tr-projects/attendance/:login/:fromTime/:toTime/:projectStatus',
			{}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectSearch', TrProjectSearch);

	TrProjectSearch.$inject = ['$resource'];

	function TrProjectSearch($resource) {
		var service = $resource('/api/tr-projects/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectSearchCustom', TrProjectSearchCustom);

	TrProjectSearchCustom.$inject = ['$resource'];

	function TrProjectSearchCustom($resource) {
		var service = $resource('/api/tr-projects-custom/searchvalue/:search/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectGeofenceSearch', TrProjectGeofenceSearch);

	TrProjectGeofenceSearch.$inject = ['$resource'];

	function TrProjectGeofenceSearch($resource) {
		var service = $resource('/api/tr-projects/geofence-searchvalue/:geofenceId/:search', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectGeofenceSearchCustom', TrProjectGeofenceSearchCustom);

	TrProjectGeofenceSearchCustom.$inject = ['$resource'];

	function TrProjectGeofenceSearchCustom($resource) {
		var service = $resource('/api/tr-projects-custom/geofence-searchvalue/:geofenceId/:search/:fromDate/:toDate', {}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrProjectGroup', TrProjectGroup);

	TrProjectGroup.$inject = ['$resource', 'DateUtils'];

	function TrProjectGroup($resource, DateUtils) {
		var resourceUrl = 'api/tr-projects-group';

		return $resource(resourceUrl, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectGroupSearch', TrProjectGroupSearch);

	TrProjectGroupSearch.$inject = ['$resource'];

	function TrProjectGroupSearch($resource) {
		var service = $resource('/api/tr-projects-group/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectGroupPrioritySearch', TrProjectGroupPrioritySearch);

	TrProjectGroupPrioritySearch.$inject = ['$resource'];

	function TrProjectGroupPrioritySearch($resource) {
		var service = $resource('/api/tr-projects-group/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectGroupPriority', TrProjectGroupPriority);

	TrProjectGroupPriority.$inject = ['$resource'];

	function TrProjectGroupPriority($resource) {
		var service = $resource('/api/tr-projects-group/priority/:priority', {
			priority: '@priorirty'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectImages', TrProjectImages);

	TrProjectImages.$inject = ['$resource'];

	function TrProjectImages($resource) {
		var service = $resource('/api/project-images/:projectId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectsForType', TrProjectsForType);

	TrProjectsForType.$inject = ['$resource'];

	function TrProjectsForType($resource) {
		var service = $resource('/api/trprojectsbytype/:projectTypeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}

})();
 (function () {
	'use strict';

	angular.module('trakeyeApp').factory('NearByBGOH', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (data,success,error) {
			$http.post('api/tr-projects/nearby-bgoh-assets',data).then(function (response) {
				success(response.data);
			},function (response) {
				error(response.status);
			});
		};

		return service;
	}]);
})();  

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectRecordings', TrProjectRecordings);

	TrProjectRecordings.$inject = ['$resource'];

	function TrProjectRecordings($resource) {
		var service = $resource('/api/project-recordings/:projectId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllProjectTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/project-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectPrioritySearch', TrProjectPrioritySearch);

	TrProjectPrioritySearch.$inject = ['$resource'];

	function TrProjectPrioritySearch($resource) {
		var service = $resource('/api/tr-projects/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrProjectUpdateGroup', TrProjectUpdateGroup);

	TrProjectUpdateGroup.$inject = ['$resource'];

	function TrProjectUpdateGroup($resource) {
		var resourceUrl = 'api/tr-projects/groups';

		return $resource(resourceUrl, {}, {
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrProjectBulkDelete', TrProjectBulkDelete);

	TrProjectBulkDelete.$inject = ['$resource'];

	function TrProjectBulkDelete($resource) {
		var resourceUrl = 'api/tr-projects/bulk/delete';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectUser', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.gettrprojectsuser = function (callback) {
			$http.get('api/tr-projects/live-logs').then(function (response) {
				callback(response.data);
			});
		};

		service.gettrprojectsuserbyid = function (id, callback) {
			$http.get('api/tr-projects/live-logs/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.searchtrprojectsuserbyvalue = function (id, callback) {
			$http.get('api/tr-projects/search/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.gettrprojectsanduserbypriority = function (priority, callback) {
			$http.get('api/tr-projects/live-logs/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		service.getAgents = function (callback) {
			$http.get('api/dashboard/agentdashboard').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectEdit', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getalltrprojects = function (callback) {
			$http.get('api/tr-allprojects').then(function (response) {
				callback(response.data);
			});
		};

		service.edittrproject = function (data, callback) {
			$http.post('api/tr-projectedit/' + data.userId + '/' + data.projectId, {

			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {

				callback(error, error.headers);
			});

			/*
			 * $http.post('api/tr-projectedit/'+data.userId+'/'+data.projectId).then(function(response){
			 * callback(response.data); });
			 */
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrProjectUpload', TrProjectUpload);

	TrProjectUpload.$inject = ['$http'];

	function TrProjectUpload($http) {

		var service = {};
		service.trprojectupload = function (data, callback) {

			$http.post('api/projectimport', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupProjectSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrprojectformap = function (search, callback) {
			$http.get('api/tr-groupprojectsformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupProjectForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllProjects = function (callback) {
			$http.get('api/tr-groupprojectsformap').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrprojectformap = function (search, callback) {
			$http.get('api/tr-projectsformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};

		service.prioritysearchtrprojectformap = function (priority, callback) {
			$http.get('api/tr-projectsformap/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('TrProjectLastLocation', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			service.getlastlogs = function (callback) {
				$http.get('api/location-logs/lastuserpath').then(function (response) {
					callback(response.data);
				});
			};
			return service;
		}]);



})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ProjectsForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.projectsformapbyadmin = function (adminid, callback) {
			$http.get('api/tr-projectsformap/' + adminid).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrProjectForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllProjects = function (data, callback) {
			// $http.get('api/tr-projectsformap').then(function (response) {
			// 	callback(response.data);
			// });
			$http.post('api/tr-projectsformap', data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ShowProjectById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (projectid, callback) {
            $http.put('api/show-project/' + projectid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('HideProjectById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (projectid, callback) {
            $http.put('api/hide-project/' + projectid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('SummaryPost', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};

		
		service.resTx = function (payload, callback) {
			$http.post('api/rollout/res-tx-summary',payload).then(function (response) {
				 	callback(response.data);
				},  function (error){
					callback(error)
				})
		};

		service.mtrlTx = function (payload, callback) {
			$http.post('api/rollout/mtrl-tx-summary',payload).then(function (response) {
				 	callback(response.data);
				}, function (error){
					callback(error)
				})
		};

		service.dailyLogsTx = function (payload, callback) {
			$http.post('api/rollout/daily-task-logs-summary',payload).then(function (response) {
				 	callback(response.data);
				})
		};


		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('taskConfiguration', ['$http', function ($http) {

        var service = {};
        service.postTerrainConfiguration = function (payload, callback) {
            $http.post('api/terrain-task-map' ,payload)
			.success(function (response) {
				callback(response.data);
            })
            .error(function (err) {
				callback(err);
            });
        };

		service.getTerrainConfiguration = function (projectId, callback) {
			$http.get('api/terrain-task-map/' + projectId).then(function (response) {
				callback(response.data);
			});
        };

		service.postRoWConfiguration = function (payload, callback) {
            $http.post('api/row-task-map' ,payload)
			.success(function (response) {
				callback(response.data);
            })
            .error(function (err) {
				callback(err);
            });
        };

		service.getRoWConfiguration = function (projectId, callback) {
			$http.get('api/row-task-map/' + projectId).then(function (response) {
				callback(response.data);
			});
        };

        return service;
    }]);
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrProjectController", TrProjectController);

    TrProjectController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$compile",
        "TrProject",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "TrProjectSearch",
        "TrRouteListByProjectId",
        "routeDetail",
        "dailyLogByTaskId",
        "Inventory",
        "TrRouteForMap"
    ];

    function TrProjectController(
        $scope,
        $rootScope,
        $state,
        $compile,
        TrProject,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants, 
        TrProjectSearch,
        TrRouteListByProjectId,
        routeDetail,
        dailyLogByTaskId,
        Inventory,
        TrRouteForMap
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var searchVal = $scope.search.replace(/[^\w\s]/g, '_');
                TrProjectSearch.query(
                    {
                        search: searchVal,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.projects = [];
                    data.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.projects.push(value);
                    });
                    vm.page = pagingParams.page;
                }
    
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            TrProject.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.projects = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.projects.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ){
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal,
            });
        }


        vm.routeResponse = []
        vm.sectionResponse = []
        vm.sectionTaskResponse = []
        vm.terrainResponse = []
        vm.rowResponse = []
        vm.routeTaskResponse = []
		vm.routePlanResponse = []
        vm.toggle = []
        vm.expand = function (data, str) {
           
            if(str == "project" ){
                vm.projects.forEach(function (item) {
                    item.project = false;
                });

				if(vm.routePlanResponse.length){
					vm.routePlanResponse.forEach(function (item) {
					                        item.routeBundles = false;
					                    });
				}
                if(vm.routeResponse.length){
                    vm.routeResponse.forEach(function (item) {
                        item.route = false;
                    });
    
                   
                }

                if(vm.sectionResponse.length){
                    vm.sectionResponse.forEach(function (item) {
                        item.section = false;
                    });
                }

                if(vm.sectionTaskResponse.length){
                    vm.sectionTaskResponse.forEach(function (item) {
                        item.sectionTask = false;
                    });
    
                   
                }

                if(vm.routeTaskResponse.length){
                    vm.routeTaskResponse.forEach(function (item) {
                        item.routeTask = false;
                    });
                }
                
            }

            if(str == "route"){
                vm.routeResponse.forEach(function (item) {
                    item.route = false;
                });
                if(vm.sectionResponse.length){
                    vm.sectionResponse.forEach(function (item) {
                        item.section = false;
                    });
                }
            }
			
			if(str == "routeBundles"){
					vm.routePlanResponse.forEach(function (item) {
						item.routeBundles = false;
					});
					
					if(vm.routeResponse.length){
					   vm.routeResponse.forEach(function (item) {
					     item.route = false;
					   });
				 }
				 if(vm.sectionResponse.length){
				    vm.sectionResponse.forEach(function (item) {
				    item.section = false;
				    });
				 }
			}

            if(str == "section"){ 
                vm.sectionResponse.forEach(function (item) {
                    item.section = false;
                });
            }
            
           
            var iD = (data.id) ?  data.id : data.sectionId
            if (vm.toggle.includes(iD)) {
                vm.toggle = vm.toggle.filter(function(num){ return num !== iD} );
            } else {
                switch (str) {
                    case "project":
                    
                        vm.headers = null
                        TrRouteListByProjectId.routeBundleByProjectId(data.id,function(data){
                            vm.headers = [
                                { key: "name", display: "Route Name" },
                               
                            ] 
                            vm.routePlanResponse = data
                        })
                        data.project = true;
                        vm.toggle.push(data.id);
                        break;
						case "routeBundles":
						                    
						vm.headers = null
						TrRouteListByProjectId.routesByRouteBundleId(data.id,function(data){
						vm.headers = [
						{ key: "name", display: "Route Name" },
						                               
						] 
						vm.routeResponse = data
						})
						data.routeBundles = true;
						vm.toggle.push(data.id);
						break;

                        case "route":
                            vm.sectionheaders = null
                            routeDetail.getRoutesDetails(data.id,function(data){
                                vm.sectionheaders = [
                                    { key: "sectionName", display: "Section Name" },
                                    /* {  display: "Action" }, */
                                ]
                                vm.sectionResponse = data
                            })

                            routeDetail.getTask(data.id,function(data){
                                vm.routeTaskheaders = [
                                    { key: "name", display: "Task Name" },
                                    /* {  display: "Action" }, */
                                ]
                                vm.routeTaskResponse = data
                            })

                            TrRouteForMap.getTerrainByRoute(
                                data.id,
                                function (data) { 
                                    vm.terrainsheaders = [
                                        { key: "name", display: "Terrain Name" }
                                    ]
                                    vm.terrainResponse = data
                                })

                                TrRouteForMap.getRoWByRoute(
                                    data.id,
                                    function (data) { 
                                        vm.rowsheaders = [
                                            { key: "name", display: "Row Name" }
                                        ]
                                        vm.rowResponse = data
                                    })

                            data.route = true;
                            vm.toggle.push(data.id);

                            
                            break;


                            case "section":
                               vm.sectionTaskheaders = null
                               Inventory.taskBySection(data.sectionId,function(response){
                                vm.sectionTaskheaders = [ 
                                    { key: "name", display: "Task Name" },/* 
                                    { key: "userLogin", display: "Assigned To" } */
                                ]
                                vm.sectionTaskResponse = response
                            })
                               data.section = true;
                               vm.toggle.push(data.sectionId);
                               break;


                               case "sectionTask":
                                
                            if(vm.sectionTaskResponse.length){
                                vm.sectionTaskResponse.forEach(function (item) {
                                    item.sectionTask = false;
                                });
                               } 

                              /*  vm.logsheaders = null
                               
                                dailyLogByTaskId.query(
                                    {
                                        search: $scope.search,
                                        page: 0,
                                        size: 10, //vm.itemsPerPage
                                        sort: sort(),
                                        id:data.id
                                    },
                                    function (response,headers) {
                                        vm.links = ParseLinks.parse(headers("Link"));
                                        vm.totalItems = headers("X-Total-Count");
                                        vm.queryCount = vm.totalItems;
                                        vm.page = pagingParams.page;
                                        
                                        vm.logsheaders = [ 
                                            { key: "taskLogType", display: "Log Type" },
                                             
                                            { key: "userLogin", display: "Assigned To" } 
                                        ]

                                        vm.logsResponse = response
                                    }
                                 ); */
                           
                               data.sectionTask = true;
                               vm.toggle.push(data.id);
                               break;



                               case "routeTask":
                                
                            if(vm.routeTaskResponse.length){
                                vm.routeTaskResponse.forEach(function (item) {
                                    item.routeTask = false;
                                });
                               } 

                               //vm.logsheaders = null
                               
                               /*  dailyLogByTaskId.query(
                                    {
                                        search: $scope.search,
                                        page: pagingParams.page - 1,
                                        size: 10, //vm.itemsPerPage
                                        sort: sort(),
                                        id:data.id
                                    },
                                    function (response,headers) {
                                        vm.links = ParseLinks.parse(headers("Link"));
                                        vm.totalItems = headers("X-Total-Count");
                                        vm.queryCount = vm.totalItems;
                                        vm.page = pagingParams.page;
                                        
                                        vm.logsheaders = [ 
                                            { key: "taskLogType", display: "Log Type" }
                                        ]

                                        vm.logsrResponse = response
                                    }
                                 ); */
                           
                               data.routeTask = true;
                               vm.toggle.push(data.id);
                               break;

                    

                    default: console.log("default")
                }
            }

        }
    }
})();

(function () {
  "use strict";

  angular
    .module("trakeyeApp")
    .controller("ProjectTreeController", ProjectTreeController);

  ProjectTreeController.$inject = [
    "$scope",
    "$rootScope",
    "TrProject",
    "ParseLinks",
    "AlertService",
    "pagingParams",
    "paginationConstants",
    "TrProjectSearch",
    "TrRouteListByProjectId",
    "routeDetail",
    "Inventory",
    "TrRouteForMap",
    "RouteByID",
  ];

  function ProjectTreeController(
    $scope,
    $rootScope,
    TrProject,
    ParseLinks,
    AlertService,
    pagingParams,
    paginationConstants,
    TrProjectSearch,
    TrRouteListByProjectId,
    routeDetail,
    Inventory,
    TrRouteForMap,
    RouteByID
  ) {
    var vm = this;
    vm.assets = [];
    vm.gpAssets = [];
    var locations = {};
    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    $scope.search = pagingParams.search;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.filterSearch = filterSearch;
    $scope.tab = 1;
    $scope.isSet = function (tabNum) {
      return $scope.tab === tabNum;
    };
    vm.getRoutePath = getRoutePath;
    vm.getRingPath = getRingPath;
    $scope.setTab = function (newTab) {
      $scope.tab = newTab;
      if ($scope.tab == 1) {
        filterSearch();
      }
    };
    if ($scope.tab == 1) {
      filterSearch();
    }
    function filterSearch() {
      if (
        $scope.search != null &&
        $scope.search != "" &&
        !angular.isUndefined($scope.search)
      ) {
        var searchVal = $scope.search.replace(/[^\w\s]/g, "_");
        TrProjectSearch.query(
          {
            search: searchVal,
            page: pagingParams.page - 1,
            size: vm.itemsPerPage,
            sort: sort(),
          },
          onSuccess,
          onError
        );
        function onSuccess(data, headers) {
          vm.links = ParseLinks.parse(headers("link"));
          vm.totalItems = headers("X-Total-Count");
          vm.queryCount = vm.totalItems;
          vm.projects = [];
          data.forEach(function (value) {
            if (value.zone) {
              value.type = "MASTER";
            } else {
              value.type = "MINI";
            }
            vm.projects.push(value);
          });
          vm.page = pagingParams.page;
        }

        function onError(error) {
          AlertService.error(error.data.message);
        }
      } else {
        loadAll();
      }
    }
    function loadAll() {
      TrProject.query(
        {
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort(),
        },
        onSuccess,
        onError
      );
      function sort() {
        var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
        if (vm.predicate !== "id") {
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers("link"));
        vm.totalItems = headers("X-Total-Count");
        vm.queryCount = vm.totalItems;
        vm.projects = [];
        data.forEach(function (value) {
          if (value.zone) {
            value.type = "MASTER";
          } else {
            value.type = "MINI";
          }
          vm.projects.push(value);
        });
        vm.page = pagingParams.page;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function mapStyles() {
      var styles;
      return (styles = [
        {
          featureType: "poi",
          elementType: "labels.icon",
          stylers: [{ color: "#63666A" }],
        },
        { elementType: "labels.text.fill", stylers: [{ color: "#63666A" }] },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [{ color: "#63666A" }],
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        { featureType: "landscape", stylers: [{ color: "#efefef" }] },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }],
        },
      ]);
    }
    function myOption(zoom, center) {
      var myOptions;
      return (myOptions = {
        zoom: zoom,
        center: center,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: mapStyles(),
      });
    }
    function initMap() {
      var center = {
        lat: $rootScope.DEFAULT_LATITUDE,
        lng: $rootScope.DEFAULT_LONGITUDE,
      };
      locations.map = new google.maps.Map(
        document.getElementById("map_view"),
        myOption(12, center)
      );
      mapHeigh();
    }

    function mapHeigh() {
      var screenHeight = screen.height;
      if (screenHeight < 900) {
        document.getElementById("map_view").style.height = "80vh";
      } else {
        document.getElementById("map_view").style.height = "85vh";
      }
    }

    function sort() {
      var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
      if (vm.predicate !== "id") {
        // result.push('id');
      }
      return result;
    }
    function loadPage(page) {
      vm.page = page;

      vm.transition();
    }
    function transition() {
      var searchVal = "";
      if (
        $scope.search != null &&
        $scope.search != "" &&
        !angular.isUndefined($scope.search)
      ) {
        searchVal = $scope.search.replace(/[^\w\s]/g, "_");
      }
      $state.transitionTo($state.$current, {
        page: vm.page,
        sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
        search: searchVal,
      });
    }
    initMap();
    vm.routeResponse = [];
    vm.sectionResponse = [];
    vm.sectionTaskResponse = [];
    vm.terrainResponse = [];
    vm.rowResponse = [];
    vm.routeTaskResponse = [];
    vm.routePlanResponse = [];
    vm.toggle = [];
    vm.expand = function (data, str) {
      if (str == "project") {
        vm.projects.forEach(function (item) {
          item.project = false;
        });

        if (vm.routePlanResponse.length) {
          vm.routePlanResponse.forEach(function (item) {
            item.routeBundles = false;
          });
        }
        if (vm.routeResponse.length) {
          vm.routeResponse.forEach(function (item) {
            item.route = false;
          });
        }
        if (vm.sectionResponse.length) {
          vm.sectionResponse.forEach(function (item) {
            item.section = false;
          });
        }
        if (vm.sectionTaskResponse.length) {
          vm.sectionTaskResponse.forEach(function (item) {
            item.sectionTask = false;
          });
        }

        if (vm.routeTaskResponse.length) {
          vm.routeTaskResponse.forEach(function (item) {
            item.routeTask = false;
          });
        }
      }
      if (str == "route") {
        vm.routeResponse.forEach(function (item) {
          item.route = false;
        });
        if (vm.sectionResponse.length) {
          vm.sectionResponse.forEach(function (item) {
            item.section = false;
          });
        }
      }

      if (str == "routeBundles") {
        vm.routePlanResponse.forEach(function (item) {
          item.routeBundles = false;
        });

        if (vm.routeResponse.length) {
          vm.routeResponse.forEach(function (item) {
            item.route = false;
          });
        }
        if (vm.sectionResponse.length) {
          vm.sectionResponse.forEach(function (item) {
            item.section = false;
          });
        }
      }

      if (str == "section") {
        vm.sectionResponse.forEach(function (item) {
          item.section = false;
        });
      }
      var iD = data.id ? data.id : data.sectionId;
      if (vm.toggle.includes(iD)) {
        vm.toggle = vm.toggle.filter(function (num) {
          return num !== iD;
        });
      } else {
        switch (str) {
          case "project":
            vm.headers = null;
            TrRouteListByProjectId.routeBundleByProjectId(
              data.id,
              function (data) {
                vm.headers = [{ key: "name", display: "Route Name" }];
                vm.routePlanResponse = data;
              }
            );
            data.project = true;
            vm.toggle.push(data.id);
            break;
          case "routeBundles":
            vm.headers = null;
            TrRouteListByProjectId.routesByRouteBundleId(
              data.id,
              function (data) {
                vm.headers = [{ key: "name", display: "Route Name" }];
                vm.routeResponse = data;
              }
            );
            data.routeBundles = true;
            vm.toggle.push(data.id);
            break;

          case "route":
            vm.sectionheaders = null;
            routeDetail.getRoutesDetails(data.id, function (data) {
              vm.sectionheaders = [
                { key: "sectionName", display: "Section Name" },
                /* {  display: "Action" }, */
              ];
              vm.sectionResponse = data;
            });

            routeDetail.getTask(data.id, function (data) {
              vm.routeTaskheaders = [
                { key: "name", display: "Task Name" },
                /* {  display: "Action" }, */
              ];
              vm.routeTaskResponse = data;
            });

            TrRouteForMap.getTerrainByRoute(data.id, function (data) {
              vm.terrainsheaders = [{ key: "name", display: "Terrain Name" }];
              vm.terrainResponse = data;
            });

            TrRouteForMap.getRoWByRoute(data.id, function (data) {
              vm.rowsheaders = [{ key: "name", display: "Row Name" }];
              vm.rowResponse = data;
            });

            data.route = true;
            vm.toggle.push(data.id);
            break;
          case "section":
            vm.sectionTaskheaders = null;
            Inventory.taskBySection(data.sectionId, function (response) {
              vm.sectionTaskheaders = [
                {
                  key: "name",
                  display: "Task Name",
                } /* 
                                    { key: "userLogin", display: "Assigned To" } */,
              ];
              vm.sectionTaskResponse = response;
            });
            data.section = true;
            vm.toggle.push(data.sectionId);
            break;
          case "sectionTask":
            if (vm.sectionTaskResponse.length) {
              vm.sectionTaskResponse.forEach(function (item) {
                item.sectionTask = false;
              });
            }

            data.sectionTask = true;
            vm.toggle.push(data.id);
            break;
          case "routeTask":
            if (vm.routeTaskResponse.length) {
              vm.routeTaskResponse.forEach(function (item) {
                item.routeTask = false;
              });
            }
            data.routeTask = true;
            vm.toggle.push(data.id);
            break;

          default:
            console.log("default");
        }
      }
    };
    vm.ringList = [];
    var polylines = [];
    vm.ring = [];
    var ringPolyline = [];
    var spreadPolyline = [];
    var assetMarker = [];
    var openedInfoWindow = null;

    function getRoutePath(id) {
      clearAllPolylines();
      clearRingPolylines();
      clearAssetMarkers();
      clearSpreadPolylines();
      clearMapElements();
      vm.assets = [];
      vm.gpAssets = [];
      vm.ringList = [];

      TrRouteListByProjectId.routesByRouteBundleId(id, function (response) {
        vm.ringList = response;

        if (vm.ringList.length) {
          var completedCalls = 0;

          vm.ringList.forEach(function (ring) {
            RouteByID.get(ring.id, function (routeResponse) {
              drawPolyline(routeResponse, polylines);

              loadAssets(ring.id, null, function () {
                completedCalls++;
                if (completedCalls === vm.ringList.length) {
                  setupFilterOptions();
                }
              });
            });
          });
        }
      });
    }

    function getRingPath(id) {
      clearAllPolylines();
      clearRingPolylines();
      clearAssetMarkers();
      clearSpreadPolylines();
      clearMapElements();
      RouteByID.get(id, function (response) {
        vm.ring = response;
        drawPolyline(vm.ring, ringPolyline);
        loadAssets(id, null);
      });
    }

    function drawPolyline(assets, targetPolylineArray) {
      if (!assets.routePoints || assets.routePoints.length === 0) return;

      var groupedByPhase = {};
      assets.routePoints.forEach(function (point) {
        if (point.routePointType === "COORDINATE") {
          var phase = point.phase;
          var session = point.sessionNumber;

          if (!groupedByPhase[phase]) {
            groupedByPhase[phase] = {};
          }

          if (!groupedByPhase[phase][session]) {
            groupedByPhase[phase][session] = [];
          }

          groupedByPhase[phase][session].push({
            lat: point.latitude,
            lng: point.longitude,
            routePointNumberDouble: point.routePointNumberDouble,
          });
        }
      });

      var bounds = new google.maps.LatLngBounds();
      var phaseColors = {
        PLANNING: "#FD7A24",
        SURVEY: "#007bff",
      };

      Object.keys(groupedByPhase).forEach(function (phase) {
        var sessions = groupedByPhase[phase];
        Object.keys(sessions).forEach(function (sessionKey) {
          var path = sessions[sessionKey];
          path.sort(function (a, b) {
            return a.routePointNumberDouble - b.routePointNumberDouble;
          });
          var polyline = new google.maps.Polyline({
            path: path,
            strokeColor: phaseColors[phase],
            geodesic: true,
            strokeOpacity: 1.0,
            strokeWeight: 3,
            zIndex: 2,
          });
          polyline.setMap(locations.map);
          targetPolylineArray.push(polyline);
          path.forEach(function (pt) {
            bounds.extend(pt);
          });
        });
      });

      if (!bounds.isEmpty()) {
        locations.map.fitBounds(bounds);
      }
    }

    function clearAllPolylines() {
      if (polylines.length) {
        polylines.forEach(function (polyline) {
          polyline.setMap(null);
        });
        polylines = [];
      }
    }

    function clearRingPolylines() {
      if (ringPolyline.length) {
        ringPolyline.forEach(function (polyline) {
          polyline.setMap(null);
        });
        ringPolyline = [];
      }
    }

    function clearSpreadPolylines() {
      if (spreadPolyline.length) {
        spreadPolyline.forEach(function (polyline) {
          polyline.setMap(null);
        });
        spreadPolyline = [];
      }
    }

    function clearAssetMarkers() {
      if (assetMarker.length) {
        assetMarker.forEach(function (marker) {
          marker.setMap(null);
        });
        assetMarker = [];
      }
    }
    function clearMapElements() {
      clearAllPolylines();
      clearRingPolylines();
      clearAssetMarkers();
      clearSpreadPolylines();
      vm.assets = [];
      vm.gpAssets = [];
    }

    function loadAssets(routeId, lastId, doneCallback) {
      routeDetail.getAssetsById(routeId, lastId, function (response) {
        vm.routeAsset = response.assets;

        if (vm.routeAsset.length >= 200) {
          vm.routeAsset.forEach(function (asset) {
            vm.assets.push(asset);
          });

          loadAssets(
            routeId,
            vm.routeAsset[vm.routeAsset.length - 1].id,
            doneCallback
          );
        } else {
          vm.routeAsset.forEach(function (asset) {
            vm.assets.push(asset);
          });

          vm.assets.forEach(function (asset) {
            drawAssetMarker(asset);

            if (asset.assetTypeLayout === "SPREAD") {
              var coordinates = asset.assetCoordinates.map(function (coord) {
                return {
                  lat: coord.latitude,
                  lng: coord.longitude,
                };
              });

              var spreadLine = new google.maps.Polyline({
                path: coordinates,
                geodesic: true,
                strokeColor: "#0000FF",
                strokeOpacity: 0.9,
                strokeWeight: 2,
                zIndex: 1,
              });

              spreadLine.setMap(locations.map);
              spreadPolyline.push(spreadLine);
            }
          });

          if (doneCallback) {
            doneCallback();
          }
        }
      });
    }

    function drawAssetMarker(asset) {
      var coordinates = asset.assetCoordinates.map(function (coord) {
        return { lat: coord.latitude, lng: coord.longitude };
      });

      if (asset.assetTypeLayout === "FIXED") {
        vm.gpAssets.push(asset);

        var marker;
        if (
          asset.assetTypeName === "GP" &&
          (asset.phase === "SURVEY" || asset.phase === "ROLLOUT")
        ) {
          marker = new google.maps.Marker({
            position: coordinates[0],
            map: locations.map,
            title: asset.name,
            icon: {
              url: "content/images/yellowGp.png",
              scaledSize: new google.maps.Size(32, 32),
            },
          });
        } else {
          marker = new google.maps.Marker({
            position: coordinates[0],
            map: locations.map,
            title: asset.name,
            icon: {
              url: asset.assetTypeImagePath,
              scaledSize: new google.maps.Size(32, 32),
            },
          });
        }

        assetMarker.push(marker);

        function updateMarkerLabelVisibility() {
          var currentZoom = locations.map.getZoom();
          if (currentZoom > 14) {
            marker.setLabel({
              color: "black",
              fontWeight: "bold",
              fontSize: "12px",
              text: asset.name,
            });
          } else {
            marker.setLabel(null);
          }
        }

        google.maps.event.addListener(
          locations.map,
          "zoom_changed",
          updateMarkerLabelVisibility
        );

        var infowindow = new google.maps.InfoWindow();

        var updateIconSize = function () {
          var zoom = locations.map.getZoom();

          var minZoom = 8;
          var maxZoom = 21;
          var minSize = 6;
          var maxSize = 60;

          var newSize =
            minSize +
            ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);

          var icon = {
            url: marker.getIcon().url,
            scaledSize: new google.maps.Size(newSize, newSize),
            anchor: new google.maps.Point(newSize / 2, newSize),
          };

          marker.setIcon(icon);
        };

        updateIconSize();

        google.maps.event.addListener(
          locations.map,
          "zoom_changed",
          function () {
            updateIconSize();
          }
        );
      }
    }

    function setupFilterOptions() {
      vm.filterOptions = [];

      var phaseSet = new Set();
      var assetTypeSet = new Set();
      var completedCalls = 0;

      if (!vm.ringList.length) return;

      vm.ringList.forEach(function (ring) {
        RouteByID.get(ring.id, function (routeResponse) {
          if (routeResponse.routePoints && routeResponse.routePoints.length) {
            routeResponse.routePoints.forEach(function (point) {
              if (point.phase) {
                phaseSet.add(point.phase);
              }
            });
          }

          completedCalls++;
          if (completedCalls === vm.ringList.length) {
            Array.from(phaseSet).forEach(function (phase) {
              vm.filterOptions.push({
                name: phase,
                type: "Phase",
                selected: true,
              });
            });
            vm.assets.forEach(function (asset) {
              if (asset.assetTypeName) {
                assetTypeSet.add(asset.assetTypeName);
              }
            });

            Array.from(assetTypeSet).forEach(function (type) {
              vm.filterOptions.push({
                name: type,
                type: "AssetType",
                selected: true,
              });
            });
            vm.selectedFilters = angular.copy(vm.filterOptions);
          }
        });
      });
    }

    vm.applyUnifiedFilter = function () {
      var selectedPhases = vm.selectedFilters
        .filter(function (f) {
          return f.type === "Phase";
        })
        .map(function (f) {
          return f.name;
        });

      var selectedAssetTypes = vm.selectedFilters
        .filter(function (f) {
          return f.type === "AssetType";
        })
        .map(function (f) {
          return f.name;
        });

      clearAllPolylines();
      clearRingPolylines();
      clearAssetMarkers();
      clearSpreadPolylines();

      vm.ringList.forEach(function (ring) {
        RouteByID.get(ring.id, function (response) {
          var filteredPoints = response.routePoints.filter(function (p) {
            return selectedPhases.indexOf(p.phase) !== -1;
          });

          if (filteredPoints.length > 0) {
            response.routePoints = filteredPoints;
            drawPolyline(response, polylines);
          }
        });
      });

      vm.assets.forEach(function (asset) {
        if (selectedAssetTypes.indexOf(asset.assetTypeName) !== -1) {
          drawAssetMarker(asset);

          if (asset.assetTypeLayout === "SPREAD") {
            var coordinates = asset.assetCoordinates.map(function (coord) {
              return { lat: coord.latitude, lng: coord.longitude };
            });

            var spreadLine = new google.maps.Polyline({
              path: coordinates,
              geodesic: true,
              strokeColor: "#0000FF",
              strokeOpacity: 0.9,
              strokeWeight: 2,
              zIndex: 1,
            });

            spreadLine.setMap(locations.map);
            spreadPolyline.push(spreadLine);
          }
        }
      });
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrNotificationDialogController', TrNotificationDialogController);

    TrNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state','entity', 'TrNotification', 'User', 'TrCase', 'ActivatedUsers','TrCaseUser','ActivatedUserSearch'];

    function TrNotificationDialogController ($timeout, $scope, $stateParams, $state, entity, TrNotification, User, TrCase,ActivatedUsers,TrCaseUser,ActivatedUserSearch) {
        var vm = this;

        vm.trNotification = entity;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.filtertrcasesid=filtertrcasesid;
        vm.filterActivatedUser = filterActivatedUser;
        var usersMap={};
        //vm.users = User.query();
        ActivatedUsers.getactivatedusers(function(response){
	    	vm.users = response;
	    });
        vm.trcases = TrCase.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
      
        function save () {
            vm.isSaving = true;
            var toUser = $("#field_toUser").val();
            
            vm.trNotification.toUserId = usersMap[toUser];
            if (vm.trNotification.id !== null) {
                TrNotification.update(vm.trNotification, onSaveSuccess, onSaveError);
            } else {
                TrNotification.save(vm.trNotification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:trNotificationUpdate', result);           
            vm.isSaving = false;
            $state.go('tr-notification');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function filtertrcasesid(){
        	if(vm.trNotification.trCaseId!=null && !angular.isUndefined(vm.trNotification.trCaseId)){
        		
            	TrCaseUser.searchtrcasesuserbyvalue(vm.trNotification.trCaseId,function(response){
            		vm.caseids = response;
            	});
             }
        }
        
        function filterActivatedUser(){
			
			if(vm.trNotification.toUserId!=null && vm.trNotification.toUserId!="" && !angular.isUndefined(vm.trNotification.toUserId)){
				ActivatedUserSearch.query({userId:vm.trNotification.toUserId,
		            }, onSuccess, onError);

         function onSuccess(data, headers) {
             vm.activatedusers = data; 
             
             angular.forEach(vm.activatedusers, function(value, key){
            	 
            	 usersMap[value.login] = value.id; 
            	 
             });
             
         }
         function onError(error) {
             AlertService.error(error.data.message);
         }
			}
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrNotificationDetailController', TrNotificationDetailController);

    TrNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrNotification', 'User', 'TrCase'];

    function TrNotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, TrNotification, User, TrCase) {
        var vm = this;

        vm.trNotification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:trNotificationUpdate', function(event, result) {
            vm.trNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrNotificationDeleteController',TrNotificationDeleteController);

    TrNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrNotification'];

    function TrNotificationDeleteController($uibModalInstance, entity, TrNotification) {
        var vm = this;

        vm.trNotification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TrNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-notification', {
                parent: 'app',
                url: '/tr-notification?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trNotification.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-notification/tr-notifications.html',
                        controller: 'TrNotificationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'created_date,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trNotification');
                        $translatePartialLoader.addPart('notificationStatus');
                        $translatePartialLoader.addPart('alertType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tr-notification-detail', {
                parent: 'tr-notification',
                url: '/tr-notification/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_USER'],
                    pageTitle: 'trakeyeApp.trNotification.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-notification/tr-notification-detail.html',
                        controller: 'TrNotificationDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trNotification');
                        $translatePartialLoader.addPart('notificationStatus');
                        $translatePartialLoader.addPart('alertType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrNotification', function($stateParams, TrNotification) {
                        return TrNotification.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-notification',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('tr-notification-detail.edit', {
                parent: 'tr-notification-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-notification/tr-notification-dialog.html',
                        controller: 'TrNotificationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        //size: 'lg',
                        resolve: {
                            entity: ['TrNotification', function(TrNotification) {
                                return TrNotification.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-notification.new', {
                parent: 'tr-notification',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-notification/tr-notification-dialog.html',
                        controller: 'TrNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            createdDate: null,
                            description: null,
                            status: null,
                            subject: null,
                            alertType: null,
                            id: null
                        };
                    }
                }
            })
            .state('tr-notification.edit', {
                parent: 'tr-notification',
                url: '/edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER'],
                    pageTitle: 'trakeyeApp.trNotification.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-notification/tr-notification-dialog.html',
                        controller: 'TrNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trNotification');
                        $translatePartialLoader.addPart('notificationStatus');
                        $translatePartialLoader.addPart('alertType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrNotification', function($stateParams, TrNotification) {
                        return TrNotification.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-notification',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

        .state('tr-notification.delete', {
            parent: 'tr-notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tr-notification/tr-notification-delete-dialog.html',
                    controller: 'TrNotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TrNotification', function(TrNotification) {
                            return TrNotification.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tr-notification', null, { reload: 'tr-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
(function() {
	'use strict';
	angular.module('trakeyeApp').factory('TrNotification', TrNotification);

	TrNotification.$inject = [ '$resource', 'DateUtils' ];

	function TrNotification($resource, DateUtils) {
		var resourceUrl = 'api/tr-notifications/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrNotificationSearch', TrNotificationSearch);

	TrNotificationSearch.$inject = [ '$resource' ];

	function TrNotificationSearch($resource) {
		var service = $resource('/api/tr-notifications/searchvalue/:search', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();
(function() {
	'use strict';

	angular.module('trakeyeApp').controller('TrNotificationController', TrNotificationController);

	TrNotificationController.$inject = [ '$scope', '$state', 'TrNotification', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TrNotificationSearch' ];

	function TrNotificationController($scope, $state, TrNotification, ParseLinks, AlertService, pagingParams, paginationConstants, TrNotificationSearch) {
		var vm = this;
		$scope.search = pagingParams.search;
		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.filterSearch = filterSearch;

		function filterSearch() {

			if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
				TrNotificationSearch.query({
					search : $scope.search,
					page : pagingParams.page - 1,
					size : vm.itemsPerPage,
					sort : sort()
				}, onSuccess, onError);
				function sort() {
					var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
					if (vm.predicate !== 'id') {
						// result.push('id');
					}
					return result;
				}
				function onSuccess(data, headers) {
					vm.links = ParseLinks.parse(headers('link'));
					vm.totalItems = headers('X-Total-Count');
					vm.queryCount = vm.totalItems;
					vm.trNotifications = data;
					vm.page = pagingParams.page;

				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
			} else {
				loadAll();
			}
		}

		if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
			filterSearch();
		} else {
			loadAll();
		}

		function loadAll() {
			TrNotification.query({
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort()
			}, onSuccess, onError);
			function sort() {
				var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					// result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.trNotifications = data;
				vm.page = pagingParams.page;
			}
			function onError(error) {
				AlertService.error(error.data.message);
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search : $scope.search
			});
		}
	}
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrMaterialDialogController", TrMaterialDialogController);

    TrMaterialDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrMaterial",
        "AllMaterialTypes",
        "AllCustomMaterialTypeAttribute",
        "MaterialAttributeMappingId"
    ];

    function TrMaterialDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrMaterial,
        AllMaterialTypes,
        AllCustomMaterialTypeAttribute,
        MaterialAttributeMappingId
    ) {
        var vm = this;
        vm.trMaterial = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trMaterial);
        vm.selectAttributes = selectedMaterialTypeAttributes;
        vm.materialType = entity.materialType;
        
		vm.customAttributesMap = {};
		vm.customAttributesMapp = [];
        loadPage();


        if (vm.trMaterial.id != null) {
            vm.trMaterialType = vm.trMaterial.materialType;
        }

        function loadPage() {

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                        img +
                        '">'
                );
                imgWindow.document.close();
            };

            var materialTypeAttributeValuesList =
                vm.trMaterial.materialTypeAttributeValues;

            try {
                for (var index in vm.trMaterial.materialType.materialTypeAttribute) {
                    if (
                        !checkIfMaterialTypeExists(
                            vm.trMaterial.materialType.materialTypeAttribute[index],
                            vm.trMaterial.materialTypeAttributeValues
                        )
                    ) {
                        var materialTypeAttribute1 =
                            vm.trMaterial.materialType.materialTypeAttribute[index];
                        materialTypeAttributeValuesList.push({
                            materialTypeAttribute: materialTypeAttribute1,
                            attributeValue:
                                vm.trMaterial.materialType.materialTypeAttribute[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) {}

            function checkIfMaterialTypeExists(materialType, materialTypeAttrVal) {
                var hasMaterialType = false;
                for (var i = 0; i < materialTypeAttrVal.length; i++) {
                    var name = materialTypeAttrVal[i].materialTypeAttribute.name;
                    if (name == materialType.name) {
                        hasMaterialType = true;
                        break;
                    }
                }
                return hasMaterialType;
            }
            AllMaterialTypes.getAll(function (response) {
                vm.materialTypes = response;
            });

            AllCustomMaterialTypeAttribute.getAll(function (response) {
                //vm.customMaterialTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if(arrayItem.customMaterialTypeAttributeValues != undefined){
                        vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customMaterialTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }
                  
                });
                if (vm.trMaterial.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });
            
            
        }
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function selectedMaterialTypeAttributes() {
            vm.showFilter = true;
            if (vm.materialType) {
                vm.trMaterial.materialType = vm.materialType;
                if (
                    entity_old.materialType &&
                    vm.materialType.id === entity_old.materialType.id
                ) {
                    vm.trMaterial.materialTypeAttributeValues = [];
                    vm.trMaterial.materialTypeAttributeValues =
                        entity_old.materialTypeAttributeValues;
                } else {
                    vm.trMaterial.materialTypeAttributeValues = [];
                    $.each(
                        vm.materialType.materialTypeAttribute,
                        function (key, value) {
                            vm.trMaterial.materialTypeAttributeValues.push({
                                materialTypeAttribute:
                                    vm.materialType.materialTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        function save() {
            vm.isSaving = true;
            /* var spreadAV = vm.trMaterial.materialTypeAttributeValues;
            for (
                var spreadAssetIndex = 0;
                spreadAssetIndex < spreadAV.length;
                spreadAssetIndex++
            ) {
                if (
                    spreadAV[spreadAssetIndex].materialTypeAttribute
                        .name === "Fiber Distance (km)"
                ) {
                    spreadAV[
                        spreadAssetIndex
                    ].attributeValue = fiberDistance;
                }
            }
            vm.trMaterial.materialTypeAttributeValues = spreadAV; */
                
            if (vm.trMaterial.id !== null) {
                TrMaterial.update(vm.trMaterial, onSaveSuccess, onSaveError);
            } else {
                TrMaterial.save(vm.trMaterial, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:materialUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "user-management.new") {
                $state.go("user-management.new");
            } else {
                $state.go("tr-material");
            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        $('.select2').select2();
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrMaterialDetailController', TrMaterialDetailController);

    TrMaterialDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrMaterial', 'User', 'MaterialType', 'TrMaterialImages', 'TrMaterialRecordings','AlertService','$window','$localStorage','getMaterialImage','Configs'];

    function TrMaterialDetailController($scope, $rootScope, $stateParams, previousState, entity, TrMaterial, User, MaterialType,TrMaterialImages,TrMaterialRecordings,AlertService, $window,$localStorage,getMaterialImage,Configs) {
		var vm = this;
		
        vm.trMaterial = entity;
        vm.previousState = previousState.name;
        vm.decodeImage = decodeImage;
        var unsubscribe = $rootScope.$on('trakeyeApp:trMaterialUpdate', function(event, result) {
            vm.trMaterial = result;
        });
		vm.showMaterialAttachment = false

		Configs.get("MaterialImage",function(response){
            if(response.length > 0){
				if(response[0].configValue == "True"){
					vm.showMaterialAttachment = true
				}
			}
        })
		
        vm.imageInNewTab = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
            );
            imgWindow.document.close(); 
		};

		$scope.newTabDisplay = function(id){
            var request = new XMLHttpRequest();
            request.open('GET',"api/trakeyematerialimages/"+vm.trMaterial.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                window.open(imageUrl, "_blank")}
            } 
            request.send();
        } 

        $scope.$on('$destroy', unsubscribe);
        
          $scope.go_back = function() { 
        	  $window.history.back();
        	};
        
        $scope.allimages = false;
//		$scope

		$scope.toggle = function(id) {
			switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrMaterialImages.query(
                            {
                                materialId: vm.trMaterial.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.materialImages = data.filter(function(materialImages){
                                return materialImages.image
                             });
                        
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getMaterialImage.get(vm.trMaterial.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }


			
			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/material_"+vm.trMaterial.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrMaterialImages.query({
					materialId : vm.trMaterial.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.materialImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

//		$scope.playAudio = function() {
////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/material_"+vm.trMaterial.id+".mp3";
//            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/material_15570572.mp3";
//	        var audio = new Audio(urlStr);
//	        audio.play();
//	    };
		
		
        function decodeImage(img){
     	   return window.atob(img);
        }
       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrMaterialDeleteController',TrMaterialDeleteController);

    TrMaterialDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrMaterial','$scope'];

    function TrMaterialDeleteController($uibModalInstance, entity, TrMaterial,$scope) {
        var vm = this;

        vm.trMaterial = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrMaterial.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-material', {
                parent: 'app',
                url: '/tr-material',
                data: {
                    authorities: ['MATERIAL_SIDEBAR'],                   
                    pageTitle: 'trakeyeApp.material.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-materials.html',
                        controller: 'TrMaterialController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trMaterial');
                        $translatePartialLoader.addPart('materialStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-material-detail', {
                parent: 'tr-material',
                url: '/tr-material/{id}',
                data: {
                    authorities: ['MATERIAL_DETAIL'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-detail.html',
                        controller: 'TrMaterialDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trMaterial');
                        $translatePartialLoader.addPart('materialStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrMaterial', function ($stateParams, TrMaterial) {
                        return TrMaterial.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-material',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-material.priority', {
                parent: 'tr-material',
                url: '/tr-materials/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-materials.html',
                        controller: 'TrMaterialController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trMaterial');
                        $translatePartialLoader.addPart('materialStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-material.attendance', {
                parent: 'tr-material',
                url: '/tr-materials/attendance/{login}/{fromTime}/{toTime}/{materialStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD','ROLE_OA', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER','ROLE_PLAN_ADMIN'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-materials.html',
                        controller: 'TrMaterialController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            materialStatus: $stateParams.materialStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trMaterial');
                        $translatePartialLoader.addPart('materialStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-material.new', {
                parent: 'tr-material',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}',
                data: {
                    authorities: ['MATERIAL_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-dialog.html',
                        controller: 'TrMaterialDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            materialImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })

        .state('tr-material.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-material/tr-material-work-flow.html',
                    controller: 'TrMaterialWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        materialImages: []
                    };
                }]
            }
        })

        .state('tr-material.import', {
                parent: 'tr-material',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-import.html',
                        controller: 'TrMaterialImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            materialImages: []
                        };
                    }
                }

            })
            .state('tr-material.edit', {
                parent: 'tr-material',
                url: '/Edit/{id}',
                data: {
                    authorities: ['MATERIAL_EDIT'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-dialog.html',
                        controller: 'TrMaterialDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrMaterial', function ($stateParams, TrMaterial) {
                        return TrMaterial.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-material',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-material.delete', {
                parent: 'tr-material',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-material/tr-material-delete-dialog.html',
                        controller: 'TrMaterialDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrMaterial', function (TrMaterial) {
                                return TrMaterial.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-material', null, { reload: 'tr-material' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-material.fibercore', {
                parent: 'tr-material',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-fiber-core.html',
                        controller: 'TrMaterialFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            materialImages: []
                        };
                    }
                }

            })

            .state('show-hide-material', {
                parent: 'report',
                url: '/show-hide-material',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/show-hide-material.html',
                        controller: 'ShowHideMaterialController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('geofence-material', {
                parent: 'report',
                url: '/geofence-material',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/geofence-materialTxn.html',
                        controller: 'geofenceMaterialController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrMaterial', TrMaterial);

	TrMaterial.$inject = ['$resource', 'DateUtils'];

	function TrMaterial($resource, DateUtils) {
		var resourceUrl = 'api/tr-materials/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialGeofence', TrMaterialGeofence);

	TrMaterialGeofence.$inject = ['$resource'];

	function TrMaterialGeofence($resource) {
		var service = $resource('/api/tr-materials/geofence/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialCustomTime', TrMaterialCustomTime);

	TrMaterialCustomTime.$inject = ['$resource'];

	function TrMaterialCustomTime($resource) {
		var service = $resource('/api/tr-materials-custom/:fromDate/:toDate', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialGeofenceCustomTime', TrMaterialGeofenceCustomTime);

	TrMaterialGeofenceCustomTime.$inject = ['$resource'];

	function TrMaterialGeofenceCustomTime($resource) {
		var service = $resource('/api/tr-materials-custom/geofence/:geofenceId/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrMaterialCheckAsset', TrMaterialCheckAsset);

	TrMaterialCheckAsset.$inject = ['$resource', 'DateUtils'];

	function TrMaterialCheckAsset($resource, DateUtils) {
		var resourceUrl = 'api/assets/search/:name';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
		});
	}
})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('MaterialsForAsset', MaterialsForAsset);

    MaterialsForAsset.$inject = ['$resource'];

    function MaterialsForAsset($resource) {
        var resourceUrl = 'api/materials-for-asset/:assetId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-materials/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getMaterialImage', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/trakeyematerialimages/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getNearbyFixed', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id,data,callback) {
			$http.post('api/assets/nearby-fixed/' + id,data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialAssetsById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-materials-assets/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('MaterialAttributeMappingId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/custom-material-type-mapper/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

/*
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialById', TrMaterialById);

	TrMaterialById.$inject = [ '$resource' ];

	function TrMaterialById($resource) {
		var service = $resource('/api/tr-materials/:id', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();*/

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialCountByGroup', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/materialcountbygroup').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadMaterialReports', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-materials').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialCountByStatus', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/materialcountbystatus').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialPriority', TrMaterialPriority);

	TrMaterialPriority.$inject = ['$resource'];

	function TrMaterialPriority($resource) {
		var service = $resource('/api/tr-materials/priority/:priority/:geofenceId', {
			priority: '@priorirty'
		}, {geofenceId : '@geofenceId'},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialAttendance', TrMaterialAttendance);

	TrMaterialAttendance.$inject = ['$resource'];

	function TrMaterialAttendance($resource) {
		var service = $resource('/api/tr-materials/attendance/:login/:fromTime/:toTime/:materialStatus',
			{}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialSearch', TrMaterialSearch);

	TrMaterialSearch.$inject = ['$resource'];

	function TrMaterialSearch($resource) {
		var service = $resource('/api/tr-materials/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialSearchCustom', TrMaterialSearchCustom);

	TrMaterialSearchCustom.$inject = ['$resource'];

	function TrMaterialSearchCustom($resource) {
		var service = $resource('/api/tr-materials-custom/searchvalue/:search/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialGeofenceSearch', TrMaterialGeofenceSearch);

	TrMaterialGeofenceSearch.$inject = ['$resource'];

	function TrMaterialGeofenceSearch($resource) {
		var service = $resource('/api/tr-materials/geofence-searchvalue/:geofenceId/:search', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialGeofenceSearchCustom', TrMaterialGeofenceSearchCustom);

	TrMaterialGeofenceSearchCustom.$inject = ['$resource'];

	function TrMaterialGeofenceSearchCustom($resource) {
		var service = $resource('/api/tr-materials-custom/geofence-searchvalue/:geofenceId/:search/:fromDate/:toDate', {}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrMaterialGroup', TrMaterialGroup);

	TrMaterialGroup.$inject = ['$resource', 'DateUtils'];

	function TrMaterialGroup($resource, DateUtils) {
		var resourceUrl = 'api/tr-materials-group';

		return $resource(resourceUrl, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialGroupSearch', TrMaterialGroupSearch);

	TrMaterialGroupSearch.$inject = ['$resource'];

	function TrMaterialGroupSearch($resource) {
		var service = $resource('/api/tr-materials-group/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialGroupPrioritySearch', TrMaterialGroupPrioritySearch);

	TrMaterialGroupPrioritySearch.$inject = ['$resource'];

	function TrMaterialGroupPrioritySearch($resource) {
		var service = $resource('/api/tr-materials-group/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialGroupPriority', TrMaterialGroupPriority);

	TrMaterialGroupPriority.$inject = ['$resource'];

	function TrMaterialGroupPriority($resource) {
		var service = $resource('/api/tr-materials-group/priority/:priority', {
			priority: '@priorirty'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialImages', TrMaterialImages);

	TrMaterialImages.$inject = ['$resource'];

	function TrMaterialImages($resource) {
		var service = $resource('/api/material-images/:materialId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialsForType', TrMaterialsForType);

	TrMaterialsForType.$inject = ['$resource'];

	function TrMaterialsForType($resource) {
		var service = $resource('/api/trmaterialsbytype/:materialTypeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}

})();
 (function () {
	'use strict';

	angular.module('trakeyeApp').factory('NearByBGOH', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (data,success,error) {
			$http.post('api/tr-materials/nearby-bgoh-assets',data).then(function (response) {
				success(response.data);
			},function (response) {
				error(response.status);
			});
		};

		return service;
	}]);
})();  

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialRecordings', TrMaterialRecordings);

	TrMaterialRecordings.$inject = ['$resource'];

	function TrMaterialRecordings($resource) {
		var service = $resource('/api/material-recordings/:materialId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllMaterialTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/material-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialPrioritySearch', TrMaterialPrioritySearch);

	TrMaterialPrioritySearch.$inject = ['$resource'];

	function TrMaterialPrioritySearch($resource) {
		var service = $resource('/api/tr-materials/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrMaterialUpdateGroup', TrMaterialUpdateGroup);

	TrMaterialUpdateGroup.$inject = ['$resource'];

	function TrMaterialUpdateGroup($resource) {
		var resourceUrl = 'api/tr-materials/groups';

		return $resource(resourceUrl, {}, {
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrMaterialBulkDelete', TrMaterialBulkDelete);

	TrMaterialBulkDelete.$inject = ['$resource'];

	function TrMaterialBulkDelete($resource) {
		var resourceUrl = 'api/tr-materials/bulk/delete';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialUser', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.gettrmaterialsuser = function (callback) {
			$http.get('api/tr-materials/live-logs').then(function (response) {
				callback(response.data);
			});
		};

		service.gettrmaterialsuserbyid = function (id, callback) {
			$http.get('api/tr-materials/live-logs/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.searchtrmaterialsuserbyvalue = function (id, callback) {
			$http.get('api/tr-materials/search/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.gettrmaterialsanduserbypriority = function (priority, callback) {
			$http.get('api/tr-materials/live-logs/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		service.getAgents = function (callback) {
			$http.get('api/dashboard/agentdashboard').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialEdit', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getalltrmaterials = function (callback) {
			$http.get('api/tr-allmaterials').then(function (response) {
				callback(response.data);
			});
		};

		service.edittrmaterial = function (data, callback) {
			$http.post('api/tr-materialedit/' + data.userId + '/' + data.materialId, {

			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {

				callback(error, error.headers);
			});

			/*
			 * $http.post('api/tr-materialedit/'+data.userId+'/'+data.materialId).then(function(response){
			 * callback(response.data); });
			 */
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrMaterialUpload', TrMaterialUpload);

	TrMaterialUpload.$inject = ['$http'];

	function TrMaterialUpload($http) {

		var service = {};
		service.trmaterialupload = function (data, callback) {

			$http.post('api/materialimport', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupMaterialSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrmaterialformap = function (search, callback) {
			$http.get('api/tr-groupmaterialsformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupMaterialForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllMaterials = function (callback) {
			$http.get('api/tr-groupmaterialsformap').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrmaterialformap = function (search, callback) {
			$http.get('api/tr-materialsformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};

		service.prioritysearchtrmaterialformap = function (priority, callback) {
			$http.get('api/tr-materialsformap/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('TrMaterialLastLocation', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			service.getlastlogs = function (callback) {
				$http.get('api/location-logs/lastuserpath').then(function (response) {
					callback(response.data);
				});
			};
			return service;
		}]);



})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('MaterialsForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.materialsformapbyadmin = function (adminid, callback) {
			$http.get('api/tr-materialsformap/' + adminid).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrMaterialForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllMaterials = function (data, callback) {
			// $http.get('api/tr-materialsformap').then(function (response) {
			// 	callback(response.data);
			// });
			$http.post('api/tr-materialsformap', data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ShowMaterialById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (materialid, callback) {
            $http.put('api/show-material/' + materialid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('HideMaterialById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (materialid, callback) {
            $http.put('api/hide-material/' + materialid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('MaterialByDates', MaterialByDates)
		.factory('MaterialDates', MaterialDates);

	MaterialByDates.$inject = ["$resource", "DateUtils"];

	function MaterialByDates($resource, DateUtils) {
		var resourceUrl = "api/materials-by-entity-date/:type/:id/date/:date";

		return $resource(
			resourceUrl,
			{ type: '@type', id: '@id', date: '@date' },
			{
				query: {
					method: "GET",
					isArray: true,
				},
				get: {
					method: "GET",
					transformResponse: function (data) {
						if (data) {
							data = angular.fromJson(data);
						}
						console.log(data);
						return data;
					},
				}
			}
		);
	}

	MaterialDates.$inject = ["$resource"];

	function MaterialDates($resource) {
		var resourceUrl = "api/materialdates-by-entity/:type/:id";

		return $resource(
			resourceUrl,
			{ type: '@type', id: '@id' },
			{
				query: {
					method: "GET",
					isArray: true
				}
			}
		);
	}
})();
(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('geofenceMaterial', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			// Paginated POST API
			  service.getPage = function (data, page, size, sort, callback, errorCallback) {

            var url = "api/rollout/mtrl-tx"
                + "?page=" + page
                + "&size=" + size
                + "&sort=" + sort;

				var payload = {
					sectionIds: [],
					routeIds: [],
					projectIds: [],
					taskIds: [],
					vendorIds: [],
					geofenceIds: [data.geofenceId],
					caseIds: []
				};

				$http.post(url, payload).then(function (response) {
					if (callback) callback(response.data, response.headers);
				}, function (error) {
					console.error("API error:", error);
					if (errorCallback) errorCallback(error);
				});
			};
				service.deleteLogMtrlTx = function (payload) {
					return $http({
						method: 'DELETE',
						url: 'api/rollout/delete-log-mtrl-tx',
						data: payload,
						headers: {
							'Content-Type': 'application/json'
						}
					});
				};
				service.updateLogMtrlTx = function (payload) {
                return $http.put("api/rollout/bulk-log-mtrl-tx", payload);
                };
				service.getCumulativeSummary=function(geofenceId, page, size, success, error) {
					var url = 'api/rollout/mtrl-tx-summary/geofence/' + geofenceId;
					return $http.get(url, {
						params: {
							page: page,
							size: size,
							sort: 'materialName,asc'
						}
					}).then(function (res) {
						success(res.data,res.headers);		
	                }, error);
				}

			return service;
			
		}]);
})();


(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrMaterialController", TrMaterialController);

    TrMaterialController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "$compile",
        "TrMaterial",
        "ParseLinks",
        "AlertService",
        "pagingParams",
        "paginationConstants",
        "TrMaterialSearch"
    ];

    function TrMaterialController(
        $scope,
        $rootScope,
        $state,
        $compile,
        TrMaterial,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        TrMaterialSearch
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        if ($scope.tab == 1) {
            filterSearch();
        }

        function loadAll() {
            TrMaterial.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.materials = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.materials.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var searchVal = "";
                if (
                    $scope.search != null &&
                    $scope.search != "" &&
                    !angular.isUndefined($scope.search)
                ){
                    searchVal = $scope.search.replace(/[^\w\s]/g, '_');
                }
                
                TrMaterialSearch.query(
                    {
                        search: searchVal,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.materials = [];
                    data.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.materials.push(value);
                    });
                    vm.page = pagingParams.page;
                }
    
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }
        
        function transition() {
            var searchVal = "";
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ){
                searchVal = $scope.search.replace(/[^\w\s]/g, '_');
            }
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: searchVal,
            });
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("trakeyeApp")
    .controller("geofenceMaterialController", geofenceMaterialController);

  geofenceMaterialController.$inject = [
    "$scope",
    "AllGeofenceIDs",
    "geofenceMaterial",
  ];

  function geofenceMaterialController(
    $scope,
    AllGeofenceIDs,
    geofenceMaterial
  ) {
    var vm = this;

    vm.geofencesList = [];
    vm.selectedGeofenceId = null;
    vm.selectedGeofenceName = "";
    vm.loading = false;

    vm.resTxSummary = [];
    vm.incidentGroups = [];
    vm.cumulativeData = [];

    vm.incPage = 0;
    vm.incUiPage = 1;
    vm.incItemsPerPage = 10;
    vm.incTotalItems = 0;
    vm.today = new Date();

    vm.visibleIncidents = [];
    vm.getGeofenceList = function () {
      AllGeofenceIDs.getAll(function (response) {
        var list = response || [];
        var result = [];

        for (var i = 0; i < list.length; i++) {
          if (
            list[i].geofenceType === "MASTER" ||
            list[i].geofenceType === "MINI"
          ) {
            result.push({
              id: list[i].id,
              nameZone: list[i].name,
            });
          }
        }
        vm.geofencesList = result;
      });
    };
    vm.getGeofenceList();

    $scope.$watch("vm.selectedGeofenceId", function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        vm.incUiPage = 1;
        vm.incPage = 0;
        for (var i = 0; i < vm.geofencesList.length; i++) {
          if (vm.geofencesList[i].id === newVal) {
            vm.selectedGeofenceName = vm.geofencesList[i].nameZone;
            break;
          }
        }
        vm.loadMaterialData();
      }
    });
    vm.clearAll = function () {
      vm.resTxSummary = [];
      vm.incidentGroups = [];
      vm.cumulativeData = [];
      vm.visibleIncidents = [];
      vm.incTotalItems = 0;
    };

    vm.loadMaterialData = function () {
      if (!vm.selectedGeofenceId) return;

      vm.loading = true;
      vm.resTxSummary = [];
      vm.incidentGroups = [];
      vm.cumulativeData = [];
      vm.visibleIncidents = [];

      geofenceMaterial.getPage(
        { geofenceId: vm.selectedGeofenceId },
        vm.incPage,
        vm.incItemsPerPage,
        "last_modified_date,desc",
        function (data, headers) {
          vm.MaterialList = data || [];
          vm.incTotalItems = headers("X-Total-Count");
          vm.resTxSummary = vm.MaterialList;
          vm.incidentGroups = groupByIncident(vm.MaterialList);
          vm.visibleIncidents = vm.incidentGroups;
          vm.loadAllCumulativeData();
          vm.loading = false;
        },
        function () {
          vm.loading = false;
        }
      );
    };

    vm.incPageChanged = function () {
      vm.incPage = vm.incUiPage - 1;
      vm.loadMaterialData();
    };

    vm.toggleIncident = function (inc) {
      inc.expanded = !inc.expanded;
    };

    vm.toggleDate = function (dt) {
      dt.expanded = !dt.expanded;
    };
    function groupByIncident(list) {
      var map = {};
      var result = [];

      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var caseId = item.caseId || "NO INCIDENT";

        if (!map[caseId]) {
          map[caseId] = {
            caseId: caseId,
            mainDate: new Date(item.transactionDate),
            businessArea: item.businessAreaName,
            operationalArea: item.operationalAreaName,
            firstName: item.createdByUserFName,
            expanded: false,
            materials: {}   
          };
        }

        var material = item.materialName || "Unknown";
        var type = item.transactionType;
        var units = Number(item.noOfUnits) || 0;

        if (!map[caseId].materials[material]) {
          map[caseId].materials[material] = {
            materialName: material,
            unit: item.unitOfMeasurement,
            REQUESTED: 0,
            RECEIVED: 0,
            UTILIZED: 0,
            WASTAGE: 0,
            RECOVERED: 0,
            txItems: [] 
          };
        }

        map[caseId].materials[material][type] += units;
        map[caseId].materials[material].txItems.push(item);
      }

      for (var k in map) {
        map[k].materialList = [];

        for (var m in map[k].materials) {
          var row = map[k].materials[m];
          row.STOCK = row.REQUESTED + row.RECOVERED;
          map[k].materialList.push(row);
        }

        result.push(map[k]);
      }

      result.sort(function (a, b) {
        return b.mainDate - a.mainDate;
      });

      return result;
    }

    vm.formatUnit = function (value, unit) {
      value = value || 0;
      if (!unit) return value;

      unit = unit.toLowerCase();

      if (unit.indexOf("meter") !== -1 || unit.indexOf("mtr") !== -1) {
        return value + " Mtrs";
      }
      if (unit.indexOf("number") !== -1) {
        return value + " Numbers";
      }
      return value + " " + unit;
    };


    vm.downloadCSV = function () {

      if (!vm.visibleIncidents || !vm.visibleIncidents.length) {
        alert('No data available to download.');
        return;
      }

      var header = [
        'Ticket ID',
        'Date',
        'Block Name',
        'Business Area',
        'Operational Area',
        'First Name',
        'Material Name',
        'Unit',
        'REQUESTED',
        'RECEIVED',
        'UTILIZED',
        'RECOVERED',
        'STOCK'
      ];

      var rows = [header.join(',')];

      for (var i = 0; i < vm.visibleIncidents.length; i++) {

        var inc = vm.visibleIncidents[i];

        var dateStr = formatDateForCsv(inc.mainDate);

        for (var j = 0; j < inc.materialList.length; j++) {

          var m = inc.materialList[j];

          rows.push([
            quoteCsv(inc.caseId),
            quoteCsv(dateStr),
            quoteCsv(vm.selectedGeofenceName),
            quoteCsv(inc.businessArea || '-'),
            quoteCsv(inc.operationalArea || '-'),
            quoteCsv(inc.firstName || '-'),
            quoteCsv(m.materialName),
            quoteCsv(m.unit),
            quoteCsv(m.REQUESTED),
            quoteCsv(m.RECEIVED),
            quoteCsv(m.UTILIZED),
            quoteCsv(m.RECOVERED),
            quoteCsv(m.STOCK)
          ].join(','));
        }
      }

      var blob = new Blob([rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');

      link.href = URL.createObjectURL(blob);
      link.download = vm.selectedGeofenceName+'_Material_Transactions.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };


    function quoteCsv(value) {
      if (value === null || value === undefined) return '""';
      return '"' + String(value).replace(/"/g, '""') + '"';
    }

    function formatDateForCsv(date) {
      var d = new Date(date);
      return d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();
    }


    function formatDate(date) {
      var d = new Date(date);
      return (
        ("0" + d.getDate()).slice(-2) +
        "-" +
        ("0" + (d.getMonth() + 1)).slice(-2) +
        "-" +
        d.getFullYear()
      );
    }
   
    //open delete modal popup window
    vm.openDeleteMaterialModal = function (material, inc) {
      vm.selectedMaterial = material;
      vm.selectedInc = inc;
      vm.deletefail = false;
      angular.element("#deleteModal").modal("show");
    };

    //confirm delete material 
    vm.confirmDeleteMaterial = function () {
      var payload = [];

      for (var i = 0; i < vm.selectedMaterial.txItems.length; i++) {
        payload.push(vm.selectedMaterial.txItems[i].id);
      }

      geofenceMaterial.deleteLogMtrlTx(payload).then(
        function () {
          vm.selectedMaterial.txItems.forEach(function (tx) {
            var idx = vm.MaterialList.indexOf(tx);
            if (idx > -1) vm.MaterialList.splice(idx, 1);
          });
          vm.visibleIncidents = groupByIncident(vm.MaterialList);
          angular.element("#deleteModal").modal("hide");
          vm.clearDelete();
        },
        function () {
          vm.deletefail = true;
        }
      )
    };
    
    //clear delete modal
    vm.clearDelete = function () {
      vm.selectedMaterial = null;
      vm.selectedInc = null;
      vm.selectedIndex = null;
      vm.deletefail = false;
    };

    //edit material 
    vm.editMaterial = function (material, inc) {
      var lastTx = material.txItems[material.txItems.length - 1];

      vm.editMaterialData = angular.copy(lastTx);
      vm.selectedMaterial = material;
      vm.updating = false;

      angular.element("#editModal").modal("show");
    };

    //confirm edit material 
    vm.confirmEditMaterial = function () {
      vm.updating = true;

      var payload = [vm.editMaterialData];

      geofenceMaterial.updateLogMtrlTx(payload).then(
        function () {
          for (var i = 0; i < vm.MaterialList.length; i++) {
            if (vm.MaterialList[i].id === vm.editMaterialData.id) {
              vm.MaterialList[i].noOfUnits = vm.editMaterialData.noOfUnits;
              vm.MaterialList[i].transactionType =
                vm.editMaterialData.transactionType;
            }
          }

          vm.visibleIncidents = groupByIncident(vm.MaterialList);

          angular.element("#editModal").modal("hide");
          vm.clearEdit();
        },
        function () {
          vm.updating = false;
        }
      )
    };

    //clear edit modal
    vm.clearEdit = function () {
      vm.editMaterialData = null;
      vm.selectedInc = null;
      vm.selectedIndex = null;
      vm.updating = false;
    };
    vm.cumItemsPerPage = 10
    vm.loadAllCumulativeData = function () {
      if (!vm.selectedGeofenceId) return;

      vm.cumPage = 0;
      vm.cumulativeData = [];
      vm._grouped = {};

      fetchPage();
    };
    function fetchPage() {
      geofenceMaterial.getCumulativeSummary(
        vm.selectedGeofenceId,
        vm.cumPage,
        vm.cumItemsPerPage,
        function (data, headers) {
          if (!data || data.length === 0) {
            finalizeGroupedData();
            return;
          }
          data.forEach(function (item) {
            var name = item.materialName;

            if (!vm._grouped[name]) {
              vm._grouped[name] = {
                materialName: name,
                REQUESTED: 0,
                RECEIVED: 0,
                UTILIZED: 0,
                WASTAGE: 0,
                RECOVERED: 0
              };
            }
            var type = item.transactionType;
            vm._grouped[name][type] += item.totalNoOfUnits || 0;
          });
          vm.cumPage++;
          fetchPage();
        }
      );
    }

    function finalizeGroupedData() {
      vm.cumulativeData = [];

      for (var key in vm._grouped) {
        var row = vm._grouped[key];
        row.STOCK = (row.REQUESTED || 0) + (row.RECOVERED || 0);
        vm.cumulativeData.push(row);
      }
    }

    vm.downloadCumulativeCSV = function () {
      if (!vm.cumulativeData || !vm.cumulativeData.length) {
        alert("No data to download");
        return;
      }
      var csv = "Till Date,Material Name,REQUESTED,RECEIVED,UTILIZED,WASTAGE,RECOVERED,STOCK\n";
      var formattedDate =
        vm.today.getFullYear() + "-" +
        (vm.today.getMonth() + 1) + "-" +
        vm.today.getDate();
      vm.cumulativeData.forEach(function (row) {
        csv +=
          formattedDate + ',' +
          '"' + row.materialName + '",' +
          row.REQUESTED + ',' +
          row.RECEIVED + ',' +
          row.UTILIZED + ',' +
          row.WASTAGE + ',' +
          row.RECOVERED + ',' +
          row.STOCK + "\n";
      });

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      var link = document.createElement("a");

      link.href = URL.createObjectURL(blob);
      link.download = vm.selectedGeofenceName+"_cumulative_report.csv";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
})();

(function() {
    'use strict';

    angular.module('trakeyeApp').controller('TrCaseWorkFlowController', TrCaseWorkFlowController);

    TrCaseWorkFlowController.$inject = ['$scope', '$state', '$stateParams', 'entity', 'AlertService', 'TrCase', 'AssetGroupSearch', 'AssetGroup', 'AllCaseTypes', 'AllCustomCaseTypeAttribute', 'AllCustomAssetTypeAttribute', 'UserGroupIDs', 'ActivatedUserSearch', 'AllAssetsTypes', 'AssetType', 'TrCaseCheckAsset'];

    function TrCaseWorkFlowController($scope, $state, $stateParams, entity, AlertService, TrCase, AssetGroupSearch, AssetGroup, AllCaseTypes, AllCustomCaseTypeAttribute, AllCustomAssetTypeAttribute, UserGroupIDs, ActivatedUserSearch, AllAssetsTypes, AssetType, TrCaseCheckAsset) {
        var vm = this;

        vm.trCase = entity;
        var entity_old = angular.copy(vm.trCase);
        vm.filterActivatedUser = filterActivatedUser;
        vm.selectattributes = selectedCaseTypeAttributes;
        vm.saveEditAsset = saveEditAsset;
        vm.selectedGroup = selectedGroup;
        var openedInfoWindow = null;
        vm.connectSelectedAssets = connectSelectedAssets;
		vm.saveLinkPits = saveLinkPits;
		vm.connectMultipleAssets = connectMultipleAssets;
		vm.hideConnectMultipleAssetsModal = hideConnectMultipleAssetsModal;
		vm.searchAssetName = searchAssetName;
		vm.refreshPage = refreshPage;
        vm.connectAssets = connectAssets;
		vm.recalculate = recalculate;
        vm.isSiteASelected = false;
        vm.isSiteBSelected = false;
        vm.selectedSiteA = {};
        vm.selectedSiteB = {};
		vm.linkAssetType = null;
		vm.manholeAssetType = null;
	
        vm.editAsset = editAsset;
        vm.caseTypes = [];
        vm.multigroup = [];
        vm.assetType = [];
        var parentSite = []; 

        vm.deleteAssetModal = deleteAssetModal;
        vm.confirmDeleteAsset = confirmDeleteAsset;
        vm.cleardeleteAsset = cleardeleteAsset;
        vm.clearCreateAsset = clearCreateAsset;
        var deleteAssetName = null;
        vm.createAssetModal = createAssetModal;
        vm.createAsset = createAsset;
        vm.assetNameVal = null;
        vm.assetLat = null;
        vm.assetLong = null;
        var createAssetData = {};

        vm.customAttributesMap = {};
        var usersMap = {};
        var mappedAssetTemp = {};
        vm.mappedAssetsList = [];
		vm.tempLinkWithPits = [];
		vm.deletedAssetsList = [];
        var selectedGroup = [];
        var assetsPlanningMap = null;
        var assetsDeployedMap = null;
        vm.isShowing = true;
        vm.save = save;
        vm.handleTabClick = handleTabClick;
        vm.assetExisting = false;
        $scope.search = null;
        vm.assets = [];
        vm.showAssetCreation = false;
        vm.showAssetName = false;
		var centerlatlng = null;
        vm.hideUser = true;
        var marker = null;
//        vm.searchAssets = searchAssets;
        var editAssetMap = null;
        vm.validUser = true;
        vm.assignedUsers = [];
        vm.validUser = true;
        vm.hideConnectSitesModal = hideConnectSitesModal;
        vm.previousId = sessionStorage.getItem("prevEditId");
        if(vm.previousId) {
            vm.validUser = false;
        }
        $scope.tab = 1;
        vm.siteAssets = [];
        if ($scope.tab == 1) {
            vm.toggleFirst = true;
            vm.toggleSecond = false;
            vm.toggleThird = false;
            AllCaseTypes.getAll(function(response) {
                vm.caseTypes = response;
            });

            AllCustomCaseTypeAttribute.getAll(function(response) {
                response.forEach(function(arrayItem) {
                    vm.customAttributesMap[arrayItem.name] = arrayItem.customCaseTypeAttributeValues;
                });
            });

            if (vm.trCase.id != null) {
				vm.hideUser = false;
                vm.trCase.groups.forEach(function(group) {
                    selectedGroup.push(group.id);
                });
            }

            UserGroupIDs.getAll(function(response) {
                response.forEach(function(group) {
                    if (selectedGroup.indexOf(group.id) !== -1) {
                        vm.multigroup.push({ name: group.name, id: group.id, ticked: true });
                    } else {
                        vm.multigroup.push({ name: group.name, id: group.id, ticked: false });
                    }
                });
            });
            AllAssetsTypes.getAll(function(response) {
                response.forEach(function(assettype) {
                    vm.assetType.push(assettype);
                });
            });

            AllCustomAssetTypeAttribute.getAll(function(response) {
                response
                    .forEach(function(arrayItem) {
                        vm.customAttributesMap[arrayItem.name] = arrayItem.customAssetTypeAttributeValues;
                    });
            });

            if (vm.trCase.id != null) {
                vm.trCase.caseAssets.forEach(function(asset) {
                    asset.isChecked = true;
                    vm.mappedAssetsList.push(asset);
                    vm.isShowing = false;
                    $scope.toggle = true;
                });
                vm.caseType = entity.caseType;
            }
        }

        $scope.isSet = function(tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function(newTab) {
            $scope.tab = newTab;
            $scope.search = "";

            if($scope.tab == 1){
                vm.toggleFirst = true;
                vm.toggleSecond = false;
                vm.toggleThird = false;
            }else if ($scope.tab == 2) {
                vm.toggleFirst = false;
                vm.toggleSecond = true;
                vm.toggleThird = false;
                initPlanningMap();
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                        createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                    } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                        var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                        drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                    }
                }
				
				AssetType.query(function(data) {
                    data.forEach(function(item) {
                        if (item.name == "Link") {
							vm.linkAssetType = {};
							vm.linkAssetType.assetType = item;
                            vm.linkAssetType.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(vm.linkAssetType.assetType);
//                            $.each(vm.linkAssetType.assetType.assetTypeAttributes,function(key, value) {
//                                vm.linkAssetType.assetTypeAttributeValues.push({
//                                        assetTypeAttribute: vm.linkAssetType.assetType.assetTypeAttributes[key]
//                                    });
//                            });
						} else if (item.name == "Manhole") {
							vm.manholeAssetType = {};
							vm.manholeAssetType.assetType = item;
                            vm.manholeAssetType.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(vm.manholeAssetType.assetType);
//                            $.each(vm.manholeAssetType.assetType.assetTypeAttributes,function(key, value) {
//                                vm.manholeAssetType.assetTypeAttributeValues.push({
//                                        assetTypeAttribute: vm.manholeAssetType.assetType.assetTypeAttributes[key]
//                                    });
//                            });
						}
					});
				});
				
            } else if ($scope.tab == 3) {
				vm.toggleFirst = false;
                vm.toggleSecond = false;
                vm.toggleThird = true;
				var totalCost = 0;
                var totalPowerBudget = 0;
				var totalFiberDistance = 0.0;
                for (var assetIndex = 0; assetIndex < vm.mappedAssetsList.length; assetIndex++) {
					if(vm.mappedAssetsList[assetIndex].name != null){
	                    var assetAV = vm.mappedAssetsList[assetIndex].assetTypeAttributeValues;
	                    var isSpread = false;
	                    var fiberDistance = 0.0;
	
						if (vm.mappedAssetsList[assetIndex].assetType.layout == "SPREAD") {
							isSpread = true;
		                    var spreadAV = vm.mappedAssetsList[assetIndex].assetTypeAttributeValues;
		                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
		                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
		                          	fiberDistance = parseFloat("0"+spreadAV[spreadAssetIndex].attributeValue);
		                        }
		                    }
		                }
	
	                    assetAV.forEach(function(item) {
	                        var value = 0;
	                        if (item.attributeValue != null) {
	                            value = parseFloat(item.attributeValue);
	                        } else {
	                            value = parseFloat(item.assetTypeAttribute.defaultValue);
	                        }
	
	                        if (item.assetTypeAttribute.name == "Cost") {
	                            var tempCost = parseFloat(value);
	                            if (isSpread) {
	                                tempCost = parseFloat(value) * fiberDistance;
	                            }
	                            if (tempCost > 0) {
	                                totalCost += tempCost
	                            }
	                        }
	                        if (item.assetTypeAttribute.name == "Power Budget") {
	                            var tempPowerBudget = parseFloat(value);
	                            if (isSpread) {
	                                tempPowerBudget = parseFloat(value) * fiberDistance;
	                            }
	                            if (tempPowerBudget > 0) {
	                                totalPowerBudget += tempPowerBudget;
	                            }
	                        }
	                    });
						totalFiberDistance += fiberDistance;
					}
                }

                var caseAV = vm.trCase.caseTypeAttributeValues;
                for (var caseIndex = 0; caseIndex < caseAV.length; caseIndex++) {
                    if (caseAV[caseIndex].caseTypeAttribute.name === "Cost") {
                        caseAV[caseIndex].attributeValue = totalCost.toFixed(2);
                    }
                    if (caseAV[caseIndex].caseTypeAttribute.name === "Power Budget") {
                        caseAV[caseIndex].attributeValue = totalPowerBudget.toFixed(2);
                    }
					if (caseAV[caseIndex].caseTypeAttribute.name === "Fiber Distance") {
                        caseAV[caseIndex].attributeValue = totalFiberDistance.toFixed(2);
                    }
                }
                vm.trCase.caseTypeAttributeValues = caseAV;

                assetsDeployedMap = new google.maps.Map(document.getElementById('map_canvas_deployed'), {
                    center: {
                        lat: 5.431587,
                        lng: 101.128162
                    },
                    zoom: 13,
                    fullscreenControl: true
                });


                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                        createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsDeployedMap);
                    } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                        var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                        drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsDeployedMap, "yellow");
                    }
                }

                if (vm.mappedAssetsList.length > 0) {
                    vm.trCase.pinLat = vm.mappedAssetsList[0].assetCoordinates[0].latitude;
                    vm.trCase.pinLong = vm.mappedAssetsList[0].assetCoordinates[0].longitude;
                    vm.trCase.address = '';
                    if (vm.trCase.id == null) {
                        vm.trCase.status = "NEW";
                    }
                }
                if (vm.mappedAssetsList.length > 0) {
                    assetsDeployedMap.setCenter(new google.maps.LatLng(vm.mappedAssetsList[0].assetCoordinates[0].latitude, vm.mappedAssetsList[0].assetCoordinates[0].longitude));
                }
//
//				var pointA = new google.maps.LatLng(12.917358683134225,77.62311194634297);
//            	var pointB = new google.maps.LatLng(12.915999226925456,77.63823960497554);
//
//				getPointsRoute(pointA, pointB, assetsDeployedMap, 200);
            }
        }

        function handleTabClick($event) {
            $event.preventDefault();
            $event.stopImmediatePropagation();
        }

        function clearCreateAsset() {
            $("#create-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#create-asset").hide();
        }

        function createAssetModal(item) {
			vm.assetExisting = false;
			if(item.name == "LINK_WITH_MH"){
				connectMultipleAssets();
			}else{
	            vm.CreateAssetName = item.name;
	            vm.assetNameVal = null;
	            vm.assetLat = null;
	            vm.assetLong = null;
	            $('#create-asset').show();
	            createAssetData = item;
	            vm.showAssetName = false;
                vm.parentAsset = null;
			}
        }

		function getConsolidatedAssetTypeAttributeValue(assetType){
			var assetTypeAttributeValuesList = [];

            for (var index in assetType.assetTypeAttributes) {
                var assetTypeAttribute1 = assetType.assetTypeAttributes[index];
                assetTypeAttributeValuesList.push({ 'assetTypeAttribute': assetTypeAttribute1, 'attributeValue': assetType.assetTypeAttributes[index].defaultValue });
            }

            assetTypeAttributeValuesList
                .sort(function(a, b) {
                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                        nameB = b.assetTypeAttribute.name.toLowerCase()
                    if (nameA < nameB) // sort string ascending
                        return -1
                    if (nameA > nameB)
                        return 1
                    return 0 // default return value (no sorting)
                });
            return assetTypeAttributeValuesList;
		}

        function searchAssetName() {
            vm.assetExisting = false;
            var searchName = vm.assetNameVal;
            vm.showAssetCreation = false;
            if (searchName != undefined && searchName.length > 2) {
                TrCaseCheckAsset.get({ name: searchName }, function (checkAsset) {
                    if (checkAsset.name == searchName) {
                        vm.assetExisting = true;
                        vm.showAssetCreation = true;
                    } else if (vm.mappedAssetsList.length > 0) {
                        vm.mappedAssetsList.forEach(function (maplist) {
                            if (maplist.name == searchName) {
                                vm.assetExisting = true;
                                vm.showAssetCreation = true;
                            }
                        });
                    }
                });
            }
        }
		
		function refreshPage(){
			if (marker != null) {
                marker.setMap(null);
            }

			initPlanningMap();
            
			for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                }
            }
		}
		
		function createAsset() {
            var assetName = vm.assetNameVal;
            vm.assetExisting = false;
            var coOrdinate =  [];
            parentSite = [];
            if (marker != null) {
                marker.setMap(null);
            }
            if (vm.parentAsset != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.parentAsset == vm.mappedAssetsList[i].name) {
                        parentSite.push(vm.mappedAssetsList[i]);
                        coOrdinate.push({
                            lat: vm.mappedAssetsList[i].assetCoordinates[0].latitude,
                            lng: vm.mappedAssetsList[i].assetCoordinates[0].longitude
                        });
                        assetsPlanningMap = new google.maps.Map(document.getElementById('map_canvas_planning'), {
                            center: coOrdinate[0],
                            zoom: 13,
                            fullscreenControl: true
                        });
                    }
                }
            } else {
                assetsPlanningMap = new google.maps.Map(document.getElementById('map_canvas_planning'), {
                    center: {
                        lat: 5.431587,
                        lng: 101.128162
                    },
                    zoom: 13,
                    fullscreenControl: true
                });
            }
             if(assetName && assetName.length > 2) {
                if (!isAssetAvailable(assetName)) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                            createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                        } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                            var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(vm.mappedAssetsList[i], assetCoordinateValues, assetsPlanningMap, "yellow");
                        }
                    }
                    mappedAssetTemp = {};
                    mappedAssetTemp.name = assetName;
                    mappedAssetTemp.description = assetName;
                    mappedAssetTemp.assetType = createAssetData;
                     // mappedAssetTemp.ownedBy = parentSite;
                     mappedAssetTemp.parentAsset = parentSite;
					var date = new Date();
					mappedAssetTemp.createDate = date.getTime();
                    mappedAssetTemp.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(createAssetData);
//                    createAssetData.assetTypeAttributeValues = [];
//                    $.each(createAssetData.assetTypeAttributes,function (key) {
//                            mappedAssetTemp.assetTypeAttributeValues.push({
//                                assetTypeAttribute: createAssetData.assetTypeAttributes[key]
//                            });
//                        });
//					
                    if (createAssetData.layout == 'SPREAD') {
                        drawingManagerSpread();
                        drawingManagerValue('polylinecomplete', assetsPlanningMap, false);
                    } else if (createAssetData.layout == 'FIXED') {
                        if (vm.assetLat > 0 && vm.assetLong > 0) {
                            vm.fixedArray = [];
                            var coordinates = {};
                            coordinates.latitude = vm.assetLat;
                            coordinates.longitude = vm.assetLong;

                            vm.fixedArray.push(coordinates);
                            mappedAssetTemp.assetCoordinates = vm.fixedArray;
                            addMappedAssets(mappedAssetTemp);
                            vm.isShowing = false;
                            initPlanningMap();
                            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i], assetCoordinateValues, assetsPlanningMap, "yellow");
                                }
                            }
                            var centerlatlng = {
                                lat: parseFloat(vm.assetLat),
                                lng: parseFloat(vm.assetLong)
                            };
                            assetsPlanningMap.setCenter(centerlatlng);
                        } else if(vm.parentAsset != null){
                            // setValues();
                            drawingManagerFixed();
                            drawMarker(assetsPlanningMap, JSON.stringify(coOrdinate));
                        } 
                        else {
                            drawingManagerFixed();
                            drawingManagerValue('click', assetsPlanningMap);
                        }
                    }
                } else {
                    initPlanningMap();
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                            createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                        } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                            var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(vm.mappedAssetsList[i], assetCoordinateValues, assetsPlanningMap, "yellow");
                        }
                    }
                }
                $("#create-asset").removeClass("in");
                $(".modal-backdrop").remove();
                $("#create-asset").hide();
            }
        }

        function initPlanningMap() {
            assetsPlanningMap = new google.maps.Map(document.getElementById('map_canvas_planning'), {
                center: {
                    lat: 5.431587,
                    lng: 101.128162
                },
                zoom: 13,
                fullscreenControl: true
            });
            if (vm.mappedAssetsList.length > 0) {
                assetsPlanningMap.setCenter(new google.maps.LatLng(vm.mappedAssetsList[0].assetCoordinates[0].latitude, vm.mappedAssetsList[0].assetCoordinates[0].longitude));
            }
        }

		function getPointsRoute(assetA, assetB, map, dist) {
            	var pointA = new google.maps.LatLng(assetA.assetCoordinates[0].latitude,assetA.assetCoordinates[0].longitude);
            	var pointB = new google.maps.LatLng(assetB.assetCoordinates[0].latitude,assetB.assetCoordinates[0].longitude);


			var directionsService = new google.maps.DirectionsService;
            
			directionsService.route({
                origin: pointA,
                destination: pointB,
                travelMode: google.maps.TravelMode.DRIVING
            }, function(response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
					var route = response.routes[0];
	                var az = 0;
	                for (var i = 0; i < route.legs.length; ++i) {
	                    if (route.legs[i].distance) {
	                        az += route.legs[i].distance.value;
	                    }
	                }
	                dist = Math.max(dist, Math.round(az / 100));
	                var markerPoints = gMilestone(route, dist);
					var polylinePathPoints = gMilestone(route, 100);
					var responsePaths = response.routes;
                    vm.spreadArray = [];
                    var overViewPath = route.overview_path;
                    polylinePathPoints.forEach(function(value) {
                        var coordinates = {};
                        coordinates.latitude = value.lat();
                        coordinates.longitude = value.lng();
                        vm.spreadArray.push(coordinates);
                    });
					var newLinkAsset = {};
					newLinkAsset.name = assetA.name + "-"+ assetB.name;
					newLinkAsset.description = newLinkAsset.name;
					newLinkAsset.assetCoordinates = vm.spreadArray;
					newLinkAsset.assetType = vm.linkAssetType.assetType;
					var fiberDistance = 0.0;
                    var spreadCoordinates = newLinkAsset.assetCoordinates;
                    if (spreadCoordinates.length > 0) {
                        for (var index in spreadCoordinates) {
                            if (index > 0) {
                                fiberDistance += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
                            }
                        }
                    }
	                fiberDistance = fiberDistance.toFixed(2);
                    var spreadAV = vm.linkAssetType.assetTypeAttributeValues;
                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
                            spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
                        }
                    }
                    newLinkAsset.assetTypeAttributeValues = spreadAV;
					newLinkAsset.isChecked = true;
					vm.tempLinkWithPits.push(newLinkAsset);
					//drawPolylineForSelectedPath(assetA.name + "-"+ assetB.name, vm.fixedArray, map, 0);
					markerPoints.forEach(function(point, index){
						var newManholeAsset = {};
						newManholeAsset.name = assetA.name + "-"+ assetB.name + " Pit"+ (index+1);
						newManholeAsset.description = newManholeAsset.name;
						newManholeAsset.assetType = vm.manholeAssetType.assetType;
						newManholeAsset.assetTypeAttributeValues = vm.manholeAssetType.assetTypeAttributeValues;
						vm.fixedArray = [];
						var coordinates = {};
                        coordinates.latitude = point.lat();
                        coordinates.longitude = point.lng();
                        vm.fixedArray.push(coordinates);
						newManholeAsset.assetCoordinates = vm.fixedArray;
						newManholeAsset.isChecked = true;
						vm.tempLinkWithPits.push(newManholeAsset);
					});
//					map.clear();
					for (var i = 0; i < vm.tempLinkWithPits.length; i++) {
                        if (vm.tempLinkWithPits[i].assetType.layout == 'FIXED') {
                            createMarkerForSelectedAsset(vm.tempLinkWithPits[i], map);
                        } else if (vm.tempLinkWithPits[i].assetType.layout == 'SPREAD') {
                            var assetCoordinateValues = vm.tempLinkWithPits[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(vm.tempLinkWithPits[i], assetCoordinateValues, map, "yellow");
                        }
                    }
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
        }

		function saveLinkPits(){
			vm.tempLinkWithPits.forEach(function(asset){
				vm.mappedAssetsList.push(asset);
			});
			hideConnectMultipleAssetsModal();
		}
		function gMilestone(route, dist) {
			var path = route.overview_path;
			var geo = google.maps.geometry.spherical;
			var point = path[0];
			var distance = 0;
			var overflow = null;
			var pos = null;
			var leg = null;
			var pointsPosition = [];
			var d1 = 0;
			
		    for (var p = 1; p < path.length; ++p) {
		        leg = Math.round(geo.computeDistanceBetween(point, path[p]));
		        d1 = distance + 0
		        distance += leg;
		        overflow = dist - (d1 % dist);
		
		        if (distance >= dist && leg >= overflow) {
		            if (overflow && leg >= overflow) {
		                pos = geo.computeOffset(point, overflow, geo.computeHeading(point, path[p]));
						pointsPosition.push(pos);
		                distance -= dist;
		            }
		
		            while (distance >= dist) {
		                pos = geo.computeOffset(point, dist + overflow, geo.computeHeading(point, path[p]));
						pointsPosition.push(pos);
		                distance -= dist;
		            }
		        }
		        point = path[p]
		    }
		    return pointsPosition;
		}

        function createMarkerForSelectedAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = ({ lat: parseFloat(asset.assetCoordinates[0].latitude), lng: parseFloat(asset.assetCoordinates[0].longitude) });
				if(asset.assetType.name == "Manhole"){
					var iconSize = 4;
					var marker = new google.maps.Marker({
	                    position: myLatLng,
	                    map: map,
						icon: {
	                            scaledSize: new google.maps.Size(
	                                iconSize, iconSize),
	                            url: 'content/images/green_circle.png',
	                            anchor: new google.maps.Point(
	                                iconSize / 2, iconSize / 2),
	
	                        }
	                });
				}else{
	                var marker = new google.maps.Marker({
	                    position: myLatLng,
	                    map: map,
	                    icon: {
	                        url: 'content/images/yellow.png'
	                    },
	                    label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: asset.name, backgroundcolor: "#ff9800" },
	                });
				}
            }
        }

		function createMarkerForSiteAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = ({ lat: parseFloat(asset.assetCoordinates[0].latitude), lng: parseFloat(asset.assetCoordinates[0].longitude) });
				if(asset.assetType.name == "Manhole"){
					var iconSize = 4;
					var marker = new google.maps.Marker({
	                    position: myLatLng,
	                    map: map,
						icon: {
                                scaledSize: new google.maps.Size(
                                    iconSize, iconSize),
                                url: 'content/images/green_circle.png',
                                anchor: new google.maps.Point(
                                    iconSize / 2, iconSize / 2),

                            }
	                });
				}else{
	                var marker = new google.maps.Marker({
	                    position: myLatLng,
	                    map: map,
	                    icon: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
	                    label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: asset.name, backgroundcolor: "#ff9800" },
	                });
				}
            }
        }

        function drawPolylineForGeneratedLoc(asset, latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];

            latlngsToDraw.forEach(function(value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var ColorValue = '#ff0000';
                if (color == "red") {
                    ColorValue = '#ff0000';
                } else if (color == "black") {
                    ColorValue = '#000000';
                } else if (color == "yellow") {
                    ColorValue = '#F4A500';
                } else {
                    ColorValue = '#208000';
                }
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    var infoStr = "";
                    var otdr = "";
                    var infoWindowContent = "";
                    var assetTypeAttributeValuesList = asset.assetTypeAttributeValues;
                    assetTypeAttributeValuesList.forEach(function (attrValues) {
                        if(attrValues.attributeValue != undefined) {
                            vm.fiberLength = attrValues.attributeValue;
                        }
                        var home = attrValues;
                        var value = null;
                        if (home.attributeValue != undefined) {
                            value = home.attributeValue;
                        } else {
                            value = home.assetTypeAttribute.defaultValue;
                        }
                        infoStr += '<br><b>' +
                            home.assetTypeAttribute.name +
                            '</b> : ' +
                            value;
                        otdr = home;

                        infoWindowContent = '<div class="info_content">' +
                        '<b>' +
                        'Name' +
                            '</b> : ' +
                            asset.name +
                            '<br><b>' +
                            'Fiber Distance (km)' +
                            '</b> : ' +
                            vm.fiberLength +
                        '<hr></div><div>' + infoStr + '</div>';
                    })

                    var infoWindow2 = new google.maps.InfoWindow({
                        content: infoWindowContent,
                    });
                    infoWindow2.open(map);
                    infoWindow2.setPosition(event.latLng);
                    openedInfoWindow = infoWindow2;
                });
            }
        }

        function drawingManagerSpread() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYLINE,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polyline']
                },
                polylineOptions: {
                    fillColor: '#ffff00',
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: true,

                    editable: true,
                    zIndex: 1,
                    geodesic: true
                }
            });
        }

        function drawingManagerFixed() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.MARKER,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['marker']
                }
            });
        }

        function drawingManagerValue(option, map, isEdit) {
            if (option == 'polylinecomplete') {
                vm.isShowing = false;
                google.maps.event.addListener(vm.drawingManager, option,
                    function(event) {
                        google.maps.event.addListener(event.getPath(), 'insert_at', function() {
                            setGoefenceCoordinate(event, isEdit);
                        });
                        google.maps.event.addListener(event.getPath(), 'set_at', function(path) {
                            setGoefenceCoordinate(event, isEdit);
                        });
                        vm.drawingManager.setOptions({
                            drawingControl: false
                        });
                        vm.drawingManager.setMap(null);
                        setGoefenceCoordinate(event, isEdit);
						if (mappedAssetTemp.assetType.layout == "SPREAD") {
							var fiberDistance = 0.0;
		                    var spreadCoordinates = mappedAssetTemp.assetCoordinates;
		                    if (spreadCoordinates.length > 0) {
		                        for (var index in spreadCoordinates) {
		                            if (index > 0) {
		                                fiberDistance += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
		                            }
		                        }
		                    }
			                fiberDistance = fiberDistance.toFixed(2);
		                    var spreadAV = mappedAssetTemp.assetTypeAttributeValues;
		                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
		                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
		                            spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
		                        }
		                    }
		                    mappedAssetTemp.assetTypeAttributeValues = spreadAV;
		                }
                        addMappedAssets(mappedAssetTemp);
                    });
                vm.drawingManager.setMap(map);
            } else if (option == 'click') {
                vm.isShowing = false;
                marker = new google.maps.Marker({
                    position: location,
                    map: map
                });

                google.maps.event.addListener(map, 'click', function(e) {
                    placeMarker(e.latLng, map);
                    vm.fixedArray = [];
                    var coordinates = {};
                    coordinates.latitude = e.latLng.lat();
                    coordinates.longitude = e.latLng.lng();
                    vm.fixedArray.push(coordinates);
                    mappedAssetTemp.assetCoordinates = vm.fixedArray;
                    addMappedAssets(mappedAssetTemp);
                });
            }
        }

        function placeMarker(location, map) {
            if (marker) {
                if (location.lat != null && location.lng != null) {
                    marker.setPosition(location);
                }
            } else {
                marker = new google.maps.Marker({
                    position: location,
                    map: map
                });
            }
        }

        function addMappedAssets(newAsset) {
            if (!isAssetAvailable(newAsset.name)) {
                newAsset.isChecked = true;
                vm.mappedAssetsList.push(newAsset);
            }
			// initPlanningMap();
            // for (var i = 0; i < vm.mappedAssetsList.length; i++) {
            //     if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
            //         createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
            //     } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
            //         var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
            //         drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
            //     }
            // }
        }

        function isAssetAvailable(assetName) {
            var isAssetAvailable = false;

            vm.mappedAssetsList.forEach(function(assetVal) {
                if (assetVal.name === assetName) {
                    isAssetAvailable = true;
                }
            });
            return isAssetAvailable;
        }

        function selectedCaseTypeAttributes() {
            if (vm.caseType) {
                vm.trCase.caseType = vm.caseType;
                if (entity_old.caseType && vm.caseType.id === entity_old.caseType.id) {
                    vm.trCase.caseTypeAttributeValues = [];
                    vm.trCase.caseTypeAttributeValues = entity_old.caseTypeAttributeValues;
                } else {
                    vm.trCase.caseTypeAttributeValues = [];
                    $.each(vm.caseType.caseTypeAttribute, function(key, value) {
                        vm.trCase.caseTypeAttributeValues.push({
                            caseTypeAttribute: vm.caseType.caseTypeAttribute[key]
                        });
                    });
                }
            }
        }

        function deleteAssetModal(name) {
            $('#delete-asset').show();
            deleteAssetName = name;
        }

        function confirmDeleteAsset() {
            var assetArray = vm.mappedAssetsList;
            for (var i = assetArray.length - 1; i >= 0; --i) {
                if (assetArray[i].name == deleteAssetName) {
					vm.deletedAssetsList.push(assetArray[i]);
                    assetArray.splice(i, 1);
                }
            }
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                }
            }
            vm.mappedAssetsList = [];
            assetArray.forEach(function(asset) {
                vm.mappedAssetsList.push(asset);
            });
            $("#delete-asset").hide();
        }

        function cleardeleteAsset() {
            $("#delete-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#delete-asset").hide();
        }

        function setGoefenceCoordinate(event, isEdit) {
            vm.assetCoordinateValues = [];
            var tempAsset = {};
            tempAsset.assetCoordinates = [];
            var radius = event.getPath();
            for (var i = 0; i < radius.getLength(); i++) {
                var coordinates = {};
                coordinates.latitude = radius.getAt(i).lat();
                coordinates.longitude = radius.getAt(i).lng();
                tempAsset.assetCoordinates.push(coordinates);
            }
            if (isEdit) {
                vm.asset.assetCoordinates = tempAsset.assetCoordinates;
            } else {
                mappedAssetTemp.assetCoordinates = tempAsset.assetCoordinates;
            }
        }

        function saveEditAsset() {
            //vm.tempAssetArray.push(vm.asset);
            vm.mappedAssetsList = [];
            vm.tempAssetArray.forEach(function(assetVal) {
                vm.mappedAssetsList.push(assetVal);
            });
            vm.asset = [];
            vm.tempAssetArray = [];
            hideUserEditModal();
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                }
            }
        };

        function hideUserEditModal() {
            $("#userPathModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#userPathModal").hide();
        }

        function editAsset(asset) {
            vm.tempAssetArray = [];

            vm.mappedAssetsList.forEach(function(assetVal) {
                vm.tempAssetArray.push(assetVal);
            });
            for (var i = 0; i >= vm.tempAssetArray.length; --i) {
                if (vm.tempAssetArray[i].name == asset.name) {
                    vm.tempAssetArray.splice(i, 1);
                }
            }

            vm.asset = asset;
            var maplatlng = {
                lat: parseFloat(asset.assetCoordinates[0].latitude),
                lng: parseFloat(asset.assetCoordinates[0].longitude)
            };
            editAssetMap = new google.maps.Map(document.getElementById('map_canvas_edit_asset'), {
                center: maplatlng,
                zoom: 13,
                fullscreenControl: true
            });


            if (asset.assetType.layout == 'SPREAD') {
                drawingManagerSpread();
                drawingManagerValue('polylinecomplete', editAssetMap);
            } else if (asset.assetType.layout == 'FIXED') {
                drawingManagerFixed();
                drawingManagerValue('click', editAssetMap);
            }
            if (asset.name && asset.name != null) {
                if (asset.assetType.layout == 'SPREAD') {
                    drawPolyline(function(polyline) {
                        polyline.setMap(editAssetMap);
                        google.maps.event.addListener(polyline.getPath(),
                            'insert_at',
                            function() {
                                setGoefenceCoordinate(polyline, true);
                            });
                        google.maps.event.addListener(polyline.getPath(),
                            'set_at',
                            function(path) {
                                setGoefenceCoordinate(polyline, true);
                            });

                        vm.drawingManager.setOptions({
                            drawingControl: false
                        });
                        vm.drawingManager.setMap(null);

                    })
                } else if (asset.assetType.layout == 'FIXED') {
                    setValues();
                    drawingManagerFixed();
                    drawMarker(editAssetMap, vm.coOrdinate);
                }

                function drawPolyline(callback) {
                    setValues();
                    var centerlatlng = {};
                    if (vm.coOrdinates.length > 1) {
                        vm.coOrdinates.forEach(function(value) {
                            centerlatlng = {
                                lat: value.lat,
                                lng: value.lng
                            };
                        });

                        callback(new google.maps.Polyline({
                            path: vm.coOrdinates,
                            geodesic: true,
                            strokeColor: vm.asset.assetType.colorcode,
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: vm.asset.assetType.colorcode,
                            fillOpacity: 0.3,
                            editable: true
                        }));
                        editAssetMap.setCenter(centerlatlng);
                    }
                }

            }
            var ele = document.getElementById("userPathModal");
            $(ele).modal('show');
            $("#userPathModal").show();


            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_edit_asset").css("width", "100%");
        }

        function hideConnectAssetsModal() {
            $("#connectAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectAssetsModal").hide();
        }

        function hideConnectSitesModal () {
            $("#connectAssetsModal").hide();
        }

        function connectSelectedAssets() {
            var ele = document.getElementById("connectAssetsModal");
            $(ele).modal('show');
            $("#connectAssetsModal").show();

            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_assets").css("width", "100%");
        }

		function hideConnectMultipleAssetsModal() {
            $("#connectMultipleAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectMultipleAssetsModal").hide();
			vm.tempLinkWithPits = [];
			initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i],assetCoordinateValues, assetsPlanningMap, "yellow");
                }
            }
        }

        function connectMultipleAssets() {
			vm.siteAssets = [];
			vm.tempLinkWithPits = [];
					
            var ele = document.getElementById("connectMultipleAssetsModal");
            $(ele).modal('show');
            $("#connectMultipleAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_multiple_assets").css("width", "100%");
			var multipleSiteMap = new google.maps.Map(document.getElementById('map_canvas_connect_multiple_assets'), {
                    center: new google.maps.LatLng(vm.mappedAssetsList[0].assetCoordinates[0].latitude, vm.mappedAssetsList[0].assetCoordinates[0].longitude),
                    zoom: 12,
                    fullscreenControl: true
                });
			for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED' && vm.mappedAssetsList[i].assetType.name == "Site" && vm.mappedAssetsList[i].id == null) {
					vm.siteAssets.push(vm.mappedAssetsList[i]);
                    createMarkerForSiteAsset(vm.mappedAssetsList[i], multipleSiteMap);
                }
            }
			
			vm.siteAssets.sort(function(assetA, assetB) {
                var assetATime = assetA.createDate,
                    assetBTime = assetB.createDate
                if (assetATime < assetBTime) // sort string ascending
                    return -1
                if (assetATime > assetBTime)
                    return 1
                return 0 // default return value (no sorting)
            });
			for(var siteIndex = 1; siteIndex < vm.siteAssets.length; siteIndex++){
				getPointsRoute(vm.siteAssets[siteIndex-1], vm.siteAssets[siteIndex], multipleSiteMap, 200);
			}
        }

		function recalculate(){
            var totalCost = 0;
            var totalPowerBudget = 0;
			var totalFiberDistance = 0.0;
            for (var assetIndex = 0; assetIndex < vm.mappedAssetsList.length; assetIndex++) {
                var isSpread = false;
                var fiberDistance = 0.0;

				if (vm.mappedAssetsList[assetIndex].assetType.layout == "SPREAD") {
					isSpread = true;
                    var spreadAV = vm.mappedAssetsList[assetIndex].assetTypeAttributeValues;
                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
                           fiberDistance = parseFloat("0"+spreadAV[spreadAssetIndex].attributeValue);
                        }
                    }
                }

				for(var attrIndex = 0;attrIndex < vm.mappedAssetsList[assetIndex].assetTypeAttributeValues.length;attrIndex++) {
					var item = vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[attrIndex];
                    var value = parseFloat(item.assetTypeAttribute.defaultValue);

                    if (item.assetTypeAttribute.name == "Cost") {
                        var tempCost = parseFloat(value);
                        if (isSpread) {
                            tempCost = parseFloat(value) * fiberDistance;
                        }
                        if (tempCost > 0) {
                            totalCost += tempCost
                        }
						item.attributeValue = value;
                    }
                    if (item.assetTypeAttribute.name == "Power Budget") {
                        var tempPowerBudget = parseFloat(value);
                        if (isSpread) {
                            tempPowerBudget = parseFloat(value) * fiberDistance;
                        }
                        if (tempPowerBudget > 0) {
                            totalPowerBudget += tempPowerBudget;
                        }
						item.attributeValue = value;
                    }
					vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[attrIndex] = item;
				}
				totalFiberDistance += fiberDistance;
            }

            var caseAV = vm.trCase.caseTypeAttributeValues;
            for (var caseIndex = 0; caseIndex < caseAV.length; caseIndex++) {
                if (caseAV[caseIndex].caseTypeAttribute.name === "Cost") {
                    caseAV[caseIndex].attributeValue = totalCost.toFixed(2);;
                }
                if (caseAV[caseIndex].caseTypeAttribute.name === "Power Budget") {
                    caseAV[caseIndex].attributeValue = totalPowerBudget.toFixed(2);;
                }
				if (caseAV[caseIndex].caseTypeAttribute.name === "Fiber Distance") {
                    caseAV[caseIndex].attributeValue = totalFiberDistance.toFixed(2);;
                }
            }
            vm.trCase.caseTypeAttributeValues = caseAV;
        }

        function connectAssets() {
            if (vm.isSiteASelected == false && vm.isSiteBSelected == false) {
                alert("Please Select Site A");
            } else if (vm.isSiteASelected == true && vm.isSiteBSelected == false) {
                alert("Please Select Site B");
            } else {
                var siteALatLng = new google.maps.LatLng(vm.selectedSiteA.assetCoordinates[0].latitude, vm.selectedSiteA.assetCoordinates[0].longitude);
                var siteBLatLng = new google.maps.LatLng(vm.selectedSiteB.assetCoordinates[0].latitude, vm.selectedSiteB.assetCoordinates[0].longitude);
                var map = new google.maps.Map(document.getElementById('map_canvas_connect_assets'), {
                    center: siteALatLng,
                    zoom: 16,
                    fullscreenControl: true
                });
                createMarker(map, vm.selectedSiteA.name, siteALatLng);
                createMarker(map, vm.selectedSiteB.name, siteBLatLng);

                getShortestRoute(vm.selectedSiteA, vm.selectedSiteB, map);
            }
        }

		function setValues() {
            vm.coOrdinates = [];
            for (var i = 0; i < vm.asset.assetCoordinates.length; i++) {
                vm.coOrdinates.push({
                    lat: vm.asset.assetCoordinates[i].latitude,
                    lng: vm.asset.assetCoordinates[i].longitude
                });
                if (i == vm.asset.assetCoordinates.length - 1) {
                    vm.coOrdinate = JSON.stringify(vm.coOrdinates);
                }
            }
        }

        $("#fromAssetsView").change(function() {
            $("#toAssetsView")[0].selectedIndex = 0;
            var result = $("#fromAssetsView").val();
            if (result != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].name == result) {
                        vm.selectedSiteA = vm.mappedAssetsList[i];
                    }
                }
                vm.isSiteASelected = true;
            }
        });

        $("#toAssetsView").change(function() {
            if (vm.isSiteASelected == true) {
                var result = $("#toAssetsView").val();
                if (result != null) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].name == result) {
                            vm.selectedSiteB = vm.mappedAssetsList[i];
                        }
                    }
                    vm.isSiteBSelected = true;
                }
            } else {
                $("#toAssetsView")[0].selectedIndex = 0;
                alert("Please Select Site A");
            }

        });

        function createMarker(map, assetName, myLatLng) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: {
                    scaledSize: new google.maps.Size(
                        24, 24),
                    origin: new google.maps.Point(0, 0),
                    url: 'content/images/yellow.png',
                    anchor: new google.maps.Point(
                        16, 16),

                },
                label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: assetName, backgroundcolor: "#ff9800" },
            });

        }

        function drawMarker(map, response) {
            $.each(JSON.parse(response), function (index, value) {
                centerlatlng = {
                    lat: value.lat,
                    lng: value.lng
                };

                if (marker) {
                    marker.setMap(null);
                }
                marker = new google.maps.Marker({
                    position: centerlatlng,
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(16, 16)
                    },
                });

                marker.setMap(map);
                vm.fixedArray = [];
                var coordinates = {};
                coordinates.latitude = centerlatlng.lat;
                coordinates.longitude =centerlatlng.lng;
                vm.fixedArray.push(coordinates);
                mappedAssetTemp.assetCoordinates = vm.fixedArray;
                addMappedAssets(mappedAssetTemp);
            });
        }

        function getShortestRoute(SiteA, SiteB, map) {
            var pointA = new google.maps.LatLng(SiteA.assetCoordinates[0].latitude, SiteA.assetCoordinates[0].longitude);
            var pointB = new google.maps.LatLng(SiteB.assetCoordinates[0].latitude, SiteB.assetCoordinates[0].longitude);

            var newAsset = {
                name: '',
                assetCoordinates: []
            };
            newAsset.name = SiteA.name + "-" + SiteB.name;

            var directionsService = new google.maps.DirectionsService;

            directionsService.route({
                origin: pointA,
                destination: pointB,
                avoidTolls: true,
                avoidHighways: false,
                provideRouteAlternatives: true,
                travelMode: google.maps.TravelMode.DRIVING
            }, function(response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    var responsePaths = response.routes;
                    responsePaths.forEach(function(pathVal, index) {
                        if (index < 3) {
                            vm.fixedArray = [];
							var route = pathVal;
			                var az = 0;
			                for (var i = 0; i < route.legs.length; ++i) {
			                    if (route.legs[i].distance) {
			                        az += route.legs[i].distance.value;
			                    }
			                }
							var polylinePathPoints = gMilestone(route, 100);
//                            var overViewPath = pathVal.overview_path;
                            polylinePathPoints.forEach(function(value) {
                                var coordinates = {};
                                coordinates.lat = value.lat();
                                coordinates.lng = value.lng();
                                vm.fixedArray.push(coordinates);
                            });
                            drawPolylineForSelectedPath(SiteA.name + "-" + SiteB.name, vm.fixedArray, map, index);
                        }
                    });
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
            return newAsset;
        }

        function drawPolylineForSelectedPath(assetName, spreadAssetCoordinates, map, index) {
            if (spreadAssetCoordinates.length > 0) {
                map.setZoom(14);

                var ColorValue = '#ff0000';
                if (index == 0) {
                    ColorValue = '#ff0000';
                } else if (index == 1) {
                    ColorValue = '#000000';
                } else {
                    ColorValue = '#208000';
                }

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(polylinepath, 'mouseover', function(event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    var pointContent = document.createElement('div'),
                        button;

                    pointContent.innerHTML = '<div class="infoWindowhead">Point ' + (index + 1) +
                        '</div>';
                    button = pointContent.appendChild(document.createElement('input'));
                    button.type = 'button';
                    button.value = 'Click to select';
                    button.className = "button";

                    google.maps.event.addDomListener(button, 'click', function() {
                        var newAsset = {};
                        newAsset.name = assetName;
                        newAsset.assetCoordinates = [];
                        spreadAssetCoordinates.forEach(function(assetCoor) {
                            newAsset.assetCoordinates.push({ latitude: assetCoor.lat, longitude: assetCoor.lng });
                        });

						AssetType.query({}, function(data) {
                            data.forEach(function(item) {
                                if (item.name == "Link") {
									vm.isShowing = false;
                                    newAsset.assetType = item;
                                    newAsset.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(newAsset.assetType);
//	                                $.each(newAsset.assetType.assetTypeAttributes,function(key, value) {
//	                                    newAsset.assetTypeAttributeValues.push({
//	                                            assetTypeAttribute: newAsset.assetType.assetTypeAttributes[key]
//	                                        });
//	                                });
									if (newAsset.assetType.layout == "SPREAD") {
										var fiberDistance = 0.0;
					                    var spreadCoordinates = newAsset.assetCoordinates;
					                    if (spreadCoordinates.length > 0) {
					                        for (var index in spreadCoordinates) {
					                            if (index > 0) {
					                                fiberDistance += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
					                            }
					                        }
					                    }
						                fiberDistance = fiberDistance.toFixed(2);
					                    var spreadAV = newAsset.assetTypeAttributeValues;
					                    for (var spreadAssetIndex = 0; spreadAssetIndex < spreadAV.length; spreadAssetIndex++) {
					                        if (spreadAV[spreadAssetIndex].assetTypeAttribute.name === "Fiber Distance (km)") {
					                            spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
					                        }
					                    }
					                    newAsset.assetTypeAttributeValues = spreadAV;
					                }
	                                newAsset.isChecked = true;
	                                vm.mappedAssetsList.push(newAsset);
									initPlanningMap();
		                            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
		                                if (vm.mappedAssetsList[i].assetType.layout == 'FIXED') {
		                                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], assetsPlanningMap);
		                                } else if (vm.mappedAssetsList[i].assetType.layout == 'SPREAD') {
		                                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
		                                    drawPolylineForGeneratedLoc(vm.mappedAssetsList[i], assetCoordinateValues, assetsPlanningMap, "yellow");
		                                }
		                            }
                                }
                            });
                        });
                        hideConnectAssetsModal();
                    })

                    var infoWindow2 = new google.maps.InfoWindow({
                        content: pointContent,
                    });
                    infoWindow2.open(map);
                    infoWindow2.setPosition(event.latLng);
                    openedInfoWindow = infoWindow2;
                });
            }
        }

        function save() {
            vm.isShowing = false;
            vm.trCase.caseAssets = [];
			vm.trCase.deletedAssets = [];
			
            vm.mappedAssetsList.forEach(function(caseAssetVal) {
                if (caseAssetVal.isChecked) {
                    vm.trCase.caseAssets.push(caseAssetVal);
                }
            });

			vm.deletedAssetsList.forEach(function(asset){
				vm.trCase.deletedAssets.push(asset);
			});
			
            if (vm.trCase.caseAssets.length > 0) {
                vm.isShowing = true;
                vm.isSaving = true;
                var assignedToUser = $("#field_assignedToUser").val();
                vm.trCase.assignedTo = usersMap[assignedToUser];
                angular.forEach(vm.assetList, function(value, key) {
                    if (vm.trCase.asset.name === value.name) {
                        vm.trCase.asset = value;
                    }
                });

                if (vm.trCase.id !== null) {
                    TrCase.update(vm.trCase, onSaveSuccess, onSaveError);
                } else {
                    TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
                }
            } else {
                alert("No assets are mapped to this work flow");
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:trCaseUpdate', result);
            $state.go('tr-case');
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function selectedGroup(value){
            var input = document.getElementById("field_assignedToUser");
            input.value = '';
            vm.hideUser = false;
        }
        function filterActivatedUser() {
            if (vm.trCase.assignedToUser != null && vm.trCase.assignedToUser != "" && vm.trCase.assignedToUser != "." && !angular.isUndefined(vm.trCase.assignedToUser)) {
                $('input[name="assignedToUser"]').keyup(function () {
                    vm.user = $(this).val();
                });
                    ActivatedUserSearch.query({
                        // userId: vm.trCase.assignedToUser,
                        userId: vm.trCase.groups[0].id,
                        user: vm.user
                    }, onSuccess, onError);
                
                function onSuccess(data, headers) {
                    data.forEach(function (users) {
                        vm.assignedUsers.push(users.login);
                    });
                    vm.activatedusers = data;

                    angular.forEach(vm.activatedusers, function (value, key) {
                        usersMap[value.login] = value.id;

                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            
            }
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return (dist);
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }
        $(document).on('change', 'input', function () {
            var options = $('datalist')[0].options;
            for (var i = 0; i < options.length; i++) {
                if (options[i].value == $(this).val()) {
                    if (vm.assignedUsers.includes($(this).val())) {
                        vm.validUser = false;
                    } else {
                        vm.validUser = true;
                    }
                    break;
                }
            }
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('trakeyeApp')
    .controller('TrCaseFiberCoreController', TrCaseFiberCoreController)

  TrCaseFiberCoreController.$inject = ['$timeout', '$scope','$rootScope'];

  function TrCaseFiberCoreController($timeout, $scope,$rootScope) {
    var vm = this;
    vm.tubeImagesOrder = tubeImagesOrder;
    vm.colors = ['blue','orange','green','brown','slate','white','red','black','yellow','violet','rose','aqua'];
    var fiberData = {
      madalTube: {
        tubeName: 'Duct#1 Cable',
        tubeModule: '8F * 6 core tubes',
        tubeType: '48F cable wire',
      },
      coreTube: [{
        tubeName: 'Duct#11 Cable',
        parentTube: 'Duct#1 Cable',
        tubeModule: '8F * 3 core tubes',
        tubeType: '24F cable wire'
      },
      {
        tubeName: 'Duct#12 Cable',
        parentTube: 'Duct#1 Cable',
        tubeModule: '8F * 3 core tubes',
        tubeType: '24F cable wire'
      }
      ],
      coreTubeChildA: 
        {
          tubeName: 'Duct#111 Cable',
          parentTube: 'Duct#11 Cable',
          tubeModule: '8F * 1 core tubes',
          tubeType: '8F cable wire'
        },
        // {
        //   tubeName: 'Duct#112 Cable',
        //   parentTube: 'Duct#11 Cable',
        //   tubeModule: '8F * 1 core tubes',
        //   tubeType: '8F cable wire'
        // },
        // {
        //   tubeName: 'Duct#113 Cable',
        //   parentTube: 'Duct#11 Cable',
        //   tubeModule: '8F * 1 core tubes',
        //   tubeType: '8F cable wire'
        // }
      coreTubeChildB: {
        tubeName: 'Duct#121 Cable',
        parentTube: 'Duct#2 Cable',
        tubeModule: '(8 + 4)F core tubes',
        tubeType: '12F cable wire'
      },
      coreTubeChildBZ: {
        tubeName: 'Duct#1211 Cable',
        parentTube: 'Duct#2 Cable',
        tubeModule: '6F core tubes',
        tubeType: '6F cable wire'
      },
      coreTubeChildAZ: {
        tubeName: 'Duct#1111 Cable',
        parentTube: 'Duct#3 Cable',
        tubeModule: '4F core tubes',
        tubeType: '4F cable wire'
      }

    }
    vm.selectedTube = fiberData;
    var modalTube = fiberData.madalTube;
    var coreTubeA = fiberData.coreTube[0];
    var coreTubeB = fiberData.coreTube[1];
    var coreTubeChildA = fiberData.coreTubeChildA;
    var coreTubeChildB = fiberData.coreTubeChildB;
    var coreTubeChildBZ = fiberData.coreTubeChildBZ;
    var coreTubeChildAZ  = fiberData.coreTubeChildAZ;
    $scope.showSelectColor = false;
    
    vm.coreSize = 0;
    
    vm.coreColor = function () { 
      $scope.showSelectColor = true
    }

    function selectedTubes(item) {
      if (item === '48F cable wire') {
        vm.cableId = modalTube.tubeName;
        vm.coreSize = 12;
        vm.tube01 = true;
        vm.tube02 = true;
        vm.tube03 = true;
        vm.tube04 = true;
      } else if (item === 'Duct#11 Cable') {
        vm.cableId = coreTubeA.tubeName
        vm.coreSize = 12;
        vm.tube01 = true;
        vm.tube02 = true;
        vm.tube03 = false;
        vm.tube04 = false;
      } else if (item === 'Duct#12 Cable') {
        vm.coreSize == 12;
        vm.cableId = coreTubeB.tubeName
        vm.tube01 = true;
        vm.tube02 = true;
        vm.tube03 = false;
        vm.tube04 = false;
      }
      else if (item === '12F cable wire') {
        vm.cableId = coreTubeChildA.tubeName
        vm.coreSize = 6;
        vm.tube01 = true;
        vm.tube02 = true;
        vm.tube03 = false;
        vm.tube04 = false;
      }
      else if (item === '8F cable wire') {
        vm.cableId = coreTubeChildB.tubeName
        vm.coreSize = 8;
        vm.tube01 = true;
        vm.tube02 = false;
        vm.tube03 = false;
        vm.tube04 = false;
      }
      else if (item === '6F cable wire'){
        vm.cableId = coreTubeChildBZ.tubeName
        vm.coreSize = 6;
        vm.tube01 = true;
        vm.tube02 = false;
        vm.tube03 = false;
        vm.tube04 = false;
      }else {
        vm.cableId = coreTubeChildAZ.tubeName
        vm.coreSize = 4;
        vm.tube01 = true;
        vm.tube02 = false;
        vm.tube03 = false;
        vm.tube04 = false;
      }
    }

    vm.closeTubeColors = function () {
      $scope.showSelectColor = false;
    }

    function tubeImagesOrder() {
      for (var i = 0; i < 5; i++) {
         tubeImages;
      }
    }

    var mapDiv = document.getElementById("map_canvas");
    var map1 = new google.maps.Map(mapDiv, {
      center: { lat: parseFloat($rootScope.DEFAULT_LATITUDE), lng: parseFloat($rootScope.DEFAULT_LONGITUDE) },
      zoom: 11,
    });
    //  <<<<<<< ========= ######## Duct#1 Cable   ######### ======= >>>>>>
    var flightPath = new google.maps.Polyline({
      strokeColor: "#0000ff",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flightPath.setMap(map1);
    var flightPlanCoordinates = [
      [23.862545, 90.487167],
      [23.851916, 90.468787],
      [23.831900, 90.448787],
      [23.756025, 90.390470]
    ];
    var path = flightPath.getPath();
    for (var i = 0; i < flightPlanCoordinates.length; i++) {
      //var loc = locations[i].split(',');
      var loc = flightPlanCoordinates[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      createInfoWindow(flightPath);
    }
    function createInfoWindow(flightPath) {
      google.maps.event.addListener(flightPath, 'mouseover', function (event) {
        infowindow.setContent(userContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        // selectedTubes(modalTube.tubeType);
      });
      google.maps.event.addListener(flightPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var userContent = document.createElement('div'),
        button;
      userContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + modalTube.tubeName + '</br>' +
        '<b>Core Module : </b> ' + modalTube.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + modalTube.tubeType + '</br>';
      button = userContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: userContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        // debugger;
        selectedTubes(modalTube.tubeType);
        $("#userPathModal").show();
        
      });

    }

    $scope.hideEditModal = function () {
      vm.cableId = " ";
      vm.coreType = " ";
      $scope.showSelectColor = false;
      $("#userPathModal").removeClass("in");
      $(".modal-backdrop").remove();
      $("#userPathModal").hide();
        vm.tube01 = false;
        vm.tube02 = false;
        vm.tube03 = false;
        vm.tube04 = false;
        
    }

    //  <<<<<<< ========= ######## Duct#2A Cable   ######### ======= >>>>>>
    var flyPath = new google.maps.Polyline({
      strokeColor: "#FFA500",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath.setMap(map1);
    var PlanCoordinates = [
      [23.908254, 90.597167],
      [23.862545, 90.487167],
    ];
    var path = flyPath.getPath();
    for (var i = 0; i < PlanCoordinates.length; i++) {
      var loc = PlanCoordinates[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showInfoWindow(flyPath);
    }
   
    function showInfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeB.tubeName);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeA.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeA.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeA.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeA.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        $("#userPathModal").show();
        selectedTubes(coreTubeA.tubeName);
      });

    }
    function showInfoBWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeB.tubeName);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeB.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeB.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeB.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeB.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeB.tubeName);
        $("#userPathModal").show();
      });

    }

    function showDuck03InfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeChildA.tubeType);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeChildA.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeChildA.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeChildA.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeChildA.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeChildA.tubeType);
        $("#userPathModal").show();
      });

    }

    function showDuck12fInfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeChildB.tubeType);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeChildB.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeChildB.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeChildB.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeChildB.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeChildB.tubeType);
        $("#userPathModal").show();
      });

    }

    function showDuck6fInfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeChildBZ.tubeType);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeChildBZ.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeChildBZ.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeChildBZ.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeChildBZ.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeChildBZ.tubeType);
        $("#userPathModal").show();
      });

    }

    function showDuck4fInfoWindow(flyPath){
      google.maps.event.addListener(flyPath, 'mouseover', function (event) {
        infowindow.setContent(user24FContent);
        // infowindow.position = event.latLng;
        infowindow.setPosition(event.latLng);
        infowindow.open(map1);
        selectedTubes(coreTubeChildAZ.tubeType);
      });
      google.maps.event.addListener(flyPath, 'mouseout', function (event) {
        infowindow.close();
      });
      var user24FContent = document.createElement('div'),
        button;
        user24FContent.innerHTML = '<div class="infoWindowhead">' +
        '<b>Name : </b> ' + coreTubeChildAZ.tubeName + '</br>' +
        '<b>ParentName : </b> ' + coreTubeChildAZ.parentTube + '</br>' +
        '<b>Core Module : </b> ' + coreTubeChildAZ.tubeModule + ' </br>' +
        '<b>Cable Type : </b> ' + coreTubeChildAZ.tubeType + '</br>';
      button = user24FContent.appendChild(document.createElement('input'));
      button.type = 'button';
      button.value = 'Show';
      button.className = "button";
      button.style.width = '300px';
      button.style.textAlign = 'right';
      var infowindow = new google.maps.InfoWindow({
        content: user24FContent
      });
      google.maps.event.addDomListener(button, 'click', function () {
        selectedTubes(coreTubeChildAZ.tubeType);
        $("#userPathModal").show();
      });

    }




  //  <<<<<<< ========= ######## Duct#2 Cable   ######### ======= >>>>>>
    var flyPath1 = new google.maps.Polyline({
      strokeColor: "#FFA500",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath1.setMap(map1);
    var PlanCoordinates1 = [
      [23.938254, 90.487167],
      [23.862545, 90.487167],
    ];
    var path = flyPath1.getPath();
    for (var i = 0; i < PlanCoordinates1.length; i++) {
      var loc = PlanCoordinates1[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showInfoBWindow(flyPath1);
    }
    //  ######## =========  #########

    //  <<<<<<< ========= ######## Duct#3 8f Cable   ######### ======= >>>>>>
    var flyPathA = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathA.setMap(map1);
    var PlanCoordinatesA = [
      [23.973854,90.639167],
      [23.943254,90.629967],
      [23.908254,90.597167]
    ];
    var path = flyPathA.getPath();
    for (var i = 0; i < PlanCoordinatesA.length; i++) {
      var loc = PlanCoordinatesA[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck03InfoWindow(flyPathA);
    }
    //  ######## =========  #########

    //  <<<<<<< ========= ######## Duct#3 8f Cable   ######### ======= >>>>>>
    var flyPathB = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathB.setMap(map1);
    var PlanCoordinatesB = [
      [23.982525,90.672459],
      [23.952545,90.659999],
      [23.932254,90.639167],
      [23.908254,90.597167]
    ];
    var path = flyPathB.getPath();
    for (var i = 0; i < PlanCoordinatesB.length; i++) {
      var loc = PlanCoordinatesB[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck03InfoWindow(flyPathB);
    }
    // ##===== #### =======###
    
    //  <<<<<<< ========= ######## Duct#3 8f Cable   ######### ======= >>>>>>
    var flyPathC = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathC.setMap(map1);
    var PlanCoordinatesC = [
      [23.856254,90.639888],
      [23.893254,90.619167],
      [23.908254,90.597167]
    ];
    var path = flyPathC.getPath();
    for (var i = 0; i < PlanCoordinatesC.length; i++) {
      var loc = PlanCoordinatesC[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck03InfoWindow(flyPathC);
    }

     //  <<<<<<< ========= ######## Duct#3 4f Cable   ######### ======= >>>>>>
     var flyPathC1 = new google.maps.Polyline({
      strokeColor: "#A52A2A",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathC1.setMap(map1);
    var PlanCoordinatesC1 = [
      [23.826254,90.609888],
      [23.836254,90.619888],
      [23.846254,90.629888],
      [23.856254,90.639888]
    ];
    var path = flyPathC1.getPath();
    for (var i = 0; i < PlanCoordinatesC1.length; i++) {
      var loc = PlanCoordinatesC1[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck4fInfoWindow(flyPathC1);
    }

    //  <<<<<<< ========= ######## Duct#3 4f Cable   ######### ======= >>>>>>
    var flyPathC2 = new google.maps.Polyline({
      strokeColor: "#A52A2A",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPathC2.setMap(map1);
    var PlanCoordinatesC2 = [
      [23.886254,90.669888],
      [23.876254,90.659888],
      [23.866254,90.649888],
      [23.856254,90.639888]
    ];
    var path = flyPathC2.getPath();
    for (var i = 0; i < PlanCoordinatesC2.length; i++) {
      var loc = PlanCoordinatesC2[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck4fInfoWindow(flyPathC2);
    }


    //  <<<<<<< ========= ######## Duct#3 12f Cable   ######### ======= >>>>>>
    
     var flyPath2 = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath2.setMap(map1);
    var PlanCoordinates2 = [
      [23.998254,90.537167],
      [23.988254,90.517167],
      [23.938254,90.487167]
    ];
    var path = flyPath2.getPath();
    for (var i = 0; i < PlanCoordinates2.length; i++) {
      var loc = PlanCoordinates2[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck12fInfoWindow(flyPath2);
    }
   
     //  <<<<<<< ========= ######## Duct#3 12f Cable   ######### ======= >>>>>>
     var flyPath3 = new google.maps.Polyline({
      strokeColor: "#006400",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath3.setMap(map1);
    var PlanCoordinates3 = [
      [23.948254,90.557167],
      [23.938254,90.487167]
    ];
    var path = flyPath3.getPath();
    for (var i = 0; i < PlanCoordinates3.length; i++) {
      var loc = PlanCoordinates3[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck12fInfoWindow(flyPath3);
    }

    //  <<<<<<< ========= ######## Duct#3 6f Cable   ######### ======= >>>>>>
     var flyPath4 = new google.maps.Polyline({
      strokeColor: "#A52A2A",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath4.setMap(map1);
    var PlanCoordinates4 = [
      [23.999254,90.588167],
      [23.969254,90.578167],
      [23.959254,90.568167],
      [23.948254,90.557167]
    ];
    var path = flyPath4.getPath();
    for (var i = 0; i < PlanCoordinates4.length; i++) {
      var loc = PlanCoordinates4[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck6fInfoWindow(flyPath4);
    }
 //  <<<<<<< ========= ######## Duct#3 6f Cable   ######### ======= >>>>>>
    var flyPath5 = new google.maps.Polyline({
      strokeColor: "#A52A2A",
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });
    flyPath5.setMap(map1);
    var PlanCoordinates5 = [
      [23.899254,90.528167],
      [23.929254,90.538167],
      [23.939254,90.548167],
      [23.948254,90.557167]
    ];
    var path = flyPath5.getPath();
    for (var i = 0; i < PlanCoordinates5.length; i++) {
      var loc = PlanCoordinates5[i];
      path.push(new google.maps.LatLng(loc[0], loc[1]));
      showDuck6fInfoWindow(flyPath5);
    }
    

  }
})();





(function () {
	'use strict';

	angular.module('trakeyeApp').controller('TrCaseDialogController', TrCaseDialogController).directive('mySrc', function () {
		return {
			restrict: 'A',
			scope: {
				callback: '&'
			},
			link: function (scope, elem, attrs) {
				elem.attr('src', scope.callback());
			}
		};
	})
	TrCaseDialogController.$inject = ['$rootScope', '$timeout', '$scope', '$stateParams', '$q', 'entity', 'TrCase', 'UserGroupIDs', 'User', 'CaseType', 'Principal', 'Asset', '$state', 'ActivatedUsers', 'UserValueSearch','ChildUsersMiniGeofence',
		'AlertService', 'ActivatedUserSearch', 'TrCaseUpload', 'AssetSearchForMap', 'AssetSearch', 'AllCaseTypes', 'TrCaseImages', 'AllCustomCaseTypeAttribute', 'AssetDB', 'AssetByID', 'UserAccount', 'GeofenceIDs', 'UserGeofences', 'Geofence', '$ngConfirm', 'AssocitedVendorSearch'
	,'NearByBGOH','AttributeMappingId','getCaseImage','$localStorage','AttributeMappingList','Configs','Account','usersByGeofence','activatedUsers','IncidentStatusConfig'];

	function TrCaseDialogController($rootScope, $timeout, $scope, $stateParams, $q, entity, TrCase, UserGroupIDs, User, CaseType, Principal, Asset, $state, ActivatedUsers, UserValueSearch, ChildUsersMiniGeofence, AlertService, ActivatedUserSearch,
		TrCaseUpload, AssetSearchForMap, AssetSearch, AllCaseTypes, TrCaseImages, AllCustomCaseTypeAttribute, AssetDB, AssetByID, UserAccount, GeofenceIDs, UserGeofences, Geofence, $ngConfirm, AssocitedVendorSearch,NearByBGOH,AttributeMappingId,getCaseImage,$localStorage,AttributeMappingList,Configs,Account,usersByGeofence,activatedUsers,IncidentStatusConfig) {
		var vm = this;

		vm.trCase = entity;
		vm.showCaseAttachment = false

		var entity_old = angular.copy(vm.trCase);
		// vm.caseImages; // = entity_old.caseImages;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.save = save;
		vm.submit = submit
		vm.decodeImage = decodeImage;
		vm.filterUser = filterUser;
		vm.filterActivatedUser = filterActivatedUser;
		vm.getUsersByGeofence = getUsersByGeofence;
		vm.assetList = "";
		vm.filterAssetsList = filterAssetsList;
		vm.getAssetAddress = getAssetAddress;
		vm.filterAssetsOnMapView = filterAssetsOnMapView;
		vm.closeMapFilterModal = closeMapFilterModal;
		vm.closePopupDialogModal = closePopupDialogModal;
		vm.saveFilter = saveFilter;
		vm.showExisting = showExisting;
		vm.customAttributesMap = {};
		vm.customAttributesMapp = [];
		var openedInfoWindow = null;
		var locations = {};
		var prevInfoWindow = null;
		vm.checkattributeMappingList = []
		vm.closeModal = closeModal
		vm.showCableSplice = false
		vm.showFmsTermination = false
		vm.saveDetails = saveDetails
		// vm.showAddressAddress = true;

		var markers = [];
		var polylines = [];
		var noDataText = null;
		vm.userGeofences = [];
		vm.canFilter = false;

		vm.userAdmin = {};
		vm.userGeofenceList = null;

		$scope.allimages = false;

		vm.prevStatus = vm.trCase.status;

		vm.img;
		var attachment,maxSize;

		/* if(vm.trCase.id){
			vm.assetName = vm.trCase.caseAssets.length > 0 ? " - " + vm.trCase.caseAssets[0].name + ' (Asset Name)' : "Edit Incident"
		}

		if($rootScope.createCaseFromAssetMap){
			vm.assetNameInCreate = $rootScope.createCaseFromAssetMap.length > 0 ? " - " + $rootScope.createCaseFromAssetMap[0].name + ' (Asset Name)' : "Create Incident"
		} */

		$scope.getImage = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%" src="data:image/jpeg;base64,' +
                    img +
                    '" >'
            );
            imgWindow.document.close(); 
		};

		$scope.toggle = function (id) {
            switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrCaseImages.query(
                            {
                                caseId: vm.trCase.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');
                            vm.caseImages = data.filter(function(caseImages){
                                return caseImages.image
                             });
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getCaseImage.get(vm.trCase.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }
        };
		vm.trCase.caseImages = [];

		$(".select2").select2(); // Added search for select box
		// Added for upload
		$(":file").filestyle({
			buttonBefore: true
		});
		$(":file").filestyle('buttonText', 'Browse File');
		vm.caseTypes = loadPage(); // CaseType.query();
		vm.selectAttributes = selectedCaseTypeAttributes;
		$timeout(function () {
			angular.element('.form-group:eq(1)>input').focus();
		});

		vm.checkFrtPat = false

		$scope.editDetails = function (id, name) {
			vm.editDetails = false
			vm.new = JSON.parse(JSON.stringify(vm.trCase));
            switch (name) {
                case "cableDetails":
                    vm.selectedCable = id;
                    $("#cableDetails").show();
                    break;
                case "splicingDetails":
                    vm.selectedSlicing = id;
                    $("#splicingDetails").show();
                    break;
                case "fmsDetails":
					vm.selectedFms = id;
                    $("#fmsDetails").show();
                    break;
                case "terminationDetails":
					vm.selectedTermination = id;
                    $("#terminationDetails").show();
                    break;
                default:
                    console.log("");
            }
        };
		
		$scope.addDetails = function (id) {
			vm.editDetails = true
            switch (id) {
                case "cableDetails":
                    if (vm.trCase.cableDetails != null) {
                        vm.trCase.cableDetails.length++;
                        vm.selectedCable = vm.trCase.cableDetails.length - 1;

                        if (
                            vm.trCase.splicingDetails.length > 0 &&
                            vm.trCase.cableDetails.length > 0
                        ) {
                            vm.isSaving = false;
                        }
                    }
                    $("#cableDetails").show();
                    break;
                case "splicingDetails":
                    if (vm.trCase.splicingDetails != null) {
                        vm.trCase.splicingDetails.length++;
                        vm.selectedSlicing =
                            vm.trCase.splicingDetails.length - 1;

                        if (
                            vm.trCase.splicingDetails.length > 0 &&
                            vm.trCase.cableDetails.length > 0
                        ) {
                            vm.isSaving = false;
                        }
                    }
                    $("#splicingDetails").show();
                    break;
                case "fmsDetails":
					if (vm.trCase.fmsAndCableDetails != null) {
                        vm.trCase.fmsAndCableDetails.length++;
                        vm.selectedFms =
                            vm.trCase.fmsAndCableDetails.length - 1;

                        if (
                            vm.trCase.fmsAndCableDetails.length > 0 &&
                            vm.trCase.terminationDetails.length > 0
                        ) {
                            vm.isSaving = false;
                        }
                    }
                    $("#fmsDetails").show();
                    break;
                case "terminationDetails":
					if (vm.trCase.terminationDetails != null) {
                        vm.trCase.terminationDetails.length++;
                        vm.selectedTermination =
                            vm.trCase.terminationDetails.length - 1;

                        if (
                            vm.trCase.fmsAndCableDetails.length > 0 &&
                            vm.trCase.terminationDetails.length > 0
                        ) {
                            vm.isSaving = false;
                        }
                    }
                    $("#terminationDetails").show();
                    break;
                default:
                    console.log("");
            }
        };

		$scope.removeDetails = function (id, name) {
            switch (name) {
                case "cableDetails":
                    vm.trCase.cableDetails.splice(id, 1);
                    if (vm.trCase.cableDetails.length == 0) {
                        vm.isSaving = true;
                    }
                    break;
                case "splicingDetails":
                    vm.trCase.splicingDetails.splice(id, 1);
                    if (vm.trCase.splicingDetails.length == 0) {
                        vm.isSaving = true;
                    }
                    break;
                case "fmsDetails":
					vm.trCase.fmsAndCableDetails.splice(id, 1);
                    if (vm.trCase.fmsAndCableDetails.length == 0) {
                        vm.isSaving = true;
                    }
                    break;
                case "terminationDetails":
					vm.trCase.terminationDetails.splice(id, 1);
                    if (vm.trCase.terminationDetails.length == 0) {
                        vm.isSaving = true;
                    }
                    break;
                default:
                    console.log("");
            }
        };

		function saveDetails(id) {
            switch (id) {
                case "cableDetails":
                    if (vm.trCase.cableDetails[vm.selectedCable] == null) {
                        vm.trCase.cableDetails.splice(vm.selectedCable, 1);
                    }
                    break;
                case "splicingDetails":
                    if (vm.trCase.splicingDetails[vm.selectedSlicing] == null) {
                        vm.trCase.splicingDetails.splice(vm.selectedSlicing, 1);
                    }
                    break;
                case "fmsDetails":
					if (vm.trCase.fmsAndCableDetails[vm.selectedFms] == null) {
                        vm.trCase.fmsAndCableDetails.splice(vm.selectedFms, 1);
                    }
                    break;
                case "terminationDetails":
					if (vm.trCase.terminationDetails[vm.selectedTermination] == null) {
                        vm.trCase.terminationDetails.splice(vm.selectedTermination, 1);
                    }
                    break;
                default:
                    console.log("");
            }

            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }
			vm.selectedMiniGeofence = null;  

			$scope.selectingGeofence = function () {

				if (vm.selectedMiniGeofence && vm.selectedMiniGeofence.id) {
					vm.showSelectUserMessage = true;
				} else {
					vm.showSelectUserMessage = false;
					return; 
				}
				vm.geofenceData = {
					"id":vm.userId,
					"login":null,
					"firstName":null,
					"lastName": null,
					"visitedDateTime": null,
					"authoritieList":[],
					"geofenceId": vm.selectedMiniGeofence.id   //IMPORTANT
				};   
				vm.getUsersByGeofence() 
			};
			$scope.FRTselectedGeofence = function () {
				if (!vm.userId) {
				console.warn("UserId not available yet. Skipping API call.");
				return;
    			}

				if (!vm.trCase || !vm.trCase.geofences || !vm.trCase.geofences.length) {
					console.warn("Geofence not available.");
					return;
				}
				vm.geofenceData = {
					"id":vm.userId,
					"login":null,
					"firstName":null,
					"lastName": null,
					"visitedDateTime": null,
					"authoritieList":["ROLE_FRT", "ROLE_PATROLLER"],
					"geofenceId": vm.trCase.geofences[0].id   //IMPORTANT
				};  
				vm.nePayload = {
					"id":vm.userId,
					"login":null,
					"firstName":null,
					"lastName": null,
					"visitedDateTime": null,
					"authoritieList":["ROLE_NETWORK_ENGINEER"],
					"geofenceId": vm.trCase.geofences[0].id   //IMPORTANT
				}; 
				
				vm.getUsersByGeofence() 
			};



		function loadPage() {
			// filterActivatedUser()
			if(vm.trCase.id ==  null){
				vm.isSaving = true
			}
			
			Configs.get("MaxFileSize",function(response){
				maxSize = response[0].configValue
			})

			if(vm.trCase.id){
				Configs.get("CaseImage",function(response){
					if(response.length > 0){
						if(response[0].configValue == "True"){
							vm.showCaseAttachment = true
						}
					}
				})
			}

			vm.multiGroup = [];
			var selectedGroup = [];

			if (vm.trCase.id != null) {
				vm.trCase.groups.forEach(function (group) {
					selectedGroup.push(group.id);
				});
			}

			ReverseGeocode(parseFloat(vm.trCase.pinLat), parseFloat(vm.trCase.pinLong));
			AllCaseTypes.getAll(function (response) {
				vm.caseTypes = response;
			});

			if(vm.trCase.id){
				if(vm.trCase.caseType.name == "Splicing Details"){
					vm.showCableSplice = true;
					Configs.get("CableSide",function(response){ 
						vm.cableSide = response
					})
					Configs.get("CableName",function(response){ 
						vm.cableName = response
					})
					Configs.get("JEAvailability",function(response){ 
						vm.jeAvailability = response
					})
					Configs.get("CableCapacity",function(response){ 
						vm.cableCapacity = response
					})
					Configs.get("TubeSide",function(response){ 
						vm.tubeSide = response
					})
					Configs.get("JENumber",function(response){ 
						vm.jeNumber = response
					})
				}

				if(vm.trCase.caseType.name == "Termination Details"){
					vm.showFmsTermination = true; 
					Configs.get("CableSide",function(response){ 
						vm.cableSide = response
					})
					Configs.get("FMSNumber",function(response){ 
						vm.fmsNumber = response
					}) 
					Configs.get("FMSCapacity",function(response){ 
						vm.fmsCapacity = response
					}) 
					Configs.get("FMS",function(response){ 
						vm.fms = response
					}) 
					Configs.get("Type",function(response){ 
						vm.type = response
					}) 
					Configs.get("CableNumber",function(response){ 
						vm.cableNumber = response
					}) 
				}
			}
			
			UserGroupIDs.getAll(function (response) {
				response.forEach(function (group) {
					if (selectedGroup.indexOf(group.id) !== -1) {
						vm.multiGroup.push({ name: group.name, id: group.id, ticked: true });
					} else {
						vm.multiGroup.push({ name: group.name, id: group.id, ticked: false });
					}
				});
			});
			Account.get().$promise
				.then(onSuccessAccountLogin)
				.catch(getAccountCatch);
			function onSuccessAccountLogin(data) {
				vm.AccountUserName=data.data.login
				vm.userId=data.data.id
				vm.authorities=data.data.authorities
			}
			function getAccountCatch(error) {
				vm.errorMessage = "Failed to load users. Please try again.";
			}

			setTimeout(function(){
					
			ChildUsersMiniGeofence.query({
					userLogin: vm.AccountUserName,
				}, onSuccessUserLogin, onErrorUserLogin);
			},500)

			function onSuccessUserLogin(data, headers) {
				vm.geofences = angular.copy(data);

				// Refresh select2
				setTimeout(function() {
					$('.select2').select2();  // re-initialize if needed
					$('.select2').trigger('change');
				}, 100);
					}


			function onErrorUserLogin(error) {
				AlertService.error(error.data.message);
			}

			AllCustomCaseTypeAttribute.getAll(function (response) {
				//vm.customCaseTypeAttributes = response;
				response.forEach(function (arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customCaseTypeAttributeValues;
					vm.customAttributesMap[arrayItem.name].parentId = arrayItem.id
				});

				if(vm.trCase.id){
					var getSelectedName = []
					vm.trCase.caseTypeAttributeValues.forEach(function (val){
						if(val.caseTypeAttribute.attributeDataType.name == 'STRING' ||
						val.caseTypeAttribute.attributeDataType.name == 'FLOAT' ||
						val.caseTypeAttribute.attributeDataType.name == 'INTEGER' ||
						val.attributeValue == null){
							
						}else{
							getSelectedName.push(val)
						}
					})

					getSelectedName.forEach(function(item){ 
						vm.customAttributesMap[item.caseTypeAttribute.attributeDataType.name].forEach(function(item1){
							if(item.attributeValue == item1.value){
								AttributeMappingId.get(item1.id,function(res){ 
									res.forEach(function(val){
										if(vm.customAttributesMap[val.parentValue].parentId == val.parentId){
												vm.customAttributesMap[val.parentValue].length = 0
										}
									}) 
								res.forEach(function(val){
									vm.customAttributesMap[val.parentValue].push({id : val.id , value : val.value, parentId : val.parentId})
								})  
								})
							}
						})
					 })
				}

				/* response.forEach(function (arrayItem) {
					vm.customAttributesMapp.push({ name : arrayItem.name ,customValues : arrayItem.customCaseTypeAttributeValues});
				});

				 if(vm.trCase.id){
					var getSelectedName = []
					vm.trCase.caseTypeAttributeValues.forEach(function (val){
						if(val.caseTypeAttribute.attributeDataType.name == 'STRING' ||
						val.caseTypeAttribute.attributeDataType.name == 'FLOAT' ||
						val.caseTypeAttribute.attributeDataType.name == 'INTEGER' ||
						val.attributeValue == null){
							
						}else{
							getSelectedName.push(val)
						}
					})
					getSelectedName.forEach(function(item){
						 vm.customAttributesMapp.forEach(function(valueParam){
							if(valueParam.name == item.caseTypeAttribute.attributeDataType.name){
								valueParam.customValues.forEach(function(getId){
									if(getId.value  == item.attributeValue){
										AttributeMappingId.get(getId.id,function(res){
											if(res.length > 0){
												res.forEach(function(val){
													if(vm.customAttributesMap[val.parentValue].parentId == val.parentId){
															vm.customAttributesMap[val.parentValue].length = 0
													}
											}) 
											res.forEach(function(val){
												vm.customAttributesMap[val.parentValue].push({id : val.id , value : val.value, parentId : val.parentId})
											}) 
											}
										})
									}  
								})
							}
							 
						}) 
				   }) }  */
				   if(vm.trCase.id){
					$(":file").filestyle({
						buttonBefore: true
					});
					$(":file").filestyle('buttonText', 'Browse File');
				   }
				   AttributeMappingList.query(
					{
						page: 0,
						size: 1000,
						sort: "id,asc",
					},
					onSuccess,
					onError
				);
				function onSuccess(data, headers) {
					vm.attributeMappingList = data;
					vm.attributeMappingList.forEach(function (val){
						vm.checkattributeMappingList.push(val.caseTypeSubCategory.id)
					})
				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
			});

			UserAccount.get(function (data) {
				vm.userAdmin = data;
				vm.reportToId = data.id
				var isAdmin = false;
				data.authorities.forEach(function (val) {
					if(val == 'ROLE_FRT' || val == 'ROLE_PATROLLER' ){
						vm.checkFrtPat = true
						vm.isSaving = false
					}

					if (val == "ROLE_USER_ADMIN") {
						isAdmin = true;
					}
					if (val == "ROLE_HOD") {
						isAdmin = true;
					}
					if (val == "ROLE_FE") {
						$scope.FRTselectedGeofence()
					}
				
				});
				if (isAdmin) {
					GeofenceIDs.getAll(function (response) {
						response.forEach(function (geofence) {
							if (geofence.name != 'Bangalore') {
								vm.userGeofences.push(geofence);
								if (vm.selectedGeofenceId == null) {
									vm.selectedGeofenceId = geofence.id;
									vm.canFilter = true;
								}
							}
						});
						setCaseGeofences();
					});
				} else {
					UserGeofences.getAll(function (response) {
						vm.userGeofenceList = response;
						response.forEach(function (geofence) {
							if (geofence.name != 'Bangalore') {
								vm.userGeofences.push(geofence);
								if (vm.selectedGeofenceId == null) {
									vm.selectedGeofenceId = geofence.id;
									vm.canFilter = true;
								}
							}
						});
						setCaseGeofences();
					});
				}
			});
		}

		function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

		function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
			var locationButton = document.createElement("button");
			locationButton.setAttribute("title","Locate Me");
			locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon)
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
							infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");	
                            infoWindow.open(map);
                            map.setCenter(pos);
							map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

		function ReverseGeocode(latitude, longitude) {
			var address = new google.maps.Geocoder();

			address.geocode({
				'latLng': { lat: latitude, lng: longitude }
			}, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					if (results[0]) {
						vm.trCase.address = results[0].formatted_address;
					}
				}
			});
		}
		 function showExisting(){
			$("#existingAsset").removeClass("in");
			$(".modal-backdrop").remove();
			$("#existingAsset").hide();
			vm.isSaving = false;
		}
	      
		$scope.attributeMappingChange = function(id){
			var passId;
			vm.customAttributesMap[id.caseTypeAttribute.attributeDataType.name].forEach(function(val){
				if(val.value  == id.attributeValue){
					passId = val.id
				}
			}) 
				AttributeMappingId.get(passId,function(res){
					if(res.length > 0){
						res.forEach(function(val){
								if(vm.customAttributesMap[val.parentValue].parentId == val.parentId){
										vm.customAttributesMap[val.parentValue].length = 0
								}
						}) 
						res.forEach(function(val){
							vm.customAttributesMap[val.parentValue].push({id : val.id , value : val.value, parentId : val.parentId})
						}) 
					} else{
						if(vm.checkattributeMappingList.indexOf(passId) == -1 ){
								AllCustomCaseTypeAttribute.getAll(function (response) {
								response.forEach(function (arrayItem) {
									vm.customAttributesMap[arrayItem.name] = arrayItem.customCaseTypeAttributeValues;
									vm.customAttributesMap[arrayItem.name].parentId = arrayItem.id
								}); 
								
							})
						} 
					} 
					/* if(res.length > 0){
						res.forEach(function(val){
								if(vm.customAttributesMap[val.parentValue].parentId == val.parentId){
										vm.customAttributesMap[val.parentValue].length = 0
								}
						}) 
						res.forEach(function(val){
							vm.customAttributesMap[val.parentValue].push({id : val.id , value : val.value, parentId : val.parentId})
						}) 
					} else{
							AllCustomCaseTypeAttribute.getAll(function (response) {
								response.forEach(function (arrayItem) {
									vm.customAttributesMap[arrayItem.name] = arrayItem.customCaseTypeAttributeValues;
									vm.customAttributesMap[arrayItem.name].parentId = arrayItem.id
								}); 
							})
					} */
				})
		}

		function save() {
			//vm.isSaving = true;
			if (vm.trCase.groups.length == 0 || vm.trCase.assignedToUser == null) {
				vm.isSaving = true
			}
			if ($rootScope.createCaseFromAssetMap) {
				vm.trCase.caseAssets = $rootScope.createCaseFromAssetMap
			}

			if (vm.showCableSplice || vm.showFmsTermination) {
				vm.trCase.priority = "LOW"
			}

			vm.trCase.submitted = false;
			if (vm.caseType.name != 'Vendor Civil Work') {
				var assignedToUser = $("#field_assignedToUser").val();

				if (assignedToUser == undefined) {
					if (vm.trCase.assignedToUser != undefined) {
						assignedToUser = vm.trCase.assignedToUser;
					} else {
						assignedToUser = vm.AccountUserName;
					}
				}
				if (vm.checkFrtPat) {
					vm.trCase.reportedBy = vm.reportToId;
				} else {
					if (vm.users != undefined) {
						vm.users.forEach(function (user) {
							if (user.login == assignedToUser) {
								vm.trCase.assignedTo = user.id;
							}
						});
					} else {
						UserValueSearch.query({
							search: assignedToUser,
						}, onSuccess, onError);

						function onSuccess(data, headers) {
							data.forEach(function (user) {
								if (user.login == assignedToUser) {
									vm.trCase.assignedTo = user.id;
								}
							});
						}

						function onError(error) {
							AlertService.error(error.data.message);
						}
					}
				}
			}
			angular.forEach(vm.assetList, function (value, key) {
				if (vm.trCase.asset.name === value.name) {
					vm.trCase.asset = value;
				}
			});
			var mandatoryCaseAttr = checkMandatoryAttributes(vm.trCase.caseTypeAttributeValues);
			if (mandatoryCaseAttr.length > 0) {
				// alert(mandatoryCaseAttr);

				var ele = document.getElementById("popupDialogModal");
				$(ele).modal('show');
				$("#popupDialogModal").show();
				$("#alertMessage").html("--- Mandatory Attributes --- <br />" + mandatoryCaseAttr.split(",").join("<br />"));
				vm.isSaving = false;
			} else {
				if (assignedToUser != null) {
					if (vm.trCase.id !== null) {
						TrCase.update(vm.trCase, onSaveSuccesss, onSaveError);
					} else {
						if (vm.caseType.name == 'UG OH Declaration') {

							NearByBGOH.getAll(vm.trCase, onSuccess, onError)
							function onSuccess(data) {
								//vm.isSaving = false;
								if (data.length > 0) {
									$("#existingAsset").show();
								} else {
									TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
								}
							}

							function onError(error) {
								/* vm.handlingError = error
								vm.isSaving = false
								AlertService.error(error); */
								if (error == 404) {
									TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
								}
							}

						} else {
							TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
						}

					}
				}
			}
		}
		
		function submit() {
			vm.isSaving = true;
			vm.trCase.submitted = true;
			if(vm.users!=undefined){
				vm.users.forEach(function(user){
					if(user.login==vm.trCase.assignedToUser){
						vm.trCase.assignedTo = user.id;
					}
				});
			} else {
				UserValueSearch.query({
					search: vm.trCase.assignedToUser,
				}, onSuccess, onError);

				function onSuccess(data, headers) {
					data.forEach(function(user){
						if(user.login==vm.trCase.assignedToUser){
							vm.trCase.assignedTo = user.id;
						}
					});
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
			}

			angular.forEach(vm.assetList, function (value, key) {
				if (vm.trCase.asset.name === value.name) {
					vm.trCase.asset = value;
				}
			});
			var mandatoryCaseAttr = checkMandatoryAttributes(vm.trCase.caseTypeAttributeValues);
			if (mandatoryCaseAttr.length > 0) {
				// alert(mandatoryCaseAttr);

				var ele = document.getElementById("popupDialogModal");
				$(ele).modal('show');
				$("#popupDialogModal").show();
				$("#alertMessage").html("--- Mandatory Attributes --- <br />" + mandatoryCaseAttr.split(",").join("<br />"));
				vm.isSaving = false;
			} else {
				if (vm.trCase.id !== null) {
					TrCase.update(vm.trCase, onSaveSuccess, onSaveError);
				} else {
					TrCase.save(vm.trCase, onSaveSuccess, onSaveError);
				}
			}
		}
		function checkMandatoryAttributes(caseTypeAttribute) {
			var resStr = "";
			
			caseTypeAttribute.forEach(function (value) {
				if (value.caseTypeAttribute.mandatory) {
					if (value.attributeValue == "" || value.attributeValue == "." || value.attributeValue == null) {
						if (((!vm.trCase.id && (value.caseTypeAttribute.caseCategory == 'CATEGORY1' || value.caseTypeAttribute.caseCategory == 'DEFAULT' || value.caseTypeAttribute.caseCategory == null))
							|| (vm.trCase.id && ((vm.prevStatus != 'ASSIGNED' && vm.prevStatus == 'NEW') || (vm.prevStatus != 'NEW' && vm.prevStatus == 'ASSIGNED')) && (value.caseTypeAttribute.caseCategory == 'CATEGORY1' || value.caseTypeAttribute.caseCategory == 'DEFAULT' || value.caseTypeAttribute.caseCategory == null))
							|| (vm.trCase.id && vm.prevStatus != 'ASSIGNED' && vm.prevStatus != 'NEW') || (vm.trCase.id && vm.prevStatus == 'ASSIGNED'  && $rootScope.has_ROLE_FRT && vm.trCase.caseType.name=='Incident Management')
							|| (vm.trCase.id && vm.prevStatus=='ASSIGNED' && (vm.trCase.caseType.name!='Issue on Field' && vm.trCase.caseType.name!='Asset Safety Related' && vm.trCase.caseType.name!='Productivity & NTP' && vm.trCase.caseType.name!='PM Activity' && vm.trCase.caseType.name!='UG OH Declaration' && vm.trCase.caseType.name!='Fiber Provisioning' && vm.trCase.caseType.name!='Chamber Declaration' && vm.trCase.caseType.name!='Vendor Civil Work' && vm.trCase.caseType.name!='Incident Management')))) /*FIBERIFY-482*/{
							if (resStr.length == 0) {
								resStr = value.caseTypeAttribute.name;
							} else {
								resStr = resStr + ", " + value.caseTypeAttribute.name;
							}
						}
					}
				}
			});

			/* caseTypeAttribute.forEach(function (value) { 
				var intial = value.attributeValue
				var parsedValue = JSON.parse(intial)
				value.attributeValue = parsedValue.value
			}) */
			return resStr;
		}

		$("#caseImages").change(function () {

			var filesSelected = document.getElementById("caseImages").files;
			vm.fileWarning = false
			$scope.$apply();
            for (var i = 0; i < filesSelected.length; i++) {
                if (filesSelected[i].size <= maxSize) {
                    var fileReader = new FileReader();

                    fileReader.onload = function (fileLoadedEvent) {
                        vm.trCase.caseImages.push({
                            image: window.btoa(fileLoadedEvent.target.result),
                            trCase: {
                                id: entity_old.id,
                            },
                        });
                    };
                    fileReader.readAsBinaryString(filesSelected[i]);
                }else{
					vm.fileWarning = true
					$scope.$apply();
				}
            }

		});

		$("#attachmentFile").change(function () { 
			attachment = document.getElementById("attachmentFile").files[0];
			vm.fileWarnings = (attachment.size > maxSize) ? true : false
			$scope.$apply();
		})
		
		$scope.deleteDisplayImage = function(id){
            vm.trCase.caseImages.splice(id,1)
        }

		$scope.newTabDisplay = function(id){
            var request = new XMLHttpRequest();
            request.open('GET',"api/trakeyecaseimages/"+vm.trCase.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                window.open(imageUrl, "_blank")}
            } 
            request.send();
        } 

		function onSaveSuccesss(result) {
			if(vm.showCaseAttachment){
				if(attachment && attachment.type == "application/pdf" && attachment.size <= maxSize){
					var req = new XMLHttpRequest();
					var formData = new FormData();
					var name = attachment.name.split(".")[0];
					var type = attachment.name.split(".")[1];
					formData.append("file", attachment);
					req.open(
						"POST",
						"api/trakeyecaseimages/" +
							vm.trCase.id +
							"/" +
							name +
							"/" +
							type
					);
					req.setRequestHeader(
						"Authorization",
						"Bearer " + $localStorage.authenticationToken
					);
					req.send(formData);
					} 
			}
			$scope.$emit('trakeyeApp:trCaseUpdate', result);
			$state.go('tr-case');
			// $uibModalInstance.close(result);
			vm.isSaving = false;
		}

		function onSaveSuccess(result) {
			$scope.$emit('trakeyeApp:trCaseUpdate', result);
			$state.go('tr-case');
			// $uibModalInstance.close(result);
			vm.isSaving = false;
		}
		vm.caseType = entity.caseType;

		function selectedCaseTypeAttributes() {
			vm.showCableSplice = false;
			vm.showFmsTermination = false;
			$scope.allpdf = false;
			$scope.cableDetails = false;
			$scope.splicingDetails = false;
			$scope.fmsDetails = false;
			$scope.terminationDetails = false;
			vm.showTermination = false; 
			vm.showFMS = false;
			vm.showSplicing = false;
			vm.showCable = false;
			vm.showPdf = false;

			if(vm.caseType.name == "Splicing Details"){
				vm.trCase.cableDetails = []
				vm.trCase.splicingDetails = []
				vm.showCableSplice = true;
				vm.isSaving = true
				Configs.get("CableSide",function(response){ 
					vm.cableSide = response
				})
				Configs.get("CableName",function(response){ 
					vm.cableName = response
				})
				Configs.get("JEAvailability",function(response){ 
					vm.jeAvailability = response
				})
				Configs.get("CableCapacity",function(response){ 
					vm.cableCapacity = response
				})
				Configs.get("TubeSide",function(response){ 
					vm.tubeSide = response
				})
				Configs.get("JENumber",function(response){ 
					vm.jeNumber = response
				})
			}

			if(vm.caseType.name == "Termination Details"){
				vm.showFmsTermination = true;
				vm.trCase.fmsAndCableDetails = []
				vm.trCase.terminationDetails = []
				vm.isSaving = true
				Configs.get("CableSide",function(response){ 
					vm.cableSide = response
				})
				Configs.get("FMSNumber",function(response){ 
					vm.fmsNumber = response
				}) 
				Configs.get("FMSCapacity",function(response){ 
					vm.fmsCapacity = response
				}) 
				Configs.get("FMS",function(response){ 
					vm.fms = response
				}) 
				Configs.get("Type",function(response){ 
					vm.type = response
				}) 
				Configs.get("CableNumber",function(response){ 
					vm.cableNumber = response
				}) 
			}

			if (vm.caseType) {
				vm.trCase.caseType = vm.caseType;
				if (entity_old.caseType && vm.caseType.id === entity_old.caseType.id) {
					vm.trCase.caseTypeAttributeValues = [];
					vm.trCase.caseTypeAttributeValues = entity_old.caseTypeAttributeValues;
				} else {
					vm.trCase.caseTypeAttributeValues = [];
					$.each(vm.caseType.caseTypeAttribute, function (key, value) {
						vm.trCase.caseTypeAttributeValues.push({
							caseTypeAttribute: vm.caseType.caseTypeAttribute[key]
						});
					});
				}
			}
			
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		vm.datePickerOpenStatus.createDate = false;
		vm.datePickerOpenStatus.updateDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		function decodeImage(img) {
			return window.atob(img);
		}

		function filterUser() {
			if (vm.trCase.assignedToUser != null && vm.trCase.assignedToUser != "" && !angular.isUndefined(vm.trCase.assignedToUser)) {
				UserValueSearch.query({
					search: vm.trCase.assignedToUser,
				}, onSuccess, onError);

				function onSuccess(data, headers) {
					vm.users = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}

				ChildUsersMiniGeofence.query({
					userLogin: vm.trCase.assignedToUser,
				}, onSuccessUserLogin, onErrorUserLogin);

				function onSuccessUserLogin(data, headers) {
					vm.geofences = data;
				}

				function onErrorUserLogin(error) {
					AlertService.error(error.data.message);
				}
			}
		}

		$scope.openAssetMapModal = function () {
			var value = vm.trCase.asset;
			if (vm.trCase.asset.assetCoordinates.length > 0) {
				$("#assetsModal").show();
				var myCenter = new google.maps.LatLng(vm.trCase.pinLat, vm.trCase.pinLong);
				var ele = document.getElementById("assetsModal");
				$(ele).modal('show');
				//
				var locMap = new google.maps.Map(document
					.getElementById('map_canvas_assets'),myOption(14,myCenter) /* {
					center: myCenter,
					zoom: 14
				} */);

				//	            var markerA = new google.maps.Marker({
				//                    position: myCenter,
				//                    icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
				//                    map: locMap
				//                });

				//                var markerContent = '<div class="infoWindowhead"><b>'+ vm.trCase.description
				//    			+ '</b></div><div class="infoWindowContent">'
				//    			+'<b>Lat : </b>'+ vm.trCase.pinLat
				//    			+'<br><b>Lng : </b>'+ vm.trCase.pinLong
				//    			+'</div>';
				//                
				//                var infoWindow1 = new google.maps.InfoWindow({
				//                	content: markerContent
				//                });

				//    	        markerA.addListener('click', function () {
				//    	        	if (openedInfoWindow != null) {
				//                        openedInfoWindow.close();
				//                    }
				//    	        	infoWindow1.open(map, markerA);
				//    	        	openedInfoWindow = infoWindow1;
				//    	        });

				if (value.assetType != null) {
					if (value.assetType != null && value.assetType.layout == 'FIXED') {
						drawFixedAsset(value, locMap);
					} else if (value.assetType != null && value.assetType.layout == 'SPREAD') {
						if (value.assetCoordinates.length > 0) {
							drawPolyline(value, locMap);
						}
					}
				}

				$('#assetsModal').on('show.bs.modal', function (event) {
					$("#location-map-assets").css("width", "100%");
					$("#map_canvas_assets").css("width", "100%");
				});
			} else {
				//console.log(value.customerName + " - Location details missing!!!");
			}
		}

		function drawFixedAsset(fixed, locMap) {

			if (fixed.assetCoordinates.length > 0) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}
				var marker = new google.maps.Marker({
					position: new google.maps.LatLng(fixed.assetCoordinates[0].latitude, fixed.assetCoordinates[0].longitude),
					map: locMap,
					icon: {
						scaledSize: new google.maps.Size(
							30, 30),
						origin: new google.maps.Point(
							0, 0),
						url: fixed.assetType.imagePath,
						anchor: new google.maps.Point(
							16, 16),

					}
				});

				marker.setMap(locMap);

				var infowindow = new google.maps.InfoWindow({
					content: fixed.name
				});

				google.maps.event.addListener(marker, 'mouseover', function () {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					infowindow.open(locMap, marker);
					openedInfoWindow = infowindow;
				});
				google.maps.event.addListener(marker, 'mouseout', function () {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
				});
				openedInfoWindow = infowindow;
			}
		}

		function drawPolyline(spread, locMap) {

			var polylineColor = null;

			var spreadAssetCoordinates = [];
			var assetCoordinatesList = spread.assetCoordinates;

			assetCoordinatesList.forEach(function (value) {
				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});

			if (spreadAssetCoordinates.length > 0) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var infowindow = new google.maps.InfoWindow({
					content: '<div class="infoWindowhead">' +
						spread.name +
						'</div>'
				});

				if (spread.assetType.layout == "SPREAD") {
					polylineColor = spread.assetType.colorcode;
				}
				infowindow.setPosition(midLatLng);
				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1.0,
					strokeWeight: 2.5,
					fillColor: spread.assetType.colorcode,
					fillOpacity: 0.3,
					editable: false
				});

				google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
					infowindow.close();
				});

				google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}

					infowindow.setContent('<div class="infoWindowhead">' +
						spread.name +
						'</div>'
					);

					infowindow.mousemove
					infowindow.setPosition(event.latLng);
					infowindow.open(locMap);
					openedInfoWindow = infowindow;
				});

				if (spread.status != null && spread.status === false) {
					polylinepath.setOptions({
						strokeColor: polylineColor
					});
				}

				polylinepath.setMap(locMap);
			}
		}

		function getUsersByGeofence() {
			vm.activatedusers = [];
			setTimeout(function () {
				usersByGeofence.post(vm.geofenceData, function (data) {
					vm.activatedusers = data || [];
					loadMiniAndMasterUsers();

				}, function (error) {
					console.error("Error fetching users:", error);
					loadMiniAndMasterUsers();
				});
			}, 500)
			function loadMiniAndMasterUsers() {
				vm.userAdmin.authorities.forEach(function (authorities) {
					if (authorities == "ROLE_FE" || authorities == "ROLE_NETWORK_ENGINEER" || authorities == "ROLE_FRT" || authorities == "ROLE_PATROLLER") {
						if(vm.nePayload!=undefined){
							usersByGeofence.postMiniPayload(vm.nePayload, function (miniData) {
								appendUsers(miniData);
							}, function (error) {
								console.error("Mini payload error:", error);
							});
							usersByGeofence.postMasterPayload(vm.nePayload, function (masterData) {
								appendUsers(masterData);
							}, function (error) {
								console.error("Master payload error:", error);
							});
						}
					}
				})


				var isCurrentUserExists = false;
				vm.activatedusers.forEach(function (userVal) {
					if (userVal.login == vm.trCase.assignedToUser) {
						isCurrentUserExists = true;
					}
				});

				if (!isCurrentUserExists) {
					vm.activatedusers.push({ firstName: vm.trCase.assignedToUser, login: vm.trCase.assignedToUser, inprogressCount: 1 });
				}
			}
			function appendUsers(users) {
				if (!users || !users.length) {
					return;
				}

				angular.forEach(users, function (user) {
					if (!isUserExists(user)) {
						vm.activatedusers.push(user);
					}
				});

			}
			function isUserExists(newUser) {
				var exists = false;

				angular.forEach(vm.activatedusers, function (user) {
					if (user.login === newUser.login) {
						exists = true;
					}
				});

				return exists;
			}
		}

		vm.getUserStatus = function (user) {
			if (user.inprogressCount > 0) {
				return '(Busy)';
			} else if (user.hasCase > 0) {
				return '(Assigned)';
			} else {
				return '(Available)';
			}
		};

		vm.getUserStyle = function (user) {
			if (user.inprogressCount > 0) {
				return { color: 'red', 'font-weight': 'bold' };
			} else if (user.hasCase > 0) {
				return { color: 'orange' };
			} else {
				return { color: 'green' };
			}
		};
		function filterActivatedUser() {
			if (vm.trCase.assignedToUser != null && vm.trCase.assignedToUser != "" && !angular.isUndefined(vm.trCase.assignedToUser)) {
				if($rootScope.has_ROLE_TEAM_LEADER && vm.prevStatus=="ASSIGNED" && vm.caseType.name=="Vendor Civil Work"){
					AssocitedVendorSearch.query({
						page: 0,
                        size: 10,
						userId: vm.trCase.assignedToUser,
					}, onSuccess, onError);
				}else{
					activatedUsers.get()
                       .then(onSuccess)
                       .catch(onError);
				}

				function onSuccess(data, headers) {
					vm.activatedusers = [];
					
					data.data.forEach(function (dataVal) {
						if (vm.trCase.id && $rootScope.has_ROLE_NETWORK_ENGINEER) {
							vm.activatedusers.push(dataVal);
						} else {
							vm.activatedusers.push(dataVal);
						}
					});

					// angular.forEach(vm.activatedusers, function (value, key) {
					// 	usersMap[value.login] = value.id;
					// });
					vm.isSaving = false
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
			}
		}

		

		// Added for asset search start
		function filterAssetsList() {
			if (vm.trCase.asset.name != null && vm.trCase.asset.name != "" && !angular.isUndefined(vm.trCase.asset.name)) {
				/*
				 * AssetSearchForMap.searchassetsformap(vm.trCase.asset.name,
				 * function (response) { vm.assetList = response; });
				 */

				AssetSearch.query({
					search: vm.trCase.asset.name,

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					vm.assetList = data;

				}

				function onError(error) {
					AlertService.error(error.data.message);
				}

			}
		};

		// Added for getting lat alng values from map
		var latlng = new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE);
		/* var settings = {
			zoom: 14,
			center: latlng,
			mapTypeControl: true,
			scaleControl: true,
			mapTypeControlOptions: {
				style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
			},
			navigationControl: true,
			navigationControlOptions: {
				style: google.maps.NavigationControlStyle.DEFAULT
			},
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			backgroundColor: 'white',

		}; */

		locations.map = new google.maps.Map(document.getElementById('map_canvas'), myOption(14,latlng)/* settings */);
		geoLocation(locations.map)
		var address = new google.maps.Geocoder();
		google.maps.event.addListener(locations.map, 'click', function (event) {

			address.geocode({
				'latLng': event.latLng
			}, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					if (results[0]) {
						$ngConfirm({
							title: 'Are you sure you want to select this address?',
							content: '<strong>Address: </strong>' + results[0].formatted_address + '<br/>' + '<strong>Latitude: </strong>' + event.latLng.lat() + '</br>' +
								'<strong>Longitude: </strong>' + event.latLng.lng(),
							type: "blue",
							typeAnimated: true,
							buttons: {
								OK: {
									text: 'OK',
									btnClass: 'btn-primary',
									action: function () {
										$scope.$apply(function () {
											vm.trCase.pinLat = event.latLng.lat();
											vm.trCase.pinLong = event.latLng.lng();
											vm.trCase.address = results[0].formatted_address;
											// alert('Lat: ' +
											// event.latLng.lat() + ' Lng: ' +
											// event.latLng.lng())
										})
									}
								},
								Cancel: {
									text: 'Cancel',
									btnClass: 'btn-danger',
									action: function () {

									}

								},

							}
						});

					}
				}
			});
		});

		function setCaseGeofences() {
			var isUserCaseAdmin = false;
			vm.userAdmin.authorities.forEach(function (user) {
				if (user == "ROLE_USER_ADMIN") {
					isUserCaseAdmin = true;
				}
				if (user == "ROLE_HOD") {
					isUserCaseAdmin = true;
				}
			});
			if (isUserCaseAdmin) {
				// Geofence.query({
				// 	page: 0,
				// 	size: 500,
				// }, onSuccess, onError);

				// function onSuccess(data, headers) {
				// 	vm.selectedGeofence = [];
				// 	data.forEach(function (value) {
				// 		if (value.zone) {
				// 			value.type = "MASTER";
				// 		} else {
				// 			value.type = "MINI";
				// 		}
				// 		vm.selectedGeofence.push(value);
				// 	});
				// 	drawLatestGeofence(vm.selectedGeofence);
				// }

				// function onError(error) {
				// 	// AlertService.error(error.data.message);
				// }

				GeofenceIDs.getAll(function (response) {
					vm.selectedGeofence = [];
					response.forEach(function (value) {
						if (value.zone) {
							value.type = "MASTER";
						} else {
							value.type = "MINI";
						}
						vm.selectedGeofence.push(value);
					});
					drawLatestGeofence(vm.selectedGeofence);
				});

			} else {
				drawLatestGeofence(vm.userGeofenceList);
			}
		}

		function drawLatestGeofence(response) {
			if (response) {
				initializeGeofenceMap(response, function (latlang) {
					locations.latlng = latlang;
					// function() {
					$.each(response, function (index, value) {
						try {
							if (value.type != "Master" && value.coordinates!=undefined) {
								var path = JSON.parse(value.coordinates);
								// drawPolylineForGeoFence(path, locations.map, value.name);
								var infowindow = new google.maps.InfoWindow(
									{
										content: '<div class="infoWindowhead">'
											+ "name"
											+ '<div class="infoWindowContent"> <b>Description :</b> '
											+ "des" + '</div></div>'
									});

								infowindow.setPosition(latlang);
								var tempGeofences = new google.maps.Polyline({
									path: path,
									geodesic: true,
									strokeColor: "#ff0000",
									strokeOpacity: 0.5,
									strokeWeight: 3
								});
								google.maps.event.addListener(tempGeofences, 'mouseout', function (event) {
									infowindow.close();
								});

								google.maps.event.addListener(tempGeofences, 'click', function (event) {
									if (openedInfoWindow != null) {
										openedInfoWindow.close();
									}
									infowindow.setContent('<div class="infoWindowhead">'
										+ '<b>Geofence Name : </b><br><br>' + value.name + '</br></div>'
									);

									infowindow.mousemove;
									infowindow.open(locations.map);
									infowindow.setPosition(event.latLng);
									openedInfoWindow = infowindow;
								});
								tempGeofences.setMap(locations.map);
							}
						} catch (err) {
							console.log(err);
						}
					});
				});
			}
		}

		function initializeGeofenceMap(latlangs, callback) {
			if (latlangs && latlangs.length > 0) {
				latlng = new google.maps.LatLng(latlangs[0].pinLat, latlangs[0].pinLong);
				callback(latlng);
			} else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (position) {

						latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
						callback(latlng);
					}, function () {

						callback(new google.maps.LatLng("5.431587", "101.128162"));
					});
				} else {
					callback(new google.maps.LatLng("5.431587", "101.128162"));
				}
			}
		}

		function filterAssetsOnMapView() {
			$("#mapFilterModal").show();
			noDataText = document.getElementById("noData");
			noDataText.style.display = "none";
			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
		}

		function closeMapFilterModal(id) {
			vm.isSaving = false;
			$("#"+id).removeClass("in");
			$(".modal-backdrop").remove();
			$("#"+id).hide();
			vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
		}

		function closePopupDialogModal() {
			$("#popupDialogModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#popupDialogModal").hide();
			vm.isSaving = false;
		}

		function closeModal(id) {
			$("#scrollTop").scrollTop(0);
			if(vm.editDetails){
				if(id == 'splicingDetails'){
					vm.trCase.splicingDetails.splice(vm.selectedSlicing,1)
				}
				if(id == 'cableDetails'){
					vm.trCase.cableDetails.splice(vm.selectedCable,1)
				}
				if(id == 'fmsDetails'){
					vm.trCase.fmsAndCableDetails.splice(vm.selectedFms,1)
				}
				if(id == 'terminationDetails'){
					vm.trCase.terminationDetails.splice(vm.selectedTermination,1)
				}
			}else{
				vm.trCase = vm.new
			}
			$("#"+id).removeClass("in");
			$(".modal-backdrop").remove();
			$("#"+id).hide();
		}

		function saveFilter() {
			vm.mapAssets = [];
			markers = [];
			polylines = [];
			/* var myOptions = {
				zoom: 16,
				center: latlng,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			}; */
			locations.map = new google.maps.Map(document.getElementById("map_canvas"), myOption(16,latlng));
			geoLocation(locations.map)
			getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
			setCaseGeofences();
			google.maps.event.addListener(locations.map, 'click', function (event) {

				address.geocode({
					'latLng': event.latLng
				}, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						if (results[0]) {
							$ngConfirm({
								title: 'Are you sure you want to select this address?',
								content: '<strong>Address: </strong>' + results[0].formatted_address + '<br/>' + '<strong>Latitude: </strong>' + event.latLng.lat() + '</br>' +
									'<strong>Longitude: </strong>' + event.latLng.lng(),
								type: "blue",
								typeAnimated: true,
								buttons: {
									OK: {
										text: 'OK',
										btnClass: 'btn-primary',
										action: function () {
											$scope.$apply(function () {
												vm.trCase.pinLat = event.latLng.lat();
												vm.trCase.pinLong = event.latLng.lng();
												vm.trCase.address = results[0].formatted_address;
											})
										}
									},
									Cancel: {
										text: 'Cancel',
										btnClass: 'btn-danger',
										action: function () {

										}

									},

								}
							});

						}
					}
				});
			});
			$("#mapFilterModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterModal").hide();
		}

		function getGroupAssetsFromES(geofenceIdVal, lastAssetId, mapAssetLists) {
			AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
				vm.mapAssets = mapAssetLists;
				data.assets.forEach(function (asset) {
					var tmpAsset = {};

					tmpAsset.assetCoordinates = asset.assetCoordinates;
					tmpAsset.assetTypeName = asset.assetTypeName;
					tmpAsset.assetTypeColor = asset.assetColor;
					tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
					tmpAsset.assetTypeLayout = asset.assetTypeLayout;
					tmpAsset.id = asset.id;
					tmpAsset.name = asset.name;

					vm.mapAssets.push(tmpAsset);
				});
				drawLatestAssets(vm.mapAssets);
				if (data.lastId != null) {
					getGroupAssetsFromES(geofenceIdVal, data.lastId, vm.mapAssets);
				} else {
					if (vm.mapAssets.length > 0) {
						var assetSelected = vm.mapAssets[0];
						AssetByID.get(assetSelected.id, function (assetVal) {
							var assetLatLng = ({
								lat: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].latitude,
								lng: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].longitude
							});
							locations.map.setCenter(assetLatLng);
						});
					}
				}
			});
		}

		function hideEditModal() {
			$("#userPathModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#userPathModal").hide();
		}
		$('#userPathModal').on('hidden.bs.modal', function () {
			//			filterAssetsformap();
		})

		function getAssetAddress() {
			if (vm.trCase.pinLat != null && vm.trCase.pinLong != null) {
				var latlng = new google.maps.LatLng(vm.trCase.pinLat, vm.trCase.pinLong);
				// This is making the Geocode request
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'latLng': latlng }, function (results, status) {
					// if (status !== google.maps.GeocoderStatus.OK) {
					//	console.log(status);
					// }
					// This is checking to see if the Geoeode Status is OK before proceeding
					if (status == google.maps.GeocoderStatus.OK) {
						$scope.$apply(function () {
							vm.trCase.address = results[0].formatted_address;
						});
					}
				});
			}
		}

		function drawLatestAssets(response) {
			if (response) {
				initializeAssetMap(response, function (latlang) {
					locations.latlng = latlang;

					setupAssetMap(function () {
						$.each(response, function (index, value) {
							if (value.assetTypeLayout == null) {
								value.assetTypeName = value.assetType.name;
								value.assetTypeLayout = value.assetType.layout;
								value.assetTypeImagePath = value.assetType.imagePath;
							}
							if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
								if (value.assetCoordinates.length > 1) {
									drawPolyline(value);
									var value1 = value;
									value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

									drawFixedAsset(value1, false);

								} else {
									drawFixedAsset(value, false);
								}
							}
							if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
								drawPolyline(value, locations.map);
							}

						});
					});
				});
			}
		}

		function initializeAssetMap(latlangs, callback) {

			if (latlangs && latlangs.length > 0) {
				var latVal = null;
				var lngVal = null;
				latlangs.forEach(function (value) {
					if (latVal == null && lngVal == null) {
						if (value.assetCoordinates.length > 0) {
							latVal = value.assetCoordinates[value.assetCoordinates.length - 1].latitude;
							lngVal = value.assetCoordinates[value.assetCoordinates.length - 1].longitude;
						}
					}
				});
				if (latVal != null && lngVal != null) {
					latlng = new google.maps.LatLng(latVal, lngVal);
					callback(latlng);
				}
			} else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (
						position) {

						latlng = new google.maps.LatLng(
							position.coords.latitude,
							position.coords.longitude);
						callback(latlng);
					}, function () {

						// callback(new google.maps.LatLng("12.9716", "77.5946"));
						callback(new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE));
					});
				} else {
					callback(new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE));
				}
			}
		}

		function setupAssetMap(callback) {
			if (locations.map == null) {
				/* var myOptions = {
					zoom: 14,
					center: locations.latlng,
					mapTypeId: google.maps.MapTypeId.ROADMAP
				}; */

				locations.map = new google.maps.Map(document
					.getElementById("map_canvas"), myOption(14,locations.latlng));
				geoLocation(locations.map)
				google.maps.event.addListener(locations.map, 'zoom_changed', function () {
					vm.zoomLevel = locations.map.getZoom();
					if ((vm.prevZoomLevel == 17 && vm.zoomLevel == 18) || (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)) {
						drawLatestAssets(vm.mapAssets);
					}
					vm.prevZoomLevel = vm.zoomLevel;

				});
			} else {
				// Loop through all the markers and polylines to remove

				for (var i = 0; i < markers.length; i++) {
					markers[i].setMap(null);
				}

				for (i = 0; i < polylines.length; i++) {
					polylines[i].setMap(null);
				}

				markers = [];
				polylines = [];
			}
			locations.overlay = new google.maps.OverlayView();
			locations.overlay.draw = function () { };
			locations.overlay.setMap($scope.map);
			locations.element = document.getElementById('map_canvas');
			callback();
		}
	 	vm.incidentStatuses = [];
		vm.incidentRCAstatus = []

		$timeout(function () {
			IncidentStatusConfig.getAll(function (response) {

				response.sort(function (a, b) {
					return a.configValueOrder - b.configValueOrder;
				});

				vm.incidentStatuses = response;
			});
			IncidentStatusConfig.getRCAstatus(function (response) {

				response.sort(function (a, b) {
					return a.configValueOrder - b.configValueOrder;
				});

				vm.incidentRCAstatus = response;
			});
		}, 500);

		function drawPolyline(spread, map) {

			var spreadAssetCoordinates = [];
			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spread.assetTypeColor
				}
				var polylineWeight = 2.5;
				var strokeOpacityVal = 1.0;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div'),
								button;

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(locations.map);
						openedInfoWindow = infowindow;
					}
				});

				var polylinepathDuct = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				polylinepath.setMap(locations.map);

				polylines.push(polylinepath);
			}
		}

		function drawFixedAsset(fixed, hasParent) {

			$.each(fixed.assetCoordinates, function (index, value1) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}

				var infoWindow = new google.maps.InfoWindow();


				var iconUrl = "";
				var isFixedAsset = false;
				iconUrl = fixed.assetTypeImagePath;
				isFixedAsset = true;

				var iconSize = 8;
				if (vm.zoomLevel == 10) {
					iconSize = 8;
				} else if (vm.zoomLevel == 11) {
					iconSize = 16;
				}

				if (isFixedAsset) {
					iconSize = 24;
				}

				var startMarker = new google.maps.Marker({
					map: locations.map,
					position: new google.maps.LatLng(
						value1.latitude,
						value1.longitude),
					title: fixed.name,
					icon: {
						scaledSize: new google.maps.Size(
							iconSize, iconSize),
						url: iconUrl,
						anchor: new google.maps.Point(
							iconSize / 2, iconSize / 2),
					},
				});


				markers.push(startMarker);

				var infoWindow2 = new google.maps.InfoWindow();
				var infoStr = "";
				var otdr = "";

				var userContent = document.createElement('div'),
					button;

				userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
					'</div><div class="infoWindowContent">' +
					'<b>Lat</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
					'<br><b>Long</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
					'<br>' + infoStr + '</div>';

				google.maps.event.addListener(startMarker,
					'dblclick',
					function () {
						infoWindow2.close();
					});

				var activeInfoWindow;
				var infoWindow2 = new google.maps.InfoWindow({
					content: userContent
				});
				// add listener on InfoWindow for click
				// event
				google.maps.event.addListener(startMarker, 'click', function () {
					AssetByID.get(fixed.id, function (response) {
						var infoWindow2 = new google.maps.InfoWindow();
						var infoStr = "";
						var otdr = "";
						var assetTypeAttributeValuesList = response.assetTypeAttributeValues;
						assetTypeAttributeValuesList.sort(function (a, b) {
							var nameA = a.assetTypeAttribute.name.toLowerCase(),
								nameB = a.assetTypeAttribute.name.toLowerCase()
							if (nameA < nameB) // sort string ascending
								return -1
							if (nameA > nameB)
								return 1
							return 0 // default return value (no sorting)
						});
						for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
							var home = assetTypeAttributeValuesList[i];
							infoStr += '<br><b>' +
								home.assetTypeAttribute.name +
								'</b> : ' +
								home.attributeValue;
							otdr = home;
						}

						var userContent = document.createElement('div'),
							buttonA, buttonB, buttonC, buttonD;
						userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
							'</div><div class="infoWindowContent">' +
							'<b>Lat</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
							'<br><b>Long</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
							'<br>' + infoStr + '</div>';

						var infoWindow2 = new google.maps.InfoWindow({
							content: userContent
						});
						if (prevInfoWindow != null)
							prevInfoWindow.close();
						infoWindow2.open(locations.map, startMarker);
						setTimeout(function () { infoWindow2.close(); }, 5000);

						activeInfoWindow = infoWindow2;
						prevInfoWindow = infoWindow2;
					});

				});
				openedInfoWindow = infoWindow2;
			});
		}

		function distanceCal(lat1, lon1, lat2, lon2) {
			var theta = lon1 - lon2;
			var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
				Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
			dist = Math.acos(dist);
			dist = radians_to_degrees(dist);
			dist = dist * 60 * 1.1515;
			dist = dist * 1.609344;
			if (isNaN(dist)) {
				return 0.0;
			} else {
				return (dist);
			}
		}

		function degrees_to_radians(degrees) {
			var pi = Math.PI;
			return degrees * (pi / 180);
		}

		function radians_to_degrees(radians) {
			var pi = Math.PI;
			return radians * (180 / pi);
		}

		vm.callGroup = function(){
			vm.isSaving = false
		}
	

	}
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrCaseDetailController', TrCaseDetailController);

    TrCaseDetailController.$inject = ['$compile','$filter', '$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrCase', 'User', 'CaseType', 'TrCaseImages', 'TrCaseRecordings','AlertService','$window','$localStorage','getCaseImage','Configs','caseHistoryService','IncidentMaterial','geofenceMaterial','UserAccount','LocationLogMapPath','Report','TrCaseById','TrCaseHistoryImages', '$timeout'];

    function TrCaseDetailController($compile,$filter, $scope, $rootScope, $stateParams, previousState, entity, TrCase, User, CaseType,TrCaseImages,TrCaseRecordings,AlertService, $window,$localStorage,getCaseImage,Configs,caseHistoryService,IncidentMaterial,geofenceMaterial,UserAccount,LocationLogMapPath,Report,TrCaseById,TrCaseHistoryImages, $timeout ) {
		var vm = this;
		
      /*if (entity.status) {
        entity.status = entity.status.replace("NEW", "PLANNING PHASE");
        entity.status = entity.status.replace("INPROGRESS", "ROLL-OUT PHASE");
        entity.status = entity.status.replace("RESOLVED", "OPERATION PHASE");
      }*/

      vm.trCase = entity;
      vm.previousState = previousState.name;
      vm.assignedToUserId = null;
     
      vm.isMapVisible = false;
      vm.isMapRefreshing = false;
      vm.mapButtonText = "Show Map";
      var locations = {
        map: null,
        mapMarkers: [],
        mapPolylines: [],
        refreshControlAdded: false
      };
      var refreshControlButton = null;

      vm.decodeImage = decodeImage;
     
      var unsubscribe = $rootScope.$on('trakeyeApp:trCaseUpdate', function (event, result) {
        vm.trCase = result;
      });
     
      vm.propertyList = [];
      vm.selectedProperties = [];
      vm.historyList = [];
	  vm.showdownloadButton=true;      
	  vm.showhistoryDetailMedia=false;

      vm.showCaseAttachment = false
      Configs.get("CaseImage", function (response) {
        if (response.length > 0) {
          if (response[0].configValue == "True") {
            vm.showCaseAttachment = true
          }
        }
      })
		
      vm.imageInNewTab = function (img) {
        var imgWindow = window.open();
        imgWindow.document.write(
          '<img width="25%"   src="data:image/jpeg;base64,' +
          img +
          '">'
        );
        imgWindow.document.close();
      };

	vm.onMediaClick = function (item) {
			 vm.showdownloadButton= false;
		vm.showhistoryDetailMedia=true;
		    var spinner = document.getElementById("loading-bar-spinner");
		   // if (spinner) spinner.style.display = "block";
			vm.mediaHistoryDetails=item;
			console.log(item);
		    // Ensure list of Long IDs
		    var payload =  parseMediaIds(item.media);

		    TrCaseHistoryImages.fetch(
		        { caseId: vm.trCase.id },
		        payload,
		        function (data) {
		
		            $scope.mediaImagesIds = [];
		
		            angular.forEach(data, function (item, index) {
		                if (item.image) {
		                    $scope.mediaImagesIds.push({
		                        base64: item.image,
		                        imageType: "IMAGE",
		                        imageName: "case_image_" + (index + 1)
		                    });
		                }
		            });
		
		            if (!$scope.mediaImagesIds.length) {
		                alert("No images found for this case");
		                if (spinner) spinner.style.display = "none";
		                return;
		            }
		
		          //  if (spinner) spinner.style.display = "none";
					$scope.currentIndex = 0;
		            $scope.loadMedia($scope.mediaImagesIds[0]);
		            $("#mediaCarouselModal").modal("show");
		        },
		        function (error) {
		          //  if (spinner) spinner.style.display = "none";
		            AlertService.error(error.data.message);
		        }
		    );
		};
function parseMediaIds(media) {

    // Empty or null
    if (!media || media === '[]') {
        return [];
    }

    // Already an array
    if (angular.isArray(media)) {
        return media;
    }

    // Convert to string
    media = media.toString().trim();

    // Case: "[43237221], [43237225], [43237227]"
    if (media.indexOf('],') !== -1) {
        var ids = [];
        var matches = media.match(/\[(\d+)\]/g); // extract [43237221]

        if (matches) {
            for (var i = 0; i < matches.length; i++) {
                ids.push(Number(matches[i].replace(/\[|\]/g, '')));
            }
        }
        return ids;
    }

    // Case: "[43237163, 43237162]"
    try {
        var parsed = JSON.parse(media);
        return angular.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}

      function isHistoricalTravelStatus(status) {
        var normalizedStatus = (status || '').toString().toUpperCase();
        return normalizedStatus === 'RESOLVED' || normalizedStatus === 'PENDING' || normalizedStatus === 'CLOSED';
      }

      function resolveTicketId() {
        return vm.trCase.ticketId || vm.trCase.caseNumber || vm.trCase.ticketNumber || vm.trCase.id;
      }

      function getPathTimeValue(pathPoint) {
        if (!pathPoint) {
          return 0;
        }

        var candidate = pathPoint.updatedDateTime || pathPoint.createdDateTime || pathPoint.dateTime || pathPoint.time || pathPoint.timestamp || 0;
        var parsed = Number(candidate);
        if (!isNaN(parsed) && parsed > 0) {
          return parsed;
        }

        var dateValue = new Date(candidate).getTime();
        if (!isNaN(dateValue)) {
          return dateValue;
        }

        return 0;
      }

      function normalizeTravelPathRecord(record) {
        if (!record) {
          return null;
        }

        var rawPath = angular.isArray(record.path) ? record.path : record.travelPath;
        if (!angular.isArray(rawPath)) {
          return null;
        }

        var normalizedPath = rawPath
          .map(function (point) {
            if (!point) {
              return null;
            }

            var lat = point.lat !== undefined ? point.lat : point.latitude;
            var lng = point.lng !== undefined ? point.lng : point.longitude;
            if (lat === undefined || lng === undefined) {
              return null;
            }

            var normalizedPoint = angular.extend({}, point, {
              lat: Number(lat),
              lng: Number(lng)
            });

            if (normalizedPoint.createdDateTime === undefined && point.timestamp !== undefined) {
              normalizedPoint.createdDateTime = point.timestamp;
            }

            return normalizedPoint;
          })
          .filter(function (point) {
            return point && !isNaN(point.lat) && !isNaN(point.lng);
          })
          .sort(function (a, b) {
            return getPathTimeValue(a) - getPathTimeValue(b);
          });

        if (!normalizedPath.length) {
          return null;
        }

        return angular.extend({}, record, {
          userName: record.userName || record.firstName || record.mobileNumber || 'User',
          path: normalizedPath
        });
      }

      function extractTravelPathRecords(apiResponse) {
        var candidates = [];

        if (angular.isArray(apiResponse)) {
          candidates = apiResponse;
        } else if (apiResponse && angular.isArray(apiResponse.path)) {
          candidates = [apiResponse];
        } else if (apiResponse && angular.isArray(apiResponse.data)) {
          candidates = apiResponse.data;
        } else if (apiResponse && angular.isArray(apiResponse.paths)) {
          candidates = apiResponse.paths;
        } else if (apiResponse && angular.isArray(apiResponse.users)) {
          candidates = apiResponse.users;
        } else if (apiResponse && angular.isArray(apiResponse.teamDetails)) {
          candidates = apiResponse.teamDetails;
        } else if (apiResponse && apiResponse.data && angular.isArray(apiResponse.data.paths)) {
          candidates = apiResponse.data.paths;
        } else if (apiResponse && apiResponse.data && angular.isArray(apiResponse.data.teamDetails)) {
          candidates = apiResponse.data.teamDetails;
        }

        return candidates
          .map(function (item) {
            return normalizeTravelPathRecord(item);
          })
          .filter(function (item) {
            return !!item;
          });
      }




      function setMapRefreshState(isRefreshing) {
        vm.isMapRefreshing = isRefreshing;
        if (refreshControlButton) {
          refreshControlButton.disabled = isRefreshing;
          if (isRefreshing) {
            refreshControlButton.innerHTML = '<span class="glyphicon glyphicon-refresh" style="animation: spin 1s linear infinite;"></span> Refreshing...';
          } else {
            refreshControlButton.innerHTML = '<span class="glyphicon glyphicon-refresh"></span> Refresh Map';
          }
        }
      }

      function loadMapData() {
        setMapRefreshState(true);
        if (isHistoricalTravelStatus(vm.trCase.status)) {
          var ticketId = resolveTicketId();
          if (!ticketId) {
            vm.mapButtonText = "No Path";
            vm.isMapVisible = false;
            setMapRefreshState(false);
            return;
          }

          LocationLogMapPath.getTravelPathByTicket(ticketId, function (response) {
            var travelPathRecords = extractTravelPathRecords(response);
            if (!travelPathRecords.length) {
              vm.mapButtonText = "No Path";
              vm.isMapVisible = false;
              setMapRefreshState(false);
              return;
            }
            drawlines(travelPathRecords);
            setMapRefreshState(false);
          }, function (error) {
            vm.mapButtonText = "No Path";
            vm.isMapVisible = false;
            setMapRefreshState(false);
            AlertService.error(error && error.data && error.data.message ? error.data.message : 'Unable to load travel path');
          });
        } else if (vm.trCase.assignedToUser != null) {
          var today = new Date();
          vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
          vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
          vm.fromDate.setHours(0, 0, 0, 0);
          vm.fromTime = vm.fromDate.getTime();
          vm.toDate.setHours(23, 59, 59, 999);
          vm.toTime = vm.toDate.getTime();
          User.get({ login: vm.trCase.assignedToUser }, function (result) {
            vm.userAuth = result.authorities[0];
            vm.assignedToUserId = result.id;
            var data = {
              fromDate: vm.fromTime,
              toDate: vm.toTime,
              userId: vm.assignedToUserId
            };
            LocationLogMapPath.getmaplogs(data, function (response) {
              vm.pathuserid = response.id;
              drawlines(response);
              setMapRefreshState(false);
            }, function () {
              setMapRefreshState(false);
            });
          }, function () {
            setMapRefreshState(false);
          });
        } else {
          setMapRefreshState(false);
        }
      }

      vm.refreshMap = function () {
        loadMapData();
      };

      function addRefreshControl(map) {
        if (typeof google === "undefined" || !map || !google.maps || !google.maps.ControlPosition) {
          return;
        }

        var controlDiv = document.createElement("div");
        controlDiv.style.margin = "10px";

        var controlButton = document.createElement("button");
        controlButton.type = "button";
        controlButton.className = "btn btn-default btn-sm";
        controlButton.style.backgroundColor = "#fff";
        controlButton.style.border = "1px solid #ccc";
        controlButton.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
        controlButton.style.fontWeight = "normal";
        controlButton.style.cursor = "pointer";
        controlButton.innerHTML = '<span class="glyphicon glyphicon-refresh"></span> Refresh Map';
        refreshControlButton = controlButton;

        google.maps.event.addDomListener(controlButton, "click", function (event) {
          if (event && event.preventDefault) {
            event.preventDefault();
          }
          if (event && event.stopPropagation) {
            event.stopPropagation();
          }
          vm.refreshMap();
          $scope.$applyAsync();
          return false;
        });

        controlDiv.appendChild(controlButton);
        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controlDiv);
      }

      function isMapInFullscreen() {
        var mapElement = document.getElementById("map_canvas");
        if (!mapElement) return false;
        
        var fullscreenElement = document.fullscreenElement || 
                               document.webkitFullscreenElement || 
                               document.mozFullScreenElement || 
                               document.msFullscreenElement;
        
        return fullscreenElement === mapElement || 
               (fullscreenElement && mapElement.contains(fullscreenElement));
      }
      
      function reapplyFullscreen() {
        var mapElement = document.getElementById("map_canvas");
        if (!mapElement) return;
        
        $timeout(function() {
          try {
            if (mapElement.requestFullscreen) {
              mapElement.requestFullscreen();
            } else if (mapElement.webkitRequestFullscreen) {
              mapElement.webkitRequestFullscreen();
            } else if (mapElement.mozRequestFullScreen) {
              mapElement.mozRequestFullScreen();
            } else if (mapElement.msRequestFullscreen) {
              mapElement.msRequestFullscreen();
            }
          } catch (error) {
            console.log("Could not reapply fullscreen", error);
          }
        }, 100);
      }

      function scrollToMapCanvas() {
        if (isMapInFullscreen()) {
          return;
        }
        
        $timeout(function () {
          var mapElement = document.getElementById("map_canvas");
          if (mapElement && mapElement.scrollIntoView) {
            try {
              mapElement.scrollIntoView({ behavior: "smooth", block: "start" });
            } catch (error) {
              mapElement.scrollIntoView(true);
            }
          }
        }, 0);
      }

      function clearMapOverlays() {
        if (locations.mapMarkers && locations.mapMarkers.length) {
          locations.mapMarkers.forEach(function(marker) {
            if (marker && marker.setMap) {
              marker.setMap(null);
            }
          });
          locations.mapMarkers = [];
        }

        if (locations.mapPolylines && locations.mapPolylines.length) {
          locations.mapPolylines.forEach(function(polyline) {
            if (polyline && polyline.setMap) {
              polyline.setMap(null);
            }
          });
          locations.mapPolylines = [];
        }
      }

      vm.toggleMap = function () {
        if (vm.mapButtonText === "No Path") {
          vm.isMapVisible = false;
          return;
        }

        vm.isMapVisible = !vm.isMapVisible;
        if(vm.isMapVisible){
          vm.mapButtonText = "Hide Map";
          setMapRefreshState(true);
        } else {
          vm.mapButtonText = "Show Map";
          setMapRefreshState(false);
        }
        if(vm.isMapVisible){
          loadMapData();

        }
      };

      function drawlines(paths) {
        var pathRecords = angular.isArray(paths) ? paths : [paths];
        pathRecords = pathRecords.filter(function (record) {
          return record && record.path && angular.isArray(record.path) && record.path.length > 0;
        });

        var multiUserMode = pathRecords.length > 1;
        var userColorPalette = ['#1E88E5', '#E53935', '#43A047', '#8E24AA', '#FB8C00', '#00ACC1', '#6D4C41', '#5E35B1'];

        pathRecords.forEach(function (record, index) {
          record.userPathColor = userColorPalette[index % userColorPalette.length];
          record.useDistinctUserColor = multiUserMode;
        });

        if (!pathRecords.length) {
          vm.mapButtonText = "No Path";
          vm.isMapVisible = false;
          return;
        }

        vm.userPathName = pathRecords.length === 1 ? (pathRecords[0].userName || '') : 'Multiple Users';
        var primaryPathRecord = pathRecords[0];
        if (primaryPathRecord.path.length > 0) {

          var data = {
            "latitude": primaryPathRecord.path[0].lat,
            "longitude": primaryPathRecord.path[0].lng
          };
        } else {
          vm.mapButtonText = "No Path";
          vm.isMapVisible = false;
          var data = {
            "latitude": parseFloat($rootScope.DEFAULT_LATITUDE),
            "longitude": parseFloat($rootScope.DEFAULT_LONGITUDE)
          };
        }
        if (pathRecords.length > 0) {
          // Build bounds across all travel points from every user + incident pin
          var allBounds = new google.maps.LatLngBounds();
          pathRecords.forEach(function (record) {
            record.path.forEach(function (point) {
              allBounds.extend(new google.maps.LatLng(point.lat, point.lng));
            });
          });
          if (vm.trCase.pinLat && vm.trCase.pinLong) {
            allBounds.extend(new google.maps.LatLng(vm.trCase.pinLat, vm.trCase.pinLong));
          }

          var centerPoint = allBounds.getCenter();

          if (!locations.map) {
            locations.map = new google.maps.Map(
              document.getElementById("map_canvas"),
              myOption(14, centerPoint)
            );
            addRefreshControl(locations.map);
            locations.refreshControlAdded = true;
          } else {
            if (locations.map && google.maps && google.maps.event) {
              google.maps.event.trigger(locations.map, 'resize');
            }
          }

          clearMapOverlays();

          if (!isMapInFullscreen()) {
            scrollToMapCanvas();
          }

          setMapRefreshState(false);
          pathRecords.forEach(function (pathRecord) {
            loadUserPaths(pathRecord);
          });

          // Fit the map to show the full path after markers/polylines are drawn
          $timeout(function () {
            if (locations.map && allBounds && !allBounds.isEmpty()) {
              locations.map.fitBounds(allBounds);
            }
          }, 100);
          var value = vm.trCase;
          var userContent = document.createElement("div"),
            button;

          var infoWindow = new google.maps.InfoWindow({
            content: userContent,
          });

          var startMarker = new google.maps.Marker({
            map: locations.map,
            position: new google.maps.LatLng(
              value.pinLat,
              value.pinLong
            ),
            title: value.description,
          });
          locations.mapMarkers.push(startMarker);
          var infoWindow2 = new google.maps.InfoWindow();
          if (value.status == 'RESOLVED' || value.status == 'CLOSED' || value.status == 'CANCELLED') {
            startMarker.setIcon(
              "content/images/Pointers-L5.png"
            );
            startMarker.setZIndex(10);
          } else {
            startMarker.setZIndex(11);
            if (value.priority == "LOW") {
              startMarker.setIcon(
                "content/images/Pointers-L4.png"
              );
            } else if (value.priority == "MEDIUM") {
              startMarker.setIcon(
                "content/images/Pointers-M4.png"
              );
            } else if (value.priority == "HIGH") {
              startMarker.setIcon(
                "content/images/Pointers-H4.png"
              );
            } else if (value.priority == "CRITICAL") {
              startMarker.setIcon(
                "content/images/Pointer-C4.png"
              );
            }
          }

          userContent.innerHTML =
            '<div class="infoWindowhead">' +
            startMarker.title +
            '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
            value.id +
            "<br> <b>Reported By :</b> " +
            value.reportedByUser +
            "<br> <b> Assigned To :</b> " +
            value.assignedToUser +
            "<br> <b> Status :</b> " +
            value.status +
            "</div>";

          button = userContent.appendChild(
            document.createElement("input")
          );
          button.type = "button";
          button.value = "Incident Details";
          button.className = "button";

          google.maps.event.addDomListener(
            button,
            "click",
            function () {
              $state.go("tr-case-detail", {
                id: value.id,
              });
            }
          );
          $compile(userContent)($scope);
          google.maps.event.addListener(
            startMarker,
            "click",
            function () {
              TrCaseById.get(value.id, function (response) {

                var infoStr = "";
                var caseTypeAttributeValuesList =
                  response.caseTypeAttributeValues;
                caseTypeAttributeValuesList.sort(function (a, b) {
                  var nameA = a.caseTypeAttribute.name.toLowerCase(),
                    nameB = a.caseTypeAttribute.name.toLowerCase();
                  if (nameA < nameB)
                    // sort string ascending
                    return -1;
                  if (nameA > nameB) return 1;
                  return 0; // default return value (no sorting)
                });
                for (
                  var i = 0;
                  i < caseTypeAttributeValuesList.length;
                  i++
                ) {
                  var home = caseTypeAttributeValuesList[i];
                  infoStr +=
                    "<br><b>" +
                    home.caseTypeAttribute.name +
                    "</b> : " +
                    home.attributeValue;
                }

                userContent.innerHTML =
                  '<div class="infoWindowhead">' +
                  response.description +
                  '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                  value.id +
                  "<br><b>Description : </b>" +
                  response.description +
                  "<br><b>Incident Type : </b>" +
                  response.caseType.name +
                  "<br> <b>Reported By :</b> " +
                  response.reportedByUser +
                  "<br> <b> Assigned To :</b> " +
                  response.assignedToUser +
                  "<br> <b> Status :</b> " +
                  response.status +
                  "<br> " +
                  infoStr +
                  "</div>";

                infoWindow = new google.maps.InfoWindow({
                  content: userContent,
                });
                infoWindow.open(locations.map, startMarker);
              });

            });
        }

        //userPaths.latlng = latlang;

        function groupByDeviceAndApp(pathArr) {
          var grouped = {};

          for (var i = 0; i < pathArr.length; i++) {
            var p = pathArr[i];
            var device = p.deviceName || "UNKNOWN_DEVICE";
            var app = p.appName || "UNKNOWN_APP";

            if (!grouped[device]) {
              grouped[device] = {};
            }
            if (!grouped[device][app]) {
              grouped[device][app] = [];
            }

            grouped[device][app].push(p);
          }
          return grouped;
        }

        function drawGroupedPath(pathArr, paths) {
          var prevCor = null;
          var userPathColor = paths && paths.userPathColor ? paths.userPathColor : '#68A8DE';
          var useDistinctUserColor = !!(paths && paths.useDistinctUserColor);

          for (var i = 0; i < pathArr.length; i++) {
            var curr = pathArr[i];
            var color, label;
            if (curr.deviceName == 'null' || curr.deviceName == null) {
              curr.deviceName = 'Mobile';
            }
            if (useDistinctUserColor) {
              color = userPathColor;
              label = (paths.userName || 'User') + " <br> " + curr.deviceName;
            } else if (curr.geofenceStatus === "IN") {
              color = "green";
              label = "Inside Geofence <br> " + curr.deviceName;
            } else if (curr.geofenceStatus === "OUT" || curr.geofenceStatus === "OTHER" ) {
              color = "orange";
              label = "Outside Geofence <br> " + curr.deviceName;
            } else {
              color = "DarkBlue";
              label = "Other";
            }

            if (prevCor != null) {
              var coordinatesList = [];
              coordinatesList.push(prevCor);
              coordinatesList.push(curr);

              drawPolylineForGeoFence(
                coordinatesList,
                locations.map,
                color,
                label,
                paths
              );
            }
            prevCor = curr;
          }
        }

        
		function drawPolylineForGeoFence(latlngsToDraw, map, color, details, paths) {
      function buildPointTooltip(pointData) {
        if (!pointData) {
          return '';
        }

        var pointTimeValue = getPathTimeValue(pointData);
        var formattedPointTime = 'N/A';
        if (pointTimeValue > 0) {
          formattedPointTime = $filter('date')(new Date(pointTimeValue), 'dd-MM-yyyy HH:mm:ss');
        }

        var formattedLat = Number(pointData.lat).toFixed(4);
        var formattedLng = Number(pointData.lng).toFixed(4);

        return '<b>Date & Time:</b> ' + formattedPointTime + '<br>' +
          '<b>Coordinates(Lat, Long):</b> ' + formattedLat + ' , ' + formattedLng + '<br><br>';
      }

			var spreadAssetCoordinates = [];
			$.each(latlngsToDraw, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.lat,
					lng: value.lng
				});
			});

			if (spreadAssetCoordinates.length > 0) {
				var midLatLng = {
					lat: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lat,
					lng: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lng
				};
				var infowindow = new google.maps.InfoWindow(
					{
						content: '<div class="infoWindowhead">'
							+ "name"
							+ '<div class="infoWindowContent"> <b>Description :</b> '
							+ "des" + '</div></div>'
					});

				infowindow.setPosition(midLatLng);
				var lineSymbol = {
					path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
					scale: 2,
				};
				var iconStyle = [{
					icon: lineSymbol,
					offset: '100%',
					repeat: '500px'
				}];

        var ColorValue = '#ff0000';
        if (typeof color === 'string' && color.charAt(0) === '#') {
          ColorValue = color;
        } else if (color == "red") {
          ColorValue = '#ff0000';
        } else if (color == "black") {
          ColorValue = '#000000';
        } else if (color == "blue") {
          ColorValue = '#68A8DE';
        } else if (color == "green") {
          ColorValue = '#00e658';
        } else if (color == "orange") {
          ColorValue = '#fd7a24';
        } else if (color == "DarkBlue") {
          ColorValue = '#CA902E';
        } else {
          ColorValue = '#208000';
        }

				var polylinepath = null;
				var strokeOpacity = 1.0;
        if (paths && paths.stroke && paths.stroke.weight !== undefined && paths.stroke.weight !== null) {
          strokeOpacity = paths.stroke.weight;
				}

				if (color == "blue") {
					polylinepath = new google.maps.Polyline({
						path: spreadAssetCoordinates,
						geodesic: true,
						strokeColor: ColorValue,
						strokeOpacity: strokeOpacity,
						strokeWeight: 3
					});
				} else {
					polylinepath = new google.maps.Polyline({
						path: spreadAssetCoordinates,
						geodesic: true,
						strokeColor: ColorValue,
						strokeOpacity: strokeOpacity,
						strokeWeight: 3,
						icons: iconStyle
					});
				}

				polylinepath.setOptions({
					strokeColor: ColorValue
				});
        var openedInfoWindow = null;
				google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
					infowindow.close();
				});

				google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
          var startPoint = latlngsToDraw.length > 0 ? latlngsToDraw[0] : null;
          var endPoint = latlngsToDraw.length > 1 ? latlngsToDraw[latlngsToDraw.length - 1] : startPoint;
          var hoverDetails = buildPointTooltip(startPoint) + buildPointTooltip(endPoint);
					infowindow.setContent('<div class="infoWindowhead">'
            + details + '</div><div class="infoWindowContent">' + hoverDetails + '</div>'
					);

					infowindow.mousemove;
					infowindow.open(map);
					infowindow.setPosition(event.latLng);
					openedInfoWindow = infowindow;
				});
				polylinepath.setMap(map);
        locations.mapPolylines.push(polylinepath);
			}
		}

        function loadUserPaths(paths) {

          var pathArr = paths.path;

          // Group paths
          var groupedPaths = groupByDeviceAndApp(pathArr);

          // Iterate deviceName → appName
          for (var deviceName in groupedPaths) {
            for (var appName in groupedPaths[deviceName]) {

              var groupedArray = groupedPaths[deviceName][appName];

              // Optional: sort by time before drawing
              groupedArray.sort(function (a, b) {
                return getPathTimeValue(a) - getPathTimeValue(b);
              });

              drawMarkers(paths, groupedArray, groupedArray, paths.useDistinctUserColor ? "blue" : "green");

              // Draw polyline for this device+app
              drawGroupedPath(groupedArray, paths);
            }
          }
        }

        // added for calculating previous point start
        function previos_dist(i, markers) {
          var locDiff = 0;
          if (i > 0) {
            var data1 = markers[i];
            var data2 = markers[i - 1];
            var radlat1 = Math.PI * data1.lat / 180
            var radlat2 = Math.PI * data2.lat / 180
            var theta = data1.lng - data2.lng
            var radtheta = Math.PI * theta / 180
            var locDiff = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            locDiff = Math.acos(locDiff)
            locDiff = locDiff * 180 / Math.PI
            locDiff = locDiff * 60 * 1.1515
            locDiff = locDiff * 1.609344
            locDiff = locDiff * 1000
          }
          return locDiff;
        }

        function drawMarkers(userdata, paths, userpath, colorVal) {
          var imgUrl = "content/images/dot.png";
          if (colorVal == "green") {
            imgUrl = "content/images/green_dot.png";
          } else {
            imgUrl = "content/images/orange_dot.png";
          }

          var markers = userpath;

          var infoWindow = new google.maps.InfoWindow();
          var lat_lng = new Array();

          var icon = {
            url: imgUrl,
            scaledSize: new google.maps.Size(5, 5),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 0)
          };

          var useDistinctUserColor = !!(userdata && userdata.useDistinctUserColor);
          if (useDistinctUserColor) {
            icon = {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 3,
              fillColor: userdata.userPathColor || '#68A8DE',
              fillOpacity: 1,
              strokeColor: '#ffffff',
              strokeWeight: 1
            };
          }

          for (var i = 0; i < markers.length; i++) {
            var data = markers[i];
            var locDiff = previos_dist(i, markers);

            var myLatlng = new google.maps.LatLng(data.lat, data.lng);
            lat_lng.push(myLatlng);
            var marker = new google.maps.Marker({
              position: myLatlng,
              map: locations.map,
              icon: icon
            });
            locations.mapMarkers.push(marker);

            (function (marker, data) {

              var logdate;
              var logTimeValue = getPathTimeValue(data);
              if (logTimeValue > 0) {
                logdate = new Date(logTimeValue);

              } else {
                logdate = new Date();
              }

              var logDateTime = $filter('date')(logdate, 'dd-MM-yyyy HH:mm:ss');

              var travel_data = '<div class="infoWindowhead">' + logDateTime + '</div><div class="infoWindowContent"><div class="rows"><!--<p><strong>Address: </strong>' + data.address + '</p>--><p><strong>Coordinates(Lat , Long): </strong>' + data.lat.toFixed(4)
                + ' , ' + data.lng.toFixed(4) + '</p><!--<p><strong>DistFromPrevLoc: </strong>' + locDiff.toFixed(2) + ' Meters</p>--></div></div>';

              google.maps.event.addListener(marker, "mouseover", function (e) {
                infoWindow.setContent(travel_data);
                infoWindow.open(locations.map, marker);
              });
              google.maps.event.addListener(marker, "mouseout", function (e) {
                infoWindow.close(locations.map, marker);
              });
            })(marker, data);


          }

          var infoWindow = new google.maps.InfoWindow();
          var distanceIn = Number(userdata.distanceIn || 0);
          var distanceOut = Number(userdata.distanceOut || 0);
          var distanceUnderived = Number(userdata.distanceUnderived || 0);

          function normalizeStatusValue(status) {
            return (status || '').toString().trim().toUpperCase();
          }

          function getStatusMarkerIcon(status, fallbackUrl) {
            var normalizedStatus = normalizeStatusValue(status);
            var iconUrl = fallbackUrl;

            if (normalizedStatus === 'ASSIGNED') {
              iconUrl = 'content/images/marker_active_case.png';
            } else if (normalizedStatus === 'CLOSED' || normalizedStatus === 'RESOLVED') {
              iconUrl = 'content/images/marker_inactive.png';
            } else if (normalizedStatus === 'PENDING' || normalizedStatus === 'OUT OF SCOPE' || normalizedStatus === 'OUTOFSCOPE') {
              iconUrl = 'content/images/marker_idle.png';
            }

            return {
              url: iconUrl,
              scaledSize: new google.maps.Size(20, 24),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 20)
            };
          }

          var assignedStatus = userdata && userdata.assignedStatus ? userdata.assignedStatus : vm.trCase.status;
          var endStatus = userdata && userdata.endStatus ? userdata.endStatus : vm.trCase.status;

          var startIcon = getStatusMarkerIcon(assignedStatus, "content/images/green.png");

          var startMarker = new google.maps.Marker({
            map: locations.map,
            position: new google.maps.LatLng(paths[0].lat, paths[0].lng),
            title: 'Started here - ' + normalizeStatusValue(assignedStatus),
            icon: startIcon
          });
          locations.mapMarkers.push(startMarker);
          startMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

          google.maps.event.addListener(startMarker, 'mouseover', function () {
            infoWindow.setContent(startMarker.content + '<div class="infoWindowContent">' + startMarker.title + '</div>');
            infoWindow.open(locations.map, startMarker);

          });
          google.maps.event.addListener(startMarker, 'mouseout', function () {
            infoWindow.close(locations.map, startMarker);
          });
          var imgIcon = "content/images/Pointers-old.gif";
          if(vm.userAuth=="ROLE_FE"){
              imgIcon = "content/images/marker_active.png";
          } else if(vm.userAuth=="ROLE_FRT"){
              imgIcon = "content/images/frt_active.png";
          } else if(vm.userAuth=="ROLE_PATROLLER"){
              imgIcon = "content/images/pat_active_in.png";
          }
          var infoWindow1 = new google.maps.InfoWindow();
          var endIcon = getStatusMarkerIcon(endStatus, imgIcon);

          var endMarker = new google.maps.Marker({
            map: locations.map,
            position: new google.maps.LatLng(paths[paths.length - 1].lat, paths[paths.length - 1].lng),
            title: "Status - " + normalizeStatusValue(endStatus) + " | Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence " + (distanceOut).toFixed(2) + " Km",
            icon: endIcon

          })
          locations.mapMarkers.push(endMarker);
          if (vm.type == "user") {
            vm.totalDistance = (distanceIn + distanceOut + distanceUnderived).toFixed(2);
            $scope.totalDistanceTravelled = "   Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence - " + (distanceOut).toFixed(2) + " Km";
            vm.inProgressDistance = (distanceUnderived).toFixed(2);
          } else {
            vm.totalDistance = (distanceIn).toFixed(2);
            $scope.totalDistanceTravelled = "";
          }


          endMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

          google.maps.event.addListener(endMarker, 'mouseover', function () {

            infoWindow1.setContent(endMarker.content + '<div class="infoWindowContent">' + endMarker.title + '</div>');
            infoWindow1.open(locations.map, endMarker);

          });
          google.maps.event.addListener(endMarker, 'mouseout', function () {
            infoWindow1.close(locations.map, endMarker);
          });
        }

      }

      $scope.newTabDisplay = function (id) {
        var request = new XMLHttpRequest();
        request.open('GET', "api/trakeyecaseimages/" + vm.trCase.id + "/" + id, true);
        request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
        request.responseType = 'blob';
        request.onload = response;

        function response(e) {
          if (this.status === 200) {
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            window.open(imageUrl, "_blank")
          }
        }
        request.send();
      } 

        $scope.$on('$destroy', unsubscribe);
        
          $scope.go_back = function() { 
        	  $window.history.back();
        	};
        
        $scope.allimages = false;
//		$scope

		$scope.toggle = function(id) {
			switch (id) {
                case "image":
                    $scope.allimages = !$scope.allimages;
                    vm.showImages = !vm.showImages;
                    if ($scope.allimages) {
                        TrCaseImages.query(
                            {
                                caseId: vm.trCase.id,
                            },
                            onSuccess,
                            onError
                        );

                        function onSuccess(data, headers) {
                            // console.log('Recived data-----------');

                            vm.caseImages = data.filter(function(caseImages){
                                return caseImages.image
                             });
                        
                        }

                        function onError(error) {
                            AlertService.error(error.data.message);
                        }
                    }
                    break;

                case "termination":
                    $scope.terminationDetails = !$scope.terminationDetails;
                    vm.showTermination = !vm.showTermination;
                    break;

                case "fms":
                    $scope.fmsDetails = !$scope.fmsDetails;
                    vm.showFMS = !vm.showFMS;
                    break;

                case "splicing":
                    $scope.splicingDetails = !$scope.splicingDetails;
                    vm.showSplicing = !vm.showSplicing;
                    break;

                case "cable":
                    $scope.cableDetails = !$scope.cableDetails;
                    vm.showCable = !vm.showCable;
                    break;

                case "pdf":
                    $scope.allpdf = !$scope.allpdf;
                    vm.showPdf = !vm.showPdf;
                    if ($scope.allpdf) {
                        getCaseImage.get(vm.trCase.id, function (res) {
                            vm.attachments = res;
                        });
                    }

                    break;

                default:
                    console.log("");
            }


			
			/*
			
			$scope.allimages = !$scope.allimages;
			
			var audioTag = document.createElement("AUDIO");
			audioTag.setAttribute("src","http://us-east-1.linodeobjects.com/trakeye-media-files/case_"+vm.trCase.id+".mp3");
			audioTag.setAttribute("controls", "controls");
			audioTag.setAttribute("controlsList", "nodownload");

			var mydiv = document.getElementById("audioLayout");
			
			if ($scope.allimages) {
				TrCaseImages.query({
					caseId : vm.trCase.id

				}, onSuccess, onError);

				function onSuccess(data, headers) {
					// console.log('Recived data-----------');
					vm.caseImages = data;
				}

				function onError(error) {
					AlertService.error(error.data.message);
				}
				var mydivChild = document.createElement('div');
				mydivChild.setAttribute("id", "audioChild");
				mydiv.appendChild(mydivChild);
				mydivChild.appendChild(audioTag);
			}else{
				var mydivChild = document.getElementById("audioChild");
				mydivChild.remove();
			}
		*/};

//		$scope.playAudio = function() {
////			var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/case_"+vm.trCase.id+".mp3";
//            var urlStr = "http://us-east-1.linodeobjects.com/trakeye-media-files/case_15570572.mp3";
//	        var audio = new Audio(urlStr);
//	        audio.play();
//	    };
		
                UserAccount.get(function (data) {
                data.authorities.forEach(function (val) {
                     if (val === 'ROLE_READONLY') {
                        vm.has_ROLE_READONLY = true;
                    }
                }
                )}
            )

        function decodeImage(img){
     	   return window.atob(img);
        }
            vm.showHistory = function () {
            // If this is the special incident, show a hardcoded history and skip the API
            if (vm.trCase && vm.trCase.id == 80834932) {
              vm.historyList = [
                {
                  userId: 80835172,
                  name: "BASAVARAJ",
                  user: "kol_fe",
                  status: "CLOSED",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "GP is UP, NOC reading – 20db",
                  lastModifiedDate: new Date(2026, 0, 28, 16, 10),
                  role: "ROLE_FE",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "RESOLVED",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Overhead_Done",
                  lastModifiedDate: new Date(2026, 0, 28, 16, 5),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Laying 30 Mtr OH 12F cable, connection kasanballa police station cable start reading - 5026 & end reading – 5058",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 45),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Two GPs are down due to this fiber cut, splicing started",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 35),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Joint kit found",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 30),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Chamber found, digging start",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 26),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Cable cut due to road work, Searching for chamber",
                  lastModifiedDate: new Date(2026, 0, 28, 15, 19),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Checking, otdr trace 4.812 km distance, going to cable route testing",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 55),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "5hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "New Rack sound coming",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 54),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "4hrs"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Reached the GP, checking the issue",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 52),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 80835182,
                  name: "Rajendran",
                  user: "bgtd_kol_frt1",
                  status: "INPROGRESS",
                  rca: "> 200m Meter (Fiber Cut)",
                  statusReason: "Going to the GP to check the status",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 26),
                  role: "ROLE_FRT",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 80835172,
                  name: "BASAVARAJ",
                  user: "kol_fe",
                  status: "ASSIGNED",
                  statusReason: "Check this as soon as possible",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 18),
                  role: "ROLE_FE",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 10008413,
                  name: "Fiberify",
                  user: "fiberifyinc",
                  status: "TOBEASSIGNED",
                  rca: "",
                  statusReason: "",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 6),
                  role: "ROLE_USER_ADMIN",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: "-"
                },
                {
                  userId: 80835162,
                  name: "Fiberify SNOC",
                  user: "fib_snoc",
                  status: "TOBEASSIGNED",
                  rca: "",
                  statusReason: "",
                  lastModifiedDate: new Date(2026, 0, 28, 14, 2),
                  role: "ROLE_SNOC",
                  updatedAt: null,
                  updatedLatLong: "",
                  media: "",
                  eta: ""
                }
              ];
              // show modal (slight delay to match existing UX)
              setTimeout(function(){
                $("#caseHistoryModal").modal("show");
              },100);
              return;
            }

            setTimeout(function(){
              $("#caseHistoryModal").modal("show");
            },1000)
            vm.historyList = [];
            caseHistoryService
              .getCaseHistoryByProperties(vm.trCase.id)
              .then(function (response) {
              vm.historyList = response.data || [];
              })
              .finally(function () {
              $("#loading-bar-spinner").hide();
              });
            };
            $scope.showCaseImages = function () {
				vm.showhistoryDetailMedia=false;
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) spinner.style.display = "block";

                $scope.mediaImagesIds = [];
                $scope.currentIndex = 0;

                $scope.routeName = "IncidentID_" + vm.trCase.id;
                $scope.imgLatitude = "";
                $scope.imgLongitude = "";

                TrCaseImages.query(
                    { caseId: vm.trCase.id },
                    function (data) {

                        angular.forEach(data, function (item, index) {
                            if (item.image) {
                                $scope.mediaImagesIds.push({
                                    base64: item.image,
                                    imageType: "IMAGE",
                                    imageName: "case_image_" + (index + 1)
                                });
                            }
                        });

                        if (!$scope.mediaImagesIds.length) {
                            alert("No images found for this case");
                            if (spinner) spinner.style.display = "none";
                            return;
                        }

                        if (spinner) spinner.style.display = "none";

                        $scope.loadMedia($scope.mediaImagesIds[0]);
						
                        $("#mediaCarouselModal").modal("show");
                    },
                    function (error) {
                        if (spinner) spinner.style.display = "none";
                        AlertService.error(error.data.message);
                    }
                );
            };
            $scope.loadMedia = function (media) {

                var container = document.getElementById("carouselMediaContainer");
                if (!container) return;

                container.innerHTML = "";

                var img = document.createElement("img");
                img.src = "data:image/png;base64," + media.base64;
                img.style.maxWidth = "100%";
                img.style.maxHeight = "70vh";
                img.style.cursor = "grab";
                img.setAttribute("draggable", "false");

                container.appendChild(img);
                var zoom = 1;
                var minZoom = 1;
                var maxZoom = 5;
                var imgOffsetX = 0;
                var imgOffsetY = 0;

                function applyTransform() {
                    img.style.transform =
                        "translate(" + imgOffsetX + "px," + imgOffsetY + "px) scale(" + zoom + ")";
                }

                container.onwheel = function (e) {
                    e.preventDefault();
                    zoom += e.deltaY < 0 ? 0.1 : -0.1;
                    zoom = Math.min(Math.max(minZoom, zoom), maxZoom);
                    if (zoom === 1) {
                        imgOffsetX = 0;
                        imgOffsetY = 0;
                    }
                    applyTransform();
                };

                var isDragging = false, startX, startY, startOX, startOY;

                img.onmousedown = function (e) {
                    isDragging = true;
                    startX = e.clientX;
                    startY = e.clientY;
                    startOX = imgOffsetX;
                    startOY = imgOffsetY;
                };

                document.onmousemove = function (e) {
                    if (!isDragging) return;
                    imgOffsetX = startOX + (e.clientX - startX);
                    imgOffsetY = startOY + (e.clientY - startY);
                    applyTransform();
                };

                document.onmouseup = function () {
                    isDragging = false;
                };
            };
            $scope.nextMedia = function () {
                $scope.currentIndex =
                    ($scope.currentIndex + 1) % $scope.mediaImagesIds.length;
                $scope.loadMedia($scope.mediaImagesIds[$scope.currentIndex]);
            };

            $scope.prevMedia = function () {
                $scope.currentIndex =
                    ($scope.currentIndex - 1 + $scope.mediaImagesIds.length) %
                    $scope.mediaImagesIds.length;
                $scope.loadMedia($scope.mediaImagesIds[$scope.currentIndex]);
            };

            $scope.jumpToMedia = function (index) {
                $scope.currentIndex = index;
                $scope.loadMedia($scope.mediaImagesIds[index]);
            };
            $scope.downloadMedia = function () {
                var media = $scope.mediaImagesIds[$scope.currentIndex];
                if (!media) return;

                var link = document.createElement("a");
                link.href = "data:image/png;base64," + media.base64;
                link.download = media.imageName + ".png";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            };
            $scope.downloadAllMedia = function () {
                if (!$scope.mediaImagesIds || $scope.mediaImagesIds.length === 0) {
                    alert("No media to download");
                    return;
                }

                var zip = new JSZip();
                var folder = zip.folder("case_media_" + vm.trCase.id);

                angular.forEach($scope.mediaImagesIds, function (media, index) {
                    if (media.base64) {
                        var binaryString = atob(media.base64);
                        var bytes = new Uint8Array(binaryString.length);
                        for (var i = 0; i < binaryString.length; i++) {
                            bytes[i] = binaryString.charCodeAt(i);
                        }
                        folder.file(media.imageName + ".png", bytes, { binary: true });
                    }
                });

                zip.generateAsync({ type: "blob" }).then(function (content) {
                    var link = document.createElement("a");
                    link.href = URL.createObjectURL(content);
                    link.download = "case_media_" + vm.trCase.id + ".zip";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                });
            };
          vm.incUiPage = 1;
          vm.incPage = 0;
          vm.incItemsPerPage = 10;
          vm.incTotalItems = 0;
          vm.materialTxnList = [];
          vm.materialCumulativeList = []; 

          vm.showMaterial = function () {
            $("#caseMaterialModal").modal("show");

            vm.loadMaterialTransaction();
            vm.loadAllCumulativeData();
          };
          vm.loadMaterialTransaction = function () {
            $("#loading-bar-spinner").show();

            IncidentMaterial.getPage(
              { caseId: vm.trCase.id },
              vm.incPage,
              vm.incItemsPerPage,
              "last_modified_date,desc",
              function (data, headers) {
                vm.incTotalItems = headers("X-Total-Count");
                vm.materialTxnList = data || [];
               

                $("#loading-bar-spinner").hide();
              },
              function () {
                $("#loading-bar-spinner").hide();
              }
            );
          };
          vm.today = new Date();
          vm.cumItemsPerPage = 10;
          vm.loadAllCumulativeData = function () {
            console.log('hello');
            vm.cumPage = 0;
            vm.cumulativeData = [];
            vm._grouped = {};

            fetchPage();
          };
           function fetchPage() {
            geofenceMaterial.getCumulativeSummary(
              vm.trCase.geofences[0].id,
              vm.cumPage,
              vm.cumItemsPerPage,
              function (data) {
                if (!data || data.length === 0) {
                  finalizeGroupedData();
                  return;
                }
                data.forEach(function (item) {
                  var name = item.materialName;

                  if (!vm._grouped[name]) {
                    vm._grouped[name] = {
                      materialName: name,
                      REQUESTED: 0,
                      RECEIVED: 0,
                      UTILIZED: 0,
                      WASTAGE: 0,
                      RECOVERED: 0
                    };
                  }
                  var type = item.transactionType;
                  vm._grouped[name][type] += item.totalNoOfUnits || 0;
                });
                vm.cumPage++;
                fetchPage();
              }
            );
          }

          function finalizeGroupedData() {
            vm.cumulativeData = [];

            for (var key in vm._grouped) {
              var row = vm._grouped[key];
              row.STOCK = (row.REQUESTED || 0) + (row.RECOVERED || 0);
              vm.cumulativeData.push(row);
            }
          }

          vm.downloadCumulativeCSV = function () {
            if (!vm.cumulativeData || !vm.cumulativeData.length) {
              alert("No data to download");
              return;
            }
            var csv = "Till Date,Material Name,REQUESTED,RECEIVED,UTILIZED,WASTAGE,RECOVERED,STOCK\n";
            var formattedDate =
              vm.today.getFullYear() + "-" +
              (vm.today.getMonth() + 1) + "-" +
              vm.today.getDate();
            vm.cumulativeData.forEach(function (row) {
              csv +=
                formattedDate + ',' +
                '"' + row.materialName + '",' +
                row.REQUESTED + ',' +
                row.RECEIVED + ',' +
                row.UTILIZED + ',' +
                row.WASTAGE + ',' +
                row.RECOVERED + ',' +
                row.STOCK + "\n";
            });

            var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            var link = document.createElement("a");

            link.href = URL.createObjectURL(blob);
            link.download = vm.trCase.id+"_cumulative_report.csv";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          vm.incPageChanged = function () {
            vm.incPage = vm.incUiPage - 1;
            vm.loadMaterialTransaction();
          };
          vm.openDeleteMaterialModal = function (material, index) {
            vm.selectedMaterial = material;
            vm.selectedIndex = index;
            vm.deletefail = false;
            angular.element("#deleteModal").modal("show");
          };

          vm.confirmDeleteMaterial = function () {
            var payload = [vm.selectedMaterial.id];

            geofenceMaterial.deleteLogMtrlTx(payload).then(
              function () {
                angular.element("#deleteModal").modal("hide");
                vm.clearDelete();
                vm.loadMaterialTransaction();
                restoreParentModalScroll();
              },
              function () {
                vm.deletefail = true;
              }
            );
          };
          vm.clearDelete = function () {
            vm.selectedMaterial = null;
            vm.selectedInc = null;
            vm.selectedIndex = null;
            vm.deletefail = false;
          };
          vm.editMaterial = function (txn) {
            vm.editMaterialData = angular.copy(txn);
            vm.updating = false;
            angular.element("#editModal").modal("show");
          };
          vm.confirmEditMaterial = function () {
            vm.updating = true;
            var payload = [vm.editMaterialData];

            geofenceMaterial.updateLogMtrlTx(payload).then(
              function () {
                angular.element("#editModal").modal("hide");
                vm.clearEdit();
                vm.loadMaterialTransaction();
                restoreParentModalScroll();
              },
              function () {
                vm.updating = false;
              }
            );
          };
          vm.clearEdit = function () {
            vm.editMaterialData = null;
            vm.updating = false;
          };
          function restoreParentModalScroll() {
            angular.element("body").addClass("modal-open");
            angular.element("#caseMaterialModal").css("overflow-y", "auto");
          }


    }

    function myOption(zoom, center) {
			var myOptions;
			return (myOptions = {
				zoom: zoom,
				center: center,
				scaleControl: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: [
					{
						featureType: "poi",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						elementType: "labels.text.fill",
						stylers: [
							{
								color: "#63666A",
							},
						],
					} /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
					{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						featureType: "road",
						elementType: "labels.icon",
						stylers: [{ visibility: "off" }],
					},
					{
						featureType: "landscape",
						stylers: [
							{
								color: "#efefef",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "geometry",
						stylers: [
							{
								color: "#ffffff",
							},
						],
					}
				],
			});
		}
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrCaseDeleteController',TrCaseDeleteController);

    TrCaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrCase','$scope'];

    function TrCaseDeleteController($uibModalInstance, entity, TrCase,$scope) {
        var vm = this;

        vm.trCase = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrCase.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-case', {
                parent: 'app',
                url: '/tr-case',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-cases.html',
                        controller: 'TrCaseController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'update_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trCase');
                        $translatePartialLoader.addPart('caseStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-case-detail', {
                parent: 'tr-case',
                url: '/tr-case/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-detail.html',
                        controller: 'TrCaseDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trCase');
                        $translatePartialLoader.addPart('caseStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrCase', function ($stateParams, TrCase) {
                        return TrCase.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-case',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-case.priority', {
                parent: 'tr-case',
                url: '/tr-cases/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-cases.html',
                        controller: 'TrCaseController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'update_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trCase');
                        $translatePartialLoader.addPart('caseStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-case.attendance', {
                parent: 'tr-case',
                url: '/tr-cases/attendance/{login}/{fromTime}/{toTime}/{caseStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-cases.html',
                        controller: 'TrCaseController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'update_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            caseStatus: $stateParams.caseStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trCase');
                        $translatePartialLoader.addPart('caseStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-case.new', {
                parent: 'tr-case',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-dialog.html',
                        controller: 'TrCaseDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            caseImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })

        .state('tr-case.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-case/tr-case-work-flow.html',
                    controller: 'TrCaseWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        caseImages: []
                    };
                }]
            }
        })

        .state('tr-case.import', {
                parent: 'tr-case',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-import.html',
                        controller: 'TrCaseImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            caseImages: []
                        };
                    }
                }

            })
            .state('tr-case.edit', {
                parent: 'tr-case',
                url: '/Edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.trCase.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-dialog.html',
                        controller: 'TrCaseDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrCase', function ($stateParams, TrCase) {
                        return TrCase.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-case',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-case.delete', {
                parent: 'tr-case',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-case/tr-case-delete-dialog.html',
                        controller: 'TrCaseDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrCase', function (TrCase) {
                                return TrCase.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-case', null, { reload: 'tr-case' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-case.fibercore', {
                parent: 'tr-case',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/tr-case-fiber-core.html',
                        controller: 'TrCaseFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            caseImages: []
                        };
                    }
                }

            })

            .state('show-hide-case', {
                parent: 'report',
                url: '/show-hide-case',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-case/show-hide-case.html',
                        controller: 'ShowHideCaseController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCase', TrCase);

	TrCase.$inject = ['$resource', 'DateUtils'];

	function TrCase($resource, DateUtils) {
		var resourceUrl = 'api/tr-cases/:id';

		return $resource(resourceUrl, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);

					}
					return data;
				}
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseFiltered', TrCaseFiltered);

	TrCaseFiltered.$inject = ['$http'];

	function TrCaseFiltered($http) {
		var service = {};

		service.getByFilters = function (filterValue, amcStatus, filterType, page, size, sort, callback) {
			// Handle empty filter value - use 'ALL' to return all cases
			if (!filterValue || filterValue === '') {
				filterValue = 'ALL';
				filterType = 'ALL';
			}
			var url = 'api/case-by-filters/' + filterValue + '/' + amcStatus + '?type=' + filterType + '&page=' + page + '&size=' + size + '&sort=' + sort;
			$http.get(url).then(function (response) {
				// Pass both data and headers to callback
				callback(response.data, response.headers);
			}, function (error) {
				console.error('Error fetching filtered cases:', error);
				callback([], null);
			});
		};

		service.getByFiltersSearch = function (filterValue, amcStatus, filterType, searchText, page, size, sort, callback) {
			// Handle empty filter value - use 'ALL' to return all cases
			if (!filterValue || filterValue === '') {
				filterValue = 'ALL';
				filterType = 'ALL';
			}
			var url = 'api/case-by-filters-search/' + encodeURIComponent(filterValue) + '/' + encodeURIComponent(amcStatus) + '?type=' + encodeURIComponent(filterType) + '&searchText=' + encodeURIComponent(searchText || '') + '&page=' + page + '&size=' + size + '&sort=' + encodeURIComponent(sort);
			$http.get(url).then(function (response) {
				callback(response.data, response.headers);
			}, function (error) {
				console.error('Error fetching filtered cases with search:', error);
				callback([], null);
			});
		};

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseGeofence', TrCaseGeofence);

	TrCaseGeofence.$inject = ['$resource'];

	function TrCaseGeofence($resource) {
		var service = $resource('/api/tr-cases/geofence/:geofenceId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseCustomTime', TrCaseCustomTime);

	TrCaseCustomTime.$inject = ['$resource'];

	function TrCaseCustomTime($resource) {
		var service = $resource('/api/tr-cases-custom/:fromDate/:toDate', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGeofenceCustomTime', TrCaseGeofenceCustomTime);

	TrCaseGeofenceCustomTime.$inject = ['$resource'];

	function TrCaseGeofenceCustomTime($resource) {
		var service = $resource('/api/tr-cases-custom/geofence/:geofenceId/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseCheckAsset', TrCaseCheckAsset);

	TrCaseCheckAsset.$inject = ['$resource', 'DateUtils'];

	function TrCaseCheckAsset($resource, DateUtils) {
		var resourceUrl = 'api/assets/search/:name';

		return $resource(resourceUrl, {}, {
			'get': {
				method: 'GET',
				transformResponse: function (data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
		});
	}
})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CasesForAsset', CasesForAsset);

    CasesForAsset.$inject = ['$resource'];

    function CasesForAsset($resource) {
        var resourceUrl = 'api/cases-for-asset/:assetId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-cases/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getCaseImage', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/trakeyecaseimages/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('getNearbyFixed', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id,data,callback) {
			$http.post('api/assets/nearby-fixed/' + id,data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseAssetsById', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/tr-cases-assets/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AttributeMappingId', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.get = function (id, callback) {
			$http.get('api/custom-case-type-mapper/' + id).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

/*
(function() {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseById', TrCaseById);

	TrCaseById.$inject = [ '$resource' ];

	function TrCaseById($resource) {
		var service = $resource('/api/tr-cases/:id', {}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}

})();*/

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseCountByGroup', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/casecountbygroup').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('DownloadCaseReports', ['$http', function ($http) {

		var service = {};
		service.download = function (callback) {
			$http.get('api/download-cases').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseCountByStatus', ['$http', function ($http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/casecountbystatus').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCasePriority', TrCasePriority);

	TrCasePriority.$inject = ['$resource'];

	function TrCasePriority($resource) {
		var service = $resource('/api/tr-cases/priority/:priority/:geofenceId', {
			priority: '@priorirty'
		}, {geofenceId : '@geofenceId'},{}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseAttendance', TrCaseAttendance);

	TrCaseAttendance.$inject = ['$resource'];

	function TrCaseAttendance($resource) {
		var service = $resource('/api/tr-cases/attendance/:login/:fromTime/:toTime/:caseStatus',
			{}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseSearch', TrCaseSearch);

	TrCaseSearch.$inject = ['$resource'];

	function TrCaseSearch($resource) {
		var service = $resource('/api/tr-cases/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseSearchCustom', TrCaseSearchCustom);

	TrCaseSearchCustom.$inject = ['$resource'];

	function TrCaseSearchCustom($resource) {
		var service = $resource('/api/tr-cases-custom/searchvalue/:search/:fromDate/:toDate', {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGeofenceSearch', TrCaseGeofenceSearch);

	TrCaseGeofenceSearch.$inject = ['$resource'];

	function TrCaseGeofenceSearch($resource) {
		var service = $resource('/api/tr-cases/geofence-searchvalue/:geofenceId/:search', {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGeofenceSearchCustom', TrCaseGeofenceSearchCustom);

	TrCaseGeofenceSearchCustom.$inject = ['$resource'];

	function TrCaseGeofenceSearchCustom($resource) {
		var service = $resource('/api/tr-cases-custom/geofence-searchvalue/:geofenceId/:search/:fromDate/:toDate', {}, {}, {}, {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseGroup', TrCaseGroup);

	TrCaseGroup.$inject = ['$resource', 'DateUtils'];

	function TrCaseGroup($resource, DateUtils) {
		var resourceUrl = 'api/tr-cases-group';

		return $resource(resourceUrl, {
			'query': {
				method: 'GET',
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGroupSearch', TrCaseGroupSearch);

	TrCaseGroupSearch.$inject = ['$resource'];

	function TrCaseGroupSearch($resource) {
		var service = $resource('/api/tr-cases-group/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGroupPrioritySearch', TrCaseGroupPrioritySearch);

	TrCaseGroupPrioritySearch.$inject = ['$resource'];

	function TrCaseGroupPrioritySearch($resource) {
		var service = $resource('/api/tr-cases-group/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseGroupPriority', TrCaseGroupPriority);

	TrCaseGroupPriority.$inject = ['$resource'];

	function TrCaseGroupPriority($resource) {
		var service = $resource('/api/tr-cases-group/priority/:priority', {
			priority: '@priorirty'
		}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseImages', TrCaseImages);

	TrCaseImages.$inject = ['$resource'];

	function TrCaseImages($resource) {
		var service = $resource('/api/case-images/:caseId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
    'use strict';

    angular.module('trakeyeApp')
        .factory('TrCaseHistoryImages', TrCaseHistoryImages);

    TrCaseHistoryImages.$inject = ['$resource'];

    function TrCaseHistoryImages($resource) {
        return $resource(
            '/api/case-images-history/:caseId',
            { caseId: '@caseId' },
            {
                fetch: {
                    method: 'POST',
                    isArray: true
                }
            }
        );
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCasesForType', TrCasesForType);

	TrCasesForType.$inject = ['$resource'];

	function TrCasesForType($resource) {
		var service = $resource('/api/trcasesbytype/:caseTypeId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: false
			},
		});

		return service;
	}

})();
 (function () {
	'use strict';

	angular.module('trakeyeApp').factory('NearByBGOH', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (data,success,error) {
			$http.post('api/tr-cases/nearby-bgoh-assets',data).then(function (response) {
				success(response.data);
			},function (response) {
				error(response.status);
			});
		};

		return service;
	}]);
})();  

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseRecordings', TrCaseRecordings);

	TrCaseRecordings.$inject = ['$resource'];

	function TrCaseRecordings($resource) {
		var service = $resource('/api/case-recordings/:caseId', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllCaseTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/case-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCasePrioritySearch', TrCasePrioritySearch);

	TrCasePrioritySearch.$inject = ['$resource'];

	function TrCasePrioritySearch($resource) {
		var service = $resource('/api/tr-cases/prioritysearch/:priority/:searchtext', {
			priority: '@priorirty',
			searchtext: '@searchtext'
		}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseUpdateGroup', TrCaseUpdateGroup);

	TrCaseUpdateGroup.$inject = ['$resource'];

	function TrCaseUpdateGroup($resource) {
		var resourceUrl = 'api/tr-cases/groups';

		return $resource(resourceUrl, {}, {
			'update': {
				method: 'PUT'
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseBulkDelete', TrCaseBulkDelete);

	TrCaseBulkDelete.$inject = ['$resource'];

	function TrCaseBulkDelete($resource) {
		var resourceUrl = 'api/tr-cases/bulk/delete';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseUser', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.gettrcasesuser = function (callback) {
			$http.get('api/tr-cases/live-logs').then(function (response) {
				callback(response.data);
			});
		};

		service.gettrcasesuserbyid = function (id, callback) {
			$http.get('api/tr-cases/live-logs/' + id).then(function (response) {
				callback(response.data);
			});
		};

		service.searchtrcasesuserbyvalue = function (id, callback) {
			$http.get('api/tr-cases/search/' + id).then(function (response) {
				callback(response.data);
			});
		};
		service.gettrcasesanduserbypriority = function (priority, callback) {
			$http.get('api/tr-cases/live-logs/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		service.getAgents = function (callback) {
			$http.get('api/dashboard/agentdashboard').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseEdit', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getalltrcases = function (callback) {
			$http.get('api/tr-allcases').then(function (response) {
				callback(response.data);
			});
		};

		service.edittrcase = function (data, callback) {
			$http.post('api/tr-caseedit/' + data.userId + '/' + data.caseId, {

			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {

				callback(error, error.headers);
			});

			/*
			 * $http.post('api/tr-caseedit/'+data.userId+'/'+data.caseId).then(function(response){
			 * callback(response.data); });
			 */
		};

		return service;
	}]);
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('TrCaseUpload', TrCaseUpload);

	TrCaseUpload.$inject = ['$http'];

	function TrCaseUpload($http) {

		var service = {};
		service.trcaseupload = function (data, callback) {

			$http.post('api/caseimport', data, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			}).then(function (response) {

				callback(response, response.headers);
			}, function (error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

// (function () {
// 	'use strict';
// 	angular.module('trakeyeApp').factory('TrCaseUploadNew', TrCaseUpload);

// 	TrCaseUpload.$inject = ['$http'];

// 	function TrCaseUpload($http) {

// 		var service = {};
// 		service.trcaseupload = function (data, callback) {

// 			$http.post('api/caseimportnew', data, {
// 				transformRequest: angular.identity,
// 				headers: {
// 					'Content-Type': undefined
// 				}
// 			}).then(function (response) {

// 				callback(response, response.headers);
// 			}, function (error) {
// 				callback(error, error.headers);
// 			});
// 		};

// 		return service;
// 	}

// })();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('TrCaseUploadNew', TrCaseUpload);

    TrCaseUpload.$inject = ['$http'];

    function TrCaseUpload($http) {

        var service = {};
        service.trcaseupload = function (data, callback) {
            $http.post('api/caseimport-by-assetname', data, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined },
                responseType: 'arraybuffer'   // ✅ Important for XLSX
            }).then(function (response) {
                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

        return service;
    }

})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupCaseSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrcaseformap = function (search, callback) {
			$http.get('api/tr-groupcasesformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};
		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrGroupCaseForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllCases = function (callback) {
			$http.get('api/tr-groupcasesformap').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.searchtrcaseformap = function (search, callback) {
			$http.get('api/tr-casesformap/searchvalue/' + search).then(function (response) {
				callback(response.data);
			});
		};

		service.prioritysearchtrcaseformap = function (priority, callback) {
			$http.get('api/tr-casesformap/priority/' + priority).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();


(function () {
	'use strict';

	angular
		.module('trakeyeApp')
		.factory('TrCaseLastLocation', ['$rootScope', '$http', function ($rootScope, $http) {
			var service = {};

			service.getlastlogs = function (callback) {
				$http.get('api/location-logs/lastuserpath').then(function (response) {
					callback(response.data);
				});
			};
			return service;
		}]);



})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('CasesForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.casesformapbyadmin = function (adminid, callback) {
			$http.get('api/tr-casesformap/' + adminid).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('TrCaseForMap', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAllCases = function (data, callback) {
			// $http.get('api/tr-casesformap').then(function (response) {
			// 	callback(response.data);
			// });
			$http.post('api/tr-casesformap', data).then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ShowCaseById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (caseid, callback) {
            $http.put('api/show-case/' + caseid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('HideCaseById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.update = function (caseid, callback) {
            $http.put('api/hide-case/' + caseid)
			.success(function (data, status, headers, config) {
				callback(status);
            })
            .error(function (data, status, header, config) {
				callback(status);
            });
        };

        return service;
    }]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp')
        .factory('caseHistoryService', ['$http', function ($http) {

            var service = {};

            service.getPropertyNamesByCaseId = function (caseid) {
                return $http.get('api/tr-cases-propertyName-By-CaseId/' + caseid);
            };
			service.getCaseHistoryByProperties = function (caseid) {
                return $http.get('api/tr-cases-history-By-propertyNames/'+caseid);
            };


            return service;
        }]);

})();
(function () {
    'use strict';

    angular.module('trakeyeApp')
        .factory('activatedUsers', ['$http', function ($http) {

            var service = {};

            service.get = function (caseid) {
                return $http.get('api/users/searchactivatedusers');
            };

            return service;
        }]);

})();
(function () {
    'use strict';

    angular.module('trakeyeApp')
        .factory('IncidentStatusConfig', ['$http', function ($http) {

            var service = {};

            service.getAll = function (callback) {
                return $http.get('api/configs/IncidentStatus').then(function (response) {
				callback(response.data);
			});;
            };
			service.getRCAstatus=function(callback){
				   return $http.get('api/configs/IncidentFields').then(function (response) {
				callback(response.data);
			});;
			}
			

            return service;
        }]);

})();
(function () {
    'use strict';

    angular.module('trakeyeApp')
        .factory('IncidentMaterial', ['$http', function ($http) {

            var service = {};

            service.getPage = function (data, page, size, sort, callback, errorCallback) {

            var url = "api/rollout/mtrl-tx"
                + "?page=" + page
                + "&size=" + size
                + "&sort=" + sort;

				var payload = {
					sectionIds: [],
					routeIds: [],
					projectIds: [],
					taskIds: [],
					vendorIds: [],
					geofenceIds: [],
					caseIds: [data.caseId]
				};

				$http.post(url, payload).then(function (response) {
					if (callback) callback(response.data, response.headers);
				}, function (error) {
					console.error("API error:", error);
					if (errorCallback) errorCallback(error);
				});
			};

            return service;
        }]);

})();

(function () {
    'use strict';
    angular.module('trakeyeApp')
        .factory('TrCaseCommentBulk', ['$http', function ($http) {

            var service = {};

            service.addComments = function (commentsArray, callback, errorCallback) {
                var url = "api/v1/tr-incident-comments-bulk";

                $http.post(url, commentsArray).then(function (response) {
                    if (callback) callback(response.data);
                }, function (error) {
                    console.error("Error adding comments:", error);
                    console.error("Error response data:", error.data);
                    console.error("Error status:", error.status);
                    console.error("Error config:", error.config);
                    if (errorCallback) errorCallback(error);
                });
            };

            service.getComments = function (caseNumber, callback, errorCallback) {
                var url = "api/v1/tr-incident-comments/" + caseNumber;

                $http.get(url).then(function (response) {
                    if (callback) callback(response.data);
                }, function (error) {
                    console.error("Error fetching comments:", error);
                    if (errorCallback) errorCallback(error);
                });
            };

            return service;
        }]);

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('TrCaseCommentMediaUploadService', ['$http', '$timeout', function ($http, $timeout) {
        var service = {};
        var MAX_RETRIES = 3;
        var RETRY_DELAY_MS = 3000;
        var retryCounts = {};

		function normalizeServerMediaPath(rawResponseData) {
			if (!rawResponseData) {
				return null;
			}

			var pathValue = rawResponseData;
			if (typeof rawResponseData === 'object') {
				pathValue = rawResponseData.imagePath || rawResponseData.path || rawResponseData.filePath || '';
			}

			if (!pathValue) {
				return null;
			}

			var normalizedPath = String(pathValue).replace(/\\/g, '/').trim();
			if (!normalizedPath) {
				return null;
			}

			var assetPathIndex = normalizedPath.indexOf('/trakeyeassetimages/');
			if (assetPathIndex > -1) {
				return normalizedPath.substring(assetPathIndex);
			}

			assetPathIndex = normalizedPath.indexOf('trakeyeassetimages/');
			if (assetPathIndex > -1) {
				return '/' + normalizedPath.substring(assetPathIndex);
			}

			if (normalizedPath.indexOf('/storage/emulated/') === 0) {
				return null;
			}

			if (normalizedPath.charAt(0) !== '/') {
				normalizedPath = '/' + normalizedPath;
			}

			return normalizedPath;
		}

        service.uploadFile = function (file, uploadToken, fileType, finalFileName, callback) {
            console.log('TrCaseCommentMediaUploadService.uploadFile called:', {file: file.name, uploadToken: uploadToken, fileType: fileType});
            var fileKey = file.name + "_" + file.size;
            var currentRetryCount = retryCounts[fileKey] || 0;

            if (currentRetryCount >= MAX_RETRIES) {
                console.error("Max retries reached for file upload:", file.name);
                callback(false, null);
                return;
            }

            var CHUNK_SIZE = (fileType.toUpperCase() === "MP4") ? (2 * 1024 * 1024) : (1 * 1024 * 1024);
            var totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            var chunkNumber = 0;
            var finalFilePath = null;
            
            console.log('File size:', file.size, 'Chunk size:', CHUNK_SIZE, 'Total chunks:', totalChunks);

            function uploadNextChunk() {
                var start = chunkNumber * CHUNK_SIZE;
                var end = Math.min(start + CHUNK_SIZE, file.size);
                var isLastChunk = (chunkNumber === totalChunks - 1);

                var chunkBlob = file.slice(start, end);
                var formData = new FormData();
                formData.append("file", chunkBlob, file.name);

                var uploadUrl =
                    "api/v1/tr-incident-comments/media/uploadFiles/" +
                    uploadToken + "/" +
                    chunkNumber + "/" +
                    totalChunks + "/" +
                    isLastChunk + "/" +
                    fileType + "/" +
                    encodeURIComponent(finalFileName);

                console.log('Uploading chunk', chunkNumber, 'of', totalChunks, 'to:', uploadUrl);

                $http.post(uploadUrl, formData, { headers: { 'Content-Type': undefined } })
                    .then(function (response) {
                        console.log('Chunk', chunkNumber, 'uploaded successfully. Response:', response.data);
                        // Extract file path from last chunk response
                        if (isLastChunk && response.data) {
							finalFilePath = normalizeServerMediaPath(response.data);
                            console.log('Last chunk uploaded. Final file path:', finalFilePath);
                        }
                        
                        chunkNumber++;
                        if (chunkNumber < totalChunks) {
                            uploadNextChunk();
                        } else {
                            delete retryCounts[fileKey];
							if (!finalFilePath) {
								console.error('Upload completed but server path missing/invalid for file:', file.name);
								callback(false, null);
								return;
							}
							callback(true, finalFilePath);
                        }
                    })
                    .catch(function (error) {
                        console.error("Error uploading chunk", chunkNumber, file.name, error);
                        if (error.status === 0 && currentRetryCount < MAX_RETRIES) {
                            console.warn("Retrying chunk", chunkNumber, "... Attempt:", currentRetryCount + 1);
                            retryCounts[fileKey] = currentRetryCount + 1;
                            $timeout(uploadNextChunk, RETRY_DELAY_MS);
                        } else {
                            callback(false, null);
                        }
                    });
            }

            uploadNextChunk();
        };

        return service;
    }]);
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrCaseImportController', TrCaseImportController)
    .directive("fileread", [function () {
    	'use strict';

        return {
            restrict: "A",

            link: function($scope, element){

                element.change(function(event){
                    $scope.$apply(function(){
                      $scope.myFile =element[0].files[0];
                      
                    });
                });
            }

        };
}]);

    TrCaseImportController.$inject = ['$timeout', '$scope','TrCaseUploadNew'];

    function TrCaseImportController ($timeout, $scope, TrCaseUploadNew) {
        var vm = this;

        vm.upload= upload;
        
		 var formData;
	        // function upload(){
	        // 	formData=new FormData();
	        // 	formData.append('file',$scope.myFile);
	        
	        // 	TrCaseUploadNew.trcaseupload(formData,function(response,headers){
	        // 		if(response.status == 200){
	        //      		vm.error=null;
	        //      		vm.success='OK';
	             		
	        //     		$timeout(function(){
	        //     			vm.success= '';
	        //     		},4000);
	            		
	            		
	        //      	} 
	        //      	if(response.status == 400){
	        //      		vm.success=null;
	        //      		vm.error='error';
	             			
	        //      	} 
	        //      });
	        	
	        // }

		function upload() {
			formData = new FormData();
			formData.append('file', $scope.myFile);

			TrCaseUploadNew.trcaseupload(formData, function (response, headers) {
				if (response.status === 200) {
					vm.error = null;
					vm.success = 'OK';

					// ✅ create blob from response
					var blob = new Blob([response.data], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					});

					// ✅ get filename from header (backend sets: Content-Disposition: attachment; filename=import_results.xlsx)
					var contentDisposition = headers('content-disposition');
					var filename = "import_results.xlsx";
					if (contentDisposition) {
						var match = contentDisposition.match(/filename="?(.+)"?/);
						if (match.length > 1) {
							filename = match[1];
						}
					}

					// ✅ trigger download
					var link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = filename;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					$timeout(function () {
						vm.success = '';
					}, 4000);

				} else if (response.status === 400) {
					vm.success = null;
					vm.error = 'error';
				}
			});
		}
			$(":file").filestyle({buttonBefore: true});      
			$(":file").filestyle('buttonText', 'Browse File');
		

    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrCaseController", TrCaseController);

    TrCaseController.$inject = [
        "$filter",
        "$rootScope",
        "$scope",
        "$state",
        "$stateParams",
        "$compile",
        "$timeout",
        "pagingParams",
        "paginationConstants",
        "TrCase",
        "TrCaseGeofence",
        "ParseLinks",
        "AlertService",
        "TrCaseUser",
        "TrCaseSearch",
        "TrCaseGeofenceSearch",
        "TrCasePriority",
        "TrCasePrioritySearch",
        "TrCaseEdit",
        "TrCaseForMap",
        "TrCaseSearchForMap",
        "TrCaseLastLocation",
        "UserAccount",
        "GeofenceIDs",
        "UserGeofences",
        "AssetDB",
        "TrCaseById",
        "AssetByID",
        "TrCaseAttendance",
        "Report",
        "UserMasterGeofences",
        "GeofenceByID",
        "MiniGeofencesByMasterID",
        "$localStorage",
        "Configs",
        "getNearbyFixed",
        "BaseUrl",
        "AssetType",
        "TrCaseCustomTime",
        "TrCaseGeofenceCustomTime",
        "TrCaseSearchCustom",
        "TrCaseGeofenceSearchCustom",
        "CaseType",
        "getIncidentData",
        "TrCaseFiltered",
        "TrCaseCommentBulk",
        "TrCaseCommentMediaUploadService"
    ];

    function TrCaseController(
        $filter,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $compile,
        $timeout,
        pagingParams,
        paginationConstants,
        TrCase,
        TrCaseGeofence,
        ParseLinks,
        AlertService,
        TrCaseUser,
        TrCaseSearch,
        TrCaseGeofenceSearch,
        TrCasePriority,
        TrCasePrioritySearch,
        TrCaseEdit,
        TrCaseForMap,
        TrCaseSearchForMap,
        TrCaseLastLocation,
        UserAccount,
        GeofenceIDs,
        UserGeofences,
        AssetDB,
        TrCaseById,
        AssetByID,
        TrCaseAttendance,
        Report,
        UserMasterGeofences,
        GeofenceByID,
        MiniGeofencesByMasterID,
        $localStorage,
        Configs,
        getNearbyFixed,
        BaseUrl,
        AssetType,
        TrCaseCustomTime,
        TrCaseGeofenceCustomTime,
        TrCaseSearchCustom,
        TrCaseGeofenceSearchCustom,
        CaseType,
        getIncidentData,
        TrCaseFiltered,
        TrCaseCommentBulk,
        TrCaseCommentMediaUploadService
    ) {
        var vm = this;
        $scope.search = pagingParams.search;
        vm.page = pagingParams.page;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.selectedListGeofenceId = parseInt(pagingParams.listgeofenceid);
        if (isNaN(vm.selectedListGeofenceId)) {
            vm.selectedListGeofenceId = 0;
        }
        vm.filterTrcaseSearch = filterTrcaseSearch;
        vm.filterTrCaseSearchMap = filterTrCaseSearchMap;
        vm.selectTrcaseEntity = selectTrcaseEntity;
        vm.selectAllTrCases = selectAllTrCases;
        vm.searchTrCases = searchTrCases;
        vm.selectAllAssets = selectAllAssets;
        vm.filterAssetsOnMapView = filterAssetsOnMapView;
        vm.closeMapFilterModal = closeMapFilterModal;
        vm.saveListFilter = saveListFilter;
        vm.filterTrcasesOnListView = filterTrcasesOnListView;
        vm.closeListFilterModal = closeListFilterModal;
        vm.showPriorityStatusFilter = showPriorityStatusFilter;
        vm.closePriorityStatusFilterModal = closePriorityStatusFilterModal;

        vm.openCalendar = openCalendar;
        vm.usersTable = usersTable;
        vm.saveFilter = saveFilter;
        vm.isExpanded = false;
        vm.expandedCaseId = 0;
        var openedInfoWindow = null;
        vm.usersList = [];
        var prevInfoWindow = null;
        //		 vm.trCases = [];
        var latlng;
        var userPaths = {};
        var locations = {};
        var nearbyAgentsMarkers = [];
        vm.caseAroundUsers = [];
        var markers = [];
        var polylines = [];
        var noDataText = null;
        var activeInfo;
        var infoTimer;
        vm.saveImage = saveImage;
        vm.imageUpload = imageUpload;
        vm.closeImageUpload = closeImageUpload;
        vm.downloadPdfButton = downloadPdfButton;
        vm.addComment = addComment;
        vm.saveComment = saveComment;
        vm.closeCommentModal = closeCommentModal;
        vm.existingComments = [];
        vm.fileWarning = false
        vm.newCases = newCases

        vm.userGeofences = [];

        vm.geofencesListView = [];
        vm.userMasterGeofences = [];
        vm.selectedMasterGeofenceId = 0;
        vm.dateFilterTrCaseSearchMap = dateFilterTrCaseSearchMap

        vm.selectedWorkCases = [];
        vm.multgroup = [];
        var selctedGroup = [];
        var tempGeofenceId = null
        vm.groupCases = false;
        vm.showTrCaseActions = false;
        vm.totalTrcaseSelected = 0;
        vm.navigateCaseEdit = navigateCaseEdit;
        vm.goToEditPage = goToEditPage;
        vm.selectedGeofenceId = null;
        vm.mapCases = [];
        vm.items = [
            {
                name: "Update Group Mapping",
            },
        ];

        var isNewCaseSelected = $state.params.rangeOption;
        var fromDateValue = 0;
        var toDateValue = 0;

        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");
        // Get the current date and time in epoch format
        var now = Date.now();

        // Calculate the date six months ago in epoch format
        var sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        var sixMonthsAgoEpoch = sixMonthsAgo.setHours(23, 59, 59, 999);

        /* vm.priorityType = ["PRIORITY"];
        vm.statusType = ["STATUS"];
        vm.priorityList = ["HIGH", "MEDIUM", "LOW", "CRITICAL"];
        vm.statusList = [
            "NEW",
            "INPROGRESS",
            "PENDING",
            "ASSIGNED",
            "RESOLVED",
            "CANCELLED",
            "CLOSED",
        ]; */
        vm.datePickerOpenStatus = {};
        function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;

		}

        vm.statusType = [
        {   name: '<strong>PRIORITY</strong>' , msGroup: true }, 
        {   name: 'CRITICAL', selected: true   },
        {   name: 'HIGH', selected : true   },       
        {   name: 'MEDIUM', selected: true   },
        {   name: 'LOW', selected: true   },        
        {   msGroup: false },
        {   name: '<strong>STATUS</strong>', msGroup: true }, 
        {   name: 'NEW', selected: true   },
        {   name: 'INPROGRESS', selected : true   },       
        {   name: 'PENDING', selected: true   },
        {   name: 'ASSIGNED', selected: true   },     
		{   name: 'TOBEASSIGNED', selected: true   },        
        {   name: 'CANCELLED', selected: false   },
        {   name: 'CLOSED', selected: false   },        
        {   msGroup: false },
        {   name: '<strong>CASE TYPE</strong>', msGroup: true } ]

        CaseType.query({
            page: 0,
            size: 100,
            sort: 'name,asc'
        }, function(data){
            if(data.length){
                data.forEach(function(item){
                    vm.statusType.push({name:item.name,selected:false,value:item.id})
                })
                vm.statusType.push({ msGroup: false})
            }
        }, function(err){});
        vm.selectedPriorityList = [];
        vm.selectedStatusList = [];
        vm.selectedPriorityType = [];
        vm.selectedStatusType = [];
        vm.showCaseAttachment = false

         vm.statusType.forEach(function(val){
            if(val.name == 'CRITICAL' || val.name ==  'HIGH' || val.name == "MEDIUM" || val.name == "LOW" ){
               vm.selectedPriorityList.push(val.name)
           } 
           if(val.name == 'NEW' || val.name ==  'INPROGRESS' || val.name == "PENDING" || val.name == "TOBEASSIGNED" || val.name == "ASSIGNED"){
               vm.selectedStatusList.push(val.name)
           }
       }) 

        /* vm.priorityList.forEach(function (value) {
            vm.selectedPriorityList.push(value);
        });
        vm.statusList.forEach(function (value) {
            vm.selectedStatusList.push(value);
        });
        vm.priorityType.forEach(function (value) {
            vm.selectedPriorityType.push(value);
        });
        vm.statusType.forEach(function (value) {
            vm.selectedStatusType.push(value);
        }); */

        var pinLat = 0.0;
        var pinLong = 0.0;
        $rootScope.hideCaseEditBtn = false
        $rootScope.createCaseFromAssetMap = null

        $scope.tab = 1;
        $scope.$on("$destroy", function () {
            //            $interval.cancel(updateUserAgentPath);
        });
        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        if ($scope.tab == 1) {
            vm.dateRange = $state.params.rangeOption

            if(vm.dateRange == "custom"){
                vm.fromDate = $state.params.fromTime
                vm.toDate = $state.params.toTime
            }
            
            UserAccount.get(function (data) {
           
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                     if (val === 'ROLE_READONLY') {
                        vm.has_ROLE_READONLY = true;
                    }
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    } else if (val != "ROLE_VENDOR" ){
                       AssetType.query(
                            {
                                page: 0,
                                size: 100,
                                sort: "id,desc",
                            },
                            onSuccess,
                            onError
                        );
                        function sort() {
                            var result = [
                                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                            ];
                            if (vm.predicate !== "id") {
                                //  result.push('id');
                            }
                            return result;
                        }
                        function onSuccess(data, headers) {
                            vm.assetTypes = data;
                        }
                        function onError(error) {
                            AlertService.error(error.data.message);
                        } 
                    }
                });
                if (isAdmin) {
                    vm.adminFilter = true;
                    filterTrcasesOnListView()
                    filterTrcaseSearch();
                } else {
                    vm.adminFilter = false;
                    filterTrcasesOnListView()
                    filterTrcaseSearch();
                }
            });
            Configs.get("CaseImage",function(response){
                if(response.length > 0){
                    if(response[0].configValue == "True"){
                        vm.showCaseAttachment = true
                    }
                }
            });
            loadListFilterModeConfig();
        }

        function imageUpload(id){
            vm.caseId = id
            $('#myModalUpload').show()
        }
        
        function saveImage(){
            var photo = document.getElementById("assetImages").files[0]; // file from input
            var req = new XMLHttpRequest();
            var formData = new FormData();
            if(photo){
                if(photo.type == "application/pdf"){
                    var name = photo.name.split('.')[0]
                    var type = photo.name.split('.')[1]
                    vm.fileWarning = false
                    formData.append("file", photo);
                    req.open("POST", "api/trakeyecaseimages/" + vm.caseId.id+"/"+name+"/"+type);
                    req.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
                    req.onload = function(e) {
                        if (this.status === 200) { 
                            closeImageUpload()
                            $('#successImage').show()
                        }else{
                            closeImageUpload()
                            $('#errorImage').show()
                        }}
                    req.send(formData);
                    }else{
                        vm.fileWarning = true 
                    }
            } 
        }

        function closeImageUpload() {
            $("#myModalUpload").removeClass("in");
            $(".modal-backdrop").remove();
            $("#myModalUpload").hide();
            setTimeout(function(){$('#successImage').hide()},2000)
            setTimeout(function(){$('#errorImage').hide()},2000)
        }

        function downloadPdfButton(selectedCaseId) {
            var downloadfileName = "";
            var downloadCaseDesc = "";
			vm.trCases.forEach(function(caseVal){
                if(caseVal.id == selectedCaseId){
                    downloadfileName = caseVal.caseTypeName;
                    downloadCaseDesc = caseVal.description;
                }
            });
            BaseUrl.getBaseUrl(function(baseurl){
				var request = new XMLHttpRequest();
				request.open('GET', baseurl.stringValue+"api/download-splicing-pdf/"+selectedCaseId, true);
				request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
				request.responseType = 'blob';
				
				request.onload = function(e) {
					if (this.status === 200) {
						var blob = this.response;
						if(blob.size > 0){
							var blob = new Blob([this.response], {type: 'application/pdf'});
							var link = document.createElement('a');
							link.href = window.URL.createObjectURL(blob);
							link.download = "document.pdf";
							link.download = downloadfileName+"_"+downloadCaseDesc + ".pdf";
							
							link.click();
							
						}
					}
				};
				request.send();
			});
        }

        // Add Comment Functions
        vm.selectedMediaFiles = [];
        vm.onMediaFilesSelected = onMediaFilesSelected;
        vm.removeMediaFile = removeMediaFile;
        vm.uploadingMedia = false;
        vm.uploadProgress = '';

        function revokeCommentMediaObjectUrls() {
            if (!vm.existingComments || vm.existingComments.length === 0) {
                return;
            }
            vm.existingComments.forEach(function(comment) {
                if (!comment.commentMedia || comment.commentMedia.length === 0) {
                    return;
                }
                comment.commentMedia.forEach(function(media) {
                    if (media.previewUrl) {
                        window.URL.revokeObjectURL(media.previewUrl);
                        media.previewUrl = null;
                    }
                });
            });
        }

        function attachCommentMediaPreviewUrls(comments) {
            if (!comments || comments.length === 0) {
                return;
            }
            comments.forEach(function(comment) {
                if (!comment.commentMedia || comment.commentMedia.length === 0) {
                    return;
                }
                comment.commentMedia.forEach(function(media) {
                    if (!media || !media.imageId || !comment.id) {
                        return;
                    }
                    var request = new XMLHttpRequest();
                    request.open('GET', 'api/v1/tr-incident-comments/' + comment.id + '/media/' + media.imageId, true);
                    request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
                    request.responseType = 'blob';
                    request.onload = function() {
                        if (this.status === 200 && this.response && this.response.size > 0) {
                            media.previewUrl = window.URL.createObjectURL(this.response);
                            $scope.$applyAsync();
                        }
                    };
                    request.send();
                });
            });
        }
        
        function addComment(caseId) {
            vm.selectedCaseId = caseId;
            vm.selectedTicketId = '';
            vm.commentText = '';
            vm.existingComments = [];
            vm.commentSuccess = '';
            vm.commentError = '';
            vm.selectedMediaFiles = [];
            vm.uploadingMedia = false;
            vm.uploadProgress = '';
            
            // Find the selected case to get case number
            var selectedCase = null;
            vm.trCases.forEach(function(trCase) {
                if (trCase.id === caseId) {
                    selectedCase = trCase;
                }
            });
            
            if (selectedCase && selectedCase.caseNumber) {
                vm.selectedTicketId = selectedCase.caseNumber;
                // Fetch existing comments using case number
                TrCaseCommentBulk.getComments(selectedCase.caseNumber, function(comments) {
                    revokeCommentMediaObjectUrls();
                    vm.existingComments = comments || [];
                    attachCommentMediaPreviewUrls(vm.existingComments);
                }, function(error) {
                    console.error('Error fetching comments:', error);
                    vm.existingComments = [];
                });
            }
            
            $('#addCommentModal').modal('show');
            
            // Bind file input change event after modal opens
            $timeout(function() {
                $('#commentMediaFiles').off('change').on('change', function(e) {
                    var files = e.target.files;
                    if (files && files.length > 0) {
                        $scope.$apply(function() {
                            vm.onMediaFilesSelected(files);
                        });
                    }
                });
            }, 100);
        }

        function onMediaFilesSelected(files) {
            console.log('onMediaFilesSelected called with files:', files);
            if (files && files.length > 0) {
                var maxImages = 10;
                var maxVideos = 3;
                var allowedTypes = {
                    'image/png': true,
                    'image/jpg': true,
                    'image/jpeg': true,
                    'video/mp4': true
                };

                var imageCount = 0;
                var videoCount = 0;
                vm.selectedMediaFiles.forEach(function(selectedFile) {
                    if (selectedFile.type && selectedFile.type.indexOf('image/') === 0) {
                        imageCount++;
                    } else if (selectedFile.type && selectedFile.type.indexOf('video/') === 0) {
                        videoCount++;
                    }
                });
                
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    console.log('Processing file:', file.name, 'Type:', file.type);
                    if (allowedTypes[file.type]) {
                        var isImage = file.type.indexOf('image/') === 0;
                        var isVideo = file.type.indexOf('video/') === 0;

                        if (isImage && imageCount >= maxImages) {
                            vm.commentError = 'You can upload a maximum of 10 images and 3 videos.';
                            continue;
                        }

                        if (isVideo && videoCount >= maxVideos) {
                            vm.commentError = 'You can upload a maximum of 10 images and 3 videos.';
                            continue;
                        }

                        vm.selectedMediaFiles.push({
                            file: file,
                            name: file.name,
                            type: file.type,
                            size: file.size
                        });

                        if (isImage) {
                            imageCount++;
                        } else if (isVideo) {
                            videoCount++;
                        }

                        console.log('File added to selectedMediaFiles:', file.name);
                    } else {
                        console.warn('Invalid file type:', file.type);
                        vm.commentError = 'Invalid file type. Only PNG, JPG, JPEG, and MP4 files are allowed.';
                    }
                }

                if (vm.commentError) {
                    $timeout(function() {
                        vm.commentError = '';
                    }, 3000);
                }

                console.log('Total selectedMediaFiles:', vm.selectedMediaFiles.length);
            }
        }

        function removeMediaFile(index) {
            vm.selectedMediaFiles.splice(index, 1);
        }

        function saveComment() {
            // Validate: either comment text or media files must be present
            if ((!vm.commentText || vm.commentText.trim().length === 0) && vm.selectedMediaFiles.length === 0) {
                vm.commentError = 'Please enter a comment or attach media files.';
                return;
            }
            
            // Find the selected case to get case number and location
            var selectedCase = null;
            vm.trCases.forEach(function(trCase) {
                if (trCase.id === vm.selectedCaseId) {
                    selectedCase = trCase;
                }
            });
            
            if (!selectedCase) {
                vm.commentError = 'Case not found. Please try again.';
                return;
            }
            
            // If there are media files, upload them first
            if (vm.selectedMediaFiles.length > 0) {
                console.log('Starting media upload for', vm.selectedMediaFiles.length, 'files');
                vm.uploadingMedia = true;
                vm.uploadProgress = 'Uploading media files...';
                
                var uploadedMedia = [];
                var uploadCount = 0;
                var uploadErrors = [];
                
                vm.selectedMediaFiles.forEach(function(mediaFile, index) {
                    // Generate UUID as upload token so server names file as {uuid}_{fileName}
                    var uploadToken = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                        var r = Math.random() * 16 | 0;
                        var v = c === 'x' ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                    });
                    var fileType = '';
                    if (mediaFile.type && mediaFile.type.indexOf('/') > -1) {
                        fileType = mediaFile.type.split('/')[1].toUpperCase();
                    } else if (mediaFile.name && mediaFile.name.indexOf('.') > -1) {
                        fileType = mediaFile.name.split('.').pop().toUpperCase();
                    }
                    var finalFileName = mediaFile.name;
                    
                    console.log('Uploading file:', finalFileName, 'Token:', uploadToken, 'Type:', fileType);
                    
                    TrCaseCommentMediaUploadService.uploadFile(
                        mediaFile.file,
                        uploadToken,
                        fileType,
                        finalFileName,
                        function(success, filePath) {
                            uploadCount++;
                            console.log('Upload callback - Success:', success, 'FilePath:', filePath, 'Count:', uploadCount);
                            
                            if (success && filePath && filePath.indexOf('/trakeyeassetimages/') === 0) {
                                uploadedMedia.push({
                                    imageName: mediaFile.name,
                                    imageType: fileType,
                                    imagePath: filePath
                                });
                            } else {
                                uploadErrors.push(mediaFile.name);
                            }
                            
                            // Check if all uploads are complete
                            if (uploadCount === vm.selectedMediaFiles.length) {
                                console.log('All uploads complete. Uploaded:', uploadedMedia.length, 'Errors:', uploadErrors.length);
                                vm.uploadingMedia = false;
                                vm.uploadProgress = '';
                                
                                if (uploadErrors.length > 0) {
                                    vm.commentError = 'Failed to upload: ' + uploadErrors.join(', ');
                                    return;
                                }
                                
                                // All files uploaded successfully, save comment
                                saveCommentWithMedia(selectedCase, uploadedMedia);
                            }
                        }
                    );
                });
            } else {
                // No media files, save comment directly
                saveCommentWithMedia(selectedCase, []);
            }
        }
        
        function saveCommentWithMedia(selectedCase, commentMedia) {
            // Prepare comment data
            var commentData = [{
                comment: vm.commentText ? vm.commentText.trim() : '',
                caseNumber: selectedCase.caseNumber || 'INC-' + selectedCase.id,
                latitude: (selectedCase.latitude !== null && selectedCase.latitude !== undefined) ? selectedCase.latitude : 0.0,
                longitude: (selectedCase.longitude !== null && selectedCase.longitude !== undefined) ? selectedCase.longitude : 0.0
            }];
            
            // Add media only if present
            if (commentMedia && commentMedia.length > 0) {
                commentData[0].commentMedia = commentMedia;
            }
            
            console.log('Comment payload being sent to bulk API:', JSON.stringify(commentData, null, 2));
            
            // Call the service to save comments
            TrCaseCommentBulk.addComments(commentData, function(response) {
                // Success - refresh comments list
                vm.commentSuccess = 'Comment added successfully!';
                vm.commentError = '';
                vm.commentText = '';
                vm.selectedMediaFiles = [];
                
                // Refresh the comments list using case number
                if (selectedCase.caseNumber) {
                    TrCaseCommentBulk.getComments(selectedCase.caseNumber, function(comments) {
                        revokeCommentMediaObjectUrls();
                        vm.existingComments = comments || [];
                        attachCommentMediaPreviewUrls(vm.existingComments);
                    }, function(error) {
                        console.error('Error fetching comments:', error);
                    });
                }
                
                // Clear success message after 3 seconds
                $timeout(function() {
                    vm.commentSuccess = '';
                }, 3000);
            }, function(error) {
                // Error
                console.error('Error saving comment:', error);
                var errorMsg = 'Failed to add comment.';
                if (error && error.data && typeof error.data === 'string') {
                    errorMsg = error.data;
                } else if (error && error.statusText) {
                    errorMsg = error.statusText;
                }
                vm.commentError = errorMsg;
                vm.commentSuccess = '';
            });
        }

        function closeCommentModal() {
            vm.commentText = '';
            vm.selectedCaseId = null;
            vm.selectedTicketId = '';
            revokeCommentMediaObjectUrls();
            vm.existingComments = [];
            vm.commentSuccess = '';
            vm.commentError = '';
            vm.selectedMediaFiles = [];
            vm.uploadingMedia = false;
            vm.uploadProgress = '';
            
            // Clear file input
            $('#commentMediaFiles').val('');
            $('#commentMediaFiles').filestyle('clear');
            
            $('#addCommentModal').modal('hide');
            $(".modal-backdrop").remove();
        }

        function downloadPdfMapButton(caseId, fileName) {
            var downloadfileName = "";
            var downloadCaseDesc = "";
			vm.trCases.forEach(function(caseVal){
                if(caseVal.id == caseId){
                    downloadfileName = caseVal.caseTypeName;
                    downloadCaseDesc = caseVal.description;
                }
            });
            BaseUrl.getBaseUrl(function(baseurl){
				var request = new XMLHttpRequest();
				request.open('GET', baseurl.stringValue+"api/download-splicing-pdf/"+caseId, true);
				request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
				request.responseType = 'blob';
				
				request.onload = function(e) {
					if (this.status === 200) {
						var blob = this.response;
						if(blob.size > 0){
							var blob = new Blob([this.response], {type: 'application/pdf'});
							var link = document.createElement('a');
							link.href = window.URL.createObjectURL(blob);
							link.download = fileName + ".pdf";
							
							link.click();
							
						}
					}
				};
				request.send();
			});
        }


        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        $scope.geofencelabel = {
            search          : "Search",
            nothingSelected : "Block"      
        }

        $scope.statuslabel = {
            search          : "Search",
            nothingSelected : "Priority/Status",
            selectAll       : "All",
            selectNone      : "None", 
            Done : "Done" 
        }

        vm.showCasesFilter = false
        vm.textFilter = "Show"
        vm.showHideFilter = function (){
            vm.showCasesFilter = !vm.showCasesFilter
            vm.textFilter = vm.showCasesFilter ? "Hide" : "Show"
        }
        $scope.setTab = function (newTab) {
            $scope.search = null;
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                /* filterTrcasesOnListView()
                filterTrcaseSearch(); */
                if (vm.showLegacyListFilterMode) {
                    // Rebuild geofencesListView from the already-fetched userGeofences
                    // cache so the multi-select directive gets a new array reference
                    // (prevents duplicate ticked values) while restoring the user's
                    // current block selection (prevents "Please Select Block" reset).
                    var savedListGeofenceId = vm.selectedListGeofenceId;
                    vm.geofencesListView = [];
                    if (vm.userGeofences.length >= 2) {
                        vm.geofencesListView.push({ id: 0, name: "All", label: "All" });
                    }
                    vm.userGeofences.forEach(function (geofence) {
                        geofence.ticked = (savedListGeofenceId && savedListGeofenceId == geofence.id);
                        vm.geofencesListView.push(geofence);
                    });
                } else if(tempGeofenceId){
                    vm.selectedListGeofenceId = tempGeofenceId
                    saveListFilter()
                    vm.geofencesListView.forEach(function (item){
                        if(item.id == vm.selectedListGeofenceId){
                            item.ticked = true
                        }else{
                            item.ticked = false
                        }
                    })
                }
                
            } else if ($scope.tab == 2) {
                /* var myOptions = {
                    zoom: 12,
                    center: new google.maps.LatLng(
                        $rootScope.DEFAULT_LATITUDE,
                        $rootScope.DEFAULT_LONGITUDE
                    ),
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas1"),
                    myOption(12,new google.maps.LatLng(
                        $rootScope.DEFAULT_LATITUDE,
                        $rootScope.DEFAULT_LONGITUDE
                    ))
                );
                geoLocation(locations.map);
                vm.selectedGeofenceId = 0;
                //filterTrCaseSearchMap();
                //vm.mapAssets = [];
                //getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
                setTimeout(function () {
                    removeMarkers();
                }, 2000);

                statusFilter();
                filterAssetsOnMapView()
                if(tempGeofenceId){
                    vm.selectedGeofenceId = tempGeofenceId
                    saveFilter()
                }
                
            } else if ($scope.tab == 3) {
                filterAssetsOnMapView()
                //vm.selectedGeofenceId = 0;
                //filterTrCaseSearchMap();
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas2"),
                    myOption(12,new google.maps.LatLng(
                        $rootScope.DEFAULT_LATITUDE,
                        $rootScope.DEFAULT_LONGITUDE
                    ))
                );
                geoLocation(locations.map); 
                getAllUsers()
                if(tempGeofenceId){
                    vm.selectedGeofenceId = tempGeofenceId
                    saveFilter()
                }
            } else if ($scope.tab == 4) {
                vm.selectedGeofenceId = 0;
                vm.selectedGeofenceMap = null
                /* var myOptions = {
                    zoom: 12,
                    center: new google.maps.LatLng(
                        $rootScope.DEFAULT_LATITUDE,
                        $rootScope.DEFAULT_LONGITUDE
                    ),
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas4"),
                    myOption(12,new google.maps.LatLng(
                        $rootScope.DEFAULT_LATITUDE,
                        $rootScope.DEFAULT_LONGITUDE
                    ))
                );
                geoLocation(locations.map);

                vm.userMasterGeofences = [];
                UserMasterGeofences.getAll(function (response) {
                    vm.userMasterGeofences = response;
                });
                setTimeout(function () {
                    removeMarkers();
                }, 2000);
                statusFilter();
                vm.selectedMasterGeofenceId = 0;
            }
        };

        $("#masterGeofence").on("change", function () {
            var value = $(this).val();
            vm.selectedMasterGeofenceId = value;
            filterAssetsOnMapView()
        });

        function statusFilter() {
            $scope.togglePriorityTypeSelection = function togglePriorityTypeSelection(
                priorityName
            ) {
                var idx = vm.selectedPriorityType.indexOf(priorityName);

                if (idx > -1) {
                    vm.selectedPriorityType.splice(idx, 1);
                    vm.selectedPriorityList = [];
                } else {
                    vm.selectedPriorityType.push(priorityName);
                    vm.selectedPriorityList = [];
                    vm.priorityList.forEach(function (value) {
                        vm.selectedPriorityList.push(value);
                    });
                }
            };

            $scope.togglePriorityListSelection = function togglePriorityListSelection(
                priorityName
            ) {
                var idx = vm.selectedPriorityList.indexOf(priorityName);

                if (idx > -1) {
                    vm.selectedPriorityList.splice(idx, 1);
                } else {
                    vm.selectedPriorityList.push(priorityName);
                }
            };

            $scope.toggleStatusTypeSelection = function toggleStatusTypeSelection(
                statusName
            ) {
                var idx = vm.selectedStatusType.indexOf(statusName);

                if (idx > -1) {
                    vm.selectedStatusType.splice(idx, 1);
                    vm.selectedStatusList = [];
                } else {
                    vm.selectedStatusType.push(statusName);
                    vm.selectedStatusList = [];
                    vm.statusList.forEach(function (value) {
                        vm.selectedStatusList.push(value);
                    });
                }
            };

            $scope.toggleStatusListSelection = function toggleStatusListSelection(
                statusName
            ) {
                var idx = vm.selectedStatusList.indexOf(statusName);

                if (idx > -1) {
                    vm.selectedStatusList.splice(idx, 1);
                } else {
                    vm.selectedStatusList.push(statusName);
                }
            };
        }

        $scope.savePriorityStatusFilter = function () {
            vm.selectedPriorityList = []
            vm.selectedStatusList = []
            vm.selectedCaseTypeList = []
            vm.selectedstatusType.forEach(function(val){
                 if(val.name == 'CRITICAL' || val.name ==  'HIGH' || val.name == "MEDIUM" || val.name == "LOW" ){
                    vm.selectedPriorityList.push(val.name)
                } else if(val.name == 'NEW' || val.name ==  'INPROGRESS' || val.name == "PENDING" || val.name == "TOBEASSIGNED" || val.name == "ASSIGNED"
                || val.name ==  'CANCELLED' || val.name == "CLOSED" ){
                    vm.selectedStatusList.push(val.name)
                }else{
                    vm.selectedCaseTypeList.push(val.value)
                }

            })

            if (
                vm.selectedPriorityList.length > 0 &&
                vm.selectedStatusList.length > 0
            ) {
                saveFilter();
            }
        };

        function navigateCaseEdit(selectedId) {
            vm.editId = selectedId.id;
            sessionStorage.setItem("prevEditId", vm.editId);
            $state.go("tr-case.edit", {
                id: vm.editId,
            });
        }

        function goToEditPage(selectedId) {
            $state.go("asset.edit", {
                id: selectedId.id,
            });
        }

        function usersTable(trCase) {
            vm.trCases.forEach(function (item) {
                item.isExpanded = false;
            });
            if (vm.toggle == trCase.id) {
                vm.toggle = undefined;
            } else {
                trCase.isExpanded = true;
                vm.toggle = trCase.id;
            }

            Report.getUsersAroundCase(
                {
                    id: trCase.id,
                    fromTime: trCase.createDate,
                    toTime: trCase.createDate + 1.8e6,
                },
                function (response) {
                    if (response instanceof Array) {
                        vm.caseAroundUsers = response;
                    } else {
                        vm.caseAroundUsers = [];
                        vm.caseAroundUsers.push(response);
                    }
                    vm.search = "";
                    vm.reporthide = true;
                }
            );
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                    Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                    Math.cos(degrees_to_radians(lat2)) *
                    Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

        function searchTrCases() {
            // if(isNewCaseSelected == 'day') {
            //     fromDateValue = sixMonthsAgoEpoch;
            //     toDateValue = now;
            // } else {
            //     fromDateValue = vm.fromDate.setHours(0, 0, 0, 0);
            //     toDateValue = vm.toDate.setHours(23, 59, 59, 999);
            // }
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search) &&
                $scope.search.length != 1 &&
                $scope.search.length != 2 &&
                $scope.search.length != 3 &&
                $scope.search.length != 4
            ) {
                if ($stateParams.priority == undefined) {
                    if (vm.selectedListGeofenceId > 0) {
                        // TrCaseGeofenceSearchCustom.query(
                        //     {
                        //         search: $scope.search,
                        //         page: pagingParams.page - 1,
                        //         size: vm.itemsPerPage,
                        //         sort: sort(),
                        //         geofenceId: vm.selectedListGeofenceId,
                        //         fromDate: fromDateValue,
                        //         toDate: toDateValue
                        //     },
                        //     onSuccess,
                        //     onError
                        // );
                        TrCaseGeofenceSearch.query(
                            {
                                search: $scope.search,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                                geofenceId: vm.selectedListGeofenceId
                            },
                            onSuccess,
                            onError
                        );
                    } else {
                        // TrCaseSearchCustom.query(
                        //     {
                        //         search: $scope.search,
                        //         page: pagingParams.page - 1,
                        //         size: vm.itemsPerPage,
                        //         sort: sort(),
                        //         geofenceId: vm.selectedListGeofenceId,
                        //         fromDate: fromDateValue,
                        //         toDate: toDateValue
                        //     },
                        //     onSuccess,
                        //     onError
                        // );
                        TrCaseSearch.query(
                            {
                                search: $scope.search,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                                geofenceId: vm.selectedListGeofenceId
                            },
                            onSuccess,
                            onError
                        );
                    }
                } else {
                    TrCasePrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }

                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    var trCasesSearchRes = [];
                    data.forEach(function (values) {
                        var FiberStatus = "";
                        var Cost = "";
                        var pb = "";
                        var dis = "";
                        var baseCost = "";
                        var caseTypeAttrVal = values.caseTypeAttributeValues;

                        caseTypeAttrVal.forEach(function (item) {
                            if (item.caseDataTypeName == "Fiber Status") {
                                FiberStatus = item.attributeValue;
                            }
                            if (item.name == "Cost") {
                                Cost = item.attributeValue;
                            } else if (item.name == "Power Budget") {
                                pb = item.attributeValue;
                            } else if (item.name == "Fiber Distance") {
                                dis = item.attributeValue;
                            } else if (item.name == "Base Cost") {
                                baseCost = item.attributeValue;
                            }
                        });

                        //						if (values.status) {
                        //							values.status = values.status.replace("NEW", "PLANNING PHASE");
                        //							values.status = values.status.replace("INPROGRESS", "ROLL-OUT PHASE");
                        //							values.status = values.status.replace("RESOLVED", "OPERATION PHASE");
                        //						}

                        var isVerified = false;
                        if (values.verified) {
                            isVerified = true;
                        }
                        var res = {
                            id: values.id,
                            description: values.description,
                            title:values.title,
                            address: values.address,
                            escalated: values.escalated,
                            status: values.status,
                            reportedByUser: values.reportedByUser,
                            assignedToUser: values.assignedToUser,
                            assignedToUserFirstName:values.assignedToUserFirstName,
                            assignedToUserLastName:values.assignedToUserLastName,
                            verified: isVerified,
                            caseTypeName: values.caseTypeName,
                            pinLat: values.pinLat,
                            pinLong: values.pinLong,
                            caseType: values.caseType,
                            priority: values.priority,
                            caseNumber: caseNumber.caseNumber,
                            fiberStatus: FiberStatus,
                            groups: values.groups,
                            geofenceName: values.geofenceName,
                            caseAssets: values.caseAssets,
                            Cost: "$" + Cost,
                            pb: pb,
                            dis: dis,
                            baseCost: baseCost,
                        };

                        trCasesSearchRes.push(res);
                    });
                    vm.trCases = trCasesSearchRes;
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        // Helper function to load filtered cases with search
        function loadFilteredCasesWithSearch(searchText) {
            var filterValue = '';
            var amcStatus = vm.selectedAMCStatusList || 'ALL';
            var filterType = 'PACKAGE'; // Default filter type
            
            // Determine filter type based on what's selected (most specific to least specific)
            if (vm.selectedGPList) {
                filterType = 'GP';
                filterValue = vm.selectedGPList;
            } else if (vm.selectedBlockList) {
                filterType = 'MINI';
                filterValue = vm.selectedBlockList;
            } else if (vm.selectedDistrictList) {
                filterType = 'MASTER';
                filterValue = vm.selectedDistrictList;
            } else if (vm.selectedOperationalAreaList) {
                filterType = 'OA';
                filterValue = vm.selectedOperationalAreaList;
            } else if (vm.selectedBusinessAreaList) {
                filterType = 'BA';
                filterValue = vm.selectedBusinessAreaList;
            } else if (vm.selectedStateList) {
                filterType = 'STATE';
                filterValue = vm.selectedStateList;
            } else if (vm.selectedPackageList) {
                filterType = 'PACKAGE';
                filterValue = vm.selectedPackageList;
            }
            
            var page = (vm.page - 1) || 0;
            var size = vm.itemsPerPage;
            var sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            
            // Call backend search API so the search respects the selected filters
            TrCaseFiltered.getByFiltersSearch(filterValue, amcStatus, filterType, searchText, page, size, sort, function(data, headers) {
                if (data && Array.isArray(data)) {
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.trCases = data;
                } else {
                    vm.trCases = [];
                    vm.totalItems = 0;
                    vm.queryCount = 0;
                }
            });
        }

        function filterTrcaseSearch() {
            // Check if any meaningful geographic filters are active (beyond just the default package)
            var hasDropdownFilters = vm.selectedStateList || 
                vm.selectedBusinessAreaList || vm.selectedOperationalAreaList || 
                vm.selectedDistrictList || vm.selectedBlockList || vm.selectedGPList;
            var pageIndex = (vm.page - 1) || 0;
            
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                // If dropdown filters are active, call filter API first, then apply search
                if (hasDropdownFilters) {
                    loadFilteredCasesWithSearch($scope.search);
                    return;
                }
                
                if ($stateParams.priority == undefined) {
                    if (vm.selectedListGeofenceId > 0) {
                        // TrCaseGeofenceSearchCustom.query(
                        //     {
                        //         search: $scope.search,
                        //         page: pagingParams.page - 1,
                        //         size: vm.itemsPerPage,
                        //         sort: sort(),
                        //         geofenceId: vm.selectedListGeofenceId,
                        //         fromDate: fromDateValue,
                        //         toDate: toDateValue,
                        //     },
                        //     onSuccess,
                        //     onError
                        // );
                         TrCaseGeofenceSearch.query(
                            {
                                search: $scope.search,
                                page: pageIndex,
                                size: vm.itemsPerPage,
                                sort: sort(),
                                geofenceId: vm.selectedListGeofenceId
                            },
                            onSuccess,
                            onError
                        );
                    } else {
                        // TrCaseSearchCustom.query(
                        //     {
                        //         search: $scope.search,
                        //         page: pagingParams.page - 1,
                        //         size: vm.itemsPerPage,
                        //         sort: sort(),
                        //         fromDate: fromDateValue,
                        //         toDate: toDateValue,
                        //     },
                        //     onSuccess,
                        //     onError
                        // );
                        TrCaseSearch.query(
                            {
                                search: $scope.search,
                                page: pageIndex,
                                size: vm.itemsPerPage,
                                sort: sort()
                            },
                            onSuccess,
                            onError
                        );
                    }
                } else {
                    TrCasePrioritySearch.query(
                        {
                            priority: $stateParams.priority,
                            searchtext: $scope.search,
                            page: pageIndex,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }

                function sort() {
                    var result = [
                        vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                    ];
                    if (vm.predicate !== "id") {
                        // result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    var dateFormat = "dd-MM-yyyy";
                    // vm.trCases = data;
                    var trCaseSearch = [];

                    data.forEach(function (value) {
                        var isVerified = false;
                        if (value.verified) {
                            isVerified = true;
                        }
                        var res = {
                            id: value.id,
                            createDateFormat: $filter("date")(
                                value.createDate,
                                dateFormat
                            ),
                            createDate: value.createDate,
                            description: value.description,
                            title:value.title,
                            address: value.address,
                            escalated: value.escalated,
                            status: value.status,
                            reportedByUser: value.reportedByUser,
                            assignedToUser: value.assignedToUser,
                            assignedToUserFirstName:value.assignedToUserFirstName,
                            assignedToUserLastName:value.assignedToUserLastName,
                            verified: isVerified,
                            caseTypeName: value.caseTypeName,
                            pinLat: value.pinLat,
                            pinLong: value.pinLong,
                            caseType: value.caseType,
                            priority: value.priority,
                            caseNumber: value.caseNumber,
                            groups: value.groups,
                            geofenceName: value.geofenceName,
                            caseAssets: value.caseAssets,
                        };
                        trCaseSearch.push(res);
                    });
                    vm.trCases = trCaseSearch;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function getGroupAssetsFromES(
            geofenceIdVal,
            lastAssetId,
            mapAssetLists
        ) {
            AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;
                if (data && Array.isArray(data.assets) && data.assets.length > 0) {
                 data.assets.forEach(function (asset) {
                 var tmpAsset = {};

                tmpAsset.assetCoordinates = asset.assetCoordinates;
                tmpAsset.assetTypeName = asset.assetTypeName;
                tmpAsset.assetTypeColor = asset.assetColor;
                tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                tmpAsset.healthIndicator = asset.healthIndicator;
                tmpAsset.healthRemarks = asset.healthRemarks;
                tmpAsset.id = asset.id;
                tmpAsset.name = asset.name;

                vm.mapAssets.push(tmpAsset);
                });
                }

                drawLatestAssets(vm.mapAssets);
                if (data.lastId != null) {
                    getGroupAssetsFromES(
                        geofenceIdVal,
                        data.lastId,
                        vm.mapAssets
                    );
                } else {
                    if (vm.mapAssets.length > 0) {
                        var assetSelected = vm.mapAssets[0];
                        AssetByID.get(assetSelected.id, function (assetVal) {
                            var assetLatLng = {
                                lat:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].latitude,
                                lng:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].longitude,
                            };
                            locations.map.setCenter(assetLatLng);
                        });
                    }
                }
            });
        }

        $scope.submitDate = function (){
            $scope.search = "";
            $state.params.rangeOption = 'custom'
            isNewCaseSelected = $state.params.rangeOption
            //isNewCaseSelected = false;
            
            if(vm.fromDate && vm.toDate){
                fromDateValue = vm.fromDate.setHours(0, 0, 0, 0);
                toDateValue = vm.toDate.setHours(23, 59, 59, 999);
                if (vm.selectedListGeofenceId > 0) {
                    // TrCaseGeofenceCustomTime.query(
                    //     {
                    //         page: pagingParams.page - 1,
                    //         size: vm.itemsPerPage,
                    //         sort: sort(),
                    //         geofenceId: vm.selectedListGeofenceId,
                    //         fromDate: fromDateValue,
                    //         toDate: toDateValue,
                    //     },
                    //     onSuccess,
                    //     onError
                    // );
                    TrCaseGeofence.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                            geofenceId: vm.selectedListGeofenceId
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    // TrCaseCustomTime.query(
                    //     {
                    //         page: pagingParams.page - 1,
                    //         size: vm.itemsPerPage,
                    //         sort: sort(),
                    //         fromDate: fromDateValue,
                    //         toDate: toDateValue,
                    //     },
                    //     onSuccess,
                    //     onError
                    // );
                    // OLD API CALL - REPLACED WITH FILTERED API
                    // TrCase.query(
                    //     {
                    //         page: pagingParams.page - 1,
                    //         size: vm.itemsPerPage,
                    //         sort: sort()
                    //     },
                    //     onSuccess,
                    //     onError
                    // );
                }
            }
            
        }

        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers("link"));
            vm.totalItems = headers("X-Total-Count");
            vm.queryCount = vm.totalItems;
            var trCasesRes = [];
            var dateFormat = "dd-MM-yyyy";
            vm.trBreakUps = data;
            data.forEach(function (values) {
                var groups = Array.isArray(values.groups) ? values.groups : [];
                if (groups.length > 0) {
                    vm.parentGroup = groups[0].name;
                }
                var FiberStatus = "";
                var Cost = "";
                var pb = "";
                var dis = "";
                var baseCost = "";
                var caseTypeAttrVal = Array.isArray(values.caseTypeAttributeValues) ? values.caseTypeAttributeValues : [];

                caseTypeAttrVal.forEach(function (item) {
                    if (item.caseDataTypeName == "Fiber Status") {
                        FiberStatus = item.attributeValue;
                    }
                    if (item.name == "Cost") {
                        Cost = item.attributeValue;
                    } else if (item.name == "Power Budget") {
                        pb = item.attributeValue;
                    } else if (item.name == "Fiber Distance") {
                        dis = item.attributeValue;
                    } else if (item.name == "Base Cost") {
                        baseCost = item.attributeValue;
                    }
                });
                var isVerified = false;
                if (values.verified) {
                    isVerified = true;
                }
                var res = {
                    id: values.id,
                    createDateFormat: $filter("date")(
                        values.createDate,
                        dateFormat
                    ),
                    createDate: values.createDate,
                    description: values.description,
                    title:values.title,
                    address: values.address,
                    escalated: values.escalated,
                    status: values.status,
                    reportedByUser: values.reportedByUser,
                    assignedToUser: values.assignedToUser,
                    assignedToUserFirstName:values.assignedToUserFirstName,
                    assignedToUserLastName:values.assignedToUserLastName,
                    verified: isVerified,
                    caseTypeName: values.caseTypeName,
                    pinLat: values.pinLat,
                    pinLong: values.pinLong,
                    caseType: values.caseType,
                    priority: values.priority,
                    caseNumber: values.caseNumber,
                    fiberStatus: FiberStatus,
                    groups: groups,
                    geofenceName: values.geofenceName,
                    caseAssets: values.caseAssets,
                    Cost: "$" + Cost,
                    pb: pb,
                    dis: dis,
                    baseCost: baseCost,
                };
                trCasesRes.push(res);
            });
            vm.trCases = trCasesRes;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function newCases(){
            $scope.search = "";
            $state.params.rangeOption = vm.dateRange
            isNewCaseSelected = $state.params.rangeOption;
                        
            if(isNewCaseSelected == 'day') {
                fromDateValue = sixMonthsAgoEpoch;
                toDateValue = now;
                vm.fromDate = null
                vm.toDate = null
            } else {
                fromDateValue = vm.fromDate.setHours(0, 0, 0, 0);
                toDateValue = vm.toDate.setHours(23, 59, 59, 999);
            }
            
            if (vm.selectedListGeofenceId > 0) {
                // TrCaseGeofenceCustomTime.query(
                //     {
                //         page: pagingParams.page - 1,
                //         size: vm.itemsPerPage,
                //         sort: sort(),
                //         geofenceId: vm.selectedListGeofenceId,
                //         fromDate: fromDateValue,
                //         toDate: toDateValue,
                //     },
                //     onSuccess,
                //     onError
                // );
                TrCaseGeofence.query(
                    {
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                        geofenceId: vm.selectedListGeofenceId
                    },
                    onSuccess,
                    onError
                );
            } else {
                TrCase.query(
                    {
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    },
                    onSuccess,
                    onError
                );
            }
        }
        function loadAll() {
            $scope.search == null;

            if ($stateParams.priority == undefined) {
                vm.groupCases = false;
                vm.showTrCaseActions = false;
                if ($stateParams.caseStatus == undefined) {
                    newCases()
                } else {
                    TrCaseAttendance.query(
                        {
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            caseStatus: $stateParams.caseStatus,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            } else {
                TrCasePriority.query(
                    {
                        priority: $stateParams.priority,
                        geofenceId: $stateParams.geofenceId,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
            }

            /* function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    // result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                var trCasesRes = [];
                var dateFormat = "dd-MM-yyyy";
                vm.trBreakUps = data;
                data.forEach(function (values) {
                    if (values.groups.length > 0) {
                        vm.parentGroup = values.groups[0].name;
                    }
                    var FiberStatus = "";
                    var Cost = "";
                    var pb = "";
                    var dis = "";
                    var baseCost = "";
                    var caseTypeAttrVal = values.caseTypeAttributeValues;

                    caseTypeAttrVal.forEach(function (item) {
                        if (item.caseDataTypeName == "Fiber Status") {
                            FiberStatus = item.attributeValue;
                        }
                        if (item.name == "Cost") {
                            Cost = item.attributeValue;
                        } else if (item.name == "Power Budget") {
                            pb = item.attributeValue;
                        } else if (item.name == "Fiber Distance") {
                            dis = item.attributeValue;
                        } else if (item.name == "Base Cost") {
                            baseCost = item.attributeValue;
                        }
                    });
                    var isVerified = false;
                    if (values.verified) {
                        isVerified = true;
                    }
                    var res = {
                        id: values.id,
                        createDateFormat: $filter("date")(
                            values.createDate,
                            dateFormat
                        ),
                        createDate: values.createDate,
                        description: values.description,
                        address: values.address,
                        escalated: values.escalated,
                        status: values.status,
                        reportedByUser: values.reportedByUser,
                        assignedToUser: values.assignedToUser,
                        verified: isVerified,
                        caseTypeName: values.caseTypeName,
                        pinLat: values.pinLat,
                        pinLong: values.pinLong,
                        caseType: values.caseType,
                        priority: values.priority,
                        caseNumber: values.caseNumber,
                        fiberStatus: FiberStatus,
                        groups: values.groups,
                        geofenceName: values.geofenceName,
                        caseAssets: values.caseAssets,
                        Cost: "$" + Cost,
                        pb: pb,
                        dis: dis,
                        baseCost: baseCost,
                    };
                    trCasesRes.push(res);
                });
                vm.trCases = trCasesRes;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            } */
        }

        function saveListFilter() {
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
            filterTrcaseSearch();
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
        }

        $scope.geofenceListView = function(){
            console.log(vm.selectedListGeofenceId);
            if($scope.tab == 1){
                isNewCaseSelected = vm.dateRange
                vm.selectedListGeofenceId = vm.selectedGeofenceId[0].id
                tempGeofenceId = vm.selectedGeofenceId[0].id
                saveListFilter()
            }else if($scope.tab == 2 || $scope.tab == 3 || $scope.tab == 4){
                $scope.search = ""
                vm.selectedGeofenceId = vm.selectedGeofenceMap[0].id
                tempGeofenceId = vm.selectedGeofenceMap[0].id
                saveFilter()
            }
        }
        function filterTrcasesOnListView() {
            tempGeofenceId = $state.params.listgeofenceid
            vm.geofencesListView = [];
            vm.userGeofences = []
            if (vm.adminFilter) {
                GeofenceIDs.getAll(function (response) {
                    if (response.length >= 2) {
                        vm.geofencesListView.push({ id: 0, name: "All", label : "All" });
                    }
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                        vm.geofencesListView.push(geofence);
                        vm.userGeofences.push(geofence);
                        /* if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        } */
                    });
                });
            } else {
                UserGeofences.getAll(function (response) {
                    if (response.length >= 2) {
                        vm.geofencesListView.push({ id: 0, name: "All", label : "All" });
                    }
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                        vm.userGeofences.push(geofence);
                        vm.geofencesListView.push(geofence);
                        /* if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        } */
                    });
                });
            }
            //$("#listFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
        }

        function closeListFilterModal() {
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
            vm.selectedListGeofenceId = vm.PrevselectedListGeofenceId;
        }

        function showPriorityStatusFilter() {
            vm.currentZoom = locations.map.getZoom();

            vm.getCenter = locations.map.center;

            $("#priorityStatusfilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function closePriorityStatusFilterModal() {
            $("#priorityStatusfilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#priorityStatusfilterModal").hide();
        }

        function dateFilterTrCaseSearchMap() {
                var tempResponse;

                if (vm.geofenceResponse && vm.geofenceResponse.length > 0 && $scope.search) {
                    tempResponse = vm.geofenceResponse.find(function (element) {
                        return $scope.search == element.id;
                    });

                    if (tempResponse && tempResponse.pinLat && tempResponse.pinLong) {
                        var latLng = new google.maps.LatLng(
                            tempResponse.pinLat,
                            tempResponse.pinLong
                        );
                        locations.map.panTo(latLng);
                        locations.map.setZoom(14);
                    }
                }
        }


        function filterTrCaseSearchMap() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                // TrCaseSearchForMap.searchtrcaseformap($scope.search, function (response) {
                //     drawResponseMap(response);
                // });

                TrCaseForMap.getAllCases(
                    {
                        geofenceId: vm.selectedGeofenceId,
                        searchText: $scope.search,
                        // priorityList: vm.selectedPriorityList,
                        // statusList: vm.selectedStatusList,
                    },
                    function (response) {
                        drawResponseMap(response);
                    }
                );
            } else {
                if ($stateParams.priority == undefined) {
                    // TrCaseForMap.getAllCases(function (response) {
                    //     drawResponseMap(response);
                    // });
                    TrCaseForMap.getAllCases(
                        {
                            geofenceId: vm.selectedGeofenceId,
                            // priorityList: vm.selectedPriorityList,
                            // statusList: vm.selectedStatusList,
                        },
                        function (response) {
                            drawResponseMap(response);
                        }
                    );
                } else {
                    TrCaseForMap.getAllCases(
                        {
                            geofenceId: vm.selectedGeofenceId,
                            prioritySearch: $stateParams.priority,
                        },
                        function (response) {
                            drawResponseMap(response);
                        }
                    );
                    // TrCaseSearchForMap.prioritysearchtrcaseformap($stateParams.priority, function (response) {
                    //     drawResponseMap(response);
                    // });
                }
            }
        }

        function drawLatestAssets(response) {
            if (response) {
                initializeAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                            value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    drawFixedAsset(value1, false);
                                } else {
                                    drawFixedAsset(value, false);
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                drawPolyline(value, locations.map);
                            }
                        });
                    });
                });
            }
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 14,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(14,locations.latlng)
                );

                google.maps.event.addListener(
                    locations.map,
                    "zoom_changed",
                    function () {
                        vm.zoomLevel = locations.map.getZoom();
                        if (
                            (vm.prevZoomLevel == 17 && vm.zoomLevel == 18) ||
                            (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)
                        ) {
                            drawLatestAssets(vm.mapAssets);
                        }
                        vm.prevZoomLevel = vm.zoomLevel;
                    }
                );
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () {};
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById("map_canvas");
            callback();
        }

        function initializeAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            lngVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            // callback(new google.maps.LatLng("12.9716", "77.5946"));
                            callback(
                                new google.maps.LatLng(
                                    $rootScope.DEFAULT_LATITUDE,
                                    $rootScope.DEFAULT_LONGITUDE
                                )
                            );
                        }
                    );
                } else {
                    callback(
                        new google.maps.LatLng(
                            $rootScope.DEFAULT_LATITUDE,
                            $rootScope.DEFAULT_LONGITUDE
                        )
                    );
                }
            }
        }

        function drawFixedAsset(fixed, hasParent) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                if(fixed.assetTypeName=="Router"){
                    if(fixed.healthIndicator==true){
                        iconUrl = "content/images/route_green.png"
                    } else {
                        iconUrl = "content/images/route_red.png"
                    }
                } else if(fixed.assetTypeName=="NOC") {
                    if(fixed.healthIndicator==true){
                        iconUrl = "content/images/noc_green.png"
                    } else {
                        iconUrl = "content/images/noc_red.png"
                    }
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                    },
                });
                markers.push(startMarker);
                var updateIconSize = function () {
                    var zoom = locations.map.getZoom();

                    // Define minimum and maximum zoom levels
                    var minZoom = 8;
                    var maxZoom = 21;

                    // Define minimum and maximum icon sizes
                    var minSize = 6;  // Smallest size at zoom 8
                    var maxSize = 60;  // Full size at zoom 21

                    // Compute new size based on zoom level
                    var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);

                    var icon = {
                        url: startMarker.getIcon().url,  // Keep the existing marker image
                        scaledSize: new google.maps.Size(newSize, newSize),  // Only use scaledSize
                        anchor: new google.maps.Point(newSize / 2, newSize / 2), // Adjust anchor to prevent clipping
                    };

                    startMarker.setIcon(icon);
                };

                // Run updateIconSize once to initialize
                updateIconSize();
                function updateMarkerLabelVisibility() {
                    var currentZoom = locations.map.getZoom();
                    if (currentZoom > 10) {
                        if (fixed.assetTypeName === "GP" || fixed.assetTypeName==="ONT") {
                            startMarker.setLabel({
                                color: "red",
                                fontWeight: "bold",
                                fontSize: "12px",
                                text: fixed.name,
                                className: "asset_label top-label"
                            });
                        }
                    } else {
                        startMarker.setLabel(null);
                    }
                    var style = document.createElement('style');
                    style.innerHTML = '.top-label {' +
                        '    position: relative;' +
                        '    top: 30px;' +
                        '    left: 0;' +
                        '    transform: translateX(10%);' +
                        '    white-space: nowrap;' +
                        '}';
                    document.head.appendChild(style);
                }
                var infoWindow2 = new google.maps.InfoWindow();
                var infoStr = "";
                var otdr = "";

                var userContent = document.createElement("div"),
                    button;

                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    startMarker.title +
                    '</div><div class="infoWindowContent">' +
                    "<b>Lat</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .latitude +
                    "<br><b>Long</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .longitude +
                    "<br>" +
                    infoStr +
                    "</div>";

                google.maps.event.addListener(
                    startMarker,
                    "dblclick",
                    function () {
                        infoWindow2.close();
                    }
                );

                var activeInfoWindow;
                var infoWindow2 = new google.maps.InfoWindow({
                    content: userContent,
                });
                // add listener on InfoWindow for click
                // event
                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function () {
                        AssetByID.get(fixed.id, function (response) {
                            var infoWindow2 = new google.maps.InfoWindow();
                            var infoStr = "";
                            var otdr = "";
                            var assetTypeAttributeValuesList =
                                response.assetTypeAttributeValues;
                            assetTypeAttributeValuesList.sort(function (a, b) {
                                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                    nameB = a.assetTypeAttribute.name.toLowerCase();
                                if (nameA < nameB)
                                    // sort string ascending
                                    return -1;
                                if (nameA > nameB) return 1;
                                return 0; // default return value (no sorting)
                            });
                            for (
                                var i = 0;
                                i < assetTypeAttributeValuesList.length;
                                i++
                            ) {
                                var home = assetTypeAttributeValuesList[i];
                                infoStr +=
                                    "<br><b>" +
                                    home.assetTypeAttribute.name +
                                    "</b> : " +
                                    home.attributeValue;
                                otdr = home;
                            }

                            var userContent = document.createElement("div"),
                                buttonA,
                                buttonB,
                                buttonC,
                                buttonD;
                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                "<b>Name</b> : " + fixed.name +
                                '</div><div class="infoWindowContent">' +
                                "<b>Asset Type</b> : " + fixed.assetTypeName +
                                "<br><b>Latitude</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].latitude +
                                "<br><b>Longitude</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].longitude +
                                "<br>" +
                                infoStr +
                                "</div>";

                            var infoWindow2 = new google.maps.InfoWindow({
                                content: userContent,
                            });
                            if (prevInfoWindow != null) prevInfoWindow.close();
                            infoWindow2.open(locations.map, startMarker);
                         

                            activeInfoWindow = infoWindow2;
                            prevInfoWindow = infoWindow2;
                        });
                    }
                );
                google.maps.event.addListener(locations.map, "zoom_changed", function () {
                    updateIconSize();
                    updateMarkerLabelVisibility()
                });
                openedInfoWindow = infoWindow2;
            });
        }

        function selectAllAssets() {
            var toggleStatus = vm.isAllAssetSelected;
            if (toggleStatus) {
                vm.showAssetActions = true;
                vm.selectedAssets = [];
                vm.trCases.forEach(function (asset) {
                    vm.selectedAssets.push(asset.id);
                });
            } else {
                vm.showAssetActions = false;
                vm.selectedAssets = [];
            }
            angular.forEach(vm.trCases, function (item) {
                item.isChecked = toggleStatus;
            });
        }

        function filterAssetsOnMapView() {
            vm.userGeofences = [];
            if (vm.adminFilter) {
                if ($scope.tab == 2 || $scope.tab == 3) {
                    GeofenceIDs.getAll(function (response) {
                        response.forEach(function (geofence) {
                            geofence.label = geofence.name.substring(0, 15) + "..";
                            vm.userGeofences.push(geofence);

                            geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                           /*  if (vm.selectedGeofenceId == null) {
                                vm.selectedGeofenceId = geofence.id;
                            } */
                        });
                        vm.countUserGeofences = vm.userGeofences.length;
                    });
                } else if ($scope.tab == 4) {
                    vm.userGeofences = [];
                    MiniGeofencesByMasterID.get(
                        vm.selectedMasterGeofenceId,
                        function (response) {
                            response.forEach(function (geofence) {
                                geofence.label = geofence.name.substring(0, 15) + "..";
                                vm.userGeofences.push(geofence);

                                //geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                                /* if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                } */
                            });
                            vm.countUserGeofences = vm.userGeofences.length;
                        }
                    );
                }
            } else {
                UserGeofences.getAll(function (response) {
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        vm.userGeofences.push(geofence);
                        if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        }
                    });
                    vm.countUserGeofences = vm.userGeofences.length;
                });
            }
            //$("#mapFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            //vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
            /* vm.selectedPriorityList = [];
            vm.priorityList.forEach(function (value) {
                vm.selectedPriorityList.push(value);
            });
            vm.selectedStatusList = [];
            vm.statusList.forEach(function (value) {
                vm.selectedStatusList.push(value);
            }); */
        }

        function closeMapFilterModal() {
            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
        }

        function saveFilter() {
            if(isNewCaseSelected == 'day') {
                fromDateValue = sixMonthsAgoEpoch;
                toDateValue = now;
            } else {
                fromDateValue = vm.fromDate.setHours(0, 0, 0, 0);
                toDateValue = vm.toDate.setHours(23, 59, 59, 999);
            }
            if ($stateParams.priority == undefined) {
                var sendData
                if (vm.dateRange == 'day'){
                    sendData = {
                        geofenceId: vm.selectedGeofenceId,
                        // priorityList: vm.selectedPriorityList,
                        // statusList: vm.selectedStatusList,
                        caseTypeIds : vm.selectedCaseTypeList,
                    }

                }else if(vm.dateRange == 'custom'){
                    sendData = {
                        geofenceId: vm.selectedGeofenceId,
                        // priorityList: vm.selectedPriorityList,
                        // statusList: vm.selectedStatusList,
                        caseTypeIds : vm.selectedCaseTypeList
                    }
                }

                TrCaseForMap.getAllCases(
                    sendData,
                    function (response) {
                        vm.geofenceResponse = response
                        drawResponseMap(response);
                        vm.mapAssets = [];
                        markers = [];
                        polylines = [];
                       /*  var myOptions = {
                            zoom: 17,
                            center: locations.latlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP,
                        }; */
                        if ($scope.tab == 2) {
                            locations.map = new google.maps.Map(
                                document.getElementById("map_canvas1"),
                                myOption(17,locations.latlng)
                            );
                        } else if ($scope.tab == 3) {
                            locations.map = new google.maps.Map(
                                document.getElementById("map_canvas2"),
                                myOption(17,locations.latlng)
                            );
                        } else if ($scope.tab == 4) {
                            locations.map = new google.maps.Map(
                                document.getElementById("map_canvas4"),
                                myOption(17,locations.latlng)
                            );
                        }

                        geoLocation(locations.map);
                        getGroupAssetsFromES(
                            vm.selectedGeofenceId,
                            null,
                            vm.mapAssets
                        );
                        drawLatestTrCases(response);
                        closePriorityStatusFilterModal();
                        vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
                    }
                );
            }

            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
        }

        function selectTrcaseEntity(trCase) {
            if (trCase.id != null) {
                if (trCase.isChecked == true) {
                    vm.totalTrcaseSelected++;
                    vm.showTrCaseActions = true;
                    vm.isAllTrCaseSelected = vm.trCases.every(function (itm) {
                        return itm.isChecked;
                    });
                    vm.selectedWorkCases.push(trCase.id);
                } else {
                    vm.totalTrcaseSelected--;
                }
                if (vm.totalTrcaseSelected == 0) {
                    vm.groupAssets = true;
                    vm.showTrCaseActions = false;
                    filterTrcaseSearch();
                }
            }
        }

        function selectAllTrCases() {
            var toggleStatus = vm.isAllTrCaseSelected;
            if (toggleStatus) {
                vm.showTrCaseActions = true;
                vm.selectedWorkCases = [];
                vm.trCases.forEach(function (trCase) {
                    vm.selectedWorkCases.push(trCase.id);
                });
            } else {
                vm.showTrCaseActions = false;
                vm.selectedWorkCases = [];
            }
            angular.forEach(vm.trCases, function (itm) {
                itm.isChecked = toggleStatus;
            });
        }

        function animatedMove(marker, t, current, moveto) {
            var lat = current.lat();
            var lng = current.lng();

            var deltalat = (moveto.lat() - current.lat()) / 100;
            var deltalng = (moveto.lng() - current.lng()) / 100;

            var delay = 10 * t;
            for (var i = 0; i < 100; i++) {
                (function (ind) {
                    setTimeout(function () {
                        var lat = marker.position.lat();
                        var lng = marker.position.lng();
                        lat += deltalat;
                        lng += deltalng;
                        latlng = new google.maps.LatLng(lat, lng);
                        marker.setPosition(latlng);
                    }, delay * ind);
                })(i);
            }
        }

        function getAllUsers(){
            TrCaseLastLocation.getlastlogs(function (response) {
                var lastLocByAgents = response;
                vm.usersList = [];
                response.forEach(function (user) {
                    if (user.path.length > 0) {
                        vm.usersList.push(user);
                    }
                });
                var markerIcon = "inactive";
                var imageUrl = "";
                switch (markerIcon) {
                    case "inactive":
                        imageUrl = "content/images/inactive_out.png";
                        break;
                    case "idle":
                        imageUrl = "content/images/marker_idle.png";
                        break;
                    case "active":
                        imageUrl = "content/images/marker_active.png";
                        break;
                    case "active_case":
                        imageUrl = "content/images/marker_active_case.png";
                        break;
                    default:
                        imageUrl = "content/images/green.png";
                        break;
                }

                var lastLocVal = [];
                removeMarkers();
                var iconSize=24;
                for (var i = 0; i < lastLocByAgents.length; i++) {
                    var path = lastLocByAgents[i].path;
                    if (path.length > 1) {
                        var marker = new google.maps.Marker({
                            position: new google.maps.LatLng(
                                path[0].lat,
                                path[0].lng
                            ),
                            map: locations.map,
                            icon: {
                                scaledSize: new google.maps.Size(42, 40),
                                origin: new google.maps.Point(0, 0),
                                url: imageUrl,
                                anchor: new google.maps.Point(16, 16),
                                labelOrigin: new google.maps.Point(iconSize*1.1, iconSize*1.2),
                            },
                            label: {
                                color: "#000000",
                                fontWeight: "bold",
                                fontSize: "12px",
                                text: lastLocByAgents[i].userName,
                                backgroundcolor: "#ff9800",
                            },
                            title: lastLocByAgents[i].userName,
                        });
                        var markerContent =
                            '<div class="infoWindowhead">' +
                            lastLocByAgents[i].userName +
                            '</div><div class="infoWindowContent"> <br> <b> Lat  :</b> ' +
                            +path[0].lat +
                            "<br> <b>Lng :</b> " +
                            path[0].lng +
                            "</div>";

                        infowindowUsers(markerContent, marker);

                        animatedMove(
                            marker,
                            50,
                            marker.position,
                            new google.maps.LatLng(path[1].lat, path[1].lng)
                        );
                        nearbyAgentsMarkers.push(marker);
                    }
                }
            });
        }

        function drawResponseMap(data) {
            var myOptions = null;
            var latCase
            var longCase
             if (Array.isArray(data) && data.length > 0) {
            data.forEach(function (coOrdinates) {
                if (coOrdinates.pinLat != null && coOrdinates.pinLong != null) {
                     latCase = coOrdinates.pinLat.toString();
                     longCase = coOrdinates.pinLong.toString();
                   /*  myOptions = {
                        zoom: 10,
                        center: new google.maps.LatLng(lat, long),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                    }; */
                }else if(coOrdinates.pinLat == null && coOrdinates.pinLong == null){
                     latCase = $rootScope.DEFAULT_LATITUDE;
                     longCase = $rootScope.DEFAULT_LONGITUDE;     
                }
            });
        }else {
        latCase = parseFloat($rootScope.DEFAULT_LATITUDE);
        longCase = parseFloat($rootScope.DEFAULT_LONGITUDE);
    }
     if (isNaN(latCase) || isNaN(longCase)) {
        latCase = parseFloat($rootScope.DEFAULT_LATITUDE);
        longCase = parseFloat($rootScope.DEFAULT_LONGITUDE);
    }
            if ($scope.tab == 2 || $scope.tab == 4) {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas1"),
                    myOption(10,new google.maps.LatLng(latCase, longCase))
                );
                geoLocation(locations.map);
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () {};
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById("map_canvas1");
                drawLatestTrCases(data);
            } else if ($scope.tab == 3) {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas2"),
                    myOption(10,new google.maps.LatLng(latCase, longCase))
                );
                geoLocation(locations.map);
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () {};
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById("map_canvas2");
                drawCasesAndNearByAgents(data);
                getAllUsers()
            }
        }

        function infowindowUsers(markerContent, marker) {
            var infowindow = new google.maps.InfoWindow();
            marker.addListener("click", function () {
                clearTimeout(infoTimer);
                if (activeInfo != null) {
                    activeInfo.close();
                }
                infowindow.setContent(markerContent);
                infowindow.open(locations.map, marker);
                activeInfo = infowindow;
                infoTimer = setTimeout(function () {
                    if (activeInfo != null) {
                        activeInfo.close();
                    }
                }, 8000);
            });
        }

        function removeMarkers() {
            for (var i = 0; i < nearbyAgentsMarkers.length; i++) {
                nearbyAgentsMarkers[i].setMap(null);
            }
            nearbyAgentsMarkers = [];
        }

        $("#searchOnMap").change(function () {
            var userSelected = JSON.parse($("#searchOnMap").val());
            var userLatLng = {
                lat: userSelected.path[0].lat,
                lng: userSelected.path[0].lng,
            };
            locations.map.setZoom(15);
            locations.map.setCenter(userLatLng);
        });

        /*function filterTrcases() {
            vm.itemsPerPage = 1000;
            if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
                if ($stateParams.priority == undefined) {

                    TrCaseSearchCustom.query({
                        search : $scope.search,
                        page : pagingParams.page - 1,
                        size : vm.itemsPerPage,
                        sort : sort()
                    }, onSuccess, onError);
                } else {
                    TrCasePrioritySearch.query({
                        searchtext : $scope.search,
                        priority : $stateParams.priority,
                        page : pagingParams.page - 1,
                        size : vm.itemsPerPage,
                        sort : sort()
                    }, onSuccess, onError);
                }
            } else {
                if ($stateParams.priority == undefined) {
                    // OLD API CALL - REPLACED WITH FILTERED API
                    // TrCase.query({
                    //     page : pagingParams.page - 1,
                    //     size : vm.itemsPerPage,
                    //     sort : sort()
                    // }, onSuccess, onError);
                } else {
                    TrCasePriority.query({
                        priority : $stateParams.priority,
                        page : pagingParams.page - 1,
                        size : vm.itemsPerPage,
                        sort : sort()
                    }, onSuccess, onError);
                }
            }
            function sort() {
                var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
                if (vm.predicate !== 'id') {
                    // result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                var myOptions = {
                    zoom : 10,
                    center : new google.maps.LatLng("5.431587","101.128162"),
                    mapTypeId : google.maps.MapTypeId.ROADMAP
                };

                if ($scope.tab == 2) {

                    locations.map = new google.maps.Map(document.getElementById("map_canvas1"), myOptions);
                    locations.overlay = new google.maps.OverlayView();
                    locations.overlay.draw = function() {
                    };
                    locations.overlay.setMap($scope.map);
                    locations.element = document.getElementById('map_canvas1');
                    drawLatestTrCases(data);
                } else if ($scope.tab == 3) {

                    locations.map = new google.maps.Map(document.getElementById("map_canvas2"), myOptions);
                    locations.overlay = new google.maps.OverlayView();
                    locations.overlay.draw = function() {
                    };
                    locations.overlay.setMap($scope.map);
                    locations.element = document.getElementById('map_canvas2');
                    drawCasesAndNearByAgents(data);
                }

            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

        }*/

        /*if ($scope.search === null || $scope.search === "" || angular.isUndefined($scope.search)) {
            loadAll();
        } else {
            if ($scope.tab == 2) {
                filterTrcases();
            	
            }
            if ($scope.tab == 3) {
                TrCaseUser.gettrcasesuser(function(response) {
                    $scope.trcaseuser = response;
                });
                filterTrcases();
            	
            } else if ($scope.tab == 1) {
                vm.itemsPerPage = paginationConstants.itemsPerPage;
                filterTrcaseSearch();
            }
        }*/

        function loadPage(page) {
            vm.page = page;
            // For filtered cases, load data directly without state transition
            if ($scope.search && $scope.search.trim() !== '') {
                loadFilteredCasesWithSearch($scope.search.trim());
            } else {
                loadFilteredCases();
            }
        }
        
        function transition() {
            // For filtered cases, just load data without state transition to preserve filters
            if (filtersInitialized) {
                if ($scope.search && $scope.search.trim() !== '') {
                    loadFilteredCasesWithSearch($scope.search.trim());
                } else {
                    loadFilteredCases();
                }
                return;
            }
            
            // For non-filtered cases, use state transition
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                priority: pagingParams.priority,
                geofenceId : pagingParams.geofenceId,
                login: $stateParams.login,
                fromTime: vm.fromDate,
                toTime: vm.toDate,
                listgeofenceid: vm.selectedListGeofenceId,
                caseStatus: $stateParams.caseStatus,
                rangeOption : vm.dateRange,
                // Preserve filter selections
                selectedPackage: vm.selectedPackageList,
                selectedState: vm.selectedStateList,
                selectedBA: vm.selectedBusinessAreaList,
                selectedOA: vm.selectedOperationalAreaList,
                selectedDistrict: vm.selectedDistrictList,
                selectedBlock: vm.selectedBlockList,
                selectedGP: vm.selectedGPList,
                selectedAMC: vm.selectedAMCStatusList
            })
        }

        $scope.openInfoWindow = function (e, selectedMarker) {
            e.preventDefault();
            google.maps.event.trigger(selectedMarker, "click");
        };

        function drawPolyline(spread, map) {
            var spreadAssetCoordinates = [];
            var spreadColor = 0;
            var spreadWidth = 0;
            var spreadOpacity = 0;

            vm.assetTypes.forEach(function (assetType) {
                if (assetType.name == spread.assetTypeName) {
                    spreadColor = assetType.colorcode;
                    spreadWidth = assetType.lineWidth * 0.05;
                    spreadOpacity = assetType.transparency * 0.01;
                }
            });

            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = null;
               if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spreadColor;
                }
                var polylineWeight = spreadWidth;
                var strokeOpacityVal = spreadOpacity;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var disVal = 0;
                        var cLocations = [];

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }

                                var userContent = document.createElement("div"),
                                    button;
                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' +
                                    "<b>Name : </b> " +
                                    spread.name +
                                    "<br><b>Asset Type : </b> " + spread.assetType.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km</br>";

                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });
                            });
                        }
                        if (infowindow != null) {
                            infowindow.setPosition(event.latLng);
                            infowindow.open(locations.map);
                            openedInfoWindow = infowindow;
                        }
                    }
                );

                var polylinepathDuct = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(locations.map);

                polylines.push(polylinepath);
            }
        }
        

        function drawLatestTrCases(response) {
            if (response) {
                initializeTrcaseMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // function() {
                    var btnDrawLine,brBreak,noAssetsFound,btnDownloadPdf;
                    var entryMarker = []
                    var endMarker = []
                    $.each(response, function (index, value) {
                        var userContent = document.createElement("div"),
                            button;

                        var infoWindow = new google.maps.InfoWindow({
                            content: userContent,
                        });

                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });
                        var infoWindow2 = new google.maps.InfoWindow();
                        // if(value.userCase=='C'){
                        if(value.status=='RESOLVED' || value.status=='CLOSED' || value.status=='CANCELLED'){
                                 startMarker.setIcon(
                                    "content/images/Pointers-L5.png"
                                );
                                startMarker.setZIndex(10);
                        } else {
                            startMarker.setZIndex(11);
                            if (value.priority == "LOW") {
                                startMarker.setIcon(
                                    "content/images/Pointers-L4.png"
                                );
                            } else if (value.priority == "MEDIUM") {
                                startMarker.setIcon(
                                    "content/images/Pointers-M4.png"
                                );
                            } else if (value.priority == "HIGH") {
                                startMarker.setIcon(
                                    "content/images/Pointers-H4.png"
                                );
                            } else if (value.priority == "CRITICAL") {
                                startMarker.setIcon(
                                    "content/images/Pointer-C4.png"
                                );
                            }
                        }

                        userContent.innerHTML =
                            '<div class="infoWindowhead">' +
                            startMarker.title +
                            '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b> Status :</b> " +
                            value.status +                            
                            "</div>";

                        // var span = '<a userId="' + value.geofenceName + '" class="userpath" >Load travelled path</a>';
                        // startMarker.content = '<div class="infoWindowContent"> <b>Incident Id : </b>' + value.id + '<br> <b>Reported By :</b> ' + value.reportedByUser + '<br> <b> Assigned To :</b> ' + value.assignedToUser +
                        //     '<br> <b>Address :</b> ' + value.address + '</div>';

                        button = userContent.appendChild(
                            document.createElement("input")
                        );
                        button.type = "button";
                        button.value = "Incident Details";
                        button.className = "button";

                        google.maps.event.addDomListener(
                            button,
                            "click",
                            function () {
                                $state.go("tr-case-detail", {
                                    id: value.id,
                                });
                            }
                        );
                        $compile(userContent)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "click",
                            function () {
                                // infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + userContent);
                                // infoWindow.open(locations.map, startMarker);
                                TrCaseById.get(value.id, function (response) {

                                     var infoStr = "";
                                    var caseTypeAttributeValuesList =
                                        response.caseTypeAttributeValues;
                                    caseTypeAttributeValuesList.sort(function (a, b) {
                                        var nameA = a.caseTypeAttribute.name.toLowerCase(),
                                            nameB = a.caseTypeAttribute.name.toLowerCase();
                                        if (nameA < nameB)
                                            // sort string ascending
                                            return -1;
                                        if (nameA > nameB) return 1;
                                        return 0; // default return value (no sorting)
                                    });
                                    for (
                                        var i = 0;
                                        i < caseTypeAttributeValuesList.length;
                                        i++
                                    ) {
                                        var home = caseTypeAttributeValuesList[i];
                                        infoStr +=
                                            "<br><b>" +
                                            home.caseTypeAttribute.name +
                                            "</b> : " +
                                            home.attributeValue;
                                    }

                                    userContent.innerHTML =
                                        '<div class="infoWindowhead">' +
                                        response.description +
                                        '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                                        value.id +
                                        "<br><b>Description : </b>" +
                                        response.description +
                                        "<br><b>Incident Type : </b>" +
                                        response.caseType.name +
                                        "<br> <b>Reported By :</b> " +
                                        response.reportedByUser +
                                        "<br> <b> Assigned To :</b> " +
                                        response.assignedToUser +
                                        "<br> <b> Status :</b> " +
                                        response.status +                                        
                                        "<br> " +
                                        infoStr +
                                        "</div>";

                                        // if ($scope.tab == 2) { 
                                        //     brBreak = userContent.appendChild(
                                        //         document.createElement("br")
                                        //     );
    
                                        //     btnDrawLine = userContent.appendChild(
                                        //         document.createElement("button")
                                        //     );
                                        //     btnDrawLine.classList.add("btn");
                                        //     btnDrawLine.classList.add("btn-sm");
                                        //     btnDrawLine.classList.add("btn-primary");
                                        //     // btnDrawLine.textContent = "Nearby Assets";
                                        //     btnDrawLine.style.marginRight = "4px";

                                        //     btnDrawLine.onclick = function () { 
                                        //         for (var i = 0; i < entryMarker.length; i++) {
                                        //             entryMarker[i].setMap(null);
                                        //         }
                                        //         for (var i = 0; i < endMarker.length; i++) {
                                        //             endMarker[i].setMap(null);
                                        //         }

                                        //         var sendLatLng ={lat: response.pinLat,lng:response.pinLong}
                                        //         getNearbyFixed.get(vm.selectedGeofenceId,sendLatLng,function (getLatLng){
                                                    
                                        //         var directionsService = new google.maps.DirectionsService();

                                        //         if(getLatLng.length > 0){
                                        //             var marker = new google.maps.Marker({
                                        //                 icon:  {
                                        //                     path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                        //                     strokeColor: "#808000",
                                        //                     fillColor:'#808000',
                                        //                     fillOpacity:1,
                                        //                     scale: 4,
                                        //                     labelOrigin: new google.maps.Point(-1, 7)
                                        //                 },
                                        //                 map: locations.map,
                                        //                 position: {"lat":response.pinLat,
                                        //                 "lng":response.pinLong},
                                        //                 label: {
                                        //                     text:"Start",
                                        //                     fontSize: '15px',
                                        //                     fontWeight: 'bold'
                                        //                   }
                                        //             });
                                        //             entryMarker.push(marker)
                                        //             marker.setMap(locations.map)
                                        //             infoWindow.close();
                                        //             calculateAndDisplayRoute(directionsService,getLatLng);
                                        //         }else{
                                        //             noAssetsFound = userContent.appendChild(
                                        //                 document.createElement("b")
                                        //             );
                                        //             noAssetsFound.textContent = "No Nearby Assets";
                                        //             noAssetsFound.style.marginRight = "4px";
                                        //             noAssetsFound.style.color = "red"
                                        //             noAssetsFound.style.fontSize = "15px";
                                        //         }
                                        //         })
                                        //     } 


                                        //     if(value.caseTypeName=='Termination Details' || value.caseTypeName=='Splicing Details') {
                                        //         btnDownloadPdf = userContent.appendChild(
                                        //             document.createElement("button")
                                        //         );
                                        //         btnDownloadPdf.classList.add("btn");
                                        //         btnDownloadPdf.classList.add("btn-sm");
                                        //         btnDownloadPdf.classList.add("btn-primary");
                                        //         btnDownloadPdf.textContent = "Download Pdf";
                                        //         btnDownloadPdf.style.marginRight = "4px";
                                        //         btnDownloadPdf.onclick = function () { 
                                        //             downloadPdfMapButton(value.id, value.caseTypeName+"_"+value.id);
                                        //         }
                                        //     }
                                          
                                        //     function calculateAndDisplayRoute(
                                        //         directionsService,
                                        //         getLatLng
                                        //       ) {
                                              
                                        //         for(var i=0;i<getLatLng.length;i++){
                                                    
                                        //            directionsService
                                        //           .route({
                                        //             origin: { lat: response.pinLat,  lng: response.pinLong }, 
                                        //             destination: { lat: getLatLng[i].latitude , lng: getLatLng[i].longitude }, 
                                        //             travelMode: google.maps.TravelMode.WALKING,
                                        //           })
                                        //           .then(function(response)  {
                                        //                 var marker = new google.maps.Marker({
                                        //                     icon: {
                                        //                         path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                                        //                         strokeColor: "#7F00FF ",
                                        //                         fillColor:'#7F00FF ',
                                        //                         fillOpacity:1,
                                        //                         scale: 4,
                                        //                         labelOrigin: new google.maps.Point(1, -7)
                                        //                     },
                                        //                     map: locations.map,
                                        //                     position: { lat: response.request.destination.location.lat() , lng: response.request.destination.location.lng() },
                                        //                     label : {text:response.routes[0].legs[0].distance.value + "m",fontSize: '15px',
                                        //                     fontWeight: 'bold'} 
                                                            
                                        //                 });
                                        //                 endMarker.push(marker)
                                        //                 marker.setMap(locations.map);
                                        //           })
                                        //           .catch(function(e) {console.log("Directions request failed due to " + e)} );
                                        //         }
                                                
                                        //       }
                                        // }  
                                        
                                    infoWindow = new google.maps.InfoWindow({
                                        content: userContent,
                                    });
                                    infoWindow.open(locations.map, startMarker);
                                    // setTimeout(function () {
                                    //     infoWindow.close();
                                    // }, 5000);
                                });
                            }
                        );

                        // }
                        // on mouseout
                        // google.maps.event.addListener(startMarker, 'mouseout', function () {
                        //     infoWindow.close();
                        // });

                        //						var activeInfoWindow;
                        //						// add content to InfoWindow for click event
                        //						infoWindow2.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
                        //
                        //						// add listener on InfoWindow for click event
                        //						google.maps.event.addListener(startMarker, 'click', function() {
                        //
                        //							if (activeInfoWindow != null)
                        //								activeInfoWindow.close();
                        //							// Open InfoWindow - on click
                        //							infoWindow2.open(locations.map, startMarker);
                        //							$(".userpath").click(function() {
                        //								var ele = document.getElementById("userPathModal");
                        //								$(ele).modal('show');
                        //								vm.drawUserPath($(this).attr('userid'));
                        //							});
                        //
                        //							// Store new open InfoWindow in global variable
                        //							activeInfoWindow = infoWindow2;
                        //						});
                        //						resizeTrCaseMap();
                    });
                    // resizeTrCaseMap();
                    // };
                });
            }

            /*
             * function setupTrcaseMap(callback) { var myOptions = { zoom : 10,
             * center : new google.maps.LatLng("5.431587","101.128162"), mapTypeId :
             * google.maps.MapTypeId.ROADMAP }; locations.map = new
             * google.maps.Map(document.getElementById("map_canvas1"),
             * myOptions); locations.overlay = new google.maps.OverlayView();
             * locations.overlay.draw = function() { };
             * locations.overlay.setMap($scope.map); locations.element =
             * document.getElementById('map_canvas1'); callback(); }
             */
        }

        //		function resizeTrCaseMap() {
        //			setTimeout(function() {
        //				google.maps.event.trigger(locations.map, "resize");
        //				locations.map.setCenter(locations.latlng);
        //			}, 1000);
        //		}

        function initializeTrcaseMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        /*
         * function drawCasesA() { drawLatestCases($scope.trcaseuser); }
         */
        function drawCasesAndNearByAgents(response) {
            if (response) {
                initializeMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // setupMap(function() {
                    $.each(response, function (index, value) {
                        var infoWindow = new google.maps.InfoWindow();
                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });

                        var infoWindow2 = new google.maps.InfoWindow();

                        if(value.status=='RESOLVED' || value.status=='CLOSED' || value.status=='CANCELLED'){
                            startMarker.setIcon(
                                "content/images/Pointers-L5.png"
                            );
                            startMarker.setZIndex(10);
                        } else {
                            startMarker.setZIndex(11);
                            if (value.priority == "LOW") {
                                startMarker.setIcon(
                                    "content/images/Pointers-L4.png"
                                );
                            } else if (value.priority == "MEDIUM") {
                                startMarker.setIcon(
                                    "content/images/Pointers-M4.png"
                                );
                            } else if (value.priority == "HIGH") {
                                startMarker.setIcon(
                                    "content/images/Pointers-H4.png"
                                );
                            } else if (value.priority == "CRITICAL") {
                                startMarker.setIcon(
                                    "content/images/Pointer-C4.png"
                                );
                            }
                        }


                        $compile(startMarker.content)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "click",
                            function () {
                                TrCaseById.get(value.id, function (response) {
                                    var userContent = document.createElement(
                                        "div"
                                    );

                                    userContent.innerHTML =
                                        '<div class="infoWindowContent"><b>Incident Id : </b>' +
                                        response.id +
                                        "<br> <b>Description : </b>" +
                                        response.description +
                                        "<br> <b>Reported By :</b> " +
                                        response.reportedByUser +
                                        "<br> <b> Assigned To :</b> " +
                                        response.assignedToUser +
                                        "<br> <b> Status :</b> " +
                                        response.status +                                        
                                        "</div>";

                                    infoWindow2 = new google.maps.InfoWindow({
                                        content: userContent,
                                    });
                                    infoWindow2.open(
                                        locations.map,
                                        startMarker
                                    );
                                    setTimeout(function () {
                                        infoWindow2.close();
                                    }, 5000);
                                });
                            }
                        );

                        // on mouseout
                        google.maps.event.addListener(
                            startMarker,
                            "mouseout",
                            function () {
                                infoWindow.close();
                            }
                        );

                        resizeMap();
                    });
                    // });
                });
            }
            //			drawAgents();
        }

        function drawAgents() {
            var infoWindow = null;
            var markers = [
                {
                    Lat: "0.0",
                    Lng: "0.0",
                    name: "default",
                },
            ];
            TrCaseUser.getAgents(function (response) {
                $.each(response.liveLogs, function (index, value) {
                    infoWindow = new google.maps.InfoWindow();

                    var imgbg = document.createElement("img");
                    imgbg.className = "marker_back_image";

                    if (value.status == "ACTIVE") {
                        imgbg.src = "content/images/greenmarker.png";
                    } else if (value.status == "INACTIVE") {
                        imgbg.src = "content/images/redmarker.png";
                    } else if (value.status == "IDLE") {
                        imgbg.src = "content/images/yellowmarker.png";
                    }

                    function customMarker() {
                        this.latlng = new google.maps.LatLng(
                            value.latitude,
                            value.longitude
                        );
                        this.setMap(locations.map);
                        this.title = value.login;
                        this.icon = imgbg;
                    }
                    var userContent;
                    if (value.userImage != null) {
                        userContent =
                            '<div class="infoWindowhead">' +
                            value.login +
                            '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-4"><img src="data:image/png;base64,' +
                            value.userImage +
                            '" style="width: 50px; height: 60px;"></div><div class="col-md-8"><p>' +
                            value.address +
                            "</p><p>Phone : " +
                            value.phone +
                            "</p><p>Battery :" +
                            value.batteryPercentage +
                            " %</p></div></div></div>";
                    } else {
                        userContent =
                            '<div class="infoWindowhead">' +
                            value.login +
                            '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-4"><img src="content/images/userimg.gif" style="width: 50px; height: 60px;"></div><div class="col-md-8"><p>' +
                            value.address +
                            "</p><p>Phone : " +
                            value.phone +
                            "</p><p>Battery :" +
                            value.batteryPercentage +
                            " %</p></div></div></div>";
                    }
                    var infowindowPopup = new google.maps.InfoWindow({
                        content: userContent,
                        pixelOffset: new google.maps.Size(0, -50),
                    });
                    infowindowPopup.setPosition(
                        new google.maps.LatLng(value.latitude, value.longitude)
                    );

                    customMarker.prototype = new google.maps.OverlayView();
                    customMarker.prototype.draw = function () {
                        var self = this;
                        var div = this.div;

                        if (!div) {
                            div = this.div = document.createElement("div");
                            div.id = "marker";
                            div.style.width = "100px";
                            div.style.height = "100px";

                            var div_pointer = document.createElement("div");
                            div_pointer.className = "triangle";

                            var image_container = document.createElement("div");
                            image_container.className = "image_container";

                            var img = document.createElement("img");
                            img.className = "marker_image";
                            img.src = "data:image/png;base64,";
                            img.src += value.userImage;
                            if (value.userImage == undefined) {
                                img.src = "content/images/userimg.gif";
                            }

                            var name_container = document.createElement("div");
                            name_container.className = "name_container";

                            div.appendChild(image_container);
                            image_container.appendChild(img);
                            image_container.appendChild(imgbg);

                            name_container.onmouseover = function () {
                                name_container.style.opacity = "0.6";
                                div.style.zIndex = "1000";
                            };
                            name_container.onmouseout = function () {
                                name_container.style.opacity = "0";
                                div.style.zIndex = "100";
                            };

                            google.maps.event.addDomListener(
                                imgbg,
                                "click",
                                function (event) {
                                    google.maps.event.trigger(self, "click");
                                    infowindowPopup.open(locations.map);
                                }
                            );

                            var panes = this.getPanes();

                            panes.overlayImage.appendChild(div);
                        }

                        var point = this.getProjection().fromLatLngToDivPixel(
                            this.latlng
                        );

                        if (point) {
                            div.style.left = point.x - 50 + "px";
                            div.style.top = point.y - 125 + "px";
                        }
                    };

                    customMarker.prototype.getPosition = function () {
                        return this.latlng;
                    };
                    markers.forEach(function (marker) {
                        var overlay = new customMarker();
                    });
                });
            });
        }
        $scope.caseLocation = function (selectedCase) {
            $("#caseLocationModal").show();
            var myCenter = new google.maps.LatLng(
                selectedCase.pinLat,
                selectedCase.pinLong
            );
            var ele = document.getElementById("caseLocationModal");
            $(ele).modal("show");

            var map = new google.maps.Map(
                document.getElementById("map_canvas_case_location"),
                {
                    center: myCenter,
                    zoom: 18,
                }
            );

            var markerIcon = "";
            var zIndexVal = 11;
            if(value.status=='RESOLVED' || value.status=='CLOSED' || value.status=='CANCELLED'){
                markerIcon = 'content/images/Pointers-L5.png';
                zIndexVal =10;
            } else {
                if (selectedCase.priority == "LOW") {
                    markerIcon = "content/images/Pointers-L4.png";
                } else if (selectedCase.priority == "MEDIUM") {
                    markerIcon = "content/images/Pointers-M4.png";
                } else if (selectedCase.priority == "HIGH") {
                    markerIcon = "content/images/Pointers-H4.png";
                } else if (selectedCase.priority == "CRITICAL") {
                    markerIcon = "content/images/Pointer-C4.png";
                }
            }

            var markerContent = null;
            if (selectedCase.caseDistance != null) {
                markerContent =
                    '<div class="infoWindowhead">' +
                    "<b>Incident Id : </b>" +
                    selectedCase.id +
                    "<br><b>Description : </b>" +
                    selectedCase.description +
                    "<br> <b>Lat : </b>" +
                    selectedCase.pinLat +
                    "<br> <b>Lng : </b>" +
                    selectedCase.pinLong +
                    "<br><b>Distance (km) : </b>" +
                    selectedCase.caseDistance +
                    "</div>";
            } else {
                markerContent =
                    '<div class="infoWindowhead">' +
                    "<b>Incident Id : </b>" +
                    selectedCase.id +
                    "<br><b>Description : </b>" +
                    selectedCase.description +
                    "<br> <b>Lat : </b>" +
                    selectedCase.pinLat +
                    "<br> <b>Lng : </b>" +
                    selectedCase.pinLong +
                    "</div>";
            }
            var marker = new google.maps.Marker({
                position: myCenter,
                content: markerContent,
                icon: {
                    url: markerIcon,
                    size: new google.maps.Size(70, 86), //marker image size
                    origin: new google.maps.Point(0, 0), // marker origin
                    anchor: new google.maps.Point(35, 86), // X-axis value (35, half of marker width) and 86 is Y-axis value (height of the marker).
                },
                zIndex: zIndexVal
            });

            var infowindow = new google.maps.InfoWindow({
                content: markerContent,
            });
            infowindow.open(map, marker);
            marker.addListener("click", function () {
                // infowindow.open(map, marker);
                TrCaseById.get(selectedCase.id, function (response) {
                    userContent.innerHTML =
                        '<div class="infoWindowhead">' +
                        response.description +
                        '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                        value.id +
                        "<br> <b>Description : </b>" +
                        value.description +
                        "<br> <b>Reported By :</b> " +
                        response.reportedByUser +
                        "<br> <b> Assigned To :</b> " +
                        response.assignedToUser +
                        "<br> <b> Status :</b> " +
                        response.status +
                        "</div>";

                    infoWindow = new google.maps.InfoWindow({
                        content: userContent,
                    });
                    infoWindow.open(locations.map, startMarker);
                    setTimeout(function () {
                        infoWindow.close();
                    }, 5000);
                });
            });
            marker.setMap(map);

            $("#caseLocationModal").on("show.bs.modal", function (event) {
                $("#location-map-case-location").css("width", "100%");
                $("#map_canvas_case_location").css("width", "100%");
            });
        };

        function resizeMap() {
            setTimeout(function () {
                google.maps.event.trigger(locations.map, "resize");
                locations.map.setCenter(locations.latlng);
            }, 1000);
        }
        vm.priorityClass = function(priority){
            if(!priority) return 'priority-default';
            var p = ('' + priority).trim().toLowerCase();
            return 'priority-' + p;
        };

        function initializeMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        $(".select2").select2();

        function assigncasetouser(userId, userLogin) {
            vm.editUserId = userId;
            $scope.edituserLogin = userLogin;
            TrCaseEdit.getalltrcases(function (response) {
                $scope.trallcases = response;
            });
        }
        
        // List View Filters - Initialize filter state variables and arrays
        vm.selectedAMCStatusList = 'ALL';
        vm.selectedPackageList = '';
        vm.selectedStateList = '';
        vm.selectedBusinessAreaList = '';
        vm.selectedOperationalAreaList = '';
        vm.selectedDistrictList = '';
        vm.selectedBlockList = '';
        vm.selectedGPList = '';
        vm.showNewListFilterMode = true;
        vm.showLegacyListFilterMode = false;
        
        // Filter data arrays
        vm.amcStatusListView = [];
        vm.packageListView = [];
        vm.stateListView = [];
        vm.businessAreaListView = [];
        vm.operationalAreaListView = [];
        vm.districtListView = [];
        vm.blockListView = [];
        vm.gpListView = [];
        
        // Filter handler functions
        vm.onAMCStatusChangeList = onAMCStatusChangeList;
        vm.onPackageChangeList = onPackageChangeList;
        vm.onStateChangeList = onStateChangeList;
        vm.onBusinessAreaChangeList = onBusinessAreaChangeList;
        vm.onOperationalAreaChangeList = onOperationalAreaChangeList;
        vm.onDistrictChangeList = onDistrictChangeList;
        vm.onBlockChangeList = onBlockChangeList;
        vm.onGPChangeList = onGPChangeList;
        vm.onSearchInputChange = onSearchInputChange;
        
        // Flag to track if filters are initialized
        var filtersInitialized = false;

        function normalizeFeatureKey(key) {
            return (key || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
        }

        function parseFeatureBool(value) {
            return (value || '').toString().toLowerCase() === 'true';
        }

        function applyListFilterModeConfig(response) {
            var useNewAllFilters = false;
            var useLegacyBlockFilter = false;
            var featureList = [];

            if (Array.isArray(response)) {
                featureList = response;
            } else if (response && response.configKey) {
                featureList = [response];
            }

            featureList.forEach(function (item) {
                var key = normalizeFeatureKey(item && item.configKey);
                var value = parseFeatureBool(item && item.configValue);

                if (!value) {
                    return;
                }

                if (key === 'allfilters' || key === 'newfilters' || key === 'allnewfilters') {
                    useNewAllFilters = true;
                }

                if (key === 'blockfilter' || key === 'legacyblockfilter' || key === 'oldblockfilter') {
                    useLegacyBlockFilter = true;
                }
            });

            if (useNewAllFilters) {
                vm.showNewListFilterMode = true;
                vm.showLegacyListFilterMode = false;
                if (!filtersInitialized) {
                    initializeListViewFilters();
                }
                return;
            }

            if (useLegacyBlockFilter) {
                vm.showNewListFilterMode = false;
                vm.showLegacyListFilterMode = true;
                filterTrcasesOnListView();
                filterTrcaseSearch();
                return;
            }

            vm.showNewListFilterMode = true;
            vm.showLegacyListFilterMode = false;
            if (!filtersInitialized) {
                initializeListViewFilters();
            }
        }

        function loadListFilterModeConfig() {
            Configs.get('Features', function (response) {
                applyListFilterModeConfig(response);
            });
        }
        
        // Helper function to load filtered cases
        function loadFilteredCases() {
            var filterValue = '';
            var amcStatus = vm.selectedAMCStatusList || 'ALL';
            var filterType = 'PACKAGE'; // Default filter type
            
            // Determine filter type based on what's selected (most specific to least specific)
            if (vm.selectedGPList) {
                filterType = 'GP';
                filterValue = vm.selectedGPList;
            } else if (vm.selectedBlockList) {
                filterType = 'MINI';
                filterValue = vm.selectedBlockList;
            } else if (vm.selectedDistrictList) {
                filterType = 'MASTER';
                filterValue = vm.selectedDistrictList;
            } else if (vm.selectedOperationalAreaList) {
                filterType = 'OA';
                filterValue = vm.selectedOperationalAreaList;
            } else if (vm.selectedBusinessAreaList) {
                filterType = 'BA';
                filterValue = vm.selectedBusinessAreaList;
            } else if (vm.selectedStateList) {
                filterType = 'STATE';
                filterValue = vm.selectedStateList;
            } else if (vm.selectedPackageList) {
                filterType = 'PACKAGE';
                filterValue = vm.selectedPackageList;
            }
            // If no filter is selected, filterValue will be empty string and API will return all cases
            
            var page = (vm.page - 1) || 0;
            var size = vm.itemsPerPage;
            var sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            
            TrCaseFiltered.getByFilters(filterValue, amcStatus, filterType, page, size, sort, function(data, headers) {
                if (data && Array.isArray(data)) {
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.trCases = data;
                } else {
                    vm.trCases = [];
                    vm.totalItems = 0;
                    vm.queryCount = 0;
                }
            });
        }
        
        // List View Filter Functions
        function initializeListViewFilters() {
            if (filtersInitialized) {
                return;
            }

            // Restore filter values from localStorage if available
            var savedFilters = localStorage.getItem('trCaseFilters');
            if (savedFilters) {
                try {
                    var filters = JSON.parse(savedFilters);
                    vm.selectedAMCStatusList = filters.selectedAMC || 'ALL';
                    vm.selectedPackageList = filters.selectedPackage || '';
                    vm.selectedStateList = filters.selectedState || '';
                    vm.selectedBusinessAreaList = filters.selectedBA || '';
                    vm.selectedOperationalAreaList = filters.selectedOA || '';
                    vm.selectedDistrictList = filters.selectedDistrict || '';
                    vm.selectedBlockList = filters.selectedBlock || '';
                    vm.selectedGPList = filters.selectedGP || '';
                } catch (e) {
                    // If parsing fails, use defaults
                    vm.selectedAMCStatusList = 'ALL';
                }
            } else {
                vm.selectedAMCStatusList = 'ALL';
            }
            
            // Load initial AMC Status list with ALL option
            vm.amcStatusListView = [
                { id: 'ALL', name: 'ALL' },
                { id: 'AMC', name: 'AMC' },
                { id: 'NON-AMC', name: 'NON-AMC' }
            ];
            
            // Load initial package list
            if (typeof getIncidentData.getPackages === 'function') {
                getIncidentData.getPackages(function (response) {
                    if (response.data && response.data.length > 0) {
                        vm.packageListView = response.data.map(function(packageName) {
                            return {
                                id: packageName,
                                name: packageName
                            };
                        });
                        
                        // If no package selected from URL, set first package as default
                        if (!vm.selectedPackageList && vm.packageListView.length > 0) {
                            vm.selectedPackageList = vm.packageListView[0].id;
                        }
                        
                        // If package is selected, load/restore the filter hierarchy
                        if (vm.selectedPackageList) {
                            restoreFilterHierarchy(function() {
                                // Mark filters as initialized and load data
                                filtersInitialized = true;
                                loadFilteredCases();
                            });
                        }
                    } else {
                        vm.packageListView = [];
                        filtersInitialized = true;
                    }
                });
            }
        }
        
        // Helper function to save current filter selections to localStorage
        function saveFiltersToLocalStorage() {
            var filters = {
                selectedAMC: vm.selectedAMCStatusList,
                selectedPackage: vm.selectedPackageList,
                selectedState: vm.selectedStateList,
                selectedBA: vm.selectedBusinessAreaList,
                selectedOA: vm.selectedOperationalAreaList,
                selectedDistrict: vm.selectedDistrictList,
                selectedBlock: vm.selectedBlockList,
                selectedGP: vm.selectedGPList
            };
            localStorage.setItem('trCaseFilters', JSON.stringify(filters));
        }
        
        // Helper function to restore filter hierarchy from saved selections
        function restoreFilterHierarchy(callback) {
            // Load states for selected package
            loadStatesForPackage(vm.selectedPackageList, function() {
                if (!vm.selectedStateList) {
                    // No state selected, we're done
                    if (callback) callback();
                    return;
                }
                
                // State is selected, load business areas
                getIncidentData.getBusinessArea(vm.selectedStateList, vm.selectedPackageList, function (response) {
                    if (response.data && response.data.baList) {
                        vm.businessAreaListView = response.data.baList || [];
                    }
                    
                    if (!vm.selectedBusinessAreaList) {
                        if (callback) callback();
                        return;
                    }
                    
                    // BA is selected, load operational areas
                    getIncidentData.getOperationalArea(vm.selectedBusinessAreaList, function (response) {
                        vm.operationalAreaListView = response.data || [];
                        
                        if (!vm.selectedOperationalAreaList) {
                            if (callback) callback();
                            return;
                        }
                        
                        // OA is selected, load districts
                        getIncidentData.getDistrict(vm.selectedOperationalAreaList, function (response) {
                            vm.districtListView = response.data || response || [];
                            
                            if (!vm.selectedDistrictList) {
                                if (callback) callback();
                                return;
                            }
                            
                            // District is selected, load blocks
                            getIncidentData.getBlocks(vm.selectedDistrictList, function (response) {
                                vm.blockListView = response.data || response || [];
                                
                                if (!vm.selectedBlockList) {
                                    if (callback) callback();
                                    return;
                                }
                                
                                // Block is selected, load GPs
                                var amcStatus = vm.selectedAMCStatusList || 'ALL';
                                getIncidentData.getGPListByBlock(vm.selectedBlockList, amcStatus, function (response) {
                                    if (response && response.data && Array.isArray(response.data)) {
                                        vm.gpListView = response.data.map(function(gp) {
                                            return {
                                                id: gp.id,
                                                name: gp.name
                                            };
                                        });
                                    }
                                    if (callback) callback();
                                });
                            });
                        });
                    });
                });
            });
        }
        
        // Helper function to load states without triggering transition (for initialization)
        function loadStatesForPackage(packageId, callback) {
            if (packageId) {
                getIncidentData.getStatesByPackage(packageId, function (response) {
                    if (response.data && response.data.length > 0) {
                        vm.stateListView = response.data.map(function(stateName) {
                            return {
                                id: stateName,
                                name: stateName
                            };
                        });
                    } else {
                        vm.stateListView = [];
                    }
                    vm.selectedStateList = '';
                    vm.selectedBusinessAreaList = '';
                    vm.businessAreaListView = [];
                    vm.selectedOperationalAreaList = '';
                    vm.operationalAreaListView = [];
                    vm.selectedDistrictList = '';
                    vm.districtListView = [];
                    vm.selectedBlockList = '';
                    vm.blockListView = [];
                    vm.selectedGPList = '';
                    vm.gpListView = [];
                    if (callback) callback();
                });
            } else {
                vm.stateListView = [];
                vm.selectedStateList = '';
                if (callback) callback();
            }
        }
        
        function onAMCStatusChangeList(amcStatus) {
            // AMC Status filter changed - save to localStorage, reset to page 1 and reload
            saveFiltersToLocalStorage();
            vm.page = 1;
            loadFilteredCases();
        }
        
        // Helper function to load data after filter change - checks if search is active
        function loadDataAfterFilterChange() {
            // If search text is present, trigger search with new filters
            if ($scope.search && $scope.search.trim() !== '') {
                filterTrcaseSearch();
            } else {
                // Otherwise just load filtered data
                loadFilteredCases();
            }
        }

        function onSearchInputChange() {
            if (!$scope.search || $scope.search.trim() === '') {
                vm.page = 1;
                loadDataAfterFilterChange();
            }
        }

        function onPackageChangeList(packageId) {
            // Load states when package changes
            if (packageId) {
                getIncidentData.getStatesByPackage(packageId, function (response) {
                    if (response.data && response.data.length > 0) {
                        vm.stateListView = response.data.map(function(stateName) {
                            return {
                                id: stateName,
                                name: stateName
                            };
                        });
                    } else {
                        vm.stateListView = [];
                    }
                    vm.selectedStateList = '';
                    vm.selectedBusinessAreaList = '';
                    vm.businessAreaListView = [];
                    vm.selectedOperationalAreaList = '';
                    vm.operationalAreaListView = [];
                    vm.selectedDistrictList = '';
                    vm.districtListView = [];
                    vm.selectedBlockList = '';
                    vm.blockListView = [];
                    vm.selectedGPList = '';
                    vm.gpListView = [];
                    // Save to localStorage, reset to page 1 and load data after filters are updated
                    saveFiltersToLocalStorage();
                    vm.page = 1;
                    loadDataAfterFilterChange();
                });
            } else {
                vm.stateListView = [];
                vm.selectedStateList = '';
                saveFiltersToLocalStorage();
                vm.page = 1;
                loadDataAfterFilterChange();
            }
        }
        
        function onStateChangeList(stateId) {
            // Load business areas when state changes
            if (stateId && vm.selectedPackageList) {
                getIncidentData.getBusinessArea(stateId, vm.selectedPackageList, function (response) {
                    if (response.data && response.data.baList) {
                        vm.businessAreaListView = response.data.baList || [];
                    } else {
                        vm.businessAreaListView = [];
                    }
                    vm.selectedBusinessAreaList = '';
                    vm.selectedOperationalAreaList = '';
                    vm.operationalAreaListView = [];
                    vm.selectedDistrictList = '';
                    vm.districtListView = [];
                    vm.selectedBlockList = '';
                    vm.blockListView = [];
                    vm.selectedGPList = '';
                    vm.gpListView = [];
                    // Save to localStorage, reset to page 1 and load data after filters are updated
                    saveFiltersToLocalStorage();
                    vm.page = 1;
                    loadDataAfterFilterChange();
                });
            } else {
                vm.businessAreaListView = [];
                vm.selectedBusinessAreaList = '';
                saveFiltersToLocalStorage();
                vm.page = 1;
                loadDataAfterFilterChange();
            }
        }
        
        function onBusinessAreaChangeList(businessAreaId) {
            // Load operational areas when BA changes
            if (businessAreaId) {
                getIncidentData.getOperationalArea(businessAreaId, function (response) {
                    vm.operationalAreaListView = response.data || [];
                    vm.selectedOperationalAreaList = '';
                    vm.selectedDistrictList = '';
                    vm.districtListView = [];
                    vm.selectedBlockList = '';
                    vm.blockListView = [];
                    vm.selectedGPList = '';
                    vm.gpListView = [];
                    // Save to localStorage, reset to page 1 and load data after filters are updated
                    saveFiltersToLocalStorage();
                    vm.page = 1;
                    loadDataAfterFilterChange();
                });
            } else {
                vm.operationalAreaListView = [];
                vm.selectedOperationalAreaList = '';
                saveFiltersToLocalStorage();
                vm.page = 1;
                loadDataAfterFilterChange();
            }
        }
        
        function onOperationalAreaChangeList(operationalAreaId) {
            // Load districts when OA changes
            if (operationalAreaId) {
                getIncidentData.getDistrict(operationalAreaId, function (response) {
                    vm.districtListView = response.data || response || [];
                    vm.selectedDistrictList = '';
                    vm.selectedBlockList = '';
                    vm.blockListView = [];
                    vm.selectedGPList = '';
                    vm.gpListView = [];
                    // Save to localStorage, reset to page 1 and load data after filters are updated
                    saveFiltersToLocalStorage();
                    vm.page = 1;
                    loadDataAfterFilterChange();
                });
            } else {
                vm.districtListView = [];
                vm.selectedDistrictList = '';
                saveFiltersToLocalStorage();
                vm.page = 1;
                loadDataAfterFilterChange();
            }
        }
        
        function onDistrictChangeList(districtId) {
            // Load blocks when district changes
            if (districtId) {
                getIncidentData.getBlocks(districtId, function (response) {
                    vm.blockListView = response.data || response || [];
                    vm.selectedBlockList = '';
                    vm.selectedGPList = '';
                    vm.gpListView = [];
                    // Save to localStorage, reset to page 1 and load data after filters are updated
                    saveFiltersToLocalStorage();
                    vm.page = 1;
                    loadDataAfterFilterChange();
                });
            } else {
                vm.blockListView = [];
                vm.selectedBlockList = '';
                saveFiltersToLocalStorage();
                vm.page = 1;
                loadDataAfterFilterChange();
            }
        }
        
        function onBlockChangeList(blockId) {
            // Load GPs when block changes
            if (blockId) {
                var amcStatus = vm.selectedAMCStatusList || 'ALL';
                getIncidentData.getGPListByBlock(blockId, amcStatus, function (response) {
                    if (response && response.data && Array.isArray(response.data)) {
                        vm.gpListView = response.data.map(function(gp) {
                            return {
                                id: gp.id,
                                name: gp.name
                            };
                        });
                    } else {
                        vm.gpListView = [];
                    }
                    vm.selectedGPList = '';
                    // Save to localStorage, reset to page 1 and load data after filters are updated
                    saveFiltersToLocalStorage();
                    vm.page = 1;
                    loadDataAfterFilterChange();
                });
            } else {
                vm.gpListView = [];
                vm.selectedGPList = '';
                saveFiltersToLocalStorage();
                vm.page = 1;
                loadDataAfterFilterChange();
            }
        }
        
        function onGPChangeList(gpId) {
            // GP filter selected - save to localStorage, reset to page 1 and reload
            saveFiltersToLocalStorage();
            vm.page = 1;
            loadDataAfterFilterChange();
        }
        
        vm.success = null;
        vm.error = null;

        function editcase() {
            var data = {
                userId: vm.editUserId,
                caseId: vm.seachCaseId,
            };

            /*
             * TrCaseEdit.edittrcase(data, function(response){
             * $scope.edittrcaseresponse=response; vm.success = 'OK';
             *
             * });
             */
            TrCaseEdit.edittrcase(data, function (response, headers) {
                if (response.status == 200) {
                    vm.error = null;
                    vm.success = "OK";
                }
                if (response.status == 400) {
                    vm.success = null;
                    vm.error = "No case found with this case id";
                }
            });
            $timeout(function () {
                $("#assigncaseModal").modal("hide");
                vm.success = null;
                vm.error = null;
                vm.seachCaseId = null;
                vm.caseIds = null;
            }, 2000);
        }
    }



    var uniqueItems = function (data, key) {
        var result = [];

        for (var i = 0; i < data.length; i++) {
            var value = data[i][key];

            if (result.indexOf(value) == -1) {
                result.push(value);
            }
        }
        return result;


        
    };
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').controller('ShowHideCaseController', ShowHideCaseController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	ShowHideCaseController.$inject = ['$scope', '$sce', '$state', 'ShowCaseById', 'HideCaseById'];

	function ShowHideCaseController($scope, $sce, $state, ShowCaseById, HideCaseById) {
		var vm = this;
		vm.showCase = showCase;
		vm.hideCase = hideCase;
		vm.status = 0;

		function showCase() {
			vm.status = 0;
			var caseId = parseInt(vm.caseId);
			if(caseId > 0){
				ShowCaseById.update(caseId, function(response) {
					if(response == 200){
						vm.status = 200;
					}else{
						vm.status = 400;
					}
				});
			}else{
				alert("Please Enter Valid Incident ID");
			}
		}

		function hideCase() {
			vm.status = 0;
			var caseId = parseInt(vm.caseId);
			if(caseId > 0){
				HideCaseById.update(caseId, function(response) {
					if(response == 200){
						vm.status = 200;
					}else{
						vm.status = 400;
					}
				});
			}else{
				alert("Please Enter Valid Incident ID");
			}
		}
	}
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TerrainTypeDialogController", TerrainTypeDialogController);

    TerrainTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "TerrainType",
        "User",
        "TerrainTypeSearch",
        "AllCustomTerrainTypeAttribute",
    ];


    function TerrainTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        TerrainType,
        User,
        TerrainTypeSearch,
        AllCustomTerrainTypeAttribute
    ) {
        var vm = this;
        //terraintype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.terrainType = entity;
        vm.terrainTypeImageName = terrainTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customTerrainTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");



        vm.checkNumber;





        function terrainTypeImageName(image) {
            vm.terrainType.image = image;
        }


        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomTerrainTypeAttribute.getAll(function (response) {
                vm.customTerrainTypeAttributes = response;
                console.log(vm.customTerrainTypeAttributes)
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customTerrainTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, defaultValue: "" }];

        if (
            vm.terrainType.terrainTypeAttribute != null &&
            vm.terrainType.terrainTypeAttribute.length != 0
        ) {
            vm.items = vm.terrainType.terrainTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.terrainCategory == null) {
                value.terrainCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.terrainType.id !== null) {
                vm.terrainType.terrainTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.terrainType.terrainTypeAttribute.push({
                        terrainCategory: vm.items[i].terrainCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        defaultValue: vm.items[i].defaultValue,
                        terrainTypeAttribOrder: vm.items[i].terrainTypeAttribOrder
                    });
                }
                TerrainType.update(vm.terrainType, onSaveSuccess, onSaveError);
            } else {
                vm.terrainType.terrainTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.terrainType.terrainTypeAttribute.push({
                        terrainCategory: vm.items[i].terrainCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        defaultValue: vm.items[i].defaultValue,
                        terrainTypeAttribOrder: vm.items[i].terrainTypeAttribOrder
                    });
                }
                TerrainType.save(vm.terrainType, onSaveSuccess, onSaveError);
            }
        }

        $("#terrainTypeImage").change(function () {
            var filesSelected = document.getElementById("terrainTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.terrainType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:terrainTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("terrain-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {


            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index + 1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });

        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);


        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.colorcode = function (color) {
            vm.terrainType.colorcode = color;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TerrainTypeDetailController', TerrainTypeDetailController);

    TerrainTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TerrainType', 'User'];

    function TerrainTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TerrainType, User) {
        var vm = this;

        vm.terrainType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:terrainTypeUpdate', function (event, result) {
            vm.terrainType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TerrainTypeDeleteController', TerrainTypeDeleteController);

    TerrainTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TerrainType'];

    function TerrainTypeDeleteController($uibModalInstance, entity, TerrainType) {
        var vm = this;

        vm.terrainType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            TerrainType.delete({ id: id },
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('terrain-type', {
            parent: 'entity',
            url: '/terrain-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.terrainType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/terrain-type/terrain-types.html',
                    controller: 'TerrainTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('terrainType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('terrain-type-detail', {
            parent: 'terrain-type',
            url: '/terrain-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.terrainType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/terrain-type/terrain-type-detail.html',
                    controller: 'TerrainTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('terrainType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TerrainType', function($stateParams, TerrainType) {
                    return TerrainType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'terrain-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('terrain-type.new', {
            parent: 'terrain-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/terrain-type/terrain-type-dialog.html',
                    controller: 'TerrainTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('terrain-type.edit', {
            parent: 'terrain-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.terrainType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/terrain-type/terrain-type-dialog.html',
                    controller: 'TerrainTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('terrainType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TerrainType', function($stateParams, TerrainType) {
                    return TerrainType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'terrain-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('terrain-type.delete', {
            parent: 'terrain-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/terrain-type/terrain-type-delete-dialog.html',
                    controller: 'TerrainTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['TerrainType', function(TerrainType) {
                            return TerrainType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('terrain-type', null, { reload: 'terrain-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('TerrainType', TerrainType);

    TerrainType.$inject = ['$resource', 'DateUtils'];

    function TerrainType ($resource, DateUtils) {
        var resourceUrl =  'api/terrain-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TerrainTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getterraintypebyname = function (data,callback){
		$http.get('api/terrain-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TerrainTypeSearch', TerrainTypeSearch);

    TerrainTypeSearch.$inject = ['$resource'];

    function TerrainTypeSearch ($resource) {
        var service = $resource('/api/terrain-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomTerrainTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-terrain-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TerrainTypeController', TerrainTypeController);

    TerrainTypeController.$inject = ['$scope', '$state', 'TerrainType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','TerrainTypeSearch'];

    function TerrainTypeController ($scope, $state, TerrainType, ParseLinks, AlertService, pagingParams, paginationConstants,TerrainTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			TerrainTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.terrainTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            TerrainType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.terrainTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TenantDialogController', TenantDialogController);

    TenantDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity','$state', 'Tenant'];

    function TenantDialogController ($timeout, $scope, $stateParams, entity, $state, Tenant) {
    	$scope.EMAIL_REGEXP =/^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
        $scope.PHONE_REGEXP =/^[0-9]+$/;
        var vm = this;

        vm.tenant = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tenant.id !== null) {
                Tenant.update(vm.tenant, onSaveSuccess, onSaveError);
            } else {
                Tenant.save(vm.tenant, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:tenantUpdate', result);
            vm.isSaving = false;
            $state.go('tenant');
         }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TenantDetailController', TenantDetailController);

    TenantDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tenant'];

    function TenantDetailController($scope, $rootScope, $stateParams, previousState, entity, Tenant) {
        var vm = this;

        vm.tenant = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:tenantUpdate', function(event, result) {
            vm.tenant = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TenantDeleteController',TenantDeleteController);

    TenantDeleteController.$inject = [ 'entity', 'Tenant'];

    function TenantDeleteController( entity, Tenant) {
        var vm = this;

        vm.tenant = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
          //  $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tenant.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
       /* .state('tenant', {
            parent: 'entity',
            url: '/tenant?page&sort&search',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tenant/tenants.html',
                    controller: 'TenantController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })*/
        .state('tenant', {
            parent: 'entity',
            url: '/tenant?page&sort$search',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tenant/tenants.html',
                    controller: 'TenantController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }]

            }       
			})
        
        
        
        
        
        /*.state('tenant-detail', {
            parent: 'entity',
            url: '/tenant/{id}',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tenant/tenant-detail.html',
                    controller: 'TenantDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tenant', function($stateParams, Tenant) {
                    return Tenant.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tenant',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })*/
		.state('tenant-detail', {
            parent: 'entity',
            url: '/tenant/{id}',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tenant/tenant-detail.html',
                    controller: 'TenantDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tenant', function($stateParams, Tenant) {
                    return Tenant.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tenant',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
			
			
			
			
			
        /*.state('tenant-detail.edit', {
            parent: 'tenant-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tenant', function(Tenant) {
                            return Tenant.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        .state('tenant-detail.edit', {
            parent: 'tenant-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenant.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tenant', function($stateParams, Tenant) {
                    return Tenant.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tenant',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        
        
       /* .state('tenant.new', {
            parent: 'tenant',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                organization: null,
                                loginName: null,
                                email: null,
                                phone: null,
                                city: null,
                                address: null,
                                createdDate: null,
                                updatedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tenant', null, { reload: 'tenant' });
                }, function() {
                    $state.go('tenant');
                });
            }]
        })*/
        .state('tenant.new', {
            parent: 'tenant',
            url: '/new',
            data: {
            	 authorities: ['ROLE_SUPER_ADMIN']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm'
				}
			},
			 resolve: {
                        entity: function () {
                            return {
                            	 organization: null,
                                 loginName: null,
                                 email: null,
                                 phone: null,
                                 city: null,
                                 address: null,
                                 createdDate: null,
                                 updatedDate: null,
                                 id: null
                            };
                        }
                    }
            
        })
        
        
       /*.state('tenant.edit', {
            parent: 'tenant',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tenant', function(Tenant) {
                            return Tenant.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tenant', null, { reload: 'tenant' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        .state('tenant.edit', {
            parent: 'tenant',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'trakeyeApp.tenat.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/tenant/tenant-dialog.html',
                    controller: 'TenantDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tenant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tenant', function($stateParams, Tenant) {
                    return Tenant.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tenant',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('tenant.delete', {
            parent: 'tenant',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tenant/tenant-delete-dialog.html',
                    controller: 'TenantDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tenant', function(Tenant) {
                            return Tenant.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tenant', null, { reload: 'tenant' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('Tenant', Tenant);

    Tenant.$inject = ['$resource'];

    function Tenant ($resource) {
        var resourceUrl =  'api/tenants/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TenantSearch', TenantSearch);

    TenantSearch.$inject = ['$resource'];

    function TenantSearch ($resource) {
        var service = $resource('/api/tenants/searchvalue/:searchvalue',{searchvalue:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllTenant', AllTenant);

    AllTenant.$inject = ['$resource'];

    function AllTenant($resource) {
        var service = $resource('/api/all-tenants', {}, {
            'getAll': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TenantController', TenantController);

    TenantController.$inject = ['$scope', '$state', 'Tenant', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TenantSearch'];

    function TenantController ($scope, $state, Tenant, ParseLinks, AlertService, pagingParams, paginationConstants, TenantSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;
        
        function filterSearch(){
			if(vm.search!=null && vm.search!="" && !angular.isUndefined(vm.search)){
			TenantSearch.query({searchvalue:vm.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tenants = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}

        loadAll();

        function loadAll () {
            Tenant.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tenants = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TaskTypeDialogController", TaskTypeDialogController);

    TaskTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "TaskType",
        "User",
        "TaskTypeSearch",
        "AllCustomTaskTypeAttribute",
        "Configs"
    ];

    
    function TaskTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        TaskType,
        User,
        TaskTypeSearch,
        AllCustomTaskTypeAttribute,
        Configs
    ) {
        var vm = this;
        //tasktype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.taskType = entity;
        vm.taskTypeImageName = taskTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customTaskTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");
        vm.checkNumber;
        $(".select2").select2()

        vm.storeConfig = {}
		
        config("ROLLOUT_TASK_CATEGORY")
        config("ROLLOUT_TASK_STAGE")
		
        function config(catName){
            Configs.get(catName, function (response) {
                if(response.length){
                    vm.storeConfig[catName] = [];
                    response.forEach(function (item){
                        vm.storeConfig[catName].push({key:item.configKey, value:item.configValue});
                    })  
                }
            });
        }

        function taskTypeImageName(image) {
            vm.taskType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomTaskTypeAttribute.getAll(function (response) {
                vm.customTaskTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customTaskTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.taskType.taskTypeAttribute != null &&
            vm.taskType.taskTypeAttribute.length != 0
        ) {
            vm.items = vm.taskType.taskTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.taskCategory == null) {
                value.taskCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.taskType.id !== null) {
                vm.taskType.taskTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.taskType.taskTypeAttribute.push({
                        taskCategory: vm.items[i].taskCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        taskTypeAttribOrder: vm.items[i].taskTypeAttribOrder
                    });
                }
                TaskType.update(vm.taskType, onSaveSuccess, onSaveError);
            } else {
                vm.taskType.taskTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.taskType.taskTypeAttribute.push({
                        taskCategory: vm.items[i].taskCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        taskTypeAttribOrder: vm.items[i].taskTypeAttribOrder
                    });
                }
                TaskType.save(vm.taskType, onSaveSuccess, onSaveError);
            }
        }

        $("#taskTypeImage").change(function () {
            var filesSelected = document.getElementById("taskTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.taskType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:taskTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("task-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TaskTypeDetailController', TaskTypeDetailController);

    TaskTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TaskType', 'User'];

    function TaskTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TaskType, User) {
        var vm = this;

        vm.taskType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:taskTypeUpdate', function(event, result) {
            vm.taskType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TaskTypeDeleteController',TaskTypeDeleteController);

    TaskTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaskType'];

    function TaskTypeDeleteController($uibModalInstance, entity, TaskType) {
        var vm = this;

        vm.taskType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TaskType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-type', {
            parent: 'entity',
            url: '/task-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.taskType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-type/task-types.html',
                    controller: 'TaskTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-type-detail', {
            parent: 'task-type',
            url: '/task-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.taskType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-type/task-type-detail.html',
                    controller: 'TaskTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaskType', function($stateParams, TaskType) {
                    return TaskType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'task-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('task-type.new', {
            parent: 'task-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/task-type/task-type-dialog.html',
                    controller: 'TaskTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('task-type.edit', {
            parent: 'task-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.taskType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-type/task-type-dialog.html',
                    controller: 'TaskTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaskType', function($stateParams, TaskType) {
                    return TaskType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'task-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('task-type.delete', {
            parent: 'task-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-type/task-type-delete-dialog.html',
                    controller: 'TaskTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['TaskType', function(TaskType) {
                            return TaskType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task-type', null, { reload: 'task-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('TaskType', TaskType);

    TaskType.$inject = ['$resource', 'DateUtils'];

    function TaskType ($resource, DateUtils) {
        var resourceUrl =  'api/task-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TaskTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.gettasktypebyname = function (data,callback){
		$http.get('api/task-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TaskTypeSearch', TaskTypeSearch);

    TaskTypeSearch.$inject = ['$resource'];

    function TaskTypeSearch ($resource) {
        var service = $resource('/api/task-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomTaskTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-task-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TaskTypeController', TaskTypeController);

    TaskTypeController.$inject = ['$scope', '$state', 'TaskType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','TaskTypeSearch'];

    function TaskTypeController ($scope, $state, TaskType, ParseLinks, AlertService, pagingParams, paginationConstants,TaskTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			TaskTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taskTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            TaskType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taskTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TaskLogDialogController", TaskLogDialogController);

    TaskLogDialogController.$inject = ['section', 'task', 'UserAccount', 'TaskLog', '$timeout', '$state', 'AlertService', '$scope', 'taskLog', 'pagingParams', 'TrMaterial', 'ParseLinks', 'TrResource', 'TaskPathById', '$window', 'str', '$rootScope', 'Inventory', 'AllLogTypes'
    ];

    function TaskLogDialogController(section, task, UserAccount, TaskLog, $timeout, $state, AlertService, $scope, taskLog, pagingParams, TrMaterial, ParseLinks, TrResource, TaskPathById, $window, str, $rootScope, Inventory, AllLogTypes
    ) {
        var vm = this;
        vm.taskLogs = taskLog;
        var entity_old = angular.copy(vm.taskLogs);
        vm.taskLogs.taskLogType = str
        if (vm.taskLogs.taskLogType == 'PROGRESS') {
            vm.labelLog = "Daily Task Log"
        } else if (vm.taskLogs.taskLogType == 'OBSTACLE') {
            vm.labelLog = "Obstacle Log"
        }
        var coordinateList = []
        var chainageList = []
        var markerList = []
        var iconSize = 20
        var markersSection = []
        var markerstasks = []
        vm.logType = taskLog.logType;

        vm.selectAttributes = selectedLogTypeAttributes;

        var infowindow = new google.maps.InfoWindow();
        var openedInfoWindow = null;
        var btnAddSection;
        //vm.routeName = route
        /* vm.isEnableStep = false
        if(entity && entity.section){
            vm.isEnableStep = true
        } */

        vm.transactionType = ["PLANNED", "REQUESTED", "RECEIVED", "UTILIZED", "RECONCILED"]
        var today = new Date();
        today.setHours(23, 59, 59);
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.options = {
            maxDate: today
        };


        /*  var todayFormatted = today.toISOString().split("T")[0];
         document.getElementById("dateInput").max = todayFormatted; */

        var locations = {};
        var markers = [];
        var center = {
            lat: parseFloat($rootScope.DEFAULT_LATITUDE),
            lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
        };
        locations.map = new google.maps.Map(
            document.getElementById("map_canvasStart"),
            myOption($rootScope.rolloutMapInitZoom, center)
        );
        geoLocation(locations.map);

        google.maps.event.addListener(locations.map, "click", function (event) {
            if (markers.length < 2) {
                // Add a marker to the map
                addMarker(event.latLng);
            } else {
                console.log("Maximum 2 markers allowed.");
            }
        });

        $scope.tab = 1;
        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
        }

        UserAccount.get(function (data) {
            vm.taskLogs.userId = data.id;
        });

        AllLogTypes.getAll(function (response) {
            vm.logTypes = response;
        });

        if (vm.taskLogs.id) {
            vm.taskLogs.task = { id: vm.taskLogs.task.id };

        } else if (!vm.taskLogs.id) {
            vm.taskLogs.task = { id: parseInt(task.id) };

        }

        if (vm.taskLogs.id) {
            vm.taskLogs.workDate = new Date(vm.taskLogs.workDate);
        }

        function epoch(date) {
            return Date.parse(date)
        }

        function selectedLogTypeAttributes() {
            vm.showFilter = true;
            if (vm.logType) {
                vm.taskLogs.logType = vm.logType;
                if (
                    entity_old.logType &&
                    vm.logType.id === entity_old.logType.id
                ) {
                    vm.taskLogs.logTypeAttributeValues = [];
                    vm.taskLogs.logTypeAttributeValues =
                        entity_old.logTypeAttributeValues;
                } else {
                    vm.taskLogs.logTypeAttributeValues = [];
                    $.each(
                        vm.logType.logTypeAttribute,
                        function (key, value) {
                            vm.taskLogs.logTypeAttributeValues.push({
                                logTypeAttribute:
                                    vm.logType.logTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        }

        vm.save = function () {
            vm.taskLogs.approvedByUserId = parseInt(vm.taskLogs.approvedByUserId)
            vm.taskLogs.workDate = epoch(vm.taskLogs.workDate)

            if (markers.length == 2) {
                markers.forEach(function (item) {
                    if (item.label.text == "from") {
                        if (vm.taskLogs.id) {
                            vm.taskLogs.fromRoutePoint.latitude = item.position.lat()
                            vm.taskLogs.fromRoutePoint.longitude = item.position.lng()
                        } else {
                            vm.taskLogs.fromRoutePoint = {
                                "latitude": item.position.lat(), "longitude": item.position.lng()
                            };
                        }

                    } else if (item.label.text == "to") {
                        if (vm.taskLogs.id) {
                            vm.taskLogs.toRoutePoint.latitude = item.position.lat()
                            vm.taskLogs.toRoutePoint.longitude = item.position.lng()
                        } else {
                            vm.taskLogs.toRoutePoint = {
                                "latitude": item.position.lat(), "longitude": item.position.lng()
                            };
                        }


                    }
                })
                callTaskLog()
            } else {
                alert("Points are Empty");
            }


            /*
                        TaskLog.postResorceTxn(
                            vm.taskLogsResource,
                            function () {
                            },
                            function () {}
                        ); */



        };


        $scope.toggle = function (id) {
            switch (id) {

                case "material":
                    vm.showMaterial = !vm.showMaterial;


                    break;

                case "resource":
                    vm.showResource = !vm.showResource;


                    break;

                default:
                    console.log("");
            }
        };

        TaskPathById.get(vm.taskLogs.task.id, function (response) {
            if (response.COORDINATE != null) {
                response.COORDINATE.forEach(function (coor) {
                    coordinateList.push({ lat: coor.latitude, lng: coor.longitude });
                });
            }

            if (response.CHAINAGE != null) {
                response.CHAINAGE.forEach(function (chainageVal) {
                    chainageList.push({ lat: chainageVal.latitude, lng: chainageVal.longitude, type: chainageVal.routePointType, number: chainageVal.routePointNumber });
                });
            }

            /*  if(response.MARKER != null){
                 response.MARKER.forEach(function (markerVal) {
                     markerList.push({ lat: markerVal.latitude, lng: markerVal.longitude });
                 });
             } */

            if (coordinateList.length) {
                locations.map.setCenter(coordinateList[0]);

                var polyline = new google.maps.Polyline({
                    path: coordinateList,
                    geodesic: true,
                    strokeColor: '#FD7A24',
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                    zIndex: 1
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
                addClick(polyline)
            }

            /* if(markerList.length){
                locations.map.setCenter(markerList[0]);
                createMarkers(markerList,'content/images/markersPoint.png',locations.map)
            } */

            if (chainageList.length) {

                locations.map.setCenter(chainageList[0]);
                createMarkers(chainageList, 'content/images/chainagePoints.png', locations.map)
            }
        });


        //Functions

        function addClick(item) {
            // Add a click event listener to the map
            item.addListener("click", function (event) {
                if (markers.length < 2) {
                    // Add a marker to the map
                    addMarker(event.latLng);

                    // Get the latitude and longitude of the clicked point
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }


        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                    zIndex: 4
                });

                google.maps.event.addListener(
                    marker,
                    "click",
                    (function () {
                        //var name = (each.name == (undefined || null)) ? " " : each.name
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var userContent = document.createElement("div")

                        userContent.innerHTML = '<div class="infoWindowhead"></br></br>' +
                            /* "<b>Name : "+name+"</b></br>"+ */
                            "<b>Latitude : " + each.lat + "</b></br>" +
                            "<b>Longitude : " + each.lng + "</b></br>" +
                            "<b>Type : " + each.type + "</b></br>" +
                            "<b>Number : " + each.number + "</b></br>" +
                            "</br></div>"
                        infowindow.setContent(
                            userContent
                        );
                        infowindow.open(map);
                        infowindow.setPosition({
                            lat: each.lat,
                            lng: each.lng,
                        });
                        openedInfoWindow = infowindow;

                        if (markers.length < 2) {
                            btnAddSection = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnAddSection.type = "button";

                            btnAddSection.value = "Add Log Point";

                            btnAddSection.className = "button";

                            btnAddSection.addEventListener("click", function () {
                                if (markers.length < 2) {
                                    // Add a marker to the map
                                    addMarker({
                                        lat: each.lat,
                                        lng: each.lng,
                                    });

                                    // Get the latitude and longitude of the clicked point
                                    vm.pinLat = each.lat;
                                    vm.pinLong = each.lng;
                                    openedInfoWindow.close();
                                } else {
                                    alert("From and To Log Exists");
                                }
                            })
                        }
                    }))


                //addClick(marker)
                arr.push(marker);
            })
        }

        function callTaskLog() {

            if (vm.taskLogs.id) {
                TaskLog.update(vm.taskLogs, onSuccessLog, function (error) { AlertService.error(error.data.message); })
            } else {
                TaskLog.post(
                    vm.taskLogs,
                    onSuccessLog,
                    function (error) {
                        AlertService.error(error.data.message);
                    }
                );
            }

        }

        function onSuccessLog() {
            if (vm.showMaterial) {
                vm.materialTxn.materialId = parseInt(vm.materialTxn.material)

                if (vm.materialTxn.transactionDate) {
                    vm.materialTxn.transactionDate = vm.materialTxn.transactionDate.getTime();
                }
                Inventory.postBulkMaterialTxn(
                    vm.materialTxn,
                    function () {
                        $window.history.back();
                    },
                    function (error) {
                        AlertService.error('Error - Material Transaction');
                    }
                );
            }

            if (vm.showResource) {
                vm.resourceTxn.resourceId = parseInt(vm.resourceTxn.resource)

                if (vm.resourceTxn.transactionDate) {
                    vm.resourceTxn.transactionDate = vm.resourceTxn.transactionDate.getTime();
                }

                Inventory.postBulkResourceTxn(vm.resourceTxn, function () {
                    $window.history.back();
                },
                    function (error) {
                        AlertService.error('Error - Resource Transaction');
                    })
            }

            if (!vm.showResource && !vm.showMaterial) {
                $window.history.back();
            }
        }


        vm.removeMarker = function () {
            markers.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the markers array
            markers = [];
        }

        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = "from"
            } else if (markers.length == 1) {
                markerText = "to"
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: markerText,
                },
                draggable: true
            });

            // Add the marker to the markers array
            markers.push(marker);
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }



        if (vm.taskLogs.id && vm.taskLogs.fromRoutePoint && vm.taskLogs.toRoutePoint) {
            showMarker({ lat: vm.taskLogs.fromRoutePoint.latitude, lng: vm.taskLogs.fromRoutePoint.longitude }, "from")
            showMarker({ lat: vm.taskLogs.toRoutePoint.latitude, lng: vm.taskLogs.toRoutePoint.longitude }, "to")
            locations.map.setCenter({ lat: vm.taskLogs.fromRoutePoint.latitude, lng: vm.taskLogs.fromRoutePoint.longitude });
        }

        function showMarker(location, text) {
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: text,
                }
            });

            // Add the marker to the markers array
            markers.push(marker);
        }

        // if (section && section.id && section.fromRoutePoint && section.toRoutePoint) {
        //     addMarkerSection({ lat: section.fromRoutePoint.latitude, lng: section.fromRoutePoint.longitude }, "From Section")
        //     addMarkerSection({ lat: section.toRoutePoint.latitude, lng: section.toRoutePoint.longitude }, "To Section")
        //     locations.map.setCenter({ lat: section.fromRoutePoint.latitude, lng: section.fromRoutePoint.longitude });
        // }

        if (task && task.id && task.fromRoutePoint && task.toRoutePoint) {
            addMarkerTask({ lat: task.fromRoutePoint.latitude, lng: task.fromRoutePoint.longitude }, "From Task")
            addMarkerTask({ lat: task.toRoutePoint.latitude, lng: task.toRoutePoint.longitude }, "To Task")
            locations.map.setCenter({ lat: task.fromRoutePoint.latitude, lng: task.fromRoutePoint.longitude });
        }

        function addMarkerSection(location, text) {
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: "content/images/sections.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        -4
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
                label: {
                    text: text,
                }
            });

            // Add the marker to the markers array
            markersSection.push(marker);
        }

        function addMarkerTask(location, text) {
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: "content/images/tasks.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        iconSize / 2
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
                label: {
                    text: text,
                }


            });
            addClick(marker)

            // Add the marker to the markers array
            markerstasks.push(marker);
        }

        vm.objectRouteImg = {}
        vm.objectRouteImg.routeId = $state.params.routeId
        vm.objectRouteImg.map = locations.map



        //Material/Resource TXN
        vm.materialTxn = {}
        vm.resourceTxn = {}
        vm.isShowTXN = false

        vm.transactionType = ["PLANNED", "REQUESTED", "RECEIVED", "UTILIZED", "RECONCILED"]
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        if (section && section.id) {
            vm.materialTxn = [{ sectionId: parseInt($state.params.sectionId) }]
            vm.resourceTxn = [{ sectionId: parseInt($state.params.sectionId) }]
            vm.isShowTXN = true



            TrMaterial.query(
                {
                    page: 0,
                    size: 200,
                    sort: 'last_modified_date,desc',
                },
                onSuccess,
                onError
            );



            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.materials = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.materials.push(value);
                });
                vm.page = pagingParams.page;
            }

            TrResource.query(
                {
                    page: 0,
                    size: 200,
                    sort: 'last_modified_date,desc',
                },
                onSuccessResource,
                onError
            );


            function onSuccessResource(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.resources = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.resources.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        $scope.addDetailsMaterial = function () {
            vm.materialTxn.push({ sectionId: $state.params.sectionId })
        }

        vm.dateChangedMaterial = function (index) {
            if (vm.materialTxn[index].transactionDate) {
                vm.materialTxn[index].transactionDate = epoch(vm.materialTxn[index].transactionDate)
            }
        }

        $scope.removeDetailsMaterial = function (id) {
            vm.materialTxn.splice(id, 1);
        };

        $scope.addDetailsResource = function () {
            vm.resourceTxn.push({ sectionId: $state.params.sectionId })
        }

        vm.dateChangedResource = function (index) {
            if (vm.resourceTxn[index].transactionDate) {
                vm.resourceTxn[index].transactionDate = epoch(vm.resourceTxn[index].transactionDate)
            }
        }

        $scope.removeDetailsResource = function (id) {
            vm.resourceTxn.splice(id, 1);
        };

        $('.select2').select2();

        vm.onChangeUom = function(id,index){
            
            var temp  = vm.materials.find(function (eachElement){
                return eachElement.id == id
            })

            vm.materialTxn[index].unitOfMeasurement = temp.unitOfMeasurement
        }

        function geoLocation(map) {
            var goTo = document.createElement("span");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            gotoIcon.classList.add("mt-5");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);
            goTo.addEventListener("click", function () {
                vm.removeMarker()
                $("#modalLatLongs").show();
            });
        }

         vm.closeModal = function(id) {
            vm.getLocationCoordinateA = null
            vm.getLocationCoordinateB = null

            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

         vm.onLocationCoordinates = function() {
                var latlngA = vm.getLocationCoordinateA.split(",");
                var latlngB = vm.getLocationCoordinateB.split(",");

                addMarker({lat: parseFloat(latlngA[0]),lng: parseFloat(latlngA[1])})
                addMarker({lat: parseFloat(latlngB[0]),lng: parseFloat(latlngB[1])})

                locations.map.setCenter({lat: parseFloat(latlngB[0]),lng: parseFloat(latlngB[1])})
                vm.closeModal('modalLatLongs')
        }
    }
})();

/* (function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TaskLogController", TaskLogController);

    TaskLogController.$inject = ["$scope",
    "$rootScope",
    "$state",
    "$compile",
    "ParseLinks",
    "AlertService",
    "pagingParams",
    "paginationConstants",
    "dailyTaskLog",
    "$filter"
    ];

    function TaskLogController($scope,
        $rootScope,
        $state,
        $compile,
        ParseLinks,
        AlertService,
        pagingParams,
        paginationConstants,
        dailyTaskLog,
        $filter
    ) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;


        dailyTaskLog.query(
            {
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
            },
            onSuccess,
            onError
        );

        function sort() {
            var result = [
                vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
            ];
            if (vm.predicate !== "id") {
                //  result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers("link"));
            vm.totalItems = headers("X-Total-Count");
            vm.queryCount = vm.totalItems;
            var dateFormat = "dd-MM-yyyy";
            vm.taskLogs = data;

            vm.taskLogs.forEach(function(item){
                item.workDate = $filter("date")(
                    item.workDate,
                    dateFormat
                )
            })
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
            });
        }
    }
})();
 */
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ServiceTypeDialogController', ServiceTypeDialogController);

    ServiceTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state', 'entity', 'ServiceType', 'User','AllCustomServiceTypeAttribute'];

    function ServiceTypeDialogController ($timeout, $scope, $stateParams, $state, entity, ServiceType, User,AllCustomServiceTypeAttribute) {
        var vm = this;
        vm.serviceType = entity;       
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.customServiceTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.attributetypes = ['INTEGER', 'FLOAT', 'STRING','BOOLEAN'];
       // vm.items=[{name: 'SLA',dataType: 'INTEGER',value :'4'}];
        vm.items=[{ name: '',attributeDataType: {},value :''}];
        if(vm.serviceType.serviceTypeAttribute!=null && vm.serviceType.serviceTypeAttribute.length!=0){
        	vm.items=vm.serviceType.serviceTypeAttribute;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        
        function loadPage() {
	    	 AllCustomServiceTypeAttribute.getAll(function(response) {
	    		 vm.customServiceTypeAttributes = response;
	     		 response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customServiceTypeAttributeValues;
					});
	    		 
				});
	    	    
	    	 }
        
        function save () {
            vm.isSaving = true;
            
            if (vm.serviceType.id !== null) {
            	vm.serviceType.serviceTypeAttribute=[];
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            	   // vm.serviceType.serviceTypeAttribute.push({"name" :  vm.items[i].name, "value" :  vm.items[i].value});
            	    vm.serviceType.serviceTypeAttribute.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,   "attributeDataType" :  vm.items[i].attributeDataType,"value" :  vm.items[i].value});
            	    
            	}
                ServiceType.update(vm.serviceType, onSaveSuccess, onSaveError);
            } else {
            	vm.serviceType.serviceTypeAttribute=[];
            	
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            	    //vm.serviceType.serviceTypeAttribute.push({"name" :  vm.items[i].name, "value" :  vm.items[i].value});
            		vm.serviceType.serviceTypeAttribute.push({"id" : vm.items[i].id ,"name" :  vm.items[i].name, "attributeDataType" :  vm.items[i].attributeDataType, "value" :  vm.items[i].value});
             	    
            	}
                ServiceType.save(vm.serviceType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:serviceTypeUpdate', result);
            vm.isSaving = false;
			$state.go('service-type');
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
      /* vm.addmore = function() {
            var newItemNo = vm.items.length+1;
            vm.items.push({'id':newItemNo});
          };*/
        vm.addmore = function() {
            //vm.items.push({name: '',dataType:'', value:''});
        	 vm.items.push({name: '',attributeDataType:{}, value:''});
          };
          
          vm.remove = function(index) {
              vm.items.splice(index, 1);
            };
            
     /*  vm.remove = function() {
            var lastItem = vm.items.length-1;
            vm.items.splice(lastItem);
          };*/

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updatedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ServiceTypeDetailController', ServiceTypeDetailController);

    ServiceTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ServiceType', 'User'];

    function ServiceTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, ServiceType, User) {
        var vm = this;

        vm.serviceType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:serviceTypeUpdate', function(event, result) {
            vm.serviceType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ServiceTypeDeleteController',ServiceTypeDeleteController);

    ServiceTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceType'];

    function ServiceTypeDeleteController($uibModalInstance, entity, ServiceType) {
        var vm = this;

        vm.serviceType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ServiceType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-type', {
            parent: 'entity',
            url: '/service-type',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.serviceType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-type/service-types.html',
                    controller: 'ServiceTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'updated_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-type-detail', {
            parent: 'entity',
            url: '/service-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.serviceType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-type/service-type-detail.html',
                    controller: 'ServiceTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceType', function($stateParams, ServiceType) {
                    return ServiceType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-type.new', {
            parent: 'service-type',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/service-type/service-type-dialog.html',
                    controller: 'ServiceTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updatedDate: null,
                                id: null
                            };
                        }
                    }            
        })
		.state('service-type.edit', {
            parent: 'entity',
            url: '/service-type/Edit/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-type/service-type-dialog.html',
                    controller: 'ServiceTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceType', function($stateParams, ServiceType) {
                    return ServiceType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('service-type.delete', {
            parent: 'service-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-type/service-type-delete-dialog.html',
                    controller: 'ServiceTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['ServiceType', function(ServiceType) {
                            return ServiceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-type', null, { reload: 'service-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('ServiceType', ServiceType);

    ServiceType.$inject = ['$resource', 'DateUtils'];

    function ServiceType ($resource, DateUtils) {
        var resourceUrl =  'api/service-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ServiceTypeSearch', ServiceTypeSearch);

    ServiceTypeSearch.$inject = ['$resource'];

    function ServiceTypeSearch ($resource) {
        var service = $resource('/api/service-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomServiceTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-service-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ServiceTypeController', ServiceTypeController);

    ServiceTypeController.$inject = ['$scope', '$state', 'ServiceType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','ServiceTypeSearch'];

    function ServiceTypeController ($scope, $state, ServiceType, ParseLinks, AlertService, pagingParams, paginationConstants,ServiceTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			ServiceTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                   // result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            ServiceType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                   // result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("SectionTypeDialogController", SectionTypeDialogController);

    SectionTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "SectionType",
        "User",
        "SectionTypeSearch",
        "AllCustomSectionTypeAttribute",
    ];

    
    function SectionTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        SectionType,
        User,
        SectionTypeSearch,
        AllCustomSectionTypeAttribute
    ) {
        var vm = this;
        //sectiontype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.sectionType = entity;
        vm.sectionTypeImageName = sectionTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customSectionTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function sectionTypeImageName(image) {
            vm.sectionType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomSectionTypeAttribute.getAll(function (response) {
                vm.customSectionTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customSectionTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.sectionType.sectionTypeAttribute != null &&
            vm.sectionType.sectionTypeAttribute.length != 0
        ) {
            vm.items = vm.sectionType.sectionTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.sectionCategory == null) {
                value.sectionCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.sectionType.id !== null) {
                vm.sectionType.sectionTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.sectionType.sectionTypeAttribute.push({
                        sectionCategory: vm.items[i].sectionCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        defaultValue: vm.items[i].value,
                        sectionTypeAttribOrder: vm.items[i].sectionTypeAttribOrder
                    });
                }
                SectionType.update(vm.sectionType, onSaveSuccess, onSaveError);
            } else {
                vm.sectionType.sectionTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.sectionType.sectionTypeAttribute.push({
                        sectionCategory: vm.items[i].sectionCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        defaultValue: vm.items[i].value,
                        sectionTypeAttribOrder: vm.items[i].sectionTypeAttribOrder
                    });
                }
                SectionType.save(vm.sectionType, onSaveSuccess, onSaveError);
            }
        }

        $("#sectionTypeImage").change(function () {
            var filesSelected = document.getElementById("sectionTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.sectionType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:sectionTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("section-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('SectionTypeDetailController', SectionTypeDetailController);

    SectionTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SectionType', 'User'];

    function SectionTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, SectionType, User) {
        var vm = this;

        vm.sectionType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:sectionTypeUpdate', function(event, result) {
            vm.sectionType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('SectionTypeDeleteController',SectionTypeDeleteController);

    SectionTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'SectionType'];

    function SectionTypeDeleteController($uibModalInstance, entity, SectionType) {
        var vm = this;

        vm.sectionType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SectionType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('section-type', {
            parent: 'entity',
            url: '/section-type',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.sectionType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section-type/section-types.html',
                    controller: 'SectionTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectionType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('section-type-detail', {
            parent: 'section-type',
            url: '/section-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.sectionType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section-type/section-type-detail.html',
                    controller: 'SectionTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectionType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectionType', function($stateParams, SectionType) {
                    return SectionType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'section-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('section-type.new', {
            parent: 'section-type',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/section-type/section-type-dialog.html',
                    controller: 'SectionTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('section-type.edit', {
            parent: 'section-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.sectionType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section-type/section-type-dialog.html',
                    controller: 'SectionTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectionType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectionType', function($stateParams, SectionType) {
                    return SectionType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'section-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('section-type.delete', {
            parent: 'section-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/section-type/section-type-delete-dialog.html',
                    controller: 'SectionTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['SectionType', function(SectionType) {
                            return SectionType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('section-type', null, { reload: 'section-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('SectionType', SectionType);

    SectionType.$inject = ['$resource', 'DateUtils'];

    function SectionType ($resource, DateUtils) {
        var resourceUrl =  'api/section-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('SectionTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getsectiontypebyname = function (data,callback){
		$http.get('api/section-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('SectionTypeSearch', SectionTypeSearch);

    SectionTypeSearch.$inject = ['$resource'];

    function SectionTypeSearch ($resource) {
        var service = $resource('/api/section-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomSectionTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-section-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('SectionTypeController', SectionTypeController);

    SectionTypeController.$inject = ['$scope', '$state', 'SectionType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','SectionTypeSearch'];

    function SectionTypeController ($scope, $state, SectionType, ParseLinks, AlertService, pagingParams, paginationConstants,SectionTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			SectionTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sectionTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            SectionType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sectionTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("RowTypeDialogController", RowTypeDialogController);

    RowTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "RowType",
        "User",
        "RowTypeSearch",
        "AllCustomRowTypeAttribute",
    ];


    function RowTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        RowType,
        User,
        RowTypeSearch,
        AllCustomRowTypeAttribute
    ) {
        var vm = this;
        //rowtype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.rowType = entity;
        vm.rowTypeImageName = rowTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customRowTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");



        vm.checkNumber;





        function rowTypeImageName(image) {
            vm.rowType.image = image;
        }


        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomRowTypeAttribute.getAll(function (response) {
                vm.customRowTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customRowTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, defaultValue: "" }];

        if (
            vm.rowType.rowTypeAttribute != null &&
            vm.rowType.rowTypeAttribute.length != 0
        ) {
            vm.items = vm.rowType.rowTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.rowCategory == null) {
                value.rowCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.rowType.id !== null) {
                vm.rowType.rowTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.rowType.rowTypeAttribute.push({
                        rowCategory: vm.items[i].rowCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        defaultValue: vm.items[i].defaultValue,
                        rowTypeAttribOrder: vm.items[i].rowTypeAttribOrder
                    });
                }
                RowType.update(vm.rowType, onSaveSuccess, onSaveError);
            } else {
                vm.rowType.rowTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.rowType.rowTypeAttribute.push({
                        rowCategory: vm.items[i].rowCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        defaultValue: vm.items[i].defaultValue,
                        rowTypeAttribOrder: vm.items[i].rowTypeAttribOrder
                    });
                }
                RowType.save(vm.rowType, onSaveSuccess, onSaveError);
            }
        }

        $("#rowTypeImage").change(function () {
            var filesSelected = document.getElementById("rowTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.rowType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:rowTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("row-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {


            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index + 1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });

        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);


        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.colorcode = function (color) {
            vm.rowType.colorcode = color;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RowTypeDetailController', RowTypeDetailController);

    RowTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RowType', 'User'];

    function RowTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, RowType, User) {
        var vm = this;

        vm.rowType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:rowTypeUpdate', function (event, result) {
            vm.rowType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RowTypeDeleteController', RowTypeDeleteController);

    RowTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RowType'];

    function RowTypeDeleteController($uibModalInstance, entity, RowType) {
        var vm = this;

        vm.rowType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            RowType.delete({ id: id },
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('row-type', {
            parent: 'entity',
            url: '/row-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.rowType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/row-type/row-types.html',
                    controller: 'RowTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rowType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('row-type-detail', {
            parent: 'row-type',
            url: '/row-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.rowType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/row-type/row-type-detail.html',
                    controller: 'RowTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rowType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RowType', function($stateParams, RowType) {
                    return RowType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'row-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('row-type.new', {
            parent: 'row-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/row-type/row-type-dialog.html',
                    controller: 'RowTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('row-type.edit', {
            parent: 'row-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.rowType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/row-type/row-type-dialog.html',
                    controller: 'RowTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rowType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RowType', function($stateParams, RowType) {
                    return RowType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'row-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('row-type.delete', {
            parent: 'row-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/row-type/row-type-delete-dialog.html',
                    controller: 'RowTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['RowType', function(RowType) {
                            return RowType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('row-type', null, { reload: 'row-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('RowType', RowType);

    RowType.$inject = ['$resource', 'DateUtils'];

    function RowType ($resource, DateUtils) {
        var resourceUrl =  'api/row-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('RowTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getrowtypebyname = function (data,callback){
		$http.get('api/row-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('RowTypeSearch', RowTypeSearch);

    RowTypeSearch.$inject = ['$resource'];

    function RowTypeSearch ($resource) {
        var service = $resource('/api/row-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomRowTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-row-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RowTypeController', RowTypeController);

    RowTypeController.$inject = ['$scope', '$state', 'RowType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','RowTypeSearch'];

    function RowTypeController ($scope, $state, RowType, ParseLinks, AlertService, pagingParams, paginationConstants,RowTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			RowTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.rowTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            RowType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.rowTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("RouteTypeDialogController", RouteTypeDialogController);

    RouteTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "RouteType",
        "User",
        "RouteTypeSearch",
        "AllCustomRouteTypeAttribute",
    ];

    
    function RouteTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        RouteType,
        User,
        RouteTypeSearch,
        AllCustomRouteTypeAttribute
    ) {
        var vm = this;
        //routetype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.routeType = entity;
        vm.routeTypeImageName = routeTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customRouteTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function routeTypeImageName(image) {
            vm.routeType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomRouteTypeAttribute.getAll(function (response) {
                vm.customRouteTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customRouteTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.routeType.routeTypeAttribute != null &&
            vm.routeType.routeTypeAttribute.length != 0
        ) {
            vm.items = vm.routeType.routeTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.routeCategory == null) {
                value.routeCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.routeType.id !== null) {
                vm.routeType.routeTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.routeType.routeTypeAttribute.push({
                        routeCategory: vm.items[i].routeCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        routeTypeAttribOrder: vm.items[i].routeTypeAttribOrder
                    });
                }
                RouteType.update(vm.routeType, onSaveSuccess, onSaveError);
            } else {
                vm.routeType.routeTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.routeType.routeTypeAttribute.push({
                        routeCategory: vm.items[i].routeCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        routeTypeAttribOrder: vm.items[i].routeTypeAttribOrder
                    });
                }
                RouteType.save(vm.routeType, onSaveSuccess, onSaveError);
            }
        }

        $("#routeTypeImage").change(function () {
            var filesSelected = document.getElementById("routeTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.routeType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:routeTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("route-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RouteTypeDetailController', RouteTypeDetailController);

    RouteTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RouteType', 'User'];

    function RouteTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, RouteType, User) {
        var vm = this;

        vm.routeType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:routeTypeUpdate', function(event, result) {
            vm.routeType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RouteTypeDeleteController',RouteTypeDeleteController);

    RouteTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RouteType'];

    function RouteTypeDeleteController($uibModalInstance, entity, RouteType) {
        var vm = this;

        vm.routeType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RouteType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('route-type', {
            parent: 'entity',
            url: '/route-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.routeType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/route-type/route-types.html',
                    controller: 'RouteTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('routeType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('route-type-detail', {
            parent: 'route-type',
            url: '/route-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.routeType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/route-type/route-type-detail.html',
                    controller: 'RouteTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('routeType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RouteType', function($stateParams, RouteType) {
                    return RouteType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'route-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('route-type.new', {
            parent: 'route-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/route-type/route-type-dialog.html',
                    controller: 'RouteTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('route-type.edit', {
            parent: 'route-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.routeType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/route-type/route-type-dialog.html',
                    controller: 'RouteTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('routeType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RouteType', function($stateParams, RouteType) {
                    return RouteType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'route-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('route-type.delete', {
            parent: 'route-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/route-type/route-type-delete-dialog.html',
                    controller: 'RouteTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['RouteType', function(RouteType) {
                            return RouteType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('route-type', null, { reload: 'route-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('RouteType', RouteType);

    RouteType.$inject = ['$resource', 'DateUtils'];

    function RouteType ($resource, DateUtils) {
        var resourceUrl =  'api/route-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('RouteTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getroutetypebyname = function (data,callback){
		$http.get('api/route-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('RouteTypeSearch', RouteTypeSearch);

    RouteTypeSearch.$inject = ['$resource'];

    function RouteTypeSearch ($resource) {
        var service = $resource('/api/route-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomRouteTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-route-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RouteTypeController', RouteTypeController);

    RouteTypeController.$inject = ['$scope', '$state', 'RouteType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','RouteTypeSearch'];

    function RouteTypeController ($scope, $state, RouteType, ParseLinks, AlertService, pagingParams, paginationConstants,RouteTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			RouteTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.routeTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            RouteType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.routeTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ResourceTypeDialogController", ResourceTypeDialogController);

    ResourceTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "ResourceType",
        "User",
        "ResourceTypeSearch",
        "AllCustomResourceTypeAttribute",
    ];

    
    function ResourceTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        ResourceType,
        User,
        ResourceTypeSearch,
        AllCustomResourceTypeAttribute
    ) {
        var vm = this;
        //resourcetype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.resourceType = entity;
        vm.resourceTypeImageName = resourceTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customResourceTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function resourceTypeImageName(image) {
            vm.resourceType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomResourceTypeAttribute.getAll(function (response) {
                vm.customResourceTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customResourceTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.resourceType.resourceTypeAttribute != null &&
            vm.resourceType.resourceTypeAttribute.length != 0
        ) {
            vm.items = vm.resourceType.resourceTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.resourceCategory == null) {
                value.resourceCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.resourceType.id !== null) {
                vm.resourceType.resourceTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.resourceType.resourceTypeAttribute.push({
                        resourceCategory: vm.items[i].resourceCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        resourceTypeAttribOrder: vm.items[i].resourceTypeAttribOrder
                    });
                }
                ResourceType.update(vm.resourceType, onSaveSuccess, onSaveError);
            } else {
                vm.resourceType.resourceTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.resourceType.resourceTypeAttribute.push({
                        resourceCategory: vm.items[i].resourceCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        resourceTypeAttribOrder: vm.items[i].resourceTypeAttribOrder
                    });
                }
                ResourceType.save(vm.resourceType, onSaveSuccess, onSaveError);
            }
        }

        $("#resourceTypeImage").change(function () {
            var filesSelected = document.getElementById("resourceTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.resourceType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:resourceTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("resource-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ResourceTypeDetailController', ResourceTypeDetailController);

    ResourceTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ResourceType', 'User'];

    function ResourceTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, ResourceType, User) {
        var vm = this;

        vm.resourceType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:resourceTypeUpdate', function(event, result) {
            vm.resourceType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ResourceTypeDeleteController',ResourceTypeDeleteController);

    ResourceTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ResourceType'];

    function ResourceTypeDeleteController($uibModalInstance, entity, ResourceType) {
        var vm = this;

        vm.resourceType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ResourceType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('resource-type', {
            parent: 'entity',
            url: '/resource-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.resourceType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/resource-type/resource-types.html',
                    controller: 'ResourceTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resourceType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('resource-type-detail', {
            parent: 'resource-type',
            url: '/resource-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.resourceType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/resource-type/resource-type-detail.html',
                    controller: 'ResourceTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resourceType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ResourceType', function($stateParams, ResourceType) {
                    return ResourceType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'resource-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('resource-type.new', {
            parent: 'resource-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/resource-type/resource-type-dialog.html',
                    controller: 'ResourceTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('resource-type.edit', {
            parent: 'resource-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.resourceType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/resource-type/resource-type-dialog.html',
                    controller: 'ResourceTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resourceType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ResourceType', function($stateParams, ResourceType) {
                    return ResourceType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'resource-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('resource-type.delete', {
            parent: 'resource-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/resource-type/resource-type-delete-dialog.html',
                    controller: 'ResourceTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['ResourceType', function(ResourceType) {
                            return ResourceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('resource-type', null, { reload: 'resource-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('ResourceType', ResourceType);

    ResourceType.$inject = ['$resource', 'DateUtils'];

    function ResourceType ($resource, DateUtils) {
        var resourceUrl =  'api/resource-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ResourceTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getresourcetypebyname = function (data,callback){
		$http.get('api/resource-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ResourceTypeSearch', ResourceTypeSearch);

    ResourceTypeSearch.$inject = ['$resource'];

    function ResourceTypeSearch ($resource) {
        var service = $resource('/api/resource-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomResourceTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-resource-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ResourceTypeController', ResourceTypeController);

    ResourceTypeController.$inject = ['$scope', '$state', 'ResourceType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','ResourceTypeSearch'];

    function ResourceTypeController ($scope, $state, ResourceType, ParseLinks, AlertService, pagingParams, paginationConstants,ResourceTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			ResourceTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.resourceTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            ResourceType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.resourceTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ProjectTypeDialogController", ProjectTypeDialogController);

    ProjectTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "ProjectType",
        "User",
        "ProjectTypeSearch",
        "AllCustomProjectTypeAttribute",
    ];

    
    function ProjectTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        ProjectType,
        User,
        ProjectTypeSearch,
        AllCustomProjectTypeAttribute
    ) {
        var vm = this;
        //projecttype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.projectType = entity;
        vm.projectTypeImageName = projectTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customProjectTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function projectTypeImageName(image) {
            vm.projectType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomProjectTypeAttribute.getAll(function (response) {
                vm.customProjectTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customProjectTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.projectType.projectTypeAttribute != null &&
            vm.projectType.projectTypeAttribute.length != 0
        ) {
            vm.items = vm.projectType.projectTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.projectCategory == null) {
                value.projectCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.projectType.id !== null) {
                vm.projectType.projectTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.projectType.projectTypeAttribute.push({
                        projectCategory: vm.items[i].projectCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        projectTypeAttribOrder: vm.items[i].projectTypeAttribOrder
                    });
                }
                ProjectType.update(vm.projectType, onSaveSuccess, onSaveError);
            } else {
                vm.projectType.projectTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.projectType.projectTypeAttribute.push({
                        projectCategory: vm.items[i].projectCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        projectTypeAttribOrder: vm.items[i].projectTypeAttribOrder
                    });
                }
                ProjectType.save(vm.projectType, onSaveSuccess, onSaveError);
            }
        }

        $("#projectTypeImage").change(function () {
            var filesSelected = document.getElementById("projectTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.projectType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:projectTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("project-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ProjectTypeDetailController', ProjectTypeDetailController);

    ProjectTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProjectType', 'User'];

    function ProjectTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, ProjectType, User) {
        var vm = this;

        vm.projectType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:projectTypeUpdate', function(event, result) {
            vm.projectType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ProjectTypeDeleteController',ProjectTypeDeleteController);

    ProjectTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectType'];

    function ProjectTypeDeleteController($uibModalInstance, entity, ProjectType) {
        var vm = this;

        vm.projectType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProjectType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-type', {
            parent: 'entity',
            url: '/project-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.projectType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-type/project-types.html',
                    controller: 'ProjectTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-type-detail', {
            parent: 'project-type',
            url: '/project-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.projectType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-type/project-type-detail.html',
                    controller: 'ProjectTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectType', function($stateParams, ProjectType) {
                    return ProjectType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('project-type.new', {
            parent: 'project-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/project-type/project-type-dialog.html',
                    controller: 'ProjectTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('project-type.edit', {
            parent: 'project-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.projectType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-type/project-type-dialog.html',
                    controller: 'ProjectTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectType', function($stateParams, ProjectType) {
                    return ProjectType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('project-type.delete', {
            parent: 'project-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-type/project-type-delete-dialog.html',
                    controller: 'ProjectTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['ProjectType', function(ProjectType) {
                            return ProjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-type', null, { reload: 'project-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('ProjectType', ProjectType);

    ProjectType.$inject = ['$resource', 'DateUtils'];

    function ProjectType ($resource, DateUtils) {
        var resourceUrl =  'api/project-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ProjectTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getprojecttypebyname = function (data,callback){
		$http.get('api/project-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ProjectTypeSearch', ProjectTypeSearch);

    ProjectTypeSearch.$inject = ['$resource'];

    function ProjectTypeSearch ($resource) {
        var service = $resource('/api/project-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomProjectTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-project-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ProjectTypeController', ProjectTypeController);

    ProjectTypeController.$inject = ['$scope', '$state', 'ProjectType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','ProjectTypeSearch'];

    function ProjectTypeController ($scope, $state, ProjectType, ParseLinks, AlertService, pagingParams, paginationConstants,ProjectTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			ProjectTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.projectTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            ProjectType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.projectTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("MaterialTypeDialogController", MaterialTypeDialogController);

    MaterialTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "MaterialType",
        "User",
        "MaterialTypeSearch",
        "AllCustomMaterialTypeAttribute",
        "getUoM"
    ];

    
    function MaterialTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        MaterialType,
        User,
        MaterialTypeSearch,
        AllCustomMaterialTypeAttribute,
        getUoM
    ) {
        var vm = this;
        //materialtype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.materialType = entity;
        vm.materialTypeImageName = materialTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customMaterialTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");
        vm.checkNumber;

        function materialTypeImageName(image) {
            vm.materialType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomMaterialTypeAttribute.getAll(function (response) {
                vm.customMaterialTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customMaterialTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.materialType.materialTypeAttribute != null &&
            vm.materialType.materialTypeAttribute.length != 0
        ) {
            vm.items = vm.materialType.materialTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.materialCategory == null) {
                value.materialCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            //vm.isSaving = true;
            if (vm.materialType.id !== null) {
                vm.materialType.materialTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.materialType.materialTypeAttribute.push({
                        materialCategory: vm.items[i].materialCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        materialTypeAttribOrder: vm.items[i].materialTypeAttribOrder
                    });
                }
                MaterialType.update(vm.materialType, onSaveSuccess, onSaveError);
            } else {
                vm.materialType.materialTypeAttribute = [];
 
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.materialType.materialTypeAttribute.push({
                        materialCategory: vm.items[i].materialCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        materialTypeAttribOrder: vm.items[i].materialTypeAttribOrder
                    });
                }
                MaterialType.save(vm.materialType, onSaveSuccess, onSaveError);
            }
        }

        $("#materialTypeImage").change(function () {
            var filesSelected = document.getElementById("materialTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.materialType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:materialTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("material-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        if(!vm.materialType.id){
            vm.materialType.trUnitOfMeasurement = {}
        } 

        getUoM.get(function(response){
            vm.optionsUoM = response
        })

        $('.select2').select2();
       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('MaterialTypeDetailController', MaterialTypeDetailController);

    MaterialTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MaterialType', 'User'];

    function MaterialTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, MaterialType, User) {
        var vm = this;

        vm.materialType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:materialTypeUpdate', function(event, result) {
            vm.materialType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('MaterialTypeDeleteController',MaterialTypeDeleteController);

    MaterialTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'MaterialType'];

    function MaterialTypeDeleteController($uibModalInstance, entity, MaterialType) {
        var vm = this;

        vm.materialType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MaterialType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('material-type', {
            parent: 'entity',
            url: '/material-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.materialType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material-type/material-types.html',
                    controller: 'MaterialTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('materialType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('material-type-detail', {
            parent: 'material-type',
            url: '/material-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.materialType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material-type/material-type-detail.html',
                    controller: 'MaterialTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('materialType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MaterialType', function($stateParams, MaterialType) {
                    return MaterialType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'material-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('material-type.new', {
            parent: 'material-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/material-type/material-type-dialog.html',
                    controller: 'MaterialTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('material-type.edit', {
            parent: 'material-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.materialType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material-type/material-type-dialog.html',
                    controller: 'MaterialTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('materialType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MaterialType', function($stateParams, MaterialType) {
                    return MaterialType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'material-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('material-type.delete', {
            parent: 'material-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material-type/material-type-delete-dialog.html',
                    controller: 'MaterialTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['MaterialType', function(MaterialType) {
                            return MaterialType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('material-type', null, { reload: 'material-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('MaterialType', MaterialType);

    MaterialType.$inject = ['$resource', 'DateUtils'];

    function MaterialType ($resource, DateUtils) {
        var resourceUrl =  'api/material-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('MaterialTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getmaterialtypebyname = function (data,callback){
		$http.get('api/material-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('MaterialTypeSearch', MaterialTypeSearch);

    MaterialTypeSearch.$inject = ['$resource'];

    function MaterialTypeSearch ($resource) {
        var service = $resource('/api/material-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomMaterialTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-material-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('getUoM', ['$http', function($http) {

		var service = {};
		service.get = function(callback) {
			$http.get('api/rollout/tr-uom').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('MaterialTypeController', MaterialTypeController);

    MaterialTypeController.$inject = ['$scope', '$state', 'MaterialType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','MaterialTypeSearch'];

    function MaterialTypeController ($scope, $state, MaterialType, ParseLinks, AlertService, pagingParams, paginationConstants,MaterialTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			MaterialTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materialTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            MaterialType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materialTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("LogTypeDialogController", LogTypeDialogController);

    LogTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "LogType",
        "User",
        "LogTypeSearch",
        "AllCustomLogTypeAttribute",
    ];

    
    function LogTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        LogType,
        User,
        LogTypeSearch,
        AllCustomLogTypeAttribute
    ) {
        var vm = this;
        //logtype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.logType = entity;
        vm.logTypeImageName = logTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customLogTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function logTypeImageName(image) {
            vm.logType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomLogTypeAttribute.getAll(function (response) {
                vm.customLogTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customLogTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.logType.logTypeAttribute != null &&
            vm.logType.logTypeAttribute.length != 0
        ) {
            vm.items = vm.logType.logTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.logCategory == null) {
                value.logCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.logType.id !== null) {
                vm.logType.logTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.logType.logTypeAttribute.push({
                        logCategory: vm.items[i].logCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        logTypeAttribOrder: vm.items[i].logTypeAttribOrder
                    });
                }
                LogType.update(vm.logType, onSaveSuccess, onSaveError);
            } else {
                vm.logType.logTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.logType.logTypeAttribute.push({
                        logCategory: vm.items[i].logCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        logTypeAttribOrder: vm.items[i].logTypeAttribOrder
                    });
                }
                LogType.save(vm.logType, onSaveSuccess, onSaveError);
            }
        }

        $("#logTypeImage").change(function () {
            var filesSelected = document.getElementById("logTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.logType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:logTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("log-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LogTypeDetailController', LogTypeDetailController);

    LogTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'LogType', 'User'];

    function LogTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, LogType, User) {
        var vm = this;

        vm.logType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:logTypeUpdate', function(event, result) {
            vm.logType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TaskTypeDeleteController',TaskTypeDeleteController);

    TaskTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaskType'];

    function TaskTypeDeleteController($uibModalInstance, entity, TaskType) {
        var vm = this;

        vm.taskType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TaskType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('log-type', {
            parent: 'entity',
            url: '/log-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.logType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/log-type/log-types.html',
                    controller: 'LogTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('log-type-detail', {
            parent: 'log-type',
            url: '/log-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.logType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/log-type/log-type-detail.html',
                    controller: 'LogTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LogType', function($stateParams, LogType) {
                    return LogType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'log-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('log-type.new', {
            parent: 'log-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/log-type/log-type-dialog.html',
                    controller: 'LogTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('log-type.edit', {
            parent: 'log-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.logType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/log-type/log-type-dialog.html',
                    controller: 'LogTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LogType', function($stateParams, LogType) {
                    return LogType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'log-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('log-type.delete', {
            parent: 'log-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/log-type/log-type-delete-dialog.html',
                    controller: 'LogTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['LogType', function(LogType) {
                            return LogType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('log-type', null, { reload: 'log-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LogType', LogType);

    LogType.$inject = ['$resource', 'DateUtils'];

    function LogType ($resource, DateUtils) {
        var resourceUrl =  'api/log-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllLogTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/log-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('LogTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getlogtypebyname = function (data,callback){
		$http.get('api/log-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('LogTypeSearch', LogTypeSearch);

    LogTypeSearch.$inject = ['$resource'];

    function LogTypeSearch ($resource) {
        var service = $resource('/api/log-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomLogTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-log-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LogTypeController', LogTypeController);

    LogTypeController.$inject = ['$scope', '$state', 'LogType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','LogTypeSearch'];

    function LogTypeController ($scope, $state, LogType, ParseLinks, AlertService, pagingParams, paginationConstants,LogTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			LogTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.logTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            LogType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.logTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LocationLogDialogController', LocationLogDialogController);

    LocationLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LocationLog', 'User'];

    function LocationLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LocationLog, User) {
        var vm = this;

        vm.locationLog = entity;
        vm.locationLog.createdDateTime = (new Date()).getTime();
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
       // vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	vm.isSaving = true;
            if (vm.locationLog.id !== null) {
                LocationLog.update(vm.locationLog, onSaveSuccess, onSaveError);
            } else {
                LocationLog.save(vm.locationLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:locationLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDateTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LocationLogDetailController', LocationLogDetailController);

    LocationLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'LocationLog', 'User'];

    function LocationLogDetailController($scope, $rootScope, $stateParams, previousState, entity, LocationLog, User) {
        var vm = this;

        vm.locationLog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:locationLogUpdate', function(event, result) {
            vm.locationLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LocationLogDeleteController',LocationLogDeleteController);

    LocationLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'LocationLog'];

    function LocationLogDeleteController($uibModalInstance, entity, LocationLog) {
        var vm = this;

        vm.locationLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LocationLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('location-log', {
                parent: 'app',
                url: '/live-monitoring?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.locationLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-log/location-logs.html',
                        controller: 'LocationLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationLog');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('location-log.login', {
                parent: 'app',
                url: '/live-monitoring/{login}?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.locationLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-log/location-logs.html',
                        controller: 'LocationLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationLog');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('location-log-detail', {
                parent: 'entity',
                url: '/location-log/{id}',
                data: {
                    authorities: ['ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.locationLog.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-log/location-log-detail.html',
                        controller: 'LocationLogDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationLog');
                        $translatePartialLoader.addPart('logSource');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'LocationLog', function($stateParams, LocationLog) {
                        return LocationLog.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'location-log',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('location-log-detail.edit', {
                parent: 'location-log-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/location-log/location-log-dialog.html',
                        controller: 'LocationLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        //size: 'lg',
                        resolve: {
                            entity: ['LocationLog', function(LocationLog) {
                                return LocationLog.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('location-log.new', {
                parent: 'location-log',
                url: '/new',
                data: {
                    authorities: ['ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/location-log/location-log-dialog.html',
                        controller: 'LocationLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        // size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    latitude: null,
                                    longitude: null,
                                    address: null,
                                    logSource: null,
                                    createdDateTime: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('location-log', null, { reload: 'location-log' });
                    }, function() {
                        $state.go('location-log');
                    });
                }]
            })
            .state('location-log.edit', {
                parent: 'location-log',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/location-log/location-log-dialog.html',
                        controller: 'LocationLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        // size: 'lg',
                        resolve: {
                            entity: ['LocationLog', function(LocationLog) {
                                return LocationLog.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('location-log', null, { reload: 'location-log' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })




        .state('location-log.delete', {
            parent: 'location-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location-log/location-log-delete-dialog.html',
                    controller: 'LocationLogDeleteController',
                    controllerAs: 'vm',
                    //size: 'md',
                    resolve: {
                        entity: ['LocationLog', function(LocationLog) {
                            return LocationLog.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('location-log', null, { reload: 'location-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LocationLog', LocationLog);

    LocationLog.$inject = ['$resource', 'DateUtils'];

    function LocationLog($resource, DateUtils) {
        var resourceUrl = 'api/location-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });
    }
})();

// (function() {
// 	'use strict';

// 	angular.module('trakeyeApp').factory('AssetsList', [ '$rootScope', '$http', function($rootScope, $http) {

// 		var service = {};
// 		service.getAll = function( callback) {
// 			$http.get('api/assetlisttypespread').then(function(response) {
// 				callback(response.data);
// 			});
// 		};

// 		return service;
// 	} ]);
// })();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LocationLogMapPath', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getmaplogs = function (data, callback) {

                $http.get('api/location-logs/userpath/' + data.userId + '/' + data.fromDate + '/' + data.toDate, { ignoreLoadingBar: true }).then(function (response) {
                    callback(response.data);
                });
            };
            service.getTravelPathByTicket = function (ticketId, successCb, errorCb) {
                $http.get('api/v1/field-users/travel-path/' + encodeURIComponent(ticketId), { ignoreLoadingBar: true }).then(
                    function (response) {
                        if (successCb) {
                            successCb(response.data);
                        }
                    },
                    function (error) {
                        if (errorCb) {
                            errorCb(error);
                        }
                    }
                );
            };
            service.downloadUserPath = function (data, callback) {

				$http.get('api/location-logs/download-userpath/' + data.userId + '/' + data.fromDate + '/' + data.toDate + '/' + data.type).then(function (response) {
					callback(response.data);
				});
			};
            service.locateUsers = function (callback) {
                $http.get('api/dashboard/agentlivedashboard').then(function (response) {
                    callback(response.data);
                });
            };

            service.locateUsersLogin = function (loginName, successCb, errorCb) {
                $http.get('api/dashboard/agentlivedashboard/' + loginName).then(
			   function (response) {
				successCb(response.data);
			    },
			    function (error) {
				if (errorCb) {
					errorCb(error);
				}
			}
		);
            };

            /* service.locateInActiveUsers = function (callback){
                 $http.get('api/location-logs/latestinactive').then(function(response){
                     callback(response.data);
                 });
             };*/

            return service;
        }]);



})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LocationLogVehicleMapPath', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getmaplogs = function (data, callback) {

                $http.get('api/location-logs/vehiclepath/' + data.userId + '/' + data.fromDate + '/' + data.toDate).then(function (response) {
                    callback(response.data);
                });
            };
            return service;
        }]);



})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LocationLogMap', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getlogsbydate = function (data, callback) {

                $http.get('api/location-logs/' + data.fromDate + '/' + data.toDate).then(function (response) {
                    callback(response.data, response.headers);
                });
            };

            return service;
        }]);



})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('UsersGeoFenceData', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getGeoFenceData = function (data, callback) {

                $http.get('api/users-geofences/' + data).then(function (response) {
                    callback(response.data, response.headers);
                });
            };

            return service;
        }]);
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('VehicleGeoFenceData', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getGeoFenceData = function (data, callback) {

                $http.get('api/vehicle-geofences/' + data).then(function (response) {
                    callback(response.data, response.headers);
                });
            };

            return service;
        }]);



})();
(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('UserDetails', ['$rootScope', '$http', function ($rootScope, $http) {
            var service = {};

            service.getUserDetails = function (userName, callback) {

                $http.get('/api/user_profile_details/'+userName).then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        }]);
})();








(function () {
	'use strict';

	angular.module('trakeyeApp').controller('LocationLogController', LocationLogController);

	LocationLogController.$inject = ['$filter', '$scope', '$compile', '$state', 'LocationLog', 'ParseLinks', 'AlertService', 'pagingParams', '$stateParams', 'paginationConstants', 'LocationLogMap',
		'LocationLogMapPath', 'LocationLogVehicleMapPath', 'UsersGeoFenceData', 'UserAccount', 'GeofenceIDs', 'UserGeofences', 'AssetDB', 'AssetByID', '$interval', 'Report', 'AssetTypesByGeofenceID', 'VehicleGeoFenceData', 'AssetType', '$rootScope','GeofenceByID','TrCaseForMap','TrCaseById','UserDetails'];

	function LocationLogController($filter, $scope, $compile, $state, LocationLog, ParseLinks, AlertService, pagingParams, $stateParams, paginationConstants, LocationLogMap, LocationLogMapPath, LocationLogVehicleMapPath,
		UsersGeoFenceData, UserAccount, GeofenceIDs, UserGeofences, AssetDB, AssetByID, $interval, Report, AssetTypesByGeofenceID, VehicleGeoFenceData, AssetType, $rootScope,GeofenceByID,TrCaseForMap,TrCaseById,UserDetails) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.drawUserPath = drawUserPath;
		vm.type = "user";
		vm.pathuserid = null;
		vm.logsbystatus = [];
		vm.all = all;
		vm.active = active;
		vm.inactive = inactive;
		vm.idle = idle;
		vm.absent = absent;
		vm.filterUsers = filterUsers;
		vm.fromDate = null;
		vm.toDate = null;
		vm.today = today;
		vm.today();
		vm.onChangeDate = onChangeDate;
		var openedInfoWindow = null;
		var latlng;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		var dateFormat = 'yyyy-MM-dd';
		vm.selectedLogs = "ALL";
		var markerUserName = "";
		$scope.alllength;
		$scope.activelength;
		$scope.inactivelength;
		$scope.idlelength;
		vm.vehicles = [];
		vm.polygon = [];

		vm.allGeofences = [];
		vm.selectedGeofenceId = null;
		vm.prevSelectedGeofenceId = null;
		var prevInfoWindow = null;

		vm.userGeofences = [];
		vm.assetFilterGeofences = [];
		vm.selectedUserGeofenceId = null;
		vm.prevSelectedUserGeofenceId = null;
		vm.responseLiveLogs = null

		vm.filterAssetsLocationOnMapView = filterAssetsLocationOnMapView;
		vm.closeMapLocationFilterModal = closeMapLocationFilterModal;
		vm.filterAssetsLoadOnMapView = filterAssetsLoadOnMapView;
		vm.closeMapLoadPathFilterModal = closeMapLoadPathFilterModal;
		vm.saveLocationFilter = saveLocationFilter;
		vm.saveLoadPathFilter = saveLoadPathFilter;

		vm.downloadLoadPath = downloadLoadPath;

		var markers = [];
		var polylines = [];

		var markersForPath = [];
		var polylinesForPath = [];

		var noDataText = null;
		vm.mapAssets = [];
		var userPathId = null;
		var userIdSelected = null;

		vm.assetTypeValues = [];

		vm.assetTypeValuesPath = [];

		vm.selecterange = selectRange;
		vm.customRange = customRange;

		$scope.tab = 1;
		$scope.geofencelabel = {
			search: "Search",
			nothingSelected: "Block"
		}
		$scope.setTab = function (newTab) {
			$scope.tab = newTab;
			if ($scope.tab == 1) {
				//filterAssetsLocationOnMapView()
			} else if ($scope.tab == 2) {
				vm.locateUsers;
			}
		};
		$scope.isSet = function (tabNum) {
			return $scope.tab === tabNum;
		};
		$(".select2").select2();
		$scope.geofenceMapview = function () {
			vm.selectedGeofenceId = vm.selectedGeofence[0].id
			vm.displayGeofenceCases(vm.selectedGeofenceId)
			saveLocationFilter()
		}

		$scope.geofenceTravelledPath = function () {
          
			if (!vm.selectedUserGeofenceId) {
				console.log("No geofence selected");
				return;
			}

			saveLoadPathFilter();
			vm.displayGeofenceCasesInLOadTravel(vm.selectedUserGeofenceId);
		};

		$("#searchOnMap").change(function () {
			var vehicleSelected = JSON.parse($("#searchOnMap").val());
			var vehicleLatLng = ({
				lat: vehicleSelected.latitude,
				lng: vehicleSelected.longitude
			});
			locations.map.setCenter(vehicleLatLng);
			locations.map.setZoom(20);
		});

		function myOption(zoom, center) {
			var myOptions;
			return (myOptions = {
				zoom: zoom,
				center: center,
				scaleControl: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: [
					{
						featureType: "poi",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						elementType: "labels.text.fill",
						stylers: [
							{
								color: "#63666A",
							},
						],
					} /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
					{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [
							{
								color: "#63666A",
							},
						],
					},
					{
						featureType: "road",
						elementType: "labels.icon",
						stylers: [{ visibility: "off" }],
					},
					{
						featureType: "landscape",
						stylers: [
							{
								color: "#efefef",
							},
						],
					},
					{
						featureType: "road.highway",
						elementType: "geometry",
						stylers: [
							{
								color: "#ffffff",
							},
						],
					}
				],
			});
		}

		function geoLocation(map) {
			var infoWindow = new google.maps.InfoWindow();
			var locationButton = document.createElement("button");
			locationButton.setAttribute("title", "Locate Me");
			locationButton.classList.add("custom-map-control-button");
			var geoIcon = document.createElement("i");
			geoIcon.classList.add("fa");
			geoIcon.classList.add("fa-crosshairs");
			geoIcon.classList.add("geo");
			locationButton.appendChild(geoIcon)
			map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
				locationButton
			);

			/* locationButton.addEventListener("click", function () {
				// Try HTML5 geolocation.
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						function (position) {
							var pos = {
								lat: position.coords.latitude,
								lng: position.coords.longitude,
							};
							infoWindow.setPosition(pos);
							infoWindow.setContent("Location found.");	
							infoWindow.open(map);
							map.setCenter(pos);
							map.setZoom(18);
						},
						function () {
							handleLocationError(
								true,
								infoWindow,
								map.getCenter()
							);
						},
						{ enableHighAccuracy: true,
							timeout: 5000,
							maximumAge: 0}
					);
				} else {
					// Browser doesn't support Geolocation
					handleLocationError(
						false,
						infoWindow,
						map.getCenter()
					);
				}
			}); */

			/* function handleLocationError(
				browserHasGeolocation,
				infoWindow,
				pos
			) {
				infoWindow.setPosition(pos);
				infoWindow.setContent(
					browserHasGeolocation
						? "Error: The Geolocation service failed."
						: "Error: Your browser doesn't support geolocation."
				);
				infoWindow.open(map);
			} */
		}

		if ($scope.tab == 1) {
			UserAccount.get(function (data) {
				var isAdmin = false;
				data.authorities.forEach(function (val) {
					if (val == "ROLE_USER_ADMIN") {
						isAdmin = true;
					} else if (val == "ROLE_HOD") {
						isAdmin = true;
					}
				});
				if (isAdmin) {
					vm.adminFilter = true;
					filterUsers();
					vm.updateUsers();
					vm.locateUsers;
					filterAssetsLocationOnMapView()
				} else {
					vm.adminFilter = false;
					filterUsers();
					vm.updateUsers();
					vm.locateUsers;
					filterAssetsLocationOnMapView()
				}
				AssetType.query(
					{
						page: 0,
						size: 100,
						sort: sort(),
					},
					onSuccess,
					onError
				);
				function sort() {
					var result = [
						vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
					];
					if (vm.predicate !== "id") {
						//  result.push('id');
					}
					return result;
				}
				function onSuccess(data, headers) {
					vm.assetTypes = data;
				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
			});
		}

		function getGroupAssetsFromES(geofenceIdVal, lastAssetId, mapAssetLists) {
			AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
				vm.mapAssets = mapAssetLists;
				data.assets.forEach(function (asset) {
					var tmpAsset = {};

					tmpAsset.assetCoordinates = asset.assetCoordinates;
					tmpAsset.assetTypeName = asset.assetTypeName;
					tmpAsset.assetTypeColor = asset.assetColor;
					tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
					tmpAsset.assetTypeLayout = asset.assetTypeLayout;
					tmpAsset.id = asset.id;
					tmpAsset.name = asset.name;

					vm.mapAssets.push(tmpAsset);
				});


				if (data.assets.length < 200) {
					clearMarkers(markers);
					clearPolylines(polylines);

					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						var assetType = vm.assetTypeValues[index];
						var typeName = assetType.assetTypeName;
						var typeAssetsList = [];
						if (assetType.assets != null) {
							typeAssetsList = assetType.assets;
						}

						vm.mapAssets.forEach(function (asset) {
							if (typeName == asset.assetTypeName) {
								typeAssetsList.push(asset);
							}
						});
						assetType.assets = typeAssetsList;
						vm.assetTypeValues[index] = assetType;
					}
					var assetList = [];
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						vm.assetTypeValues[index].assets.forEach(function (assetVal) {
							assetList.push(assetVal);
						});
					}
					drawAssets(assetList);
					// if (vm.selectedLogs === "ALL") {
					// 	vm.all();
					// } else if (vm.selectedLogs === "ACTIVE") {
					// 	vm.active();
					// } else if (vm.selectedLogs === "INACTIVE") {
					// 	vm.inactive();
					// } else if (vm.selectedLogs === "IDLE") {
					// 	vm.idle();
					// }
				}
				if (data.lastId != null) {
					getGroupAssetsFromES(geofenceIdVal, data.lastId, vm.mapAssets);
				} else {
					if (vm.mapAssets.length > 0) {
						var assetSelected = vm.mapAssets[0];
						var centerlatlng = {
							lat: assetSelected.assetCoordinates[0].latitude,
							lng: assetSelected.assetCoordinates[0].longitude
						};
						try {
							locations.map.setCenter(centerlatlng);
							locations.map.setZoom(10);
						} catch (err) {
							console.log(err);
						}
					}
				}
			});
		}

		function getGroupAssetsFromDBPath(geofenceIdVal, lastAssetId, mapAssetLists) {
			AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
				vm.mapUserAssets = mapAssetLists;
				data.assets.forEach(function (asset) {
					var tmpAsset = {};

					tmpAsset.assetCoordinates = asset.assetCoordinates;
					tmpAsset.assetTypeName = asset.assetTypeName;
					tmpAsset.assetTypeColor = asset.assetColor;
					tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
					tmpAsset.assetTypeLayout = asset.assetTypeLayout;
					tmpAsset.id = asset.id;
					tmpAsset.name = asset.name;
					vm.mapUserAssets.push(tmpAsset);
				});


				if (data.assets.length < 200) {
					clearMarkers(markersForPath);
					clearPolylines(polylinesForPath);

					for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
						var assetType = vm.assetTypeValuesPath[index];
						var typeName = assetType.assetTypeName;
						var typeAssetsList = [];
						if (assetType.assets != null) {
							typeAssetsList = assetType.assets;
						}

						vm.mapUserAssets.forEach(function (asset) {
							if (typeName == asset.assetTypeName) {
								typeAssetsList.push(asset);
							}
						});
						assetType.assets = typeAssetsList;
						vm.assetTypeValuesPath[index] = assetType;
					}
					var assetList = [];
					for (var index = 0; index < vm.assetTypeValuesPath.length; index++) {
						vm.assetTypeValuesPath[index].assets.forEach(function (assetVal) {
							assetList.push(assetVal);
						});
					}
					drawAssetsForPath(assetList);

					vm.assetFilterGeofences.forEach(function(value){
						var coordinatesList = JSON.parse(value.coordinates);
						coordinatesList.push(coordinatesList[0]);
						
						if(value.id==vm.selectedUserGeofenceId){
							drawPolylineForGeoFence(coordinatesList, userPaths.map, "green", value.name,null);
						} else {
							drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,null);
						}
					});
				}
				if (data.lastId != null) {
					getGroupAssetsFromDBPath(geofenceIdVal, data.lastId, vm.mapUserAssets);
				} else {
					if (vm.mapUserAssets.length > 0) {
						var assetSelected = vm.mapUserAssets[0];
						var centerlatlng = {
							lat: assetSelected.assetCoordinates[0].latitude,
							lng: assetSelected.assetCoordinates[0].longitude
						};
						try {
							userPaths.map.setCenter(centerlatlng);
							userPaths.map.setZoom(10);
						} catch (err) {
							console.log(err);
						}
					}
				}
			});
		}

		vm.updateUsers = function () {
			vm.locateUsers(function () {
				if (vm.selectedLogs === "ALL") {
					vm.all();
				} else if (vm.selectedLogs === "ACTIVE") {
					vm.active();
				} else if (vm.selectedLogs === "INACTIVE") {
					vm.inactive();
				} else if (vm.selectedLogs === "IDLE") {
					vm.idle();
				} else if (vm.selectedLogs === "ABSENT"){
					vm.absent();
				}
			});
		}
		var updateLogs = function () {

			vm.updateUsers();
			vm.locateUsers;
		}

		var userPaths = {};
		var locations = {};

		function onChangeDate() {
			if (vm.fromDate && vm.toDate) {
				vm.toDate.setHours(23, 59, 59, 999);
				if (vm.fromDate <= vm.toDate) {
					vm.drawUserPath(vm.pathuserid, vm.type);
					userIdSelected = vm.pathuserid;
				} else {
					alert('Selected "From Date" is greater than "To Date" : Please Select Proper Date')
				}
			}
		}

		function customRange() {
			vm.fromDate = null
			vm.toDate = null
			vm.totalDistance = 0;
			$scope.totalDistanceTravelled = "0 kms";
			vm.inProgressDistance = 0
			userPaths.map = new google.maps.Map(document.getElementById("userPath_map_canvas"), myOption(13, userPaths.latlng));
		}
		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
		}
		var date = new Date();

		$scope.options = {
			maxDate: date.setDate(date.getDate())
		};
		function selectRange() {
			selectRangePresent()
			vm.drawUserPath(vm.pathuserid, vm.type);
			userIdSelected = vm.pathuserid;
		}
		function selectRangePresent() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page: vm.page,
				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search: vm.currentSearch
			});
		}

		$scope.$watch('login', function (searchkey, oldval) {
			if (searchkey || oldval)
				drawLatestlocations($filter('filter')($scope.locations, {
					userName: searchkey
				}));
		})

		$scope.openInfoWindow = function (e, selectedMarker) {
			e.preventDefault();
			google.maps.event.trigger(selectedMarker, 'click');
		}

		function drawUserPath(userId) {
			var data = {
				fromDate: vm.fromDate.getTime(),
				toDate: vm.toDate.getTime(),
				userId: userId
			}
			if (vm.type == "user") {
				LocationLogMapPath.getmaplogs(data, function (response) {
					vm.pathuserid = response.id;
					drawlines(response);
				});
			} else {
				LocationLogVehicleMapPath.getmaplogs(data, function (response) {
					vm.pathuserid = response.id;
					drawlines(response);
				});
			}
		}

		vm.locateUsers = function (callback) {
			LocationLogMapPath.locateUsers(function (response) {
				vm.responseLiveLogs = response.liveLogs
				$scope.trCases = response.trCases;
				$scope.locations = response.liveLogs;
				vm.vehicles = response.vehicleLocationList;
				$scope.offDutyUserlocations = response.inactiveUserLogs;
				callback();
			});
		}

		function filterUsers() {
			var isTrue
			if (vm.responseLiveLogs && vm.searchUser) {
				isTrue = vm.responseLiveLogs.find(function (item) {
					return item.login == vm.searchUser
				})
			}

			if (vm.searchUser && !isTrue) {
				LocationLogMapPath.locateUsersLogin(
					vm.searchUser,
					function (response) {

						if (!response || !response.length) {
							alert('User not found');
							return;
						}

						var updatedResponse = [{
							"latitude": response[0].latitude,
							"longitude": response[0].longitude,
							"login": response[0].login,
							"userid": response[0].userId
						}];

						callSelectedLogs(updatedResponse);
					},
					function () {
						alert('User has not traveled today.');
					}
				);
			}


			callSelectedLogs($scope.locations)

		}
		vm.filteredUsers = [];
		vm.showSuggestions = false;

		vm.onUserSearchChange = function () {
			if (!vm.searchUser || vm.searchUser.length < 3) {
				vm.filteredUsers = [];
				vm.showSuggestions = false;
				return;
			}
			var keyword = vm.searchUser.toLowerCase();
			vm.filteredUsers = [];
			for (var i = 0; i < vm.responseLiveLogs.length; i++) {
				var login = vm.responseLiveLogs[i].login.toLowerCase();

				if (login.indexOf(keyword) !== -1) {
					vm.filteredUsers.push(vm.responseLiveLogs[i]);
				}
			}
			vm.showSuggestions = vm.filteredUsers.length > 0;
		};

		vm.selectUser = function (user) {
			vm.searchUser = user.login;
			vm.showSuggestions = false;
			filterUsers();   
		};

		function callSelectedLogs(param) {
			if (vm.selectedLogs === "ALL") {

				drawLatestlocations($filter('filter')(param, {
					'login': vm.searchUser
				}));


			} else {
				$scope.alllength = ($filter('filter')($filter('filter')(param, {
					'status': vm.selectedLogs
				}, true), {
					'login': vm.searchUser
				})).length;
				drawLatestlocations($filter('filter')($filter('filter')(param, {
					'status': vm.selectedLogs
				}, true), {
					'login': vm.searchUser
				}));
			}
		}

		function all() {
			vm.selectedLogs = "ALL";
			if ($stateParams.login == undefined) {
				try {
					$scope.alllength = ($filter('filter')($scope.locations, {
						'login': $stateParams.login
					})).length;
					$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "INACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "IDLE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ABSENT"
					}, true), {
						'login': vm.searchUser
					})).length;
				} catch (err) {
					console.log(err);
				}
				drawLatestlocations($filter('filter')($scope.locations, {
					'login': vm.searchUser
				}));
			} else {
				try {
					$scope.alllength = ($filter('filter')($scope.locations, {
						'login': $stateParams.login
					})).length;
					$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "INACTIVE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "IDLE"
					}, true), {
						'login': vm.searchUser
					})).length;
					$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
						'status': "ABSENT"
					}, true), {
						'login': vm.searchUser
					})).length;
				} catch (err) {
					console.log(err);
				}
				drawLatestlocations($filter('filter')($scope.locations, {
					'login': $stateParams.login
				}));
			}

		}
		function active() {
			vm.selectedLogs = "ACTIVE";
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "INACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "IDLE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ABSENT"
			}, true), {
				'login': vm.searchUser
			})).length;

			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));

		}

		function inactive() {
			vm.selectedLogs = "INACTIVE";
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "IDLE"
			}, true), {
				'login': vm.searchUser
			})).length;
			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));

		}

		function idle() {
			vm.selectedLogs = "IDLE";
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "INACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ABSENT"
			}, true), {
				'login': vm.searchUser
			})).length;

			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));

		}

		function absent() {
			vm.selectedLogs = "ABSENT";
			$scope.absentlength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.idlelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "IDLE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.alllength = ($filter('filter')($scope.locations, {
				'login': $stateParams.login
			})).length;
			$scope.activelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "ACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;
			$scope.inactivelength = ($filter('filter')($filter('filter')($scope.locations, {
				'status': "INACTIVE"
			}, true), {
				'login': vm.searchUser
			})).length;

			drawLatestlocations($filter('filter')($filter('filter')($scope.locations, {
				'status': vm.selectedLogs
			}, true), {
				'login': vm.searchUser
			}));

		}

		function drawLatestVehicles(vehicles) {
			if(vehicles!=undefined){
			vehicles.forEach(function (vehicle) {
				var activeInfoWindow;
				var startMarker = new google.maps.Marker({
					map: locations.map,
					position: new google.maps.LatLng(vehicle.latitude, vehicle.longitude),
					title: vehicle.licenseplate,
					icon: {
						scaledSize: new google.maps.Size(
							32, 32),
						url: 'content/images/car.png',
						anchor: new google.maps.Point(
							(32 / 2) + 16, (32 / 2) + 16),
					}
				});
				var infoWindow = new google.maps.InfoWindow();

				var userContent = document.createElement('div'),
					button;
				userContent.innerHTML = '<div>' +
					'<b>Vehicle Id&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : </b>&nbsp;' + vehicle.vehicleid + '<br>' +
					'<b>License Plate&nbsp; : </b>&nbsp;' + vehicle.licenseplate + '<br>' +
					'<b>GPS IMEI&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : </b>&nbsp;' + vehicle.gpsimei + '<br>' +
					'<b>Vehicle Type&nbsp;&nbsp; : </b>&nbsp;' + vehicle.vehicletype + '</div>';

				button = userContent.appendChild(document.createElement('input'));
				button.type = 'button';
				button.value = 'Load travelled path';
				button.className = "button";
				google.maps.event.addDomListener(button, 'click', function () {
					vm.dateRange = null
					vm.dateRange = 'day'
					selectRangePresent()
					vm.type = "vehicle";
					markerUserName = vehicle.licenseplate;
					userPath(vehicle.vehicleid);
				})
				var infowindowPopup = new google.maps.InfoWindow({
					content: userContent,
					pixelOffset: new google.maps.Size(0, -50),
				});
				google.maps.event.addDomListener(startMarker, 'click', function (event) {
					infowindowPopup.setPosition(new google.maps.LatLng(vehicle.latitude, vehicle.longitude));
					infowindowPopup.open(locations.map);

					if (activeInfoWindow != null)
						activeInfoWindow.close();
					activeInfoWindow = infowindowPopup;

				});

				google.maps.event.addDomListener(startMarker, "click", function (event) {
					google.maps.event.trigger(self, "click");

					infowindowPopup.open(locations.map);
				});
				function userPath(id) {
					vm.userGeofences = [];
					vm.assetFilterGeofences = [];
					vm.selectedUserGeofenceId = null;
					vm.prevSelectedUserGeofenceId = null;
					var ele = document.getElementById("userPathModal");
					$(ele).modal('show');
					vm.drawUserPath(id);
					userIdSelected = id;
				}
			});
		}
		}
        var userMarkersMap = {}; // userid → customMarker
		function drawLatestlocations(response) {
			var markers = [{
				Lat: "0.0",
				Lng: "0.0",
				name: "default"
			}];

			if (response) {
				var activeInfoWindow;
				initializeMap(
					response,
					function (latlang) {
						locations.latlng = latlang;
						var bounds = new google.maps.LatLngBounds();

						setupUsersMap(function () {
							response.sort(function(a, b) {
								return a.createdDateTime - b.createdDateTime;
							});
							$.each(response, function (index, value) {
								
								if (!(vm.selectedLogs === "ALL" && value.status === "ABSENT") && value.latitude != null && value.longitude != null &&
									!isNaN(value.latitude) && !isNaN(value.longitude) &&
									Number(value.latitude) > 0 &&
									Number(value.longitude) > 0) {
									var infoWindow = new google.maps.InfoWindow();

									var infoWindow2 = new google.maps.InfoWindow();

									// Create a custom marker

									var imgbg = document.createElement('img');
									imgbg.className = "marker_back_image";

									if (value.reportingStatus == true) {
										if (value.status === 'ABSENT') {
											imgbg.src = 'content/images/Absent_user.png';
										} else if (value.userRole === 'ROLE_FRT') {
											if (value.status === 'ACTIVE') {
												imgbg.src = 'content/images/frt_active.png';
											} else if (value.status === 'INACTIVE') {
												imgbg.src = 'content/images/frt_inactive.png';
											} else if (value.status === 'IDLE') {
												imgbg.src = 'content/images/frt_idle.png';
											}
										} else {
											if (value.status == 'ACTIVE') {
												if (value.geoStatus == 'IN') {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_active_in.png';
													} else {
														imgbg.src = 'content/images/active_in.png';
													}

												} else {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_active_out.png';
													} else {
														imgbg.src = 'content/images/active_out.png';
													}
												}
											} else if (value.status == 'INACTIVE') {
												if (value.geoStatus == 'IN') {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_inactive_out.png';
													} else {
														imgbg.src = 'content/images/inactive_in.png';
													}
												} else {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_inactive_out.png';
													} else {
														imgbg.src = 'content/images/inactive_out.png';
													}
												}
											} else if (value.status == 'IDLE') {
												if (value.geoStatus == 'IN') {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_idle_in.png';
													} else {
														imgbg.src = 'content/images/idle_in.png';
													}
												} else {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_idle_out.png';
													} else {
														imgbg.src = 'content/images/idle_out.png';
													}
												}
											} else if (value.status == 'Off duty user') {
												if (value.geoStatus == 'IN') {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_off_duty_in.png';
													} else {
														imgbg.src = 'content/images/off_duty_in.png';
													}
												} else {
													if (value.userRole == 'ROLE_PATROLLER') {
														imgbg.src = 'content/images/pat_off_duty_out.png';
													} else {
														imgbg.src = 'content/images/off_duty_out.png';
													}
												}
											}
										}
									} else {
										if (value.status === 'ABSENT') {
											imgbg.src = 'content/images/Absent_user.png';
										} else if (value.geoStatus == 'IN') {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_caseactive_in.png';
											} else {
												imgbg.src = 'content/images/case_active_in.png';
											}
											if (value.userRole == 'ROLE_FRT') {
												imgbg.src = 'content/images/Inactive_FRT.png'
											}
										} else {
											if (value.userRole == 'ROLE_PATROLLER') {
												imgbg.src = 'content/images/pat_caseactive_out.png';
											} else {
												imgbg.src = 'content/images/case_active_out.png';
											}
											if (value.userRole == 'ROLE_FRT') {
												imgbg.src = 'content/images/Inactive_FRT.png'
											}
										}

									}

									if (value.address == 'SOS') {
										imgbg.src = 'content/images/alert.png'
									}

									if ($scope.trCases != undefined && $scope.trCases.length > 0) {

										$.each($scope.trCases, function (index, value) {

											var infoWindow = new google.maps.InfoWindow();
											var startMarker = new google.maps.Marker({
												map: locations.map,
												position: new google.maps.LatLng(value.pinLat, value.pinLong),
												title: value.description,

											});
											var infoWindow2 = new google.maps.InfoWindow();
											if (value.priority == 'LOW') {
												startMarker.setIcon('content/images/Pointers-L4.png');
											} else if (value.priority == 'MEDIUM') {

												startMarker.setIcon('content/images/Pointers-M4.png');
											} else if (value.priority == 'HIGH') {
												startMarker.setIcon('content/images/Pointers-H4.png');
											} else if (value.priority == 'CRITICAL') {
												startMarker.setIcon('content/images/Pointer-C4.png');
											}
											var span = '<a userId="' + value.geofenceName + '" class="userpath" >Load travelled path</a>';
											startMarker.content = '<div class="infoWindowContent"><b>Incident Id : </b>' + value.id + '<br> <b>Reported By :</b> ' + value.reportedByUser
												+ '<br> <b> Assigned To :</b> ' + value.assignedToUser + '<br> <b>Address :</b> ' + value.address + '</div>';

											$compile(startMarker.content)($scope);

											google.maps.event.addListener(startMarker, 'mouseover', function () {
												infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
												infoWindow.open(locations.map, startMarker);
											});
											// on mouseout
											google.maps.event.addListener(startMarker, 'mouseout', function () {
												infoWindow.close();
											});

											var activeInfoWindow;
											// add content to
											// InfoWindow for
											// click event
											infoWindow2.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);
										})
									}

									function customMarker() {
										this.latlng = new google.maps.LatLng(value.latitude, value.longitude);
										this.setMap(locations.map);
										this.status = value.status;
										this.title = value.login;
										this.icon = imgbg;
									}

									bounds.extend(new google.maps.LatLng(value.latitude, value.longitude));

									var userContent = document.createElement('div'),
										button;

									google.maps.event.addDomListener(imgbg, 'click', function () {
										if (value.userImage != null) {
											UserDetails.getUserDetails(value.login, function (userResp) {
												var firstName = userResp.firstName || '';
												var lastName = userResp.lastName || '';
												var phone = value.phone || 'NA';
												var masterGeofence = userResp.masterGeofences
												var miniGeofence = userResp.miniGeofences
												var reportingTo = userResp.reportingTo
												var distanceTravelled = userResp.distanceTravelled
												var address = value.address || 'NA';
												var selfieImg = userResp.selfyImage;
												var imageSrc = 'content/images/userimg.gif';
												var createdDateTime = formatIST(value.createdDateTime);

												if (selfieImg) {
													imageSrc = 'data:image/jpeg;base64,' + selfieImg;
												}
												userContent.innerHTML =
													'<div class="infoWindowhead" style="position:relative;">' + value.login + '</div>' +
													'<div class="infoWindowContent"style="width:400px;">' +
													'<div style="text-align:center;margin-bottom:6px;">' +
													'<img src="' + imageSrc + '" style="width:80px;height:80px;border-radius:50%;border:2px solid #ccc;" />' +
													'</div>' +
													'<p><b>Name</b> : ' + firstName + ' ' + lastName + '</p>' +
													'<p><b>Phone</b> : ' + phone + '</p>' +
													'<p><b>District</b> : ' + masterGeofence + '</p>' +
													'<p><b>Block</b> : ' + miniGeofence + '</p>' +
													'<p><b>Reporting To</b> : ' + reportingTo + '</p>' +
													'<p><b>Distance Travelled</b> : ' + distanceTravelled + "km" + '</p>' +
													'<p><b>Address</b> : ' + address + '</p>' +
													'<p><b>Captured On :</b> ' + createdDateTime + '</p>' +
													'</div>'

												var button = document.createElement('input');
												button.type = 'button';
												button.value = 'Load travelled path';
												button.className = 'button';
												button.style.position = 'absolute';
												button.style.right = '6px';
												button.style.top = '4px';
												button.style.fontSize = '14px';
												button.style.textDecoration = 'none';

												var header = userContent.querySelector('.infoWindowhead');
												header.appendChild(button);

												// userContent.appendChild(button);

												google.maps.event.addDomListener(button, 'click', function () {
													markerUserName = value.login;
													vm.userPhoneNumber = value.phone
													userPath(value.userid);
												})
											})
										} else {

											UserDetails.getUserDetails(value.login, function (userResp) {

												var firstName = userResp.firstName || '';
												var lastName = userResp.lastName || '';
												var phone = value.phone || 'NA';
												var masterGeofence = userResp.masterGeofences
												var miniGeofence = userResp.miniGeofences
												var reportingTo = userResp.reportingTo
												var distanceTravelled = userResp.distanceTravelled
												var address = value.address || 'NA';

												var selfieImg = userResp.selfyImage;

												var imageSrc = 'content/images/userimg.gif';

												var createdDateTime = formatIST(value.createdDateTime);

												if (selfieImg) {
													imageSrc = 'data:image/jpeg;base64,' + selfieImg;
												}

												userContent.innerHTML =
													'<div class="infoWindowhead" style="position:relative;">' + value.login + '</div>' +
													'<div class="infoWindowContent"style="width:400px;">' +
													'<div style="text-align:center;margin-bottom:6px;">' +
													'<img src="' + imageSrc + '" style="width:80px;height:80px;border-radius:50%;border:2px solid #ccc;" />' +
													'</div>' +
													'<p><b>Name</b> : ' + firstName + ' ' + lastName + '</p>' +
													'<p><b>Phone</b> : ' + phone + '</p>' +
													'<p><b>District</b> : ' + masterGeofence + '</p>' +
													'<p><b>Block</b> : ' + miniGeofence + '</p>' +
													'<p><b>Reporting To</b> : ' + reportingTo + '</p>' +
													'<p><b>Distance Travelled</b> : ' + distanceTravelled + "km" + '</p>' +
													'<p><b>Address</b> : ' + address + '</p>' +
													'<p><b>Captured On :</b> ' + createdDateTime + '</p>' +
													'</div>'

												var button = document.createElement('input');
												button.type = 'button';
												button.value = 'Load travelled path';
												button.className = 'button';
												button.style.position = 'absolute';
												button.style.right = '6px';
												button.style.top = '4px';
												button.style.fontSize = '14px';
												button.style.textDecoration = 'none';
												var header = userContent.querySelector('.infoWindowhead');
												header.appendChild(button);

												google.maps.event.addDomListener(button, 'click', function () {
													vm.dateRange = 'day';
													vm.userPhoneNumber = value.phone;

													selectRangePresent();
													vm.type = 'user';
													markerUserName = value.login;
													userPath(value.userid);
												});
											})
											userPathId = value.userid;
										}
									})

									function formatIST(utcMillis) {
										var date = new Date(utcMillis); // auto converts to IST

										var months = ["Jan","Feb","Mar","Apr","May","Jun",
													"Jul","Aug","Sep","Oct","Nov","Dec"];

										var month = months[date.getMonth()];
										var day = date.getDate();
										var year = date.getFullYear();

										var hours = date.getHours();
										var minutes = date.getMinutes();
										var seconds = date.getSeconds();

										var ampm = hours >= 12 ? "PM" : "AM";
										hours = hours % 12;
										hours = hours ? hours : 12;

										minutes = minutes < 10 ? "0" + minutes : minutes;
										seconds = seconds < 10 ? "0" + seconds : seconds;

										return month + " " + day + ", " + year + " " +
											hours + ":" + minutes + ":" + seconds + " " + ampm;
									}
									function userPath(id) {
										vm.userGeofences = [];
										vm.assetFilterGeofences = [];
										vm.selectedUserGeofenceId = null;
										vm.prevSelectedUserGeofenceId = null;
										var ele = document.getElementById("userPathModal");
										$(ele).modal('show');
										vm.drawUserPath(id);
										userIdSelected = id;
										var cleratodatefromdate = vm.today();
									}
									var infowindowPopup = new google.maps.InfoWindow({
										content: userContent,
										pixelOffset: new google.maps.Size(0, -50),
									});

									

									customMarker.prototype = new google.maps.OverlayView();

									customMarker.prototype.draw = function () {
										var self = this;
										var div = this.div;

										if (!div) {

											div = this.div = document.createElement('div');
											div.id = 'marker';
											div.style.width = '100px';
											div.style.height = '100px';

											var div_pointer = document.createElement('div');
											div_pointer.className = 'triangle';

											var image_container = document.createElement('div');
											image_container.className = 'image_container';

											var img = document.createElement('img');
											img.className = "marker_image";
											var image2 = "data:image/png;base64,";
											image2 += value.userImage;
											if (value.userImage == undefined) {
												image2 = "content/images/userimg.gif";
											}

											img.src = image2;

											var name_container = document.createElement('div');
											name_container.className = 'name_container';

											var exit = document.createElement('div');
											exit.className = 'exit';
											exit.innerHTML = '<img className="exit_image" style="width:30px; height:30px;" src="https://cdn0.iconfinder.com/data/icons/large-glossy-icons/512/Delete.png">'
												+ '</img>';
											exit.style.display = 'none';

											div.appendChild(image_container);
											image_container.appendChild(img);
											image_container.appendChild(imgbg);

											div.appendChild(exit);

											name_container.onmouseover = function () {
												name_container.style.opacity = '0.6';
												div.style.zIndex = '1000'
											};
											name_container.onmouseout = function () {
												name_container.style.opacity = '0';
												div.style.zIndex = '100'
											};

											if (this.status === 'ABSENT') {
												div.style.opacity = '0.5';
											}

											// add content to
											// InfoWindow for
											// click event
											infoWindow2.setContent('<div class="infoWindowhead">' + value.login + '</div>' + userContent);
											if (activeInfoWindow != null)
												activeInfoWindow.close();

											google.maps.event.addDomListener(imgbg, 'click', function (event) {
												infowindowPopup.setPosition(new google.maps.LatLng(value.latitude, value.longitude));
												infowindowPopup.open(locations.map);

												if (activeInfoWindow != null)
													activeInfoWindow.close();

												activeInfoWindow = infowindowPopup;

											});

											google.maps.event.addDomListener(imgbg, "click", function (event) {
												google.maps.event.trigger(self, "click");

												infowindowPopup.open(locations.map);
											});

											var panes = this.getPanes();

											panes.overlayImage.appendChild(div);

										}

										var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

										if (point) {
											div.style.left = (point.x - 50) + 'px';
											div.style.top = (point.y - 125) + 'px';
										}
									}
									
									customMarker.prototype.remove = function () {

										if (this.div) {
											this.div.parentNode.removeChild(this.div);
											this.div = null;
										}
									}

									customMarker.prototype.getPosition = function () {
										return this.latlng;
									}
									markers.forEach(function (marker) {
										// image =
										// value.userImage;

										var overlay = new customMarker();
									});
									var overlay = new customMarker();
									userMarkersMap[value.userid] = overlay;


								}
							});

							locations.map.fitBounds(bounds);
						});
					});
			}
			drawLatestVehicles(vm.vehicles);

		}
		var lastHoveredUserId = null;

		$scope.highlightUser = function (userId) {
			if (lastHoveredUserId === userId) return;

			lastHoveredUserId = userId;

			var marker = userMarkersMap[userId];
			if (marker && marker.latlng) {
				locations.map.panTo(marker.latlng);
				locations.map.setOptions({
					gestureHandling: 'greedy'
				});
				if (locations.map.getZoom() < 16) {
					locations.map.setZoom(16);
				}
				if (marker.div) {
				    marker.div.style.transform = 'scale(2)';
				}
			}
		};


		$scope.removeHighlight = function (userId) {
			var marker = userMarkersMap[userId];
			if (marker && marker.div) {
				marker.div.style.transform = 'scale(1)';
				marker.div.style.zIndex = '100';
				marker.div.style.boxShadow = 'none';
			}
			locations.map.setZoom(14);
		};

		function setupUsersMap(callback) {

			locations.map = new google.maps.Map(document.getElementById("map_canvas"), myOption(21, locations.latlng));
			geoLocation(locations.map)
			locations.overlay = new google.maps.OverlayView();
			locations.overlay.draw = function () {
			};
			locations.overlay.setMap($scope.map);
			locations.element = document.getElementById('map_canvas');
			callback();
			if (vm.assetTypeValues != null) {
				if (vm.assetTypeValues.length > 0) {
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						var assetType = vm.assetTypeValues[index];
						var typeName = assetType.assetTypeName;
						var typeAssetsList = [];
						if (assetType.assets != null) {
							typeAssetsList = assetType.assets;
						}

						vm.mapAssets.forEach(function (asset) {
							if (typeName == asset.assetTypeName) {
								typeAssetsList.push(asset);
							}
						});
						assetType.assets = typeAssetsList;
						vm.assetTypeValues[index] = assetType;
					}
					var assetList = [];
					for (var index = 0; index < vm.assetTypeValues.length; index++) {
						vm.assetTypeValues[index].assets.forEach(function (assetVal) {
							assetList.push(assetVal);
						});
					}
					drawAssets(assetList);
				}
			}
		}

		function drawAssets(response) {
			if (response) {
				$.each(response, function (index, value) {
					if (value.assetTypeLayout == null) {
						value.assetTypeName = value.assetType.name;
						value.assetTypeLayout = value.assetType.layout;
						value.assetTypeImagePath = value.assetType.imagePath;
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
						if (value.assetCoordinates.length > 1) {
							var value1 = value;
							value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

							drawFixedAsset(value1, false);

						} else {
							drawFixedAsset(value, false);
						}
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
						drawPolyline(value, locations.map);
					}

				});
			}
		}

		function drawAssetsForPath(response) {
			if (response) {
				$.each(response, function (index, value) {
					if (value.assetTypeLayout == null) {
						value.assetTypeName = value.assetType.name;
						value.assetTypeLayout = value.assetType.layout;
						value.assetTypeImagePath = value.assetType.imagePath;
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
						if (value.assetCoordinates.length > 1) {
							var value1 = value;
							value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

							drawFixedAssetForPath(value1, false);

						} else {
							drawFixedAssetForPath(value, false);
						}
					}
					if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
						drawPolylineForPath(value, userPaths.map);
					}

				});
			}
		}

		function drawFixedAsset(fixed, hasParent) {

			$.each(fixed.assetCoordinates, function (index, value1) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}

				var infoWindow = new google.maps.InfoWindow();


				var iconUrl = "";
				var isFixedAsset = false;
				iconUrl = fixed.assetTypeImagePath;
				isFixedAsset = true;

				var iconSize = 8;


				if (isFixedAsset) {
					iconSize = 24;
				}

				var startMarker = new google.maps.Marker({
					map: locations.map,
					position: new google.maps.LatLng(
						value1.latitude,
						value1.longitude),
					title: fixed.name,
					icon: {
						scaledSize: new google.maps.Size(
							iconSize, iconSize),
						url: iconUrl,
						anchor: new google.maps.Point(
							iconSize / 2, iconSize / 2),
					},
				});

				markers.push(startMarker);

				var infoWindow2 = new google.maps.InfoWindow();
				var infoStr = "";
				var otdr = "";

				var userContent = document.createElement('div'),
					button;

				userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
					'</div><div class="infoWindowContent">' +
					'<b>Lat</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
					'<br><b>Long</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
					'<br>' + infoStr + '</div>';

				google.maps.event.addListener(startMarker,
					'dblclick',
					function () {
						infoWindow2.close();
					});

				var activeInfoWindow;
				var infoWindow2 = new google.maps.InfoWindow({
					content: userContent
				});
				// add listener on InfoWindow for click
				// event
				google.maps.event.addListener(startMarker, 'click', function () {
					AssetByID.get(fixed.id, function (response) {
						var infoWindow2 = new google.maps.InfoWindow();
						var infoStr = "";
						var otdr = "";
						var assetTypeAttributeValuesList = response.assetTypeAttributeValues;
						assetTypeAttributeValuesList.sort(function (a, b) {
							var nameA = a.assetTypeAttribute.name.toLowerCase(),
								nameB = a.assetTypeAttribute.name.toLowerCase()
							if (nameA < nameB) // sort string ascending
								return -1
							if (nameA > nameB)
								return 1
							return 0 // default return value (no sorting)
						});
						for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
							var home = assetTypeAttributeValuesList[i];
							infoStr += '<br><b>' +
								home.assetTypeAttribute.name +
								'</b> : ' +
								home.attributeValue;
							otdr = home;
						}

						var userContent = document.createElement('div'),
							button;
						userContent.innerHTML = '<div class="infoWindowhead">' + "<b>Name</b> : " + startMarker.title +
							'</div><div class="infoWindowContent">' +
							"<b>Asset Type</b> : " + fixed.assetTypeName +
							"<br><b>Latitude</b> :" +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
							'<br><b>Longitude</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
							'<br>' + infoStr + '</div>';

						button = userContent.appendChild(document.createElement('input'));
						button.type = 'button';
						button.value = 'Creat Incident';
						button.className = "button";

						google.maps.event.addDomListener(button, 'click', function () {
							$state.go("tr-case.new", {
								'lat': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude,
								'lng': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude,
								'desc': "Incident for " + fixed.name
							});
						});


						var infoWindow2 = new google.maps.InfoWindow({
							content: userContent
						});
						if (prevInfoWindow != null)
							prevInfoWindow.close();
						infoWindow2.open(locations.map, startMarker);
						setTimeout(function () { infoWindow2.close(); }, 5000);

						activeInfoWindow = infoWindow2;
						prevInfoWindow = infoWindow2;
					});

				});
				openedInfoWindow = infoWindow2;
			});
		}

		function drawPolyline(spread, map) {

			var spreadAssetCoordinates = [];
			var spreadColor = 0;
			var spreadWidth = 0;
			var spreadOpacity = 0;

			vm.assetTypes.forEach(function (assetType) {
				if (assetType.name == spread.assetTypeName) {
					spreadColor = assetType.colorcode;
					spreadWidth = assetType.lineWidth * 0.05;
					spreadOpacity = assetType.transparency * 0.01;
				}
			});

			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spreadColor;
				}
				var polylineWeight = spreadWidth;
				var strokeOpacityVal = spreadOpacity;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false,
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div');

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + "<br><b>Asset Type : </b> " + spread.assetType.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(locations.map);
						openedInfoWindow = infowindow;
					}
				});

				var polylinepathDuct = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				polylinepath.setMap(locations.map);
				polylines.push(polylinepath);
			}
		}

		function drawFixedAssetForPath(fixed, hasParent) {

			$.each(fixed.assetCoordinates, function (index, value1) {
				if (openedInfoWindow != null) {
					openedInfoWindow.close();
				}

				var infoWindow = new google.maps.InfoWindow();


				var iconUrl = "";
				var isFixedAsset = false;
				iconUrl = fixed.assetTypeImagePath;
				isFixedAsset = true;

				var iconSize = 16;
				if (isFixedAsset) {
					iconSize = 24;
				}

				var startMarker = new google.maps.Marker({
					map: userPaths.map,
					position: new google.maps.LatLng(
						value1.latitude,
						value1.longitude),
					title: fixed.name,
					icon: {
						scaledSize: new google.maps.Size(
							iconSize, iconSize),
						url: iconUrl,
						anchor: new google.maps.Point(
							iconSize / 2, iconSize / 2),
					},
				});

				markersForPath.push(startMarker);

				var infoWindow2 = new google.maps.InfoWindow();
				var infoStr = "";
				var otdr = "";

				var userContent = document.createElement('div'),
					button;

				userContent.innerHTML = '<div class="infoWindowhead">' + startMarker.title +
					'</div><div class="infoWindowContent">' +
					'<b>Lat</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
					'<br><b>Long</b> :' +
					fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
					'<br>' + infoStr + '</div>';

				google.maps.event.addListener(startMarker,
					'dblclick',
					function () {
						infoWindow2.close();
					});

				var activeInfoWindow;
				var infoWindow2 = new google.maps.InfoWindow({
					content: userContent
				});
				// add listener on InfoWindow for click
				// event
				google.maps.event.addListener(startMarker, 'click', function () {
					AssetByID.get(fixed.id, function (response) {
						var infoWindow2 = new google.maps.InfoWindow();
						var infoStr = "";
						var otdr = "";
						var assetTypeAttributeValuesList = response.assetTypeAttributeValues;
						assetTypeAttributeValuesList.sort(function (a, b) {
							var nameA = a.assetTypeAttribute.name.toLowerCase(),
								nameB = a.assetTypeAttribute.name.toLowerCase()
							if (nameA < nameB) // sort string ascending
								return -1
							if (nameA > nameB)
								return 1
							return 0 // default return value (no sorting)
						});
						for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
							var home = assetTypeAttributeValuesList[i];
							infoStr += '<br><b>' +
								home.assetTypeAttribute.name +
								'</b> : ' +
								home.attributeValue;
							otdr = home;
						}

						var userContent = document.createElement('div'),
							button;
						userContent.innerHTML = '<div class="infoWindowhead">' + "<b>Name</b> : " + startMarker.title +
							'</div><div class="infoWindowContent">' +
							"<b>Asset Type</b> : " + fixed.assetTypeName +
							"<br><b>Latitude</b> :" +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude +
							'<br><b>Longitude</b> :' +
							fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude +
							'<br>' + infoStr + '</div>';

						button = userContent.appendChild(document.createElement('input'));
						button.type = 'button';
						button.value = 'Creat Incident';
						button.className = "button";

						google.maps.event.addDomListener(button, 'click', function () {
							$state.go("tr-case.new", {
								'lat': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].latitude,
								'lng': fixed.assetCoordinates[fixed.assetCoordinates.length - 1].longitude,
								'desc': "Incident for " + fixed.name
							});
						});


						var infoWindow2 = new google.maps.InfoWindow({
							content: userContent
						});
						if (prevInfoWindow != null)
							prevInfoWindow.close();
						infoWindow2.open(userPaths.map, startMarker);
						setTimeout(function () { infoWindow2.close(); }, 5000);

						activeInfoWindow = infoWindow2;
						prevInfoWindow = infoWindow2;
					});

				});
				openedInfoWindow = infoWindow2;
			});
		}
		vm.toggleAssets = function () {
			if (vm.showAssets) {
				hideAllAssets();
			} else {
				showAllAssets();
			}
		};
		function hideAllAssets() {
		for (var i = 0; i < markersForPath.length; i++) {
			markersForPath[i].setMap(null);
		}
		}

		function showAllAssets() {
			for (var i = 0; i < markersForPath.length; i++) {
				markersForPath[i].setMap(userPaths.map);
			}
		}
		function drawPolylineForPath(spread, map) {

			var spreadAssetCoordinates = [];
			var spreadColor = 0;
			var spreadWidth = 0;
			var spreadOpacity = 0;

			vm.assetTypes.forEach(function (assetType) {
				if (assetType.name == spread.assetTypeName) {
					spreadColor = assetType.colorcode;
					spreadWidth = assetType.lineWidth * 0.05;
					spreadOpacity = assetType.transparency * 0.01;
				}
			});
			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spreadColor;
				}
				var polylineWeight = spreadWidth;
				var strokeOpacityVal = spreadOpacity;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div');

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + "<br><b>Asset Type : </b> " + spread.assetType.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(userPaths.map);
						openedInfoWindow = infowindow;
					}
				});

				var polylinepathDuct = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: 1,
					strokeWeight: 2,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false
				});

				polylinepath.setMap(userPaths.map);

				polylinesForPath.push(polylinepath);
			}
		}

		function drawlines(paths) {
			vm.userPathName = paths.userName;
			var userData = paths;
			if (paths.path.length > 0) {

				var data = [{
					"latitude": paths.path[0].lat,
					"longitude": paths.path[0].lng
				}];
			} else {
				var data = [{
					"latitude": parseFloat($rootScope.DEFAULT_LATITUDE),
					"longitude": parseFloat($rootScope.DEFAULT_LONGITUDE)
				}];
			}
			initializeMap(data, function (latlang) {
				userPaths.latlng = latlang;
				setupMap(function () {
					if (paths && paths.path && paths.path.length > 0) {
						loadUserPaths(paths);
					} else {
						//						resizeMap();
						if (vm.type == "user") {
							UsersGeoFenceData.getGeoFenceData(markerUserName, function (response) {
								vm.userGeofences = [];
								vm.assetFilterGeofences = [];
								$.each(response, function (index, value) {
									if (index === 0) {
										console.log("hello");
            vm.displayGeofenceCasesInLOadTravel(value.id);
            console.log("Called for first geofence:", value.id);
        }
									console.log(value.id)
									if (value.geofenceType != "MASTER") {
										if (value.geofenceType == "MINI") {
											vm.userGeofences.push(value);
											value.label = value.name.substring(0, 15) + "..";
											value.ticked = false;
											vm.assetFilterGeofences.push(value);
											if (vm.selectedUserGeofenceId == null) {
												vm.selectedUserGeofenceId = value.id;
												vm.canUserGeofenceFilter = true;
												vm.mapUserAssets = [];
												AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
													vm.assetTypeValuesPath = assetTypeVal;
													getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
												});
											}
										} else {
											vm.userGeofences.push(value);
										}
									}
								});
							});
						} else {
							VehicleGeoFenceData.getGeoFenceData(paths.id, function (response) {
								vm.userGeofences = [];
								vm.assetFilterGeofences = [];
								$.each(response, function (index, value) {
									if (index === 0) {
										console.log("hello");
            vm.displayGeofenceCasesInLOadTravel(value.id);
            console.log("Called for first geofence:", value.id);
        }
									console.log(value.id)
									if (value.geofenceType != "MASTER") {
										if (value.geofenceType == "MINI") {
											vm.userGeofences.push(value);
											value.label = value.name.substring(0, 15) + "..";
											value.ticked = false;
											vm.assetFilterGeofences.push(value);
											if (vm.selectedUserGeofenceId == null) {
												vm.selectedUserGeofenceId = value.id;
												vm.canUserGeofenceFilter = true;
												vm.mapUserAssets = [];
												AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
													vm.assetTypeValuesPath = assetTypeVal;
													getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
												});
											}
										} else {
											vm.userGeofences.push(value);
										}
									}
								});
							});
						}
						vm.totalDistance = 0;
						$scope.totalDistanceTravelled = "0 kms";
						vm.inProgressDistance = 0
						console.log('there are no user agents found');
					}
				});

				function groupByDeviceAndApp(pathArr) {
					var grouped = {};

					for (var i = 0; i < pathArr.length; i++) {
						var p = pathArr[i];
						var device = p.deviceName || "UNKNOWN_DEVICE";
						var app = p.appName || "UNKNOWN_APP";

						if (!grouped[device]) {
							grouped[device] = {};
						}
						if (!grouped[device][app]) {
							grouped[device][app] = [];
						}

						grouped[device][app].push(p);
					}
					return grouped;
				}

				function drawGroupedPath(pathArr, paths) {
					var prevCor = null;

					for (var i = 0; i < pathArr.length; i++) {
						var pathIn = [];
						var pathOut = [];
						var curr = pathArr[i];
						var color, label;
						if(curr.deviceName=='null'||curr.deviceName==null){
							curr.deviceName='Mobile';
						}
						if (curr.geofenceStatus === "IN") {
							pathIn.push(curr);
							color = "green";
							label = "Inside Geofence <br> "+curr.deviceName;
						} else if (curr.geofenceStatus === "OUT" || curr.geofenceStatus === "OTHER") {
							pathOut.push(curr);
							color = "orange";
							label = "Outside Geofence <br> "+curr.deviceName;
						} else {
							color = "DarkBlue";
							label = "Other";
						}

						if (prevCor != null) {
							var coordinatesList = [];
							coordinatesList.push(prevCor);
							coordinatesList.push(curr);

							drawPolylineForGeoFence(
								coordinatesList,
								userPaths.map,
								color,
								label,
								paths
							);
						}
						prevCor = curr;
						
						drawMarkers(paths, pathArr, pathIn, "green");
						drawMarkers(paths, pathArr, pathOut, "orange");
					}
				}

				function loadUserPaths(paths) {

					var pathArr = paths.path;

					// Group paths
					var groupedPaths = groupByDeviceAndApp(pathArr);

					// Iterate deviceName → appName
					for (var deviceName in groupedPaths) {
						for (var appName in groupedPaths[deviceName]) {

							var groupedArray = groupedPaths[deviceName][appName];

							// Optional: sort by time before drawing
							groupedArray.sort(function (a, b) {
								return a.createdDateTime - b.createdDateTime;
							});

							// Draw polyline for this device+app
							drawGroupedPath(groupedArray, paths);
						}
					}

					// // Existing marker & geofence logic stays SAME
					// drawMarkers(paths, pathArr, [], "green");

					if (vm.type == "user") {
						UsersGeoFenceData.getGeoFenceData(markerUserName, function (response) {
							vm.displayGeofenceCasesInLOadTravel(response[0].id);
							vm.userGeofences = [];
							vm.assetFilterGeofences = [];
							$.each(response, function (index, value) {
								if (value.geofenceType != "MASTER") {
									if (value.geofenceType == "MINI") {
										vm.userGeofences.push(value);
										value.label = value.name.substring(0, 15) + "..";
										value.ticked = false;
										vm.assetFilterGeofences.push(value);
										if (vm.selectedUserGeofenceId == null) {
											vm.selectedUserGeofenceId = value.id;		
											vm.mapUserAssets = [];
											AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
												vm.assetTypeValuesPath = assetTypeVal;
												getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
											});
											vm.canUserGeofenceFilter = true;
										}
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
									} else {
										vm.userGeofences.push(value);
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
									}
								}
							});
						});
					} else {
						VehicleGeoFenceData.getGeoFenceData(paths.id, function (response) {
							vm.displayGeofenceCasesInLOadTravel(response[0].id);
							vm.userGeofences = [];
							vm.assetFilterGeofences = [];
							$.each(response, function (index, value) {
								if (value.geofenceType != "MASTER") {
									if (value.geofenceType == "MINI") {
										vm.userGeofences.push(value);
										value.label = value.name.substring(0, 15) + "..";
										value.ticked = false;
										vm.assetFilterGeofences.push(value);
										if (vm.selectedUserGeofenceId == null) {
											vm.selectedUserGeofenceId = value.id;
											vm.mapUserAssets = [];
											AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
												vm.assetTypeValuesPath = assetTypeVal;
												getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
											});
											vm.canUserGeofenceFilter = true;
										}
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
									} else {
										vm.userGeofences.push(value);
										var coordinatesList = JSON.parse(value.coordinates);
										coordinatesList.push(coordinatesList[0]);
										drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
									}
								}
							});
						});
					}

					if (vm.selectedUserGeofenceId != null) {
						vm.mapUserAssets = [];
						AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
							vm.assetTypeValuesPath = assetTypeVal;
							getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
						});
					}

					Report.getReportingReport({
						id: userIdSelected,
						fromTime: vm.fromDate.getTime(),
						toTime: vm.toDate.getTime()
					}, function (response) {
						response.forEach(function (reporting) {

							if (reporting.userLatitude > 0 && reporting.userLongitude > 0) {
								var iconUrl = 'content/images/Pointer-C4.png';
								if (reporting.reportType == "CHECKIN") {
									iconUrl = 'content/images/Pointers-L4.png';
								} else {
									iconUrl = 'content/images/Pointer-C4.png';
								}
								var startMarker = new google.maps.Marker({
									map: userPaths.map,
									position: new google.maps.LatLng(
										reporting.userLatitude,
										reporting.userLongitude),
									icon: iconUrl,
									title: reporting.userLogin
								});

								google.maps.event.addListener(startMarker, 'click', function (event) {
									var date = new Date(reporting.dateTime);
									var infowindow = new google.maps.InfoWindow(
										{
											content: '<div class="infoWindowhead">' +
												'<b>Name : </b> ' + reporting.userLogin + '</br>' +
												'<b>Reporting Status : </b> ' + reporting.reportType + '</br>' +
												'<b>Reporting Time : </b> ' + date.toString() + '</br>' +
												'<b>LatLng : </b> ' + reporting.userLatitude + ', ' + reporting.userLongitude + '</br>'
										});
									infowindow.open(userPaths.map);
									infowindow.setPosition(event.latLng);
								});
							}
						});
					});
				}

				// function loadUserPaths(paths) {
				// 	var pathIn = [];
				// 	var pathOut = [];
				// 	var pathArr = paths.path;
				// 	var prevCor = null;
				// 	var pathOther = []

				// 	for (var i = 0; i < pathArr.length; i++) {
				// 		if (pathArr[i].geofenceStatus == "IN") {
				// 			pathIn.push(pathArr[i]);

				// 			if (prevCor != null) {
				// 				var coordinatesList = [];
				// 				coordinatesList.push(prevCor);
				// 				coordinatesList.push(pathArr[i]);
				// 				drawPolylineForGeoFence(coordinatesList, userPaths.map, "green", "Inside Geofence",paths);
				// 			}
				// 		} else if (pathArr[i].geofenceStatus == "OUT") {
				// 			pathOut.push(pathArr[i]);

				// 			if (prevCor != null) {
				// 				var coordinatesList = [];
				// 				coordinatesList.push(prevCor);
				// 				coordinatesList.push(pathArr[i]);
				// 				drawPolylineForGeoFence(coordinatesList, userPaths.map, "orange", "Outside Geofence",paths);
				// 			}
				// 		} else {
				// 			pathOther.push(pathArr[i]);

				// 			if (prevCor != null) {
				// 				var coordinatesList = [];
				// 				coordinatesList.push(prevCor);
				// 				coordinatesList.push(pathArr[i]);
				// 				drawPolylineForGeoFence(coordinatesList, userPaths.map, "DarkBlue", "Other",paths);
				// 			}
				// 		}
				// 		prevCor = pathArr[i];
				// 	}

				// 	drawMarkers(paths, pathArr, pathIn, "green");
				// 	drawMarkers(paths, pathArr, pathOut, "orange");
				// 	if (vm.type == "user") {
				// 		UsersGeoFenceData.getGeoFenceData(markerUserName, function (response) {
				// 			vm.userGeofences = [];
				// 			vm.assetFilterGeofences = [];
				// 			$.each(response, function (index, value) {
				// 				if (value.geofenceType != "MASTER") {
				// 					if (value.geofenceType == "MINI") {
				// 						vm.userGeofences.push(value);
				// 						value.label = value.name.substring(0, 15) + "..";
				// 						value.ticked = false;
				// 						vm.assetFilterGeofences.push(value);
				// 						if (vm.selectedUserGeofenceId == null) {
				// 							vm.selectedUserGeofenceId = value.id;
				// 							vm.mapUserAssets = [];
				// 							AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
				// 								vm.assetTypeValuesPath = assetTypeVal;
				// 								getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
				// 							});
				// 							vm.canUserGeofenceFilter = true;
				// 						}
				// 						var coordinatesList = JSON.parse(value.coordinates);
				// 						coordinatesList.push(coordinatesList[0]);
				// 						drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
				// 					} else {
				// 						vm.userGeofences.push(value);
				// 						var coordinatesList = JSON.parse(value.coordinates);
				// 						coordinatesList.push(coordinatesList[0]);
				// 						drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
				// 					}
				// 				}
				// 			});
				// 		});
				// 	} else {
				// 		VehicleGeoFenceData.getGeoFenceData(paths.id, function (response) {
				// 			vm.userGeofences = [];
				// 			vm.assetFilterGeofences = [];
				// 			$.each(response, function (index, value) {
				// 				if (value.geofenceType != "MASTER") {
				// 					if (value.geofenceType == "MINI") {
				// 						vm.userGeofences.push(value);
				// 						value.label = value.name.substring(0, 15) + "..";
				// 						value.ticked = false;
				// 						vm.assetFilterGeofences.push(value);
				// 						if (vm.selectedUserGeofenceId == null) {
				// 							vm.selectedUserGeofenceId = value.id;
				// 							vm.mapUserAssets = [];
				// 							AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
				// 								vm.assetTypeValuesPath = assetTypeVal;
				// 								getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
				// 							});
				// 							vm.canUserGeofenceFilter = true;
				// 						}
				// 						var coordinatesList = JSON.parse(value.coordinates);
				// 						coordinatesList.push(coordinatesList[0]);
				// 						drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
				// 					} else {
				// 						vm.userGeofences.push(value);
				// 						var coordinatesList = JSON.parse(value.coordinates);
				// 						coordinatesList.push(coordinatesList[0]);
				// 						drawPolylineForGeoFence(coordinatesList, userPaths.map, "blue", value.name,paths);
				// 					}
				// 				}
				// 			});
				// 		});
				// 	}

				// 	if (vm.selectedUserGeofenceId != null) {
				// 		vm.mapUserAssets = [];
				// 		AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
				// 			vm.assetTypeValuesPath = assetTypeVal;
				// 			getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
				// 		});
				// 	}

				// 	Report.getReportingReport({
				// 		id: userIdSelected,
				// 		fromTime: vm.fromDate.getTime(),
				// 		toTime: vm.toDate.getTime()
				// 	}, function (response) {
				// 		response.forEach(function (reporting) {

				// 			if (reporting.userLatitude > 0 && reporting.userLongitude > 0) {
				// 				var iconUrl = 'content/images/Pointer-C4.png';
				// 				if (reporting.reportType == "CHECKIN") {
				// 					iconUrl = 'content/images/Pointers-L4.png';
				// 				} else {
				// 					iconUrl = 'content/images/Pointer-C4.png';
				// 				}
				// 				var startMarker = new google.maps.Marker({
				// 					map: userPaths.map,
				// 					position: new google.maps.LatLng(
				// 						reporting.userLatitude,
				// 						reporting.userLongitude),
				// 					icon: iconUrl,
				// 					title: reporting.userLogin
				// 				});

				// 				google.maps.event.addListener(startMarker, 'click', function (event) {
				// 					var date = new Date(reporting.dateTime);
				// 					var infowindow = new google.maps.InfoWindow(
				// 						{
				// 							content: '<div class="infoWindowhead">' +
				// 								'<b>Name : </b> ' + reporting.userLogin + '</br>' +
				// 								'<b>Reporting Status : </b> ' + reporting.reportType + '</br>' +
				// 								'<b>Reporting Time : </b> ' + date.toString() + '</br>' +
				// 								'<b>LatLng : </b> ' + reporting.userLatitude + ', ' + reporting.userLongitude + '</br>'
				// 						});
				// 					infowindow.open(userPaths.map);
				// 					infowindow.setPosition(event.latLng);
				// 				});
				// 			}
				// 		});
				// 	});
				// }

				// added for calculating previous point start
				function previos_dist(i, markers) {
					var locDiff = 0;
					if (i > 0) {
						var data1 = markers[i];
						var data2 = markers[i - 1];
						var radlat1 = Math.PI * data1.lat / 180
						var radlat2 = Math.PI * data2.lat / 180
						var theta = data1.lng - data2.lng
						var radtheta = Math.PI * theta / 180
						var locDiff = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
						locDiff = Math.acos(locDiff)
						locDiff = locDiff * 180 / Math.PI
						locDiff = locDiff * 60 * 1.1515
						locDiff = locDiff * 1.609344
						locDiff = locDiff * 1000
					}
					return locDiff;
				}

				function drawMarkers(userdata, paths, userpath, colorVal) {
					var imgUrl = "content/images/dot.png";
					if (colorVal == "green") {
						imgUrl = "content/images/green_dot.png";
					} else {
						imgUrl = "content/images/orange_dot.png";
					}

					var markers = userpath;

					var infoWindow = new google.maps.InfoWindow();
					var lat_lng = new Array();

					var icon = {
						url: imgUrl, // url
						scaledSize: new google.maps.Size(5, 5),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(0, 0)
					};

					for (var i = 0; i < markers.length; i++) {
						var data = markers[i];
						var locDiff = previos_dist(i, markers);

						var myLatlng = new google.maps.LatLng(data.lat, data.lng);
						lat_lng.push(myLatlng);
						var marker = new google.maps.Marker({
							position: myLatlng,
							map: userPaths.map,
							icon: icon
						});

						(function (marker, data) {

							var logdate;
							if (data.updatedDateTime != 0) {
								logdate = new Date(data.updatedDateTime);

							} else {
								logdate = new Date(data.createdDateTime);
							}

							var logDateTime = $filter('date')(logdate, 'dd MMM HH:mm:ss');

							var travel_data = '<div class="infoWindowhead">' + logDateTime + '</div><div class="infoWindowContent"><div class="rows"><!--<p><strong>Address: </strong>' + data.address + '</p>--><p><strong>Coordinates(Lat , Long): </strong>' + data.lat.toFixed(4)
								+ ' , ' + data.lng.toFixed(4) + '</p><!--<p><strong>DistFromPrevLoc: </strong>' + locDiff.toFixed(2) + ' Meters</p>--></div></div>';

							google.maps.event.addListener(marker, "mouseover", function (e) {
								infoWindow.setContent(travel_data);
								infoWindow.open(userPaths.map, marker);
							});
							google.maps.event.addListener(marker, "mouseout", function (e) {
								infoWindow.close(userPaths.map, marker);
							});
						})(marker, data);


					}

					var infoWindow = new google.maps.InfoWindow();
					var distanceIn = userdata.distanceIn;
					var distanceOut = userdata.distanceOut;
					var distanceUnderived = userdata.distanceUnderived;

					var startMarker = new google.maps.Marker({
						map: userPaths.map,
						position: new google.maps.LatLng(paths[0].lat, paths[0].lng),
						title: 'Started here',
						icon: "content/images/green.png"
					});
					startMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

					google.maps.event.addListener(startMarker, 'mouseover', function () {
						infoWindow.setContent(startMarker.content + '<div class="infoWindowContent">' + startMarker.title + '</div>');
						infoWindow.open(userPaths.map, startMarker);

					});
					google.maps.event.addListener(startMarker, 'mouseout', function () {
						infoWindow.close(userPaths.map, startMarker);
					});

					var infoWindow1 = new google.maps.InfoWindow();
					var endMarker = new google.maps.Marker({
						map: userPaths.map,
						position: new google.maps.LatLng(paths[paths.length - 1].lat, paths[paths.length - 1].lng),
						title: "Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence " + (distanceOut).toFixed(2) + " Km",
						icon: "content/images/red.png"

					})
					if (vm.type == "user") {
						vm.totalDistance = (distanceIn + distanceOut + distanceUnderived).toFixed(2);
						$scope.totalDistanceTravelled = "   Inside Geofence - " + (distanceIn).toFixed(2) + " Km and Outside Geofence - " + (distanceOut).toFixed(2) + " Km";
						vm.inProgressDistance = (distanceUnderived).toFixed(2);
					} else {
						vm.totalDistance = (distanceIn).toFixed(2);
						$scope.totalDistanceTravelled = "";
					}


					endMarker.content = '<div class="infoWindowhead">' + userdata.userName + '</div>';

					google.maps.event.addListener(endMarker, 'mouseover', function () {

						infoWindow1.setContent(endMarker.content + '<div class="infoWindowContent">' + endMarker.title + '</div>');
						infoWindow1.open(userPaths.map, endMarker);

					});
					google.maps.event.addListener(endMarker, 'mouseout', function () {
						infoWindow1.close(userPaths.map, endMarker);
					});
				}
			});

		}

		function setupMap(callback) {

			userPaths.map = new google.maps.Map(document.getElementById("userPath_map_canvas"), myOption(13, userPaths.latlng));
			geoLocation(userPaths.map)
			userPaths.overlay = new google.maps.OverlayView();
			userPaths.overlay.draw = function () {
			};
			userPaths.overlay.setMap(userPaths.map);
			userPaths.element = document.getElementById('userPath');
			callback();
		}

		$scope.$on('$destroy', function () {
			$interval.cancel(updateLogs);
		});

		function initializeMap(latlangs, callback) {
			if (latlangs && latlangs.length > 0) {
				latlng = new google.maps.LatLng(latlangs[0].latitude, latlangs[0].longitude);
				callback(latlng);
			/* } else {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (position) {

						google.maps.event.trigger(locations.map, "resize");
						var centerlatlng = {
							lat: parseFloat($rootScope.DEFAULT_LATITUDE),
							lng: parseFloat($rootScope.DEFAULT_LONGITUDE)
						};
						try {
							locations.map.setCenter(centerlatlng);
						} catch (err) {
							console.log(err);
						}
					}, function () {
						setTimeout(function () {
							google.maps.event.trigger(locations.map, "resize");
							var centerlatlng = {
								lat: parseFloat($rootScope.DEFAULT_LATITUDE),
								lng: parseFloat($rootScope.DEFAULT_LONGITUDE)
							};
							try {
								locations.map.setCenter(centerlatlng);
							} catch (err) {
								console.log(err);
							}
						}, 100);
					});
				} else {
					setTimeout(function () {
						google.maps.event.trigger(locations.map, "resize");
						var centerlatlng = {
							lat: parseFloat($rootScope.DEFAULT_LATITUDE),
							lng: parseFloat($rootScope.DEFAULT_LONGITUDE)
						};
						try {
							locations.map.setCenter(centerlatlng);
						} catch (err) {
							console.log(err);
						}
					}, 100);
				} */
			}
		}


		function drawPolylineForGeoFence(latlngsToDraw, map, color, details, paths) {
			var spreadAssetCoordinates = [];
			$.each(latlngsToDraw, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.lat,
					lng: value.lng
				});
			});

			if (spreadAssetCoordinates.length > 0) {
				var midLatLng = {
					lat: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lat,
					lng: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lng
				};
				var infowindow = new google.maps.InfoWindow(
					{
						content: '<div class="infoWindowhead">'
							+ "name"
							+ '<div class="infoWindowContent"> <b>Description :</b> '
							+ "des" + '</div></div>'
					});

				infowindow.setPosition(midLatLng);
				var lineSymbol = {
					path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
					scale: 2,
				};
				var iconStyle = [{
					icon: lineSymbol,
					offset: '100%',
					repeat: '500px'
				}];

				var ColorValue = '#ff0000';
				if (color == "red") {
					ColorValue = '#ff0000';
				} else if (color == "black") {
					ColorValue = '#000000';
				} else if (color == "blue") {
					ColorValue = '#68A8DE';
				} else if (color == "green") {
					ColorValue = '#00e658';
				} else if (color == "orange") {
					ColorValue = '#fd7a24';
				} else if (color == "DarkBlue") {
					ColorValue = '#CA902E';
				} else {
					ColorValue = '#208000';
				}

				var polylinepath = null;
				var strokeOpacity = 1.0;
				if(paths!=null || paths!=undefined){
					strokeOpacity = paths.stroke.weight;
				}

				if (color == "blue") {
					polylinepath = new google.maps.Polyline({
						path: spreadAssetCoordinates,
						geodesic: true,
						strokeColor: ColorValue,
						strokeOpacity: strokeOpacity,
						strokeWeight: 3
					});
				} else {
					polylinepath = new google.maps.Polyline({
						path: spreadAssetCoordinates,
						geodesic: true,
						strokeColor: ColorValue,
						strokeOpacity: strokeOpacity,
						strokeWeight: 3,
						icons: iconStyle
					});
				}

				polylinepath.setOptions({
					strokeColor: ColorValue
				});

				google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
					infowindow.close();
				});

				google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					infowindow.setContent('<div class="infoWindowhead">'
						+ '</br></br>' + details + '</br></div>'
					);

					infowindow.mousemove;
					infowindow.open(map);
					infowindow.setPosition(event.latLng);
					openedInfoWindow = infowindow;
				});
				polylinepath.setMap(map);
			}
		}

		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;

		}

		$scope.reset = function () {
			vm.userGeofences = [];
			vm.assetFilterGeofences = [];
			vm.selectedUserGeofenceId = null;
			vm.prevSelectedUserGeofenceId = null;
			var cleratodatefromdate = vm.today();
			// cleratodatefromdate.remove();
		}

		function downloadLoadPath() {
			var data = {
				fromDate: vm.fromDate.getTime(),
				toDate: vm.toDate.getTime(),
				userId: vm.pathuserid,
				type: vm.type
			}
			LocationLogMapPath.downloadUserPath(data, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/text' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "TravelledPath.kml";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function filterAssetsLocationOnMapView() {
			vm.allGeofences = []
			if (vm.adminFilter) {
				GeofenceIDs.getAll(function (response) {
					response.forEach(function (geofence) {
						if (geofence.name != 'Bangalore') {
							geofence.label = geofence.name.substring(0, 15) + "..";
							vm.allGeofences.push(geofence);
							if (vm.selectedGeofenceId == null) {
								vm.selectedGeofenceId = geofence.id;
							}
						}
					});
				});
			} else {
				UserGeofences.getAll(function (response) {
					response.forEach(function (geofence) {
						if (geofence.name != 'Bangalore') {
							geofence.label = geofence.name.substring(0, 15) + "..";
							vm.allGeofences.push(geofence);
							if (vm.selectedGeofenceId == null) {
								vm.selectedGeofenceId = geofence.id;
							}
						}
					});
				});
			}
			/* $("#mapFilterLocationModal").show();
			noDataText = document.getElementById("noData");
			noDataText.style.display = "none"; */
			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
		}

		function closeMapLocationFilterModal() {
			$("#mapFilterLocationModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLocationModal").hide();
			vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
		}

		function filterAssetsLoadOnMapView() {
			$("#mapFilterLoadPathModal").show();
			noDataText = document.getElementById("noData");
			noDataText.style.display = "none";
			vm.prevSelectedUserGeofenceId = vm.selectedUserGeofenceId;
		}

		function closeMapLoadPathFilterModal() {
			$("#mapFilterLoadPathModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLoadPathModal").hide();
			vm.selectedUserGeofenceId = vm.prevSelectedUserGeofenceId;
		}
			$scope.onDateChange = function () {
            onChangeDate(vm.pathuserid);
            };

		function saveLoadPathFilter() {

			// onChangeDate(vm.pathuserid);

			vm.mapUserAssets = [];

			AssetTypesByGeofenceID.get(vm.selectedUserGeofenceId, function (assetTypeVal) {
				vm.assetTypeValuesPath = assetTypeVal;
				getGroupAssetsFromDBPath(vm.selectedUserGeofenceId, null, vm.mapUserAssets);
			});

			vm.prevSelectedUserGeofenceId = vm.selectedUserGeofenceId;
		}

		function clearMarkers(markersList) {
			for (var i = 0; i < markersList.length; i++) {
				markersList[i].setMap(null);
			}
		}

		function clearPolylines(polylinesList) {
			for (var i = 0; i < polylinesList.length; i++) {
				polylinesList[i].setMap(null);
			}
		}


		function saveLocationFilter() {
			vm.polygon.forEach(function(polygon){
				polygon.setMap(null);
			});
			vm.polygon = [];
			vm.mapAssets = [];
			AssetTypesByGeofenceID.get(vm.selectedGeofenceId, function (assetTypeVal) {
				vm.assetTypeValues = assetTypeVal;
				getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
			});

			vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
			GeofenceByID.get(vm.selectedGeofenceId, function (geofenceDetails) {
				var path = JSON.parse(geofenceDetails.coordinates);
				var infowindow = new google.maps.InfoWindow({
					content:
						'<div class="infoWindowhead">' +
						"name" +
						'<div class="infoWindowContent"> <b>Description :</b> ' +
						"des" +
						"</div></div>",
				});

				if(path.length>0){
					infowindow.setPosition(path[0]);
				}
				var strokeColor = "#0066CC";

				var tempPolygon = new google.maps.Polygon({
					paths: path,
					strokeColor: strokeColor,
					strokeOpacity: 0.5,
					strokeWeight: 1.2,
					fillColor: strokeColor,
					fillOpacity: 0.1,
					zIndex:-1
				});			
				google.maps.event.addListener(
					tempPolygon,
					"click",
					function (event) {
						if (openedInfoWindow != null) {
							openedInfoWindow.close();
						}
						infowindow.setContent(
							'<div class="infoWindowhead">' +
							"<b>Geofence </b><br><br>" +
							geofenceDetails.name +
							"</br></div>"
						);

						infowindow.mousemove;
						infowindow.open(locations.map);
						infowindow.setPosition(event.latLng);
						openedInfoWindow = infowindow;

						//geoLocation(locationsCity.mapCity)
					}
            );
				tempPolygon.setMap(locations.map);
				vm.polygon.push(tempPolygon);																				
			});
			$("#mapFilterLocationModal").removeClass("in");
			$(".modal-backdrop").remove();
			$("#mapFilterLocationModal").hide();
		}

		function drawPolyline(spread, map) {

			var spreadAssetCoordinates = [];
			var spreadColor = 0;
			var spreadWidth = 0;
			var spreadOpacity = 0;

			vm.assetTypes.forEach(function (assetType) {
				if (assetType.name == spread.assetTypeName) {
					spreadColor = assetType.colorcode;
					spreadWidth = assetType.lineWidth * 0.05;
					spreadOpacity = assetType.transparency * 0.01;
				}
			});
			$.each(spread.assetCoordinates, function (index, value) {

				spreadAssetCoordinates.push({
					lat: value.latitude,
					lng: value.longitude
				});
			});
			if (spreadAssetCoordinates.length > 1) {
				var midLatLng = {
					lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
					lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
				};

				var polylineColor = '';
				var distanceFromPOP = '';
				var fiberCoreVal = '';
				var infowindow = null;
				if (spread.assetTypeLayout == "SPREAD") {
					polylineColor = spreadColor;
				}
				var polylineWeight = spreadWidth;
				var strokeOpacityVal = spreadOpacity;

				var polylinepath = new google.maps.Polyline({
					path: spreadAssetCoordinates,
					geodesic: true,
					strokeColor: polylineColor,
					strokeOpacity: strokeOpacityVal,
					strokeWeight: polylineWeight,
					fillColor: polylineColor,
					fillOpacity: 0.3,
					editable: false,
				});

				google.maps.event.addListener(polylinepath, 'click', function (event) {
					if (openedInfoWindow != null) {
						openedInfoWindow.close();
					}
					var disVal = 0;
					var cLocations = [];

					if (spread.description == null || spread.description == undefined) {
						spread.description = "";
					}

					if (spread.assetTypeLayout == "SPREAD") {
						AssetByID.get(spread.id, function (assetVal) {
							spread = assetVal;
							var infoStr = "";
							var assetTypeAttributeValuesList = spread.assetTypeAttributeValues;
							assetTypeAttributeValuesList.sort(function (a, b) {
								var nameA = a.assetTypeAttribute.name.toLowerCase(),
									nameB = b.assetTypeAttribute.name.toLowerCase()
								if (nameA < nameB) // sort string ascending
									return -1
								if (nameA > nameB)
									return 1
								return 0 // default return value (no sorting)
							});
							for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
								var home = assetTypeAttributeValuesList[i];

								var attrVal = "";
								if (home.attributeValue != null) {
									attrVal = home.attributeValue;
								}
								infoStr += '<br><b>' +
									home.assetTypeAttribute.name +
									'</b> : ' +
									attrVal;
							}
							var spreadCoordinates = spread.assetCoordinates;
							if (spreadCoordinates.length > 0) {
								for (var index in spreadCoordinates) {
									if (index > 0) {
										disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
									}
								}
							}

							var userContent = document.createElement('div');

							userContent.innerHTML = '<div class="infoWindowhead">' +
								'<b>Name : </b> ' + spread.name + "<br><b>Asset Type : </b> " + spread.assetType.name + '</br>' +
								'<b>Distance : </b> ' + (parseFloat(disVal)).toFixed(2) + ' Km</br>';

							infowindow = new google.maps.InfoWindow({
								content: userContent
							});
						});
					}
					if (infowindow != null) {
						infowindow.setPosition(event.latLng);
						infowindow.open(map);
						openedInfoWindow = infowindow;
					}
				});

				polylinepath.setMap(map);

				polylines.push(polylinepath);
			}
		}


		function distanceCal(lat1, lon1, lat2, lon2) {
			var theta = lon1 - lon2;
			var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
				Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
			dist = Math.acos(dist);
			dist = radians_to_degrees(dist);
			dist = dist * 60 * 1.1515;
			dist = dist * 1.609344;
			if (isNaN(dist)) {
				return 0.0;
			} else {
				return (dist);
			}
		}

		function degrees_to_radians(degrees) {
			var pi = Math.PI;
			return degrees * (pi / 180);
		}

		function radians_to_degrees(radians) {
			var pi = Math.PI;
			return radians * (180 / pi);
		}
			vm.geofenceCaseMarkers = [];
			vm.showGeofenceCases = true;

			function clearGeofenceCaseMarkers() {
				for (var i = 0; i < vm.geofenceCaseMarkers.length; i++) {
					vm.geofenceCaseMarkers[i].setMap(null);
				}
				vm.geofenceCaseMarkers = [];
			}

				vm.displayGeofenceCases=function(geofenceId){
					clearGeofenceCaseMarkers();
					var sendData={
						geofenceId: geofenceId,
					}
						TrCaseForMap.getAllCases(
							sendData,
							function (response) {
								vm.geofenceCaseResponse = response
						drawLatestTrCases(vm.geofenceCaseResponse)
							}
				)
				}
function clearGeofenceMarkers() {
    vm.geofenceMarkers.forEach(function (m) {
        m.setMap(null);
    });
    vm.geofenceMarkers = [];
}

vm.displayGeofenceCasesInLOadTravel = function (geofenceId) {
    clearGeofenceMarkers();

    TrCaseForMap.getAllCases({ geofenceId: geofenceId }, function (response) {
        drawLatestTrCasesOnTravel(response);
    });
};

				function drawLatestTrCases(data){
					data.forEach(function(value){
                    var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });
						vm.geofenceCaseMarkers.push(startMarker);
						var userContent = document.createElement("div"),
                            button;

                        var infoWindow = new google.maps.InfoWindow({
                            content: userContent,
                        });
                        var infoWindow2 = new google.maps.InfoWindow();
                        // if(value.userCase=='C'){
                        if(value.status=='RESOLVED' || value.status=='CLOSED' || value.status=='CANCELLED'){
                                 startMarker.setIcon(
                                    "content/images/Pointers-L5.png"
                                );
                                startMarker.setZIndex(10);
                        } else {
                            startMarker.setZIndex(11);
                            if (value.priority == "LOW") {
                                startMarker.setIcon(
                                    "content/images/Pointers-L4.png"
                                );
                            } else if (value.priority == "MEDIUM") {
                                startMarker.setIcon(
                                    "content/images/Pointers-M4.png"
                                );
                            } else if (value.priority == "HIGH") {
                                startMarker.setIcon(
                                    "content/images/Pointers-H4.png"
                                );
                            } else if (value.priority == "CRITICAL") {
                                startMarker.setIcon(
                                    "content/images/Pointer-C4.png"
                                );
                            }
                        }
						userContent.innerHTML =
                            '<div class="infoWindowhead">' +
                            startMarker.title +
                            '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b> Status :</b> " +
                            value.status +                            
                            "</div>";
							button = userContent.appendChild(
                            document.createElement("input")
                        );
                        button.type = "button";
                        button.value = "Incident Details";
                        button.className = "button";

                        google.maps.event.addDomListener(
                            button,
                            "click",
                            function () {
                                $state.go("tr-case-detail", {
                                    id: value.id,
                                });
                            }
                        );
                        $compile(userContent)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "click",
                            function () {
                                // infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + userContent);
                                // infoWindow.open(locations.map, startMarker);
                                TrCaseById.get(value.id, function (response) {

                                     var infoStr = "";
                                    var caseTypeAttributeValuesList =
                                        response.caseTypeAttributeValues;
                                    caseTypeAttributeValuesList.sort(function (a, b) {
                                        var nameA = a.caseTypeAttribute.name.toLowerCase(),
                                            nameB = a.caseTypeAttribute.name.toLowerCase();
                                        if (nameA < nameB)
                                            // sort string ascending
                                            return -1;
                                        if (nameA > nameB) return 1;
                                        return 0; // default return value (no sorting)
                                    });
                                    for (
                                        var i = 0;
                                        i < caseTypeAttributeValuesList.length;
                                        i++
                                    ) {
                                        var home = caseTypeAttributeValuesList[i];
                                        infoStr +=
                                            "<br><b>" +
                                            home.caseTypeAttribute.name +
                                            "</b> : " +
                                            home.attributeValue;
                                    }

                                    userContent.innerHTML =
                                        '<div class="infoWindowhead">' +
                                        response.description +
                                        '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                                        value.id +
                                        "<br><b>Description : </b>" +
                                        response.description +
                                        "<br><b>Incident Type : </b>" +
                                        response.caseType.name +
                                        "<br> <b>Reported By :</b> " +
                                        response.reportedByUser +
                                        "<br> <b> Assigned To :</b> " +
                                        response.assignedToUser +
                                        "<br> <b> Status :</b> " +
                                        response.status +                                        
                                        "<br> " +
                                        infoStr +
                                        "</div>";
										infoWindow = new google.maps.InfoWindow({
                                        content: userContent,
                                    });
                                    infoWindow.open(locations.map, startMarker);
                            
                                });
							})
							})
						}
						vm.geofenceMarkers=[]
			function drawLatestTrCasesOnTravel(data){
					data.forEach(function(value){
                    var startMarker = new google.maps.Marker({
                            map: userPaths.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });
						vm.geofenceMarkers.push(startMarker);
						var userContent = document.createElement("div"),
                            button;

                        var infoWindow = new google.maps.InfoWindow({
                            content: userContent,
                        });
                        var infoWindow2 = new google.maps.InfoWindow();
                        // if(value.userCase=='C'){
                        if(value.status=='RESOLVED' || value.status=='CLOSED' || value.status=='CANCELLED'){
                                 startMarker.setIcon(
                                    "content/images/Pointers-L5.png"
                                );
                                startMarker.setZIndex(10);
                        } else {
                            startMarker.setZIndex(11);
                            if (value.priority == "LOW") {
                                startMarker.setIcon(
                                    "content/images/Pointers-L4.png"
                                );
                            } else if (value.priority == "MEDIUM") {
                                startMarker.setIcon(
                                    "content/images/Pointers-M4.png"
                                );
                            } else if (value.priority == "HIGH") {
                                startMarker.setIcon(
                                    "content/images/Pointers-H4.png"
                                );
                            } else if (value.priority == "CRITICAL") {
                                startMarker.setIcon(
                                    "content/images/Pointer-C4.png"
                                );
                            }
                        }
						userContent.innerHTML =
                            '<div class="infoWindowhead">' +
                            startMarker.title +
                            '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b> Status :</b> " +
                            value.status +                            
                            "</div>";
							button = userContent.appendChild(
                            document.createElement("input")
                        );
                        button.type = "button";
                        button.value = "Incident Details";
                        button.className = "button";

                        google.maps.event.addDomListener(
                            button,
                            "click",
                            function () {
                                $state.go("tr-case-detail", {
                                    id: value.id,
                                });
                            }
                        );
                        $compile(userContent)($scope);
                        google.maps.event.addListener(
                            startMarker,
                            "click",
                            function () {
                                // infoWindow.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + userContent);
                                // infoWindow.open(locations.map, startMarker);
                                TrCaseById.get(value.id, function (response) {

                                     var infoStr = "";
                                    var caseTypeAttributeValuesList =
                                        response.caseTypeAttributeValues;
                                    caseTypeAttributeValuesList.sort(function (a, b) {
                                        var nameA = a.caseTypeAttribute.name.toLowerCase(),
                                            nameB = a.caseTypeAttribute.name.toLowerCase();
                                        if (nameA < nameB)
                                            // sort string ascending
                                            return -1;
                                        if (nameA > nameB) return 1;
                                        return 0; // default return value (no sorting)
                                    });
                                    for (
                                        var i = 0;
                                        i < caseTypeAttributeValuesList.length;
                                        i++
                                    ) {
                                        var home = caseTypeAttributeValuesList[i];
                                        infoStr +=
                                            "<br><b>" +
                                            home.caseTypeAttribute.name +
                                            "</b> : " +
                                            home.attributeValue;
                                    }

                                    userContent.innerHTML =
                                        '<div class="infoWindowhead">' +
                                        response.description +
                                        '</div><div class="infoWindowContent"> <b>Incident Id : </b>' +
                                        value.id +
                                        "<br><b>Description : </b>" +
                                        response.description +
                                        "<br><b>Incident Type : </b>" +
                                        response.caseType.name +
                                        "<br> <b>Reported By :</b> " +
                                        response.reportedByUser +
                                        "<br> <b> Assigned To :</b> " +
                                        response.assignedToUser +
                                        "<br> <b> Status :</b> " +
                                        response.status +                                        
                                        "<br> " +
                                        infoStr +
                                        "</div>";
										infoWindow = new google.maps.InfoWindow({
                                        content: userContent,
                                    });
                                    infoWindow.open(userPaths.map, startMarker);
                            
                                });
							})
							})
						}
						vm.toggleGeofenceCaseMarkers = function () {
						for (var i = 0; i < vm.geofenceCaseMarkers.length; i++) {
						vm.geofenceCaseMarkers[i].setMap(
							vm.showGeofenceCases ? locations.map : null
						);
							}
						};

	}
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupTypeDialogController', GroupTypeDialogController);

    GroupTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams',  'entity', 'GroupType', 'User','AllCustomGroupTypeAttribute', '$state', '$q'];

    function GroupTypeDialogController ($timeout, $scope, $stateParams,  entity, GroupType, User,AllCustomGroupTypeAttribute, $state, $q) {
        var vm = this;

        vm.groupType = entity;
        $scope.attributetypes = ['INTEGER', 'FLOAT', 'STRING','BOOLEAN'];
        vm.clear = clear;
        
        vm.customCaseTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        
        
		vm.save = save;
		 $(":file").filestyle({buttonBefore: true});      
	     $(":file").filestyle('buttonText', 'Browse File');
       
        
	     vm.items=[{ name: '',attributeDataType: {},defaultValue :''}];
	     
	     if(vm.groupType.groupTypeAttributes!=null && vm.groupType.groupTypeAttributes.length!=0){
	        	vm.items=vm.groupType.groupTypeAttributes;
	        }
	     
	     function loadPage() {
	    	 AllCustomGroupTypeAttribute.getAll(function(response) {
	    		 vm.customGroupTypeAttributes = response;
	     		 response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customGroupTypeAttributeValues;
					});
	    		 
				});
	    	    
	    	 }
        
        if(vm.groupType.groupTypeAttributes!=null && vm.groupType.groupTypeAttributes.length!=0){
        	vm.items=vm.groupType.groupTypeAttributes;
        }
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.groupType.id !== null) {
            	vm.groupType.groupTypeAttributes=[];
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            		 vm.groupType.groupTypeAttributes.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,  "attributeDataType" :  vm.items[i].attributeDataType,"defaultValue" :  vm.items[i].defaultValue});
            	}
                GroupType.update(vm.groupType, onSaveSuccess, onSaveError);
            } else {
                vm.groupType.groupTypeAttributes=[];
            	
            	for(var i = 0; i < vm.items.length; i++){
            		var attributes ={"name" :  vm.items[i]};
            		 vm.groupType.groupTypeAttributes.push({"id" : vm.items[i].id , "name" :  vm.items[i].name,   "attributeDataType" :  vm.items[i].attributeDataType,"defaultValue" :  vm.items[i].defaultValue});
            	}
                GroupType.save(vm.groupType, onSaveSuccess, onSaveError);
            }
        }
        
        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:groupTypeUpdate', result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == 'group.new') {
                $state.go('group.new');
            } else {
                $state.go('group-type');
            }
            // sessionStorage.removeItem("prevPage");
            // $state.go('group-type');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        
        vm.addmore = function() {
        	vm.items.push({name: '',attributeDataType:{}, defaultValue:''});
          };
            
       vm.remove = function(index) {
            vm.items.splice(index, 1);
          };

    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupTypeDetailController', GroupTypeDetailController);

    GroupTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GroupType', 'User'];

    function GroupTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, GroupType, User) {
        var vm = this;

        vm.groupType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:groupTypeUpdate', function(event, result) {
            vm.groupType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupTypeDeleteController',GroupTypeDeleteController);

    GroupTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'GroupType'];

    function GroupTypeDeleteController($uibModalInstance, entity, GroupType) {
        var vm = this;

        vm.groupType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GroupType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('group-type', {
            parent: 'entity',
            url: '/group-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER_ADMIN','ROLE_USER'],
                pageTitle: 'trakeyeApp.groupType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group-type/group-types.html',
                    controller: 'GroupTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    $translatePartialLoader.addPart('layout');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('group-type-detail', {
            parent: 'entity',
            url: '/group-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.groupType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group-type/group-type-detail.html',
                    controller: 'GroupTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    $translatePartialLoader.addPart('layout');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupType', function($stateParams, GroupType) {
                    return GroupType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('group-type-detail.edit', {
            parent: 'group-type-detail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.groupType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/group-type/group-type-dialog.html',
                    controller: 'GroupTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupType', function($stateParams, GroupType) {
                    return GroupType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
       
        
        .state('group-type.new', {
            parent: 'group-type',
            url: '/new',
            data: {
            	 authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					 templateUrl: 'app/entities/group-type/group-type-dialog.html',
	                    controller: 'GroupTypeDialogController',
	                    controllerAs: 'vm',
				}
			},
			 resolve: {
                        entity: function () {
                            return {
                            	name: null,
                                description: null,
                                layout: null,
                                colorcode: null,
                                createDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
            
        })
        
        .state('group-type.edit', {
            parent: 'group-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.groupType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/group-type/group-type-dialog.html',
                    controller: 'GroupTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupType', function($stateParams, GroupType) {
                    return GroupType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('group-type.delete', {
            parent: 'group-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-type/group-type-delete-dialog.html',
                    controller: 'GroupTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GroupType', function(GroupType) {
                            return GroupType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('group-type', null, { reload: 'group-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('GroupType', GroupType);

    GroupType.$inject = ['$resource'];

    function GroupType ($resource) {
        var resourceUrl =  'api/group-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('GroupTypeSearch', GroupTypeSearch);

    GroupTypeSearch.$inject = ['$resource'];

    function GroupTypeSearch ($resource) {
        var service = $resource('/api/group-types/searchvalue/:searchvalue',{searchvalue:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomGroupTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-group-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupTypeController', GroupTypeController);

    GroupTypeController.$inject = ['$scope', '$state', 'GroupType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'GroupTypeSearch'];

    function GroupTypeController ($scope, $state, GroupType, ParseLinks, AlertService, pagingParams, paginationConstants, GroupTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;
        
        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			GroupTypeSearch.query({searchvalue:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    //result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groupTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}

        loadAll();

        function loadAll () {
            GroupType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groupTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupDialogController', GroupDialogController);

    GroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state', 'entity', 'Group', 'AllCustomGroupTypeAttribute', 'AllGroupsTypes', 'UserIDs','AssetIDs','AssetByID','Principal'];

    function GroupDialogController ($timeout, $scope, $stateParams, $state, entity, Group, AllCustomGroupTypeAttribute, AllGroupsTypes, UserIDs,Principal) {
        var vm = this;
        vm.group = entity;
        vm.clear = clear;
		var entity_old = angular.copy(vm.group);
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
		vm.customAttributesMap = {};
		vm.selectattributes = selectedGroupTypeAttributes;
		vm.save = save;
		vm.navigateGroupTypefromGroup = navigateGroupTypefromGroup;
        loadPage();
		var selctedUsers = [];
        
        function loadPage() {
        	vm.multiuser = [];
          	vm.multigroups = [];
          	AllGroupsTypes.getAll(function(response) {
				vm.grouptypes = response;
			});
			
			AllCustomGroupTypeAttribute.getAll(function(response) {
				response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customGroupTypeAttributeValues;
				});
			
			});
        	
        	UserIDs.getAdminAll(function(response) {
        		response.forEach(function(user) {
        			if(selctedUsers.indexOf(user.id) !== -1){
        					vm.multiuser.push({ login: user.login, id:user.id ,ticked: true });
        				}else{
        					vm.multiuser.push({ login: user.login, id:user.id ,ticked: false });
        			}
        		});
			});
		}
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }
        
		function selectedGroupTypeAttributes() {
			if (vm.groupType) {
				vm.isSite = false;
				
				vm.group.groupType = vm.groupType;
				if (entity_old.groupType
						&& vm.groupType.id === entity_old.groupType.id) {
					vm.group.groupTypeAttributeValues = [];
					vm.group.groupTypeAttributeValues = entity_old.groupTypeAttributeValues;
				} else {
					vm.group.groupTypeAttributeValues = [];
					$.each(
						vm.groupType.groupTypeAttributes,
						function(key, value) {
							vm.group.groupTypeAttributeValues
								.push({
									groupTypeAttribute : vm.groupType.groupTypeAttributes[key]
								});
						});
				}

			}

		}
     
        function save () {
            vm.isSaving = true;
            if (vm.group.id !== null) {
                Group.update(vm.group, onSaveSuccess, onSaveError);
            } else {
                Group.save(vm.group, onSaveSuccess, onSaveError);
            }
        }

		function onSaveSuccess(result) {
			$scope.$emit('trakeyeApp:groupUpdate', result);
			// $uibModalInstance.close(result);
			vm.isSaving = false;
			var pageValue = sessionStorage.getItem("prevPage");
			var previousId = sessionStorage.getItem("prevId");
			var prevEditDetail = sessionStorage.getItem("prevEditId");
			if (pageValue == 'user-management.new') {
				$state.go('user-management.new');
			} else if (previousId) {
				sessionStorage.setItem("groupToEditAsset", "groupToasset");
				$state.go('asset.edit', {
					'id': previousId
				});
			} else if (prevEditDetail) {
				sessionStorage.setItem("groupToEditAssetDetail", "groupToassetDetail");
				$state.go('asset-detail.edit', {
					'id': prevEditDetail
				});
			} else if(sessionStorage.getItem("createGroup")) {
				$state.go('asset.new', {
				});
			}
			else {
				$state.go('group');
			}
		}

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;
        

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
		}
		
		function navigateGroupTypefromGroup() {
			sessionStorage.setItem("prevPage", "group.new");
			$state.go('group-type.new');
		}
    }
    
})();


(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupDetailController', GroupDetailController);

    GroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Group', 'User'];

    function GroupDetailController($scope, $rootScope, $stateParams, previousState, entity, Group, User) {
        var vm = this;
       
        vm.group = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:groupUpdate', function(event, result) {
            vm.group = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
          
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupDeleteController',GroupDeleteController);

    GroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'Group'];

    function GroupDeleteController($uibModalInstance, entity, Group) {
        var vm = this;

        vm.group = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Group.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('group', {
                parent: 'entity',
                url: '/group?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'trakeyeApp.group.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group/groups.html',
                        controller: 'GroupController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'modified_date,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('group');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('group-detail', {
                parent: 'entity',
                url: '/group/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'trakeyeApp.group.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group/group-detail.html',
                        controller: 'GroupDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('group');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Group', function($stateParams, Group) {
                        return Group.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'group',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

        .state('group.new', {
                parent: 'group',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group/group-dialog.html',
                        controller: 'GroupDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            name: null,
                            description: null,
                            coordinates: null,
                            createdDate: null,
                            modifiedDate: null,
                            id: null
                        };
                    }
                }

            })
            .state('group.edit', {
                parent: 'entity',
                url: '/group/edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group/group-dialog.html',
                        controller: 'GroupDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('group');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Group', function($stateParams, Group) {
                        return Group.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'group',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })


        .state('group.delete', {
            parent: 'group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group/group-delete-dialog.html',
                    controller: 'GroupDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['Group', function(Group) {
                            return Group.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('group', null, { reload: 'group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('group.import', {
            parent: 'group',
            url: '/import',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group/group-import.html',
                    controller: 'GroupImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function() {
                    return {
                        description: null,
                        createDate: null,
                        updateDate: null,
                        pinLat: null,
                        pinLong: null,
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        caseImages: []
                    };
                }
            }

        });
    }

})();
(function() {
	'use strict';
	angular.module('trakeyeApp').factory('Group', Group);

	Group.$inject = [ '$resource', 'DateUtils' ];

	function Group($resource, DateUtils) {
		var resourceUrl = 'api/groups/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('GroupSearch', GroupSearch);

	GroupSearch.$inject = [ '$resource' ];

	function GroupSearch($resource) {
		var service = $resource('/api/groups/searchvalue/:userId', {
			userId : '@id'
		}, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllGroups', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/groupsall').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllGroupsTypes', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/group-alltypes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
	'use strict';
	angular.module('trakeyeApp').factory('GroupUpload', GroupUpload);

	GroupUpload.$inject = [ '$http' ];

	function GroupUpload($http) {

		var service = {};
		service.groupUpload = function(data,assetType, callback) {
			$http.post('api/groupsimport/'+assetType.name, data, {
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				}
			}).then(function(response) {

				callback(response, response.headers);
			}, function(error) {
				callback(error, error.headers);
			});
		};

		return service;
	}

})();

//(function() {
//	'use strict';
//
//	angular.module('trakeyeApp').factory('GroupIDs', [ '$rootScope', '$http', function($rootScope, $http) {
//
//		var service = {};
//		service.getAll = function( callback) {
//			$http.get('api/grouplist').then(function(response) {
//				callback(response.data);
//			});
//		};
//
//		return service;
//	} ]);
//})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('UserGroupIDs', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function( callback) {
			$http.get('api/user-groups').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupController', GroupController);

    GroupController.$inject = ['$scope', '$state', 'Group', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','GroupSearch'];

    function GroupController ($scope, $state, Group, ParseLinks, AlertService, pagingParams, paginationConstants,GroupSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			GroupSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groups = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        loadAll();

        function loadAll () {
            Group.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groups = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceImportController', GeofenceImportController)
        .directive("fileread", [function () {
            'use strict';

            return {
                restrict: "A",

                link: function ($scope, element) {

                    element.change(function (event) {
                        $scope.$apply(function () {
                            $scope.myFile = element[0].files[0];

                        });
                    });
                }

            };
        }]);

    GeofenceImportController.$inject = ['$timeout','$state', '$scope', 'GeofenceUpload', 'AllAssetsTypes'];

    function GeofenceImportController($timeout,$state, $scope, GeofenceUpload, AllAssetsTypes) {
        var vm = this;
        vm.upload = upload;
        vm.geofencetype = null;
        var formData;

        function upload() {
            formData = new FormData();
            formData.append('file', $scope.myFile);
            if (vm.geofencetype != null) {
                // var isMaster = false;

                // if (vm.geofencetype == "MASTER") {
                //     isMaster = true;
                // }
                GeofenceUpload.geofenceUpload(formData, vm.geofencetype, function (response, headers) {
                    if (response.status == 200) {
                        vm.error = null;
                        vm.success = 'OK';

                        $timeout(function () {
                            vm.success = '';
                        }, 4000);


                    }
                    if (response.status == 400) {
                        vm.success = null;
                        vm.error = 'error';

                    }
                });
               setTimeout(function(){
                //  $state.go('geofence',{}, { reload: true })
                 $state.transitionTo('geofence', {}, { reload: true, notify: true });
               },2000)
            } else {
                AlertService.error("Please select Geofence type.");
            }     
        }
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle('buttonText', 'Browse File');

        
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceDialogController', GeofenceDialogController);

    GeofenceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state', 'entity', 'Geofence', 'UserIDs', 'AssetIDs', 'AssetByID', 'AssetsForMap', 'Principal','$rootScope','MiniGeofencesByMasterID','BufferGeofencesByMiniID', 'ParentGeofencesByID','AssetsByGeofenceID'];

    function GeofenceDialogController($timeout, $scope,  $stateParams, $state, entity, Geofence, UserIDs, AssetIDs, AssetByID, AssetsForMap, Principal,$rootScope,MiniGeofencesByMasterID,BufferGeofencesByMiniID,ParentGeofencesByID,AssetsByGeofenceID) {
        var vm = this;
        var newFence = false;
        vm.geofence = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.assets = [];
        vm.ownedBy = [];
        vm.assetList = [];
        vm.navigateCreateAssetGeo = navigateCreateAssetGeo;
        loadPage();
        var marker;
        if (vm.geofence.id != null) {
        ParentGeofencesByID.get(
            vm.geofence.id,
            function (parentGeofences) {
                vm.geofence.parentGeofence = parentGeofences;
                entity.parentGeofence = parentGeofences;
            }
         );
         }
        if (vm.geofence.id != null) {
         AssetsByGeofenceID.get(
            vm.geofence.id,
            function (assets) {
                vm.geofence.assets = assets;
                entity.assets = assets;
            }
          );
         }
        if (vm.geofence.id != null) {
            // if (vm.geofence.zone == true) {
            //     vm.geofenceType = "MASTER";
            // } else {
            //     vm.geofenceType = "MINI";
            // }
            vm.geofenceType = vm.geofence.geofenceType;
        }

        function loadPage() {
            vm.multiuser = [];
            //vm.multiassets = [];

            var selctedUsers = [];
            var selctedAssets = [];

            if (vm.geofence.id != null) {
                vm.geofence.ownedBy.forEach(function (user) {
                    selctedUsers.push(user.id);
                })

                if(vm.geofence.asset!=null){
                    vm.geofence.assets.forEach(function (asset) {
                        selctedAssets.push(asset.id);
                    })
                }

            } else {
                Principal.identity().then(function (identity) {
                    selctedUsers.push(identity.id);
                });
            }

            UserIDs.getAdminAll(function (response) {
                response.forEach(function (user) {
                    if (selctedUsers.indexOf(user.id) !== -1) {
                        var userExits = false;
                        vm.multiuser.forEach(function (userVal) {
                            if (userVal.login == user.login) {
                                userExits = true;
                            }
                        });
                        if (!userExits) {
                            vm.multiuser.push({ login: user.login, id: user.id, ticked: true });
                        }
                    } else {
                        var userExits = false;
                        vm.multiuser.forEach(function (userVal) {
                            if (userVal.login == user.login) {
                                userExits = true;
                            }
                        });
                        if (!userExits) {
                            vm.multiuser.push({ login: user.login, id: user.id, ticked: false });
                        }
                    }
                });
            });

            /*AssetsForMap.assetsformap(function(response) {
                vm.assetList = response;
            });*/

            /*AssetIDs.getAll(function(response) {
                response.forEach(function(asset) {
                    if (selctedAssets.indexOf(asset.id) !== -1) {
                        vm.multiassets.push({ name: asset.name, id: asset.id, ticked: true });
                    } else {
                        vm.multiassets.push({ name: asset.name, id: asset.id, ticked: false });
                    }
                });
            });*/

        }


        /*$scope.modernBrowsers = [
            { icon: "<img src=[..]/opera.png.. />",               name: "Opera",              maker: "(Opera Software)",        ticked: true  },
            { icon: "<img src=[..]/internet_explorer.png.. />",   name: "Internet Explorer",  maker: "(Microsoft)",             ticked: false },
            { icon: "<img src=[..]/firefox-icon.png.. />",        name: "Firefox",            maker: "(Mozilla Foundation)",    ticked: true  },
            { icon: "<img src=[..]/safari_browser.png.. />",      name: "Safari",             maker: "(Apple)",                 ticked: false },
            { icon: "<img src=[..]/chrome.png.. />",              name: "Chrome",             maker: "(Google)",                ticked: true  }
        ]; 
        */

        function drawFixedAsset(fixed, map) {
            $.each(fixed.assetCoordinates, function (index, value1) {

                var infoWindow = new google.maps.InfoWindow();
                var startMarker = new google.maps.Marker({
                    map: map,
                    position: new google.maps.LatLng(value1.latitude, value1.longitude),
                    title: fixed.name,
                    icon: {
                        // size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(20, 20),
                        origin: new google.maps.Point(0, 0),
                        // url : "data:image/png;base64," +
                        // fixed.assetType.image,
                        url: "data:image/png;base64," + vm.assetTypeMap[fixed.assetType.name],

                        anchor: new google.maps.Point(16, 16)
                    },
                });
                var infoWindow2 = new google.maps.InfoWindow();
                startMarker.content = '<div class="infoWindowContent"> <b>Description :</b> ' + fixed.description + '</div>';

                // on mouseout
                google.maps.event.addListener(startMarker, 'mouseout', function () {
                    infoWindow.close();
                });

                var activeInfoWindow;
                // add content to InfoWindow for click event
                infoWindow2.setContent('<div class="infoWindowhead">' + startMarker.title + '</div>' + startMarker.content);

                // add listener on InfoWindow for click event
                google.maps.event.addListener(startMarker, 'click', function () {

                    if (activeInfoWindow != null)
                        activeInfoWindow.close();
                    // Open InfoWindow - on click
                    infoWindow2.open(map, startMarker);
                    $(".userpath").click(function () {
                        var ele = document.getElementById("userPathModal");
                        $(ele).modal('show');
                        vm.drawUserPath($(this).attr('userid'));
                    });

                    // Store new open InfoWindow in global variable
                    activeInfoWindow = infoWindow2;
                });
                // function resizeMap(){
                setTimeout(function () {
                    google.maps.event.trigger(map, "resize");
                }, 100);
                // }
                // resizeAssetMap();

            });

        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }
        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("span");
            locationButton.setAttribute("title","Locate Me");
			locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon)
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
							infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");	
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function navigateCreateAssetGeo() {
            sessionStorage.setItem("prevPage", "geofence.new");
            $state.go('asset.new');
        }

        vm.createNewFence = function () {
            newFence = true;
            vm.geofence.coordinates = [];
            vm.createfence();
        }
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        vm.clearCoordinates = function () {
            newFence = false;
            vm.geofence.coordinates = [];
        }

        function save() {
            vm.isSaving = true;
            if (vm.geofenceType == "MASTER") {
                vm.geofence.zone = true;
            } else {
                vm.geofence.zone = false;
            }

            vm.geofence.geofenceType = vm.geofenceType;

            if (vm.geofence.id !== null) {
                Geofence.update(vm.geofence, onSaveSuccess, onSaveError);
            } else {
                Geofence.save(vm.geofence, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('trakeyeApp:geofenceUpdate', result);
            // $uibModalInstance.close(result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == 'user-management.new') {
                $state.go('user-management.new');
            } else {
                $state.go('geofence');

            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;


        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
        var map;
        vm.getMiniGeofences = function () {
            var parentGeofenceId = entity.parentGeofence.map(function (parentID) {
                return parentID.id;
            });
        MiniGeofencesByMasterID.get(parentGeofenceId, function (response) {
            vm.miniGeofences = response;

            var firstItem = vm.miniGeofences[0];
            var firstCoordinates = JSON.parse(firstItem.coordinates);
            map = new google.maps.Map(document.getElementById('map_canvas'), myOption(10, { lat: firstCoordinates[0].lat, lng: firstCoordinates[0].lng }));
            geoLocation(map);
            vm.miniGeofences.forEach(function (co_ordinates) {
                var paths = JSON.parse(co_ordinates.coordinates);
                var bounds = new google.maps.LatLngBounds();
                paths.forEach(function (point) { bounds.extend(point); });
                var center = bounds.getCenter();

                var tempPolygon = new google.maps.Polygon({
                    paths: paths,
                    strokeOpacity: 0.5,
                    strokeColor: "#fd7a24",
                    strokeWeight: 1.2,
                    fillColor: "#fd7a24",
                    fillOpacity: 0.1,
                    zIndex: 1,
                    editable: co_ordinates.id === vm.geofence.id
                });

                map.setCenter(center);
                tempPolygon.setMap(map);
                attachPolygonListeners(tempPolygon, map, co_ordinates.name);
            });

            if(entity.parentGeofence[0].coordinates){
                var masterPolygon = new google.maps.Polygon({
                    paths: JSON.parse(entity.parentGeofence[0].coordinates),
                    strokeOpacity: 0.5,
                    strokeColor: "#00e658",
                    strokeWeight: 1.2,
                    fillColor: "#00e658",
                    fillOpacity: 0.1,
                    zIndex: 1
                });
                masterPolygon.setMap(map);
                attachPolygonListeners(masterPolygon, map, entity.parentGeofence[0].name);
            }
        });        
        };

        vm.createfence = function () {
            if(vm.geofence.geofenceType=="MINI"){
                   vm.getMiniGeofences();
   
            }
             var parent = {};
            var coOrdinates = JSON.parse(entity.coordinates);
            /*for (var i = 0; i < vm.multiassets.length; i++) {
                if (vm.multiassets[i].ticked == true) {
                    parent = vm.multiassets[i];
                    AssetByID.get(parent.id, function(response) {
                        if (response.assetType.layout == 'FIXED') {
                            drawFixedAsset(response, map);
                        }
                        if (response.assetType.layout == 'SPREAD') {
                            drawPolyline(response, map);
                        }
                    });
                }
            }*/
            if (vm.geofence.id !== null) {
                var map = new google.maps.Map(document.getElementById('map_canvas'),
                myOption(12,{ lat: coOrdinates[0].lat, lng: coOrdinates[0].lng } ) /* {
                    // center: { lat: parseFloat($rootScope.DEFAULT_LATITUDE), lng: parseFloat($rootScope.DEFAULT_LONGITUDE) },
                    center: { lat: coOrdinates[0].lat, lng: coOrdinates[0].lng },
                    zoom: 12
                } */);
                geoLocation(map)
            } else {
                var map = new google.maps.Map(document.getElementById('map_canvas'),
                myOption(12,{ lat: parseFloat($rootScope.DEFAULT_LATITUDE), lng: parseFloat($rootScope.DEFAULT_LONGITUDE) }) /* {
                    center: { lat: parseFloat($rootScope.DEFAULT_LATITUDE), lng: parseFloat($rootScope.DEFAULT_LONGITUDE) },
                    // center: { lat: coOrdinates[0].lat, lng: coOrdinates[0].lng },
                    zoom: 12
                } */);
                geoLocation(map)
            }
            /*$.each(vm.assetList, function(index, value) {
                var assetCorRes = value.assetCoordinates;
                var assetCorVal = [];
                for (var i = 0; i < assetCorRes.length; i++) {
                    assetCorVal.push({ lat: assetCorRes[i].latitude, lng: assetCorRes[i].longitude });;
                }
                drawPolylineForGeoFence(assetCorVal, map, value);
            });*/

            var drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYGON,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polygon']
                },
                polygonOptions: {
                    fillColor: '#00000',
                    fillOpacity: 0.0,
                    strokeWeight: 5,
                    clickable: false,
                    editable: true,
                    zIndex: 1,
                    geodesic: true
                }
            })
            google.maps.event.addListener(drawingManager, 'polygoncomplete', function (event) {
                google.maps.event.addListener(event.getPath(), 'insert_at', function () {
                    setGoefenceCoordinate(event);
                });
                google.maps.event.addListener(event.getPath(), 'set_at', function (path) {
                    setGoefenceCoordinate(event);
                });

                drawingManager.setOptions({
                    drawingControl: false
                });
                drawingManager.setMap(null);
                setGoefenceCoordinate(event);

            });
            drawingManager.setMap(map);

            if (entity.id && entity.id != null && !newFence) {

                drawPolygon(function (polygon) {
                    polygon.setMap(map);
                    google.maps.event.addListener(polygon.getPath(), 'insert_at', function () {
                        setGoefenceCoordinate(polygon);
                    });
                    google.maps.event.addListener(polygon.getPath(), 'set_at', function (path) {
                        setGoefenceCoordinate(polygon);
                    });

                    drawingManager.setOptions({
                        drawingControl: false
                    });
                    drawingManager.setMap(null);
                })

            }

            function setGoefenceCoordinate(event) {
                var coOrdinates = [];
                var radius = event.getPath();
                for (var i = 0; i < radius.getLength(); i++) {
                    coOrdinates.push({ lat: radius.getAt(i).lat(), lng: radius.getAt(i).lng() });
                    if (i == radius.getLength() - 1) {
                        $scope.$apply(function () {
                            vm.geofence.coordinates = JSON.stringify(coOrdinates);
                        })
                    }
                }
            }

            function drawPolygon(callback) {
                callback(new google.maps.Polygon({
                    path: JSON.parse(entity.coordinates),

                    strokeColor: "#fd7a24",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#fd7a24",
                    fillOpacity: 0.3,
                    editable: true
                }));
            }

            if (entity.id && entity.id != null) {
                $.each(vm.geofence.assets, function (index, value) {

                    //Asset ID object contains light weight object , get detailsed object and plot details

                    AssetByID.get(value.id, function (response) {
                        //response.forEach(function(user) {
                        if (response.assetType.layout == 'FIXED') {
                            drawFixedAsset(response, map);
                        }
                        if (response.assetType.layout == 'SPREAD') {
                            drawPolyline(response, map);
                        }
                        //});
                    });



                });

            }

            function drawPolyline(spread, map) {

                var spreadAssetCoordinates = [];
                $.each(spread.assetCoordinates, function (index, value) {

                    spreadAssetCoordinates.push({
                        lat: value.latitude,
                        lng: value.longitude
                    });
                });
                var midLatLng = {
                    lat: spread.assetCoordinates[0].latitude,
                    lng: spread.assetCoordinates[0].longitude
                };
                var infowindow = new google.maps.InfoWindow({
                    content: '<div class="infoWindowhead">' + spread.name + '<div class="infoWindowContent"> <b>Description :</b> ' + spread.description + '</div></div>'
                });
                infowindow.setPosition(midLatLng);
                // infowindow.open(locations.map);
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: spread.assetType.colorcode,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: spread.assetType.colorcode,
                    fillOpacity: 0.3,
                    editable: false
                });
                polylinepath.setMap(map);
                setTimeout(function () {

                    google.maps.event.trigger(map, "resize");
                    map.setCenter(midLatLng);
                }, 100);

            }


        };
 function attachPolygonListeners(polygon,map,name) {
    google.maps.event.addListener(polygon.getPath(), 'insert_at', function () {
        setGeofenceCoordinate(polygon);
    });
    google.maps.event.addListener(polygon.getPath(), 'set_at', function () {
        setGeofenceCoordinate(polygon);
    });
   var infowindow=new google.maps.InfoWindow()
   
   google.maps.event.addListener(polygon,'click',function(event){
   var contentString='<div class="infoWindowhead"><b>'+name+'</b></div>'
    infowindow.setContent(contentString)
    infowindow.setPosition(event.latLng)
    infowindow.open(map)
   })
   google.maps.event.addListener(polygon,'mouseout',function(event){
    infowindow.close()
   })
}

function setGeofenceCoordinate(polygon) {
    var coOrdinates = [];
    var path = polygon.getPath();

    for (var i = 0; i < path.getLength(); i++) {
        coOrdinates.push({ lat: path.getAt(i).lat(), lng: path.getAt(i).lng() });
        if (i === path.getLength() - 1) {
            $scope.$apply(function () {
                vm.geofence.coordinates = JSON.stringify(coOrdinates);
            });
        }
    }
}
}

    function drawPolylineForGeoFence(latlngsToDraw, map, asset) {
        var spreadAssetCoordinates = [];
        $.each(latlngsToDraw, function (index, value) {

            spreadAssetCoordinates.push({
                lat: value.lat,
                lng: value.lng
            });
        });

        if (spreadAssetCoordinates.length > 0) {
            var midLatLng = {
                lat: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lat,
                lng: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lng
            };
            var infowindow = new google.maps.InfoWindow({
                content: '<div class="infoWindowhead">' +
                    "name" +
                    '<div class="infoWindowContent"> <b>Description :</b> ' +
                    "des" + '</div></div>'
            });

            infowindow.setPosition(midLatLng);
            var polylineColor = '#000000';

            var spreadAttrValues = asset.assetTypeAttributeValues;
            spreadAttrValues.forEach(function (item, index) {
                if (item.name == "Fiber Status") {
                    if (item.attributeValue == "Planned") {
                        polylineColor = '#0000cc';
                    } else if (item.attributeValue == "On Air") {
                        polylineColor = '#00e658';
                    } else if (item.attributeValue == "Under Deployment") {
                        polylineColor = '#ff0000';
                    }
                }
            });

            var polylinepath = new google.maps.Polyline({
                path: spreadAssetCoordinates,
                geodesic: true,
                strokeColor: polylineColor,
                strokeWeight: 3
            });

            polylinepath.setOptions({
                strokeColor: polylineColor
            });

            google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
                infowindow.close();
            });

            google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
                infowindow.setContent('<div class="infoWindowhead">' +
                    '<b></b>' + asset.name + '</br></div>'
                );

                infowindow.mousemove;
                infowindow.open(map);
                infowindow.setPosition(event.latLng);
            });
            polylinepath.setMap(map);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceDetailController', GeofenceDetailController);

    GeofenceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Geofence', 'User','AssetsByGeofenceID'];

    function GeofenceDetailController($scope, $rootScope, $stateParams, previousState, entity, Geofence, User,AssetsByGeofenceID) {
        var vm = this;
        
        vm.geofence = entity;
        vm.previousState = previousState.name;
        
        google.maps.Polygon.prototype.getBounds = function () {
            var bounds = new google.maps.LatLngBounds();
            var paths = this.getPaths();
            var path;
            for (var i = 0; i < paths.getLength(); i++) {
                path = paths.getAt(i);
                for (var ii = 0; ii < path.getLength(); ii++) {
                    bounds.extend(path.getAt(ii));
                }
            }
            return bounds;
        }
        AssetsByGeofenceID.get(
            vm.geofence.id,
            function (assets) {
                vm.geofence.assets = assets;
            }
        );


        // if (vm.geofence.zone == true) {
        // 	vm.geofence.zone = "MASTER"
        // } else {
        // 	vm.geofence.zone = "MINI"
        // }


        var unsubscribe = $rootScope.$on('trakeyeApp:geofenceUpdate', function (event, result) {
            vm.geofence = result;
        });
        $scope.$on('$destroy', unsubscribe);

        drawmap(JSON.parse(entity.coordinates), function (latlng, geofence) {

            var myOptions = {
                zoom: 10,
                center: geofence.getBounds().getCenter(),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);

            geofence.setMap($scope.map);
        });

        function drawmap(path, callback) {
            try {

                callback(new google.maps.LatLng(path[0].lat, path[0].lng), new google.maps.Polygon({
                    paths: path,
                    strokeColor: '#fd7a24',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#fd7a24',
                    fillOpacity: 0.35
                }));
            } catch (err) { }

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceDeleteController',GeofenceDeleteController);

    GeofenceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Geofence'];

    function GeofenceDeleteController($uibModalInstance, entity, Geofence) {
        var vm = this;

        vm.geofence = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Geofence.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('geofence', {
                parent: 'entity',
                url: '/geofence?page&sort&search',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'trakeyeApp.geofence.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/geofence/geofences.html',
                        controller: 'GeofenceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'modified_date,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('geofence');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('geofence-detail', {
                parent: 'entity',
                url: '/geofence/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'trakeyeApp.geofence.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/geofence/geofence-detail.html',
                        controller: 'GeofenceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('geofence');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Geofence', function($stateParams, Geofence) {
                        return Geofence.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'geofence',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

        .state('geofence.new', {
                parent: 'geofence',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_PLANNER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/geofence/geofence-dialog.html',
                        controller: 'GeofenceDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            name: null,
                            description: null,
                            coordinates: null,
                            createdDate: null,
                            modifiedDate: null,
                            id: null
                        };
                    }
                }

            })
            .state('geofence.edit', {
                parent: 'entity',
                url: '/geofence/edit/{id}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_PLANNER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/geofence/geofence-dialog.html',
                        controller: 'GeofenceDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('geofence');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Geofence', function($stateParams, Geofence) {
                        return Geofence.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'geofence',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })


        .state('geofence.delete', {
            parent: 'geofence',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geofence/geofence-delete-dialog.html',
                    controller: 'GeofenceDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['Geofence', function(Geofence) {
                            return Geofence.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('geofence', null, { reload: 'geofence' });
                }, function() {
                    $state.go('^');
                });
            }]
        })




        .state('geofence.import', {
            parent: 'geofence',
            url: '/import',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_PLANNER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geofence/geofence-import.html',
                    controller: 'GeofenceImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function() {
                    return {
                        description: null,
                        createDate: null,
                        updateDate: null,
                        pinLat: null,
                        pinLong: null,
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        caseImages: []
                    };
                }
            }

        });
    }

})();
(function () {
    'use strict';
    angular.module('trakeyeApp').factory('Geofence', Geofence);

    Geofence.$inject = ['$resource', 'DateUtils'];

    function Geofence($resource, DateUtils) {
        var resourceUrl = 'api/geofences/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceByID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/geofences/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ParentGeofencesByID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/parent-geofences-by-GefenceId/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('MiniGeofencesByMasterID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/mini-geofences-by-masterGefenceId/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllMiniGeofencesByMasterID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/all-mini-geofences-by-master/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('MasterGeofencesByTenantID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/master-geofences-by-tenant/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('BufferGeofencesByMiniID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/buffer-geofences-by-miniGefenceId/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceSearch', GeofenceSearch);

    GeofenceSearch.$inject = ['$resource'];

    function GeofenceSearch($resource) {
        var service = $resource('/api/geofences/searchvalue/:userId', {
            userId: '@id'
        }, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllGeofences', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/geofencesall').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UserMasterGeofences', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/user-geofences-by-type-master').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('GeofenceUpload', GeofenceUpload);

    GeofenceUpload.$inject = ['$http'];

    function GeofenceUpload($http) {

        var service = {};
        service.geofenceUpload = function (data, geoType, callback) {
            $http.post('api/geofencesimport/' + geoType, data, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {

                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/geofencelist').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceMasterMiniIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/master-mini-geofences').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('MasterGeofences', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/master-geofences').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllGeofenceIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/all-geofences').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UserGeofences', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/user-geofences-web').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeofenceChildAssets', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/geofence-users/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('ChildUsersMiniGeofence', ChildUsersMiniGeofence);

	ChildUsersMiniGeofence.$inject = ['$resource'];

	function ChildUsersMiniGeofence($resource) {
		var service = $resource('/api/child-users-mini-geofences-by-userlogin/:userLogin', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
    
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('usersByGeofence', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
       service.post = function (payload, onSuccess, onError) {
    $http.post('api/users-by-geofence-and-roles', payload)
        .then(function (response) {
            if (onSuccess) onSuccess(response.data);
        })
        .catch(function (error) {
            if (onError) onError(error);
        });
};
       service.postMiniPayload = function (payload, onSuccess, onError) {
    $http.post('api/users-by-roles-mini-geofence', payload)
        .then(function (response) {
            if (onSuccess) onSuccess(response.data);
        })
        .catch(function (error) {
            if (onError) onError(error);
        });
};       service.postMasterPayload = function (payload, onSuccess, onError) {
    $http.post('api/users-by-roles-master-geofence', payload)
        .then(function (response) {
            if (onSuccess) onSuccess(response.data);
        })
        .catch(function (error) {
            if (onError) onError(error);
        });
};


        return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GeofenceController', GeofenceController);

    GeofenceController.$inject = ['$scope', '$rootScope','$state', '$compile', 'Geofence', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'GeofenceSearch', 'UserAccount', 'GeofenceIDs', 'UserGeofences', 'AssetDB', 'AssetByID', 'GeofenceChildAssets', 'Report', 'UserMasterGeofences', 'GeofenceByID', 'MiniGeofencesByMasterID', 'BufferGeofencesByMiniID','AssetLinkList','AllGeofenceIDs','geofenceMaterial'];

    function GeofenceController($scope, $rootScope, $state, $compile, Geofence, ParseLinks, AlertService, pagingParams, paginationConstants, GeofenceSearch, UserAccount, GeofenceIDs, UserGeofences, AssetDB, AssetByID, GeofenceChildAssets, Report, UserMasterGeofences, GeofenceByID, MiniGeofencesByMasterID, BufferGeofencesByMiniID,AssetLinkList,AllGeofenceIDs,geofenceMaterial) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        $scope.search = pagingParams.search;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        vm.filterGeofenceSearchMap = filterGeofenceSearchMap;
        vm.filterAssetsOnGeofenveMapView = filterAssetsOnGeofenveMapView;
        vm.closeMapFilterModal = closeMapFilterModal;
        vm.saveGeofenceFilter = saveGeofenceFilter;
        vm.geofencesTable = geofencesTable;
        vm.downloadAttendenceReport = downloadAttendenceReport;
        vm.downloadAttendenceReportKml = downloadAttendenceReportKml;
        $scope.tab = 1;
        var locations = {};
        var latlng;
        vm.resTxSummary=[]
        var noDataText = null;
        var markers = [];
        var polylines = [];
        vm.userGeofences = [];
        vm.geofenceChildUsers = [];
        var openedInfoWindow = null;

        vm.userMasterGeofences = [];
        vm.previousPolygons = [];

        vm.selectGeofenceEntity = selectGeofenceEntity;
        vm.selectAllGeofences = selectAllGeofences;
        vm.isAllGeofencesSelected = false;
        vm.selectedGeofences = [];

        vm.gotoLatitute = gotoLatitute;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.showZoomLocation = showZoomLocation;
        var centerLatLng;
        vm.selectCityFilter= false;
        $scope.geofencelabel = {
            search          : "Search",
            nothingSelected : "Block"      
        }

        $scope.geofenceMap = function(){
            vm.selectedGeofenceId = vm.selectedGeofence[0].id
            saveGeofenceFilter()
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title","Locate Me");
			locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon)
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(
                goTo
            ); 

            goTo.addEventListener("click", function () {
                gotoLatitute()
            })

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");	
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        { enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0}
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(
                        false,
                        infoWindow,
                        map.getCenter()
                    );
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                /* if(vm.userGeofences.length > 0){
                    filterSearch();
                } */
                filterSearch();
            } else if ($scope.tab == 2) {
                vm.selectCityFilter = false
                var centerGeofence = new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE);
                locations.map = new google.maps.Map(document.getElementById("map_canvas1"), myOption(15,centerGeofence));
                geoLocation(locations.map)
                
                vm.userMasterGeofences = [];
                UserMasterGeofences.getAll(function (response) {
                    vm.userMasterGeofences = response;
                });
                //filterGeofenceSearchMap();
                vm.mapAssets = [];
                //getGroupGeofenceAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
            }
        }

        if ($scope.tab == 1) {
            UserAccount.get(function (data) {
                vm.userId = data.id
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if (val === 'ROLE_READONLY') {
                        vm.has_ROLE_READONLY = true;
                    }
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }
                });
                filterSearch();
                /* if (isAdmin) {
                    GeofenceIDs.getAll(function (response) {
                        response.forEach(function (geofence) {
                            if (geofence.name != 'Bangalore') {
                                vm.userGeofences.push(geofence);
                                if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                    vm.canFilter = true;
                                }
                            }
                        });
                    }); 
                    filterSearch();
                } else {
                    UserGeofences.getAll(function (response) {
                        response.forEach(function (geofence) {
                            if (geofence.name != 'Bangalore') {
                                vm.userGeofences.push(geofence);
                                if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                    vm.canFilter = true;
                                }
                            }
                        });
                    filterSearch();
                    });
                } */
            });
        }

        function filterGeofenceSearchMap() {
            var data = vm.geofences;
            drawResponseMap(data);
        }

        vm.sendAssetLinkRequest = function(geoId,geoName){
            $('#mappingFixed').show()
            vm.geoName = geoName
            vm.geoId = geoId
        }

        vm.postRequest = function (){
            AssetLinkList.post({
                "entityName": "Assets",
                "entityLayout": "SPREAD",
                "reqByUserId": vm.userId,
                "messageType": "ADD",
                "messageStatus": "OPEN",
                "geofences": [
                    {
                        "id": vm.geoId
                    }
                ] 
            }, function (response) {
                vm.success = response.status == 200 ? "success" : ""
                if (vm.success) {
                    $rootScope.highlightAssetLink = true
                    vm.mappingFixed()
                    setTimeout(function () {
                        vm.success = "";
                        $scope.$apply()
                    }, 5000);
                }else{
                    $rootScope.highlightAssetLink = false
                }
            })
        }

        vm.mappingFixed= function(){
            $("#mappingFixed").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mappingFixed").hide();
        }
        function drawResponseMap(data) {
            //var myOptions = null;
            var centerGeofence
            data.forEach(function (assets) {
                JSON.parse(assets.coordinates).forEach(function (value, key) {
                    var lat = value.lat.toString();
                    var long = value.lng.toString();
                    centerGeofence = new google.maps.LatLng(lat, long)
                    /* myOptions = {
                        zoom: 15,
                        center: new google.maps.LatLng(lat, long),
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    }; */
                });
            });
            if ($scope.tab == 2) {
                locations.map = new google.maps.Map(document.getElementById("map_canvas1"), myOption(15,centerGeofence));
                geoLocation(locations.map)

                
                locations.overlay = new google.maps.OverlayView();
                locations.overlay.draw = function () { };
                locations.overlay.setMap($scope.map);
                locations.element = document.getElementById('map_canvas1');
                
                // drawLatestGeofence(data);
                // Geofence.query({
                //     page: 0,
                //     size: 100000,
                // }, onSuccessPolygon, onErrorPolygon);

                // function onSuccessPolygon(data, headers) {
                //     vm.geofencesPolygon = [];
                //     data.forEach(function (value) {
                //         if (value.zone) {
                //             value.type = "MASTER";
                //         } else {
                //             value.type = "MINI";
                //         }
                //         vm.geofencesPolygon.push(value);
                //     });
                //     drawLatestGeofence(vm.geofencesPolygon);
                // }

                // function onErrorPolygon(error) {  
                //     // AlertService.error(error.data.message);
                // }
            }
        }

        function selectAllGeofences() {
            var toggleStatus = vm.isAllGeofencesSelected;
            if (toggleStatus) {
                vm.canDownload = true;
                vm.selectedGeofences = [];
                vm.geofences.forEach(function (geofence) {
                    vm.selectedGeofences.push(geofence.id);
                });
            } else {
                vm.canDownload = false;
                vm.selectedGeofences = [];
            }
            angular.forEach(vm.geofences, function (item) { item.isChecked = toggleStatus; });
        }

        function selectGeofenceEntity(geofence) {
            if (geofence.id != null) {
                if (geofence.isChecked) {
                    vm.canDownload = true;
                    vm.selectedGeofences.push(geofence.id);
                } else {
                    var index = vm.selectedGeofences.indexOf(geofence.id);
                    if (index > -1) {
                        vm.selectedGeofences.splice(index, 1);
                    }
                }
                if (vm.selectedGeofences.length == 0) {
                    vm.canDownload = false;
                    // getAssetsForListView();
                } else {
                    vm.canDownload = true;
                }
            }
        };

        function downloadAttendenceReport() {
			Report.downloadGeofenceDump({
				ids: vm.selectedGeofences
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "geofence.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function downloadAttendenceReportKml() {
			Report.downloadGeofenceDumpKml({
				ids: vm.selectedGeofences
			}, function (response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/text' });
				var fileURL = URL.createObjectURL(file);
				a.href = fileURL;
				a.download = "geofence.kml";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

        function drawLatestGeofence(response) {
            if (response) {
                initializeGeofenceMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // function() {
                    $.each(response, function (index, value) {

                        try {
                            if (value.type == "MASTER") {
                                drawPolygon(value, latlang, "#fd7a24", 1);
                            }

                        } catch (err) {
                            console.log(err);
                        }
                    });
                    $.each(response, function (index, value) {

                        try {
                            if (value.type == "MINI") {
                                drawPolygon(value, latlang, "#fd7a24", 2);
                            }

                        } catch (err) {
                            console.log(err);
                        }
                    });
                    $.each(response, function (index, value) {

                        try {
                            if (value.type == "BUFFER") {
                                drawPolygon(value, latlang,"#fd7a24", 3);
                            }

                        } catch (err) {
                            console.log(err);
                        }
                    });
                });
            }
        }

        function drawPolygon(value, latlang, color, zIndex) {
            var path = JSON.parse(value.coordinates);
            // drawPolylineForGeoFence(path, locations.map, value.name);
            var infowindow = new google.maps.InfoWindow(
                {
                    content: '<div class="infoWindowhead">'
                        + "name"
                        + '<div class="infoWindowContent"> <b>Description :</b> '
                        + "des" + '</div></div>'
                });

            infowindow.setPosition(latlang);
            var strokeColor = "#ff6a08";

            if(color == "green"){
                strokeColor = "#00e658";
            } else if (color == "blue") {
                strokeColor = "#0066CC";
            }
            
            var tempPolygon = new google.maps.Polygon({
                paths: path,
                strokeColor: strokeColor,
                strokeOpacity: 0.5,
                strokeWeight: 1.2,
                fillColor: strokeColor,
                fillOpacity: 0.1,
                zIndex: zIndex
            });
            google.maps.event.addListener(tempPolygon, 'mouseout', function (event) {
                infowindow.close();
            });

            google.maps.event.addListener(tempPolygon, 'click', function (event) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }
                infowindow.setContent('<div class="infoWindowhead">'
                    + '<b>Geofence Name : </b><br><br>' + value.name + '</br></div>'
                );

                infowindow.mousemove;
                infowindow.open(locations.map);
                infowindow.setPosition(event.latLng);
                openedInfoWindow = infowindow;
            });
            tempPolygon.setMap(locations.map);
            return tempPolygon
        }

        function GetCenterFromDegrees(data) {
            if (!(data.length > 0)) {
                return false;
            }

            var num_coords = data.length;

            var X = 0.0;
            var Y = 0.0;
            var Z = 0.0;

            for (var i = 0; i < data.length; i++) {
                var lat = (data[i].lat * Math.PI) / 180;
                var lon = (data[i].lng * Math.PI) / 180;

                var a = Math.cos(lat) * Math.cos(lon);
                var b = Math.cos(lat) * Math.sin(lon);
                var c = Math.sin(lat);

                X += a;
                Y += b;
                Z += c;
            }

            X /= num_coords;
            Y /= num_coords;
            Z /= num_coords;

            var lon = Math.atan2(Y, X);
            var hyp = Math.sqrt(X * X + Y * Y);
            var lat = Math.atan2(Z, hyp);

            var newX = (lat * 180) / Math.PI;
            var newY = (lon * 180) / Math.PI;

            centerLatLng = ({
                lat: newX,
                lng: newY
            });

            return centerLatLng
        }

        $('#masterGeofence').on('change', function() {
            vm.selectCityFilter = true;
            var value = $(this).val();
            if(value != ""){
            GeofenceByID.get(value, function (geofenceDetails) {
                var points = JSON.parse(geofenceDetails.coordinates);
                GetCenterFromDegrees(points)
                locations.latlng = {lat:points[0].lat, lng:points[0].lng};
                /* var myOptions = {
                    zoom: 10,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                }; */

                locations.map = new google.maps.Map(document
                    .getElementById("map_canvas1"), myOption(10,locations.latlng));
                geoLocation(locations.map)   
                drawPolygon(geofenceDetails, locations.latlng, "red", 1);
                MiniGeofencesByMasterID.get(geofenceDetails.id, function (response) {
                    vm.userGeofences = [];
                    response.forEach(function(value){
                        vm.previousPolygons.push(drawPolygon(value, locations.latlng, "red", 2));
                        value.label = value.name.substring(0, 15) + "..";
                        vm.userGeofences.push(value);
                    });
                });
                locations.map.setCenter(centerLatLng)
            });
            }
        });

        function drawPolylineForGeoFence(latlngsToDraw, map, details) {
            var spreadAssetCoordinates = [];
            $.each(latlngsToDraw, function (index, value) {

                spreadAssetCoordinates.push({
                    lat: value.lat,
                    lng: value.lng
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var midLatLng = {
                    lat: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lat,
                    lng: spreadAssetCoordinates[spreadAssetCoordinates.length - 1].lng
                };
                var infowindow = new google.maps.InfoWindow(
                    {
                        content: '<div class="infoWindowhead">'
                            + "name"
                            + '<div class="infoWindowContent"> <b>Description :</b> '
                            + "des" + '</div></div>'
                    });

                infowindow.setPosition(midLatLng);
                var ColorValue = '#68A8DE';
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 0.8,
                    strokeWeight: 3
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue
                });

                google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
                    infowindow.close();
                });

                google.maps.event.addListener(polylinepath, 'mouseover', function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent('<div class="infoWindowhead">'
                        + '<b></b>' + details + '</br></div>'
                    );

                    infowindow.mousemove;
                    infowindow.open(map);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;
                });
                polylinepath.setMap(map);
            }
        }

        function initializeGeofenceMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(latlangs[0].pinLat, latlangs[0].pinLong);
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {

                        latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        callback(latlng);
                    }, function () {

                        callback(new google.maps.LatLng("5.431587", "101.128162"));
                    });
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        function geofencesTable(geo) {
            vm.geofences.forEach(function (item) {
                item.isExpanded = false;
            })
            if (vm.toggle == geo.id) {
                vm.toggle = undefined
            } else {
                geo.isExpanded = true;
                vm.toggle = geo.id;
            }
            GeofenceChildAssets.get(geo.id, function (response) {
                vm.geofenceChildUsers = response;
            });
        }



        function filterSearch() {
            if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
                var str = $scope.search+"";
                    str = str.replace('/', 'slash');
                GeofenceSearch.query({
                    userId: str,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);

                function sort() {
                    var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                    if (vm.predicate !== 'id') {
                        //  result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.geofences = [];
                    data.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.geofences.push(value);
                    });
                    vm.page = pagingParams.page;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {
            Geofence.query({
                page:   pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    //  result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.geofences = [];
                data.forEach(function (value) {
                    if (value.zone) {
                        value.type = "MASTER";
                    } else {
                        value.type = "MINI";
                    }
                    vm.geofences.push(value);
                });
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        var gotoMarker = null;
        
        var input = document.getElementById('field_pinLat');
            input.addEventListener('input', function() {
            this.value = this.value.replace(/[^-0-9\,\.]/, '');
            });
        function showZoomLocation() {
            var latlng = vm.getLocationCoordinate.split(",");
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinate != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };
                locations.map.setCenter(assetCenterLatLng);
                locations.map.setZoom(18);
                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: assetCenterLatLng,
                });

                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }
        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function closeGotoLatitute() {
            $("#modalLatLongs").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalLatLongs").hide();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: $scope.search
            }); 
        }

        function filterAssetsOnGeofenveMapView() {
            $("#mapFilterGeofenceModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.marginLeft = "25px";
            vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
        }

        function closeMapFilterModal() {
            $("#mapFilterGeofenceModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterGeofenceModal").hide();
            vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
        }

        function saveGeofenceFilter() {
            vm.mapAssets = [];
            //getGroupGeofenceAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
            vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
            vm.previousPolygons.forEach(function(polygon){
                polygon.setMap(null);
            });
            vm.userGeofences.forEach(function(value){
                if(value.id == vm.selectedGeofenceId){
                    vm.previousPolygons.push(drawPolygon(value, locations.latlng, "green", 2));
                } else {
                    vm.previousPolygons.push(drawPolygon(value, locations.latlng, "red", 2));
                }
            });
           
            BufferGeofencesByMiniID.get(vm.selectedGeofenceId, function (response) {
                response.forEach(function(value){
                    vm.previousPolygons.push(drawPolygon(value, locations.latlng, "blue", 3));
                });
            });
            $("#mapFilterGeofenceModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterGeofenceModal").hide();
        }

        /* function getGroupGeofenceAssetsFromES(geofenceIdVal, lastAssetId, mapAssetLists) {
            AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;
                data.assets.forEach(function (asset) {
                    var tmpAsset = {};

                    tmpAsset.assetCoordinates = asset.assetCoordinates;
                    tmpAsset.assetTypeName = asset.assetTypeName;
                    tmpAsset.assetTypeColor = asset.assetColor;
                    tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                    tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                    tmpAsset.id = asset.id;
                    tmpAsset.name = asset.name;

                    vm.mapAssets.push(tmpAsset);
                });
                drawLatestAssetsOnMap(vm.mapAssets);
                if (data.lastId != null) {
                    getGroupGeofenceAssetsFromES(geofenceIdVal, data.lastId, vm.mapAssets);
                } else {
                    if (vm.mapAssets.length > 0) {
                        var assetSelected = vm.mapAssets[0];
                        AssetByID.get(assetSelected.id, function (assetVal) {
                            var assetLatLng = ({
                                lat: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].latitude,
                                lng: assetSelected.assetCoordinates[assetSelected.assetCoordinates.length - 1].longitude
                            });
                            locations.map.setCenter(assetLatLng);
                        });
                    }
                }
                // filterGeofenceSearchMap();
            });
        } */

       /*  function drawLatestAssetsOnMap(response) {
            if (response) {
                initializeGeofenceAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath = value.assetType.imagePath;
                            }
                            if (value.assetTypeLayout != null && value.assetTypeLayout == 'FIXED') {
                                if (value.assetCoordinates.length > 1) {
                                    drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [value.assetCoordinates[value.assetCoordinates.length - 1]];

                                    drawFixedGeofenceAsset(value1, false);

                                } else {
                                    drawFixedGeofenceAsset(value, false);
                                }
                            }
                            if (value.assetTypeLayout != null && value.assetTypeLayout == 'SPREAD') {
                                drawPolyline(value, locations.map);
                            }

                        });
                    });
                });
            }
        } */

        /* function initializeGeofenceAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal = value.assetCoordinates[value.assetCoordinates.length - 1].latitude;
                            lngVal = value.assetCoordinates[value.assetCoordinates.length - 1].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (
                        position) {

                        latlng = new google.maps.LatLng(
                            position.coords.latitude,
                            position.coords.longitude);
                        callback(latlng);
                    }, function () {

                        // callback(new google.maps.LatLng("12.9716", "77.5946"));
                        callback(new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE));
                    });
                } else {
                    callback(new google.maps.LatLng($rootScope.DEFAULT_LATITUDE, $rootScope.DEFAULT_LONGITUDE));
                }
            }
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                var myOptions = {
                    zoom: 14,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                locations.map = new google.maps.Map(document
                    .getElementById("map_canvas"), myOptions);

                // google.maps.event.addListener(locations.map, 'zoom_changed', function () {
                //     vm.zoomLevel = locations.map.getZoom();
                //     if ((vm.prevZoomLevel == 17 && vm.zoomLevel == 18) || (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)) {
                //         drawLatestAssetsOnMap(vm.mapAssets);
                //     }
                //     vm.prevZoomLevel = vm.zoomLevel;

                // });
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () { };
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById('map_canvas');
            callback();
        }

        function drawPolyline(spread, map) {
            var spreadAssetCoordinates = [];
            $.each(spread.assetCoordinates, function (index, value) {

                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat: spread.assetCoordinates[spread.assetCoordinates.length - 1].latitude,
                    lng: spread.assetCoordinates[spread.assetCoordinates.length - 1].longitude
                };

                var polylineColor = '#FFFFFF';
                var distanceFromPOP = '';
                var fiberCoreVal = '';
                var infowindow = new google.maps.InfoWindow();
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spread.assetTypeColor
                }
                var polylineWeight = 2.5;
                var strokeOpacityVal = 1.0;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false
                });

                google.maps.event.addListener(polylinepath, 'mouseout', function (event) {
                    infowindow.close();
                });

                google.maps.event.addListener(polylinepath, 'click', function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent('<div class="infoWindowhead">'
                        + '<b>Asset Name : </b><br><br>' + spread.name + '</br></div>'
                    );

                    infowindow.mousemove;
                    infowindow.open(locations.map);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;
                });

                polylinepath.setMap(locations.map);
                polylines.push(polylinepath);
            }
        }

        function drawFixedGeofenceAsset(fixed, hasParent) {

            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infowindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(
                            iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2, iconSize / 2),
                    },
                });
                google.maps.event.addListener(startMarker, 'mouseout', function (event) {
                    infowindow.close();
                });

                google.maps.event.addListener(startMarker, 'click', function (event) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent('<div class="infoWindowhead">'
                        + '<b>Asset Name : </b><br><br>' + fixed.name + '</br></div>'
                    );

                    infowindow.mousemove;
                    infowindow.open(locations.map);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;
                });
                markers.push(startMarker);

                openedInfoWindow = infowindow;
            });
        } */

    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckDialogController', FeasibilityCheckDialogController);

    FeasibilityCheckDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FeasibilityCheck'];

    function FeasibilityCheckDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FeasibilityCheck) {
        var vm = this;
        $scope.EMAIL_REGEXP = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
		$scope.PHONE_REGEXP = /^[0-9]+$/;
        vm.feasibilityCheck = entity;
        vm.clear = clear;
        vm.save = save;
        vm.feasibilityCheck.notificationType = "SMS";
       // vm.users = User.query();
       // vm.tenants = Tenant.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.feasibilityCheck.id !== null) {
                FeasibilityCheck.update(vm.feasibilityCheck, onSaveSuccess, onSaveError);
            } else {
                FeasibilityCheck.save(vm.feasibilityCheck, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:feasibilityCheckUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckDetailController', FeasibilityCheckDetailController);

    FeasibilityCheckDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FeasibilityCheck', 'User', 'Tenant'];

    function FeasibilityCheckDetailController($scope, $rootScope, $stateParams, previousState, entity, FeasibilityCheck, User, Tenant) {
        var vm = this;

        vm.feasibilityCheck = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:feasibilityCheckUpdate', function(event, result) {
            vm.feasibilityCheck = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckDeleteController',FeasibilityCheckDeleteController);

    FeasibilityCheckDeleteController.$inject = ['$uibModalInstance', 'entity', 'FeasibilityCheck'];

    function FeasibilityCheckDeleteController($uibModalInstance, entity, FeasibilityCheck) {
        var vm = this;

        vm.feasibilityCheck = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FeasibilityCheck.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('feasibility-check', {
            parent: 'entity',
            url: '/feasibility-check?page&sort&search',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.feasibilityCheck.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/feasibility-check/feasibility-checks.html',
                    controller: 'FeasibilityCheckController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                		value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feasibilityCheck');
                    $translatePartialLoader.addPart('alertType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('feasibility-check-detail', {
            parent: 'feasibility-check',
            url: '/feasibility-check/{id}',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.feasibilityCheck.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-detail.html',
                    controller: 'FeasibilityCheckDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feasibilityCheck');
                    $translatePartialLoader.addPart('alertType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FeasibilityCheck', function($stateParams, FeasibilityCheck) {
                    return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'feasibility-check',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('feasibility-check-detail.edit', {
            parent: 'feasibility-check-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-dialog.html',
                    controller: 'FeasibilityCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeasibilityCheck', function(FeasibilityCheck) {
                            return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('feasibility-check.new', {
            parent: 'feasibility-check',
            url: '/new',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-dialog.html',
                    controller: 'FeasibilityCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                requestId: null,
                                customerName: null,
                                phone: null,
                                email: null,
                                createDate: null,
                                updateDate: null,
                                notes: null,
                                latitude: null,
                                longitude: null,
                                address: null,
                                notificationType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('feasibility-check', null, { reload: 'feasibility-check' });
                }, function() {
                    $state.go('feasibility-check');
                });
            }]
        })
        .state('feasibility-check.edit', {
            parent: 'feasibility-check',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-dialog.html',
                    controller: 'FeasibilityCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeasibilityCheck', function(FeasibilityCheck) {
                            return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('feasibility-check', null, { reload: 'feasibility-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('feasibility-check.delete', {
            parent: 'feasibility-check',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER','ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feasibility-check/feasibility-check-delete-dialog.html',
                    controller: 'FeasibilityCheckDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FeasibilityCheck', function(FeasibilityCheck) {
                            return FeasibilityCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('feasibility-check', null, { reload: 'feasibility-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('FeasibilityCheck', FeasibilityCheck);

    FeasibilityCheck.$inject = ['$resource'];

    function FeasibilityCheck ($resource) {
        var resourceUrl =  'api/feasibility-checks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();



(function() {
	'use strict';

	angular.module('trakeyeApp').factory('FeasibilityCheckSearch', FeasibilityCheckSearch);

	FeasibilityCheckSearch.$inject = [ '$resource' ];

	function FeasibilityCheckSearch($resource) {
		var service = $resource('api/feasibility-checks/search/:searchText', {
			searchText : '@searchText'
		}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();





(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckController', FeasibilityCheckController);

    FeasibilityCheckController.$inject = ['$state', '$scope','FeasibilityCheck', 'FeasibilityCheckSearch','ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FeasibilityCheckController($state, $scope,FeasibilityCheck, FeasibilityCheckSearch,ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;
        $scope.search = pagingParams.search;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = filterSearch;
        loadAll();

        function loadAll () {
            FeasibilityCheck.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.feasibilityChecks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        function filterSearch () {
        	if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {
        		FeasibilityCheckSearch.query({
            	 	searchText : $scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.feasibilityChecks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
            
        	}else{
        		loadAll ();
            }
        	
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: $scope.search,
            });
        }
    }
})();

(function() {
    'use strict';

    
    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkOrderTypeAttributeDialogController",
            CustomWorkOrderTypeAttributeDialogController
        );

    CustomWorkOrderTypeAttributeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "$stateParams",
        "entity",
        "CustomWorkOrderTypeAttribute",
    ];

    function CustomWorkOrderTypeAttributeDialogController(
        $timeout,
        $scope,
        $state,
        $stateParams,
        entity,
        CustomWorkOrderTypeAttribute
    ) {
        var vm = this;

        vm.customWorkOrderTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.customworkordertypeattributevalues = CustomWorkOrderTypeAttributeValue.query();

        vm.items = [
            {
                value: "",
            },
        ];

        if (
            vm.customWorkOrderTypeAttribute
                .customWorkOrderTypeAttributeValues != null &&
            vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues
                .length != 0
        ) {
            vm.items =
                vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues;
        }
        vm.addmore = function () {
            vm.items.push({
                value: "",
            });
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
        };

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.customWorkOrderTypeAttribute.id !== null) {
                vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues =
                    [];
                for (var i = 0; i < vm.items.length; i++) {
                    vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues.push(
                        {
                            id: vm.items[i].id,
                            value: vm.items[i].value,
                        }
                    );
                }
                CustomWorkOrderTypeAttribute.update(
                    vm.customWorkOrderTypeAttribute,
                    onSaveSuccess,
                    onSaveError
                );
            } else {
                vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues =
                    [];

                for (var i = 0; i < vm.items.length; i++) {
                    vm.customWorkOrderTypeAttribute.customWorkOrderTypeAttributeValues.push(
                        {
                            id: vm.items[i].id,
                            value: vm.items[i].value,
                        }
                    );
                }

                CustomWorkOrderTypeAttribute.save(
                    vm.customWorkOrderTypeAttribute,
                    onSaveSuccess,
                    onSaveError
                );
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit(
                "trakeyeApp:customWorkOrderTypeAttributeUpdate",
                result
            );
            // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go("custom-workorder-type-attribute");
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkOrderTypeAttributeDetailController",
            CustomWorkOrderTypeAttributeDetailController
        );

    CustomWorkOrderTypeAttributeDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "CustomWorkOrderTypeAttribute",
    ];

    function CustomWorkOrderTypeAttributeDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        CustomWorkOrderTypeAttribute
    ) {
        var vm = this;

        vm.customWorkOrderTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on(
            "trakeyeApp:customWorkOrderTypeAttributeUpdate",
            function (event, result) {
                vm.customWorkOrderTypeAttribute = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkOrderTypeAttributeDeleteController",
            CustomWorkOrderTypeAttributeDeleteController
        );

    CustomWorkOrderTypeAttributeDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "CustomWorkOrderTypeAttribute",
    ];

    function CustomWorkOrderTypeAttributeDeleteController(
        $uibModalInstance,
        entity,
        CustomWorkOrderTypeAttribute
    ) {
        var vm = this;

        vm.customWorkOrderTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            CustomWorkOrderTypeAttribute.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("custom-workorder-type-attribute", {
                parent: "entity",
                url: "/custom-workorder-type-attribute?page&sort&search",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle:
                        "trakeyeApp.customWorkOrderTypeAttribute.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/custom-workorder-type-attribute/custom-workorder-type-attributes.html",
                        controller: "CustomWorkOrderTypeAttributeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart(
                                "customWorkOrderTypeAttribute"
                            );
                            $translatePartialLoader.addPart("global");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state("custom-workorder-type-attribute-detail", {
                parent: "custom-workorder-type-attribute",
                url: "/custom-workorder-type-attribute/{id}",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle:
                        "trakeyeApp.customWorkOrderTypeAttribute.detail.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-detail.html",
                        controller:
                            "CustomWorkOrderTypeAttributeDetailController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart(
                                "customWorkOrderTypeAttribute"
                            );
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "CustomWorkOrderTypeAttribute",
                        function ($stateParams, CustomWorkOrderTypeAttribute) {
                            return CustomWorkOrderTypeAttribute.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "custom-workorder-type-attribute",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })

            .state("custom-workorder-type-attribute.new", {
                parent: "custom-workorder-type-attribute",
                url: "/new",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-dialog.html",
                        controller:
                            "CustomWorkOrderTypeAttributeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            description: null,
                            id: null,
                        };
                    },
                },
            })

            .state("custom-workorder-type-attribute.edit", {
                parent: "custom-workorder-type-attribute",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                    pageTitle:
                        "trakeyeApp.customWorkOrderTypeAttribute.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-dialog.html",
                        controller:
                            "CustomWorkOrderTypeAttributeDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart(
                                "customWorkOrderTypeAttribute"
                            );
                            return $translate.refresh();
                        },
                    ],
                    entity: [
                        "$stateParams",
                        "CustomWorkOrderTypeAttribute",
                        function ($stateParams, CustomWorkOrderTypeAttribute) {
                            return CustomWorkOrderTypeAttribute.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "custom-workorder-type-attribute",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("custom-workorder-type-attribute.delete", {
                parent: "custom-workorder-type-attribute",
                url: "/{id}/delete",
                data: {
                    authorities: ["ROLE_USER_ADMIN","ROLE_PLAN_ADMIN"],
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-delete-dialog.html",
                                controller:
                                    "CustomWorkOrderTypeAttributeDeleteController",
                                controllerAs: "vm",
                                size: "md",
                                resolve: {
                                    entity: [
                                        "CustomWorkOrderTypeAttribute",
                                        function (
                                            CustomWorkOrderTypeAttribute
                                        ) {
                                            return CustomWorkOrderTypeAttribute.get(
                                                { id: $stateParams.id }
                                            ).$promise;
                                        },
                                    ],
                                },
                            })
                            .result.then(
                                function () {
                                    $state.go(
                                        "custom-workorder-type-attribute",
                                        null,
                                        {
                                            reload: "custom-workorder-type-attribute",
                                        }
                                    );
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    },
                ],
            });
    }
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("CustomWorkOrderTypeAttribute", CustomWorkOrderTypeAttribute);

    CustomWorkOrderTypeAttribute.$inject = ["$resource"];

    function CustomWorkOrderTypeAttribute($resource) {
        var resourceUrl = "api/custom-workorder-type-attributes/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkOrderTypeAttributeController",
            CustomWorkOrderTypeAttributeController
        );

    CustomWorkOrderTypeAttributeController.$inject = [
        "$state",
        "CustomWorkOrderTypeAttribute",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
    ];

    function CustomWorkOrderTypeAttributeController(
        $state,
        CustomWorkOrderTypeAttribute,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomWorkOrderTypeAttribute.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.customWorkOrderTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomWorkFlowTypeAttributeDialogController', CustomWorkFlowTypeAttributeDialogController);

    CustomWorkFlowTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomWorkFlowTypeAttribute'];

    function CustomWorkFlowTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomWorkFlowTypeAttribute) {
        var vm = this;

        vm.customWorkFlowTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customworkflowtypeattributevalues = CustomWorkFlowTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues != null && vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues.length != 0) {
			vm.items = vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customWorkFlowTypeAttribute.id !== null) {
            	
            	 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomWorkFlowTypeAttribute.update(vm.customWorkFlowTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customWorkFlowTypeAttribute.customWorkFlowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomWorkFlowTypeAttribute.save(vm.customWorkFlowTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customWorkFlowTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-work-flow-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkFlowTypeAttributeDetailController",
            CustomWorkFlowTypeAttributeDetailController
        );

    CustomWorkFlowTypeAttributeDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$stateParams",
        "previousState",
        "entity",
        "CustomWorkFlowTypeAttribute",
        "User",
        "Tenant"
    ];

    function CustomWorkFlowTypeAttributeDetailController(
        $scope,
        $rootScope,
        $stateParams,
        previousState,
        entity,
        CustomWorkFlowTypeAttribute,
        User,
        Tenant
    ) {
        var vm = this;

        vm.customWorkFlowTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on(
            "trakeyeApp:customWorkFlowTypeAttributeUpdate",
            function (event, result) {
                vm.customWorkFlowTypeAttribute = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkFlowTypeAttributeDeleteController",
            CustomWorkFlowTypeAttributeDeleteController
        );

    CustomWorkFlowTypeAttributeDeleteController.$inject = [
        "$uibModalInstance",
        "entity",
        "CustomWorkFlowTypeAttribute",
    ];

    function CustomWorkFlowTypeAttributeDeleteController(
        $uibModalInstance,
        entity,
        CustomWorkFlowTypeAttribute
    ) {
        var vm = this;

        vm.customWorkFlowTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmDelete(id) {
            CustomWorkFlowTypeAttribute.delete({ id: id }, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-work-flow-type-attribute', {
            parent: 'entity',
            url: '/custom-work-flow-type-attribute?page&sort&search',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                pageTitle: 'trakeyeApp.customWorkFlowTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attributes.html',
                    controller: 'CustomWorkFlowTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customWorkFlowTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-work-flow-type-attribute-detail', {
            parent: 'custom-work-flow-type-attribute',
            url: '/custom-work-flow-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                pageTitle: 'trakeyeApp.customWorkFlowTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-detail.html',
                    controller: 'CustomWorkFlowTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customWorkFlowTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomWorkFlowTypeAttribute', function($stateParams, CustomWorkFlowTypeAttribute) {
                    return CustomWorkFlowTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-work-flow-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })

        .state('custom-work-flow-type-attribute.new', {
            parent: 'custom-work-flow-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-dialog.html',
                    controller: 'CustomWorkFlowTypeAttributeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
            }
        })
        .state('custom-work-flow-type-attribute.edit', {
            parent: 'custom-work-flow-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-dialog.html',
                    controller: 'CustomWorkFlowTypeAttributeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customWorkFlowTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomWorkFlowTypeAttribute', function($stateParams, CustomWorkFlowTypeAttribute) {
                    return CustomWorkFlowTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-work-flow-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-work-flow-type-attribute.delete', {
            parent: 'custom-work-flow-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-delete-dialog.html',
                    controller: 'CustomWorkFlowTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomWorkFlowTypeAttribute', function(CustomWorkFlowTypeAttribute) {
                            return CustomWorkFlowTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-work-flow-type-attribute', null, { reload: 'custom-work-flow-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("CustomWorkFlowTypeAttribute", CustomWorkFlowTypeAttribute);

    CustomWorkFlowTypeAttribute.$inject = ["$resource"];

    function CustomWorkFlowTypeAttribute($resource) {
        var resourceUrl = "api/custom-workflow-type-attributes/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AllCustomWorkFlowTypeAttribute", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.getAll = function (callback) {
                $http
                    .get("api/custom-workflow-type-attributes")
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller(
            "CustomWorkFlowTypeAttributeController",
            CustomWorkFlowTypeAttributeController
        );

    CustomWorkFlowTypeAttributeController.$inject = [
        "$state",
        "CustomWorkFlowTypeAttribute",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
    ];

    function CustomWorkFlowTypeAttributeController(
        $state,
        CustomWorkFlowTypeAttribute,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams
    ) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomWorkFlowTypeAttribute.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            function onSuccess(data, headers) {
                // vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.customWorkFlowTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTrWorkOrderTypeAttributeDialogController', CustomTrWorkOrderTypeAttributeDialogController);

    CustomTrWorkOrderTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomTrWorkOrderTypeAttribute'];

    function CustomTrWorkOrderTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomTrWorkOrderTypeAttribute) {
        var vm = this;

        vm.customTrWorkOrderTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customtrWorkOrdertypeattributevalues = CustomTrWorkOrderTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues != null && vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues.length != 0) {
			vm.items = vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customTrWorkOrderTypeAttribute.id !== null) {
            	
            	 vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomTrWorkOrderTypeAttribute.update(vm.customTrWorkOrderTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTrWorkOrderTypeAttribute.customTrWorkOrderTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomTrWorkOrderTypeAttribute.save(vm.customTrWorkOrderTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customTrWorkOrderTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-trworkorder-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTrWorkOrderTypeAttributeDetailController', CustomTrWorkOrderTypeAttributeDetailController);

    CustomTrWorkOrderTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomTrWorkOrderTypeAttribute'];

    function CustomTrWorkOrderTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomTrWorkOrderTypeAttribute) {
        var vm = this;

        vm.customTrWorkOrderTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customTrWorkOrderTypeAttributeUpdate', function(event, result) {
            vm.customTrWorkOrderTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTrWorkOrderTypeAttributeDeleteController',CustomTrWorkOrderTypeAttributeDeleteController);

    CustomTrWorkOrderTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomTrWorkOrderTypeAttribute'];

    function CustomTrWorkOrderTypeAttributeDeleteController($uibModalInstance, entity, CustomTrWorkOrderTypeAttribute) {
        var vm = this;

        vm.customTrWorkOrderTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomTrWorkOrderTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-trworkorder-type-attribute', {
            parent: 'entity',
            url: '/custom-trworkorder-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customWorkOrderTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attributes.html',
                    controller: 'CustomTrWorkOrderTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-trworkorder-type-attribute-detail', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/custom-trworkorder-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customWorkOrderTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-detail.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTrWorkOrderTypeAttribute', function($stateParams, CustomTrWorkOrderTypeAttribute) {
                    return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-trworkorder-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-trworkorder-type-attribute-detail.edit', {
            parent: 'custom-trworkorder-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-trworkorder-type-attribute.new', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('custom-trworkorder-type-attribute');
                });
            }]
        })*/
        
        .state('custom-trworkorder-type-attribute.new', {
			parent : 'custom-trworkorder-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-trworkorder-type-attribute.edit', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-trworkorder-type-attribute.edit', {
			parent : 'custom-trworkorder-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customWorkOrderTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomTrWorkOrderTypeAttribute', function($stateParams, CustomTrWorkOrderTypeAttribute) {
					return CustomTrWorkOrderTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-trworkorder-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-trworkorder-type-attribute.delete', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-delete-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-trworkorder-type-attribute', {
            parent: 'entity',
            url: '/custom-trworkorder-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTrWorkOrderTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attributes.html',
                    controller: 'CustomTrWorkOrderTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-trworkorder-type-attribute-detail', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/custom-trworkorder-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customTrWorkOrderTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-detail.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTrWorkOrderTypeAttribute', function($stateParams, CustomTrWorkOrderTypeAttribute) {
                    return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-trworkorder-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-trworkorder-type-attribute-detail.edit', {
            parent: 'custom-trworkorder-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-trworkorder-type-attribute.new', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('custom-trworkorder-type-attribute');
                });
            }]
        })
        .state('custom-trworkorder-type-attribute.edit', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-trworkorder-type-attribute.delete', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-delete-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomTrWorkOrderTypeAttribute', CustomTrWorkOrderTypeAttribute);

    CustomTrWorkOrderTypeAttribute.$inject = ['$resource'];

    function CustomTrWorkOrderTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-trworkorder-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomTrWorkOrderTypeAttributeList', CustomTrWorkOrderTypeAttributeList);

    CustomTrWorkOrderTypeAttributeList.$inject = ['$resource'];

    function CustomTrWorkOrderTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-trworkorder-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTrWorkOrderTypeAttributeController', CustomTrWorkOrderTypeAttributeController);

    CustomTrWorkOrderTypeAttributeController.$inject = ['$state', 'CustomTrWorkOrderTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomTrWorkOrderTypeAttributeController($state, CustomTrWorkOrderTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomTrWorkOrderTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customTrWorkOrderTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTerrainTypeAttributeDialogController', CustomTerrainTypeAttributeDialogController);

    CustomTerrainTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomTerrainTypeAttribute'];

    function CustomTerrainTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomTerrainTypeAttribute) {
        var vm = this;

        vm.customTerrainTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customterraintypeattributevalues = CustomTerrainTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues != null && vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues.length != 0) {
			vm.items = vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customTerrainTypeAttribute.id !== null) {
            	
            	 vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomTerrainTypeAttribute.update(vm.customTerrainTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomTerrainTypeAttribute.save(vm.customTerrainTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customTerrainTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-terrain-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTerrainTypeAttributeDetailController', CustomTerrainTypeAttributeDetailController);

    CustomTerrainTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomTerrainTypeAttribute'];

    function CustomTerrainTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomTerrainTypeAttribute) {
        var vm = this;

        vm.customTerrainTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customTerrainTypeAttributeUpdate', function(event, result) {
            vm.customTerrainTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTerrainTypeAttributeDeleteController',CustomTerrainTypeAttributeDeleteController);

    CustomTerrainTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomTerrainTypeAttribute'];

    function CustomTerrainTypeAttributeDeleteController($uibModalInstance, entity, CustomTerrainTypeAttribute) {
        var vm = this;

        vm.customTerrainTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomTerrainTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-terrain-type-attribute', {
            parent: 'entity',
            url: '/custom-terrain-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTerrainTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attributes.html',
                    controller: 'CustomTerrainTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTerrainTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-terrain-type-attribute-detail', {
            parent: 'custom-terrain-type-attribute',
            url: '/custom-terrain-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTerrainTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-detail.html',
                    controller: 'CustomTerrainTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTerrainTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTerrainTypeAttribute', function($stateParams, CustomTerrainTypeAttribute) {
                    return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-terrain-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-terrain-type-attribute-detail.edit', {
            parent: 'custom-terrain-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-terrain-type-attribute.new', {
            parent: 'custom-terrain-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('custom-terrain-type-attribute');
                });
            }]
        })*/
        
        .state('custom-terrain-type-attribute.new', {
			parent : 'custom-terrain-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-terrain-type-attribute.edit', {
            parent: 'custom-terrain-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-terrain-type-attribute.edit', {
			parent : 'custom-terrain-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customTerrainTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customTerrainTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomTerrainTypeAttribute', function($stateParams, CustomTerrainTypeAttribute) {
					return CustomTerrainTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-terrain-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-terrain-type-attribute.delete', {
            parent: 'custom-terrain-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-delete-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-terrain-type-attribute', {
            parent: 'entity',
            url: '/custom-terrain-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTerrainTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attributes.html',
                    controller: 'CustomTerrainTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTerrainTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-terrain-type-attribute-detail', {
            parent: 'custom-terrain-type-attribute',
            url: '/custom-terrain-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customTerrainTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-detail.html',
                    controller: 'CustomTerrainTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTerrainTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTerrainTypeAttribute', function($stateParams, CustomTerrainTypeAttribute) {
                    return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-terrain-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-terrain-type-attribute-detail.edit', {
            parent: 'custom-terrain-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-terrain-type-attribute.new', {
            parent: 'custom-terrain-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('custom-terrain-type-attribute');
                });
            }]
        })
        .state('custom-terrain-type-attribute.edit', {
            parent: 'custom-terrain-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-terrain-type-attribute.delete', {
            parent: 'custom-terrain-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-delete-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomTerrainTypeAttribute', CustomTerrainTypeAttribute);

    CustomTerrainTypeAttribute.$inject = ['$resource'];

    function CustomTerrainTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-terrain-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomTerrainTypeAttributeList', CustomTerrainTypeAttributeList);

    CustomTerrainTypeAttributeList.$inject = ['$resource'];

    function CustomTerrainTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-terrain-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTerrainTypeAttributeController', CustomTerrainTypeAttributeController);

    CustomTerrainTypeAttributeController.$inject = ['$state', 'CustomTerrainTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomTerrainTypeAttributeController($state, CustomTerrainTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomTerrainTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customTerrainTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTaskTypeAttributeDialogController', CustomTaskTypeAttributeDialogController);

    CustomTaskTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomTaskTypeAttribute'];

    function CustomTaskTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomTaskTypeAttribute) {
        var vm = this;

        vm.customTaskTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customtasktypeattributevalues = CustomTaskTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customTaskTypeAttribute.customTaskTypeAttributeValues != null && vm.customTaskTypeAttribute.customTaskTypeAttributeValues.length != 0) {
			vm.items = vm.customTaskTypeAttribute.customTaskTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customTaskTypeAttribute.id !== null) {
            	
            	 vm.customTaskTypeAttribute.customTaskTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTaskTypeAttribute.customTaskTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomTaskTypeAttribute.update(vm.customTaskTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customTaskTypeAttribute.customTaskTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTaskTypeAttribute.customTaskTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomTaskTypeAttribute.save(vm.customTaskTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customTaskTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-task-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTaskTypeAttributeDetailController', CustomTaskTypeAttributeDetailController);

    CustomTaskTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomTaskTypeAttribute'];

    function CustomTaskTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomTaskTypeAttribute) {
        var vm = this;

        vm.customTaskTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customTaskTypeAttributeUpdate', function(event, result) {
            vm.customTaskTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTaskTypeAttributeDeleteController',CustomTaskTypeAttributeDeleteController);

    CustomTaskTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomTaskTypeAttribute'];

    function CustomTaskTypeAttributeDeleteController($uibModalInstance, entity, CustomTaskTypeAttribute) {
        var vm = this;

        vm.customTaskTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomTaskTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-task-type-attribute', {
            parent: 'entity',
            url: '/custom-task-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTaskTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attributes.html',
                    controller: 'CustomTaskTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTaskTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-task-type-attribute-detail', {
            parent: 'custom-task-type-attribute',
            url: '/custom-task-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTaskTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-detail.html',
                    controller: 'CustomTaskTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTaskTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTaskTypeAttribute', function($stateParams, CustomTaskTypeAttribute) {
                    return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-task-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-task-type-attribute-detail.edit', {
            parent: 'custom-task-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-task-type-attribute.new', {
            parent: 'custom-task-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('custom-task-type-attribute');
                });
            }]
        })*/
        
        .state('custom-task-type-attribute.new', {
			parent : 'custom-task-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-task-type-attribute.edit', {
            parent: 'custom-task-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-task-type-attribute.edit', {
			parent : 'custom-task-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customTaskTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customTaskTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomTaskTypeAttribute', function($stateParams, CustomTaskTypeAttribute) {
					return CustomTaskTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-task-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-task-type-attribute.delete', {
            parent: 'custom-task-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-delete-dialog.html',
                    controller: 'CustomTaskTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-task-type-attribute', {
            parent: 'entity',
            url: '/custom-task-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTaskTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attributes.html',
                    controller: 'CustomTaskTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTaskTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-task-type-attribute-detail', {
            parent: 'custom-task-type-attribute',
            url: '/custom-task-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customTaskTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-detail.html',
                    controller: 'CustomTaskTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTaskTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTaskTypeAttribute', function($stateParams, CustomTaskTypeAttribute) {
                    return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-task-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-task-type-attribute-detail.edit', {
            parent: 'custom-task-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-task-type-attribute.new', {
            parent: 'custom-task-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('custom-task-type-attribute');
                });
            }]
        })
        .state('custom-task-type-attribute.edit', {
            parent: 'custom-task-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html',
                    controller: 'CustomTaskTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-task-type-attribute.delete', {
            parent: 'custom-task-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-task-type-attribute/custom-task-type-attribute-delete-dialog.html',
                    controller: 'CustomTaskTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTaskTypeAttribute', function(CustomTaskTypeAttribute) {
                            return CustomTaskTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-task-type-attribute', null, { reload: 'custom-task-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomTaskTypeAttribute', CustomTaskTypeAttribute);

    CustomTaskTypeAttribute.$inject = ['$resource'];

    function CustomTaskTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-task-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomTaskTypeAttributeList', CustomTaskTypeAttributeList);

    CustomTaskTypeAttributeList.$inject = ['$resource'];

    function CustomTaskTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-task-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTaskTypeAttributeController', CustomTaskTypeAttributeController);

    CustomTaskTypeAttributeController.$inject = ['$state', 'CustomTaskTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomTaskTypeAttributeController($state, CustomTaskTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomTaskTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customTaskTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeDialogController', CustomServiceTypeAttributeDialogController);

    CustomServiceTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams',  'entity', 'CustomServiceTypeAttribute'];

    function CustomServiceTypeAttributeDialogController ($timeout, $scope, $state, $stateParams,  entity, CustomServiceTypeAttribute) {
        var vm = this;

        vm.customServiceTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       
        
       // vm.customservicetypeattributevalues = CustomServiceTypeAttributeValue.query();

        
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customServiceTypeAttribute.customServiceTypeAttributeValues != null && vm.customServiceTypeAttribute.customServiceTypeAttributeValues.length != 0) {
			vm.items = vm.customServiceTypeAttribute.customServiceTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};
        
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customServiceTypeAttribute.id !== null) {
            	 vm.customServiceTypeAttribute.customServiceTypeAttributeValues = [];
 				for (var i = 0; i < vm.items.length; i++) {
 					vm.customServiceTypeAttribute.customServiceTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
                CustomServiceTypeAttribute.update(vm.customServiceTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	vm.customServiceTypeAttribute.customServiceTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					vm.customServiceTypeAttribute.customServiceTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
            	
                CustomServiceTypeAttribute.save(vm.customServiceTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customServiceTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-service-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeDetailController', CustomServiceTypeAttributeDetailController);

    CustomServiceTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomServiceTypeAttribute'];

    function CustomServiceTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomServiceTypeAttribute) {
        var vm = this;

        vm.customServiceTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customServiceTypeAttributeUpdate', function(event, result) {
            vm.customServiceTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeDeleteController',CustomServiceTypeAttributeDeleteController);

    CustomServiceTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomServiceTypeAttribute'];

    function CustomServiceTypeAttributeDeleteController($uibModalInstance, entity, CustomServiceTypeAttribute) {
        var vm = this;

        vm.customServiceTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomServiceTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-service-type-attribute', {
            parent: 'entity',
            url: '/custom-service-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customServiceTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attributes.html',
                    controller: 'CustomServiceTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customServiceTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-service-type-attribute-detail', {
            parent: 'custom-service-type-attribute',
            url: '/custom-service-type-attribute/{id}',
            data: {
                authorities:  [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customServiceTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-detail.html',
                    controller: 'CustomServiceTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customServiceTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomServiceTypeAttribute', function($stateParams, CustomServiceTypeAttribute) {
                    return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-service-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-service-type-attribute-detail.edit', {
            parent: 'custom-service-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomServiceTypeAttribute', function(CustomServiceTypeAttribute) {
                            return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       /* .state('custom-service-type-attribute.new', {
            parent: 'custom-service-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-service-type-attribute', null, { reload: 'custom-service-type-attribute' });
                }, function() {
                    $state.go('custom-service-type-attribute');
                });
            }]
        })*/
        
        .state('custom-service-type-attribute.new', {
			parent : 'custom-service-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					 templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
	                    controller: 'CustomServiceTypeAttributeDialogController',
	                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-service-type-attribute.edit', {
            parent: 'custom-service-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomServiceTypeAttribute', function(CustomServiceTypeAttribute) {
                            return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-service-type-attribute', null, { reload: 'custom-service-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-service-type-attribute.edit', {
			parent : 'custom-service-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customServiceTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customServiceTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomServiceTypeAttribute', function($stateParams, CustomServiceTypeAttribute) {
					return CustomServiceTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-service-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-service-type-attribute.delete', {
            parent: 'custom-service-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-delete-dialog.html',
                    controller: 'CustomServiceTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomServiceTypeAttribute', function(CustomServiceTypeAttribute) {
                            return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-service-type-attribute', null, { reload: 'custom-service-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomServiceTypeAttribute', CustomServiceTypeAttribute);

    CustomServiceTypeAttribute.$inject = ['$resource'];

    function CustomServiceTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-service-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeController', CustomServiceTypeAttributeController);

    CustomServiceTypeAttributeController.$inject = ['$state', 'CustomServiceTypeAttribute', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomServiceTypeAttributeController($state, CustomServiceTypeAttribute, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CustomServiceTypeAttribute.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customServiceTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomSectionTypeAttributeDialogController', CustomSectionTypeAttributeDialogController);

    CustomSectionTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomSectionTypeAttribute'];

    function CustomSectionTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomSectionTypeAttribute) {
        var vm = this;

        vm.customSectionTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customsectiontypeattributevalues = CustomSectionTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customSectionTypeAttribute.customSectionTypeAttributeValues != null && vm.customSectionTypeAttribute.customSectionTypeAttributeValues.length != 0) {
			vm.items = vm.customSectionTypeAttribute.customSectionTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customSectionTypeAttribute.id !== null) {
            	
            	 vm.customSectionTypeAttribute.customSectionTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customSectionTypeAttribute.customSectionTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomSectionTypeAttribute.update(vm.customSectionTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customSectionTypeAttribute.customSectionTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customSectionTypeAttribute.customSectionTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomSectionTypeAttribute.save(vm.customSectionTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customSectionTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-section-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomSectionTypeAttributeDetailController', CustomSectionTypeAttributeDetailController);

    CustomSectionTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomSectionTypeAttribute'];

    function CustomSectionTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomSectionTypeAttribute) {
        var vm = this;

        vm.customSectionTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customSectionTypeAttributeUpdate', function(event, result) {
            vm.customSectionTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomSectionTypeAttributeDeleteController',CustomSectionTypeAttributeDeleteController);

    CustomSectionTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomSectionTypeAttribute'];

    function CustomSectionTypeAttributeDeleteController($uibModalInstance, entity, CustomSectionTypeAttribute) {
        var vm = this;

        vm.customSectionTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomSectionTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-section-type-attribute', {
            parent: 'entity',
            url: '/custom-section-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customSectionTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attributes.html',
                    controller: 'CustomSectionTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customSectionTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-section-type-attribute-detail', {
            parent: 'custom-section-type-attribute',
            url: '/custom-section-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customSectionTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-detail.html',
                    controller: 'CustomSectionTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customSectionTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomSectionTypeAttribute', function($stateParams, CustomSectionTypeAttribute) {
                    return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-section-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-section-type-attribute-detail.edit', {
            parent: 'custom-section-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-section-type-attribute.new', {
            parent: 'custom-section-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('custom-section-type-attribute');
                });
            }]
        })*/
        
        .state('custom-section-type-attribute.new', {
			parent : 'custom-section-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-section-type-attribute.edit', {
            parent: 'custom-section-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-section-type-attribute.edit', {
			parent : 'custom-section-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customSectionTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customSectionTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomSectionTypeAttribute', function($stateParams, CustomSectionTypeAttribute) {
					return CustomSectionTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-section-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-section-type-attribute.delete', {
            parent: 'custom-section-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-delete-dialog.html',
                    controller: 'CustomSectionTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-section-type-attribute', {
            parent: 'entity',
            url: '/custom-section-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customSectionTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attributes.html',
                    controller: 'CustomSectionTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customSectionTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-section-type-attribute-detail', {
            parent: 'custom-section-type-attribute',
            url: '/custom-section-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customSectionTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-detail.html',
                    controller: 'CustomSectionTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customSectionTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomSectionTypeAttribute', function($stateParams, CustomSectionTypeAttribute) {
                    return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-section-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-section-type-attribute-detail.edit', {
            parent: 'custom-section-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-section-type-attribute.new', {
            parent: 'custom-section-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('custom-section-type-attribute');
                });
            }]
        })
        .state('custom-section-type-attribute.edit', {
            parent: 'custom-section-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html',
                    controller: 'CustomSectionTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-section-type-attribute.delete', {
            parent: 'custom-section-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-section-type-attribute/custom-section-type-attribute-delete-dialog.html',
                    controller: 'CustomSectionTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomSectionTypeAttribute', function(CustomSectionTypeAttribute) {
                            return CustomSectionTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-section-type-attribute', null, { reload: 'custom-section-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomSectionTypeAttribute', CustomSectionTypeAttribute);

    CustomSectionTypeAttribute.$inject = ['$resource'];

    function CustomSectionTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-section-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomSectionTypeAttributeList', CustomSectionTypeAttributeList);

    CustomSectionTypeAttributeList.$inject = ['$resource'];

    function CustomSectionTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-section-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomSectionTypeAttributeController', CustomSectionTypeAttributeController);

    CustomSectionTypeAttributeController.$inject = ['$state', 'CustomSectionTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomSectionTypeAttributeController($state, CustomSectionTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomSectionTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customSectionTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRowTypeAttributeDialogController', CustomRowTypeAttributeDialogController);

    CustomRowTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomRowTypeAttribute'];

    function CustomRowTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomRowTypeAttribute) {
        var vm = this;

        vm.customRowTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customrowtypeattributevalues = CustomRowTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customRowTypeAttribute.customRowTypeAttributeValues != null && vm.customRowTypeAttribute.customRowTypeAttributeValues.length != 0) {
			vm.items = vm.customRowTypeAttribute.customRowTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customRowTypeAttribute.id !== null) {
            	
            	 vm.customRowTypeAttribute.customRowTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customRowTypeAttribute.customRowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomRowTypeAttribute.update(vm.customRowTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customRowTypeAttribute.customRowTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customRowTypeAttribute.customRowTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomRowTypeAttribute.save(vm.customRowTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customRowTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-row-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRowTypeAttributeDetailController', CustomRowTypeAttributeDetailController);

    CustomRowTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomRowTypeAttribute'];

    function CustomRowTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomRowTypeAttribute) {
        var vm = this;

        vm.customRowTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customRowTypeAttributeUpdate', function(event, result) {
            vm.customRowTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRowTypeAttributeDeleteController',CustomRowTypeAttributeDeleteController);

    CustomRowTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomRowTypeAttribute'];

    function CustomRowTypeAttributeDeleteController($uibModalInstance, entity, CustomRowTypeAttribute) {
        var vm = this;

        vm.customRowTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomRowTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-row-type-attribute', {
            parent: 'entity',
            url: '/custom-row-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customRowTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attributes.html',
                    controller: 'CustomRowTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customRowTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-row-type-attribute-detail', {
            parent: 'custom-row-type-attribute',
            url: '/custom-row-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customRowTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-detail.html',
                    controller: 'CustomRowTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customRowTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomRowTypeAttribute', function($stateParams, CustomRowTypeAttribute) {
                    return CustomRowTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-row-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-row-type-attribute-detail.edit', {
            parent: 'custom-row-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-dialog.html',
                    controller: 'CustomRowTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomRowTypeAttribute', function(CustomRowTypeAttribute) {
                            return CustomRowTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-row-type-attribute.new', {
            parent: 'custom-row-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-dialog.html',
                    controller: 'CustomRowTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-row-type-attribute', null, { reload: 'custom-row-type-attribute' });
                }, function() {
                    $state.go('custom-row-type-attribute');
                });
            }]
        })*/
        
        .state('custom-row-type-attribute.new', {
			parent : 'custom-row-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-dialog.html',
                    controller: 'CustomRowTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-row-type-attribute.edit', {
            parent: 'custom-row-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-dialog.html',
                    controller: 'CustomRowTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomRowTypeAttribute', function(CustomRowTypeAttribute) {
                            return CustomRowTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-row-type-attribute', null, { reload: 'custom-row-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-row-type-attribute.edit', {
			parent : 'custom-row-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customRowTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-dialog.html',
                    controller: 'CustomRowTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customRowTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomRowTypeAttribute', function($stateParams, CustomRowTypeAttribute) {
					return CustomRowTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-row-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-row-type-attribute.delete', {
            parent: 'custom-row-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-delete-dialog.html',
                    controller: 'CustomRowTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomRowTypeAttribute', function(CustomRowTypeAttribute) {
                            return CustomRowTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-row-type-attribute', null, { reload: 'custom-row-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-row-type-attribute', {
            parent: 'entity',
            url: '/custom-row-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customRowTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attributes.html',
                    controller: 'CustomRowTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customRowTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-row-type-attribute-detail', {
            parent: 'custom-row-type-attribute',
            url: '/custom-row-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customRowTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-detail.html',
                    controller: 'CustomRowTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customRowTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomRowTypeAttribute', function($stateParams, CustomRowTypeAttribute) {
                    return CustomRowTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-row-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-row-type-attribute-detail.edit', {
            parent: 'custom-row-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-dialog.html',
                    controller: 'CustomRowTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomRowTypeAttribute', function(CustomRowTypeAttribute) {
                            return CustomRowTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-row-type-attribute.new', {
            parent: 'custom-row-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-dialog.html',
                    controller: 'CustomRowTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-row-type-attribute', null, { reload: 'custom-row-type-attribute' });
                }, function() {
                    $state.go('custom-row-type-attribute');
                });
            }]
        })
        .state('custom-row-type-attribute.edit', {
            parent: 'custom-row-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-dialog.html',
                    controller: 'CustomRowTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomRowTypeAttribute', function(CustomRowTypeAttribute) {
                            return CustomRowTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-row-type-attribute', null, { reload: 'custom-row-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-row-type-attribute.delete', {
            parent: 'custom-row-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-row-type-attribute/custom-row-type-attribute-delete-dialog.html',
                    controller: 'CustomRowTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomRowTypeAttribute', function(CustomRowTypeAttribute) {
                            return CustomRowTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-row-type-attribute', null, { reload: 'custom-row-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomRowTypeAttribute', CustomRowTypeAttribute);

    CustomRowTypeAttribute.$inject = ['$resource'];

    function CustomRowTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-row-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomRowTypeAttributeList', CustomRowTypeAttributeList);

    CustomRowTypeAttributeList.$inject = ['$resource'];

    function CustomRowTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-row-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRowTypeAttributeController', CustomRowTypeAttributeController);

    CustomRowTypeAttributeController.$inject = ['$state', 'CustomRowTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomRowTypeAttributeController($state, CustomRowTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomRowTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customRowTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRouteTypeAttributeDialogController', CustomRouteTypeAttributeDialogController);

    CustomRouteTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomRouteTypeAttribute'];

    function CustomRouteTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomRouteTypeAttribute) {
        var vm = this;

        vm.customRouteTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customroutetypeattributevalues = CustomRouteTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customRouteTypeAttribute.customRouteTypeAttributeValues != null && vm.customRouteTypeAttribute.customRouteTypeAttributeValues.length != 0) {
			vm.items = vm.customRouteTypeAttribute.customRouteTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customRouteTypeAttribute.id !== null) {
            	
            	 vm.customRouteTypeAttribute.customRouteTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customRouteTypeAttribute.customRouteTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomRouteTypeAttribute.update(vm.customRouteTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customRouteTypeAttribute.customRouteTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customRouteTypeAttribute.customRouteTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomRouteTypeAttribute.save(vm.customRouteTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customRouteTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-route-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRouteTypeAttributeDetailController', CustomRouteTypeAttributeDetailController);

    CustomRouteTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomRouteTypeAttribute'];

    function CustomRouteTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomRouteTypeAttribute) {
        var vm = this;

        vm.customRouteTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customRouteTypeAttributeUpdate', function(event, result) {
            vm.customRouteTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRouteTypeAttributeDeleteController',CustomRouteTypeAttributeDeleteController);

    CustomRouteTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomRouteTypeAttribute'];

    function CustomRouteTypeAttributeDeleteController($uibModalInstance, entity, CustomRouteTypeAttribute) {
        var vm = this;

        vm.customRouteTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomRouteTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-route-type-attribute', {
            parent: 'entity',
            url: '/custom-route-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customRouteTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attributes.html',
                    controller: 'CustomRouteTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customRouteTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-route-type-attribute-detail', {
            parent: 'custom-route-type-attribute',
            url: '/custom-route-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customRouteTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-detail.html',
                    controller: 'CustomRouteTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customRouteTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomRouteTypeAttribute', function($stateParams, CustomRouteTypeAttribute) {
                    return CustomRouteTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-route-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-route-type-attribute-detail.edit', {
            parent: 'custom-route-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-dialog.html',
                    controller: 'CustomRouteTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomRouteTypeAttribute', function(CustomRouteTypeAttribute) {
                            return CustomRouteTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-route-type-attribute.new', {
            parent: 'custom-route-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-dialog.html',
                    controller: 'CustomRouteTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-route-type-attribute', null, { reload: 'custom-route-type-attribute' });
                }, function() {
                    $state.go('custom-route-type-attribute');
                });
            }]
        })*/
        
        .state('custom-route-type-attribute.new', {
			parent : 'custom-route-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-dialog.html',
                    controller: 'CustomRouteTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-route-type-attribute.edit', {
            parent: 'custom-route-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-dialog.html',
                    controller: 'CustomRouteTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomRouteTypeAttribute', function(CustomRouteTypeAttribute) {
                            return CustomRouteTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-route-type-attribute', null, { reload: 'custom-route-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-route-type-attribute.edit', {
			parent : 'custom-route-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customRouteTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-dialog.html',
                    controller: 'CustomRouteTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customRouteTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomRouteTypeAttribute', function($stateParams, CustomRouteTypeAttribute) {
					return CustomRouteTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-route-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-route-type-attribute.delete', {
            parent: 'custom-route-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-delete-dialog.html',
                    controller: 'CustomRouteTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomRouteTypeAttribute', function(CustomRouteTypeAttribute) {
                            return CustomRouteTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-route-type-attribute', null, { reload: 'custom-route-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-route-type-attribute', {
            parent: 'entity',
            url: '/custom-route-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customRouteTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attributes.html',
                    controller: 'CustomRouteTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customRouteTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-route-type-attribute-detail', {
            parent: 'custom-route-type-attribute',
            url: '/custom-route-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customRouteTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-detail.html',
                    controller: 'CustomRouteTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customRouteTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomRouteTypeAttribute', function($stateParams, CustomRouteTypeAttribute) {
                    return CustomRouteTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-route-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-route-type-attribute-detail.edit', {
            parent: 'custom-route-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-dialog.html',
                    controller: 'CustomRouteTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomRouteTypeAttribute', function(CustomRouteTypeAttribute) {
                            return CustomRouteTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-route-type-attribute.new', {
            parent: 'custom-route-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-dialog.html',
                    controller: 'CustomRouteTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-route-type-attribute', null, { reload: 'custom-route-type-attribute' });
                }, function() {
                    $state.go('custom-route-type-attribute');
                });
            }]
        })
        .state('custom-route-type-attribute.edit', {
            parent: 'custom-route-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-dialog.html',
                    controller: 'CustomRouteTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomRouteTypeAttribute', function(CustomRouteTypeAttribute) {
                            return CustomRouteTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-route-type-attribute', null, { reload: 'custom-route-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-route-type-attribute.delete', {
            parent: 'custom-route-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-route-type-attribute/custom-route-type-attribute-delete-dialog.html',
                    controller: 'CustomRouteTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomRouteTypeAttribute', function(CustomRouteTypeAttribute) {
                            return CustomRouteTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-route-type-attribute', null, { reload: 'custom-route-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomRouteTypeAttribute', CustomRouteTypeAttribute);

    CustomRouteTypeAttribute.$inject = ['$resource'];

    function CustomRouteTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-route-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomRouteTypeAttributeList', CustomRouteTypeAttributeList);

    CustomRouteTypeAttributeList.$inject = ['$resource'];

    function CustomRouteTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-route-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRouteTypeAttributeController', CustomRouteTypeAttributeController);

    CustomRouteTypeAttributeController.$inject = ['$state', 'CustomRouteTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomRouteTypeAttributeController($state, CustomRouteTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomRouteTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customRouteTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomResourceTypeAttributeDialogController', CustomResourceTypeAttributeDialogController);

    CustomResourceTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomResourceTypeAttribute'];

    function CustomResourceTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomResourceTypeAttribute) {
        var vm = this;

        vm.customResourceTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customresourcetypeattributevalues = CustomResourceTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customResourceTypeAttribute.customResourceTypeAttributeValues != null && vm.customResourceTypeAttribute.customResourceTypeAttributeValues.length != 0) {
			vm.items = vm.customResourceTypeAttribute.customResourceTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customResourceTypeAttribute.id !== null) {
            	
            	 vm.customResourceTypeAttribute.customResourceTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customResourceTypeAttribute.customResourceTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomResourceTypeAttribute.update(vm.customResourceTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customResourceTypeAttribute.customResourceTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customResourceTypeAttribute.customResourceTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomResourceTypeAttribute.save(vm.customResourceTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customResourceTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-resource-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomResourceTypeAttributeDetailController', CustomResourceTypeAttributeDetailController);

    CustomResourceTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomResourceTypeAttribute'];

    function CustomResourceTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomResourceTypeAttribute) {
        var vm = this;

        vm.customResourceTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customResourceTypeAttributeUpdate', function(event, result) {
            vm.customResourceTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomResourceTypeAttributeDeleteController',CustomResourceTypeAttributeDeleteController);

    CustomResourceTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomResourceTypeAttribute'];

    function CustomResourceTypeAttributeDeleteController($uibModalInstance, entity, CustomResourceTypeAttribute) {
        var vm = this;

        vm.customResourceTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomResourceTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-resource-type-attribute', {
            parent: 'entity',
            url: '/custom-resource-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customResourceTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attributes.html',
                    controller: 'CustomResourceTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customResourceTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-resource-type-attribute-detail', {
            parent: 'custom-resource-type-attribute',
            url: '/custom-resource-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customResourceTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-detail.html',
                    controller: 'CustomResourceTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customResourceTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomResourceTypeAttribute', function($stateParams, CustomResourceTypeAttribute) {
                    return CustomResourceTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-resource-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-resource-type-attribute-detail.edit', {
            parent: 'custom-resource-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-dialog.html',
                    controller: 'CustomResourceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomResourceTypeAttribute', function(CustomResourceTypeAttribute) {
                            return CustomResourceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-resource-type-attribute.new', {
            parent: 'custom-resource-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-dialog.html',
                    controller: 'CustomResourceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-resource-type-attribute', null, { reload: 'custom-resource-type-attribute' });
                }, function() {
                    $state.go('custom-resource-type-attribute');
                });
            }]
        })*/
        
        .state('custom-resource-type-attribute.new', {
			parent : 'custom-resource-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-dialog.html',
                    controller: 'CustomResourceTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-resource-type-attribute.edit', {
            parent: 'custom-resource-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-dialog.html',
                    controller: 'CustomResourceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomResourceTypeAttribute', function(CustomResourceTypeAttribute) {
                            return CustomResourceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-resource-type-attribute', null, { reload: 'custom-resource-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-resource-type-attribute.edit', {
			parent : 'custom-resource-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customResourceTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-dialog.html',
                    controller: 'CustomResourceTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customResourceTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomResourceTypeAttribute', function($stateParams, CustomResourceTypeAttribute) {
					return CustomResourceTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-resource-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-resource-type-attribute.delete', {
            parent: 'custom-resource-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-delete-dialog.html',
                    controller: 'CustomResourceTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomResourceTypeAttribute', function(CustomResourceTypeAttribute) {
                            return CustomResourceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-resource-type-attribute', null, { reload: 'custom-resource-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-resource-type-attribute', {
            parent: 'entity',
            url: '/custom-resource-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customResourceTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attributes.html',
                    controller: 'CustomResourceTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customResourceTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-resource-type-attribute-detail', {
            parent: 'custom-resource-type-attribute',
            url: '/custom-resource-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customResourceTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-detail.html',
                    controller: 'CustomResourceTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customResourceTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomResourceTypeAttribute', function($stateParams, CustomResourceTypeAttribute) {
                    return CustomResourceTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-resource-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-resource-type-attribute-detail.edit', {
            parent: 'custom-resource-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-dialog.html',
                    controller: 'CustomResourceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomResourceTypeAttribute', function(CustomResourceTypeAttribute) {
                            return CustomResourceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-resource-type-attribute.new', {
            parent: 'custom-resource-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-dialog.html',
                    controller: 'CustomResourceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-resource-type-attribute', null, { reload: 'custom-resource-type-attribute' });
                }, function() {
                    $state.go('custom-resource-type-attribute');
                });
            }]
        })
        .state('custom-resource-type-attribute.edit', {
            parent: 'custom-resource-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-dialog.html',
                    controller: 'CustomResourceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomResourceTypeAttribute', function(CustomResourceTypeAttribute) {
                            return CustomResourceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-resource-type-attribute', null, { reload: 'custom-resource-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-resource-type-attribute.delete', {
            parent: 'custom-resource-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-resource-type-attribute/custom-resource-type-attribute-delete-dialog.html',
                    controller: 'CustomResourceTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomResourceTypeAttribute', function(CustomResourceTypeAttribute) {
                            return CustomResourceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-resource-type-attribute', null, { reload: 'custom-resource-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomResourceTypeAttribute', CustomResourceTypeAttribute);

    CustomResourceTypeAttribute.$inject = ['$resource'];

    function CustomResourceTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-resource-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomResourceTypeAttributeList', CustomResourceTypeAttributeList);

    CustomResourceTypeAttributeList.$inject = ['$resource'];

    function CustomResourceTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-resource-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomResourceTypeAttributeController', CustomResourceTypeAttributeController);

    CustomResourceTypeAttributeController.$inject = ['$state', 'CustomResourceTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomResourceTypeAttributeController($state, CustomResourceTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomResourceTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customResourceTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomProjectTypeAttributeDialogController', CustomProjectTypeAttributeDialogController);

    CustomProjectTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomProjectTypeAttribute'];

    function CustomProjectTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomProjectTypeAttribute) {
        var vm = this;

        vm.customProjectTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customprojecttypeattributevalues = CustomProjectTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customProjectTypeAttribute.customProjectTypeAttributeValues != null && vm.customProjectTypeAttribute.customProjectTypeAttributeValues.length != 0) {
			vm.items = vm.customProjectTypeAttribute.customProjectTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customProjectTypeAttribute.id !== null) {
            	
            	 vm.customProjectTypeAttribute.customProjectTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customProjectTypeAttribute.customProjectTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomProjectTypeAttribute.update(vm.customProjectTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customProjectTypeAttribute.customProjectTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customProjectTypeAttribute.customProjectTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomProjectTypeAttribute.save(vm.customProjectTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customProjectTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-project-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomProjectTypeAttributeDetailController', CustomProjectTypeAttributeDetailController);

    CustomProjectTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomProjectTypeAttribute'];

    function CustomProjectTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomProjectTypeAttribute) {
        var vm = this;

        vm.customProjectTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customProjectTypeAttributeUpdate', function(event, result) {
            vm.customProjectTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomProjectTypeAttributeDeleteController',CustomProjectTypeAttributeDeleteController);

    CustomProjectTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomProjectTypeAttribute'];

    function CustomProjectTypeAttributeDeleteController($uibModalInstance, entity, CustomProjectTypeAttribute) {
        var vm = this;

        vm.customProjectTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomProjectTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-project-type-attribute', {
            parent: 'entity',
            url: '/custom-project-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customProjectTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attributes.html',
                    controller: 'CustomProjectTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customProjectTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-project-type-attribute-detail', {
            parent: 'custom-project-type-attribute',
            url: '/custom-project-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customProjectTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-detail.html',
                    controller: 'CustomProjectTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customProjectTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomProjectTypeAttribute', function($stateParams, CustomProjectTypeAttribute) {
                    return CustomProjectTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-project-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-project-type-attribute-detail.edit', {
            parent: 'custom-project-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-dialog.html',
                    controller: 'CustomProjectTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomProjectTypeAttribute', function(CustomProjectTypeAttribute) {
                            return CustomProjectTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-project-type-attribute.new', {
            parent: 'custom-project-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-dialog.html',
                    controller: 'CustomProjectTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-project-type-attribute', null, { reload: 'custom-project-type-attribute' });
                }, function() {
                    $state.go('custom-project-type-attribute');
                });
            }]
        })*/
        
        .state('custom-project-type-attribute.new', {
			parent : 'custom-project-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-dialog.html',
                    controller: 'CustomProjectTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-project-type-attribute.edit', {
            parent: 'custom-project-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-dialog.html',
                    controller: 'CustomProjectTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomProjectTypeAttribute', function(CustomProjectTypeAttribute) {
                            return CustomProjectTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-project-type-attribute', null, { reload: 'custom-project-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-project-type-attribute.edit', {
			parent : 'custom-project-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customProjectTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-dialog.html',
                    controller: 'CustomProjectTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customProjectTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomProjectTypeAttribute', function($stateParams, CustomProjectTypeAttribute) {
					return CustomProjectTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-project-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-project-type-attribute.delete', {
            parent: 'custom-project-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-delete-dialog.html',
                    controller: 'CustomProjectTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomProjectTypeAttribute', function(CustomProjectTypeAttribute) {
                            return CustomProjectTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-project-type-attribute', null, { reload: 'custom-project-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-project-type-attribute', {
            parent: 'entity',
            url: '/custom-project-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customProjectTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attributes.html',
                    controller: 'CustomProjectTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customProjectTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-project-type-attribute-detail', {
            parent: 'custom-project-type-attribute',
            url: '/custom-project-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customProjectTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-detail.html',
                    controller: 'CustomProjectTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customProjectTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomProjectTypeAttribute', function($stateParams, CustomProjectTypeAttribute) {
                    return CustomProjectTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-project-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-project-type-attribute-detail.edit', {
            parent: 'custom-project-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-dialog.html',
                    controller: 'CustomProjectTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomProjectTypeAttribute', function(CustomProjectTypeAttribute) {
                            return CustomProjectTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-project-type-attribute.new', {
            parent: 'custom-project-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-dialog.html',
                    controller: 'CustomProjectTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-project-type-attribute', null, { reload: 'custom-project-type-attribute' });
                }, function() {
                    $state.go('custom-project-type-attribute');
                });
            }]
        })
        .state('custom-project-type-attribute.edit', {
            parent: 'custom-project-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-dialog.html',
                    controller: 'CustomProjectTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomProjectTypeAttribute', function(CustomProjectTypeAttribute) {
                            return CustomProjectTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-project-type-attribute', null, { reload: 'custom-project-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-project-type-attribute.delete', {
            parent: 'custom-project-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-project-type-attribute/custom-project-type-attribute-delete-dialog.html',
                    controller: 'CustomProjectTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomProjectTypeAttribute', function(CustomProjectTypeAttribute) {
                            return CustomProjectTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-project-type-attribute', null, { reload: 'custom-project-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomProjectTypeAttribute', CustomProjectTypeAttribute);

    CustomProjectTypeAttribute.$inject = ['$resource'];

    function CustomProjectTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-project-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomProjectTypeAttributeList', CustomProjectTypeAttributeList);

    CustomProjectTypeAttributeList.$inject = ['$resource'];

    function CustomProjectTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-project-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomProjectTypeAttributeController', CustomProjectTypeAttributeController);

    CustomProjectTypeAttributeController.$inject = ['$state', 'CustomProjectTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomProjectTypeAttributeController($state, CustomProjectTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomProjectTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customProjectTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomMaterialTypeAttributeDialogController', CustomMaterialTypeAttributeDialogController);

    CustomMaterialTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomMaterialTypeAttribute'];

    function CustomMaterialTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomMaterialTypeAttribute) {
        var vm = this;

        vm.customMaterialTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.custommaterialtypeattributevalues = CustomMaterialTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues != null && vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues.length != 0) {
			vm.items = vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customMaterialTypeAttribute.id !== null) {
            	
            	 vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomMaterialTypeAttribute.update(vm.customMaterialTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customMaterialTypeAttribute.customMaterialTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomMaterialTypeAttribute.save(vm.customMaterialTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customMaterialTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-material-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomMaterialTypeAttributeDetailController', CustomMaterialTypeAttributeDetailController);

    CustomMaterialTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomMaterialTypeAttribute'];

    function CustomMaterialTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomMaterialTypeAttribute) {
        var vm = this;

        vm.customMaterialTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customMaterialTypeAttributeUpdate', function(event, result) {
            vm.customMaterialTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomMaterialTypeAttributeDeleteController',CustomMaterialTypeAttributeDeleteController);

    CustomMaterialTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomMaterialTypeAttribute'];

    function CustomMaterialTypeAttributeDeleteController($uibModalInstance, entity, CustomMaterialTypeAttribute) {
        var vm = this;

        vm.customMaterialTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomMaterialTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-material-type-attribute', {
            parent: 'entity',
            url: '/custom-material-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customMaterialTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attributes.html',
                    controller: 'CustomMaterialTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customMaterialTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-material-type-attribute-detail', {
            parent: 'custom-material-type-attribute',
            url: '/custom-material-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customMaterialTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-detail.html',
                    controller: 'CustomMaterialTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customMaterialTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomMaterialTypeAttribute', function($stateParams, CustomMaterialTypeAttribute) {
                    return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-material-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-material-type-attribute-detail.edit', {
            parent: 'custom-material-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-material-type-attribute.new', {
            parent: 'custom-material-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('custom-material-type-attribute');
                });
            }]
        })*/
        
        .state('custom-material-type-attribute.new', {
			parent : 'custom-material-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-material-type-attribute.edit', {
            parent: 'custom-material-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-material-type-attribute.edit', {
			parent : 'custom-material-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customMaterialTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customMaterialTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomMaterialTypeAttribute', function($stateParams, CustomMaterialTypeAttribute) {
					return CustomMaterialTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-material-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-material-type-attribute.delete', {
            parent: 'custom-material-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-delete-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-material-type-attribute', {
            parent: 'entity',
            url: '/custom-material-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customMaterialTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attributes.html',
                    controller: 'CustomMaterialTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customMaterialTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-material-type-attribute-detail', {
            parent: 'custom-material-type-attribute',
            url: '/custom-material-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customMaterialTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-detail.html',
                    controller: 'CustomMaterialTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customMaterialTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomMaterialTypeAttribute', function($stateParams, CustomMaterialTypeAttribute) {
                    return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-material-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-material-type-attribute-detail.edit', {
            parent: 'custom-material-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-material-type-attribute.new', {
            parent: 'custom-material-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('custom-material-type-attribute');
                });
            }]
        })
        .state('custom-material-type-attribute.edit', {
            parent: 'custom-material-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-material-type-attribute.delete', {
            parent: 'custom-material-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-delete-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomMaterialTypeAttribute', CustomMaterialTypeAttribute);

    CustomMaterialTypeAttribute.$inject = ['$resource'];

    function CustomMaterialTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-material-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomMaterialTypeAttributeList', CustomMaterialTypeAttributeList);

    CustomMaterialTypeAttributeList.$inject = ['$resource'];

    function CustomMaterialTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-material-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomMaterialTypeAttributeController', CustomMaterialTypeAttributeController);

    CustomMaterialTypeAttributeController.$inject = ['$state', 'CustomMaterialTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomMaterialTypeAttributeController($state, CustomMaterialTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomMaterialTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customMaterialTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomLogTypeAttributeDialogController', CustomLogTypeAttributeDialogController);

    CustomLogTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomLogTypeAttribute'];

    function CustomLogTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomLogTypeAttribute) {
        var vm = this;

        vm.customLogTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customlogtypeattributevalues = CustomLogTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customLogTypeAttribute.customLogTypeAttributeValues != null && vm.customLogTypeAttribute.customLogTypeAttributeValues.length != 0) {
			vm.items = vm.customLogTypeAttribute.customLogTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customLogTypeAttribute.id !== null) {
            	
            	 vm.customLogTypeAttribute.customLogTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customLogTypeAttribute.customLogTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomLogTypeAttribute.update(vm.customLogTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customLogTypeAttribute.customLogTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customLogTypeAttribute.customLogTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomLogTypeAttribute.save(vm.customLogTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customLogTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-log-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomLogTypeAttributeDetailController', CustomLogTypeAttributeDetailController);

    CustomLogTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomLogTypeAttribute'];

    function CustomLogTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomLogTypeAttribute) {
        var vm = this;

        vm.customLogTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customLogTypeAttributeUpdate', function(event, result) {
            vm.customLogTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomLogTypeAttributeDeleteController',CustomLogTypeAttributeDeleteController);

    CustomLogTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomLogTypeAttribute'];

    function CustomLogTypeAttributeDeleteController($uibModalInstance, entity, CustomLogTypeAttribute) {
        var vm = this;

        vm.customLogTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomLogTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-log-type-attribute', {
            parent: 'entity',
            url: '/custom-log-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customLogTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attributes.html',
                    controller: 'CustomLogTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customLogTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-log-type-attribute-detail', {
            parent: 'custom-log-type-attribute',
            url: '/custom-log-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customLogTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-detail.html',
                    controller: 'CustomLogTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customLogTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomLogTypeAttribute', function($stateParams, CustomLogTypeAttribute) {
                    return CustomLogTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-log-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-log-type-attribute-detail.edit', {
            parent: 'custom-log-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-dialog.html',
                    controller: 'CustomLogTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomLogTypeAttribute', function(CustomLogTypeAttribute) {
                            return CustomLogTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-log-type-attribute.new', {
            parent: 'custom-log-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-dialog.html',
                    controller: 'CustomLogTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-log-type-attribute', null, { reload: 'custom-log-type-attribute' });
                }, function() {
                    $state.go('custom-log-type-attribute');
                });
            }]
        })*/
        
        .state('custom-log-type-attribute.new', {
			parent : 'custom-log-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-dialog.html',
                    controller: 'CustomLogTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-log-type-attribute.edit', {
            parent: 'custom-log-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-dialog.html',
                    controller: 'CustomLogTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomLogTypeAttribute', function(CustomLogTypeAttribute) {
                            return CustomLogTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-log-type-attribute', null, { reload: 'custom-log-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-log-type-attribute.edit', {
			parent : 'custom-log-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customLogTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-dialog.html',
                    controller: 'CustomLogTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customLogTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomLogTypeAttribute', function($stateParams, CustomLogTypeAttribute) {
					return CustomLogTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-log-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-log-type-attribute.delete', {
            parent: 'custom-log-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-delete-dialog.html',
                    controller: 'CustomLogTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomLogTypeAttribute', function(CustomLogTypeAttribute) {
                            return CustomLogTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-log-type-attribute', null, { reload: 'custom-log-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-log-type-attribute', {
            parent: 'entity',
            url: '/custom-log-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customLogTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attributes.html',
                    controller: 'CustomLogTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customLogTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-log-type-attribute-detail', {
            parent: 'custom-log-type-attribute',
            url: '/custom-log-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customLogTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-detail.html',
                    controller: 'CustomLogTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customLogTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomLogTypeAttribute', function($stateParams, CustomLogTypeAttribute) {
                    return CustomLogTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-log-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-log-type-attribute-detail.edit', {
            parent: 'custom-log-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-dialog.html',
                    controller: 'CustomLogTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomLogTypeAttribute', function(CustomLogTypeAttribute) {
                            return CustomLogTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-log-type-attribute.new', {
            parent: 'custom-log-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-dialog.html',
                    controller: 'CustomLogTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-log-type-attribute', null, { reload: 'custom-log-type-attribute' });
                }, function() {
                    $state.go('custom-log-type-attribute');
                });
            }]
        })
        .state('custom-log-type-attribute.edit', {
            parent: 'custom-log-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-dialog.html',
                    controller: 'CustomLogTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomLogTypeAttribute', function(CustomLogTypeAttribute) {
                            return CustomLogTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-log-type-attribute', null, { reload: 'custom-log-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-log-type-attribute.delete', {
            parent: 'custom-log-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-log-type-attribute/custom-log-type-attribute-delete-dialog.html',
                    controller: 'CustomLogTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomLogTypeAttribute', function(CustomLogTypeAttribute) {
                            return CustomLogTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-log-type-attribute', null, { reload: 'custom-log-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomLogTypeAttribute', CustomLogTypeAttribute);

    CustomLogTypeAttribute.$inject = ['$resource'];

    function CustomLogTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-log-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomLogTypeAttributeList', CustomLogTypeAttributeList);

    CustomLogTypeAttributeList.$inject = ['$resource'];

    function CustomLogTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-log-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomLogTypeAttributeController', CustomLogTypeAttributeController);

    CustomLogTypeAttributeController.$inject = ['$state', 'CustomLogTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomLogTypeAttributeController($state, CustomLogTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomLogTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customLogTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeDialogController', CustomGroupTypeAttributeDialogController);

    CustomGroupTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'CustomGroupTypeAttribute'];

    function CustomGroupTypeAttributeDialogController ($timeout, $scope, $state, $stateParams, entity, CustomGroupTypeAttribute) {
        var vm = this;

        vm.customGroupTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
        //vm.customgrouptypeattributevalues = CustomGroupTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customGroupTypeAttribute.customGroupTypeAttributeValues != null && vm.customGroupTypeAttribute.customGroupTypeAttributeValues.length != 0) {
			vm.items = vm.customGroupTypeAttribute.customGroupTypeAttributeValues;
		}
        
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
           // $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customGroupTypeAttribute.id !== null) {
            	
            	 vm.customGroupTypeAttribute.customGroupTypeAttributeValues = [];
 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customGroupTypeAttribute.customGroupTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
            	
                CustomGroupTypeAttribute.update(vm.customGroupTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customGroupTypeAttribute.customGroupTypeAttributeValues = [];

 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customGroupTypeAttribute.customGroupTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
                CustomGroupTypeAttribute.save(vm.customGroupTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customGroupTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-group-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeDetailController', CustomGroupTypeAttributeDetailController);

    CustomGroupTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomGroupTypeAttribute'];

    function CustomGroupTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomGroupTypeAttribute) {
        var vm = this;

        vm.customGroupTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customGroupTypeAttributeUpdate', function(event, result) {
            vm.customGroupTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeDeleteController',CustomGroupTypeAttributeDeleteController);

    CustomGroupTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomGroupTypeAttribute'];

    function CustomGroupTypeAttributeDeleteController($uibModalInstance, entity, CustomGroupTypeAttribute) {
        var vm = this;

        vm.customGroupTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomGroupTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-group-type-attribute', {
            parent: 'entity',
            url: '/custom-group-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customGroupTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attributes.html',
                    controller: 'CustomGroupTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customGroupTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-group-type-attribute-detail', {
            parent: 'custom-group-type-attribute',
            url: '/custom-group-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customGroupTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-detail.html',
                    controller: 'CustomGroupTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customGroupTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomGroupTypeAttribute', function($stateParams, CustomGroupTypeAttribute) {
                    return CustomGroupTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-group-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-group-type-attribute-detail.edit', {
            parent: 'custom-group-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomGroupTypeAttribute', function(CustomGroupTypeAttribute) {
                            return CustomGroupTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
       /* .state('custom-group-type-attribute.new', {
            parent: 'custom-group-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-group-type-attribute', null, { reload: 'custom-group-type-attribute' });
                }, function() {
                    $state.go('custom-group-type-attribute');
                });
            }]
        })*/
        
        .state('custom-group-type-attribute.new', {
			parent : 'custom-group-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-group-type-attribute.edit', {
            parent: 'custom-group-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomGroupTypeAttribute', function(CustomGroupTypeAttribute) {
                            return CustomGroupTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-group-type-attribute', null, { reload: 'custom-group-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-group-type-attribute.edit', {
			parent : 'custom-group-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customGroupTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html',
                    controller: 'CustomGroupTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customGroupTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomGroupTypeAttribute', function($stateParams, CustomGroupTypeAttribute) {
					return CustomGroupTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-group-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
		
        .state('custom-group-type-attribute.delete', {
            parent: 'custom-group-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-group-type-attribute/custom-group-type-attribute-delete-dialog.html',
                    controller: 'CustomGroupTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomGroupTypeAttribute', function(CustomGroupTypeAttribute) {
                            return CustomGroupTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-group-type-attribute', null, { reload: 'custom-group-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomGroupTypeAttribute', CustomGroupTypeAttribute);

    CustomGroupTypeAttribute.$inject = ['$resource'];

    function CustomGroupTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-group-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeController', CustomGroupTypeAttributeController);

    CustomGroupTypeAttributeController.$inject = ['$state', 'CustomGroupTypeAttribute', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomGroupTypeAttributeController($state, CustomGroupTypeAttribute, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CustomGroupTypeAttribute.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customGroupTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeDialogController', CustomCaseTypeAttributeDialogController);

    CustomCaseTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomCaseTypeAttribute'];

    function CustomCaseTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomCaseTypeAttribute) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customcasetypeattributevalues = CustomCaseTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customCaseTypeAttribute.customCaseTypeAttributeValues != null && vm.customCaseTypeAttribute.customCaseTypeAttributeValues.length != 0) {
			vm.items = vm.customCaseTypeAttribute.customCaseTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customCaseTypeAttribute.id !== null) {
            	
            	 vm.customCaseTypeAttribute.customCaseTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customCaseTypeAttribute.customCaseTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomCaseTypeAttribute.update(vm.customCaseTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customCaseTypeAttribute.customCaseTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customCaseTypeAttribute.customCaseTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomCaseTypeAttribute.save(vm.customCaseTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customCaseTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-case-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeDetailController', CustomCaseTypeAttributeDetailController);

    CustomCaseTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomCaseTypeAttribute'];

    function CustomCaseTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomCaseTypeAttribute) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customCaseTypeAttributeUpdate', function(event, result) {
            vm.customCaseTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeDeleteController',CustomCaseTypeAttributeDeleteController);

    CustomCaseTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomCaseTypeAttribute'];

    function CustomCaseTypeAttributeDeleteController($uibModalInstance, entity, CustomCaseTypeAttribute) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomCaseTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-case-type-attribute', {
            parent: 'entity',
            url: '/custom-case-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attributes.html',
                    controller: 'CustomCaseTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-case-type-attribute-detail', {
            parent: 'custom-case-type-attribute',
            url: '/custom-case-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-detail.html',
                    controller: 'CustomCaseTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomCaseTypeAttribute', function($stateParams, CustomCaseTypeAttribute) {
                    return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-case-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-case-type-attribute-detail.edit', {
            parent: 'custom-case-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-case-type-attribute.new', {
            parent: 'custom-case-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('custom-case-type-attribute');
                });
            }]
        })*/
        
        .state('custom-case-type-attribute.new', {
			parent : 'custom-case-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-case-type-attribute.edit', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-case-type-attribute.edit', {
			parent : 'custom-case-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customCaseTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customCaseTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomCaseTypeAttribute', function($stateParams, CustomCaseTypeAttribute) {
					return CustomCaseTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-case-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-case-type-attribute.delete', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-delete-dialog.html',
                    controller: 'CustomCaseTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-case-type-attribute', {
            parent: 'entity',
            url: '/custom-case-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attributes.html',
                    controller: 'CustomCaseTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-case-type-attribute-detail', {
            parent: 'custom-case-type-attribute',
            url: '/custom-case-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-detail.html',
                    controller: 'CustomCaseTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomCaseTypeAttribute', function($stateParams, CustomCaseTypeAttribute) {
                    return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-case-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-case-type-attribute-detail.edit', {
            parent: 'custom-case-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-case-type-attribute.new', {
            parent: 'custom-case-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('custom-case-type-attribute');
                });
            }]
        })
        .state('custom-case-type-attribute.edit', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-case-type-attribute.delete', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-delete-dialog.html',
                    controller: 'CustomCaseTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomCaseTypeAttribute', CustomCaseTypeAttribute);

    CustomCaseTypeAttribute.$inject = ['$resource'];

    function CustomCaseTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-case-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('CustomCaseTypeAttributeList', CustomCaseTypeAttributeList);

    CustomCaseTypeAttributeList.$inject = ['$resource'];

    function CustomCaseTypeAttributeList($resource) {
        var resourceUrl = 'api/custom-case-type-attributes-list';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeController', CustomCaseTypeAttributeController);

    CustomCaseTypeAttributeController.$inject = ['$state', 'CustomCaseTypeAttributeList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomCaseTypeAttributeController($state, CustomCaseTypeAttributeList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CustomCaseTypeAttributeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customCaseTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomAssetTypeAttributeDialogController', CustomAssetTypeAttributeDialogController);

    CustomAssetTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'CustomAssetTypeAttribute'];

    function CustomAssetTypeAttributeDialogController ($timeout, $scope, $state, $stateParams, entity, CustomAssetTypeAttribute) {
        var vm = this;

        vm.customAssetTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
        //vm.customassettypeattributevalues = CustomAssetTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customAssetTypeAttribute.customAssetTypeAttributeValues != null && vm.customAssetTypeAttribute.customAssetTypeAttributeValues.length != 0) {
			vm.items = vm.customAssetTypeAttribute.customAssetTypeAttributeValues;
		}
        
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
           // $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customAssetTypeAttribute.id !== null) {
            	
            	 vm.customAssetTypeAttribute.customAssetTypeAttributeValues = [];
 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customAssetTypeAttribute.customAssetTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
            	
                CustomAssetTypeAttribute.update(vm.customAssetTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customAssetTypeAttribute.customAssetTypeAttributeValues = [];

 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customAssetTypeAttribute.customAssetTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
                CustomAssetTypeAttribute.save(vm.customAssetTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customAssetTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-asset-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomAssetTypeAttributeDetailController', CustomAssetTypeAttributeDetailController);

    CustomAssetTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomAssetTypeAttribute'];

    function CustomAssetTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomAssetTypeAttribute) {
        var vm = this;

        vm.customAssetTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customAssetTypeAttributeUpdate', function(event, result) {
            vm.customAssetTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomAssetTypeAttributeDeleteController',CustomAssetTypeAttributeDeleteController);

    CustomAssetTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomAssetTypeAttribute'];

    function CustomAssetTypeAttributeDeleteController($uibModalInstance, entity, CustomAssetTypeAttribute) {
        var vm = this;

        vm.customAssetTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomAssetTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-asset-type-attribute', {
            parent: 'entity',
            url: '/custom-asset-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customAssetTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attributes.html',
                    controller: 'CustomAssetTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customAssetTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-asset-type-attribute-detail', {
            parent: 'custom-asset-type-attribute',
            url: '/custom-asset-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customAssetTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-detail.html',
                    controller: 'CustomAssetTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customAssetTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomAssetTypeAttribute', function($stateParams, CustomAssetTypeAttribute) {
                    return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-asset-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-asset-type-attribute-detail.edit', {
            parent: 'custom-asset-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomAssetTypeAttribute', function(CustomAssetTypeAttribute) {
                            return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
       /* .state('custom-asset-type-attribute.new', {
            parent: 'custom-asset-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-asset-type-attribute', null, { reload: 'custom-asset-type-attribute' });
                }, function() {
                    $state.go('custom-asset-type-attribute');
                });
            }]
        })*/
        
        .state('custom-asset-type-attribute.new', {
			parent : 'custom-asset-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-asset-type-attribute.edit', {
            parent: 'custom-asset-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomAssetTypeAttribute', function(CustomAssetTypeAttribute) {
                            return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-asset-type-attribute', null, { reload: 'custom-asset-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-asset-type-attribute.edit', {
			parent : 'custom-asset-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customAssetTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html',
                    controller: 'CustomAssetTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customAssetTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomAssetTypeAttribute', function($stateParams, CustomAssetTypeAttribute) {
					return CustomAssetTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-asset-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
		
        .state('custom-asset-type-attribute.delete', {
            parent: 'custom-asset-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-asset-type-attribute/custom-asset-type-attribute-delete-dialog.html',
                    controller: 'CustomAssetTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomAssetTypeAttribute', function(CustomAssetTypeAttribute) {
                            return CustomAssetTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-asset-type-attribute', null, { reload: 'custom-asset-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomAssetTypeAttribute', CustomAssetTypeAttribute);

    CustomAssetTypeAttribute.$inject = ['$resource'];

    function CustomAssetTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-asset-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomAssetTypeAttributeController', CustomAssetTypeAttributeController);

    CustomAssetTypeAttributeController.$inject = ['$state', 'CustomAssetTypeAttribute', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomAssetTypeAttributeController($state, CustomAssetTypeAttribute, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CustomAssetTypeAttribute.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customAssetTypeAttributes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ConfigDialogController", ConfigDialogController);

    ConfigDialogController.$inject = [
        "$state",
        "$stateParams",
        "ConfigSave",
        "ConfigUpdate",
        "Configs",
        "AlertService"
    ];

    function ConfigDialogController($state, $stateParams, ConfigSave, ConfigUpdate, Configs, AlertService) {
        var vm = this;
        vm.config = {};
        vm.save = save;
        vm.clear = clear;

        if ($stateParams.id) {
            Configs.get({ id: $stateParams.id }, function (result) {
                vm.config = result;
            });
        }

        function clear() {
            $state.go("config", null, { reload: true });
        }

        function save() {
            if (vm.config.id) {
                ConfigUpdate.update(vm.config, onSaveSuccess, onSaveError);
            } else {
                ConfigSave.save(vm.config, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            AlertService.success("Configuration saved successfully!");
            $state.go("config", null, { reload: true });
        }

        function onSaveError(error) {
            AlertService.error(error.data.message);
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("config", {
                parent: "entity",
                url: "/config?page&sort&search",
                data: {
                    authorities: ['ROLE_SUPER_ADMIN'],
                    pageTitle: "trakeyeApp.workFlow.home.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/config/configs.html",
                        controller: "ConfigController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    size: {
                        value: "10",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ]
                },
            })
            .state("config.new", {
                url: "/config",
                data: {
                    authorities: ['ROLE_SUPER_ADMIN'],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/config/config-dialog.html",
                        controller: "ConfigDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "PaginationUtil",
                        function () {
                            return {
                                configCategoryName: null,
                                configKey: null,
                                configValue: null,
                                createdBy:  null,
                                createdDate:  null,
                            };
                        },
                    ],
                },
            })
            
            .state('config.edit', {
                parent: 'config',
                url: '/Edit/{id}',
                data: {
                    authorities: ['ROLE_SUPER_ADMIN'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl:
                            "app/entities/config/config-dialog.html",
                        controller: 'ConfigDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'Configs', function ($stateParams, Configs) {
                        return Configs.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'config',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
    }
})();


(function () {
	'use strict';

	angular.module('trakeyeApp').factory('Configs', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
        var config_catName = "ROLLOUT_FEATURES"
        var latitude = "DEFAULT_LATITUDE";
        var longitude = "DEFAULT_LONGITUDE"

		service.get = function (name, callback) {
			$http.get('api/configs/' + name).then(function (response) {
				callback(response.data);
			});
		};

        service.rolloutFeatures = function (callback) {
			$http.get('api/configs/'+config_catName).then(function (response) {
                callback(response.data);
            },
            function (error) {
                callback(error);
            });
		};

        service.getLatLng = function (callback) {

			$http.get('api/configs/'+latitude).then(function (response) {
                var dataLat = response.data
                if(dataLat.length && dataLat[0].configValue){
                    $http.get('api/configs/'+longitude).then(function (responseLng) {
                        var dataLng = responseLng.data
                        if(dataLng.length && dataLng[0].configValue){ 
                            callback(dataLat[0].configValue,dataLng[0].configValue);
                        }else{
                            callback(null)
                        }
                    },
                    function (error) {
                        callback(error);
                    });
                }else{
                    callback(null)
                }
            },
            function (error) {
                callback(error);
            });
		}

		return service;
	}]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ConfigList', ConfigList);

    ConfigList.$inject = ['$resource'];

    function ConfigList($resource) {
        var resourceUrl = 'api/configs/configs';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ConfigUpdate', ConfigUpdate);

    ConfigUpdate.$inject = ['$resource'];

    function ConfigUpdate($resource) {
        var resourceUrl = 'api/configs/configs';

        return $resource(resourceUrl, {}, {
            'update': {
                method: 'PUT'
            },
        });
    }
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('ConfigSave', ConfigSave);

	ConfigSave.$inject = ['$resource'];

	function ConfigSave($resource) {
		var resourceUrl = 'api/configs/configs';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('ConfigSearch', ConfigSearch);

	ConfigSearch.$inject = [ '$resource' ];

	function ConfigSearch($resource) {
		var service = $resource('api/configs/configs/searchvalue/:searchText', {
			searchText : '@searchText'
		}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ConfigController", ConfigController);

    ConfigController.$inject = [
        "$state",
        "$scope",
        "$stateParams",
        "ConfigList",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "ConfigSearch"
    ];

    function ConfigController(
        $state,
        $scope,
        $stateParams,
        ConfigList,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        ConfigSearch
    ) {
        var vm = this;
        vm.page = pagingParams.page;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterConfigSearch = filterConfigSearch;
        
        loadAll();

        function loadAll() {

            ConfigList.query({
                page: vm.page-1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.configs = data;
                vm.page = pagingParams.page;

            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                size: vm.itemsPerPage,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch
            });
        }

        function filterConfigSearch() {
            if ($scope.search) {
                ConfigSearch.query({
                    searchText: $scope.search,
                    page: vm.page-1,
                    size: vm.itemsPerPage,
                    sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
                }, function (data, headers) {
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.configs = data;
                    vm.page = pagingParams.page;

                });
            } else {
                loadAll();
            }
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("CaseTypeDialogController", CaseTypeDialogController);

    CaseTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "CaseType",
        "User",
        "CaseTypeSearch",
        "AllCustomCaseTypeAttribute",
    ];

    
    function CaseTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        CaseType,
        User,
        CaseTypeSearch,
        AllCustomCaseTypeAttribute
    ) {
        var vm = this;
        //casetype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.caseType = entity;
        vm.caseTypeImageName = caseTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customCaseTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function caseTypeImageName(image) {
            vm.caseType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomCaseTypeAttribute.getAll(function (response) {
                vm.customCaseTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customCaseTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.caseType.caseTypeAttribute != null &&
            vm.caseType.caseTypeAttribute.length != 0
        ) {
            vm.items = vm.caseType.caseTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.caseCategory == null) {
                value.caseCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.caseType.id !== null) {
                vm.caseType.caseTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.caseType.caseTypeAttribute.push({
                        caseCategory: vm.items[i].caseCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        caseTypeAttribOrder: vm.items[i].caseTypeAttribOrder
                    });
                }
                CaseType.update(vm.caseType, onSaveSuccess, onSaveError);
            } else {
                vm.caseType.caseTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.caseType.caseTypeAttribute.push({
                        caseCategory: vm.items[i].caseCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        caseTypeAttribOrder: vm.items[i].caseTypeAttribOrder
                    });
                }
                CaseType.save(vm.caseType, onSaveSuccess, onSaveError);
            }
        }

        $("#caseTypeImage").change(function () {
            var filesSelected = document.getElementById("caseTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.caseType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:caseTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("case-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CaseTypeDetailController', CaseTypeDetailController);

    CaseTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CaseType', 'User'];

    function CaseTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, CaseType, User) {
        var vm = this;

        vm.caseType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:caseTypeUpdate', function(event, result) {
            vm.caseType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CaseTypeDeleteController',CaseTypeDeleteController);

    CaseTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CaseType'];

    function CaseTypeDeleteController($uibModalInstance, entity, CaseType) {
        var vm = this;

        vm.caseType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CaseType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('case-type', {
            parent: 'entity',
            url: '/case-type',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.caseType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/case-type/case-types.html',
                    controller: 'CaseTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caseType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('case-type-detail', {
            parent: 'case-type',
            url: '/case-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.caseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/case-type/case-type-detail.html',
                    controller: 'CaseTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CaseType', function($stateParams, CaseType) {
                    return CaseType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'case-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('case-type.new', {
            parent: 'case-type',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/case-type/case-type-dialog.html',
                    controller: 'CaseTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('case-type.edit', {
            parent: 'case-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.caseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/case-type/case-type-dialog.html',
                    controller: 'CaseTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CaseType', function($stateParams, CaseType) {
                    return CaseType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'case-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('case-type.delete', {
            parent: 'case-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/case-type/case-type-delete-dialog.html',
                    controller: 'CaseTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['CaseType', function(CaseType) {
                            return CaseType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('case-type', null, { reload: 'case-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CaseType', CaseType);

    CaseType.$inject = ['$resource', 'DateUtils'];

    function CaseType ($resource, DateUtils) {
        var resourceUrl =  'api/case-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CaseTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getcasetypebyname = function (data,callback){
		$http.get('api/case-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('CaseTypeSearch', CaseTypeSearch);

    CaseTypeSearch.$inject = ['$resource'];

    function CaseTypeSearch ($resource) {
        var service = $resource('/api/case-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomCaseTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-case-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CaseTypeController', CaseTypeController);

    CaseTypeController.$inject = ['$scope', '$state', 'CaseType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','CaseTypeSearch'];

    function CaseTypeController ($scope, $state, CaseType, ParseLinks, AlertService, pagingParams, paginationConstants,CaseTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;

        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			CaseTypeSearch.query({userId:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.caseTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}
        
        loadAll();

        function loadAll () {
            CaseType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                 //   result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.caseTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider 
            .state("attribute-mapping", {
                parent: "entity",
                url: "/custom-case-type-mappers?page&sort&search",
                data: {
                    pageTitle: "trakeyeApp.caseType.home.title",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/attributeMapping/attribute-mapping.html",
                        controller: "AttributeMapping",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("caseType");
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state('attribute-mapping.new', {
                parent : 'attribute-mapping',
                url : '/new',
                data : {
                    authorities : [ 'ROLE_USER_ADMIN' ]
                },
                views : {
                    'content@' : {
                        templateUrl: 'app/entities/attributeMapping/attribute-mapping-dialog.html',
                        controller: 'AttributeMappingDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            })
            .state('attribute-mapping.delete', {
                parent: 'attribute-mapping',
                url: '/{id}',
                data: {
                    authorities: [ 'ROLE_USER_ADMIN' ],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/attributeMapping/attribute-mapping-delete-dialog.html',
                        controller: 'AttributeMappingDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            
                        }
                    }).result.then(function() {
                        $state.go('attribute-mapping', null, { reload: 'attribute-mapping' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("Mapping", [
        "$rootScope",
        "$http",

        function ($rootScope, $http) {
            var service = {};

            service.postMapping = function (data, callback) {
                $http
                    .post("api/custom-case-type-mapper", data)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("AttributeMappingList", AttributeMappingList);

    AttributeMappingList.$inject = ["$resource"];

    function AttributeMappingList($resource) {
        var resourceUrl = "api/custom-case-type-mappers";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
    angular.module("trakeyeApp").service("myservice", function () {
        var value = null;
        return {
            setValue: function (newValue) {
                value = newValue;
            },
            getValue: function () {
                return value;
            },
        };
    });
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("AttributeMappingDelete", [
        "$http",
        function ($http) {
            var service = {};
            service.delete = function (id, callback) {
                $http
                    .delete("api/custom-case-type-mappers/" + id)
                    .then(function (response) {
                        callback(response.data);
                    });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";
    angular
        .module("trakeyeApp")
        .factory("AttributeMappingListId", AttributeMappingListId);

    AttributeMappingListId.$inject = ["$resource"];

    function AttributeMappingListId($resource) {
        var resourceUrl = "api/custom-case-type-mappers/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AttributeMappingDialogController', AttributeMappingDialogController);

        AttributeMappingDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomCaseTypeAttribute','CustomCaseTypeAttributeList','pagingParams','Mapping'];

    function AttributeMappingDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomCaseTypeAttribute,CustomCaseTypeAttributeList,pagingParams,Mapping) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.predicate = pagingParams.predicate;
        vm.clear = clear;
        vm.save = save;
        vm.searchMini=""

        loadAll();

        function loadAll() {
            CustomCaseTypeAttributeList.query(
                {
                    page: pagingParams.page - 1,
                    size: 100,
                    sort: "id,asc",
                },
                onSuccess,
                onError
            );
            function onSuccess(data, headers) {
                vm.category = []
                data.forEach(function(item, index, object){
                    if(item.name == "STRING" || item.name == "INTEGER" ||  item.name == "FLOAT"){
                        
                    }else{
                        vm.category.push(item)
                    }
                })
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        $scope.funcCategoryLeft=function(){
            vm.subCategoryLeft = []
            vm.selectedCategoryLeft[0].customCaseTypeAttributeValues.forEach(function(val){
                vm.subCategoryLeft.push(val)
            })
            vm.category.forEach(function(val){
                val.disabledRight = false;
                if(val.id == vm.selectedCategoryLeft[0].id){
                    val.disabledRight = true
                }
            })
        }
        $scope.funcCategoryRight=function(){
            vm.subCategoryRight = []
            vm.selectedCategoryRight[0].customCaseTypeAttributeValues.forEach(function(val){
                vm.subCategoryRight.push(val)
            })
            vm.category.forEach(function(val){
                val.disabledLeft = false;
                if(val.id == vm.selectedCategoryRight[0].id){
                    val.disabledLeft = true
                }
            })
        }

        function save () {
            var selectedParentCaseTypeCategory = []
            selectedParentCaseTypeCategory.push({id : vm.selectedCategoryLeft[0].id , value: vm.selectedCategoryLeft[0].name} )
            
            var selectedParentSubCaseTypeCategory = []
            selectedParentSubCaseTypeCategory.push({id : vm.selectedCategoryRight[0].id , value: vm.selectedCategoryRight[0].name} )
            
            var sendMapping = []

            for(var i=0;i<vm.selectedSubCategoryRight.length;i++){
                sendMapping.push({
                    caseTypeCategory : vm.selectedSubCategoryLeft[0],
                    caseTypeSubCategory : vm.selectedSubCategoryRight[i],
                    parentCaseTypeCategory : selectedParentCaseTypeCategory[0],
                    parentCaseTypeSubCategory : selectedParentSubCaseTypeCategory[0],
                    description : ""
                })
            }
            Mapping.postMapping(sendMapping,function (response){
                onSaveSuccess()
            }) 
        }

        function onSaveSuccess () {
            //vm.isSaving = false;
            $state.go('attribute-mapping');
        }

        /* function onSaveError () {
            vm.isSaving = false;
        } */


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AttributeMappingDeleteController',AttributeMappingDeleteController);

        AttributeMappingDeleteController.$inject = ['$uibModalInstance','AttributeMappingDelete','$scope',"myservice"];

    function AttributeMappingDeleteController($uibModalInstance, AttributeMappingDelete,$scope,myservice) {
        var vm = this;

        //vm.customCaseTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
           $scope.value = myservice.getValue();
           AttributeMappingDelete.delete( $scope.value,
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AttributeMapping", AttributeMapping);

    AttributeMapping.$inject = [
        "$state",
        "AttributeMappingList",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$scope",
        "myservice"
    ];

    function AttributeMapping(
        $state,
        AttributeMappingList,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $scope,
        myservice
    ) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();
        $scope.passDeleteId = function(id){
            myservice.setValue(id);
        }

        function loadAll() {
            AttributeMappingList.query(
                {
                    page: pagingParams.page - 1,
                    size:  vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.attributeMappingList = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetTypeDialogController', AssetTypeDialogController);

    AssetTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams',  'entity', 'AssetType', 'User','AllCustomAssetTypeAttribute', '$state', '$q'];

    function AssetTypeDialogController ($timeout, $scope, $stateParams,  entity, AssetType, User,AllCustomAssetTypeAttribute, $state, $q) {
        var vm = this;
        $scope.IMAGE_EXT_REGEXP =/^(.*?)\.(jpg||jpeg||png)$/;

        vm.assetType = entity;
        $scope.attributetypes = ['INTEGER', 'FLOAT', 'STRING','BOOLEAN'];
        var userAdminAuthorities = ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER', 'ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER',
            'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_VENDOR', 'ROLE_PLAN_ADMIN', 'ROLE_PLAN_SURVEY'
        ];
        vm.clear = clear;
        vm.colorcode = colorcode;
        vm.assetImageName = assetImageName;
        vm.decodeImage = decodeImage;
        vm.authorities = [];
        vm.customCaseTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        var zoomlevelLabel,zoomlevelObj,zoomlevelObjfixed;
        
		$scope.allimages = false;
		 $scope.toggle = function() {
			$scope.allimages = !$scope.allimages;
		};

        zoomlevelObj = document.getElementById("zoomlevel");
        setSelectedValue(zoomlevelObj, vm.assetType.zoomLevel);

        zoomlevelObjfixed = document.getElementById("zoomlevelFixed");
        setSelectedValue(zoomlevelObjfixed, vm.assetType.zoomLevel);

        /* zoomlevelLabel = document.getElementById("zoomlevelLabel");
        setSelectedValue(zoomlevelLabel, vm.assetType.zoomLevelLabel); */
       
		vm.save = save;
		 $(":file").filestyle({buttonBefore: true});      
	     $(":file").filestyle('buttonText', 'Browse File');
       
         vm.addNonReferenceAttribute = function(){
            vm.items=[{ name: '',attributeDataType: {},defaultValue :''}];
            var tempItems = [];
		    vm.items.forEach(function(value){
			if(value.assetAttributeTypes == null){
				value.assetAttributeTypes = "NON_REFERENCE";
			}
			tempItems.push(value);
		});
         }
	     //vm.items=[{name: '',dataType: '',defaultValue :''}];
	     vm.referenceAttribute = []
	     vm.addNewReferenceAttribute = function(){
            if(!vm.assetType.id){
                vm.referenceAttribute = [
                    { name: "", attributeDataType: {}, defaultValue: "" },
                    {
                        name: "",
                        attributeDataType: {},
                        defaultValue: "",
                    },{
                        name: "",
                        attributeDataType: {},
                        defaultValue: "",
                    }
                ];
            }
            
            if(vm.assetType.id &&  vm.assetType.assetTypeReferenceAttributes.length == 0 ){ 
                vm.referenceAttribute = [
                    { name: "", attributeDataType: {}, defaultValue: "" },
                    {
                        name: "",
                        attributeDataType: {},
                        defaultValue: "",
                    },{
                        name: "",
                        attributeDataType: {},
                        defaultValue: "",
                    }
                ];
            }

            var tempItems = [];
            vm.referenceAttribute.forEach(function (value) {
                if (value.assetAttributeTypes == null) {
                    value.assetAttributeTypes = "THREE_PNT_REFERENCE";
                }
                tempItems.push(value);
            });
         }
		

	     if(vm.assetType.assetTypeAttributes!=null && vm.assetType.assetTypeAttributes.length!=0){
	        	vm.items=vm.assetType.assetTypeAttributes;
	        	
	        }

           

            if (
                vm.assetType.assetTypeReferenceAttributes != null &&
                vm.assetType.assetTypeReferenceAttributes.length != 0
            ) {
                vm.assetType.assetTypeReferenceAttributes.forEach(function (val){
                    vm.referenceAttribute.push(val['assetAttributeName'])
                    vm.referenceAttribute.push(val['assetAttributeValue'])
                    if(val['assetAttributeImage'] != null){
                        val['assetAttributeImage'].assetTypeRfrncAttribOrder = val.assetTypeRfrncAttribOrder
                    }
                    vm.referenceAttribute.push(val['assetAttributeImage'])
                })
            }
	     
		function loadPage() {
            vm.multiAuthorities = [];
            var selectedAuthorities = [];
			AllCustomAssetTypeAttribute.getAll(function(response) {
				vm.customAssetTypeAttributes = response;
				response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customAssetTypeAttributeValues;
				});
                if (vm.assetType.lineWidth != null) {
					var lineWidthObj = document.getElementById("lineWidth");
					setSelectedValue(lineWidthObj, vm.assetType.lineWidth);
				}
				if (vm.assetType.transparency != null) {
					var transparencyObj = document.getElementById("transparency");
					setSelectedValue(transparencyObj, vm.assetType.transparency);
				}
			});
            if(vm.assetType.id != null){
                vm.assetType.authorities.forEach(function (authority) {
                    selectedAuthorities.push(authority);
                });
            }
            
            userAdminAuthorities.forEach(function(authority){
                if (selectedAuthorities.indexOf(authority) !== -1) {
                    vm.multiAuthorities.push({ name: authority, ticked: true });
                } else {
                    vm.multiAuthorities.push({ name: authority, ticked: false });
                }
            });
            
		}
        function setSelectedValue(selectObj, valueToSet) {
            for (var i = 0; i < selectObj.options.length; i++) {
                if (selectObj.options[i].text== valueToSet) {
                    selectObj.options[i].selected = true;
                    return;
                }
            }
        }

        if(vm.assetType.assetTypeAttributes!=null && vm.assetType.assetTypeAttributes.length!=0){
        	vm.items=vm.assetType.assetTypeAttributes;
        }
        
        function colorcode(color) {
        	vm.assetType.colorcode = color;
            
        }
        function assetImageName(image) {
        	vm.assetType.image = image;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        function save () {
            vm.isSaving = true;
            vm.assetType.authorities = [];
            vm.authorities.forEach(function(auth){
                vm.assetType.authorities.push(auth.name);
            });
            if(document.getElementById("lineWidth") != null && document.getElementById("transparency") != null){
                vm.assetType.lineWidth = parseInt(document.getElementById("lineWidth").value);
                vm.assetType.transparency = parseInt(document.getElementById("transparency").value);
            }

            if(vm.assetType.layout == 'SPREAD'){
                vm.assetType.zoomLevel = parseInt(document.getElementById("zoomlevel").value);
            }

            if(vm.assetType.layout == 'FIXED'){
                vm.assetType.zoomLevel = parseInt(document.getElementById("zoomlevelFixed").value);
                //vm.assetType.zoomLevelLabel = parseInt(document.getElementById("zoomlevelLabel").value);
            }
            
            if(vm.assetType.isSeniorElement){
                vm.assetType.zoomLevel = null;
            }
            if (vm.assetType.id !== null) {
            	vm.assetType.assetTypeAttributes=[];

                if(vm.items != null && vm.items.length > 0){ 
                    for(var i = 0; i < vm.items.length; i++){
                        var attributes ={"name" :  vm.items[i]};
                        //vm.assetType.assetTypeAttributes.push({"name" :  vm.items[i].name});
                         vm.assetType.assetTypeAttributes.push({"assetAttributeTypes" : vm.items[i].assetAttributeTypes,"id" : vm.items[i].id , "name" :  vm.items[i].name,  "attributeDataType" :  vm.items[i].attributeDataType,"defaultValue" :  vm.items[i].defaultValue, 
                         assetTypeAttribOrder:vm.items[i].assetTypeAttribOrder, 
                         assetTypePopupDisplay:vm.items[i].assetTypePopupDisplay,
						             assetTypeImage:vm.items[i].assetTypeImage,
                                     mandatory: vm.items[i].mandatory
                        //  assetTypeListViewDisplay:vm.items[i].assetTypeListViewDisplay
                        });
                    }
                }
            	

                if(vm.assetType.layout == "FIXED" && vm.referenceAttribute != null && vm.referenceAttribute.length > 0){
                    vm.assetType.assetTypeReferenceAttributes=[];
                    callAssetTypeReference()
                }
                AssetType.update(vm.assetType, onSaveSuccess, onSaveError);
            } else {
                vm.assetType.assetTypeAttributes=[];

                if(vm.items != null && vm.items.length > 0){
                    for(var i = 0; i < vm.items.length; i++){
                        var attributes ={"name" :  vm.items[i]};
                       // vm.assetType.assetTypeAttributes.push({"name" :  vm.items[i].name});
                         vm.assetType.assetTypeAttributes.push({"assetAttributeTypes" : vm.items[i].assetAttributeTypes,"id" : vm.items[i].id , "name" :  vm.items[i].name,   "attributeDataType" :  vm.items[i].attributeDataType,"defaultValue" :  vm.items[i].defaultValue,
                         assetTypeAttribOrder:vm.items[i].assetTypeAttribOrder,
                         assetTypePopupDisplay:vm.items[i].assetTypePopupDisplay
                        //  assetTypeListViewDisplay:vm.items[i].assetTypeListViewDisplay
                        });
                    }
                }
            	
                if(vm.assetType.layout == "FIXED" && vm.referenceAttribute != null && vm.referenceAttribute.length > 0){
                    /* for(var i = 0; i < vm.referenceAttribute.length; i++){
                        var attributes ={"name" :  vm.referenceAttribute[i]};
                        //vm.assetType.assetTypeAttributes.push({"name" :  vm.referenceAttribute[i].name});
                         vm.assetType.assetTypeReferenceAttributes.push({
                            "assetTypeRfrncAttribOrder":  vm.referenceAttribute[i].assetTypeAttribOrder,
                            "assetAttributeName" : {
                                "assetAttributeTypes": vm.referenceAttribute[i].assetAttributeTypes,
                                "name": vm.referenceAttribute[i].name,
                                "attributeDataType": vm.referenceAttribute[i].attributeDataType,
                                "defaultValue" : vm.referenceAttribute[i].arridefaultValue,
                                "assetTypeAttribOrder": null,
                            }

                        });
                    } */
                    vm.assetType.assetTypeReferenceAttributes=[];
                    callAssetTypeReference()
                }
                AssetType.save(vm.assetType, onSaveSuccess, onSaveError);
            }
        }
       
        function callAssetTypeReference(){
            for (var i = 0; i < vm.referenceAttribute.length; i += 3) {
                        
                var obj = {
                    "assetTypeRfrncAttribOrder":  vm.referenceAttribute[i+2].assetTypeRfrncAttribOrder 
                    };
              
                obj["assetAttributeName"] = vm.referenceAttribute[i] ? {"assetAttributeTypes": vm.referenceAttribute[i].assetAttributeTypes,
                "name": vm.referenceAttribute[i].name,
                "attributeDataType": vm.referenceAttribute[i].attributeDataType,
                "defaultValue" : vm.referenceAttribute[i].defaultValue,
                "assetTypeAttribOrder": "0",} : null;
                obj["assetAttributeValue"] = vm.referenceAttribute[i + 1] ? {"assetAttributeTypes": vm.referenceAttribute[i+1].assetAttributeTypes,
                "name": vm.referenceAttribute[i+1].name,
                "attributeDataType": vm.referenceAttribute[i+1].attributeDataType,
                "defaultValue" : vm.referenceAttribute[i+1].defaultValue,
                "assetTypeAttribOrder": "1",} : null;
                obj["assetAttributeImage"] = vm.referenceAttribute[i + 2] ? {"assetAttributeTypes": vm.referenceAttribute[i+2].assetAttributeTypes,
                "name": vm.referenceAttribute[i+2].name,
                "attributeDataType": vm.referenceAttribute[i+2].attributeDataType,
                "defaultValue" : vm.referenceAttribute[i+2].defaultValue,
                "assetTypeAttribOrder": "2",} : null;

                vm.assetType.assetTypeReferenceAttributes.push(obj);
              }
        }
       /* $scope.fileNameChanged = function() {
        	
        	 var filesSelected = document.getElementById("assetImage").files;
        	 for(var i=0; i<filesSelected.length; i++){
 				var fileReader = new FileReader();
                  fileReader.onload = function(fileLoadedEvent) {
 			    	var test=window.btoa(fileLoadedEvent.target.result);
 			    	 vm.assetType.image= test;
 			    }
 			      fileReader.readAsBinaryString(filesSelected[i]);
 			}
 		   
        	}*/
        
        $("#assetImage").change(function(){
        	var filesSelected = document.getElementById("assetImage").files;
       	 	for(var i=0; i<filesSelected.length; i++){
				var fileReader = new FileReader();
                fileReader.onload = function(fileLoadedEvent) {
			    	var test=window.btoa(fileLoadedEvent.target.result);
			    	 vm.assetType.image= test;
			    	
			    }
			    fileReader.readAsBinaryString(filesSelected[i]);
			}
		    
		});
        
        

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:assetTypeUpdate", result);
            vm.isSaving = false;
            var previousId = sessionStorage.getItem("prevId");
            var prevEditDetail = sessionStorage.getItem("prevEditId");
            if (previousId) {
                sessionStorage.setItem("AssetTypeToEditAsset", "assetTypeToAsset");
                $state.go("asset.edit", {
                    id: previousId
                });
                sessionStorage.removeItem("prevId");
            } else if (prevEditDetail) {
                sessionStorage.setItem("AssetTypeToEditDetails", "assetTypeToAssetDetails");
                $state.go("asset-detail.edit", {
                    id: prevEditDetail
                });
                sessionStorage.removeItem("prevEditId");
            } else if(sessionStorage.getItem("createAssetType")) {
                $state.go("asset.new", {
                });
            }
             else if(sessionStorage.getItem("createAssetTypeAssetType")){
                $state.go("asset-type");
            } else {
                $state.go("asset-type");
            }
        }

        function onSaveError () {
            vm.isSaving = false;
        }

      /*  vm.addmore = function() {
            vm.items.push({name: ''});
          };
            
         vm.remove = function(index) {
            vm.items.splice(index, 1);
          };*/
        
        vm.addmore = function(index) {
        	vm.items.splice((index+1), 0,{name: '',attributeDataType:{}, defaultValue:'', assetAttributeTypes:"NON_REFERENCE"});
             
          };

          vm.addReferenceAttribute = function (index) {
              for (var i = 0; i < 3; i++) {
                  /* 1039 change to i<3 */
                  vm.referenceAttribute.splice(index + 1, 0, {
                      name: "",
                      attributeDataType: {},
                      defaultValue: "",
                      assetAttributeTypes: "THREE_PNT_REFERENCE",
                  });
              }
          };

          $scope.removeRow = function (index) {
              for (var i = 0; i < 3; i++) {
                  /* 1039 change to i<3*/
                  vm.referenceAttribute.splice(index - i, 1);
              }
          };

       vm.remove = function(index) {
            vm.items.splice(index, 1);
          };
          function decodeImage(img){
        	   return window.atob(img);
           }

    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetTypeDetailController', AssetTypeDetailController);

    AssetTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AssetType', 'User'];

    function AssetTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, AssetType, User) {
        var vm = this;

        vm.assetType = entity;
        vm.previousState = previousState.name;
        vm.referenceAttribute = []

        var unsubscribe = $rootScope.$on('trakeyeApp:assetTypeUpdate', function(event, result) {
            vm.assetType = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.assetType.assetTypeReferenceAttributes.forEach(function (val){
            vm.referenceAttribute.push(val['assetAttributeName'])
            vm.referenceAttribute.push(val['assetAttributeValue'])
            vm.referenceAttribute.push(val['assetAttributeImage'])
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetTypeDeleteController',AssetTypeDeleteController);

    AssetTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'AssetType'];

    function AssetTypeDeleteController($uibModalInstance, entity, AssetType) {
        var vm = this;

        vm.assetType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AssetType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('asset-type', {
            parent: 'entity',
            url: '/asset-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER_ADMIN','ROLE_USER'],
                pageTitle: 'trakeyeApp.assetType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/asset-type/asset-types.html',
                    controller: 'AssetTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assetType');
                    $translatePartialLoader.addPart('layout');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('asset-type-detail', {
            parent: 'entity',
            url: '/asset-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.assetType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/asset-type/asset-type-detail.html',
                    controller: 'AssetTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assetType');
                    $translatePartialLoader.addPart('layout');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AssetType', function($stateParams, AssetType) {
                    return AssetType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'asset-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('asset-type-detail.edit', {
            parent: 'asset-type-detail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.assetType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/asset-type/asset-type-dialog.html',
                    controller: 'AssetTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assetType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AssetType', function($stateParams, AssetType) {
                    return AssetType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'asset-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
       
        
        .state('asset-type.new', {
            parent: 'asset-type',
            url: '/new',
            data: {
            	 authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					 templateUrl: 'app/entities/asset-type/asset-type-dialog.html',
	                    controller: 'AssetTypeDialogController',
	                    controllerAs: 'vm',
				}
			},
			 resolve: {
                        entity: function () {
                            return {
                            	name: null,
                                description: null,
                                layout: null,
                                colorcode: null,
                                createDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
            
        })
        
        .state('asset-type.edit', {
            parent: 'asset-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.assetType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/asset-type/asset-type-dialog.html',
                    controller: 'AssetTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assetType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AssetType', function($stateParams, AssetType) {
                    return AssetType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'asset-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('asset-type.delete', {
            parent: 'asset-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/asset-type/asset-type-delete-dialog.html',
                    controller: 'AssetTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AssetType', function(AssetType) {
                            return AssetType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('asset-type', null, { reload: 'asset-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('AssetType', AssetType);

    AssetType.$inject = ['$resource'];

    function AssetType($resource) {
        var resourceUrl = 'api/asset-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('AssetTypeSearch', AssetTypeSearch);

    AssetTypeSearch.$inject = ['$resource'];

    function AssetTypeSearch($resource) {
        var service = $resource('/api/asset-types/searchvalue/:searchvalue', { searchvalue: '@id' }, {}, {
            'query': { method: 'GET', isArray: true },
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllCustomAssetTypeAttribute', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/all-custom-asset-type-attributes').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetTypesByGeofenceID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (geofenceId, callback) {
            $http.get('api/asset-types-geofence/' + geofenceId).then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetTypesByGeofenceIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function ( data, callback) {
            $http.post("api/asset-types-geofences", data).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetTypeController', AssetTypeController);

    AssetTypeController.$inject = ['$scope', '$state', 'AssetType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'AssetTypeSearch'];

    function AssetTypeController ($scope, $state, AssetType, ParseLinks, AlertService, pagingParams, paginationConstants, AssetTypeSearch) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch=filterSearch;
        vm.navigateCreateAssetType = navigateCreateAssetType;
        
        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			AssetTypeSearch.query({searchvalue:$scope.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    //result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.assetTypes = data;
                vm.page = pagingParams.page;
        
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
			}else{
				loadAll ();
			}
		}

        loadAll();

        function loadAll () {
            AssetType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                  //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.assetTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function navigateCreateAssetType() {
            sessionStorage.setItem("createAssetTypeAssetType", "createAssetTypeFromAssetType");
            $state.go("asset-type.new", {
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetRouteController", AssetRouteController);

    AssetRouteController.$inject = ["$scope", "$rootScope", "TrProjectListIdName", "TrRouteListByProjectId", "AssetViewES", "AssetDemographicList"];

    function AssetRouteController($scope, $rootScope, TrProjectListIdName, TrRouteListByProjectId, AssetViewES, AssetDemographicList) {
        var vm = this;
        var locations = {};

        vm.projectList = [];
        vm.routeList = [];
        vm.selectedProjectId = 0;
        vm.selectedRouteIds = 0;

        vm.selectedStates = null;
        vm.selectedDistrict = null;
        vm.selectedBlock = null;

        vm.projectSelectBtn = projectSelectBtn;
        vm.routeSelectBtn = routeSelectBtn;

        vm.fixedAssets = [];
        vm.spreadAssets = [];

        var iconSize = 18;
        var infowindow = new google.maps.InfoWindow();

        var markers = [];
        var polylines = [];
        vm.distractChartVisible = false;
        vm.countChartVisible = false;

        init();


        function init() {
            mapHeigh();
            initMap();

            TrProjectListIdName.get(function (response) {
                vm.projectList = response;
            });
        }

        function initMap() {
            var center = {
                lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
            };
            locations.map = new google.maps.Map(
                document.getElementById("map_view"),
                myOption(8, center)
            );
        }


        function mapHeigh() {
            var screenHeight = screen.height;
            if (screenHeight < 900) {
                document.getElementById("map_view").style.height = "65vh";
            } else {
                document.getElementById("map_view").style.height = "70vh";
            }
        }

        function projectSelectBtn() {
            vm.selectedRouteIds = [];
            vm.stateList = [];
            vm.districtList = [];
            vm.blockList = [];
            vm.distractChartVisible = false;
            vm.countChartVisible = false;
            TrRouteListByProjectId.get(vm.selectedProjectId[0].id, function (response) {
                vm.routeList = response;
            });
        }

        function routeSelectBtn() {
            vm.stateList = [];
            vm.districtList = [];
            vm.blockList = [];
            vm.fixedAssets = [];
            vm.spreadAssets = [];

            var routeIds = [];
            vm.selectedRouteIds.forEach(function (route) {
                routeIds.push(route.id);
            });

            callAssetsRouteByID(null, null, null, routeIds, null);
        }

        vm.onStateChange = function () {
            var routeIds = [];
            vm.selectedRouteIds.forEach(function (route) {
                routeIds.push(route.id);
            });
            vm.fixedAssets = [];
            vm.spreadAssets = [];
            callAssetsRouteByID(vm.selectedStates[0].name, null, null, routeIds, null);
            AssetDemographicList.getList({
                state: vm.selectedStates[0].name,
                district: null,
                block: null,
                routeIds: routeIds,
                lastAssetId: null
            }, function (data) {
                vm.districtList = [];
                data.forEach(function (district) {
                    vm.districtList.push({ name: district, ticked: false });
                });
            });
        }

        vm.onDistrictChange = function () {
            var routeIds = [];
            vm.selectedRouteIds.forEach(function (route) {
                routeIds.push(route.id);
            });
            vm.fixedAssets = [];
            vm.spreadAssets = [];
            callAssetsRouteByID(vm.selectedStates[0].name, vm.selectedDistrict[0].name, null, routeIds, null);
            AssetDemographicList.getList({
                state: vm.selectedStates[0].name,
                district: vm.selectedDistrict[0].name,
                block: null,
                routeIds: routeIds,
                lastAssetId: null
            }, function (data) {
                vm.blockList = [];
                data.forEach(function (block) {
                    vm.blockList.push({ name: block, ticked: false });
                });
            });
        }

        vm.onBlockChange = function () {
            var routeIds = [];
            vm.selectedRouteIds.forEach(function (route) {
                routeIds.push(route.id);
            });
            vm.fixedAssets = [];
            vm.spreadAssets = [];
            callAssetsRouteByID(vm.selectedStates[0].name, vm.selectedDistrict[0].name, vm.selectedBlock[0].name, routeIds, null);
        }

        function callAssetsRouteByID(state, district, block, routeIds, lastId) {
            AssetViewES.getAssets({
                state: state,
                district: district,
                block: block,
                routeIds: routeIds,
                lastAssetId: lastId
            }, function (data) {
                if (data.count >= 50) {
                    if (data.assets.FIXED != undefined || data.assets.FIXED != null) {
                        data.assets.FIXED.forEach(function (asset) {
                            vm.fixedAssets.push(asset);
                        });
                    }

                    if (data.assets.SPREAD != undefined || data.assets.SPREAD != null) {
                        data.assets.SPREAD.forEach(function (asset) {
                            vm.spreadAssets.push(asset);
                        });
                    }
                    callAssetsRouteByID(state, district, block, routeIds, data.lastId);
                } else if (data.assets == null) {
                    for (var i = 0; i < markers.length; i++) {
                        markers[i].setMap(null);
                    }
                    for (var i = 0; i < polylines.length; i++) {
                        polylines[i].setMap(null);
                    }
                } else {
                    if (data.assets.FIXED != undefined || data.assets.FIXED != null) {
                        data.assets.FIXED.forEach(function (asset) {
                            vm.fixedAssets.push(asset);
                        });
                    }

                    if (data.assets.SPREAD != undefined || data.assets.SPREAD != null) {
                        data.assets.SPREAD.forEach(function (asset) {
                            vm.spreadAssets.push(asset);
                        });
                    }
                    vm.assetTypes = data.assetTypes;
                    $scope.hideAssetList();
                    showMarkers(vm.fixedAssets);
                    showPolylines(vm.spreadAssets);

                    var chartGroup = "";

                    if (vm.selectedStates != null) {
                        if (vm.selectedStates.length > 0, vm.selectedDistrict.length == 0) {
                            chartGroup = "Districts";
                        } else if (vm.selectedStates.length > 0, vm.selectedDistrict.length > 0) {
                            chartGroup = "Blocks";
                        }
                    }
                    vm.distractChartVisible = true;
                    vm.countChartVisible = true;
                    // Render the horizontal bar charts
                    renderHorizontalBarChart("distance-chart", data.assetDistance, "Distance", "Total Distance", chartGroup);
                    renderHorizontalBarChart("count-chart", data.assetCount, "GP Counts", "No of GP", chartGroup);

                    if (data.stateNames.length > 0 && district == null) {
                        vm.stateList = [];
                        data.stateNames.forEach(function (state) {
                            vm.stateList.push({ name: state });
                            if (vm.stateList.length == 1) {
                                vm.stateList[0].ticked = true;
                            }
                        });
                        vm.selectedStates = [];
                        vm.stateList.forEach(function (state) {
                            if (state.ticked) {
                                vm.selectedStates.push(state.name);
                            }
                        });
                        if (vm.selectedStates.length > 0) {
                            AssetDemographicList.getList({
                                state: vm.selectedStates[0].name,
                                district: null,
                                block: null,
                                routeIds: routeIds,
                                lastAssetId: null
                            }, function (data) {
                                vm.districtList = [];
                                data.forEach(function (district) {
                                    vm.districtList.push({ name: district, ticked: false });
                                });
                            });
                        }
                    }
                }
            });
        }

        function showMarkers(assets) {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
            if (assets.length > 0) {
                assets.forEach(function (asset) {
                    var imagePath = 'content/images/blue_circle.png';
                    vm.assetTypes.forEach(function (assettype) {
                        if (assettype.name == asset.assetTypeName && assettype.imagePath != null) {
                            imagePath = assettype.imagePath;
                        }
                    });
                    if (asset.assetCoordinates.length > 0) {
                        var marker = new google.maps.Marker({
                            position: new google.maps.LatLng(asset.assetCoordinates[0].lat, asset.assetCoordinates[0].lng),
                            map: locations.map,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: imagePath,
                                anchor: new google.maps.Point(
                                    iconSize / 2,
                                    iconSize / 2
                                ),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                            name: asset.phase
                        });

                        marker.setMap(locations.map);
                        google.maps.event.addListener(
                            marker,
                            "click",
                            (function (marker) {
                                var userContent = document.createElement("div");
                                var phase = "NA";
                                if (asset.phase != null) {
                                    phase = asset.phase;
                                }
                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' +
                                    asset.name +
                                    '</div><div class="infoWindowContent">' +
                                    "<br><b>Asset Type </b> : " +
                                    asset.assetTypeName +
                                    "<br><b>State </b> : " +
                                    asset.assetTypeName +
                                    "<br><b>District </b> : " +
                                    asset.district +
                                    "<br><b>Block </b> : " +
                                    asset.block +
                                    "<br>"
                                "</div><br>";

                                return function () {
                                    infowindow.setContent(userContent);
                                    infowindow.open(locations.map, marker);
                                    infowindow.setPosition(
                                        new google.maps.LatLng(
                                            marker.getPosition().lat(),
                                            marker.getPosition().lng()
                                        )
                                    );
                                    setTimeout(function () {
                                        infowindow.close();
                                    }, 50000);
                                };
                            })(marker)
                        );
                        markers.push(marker);
                    }
                });

                var lastAsset = assets[assets.length - 1];
                if (lastAsset.assetCoordinates.length > 0) {
                    var assetLatLng = { lat: lastAsset.assetCoordinates[0].lat, lng: lastAsset.assetCoordinates[0].lng };
                    try {
                        locations.map.setCenter(assetLatLng);
                        locations.map.setZoom(8);
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
        }

        function showPolylines(assets) {
            for (var i = 0; i < polylines.length; i++) {
                polylines[i].setMap(null);
            }
            if (assets.length > 0) {
                assets.forEach(function (asset) {
                    if (asset.assetCoordinates.length > 0) {
                        var path = [];
                        var coordinates = asset.assetCoordinates;
                        // coordinates.sort(compare);
                        asset.assetCoordinates.forEach(function (latlng) {
                            path.push({ lat: latlng.lat, lng: latlng.lng });
                        });
                        var strokeColor = "BLUE";
                        if (asset.isConnected) {
                            strokeColor = "#FD7A24";
                        }
                        var polyline = new google.maps.Polyline({
                            path: path,
                            strokeColor: strokeColor,
                            geodesic: true,
                            strokeOpacity: 1.0,
                            strokeWeight: 2.5,
                        });

                        polyline.setMap(locations.map);
                        polylines.push(polyline);
                    }
                });
                var bounds = new google.maps.LatLngBounds();
                var points = polylines[polylines.length - 1].getPath().getArray();
                for (var n = 0; n < points.length; n++) {
                    bounds.extend(points[n]);
                }
                locations.map.fitBounds(bounds);
            }
        }

        // Transform data into series for Highcharts
        function transformData(data) {
            var seriesData = [];
            Object.keys(data).forEach(function (name) {
                seriesData.push({ name: name, y: data[name] });
            });
            return seriesData;
        }

        // Render the horizontal bar chart using Highcharts
        function renderHorizontalBarChart(chartId, data, title, yLabel, xLabel) {
            try {
                Highcharts.chart(chartId, {
                    chart: {
                        type: 'bar'
                    },
                    title: {
                        text: title
                    },
                    yAxis: {
                        title: {
                            text: yLabel
                        }
                    },
                    xAxis: {
                        categories: Object.keys(data), // District names as categories
                        title: {
                            text: xLabel
                        }
                    },
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            stacking: 'normal',
                            dataLabels: {
                                enabled: true,
                                format: '{point.y:.1f}' // Display value on top of each bar with 1 decimal place
                            }
                        }
                    },
                    series: [{
                        data: transformData(data)
                    }]
                });
            } catch (error) {
                console.log(error);
                if(chartId == "distance-chart"){
                    vm.distractChartVisible = false;
                } else if (chartId == "count-chart"){
                    vm.countChartVisible = false;
                }
            }

        }


        function mapStyles() {
            var styles;
            return (styles = [{ featureType: "poi", elementType: "labels.icon", stylers: [{ color: "#63666A" }] },
            { elementType: "labels.text.fill", stylers: [{ color: "#63666A", },], },
            { featureType: "transit", elementType: "labels.icon", stylers: [{ color: "#63666A" }] },
            { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", stylers: [{ color: "#efefef" }] },
            { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#ffffff" }] }]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }


        $scope.complete = function () {
            $scope.hidethis = false;
        };

        $scope.hideAssetList = function () {
            $scope.hidethis = true;
        };
        $scope.fillTextbox = function (item) {
            $scope.searchAsset = item.name;
            $scope.hidethis = true;
            var assetSelected = item;

            if (assetSelected.assetCoordinates.length > 0) {
                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length -
                            1
                        ].lat,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length -
                            1
                        ].lng,
                };
                try {
                    locations.map.setCenter(assetLatLng);
                } catch (error) {
                    console.log(error);
                }
            }
        };
    }
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetImportController", AssetImportController);

    AssetImportController.$inject = ["AllAssetsTypes", "AssetUpload"];
    function AssetImportController(AllAssetsTypes, AssetUpload) {

        var vm = this;
        var formData,getFile;

        AllAssetsTypes.getAll(function (response) {
            vm.assettypes = response;
        });

        $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });

        vm.importxlsx = /^(.*?)\.(xlsx|kml)$/;
        
        vm.upload = function () {

            getFile = document.getElementById('uploadfile').files[0]
            formData = new FormData();
            formData.append("assettype", vm.importassettype.name);
            formData.append("isexisting", true);
            formData.append("routeBundleId", 0);
            formData.append("file", getFile);
            
            AssetUpload.assetupload(formData, function (response) {
                vm.success = response.status == 200 ? "success" : ""
                if (vm.success) {
                    setTimeout(function () {
                        vm.success = "";
                    }, 3000);
                }
            });
        };
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetDialogController", AssetDialogController)

        .directive("fileread", [
            function () {
                "use strict";

                return {
                    restrict: "A",

                    link: function ($scope, element) {
                        element.change(function (event) {
                            $scope.$apply(function () {
                                $scope.myFile = element[0].files[0];
                                $scope.asset = $scope.assetname;
                            });
                        });
                    },
                };
            },
        ])

        .directive("fileModel", [
            "$parse",
            function ($parse) {
                return {
                    restrict: "A",
                    link: function (
                        scope,
                        element,
                        attrs,
                        $rootScope,
                        $broadcast
                    ) {
                        var model = $parse(attrs.fileModel);
                        var modelSetter = model.assign;

                        element.bind("change", function () {
                            var files = element[0].files;
                            var allowedTypes = {
                                "image/png": true,
                                "image/jpg": true,
                                "image/jpeg": true,
                            };

                            var data = {
                                file: files,
                                types: allowedTypes,
                            };
                            scope.$emit("callFunction", data);
                            //uploadFiles("reference", allowedTypes,files);
                        });
                    },
                };
            },
        ])

			.directive("fileChange", function() {
		    return {
		        restrict: "A",
		        scope: {
		            fileChange: "&" // allows calling a parent function
		        },
		        link: function(scope, element, attrs) {
		            element.bind("change", function(event) {
		                var files = event.target.files;
		
		                // Call the function from the parent scope
		                scope.$apply(function() {
		                    scope.fileChange({$files: files});
		                });
		            });
		        }
		    };
		})
		
        .directive("fileStyle", function () {
            return {
                link: function (scope, element) {
                    $(element).filestyle({
                        buttonBefore: true,
                    });
                    $(element).filestyle("buttonText", "Browse File");
                },
            };
        });

    AssetDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "AssetImages",
        "GroupAssets",
        "ParseLinks",
        "AlertService",
        "entity",
        "Asset",
        "User",
        "$state",
        "AssetUpload",
        "AllAssetsTypes",
        "AllCustomAssetTypeAttribute",
        "UserGroupIDs",
        "AssetByID",
        "AssetGroupSearch",
        "UserAccount",
        "GeofenceIDs",
        "UserGeofences",
        "AssetDB",
        "Geofence",
        "$localStorage",
        "Configs",
        "$rootScope"
    ];

    function AssetDialogController(
        $timeout,
        $scope,
        $stateParams,
        AssetImages,
        GroupAssets,
        ParseLinks,
        AlertService,
        entity,
        Asset,
        User,
        $state,
        AssetUpload,
        AllAssetsTypes,
        AllCustomAssetTypeAttribute,
        UserGroupIDs,
        AssetByID,
        AssetGroupSearch,
        UserAccount,
        GeofenceIDs,
        UserGeofences,
        AssetDB,
        Geofence,
        $localStorage,
        Configs,
        $rootScope
    ) {
        var vm = this;

        vm.asset = entity;

        if (vm.asset.id != null && vm.asset.assetType.layout == 'SPREAD') {
            vm.asset.assetCoordinates.sort(function (a, b) {
                // Sort by sortOrder, placing null or undefined at the end
                if (a.sortOrder == null && b.sortOrder != null) {
                    return 1;
                } else if (a.sortOrder != null && b.sortOrder == null) {
                    return -1;
                } else if (a.sortOrder != null && b.sortOrder != null) {
                    // Both have sortOrder, compare numerically
                    return a.sortOrder - b.sortOrder;
                } else {
                    // Both sortOrder are null, fallback to id comparison
                    return a.id - b.id;
                }
            });
        }
        var entity_old = angular.copy(vm.asset);
        vm.clear = clear;
        vm.save = save;
        vm.assetType = entity.assetType;

        vm.upload = upload;
        vm.showAssetImage = false;

        vm.assettypes = loadPage();
        vm.selectattributes = selectedAssetTypeAttributes;
        vm.coOrdinates = [];
        vm.coOrdinate = null;
        var newFence = false;
        var latlng;
        var locations = {};
        var centerlatlng = null;
        vm.customAttributesMap = {};
        var formData, maxSize = '2021440';
        var spreadAssets = [];
        vm.parentLatLng = [];
        vm.userAdmin = {};
        vm.userGeofenceList = null;

        vm.selectedGeofenceId = null;
        vm.prevSelectedGeofenceId = null;
        vm.userGeofences = [];
        var openedInfoWindow = null;
        var prevInfoWindow = null;
        vm.asset.assetImages = [];

        vm.navigateCreateAsset = navigateCreateAsset;
        vm.navigateCreateGroup = navigateCreateGroup;
        vm.navigateAssetType = navigateAssetType;
        vm.filterParentAssets = filterParentAssets;
        vm.filterAssetsOnMapView = filterAssetsOnMapView;
        vm.closeMapFilterModal = closeMapFilterModal;
        vm.saveFilter = saveFilter;
        vm.selectAssetCordinates = false;
        vm.showFilter = false;
        vm.fileWarning = false;
        //vm.referenceImages = false;
        //vm.assetRefAttributes = [];
        var markers = [];
        var polylines = [];
        var noDataText = null;
        var rolloutRoles = [
            "ROLE_ROLLOUT_INFRA",
            "ROLE_ROLLOUT_SURVEY",
            "ROLE_ROLLOUT_ADMIN",
        ];
        var planRoles = [
            "ROLE_PLAN_ADMIN",
            "ROLE_PLAN_INFRA",
            "ROLE_PLAN_SURVEY",
        ];
        var groupPlanRollout = ["Rollout Group", "Planning Group"];
        vm.roleAccess = false;
        vm.groupAccess = false;
        vm.roleRolloutAdmin = false;

        vm.onSelectPhase = function () {
            vm.asset.phase = vm.asset.phase[0].configKey;
        };

        $scope.$on("callFunction", function (event, data) {
            // Call the function in this controller
            uploadFiles(
                "reference",
                data.types,
                data.file,
                event.targetScope.attribute.id
            );
        });

        function loadPage() {
            if (!vm.asset.id) {
                vm.asset.phase = "ROLLOUT";
            }

            vm.multiGroup = [];
            var selectedGroup = [];

            vm.multiassets = [];
            vm.multiassetsLink = [];
            var selectedAssets = [];

            Configs.get("AssetImage", function (response) {
                if (response.length > 0) {
                    if (response[0].configValue == "True") {
                        vm.showAssetImage = true;
                    }
                }
            });

            Configs.get("MaxFileSize", function (response) {
                maxSize = response[0].configValue;
            });

            if (vm.asset.id) {

                if (vm.asset.assetReferenceAttributes.length) {
                    vm.assetRefAttributes = [];
                    vm.asset.assetReferenceAttributes.forEach(function (get) {
                        if (get["assetAttributeName"] != null) {
                            get[
                                "assetAttributeName"
                            ].assetTypeAttribute.attributeValue =
                                get["assetAttributeName"].attributeValue;
                            vm.assetRefAttributes.push(
                                get["assetAttributeName"].assetTypeAttribute
                            );
                        }

                        if (get["assetAttributeValue"] != null) {
                            get[
                                "assetAttributeValue"
                            ].assetTypeAttribute.attributeValue =
                                get["assetAttributeValue"].attributeValue;
                            vm.assetRefAttributes.push(
                                get["assetAttributeValue"].assetTypeAttribute
                            );
                        }

                        if (get["assetAttributeImage"] != null) {
                            get[
                                "assetAttributeImage"
                            ].assetTypeAttribute.attributeValue =
                                get["assetAttributeImage"].image;
                            get[
                                "assetAttributeImage"
                            ].assetTypeAttribute.attributeName =
                                get["assetAttributeImage"].imageName;
                            get[
                                "assetAttributeImage"
                            ].assetTypeAttribute.imageId =
                                get["assetAttributeImage"].imageId;
                            get[
                                "assetAttributeImage"
                            ].assetTypeAttribute.attributeType =
                                get["assetAttributeImage"].imageType;
                            vm.assetRefAttributes.push(
                                get["assetAttributeImage"].assetTypeAttribute
                            );
                        }
                    });
                } else {
                    vm.assetRefAttributes = [];
                    if (vm.asset.assetType.assetTypeReferenceAttributes.length) {
                        vm.asset.assetType.assetTypeReferenceAttributes.forEach(function (get) {
                            get["assetAttributeName"].attributeValue =
                                get["assetAttributeName"].defaultValue;
                            vm.assetRefAttributes.push(get["assetAttributeName"]);
                            get["assetAttributeValue"].attributeValue =
                                get["assetAttributeValue"].defaultValue;
                            vm.assetRefAttributes.push(get["assetAttributeValue"]);
                            vm.assetRefAttributes.push(get["assetAttributeImage"]);
                        });
                    }

                }
            }

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
                );
                imgWindow.document.close();
            };

            if (vm.asset.id != null) {
                vm.asset.ownedBy.forEach(function (asset) {
                    selectedAssets.push(asset.id);
                    vm.selectedParent = asset.name;
                    AssetGroupSearch.query(
                        {
                            search: asset.name,
                        },
                        onSuccess,
                        onError
                    );

                    function onSuccess(data, headers) {
                        vm.parentAssets = data;
                    }

                    function onError(error) {
                        AlertService.error(error.data.message);
                    }
                });

                vm.asset.groups.forEach(function (group) {
                    selectedGroup.push(group.id);
                });
            }

            var assetTypeAttributeValuesList =
                vm.asset.assetTypeAttributeValues;

            try {
                for (var index in vm.asset.assetType.assetTypeAttributes) {
                    if (
                        !checkIfAssetTypeExists(
                            vm.asset.assetType.assetTypeAttributes[index],
                            vm.asset.assetTypeAttributeValues
                        )
                    ) {
                        var assetTypeAttribute1 =
                            vm.asset.assetType.assetTypeAttributes[index];
                        assetTypeAttributeValuesList.push({
                            assetTypeAttribute: assetTypeAttribute1,
                            attributeValue:
                                vm.asset.assetType.assetTypeAttributes[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) { }

            function checkIfAssetTypeExists(assetType, assetTypeAttrVal) {
                var hasAssetType = false;
                for (var i = 0; i < assetTypeAttrVal.length; i++) {
                    var name = assetTypeAttrVal[i].assetTypeAttribute.name;
                    if (name == assetType.name) {
                        hasAssetType = true;
                        break;
                    }
                }
                return hasAssetType;
            }

            // assetTypeAttributeValuesList.sort(function (a, b) {
            //     var nameA = a.assetTypeAttribute.name.toLowerCase(),
            //         nameB = b.assetTypeAttribute.name.toLowerCase();
            //     if (nameA < nameB)
            //         // sort string ascending
            //         return -1;
            //     if (nameA > nameB) return 1;
            //     return 0; // default return value (no sorting)
            // });
            // vm.asset.assetTypeAttributeValues = assetTypeAttributeValuesList;

            UserGroupIDs.getAll(function (response) {
                response.forEach(function (group) {
                    if (selectedGroup.indexOf(group.id) !== -1) {
                        vm.multiGroup.push({
                            name: group.name,
                            id: group.id,
                            ticked: true,
                        });
                    } else {
                        vm.multiGroup.push({
                            name: group.name,
                            id: group.id,
                            ticked: false,
                        });
                    }

                    if (groupPlanRollout.includes(group.name)) {
                        vm.groupAccess = true;
                    }
                });
            });
            //            if (!entity.assetImport) {
            //                getGroupAsset(0, vm.multiassets, selectedAssets);
            //            }

            AllAssetsTypes.getAll(function (response) {
                vm.assettypes = response;
            });

            AllCustomAssetTypeAttribute.getAll(function (response) {
                // vm.customCaseTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customAssetTypeAttributeValues;
                });
            });

            vm.multiassets.sort(function (a, b) {
                var nameA = a.name.toLowerCase(),
                    nameB = b.name.toLowerCase();
                if (nameA < nameB)
                    // sort string ascending
                    return -1;
                if (nameA > nameB) return 1;
                return 0; // default return value (no sorting)
            });

            UserAccount.get(function (data) {
                vm.userAdmin = data;
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    }
                    if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }

                    if (
                        val == "ROLE_ROLLOUT_ADMIN" &&
                        vm.asset.phase == "ROLLOUT"
                    ) {
                        vm.roleRolloutAdmin = true;
                    }

                    if (rolloutRoles.includes(val) || planRoles.includes(val)) {
                        vm.roleAccess = true;
                    }
                });
                if (isAdmin) {
                    GeofenceIDs.getAll(function (response) {
                        response.forEach(function (geofence) {
                            if (geofence.name != "Bangalore") {
                                vm.userGeofences.push(geofence);
                                if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                    vm.canFilter = true;
                                }
                            }
                        });
                    });
                } else {
                    UserGeofences.getAll(function (response) {
                        vm.userGeofenceList = response;
                        response.forEach(function (geofence) {
                            if (geofence.name != "Bangalore") {
                                vm.userGeofences.push(geofence);
                                if (vm.selectedGeofenceId == null) {
                                    vm.selectedGeofenceId = geofence.id;
                                    vm.canFilter = true;
                                }
                            }
                        });
                    });
                }
            });
            if (vm.asset.id) {
                vm.nameImages = [];
                vm.asset.assetImages.forEach(function (item) {
                    vm.nameImages.push(item);
                });
            }
        }

        $scope.newTabDisplay = function (id, name, str) {
            var request = new XMLHttpRequest(), apiImage = name == 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";

            request.open(
                "GET",
                apiImage + vm.asset.id + "/" + id,
                true
            );

            request.setRequestHeader(
                "Authorization",
                "Bearer " + $localStorage.authenticationToken
            );
            request.responseType = "blob";
            request.onload = response;

            function response(e) {


                /* if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    window.open(imageUrl, "_blank");
                } */

                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;


                    if (str == "MP4") {
                        var videoUrl = urlCreator.createObjectURL(this.response);

                        var video = document.createElement('video');
                        video.src = videoUrl;
                        video.controls = true;
                        video.autoplay = true;

                        var videoWindow = window.open("", "_blank");
                        videoWindow.document.body.appendChild(video);
                    } else {
                        var imageUrl = urlCreator.createObjectURL(this.response);
                        window.open(imageUrl, "_blank");
                    }

                }

            }
            request.send();
        };

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function filterParentAssets() {
            // if (vm.asset.user.length > 2 && vm.asset.user != null && vm.asset.user != "" && vm.asset.user != "." && !angular.isUndefined(vm.asset.user)) {
            if (vm.selectedParent.length > 1) {
                AssetGroupSearch.query(
                    {
                        search: vm.selectedParent,
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    vm.parentAssets = data;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }
            // }
        }

        Configs.get("Phases", function (response) {
            vm.phases = response;
            /*  response.forEach(function (item){
                 if(!vm.asset.phase){
                     item.ticked = (item.configKey == "ROLLOUT") ? true : false
                      
                 }else{
                     item.ticked = (vm.asset.phase == item.configKey) ? true : false
                 }

                 if(vm.roleRolloutAdmin){
                     item.roleRolloutAdmin = false
                 }else {
                     item.roleRolloutAdmin = true
                 }
             }) */
        });

        function getGroupAsset(pageNum, mapAssetLists, selectedAssets) {
            GroupAssets.query(
                {
                    page: pageNum,
                    size: 500,
                },
                onSuccess,
                onError
            );

            function onSuccess(data, headers) {
                vm.multiassets = mapAssetLists;
                data.forEach(function (asset) {
                    if (selectedAssets.indexOf(asset.id) !== -1) {
                        vm.multiassets.push({
                            lat:
                                asset.assetCoordinates[
                                    asset.assetCoordinates.length - 1
                                ].latitude,
                            lng:
                                asset.assetCoordinates[
                                    asset.assetCoordinates.length - 1
                                ].longitude,
                            name: asset.name,
                            layout: asset.assetType.layout,
                            assetType: asset.assetTypeName,
                            assetCoordinates: asset.assetCoordinates,
                            id: asset.id,
                            ownedBy: asset.ownedBy,
                            ticked: true,
                        });
                    } else {
                        try {
                            vm.multiassets.push({
                                lat:
                                    asset.assetCoordinates[
                                        asset.assetCoordinates.length - 1
                                    ].latitude,
                                lng:
                                    asset.assetCoordinates[
                                        asset.assetCoordinates.length - 1
                                    ].longitude,
                                name: asset.name,
                                assetType: asset.assetTypeName,
                                layout: asset.assetType.layout,
                                assetCoordinates: asset.assetCoordinates,
                                id: asset.id,
                                ownedBy: asset.ownedBy,
                                ticked: false,
                            });
                        } catch (e) {
                            // TODO: handle exception
                        }
                    }
                });
                if (vm.assetTotalPage == 0) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.assetTotalPage = Math.ceil(vm.totalItems / 500);
                }

                vm.assetCurrentPage = pageNum;

                if (vm.assetTotalPage > 1) {
                    if (vm.assetCurrentPage != vm.assetTotalPage) {
                        //                        getGroupAsset(pageNum + 1, vm.multiassets, selectedAssets);
                    } else {
                        var lastAsset =
                            vm.multiassets[vm.multiassets.length - 1];
                        if (lastAsset.assetCoordinates.length > 0) {
                            var latestLatLng = {
                                lat: lastAsset.assetCoordinates[0].latitude,
                                lng: lastAsset.assetCoordinates[0].longitude,
                            };
                            map.setCenter(latestLatLng);
                        }
                    }
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function upload() {
            formData = new FormData();

            formData.append("assettype", vm.importassettype.name);
            formData.append("file", $scope.myFile);

            AssetUpload.assetupload(formData, function (response, headers) {
                if (response.status == 200) {
                    vm.error = null;
                    vm.success = "OK";
                    $scope.spreadassetname = "";

                    $timeout(function () {
                        vm.success = "";
                    }, 4000);
                }
                if (response.status == 400) {
                    vm.success = null;
                    vm.error = "error";
                }
            });
        }

        $(":file").filestyle({
            buttonBefore: true,
        });
        // $(":file").filestyle('placeholder', 'Choose File');
        $(":file").filestyle("buttonText", "Browse File");

        //		$scope.importxlsx = /^(.*?)\.(xlsx)$/;
        $scope.importxlsx = /^(.*?)\.(xlsx|kml)$/;

        /* import end */
        vm.createNewFence = function () {
            newFence = true;
            vm.asset.assetCoordinates = [];
            vm.createfence();
        };

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        $("#assetImages").change(function () {
            $scope.allimages = false; // to close preview table
            var allowedTypes = {
                "image/png": true,
                "image/jpg": true,
                "image/jpeg": true,
                "video/mp4": true
            };

            uploadFiles("assetImages", allowedTypes);
        });

        $("#assetAttachment").change(function () {
            var allowedTypes = {
                "application/pdf": true,
            };

            uploadFiles("assetAttachment", allowedTypes);
        });

        function uploadFiles(id, allowedTypes, fileReference, referenceId) {
            if (id == "reference") {
                filesSelected = fileReference;
            } else if (id != "reference") {
                var filesSelected = document.getElementById(id).files;
            } //vm.attributeImage = [] 1039
            for (var i = 0; i < filesSelected.length; i++) {
                if (
                    allowedTypes[filesSelected[i].type] &&
                    filesSelected[i].size <= maxSize
                ) {
                    if (id != "reference") {
                        var fileReader = new FileReader();
                        fileReader.onload = function (fileLoadedEvent) {
                            vm.asset.assetImages.push({
                                image: window.btoa(
                                    fileLoadedEvent.target.result
                                ),
                                imageName: fileLoadedEvent.target.name,
                                imageType: fileLoadedEvent.target.type,
                            });
                        };
                        fileReader.name = filesSelected[i].name.split(".")[0];
                        fileReader.type = filesSelected[i].type
                            .split("/")[1]
                            .toUpperCase();

                        if (allowedTypes[filesSelected[i].type] == "video/mp4") {
                            fileReader.readAsDataURL(filesSelected[i]);
                        } else {
                            fileReader.readAsBinaryString(filesSelected[i]);
                        }
                    } else if (id == "reference") {
                        vm.assetRefAttributes.forEach(function (val) {
                            if (val.id == referenceId) {
                                var fileReader_reference = new FileReader();
                                fileReader_reference.onload = function (
                                    fileLoadedEvent
                                ) {
                                    val.attributeValue = window.btoa(
                                        fileLoadedEvent.target.result
                                    );
                                    val.attributeName = fileLoadedEvent.target.name;
                                    val.attributeType = fileLoadedEvent.target.type;
                                };
                                fileReader_reference.name = filesSelected[i].name.split(".")[0];
                                fileReader_reference.type = filesSelected[i].type
                                    .split("/")[1]
                                    .toUpperCase();
                                fileReader_reference.readAsBinaryString(
                                    filesSelected[i]
                                );
                            }
                        });
                    }

                    if (
                        vm.fileWarning ||
                        vm.imageWarning ||
                        vm.referenceWarning
                    ) {
                        boolWarning(id, false);
                    }
                } else {
                    boolWarning(id, true);
                }
            }
        }

        function boolWarning(id, bool) {
            switch (id) {
                case "assetAttachment":
                    vm.fileWarning = bool;
                    break;
                case "assetImages":
                    vm.imageWarning = bool;
                    break;
                case "referenceImages":
                    vm.referenceWarning = bool;
                    break;
            }
            $scope.$apply();
        }

        $scope.deleteDisplayImage = function (id) {
            vm.asset.assetImages.splice(id, 1);
            $(":file").filestyle("clear");
        };

        $scope.toggle = function (id) {
            switch (id) {
                case "images":
                    $scope.allimages = !$scope.allimages;
                    break;

                case "pdf":
                    vm.showAttachments = !vm.showAttachments;
                    vm.showPdf = !vm.showPdf;
                    break;

                case "existingImg":
                    vm.showExistingImage = !vm.showExistingImage;
                    vm.showImg = !vm.showImg;
                    break;

                default:
                    console.log("");
            }
            /* //$("#soundtrack").get(0).play();
            
            if ($scope.allimages) {
                AssetImages.query(
                    {
                        assetId: vm.asset.id,
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    vm.assetImages = data;
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }*/
        };

        function save() {
            if (vm.asset.assetCoordinates.length > 0) {
                vm.asset.ownedBy = [];
                var parentLat = 0.0;
                var parentLng = 0.0;
                if (vm.parentAssets != null) {
                    vm.parentAssets.forEach(function (value) {
                        if (value.name == vm.selectedParent) {
                            var tempAsset = {};
                            tempAsset.id = value.id;
                            tempAsset.name = value.name;
                            parentLat =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            parentLng =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                            vm.asset.ownedBy.push(tempAsset);
                        }
                    });
                }
                //vm.isSaving = true;
                var fiberDistance = 0.0;
                if (vm.asset.assetType.layout == "SPREAD") {
                    var spreadCoordinates = vm.asset.assetCoordinates;
                    if (spreadCoordinates.length > 0) {
                        for (var index in spreadCoordinates) {
                            if (index > 0) {
                                fiberDistance += distanceCal(
                                    spreadCoordinates[index].latitude,
                                    spreadCoordinates[index].longitude,
                                    spreadCoordinates[index - 1].latitude,
                                    spreadCoordinates[index - 1].longitude
                                );
                            }
                        }
                    }
                    // vm.asset.trakeyeGeometry = {
                    //     type: "MultiLineString",
                    //     coordinates: [[
                    //         []
                    //     ]]
                    // }
                    fiberDistance = fiberDistance.toFixed(2);
                    var spreadAV = vm.asset.assetTypeAttributeValues;
                    for (
                        var spreadAssetIndex = 0;
                        spreadAssetIndex < spreadAV.length;
                        spreadAssetIndex++
                    ) {
                        if (
                            spreadAV[spreadAssetIndex].assetTypeAttribute
                                .name === "Fiber Distance (km)"
                        ) {
                            spreadAV[
                                spreadAssetIndex
                            ].attributeValue = fiberDistance;
                        }
                    }
                    vm.asset.assetTypeAttributeValues = spreadAV;
                    // var tempCoordinates = [];
                    // tempCoordinates.push({ latitude: parentLat, longitude: parentLng });
                    // vm.asset.assetCoordinates.forEach(function(value) {
                    //     tempCoordinates.push(value);
                    // });
                    // vm.asset.assetCoordinates = tempCoordinates;
                }

                /* vm.asset.assetTypeAttributeValues.forEach(function (attribute){
                    if(attribute.assetTypeAttribute.attributeDataType.name == 'IMAGE'){
                        attribute.attributeValue =  vm.attributeImage
                    }
                }) 1039 */
                vm.asset.assetReferenceAttributes = [];
                if (vm.assetRefAttributes != null) {
                    for (var i = 0; i < vm.assetRefAttributes.length; i += 3) {
                        var obj = {};

                        obj["assetAttributeName"] = vm.assetRefAttributes[i]
                            ? {
                                assetTypeAttribute: vm.assetRefAttributes[i],
                                attributeValue:
                                    vm.assetRefAttributes[i].attributeValue,
                                order: 0,
                                popupDisplay:
                                    vm.assetRefAttributes[i]
                                        .assetTypePopupDisplay,
                            }
                            : null;

                        obj["assetAttributeValue"] = vm.assetRefAttributes[
                            i + 1
                        ]
                            ? {
                                assetTypeAttribute:
                                    vm.assetRefAttributes[i + 1],
                                attributeValue:
                                    vm.assetRefAttributes[i + 1]
                                        .attributeValue,
                                order: 1,
                                popupDisplay:
                                    vm.assetRefAttributes[i + 1]
                                        .assetTypePopupDisplay,
                            }
                            : null;


                        obj["assetAttributeImage"] = vm.assetRefAttributes[
                            i + 2
                        ]
                            ? {
                                assetTypeAttribute:
                                    vm.assetRefAttributes[i + 2],
                                image:
                                    vm.assetRefAttributes[i + 2]
                                        .attributeValue,
                                imageName: vm.assetRefAttributes[i + 2]
                                    .attributeName,
                                imageType: vm.assetRefAttributes[i + 2]
                                    .attributeType,
                                imageId: vm.assetRefAttributes[i + 2]
                                    .imageId,
                                attributeValue: "images",
                                order: 2,
                                popupDisplay:
                                    vm.assetRefAttributes[i + 2]
                                        .assetTypePopupDisplay,
                            }
                            : null;
                        vm.asset.assetReferenceAttributes.push(obj);
                    }
                }
                vm.assetTypeReferenceAttributesVal = [];
                vm.asset.assetReferenceAttributes.forEach(function (value) {
                    var assetTypeReferenceAttributesValue = value;
                    vm.assetType.assetTypeReferenceAttributes.forEach(function (
                        assettyperef
                    ) {
                        if (
                            value.assetAttributeName.assetTypeAttribute.id ==
                            assettyperef.assetAttributeName.id
                        ) {
                            assetTypeReferenceAttributesValue.assetRfrncAttribOrder =
                                assettyperef.assetTypeRfrncAttribOrder;
                        }
                    });
                    vm.assetTypeReferenceAttributesVal.push(
                        assetTypeReferenceAttributesValue
                    );
                });
                vm.asset.assetReferenceAttributes =
                    vm.assetTypeReferenceAttributesVal;
                vm.asset.uniqueIdentifierCode=""; 
                if (vm.asset.id !== null) {
                    Asset.update(vm.asset, onSaveSuccess, onSaveError);
                } else {
                    Asset.save(vm.asset, onSaveSuccess, onSaveError);
                }
            } else {
                vm.selectAssetCordinates = true;
                // alert("Asset Coordinates should not be empty");
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = true;
            if (vm.asset.groups.length > 0) {
                vm.isSaving = false;
                $scope.$emit("trakeyeApp:assetUpdate", result);
                var pageValue = sessionStorage.getItem("prevPage");
                var previousId = sessionStorage.getItem("prevId");
                var prevEditDetail = sessionStorage.getItem("prevEditId");
                var preEditPage = sessionStorage.getItem("firstEditPage");
                var preEditDetailPage = sessionStorage.getItem(
                    "firstEditDetailPage"
                );

                var assetToassetVar = sessionStorage.getItem(
                    "assetCreateToassetEdit"
                );
                var assetTypeToAssetVar = sessionStorage.getItem(
                    "AssetTypeToEditAsset"
                );
                var groupToAssetVar = sessionStorage.getItem(
                    "groupToEditAsset"
                );

                var groupToEditAssetDetailVar = sessionStorage.getItem(
                    "groupToEditAssetDetail"
                );
                var AssetTypeToEditDetailsVar = sessionStorage.getItem(
                    "AssetTypeToEditDetails"
                );
                var assetCreateToassetEditDetailsVar = sessionStorage.getItem(
                    "assetCreateToassetEditDetails"
                );

                if (pageValue == "geofence.new") {
                    $state.go("geofence.new");
                } else if (pageValue == "asset") {
                    $state.go("asset");
                } else if (previousId) {
                    if (
                        preEditPage == "asset" ||
                        groupToAssetVar == "groupToasset" ||
                        assetTypeToAssetVar == "assetTypeToAsset" ||
                        assetToassetVar == "assetToasset"
                    ) {
                        $state.go("asset", {
                            id: previousId,
                        });
                    } else if (preEditPage == "assetEdit") {
                        sessionStorage.setItem(
                            "assetCreateToassetEdit",
                            "assetToasset"
                        );
                        $state.go("asset.edit", {
                            id: previousId,
                        });
                    }
                } else if (prevEditDetail) {
                    if (
                        preEditDetailPage == "assetDetail" ||
                        groupToEditAssetDetailVar == "groupToassetDetail" ||
                        AssetTypeToEditDetailsVar ==
                        "assetTypeToAssetDetails" ||
                        assetCreateToassetEditDetailsVar ==
                        "assetToassetDetails"
                    ) {
                        $state.go("asset", {
                            id: prevEditDetail,
                        });
                    } else if (preEditDetailPage == "assetEditDetails") {
                        sessionStorage.setItem(
                            "assetCreateToassetEditDetails",
                            "assetToassetDetails"
                        );
                        $state.go("asset-detail.edit", {
                            id: prevEditDetail,
                        });
                    }
                } else {
                    $state.go("asset");
                }
            }
        }

        function onSaveError(result) {
			console.log(result.data.message);
            vm.isSaving = false;	
			AlertService.error(result.data.message);
			setTimeout(function() {
  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    window.scrollTo(0, 0);
  }
}, 100);

        }

        function selectedAssetTypeAttributes() {
            vm.createfence()
            vm.showFilter = true;
            vm.asset.ownedBy = [];
            //vm.referenceAttribute = [];
            if (vm.parentAssets != null) {
                vm.parentAssets.forEach(function (value) {
                    if (value.name == vm.selectedParent) {
                        var tempAsset = {};
                        tempAsset.id = value.id;
                        tempAsset.lat = value.assetCoordinates[0].latitude;
                        tempAsset.lng = value.assetCoordinates[0].longitude;
                        vm.asset.ownedBy.push(tempAsset);
                    }
                });
            }
            if (vm.assetType) {
                if (vm.assetType.assetTypeReferenceAttributes.length) {
                    vm.assetRefAttributes = [];
                    vm.assetType.assetTypeReferenceAttributes.forEach(function (
                        get
                    ) {
                        get["assetAttributeName"].attributeValue =
                            get["assetAttributeName"].defaultValue;
                        vm.assetRefAttributes.push(get["assetAttributeName"]);
                        get["assetAttributeValue"].attributeValue =
                            get["assetAttributeValue"].defaultValue;
                        vm.assetRefAttributes.push(get["assetAttributeValue"]);
                        vm.assetRefAttributes.push(get["assetAttributeImage"]);
                    });
                }
                if (vm.asset.ownedBy != "") {
                    for (var i = 0; i < vm.multiassets.length; i++) {
                        if (vm.multiassets[i].id == vm.asset.ownedBy[0].id) {
                            if (vm.multiassets[i].layout == "FIXED") {
                                vm.fixedArray = [];
                                var coordinates = {};
                                coordinates.latitude =
                                    vm.multiassets[
                                        i
                                    ].assetCoordinates[0].latitude;
                                coordinates.longitude =
                                    vm.multiassets[
                                        i
                                    ].assetCoordinates[0].longitude;
                                vm.fixedArray.push(coordinates);
                                vm.asset.assetCoordinates = vm.fixedArray;
                                vm.parentLatLng.push({
                                    latitude:
                                        vm.multiassets[i].assetCoordinates[0]
                                            .latitude,
                                    longitude:
                                        vm.multiassets[i].assetCoordinates[0]
                                            .longitude,
                                });
                            }
                        }
                    }
                }

                vm.asset.assetType = vm.assetType;
                // if (vm.asset.assetType.layout == "FIXED") {
                //     vm.asset.trakeyeGeometry = {
                //         type: "Point",
                //         coordinates: [[]]
                //     };
                // }
                if (
                    entity_old.assetType &&
                    vm.assetType.id === entity_old.assetType.id
                ) {
                    vm.asset.assetTypeAttributeValues = [];
                    vm.asset.assetTypeAttributeValues =
                        entity_old.assetTypeAttributeValues;
                } else {
                    vm.asset.assetTypeAttributeValues = [];
                    $.each(
                        vm.assetType.assetTypeAttributes,
                        function (key, value) {
                            vm.asset.assetTypeAttributeValues.push({
                                assetTypeAttribute:
                                    vm.assetType.assetTypeAttributes[key],
                            });
                        }
                    );
                    /* vm.asset.assetReferenceAttributes = [];
                    $.each(
                        vm.assetType.assetTypeReferenceAttributes,
                        function (key, value) {
                            vm.asset.assetReferenceAttributes.push([
                                vm.assetType.assetTypeReferenceAttributes[key]
                            ]);
                        }
                    );
                    var referenceAttribute = [];
                    vm.assetType.assetTypeReferenceAttributes.forEach(function(value){
                        var attrName = {};
                        attrName["assetTypeAttribute"] = value.assetAttributeName;
                        attrName["attributeValue"] = value.assetAttributeName.defaultValue;
                        attrName["order"] = value.assetAttributeName.assetTypeAttribOrder;
                        attrName["popupDisplay"] = value.assetAttributeName.assetTypePopupDisplay;
                        var attrValue = {};
                        attrValue["assetTypeAttribute"] = value.assetAttributeValue;
                        attrValue["attributeValue"] = value.assetAttributeValue.defaultValue;
                        attrValue["order"] = value.assetAttributeValue.assetTypeAttribOrder;
                        attrValue["popupDisplay"] = value.assetAttributeValue.assetTypePopupDisplay;
                        referenceAttribute.push({
                            assetAttributeName: attrName,
                            assetAttributeValue: attrValue
                        });
                    });
                    vm.asset.assetReferenceAttributes = referenceAttribute; */
                }
            }
        }
        vm.createfence = function () {
            var elem = document.getElementById("map_canvas");
            vm.asset.ownedBy = [];
            if (vm.parentAssets != null) {
                vm.parentAssets.forEach(function (value) {
                    if (value.name == vm.selectedParent) {
                        var tempAsset = {};
                        tempAsset.id = value.id;
                        tempAsset.lat = value.assetCoordinates[0].latitude;
                        tempAsset.lng = value.assetCoordinates[0].longitude;
                        vm.asset.ownedBy.push(tempAsset);
                    }
                });
            }
            /* if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                //Firefox
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                //Chrome, Safari & Opera
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                //IE/Edge
                elem.msRequestFullscreen();
            } */

            if (vm.asset.ownedBy == "") {
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    {
                        center: {
                            lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                            lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                        },
                        zoom: 13,
                        fullscreenControl: true,
                        styles: mapStyles(),
                    }
                );
                geoLocation(locations.map);
            } else {
                var coordinates = [];
                if (vm.asset.ownedBy.length > 0) {
                    coordinates.push({
                        lat: vm.asset.ownedBy[0].lat,
                        lng: vm.asset.ownedBy[0].lng,
                    });
                }
                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    {
                        center: coordinates[0],
                        zoom: 13,
                        fullscreenControl: true,
                        styles: mapStyles(),
                    }
                );
                geoLocation(locations.map);
            }

            if (vm.assetType.layout == "SPREAD") {
                setGeofences();
                drawingManagerSpread();
                drawingManagerValue("polylinecomplete", locations.map);
            } else if (vm.assetType.layout == "FIXED") {
                setGeofences();
                drawingManagerFixed();
                drawingManagerValue("click", locations.map);
            }

            if (entity.id && entity.id != null && !newFence) {
                if (vm.assetType.layout == "SPREAD") {
                    drawPolyline(function (polyline) {
                        polyline.setMap(locations.map);
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(polyline);
                            }
                        );
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(polyline);
                            }
                        );

                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                    });
                } else if (vm.assetType.layout == "FIXED") {
                    if (vm.asset.assetCoordinates.length > 1) {
                        drawPolyline(function (polyline) {
                            polyline.setMap(locations.map);
                            google.maps.event.addListener(
                                polyline.getPath(),
                                "insert_at",
                                function () {
                                    setGoefenceCoordinate(polyline);
                                }
                            );
                            google.maps.event.addListener(
                                polyline.getPath(),
                                "set_at",
                                function (path) {
                                    setGoefenceCoordinate(polyline);
                                }
                            );

                            vm.drawingManager.setOptions({
                                drawingControl: false,
                            });
                            vm.drawingManager.setMap(null);
                        });
                    } else {
                        var latitudelongitude = {
                            latitude: vm.asset.assetCoordinates[0].latitude,
                            longitude: vm.asset.assetCoordinates[0].longitude,
                        };

                        setValues();
                        drawingManagerFixed();
                        drawMarker(locations.map, vm.coOrdinate);
                        // drawFixedAssetImages(vm.coOrdinate);
                    }
                }
                vm.mapAssets = []
                getGroupAssetsFromES(vm.asset.geofences[0].id, null, vm.mapAssets);

            }

            function drawPolyline(callback) {
                setValues();
                JSON.parse(vm.coOrdinate).forEach(function (value, key) {
                    centerlatlng = {
                        lat: value.lat,
                        lng: value.lng,
                    };
                });
                callback(
                    new google.maps.Polyline({
                        path: JSON.parse(vm.coOrdinate),
                        geodesic: true,
                        strokeColor: vm.asset.assetType.colorcode,
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: vm.asset.assetType.colorcode,
                        fillOpacity: 0.3,
                        editable: true,
                    })
                );
                locations.map.setCenter(centerlatlng);
            }

            spreadAssets = [];
            var multiAssetList = vm.multiassets;
            var latlngs = [];
            for (var i = 0; i < multiAssetList.length; i++) {
                var assetCoordinateValues = multiAssetList[i].assetCoordinates;
                if (assetCoordinateValues.length == 1) {
                    latlngs.push({
                        lat:
                            assetCoordinateValues[
                                assetCoordinateValues.length - 1
                            ].latitude,
                        lng:
                            assetCoordinateValues[
                                assetCoordinateValues.length - 1
                            ].longitude,
                        name: multiAssetList[i].name,
                        assetType: multiAssetList[i].assetType,
                    });
                }
                drawPolylineForGeneratedLoc(
                    assetCoordinateValues,
                    map,
                    "yellow"
                );
            }

            for (var i = 0; i < vm.multiassetsLink.length; i++) {
                var assetCoordinateValues =
                    vm.multiassetsLink[i].assetCoordinates;
                drawPolylineForGeneratedLoc(
                    assetCoordinateValues,
                    map,
                    "yellow"
                );
            }

            for (var i = 0; i < latlngs.length; i++) {
                var myLatLng = { lat: latlngs[i].lat, lng: latlngs[i].lng };
                if (
                    latlngs[i].assetType != "WDM" &&
                    latlngs[i].assetType != "Router" &&
                    latlngs[i].assetType != "NTTN" &&
                    latlngs[i].assetType != "Others" &&
                    latlngs[i].assetType != "BackToBack"
                ) {
                    createMarkerOfAllAssets(myLatLng, map, latlngs[i].name);
                }
            }

            for (var i = 0; i < multiAssetList.length; i++) {
                var array_element = multiAssetList[i];
                if (array_element.layout == "SPREAD") {
                    spreadAssets.push(array_element);
                }
            }
            for (var i = 0; i < spreadAssets.length; i++) {
                var spreadAssetAC = spreadAssets[i].assetCoordinates;
                for (var j = 0; j < spreadAssetAC.length; j++) {
                    if (j > 0) {
                        var locValues = [];
                        locValues.push(spreadAssetAC[j - 1]);
                        locValues.push(spreadAssetAC[j]);
                        drawPolylineForGeneratedLoc(locValues, map, "black");
                    }
                }
            }
        };

        function navigateCreateAsset() {
            var previousId = sessionStorage.getItem("prevId");
            var editDetailValue = sessionStorage.getItem("prevEditId");
            sessionStorage.setItem("firstEditPage", "assetEdit");
            sessionStorage.setItem("firstEditDetailPage", "assetEditDetails");
            if (previousId) {
                $state.go("asset.new", {
                    id: previousId,
                });
            }
            if (editDetailValue) {
                $state.go("asset.new", {
                    id: editDetailValue,
                });
            }
        }

        function navigateCreateGroup() {
            sessionStorage.setItem("createGroup", "createAssetToCreateGroup");
            $state.go("group.new", {});
            // var previousId = sessionStorage.getItem("prevId");
            // var editDetailValue = sessionStorage.getItem("prevEditId");
            // console.log('previousId', previousId);
            // console.log('editDetailValue', editDetailValue);
            // if (previousId) {
            //     $state.go("group.new", {
            //         id: previousId
            //     });
            // } else if (editDetailValue) {
            //     $state.go("group.new", {
            //         id: editDetailValue
            //     });
            // }
        }

        function navigateAssetType() {
            sessionStorage.setItem(
                "createAssetType",
                "createAssetToCreateAssetType"
            );
            $state.go("asset-type.new", {});
            // var pageValue = sessionStorage.getItem("prevId");
            // var editDetailValue = sessionStorage.getItem("prevEditId");
            // if (pageValue) {
            //     $state.go("asset-type.new", {
            //         id: pageValue
            //     });
            // } else if (editDetailValue) {
            //     $state.go("asset-type.new", {
            //         id: editDetailValue
            //     });
            // }
        }

        function createMarkerOfAllAssets(myLatLng, map, myLocName, index) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: {
                    scaledSize: new google.maps.Size(24, 24),
                    origin: new google.maps.Point(0, 0),
                    url: "content/images/yellow.png",
                    anchor: new google.maps.Point(16, 16),
                },
                //                label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: myLocName, backgroundcolor: "#ff9800" },
            });
        }

        function setGeofences() {
            var isUserAdmin = false;
            vm.userAdmin.authorities.forEach(function (val) {
                if (val == "ROLE_USER_ADMIN") {
                    isUserAdmin = true;
                }
                if (val == "ROLE_HOD") {
                    isUserAdmin = true;
                }
            });
            if (isUserAdmin) {
                // Geofence.query({
                //     page: 0,
                //     size: 500,
                // }, onSuccess, onError);

                // function onSuccess(data, headers) {
                //     vm.selectedGeofence = [];
                //     data.forEach(function (value) {
                //         if (value.zone) {
                //             value.type = "MASTER";
                //         } else {
                //             value.type = "MINI";
                //         }
                //         vm.selectedGeofence.push(value);
                //     });
                //     drawLatestGeofence(vm.selectedGeofence);
                // }

                // function onError(error) {
                //     // AlertService.error(error.data.message);
                // }

                GeofenceIDs.getAll(function (response) {
                    vm.selectedGeofence = [];
                    response.forEach(function (value) {
                        if (value.zone) {
                            value.type = "MASTER";
                        } else {
                            value.type = "MINI";
                        }
                        vm.selectedGeofence.push(value);
                    });
                    drawLatestGeofence(vm.selectedGeofence);
                });
            } else {
                drawLatestGeofence(vm.userGeofenceList);
            }
        }

        function drawLatestGeofence(response) {
            if (response) {
                initializeGeofenceMap(response, function (latlang) {
                    locations.latlng = latlang;
                    // function() {
                    $.each(response, function (index, value) {
                        try {
                            if (
                                value.type != "MASTER" &&
                                value.coordinates != undefined
                            ) {
                                var path = JSON.parse(value.coordinates);
                                // drawPolylineForGeoFence(path, locations.map, value.name);
                                var infowindow = new google.maps.InfoWindow({
                                    content:
                                        '<div class="infoWindowhead">' +
                                        "name" +
                                        '<div class="infoWindowContent"> <b>Description :</b> ' +
                                        "des" +
                                        "</div></div>",
                                });

                                infowindow.setPosition(latlang);
                                var tempGeofences = new google.maps.Polyline({
                                    path: path,
                                    geodesic: true,
                                    strokeColor: "#ff0000",
                                    strokeOpacity: 0.5,
                                    strokeWeight: 3,
                                });
                                google.maps.event.addListener(
                                    tempGeofences,
                                    "mouseout",
                                    function (event) {
                                        infowindow.close();
                                    }
                                );

                                google.maps.event.addListener(
                                    tempGeofences,
                                    "click",
                                    function (event) {
                                        if (openedInfoWindow != null) {
                                            openedInfoWindow.close();
                                        }
                                        infowindow.setContent(
                                            '<div class="infoWindowhead">' +
                                            "<b>Geofence Name : </b><br><br>" +
                                            value.name +
                                            "</br></div>"
                                        );

                                        infowindow.mousemove;
                                        infowindow.open(locations.map);
                                        infowindow.setPosition(event.latLng);
                                        openedInfoWindow = infowindow;
                                    }
                                );
                                tempGeofences.setMap(locations.map);
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    });
                });
            }
        }

        function initializeGeofenceMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                latlng = new google.maps.LatLng(
                    latlangs[0].pinLat,
                    latlangs[0].pinLong
                );
                callback(latlng);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            callback(
                                new google.maps.LatLng("5.431587", "101.128162")
                            );
                        }
                    );
                } else {
                    callback(new google.maps.LatLng("5.431587", "101.128162"));
                }
            }
        }

        function drawingManagerSpread() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYLINE,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["polyline"],
                },
                polylineOptions: {
                    fillColor: "#ffff00",
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: true,

                    editable: true,
                    zIndex: 1,
                    geodesic: true,
                },
            });
        }

        function drawingManagerFixed() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.MARKER,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["marker"],
                },
                markerOptions: {
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        // url : "data:image/png;base64," +
                        // vm.asset.assetType.image,
                        // url : vm.asset.assetType.imagePath,
                        anchor: new google.maps.Point(16, 16),
                    },
                },
            });
        }

        var recursiveOwnedByAsset = function (ownedBy) {
            var names = [];
            if (ownedBy.length > 0) {
                if (ownedBy[0].ownedBy != null) {
                    if (ownedBy[0].ownedBy.length > 0) {
                        var assetCoordinateValues2 = ownedBy[0].ownedBy;
                        names.push({
                            lat:
                                assetCoordinateValues2[0].assetCoordinates[0]
                                    .latitude,
                            lng:
                                assetCoordinateValues2[0].assetCoordinates[0]
                                    .longitude,
                        });
                        if (assetCoordinateValues2.length > 0) {
                            Array.prototype.push.apply(
                                names,
                                recursiveOwnedByAsset(assetCoordinateValues2)
                            );
                        }
                    }
                }
            }
            return names;
        };

        function drawPolylineForGeneratedLoc(latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];
            $.each(latlngsToDraw, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var midLatLng = {
                    lat:
                        spreadAssetCoordinates[
                            spreadAssetCoordinates.length - 1
                        ].lat,
                    lng:
                        spreadAssetCoordinates[
                            spreadAssetCoordinates.length - 1
                        ].lng,
                };
                var infowindow = new google.maps.InfoWindow({
                    content:
                        '<div class="infoWindowhead">' +
                        "name" +
                        '<div class="infoWindowContent"> <b>Description :</b> ' +
                        "des" +
                        "</div></div>",
                });
                infowindow.setPosition(midLatLng);

                var ColorValue = "#ff0000";
                if (color == "red") {
                    ColorValue = "#ff0000";
                } else if (color == "black") {
                    ColorValue = "#000000";
                } else if (color == "yellow") {
                    ColorValue = "#F4A500";
                } else {
                    ColorValue = "#208000";
                }
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue,
                });

                polylinepath.setMap(map);
            }
        }

        function drawingManagerValue(option, map) {
            var parent = {};
            // for (var i = 0; i < vm.multiassets.length; i++) {
            //     if (vm.multiassets[i].ticked == true) {
            //         parent = vm.multiassets[i];
            //     }
            // }
            if (vm.parentAssets && vm.parentAssets.length > 0) {
                for (var i = 0; i < vm.parentAssets.length; i++) {
                    if (vm.parentAssets[i].status == true) {
                        parent = vm.parentAssets[i];
                    }
                }
            }
            if (parent.id != null) {
                AssetByID.get(parent.id, function (response) {
                    parent = response;
                    var latlngs = [];
                    try {
                        var len = parent.ownedBy;
                        var assetCoordinateValuesParent =
                            parent.assetCoordinates;
                        latlngs.push({
                            lat:
                                assetCoordinateValuesParent[
                                    assetCoordinateValuesParent.length - 1
                                ].latitude,
                            lng:
                                assetCoordinateValuesParent[
                                    assetCoordinateValuesParent.length - 1
                                ].longitude,
                        });

                        if (len.length > 0) {
                            var assetCoordinateValues = len[0].assetCoordinates;
                            latlngs.push({
                                lat:
                                    assetCoordinateValues[
                                        assetCoordinateValues.length - 1
                                    ].latitude,
                                lng:
                                    assetCoordinateValues[
                                        assetCoordinateValues.length - 1
                                    ].longitude,
                            });

                            if (recursiveOwnedByAsset(len) != null) {
                                Array.prototype.push.apply(
                                    latlngs,
                                    recursiveOwnedByAsset(len)
                                );
                            }
                        }

                        for (var i = 0; i < latlngs.length; i++) {
                            createMarker(latlngs[i], map, i);
                        }

                        if (latlngs.length > 0) {
                            moveToLocation(latlngs[0].lat, latlngs[0].lng, map);
                            map.setZoom(16);
                        }
                    } catch (err) {
                        var event232 = err;
                    }
                });
            }

            if (option == "polylinecomplete") {
                vm.selectAssetCordinates = false;
                google.maps.event.addListener(
                    vm.drawingManager,
                    option,
                    function (event) {
                        google.maps.event.addListener(
                            event.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(event);
                            }
                        );
                        google.maps.event.addListener(
                            event.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(event);
                            }
                        );
                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                        setGoefenceCoordinate(event);
                    }
                );
                var assetCoorVal = [];

                vm.parentLatLng.forEach(function (value) {
                    assetCoorVal.push(value);
                });
                vm.asset.assetCoordinates.forEach(function (assetlatlng) {
                    assetCoorVal.push(assetlatlng);
                });
                vm.asset.assetCoordinates = assetCoorVal;
                vm.drawingManager.setMap(map);
            } else if (option == "click") {
                vm.selectAssetCordinates = false;
                google.maps.event.addListener(map, "click", function (e) {
                    placeMarker(e.latLng, map);
                    vm.fixedArray = [];
                    var coordinates = {};
                    coordinates.latitude = e.latLng.lat();
                    coordinates.longitude = e.latLng.lng();
                    vm.fixedArray.push(coordinates);
                    vm.asset.assetCoordinates = vm.fixedArray;
                });
            }
        }

        function moveToLocation(lat, lng, map) {
            var center = new google.maps.LatLng(lat, lng);
            // using global variable:
            map.panTo(center);
        }

        function createMarker(myLatLng, map, index) {
            if (index == 0) {
                var marker = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon:
                        "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                    animation: google.maps.Animation.DROP,
                });
            } else {
                var marker = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon:
                        "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
                });
            }
        }

        var marker;

        function placeMarker(location, map) {
            if (marker) {
                marker.setPosition(location);
            } else {
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        // url : "data:image/png;base64," +
                        // vm.asset.assetType.image,
                        // url : vm.asset.assetType.imagePath,
                        anchor: new google.maps.Point(16, 16),
                    },
                });
            }
        }
        $scope.mapEvents = {
            click: function () { },
        };

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                Math.cos(degrees_to_radians(lat2)) *
                Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

        function setGoefenceCoordinate(event) {
            vm.assetCoordinateValues = [];
            vm.asset.assetCoordinates = [];

            var radius = event.getPath();
            for (var i = 0; i < radius.getLength(); i++) {
                var coordinates = {};
                coordinates.latitude = radius.getAt(i).lat();
                coordinates.longitude = radius.getAt(i).lng();
                vm.asset.assetCoordinates.push(coordinates);
            }
        }

        function setValues() {
            vm.coOrdinates = [];
            for (var i = 0; i < vm.asset.assetCoordinates.length; i++) {
                vm.coOrdinates.push({
                    lat: vm.asset.assetCoordinates[i].latitude,
                    lng: vm.asset.assetCoordinates[i].longitude,
                });
                if (i == vm.asset.assetCoordinates.length - 1) {
                    vm.coOrdinate = JSON.stringify(vm.coOrdinates);
                }
            }
        }

        function drawMarker(map, response) {
            $.each(JSON.parse(response), function (index, value) {
                centerlatlng = {
                    lat: value.lat,
                    lng: value.lng,
                };

                //edit asset marker
                var startMarker = new google.maps.Marker({
                    map: map,
                    position: new google.maps.LatLng(value.lat, value.lng),

                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        // url : "data:image/png;base64," +
                        // vm.asset.assetType.image,
                        // url : vm.asset.assetType.imagePath,
                        anchor: new google.maps.Point(16, 16),
                    },
                });
            });
            map.setCenter(centerlatlng);
        }

        function filterAssetsOnMapView() {
            $("#mapFilterModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none";
            vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
        }

        function closeMapFilterModal() {
            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
        }

        function saveFilter() {
            vm.mapAssets = [];

            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 16,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                var elem = document.getElementById("map_canvas");
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    /* Firefox */
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) {
                    /* Chrome, Safari & Opera */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) {
                    /* IE/Edge */
                    elem.msRequestFullscreen();
                }

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(16, locations.latlng)
                );
                geoLocation(locations.map);

                getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
                vm.prevSelectedGeofenceId = vm.selectedGeofenceId;

                if (vm.assetType.layout == "SPREAD") {
                    setGeofences();
                    drawingManagerSpread();
                    drawingManagerValue("polylinecomplete", locations.map);
                } else if (vm.assetType.layout == "FIXED") {
                    setGeofences();
                    drawingManagerFixed();
                    drawingManagerValue("click", locations.map);
                }

                $("#mapFilterModal").removeClass("in");
                $(".modal-backdrop").remove();
                $("#mapFilterModal").hide();
            } else {
                /* var myOptions = {
                    zoom: 16,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(16, locations.latlng)
                );
                geoLocation(locations.map);

                getGroupAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
                vm.prevSelectedGeofenceId = vm.selectedGeofenceId;

                if (vm.assetType.layout == "SPREAD") {
                    setGeofences();
                    drawingManagerSpread();
                    drawingManagerValue("polylinecomplete", locations.map);
                } else if (vm.assetType.layout == "FIXED") {
                    setGeofences();
                    drawingManagerFixed();
                    drawingManagerValue("click", locations.map);
                }

                $("#mapFilterModal").removeClass("in");
                $(".modal-backdrop").remove();
                $("#mapFilterModal").hide();
            }
        }

        function getGroupAssetsFromES(
            geofenceIdVal,
            lastAssetId,
            mapAssetLists
        ) {
            AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;

                data.assets.forEach(function (asset) {

                    if (vm.asset.id != asset.id) {
                        var tmpAsset = {};

                        tmpAsset.assetCoordinates = asset.assetCoordinates;
                        tmpAsset.assetTypeName = asset.assetTypeName;
                        tmpAsset.assetTypeColor = asset.assetColor;
                        tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                        tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                        tmpAsset.id = asset.id;
                        tmpAsset.name = asset.name;

                        vm.mapAssets.push(tmpAsset);
                    }


                });
                drawLatestAssets(vm.mapAssets);
                if (data.lastId != null) {
                    getGroupAssetsFromES(
                        geofenceIdVal,
                        data.lastId,
                        vm.mapAssets
                    );
                } else {
                    if (vm.mapAssets.length > 0) {
                        var assetSelected = vm.mapAssets[0];
                        AssetByID.get(assetSelected.id, function (assetVal) {
                            var assetLatLng = {
                                lat:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                        1
                                    ].latitude,
                                lng:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                        1
                                    ].longitude,
                            };

                            if (!vm.asset.id) {
                                locations.map.setCenter(assetLatLng);
                            }

                        });
                    }
                }
            });
        }

        function drawLatestAssets(response) {
            if (response) {
                initializeAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                        value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    drawFixedAsset(value1, false);
                                } else {
                                    drawFixedAsset(value, false);
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                drawPolyline(value, locations.map);
                            }
                        });
                    });
                });
            }
        }

        function initializeAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            lngVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            // callback(new google.maps.LatLng("12.9716", "77.5946"));
                            callback(
                                new google.maps.LatLng(
                                    $rootScope.DEFAULT_LATITUDE,
                                    $rootScope.DEFAULT_LONGITUDE
                                )
                            );
                        }
                    );
                } else {
                    callback(
                        new google.maps.LatLng(
                            $rootScope.DEFAULT_LATITUDE,
                            $rootScope.DEFAULT_LONGITUDE
                        )
                    );
                }
            }
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 16,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(16, locations.latlng)
                );
                geoLocation(locations.map);

                google.maps.event.addListener(
                    locations.map,
                    "zoom_changed",
                    function () {
                        vm.zoomLevel = locations.map.getZoom();
                        if (
                            (vm.prevZoomLevel == 17 && vm.zoomLevel == 18) ||
                            (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)
                        ) {
                            drawLatestAssets(vm.mapAssets);
                        }
                        vm.prevZoomLevel = vm.zoomLevel;
                    }
                );
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () { };
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById("map_canvas");
            callback();
        }

        function drawPolyline(spread, map) {
            var spreadAssetCoordinates = [];
            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = null;
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spread.assetTypeColor;
                }
                var polylineWeight = 2.5;
                var strokeOpacityVal = 1.0;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var disVal = 0;
                        var cLocations = [];

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }

                                var userContent = document.createElement("div"),
                                    button;

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' +
                                    "<b>Name : </b> " +
                                    spread.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km</br>";

                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });

                                google.maps.event.addDomListener(
                                    button,
                                    "click",
                                    function () {
                                        ChildAssets.query(
                                            {
                                                parentId: spread.id,
                                            },
                                            onSuccess
                                        );

                                        function onSuccess(data, headers) {
                                            if (
                                                spread.assetType.name == "432FR"
                                            ) {
                                                $("#ribbonPathModal").show();
                                                try {
                                                    var assetCoordinateValues =
                                                        spread.assetCoordinates;
                                                    latlngs.push({
                                                        lat:
                                                            assetCoordinateValues[
                                                                assetCoordinateValues.length -
                                                                1
                                                            ].latitude,
                                                        lng:
                                                            assetCoordinateValues[
                                                                assetCoordinateValues.length -
                                                                1
                                                            ].longitude,
                                                    });
                                                } catch (err) {
                                                    var event232 = err;
                                                }
                                                showFiberDetails(
                                                    spread,
                                                    data,
                                                    spread.assetCoordinates[
                                                        spread.assetCoordinates
                                                            .length - 1
                                                    ].latitude,
                                                    spread.assetCoordinates[
                                                        spread.assetCoordinates
                                                            .length - 1
                                                    ].longitude,
                                                    latlngs
                                                );
                                            } else {
                                                $("#cablePathModal").show();
                                                try {
                                                    var assetCoordinateValues =
                                                        spread.assetCoordinates;
                                                    latlngs.push({
                                                        lat:
                                                            assetCoordinateValues[
                                                                assetCoordinateValues.length -
                                                                1
                                                            ].latitude,
                                                        lng:
                                                            assetCoordinateValues[
                                                                assetCoordinateValues.length -
                                                                1
                                                            ].longitude,
                                                    });
                                                } catch (err) {
                                                    var event232 = err;
                                                }
                                                showFiberDetails(
                                                    spread,
                                                    data,
                                                    spread.assetCoordinates[
                                                        spread.assetCoordinates
                                                            .length - 1
                                                    ].latitude,
                                                    spread.assetCoordinates[
                                                        spread.assetCoordinates
                                                            .length - 1
                                                    ].longitude,
                                                    latlngs
                                                );
                                            }
                                        }
                                    }
                                );
                            });
                        }
                        if (infowindow != null) {
                            infowindow.setPosition(event.latLng);
                            infowindow.open(locations.map);
                            openedInfoWindow = infowindow;
                        }
                    }
                );

                var polylinepathDuct = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(locations.map);

                polylines.push(polylinepath);
            }

            if (vm.asset.id && vm.asset.assetCoordinates.length) {
                locations.map.setZoom(16)
                locations.map.setCenter({ lat: vm.asset.assetCoordinates[0].latitude, lng: vm.asset.assetCoordinates[0].longitude })
            }
        }

        function drawFixedAsset(fixed, hasParent) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                    },
                });

                // if (vm.zoomLevel == 10) {
                //     startMarker.setLabel('');
                // } else if (vm.zoomLevel == 11) {
                //     var label = { color: '#000000', fontWeight: 'bold', fontSize: '12px', text: fixed.name };
                //     startMarker.setLabel(label);
                // }

                // if (fixed.status != null &&
                //     fixed.status === false) {
                //     startMarker.setLabel({
                //         color: 'red',
                //         fontSize: '30px',
                //         fontWeight: '20px',
                //         text: '\u2297'
                //     });
                // }
                // Add marker to the array.
                markers.push(startMarker);

                var infoWindow2 = new google.maps.InfoWindow();
                var infoStr = "";
                var otdr = "";

                var userContent = document.createElement("div"),
                    button;

                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    startMarker.title +
                    '</div><div class="infoWindowContent">' +
                    "<b>Lat</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .latitude +
                    "<br><b>Long</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .longitude +
                    "<br>" +
                    infoStr +
                    "</div>";

                google.maps.event.addListener(
                    startMarker,
                    "dblclick",
                    function () {
                        infoWindow2.close();
                    }
                );

                var activeInfoWindow;
                var infoWindow2 = new google.maps.InfoWindow({
                    content: userContent,
                });
                // add listener on InfoWindow for click
                // event
                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function () {
                        AssetByID.get(fixed.id, function (response) {
                            var infoWindow2 = new google.maps.InfoWindow();
                            var infoStr = "";
                            var otdr = "";
                            var assetTypeAttributeValuesList =
                                response.assetTypeAttributeValues;
                            assetTypeAttributeValuesList.sort(function (a, b) {
                                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                    nameB = a.assetTypeAttribute.name.toLowerCase();
                                if (nameA < nameB)
                                    // sort string ascending
                                    return -1;
                                if (nameA > nameB) return 1;
                                return 0; // default return value (no sorting)
                            });
                            for (
                                var i = 0;
                                i < assetTypeAttributeValuesList.length;
                                i++
                            ) {
                                var home = assetTypeAttributeValuesList[i];
                                infoStr +=
                                    "<br><b>" +
                                    home.assetTypeAttribute.name +
                                    "</b> : " +
                                    home.attributeValue;
                                otdr = home;
                            }

                            var userContent = document.createElement("div"),
                                buttonA,
                                buttonB,
                                buttonC,
                                buttonD;
                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                startMarker.title +
                                '</div><div class="infoWindowContent">' +
                                "<b>Lat</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].latitude +
                                "<br><b>Long</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].longitude +
                                "<br>" +
                                infoStr +
                                "</div>";

                            var infoWindow2 = new google.maps.InfoWindow({
                                content: userContent,
                            });
                            if (prevInfoWindow != null) prevInfoWindow.close();
                            infoWindow2.open(locations.map, startMarker);
                            setTimeout(function () {
                                infoWindow2.close();
                            }, 5000);

                            activeInfoWindow = infoWindow2;
                            prevInfoWindow = infoWindow2;
                        });
                    }
                );
                openedInfoWindow = infoWindow2;
            });

            if (vm.asset.id && vm.asset.assetCoordinates.length) {
                locations.map.setZoom(16)
                locations.map.setCenter({ lat: vm.asset.assetCoordinates[0].latitude, lng: vm.asset.assetCoordinates[0].longitude })
            }
        }

		vm.processAssetAttribFile = function (files, index) {			
			
		    if (!files || !files.length) return;
		
		    var attribute = vm.asset.assetTypeAttributeValues[index];
		
		    if (!attribute.assetAttributeImages) {
		        attribute.assetAttributeImages = [];
		    }
		
		    Array.from(files).forEach(function(file) {
		        var reader = new FileReader();
		        reader.onload = function(e) {
		            var base64Data = e.target.result.split(',')[1];
					var ext = "";
			            var parts = file.name.split(".");
			            if (parts.length > 1) {
			                ext = parts[parts.length - 1].toUpperCase(); 
			            } else {
			                ext = "UNKNOWN";
			            }
		            var imageObj = {
		                image: base64Data,
		                imageName: file.name,
		                imageType: ext
		            };
		
		            attribute.assetAttributeImages.push(imageObj);
		
		            if (!vm.$$phase) $scope.$apply();
		        };
		        reader.readAsDataURL(file);
		    });
		};
$scope.showAllImages = function (images, name) {
    if (!images || images.length === 0) {
        alert("No images available for this attribute.");
        return;
    }

    var apiBase = name === 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";
    var imageBlobs = [];
    var loadedCount = 0;

    // Open a new tab immediately
    var imageWindow = window.open("", "_blank");
    imageWindow.document.title = "Attribute Images";
    imageWindow.document.write("<h2 style='font-family:Arial; color:#3c8dbc;'>Attribute Images</h2>");
    imageWindow.document.write("<div id='imageContainer' style='display:flex; flex-wrap:wrap; gap:10px;'></div>");

    images.forEach(function (img) {
        if (!img.imageId) return;

        var request = new XMLHttpRequest();
        request.open('GET', apiBase + vm.asset.id + "/" + img.imageId, true);
        request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
        request.responseType = 'blob';
        
        request.onload = function () {
            loadedCount++;
            if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var blobUrl = urlCreator.createObjectURL(this.response);

                // Append image to the new tab dynamically
                var container = imageWindow.document.getElementById('imageContainer');
                var imgTag = imageWindow.document.createElement('img');
                imgTag.src = blobUrl;
                imgTag.style.maxWidth = "250px";
                imgTag.style.border = "1px solid #ccc";
                imgTag.style.borderRadius = "6px";
                imgTag.style.margin = "5px";
                container.appendChild(imgTag);
            }

            if (loadedCount === images.length) {
                imageWindow.document.write("<p style='font-family:Arial; color:gray;'>All images loaded.</p>");
            }
        };

        request.onerror = function () {
            loadedCount++;
            console.error("Error loading image:", img.imageId);
        };

        request.send();
    });
};


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetDetailController', AssetDetailController);

    AssetDetailController.$inject = ['$scope', '$rootScope', '$stateParams','$state', 'pagingParams', 'ParseLinks', 'paginationConstants','previousState', 'entity', 'Asset', 'User', 'AssetType','$localStorage','Configs','MappedFixedAssets','UserAccount'];

    function AssetDetailController($scope, $rootScope, $stateParams,$state, pagingParams, ParseLinks, paginationConstants,previousState, entity, Asset, User, AssetType,$localStorage,Configs,MappedFixedAssets,UserAccount) {
        var vm = this;

        vm.asset = entity;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        var locations = {};
        vm.isMapVisible = false;

        if(vm.asset.id!=null && vm.asset.assetType.layout=='SPREAD'){
            vm.asset.assetCoordinates.sort(function (a, b) {
                // Sort by sortOrder, placing null or undefined at the end
                if (a.sortOrder == null && b.sortOrder != null) {
                    return 1;
                } else if (a.sortOrder != null && b.sortOrder == null) {
                    return -1;
                } else if (a.sortOrder != null && b.sortOrder != null) {
                    // Both have sortOrder, compare numerically
                    return a.sortOrder - b.sortOrder;
                } else {
                    // Both sortOrder are null, fallback to id comparison
                    return a.id - b.id;
                }
            });
        }
        

        var assetCoor = [];
        vm.asset.assetCoordinates.forEach(function (val) {
            assetCoor.push({
                lat: val.latitude,
                lng: val.longitude,
            });
        });
        locations.map = new google.maps.Map(
            document.getElementById("map_canvas"),
            myOption(
                12,assetCoor[0]
            )
        );
         UserAccount.get(function (data) {
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if(val == "ROLE_READONLY"){
                        vm.has_ROLE_READONLY=true
                    }
                })
         })

        if(vm.asset.assetType.layout=='FIXED'){
            var infowindow = new google.maps.InfoWindow();
            var fixed = vm.asset;
            var iconUrl = "";
            var isFixedAsset = false;
            iconUrl = fixed.assetType.imagePath;
            isFixedAsset = true;

            var iconSize = 8;
            if (vm.zoomLevel == 10) {
                iconSize = 8;
            } else if (vm.zoomLevel == 11) {
                iconSize = 16;
            }

            if (isFixedAsset) {
                iconSize = 24;
            }

            var startMarker = new google.maps.Marker({
                map: locations.map,
                position: assetCoor[0],
                title: fixed.name,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: iconUrl,
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        iconSize / 2
                    ),
                },
            });
            google.maps.event.addListener(
                startMarker,
                "mouseout",
                function (event) {
                    infowindow.close();
                }
            );

            google.maps.event.addListener(
                startMarker,
                "click",
                function (event) {
                    infowindow.setContent(
                        '<div class="infoWindowhead">' +
                        "<b>Asset Name : </b><br><br>" +
                        fixed.name +
                        "</br></div>"
                    );

                    infowindow.mousemove;
                    infowindow.open(locations.map);
                    infowindow.setPosition(event.latLng);
                }
            );
        } else {
            var spreadAsset = new google.maps.Polyline({
                path: assetCoor,
                strokeColor: vm.asset.assetType.colorcode
            });
            spreadAsset.setMap(locations.map);
        }
        

        

        vm.toggleMap = function () {
            vm.isMapVisible = !vm.isMapVisible;
        };
        vm.showImages = function () {
            if (vm.asset && vm.asset.assetImages.length) {
                var token = $localStorage.authenticationToken;
                gpName = vm.asset.name || "Images";
                  var validTypes = ['.PNG', 'PNG', 'PDF', '.PDF', 'JPEG', '.JPEG', 'JPG', '.JPG', 'MP4', '.MP4'];
                var imageMetaList = vm.asset.assetImages.filter(function (img) {
                    var type = img.imageType ? img.imageType.toUpperCase() : '';
                    return validTypes.indexOf(type) !== -1;
                }).sort(function (a, b) {
                    return a.createdDate - b.createdDate;
                }).map(function (img) {
                    return {
                        url: img.imageUrl || ('/api/trakeyeassetimages/' + vm.asset.id + '/' + img.imageId),
                        type: img.imageType ? img.imageType.toUpperCase() : 'PNG',
                        createdDate: img.createdDate
                    };
                });
                if (imageMetaList.length) {
                    preloadImagesWithToken(imageMetaList, token);
                } else {
                    alert("No images or PDFs found.");
                }
            } else {
                alert("No images or PDFs found.");
            }
        }
         var carouselImages = [];
        var currentImageIndex = 0;
        var gpName = 'images';
        function preloadImagesWithToken(imageMetaList, token) {
            var blobUrls = [];
            var remaining = imageMetaList.length;
            var hasError = false;

            for (var i = 0; i < imageMetaList.length; i++) {
                (function (img, index) {
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', img.url, true);
                    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                        if (xhr.status === 200 && xhr.response) {
                            var metaType = img.type ? img.type.toUpperCase() : '';
                            var type = metaType.includes("PDF") ? "PDF" :
                                metaType.includes("MP4") ? "VIDEO" :
                                    "IMAGE";
                            blobUrls[index] = {
                                url: URL.createObjectURL(xhr.response),
                                type: type
                            };
                        } else {
                            hasError = true;
                        }
                        remaining--;
                        if (remaining === 0) {
                            if (hasError) alert("Failed to load one or more files.");
                            var finalBlobUrls = blobUrls.filter(function (item) { return !!item; });
                            openCarousel(finalBlobUrls);
                        }
                    };
                    xhr.onerror = function () {
                        hasError = true;
                        remaining--;
                        if (remaining === 0) {
                            alert("Failed to load one or more files.");
                            var finalBlobUrls = blobUrls.filter(function (item) { return !!item; });
                            openCarousel(finalBlobUrls);
                        }
                    };
                    xhr.send();
                })(imageMetaList[i], i);
            }
        }

        function openCarousel(images) {
            carouselImages = images;
            currentImageIndex = 0;
            document.getElementById("imageCarouselModal").style.display = "flex";
            updateCarouselImage();
            generateThumbnails();
        }

        function updateCarouselImage() {
            var container = document.getElementById("carouselDisplayContainers");
            container.innerHTML = "";
            if (!carouselImages.length || !carouselImages[currentImageIndex]) {
                console.warn("No valid media found at index:", currentImageIndex);
                return;
            }
            var current = carouselImages[currentImageIndex];
            if (current.type === "PDF") {
                var iframe = document.createElement("iframe");
                iframe.src = current.url;
                iframe.className = "carousel-pdf";
                container.appendChild(iframe);
            } else if (current.type === "VIDEO") {
                var video = document.createElement("video");
                video.src = current.url;
                video.controls = true;
                video.autoplay = true;
                video.className = "carousel-video";
                container.appendChild(video);
            } else {
                var img = document.createElement("img");
                img.className = "carousel-image";
                img.src = current.url;
                img.id = "carouselImage";
                img.style.cursor = "grab";
                img.setAttribute("draggable", "false");
                container.appendChild(img);

                // Zoom + Drag behavior
                var zoom = 1;
                var minZoom = 1;
                var maxZoom = 5;
                var imgOffsetX = 0;
                var imgOffsetY = 0;

                function applyTransform() {
                    img.style.transform = 'translate(' + imgOffsetX + 'px, ' + imgOffsetY + 'px) scale(' + zoom + ')';
                    img.style.transition = "transform 0.1s ease-out";
                }

                applyTransform();

                container.addEventListener("wheel", function (e) {
                    e.preventDefault();
                    var delta = Math.sign(e.deltaY);
                    var zoomAmount = 0.10;
                    var newZoom = zoom;

                    if (delta < 0) {
                        newZoom = Math.min(maxZoom, zoom + zoomAmount);
                    } else {
                        newZoom = Math.max(minZoom, zoom - zoomAmount);
                    }

                    var scaleFactor = newZoom / zoom;
                    var rect = img.getBoundingClientRect();
                    var mouseX = e.clientX - rect.left;
                    var mouseY = e.clientY - rect.top;

                    if (newZoom === minZoom) {
                        imgOffsetX = 0;
                        imgOffsetY = 0;
                    } else {
                        imgOffsetX -= mouseX * scaleFactor - mouseX;
                        imgOffsetY -= mouseY * scaleFactor - mouseY;
                    }

                    zoom = newZoom;
                    applyTransform();
                });

                var isDragging = false;
                var startCursorX, startCursorY;
                var startImgOffsetX, startImgOffsetY;

                img.addEventListener("mousedown", function (e) {
                    isDragging = true;
                    img.style.cursor = "grabbing";
                    startCursorX = e.clientX;
                    startCursorY = e.clientY;
                    startImgOffsetX = imgOffsetX;
                    startImgOffsetY = imgOffsetY;
                    img.style.transition = "none";
                });

                document.addEventListener("mouseup", function () {
                    isDragging = false;
                    img.style.cursor = "grab";
                });

                document.addEventListener("mousemove", function (e) {
                    if (!isDragging) return;
                    e.preventDefault();
                    var dx = e.clientX - startCursorX;
                    var dy = e.clientY - startCursorY;
                    imgOffsetX = startImgOffsetX + dx;
                    imgOffsetY = startImgOffsetY + dy;
                    applyTransform();
                });
            }
        }

        function generateThumbnails() {
            var container = document.getElementById("carouselThumbnails");
            container.innerHTML = "";

            for (var i = 0; i < carouselImages.length; i++) {
                (function (index) {
                    var current = carouselImages[index];
                    var thumb = document.createElement("img");

                    thumb.src = current.type === "PDF"
                        ? "content/images/pdf_file_icon.png"
                        : current.type === "VIDEO"
                            ? "content/images/video_icon.png"
                            : current.url;

                    console.log("Thumbnail src for type", current.type, "->", thumb.src);

                    thumb.className = "carousel-thumbnail";
                    if (index === currentImageIndex) {
                        thumb.classList.add("selected");
                    }

                    thumb.onclick = function () {
                        currentImageIndex = index;
                        updateCarouselImage();
                        generateThumbnails();
                    };

                    container.appendChild(thumb);
                })(i);
            }
        }

        window.closeCarousel = function () {
            document.getElementById("imageCarouselModal").style.display = "none";
        };

        window.changeImage = function (n) {
            currentImageIndex += n;
            if (currentImageIndex < 0) currentImageIndex = carouselImages.length - 1;
            if (currentImageIndex >= carouselImages.length) currentImageIndex = 0;
            updateCarouselImage();
            generateThumbnails();
        };

        window.downloadCurrentImage = function () {
            var current = carouselImages[currentImageIndex];
            var link = document.createElement('a');
            link.href = current.url;
             var extension = current.type === "PDF" ? ".pdf" :
                    current.type === "VIDEO" ? ".mp4" :
                    ".png"; 
            link.download = gpName + "_gpfile_" + (currentImageIndex + 1)+extension;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        window.downloadAllImages = function () {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block";
            }
            var xhr = new XMLHttpRequest();
            xhr.open('GET', '/api/assets/downloadFiles/' + vm.asset.id, true);
            xhr.setRequestHeader('Accept', 'application/zip');
            xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
            xhr.responseType = 'blob';

            xhr.onload = function () {
                if (spinner) {
                    spinner.style.display = "none"; // Show the spinner
                }
                if (xhr.status === 200) {
                    var blob = new Blob([xhr.response], { type: 'application/zip' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = vm.asset.name + '_GP' + '.zip';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    alert('Download failed. Status: ' + xhr.status);
                }
            };

            xhr.onerror = function () {
                alert('Request error.');
            };

            xhr.send();
        }
        $scope.tab = 1;
        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };
        $scope.setTab = function (newTab) {
            $scope.tab = newTab; 
            if ($scope.tab == 2) { 
                MappedFixedAssets.get(vm.asset.id,pagingParams.page - 1,vm.itemsPerPage, function(response){
                    vm.links = ParseLinks.parse(response.headers("link"));
                    vm.totalItems = response.headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.totalItems = Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                    vm.listMappedAssets = response.data
                    vm.page = pagingParams.page;
                })
            }
        }
        vm.previousState = previousState.name;
        //vm.showAssetImage = false

        /* Configs.get("AssetImage",function(response){
            if(response.length > 0){
                if(response[0].configValue == "True"){
                    vm.showAssetImage = true
                }
            }
        }) */
        if(vm.asset.assetReferenceAttributes.length){
            vm.assetRefAttributes = []
            vm.asset.assetReferenceAttributes.forEach(function (get){
                if (get["assetAttributeName"] != null) {
                    get['assetAttributeName'].assetTypeAttribute.attributeValue = get['assetAttributeName'].attributeValue;
                    vm.assetRefAttributes.push(get['assetAttributeName'].assetTypeAttribute);
                }

                if (get["assetAttributeValue"] != null) {
                    get['assetAttributeValue'].assetTypeAttribute.attributeValue = get['assetAttributeValue'].attributeValue;
                    vm.assetRefAttributes.push(get['assetAttributeValue'].assetTypeAttribute);
                }

                if (get["assetAttributeImage"] != null) {
                    get['assetAttributeImage'].assetTypeAttribute.imageId = get['assetAttributeImage'].imageId;
                    get['assetAttributeImage'].assetTypeAttribute.attributeName = get['assetAttributeImage'].imageName;
                    vm.assetRefAttributes.push(get['assetAttributeImage'].assetTypeAttribute);
                }
            })
        }

       /*  vm.imageInNewTab = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
            );
            imgWindow.document.close(); 
		}; */
        vm.transition = function transition() {
          /*  if(vm.queryCount )
            MappedFixedAssets.get(vm.asset.id,vm.page,vm.itemsPerPage, function(response){
                vm.links = ParseLinks.parse(response.headers("link"));
                vm.totalItems = response.headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.totalItems = Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                vm.listMappedAssets = response.data
                vm.page = pagingParams.page;
            }) */
        }
$scope.showAllImages = function (images, name) {
    if (!images || images.length === 0) {
        alert("No images available for this attribute.");
        return;
    }

    var apiBase = name === 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";
    var imageBlobs = [];
    var loadedCount = 0;
    // Open a new tab immediately
    var imageWindow = window.open("", "_blank");
    imageWindow.document.title = "Attribute Images";
    imageWindow.document.write("<h2 style='font-family:Arial; color:#3c8dbc;'>Attribute Images</h2>");
    imageWindow.document.write("<div id='imageContainer' style='display:flex; flex-wrap:wrap; gap:10px;'></div>");

    images.forEach(function (img) {
        if (!img.imageId) return;

        var request = new XMLHttpRequest();
        request.open('GET', apiBase + vm.asset.id + "/" + img.imageId, true);
        request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
        request.responseType = 'blob';
        
        request.onload = function () {
            loadedCount++;
            if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var blobUrl = urlCreator.createObjectURL(this.response);
                // Append image to the new tab dynamically
                var container = imageWindow.document.getElementById('imageContainer');
                var imgTag = imageWindow.document.createElement('img');
                imgTag.src = blobUrl;
                imgTag.style.maxWidth = "250px";
                imgTag.style.border = "1px solid #ccc";
                imgTag.style.borderRadius = "6px";
                imgTag.style.margin = "5px";
                container.appendChild(imgTag);
            }

            if (loadedCount === images.length) {
                imageWindow.document.write("<p style='font-family:Arial; color:gray;'>All images loaded.</p>");
            }
        };

        request.onerror = function () {
            loadedCount++;
            console.error("Error loading image:", img.imageId);
        };

        request.send();
    });
};


        $scope.newTabDisplay = function(id,name,str){
            var request = new XMLHttpRequest(),apiImage = name == 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";;
            request.open('GET',apiImage+vm.asset.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                  
                    
                    if(str == "MP4"){
                        var videoUrl = urlCreator.createObjectURL(this.response);
                        
                        var video = document.createElement('video');
                        video.src = videoUrl;
                        video.controls = true;
                        video.autoplay = true;
                
                        var videoWindow = window.open("", "_blank");
                        videoWindow.document.body.appendChild(video);
                    }else{
                        var imageUrl = urlCreator.createObjectURL(this.response);
                        window.open(imageUrl, "_blank");
                    }
                   
                }
            } 
            request.send();
        } 

        var unsubscribe = $rootScope.$on('trakeyeApp:assetUpdate', function(event, result) {
            vm.asset = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
    
    function myOption(zoom, center) {
        var myOptions;
        return (myOptions = {
            zoom: zoom,
            center: center,
            scaleControl: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ],
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetDeleteController',AssetDeleteController);

    AssetDeleteController.$inject = ['$uibModalInstance', 'entity', 'Asset'];

    function AssetDeleteController($uibModalInstance, entity, Asset) {
        var vm = this;

        vm.asset = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Asset.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetConnectController',
			AssetConnectController);

	AssetConnectController.$inject = [ '$timeout', '$scope', '$stateParams','AlertService',
			'entity', 'Asset', 'User', 'AssetType', '$state', 'AssetUpload',
			'AllAssetsTypes', 'AllCustomAssetTypeAttribute', 'AssetIDs','AssetByID' ];

	function AssetConnectController($timeout, $scope, $stateParams, AlertService, entity,
			Asset, User, AssetType, $state, AssetUpload, AllAssetsTypes,
			AllCustomAssetTypeAttribute, AssetIDs,AssetByID) {
		var vm = this;
//		var entity_old = angular.copy(vm.asset);
		vm.asset = entity;
		vm.generatedasset = null;
		vm.childAsset =  null;
		vm.parentName = null;
		vm.clear = clear;
		vm.save = save;
		vm.assetType = entity.assetType;

		vm.upload = upload;
		vm.assettypes = loadPage();
		vm.coOrdinates = [];
		vm.coOrdinate = null;
		vm.isAutomatic = true;
		vm.isRoadLeft = true;
		vm.isSiteASelected = false;
		vm.isSiteBSelected = false;
		vm.selectedSiteA = {};
		vm.selectedSiteB = {};
		var isSaved = false;

		var newFence = false;
		var latlng;
		var locations = {};
		var centerlatlng = null;
		vm.customAttributesMap = {};
		var formData;
		var spreadAssets = [];
		vm.isSaving = true;

		function loadPage() {
            vm.assestList = [];
			vm.multiassets = [];
			var selctedAssets = [];

			if (vm.asset.id != null) {
				vm.asset.ownedBy.forEach(function(asset) {
					selctedAssets.push(asset.id);
				})
			}

			AssetIDs.getAll(function(response) {
				response.forEach(function(asset) {
					vm.assestList.push(asset);
					if(asset.assetTypeName == "Site"){
						if (selctedAssets.indexOf(asset.id) !== -1) {
							vm.multiassets.push({
								lat : asset.assetCoordinates[asset.assetCoordinates.length-1].latitude,
								lng : asset.assetCoordinates[asset.assetCoordinates.length-1].longitude,
								name : asset.name,
								assetType : asset.assetType,
								assetCoordinates : asset.assetCoordinates,
								id : asset.id,
								ownedBy : asset.ownedBy,
								ticked : true
							});
						} else {
							try {
								vm.multiassets.push({
									lat : asset.assetCoordinates[asset.assetCoordinates.length-1].latitude,
									lng : asset.assetCoordinates[asset.assetCoordinates.length-1].longitude,
									name : asset.name,
									assetType : asset.assetType,
									assetCoordinates : asset.assetCoordinates,
									id : asset.id,
									ownedBy : asset.ownedBy,
									ticked : false
								});
							} catch (e) {
								// TODO: handle exception
							}

						}
					}
				});
			});

			AllAssetsTypes.getAll(function(response) {
				vm.assettypes = response;
			});

			AllCustomAssetTypeAttribute.getAll(function(response) {
				response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customAssetTypeAttributeValues;
				});
			});
			$( "#connectTypeRadio1").prop('checked', true);
			$( "#roadSideRadio1").prop('checked', true);
		}

		function upload() {
			formData = new FormData();

			formData.append("assetname", $scope.assetname);
			formData.append('file', $scope.myFile);

			AssetUpload.assetupload(formData, function(response, headers) {
				if (response.status == 200) {
					vm.error = null;
					vm.success = 'OK';
					$scope.spreadassetname = '';

					$timeout(function() {
						vm.success = '';
					}, 4000);

				}
				if (response.status == 400) {
					vm.success = null;
					vm.error = 'error';

				}
			});

		}

        $(".select2").select2();

  		$("#fromAssetsView").change(function () {
			$("#toAssetsView")[0].selectedIndex = 0;
			var result = $("#fromAssetsView").val();
			if(result != null){
				for (var i = 0; i < vm.multiassets.length; i++) {
					if (vm.multiassets[i].id == result) {
						vm.selectedSiteA = vm.multiassets[i];
					}
				}
				vm.isSiteASelected = true;
			}
		});

		$("#toAssetsView").change(function () {
			if(vm.isSiteASelected == true){
				var result = $("#toAssetsView").val();
				if(result != null){
					for (var i = 0; i < vm.multiassets.length; i++) {
					if (vm.multiassets[i].id == result) {
						vm.selectedSiteB = vm.multiassets[i];
					}
				}
					vm.isSiteBSelected = true;
				}
			}else{
				$("#toAssetsView")[0].selectedIndex = 0;
				alert("Please Select Site A");
			}

		});

		/* import end */
		vm.createNewFence = function() {
			newFence = true;
			vm.asset.assetCoordinates = [];
			vm.createfence();
		}

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		function clear() {
			//$uibModalInstance.dismiss('cancel');
			
		}

		function save() {
			if(vm.fiberowner != null){
				if(vm.isSiteASelected == false && vm.isSiteBSelected == false){
					alert("Please Select Site A");
				}else if(vm.isSiteASelected == true && vm.isSiteBSelected == false){
					alert("Please Select Site B");
				}else {
					vm.assestList.forEach(function(assetVal){
						if (assetVal.name == vm.asset.name) {
							alert("site A and site B already exist in assetsList");
						} else {
							vm.asset.assetTypeAttributeValues = [];
							var disVal = 0.0;
							var spreadCoordinates = vm.asset.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(spreadCoordinates[index].latitude, spreadCoordinates[index].longitude, spreadCoordinates[index - 1].latitude, spreadCoordinates[index - 1].longitude);
                                        }
                                    }
                                }
							vm.asset.assetType.assetTypeAttributes.forEach(function(assetAttrVal){
								if(assetAttrVal.name == "Fiber Owner"){
									vm.asset.assetTypeAttributeValues.push(
										{
											attributeValue : vm.fiberowner,
											assetTypeAttribute : assetAttrVal
										}
									)
								}else if(assetAttrVal.name == "Fiber Distance (km)"){
									vm.asset.assetTypeAttributeValues.push(
										{
											attributeValue : disVal.toFixed(2),
											assetTypeAttribute : assetAttrVal
										}
									)
								}else{
									vm.asset.assetTypeAttributeValues.push(
										{
											attributeValue : assetAttrVal.defaultValue,
											assetTypeAttribute : assetAttrVal
										}
									)
								}
								
							});
							vm.isSaving = true;
							if(!isSaved){
								Asset.save(vm.asset, onSaveSuccess, onSaveError);
								isSaved = true;
							}
						}
					})
				}
			}else{
				alert("Please Enter Fiber Owner Name");
			}
		}

		function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return (dist);
            }
        }


        function moveToLocation(lat, lng, map) {
            var center = new google.maps.LatLng(lat, lng);
            map.panTo(center);
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

		function onSaveSuccess(result) {
			isSaved = true;
			$scope.$emit('trakeyeApp:assetUpdate', result);
			vm.isSaving = false;
			$state.go('asset');
		}

		function onSaveError() {
			vm.isSaving = false;
		}

//		function onSaveSuccess(result) {
//			$scope.$emit('trakeyeApp:assetUpdate', result);
//			vm.isSaving = false;
//			$state.go('asset');
//		}
//
//		function onSaveError() {
//			vm.isSaving = false;
//		}

		vm.createfence = function() {
			if (vm.selectedSiteA.name == vm.selectedSiteB.name) {
				alert("same asset Name is not valid")
			} else {
			var connectTypeVal = $('input[name=connectTypeRdo]:checked').val();
			if(connectTypeVal == "Automatic"){
				vm.isAutomatic = true;
			}else{
				vm.isAutomatic = false;
			}
		
			var roadSiteVal = $('input[name=RoadSideRdo]:checked').val();
			if(roadSiteVal == "Left"){
				vm.isRoadLeft = true;
			}else{
				vm.isRoadLeft = false;
			}

			

			if(vm.isSiteASelected == false && vm.isSiteBSelected == false){
				alert("Please Select Site A");
			}else if(vm.isSiteASelected == true && vm.isSiteBSelected == false){
				alert("Please Select Site B");
			}else{
				var siteALatLng = new google.maps.LatLng(vm.selectedSiteA.assetCoordinates[0].latitude, vm.selectedSiteA.assetCoordinates[0].longitude);
				var siteBLatLng = new google.maps.LatLng(vm.selectedSiteB.assetCoordinates[0].latitude, vm.selectedSiteB.assetCoordinates[0].longitude);
				var map = new google.maps.Map(document.getElementById('map_canvas'), {
					center : siteALatLng,
					zoom : 16,
					fullscreenControl: true
				});
				createMarker(map, vm.selectedSiteA.name, siteALatLng);
				createMarker(map, vm.selectedSiteB.name, siteBLatLng);
			
				if(vm.isAutomatic){
					var generatedAssetVal = {};
					if(vm.isRoadLeft){
						generatedAssetVal = getShortestRoute(vm.selectedSiteA, vm.selectedSiteB, map);
					}else{
						generatedAssetVal = getShortestRoute(vm.selectedSiteB, vm.selectedSiteA, map);
					}
					
					if(generatedAssetVal != null){
						vm.asset = generatedAssetVal;
					}
				}else{
					var newAsset = {
						name: '',
						assetCoordinates: []
					};
					newAsset.name = vm.selectedSiteA.name+"-"+vm.selectedSiteB.name;
					AssetType.query({}, function (data) {
                        data.forEach(function (item) {
                            if (item.name == "Link") {
                                newAsset.assetType = item;
                            }
                        });
					});
					drawingManagerSpread();
					drawingManagerValue('polylinecomplete', map, newAsset);
				}
				
			}
			vm.isSaving = false;
		  }
		};

		function getShortestRoute(SiteA, SiteB, map){
			var pointA = new google.maps.LatLng(SiteA.assetCoordinates[0].latitude, SiteA.assetCoordinates[0].longitude);
            var pointB = new google.maps.LatLng(SiteB.assetCoordinates[0].latitude, SiteB.assetCoordinates[0].longitude);

            var newAsset = {
                name: '',
                assetCoordinates: []
            };
            newAsset.name = SiteA.name+"-"+SiteB.name;

            var directionsService = new google.maps.DirectionsService;
            var myOptions = {
                zoom: 14,
                center: pointA,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var polylineOptionsActual = new google.maps.Polyline({
                strokeColor: '#ff0000',
                strokeOpacity: 0.5,
                strokeWeight: 4
            });
            var directionsDisplay = new google.maps.DirectionsRenderer({
                map: map,
                polylineOptions: polylineOptionsActual,
                suppressMarkers: true
            });

            directionsService.route({
                origin: pointA,
                destination: pointB,
                avoidTolls: true,
                avoidHighways: false,
                travelMode: google.maps.TravelMode.DRIVING
            }, function (response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);
                    var responsePath = response.routes[0].overview_path;
                    vm.fixedArray = [];
                    responsePath.forEach(function (value) {
                        var coordinates = {};
                        coordinates.latitude = value.lat();
                        coordinates.longitude = value.lng();
                        vm.fixedArray.push(coordinates);
                    });
                    newAsset.assetCoordinates = vm.fixedArray;
                    newAsset.layout == 'SPREAD';

                    AssetType.query({}, function (data) {
                        data.forEach(function (item) {
                            if (item.name == "Link") {
                                newAsset.assetType = item;
                            }
                        });
                    });
                } else {
					window.alert('Directions request failed due to ' + status);
                }
			});
			return newAsset;
		}
		function drawingManagerSpread() {
			vm.drawingManager = new google.maps.drawing.DrawingManager({
				drawingMode : google.maps.drawing.OverlayType.POLYLINE,
				drawingControl : true,
				drawingControlOptions : {
					position : google.maps.ControlPosition.TOP_CENTER,
					drawingModes : [ 'polyline' ]
				},
				polylineOptions : {
					fillColor : '#ffff00',
					fillOpacity : 1,
					strokeWeight : 5,
					clickable : true,

					editable : true,
					zIndex : 1,
					geodesic : true
				}
			});
		}

		function createMarker(map, assetName, myLatLng) {
			var marker = new google.maps.Marker(
					{
						position : myLatLng,
						map : map,
						icon : {
							scaledSize : new google.maps.Size(
									24, 24),
									origin : new google.maps.Point(0, 0),
									url :'content/images/yellow.png',
									anchor : new google.maps.Point(
											16, 16),

						},
						label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: assetName, backgroundcolor: "#ff9800" },
					});
			
		}

		function drawingManagerValue(option, map, assetVal) {
			if (option == 'polylinecomplete') {
				google.maps.event.addListener(vm.drawingManager, option,
						function(event) {
							google.maps.event.addListener(event.getPath(),
									'insert_at', function() {
										setGoefenceCoordinate(event, assetVal);
									});
							google.maps.event.addListener(event.getPath(),
									'set_at', function(path) {
										setGoefenceCoordinate(event, assetVal);
									});
							vm.drawingManager.setOptions({
								drawingControl : false
							});
							vm.drawingManager.setMap(null);
							setGoefenceCoordinate(event, assetVal);
						});
				vm.drawingManager.setMap(map);
			}
		}

		function setGoefenceCoordinate(event, assetVal) {
			assetVal.assetCoordinates = [];
			var radius = event.getPath();
			for (var i = 0; i < radius.getLength(); i++) {
				var coordinates = {};
				coordinates.latitude = radius.getAt(i).lat();
				coordinates.longitude = radius.getAt(i).lng();
				assetVal.assetCoordinates.push(coordinates);
			}
			vm.asset = assetVal;
		}

		function moveToLocation(lat, lng, map) {
			var center = new google.maps.LatLng(lat, lng);
			// using global variable:
			map.panTo(center);
		}

		$scope.mapEvents = {
			"click" : function() {

			}
		}
	}
})();
(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetAdditionController',
			AssetAdditionController);

	AssetAdditionController.$inject = [ '$timeout', '$scope', '$stateParams','AlertService',
			'entity', 'Asset', 'User', 'AssetType', '$state', 'AssetUpload',
			'AllAssetsTypes', 'AllCustomAssetTypeAttribute', 'AssetIDs','AssetByID' ];

	function AssetAdditionController($timeout, $scope, $stateParams, AlertService, entity,
			Asset, User, AssetType, $state, AssetUpload, AllAssetsTypes,
			AllCustomAssetTypeAttribute, AssetIDs,AssetByID) {
		var vm = this;
//		var entity_old = angular.copy(vm.asset);
		vm.asset = entity;
		vm.generatedasset = null;
		vm.childAsset =  null;
		vm.parentName = null;
		var entity_old = angular.copy(vm.asset);
		vm.clear = clear;
		vm.save = save;
		vm.assetType = entity.assetType;

		vm.upload = upload;
		var childAC = [];
		vm.assettypes = loadPage();
		vm.coOrdinates = [];
		vm.coOrdinate = null;
		var newFence = false;
		var latlng;
		var locations = {};
		var centerlatlng = null;
		vm.customAttributesMap = {};
		var formData;
		var spreadAssets = [];
		
		function loadPage() {

			vm.multiassets = [];
			var selctedAssets = [];

			if (vm.asset.id != null) {
				vm.asset.ownedBy.forEach(function(asset) {
					selctedAssets.push(asset.id);
				})
			}

			AssetIDs.getAll(function(response) {
				response.forEach(function(asset) {
					if (selctedAssets.indexOf(asset.id) !== -1) {
						vm.multiassets.push({
							lat : asset.assetCoordinates[asset.assetCoordinates.length-1].latitude,
							lng : asset.assetCoordinates[asset.assetCoordinates.length-1].longitude,
							name : asset.name,
							assetType : asset.assetType,
							assetCoordinates : asset.assetCoordinates,
							id : asset.id,
							ownedBy : asset.ownedBy,
							ticked : true
						});
					} else {
						try {
							vm.multiassets.push({
								lat : asset.assetCoordinates[asset.assetCoordinates.length-1].latitude,
								lng : asset.assetCoordinates[asset.assetCoordinates.length-1].longitude,
								name : asset.name,
								assetType : asset.assetType,
								assetCoordinates : asset.assetCoordinates,
								id : asset.id,
								ownedBy : asset.ownedBy,
								ticked : false
							});
						} catch (e) {
							// TODO: handle exception
						}
						
					}
				});
			});
			
			AllAssetsTypes.getAll(function(response) {
				vm.assettypes = response;
			});

			AllCustomAssetTypeAttribute.getAll(function(response) {
				response.forEach(function(arrayItem) {
					vm.customAttributesMap[arrayItem.name] = arrayItem.customAssetTypeAttributeValues;
				});
			});
		}

		function upload() {
			formData = new FormData();

			formData.append("assetname", $scope.assetname);
			formData.append('file', $scope.myFile);

			AssetUpload.assetupload(formData, function(response, headers) {
				if (response.status == 200) {
					vm.error = null;
					vm.success = 'OK';
					$scope.spreadassetname = '';

					$timeout(function() {
						vm.success = '';
					}, 4000);

				}
				if (response.status == 400) {
					vm.success = null;
					vm.error = 'error';

				}
			});

		}

		/* import end */
		vm.createNewFence = function() {
			newFence = true;
			vm.asset.assetCoordinates = [];
			vm.createfence();
		}

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			vm.isSaving = true;
			if (vm.asset.id !== null) {
				Asset.update(vm.asset, onSaveSuccess, onSaveError);
			} else {
				Asset.save(vm.asset, onSaveSuccess, onSaveError);
			}
		}

		function onSaveSuccess(result) {
			$scope.$emit('trakeyeApp:assetUpdate', result);
			vm.isSaving = false;
			$state.go('asset');
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		vm.createfence = function() {
			
			var elem = document.getElementById("map_canvas");

			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if (elem.mozRequestFullScreen) { /* Firefox */
				elem.mozRequestFullScreen();
			} else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
				elem.webkitRequestFullscreen();
			} else if (elem.msRequestFullscreen) { /* IE/Edge */
				elem.msRequestFullscreen();
			}
			 
			var child = {};
			childAC = [];
			for (var i = 0; i < vm.multiassets.length; i++) {
				if (vm.multiassets[i].ticked == true) {
					child = vm.multiassets[i];
					childAC = vm.multiassets[i].assetCoordinates;
				}
			}
			
			var myLatLng = ({lat:child.lat, lng:child.lng});
			var map = new google.maps.Map(document
					.getElementById('map_canvas'), {
				center : myLatLng,
				zoom : 16,
				fullscreenControl: true
			});
			
			createMarkerOfAllAssets(myLatLng,map,child.name);

			for(var j = 0; j < childAC.length;j++){
				if(j > 0){
					var locValues =[];
					locValues.push(childAC[j-1]);
					locValues.push(childAC[j]);
					drawPolylineForGeneratedLoc(locValues,map, "black");
				}
			}	
			
			AssetByID.get(child.id,function(response) {
				vm.childAsset = response;
				if(response.ownedBy != null){
					var parent = response.ownedBy;
						if (parent.length > 0) {
							vm.parentName = parent[0].name;
							var assetCoordinateValues = parent[0].assetCoordinates;
							var myLatLng = ({lat:assetCoordinateValues[assetCoordinateValues.length-1].latitude, lng:assetCoordinateValues[assetCoordinateValues.length-1].longitude});
							createMarkerOfAllAssets(myLatLng,map,parent[0].name);
						}
					}
			});
		};

		function drawPolylineForGeneratedLoc(latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];
            $.each(latlngsToDraw, function(index, value) {

                spreadAssetCoordinates.push({
                    lat : value.latitude,
                    lng : value.longitude
                });
            });

            if (spreadAssetCoordinates.length > 0) {
                var midLatLng = {
                        lat : spreadAssetCoordinates[spreadAssetCoordinates.length-1].lat,
                        lng : spreadAssetCoordinates[spreadAssetCoordinates.length-1].lng
                    };
                var infowindow = new google.maps.InfoWindow(
                        {
                            content : '<div class="infoWindowhead">'
                                    + "name"
                                    + '<div class="infoWindowContent"> <b>Description :</b> '
                                    + "des" + '</div></div>'
                        });
                infowindow.setPosition(midLatLng);

                var ColorValue = '#ff0000';
                if(color == "red"){
                    ColorValue = '#ff0000';
                }else if(color == "black"){
                	ColorValue = '#000000';
                }else{
                    ColorValue = '#208000';
                }
                var polylinepath = new google.maps.Polyline({
                    path : spreadAssetCoordinates,
                    geodesic : true,
                    strokeColor : ColorValue,
                    strokeOpacity : 1.0,
                    strokeWeight : 2.5,
                    fillColor : ColorValue,
                    fillOpacity : 0.3,
                    editable : false
                });

                google.maps.event.addListener(polylinepath, 'mouseout', function(event) {
					infowindow.close();
				});

				google.maps.event.addListener(polylinepath, 'mouseover', function(event) {
					
					var userContent= document.createElement('div'), button;

					userContent.innerHTML = '<div class="infoWindowhead">' + 'Insert Asset at '
					+ '</div><div class="infoWindowContent">'
					+'<b>Latitude :</b> '
					+ event.latLng.lat()
					+'<br><b>Longitude :</b> '
					+ event.latLng.lng()
					+ '</div>';

					button = userContent.appendChild(document.createElement('input'));
					button.type = 'button';
					button.value = 'Save';
					button.className = "button"; 
					button.style.width = '300px';
					infowindow = new google.maps.InfoWindow({
						content : userContent
					});

					google.maps.event.addDomListener(button, 'click', function () {
						var newAssetAC = [];
						var newChildAC = [];
						var isACSplitted = false;
						
						vm.generatedasset = vm.asset;
						vm.generatedasset.name = "Asset BW "+vm.childAsset.name + " " +vm.parentName;
						vm.generatedasset.assetCoordinates = [];
						vm.generatedasset.assetCoordinates.push({latitude:event.latLng.lat(), longitude:event.latLng.lng()});
						var assetTypes = vm.assettypes;
						var assetTypeAttributesVal = [];
						var assetTypeValConsolidated = null;
						for (var i = 0; i < assetTypes.length; i++) {
							if(assetTypes[i].name == "Joint Kit"){
								assetTypeValConsolidated = assetTypes[i];
								assetTypeAttributesVal = assetTypes[i].assetTypeAttributes;
							}	
						}
						var assetTypeAttributesValConsolidated = [];
						for (var i = 0; i < assetTypeAttributesVal.length; i++) {
							if(assetTypeAttributesVal[i] != null){
								assetTypeAttributesValConsolidated.push({assetTypeAttribute:assetTypeAttributesVal[i],attributeValue:assetTypeAttributesVal[i].defaultValue}  );
							}
						}
						vm.generatedasset.assetTypeAttributeValues = assetTypeAttributesValConsolidated;
						vm.generatedasset.assetType = assetTypeValConsolidated;

						for (var i = 0; i < childAC.length; i++) {
							if(!isACSplitted){
								newAssetAC.push({latitude:childAC[i].latitude, longitude:childAC[i].longitude});
								if(latlngsToDraw[0].latitude == childAC[i].latitude){
									isACSplitted = true;
									newAssetAC.push({latitude:event.latLng.lat(), longitude:event.latLng.lng()});
									newChildAC.push({latitude:event.latLng.lat(), longitude:event.latLng.lng()});
								}
							}else{
								newChildAC.push({latitude:childAC[i].latitude, longitude:childAC[i].longitude});
							}
						}
					
						if(newAssetAC.length > 0){
							vm.childAsset.assetCoordinates.push({latitude:newAssetAC[newAssetAC.length-1].latitude, longitude:newAssetAC[newAssetAC.length-1].longitude});
						}
						
						for (var i = 0; i < newChildAC.length; i++) {
							vm.childAsset.assetCoordinates.push({latitude:newChildAC[i].latitude, longitude:newChildAC[i].longitude});
						}
						
						vm.generatedasset.assetCoordinates = [];
						
						for (var i = 0; i < newAssetAC.length; i++) {
							vm.generatedasset.assetCoordinates.push({latitude:newAssetAC[i].latitude, longitude:newAssetAC[i].longitude});
						}
						

						
						Asset.save(vm.generatedasset, function(response) {
							
							vm.generatedasset.ownedBy = vm.childAsset.ownedBy;
							vm.childAsset.ownedBy = [];
							vm.childAsset.ownedBy.push({id:response.id})
							
							vm.generatedasset.id = response.id;

							Asset.update(vm.childAsset,function(response) {
								Asset.update(vm.generatedasset,function(response) {
									$state.go('asset');
								});
							});
							
							
						});
						newAssetAC = [];
						newChildAC = [];
						
					});
                    infowindow.mousemove;
					infowindow.setPosition(event.latLng);
					infowindow.open(map);
				});
				
                polylinepath.setOptions({
                    strokeColor : ColorValue
                });
                
                
                polylinepath.setMap(map);
            }
        }
		
		function distanceCal(lat1, lon1, lat2, lon2) {
			var theta = lon1 - lon2;
			var dist = Math.sin(degrees_to_radians(lat1)) * Math.sin(degrees_to_radians(lat2))
			+ Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * Math.cos(degrees_to_radians(theta));
			dist = Math.acos(dist);
			dist = radians_to_degrees(dist);
			dist = dist * 60 * 1.1515;
			dist = dist * 1.609344;
			if(isNaN(dist)){
				return 0.0;
			}else{
				return (dist);	
			}
		}
		function degrees_to_radians(degrees){
			var pi = Math.PI;
			return degrees * (pi/180);
		}

		function radians_to_degrees(radians){
			var pi = Math.PI;
			return radians * (180/pi);
		}

		function createMarkerOfAllAssets(myLatLng, map, myLocName) {
				var marker = new google.maps.Marker(
						{
							position : myLatLng,
							map : map,
							icon : {
								scaledSize : new google.maps.Size(
										24, 24),
										origin : new google.maps.Point(0, 0),
										icon :'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
										anchor : new google.maps.Point(
														0, 0),

							},
							label: { color: 'black', fontWeight: 'medium', fontSize: '12px', text: myLocName, backgroundcolor: "#ff9800" },
						});
		}
		

		function moveToLocation(lat, lng, map) {
			var center = new google.maps.LatLng(lat, lng);
			// using global variable:
			map.panTo(center);
		}


	
		$scope.mapEvents = {
			"click" : function() {

			}
		}

	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').controller('AssetTypeSiteReportController', AssetTypeSiteReportController)

	AssetTypeSiteReportController.$inject = [ '$scope', '$state', 'pagingParams','paginationConstants', 'ParseLinks', 'SiteAssets', '$rootScope', '$timeout', '$window', '$filter', '$interval' ];

	function AssetTypeSiteReportController($scope, $state, pagingParams, paginationConstants, ParseLinks, SiteAssets, $rootScope, $timeout, $window, $filter, $interval) {
		var vm = this;
		vm.multiassets = [];
		 vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.appName = $rootScope.APP_NAME;
		vm.filterSearch=filterSearch;
        
        function filterSearch(){
        	
			if($scope.search!=null && $scope.search!="" && !angular.isUndefined($scope.search)){
			
			}
		}
			
		SiteAssets.query({
                page: pagingParams.page - 1,
                search: $scope.search,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' +
                    (vm.reverse ? 'asc' : 'desc')
                ];
                if (vm.predicate !== 'id') {
                    // result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
				data.forEach(function(asset) {
					if (asset.assetTypeName == "Site") {
						vm.multiassets.push({
							id : asset.name,
							name : asset.siteChildAssetsDTO.siteName,
							WDM : asset.siteChildAssetsDTO.wdmCount,
							NTTN : asset.siteChildAssetsDTO.nttnCount,
							Router : asset.siteChildAssetsDTO.routerCount,
							BackToBack : asset.siteChildAssetsDTO.backtobackCount,
							Others : asset.siteChildAssetsDTO.othersCount
						});
						
						vm.multiassets.sort(function(a, b){
						    var nameA=a.id.toLowerCase(), nameB=b.id.toLowerCase()
						    if (nameA < nameB) //sort string ascending
						        return -1 
						    if (nameA > nameB)
						        return 1
						    return 0 //default return value (no sorting)
						})
                    }
				});
			}
			
			function onError(error) {
                AlertService.error(error.data.message);
            }

		function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: $scope.search
            });
        }
	}
		

})();
(function () {
    'use strict';

    angular.module('trakeyeApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('asset', {
            parent: 'app',
            url: '/asset?page&sort&search',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER','ROLE_PLAN_ADMIN','ROLE_ROLLOUT_ADMIN'],
                pageTitle: 'trakeyeApp.asset.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/asset/assets.html',
                    controller: 'AssetController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name',
                    squash: true
                },
                search: null,
                pagesize: 10,
                listgeofenceid: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        pagesize: $stateParams.pagesize,
                        listgeofenceid: $stateParams.listgeofenceid
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('asset');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('asset-detail', {
            parent: 'asset',
            url: '/asset/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                pageTitle: 'trakeyeApp.asset.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/asset/asset-detail.html',
                    controller: 'AssetDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('asset');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Asset', function ($stateParams, Asset) {
                    return Asset.get({
                        id: $stateParams.id
                    }).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'asset',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })

            .state('asset-type-site-report', {
                parent: 'asset',
                url: '/asset-type-site-report',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER'],
                    pageTitle: 'trakeyeApp.report.asset-type-site-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-type-site-report.html',
                        controller: 'AssetTypeSiteReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'name',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('asset');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('asset-route', {
                parent: 'app',
                url: '/asset-route',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_PLAN_ADMIN', 'ROLE_ROLLOUT_ADMIN'],
                    pageTitle: 'trakeyeApp.asset.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-route.html',
                        controller: 'AssetRouteController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('asset-detail.edit', {
                parent: 'asset-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.asset.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-dialog.html',
                        controller: 'AssetDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('asset');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Asset', function ($stateParams, Asset) {
                        return Asset.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'asset',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('asset.new', {
                parent: 'asset',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-dialog.html',
                        controller: 'AssetDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            description: null,
                            createDate: null,
                            updateDate: null,
                            userId: null,
                            assetType: null,
                            assetTypeAttributeValues: [],
                            assetCoordinates: [],
                            assetImport: false
                        };
                    }
                }

            })

            .state('asset.import', {
                parent: 'asset',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-import.html',
                        controller: 'AssetImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            description: null,
                            createDate: null,
                            updateDate: null,
                            userId: null,
                            assetType: null,
                            assetTypeAttributeValues: [],
                            assetCoordinates: [],
                            assetImport: true
                        };
                    }
                }

            }) 
            /* .state('asset.import', {
                parent: 'asset',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/import/entity-import-dialog.html',
                        controller: 'ImportDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return $state.current.name || 'asset';
                    }]
                }
            }) */

            .state('asset.add', {
                parent: 'asset',
                url: '/add',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-addition.html',
                        controller: 'AssetAdditionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            description: null,
                            createDate: null,
                            updateDate: null,
                            userId: null,
                            assetType: null,
                            assetTypeAttributeValues: [],
                            assetCoordinates: []
                        };
                    }
                }

            })

            .state('asset.connect', {
                parent: 'asset',
                url: '/connect',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_USER', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-connect.html',
                        controller: 'AssetConnectController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            description: null,
                            createDate: null,
                            updateDate: null,
                            userId: null,
                            assetType: null,
                            assetTypeAttributeValues: [],
                            assetCoordinates: []
                        };
                    }
                }

            })

            .state('asset.edit', {
                parent: 'asset',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.asset.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/asset/asset-dialog.html',
                        controller: 'AssetDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('asset');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Asset', function ($stateParams, Asset) {
                        return Asset.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'asset',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('asset.delete', {
                parent: 'asset',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/asset/asset-delete-dialog.html',
                        controller: 'AssetDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Asset', function (Asset) {
                                return Asset.get({
                                    id: $stateParams.id
                                }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        setTimeout(function () {
                            $state.go('asset', null, {
                                reload: 'asset'
                            });
                        }, 1000);
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
(function () {
    'use strict';
    angular.module('trakeyeApp').factory('Asset', Asset);

    Asset.$inject = ['$resource'];

    function Asset($resource) {
        var resourceUrl = 'api/assets/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    }
})();

(function () {
    "use strict";
    angular.module("trakeyeApp").factory("ChildAssetMarkers", ChildAssetMarkers);

    ChildAssetMarkers.$inject = ["$resource"];

    function ChildAssetMarkers($resource) {
        var resourceUrl = "api/linked-asset-markers/:assetId";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetByMarkerId', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/asset-by-assetmarkerid/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetSiteIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/siteassetlistnew').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetCountByGroup', ['$http', function ($http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/assetcountbygroup').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetCountBySiteStatus', ['$http', function ($http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/assetcountbystatus').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

//(function() {
//    'use strict';
//
//    angular.module('trakeyeApp').factory('AssetCountByLinkStatus', ['$http', function($http) {
//
//        var service = {};
//        service.getAll = function(callback) {
//            $http.get('api/assetcountbylinkstatus').then(function(response) {
//                callback(response.data);
//            });
//        };
//
//        return service;
//    }]);
//})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetCountByLinkStatus', ['$http', function ($http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/assets/aggs/Link/Link%20Status').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetGroup', AssetGroup);

    AssetGroup.$inject = ['$resource'];

    function AssetGroup($resource) {
        var resourceUrl = 'api/assets-group-db';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupSearch', AssetGroupSearch);

    AssetGroupSearch.$inject = ['$resource'];

    function AssetGroupSearch($resource) {
        var service = $resource('/api/assets-group-db/searchvalue/:search', {
            // searchvalue : '@id'
        }, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetGroupWithGeofence', AssetGroupWithGeofence);

    AssetGroupWithGeofence.$inject = ['$resource'];

    function AssetGroupWithGeofence($resource) {
        var resourceUrl = 'api/assets-group-db/geofence/:geofenceId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetStatusListWithGeofence', AssetStatusListWithGeofence);

    AssetStatusListWithGeofence.$inject = ['$resource'];

    function AssetStatusListWithGeofence($resource) {
        var resourceUrl = 'api/asset-health-list-with-geofence/:geofenceId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupSearchWithGeofence', AssetGroupSearchWithGeofence);

    AssetGroupSearchWithGeofence.$inject = ['$resource'];

    function AssetGroupSearchWithGeofence($resource) {
        var service = $resource('/api/assets-group-db/geofence-searchvalue/:geofenceId/:search', {
            // searchvalue : '@id'
        }, {}, {}, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsUpdateGroup', AssetsUpdateGroup);

    AssetsUpdateGroup.$inject = ['$resource'];

    function AssetsUpdateGroup($resource) {
        var resourceUrl = 'api/assets/groups';

        return $resource(resourceUrl, {}, {
            'update': {
                method: 'PUT'
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsBulkDelete', AssetsBulkDelete);

    AssetsBulkDelete.$inject = ['$resource'];

    function AssetsBulkDelete($resource) {
        var resourceUrl = 'api/assets/bulk/delete';

        return $resource(resourceUrl, {
            'save': {
                method: 'POST'
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('UpdateAssetsGroup', UpdateAssetsGroup);

    UpdateAssetsGroup.$inject = ['$resource'];

    function UpdateAssetsGroup($resource) {
        var resourceUrl = 'api/assets';

        return $resource(resourceUrl, {}, {
            'update': {
                method: 'PUT'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('PrivateAssetsForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformapbyadmin = function (adminid, callback) {
            $http.get('api/privateassetsformap/' + adminid).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ChildAssetsType', ChildAssetsType);

    ChildAssetsType.$inject = ['$resource'];

    function ChildAssetsType($resource) {
        var resourceUrl = 'api/childassetslist/:parentId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ChildAssets', ChildAssets);

    ChildAssets.$inject = ['$resource'];

    function ChildAssets($resource) {
        var resourceUrl = 'api/childAssets/:parentId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ChildAssetsByTypeName', ChildAssetsByTypeName);

    ChildAssetsByTypeName.$inject = ['$resource'];

    function ChildAssetsByTypeName($resource) {
        var resourceUrl = 'api/childassetstypenamelist/:parentId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetImages', AssetImages);

    AssetImages.$inject = ['$resource'];

    function AssetImages($resource) {
        var service = $resource('/api/asset-images/:assetId', {}, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupByBufferGeo', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (minigeofenceid, callback) {
            $http.get('api/asset-groupby-buffergeofence/' + minigeofenceid).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

/* (function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetIdImageId', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (assetId,imageId, callback) {
            $http.get('api/trakeyeassetimages/' + assetId + '/'+ imageId).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})(); */

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UsersList', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getusers = function (callback) {
            $http.get('api/users').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetUser', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.gettrcasesuser = function (callback) {
            $http.get('api/location-logs/latest').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.searchassetsformap = function (search, callback) {
            $http.get('api/assets/searchformap/' + search).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupSearchForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.searchassetsformap = function (search, callback) {
            $http.get('api/assets/searchgroupassetsformap/' + search).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/assetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupFixedAssets', GroupFixedAssets);

    GroupFixedAssets.$inject = ['$resource'];

    function GroupFixedAssets($resource) {
        var service = $resource('/api/groupfixedassets', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupSpreadAssets', GroupSpreadAssets);

    GroupSpreadAssets.$inject = ['$resource'];

    function GroupSpreadAssets($resource) {
        var service = $resource('/api/groupspreadassets', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupFixedAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupfixedassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupSpreadAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupspreadassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupFixedAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupfixedassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupSpreadAssetsForMap', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformap = function (callback) {
            $http.get('api/groupspreadassetsformap').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetsForMapByAdmin', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.assetsformapbyadmin = function (adminid, callback) {
            $http.get('api/assetsformap/' + adminid).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetSearch', AssetSearch);

    AssetSearch.$inject = ['$resource'];

    function AssetSearch($resource) {
        var service = $resource('/api/assets/searchvalue/:search', {
            // searchvalue : '@id'
        }, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetUpload', AssetUpload);

    AssetUpload.$inject = ['$http'];

    function AssetUpload($http) {

        var service = {};
        service.assetupload = function (data, callback) {

            $http.post('api/assetsimport', data, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {
                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetIDs', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/assetlistnew').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('UserAccount', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (callback) {
            $http.get('api/user-auths').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

/*(function() {
    'use strict';

    angular.module('trakeyeApp').factory('SiteAssets', ['$rootScope', '$http', function($rootScope, $http) {

        var service = {};
        service.getAll = function(callback) {
            $http.get('api/siteassetdashboard').then(function(response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();*/

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('FilterAssetsForMap', FilterAssetsForMap);

    FilterAssetsForMap.$inject = ['$http', 'DateUtils'];

    function FilterAssetsForMap($http, DateUtils) {
        var service = {};

        service.loaddata = function (callback) {

            $http.get('api/filterassetsformap').then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('AttrTypeVal', AttrTypeVal);

    AttrTypeVal.$inject = ['$http', 'DateUtils'];

    function AttrTypeVal($http, DateUtils) {
        var service = {};

        service.loaddata = function (type, attribute, callback) {

            $http.get('api/assets/attrvalue-type-attrname/' + type + '/' + attribute).then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('SiteAssets', SiteAssets);

    SiteAssets.$inject = ['$resource'];

    function SiteAssets($resource) {
        var resourceUrl = 'api/siteassetdashboard';

        return $resource(resourceUrl, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

// (function() {
//     'use strict';

//     angular.module('trakeyeApp').factory('AssetCount', ['$rootScope', '$http', function($rootScope, $http) {

//         var service = {};
//         service.get = function(id, callback) {
//             $http.get('api/assetcountdashboard').then(function(response) {
//                 callback(response.data);
//             });
//         };

//         return service;
//     }]);
// })();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('AssetCount', AssetCount);

    AssetCount.$inject = ['$http', 'DateUtils'];

    function AssetCount($http, DateUtils) {
        var service = {};

        service.get = function (callback) {

            $http.get('api/assetcountdashboard').then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('AssetTypes', AssetTypes);

    AssetTypes.$inject = ['$http', 'DateUtils'];

    function AssetTypes($http, DateUtils) {
        var service = {};

        service.get = function (callback) {

            $http.get('api/assets/type/stats').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('SiteAssetById', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/assets/type/' + id + '/stats').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupES', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (geofenceId, lastid, callback) {
            $http.get('api/assets-group-es/' + geofenceId + "/" + lastid).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetDB', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (geofenceId, lastid, callback) {
            $http.get('api/assets-db/' + geofenceId + "/" + lastid).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('MappedFixedAssets', [ '$http', function ($http) {

        var service = {};
        service.get = function (id,paramPage,paramSize,callback) {
            $http.get('api/assets-group-db/mapped-fixed-assets/' + id + '?page='+paramPage+'&size='+paramSize).then(function (response) {
                callback(response);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupByGeofencesES', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function ( data, callback) {
            $http.post("api/assets-group-by-geofences-es", data).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetGroupByGeofencesDB', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function ( data, callback) {
            $http.post("api/assets-group-by-geofences-db", data).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('casesInMap', ['$http', function ($http) {

        var service = {};
        service.get = function ( data, callback) {
            $http.post("api/cases-for-asset-mapview", data).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllAssetsTypes', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/asset-types-by-roles').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AllCusAssetTypeAttr', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getCusAssetTypeAttr = function (callback) {
            $http.get('api/all-custom-asset-type-attributes').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetByID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/assets/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetsByGeofenceID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/geofence-assets-by-GefenceId/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetByName', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.check = function (name, callback) {
            $http.get('api/check-assets/' + name).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetDeleteByID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.delete = function (id, callback) {
            $http.delete('api/assets/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GeoAssetTypeReport', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAssetTypesByGeo = function (callback) {
            $http.get('api/reports/geoassettypereport').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('LinkAssets', GroupAssets);

    GroupAssets.$inject = ['$resource'];

    function GroupAssets($resource) {
        var service = $resource('/api/groupassets', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('GroupAssets', GroupAssets);

    GroupAssets.$inject = ['$resource'];

    function GroupAssets($resource) {
        var service = $resource('/api/groupassets', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetChildren', ['$rootScope', '$http', function ($rootScope, $http) {
        var service = {};
        service.getAssetChildren = function (login, callback) {
            var url = 'api/asset-childs/';
            if (login != null) {
                url = url + login
            }
            $http.get(url).then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsByGeofenceId', AssetsByGeofenceId);

    AssetsByGeofenceId.$inject = ['$resource'];

    function AssetsByGeofenceId($resource) {
        var resourceUrl = 'api/geofence-assets/:geofenceId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsGeofenceMapping', AssetsGeofenceMapping);

    AssetsGeofenceMapping.$inject = ['$resource'];

    function AssetsGeofenceMapping($resource) {
        var resourceUrl = 'api/asset-geofence-mapping/:geofenceId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AssetsBulkDelete', AssetsBulkDelete);

    AssetsBulkDelete.$inject = ['$resource'];

    function AssetsBulkDelete($resource) {
        var resourceUrl = 'api/assets/bulk/delete';

        return $resource(resourceUrl, {
            'save': {
                method: 'POST'
            }
        });
    }
})();


(function () {
    'use strict';
    angular.module('trakeyeApp').factory('FixedAssetExcelUpload', AssetExcelUpload);

    AssetExcelUpload.$inject = ['$http'];

    function AssetExcelUpload($http) {

        var service = {};
        service.assetupload = function (routeId,data, callback) {

            $http.post('api/importFixedAssetsFromExcelNew/'+routeId, data, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {
                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

        return service;
    }

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('SpreadAssetExcelUpload', AssetExcelUpload);

    AssetExcelUpload.$inject = ['$http'];

    function AssetExcelUpload($http) {

        var service = {};
        service.assetupload = function (data, callback) {

            $http.post('api/importSpreadAssetsFromExcel', data, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {
                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

        return service;
    }

})();


(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetViewES', ['$http', function ($http) {

        var service = {};
        service.getAssets = function (data, callback) {
            $http.post("api/assets-view-es", data)
            .then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetDemographicList', ['$http', function ($http) {

        var service = {};
        service.getList = function (data, callback) {
            $http.post("api/tr-routes/view-list", data)
            .then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

// (function () {
//     'use strict';

//     angular.module('trakeyeApp').factory('AssetFixedGroupES', ['$rootScope', '$http', function ($rootScope, $http) {

//         var service = {};
//         service.get = function (geofenceId, lastid, callback) {
//             $http.get('api/assets-fixed-group-es/' + geofenceId + "/" + lastid).then(function (response) {
//                 callback(response.data);
//             });
//         };

//         return service;
//     }]);
// })();

// (function () {
//     'use strict';

//     angular.module('trakeyeApp').factory('AssetSpreadGroupES', ['$rootScope', '$http', function ($rootScope, $http) {

//         var service = {};
//         service.get = function (geofenceId, lastid, callback) {
//             $http.get('api/assets-spread-group-es/' + geofenceId + "/" + lastid).then(function (response) {
//                 callback(response.data);
//             });
//         };

//         return service;
//     }]);
// })();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetController", AssetController)

        .directive("fileModel", [
            "$parse",
            function ($parse) {
                return {
                    restrict: "A",
                    link: function (
                        scope,
                        element,
                        attrs,
                        $rootScope,
                        $broadcast
                    ) {
                        var model = $parse(attrs.fileModel);
                        var modelSetter = model.assign;

                        element.bind("change", function () {
                            var files = element[0].files;
                            var allowedTypes = {
                                "image/png": true,
                                "image/jpg": true,
                                "image/jpeg": true,
                            };

                            var data = {
                                file: files,
                                types: allowedTypes,
                            };
                            scope.$emit("callFunction", data);
                            //uploadFiles("reference", allowedTypes,files);
                        });
                    },
                };
            },
        ])

        .directive("fileStyle", function () {
            return {
                link: function (scope, element) {
                    $(element).filestyle({
                        buttonBefore: true,
                    });
                    $(element).filestyle("buttonText", "Browse File");
                },
            };
        });

    AssetController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "pagingParams",
        "paginationConstants",
        "ParseLinks",
        "AssetTypesByGeofenceID",
        "UserGeofences",
        "GeofenceIDs",
        "AssetGroup",
        "AssetGroupSearch",
        "AssetDB",
        "AssetByID",
        "UserAccount",
        "AssetsBulkDelete",
        "AssetGroupWithGeofence",
        "AssetGroupSearchWithGeofence",
        "AssetType",
        "AlertService",
        "Asset",
        "AllCustomAssetTypeAttribute",
        "UserMasterGeofences",
        "GeofenceByID",
        "MiniGeofencesByMasterID",
        "AssetTypesByGeofenceIDs",
        "AssetGroupByGeofencesDB",
        "$localStorage",
        "Configs",
        "casesInMap",
        "CaseType",
        "EntityImport",
        "$timeout",
        "ChildAssetMarkers",
        "AssetByMarkerId",
        "WorkOrderLastLocation"
    ];

    function AssetController(
        $scope,
        $rootScope,
        $state,
        pagingParams,
        paginationConstants,
        ParseLinks,
        AssetTypesByGeofenceID,
        UserGeofences,
        GeofenceIDs,
        AssetGroup,
        AssetGroupSearch,
        AssetDB,
        AssetByID,
        UserAccount,
        AssetsBulkDelete,
        AssetGroupWithGeofence,
        AssetGroupSearchWithGeofence,
        AssetType,
        AlertService,
        Asset,
        AllCustomAssetTypeAttribute,
        UserMasterGeofences,
        GeofenceByID,
        MiniGeofencesByMasterID,
        AssetTypesByGeofenceIDs,
        AssetGroupByGeofencesDB,
        $localStorage,
        Configs,
        casesInMap,
        CaseType,
        EntityImport,
        $timeout,
        ChildAssetMarkers,
        AssetByMarkerId,
        WorkOrderLastLocation
    ) {
        var vm = this;
        $scope.tab = 1;
        vm.selectedListGeofenceId = parseInt(pagingParams.listgeofenceid);
        if (isNaN(vm.selectedListGeofenceId)) {
            vm.selectedListGeofenceId = 0;
        }
        $scope.search = pagingParams.search;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.masterGeofenceData = {};
        $("#pagenum").val(pagingParams.page + "");
        if (pagingParams.pagesize != null) {
            vm.itemsPerPage = pagingParams.pagesize;
            //Get select object
            var objSelect = document.getElementById("page_size");

            //Set selected
            setSelectedValue(objSelect, vm.itemsPerPage);
        }
        vm.filterAssetTypes = [];
        vm.filterAssetTypesCity = [];
        vm.assetToEdit = {};
        vm.transition = transition;
        vm.goToPage = goToPage;
        vm.filterAssetsOnListView = filterAssetsOnListView;
        vm.imageUpload = imageUpload;
        vm.showAssetImage = false;
        var nearbyAgentsMarkers = [];
        vm.userGeofences = [];
        vm.userGeofencesCity = [];
        vm.userGeofencesCityAmc = [];
        vm.geofencesListView = [];
        vm.selectedMapGeofenceId = null;
        vm.prevSelectedGeofenceId = null;
        vm.selectedMapGeofenceIds = [];
        vm.prevSelectedMapGeofenceIds = [];
        vm.editAssetOnMapView = editAssetOnMapView;
        vm.editAssetMarker = editAssetMarker;
        vm.closeEditAssetModal = closeEditAssetModal;
        vm.showAssetMarkerDetails = showAssetMarkerDetails;
        vm.saveEditMarkerAssetModal = saveEditMarkerAssetModal;
        vm.editAssetMarkerOnMapView = editAssetMarkerOnMapView;
        vm.closeEditAssetMarkerModal = closeEditAssetMarkerModal;
        vm.saveEditAssetModal = saveEditAssetModal;
        vm.viewAssetMarkerOnMapView = viewAssetMarkerOnMapView;
        vm.closeViewAssetMarkerModal = closeViewAssetMarkerModal;
        vm.getAssetsForListView = getAssetsForListView;
        vm.filterAssetsOnMapView = filterAssetsOnMapView;
        vm.filterAssetsOnMapViewCity = filterAssetsOnMapViewCity;
        vm.closeMapFilterModal = closeMapFilterModal;
        vm.closeMapFilterModalCity = closeMapFilterModalCity;
        vm.closeImageUpload = closeImageUpload;
        vm.closeListFilterModal = closeListFilterModal;
        vm.saveListFilter = saveListFilter;
        vm.saveAssetTypeFilter = saveAssetTypeFilter;
        vm.saveAssetTypeFilterCity = saveAssetTypeFilterCity;
        vm.saveAssetTypeFilterCityAmc = saveAssetTypeFilterCityAmc;
        vm.createAsset = createAsset;
        vm.saveFilter = saveFilter;
        vm.saveFilterCity = saveFilterCity;
        vm.saveFilterCityAmc = saveFilterCityAmc;
        vm.selectAllAssets = selectAllAssets;
        vm.selectAssetEntity = selectAssetEntity;
        vm.selectAsets = selectAsets;
        vm.gotoLatitute = gotoLatitute;
        vm.gotoLatituteCity = gotoLatituteCity;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.closeGotoLatituteCity = closeGotoLatituteCity;
        vm.showLayers = showLayers;
        vm.showLayersCity = showLayersCity;
        vm.closeLayers = closeLayers;
        vm.showZoomLocation = showZoomLocation;
        vm.showAssetAttributesModal = showAssetAttributesModal;
        vm.closeAssetAttributesModal = closeAssetAttributesModal;
        vm.closeThreePointReference = closeThreePointReference;
        vm.confirmDelete = confirmDelete;
        vm.saveImage = saveImage;
        vm.customAttributesMap = {};
        vm.zoomLevel = 12;
        vm.zoomLevelCity = 8;
        vm.userMasterGeofences = [];
        vm.previousPolygons = [];

        vm.assetMarkerTable = assetMarkerTable;

        //measure tool
        var measureEnabled = false
        var polyMeasureTool, segmentDistance, midpoint
        var totalDistance = 0
        var distanceMarkers = []
        var totalDistanceMarkers = []
        var pointerMarkers = []
        var arrpolyMeasureTool = []
        var measureTool = document.createElement("button");
        var measureToolIcon = document.createElement("i");
        vm.storeTempPolygon = []
        var gotoMarker = null;
        var isLevel1AssetsVisible = false;
        var isLevel2AssetsVisible = false;
        var isLevel3AssetsVisible = false;
        var isLevel4AssetsVisible = false;
        var isLevel5AssetsVisible = false;
        var isLevelNodeVisible = false;
        var assetVisibility19 = false;
        var assetVisibility20 = false;

        var isLevel1AssetsVisibleCity = true;
        var isLevel2AssetsVisibleCity = true;
        var isLevel3AssetsVisibleCity = true;
        var isLevel4AssetsVisibleCity = true;
        var isLevel5AssetsVisibleCity = true;

        var isLevel1AssetsVisibleCityAmc = true;
        var isLevel2AssetsVisibleCityAmc = true;
        var isLevel3AssetsVisibleCityAmc = true;
        var isLevel4AssetsVisibleCityAmc = true;
        var isLevel5AssetsVisibleCityAmc = true;

        vm.zoom13 = false;
        vm.zoom14 = false;
        vm.zoomLabel18 = false;
        vm.zoomLabel19 = false;
        vm.zoomLabel20 = false;
        vm.fileWarning = false;

        var nodeCluster, existingHighlight, existingHighlightFixed;
        var nodeMarkers = [];
        var nodePolyline = [];

        var level1AssetsMarkers = [];
        var level2AssetsMarkers = [];
        var level3AssetsMarkers = [];
        var level4AssetsMarkers = [];
        var level5AssetsMarkers = [];
        var level6AssetsMarkers = [];
        var level7AssetsMarkers = [];

        var level1AssetsMarkersCity = [];
        var level2AssetsMarkersCity = [];
        var level3AssetsMarkersCity = [];
        var level4AssetsMarkersCity = [];
        var level5AssetsMarkersCity = [];

        var level1AssetsMarkersCityAmc = [];
        var level2AssetsMarkersCityAmc = [];
        var level3AssetsMarkersCityAmc = [];
        var level4AssetsMarkersCityAmc = [];
        var level5AssetsMarkersCityAmc = [];

        var level1AssetsPolyline = [];
        var level2AssetsPolyline = [];
        var level3AssetsPolyline = [];
        var level4AssetsPolyline = [];
        var level5AssetsPolyline = [];

        var level1AssetsPolylineCity = [];
        var level2AssetsPolylineCity = [];
        var level3AssetsPolylineCity = [];
        var level4AssetsPolylineCity = [];
        var level5AssetsPolylineCity = [];

        var level1AssetsPolylineCityAmc = [];
        var level2AssetsPolylineCityAmc = [];
        var level3AssetsPolylineCityAmc = [];
        var level4AssetsPolylineCityAmc = [];
        var level5AssetsPolylineCityAmc = [];

        vm.isAllAssetSelected = false;
        // vm.isShowing = true;
        $scope.selectAll = false;
        $scope.options = [];
        vm.assetTypeValues = [];
        vm.assetTypeValuesCity = [];
        $scope.selectedFilterAssetTypes = [];
        $scope.selectedFilterAssetTypesCity = [];
        var locations = {};
        var locationsCity = {};
        var locationsCityAmc = {};
        var latlng = null;
        var openedInfoWindow = null;
        var prevInfoWindow = null;

        var markers = [];
        var markersCity = [];
        var markersCityAmc = [];
        var polylines = [];
        var polylinesCity = [];
        var polylinesCityAmc = [];
        var noDataText = null;
        vm.mapAssets = [];
        vm.mapAssetsCity = [];
        vm.mapAssetsCityAmc = [];

        vm.selectedAssets = [];
        vm.isAllAssetSelected = false;
        var tempGeofenceId = null,
            caseMarker = [],
            lastOpenedInfoWindow,
            caseTypeIds;

        vm.selectedMasterGeofenceId = 0;

        $scope.bool = true;
        $scope.boolCity = true;

        vm.currentZoom = 12;
        vm.currentZoomCity = 12;

        vm.getCenter;
        vm.getCenterCity;
        var infowindowSearchCity;
        var infowindowSearch;
        var activeInfo;
        var activeInfoCity;
        var activeInfoCityAmc;
        var spreadPoly;
        var spreadPolyCity;
        var spreadPolyCityAmc;
        var assetTimer;
        var polylineTimer;
        var assetTimerCity;
        var assetTimerCityAmc;
        var polylineTimerCity;
        var polylineTimerCityAmc
        var closeClick, tempList;
        $scope.hidethis = true;
        vm.closeModal = closeModal;
        vm.saveAttachments = saveAttachments;
        var filesSelected,
            accessEditAsset = false;
        vm.importxlsx = /^(.*?)\.(csv)$/;

        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        $scope.$on("callFunction", function (event, data) {
            // Call the function in this controller
            uploadFiles(
                "reference",
                data.types,
                data.file,
                event.targetScope.attribute.id
            );
        });

        var maxSize;
        Configs.get("MaxFileSize", function (response) {
            maxSize = response[0].configValue;
        });

        vm.isAssetImport = false
        Configs.get("Features", function (response) {
            response.forEach(function (val) {
                if (val.configKey == "IsNewAssetImport" && val.configValue == "True") {
                    vm.isAssetImport = true
                }
            })
        });

        function uploadFiles(id, allowedTypes, fileReference, referenceId) {
            filesSelected = fileReference;
            for (var i = 0; i < filesSelected.length; i++) {
                if (
                    allowedTypes[filesSelected[i].type] &&
                    filesSelected[i].size <= maxSize
                ) {
                    if (id == "reference") {
                        vm.assetRefAttributes.forEach(function (val) {
                            if (val.id == referenceId) {
                                var fileReader_reference = new FileReader();
                                fileReader_reference.onload = function (
                                    fileLoadedEvent
                                ) {
                                    val.attributeValue = window.btoa(
                                        fileLoadedEvent.target.result
                                    );
                                    val.attributeName = fileLoadedEvent.target.name;
                                    val.attributeType = fileLoadedEvent.target.type;
                                };
                                fileReader_reference.name = filesSelected[i].name.split(".")[0];
                                fileReader_reference.type = filesSelected[i].type
                                    .split("/")[1]
                                    .toUpperCase();
                                fileReader_reference.readAsBinaryString(
                                    filesSelected[i]
                                );
                            }
                        });
                    }
                }
            }
        }

        $scope.geofencelabel = {
            search: "Search",
            nothingSelected: "Block",
        };

        $scope.type = {
            assetTypeLabel: {
                search: "Search",
                nothingSelected: "Asset Type",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            },
            caseTypeLabel: {
                search: "Search",
                nothingSelected: "Incident Type",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            },
        };

        $scope.GeofenceCity = {
            search: "Search",
            nothingSelected: "Block",
            selectAll: "All",
            selectNone: "None",
            Done: "Done",
        };

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.centerCapture = function () {
            vm.getCenterCity = locationsCity.mapCity.center;
            vm.currentZoomCity = locationsCity.mapCity.getZoom();
        };

        $scope.centerCaptureAmc = function () {
            vm.getCenterCityAmc = locationsCityAmc.mapCity.center;
            vm.currentZoomCityAmc = locationsCityAmc.mapCity.getZoom();
        };
        // $scope.search = null;

        function createAsset() {
            sessionStorage.setItem("pageValue", "asset");
            $state.go("asset.new");
        }

        $(".select2").select2();
        function setSelectedValue(selectObj, valueToSet) {
            for (var i = 0; i < selectObj.options.length; i++) {
                if (selectObj.options[i].text == valueToSet) {
                    selectObj.options[i].selected = true;
                    return;
                }
            }
        }

        $scope.toggle = function () {
            $scope.allimages = true;
        };

        $scope.deleteDisplayImage = function (id) {
            vm.assetAttachments.assetImages.splice(id, 1);
            if (vm.assetAttachments.assetImages.length == 0) {
                filesSelected = null;
                $(":file").filestyle("clear");
            }
        };

        $("#assetImages").change(function () {
            filesSelected = document.getElementById("assetImages").files;
            for (var i = 0; i < filesSelected.length; i++) {
                if (
                    (filesSelected[i].type == "image/png" ||
                        filesSelected[i].type == "image/jpg" ||
                        filesSelected[i].type == "image/jpeg" ||
                        filesSelected[i].type == "application/pdf") &&
                    filesSelected[i].size <= 2621440
                ) {
                    vm.fileWarning = false;
                    var fileReader = new FileReader();
                    /* var name = filesSelected[i].name.split('.')[0]
                        var type = filesSelected[i].name.split('.')[1] */
                    fileReader.onload = function (fileLoadedEvent) {
                        vm.assetAttachments.assetImages.push({
                            image: window.btoa(fileLoadedEvent.target.result),
                            asset: {
                                id: vm.assetIdImg,
                            },
                            imageName: fileLoadedEvent.target.name,
                            imageType: fileLoadedEvent.target.type,
                        });
                    };
                    fileReader.name = filesSelected[i].name.split(".")[0];
                    fileReader.type = filesSelected[i].type
                        .split("/")[1]
                        .toUpperCase();
                    fileReader.readAsBinaryString(filesSelected[i]);
                } else {
                    filesSelected = null;
                    vm.fileWarning = true;
                }
            }
        });


        function saveAttachments() {
            if (filesSelected) {
                Asset.update(
                    vm.assetAttachments,
                    function () {
                        $("#modalAttachment").hide();
                        $(":file").filestyle("clear");
                        $scope.allimages = false;
                    },
                    function () { }
                );
            }
        }

        /* function onSuccess(){
            
        }

        function onError(e){
            console.error(e)
        } */

        function imageUpload(id) {
            vm.assetId = id;
            $("#myModalUpload").show();
        }

        function saveImage() {
            var photo = document.getElementById("assetImages").files[0]; // file from input
            var req = new XMLHttpRequest();
            var formData = new FormData();
            if (photo) {
                if (
                    photo.type == "image/png" ||
                    photo.type == "image/jpg" ||
                    photo.type == "image/jpeg" ||
                    photo.type == "application/pdf"
                ) {
                    var name = photo.name.split(".")[0];
                    var type = photo.name.split(".")[1].toUpperCase();
                    vm.fileWarning = false;
                    formData.append("file", photo);
                    req.open(
                        "POST",
                        "api/trakeyeassetimages/" +
                        vm.assetId.id +
                        "/" +
                        name +
                        "/" +
                        type
                    );
                    req.setRequestHeader(
                        "Authorization",
                        "Bearer " + $localStorage.authenticationToken
                    );
                    req.onload = function (e) {
                        if (this.status === 200) {
                            closeImageUpload();
                            $("#successImage").show();
                        } else {
                            closeImageUpload();
                            $("#errorImage").show();
                        }
                    };
                    req.send(formData);
                } else {
                    vm.fileWarning = true;
                }
            }
        }


        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    },
                ],
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);

            /* var zoomLabel = document.createElement("span");
            zoomLabel.setAttribute("title", "Zoom");
            zoomLabel.classList.add("custom-map-control-button");
            var textnode = document.createTextNode("Zoom :"+vm.zoomLevel);
            zoomLabel.appendChild(textnode);
            map.controls[google.maps.ControlPosition.LEFT_TOP].push(
                zoomLabel
            );  */

            goTo.addEventListener("click", function () {
                gotoLatitute();
            });


            measureTool = document.createElement("button");
            measureTool.setAttribute("title", "Measure Distance");
            measureTool.classList.add("custom-map-control-button");
            measureTool.id = "measureDistance";
            measureToolIcon.classList.add("fa");
            measureToolIcon.classList.add("fa-arrows-h");
            measureToolIcon.classList.add("ruler");
            measureTool.appendChild(measureToolIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(measureTool);
            measureTool.addEventListener("click", function () {

                if (measureEnabled) {
                    google.maps.event.removeListener(vm.clickListener);

                    totalDistance = 0
                    clearMeasureTool(distanceMarkers)
                    clearMeasureTool(pointerMarkers)
                    clearMeasureTool(arrpolyMeasureTool)
                    clearMeasureTool(totalDistanceMarkers)
                    distanceMarkers = []
                    totalDistanceMarkers = []
                    pointerMarkers = []
                    arrpolyMeasureTool = []


                    measureEnabled = false

                    measureTool.setAttribute("title", "Measure Distance");
                    measureToolIcon.classList.remove("fa-times");
                    measureToolIcon.classList.add("fa-arrows-h");


                } else {
                    measureEnabled = true
                    polyMeasureTool = new google.maps.Polyline({
                        strokeColor: 'black',
                        strokeOpacity: 1.0,
                        strokeWeight: 3
                    });
                    polyMeasureTool.setMap(map);
                    arrpolyMeasureTool.push(polyMeasureTool)

                    vm.clickListener = map.addListener('click', function (event) {
                        addLatLng(event, map)
                    });


                    measureTool.setAttribute("title", "Clear Distance");
                    measureToolIcon.classList.remove("fa-arrows-h");
                    measureToolIcon.classList.add("fa-times");
                }
            });

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };

                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            // var image = {
                            //     url: "content/images/geoLocation.png", // url
                            //     scaledSize: new google.maps.Size(25, 25), // scaled size
                            //     origin: new google.maps.Point(0, 0), // origin
                            //     anchor: new google.maps.Point(0, 0), // anchor
                            // };
                            // var markerGeo = new google.maps.Marker({
                            //     position: pos,
                            //     icon: image,
                            // });
                            // map.setZoom(20);
                            // markerGeo.setMap(map);
                            map.setZoom(18);
                            map.setCenter(pos);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        if ($scope.tab == 1) {
            UserAccount.get(function (data) {
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if (val == "ROLE_READONLY") {
                        vm.has_ROLE_READONLY = true
                    }
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }

                    if (
                        val == "ROLE_USER_ADMIN" ||
                        val == "ROLE_CITY_PLANNER"
                    ) {
                        accessEditAsset = true;
                    }
                });
                if (isAdmin) {
                    vm.adminFilter = true;
                    filterAssetsOnListView();
                    getAssetsForListView();
                } else {
                    vm.adminFilter = false;
                    filterAssetsOnListView();
                    getAssetsForListView();
                }
            });
            Configs.get("AssetImage", function (response) {
                if (response.length > 0) {
                    if (response[0].configValue == "True") {
                        vm.showAssetImage = true;
                    }
                }
            });

            AllCustomAssetTypeAttribute.getAll(function (response) {
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customAssetTypeAttributeValues;
                });
            });
            AssetType.query(
                {
                    page: 0,
                    size: 100,
                    sort: sort(),
                },
                onSuccess,
                onError
            );
            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    //  result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.assetTypes = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        $scope.setTab = function (newTab) {
            $scope.search = null;
            $scope.tab = newTab;
            if ($scope.tab == 1) {
                if (tempGeofenceId) {
                    vm.selectedListGeofenceId = tempGeofenceId;
                    getAssetsForListView();
                    vm.geofencesListView.forEach(function (item) {
                        if (item.id == vm.selectedListGeofenceId) {
                            item.ticked = true;
                        } else {
                            item.ticked = false;
                        }
                    });
                }

                /* getAssetsForListView();
                filterAssetsOnListView()
                vm.selectedMapGeofenceId = null;
                vm.userGeofences.forEach(function (value) {
                    if (vm.selectedMapGeofenceId == null) {
                        vm.selectedMapGeofenceId = value.id;
                    }
                }); */
            } else if ($scope.tab == 2) {
                CaseType.query(
                    {
                        page: 0,
                        size: 100,
                        sort: "update_date,desc",
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(data) {
                    vm.caseType = data;
                    caseTypeIds = data
                        .filter(function (item) {
                            return item.showInAssetsView;
                        })
                        .map(function (item) {
                            return item.id;
                        });
                }
                function onError(error) {
                    console.error(error);
                }
                //vm.selectedGeofence.length=0
                vm.mapAssets = [];
                vm.mapAssetsCity = [];
                /* AssetTypesByGeofenceID.get(
                    vm.selectedMapGeofenceId,
                    function (assetTypeVal) {
                        vm.assetTypeValues = assetTypeVal;
                        getGroupAssetsFromES(
                            vm.selectedMapGeofenceId,
                            null,
                            vm.mapAssets
                        );
                    }
                );*/
                document.getElementById("myspan").textContent = " ";
                /*  var myOptions = {
                    zoom: 12,
                    center: new google.maps.LatLng(
                        $rootScope.DEFAULT_LATITUDE,
                        $rootScope.DEFAULT_LONGITUDE
                    ),
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(
                        12,
                        new google.maps.LatLng(
                            $rootScope.DEFAULT_LATITUDE,
                            $rootScope.DEFAULT_LONGITUDE
                        )
                    )
                );
                geoLocation(locations.map);
                filterAssetsOnMapView();
                if (tempGeofenceId) {
                    vm.selectedMapGeofenceId = tempGeofenceId;
                    saveFilter();
                }
                var input = document.getElementById("field_pinLat");
                input.value = "";
            } else if ($scope.tab == 3) {
                vm.userGeofencesCity.length = 0;
                vm.mapAssets = [];
                vm.userMasterGeofences = [];
                vm.masterGeofence = "";
                UserMasterGeofences.getAll(function (response) {
                    vm.userMasterGeofences = response;
                });
                vm.mapAssetsCity = [];
                document.getElementById("myspanCity").textContent = " ";
                /* var myOptions = {
                    zoom: vm.zoomLevelCity,
                    center: new google.maps.LatLng(
                        $rootScope.DEFAULT_LATITUDE,
                        $rootScope.DEFAULT_LONGITUDE
                    ),
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locationsCity.mapCity = new google.maps.Map(
                    document.getElementById("map_canva"),
                    myOption(
                        12,
                        new google.maps.LatLng(
                            $rootScope.DEFAULT_LATITUDE,
                            $rootScope.DEFAULT_LONGITUDE
                        )
                    )
                );
                geoLocation(locationsCity.mapCity);
                var input = document.getElementById("field_pinLat");
                input.value = "";
            } else if ($scope.tab == 4) {
                vm.userGeofencesCityAmc.length = 0;
                vm.mapAssetsAmc = [];
                vm.userMasterGeofencesAmc = [];
                vm.masterGeofenceAmc = "";
                UserMasterGeofences.getAll(function (response) {
                    vm.userMasterGeofencesAmc = response;
                });
                vm.mapAssetsCityAmc = [];
                document.getElementById("myspanCityAmc").textContent = " ";

                locationsCityAmc.mapCity = new google.maps.Map(
                    document.getElementById("map_canvas_amc"),
                    myOption(
                        12,
                        new google.maps.LatLng(
                            $rootScope.DEFAULT_LATITUDE,
                            $rootScope.DEFAULT_LONGITUDE
                        )
                    )
                );
                geoLocation(locationsCityAmc.mapCity);
                var input = document.getElementById("field_pinLat");
                input.value = "";
            }
        };

        $("#masterGeofence").on("change", function () {
            $scope.searchAssetCity = "";
            vm.mapAssetsCity = [];
            vm.userGeofencesCity = [];
            var value = $(this).val();
            vm.selectedMasterGeofenceId = value;
            GeofenceByID.get(value, function (geofenceDetails) {
                var points = JSON.parse(geofenceDetails.coordinates);
                locationsCity.latlng = {
                    lat: points[0].lat,
                    lng: points[0].lng,
                };
                /* var myOptions = {
                    zoom: 10,
                    center: locationsCity.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locationsCity.mapCity = new google.maps.Map(
                    document.getElementById("map_canva"),
                    myOption(8, locationsCity.latlng)
                );
                geoLocation(locationsCity.mapCity);
                drawPolygon(
                    geofenceDetails,
                    locationsCity.latlng,
                    "#fd7a24",
                    1,
                    false
                );
                vm.selectedMapGeofenceIds = [];
                MiniGeofencesByMasterID.get(
                    geofenceDetails.id,
                    function (response) {
                        if (response.length > 0) {
                            mapZoomChangeCity(locationsCity.mapCity);
                        } else {
                            document.getElementById("myspanCity").textContent =
                                "";
                        }
                        vm.userGeofencesCity = [];
                        response.forEach(function (value, index) {
                            value.ticked = true;
                            $scope.selectAll = true;
                            $scope.options[index] = true;
                            value.label = value.name.substring(0, 15);
                            vm.userGeofencesCity.push(value);
                            vm.selectedMapGeofenceIds.push(value.id);
                            vm.previousPolygons.push(
                                drawPolygon(
                                    value,
                                    locationsCity.latlng,
                                    "#00e658",
                                    2,
                                    false
                                )
                            );
                        });
                        AssetTypesByGeofenceIDs.get(
                            {
                                geofences: vm.selectedMapGeofenceIds,
                            },
                            function (assetTypeVal) {
                                vm.storeAssetTypeName = []
                                vm.assetTypeValuesCity = assetTypeVal;
                                vm.filterAssetTypesCity = [];

                                assetTypeVal.forEach(function (assettype) {
                                    vm.filterAssetTypesCity.push({
                                        id: assettype.id,
                                        name: assettype.assetTypeName,
                                        ticked: false,
                                    });
                                });
                                $scope.selectedFilterAssetTypesCity = [];
                                for (
                                    var i = 0;
                                    i < vm.filterAssetTypesCity.length;
                                    i++
                                ) {
                                    if (
                                        vm.filterAssetTypesCity[i].name ==
                                        "KML Link" ||
                                        vm.filterAssetTypesCity[i].name ==
                                        "Optical Fiber Cable"
                                    ) {
                                        vm.storeAssetTypeName.push(vm.filterAssetTypesCity[i].name)
                                        $scope.selectedFilterAssetTypesCity.push(
                                            vm.filterAssetTypesCity[i]
                                        );
                                        vm.filterAssetTypesCity[
                                            i
                                        ].ticked = true;
                                    } else {
                                        vm.filterAssetTypesCity[
                                            i
                                        ].ticked = false;
                                    }
                                }
                                var assetLayersbyCity = [];
                                vm.mapAssetsCity = [];
                                $scope.selectedFilterAssetTypesCity.forEach(
                                    function (item) {
                                        assetLayersbyCity.push(item.name);
                                    }
                                );

                                if (vm.storeAssetTypeName.includes("Optical Fiber Cable") || vm.storeAssetTypeName.includes("KML Link")) {
                                    getGroupAssetsFromESCity(
                                        vm.selectedMapGeofenceIds,
                                        null,
                                        vm.mapAssetsCity,
                                        assetLayersbyCity
                                    );
                                }
                            }
                        );
                    }
                );
            });
        });

        $("#masterGeofenceAmc").on("change", function () {
            $scope.searchAssetCityAmc = "";
            vm.mapAssetsCityAmc = [];
            vm.userGeofencesCityAmc = [];
            var value = $(this).val();
            vm.selectedMasterGeofenceId = value;
            GeofenceByID.get(value, function (geofenceDetails) {
                var points = JSON.parse(geofenceDetails.coordinates);
                locationsCityAmc.latlng = {
                    lat: points[0].lat,
                    lng: points[0].lng,
                };
                /* var myOptions = {
                    zoom: 10,
                    center: locationsCity.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locationsCityAmc.mapCity = new google.maps.Map(
                    document.getElementById("map_canvas_amc"),
                    myOption(8, locationsCityAmc.latlng)
                );
                geoLocation(locationsCityAmc.mapCity);
                GeofenceByID.get(
                    vm.selectedMasterGeofenceId,
                    function (geofenceDetails) {
                        vm.masterGeofenceData = parsePolygonFromGeofence(geofenceDetails);
                        drawPolygonAmc(
                            geofenceDetails,
                            locationsCityAmc.latlng,
                            "red",
                            1,
                            false
                        );
                    }
                );

                vm.selectedMapGeofenceIds = [];
                MiniGeofencesByMasterID.get(
                    geofenceDetails.id,
                    function (response) {
                        if (response.length > 0) {
                            mapZoomChangeCityAmc(locationsCityAmc.mapCity);
                        } else {
                            document.getElementById("myspanCityAmc").textContent =
                                "";
                        }
                        vm.userGeofencesCityAmc = [];
                        response.forEach(function (value, index) {
                            value.ticked = true;
                            $scope.selectAll = true;
                            $scope.options[index] = true;
                            value.label = value.name.substring(0, 15);
                            vm.userGeofencesCityAmc.push(value);
                            vm.selectedMapGeofenceIds.push(value.id);
                            vm.previousPolygons.push(
                                drawPolygonAmc(
                                    value,
                                    locationsCityAmc.latlng,
                                    "green",
                                    2,
                                    false
                                )
                            );
                        });
                        AssetTypesByGeofenceIDs.get(
                            {
                                geofences: vm.selectedMapGeofenceIds,
                            },
                            function (assetTypeVal) {
                                vm.storeAssetTypeName = []
                                vm.assetTypeValuesCityAmc = assetTypeVal;
                                vm.filterAssetTypesCityAmc = [];

                                assetTypeVal.forEach(function (assettype) {
                                    vm.filterAssetTypesCityAmc.push({
                                        id: assettype.id,
                                        name: assettype.assetTypeName,
                                        layout: assettype.assetTypeLayout,
                                        ticked: false,
                                    });
                                });
                                $scope.selectedFilterAssetTypesCityAmc = [];
                                for (var i = 0; i < vm.filterAssetTypesCityAmc.length; i++) {
                                    if (
                                        vm.filterAssetTypesCityAmc[i].name == "GP" ||
                                        vm.filterAssetTypesCityAmc[i].name == "ONT" || vm.filterAssetTypesCityAmc[i].layout == "SPREAD"
                                    ) {
                                        $scope.selectedFilterAssetTypesCityAmc.push(
                                            vm.filterAssetTypesCityAmc[i]
                                        );
                                        vm.filterAssetTypesCityAmc[i].ticked = true;
                                    } else {
                                        vm.filterAssetTypesCityAmc[i].ticked = false;
                                    }
                                }
                                var assetLayersbyCityAmc = [];
                                vm.mapAssetsCityAmc = [];
                                $scope.selectedFilterAssetTypesCityAmc.forEach(
                                    function (item) {
                                        assetLayersbyCityAmc.push(item.name);
                                    }
                                );

                                getGroupAssetsFromESCityAmc(
                                    vm.selectedMapGeofenceIds,
                                    null,
                                    vm.mapAssetsCityAmc,
                                    assetLayersbyCityAmc
                                );


                                WorkOrderLastLocation.getlastlogs(function (response) {
                                    var lastLocByAgents = response;
                                    var markerIcon = "inactive";
                                    var imageUrl = "";
                                    switch (markerIcon) {
                                        case "inactive":
                                            imageUrl = "content/images/marker_inactive.png";
                                            break;
                                        case "idle":
                                            imageUrl = "content/images/marker_idle.png";
                                            break;
                                        case "active":
                                            imageUrl = "content/images/marker_active.png";
                                            break;
                                        case "active_case":
                                            imageUrl = "content/images/marker_active_case.png";
                                            break;
                                        default:
                                            imageUrl = "content/images/green.png";
                                            break;
                                    }

                                    var lastLocVal = [];
                                    removeMarkers();
                                    for (var i = 0; i < lastLocByAgents.length; i++) {
                                        var path = lastLocByAgents[i].path;
                                        var isUserInside = false;
                                        var canCheck = true;
                                        if (path.length > 1) {
                                            var userPoint = { lat: path[0].lat, lng: path[0].lng };
                                            if (pointInPolygon(userPoint, vm.masterGeofenceData)) {
                                                isUserInside = true;
                                                canCheck = false;
                                            } else {
                                                isUserInside = false;
                                            }
                                            if (isUserInside) {
                                                var marker = new google.maps.Marker({
                                                    position: new google.maps.LatLng(path[0].lat, path[0].lng),
                                                    map: locationsCityAmc.mapCity,
                                                    icon: {
                                                        url: imageUrl,
                                                        scaledSize: new google.maps.Size(24, 32),
                                                        origin: new google.maps.Point(0, 0),
                                                        anchor: new google.maps.Point(12, 32), // center bottom of icon
                                                        labelOrigin: new google.maps.Point(12, 40) // move label below the icon
                                                    },
                                                    label: {
                                                        text: lastLocByAgents[i].userName,
                                                        color: "#2e2e2eff",
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                    },
                                                    title: lastLocByAgents[i].userName,
                                                });
                                                var infowindow = new google.maps.InfoWindow();
                                                google.maps.event.addListener(
                                                    marker,
                                                    "click",
                                                    function (event) {
                                                        console.log(lastLocByAgents[i]);
                                                        var markerContent =
                                                            '<div class="infoWindowhead">' +
                                                            '</div><div class="infoWindowContent"> ' +
                                                            '<br> <b> LatLng  : ' + event.latLng.lat() + "," + event.latLng.lng() + '</b> '
                                                        "</div>";
                                                        infowindow.setContent(markerContent);

                                                        infowindow.open(locationsCityAmc.mapCity);
                                                        infowindow.setPosition(event.latLng);
                                                    }
                                                );
                                                nearbyAgentsMarkers.push(marker);
                                            }
                                        }
                                    }
                                });
                            }
                        );
                    }
                );
            });

        });

        // --- helper: parse polygon from your geofence object ---
        function parsePolygonFromGeofence(geofence) {
            if (!geofence) return [];
            var coordsRaw = geofence.coordinates || geofence.coordinatesString || geofence.coordinatesJson;
            if (!coordsRaw) return [];
            var arr;
            try {
                // coordsRaw may already be an array or a JSON string (possibly escaped)
                if (typeof coordsRaw === 'string') {
                    // unescape if necessary (handles strings like "[{\"lat\":...}]")
                    try {
                        arr = JSON.parse(coordsRaw);
                    } catch (e) {
                        // attempt a safer replace of escaped quotes then parse
                        var cleaned = coordsRaw.replace(/\\"/g, '"');
                        arr = JSON.parse(cleaned);
                    }
                } else {
                    arr = coordsRaw;
                }
            } catch (e) {
                console.error('Failed to parse polygon coordinates:', e, coordsRaw);
                return [];
            }

            // Normalize to array of {lat: Number, lng: Number}
            var poly = [];
            for (var i = 0; i < arr.length; i++) {
                var p = arr[i];
                if (!p) continue;
                // If pair like [lng, lat] or [lat,lng]
                if (Array.isArray && Array.isArray(p)) {
                    // assume [lng, lat] is common; if wrong, swap indices
                    poly.push({ lat: Number(p[1]), lng: Number(p[0]) });
                } else if (typeof p === 'object') {
                    // handle both lat/lng and latitude/longitude keys
                    var lat = p.lat !== undefined ? p.lat : (p.latitude !== undefined ? p.latitude : null);
                    var lng = p.lng !== undefined ? p.lng : (p.longitude !== undefined ? p.longitude : null);
                    if (lat === null || lng === null) {
                        // try first two numeric properties
                        var keys = Object.keys(p);
                        var vals = [];
                        for (var k = 0; k < keys.length && vals.length < 2; k++) {
                            var v = p[keys[k]];
                            if (!isNaN(Number(v))) vals.push(Number(v));
                        }
                        if (vals.length === 2) {
                            poly.push({ lat: Number(vals[0]), lng: Number(vals[1]) });
                        }
                    } else {
                        poly.push({ lat: Number(lat), lng: Number(lng) });
                    }
                }
            }
            return poly;
        }

        // old-JS point-in-polygon using ray-casting
        function pointInPolygon(point, polygonRaw) {
            // Normalize polygon input
            var polygon;
            if (typeof polygonRaw === 'string') {
                try {
                    polygon = JSON.parse(polygonRaw);
                } catch (e) {
                    console.error('Invalid polygon JSON:', e);
                    return false;
                }
            } else {
                polygon = polygonRaw;
            }

            if (!polygon || polygon.length === 0) {
                return false;
            }

            // Convert polygon to array of {lat:..., lng:...}
            var poly = [];
            for (var i = 0; i < polygon.length; i++) {
                var p = polygon[i];
                if (Array.isArray && Array.isArray(p)) {
                    // [lng, lat] or [lat, lng] — assume [lng, lat] (common)
                    poly.push({ lat: Number(p[1]), lng: Number(p[0]) });
                } else if (p && typeof p === 'object') {
                    // object with lat/lng (or latitude/longitude)
                    if (p.lat !== undefined && p.lng !== undefined) {
                        poly.push({ lat: Number(p.lat), lng: Number(p.lng) });
                    } else if (p.latitude !== undefined && p.longitude !== undefined) {
                        poly.push({ lat: Number(p.latitude), lng: Number(p.longitude) });
                    } else {
                        // try to detect reversed names
                        var keys = Object.keys(p);
                        // fallback: try first two numeric properties
                        var vals = [];
                        for (var k = 0; k < keys.length && vals.length < 2; k++) {
                            var v = p[keys[k]];
                            if (!isNaN(Number(v))) vals.push(Number(v));
                        }
                        if (vals.length === 2) poly.push({ lat: vals[0], lng: vals[1] });
                    }
                } else {
                    // unknown format
                    console.warn('Unknown polygon point format at index', i, polygon[i]);
                }
            }

            var x = Number(point.lng), y = Number(point.lat);
            var inside = false;
            for (var j = 0, k = poly.length - 1; j < poly.length; k = j++) {
                var xi = Number(poly[j].lng), yi = Number(poly[j].lat);
                var xk = Number(poly[k].lng), yk = Number(poly[k].lat);

                var intersect = ((yi > y) !== (yk > y)) &&
                    (x < (xk - xi) * (y - yi) / (yk - yi + 0.0) + xi);
                if (intersect) inside = !inside;
            }
            return inside;
        }


        function drawTheAssetsCity() {
            vm.zoomLevelCity = locationsCity.mapCity.getZoom();

            if (vm.zoomLevelCity > 7) {
                var assetListCity = [];
                var chamberListCity = [];
                var couplerListCity = [];
                var poleListCity = [];
                var otherListCity = [];
                var handholeListCity = [];
                var jointClosureListCity = [];
                var SiteListCity = [];
                var handholeCHListCity = [];

                for (
                    var index = 0;
                    index < vm.assetTypeValuesCity.length;
                    index++
                ) {
                    if (
                        vm.zoomLevelCity >= 8 &&
                        vm.zoomLevelCity <= 14
                    ) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            assetListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 15) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            chamberListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 15) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            handholeListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 15) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            handholeCHListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 15) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            SiteListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 16) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            couplerListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 17) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            poleListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 16) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            jointClosureListCity.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCity[index].zoomLevel == 18) {
                        vm.assetTypeValuesCity[index].assets.forEach(function (
                            assetVal
                        ) {
                            otherListCity.push(assetVal);
                        });
                    }
                }
                drawLatestAssetsCity(assetListCity, "level1");

                drawAssetsCity(chamberListCity, "level2");
                drawAssetsCity(handholeListCity, "level2");
                drawAssetsCity(SiteListCity, "level2");

                drawAssetsCity(couplerListCity, "level3");

                drawAssetsCity(poleListCity, "level4");
                drawAssetsCity(jointClosureListCity, "level4");

                drawAssetsCity(otherListCity, "level5");
            }
        }

        function drawTheAssetsCityAmc() {
            vm.zoomLevelCityAmc = locationsCityAmc.mapCity.getZoom();

            if (vm.zoomLevelCityAmc > 7) {
                var assetListCityAmc = [];
                var chamberListCityAmc = [];
                var couplerListCityAmc = [];
                var poleListCityAmc = [];
                var otherListCityAmc = [];
                var handholeListCityAmc = [];
                var jointClosureListCityAmc = [];
                var SiteListCityAmc = [];
                var handholeCHListCityAmc = [];

                for (
                    var index = 0;
                    index < vm.assetTypeValuesCityAmc.length;
                    index++
                ) {
                    if (
                        vm.zoomLevelCityAmc >= 8 &&
                        vm.zoomLevelCityAmc <= 14
                    ) {
                        vm.assetTypeValuesCityAmc[index].assets.forEach(function (
                            assetVal
                        ) {
                            assetListCityAmc.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCityAmc[index].zoomLevel == 15) {
                        vm.assetTypeValuesCityAmc[index].assets.forEach(function (
                            assetVal
                        ) {
                            chamberListCityAmc.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCityAmc[index].zoomLevel == 15) {
                        vm.assetTypeValuesCityAmc[index].assets.forEach(function (
                            assetVal
                        ) {
                            handholeListCityAmc.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCityAmc[index].zoomLevel == 15) {
                        vm.assetTypeValuesCityAmc[index].assets.forEach(function (
                            assetVal
                        ) {
                            handholeCHListCityAmc.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCityAmc[index].zoomLevel == 15) {
                        vm.assetTypeValuesCityAmc[index].assets.forEach(function (
                            assetVal
                        ) {
                            SiteListCityAmc.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCityAmc[index].zoomLevel == 16) {
                        vm.assetTypeValuesCityAmc[index].assets.forEach(function (
                            assetVal
                        ) {
                            couplerListCityAmc.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCityAmc[index].zoomLevel == 17) {
                        vm.assetTypeValuesCityAmc[index].assets.forEach(function (
                            assetVal
                        ) {
                            poleListCityAmc.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCityAmc[index].zoomLevel == 16) {
                        vm.assetTypeValuesCityAmc[index].assets.forEach(function (
                            assetVal
                        ) {
                            jointClosureListCityAmc.push(assetVal);
                        });
                    }
                    if (vm.assetTypeValuesCityAmc[index].zoomLevel == 18) {
                        vm.assetTypeValuesCityAmc[index].assets.forEach(function (
                            assetVal
                        ) {
                            otherListCityAmc.push(assetVal);
                        });
                    }
                }
                drawLatestAssetsCityAmc(assetListCityAmc, "level1");

                drawAssetsCityAmc(chamberListCityAmc, "level2");
                drawAssetsCityAmc(handholeListCityAmc, "level2");
                drawAssetsCityAmc(SiteListCityAmc, "level2");

                drawAssetsCityAmc(couplerListCityAmc, "level3");

                drawAssetsCityAmc(poleListCityAmc, "level4");
                drawAssetsCityAmc(jointClosureListCityAmc, "level4");

                drawAssetsCityAmc(otherListCityAmc, "level5");
            }
        }

        $scope.toggleUserGeofences = function (index) {
            vm.userGeofencesCity[index].checked = !vm.userGeofencesCity[index]
                .checked;
            $scope.selectAll = true;
            vm.userGeofencesCity.forEach(function (value) {
                if (!value.checked) {
                    $scope.selectAll = false;
                }
            });
        };

        $scope.toggleAll = function () {
            var checked = $scope.selectAll;
            for (var i = 0; i < vm.userGeofencesCity.length; i++) {
                $scope.options[i] = checked;
                vm.userGeofencesCity[i].checked = checked;
            }
        };

        function drawPolygon(value, latlang, color, zIndex, canClick) {
            var path = JSON.parse(value.coordinates);
            // drawPolylineForGeoFence(path, locations.map, value.name);
            var infowindow = new google.maps.InfoWindow({
                content:
                    '<div class="infoWindowhead">' +
                    "name" +
                    '<div class="infoWindowContent"> <b>Description :</b> ' +
                    "des" +
                    "</div></div>",
            });

            infowindow.setPosition(latlang);
            var strokeColor = "#ff6a08";

            if (color == "green") {
                strokeColor = "#00e658";
            } else if (color == "blue") {
                strokeColor = "#0066CC";
            }

            var tempPolygon = new google.maps.Polygon({
                paths: path,
                strokeColor: strokeColor,
                strokeOpacity: 0.5,
                strokeWeight: 1.2,
                fillColor: strokeColor,
                fillOpacity: 0.1,
                zIndex: zIndex
            });
            // google.maps.event.addListener(
            //     tempPolygon,
            //     "mouseout",
            //     function (event) {
            //         infowindow.close();
            //     }
            // );


            // google.maps.event.addListener(
            //     tempPolygon,
            //     "click",
            //     function (event) {
            //         if (openedInfoWindow != null) {
            //             openedInfoWindow.close();
            //         }
            //         infowindow.setContent(
            //             '<div class="infoWindowhead">' +
            //                 "<b>Geofence Name : </b><br><br>" +
            //                 value.name +
            //                 "</br></div>"
            //         );

            //         infowindow.mousemove;
            //         infowindow.open(locationsCity.mapCity);
            //         infowindow.setPosition(event.latLng);
            //         openedInfoWindow = infowindow;

            //         //geoLocation(locationsCity.mapCity)
            //     }
            // );

            google.maps.event.addListener(tempPolygon, 'click', function (event) {
                var clickedLatLng = event.latLng;
                var isNearBorder = false;

                // Check each edge of the polygon to see if the click is near the border
                var paths = tempPolygon.getPath();
                for (var i = 0; i < paths.getLength(); i++) {
                    var start = paths.getAt(i);
                    var end = paths.getAt((i + 1) % paths.getLength());

                    // Calculate the distance between the clicked point and the polygon edge
                    var distanceToEdge = google.maps.geometry.spherical.computeDistanceBetween(clickedLatLng, start) +
                        google.maps.geometry.spherical.computeDistanceBetween(clickedLatLng, end) -
                        google.maps.geometry.spherical.computeDistanceBetween(start, end);

                    if (Math.abs(distanceToEdge) < 10) {  // Adjust this threshold (in meters)
                        isNearBorder = true;
                        break;
                    }
                }

                if (isNearBorder) {
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent(
                        '<div class="infoWindowhead">' +
                        "<b>Geofence Name : </b><br><br>" +
                        value.name +
                        "</br></div>"
                    );

                    infowindow.mousemove;
                    infowindow.open(locationsCity.mapCity);
                    infowindow.setPosition(event.latLng);
                    openedInfoWindow = infowindow;

                } else {
                    if (measureEnabled) {
                        addLatLng(event, locationsCity.mapCity);
                    }

                    // console.log('Clicked inside the polygon!');
                    // // Handle fill click logic here
                }
            });

            tempPolygon.setMap(locationsCity.mapCity);

            vm.storeTempPolygon.push(tempPolygon)
            return tempPolygon;
        }

        function drawPolygonAmc(value, latlang, color, zIndex, canClick) {
            var path = JSON.parse(value.coordinates);
            // drawPolylineForGeoFence(path, locations.map, value.name);
            var infowindow = new google.maps.InfoWindow({
                content:
                    '<div class="infoWindowhead">' +
                    "name" +
                    '<div class="infoWindowContent"> <b>Description :</b> ' +
                    "des" +
                    "</div></div>",
            });

            infowindow.setPosition(latlang);
            var strokeColor = "#ff6a08";

            if (color == "green") {
                strokeColor = "#00e658";
            } else if (color == "blue") {
                strokeColor = "#0066CC";
            }

            var tempPolygon = new google.maps.Polygon({
                paths: path,
                strokeColor: strokeColor,
                strokeOpacity: 0.5,
                strokeWeight: 1.2,
                fillColor: strokeColor,
                fillOpacity: 0.1,
                zIndex: zIndex
            });

            google.maps.event.addListener(tempPolygon, 'click', function (event) {
                var clickedLatLng = event.latLng;
                var isNearBorder = false;

                // // Check each edge of the polygon to see if the click is near the border
                // var paths = tempPolygon.getPath();
                // for (var i = 0; i < paths.getLength(); i++) {
                //     var start = paths.getAt(i);
                //     var end = paths.getAt((i + 1) % paths.getLength());

                //     // Calculate the distance between the clicked point and the polygon edge
                //     var distanceToEdge = google.maps.geometry.spherical.computeDistanceBetween(clickedLatLng, start) +
                //         google.maps.geometry.spherical.computeDistanceBetween(clickedLatLng, end) -
                //         google.maps.geometry.spherical.computeDistanceBetween(start, end);

                //     if (Math.abs(distanceToEdge) < 10) {  // Adjust this threshold (in meters)
                //         isNearBorder = true;
                //         break;
                //     }
                // }

                // if (isNearBorder) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }
                infowindow.setContent(
                    '<div class="infoWindowhead">' +
                    "<b>Geofence Name : </b><br><br>" +
                    value.name +
                    "</br></div>"
                );

                infowindow.mousemove;
                infowindow.open(locationsCityAmc.mapCity);
                infowindow.setPosition(event.latLng);
                openedInfoWindow = infowindow;

                // } else {
                //     if (measureEnabled) {
                //         addLatLng(event, locationsCityAmc.mapCity);
                //     }

                //     // console.log('Clicked inside the polygon!');
                //     // // Handle fill click logic here
                // }
            });

            tempPolygon.setMap(locationsCityAmc.mapCity);

            vm.storeTempPolygon.push(tempPolygon)
            return tempPolygon;
        }

        $(function () {
            $("#page_size").change(function () {
                vm.itemsPerPage = parseInt(
                    document.getElementById("page_size").value
                );
                vm.showAssetDelete = false;
                vm.selectedAssets = [];
                getAssetsForListView();
                vm.selectedMapGeofenceId = null;
                vm.userGeofences.forEach(function (value) {
                    if (vm.selectedMapGeofenceId == null) {
                        vm.selectedMapGeofenceId = value.id;
                    }
                });
            });
        });

        function getAssetsForListView() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                var str = $scope.search + "";
                str = str.replace("/", "slash");
                if (vm.selectedListGeofenceId > 0) {
                    AssetGroupSearchWithGeofence.query(
                        {
                            search: str,
                            geofenceId: vm.selectedListGeofenceId,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                        },
                        onSuccessListSearch,
                        onErrorListSearch
                    );
                } else {
                    AssetGroupSearch.query(
                        {
                            search: str,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                        },
                        onSuccessListSearch,
                        onErrorListSearch
                    );
                }

                function onSuccessListSearch(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.totalItems =
                        Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                    vm.assetsForListView = data;
                    tempList = []
                    data.forEach(function (item) {
                        tempList.push({ id: item.id, burriedStatus: item.burried })
                    })
                    vm.page = pagingParams.page;
                }

                function onErrorListSearch(error) {
                    AlertService.error(error.data.message);
                }
            } else {
                if (vm.selectedListGeofenceId > 0) {
                    AssetGroupWithGeofence.query(
                        {
                            geofenceId: vm.selectedListGeofenceId,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                        },
                        onSuccessList,
                        onErrorList
                    );
                } else {
                    AssetGroup.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                        },
                        onSuccessList,
                        onErrorList
                    );
                }

                function onSuccessList(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.totalItems =
                        Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                    vm.assetsForListView = data;
                    tempList = []
                    data.forEach(function (item) {
                        tempList.push({ id: item.id, burriedStatus: item.burried })
                    })
                    vm.page = pagingParams.page;
                }

                function onErrorList(error) {
                    AlertService.error(error.data.message);
                }
            }
        }

        $scope.accessibleCheckChange = function (asset) {
            vm.checkAccessible = asset.accessible;
            vm.changeAcessibleStatus = vm.checkAccessible
                ? "Accessible"
                : "Inaccessible";
            var yes = document.getElementById("yes-button");

            yes.onclick = function () {
                AssetByID.get(asset.id, function (assetVal) {
                    assetVal.accessible = asset.accessible;
                    assetVal.assetImages = []
                    Asset.update(assetVal);
                });
            };

            var no = document.getElementById("remove-button");

            no.onclick = function () {
                getAssetsForListView();
            };

            var close = document.getElementById("close-button");

            close.onclick = function () {
                getAssetsForListView();
            };

            var closeModal = document.getElementById("myModal");

            closeModal.onclick = function (e) {
                if (e.target == this) {
                    getAssetsForListView();
                }
            };
        };

        vm.onChangeBuried = function (asset) {
            vm.assetTitle = asset.name
            var yes = document.getElementById("yesButtonBurried");
            var no = document.getElementById("noButtonBurried");
            var close = document.getElementById("closeButtonBurried");

            var tempBuriedStatus = tempList.find(function (item) {
                return item.id == asset.id
            })

            yes.onclick = function () {
                AssetByID.get(asset.id, function (assetVal) {
                    assetVal.burried = asset.burried;
                    assetVal.assetImages = []
                    Asset.update(assetVal);
                });
            };

            no.onclick = function () {
                asset.burried = tempBuriedStatus.burriedStatus
                $scope.$apply()
            };

            close.onclick = function () {
                asset.burried = tempBuriedStatus.burriedStatus
                $scope.$apply()
            };
        }

        function getGroupAssetsFromES(
            geofenceIdVal,
            lastAssetId,
            mapAssetLists
        ) {
            // AssetGroupES.get(geofenceIdVal, lastAssetId, function (data) {
            AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;
                if (lastAssetId == null) {
                    vm.filterAssetTypes = [];
                    if (data.assettypes.length) {
                        data.assettypes.forEach(function (assettype) {
                            if (vm.assetTypes.length) {
                                vm.assetTypes.forEach(function (item) {
                                    if (item.id == assettype.id) {
                                        assettype.layout = item.layout
                                        if (item.layout == "FIXED") {
                                            assettype.icon =
                                                '<img  src="' +
                                                item.imagePath +
                                                '"style="width: 24px; height: 24px;">';
                                            assettype.code = item.imagePath
                                        } else {
                                            assettype.icon =
                                                '<img class="square" style="background-color:' +
                                                item.colorcode +
                                                ';">';
                                            assettype.code = item.colorcode
                                        }
                                    }
                                })
                            }


                            vm.filterAssetTypes.push({
                                id: assettype.id,
                                name: assettype.assetTypeName,
                                ticked: true,
                                icon: assettype.icon,
                                layout: assettype.layout,
                                code: assettype.code
                            });
                        });
                    }
                }
                data.assets.forEach(function (asset) {
                    var tmpAsset = {};

                    tmpAsset.assetCoordinates = asset.assetCoordinates;
                    tmpAsset.assetTypeName = asset.assetTypeName;
                    tmpAsset.assetTypeColor = asset.assetColor;
                    tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                    tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                    tmpAsset.id = asset.id;
                    tmpAsset.name = asset.name;
                    tmpAsset.burried = asset.burried
                    tmpAsset.healthIndicator = asset.healthIndicator;
                    tmpAsset.healthRemarks = asset.healthRemarks;

                    tmpAsset.amcStatus = asset.amcStatus;
                    tmpAsset.bsnlDistance = asset.bsnlDistance;
                    tmpAsset.bbnlDistance = asset.bbnlDistance;
                    tmpAsset.totalDistance = asset.totalDistance;
					tmpAsset.availability = asset.availability;
					
					
                    vm.mapAssets.push(tmpAsset);
                });

                if (data.assets.length < 200) {
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        var assetType = vm.assetTypeValues[index];
                        var typeName = assetType.assetTypeName;
                        var typeAssetsList = [];
                        if (assetType.assets != null) {
                            typeAssetsList = assetType.assets;
                        }

                        vm.mapAssets.forEach(function (asset) {
                            if (typeName == asset.assetTypeName) {
                                typeAssetsList.push(asset);
                            }
                        });
                        assetType.assets = typeAssetsList;
                        vm.assetTypeValues[index] = assetType;
                        if (vm.assetTypeValues[index].zoomLevel >= 15) {
                            var labelLength = vm.assetTypeValues[index].assets;
                            for (var i = 0; i < labelLength.length; i++) {
                                vm.assetTypeValues[index].assets[i].label =
                                    vm.assetTypeValues[index].zoomLevel;
                            }
                        }
                    }

                    if (vm.zoomLevel == 12) {
                        var assetList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 12) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        assetList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawLatestAssets(assetList, "level1");
                        isLevel1AssetsVisible = true;
                    }

                    vm.nodeAssets = [];
                    var tempNodeAssets = [];

                    vm.mapAssets.forEach(function (asset) {
                        if (
                            asset.assetTypeName == "BX1" ||
                            asset.assetTypeName == "BX2" ||
                            asset.assetTypeName == "BX3" ||
                            asset.assetTypeName == "BX4" ||
                            asset.assetTypeName == "DX4" ||
                            asset.assetTypeName == "DX16" ||
                            asset.assetTypeName == "DX11" ||
                            asset.assetTypeName == "DX10" ||
                            asset.assetTypeName == "DX15" ||
                            asset.assetTypeName == "ADX1" ||
                            asset.assetTypeName == "DX7" ||
                            asset.assetTypeName == "DX12" ||
                            asset.assetTypeName == "Sr Elements_Ax" ||
                            asset.assetTypeName == "Sr Elements_Bx" ||
                            asset.assetTypeName == "Sr Elements_Dx" ||
                            asset.assetTypeName == "Sr Elements_Mcr" ||
                            asset.assetTypeName == "Sr Elements_AX" ||
                            asset.assetTypeName == "Sr Elements_BX" ||
                            asset.assetTypeName == "Sr Elements_DX" ||
                            asset.assetTypeName == "Sr Elements_MCR" ||
                            asset.assetTypeName == "Sr_Elements_Cluster_New" ||
                            asset.assetTypeName == "Sr_Elements_Cluster"
                        ) {
                            var lat = asset.assetCoordinates[0].latitude.toFixed(
                                4
                            );
                            var lng = asset.assetCoordinates[0].longitude.toFixed(
                                4
                            );
                            tempNodeAssets.push({
                                lat: lat,
                                lng: lng,
                                assetDetails: asset,
                            });
                        }
                    });
                    if (vm.mapAssets.length > 0) {
                        var assetCenterLatLng = {
                            lat: parseFloat(vm.mapAssets[vm.mapAssets.length - 1].assetCoordinates[0].latitude),
                            lng: parseFloat(vm.mapAssets[vm.mapAssets.length - 1].assetCoordinates[0].longitude)
                        };

                        locations.map.setCenter(assetCenterLatLng);
                    }
                    vm.nodeAssets = Object.values(groupByKey(tempNodeAssets));

                } else {
                    // drawLatestAssets(vm.mapAssets);
                    if (data.lastId != null && data.lastId != undefined) {
                        getGroupAssetsFromES(
                            geofenceIdVal,
                            data.lastId,
                            vm.mapAssets
                        );
                    } else {
                        if (vm.mapAssets.length > 0) {
                            var assetSelected = vm.mapAssets[0];
                            var assetLatLng = {
                                lat:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                        1
                                    ].latitude,
                                lng:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                        1
                                    ].longitude,
                            };
                            try {
                                locations.map.setCenter(assetLatLng);
                            } catch (error) {
                                console.log(error);
                            }
                            /* AssetByID.get(assetSelected.id, function (assetVal) {
                                var assetLatLng = {
                                    lat:
                                        assetSelected.assetCoordinates[
                                            assetSelected.assetCoordinates.length -
                                                1
                                        ].latitude,
                                    lng:
                                        assetSelected.assetCoordinates[
                                            assetSelected.assetCoordinates.length -
                                                1
                                        ].longitude,
                                };
                                try {
                                    locations.map.setCenter(assetLatLng);
                                } catch (error) {
                                    console.log(error);
                                }
                            }); */
                        }
                    }
                }

                if (vm.isEnableNavigate) {
                    $scope.fillTextbox(vm.storeAsset)
                    $scope.searchAsset = "";
                }
            });
        }

        function groupByKey(array) {
            var flags = [],
                output = [];
            for (var i = 0; i < array.length; i++) {
                if (flags[array[i].lat]) continue;
                flags[array[i].lat] = true;
                output.push(array[i].lat);
            }
            var result = [];
            for (var j = 0; j < output.length; j++) {
                var objArray = [];
                for (var k = 0; k < array.length; k++) {
                    if (output[j] == array[k].lat) {
                        objArray.push(array[k]);
                    }
                }
                result.push(objArray);
            }
            return result;
        }

        function getGroupAssetsFromESCity(
            geofenceIds,
            lastAssetId,
            mapAssetLists,
            assetLayersbyCity
        ) {
            // AssetGroupByGeofencesES.get(
            AssetGroupByGeofencesDB.get(
                {
                    lastAssetId: lastAssetId,
                    geofences: geofenceIds,
                    assetTypes: assetLayersbyCity,
                },
                function (data) {
                    vm.mapAssetsCity = mapAssetLists;
                    data.assets.forEach(function (asset) {
                        var tmpAsset = {};

                        tmpAsset.assetCoordinates = asset.assetCoordinates;
                        tmpAsset.assetTypeName = asset.assetTypeName;
                        tmpAsset.assetTypeColor = asset.assetColor;
                        tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                        tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                        tmpAsset.healthIndicator = asset.healthIndicator;
                        tmpAsset.healthRemarks = asset.healthRemarks;
                        tmpAsset.id = asset.id;
                        tmpAsset.name = asset.name;
                        tmpAsset.amcStatus = asset.amcStatus;
                        tmpAsset.bsnlDistance = asset.bsnlDistance;
                        tmpAsset.bbnlDistance = asset.bbnlDistance;
                        tmpAsset.totalDistance = asset.totalDistance;
						tmpAsset.availability = asset.availability;
                        vm.mapAssetsCity.push(tmpAsset);
                    });

                    if (data.assets.length < 200) {
                        for (
                            var index = 0;
                            index < vm.assetTypeValuesCity.length;
                            index++
                        ) {
                            var assetType = vm.assetTypeValuesCity[index];
                            var typeName = assetType.assetTypeName;
                            var typeAssetsList = [];
                            if (assetType.assets != null) {
                                typeAssetsList = assetType.assets;
                            }

                            vm.mapAssetsCity.forEach(function (asset) {
                                if (typeName == asset.assetTypeName) {
                                    typeAssetsList.push(asset);
                                }
                            });
                            assetType.assets = typeAssetsList;
                            vm.assetTypeValuesCity[index] = assetType;
                        }
                        /* var assetListCity = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValuesCity.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValuesCity[index].assetTypeName ==
                                    "KML Link" ||
                                vm.assetTypeValuesCity[index].assetTypeName ==
                                    "SOH" ||
                                vm.assetTypeValuesCity[index].assetTypeName ==
                                    "Link" ||
                                vm.assetTypeValuesCity[index].assetTypeName ==
                                    "UG-OH"
                            ) {
                                vm.assetTypeValuesCity[index].assets.forEach(
                                    function (assetVal) {
                                        assetListCity.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawLatestAssetsCity(assetListCity, "level1");
                        */
                        if ($scope.selectedFilterAssetTypesCity.length > 0) {
                            drawTheAssetsCity();
                        }
                    } else {
                        // drawLatestAssets(vm.mapAssets);
                        if (data.lastId != null && data.lastId != undefined) {
                            getGroupAssetsFromESCity(
                                geofenceIds,
                                data.lastId,
                                vm.mapAssetsCity,
                                assetLayersbyCity
                            );
                        } else {
                            if (vm.mapAssetsCity.length > 0) {
                                var assetSelected = vm.mapAssetsCity[0];
                                var assetLatLng = {
                                    lat:
                                        assetSelected.assetCoordinates[
                                            assetSelected.assetCoordinates
                                                .length - 1
                                        ].latitude,
                                    lng:
                                        assetSelected.assetCoordinates[
                                            assetSelected.assetCoordinates
                                                .length - 1
                                        ].longitude,
                                };
                                try {
                                    locationsCity.mapCity.setCenter(
                                        assetLatLng
                                    );
                                } catch (error) {
                                    console.log(error);
                                }
                                /* AssetByID.get(
                                    assetSelected.id,
                                    function (assetVal) {
                                        
                                    }
                                ); */
                            }
                        }
                    }

                }
            );
        }

        function getGroupAssetsFromESCityAmc(
            geofenceIds,
            lastAssetId,
            mapAssetLists,
            assetLayersbyCityAmc
        ) {
            // AssetGroupByGeofencesES.get(
            AssetGroupByGeofencesDB.get(
                {
                    lastAssetId: lastAssetId,
                    geofences: geofenceIds,
                    assetTypes: assetLayersbyCityAmc,
                },
                function (data) {
                    vm.mapAssetsCityAmc = mapAssetLists;
                    data.assets.forEach(function (asset) {
                        var tmpAsset = {};

                        tmpAsset.assetCoordinates = asset.assetCoordinates;
                        tmpAsset.assetTypeName = asset.assetTypeName;
                        tmpAsset.assetTypeColor = asset.assetColor;
                        tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                        tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                        tmpAsset.healthIndicator = asset.healthIndicator;
                        tmpAsset.healthRemarks = asset.healthRemarks;
                        tmpAsset.id = asset.id;
                        tmpAsset.name = asset.name;
                        tmpAsset.amcStatus = asset.amcStatus;
                        tmpAsset.bsnlDistance = asset.bsnlDistance;
                        tmpAsset.bbnlDistance = asset.bbnlDistance;
                        tmpAsset.totalDistance = asset.totalDistance;
						tmpAsset.availability = asset.availability;
                        vm.mapAssetsCityAmc.push(tmpAsset);
                    });

                    if (data.assets.length < 200) {
                        for (
                            var index = 0;
                            index < vm.assetTypeValuesCityAmc.length;
                            index++
                        ) {
                            var assetType = vm.assetTypeValuesCityAmc[index];
                            var typeName = assetType.assetTypeName;
                            var typeAssetsList = [];
                            if (assetType.assets != null) {
                                typeAssetsList = assetType.assets;
                            }

                            vm.mapAssetsCityAmc.forEach(function (asset) {
                                if (typeName == asset.assetTypeName) {
                                    typeAssetsList.push(asset);
                                }
                            });
                            assetType.assets = typeAssetsList;
                            vm.assetTypeValuesCityAmc[index] = assetType;
                        }
                        if ($scope.selectedFilterAssetTypesCityAmc.length > 0) {
                            drawTheAssetsCityAmc();
                        }
                    } else {
                        if (data.lastId != null && data.lastId != undefined) {
                            getGroupAssetsFromESCityAmc(
                                geofenceIds,
                                data.lastId,
                                vm.mapAssetsCityAmc,
                                assetLayersbyCityAmc
                            );
                        } else {
                            if (vm.mapAssetsCityAmc.length > 0) {
                                var assetSelected = vm.mapAssetsCityAmc[0];
                                var assetLatLng = {
                                    lat:
                                        assetSelected.assetCoordinates[
                                            assetSelected.assetCoordinates
                                                .length - 1
                                        ].latitude,
                                    lng:
                                        assetSelected.assetCoordinates[
                                            assetSelected.assetCoordinates
                                                .length - 1
                                        ].longitude,
                                };
                                try {
                                    locationsCityAmc.mapCity.setCenter(
                                        assetLatLng
                                    );
                                } catch (error) {
                                    console.log(error);
                                }
                            }
                        }
                    }

                }
            );
        }

        function selectAssetEntity(asset) {
            if (asset.id != null) {
                if (asset.isChecked) {
                    vm.showAssetDelete = true;
                    //vm.isAllAssetSelected = vm.assets.every(function (itm) { return itm.isChecked; });
                    vm.selectedAssets.push(asset.id);
                } else {
                    var index = vm.selectedAssets.indexOf(asset.id);
                    if (index > -1) {
                        vm.selectedAssets.splice(index, 1);
                    }
                }
                if (vm.selectedAssets.length == 0) {
                    // vm.groupAssets = true;
                    vm.showAssetDelete = false;
                    getAssetsForListView();
                } else {
                    vm.showAssetDelete = true;
                }
            }
        }

        function selectAllAssets() {
            var toggleStatus = vm.isAllAssetSelected;
            if (toggleStatus) {
                vm.showAssetDelete = true;
                vm.selectedAssets = [];
                vm.assetsForListView.forEach(function (asset) {
                    vm.selectedAssets.push(asset.id);
                });
            } else {
                vm.showAssetDelete = false;
                vm.selectedAssets = [];
            }
            angular.forEach(vm.assetsForListView, function (item) {
                item.isChecked = toggleStatus;
            });
        }

        function confirmDelete() {
            $("#deleteAsset").show();
        }

        function selectAsets() {
            if (vm.selectedAssets.length > 0) {
                var assetGroupArray = [];
                vm.selectedAssets.forEach(function (assetId) {
                    assetGroupArray.push({ id: assetId });
                });
                AssetsBulkDelete.save(assetGroupArray, onSuccess, onError);
                function onSuccess() {
                    $("#deleteAsset").removeClass("in");
                    $(".modal-backdrop").remove();
                    $("#deleteAsset").hide();
                    vm.showAssetDelete = false;
                    vm.selectedAssets = [];
                    vm.isAllAssetSelected = false;
                    getAssetsForListView();
                    // $state.go('asset');
                }
                function onError(error) {
                    $("#deleteAsset").removeClass("in");
                    $(".modal-backdrop").remove();
                    $("#deleteAsset").hide();
                    var msg =
                        "Asset deletion failed, Asset has some dependent data";
                    if (error.status == 400) {
                        AlertService.error(msg);
                    } else {
                        AlertService.error(error.data.message);
                    }
                }
            } else {
                alert("Please select assets to delete list");
            }
        }

        var input = document.getElementById("field_pinLat");
        input.addEventListener("input", function () {
            this.value = this.value.replace(/[^-0-9\,\.]/, "");
        });

        function showZoomLocation() {
            var latlng = vm.getLocationCoordinate.split(",");
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinate != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };

                if ($scope.tab == 2) {
                    locations.map.setCenter(assetCenterLatLng);
                    locations.map.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: locations.map,
                        position: assetCenterLatLng,
                    });
                }

                if ($scope.tab == 3) {
                    locationsCity.mapCity.setCenter(assetCenterLatLng);
                    locationsCity.mapCity.setZoom(18);
                    var startMarker = new google.maps.Marker({
                        map: locationsCity.mapCity,
                        position: assetCenterLatLng,
                    });
                }

                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }
        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function gotoLatituteCity() {
            $("#modalLatLongs").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function closeGotoLatitute(id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }
        function closeGotoLatituteCity() {
            $("#modalLatLongs").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalLatLongs").hide();
        }

        function showLayers() {
            vm.currentZoom = locations.map.getZoom();

            vm.getCenter = locations.map.center;

            $("#modalLayer").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }
        function showLayersCity() {
            vm.currentZoomCity = locationsCity.mapCity.getZoom();

            vm.getCenterCity = locationsCity.mapCity.center;

            $("#modalLayer").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
        }

        function closeLayers() {
            $("#modalLayer").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalLayer").hide();
        }

        function filterAssetsOnMapView() {
            vm.userGeofences = [];
            if (vm.adminFilter) {
                GeofenceIDs.getAll(function (response) {
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        vm.userGeofences.push(geofence);
                        /* if (vm.selectedMapGeofenceId == null) {
                            vm.selectedMapGeofenceId = geofence.id;
                        } */
                        if (tempGeofenceId == geofence.id) {
                            geofence.ticked = true;
                        }
                    });
                    vm.countLength = vm.userGeofences.length;
                });
            } else {
                UserGeofences.getAll(function (response) {
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        vm.userGeofences.push(geofence);
                        /* if (vm.selectedMapGeofenceId == null) {
                            vm.selectedMapGeofenceId = geofence.id;
                        } */
                        if (tempGeofenceId == geofence.id) {
                            geofence.ticked = true;
                        }
                    });
                    vm.countLength = vm.userGeofences.length;
                });
            }

            //$("#mapFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.prevSelectedGeofenceId = vm.selectedMapGeofenceId;
        }

        function filterAssetsOnMapViewCity() {
            $("#mapFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.prevSelectedMapGeofenceIds = vm.selectedMapGeofenceIds;
        }

        function closeMapFilterModal() {
            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            vm.selectedMapGeofenceId = vm.prevSelectedGeofenceId;
        }

        function closeImageUpload() {
            $("#myModalUpload").removeClass("in");
            $(".modal-backdrop").remove();
            $("#myModalUpload").hide();
            setTimeout(function () {
                $("#successImage").hide();
            }, 2000);
            setTimeout(function () {
                $("#errorImage").hide();
            }, 2000);
        }

        function closeMapFilterModalCity() {
            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            vm.selectedMapGeofenceIds = vm.prevSelectedMapGeofenceIds;
        }

        function editAssetOnMapView(fixed) {
            $("#assetEditModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none";
        }

        function closeEditAssetModal() {
            document.getElementById("assetEditName").textContent = "Asset";
            $("#assetEditModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#assetEditModal").hide();
        }

        function editAssetMarkerOnMapView(fixed) {
            $("#assetMarkerEditModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none";
        }

        function closeEditAssetMarkerModal() {
            document.getElementById("assetMarkerEditName").textContent = "Asset";
            $("#assetMarkerEditModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#assetMarkerEditModal").hide();
        }

        function viewAssetMarkerOnMapView(fixed) {
            $("#assetMarkerViewModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none";
        }

        function closeViewAssetMarkerModal() {
            document.getElementById("assetMarkerViewName").textContent = "Asset";
            $("#assetMarkerViewModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#assetMarkerViewModal").hide();
        }

        vm.imageInNewTab = function (img) {
            var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' + img + '">'
            );
            imgWindow.document.close();
        };

        function showAssetMarkerDetails(assetMarker) {
            vm.markerAssetToView = assetMarker;
            viewAssetMarkerOnMapView(assetMarker);
        }

        function editAssetMarker(assetMarker) {
            vm.markerAssetToEdit = assetMarker;
            editAssetMarkerOnMapView(assetMarker);
        }

        function saveEditMarkerAssetModal() {
            AssetByMarkerId.get(vm.markerAssetToEdit.id, function (response) {
                var assetMarkersList = [];
                response.assetMarkers.forEach(function (value) {
                    if (value.id == vm.markerAssetToEdit.id) {
                        value = vm.markerAssetToEdit;
                    }
                    assetMarkersList.push(value);
                });
                response.assetMarkers = assetMarkersList;
                Asset.update(response, onSaveSuccess, onSaveError);
                function onSaveSuccess(result) {
                    closeEditAssetMarkerModal();
                    // alert(result.name + " updated successfully!");
                }

                function onSaveError() {
                    closeEditAssetMarkerModal();
                    // alert(vm.assetToEdit.name + " got error while updating!");
                }
            });

        }
        function saveEditAssetModal() {
            if (vm.assetRefAttributes != null) {
                vm.assetToEdit.assetReferenceAttributes = [];
                for (var i = 0; i < vm.assetRefAttributes.length; i += 3) {
                    var obj = {};

                    obj["assetAttributeName"] = vm.assetRefAttributes[i]
                        ? {
                            assetTypeAttribute: vm.assetRefAttributes[i],
                            attributeValue:
                                vm.assetRefAttributes[i].attributeValue,
                            order: 0,
                            popupDisplay:
                                vm.assetRefAttributes[i]
                                    .assetTypePopupDisplay,
                        }
                        : null;

                    obj["assetAttributeValue"] = vm.assetRefAttributes[i + 1]
                        ? {
                            assetTypeAttribute: vm.assetRefAttributes[i + 1],
                            attributeValue:
                                vm.assetRefAttributes[i + 1].attributeValue,
                            order: 1,
                            popupDisplay:
                                vm.assetRefAttributes[i + 1]
                                    .assetTypePopupDisplay,
                        }
                        : null;

                    obj["assetAttributeImage"] = vm.assetRefAttributes[i + 2]
                        ? {
                            assetTypeAttribute: vm.assetRefAttributes[i + 2],
                            image:
                                vm.assetRefAttributes[i + 2].attributeValue,
                            imageName: vm.assetRefAttributes[i + 2]
                                .attributeName,
                            imageType: vm.assetRefAttributes[i + 2]
                                .attributeType,
                            imageId: vm.assetRefAttributes[i + 2]
                                .imageId,
                            attributeValue: "images",
                            order: 1,
                            popupDisplay:
                                vm.assetRefAttributes[i + 2]
                                    .assetTypePopupDisplay,
                        }
                        : null;
                    vm.assetToEdit.assetReferenceAttributes.push(obj);
                }
            }
            vm.assetToEdit.assetImages = []
            Asset.update(vm.assetToEdit, onSaveSuccess, onSaveError);
            function onSaveSuccess(result) {
                closeEditAssetModal();
                var findAssetIndex;
                switch (result.assetType.zoomLevel) {
                    case 15:
                        for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if (result.id == level2AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level2AssetsMarkers[i].setLabel("");
                                level2AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level2AssetsMarkers[i].setLabel(
                                    level2AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 15) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 16:
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if (result.id == level3AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level3AssetsMarkers[i].setLabel("");
                                level3AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level3AssetsMarkers[i].setLabel(
                                    level3AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }

                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 16) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 17:
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if (result.id == level4AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level4AssetsMarkers[i].setLabel("");
                                level4AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level4AssetsMarkers[i].setLabel(
                                    level4AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 17) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 18:
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if (result.id == level5AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level5AssetsMarkers[i].setLabel("");
                                level5AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level5AssetsMarkers[i].setLabel(
                                    level5AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 18) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 19:
                        for (var i = 0; i < level6AssetsMarkers.length; i++) {
                            if (result.id == level6AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level6AssetsMarkers[i].setLabel("");
                                level6AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level6AssetsMarkers[i].setLabel(
                                    level6AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 19) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    case 20:
                        for (var i = 0; i < level7AssetsMarkers.length; i++) {
                            if (result.id == level7AssetsMarkers[i].assetId) {
                                findAssetIndex = i;
                                level7AssetsMarkers[i].setLabel("");
                                level7AssetsMarkers[i].displayLabel.text =
                                    result.name;
                                level7AssetsMarkers[i].setLabel(
                                    level7AssetsMarkers[i].displayLabel
                                );
                                break;
                            }
                        }
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 20) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].name = result.name;
                                break;
                            }
                        }
                        break;

                    default:
                        console.log("not found");
                }
                vm.closeInfoWindow.close();
                //alert(result.name + " updated successfully!");
            }

            function onSaveError() {
                closeEditAssetModal();
                alert(vm.assetToEdit.name + " got error while updating!");
            }
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                pagesize: vm.itemsPerPage,
                listgeofenceid: vm.selectedListGeofenceId,
            });
        }

        function goToPage() {
            vm.page = parseInt(document.getElementById("pagenum").value);
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                pagesize: vm.itemsPerPage,
                listgeofenceid: vm.selectedListGeofenceId,
            });
        }

        function showAssetAttributesModal(assetVal) {
            $("#modalAssetAttributes").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues;
            document.getElementById("assetAttributeTable").innerHTML = "";

            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Name</th><th style='border: 1px solid black;text-align: center;'>Value</th></tr>";

            assetTypeAttributeValuesList.forEach(function (value) {
                if (
                    value.assetTypeAttribute.assetAttributeTypes ==
                    "NON_REFERENCE"
                ) {
                    newTable +=
                        "<tr><td style='border: 1px solid black;text-align: center;'>" +
                        value.assetTypeAttribute.name +
                        "</td><td style='border: 1px solid black;text-align: center;'>" +
                        value.attributeValue +
                        "</td></tr>";
                }
            });
            newTable += "</table>";
            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }

        function showThreePontReferenceModal(assetVal) {
            $("#modalThreePointReference").show();
            var assetTypeAttributeValuesList =
                assetVal.assetTypeAttributeValues,
                assetReferenceAttributesList =
                    assetVal.assetReferenceAttributes,
                referenceAttribute = [];
            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Object</th><th style='border: 1px solid black;text-align: center;'>Distance (mtr)</th></tr>";
            var ref = [];
            var dist = [];
            if (assetVal.assetReferenceAttributes.length) {
                assetReferenceAttributesList.forEach(function (val) {
                    referenceAttribute.push(val["assetAttributeName"]);
                    referenceAttribute.push(val["assetAttributeValue"]);
                });
                referenceAttribute.forEach(function (val) {
                    if (
                        val.assetTypeAttribute.assetAttributeTypes ==
                        "THREE_PNT_REFERENCE"
                    ) {
                        if (
                            val.assetTypeAttribute.name ==
                            "3 Point Reference1" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name ==
                            "3 Point Reference2" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name ==
                            "3 Point Reference3" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance1" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance2" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance3" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        }
                    }
                });
            } else {
                assetTypeAttributeValuesList.forEach(function (value) {
                    if (
                        value.assetTypeAttribute.assetAttributeTypes ==
                        "THREE_PNT_REFERENCE"
                    ) {
                        if (
                            value.assetTypeAttribute.name ==
                            "3 Point Reference1"
                        ) {
                            ref.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name ==
                            "3 Point Reference2"
                        ) {
                            ref.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name ==
                            "3 Point Reference3"
                        ) {
                            ref.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name == "Distance1"
                        ) {
                            dist.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name == "Distance2"
                        ) {
                            dist.push(value.attributeValue);
                        } else if (
                            value.assetTypeAttribute.name == "Distance3"
                        ) {
                            dist.push(value.attributeValue);
                        }
                    }
                });
            }

            for (var i = 0; i < 3; i++) {
                if (ref[i] || dist[i]) {
                    newTable +=
                        "<tr><td style='border: 1px solid black;text-align: center;'>" +
                        ref[i] +
                        "</td><td style='border: 1px solid black;text-align: center;'>" +
                        dist[i] +
                        "</td></tr>";
                }
            }
            newTable += "</table>";
            document.getElementById(
                "assetNameThreePointReference"
            ).textContent = assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById(
                "threePointReferenceTable"
            ).innerHTML = newTable;
        }

        function closeAssetAttributesModal() {
            $("#modalAssetAttributes").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalAssetAttributes").hide();
        }

        function closeThreePointReference() {
            $("#modalThreePointReference").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalThreePointReference").hide();
        }

        $scope.geofenceListView = function () {
            if ($scope.tab == 1) {
                vm.selectedListGeofenceId = vm.selectedGeofence[0].id;
                tempGeofenceId = vm.selectedGeofence[0].id;
                getAssetsForListView();
            } else if ($scope.tab == 2) {
                isLevel1AssetsVisible = false;
                isLevel2AssetsVisible = false;
                isLevel3AssetsVisible = false;
                isLevel4AssetsVisible = false;
                isLevel5AssetsVisible = false;
                isLevelNodeVisible = false;
                assetVisibility19 = false;
                assetVisibility20 = false;
                vm.isEnableNavigate = false
                vm.selectedMapGeofenceId = vm.selectedMapGeofence[0].id;
                tempGeofenceId = vm.selectedMapGeofence[0].id; // switiching between one view to another view
                saveFilter();
            }
        };

        function filterAssetsOnListView() {
            tempGeofenceId = $state.params.listgeofenceid;
            vm.geofencesListView = [];
            if (vm.adminFilter) {
                GeofenceIDs.getAll(function (response) {
                    if ($scope.tab == 1) {
                        if (response.length >= 2) {
                            vm.geofencesListView.push({
                                id: 0,
                                name: "All",
                                label: "All",
                            });
                        }
                    }
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        geofence.ticked =
                            tempGeofenceId == geofence.id ? true : false;
                        vm.geofencesListView.push(geofence);
                        if (vm.selectedMapGeofenceId == null) {
                            vm.selectedMapGeofenceId = geofence.id;
                        }
                    });
                    vm.countLength = vm.geofencesListView.length;
                });
            } else {
                UserGeofences.getAll(function (response) {
                    if ($scope.tab == 1) {
                        if (response.length >= 2) {
                            vm.geofencesListView.push({
                                id: 0,
                                name: "All",
                                label: "All",
                            });
                        }
                    }
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        geofence.ticked =
                            tempGeofenceId == geofence.id ? true : false;
                        vm.geofencesListView.push(geofence);
                        if (vm.selectedMapGeofenceId == null) {
                            vm.selectedMapGeofenceId = geofence.id;
                        }
                    });
                    vm.countLength = vm.geofencesListView.length;
                });
            }
            /* $("#listFilterModal").show();
            noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
        }

        function closeListFilterModal() {
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
            vm.selectedListGeofenceId = vm.PrevselectedListGeofenceId;
        }

        function saveListFilter() {
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
            getAssetsForListView();
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
        }

        $scope.initial = function (item) {
            if ($scope.bool) {
                // add item
                $scope.selectedFilterAssetTypes.push(item);
            }
        };

        $scope.initialCity = function () {
            if (vm.filterAssetTypesCity[0].isChecked != undefined) {
                $scope.selectedFilterAssetTypesCity = [];
                for (var i = 0; i < vm.filterAssetTypesCity.length; i++) {
                    if (
                        vm.filterAssetTypesCity[i].name == "KML Link" ||
                        vm.filterAssetTypesCity[i].name == "Optical Fiber Cable"
                    ) {
                        $scope.selectedFilterAssetTypesCity.push(
                            vm.filterAssetTypesCity[i]
                        );
                        vm.filterAssetTypesCity[i].ticked = true;
                    } else {
                        vm.filterAssetTypesCity[i].ticked = false;
                    }
                }
            }
        };

        $scope.sync = function () {
            $scope.selectedFilterAssetTypes = [];
            for (var i = 0; i < vm.selectedAsset.length; i++) {
                $scope.selectedFilterAssetTypes.push(vm.selectedAsset[i]);
            }
            vm.getCenter = locations.map.center;
            saveAssetTypeFilter();
        };

        /* $scope.sync = function (bool, item) {
            if (bool) {
                // add item
                $scope.selectedFilterAssetTypes.push(item);
            } else {
                // remove item

                for (
                    var i = 0;
                    i < $scope.selectedFilterAssetTypes.length;
                    i++
                ) {
                    if ($scope.selectedFilterAssetTypes[i].id == item.id) {
                        $scope.selectedFilterAssetTypes.splice(i, 1);
                    }
                }
            }
        };     */

        /* 
         ng-checked="isChecked(item.id)"

         $scope.isChecked = function(id){
            var match = true;
            for(var i=0 ; i < $scope.selectedFilterAssetTypes.length; i++) {
              if($scope.selectedFilterAssetTypes[i].id == id){
                match = true;
              }
            }
            return match;
        };*/

        function saveFilterCity() {
            $scope.searchAssetCity = "";
            vm.mapAssetsCity = [];
            vm.selectedMapGeofenceIds = [];
            vm.userGeofencesCity.forEach(function (geofence) {
                if (geofence.ticked) {
                    vm.selectedMapGeofenceIds.push(geofence.id);
                }
            });
            markersCity = [];
            polylinesCity = [];
            /* var myOptions = {
                zoom: 10,
                center: locationsCity.latlng,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */
            locationsCity.mapCity = new google.maps.Map(
                document.getElementById("map_canva"),
                myOption(8, locationsCity.latlng)
            );
            geoLocation(locationsCity.mapCity);
            /* var measureTool = new MeasureTool(locationsCity.mapCity, {
                contextMenu: true,
                unit: MeasureTool.UnitTypeId.METRIC,
            }); */

            mapZoomChangeCity(locationsCity.mapCity);
            var assetLayersbyCity = [];

            AssetTypesByGeofenceIDs.get(
                {
                    geofences: vm.selectedMapGeofenceIds,
                },
                function (assetTypeVal) {
                    vm.assetTypeValuesCity = assetTypeVal;
                    vm.filterAssetTypesCity = [];
                    assetTypeVal.forEach(function (assettype) {
                        vm.filterAssetTypesCity.push({
                            id: assettype.id,
                            name: assettype.assetTypeName,
                            ticked: false,
                        });
                    });
                    $scope.selectedFilterAssetTypesCity = [];
                    for (var i = 0; i < vm.filterAssetTypesCity.length; i++) {
                        if (
                            vm.filterAssetTypesCity[i].name == "KML Link" ||
                            vm.filterAssetTypesCity[i].name ==
                            "Optical Fiber Cable" || vm.filterAssetTypesCity[i].name == "GP" ||
                            vm.filterAssetTypesCity[i].name == "ONT"
                        ) {
                            $scope.selectedFilterAssetTypesCity.push(
                                vm.filterAssetTypesCity[i]
                            );
                            vm.filterAssetTypesCity[i].ticked = true;
                        } else {
                            vm.filterAssetTypesCity[i].ticked = false;
                        }
                    }
                    $scope.selectedFilterAssetTypesCity.forEach(function (
                        item
                    ) {
                        assetLayersbyCity.push(item.name);
                    });
                    vm.mapAssetsCity = [];
                    getGroupAssetsFromESCity(
                        vm.selectedMapGeofenceIds,
                        null,
                        vm.mapAssetsCity,
                        assetLayersbyCity
                    );
                }
            );
            vm.prevSelectedMapGeofenceIds = vm.selectedMapGeofenceIds;
            vm.previousPolygons.forEach(function (polygon) {
                polygon.setMap(null);
            });
            GeofenceByID.get(
                vm.selectedMasterGeofenceId,
                function (geofenceDetails) {
                    drawPolygon(
                        geofenceDetails,
                        locationsCity.latlng,
                        "red",
                        1,
                        false
                    );
                }
            );
            vm.userGeofencesCity.forEach(function (value) {
                if (value.ticked) {
                    vm.previousPolygons.push(
                        drawPolygon(value, locationsCity.latlng, "green", 2, false)
                    );
                }
            });

            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            $scope.selectedFilterAssetTypesCity = [];
        }

        function saveFilterCityAmc() {
            $scope.searchAssetCityAmc = "";
            vm.mapAssetsCityAmc = [];
            vm.selectedMapGeofenceIds = [];
            vm.userGeofencesCityAmc.forEach(function (geofence) {
                if (geofence.ticked) {
                    vm.selectedMapGeofenceIds.push(geofence.id);
                }
            });
            markersCityAmc = [];
            polylinesCityAmc = [];
            /* var myOptions = {
                zoom: 10,
                center: locationsCity.latlng,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */
            locationsCityAmc.mapCity = new google.maps.Map(
                document.getElementById("map_canvas_amc"),
                myOption(8, locationsCityAmc.latlng)
            );
            geoLocation(locationsCityAmc.mapCity);
            /* var measureTool = new MeasureTool(locationsCity.mapCity, {
                contextMenu: true,
                unit: MeasureTool.UnitTypeId.METRIC,
            }); */

            mapZoomChangeCityAmc(locationsCityAmc.mapCity);
            var assetLayersbyCityAmc = [];

            AssetTypesByGeofenceIDs.get(
                {
                    geofences: vm.selectedMapGeofenceIds,
                },
                function (assetTypeVal) {
                    vm.assetTypeValuesCityAmc = assetTypeVal;
                    vm.filterAssetTypesCityAmc = [];
                    assetTypeVal.forEach(function (assettype) {
                        vm.filterAssetTypesCityAmc.push({
                            id: assettype.id,
                            name: assettype.assetTypeName,
                            ticked: false,
                        });
                    });
                    $scope.selectedFilterAssetTypesCityAmc = [];
                    for (var i = 0; i < vm.filterAssetTypesCityAmc.length; i++) {
                        if (
                            vm.filterAssetTypesCityAmc[i].name == "GP" ||
                            vm.filterAssetTypesCityAmc[i].name == "ONT" || vm.filterAssetTypesCityAmc[i].layout == "SPREAD"
                        ) {
                            $scope.selectedFilterAssetTypesCityAmc.push(
                                vm.filterAssetTypesCityAmc[i]
                            );
                            vm.filterAssetTypesCityAmc[i].ticked = true;
                        } else {
                            vm.filterAssetTypesCityAmc[i].ticked = false;
                        }
                    }
                    $scope.selectedFilterAssetTypesCityAmc.forEach(function (
                        item
                    ) {
                        assetLayersbyCityAmc.push(item.name);
                    });
                    vm.mapAssetsCityAmc = [];
                    getGroupAssetsFromESCityAmc(
                        vm.selectedMapGeofenceIds,
                        null,
                        vm.mapAssetsCityAmc,
                        assetLayersbyCityAmc
                    );
                }
            );
            vm.prevSelectedMapGeofenceIds = vm.selectedMapGeofenceIds;
            vm.previousPolygons.forEach(function (polygon) {
                polygon.setMap(null);
            });
            GeofenceByID.get(
                vm.selectedMasterGeofenceId,
                function (geofenceDetails) {
                    drawPolygonAmc(
                        geofenceDetails,
                        locationsCityAmc.latlng,
                        "red",
                        1,
                        false
                    );
                }
            );
            vm.userGeofencesCityAmc.forEach(function (value) {
                if (value.ticked) {
                    vm.previousPolygons.push(
                        drawPolygonAmc(value, locationsCityAmc.latlng, "green", 2, false)
                    );
                }
            });

            WorkOrderLastLocation.getlastlogs(function (response) {
                var lastLocByAgents = response;
                var markerIcon = "inactive";
                var imageUrl = "";
                switch (markerIcon) {
                    case "inactive":
                        imageUrl = "content/images/marker_inactive.png";
                        break;
                    case "idle":
                        imageUrl = "content/images/marker_idle.png";
                        break;
                    case "active":
                        imageUrl = "content/images/marker_active.png";
                        break;
                    case "active_case":
                        imageUrl = "content/images/marker_active_case.png";
                        break;
                    default:
                        imageUrl = "content/images/green.png";
                        break;
                }

                var lastLocVal = [];
                removeMarkers();
                for (var i = 0; i < lastLocByAgents.length; i++) {
                    var path = lastLocByAgents[i].path;
                    var isUserInside = false;
                    var canCheck = true;

                    if (path.length > 1) {
                        var userPoint = { lat: path[0].lat, lng: path[0].lng };
                        if (pointInPolygon(userPoint, vm.masterGeofenceData)) {
                            isUserInside = true;
                            canCheck = false;
                        } else {
                            isUserInside = false;
                        }
                        if (isUserInside) {
                            var marker = new google.maps.Marker({
                                position: new google.maps.LatLng(path[0].lat, path[0].lng),
                                map: locationsCityAmc.mapCity,
                                icon: {
                                    url: imageUrl,
                                    scaledSize: new google.maps.Size(24, 32),
                                    origin: new google.maps.Point(0, 0),
                                    anchor: new google.maps.Point(12, 32), // center bottom of icon
                                    labelOrigin: new google.maps.Point(12, 40) // move label below the icon
                                },
                                label: {
                                    text: lastLocByAgents[i].userName,
                                    color: "#2e2e2eff",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                },
                                title: lastLocByAgents[i].userName,
                            });

                            var infowindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(
                                marker,
                                "click",
                                function (event) {
                                    console.log(lastLocByAgents[i]);
                                    var markerContent =
                                        '<div class="infoWindowhead">' +
                                        '</div><div class="infoWindowContent"> ' +
                                        '<br> <b> LatLng  : ' + event.latLng.lat() + "," + event.latLng.lng() + '</b> '
                                    "</div>";
                                    infowindow.setContent(markerContent);

                                    infowindow.open(locationsCityAmc.mapCity);
                                    infowindow.setPosition(event.latLng);
                                }
                            );
                            nearbyAgentsMarkers.push(marker);
                        }
                    }
                }
            });

            $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide();
            $scope.selectedFilterAssetTypesCityAmc = [];
        }

        //vm.boolTrue;
        /*  $scope.check = function () {
            var myOptions = {
                zoom: vm.currentZoom1,
                center: vm.getCenter,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };
            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOptions
            );
            var assetList = [];
            for (var index = 0; index < vm.assetTypeValues.length; index++) {
                if (
                    vm.assetTypeValues[index].assetTypeName == "KML Link" ||
                    vm.assetTypeValues[index].assetTypeName == "SOH" ||
                    vm.assetTypeValues[index].assetTypeName == "Link" ||
                    vm.assetTypeValues[index].assetTypeName == "UG-OH"
                ) {
                    vm.assetTypeValues[index].assets.forEach(function (
                        assetVal
                    ) {
                        assetList.push(assetVal);
                    });
                }
            }

            drawLatestAssets(assetList, "level1");
            isLevel1AssetsVisible = true;
            //saveFilter();
            //  for (var index = 0; index < vm.assetTypeValues.length; index++) {
            //     var assetType = vm.assetTypeValues[index];
            //     var typeName = assetType.assetTypeName;
            //     var typeAssetsList = [];
            //     if (assetType.assets != null) {
            //         typeAssetsList = assetType.assets;
            //     }

            //     vm.mapAssets.forEach(function (asset) {
            //         if (typeName == asset.assetTypeName) {
            //             typeAssetsList.push(asset);
            //         }
            //     });
            //     assetType.assets = typeAssetsList;
            //     vm.assetTypeValues[index] = assetType;
            // }
            
            // var assetList = [];
            // for (var index = 0; index < vm.assetTypeValues.length; index++) {
            //     if (
            //         vm.assetTypeValues[index].assetTypeName == "KML Link" ||
            //         vm.assetTypeValues[index].assetTypeName == "SOH" ||
            //         vm.assetTypeValues[index].assetTypeName == "Link" ||
            //         vm.assetTypeValues[index].assetTypeName == "UG-OH"
            //     ) {
            //         vm.assetTypeValues[index].assets.forEach(function (
            //             assetVal
            //         ) {
            //             assetList.push(assetVal);
            //         });
            //     }
            // }
            // drawLatestAssets(assetList, "level1");
            
            // isLevel1AssetsVisible = true; 

            // vm.nodeAssets = [];
            // var tempNodeAssets = [];

            // vm.mapAssets.forEach(function (asset) {
            //     if (
            //         asset.assetTypeName == "BX1" ||
            //         asset.assetTypeName == "BX2" ||
            //         asset.assetTypeName == "BX3" ||
            //         asset.assetTypeName == "BX4" ||
            //         asset.assetTypeName == "DX4" ||
            //         asset.assetTypeName == "DX16" ||
            //         asset.assetTypeName == "DX11" ||
            //         asset.assetTypeName == "DX10" ||
            //         asset.assetTypeName == "DX15" ||
            //         asset.assetTypeName == "ADX1" ||
            //         asset.assetTypeName == "DX7" ||
            //         asset.assetTypeName == "DX12" ||
            //         asset.assetTypeName == "Sr Elements_Ax" ||
            //         asset.assetTypeName == "Sr Elements_Bx" ||
            //         asset.assetTypeName == "Sr Elements_Dx" ||
            //         asset.assetTypeName == "Sr Elements_Mcr" ||
            //         asset.assetTypeName == "Sr Elements_AX" ||
            //         asset.assetTypeName == "Sr Elements_BX" ||
            //         asset.assetTypeName == "Sr Elements_DX" ||
            //         asset.assetTypeName == "Sr Elements_MCR"
            //     ) {
            //         var lat = asset.assetCoordinates[0].latitude.toFixed(4);
            //         var lng = asset.assetCoordinates[0].longitude.toFixed(4);
            //         tempNodeAssets.push({
            //             lat: lat,
            //             lng: lng,
            //             assetDetails: asset,
            //         });
            //     }
            // });
            // vm.nodeAssets = Object.values(groupByKey(tempNodeAssets));
        };   */

        function saveFilter() {
            vm.storeCases = null;
            vm.displayCaseType = false;
            $scope.$evalAsync();
            $scope.searchAsset = "";
            /* if (vm.prevSelectedGeofenceId != vm.selectedMapGeofenceId) {
                $scope.variableHealth = false;
            }
            vm.health = true; */

            vm.mapAssets = [];
            markers = [];
            polylines = [];

            /* var myOptions = {
                zoom: 12,
                center: locations.latlng,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */
            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(12, locations.latlng)
            );

            geoLocation(locations.map);
            /* try{
                var measureTool = new MeasureTool(locations.map, {
                    contextMenu: true,
                    unit: MeasureTool.UnitTypeId.METRIC,
                });
            }catch(err){
                console.log(err)
            } */
            document.getElementById("myspan").textContent = "";
            vm.zoomLevel = locations.map.getZoom();
            AssetTypesByGeofenceID.get(
                vm.selectedMapGeofenceId,
                function (assetTypeVal) {
                    vm.assetTypeValues = assetTypeVal;
                    getGroupAssetsFromES(
                        vm.selectedMapGeofenceId,
                        null,
                        vm.mapAssets
                    );
                }
            );
            vm.prevSelectedGeofenceId = vm.selectedMapGeofenceId;

            /*  $("#mapFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterModal").hide(); */
            $scope.selectedFilterAssetTypes = [];
        }

        function saveAssetTypeFilter() {
            $scope.searchAsset = "";
            //closeLayers();
            drawAssets(vm.mapAssets, "level1");
            /* var myOptions = {
                zoom: vm.currentZoom,
                center: vm.getCenter,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; */
            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(vm.currentZoom, vm.getCenter)
            );
            geoLocation(locations.map);
            /* var measureTool = new MeasureTool(locations.map, {
                contextMenu: true,
                unit: MeasureTool.UnitTypeId.METRIC,
            }); */
            document.getElementById("myspan").textContent = "";
            if ($scope.selectedFilterAssetTypes.length > 0) {
                mapZoomChange(locations.map);
                mapZoomChangeFilter(locations.map);

                var assetList = [];
                for (
                    var index = 0;
                    index < vm.assetTypeValues.length;
                    index++
                ) {
                    if (
                        vm.assetTypeValues[index].zoomLevel >= 8 &&
                        vm.assetTypeValues[index].zoomLevel <= 14
                    ) {
                        vm.assetTypeValues[index].assets.forEach(function (
                            assetVal
                        ) {
                            assetList.push(assetVal);
                        });
                    }
                }

                drawLatestAssets(assetList, "level1");
                isLevel1AssetsVisible = true;
            }

            /* if (vm.mapAssets.length > 0) {
                var assetSelected = vm.mapAssets[0];
                AssetByID.get(assetSelected.id, function (assetVal) {
                    var assetLatLng = {
                        lat: assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                        lng: assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                    };
                    try {
                        locations.map.setCenter(assetLatLng);
                    } catch (error) {
                        console.log(error);
                    }
                }); 
            }*/
        }

        function saveAssetTypeFilterCity() {
            $scope.searchAssetCity = "";
            //closeLayers();
            // drawAssetsCity(vm.mapAssetsCity, "level1");
            $scope.selectedFilterAssetTypesCity = [];
            vm.filterAssetTypesCity.forEach(function (value) {
                if (value.ticked) {
                    $scope.selectedFilterAssetTypesCity.push(value);
                }
            });
            /*  var myOptions = {
                zoom: vm.currentZoomCity,
                center: vm.getCenterCity,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.TERRAIN,
            }; */
            locationsCity.mapCity = new google.maps.Map(
                document.getElementById("map_canva"),
                myOption(vm.currentZoomCity, vm.getCenterCity)
            );

            geoLocation(locationsCity.mapCity);
            document.getElementById("myspanCity").textContent = "";

            //drawTheAssetsCity();

            mapZoomChangeCity(locationsCity.mapCity);

            GeofenceByID.get(
                vm.selectedMasterGeofenceId,
                function (geofenceDetails) {
                    drawPolygon(
                        geofenceDetails,
                        locationsCity.latlng,
                        "red",
                        1,
                        false
                    );
                }
            );
            vm.userGeofencesCity.forEach(function (value) {
                if (value.ticked) {
                    vm.previousPolygons.push(
                        drawPolygon(value, locationsCity.latlng, "green", 2, false)
                    );
                }
            });
            var assetLayersbyCity = [];
            vm.mapAssetsCity = [];

            $scope.selectedFilterAssetTypesCity.forEach(function (item) {
                assetLayersbyCity.push(item.name);
            });
            getGroupAssetsFromESCity(
                vm.selectedMapGeofenceIds,
                null,
                vm.mapAssetsCity,
                assetLayersbyCity
            );
        }

        function saveAssetTypeFilterCityAmc() {
            $scope.searchAssetCityAmc = "";
            $scope.selectedFilterAssetTypesCityAmc = [];
            vm.filterAssetTypesCityAmc.forEach(function (value) {
                if (value.ticked) {
                    $scope.selectedFilterAssetTypesCityAmc.push(value);
                }
            });

            locationsCityAmc.mapCity = new google.maps.Map(
                document.getElementById("map_canvas_amc"),
                myOption(vm.currentZoomCityAmc, vm.getCenterCityAmc)
            );

            geoLocation(locationsCityAmc.mapCity);
            document.getElementById("myspanCityAmc").textContent = "";

            mapZoomChangeCityAmc(locationsCityAmc.mapCity);

            GeofenceByID.get(
                vm.selectedMasterGeofenceId,
                function (geofenceDetails) {
                    drawPolygonAmc(
                        geofenceDetails,
                        locationsCityAmc.latlng,
                        "red",
                        1,
                        false
                    );
                }
            );
            vm.userGeofencesCityAmc.forEach(function (value) {
                if (value.ticked) {
                    vm.previousPolygons.push(
                        drawPolygonAmc(value, locationsCityAmc.latlng, "green", 2, false)
                    );
                }
            });

            var assetLayersbyCityAmc = [];
            vm.mapAssetsCityAmc = [];

            $scope.selectedFilterAssetTypesCityAmc.forEach(function (item) {
                assetLayersbyCityAmc.push(item.name);
            });
            getGroupAssetsFromESCityAmc(
                vm.selectedMapGeofenceIds,
                null,
                vm.mapAssetsCityAmc,
                assetLayersbyCityAmc
            );

            WorkOrderLastLocation.getlastlogs(function (response) {
                var lastLocByAgents = response;
                var markerIcon = "inactive";
                var imageUrl = "";
                switch (markerIcon) {
                    case "inactive":
                        imageUrl = "content/images/marker_inactive.png";
                        break;
                    case "idle":
                        imageUrl = "content/images/marker_idle.png";
                        break;
                    case "active":
                        imageUrl = "content/images/marker_active.png";
                        break;
                    case "active_case":
                        imageUrl = "content/images/marker_active_case.png";
                        break;
                    default:
                        imageUrl = "content/images/green.png";
                        break;
                }

                var lastLocVal = [];
                removeMarkers();
                for (var i = 0; i < lastLocByAgents.length; i++) {
                    var path = lastLocByAgents[i].path;
                    var isUserInside = false;
                    var canCheck = true;
                    if (path.length > 1) {
                        var userPoint = { lat: path[0].lat, lng: path[0].lng };
                        if (pointInPolygon(userPoint, vm.masterGeofenceData)) {
                            isUserInside = true;
                            canCheck = false;
                        } else {
                            isUserInside = false;
                        }
                        if (isUserInside) {
                            var marker = new google.maps.Marker({
                                position: new google.maps.LatLng(path[0].lat, path[0].lng),
                                map: locationsCityAmc.mapCity,
                                icon: {
                                    url: imageUrl,
                                    scaledSize: new google.maps.Size(24, 32),
                                    origin: new google.maps.Point(0, 0),
                                    anchor: new google.maps.Point(12, 32), // center bottom of icon
                                    labelOrigin: new google.maps.Point(12, 40) // move label below the icon
                                },
                                label: {
                                    text: lastLocByAgents[i].userName,
                                    color: "#2e2e2eff",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                },
                                title: lastLocByAgents[i].userName,
                            });
                            var infowindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(
                                marker,
                                "click",
                                function (event) {
                                    console.log(lastLocByAgents[i]);
                                    var markerContent =
                                        '<div class="infoWindowhead">' +
                                        '</div><div class="infoWindowContent"> ' +
                                        '<br> <b> LatLng  : ' + event.latLng.lat() + "," + event.latLng.lng() + '</b> '
                                    "</div>";
                                    infowindow.setContent(markerContent);

                                    infowindow.open(locationsCityAmc.mapCity);
                                    infowindow.setPosition(event.latLng);
                                }
                            );
                            nearbyAgentsMarkers.push(marker);
                        }
                    }
                }
            });
        }

        function removeMarkers() {
            for (var i = 0; i < nearbyAgentsMarkers.length; i++) {
                nearbyAgentsMarkers[i].setMap(null);
            }
            nearbyAgentsMarkers = [];
        }
        $scope.complete = function () {
            $scope.hidethis = false;
        };

        $scope.hideAssetList = function () {
            $scope.hidethis = true;
        };
        $scope.fillTextbox = function (item) {
            $scope.searchAsset = item.name;
            $scope.hidethis = true;
            var assetSelected = item;
            clearTimeout(assetTimer);
            clearTimeout(polylineTimer);
            clearTimeout(closeClick);
            infowindowSearch = new google.maps.InfoWindow();
            if (activeInfo != null) {
                activeInfo.close();
                if (spreadPoly != null) {
                    spreadPoly.setMap(null);
                }
            }
            if (item.label <= 18) {
                locations.map.setZoom(18);
            } else if (item.label) {
                locations.map.setZoom(item.label);
            } else {
                locations.map.setZoom(21);
            }

            var getMapZoom = locations.map.getZoom();
            AssetByID.get(assetSelected.id, function (assetVal) {
                if (assetVal.assetType.layout == "SPREAD") {
                    locations.map.setZoom(21);
                    var spreadPolyArr = [];
                    assetVal.assetCoordinates.forEach(function (val) {
                        spreadPolyArr.push({
                            lat: val.latitude,
                            lng: val.longitude,
                        });
                    });
                    spreadPoly = new google.maps.Polyline({
                        path: spreadPolyArr,
                        strokeColor: "#FFFF00",
                        strokeOpacity: 0.6,
                        strokeWeight: 19,
                    });

                    spreadPoly.setMap(locations.map);

                    polylineTimer = setTimeout(function () {
                        if (spreadPoly != null) {
                            spreadPoly.setMap(null);
                            spreadPoly = null;
                        }
                    }, 10000);
                }
                if (getMapZoom > 15) {
                    if (!isLevelNodeVisible) {
                        for (var i = 0; i < nodeMarkers.length; i++) {
                            for (
                                var index = 0;
                                index < nodeMarkers.length;
                                index++
                            ) {
                                nodeMarkers[index].setMap(null);
                            }
                            nodeCluster.clearMarkers();
                            nodeMarkers = [];
                        }
                        drawNodeAssets();
                        isLevelNodeVisible = true;
                    }
                }

                if (getMapZoom > 14) {
                    if (!isLevel2AssetsVisible) {
                        var zoomLevel_15 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 15) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_15.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_15, "level2");

                        /* var handHoleList = [];
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Chamber / Handhole"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    handHoleList.push(assetVal);
                                }
                            );
                        }
                    }
                    drawAssets(handHoleList, "level2");

                    var handHoleCHList = [];
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Handhole CH"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    handHoleCHList.push(assetVal);
                                }
                            );
                        }
                    }
                    drawAssets(handHoleCHList, "level2");

                    var siteList = [];
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Site"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    siteList.push(assetVal);
                                }
                            );
                        }
                    }
                    drawAssets(siteList, "level2"); */
                        isLevel2AssetsVisible = true;
                    }
                }

                if (getMapZoom > 15) {
                    if (!isLevel3AssetsVisible) {
                        var couplerList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 16) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        couplerList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(couplerList, "level3");
                        isLevel3AssetsVisible = true;
                    }
                }

                if (getMapZoom > 16) {
                    if (!isLevel4AssetsVisible) {
                        var zoomLevel_17 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 17) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_17.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_17, "level4");
                        isLevel4AssetsVisible = true;
                    }
                }

                if (getMapZoom > 17) {
                    if (!isLevel5AssetsVisible) {
                        var zoomLevel_18 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 18) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_18.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_18, "level5");
                        isLevel5AssetsVisible = true;
                    }
                }

                if (getMapZoom > 18) {
                    if (!assetVisibility19) {
                        var zoomLevel_19 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 19) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_19.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_19, "level6");
                        assetVisibility19 = true;
                    }
                }

                if (getMapZoom > 19) {
                    if (!assetVisibility20) {
                        var zoomLevel_20 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 20) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_20.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_20, "level7");
                        assetVisibility20 = true;
                    }
                }

                /* if(getMapZoom == 19){
                    if(!vm.zoomLabel19){
                        for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if(level2AssetsMarkers[i].labelZoom == 19){
                                level2AssetsMarkers[i].setLabel(level2AssetsMarkers[i].displayLabel);
                            }
                        }
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if(level3AssetsMarkers[i].labelZoom == 19){
                            level3AssetsMarkers[i].setLabel(level3AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if(level4AssetsMarkers[i].labelZoom == 19){
                            level4AssetsMarkers[i].setLabel(level4AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if(level5AssetsMarkers[i].labelZoom == 19){
                            level5AssetsMarkers[i].setLabel(level5AssetsMarkers[i].displayLabel);}
                        }
                        vm.zoomLabel19 = true 
                    }
                }

                if(getMapZoom == 20){
                    if(!vm.zoomLabel20){
                        for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if(level2AssetsMarkers[i].labelZoom == 20){
                                level2AssetsMarkers[i].setLabel(level2AssetsMarkers[i].displayLabel);
                            }
                        }
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if(level3AssetsMarkers[i].labelZoom == 20){
                            level3AssetsMarkers[i].setLabel(level3AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if(level4AssetsMarkers[i].labelZoom == 20){
                            level4AssetsMarkers[i].setLabel(level4AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if(level5AssetsMarkers[i].labelZoom == 20){
                            level5AssetsMarkers[i].setLabel(level5AssetsMarkers[i].displayLabel);}
                        }
                        vm.zoomLabel20 =  true;
                    }
                } */

                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                };
                locations.map.setCenter(assetLatLng);
                infowindowSearch.setContent(item.name);
                infowindowSearch.open(locations.map);
                activeInfo = infowindowSearch;
                infowindowSearch.setPosition(assetLatLng);
                assetTimer = setTimeout(function () {
                    if (activeInfo != null) {
                        activeInfo.close();
                    }
                }, 10000);
            });
            google.maps.event.addListener(locations.map, "click", function () {
                activeInfo.close();
            });
        };
        /* $("#searchAssetsOnMap").click(function () {
            clearTimeout(assetTimer)
            clearTimeout(polylineTimer)
            clearTimeout(closeClick)
            infowindowSearch = new google.maps.InfoWindow();
            var assetSelected = JSON.parse($("#searchAssetsOnMap").val());
            if (activeInfo != null) {
                activeInfo.close();
                if (spreadPoly != null) {
                    spreadPoly.setMap(null);
                }
            }
            locations.map.setZoom(18);
            var getMapZoom = locations.map.getZoom()
            AssetByID.get(assetSelected.id, function (assetVal) {
                if (
                    assetVal.assetType.name == "KML Link" ||
                    assetVal.assetType.name == "SOH" ||
                    assetVal.assetType.name == "Link" ||
                    assetVal.assetType.name == "UG-OH"
                ) {
                    locations.map.setZoom(21);
                    var spreadPolyArr = [];
                    assetVal.assetCoordinates.forEach(function (val) {
                        spreadPolyArr.push({
                            lat: val.latitude,
                            lng: val.longitude,
                        });
                    });
                    spreadPoly = new google.maps.Polyline({
                        path: spreadPolyArr,
                        strokeColor: "#FFFF00",
                        strokeOpacity: 0.6,
                        strokeWeight: 19,
                    });

                    spreadPoly.setMap(locations.map);

                    polylineTimer = setTimeout(function () {
                        if (spreadPoly != null) {
                            spreadPoly.setMap(null);
                            spreadPoly = null;
                        }
                    }, 10000);
                }
                
                if (getMapZoom > 15){
                    if(!isLevelNodeVisible){
                        for (var i = 0; i < nodeMarkers.length; i++) {
                            for (
                                var index = 0;
                                index < nodeMarkers.length;
                                index++
                            ) {
                                nodeMarkers[index].setMap(null);
                            }
                            nodeCluster.clearMarkers();
                            nodeMarkers = [];
                        }
                        drawNodeAssets();
                        isLevelNodeVisible = true;
                    }
                 } 
                 
                 if (getMapZoom > 14){
                    if(!isLevel2AssetsVisible){
                        var chamberList = [];
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Chamber"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    chamberList.push(assetVal);
                                }
                            );
                        }
                    }
                    drawAssets(chamberList, "level2");
                    isLevel2AssetsVisible = true;
                    }
                }
                
                if (getMapZoom > 15){
                    if (!isLevel3AssetsVisible) {
                        var couplerList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValues[index].assetTypeName ==
                                "Coupler"
                            ) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        couplerList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(couplerList, "level3");
                        isLevel3AssetsVisible = true;
                    }
                }
                
                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                };
                locations.map.setCenter(assetLatLng);
                infowindowSearch.setContent(assetVal.name);
                infowindowSearch.open(locations.map);
                activeInfo = infowindowSearch;
                infowindowSearch.setPosition(assetLatLng);
                assetTimer = setTimeout(function () { 
                    if (activeInfo != null) {activeInfo.close(); }},10000)
            });
            google.maps.event.addListener(locations.map, "click", function () {
                activeInfo.close();
            });
        }); */

        $scope.searchAssetsOnMapCity = function (item) {
            $scope.searchAssetCity = item.name;
            $scope.hidethis = true;
            var assetSelected = item;
            clearTimeout(assetTimerCity);
            clearTimeout(polylineTimerCity);
            locationsCity.mapCity.setZoom(18);
            infowindowSearchCity = new google.maps.InfoWindow();
            if (activeInfoCity != null) {
                activeInfoCity.close();
                if (spreadPolyCity != null) {
                    spreadPolyCity.setMap(null);
                }
            }
            AssetByID.get(assetSelected.id, function (assetVal) {
                if (assetVal.assetType.layout == "SPREAD") {
                    locationsCity.mapCity.setZoom(21);
                    var spreadPolyArrCity = [];
                    assetVal.assetCoordinates.forEach(function (val) {
                        spreadPolyArrCity.push({
                            lat: val.latitude,
                            lng: val.longitude,
                        });
                    });
                    spreadPolyCity = new google.maps.Polyline({
                        path: spreadPolyArrCity,
                        strokeColor: "#FFFF00",
                        strokeOpacity: 0.6,
                        strokeWeight: 19,
                    });

                    spreadPolyCity.setMap(locationsCity.mapCity);

                    polylineTimerCity = setTimeout(function () {
                        if (spreadPolyCity != null) {
                            spreadPolyCity.setMap(null);
                            spreadPolyCity = null;
                        }
                    }, 10000);
                }
                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                };
                locationsCity.mapCity.setCenter(assetLatLng);
                infowindowSearchCity.setContent(item.name);
                infowindowSearchCity.open(locationsCity.mapCity);
                activeInfoCity = infowindowSearchCity;
                infowindowSearchCity.setPosition(assetLatLng);
                assetTimerCity = setTimeout(function () {
                    if (activeInfoCity != null) {
                        activeInfoCity.close();
                    }
                }, 10000);
            });
        };
        var infowindowSearchCityAmc;
        $scope.searchAssetsOnMapCityAmc = function (item) {
            $scope.searchAssetCityAmc = item.name;
            $scope.hidethis = true;
            var assetSelected = item;
            clearTimeout(assetTimerCityAmc);
            clearTimeout(polylineTimerCityAmc);
            locationsCityAmc.mapCity.setZoom(18);
            infowindowSearchCityAmc = new google.maps.InfoWindow();
            if (activeInfoCityAmc != null) {
                activeInfoCityAmc.close();
                if (spreadPolyCityAmc != null) {
                    spreadPolyCityAmc.setMap(null);
                }
            }
            AssetByID.get(assetSelected.id, function (assetVal) {
                if (assetVal.assetType.layout == "SPREAD") {
                    locationsCityAmc.mapCity.setZoom(21);
                    var spreadPolyArrCityAmc = [];
                    assetVal.assetCoordinates.forEach(function (val) {
                        spreadPolyArrCityAmc.push({
                            lat: val.latitude,
                            lng: val.longitude,
                        });
                    });
                    spreadPolyCityAmc = new google.maps.Polyline({
                        path: spreadPolyArrCityAmc,
                        strokeColor: "#FFFF00",
                        strokeOpacity: 0.6,
                        strokeWeight: 19,
                    });

                    spreadPolyArrCityAmc.setMap(locationsCity.mapCity);

                    polylineTimerCity = setTimeout(function () {
                        if (spreadPolyArrCityAmc != null) {
                            spreadPolyCityAmc.setMap(null);
                            spreadPolyCityAmc = null;
                        }
                    }, 10000);
                }
                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                };
                locationsCityAmc.mapCity.setCenter(assetLatLng);
                infowindowSearchCityAmc.setContent(item.name);
                infowindowSearchCityAmc.open(locationsCityAmc.mapCity);
                activeInfoCityAmc = infowindowSearchCityAmc;
                infowindowSearchCityAmc.setPosition(assetLatLng);
                assetTimerCity = setTimeout(function () {
                    if (activeInfoCityAmc != null) {
                        activeInfoCityAmc.close();
                    }
                }, 10000);
            });
        };
        /*  $("#searchAssetsOnMapCity").change(function () {
            clearTimeout(assetTimerCity)
            clearTimeout(polylineTimerCity)
            locationsCity.mapCity.setZoom(18);
            infowindowSearchCity = new google.maps.InfoWindow();
            var assetSelected = JSON.parse($("#searchAssetsOnMapCity").val());
            if (activeInfoCity != null) {
                activeInfoCity.close();
                if (spreadPolyCity != null) {
                    spreadPolyCity.setMap(null);
                }
            }
            AssetByID.get(assetSelected.id, function (assetVal) {
                if (
                    assetVal.assetType.name == "KML Link" ||
                    assetVal.assetType.name == "SOH" ||
                    assetVal.assetType.name == "Link" ||
                    assetVal.assetType.name == "UG-OH"
                ) {
                    locationsCity.mapCity.setZoom(21);
                    var spreadPolyArrCity = [];
                    assetVal.assetCoordinates.forEach(function (val) {
                        spreadPolyArrCity.push({
                            lat: val.latitude,
                            lng: val.longitude,
                        });
                    });
                    spreadPolyCity = new google.maps.Polyline({
                        path: spreadPolyArrCity,
                        strokeColor: "#FFFF00",
                        strokeOpacity: 0.6,
                        strokeWeight: 19,
                    });

                    spreadPolyCity.setMap(locationsCity.mapCity);

                    polylineTimerCity = setTimeout(function () {
                        if (spreadPolyCity != null) {
                            spreadPolyCity.setMap(null);
                            spreadPolyCity = null;
                        }
                    }, 10000);
                }
                var assetLatLng = {
                    lat:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        assetSelected.assetCoordinates[
                            assetSelected.assetCoordinates.length - 1
                        ].longitude,
                };
                locationsCity.mapCity.setCenter(assetLatLng);
                infowindowSearchCity.setContent(assetVal.name);
                infowindowSearchCity.open(locationsCity.mapCity);
                activeInfoCity = infowindowSearchCity;
                infowindowSearchCity.setPosition(assetLatLng);
                assetTimerCity = setTimeout(function () { 
                    if (activeInfoCity != null) {activeInfoCity.close(); }},10000)
            });
        }); */

        function drawLatestAssets(response, level) {
            if (response) {
                initializeAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    // drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                        value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    if (
                                        $scope.selectedFilterAssetTypes.length >
                                        0
                                    ) {
                                        $scope.selectedFilterAssetTypes.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value1.assetTypeName
                                                ) {
                                                    drawFixedAsset(
                                                        value1,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAsset(value1, false, level);
                                    }
                                } else {
                                    if (
                                        $scope.selectedFilterAssetTypes.length >
                                        0
                                    ) {
                                        $scope.selectedFilterAssetTypes.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value.assetTypeName
                                                ) {
                                                    drawFixedAsset(
                                                        value,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAsset(value, false, level);
                                    }
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                if (
                                    $scope.selectedFilterAssetTypes.length > 0
                                ) {
                                    $scope.selectedFilterAssetTypes.forEach(
                                        function (assetTypeVal) {
                                            if (
                                                assetTypeVal.name ==
                                                value.assetTypeName
                                            ) {
                                                drawPolyline(
                                                    value,
                                                    locations.map,
                                                    level
                                                );
                                            }
                                        }
                                    );
                                } else {
                                    drawPolyline(value, locations.map, level);
                                }
                            }
                        });
                    });
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisible = true;
                    break;
                case "level2":
                    isLevel2AssetsVisible = true;
                    break;
                case "level3":
                    isLevel3AssetsVisible = true;
                    break;
                case "level4":
                    isLevel4AssetsVisible = true;
                    break;
                case "level5":
                    isLevel5AssetsVisible = true;
                    break;
                case "level6":
                    assetVisibility19 = true;
                    break;
                case "level7":
                    assetVisibility20 = true;
                    break;
                default:
                    break;
            }
        }

        function drawLatestAssetsCity(response, level) {
            if (response) {
                initializeAssetMap(response, function (latlang) {
                    locationsCity.latlng = latlang;

                    setupAssetMapCity(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    // drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                        value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    if (
                                        $scope.selectedFilterAssetTypesCity
                                            .length > 0
                                    ) {
                                        $scope.selectedFilterAssetTypesCity.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value1.assetTypeName
                                                ) {
                                                    drawFixedAssetCity(
                                                        value1,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAssetCity(
                                            value1,
                                            false,
                                            level
                                        );
                                    }
                                } else {
                                    if (
                                        $scope.selectedFilterAssetTypesCity
                                            .length > 0
                                    ) {
                                        $scope.selectedFilterAssetTypesCity.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value.assetTypeName
                                                ) {
                                                    drawFixedAssetCity(
                                                        value,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAssetCity(value, false, level);
                                    }
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                if (
                                    $scope.selectedFilterAssetTypesCity.length >
                                    0
                                ) {
                                    $scope.selectedFilterAssetTypesCity.forEach(
                                        function (assetTypeVal) {
                                            if (
                                                assetTypeVal.name ==
                                                value.assetTypeName
                                            ) {
                                                drawPolylineCity(
                                                    value,
                                                    locationsCity.mapCity,
                                                    level
                                                );
                                            }
                                        }
                                    );
                                } else {
                                    drawPolylineCity(
                                        value,
                                        locationsCity.mapCity,
                                        level
                                    );
                                }
                            }
                        });
                    });
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisibleCity = true;
                    break;
                case "level2":
                    isLevel2AssetsVisibleCity = true;
                    break;
                case "level3":
                    isLevel3AssetsVisibleCity = true;
                    break;
                case "level4":
                    isLevel4AssetsVisibleCity = true;
                    break;
                case "level5":
                    isLevel5AssetsVisibleCity = true;
                    break;
                default:
                    break;
            }
        }


        function drawLatestAssetsCityAmc(response, level) {
            if (response) {
                initializeAssetMap(response, function (latlang) {
                    locationsCityAmc.latlng = latlang;

                    setupAssetMapCityAmc(function () {
                        $.each(response, function (index, value) {

                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    // drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                        value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    if (
                                        $scope.selectedFilterAssetTypesCityAmc
                                            .length > 0
                                    ) {
                                        $scope.selectedFilterAssetTypesCityAmc.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value1.assetTypeName
                                                ) {
                                                    drawFixedAssetCityAmc(
                                                        value1,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAssetCityAmc(
                                            value1,
                                            false,
                                            level
                                        );
                                    }
                                } else {
                                    if (
                                        $scope.selectedFilterAssetTypesCityAmc
                                            .length > 0
                                    ) {
                                        $scope.selectedFilterAssetTypesCityAmc.forEach(
                                            function (assetTypeVal) {
                                                if (
                                                    assetTypeVal.name ==
                                                    value.assetTypeName
                                                ) {
                                                    drawFixedAssetCityAmc(
                                                        value,
                                                        false,
                                                        level
                                                    );
                                                }
                                            }
                                        );
                                    } else {
                                        drawFixedAssetCityAmc(value, false, level);
                                    }
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                if (
                                    $scope.selectedFilterAssetTypesCityAmc.length >
                                    0
                                ) {
                                    $scope.selectedFilterAssetTypesCityAmc.forEach(
                                        function (assetTypeVal) {
                                            if (
                                                assetTypeVal.name ==
                                                value.assetTypeName
                                            ) {
                                                drawPolylineCityAmc(
                                                    value,
                                                    locationsCityAmc.mapCity,
                                                    level
                                                );
                                            }
                                        }
                                    );
                                } else {
                                    drawPolylineCityAmc(
                                        value,
                                        locationsCityAmc.mapCity,
                                        level
                                    );
                                }
                            }
                        });
                    });
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisibleCityAmc = true;
                    break;
                case "level2":
                    isLevel2AssetsVisibleCityAmc = true;
                    break;
                case "level3":
                    isLevel3AssetsVisibleCityAmc = true;
                    break;
                case "level4":
                    isLevel4AssetsVisibleCityAmc = true;
                    break;
                case "level5":
                    isLevel5AssetsVisibleCityAmc = true;
                    break;
                default:
                    break;
            }
        }
        function llFromDistance(
            latitude,
            longitude,
            distance,
            bearing,
            number
        ) {
            // distance in KM, bearing in degrees

            var R = 6378.1; // Radius of the Earth
            var brng = (bearing * Math.PI) / 180; // Convert bearing to radian
            var lat = (latitude * Math.PI) / 180; // Current coords to radians
            var lon = (longitude * Math.PI) / 180;

            lat = Math.asin(
                Math.sin(lat) * Math.cos(distance / R) +
                Math.cos(lat) * Math.sin(distance / R) * Math.cos(brng)
            );
            lon += Math.atan2(
                Math.sin(brng) * Math.sin(distance / R) * Math.cos(lat),
                Math.cos(distance / R) - Math.sin(lat) * Math.sin(lat)
            );
            // Coords back to degrees and return
            return [
                "" + (number + 1) + "",
                (lat * 180) / Math.PI,
                (lon * 180) / Math.PI,
                number + 1,
            ];
        }

        function getPentagonPoints(latlng, distance, numPoints) {
            var pentagonLatLng = [];
            for (var i = 0; i < numPoints; i++) {
                var bearing = Math.round((360 / numPoints) * i);
                pentagonLatLng.push(
                    llFromDistance(latlng.lat, latlng.lng, distance, bearing, i)
                );
            }
            return pentagonLatLng;
        }

        function drawNodeAssets() {
            nodeMarkers = [];
            nodeCluster = null;
            for (var index = 0; index < vm.nodeAssets.length; index++) {
                var nodeAssetVal = vm.nodeAssets[index];
                var latitude =
                    nodeAssetVal[0].assetDetails.assetCoordinates[0].latitude;
                var longitude =
                    nodeAssetVal[0].assetDetails.assetCoordinates[0].longitude;
                var points = getPentagonPoints(
                    {
                        lat: latitude,
                        lng: longitude,
                    },
                    0.01,
                    nodeAssetVal.length
                );

                var infowindow = new google.maps.InfoWindow();

                for (var i = 0; i < nodeAssetVal.length; i++) {
                    var pointVal = points[i];
                    var iconSize = 48;
                    var newMarker = new google.maps.Marker({
                        position: new google.maps.LatLng(
                            pointVal[1],
                            pointVal[2]
                        ),
                        map: locations.map,
                        icon: {
                            labelOrigin: new google.maps.Point(24, -4),
                            scaledSize: new google.maps.Size(
                                iconSize,
                                iconSize
                            ),
                            url:
                                nodeAssetVal[i].assetDetails.assetTypeImagePath,
                            anchor: new google.maps.Point(
                                iconSize / 2,
                                iconSize / 2
                            ),
                        },
                        label: {
                            text: nodeAssetVal[i].assetDetails.name,
                            color: "#000000",
                            fontSize: "12px",
                            fontWeight: "bold"
                        }
                    });

                    google.maps.event.addListener(
                        newMarker,
                        "click",
                        (function (newMarker) {
                            var assetDetails = nodeAssetVal[i].assetDetails;
                            var userContent = document.createElement("div"),
                                btnShowAttributes,
                                btnCr,
                                btnText,
                                btnEditAsset,
                                btnCreateCase,
                                btnThreePointRef,
                                brBreak;

                            userContent.innerHTML =
                                '<div class="infoWindowhead">' +
                                assetDetails.name +
                                '</div><div class="infoWindowContent">' +
                                "<b>Lat</b> :" +
                                pointVal[1] +
                                "<br><b>Long</b> :" +
                                pointVal[2] +
                                "</div><br>";

                            btnText = userContent.appendChild(
                                document.createElement("b")
                            );
                            btnText.textContent = "Accessible";
                            btnText.style.marginRight = "4px";

                            btnCr = userContent.appendChild(
                                document.createElement("input")
                            );
                            var attr = document.createAttribute("data-toggle");
                            attr.value = "modal";
                            var attr1 = document.createAttribute("data-target");
                            attr1.value = "#myModalMap";

                            btnCr.setAttributeNode(attr);
                            btnCr.setAttributeNode(attr1);

                            btnCr.style.marginRight = "18px";
                            btnCr.type = "checkbox";

                            google.maps.event.addDomListener(
                                newMarker,
                                "click",
                                function () {
                                    AssetByID.get(
                                        assetDetails.id,
                                        function (response) {
                                            btnCr.id = response.id;

                                            btnCr.checked = response.accessible;

                                            vm.changeAcessible = response.accessible
                                                ? "Inaccessible"
                                                : "Accessible";

                                            var yes = document.getElementById(
                                                "yesButton"
                                            );

                                            yes.onclick = function () {
                                                if (btnCr.checked == true) {
                                                    response.accessible = true;
                                                }
                                                if (btnCr.checked == false) {
                                                    response.accessible = false;
                                                }
                                                response.assetImages = []
                                                Asset.update(response);
                                            };

                                            var noBtn = document.getElementById(
                                                "noButton"
                                            );

                                            noBtn.onclick = function () {
                                                if (btnCr.checked == true) {
                                                    document.getElementById(
                                                        btnCr.id
                                                    ).checked = false;
                                                } else {
                                                    document.getElementById(
                                                        btnCr.id
                                                    ).checked = true;
                                                }
                                            };

                                            var closeBtn = document.getElementById(
                                                "closeButton"
                                            );

                                            closeBtn.onclick = function () {
                                                if (btnCr.checked == true) {
                                                    document.getElementById(
                                                        btnCr.id
                                                    ).checked = false;
                                                } else {
                                                    document.getElementById(
                                                        btnCr.id
                                                    ).checked = true;
                                                }
                                            };

                                            var closeModal = document.getElementById(
                                                "myModalMap"
                                            );

                                            closeModal.onclick = function (e) {
                                                if (e.target == this) {
                                                    if (btnCr.checked == true) {
                                                        document.getElementById(
                                                            btnCr.id
                                                        ).checked = false;
                                                    } else {
                                                        document.getElementById(
                                                            btnCr.id
                                                        ).checked = true;
                                                    }
                                                }
                                            };
                                        }
                                    );
                                }
                            );

                            brBreak = userContent.appendChild(
                                document.createElement("br")
                            );
                            brBreak = userContent.appendChild(
                                document.createElement("br")
                            );

                            btnCreateCase = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnCreateCase.type = "button";
                            btnCreateCase.value = "Create Incident";
                            btnCreateCase.className = "button";

                            btnEditAsset = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnEditAsset.type = "button";
                            btnEditAsset.value = "Edit Asset";
                            btnEditAsset.className = "button";

                            btnShowAttributes = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnShowAttributes.type = "button";
                            btnShowAttributes.value = "Show Attributes";
                            btnShowAttributes.className = "button";

                            btnThreePointRef = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnThreePointRef.type = "button";
                            btnThreePointRef.value = "3 Point Reference";
                            btnThreePointRef.className = "button";

                            google.maps.event.addDomListener(
                                btnCreateCase,
                                "click",
                                function () {
                                    $state.go("tr-case.new", {
                                        lat: pointVal[1],
                                        lng: pointVal[2],
                                        desc: "Incident for " + assetDetails.name,
                                    });
                                }
                            );

                            google.maps.event.addDomListener(
                                btnEditAsset,
                                "click",
                                function () {
                                    AssetByID.get(
                                        assetDetails.id,
                                        function (response) {
                                            vm.assetToEdit = response;
                                            document.getElementById(
                                                "assetEditName"
                                            ).textContent =
                                                "Asset - " +
                                                vm.assetToEdit.name;
                                            editAssetOnMapView(assetDetails);
                                        }
                                    );
                                }
                            );

                            google.maps.event.addDomListener(
                                btnShowAttributes,
                                "click",
                                function () {
                                    AssetByID.get(
                                        assetDetails.id,
                                        function (response) {
                                            showAssetAttributesModal(response);
                                        }
                                    );
                                }
                            );

                            google.maps.event.addDomListener(
                                btnThreePointRef,
                                "click",
                                function () {
                                    AssetByID.get(
                                        assetDetails.id,
                                        function (response) {
                                            showThreePontReferenceModal(
                                                response
                                            );
                                        }
                                    );
                                }
                            );
                            return function () {
                                infowindow.setContent(userContent);
                                infowindow.open(locations.map, newMarker);
                                infowindow.open(locations.map, nodeCluster);
                                infowindow.setPosition(
                                    new google.maps.LatLng(
                                        newMarker.getPosition().lat(),
                                        newMarker.getPosition().lng()
                                    )
                                );
                                setTimeout(function () {
                                    infowindow.close();
                                }, 20000);
                            };
                        })(newMarker, i)
                    );

                    nodeMarkers.push(newMarker);
                }
            }
            nodeCluster = new MarkerClusterer(locations.map, nodeMarkers, {
                imagePath:
                    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
            });

            google.maps.event.addDomListener(nodeCluster, "click", function () {
                closeClick = setTimeout(function () {
                    locations.map.setZoom(16);
                }, 10000);
            });

            /*  var zoomClose;
            google.maps.event.addDomListener(
                locations.map,
                "zoom_changed",
                function () {
                    var nodeZoom = locations.map.getZoom()
                    if(nodeZoom > 20){
                        clearTimeout(zoomClose)
                        zoomClose = setTimeout(function(){ locations.map.setZoom(16)},12000)
                    }
                }
            );  */
        }

        function drawNodeAssetsPolyline() {
            nodePolyline = [];

            for (var index = 0; index < vm.nodeAssets.length; index++) {
                if (vm.nodeAssets[index].length > 1) {
                    var nodeAssetVal = vm.nodeAssets[index];
                    var nodeAssetFirstVal = nodeAssetVal[0];
                    var nodeAssetFirstCoor =
                        nodeAssetFirstVal.assetDetails.assetCoordinates[0];
                    var latitude = nodeAssetFirstCoor.latitude;
                    var longitude = nodeAssetFirstCoor.longitude;
                    var points = getPentagonPoints(
                        {
                            lat: latitude,
                            lng: longitude,
                        },
                        0.01,
                        nodeAssetVal.length
                    );

                    for (var i = 0; i < nodeAssetVal.length; i++) {
                        var path = [];
                        var pointVal = points[i];
                        path.push({ lat: latitude, lng: longitude });
                        path.push({ lat: pointVal[1], lng: pointVal[2] });
                        var polyline = new google.maps.Polyline({
                            path: path,
                            strokeColor: "#000000",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                        });

                        polyline.setMap(locations.map);

                        nodePolyline.push(polyline);
                    }
                }
            }
        }

        function drawAssets(response, level) {
            if (response) {
                $.each(response, function (index, value) {
                    if (value.assetTypeLayout == null) {
                        value.assetTypeName = value.assetType.name;
                        value.assetTypeLayout = value.assetType.layout;
                        value.assetTypeImagePath = value.assetType.imagePath;
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "FIXED"
                    ) {
                        if (value.assetCoordinates.length > 1) {
                            // drawPolyline(value);
                            var value1 = value;
                            value1.assetCoordinates = [
                                value.assetCoordinates[
                                value.assetCoordinates.length - 1
                                ],
                            ];
                            if ($scope.selectedFilterAssetTypes.length > 0) {
                                $scope.selectedFilterAssetTypes.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value1.assetTypeName
                                        ) {
                                            drawFixedAsset(
                                                value1,
                                                false,
                                                level
                                            );
                                        }
                                    }
                                );
                            } else {
                                drawFixedAsset(value1, false, level);
                            }
                        } else {
                            if ($scope.selectedFilterAssetTypes.length > 0) {
                                $scope.selectedFilterAssetTypes.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value.assetTypeName
                                        ) {
                                            drawFixedAsset(value, false, level);
                                        }
                                    }
                                );
                            } else {
                                drawFixedAsset(value, false, level);
                            }
                        }
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "SPREAD"
                    ) {
                        if ($scope.selectedFilterAssetTypes.length > 0) {
                            $scope.selectedFilterAssetTypes.forEach(function (
                                assetTypeVal
                            ) {
                                if (assetTypeVal.name == value.assetTypeName) {
                                    drawPolyline(value, locations.map, level);
                                }
                            });
                        } else {
                            drawPolyline(value, locations.map, level);
                        }
                    }
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisible = true;
                    break;
                case "level2":
                    isLevel2AssetsVisible = true;
                    break;
                case "level3":
                    isLevel3AssetsVisible = true;
                    break;
                case "level4":
                    isLevel4AssetsVisible = true;
                    break;
                case "level5":
                    isLevel5AssetsVisible = true;
                    break;
                case "level6":
                    assetVisibility19 = true;
                    break;
                case "level7":
                    assetVisibility20 = true;
                    break;
                default:
                    break;
            }
        }

        function drawAssetsCity(response, level) {
            if (response) {
                $.each(response, function (index, value) {
                    if (value.assetTypeLayout == null) {
                        value.assetTypeName = value.assetType.name;
                        value.assetTypeLayout = value.assetType.layout;
                        value.assetTypeImagePath = value.assetType.imagePath;
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "FIXED"
                    ) {
                        if (value.assetCoordinates.length > 1) {
                            // drawPolyline(value);
                            var value1 = value;
                            value1.assetCoordinates = [
                                value.assetCoordinates[
                                value.assetCoordinates.length - 1
                                ],
                            ];
                            if (
                                $scope.selectedFilterAssetTypesCity.length > 0
                            ) {
                                $scope.selectedFilterAssetTypesCity.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value1.assetTypeName
                                        ) {
                                            drawFixedAssetCity(
                                                value1,
                                                false,
                                                level
                                            );
                                        }
                                    }
                                );
                            } else {
                                drawFixedAssetCity(value1, false, level);
                            }
                        } else {
                            if (
                                $scope.selectedFilterAssetTypesCity.length > 0
                            ) {
                                $scope.selectedFilterAssetTypesCity.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value.assetTypeName
                                        ) {
                                            drawFixedAssetCity(
                                                value,
                                                false,
                                                level
                                            );
                                        }
                                    }
                                );
                            } else {
                                drawFixedAssetCity(value, false, level);
                            }
                        }
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "SPREAD"
                    ) {
                        if ($scope.selectedFilterAssetTypesCity.length > 0) {
                            $scope.selectedFilterAssetTypesCity.forEach(
                                function (assetTypeVal) {
                                    if (
                                        assetTypeVal.name == value.assetTypeName
                                    ) {
                                        drawPolylineCity(
                                            value,
                                            locationsCity.mapCity,
                                            level
                                        );
                                    }
                                }
                            );
                        } else {
                            drawPolylineCity(
                                value,
                                locationsCity.mapCity,
                                level
                            );
                        }
                    }
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisibleCity = true;
                    break;
                case "level2":
                    isLevel2AssetsVisibleCity = true;
                    break;
                case "level3":
                    isLevel3AssetsVisibleCity = true;
                    break;
                case "level4":
                    isLevel4AssetsVisibleCity = true;
                    break;
                case "level5":
                    isLevel5AssetsVisibleCity = true;
                    break;
                default:
                    break;
            }
        }

        function drawAssetsCityAmc(response, level) {
            if (response) {
                $.each(response, function (index, value) {
                    if (value.assetTypeLayout == null) {
                        value.assetTypeName = value.assetType.name;
                        value.assetTypeLayout = value.assetType.layout;
                        value.assetTypeImagePath = value.assetType.imagePath;
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "FIXED"
                    ) {
                        if (value.assetCoordinates.length > 1) {
                            // drawPolyline(value);
                            var value1 = value;
                            value1.assetCoordinates = [
                                value.assetCoordinates[
                                value.assetCoordinates.length - 1
                                ],
                            ];
                            if (
                                $scope.selectedFilterAssetTypesCityAmc.length > 0
                            ) {
                                $scope.selectedFilterAssetTypesCityAmc.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value1.assetTypeName
                                        ) {
                                            drawFixedAssetCityAmc(
                                                value1,
                                                false,
                                                level
                                            );
                                        }
                                    }
                                );
                            } else {
                                drawFixedAssetCityAmc(value1, false, level);
                            }
                        } else {
                            if (
                                $scope.selectedFilterAssetTypesCityAmc.length > 0
                            ) {
                                $scope.selectedFilterAssetTypesCityAmc.forEach(
                                    function (assetTypeVal) {
                                        if (
                                            assetTypeVal.name ==
                                            value.assetTypeName
                                        ) {
                                            drawFixedAssetCityAmc(
                                                value,
                                                false,
                                                level
                                            );
                                        }
                                    }
                                );
                            } else {
                                drawFixedAssetCityAmc(value, false, level);
                            }
                        }
                    }
                    if (
                        value.assetTypeLayout != null &&
                        value.assetTypeLayout == "SPREAD"
                    ) {
                        if ($scope.selectedFilterAssetTypesCityAmc.length > 0) {
                            $scope.selectedFilterAssetTypesCityAmc.forEach(
                                function (assetTypeVal) {
                                    if (
                                        assetTypeVal.name == value.assetTypeName
                                    ) {
                                        drawPolylineCityAmc(
                                            value,
                                            locationsCityAmc.mapCity,
                                            level
                                        );
                                    }
                                }
                            );
                        } else {
                            drawPolylineCityAmc(
                                value,
                                locationsCityAmc.mapCity,
                                level
                            );
                        }
                    }
                });
            }
            switch (level) {
                case "level1":
                    isLevel1AssetsVisibleCityAmc = true;
                    break;
                case "level2":
                    isLevel2AssetsVisibleCityAmc = true;
                    break;
                case "level3":
                    isLevel3AssetsVisibleCityAmc = true;
                    break;
                case "level4":
                    isLevel4AssetsVisibleCityAmc = true;
                    break;
                case "level5":
                    isLevel5AssetsVisibleCityAmc = true;
                    break;
                default:
                    break;
            }
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 12,
                    center: locations.latlng,
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(12, locations.latlng)
                );
                geoLocation(locations.map);
                document.getElementById("myspan").textContent = "";
                mapZoomChange(locations.map);
                /* var measureTool = new MeasureTool(locations.map, {
                    contextMenu: true,
                    unit: MeasureTool.UnitTypeId.METRIC,
                }); */
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
                mapZoomChange(locations.map);
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () { };
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById("map_canvas");

            callback();
        }
        function setupAssetMapCity(callback) {
            if (locationsCity.mapCity == null) {
                /* var myOptions = {
                    zoom: 12,
                    center: locationsCity.latlng,
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locationsCity.mapCity = new google.maps.Map(
                    document.getElementById("map_canva"),
                    myOption(12, locationsCity.latlng)
                );
                geoLocation(locationsCity.mapCity);
                document.getElementById("myspanCity").textContent = "";

                //drawTheAssetsCity();
                mapZoomChangeCity(locationsCity.mapCity);
                /* var measureTool = new MeasureTool(locationsCity.mapCity, {
                    contextMenu: true,
                    unit: MeasureTool.UnitTypeId.METRIC,
                }); */
            }
            locationsCity.overlay = new google.maps.OverlayView();
            locationsCity.overlay.draw = function () { };
            locationsCity.overlay.setMap($scope.mapCity);
            locationsCity.element = document.getElementById("map_canva");
            callback(buildCityAssetLegends())
            buildCityAssetLegends();
            callback();
        }

        function setupAssetMapCityAmc(callback) {
            if (locationsCityAmc.mapCity == null) {
                locationsCityAmc.mapCity = new google.maps.Map(
                    document.getElementById("map_canvas_amc"),
                    myOption(12, locationsCityAmc.latlng)
                );
                geoLocation(locationsCityAmc.mapCity);
                document.getElementById("myspanCityAmc").textContent = "";

                mapZoomChangeCityAmc(locationsCityAmc.mapCity);
            }
            locationsCityAmc.overlay = new google.maps.OverlayView();
            locationsCityAmc.overlay.draw = function () { };
            locationsCityAmc.overlay.setMap($scope.mapCityAmc);
            locationsCityAmc.element = document.getElementById("map_canvas_amc");

            callback();
        }

        function showAssetsonZoom(zoom) {
            var assetList = [];
            for (var index = 0; index < vm.assetTypeValues.length; index++) {
                if (vm.assetTypeValues[index].zoomLevel == zoom) {
                    vm.assetTypeValues[index].assets.forEach(function (
                        assetVal
                    ) {
                        assetList.push(assetVal);
                    });
                }
            }
            drawLatestAssets(assetList, "level1");
        }

        function showLabelBounds() {
            var bounds = locations.map.getBounds();
            for (var i = 0; i < level2AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level2AssetsMarkers[i].position)) {
                    level2AssetsMarkers[i].setLabel("");
                    level2AssetsMarkers[i].setLabel(
                        level2AssetsMarkers[i].displayLabel
                    );
                }
            }

            for (var i = 0; i < level3AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level3AssetsMarkers[i].position)) {
                    level3AssetsMarkers[i].setLabel("");
                    level3AssetsMarkers[i].setLabel(
                        level3AssetsMarkers[i].displayLabel
                    );
                }
            }
            for (var i = 0; i < level4AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level4AssetsMarkers[i].position)) {
                    level4AssetsMarkers[i].setLabel("");
                    level4AssetsMarkers[i].setLabel(
                        level4AssetsMarkers[i].displayLabel
                    );
                }
            }

            for (var i = 0; i < level5AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level5AssetsMarkers[i].position)) {
                    level5AssetsMarkers[i].setLabel("");
                    level5AssetsMarkers[i].setLabel(
                        level5AssetsMarkers[i].displayLabel
                    );
                }
            }

            for (var i = 0; i < level6AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level6AssetsMarkers[i].position)) {
                    level6AssetsMarkers[i].setLabel("");
                    level6AssetsMarkers[i].setLabel(
                        level6AssetsMarkers[i].displayLabel
                    );
                }
            }

            for (var i = 0; i < level7AssetsMarkers.length; i++) {
                //
                if (bounds.contains(level7AssetsMarkers[i].position)) {
                    level7AssetsMarkers[i].setLabel("");
                    level7AssetsMarkers[i].setLabel(
                        level7AssetsMarkers[i].displayLabel
                    );
                }
            }
        }
        function showLabelOnView() {
            google.maps.event.addListener(
                locations.map,
                "dragend",
                function () {
                    //var bounds = locations.map.getBounds();
                    if (vm.zoomLevel < 18) {
                        clearLabel();
                    }
                    if (vm.zoomLevel >= 18) {
                        showLabelBounds();
                    }
                }
            );
        }

        function clearLabel() {
            for (var i = 0; i < level2AssetsMarkers.length; i++) {
                level2AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level3AssetsMarkers.length; i++) {
                level3AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level4AssetsMarkers.length; i++) {
                level4AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level5AssetsMarkers.length; i++) {
                level5AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level6AssetsMarkers.length; i++) {
                level6AssetsMarkers[i].setLabel("");
            }
            for (var i = 0; i < level7AssetsMarkers.length; i++) {
                level7AssetsMarkers[i].setLabel("");
            }
            vm.zoomLabel18 = false;
            /* vm.zoomLabel19 = false
            vm.zoomLabel20 = false */
        }

        vm.showCases = function () {
            clearCaseMarker();
            if (vm.storeCases && vm.zoomLevel >= 15 && vm.selectedCase.length) {
                callTempUG(vm.selectedCase);
            }
        };

        function clearCaseMarker() {
            for (var i = 0; i < caseMarker.length; i++) {
                caseMarker[i].setMap(null);
            }

            /* for (var i = 0; i < caseMarker.length; i++) {
                caseMarker[i].setLabel("");
            } */
        }

        function callTempUG(arr) {
            var tempUGMapMarker,
                image,
                userContent,
                infowindow,
                btnEditCase,
                btnViewCase;
            infowindow = new google.maps.InfoWindow();

            arr.forEach(function (arrId) {
                vm.storeCases[arrId.id].forEach(function (item) {
                    if (vm.caseTypes) {
                        var caseType = vm.caseTypes.find(function (caseType) {
                            return caseType.name == item.caseTypeName;
                        });
                        image =
                            caseType && caseType.image
                                ? "data:image/png;base64," + caseType.image
                                : "content/images/dot_marker.png";
                    }

                    tempUGMapMarker = new google.maps.Marker({
                        map: locations.map,
                        position: new google.maps.LatLng(
                            item.pinLat,
                            item.pinLong
                        ),
                        title: item.description,
                        icon: {
                            url: image,
                            scaledSize: new google.maps.Size(24, 24),
                            labelOrigin: new google.maps.Point(25, -4),
                        },
                    });

                    tempUGMapMarker.setMap(locations.map);
                    /* tempUGMapMarker.displayLabel =  {
                        text: item.description,
                        color: '#000',
                        fontSize: '12px',
                        fontWeight: 'bold',
                      }
    
                    tempUGMapMarker.setLabel(tempUGMapMarker.displayLabel); */
                    userContent = document.createElement("div");
                    userContent.innerHTML =
                        '<div class="infoWindowhead">' +
                        "<b> Incident Type : </b>" +
                        item.caseTypeName +
                        "<br> <b> Description : </b>" +
                        item.description +
                        '</div><div class="infoWindowContent">' +
                        "<b> Incident Id : </b>" +
                        item.id +
                        "<br><b> Priority : </b>" +
                        item.priority +
                        "<br> <b> Status : </b>" +
                        item.status +
                        "<br><b>Latitude</b> :" +
                        item.pinLat +
                        "<br><b>Longitude</b> :" +
                        item.pinLong;
                    ("</div>");

                    /* btnEditCase = userContent.appendChild(
                        document.createElement("input")
                    );
    
                    btnEditCase.type = "button";
                    btnEditCase.value = "Edit Incident";
                    btnEditCase.className = "button"; */

                    btnViewCase = userContent.appendChild(
                        document.createElement("input")
                    );

                    btnViewCase.type = "button";
                    btnViewCase.value = "View Incident";
                    btnViewCase.className = "button";

                    /* google.maps.event.addDomListener(
                        btnEditCase,
                        "click",
                        function () {
                            $state.go("tr-case.edit", {
                                     id: item.id,
                                 });
                        }
                    ); */

                    google.maps.event.addDomListener(
                        btnViewCase,
                        "click",
                        function () {
                            $rootScope.hideCaseEditBtn = true;
                            $state.go("tr-case-detail", {
                                id: item.id,
                            });
                        }
                    );

                    google.maps.event.addListener(
                        tempUGMapMarker,
                        "click",
                        (function (tempUGMapMarker, userContent, infowindow) {
                            return function () {
                                closeLastOpenedInfoWindow();
                                infowindow.setContent(userContent);
                                infowindow.open(locations.map, tempUGMapMarker);
                                lastOpenedInfoWindow = infowindow;
                                setTimeout(function () {
                                    lastOpenedInfoWindow.close();
                                }, 8000);
                            };
                        })(tempUGMapMarker, userContent, infowindow)
                    );

                    caseMarker.push(tempUGMapMarker);
                });
            });
        }

        function closeLastOpenedInfoWindow() {
            if (lastOpenedInfoWindow) {
                lastOpenedInfoWindow.close();
            }
            if (vm.closeInfoWindow) {
                vm.closeInfoWindow.close();
            }
            if (openedInfoWindow) {
                openedInfoWindow.close();
            }
        }

        function mapZoomChange(map) {
            google.maps.event.addListener(
                locations.map,
                "zoom_changed",
                function () {
                    vm.zoomLevel = locations.map.getZoom();
                    vm.currentZoom = locations.map.getZoom();
                    document.getElementById("myspan").textContent =
                        "ZOOM : " + vm.zoomLevel;
                    if (vm.prevZoomLevel == 19 && vm.zoomLevel <= 18) {
                        clearTimeout(closeClick);
                    }
                    if (vm.zoomLevel < 12) {
                        for (var i = 0; i < level1AssetsMarkers.length; i++) {
                            level1AssetsMarkers[i].setMap(null);
                        }

                        for (i = 0; i < level1AssetsPolyline.length; i++) {
                            level1AssetsPolyline[i].setMap(null);
                        }
                        isLevel1AssetsVisible = false;
                        vm.zoom13 = false;
                        vm.zoom14 = false;
                    }
                    if (vm.zoomLevel == 12) {
                        if (!isLevel1AssetsVisible) {
                            var assetList = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 12) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            assetList.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawLatestAssets(assetList, "level1");
                            isLevel1AssetsVisible = true;
                        }
                    }

                    if (vm.zoomLevel == 13) {
                        if (!vm.zoom13) {
                            showAssetsonZoom(13);
                            vm.zoom13 = true;
                        }
                    }

                    if (vm.zoomLevel == 14) {
                        if (!vm.zoom14) {
                            showAssetsonZoom(14);
                            vm.zoom14 = true;
                        }
                    }
                    if (vm.zoomLevel < 15) {
                        vm.displayCaseType = false;
                        $scope.$evalAsync();

                        for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            level2AssetsMarkers[i].setMap(null);
                        }

                        for (i = 0; i < level2AssetsPolyline.length; i++) {
                            level2AssetsPolyline[i].setMap(null);
                        }

                        clearCaseMarker();

                        isLevel2AssetsVisible = false;
                    }

                    if (vm.zoomLevel < 18) {
                        clearLabel();
                    }

                    /* if(vm.prevZoomLevel == 18 && vm.zoomLevel == 19) {
                    if(!vm.zoomLabel19){
                        showLabelBounds()
                        showLabelOnView()
                        
                         for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if(level2AssetsMarkers[i].labelZoom == 19){
                                level2AssetsMarkers[i].setLabel(level2AssetsMarkers[i].displayLabel);
                            }
                        }
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if(level3AssetsMarkers[i].labelZoom == 19){
                            level3AssetsMarkers[i].setLabel(level3AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if(level4AssetsMarkers[i].labelZoom == 19){
                            level4AssetsMarkers[i].setLabel(level4AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if(level5AssetsMarkers[i].labelZoom == 19){
                            level5AssetsMarkers[i].setLabel(level5AssetsMarkers[i].displayLabel);}
                        } 
                        vm.zoomLabel19 = true 
                    }
                } */

                    if (vm.prevZoomLevel == 14 && vm.zoomLevel == 15) {
                        vm.displayCaseType = true;
                        $scope.$evalAsync();
                        vm.getCenter = locations.map.center;
                        vm.currentZoom1 = locations.map.getZoom();

                        if (!vm.storeCases) {
                            casesInMap.get(
                                {
                                    geofenceId: vm.selectedMapGeofenceId,
                                    caseTypeIds: caseTypeIds,
                                },
                                function (response) {
                                    vm.tempLength = response.cases.length > 0;
                                    var result = {},
                                        arrId = [];
                                    if (vm.tempLength) {
                                        response.casetypes.forEach(function (
                                            casetype
                                        ) {
                                            result[
                                                casetype.id
                                            ] = response.cases.filter(function (
                                                c
                                            ) {
                                                return (
                                                    c.caseTypeName ===
                                                    casetype.name
                                                );
                                            });
                                        });
                                    }

                                    vm.storeCases = vm.tempLength
                                        ? result
                                        : false;
                                    vm.caseTypes =
                                        response.cases.length > 0
                                            ? vm.caseType.filter(function (
                                                obj1
                                            ) {
                                                obj1.showInAssetsView = true;

                                                for (var property in result) {
                                                    if (property == obj1.id) {
                                                        obj1.displayName =
                                                            obj1.name +
                                                            " - (" +
                                                            result[obj1.id]
                                                                .length +
                                                            ")";
                                                    }
                                                }

                                                return response.casetypes.some(
                                                    function (obj2) {
                                                        return (
                                                            obj1.id ===
                                                            obj2.id
                                                        );
                                                    }
                                                );
                                            })
                                            : [];

                                    vm.caseTypes.forEach(function (id) {
                                        arrId.push({ id: id.id });
                                    });
                                    if (vm.storeCases) {
                                        callTempUG(arrId);
                                    }
                                }
                            );
                        } else if (vm.storeCases && vm.selectedCase.length) {
                            callTempUG(vm.selectedCase);
                        }

                        if (!isLevel2AssetsVisible) {
                            var zoomLevel_15 = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                /* vm.assetTypeValues.forEach(function (val){
                                val.assets.forEach(function(item){
                                    item.label = val.zoomLevelLabel
                                })
                            }) */
                                if (vm.assetTypeValues[index].zoomLevel == 15) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            zoomLevel_15.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(zoomLevel_15, "level2");

                            /* var siteList = [];
                        for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                        ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Site"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    siteList.push(assetVal);
                                }
                            );
                        }
                        }
                        drawAssets(siteList, "level2");

                        var chamberHandHoleList = [];
                        for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                        ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Chamber / Handhole"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    chamberHandHoleList.push(assetVal);
                                }
                            );
                        }
                        }
                        drawAssets(chamberHandHoleList, "level2");

                        var handHoleChList = [];
                        for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                        ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Handhole CH"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    handHoleChList.push(assetVal);
                                }
                            );
                        }
                        }
                        drawAssets(handHoleChList, "level2"); */

                            isLevel2AssetsVisible = true;
                        }
                    }
                    /* if (vm.currentZoom >= 15) {
                    vm.getCenter = locations.map.center;
                    if (isLevel2AssetsVisible) {
                        var chamberList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValues[index].assetTypeName ==
                                "Chamber"
                            ) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        chamberList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(chamberList, "level2");
                        isLevel2AssetsVisible = true;
                    }
                } */

                    if (vm.zoomLevel <= 15) {
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            level3AssetsMarkers[i].setMap(null);
                        }

                        for (i = 0; i < level3AssetsPolyline.length; i++) {
                            level3AssetsPolyline[i].setMap(null);
                        }
                        isLevel3AssetsVisible = false;
                    }

                    if (vm.prevZoomLevel == 15 && vm.zoomLevel == 16) {
                        vm.getCenter = locations.map.center;
                        vm.currentZoom1 = locations.map.getZoom();
                        if (!isLevel3AssetsVisible) {
                            var couplerList = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 16) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            couplerList.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(couplerList, "level3");
                            isLevel3AssetsVisible = true;
                        }
                    }

                    /*  if (vm.currentZoom >= 16) {
                    vm.getCenter = locations.map.center;
                    if (isLevel3AssetsVisible) {
                        var couplerList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValues[index].assetTypeName ==
                                "Coupler"
                            ) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        couplerList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(couplerList, "level3");
                        isLevel3AssetsVisible = true;
                    }
                } */

                    if (vm.zoomLevel <= 16) {
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            level4AssetsMarkers[i].setMap(null);
                        }

                        for (i = 0; i < level4AssetsPolyline.length; i++) {
                            level4AssetsPolyline[i].setMap(null);
                        }
                        isLevel4AssetsVisible = false;
                    }

                    if (vm.prevZoomLevel == 16 && vm.zoomLevel == 17) {
                        vm.getCenter = locations.map.center;
                        vm.currentZoom1 = locations.map.getZoom();
                        if (!isLevel4AssetsVisible) {
                            var zoomLevel_17 = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 17) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            zoomLevel_17.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(zoomLevel_17, "level4");

                            /* var jointClosureList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (
                                vm.assetTypeValues[index].assetTypeName ==
                                "Joint Closure"
                            ) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        jointClosureList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(jointClosureList, "level4"); */
                            isLevel4AssetsVisible = true;
                        }
                    }

                    if (vm.zoomLevel <= 17) {
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            level5AssetsMarkers[i].setMap(null);
                        }
                        isLevel5AssetsVisible = false;
                    }
                    if (vm.prevZoomLevel == 17 && vm.zoomLevel == 18) {
                        if (!isLevel5AssetsVisible) {
                            var otherList = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 18) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            otherList.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(otherList, "level5");
                            isLevel5AssetsVisible = true;
                        }
                    }

                    if (vm.zoomLevel <= 18) {
                        for (var i = 0; i < level6AssetsMarkers.length; i++) {
                            level6AssetsMarkers[i].setMap(null);
                        }
                        assetVisibility19 = false;
                    }
                    if (vm.prevZoomLevel == 18 && vm.zoomLevel == 19) {
                        if (!assetVisibility19) {
                            var assetZoom19 = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 19) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            assetZoom19.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(assetZoom19, "level6");
                            showLabelBounds();
                            assetVisibility19 = true;
                        }
                    }

                    if (vm.zoomLevel <= 19) {
                        for (var i = 0; i < level7AssetsMarkers.length; i++) {
                            level7AssetsMarkers[i].setMap(null);
                        }
                        assetVisibility20 = false;
                    }
                    if (vm.prevZoomLevel == 19 && vm.zoomLevel == 20) {
                        if (!assetVisibility20) {
                            var assetZoom20 = [];
                            for (
                                var index = 0;
                                index < vm.assetTypeValues.length;
                                index++
                            ) {
                                if (vm.assetTypeValues[index].zoomLevel == 20) {
                                    vm.assetTypeValues[index].assets.forEach(
                                        function (assetVal) {
                                            assetZoom20.push(assetVal);
                                        }
                                    );
                                }
                            }
                            drawAssets(assetZoom20, "level7");
                            showLabelBounds();
                            assetVisibility20 = true;
                        }
                    }
                    if (vm.zoomLevel <= 15) {
                        for (var i = 0; i < nodeMarkers.length; i++) {
                            for (
                                var index = 0;
                                index < nodeMarkers.length;
                                index++
                            ) {
                                nodeMarkers[index].setMap(null);
                            }
                            nodeCluster.clearMarkers();
                            nodeMarkers = [];
                            isLevelNodeVisible = false;
                        }
                    }

                    if (vm.prevZoomLevel == 17 && vm.zoomLevel == 18) {
                        if (!vm.zoomLabel18) {
                            showLabelBounds();
                            showLabelOnView();
                            /* for (var i = 0; i < level2AssetsMarkers.length; i++) {
                            if(level2AssetsMarkers[i].labelZoom == 18){
                                level2AssetsMarkers[i].setLabel(level2AssetsMarkers[i].displayLabel);
                            }
                        }
                        for (var i = 0; i < level3AssetsMarkers.length; i++) {
                            if(level3AssetsMarkers[i].labelZoom == 18){
                            level3AssetsMarkers[i].setLabel(level3AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level4AssetsMarkers.length; i++) {
                            if(level4AssetsMarkers[i].labelZoom == 18){
                            level4AssetsMarkers[i].setLabel(level4AssetsMarkers[i].displayLabel);}
                        }
                        for (var i = 0; i < level5AssetsMarkers.length; i++) {
                            if(level5AssetsMarkers[i].labelZoom == 18){
                            level5AssetsMarkers[i].setLabel(level5AssetsMarkers[i].displayLabel);}
                        } */
                            vm.zoomLabel18 = true;
                        }
                    }

                    if (vm.prevZoomLevel == 15 && vm.zoomLevel == 16) {
                        if (!isLevelNodeVisible) {
                            for (var i = 0; i < nodeMarkers.length; i++) {
                                for (
                                    var index = 0;
                                    index < nodeMarkers.length;
                                    index++
                                ) {
                                    nodeMarkers[index].setMap(null);
                                }
                                nodeCluster.clearMarkers();
                                nodeMarkers = [];
                            }
                            drawNodeAssets();
                            isLevelNodeVisible = true;
                        }
                    }

                    if (vm.prevZoomLevel >= 19 && vm.zoomLevel <= 18) {
                        for (var i = 0; i < nodePolyline.length; i++) {
                            for (
                                var index = 0;
                                index < nodePolyline.length;
                                index++
                            ) {
                                nodePolyline[index].setMap(null);
                            }
                            nodePolyline = [];
                        }
                    }
                    if (vm.zoomLevel >= 19 && nodePolyline.length == 0) {
                        drawNodeAssetsPolyline();
                    }

                    vm.prevZoomLevel = vm.zoomLevel;
                }
            );
        }

        function mapZoomChangeCity(map) {
            google.maps.event.addListener(
                locationsCity.mapCity,
                "idle",
                function () {
                    vm.zoomLevelCity = locationsCity.mapCity.getZoom();

                    document.getElementById("myspanCity").textContent =
                        "ZOOM : " + vm.zoomLevelCity;
                }
            );
        }

        function mapZoomChangeCityAmc(map) {
            google.maps.event.addListener(
                locationsCityAmc.mapCity,
                "idle",
                function () {
                    vm.zoomLevelCityAmc = locationsCityAmc.mapCity.getZoom();

                    document.getElementById("myspanCityAmc").textContent =
                        "ZOOM : " + vm.zoomLevelCityAmc;
                }
            );
        }

        function mapZoomChangeFilter(map) {
            google.maps.event.addListener(locations.map, "idle", function () {
                vm.currentZoom = locations.map.getZoom();

                document.getElementById("myspan").textContent =
                    "ZOOM : " + vm.currentZoom;

                if (vm.currentZoom >= 15) {
                    if (isLevel2AssetsVisible) {
                        var zoomLevel_15 = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 15) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        zoomLevel_15.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(zoomLevel_15, "level2");

                        /* var siteList = [];
                        for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                        ) {
                        if (
                            vm.assetTypeValues[index].assetTypeName ==
                            "Site"
                        ) {
                            vm.assetTypeValues[index].assets.forEach(
                                function (assetVal) {
                                    siteList.push(assetVal);
                                }
                            );
                        }
                        }
                        drawAssets(siteList, "level2"); */

                        isLevel2AssetsVisible = true;
                    }
                    if (vm.storeCases && vm.selectedCase.length) {
                        callTempUG(vm.selectedCase);
                    }
                }

                if (vm.currentZoom >= 16) {
                    if (isLevel3AssetsVisible) {
                        var couplerList = [];
                        for (
                            var index = 0;
                            index < vm.assetTypeValues.length;
                            index++
                        ) {
                            if (vm.assetTypeValues[index].zoomLevel == 16) {
                                vm.assetTypeValues[index].assets.forEach(
                                    function (assetVal) {
                                        couplerList.push(assetVal);
                                    }
                                );
                            }
                        }
                        drawAssets(couplerList, "level3");
                        isLevel3AssetsVisible = true;
                    }
                }
            });
        }

        function initializeAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            lngVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            // callback(new google.maps.LatLng("12.9716", "77.5946"));
                            callback(
                                new google.maps.LatLng(
                                    $rootScope.DEFAULT_LATITUDE,
                                    $rootScope.DEFAULT_LONGITUDE
                                )
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    callback(
                        new google.maps.LatLng(
                            $rootScope.DEFAULT_LATITUDE,
                            $rootScope.DEFAULT_LONGITUDE
                        )
                    );
                }
            }
        }

        function drawFixedAsset(fixed, hasParent, level) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";

                var isFixedAsset = false;

                /*  if ($scope.variableHealth) {
                    if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Chamber"
                    ) {
                        iconUrl = "content/images/chamber_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Chamber"
                    ) {
                        iconUrl = "content/images/chamber_red.png";
                    } else if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Coupler"
                    ) {
                        iconUrl = "content/images/coupler_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Coupler"
                    ) {
                        iconUrl = "content/images/coupler_red.png";
                    } else if (
                        fixed.healthIndicator == true &&
                        fixed.assetTypeName == "Pole"
                    ) {
                        iconUrl = "content/images/pole_green.png";
                    } else if (
                        fixed.healthIndicator == false &&
                        fixed.assetTypeName == "Pole"
                    ) {
                        iconUrl = "content/images/pole_red.png";
                    } else {
                        iconUrl = fixed.assetTypeImagePath;
                    }
                } else {
                    iconUrl = fixed.assetTypeImagePath;
                } */

                //buried chamber
                if (fixed.assetTypeName == "Chamber" && fixed.burried) {
                    iconUrl = "content/images/buriedChamber.png"
                } else {
                    iconUrl = fixed.assetTypeImagePath;
                }

                if (fixed.assetTypeName == "Router") {
                    if (fixed.healthIndicator == true) {
                        iconUrl = "content/images/route_green.png"
                    } else {
                        iconUrl = "content/images/route_red.png"
                    }
                } else if (fixed.assetTypeName == "NOC") {
                    if (fixed.healthIndicator == true) {
                        iconUrl = "content/images/noc_green.png"
                    } else {
                        iconUrl = "content/images/noc_red.png"
                    }
                }
                //iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(iconSize * 1.1, iconSize * 1.2),
                    },
                })
                startMarker.labelZoom = fixed.label;
                startMarker.assetId = fixed.id;
                function updateMarkerLabelVisibility() {
                    var currentZoom = locations.map.getZoom()
                    if (currentZoom > 12) {
                        if (fixed.assetTypeName == "GP" || fixed.assetTypeName == "ONT") {
                            startMarker.setLabel({
                                color: "#fa1f27ff",
                                fontWeight: "bold",
                                fontSize: "12px",
                                text: fixed.name,
                                className: "asset_label top-label"
                            });
                        }
                    } else {
                        startMarker.setLabel(null);
                    }
                    var style = document.createElement('style');
                    style.innerHTML = '.top-label {' +
                        '    position: relative;' +
                        '    top: 10px;' +
                        '    left: 0;' +
                        '    transform: translateX(10%);' +
                        '    white-space: nowrap;' +
                        '}';
                    document.head.appendChild(style);
                }
                google.maps.event.addListener(locationsCity.mapCity, "zoom_changed", function () {

                    updateMarkerLabelVisibility()
                });
                // if (vm.zoomLevel == 10) {
                //     startMarker.setLabel('');
                // } else if (vm.zoomLevel == 11) {
                //     var label = { color: '#000000', fontWeight: 'bold', fontSize: '12px', text: fixed.name };
                //     startMarker.setLabel(label);
                // }

                // if (fixed.status != null &&
                //     fixed.status === false) {
                //     startMarker.setLabel({
                //         color: 'red',
                //         fontSize: '30px',
                //         fontWeight: '20px',
                //         text: '\u2297'
                //     });
                // }
                // Add marker to the array.

                // markers.push(startMarker);

                switch (level) {
                    case "level1":
                        level1AssetsMarkers.push(startMarker);
                        break;
                    case "level2":
                        level2AssetsMarkers.push(startMarker);
                        break;
                    case "level3":
                        level3AssetsMarkers.push(startMarker);
                        break;
                    case "level4":
                        level4AssetsMarkers.push(startMarker);
                        break;
                    case "level5":
                        level5AssetsMarkers.push(startMarker);
                        break;
                    case "level6":
                        level6AssetsMarkers.push(startMarker);
                        break;
                    case "level7":
                        level7AssetsMarkers.push(startMarker);
                        break;
                    default:
                        markers.push(startMarker);
                        break;
                }
                var infoWindow2 = new google.maps.InfoWindow();
                var infoStr = "";
                var otdr = "";

                var userContent = document.createElement("div"),
                    button;

                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    fixed.name +
                    '</div><div class="infoWindowContent">' +
                    "<b>Lat</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .latitude +
                    "<br><b>Long</b> :" +
                    fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                        .longitude +
                    "<br>" +
                    infoStr +
                    "</div>";

                google.maps.event.addListener(
                    startMarker,
                    "dblclick",
                    function () {
                        infoWindow2.close();
                    }
                );

                var activeInfoWindow;
                var infoWindow2 = new google.maps.InfoWindow({
                    content: userContent,
                });
                // add listener on InfoWindow for click
                // event
                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function () {
                        if (existingHighlightFixed != null) {
                            existingHighlightFixed.setMap(null);
                            existingHighlightFixed = null;
                        }

                        var circle = new google.maps.Circle({
                            map: locations.map, // The map object
                            center: { lat: startMarker.map.center.lat(), lng: startMarker.map.center.lng() }, // Center of the circle (same as the marker)
                            radius: 2, // Radius in meters (1000 meters = 1 kilometer)
                            strokeColor: '#fd7a24', // Color of the circle's border
                            strokeOpacity: 0.8, // Opacity of the circle's border
                            strokeWeight: 2, // Width of the circle's border
                            fillColor: '#fd7a24', // Fill color of the circle
                            fillOpacity: 1, // Opacity of the circle's fill color
                        });

                        // Bind the circle to the marker so it moves with the marker if the marker is draggable
                        circle.bindTo('center', startMarker, 'position');
                        existingHighlightFixed = circle;

                        var fixedHighlightTimer = setTimeout(function () {
                            if (circle != null) {
                                circle.setMap(null);
                                circle = null;
                            }
                        }, 6000);

                        if (activeInfo != null) {
                            activeInfo.close();
                        }
                        closeLastOpenedInfoWindow();

                        AssetByID.get(fixed.id, function (response) {
                            vm.assetRefAttributes = [];
                            if (response.assetReferenceAttributes.length) {
                                response.assetReferenceAttributes.forEach(
                                    function (get) {
                                        get[
                                            "assetAttributeName"
                                        ].assetTypeAttribute.attributeValue =
                                            get[
                                                "assetAttributeName"
                                            ].attributeValue;
                                        vm.assetRefAttributes.push(
                                            get["assetAttributeName"]
                                                .assetTypeAttribute
                                        );
                                        get[
                                            "assetAttributeValue"
                                        ].assetTypeAttribute.attributeValue =
                                            get[
                                                "assetAttributeValue"
                                            ].attributeValue;
                                        vm.assetRefAttributes.push(
                                            get["assetAttributeValue"]
                                                .assetTypeAttribute
                                        );
                                        get[
                                            "assetAttributeImage"
                                        ].assetTypeAttribute.attributeValue =
                                            get["assetAttributeImage"].image;
                                        get[
                                            "assetAttributeImage"
                                        ].assetTypeAttribute.attributeName =
                                            get["assetAttributeImage"].imageName;
                                        get[
                                            "assetAttributeImage"
                                        ].assetTypeAttribute.imageId =
                                            get["assetAttributeImage"].imageId;
                                        get[
                                            "assetAttributeImage"
                                        ].assetTypeAttribute.attributeType =
                                            get["assetAttributeImage"].imageType;
                                        vm.assetRefAttributes.push(
                                            get["assetAttributeImage"]
                                                .assetTypeAttribute
                                        );
                                    }
                                );
                            }
                            vm.assetToEdit = {};
                            vm.assetToEdit = response;
                            vm.assetAttachments = response;
                            var infoWindow2 = new google.maps.InfoWindow();
                            var infoStr = "";
                            var otdr = "";
                            var assetTypeAttributeValuesList =
                                response.assetTypeAttributeValues;
                            assetTypeAttributeValuesList.sort(function (a, b) {
                                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                    nameB = a.assetTypeAttribute.name.toLowerCase();
                                if (nameA < nameB)
                                    // sort string ascending
                                    return -1;
                                if (nameA > nameB) return 1;
                                return 0; // default return value (no sorting)
                            });
                            for (
                                var i = 0;
                                i < assetTypeAttributeValuesList.length;
                                i++
                            ) {
                                var home = assetTypeAttributeValuesList[i];
                                infoStr +=
                                    "<br><b>" +
                                    home.assetTypeAttribute.name +
                                    "</b> : " +
                                    home.attributeValue;
                                otdr = home;
                            }

                            var userContent = document.createElement("div"),
                                btnShowAttributes,
                                btnCr,
                                btnText,
                                btnText1,
                                btnText2,
                                btnEditAsset,
                                btnCreateCase,
                                btnThreePointRef,
                                btnShowAttachments,
                                btnTextBuried,
                                btnBuried;

                            var url = $state.href('asset-detail', { id: response.id });

                            userContent.innerHTML =
                                '<div class="infoWindowhead">' + /* 
                                "<b>Id</b> : <a target='_blank' href='" + url + "'>" + */ response.id +
                                "</a><br><b>Name</b>" +
                                response.name +
                                '</div><div class="infoWindowContent">' +
                                "<b>Asset Type</b> : " +
                                fixed.assetTypeName +
                                "<br><b>Latitude</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].latitude +
                                "<br><b>Longitude</b> :" +
                                fixed.assetCoordinates[
                                    fixed.assetCoordinates.length - 1
                                ].longitude +
                                "</div>";

                            vm.assetTitle = response.name;
                            btnText = userContent.appendChild(
                                document.createElement("b")
                            );

                            btnText.textContent = "Accessible";
                            btnText.style.marginRight = "4px";

                            btnCr = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnCr.style.marginRight = "18px";
                            btnCr.type = "checkbox";
                            btnCr.id = response.id;

                            btnCr.checked = response.accessible;

                            btnText1 = userContent.appendChild(
                                document.createElement("b")
                            );
                            /* if (
                                ($scope.variableHealth == true &&
                                    response.healthIndicator == true) ||
                                ($scope.variableHealth == true &&
                                    response.healthIndicator == false)
                            ) {
                                btnText1.textContent =
                                    "Remarks:" + response.healthRemarks;
                                btnText1.style.marginLeft = "4px";
                            } */

                            var attr = document.createAttribute("data-toggle");
                            attr.value = "modal";
                            var attr1 = document.createAttribute("data-target");
                            attr1.value = "#myModalMap";

                            btnCr.setAttributeNode(attr);
                            btnCr.setAttributeNode(attr1);

                            vm.changeAcessible = response.accessible
                                ? "Inaccessible"
                                : "Accessible";

                            var yes = document.getElementById("yesButton");

                            yes.onclick = function () {
                                if (btnCr.checked == true) {
                                    response.accessible = true;
                                }
                                if (btnCr.checked == false) {
                                    response.accessible = false;
                                }
                                response.assetImages = []
                                Asset.update(response);
                            };

                            var noBtn = document.getElementById("noButton");

                            noBtn.onclick = function () {
                                if (btnCr.checked == true) {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = false;
                                } else {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = true;
                                }
                            };

                            var closeBtn = document.getElementById(
                                "closeButton"
                            );

                            closeBtn.onclick = function () {
                                if (btnCr.checked == true) {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = false;
                                } else {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = true;
                                }
                            };

                            var closeModal = document.getElementById(
                                "myModalMap"
                            );

                            closeModal.onclick = function (e) {
                                if (e.target == this) {
                                    if (btnCr.checked == true) {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = false;
                                    } else {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = true;
                                    }
                                }
                            };

                            var brBreak = userContent.appendChild(
                                document.createElement("br")
                            );
                            var brBreak1 = userContent.appendChild(
                                document.createElement("br")
                            );


                            if (response.assetTypeName == "Chamber") {
                                btnTextBuried = userContent.appendChild(
                                    document.createElement("b")
                                );
                                btnTextBuried.textContent = "Buried Chamber";
                                btnTextBuried.style.marginRight = "4px";

                                btnBuried = userContent.appendChild(
                                    document.createElement("input")
                                );
                                btnBuried.style.marginRight = "18px";
                                btnBuried.type = "checkbox";
                                btnBuried.checked = response.burried;
                                btnBuried.id = response.id + '0';

                                var brBreak = userContent.appendChild(
                                    document.createElement("br")
                                );
                                var brBreak1 = userContent.appendChild(
                                    document.createElement("br")
                                );

                                var attr = document.createAttribute("data-toggle");
                                attr.value = "modal";
                                var attr1 = document.createAttribute("data-target");
                                attr1.value = "#myModalBuried";

                                btnBuried.setAttributeNode(attr);
                                btnBuried.setAttributeNode(attr1);

                                var yesBurried = document.getElementById("yesButtonBurried");

                                yesBurried.onclick = function () {
                                    if (btnBuried.checked == true) {
                                        response.burried = true;
                                    }
                                    if (btnBuried.checked == false) {
                                        response.burried = false;
                                    }
                                    response.assetImages = []
                                    Asset.update(response, onSaveSuccessBuried);
                                };

                                var noBtnBurried = document.getElementById("noButtonBurried");

                                noBtnBurried.onclick = function () {
                                    if (btnBuried.checked == true) {
                                        document.getElementById(
                                            btnBuried.id
                                        ).checked = false;
                                    } else {
                                        document.getElementById(
                                            btnBuried.id
                                        ).checked = true;
                                    }
                                };

                                var closeBtnBurried = document.getElementById(
                                    "closeButtonBurried"
                                );

                                closeBtnBurried.onclick = function () {
                                    if (btnBuried.checked == true) {
                                        document.getElementById(
                                            btnBuried.id
                                        ).checked = false;
                                    } else {
                                        document.getElementById(
                                            btnBuried.id
                                        ).checked = true;
                                    }
                                };

                                /* var closeModalBurried = document.getElementById(
                                    "myModalBuried"
                                );
    
                                closeModalBurried.onclick = function (e) {
                                    if (e.target == this) {
                                        if (btnBuried.checked == true) {
                                            document.getElementById(
                                                btnBuried.id
                                            ).checked = false;
                                        } else {
                                            document.getElementById(
                                                btnBuried.id
                                            ).checked = true;
                                        }
                                    }
                                }; */
                            }


                            btnCreateCase = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnCreateCase.type = "button";
                            btnCreateCase.value = "Create Incident";
                            btnCreateCase.className = "button";

                            btnEditAsset = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnEditAsset.type = "button";
                            btnEditAsset.value = "Edit Asset";
                            btnEditAsset.className = "button";

                            btnShowAttributes = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnShowAttributes.type = "button";
                            btnShowAttributes.value = "Show Attributes";
                            btnShowAttributes.className = "button";

                            btnThreePointRef = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnThreePointRef.type = "button";
                            btnThreePointRef.value = "3 Point Reference";
                            btnThreePointRef.className = "button";

                            vm.nameImages = [];
                            vm.assetIdImg = response.id;
                            response.assetImages.forEach(function (item) {
                                vm.nameImages.push(item);
                            });

                            btnShowAttachments = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnShowAttachments.type = "button";
                            btnShowAttachments.value = "Attachments";
                            btnShowAttachments.className = "button";

                            google.maps.event.addDomListener(
                                btnShowAttachments,
                                "click",
                                function () {
                                    vm.assetAttachments.assetImages = [];
                                    $("#modalAttachment").show();
                                }
                            );

                            google.maps.event.addDomListener(
                                btnCreateCase,
                                "click",
                                function () {
                                    $rootScope.createCaseFromAssetMap = [
                                        response,
                                    ];
                                    $state.go("tr-case.new", {
                                        lat:
                                            fixed.assetCoordinates[
                                                fixed.assetCoordinates.length -
                                                1
                                            ].latitude,
                                        lng:
                                            fixed.assetCoordinates[
                                                fixed.assetCoordinates.length -
                                                1
                                            ].longitude,
                                        desc: "Incident for " + fixed.name,
                                    });
                                }
                            );

                            google.maps.event.addDomListener(
                                btnEditAsset,
                                "click",
                                function () {
                                    // $state.go("asset.edit", {
                                    //     id: fixed.id,
                                    // });

                                    document.getElementById(
                                        "assetEditName"
                                    ).textContent =
                                        "Asset - " + vm.assetToEdit.name;
                                    editAssetOnMapView(fixed);
                                }
                            );

                            google.maps.event.addDomListener(
                                btnShowAttributes,
                                "click",
                                function () {
                                    showAssetAttributesModal(response);
                                }
                            );

                            google.maps.event.addDomListener(
                                btnThreePointRef,
                                "click",
                                function () {
                                    showThreePontReferenceModal(response);
                                }
                            );

                            vm.closeInfoWindow = new google.maps.InfoWindow({
                                content: userContent,
                            });
                            if (prevInfoWindow != null) prevInfoWindow.close();
                            vm.closeInfoWindow.open(locations.map, startMarker);
                            setTimeout(function () {
                                vm.closeInfoWindow.close();
                            }, 10000);

                            activeInfoWindow = vm.closeInfoWindow;
                            prevInfoWindow = vm.closeInfoWindow;
                        });
                    }
                );
                openedInfoWindow = infoWindow2;
            });
        }

        function drawFixedAssetCity(fixed, hasParent, level) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;

                if (fixed.assetTypeName == "Router") {
                    if (fixed.healthIndicator == true) {
                        iconUrl = "content/images/route_green.png";
                    } else {
                        iconUrl = "content/images/route_red.png";
                    }
                } else if (fixed.assetTypeName == "NOC") {
                    if (fixed.healthIndicator == true) {
                        iconUrl = "content/images/noc_green.png";
                    } else {
                        iconUrl = "content/images/noc_red.png";
                    }
                }

                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevelCity == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevelCity == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker;

                if (fixed.amcStatus != null && fixed.amcStatus != undefined) {
                    var baseIconUrl = fixed.assetTypeImagePath;
                    var hueShift = 220; // try 60 for yellow, 120 for cyan, 180 for blue, 300 for magenta
  
                    if (fixed.amcStatus == "AMC") {
                        hueShift = 25;
                    } else if (fixed.amcStatus == "NON-AMC" || fixed.amcStatus == "Non-AMC") {
                        hueShift = 280;
                    }

                    recolorPngHue(baseIconUrl, hueShift, function (newIconUrl) {
                        startMarker = new google.maps.Marker({
                            position: { lat: fixed.assetCoordinates[0].latitude, lng: fixed.assetCoordinates[0].longitude },
                            map: locationsCity.mapCity,
                            icon: {
                                url: newIconUrl,
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                labelOrigin: new google.maps.Point(25, 22)
                            },
                            name: fixed.name
                        });
                        processCityMarker(startMarker, fixed, level);
                            
                        $scope.showDropDown = false
                    });
                    if (!startMarker || !startMarker.getIcon) {
                        // console.warn('Marker not ready yet.');
                        return;
                    }
                    var icon = startMarker.getIcon();
                    icon.scaledSize = new google.maps.Size(48, 48);
                    startMarker.setIcon(icon);

                } else {
                    startMarker = new google.maps.Marker({
                        map: locationsCity.mapCity,
                        position: { lat: fixed.assetCoordinates[0].latitude, lng: fixed.assetCoordinates[0].longitude },
                        icon: {
                            scaledSize: new google.maps.Size(iconSize, iconSize),
                            url: iconUrl,
                            anchor: new google.maps.Point(
                                iconSize / 2,
                                iconSize / 2
                            ),
                            labelOrigin: new google.maps.Point(iconSize * 1.1, iconSize * 1.2),
                        },
                    });
                    processCityMarker(startMarker, fixed, level);

                }
            });
         
        }
vm.cityAssetLegends = [];
vm.cityLegendIconCache = {};

function buildCityAssetLegends() {

    vm.cityAssetLegends = [];

    var uniqueMap = {};

    angular.forEach(vm.mapAssetsCity, function (fixed) {

        var iconUrl = fixed.assetTypeImagePath;
        var status = "";
        var hueShift = null;

        if (fixed.assetTypeName == "Router") {

            if (fixed.healthIndicator == true) {
                iconUrl = "content/images/route_green.png";
                status = "HEALTHY";
            } else {
                iconUrl = "content/images/route_red.png";
                status = "DOWN";
            }

        } else if (fixed.assetTypeName == "NOC") {

            if (fixed.healthIndicator == true) {
                iconUrl = "content/images/noc_green.png";
                status = "HEALTHY";
            } else {
                iconUrl = "content/images/noc_red.png";
                status = "DOWN";
            }

        }
        else if (fixed.amcStatus != null && fixed.amcStatus != undefined) {

            hueShift = 220;
            status = fixed.amcStatus;

            if (fixed.amcStatus == "AMC") {
                hueShift = 25;
            } else if (fixed.amcStatus == "NON-AMC" || fixed.amcStatus == "Non-AMC") {
                hueShift = 280;
            }
        }

        var key = fixed.assetTypeName + "_" + status;

        if (!uniqueMap[key]) {
            uniqueMap[key] = {
                name: fixed.assetTypeName,
                status: status,
                icon: iconUrl,
                hue: hueShift
            };
        }
    });

    angular.forEach(uniqueMap, function (legendItem) {

        // If hue is present → recolor
        if (legendItem.hue !== null) {

            var cacheKey = legendItem.icon + "_" + legendItem.hue;

            if (vm.cityLegendIconCache[cacheKey]) {

                vm.cityAssetLegends.push({
                    name: legendItem.name,
                    status: legendItem.status,
                    coloredIcon: vm.cityLegendIconCache[cacheKey]
                });

            } else {

                recolorPngHue(legendItem.icon, legendItem.hue, function (newIconUrl) {

                    vm.cityLegendIconCache[cacheKey] = newIconUrl;

                    vm.cityAssetLegends.push({
                        name: legendItem.name,
                        status: legendItem.status,
                        coloredIcon: newIconUrl
                    });

                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });
            }

        } else {

            // No recolor required (Router/NOC health or normal asset)

            vm.cityAssetLegends.push({
                name: legendItem.name,
                status: legendItem.status,
                coloredIcon: legendItem.icon
            });
        }
    });
}

        function processCityMarker(startMarker, fixed, level) {

            if (fixed.amcStatus == null || fixed.amcStatus == undefined) {
                fixed.amcStatus = "Not Available";
            }
            // function updateMarkerLabelVisibility() {
            //     var currentZoom = locationsCity.mapCity.getZoom()
            //     if (currentZoom > 12) {
            //         if (fixed.assetTypeName == "GP" || fixed.assetTypeName == "ONT") {
            //             startMarker.setLabel({
            //                 color: "#fa1f27ff",
            //                 fontWeight: "bold",
            //                 fontSize: "12px",
            //                 text: fixed.name,
            //                 className: "asset_label top-label"
            //             });
            //         }
            //     } else {
            //         startMarker.setLabel(null);
            //     }
            //     var style = document.createElement('style');
            //     style.innerHTML = '.top-label {' +
            //         '    position: relative;' +
            //         '    top: 10px;' +
            //         '    left: 0;' +
            //         '    transform: translateX(10%);' +
            //         '    white-space: nowrap;' +
            //         '}';
            //     document.head.appendChild(style);
            // }
            // google.maps.event.addListener(locationsCity.mapCity, "zoom_changed", function () {

            //     updateMarkerLabelVisibility()
            // });
            // if (vm.zoomLevel == 10) {
            //     startMarker.setLabel('');
            // } else if (vm.zoomLevel == 11) {
            //     var label = { color: '#000000', fontWeight: 'bold', fontSize: '12px', text: fixed.name };
            //     startMarker.setLabel(label);
            // }

            // if (fixed.status != null &&
            //     fixed.status === false) {
            //     startMarker.setLabel({
            //         color: 'red',
            //         fontSize: '30px',
            //         fontWeight: '20px',
            //         text: '\u2297'
            //     });
            // }
            // Add marker to the array.

            // markers.push(startMarker);

            switch (level) {
                case "level1":
                    level1AssetsMarkersCity.push(startMarker);
                    break;
                case "level2":
                    level2AssetsMarkersCity.push(startMarker);
                    break;
                case "level3":
                    level3AssetsMarkersCity.push(startMarker);
                    break;
                case "level4":
                    level4AssetsMarkersCity.push(startMarker);
                    break;
                case "level5":
                    level5AssetsMarkersCity.push(startMarker);
                    break;
                default:
                    markersCity.push(startMarker);
                    break;
            }
            var infoWindow2 = new google.maps.InfoWindow();
            var infoStr = "";
            var otdr = "";
            var userContent = document.createElement("div"),
                button;
            userContent.innerHTML =
                '<div class="infoWindowhead">' +
                "<b>Name</b> : " +
                fixed.name +
                '</div><div class="infoWindowContent">' +
                "<b>Asset Type</b> : " +
                fixed.assetTypeName +
                "<br><b>Amc Status</b> : " +
                fixed.amcStatus +
 				"<br><b>Availability</b> : " +
                fixed.availability + " %" +
                "<br><b>Latitude</b> : " +
                fixed.assetCoordinates[
                    fixed.assetCoordinates.length - 1
                ].latitude +
                "<br><b>Longitude</b> : " +
                fixed.assetCoordinates[
                    fixed.assetCoordinates.length - 1
                ].longitude +
                "<br>" +
                infoStr +
                "</div>";

            google.maps.event.addListener(
                startMarker,
                "dblclick",
                function () {
                    infoWindow2.close();
                }
            );

            var activeInfoWindow;
            var infoWindow2 = new google.maps.InfoWindow({
                content: userContent,
            });
            // add listener on InfoWindow for click
            // event
            google.maps.event.addListener(
                startMarker,
                "click",
                function () {
                    if (activeInfoCity != null) {
                        activeInfoCity.close();
                    }
                    AssetByID.get(fixed.id, function (response) {
                        vm.assetToEdit = {};
                        vm.assetToEdit = response;
                        var infoWindow2 = new google.maps.InfoWindow();
                        var infoStr = "";
                        var otdr = "";
                        var assetTypeAttributeValuesList =
                            response.assetTypeAttributeValues;
                        assetTypeAttributeValuesList.sort(function (a, b) {
                            var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                nameB = a.assetTypeAttribute.name.toLowerCase();
                            if (nameA < nameB)
                                // sort string ascending
                                return -1;
                            if (nameA > nameB) return 1;
                            return 0; // default return value (no sorting)
                        });
                        for (
                            var i = 0;
                            i < assetTypeAttributeValuesList.length;
                            i++
                        ) {
                            var home = assetTypeAttributeValuesList[i];
                            infoStr +=
                                "<br><b>" +
                                home.assetTypeAttribute.name +
                                "</b> : " +
                                home.attributeValue;
                            otdr = home;
                        }

                        var userContent = document.createElement("div"),
                            btnShowAttributes,
                            btnCr,
                            btnText,
                            btnEditAsset,
                            btnCreateCase,
                            btnThreePointRef;

                        userContent.innerHTML =
                            '<div class="infoWindowhead">' +
                            "<b>Name</b> : " +
                            fixed.name +
                            '</div><div class="infoWindowContent">' +
                            "<b>Asset Type</b> : " +
                            fixed.assetTypeName +
                            "<br><b>Amc Status</b> : " +
                            fixed.amcStatus +
							"<br><b>Availability</b> : " +
                			fixed.availability + " %" +
                            "<br><b>Latitude</b> : " +
                            fixed.assetCoordinates[
                                fixed.assetCoordinates.length - 1
                            ].latitude +
                            "<br><b>Longitude</b> : " +
                            fixed.assetCoordinates[
                                fixed.assetCoordinates.length - 1
                            ].longitude +
                            "<br>" +
                            "</div>";

                        vm.assetTitle = startMarker.title;
                        btnText = userContent.appendChild(
                            document.createElement("b")
                        );

                        btnText.textContent = "Accessible";
                        btnText.style.marginRight = "4px";

                        btnCr = userContent.appendChild(
                            document.createElement("input")
                        );
                        var attr = document.createAttribute("data-toggle");
                        attr.value = "modal";
                        var attr1 = document.createAttribute("data-target");
                        attr1.value = "#myModalMap";

                        btnCr.setAttributeNode(attr);
                        btnCr.setAttributeNode(attr1);

                        btnCr.style.marginRight = "18px";
                        btnCr.type = "checkbox";
                        btnCr.id = response.id;

                        btnCr.checked = response.accessible;

                        vm.changeAcessible = response.accessible
                            ? "Inaccessible"
                            : "Accessible";

                        var yes = document.getElementById("yesButton");

                        yes.onclick = function () {
                            if (btnCr.checked == true) {
                                response.accessible = true;
                            }
                            if (btnCr.checked == false) {
                                response.accessible = false;
                            }
                            response.assetImages = []
                            Asset.update(response);
                        };

                        var noBtn = document.getElementById("noButton");

                        noBtn.onclick = function () {
                            if (btnCr.checked == true) {
                                document.getElementById(
                                    btnCr.id
                                ).checked = false;
                            } else {
                                document.getElementById(
                                    btnCr.id
                                ).checked = true;
                            }
                        };

                        var closeBtn = document.getElementById(
                            "closeButton"
                        );

                        closeBtn.onclick = function () {
                            if (btnCr.checked == true) {
                                document.getElementById(
                                    btnCr.id
                                ).checked = false;
                            } else {
                                document.getElementById(
                                    btnCr.id
                                ).checked = true;
                            }
                        };

                        var closeModal = document.getElementById(
                            "myModalMap"
                        );

                        closeModal.onclick = function (e) {
                            if (e.target == this) {
                                if (btnCr.checked == true) {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = false;
                                } else {
                                    document.getElementById(
                                        btnCr.id
                                    ).checked = true;
                                }
                            }
                        };

                        var brBreak = userContent.appendChild(
                            document.createElement("br")
                        );
                        var brBreak1 = userContent.appendChild(
                            document.createElement("br")
                        );

                        btnCreateCase = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnCreateCase.type = "button";
                        btnCreateCase.value = "Create Incident";
                        btnCreateCase.className = "button";

                        btnEditAsset = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnEditAsset.type = "button";
                        btnEditAsset.value = "Edit Asset";
                        btnEditAsset.className = "button";

                        btnShowAttributes = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnShowAttributes.type = "button";
                        btnShowAttributes.value = "Show Attributes";
                        btnShowAttributes.className = "button";

                        btnThreePointRef = userContent.appendChild(
                            document.createElement("input")
                        );
                        btnThreePointRef.type = "button";
                        btnThreePointRef.value = "3 Point Reference";
                        btnThreePointRef.className = "button";

                        google.maps.event.addDomListener(
                            btnCreateCase,
                            "click",
                            function () {
                                $state.go("tr-case.new", {
                                    lat:
                                        fixed.assetCoordinates[
                                            fixed.assetCoordinates.length -
                                            1
                                        ].latitude,
                                    lng:
                                        fixed.assetCoordinates[
                                            fixed.assetCoordinates.length -
                                            1
                                        ].longitude,
                                    desc: "Incident for " + fixed.name,
                                });
                            }
                        );

                        google.maps.event.addDomListener(
                            btnEditAsset,
                            "click",
                            function () {
                                // $state.go("asset.edit", {
                                //     id: fixed.id,
                                // });

                                document.getElementById(
                                    "assetEditName"
                                ).textContent =
                                    "Asset - " + vm.assetToEdit.name;
                                editAssetOnMapView(fixed);
                            }
                        );

                        google.maps.event.addDomListener(
                            btnShowAttributes,
                            "click",
                            function () {
                                showAssetAttributesModal(response);
                            }
                        );

                        google.maps.event.addDomListener(
                            btnThreePointRef,
                            "click",
                            function () {
                                showThreePontReferenceModal(response);
                            }
                        );

                        var infoWindow2 = new google.maps.InfoWindow({
                            content: userContent,
                        });
                        if (prevInfoWindow != null) prevInfoWindow.close();
                        infoWindow2.open(
                            locationsCity.mapCity,
                            startMarker
                        );
                        setTimeout(function () {
                            infoWindow2.close();
                        }, 10000);

                        activeInfoWindow = infoWindow2;
                        prevInfoWindow = infoWindow2;
                    });
                }
            );
            openedInfoWindow = infoWindow2;
        }


        function recolorPngHue(url, hueShiftDeg, callback) {
            var img = new Image();
            img.crossOrigin = 'Anonymous';

            img.onload = function () {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;

                // Draw original image
                ctx.drawImage(img, 0, 0);

                // Apply hue-rotation filter
                ctx.filter = 'hue-rotate(' + hueShiftDeg + 'deg) saturate(1.0) brightness(1.4)';
                ctx.drawImage(img, 0, 0);

                callback(canvas.toDataURL());
            };

            img.src = url;
        }

        function drawFixedAssetCityAmc(fixed, hasParent, level) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }
                var infoWindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;

                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevelCityAmc == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevelCityAmc == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }
                var startMarker;
                if (fixed.amcStatus != null && fixed.amcStatus != undefined) {
                    var baseIconUrl = fixed.assetTypeImagePath;
                    var hueShift = 220; // try 60 for yellow, 120 for cyan, 180 for blue, 300 for magenta

                    if (fixed.amcStatus == "AMC") {
                        hueShift = 25;
                    } else if (fixed.amcStatus == "NON-AMC" || fixed.amcStatus == "Non-AMC") {
                        hueShift = 280;
                    }

                    recolorPngHue(baseIconUrl, hueShift, function (newIconUrl) {
                        startMarker = new google.maps.Marker({
                            position: { lat: fixed.assetCoordinates[0].latitude, lng: fixed.assetCoordinates[0].longitude },
                            map: locationsCityAmc.mapCity,
                            icon: {
                                url: newIconUrl,
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                labelOrigin: new google.maps.Point(25, 22)
                            },
                            name: fixed.name
                        });

                        // assetMarkers.push(startMarker)
                        var infowindow = new google.maps.InfoWindow();

                        google.maps.event.addListener(startMarker, 'click', function () {
                            if (openedInfoWindow !== null) {
                                openedInfoWindow.close();
                            }
                            var contentString = document.createElement("div"),
                                btnShowImage,
                                btnShowAsset
                            contentString.innerHTML =
                                '<div class="infoWindowhead">' +
                                '<b>ID: ' + fixed.id + '</b><br>' +
                                '<b>Name: ' + fixed.name + '</b><br>' +
                                '<b>AMC Status: ' + fixed.amcStatus + '</b><br>' +
								'<b>Availability: ' + fixed.availability + '</b><br>' +
                                '<b>AssetTypeName: ' + fixed.assetTypeName + '</b><br>' +
                                '<b>Latitude: ' + fixed.assetCoordinates[0].latitude + '</b><br>' +
                                '<b>Longitude: ' + fixed.assetCoordinates[0].longitude + '</b>' +
                                '<br><br><button onclick="copyToClipboard(\'' + fixed.assetCoordinates[0].latitude + ',' + fixed.assetCoordinates[0].longitude + '\', this)" ' +
                                'style="font-size:10px; padding:2px 5px; margin-left:5px; cursor:pointer;">Copy</button>' +
                                '</div>';

                            infowindow.setContent(contentString);
                            infowindow.open(locationsCityAmc.mapCity, startMarker);
                            openedInfoWindow = infowindow;

                        });
                        $scope.showDropDown = false
                    });
                    if (!startMarker || !startMarker.getIcon) {
                        // console.warn('Marker not ready yet.');
                        return;
                    }
                    var icon = startMarker.getIcon();
                    icon.scaledSize = new google.maps.Size(48, 48);
                    startMarker.setIcon(icon);

                } else {
                    startMarker = new google.maps.Marker({
                        map: locationsCityAmc.mapCity,
                        position: new google.maps.LatLng(
                            value1.latitude,
                            value1.longitude
                        ),
                        icon: {
                            scaledSize: new google.maps.Size(iconSize, iconSize),
                            url: iconUrl,
                            anchor: new google.maps.Point(
                                iconSize / 2,
                                iconSize / 2
                            ),
                            labelOrigin: new google.maps.Point(iconSize * 1.1, iconSize * 1.2),
                        },
                    });

                    switch (level) {
                        case "level1":
                            level1AssetsMarkersCityAmc.push(startMarker);
                            break;
                        case "level2":
                            level2AssetsMarkersCityAmc.push(startMarker);
                            break;
                        case "level3":
                            level3AssetsMarkersCityAmc.push(startMarker);
                            break;
                        case "level4":
                            level4AssetsMarkersCityAmc.push(startMarker);
                            break;
                        case "level5":
                            level5AssetsMarkersCityAmc.push(startMarker);
                            break;
                        default:
                            markersCityAmc.push(startMarker);
                            break;
                    }
                    var infoWindow2 = new google.maps.InfoWindow();
                    var infoStr = "";
                    var otdr = "";

                    var userContent = document.createElement("div"),
                        button;

                    userContent.innerHTML =
                        '<div class="infoWindowhead">' +
                        startMarker.title +
                        '</div><div class="infoWindowContent">' +
                        "<b>Lat</b> :" +
                        fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                            .latitude +
                        "<br><b>Long</b> :" +
                        fixed.assetCoordinates[fixed.assetCoordinates.length - 1]
                            .longitude +
                        "<br>" +
                        infoStr +
                        "</div>";

                    google.maps.event.addListener(
                        startMarker,
                        "dblclick",
                        function () {
                            infoWindow2.close();
                        }
                    );

                    var activeInfoWindow;
                    var infoWindow2 = new google.maps.InfoWindow({
                        content: userContent,
                    });
                    // add listener on InfoWindow for click
                    // event
                    google.maps.event.addListener(
                        startMarker,
                        "click",
                        function () {
                            if (activeInfoCity != null) {
                                activeInfoCity.close();
                            }
                            AssetByID.get(fixed.id, function (response) {
                                vm.assetToEdit = {};
                                vm.assetToEdit = response;
                                var infoWindow2 = new google.maps.InfoWindow();
                                var infoStr = "";
                                var otdr = "";
                                var assetTypeAttributeValuesList =
                                    response.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (a, b) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = a.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        home.attributeValue;
                                    otdr = home;
                                }

                                var userContent = document.createElement("div"),
                                    btnShowAttributes,
                                    btnCr,
                                    btnText,
                                    btnEditAsset,
                                    btnCreateCase,
                                    btnThreePointRef;

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' +
                                    "<b>Name</b> : " +
                                    fixed.name +
                                    '</div><div class="infoWindowContent">' +
                                    "<b>Asset Type</b> : " +
                                    fixed.assetTypeName +
                                    "<br><b>Amc Status</b> : " +
                                    fixed.amcStatus +
									"<br><b>Availability</b> : " +
                					fixed.availability + " %" +
                                    "<br><b>Latitude</b> : " +
                                    fixed.assetCoordinates[
                                        fixed.assetCoordinates.length - 1
                                    ].latitude +
                                    "<br><b>Longitude</b> : " +
                                    fixed.assetCoordinates[
                                        fixed.assetCoordinates.length - 1
                                    ].longitude +
                                    "</div><br>";

                                vm.assetTitle = startMarker.title;
                                btnText = userContent.appendChild(
                                    document.createElement("b")
                                );

                                btnText.textContent = "Accessible";
                                btnText.style.marginRight = "4px";

                                btnCr = userContent.appendChild(
                                    document.createElement("input")
                                );
                                var attr = document.createAttribute("data-toggle");
                                attr.value = "modal";
                                var attr1 = document.createAttribute("data-target");
                                attr1.value = "#myModalMap";

                                btnCr.setAttributeNode(attr);
                                btnCr.setAttributeNode(attr1);

                                btnCr.style.marginRight = "18px";
                                btnCr.type = "checkbox";
                                btnCr.id = response.id;

                                btnCr.checked = response.accessible;

                                vm.changeAcessible = response.accessible
                                    ? "Inaccessible"
                                    : "Accessible";

                                var yes = document.getElementById("yesButton");

                                yes.onclick = function () {
                                    if (btnCr.checked == true) {
                                        response.accessible = true;
                                    }
                                    if (btnCr.checked == false) {
                                        response.accessible = false;
                                    }
                                    response.assetImages = []
                                    Asset.update(response);
                                };

                                var noBtn = document.getElementById("noButton");

                                noBtn.onclick = function () {
                                    if (btnCr.checked == true) {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = false;
                                    } else {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = true;
                                    }
                                };

                                var closeBtn = document.getElementById(
                                    "closeButton"
                                );

                                closeBtn.onclick = function () {
                                    if (btnCr.checked == true) {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = false;
                                    } else {
                                        document.getElementById(
                                            btnCr.id
                                        ).checked = true;
                                    }
                                };

                                var closeModal = document.getElementById(
                                    "myModalMap"
                                );

                                closeModal.onclick = function (e) {
                                    if (e.target == this) {
                                        if (btnCr.checked == true) {
                                            document.getElementById(
                                                btnCr.id
                                            ).checked = false;
                                        } else {
                                            document.getElementById(
                                                btnCr.id
                                            ).checked = true;
                                        }
                                    }
                                };

                                var brBreak = userContent.appendChild(
                                    document.createElement("br")
                                );
                                var brBreak1 = userContent.appendChild(
                                    document.createElement("br")
                                );

                                btnCreateCase = userContent.appendChild(
                                    document.createElement("input")
                                );

                                btnCreateCase.type = "button";
                                btnCreateCase.value = "Create Incident";
                                btnCreateCase.className = "button";

                                btnEditAsset = userContent.appendChild(
                                    document.createElement("input")
                                );

                                btnEditAsset.type = "button";
                                btnEditAsset.value = "Edit Asset";
                                btnEditAsset.className = "button";

                                btnShowAttributes = userContent.appendChild(
                                    document.createElement("input")
                                );

                                btnShowAttributes.type = "button";
                                btnShowAttributes.value = "Show Attributes";
                                btnShowAttributes.className = "button";

                                btnThreePointRef = userContent.appendChild(
                                    document.createElement("input")
                                );
                                btnThreePointRef.type = "button";
                                btnThreePointRef.value = "3 Point Reference";
                                btnThreePointRef.className = "button";

                                google.maps.event.addDomListener(
                                    btnCreateCase,
                                    "click",
                                    function () {
                                        $state.go("tr-case.new", {
                                            lat:
                                                fixed.assetCoordinates[
                                                    fixed.assetCoordinates.length -
                                                    1
                                                ].latitude,
                                            lng:
                                                fixed.assetCoordinates[
                                                    fixed.assetCoordinates.length -
                                                    1
                                                ].longitude,
                                            desc: "Incident for " + fixed.name,
                                        });
                                    }
                                );

                                google.maps.event.addDomListener(
                                    btnEditAsset,
                                    "click",
                                    function () {
                                        // $state.go("asset.edit", {
                                        //     id: fixed.id,
                                        // });

                                        document.getElementById(
                                            "assetEditName"
                                        ).textContent =
                                            "Asset - " + vm.assetToEdit.name;
                                        editAssetOnMapView(fixed);
                                    }
                                );

                                google.maps.event.addDomListener(
                                    btnShowAttributes,
                                    "click",
                                    function () {
                                        showAssetAttributesModal(response);
                                    }
                                );

                                google.maps.event.addDomListener(
                                    btnThreePointRef,
                                    "click",
                                    function () {
                                        showThreePontReferenceModal(response);
                                    }
                                );

                                var infoWindow2 = new google.maps.InfoWindow({
                                    content: userContent,
                                });
                                if (prevInfoWindow != null) prevInfoWindow.close();
                                infoWindow2.open(
                                    locationsCity.mapCity,
                                    startMarker
                                );
                                setTimeout(function () {
                                    infoWindow2.close();
                                }, 10000);

                                activeInfoWindow = infoWindow2;
                                prevInfoWindow = infoWindow2;
                            });
                        }
                    );
                    openedInfoWindow = infoWindow2;
                }


            });
        }

        function drawPolyline(spread, map, level) {
            var spreadAssetCoordinates = [];
            var spreadColor = 0;
            var spreadWidth = 0;
            var spreadOpacity = 0;

            vm.assetTypes.forEach(function (assetType) {
                if (assetType.name == spread.assetTypeName) {
                    spreadColor = assetType.colorcode;
                    spreadWidth = assetType.lineWidth * 0.05;
                    spreadOpacity = assetType.transparency * 0.01;
                }
            });

            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = null;
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spreadColor;
                }
                var polylineWeight = spreadWidth;
                var strokeOpacityVal = spreadOpacity;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {

                        if (existingHighlight != null) {
                            existingHighlight.setMap(null);
                            existingHighlight = null;
                        }

                        var polylinepathHighlight = new google.maps.Polyline({
                            path: spreadAssetCoordinates,
                            strokeColor: "#FFFF00",
                            strokeOpacity: 0.6,
                            strokeWeight: 19,
                        });


                        polylinepathHighlight.setMap(locations.map);
                        existingHighlight = polylinepathHighlight;

                        var polylineTimer = setTimeout(function () {
                            if (polylinepathHighlight != null) {
                                polylinepathHighlight.setMap(null);
                                polylinepathHighlight = null;
                            }
                        }, 10000);

                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        closeLastOpenedInfoWindow();
                        var disVal = 0;
                        var cLocations = [];

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD" || spread.assetType.layout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                vm.assetToEdit = {};
                                vm.assetToEdit = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }
                                var assetTypeAttrPopupNames = [];
                                assetVal.assetType.assetTypeAttributes.forEach(
                                    function (assetTypeAttrVal) {
                                        if (
                                            assetTypeAttrVal.assetTypePopupDisplay ==
                                            true
                                        ) {
                                            assetTypeAttrPopupNames.push(
                                                assetTypeAttrVal.name
                                            );
                                        }
                                    }
                                );
                                var getAttribute =
                                    assetVal.assetTypeAttributeValues;
                                var userContent = document.createElement("div"),
                                    btnShowAttributes,
                                    btnEditAssets;

                                var url = $state.href('asset-detail', { id: spread.id });

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' + "<b>Id</b> : <a target='_blank' href='" + url + "'>" + spread.id +
                                    "</a><br><b>Name : </b> " +
                                    spread.name +
                                    "<br><b>Asset Type : </b> " +
                                    spread.assetType.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km";

                                for (i = 0; i < getAttribute.length; i++) {
                                    if (
                                        assetTypeAttrPopupNames.includes(
                                            getAttribute[i].assetTypeAttribute
                                                .name
                                        )
                                    ) {
                                        userContent.innerHTML +=
                                            "<b>" +
                                            getAttribute[i].assetTypeAttribute
                                                .name +
                                            "</b>" +
                                            " : " +
                                            getAttribute[i].attributeValue +
                                            "</br>";
                                    }
                                }


                                if (accessEditAsset) {
                                    btnEditAssets = userContent.appendChild(
                                        document.createElement("input")
                                    );

                                    btnEditAssets.type = "button";
                                    btnEditAssets.value = "Edit Asset";
                                    btnEditAssets.className = "button";

                                    google.maps.event.addDomListener(
                                        btnEditAssets,
                                        "click",
                                        function () {
                                            $(":file").filestyle("clear");
                                            $("#assetEditModal").show();
                                        }
                                    );
                                }

                                btnShowAttributes = userContent.appendChild(
                                    document.createElement("input")
                                );

                                btnShowAttributes.type = "button";
                                btnShowAttributes.value = "Show Attributes";
                                btnShowAttributes.className = "button";

                                google.maps.event.addDomListener(
                                    btnShowAttributes,
                                    "click",
                                    function () {
                                        showAssetAttributesModal(assetVal);
                                    }
                                );
                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });

                                if (infowindow != null) {
                                    infowindow.setPosition(event.latLng);
                                    infowindow.open(locations.map);
                                    openedInfoWindow = infowindow;
                                }
                            });
                        }

                    }
                );

                var polylinepathDuct = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(locations.map);

                // polylines.push(polylinepath);
                switch (level) {
                    case "level1":
                        level1AssetsPolyline.push(polylinepath);
                        break;
                    case "level2":
                        level2AssetsPolyline.push(polylinepath);
                        break;
                    case "level3":
                        level3AssetsPolyline.push(polylinepath);
                        break;
                    case "level4":
                        level4AssetsPolyline.push(polylinepath);
                        break;
                    case "level5":
                        level5AssetsPolyline.push(polylinepath);
                        break;
                    default:
                        polylines.push(polylinepath);
                        break;
                }
            }
        }

        function drawPolylineCity(spread, map, level) {
            var spreadAssetCoordinates = [];
            var spreadColor = 0;
            var spreadWidth = 0;
            var spreadOpacity = 0;

            vm.assetTypes.forEach(function (assetType) {
                if (assetType.name == spread.assetTypeName) {
                    spreadColor = assetType.colorcode;
                    spreadWidth = assetType.lineWidth * 0.05;
                    spreadOpacity = assetType.transparency * 0.01;
                }
            });

            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = null;
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spreadColor;
                }
                var polylineWeight = spreadWidth;
                var strokeOpacityVal = spreadOpacity;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var disVal = 0;
                        var cLocations = [];

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }

                                var userContent = document.createElement("div");

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' +
                                    "<b>Name : </b> " +
                                    spread.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km</br>";

                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });
                            });
                        }
                        if (infowindow != null) {
                            infowindow.setPosition(event.latLng);
                            infowindow.open(locationsCity.mapCity);
                            openedInfoWindow = infowindow;
                        }
                    }
                );

                var polylinepathDuct = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(locationsCity.mapCity);

                // polylines.push(polylinepath);
                switch (level) {
                    case "level1":
                        level1AssetsPolylineCity.push(polylinepath);
                        break;
                    case "level2":
                        level2AssetsPolylineCity.push(polylinepath);
                        break;
                    case "level3":
                        level3AssetsPolylineCity.push(polylinepath);
                        break;
                    case "level4":
                        level4AssetsPolylineCity.push(polylinepath);
                        break;
                    case "level5":
                        level5AssetsPolylineCity.push(polylinepath);
                        break;
                    default:
                        polylinesCity.push(polylinepath);
                        break;
                }
            }
        }

        function drawPolylineCityAmc(spread, map, level) {
            var spreadAssetCoordinates = [];
            var spreadColor = 0;
            var spreadWidth = 0;
            var spreadOpacityAmc = 0;

            vm.assetTypes.forEach(function (assetType) {
                if (assetType.name == spread.assetTypeName) {
                    spreadColor = assetType.colorcode;
                    spreadWidth = assetType.lineWidth * 0.05;
                    spreadOpacityAmc = assetType.transparency * 0.01;
                }
            });

            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = null;
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spreadColor;
                }
                var polylineWeight = spreadWidth;
                var strokeOpacityVal = spreadOpacityAmc;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var disVal = 0;
                        var cLocations = [];

                        if (
                            spread.description == null ||
                            spread.description == undefined
                        ) {
                            spread.description = "";
                        }

                        if (spread.assetTypeLayout == "SPREAD") {
                            AssetByID.get(spread.id, function (assetVal) {
                                spread = assetVal;
                                var infoStr = "";
                                var assetTypeAttributeValuesList =
                                    spread.assetTypeAttributeValues;
                                assetTypeAttributeValuesList.sort(function (
                                    a,
                                    b
                                ) {
                                    var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                        nameB = b.assetTypeAttribute.name.toLowerCase();
                                    if (nameA < nameB)
                                        // sort string ascending
                                        return -1;
                                    if (nameA > nameB) return 1;
                                    return 0; // default return value (no sorting)
                                });
                                for (
                                    var i = 0;
                                    i < assetTypeAttributeValuesList.length;
                                    i++
                                ) {
                                    var home = assetTypeAttributeValuesList[i];

                                    var attrVal = "";
                                    if (home.attributeValue != null) {
                                        attrVal = home.attributeValue;
                                    }
                                    infoStr +=
                                        "<br><b>" +
                                        home.assetTypeAttribute.name +
                                        "</b> : " +
                                        attrVal;
                                }
                                var spreadCoordinates = spread.assetCoordinates;
                                if (spreadCoordinates.length > 0) {
                                    for (var index in spreadCoordinates) {
                                        if (index > 0) {
                                            disVal += distanceCal(
                                                spreadCoordinates[index]
                                                    .latitude,
                                                spreadCoordinates[index]
                                                    .longitude,
                                                spreadCoordinates[index - 1]
                                                    .latitude,
                                                spreadCoordinates[index - 1]
                                                    .longitude
                                            );
                                        }
                                    }
                                }

                                var userContent = document.createElement("div");

                                userContent.innerHTML =
                                    '<div class="infoWindowhead">' +
                                    "<b>Name : </b> " +
                                    spread.name +
                                    "</br>" +
                                    "<b>Distance : </b> " +
                                    parseFloat(disVal).toFixed(2) +
                                    " Km</br>";

                                infowindow = new google.maps.InfoWindow({
                                    content: userContent,
                                });
                            });
                        }
                        if (infowindow != null) {
                            infowindow.setPosition(event.latLng);
                            infowindow.open(locationsCity.mapCity);
                            openedInfoWindow = infowindow;
                        }
                    }
                );

                var polylinepathDuct = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(locationsCityAmc.mapCity);

                // polylines.push(polylinepath);
                switch (level) {
                    case "level1":
                        level1AssetsPolylineCityAmc.push(polylinepath);
                        break;
                    case "level2":
                        level2AssetsPolylineCityAmc.push(polylinepath);
                        break;
                    case "level3":
                        level3AssetsPolylineCityAmc.push(polylinepath);
                        break;
                    case "level4":
                        level4AssetsPolylineCityAmc.push(polylinepath);
                        break;
                    case "level5":
                        level5AssetsPolylineCityAmc.push(polylinepath);
                        break;
                    default:
                        polylinesCityAmc.push(polylinepath);
                        break;
                }
            }
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                Math.cos(degrees_to_radians(lat2)) *
                Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }

        function closeModal(id) {
            if (id == 'modalAttachment') {
                $(":file").filestyle("clear");
                $scope.allimages = false;
            }
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

        $scope.newTabDisplay = function (id, name) {
            var request = new XMLHttpRequest(), apiImage = name == 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";
            request.open(
                "GET",
                apiImage + vm.assetIdImg + "/" + id,
                true
            );
            request.setRequestHeader(
                "Authorization",
                "Bearer " + $localStorage.authenticationToken
            );
            request.responseType = "blob";
            request.onload = response;

            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    window.open(imageUrl, "_blank");
                }
            }
            request.send();
        };

        vm.assetMarkerUpload = function (id) {
            vm.assetMarkerUploadId = id;
            $("#markerUploadModal").show();
        };

        vm.closeAssetMarkerModal = function () {
            $scope.uploadfile = null;
            $(":file").filestyle("clear");
            $("#markerUploadModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#markerUploadModal").hide();
        };

        vm.uploadAssetMarker = function () {
            var getFile, lastDotPosition, format;
            getFile = document.getElementById("uploadfile").files[0];
            lastDotPosition = getFile.name.lastIndexOf(".");
            format = getFile.name.substring(lastDotPosition + 1);

            var fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                EntityImport.get(
                    {
                        entityName: "ASSETSMARKER",
                        parentEntityId: vm.assetMarkerUploadId.id,
                        parentEntityName: "ASSETS",
                        entityLayout: "SPREAD",
                        fileFormat: format,
                        messageType: "ADD",
                        messageStatus: "OPEN",
                        fileImage: window.btoa(fileLoadedEvent.target.result), // imported file
                    },
                    function (response) {
                        vm.success = true;
                        $timeout(function () {
                            vm.closeAssetMarkerModal();
                        }, 2300);
                        /* vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id;
                        $timeout(function () {
                            $state.go(vm.currentState)
                        }, 4000); */
                    }
                );
            };
            fileReader.readAsBinaryString(getFile);
        };

        function assetMarkerTable(asset) {
            vm.assetsForListView.forEach(function (item) {
                item.isExpanded = false;
            });
            if (vm.toggle == asset.id) {
                vm.toggle = undefined;
            } else {
                asset.isExpanded = true;
                vm.toggle = asset.id;
            }
            if (asset.isExpanded) {
                ChildAssetMarkers.query(
                    {
                        assetId: asset.id,
                    },
                    onSuccess
                );

                function onSuccess(data) {
                    var assetMarkersRes = [];
                    data.forEach(function (values, index) {
                        values.no = index + 1;
                        assetMarkersRes.push(values);
                    });
                    vm.assetMarkers = assetMarkersRes;
                }
            }

        }

        function onSaveSuccessBuried(result) {

            var assetImagePath = result.assetType.imagePath
            var findAssetIndex;
            switch (result.assetType.zoomLevel) {
                case 15:
                    for (var i = 0; i < level2AssetsMarkers.length; i++) {
                        if (result.id == level2AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level2AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level2AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level2AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level2AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 15) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                case 16:
                    for (var i = 0; i < level3AssetsMarkers.length; i++) {
                        if (result.id == level3AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level3AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level3AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level3AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level3AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }


                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 16) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }

                            break;
                        }
                    }
                    break;

                case 17:
                    for (var i = 0; i < level4AssetsMarkers.length; i++) {
                        if (result.id == level4AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level4AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level4AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level4AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level4AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 17) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                case 18:
                    for (var i = 0; i < level5AssetsMarkers.length; i++) {
                        if (result.id == level5AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level5AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level5AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level5AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level5AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 18) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                case 19:
                    for (var i = 0; i < level6AssetsMarkers.length; i++) {
                        if (result.id == level6AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level6AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level6AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level6AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level6AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 19) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                case 20:
                    for (var i = 0; i < level7AssetsMarkers.length; i++) {
                        if (result.id == level7AssetsMarkers[i].assetId) {
                            findAssetIndex = i;
                            level7AssetsMarkers[i].setMap(null);

                            if (result.burried) {
                                level7AssetsMarkers[i].icon.url =
                                    "content/images/buriedChamber.png";
                            } else {
                                level7AssetsMarkers[i].icon.url =
                                    assetImagePath;
                            }

                            level7AssetsMarkers[i].setMap(locations.map);
                            break;
                        }
                    }
                    for (
                        var index = 0;
                        index < vm.assetTypeValues.length;
                        index++
                    ) {
                        if (vm.assetTypeValues[index].zoomLevel == 20) {
                            if (result.burried) {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    "content/images/buriedChamber.png";
                            } else {
                                vm.assetTypeValues[index].assets[
                                    findAssetIndex
                                ].assetTypeImagePath =
                                    assetImagePath;
                            }
                            break;
                        }
                    }
                    break;

                default:
                    console.log("not found");
            }


        }

        vm.onNavigate = function (asset, geofence) {
            assetVisibility20 = false
            assetVisibility19 = false
            isLevel4AssetsVisible = false
            isLevel3AssetsVisible = false
            isLevel2AssetsVisible = false
            isLevelNodeVisible = false
            isLevel5AssetsVisible = false

            vm.isEnableNavigate = true
            vm.storeAsset = asset
            if (geofence != null && geofence.length > 0) {
                tempGeofenceId = geofence[0].id
            }
            /* var getZoom = vm.assetTypes.find(function(item){
                return item.name == asset.assetTypeName
            })
            vm.getZoomLevel = getZoom.zoomLevel */
            $scope.setTab(2)
        }


        function addLatLng(event, map) {
            var path = polyMeasureTool.getPath();
            path.push(event.latLng);


            addPointer(event.latLng, map);

            var point1, point2
            for (var i = 0; i < path.getLength() - 1; i++) {
                point1 = path.getAt(i);
                point2 = path.getAt(i + 1);
                segmentDistance = google.maps.geometry.spherical.computeDistanceBetween(point1, point2);


                // Add distance marker
                midpoint = google.maps.geometry.spherical.interpolate(point1, point2, 0.5);

            }


            if (path.getLength() > 1) {
                totalDistance += segmentDistance;
                var marker = new google.maps.Marker({
                    position: midpoint,
                    map: map,
                    icon: {
                        url: 'content/images/iconTransparent.png',
                    },
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "14px",
                        text: formatDistance(segmentDistance),
                    },
                });
                distanceMarkers.push(marker);

                var totalDistanceMarker = new google.maps.Marker({
                    position: point2,
                    map: map,
                    icon: {
                        url: 'content/images/iconTransparent.png',
                    },
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "14px",
                        text: "Total : " + formatDistance(totalDistance),
                    },
                });
                totalDistanceMarkers.push(totalDistanceMarker);
            }

        }

        function addPointer(location, map) {
            var pointerIcon = {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 5,
                strokeColor: 'black',
                fillColor: 'white',
                fillOpacity: 1,
                strokeWeight: 2
            };

            var pointer = new google.maps.Marker({
                position: location,
                map: map,
                icon: pointerIcon
            });
            pointerMarkers.push(pointer);
        }
        function formatDistance(distance) {
            // Convert meters to kilometers
            var km = distance / 1000;

            // Show in meters if less than 1 km, otherwise show in kilometers
            if (km < 1) {
                return distance.toFixed(0) + ' m';
            } else {
                return km.toFixed(2) + ' km';
            }
        }

        function clearMeasureTool(arr) {
            for (var i = 0; i < arr.length; i++) {
                arr[i].setMap(null)
            }
        }
        vm.assetMap;
        vm.filterAssetType = [];
        vm.selectedAsset = [];
        vm.assetMarkers = [];
        vm.allAssets = [];
        vm.markers = [];
        vm.polylines = [];
        vm.mapCentered = false;
        vm.getAllGeogenceList = function () {
            vm.userAllGeofences = [];

            GeofenceIDs.getAll(function (response) {
                angular.forEach(response, function (geofence) {
                    vm.userAllGeofences.push({
                        id: geofence.id,
                        name: geofence.name,
                        ticked: false
                    });
                });
            });
            vm.assetMap = new google.maps.Map(
                document.getElementById("map_asset"),
                myOption(
                    12,
                    new google.maps.LatLng(
                        $rootScope.DEFAULT_LATITUDE,
                        $rootScope.DEFAULT_LONGITUDE
                    )
                )
            );

            google.maps.event.addListener(vm.assetMap, "zoom_changed", function () {
                vm.zoomLevel = vm.assetMap.getZoom();
                document.getElementById("myspan").textContent = "ZOOM : " + vm.zoomLevel;
            });
        };

        vm.init = function () {
            vm.getAllGeogenceList();
        };
        vm.init();

        vm.selectedMapGeofence = [];
        vm.userSelectedGeofenceId = null;

        vm.onGeofenceSelect = function () {
            if (vm.selectedMapGeofence && vm.selectedMapGeofence.length > 0) {
                vm.userSelectedGeofenceId = vm.selectedMapGeofence[0].id;
                vm.clearMapObjects();
                vm.allAssets = [];
                vm.filterAssetType = [];
                vm.selectedAsset = [];
                vm.showAssetsByGefenceId(vm.userSelectedGeofenceId, null);
            } else {
                vm.userSelectedGeofenceId = null;
                vm.clearMapObjects();
            }
        };
        vm.clearMapObjects = function () {
            (vm.markers || []).forEach(function (m) { m.setMap(null); });
            (vm.polylines || []).forEach(function (p) { p.setMap(null); });

            vm.markers = [];
            vm.polylines = [];
            vm.assetMarkers = [];
            vm.mapCentered = false;
        };

        vm.showAssetsByGefenceId = function (geofenceId, lastId) {
            if (!geofenceId) return;
            AssetDB.get(geofenceId, lastId, function (data) {
                if (!data) return;
                if (data.assettypes && data.assettypes.length > 0 && vm.filterAssetType.length === 0) {
                    vm.filterAssetType = [];
                    if (lastId == null) {
                        if (data.assettypes.length) {
                            data.assettypes.forEach(function (assettype) {
                                if (vm.assetTypes.length) {
                                    vm.assetTypes.forEach(function (item) {
                                        if (item.id == assettype.id) {
                                            assettype.layout = item.layout
                                            if (item.layout == "FIXED") {
                                                assettype.icon =
                                                    '<img  src="' +
                                                    item.imagePath +
                                                    '"style="width: 24px; height: 24px;">';
                                                assettype.code = item.imagePath
                                            } else {
                                                assettype.icon =
                                                    '<img class="square" style="background-color:' +
                                                    item.colorcode +
                                                    ';">';
                                                assettype.code = item.colorcode
                                            }
                                        }
                                    })
                                }
                                vm.filterAssetType.push({
                                    id: assettype.id,
                                    name: assettype.assetTypeName,
                                    ticked: true,
                                    icon: assettype.icon,
                                    layout: assettype.layout,
                                    code: assettype.code
                                });
                            });
                        }
                    }
                }
                if (data.assets && data.assets.length > 0) {
                    Array.prototype.push.apply(vm.allAssets, data.assets);

                }
                vm.drawFilteredAssets();
                if (data.assets && data.assets.length === 200) {
                    vm.showAssetsByGefenceId(geofenceId, data.lastId);
                }
            });
        };

        vm.drawFilteredAssets = function () {
            (vm.assetMarkers || []).forEach(function (m) { m.setMap(null); });
            (vm.polylines || []).forEach(function (p) { p.setMap(null); });
            vm.assetMarkers = [];
            vm.polylines = [];
            var infowindow = null;
            var selectedTypeNames = vm.selectedAsset.map(function (s) { return s.name; });
            angular.forEach(vm.allAssets, function (asset) {
                if (selectedTypeNames.length > 0 && selectedTypeNames.indexOf(asset.assetTypeName) === -1) {
                    return;
                }
                if (asset.assetTypeLayout === "FIXED" && asset.assetCoordinates && asset.assetCoordinates.length > 0) {
                    asset.assetCoordinates.forEach(function (coord) {
                        var latLng = new google.maps.LatLng(parseFloat(coord.latitude), parseFloat(coord.longitude));
                        if (!vm.mapCentered) {
                            vm.assetMap.setCenter(latLng);
                            vm.assetMap.setZoom(12);
                            vm.mapCentered = true;
                        }
                        

                        var marker;
                        if (asset.amcStatus != null && asset.amcStatus != undefined) {
                            var baseIconUrl = asset.assetTypeImagePath;
                            var hueShift = 220; // try 60 for yellow, 120 for cyan, 180 for blue, 300 for magenta

                            if (asset.amcStatus == "AMC") {
                                hueShift = 25;
                            } else if (asset.amcStatus == "NON-AMC" || asset.amcStatus == "Non-AMC") {
                                hueShift = 280;
                            }
                            var iconSize = 28;
                            recolorPngHue(baseIconUrl, hueShift, function (newIconUrl) {
                                marker = new google.maps.Marker({
                                    position: { lat: asset.assetCoordinates[0].latitude, lng: asset.assetCoordinates[0].longitude },
                                    map: vm.assetMap,
                                    icon: {
                                        url: newIconUrl,
                                        scaledSize: new google.maps.Size(iconSize, iconSize),
                                        anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                        labelOrigin: new google.maps.Point(25, 22)
                                    },
                                    name: asset.name
                                });
                                processMarker(asset, marker);
                                $scope.showDropDown = false
                            });
                            if (!marker || !marker.getIcon) {
                                // console.warn('Marker not ready yet.');
                                return;
                            }
                            var icon = marker.getIcon();
                            icon.scaledSize = new google.maps.Size(48, 48);
                            marker.setIcon(icon);

                        } else {
                            marker = new google.maps.Marker({
                                map: vm.assetMap,
                                position: latLng,
                                title: asset.name,
                                icon: {
                                    url: asset.assetTypeImagePath,
                                    scaledSize: new google.maps.Size(28, 28),
                                    anchor: new google.maps.Point(14, 14)
                                }
                            });


                            processMarker(asset, marker);
                        }
                    });

                }
                else if (asset.assetTypeLayout === "SPREAD" && asset.assetCoordinates && asset.assetCoordinates.length > 1) {
                    var coords = asset.assetCoordinates.map(function (c) {
                        return { lat: parseFloat(c.latitude), lng: parseFloat(c.longitude) };
                    });

                    var polyline = new google.maps.Polyline({
                        path: coords,
                        geodesic: true,
                        strokeColor: asset.assetColor,
                        strokeOpacity: 1.0,
                        strokeWeight: 5,
                        map: vm.assetMap
                    });
                    vm.polylines.push(polyline);
                    google.maps.event.addListener(
                        polyline,
                        "click",
                        function (event) {

                            if (existingHighlight != null) {
                                existingHighlight.setMap(null);
                                existingHighlight = null;
                            }

                            var polylinepathHighlight = new google.maps.Polyline({
                                path: asset.assetColor,
                                strokeColor: "#FFFF00",
                                strokeOpacity: 0.6,
                                strokeWeight: 19,
                            });

                            polylinepathHighlight.setMap(vm.assetMap);
                            existingHighlight = polylinepathHighlight;

                            var polylineTimer = setTimeout(function () {
                                if (polylinepathHighlight != null) {
                                    polylinepathHighlight.setMap(null);
                                    polylinepathHighlight = null;
                                }
                            }, 10000);

                            if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }
                            closeLastOpenedInfoWindow();
                            var disVal = 0;
                            var cLocations = [];

                            if (
                                asset.description == null ||
                                asset.description == undefined
                            ) {
                                asset.description = "";
                            }

                            if (asset.assetTypeLayout === "SPREAD") {
                                AssetByID.get(asset.id, function (assetVal) {
                                    asset = assetVal;
                                    vm.assetToEdit = {};
                                    vm.assetToEdit = assetVal;
                                    var infoStr = "";
                                    var assetTypeAttributeValuesList =
                                        asset.assetTypeAttributeValues;
                                    assetTypeAttributeValuesList.sort(function (
                                        a,
                                        b
                                    ) {
                                        var nameA = a.assetTypeAttribute.name.toLowerCase(),
                                            nameB = b.assetTypeAttribute.name.toLowerCase();
                                        if (nameA < nameB)
                                            return -1;
                                        if (nameA > nameB) return 1;
                                        return 0;
                                    });
                                    for (
                                        var i = 0;
                                        i < assetTypeAttributeValuesList.length;
                                        i++
                                    ) {
                                        var home = assetTypeAttributeValuesList[i];

                                        var attrVal = "";
                                        if (home.attributeValue != null) {
                                            attrVal = home.attributeValue;
                                        }
                                        infoStr +=
                                            "<br><b>" +
                                            home.assetTypeAttribute.name +
                                            "</b> : " +
                                            attrVal;
                                    }
                                    var spreadCoordinates = asset.assetCoordinates;
                                    if (spreadCoordinates.length > 0) {
                                        for (var index in spreadCoordinates) {
                                            if (index > 0) {
                                                disVal += distanceCal(
                                                    spreadCoordinates[index]
                                                        .latitude,
                                                    spreadCoordinates[index]
                                                        .longitude,
                                                    spreadCoordinates[index - 1]
                                                        .latitude,
                                                    spreadCoordinates[index - 1]
                                                        .longitude
                                                );
                                            }
                                        }
                                    }
                                    var assetTypeAttrPopupNames = [];
                                    assetVal.assetType.assetTypeAttributes.forEach(
                                        function (assetTypeAttrVal) {
                                            if (
                                                assetTypeAttrVal.assetTypePopupDisplay ==
                                                true
                                            ) {
                                                assetTypeAttrPopupNames.push(
                                                    assetTypeAttrVal.name
                                                );
                                            }
                                        }
                                    );
                                    var getAttribute =
                                        assetVal.assetTypeAttributeValues;
                                    var userContent = document.createElement("div"),
                                        btnShowAttributes,
                                        btnEditAssets;

                                    var url = $state.href('asset-detail', { id: asset.id });

                                    userContent.innerHTML =
                                        '<div class="infoWindowhead">' + "<b>Id</b> : <a target='_blank' href='" + url + "'>" + asset.id +
                                        "</a><br><b>Name : </b> " +
                                        asset.name +
                                        "<br><b>Asset Type : </b> " +
                                        asset.assetType.name +
                                        "</br>" +
                                        "<b>Distance : </b> " +
                                        parseFloat(disVal).toFixed(2) +
                                        " Km";

                                    for (i = 0; i < getAttribute.length; i++) {
                                        if (
                                            assetTypeAttrPopupNames.includes(
                                                getAttribute[i].assetTypeAttribute
                                                    .name
                                            )
                                        ) {
                                            userContent.innerHTML +=
                                                "<b>" +
                                                getAttribute[i].assetTypeAttribute
                                                    .name +
                                                "</b>" +
                                                " : " +
                                                getAttribute[i].attributeValue +
                                                "</br>";
                                        }
                                    }


                                    if (accessEditAsset) {
                                        btnEditAssets = userContent.appendChild(
                                            document.createElement("input")
                                        );

                                        btnEditAssets.type = "button";
                                        btnEditAssets.value = "Edit Asset";
                                        btnEditAssets.className = "button";
                                        google.maps.event.addDomListener(
                                            btnEditAssets,
                                            "click",
                                            function () {
                                                $(":file").filestyle("clear");
                                                $("#assetEditModal").show();
                                            }
                                        );
                                    }

                                    btnShowAttributes = userContent.appendChild(
                                        document.createElement("input")
                                    );

                                    btnShowAttributes.type = "button";
                                    btnShowAttributes.value = "Show Attributes";
                                    btnShowAttributes.className = "button";
                                    google.maps.event.addDomListener(
                                        btnShowAttributes,
                                        "click",
                                        function () {
                                            showAssetAttributesModal(assetVal);
                                        }
                                    );
                                    infowindow = new google.maps.InfoWindow({
                                        content: userContent,
                                    });

                                    if (infowindow != null) {
                                        infowindow.setPosition(event.latLng);
                                        infowindow.open(vm.assetMap);
                                        openedInfoWindow = infowindow;
                                    }
                                });
                            }

                        }
                    );
                    if (!vm.mapCentered && coords.length > 0) {
                        vm.assetMap.setCenter(coords[0]);
                        vm.assetMap.setZoom(10);
                        vm.mapCentered = true;
                    }
                }

            });
            buildAssetLegends();
        };
vm.assetLegends = [];

function buildAssetLegends() {

    vm.assetLegends = [];

    var uniqueMap = {};

    angular.forEach(vm.allAssets, function (asset) {

        var status = asset.amcStatus ? asset.amcStatus.toUpperCase() : "NO-STATUS";

        var hueShift = 220;

        if (status === "AMC") {
            hueShift = 25;
        } else if (status === "NON-AMC") {
            hueShift = 280;
        }

        // create unique key
        var key = asset.assetTypeName + "_" + status;

        if (!uniqueMap[key]) {

            uniqueMap[key] = {
                name: asset.assetTypeName,
                status: status,
                icon: asset.assetTypeImagePath,
                hue: hueShift
            };
        }
    });

    // 🔥 Now recolor only unique items
    angular.forEach(uniqueMap, function (legendItem) {

        recolorPngHue(legendItem.icon, legendItem.hue, function (newIconUrl) {

            vm.assetLegends.push({
                name: legendItem.name,
                status: legendItem.status,
                coloredIcon: newIconUrl
            });

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });

    });
}
        function processMarker(asset, marker) {

            var infoWindow2 = new google.maps.InfoWindow();
            var infoStr = "";
            var otdr = "";

            var userContent = document.createElement("div"),
                button;

            userContent.innerHTML =
                '<div class="infoWindowhead">' +
                marker.title +
                '</div><div class="infoWindowContent">' +
                "<b>Lat</b> :" +
                asset.assetCoordinates[asset.assetCoordinates.length - 1]
                    .latitude +
                "<br><b>Long</b> :" +
                asset.assetCoordinates[asset.assetCoordinates.length - 1]
                    .longitude +
                "<br>" +
                infoStr +
                "</div>";

            google.maps.event.addListener(
                marker,
                "dblclick",
                function () {
                    infoWindow2.close();
                }
            );
            var activeInfoWindow;
            var infoWindow2 = new google.maps.InfoWindow({
                content: userContent,
            });

            google.maps.event.addListener(marker, "click", function () {
                if (existingHighlightFixed != null) {
                    existingHighlightFixed.setMap(null);
                    existingHighlightFixed = null;
                }
                var circle = new google.maps.Circle({
                    map: vm.assetMap,
                    center: marker.getPosition(),
                    radius: 2,
                    strokeColor: '#fd7a24',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#fd7a24',
                    fillOpacity: 1
                });

                circle.bindTo('center', marker, 'position');
                existingHighlightFixed = circle;
                setTimeout(function () {
                    if (circle != null) {
                        circle.setMap(null);
                        circle = null;
                    }
                }, 6000);
                if (activeInfoWindow != null) {
                    activeInfoWindow.close();
                }
                closeLastOpenedInfoWindow();
                AssetByID.get(asset.id, function (response) {
                    vm.assetToEdit = response;
                    vm.assetRefAttributes = [];
                    vm.assetAttachments = response;
                    if (response.assetReferenceAttributes && response.assetReferenceAttributes.length) {
                        angular.forEach(response.assetReferenceAttributes, function (get) {
                            if (get.assetAttributeName) {
                                get.assetAttributeName.assetTypeAttribute.attributeValue = get.assetAttributeName.attributeValue;
                                vm.assetRefAttributes.push(get.assetAttributeName.assetTypeAttribute);
                            }
                            if (get.assetAttributeValue) {
                                get.assetAttributeValue.assetTypeAttribute.attributeValue = get.assetAttributeValue.attributeValue;
                                vm.assetRefAttributes.push(get.assetAttributeValue.assetTypeAttribute);
                            }
                            if (get.assetAttributeImage) {
                                var imgAttr = get.assetAttributeImage.assetTypeAttribute;
                                imgAttr.attributeValue = get.assetAttributeImage.image;
                                imgAttr.attributeName = get.assetAttributeImage.imageName;
                                imgAttr.imageId = get.assetAttributeImage.imageId;
                                imgAttr.attributeType = get.assetAttributeImage.imageType;
                                vm.assetRefAttributes.push(imgAttr);
                            }
                        });
                    }

                    // Create the info window content
                    var userContent = document.createElement("div");
                    userContent.className = "infoWindowContent";

                    var url = $state.href('asset-detail', { id: response.id });
                   
                    if (response.amcStatus == null || response.amcStatus == undefined) {
                        response.amcStatus = "Not Available";
                    }
                   
                    userContent.innerHTML =
                        '<div class="infoWindowhead">' +
                        '<b>ID:</b> <a target="_blank" href="' + url + '">' + response.id + '</a><br>' +
                        '<b>Name:</b> ' + response.name + '</div>' +
                        '<div><b>Asset Type:</b> ' + response.assetTypeName +
                        "<br><b>Availability</b> : " + response.availability +" %" +
						"<br><b>Amc Status</b> : " + response.amcStatus +
                        '<br><b>Latitude:</b> ' + response.assetCoordinates[response.assetCoordinates.length - 1].latitude +
                        '<br><b>Longitude:</b> ' + response.assetCoordinates[response.assetCoordinates.length - 1].longitude + '</div>';




                    // Accessible checkbox
                    var lblAcc = document.createElement("b");
                    lblAcc.textContent = "Accessible";
                    lblAcc.style.marginRight = "5px";
                    userContent.appendChild(document.createElement("br"));
                    userContent.appendChild(lblAcc);


                    var chkAcc = document.createElement("input");
                    chkAcc.type = "checkbox";
                    chkAcc.id = response.id;
                    chkAcc.checked = response.accessible;
                    userContent.appendChild(chkAcc);

                    // Modal toggle setup
                    chkAcc.setAttribute("data-toggle", "modal");
                    chkAcc.setAttribute("data-target", "#myModalMap");

                    // Accessible modal logic
                    var yesBtn = document.getElementById("yesButton");
                    var noBtn = document.getElementById("noButton");
                    var closeBtn = document.getElementById("closeButton");

                    yesBtn.onclick = function () {
                        response.accessible = chkAcc.checked;
                        response.assetImages = [];
                        Asset.update(response);
                    };

                    noBtn.onclick = function () {
                        chkAcc.checked = !chkAcc.checked;
                    };

                    closeBtn.onclick = function () {
                        chkAcc.checked = !chkAcc.checked;
                    };
                    userContent.appendChild(document.createElement("br"));
                    userContent.appendChild(document.createElement("br"));
                    // Edit & Show Attributes buttons
                    var btnEdit = document.createElement("input");
                    btnEdit.type = "button";
                    btnEdit.value = "Edit Asset";
                    btnEdit.className = "button";
                    userContent.appendChild(btnEdit);

                    var btnThreePointRef = userContent.appendChild(
                        document.createElement("input")
                    );
                    btnThreePointRef.type = "button";
                    btnThreePointRef.value = "3 Point Reference";
                    btnThreePointRef.className = "button";
                    var btnCreateCase = userContent.appendChild(
                        document.createElement("input")
                    );

                    userContent.appendChild(document.createElement("br"));

                    btnCreateCase.type = "button";
                    btnCreateCase.value = "Create Incident";
                    btnCreateCase.className = "button";
                    var btnShowAttr = document.createElement("input");
                    btnShowAttr.type = "button";
                    btnShowAttr.value = "Show Attributes";
                    btnShowAttr.className = "button";
                    userContent.appendChild(btnShowAttr);

                    google.maps.event.addDomListener(btnEdit, "click", function () {
                        document.getElementById("assetEditName").textContent = "Asset - " + vm.assetToEdit.name;
                        editAssetOnMapView(response);
                    });

                    google.maps.event.addDomListener(btnShowAttr, "click", function () {
                        showAssetAttributesModal(response);
                    });
                    google.maps.event.addDomListener(
                        btnCreateCase,
                        "click",
                        function () {
                            $rootScope.createCaseFromAssetMap = [
                                response,
                            ];
                            $state.go("tr-case.new", {
                                lat:
                                    asset.assetCoordinates[
                                        asset.assetCoordinates.length -
                                        1
                                    ].latitude,
                                lng:
                                    asset.assetCoordinates[
                                        asset.assetCoordinates.length -
                                        1
                                    ].longitude,
                                desc: "Incident for " + asset.name,
                            });
                        }
                    );


                    google.maps.event.addDomListener(
                        btnThreePointRef,
                        "click",
                        function () {
                            showThreePontReferenceModal(response);
                        }
                    );
                    // Attachments button
                    var btnAttach = document.createElement("input");
                    btnAttach.type = "button";
                    btnAttach.value = "Attachments";
                    btnAttach.className = "button";
                    userContent.appendChild(btnAttach);

                    google.maps.event.addDomListener(btnAttach, "click", function () {
                        vm.assetAttachments.assetImages = [];
                        $("#modalAttachment").show();
                    });

                    // Display the info window
                    var infoWindow = new google.maps.InfoWindow({
                        content: userContent
                    });

                    infoWindow.open(vm.assetMap, marker);
                    activeInfoWindow = infoWindow;

                    setTimeout(function () {
                        infoWindow.close();
                    }, 10000);
                });
            });
            function updateMarkerLabelVisibility() {
                var currentZoom = vm.assetMap.getZoom();
                if (currentZoom > 10) {
                    marker.setLabel({
                        color: "red",
                        fontWeight: "bold",
                        fontSize: "12px",
                        text: asset.name,
                        className: "asset_label top-label"
                    });
                } else {
                    marker.setLabel(null);
                }
                var style = document.createElement('style');
                style.innerHTML = '.top-label {' +
                    '    position: relative;' +
                    '    top: 30px;' +
                    '    left: 0;' +
                    '    transform: translateX(10%);' +
                    '    white-space: nowrap;' +
                    '}';
                document.head.appendChild(style);
            }
            openedInfoWindow = infoWindow2;
            var updateIconSize = function () {
                var zoom = vm.assetMap.getZoom();

                // Define minimum and maximum zoom levels
                var minZoom = 8;
                var maxZoom = 21;
                var minSize = 6;  // Smallest size at zoom 8
                var maxSize = 60;  // Full size at zoom 21

                var newSize = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);

                var icon = {
                    url: marker.getIcon().url,  // Keep the existing marker image
                    scaledSize: new google.maps.Size(newSize, newSize),  // Only use scaledSize
                    anchor: new google.maps.Point(newSize / 2, newSize / 2), // Adjust anchor to prevent clipping
                };

                marker.setIcon(icon);
            };

            updateIconSize();

            google.maps.event.addListener(vm.assetMap, "zoom_changed", function () {
                updateIconSize();
                updateMarkerLabelVisibility()
            });
            vm.assetMarkers.push(marker);
            vm.markers.push(marker);
        }

        vm.sync = function () {
            vm.drawFilteredAssets();
        };
        vm.hideAssetListDelayed = function () {
            $timeout(function () {
                vm.showAssetList = false;
            }, 300);
        };
        vm.selectAssetFromSearch = function (asset) {
            vm.searchAsset = asset.name;
            vm.showAssetList = false;

            if (vm.activeSearchInfoWindow) {
                vm.activeSearchInfoWindow.close();
            }

            var infoContent =
                '<div class="infoWindowhead">' +
                '<b>' + asset.name + '</b><br>' +
                (asset.assetTypeName ? '<b>Type:</b> ' + asset.assetTypeName + '<br>' : '') +
                (asset.id ? '<b>ID:</b> ' + asset.id + '<br>' : '') +
                '</div>';

            var infoWindow = new google.maps.InfoWindow({
                content: infoContent
            });

            if (asset.assetTypeLayout === "FIXED" && asset.assetCoordinates && asset.assetCoordinates.length > 0) {
                var coord = asset.assetCoordinates[asset.assetCoordinates.length - 1];
                var latLng = new google.maps.LatLng(parseFloat(coord.latitude), parseFloat(coord.longitude));

                vm.assetMap.setCenter(latLng);
                vm.assetMap.setZoom(16);

                var circle = new google.maps.Circle({
                    map: vm.assetMap,
                    center: latLng,
                    radius: 5,
                    strokeColor: '#fd7a24',
                    strokeOpacity: 0.8,
                    strokeWeight: 3,
                    fillColor: '#fd7a24',
                    fillOpacity: 0.6
                });

                infoWindow.setPosition(latLng);
                infoWindow.open(vm.assetMap);

                vm.activeSearchInfoWindow = infoWindow;

                setTimeout(function () {
                    circle.setMap(null);
                }, 4000);
            }

            else if (asset.assetTypeLayout === "SPREAD" && asset.assetCoordinates && asset.assetCoordinates.length > 1) {
                var coords = asset.assetCoordinates.map(function (c) {
                    return { lat: parseFloat(c.latitude), lng: parseFloat(c.longitude) };
                });

                var bounds = new google.maps.LatLngBounds();
                coords.forEach(function (c) {
                    bounds.extend(new google.maps.LatLng(c.lat, c.lng));
                });
                vm.assetMap.fitBounds(bounds);
                var highlightLine = new google.maps.Polyline({
                    path: coords,
                    strokeColor: "#FFFF00",
                    strokeOpacity: 0.6,
                    strokeWeight: 19,
                    map: vm.assetMap
                });

                var midIndex = Math.floor(coords.length / 2);
                var midLatLng = new google.maps.LatLng(coords[midIndex].lat, coords[midIndex].lng);
                infoWindow.setPosition(midLatLng);
                infoWindow.open(vm.assetMap);

                vm.activeSearchInfoWindow = infoWindow;

                setTimeout(function () {
                    highlightLine.setMap(null);
                }, 5000);
            }
        };


    }

    window.copyToClipboard = function (text) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function () {
            }).catch(function (err) {
                console.error("Clipboard copy failed: ", err);
            });
        } else {
            var tempInput = document.createElement("input");
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
        }
    };
    // google.maps.event.addListener(
    //     locationsCity.mapCity,
    //     "zoom_changed",
    //     function () {
    //         vm.zoomLevelCity = locationsCity.mapCity.getZoom();

    //       if(vm.zoomLevelCity >= 15){
    //         vm.storeTempPolygon.forEach(function(each){
    //             each.setMap(null)
    //         })
    //       }else if (vm.zoomLevelCity < 15){
    //         each.setMap(locationsCity.mapCity)
    //       }
    //     }
    // );

})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("IncidentDashboardController", IncidentDashboardController);

    IncidentDashboardController.$inject = ['$timeout', '$rootScope', '$scope', '$document', 'getIncidentData', '$q'];

    function IncidentDashboardController($timeout, $rootScope, $scope, $document, getIncidentData, $q) {
        var vm = this;
        
        // Request cancellation management
        var pendingDataRequests = {
            incidents: null,
            status: null,
            sla: null,
            roles: null,
            gp: null,
            trend: null
        };
        
        // Debounce timer for filter changes
        var filterChangeDebounceTimer = null;
        
        // Flag to prevent watcher from loading when ng-change handlers already did
        var isLoadingViaHandler = false;
        vm.chartData = [];
        vm.businessAreaName = [];
        vm.operationalAreaName = [];
        vm.districtList = [];
        vm.blockList = [];
        vm.gpList = [];
        vm.stateList = [];
        vm.packageList = [];
        vm.selectedBusinessArea = null;
        vm.selectedOperationalAreaName = null;
        vm.selectedDistrict = null;
        vm.selectedBlock = null;
        vm.loadSLABreachData=loadSLABreachData;
        vm.selectedGP = null;
        vm.selectedState = null;
        vm.selectedPackage = null;
        vm.selectedAMCStatus = 'ALL'; // Default to ALL
        vm.selectedAlertType = 'ALL';
        vm.alertTypeFilterOptions = [
            { id: 'ALL', name: 'All' }
        ];
        vm.selectedOpenAlertType = 'ALL';
        vm.openAlertTypeFilterOptions = [
            { id: 'ALL', name: 'All' }
        ];
        vm.amcStatusList = [
            { id: 'ALL', name: 'ALL' },
            { id: 'AMC', name: 'AMC' },
            { id: 'NONAMC', name: 'NON-AMC' }
        ];
        vm.lastFilterChanged = null; // Track which filter was changed last: 'package' or 'state'
        vm.fromDate = null;
        vm.toDate = null;
        vm.maxDate = new Date(); // Set max date to today to prevent future date selection
        vm.datePickerOptions = {
            maxDate: new Date() // Datepicker option to prevent future date selection
        };
        vm.dateRange = "";
        vm.showDatePopup = false;
        vm.datePickerOpenStatus = { fromDate: false, toDate: false };
        vm.dateValidationError = null; // Error message for date validation
        
        // Sorting variables for SLA Breach table
        vm.predicate = 'createdDate'; // Default sort field
        vm.reverse = false; // Default sort direction (ascending)
        
        // Sorting variables for Open Incidents table
        vm.openIncidentsPredicate = 'createdDate';
        vm.openIncidentsReverse = false;
        
        // Sorting variables for Resolved Incidents table
        vm.resolvedIncidentsPredicate = 'createdDate';
        vm.resolvedIncidentsReverse = false;
        
        // Sorting variables for Near To Breach table
        vm.nearToBreachPredicate = 'createdDate';
        vm.nearToBreachReverse = false;
        
        // Generic sort function for any table
        vm.sortTable = function(table, field) {
            var predKey, reverseKey, pageKey, transitionFunc;
            
            // Handle SLA Breach table (empty string means SLA table)
            if (!table || table === '') {
                predKey = 'predicate';
                reverseKey = 'reverse';
                pageKey = 'page';
                transitionFunc = vm.transition;
            } else {
                // Handle other tables
                predKey = table + 'Predicate';
                reverseKey = table + 'Reverse';
                pageKey = table + 'Page';
                var funcName = 'transition' + table.charAt(0).toUpperCase() + table.slice(1);
                transitionFunc = vm[funcName];
            }
            
            if (vm[predKey] === field) {
                vm[reverseKey] = !vm[reverseKey];
            } else {
                vm[predKey] = field;
                vm[reverseKey] = false;
            }
            
            // Update pagination for the specific table
            vm[pageKey] = 1;
            
            // Call the transition function with proper context
            if (typeof transitionFunc === 'function') {
                transitionFunc.call(vm);
            }
        };
        
        // Generic sort data function
        vm.applySorting = function(data, predicate, reverse) {
            if (!data || !Array.isArray(data) || data.length === 0) {
                return data || [];
            }
            if (!predicate) {
                return data;
            }
            
            var sorted = data.slice(); // Create a copy to avoid mutating original
            sorted.sort(function(a, b) {
                var aVal = a[predicate];
                var bVal = b[predicate];
                
                // Handle null/undefined values
                if (aVal == null && bVal == null) return 0;
                if (aVal == null) return reverse ? -1 : 1;
                if (bVal == null) return reverse ? 1 : -1;
                
                var compareResult = 0;
                
                // Handle Date objects
                if (aVal instanceof Date && bVal instanceof Date) {
                    compareResult = aVal.getTime() - bVal.getTime();
                } 
                // Handle strings
                else if (typeof aVal === 'string' && typeof bVal === 'string') {
                    var aStr = aVal.toLowerCase();
                    var bStr = bVal.toLowerCase();
                    compareResult = aStr < bStr ? -1 : (aStr > bStr ? 1 : 0);
                }
                // Handle numbers
                else if (typeof aVal === 'number' && typeof bVal === 'number') {
                    compareResult = aVal - bVal;
                }
                // Fallback to generic comparison
                else {
                    compareResult = aVal < bVal ? -1 : (aVal > bVal ? 1 : 0);
                }
                
                return reverse ? -compareResult : compareResult;
            });
            
            return sorted;
        };

        function normalizeAlertTypeName(value) {
            if (value === null || value === undefined) {
                return '-';
            }
            var normalized = String(value).trim();
            return normalized || '-';
        }

        function getFilteredSlaBreachesByAlertType(data) {
            var source = Array.isArray(data) ? data : [];
            if (!vm.selectedAlertType || vm.selectedAlertType === 'ALL') {
                return source;
            }
            return source.filter(function(item) {
                return normalizeAlertTypeName(item && item.caseTypeName) === vm.selectedAlertType;
            });
        }

        function getFilteredOpenIncidentsByAlertType(data) {
            var source = Array.isArray(data) ? data : [];
            if (!vm.selectedOpenAlertType || vm.selectedOpenAlertType === 'ALL') {
                return source;
            }
            return source.filter(function(item) {
                return normalizeAlertTypeName(item && item.caseTypeName) === vm.selectedOpenAlertType;
            });
        }

        function getFilteredMttrDetailsByAlertType(data) {
            var source = Array.isArray(data) ? data : [];
            if (!vm.selectedAlertType || vm.selectedAlertType === 'ALL') {
                return source;
            }
            return source.filter(function(item) {
                return normalizeAlertTypeName(item && item.caseTypeName) === vm.selectedAlertType;
            });
        }

        function updateAlertTypeFilterOptions(data) {
            var source = Array.isArray(data) ? data : [];
            var seen = {};
            var dynamicOptions = [];

            source.forEach(function(item) {
                var alertType = normalizeAlertTypeName(item && item.caseTypeName);
                if (alertType === '-' || seen[alertType]) {
                    return;
                }
                seen[alertType] = true;
                dynamicOptions.push({ id: alertType, name: alertType });
            });

            dynamicOptions.sort(function(a, b) {
                var aName = a.name.toLowerCase();
                var bName = b.name.toLowerCase();
                return aName < bName ? -1 : (aName > bName ? 1 : 0);
            });

            vm.alertTypeFilterOptions = [{ id: 'ALL', name: 'All' }].concat(dynamicOptions);

            if (!vm.selectedAlertType || !vm.alertTypeFilterOptions.some(function(option) {
                return option.id === vm.selectedAlertType;
            })) {
                vm.selectedAlertType = 'ALL';
            }
        }

        function updateOpenAlertTypeFilterOptions(data) {
            var source = Array.isArray(data) ? data : [];
            var seen = {};
            var dynamicOptions = [];

            source.forEach(function(item) {
                var alertType = normalizeAlertTypeName(item && item.caseTypeName);
                if (alertType === '-' || seen[alertType]) {
                    return;
                }
                seen[alertType] = true;
                dynamicOptions.push({ id: alertType, name: alertType });
            });

            dynamicOptions.sort(function(a, b) {
                var aName = a.name.toLowerCase();
                var bName = b.name.toLowerCase();
                return aName < bName ? -1 : (aName > bName ? 1 : 0);
            });

            vm.openAlertTypeFilterOptions = [{ id: 'ALL', name: 'All' }].concat(dynamicOptions);

            if (!vm.selectedOpenAlertType || !vm.openAlertTypeFilterOptions.some(function(option) {
                return option.id === vm.selectedOpenAlertType;
            })) {
                vm.selectedOpenAlertType = 'ALL';
            }
        }

        vm.onAlertTypeChange = function () {
            vm.page = 1;
            vm.updatePagedSLA();
        };

        vm.onOpenAlertTypeChange = function () {
            vm.openIncidentsPage = 1;
            vm.updatePagedOpenIncidents();
        };

        vm.hasFilteredSlaBreachData = function() {
            return getFilteredSlaBreachesByAlertType(vm.slaBreaches).length > 0;
        };

        vm.hasFilteredOpenIncidentsData = function() {
            return getFilteredOpenIncidentsByAlertType(vm.openIncidents).length > 0;
        };

        vm.hasFilteredMttrDetailsData = function() {
            return getFilteredMttrDetailsByAlertType(vm.mttrDetails).length > 0;
        };
        
        vm.openCalendar = function(field) { vm.datePickerOpenStatus[field] = true; };

        vm.onDatePickerClosed = function(field, args) {
            if (!args || !args.closeDate) {
                return;
            }

            vm[field] = args.closeDate;

            if (field === 'fromDate') {
                vm.calculateFromDate();
            } else if (field === 'toDate') {
                vm.calculateToDate();
            }
        };
        
        vm.calculateFromDate = function() {
            if (!vm.fromDate) {
                return; // User is still selecting date
            }
            
            // If only fromDate is set, clear any existing error
            if (!vm.toDate) {
                vm.dateValidationError = null;
                return;
            }
            
            // Both dates are set, validate
            var fromTime = new Date(vm.fromDate).getTime();
            var toTime = new Date(vm.toDate).getTime();
            
            if (fromTime > toTime) {
                vm.dateValidationError = 'From Date cannot be greater than To Date';
            } else {
                vm.dateValidationError = null; // Clear error if dates are now valid
                vm.dateRange = formatDate(vm.fromDate) + " - " + formatDate(vm.toDate);
            }
        };
        
        vm.calculateToDate = function() {
            if (!vm.toDate) {
                return; // User is still selecting date
            }
            
            // If only toDate is set, clear any existing error
            if (!vm.fromDate) {
                vm.dateValidationError = null;
                return;
            }
            
            // Both dates are set, validate
            var fromTime = new Date(vm.fromDate).getTime();
            var toTime = new Date(vm.toDate).getTime();
            
            if (toTime < fromTime) {
                vm.dateValidationError = 'To Date cannot be earlier than From Date';
            } else {
                vm.dateValidationError = null; // Clear error if dates are now valid
                vm.dateRange = formatDate(vm.fromDate) + " - " + formatDate(vm.toDate);
            }
        };

        // Watch for when date pickers close to trigger validation
        $scope.$watch(function() {
            return vm.datePickerOpenStatus.fromDate;
        }, function(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                // From date picker just closed - wait for model to update
                $timeout(function() {
                    if (vm.fromDate && vm.toDate) {
                        vm.calculateFromDate();
                        vm.calculateToDate();
                    }
                }, 300);
            }
        });

        $scope.$watch(function() {
            return vm.datePickerOpenStatus.toDate;
        }, function(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                // To date picker just closed - wait for model to update
                $timeout(function() {
                    if (vm.fromDate && vm.toDate) {
                        vm.calculateToDate();
                        vm.calculateFromDate();
                    }
                }, 300);
            }
        });

        vm.slaBreaches = [];
        vm.slaBreachCount = 0;
        vm.nearToBreachCount = 0;
        vm.noActionCount = 0;
        vm.gpDownCount = 0;
        vm.totalGPCount = 0;
        vm.blockDownCount = 0;
        vm.totalBlockCount = 0;
        vm.slaCompliancePerc = 0;
        vm.avgResolutionTime = 0;
        vm.avgResolutionHours = 0;
        vm.avgResponseTime = 0;
        vm.avgResponseHours = 0;
        vm.patrollerCount = 0;
        vm.frtCount = 0;
        vm.dayWiseTrendData = null;
        vm.priorityTotals = {
            ASSIGNED: 0,
            TOBEASSIGNED: 0,
            RESOLVED: 0,
            INPROGRESS: 0,
            PENDING: 0,
            CLOSED: 0
        };
        vm.resolvedwithinTimeCount = 0;

        // Open Incidents data
        vm.openIncidents = [];
        vm.showOpenIncidentsTable = false;
        vm.openIncidentsPage = 1;
        vm.openIncidentsTotalItems = 0;
        vm.openIncidentsQueryCount = 0;
        vm.openIncidentsPaged = [];
        
        // Resolved Incidents data
        vm.resolvedIncidents = [];
        vm.showResolvedIncidentsTable = false;
        vm.resolvedIncidentsPage = 1;
        vm.resolvedIncidentsTotalItems = 0;
        vm.resolvedIncidentsQueryCount = 0;
        vm.resolvedIncidentsPaged = [];
        
        // Near To Breach Incidents data
        vm.nearToBreachIncidents = [];
        vm.showNearToBreachTable = false;
        vm.nearToBreachPage = 1;
        vm.nearToBreachTotalItems = 0;
        vm.nearToBreachQueryCount = 0;
        vm.nearToBreachPaged = [];
        
        // Patroller data
        vm.patrollerUsers = [];
        vm.showPatrollerTable = false;
        vm.patrollerPage = 1;
        vm.patrollerTotalItems = 0;
        vm.patrollerQueryCount = 0;
        vm.patrollerPaged = [];
        
        // FRT data
        vm.frtUsers = [];
        vm.showFrtTable = false;
        vm.frtPage = 1;
        vm.frtTotalItems = 0;
        vm.frtQueryCount = 0;
        vm.frtPaged = [];

        // GP Down data
        vm.gpDownList = [];
        vm.showGpDownTable = false;
        vm.gpDownPage = 1;
        vm.gpDownTotalItems = 0;
        vm.gpDownQueryCount = 0;
        vm.gpDownPaged = [];
        vm.gpDownPredicate = 'caseCreatedTime';
        vm.gpDownReverse = true;

        // Block Down data
        vm.blockDownList = [];
        vm.showBlockDownTable = false;
        vm.blockDownPage = 1;
        vm.blockDownTotalItems = 0;
        vm.blockDownQueryCount = 0;
        vm.blockDownPaged = [];
        vm.blockDownPredicate = 'createdDate';
        vm.blockDownReverse = true;

        // MTTR Details data (shared by Resolved Incidents, SLA Compliance, AVG Resolution cards)
        vm.mttrDetails = [];
        vm.showMttrDetailsTable = false;
        vm.mttrDetailsPage = 1;
        vm.mttrDetailsTotalItems = 0;
        vm.mttrDetailsQueryCount = 0;
        vm.mttrDetailsPaged = [];
        vm.mttrDetailsPredicate = 'createdDate';
        vm.mttrDetailsReverse = false;

        vm.formatGpDownDuration = function(createdTime) {
            if (!createdTime) {
                return '-';
            }
            var createdMs = new Date(createdTime).getTime();
            if (isNaN(createdMs)) {
                return '-';
            }
            var diffMs = Date.now() - createdMs;
            if (diffMs < 0) {
                diffMs = 0;
            }
            var totalMinutes = Math.floor(diffMs / (1000 * 60));
            var hours = Math.floor(totalMinutes / 60);
            var minutes = totalMinutes % 60;
            return hours + 'h ' + minutes + 'm';
        };

        vm.getGpDownDurationStyle = function(createdTime) {
            var createdMs = new Date(createdTime).getTime();
            if (!createdTime || isNaN(createdMs)) {
                return {
                    'color': '#6c757d',
                    'font-weight': '400',
                    'font-size': 'inherit'
                };
            }

            var totalMinutes = Math.max(0, Math.floor((Date.now() - createdMs) / (1000 * 60)));
            var color = '#28a745';

            if (totalMinutes >= 480) {
                color = '#dc3545';
            } else if (totalMinutes >= 120) {
                color = '#e67e22';
            }

            return {
                'color': color,
                'font-weight': '400',
                'font-size': 'inherit'
            };
        };
        
        vm.toggleOpenIncidentsTable = function() {
            vm.showOpenIncidentsTable = !vm.showOpenIncidentsTable;
            // Hide all other tables when opening Open Incidents
            if (vm.showOpenIncidentsTable) {
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            if (vm.showOpenIncidentsTable && (!vm.openIncidents || vm.openIncidents.length === 0)) {
                vm.loadOpenIncidentsData();
            }
            
            // Scroll to the Open Incidents table when showing it
            if (vm.showOpenIncidentsTable) {
                $timeout(function() {
                    var element = document.getElementById('openIncidentsTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionOpenIncidents = function() {
            vm.updatePagedOpenIncidents();
        };
        
        vm.updatePagedOpenIncidents = function() {
            try {
                updateOpenAlertTypeFilterOptions(vm.openIncidents);
                var filteredData = getFilteredOpenIncidentsByAlertType(vm.openIncidents);
                var sortedData = vm.applySorting(filteredData, vm.openIncidentsPredicate, vm.openIncidentsReverse);
                vm.openIncidentsTotalItems = filteredData.length;
                vm.openIncidentsQueryCount = vm.openIncidentsTotalItems;

                var totalPages = Math.max(1, Math.ceil(vm.openIncidentsTotalItems / vm.itemsPerPage));
                if (vm.openIncidentsPage > totalPages) {
                    vm.openIncidentsPage = 1;
                }

                var start = (vm.openIncidentsPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.openIncidentsPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.openIncidentsPaged = vm.openIncidents || [];
            }
        };

        vm.toggleResolvedIncidentsTable = function() {
            vm.showResolvedIncidentsTable = !vm.showResolvedIncidentsTable;
            // Hide all other tables when opening Resolved Incidents
            if (vm.showResolvedIncidentsTable) {
                vm.showOpenIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            
            // Scroll to the Resolved Incidents table when showing it
            if (vm.showResolvedIncidentsTable) {
                $timeout(function() {
                    var element = document.getElementById('resolvedIncidentsTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionResolvedIncidents = function() {
            vm.updatePagedResolvedIncidents();
        };
        
        vm.updatePagedResolvedIncidents = function() {
            try {
                var sortedData = vm.applySorting(vm.resolvedIncidents, vm.resolvedIncidentsPredicate, vm.resolvedIncidentsReverse);
                var start = (vm.resolvedIncidentsPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.resolvedIncidentsPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.resolvedIncidentsPaged = vm.resolvedIncidents || [];
            }
        };

        vm.toggleNearToBreachTable = function() {
            vm.showNearToBreachTable = !vm.showNearToBreachTable;
            // Hide all other tables when opening Near To Breach
            if (vm.showNearToBreachTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            
            // Scroll to the Near To Breach table when showing it
            if (vm.showNearToBreachTable) {
                $timeout(function() {
                    var element = document.getElementById('nearToBreachTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionNearToBreach = function() {
            vm.updatePagedNearToBreach();
        };
        
        vm.updatePagedNearToBreach = function() {
            try {
                var sortedData = vm.applySorting(vm.nearToBreachIncidents, vm.nearToBreachPredicate, vm.nearToBreachReverse);
                var start = (vm.nearToBreachPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.nearToBreachPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.nearToBreachPaged = vm.nearToBreachIncidents || [];
            }
        };

        vm.togglePatrollerTable = function() {
            vm.showPatrollerTable = !vm.showPatrollerTable;
            // Hide all other tables when opening Patroller
            if (vm.showPatrollerTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            
            // Scroll to the Patroller table when showing it
            if (vm.showPatrollerTable) {
                $timeout(function() {
                    var element = document.getElementById('patrollerTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionPatroller = function() {
            vm.updatePagedPatroller();
        };
        
        vm.updatePagedPatroller = function() {
            try {
                var start = (vm.patrollerPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.patrollerPaged = (vm.patrollerUsers || []).slice(start, end);
            } catch (e) {
                vm.patrollerPaged = vm.patrollerUsers || [];
            }
        };
        vm.toggleFrtTable = function() {
            vm.showFrtTable = !vm.showFrtTable;
            // Hide all other tables when opening FRT
            if (vm.showFrtTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }
            
            // Scroll to the FRT table when showing it
            if (vm.showFrtTable) {
                $timeout(function() {
                    var element = document.getElementById('frtTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };
        
        vm.transitionFrt = function() {
            vm.updatePagedFrt();
        };
        
        vm.updatePagedFrt = function() {
            try {
                var start = (vm.frtPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.frtPaged = (vm.frtUsers || []).slice(start, end);
            } catch (e) {
                vm.frtPaged = vm.frtUsers || [];
            }
        };

        vm.toggleGpDownTable = function() {
            vm.showGpDownTable = !vm.showGpDownTable;
            // Hide all other tables when opening GP Down
            if (vm.showGpDownTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showBlockDownTable = false;
                vm.showMttrDetailsTable = false;
            }

            // Scroll to the GP Down table when showing it
            if (vm.showGpDownTable) {
                $timeout(function() {
                    var element = document.getElementById('gpDownTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };

        vm.transitionGpDown = function() {
            vm.updatePagedGpDown();
        };

        vm.updatePagedGpDown = function() {
            try {
                var sortedData = vm.applySorting(vm.gpDownList, vm.gpDownPredicate, vm.gpDownReverse);
                var start = (vm.gpDownPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.gpDownPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.gpDownPaged = vm.gpDownList || [];
            }
        };

        vm.toggleBlockDownTable = function() {
            vm.showBlockDownTable = !vm.showBlockDownTable;
            // Hide all other tables when opening Block Down
            if (vm.showBlockDownTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showMttrDetailsTable = false;
            }

            if (vm.showBlockDownTable) {
                $timeout(function() {
                    var element = document.getElementById('blockDownTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };

        vm.transitionBlockDown = function() {
            vm.updatePagedBlockDown();
        };

        vm.updatePagedBlockDown = function() {
            try {
                var sortedData = vm.applySorting(vm.blockDownList, vm.blockDownPredicate, vm.blockDownReverse);
                var start = (vm.blockDownPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.blockDownPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.blockDownPaged = vm.blockDownList || [];
            }
        };

        vm.toggleMttrDetailsTable = function() {
            vm.showMttrDetailsTable = !vm.showMttrDetailsTable;
            // Hide all other tables when opening MTTR Details
            if (vm.showMttrDetailsTable) {
                vm.showOpenIncidentsTable = false;
                vm.showResolvedIncidentsTable = false;
                vm.showNearToBreachTable = false;
                vm.showPatrollerTable = false;
                vm.showFrtTable = false;
                vm.showGpDownTable = false;
                vm.showBlockDownTable = false;
            }

            // Scroll to the MTTR Details table when showing it
            if (vm.showMttrDetailsTable) {
                $timeout(function() {
                    var element = document.getElementById('mttrDetailsTableSection');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            }
        };

        vm.openMttrDetailsTable = function() {
            vm.showMttrDetailsTable = true;
            vm.showOpenIncidentsTable = false;
            vm.showResolvedIncidentsTable = false;
            vm.showNearToBreachTable = false;
            vm.showPatrollerTable = false;
            vm.showFrtTable = false;
            vm.showGpDownTable = false;

            $timeout(function() {
                var element = document.getElementById('mttrDetailsTableSection');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 300);
        };

        vm.transitionMttrDetails = function() {
            vm.updatePagedMttrDetails();
        };

        vm.updatePagedMttrDetails = function() {
            try {
                updateAlertTypeFilterOptions(vm.mttrDetails);
                var filteredData = getFilteredMttrDetailsByAlertType(vm.mttrDetails);
                var sortedData = vm.applySorting(filteredData, vm.mttrDetailsPredicate, vm.mttrDetailsReverse);
                vm.mttrDetailsTotalItems = filteredData.length;
                vm.mttrDetailsQueryCount = vm.mttrDetailsTotalItems;

                var totalPages = Math.max(1, Math.ceil(vm.mttrDetailsTotalItems / vm.itemsPerPage));
                if (vm.mttrDetailsPage > totalPages) {
                    vm.mttrDetailsPage = 1;
                }

                var start = (vm.mttrDetailsPage - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.mttrDetailsPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.mttrDetailsPaged = vm.mttrDetails || [];
            }
        }

        // CSV Export Functions
        function formatDateForCSV(date) {
            if (!date) return '';
            var d = new Date(date);
            var day = String(d.getDate()).padStart(2, '0');
            var month = String(d.getMonth() + 1).padStart(2, '0');
            var year = d.getFullYear();
            var hours = String(d.getHours()).padStart(2, '0');
            var minutes = String(d.getMinutes()).padStart(2, '0');
            var seconds = String(d.getSeconds()).padStart(2, '0');
            return day + '-' + month + '-' + year + ' ' + hours + ':' + minutes + ':' + seconds;
        }

        function convertToCSV(data, headers, headerMap) {
            if (!data || data.length === 0) {
                return '';
            }

            // Create CSV header row
            var csvContent = headers.map(function(header) {
                var displayName = headerMap && headerMap[header] ? headerMap[header] : header;
                return '"' + (displayName || '').toString().replace(/"/g, '""') + '"';
            }).join(',') + '\n';

            // Create CSV data rows
            csvContent += data.map(function(row) {
                return headers.map(function(header) {
                    var value = row[header];
                    if (value === null || value === undefined) {
                        value = '';
                    } else if (header.toLowerCase().includes('date') && (value instanceof Date || typeof value === 'number')) {
                        // Handle Date objects or timestamps
                        value = formatDateForCSV(value);
                    } else if (header.toLowerCase().includes('date') && typeof value === 'string') {
                        // If it's a string date, try to parse and format it
                        var parsed = new Date(value);
                        if (!isNaN(parsed)) {
                            value = formatDateForCSV(parsed);
                        }
                    }
                    return '"' + value.toString().replace(/"/g, '""') + '"';
                }).join(',');
            }).join('\n');

            return csvContent;
        }

        function downloadCSV(csvContent, filename) {
            var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            var link = document.createElement('a');
            var url = URL.createObjectURL(blob);
            
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        function getConsolidatedIncidentDetailsForCSV() {
            var openIncidents = (vm.openIncidents || []).map(function(item) {
                return {
                    incidentCategory: 'Open',
                    createdDate: item.createdDate,
                    ticketId: item.ticketId,
                    description: item.description,
                    district: item.district,
                    block: item.block,
                    gpLocation: item.gpLocation,
                    baName: item.baName || '-',
                    oaName: item.oaName || '-',
                    caseTypeName: item.caseTypeName || '-',
                    caseStatus: item.caseStatus,
                    assignedTo: item.assignedTo,
                    rca: item.rca || '-',
                    type: item.type
                };
            });

            var resolvedIncidents = (vm.resolvedIncidents || []).map(function(item) {
                return {
                    incidentCategory: 'Resolved',
                    createdDate: item.createdDate,
                    ticketId: item.ticketId,
                    description: item.description,
                    district: item.district,
                    block: item.block,
                    gpLocation: item.gpLocation,
                    baName: item.baName || '-',
                    oaName: item.oaName || '-',
                    caseTypeName: item.caseTypeName || '-',
                    caseStatus: item.caseStatus,
                    assignedTo: item.assignedTo,
                    rca: item.rca || '-',
                    type: item.type
                };
            });

            return openIncidents.concat(resolvedIncidents);
        }

        vm.exportSLABreachCSV = function() {
            var data = vm.slaBreaches || [];
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'slaDue', 'caseStatus', 'assignedTo', 'gpStatus', 'slaStatus'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'slaDue': 'Breach/Remaining Time',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'gpStatus': 'GP Status',
                'slaStatus': 'SLA Status'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'SLA_Breach_' + timestamp + '.csv');
        };

        vm.exportFilteredSLABreachCSV = function() {
            var data = getFilteredSlaBreachesByAlertType(vm.slaBreaches || []);
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'slaDue', 'caseStatus', 'assignedTo', 'gpStatus', 'slaStatus'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'slaDue': 'Breach/Remaining Time',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'gpStatus': 'GP Status',
                'slaStatus': 'SLA Status'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'SLA_Breach_Filtered_' + timestamp + '.csv');
        };

        vm.exportOpenIncidentsCSV = function() {
            var data = vm.openIncidents || [];
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'caseStatus', 'assignedTo', 'rca', 'type'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'rca': 'RCA',
                'type': 'Priority'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Open_Incidents_' + timestamp + '.csv');
        };

        vm.exportFilteredOpenIncidentsCSV = function() {
            var data = getFilteredOpenIncidentsByAlertType(vm.openIncidents || []);
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'caseStatus', 'assignedTo', 'rca', 'type'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'rca': 'RCA',
                'type': 'Priority'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Open_Incidents_Filtered_' + timestamp + '.csv');
        };

        vm.exportOpenResolvedIncidentsCSV = function() {
            var data = getConsolidatedIncidentDetailsForCSV();
            var headers = ['incidentCategory', 'createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'caseStatus', 'assignedTo', 'rca', 'type'];
            var headerMap = {
                'incidentCategory': 'Incident Category',
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'rca': 'RCA',
                'type': 'Priority'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Open_And_Resolved_Incidents_' + timestamp + '.csv');
        };

        vm.exportResolvedIncidentsCSV = function() {
            var data = vm.resolvedIncidents || [];
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'caseStatus', 'assignedTo', 'rca', 'type'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'rca': 'RCA',
                'type': 'Priority'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Resolved_Incidents_' + timestamp + '.csv');
        };

        vm.exportNearToBreachCSV = function() {
            var data = vm.nearToBreachIncidents || [];
            var headers = ['createdDate', 'ticketId', 'description', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'slaDue', 'caseStatus', 'assignedTo', 'gpStatus', 'slaStatus'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'ticketId': 'Ticket ID',
                'description': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'slaDue': 'Breach/Remaining Time',
                'caseStatus': 'Incident Status',
                'assignedTo': 'Assigned To',
                'gpStatus': 'GP Status',
                'slaStatus': 'SLA Status'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Near_Threshold_' + timestamp + '.csv');
        };

        vm.exportPatrollerCSV = function() {
            var data = vm.patrollerUsers || [];
            var headers = ['login', 'firstName', 'lastName', 'email', 'phone', 'reportingStatus', 'applicationVersion'];
            var csv = convertToCSV(data, headers);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Patroller_Team_' + timestamp + '.csv');
        };

        vm.exportFrtCSV = function() {
            var data = vm.frtUsers || [];
            var headers = ['login', 'firstName', 'lastName', 'email', 'phone', 'reportingStatus', 'applicationVersion'];
            var csv = convertToCSV(data, headers);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'FRT_' + timestamp + '.csv');
        };

        vm.exportGpDownCSV = function() {
            var data = (vm.gpDownList || []).map(function(item) {
                var createdDateObj = item.caseCreatedTime ? new Date(item.caseCreatedTime) : null;
                return {
                    createdAt: createdDateObj && !isNaN(createdDateObj.getTime())
                        ? String(createdDateObj.getDate()).padStart(2, '0') + '-' + String(createdDateObj.getMonth() + 1).padStart(2, '0') + '-' + createdDateObj.getFullYear() + ' ' +
                          String(createdDateObj.getHours()).padStart(2, '0') + ':' + String(createdDateObj.getMinutes()).padStart(2, '0') + ':' + String(createdDateObj.getSeconds()).padStart(2, '0')
                        : '',
                    ticketId: item.ticketId || item.caseNumber || '',
                    description: item.description || '',
                    assetName: item.assetName || '',
                    state: item.state || '',
                    district: item.district || '',
                    block: item.block || '',
                    'AMC/NON-AMC Status': item.amcStatus || '',
                    assignTo: item.assignTo || ''
                };
            });
            var headers = ['createdAt', 'ticketId', 'description', 'assetName', 'state', 'district', 'block', 'AMC/NON-AMC Status', 'assignTo'];
            var csv = convertToCSV(data, headers);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'GP_Down_List_' + timestamp + '.csv');
        };

        vm.exportBlockDownCSV = function() {
            var data = (vm.blockDownList || []).map(function(item) {
                var createdDateObj = item.createdDate ? new Date(item.createdDate) : null;
                var dueDateObj = item.dueDate ? new Date(item.dueDate) : null;
                return {
                    createdAt: createdDateObj && !isNaN(createdDateObj.getTime())
                        ? String(createdDateObj.getDate()).padStart(2, '0') + '-' + String(createdDateObj.getMonth() + 1).padStart(2, '0') + '-' + createdDateObj.getFullYear() + ' ' +
                          String(createdDateObj.getHours()).padStart(2, '0') + ':' + String(createdDateObj.getMinutes()).padStart(2, '0') + ':' + String(createdDateObj.getSeconds()).padStart(2, '0')
                        : '',
                    dueDate: dueDateObj && !isNaN(dueDateObj.getTime())
                        ? String(dueDateObj.getDate()).padStart(2, '0') + '-' + String(dueDateObj.getMonth() + 1).padStart(2, '0') + '-' + dueDateObj.getFullYear() + ' ' +
                          String(dueDateObj.getHours()).padStart(2, '0') + ':' + String(dueDateObj.getMinutes()).padStart(2, '0') + ':' + String(dueDateObj.getSeconds()).padStart(2, '0')
                        : '',
                    ticketId: item.ticketId || '',
                    description: item.description || '',
                    state: item.state || '',
                    district: item.district || '',
                    block: item.block || '',
                    priority: item.priority || '',
                    assignedTo: item.assignedTo || item.assignedToUser || '',
                    status: item.caseStatus || item.status || '',
                    caseTypeName: item.caseTypeName || ''
                };
            });
            var headers = ['createdAt', 'dueDate', 'ticketId', 'description', 'state', 'district', 'block', 'priority', 'assignedTo', 'status', 'caseTypeName'];
            var csv = convertToCSV(data, headers);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'Block_Incidents_' + timestamp + '.csv');
        };

        vm.exportMttrDetailsCSV = function() {
            var data = vm.mttrDetails || [];
            var headers = ['createdDate', 'resolvedDate', 'resolutionTime', 'slaStatus', 'ticketId', 'title', 'district', 'block', 'gpLocation', 'incidentStatus', 'rca', 'state', 'priority', 'assignedTo'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'resolvedDate': 'Resolved date and time',
                'resolutionTime': 'Resolution Time',
                'slaStatus': 'SLA Status',
                'ticketId': 'Ticket ID',
                'title': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'incidentStatus': 'Incident Status',
                'rca': 'RCA',
                'state': 'State',
                'priority': 'Priority',
                'assignedTo': 'Assigned To'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'MTTR_Details_' + timestamp + '.csv');
        };

        vm.exportFilteredMttrDetailsCSV = function() {
            var data = getFilteredMttrDetailsByAlertType(vm.mttrDetails || []);
            var headers = ['createdDate', 'resolvedDate', 'resolutionTime', 'slaStatus', 'ticketId', 'title', 'district', 'block', 'gpLocation', 'baName', 'oaName', 'caseTypeName', 'incidentStatus', 'rca', 'state', 'priority', 'assignedTo'];
            var headerMap = {
                'createdDate': 'Created date and time',
                'resolvedDate': 'Resolved date and time',
                'resolutionTime': 'Resolution Time',
                'slaStatus': 'SLA Status',
                'ticketId': 'Ticket ID',
                'title': 'Title',
                'district': 'District',
                'block': 'Block',
                'gpLocation': 'GP Location',
                'baName': 'BA',
                'oaName': 'OA',
                'caseTypeName': 'Alert Type',
                'incidentStatus': 'Incident Status',
                'rca': 'RCA',
                'state': 'State',
                'priority': 'Priority',
                'assignedTo': 'Assigned To'
            };
            var csv = convertToCSV(data, headers, headerMap);
            var timestamp = new Date().getTime();
            downloadCSV(csv, 'MTTR_Details_Filtered_' + timestamp + '.csv');
        };

        // Pagination for SLA table.
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.totalItems = 0;
        vm.queryCount = 0;
        vm.slaBreachesPaged = [];
        vm.transition = function () {
            vm.updatePagedSLA();
        };
        vm.updatePagedSLA = function () {
            try {
                updateAlertTypeFilterOptions(vm.slaBreaches);
                var filteredData = getFilteredSlaBreachesByAlertType(vm.slaBreaches);
                var sortedData = vm.applySorting(filteredData, vm.predicate, vm.reverse);
                vm.totalItems = filteredData.length;
                vm.queryCount = vm.totalItems;

                var totalPages = Math.max(1, Math.ceil(vm.totalItems / vm.itemsPerPage));
                if (vm.page > totalPages) {
                    vm.page = 1;
                }

                var start = (vm.page - 1) * vm.itemsPerPage;
                var end = start + vm.itemsPerPage;
                vm.slaBreachesPaged = sortedData.slice(start, end);
            } catch (e) {
                vm.slaBreachesPaged = vm.slaBreaches || [];
            }
        };

        // Default last 7 days
        (function setLastSevenDays() {
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            start.setDate(start.getDate() - 6);
            vm.fromDate = start;
            vm.toDate = end;
            vm.dateRange = formatDate(vm.fromDate) + " - " + formatDate(vm.toDate);
        })();

        vm.donutCharts = [];
        vm.stateList = [];
        function loadPage() {
            // Load Packages from separate API
            getIncidentData.getPackages(function (response) {
                if (response.data && response.data.length > 0) {
                    vm.packageList = response.data.map(function(packageName, index) {
                        return {
                            id: packageName,
                            name: packageName
                        };
                    });
                    
                    // Set first package as default after packages are loaded
                    $timeout(function() {
                        if (vm.packageList && vm.packageList.length > 0) {
                            vm.selectedPackage = vm.packageList[0].id;
                            
                            // Load states for the default package
                            loadStatesForPackage(vm.selectedPackage);
                            
                            // Trigger data load with first package
                            $timeout(function() {
                                vm.onPackageChange(vm.selectedPackage);
                            }, 100);
                        }
                    }, 200);
                }
            });
            
            // Load SLA Breach data - but don't block if it fails
            try {
                vm.loadSLABreachData();
            } catch (e) {
                console.error('Error loading SLA breach data:', e);
            }
        }
        
        // Helper function to load states based on selected package
        function loadStatesForPackage(packageId) {
            if (!packageId) {
                vm.stateList = [];
                return;
            }
            
            getIncidentData.getStatesByPackage(packageId, function (response) {
                if (response.data && response.data.length > 0) {
                    vm.stateList = response.data.map(function(stateName, index) {
                        return {
                            id: stateName,
                            name: stateName
                        };
                    });
                } else {
                    vm.stateList = [];
                }
            });
        }
        loadPage();

        // Initialize Google Map
        var incidentMap = null;
        function initializeMap() {
            var centerGeofence = {
                lat: $rootScope.DEFAULT_LATITUDE || 28.7041,
                lng: $rootScope.DEFAULT_LONGITUDE || 77.1025
            };

            var mapElement = document.getElementById('incident-map');
            if (mapElement && typeof google !== 'undefined' && google.maps) {
                incidentMap = new google.maps.Map(mapElement, {
                    zoom: 5,
                    center: centerGeofence,
                    scaleControl: true,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: [
                        {
                            featureType: 'poi',
                            elementType: 'labels.icon',
                            stylers: [{ color: '#63666A' }]
                        },
                        {
                            elementType: 'labels.text.fill',
                            stylers: [{ color: '#63666A' }]
                        }
                    ]
                });
            }
        }

        // Initialize map after a short delay to ensure DOM is ready
        $timeout(initializeMap, 500);

        // Close date popup when clicking outside
        (function setupClickOutsideClose() {
            var onDocClick = function (e) {
                try {
                    if (!vm.showDatePopup) { return; }
                    var popupEl = document.getElementById('incident-date-popup');
                    var triggerEl = document.getElementById('incident-date-range-input');
                    if (!popupEl) { return; }
                    if (popupEl.contains(e.target)) { return; }
                    if (triggerEl && triggerEl.contains(e.target)) { return; }
                    
                    // Check if click is on datepicker elements (which are rendered outside the popup)
                    var target = e.target;
                    if (target.closest('.uib-datepicker-popup') || 
                        target.closest('.dropdown-menu') ||
                        target.classList.contains('uib-day') ||
                        target.classList.contains('uib-daypicker') ||
                        target.classList.contains('btn-default')) {
                        return;
                    }
                    
                    $timeout(function () { vm.showDatePopup = false; });
                } catch (err) { /* noop */ }
            };
            $document.on('click', onDocClick);
            $scope.$on('$destroy', function () { $document.off('click', onDocClick); });
        })();

        // Helper function to remove seconds from time string
        function removeSeconds(timeStr) {
            if (!timeStr || timeStr === '-') {
                return timeStr;
            }
            // Remove seconds pattern like "17s" or "17 s"
            return timeStr.replace(/\s*\d+s\s*$/i, '').trim();
        }

        // Helper function to cancel pending HTTP requests
        function cancelPendingRequests() {
            // Cancel all pending requests to prevent race conditions
            for (var key in pendingDataRequests) {
                if (pendingDataRequests[key] && pendingDataRequests[key].resolve) {
                    pendingDataRequests[key].resolve('cancelled');
                    pendingDataRequests[key] = null;
                }
            }
        }

        // Debounce function for filter changes to prevent multiple simultaneous API calls
        function debounceFilterChange(callback, delay) {
            if (filterChangeDebounceTimer) {
                $timeout.cancel(filterChangeDebounceTimer);
            }
            filterChangeDebounceTimer = $timeout(function() {
                callback();
                filterChangeDebounceTimer = null;
            }, delay || 300);
        }

        // Wrapper to load SLA data with proper cancellation
        function loadSLADataWithCancellation() {
            // Cancel any pending SLA requests
            if (pendingDataRequests.sla) {
                $timeout.cancel(pendingDataRequests.sla);
            }
            loadSLABreachData();
        }

        // Helper function to abbreviate GP Status
        function abbreviateGPStatus(status) {
            if (!status || status === '-') {
                return status;
            }
            // Abbreviate UNKNOWN PREV DOWN to PREV DOWN
            if (status === 'UNKNOWN PREV DOWN') {
                return 'PREV DOWN';
            }
            return status;
        }

        // Function to load SLA Breach data from API
       function loadSLABreachData() {            
            try {
                // Get date range
                var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
                var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
                
                // Check if package or state filter is selected - use different API
                // But only if GP, Block, District, OA, or BA are NOT selected
                if ((vm.selectedPackage || vm.selectedState) && 
                    !vm.selectedGP && !vm.selectedBlock && !vm.selectedDistrict && 
                    !vm.selectedOperationalAreaName && !vm.selectedBusinessArea) {
                    var packageId = vm.selectedPackage || '';
                    var stateId = vm.selectedState || '';
                    
                    // Determine type based on which filter was changed last
                    var type;
                    if (vm.lastFilterChanged === 'state') {
                        type = 'STATE'; // State was changed last
                    } else if (vm.lastFilterChanged === 'package') {
                        type = 'PACKAGE'; // Package was changed last
                    } else if (vm.selectedPackage) {
                        type = 'PACKAGE'; // Default to package if it's selected
                    } else if (vm.selectedState) {
                        type = 'STATE'; // Default to state if only state is selected
                    }
                    
                    // console.log('Loading SLA data by package/state - Package:', packageId, 'State:', stateId, 'Type:', type, 'LastChanged:', vm.lastFilterChanged);
                    
                    if (typeof getIncidentData.getSLAStatusDataByPackageAndState === 'function') {
                        getIncidentData.getSLAStatusDataByPackageAndState(
                            packageId,
                            stateId,
                            type, 
                            fromTS, 
                            toTS,
                            vm.selectedAMCStatus,
                            function(response) {
                                try {
                                    if (response && response.data) {
                                        vm.transformAndDisplaySLAData(response.data);
                                    } else if (response === null) {
                                        console.error('>>> API call failed - response is null (check service error)');
                                        vm.slaBreaches = [];
                                        vm.avgResolutionTime = 0;
                                        vm.avgResolutionHours = 0;
                                        vm.avgResponseTime = 0;
                                        vm.avgResponseHours = 0;
                                    } else {
                                        console.warn('>>> No data in SLA response:', response);
                                        vm.slaBreaches = [];
                                        vm.avgResolutionTime = 0;
                                        vm.avgResolutionHours = 0;
                                        vm.avgResponseTime = 0;
                                        vm.avgResponseHours = 0;
                                    }
                                } catch (e) {
                                    console.error('>>> Error transforming SLA data:', e);
                                    vm.slaBreaches = [];
                                    vm.avgResolutionTime = 0;
                                    vm.avgResolutionHours = 0;
                                    vm.avgResponseTime = 0;
                                    vm.avgResponseHours = 0;
                                }
                            }
                        );
                    } else {
                        console.error('>>> getSLAStatusDataByPackageAndState function not available on service!');
                    }
                    return;
                }
                
                // Build ID based on selected filters (original logic for BA/OA/District/Block/GP)
                var id;
                if (vm.selectedGP) {
                    id = vm.selectedGP;
                } else if (vm.selectedBlock) {
                    id = vm.selectedBlock;
                } else if (vm.selectedDistrict) {
                    id = vm.selectedDistrict;
                } else if (vm.selectedOperationalAreaName) {
                    id = vm.selectedOperationalAreaName;
                } else if (vm.selectedBusinessArea) {
                    id = vm.selectedBusinessArea;
                } else {
                    // No valid filter selected - don't make the API call
                    // console.log('No valid filter selected - skipping SLA breach data API call');
                    vm.slaBreaches = [];
                    vm.avgResolutionTime = 0;
                    vm.avgResolutionHours = 0;
                    vm.avgResponseTime = 0;
                    vm.avgResponseHours = 0;
                    return;
                }
                
                // Determine type based on filter level
                var type = 'BA'; // Default to Business Area
                if (vm.selectedGP) {
                    type = 'GP';
                } else if (vm.selectedBlock) {
                    type = 'MINI';
                } else if (vm.selectedDistrict) {
                    type = 'MASTER';
                } else if (vm.selectedOperationalAreaName) {
                    type = 'OA';
                }
                
                // console.log('Loading SLA data with ID:', id, 'Type:', type);
                                
                if (typeof getIncidentData.getSLAStatusData === 'function') {                    
                    getIncidentData.getSLAStatusData(id, type, fromTS, toTS, vm.selectedAMCStatus, function(response) {                        
                        try {
                            if (response && response.data) {
                                vm.transformAndDisplaySLAData(response.data);
                            } else if (response === null) {
                                console.error('>>> API call failed - response is null (check service error)');
                                vm.slaBreaches = [];
                                vm.avgResolutionTime = 0;
                                vm.avgResolutionHours = 0;
                                vm.avgResponseTime = 0;
                                vm.avgResponseHours = 0;
                            } else {
                                console.warn('>>> No data in SLA response:', response);
                                vm.slaBreaches = [];
                                vm.avgResolutionTime = 0;
                                vm.avgResolutionHours = 0;
                                vm.avgResponseTime = 0;
                                vm.avgResponseHours = 0;
                            }
                        } catch (e) {
                            console.error('>>> Error transforming SLA data:', e);
                            vm.slaBreaches = [];
                            vm.avgResolutionTime = 0;
                            vm.avgResolutionHours = 0;
                            vm.avgResponseTime = 0;
                            vm.avgResponseHours = 0;
                        }
                    });
                } else {
                    console.error('>>> getSLAStatusData function not available on service!');
                }
            } catch (e) {
                console.error('>>> Error in loadSLABreachData:', e);
            }
        };

        vm.loadRoleCounts = function() {
            try {
                var name = '';
                var type = '';
                
                // Check if package or state was last changed - they should take priority
                if (vm.lastFilterChanged === 'package' && vm.selectedPackage) {
                    name = vm.selectedPackage;
                    type = 'PACKAGE';
                } else if (vm.lastFilterChanged === 'state' && vm.selectedState) {
                    name = vm.selectedState;
                    type = 'STATE';
                }
                // Otherwise use hierarchical filter priority: GP > Block > District > OA > BA
                else if (vm.selectedGP) {
                    name = vm.selectedGP;
                    type = 'GP';
                } else if (vm.selectedBlock) {
                    name = vm.selectedBlock;
                    type = 'MINI';
                } else if (vm.selectedDistrict) {
                    name = vm.selectedDistrict;
                    type = 'MASTER';
                } else if (vm.selectedOperationalAreaName) {
                    name = vm.selectedOperationalAreaName;
                    type = 'OA';
                } else if (vm.selectedBusinessArea) {
                    name = vm.selectedBusinessArea;
                    type = 'BA';
                } else if (vm.selectedState) {
                    name = vm.selectedState;
                    type = 'STATE';
                } else if (vm.selectedPackage) {
                    name = vm.selectedPackage;
                    type = 'PACKAGE';
                } else {
                    // No filter selected, reset counts
                    vm.patrollerCount = 0;
                    vm.frtCount = 0;
                    return;
                }
                
                // console.log('Loading role counts for:', name, 'Type:', type);
                
                if (typeof getIncidentData.getRoleCountsByAuthority === 'function') {
                    getIncidentData.getRoleCountsByAuthority(name, type, function(response) {
                        try {
                            // console.log('>>> getRoleCountsByAuthority response:', response);
                            if (response && response.data && Array.isArray(response.data)) {
                                vm.patrollerCount = 0;
                                vm.frtCount = 0;
                                vm.patrollerUsers = [];
                                vm.frtUsers = [];
                                
                                response.data.forEach(function(roleData) {
                                    if (roleData.role === 'ROLE_PATROLLER') {
                                        vm.patrollerCount = roleData.count || 0;
                                        vm.patrollerCurrentDayCheckInCount = roleData.currentdayCheckInCount || 0;
                                        // Extract user data for patroller table
                                        if (roleData.userData && Array.isArray(roleData.userData)) {
                                            vm.patrollerUsers = roleData.userData.map(function(user) {
                                                return {
                                                    login: user.login || '-',
                                                    id: user.id || '-',
                                                    firstName: user.firstName || '-',
                                                    lastName: user.lastName || '-',
                                                    email: user.email || '-',
                                                    phone: user.phone || '-',
                                                    gpsStatus: user.gpsStatus ? 'Active' : 'Inactive',
                                                    reportingStatus: user.reportingStatus ? 'Reporting' : 'Not Reporting',
                                                    operatingSystem: user.operatingSystem || '-',
                                                    applicationVersion: user.applicationVersion 
                                                };
                                            });
                                        }
                                    } else if (roleData.role === 'ROLE_FRT') {
                                        vm.frtCount = roleData.count || 0;
                                        vm.frtCurrentDayCheckInCount = roleData.currentdayCheckInCount || 0;
                                        // Extract user data for FRT table
                                        if (roleData.userData && Array.isArray(roleData.userData)) {
                                            vm.frtUsers = roleData.userData.map(function(user) {
                                                return {
                                                    login: user.login || '-',
                                                    id: user.id || '-',
                                                    firstName: user.firstName || '-',
                                                    lastName: user.lastName || '-',
                                                    email: user.email || '-',
                                                    phone: user.phone || '-',
                                                    gpsStatus: user.gpsStatus ? 'Active' : 'Inactive',
                                                    reportingStatus: user.reportingStatus ? 'Reporting' : 'Not Reporting',
                                                    operatingSystem: user.operatingSystem || '-',
                                                    applicationVersion: user.applicationVersion 
                                                };
                                            });
                                        }
                                    }
                                });
                                
                                // Update patroller pagination
                                vm.patrollerTotalItems = (vm.patrollerUsers || []).length;
                                vm.patrollerQueryCount = vm.patrollerTotalItems;
                                vm.patrollerPage = 1;
                                vm.updatePagedPatroller();
                                
                                // Update FRT pagination
                                vm.frtTotalItems = (vm.frtUsers || []).length;
                                vm.frtQueryCount = vm.frtTotalItems;
                                vm.frtPage = 1;
                                vm.updatePagedFrt();
                                
                                // console.log('Role counts - Patroller:', vm.patrollerCount, 'FRT:', vm.frtCount);
                            } else {
                                console.warn('No role count data in response:', response);
                                vm.patrollerCount = 0;
                                vm.frtCount = 0;
                                vm.patrollerUsers = [];
                                vm.frtUsers = [];
                            }
                        } catch (e) {
                            console.error('Error processing role counts:', e);
                            vm.patrollerCount = 0;
                            vm.frtCount = 0;
                            vm.patrollerUsers = [];
                            vm.frtUsers = [];
                        }
                    });
                } else {
                    console.error('getRoleCountsByAuthority function not available on service!');
                }
            } catch (e) {
                console.error('Error in loadRoleCounts:', e);
            }
        };

        vm.loadGPTotalCount = function() {
            try {
                var id = '';
                var type = '';
                
                // Check if package or state was last changed - they should take priority
                if (vm.lastFilterChanged === 'package' && vm.selectedPackage) {
                    id = vm.selectedPackage;
                    type = 'PACKAGE';
                } else if (vm.lastFilterChanged === 'state' && vm.selectedState) {
                    id = vm.selectedState;
                    type = 'STATE';
                }
                // Otherwise use hierarchical filter priority: GP > Block > District > OA > BA
                else if (vm.selectedGP) {
                    id = vm.selectedGP;
                    type = 'GP';
                } else if (vm.selectedBlock) {
                    id = vm.selectedBlock;
                    type = 'MINI';
                } else if (vm.selectedDistrict) {
                    id = vm.selectedDistrict;
                    type = 'MASTER';
                } else if (vm.selectedOperationalAreaName) {
                    id = vm.selectedOperationalAreaName;
                    type = 'OA';
                } else if (vm.selectedBusinessArea) {
                    id = vm.selectedBusinessArea;
                    type = 'BA';
                } else if (vm.selectedState) {
                    id = vm.selectedState;
                    type = 'STATE';
                } else if (vm.selectedPackage) {
                    id = vm.selectedPackage;
                    type = 'PACKAGE';
                } else {
                    // No filter selected, reset count
                    vm.totalGPCount = 0;
                    return;
                }
                
                // console.log('Loading GP total count for ID:', id, 'Type:', type);
                
                if (typeof getIncidentData.getGPTotalCount === 'function') {
                    getIncidentData.getGPTotalCount(id, type, vm.selectedAMCStatus, function(response) {
                        try {
                            if (response && response.data !== undefined && response.data !== null) {
                                vm.totalGPCount = response.data;
                                // console.log('GP Total Count:', vm.totalGPCount);
                            } else {
                                console.warn('No GP total count data in response:', response);
                                vm.totalGPCount = 0;
                            }
                        } catch (e) {
                            console.error('Error processing GP total count:', e);
                            vm.totalGPCount = 0;
                        }
                    });
                } else {
                    console.error('getGPTotalCount function not available on service!');
                }
            } catch (e) {
                console.error('Error in loadGPTotalCount:', e);
            }
        };

        vm.loadDayWiseTrendData = function() {
            // console.log('=== loadDayWiseTrendData CALLED ===');
            try {
                var id = '';
                var type = '';
                
                // Check if package or state was last changed - they should take priority
                if (vm.lastFilterChanged === 'package' && vm.selectedPackage) {
                    id = vm.selectedPackage;
                    type = 'PACKAGE';
                } else if (vm.lastFilterChanged === 'state' && vm.selectedState) {
                    id = vm.selectedState;
                    type = 'STATE';
                }
                // Otherwise use hierarchical filter priority: GP > Block > District > OA > BA
                else if (vm.selectedGP) {
                    id = vm.selectedGP;
                    type = 'GP';
                } else if (vm.selectedBlock) {
                    id = vm.selectedBlock;
                    type = 'MINI';
                } else if (vm.selectedDistrict) {
                    id = vm.selectedDistrict;
                    type = 'MASTER';
                } else if (vm.selectedOperationalAreaName) {
                    id = vm.selectedOperationalAreaName;
                    type = 'OA';
                } else if (vm.selectedBusinessArea) {
                    id = vm.selectedBusinessArea;
                    type = 'BA';
                } else if (vm.selectedState) {
                    id = vm.selectedState;
                    type = 'STATE';
                } else if (vm.selectedPackage) {
                    id = vm.selectedPackage;
                    type = 'PACKAGE';
                } else {
                    // No filter selected, use default empty data
                    // console.log('No filter selected, rendering default chart');
                    renderOverallObservationChart();
                    return;
                }
                
                var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
                var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
                
                // console.log('Loading day-wise trend data for ID:', id, 'Type:', type, 'FromDate:', fromTS, 'ToDate:', toTS);
                
                if (typeof getIncidentData.getDayWiseIncidentCounts === 'function') {
                    getIncidentData.getDayWiseIncidentCounts(id, fromTS, toTS, type, vm.selectedAMCStatus, function(response) {
                        try {
                            if (response && response.data) {
                                vm.dayWiseTrendData = response.data;
                                // console.log('Day-wise trend data:', vm.dayWiseTrendData);
                                renderOverallObservationChart();
                            } else {
                                console.warn('No day-wise trend data in response:', response);
                                vm.dayWiseTrendData = null;
                                renderOverallObservationChart();
                            }
                        } catch (e) {
                            console.error('Error processing day-wise trend data:', e);
                            vm.dayWiseTrendData = null;
                            renderOverallObservationChart();
                        }
                    });
                } else {
                    console.error('getDayWiseIncidentCounts function not available on service!');
                }
            } catch (e) {
                console.error('Error in loadDayWiseTrendData:', e);
            }
        };

        // Function to transform API response to table display format
        vm.transformAndDisplaySLAData = function(apiResponse) {
            try {
                // DEBUG: Log the entire API response to see what fields are available
                // console.log('=== SLA API Response ===', apiResponse);
                // console.log('Response keys:', apiResponse ? Object.keys(apiResponse) : 'null response');
                // console.log('Has openCaseData?', apiResponse && apiResponse.openCaseData);
                if (apiResponse && apiResponse.openCaseData) {
                    // console.log('openCaseData length:', apiResponse.openCaseData.length);
                    // console.log('First open case:', apiResponse.openCaseData[0]);
                }
                // console.log('Has resovedcaseData?', apiResponse && apiResponse.resovedcaseData);
                if (apiResponse && apiResponse.resovedcaseData) {
                    // console.log('resovedcaseData length:', apiResponse.resovedcaseData.length);
                    // console.log('First resolved case:', apiResponse.resovedcaseData[0]);
                }
                
                vm.slaBreaches = [];
                vm.slaBreachCount = 0;
                vm.nearToBreachCount = 0;
                vm.noActionCount = 0;
                vm.gpDownCount = 0;
                vm.blockDownCount = 0;
                vm.totalBlockCount = 0;
                // Note: totalGPCount is managed by loadGPTotalCount() API, not reset here
                vm.slaCompliancePerc = 0;
                vm.avgResolutionTime = 0;
                vm.avgResolutionHours = 0;
                vm.avgResponseTime = 0;
                vm.avgResponseHours = 0;
                
                if (!apiResponse) {
                    console.warn('No API response data');
                    return;
                }
                
                // Extract priorityTotals if available in API response
                if (apiResponse.priorityTotals) {
                    vm.priorityTotals = apiResponse.priorityTotals;
                    // console.log('>>> priorityTotals extracted from API:', vm.priorityTotals);
                }
                
                // Process Breach cases
                if (apiResponse.breach && apiResponse.breach.data && Array.isArray(apiResponse.breach.data)) {
                    vm.slaBreachCount = apiResponse.breach.count || apiResponse.breach.data.length;
                    apiResponse.breach.data.forEach(function(item) {
                        vm.slaBreaches.push({
                            incidentId: item.caseId,
                            state: item.state || '-',
                            district: item.district || '-',
                            block: item.block || '-',
                            type: item.status || '-',
                            reportedDate: new Date(),
                            status: 'Breach',
                            slaDue: removeSeconds(item.breachTime || '-'),
                            resolutionDate: new Date(),
                            slaStatus: 'Breach',
                            assignedTo: item.assignedTo || '-',
                            caseStatus: item.caseStatus || '-',
                            ticketId: item.ticketId || null,
                            gpStatus: abbreviateGPStatus(item.gpStatus || '-'),
                            gpLocation: item.gpLocation || '-',
                            createdDate: item.createdDate ? new Date(item.createdDate) : null,
                            description: item.description || item.title || '-',
                            baName: item.baName || '-',
                            oaName: item.oaName || '-',
                            caseTypeName: item.caseTypeName || '-'
                        });
                    });
                }
                
                // Process Near To Breach cases
                vm.nearToBreachIncidents = [];
                if (apiResponse.nearToBreach && apiResponse.nearToBreach.data && Array.isArray(apiResponse.nearToBreach.data)) {
                    vm.nearToBreachCount = apiResponse.nearToBreach.count || apiResponse.nearToBreach.data.length;
                    apiResponse.nearToBreach.data.forEach(function(item) {
                        var nearToBreachItem = {
                            incidentId: item.caseId,
                            state: item.state || '-',
                            district: item.district || '-',
                            block: item.block || '-',
                            type: item.status || '-',
                            reportedDate: new Date(),
                            status: 'Near To Breach',
                            slaDue: removeSeconds(item.remainingTime || '-'),
                            resolutionDate: new Date(),
                            slaStatus: 'Nearing Breach',
                            assignedTo: item.assignedTo || '-',
                            caseStatus: item.caseStatus || '-',
                            ticketId: item.ticketId || null,
                            gpStatus: abbreviateGPStatus(item.gpStatus || '-'),
                            gpLocation: item.gpLocation || '-',
                            createdDate: item.createdDate ? new Date(item.createdDate) : null,
                            description: item.description || item.title || '-',
                            baName: item.baName || '-',
                            oaName: item.oaName || '-',
                            caseTypeName: item.caseTypeName || '-'
                        };
                        vm.nearToBreachIncidents.push(nearToBreachItem);
                        vm.slaBreaches.push(nearToBreachItem);
                    });
                }
                
                // Process Open Cases (ASSIGNED, TO_BE_ASSIGNED, IN_PROGRESS)
                vm.openIncidents = [];
                if (apiResponse.openCaseData && Array.isArray(apiResponse.openCaseData)) {
                    apiResponse.openCaseData.forEach(function(item) {
                        vm.openIncidents.push({
                            incidentId: item.id || item.caseId || '-',
                            state: item.state || '-',
                            district: item.district || '-',
                            block: item.block || '-',
                            type: item.priority || '-',
                            reportedDate: item.createDate ? new Date(item.createDate) : new Date(),
                            assignedTo: item.assignedToUser || '-',
                            caseStatus: item.status || '-',
                            ticketId: item.ticketId || null,
                            gpStatus: abbreviateGPStatus(item.gpStatus || '-'),
                            gpLocation: item.gpLocation || '-',
                            createdDate: item.createDate ? new Date(item.createDate) : null,
                            dueDate: item.dueDate ? new Date(item.dueDate) : null,
                            description: item.description || '-',
                            rca: item.rca || '-',
                            baName: item.baName || '-',
                            oaName: item.oaName || '-',
                            caseTypeName: item.caseTypeName || '-'
                        });
                    });
                }
                
                // Process Resolved Cases
                vm.resolvedIncidents = [];
                if (apiResponse.resovedcaseData && Array.isArray(apiResponse.resovedcaseData)) {
                    apiResponse.resovedcaseData.forEach(function(item) {
                        vm.resolvedIncidents.push({
                            incidentId: item.id || item.caseId || '-',
                            state: item.state || '-',
                            district: item.district || '-',
                            block: item.block || '-',
                            type: item.priority || item.priorityType || item.priorityName || item.type || '-',
                            reportedDate: item.createDate ? new Date(item.createDate) : new Date(),
                            assignedTo: item.assignedToUser || '-',
                            caseStatus: item.status || '-',
                            ticketId: item.ticketId || null,
                            gpStatus: abbreviateGPStatus(item.gpStatus || '-'),
                            gpLocation: item.gpLocation || '-',
                            createdDate: item.createDate ? new Date(item.createDate) : null,
                            dueDate: item.dueDate ? new Date(item.dueDate) : null,
                            description: item.description || item.title || item.caseTitle || '-',
                            rca: item.rca || '-',
                            baName: item.baName || '-',
                            oaName: item.oaName || '-',
                            caseTypeName: item.caseTypeName || '-'
                        });
                    });
                }
                
                // Process No Action cases
                if (apiResponse.noAction && apiResponse.noAction.data && Array.isArray(apiResponse.noAction.data)) {
                    vm.noActionCount = apiResponse.noAction.count || apiResponse.noAction.data.length;
                }
                // SLA Compliance percentage from API if available
                if (apiResponse && typeof apiResponse.resolvedInTimePerc !== 'undefined' && apiResponse.resolvedInTimePerc !== null) {
                  //  vm.slaCompliancePerc = apiResponse.resolvedInTimePerc;
                }
                
                // Populate MTTR Details table from resolved case data and mttrdata mapping
                vm.mttrDetails = [];
                var mttrDataMap = {}; // Map caseNumber to mttrdata rows for quick lookup
                
                // Build map from mttrdata
                if (apiResponse && apiResponse.mttrdata && Array.isArray(apiResponse.mttrdata)) {
                    apiResponse.mttrdata.forEach(function(item) {
                        var caseNumber = item && item.caseNumber ? String(item.caseNumber) : '';
                        if (caseNumber) {
                            if (!mttrDataMap[caseNumber]) {
                                mttrDataMap[caseNumber] = [];
                            }
                            mttrDataMap[caseNumber].push(item);
                        }
                    });
                }
                
                // Populate MTTR table from resolved cases with mttrdata enrichment
                if (apiResponse && apiResponse.resovedcaseData && Array.isArray(apiResponse.resovedcaseData)) {
                    apiResponse.resovedcaseData.forEach(function(resolvedCase) {
                        var createdDate = resolvedCase.createDate ? new Date(resolvedCase.createDate) : null;
                        var resolvedCaseTicketId = resolvedCase.ticketId ? String(resolvedCase.ticketId) : '';
                        
                        // Match corresponding MTTR data using ticketId/caseNumber and createDate/caseCreatedDate
                        var mttrCandidates = resolvedCaseTicketId ? (mttrDataMap[resolvedCaseTicketId] || []) : [];
                        var mttrData = null;

                        for (var mttrIndex = 0; mttrIndex < mttrCandidates.length; mttrIndex++) {
                            var candidate = mttrCandidates[mttrIndex];
                            if (isSameCaseDateTime(resolvedCase.createDate, candidate && candidate.caseCreatedDate)) {
                                mttrData = candidate;
                                break;
                            }
                        }

                        var resolvedDate = mttrData && mttrData.resolvedTime ? parseDateTimeValue(mttrData.resolvedTime) : null;
                        var resolutionTime = mttrData ? mttrData.createdDateToResolvedH : '-';
                        
                        // Calculate resolution hours for SLA comparison
                        var resolvedHours = 99; // Default high value for breach
                        if (mttrData) {
                            resolvedHours = extractHours(mttrData.createdDateToResolvedH);
                        }
                        
                        vm.mttrDetails.push({
                            incidentId: resolvedCase.id || resolvedCase.caseId || '-',
                            createdDate: createdDate,
                            createdTime: createdDate ? formatTime(createdDate) : '-',
                            resolvedDate: resolvedDate,
                            resolvedTime: resolvedDate ? formatTime(resolvedDate) : '-',
                            resolutionTime: resolutionTime,
                            slaStatus: !isNaN(resolvedHours) && resolvedHours <= 8 ? 'Within SLA' : 'After SLA',
                            ticketId: resolvedCase.ticketId || '-',
                            title: resolvedCase.description || '-',
                            district: resolvedCase.district || '-',
                            block: resolvedCase.block || '-',
                            gpLocation: resolvedCase.gpLocation || '-',
                            incidentStatus: resolvedCase.status || '-',
                            rca: resolvedCase.rca || (mttrData && mttrData.rca ? mttrData.rca : '-'),
                            state: resolvedCase.state || '-',
                            priority: resolvedCase.priority || '-',
                            assignedTo: resolvedCase.assignedToUser || '-',
                            gpStatus: abbreviateGPStatus(resolvedCase.gpStatus || '-'),
                            baName: resolvedCase.baName || '-',
                            oaName: resolvedCase.oaName || '-',
                            caseTypeName: resolvedCase.caseTypeName || '-'
                        });
                    });
                }
                
                // Avg. Response/Resolution Time from mttrdata
                var totalResolvedHours = 0;
                var totalResponseHours = 0;
                var resolvedWithinSLACount = 0;
                
                if (apiResponse && apiResponse.mttrdata && Array.isArray(apiResponse.mttrdata)) {
                    apiResponse.mttrdata.forEach(function(item) {
                        var resolvedHours = extractHours(item && item.createdDateToResolvedH);
                        var responseHours = extractHours(item && item.resolutionTimeH);
                        
                        if (!isNaN(resolvedHours)) {
                            totalResolvedHours += resolvedHours;
                            // Count cases resolved within SLA (8 hours)
                            if (resolvedHours <= 8) {
                                resolvedWithinSLACount++;
                            }
                        }
                        if (!isNaN(responseHours)) {
                            totalResponseHours += responseHours;
                        }
                    });
                    
                    var mttrCount = apiResponse.mttrdata.length;
                    
                    // Set resolved within time count from mttrdata where createdDateToResolvedH <= 8
                    vm.resolvedwithinTimeCount = resolvedWithinSLACount;
                    
                    // Try to calculate immediately if priorityTotals is already available
                    recalculateSLACompliance();
                    var avgResolvedHours = mttrCount > 0 ? (totalResolvedHours / mttrCount) : 0;
                    var avgResponseHours = mttrCount > 0 ? (totalResponseHours / mttrCount) : 0;
                    var roundedAvgResolvedHours = roundHoursByMinutes(avgResolvedHours);
                    var roundedAvgResponseHours = roundHoursByMinutes(avgResponseHours);
                    vm.avgResolutionTime = roundedAvgResolvedHours;
                    vm.avgResolutionHours = roundedAvgResolvedHours;
                    vm.avgResponseTime = roundedAvgResponseHours;
                    vm.avgResponseHours = roundedAvgResponseHours;
                } else {
                    vm.avgResolutionTime = 0;
                    vm.avgResolutionHours = 0;
                    vm.avgResponseTime = 0;
                    vm.avgResponseHours = 0;
                }

                // Update MTTR details pagination
                vm.mttrDetailsTotalItems = (vm.mttrDetails || []).length;
                vm.mttrDetailsQueryCount = vm.mttrDetailsTotalItems;
                vm.mttrDetailsPage = 1;
                vm.updatePagedMttrDetails();

                // Get GP Down count directly from API response
                if (apiResponse && typeof apiResponse.gpDown !== 'undefined' && apiResponse.gpDown !== null) {
                    vm.gpDownCount = apiResponse.gpDown;
                } else {
                    vm.gpDownCount = 0;
                }

                if (apiResponse && apiResponse.blockDownData) {
                    vm.totalBlockCount = apiResponse.blockDownData.totalBlockCount || 0;
                    vm.blockDownCount = apiResponse.blockDownData.totalBlockDownCount || 0;
                } else {
                    vm.totalBlockCount = 0;
                    vm.blockDownCount = 0;
                }

                // GP Down list from API response
                if (apiResponse && Array.isArray(apiResponse.gpDownList)) {
                    vm.gpDownList = apiResponse.gpDownList.map(function(item) {
                        var createdMs = item && item.caseCreatedTime ? new Date(item.caseCreatedTime).getTime() : NaN;
                        var durationMinutes = isNaN(createdMs) ? 0 : Math.max(0, Math.floor((Date.now() - createdMs) / (1000 * 60)));
                        return angular.extend({}, item, {
                            gpDownDurationMinutes: durationMinutes
                        });
                    });
                } else {
                    vm.gpDownList = [];
                }

                if (apiResponse && apiResponse.blockDownData && Array.isArray(apiResponse.blockDownData.blockTicketsList)) {
                    vm.blockDownList = apiResponse.blockDownData.blockTicketsList.map(function(item) {
                        return angular.extend({}, item, {
                            createdDate: item.createDate ? new Date(item.createDate) : null,
                            dueDate: item.dueDate ? new Date(item.dueDate) : null,
                            caseStatus: item.status || '-',
                            assignedTo: item.assignedToUser || '-',
                            incidentId: item.id || item.caseId || '-',
                            ticketId: item.ticketId || null
                        });
                    });
                } else {
                    vm.blockDownList = [];
                }

                // Update GP Down pagination
                vm.gpDownTotalItems = (vm.gpDownList || []).length;
                vm.gpDownQueryCount = vm.gpDownTotalItems;
                vm.gpDownPage = 1;
                vm.updatePagedGpDown();

                vm.blockDownTotalItems = (vm.blockDownList || []).length;
                vm.blockDownQueryCount = vm.blockDownTotalItems;
                vm.blockDownPage = 1;
                vm.updatePagedBlockDown();
                
                // Update pagination totals and slice
                vm.totalItems = (vm.slaBreaches || []).length;
                vm.queryCount = vm.totalItems;
                vm.page = 1;
                vm.updatePagedSLA();
                
                // Update open incidents pagination
                vm.openIncidentsTotalItems = (vm.openIncidents || []).length;
                vm.openIncidentsQueryCount = vm.openIncidentsTotalItems;
                vm.openIncidentsPage = 1;
                vm.updatePagedOpenIncidents();
                
                // Update resolved incidents pagination
                vm.resolvedIncidentsTotalItems = (vm.resolvedIncidents || []).length;
                vm.resolvedIncidentsQueryCount = vm.resolvedIncidentsTotalItems;
                vm.resolvedIncidentsPage = 1;
                vm.updatePagedResolvedIncidents();
                
                // Update near to breach incidents pagination
                vm.nearToBreachTotalItems = (vm.nearToBreachIncidents || []).length;
                vm.nearToBreachQueryCount = vm.nearToBreachTotalItems;
                vm.nearToBreachPage = 1;
                vm.updatePagedNearToBreach();
                vm.page = 1;
                vm.updatePagedSLA();
                renderResponseTimeChart();
                
            } catch (e) {
                console.error('Error in transformAndDisplaySLAData:', e);
                vm.slaBreaches = [];
                vm.totalItems = 0;
                vm.queryCount = 0;
                vm.page = 1;
                vm.updatePagedSLA();
            }
        };
        
        function formatDate(dateStr) {
            var d = new Date(dateStr);
            var month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            return month[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
        }

        function formatTime(date) {
            if (!date || !(date instanceof Date)) return '-';
            var hours = String(date.getHours()).padStart(2, '0');
            var minutes = String(date.getMinutes()).padStart(2, '0');
            var seconds = String(date.getSeconds()).padStart(2, '0');
            return hours + ':' + minutes + ':' + seconds;
        }

        function parseDateTimeValue(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }
            if (value instanceof Date) {
                return isNaN(value.getTime()) ? null : value;
            }
            if (typeof value === 'number') {
                var numberDate = new Date(value);
                return isNaN(numberDate.getTime()) ? null : numberDate;
            }

            var str = String(value).trim();
            if (!str) {
                return null;
            }

            var normalized = str.replace(' ', 'T');
            var parsedDate = new Date(normalized);
            if (!isNaN(parsedDate.getTime())) {
                return parsedDate;
            }

            var match = str.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?$/);
            if (match) {
                return new Date(
                    parseInt(match[1], 10),
                    parseInt(match[2], 10) - 1,
                    parseInt(match[3], 10),
                    parseInt(match[4], 10),
                    parseInt(match[5], 10),
                    parseInt(match[6], 10),
                    parseInt((match[7] || '0').padEnd(3, '0'), 10)
                );
            }

            return null;
        }

        function isSameCaseDateTime(resolvedCaseCreateDate, mttrCaseCreatedDate) {
            var resolvedDate = parseDateTimeValue(resolvedCaseCreateDate);
            var mttrDate = parseDateTimeValue(mttrCaseCreatedDate);

            if (!resolvedDate || !mttrDate) {
                return false;
            }

            return resolvedDate.getTime() === mttrDate.getTime();
        }

        function extractHours(value) {
            if (value === null || value === undefined) { return 0; }
            if (typeof value === 'number') { return value; }
            var str = String(value);
            var m = str.match(/(\d+)\s*hrs?/i);
            if (m && m[1]) { return parseInt(m[1], 10) || 0; }
            var n = parseFloat(str);
            if (!isNaN(n)) { return n; }
            return 0;
        }

        function roundHoursByMinutes(hours) {
            if (hours === null || hours === undefined || isNaN(hours)) { return 0; }
            var totalMinutes = Math.round(hours * 60);
            var roundedHours = totalMinutes / 60;
            return parseFloat(roundedHours.toFixed(2));
        }

        // Function to recalculate SLA compliance when priorityTotals is updated
        function recalculateSLACompliance() {
            // Check if resolvedwithinTimeCount is defined (allow 0 as valid value)
            if (vm.resolvedwithinTimeCount === undefined || vm.resolvedwithinTimeCount === null) {
                return; // No data yet
            }
            
            var priorityTotals = vm.priorityTotals || {};
            var totalCount = (priorityTotals.ASSIGNED || 0) + 
                             (priorityTotals.TOBEASSIGNED || 0) + 
                             (priorityTotals.RESOLVED || 0) + 
                             (priorityTotals.INPROGRESS || 0) + 
                             (priorityTotals.PENDING || 0) + 
                             (priorityTotals.CLOSED || 0);
            
            vm.slaCompliancePerc = totalCount > 0 ? (vm.resolvedwithinTimeCount / totalCount) * 100 : 0;
        }

        vm.opertionalAreaSelect = function (businessAreaId) {

            if (!businessAreaId) {
                // Business Area was cleared - fall back to state-level data
                if (vm.selectedState) {
                    vm.onStateChange(vm.selectedState);
                }
                return;
            }

            // Set flag to prevent watcher from also loading data
            isLoadingViaHandler = true;
            
            // reset dependent filters when BA changes
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            vm.selectedOperationalAreaName = null;
            vm.selectedDistrict = null;
            vm.selectedBlock = null;
            vm.selectedGP = null;
            vm.districtList = [];
            vm.blockList = [];
            vm.gpList = [];

            getIncidentData.getOperationalArea(businessAreaId, function (response) {
                vm.operationalAreaName = response.data;
            });

            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;

            getIncidentData.getGeofenceIncidents(
                businessAreaId,
                fromTS,
                toTS,
                vm.selectedAMCStatus,
                function (priorityResp) {

                    getIncidentData.getGeofenceIncident(
                        businessAreaId,
                        fromTS,
                        toTS,
                        vm.selectedAMCStatus,
                        function (statusResp) {

                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);

                        });
                }
            );
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Reset flag after a short delay to allow watchers to settle
            $timeout(function() {
                isLoadingViaHandler = false;
            }, 100);

        };

        vm.onOperationalAreaChange = function (operationalAreaId) {
            isLoadingViaHandler = true;
            
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            vm.selectedDistrict = null;
            vm.selectedBlock = null;
            vm.selectedGP = null;
            vm.blockList = [];
            vm.districtList = [];
            vm.gpList = [];

            if (!operationalAreaId) {
                // Operational Area was cleared - fall back to Business Area level if available
                if (vm.selectedBusinessArea) {
                    vm.opertionalAreaSelect(vm.selectedBusinessArea);
                }
                isLoadingViaHandler = false;
                return;
            }

            getIncidentData.getDistrict(operationalAreaId, function (response) {
                vm.districtList = response.data || response;
            });

            vm.triggerAPICall();
            
            // Debounce the SLA data loading to avoid race conditions
            debounceFilterChange(function() {
                loadSLADataWithCancellation();
                vm.loadRoleCounts();
                vm.loadGPTotalCount();
                vm.loadDayWiseTrendData();
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onDistrictChange = function (districtId) {
            isLoadingViaHandler = true;
            
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            vm.selectedBlock = null;
            vm.selectedGP = null;
            vm.blockList = [];
            vm.gpList = [];

            if (!districtId) {
                // District was cleared - fall back to Operational Area level if available
                if (vm.selectedOperationalAreaName) {
                    vm.onOperationalAreaChange(vm.selectedOperationalAreaName);
                }
                isLoadingViaHandler = false;
                return;
            }
            
            getIncidentData.getBlocks(districtId, function (response) {
                vm.blockList = response.data || response;
            });

            // Get date range for API calls
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;


            if (typeof getIncidentData.getIncidentsData === 'function' && typeof getIncidentData.getStatusData === 'function') {
                getIncidentData.getIncidentsData(districtId, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                    getIncidentData.getStatusData(districtId, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                        mergeData(priorityResp.data, statusResp.data);
                        prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        });
                    });
                } else {
                    console.error('getIncidentsData/getStatusData not available on getIncidentData service');
                }
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onBlockChange = function (blockId) {
            isLoadingViaHandler = true;
            
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            // Reset GP list when block changes
            vm.selectedGP = null;
            vm.gpList = [];
            
            if (!blockId) {
                // Block was cleared - fall back to District level if available
                if (vm.selectedDistrict) {
                    vm.onDistrictChange(vm.selectedDistrict);
                }
                isLoadingViaHandler = false;
                return;
            }
            
            // Load GP list for the selected block
            if (typeof getIncidentData.getGPListByBlock === 'function') {
                getIncidentData.getGPListByBlock(blockId, vm.selectedAMCStatus, function(response) {
                    if (response && response.data && response.data && Array.isArray(response.data)) {
                        vm.gpList = response.data.map(function(gp) {
                            return {
                                id: gp.id,
                                name: gp.name
                            };
                        });
                        // console.log('GP list loaded:', vm.gpList.length, 'GPs');
                    } else {
                        console.warn('No GP data in response:', response);
                        vm.gpList = [];
                    }
                });
            }
            
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;

            if (typeof getIncidentData.getIncidentsDataBlock === 'function' && 
                typeof getIncidentData.getStatusDataBlock === 'function') {
                getIncidentData.getIncidentsDataBlock(blockId, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                    getIncidentData.getStatusDataBlock(blockId, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                        mergeData(priorityResp.data, statusResp.data);
                        prepareBusinessAreaCases();
                        calculateTotals();
                        $timeout(renderAllBusinessAreaCharts, 500);
                    });
                });
            } else {
                console.error('getIncidentsDataBlock/getStatusDataBlock not available on getIncidentData service');
            }
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onPackageChange = function (packageId) {
            isLoadingViaHandler = true;
            
            // console.log('onPackageChange called with packageId:', packageId, 'selectedState:', vm.selectedState);
            vm.lastFilterChanged = 'package'; // Track that package was changed
            
            // Reset state when package changes and reload states for new package
            vm.selectedState = null;
            loadStatesForPackage(packageId);
            
            // Reset hierarchical filters when package is changed
            vm.selectedGP = null;
            vm.gpList = [];
            
            if (!packageId) return;
            
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
            
            // console.log('Package change - fromTS:', fromTS, 'toTS:', toTS);
            
            // If both package and state are selected, call both APIs
            if (packageId && vm.selectedState) {
                // console.log('Calling getIncidentsbyPackageAndState and getStatusbyPackageAndState');
                getIncidentData.getIncidentsbyPackageAndState(
                    packageId,
                    vm.selectedState,
                    fromTS,
                    toTS,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        // console.log('getIncidentsbyPackageAndState response:', priorityResp);
                        getIncidentData.getStatusbyPackageAndState(
                            packageId,
                            vm.selectedState,
                            fromTS,
                            toTS,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                // console.log('getStatusbyPackageAndState response:', statusResp);
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            } 
            // If only package is selected, call both package APIs
            else if (packageId) {
                // console.log('Calling getIncidentsbyPackage and getStatusbyPackage');
                getIncidentData.getIncidentsbyPackage(
                    fromTS,
                    toTS,
                    packageId,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        // console.log('getIncidentsbyPackage response:', priorityResp);
                        getIncidentData.getStatusbyPackage(
                            fromTS,
                            toTS,
                            packageId,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                // console.log('getStatusbyPackage response:', statusResp);
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            }
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onStateChange = function (stateId) {
            isLoadingViaHandler = true;
            
            // console.log('onStateChange called with stateId:', stateId, 'selectedPackage:', vm.selectedPackage);
            vm.lastFilterChanged = 'state'; // Track that state was changed
            
            // Reset hierarchical filters when state is changed
            vm.selectedBusinessArea = null;
            vm.selectedOperationalAreaName = null;
            vm.selectedDistrict = null;
            vm.selectedBlock = null;
            vm.selectedGP = null;
            vm.businessAreaName = [];
            vm.operationalAreaName = [];
            vm.districtList = [];
            vm.blockList = [];
            vm.gpList = [];
            
            if (!stateId) {
                // State was cleared - fall back to package-level data
                if (vm.selectedPackage) {
                    vm.onPackageChange(vm.selectedPackage);
                }
                isLoadingViaHandler = false;
                return;
            }
            
            // Load business areas for the selected state and package
            if (vm.selectedPackage && stateId) {
                getIncidentData.getBusinessArea(stateId, vm.selectedPackage, function (response) {
                    if (response.data) {
                        vm.businessAreaName = response.data.baList || [];
                    }
                });
            }
            
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
            
            // console.log('State change - fromTS:', fromTS, 'toTS:', toTS);
            
            // If both package and state are selected, call both APIs
            if (vm.selectedPackage && stateId) {
                // console.log('Calling getIncidentsbyPackageAndState and getStatusbyPackageAndState');
                getIncidentData.getIncidentsbyPackageAndState(
                    vm.selectedPackage,
                    stateId,
                    fromTS,
                    toTS,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        // console.log('getIncidentsbyPackageAndState response:', priorityResp);
                        getIncidentData.getStatusbyPackageAndState(
                            vm.selectedPackage,
                            stateId,
                            fromTS,
                            toTS,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                // console.log('getStatusbyPackageAndState response:', statusResp);
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            }
            // If only state is selected, you might want to handle this case
            // For now, just reload SLA data
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onGPChange = function (gpId) {
            isLoadingViaHandler = true;
            
            // console.log('onGPChange called with gpId:', gpId);
            vm.lastFilterChanged = null; // Reset to use hierarchical priority
            
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;
            
            if (!gpId) {
                // GP was cleared - fall back to Block level if available
                if (vm.selectedBlock) {
                    vm.onBlockChange(vm.selectedBlock);
                }
                isLoadingViaHandler = false;
                return;
            }
            
            // Call both priority and status APIs for GP
            if (typeof getIncidentData.getIncidentsDataGP === 'function' && 
                typeof getIncidentData.getStatusDataGP === 'function') {
                getIncidentData.getIncidentsDataGP(gpId, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                    getIncidentData.getStatusDataGP(gpId, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                        if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        }
                    });
                });
            } else {
                console.error('getIncidentsDataGP/getStatusDataGP not available on getIncidentData service');
            }
            
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
            
            // Debounce to prevent race conditions
            debounceFilterChange(function() {
                isLoadingViaHandler = false;
            }, 200);
        };

        vm.onCaseTypeChange = function (caseTypeId) {
            vm.onAlertTypeChange();
        };

        vm.onAMCStatusChange = function (amcStatus) {
            isLoadingViaHandler = true;
            vm.selectedAMCStatus = amcStatus || vm.selectedAMCStatus || 'ALL';
            var fromTS = vm.fromDate ? new Date(vm.fromDate).getTime() : 0;
            var toTS = vm.toDate ? new Date(vm.toDate).getTime() : 0;

            function reloadDashboardForActiveFilter() {
                // Reload by most specific active filter to avoid wrong endpoint selection
                if (vm.selectedGP) {
                    getIncidentData.getIncidentsDataGP(vm.selectedGP, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusDataGP(vm.selectedGP, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                mergeData(priorityResp.data, statusResp.data);
                                prepareBusinessAreaCases();
                                calculateTotals();
                                $timeout(renderAllBusinessAreaCharts, 500);
                            }
                        });
                    });
                } else if (vm.selectedBlock) {
                    getIncidentData.getIncidentsDataBlock(vm.selectedBlock, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusDataBlock(vm.selectedBlock, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                mergeData(priorityResp.data, statusResp.data);
                                prepareBusinessAreaCases();
                                calculateTotals();
                                $timeout(renderAllBusinessAreaCharts, 500);
                            }
                        });
                    });
                } else if (vm.selectedDistrict) {
                    getIncidentData.getIncidentsData(vm.selectedDistrict, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusData(vm.selectedDistrict, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                mergeData(priorityResp.data, statusResp.data);
                                prepareBusinessAreaCases();
                                calculateTotals();
                                $timeout(renderAllBusinessAreaCharts, 500);
                            }
                        });
                    });
                } else if (vm.selectedOperationalAreaName || vm.selectedBusinessArea) {
                    vm.triggerAPICall();
                } else if (vm.selectedPackage && vm.selectedState) {
                    getIncidentData.getIncidentsbyPackageAndState(
                        vm.selectedPackage,
                        vm.selectedState,
                        fromTS,
                        toTS,
                        vm.selectedAMCStatus,
                        function (priorityResp) {
                            getIncidentData.getStatusbyPackageAndState(
                                vm.selectedPackage,
                                vm.selectedState,
                                fromTS,
                                toTS,
                                vm.selectedAMCStatus,
                                function (statusResp) {
                                    if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                        mergeData(priorityResp.data, statusResp.data);
                                        prepareBusinessAreaCases();
                                        calculateTotals();
                                        $timeout(renderAllBusinessAreaCharts, 500);
                                    }
                                }
                            );
                        }
                    );
                } else if (vm.selectedPackage) {
                    getIncidentData.getIncidentsbyPackage(
                        fromTS,
                        toTS,
                        vm.selectedPackage,
                        vm.selectedAMCStatus,
                        function (priorityResp) {
                            getIncidentData.getStatusbyPackage(
                                fromTS,
                                toTS,
                                vm.selectedPackage,
                                vm.selectedAMCStatus,
                                function (statusResp) {
                                    if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                        mergeData(priorityResp.data, statusResp.data);
                                        prepareBusinessAreaCases();
                                        calculateTotals();
                                        $timeout(renderAllBusinessAreaCharts, 500);
                                    }
                                }
                            );
                        }
                    );
                }

                vm.loadSLABreachData();
                vm.loadRoleCounts();
                vm.loadGPTotalCount();
                vm.loadDayWiseTrendData();

                // Debounce to prevent race conditions
                debounceFilterChange(function() {
                    isLoadingViaHandler = false;
                }, 200);
            }

            // AMC status filter changed, reload data with the selected filter
            // If block is selected, reload GP list with new AMC status
            if (vm.selectedBlock) {
                if (typeof getIncidentData.getGPListByBlock === 'function') {
                    getIncidentData.getGPListByBlock(vm.selectedBlock, vm.selectedAMCStatus, function(response) {
                        if (response && response.data && Array.isArray(response.data)) {
                            vm.gpList = response.data.map(function(gp) {
                                return {
                                    id: gp.id,
                                    name: gp.name
                                };
                            });
                            // Clear selected GP if it's no longer in the updated list
                            if (vm.selectedGP) {
                                var gpExists = vm.gpList.some(function(gp) {
                                    return gp.id === vm.selectedGP;
                                });
                                if (!gpExists) {
                                    vm.selectedGP = null;
                                }
                            }
                        } else {
                            vm.gpList = [];
                            vm.selectedGP = null;
                        }

                        reloadDashboardForActiveFilter();
                    });

                    return;
                }
            }

            reloadDashboardForActiveFilter();
        };

        vm.applyDateRange = function () {
            // Cancel any pending requests to prevent race conditions
            cancelPendingRequests();
            
            // Validate dates
            if (!vm.fromDate || !vm.toDate) {
                vm.dateValidationError = 'Please select both From Date and To Date';
                return;
            }
            
            var fromTime = new Date(vm.fromDate).getTime();
            var toTime = new Date(vm.toDate).getTime();
            
            // Validate timestamps
            if (isNaN(fromTime) || isNaN(toTime)) {
                vm.dateValidationError = 'Invalid date format. Please select valid dates.';
                return;
            }
            
            if (fromTime > toTime) {
                vm.dateValidationError = 'From Date cannot be greater than To Date';
                return;
            }
            
            // If we reach here, dates are valid, clear any error
            vm.dateValidationError = null;
            
            if (vm.fromDate && vm.toDate) {
                vm.dateRange = formatDate(vm.fromDate) + " - " + formatDate(vm.toDate);
            }
            vm.showDatePopup = false;

            var fromTS = fromTime;
            var toTS = toTime;

            // Determine most specific active filter
            // Priority: GP > Block > District > OA > BA > Package+State > Package > State > None
            var mostSpecificFilter = null;
            if (vm.selectedGP) {
                mostSpecificFilter = 'gp';
            } else if (vm.selectedBlock) {
                mostSpecificFilter = 'block';
            } else if (vm.selectedDistrict) {
                mostSpecificFilter = 'district';
            } else if (vm.selectedOperationalAreaName) {
                mostSpecificFilter = 'oa';
            } else if (vm.selectedBusinessArea) {
                mostSpecificFilter = 'ba';
            } else if (vm.selectedPackage && vm.selectedState) {
                mostSpecificFilter = 'packageState';
            } else if (vm.selectedPackage) {
                mostSpecificFilter = 'package';
            } else if (vm.selectedState) {
                mostSpecificFilter = 'state';
            }

            // Trigger appropriate data API calls based on most specific active filter
            if (mostSpecificFilter === 'gp') {
                if (typeof getIncidentData.getIncidentsDataGP === 'function' && 
                    typeof getIncidentData.getStatusDataGP === 'function') {
                    getIncidentData.getIncidentsDataGP(vm.selectedGP, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusDataGP(vm.selectedGP, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        });
                    });
                }
            } else if (mostSpecificFilter === 'block') {
                if (typeof getIncidentData.getIncidentsDataBlock === 'function' && 
                    typeof getIncidentData.getStatusDataBlock === 'function') {
                    getIncidentData.getIncidentsDataBlock(vm.selectedBlock, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusDataBlock(vm.selectedBlock, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        });
                    });
                }
            } else if (mostSpecificFilter === 'district') {
                if (typeof getIncidentData.getIncidentsData === 'function' && 
                    typeof getIncidentData.getStatusData === 'function') {
                    getIncidentData.getIncidentsData(vm.selectedDistrict, fromTS, toTS, vm.selectedAMCStatus, function (priorityResp) {
                        getIncidentData.getStatusData(vm.selectedDistrict, fromTS, toTS, vm.selectedAMCStatus, function (statusResp) {
                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);
                        });
                    });
                }
            } else if (mostSpecificFilter === 'packageState') {
                getIncidentData.getIncidentsbyPackageAndState(
                    vm.selectedPackage,
                    vm.selectedState,
                    fromTS,
                    toTS,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        getIncidentData.getStatusbyPackageAndState(
                            vm.selectedPackage,
                            vm.selectedState,
                            fromTS,
                            toTS,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            } else if (mostSpecificFilter === 'package') {
                getIncidentData.getIncidentsbyPackage(
                    fromTS,
                    toTS,
                    vm.selectedPackage,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        getIncidentData.getStatusbyPackage(
                            fromTS,
                            toTS,
                            vm.selectedPackage,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            } else if (mostSpecificFilter === 'state') {
                getIncidentData.getIncidentsbyPackageAndState(
                    vm.selectedPackage || 0,
                    vm.selectedState,
                    fromTS,
                    toTS,
                    vm.selectedAMCStatus,
                    function (priorityResp) {
                        getIncidentData.getStatusbyPackageAndState(
                            vm.selectedPackage || 0,
                            vm.selectedState,
                            fromTS,
                            toTS,
                            vm.selectedAMCStatus,
                            function (statusResp) {
                                if (priorityResp && priorityResp.data && statusResp && statusResp.data) {
                                    mergeData(priorityResp.data, statusResp.data);
                                    prepareBusinessAreaCases();
                                    calculateTotals();
                                    $timeout(renderAllBusinessAreaCharts, 500);
                                }
                            }
                        );
                    }
                );
            } else {
                // Default: BA/OA level or no filters
                vm.triggerAPICall();
            }

            // Always trigger these additional API calls
            vm.loadSLABreachData();
            vm.loadRoleCounts();
            vm.loadGPTotalCount();
            vm.loadDayWiseTrendData();
        }

        // Debounced data reload function to prevent race conditions
        vm.debouncedReloadData = function() {
            // Cancel any pending debounce timer
            if (filterChangeDebounceTimer) {
                $timeout.cancel(filterChangeDebounceTimer);
            }
            
            // Set a new debounce timer (500ms delay)
            filterChangeDebounceTimer = $timeout(function() {
                // Only reload if we have valid dates
                if (vm.fromDate && vm.toDate) {
                    var fromTime = new Date(vm.fromDate).getTime();
                    var toTime = new Date(vm.toDate).getTime();
                    
                    // Validate date range before reloading
                    if (!isNaN(fromTime) && !isNaN(toTime) && fromTime <= toTime) {
                        vm.applyDateRange();
                    }
                }
            }, 500);
        };

        // Watch for filter changes and trigger data reload
        // This ensures data consistency when filters change programmatically or via UI
        $scope.$watchGroup([
            function() { return vm.selectedPackage; },
            function() { return vm.selectedState; },
            function() { return vm.selectedBusinessArea; },
            function() { return vm.selectedOperationalAreaName; },
            function() { return vm.selectedDistrict; },
            function() { return vm.selectedBlock; },
            function() { return vm.selectedGP; },
            function() { return vm.selectedAMCStatus; },
            function() { return vm.fromDate; },
            function() { return vm.toDate; }
        ], function(newValues, oldValues, scope) {
            // Skip if data is already being loaded by ng-change handlers
            if (isLoadingViaHandler) {
                return;
            }
            
            // Skip the initial trigger when controller loads
            if (newValues === oldValues) {
                return;
            }
            
            // Check if any filter actually changed
            var hasChanged = false;
            for (var i = 0; i < newValues.length; i++) {
                if (newValues[i] !== oldValues[i]) {
                    hasChanged = true;
                    break;
                }
            }
            
            if (hasChanged) {
                // Use debounced reload to prevent rapid-fire requests
                vm.debouncedReloadData();
            }
        });

        // Apply defaults on load
        $timeout(function () {
            vm.applyDateRange();
        }, 0);
        vm.incidentData = []
        vm.triggerAPICall = function () {
            if (!vm.selectedBusinessArea) {
                return;
            }

            var fromTS = new Date(vm.fromDate).getTime();
            var toTS = new Date(vm.toDate).getTime();

            var oaId = vm.selectedOperationalAreaName || null;

            getIncidentData.getIncidents(
                vm.selectedBusinessArea,
                fromTS,
                toTS,
                oaId,
                vm.selectedAMCStatus,
                function (priorityResp) {

                    getIncidentData.getStatus(
                        vm.selectedBusinessArea,
                        fromTS,
                        toTS,
                        oaId,
                        vm.selectedAMCStatus,
                        function (statusResp) {

                            mergeData(priorityResp.data, statusResp.data);
                            prepareBusinessAreaCases();
                            calculateTotals();
                            $timeout(renderAllBusinessAreaCharts, 500);

                        });
                });

        }
        function mergeData(priorityList, statusList) {

            // Normalize inputs to arrays and add fallbacks for missing names/keys
            var pList = Array.isArray(priorityList) ? priorityList : (priorityList ? [priorityList] : []);
            var sList = Array.isArray(statusList) ? statusList : (statusList ? [statusList] : []);
            // console.log('Merging data - Priority List:', sList);

            vm.finalData = [];
            var statusMap = {};
            for (var i = 0; i < sList.length; i++) {
                var statusItem = sList[i] || {};
                var statusName = statusItem.geofenceName || statusItem.districtName || statusItem.name || 'TOTAL';
                statusMap[statusName] = statusItem;
            }
            for (var j = 0; j < pList.length; j++) {
                var p = pList[j] || {};
                var name = p.geofenceName || p.districtName || p.name || 'TOTAL';
                var s = statusMap[name] || { caseType: {} };

                vm.finalData.push({
                    geofenceName: name,
                    casePriority: p.casePriority || p.casepriority || {},
                    caseType: s.caseType || s.casetype || {}
                });
            }

            vm.geofenceData = vm.finalData;
            vm.incidentData = vm.finalData;
        }

        vm.ngRepeatDone = function () {
            $timeout(renderAllBusinessAreaCharts, 0); // DOM ready
        };
        function calculateTotals() {

            var totals = {
                CRITICAL: 0,
                HIGH: 0,
                MEDIUM: 0,
                LOW: 0,
                ASSIGNED: 0,
                TOBEASSIGNED: 0,
                RESOLVED: 0,
                // NEW: 0,
                // CANCELLED: 0,
                CLOSED: 0,
                INPROGRESS: 0,
                PENDING: 0
            };

            for (var i = 0; i < vm.finalData.length; i++) {

                var p = vm.finalData[i].casePriority || {};
                var t = vm.finalData[i].caseType || {};

                totals.CRITICAL += p.CRITICAL || 0;
                totals.HIGH += p.HIGH || 0;
                totals.MEDIUM += p.MEDIUM || 0;
                totals.LOW += p.LOW || 0;

                // totals.NEW += t.NEW || 0;
                totals.ASSIGNED += t.ASSIGNED || 0;
                totals.TOBEASSIGNED += t.TOBEASSIGNED || 0;
                totals.RESOLVED += t.RESOLVED || 0;
                // totals.CANCELLED += t.CANCELLED || 0;
                totals.CLOSED += t.CLOSED || 0;
                totals.INPROGRESS += t.INPROGRESS || 0;
                totals.PENDING += t.PENDING || 0;
            }

            vm.priorityTotals = totals;

            // Recalculate SLA compliance now that we have real priorityTotals data
            recalculateSLACompliance();

            // refresh the overall distribution pie whenever totals change
            $timeout(renderOverallDistributionChart, 0);
            $timeout(renderOverallStatusChart, 0);
        }

        function prepareBusinessAreaCases() {
            vm.businessAreaCases = [];

            for (var i = 0; i < vm.geofenceData.length; i++) {
                var item = vm.geofenceData[i];
                var p = item.casePriority || {};

                vm.businessAreaCases.push({
                    areaName: item.geofenceName,
                    critical: p.CRITICAL || 0,
                    high: p.HIGH || 0,
                    medium: p.MEDIUM || 0,
                    low: p.LOW || 0
                });
            }
        }

        function renderDonutAreaCharts() {

            d3.selectAll(".ba-chart-svg").remove();   // clear old SVGs

            var colors = {
                Critical: "#ff5c5c",
                High: "#ffa533",
                Medium: "#00e658",
                Low: "#294985"
            };

            var statusKeys = ["Critical", "High", "Medium", "Low"];

            // Tooltip (same as sync chart)
            var tooltip = d3.select("body").append("div")
                .attr("class", "chart-tooltip")
                .style("position", "absolute")
                .style("background", "white")
                .style("border", "1px solid #ccc")
                .style("padding", "6px 8px")
                .style("font-size", "12px")
                .style("border-radius", "4px")
                .style("pointer-events", "none")
                .style("opacity", 0);

            for (var i = 0; i < vm.businessAreaCases.length; i++) {

                var area = vm.businessAreaCases[i];
                var chartId = "donut-chart-" + i;

                var container = document.getElementById(chartId);
                if (!container) continue;

                var width = 220,
                    height = 180,
                    margin = { top: 20, right: 10, bottom: 60, left: 40 };

                var svg = d3.select("#" + chartId)
                    .append("svg")
                    .attr("class", "ba-chart-svg")
                    .attr("width", width)
                    .attr("height", height);

                var chartWidth = width - margin.left - margin.right;
                var chartHeight = height - margin.top - margin.bottom;

                var g = svg.append("g")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

                // Values
                var values = [
                    { key: "Critical", value: area.critical },
                    { key: "High", value: area.high },
                    { key: "Medium", value: area.medium },
                    { key: "Low", value: area.low }
                ];

                // Scales
                var x = d3.scale.ordinal()
                    .domain(statusKeys)
                    .rangeBands([0, chartWidth], 0.3);

                var y = d3.scale.linear()
                    .domain([0, d3.max(values, function (d) { return d.value; }) || 1])
                    .range([chartHeight, 0]);

                // Y-Axis (same style as sync chart)
                var yAxis = d3.svg.axis().scale(y).orient("left").ticks(5);
                g.append("g").attr("class", "y axis").call(yAxis);

                function make_y_grid() {
                    return d3.svg.axis()
                        .scale(y)
                        .orient("left")
                        .ticks(5);
                }

                g.append("g")
                    .attr("class", "grids horizontal-grid")
                    .call(make_y_grid()
                        .tickSize(-width, 0, 0)
                        .tickFormat("")
                    );
                function make_x_grid() {
                    return d3.svg.axis()
                        .scale(x)
                        .orient("bottom")
                        .ticks(vm.businessAreaCases.length);
                }

                g.append("g")
                    .attr("class", "grids vertical-grid")
                    .attr("transform", "translate(0," + chartHeight + ")")
                    .call(make_x_grid()
                        .tickSize(-chartHeight, 0, 0)
                        .tickFormat("")
                    );

                // Bars
                g.selectAll("rect")
                    .data(values)
                    .enter()
                    .append("rect")
                    .attr("x", function (d) { return x(d.key); })
                    .attr("y", function (d) { return y(d.value); })
                    .attr("width", x.rangeBand())
                    .attr("height", function (d) { return chartHeight - y(d.value); })
                    .style("fill", function (d) { return colors[d.key]; })
                    .on("mouseover", function (d) {
                        tooltip.transition().duration(200).style("opacity", 0.9);
                        tooltip.html("<b>" + d.key + "</b>: " + d.value);
                    })
                    .on("mousemove", function () {
                        tooltip.style("left", (d3.event.pageX + 10) + "px")
                            .style("top", (d3.event.pageY - 28) + "px");
                    })
                    .on("mouseout", function () {
                        tooltip.transition().duration(500).style("opacity", 0);
                    });

                // Value labels
                g.selectAll(".bar-value")
                    .data(values)
                    .enter()
                    .append("text")
                    .attr("class", "bar-value")
                    .attr("x", function (d) { return x(d.key) + x.rangeBand() / 2; })
                    .attr("y", function (d) { return y(d.value) - 5; })
                    .attr("text-anchor", "middle")
                    .style("font-size", "12px")
                    .style("font-weight", "bold")
                    .text(function (d) { return d.value; });

                // X-Axis labels
                var xAxis = d3.svg.axis().scale(x).orient("bottom");
                g.append("g")
                    .attr("class", "x axis")
                    .attr("transform", "translate(0," + chartHeight + ")")
                    .call(xAxis)
                    .selectAll("text")
                    .style("font-size", "10px")
                    .style("text-anchor", "end")
                    .attr("dx", "-0.5em")
                    .attr("dy", "0.2em")
                    .attr("transform", "rotate(-25)");

            }
        }

        function renderBarAreaCharts() {
            // remove any existing svg and tooltip for bar charts
            d3.selectAll(".ba-bar-svg").remove();
            d3.selectAll(".chart-tooltip").remove();

            var colors = {
                Met: "#1abc9c",
                Breached: "#cc0033"
            };

            // Tooltip
            var tooltip = d3.select("body").append("div")
                .attr("class", "chart-tooltip")
                .style("position", "absolute")
                .style("background", "white")
                .style("border", "1px solid #ccc")
                .style("padding", "6px 8px")
                .style("font-size", "12px")
                .style("border-radius", "4px")
                .style("pointer-events", "none")
                .style("opacity", 0);

            for (var i = 0; i < vm.businessAreaCases.length; i++) {
                var area = vm.businessAreaCases[i];
                var chartId = "bar-chart-" + i;
                var container = document.getElementById(chartId);
                if (!container) continue;

                var width = 220,
                    height = 180,
                    margin = { top: 20, right: 10, bottom: 60, left: 40 };

                var svg = d3.select("#" + chartId)
                    .append("svg")
                    .attr("class", "ba-bar-svg")
                    .attr("width", width)
                    .attr("height", height);

                var chartWidth = width - margin.left - margin.right;
                var chartHeight = height - margin.top - margin.bottom;

                var g = svg.append("g")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

                // Derive simple SLA values from area counts (used as dummy values)
                var slaMet = (area.medium || 0) + (area.low || 0) + Math.floor((area.high || 0) / 2);
                var slaBreached = (area.critical || 0) + Math.ceil((area.high || 0) / 2);

                // Ensure dummy values are visible — if computed SLA Breached is zero, set a default
                if (!slaMet || slaMet === 0) {
                    slaMet = 5;
                }
                if (!slaBreached || slaBreached === 0) {
                    slaBreached = 3;
                }

                var values = [
                    { key: "SLA Met", value: slaMet },
                    { key: "SLA Breached", value: slaBreached }
                ];

                var x = d3.scale.ordinal()
                    .domain(values.map(function (d) { return d.key; }))
                    .rangeBands([0, chartWidth], 0.6);

                var y = d3.scale.linear()
                    .domain([0, d3.max(values, function (d) { return d.value; }) || 1])
                    .range([chartHeight, 0]);

                var yAxis = d3.svg.axis().scale(y).orient("left").ticks(5);
                g.append("g").attr("class", "y axis").call(yAxis);

                // Grid lines (horizontal)
                function make_y_grid() {
                    return d3.svg.axis()
                        .scale(y)
                        .orient("left")
                        .ticks(5);
                }

                g.append("g")
                    .attr("class", "grids horizontal-grid")
                    .call(make_y_grid()
                        .tickSize(-width, 0, 0)
                        .tickFormat("")
                    );

                // Grid lines (vertical)
                function make_x_grid() {
                    return d3.svg.axis()
                        .scale(x)
                        .orient("bottom")
                        .ticks(values.length);
                }

                g.append("g")
                    .attr("class", "grids vertical-grid")
                    .attr("transform", "translate(0," + chartHeight + ")")
                    .call(make_x_grid()
                        .tickSize(-chartHeight, 0, 0)
                        .tickFormat("")
                    );

                // Bars
                g.selectAll("rect")
                    .data(values)
                    .enter()
                    .append("rect")
                    .attr("x", function (d) { return x(d.key); })
                    .attr("y", function (d) { return y(d.value); })
                    .attr("width", x.rangeBand())
                    .attr("height", function (d) { return chartHeight - y(d.value); })
                    .style("fill", function (d) { return d.key === 'SLA Met' ? colors.Met : colors.Breached; })
                    .on("mouseover", function (d) {
                        tooltip.transition().duration(200).style("opacity", 0.9);
                        tooltip.html("<b>" + d.key + "</b>: " + d.value);
                    })
                    .on("mousemove", function () {
                        tooltip.style("left", (d3.event.pageX + 10) + "px")
                            .style("top", (d3.event.pageY - 28) + "px");
                    })
                    .on("mouseout", function () {
                        tooltip.transition().duration(500).style("opacity", 0);
                    });

                // Value labels
                g.selectAll(".bar-value")
                    .data(values)
                    .enter()
                    .append("text")
                    .attr("class", "bar-value")
                    .attr("x", function (d) { return x(d.key) + x.rangeBand() / 2; })
                    .attr("y", function (d) { return y(d.value) - 5; })
                    .attr("text-anchor", "middle")
                    .style("font-size", "12px")
                    .style("font-weight", "bold")
                    .text(function (d) { return d.value; });

                // X-Axis labels
                var xAxis = d3.svg.axis().scale(x).orient("bottom");
                g.append("g")
                    .attr("class", "x axis")
                    .attr("transform", "translate(0," + chartHeight + ")")
                    .call(xAxis)
                    .selectAll("text")
                    .style("font-size", "10px")
                    .style("text-anchor", "end")
                    .attr("dx", "-0.5em")
                    .attr("dy", "0.2em")
                    .attr("transform", "rotate(-25)");

                
            }
        }

        // Render Overall Observation Line Chart (Weekly KPI) using Highcharts
        function renderOverallObservationChart() {
            var chartElement = document.getElementById('overall-observation-chart');
            if (!chartElement) return;

            // Prepare data from API response or use defaults
            var categories = [];
            var activeIncidents = [];
            var nearThreshold = [];
            var slaMetWithinTime = [];
            var slaMetAfterTime = [];
            var slaBreached = [];
            var slaExclusion = [];
            
            // console.log('renderOverallObservationChart called - vm.dayWiseTrendData:', vm.dayWiseTrendData);
            
            if (vm.dayWiseTrendData && typeof vm.dayWiseTrendData === 'object' && Object.keys(vm.dayWiseTrendData).length > 0) {
                // console.log('Processing API data - keys count:', Object.keys(vm.dayWiseTrendData).length);
                // console.log('Sample dayData structure:', vm.dayWiseTrendData[Object.keys(vm.dayWiseTrendData)[0]]);
                // API returns object with date keys - need to sort and transform
                var dateKeys = Object.keys(vm.dayWiseTrendData).sort(function(a, b) {
                    return new Date(a) - new Date(b);
                });
                
                dateKeys.forEach(function(dateKey) {
                    var dayData = vm.dayWiseTrendData[dateKey];
                    
                    // Format date to show month-day (e.g., "Jan 05")
                    var date = new Date(dateKey);
                    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    var formattedDate = months[date.getMonth()] + ' ' + date.getDate();
                    
                    categories.push(formattedDate);
                    activeIncidents.push(dayData.activeCaseCount || 0);
                    nearThreshold.push(dayData.nearBreachCount || 0);
                    slaMetWithinTime.push(dayData.resolvedWithinTime || 0);
                    slaMetAfterTime.push(dayData.resolvedAfterTime || 0);
                    slaBreached.push(dayData.breachedCount || 0);
                    slaExclusion.push(dayData.pendingCount || 0);
                });
            } else {
                console.warn('No API data found, using empty arrays');
                // Don't use dummy data - show empty chart or minimal data
                categories = ['No Data'];
                activeIncidents = [0];
                nearThreshold = [0];
                slaMetWithinTime = [0];
                slaMetAfterTime = [0];
                slaBreached = [0];
                slaExclusion = [0];
            }

            Highcharts.chart('overall-observation-chart', {
                chart: {
                    type: 'line',
                    height: 280,
                    style: { fontFamily: 'Segoe UI, Arial' },
                    spacingTop: 10,
                    spacingRight: 10,
                    spacingBottom: 10,
                    spacingLeft: 10,
                    zoomType: 'xy',
                    panning: {
                        enabled: true,
                        type: 'xy'
                    }
                },
                exporting: { enabled: false },
                title: null,
                xAxis: {
                    categories: categories,
                    crosshair: true
                },
                yAxis: {
                    title: { text: null }
                },
                tooltip: {
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    line: {
                        dataLabels: { enabled: false },
                        enableMouseTracking: true,
                        lineWidth: 2.5,
                        states: {
                            hover: {
                                lineWidth: 3
                            }
                        }
                    },
                    column: {
                        stacking: 'normal',
                        dataLabels: { enabled: false },
                        enableMouseTracking: true
                    }
                },
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom',
                    itemStyle: { fontWeight: 'normal' }
                },
                series: [
                    {
                        name: 'Active Incidents',
                        data: activeIncidents,
                        color: '#2980b9',
                        type: 'spline'
                    },
                    {
                        name: 'Near Threshold',
                        data: nearThreshold,
                        color: '#f4d03f',
                        type: 'column'
                    },
                    {
                        name: 'Resolved (Within SLA Time)',
                        data: slaMetWithinTime,
                        color: '#1abc9c',
                        type: 'column',
                        stack: 'slaMet'
                    },
                    {
                        name: 'Resolved (After SLA Time)',
                        data: slaMetAfterTime,
                        color: '#e67e22',
                        type: 'column',
                        stack: 'slaMet'
                    },
                    {
                        name: 'SLA Breached',
                        data: slaBreached,
                        color: '#cc0033',
                        type: 'column'
                    },
                    {
                        name: 'SLA Exclusion',
                        data: slaExclusion,
                        color: '#95a5a6',
                        type: 'column'
                    }
                ],
                credits: { enabled: false }
            });
        }

        // Render Overall Distribution Pie Chart using Highcharts
        function renderOverallDistributionChart() {
            var chartElement = document.getElementById('overall-distribution-chart');
            if (!chartElement) return;

            var totals = vm.priorityTotals || {};

            // inner ring: status distribution
            var statusTotal = (totals.ASSIGNED || 0) + (totals.TOBEASSIGNED || 0) + (totals.RESOLVED || 0)   + (totals.CLOSED || 0) + (totals.INPROGRESS || 0) + (totals.PENDING || 0);
            var statusSeries = statusTotal === 0 ? [
                { name: 'Assigned', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'To Be Assigned', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Resolved', y: 1, displayValue: 0, color: '#d3d3d3' },
                // { name: 'New', y: 1, displayValue: 0, color: '#d3d3d3' },
                // { name: 'Cancelled', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Closed', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'In Progress', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Out of Scope', y: 1, displayValue: 0, color: '#d3d3d3' }
            ] : [
                { name: 'Assigned',      y: totals.ASSIGNED || 0,      displayValue: totals.ASSIGNED || 0,      color: '#2980b9' },
                { name: 'To Be Assigned',y: totals.TOBEASSIGNED || 0,   displayValue: totals.TOBEASSIGNED || 0,   color: '#7a4fff' },
                { name: 'Resolved',      y: totals.RESOLVED || 0,      displayValue: totals.RESOLVED || 0,      color: '#1abc9c' },
                // { name: 'New',           y: totals.NEW || 0,           displayValue: totals.NEW || 0,           color: '#f39c12' },
                // { name: 'Cancelled',     y: totals.CANCELLED || 0,     displayValue: totals.CANCELLED || 0,     color: '#95a5a6' },
                { name: 'Closed',        y: totals.CLOSED || 0,        displayValue: totals.CLOSED || 0,        color: '#34495e' },
                { name: 'In Progress',   y: totals.INPROGRESS || 0,    displayValue: totals.INPROGRESS || 0,    color: '#9b59b6' },
                { name: 'Out of Scope',       y: totals.PENDING || 0,       displayValue: totals.PENDING || 0,       color: '#e67e22' }
            ];

            // outer ring: priority distribution
            var priorityCount = (totals.CRITICAL || 0) + (totals.HIGH || 0) + (totals.MEDIUM || 0) + (totals.LOW || 0);
            var prioritySeries = priorityCount === 0 ? [
                { name: 'Critical', y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'High',     y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Medium',   y: 1, displayValue: 0, color: '#d3d3d3' },
                { name: 'Low',      y: 1, displayValue: 0, color: '#d3d3d3' }
            ] : [
                { name: 'Critical', y: totals.CRITICAL || 0, displayValue: totals.CRITICAL || 0, color: '#ff5c5c' },
                { name: 'High',     y: totals.HIGH || 0,     displayValue: totals.HIGH || 0,     color: '#ffa533' },
                { name: 'Medium',   y: totals.MEDIUM || 0,   displayValue: totals.MEDIUM || 0,   color: '#00e658' },
                { name: 'Low',      y: totals.LOW || 0,      displayValue: totals.LOW || 0,      color: '#294985' }
            ];

            Highcharts.chart('overall-distribution-chart', {
                chart: {
                    type: 'pie',
                    height: 280,
                    style: { fontFamily: 'Segoe UI, Arial' },
                    spacingRight: 160,
                    events: {
                        load: function() {
                            var chart = this;
                            var legend = chart.legend;
                            
                            // Create custom legend HTML with table format
                            var legendHTML = '<table style="font-size:10px; width:100%;">';
                            
                            // Status header and items
                            legendHTML += '<tr><td colspan="2" style="font-weight:bold; font-size:11px; padding-top:5px; padding-bottom:5px; color:#333;">Status</td></tr>';
                            statusSeries.forEach(function(item, index) {
                                legendHTML += '<tr class="legend-item" data-series="0" data-index="' + index + '" style="cursor:pointer;">' +
                                    '<td style="padding:2px 5px 2px 0;"><span style="display:inline-block; width:10px; height:10px; background-color:' + item.color + '; border-radius:2px; margin-right:5px;"></span><span class="legend-text">' + item.name + '</span></td>' +
                                    '<td style="padding:2px 0; text-align:right;" class="legend-value"><b>' + item.displayValue + '</b></td>' +
                                    '</tr>';
                            });
                            
                            // Priority header and items
                            legendHTML += '<tr><td colspan="2" style="font-weight:bold; font-size:11px; padding-top:10px; padding-bottom:5px; color:#333;">Priority</td></tr>';
                            prioritySeries.forEach(function(item, index) {
                                legendHTML += '<tr class="legend-item" data-series="1" data-index="' + index + '" style="cursor:pointer;">' +
                                    '<td style="padding:2px 5px 2px 0;"><span style="display:inline-block; width:10px; height:10px; background-color:' + item.color + '; border-radius:2px; margin-right:5px;"></span><span class="legend-text">' + item.name + '</span></td>' +
                                    '<td style="padding:2px 0; text-align:right;" class="legend-value"><b>' + item.displayValue + '</b></td>' +
                                    '</tr>';
                            });
                            
                            legendHTML += '</table>';
                            
                            // Add custom legend to the chart - positioned on the right side
                            var legendWidth = 150;
                            var xPos = chart.chartWidth - legendWidth - 5;
                            var yPos = 30;
                            
                            var legendElement = chart.renderer.html(legendHTML, xPos, yPos)
                                .attr({ 
                                    zIndex: 5
                                })
                                .css({
                                    width: legendWidth + 'px'
                                })
                                .add();
                            
                            // Add click handlers to legend items
                            $timeout(function() {
                                var legendItems = document.querySelectorAll('#overall-distribution-chart .legend-item');
                                legendItems.forEach(function(item) {
                                    item.addEventListener('click', function() {
                                        var seriesIndex = parseInt(this.getAttribute('data-series'));
                                        var pointIndex = parseInt(this.getAttribute('data-index'));
                                        var series = chart.series[seriesIndex];
                                        var point = series.data[pointIndex];
                                        
                                        if (point.visible) {
                                            point.setVisible(false);
                                            this.style.opacity = '0.3';
                                            this.querySelector('.legend-text').style.textDecoration = 'line-through';
                                        } else {
                                            point.setVisible(true);
                                            this.style.opacity = '1';
                                            this.querySelector('.legend-text').style.textDecoration = 'none';
                                        }
                                    });
                                });
                            }, 100);
                        }
                    }
                },
                exporting: { enabled: false },
                title: null,
                tooltip: {
                    pointFormat: '<span style="color:{point.color}">●</span> <b>{point.name}</b>: {point.displayValue} <br/>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        cursor: 'pointer',
                        dataLabels: { enabled: false },
                        showInLegend: false
                    }
                },
                legend: {
                    enabled: false
                },
                series: [
                    {
                        name: 'Status',
                        colorByPoint: true,
                        innerSize: '55%',
                        data: statusSeries,
                        showInLegend: false,
                        dataLabels: { enabled: false }
                    },
                    {
                        name: 'Priority',
                        colorByPoint: true,
                        size: '80%',
                        innerSize: '65%',
                        data: prioritySeries,
                        showInLegend: false,
                        dataLabels: { enabled: false }
                    }
                ],
                credits: { enabled: false }
            });
        }

        // Render Overall Status Pie Chart using Highcharts
        function renderOverallStatusChart() {
            var chartElement = document.getElementById('overall-status-chart');
            if (!chartElement) return;

            var totals = vm.priorityTotals || {};
            var totalCount = (totals.ASSIGNED || 0) + (totals.TOBEASSIGNED || 0) + (totals.RESOLVED || 0) + (totals.NEW || 0) + (totals.CANCELLED || 0) + (totals.CLOSED || 0) + (totals.INPROGRESS || 0) + (totals.PENDING || 0);

            // Recalculate SLA compliance now that priorityTotals is updated with real data
            recalculateSLACompliance();

            var dataPoints;
            if (totalCount === 0) {
                dataPoints = [
                    { name: 'Assigned', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'To Be Assigned', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'Resolved', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'New', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'Cancelled', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'Closed', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'In Progress', y: 1, displayValue: 0, color: '#d3d3d3' },
                    { name: 'Pending', y: 1, displayValue: 0, color: '#d3d3d3' }
                ];
            } else {
                dataPoints = [
                    { name: 'Assigned',      y: totals.ASSIGNED || 0,      displayValue: totals.ASSIGNED || 0,      color: '#2980b9' },
                    { name: 'To Be Assigned',y: totals.TOBEASSIGNED || 0,   displayValue: totals.TOBEASSIGNED || 0,   color: '#7a4fff' },
                    { name: 'Resolved',      y: totals.RESOLVED || 0,      displayValue: totals.RESOLVED || 0,      color: '#1abc9c' },
                    { name: 'New',           y: totals.NEW || 0,           displayValue: totals.NEW || 0,           color: '#f39c12' },
                    { name: 'Cancelled',     y: totals.CANCELLED || 0,     displayValue: totals.CANCELLED || 0,     color: '#95a5a6' },
                    { name: 'Closed',        y: totals.CLOSED || 0,        displayValue: totals.CLOSED || 0,        color: '#34495e' },
                    { name: 'In Progress',   y: totals.INPROGRESS || 0,    displayValue: totals.INPROGRESS || 0,    color: '#9b59b6' },
                    { name: 'Pending',       y: totals.PENDING || 0,       displayValue: totals.PENDING || 0,       color: '#e67e22' }
                ];
            }

            Highcharts.chart('overall-status-chart', {
                chart: {
                    type: 'pie',
                    height: 260,
                    style: { fontFamily: 'Segoe UI, Arial' }
                },
                exporting: { enabled: false },
                title: null,
                tooltip: {
                    pointFormat: '<span style="color:{point.color}">●</span> <b>{point.name}</b>: {point.displayValue}<br/>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        cursor: 'pointer',
                        innerSize: '50%',
                        dataLabels: { enabled: false },
                        showInLegend: true
                    }
                },
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom',
                    itemStyle: { fontWeight: 'normal' },
                    useHTML: true,
                    labelFormatter: function() {
                        return this.name + ': <b>' + this.displayValue + '</b>';
                    }
                },
                series: [{
                    name: 'Status',
                    colorByPoint: true,
                    data: dataPoints
                }],
                credits: { enabled: false }
            });
        }

        // Render Response Time vs Resolution Time Chart
        function renderResponseTimeChart() {
            var chartElement = document.getElementById('response-time-chart');
            if (!chartElement) return;

            Highcharts.chart('response-time-chart', {
                chart: {
                    type: 'bar',
                    height: 200,
                    style: { fontFamily: 'Segoe UI, Arial' },
                    zoomType: 'xy',
                    panning: {
                        enabled: true,
                        type: 'xy'
                    }
                },
                exporting: { enabled: false },
                title: null,
                xAxis: {
                    categories: [''],
                    labels: {
                        enabled: false
                    }
                },
                yAxis: {
                    title: { text: 'Hours' },
                    min: 0,
                    max: 12,
                    plotLines: [{
                        value: 8,
                        color: '#cc0033',
                        width: 2,
                        dashStyle: 'Dash',
                        label: {
                            text: 'Threshold (8 hrs)',
                            align: 'right',
                            style: {
                                color: '#cc0033',
                                fontWeight: 'bold'
                            }
                        },
                        zIndex: 5
                    }]
                },
                tooltip: {
                    useHTML: true,
                    style: {
                        whiteSpace: 'normal'
                    },
                    formatter: function() {
                        return '<b>' + this.series.name + '</b><br/>' + this.y + ' hrs';
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: { 
                            enabled: true,
                            format: '{point.y} hrs',
                            style: { fontSize: '12px', fontWeight: 'bold' }
                        },
                        groupPadding: 0.1,
                        pointPadding: 0.1
                    },
                    series: {
                        pointWidth: 35
                    }
                },
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom',
                    itemStyle: { fontWeight: 'normal' }
                },
                series: [
                    {
                        name: 'Avg Response Time',
                        data: [vm.avgResponseHours || 0],
                        color: '#e84393'
                    },
                    {
                        name: 'Avg Resolution Time',
                        data: [vm.avgResolutionHours || 0],
                        color: '#34495e'
                    }
                ],
                credits: { enabled: false }
            });
        }

        // Initialize charts on load
        $timeout(function() {
            renderOverallDistributionChart();
            renderOverallStatusChart();
            // renderOverallObservationChart(); // Don't render initially - will be rendered when API data loads
            renderResponseTimeChart();
        }, 500);

        // render both kinds of charts (donut placeholders and bar charts)
        function renderAllBusinessAreaCharts() {
            try {
                renderDonutAreaCharts();
            } catch (e) {
                // swallow errors so other charts still attempt to render
                console.error('Error rendering donut area charts', e);
            }
            try {
                renderBarAreaCharts();
            } catch (e) {
                console.error('Error rendering bar area charts', e);
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("DashboardRolloutController", DashboardRolloutController);

    DashboardRolloutController.$inject = [
        "$scope",
        "$rootScope",
        "WorkOrderStats",
        "WorkOrder",
        "WorkFlowListByWorkOrderID",
        "AssetsByWorkFlowID",
        "TrProject",
        "pagingParams",
        "ParseLinks",
        "AlertService",
        "TrRouteListByProjectId",
        "RouteByID",
        "TaskStatusById",
        "SummaryPost",
        "TrRouteForMap",
        "ResourceType",
        "MaterialType"
    ];

    function DashboardRolloutController(
        $scope,
        $rootScope,
        WorkOrderStats,
        WorkOrder,
        WorkFlowListByWorkOrderID,
        AssetsByWorkFlowID,
        TrProject,
        pagingParams,
        ParseLinks,
        AlertService,
        TrRouteListByProjectId,
        RouteByID,
        TaskStatusById,
        SummaryPost,
        TrRouteForMap,
        ResourceType,
        MaterialType
    ) {
        var vm = this;
        var locations = {};
        var openedInfoWindow = null;
        var markers = [];
        var userPaths = {};
        vm.selectedWorkOrderDetails = null;
        vm.mapHeight = $rootScope.mapHeight;
        vm.routeResponse =  []
        var entryMarker =  null

        vm.uomMaterialTransaction = {}
        vm.storeMaterialTransactionName = []
        var isObjBool = {
            "PLANNING": false,
            "SURVEY": false,
            "ROLLOUT": false,
            "MAINTENANCE": false
        }
        var centerGeofence = {
            lat: $rootScope.DEFAULT_LATITUDE,
            lng: $rootScope.DEFAULT_LONGITUDE,
        };

        if(centerGeofence.lat!=undefined && centerGeofence.lng!=undefined){
            locations.map = new google.maps.Map(
                document.getElementById("map_canvas"),
                myOption(5, centerGeofence)
            );
        } else {
            console.log("Not able to fetch default latlng");
        }

        /*  WorkOrderStats.get("ROLLOUT",function (response) {
            var totalCount = response.length;
            var redCount = 0;
            var amberCount = 0;
            var greenCount = 0;
            response.forEach(function (markerVal) {
                if (markerVal.ragStatus == "RED") {
                    redCount++;
                } else if (markerVal.ragStatus == "AMBER") {
                    amberCount++;
                } else if (markerVal.ragStatus == "GREEN") {
                    greenCount++;
                }
                drawMarker(markerVal);
            });
            loadWorkOrderStats(
                totalCount,
                redCount,
                amberCount,
                greenCount
            );
        }); */

        function loadWorkOrderStats(
            totalCount,
            redCount,
            amberCount,
            greenCount
        ) {
            var svgtemp = d3.select("#workorder-stats-chart");
            svgtemp.selectAll("*").remove();
            var dataset = [
                {
                    label: "RED",
                    count: redCount,
                    percentage: ((redCount / totalCount) * 100).toFixed(0),
                },
                {
                    label: "AMBER",
                    count: amberCount,
                    percentage: ((amberCount / totalCount) * 100).toFixed(0),
                },
                {
                    label: "GREEN",
                    count: greenCount,
                    percentage: ((greenCount / totalCount) * 100).toFixed(0),
                },
            ];

            var width = 240;
            var height = 300;

            try {
                width =
                    document.getElementById("workorder-stats-chart")
                        .offsetWidth - 380;
                height = document.getElementById("workorder-stats-chart")
                    .offsetHeight;
            } catch (error) {
                // console.log(error);
            }

            // var radius = Math.min(width, height) / 2;
            // var donutWidth = 40;

            var radius = Math.min(width, height) / 1.8;
            var legendRectSize = 12;
            var legendSpacing = 3;

            var color = d3.scale
                .ordinal()
                .range(["#d2222d", "#ffbf00", "#238823"]);

            var svg = d3
                .select("#workorder-stats-chart")
                .append("svg")
                .attr("width", width)
                .attr("height", height)
                .append("g")
                .attr("shape-rendering", "geometricPrecision")
                .attr(
                    "transform",
                    "translate(" + width / 2 + "," + height / 2 + ")"
                );

            var arc = d3.svg
                .arc()
                .innerRadius(radius - 70)
                .outerRadius(radius - 30);

            var pie = d3.layout
                .pie()
                .value(function (d) {
                    return d.count;
                })
                .sort(null);

            dataset.forEach(function (d) {
                d.count = +d.count;
                d.enabled = true;
            });

            var path = svg
                .selectAll("path")
                .data(pie(dataset))
                .enter()
                .append("path")
                .attr("d", arc)
                .attr("fill", function (d, i) {
                    return color(
                        d.data.label + " - " + d.data.percentage + " %"
                    );
                })
                .each(function (d) {
                    this._current = d;
                });

            var tooltip2 = d3
                .select("body")
                .append("div")
                .attr("class", "toolTipA");

            path.on("mouseover", function (d) {
                tooltip2
                    .style("left", d3.event.pageX - 50 + "px")
                    .style("top", d3.event.pageY - 50 + "px")
                    .style("display", "inline-block")
                    .style("fill", "black")
                    .html(d.data.label + "<br>" + d.data.count);
                return tooltip2.style("visibility", "visible");
            })
                .on("mousemove", function () {
                    return tooltip2
                        .style("top", d3.event.pageY - 10 + "px")
                        .style("left", d3.event.pageX + 10 + "px");
                })
                .on("mouseout", function () {
                    return tooltip2.style("visibility", "hidden");
                });

            var legend = svg
                .selectAll(".legend")
                .data(color.domain())
                .enter()
                .append("g")
                .attr("class", "legend")
                .attr("transform", function (d, i) {
                    var height = legendRectSize + legendSpacing;
                    var offset = (height * color.domain().length) / 2;
                    var horz = -4.5 * legendRectSize;
                    var vert = i * height - offset;
                    return "translate(" + horz + "," + vert + ")";
                });

            legend
                .append("rect")
                .attr("width", legendRectSize)
                .attr("height", legendRectSize)
                .style("fill", color)
                .style("stroke", color)
                .on("click", function (label) {
                    var rect = d3.select(this);
                    var enabled = true;
                    var totalEnabled = d3.sum(
                        dataset.map(function (d) {
                            return d.enabled ? 1 : 0;
                        })
                    );

                    if (rect.attr("class") === "disabled") {
                        rect.attr("class", "");
                    } else {
                        if (totalEnabled < 2) return;
                        rect.attr("class", "disabled");
                        enabled = false;
                    }

                    pie.value(function (d) {
                        if (d.label === label) d.enabled = enabled;
                        return d.enabled ? d.count : 0;
                    });

                    path = path.data(pie(dataset));

                    path.transition()
                        .duration(750)
                        .attrTween("d", function (d) {
                            var interpolate = d3.interpolate(this._current, d);
                            this._current = interpolate(0);
                            return function (t) {
                                return arc(interpolate(t));
                            };
                        });
                });

            legend
                .append("text")
                .attr("x", legendRectSize + legendSpacing)
                .attr("y", legendRectSize - legendSpacing)
                .style("font-family", "sans-serif")
                .style("font-size", "12px")
                .text(function (d) {
                    return d;
                });
        }

        function drawMarker(value) {
            if (openedInfoWindow != null) {
                openedInfoWindow.close();
            }
            var iconUrl = "content/images/red-marker-100.png";

            if (value.ragStatus == "RED") {
                iconUrl = "content/images/red-marker-100.png";
            } else if (value.ragStatus == "AMBER") {
                iconUrl = "content/images/amber-marker-100.png";
            } else if (value.ragStatus == "GREEN") {
                iconUrl = "content/images/green-marker-100.png";
            }
            var infoWindow = new google.maps.InfoWindow();

            var startMarker = new google.maps.Marker({
                map: locations.map,
                position: new google.maps.LatLng(
                    value.latitude,
                    value.longitude
                ),
                title: value.description,
                icon: {
                    scaledSize: new google.maps.Size(36, 36),
                    origin: new google.maps.Point(0, 0),
                    url: iconUrl,
                    anchor: new google.maps.Point(24, 24),
                },
            });

            markers.push(startMarker);

            var infoWindow2 = new google.maps.InfoWindow();

            var userContent = document.createElement("div"),
                button;

            userContent.innerHTML =
                '<div class="infoWindowhead">' +
                startMarker.title +
                '</div><div class="infoWindowContent">' +
                "<b>Lat</b> :" +
                "<br>" +
                "</div>";

            google.maps.event.addListener(startMarker, "dblclick", function () {
                infoWindow2.close();
            });

            var infoWindow2 = new google.maps.InfoWindow({
                content: userContent,
            });
            // add listener on InfoWindow for click
            // event
            google.maps.event.addListener(startMarker, "click", function () {
                WorkFlowListByWorkOrderID.get(
                    value.id,
                    function (workorderDetails) {
                        vm.selectedWorkOrderDetails = null;
                        vm.new = 0;
                        vm.trenching = 0;
                        vm.ducting = 0;
                        vm.fiberifing = 0;
                        vm.lightning = 0;
                        vm.dit = 0;
                        vm.at = 0;
                        vm.workflowCount = 0;
                        vm.newAssets = [];
                        vm.trenchingAssets = [];
                        vm.ductingAssets = [];
                        vm.fiberpullingAssets = [];
                        vm.lightningAssets = [];
                        vm.routeSurveyAssets = [];
                        vm.chamberAssetsCount = 0;
                        vm.couplerAssetsCount = 0;
                        vm.siteAssetsCount = 0;
                        vm.fiberAssetsCount = 0;
                        var barData = {};
                        vm.selectedWorkOrderDetails = workorderDetails[0];
                        vm.selectedWorkOrderDetails.workflows.forEach(function (
                            workflow,
                            index
                        ) {
                            vm.workflowCount++;
                            AssetsByWorkFlowID.get(
                                workflow.id,
                                function (assets) {
                                    var workFlowAssets = [];
                                    assets.forEach(function (asset) {
                                        if (asset.assetTypeLayout == "SPREAD") {
                                            workFlowAssets.push(asset);
                                            if (asset.assetTypeName == "Link") {
                                                vm.fiberAssetsCount++;
                                            } else if (
                                                asset.assetTypeName ==
                                                "KML Link"
                                            ) {
                                                vm.fiberAssetsCount++;
                                            }
                                        } else {
                                            if (
                                                asset.assetTypeName ==
                                                    "Chamber_Latest" ||
                                                asset.assetTypeName == "Chamber"
                                            ) {
                                                vm.chamberAssetsCount++;
                                            } else if (
                                                asset.assetTypeName == "Coupler"
                                            ) {
                                                vm.couplerAssetsCount++;
                                            } else if (
                                                asset.assetTypeName == "Site"
                                            ) {
                                                vm.siteAssetsCount++;
                                            }
                                        }
                                    });
                                    switch (workflow.status) {
                                        case "NEW":
                                            vm.new++;
                                            vm.newAssets = workFlowAssets;
                                            drawPolyline(
                                                workFlowAssets,
                                                "#6495ED",
                                                userPaths.map
                                            );
                                            break;
                                        case "HDDTRENCHINGDONE":
                                            vm.trenching++;
                                            vm.trenchingAssets = workFlowAssets;
                                            drawPolyline(
                                                workFlowAssets,
                                                "#9FE2BF",
                                                userPaths.map
                                            );
                                            break;
                                        case "DUCTINGDONE":
                                            vm.ducting++;
                                            vm.ductingAssets = workFlowAssets;
                                            drawPolyline(
                                                workFlowAssets,
                                                "#FF7F50",
                                                userPaths.map
                                            );
                                            break;
                                        case "FIBERPULLINGDONE":
                                            vm.fiberifing++;
                                            vm.fiberpullingAssets = workFlowAssets;
                                            drawPolyline(
                                                workFlowAssets,
                                                "#FFBF00",
                                                userPaths.map
                                            );
                                            break;
                                        case "LIGHTING":
                                            vm.lightning++;
                                            vm.lightningAssets = workFlowAssets;
                                            drawPolyline(
                                                workFlowAssets,
                                                "#DFFF00",
                                                userPaths.map
                                            );
                                            break;
                                        case "ROUTESURVEYDONE":
                                            vm.dit++;
                                            vm.routeSurveyAssets = workFlowAssets;
                                            drawPolyline(
                                                workFlowAssets,
                                                "#CCCCFF",
                                                userPaths.map
                                            );
                                            break;
                                    }
                                    vm.newPercentage = parseInt(
                                        (vm.new / vm.workflowCount) * 100
                                    );
                                    vm.trenchingPercentage = parseInt(
                                        (vm.trenching / vm.workflowCount) * 100
                                    );
                                    vm.ductingPercentage = parseInt(
                                        (vm.ducting / vm.workflowCount) * 100
                                    );
                                    vm.fiberifingPercentage = parseInt(
                                        (vm.fiberifing / vm.workflowCount) * 100
                                    );
                                    vm.lightningPercentage = parseInt(
                                        (vm.lightning / vm.workflowCount) * 100
                                    );
                                    vm.ditPercentage = parseInt(
                                        (vm.dit / vm.workflowCount) * 100
                                    );
                                    vm.atPercentage = parseInt(
                                        (vm.at / vm.workflowCount) * 100
                                    );
                                    barData = {
                                        geofences: [
                                            {
                                                userStatusCount: {
                                                    Available:
                                                        vm.fiberAssetsCount *
                                                        1.5,
                                                },
                                                label: "Fiber",
                                                consumed: vm.fiberAssetsCount,
                                            },
                                            {
                                                userStatusCount: {
                                                    Available:
                                                        vm.siteAssetsCount *
                                                        1.5,
                                                },
                                                label: "Tower",
                                                consumed: vm.siteAssetsCount,
                                            },
                                            {
                                                userStatusCount: {
                                                    Available:
                                                        vm.couplerAssetsCount *
                                                        1.2,
                                                },
                                                label: "Coupler",
                                                consumed: vm.couplerAssetsCount,
                                            },
                                            {
                                                userStatusCount: {
                                                    Available:
                                                        vm.chamberAssetsCount *
                                                        1.3,
                                                },
                                                label: "Chamber",
                                                consumed: vm.chamberAssetsCount,
                                            },
                                        ],
                                    };
                                    if (index == 0) {
                                        showDashboardData(barData);
                                    }
                                }
                            );
                        });

                        /* var ele = document.getElementById("workorderChartModal");
                    $(ele).modal("show"); */
                        var centerGeofence = new google.maps.LatLng(
                            $rootScope.DEFAULT_LATITUDE,
                            $rootScope.DEFAULT_LONGITUDE
                        );
                        if(centerGeofence.lat!=undefined && centerGeofence.lng!=undefined){
                            userPaths.map = new google.maps.Map(
                                document.getElementById("workflow_map_canvas"),
                                myOption(10, centerGeofence)
                            );
                        } else {
                            console.log("Not able to fetch default latlng");
                        }
                        
                    }
                );
            });
            openedInfoWindow = infoWindow2;
        }

        /*  var centerGeofence = new google.maps.LatLng(
            $rootScope.DEFAULT_LATITUDE,
            $rootScope.DEFAULT_LONGITUDE
        );
        userPaths.map = new google.maps.Map(
            document.getElementById("workflow_map_canvas"),
            myOption(10, centerGeofence)
        ); */
        /* var customDiv = document.getElementById("workorder-stats-chart");

        // Add the custom div to the map
        locations.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
            customDiv
        ); */

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    },
                ],
            });
        }

        function drawPolyline(spreadAssets, color, map) {
            var cableCoordinates = [];
            var pos = {};
            for (var i = 0; i < spreadAssets.length; i++) {
                cableCoordinates = [];
                var coord = spreadAssets[i].assetCoordinates;
                pos = {
                    lat: coord[0].latitude,
                    lng: coord[0].longitude,
                };
                map.setZoom(11);
                map.setCenter(pos);
                coord.forEach(function (item) {
                    cableCoordinates.push({
                        lat: item.latitude,
                        lng: item.longitude,
                    });
                });
                var cablePath = new google.maps.Polyline({
                    path: cableCoordinates,
                    strokeColor: color,
                    strokeOpacity: 4,
                    strokeWeight: 10,
                });
                cablePath.setMap(map);
            }
        }

        /* function showDashboardData(data) {
            vm.users = data.users;
            vm.isGeofences = data.geofences.length == 0;
            var svgtempstatus = d3.select("#status");
            svgtempstatus.selectAll("*").remove();
            var svgtemp = d3.select("#stacked-chart-status");
            svgtemp.selectAll("*").remove();
            var tempHeight, tempWidth;

            // geofence bar graph
            var margin2 = { top: 30, right: 10, bottom: 85, left: 30 };

            var width2 = 960;
            var height2 = 300 - margin2.top - margin2.bottom;

            try {
                width2 =
                    document.getElementById("stacked-chart-status")
                        .offsetWidth -
                    margin2.left -
                    margin2.right;

                height2 =
                    document.getElementById("stacked-chart-status")
                        .offsetHeight -
                    margin2.top -
                    margin2.bottom;

                if (width2 < 0 || height2 < 0) {
                    width2 = tempWidth;
                    height2 = tempHeight;
                }
            } catch (error) {
                // console.log(error);
            }
            tempWidth = width2;
            tempHeight = height2;
            var svg = d3
                .select("#stacked-chart-status")
                .append("svg")
                .attr("width", width2 + margin2.left + margin2.right)
                .attr("height", height2 + margin2.top + margin2.bottom)
                .append("g")
                .attr(
                    "transform",
                    "translate(" + margin2.left + "," + margin2.top + ")"
                )
                .attr("shape-rendering", "geometricPrecision");
            // 

            var cases = data.geofences.map(function (d) {
                return {
                    x:
                        d.label.slice(0, 15) +
                        (d.label.length > 15 ? "..." : ""),
                    y: +d.consumed,
                    x1: d.label,
                };
            });
            // Transpose the data into layers
            //actual data
            var dataset = d3.layout.stack()(
                ["Available"].map(function (fruit) {
                    var groupData = data.geofences.slice(0, 40);
                    return groupData.map(function (d) {
                        return {
                            x:
                                d.label.slice(0, 15) +
                                (d.label.length > 15 ? "..." : ""),
                            y: +d.userStatusCount[fruit],
                            x1: fruit,
                        };
                    });
                    // }
                })
            );

            // Set x, y and colors
            var x = d3.scale
                .ordinal()
                .domain(
                    dataset[0].map(function (d) {
                        return d.x;
                    })
                )
                .rangeRoundBands([10, width2 - 50], 0.5);

            var countUsers = d3.max(dataset, function (d) {
                return d3.max(d, function (d) {
                    return d.y0 + d.y;
                });
            });

            if (countUsers >= 1) {
                var y = d3.scale
                    .linear()
                    .domain([
                        0,
                        d3.max(dataset, function (d) {
                            return d3.max(d, function (d) {
                                return d.y0 + d.y;
                            });
                        }),
                    ])
                    .range([height2, 0]);
            } else {
                var y = d3.scale
                    .linear()
                    .domain([
                        0,
                        d3.max(cases, function (d) {
                            return d.y;
                        }),
                    ])
                    .range([height2, 0]);
            }

            var colors = ["#99A98F", "#C1D0B5"];

            // Define and draw axes
            var yAxis = d3.svg
                .axis()
                .scale(y)
                .orient("left")
                .ticks(5)
                .tickSize(-width2, 0, 0)
                .tickFormat(function (d) {
                    if (d % 1 == 0) {
                        return d;
                    }
                });

            var xAxis = d3.svg.axis().scale(x).orient("bottom");
            // .tickFormat(d3.time.format("%y"));

            svg.append("g").attr("class", "y axis").call(yAxis);

            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height2 + ")")
                .call(xAxis)
                .selectAll("text")
                .style("text-anchor", "end")
                .style("font-family", "sans-serif")
                .style("font-size", "11px")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", "rotate(-45)");

            // Create groups for each series, rects for each segment
            var groups = svg
                .selectAll("g.cost")
                .data(dataset)
                .enter()
                .append("g")
                .attr("class", "cost")
                .style("fill", function (d, i) {
                    return colors[i];
                });

            var rect = groups
                .selectAll("rect")
                .data(function (d) {
                    return d;
                })
                .enter()
                .append("rect")
                .attr("x", function (d) {
                    return x(d.x) + x.rangeBand() / 2;
                })
                .attr("y", function (d) {
                    return y(d.y0 + d.y);
                })
                .attr("height", function (d) {
                    return y(d.y0) - y(d.y0 + d.y);
                })
                .attr("width", x.rangeBand() / 2);

            var caseBar = svg
                .selectAll(".rollOut-bar")
                .data(cases)
                .enter()
                .append("g")
                .attr("class", "rollOut-bar")
                .append("rect")
                .attr("x", function (d) {
                    return x(d.x); // center it
                })
                .attr("width", x.rangeBand() / 2) // make it slimmer
                .attr("y", function (d) {
                    return y(d.y);
                })
                .attr("height", function (d) {
                    return height2 - y(d.y);
                });
            // Draw legend
            var svg1 = d3
                .select("#status")
                .append("svg")
                .attr("width", width2 + margin2.left + margin2.right)
                .attr("height", 15)
                .append("g")
                .attr(
                    "transform",
                    "translate(" + (margin2.right - 25) + "," + -220 + ")"
                )
                .attr("shape-rendering", "geometricPrecision");

            var legend = svg1
                .selectAll(".legend")
                .data(colors)
                .enter()
                .append("g")
                .attr("class", "legend")
                .attr("width", 15)
                .attr("height", 15)
                .attr("transform", function (d, i) {
                    if (i == 2) {
                        return "translate(" + (i * 80 - 18) + ",30)";
                    } else {
                        return "translate(" + (i * 80 - 18) + ",30)";
                    }
                })
                // .on("click", function(d) {

                // });
                .on("click", function (d, i) {
                    
                    if (i == 2) {
                        if (
                            d3
                                .select(this)
                                .style("fill" == "#afafaf")
                                .style("opacity") == 1
                        ) {
                            d3.selectAll(".cost:nth-child(5)").style(
                                "opacity",
                                0
                            );
                            d3.select(this)
                                .style("fill", "#afafaf")
                                .style("opacity", "0.5");
                        } else {
                            d3.selectAll(".cost:nth-child(5)").style(
                                "opacity",
                                9
                            );
                            d3.select(this)
                                .style("fill", "#afafaf")
                                .style("opacity", 9);
                        }
                    }
                    if (i == 0) {
                        if (
                            d3
                                .select(this)
                                .style("fill" == "#99A98F")
                                .style("opacity") == 1
                        ) {
                            d3.selectAll(".cost:nth-child(3)").style(
                                "opacity",
                                0
                            );
                            d3.select(this)
                                .style("fill", "#99A98F")
                                .style("opacity", "0.5");
                        } else {
                            d3.selectAll(".cost:nth-child(3)").style(
                                "opacity",
                                9
                            );
                            d3.select(this)
                                .style("fill", "#99A98F")
                                .style("opacity", 9);
                        }
                    }
                });
            // .attr("transform", function(d,i) {
            // 	return "translate(" + width2 + "," + i * height2 + ")"; })

            legend
                .append("circle")
                .attr("cx", width2 / 2 - 96)
                .attr("cy", height2 + 67)
                .attr("r", 6)
                .style("fill", function (d, i) {
                    return colors[i];
                });

            legend
                .append("text")
                .attr("x", width2 / 2 - 85)
                .attr("y", height2 + 67)
                .attr("dy", ".35em")
                .style("text-anchor", "start")
                .style("font-family", "sans-serif")
                .style("font-size", "12px")
                .style("font-weight", "700")
                .style("cursor", "pointer")
                .text(function (d, i) {
                    switch (i) {
                        case 0:
                            return "Available";
                        case 1:
                            return "Consumed";
                    }
                });

            var tooltip1 = d3
                .select("body")
                .append("div")
                .attr("class", "toolTipA");

            rect.on("mouseover", function (d) {
                tooltip1
                    .style("left", d3.event.pageX - 50 + "px")
                    .style("top", d3.event.pageY - 50 + "px")
                    .style("display", "inline-block")
                    .style("fill", "black")
                    .html(d.x1 + "<br>" + d.y);
                return tooltip1.style("visibility", "visible");
            })
                .on("mousemove", function () {
                    return tooltip1
                        .style("top", d3.event.pageY - 10 + "px")
                        .style("left", d3.event.pageX + 10 + "px");
                })
                .on("mouseout", function () {
                    return tooltip1.style("visibility", "hidden");
                });

            caseBar
                .on("mouseover", function (d) {
                    tooltip1
                        .style("left", d3.event.pageX - 50 + "px")
                        .style("top", d3.event.pageY - 50 + "px")
                        .style("display", "inline-block")
                        .style("fill", "black")
                        .html("Consumed" + "<br>" + d.y);
                    return tooltip1.style("visibility", "visible");
                })
                .on("mousemove", function () {
                    return tooltip1
                        .style("top", d3.event.pageY - 10 + "px")
                        .style("left", d3.event.pageX + 10 + "px");
                })
                .on("mouseout", function () {
                    return tooltip1.style("visibility", "hidden");
                });
        } */

        // Rollout Dashboard Code Starts From Here
        var routeMap = {};
        var iconSize = 20;
        var infowindow = new google.maps.InfoWindow();
        var openedInfoWindow = null;
        var markersStore = [];
        var polylinesStore = [];
        var routePolylines = [];
        var terrainPolylines = [];
        var rowPolylines = [];

        $scope.type = {
            route: {
                search: "Search",
                nothingSelected: "Routes",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            },
        };
        $(".select2").select2();

        var centerGeofence = {
            lat:$rootScope.DEFAULT_LATITUDE,
            lng:$rootScope.DEFAULT_LONGITUDE
        };

        if(centerGeofence.lat!=undefined && centerGeofence.lng!=undefined){
            routeMap.map = new google.maps.Map(
                document.getElementById("workflow_map_canvas"),
                myOption(15, centerGeofence)
            );
        } else {
            console.log("Not able to fetch default latlng");
        }
        

        vm.height = 411

        vm.storeProjects = []
        callProjects(0, 20);
        function callProjects(page, size) {
            TrProject.query(
                {
                    page: page,
                    size: size,
                    sort: "last_modified_date,desc",
                },
                function onSuccess(data, headers) {
                    vm.links = ParseLinks.parse(headers("link"));
                    if ((vm.links.next <= vm.links.last)) {
                        if (data.length) {
                            /* locations.map.setCenter({
                                lat: data[0].latitude,
                                lng: data[0].longitude,
                            }); */
                            data.forEach(function (each) {
                                if (each.latitude) {
                                    vm.storeProjects.push(each)
                                    addMarker(
                                        each.latitude,
                                        each.longitude,
                                        each
                                    );
                                }
                            });
                        }
                        callProjects(vm.links.next, 20);
                    }else{
                        if (data.length) {
                            /* locations.map.setCenter({
                                lat: data[0].latitude,
                                lng: data[0].longitude,
                            }); */
                            data.forEach(function (each) {
                                if (each.latitude) {
                                    vm.storeProjects.push(each)
                                    addMarker(
                                        each.latitude,
                                        each.longitude,
                                        each
                                    );
                                }
                            });
                        }
                    }
                },
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            );
        }

        // Assuming map is your Google Maps map object
        function addMarker(latitude, longitude, each) {
            var icon = each.ragStatus
                ? "content/images/ROLLOUT_" + each.ragStatus + ".png"
                : "content/images/marker-rollout-project.png";
            var marker = new google.maps.Marker({
                position: { lat: latitude, lng: longitude },
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(32, 32),
                    origin: new google.maps.Point(0, 0),
                    url: icon,
                    anchor: new google.maps.Point(24, 24),
                },
            });

            //bouncingMarker = marker;

            marker.addListener("click", function () {
                //$('#projectSearch').val(null).trigger('change.select2');
                // Handle marker click event here
               /*  if (bouncingMarker) {
                    bouncingMarker.setAnimation(null); // Stop the current bouncing marker
                }else{
                    marker.setAnimation(google.maps.Animation.BOUNCE);
                } */

                if(entryMarker){
                    entryMarker.setMap(null)
                }
                
                var markerIndicator = new google.maps.Marker({
                    icon:  {
                        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                        strokeColor: "#FD7A24",
                        fillColor:'#FD7A24',
                        fillOpacity:1,
                        scale: 4,
                        anchor: new google.maps.Point(1, 1) // Set anchor point to the left
                    },
                    map: locations.map,
                    position: {
                        "lat": latitude,
                        "lng": longitude
                    },
                });
                entryMarker = markerIndicator
                markerIndicator.setMap(locations.map)
                
                callProjectDetail(each)
                vm.projectDetail = each.id
                vm.projectList = each

                $('#select2-projectSearch-container').text(each.name);

                //$scope.$apply()
            });

            if (vm.storeProjects[0].id == each.id) {

                var markerIndicator = new google.maps.Marker({
                    icon:  {
                        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                        strokeColor: "#FD7A24",
                        fillColor:'#FD7A24',
                        fillOpacity:1,
                        scale: 4,
                        anchor: new google.maps.Point(1, 1) // Set anchor point to the left
                    },
                    map: locations.map,
                    position: {
                        "lat": latitude,
                        "lng": longitude
                    },
                });
                entryMarker = markerIndicator
                markerIndicator.setMap(locations.map)
                
                vm.projectDetail = each.id
                vm.onProjectChange()
                $('#select2-projectSearch-container').text(each.name);
            }
        }

        var coordinateList = [];
        vm.onRouteChange = function () {
            showRouteDetails();
        };

        function showRouteDetails(){
            vm.objectTaskStatus = null
            var chainageList = [];
            coordinateList = [];
            vm.taskstatus = [];
            if (vm.routeId) {
                // To clear all markers
                markersStore.forEach(function (marker) {
                    marker.setMap(null);
                });
                markersStore = [];

                // To clear all polylines
                polylinesStore.forEach(function (polyline) {
                    polyline.setMap(null);
                });
                polylinesStore = [];

                // To clear all polylines
                routePolylines.forEach(function (routePolyline) {
                    routePolyline.setMap(null);
                });
                routePolylines = [];

                // To clear all polylines
                terrainPolylines.forEach(function (terrainPolyline) {
                    terrainPolyline.setMap(null);
                });
                terrainPolylines = [];

                // To clear all polylines
                rowPolylines.forEach(function (rowPolyline) {
                    rowPolyline.setMap(null);
                });
                rowPolylines = [];
                
                clearPolyLines();
                
                RouteByID.get(vm.routeId, function (data) {
                    vm.trRoute = data;
                    if (
                        vm.trRoute &&
                        vm.trRoute.routePoints != null &&
                        vm.trRoute.routePoints.length
                    ) {
                        vm.trRoute.routePoints.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                        var groupedRoutePoints = {};
                        vm.trRoute.routePoints.forEach(function (each) {
                            if (each.routePointType === "COORDINATE" && each.phase != null) {
                                if (each.sessionNumber) {
                                    if (!groupedRoutePoints[each.sessionNumber]) {
                                        groupedRoutePoints[each.sessionNumber] = [];
                                    }
                                    groupedRoutePoints[each.sessionNumber].push(each);
                                }
                            } else if (each.routePointType === "CHAINAGE" && each.phase != null) {
                                isObjBool[each.phase] = true;
                                chainageList.push({
                                    latitude: each.latitude,
                                    longitude: each.longitude,
                                    type: each.routePointType,
                                    number: each.routePointNumber,
                                    phase: each.phase,
                                });
                            }
                        });
                        Object.keys(groupedRoutePoints).forEach(function (sessionNumber) {
                            var sessionPoints = groupedRoutePoints[sessionNumber];
                            sessionPoints.sort(function (a, b) {
                                return a.routePointNumberDouble - b.routePointNumberDouble;
                            });

                            if (sessionPoints.length > 1) {
                                var sessionCoordinateList = [];
                                sessionPoints.forEach(function (each) {
                                    var coordinate = { lat: each.latitude, lng: each.longitude };
                                    if (each.phase === "PLANNING" || each.phase === "SURVEY") {
                                        sessionCoordinateList.push(coordinate);
                                    }
                                });
                                coordinateList.push(sessionCoordinateList);
                            }
                        });

                        coordinateList.forEach(function (sessionCoordinates) {
                            if(routeMap.map!=undefined){
                                routeMap.map.setCenter(sessionCoordinates[0]);
                            }
                            var polyline = new google.maps.Polyline({
                                path: sessionCoordinates,
                                geodesic: true,
                                strokeColor: "#FD7A24",
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                            });
                            polyline.setMap(routeMap.map);
                            routePolylines.push(polyline);
                        });

                        if (coordinateList.length) {
                            coordinateList.forEach(function(coordinate){
                                if(routeMap.map!=undefined){
                                    routeMap.map.setCenter(coordinate[0]);
                                }
                            });

                            /* var polyline = new google.maps.Polyline({
                                path: coordinateList,
                                geodesic: true,
                                strokeColor: "#FD7A24",
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                            });

                            // Set the map to display the polyline
                            polyline.setMap(routeMap.map);
                            polylinesStore.push(polyline); */
                        }

                        
                        if (chainageList.length) {
                            chainageList.forEach(function (coor) {
                                if(routeMap.map!=undefined){
                                    routeMap.map.setCenter(coor[0]);
                                }
                                createMarkers(
                                    coor,
                                    "content/images/chainagePoints.png",
                                    routeMap.map,
                                    null
                                );
                            });
                            
                        }
                    } else {
                        vm.isShowFilter = false;
                    }

                    TrRouteForMap.getTerrainPathByRoute(
                        vm.trRoute.id,
                        function (response) {
                            vm.terrainPathResponse = response;
                            vm.mapFilterList = [];
                            callTerrainPath();
                        },
                        function (err) {
                            callDrawRoute();
                            TrRouteForMap.getRoWPathByRoute(
                                vm.trRoute.id,
                                function (response) {
                                    vm.rowPathResponse = response;
                                    if (response.length) {
                                        vm.mapFilterList.push({
                                            name: "<strong>RoW</strong>",
                                            msGroup: true,
                                        });
                                        console.log(vm.mapFilterList);
                                        callRowPath();
                                    }
                                }
                            );
                        }
                    );
                });

                TaskStatusById.getworkOrderByRoute(
                    vm.routeId,
                    function (response) {
                        vm.workorderList = response;

                        if(vm.workorderList.length > 0){
                            vm.workOrderId = vm.workorderList[0].id;

                            if(vm.workOrderId){
                                vm.onWorkOrderChange()
                            }
                            
                        }else{
                            TaskStatusById.post(
                                { routeIds: [vm.routeId] },
                                function (statusresponse) {
                                    vm.taskstatus = statusresponse;
                                    if(vm.taskstatus.length){
                                        callTaskStatusByStagCat()
                                    } 
                                }
                            );
                        }
                        
                    },function (err) {
                        vm.workorderList = [];
                        TaskStatusById.post(
                            { routeIds:[10279095] },
                            function (statusresponse) {
                                vm.taskstatus = statusresponse;
                                if(vm.taskstatus.length){
                                    callTaskStatusByStagCat()
                                } 
                            }
                        );
                    }
                );

                //Resource Types
                ResourceType.query(
                    {
                        page: 0,
                        size: 30,
                        sort: "update_date,desc",
                    },
                    onSuccess,
                    onError
                );
                function onSuccess(resourceResponse, headers) {
                    /*  vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems; 
                    vm.resourceTypes = data;*/
                    if (resourceResponse.length > 0) {
                        vm.resTxSummary = resourceResponse;
                        var data = [];
                        vm.mapResourceTransaction = {};

                        resourceResponse.forEach(function (item) {
                            if (!vm.mapResourceTransaction[item.name]) {
                                vm.mapResourceTransaction[item.name] = {
                                    item: item.name,
                                    PLANNED: 0,
                                    REQUESTED: 0,
                                    RECEIVED: 0,
                                    UTILIZED: 0,
                                    RECONCILED: 0,
                                };
                                data.push(vm.mapResourceTransaction[item.name]);
                            }
                            vm.mapResourceTransaction[item.name][
                                item.transactionType
                            ] = 0;
                        });
                        d3.selectAll("#RESOURCES > *").remove();
                        //showDashboardData(data,'RESOURCES')
                        SummaryPost.resTx(
                            {
                                projectIds: [vm.projectDetail],
                                routeIds: [vm.routeId],
                            },
                            function (response) {
                                if (response.length) {
                                    vm.resTxSummary = response;
                                    response.forEach(function (item) {
                                        vm.mapResourceTransaction[
                                            item.resourceTypeName
                                        ][item.transactionType] +=
                                            item.totalNoOfResources;
                                    });
                                    showDashboardData(data, "RESOURCES");
                                } else {
                                    showDashboardData(data, "RESOURCES");
                                }
                            },
                            function (error) {
                                showDashboardData(data, "RESOURCES");
                            }
                        );
                    } else {
                        callTransaction("Resource");
                    }
                    //vm.page = pagingParams.page;
                }
                function onError(error) {
                    callTransaction("Resource");
                    AlertService.error(error.data.message);
                }


                //Material Types
                 MaterialType.query(
                    {
                        page: 0,
                        size: 30,
                        sort: "update_date,desc",
                    },
                    function onSuccess(materialResponse, headers) {
                    if (materialResponse.length > 0) {
                        vm.mtrlTxSummary = materialResponse;
                        var data = [];
                        vm.mapMaterialTransaction = {};
                        
                        //vm.quantity = []
                        materialResponse.forEach(function (item) {
                            /* if (item.trUnitOfMeasurement != null && item.trUnitOfMeasurement.name !=null && !vm.mapMaterialTransaction[item.trUnitOfMeasurement]  && !vm.mapMaterialTransaction[item.trUnitOfMeasurement.name]) {
                                vm.mapMaterialTransaction[item.trUnitOfMeasurement.name] = {};
                                //data.push(vm.mapMaterialTransaction[item.trUnitOfMeasurement.name]);
                            } */

                           /*  if (item.trUnitOfMeasurement != null && item.trUnitOfMeasurement.name !=null &&  !vm.mapMaterialTransaction[item.trUnitOfMeasurement]  && !vm.mapMaterialTransaction[item.trUnitOfMeasurement.name][item.name]) {
                                vm.mapMaterialTransaction[item.trUnitOfMeasurement.name][item.name] = {
                                    item: item.name,
                                    PLANNED: 0,
                                    REQUESTED: 0,
                                    RECEIVED: 0,
                                    UTILIZED: 0,
                                    RECONCILED: 0,
                                };
                                data.push(vm.mapMaterialTransaction[item.trUnitOfMeasurement.name][item.name]);
                            }

                            if(item.trUnitOfMeasurement != null && item.trUnitOfMeasurement.name !=null ){
                                vm.mapMaterialTransaction[item.trUnitOfMeasurement.name][item.name][
                                    item.transactionType
                                ] = 0;
                            } */

                            if (!vm.mapMaterialTransaction[item.name]) {
                                var tempUom = null;
                                if(item.trUnitOfMeasurement != null && item.trUnitOfMeasurement.name != null){
                                    tempUom = item.trUnitOfMeasurement.name
                                }
                                 
                                vm.mapMaterialTransaction[item.name] = {
                                    item: item.name,
                                    PLANNED: 0,
                                    REQUESTED: 0,
                                    RECEIVED: 0,
                                    UTILIZED: 0,
                                    RECONCILED: 0,
                                    UOM : tempUom
                                };
                                data.push(vm.mapMaterialTransaction[item.name]);
                            }

                                vm.mapMaterialTransaction[item.name][
                                    item.transactionType
                                ] = 0;
                            

                            //if(item.trUnitOfMeasurement != null && item.trUnitOfMeasurement.name != null){
                            //    vm.quantity.push(item.trUnitOfMeasurement.name)
                            //}
                            
                        });
                        //console.log(vm.quantity)
                        //d3.selectAll("#materialChart > *").remove();
                        //showDashboardData(data,'materialChart')
                        SummaryPost.mtrlTx(
                            {
                                projectIds: [vm.projectDetail],
                                routeIds: [vm.routeId],
                            },
                            function (response) {
                                if (response.length) {
                                    vm.mtrlTxSummary = response;
                                    response.forEach(function (item) {
                                        if(item.unitOfMeasurementName != null){
                                            vm.mapMaterialTransaction[
                                                item.materialTypeName
                                            ][item.transactionType] +=
                                                item.totalNoOfUnits;
                                        }
                                    });

                                   callUOM(data)
                                    //showDashboardData(data, "materialChart");
                                } else {
                                    callUOM(data)
                                }
                            },
                            function (error) {
                                callUOM(data)
                            }
                        );
                    } else {
                        callTransaction("Material");
                    }
                    //vm.page = pagingParams.page;
                },
                     function onError(error) {
                    callTransaction("Material");
                    AlertService.error(error.data.message);
                } 
                ); 
                
               
            }
        }

        function createMarkers(arr, img, map, str) {
            var marker;
            var pathCordinates = [];
            if (Array.isArray(arr)) {
                pathCordinates = arr;
            } else {
                pathCordinates = [];
                pathCordinates.push(arr);
            }
            pathCordinates.forEach(function (each) {
                marker = new google.maps.Marker({
                    position: { lat: each.latitude, lng: each.longitude },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                google.maps.event.addListener(marker, "click", function () {
                    //var name = (each.name == (undefined || null)) ? " " : each.name
                    if (openedInfoWindow != null) {
                        openedInfoWindow.close();
                    }
                    infowindow.setContent(
                        '<div class="infoWindowhead"></br></br>' +
                            /* "<b>Name : "+name+"</b></br>"+ */
                            "<b>Latitude : " +
                            each.latitude +
                            "</b></br>" +
                            "<b>Longitude : " +
                            each.longitude +
                            "</b></br>" +
                            "<b>Type : " +
                            each.type +
                            "</b></br>" +
                            "<b>Number : " +
                            each.number +
                            "</b></br>" +
                            "</br></div>"
                    );
                    infowindow.open(map);
                    infowindow.setPosition({
                        lat: each.latitude,
                        lng: each.longitude,
                    });
                    openedInfoWindow = infowindow;
                });

                //arr.push(marker);
                markersStore.push(marker);
            });
        }

        // Create a legend with color and text
        function createLegend(color, text) {
            var legend = document.createElement("div");
            legend.innerHTML =
                '<span style="background-color: ' +
                color +
                '; width: 20px; height: 12px; display: inline-block; margin-right: 5px;"></span>' +
                text;
            return legend;
        }
        addLegends();
        // Add legends to the map
        function addLegends() {
            var legends = [
                { color: "#d2222d", text: "RED" },
                { color: "#ffbf00", text: "AMBER" },
                { color: "#238823", text: "GREEN" },
            ];

            var legendWrapper = document.createElement("div");
            legendWrapper.style.padding = "10px";
            legendWrapper.style.backgroundColor = "rgba(255, 255, 255, 0.7)";
            legendWrapper.style.border = "1px solid #ccc";
            legendWrapper.style.borderRadius = "5px";
            legendWrapper.style.position = "absolute";
            legendWrapper.style.top = "10px";
            legendWrapper.style.right = "10px";

            legends.forEach(function (legend) {
                var legendElement = createLegend(legend.color, legend.text);
                legendWrapper.appendChild(legendElement);
            });

            if(locations.map!=undefined){
                locations.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                    legendWrapper
                );
            }
        }

    
        
        function showDashboardData(data,id) {
            var margin, width, height, svg, x, y, xAxis, yAxis;
            // Your existing code for setting up the c
            margin = { top: 20, right: 30, bottom: 85, left: 40 };

            // Get the current width and height of the window
            width = window.innerWidth * 0.8 - margin.left - margin.right;
            height =
                window.innerHeight * 0.5 - margin.top - margin.bottom - 100;

            x = d3.scale
                .ordinal()
                .rangeRoundBands([0, width], 0.1)
                .domain(
                    data.map(function (d) {
                        return d.item;
                    })
                );

            y = d3.scale
                .linear()
                .range([height, 0])
                .domain([
                    0,
                    d3.max(data, function (d) {
                        return d3.max([
                            d.PLANNED,
                            d.REQUESTED,
                            d.RECEIVED,
                            d.UTILIZED,
                            d.RECONCILED,
                        ]);
                    }),
                ]);

            xAxis = d3.svg.axis().scale(x).orient("bottom");

            //yAxis = d3.svg.axis().scale(y).orient("left");

            yAxis = d3.svg.axis()
    .scale(y)
    .orient("left")
    .ticks(5) // Set the number of ticks
    .tickFormat(d3.format("d")); // Use a format that removes decimals

    
            svg = d3
                .select("#"+ id)
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr(
                    "transform",
                    "translate(" + margin.left + "," + margin.top + ")"
                );

            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(xAxis)
                .selectAll("text")
                .style("text-anchor", "end")
                .style("font-family", "sans-serif")
                .style("font-size", "11px")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", "rotate(-35)");

            svg.append("g").attr("class", "y axis").call(yAxis);

             // Add text next to the y-axis
    svg.append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 0 - margin.left)
        .attr("x", 0 - height / 2 - (margin.right + 40))
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .text(id);

            var colors = [
                "#AF7AC5",
                "#7FB3D5",
                "#76D7C4",
                "#E59866",
                "#ffdcf1",
            ];

            var categories = [
                "PLANNED",
                "REQUESTED",
                "RECEIVED",
                "UTILIZED",
                "RECONCILED",
            ];

            var tooltip1 = d3
                .select("body")
                .append("div")
                .attr("class", "toolTipA");

            

            categories.forEach(function (category, i) {
                svg.selectAll(".bar-" + category)
                    .data(data)
                    .enter()
                    .append("rect")
                    .attr("class", "bar-" + category)
                    .attr("x", function (d) {
                        return (
                            x(d.item) + (x.rangeBand() / categories.length) * i
                        );
                    })
                    .attr("width", x.rangeBand() / categories.length)
                    .attr("y", function (d) {
                        return y(Math.max(0.1, d[category])); 
                    })
                    .attr("height", function (d) {
                        return Math.max(1, height - y(Math.max(0.1, d[category])));  
                    })
                    .style("fill", colors[i])

                    .on("mouseover", function (d) {

                        if(d[category] != 0){
                            tooltip1
                            .style("left", d3.event.pageX - 50 + "px")
                            .style("top", d3.event.pageY - 50 + "px")
                            .style("display", "inline-block")
                            .style("fill", "black")
                            .html( category + ' - ' + d[category]);
                        return tooltip1.style("visibility", "visible");
                        }
                        
                    })
                        .on("mousemove", function () {
                            return tooltip1
                                .style("top", d3.event.pageY - 10 + "px")
                                .style("left", d3.event.pageX + 10 + "px");
                        })
                        .on("mouseout", function () {
                            return tooltip1.style("visibility", "hidden");
                        });
            });

            
           /*  var legend = svg
                .selectAll(".legend")
                .data(categories)
                .enter()
                .append("g")
                .attr("class", "legend")
                .attr("transform", function (d, i) {
                    return "translate(" + i * 80 + ", -20)";
                });

            legend
                .append("rect")
                .attr("x", 0)
                .attr("width", 18)
                .attr("height", 18)
                .style("fill", function (d, i) {
                    return colors[i];
                });

            legend
                .append("text")
                .attr("x", 25)
                .attr("y", 9)
                .attr("dy", ".35em")
                .style("text-anchor", "start")
                .text(function (d) {
                    return d;
                }); */

                 /* var element = document.getElementById('getHeight');
                            vm.height = element.clientHeight;  */
        }

        $scope.names = ['PLANNED', 'REQUESTED', 'RECEIVED', 'UTILIZED', 'RECONCILED'];
        $scope.legends = [
            { name: 'PLANNED', color: '#AF7AC5' },
            { name: 'REQUESTED', color: '#7FB3D5' },
            { name: 'RECEIVED', color: '#76D7C4' },
            { name: 'UTILIZED', color: '#E59866' },
            { name: 'RECONCILED', color: '#ffdcf1' }
          ];

          vm.mapFilterList = [];
        var polylines = []
        var tempPath = []
       

          function callTerrainPath() {
            
            TrRouteForMap.getTerrainByRoute(
                vm.trRoute.id,
                function (nameResponse) {
                    terrainPolylines = [];
                    vm.terrainListResponse = nameResponse
                    console.log(vm.mapFilterList);
                    if (nameResponse.length) {
                        vm.isShowFilter = true
                        vm.mapFilterList.push({ name: '<strong>Terrain</strong>', msGroup: true })
                        nameResponse.forEach(function (nameEach, indexName) {
                            if (vm.terrainPathResponse.length) {
                                vm.terrainPathResponse.forEach(function (item, indexPath) {
                                    if (nameEach.id == item.id) {
                                        if (
                                            item.value["COORDINATE"]
                                        ) {
                                            item.value["COORDINATE"].forEach(function (cord) {
                                                tempPath.push({ lat: cord.latitude, lng: cord.longitude })
                                            })

                                            var colorCode = nameEach.colorcode;
                                            vm.mapFilterList.push({
                                                name:
                                                    nameEach.name,
                                                path: tempPath,
                                                visible: true,
                                                strokeColor: '<img class="square" style="background-color:' +
                                                    colorCode +
                                                    ';">',
                                                colorCode: colorCode,
                                                type: "Terrain"
                                            });
                                            tempPath = []
                                        }
                                    }
                                });
                            }
                            vm.mapFilterList.forEach(function(item){
                                var line = new google.maps.Polyline({
                                    path: item.path,
                                    visible: item.visible,
                                    strokeColor: item.colorCode,
                                    strokeOpacity: 1.0,
                                    strokeWeight: 4,
                                    name: item.name,
                                    zIndex:3
                                });

                                google.maps.event.addListener(
                                    line,
                                    "click",
                                    function (event) {
                                       if (openedInfoWindow != null) {
                                        openedInfoWindow.close();
                                    }
                                    infowindow.setContent(
                                        '<div class="infoWindowhead"></br></br>' +
                                            "<b>Name : " +
                                            item.name +
                                            "</b></br>" + "<b>Type : "+ item.type +"</b></br>" +
                                            "</div>"
                                    );
                                    infowindow.open(routeMap.map);
                                    infowindow.setPosition(event.latLng);
                                    openedInfoWindow = infowindow;
                                    }
                                );
                                line.setMap(routeMap.map);
                                terrainPolylines.push(line);
                            });
                        });
                        vm.mapFilterList.push({ msGroup: false })

                        TrRouteForMap.getRoWPathByRoute(
                            vm.trRoute.id,
                            function (response) {
                                vm.rowPathResponse = response
                                if (response.length) {
                                    vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                    callRowPath()
                                }

                            }
                        );
                    } else{

                        callDrawRoute()
                        TrRouteForMap.getRoWPathByRoute(
                            vm.trRoute.id,
                            function (response) {
                                vm.rowPathResponse = response
                                if (response.length) {
                                    vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                    callRowPath()
                                }
        
                            }
                        );
                    }
                },
                function (error) {
                    callDrawRoute()
                    TrRouteForMap.getRoWPathByRoute(
                        vm.trRoute.id,
                        function (response) {
                            vm.rowPathResponse = response
                            if (response.length) {
                                vm.mapFilterList.push({ name: '<strong>RoW</strong>', msGroup: true })
                                callRowPath()
                            }
    
                        }
                    );
                }
            );
        }

        function callRowPath() {

            TrRouteForMap.getRoWByRoute(
                vm.trRoute.id,
                function (nameResponse) {
                    vm.rowListResponse = nameResponse
                    if (nameResponse.length) {
                        nameResponse.forEach(function (nameEach, indexName) {
                            if (vm.rowPathResponse.length) {
                                vm.rowPathResponse.forEach(function (item, indexPath) {
                                    if (nameEach.id == item.id) {
                                        if (
                                            item.value["COORDINATE"]
                                        ) {
                                            item.value["COORDINATE"].forEach(function (cord) {
                                                tempPath.push({ lat: cord.latitude, lng: cord.longitude })
                                            })

                                            var colorCode = nameEach.colorcode;
                                            vm.mapFilterList.push({
                                                name:
                                                    nameEach.name,
                                                path: tempPath,
                                                visible: true,
                                                strokeColor: '<img class="square" style="background-color:' +
                                                    colorCode +
                                                    ';">',
                                                colorCode: colorCode,
                                                type: "Row"
                                            });
                                            tempPath = []
                                        }
                                    }
                                });
                            }
                            vm.mapFilterList.forEach(function(item){
                                var line = new google.maps.Polyline({
                                    path: item.path,
                                    visible: item.visible,
                                    strokeColor: item.colorCode,
                                    strokeOpacity: 1.0,
                                    strokeWeight: 4,
                                    name: item.name,
                                    zIndex:2
                                });

                                google.maps.event.addListener(
                                    line,
                                    "click",
                                    function (event) {
                                       if (openedInfoWindow != null) {
                                        openedInfoWindow.close();
                                    }
                                    infowindow.setContent(
                                        '<div class="infoWindowhead"></br></br>' +
                                            "<b>Name : " +
                                            item.name +
                                            "</b></br>" + "<b>Type : "+ item.type +"</b></br>" +
                                            "</div>"
                                    );
                                    infowindow.open(routeMap.map);
                                    infowindow.setPosition(event.latLng);
                                    openedInfoWindow = infowindow;
                                    }
                                );
                                line.setMap(routeMap.map);
                                rowPolylines.push(line);
                            });
                        });
                        vm.mapFilterList.push({ msGroup: false })
                    }
                }
            );
        }
        $scope.togglePolyline = function () {
            if (vm.selectedTerrainName.length) {
                clearPolyLines()
                vm.selectedTerrainName.forEach(function (each) {
                    for (var i = 0; i < polylines.length; i++) {
                        if (polylines[i].name === each.name) {
                            if (each.visible) {
                                polylines[i].setMap(routeMap.map);
                            }
                        }
                    }
                })
            } else {
                clearPolyLines()
            }
        };


        function clearPolyLines() {
            for (var i = 0; i < polylines.length; i++) {

                polylines[i].setMap(null);

            }
        }

        $scope.type = {
            terrain: {
                search: "Search",
                nothingSelected: "Map Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done"
            },
        };

        function randomColor() {
            return Math.floor(Math.random() * 16777215).toString(16);
        }

        vm.onWorkOrderChange = function(){
            vm.objectTaskStatus = null
            TaskStatusById.post(
                { routeIds: [vm.routeId],
                 workOrderIds:[vm.workOrderId]
                 },
                function (statusresponse) {
                    vm.taskstatus = statusresponse;
                    if(vm.taskstatus.length){
                        callTaskStatusByStagCat()
                    }  
                }
            );
        }

        vm.onProjectChange = function(){
            vm.projectList = vm.storeProjects.find(function(item) { return item.id == vm.projectDetail} );
            if(locations.map!=undefined){
                locations.map.setZoom(4);
                locations.map.setCenter({lat: vm.projectList.latitude, lng: vm.projectList.longitude});
            }

            if(entryMarker){
                entryMarker.setMap(null)
            }
            
            var markerIndicator = new google.maps.Marker({
                icon:  {
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    strokeColor: "#FD7A24",
                    fillColor:'#FD7A24',
                    fillOpacity:1,
                    scale: 4,
                    anchor: new google.maps.Point(1, 1) // Set anchor point to the left
                },
                map: locations.map,
                position: {"lat":vm.projectList.latitude,
                "lng":vm.projectList.longitude},
            });
            entryMarker = markerIndicator
            markerIndicator.setMap(locations.map)

            callProjectDetail(vm.projectList)
         }

         function callProjectDetail(each){
            TrRouteListByProjectId.get(each.id, function (data) {
                vm.routeResponse = data;
                if (vm.routeResponse.length > 0) {
                    vm.routeId = vm.routeResponse[0].id;
                    showRouteDetails();
                    vm.workorderList = [];
                    
                    TaskStatusById.getworkOrderByRoute(
                        vm.routeId,
                        function (response) {
                            vm.workorderList = response;

                            if(vm.workorderList.length > 0){
                                vm.workOrderId = vm.workorderList[0].id;

                                if(vm.workOrderId){
                                    vm.onWorkOrderChange()
                                }
                                
                            }else{
                                TaskStatusById.post(
                                    { routeIds: [vm.routeId] },
                                    function (statusresponse) {
                                        vm.taskstatus = statusresponse;
                                        if(vm.taskstatus.length){
                                            callTaskStatusByStagCat()
                                        } 
                                    }
                                );
                            }
                            
                        },function (err) {
                            vm.workorderList = [];
                            TaskStatusById.post(
                                { routeIds: [vm.routeId] },
                                function (statusresponse) {
                                    vm.taskstatus = statusresponse;
                                    if(vm.taskstatus.length){
                                        callTaskStatusByStagCat()
                                    } 
                                }
                            );
                        }
                    );
                    
                }else{
                    vm.isShowFilter = false
                    //d3.selectAll("#materialChart > *").remove(); 
                    if(vm.storeMaterialTransactionName.length){
                        vm.storeMaterialTransactionName.forEach(function(eachElement){
                            d3.selectAll("#"+ eachElement + " > *").remove();
                        })
                    }
                    d3.selectAll("#RESOURCES > *").remove();
                    vm.resTxSummary.length = 0

                    vm.mtrlTxSummary.length = 0
                    vm.workorderList = [];
                }
            });
            //$scope.$apply();
         }

         function callDrawRoute(){
            vm.mapFilterList.push({
                name:
                    '<strong>' + vm.trRoute.name + '</strong>',
                path: coordinateList,
                visible: true,
                strokeColor: '<img class="square" style="background-color:' +
                    '#FD7A24' +
                    ';">',
                colorCode: '#FD7A24',
                routeDisable: true
            })

            vm.mapFilterList.forEach(function(item){
                if(item.path!=undefined){
                    item.path.forEach(function(path){
                        var pathCordinates = [];
                        if (Array.isArray(path)) {
                            pathCordinates = path;
                        } else {
                            pathCordinates = [];
                            pathCordinates.push(path);
                        }
                        var line = new google.maps.Polyline({
                            path: pathCordinates,
                            visible: item.visible,
                            strokeColor: item.colorCode,
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                            name: item.name,
                            zIndex:1
                        });
        
                        google.maps.event.addListener(
                            line,
                            "click",
                            function (event) {
                               if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }
                            infowindow.setContent(
                                '<div class="infoWindowhead"></br></br>' +
                                    "<b>Name : " +
                                    item.name +
                                    "</b></br>" +  "<b>Type : Route </b></br>" +
                                    "</div>"
                            );
                            infowindow.open(routeMap.map);
                            infowindow.setPosition(event.latLng);
                            openedInfoWindow = infowindow;
                            }
                        );
                        line.setMap(routeMap.map);
                        routePolylines.push(line);
                    });
                }
                
            })
         }

         function callTaskStatusByStagCat(){
            vm.objectTaskStatus = {}
            vm.taskstatus.forEach(function (eachElement){
                if(eachElement.taskCategory == "Route-Task"){
                    createObjMapping(eachElement)
                }else if(eachElement.taskCategory == "Section-Task"){
                    createObjMapping(eachElement)
                }
            })
         }

         function createObjMapping(eachElement){
            if (!vm.objectTaskStatus[eachElement.taskCategory]) {
                vm.objectTaskStatus[eachElement.taskCategory] = {};
            }

            if(!vm.objectTaskStatus[eachElement.taskCategory][eachElement.taskStage]){
                vm.objectTaskStatus[eachElement.taskCategory][eachElement.taskStage] = []
            }

            vm.objectTaskStatus[eachElement.taskCategory][eachElement.taskStage].push({taskTypeName : eachElement.taskTypeName, percentage : eachElement.percentage});  
         }

         function callTransaction(str){

            if(str == "Resource"){
                SummaryPost.resTx({
                    "projectIds": [vm.projectDetail],
                    "routeIds": [vm.routeId]
                }, function (response) {
                    if(response.length){ 
                        vm.resTxSummary = response
                        var data = [];
                        vm.mapResourceTransaction = {};
                        
                        response.forEach(function(item) 
                        {
                            if (!vm.mapResourceTransaction[item.resourceName]) {
                                vm.mapResourceTransaction[item.resourceName] = {
                                    item: item.resourceName,
                                    PLANNED: 0,
                                    REQUESTED: 0,
                                    RECEIVED: 0,
                                    UTILIZED: 0,
                                    RECONCILED: 0
                                };
                                data.push(vm.mapResourceTransaction[item.resourceName]);
                            }
                            vm.mapResourceTransaction[item.resourceName][item.transactionType] += item.totalNoOfResources;
                        });
    
                        d3.selectAll("#RESOURCES > *").remove(); 
                        showDashboardData(data,'RESOURCES')
                    }
                })
            }else if(str == "Material"){
                SummaryPost.mtrlTx(
                    {
                        projectIds: [vm.projectDetail],
                        routeIds: [vm.routeId],
                    },
                    function (response) {
                        vm.mtrlTxSummary = response;

                        if (response.length) {
                            var data = [];
                            var map = {};

                            response.forEach(function (item) {
                                if (!map[item.materialName]) {
                                    map[item.materialName] = {
                                        item: item.materialName,
                                        PLANNED: 0,
                                        REQUESTED: 0,
                                        RECEIVED: 0,
                                        UTILIZED: 0,
                                        RECONCILED: 0,
                                    };
                                    data.push(map[item.materialName]);
                                }
                                map[item.materialName][item.transactionType] +=
                                    item.totalNoOfUnits;
                            });

                            //console.log(data)
                            
                            //d3.selectAll("#materialChart > *").remove();
                            callUOM(data)
                            //showDashboardData(data, "materialChart1"); 
                        }
                    })
            }
                
            }

            function callUOM(data){
                vm.uomMaterialTransaction = {}
                data.forEach(function (item){
                    if(item.UOM != null){
                        if(!vm.uomMaterialTransaction[item.UOM]){
                            vm.uomMaterialTransaction[item.UOM] = []
                        }
                        vm.uomMaterialTransaction[item.UOM].push(item)
                    }
                })
                

                if(vm.uomMaterialTransaction){
                    if(vm.storeMaterialTransactionName.length){
                        vm.storeMaterialTransactionName.forEach(function(eachElement){
                            d3.selectAll("#"+ eachElement + " > *").remove();
                        })
                    }
                    var parentContainer = document.getElementById(
                        "parentMaterial"
                    );
                    var newDiv = document.createElement(
                        "div"
                    );
                    Object.keys(vm.uomMaterialTransaction).forEach(function(key){
                        vm.storeMaterialTransactionName.push(key)
                        newDiv.id = key
                        parentContainer.appendChild(newDiv);
                        showDashboardData(
                            vm.uomMaterialTransaction[key],
                            key
                        );
                    })
                }
            }
            
         
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('dashboard', {
            parent: 'app',
            url: '/dashboard',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/dashboard.html',
                    controller: 'DashboardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]

            }
        })
        .state('dashboard-rollout', {
            parent: 'app',
            url: '/dashboard-rollout',
            data: {
                authorities: ['PROJECT_SIDEBAR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/dashboard-rollout.html',
                    controller: 'DashboardRolloutController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]

            }
        })
         .state('incident-dashboard', {
            parent: 'app',
            url: '/incident-dashboard',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER','ROLE_READONLY']
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/incident.html',
                    controller: 'IncidentDashboardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]

            }
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('DashboardService', DashboardService);

    DashboardService.$inject = ['$http', 'DateUtils'];

    function DashboardService($http, DateUtils) {
        var service = {};

        service.loaddata = function (callback) {

            $http.get('api/dashboard/dashboarddata').then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('DashboardServiceGeo', DashboardServiceGeo);

    DashboardServiceGeo.$inject = ['$resource'];

    function DashboardServiceGeo($resource) {
        var service = $resource('/api/dashboard/dashboarddata/:geofenceId', {
            // searchvalue : '@id'
        }, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CaseCountByPriority', CaseCountByPriority);

    CaseCountByPriority.$inject = ['$http'];

    function CaseCountByPriority($http) {
        var service = {};

        service.get = function (callback) {
            $http.get('api/dashboard/case-count-by-priority').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('CaseCountByPriorityGeo', CaseCountByPriorityGeo);

    CaseCountByPriorityGeo.$inject = ['$resource'];

    function CaseCountByPriorityGeo($resource) {
        var service = $resource('/api/dashboard/case-count-by-priority/:geofenceId', {
            // searchvalue : '@id'
        }, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CaseCountByStatus', CaseCountByStatus);

    CaseCountByStatus.$inject = ['$http'];

    function CaseCountByStatus($http) {
        var service = {};

        service.get = function (callback) {
            $http.get('api/dashboard/case-count-by-status').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('CaseCountByStatusGeo', CaseCountByStatusGeo);

    CaseCountByStatusGeo.$inject = ['$resource'];

    function CaseCountByStatusGeo($resource) {
        var service = $resource('/api/dashboard/case-count-by-status/:geofenceId', {
            // searchvalue : '@id'
        }, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('UserListAndDistanceGeo', UserListAndDistanceGeo);

    UserListAndDistanceGeo.$inject = ['$resource'];

    function UserListAndDistanceGeo($resource) {
        var service = $resource('api/dashboard/userlist/:geofenceId', { geofenceId: '@geofenceId' }, {}, {
            'query': { method: 'GET', isArray: true },
        });

        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LinkService', LinkService);

    LinkService.$inject = ['$http', 'DateUtils'];

    function LinkService($http, DateUtils) {
        var service = {};

        service.loaddata = function (callback) {

            $http.get('api/dashboard/dashboardlinkdata').then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('UserListAndDistance', UserListAndDistance);

    UserListAndDistance.$inject = ['$resource'];

    function UserListAndDistance($resource) {
        var service = $resource('api/dashboard/userlist', {}, {
            'query': { method: 'GET', isArray: true },
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('UserListAndDistanceSearch', UserListAndDistanceSearch);

    UserListAndDistanceSearch.$inject = ['$resource'];

    function UserListAndDistanceSearch($resource) {
        var service = $resource('api/dashboard/userlist/:login', { login: '@login' }, {}, {
            'query': { method: 'GET', isArray: true },
        });

        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('TaskStatusById', TaskStatusById);

    TaskStatusById.$inject = ['$http'];

    function TaskStatusById($http) {
        var service = {};

        service.post = function (payload, callback) {
            $http.post('api/rollout/task-status', payload).then(function (response) {
                callback(response.data);
            });
        };

        service.getworkOrderByRoute = function (id, callback) {
            $http.get('api/tr-workorders/route/' + id).then(function (response) {
                callback(response.data);
            }, function (err) {
                callback(err);
            });
        };


        return service;
    }
})();

//dashboard rollout temp services
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('WorkOrderStats', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (name, callback) {
            $http.get('api/workorderstats/' + name).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('WorkFlowListByWorkOrderID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/workorderworkflows/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetsByWorkFlowID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/assetsbywf/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('getIncidentData', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        // http://127.0.0.1:8080/api/dashboard/packages
        service.getPackages = function (callback) {
            $http.get('api/dashboard/packages').then(function (response) {
                callback(response);
            });
        };
        // http://127.0.0.1:8080/api/dashboard//statesBypackges/PKG-4
        service.getStatesByPackage = function (packageId, callback) {
            $http.get('api/dashboard/statesBypackges/' + packageId).then(function (response) {
                callback(response);
            });
        };
        // this gives list of business areas /api/dashboard/business-area/KARNATAKA/PKG-4
        service.getBusinessArea = function (stateId,packageId, callback) {
            $http.get('api/dashboard/business-area/' + stateId + '/' + packageId).then(function (response) {
                callback(response);
            });
        };
        // this gives list of operational areas by business area id
        service.getOperationalArea = function (id, callback) {
            $http.get('api/dashboard/oaNamesByBaId/' + id).then(function (response) {
                callback(response);
            });
        };
        // this gives list of districts by operational area id
        service.getDistrict = function (opId, callback) {
            $http.get('api/master-geofenceByOaId/' + opId).then(function (response) {
                callback(response);
            });
        };
        // this gives list of blocks by master geofence id
        service.getBlocks = function (dId, callback) {
            $http.get('api/mini-geofences-by-masterGefenceId/' + dId).then(function (response) {
                callback(response);
            });
        };

        service.getGeofenceIncidents = function (fromDate, toDate, opId, baId, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-data/' + opId + '/' + fromDate + '/' + toDate + '/' + baId + '/' + amcValue).then(function (response) {
                callback(response);
            });
        };
        service.getIncidents = function (baId, fromDate, toDate, oaId, amcStatus, callback) {
            var oaValue = oaId ? oaId : "";
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-data/' + baId + '/' + fromDate + '/' + toDate + '/' + oaValue + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // case-count-by-priority-incidents-package-data/PKG-4/1735669800000/1765784646301
        service.getIncidentsbyPackage = function (fromDate, toDate, packageId, amcStatus, callback) {
            var pkgValue = packageId ? packageId : "";
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-package-data/' + pkgValue + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // case-count-by-priority-incidents-package-data/PKG-4/KARNATAKA/1735669800000/1765784646301
        service.getIncidentsbyPackageAndState = function (packageId, stateId, fromDate, toDate, amcStatus, callback) {
            var pkgValue = packageId ? packageId : "";
            var stateValue = stateId ? stateId : "";
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-package-data/' + pkgValue + '/' + stateValue + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        service.getStatus = function (baId, fromDate, toDate, oaId, amcStatus, type, callback) {
            if (typeof type === 'function') {
                callback = type;
                type = null;
            }
            var oaValue = oaId ? oaId : "";
            var amcValue = amcStatus ? amcStatus : "";
            var typeValue = type ? type : (oaValue ? 'OA' : 'BA');
            $http.get('api/dashboard/case-count-by-status-incidents-data/' + baId + '/' + fromDate + '/' + toDate + '/' + oaValue + '/' + amcValue + '?type=' + typeValue)
                .then(function (response) {
                    callback(response);
                });

        };
        service.getGeofenceIncidents = function (baId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-data/' + baId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });

        };
        service.getGeofenceIncident = function (baId, fromDate, toDate, amcStatus, type, callback) {
            if (typeof type === 'function') {
                callback = type;
                type = null;
            }
            var amcValue = amcStatus ? amcStatus : "";
            var typeValue = type ? type : 'BA';
            $http.get('api/dashboard/case-count-by-status-incidents-data/' + baId + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + typeValue)
                .then(function (response) {
                    callback(response);
                });
        };
        service.getIncidentsData = function (dId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority/' + dId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };

        service.getStatusData = function (dId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-status/' + dId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };

        // /case-count-by-status-incidents-package-data/{pckg}/{startTime}/{endTime}
        service.getStatusbyPackage = function (fromDate, toDate, packageId, amcStatus, type, callback) {
            if (typeof type === 'function') {
                callback = type;
                type = null;
            }
            var pkgValue = packageId ? packageId : "";
            var amcValue = amcStatus ? amcStatus : "";
            var typeValue = type ? type : 'PACKAGE';
            var url = 'api/dashboard/case-count-by-status-incidents-package-data/' + pkgValue + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + typeValue;
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getStatusbyPackage error:', error);
                });
        };

        service.getStatusbyPackageAndState = function (packageId, stateId, fromDate, toDate, amcStatus, type, callback) {
            if (typeof type === 'function') {
                callback = type;
                type = null;
            }
            var pkgValue = packageId ? packageId : "";
            var stateValue = stateId ? stateId : "";
            var amcValue = amcStatus ? amcStatus : "";
            var typeValue = type ? type : (stateValue ? 'STATE' : 'PACKAGE');
            var url = 'api/dashboard/case-count-by-status-incidents-package-data/' + pkgValue + '/' + stateValue + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + typeValue;
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getStatusbyPackageAndState error:', error);
                });
        };

        service.getIncidentsDataBlock = function (bId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-MiniGeoId/' + bId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };

        service.getStatusDataBlock = function (bId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-status-miniGeoId/' + bId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // api/dashboard/case-count-by-priority-gp/{GPID}/{fromDate}/{toDate}
        service.getIncidentsDataGP = function (gpId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-gp/' + gpId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // /api/dashboard/case-count-by-status-gp/19463297/1763145000000/1766387318763
        service.getStatusDataGP = function (gpId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-status-gp/' + gpId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // sla-status-case-count-package-state/PKG-4/KARNATAKA/1704047400000/1765784646301?type=PACKAGE
        // or sla-status-case-count-package-state/PKG-4/1704047400000/1765784646301?type=PACKAGE (without state)
        service.getSLAStatusDataByPackageAndState = function (packageId, stateId, type, fromDate, toDate, amcStatus, callback) {
            var pkgValue = packageId ? packageId : '';
            var stateValue = stateId ? stateId : '';
            var amcValue = amcStatus ? amcStatus : '';
            
            // Build URL - include state in path if provided
            var url;
            if (stateValue) {
                url = 'api/dashboard/sla-status-case-count-package-state/'  + stateValue + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + type;
            } else {
                url = 'api/dashboard/sla-status-case-count-package-state/' + pkgValue + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + type;
            }
            
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getSLAStatusDataByPackageAndState API error:', error);
                    callback(null);
                });
        };

        // http://127.0.0.1:8080/api/dashboard/sla-status-case-count/1211202501?type=BA
        service.getSLAStatusData = function (id, type, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            var url = 'api/dashboard/sla-status-case-count/' + id + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + type;

            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getSLAStatusData API error:', error);
                    callback(null);
                });
        };
        // dashboard/roleCountsByAuthority/KARNATAKA?type=STATE
        service.getRoleCountsByAuthority = function (name, type, callback) {
            var url = 'api/dashboard/roleCountsByAuthority/' + name + '?type=' + type;
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getRoleCountsByAuthority API error:', error);
                    callback(null);
                });
        };

        // /api/dashboard/gpTotalCount/22667329/1763145000000/1766387318763
        service.getGPTotalCount = function (id, type, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : '';
            var url = 'api/dashboard/gpTotalCount/' + id + '/' + amcValue + '?type=' + type + '&assetType=GP';
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getGPTotalCount API error:', error);
                    callback(null);
                });
        };

        // POST request to get GP data by Block ID
        service.getGPByBlock = function (blockId, callback) {
            var payload = {
                lastAssetId: null,
                geofences: [Number(blockId)],
                assetTypes: ["GP", "ONT"]
            };
            var url = 'api/assets-group-by-geofences-db?';
            $http.post(url, payload)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getGPByBlock API error:', error);
                    callback(null);
                });
        };
        // /api/dashboard/gpListByBlock/19781977 
        // this is there to get GP List by Block ID
        service.getGPListByBlock = function (blockId, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            var url = 'api/dashboard/gpListByBlock/' + blockId + '/' + amcValue;
            $http.get(url)
                .then(function (response) { 
                    callback(response);
                }, function (error) {
                    console.error('getGPListByBlock API error:', error);
                    callback(null);
                });
        };
        // http://127.0.0.1:8080/api/dashboard/day-wise-incidentCouts/22667329/1735669800000/1765784646301?type=MINI
        service.getDayWiseIncidentCounts = function (id, fromDate, toDate, type, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : '';
            var url = 'api/dashboard/day-wise-incidentCouts/' + id + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + type;
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getDayWiseIncidentCounts API error:', error);
                    callback(null);
                });
        };
        return service;
    }]);
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("DashboardController", HomeController);

    HomeController.$inject = [
        "$scope",
        "GeoAssetTypeReport",
        "AlertService",
        "ParseLinks",
        "$state",
        "pagingParams",
        "paginationConstants",
        "DashboardServiceGeo",
        "CaseCountByPriority",
        "CaseCountByStatus",
        "$filter",
        "UserListAndDistanceGeo",
        "UserListAndDistanceSearch",
        "$interval",
        "UserMasterGeofences",
        "CaseCountByPriorityGeo",
        "CaseCountByStatusGeo"
    ];

    function HomeController(
        $scope,
        GeoAssetTypeReport,
        AlertService,
        ParseLinks,
        $state,
        pagingParams,
        paginationConstants,
        DashboardServiceGeo,
        CaseCountByPriority,
        CaseCountByStatus,
        $filter,
        UserListAndDistanceGeo,
        UserListAndDistanceSearch,
        $interval,
        UserMasterGeofences,
        CaseCountByPriorityGeo,
        CaseCountByStatusGeo
    ) {
        var vm = this;

        // vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        // vm.transition = transition;
        //vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPage = 4;
        vm.userslist = [];
        vm.filterSearch = filterSearch;
        vm.loaddata = loaddata;

        vm.userMasterGeofences = [];
        vm.selectCityFilter= false;
        vm.currYear = new Date().getFullYear();
        vm.isGeofences = false
        var tempWidth, tempHeight

        loaddata();

        var updateDashboard = $interval(function () {
            // loaddata();
            var date = new Date();

            var weekday = new Array(7);
            weekday[0] = "Sunday";
            weekday[1] = "Monday";
            weekday[2] = "Tuesday";
            weekday[3] = "Wednesday";
            weekday[4] = "Thursday";
            weekday[5] = "Friday";
            weekday[6] = "Saturday";
            vm.day = weekday[date.getDay()];

            var month = new Array();
            month[0] = "January";
            month[1] = "February";
            month[2] = "March";
            month[3] = "April";
            month[4] = "May";
            month[5] = "June";
            month[6] = "July";
            month[7] = "August";
            month[8] = "September";
            month[9] = "October";
            month[10] = "November";
            month[11] = "December";
            vm.month = month[date.getMonth()];
            vm.todayDate = date.getDate();
            vm.year = date.getFullYear();
            var dateFormat = "hh:mm a";
            vm.time = $filter("date")(formatAMPM(date), dateFormat);
        }, 10000);
        $scope.$on("$destroy", function () {
            $interval.cancel(updateDashboard);
        });

        var date = new Date();

        var weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";
        vm.day = weekday[date.getDay()];

        var month = new Array();
        month[0] = "January";
        month[1] = "February";
        month[2] = "March";
        month[3] = "April";
        month[4] = "May";
        month[5] = "June";
        month[6] = "July";
        month[7] = "August";
        month[8] = "September";
        month[9] = "October";
        month[10] = "November";
        month[11] = "December";
        vm.month = month[date.getMonth()];
        vm.todayDate = date.getDate();
        vm.year = date.getFullYear();
        var dateFormat = "hh:mm a";
        vm.time = $filter("date")(formatAMPM(date), dateFormat);

        $scope.setOrderProperty = function (propertyName) {
            if ($scope.orderProperty === propertyName) {
                $scope.orderProperty = "-" + propertyName;
            } else if ($scope.orderProperty === "-" + propertyName) {
                $scope.orderProperty = propertyName;
            } else {
                $scope.orderProperty = propertyName;
            }
        };

        function loaddata() {
            var geoResult = [];
            var geoGrouped = {};
            var assetTypeResult = [];
            var assetTypeGrouped = {};
            var geofences = [];
            var geoAssetTypeAssetsList = [];

            
            // CaseCountByPriority.get(function (data) {
            //     vm.casepriority = data.casePriority;
            // });

            vm.userMasterGeofences = [];
            UserMasterGeofences.getAll(function (response) {
                if(response.length>0){
                    vm.masterGeofence = "";   
                    // vm.masterGeofence = response[0].id+"";   
                }
                vm.userMasterGeofences = response;
                CaseCountByPriorityGeo.get(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessCasePriorityGeo,
                    onErrorCasePriorityGeo
                );
                function onSuccessCasePriorityGeo(data, headers) {
                    vm.casepriority = data.casePriority;
                }

                function onErrorCasePriorityGeo(error) {
                    AlertService.error(error.data.message);
                }

                UserListAndDistanceGeo.query(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessUserListGeo,
                    onErrorUserListGeo
                );
                function onSuccessUserListGeo(data, headers) {
                    vm.userslist = data;
                }
    
                function onErrorUserListGeo(error) {
                    AlertService.error(error.data.message);
                }
                
                DashboardServiceGeo.get(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessUserDashboardDataGeo,
                    onErrorUserDashboardDataGeo
                );
                function onSuccessUserDashboardDataGeo(data, headers) {
                    showDashboardData(data);
                }
    
                function onErrorUserDashboardDataGeo(error) {
                    AlertService.error(error.data.message);
                }
                
                CaseCountByStatusGeo.get(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessCaseStatusGeo,
                    onErrorCaseStatusGeo
                );
                function onSuccessCaseStatusGeo(data, headers) {
                    showCaseStatus(data);
                }

                function onErrorCaseStatusGeo(error) {
                    AlertService.error(error.data.message);
                }
            });
        }

        function showCaseStatus(data){
            
            var svgtemp = d3.select("#case-chart");
            svgtemp.selectAll("*").remove();

            var dataset = [
                { label: "New", count: data.caseType.NEW },
                { label: "In Progress", count: data.caseType.INPROGRESS },
                { label: "Pending", count: data.caseType.PENDING },
				{ label: "To Be Assigned", count: data.caseType.TOBEASSIGNED },
                { label: "Assigned", count: data.caseType.ASSIGNED },
                { label: "Resolved", count: data.caseType.RESOLVED },
                { label: "Cancelled", count: data.caseType.CANCELLED },
                { label: "Closed", count: data.caseType.CLOSED },
            ];

            var width = 240;
            var height = 300;

            try {
                width = document.getElementById("case-chart").offsetWidth;
                height = document.getElementById("case-chart").offsetHeight;
            } catch (error) {
                // console.log(error);
            }

            // var radius = Math.min(width, height) / 2;
            // var donutWidth = 40;

            var radius = Math.min(width, height) / 1.8;
            var legendRectSize = 12;
            var legendSpacing = 3;

            var color = d3.scale
                .ordinal()
                .range([
                    "#FD7A24",
                    "#82eedd",
                    "#C6418F",
                    "#00e658",
                    "#ee8293",
                    "#bbc641",
                ]);

            var svg = d3
                .select("#case-chart")
                .append("svg")
                .attr("width", width)
                .attr("height", height)
                .append("g")
                .attr("shape-rendering", "geometricPrecision")
                .attr(
                    "transform",
                    "translate(" + width / 2 + "," + height / 2 + ")"
                );
                

            var arc = d3.svg
                .arc()
                .innerRadius(radius - 70)
                .outerRadius(radius - 30);

            var pie = d3.layout
                .pie()
                .value(function (d) {
                    return d.count;
                })
                .sort(null);

            dataset.forEach(function (d) {
                d.count = +d.count;
                d.enabled = true;
            });

            var path = svg
                .selectAll("path")
                .data(pie(dataset))
                .enter()
                .append("path")
                .attr("d", arc)
                .attr("fill", function (d, i) {
                    return color(d.data.label + " - " + d.data.count);
                })
                .each(function (d) {
                    this._current = d;
                });

            var tooltip2 = d3
                .select("body")
                .append("div")
                .attr("class", "toolTipA");

            path.on("mouseover", function (d) {
                tooltip2
                    .style("left", d3.event.pageX - 50 + "px")
                    .style("top", d3.event.pageY - 50 + "px")
                    .style("display", "inline-block")
                    .style("fill", "black")
                    .html(d.data.label + "<br>" + d.value);
                return tooltip2.style("visibility", "visible");
            })
                .on("mousemove", function () {
                    return tooltip2
                        .style("top", d3.event.pageY - 10 + "px")
                        .style("left", d3.event.pageX + 10 + "px");
                })
                .on("mouseout", function () {
                    return tooltip2.style("visibility", "hidden");
                });

            var legend = svg
                .selectAll(".legend")
                .data(color.domain())
                .enter()
                .append("g")
                .attr("class", "legend")
                .attr("transform", function (d, i) {
                    var height = legendRectSize + legendSpacing;
                    var offset = (height * color.domain().length) / 2;
                    var horz = -4.5 * legendRectSize;
                    var vert = i * height - offset;
                    return "translate(" + horz + "," + vert + ")";
                });

            legend
                .append("rect")
                .attr("width", legendRectSize)
                .attr("height", legendRectSize)
                .style("fill", color)
                .style("stroke", color)
                .on("click", function (label) {
                    var rect = d3.select(this);
                    var enabled = true;
                    var totalEnabled = d3.sum(
                        dataset.map(function (d) {
                            return d.enabled ? 1 : 0;
                        })
                    );

                    if (rect.attr("class") === "disabled") {
                        rect.attr("class", "");
                    } else {
                        if (totalEnabled < 2) return;
                        rect.attr("class", "disabled");
                        enabled = false;
                    }

                    pie.value(function (d) {
                        if (d.label === label) d.enabled = enabled;
                        return d.enabled ? d.count : 0;
                    });

                    path = path.data(pie(dataset));

                    path.transition()
                        .duration(750)
                        .attrTween("d", function (d) {
                            var interpolate = d3.interpolate(
                                this._current,
                                d
                            );
                            this._current = interpolate(0);
                            return function (t) {
                                return arc(interpolate(t));
                            };
                        });
                });

            legend
                .append("text")
                .attr("x", legendRectSize + legendSpacing)
                .attr("y", legendRectSize - legendSpacing)
                .style("font-family", "sans-serif")
                .style("font-size", "12px")
                .text(function (d) {
                    return d;
                });
        }

        function showDashboardData(data){
            vm.users = data.users;
            vm.isGeofences = data.geofences.length == 0
            var svgtempstatus = d3.select("#status");
                svgtempstatus.selectAll("*").remove();
            var svgtemp = d3.select("#stacked-chart-status");
                svgtemp.selectAll("*").remove();
            

            // geofence bar graph
            var margin2 = { top: 30, right: 10, bottom: 85, left: 30 };

            var width2 = 960;
            var height2 = 300 - margin2.top - margin2.bottom;

            try {
                width2 =
                    document.getElementById("stacked-chart-status")
                        .offsetWidth -
                    margin2.left -
                    margin2.right;

                
                height2 =
                    document.getElementById("stacked-chart-status")
                        .offsetHeight -
                    margin2.top -
                    margin2.bottom; 

                    if (width2 < 0 || height2 < 0) {
                        width2 = tempWidth;
                        height2 = tempHeight;
                    }
            } catch (error) {
                // console.log(error);
            }
            tempWidth = width2
            tempHeight = height2
            var svg = d3
                .select("#stacked-chart-status")
                .append("svg")
                .attr("width", width2 + margin2.left + margin2.right)
                .attr("height", height2 + margin2.top + margin2.bottom)
                .append("g")
                .attr(
                    "transform",
                    "translate(" + margin2.left + "," + margin2.top + ")"
                )
                .attr("shape-rendering", "geometricPrecision");
            // /* Data in strings like it would be if imported from a csv */

            var cases = data.geofences.map(function (d) {
                return {
                    x:
                        d.label.slice(0, 15) +
                        (d.label.length > 15 ? "..." : ""),
                    y: +d.caseStatusCountDto.critical_priority,
                    x1: d.label,
                };
            });
            // Transpose the data into layers
            //actual data
            var dataset = d3.layout.stack()(
                ["active", "idle", "inactive"].map(function (fruit) {
                    var groupData = data.geofences.slice(0, 40);
                    return groupData.map(function (d) {
                        return {
                            x:
                                d.label.slice(0, 15) +
                                (d.label.length > 15 ? "..." : ""),
                            y: +d.userStatusCount[fruit],
                            x1: d.label,
                        };
                    });
                    // }
                })
            );

            // Set x, y and colors
            var x = d3.scale
                .ordinal()
                .domain(
                    dataset[0].map(function (d) {
                        return d.x;
                    })
                )
                .rangeRoundBands([10, width2 - 50], 0.5);

            var countUsers = d3.max(dataset, function (d) {
                return d3.max(d, function (d) {
                    return d.y0 + d.y;
                });
            })

            if(countUsers >=1){
                var y = d3.scale
                .linear()
                .domain([
                    0,
                    d3.max(dataset, function (d) {
                        return d3.max(d, function (d) {
                            return d.y0 + d.y;
                        });
                    }),
                ])
                .range([height2, 0]);
            }else {
                var y = d3.scale
                .linear()
                .domain([
                    0,
                    d3.max(cases, function (d) {
                            return  d.y;
                    }),
                ])
                .range([height2, 0]);
            }
            
            var colors = ["#00e658", "#FD7A24", "#afafaf"];

            // Define and draw axes
            var yAxis = d3.svg
                .axis()
                .scale(y)
                .orient("left")
                .ticks(5)
                .tickSize(-width2, 0, 0)
                .tickFormat(function (d) { if((d % 1 == 0)){
                    return d
                }});

            var xAxis = d3.svg.axis().scale(x).orient("bottom");
            // .tickFormat(d3.time.format("%y"));

            svg.append("g").attr("class", "y axis").call(yAxis);

            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height2 + ")")
                .call(xAxis)
                .selectAll("text")
                .style("text-anchor", "end")
                .style("font-family", "sans-serif")
                .style("font-size", "11px")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", "rotate(-45)");

            // Create groups for each series, rects for each segment
            var groups = svg
                .selectAll("g.cost")
                .data(dataset)
                .enter()
                .append("g")
                .attr("class", "cost")
                .style("fill", function (d, i) {
                    return colors[i];
                });

            var rect = groups
                .selectAll("rect")
                .data(function (d) {
                    return d;
                })
                .enter()
                .append("rect")
                .attr("x", function (d) {
                    return x(d.x) + x.rangeBand() / 2;
                })
                .attr("y", function (d) {
                    return y(d.y0 + d.y);
                })
                .attr("height", function (d) {
                    return y(d.y0) - y(d.y0 + d.y);
                })
                .attr("width", x.rangeBand() / 2);

            var caseBar = svg.selectAll(".bar1")
                .data(cases)
                .enter()
                .append("g")
                .attr("class", "bar1")
                .append("rect")
                .attr("x", function (d) {
                    return x(d.x); // center it
                })
                .attr("width", x.rangeBand() / 2) // make it slimmer
                .attr("y", function (d) {
                    return y(d.y);
                })
                .attr("height", function (d) {
                    return height2 - y(d.y);
                });
            // Draw legend
            var svg1 = d3
                .select("#status")
                .append("svg")
                .attr("width", width2 + margin2.left + margin2.right)
                .attr("height", 15)
                .append("g")
                .attr("transform", "translate(" + (margin2.right - 25) + "," + -220 + ")")
                .attr("shape-rendering", "geometricPrecision");

            var legend = svg1
                .selectAll(".legend")
                .data(colors)
                .enter()
                .append("g")
                .attr("class", "legend")
                .attr("width", 15)
                .attr("height", 15)
                .attr("transform", function (d, i) {
                    if(i==2){
                        return "translate(" + ((i * 80)-18) + ",30)";
                    }else{
                        return "translate(" + i * 80 + ",30)";
                    }
                })
                // .on("click", function(d) {

                // });
                .on("click", function (d, i) {
                    if (i == 1) {
                        if (
                            d3
                                .select(this)
                                .style("fill" == "#FD7A24")
                                .style("opacity") == 1
                        ) {
                            d3.selectAll(".cost:nth-child(4)").style(
                                "opacity",
                                0
                            );
                            d3.select(this)
                                .style("fill", "#FD7A24")
                                .style("opacity", "0.5");
                        } else {
                            d3.selectAll(".cost:nth-child(4)").style(
                                "opacity",
                                9
                            );
                            d3.select(this)
                                .style("fill", "#FD7A24")
                                .style("opacity", 9);
                        }
                    }
                    if (i == 2) {
                        if (
                            d3
                                .select(this)
                                .style("fill" == "#afafaf")
                                .style("opacity") == 1
                        ) {
                            d3.selectAll(".cost:nth-child(5)").style(
                                "opacity",
                                0
                            );
                            d3.select(this)
                                .style("fill", "#afafaf")
                                .style("opacity", "0.5");
                        } else {
                            d3.selectAll(".cost:nth-child(5)").style(
                                "opacity",
                                9
                            );
                            d3.select(this)
                                .style("fill", "#afafaf")
                                .style("opacity", 9);
                        }
                    }
                    if (i == 0) {
                        if (
                            d3
                                .select(this)
                                .style("fill" == "#00e658")
                                .style("opacity") == 1
                        ) {
                            d3.selectAll(".cost:nth-child(3)").style(
                                "opacity",
                                0
                            );
                            d3.select(this)
                                .style("fill", "#00e658")
                                .style("opacity", "0.5");
                        } else {
                            d3.selectAll(".cost:nth-child(3)").style(
                                "opacity",
                                9
                            );
                            d3.select(this)
                                .style("fill", "#00e658")
                                .style("opacity", 9);
                        }
                    }
                });
            // .attr("transform", function(d,i) {
            // 	return "translate(" + width2 + "," + i * height2 + ")"; })

            legend
                .append("circle")
                .attr("cx", width2 / 2 - 96)
                .attr("cy", height2 + 67)
                .attr("r", 6)
                .style("fill", function (d, i) {
                    return colors[i];
                });

            legend
                .append("text")
                .attr("x", width2 / 2 - 85)
                .attr("y", height2 + 67)
                .attr("dy", ".35em")
                .style("text-anchor", "start")
                .style("font-family", "sans-serif")
                .style("font-size", "12px")
                .style("font-weight", "700")
                .style("cursor", "pointer")
                .text(function (d, i) {
                    switch (i) {
                        case 0:
                            return "ACTIVE";
                        case 1:
                            return "IDLE";
                        case 2:
                            return "INACTIVE";
                    }
                });

            var tooltip1 = d3
                .select("body")
                .append("div")
                .attr("class", "toolTipA");

            rect.on("mouseover", function (d) {
                tooltip1
                    .style("left", d3.event.pageX - 50 + "px")
                    .style("top", d3.event.pageY - 50 + "px")
                    .style("display", "inline-block")
                    .style("fill", "black")
                    .html(d.x1 + "<br>" + d.y);
                return tooltip1.style("visibility", "visible");
            })
                .on("mousemove", function () {
                    return tooltip1
                        .style("top", d3.event.pageY - 10 + "px")
                        .style("left", d3.event.pageX + 10 + "px");
                })
                .on("mouseout", function () {
                    return tooltip1.style("visibility", "hidden");
                });
                
            caseBar.on("mouseover", function (d) {
                tooltip1
                    .style("left", d3.event.pageX - 50 + "px")
                    .style("top", d3.event.pageY - 50 + "px")
                    .style("display", "inline-block")
                    .style("fill", "black")
                    .html("Critical Incident Count" + "<br>" + d.y);
                return tooltip1.style("visibility", "visible");
            })
                .on("mousemove", function () {
                    return tooltip1
                        .style("top", d3.event.pageY - 10 + "px")
                        .style("left", d3.event.pageX + 10 + "px");
                })
                .on("mouseout", function () {
                    return tooltip1.style("visibility", "hidden");
                });
        }

        function formatAMPM(date) {
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? "PM" : "AM";
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? "0" + minutes : minutes;
            var strTime = hours + ":" + minutes + " " + ampm;
            return strTime;
        }

        function filterSearch() {
            if (
                vm.search != null &&
                vm.search != "" &&
                !angular.isUndefined(vm.search)
            ) {
                UserListAndDistanceSearch.query({}, onSuccess, onError);
            } else {
                UserListAndDistanceGeo.query(
                    {
                        geofenceId: vm.masterGeofence
                    },
                    onSuccessUserListGeo,
                    onErrorUserListGeo
                );
                function onSuccessUserListGeo(data, headers) {
                    vm.userslist = data;
                }
    
                function onErrorUserListGeo(error) {
                    AlertService.error(error.data.message);
                }
            }
        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                result.push("id");
            }
            return result;
        }

        function onSuccess(data, headers) {
            // vm.links = ParseLinks.parse(headers('link'));
            // vm.totalItems = headers('X-Total-Count');
            // vm.queryCount = vm.totalItems;
            vm.userslist = data;
            // vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        // $('#masterGeofence').on('change', function() {
        $scope.optionChange = function(){
            vm.masterGeofence = document.getElementById("masterGeofence").value;  
            CaseCountByPriorityGeo.get(
                {
                    geofenceId: vm.masterGeofence
                },
                onSuccessCasePriorityGeo,
                onErrorCasePriorityGeo
            );
            function onSuccessCasePriorityGeo(data, headers) {
                vm.casepriority = data.casePriority;
            }

            function onErrorCasePriorityGeo(error) {
                AlertService.error(error.data.message);
            }

            UserListAndDistanceGeo.query(
                {
                    geofenceId: vm.masterGeofence
                },
                onSuccessUserListGeo,
                onErrorUserListGeo
            );
            function onSuccessUserListGeo(data, headers) {
                vm.userslist = data;
            }

            function onErrorUserListGeo(error) {
                AlertService.error(error.data.message);
            }
            
            DashboardServiceGeo.get(
                {
                    geofenceId: vm.masterGeofence
                },
                onSuccessUserDashboardDataGeo,
                onErrorUserDashboardDataGeo
            );
            function onSuccessUserDashboardDataGeo(data, headers) {
                showDashboardData(data);
            }

            function onErrorUserDashboardDataGeo(error) {
                AlertService.error(error.data.message);
            }

            CaseCountByStatusGeo.get(
                {
                    geofenceId: vm.masterGeofence
                },
                onSuccessCaseStatusGeo,
                onErrorCaseStatusGeo
            );
            function onSuccessCaseStatusGeo(data, headers) {
                showCaseStatus(data);
            }

            function onErrorCaseStatusGeo(error) {
                AlertService.error(error.data.message);
            }
        }

        // function loadPage(page) {
        //     vm.page = page;
        //     vm.transition();
        // }

        // function transition() {
        //     $state.transitionTo($state.$current, {
        //         page: vm.page,
        //         sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        //         search: vm.currentSearch
        //     });
        // }
    }
})();

/* (function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('viewContent', function () {
            return {
              restrict: 'E', // E for element
              transclude: true, // Transclude the content of the directive
              template: 
              `
              <div class="content">
              <div class="row">
                  <div class="col-md-12">
                    <div class="box box-solid" ng-transclude>


                      </div>
                    </div>
                </div>
            </div>`
              
            };
          });
})(); */


/* SHOW/HIDE(NG-IF) COMPONENT
(function() {
    'use strict';

          angular.module('trakeyeApp').directive('configShow',['Configs','$rootScope', function (Configs,$rootScope) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var featureKey = attrs.configShow;
                    
                   if($rootScope.storeTemp){
                    var response = $rootScope.storeTemp
                    var configVisible = false;
        
                        if (response && response.length) {
                            response.forEach(function (value) {
                                if (value.configKey === featureKey) {
                                    configVisible = value.configValue === 'TRUE';
                                }
                            });
                        }
        
                        if (!configVisible) {
                            element.addClass('ng-hide'); // Add ng-hide class to hide the element
                        }
                   }
                   
                }
            };
        }]);
        
})();  */
angular.module('trakeyeApp').directive('tablePagination', [function () {
    return {
      restrict: 'E',
      scope: {
        obj:'=',
      },
      templateUrl: 'app/components/View/tablePagination.html',
      link: function (scope) {

        scope.page = 1
        scope.predicate = 'modified_date'
        scope.itemsPerPage = 10
        
        
        loadAll()
      function loadAll() {
        Geofence.query({
            page: scope.page,
            size: scope.itemsPerPage,
            sort: sort()
        }, onSuccess, onError);

        function sort() {
            var result = [scope.predicate + ',' + (scope.reverse ? 'asc' : 'desc')];
            return result;
        }

        function onSuccess(data, headers) {
            scope.links = ParseLinks.parse(headers('link'));
            scope.totalItems = headers('X-Total-Count');
            scope.queryCount = scope.totalItems;
            scope.resourceTxListView = []
            data.forEach(function (value) {
              scope.resourceTxListView.push(value);
            });
            //vm.page = pagingParams.page;
        }

        function onError(error) {
            console.log(error)
        }
        }

        scope.transition = function(){
            loadAll()
        }
  
      }
      
    };
  }]);
  
angular.module('trakeyeApp').directive('routeImage', ['$localStorage', 'imageRoutePoint', 'routeDetail', 'RouteImageMeta', 'FileUploadService', function ($localStorage, imageRoutePoint, routeDetail, RouteImageMeta, FileUploadService) {
    return {
        restrict: 'E',
        scope: {
            obj: '='
        },
        templateUrl: 'app/components/View/routeImage.html',
        link: function (scope) {

            var markerImage, iconImg
            var routeMarkers = []
            var iconSize = 20
            var iconMarker = "content/images/sm_marker_transparent.png"
            var iconImage = "content/images/routePointImage.png"
            var openedInfoWindow = null;
            var minRouteMetaUtcTime = 0;
            var metaCoordinates = [];
            var editAttributesValues = []
            google.maps.event.addListener(
                scope.obj.map,
                "zoom_changed",
                function () {
                    scope.obj.zoomLevel = scope.obj.map.getZoom();
                    // scope.$apply();
                }
            );
            scope.obj.toggleMarkers = function () {
                routeMarkers.forEach(function (marker) {
                    if (marker.icon.url !== iconImage) {
                        marker.setVisible(scope.obj.hidemarker);
                    }
                });
            };
            scope.obj.toggleRouteMarkers = function () {
                routeMarkers.forEach(function (marker) {
                    if (marker.icon.url !== iconMarker) {
                        marker.setVisible(scope.obj.hideRoutemarker);
                    }
                });
            };
            google.maps.event.addListener(
                scope.obj.map,
                "idle",
                function () {
                    scope.obj.zoomLevel = scope.obj.map.getZoom();
                    scope.$apply();
                }
            );
            var dragging = false;
            scope.obj.draggedOnce = false
            function loadMediaMarkers() {
                dragging = true
                scope.obj.draggedOnce = true;
                scope.obj.hidemarker = true;
                scope.obj.hideRoutemarker = true;
                var center = scope.obj.map.getCenter();
                imageRoutePoint.postCenterLatLng(scope.obj.routeId, { lat: center.lat(), lng: center.lng() }, function (data) {
                    if (data.length) {
                        for (var i = 0; i < routeMarkers.length; i++) {
                            routeMarkers[i].setMap(null);
                        }
                        routeMarkers = [];
                        callRouteImage(data, scope.obj.map)
                    }
                })

            };
            loadMediaMarkers()
            scope.obj.refreshMarkersFn = function () {
                loadMediaMarkers();
            };
            var customControlDiv = document.createElement('div');
            var customControlText = document.createElement('div');
            // var geocoder = new google.maps.Geocoder();

            scope.initializeMap = function () {
                if (!document.getElementById("map")) {
                    console.error("Map element not found!");
                    return;
                }
                scope.map = new google.maps.Map(document.getElementById("map"), {
                    center: { lat: 13.027893369650114, lng: 77.59144741784749 },
                    zoom: 18,
                    tilt: 45, // Enable 3D mode for rotation
                    heading: 0,
                    // mapId: "90f87356969d889c", // Vector map ID required for tilt and rotation
                    mapTypeControl: false,
                    disableDefaultUI: true,
                    cameraControl: true,
                    fullscreenControl: true
                });

                scope.polyline = new google.maps.Polyline({
                    path: scope.obj.plannedPath,
                    geodesic: true,
                    strokeColor: '#0000FF', // Set polyline color
                    strokeOpacity: 0.4,
                    strokeWeight: 32,
                    map: scope.map
                });

                customControlText.style.backgroundColor = 'rgba(211, 211, 211, 0.7)';
                customControlText.style.color = '#1a237e';
                customControlText.style.fontSize = '12px';
                customControlText.style.fontWeight = 'bold';
                customControlText.style.padding = '12px';
                customControlText.style.margin = '10px';
                customControlText.style.borderRadius = '5px';
                customControlText.style.boxShadow = '0px 2px 5px rgba(0, 0, 0, 0.3)';
                customControlDiv.appendChild(customControlText);
                scope.map.controls[google.maps.ControlPosition.TOP_LEFT].push(customControlDiv);

                scope.polyline = new google.maps.Polyline({
                    path: [],
                    geodesic: true,
                    strokeColor: '#0000FF',
                    strokeOpacity: 0.8,
                    strokeWeight: 16,
                    map: scope.map
                });

                RouteImageMeta.getData(scope.routePointId, function (response) {
                    scope.metaCoordinates = Array.isArray(response) ? response : [];
                    if (!response || response.length === 0) {
                        console.warn("No coordinates received.");
                        return;
                    }
                    minRouteMetaUtcTime = scope.metaCoordinates.reduce(function (min, current) {
                        return current.coordinateDate < min ? current.coordinateDate : min;
                    }, scope.metaCoordinates[0].coordinateDate);

                    scope.metaCoordinates.sort(function (a, b) { return a.sortOrder - b.sortOrder; });
                    // Extract the coordinates and their corresponding coordinateDate
                    scope.coordinates = scope.metaCoordinates.map(function (coord) {
                        return { lat: coord.latitude, lng: coord.longitude, coordinateDate: coord.coordinateDate, gpsAccuracy: coord.gpsAccuracy, timeInSec: (coord.coordinateDate - minRouteMetaUtcTime) / 1000 };
                    });
                    scope.usermarker = new google.maps.Marker({
                        position: scope.coordinates[0],
                        map: scope.map,
                        icon: {
                            url: 'content/images/geoLocationAnim.gif',
                            scaledSize: new google.maps.Size(24, 24),
                            anchor: new google.maps.Point(12, 12)
                        }
                    });

                    // Call animatedMove to start moving the marker with the coordinates from the response
                    animatedMove(scope.usermarker, scope.coordinates, 0);
                });
            };
            var animationTimeout;
            var isPaused = false;
            var currentStep = 0;
            var currentIndex = 0;

            function animatedMove(usermarker, coords, index) {
                currentIndex = index; // Save the current coordinate index

                if (index >= coords.length) return;

                var moveto = new google.maps.LatLng(coords[index].lat, coords[index].lng);

                scope.moveMarker(usermarker, coords, index, moveto); // Start animation
            }

            scope.moveMarker = function (usermarker, coords, index, moveto) {
                if (isPaused) return; // Exit if paused
                usermarker.setPosition(moveto);
                scope.map.setCenter(moveto);
                scope.polyline.getPath().push(moveto);
                showLatLngOnMapForVideo(moveto.lat(), moveto.lng(), coords[index].gpsAccuracy);
                if (index < coords.length - 1) {
                    var nextPoint = coords[index + 1];
                    var bearing = getBearing(moveto.lat(), moveto.lng(), nextPoint.lat, nextPoint.lng);
                    scope.map.setHeading(bearing);
                }
                animationTimeout = setTimeout(function () {
                    animatedMove(usermarker, coords, index + 1);
                }, 900);
            }
            function pauseMarkerAnimation() {
                isPaused = true;
                clearTimeout(animationTimeout); // Stop the ongoing movement
            }
            function resumeMarkerAnimation() {
                if (!isPaused) return;
                isPaused = false;
                if (!scope.usermarker || !scope.coordinates) {
                    console.error("usermarker or coordinates are not defined");
                    return;
                }
                animatedMove(scope.usermarker, scope.coordinates, currentIndex);
            }

            function showLatLngOnMapForVideo(lat, lng, gpsAccuracy) {
                var accuracy = gpsAccuracy;
                if (gpsAccuracy == null) {
                    accuracy = "";
                } else {
                    accuracy.toFixed(2);
                }
                // var latLng = new google.maps.LatLng(lat, lng);
                customControlText.innerHTML = 'Location: ' + lat.toFixed(8) + ', ' + lng.toFixed(8);
                // geocoder.geocode({ 'location': latLng }, function (results, status) {
                //     if (status === google.maps.GeocoderStatus.OK) {
                //         if (results[0]) {
                //             customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>' + results[0].formatted_address;
                //         } else {
                //             customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>No address found.';
                //         }
                //     } else {
                //         customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>Geocode failed: ' + status;
                //     }
                // });
            }

            function getBearing(lat1, lng1, lat2, lng2) {
                var dLon = (lng2 - lng1) * (Math.PI / 180);
                lat1 = lat1 * (Math.PI / 180);
                lat2 = lat2 * (Math.PI / 180);

                var y = Math.sin(dLon) * Math.cos(lat2);
                var x = Math.cos(lat1) * Math.sin(lat2) -
                    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
                var brng = Math.atan2(y, x) * (180 / Math.PI);
                return (brng + 360) % 360; // Normalize to 0-360 degrees
            }

            scope.loadAssets = function (routeId, lastId) {
                routeDetail.getAssetsById(routeId, lastId, function (response) {
                    if (response.assets.length > 0) {
                        response.assets.forEach(function (asset) {
                            var coordinates = asset.assetCoordinates.map(function (coord) {
                                return { lat: coord.latitude, lng: coord.longitude };
                            });

                            if (asset.assetTypeLayout === 'FIXED' && asset.phase === 'SURVEY') {
                                scope.map.setCenter(coordinates[0]);
                                var marker = new google.maps.Marker({
                                    position: coordinates[0],
                                    map: scope.map,
                                    title: asset.name,
                                    icon: {
                                        url: asset.assetTypeImagePath,
                                        scaledSize: new google.maps.Size(32, 32)
                                    }
                                });
                                // function updateMarkerLabel() {
                                //     var currentZoom = scope.map.getZoom();
                                //     if (currentZoom > 15) {
                                //         marker.setLabel({
                                //             text: '\n\n\n' + asset.name,
                                //             color: '#000',  // Customize as needed
                                //             fontSize: '12px',
                                //             fontWeight: "bold"
                                //         });
                                //     } else {
                                //         marker.setLabel(null);  // Remove the label if zoom <= 15
                                //     }
                                // }

                                // // Initialize label based on current zoom
                                // updateMarkerLabel();

                                // // Listen for zoom changes and update the label
                                // google.maps.event.addListener(scope.map, 'zoom_changed', function () {
                                //     updateMarkerLabel();
                                // });
                            }
                            else if (asset.assetTypeLayout === 'SPREAD' && asset.phase === 'SURVEY') {
                                var drawPolyline = new google.maps.Polyline({
                                    path: coordinates,
                                    geodesic: true,
                                    strokeColor: '#0000FF',
                                    strokeOpacity: 1.0,
                                    strokeWeight: 3
                                });
                                drawPolyline.setMap(scope.map);
                                // console.log("Polyline added:", drawPolyline);
                            }
                        });
                    }
                    // Handle pagination (if response has more than 50 assets)
                    if (response.assets.length >= 200) {
                        scope.loadAssets(routeId, response.assets[response.assets.length - 1].id);
                    }
                });
            };
            // Initialize map when modal is opened
            $("#mediaModal").on("shown.bs.modal", function () {
                setTimeout(function () {
                    scope.initializeMap();
                }, 1000);
                setTimeout(function () {
                    scope.loadAssets(scope.obj.routeId, null);
                }, 1000);
            });
            scope.currentIndex = 0;
            function callRouteImage(arr, map) {
                markerIds = [];
                var hoverInfoWindow = new google.maps.InfoWindow({ disableAutoPan: true });
                var openedInfoWindow = null;

                arr.forEach(function (each) {
                    if (scope.modalClosing) return;
                    var iconImg = (each.imageAttached) ? iconImage : iconMarker;
                    var markerImage = new google.maps.Marker({
                        position: { lat: each.latitude, lng: each.longitude },
                        map: map,
                        title: each.id.toString(),
                        icon: {
                            scaledSize: new google.maps.Size(iconSize, iconSize),
                            url: iconImg,
                            anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                            labelOrigin: new google.maps.Point(25, 22),
                        }
                    });
                    if (each.imageAttached) {
                        markerImage.setZIndex(2000);
                    } else {
                        markerImage.setIcon({
                            scaledSize: new google.maps.Size(23, 23),
                            url: iconImg,
                            anchor: new google.maps.Point(22 / 1.2, 22 / 1.2),
                            labelOrigin: new google.maps.Point(25, 22)
                        });
                    }
                    google.maps.event.addListener(markerImage, "click", function () {
                        if (each && each.id && each.imageAttached) {
                            scope.routeImageMarkerId = each.id;
                            scope.imgName = (each.name == null) ? "Marker" : each.name;
                            scope.imgLatitude = each.latitude;
                            scope.imgLongitude = each.longitude;

                            imageRoutePoint.getImagesList(each.id, function (mediaList) {
                                mediaList.sort(function (a, b) {
                                    return a.createdDate - b.createdDate;
                                });

                                mediaList.forEach(function (item) {
                                    item.rID = each.id;
                                });

                                scope.nameImages = mediaList;
                                scope.mediaImagesIds = mediaList;
                                scope.currentIndex = 0;
                                scope.loadMedia(scope.mediaImagesIds[scope.currentIndex]);
                            });

                        } else {
                            if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }

                            var contentString = document.createElement("div");
                            contentString.innerHTML =
                                '<div class="infoWindowhead">' +
                                "<br><br>" +
                                "<b>Name : " + each.type + "_" + each.id + "</b><br>" +
                                '<b>Latitude : ' + each.latitude + '</b><br>' +
                                '<b>Longitude : ' + each.longitude +
                                ' <button onclick="copyToClipboard(\'' + each.latitude + ',' + each.longitude + '\', this)" style="font-size:10px; padding:2px 5px; margin-left:5px; cursor:pointer;">Copy</button></b><br>' +
                                "<b>Type : " + each.type + "</b><br>" +
                                "<br></div>";

                            openedInfoWindow = new google.maps.InfoWindow({
                                content: contentString,
                                position: { lat: each.latitude, lng: each.longitude }
                            });

                            openedInfoWindow.open(scope.obj.map);

                            var btnShowAsset = document.createElement("input");
                            btnShowAsset.type = "button";
                            btnShowAsset.value = "Show attributes";
                            btnShowAsset.className = "button";

                            google.maps.event.addDomListener(btnShowAsset, "click", function () {
                                imageRoutePoint.getRouteMarkerDetails(each.id, function (response) {
                                    showAssetAttributesModal(response);
                                });
                            });

                            contentString.appendChild(btnShowAsset);

                            var btnEditAttrbuts = document.createElement("input");
                            btnEditAttrbuts.type = "button";
                            btnEditAttrbuts.value = "Edit attributes";
                            btnEditAttrbuts.className = "button";
                            google.maps.event.addDomListener(btnEditAttrbuts, "click", function () {
                                imageRoutePoint.getRouteMarkerDetails(each.id, function (response) {
                                    editAttributesValues = response;
                                    showAssetAttributesEditModal(editAttributesValues);
                                });
                            });
                            contentString.appendChild(btnEditAttrbuts);
                        }
                    });

                    // (function (markerCopy, eachCopy) {
                    //     google.maps.event.addListener(markerCopy, "mouseover", function () {
                    //         var contentDiv = document.createElement("div");
                    //         contentDiv.innerHTML =
                    //             '<div style="min-width:200px; padding:6px;" id="hoverContent_' + eachCopy.id + '">' +
                    //             '<strong>Upload file for Route ID: ' + eachCopy.id + '</strong><br/><br/>' +
                    //             '<input type="file" id="fileInput_' + eachCopy.id + '" />' +
                    //             '<div id="uploadStatus_' + eachCopy.id + '" style="margin-top:6px;font-size:12px;"></div>' +
                    //             '</div>';

                    //         hoverInfoWindow.setContent(contentDiv);
                    //         hoverInfoWindow.open(map, markerCopy);
                    //         setTimeout(function () {
                    //             hoverInfoWindow.close();
                    //         }, 2000);

                    //         google.maps.event.addListenerOnce(hoverInfoWindow, "domready", function () {
                    //             var fileInput = document.getElementById("fileInput_" + eachCopy.id);
                    //             var statusDiv = document.getElementById("uploadStatus_" + eachCopy.id);
                    //             if (fileInput) {
                    //                 fileInput.addEventListener("change", function (evt) {
                    //                     var file = evt.target.files && evt.target.files[0];
                    //                     if (!file) return;

                    //                     var fileName = file.name;
                    //                     var fileType = (file.name.split('.').pop() || '').toUpperCase();

                    //                     if (fileName.toUpperCase().endsWith("." + fileType)) {
                    //                         fileName = fileName.substring(0, fileName.lastIndexOf('.'));
                    //                     }
                    //                     var finalFileName = fileName + "." + fileType;

                    //                     try {
                    //                         var injector = angular.element(document.body).injector();
                    //                         var FileUploadService = injector.get("FileUploadService");

                    //                         if (statusDiv) statusDiv.innerText = "Uploading...";

                    //                         FileUploadService.uploadFile(file, eachCopy.id, fileType, finalFileName, function (success) {
                    //                             if (statusDiv) statusDiv.innerText = success ? "Upload successful" : "Upload failed";

                    //                             if (success) {
                    //                                 eachCopy.imageAttached = true;
                    //                                 markerCopy.setIcon({
                    //                                     scaledSize: new google.maps.Size(iconSize, iconSize),
                    //                                     url: iconImage,
                    //                                     anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                    //                                     labelOrigin: new google.maps.Point(25, 22)
                    //                                 });
                    //                                 markerCopy.setZIndex(2000);
                    //                                 hoverInfoWindow.close();
                    //                                 alert("Media uploaded successfully");
                    //                             }
                    //                         });
                    //                     } catch (err) {
                    //                         console.error("FileUploadService not found", err);
                    //                         if (statusDiv) statusDiv.innerText = "Upload error";
                    //                     }
                    //                 });
                    //             }
                    //         });
                    //     });

                    //     google.maps.event.addListener(map, "click", function () {
                    //         hoverInfoWindow.close();
                    //     });
                    // })(markerImage, each);

                    routeMarkers.push(markerImage);
                });
            }

            window.copyToClipboard = function (text) {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(text).then(function () {
                    }).catch(function (err) {
                        console.error("Clipboard copy failed: ", err);
                    });
                } else {
                    var tempInput = document.createElement("input");
                    tempInput.value = text;
                    document.body.appendChild(tempInput);
                    tempInput.select();
                    document.execCommand("copy");
                    document.body.removeChild(tempInput);
                }
            };
            scope.closeModal = function (id) {
                scope.mediaImagesIds = []
                var container = document.getElementById("carouselMediaContainer");
                if (container) {
                    var video = container.querySelector("video");
                    if (video) {
                        video.pause();
                        video.src = "";
                        video.load();
                    }
                    container.innerHTML = "";
                }
                var thumbContainer = document.getElementsByClassName("thumbnails_container");
                if (thumbContainer) {
                    thumbContainer.innerHTML = "";
                }
                data = null
                $("#" + id).removeClass("in");
                $(".modal-backdrop").remove();
                $("#" + id).hide();
            }

            scope.currentIndex = 0;
            scope.nameImages = [];
            scope.routeName = scope.obj.routeName
            scope.showMediaCarousel = function (markerId, markerInfo) {
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) spinner.style.display = "block";

                scope.imgName = markerInfo.name || "Marker";
                scope.imgLatitude = markerInfo.latitude;
                scope.imgLongitude = markerInfo.longitude;

                imageRoutePoint.getImagesList(markerId, function (mediaList) {
                    for (var i = 0; i < mediaList.length; i++) {
                        mediaList[i].rID = markerId;
                    }

                    scope.nameImages = mediaList;
                    scope.currentIndex = 0;

                    if (spinner) spinner.style.display = "none";

                    scope.loadMedia(scope.nameImages[scope.currentIndex]);
                    $("#mediaCarouselModal").modal("show");
                });
            };

            scope.loadMedia = function (media) {
                var container = document.getElementById("carouselMediaContainer");
                var spinner = document.getElementById("loading-bar-spinner");

                if (!container) {
                    console.warn("carouselMediaContainer not ready. Retrying...");
                    setTimeout(function () {
                        scope.loadMedia(media);
                    }, 100);
                    return;
                }

                if (spinner) spinner.style.display = "block";
                container.innerHTML = "";

                var xhr = new XMLHttpRequest();
                xhr.open("GET", 'api/routepoint-images/' + media.rID + '/' + media.imageId, true);
                xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
                xhr.responseType = "blob";

                xhr.onload = function () {
                    if (xhr.status === 200) {
                        var mediaUrl = URL.createObjectURL(xhr.response);

                        if (media.imageType === "MP4") {
                            // Video display
                            var video = document.createElement("video");
                            video.controls = true;
                            video.autoplay = true;
                            video.style.maxWidth = "100%";
                            video.style.maxHeight = "70vh";
                            video.style.width = "auto";
                            video.style.height = "auto";
                            video.style.objectFit = "contain";

                            var source = document.createElement("source");
                            source.src = mediaUrl;
                            source.type = "video/mp4";

                            video.appendChild(source);
                            container.appendChild(video);

                        } else {
                            // Image display with zoom and drag
                            var img = document.createElement("img");
                            img.src = mediaUrl;
                            img.style.maxWidth = "100%";
                            img.style.maxHeight = "70vh";
                            img.style.cursor = "grab";
                            img.setAttribute("draggable", "false");
                            img.id = "carouselImage";
                            container.appendChild(img);

                            // Zoom and pan logic
                            var zoom = 1;
                            var minZoom = 1;
                            var maxZoom = 5;
                            var imgOffsetX = 0;
                            var imgOffsetY = 0;

                            function applyTransform() {
                                img.style.transform = 'translate(' + imgOffsetX + 'px, ' + imgOffsetY + 'px) scale(' + zoom + ')';
                                img.style.transition = "transform 0.1s ease-out";
                            }
                            applyTransform();

                            container.addEventListener("wheel", function (e) {
                                e.preventDefault();
                                var delta = Math.sign(e.deltaY);
                                var zoomAmount = 0.1;
                                var newZoom = zoom;

                                if (delta < 0) {
                                    newZoom = Math.min(maxZoom, zoom + zoomAmount);
                                } else {
                                    newZoom = Math.max(minZoom, zoom - zoomAmount);
                                }

                                var scaleFactor = newZoom / zoom;
                                var rect = img.getBoundingClientRect();
                                var mouseX = e.clientX - rect.left;
                                var mouseY = e.clientY - rect.top;

                                if (newZoom === minZoom) {
                                    imgOffsetX = 0;
                                    imgOffsetY = 0;
                                } else {
                                    imgOffsetX -= mouseX * scaleFactor - mouseX;
                                    imgOffsetY -= mouseY * scaleFactor - mouseY;
                                }

                                zoom = newZoom;
                                applyTransform();
                            });

                            var isDragging = false;
                            var startCursorX, startCursorY;
                            var startImgOffsetX, startImgOffsetY;

                            img.addEventListener("mousedown", function (e) {
                                isDragging = true;
                                img.style.cursor = "grabbing";
                                startCursorX = e.clientX;
                                startCursorY = e.clientY;
                                startImgOffsetX = imgOffsetX;
                                startImgOffsetY = imgOffsetY;
                                img.style.transition = "none";
                            });

                            document.addEventListener("mouseup", function () {
                                isDragging = false;
                                img.style.cursor = "grab";
                            });

                            document.addEventListener("mousemove", function (e) {
                                if (!isDragging) return;
                                e.preventDefault();
                                var dx = e.clientX - startCursorX;
                                var dy = e.clientY - startCursorY;
                                imgOffsetX = startImgOffsetX + dx;
                                imgOffsetY = startImgOffsetY + dy;
                                applyTransform();
                            });
                        }

                        $("#mediaCarouselModal").modal("show");
                    } else {
                        alert("No media found");
                        container.innerHTML = "<p>Error loading media</p>";
                    }

                    if (spinner) spinner.style.display = "none";
                };

                xhr.onerror = function () {
                    alert("Network error");
                    container.innerHTML = "<p>Network error</p>";
                    if (spinner) spinner.style.display = "none";
                };

                xhr.send();
            };


            scope.nextMedia = function () {
                if (scope.mediaImagesIds.length > 0) {
                    scope.currentIndex = (scope.currentIndex + 1) % scope.mediaImagesIds.length;
                    scope.loadMedia(scope.mediaImagesIds[scope.currentIndex]);
                }
            };

            scope.prevMedia = function () {
                if (scope.mediaImagesIds.length > 0) {
                    scope.currentIndex = (scope.currentIndex - 1 + scope.mediaImagesIds.length) % scope.mediaImagesIds.length;
                    scope.loadMedia(scope.mediaImagesIds[scope.currentIndex]);
                }
            };
            scope.jumpToMedia = function (index) {
                if (scope.mediaImagesIds[index]) {
                    scope.currentIndex = index;
                    scope.loadMedia(scope.mediaImagesIds[index]);
                }
            };
            scope.downloadMedia = function () {
                var currentMedia = scope.mediaImagesIds[scope.currentIndex];
                if (!currentMedia) return;
                var xhr = new XMLHttpRequest();
                xhr.open("GET", 'api/routepoint-images/' + currentMedia.rID + '/' + currentMedia.imageId, true);
                xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
                xhr.responseType = "blob";

                xhr.onload = function () {
                    if (xhr.status === 200) {
                        var blob = xhr.response;
                        var url = window.URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.href = url;


                        var fileName = (scope.obj.routeName + "_" + currentMedia.imageName || "media")

                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                    } else {
                        alert("Failed to download media.");
                    }
                };

                xhr.onerror = function () {
                    alert("Network error while downloading.");
                };

                xhr.send();
            };
            scope.downloadAllMedia = function () {
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) {
                    spinner.style.display = "block";
                }
                var xhr = new XMLHttpRequest();
                xhr.open('GET', '/api/routepoint/downloadFiles/' + scope.routeImageMarkerId, true);
                xhr.setRequestHeader('Accept', 'application/zip');
                xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
                xhr.responseType = 'blob';

                xhr.onload = function () {
                    if (spinner) {
                        spinner.style.display = "none"
                    }
                    if (xhr.status === 200) {
                        var blob = new Blob([xhr.response], { type: 'application/zip' });
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = scope.obj.routeName + "_" + scope.imgLatitude + "," + scope.imgLongitude + '.zip';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        alert('Download failed. Status: ' + xhr.status);
                    }
                };

                xhr.onerror = function () {
                    alert('Request error.');
                };

                xhr.send();
            }

            scope.toggleMaximize = function () {
                var modalDialog = document.querySelector("#mediaCarouselModal .modal-dialog");
                var maximizeBtn = document.getElementById("maximizeBtn");
                var minimizeBtn = document.getElementById("minimizeBtn");

                modalDialog.classList.toggle("fullscreen-modal");

                maximizeBtn.style.display = modalDialog.classList.contains("fullscreen-modal") ? "none" : "inline-block";
                minimizeBtn.style.display = modalDialog.classList.contains("fullscreen-modal") ? "inline-block" : "none";

                // Force a redraw (optional)
                var container = document.getElementById("carouselMediaContainer");
                var current = container.innerHTML;
                container.innerHTML = "";
                container.innerHTML = current;
            };
            scope.modalClosing = false;
            $('#mediaCarouselModal').on('hide.bs.modal', function () {
                scope.modalClosing = true;
            });
            $('#mediaCarouselModal').on('hidden.bs.modal', function () {
                scope.modalClosing = false;
                var container = document.getElementById("carouselMediaContainer");
                if (container) {
                    var video = container.querySelector("video");
                    if (video) {
                        video.pause();
                        video.src = "";
                    }
                    container.innerHTML = "";
                }
            });



            function showAssetAttributesModal(assetVal) {
                var AttributeValues = []
                $("#modalAssetAttributes").show();
                AttributeValues.push({
                    "Id": assetVal.id,
                    "Depth": assetVal.depth,
                    "Distance": assetVal.distance,
                    "Latitude": assetVal.latitude,
                    "Longitude": assetVal.longitude,
                    "LHS Offset": assetVal.lhsOffset,
                    "Land Mark": assetVal.landMark,
                    "Height": assetVal.height,
                    "RHS Offset": assetVal.rhsOffset,
                    "Route Offset": assetVal.routeOffset,
                    "Road Width": assetVal.roadWidth,
                    "RodoMeter Length": assetVal.rodometerLength,
                    "Route Point Type": assetVal.routePointType,
                    "Road Type": assetVal.roadType,
                    "Placement Level": assetVal.placementLevel,
                    "Phase": assetVal.phase,
                    "Status": assetVal.status,
                    "Surrounding Type": assetVal.surroundingType,
                    "Soil Type": assetVal.soilType,
                    "Terrain Area": assetVal.terrainArea,
                })
                var attributes = AttributeValues[0];
                document.getElementById("assetAttributeTable").innerHTML = "";
                var newTable =
                    "<table align='center' style='border: 1px solid black; width: 80%;'>" +
                    "<tr><th style='border: 1px solid black; text-align: center;'>Attribute</th>" +
                    "<th style='border: 1px solid black; text-align: center;'>Attribute Value</th></tr>";

                for (var key in attributes) {
                    if (attributes.hasOwnProperty(key)) {
                        newTable +=
                            "<tr><td style='border: 1px solid black; text-align: center;'>" +
                            key +
                            "</td><td style='border: 1px solid black; text-align: center;'>" +
                            (attributes[key] !== null ? attributes[key] : "N/A") +
                            "</td></tr>";
                    }
                }

                newTable += "</table>";

                document.getElementById("assetNameAssetAttributes").textContent =
                    assetVal.id + " - " + (assetVal.routePointType || "Unknown");
                document.getElementById("assetAttributeTable").innerHTML = newTable;
            }
            scope.closeAssetAttributesModal = function () {
                $("#modalAssetAttributes").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalAssetAttributes").hide();
            }
          
            function showAssetAttributesEditModal(assetAttributes) {
                $("#marker_Attr_edit").data("original", assetAttributes);
                $("#lhsOffset").val(assetAttributes.lhsOffset || 0);
                $("#rhsOffset").val(assetAttributes.rhsOffset || 0);
                $("#roadType").val(assetAttributes.roadType || "");
                $("#roadWidth").val(assetAttributes.roadWidth || 0);
                $("#landMark").val(assetAttributes.landMark || "N/A");
                $("#rodometerLength").val(assetAttributes.rodometerLength || 0);
                $("#saveMarkerAttr").data("id", assetAttributes.id);

                $("#marker_Attr_edit").modal("show");
            }

            $(document).on("click", "#saveMarkerAttr", function () {
                var original = $("#marker_Attr_edit").data("original");
                var payload = $.extend({}, original, {
                    lhsOffset: $("#lhsOffset").val(),
                    rhsOffset: $("#rhsOffset").val(),
                    roadType: $("#roadType").val(),
                    roadWidth: $("#roadWidth").val(),
                    landMark: $("#landMark").val(),
                    rodometerLength: $("#rodometerLength").val(),
                    routeId: scope.obj.routeId
                });
                imageRoutePoint.updateRouteMarkerAttributs([payload], function (response) {
                    if (response && !response.error) {
                        alert("Marker Attribute updated successfully!");
                        $("#marker_Attr_edit").modal("hide");
                    } else {
                        alert("Failed to update marker.");
                    }
                });
            });
        }
    };
}]);
angular.module('trakeyeApp').directive('resourceTxnTab', ['SummaryPost','$rootScope','ParseLinks','Geofence','ResourceDates','ResourceByDates',function (SummaryPost,$rootScope,ParseLinks,Geofence,ResourceDates,ResourceByDates) {
    return {
      restrict: 'E',
      scope: {
        obj:'=',
      },
      templateUrl: 'app/components/View/resourceTxnTab.html',
      link: function (scope) {

        scope.RESOURCETX_EDIT = $rootScope.Roles.RESOURCETX_EDIT
        scope.entityId = scope.obj.id
        scope.entityName = scope.obj.name
        scope.sectionId = scope.obj.sectionId
        scope.page = 1
        scope.predicate = 'modified_date'
        scope.itemsPerPage = 10
        $('.select2').select2();
        
        SummaryPost.resTx({taskIds : [ scope.entityId ]}, function (response) {
          scope.resTxSummary = response
        })
        
        scope.transition = function() {
          loadAll()
        }
        //loadAll()
      function loadAll() {
       /*  Geofence.query({
            page: scope.page,
            size: scope.itemsPerPage,
            sort: sort()
        }, onSuccess, onError); */

        function sort() {
            var result = [scope.predicate + ',' + (scope.reverse ? 'asc' : 'desc')];
            return result;
        }

        function onSuccess(data, headers) {
            scope.links = ParseLinks.parse(headers('link'));
            scope.totalItems = headers('X-Total-Count');
            scope.queryCount = scope.totalItems;
            scope.resourceTxListView = []
            data.forEach(function (value) {
              scope.resourceTxListView.push(value);
            });
            //vm.page = pagingParams.page;
        }

        function onError(error) {
            console.log(error)
        }
    }
    scope.loadMaterialTxnDate = function () {
      ResourceDates.query({
        type: "task",
        id: scope.entityId,
        page: scope.page - 1,
        size: scope.itemsPerPage,
        sort: "last_modified_date,desc"
      }, function (data, headers) {
        scope.links = ParseLinks.parse(headers('link'));
        scope.totalItems = headers('X-Total-Count');
        scope.queryCount = scope.totalItems;
        scope.materialByDate = data.map(function (item) {
          return {
            timestamp: item[0],
            total: item[1],
            isExpand: false
          };
        });
      });
    };

    scope.loadMaterialTxnByDates = function (date) {
      ResourceByDates.query({
        type: 'task',
        id: scope.entityId,
        date: date,
        page: scope.page - 1,
        size: scope.itemsPerPage,
        sort: "last_modified_date,desc"
      }, function (data, headers) {
        scope.links = ParseLinks.parse(headers('link'));
        scope.totalItems = headers('X-Total-Count');
        scope.queryCount = scope.totalItems;
        scope.materialTxnByDates = data.map(function (item) {
          return {
            transactionId: item[0],
            timestamp: item[4],
            transactionName: item[1],
            transactionType: item[2],
            count: item[3],
            status: item[5],
          };
        });
      });
    };

    scope.toggleExpand = function (selectedTask) {
      angular.forEach(scope.materialByDate, function (task) {
        if (task === selectedTask) {
          task.isExpand = !task.isExpand;
          if (task.isExpand) {
            scope.loadMaterialTxnByDates(task.timestamp);
          } else {
            scope.materialTxnByDates = [];
          }
        } else {
          task.isExpand = false;
        }
      });
    };

    scope.transitionMainMaterial = function () {
      scope.loadMaterialTxnDate();
    };

    // Initial load
    scope.loadMaterialTxnDate();
      }
      
    };
  }]);
  
angular.module('trakeyeApp').directive('materialTxnTab', [
  'SummaryPost', '$rootScope', '$window', 'ParseLinks', 'Geofence', 'Summary', 'MaterialByDates', 'MaterialDates', 'Inventory',
  function (SummaryPost, $rootScope, $window, ParseLinks, Geofence, Summary, MaterialByDates, MaterialDates, Inventory) {
    return {
      restrict: 'E',
      scope: {
        obj: '=',
      },
      templateUrl: 'app/components/View/materialTxnTab.html',
      link: function (scope) {

        scope.MATERIALTX_EDIT = $rootScope.Roles.MATERIALTX_EDIT;
        scope.entityId = scope.obj.id;
        scope.entityName = scope.obj.name;
        scope.sectionId = scope.obj.sectionId;

        scope.page = 1;
        scope.itemsPerPage = 10;
        scope.totalItems = 0;
        scope.queryCount = 0;

        scope.summaryPage = 1;
        scope.summaryItemsPerPage = 10;
        scope.summaryTotalItems = 0;
        scope.summaryQueryCount = 0;


        scope.txnPage = 1;
        scope.txnItemsPerPage = 10;
        scope.txnTotalItems = 0;
        scope.txnQueryCount = 0;

        scope.reverse = false;
        scope.mtrlTxListView = [];
        scope.mtrlTxSummary = [];
        scope.materialByDate = [];
        scope.materialTxnByDates = [];
        $('.select2').select2();

        SummaryPost.mtrlTx({ taskIds: [scope.entityId] }, function (response) {
          scope.mtrlTxSummary = response
        })
        function sort() {
          var result = [scope.predicate + ',' + (scope.reverse ? 'asc' : 'desc')];
          return result;
        }
        scope.transition = function () {
          loadAll()
        }
        //loadAll()
        function loadAll() {
          /* Geofence.query({
            page: scope.page,
            size: scope.itemsPerPage,
            sort: sort()
          }, onSuccess, onError); */

          function onSuccess(data, headers) {
            scope.links = ParseLinks.parse(headers('link'));
            scope.totalItems = headers('X-Total-Count');
            scope.queryCount = scope.totalItems;
            scope.mtrlTxListView = []
            data.forEach(function (value) {
              scope.mtrlTxListView.push(value);
              // console.log(data)
            });
            //vm.page = pagingParams.page;
          }

          function onError(error) {
            console.log(error)
          }
        }


        function loadMaterialTxnDate() {
          MaterialDates.query(
            {
              type: 'task',
              id: scope.entityId,
              page: scope.summaryPage - 1,
              size: scope.summaryItemsPerPage,
              sort: "last_modified_date,desc"
            },
            function (data, headers) {
              scope.links = ParseLinks.parse(headers('link'));
              scope.summaryTotalItems = headers('X-Total-Count');
              scope.summaryQueryCount = scope.summaryTotalItems;
              scope.materialByDate = data.map(function (item) {
                return {
                  timestamp: item[0],
                  total: item[1],
                  isExpand: false,
                };
              });
            }
          );
        }

        function loadMaterialTxnByDates(date) {
          MaterialByDates.query(
            {
              type: 'task',
              id: scope.entityId,
              date: date,
              page: scope.txnPage - 1,
              size: "last_modified_date,desc",
              sort: sort()
            }, onSuccess)
          function onSuccess(data, headers) {
            scope.links = ParseLinks.parse(headers('link'));
            scope.txnTotalItems = headers('X-Total-Count');
            scope.txnQueryCount = scope.txnTotalItems;
            scope.materialTxnByDates = data.map(function (item) {
              return {
                materialId: item[0] || "NA",
                timestamp: item[4] || "NA",
                materialType: item[1] || "NA",
                materialName: item[2] || "NA",
                transactionType: item[5] || "NA",
                mtrlTxNumber: item[6] || "NA",
                count: item[3] || "NA"
              };
            });
          };
        }

        scope.mtrlTxTransition = function () {
          loadAll();
        };

        scope.loadMaterialTxnDate = function () {
          loadMaterialTxnDate();
        };

        scope.loadMaterial = function (timestamp) {
          loadMaterialTxnByDates(timestamp);
        };

        scope.toggleExpand = function (selectedTask) {
          angular.forEach(scope.materialByDate, function (task) {
            if (task === selectedTask) {
              task.isExpand = !task.isExpand;
              if (task.isExpand) {
                scope.loadMaterial(task.timestamp);
              } else {
                scope.materialTxnByDates = [];
              }
            } else {
              task.isExpand = false;
            }
          });
        };

        loadAll();
        loadMaterialTxnDate();
        var today = new Date();
        today.setHours(23, 59, 59);
        scope.datePickerOpenStatus = {};
        scope.openCalendar = openCalendar;
        scope.options = {
          maxDate: today
        };
        function openCalendar(date) {
          scope.datePickerOpenStatus[date] = true;
        }



        function epoch(date) {
          return Date.parse(date)
        }
        scope.isModalOpen = false;
        scope.selectedTransaction = {};
        scope.openTransactionModal = function (transaction) {
          scope.selectedTransaction = angular.copy(transaction);
          scope.isModalOpen = true;
        };

        scope.saveTransaction = function () {
          var transactionData = {
            materialId: scope.selectedTransaction.materialId,
            unitOfMeasurement: scope.selectedTransaction.unitOfMeasurement,
            noOfUnits: scope.selectedTransaction.noOfUnits,
            transactionDate: epoch(scope.selectedTransaction.transactionDate),
            transactionType: scope.selectedTransaction.transactionType,
            mtrlTxNumber: scope.selectedTransaction.mtrlTxNumber,
            invoiceNumber: scope.selectedTransaction.invoiceNumber || null,
            remarks: scope.selectedTransaction.remarks || null,
            taskId: scope.entityId,
            sectionId: scope.obj.sectionId

          };
          Inventory.postBulkMaterialTxn([transactionData], function () {
            $window.history.back();
          }, function (error) {
            console.error('Error saving transaction:', error)
          });
          scope.isModalOpen = false;
        };

        scope.cancelTransaction = function () {
          scope.selectedTransaction = {};
          scope.isModalOpen = false;
        };

        scope.transactionType = ["RECEIVED", "UTILIZED", "RECONCILED"]
      },
    };
  }
]);

angular.module('trakeyeApp').directive('comments', ['taskComment','$rootScope',function (taskComment,$rootScope) {
    return {
      restrict: 'E',
      scope: {
        obj:'=',
      },
      templateUrl: 'app/components/View/comments.html',
      link: function (scope) {

        scope.loginUserName = $rootScope.loginUserName
        scope.comments = [];
        callGetComment();


        scope.addComment = function () {
            if (scope.newComment.trim() !== "") {
                var comment = {
                    entityId: scope.obj.entityId,
                    comment: scope.newComment,
                    entityName: scope.obj.entityName
                };

                //scope.comments.push(comment);
                scope.newComment = "";

                taskComment.post(comment, function () {
                    callGetComment();
                });
            }
        };

        scope.startEditing = function (comment) {
            comment.editing = true;
        };

        scope.saveEdit = function (comment) {
            comment.editing = false;
            taskComment.put(comment, function () {
                callGetComment();
            });
        };

        scope.cancelEdit = function (comment) {
            comment.editing = false;
        };

        scope.deleteComment = function (commentId) {
            $("#deleteComment").show();
            scope.storeComment = commentId;
        };

        scope.deleteCommentConfirm = function () {
            taskComment.delete(scope.storeComment, function () {
                callGetComment();
                scope.closeModal("deleteComment");
            });
        };

        function callGetComment() {
            taskComment.get(scope.obj.entityId,scope.obj.entityName, function (response) {
                scope.comments = response;
            });
        }

        scope.closeModal = function(id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        };
    
      }
      
    };
  }]);
  
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('trakeyeApp')
        .component('jhiItemCount', jhiItemCount);
})();

/* 
 * Angular JS Multi Select
 * Creates a dropdown-like button with checkboxes. 
 *
 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
 * Current version: 4.0.0
 * 
 * Released under the MIT License
 * --------------------------------------------------------------------------------
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy 
 * of this software and associated documentation files (the "Software"), to deal 
 * in the Software without restriction, including without limitation the rights 
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
 * copies of the Software, and to permit persons to whom the Software is 
 * furnished to do so, subject to the following conditions: 
 *
 * The above copyright notice and this permission notice shall be included in all 
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE 
 * SOFTWARE.
 * --------------------------------------------------------------------------------
 */

'use strict'

angular.module( 'isteven-multi-select', ['ng'] ).directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
    return {
        restrict: 
            'AE',

        scope: 
        {   
            // models
            inputModel      : '=',
            outputModel     : '=',

            // settings based on attribute
            isDisabled      : '=',

            // callbacks
            onClear         : '&',  
            onClose         : '&',
            onSearchChange  : '&',  
            onItemClick     : '&',            
            onOpen          : '&', 
            onReset         : '&',  
            onSelectAll     : '&',  
            onSelectNone    : '&',  
            onSelectDone    : '&', 

            // i18n
            translation     : '='   
        },
        
        /* 
         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
         */
                                                         
         templateUrl: 
            'isteven-multi-select.htm',                            

        link: function ( $scope, element, attrs ) {                       

            $scope.backUp           = [];
            $scope.varButtonLabel   = '';               
            $scope.spacingProperty  = '';
            $scope.indexProperty    = '';                        
            $scope.orientationH     = false;
            $scope.orientationV     = true;
            $scope.filteredModel    = [];
            $scope.inputLabel       = { labelFilter: '' };                        
            $scope.tabIndex         = 0;            
            $scope.lang             = {};
            $scope.helperStatus     = {
                all     : true,
                none    : true,
                reset   : true,
                filter  : true,
                done : true
            };

            var 
                prevTabIndex        = 0,
                helperItems         = [],
                helperItemsLength   = 0,
                checkBoxLayer       = '',
                scrolled            = false,
                selectedItems       = [],
                formElements        = [],
                vMinSearchLength    = 0,
                clickedItem         = null                

            // v3.0.0
            // clear button clicked
            $scope.clearClicked = function( e ) {                
                $scope.inputLabel.labelFilter = '';
                $scope.updateFilter();
                $scope.select( 'clear', e );                
            }

            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
            $scope.numberToArray = function( num ) {
                return new Array( num );   
            }

            // Call this function when user type on the filter field
            $scope.searchChanged = function() {                                                
                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
                    return false;
                }                
                $scope.updateFilter();
            }

            $scope.updateFilter = function()
            {      
                // we check by looping from end of input-model
                $scope.filteredModel = [];
                var i = 0;

                if ( typeof $scope.inputModel === 'undefined' ) {
                    return false;                   
                }

                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {

                    // if it's group end, we push it to filteredModel[];
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
                        $scope.filteredModel.push( $scope.inputModel[ i ] );
                    }
                    
                    // if it's data 
                    var gotData = false;
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {                        
                        
                        // If we set the search-key attribute, we use this loop. 
                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {

                            for (var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                    && attrs.searchProperty.indexOf( key ) > -1
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }
                        // if there's no search-key attribute, we use this one. Much better on performance.
                        else {
                            for ( var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }

                        if ( gotData === true ) {    
                            // push
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }

                    // if it's group start
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {

                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined' 
                                && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
                            $scope.filteredModel.pop();
                        }
                        else {
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }
                }                

                $scope.filteredModel.reverse();  
                
                $timeout( function() {                    

                    $scope.getFormElements();               
                    
                    // Callback: on filter change                      
                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {

                        var filterObj = [];

                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' ) {                   
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                                                    
                                    var tempObj = angular.copy( value );
                                    var index = filterObj.push( tempObj );                                
                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];      
                                }
                            }
                        });

                        $scope.onSearchChange({ 
                            data: 
                            {
                                keyword: $scope.inputLabel.labelFilter, 
                                result: filterObj 
                            } 
                        });
                    }
                },0);
            };

            // List all the input elements. We need this for our keyboard navigation.
            // This function will be called everytime the filter is updated. 
            // Depending on the size of filtered mode, might not good for performance, but oh well..
            $scope.getFormElements = function() {                                     
                formElements = [];

                var 
                    selectButtons   = [],
                    inputField      = [],
                    checkboxes      = [],
                    clearButton     = [];
                
                // If available, then get select all, select none, and reset buttons
                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.done || $scope.helperStatus.reset ) {                                                       
                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );                    
                    // If available, then get the search box and the clear button
                    if ( $scope.helperStatus.filter ) {                                            
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );                        
                    }
                }
                else {
                    if ( $scope.helperStatus.filter ) {   
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    }
                }
               
                // Get checkboxes
                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.done && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
                }
                else {
                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
                }

                // Push them into global array formElements[] 
                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }                                
            }            

            // check if an item has attrs.groupProperty (be it true or false)
            $scope.isGroupMarker = function( item , type ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true; 
                return false;
            }

            $scope.removeGroupEndMarker = function( item ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false; 
                return true;
            }                       

            // call this function when an item is clicked
            $scope.syncItems = function( item, e, ng_repeat_index ) {                                      

                e.preventDefault();
                e.stopPropagation();

                // if the directive is globaly disabled, do nothing
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return false;
                }

                // if item is disabled, do nothing
                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {                        
                    return false;
                }                                

                // if end group marker is clicked, do nothing
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
                    return false;
                }                

                var index = $scope.filteredModel.indexOf( item );       

                // if the start of group marker is clicked ( only for multiple selection! )
                // how it works:
                // - if, in a group, there are items which are not selected, then they all will be selected
                // - if, in a group, all items are selected, then they all will be de-selected                
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {                                  

                    // this is only for multiple selection, so if selection mode is single, do nothing
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        return false;
                    }
                    
                    var i,j,k;
                    var startIndex = 0;
                    var endIndex = $scope.filteredModel.length - 1;
                    var tempArr = [];

                    // nest level is to mark the depth of the group.
                    // when you get into a group (start group marker), nestLevel++
                    // when you exit a group (end group marker), nextLevel--
                    var nestLevel = 0;                    

                    // we loop throughout the filtered model (not whole model)
                    for( i = index ; i < $scope.filteredModel.length ; i++) {  

                        // this break will be executed when we're done processing each group
                        if ( nestLevel === 0 && i > index ) 
                        {
                            break;
                        }
                    
                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {
                            
                            // To cater multi level grouping
                            if ( tempArr.length === 0 ) {
                                startIndex = i + 1; 
                            }                            
                            nestLevel = nestLevel + 1;
                        }                                                

                        // if group end
                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {

                            nestLevel = nestLevel - 1;                            

                            // cek if all are ticked or not                            
                            if ( tempArr.length > 0 && nestLevel === 0 ) {                                

                                var allTicked = true;       

                                endIndex = i;

                                for ( j = 0; j < tempArr.length ; j++ ) {                                
                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
                                        allTicked = false;
                                        break;
                                    }
                                }                                                                                    

                                if ( allTicked === true ) {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                        }
                                    }                                
                                }

                                else {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;                                                
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;

                                            }                                            
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
                                            }
                                        }
                                    }                                
                                }                                                                                    
                            }
                        }
            
                        // if data
                        else {                            
                            tempArr.push( $scope.filteredModel[ i ] );                                                                                    
                        }
                    }                                 
                }

                // if an item (not group marker) is clicked
                else {

                    // If it's single selection mode
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        
                        // first, set everything to false
                        for( i=0 ; i < $scope.filteredModel.length ; i++) {                            
                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        for( i=0 ; i < $scope.inputModel.length ; i++) {                            
                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        
                        // then set the clicked item to true
                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;                                                                 
                    }   

                    // Multiple
                    else {
                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
                    }

                    // we refresh input model as well
                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];                                        
                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];                    
                }                                  

                // we execute the callback function here
                clickedItem = angular.copy( item );                                                    
                if ( clickedItem !== null ) {                        
                    $timeout( function() {
                        delete clickedItem[ $scope.indexProperty ];
                        delete clickedItem[ $scope.spacingProperty ];      
                        $scope.onItemClick( { data: clickedItem } );
                        clickedItem = null;                    
                    }, 0 );                                                 
                }                                    
                
                $scope.refreshOutputModel();
                $scope.refreshButton();                              

                // We update the index here
                prevTabIndex = $scope.tabIndex;
                $scope.tabIndex = ng_repeat_index + helperItemsLength;
                                
                // Set focus on the hidden checkbox 
                e.target.focus();

                // set & remove CSS style
                $scope.removeFocusStyle( prevTabIndex );
                $scope.setFocusStyle( $scope.tabIndex );

                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                    // on single selection mode, we then hide the checkbox layer
                    $scope.toggleCheckboxes( e );       
                }
            }     

            // update $scope.outputModel
            $scope.refreshOutputModel = function() {            
                
                $scope.outputModel  = [];
                var 
                    outputProps     = [],
                    tempObj         = {};

                // v4.0.0
                if ( typeof attrs.outputProperties !== 'undefined' ) {                    
                    outputProps = attrs.outputProperties.split(' ');                
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            tempObj         = {};
                            angular.forEach( value, function( value1, key1 ) {                                
                                if ( outputProps.indexOf( key1 ) > -1 ) {                                                                         
                                    tempObj[ key1 ] = value1;                                    
                                }
                            });
                            var index = $scope.outputModel.push( tempObj );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
                else {
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            var temp = angular.copy( value );
                            var index = $scope.outputModel.push( temp );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
            }

            // refresh button label
            $scope.refreshButton = function() {

                $scope.varButtonLabel   = '';                
                var ctr                 = 0;                  

                // refresh button label...
                if ( $scope.outputModel.length === 0 ) {
                    // https://github.com/isteven/angular-multi-select/pull/19                    
                    $scope.varButtonLabel = $scope.lang.nothingSelected;
                }
                else {                
                    var tempMaxLabels = $scope.outputModel.length;
                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
                        tempMaxLabels = attrs.maxLabels;
                    }

                    // if max amount of labels displayed..
                    if ( $scope.outputModel.length > tempMaxLabels ) {
                        $scope.more = true;
                    }
                    else {
                        $scope.more = false;
                    }                
                    
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {                        
                            if ( ctr < tempMaxLabels ) {                            
                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
                            }
                            ctr++;
                        }
                    });                

                    if ( $scope.more === true ) {
                        // https://github.com/isteven/angular-multi-select/pull/16
                        if (tempMaxLabels > 0) {
                            $scope.varButtonLabel += ', ... ';
                        }
                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';                        
                    }
                }
                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );                
            }

            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
            // Take note that the granular control has higher priority.
            $scope.itemIsDisabled = function( item ) {
                
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return true;
                }
                else {             
                    if ( $scope.isDisabled === true ) {                        
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                
            }

            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
            $scope.writeLabel = function( item, type ) {
                
                // type is either 'itemLabel' or 'buttonLabel'
                var temp    = attrs[ type ].split( ' ' );                    
                var label   = '';                

                angular.forEach( temp, function( value, key ) {                    
                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
                        return prev[ current ]; 
                    }, item ));        
                });
                
                if ( type.toUpperCase() === 'BUTTONLABEL' ) {                    
                    return label;
                }
                return $sce.trustAsHtml( label );
            }                                

            // UI operations to show/hide checkboxes based on click event..
            $scope.toggleCheckboxes = function( e ) {                                    
                
                // We grab the button
                var clickedEl = element.children()[0];

                // Just to make sure.. had a bug where key events were recorded twice
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );        

                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect 
                // His version is awesome if you need a more simple multi-select approach.                                

                // close
                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {                         

                    angular.element( checkBoxLayer ).removeClass( 'show' );                    
                    angular.element( clickedEl ).removeClass( 'buttonClicked' );                    
                    angular.element( document ).off( 'click', $scope.externalClickListener );
                    angular.element( document ).off( 'keydown', $scope.keyboardListener );                                    

                    // clear the focused element;
                    $scope.removeFocusStyle( $scope.tabIndex );
                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
                        formElements[ $scope.tabIndex ].blur();
                    }

                    // close callback
                    $timeout( function() {
                        $scope.onClose();
                    }, 0 );

                    // set focus on button again
                    element.children().children()[ 0 ].focus();
                } 
                // open
                else                 
                {    
                    // clear filter
                    $scope.inputLabel.labelFilter = '';                
                    $scope.updateFilter();                                

                    helperItems = [];
                    helperItemsLength = 0;

                    angular.element( checkBoxLayer ).addClass( 'show' );
                    angular.element( clickedEl ).addClass( 'buttonClicked' );       

                    // Attach change event listener on the input filter. 
                    // We need this because ng-change is apparently not an event listener.                    
                    angular.element( document ).on( 'click', $scope.externalClickListener );
                    angular.element( document ).on( 'keydown', $scope.keyboardListener );  

                    // to get the initial tab index, depending on how many helper elements we have. 
                    // priority is to always focus it on the input filter                                                                
                    $scope.getFormElements();
                    $scope.tabIndex = 0;

                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];                
                    
                    if ( typeof helperContainer !== 'undefined' ) {
                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
                        }
                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
                    }
                    
                    // focus on the filter element on open. 
                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {                        
                        element[ 0 ].querySelector( '.inputFilter' ).focus();    
                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
                        // blur button in vain
                        angular.element( element ).children()[ 0 ].blur();
                    }
                    // if there's no filter then just focus on the first checkbox item
                    else {                  
                        if ( !$scope.isDisabled ) {                        
                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
                            if ( $scope.inputModel.length > 0 ) {
                                formElements[ $scope.tabIndex ].focus();
                                $scope.setFocusStyle( $scope.tabIndex );
                                // blur button in vain
                                angular.element( element ).children()[ 0 ].blur();
                            }                            
                        }
                    }                          

                    // open callback
                    $scope.onOpen();
                }                            
            }
            
            // handle clicks outside the button / multi select layer
            $scope.externalClickListener = function( e ) {                   

                var targetsArr = element.find( e.target.tagName );
                for (var i = 0; i < targetsArr.length; i++) {                                        
                    if ( e.target == targetsArr[i] ) {
                        return;
                    }
                }

                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );                    
                angular.element( checkBoxLayer ).removeClass( 'show' );
                angular.element( document ).off( 'click', $scope.externalClickListener ); 
                angular.element( document ).off( 'keydown', $scope.keyboardListener );                
                
                // close callback                
                $timeout( function() {
                    $scope.onClose();
                }, 0 );

                // set focus on button again
                element.children().children()[ 0 ].focus();
            }
   
            // select All / select None / reset buttons
            $scope.select = function( type, e ) {

                var helperIndex = helperItems.indexOf( e.target );
                $scope.tabIndex = helperIndex;

                switch( type.toUpperCase() ) {
                    case 'ALL':
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                                
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = true;
                                }
                            }
                        });                            
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                  
                        $scope.onSelectAll();                                                
                        break;
                    case 'NONE':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = false;
                                }
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onSelectNone();                        
                        break;
                    
                    case 'DONE':                                                                          
                            $scope.onSelectDone();
                            angular.element( checkBoxLayer ).removeClass( 'show' );                      
                            break;

                    case 'RESET':            
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                var temp = value[ $scope.indexProperty ];                                
                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onReset();                        
                        break;
                    case 'CLEAR':
                        $scope.tabIndex = $scope.tabIndex + 1;
                        $scope.onClear();    
                        break;
                    case 'FILTER':                        
                        $scope.tabIndex = helperItems.length - 1;
                        break;
                    default:                        
                }                                                                                 
            }            

            // just to create a random variable name                
            function genRandomString( length ) {                
                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                var temp        = '';
                for( var i=0; i < length; i++ ) {
                     temp += possible.charAt( Math.floor( Math.random() * possible.length ));
                }
                return temp;
            }

            // count leading spaces
            $scope.prepareGrouping = function() {
                var spacing     = 0;                                                
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.spacingProperty ] = spacing;                    
                    if ( value[ attrs.groupProperty ] === true ) {
                        spacing+=2;
                    }                    
                    else if ( value[ attrs.groupProperty ] === false ) {
                        spacing-=2;
                    }                 
                });
            }

            // prepare original index
            $scope.prepareIndex = function() {
                var ctr = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.indexProperty ] = ctr;
                    ctr++;
                });
            }

            // navigate using up and down arrow
            $scope.keyboardListener = function( e ) { 
                
                var key = e.keyCode ? e.keyCode : e.which;      
                var isNavigationKey = false;                                                

                // ESC key (close)
                if ( key === 27 ) {
                    e.preventDefault();                   
                    e.stopPropagation();
                    $scope.toggleCheckboxes( e );
                }                    
                
                
                // next element ( tab, down & right key )                    
                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {                    
                    
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex++;                         
                    if ( $scope.tabIndex > formElements.length - 1 ) {
                        $scope.tabIndex = 0;
                        prevTabIndex = formElements.length - 1; 
                    }                                                            
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex++;
                        if ( $scope.tabIndex > formElements.length - 1 ) {
                            $scope.tabIndex = 0;                            
                        }                                                                                    
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                    }              
                }
                  
                // prev element ( shift+tab, up & left key )
                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) { 
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex--;                              
                    if ( $scope.tabIndex < 0 ) {
                        $scope.tabIndex = formElements.length - 1;
                        prevTabIndex = 0;
                    }                                         
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {                        
                        $scope.tabIndex--;
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }                                            
                        if ( $scope.tabIndex < 0 ) {
                            $scope.tabIndex = formElements.length - 1;
                        }                             
                    }                                                     
                }                    

                if ( isNavigationKey === true ) {                                         
                    
                    e.preventDefault();

                    // set focus on the checkbox                    
                    formElements[ $scope.tabIndex ].focus();    
                    var actEl = document.activeElement;                     
                    
                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {                                                   
                        $scope.setFocusStyle( $scope.tabIndex );
                        $scope.removeFocusStyle( prevTabIndex );
                    }                    
                    else {
                        $scope.removeFocusStyle( prevTabIndex );
                        $scope.removeFocusStyle( helperItemsLength );
                        $scope.removeFocusStyle( formElements.length - 1 );
                    } 
                }                

                isNavigationKey = false;
            }

            // set (add) CSS style on selected row
            $scope.setFocusStyle = function( tabIndex ) {                                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );                        
            }

            // remove CSS style on selected row
            $scope.removeFocusStyle = function( tabIndex ) {                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
            }

            /*********************
             *********************             
             *
             * 1) Initializations
             *
             *********************
             *********************/

            // attrs to $scope - attrs-$scope - attrs - $scope
            // Copy some properties that will be used on the template. They need to be in the $scope.
            $scope.groupProperty    = attrs.groupProperty;   
            $scope.tickProperty     = attrs.tickProperty;
            $scope.directiveId      = attrs.directiveId;
            
            // Unfortunately I need to add these grouping properties into the input model
            var tempStr = genRandomString( 5 );
            $scope.indexProperty = 'idx_' + tempStr;
            $scope.spacingProperty = 'spc_' + tempStr;         

            // set orientation css            
            if ( typeof attrs.orientation !== 'undefined' ) {

                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {                    
                    $scope.orientationH = true;
                    $scope.orientationV = false;
                }
                else 
                {
                    $scope.orientationH = false;
                    $scope.orientationV = true;
                }
            }            

            // get elements required for DOM operation
            checkBoxLayer = element.children().children().next()[0];

            // set max-height property if provided
            if ( typeof attrs.maxHeight !== 'undefined' ) {                
                var layer = element.children().children().children()[0];
                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );                                
            }

            // some flags for easier checking            
            for ( var property in $scope.helperStatus ) {
                if ( $scope.helperStatus.hasOwnProperty( property )) {                    
                    if ( 
                        typeof attrs.helperElements !== 'undefined' 
                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1 
                    ) {
                        $scope.helperStatus[ property ] = false;
                    }
                }
            }
            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
                $scope.helperStatus[ 'all' ] = false;
                $scope.helperStatus[ 'none' ] = false;
                $scope.helperStatus[ 'done' ] = false;
            }

            // helper button icons.. I guess you can use html tag here if you want to. 
            $scope.icon        = {};            
            $scope.icon.selectAll  = '&#10003;';    // a tick icon
            $scope.icon.selectNone = '&times;';
            $scope.icon.Done = '';     
            $scope.icon.reset      = '&#8630;';     // undo icon            
            // this one is for the selected items
            $scope.icon.tickMark   = '&#10003;';    // a tick icon 

            // configurable button labels                       
            if ( typeof attrs.translation !== 'undefined' ) {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
                $scope.lang.Done      = $sce.trustAsHtml( /* $scope.icon.Done + '&nbsp;&nbsp;' + */ $scope.translation.Done );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
                $scope.lang.search          = $scope.translation.search;                
                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );                
            }
            else {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );                
                $scope.lang.Done      = $sce.trustAsHtml( $scope.icon.Done + '&nbsp;&nbsp;Select Done' );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
                $scope.lang.search          = 'Search...';
                $scope.lang.nothingSelected = 'None Selected';               
            }
            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );
                
            // min length of keyword to trigger the filter function
            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
            }

            /*******************************************************
             *******************************************************
             *
             * 2) Logic starts here, initiated by watch 1 & watch 2
             *
             *******************************************************
             *******************************************************/
            
            // watch1, for changes in input model property
            // updates multi-select when user select/deselect a single checkbox programatically
            // https://github.com/isteven/angular-multi-select/issues/8            
            $scope.$watch( 'inputModel' , function( newVal ) {                                 
                if ( newVal ) {                            
                    $scope.refreshOutputModel();                                    
                    $scope.refreshButton();                                                  
                }
            }, true );
            
            // watch2 for changes in input model as a whole
            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
            $scope.$watch( 'inputModel' , function( newVal ) {  
                if ( newVal ) {
                    $scope.backUp = angular.copy( $scope.inputModel );    
                    $scope.updateFilter();
                    $scope.prepareGrouping();
                    $scope.prepareIndex();                                                              
                    $scope.refreshOutputModel();                
                    $scope.refreshButton();                                                                                                                 
                }
            });                        

            // watch for changes in directive state (disabled or enabled)
            $scope.$watch( 'isDisabled' , function( newVal ) {         
                $scope.isDisabled = newVal;                               
            });            
            
            // this is for touch enabled devices. We don't want to hide checkboxes on scroll. 
            var onTouchStart = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = false;
            	}); 
            };
            angular.element( document ).bind( 'touchstart', onTouchStart);
            var onTouchMove = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = true;                
            	});
            };
            angular.element( document ).bind( 'touchmove', onTouchMove);            

            // unbind document events to prevent memory leaks
            $scope.$on( '$destroy', function () {
			    angular.element( document ).unbind( 'touchstart', onTouchStart);
            	angular.element( document ).unbind( 'touchmove', onTouchMove);
            });
        }
    }
}]).run( [ '$templateCache' , function( $templateCache ) {
    var template = 
        '<span class="multiSelect inlineBlock">' +
            // main button
            '<button id="{{directiveId}}" type="button"' +                
                'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
                'ng-bind-html="varButtonLabel"' +
                'ng-disabled="disable-button"' +
            '>' +
            '</button>' +
            // overlay layer
            '<div class="checkboxLayer">' +
                // container of the helper elements
                '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none ||  helperStatus.done || helperStatus.reset ">' +
                    // container of the first 3 buttons, select all, none and reset
                    '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.done || helperStatus.reset ">' +
                        // select all
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.all"' +
                            'ng-click="select( \'all\', $event );"' +
                            'ng-bind-html="lang.selectAll">' +
                        '</button>'+
                        // select none
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.none"' +
                            'ng-click="select( \'none\', $event );"' +
                            'ng-bind-html="lang.selectNone">' +
                        '</button>'+
                            //done
                        '<button type="button" class="pull-right doneFilter helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.done"' +
                            'ng-click="select( \'done\', $event );"' +
                            'ng-bind-html="lang.Done">' +
                        '</button>'+

                        // reset
                        '<button type="button" class="helperButton reset"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.reset"' +
                            'ng-click="select( \'reset\', $event );"' +
                            'ng-bind-html="lang.reset">'+
                        '</button>' +
                    '</div>' +
                    // the search box
                    '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
                        // textfield                
                        '<input placeholder="{{lang.search}}" type="text"' +
                            'ng-click="select( \'filter\', $event )" '+
                            'ng-model="inputLabel.labelFilter" '+
                            'ng-change="searchChanged()" class="inputFilter"'+
                            '/>'+
                        // clear button
                        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
                    '</div> '+
                '</div> '+
                // selection items
                '<div class="checkBoxContainer">'+
                    '<div '+
                        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
                        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
                        'ng-click="syncItems( item, $event, $index );" '+
                        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
                        // this is the spacing for grouped items
                        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+                        
                    '</div>  '+        
                    '<div class="acol">'+
                        '<label>'+                                
                            // input, so that it can accept focus on keyboard click
                            '<input class="checkbox focusable" type="checkbox" '+
                                'ng-disabled="itemIsDisabled( item )" '+
                                'ng-checked="item[ tickProperty ]" '+
                                'ng-click="syncItems( item, $event, $index )" />'+
                            // item label using ng-bind-hteml
                            '<span '+
                                'ng-class="{disabled:itemIsDisabled( item )}" '+
                                'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
                            '</span>'+
                        '</label>'+
                    '</div>'+
                    // the tick/check mark
                    '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</span>';
	$templateCache.put( 'isteven-multi-select.htm' , template );
}]); 

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'app',
            url: '/login',
            data: {
                authorities: [],
                pageTitle: 'login.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/login/login.html',
                    controller: 'LoginControllers',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LoginControllers', LoginControllers);

    LoginControllers.$inject = ['$rootScope', '$state', '$timeout', 'Auth', 'Principal'];

    function LoginControllers($rootScope, $state, $timeout, Auth, Principal) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.appName = $rootScope.APP_NAME;
        $timeout(function () { angular.element('#username').focus(); });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            //  $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $rootScope.has_ROLE_SUPER_ADMIN = false;
                $rootScope.has_ROLE_USER_ADMIN = false;
                $rootScope.has_ROLE_USER = false;
                $rootScope.has_ROLE_VENDOR_ADMIN = false;
                $rootScope.has_ROLE_HOD = false;
                $rootScope.has_ROLE_CITY_MANAGER = false;
                $rootScope.has_ROLE_CITY_PLANNER = false;
                $rootScope.has_ROLE_ASSISTANT_MANAGER = false;
                $rootScope.has_ROLE_TEAM_LEADER = false;
                $rootScope.has_ROLE_NETWORK_ENGINEER = false;
                $rootScope.has_ROLE_FRT = false;
                $rootScope.has_ROLE_PATROLLER = false;

                $rootScope.has_ROLE_ROLLOUT_SURVEY = false;
                $rootScope.has_ROLE_ROLLOUT_INFRA = false;
                $rootScope.has_ROLE_ROLLOUT_ADMIN = false;
                $rootScope.has_ROLE_PLAN_SURVEY = false;
                $rootScope.has_ROLE_PLAN_INFRA = false;
                $rootScope.has_ROLE_PLAN_ADMIN = false;

                $rootScope.has_ROLE_ROLLOUT_FE = false;
                $rootScope.has_ROLE_ROLLOUT_VENDOR = false;
                $rootScope.has_ROLE_ROLLOUT_MANAGER =  false

                $rootScope.has_ROLE_BA = false;
                $rootScope.has_ROLE_OA = false;
                $rootScope.has_ROLE_FE = false;

                $rootScope.has_ROLE_READONLY = false;

                Principal.identity().then(function (identity) {
                    if (identity && identity.authorities && identity.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1) {
                        $rootScope.has_ROLE_SUPER_ADMIN = true;
                        $state.go('tenant');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_USER_ADMIN') !== -1) {
                        $rootScope.has_ROLE_USER_ADMIN = true;
                        $state.go('incident-dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_VENDOR') !== -1) {
                        $rootScope.has_ROLE_VENDOR = true;
                        $state.go('incident-dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_HOD') !== -1) {
                        $rootScope.has_ROLE_HOD = true;
                        $state.go('incident-dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_CITY_MANAGER') !== -1) {
                        $rootScope.has_ROLE_CITY_MANAGER = true;
                        $state.go('incident-dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_BA') !== -1) {
                        $rootScope.has_ROLE_BA = true;
                        $state.go('incident-dashboard');                        
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_CITY_PLANNER') !== -1) {
                        $rootScope.has_ROLE_CITY_PLANNER = true;
                        $state.go('incident-dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ASSISTANT_MANAGER') !== -1) {
                        $rootScope.has_ROLE_ASSISTANT_MANAGER = true;
                        $state.go('incident-dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_OA') !== -1) {
                        $rootScope.has_ROLE_OA = true;
                        $state.go('incident-dashboard');    
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_TEAM_LEADER') !== -1) {
                        $rootScope.has_ROLE_TEAM_LEADER = true;
                        $state.go('incident-dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_NETWORK_ENGINEER') !== -1) {
                        $rootScope.has_ROLE_NETWORK_ENGINEER = true;
                        $state.go('incident-dashboard');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_FE') !== -1) {
                        $rootScope.has_ROLE_FE = true;
                        $state.go('incident-dashboard');                            
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_READONLY') !== -1) {
                        $rootScope.has_ROLE_READONLY = true;
                        $state.go('incident-dashboard');                 
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_FRT') !== -1) {
                        $rootScope.has_ROLE_FRT = true;
                        $state.go('tr-case');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_PATROLLER') !== -1) {
                        $rootScope.has_ROLE_PATROLLER = true;
                        $state.go('tr-case');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_USER') !== -1) {
                        $rootScope.has_ROLE_USER = true;
                        // $state.go('location-log');
                        $state.go('tr-case');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ROLLOUT_SURVEY') !== -1) {
                        $rootScope.has_ROLE_ROLLOUT_SURVEY = true;
                        $state.go('work-flow');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ROLLOUT_ADMIN') !== -1) {
                        $rootScope.has_ROLE_ROLLOUT_ADMIN = true;
                        $state.go('tr-project');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ROLLOUT_MANAGER') !== -1) {
                        $rootScope.has_ROLE_ROLLOUT_MANAGER = true;
                        $state.go('tr-project');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_ROLLOUT_INFRA') !== -1) {
                        $rootScope.has_ROLE_ROLLOUT_INFRA = true;
                        $state.go('work-flow');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_PLAN_SURVEY') !== -1) {
                        $rootScope.has_ROLE_PLAN_SURVEY = true;
                        $state.go('work-order');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_PLAN_INFRA') !== -1) {
                        $rootScope.has_ROLE_PLAN_INFRA = true;
                        $state.go('work-order');
                    }  if (identity && identity.authorities && identity.authorities.indexOf('ROLE_PLAN_ADMIN') !== -1) {
                        $rootScope.has_ROLE_PLAN_ADMIN = true;
                        $state.go('tr-project');
                        //$state.go('work-order');
                    }

                    if (
                        identity &&
                        identity.authorities &&
                        identity.authorities.indexOf("ROLE_ROLLOUT_FE") !== -1
                    ) {
                        
                        $state.go('tr-project');
                        $rootScope.has_ROLE_ROLLOUT_FE = true
                    }
                  /* if (
                        identity &&
                        identity.authorities &&
                        identity.authorities.indexOf("ROLE_ROLLOUT_MANAGER") !== -1
                    ) {
                        
                        $state.go('tr-project');
                    } */ 
                    if (
                        identity &&
                        identity.authorities &&
                        identity.authorities.indexOf("ROLE_ROLLOUT_VENDOR") !== -1
                    ) {
                        $rootScope.has_ROLE_ROLLOUT_VENDOR = true
                        $state.go('tr-task');
                    }

                    if (
                        identity &&
                        identity.authorities &&
                        identity.authorities.indexOf("ROLE_VENDOR_ADMIN") !== -1
                    ) {
                        $rootScope.has_ROLE_VENDOR_ADMIN = true;
                        $state.go('tr-workorder');
                    }

                    if (identity) {
                        $rootScope.userName = identity.login;
                        $rootScope.image = identity.userImage;
                    }
                });

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState

                ///////////////////No use with this code ///////////////////
                /*if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }*/
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register() {
            //$uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword() {
            //$uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'de',
            'hi',
            'ja'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                         if (!inputName || !formCtrl[inputName]) {
                            return;
                        }
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

     var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    }; 
    /* var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Something went wrong.</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    }; */

    angular
        .module('trakeyeApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('trakeyeApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-trakeyeApp-error');
                var entityKey = httpResponse.headers('X-trakeyeApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('trakeyeApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('trakeyeApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-trakeyeApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-trakeyeApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('trakeyeApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];
   
   
    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

/*! AdminLTE app.js
 * ================
 * Main JS application file for AdminLTE v2. This file
 * should be included in all pages. It controls some layout
 * options and implements exclusive AdminLTE plugins.
 *
 * @Author  Almsaeed Studio
 * @Support <http://www.almsaeedstudio.com>
 * @Email   <abdullah@almsaeedstudio.com>
 * @version 2.3.6
 * @license MIT <http://opensource.org/licenses/MIT>
 */
function _init() {
    "use strict";
	$("#map_canvas").height($(window).height());
	$(window).resize(function() {
			if ($(window).height() <= 250){
				$("#map_canvas").height($(window).height()+250);
			}
			else{							
				$("#map_canvas").height($(window).height()-262);
			}
		});
 		$(window).trigger('resize');
	
    $.AdminLTE.layout = {
        activate: function() {
            var a = this;
            a.fix(), a.fixSidebar(), $(window, ".wrapper").resize(function() {
                a.fix(), a.fixSidebar()
            })
        },
        fix: function() { /*var a=$(".main-header").outerHeight()+$(".main-footer").outerHeight(),*/
            var a = 102,
                b = $(window).height(),
                c = $(".sidebar").height();
            if ($("body").hasClass("fixed")) $(".content-wrapper, .right-side").css("min-height", b - $(".main-footer").outerHeight());
            else {
                var d;
                b >= c ? ($(".content-wrapper, .right-side").css("min-height", b - a), d = b - a) : ($(".content-wrapper, .right-side").css("min-height", c), d = c);
                var e = $($.AdminLTE.options.controlSidebarOptions.selector);
                "undefined" != typeof e && e.height() > d && $(".content-wrapper, .right-side").css("min-height", e.height())
            }
        },
        fixSidebar: function() {
            return $("body").hasClass("fixed") ? ("undefined" == typeof $.fn.slimScroll && window.console && window.console.error("Error: the fixed layout requires the slimscroll plugin!"), void($.AdminLTE.options.sidebarSlimScroll && "undefined" != typeof $.fn.slimScroll && ($(".sidebar").slimScroll({
                destroy: !0
            }).height("auto"), $(".sidebar").slimscroll({
                height: $(window).height() - $(".main-header").height() + "px",
                color: "rgba(0,0,0,0.2)",
                size: "3px"
            })))) : void("undefined" != typeof $.fn.slimScroll && $(".sidebar").slimScroll({
                destroy: !0
            }).height("auto"))
        }
    }, $.AdminLTE.pushMenu = {
        activate: function(a) {
            var b = $.AdminLTE.options.screenSizes;
            $(document).on("click", a, function(a) {
                a.preventDefault(), $(window).width() > b.sm - 1 ? $("body").hasClass("sidebar-collapse") ? $("body").removeClass("sidebar-collapse").trigger("expanded.pushMenu") : $("body").addClass("sidebar-collapse").trigger("collapsed.pushMenu") : $("body").hasClass("sidebar-open") ? $("body").removeClass("sidebar-open").removeClass("sidebar-collapse").trigger("collapsed.pushMenu") : $("body").addClass("sidebar-open").trigger("expanded.pushMenu")
            }), $(".content-wrapper").click(function() {
                $(window).width() <= b.sm - 1 && $("body").hasClass("sidebar-open") && $("body").removeClass("sidebar-open")
            }), ($.AdminLTE.options.sidebarExpandOnHover || $("body").hasClass("fixed") && $("body").hasClass("sidebar-mini")) && this.expandOnHover()
        },
        expandOnHover: function() {
            var a = this,
                b = $.AdminLTE.options.screenSizes.sm - 1;
            $(".main-sidebar").hover(function() {
                $("body").hasClass("sidebar-mini") && $("body").hasClass("sidebar-collapse") && $(window).width() > b && a.expand()
            }, function() {
                $("body").hasClass("sidebar-mini") && $("body").hasClass("sidebar-expanded-on-hover") && $(window).width() > b && a.collapse()
            })
        },
        expand: function() {
            $("body").removeClass("sidebar-collapse").addClass("sidebar-expanded-on-hover")
        },
        collapse: function() {
            $("body").hasClass("sidebar-expanded-on-hover") && $("body").removeClass("sidebar-expanded-on-hover").addClass("sidebar-collapse")
        }
    }, $.AdminLTE.tree = function(a) {
        var b = this,
            c = $.AdminLTE.options.animationSpeed;
        $(document).off("click", a + " li a").on("click", a + " li a", function(a) {
            var d = $(this),
                e = d.next();
            if (e.is(".treeview-menu") && e.is(":visible") && !$("body").hasClass("sidebar-collapse")) e.slideUp(c, function() {
                d.children('.pull-right-container').children('.rotate').removeClass('down')
                d.children('.pull-right-container').children('.fa-plus').removeClass('fa-minus')
                e.removeClass("menu-open")
                var t = e.children('li').children('a').next()
                t.removeClass("menu-open")
                t.css({'display':'none'});
            }), e.parent("li").removeClass("active");
            else if (e.is(".treeview-menu") && !e.is(":visible")) {
                var f = d.parents("ul").first(),
                    g = f.find("ul:visible").slideUp(c);
                g.removeClass("menu-open");
                var t = e.children('li').children('a').next()
                t.removeClass("menu-open")
                t.css({'display':'none'});
                d.children('.pull-right-container').children('.rotate').removeClass('down')
                d.children('.pull-right-container').children('.fa-plus').removeClass('fa-minus')
                var h = d.parent("li");
                e.slideDown(c, function() {
                    d.children('.pull-right-container').children('.rotate').addClass('down'),d.children('.pull-right-container').children('.fa-plus').addClass('fa-minus'), e.addClass("menu-open"), f.find("li.active").removeClass("active"), h.addClass("active"), b.layout.fix()
                })
            }
            e.is(".treeview-menu") && a.preventDefault()
        })
    }, $.AdminLTE.controlSidebar = {
        activate: function() {
            var a = this,
                b = $.AdminLTE.options.controlSidebarOptions,
                c = $(b.selector),
                d = $(b.toggleBtnSelector);
            d.on("click", function(d) {
                d.preventDefault(), c.hasClass("control-sidebar-open") || $("body").hasClass("control-sidebar-open") ? a.close(c, b.slide) : a.open(c, b.slide)
            });
            var e = $(".control-sidebar-bg");
            a._fix(e), $("body").hasClass("fixed") ? a._fixForFixed(c) : $(".content-wrapper, .right-side").height() < c.height() && a._fixForContent(c)
        },
        open: function(a, b) {
            b ? a.addClass("control-sidebar-open") : $("body").addClass("control-sidebar-open")
        },
        close: function(a, b) {
            b ? a.removeClass("control-sidebar-open") : $("body").removeClass("control-sidebar-open")
        },
        _fix: function(a) {
            var b = this;
            if ($("body").hasClass("layout-boxed")) {
                if (a.css("position", "absolute"), a.height($(".wrapper").height()), b.hasBindedResize) return;
                $(window).resize(function() {
                    b._fix(a)
                }), b.hasBindedResize = !0
            } else a.css({
                position: "fixed",
                height: "auto"
            })
        },
        _fixForFixed: function(a) {
            a.css({
                position: "fixed",
                "max-height": "100%",
                overflow: "auto",
                "padding-bottom": "50px"
            })
        },
        _fixForContent: function(a) {
            $(".content-wrapper, .right-side").css("min-height", a.height())
        }
    }, $.AdminLTE.boxWidget = {
        selectors: $.AdminLTE.options.boxWidgetOptions.boxWidgetSelectors,
        icons: $.AdminLTE.options.boxWidgetOptions.boxWidgetIcons,
        animationSpeed: $.AdminLTE.options.animationSpeed,
        activate: function(a) {
            var b = this;
            a || (a = document), $(a).on("click", b.selectors.collapse, function(a) {
                a.preventDefault(), b.collapse($(this))
            }), $(a).on("click", b.selectors.remove, function(a) {
                a.preventDefault(), b.remove($(this))
            })
        },
        collapse: function(a) {
            var b = this,
                c = a.parents(".box").first(),
                d = c.find("> .box-body, > .box-footer, > form  >.box-body, > form > .box-footer");
            c.hasClass("collapsed-box") ? (a.children(":first").removeClass(b.icons.open).addClass(b.icons.collapse), d.slideDown(b.animationSpeed, function() {
                c.removeClass("collapsed-box")
            })) : (a.children(":first").removeClass(b.icons.collapse).addClass(b.icons.open), d.slideUp(b.animationSpeed, function() {
                c.addClass("collapsed-box")
            }))
        },
        remove: function(a) {
            var b = a.parents(".box").first();
            b.slideUp(this.animationSpeed)
        }
    }
}
if ("undefined" == typeof jQuery) throw new Error("AdminLTE requires jQuery");
$.AdminLTE = {}, $.AdminLTE.options = {
        navbarMenuSlimscroll: !0,
        navbarMenuSlimscrollWidth: "3px",
        navbarMenuHeight: "200px",
        animationSpeed: 500,
        sidebarToggleSelector: "[data-toggle='offcanvas']",
        sidebarPushMenu: !0,
        sidebarSlimScroll: !0,
        sidebarExpandOnHover: !1,
        enableBoxRefresh: !0,
        enableBSToppltip: !0,
        BSTooltipSelector: "[data-toggle='tooltip']",
        enableFastclick: !1,
        enableControlSidebar: !0,
        controlSidebarOptions: {
            toggleBtnSelector: "[data-toggle='control-sidebar']",
            selector: ".control-sidebar",
            slide: !0
        },
        enableBoxWidget: !0,
        boxWidgetOptions: {
            boxWidgetIcons: {
                collapse: "fa-minus",
                open: "fa-plus",
                remove: "fa-times"
            },
            boxWidgetSelectors: {
                remove: '[data-widget="remove"]',
                collapse: '[data-widget="collapse"]'
            }
        },
        directChat: {
            enable: !0,
            contactToggleSelector: '[data-widget="chat-pane-toggle"]'
        },
        colors: {
            lightBlue: "#3c8dbc",
            red: "#f56954",
            green: "#00a65a",
            aqua: "#00c0ef",
            yellow: "#f39c12",
            blue: "#0073b7",
            navy: "#001F3F",
            teal: "#39CCCC",
            olive: "#3D9970",
            lime: "#01FF70",
            orange: "#FF851B",
            fuchsia: "#F012BE",
            purple: "#8E24AA",
            maroon: "#D81B60",
            black: "#222222",
            gray: "#d2d6de"
        },
        screenSizes: {
            xs: 480,
            sm: 768,
            md: 992,
            lg: 1200
        }
    }, $(function() {
        "use strict";
        $("body").removeClass("hold-transition"), "undefined" != typeof AdminLTEOptions && $.extend(!0, $.AdminLTE.options, AdminLTEOptions);
        var a = $.AdminLTE.options;
        _init(), $.AdminLTE.layout.activate(), $.AdminLTE.tree(".sidebar"), a.enableControlSidebar && $.AdminLTE.controlSidebar.activate(), a.navbarMenuSlimscroll && "undefined" != typeof $.fn.slimscroll && $(".navbar .menu").slimscroll({
            height: a.navbarMenuHeight,
            alwaysVisible: !1,
            size: a.navbarMenuSlimscrollWidth
        }).css("width", "100%"), a.sidebarPushMenu && $.AdminLTE.pushMenu.activate(a.sidebarToggleSelector), a.enableBSToppltip && $("body").tooltip({
            selector: a.BSTooltipSelector
        }), a.enableBoxWidget && $.AdminLTE.boxWidget.activate(), a.enableFastclick && "undefined" != typeof FastClick && FastClick.attach(document.body), a.directChat.enable && $(document).on("click", a.directChat.contactToggleSelector, function() {
            var a = $(this).parents(".direct-chat").first();
            a.toggleClass("direct-chat-contacts-open")
        }), $('.btn-group[data-toggle="btn-toggle"]').each(function() {
            var a = $(this);
            $(this).find(".btn").on("click", function(b) {
                a.find(".btn.active").removeClass("active"), $(this).addClass("active"), b.preventDefault()
            })
        })
    }),
    function(a) {
        "use strict";
        a.fn.boxRefresh = function(b) {
            function c(a) {
                a.append(f), e.onLoadStart.call(a)
            }

            function d(a) {
                a.find(f).remove(), e.onLoadDone.call(a)
            }
            var e = a.extend({
                    trigger: ".refresh-btn",
                    source: "",
                    onLoadStart: function(a) {
                        return a
                    },
                    onLoadDone: function(a) {
                        return a
                    }
                }, b),
                f = a('<div class="overlay"><div class="fa fa-refresh fa-spin"></div></div>');
            return this.each(function() {
                if ("" === e.source) return void(window.console && window.console.log("Please specify a source first - boxRefresh()"));
                var b = a(this),
                    f = b.find(e.trigger).first();
                f.on("click", function(a) {
                    a.preventDefault(), c(b), b.find(".box-body").load(e.source, function() {
                        d(b)
                    })
                })
            })
        }
    }(jQuery),
    function(a) {
        "use strict";
        a.fn.activateBox = function() {
            a.AdminLTE.boxWidget.activate(this)
        }, a.fn.toggleBox = function() {
            var b = a(a.AdminLTE.boxWidget.selectors.collapse, this);
            a.AdminLTE.boxWidget.collapse(b)
        }, a.fn.removeBox = function() {
            var b = a(a.AdminLTE.boxWidget.selectors.remove, this);
            a.AdminLTE.boxWidget.remove(b)
        }
    }(jQuery),
    function(a) {
        "use strict";
        a.fn.todolist = function(b) {
            var c = a.extend({
                onCheck: function(a) {
                    return a
                },
                onUncheck: function(a) {
                    return a
                }
            }, b);
            return this.each(function() {
                "undefined" != typeof a.fn.iCheck ? (a("input", this).on("ifChecked", function() {
                    var b = a(this).parents("li").first();
                    b.toggleClass("done"), c.onCheck.call(b)
                }), a("input", this).on("ifUnchecked", function() {
                    var b = a(this).parents("li").first();
                    b.toggleClass("done"), c.onUncheck.call(b)
                })) : a("input", this).on("change", function() {
                    var b = a(this).parents("li").first();
                    b.toggleClass("done"), a("input", b).is(":checked") ? c.onCheck.call(b) : c.onUncheck.call(b)
                })
            })
        }
    }(jQuery);
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('trakeyeApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').controller('VehicleManagementDialogController', VehicleManagementDialogController);

    VehicleManagementDialogController.$inject = ['$rootScope', '$scope', '$state', 'entity', 'Vehicle', 'JhiLanguageService', 'Principal', 'ReportingNeUsers'
    ];

    function VehicleManagementDialogController($rootScope, $scope, $state, entity, Vehicle, JhiLanguageService, Principal, ReportingNeUsers) {
        $scope.IMEI_REGEXP = /^[0-9]+$/;
        var vm = this;

        vm.languages = null;
        vm.save = save;
        vm.vehicle = entity;
        vm.multiUser = [];
        var selectedUsers = [];
        vm.selectedUserId = [];

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        if(vm.vehicle.attachedTo != null){
            selectedUsers = vm.vehicle.attachedTo;
        }

        ReportingNeUsers.getAll(function (response) {
            response.forEach(function (user) {
                // if (user.authorities.includes("ROLE_NETWORK_ENGINEER")) {
                    if (selectedUsers == user.id) {
                        vm.multiUser.push({ login: user.login, id: user.id, ticked: true });
                    } else {
                        vm.multiUser.push({ login: user.login, id: user.id, ticked: false });
                    }
                // }
            });
        });

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go('vehicle-management');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.selectedUserId.forEach(function(user){
                vm.vehicle.attachedTo = user.id;
            });
            vm.isSaving = true;
            if (vm.vehicle.id !== null) {
                Vehicle.update(vm.vehicle, onSaveSuccess, onSaveError);
            } else {
                Vehicle.save(vm.vehicle, onSaveSuccess, onSaveError);
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('VehicleManagementDetailController', VehicleManagementDetailController);

    VehicleManagementDetailController.$inject = ['$stateParams', 'Vehicle'];

    function VehicleManagementDetailController($stateParams, Vehicle) {
        var vm = this;

        vm.load = load;
        vm.vehicle = {};

        vm.load($stateParams.id);

        function load(id) {
            Vehicle.get({ id: id }, function (result) {
                vm.vehicle = result;
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('vehicle-management', {
            parent: 'admin',
            url: '/vehicle-management',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER'],
                pageTitle: 'vehicleManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/vehicle-management/vehicle-management.html',
                    controller: 'VehicleManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehicle-management');
                    return $translate.refresh();
                }]

            }
        })

            .state('vehicle-management-detail', {
                parent: 'admin',
                url: '/vehicles/:id',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'vehicle-management.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/vehicle-management/vehicle-management-detail.html',
                        controller: 'VehicleManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('vehicle-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('vehicle-management.new', {
                parent: 'vehicle-management',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/vehicle-management/vehicle-management-dialog.html',
                        controller: 'VehicleManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            "id": null,
                            "status": null,
                            "vehicleType": null,
                            "licensePlate": null,
                            "gpsimei": null,
                            "createdDate": null,
                            "lastModifiedBy": null,
                            "lastModifiedDate": null
                        };
                    }
                }

            })

            .state('vehicle-management.edit', {
                parent: 'vehicle-management',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/vehicle-management/vehicle-management-dialog.html',
                        controller: 'VehicleManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('vehicle-management');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Vehicle', function ($stateParams, Vehicle) {
                        return Vehicle.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('Vehicle', Vehicle);

    Vehicle.$inject = ['$resource'];

    function Vehicle($resource) {
        var service = $resource('api/vehicles/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });

        return service;
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('VehicleValueSearch', VehicleValueSearch);

	VehicleValueSearch.$inject = ['$resource'];

	function VehicleValueSearch($resource) {
		var service = $resource('/api/vehicles/searchvalue/:search', {}, {}, {
			'query': {
				method: 'GET',
				isArray: true
			},
		});

		return service;
	}
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('VehicleManagementController', VehicleManagementController);

    VehicleManagementController.$inject = ['$scope', 'Principal', 'Vehicle', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'UserValueSearch', 'UsersStatusService', '$stateParams', 'VehicleValueSearch', 'UsersHierarchy', 'UserAccount', 'GeofenceIDs', 'UserGeofences'];

    function VehicleManagementController($scope, Principal, Vehicle, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, UserValueSearch, UsersStatusService, $stateParams, VehicleValueSearch, UsersHierarchy, UserAccount, GeofenceIDs, UserGeofences) {
        var vm = this;
        $scope.search = pagingParams.search;
        vm.authorities = ['ROLE_USER', 'ROLE_USER_ADMIN', 'ROLE_VENDOR_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.vehicles = [];
        vm.vehiclesList = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.filterSearch = filterSearch;
        $scope.tab = 1;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;

            if ($scope.tab == 1) {
                filterSearch();
            }
        };

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });


        if ($scope.search === null || $scope.search === "" || angular.isUndefined($scope.search)) {
            loadAll();
        } else {
            filterSearch();
        }

        function filterSearch() {

            if ($scope.search != null && $scope.search != "" && !angular.isUndefined($scope.search)) {

                VehicleValueSearch.query({
                    search: $scope.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);

            } else {
                loadAll();
            }
        }



        function loadAll() {

            if ($stateParams.status == undefined) {
                Vehicle.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
        }

        function onSuccess(data, headers) {
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.vehicles = data;

        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.vehicle = {
                "id": null,
                "status": null,
                "vehicleType": null,
                "licensePlate": null,
                "gpsimei": null,
                "createdDate": null,
                "lastModifiedBy": null,
                "lastModifiedDate": null
            };
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                // result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: $scope.search,
                status: pagingParams.status
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$rootScope', '$scope', '$stateParams', '$state', 'entity', 'User', 'JhiLanguageService', 'UserGroupIDs', 'Geofence', 'TrakeyeType', 'AllTrakeyeTypes', 'GeofenceMasterMiniIDs',
        'UserIDs', 'Principal', 'ReportingUsers', 'Vendors','Configs','UserAccount', 'AllVendorIds'
    ];

    function UserManagementDialogController($rootScope, $scope, $stateParams, $state, entity, User, JhiLanguageService, UserGroupIDs, Geofence, TrakeyeType, AllTrakeyeTypes, GeofenceMasterMiniIDs, UserIDs, Principal, ReportingUsers, Vendors, Configs,UserAccount, AllVendorIds) {
        $scope.EMAIL_REGEXP = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
        $scope.PHONE_REGEXP = /^[0-9]+$/;
        $scope.IMEI_REGEXP = /^[0-9]+$/;
        $scope.IMAGE_EXT_REGEXP = /^(.*?)\.(jpg||jpeg||png)$/;
        var vm = this;

        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.decodeImage = decodeImage;
        $scope.hasDeviceInfo = false;
		vm.isMobileDeviceTracking = false;
        if(vm.user.hasDeviceInfo){
            $scope.hasDeviceInfo = true;
        }
        /* var userAdminAuthorities = ['ROLE_USER_ADMIN', 'ROLE_USER', 'ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_FE','ROLE_FE','ROLE_NETWORK_ENGINEER',
            'ROLE_FRT', 'ROLE_PATROLLER', 'ROLE_VENDOR'
        ];
        var hodAuthorities = ['ROLE_CITY_MANAGER', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'];
        var cityManagerAuthorities = ['ROLE_ASSISTANT_MANAGER', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'];
        var assistantManagerAuthorities = ['ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'];
        var teamLeaderAuthorities = ['ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'];  */

        vm.navigateGeofence = navigateGeofence
        vm.navigateGroupfromUserMng = navigateGroupfromUserMng;
        vm.navigateFiberifyTypefromGroup = navigateFiberifyTypefromGroup;

        $scope.allimages = false;
        $(":file").filestyle({
            buttonBefore: true
        });
        $(":file").filestyle('buttonText', 'Browse File');

        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;

        };

        $("#userImage").change(function () {
            var filesSelected = document.getElementById("userImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();

                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.user.userImage = test;
                }
                fileReader.readAsBinaryString(filesSelected[i]);
            }

        });

        var entity_old = angular.copy(vm.user)
        Principal.identity().then(function (identity) {
            /*
             * if(identity.authorities &&
             * identity.authorities.indexOf('ROLE_SUPER_ADMIN') !==- 1){
             * vm.authorities = ['ROLE_USER_ADMIN'];
             * 
             * }else if(identity.authorities &&
             * identity.authorities.indexOf('ROLE_USER_ADMIN') !==- 1){
             */
            /* vm.authorities = [
                //'ROLE_USER', 
                'ROLE_USER_ADMIN',
                //'ROLE_VENDOR_ADMIN',
                'ROLE_USER',
                'ROLE_CITY_MANAGER',
                'ROLE_CITY_PLANNER',
                'ROLE_ASSISTANT_MANAGER',
                'ROLE_TEAM_LEADER',
                'ROLE_FE','ROLE_NETWORK_ENGINEER',
                'ROLE_FRT',
                'ROLE_PATROLLER'
            ]; */

            /* if ($rootScope.has_ROLE_USER_ADMIN) {
                vm.authorities = userAdminAuthorities;
            } else if ($rootScope.has_ROLE_USER) {
                vm.authorities = hodAuthorities;
            } else if ($rootScope.has_ROLE_CITY_MANAGER || $rootScope.has_ROLE_CITY_PLANNER) {
                vm.authorities = cityManagerAuthorities;
            } else if ($rootScope.has_ROLE_ASSISTANT_MANAGER) {
                vm.authorities = assistantManagerAuthorities;
            } else if ($rootScope.has_ROLE_TEAM_LEADER) {
                vm.authorities = teamLeaderAuthorities;
            } */

            Configs.get("Roles",function(response){
                vm.authorities = response
            })


            vm.selectattributes = selectedTrakeyeTypeAttributes;
            vm.geofences = loadAllGeofences(); // Geofence.query();
            vm.trakeyeTypes = loadAllTrakeyeTypes(); // TrakeyeType.query();

            // }
            if (vm.user.id == null) {
                vm.user.langKey = 'en';
                // vm.user.authorities=vm.authorities;
                vm.user.fromTime = 8;
                vm.user.toTime = 20;

            }

        });

        function loadAllTrakeyeTypes() {
            AllTrakeyeTypes.getAll(function (response) {
                vm.trakeyeTypes = response;
            });

        }

        function loadAllGeofences() {

            vm.multiGeofence = [];
            vm.multiVendorEntity = [];
            var selectedVendorEntity = [];
            vm.multiGroup = [];
            var selectedGeofence = [];
            var selectedGroup = [];
            vm.multiUser = [];
            vm.multiVendor = [];
            var selectedUsers = [];
            var selectedVendors = [];

            if (vm.user.id != null) {
                vm.user.geofences.forEach(function (geofence) {
                    selectedGeofence.push(geofence);
                });
                vm.user.vendor.forEach(function(vendor){
                    selectedVendorEntity.push(vendor.id);
                });

                vm.user.groups.forEach(function (group) {
                    selectedGroup.push(group.id);
                });

                vm.user.ownedBy.forEach(function (user) {
                    selectedUsers.push(user.id);
                });

                if (vm.user.vendors != null) {
                    vm.user.vendors.forEach(function (user) {
                        selectedVendors.push(user.id);
                    });
                }

                if (selectedUsers.length === 0) {
                    selectedUsers.push(vm.user.id);
                }

            } else {

                Principal.identity().then(function (identity) {
                    selectedUsers.push(identity.id);
                });
            }

            GeofenceMasterMiniIDs.getAll(function (response) {
                response.forEach(function (geofence) {
                    // var zone = "MINI";

                    // if (geofence.zone == true) {
                    //     zone = "MASTER";
                    // }

                    if (selectedGeofence.indexOf(geofence.id) !== -1) {
                        vm.multiGeofence.push({ name: geofence.name, id: geofence.id, nameZone: geofence.name + " - " + geofence.geofenceType, ticked: true });
                    } else {
                        vm.multiGeofence.push({ name: geofence.name, id: geofence.id, nameZone: geofence.name + " - " + geofence.geofenceType, ticked: false });
                    }
                });
            });

            UserGroupIDs.getAll(function (response) {
                response.forEach(function (group) {
                    if (selectedGroup.indexOf(group.id) !== -1) {
                        vm.multiGroup.push({ name: group.name, id: group.id, ticked: true });
                    } else {
                        vm.multiGroup.push({ name: group.name, id: group.id, ticked: false });
                    }
                });

                if (selectedGroup.length === 0) {
                    var tempGroups = [];
                    vm.multiGroup.forEach(function (groupVal) {
                        if (groupVal.name === "Default Group") {
                            groupVal.ticked = true;
                        }
                        tempGroups.push(groupVal);
                    });
                    vm.multiGroup = tempGroups;
                }
            });

            // UserIDs.getAdminAll(function(response) {
            //     response.forEach(function(user) {
            //         if (selectedUsers.indexOf(user.id) !== -1) {
            //             vm.multiUser.push({ login: user.login, id: user.id, ticked: true });
            //         } else {
            //             vm.multiUser.push({ login: user.login, id: user.id, ticked: false });
            //         }
            //     });
            // });
            ReportingUsers.getAll(function (response) {
                response.forEach(function (user) {
                    if (selectedUsers.indexOf(user.id) !== -1) {
                        vm.multiUser.push({ login: user.login, id: user.id, ticked: true });
                    } else {
                        vm.multiUser.push({ login: user.login, id: user.id, ticked: false });
                    }
                });
            });

            Vendors.getAll(function (response) {
                response.forEach(function (user) {
                    if (selectedVendors.indexOf(user.id) !== -1) {
                        vm.multiVendor.push({ login: user.login, id: user.id, ticked: true });
                    } else {
                        vm.multiVendor.push({ login: user.login, id: user.id, ticked: false });
                    }
                });
            });

            AllVendorIds.getAll(function (response) {
                //console.log(response);
                response.forEach(function(value){
                    if (selectedVendorEntity.indexOf(value.id) !== -1) {
                        vm.multiVendorEntity.push({ name: value.name, id: value.id, ticked: true });
                    } else {
                        vm.multiVendorEntity.push({ name: value.name, id: value.id, ticked: false });
                    }
                });
            });
        }

        function selectedTrakeyeTypeAttributes() {
            if (vm.user.trakeyeType) {
                if (entity_old.trakeyeType && vm.user.trakeyeType.id === entity_old.trakeyeType.id) {
                    vm.user.trakeyeTypeAttributeValues = [];
                    vm.user.trakeyeTypeAttributeValues = entity_old.trakeyeTypeAttributeValues;
                } else {
                    vm.user.trakeyeTypeAttributeValues = [];
                    $.each(vm.user.trakeyeType.trakeyeTypeAttribute, function (key, value) {
                        vm.user.trakeyeTypeAttributeValues.push({
                            trakeyeTypeAttribute: vm.user.trakeyeType.trakeyeTypeAttribute[key]
                        });
                    });
                }
            }

        }

        vm.selectfrom = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go('user-management');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
			console.log(vm.user);
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function decodeImage(img) {
            return window.atob(img);
        }

        function navigateGeofence() {
            sessionStorage.setItem("prevPage", "user-management.new");
            $state.go('geofence.new');
        }

        function navigateGroupfromUserMng() {
            sessionStorage.setItem("prevPage", "user-management.new");
            $state.go('group.new');
        }

        function navigateFiberifyTypefromGroup() {
            sessionStorage.setItem("prevPage", "user-management.new");
            $state.go('trakeye-type.new');
        }


        vm.reportsEnable = true
            vm.deviceInfo = true
            Configs.get("InputFields", function (response) {
                if (response.length > 0) {
                    response.forEach(function(val){
                        if(val.configKey == "DeviceInfo" && val.configValue == "True" ){
                            vm.deviceInfo = false
                        }

                        if(val.configKey == "ReportsTo" && val.configValue == "True"){
                            vm.reportsEnable = false
                        }
                    })
                }
            });
        
    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User','UserAccount'];

    function UserManagementDetailController ($stateParams, User,UserAccount) {
        var vm = this;

        vm.load = load;
        vm.user = {};
       
        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
       UserAccount.get(function (data) {
                data.authorities.forEach(function (val) {
                    if(val == "ROLE_READONLY"){
                         vm.has_ROLE_READONLY=true
                    }
                });
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'last_modified_date,desc',
                    squash: true
                },
                search: null,
                listgeofenceid: null,
                columnNames: null,
                columnList: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        listgeofenceid: $stateParams.listgeofenceid,
                        columnNames: $stateParams.columnNames,
                        columnList: $stateParams.columnList
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }
        })

            .state('user-management.status', {
                parent: 'user-management',
                url: '/user-management/{status}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'userManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            status: $stateParams.status,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]

                }
            })

            .state('user-management-detail', {
                parent: 'admin',
                url: '/user/:login',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER'],
                    pageTitle: 'user-management.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            }).state('user-management.new', {
                parent: 'user-management',
                url: '/create',
                data: {
                    authorities: ['ROLE_USER_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            login: null,
                            firstName: null,
                            lastName: null,
                            email: null,
                            phone: null,
                            imsi: null,
                            activated: true,
                            langKey: null,
                            createdBy: null,
                            createdDate: null,
                            lastModifiedBy: null,
                            lastModifiedDate: null,
                            resetDate: null,
                            resetKey: null,
                            authorities: null,
                            geofences: null
                        };
                    }
                }

            })

            .state('user-management.edit', {
                parent: 'user-management',
                url: '/{login}/edit',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'User', function ($stateParams, User) {
                        return User.get({
                            login: $stateParams.login
                        }).$promise;
                    }],
                }

            }).state('user-management.delete', {
                parent: 'user-management',
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                        controller: 'UserManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'sm',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({
                                    login: $stateParams.login
                                });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {
                            reload: true
                        });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ReportingUsers', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/reporting-users').then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('ReportingNeUsers', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/reporting-ne-users').then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);

})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('Vendors', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.getAll = function (callback) {
            $http.get('api/vendors').then(function (response) {
                callback(response.data);
            });
        };
        return service;
    }]);

})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('NearbyUser', NearbyUser);

    NearbyUser.$inject = ['$resource'];

    function NearbyUser($resource) {
        var resourceUrl = 'api/nearby-users/:latitude/:longitude/:dis';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("UserManagementController", UserManagementController);

    UserManagementController.$inject = [
        "$rootScope",
        "$scope",
        "$ngConfirm",
        "$filter",
        "Principal",
        "User",
        "ReportingUsers",
        "ParseLinks",
        "AlertService",
        "$state",
        "pagingParams",
        "paginationConstants",
        "JhiLanguageService",
        "UserValueSearch",
        "UsersStatusService",
        "$stateParams",
        "UserStatusSearch",
        "UsersHierarchy",
        "UserAccount",
        "GeofenceMasterMiniIDs",
        "UserGeofences",
        "AssetDB",
        "AssetByID",
        "NearbyUser",
        "MasterGeofences",
        "UserValueGeofenceSearch",
        "UsersByGeo",
        "DownloadUsers",
        "Configs"
    ];

    function UserManagementController(
        $rootScope,
        $scope,
        $ngConfirm,
        $filter,
        Principal,
        User,
        ReportingUsers,
        ParseLinks,
        AlertService,
        $state,
        pagingParams,
        paginationConstants,
        JhiLanguageService,
        UserValueSearch,
        UsersStatusService,
        $stateParams,
        UserStatusSearch,
        UsersHierarchy,
        UserAccount,
        GeofenceMasterMiniIDs,
        UserGeofences,
        AssetDB,
        AssetByID,
        NearbyUser,
        MasterGeofences,
        UserValueGeofenceSearch,
        UsersByGeo,
        DownloadUsers,
        Configs
    ) {
        var vm = this;
        $scope.search = pagingParams.search;
        vm.authorities = ["ROLE_USER", "ROLE_USER_ADMIN", "ROLE_VENDOR_ADMIN"];
        vm.currentAccount = null;
        vm.languages = null;
        vm.setActive = setActive;
        vm.loadAll = loadAll;
        vm.users = [];
        vm.usersList = [];
        vm.page = 1;
        vm.totalItems = null;
        var userMarkers = [];
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.downloadImage = downloadImage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.getLocalhour = getLocalhour;
        vm.filterSearch = filterSearch;
        vm.usersTable = usersTable;
        vm.selectedListGeofenceId = parseInt(pagingParams.listgeofenceid);
        vm.saveListFilter = saveListFilter;
        vm.filterAssetsOnListView = filterAssetsOnListView;
        vm.closeListFilterModal = closeListFilterModal;
        vm.downloadUserManagementUserList = downloadUserManagementUserList;
        vm.downloadUsers = downloadUsers;
        vm.filterAssetsOnUserManagementMapView = filterAssetsOnUserManagementMapView;
        vm.closeUserManagementMapFilterModal = closeUserManagementMapFilterModal;
        vm.saveUserManagementGeofenceFilter = saveUserManagementGeofenceFilter;
        vm.masterGeofences = [];
        // vm.loadAll();
        $scope.tab = 1;
        var svgUH = null;
        var svgUHwidth = null;
        var svgUHheigth = null;

        var activeInfoWindow = [];
        var prevSelectedCircle = null;
        vm.columnList = pagingParams.columnList;

        if(vm.columnList == undefined){
            vm.columnList = [{name:"login", ticked:true}, 
            {name:"email", ticked:true}, 
            {name:"phone", ticked:true}, 
            {name:"applicationVersion", ticked:true}, 
            {name:"gpsimei", ticked:true}];
        }
        

        vm.selectedColumnList = pagingParams.columnNames;

        var noDataText = null;
        var markers = [];
        var polylines = [];
        vm.userGeofences = [];
        var openedInfoWindow = null;

        var locations = {};
        var latlng;

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    } /* 
                    {
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#EFEFEF",
                            },
                        ],
                    }, */,
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    }
                ],
            });
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        $scope.geofencelabel = {
            list : {
                search          : "Search",
                nothingSelected : "City"      
            },
            map : {
                    search          : "Search",
                    nothingSelected : "Geofence"  
            }
        }

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;

            if ($scope.tab == 1) {
                filterAssetsOnListView()
                /* vm.masterGeofences = [];
                vm.masterGeofences.push({id:0,name:"All"});
                if(isNaN(vm.selectedListGeofenceId)){
                    vm.selectedListGeofenceId = 0;
                }
                
                MasterGeofences.getAll(function (response) {
                    response.forEach(function(geofence){
                        vm.masterGeofences.push(geofence);
                    });
                }); */
                filterSearch();
            } else if ($scope.tab == 2) {
                UsersHierarchy.getUsersHierarchy(null, function (response) {
                    u_data = response;
                    orgChart.initTree({
                        id: "#body",
                        data: response,
                        modus: "diagonal",
                        loadFunc: loadChilds,
                    });
                });
            } else {
                filterAssetsOnUserManagementMapView()
                vm.mapAssets = [];
                var latlngs = new google.maps.LatLng(
                    $rootScope.DEFAULT_LATITUDE,
                    $rootScope.DEFAULT_LONGITUDE
                );
                /* var myOptions = {
                    zoom: 17,
                    center: latlngs,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */
                var map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(17, latlngs)
                );
                geoLocation(map);
                //getGroupUserManagementAssetsFromES(vm.selectedGeofenceId, null, vm.mapAssets);
            }
        };

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });

        if ($scope.tab == 1) {
            UserAccount.get(function (data) {
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if(val == "ROLE_READONLY"){
                         vm.has_ROLE_READONLY=true
                    }
                    if (val == "ROLE_USER_ADMIN") {
                        isAdmin = true;
                    } else if (val == "ROLE_HOD") {
                        isAdmin = true;
                    }
                });
                if (isAdmin) {
                    vm.adminFilter = true;
                } else {
                    vm.adminFilter = false;
                }
            });
            filterAssetsOnListView()
        }

        function filterAssetsOnListView() {
            var tempGeofenceId = $state.params.listgeofenceid
            vm.masterGeofences = [];
            vm.masterGeofences.push({ id: 0, name: "All" });
            if (isNaN(vm.selectedListGeofenceId)) {
                vm.selectedListGeofenceId = 0;
            }
            MasterGeofences.getAll(function (response) {
                response.forEach(function (geofence) {
                    geofence.ticked = (tempGeofenceId == geofence.id) ? true : false
                    vm.masterGeofences.push(geofence);
                });
            });
            //$("#listFilterModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
        }

        function closeListFilterModal() {
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
            vm.selectedListGeofenceId = vm.PrevselectedListGeofenceId;
        }

        function saveListFilter() {
            vm.PrevselectedListGeofenceId = vm.selectedListGeofenceId;
            $("#listFilterModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#listFilterModal").hide();
            filterSearch();
        }

        function usersTable(actualElement, successFunction) {
            UsersHierarchy.getUsersHierarchy(
                actualElement.id,
                function (response) {
                    vm.usersData = response.children;
                }
            );
        }

        function getLocalhour(hour) {
            var d = new Date();
            d.setUTCHours(hour);
            return d.getHours();
        }

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        // ReportingUsers.getAll(function(response) {
        //     vm.usersReporting = response;
        // });

        if (
            $scope.search === null ||
            $scope.search === "" ||
            angular.isUndefined($scope.search)
        ) {
            loadAll();
        } else {
            filterSearch();
        }

        $scope.geofenceListView = function(){
            if($scope.tab == 1){
                vm.selectedListGeofenceId = vm.selectedGeofenceNearby[0].id
                saveListFilter()
            }else if($scope.tab == 3){
                vm.selectedGeofenceId = vm.selectedGeofenceNearby[0].id
                saveUserManagementGeofenceFilter()
            }
            
        }
        function filterSearch() {
            if (
                $scope.search != null &&
                $scope.search != "" &&
                !angular.isUndefined($scope.search)
            ) {
                if ($stateParams.status == undefined) {
                    if (
                        isNaN(vm.selectedListGeofenceId) ||
                        vm.selectedListGeofenceId == 0
                    ) {
                        UserValueSearch.query(
                            {
                                search: $scope.search,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                            },
                            onSuccess,
                            onError
                        );
                    } else {
                        var columnList = [];
                        vm.selectedColumnList.forEach(function(value){
                            columnList.push(value.name);
                        });

                        UserValueGeofenceSearch.query(
                            {
                                search: $scope.search,
                                geofenceId: vm.selectedListGeofenceId,
                                page: pagingParams.page - 1,
                                size: vm.itemsPerPage,
                                sort: sort(),
                                columnNames: columnList
                            },
                            onSuccess,
                            onError
                        );
                    }
                } else {
                    UserStatusSearch.query(
                        {
                            status: $stateParams.status,
                            searchtext: $scope.search,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            } else {
                loadAll();
            }
        }

        function loadAll() {

            if ($stateParams.status == undefined) {
                if (
                    isNaN(vm.selectedListGeofenceId) ||
                    vm.selectedListGeofenceId == 0
                ) {
                    User.query(
                        {
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                } else {
                    UsersByGeo.query(
                        {
                            geofenceId: vm.selectedListGeofenceId,
                            page: pagingParams.page - 1,
                            size: vm.itemsPerPage,
                            sort: sort(),
                        },
                        onSuccess,
                        onError
                    );
                }
            } else {
                UsersStatusService.query(
                    {
                        status: $stateParams.status,
                        geofenceId : $stateParams.geofenceId,
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    },
                    onSuccess,
                    onError
                );
            }
        }

        function onSuccess(data, headers) {
            // hide anonymous user from user management: it's a required user
            // for Spring Security
            for (var i in data) {
                if (data[i]["login"] === "anonymoususer") {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers("link"));
            vm.totalItems = headers("X-Total-Count");
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.user = {
                id: null,
                login: null,
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                imsi: null,
                activated: null,
                langKey: null,
                createdBy: null,
                createdDate: null,
                lastModifiedBy: null,
                lastModifiedDate: null,
                resetDate: null,
                resetKey: null,
                authorities: null,
            };
        }

        function sort() {
            var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
            if (vm.predicate !== "id") {
                // result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: $scope.search,
                status: pagingParams.status,
                geofenceId : pagingParams.geofenceId,
                listgeofenceid: vm.selectedListGeofenceId,
                columnNames: vm.selectedColumnList,
                columnList: vm.columnList
            });
        }

        function filterAssetsOnUserManagementMapView() {
            vm.userGeofences = [];
            if (vm.adminFilter) {
                GeofenceMasterMiniIDs.getAll(function (response) {
                    response.forEach(function (geofence) {
                        geofence.label = geofence.name.substring(0, 15) + "..";
                        vm.userGeofences.push(geofence);
                        if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        }
                    });
                    // filterSearch();
                });
            } else {
                UserGeofences.getAll(function (response) {
                    response.forEach(function (geofence) {
                        vm.userGeofences.push(geofence);
                        if (vm.selectedGeofenceId == null) {
                            vm.selectedGeofenceId = geofence.id;
                        }
                    });
                    //filterSearch();
                });
            }
            //$("#mapFilterUserManagementModal").show();
            /* noDataText = document.getElementById("noData");
            noDataText.style.display = "none"; */
            //vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
        }

        function closeUserManagementMapFilterModal() {
            $("#mapFilterUserManagementModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterUserManagementModal").hide();
            vm.selectedGeofenceId = vm.prevSelectedGeofenceId;
        }

        function saveUserManagementGeofenceFilter() {
            vm.mapAssets = [];
            // var myOptions = {
            //     zoom: 17,
            //     center: latlngs,
            //     mapTypeId: google.maps.MapTypeId.ROADMAP
            // };
            // var map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
            getGroupUserManagementAssetsFromES(
                vm.selectedGeofenceId,
                null,
                vm.mapAssets
            );
            //vm.prevSelectedGeofenceId = vm.selectedGeofenceId;
/* 
            $("#mapFilterUserManagementModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#mapFilterUserManagementModal").hide(); */
        }

        function getGroupUserManagementAssetsFromES(
            geofenceIdVal,
            lastAssetId,
            mapAssetLists
        ) {
            AssetDB.get(geofenceIdVal, lastAssetId, function (data) {
                vm.mapAssets = mapAssetLists;
                data.assets.forEach(function (asset) {
                    var tmpAsset = {};

                    tmpAsset.assetCoordinates = asset.assetCoordinates;
                    tmpAsset.assetTypeName = asset.assetTypeName;
                    tmpAsset.assetTypeColor = asset.assetColor;
                    tmpAsset.assetTypeImagePath = asset.assetTypeImagePath;
                    tmpAsset.assetTypeLayout = asset.assetTypeLayout;
                    tmpAsset.id = asset.id;
                    tmpAsset.name = asset.name;

                    vm.mapAssets.push(tmpAsset);
                });
                drawLatestAssetsOnMap(vm.mapAssets);
                if (data.lastId != null) {
                    getGroupUserManagementAssetsFromES(
                        geofenceIdVal,
                        data.lastId,
                        vm.mapAssets
                    );
                } else {
                    if (vm.mapAssets.length > 0) {
                        var assetSelected = vm.mapAssets[0];
                        AssetByID.get(assetSelected.id, function (assetVal) {
                            var assetLatLng = {
                                lat:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].latitude,
                                lng:
                                    assetSelected.assetCoordinates[
                                        assetSelected.assetCoordinates.length -
                                            1
                                    ].longitude,
                            };
                            locations.map.setCenter(assetLatLng);
                        });
                    }
                }
                // filterGeofenceSearchMap();
            });
        }

        function drawLatestAssetsOnMap(response) {
            if (response) {
                initializeGeofenceAssetMap(response, function (latlang) {
                    locations.latlng = latlang;

                    setupAssetMap(function () {
                        $.each(response, function (index, value) {
                            if (value.assetTypeLayout == null) {
                                value.assetTypeName = value.assetType.name;
                                value.assetTypeLayout = value.assetType.layout;
                                value.assetTypeImagePath =
                                    value.assetType.imagePath;
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "FIXED"
                            ) {
                                if (value.assetCoordinates.length > 1) {
                                    drawPolyline(value);
                                    var value1 = value;
                                    value1.assetCoordinates = [
                                        value.assetCoordinates[
                                            value.assetCoordinates.length - 1
                                        ],
                                    ];

                                    drawFixedGeofenceAsset(value1, false);
                                } else {
                                    drawFixedGeofenceAsset(value, false);
                                }
                            }
                            if (
                                value.assetTypeLayout != null &&
                                value.assetTypeLayout == "SPREAD"
                            ) {
                                drawPolyline(value, locations.map);
                            }
                        });
                    });
                });
            }
        }

        function initializeGeofenceAssetMap(latlangs, callback) {
            if (latlangs && latlangs.length > 0) {
                var latVal = null;
                var lngVal = null;
                latlangs.forEach(function (value) {
                    if (latVal == null && lngVal == null) {
                        if (value.assetCoordinates.length > 0) {
                            latVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].latitude;
                            lngVal =
                                value.assetCoordinates[
                                    value.assetCoordinates.length - 1
                                ].longitude;
                        }
                    }
                });
                if (latVal != null && lngVal != null) {
                    latlng = new google.maps.LatLng(latVal, lngVal);
                    callback(latlng);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            callback(latlng);
                        },
                        function () {
                            // callback(new google.maps.LatLng("12.9716", "77.5946"));
                            callback(
                                new google.maps.LatLng(
                                    $rootScope.DEFAULT_LATITUDE,
                                    $rootScope.DEFAULT_LONGITUDE
                                )
                            );
                        }
                    );
                } else {
                    callback(
                        new google.maps.LatLng(
                            $rootScope.DEFAULT_LATITUDE,
                            $rootScope.DEFAULT_LONGITUDE
                        )
                    );
                }
            }
        }

        $("#searchUsersOnMap").change(function () {
            var userSelected = JSON.parse($("#searchUsersOnMap").val());
            var userLatLng = {
                lat: userSelected.latitude,
                lng: userSelected.longitude,
            };
            locations.map.setCenter(userLatLng);
        });

        function drawLatestlocations(response) {
            vm.usersList = response;
            for (var i = 0; i < userMarkers.length; i++) {
                userMarkers[i].setMap(null);
            }
            userMarkers = [];
            var markers = [
                {
                    Lat: "0.0",
                    Lng: "0.0",
                    name: "default",
                },
            ];

            $.each(response, function (index, value) {
                var infoWindow2 = new google.maps.InfoWindow();
                var imgbg = document.createElement("img");
                imgbg.className = "marker_back_image";

                if (value.reportingStatus == true) {
                    if (value.status == "ACTIVE") {
                        imgbg.src = "content/images/greenmarker.png";
                    } else if (value.status == "INACTIVE") {
                        imgbg.src = "content/images/redmarker.png";
                    } else if (value.status == "IDLE") {
                        imgbg.src = "content/images/yellowmarker.png";
                    } else if (value.status == "Off duty user") {
                        imgbg.src = "content/images/marker_offduty1.png";
                    }
                } else {
                    imgbg.src = "content/images/marker_active_case.png";
                }

                if (value.address == "SOS") {
                    imgbg.src = "content/images/alert.png";
                }

                if ($scope.trCases != undefined && $scope.trCases.length > 0) {
                    $.each($scope.trCases, function (index, value) {
                        var infoWindow = new google.maps.InfoWindow();
                        var startMarker = new google.maps.Marker({
                            map: locations.map,
                            position: new google.maps.LatLng(
                                value.pinLat,
                                value.pinLong
                            ),
                            title: value.description,
                        });
                        var infoWindow2 = new google.maps.InfoWindow();
                        if (value.priority == "LOW") {
                            startMarker.setIcon(
                                "content/images/Pointers-L4.png"
                            );
                        } else if (value.priority == "MEDIUM") {
                            startMarker.setIcon(
                                "content/images/Pointers-M4.png"
                            );
                        } else if (value.priority == "HIGH") {
                            startMarker.setIcon(
                                "content/images/Pointers-H4.png"
                            );
                        } else if (value.priority == "CRITICAL") {
                            startMarker.setIcon(
                                "content/images/Pointer-C4.png"
                            );
                        }
                        var span =
                            '<a userId="' +
                            value.geofenceName +
                            '" class="userpath" >Load travelled path</a>';
                        startMarker.content =
                            '<div class="infoWindowContent"><b>Incident Id : </b>' +
                            value.id +
                            "<br> <b>Reported By :</b> " +
                            value.reportedByUser +
                            "<br> <b> Assigned To :</b> " +
                            value.assignedToUser +
                            "<br> <b>Address :</b> " +
                            value.address +
                            "</div>";

                        $compile(startMarker.content)($scope);

                        google.maps.event.addListener(
                            startMarker,
                            "mouseover",
                            function () {
                                infoWindow.setContent(
                                    '<div class="infoWindowhead">' +
                                        startMarker.title +
                                        "</div>" +
                                        startMarker.content
                                );
                                infoWindow.open(locations.map, startMarker);
                            }
                        );
                        // on mouseout
                        google.maps.event.addListener(
                            startMarker,
                            "mouseout",
                            function () {
                                infoWindow.close();
                            }
                        );

                        var activeInfoWindow;
                        infoWindow2.setContent(
                            '<div class="infoWindowhead">' +
                                startMarker.title +
                                "</div>" +
                                startMarker.content
                        );
                        userMarkers.push(startMarker);
                    });
                }

                function customMarker() {
                    this.latlng = new google.maps.LatLng(
                        value.latitude,
                        value.longitude
                    );
                    this.setMap(locations.map);
                    this.title = value.login;
                    this.icon = imgbg;
                }
                var userContent = document.createElement("div"),
                    button;

                if (value.userImage != null) {
                    userContent.innerHTML =
                        '<div class="infoWindowhead">' +
                        value.login +
                        '</div><div class="infoWindowContent"><div class="rows"><div class="col-md-4"><img src="data:image/png;base64,' +
                        value.userImage +
                        '" style="width: 50px; height: 60px;"></div><div class="col-md-8"><p>' +
                        value.address +
                        "</p><p><b>Phone</b> : " +
                        value.phone;
                    button = userContent.appendChild(
                        document.createElement("input")
                    );
                    button.type = "button";
                    button.value = "Load travelled path";
                    button.className = "button";

                    google.maps.event.addDomListener(
                        button,
                        "click",
                        function () {
                            markerUserName = value.login;
                            userPath(value.userid);
                        }
                    );
                } else {
                    userContent.innerHTML =
                        '<div class="infoWindowhead"><span style="margin-left:10px;"><b>' +
                        value.login +
                        '</b></span></div><div style="width: 300px; height: 120px;" class="infoWindowContent"><div class="rows"><div class="col-md-7"><p>' +
                        value.address +
                        "</p><p><b>Phone</b> : " +
                        value.phone +
                        "</p><b>Latitude</b> : " +
                        value.latitude +
                        "</p> <p> <b>Longitude</b> : " +
                        value.longitude +
                        '</p> </div></div><div class="col-md-5"> <img src="content/images/userimg.gif" style="width: 80px; height: 90px; margin-top:26px;"></div></div>';

                    button = userContent.appendChild(
                        document.createElement("input")
                    );
                    button.type = "button";
                    button.value = "Load travelled path";
                    button.className = "button"; // set the CSS class

                    google.maps.event.addDomListener(
                        button,
                        "click",
                        function () {
                            markerUserName = value.login;
                            userPath(value.userid);
                        }
                    );
                }

                function userPath(id) {
                    var ele = document.getElementById("userPathModal");
                    $(ele).modal("show");
                    vm.drawUserPath(id);
                    var cleratodatefromdate = vm.today();
                    // cleratodatefromdate.remove();
                }
                var infowindowPopup = new google.maps.InfoWindow({
                    content: userContent,
                    pixelOffset: new google.maps.Size(0, -50),
                });

                customMarker.prototype = new google.maps.OverlayView();

                customMarker.prototype.draw = function () {
                    var self = this;
                    var div = this.div;

                    if (!div) {
                        div = this.div = document.createElement("div");
                        div.id = "marker";
                        div.style.width = "100px";
                        div.style.height = "100px";

                        var div_pointer = document.createElement("div");
                        div_pointer.className = "triangle";

                        var image_container = document.createElement("div");
                        image_container.className = "image_container";

                        var img = document.createElement("img");
                        img.className = "marker_image";
                        var image2 = "data:image/png;base64,";
                        image2 += value.userImage;
                        if (value.userImage == undefined) {
                            image2 = "content/images/userimg.gif";
                        }

                        img.src = image2;

                        var name_container = document.createElement("div");
                        name_container.className = "name_container";

                        var exit = document.createElement("div");
                        exit.className = "exit";
                        exit.innerHTML =
                            '<img className="exit_image" style="width:30px; height:30px;" src="https://cdn0.iconfinder.com/data/icons/large-glossy-icons/512/Delete.png">' +
                            "</img>";
                        exit.style.display = "none";

                        div.appendChild(image_container);
                        image_container.appendChild(img);
                        image_container.appendChild(imgbg);

                        div.appendChild(exit);

                        name_container.onmouseover = function () {
                            name_container.style.opacity = "0.6";
                            div.style.zIndex = "1000";
                        };
                        name_container.onmouseout = function () {
                            name_container.style.opacity = "0";
                            div.style.zIndex = "100";
                        };

                        infoWindow2.setContent(
                            '<div class="infoWindowhead">' +
                                value.login +
                                "</div>" +
                                userContent
                        );
                        // if (activeInfoWindow != null)
                        //     activeInfoWindow.close();

                        google.maps.event.addDomListener(
                            imgbg,
                            "click",
                            function (event) {
                                infowindowPopup.setPosition(
                                    new google.maps.LatLng(
                                        value.latitude,
                                        value.longitude
                                    )
                                );
                                infowindowPopup.open(locations.map);

                                if (activeInfoWindow != null)
                                    activeInfoWindow.close();
                                activeInfoWindow = infowindowPopup;
                            }
                        );

                        google.maps.event.addDomListener(
                            imgbg,
                            "click",
                            function (event) {
                                google.maps.event.trigger(self, "click");

                                infowindowPopup.open(locations.map);
                            }
                        );

                        var panes = this.getPanes();

                        panes.overlayImage.appendChild(div);
                    }

                    var point = this.getProjection().fromLatLngToDivPixel(
                        this.latlng
                    );

                    if (point) {
                        div.style.left = point.x - 50 + "px";
                        div.style.top = point.y - 125 + "px";
                    }
                };

                customMarker.prototype.remove = function () {
                    if (this.div) {
                        this.div.parentNode.removeChild(this.div);
                        this.div = null;
                    }
                };

                customMarker.prototype.getPosition = function () {
                    return this.latlng;
                };
                markers.forEach(function (marker) {
                    // image =
                    // value.userImage;

                    var overlay = new customMarker();
                });
                // end
            });
        }

        function downloadImage() {
            var svgString = getSVGString(svgUH.node());
            svgString2Image(svgString, 2 * 2160, 2 * 2160, "png", save);

            function save(dataBlob, filesize) {
                var imageURL = URL.createObjectURL(dataBlob);

                var link = document.createElement("a");
                link.href = imageURL;
                link.download = "UserHierarchy.png";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

        // Below are the functions that handle actual exporting:
        // getSVGString ( svgNode ) and svgString2Image( svgString, width, height, format, callback )
        function getSVGString(svgNode) {
            svgNode.setAttribute("xlink", "http://www.w3.org/1999/xlink");
            var cssStyleText = getCSSStyles(svgNode);
            appendCSS(cssStyleText, svgNode);

            var serializer = new XMLSerializer();
            var svgString = serializer.serializeToString(svgNode);
            svgString = svgString.replace(/(\w+)?:?xlink=/g, "xmlns:xlink="); // Fix root xlink without namespace
            svgString = svgString.replace(/NS\d+:href/g, "xlink:href"); // Safari NS namespace fix

            return svgString;

            function getCSSStyles(parentElement) {
                var selectorTextArr = [];

                // Add Parent element Id and Classes to the list
                selectorTextArr.push("#" + parentElement.id);
                for (var c = 0; c < parentElement.classList.length; c++)
                    if (
                        !contains(
                            "." + parentElement.classList[c],
                            selectorTextArr
                        )
                    )
                        selectorTextArr.push("." + parentElement.classList[c]);

                // Add Children element Ids and Classes to the list
                var nodes = parentElement.getElementsByTagName("*");
                for (var i = 0; i < nodes.length; i++) {
                    var id = nodes[i].id;
                    if (!contains("#" + id, selectorTextArr))
                        selectorTextArr.push("#" + id);

                    var classes = nodes[i].classList;
                    for (var c = 0; c < classes.length; c++)
                        if (!contains("." + classes[c], selectorTextArr))
                            selectorTextArr.push("." + classes[c]);
                }

                // Extract CSS Rules
                var extractedCSSText = "";
                for (var i = 0; i < document.styleSheets.length; i++) {
                    var s = document.styleSheets[i];

                    try {
                        if (!s.cssRules) continue;
                    } catch (e) {
                        if (e.name !== "SecurityError") throw e; // for Firefox
                        continue;
                    }

                    var cssRules = s.cssRules;
                    for (var r = 0; r < cssRules.length; r++) {
                        if (contains(cssRules[r].selectorText, selectorTextArr))
                            extractedCSSText += cssRules[r].cssText;
                    }
                }

                return extractedCSSText;

                function contains(str, arr) {
                    return arr.indexOf(str) === -1 ? false : true;
                }
            }

            function appendCSS(cssText, element) {
                var styleElement = document.createElement("style");
                styleElement.setAttribute("type", "text/css");
                styleElement.innerHTML = cssText;
                var refNode = element.hasChildNodes()
                    ? element.children[0]
                    : null;
                element.insertBefore(styleElement, refNode);
            }
        }

        function svgString2Image(svgString, width, height, format, callback) {
            var format = format ? format : "png";

            var imgsrc =
                "data:image/svg+xml;base64," +
                btoa(unescape(encodeURIComponent(svgString))); // Convert SVG string to data URL

            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");

            canvas.width = width;
            canvas.height = height;

            var image = new Image();
            image.onload = function () {
                context.clearRect(0, 0, width, height);
                context.drawImage(image, 0, 0, width, height);

                canvas.toBlob(function (blob) {
                    var filesize = Math.round(blob.length / 1024) + " KB";
                    if (callback) callback(blob, filesize);
                });
            };

            image.src = imgsrc;
        }

        function onSuccessUsers(data, headers) {
            drawLatestlocations($filter("filter")(data, { login: "" }));
        }

        function setupAssetMap(callback) {
            if (locations.map == null) {
                /* var myOptions = {
                    zoom: 16,
                    center: locations.latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }; */

                locations.map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOption(16, locations.latlng)
                );
                geoLocation(locations.map);
                var address = new google.maps.Geocoder();

                google.maps.event.addListener(
                    locations.map,
                    "click",
                    function (event) {
                        address.geocode(
                            {
                                latLng: event.latLng,
                            },
                            function (results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    if (results[0]) {
                                        $ngConfirm({
                                            title:
                                                "Are you sure you want to select this address?",
                                            content:
                                                "<strong>Address: </strong>" +
                                                results[0].formatted_address +
                                                "<br/>" +
                                                "<strong>Latitude: </strong>" +
                                                event.latLng.lat() +
                                                "</br>" +
                                                "<strong>Longitude: </strong>" +
                                                event.latLng.lng(),
                                            type: "blue",
                                            typeAnimated: true,
                                            buttons: {
                                                OK: {
                                                    text: "OK",
                                                    btnClass: "btn-primary",
                                                    action: function () {
                                                        var distance = parseInt(
                                                            document.getElementById(
                                                                "user_distance"
                                                            ).value
                                                        );

                                                        vm.filterData = true;
                                                        var clickLoc = {
                                                            lat: event.latLng.lat(),
                                                            lng: event.latLng.lng(),
                                                        };
                                                        var circle = new google.maps.Circle(
                                                            {
                                                                map:
                                                                    locations.map,
                                                                radius:
                                                                    distance +
                                                                    distance /
                                                                        2,
                                                                center: clickLoc,
                                                                fillColor:
                                                                    "#FD7A24",
                                                                strokeColor:
                                                                    "#FF0000",
                                                                strokeOpacity: 0.8,
                                                                strokeWeight: 1.0,
                                                            }
                                                        );

                                                        if (
                                                            prevSelectedCircle ==
                                                            null
                                                        ) {
                                                            prevSelectedCircle = circle;
                                                        } else {
                                                            prevSelectedCircle.setMap(
                                                                null
                                                            );
                                                            prevSelectedCircle = circle;
                                                        }
                                                        NearbyUser.query(
                                                            {
                                                                latitude: event.latLng.lat(),
                                                                longitude: event.latLng.lng(),
                                                                dis: distance,
                                                            },
                                                            onSuccessUsers
                                                        );
                                                    },
                                                },
                                                Cancel: {
                                                    text: "Cancel",
                                                    btnClass: "btn-danger",
                                                    action: function () {},
                                                },
                                            },
                                        });
                                    }
                                }
                            }
                        );
                    }
                );
                // google.maps.event.addListener(locations.map, 'zoom_changed', function () {
                //     vm.zoomLevel = locations.map.getZoom();
                //     if ((vm.prevZoomLevel == 17 && vm.zoomLevel == 18) || (vm.prevZoomLevel == 18 && vm.zoomLevel == 17)) {
                //         drawLatestAssetsOnMap(vm.mapAssets);
                //     }
                //     vm.prevZoomLevel = vm.zoomLevel;

                // });
            } else {
                // Loop through all the markers and polylines to remove

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                for (i = 0; i < polylines.length; i++) {
                    polylines[i].setMap(null);
                }

                markers = [];
                polylines = [];
            }
            locations.overlay = new google.maps.OverlayView();
            locations.overlay.draw = function () {};
            locations.overlay.setMap($scope.map);
            locations.element = document.getElementById("map_canvas");
            callback();
        }

        function drawPolyline(spread, map) {
            var spreadAssetCoordinates = [];
            $.each(spread.assetCoordinates, function (index, value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });
            if (spreadAssetCoordinates.length > 1) {
                var midLatLng = {
                    lat:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].latitude,
                    lng:
                        spread.assetCoordinates[
                            spread.assetCoordinates.length - 1
                        ].longitude,
                };

                var polylineColor = "#FFFFFF";
                var distanceFromPOP = "";
                var fiberCoreVal = "";
                var infowindow = new google.maps.InfoWindow();
                if (spread.assetTypeLayout == "SPREAD") {
                    polylineColor = spread.assetTypeColor;
                }
                var polylineWeight = 2.5;
                var strokeOpacityVal = 1.0;

                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: polylineColor,
                    strokeOpacity: strokeOpacityVal,
                    strokeWeight: polylineWeight,
                    fillColor: polylineColor,
                    fillOpacity: 0.3,
                    editable: false,
                });

                google.maps.event.addListener(
                    polylinepath,
                    "mouseout",
                    function (event) {
                        infowindow.close();
                    }
                );

                google.maps.event.addListener(
                    polylinepath,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead">' +
                                "<b>Asset Name : </b><br><br>" +
                                spread.name +
                                "</br></div>"
                        );

                        infowindow.mousemove;
                        infowindow.open(locations.map);
                        infowindow.setPosition(event.latLng);
                        openedInfoWindow = infowindow;
                    }
                );

                polylinepath.setMap(locations.map);
                polylines.push(polylinepath);
            }
        }

        function drawFixedGeofenceAsset(fixed, hasParent) {
            $.each(fixed.assetCoordinates, function (index, value1) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                }

                var infowindow = new google.maps.InfoWindow();

                var iconUrl = "";
                var isFixedAsset = false;
                iconUrl = fixed.assetTypeImagePath;
                isFixedAsset = true;

                var iconSize = 8;
                if (vm.zoomLevel == 10) {
                    iconSize = 8;
                } else if (vm.zoomLevel == 11) {
                    iconSize = 16;
                }

                if (isFixedAsset) {
                    iconSize = 24;
                }

                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: new google.maps.LatLng(
                        value1.latitude,
                        value1.longitude
                    ),
                    title: fixed.name,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: iconUrl,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                    },
                });
                google.maps.event.addListener(
                    startMarker,
                    "mouseout",
                    function (event) {
                        infowindow.close();
                    }
                );

                google.maps.event.addListener(
                    startMarker,
                    "click",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        infowindow.setContent(
                            '<div class="infoWindowhead">' +
                                "<b>Asset Name : </b><br><br>" +
                                fixed.name +
                                "</br></div>"
                        );

                        infowindow.mousemove;
                        infowindow.open(locations.map);
                        infowindow.setPosition(event.latLng);
                        openedInfoWindow = infowindow;
                    }
                );
                markers.push(startMarker);

                openedInfoWindow = infowindow;
            });
        }

        /* treeeeeeeeeeeeeeeeeeeeeeeeeeeee */
        var orgChart = (function () {
            var _margin = {
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20,
                },
                _root = {},
                _nodes = [],
                _counter = 0,
                _svgroot = null,
                _svg = null,
                _tree = null,
                _diagonal = null,
                _lineFunction = null,
                _loadFunction = null,
                /* Configuration */
                _duration = 750,
                /* Duration of the animations */
                _rectW = 150,
                /* Width of the rectangle */
                _rectH = 50,
                /* Height of the rectangle */
                _rectSpacing = 20,
                /* Spacing between the rectangles */
                _fixedDepth = 80,
                /*
                 * Height of the line for child
                 * nodes
                 */
                _mode = "line",
                /*
                 * Choose the values "line" or
                 * "diagonal"
                 */
                _callerNode = null,
                _callerMode = 0,
                defLinearGradient = function (id, x1, y1, x2, y2, stopsdata) {
                    var gradient = _svgroot
                        .append("svg:defs")
                        .append("svg:linearGradient")
                        .attr("id", id)
                        .attr("x1", x1)
                        .attr("y1", y1)
                        .attr("x2", x2)
                        .attr("y2", y2)
                        .attr("spreadMethod", "pad");

                    $.each(stopsdata, function (index, value) {
                        gradient
                            .append("svg:stop")
                            .attr("offset", value.offset)
                            .attr("stop-color", value.color)
                            .attr("stop-opacity", value.opacity);
                    });
                },
                defBoxShadow = function (id) {
                    var filter = _svgroot
                        .append("svg:defs")
                        .append("svg:filter")
                        .attr("id", id)
                        .attr("height", "150%")
                        .attr("width", "150%");

                    filter
                        .append("svg:feOffset")
                        .attr("dx", "2")
                        .attr("dy", "2")
                        .attr("result", "offOut"); // how
                    // much
                    // to
                    // offset
                    filter
                        .append("svg:feGaussianBlur")
                        .attr("in", "offOut")
                        .attr("result", "blurOut")
                        .attr("stdDeviation", "2"); // stdDeviation
                    // is
                    // how
                    // much
                    // to
                    // blur
                    filter
                        .append("svg:feBlend")
                        .attr("in", "SourceGraphic")
                        .attr("in2", "blurOut")
                        .attr("mode", "normal");
                },
                collapse = function (d) {
                    if (d.children) {
                        d._children = d.children;
                        d._children.forEach(collapse);
                        d.children = null;
                    }
                },
                update = function (source) {
                    // Compute the new tree layout.
                    _nodes = _tree.nodes(_root).reverse();
                    var links = _tree.links(_nodes);

                    // Normalize for fixed-depth.
                    _nodes.forEach(function (d) {
                        d.y = d.depth * _fixedDepth;
                    });

                    // Update the nodes
                    var node = _svg
                        .selectAll("g.node")
                        .data(_nodes, function (d) {
                            return d.id || (d.id = ++_counter);
                        });

                    // Enter any new nodes at the parent's previous position.
                    var nodeEnter = node
                        .enter()
                        .append("g")
                        .attr("class", "node")
                        .attr("transform", function (d) {
                            return (
                                "translate(" + source.x0 + "," + source.y0 + ")"
                            );
                        })
                        .on("click", nodeclick);

                    nodeEnter
                        .append("rect")
                        .attr("width", _rectW)
                        .attr("height", _rectH)
                        .attr("fill", "#898989")
                        .attr("filter", "url(#boxShadow)");

                    nodeEnter
                        .append("rect")
                        .attr("width", _rectW)
                        .attr("height", _rectH)
                        .attr("id", function (d) {
                            return d.id;
                        })
                        .attr("fill", function (d) {
                            return d.children || d._children || d.hasChild
                                ? "url(#gradientchilds)"
                                : "url(#gradientnochilds)";
                        })
                        .style("cursor", function (d) {
                            return d.children || d._children || d.hasChild
                                ? "pointer"
                                : "default";
                        })
                        .attr("class", "box1");

                    nodeEnter
                        .append("text")
                        .attr("x", _rectW / 2)
                        .attr("y", _rectH / 2)
                        .attr("dy", ".35em")
                        .attr("text-anchor", "middle")
                        .style("cursor", function (d) {
                            return d.children || d._children || d.hasChild
                                ? "pointer"
                                : "default";
                        })
                        .text(function (d) {
                            if(d.authvalue!=null || d.authvalue!=undefined){
                                return d.firstName + " " + d.lastName + " ( " + d.authvalue + " )";
                            } else {
                                return d.firstName + " " + d.lastName;
                            }
                        });

                    // Transition nodes to their new position.
                    var nodeUpdate = node
                        .transition()
                        .duration(_duration)
                        .attr("transform", function (d) {
                            return "translate(" + d.x + "," + d.y + ")";
                        });

                    nodeUpdate.select("rect.box1").attr("fill", function (d) {
                        return d.children || d._children || d.hasChild
                            ? "url(#gradientchilds)"
                            : "url(#gradientnochilds)";
                    });

                    // Transition exiting nodes to the parent's new position.
                    var nodeExit = node
                        .exit()
                        .transition()
                        .duration(_duration)
                        .attr("transform", function (d) {
                            return (
                                "translate(" + source.x + "," + source.y + ")"
                            );
                        })
                        .remove();

                    // Update the links
                    var link = _svg
                        .selectAll("path.link")
                        .data(links, function (d) {
                            return d.target.id;
                        });

                    if (_mode === "line") {
                        // Enter any new links at the parent's previous position.
                        link.enter()
                            .append("path", "g")
                            .attr("class", "link")
                            .attr("d", function (d) {
                                var u_line = (function (d) {
                                    var u_linedata = [
                                        {
                                            x:
                                                d.source.x0 +
                                                parseInt(_rectW / 2),
                                            y: d.source.y0 + _rectH + 2,
                                        },
                                        {
                                            x:
                                                d.source.x0 +
                                                parseInt(_rectW / 2),
                                            y: d.source.y0 + _rectH + 2,
                                        },
                                        {
                                            x:
                                                d.source.x0 +
                                                parseInt(_rectW / 2),
                                            y: d.source.y0 + _rectH + 2,
                                        },
                                        {
                                            x:
                                                d.source.x0 +
                                                parseInt(_rectW / 2),
                                            y: d.source.y0 + _rectH + 2,
                                        },
                                    ];

                                    return u_linedata;
                                })(d);

                                return _lineFunction(u_line);
                            });

                        // Transition links to their new position.
                        link.transition()
                            .duration(_duration)
                            .attr("d", function (d) {
                                var u_line = (function (d) {
                                    var u_linedata = [
                                        {
                                            x:
                                                d.source.x +
                                                parseInt(_rectW / 2),
                                            y: d.source.y + _rectH,
                                        },
                                        {
                                            x:
                                                d.source.x +
                                                parseInt(_rectW / 2),
                                            y: d.target.y - _margin.top / 2,
                                        },
                                        {
                                            x:
                                                d.target.x +
                                                parseInt(_rectW / 2),
                                            y: d.target.y - _margin.top / 2,
                                        },
                                        {
                                            x:
                                                d.target.x +
                                                parseInt(_rectW / 2),
                                            y: d.target.y,
                                        },
                                    ];

                                    return u_linedata;
                                })(d);

                                return _lineFunction(u_line);
                            });

                        // Transition exiting nodes to the parent's new position.
                        link.exit()
                            .transition()
                            .duration(_duration)
                            .attr("d", function (d) {
                                /*
                                 * This is needed to draw the lines
                                 * right back to the caller
                                 */
                                var u_line = (function (d) {
                                    var u_linedata = [
                                        {
                                            x:
                                                _callerNode.x +
                                                parseInt(_rectW / 2),
                                            y: _callerNode.y + _rectH + 2,
                                        },
                                        {
                                            x:
                                                _callerNode.x +
                                                parseInt(_rectW / 2),
                                            y: _callerNode.y + _rectH + 2,
                                        },
                                        {
                                            x:
                                                _callerNode.x +
                                                parseInt(_rectW / 2),
                                            y: _callerNode.y + _rectH + 2,
                                        },
                                        {
                                            x:
                                                _callerNode.x +
                                                parseInt(_rectW / 2),
                                            y: _callerNode.y + _rectH + 2,
                                        },
                                    ];

                                    return u_linedata;
                                })(d);

                                return _lineFunction(u_line);
                            })
                            .each("end", function () {
                                _callerNode = null;
                                /*
                                 * After
                                 * transition
                                 * clear
                                 * the
                                 * caller
                                 * node
                                 * variable
                                 */
                            });
                    } else if (_mode === "diagonal") {
                        // Enter any new links at the parent's previous position.
                        link.enter()
                            .insert("path", "g")
                            .attr("class", "link")
                            .attr("x", _rectW / 2)
                            .attr("y", _rectH / 2)
                            .attr("d", function (d) {
                                var o = {
                                    x: source.x0,
                                    y: source.y0,
                                };
                                return _diagonal({
                                    source: o,
                                    target: o,
                                });
                            });

                        // Transition links to their new position.
                        link.transition()
                            .duration(_duration)
                            .attr("d", _diagonal);

                        // Transition exiting nodes to the parent's new position.
                        link.exit()
                            .transition()
                            .duration(_duration)
                            .attr("d", function (d) {
                                var o = {
                                    x: source.x,
                                    y: source.y,
                                };
                                return _diagonal({
                                    source: o,
                                    target: o,
                                });
                            })
                            .remove();
                    }

                    // Stash the old positions for transition.
                    _nodes.forEach(function (d) {
                        d.x0 = d.x;
                        d.y0 = d.y;
                    });
                },
                // Toggle children on click.
                nodeclick = function (d) {
                    if (!d.children && !d._children && d.hasChild) {
                        // If there are no childs --> Try to load child nodes
                        _loadFunction(d, function (childs) {
                            var response = {
                                id: d.id,
                                login: d.login,
                                children: childs.result,
                            };

                            response.children.forEach(function (child) {
                                if (!_tree.nodes(d)[0]._children) {
                                    _tree.nodes(d)[0]._children = [];
                                }

                                child.x = d.x;
                                child.y = d.y;
                                child.x0 = d.x0;
                                child.y0 = d.y0;
                                _tree.nodes(d)[0]._children.push(child);
                            });

                            if (d.children) {
                                _callerNode = d;
                                _callerMode = 0; // Collapse
                                d._children = d.children;
                                d.children = null;
                            } else {
                                _callerNode = null;
                                _callerMode = 1; // Expand
                                d.children = d._children;
                                d._children = null;
                            }

                            update(d);
                        });
                    } else {
                        if (d.children) {
                            _callerNode = d;
                            _callerMode = 0; // Collapse
                            d._children = d.children;
                            d.children = null;
                        } else {
                            _callerNode = d;
                            _callerMode = 1; // Expand
                            d.children = d._children;
                            d._children = null;
                        }

                        update(d);
                    }
                },
                // Redraw for zoom
                redraw = function () {
                    _svg.attr(
                        "transform",
                        "translate(" +
                            d3.event.translate +
                            ")" +
                            " scale(" +
                            d3.event.scale.toFixed(1) +
                            ")"
                    );
                },
                initTree = function (options) {
                    var u_opts = $.extend(
                            {
                                id: "",
                                data: {},
                                modus: "line",
                                loadFunc: function () {},
                            },
                            options
                        ),
                        id = u_opts.id;

                    _loadFunction = u_opts.loadFunc;
                    _mode = u_opts.modus;
                    _root = u_opts.data;

                    if (_mode == "line") {
                        _fixedDepth = 80;
                    } else {
                        _fixedDepth = 110;
                    }

                    $(id).html(""); // Reset

                    var width =
                            $(id).innerWidth() - _margin.left - _margin.right,
                        height =
                            $(id).innerHeight() - _margin.top - _margin.bottom;

                    //    var width = 1050;
                    //    var height = 1500;

                    _tree = d3.layout
                        .tree()
                        .nodeSize([
                            _rectW + _rectSpacing,
                            _rectH + _rectSpacing,
                        ]);

                    /* Basic Setup for the diagonal function. _mode = "diagonal" */
                    _diagonal = d3.svg.diagonal().projection(function (d) {
                        return [d.x + _rectW / 2, d.y + _rectH / 2];
                    });

                    /* Basic setup for the line function. _mode = "line" */
                    _lineFunction = d3.svg
                        .line()
                        .x(function (d) {
                            return d.x;
                        })
                        .y(function (d) {
                            return d.y;
                        })
                        .interpolate("linear");

                    var u_childwidth = parseInt(
                        (_root.children.length * _rectW) / 2
                    );
                    var zm;
                    _svgroot = d3
                        .select(id)
                        .append("svg")
                        .attr("width", width)
                        .attr("height", height)
                        .call(
                            (zm = d3.behavior
                                .zoom()
                                .scaleExtent([0.15, 3])
                                .on("zoom", redraw))
                        );

                    _svg = _svgroot
                        .append("g")
                        .attr(
                            "transform",
                            "translate(" +
                                parseInt(
                                    u_childwidth +
                                        (width - u_childwidth * 2) / 2 -
                                        _margin.left / 2
                                ) +
                                "," +
                                20 +
                                ")"
                        )
                        .attr("shape-rendering", "geometricPrecision");

                    var u_stops = [
                        { offset: "0%", color: "#03A9F4", opacity: 1 },
                        { offset: "100%", color: "#0288D1", opacity: 1 },
                    ];
                    defLinearGradient(
                        "gradientnochilds",
                        "0%",
                        "0%",
                        "0%",
                        "100%",
                        u_stops
                    );
                    var u_stops = [
                        { offset: "0%", color: "#00e658", opacity: 1 },
                        { offset: "100%", color: "#048033", opacity: 1 },
                    ];
                    defLinearGradient(
                        "gradientchilds",
                        "0%",
                        "0%",
                        "0%",
                        "100%",
                        u_stops
                    );

                    defBoxShadow("boxShadow");

                    // necessary so that zoom knows where to zoom and unzoom from
                    zm.translate([
                        parseInt(
                            u_childwidth +
                                (width - u_childwidth * 2) / 2 -
                                _margin.left / 2
                        ),
                        20,
                    ]);

                    _root.x0 = 0; // the root is already centered
                    _root.y0 = height / 2; // draw & animate from center

                    _root.children.forEach(collapse);
                    update(_root);

                    d3.select(id).style(
                        "height",
                        height + _margin.top + _margin.bottom
                    );
                    svgUH = _svgroot;
                    svgUHwidth = width;
                    svgUHheigth = height;
                };

            return { initTree: initTree };
        })();

        var u_data = {};

        function loadChilds(actualElement, successFunction) {
            UsersHierarchy.getUsersHierarchy(
                actualElement.login,
                function (response) {
                    var result = { result: response.children };
                    successFunction(result);
                }
            );
        }

        // treeeeeeeeeeeeee------------------------------------------///

        function downloadUserManagementUserList() {
            // DownloadCaseReports.download(function (response) {
            var a = document.createElement("a");
            a.style = "display: none";
            var file = new Blob([response], { type: "application/csv" });
            var fileURL = URL.createObjectURL(file);
            // window.open(fileURL, "_blank");
            a.href = fileURL;
            a.download = "case_report.csv";
            a.click();
            window.URL.revokeObjectURL(fileURL);
            // });
        }

        function downloadUsers() {
            DownloadUsers.download(function (response) {
                var a = document.createElement("a");
                a.style = "display: none";
                var file = new Blob([response], { type: "application/csv" });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = "users.csv";
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
        }


       /*  Configs.rolloutFeatures(function (response) {
            if(response.length){
                response.filter(function (value){
                    if(value.configKey == "PROJECT_SIDEBAR"){
                        if(value.configValue == "True"){
                            $rootScope.showRolloutProject = true
                        }
                    } })
            }else{
                $rootScope.showRolloutProject = false
            }
        }); */
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ImportDialogController", ImportDialogController);

    ImportDialogController.$inject = ["EntityImport", "$timeout", "$state","previousState"];
    function ImportDialogController(EntityImport, $timeout, $state,previousState) {
        var vm = this;
        var getFile, lastDotPosition, format;
        vm.currentState = previousState

        $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });
        
        vm.importxlsx = /^(.*?)\.(xlsx|kml)$/;

        vm.onSubmit = function () {
            getFile = document.getElementById("uploadfile").files[0];
            lastDotPosition = getFile.name.lastIndexOf(".");
            format = getFile.name.substring(lastDotPosition + 1);

            var fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                EntityImport.get(
                    {
                        entityName: vm.entity,
                        entityLayout: vm.entityLayout,
                        fileFormat: format,
                        messageType: "ADD",
                        messageStatus: "OPEN",
                        fileImage: window.btoa(fileLoadedEvent.target.result), // imported file
                    },
                    function (response) {
                        vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id;
                        $timeout(function () {
                            $state.go(vm.currentState)
                        }, 4000);
                    }
                );
            };
            fileReader.readAsBinaryString(getFile);
        };
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("entity-import", {
                parent: "admin",
                url: "/entity-import",
                data: {
                    authorities: [
                        "ROLE_USER_ADMIN",
                    ],
                    pageTitle: "global.menu.entityImport",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/import/entity-import.html",
                        controller: "ImportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
    
                }
            })

            .state('entity-import.new', {
                parent: 'entity-import',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/import/entity-import-dialog.html',
                        controller: 'ImportDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return $state.current.name || 'entity-import';
                    }]
                }
            })
        }
    })();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('EntityImport', ['$http', function ($http) {

		var service = {};
		service.get = function (data,callback) {
			$http.post('api/assetsimportrequests',data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('EntityImportList', ['$http', function ($http) {

		var service = {};
		service.get = function (callback) {
			$http.get('api/assetsimportrequests').then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AssetLinkList', ['$http', function ($http) {

		var service = {};
		service.get = function (callback) {
			$http.get('api/link-assets').then(function (response) {
				callback(response.data);
			}); 
		};

		service.post = function (data,callback) {
			$http.post('api/link-assets',data).then(function (response) {
				callback(response);
			}); 
		};
		return service;
	}]);
})(); 


(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ImportController", ImportController);

        ImportController.$inject = ["EntityImportList"];
    function ImportController(EntityImportList) {

        var vm = this;

        EntityImportList.get(function (response){
            vm.displayList = response
        })

        vm.refresh = function(){
            EntityImportList.get(function (response){
                vm.displayList = response
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('trakeyeApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomerManagementDetailController', CustomerManagementDetailController);

    CustomerManagementDetailController.$inject = ['$stateParams', '$state', 'CustomerDetails', 'CustomerUpdate'];

    function CustomerManagementDetailController ($stateParams, $state, CustomerDetails, CustomerUpdate) {
        var vm = this;
        
        vm.save = save;
        vm.load = load;
        vm.customer = {};

        vm.load($stateParams.id);

        function load (id) {
        	CustomerDetails.get({customerId: id}, function(result) {
                vm.customer = result;
            });
        }

        function onSaveSuccess (result) {
            //vm.isSaving = false;
            $state.go('customer-management');
        }

        function onSaveError () {
            //vm.isSaving = false;
        }
        
        function save () {
       
            if (vm.customer.id !== null) {
                CustomerUpdate.update(vm.customer, onSaveSuccess, onSaveError);
            } else {
                CustomerUpdate.save(vm.customer, onSaveSuccess, onSaveError);
            }
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomerManagementDetailController', CustomerManagementDetailController);

    CustomerManagementDetailController.$inject = ['$stateParams', 'CustomerDetails'];

    function CustomerManagementDetailController ($stateParams, CustomerDetails) {
        var vm = this;

        vm.load = load;
        vm.customer = {};

        vm.load($stateParams.id);

        function load (id) {
        	CustomerDetails.get({customerId: id}, function(result) {
                vm.customer = result;
            });
        }
       
    }
})();


(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-management', {
            parent: 'admin',
            //url: '/customer-management?page&sort$search',
            url: '/customer-management',
            data: {
            	authorities: [],
                pageTitle: 'customerManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/customer-management/customer-management.html',
                    controller: 'CustomerManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer-management');
                    return $translate.refresh();
                }]

            }       
			})
    
    .state('customer-management.edit', {
        parent: 'customer-management',
        url: '/{id}/edit',
        data: {
        	 //authorities: ['ROLE_SUPER_ADMIN','ROLE_USER_ADMIN']
        },
		views:{
			'content@':{
				templateUrl: 'app/admin/customer-management/customer-management-dialog.html',
                controller: 'CustomerDetails',
                controllerAs: 'vm'
			}
		},
		resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('customer-management');
                return $translate.refresh();
            }],
			entity: ['$stateParams', 'CustomerDetails', function($stateParams, CustomerDetails) {
                return CustomerDetails.get({id : $stateParams.id}).$promise;
            }],
        }		        
    })
    
    .state('customer-management-detail', {
        parent: 'admin',
        url: '/customer/:id',
        data: {
        	 //authorities: ['ROLE_SUPER_ADMIN','ROLE_USER_ADMIN'],
            pageTitle: 'customer-management.detail.title'
        },
        views: {
            'content@': {
                templateUrl: 'app/admin/customer-management/customer-management-dialog.html',
                controller: 'CustomerManagementDetailController',
                controllerAs: 'vm'
            }
        },
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('customer-management');
                return $translate.refresh();
            }]
        }
    });
    }
})();

(function() {
    'use strict';

    angular
    .module('trakeyeApp')
    .controller('CustomerManagementController', CustomerManagementController);

    //CustomerManagementController.$inject = ['Customer','ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService','$stateParams'];
    CustomerManagementController.$inject = ['CustomerDetails', 'CustomerValueSearch', '$state', 'pagingParams', 'paginationConstants','$stateParams', 'Customer', 'AlertService'];
    
    function CustomerManagementController(CustomerDetails, CustomerValueSearch, $state, pagingParams, paginationConstants, $stateParams, Customer, AlertService) {
        var vm = this;

        vm.firstName = null;
        vm.lastName = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.customers = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.getLocalhour = getLocalhour;
        vm.filterSearch=filterSearch;

        vm.loadAll();
        
        function getLocalhour(hour){
        	var d  = new Date();
			d.setUTCHours(hour);
			return d.getHours();
		}

        function setActive (customer, isActivated) {
            customer.activated = isActivated;
            Customer.update(customer, function () {
                vm.loadAll();
                vm.clear();
            });
        }
        
        function filterSearch(){
			if(vm.search!=null && vm.search!="" && !angular.isUndefined(vm.search)){
				CustomerValueSearch.query({customerId:vm.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
			}else{
				loadAll ();
			}

		}
        

        function loadAll () {        	
          if($stateParams.status==undefined){
        	  Customer.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
          }else{ 
        	 
        	CustomersStatusService.query({status:$stateParams.status,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
          }    
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['firstName'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            //vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.customers = data;
           
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.customer = {
                id: null, firstName: null, lastName: null, email: null, mobilePhone: null,
                langKey: null, createdDate: null, status:null, city:null, state:null, country:null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("CaseImportDialogController", CaseImportDialogController);

    CaseImportDialogController.$inject = ["CaseImport", "$timeout", "$state","previousState"];
    function CaseImportDialogController(CaseImport, $timeout, $state,previousState) {
        var vm = this;
        var getFile, lastDotPosition, format;
        vm.currentState = previousState

        $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });
        
        vm.importxlsx = /^(.*?)\.(xlsx|kml)$/;

        vm.onSubmit = function () {
            getFile = document.getElementById("uploadfile").files[0];
            lastDotPosition = getFile.name.lastIndexOf(".");
            format = getFile.name.substring(lastDotPosition + 1);

            var fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                CaseImport.get(
                    {
                        entityName: vm.entity,
                        entityLayout: vm.entityLayout,
                        fileFormat: format,
                        messageType: "ADD",
                        messageStatus: "OPEN",
                        fileImage: window.btoa(fileLoadedEvent.target.result), // imported file
                    },
                    function (response) {
                        vm.showMessageError = false;
                        vm.showMessage = true;
                        vm.trackingId = response.id;
                        $timeout(function () {
                            $state.go(vm.currentState)
                        }, 500);
                    }
                );
            };
            fileReader.readAsBinaryString(getFile);
        };
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("case-import", {
                parent: "admin",
                url: "/case-import",
                data: {
                    authorities: ["ROLE_USER_ADMIN"],
                    pageTitle: "global.menu.entityImport",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/case-import/case-import.html",
                        controller: "CaseImportController",
                        controllerAs: "vm",
                    },
                },
                reloadOnSearch: false,   // ✅ IMPORTANT
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })

            .state('case-import.new', {
                parent: 'case-import',
                url: '/case-import',
                data: {
                    authorities: ['ROLE_USER_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/case-import/case-import-dialog.html',
                        controller: 'CaseImportDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return $state.current.name || 'case-import';
                    }]
                }
            })
        }
    })();
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('CaseImport', ['$http', function ($http) {

		var service = {};
		service.get = function (data,callback) {
			$http.post('api/casesimportrequests',data).then(function (response) {
				callback(response.data);
			}); 
		};
		return service;
	}]);
})(); 

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('CaseImportList', ['$http', function ($http) {

        var service = {};

        service.get = function (page, size, sort, callback) {

			// 🔥 HANDLE OLD CALL STYLE
			if (typeof page === 'function') {
				callback = page;
				page = 0;
				size = 10;
				sort = 'id,desc';
			}

			page = (typeof page === 'number') ? page : 0;
			size = (typeof size === 'number') ? size : 10;
			sort = sort || 'id,desc';

			var url = 'api/casesimportrequests?page=' + page + '&size=' + size + '&sort=' + sort;

			$http.get(url).then(function (response) {

				if (typeof callback === 'function') {
					callback(response.data, response.headers);
				}

			});
		};
        return service;
    }]);
})();

(function () {
	"use strict";

	angular
		.module("trakeyeApp")
		.controller("CaseImportController", CaseImportController);

	CaseImportController.$inject = ["CaseImportList", "Report"];

	function CaseImportController(CaseImportList, Report) {

		var vm = this;

		vm.page = 1;
		vm.itemsPerPage = 10;
		vm.totalItems = 0;
		vm.displayList = [];
		vm.expandResponse = null;

		// ===== LOAD DATA =====
		vm.loadData = function () {

			var pageToSend = vm.page - 1;
			CaseImportList.get(pageToSend, vm.itemsPerPage, 'id,desc', function (data, headers) {
				vm.displayList = data;
				vm.totalItems = headers('X-Total-Count');
			});
		};

		// ===== PAGE CHANGE =====
		vm.loadPage = function (page) {
			vm.page = page;
			vm.loadData();
		};

		// ===== REFRESH =====
		vm.refresh = function () {
			vm.page = 1;
			vm.loadData();
		};

		// ===== INITIAL LOAD =====
		vm.loadData();

		// ===== EXPAND =====
		vm.expand = function (entity) {

			vm.displayList.forEach(function (item) {
				item.expand = false;
			});

			if (vm.toggle === entity.id) {
				vm.toggle = undefined;
			} else {
				entity.expand = true;
				vm.toggle = entity.id;

				vm.expandResponse = null;

				Report.getEntityDetails(entity.id, function (response) {
					vm.expandResponse = response;
				});
			}
		};

		// ===== DOWNLOAD =====
		vm.download = function (imgId, id, name) {
            var temp = "Report"
			Report.downloadZip(id, imgId, function (data) {
				var a = document.createElement("a");
                var file = new Blob([data], { type: 'application/xlsx' });

                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = name ? name : temp + ".xlsx";
				a.click();
                window.URL.revokeObjectURL(fileURL);
            })
        }
	}
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("asset-link", {
                parent: "admin",
                url: "/asset-link",
                data: {
                    authorities: [
                        "ROLE_USER_ADMIN",
                    ],
                    pageTitle: "global.menu.assetLink",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/asset-link/asset-link-request.html",
                        controller: "AssetLinkController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
    
                }
            })
        }
    })();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetLinkController", AssetLinkController);

        AssetLinkController.$inject = ["AssetLinkList"];
    function AssetLinkController(AssetLinkList) {

        var vm = this;

        AssetLinkList.get(function (response){
            vm.displayList = response
        })

        vm.refresh = function(){
            AssetLinkList.get(function (response){
                vm.displayList = response
            })
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetAvailabilityImport", AssetAvailabilityImport);

    AssetAvailabilityImport.$inject = ["AmcUpload","$state","$timeout"];
    function AssetAvailabilityImport(AmcUpload,$state,$timeout) {

        var vm = this;
		var formData,getFile;
		
          $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });
        
        vm.importxlsx = /^(.*?)\.(xlsx)$/;
		vm.upload = function () {

    var file = document.getElementById('uploadfile').files[0];
    var formData = new FormData();
    formData.append("file", file);

    AmcUpload.uploadAssetAvailability(formData).then(function (response) {

        var contentType = response.headers('content-type');

        // If backend returned file
        if (contentType === "application/octet-stream") {

            var blob = new Blob([response.data], { type: contentType });

            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = "NotProcessedRows.xlsx";
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
			$timeout(function () {
		        $state.go("asset");
		    }, 200);

        } else {
            // Convert buffer to text (Success message)
            var text = new TextDecoder("utf-8")
                .decode(new Uint8Array(response.data));
				$timeout(function () {
		          $state.go("asset");
		       }, 200);
            alert(text);
        }

    }, function (error) {
        console.log("Error:", error);
    });
};
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("amc-status-import", {
                parent: "admin",
                url: "/amc-status-import",
                data: {
                    authorities: [
                        "ROLE_USER_ADMIN",
                    ],
                    pageTitle: "global.menu.entityImport",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/amc-status-import/amc-status-import.html",
                        controller: "AmcImportController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
    
                }
            }).state("asset-availability-import", {
                parent: "admin",
                url: "/asset-availability-import",
                data: {
                    authorities: [
                        "ROLE_USER_ADMIN",
                    ],
                    pageTitle: "global.menu.entityImport",
                },
                views: {
                    "content@": {
                        templateUrl: "app/admin/amc-status-import/asset-availability-import.html",
                        controller: "AssetAvailabilityImport",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
    
                }
            })
        }
    })();
(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AmcUpload', AssetUpload);

    AssetUpload.$inject = ['$http'];

    function AssetUpload($http) {

        var service = {};
        service.amcupload = function (data, callback) {

            $http.post('api/uploadFilesAMCNONAMC', data, {
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {
                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

		  service.uploadAssetAvailability = function (data) {
    return $http({
        method: "POST",
        url: "api/uploadFilesAssetAvailability",
        data: data,
        headers: { 'Content-Type': undefined },
        transformRequest: angular.identity,
        responseType: 'arraybuffer'
    });
};

        return service;
    }

})();
(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AmcImportController", AmcImportController);

    AmcImportController.$inject = ["AmcUpload","$state","$timeout"];
    function AmcImportController(AmcUpload,$state,$timeout) {

        var vm = this;
		var formData,getFile;
		
          $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });
        
        vm.importxlsx = /^(.*?)\.(xlsx)$/;
		  vm.upload = function () {

            getFile = document.getElementById('uploadfile').files[0];
            formData = new FormData();
            formData.append("file", getFile);
            
            AmcUpload.amcupload(formData, function (response) {
                if (response.status === 200) {
		            $timeout(function () {
		                $state.go("asset");
		            }, 200);
		        }
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER','ROLE_SUPER_ADMIN','ROLE_USER_ADMIN','ROLE_VENDOR_ADMIN'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth','$state'];

    function RequestResetController ($timeout, Auth,$state) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;
        vm.errorUserDeactivate= null;
        vm.countExceeded = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.login).then(function (response) {
                vm.success = 'OK';
                vm.resetAccount.login = '';
                $timeout(function (){
                	$state.go("login");
                },2000);
                
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'username not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                   
                } else if(response.status === 400 && response.data === 'user is deactivated'){
                	 vm.errorUserDeactivate = 'ERROR';
                    
                } else if(response.status === 400 && response.data === 'Reset password count exceeded for the day'){
               	 vm.countExceeded = 'ERROR';
                 
                }else {
                    vm.error = 'ERROR';//User has not yet set password once. So forget password email can not be sent. Check your email to set the password
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;
        vm.emaillinkinvalid = null;
        vm.verifyaccount=null;
        
        Auth.verify($stateParams.key ,function (response) {
        	vm.verifyaccount = response.data;
            
        });
        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if(response.status === 400 && response.data === 'email link invalid'){
                   	 vm.emaillinkinvalid = 'ERROR';
                    }else{
                    	vm.error = 'ERROR';
                    }
                    
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RegisterController', RegisterController);

    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
		vm.appName = $rootScope.APP_NAME;
        $timeout(function (){angular.element('#login').focus();});

        function register () {
        
            vm.registerAccount.langKey = $translate.use();
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;

            Auth.createAccount(vm.registerAccount).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'firstName already in use') {
                    vm.errorUserExists = 'ERROR';
                } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                    vm.errorEmailExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        	}
        }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER','ROLE_SUPER_ADMIN','ROLE_USER_ADMIN','ROLE_VENDOR_ADMIN'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('FeasibilityVerifyFinish', FeasibilityVerifyFinish);

    FeasibilityVerifyFinish.$inject = ['$resource'];

    function FeasibilityVerifyFinish($resource) {
        var service = $resource('api/feasibility-checks/record', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('feasibilityVerify', {
            parent: 'account',
            url: '/feasibilityverify/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/feasibility/verify/finish/feasibility.verify.finish.html',
                    controller: 'FeasibilityVerifyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feasibilityVerify');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityVerifyController', FeasibilityVerifyController);

    FeasibilityVerifyController.$inject = ['$stateParams', '$timeout','Feasibility'];

    function FeasibilityVerifyController ($stateParams, $timeout,Feasibility) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        //vm.confirmPassword = null;
        //vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
       // vm.login = LoginService.open;
       // vm.resetAccount = {};
        vm.success = null;
       
       
       // vm.emaillinkinvalid = null;
       // vm.verifyaccount=null;
        
       /* Auth.verify($stateParams.key ,function (response) {
        	vm.verifyaccount = response.data;
            
        });*/
       // $timeout(function (){angular.element('#password').focus();});
       // var geocoder = new google.maps.Geocoder();
        function finishReset() {
           // vm.doNotMatch = null;
            vm.error = null;
            
          /*  if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if(response.status === 400 && response.data === 'email link invalid'){
                   	 vm.emaillinkinvalid = 'ERROR';
                    }else{
                    	vm.error = 'ERROR';
                    }
                    
                });
            }*/
            
            
            if (navigator.geolocation) {
                var location_timeout = setTimeout("geolocFail()", 10000);

                navigator.geolocation.getCurrentPosition(function(position) {
                    clearTimeout(location_timeout);

                    var lat = position.coords.latitude;
                    var lng = position.coords.longitude;
                   alert("Your location has been shared to ACT. You will receive a confirmation about broadband connection feasibility at your location  Lat [" + lat + "]  lan ["+ lng+"]");
                   Feasibility.fesibilityVerify({key: $stateParams.key, latitude: lat,longitude: lng }).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if(response.status === 400 && response.data === 'email link invalid'){
                   	 vm.emaillinkinvalid = 'ERROR';
                    }else{
                    	vm.error = 'ERROR';
                    }
                    
                })
                   
                   
                   // geocodeLatLng(lat, lng);
                }, function(error) {
                      alert(error.message);
                    clearTimeout(location_timeout);
                    geolocFail();
                });
            } else {
                  alert("Turn on the location service to make the deposit");
                // Fallback for no geolocation
                geolocFail();
            }
            
            
            
        }
        
        
        
        function geolocFail(){
        	 alert("Turn on the location service to Verify feasibility");
        	 document.write("Turn on the location service to Verify feasibility");
        	}
        
        function geocodeLatLng(lat, lng) {
        	var latlng = new google.maps.LatLng(lat, lng);
       	geocoder.geocode({'latLng': latlng}, function(results, status) {
        	if (status == google.maps.GeocoderStatus.OK) {
        	if (results[1]) {
        	//formatted address
       	var add= results[0].formatted_address
        	alert(add);

        	//city data
        	//alert(city.short_name + " " + city.long_name)

        	} else {
        	alert("No results found");
        	}
        	} else {
        	alert("Geocoder failed due to: " + status);
        	}
        	});
        	}
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('Feasibility', Feasibility);

    Feasibility.$inject = ['$rootScope', '$http', 'FeasibilityVerifyFinish'];

    function Feasibility ($rootScope, $http,FeasibilityVerifyFinish) {
        var service = {
           
            fesibilityVerify: fesibilityVerify
            
        };
        return service;
        
        function fesibilityVerify (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return FeasibilityVerifyFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }
        
    }
})();
(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('trakeyeApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/dashboard/dashboard-rollout.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-home"></i> <span>Rollout</span></h3></div></div><div class="box-body rollout-container mh-90vh"><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><div class="w-190"><select class="form-control select2 selectRoutes" id="projectSearch" ng-model="vm.projectDetail" ng-options="item.id as item.name for item in vm.storeProjects" ng-change="vm.onProjectChange()"><option value="" disabled="disabled"><span>--- Select Project ---</span></option></select></div><div id="map_canvas" ng-style="{\'height\': 46 + \'vh\'}"></div></div><div class="col-md-8" id="getHeight" ng-show="vm.projectList"><div><div class="flexBetween"><div ng-show="vm.projectList"><span class="rollout-name">Project <span class="square--{{vm.projectList.ragStatus}}">{{vm.projectList.name | limitTo: 20}}</span></span> <span class="rollout-name" ng-hide="!vm.routeResponse.length">Route <span class="rollout-value" ng-hide="!vm.routeResponse.length"><select class="form-control select2 selectRoutes" ng-model="vm.routeId" ng-options="item.id as item.name for item in vm.routeResponse" ng-change="vm.onRouteChange()"><option value="" disabled="disabled"><span>--- Select Routes ---</span></option></select></span></span><span class="rollout-name" ng-show="vm.routeId && vm.workorderList.length">Work Order <span ng-show="vm.routeId && vm.workorderList.length"><select class="form-control select2 selectRoutes" ng-model="vm.workOrderId" ng-options="item.id as item.name for item in vm.workorderList" ng-change="vm.onWorkOrderChange()"><option value="" disabled="disabled"><span>--- Select Workorder ---</span></option></select></span></span></div></div><h4 ng-show="!vm.routeResponse.length">No Routes available</h4><div id="workflow_map_canvas" ng-show="vm.routeResponse.length"></div><div class="dropFilter pull-left" ng-show="(vm.terrainPathResponse.length || vm.rowPathResponse.length) && (vm.routeResponse.length)"><div isteven-multi-select input-model="vm.mapFilterList" group-property="msGroup" output-model="vm.selectedTerrainName" button-label="name" item-label="name strokeColor" tick-property="visible" translation="type.terrain" output-properties="name visible" helper-elements="all none Done filter" on-select-done="togglePolyline()" max-height="170px" max-labels="1" disable-property="routeDisable"></div></div></div></div></div><div class="row mt-10 d-Flex"><div class="w-fc dashboard_opencases rollout-container ml-15" ng-if="vm.objectTaskStatus[\'Route-Task\']"><div class="open-head"><span class="case-heading">Route Tasks</span></div><div class="flexEvenWrap"><div class="pl-0 mr-15" ng-repeat="(key, value) in vm.objectTaskStatus[\'Route-Task\']"><div class="dashboard_opencases"><div class="open-head"><span class="stageName">{{key}}</span></div><div class="flexEvenWrap"><div ng-repeat="status in value"><h5 class="statusName mr-15">{{status.taskTypeName}}</h5><div class="progress mr-15"><div class="bar" ng-style="{\'width\': status.percentage + \'%\'}"><p class="percent">{{status.percentage}}%</p></div></div></div></div></div></div></div></div><div class="w-fc dashboard_opencases rollout-container ml-15" ng-if="vm.objectTaskStatus[\'Section-Task\']"><div class="open-head"><span class="case-heading">Section Tasks</span></div><div class="flexEvenWrap"><div class="pl-0 mr-15" ng-repeat="(key, value) in vm.objectTaskStatus[\'Section-Task\']"><div class="dashboard_opencases"><div class="open-head"><span class="stageName">{{key}}</span></div><div class="flexEvenWrap"><div ng-repeat="status in value"><h5 class="statusName mr-15">{{status.taskTypeName}}</h5><div class="progress mr-15"><div class="bar" ng-style="{\'width\': status.percentage + \'%\'}"><p class="percent">{{status.percentage}}%</p></div></div></div></div></div></div></div></div><!-- <div  class="rollout-container col-md-12 pl-0" ng-show="vm.taskstatus.length">\r\n                            <div class="col-md-3 pl-0" ng-repeat="status in vm.taskstatus"><h5>{{status.taskStage}}</h5><div class="progress">\r\n                                <div class="bar"  ng-style="{\'width\': status.percentage + \'%\'}">\r\n                                    <p class="percent">{{status.percentage}}%</p>\r\n                                </div>\r\n                            </div>  </div>\r\n                       </div>  --></div><div class="row"><div class="col-md-12 col-sm-12 mt-5" ng-show="vm.mtrlTxSummary.length"><div class="box box-solid"><div class="box-header with-border" style="height:38.42px"><div class="col-md-12"><h3 class="box-title">Material Transaction</h3><ul class="legends pull-right"><li ng-repeat="legend in legends"><span class="barCircle" ng-style="{\'background-color\': legend.color}"></span> {{legend.name}}</li></ul></div></div><div class="box-body chart-responsive" id="parentMaterial"><!--  <div  id="{{key}}" ng-repeat="(key,value) in vm.uomMaterialTransaction">\r\n                                    {{key}}\r\n                                </div> --></div></div></div><div class="col-md-12 col-sm-12 mt-5" ng-show="vm.resTxSummary.length"><div class="box box-solid"><div class="box-header with-border" style="height:38.42px"><div class="col-md-12"><h3 class="box-title">Resource Transaction</h3><ul class="legends pull-right"><li ng-repeat="legend in legends"><span class="barCircle" ng-style="{\'background-color\': legend.color}"></span> {{legend.name}}</li></ul></div></div><div class="box-body chart-responsive"><div id="RESOURCES"></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/dashboard/dashboard.html','<div ng-cloak><div class="content" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE"><div class="row mt-5"><!--  <div class="col-sm-3">\r\n                 <h2>Welcome, UserName! &#128075;</h2> \r\n                 <div class="dashboard_time">\r\n                    <h2 class="text-center" style="margin-top: 3%;">{{vm.time}}</h1>\r\n                        <h4 class="text-center">{{vm.day}}, {{vm.month}} {{vm.todayDate}}, {{vm.year}}</h4>   \r\n                </div> \r\n            </div> --><!--col-sm-3--><div class="col-sm-5"><div class="dashboard_opencases"><div class="open-head"><i class="fa fa-file-text-o" aria-hidden="true" style="color:rgba(0, 0, 0, 0.39)"></i><span class="case-heading"> Open Incidents - Priority view</span></div><div class="clearfix"></div><div class="col-md-3 col-sm-3 col-xs-6 notification-border plr-5"><h3 class="red" style="color: #a10000">Critical</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.priority({priority:\'CRITICAL\',geofenceId:vm.masterGeofence})"><span class="notification-count text-info">{{vm.casepriority.CRITICAL}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-info">{{vm.casepriority.CRITICAL}}</span></div></div><!--notification--><div class="col-md-3 col-sm-3 col-xs-6 notification-border plr-5"><h3 class="yellow" style="color: #FF0000;">High</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.priority({priority:\'HIGH\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.casepriority.HIGH}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.casepriority.HIGH}}</span></div></div><!--notification--><div class="col-md-3 col-sm-3 col-xs-6 notification-border plr-5"><h3 class="green">Medium</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.priority({priority:\'MEDIUM\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.casepriority.MEDIUM}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.casepriority.MEDIUM}}</span></div></div><!--notification--><div class="col-md-3 col-sm-3 col-xs-6 plr-5"><h3 class="blue" style="color: #7bc9de;">Low</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.priority({priority:\'LOW\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.casepriority.LOW}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.casepriority.LOW}}</span></div></div><!--notification--></div><!--dashboard_opencases--></div><!--col-sm-5--><div class="col-sm-4"><div class="dashboard_opencases"><div class="open-head"><i class="fa fa-user" aria-hidden="true" style="color:rgba(0, 0, 0, 0.39)"></i><span class="case-heading"> Patrollers/FRT</span></div><div class="clearfix"></div><div class="col-md-4 col-sm-4 col-xs-6 notification-border plr-5"><h3 class="green">Active</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="user-management.status({status:\'ACTIVE\',geofenceId:vm.masterGeofence})"><span class="notification-count text-info">{{vm.users.ACTIVE}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-info">{{vm.users.ACTIVE}}</span></div></div><!--notification--><div class="col-md-4 col-sm-4 col-xs-6 notification-border plr-5"><h3 class="yellow">Idle</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="user-management.status({status:\'IDLE\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.users.IDLE}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.users.IDLE}}</span></div></div><!--notification--><div class="col-md-4 col-sm-4 col-xs-6 plr-5"><h3 class="inactive">Inactive</h3><div class="notification-content text-center" ng-hide="has_ROLE_VENDOR"><a ui-sref="user-management.status({status:\'INACTIVE\',geofenceId:vm.masterGeofence})"><span class="notification-count text-success">{{vm.users.INACTIVE}}</span></a></div><div class="notification-content text-center" ng-if="has_ROLE_VENDOR"><span class="notification-count text-success">{{vm.users.INACTIVE}}</span></div></div><!--notification--></div><!--dashboard_opencases--></div><div class="col-md-3"><div class="open-head"><i class="fa fa-user" aria-hidden="true" style="color:rgba(0, 0, 0, 0.39)"></i><span class="case-heading"> District</span></div><select id="masterGeofence" ng-model="vm.masterGeofence" ng-change="optionChange()"><option value="">All District</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select><br><span id="noData" ng-if="vm.masterGeofence==\'\'">*Please Select District</span></div><!--col-sm-5--></div><div class="row" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_case_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE"><!-- <div class="col-md-6 ">\r\n\t\t\t<div class="box box-solid ">\r\n\t\t\t<div class="box-header ">\r\n\t\t\t  <h3 class="box-title ">Geo Fence Report</h3>\r\n\t\t\t</div>\r\n\t\t\t<div class="box-body chart-responsive ">\r\n\t\t\t  <div class="chart " id="bar-chart " style="height: 300px; "></div>\r\n\t\t\t</div>\r\n         </div>\r\n        </div>--><div class="col-md-12 col-sm-12"><!-- Map box --><div class="box box-solid"><div class="box-header with-border"><div class="col-md-4"><h3 class="box-title">Agent Status Report - Geofence view</h3></div><div ng-hide="vm.isGeofences" class="col-md-4" id="status"></div></div><div class="box-body chart-responsive"><h4 ng-show="vm.isGeofences">No data available</h4><div ng-hide="vm.isGeofences" id="stacked-chart-status" style="height: 247px; position: relative;"></div></div><!-- <div class="box-header ">\r\n                        <h3 class="box-title ">Site Asset View</h3>\r\n                    </div>\r\n                    <div class="box-body chart-responsive ">\r\n                        <div id="geo1 " style=" "></div>\r\n                    </div> --><!-- /.box-body --></div></div><div class="col-md-6 col-sm-12"><div class="box box-solid"><div class="box-header with-border" style="height: 48px;"><div class="col-md-12"><h3 class="box-title mt-5">Incidents - Status view</h3></div></div><div class="box-body chart-responsive"><div id="case-chart" style="height: 285px; position: relative;"></div></div><!-- /.box-body --></div></div><!-- <div class="col-md-4 col-sm-12">\r\n                <div class="box box-solid ">\r\n                    <div class="box-header with-border">\r\n                        <h3 class="box-title ">Services Chart</h3>\r\n                    </div>\r\n                    <div class="box-body chart-responsive ">\r\n                        <div  id="service-chart" style="height: 285px; position: relative; "></div>\r\n                    </div>\r\n                </div>\r\n            </div> --><div class="col-xs-12 col-md-6"><div class="box box-solid" style="height: 346px"><div class="box-header with-border"><div class="col-md-6"><h3 class="box-title mt-5">Agent Activity Report</h3></div><div class="col-md-6"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control input-sm" placeholder="Search" ng-model="search" style="border-top-left-radius: 15px;\r\n                                        border-bottom-left-radius: 15px;"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat header-button" style="background-color:#efefef !important;"><i class="fa fa-search" style="color:#fd7124"></i></button></span></div></div></div><!-- <div class="col-md-12 mt-5 mb-5 ">\r\n                        \r\n                    </div> --><div class="box-body scrollbar" style="height: fit-content;" id="style-3" ng-hide="has_ROLE_VENDOR"><ul class="nav nav-stacked"><!--  <li ng-repeat="user in vm.userslist ">--><!-- <li dir-paginate="user in users = (vm.userslist|filter:search) | itemsPerPage: vm.itemsPerPage "\r\n                                style="text-align: center;">\r\n                                <a ui-sref="location-log.login({login: \'{{user.login}}\'}) ">\r\n                                    <div class="col-md-12" style="height: 40px;">\r\n                                        <div class="col-md-4 ">\r\n                                            <i class="pull-left fa fa-user" style="text-align: left;width: auto;"\r\n                                            aria-hidden="true ">\r\n                                            {{user.login}}</i>\r\n                                        </div>\r\n            \r\n                                        <div class="col-md-2 ">\r\n                                            <span class="badge bg-grey" style="width: auto;">{{user.cases |\r\n                                                number}}</span>\r\n                                        </div>\r\n                                        <div class="col-md-3 ">\r\n                                            <span class="badge bg-grey " style="width: auto;">{{(user.percentageCovered).toFixed(2)}} %</span>\r\n                                        </div>\r\n                                        <div class="col-md-3 ">\r\n                                            <span class="pull-right badge bg-grey " style="width: auto;">{{user.distance |\r\n                                                number}} KM</span>\r\n                                        </div>\r\n                                    <div>\r\n                                </a>\r\n                            </li> --><div class="case-table" aria-hidden="false"><div class="table-responsive mt-10"><table class="table table-responsive table-hover"><thead class="bg-default"><tr class="font_sizeEm"><th class="pull-left" ng-click="setOrderProperty(\'login\')">Agent Name <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'cases\')">Assigned Incidents <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'percentageCovered\')">Target Covered <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'distance\')">Distance <span class="fa fa-sort"></span></th></tr></thead><tbody><!----><tr dir-paginate="user in users = (vm.userslist|filter:search) | itemsPerPage: vm.itemsPerPage | orderBy:orderProperty" style="text-align: center;"><td class="pull-left"><a ui-sref="location-log.login({login: user.login})" style="display:block; color: inherit; text-decoration: none;"><i class="fa fa-user mr-5" aria-hidden="true "></i> <span>{{user.login}}</span></a></td><td><a ui-sref="location-log.login({login: user.login})" style="display:block; color: inherit; text-decoration: none;"><span class="bg-grey">{{user.cases | number}}</span></a></td><!-- <div><span>{{user.reportCases |\r\n                                        number}}</span></div> --><td><a ui-sref="location-log.login({login: user.login})" style="display:block; color: inherit; text-decoration: none;"><span class="badge bg-grey" ng-style=" (user.percentageCovered >= 70) && {\'background-color\':\'#00e658\'}  || (user.percentageCovered >= 34) && {\'background-color\':\'#FD7A24\'} || (user.percentageCovered <= 33) && {\'background-color\':\'#FF0000\'}">{{(user.percentageCovered).toFixed(2)}} %</span></a></td><td><a ui-sref="location-log.login({login: user.login})" style="display:block; color: inherit; text-decoration: none;"><span>{{user.distance | number}} KM</span></a></td></tr></tbody></table></div></div><!-- <div class="flex-container">\r\n                                <div>\r\n                                    Agent <span class="fa fa-sort" ng-click="setOrderProperty(\'login\')"></span> Name  \r\n                                </div>\r\n        \r\n                                <div>\r\n                                   Assigned <span class="fa fa-sort" ng-click="setOrderProperty(\'cases\')"></span> Incidents \r\n                                </div>\r\n                                 <div>\r\n                                    Reported <span class="fa fa-sort" ng-click="setOrderProperty(\'rCases\')"></span> Incidents \r\n                                </div>\r\n                                <div>\r\n                                    Target <span class="fa fa-sort" ng-click="setOrderProperty(\'percentageCovered\')"></span> Covered \r\n                                </div>\r\n                                <div>\r\n                                    Distance <span class="fa fa-sort" ng-click="setOrderProperty(\'distance\')"></span>\r\n                                </div>\r\n                            </div> --><!-- <li dir-paginate="user in users = (vm.userslist|filter:search) | itemsPerPage: vm.itemsPerPage "\r\n                                style="text-align: center;">\r\n                                <a ui-sref="location-log.login({login: \'{{user.login}}\'}) ">\r\n                                    <i class="pull-left fa fa-user" style="width: 200px;text-align: left;"\r\n                                        aria-hidden="true ">\r\n                                        {{user.login}}</i>\r\n                                    <span class="badge bg-grey">{{user.cases |\r\n                                        number}}</span>\r\n                                    <span class="badge bg-grey " style="width: 80px;">{{(user.percentageCovered).toFixed(2)}} %</span>\r\n                                    <span class="pull-right badge bg-grey " style="width: 100px;">{{user.distance |\r\n                                        number}} KM</span>\r\n                                </a>\r\n                            </li> --><li ng-show="vm.userslist==0" style="text-align: center;"><h4>No data available</h4></li></ul></div><div class="box-body scrollbar" id="style-3" ng-if="has_ROLE_VENDOR"><ul class="nav nav-stacked"><!--  <li ng-repeat="user in vm.userslist ">--><li dir-paginate="user in vm.userslist | itemsPerPage: vm.itemsPerPage " style="text-align: center;"><a><i class="pull-left fa fa-user" style="width: 200px;text-align: left;" aria-hidden="true ">{{user.login}}</i> <span class="badge bg-grey">{{user.cases | number}}</span> <span class="pull-right badge bg-grey" style="width: 160px;">{{user.distance | number}} KM</span></a></li><li ng-show="vm.userslist==0" style="text-align: center;"><h4>No data available</h4></li></ul></div><div class="row mt-5"><!--<div class="col-md-4 ">\r\n\t\t\t\t\t\t\t<div class="count-length ">\r\n\t\t\t\t\t\t\t\t<jhi-item-count page="vm.page " total="vm.queryCount " items-per-page="vm.itemsPerPage "></jhi-item-count>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>--><div class="col-md-12"><div class="pull-right pr-10"><div class="pagination-list"><!--  <uib-pagination class="pagination-sm pagination-bottom " total-items="vm.totalItems " ng-model="vm.page " ng-change="vm.transition() "></uib-pagination>--><dir-pagination-controls direction-links="true " boundary-links="true "></dir-pagination-controls></div></div></div></div><!-- /.box-body --></div></div></div><!-- <div class="col-md-12 col-sm-12 text-center">\r\n            <strong>&copy; {{vm.currYear}} Polycab Inc\r\n            </strong>\r\n        </div> --></div></div>');
$templateCache.put('app/dashboard/incident.html','<div ng-cloak><div class="content" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA || has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE||has_ROLE_READONLY"><div class="d-flex justify-content-between align-items-center mb-3"><!-- Filters --><!-- HTML --><div class="row g-3 mb-4 dashboard-row" style="margin-bottom: 5px;"><!-- <div class="col-12 col-lg-4">\r\n                    <div class="cards dashboard-card h-100">\r\n                        <h3 class="page-title mb-0" style="text-align: center;">Incident Dashboard</h3>\r\n                    </div>\r\n                </div> --><!-- filters --><div class="col-12 col-lg-12"><div class="row g-2"><!-- DATE RANGE (Popup style) --><div class="col-12 col-sm-6 col-lg-2 position-relative"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600; margin-bottom: 0px;">Date Range</label> <input id="incident-date-range-input" type="text" class="form-control form-control-sm" ng-model="vm.dateRange" placeholder="Date Range" ng-focus="vm.showDatePopup = true" readonly="readonly" title="Date Range" style="height: 32px; width: 100%;"><!-- POPUP --><div id="incident-date-popup" class="card shadow p-3" ng-show="vm.showDatePopup" style="position:absolute; z-index:999; width:100%; background:#fff;"><label class="form-label mb-1" style="font-size: 11px; font-weight: 600;">From Date</label><div class="input-group mb-2"><input type="text" class="form-control form-control-sm" name="fromDate" required readonly="readonly" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate" when-closed="vm.onDatePickerClosed(\'fromDate\', args)" max-date="vm.toDate || vm.maxDate" datepicker-options="vm.datePickerOptions" title="From Date"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'fromDate\')" title="Open from date"><i class="glyphicon glyphicon-calendar"></i></button></span></div><label class="form-label mb-1" style="font-size: 11px; font-weight: 600;">To Date</label><div class="input-group mb-3"><input type="text" class="form-control form-control-sm" name="toDate" required readonly="readonly" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate" when-closed="vm.onDatePickerClosed(\'toDate\', args)" min-date="vm.fromDate" max-date="vm.maxDate" datepicker-options="vm.datePickerOptions" title="To Date"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'toDate\')" title="Open to date"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div class="alert alert-danger mb-2" ng-show="vm.dateValidationError" role="alert">{{vm.dateValidationError}}</div><button class="btn btn-primary btn-sm" ng-click="vm.applyDateRange()">Apply</button> <button class="btn btn-light btn-sm float-end" ng-click="vm.showDatePopup=false">Cancel</button></div></div><!-- AMC Status --><div class="col-12 col-sm-6 col-lg-1"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Status</label> <select class="form-select form-select-sm" ng-model="vm.selectedAMCStatus" ng-change="vm.onAMCStatusChange(vm.selectedAMCStatus)" title="Status" style="height: 32px; width: 100%;" ng-options="status.id as status.name for status in vm.amcStatusList"><!-- <option value="">-- Select Status --</option> --></select></div><!-- Package --><div class="col-12 col-sm-6 col-lg-1"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Package</label> <select class="form-select form-select-sm" ng-model="vm.selectedPackage" ng-change="vm.onPackageChange(vm.selectedPackage)" title="Package" ng-disabled="!vm.packageList || vm.packageList.length === 0" style="height: 32px; width: 100%;" ng-options="package.id as package.name for package in vm.packageList"><option value="">-- Select Package --</option></select></div><!-- State --><div class="col-12 col-sm-6 col-lg-1"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">State</label> <select class="form-select form-select-sm" ng-model="vm.selectedState" ng-change="vm.onStateChange(vm.selectedState)" title="State" ng-disabled="!vm.stateList || vm.stateList.length === 0" style="height: 32px; width: 100%;" ng-options="state.id as state.name for state in vm.stateList"><option value="">-- Select State --</option></select></div><!-- BUSINESS AREA --><div class="col-12 col-sm-6 col-lg-1"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Business Area</label> <select class="form-select form-select-sm" ng-model="vm.selectedBusinessArea" ng-change="vm.opertionalAreaSelect(vm.selectedBusinessArea)" title="Business Area" ng-disabled="!vm.businessAreaName || vm.businessAreaName.length === 0" style="height: 32px; width: 100%;" ng-options="businessArea.id as businessArea.businessAreaName for businessArea in vm.businessAreaName"><option value="">-- Select Business Area --</option></select></div><!-- OPERATIONAL AREA --><div class="col-12 col-sm-6 col-lg-1"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Operational Area</label> <select class="form-select form-select-sm" ng-model="vm.selectedOperationalAreaName" ng-change="vm.onOperationalAreaChange(vm.selectedOperationalAreaName)" ng-disabled="!vm.operationalAreaName || vm.operationalAreaName.length === 0" title="Operational Area" style="height: 32px; width: 100%;"><option value="">-- Select Operational Area --</option><option ng-repeat="op in vm.operationalAreaName" ng-value="op.id">{{op.opAreaName}}</option></select></div><!-- District --><div class="col-12 col-sm-6 col-lg-1"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">District</label> <select class="form-select form-select-sm" ng-model="vm.selectedDistrict" ng-change="vm.onDistrictChange(vm.selectedDistrict)" title="District" ng-disabled="!vm.districtList || vm.districtList.length === 0" style="height: 32px; width: 100%;"><option value="">-- Select District --</option><option ng-repeat="district in vm.districtList" ng-value="district.id">{{district.name}}</option></select></div><!-- Block --><div class="col-12 col-sm-6 col-lg-1"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Block</label> <select class="form-select form-select-sm" ng-model="vm.selectedBlock" ng-change="vm.onBlockChange(vm.selectedBlock)" title="Block" ng-disabled="!vm.blockList || vm.blockList.length === 0" style="height: 32px; width: 100%;"><option value="">-- Select Block --</option><option ng-repeat="block in vm.blockList" ng-value="block.id">{{block.name}}</option></select></div><!-- GP --><div class="col-12 col-sm-6 col-lg-1"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">GP</label> <select class="form-select form-select-sm" ng-model="vm.selectedGP" ng-change="vm.onGPChange(vm.selectedGP)" title="GP" ng-disabled="!vm.gpList || vm.gpList.length === 0" style="height: 32px; width: 100%;"><option value="">-- Select GP --</option><option ng-repeat="gp in vm.gpList" ng-value="gp.id">{{gp.name}}</option></select></div><!-- Case Type --><!-- <div class="col-12 col-sm-6 col-lg-2">\r\n                            <select class="form-select form-select-sm" ng-model="vm.selectedCaseType"\r\n                                ng-change="vm.onCaseTypeChange(vm.selectedCaseType)" title="Case Type"\r\n                                style="height: 32px; width: 100%;">\r\n                                <option value="">Case Type</option>\r\n                                <option ng-repeat="caseType in vm.caseTypeList" ng-value="caseType.id">\r\n                                    {{caseType.name}}\r\n                                </option>\r\n                            </select>\r\n                        </div> --></div></div></div><!-- Divider Line --><hr class="dashboard-divider"><!-- Summary cards --><!-- Dashboard Metrics in Separate Cards --><div class="row g-3 mb-4"><!-- Total Incidents Card --><!-- <div class="col-12 col-md-2">\r\n                    <div class="card h-100">\r\n                        <div class="card-body d-flex flex-column justify-content-center align-items-center py-3 px-2">\r\n                            <div class="stat-label mb-2">GP Down Count</div>\r\n                            <div class="stat-count">{{ (vm.priorityTotals.ASSIGNED || 0)}}/{{\r\n                                (vm.priorityTotals.TOBEASSIGNED || 0) + (vm.priorityTotals.RESOLVED || 0) }}\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div> --><!-- Open & Resolved Incidents Card --><div class="col-12 col-md-3"><div class="card h-100"><div class="card-body d-flex justify-content-center align-items-center p-2"><div style="display: flex; justify-content: space-between; align-items: center; width: 100%; gap: 8px;"><!-- Open Incidents --><div style="flex: 1; text-align: center; cursor: pointer;" ng-click="vm.toggleOpenIncidentsTable()"><div class="stat-label">Open</div><div class="stat-count">{{(vm.priorityTotals.ASSIGNED || 0) + (vm.priorityTotals.TOBEASSIGNED || 0) + (vm.priorityTotals.INPROGRESS || 0)}}/{{(vm.priorityTotals.ASSIGNED || 0) + (vm.priorityTotals.TOBEASSIGNED || 0) + (vm.priorityTotals.RESOLVED || 0) + (vm.priorityTotals.INPROGRESS || 0) + (vm.priorityTotals.PENDING || 0) + (vm.priorityTotals.CLOSED || 0) }}</div></div><!-- Divider --><div style="width: 1px; height: 50px; background-color: #dee2e6; flex-shrink: 0;"></div><!-- Resolved Incidents --><div style="flex: 1; text-align: center; cursor: pointer;" ng-click="vm.openMttrDetailsTable()" title="Click to view MTTR details"><div class="stat-label">Resolved + Closed</div><div class="stat-count" title="Resolved: {{ (vm.priorityTotals.RESOLVED || 0) }} / Closed: {{ (vm.priorityTotals.CLOSED || 0) }}">{{ (vm.priorityTotals.RESOLVED || 0) + (vm.priorityTotals.CLOSED || 0) }}</div></div></div></div></div></div><!-- SLA Metrics Combined Card (All in one row) --><div class="col-12 col-md-5"><div class="card h-100"><div class="card-body p-2"><div style="display: flex; justify-content: space-between; align-items: center; height: 100%; gap: 8px;"><!-- Avg. Resolution Time --><div style="flex: 1; text-align: center; cursor: pointer;" ng-click="vm.openMttrDetailsTable()" title="Click to view MTTR details"><div class="stat-label">Avg. Resolution Time</div><!-- <div class="stat-count">{{ (vm.priorityTotals.NEW || 0) +\r\n                                        (vm.priorityTotals.TOBEASSIGNED || 0) + (vm.priorityTotals.RESOLVED || 0) }} hrs\r\n                                    </div> --><div class="stat-count">{{ vm.avgResolutionHours || 0 }} hrs</div></div><!-- Divider --><div style="width: 1px; height: 50px; background-color: #dee2e6; flex-shrink: 0;"></div><!-- SLA Compliance --><div style="flex: 1; text-align: center; cursor: pointer;" ng-click="vm.openMttrDetailsTable()" title="Click to view MTTR details"><div class="stat-label">SLA Compliance</div><div class="stat-count" title="Resolved within SLA: {{vm.resolvedwithinTimeCount}} / Total: {{(vm.priorityTotals.ASSIGNED || 0) + (vm.priorityTotals.TOBEASSIGNED || 0) + (vm.priorityTotals.RESOLVED || 0) + (vm.priorityTotals.INPROGRESS || 0) + (vm.priorityTotals.PENDING || 0) + (vm.priorityTotals.CLOSED || 0)}}">{{ (vm.slaCompliancePerc || 0) | number:1 }}%</div></div><!-- Divider --><div style="width: 1px; height: 50px; background-color: #dee2e6; flex-shrink: 0;"></div><!-- Near Threshold --><div style="flex: 1; text-align: center; cursor: pointer;" ng-click="vm.toggleNearToBreachTable()" title="Click to view Near Threshold incidents"><div class="stat-label">Near Threshold</div><div class="stat-count">{{ (vm.nearToBreachCount || 0) }}</div></div></div></div></div></div><!-- GP Down Card --><div class="col-12 col-md-2" ng-hide="vm.selectedGP"><div class="card h-100"><div class="card-body d-flex flex-column justify-content-center align-items-center py-3 px-2 text-center"><div class="w-100"><div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer; line-height: 1;" ng-click="vm.toggleGpDownTable()"><span class="stat-label" style="margin: 0;">GP Down</span> <span class="stat-count" style="margin: 0;">{{ vm.gpDownCount || 0 }}/{{ vm.totalGPCount || 0 }}</span></div><div style="height: 8px;"></div><div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer; line-height: 1;" ng-click="vm.toggleBlockDownTable()"><span class="stat-label" style="margin: 0;">Block Down</span> <span class="stat-count" style="margin: 0;">{{ vm.blockDownCount || 0 }}/{{ vm.totalBlockCount || 0 }}</span></div></div></div></div></div><!-- Patroller & FRT Card --><div class="col-12 col-md-2"><div class="card h-100"><div class="card-body d-flex flex-column justify-content-center align-items-center py-3 px-2 text-center"><div class="w-100"><div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer; line-height: 1;" ng-click="vm.togglePatrollerTable()"><span class="stat-label" style="margin: 0;">Patroller</span> <span class="stat-count" style="margin: 0;" title="Actual: {{ vm.patrollerCurrentDayCheckInCount || 0 }} / Planned: {{ vm.patrollerCount || 0 }}">{{ vm.patrollerCurrentDayCheckInCount || 0 }}/{{ vm.patrollerCount || 0 }}</span></div><div style="height: 6px;"></div><div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer; line-height: 1;" ng-click="vm.toggleFrtTable()"><span class="stat-label" style="margin: 0;">FRT</span> <span class="stat-count" style="margin: 0;" title="Actual: {{ vm.frtCurrentDayCheckInCount || 0 }} / Planned: {{ vm.frtCount || 0 }}">{{ vm.frtCurrentDayCheckInCount || 0 }}/{{ vm.frtCount || 0 }}</span></div></div></div></div></div><!-- Open Incidents Card --><!-- <div class="col-12 col-md-3">\r\n                    <div class="card h-100">\r\n                        <div class="card-body d-flex flex-column justify-content-center align-items-center py-3 px-2">\r\n                            <div class="stat-label mb-2">Open Incidents</div>\r\n                            <div class="stat-count">{{(vm.priorityTotals.ASSIGNED || 0) +\r\n                                (vm.priorityTotals.TOBEASSIGNED || 0)}}/{{(vm.priorityTotals.ASSIGNED || 0) +\r\n                                (vm.priorityTotals.TOBEASSIGNED || 0) + (vm.priorityTotals.RESOLVED || 0)}}</div>\r\n                        </div>\r\n                    </div>\r\n                </div> --></div><!-- Charts Section --><div class="row g-3 dashboard-charts"><div class="col-12 col-md-4"><div class="card h-100"><div class="card-body"><h6 class="card-title">Incidents By Status and Priority</h6><div id="overall-distribution-chart"></div></div></div></div><!-- <div class="col-12 col-md-3">\r\n                    <div class="card h-100">\r\n                        <div class="card-body">\r\n                            <h6 class="card-title">Overall Distribution</h6>\r\n                            <div id="overall-distribution-chart"></div>\r\n                        </div>\r\n                    </div>\r\n                </div> --><div class="col-12 col-md-8"><div class="card h-100"><div class="card-body"><h6 class="card-title">SLA Trend</h6><div id="overall-observation-chart"></div></div></div></div><!-- <div class="col-12 col-md-3">\r\n                    <div class="card h-100">\r\n                        <div id="incident-map" style="width: 100%; height: 355px;"></div>\r\n                    </div>\r\n                </div> --></div></div><!-- Status Pie Chart --><!-- <div class="row g-3 mb-3">\r\n                <div class="col-12 col-md-6">\r\n                    <div class="card h-100">\r\n                        <div class="card-body">\r\n                            <h6 class="card-title">Overall Status Distribution</h6>\r\n                            <div id="overall-status-chart"></div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div> --><!-- Multiple Donut Charts for Business Area Incidents --><!-- Common Legend Above Donut Charts --><!-- <div class="donut-common-legend mb-2">\r\n                <div><span style="color:#ff5c5c;">\xE2\u2014\uFFFD</span> Critical</div>\r\n                <div><span style="color: #ffa533;;">\xE2\u2014\uFFFD</span> High</div>\r\n                <div><span style="color:#00e658;">\xE2\u2014\uFFFD</span> Medium</div>\r\n                <div><span style="color:#294985;">\xE2\u2014\uFFFD</span> Low</div>\r\n            </div> --><!-- bar chart cards --><!-- <div class="dashboard_opencases1">\r\n                <div class="card-title">Overall Open Incidents</div>\r\n                <div class="scroll-inner">\r\n                    <div ng-repeat="area in vm.businessAreaCases">\r\n                        <div class="section-title text-center">{{area.areaName}}</div>\r\n                        <div class="chart-wrapper">\r\n                            <div id="donut-chart-{{$index}}"></div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div> --><!-- commented --><!-- <div class="row g-3 mb-3">\r\n                <div class="col-md-8">\r\n                    <div class="dashboard_opencases1">\r\n                        <div class="card-title">MTTR</div>\r\n                        <div class="scroll-inner">\r\n                            <div ng-repeat="area in vm.businessAreaCases">\r\n                                <div class="section-title text-center">{{area.areaName}}</div>\r\n                                <div class="chart-wrapper">\r\n                                    <div id="bar-chart-{{$index}}"></div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div> --><!-- <div class="col-md-4">\r\n                    <div class="dashboard_opencases1">\r\n                        <div class="card-title">Avg. Response Time vs Avg. Resolution Time</div>\r\n                        <div class="chart-wrapper">\r\n                            <div id="response-time-chart"></div>\r\n                        </div>\r\n                    </div>\r\n                </div> --><!-- SLA Breach Table --><div class="row g-3 mb-4" ng-hide="vm.showOpenIncidentsTable || vm.showResolvedIncidentsTable || vm.showNearToBreachTable || vm.showPatrollerTable || vm.showFrtTable || vm.showGpDownTable || vm.showBlockDownTable || vm.showMttrDetailsTable"><div class="col-12 col-md-12"><div class="table-card"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"><div class="section-title" style="margin: 0;">SLA Breach</div><div style="display: flex; gap: 10px; align-items: center;"><div style="width: 220px;"><select class="form-select form-select-sm" ng-model="vm.selectedAlertType" ng-options="option.id as option.name for option in vm.alertTypeFilterOptions" ng-change="vm.onAlertTypeChange()" title="Alert Type" style="height: 32px; width: 100%;"></select></div><div style="width: 250px;"><div class="input-group input-group-sm"><input type="text" ng-model="vm.slaBreachSearch" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-success btn-sm" ng-click="vm.exportSLABreachCSV()" ng-disabled="!vm.slaBreaches || vm.slaBreaches.length === 0" title="Download as CSV"><i class="fa fa-download"></i> CSV</button> <button class="btn btn-primary btn-sm" ng-click="vm.exportFilteredSLABreachCSV()" ng-disabled="!vm.hasFilteredSlaBreachData()" title="Download filtered data as CSV"><i class="fa fa-download"></i> Filtered CSV</button></div></div><div class="table-responsive"><table class="table table-hover"><thead class="thead-light"><tr><th ng-click="vm.sortTable(\'\', \'createdDate\')" style="cursor: pointer;">Created Date and Time <span class="fa" ng-class="vm.predicate === \'createdDate\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><!-- <th ng-click="vm.sortTable(\'\', \'incidentId\')" style="cursor: pointer;">Incident ID\r\n                                        <span class="fa"\r\n                                            ng-class="vm.predicate === \'incidentId\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span>\r\n                                    </th> --><!-- <th>State</th> --><th ng-click="vm.sortTable(\'\', \'ticketId\')" style="cursor: pointer;">Ticket ID <span class="fa" ng-class="vm.predicate === \'ticketId\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'\', \'description\')" style="cursor: pointer;">Title <span class="fa" ng-class="vm.predicate === \'description\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'\', \'district\')" style="cursor: pointer;">District <span class="fa" ng-class="vm.predicate === \'district\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'\', \'block\')" style="cursor: pointer;">Block <span class="fa" ng-class="vm.predicate === \'block\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'\', \'gpLocation\')" style="cursor: pointer;">GP Location <span class="fa" ng-class="vm.predicate === \'gpLocation\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'\', \'baName\')" style="cursor: pointer;">BA <span class="fa" ng-class="vm.predicate === \'baName\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'\', \'oaName\')" style="cursor: pointer;">OA <span class="fa" ng-class="vm.predicate === \'oaName\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'\', \'caseTypeName\')" style="cursor: pointer;">Alert Type <span class="fa" ng-class="vm.predicate === \'caseTypeName\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><!-- <th>Status</th> --><th ng-click="vm.sortTable(\'\', \'slaDue\')" style="cursor: pointer;">Breach/Remaining Time <span class="fa" ng-class="vm.predicate === \'slaDue\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'\', \'caseStatus\')" style="cursor: pointer;">Incident Status <span class="fa" ng-class="vm.predicate === \'caseStatus\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'\', \'assignedTo\')" style="cursor: pointer;">Assigned To <span class="fa" ng-class="vm.predicate === \'assignedTo\' ? (vm.reverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th>GP Status</th><th>SLA Status</th></tr></thead><tbody><tr ng-repeat="inc in vm.slaBreachesPaged | filter: vm.slaBreachSearch"><td>{{inc.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><!-- <td><a ui-sref="tr-case-detail({id: inc.incidentId})"\r\n                                            style="cursor: pointer; color: #007bff; text-decoration: underline;">{{inc.incidentId}}</a>\r\n                                    </td> --><!-- <td>{{inc.state}}</td> --><td><a ui-sref="tr-case-detail({id: inc.incidentId})" style="cursor: pointer; color: #007bff; text-decoration: underline;">{{inc.ticketId ? inc.ticketId : inc.incidentId}}</a></td><td title="{{inc.description}}">{{inc.description ? (inc.description | limitTo:40) + (inc.description.length > 40 ? \'...\' : \'\') : \'NA\'}}</td><td>{{inc.district}}</td><td>{{inc.block}}</td><td>{{inc.gpLocation}}</td><td>{{inc.baName || \'-\'}}</td><td>{{inc.oaName || \'-\'}}</td><td>{{inc.caseTypeName || \'-\'}}</td><!-- <td>{{inc.status}}</td> --><td>{{inc.slaDue}}</td><td>{{inc.caseStatus}}</td><td>{{inc.assignedTo}}</td><td><span class="badge" ng-if="inc.gpStatus && inc.gpStatus !== \'\'" ng-style="{\r\n                    \'background-color\': inc.gpStatus == \'UP\' ? \'#28a745\' : (inc.gpStatus == \'DOWN\' ? \'#dc3545\' : \'#ffc107\'),\r\n                    \'color\': inc.gpStatus == \'UNKNOWN\' ? \'#212529\' : \'#fff\'\r\n                  }">{{inc.gpStatus}}</span></td><td><span class="badge" ng-style="{\r\n                    \'background-color\': inc.slaStatus == \'Within\' ? \'#28a745\' : (inc.slaStatus == \'Breach\' ? \'#dc3545\' : \'#ffc107\'),\r\n                    \'color\': inc.slaStatus == \'Near To Breach\' ? \'#212529\' : \'#fff\'\r\n                  }">{{inc.slaStatus}}</span></td></tr><tr ng-show="!vm.slaBreachesPaged || vm.slaBreachesPaged.length==0"><td colspan="15" class="text-center small-muted">No data available</td></tr></tbody></table></div><!-- Pagination (mirror tr-cases) --><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div><!-- Open Incidents Table --><div class="row g-3 mb-4" ng-show="vm.showOpenIncidentsTable" id="openIncidentsTableSection"><div class="col-12 col-md-12"><div class="table-card"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"><div class="section-title" style="margin: 0;">Open Incidents</div><div style="display: flex; gap: 10px; align-items: center;"><div style="width: 220px;"><select class="form-select form-select-sm" ng-model="vm.selectedOpenAlertType" ng-options="option.id as option.name for option in vm.openAlertTypeFilterOptions" ng-change="vm.onOpenAlertTypeChange()" title="Alert Type" style="height: 32px; width: 100%;"></select></div><div style="width: 250px;"><div class="input-group input-group-sm"><input type="text" ng-model="vm.openIncidentsSearch" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-success btn-sm" ng-click="vm.exportOpenIncidentsCSV()" ng-disabled="!vm.openIncidents || vm.openIncidents.length === 0" title="Download as CSV"><i class="fa fa-download"></i> CSV</button> <button class="btn btn-primary btn-sm" ng-click="vm.exportFilteredOpenIncidentsCSV()" ng-disabled="!vm.hasFilteredOpenIncidentsData()" title="Download filtered data as CSV"><i class="fa fa-download"></i> Filtered CSV</button> <button class="btn btn-success btn-sm" ng-click="vm.exportOpenResolvedIncidentsCSV()" ng-disabled="(!vm.openIncidents || vm.openIncidents.length === 0) && (!vm.mttrDetails || vm.mttrDetails.length === 0)" title="Download open incidents and MTTR details as CSV"><i class="fa fa-download"></i> Consolidated CSV</button> <button class="btn btn-outline-secondary btn-sm" ng-click="vm.toggleOpenIncidentsTable()" title="Back to SLA Breach Table"><i class="fa fa-arrow-left"></i> Back</button></div></div><div class="table-responsive"><table class="table table-hover"><thead class="thead-light"><tr><th ng-click="vm.sortTable(\'openIncidents\', \'createdDate\')" style="cursor: pointer;">Created Date and Time <span class="fa" ng-class="vm.openIncidentsPredicate === \'createdDate\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><!-- <th ng-click="vm.sortTable(\'openIncidents\', \'incidentId\')" style="cursor: pointer;">\r\n                                        Incident ID <span class="fa"\r\n                                            ng-class="vm.openIncidentsPredicate === \'incidentId\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span>\r\n                                    </th> --><th ng-click="vm.sortTable(\'openIncidents\', \'ticketId\')" style="cursor: pointer;">Ticket ID <span class="fa" ng-class="vm.openIncidentsPredicate === \'ticketId\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th>Title</th><th ng-click="vm.sortTable(\'openIncidents\', \'district\')" style="cursor: pointer;">District <span class="fa" ng-class="vm.openIncidentsPredicate === \'district\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'openIncidents\', \'block\')" style="cursor: pointer;">Block <span class="fa" ng-class="vm.openIncidentsPredicate === \'block\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'openIncidents\', \'gpLocation\')" style="cursor: pointer;">GP Location <span class="fa" ng-class="vm.openIncidentsPredicate === \'gpLocation\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'openIncidents\', \'baName\')" style="cursor: pointer;">BA <span class="fa" ng-class="vm.openIncidentsPredicate === \'baName\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'openIncidents\', \'oaName\')" style="cursor: pointer;">OA <span class="fa" ng-class="vm.openIncidentsPredicate === \'oaName\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'openIncidents\', \'caseTypeName\')" style="cursor: pointer;">Alert Type <span class="fa" ng-class="vm.openIncidentsPredicate === \'caseTypeName\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'openIncidents\', \'caseStatus\')" style="cursor: pointer;">Incident Status <span class="fa" ng-class="vm.openIncidentsPredicate === \'caseStatus\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'openIncidents\', \'assignedTo\')" style="cursor: pointer;">Assigned To <span class="fa" ng-class="vm.openIncidentsPredicate === \'assignedTo\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'openIncidents\', \'rca\')" style="cursor: pointer;">RCA <span class="fa" ng-class="vm.openIncidentsPredicate === \'rca\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th>GP Status</th><th ng-click="vm.sortTable(\'openIncidents\', \'type\')" style="cursor: pointer;">Priority <span class="fa" ng-class="vm.openIncidentsPredicate === \'type\' ? (vm.openIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th></tr></thead><tbody><tr ng-repeat="inc in vm.openIncidentsPaged | filter: vm.openIncidentsSearch"><td>{{inc.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><!-- <td><a ui-sref="tr-case-detail({id: inc.incidentId})"\r\n                                            style="cursor: pointer; color: #007bff; text-decoration: underline;">{{inc.incidentId}}</a>\r\n                                    </td> --><td><a ui-sref="tr-case-detail({id: inc.incidentId})" style="cursor: pointer; color: #007bff; text-decoration: underline;">{{inc.ticketId ? inc.ticketId : inc.incidentId}}</a></td><td>{{inc.description}}</td><td>{{inc.district}}</td><td>{{inc.block}}</td><td>{{inc.gpLocation}}</td><td>{{inc.baName || \'-\'}}</td><td>{{inc.oaName || \'-\'}}</td><td>{{inc.caseTypeName || \'-\'}}</td><td>{{inc.caseStatus}}</td><td>{{inc.assignedTo}}</td><td>{{inc.rca || \'-\'}}</td><td><span class="badge" ng-if="inc.gpStatus && inc.gpStatus !== \'\'" ng-style="{\r\n                    \'background-color\': inc.gpStatus == \'UP\' ? \'#28a745\' : (inc.gpStatus == \'DOWN\' ? \'#dc3545\' : \'#ffc107\'),\r\n                    \'color\': inc.gpStatus == \'UNKNOWN\' ? \'#212529\' : \'#fff\'\r\n                  }">{{inc.gpStatus}}</span></td><td><span class="badge" ng-style="{\r\n                    \'background-color\': inc.type == \'CRITICAL\' ? \'#ff5c5c\' : (inc.type == \'HIGH\' ? \'#ffa533\' : (inc.type == \'MEDIUM\' ? \'#00e658\' : \'#294985\')),\r\n                    \'color\': inc.type == \'MEDIUM\' ? \'#212529\' : \'#fff\'\r\n                  }">{{inc.type}}</span></td></tr><tr ng-show="!vm.openIncidentsPaged || vm.openIncidentsPaged.length==0"><td colspan="14" class="text-center small-muted">No data available</td></tr></tbody></table></div><!-- Pagination for Open Incidents --><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.openIncidentsPage" total="vm.openIncidentsQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.openIncidentsTotalItems" ng-model="vm.openIncidentsPage" ng-change="vm.transitionOpenIncidents()"></uib-pagination></div></div></div></div></div></div><!-- Resolved Incidents Table --><div class="row g-3 mb-4" ng-show="vm.showResolvedIncidentsTable" id="resolvedIncidentsTableSection"><div class="col-12 col-md-12"><div class="table-card"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"><div class="section-title" style="margin: 0;">Resolved Incidents</div><div style="display: flex; gap: 10px; align-items: center;"><div style="width: 250px;"><div class="input-group input-group-sm"><input type="text" ng-model="vm.resolvedIncidentsSearch" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-success btn-sm" ng-click="vm.exportResolvedIncidentsCSV()" ng-disabled="!vm.resolvedIncidents || vm.resolvedIncidents.length === 0" title="Download as CSV"><i class="fa fa-download"></i> CSV</button> <button class="btn btn-success btn-sm" ng-click="vm.exportOpenResolvedIncidentsCSV()" ng-disabled="(!vm.openIncidents || vm.openIncidents.length === 0) && (!vm.mttrDetails || vm.mttrDetails.length === 0)" title="Download open incidents and MTTR details as CSV"><i class="fa fa-download"></i> Consolidated CSV</button> <button class="btn btn-outline-secondary btn-sm" ng-click="vm.toggleResolvedIncidentsTable()" title="Back to SLA Breach Table"><i class="fa fa-arrow-left"></i> Back</button></div></div><div class="table-responsive"><table class="table table-hover"><thead class="thead-light"><tr><th ng-click="vm.sortTable(\'resolvedIncidents\', \'createdDate\')" style="cursor: pointer;">Created Date and Time <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'createdDate\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><!-- <th ng-click="vm.sortTable(\'resolvedIncidents\', \'incidentId\')"\r\n                                        style="cursor: pointer;">Incident ID <span class="fa"\r\n                                            ng-class="vm.resolvedIncidentsPredicate === \'incidentId\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span>\r\n                                    </th> --><th ng-click="vm.sortTable(\'resolvedIncidents\', \'ticketId\')" style="cursor: pointer;">Ticket ID <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'ticketId\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th>Title</th><th ng-click="vm.sortTable(\'resolvedIncidents\', \'district\')" style="cursor: pointer;">District <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'district\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'resolvedIncidents\', \'block\')" style="cursor: pointer;">Block <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'block\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'resolvedIncidents\', \'gpLocation\')" style="cursor: pointer;">GP Location <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'gpLocation\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'resolvedIncidents\', \'baName\')" style="cursor: pointer;">BA <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'baName\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'resolvedIncidents\', \'oaName\')" style="cursor: pointer;">OA <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'oaName\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'resolvedIncidents\', \'caseTypeName\')" style="cursor: pointer;">Alert Type <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'caseTypeName\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'resolvedIncidents\', \'caseStatus\')" style="cursor: pointer;">Incident Status <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'caseStatus\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'resolvedIncidents\', \'assignedTo\')" style="cursor: pointer;">Assigned To <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'assignedTo\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><!-- <th>GP Status</th> --><th ng-click="vm.sortTable(\'resolvedIncidents\', \'type\')" style="cursor: pointer;">Priority <span class="fa" ng-class="vm.resolvedIncidentsPredicate === \'type\' ? (vm.resolvedIncidentsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th></tr></thead><tbody><tr ng-repeat="inc in vm.resolvedIncidentsPaged | filter: vm.resolvedIncidentsSearch"><td>{{inc.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><!-- <td><a ui-sref="tr-case-detail({id: inc.incidentId})"\r\n                                            style="cursor: pointer; color: #007bff; text-decoration: underline;">{{inc.incidentId}}</a>\r\n                                    </td> --><td><a ui-sref="tr-case-detail({id: inc.incidentId})" style="cursor: pointer; color: #007bff; text-decoration: underline;">{{inc.ticketId ? inc.ticketId : inc.incidentId}}</a></td><td>{{inc.description}}</td><td>{{inc.district}}</td><td>{{inc.block}}</td><td>{{inc.gpLocation}}</td><td>{{inc.baName || \'-\'}}</td><td>{{inc.oaName || \'-\'}}</td><td>{{inc.caseTypeName || \'-\'}}</td><td>{{inc.caseStatus}}</td><td>{{inc.assignedTo}}</td><!-- <td>\r\n                                        <span class="badge" ng-if="inc.gpStatus && inc.gpStatus !== \'\'" ng-style="{\r\n                    \'background-color\': inc.gpStatus == \'UP\' ? \'#28a745\' : (inc.gpStatus == \'DOWN\' ? \'#dc3545\' : \'#ffc107\'),\r\n                    \'color\': inc.gpStatus == \'UNKNOWN\' ? \'#212529\' : \'#fff\'\r\n                  }">{{inc.gpStatus}}</span>\r\n                                    </td> --><td><span class="badge" ng-style="{\r\n                    \'background-color\': inc.type == \'CRITICAL\' ? \'#ff5c5c\' : (inc.type == \'HIGH\' ? \'#ffa533\' : (inc.type == \'MEDIUM\' ? \'#00e658\' : \'#294985\')),\r\n                    \'color\': inc.type == \'MEDIUM\' ? \'#212529\' : \'#fff\'\r\n                  }">{{inc.type}}</span></td></tr><tr ng-show="!vm.resolvedIncidents || vm.resolvedIncidents.length==0"><td colspan="13" class="text-center small-muted">No data available</td></tr></tbody></table></div><!-- Pagination for Resolved Incidents --><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.resolvedIncidentsPage" total="vm.resolvedIncidentsQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.resolvedIncidentsTotalItems" ng-model="vm.resolvedIncidentsPage" ng-change="vm.transitionResolvedIncidents()"></uib-pagination></div></div></div></div></div></div><!-- GP Down Table --><div class="row g-3 mb-4" ng-show="vm.showGpDownTable" id="gpDownTableSection"><div class="col-12 col-md-12"><div class="table-card"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"><div class="section-title" style="margin: 0;">GP Down List</div><div style="display: flex; gap: 10px; align-items: center;"><div style="width: 250px;"><div class="input-group input-group-sm"><input type="text" ng-model="vm.gpDownSearch" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-success btn-sm" ng-click="vm.exportGpDownCSV()" ng-disabled="!vm.gpDownList || vm.gpDownList.length === 0" title="Download as CSV"><i class="fa fa-download"></i> CSV</button> <button class="btn btn-outline-secondary btn-sm" ng-click="vm.toggleGpDownTable()" title="Back to SLA Breach Table"><i class="fa fa-arrow-left"></i> Back</button></div></div><div class="table-responsive"><table class="table table-hover"><thead class="thead-light"><tr><th ng-click="vm.sortTable(\'gpDown\', \'caseCreatedTime\')" style="cursor: pointer;">Created Date and Time <span class="fa" ng-class="vm.gpDownPredicate === \'caseCreatedTime\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'gpDown\', \'ticketId\')" style="cursor: pointer;">Ticket ID <span class="fa" ng-class="vm.gpDownPredicate === \'ticketId\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'gpDown\', \'description\')" style="cursor: pointer;">Title <span class="fa" ng-class="vm.gpDownPredicate === \'description\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'gpDown\', \'assetName\')" style="cursor: pointer;">Asset Name <span class="fa" ng-class="vm.gpDownPredicate === \'assetName\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'gpDown\', \'state\')" style="cursor: pointer;">State <span class="fa" ng-class="vm.gpDownPredicate === \'state\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'gpDown\', \'district\')" style="cursor: pointer;">District <span class="fa" ng-class="vm.gpDownPredicate === \'district\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'gpDown\', \'block\')" style="cursor: pointer;">Block <span class="fa" ng-class="vm.gpDownPredicate === \'block\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'gpDown\', \'amcStatus\')" style="cursor: pointer;">AMC/NON-AMC Status <span class="fa" ng-class="vm.gpDownPredicate === \'amcStatus\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'gpDown\', \'gpDownDurationMinutes\')" style="cursor: pointer;">GP Down Time <span class="fa" ng-class="vm.gpDownPredicate === \'gpDownDurationMinutes\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'gpDown\', \'assignTo\')" style="cursor: pointer;">Assigned To <span class="fa" ng-class="vm.gpDownPredicate === \'assignTo\' ? (vm.gpDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th></tr></thead><tbody><tr ng-repeat="gp in vm.gpDownPaged | filter: vm.gpDownSearch"><td>{{gp.caseCreatedTime | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><td><a ui-sref="tr-case-detail({id: gp.incidentId})" style="cursor: pointer; color: #007bff; text-decoration: underline;">{{gp.ticketId ? gp.ticketId : gp.caseNumber}}</a></td><td>{{gp.description || \'-\'}}</td><td>{{gp.assetName || \'-\'}}</td><td>{{gp.state || \'-\'}}</td><td>{{gp.district || \'-\'}}</td><td>{{gp.block || \'-\'}}</td><td>{{gp.amcStatus || \'-\'}}</td><td><span ng-style="vm.getGpDownDurationStyle(gp.caseCreatedTime)" title="Time since case creation">{{vm.formatGpDownDuration(gp.caseCreatedTime)}}</span></td><td>{{gp.assignTo || \'-\'}}</td></tr><tr ng-show="!vm.gpDownList || vm.gpDownList.length==0"><td colspan="10" class="text-center small-muted">No data available</td></tr></tbody></table></div><!-- Pagination for GP Down list --><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.gpDownPage" total="vm.gpDownQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.gpDownTotalItems" ng-model="vm.gpDownPage" ng-change="vm.transitionGpDown()"></uib-pagination></div></div></div></div></div></div><!-- Block Down Table --><div class="row g-3 mb-4" ng-show="vm.showBlockDownTable" id="blockDownTableSection"><div class="col-12 col-md-12"><div class="table-card"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"><div class="section-title" style="margin: 0;">Block Incident List</div><div style="display: flex; gap: 10px; align-items: center;"><div style="width: 250px;"><div class="input-group input-group-sm"><input type="text" ng-model="vm.blockDownSearch" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-success btn-sm" ng-click="vm.exportBlockDownCSV()" ng-disabled="!vm.blockDownList || vm.blockDownList.length === 0" title="Download as CSV"><i class="fa fa-download"></i> CSV</button> <button class="btn btn-outline-secondary btn-sm" ng-click="vm.toggleBlockDownTable()" title="Back to Dashboard"><i class="fa fa-arrow-left"></i> Back</button></div></div><div class="table-responsive"><table class="table table-hover"><thead class="thead-light"><tr><th ng-click="vm.sortTable(\'blockDown\', \'createdDate\')" style="cursor: pointer;">Created Date and Time <span class="fa" ng-class="vm.blockDownPredicate === \'createdDate\' ? (vm.blockDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'blockDown\', \'ticketId\')" style="cursor: pointer;">Ticket ID <span class="fa" ng-class="vm.blockDownPredicate === \'ticketId\' ? (vm.blockDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'blockDown\', \'description\')" style="cursor: pointer;">Title <span class="fa" ng-class="vm.blockDownPredicate === \'description\' ? (vm.blockDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'blockDown\', \'state\')" style="cursor: pointer;">State <span class="fa" ng-class="vm.blockDownPredicate === \'state\' ? (vm.blockDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'blockDown\', \'district\')" style="cursor: pointer;">District <span class="fa" ng-class="vm.blockDownPredicate === \'district\' ? (vm.blockDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'blockDown\', \'block\')" style="cursor: pointer;">Block <span class="fa" ng-class="vm.blockDownPredicate === \'block\' ? (vm.blockDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'blockDown\', \'priority\')" style="cursor: pointer;">Priority <span class="fa" ng-class="vm.blockDownPredicate === \'priority\' ? (vm.blockDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'blockDown\', \'caseStatus\')" style="cursor: pointer;">Status <span class="fa" ng-class="vm.blockDownPredicate === \'caseStatus\' ? (vm.blockDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'blockDown\', \'assignedTo\')" style="cursor: pointer;">Assigned To <span class="fa" ng-class="vm.blockDownPredicate === \'assignedTo\' ? (vm.blockDownReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th></tr></thead><tbody><tr ng-repeat="item in vm.blockDownPaged | filter: vm.blockDownSearch"><td>{{item.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><td><a ui-sref="tr-case-detail({id: item.incidentId})" style="cursor: pointer; color: #007bff; text-decoration: underline;">{{item.ticketId ? item.ticketId : (item.caseNumber || item.incidentId || \'-\')}}</a></td><td>{{item.description || \'-\'}}</td><td>{{item.state || \'-\'}}</td><td>{{item.district || \'-\'}}</td><td>{{item.block || \'-\'}}</td><td>{{item.priority || \'-\'}}</td><td>{{item.caseStatus || item.status || \'-\'}}</td><td>{{item.assignedTo || item.assignedToUser || \'-\'}}</td></tr><tr ng-show="!vm.blockDownList || vm.blockDownList.length==0"><td colspan="9" class="text-center small-muted">No data available</td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.blockDownPage" total="vm.blockDownQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.blockDownTotalItems" ng-model="vm.blockDownPage" ng-change="vm.transitionBlockDown()"></uib-pagination></div></div></div></div></div></div><!-- MTTR Details Table (Shared by Resolved, SLA Compliance, and Avg. Resolution cards) --><div class="row g-3 mb-4" ng-show="vm.showMttrDetailsTable" id="mttrDetailsTableSection"><div class="col-12 col-md-12"><div class="table-card"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"><div class="section-title" style="margin: 0;">MTTR Details</div><div style="display: flex; gap: 10px; align-items: center;"><div style="width: 220px;"><select class="form-select form-select-sm" ng-model="vm.selectedAlertType" ng-options="option.id as option.name for option in vm.alertTypeFilterOptions" ng-change="vm.transitionMttrDetails()" title="Alert Type" style="height: 32px; width: 100%;"></select></div><div style="width: 250px;"><div class="input-group input-group-sm"><input type="text" ng-model="vm.mttrDetailsSearch" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-success btn-sm" ng-click="vm.exportMttrDetailsCSV()" ng-disabled="!vm.mttrDetails || vm.mttrDetails.length === 0" title="Download as CSV"><i class="fa fa-download"></i> CSV</button> <button class="btn btn-primary btn-sm" ng-click="vm.exportFilteredMttrDetailsCSV()" ng-disabled="!vm.hasFilteredMttrDetailsData()" title="Download filtered data as CSV"><i class="fa fa-download"></i> Filtered CSV</button> <button class="btn btn-outline-secondary btn-sm" ng-click="vm.toggleMttrDetailsTable()" title="Back to SLA Breach Table"><i class="fa fa-arrow-left"></i> Back</button></div></div><div class="table-responsive"><table class="table table-hover"><thead class="thead-light"><tr><th ng-click="vm.sortTable(\'mttrDetails\', \'createdDate\')" style="cursor: pointer;">Created Date & Time <span class="fa" ng-class="vm.mttrDetailsPredicate === \'createdDate\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'ticketId\')" style="cursor: pointer;">Ticket ID <span class="fa" ng-class="vm.mttrDetailsPredicate === \'ticketId\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'title\')" style="cursor: pointer;">Title <span class="fa" ng-class="vm.mttrDetailsPredicate === \'title\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'resolvedDate\')" style="cursor: pointer;">Resolved Date & Time <span class="fa" ng-class="vm.mttrDetailsPredicate === \'resolvedDate\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'resolutionTime\')" style="cursor: pointer;">Resolution Time <span class="fa" ng-class="vm.mttrDetailsPredicate === \'resolutionTime\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'state\')" style="cursor: pointer;">State <span class="fa" ng-class="vm.mttrDetailsPredicate === \'state\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'district\')" style="cursor: pointer;">District <span class="fa" ng-class="vm.mttrDetailsPredicate === \'district\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'block\')" style="cursor: pointer;">Block <span class="fa" ng-class="vm.mttrDetailsPredicate === \'block\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'gpLocation\')" style="cursor: pointer;">GP <span class="fa" ng-class="vm.mttrDetailsPredicate === \'gpLocation\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'baName\')" style="cursor: pointer;">BA <span class="fa" ng-class="vm.mttrDetailsPredicate === \'baName\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'oaName\')" style="cursor: pointer;">OA <span class="fa" ng-class="vm.mttrDetailsPredicate === \'oaName\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'caseTypeName\')" style="cursor: pointer;">Alert Type <span class="fa" ng-class="vm.mttrDetailsPredicate === \'caseTypeName\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'incidentStatus\')" style="cursor: pointer;">Incident Status <span class="fa" ng-class="vm.mttrDetailsPredicate === \'incidentStatus\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'rca\')" style="cursor: pointer;">RCA <span class="fa" ng-class="vm.mttrDetailsPredicate === \'rca\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'priority\')" style="cursor: pointer;">Priority <span class="fa" ng-class="vm.mttrDetailsPredicate === \'priority\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'assignedTo\')" style="cursor: pointer;">Assigned To <span class="fa" ng-class="vm.mttrDetailsPredicate === \'assignedTo\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'mttrDetails\', \'slaStatus\')" style="cursor: pointer;">SLA Status <span class="fa" ng-class="vm.mttrDetailsPredicate === \'slaStatus\' ? (vm.mttrDetailsReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th></tr></thead><tbody><tr ng-repeat="mttr in vm.mttrDetailsPaged | filter: vm.mttrDetailsSearch"><td>{{mttr.createdDate ? (mttr.createdDate | date:\'dd-MM-yyyy HH:mm:ss\') : \'-\'}}</td><td><a ui-sref="tr-case-detail({id: mttr.incidentId})" style="cursor: pointer; color: #007bff; text-decoration: underline;">{{mttr.ticketId}}</a></td><td title="{{mttr.title}}">{{mttr.title ? (mttr.title | limitTo:40) + (mttr.title.length > 40 ? \'...\' : \'\') : \'-\'}}</td><td>{{mttr.resolvedDate ? (mttr.resolvedDate | date:\'dd-MM-yyyy HH:mm:ss\') : \'-\'}}</td><td title="{{mttr.resolutionTime}}">{{mttr.resolutionTime ? (mttr.resolutionTime | limitTo:30) + (mttr.resolutionTime.length > 30 ? \'...\' : \'\') : \'-\'}}</td><td>{{mttr.state}}</td><td>{{mttr.district}}</td><td>{{mttr.block}}</td><td>{{mttr.gpLocation}}</td><td>{{mttr.baName || \'-\'}}</td><td>{{mttr.oaName || \'-\'}}</td><td>{{mttr.caseTypeName || \'-\'}}</td><td>{{mttr.incidentStatus}}</td><td>{{mttr.rca}}</td><td>{{mttr.priority}}</td><td>{{mttr.assignedTo}}</td><td><span class="badge" ng-style="{\r\n                                        \'background-color\': mttr.slaStatus === \'Within SLA\' ? \'#28a745\' : ((mttr.slaStatus === \'After SLA\' || mttr.slaStatus === \'Breach\') ? \'#dc3545\' : \'#ffc107\'),\r\n                                        \'color\': (mttr.slaStatus === \'After SLA\' || mttr.slaStatus === \'Breach\') ? \'#fff\' : \'#212529\'\r\n                  }">{{mttr.slaStatus}}</span></td></tr><tr ng-show="!vm.mttrDetailsPaged || vm.mttrDetailsPaged.length==0"><td colspan="17" class="text-center small-muted">No data available</td></tr></tbody></table></div><!-- Pagination for MTTR Details --><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.mttrDetailsPage" total="vm.mttrDetailsQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.mttrDetailsTotalItems" ng-model="vm.mttrDetailsPage" ng-change="vm.transitionMttrDetails()"></uib-pagination></div></div></div></div></div></div><!-- Near To Breach Table --><div class="row g-3 mb-4" ng-show="vm.showNearToBreachTable" id="nearToBreachTableSection"><div class="col-12 col-md-12"><div class="table-card"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"><div class="section-title" style="margin: 0;">Near Threshold</div><div style="display: flex; gap: 10px; align-items: center;"><div style="width: 250px;"><div class="input-group input-group-sm"><input type="text" ng-model="vm.nearToBreachSearch" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-success btn-sm" ng-click="vm.exportNearToBreachCSV()" ng-disabled="!vm.nearToBreachIncidents || vm.nearToBreachIncidents.length === 0" title="Download as CSV"><i class="fa fa-download"></i> CSV</button> <button class="btn btn-outline-secondary btn-sm" ng-click="vm.toggleNearToBreachTable()" title="Back to SLA Breach Table"><i class="fa fa-arrow-left"></i> Back</button></div></div><div class="table-responsive"><table class="table table-hover"><thead class="thead-light"><tr><th ng-click="vm.sortTable(\'nearToBreach\', \'createdDate\')" style="cursor: pointer;">Created Date and Time <span class="fa" ng-class="vm.nearToBreachPredicate === \'createdDate\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><!-- <th ng-click="vm.sortTable(\'nearToBreach\', \'incidentId\')" style="cursor: pointer;">\r\n                                        Incident ID <span class="fa"\r\n                                            ng-class="vm.nearToBreachPredicate === \'incidentId\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span>\r\n                                    </th> --><th ng-click="vm.sortTable(\'nearToBreach\', \'ticketId\')" style="cursor: pointer;">Ticket ID <span class="fa" ng-class="vm.nearToBreachPredicate === \'ticketId\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'description\')" style="cursor: pointer;">Title <span class="fa" ng-class="vm.nearToBreachPredicate === \'description\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'district\')" style="cursor: pointer;">District <span class="fa" ng-class="vm.nearToBreachPredicate === \'district\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'block\')" style="cursor: pointer;">Block <span class="fa" ng-class="vm.nearToBreachPredicate === \'block\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'gpLocation\')" style="cursor: pointer;">GP Location <span class="fa" ng-class="vm.nearToBreachPredicate === \'gpLocation\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'baName\')" style="cursor: pointer;">BA <span class="fa" ng-class="vm.nearToBreachPredicate === \'baName\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'oaName\')" style="cursor: pointer;">OA <span class="fa" ng-class="vm.nearToBreachPredicate === \'oaName\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'caseTypeName\')" style="cursor: pointer;">Alert Type <span class="fa" ng-class="vm.nearToBreachPredicate === \'caseTypeName\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'slaDue\')" style="cursor: pointer;">Remaining Time <span class="fa" ng-class="vm.nearToBreachPredicate === \'slaDue\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'caseStatus\')" style="cursor: pointer;">Incident Status <span class="fa" ng-class="vm.nearToBreachPredicate === \'caseStatus\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th ng-click="vm.sortTable(\'nearToBreach\', \'assignedTo\')" style="cursor: pointer;">Assigned To <span class="fa" ng-class="vm.nearToBreachPredicate === \'assignedTo\' ? (vm.nearToBreachReverse ? \'fa-sort-desc\' : \'fa-sort-asc\') : \'fa-sort\'"></span></th><th>GP Status</th><th>SLA Status</th></tr></thead><tbody><tr ng-repeat="inc in vm.nearToBreachPaged | filter: vm.nearToBreachSearch"><td>{{inc.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><!-- <td><a ui-sref="tr-case-detail({id: inc.incidentId})"\r\n                                            style="cursor: pointer; color: #007bff; text-decoration: underline;">{{inc.incidentId}}</a>\r\n                                    </td> --><td><a ui-sref="tr-case-detail({id: inc.incidentId})" style="cursor: pointer; color: #007bff; text-decoration: underline;">{{inc.ticketId ? inc.ticketId : inc.incidentId}}</a></td><td title="{{inc.description}}">{{inc.description ? (inc.description | limitTo:40) + (inc.description.length > 40 ? \'...\' : \'\') : \'NA\'}}</td><td>{{inc.district}}</td><td>{{inc.block}}</td><td>{{inc.gpLocation}}</td><td>{{inc.baName || \'-\'}}</td><td>{{inc.oaName || \'-\'}}</td><td>{{inc.caseTypeName || \'-\'}}</td><td>{{inc.slaDue}}</td><td>{{inc.caseStatus}}</td><td>{{inc.assignedTo}}</td><td><span class="badge" ng-if="inc.gpStatus && inc.gpStatus !== \'\'" ng-style="{\r\n                    \'background-color\': inc.gpStatus == \'UP\' ? \'#28a745\' : (inc.gpStatus == \'DOWN\' ? \'#dc3545\' : \'#ffc107\'),\r\n                    \'color\': inc.gpStatus == \'UNKNOWN\' ? \'#212529\' : \'#fff\'\r\n                  }">{{inc.gpStatus}}</span></td><td><span class="badge" ng-style="{\r\n                    \'background-color\': inc.slaStatus == \'Breach\' ? \'#dc3545\' : \'#ffc107\',\r\n                    \'color\': \'#fff\'\r\n                  }">{{inc.slaStatus}}</span></td></tr><tr ng-show="!vm.nearToBreachIncidents || vm.nearToBreachIncidents.length==0"><td colspan="14" class="text-center small-muted">No data available</td></tr></tbody></table></div><!-- Pagination for Near To Breach --><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.nearToBreachPage" total="vm.nearToBreachQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.nearToBreachTotalItems" ng-model="vm.nearToBreachPage" ng-change="vm.transitionNearToBreach()"></uib-pagination></div></div></div></div></div></div><!-- Patroller Table --><div class="row g-3 mb-4" ng-show="vm.showPatrollerTable" id="patrollerTableSection"><div class="col-12 col-md-12"><div class="table-card"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"><div class="section-title" style="margin: 0;">Patroller Team</div><div style="display: flex; gap: 10px; align-items: center;"><div style="width: 250px;"><div class="input-group input-group-sm"><input type="text" ng-model="vm.patrollerSearch" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-success btn-sm" ng-click="vm.exportPatrollerCSV()" ng-disabled="!vm.patrollerUsers || vm.patrollerUsers.length === 0" title="Download as CSV"><i class="fa fa-download"></i> CSV</button> <button class="btn btn-outline-secondary btn-sm" ng-click="vm.togglePatrollerTable()" title="Back to Dashboard"><i class="fa fa-arrow-left"></i> Back</button></div></div><div class="table-responsive"><table class="table table-hover"><thead class="thead-light"><tr><th>Login</th><th>First Name</th><th>Last Name</th><th>Email</th><th>Phone</th><!-- <th>GPS Status</th> --><th>Reporting Status</th><!-- <th>OS</th> --><th>App Version</th></tr></thead><tbody><tr ng-repeat="user in vm.patrollerPaged | filter: vm.patrollerSearch"><td>{{user.login}}</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.email}}</td><td>{{user.phone}}</td><!-- <td>\r\n                                        <span class="badge" ng-style="{\r\n                    \'background-color\': user.gpsStatus == \'Active\' ? \'#28a745\' : \'#dc3545\',\r\n                    \'color\': \'#fff\'\r\n                  }">{{user.gpsStatus}}</span>\r\n                                    </td> --><td ng-if="user.applicationVersion"><span class="badge" ng-style="{\r\n                    \'background-color\': user.reportingStatus == \'Reporting\' ? \'#28a745\' : \'#ffc107\',\r\n                    \'color\': user.reportingStatus == \'Reporting\' ? \'#fff\' : \'#212529\'\r\n                  }">{{user.reportingStatus}}</span></td><td ng-if="!user.applicationVersion"><span class="badge" ng-style="{\r\n                    \'background-color\': \'#fa1b35\',\r\n                    \'color\': \'#fff\'\r\n                  }">Not Installed</span></td><!-- <td>{{user.operatingSystem}}</td> --><td>{{user.applicationVersion || \'-\' }}</td></tr><tr ng-show="!vm.patrollerUsers || vm.patrollerUsers.length==0"><td colspan="9" class="text-center small-muted">No data available</td></tr></tbody></table></div><!-- Pagination for Patroller --><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.patrollerPage" total="vm.patrollerQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.patrollerTotalItems" ng-model="vm.patrollerPage" ng-change="vm.transitionPatroller()"></uib-pagination></div></div></div></div></div></div><!-- FRT Table --><div class="row g-3 mb-4" ng-show="vm.showFrtTable" id="frtTableSection"><div class="col-12 col-md-12"><div class="table-card"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"><div class="section-title" style="margin: 0;">FRT</div><div style="display: flex; gap: 10px; align-items: center;"><div style="width: 250px;"><div class="input-group input-group-sm"><input type="text" ng-model="vm.frtSearch" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-success btn-sm" ng-click="vm.exportFrtCSV()" ng-disabled="!vm.frtUsers || vm.frtUsers.length === 0" title="Download as CSV"><i class="fa fa-download"></i> CSV</button> <button class="btn btn-outline-secondary btn-sm" ng-click="vm.toggleNearToBreachTable()" title="Back to SLA Breach Table"><i class="fa fa-arrow-left"></i> Back</button></div></div><div class="table-responsive"><table class="table table-hover"><thead class="thead-light"><tr><th>Login</th><th>First Name</th><th>Last Name</th><th>Email</th><th>Phone</th><!-- <th>GPS Status</th> --><th>Reporting Status</th><!-- <th>OS</th> --><th>App Version</th></tr></thead><tbody><tr ng-repeat="user in vm.frtPaged | filter: vm.frtSearch"><td>{{user.login}}</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.email}}</td><td>{{user.phone}}</td><!-- <td>\r\n                                        <span class="badge" ng-style="{\r\n                    \'background-color\': user.gpsStatus == \'Active\' ? \'#28a745\' : \'#dc3545\',\r\n                    \'color\': \'#fff\'\r\n                  }">{{user.gpsStatus}}</span>\r\n                                    </td> --><td ng-if="user.applicationVersion"><span class="badge" ng-style="{\r\n\t\t\t\t\t                    \'background-color\': user.reportingStatus == \'Reporting\' ? \'#28a745\' : \'#ffc107\',\r\n\t\t\t\t\t                    \'color\': user.reportingStatus == \'Reporting\' ? \'#fff\' : \'#212529\'\r\n\t\t\t\t\t                  }">{{user.reportingStatus}}</span></td><td ng-if="!user.applicationVersion"><span class="badge" ng-style="{\r\n                   \t\t\t\t\t\t\t \'background-color\': \'#fa1b35\',\r\n                    \t\t\t\t\t\t\'color\': \'#fff\'\r\n                  \t\t\t\t\t\t}">Not Installed</span></td><!-- <td>{{user.operatingSystem}}</td> --><td>{{user.applicationVersion || \'-\'}}</td></tr><tr ng-show="!vm.frtUsers || vm.frtUsers.length==0"><td colspan="9" class="text-center small-muted">No data available</td></tr></tbody></table></div><!-- Pagination for FRT --><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.frtPage" total="vm.frtQueryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.frtTotalItems" ng-model="vm.frtPage" ng-change="vm.transitionFrt()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/history/asset-history.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="glyphicon glyphicon-time"></i> &nbsp;<span>Asset History</span></h3><div class="col-md-3 search-top pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetHistorySearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="box-body border"><div class="case-table"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-click="setOrderProperty(\'assetId\')">Asset Id <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'assetName\')">Asset Name <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'assetTypeName\')">Asset Type Name <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'modeName\')">Mode Name <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'propertyName\')">Property Name <span class="fa fa-sort"></span></th><th>New Value</th><th>Old Value</th><th ng-click="setOrderProperty(\'createdBy\')"><span>Created By</span> <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'cdate\')"><span>Created Date </span><span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'lastModifiedBy\')"><span>Last Modified By</span> <span class="fa fa-sort"></span></th><th ng-click="setOrderProperty(\'ldate\')">Last Modified Date <span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="asset in vm.assetHistory  | orderBy:orderProperty"><td>{{asset.assetId}}</td><td>{{asset.assetName}}</td><td>{{asset.assetTypeName}}</td><td>{{asset.modeName}}</td><td>{{asset.propertyName}}</td><td>{{asset.newValue}}</td><td>{{asset.oldValue}}</td><td>{{asset.createdBy}}</td><td>{{asset.cdate}}</td><td>{{asset.lastModifiedBy}}</td><td>{{asset.ldate}}</td></tr><tr><td colspan="10" ng-show="vm.assetHistory == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row row__div--pagination"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-3"><label>Go To</label> <input type="text" id="pagenum" oninput="this.value|=0" onkeyup="if(this.value<0){this.value= this.value * -1}" maxlength="4"> <button type="button " ng-click="vm.goToPage()" class="button__goto"><i class="fa fa-caret-right"></i></button></div><div class="col-md-4 pull-right"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/home/home.html','<div class="content" ng-if="!vm.isAuthenticated()" ng-cloak style="padding:0px;"><div class="container navbar-wrapper"><div class="row"><nav class="navbar navbar-default" role="navigation"><div class="col-sm-4 mt-45 mt-65"><div class="row"><div class="col-xs-9 col-sm-12"><img src="content/images/fiberify-logo.png" alt="trakeye" class="img-responsive2 trakeye_logo" ng-if="vm.appName==\'Fiberify\'"> <img src="content/images/fiberify-logo.png" alt="trakeye" class="img-responsive2 trakeye_logo" ng-if="vm.appName==\'Fiberify\'"> <img src="content/images/bharatnet_logo.png" alt="trakeye" class="img-responsive2 trakeye_logo" ng-if="vm.appName==\'BSNL\'"><!--  content/images/newlogo3.png orange logo --></div><!-- <div class="navbar-header col-xs-3">\r\n\t\t\t\t\t<button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">\r\n\t\t\t\t\t  <span class="sr-only">Toggle navigation</span>\r\n\t\t\t\t\t  <span class="icon-bar"></span>\r\n\t\t\t\t\t  <span class="icon-bar"></span>\r\n\t\t\t\t\t  <span class="icon-bar"></span>\r\n\t\t\t\t\t</button>\r\n\t\t\t\t  </div> --></div><!--row--></div><!--col-sm-4--><div class="col-sm-8 mt-45 mt-bg"><!-- Brand and toggle get grouped for better mobile display --><!-- Collect the nav links, forms, and other content for toggling --><div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1"><!--<ul class="nav navbar-nav navbar-right">\r\n\t\t\t   <li><a ui-sref="home">Home</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Solutions</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Industries</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Support</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Blog</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Contact Us</a></li>\r\n\t\t\t</ul>--></div><!-- /.navbar-collapse --></div><!--col-sm-8--></nav></div><!--row--></div><!-- Carousel\r\n    ================================================== --><div id="myCarousel" class="carousel slide" data-ride="carousel"><!-- Indicators --><ol class="carousel-indicators"><li data-target="#myCarousel" data-slide-to="0" class="active"></li><li data-target="#myCarousel" data-slide-to="1" class=""></li><li data-target="#myCarousel" data-slide-to="2" class=""></li></ol><div class="carousel-inner" role="listbox"><div class="item active"><img class="second-slide" src="content/images/bg3.png" alt="Second slide"><div class="container"><div class="col-sm-7 col-lg-7"><div class="home-banner"><img src="content/images/bg1-slide.png" class="img-responsive" alt="First slide" style="padding-top:0vh"></div></div><div class="col-sm-5 col-lg-5"><div class="home-banner-con"><div style="padding-top:16vh"><h1 style="color: #fff;">Field Activity Management</h1><h4 style="color: #fff;">Field activity monitoring console</h4><h4 style="color: #fff;">Location based issue reporting</h4><h4 style="color: #fff;">Find near-by agents to attend issues</h4><h4 style="color: #fff;">Get service activity updates from field</h4><h4 style="color: #fff;">View open issues and service activity on maps</h4></div></div></div></div></div><div class="item"><img class="first-slide" src="content/images/bg1.png" alt="First slide"><div class="container"><div class="col-sm-7 col-lg-7 col-lg-7"><div class="home-banner"><img src="content/images/bg1-slide3.png" class="img-responsive" alt="First slide" style="padding-top:0vh"></div></div><div class="col-sm-5 col-lg-5"><div class="home-banner-con"><div style="padding-top:16vh"><h1>Field Agent Tracking</h1><h4>Field agents live monitoring console</h4><h4>Individual field agent and vehicle tracking</h4><h4>Geofence entry/exit control</h4><h4>Field vehicle efficiency tracking</h4></div></div></div></div></div><div class="item"><img class="third-slide" src="content/images/bg2.png" alt="Third slide"><div class="container"><div class="col-sm-7 col-lg-7"><div class="home-banner"><img src="content/images/bg2-slide.png" class="img-responsive" alt="First slide" style="padding-top:0vh"></div></div><div class="col-sm-5 col-lg-5"><div class="home-banner-con"><div style="padding-top:20vh"><h1>Real-time Analytics</h1><h4>Ad-hoc Reports</h4><h4>Scheduled Reports</h4><h4>Analytics Dashboard</h4></div></div></div></div></div></div><a class="left carousel-control" href="#myCarousel" role="button" data-slide="prev"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> <span class="sr-only">Previous</span> </a><a class="right carousel-control" href="#myCarousel" role="button" data-slide="next"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span> <span class="sr-only">Next</span></a></div><!-- /.carousel --><!--<div class="row login-sizes">\r\n     \t \t<div class="col-md-6">\r\n\t\t\t<div class="home-content text-center mt-110">\r\n\t\t\t\t<h1 class="home-heading">Data Driven.</h1>\r\n\t\t\t\t<h1 class="home-subheading">Decision Making</h1>\r\n\t\t\t\t<h4 class="home-subheading">Field Optimized Solution</h4>\r\n\t\t\r\n\t\t\t\t<button class="btn btn-danger" ui-sref="register">Try it Now</button>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class="col-md-5">\r\n\t\t\t<div class="phone-image">\r\n\t\t\t\t<img ng-src="content/images/phone.png" class="img-responsive phone" style="width: 100%; height: 495px;">\r\n\t\t\t</div>\r\n\t\t\t<div class="content-data">\r\n\t\t\t\t<h3 class="phone-head text-center">Our Platform represent everything <br/>you want to track</h3>\r\n\t\t\t</div>\r\n\t\t</div>\r\n    </div>\t--></div>');
$templateCache.put('app/upload/uploadagent.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);vm.showandroidfiles();" data-toggle="tab">Upload APK Files</a></li><!-- <li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2);vm.showiosfiles();" data-toggle="tab"> Upload IPA Files</a></li> --></ul></div><!-- /.box-header --><!-- form start --><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p translate="upload.success">File has been uploaded successfully</p></div><!-- <div class="alert alert-danger" ng-show="vm.error">\r\n\t\t\t        <p >Only apk file should be uploaded</p>\r\n\t\t\t  </div>  --><div class="form-group"><label for="upload" class="col-sm-3 control-label" translate="upload.uploadfile">Upload File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="upload-file-input" class="filestyle" valid-file agent-file accept="*.ipa||*.apk" required ng-pattern="FILE_EXT_REGEXP"><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern" translate="upload.patternerror">Only apk and ipa file should be uploaded</p><!-- <div ng-show="uploadForm.uploadfile.$invalid">\r\n\t\t                   <p class="help-block" ng-show="uploadForm.uploadfile.$error.pattern" >\r\n                                  Only apk file should be uploaded\r\n                          </p>\r\n\t\t             </div>  --></div></div><!-- <div class="form-group">\r\n                  <label for="version" class="col-sm-3 control-label" translate="upload.versionno">Version Number</label>\r\n                  <div class="col-sm-8">\r\n                \t <input type="text" name="version" id=\'versionno\' ng-model="version" placeholder="Version Number" class="form-control" required>\r\n                  </div>\r\n                </div>                 --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div><div class="col-md-8 col-md-offset-2" ng-show="isSet(1)"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i> Uploaded APK Details</h3></div><div class="box-body"><div class="table-responsive mt-10" style="max-height: 400px;  overflow: hidden; overflow-y: auto;"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>File Name<span class="fa fa-sort"></span></th><th>Version<span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="file in vm.files"><td>{{file.fileName}}</td><td>{{file.version}}</td></tr></tbody></table></div></div></div></div><div class="col-md-8 col-md-offset-2" ng-show="isSet(2)"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i> Uploaded IPA Details</h3></div><div class="box-body"><div class="table-responsive mt-10" style="max-height: 400px;  overflow: hidden; overflow-y: auto;"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>File Name<span class="fa fa-sort"></span></th><th>Version<span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="file in vm.iosfiles"><td>{{file.fileName}}</td><td>{{file.version}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/asset-case-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-bandcamp"></i> <span translate="global.menu.asset-case-report">Asset Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="assetForm" ng-submit="assetReport()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">From Date <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label assetCaseReport_toDate">To Date <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.report.casetype">caseType</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="caseType" ng-model="vm.caseType" ng-options="item.id as item.name for item in vm.caseTypes track by item.id" required><option value="" translate="trakeyeApp.report.selectcase">--- Select CaseType ---</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="assetForm.$invalid">Submit</button></div></div></form></div></div></div><!-- <div class="row">\r\n\t\t<div class="col-md-10 col-md-offset-1">\r\n\t\t\t<div  ng-if="assetreportbutton == \'option2\'">\r\n\t\t\t\t<div id="asset_graph"></div>\r\n\t\t\t</div>\r\n\t\t\t<div  ng-if="assetreportbutton == \'option1\'">\r\n\t\t\t\t<div id="asset_graph"></div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div> --><div class="row" ng-if="reporthide"><div class="col-md-10 col-md-offset-1"><!-- Map box --><div class="box box-solid"><div class="box-header"><i class="fa fa-server"></i><h3 class="box-title" translate="global.menu.asset-case-report">Generic Reports</h3></div><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control" placeholder="Search" ng-change="assetReportSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Asset Name</span></th><th><span>Asset Status</span></th><th><span>Incident ID</span></th><th><span>Incident Description</span></th><th>Incident Status</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords"><td>{{record.assetName}}</td><td>{{record.assetStatus == true ? \'ACTIVE\' : \'IN-ACTIVE\' }}</td><td><a ui-sref="tr-case-detail({id:record.caseId})">{{record.caseId}}</a></td><td>{{record.caseDescription}}</td><td>{{record.caseStatus}}</td></tr></tbody></table></div></div><!--  added for heightchart end --></div></div></div>');
$templateCache.put('app/report/asset-geofence-mapping.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-heartbeat"></i> &nbsp;<span> Asset Geofence Mapping</span></h3></div><div class="box-body border"><div class="col-md-12 form-group"><label class="col-md-3 control-label"><span>Select Tenant</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedTenantId" ng-change="onTenantChange();" required><option value="">Select Tenant</option><option ng-repeat="item in vm.tenants" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="col-md-12 form-group" ng-show="vm.selectedTenantId"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="onMasterChange();" required><option value="">Select Geofence</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><br><div class="col-md-12 form-group" ng-show="vm.selectedMasterGeofenceId"><label class="col-md-3 control-label"><span>Select Geofence</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedGeofenceId" required><option value="">Select Geofence</option><option ng-repeat="item in vm.geofenceMini" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="row" ng-show="vm.selectedGeofenceId" style="margin: 20px;"><button class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" ng-click="vm.associateAssetsToGeofence()" style="margin: 20px;">Associate <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></div></div></div></div>');
$templateCache.put('app/report/asset-health-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-heartbeat"></i> &nbsp;<span> Asset Health Report</span></h3></div><div class="box-body"><jhi-alert></jhi-alert><div class="col-md-12" style="margin: 10px;"><div class="form-group"><label class="col-md-2 control-label mt-8"><span>Select Geofence</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3 ml_4"><select id="miniGeofences" class="select2 form-control" name="search" ng-model="vm.selectedGeofenceId" ng-options="item.id as item.name for item in vm.userGeofences" required><option value="">Select geofence</option><option ng-repeat="geofence in vm.userGeofences" value="geofence.id">{{geofence.name}}</option></select></div><div class="col-md-2 mr_5"><button type="button" class="btn btn-info btn-flat" ng-click="vm.showAssetHealth()" ng-if="vm.selectedGeofenceId!=null">Show Assets</button></div></div><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="vm.mapAssets.length>0"><select id="searchAssetsOnMap" class="select2 form-control" name="search"><option value="">Search Asset</option><option ng-repeat="item in vm.mapAssets" value="{{item}}">{{item.name}}</option></select></div><!-- <div class="col-md-1" ng-show="isSet(2)">\r\n                            <button type="button" value="GOTO" class="btn btn-info btn-flat"\r\n                                ng-click="vm.gotoLatitute()">\r\n                                GOTO\r\n                            </button>\r\n                        </div>\r\n\t\t\t\t\t\t<div class="pull-right ml-10 mt-0 div--filter" ng-show="isSet(2)">\r\n                            <button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnMapView()"\r\n                                >\r\n                                <i class="fa fa-filter"></i>\r\n                            </button>\r\n                            <button type="button" value="Layers" class="btn btn-info btn-flat"\r\n                                ng-click="vm.showLayers()">\r\n                                Layers\r\n                            </button>\r\n                        </div> --></div><div class="map-view"><div class="row mt-5"><div class="pull-right"><span id="myspan"></span></div><div class="col-md-8"><div id="map_canvas" style="height:{{mapHeight}}px;"></div></div><div class="col-md-4 table-responsive mt_3" ng-show="vm.selectedGeofenceId>0"><table class="jh-table table table-responsive table-hover" style="display: block;height: {{mapHeight}}px;overflow: auto;"><thead class="thead-light"><tr><th><span translate="">Geofence</span></th><th><span translate="">Good (Km)</span></th><th><span translate="">Bad (Km)</span></th><th><span translate="">NA (Km)</span></th></tr></thead><tbody><tr ng-repeat="assethealth in vm.assetHealthDistance" ng-show="vm.assetHealthDistance.length>0"><td>{{assethealth.name}}</td><td>{{assethealth.okDistance}}</td><td>{{assethealth.notOkDistance}}</td><td>{{assethealth.normalDistance}}</td></tr><tr><td colspan="10" ng-show="vm.assetHealthDistance.length == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div></div></div></div><div id="modalAssetAttributes" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameAssetAttributes" class="span__modal-header">Asset Attributes</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeAssetAttributesModal()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body"><div id="assetAttributeTable"></div></div></form></div></div></div><div id="modalThreePointReference" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameThreePointReference" class="span__modal-header">3 Point Reference</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeThreePointReference()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body"><div id="threePointReferenceTable"></div></div></form></div></div></div>');
$templateCache.put('app/report/asset-health-status-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-heartbeat"></i> &nbsp;<span> Asset Health Status Report</span></h3></div><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="onMasterChange();" required><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><br><div class="form-group" ng-show="vm.selectedMasterGeofenceId"><label class="col-md-3 control-label"><span>Select Geofence</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedGeofenceId" ng-change="onMiniChange();" required><option value="">Select Geofence</option><option ng-repeat="item in vm.geofenceMini" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="row" ng-show="vm.assetRecords" style="margin: 20px;"><button class="btn btn-primary btn-sm pull-right" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAssetHealthStatusReport()" style="margin: 20px;">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th style="width: 2%;"></th><th jh-sort-by="assetId"><span>Asset Id </span><span class="fa fa-sort"></span></th><th jh-sort-by="assetName"><span>Asset Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="assetStatus"><span>Asset Status </span><span class="fa fa-sort"></span></th><th jh-sort-by="geofenceName"><span>Geofence Name</span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat-start="assetRecord in vm.assetRecords | filter:search" ng-class="{selected: assetRecord.isChecked}"><!-- <td style="position:relative; padding-left: 1px;width: 2%">\r\n                                            <button ng-click="vm.caseTable(assetRecord);" expand\r\n                                                style="padding: 4px 4px;position: absolute;margin-top: -6px;">\r\n                                            <span ng-bind="assetRecord.isExpanded ? \'-\' : \'+\'"\r\n                                                    style="position: absolute;margin-top: -11px;margin-left: -4px;"></span>\r\n                                            </button>\r\n                                        </td> --><td class="td__listViewRow" ng-click="vm.caseTable(assetRecord);" expand><span ng-if="!assetRecord.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="assetRecord.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{assetRecord.assetId}}</td><td>{{assetRecord.assetName}}</td><td>{{assetRecord.assetStatus}}</td><td>{{assetRecord.geofenceName}}</td></tr><tr ng-show="assetRecord.isExpanded"><td></td><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 27px;"><thead><tr></tr></thead><tbody><tr ng-repeat-start="case in vm.caseRecords"><td>{{case.id}}</td><td>{{case.description}}</td><td>{{case.createDate | date:\'medium\'}}</td><td>{{case.status}}</td><td>{{case.reportedByUser}}</td><td>{{case.assignedToUser}}</td></tr><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.assetRecords == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/report/asset-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-bandcamp"></i> <span translate="trakeyeApp.report.asset-report">Asset Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="assetForm" ng-submit="assetReport()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">From Date <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-2"><div class="input-group"><input type="text" id="date" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label assetReport_toDate">To Date <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><span class="dateError col-md-2" ng-if="vm.fromDate > vm.toDate">To date should be greater than from date</span></div><div class="form-group"><label class="col-sm-3 control-label ng-scope" translate="report.report">Report</label><div class="col-sm-8" ng-init="assetreportbutton=\'option1\'"><label class="radio-inline"><input type="radio" ng-model="assetreportbutton" value="option1" checked="checked" ng-change="clearSearch()"> Asset Report</label> <label class="radio-inline"><input type="radio" ng-model="assetreportbutton" value="option2" ng-change="clearSearch()"> Asset Incident Attribute Report</label></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_asset"><span translate="trakeyeApp.report.asset">Asset</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><input list="assetlist" class="form-control" id="asset_list" placeholder="Search Asset" type="text" ng-model="vm.assetType" autocomplete="off" name="assetList" ng-change="vm.filterAssetsList()" required><datalist ng-hide="vm.assetList" id="assetlist" class="form-control1" required><option ng-repeat="asset in vm.assetList" value="{{asset.name}}"></datalist></div></div><div class="form-group" ng-if="assetreportbutton == \'option2\'"><label class="col-md-3 control-label"><span translate="trakeyeApp.report.casetype">caseType</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="caseType" ng-model="vm.caseType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.caseTypes track by item.id" required><option value="" translate="trakeyeApp.report.selectcase">--- Select CaseType ---</option></select></div></div><div class="form-group" ng-if="assetreportbutton == \'option2\'"><label class="col-md-3 control-label"><span translate="trakeyeApp.report.attribute">Attribute</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="attribute" ng-model="vm.attribute" ng-options="attribute as attribute.caseTypeAttribute.name for attribute in vm.attributeValues" required><option value="" translate="trakeyeApp.report.selectattribute">--- Select Attribute ---</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="assetForm.$invalid || vm.toDate < vm.fromDate">Submit</button></div></div></form></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1"><div ng-if="assetreportbutton == \'option2\'"><div id="asset_graph"></div></div><div ng-if="assetreportbutton == \'option1\'"><div id="asset_graph"></div></div></div></div><!--  added for heightchart end --></div>');
$templateCache.put('app/report/battery-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-battery-full"></i> <span translate="global.menu.battery-report">Battery Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="batteryreportForm" ng-submit="batteryreport()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label battery_toDate">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" required ng-model="vm.userid" ng-options="item.id as item.login for item in vm.batteryusers"><option value="">Select UserName</option><option ng-repeat="user in vm.batteryusers" value="user.id">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="batteryreportForm.$invalid">Submit</button></div></div></form></div></div></div><!--  added for heightchart start --><!--<div class="row" ng-if="batteryreport">\r\n\t\t<div id="linegraphdiv">\r\n\t\t\t<div class="col-md-10 col-md-offset-1">\r\n\t\t\t\t<div class="box box-solid">\r\n\t\t\t\t\t<div class="box-header">\r\n\t\t\t\t\t\t<h3 class="box-title">Battery Line Graph</h3>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="box-body chart-responsive">\r\n\t\t\t\t\t\t<div id="linegraphmessage">\r\n\t\t\t\t\t\t\t<p class="text-danger">No battery data available for the given input</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div id="battery_graph"></div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>--><div class="row"><div class="col-md-10 col-md-offset-1"><div id="battery_graph"></div></div></div><!--  added for heightchart end --><div class="row"><!-- Map box --><div class="col-md-12"><!-- <div class="box box-solid">\r\n                <div class="box-body chart-responsive">\r\n                    <h4 style="text-align: center;">Battery Reports</h4>\r\n                    <div id="line-chart" style="height: 285px; position: relative;"></div>\r\n                </div>\r\n            </div> --></div></div></div><style>.axis path,\r\n    .axis line {\r\n        fill: none;\r\n        stroke: grey;\r\n        stroke-width: 1;\r\n        shape-rendering: crispEdges;\r\n    }</style>');
$templateCache.put('app/report/case-aging-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-bar-chart"></i> <span translate="trakeyeApp.caseAging.report">Incident Aging Report</span></h3></div><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label" translate="trakeyeApp.caseAging.agerange">Age Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="WEEKS"> <span translate="trakeyeApp.caseAging.agerangevalue.weeks">WEEKS</span></label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="MONTHS"> <span translate="trakeyeApp.caseAging.agerangevalue.months">MONTHS</span></label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="YEARS"> <span translate="trakeyeApp.caseAging.agerangevalue.years">YEARS</span></label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="DAYS"> <span translate="trakeyeApp.caseAging.agerangevalue.days">DAYS</span></label></div></div><div class="form-group" ng-if="vm.dateRange == \'DAYS\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" ng-model="vm.reportUser"><option value="">Select UserName</option><option ng-repeat="item in vm.users" title="{{item.login}}" ng-selected="{{item.login == vm.reportUser}}" value="{{item.login}}">{{item.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div><div><button ng-if="vm.reportGenerated" class="btn btn-primary center-block" ng-click="download()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div><div class="container" style="overflow: scroll;overflow-x: scroll;overflow-y:hidden;width: 100%;"><!-- <button class="btn btn-primary center-block" ng-click="getPdf()"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="reportpdf"><div class="col-md-12" data-ng-bind-html="myhtml | trustFilter"></div><!-- <div class="col-md-12">\r\n\t\t\t<div id="verticalBarChart"></div>\r\n\t\t</div> --></div></div>');
$templateCache.put('app/report/case-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="global.menu.reportcharts.case-report">Generic Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label" translate="report.report">Report</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="report" class="report" ng-model="vm.reportType" value="AGENT" required ng-click="vm.reportTypeChange()"><span>User-Agent</span></label> <label class="radio-inline"><input type="radio" name="report" class="report" ng-model="vm.reportType" value="GEOFENCE" ng-click="vm.reportTypeChange()">Geofence</label></div></div><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-1 control-label">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group" ng-if="vm.reportType == \'AGENT\'"><label class="col-sm-3 control-label">User-Agent Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="AGENT" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'AGENT\' && vm.userAgent==\'AGENT\'"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><!-- useragent Report --><!-- Geofence Report --><div class="form-group" ng-if="vm.reportType == \'GEOFENCE\'"><label class="col-sm-3 control-label">Geofence Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="geofence" required ng-model="vm.geofence" value="GEOFENCE" ng-click="vm.select2()">Geofence Name</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.geofence" value="all">All Geofence</label></div></div><div class="form-group" ng-if="vm.reportType == \'GEOFENCE\' && vm.geofence == \'GEOFENCE\'"><label class="col-sm-3 control-label"><span>Select Geofence</span></label><div class="col-sm-7"><select class="form-control select2" name="search" required id="geofences" ng-model="vm.id" ng-options="item.id as item.name for item in vm.geofences"><option value="">Select Geofence</option></select></div></div><!--Geofence Report --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1"><div style="display: block;" class="birt-graph" data-ng-bind-html="myhtml | trustFilter"></div></div></div></div>');
$templateCache.put('app/report/case-tat-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="trakeyeApp.caseTat.title">Incident TAT Report</span></h3></div><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label" translate="trakeyeApp.caseTat.agerange">Age Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="MONTHS"> <span translate="trakeyeApp.caseTat.agerangevalue.months">MONTHS</span></label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="DAYS"> <span translate="trakeyeApp.caseTat.agerangevalue.days">DAYS</span></label><!--  <label class="radio-inline pl-10"><input type="radio"\r\n\t\t\t\t\t\t\t\t\tname="dateRange" ng-model="vm.dateRange" value="custom">Custom</label>--></div></div><div class="form-group" ng-if="vm.dateRange == \'DAYS\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.caseTat.tat">TAT</span></label><div class="col-md-1"><input type="number" class="form-control" name="tat" ng-model="vm.tat" ngminlength="1" ngmaxlength="1000" min="1" max="1000"></div><label class="col-sm-2 control-label tatReport_selectUser"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" ng-model="vm.reportUser"><option value="">Select UserName</option><option ng-repeat="item in vm.users" title="{{item.login}}" ng-selected="{{item.login == vm.reportUser}}" value="{{item.login}}">{{item.login}}</option></select></div></div><div class="form-group"></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div></div><div class="content" style="overflow: scroll;overflow-x: scroll;overflow-y:hidden"><!-- <button class="btn btn-primary center-block"  ng-click="getPdf()"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="reportpdf"><div class="col-md-12" data-ng-bind-html="myhtml | trustFilter"></div><!-- <div class="col-md-12">\r\n\t\t\t<div id="verticalBarChart" style="width: 100%;height: 100%;"></div>\r\n\t\t</div> --></div>');
$templateCache.put('app/report/case-type-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="global.menu.reportcharts.case-report">CaseType Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label">Incident Type Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="case" required ng-model="vm.selectCaseType" value="1">Incident Type</label> <label class="radio-inline"><input type="radio" name="case" ng-model="vm.selectCaseType" value="all">All Cases</label></div></div><div class="form-group" ng-if="vm.selectCaseType == 1"><label class="col-sm-3 control-label"><span>Select Incident Type</span></label><div class="col-sm-4"><select class="select2 form-control" name="caseType" ng-model="vm.selectedCaseType" ng-options="item as item.name for item in\r\n\t\t\t\t\t\t\t\t\tvm.caseTypes track by item.id" style="width: 100%;" value="{{item.id}}"><option value="">--- Select CaseType ---</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" ng-click="vm.submitCaseReport()" translate="upload.submit">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadCaseReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div><div class="content"><div class="row" ng-if="reporthide"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-body"><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="id"><span>ID </span><span class="fa fa-sort"></span></th><th jh-sort-by="description"><span>Description </span><span class="fa fa-sort"></span></th><th jh-sort-by="status"><span>Status </span><span class="fa fa-sort"></span></th><th jh-sort-by="caseTypeName"><span>Incident Type </span><span class="fa fa-sort"></span></th><th jh-sort-by="address"><span>Address </span><span class="fa fa-sort"></span></th><th jh-sort-by="pinLat"><span>Latitude </span><span class="fa fa-sort"></span></th><th jh-sort-by="pinLong"><span>Longitude </span><span class="fa fa-sort"></span></th><th jh-sort-by="assignedToUser"><span>Assigned To </span><span class="fa fa-sort"></span></th><th jh-sort-by="reportedByUser"><span>Reported By </span><span class="fa fa-sort"></span></th><th jh-sort-by="updatedByUser"><span>Updated By </span><span class="fa fa-sort"></span></th><th jh-sort-by="assignedByUser"><span>Assigned By </span><span class="fa fa-sort"></span></th><th jh-sort-by="createDate"><span>Created Date </span><span class="fa fa-sort"></span></th><th jh-sort-by="updateDate"><span>Updated Date </span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td>{{record.id}}</td><td>{{record.description}}</td><td>{{record.status}}</td><td>{{record.caseTypeName}}</td><td>{{record.address}}</td><td>{{record.pinLat}}</td><td>{{record.pinLong}}</td><td>{{record.assignedToUser}}</td><td>{{record.reportedByUser}}</td><td>{{record.updatedByUser}}</td><td>{{record.assignedByUser}}</td><td><span>{{record.createDate | date:\'medium\'}}</span></td><td><span>{{record.updateDate | date:\'medium\'}}</span></td></tr></tbody></table></div></div></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1"><div style="display: block;" class="birt-graph" data-ng-bind-html="myhtml | trustFilter"></div></div></div></div></div>');
$templateCache.put('app/report/cases-dump-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> <span translate=" ">Download Cases</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-4 control-label">Select Type</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="type" ng-model="vm.downloadType" value="opencases">Open Cases</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.downloadType" value="closedcases">Closed Cases</label></div></div><div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessage"><h1>THANK YOU!</h1><i class="fa fa-check main-content__checkmark" style="font-size:96px;color: green;"></i><p>Action has been taken.</p><p>We are now generating the report</p></div></div><div class="box-footer"><div><button class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" ng-click="vm.downloadCaseDumpReport()" style="margin: 20px;">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/daily-survey-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span>Daily Survey Reports</span></h3></div><!-- Form start --><form class="form-horizontal" name="reportForm" ng-submit="report(true)"><div class="box-body border"><!-- Date Range --><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- Custom date range --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-1 control-label">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- User selection --><!-- <div class="form-group">\r\n\t\t\t\t\t\t\t<label class="col-sm-3 control-label"><span>Select User</span></label>\r\n\t\t\t\t\t\t\t<div class="col-sm-3">\r\n\t\t\t\t\t\t\t\t<select class="select2 form-control" name="search" required ng-model="vm.userid"\r\n\t\t\t\t\t\t\t\t\tng-options="item.login as item.login for item in vm.users">\r\n\t\t\t\t\t\t\t\t\t<option value="">Select UserName</option>\r\n\t\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --></div><!-- Submit button --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div><div><button ng-if="dailySurveyData.length>0" class="btn btn-primary center-block" ng-click="download()">Download CSV <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><!-- Report content --><div class="row" ng-if="dailySurveyData.length > 0"><div class="table-responsive"><table class="jh-table table table-responsive table-hover" style="width: 100%; border-spacing:0; margin: 0;"><thead class="bg-default"></thead><tr><th><span>Sl No</span></th><th><span>Created Date</span></th><th><span>Updated Date</span></th><th><span>Asset Name</span></th><th><span>Asset Type Name</span></th><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Block Name</span></th><th><span>District Name</span></th><th><span>Status</span></th><th><span>Progress</span></th></tr><tbody><tr ng-repeat="asset in dailySurveyData track by $index"><td>{{$index+1}}</td><td>{{asset.createDate | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</td><td>{{asset.updateDate | date:\'dd-MMM-yyyy hh:mm:ss a\'}}</td><td>{{asset.assetName}}</td><td>{{asset.assetTypeName}}</td><td>{{asset.firstName}}</td><td>{{asset.lastName}}</td><td>{{asset.blockName}}</td><td>{{asset.district}}</td><td>{{asset.status}}</td><td><span ng-if="asset.status === \'Completed\'">100% </span><span ng-if="asset.status === \'In Progress\'">50% </span><span ng-if="asset.status === \'Not Started\'">0%</span> <span ng-if="!asset.status">N/A</span></td></tr><tr><td colspan="7" ng-show="dailySurveyData==0 " style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div><!-- Pagination --><div class="row mt-10" ng-if="vm.totalItems > 0"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage" ng-change="report(false)"></uib-pagination></div></div></div></div></div></div></div>');
$templateCache.put('app/report/distance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="global.menu.reportcharts.distance-report">Generic Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-1 control-label">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" required ng-model="vm.userid" ng-options="item.login as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.login">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1"><div style="display: block;" class="birt-graph" data-ng-bind-html="myhtml | trustFilter"></div></div></div></div>');
$templateCache.put('app/report/distance-travelled.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-motorcycle"></i> <span translate="global.menu.distance-travelled">Distance Travelled</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="distanceForm" ng-submit="distancereport()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label dstnTrvld_toDate">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" required ng-model="vm.userid" ng-options="item.id as item.login for item in vm.batteryusers"><option value="">Select UserName</option><option ng-repeat="user in vm.batteryusers" value="user.id">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="distanceForm.$invalid">Submit</button></div></div></form></div></div></div><!--  added for heightchart start --><!--<div class="row" ng-if="batteryreport">\r\n\t\t<div id="linegraphdiv">\r\n\t\t\t<div class="col-md-10 col-md-offset-1">\r\n\t\t\t\t<div class="box box-solid">\r\n\t\t\t\t\t<div class="box-header">\r\n\t\t\t\t\t\t<h3 class="box-title">Battery Line Graph</h3>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="box-body chart-responsive">\r\n\t\t\t\t\t\t<div id="linegraphmessage">\r\n\t\t\t\t\t\t\t<p class="text-danger">No battery data available for the given input</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div id="battery_graph"></div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>--><div class="row"><div class="col-md-10 col-md-offset-1"><div id="distance_graph"></div></div></div><!--  added for heightchart end --><div class="row"><!-- Map box --><!-- <div class="col-md-12">\r\n            <div class="box box-solid">\r\n                <div class="box-body chart-responsive">\r\n                    <h4 style="text-align: center;">Distance Travelled Reports</h4>\r\n                    <div id="line-chart" style="height: 285px; position: relative;"></div>\r\n                </div>\r\n            </div>\r\n        </div> --></div></div><style>.axis path,\r\n    .axis line {\r\n        fill: none;\r\n        stroke: grey;\r\n        stroke-width: 1;\r\n        shape-rendering: crispEdges;\r\n    }</style>');
$templateCache.put('app/report/entity-dump-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span>Create New Request</span></h3></div><!-- /.box-header --><!-- form start --><div class="col-md-12 mt-5"><span ui-sref="entity-dump" class="fa fa-arrow-left" style="font-size: 15px;cursor: pointer;color:#000">Back</span></div><form class="form-horizontal" name="entityForm" ng-submit="entityDump()"><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select Entity</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="entity" ng-model="vm.entity" required><option value="">--- Select Entity ---</option><option value="Assets" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD">Assets</option><option value="Cases">Cases</option><option value="Users">Users</option></select></div></div><div class="form-group" ng-if="vm.entity==\'Assets\' && (has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="onMasterChange();" required><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-if="vm.entity==\'Assets\' && vm.selectedMasterGeofenceId>0 && (has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select Geofence</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div isteven-multi-select input-model="vm.geofenceMini" output-model="vm.selectedGeofenceId" button-label="name" item-label="name" tick-property="ticked" helper-elements="all none filter" output-properties="id geofenceDTO"></div><input type="text" ng-model="vm.selectedGeofenceId" name="vm.searchMini" style="display:none" required></div></div><div class="form-group" ng-if="vm.entity==\'Assets\' && (has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select Asset Layout</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="layout" ng-model="vm.entityLayout" ng-change="assetLayoutChange()" required><option value="">--- Select Asset Layout ---</option><option value="FIXED">FIXED</option><option value="SPREAD">SPREAD</option></select></div></div><div class="form-group" ng-if="vm.entity==\'Assets\' && vm.entityLayout.length >0 && (has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select Asset Type</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div isteven-multi-select input-model="vm.assetTypes" selection-mode="single" output-model="vm.selectedAssettypeId" button-label="name" item-label="name" tick-property="ticked" helper-elements="all none filter" output-properties="id"></div><input type="text" ng-model="vm.selectedAssettypeId" name="vm.searchMini" style="display:none" required></div></div><div class="form-group" ng-if="vm.entity==\'Assets\' && vm.selectedAssettypeId.length > 0 &&(has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER)"><label class="col-md-3 control-label"><span>Select File Format</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" ng-model="vm.entityFileFormat" required><option value="">--- Select File Format ---</option><option value="CSV">CSV</option><option value="KML">KML</option><!-- <option value="EXCEL">EXCEL</option> --></select></div></div><div class="form-group" ng-if="vm.entity==\'Cases\'"><label class="col-sm-3 control-label">Select Type</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="type" ng-model="vm.entityStatus" value="ALL">All</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.entityStatus" value="OPEN">Open Cases</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.entityStatus" value="CLOSED">Closed Cases</label></div></div><div class="form-group" ng-if="(vm.entityStatus == \'OPEN\' || vm.entityStatus == \'CLOSED\' || vm.entityStatus == \'ALL\') && vm.entity==\'Cases\' && (has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER)"><div class="form-group"><label class="col-sm-3 control-label">Select</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="case" ng-model="vm.selectCaseType" value="all">All</label> <label class="radio-inline"><input type="radio" name="case" required ng-model="vm.selectCaseType" value="1">Incident Type</label></div></div><div class="form-group" ng-if="vm.selectCaseType == 1"><label class="col-sm-3 control-label"><span>Select Incident Type</span></label><div class="col-sm-4"><select class="select2 form-control" name="caseType" ng-model="vm.selectedCaseType" ng-options="item as item.name for item in\r\n\t\t\t\t\t\t\t\t\t\tvm.caseTypes track by item.id" style="width: 100%;" value="{{item.id}}"><option value="">--- Select CaseType ---</option></select></div></div><div class="form-group" ng-if="(vm.selectCaseType == 1 && vm.selectedCaseType.id>0) || vm.selectCaseType == \'all\' "><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" datepicker-options="optionsFrom" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" datepicker-options="optionsTo" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><!-- <div class="form-group" ng-show="vm.entity !== \'Asset\'">\r\n\t\t\t\t\t\t\t<label class="col-sm-3 control-label">From Date</label>\r\n\t\t\t\t\t\t\t<div class="col-sm-3">\r\n\t\t\t\t\t\t\t\t<div class="input-group">\r\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="fromDate" required disabled\r\n\t\t\t\t\t\t\t\t\t\tdatetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate"\r\n\t\t\t\t\t\t\t\t\t\tng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate" />\r\n\t\t\t\t\t\t\t\t\t<span class="input-group-btn">\r\n\t\t\t\t\t\t\t\t\t\t<button type="button" class="btn btn-default"\r\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.openCalendar(\'fromDate\')">\r\n\t\t\t\t\t\t\t\t\t\t\t<i class="glyphicon glyphicon-calendar"></i>\r\n\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t<label class="col-sm-2 control-label">To Date</label>\r\n\t\t\t\t\t\t\t<div class="col-sm-3">\r\n\t\t\t\t\t\t\t\t<div class="input-group">\r\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="toDate" required disabled\r\n\t\t\t\t\t\t\t\t\t\tdatetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate"\r\n\t\t\t\t\t\t\t\t\t\tng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate" />\r\n\t\t\t\t\t\t\t\t\t<span class="input-group-btn">\r\n\t\t\t\t\t\t\t\t\t\t<button type="button" class="btn btn-default"\r\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.openCalendar(\'toDate\')">\r\n\t\t\t\t\t\t\t\t\t\t\t<i class="glyphicon glyphicon-calendar"></i>\r\n\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessage"><h1>THANK YOU!</h1><i class="fa fa-check main-content__checkmark" style="font-size:96px;color: green;"></i><!-- <p>Your Request Has Been Successfully Recorded.</p>\r\n\t\t\t\t\t\t\t<p>Please Expect Email Soon..</p> --><p>Your Tracking Id is {{vm.trackingId}}</p></div><div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessageError"><h1>Error</h1><i class="fa fa-times main-content__checkmark" style="font-size:96px;color: red;"></i><p>{{vm.errorMessage}}</p></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm pull-right" ng-disabled="entityForm.$invalid">Submit</button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/entity-dump.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="glyphicon glyphicon-envelope"></i> &nbsp;<span> Entity Dump</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="entity-dump.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><i class="fa fa-refresh" aria-hidden="true" style="font-size: 20px;cursor: pointer;color:#000" title="Refresh" ng-click="vm.refresh()"></i><div class="table-responsive mt-10"><table class="table table-responsive table-hover"><thead class="bg-default"><tr><th></th><!-- <th>ID</th> --><th>Entity Name</th><th>Entity Layout</th><th>Entity Status</th><th>Geofence Name</th><th>Request From Date</th><th>Request To Date</th><th><span>Status</span></th><th><span>Created Date</span></th><th></th><!-- <th><span>Type</span> <span\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-sort"></span></th> --></tr></thead><tbody><tr ng-repeat-start="list in vm.displayList track by list.id" ng-class="{greenyellow: $index === 0 && vm.highlightRow }"><td class="td__listViewRow" ng-click="vm.expand(list);" ng-show="(list.entityName == \'CASES\' || list.entityName == \'ASSETS\') && list.messageStatus == \'COMPLETE\'"><span ng-if="!list.expand"><i class="fa fa-plus-square" aria-hidden="true" title="Details"></i></span> <span ng-if="list.expand"><i class="fa fa-minus-square" aria-hidden="true" title="Details"></i></span></td><td ng-hide="(list.entityName == \'CASES\' || list.entityName == \'ASSETS\') && list.messageStatus == \'COMPLETE\'"></td><!-- <td>\r\n                                         {{list.id}}\r\n                                    </td> --><td>{{list.entityName}}</td><td><span ng-show="list.entityLayout != null">{{list.entityLayout}}</span> <span ng-show="list.entityLayout == null">n/a</span></td><td><span ng-show="list.entityStatus != null">{{list.entityStatus}}</span> <span ng-show="list.entityStatus == null">n/a</span></td><td><div ng-repeat="geofenceVal in list.geofences"><span style="display: block;width: 250px;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">{{geofenceVal.name}}</span></div></td><td><span ng-show="list.reqFromDate != null">{{list.reqFromDate | date: "dd/MM/yyyy \'at\' h:mma"}}</span> <span ng-show="list.reqFromDate == null">n/a</span></td><td><span ng-show="list.reqToDate != null">{{list.reqToDate | date: "dd/MM/yyyy \'at\' h:mma"}}</span> <span ng-show="list.reqToDate == null">n/a</span></td><td><span class="label label-info" ng-if="list.messageStatus == \'OPEN\'">{{list.messageStatus}}</span> <span class="label label-success" ng-if="list.messageStatus == \'COMPLETE\'">{{list.messageStatus}}</span> <span class="label label-danger" ng-if="(list.messageStatus !== \'OPEN\') && (list.messageStatus !== \'COMPLETE\')">{{list.messageStatus}}</span></td><td>{{list.createdDate | date: "dd/MM/yyyy \'at\' h:mma"}}</td></tr><tr ng-show="list.expand"><td colspan="11"><table style="width: 40%; height:100%; border-spacing:0; margin-left: 3%;"><thead><tr><th>Sl No</th><!--  <th>Report Name</th> --><th>File Name</th><th>Type</th></tr></thead><tbody><tr ng-repeat="item in vm.expandResponse"><td>{{$index+1}}</td><!-- <td>{{item.imageName}}</td> --><td ng-click="vm.download(item.imageId,item.trackerId,item.imageName)"><a>{{item.imageName}}</a></td><td>{{item.imageType}}</td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0"><h4>No data available</h4></td><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null"><h4>Loading...</h4></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.displayList.length == 0"><h4>No data available</h4></td></tr></tbody></table><!-- <div class="row">\r\n                            <div class="col-md-4">\r\n                                <div class="count-length">\r\n                                    <jhi-item-count page="vm.page" total="vm.queryCount"\r\n                                        items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n                                </div>\r\n                            </div>\r\n                            <div class="col-md-8">\r\n                                <div class="pagination-list pull-right">\r\n                                    <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page"\r\n                                        ng-change="vm.transition()"></uib-pagination>\r\n                                </div>\r\n                            </div>\r\n                        </div> --></div></div></div></div></div></div>');
$templateCache.put('app/report/fiber-status-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-line-chart"></i> <span>Fiber Status Reports</span></h3></div><form class="form-horizontal" name="batteryreportForm"><div class="box-body border" style="height: 120px"><div class="form-group" style="margin-top: 30px;"><label class="col-sm-2 control-label"><span>Select Vendor</span></label><div class="col-sm-2"><select id="userlist" class="select2 form-control" style="width: 220px; height: 40px"><option value="">---All Vendors---</option><option ng-repeat="item in vm.userlist" value="{{item.id}}">{{item.firstName}} {{item.lastName}}</option></select></div></div></div><div class="col-sm-7" style="margin-top: 20px"><div class="box box-solid"><div class="box-body"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Fiber Provider</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>On Air</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Under Deployment</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Planned</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.multiassets track by asset.name"><td data-ng-click="vm.caseTypeClick(asset.name,\'\')" style="text-align:center;vertical-align:middle">{{asset.name}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'On Air\')" style="text-align:center;vertical-align:middle">{{asset.onair}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'Under Deployment\')" style="text-align:center;vertical-align:middle">{{asset.deployed}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'Planned\')" style="text-align:center;vertical-align:middle">{{asset.planned}}</td></tr></tbody></table></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Name</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Fiber Status</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Distance</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Link Status</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.assets track by asset.name"><td data-ng-click="vm.caseTypeClick(asset.name,\'\')" style="text-align:center;vertical-align:middle">{{asset.name}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'On Air\')" style="text-align:center;vertical-align:middle">{{asset.status}}</td><td data-ng-click="vm.caseTypeClick(asset.name,\'Under Deployment\')" style="text-align:center;vertical-align:middle">{{asset.distance}}</td><td style="text-align:center;vertical-align:middle">{{asset.linkstatus}}</td></tr></tbody></table></div></div></div></div><div class="col-sm-5" style="margin-top: 20px"><div style="text-align: center"><div class="box box-solid"><div class="box-body chart-responsive" style="text-align: center"><h3>On Air Status</h3><div class="chart" id="vendor-chart" style="height: 285px; position: relative;"></div></div><!-- /.box-body --></div></div><div style="text-align: center"><div class="box box-solid"><div class="box-body chart-responsive" style="align-content: center"><h3>Fiber Status</h3><div class="chart" id="fiber-chart" style="height: 285px; position: relative;"></div></div><!-- /.box-body --></div></div></div></form></div></div></div></div>');
$templateCache.put('app/report/geofence-dump.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> <span translate=" ">Geofence Dump</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label"><span>Select geofence</span></label><div class="col-sm-4"><select class="select2 form-control" name="search" ng-model="vm.selectedGeofenceId" ng-options="item.id as item.nameZone for item in vm.geofences" required><option value="">Select geofence</option><option ng-repeat="geofence in vm.geofences" value="geofence.id">{{geofence.nameZone}}</option></select></div></div></div><div class="box-footer"><div><button class="btn btn-primary pull-left" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download CSV <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div><div><button class="btn btn-primary pull-right" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReportKml()">Download KML <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/geofence-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span>Geofence Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group" ng-if="vm.reportType == \'agent\'"><label class="col-sm-3 control-label">User-Agent Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'agent\' && vm.userAgent==\'username\'"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><!-- useragent Report --><!-- Geofence Report --><div class="form-group" ng-if="vm.reportType == \'geofence\'"><label class="col-sm-3 control-label">Geofence Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="geofence" required ng-model="vm.geofence" value="geofence" ng-click="vm.select2()">Geofence Name</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.geofence" value="all">All Geofence</label></div></div><div class="form-group" ng-if="vm.reportType == \'geofence\' && vm.geofence == \'geofence\'"><label class="col-sm-3 control-label"><span>Select Geofence</span></label><div class="col-sm-7"><select class="form-control select2" name="search" required id="geofences" ng-model="vm.id" ng-options="item.id as item.name for item in vm.geofences"><option value="">Select Geofence</option></select></div></div><!--Geofence Report --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div><div class="row" ng-if="reporthide"><div class="col-md-10 col-md-offset-1"><!-- Map box --><div class="box box-solid"><div class="box-body"><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th ng-if="vm.reportType==\'agent\'"><span>Login</span> </th> --><th ng-if="vm.reportType==\'geofence\'"><span>Name</span></th><!-- <th ng-if="vm.reportType==\'agent\'"><span>From Hour</span></th>\r\n\t\t\t\t\t\t\t\t\t<th ng-if="vm.reportType==\'agent\'"><span>To Hour</span> </th> --><th><span>Cases</span></th><!-- <th><span>Services</span> </th> --><!-- <th ng-if="vm.reportType==\'agent\'">Distance Within Geofence</th> --><!-- <th ng-if="vm.reportType==\'agent\'">Distance Outside Geofence</th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><!-- <td ng-if="vm.reportType==\'agent\'">{{record.login}}</td> --><td ng-if="vm.reportType==\'geofence\'">{{record.name}}</td><!-- \t<td ng-if="vm.reportType==\'agent\'">{{getLocalhour(record.fromTime)}}</td>\r\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.reportType==\'agent\'">{{getLocalhour(record.toTime)}}</td> --><td>{{record.cases}}</td><!-- <td>{{record.services}}</td>\r\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.reportType==\'agent\'">{{record.distance_in |\r\n\t\t\t\t\t\t\t\t\t\tnumber:2}} KM</td>\r\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.reportType==\'agent\'">{{record.distance_out |\r\n\t\t\t\t\t\t\t\t\tnumber:2}} KM</td> --><td><a href="" ng-click="vm.detailedReport(record.id)"><i class="fa fa-eye"></i></a></td></tr></tbody></table></div></div></div></div></div><div class="row"><div id="report" class="col-md-10 col-md-offset-1" style="display: none;"><!-- box content--><div class="box box-solid"><div class="box-header box-info"><button type="button" class="btn btn-info btn-flat pull-right" ng-click="close()">Close</button><h4 class="box-title text-left"><img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'Fiberify\'"> <img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'Fiberify\'"> <img ng-src="content/images/bharatnet_logo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'BSNL\'"></h4></div><button class="btn btn-primary center-block" ng-click="getPdf()">Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="box-body" ng-if="vm.reportType==\'geofence\'" id="reportpdf"><h4 class="text-center mt-5">Geofence Report for <b>{{vm.detailedReportCounts.name}}</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowCancelled}}</p></div></div></div></div></div><!-- Services --><!-- <div class="box box-solid">\r\n\r\n                        <div class="box-header">\r\n                            <h3 class="box-title">Services</h3>\r\n                        </div>\r\n                        <div class="box-body">\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-danger">Critical</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-success">High</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-primary">Medium</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n\r\n                            <div class="col-sm-3">\r\n                                <h4 class="report-head text-warning">Low</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div> --><div class="box box-solid"><div class="box-header"><h3 class="box-title">Geofence</h3></div><div class="box-body"><div class="row"><div class="col-md-12"><div id="map_canvas" style="height:300px; width:100%;"></div></div></div></div></div></div><div class="box-body" ng-if="vm.reportType==\'agent\'" id="reportpdf"><!-- <div class="box-body" ng-if="vm.reportType==\'agent\'"> --><h4 class="text-center mt-5">Agent Report for <b>{{vm.detailedReportCounts.name}} ({{vm.detailedReportCounts.login}})</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Created by Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Assigned to Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowCancelled}}</p></div></div></div></div></div><!-- Services --><!-- <div class="box box-solid">\r\n                        <div class="box-header">\r\n                            <h3 class="box-title">Services</h3>\r\n                        </div>\r\n                        <div class="box-body">\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-danger">Critical</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-success">High</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-primary">Medium</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n\r\n                            <div class="col-sm-3">\r\n                                <h4 class="report-head text-warning">Low</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div> --><div class="box box-solid"><div class="box-header"><h3 class="box-title">Distanc IN</h3>{{vm.detailedReportCounts.distance_in | number:2}} KM<h3 class="box-title">Distanc OUT</h3>{{vm.detailedReportCounts.distance_out | number:2}} KM</div><!-- <div class="box-body">\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">\r\n\t\t\t\t\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100%;"></div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div></div>');
$templateCache.put('app/report/gps-user-attendance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-motorcycle"></i> <span translate=" ">Distance Travelled Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\'"><label class="col-sm-4 control-label">User-Attendance Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download CSV <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10 table-scroll" ng-if=\'vm.userType=="gpsUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="userName"><span>User Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="userFirstName"><span>First Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="userLastName"><span>Last Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="phone"><span>Phone No </span><span class="fa fa-sort"></span></th><th jh-sort-by="businessArea"><span>BA Name</span><span class="fa fa-sort"></span></th><th jh-sort-by="districtName"><span>District Name</span><span class="fa fa-sort"></span></th><th jh-sort-by="blockName"><span>Block Name</span><span class="fa fa-sort"></span></th><th jh-sort-by="startTime"><span>Start Time </span><span class="fa fa-sort"></span></th><th><span>Start LatLng</span></th><th jh-sort-by="endTime"><span>End Time </span><span class="fa fa-sort"></span></th><th><span>End LatLng</span></th><th jh-sort-by="distanceIn">Distance Within Geofence <span class="fa fa-sort"></span></th><th jh-sort-by="distanceOut">Distance Outside Geofence <span class="fa fa-sort"></span></th><th jh-sort-by="totalDistance"><span>Distance </span><span class="fa fa-sort"></span></th><th jh-sort-by="createdCaseCount"><span>Incident Created </span><span class="fa fa-sort"></span></th><th jh-sort-by="assignedCaseCount"><span>Incident Assigned </span><span class="fa fa-sort"></span></th><th jh-sort-by="resolvedCaseCount"><span>Incident Resolved </span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.totalDistance>0"><td>{{record.userName}}</td><td>{{record.userFirstName}}</td><td>{{record.userLastName}}</td><td>{{record.phone}}</td><td>{{record.businessArea}}</td><td>{{record.districtName}}</td><td>{{record.block}}</td><td>{{record.startTime | date:\'medium\'}}</td><td>{{record.startLatLng}}</td><td>{{record.endTime | date:\'medium\'}}</td><td>{{record.endLatLng}}</td><td>{{record.distanceIn | number:2}} KM</td><td>{{record.distanceOut | number:2}} KM</td><td>{{record.totalDistance | number:2}} KM</td><!-- <td>{{record.createdCaseCount}}</td>\r\n                                     <td>{{record.assignedCaseCount}}</td>\r\n                                      <td>{{record.resolvedCaseCount}}</td> --><td><a ui-sref="tr-case.attendance({login:record.userId, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.createdCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.userId, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assignedCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.userId, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolvedCaseCount}}</a></td></tr></tbody></table></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="mobileUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Name</span></th><th><span>Check-In Time</span></th><th><span>Check-In Location</span></th><th><span>Check-In Address</span></th><th><span>Check-Out Time</span></th><th><span>Check-Out Location</span></th><th><span>Check-Out Address</span></th><th><span>Incident Created</span></th><th><span>Incident Assigned</span></th><th><span>Incident Resolved</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.checkInTime>0||record.createdCaseCount>0||record.assignedCaseCount>0||record.resolvedCaseCount>0"><td>{{record.userName}}</td><td ng-if="record.checkInTime>0">{{record.checkInTime | date:\'medium\'}}</td><td>{{record.checkInLocation}}</td><td title="{{record.checkInAddress}}">{{record.checkInAddress | limitTo: 20 }}{{record.checkInAddress.length > 20 ? \'...\' : \'\'}}</td><td ng-if="record.checkInTime==0">NA</td><td ng-if="record.checkOutTime>0">{{record.checkOutTime | date:\'medium\'}}</td><td>{{record.checkOutLocation}}</td><td title="{{record.checkOutAddress}}">{{record.checkOutAddress | limitTo: 20 }}{{record.checkOutAddress.length > 20 ? \'...\' : \'\'}}</td><td ng-if="record.checkOutTime==0">NA</td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.createdCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assignedCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolvedCaseCount}}</a></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/incidents-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate=" ">Incidents Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadIncidentsReport()">Download CSV <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10 table-scroll"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th><span>Id</span></th>`<th><span>Description</span></th><th><span>Case Create Date</span></th><th><span>Case Number</span></th><th><span>Status</span></th><th><span>Assigned To</span></th><th><span>Assigned To User</span></th><th><span>State</span></th><th><span>District</span></th><th><span>Block</span></th><th><span>Operation Area</span></th><th><span>Package Name</span></th><th><span>Business Area</span></th><th><span>Resolved Date</span></th><th><span>Resolution Time</span></th><th><span>Create to Resolve Time</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="vm.reportRecords.length > 0"><td>{{record.id}}</td><td>{{record.description}}</td><td>{{record.caseCreateDate}}</td><td>{{record.caseNumber}}</td><td>{{record.status}}</td><td>{{record.assignedTo}}</td><td>{{record.assignedToUser}}</td><td>{{record.state}}</td><td>{{record.district}}</td><td>{{record.block}}</td><td>{{record.operationArea}}</td><td>{{record.packageName}}</td><td>{{record.businessArea}}</td><td>{{record.resolvedDateTime}}</td><td>{{record.resolutionTimeH}}</td><td>{{record.createDateToResolvedH}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/mobile-user-attendance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate=" ">User Attendance Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="col-md-6"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-2 control-label">From Date</label><div class="col-sm-4"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate" max-date="vm.maxDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-4"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate" max-date="vm.maxDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- <div class="form-group">\r\n                            <label class="col-sm-4 control-label">User-Attendance Type</label>\r\n                            <div class="col-sm-6">\r\n                                <label class="radio-inline"><input type="radio" name="userType" required\r\n                                        ng-model="vm.userType" value="gpsUser">GPS-User</label>\r\n                                <label class="radio-inline"><input type="radio" name="userType" ng-model="vm.userType"\r\n                                        value="mobileUser">Mobile-User</label>\r\n                            </div>\r\n                        </div> --><!-- user attendance type --><!-- user attendance Report --><div class="form-group" ng-if="vm.userType == \'mobileUser\'"><label class="col-sm-4 control-label">User-Attendance Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.userType == \'mobileUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><div class="col-md-6"><!-- Header --><div class="summary-header">Present Day Summary</div><div class="table-responsive summary-table"><table class="table table-bordered text-center"><thead><tr><th>Patrollers</th><th>FRT</th><th>FE</th><th>NE</th><th>OA</th><th>BA</th><th>All Users</th></tr></thead><tbody><tr><td><strong>{{vm.summary.checkInPATCount}}</strong> <span class="text-muted">/ {{vm.summary.ROLE_PATROLLER}}</span></td><td><strong>{{vm.summary.checkInFRTCount}}</strong> <span class="text-muted">/ {{vm.summary.ROLE_FRT}}</span></td><td><strong>{{vm.summary.checkInFECount}}</strong> <span class="text-muted">/ {{vm.summary.ROLE_FE}}</span></td><td><strong>{{vm.summary.checkInNECount}}</strong> <span class="text-muted">/ {{vm.summary.ROLE_NETWORK_ENGINEER}}</span></td><td><strong>{{vm.summary.checkInOACount}}</strong> <span class="text-muted">/ {{vm.summary.ROLE_OA}}</span></td><td><strong>{{vm.summary.checkInBACount}}</strong> <span class="text-muted">/ {{vm.summary.ROLE_BA}}</span></td><td class="highlight"><strong>{{vm.summary.totalCheckINUserCount}}</strong> <span class="text-muted">/ {{vm.summary.allUserCount}}</span></td></tr></tbody></table></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="attendanceDate"><span>Date </span><span class="fa fa-sort"></span></th><th jh-sort-by="businessArea"><span>Business Area Name</span><span class="fa fa-sort"></span></th><th jh-sort-by="districtName"><span>District Name</span><span class="fa fa-sort"></span></th><th jh-sort-by="blockName"><span>Block Name</span><span class="fa fa-sort"></span></th><th jh-sort-by="userName"><span>UID Name</span><span class="fa fa-sort"></span></th><th jh-sort-by="firstName"><span>UserName </span><span class="fa fa-sort"></span></th><th jh-sort-by="phone"><span>Phone No</span><span class="fa fa-sort"></span></th><th jh-sort-by="userRoles"><span>Role</span><span class="fa fa-sort"></span></th><th jh-sort-by="reportsTo"><span>Reports To</span><span class="fa fa-sort"></span></th><th jh-sort-by="checkInTime"><span>Check-In Time </span><span class="fa fa-sort"></span></th><!-- <th><span>Check-In Location</span> </th> --><th jh-sort-by="checkInGeofenceStatus"><span>Check-In Geofence Status</span> <span class="fa fa-sort"></span></th><!-- <th>Check-In Meter Reading</th> --><!-- <th><span>Check-In Address</span> </th> --><th jh-sort-by="geofenceEnterdTime"><span>Geofence Entered Time</span> <span class="fa fa-sort"></span></th><th jh-sort-by="checkOutTime"><span>Check-Out Time </span><span class="fa fa-sort"></span></th><!--  <th><span>Check-Out Location</span> </th> --><th jh-sort-by="checkOutGeofenceStatus"><span>Check-Out Geofence Status</span><span class="fa fa-sort"></span></th><!-- <th>Check-Out Meter Reading</th> --><th jh-sort-by="vendorName"><span>Vendor </span><span class="fa fa-sort"></span></th><!-- <th><span>Check-Out Address</span> </th> --><!-- <th><span>Incident Created</span></th>\r\n                                    <th><span>Incident Assigned</span></th>\r\n                                    <th><span>Incident Resolved</span></th> --><th jh-sort-by="distanceIn"><span>Distance Within Geofence</span><span class="fa fa-sort"></span></th><th jh-sort-by="distanceOut"><span>Distance Out Of Geofence</span><span class="fa fa-sort"></span></th><th jh-sort-by="totalDistance"><span>Total Distance</span><span class="fa fa-sort"></span></th><!--  <th jh-sort-by="appName"><span>App Name</span><span class="fa fa-sort"></span></th> --><th jh-sort-by="appName"><span>App Version</span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td style="white-space: nowrap;overflow: hidden;">{{record.attendanceDate}}</td><td>{{record.businessArea}}</td><td>{{record.districtName}}</td><td>{{record.blockName}}</td><td>{{record.userName}}</td><td>{{record.firstName}} {{record.lastName}}</td><td>{{record.phone}}</td><td>{{record.userRoles}}</td><td>{{record.reportsTo}}</td><td ng-if="record.checkInTime>0">{{record.checkInTime | date:\'medium\'}}</td><td ng-if="record.checkInTime==0">NA</td><!--  <td>{{record.checkInLocation}}</td> --><td>{{record.checkInGeofenceStatus}}</td><td ng-if="record.geofenceEnterdTime>0">{{record.geofenceEnterdTime |date:\'medium\'}}</td><td ng-if="record.geofenceEnterdTime==0">NA</td><!-- <td>{{record.checkInMeterReading}}</td> --><td ng-if="record.checkOutTime>0 && record.checkOutTime>record.checkInTime">{{record.checkOutTime | date:\'medium\'}}</td><td ng-if="record.checkOutTime==0 || record.checkOutTime<record.checkInTime">NA</td><!--  <td>{{record.checkOutLocation}}</td> --><td>{{record.checkOutGeofenceStatus}}</td><!-- <td>{{record.checkOutMeterReading}}</td> --><td>{{record.vendorName}}</td><!-- <td><a\r\n                                            ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.createdCaseCount}}</a>\r\n                                    </td>\r\n                                    <td><a\r\n                                            ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assignedCaseCount}}</a>\r\n                                    </td>\r\n                                    <td><a\r\n                                            ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolvedCaseCount}}</a>\r\n                                    </td> --><td>{{record.distanceIn}}</td><td>{{record.distanceOut}}</td><td>{{record.totalDistance}}</td><!--  <td>{{record.appName}}</td> --><td>{{record.appVersion}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/noc-alerts-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate=" ">NOC Alerts Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadIncidentsAlarmQueueReport()">Download CSV <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10 table-scroll"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Id</span></th><th><span>Ticket Id</span></th><th><span>Title</span></th><th><span>Description</span></th><th><span>Alarm Category</span></th><th><span>Alarm Type</span></th><th><span>Alarm Date</span></th><th><span>Created Date</span></th><th><span>Detected Date</span></th><th><span>Latitude</span></th><th><span>Longitude</span></th><th><span>GPS Accuracy</span></th><th><span>Asset Type</span></th><th><span>Asset Identifier</span></th><th><span>Asset Lat</span></th><th><span>Asset Lng</span></th><th><span>Asset Status</span></th><th><span>Process Status</span></th><th><span>Process Message</span></th><th><span>Tenant Id</span></th><th><span>Queued By User</span></th><th><span>Ticket Status</span></th><th><span>NMS Name</span></th><th><span>NMS Version</span></th><th><span>PIC Id</span></th><th><span>PON Id</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="vm.reportRecords.length > 0"><td>{{record.id}}</td><td>{{record.ticketId}}</td><td>{{record.title}}</td><td>{{record.description}}</td><td>{{record.alarmCategory}}</td><td>{{record.alarmType}}</td><td>{{record.alarmDate | date:\'medium\'}}</td><td>{{record.createdDate | date:\'medium\'}}</td><td>{{record.detectedDate | date:\'medium\'}}</td><td>{{record.lat}}</td><td>{{record.lng}}</td><td>{{record.gpsAccuracy}}</td><td>{{record.assetTypeName}}</td><td>{{record.assetUniqueIdentifier}}</td><td>{{record.assetLat}}</td><td>{{record.assetLng}}</td><td>{{record.assetStatus}}</td><td>{{record.processStatus}}</td><td>{{record.processMessage}}</td><td>{{record.tenantId}}</td><td>{{record.queuedByUserId}}</td><td>{{record.ticketStatus}}</td><td>{{record.nmsName}}</td><td>{{record.nmsVersion}}</td><td>{{record.picId}}</td><td>{{record.ponId}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="global.menu.generic-report">Generic Reports</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label" translate="report.report">Report</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="report" class="report" ng-model="vm.reportType" value="agent" required ng-click="vm.reportTypeChange()"><span>User-Agent Report</span></label> <label class="radio-inline"><input type="radio" name="report" class="report" ng-model="vm.reportType" value="geofence" ng-click="vm.reportTypeChange()">Geofence Report</label></div></div><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group" ng-if="vm.reportType == \'agent\'"><label class="col-sm-3 control-label">User-Agent Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'agent\' && vm.userAgent==\'username\'"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><!-- useragent Report --><!-- Geofence Report --><div class="form-group" ng-if="vm.reportType == \'geofence\'"><label class="col-sm-3 control-label">Geofence Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="geofence" required ng-model="vm.geofence" value="geofence" ng-click="vm.select2()">Geofence Name</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.geofence" value="all">All Geofence</label></div></div><div class="form-group" ng-if="vm.reportType == \'geofence\' && vm.geofence == \'geofence\'"><label class="col-sm-3 control-label"><span>Select Geofence</span></label><div class="col-sm-7"><select class="form-control select2" name="search" required id="geofences" ng-model="vm.id" ng-options="item.id as item.name for item in vm.geofences"><option value="">Select Geofence</option></select></div></div><!--Geofence Report --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div></div></form></div></div></div><div class="row" ng-if="reporthide"><div class="col-md-10 col-md-offset-1"><!-- Map box --><div class="box box-solid"><div class="box-header"><i class="fa fa-server"></i><h3 class="box-title" translate="global.menu.generic-report">Generic Reports</h3></div><div class="box-body"><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th ng-if="vm.reportType==\'agent\'"><span>Login</span></th><th ng-if="vm.reportType==\'geofence\'"><span>Name</span></th><!-- <th ng-if="vm.reportType==\'agent\'"><span>From Hour</span></th>\r\n\t\t\t\t\t\t\t\t\t<th ng-if="vm.reportType==\'agent\'"><span>To Hour</span> </th> --><th><span>Cases</span></th><th><span>Services</span></th><th ng-if="vm.reportType==\'agent\'">Distance Covered</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td ng-if="vm.reportType==\'agent\'">{{record.login}}</td><td ng-if="vm.reportType==\'geofence\'">{{record.name}}</td><!-- \t<td ng-if="vm.reportType==\'agent\'">{{getLocalhour(record.fromTime)}}</td>\r\n\t\t\t\t\t\t\t\t\t<td ng-if="vm.reportType==\'agent\'">{{getLocalhour(record.toTime)}}</td> --><td>{{record.cases}}</td><td>{{record.services}}</td><td ng-if="vm.reportType==\'agent\'">{{record.distance | number:2}} KM</td><td><a href="" ng-click="vm.detailedReport(record.id)"><i class="fa fa-eye"></i></a></td></tr></tbody></table></div></div></div></div></div><div class="row"><div id="report" class="col-md-10 col-md-offset-1" style="display: none;"><!-- box content--><div class="box box-solid"><div class="box-header box-info"><button type="button" class="close" ng-click="close()">&times;</button><h4 class="box-title text-left"><img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'Fiberify\'"> <img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'Fiberify\'"> <img ng-src="content/images/bharatnet_logo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'BSNL\'"></h4></div><button class="btn btn-primary center-block" ng-click="getPdf()">Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="box-body" ng-if="vm.reportType==\'geofence\'" id="reportpdf"><h4 class="text-center mt-5">Geofence Report for <b>{{vm.detailedReportCounts.name}}</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Services --><div class="box-header"><h3 class="box-title">Services</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><div class="box-header"><h3 class="box-title">Geofence</h3></div><div class="box-body"><div class="row"><div class="col-md-12"><div id="map_canvas" style="height:300px; width:100%;"></div></div></div></div></div></div><div class="box-body" ng-if="vm.reportType==\'agent\'" id="reportpdf"><!-- <div class="box-body" ng-if="vm.reportType==\'agent\'"> --><h4 class="text-center mt-5">Agent Report for <b>{{vm.detailedReportCounts.name}} ({{vm.detailedReportCounts.login}})</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Created by Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Assigned to Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Services --><div class="box-header"><h3 class="box-title">Services</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><div class="box-header"><h3 class="box-title">Distanc Covered</h3>{{vm.detailedReportCounts.distance | number:2}} KM</div><!-- <div class="box-body">\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">\r\n\t\t\t\t\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100%;"></div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div></div>');
$templateCache.put('app/report/site-status-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-line-chart"></i> <span>Site Status Reports</span></h3></div><form class="form-horizontal" name="batteryreportForm"><div class="box-body border" style="height: 120px"><div class="form-group" style="margin-top: 30px;"><label class="col-sm-2 control-label"><span>Select Vendor</span></label><div class="col-sm-2"><select id="userlist" class="select2 form-control" style="width: 220px; height: 40px"><option value="">---All Vendors---</option><option ng-repeat="item in vm.userlist" value="{{item.id}}">{{item.firstName}} {{item.lastName}}</option></select></div></div></div><div class="col-sm-7" style="margin-top: 20px"><div class="box box-solid"><div class="box-body"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Asset Name</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>On Air</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Under Deployment</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Planned</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.multiassets track by asset.name"><td style="text-align:center;vertical-align:middle">{{asset.name}}</td><td style="text-align:center;vertical-align:middle">{{asset.onair}}</td><td style="text-align:center;vertical-align:middle">{{asset.deployed}}</td><td style="text-align:center;vertical-align:middle">{{asset.planned}}</td></tr></tbody></table></div></div></div></div><div class="col-sm-5" style="margin-top: 20px"><div style="text-align: center"><div class="box box-solid"><div class="box-body chart-responsive" style="text-align: center"><h3>Site Type On Air Distribution</h3><div class="chart" id="vendor-chart" style="height: 285px; position:;"></div></div></div></div></div><div class="row" ng-if="reporthide"><div class="col-sm-7" style="margin-top: 20px"><div class="box box-solid"><div class="box-body"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Asset Name</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>On Air</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Under Deployment</span></th><th style="text-align:center;vertical-align:middle;font-size: 14px"><span>Planned</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.multiassets track by asset.name"><td style="text-align:center;vertical-align:middle">{{asset.name}}</td><td style="text-align:center;vertical-align:middle">{{asset.onair}}</td><td style="text-align:center;vertical-align:middle">{{asset.deployed}}</td><td style="text-align:center;vertical-align:middle">{{asset.planned}}</td></tr></tbody></table></div></div></div></div><div class="col-sm-5" style="margin-top: 20px"><div style="text-align: center"><div class="box box-solid"><div class="box-body chart-responsive" style="text-align: center"><h3>Site Type On Air Distribution</h3><div class="chart" id="vendor-chart1" style="height: 285px; position:;"></div></div></div></div></div></div></form></div></div></div></div>');
$templateCache.put('app/report/splicing-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> <span translate="">Splicing Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><div class="col-sm-12"><label class="col-sm-3 control-label"><span>Select Incident Type</span></label><div class="col-sm-4"><select class="select2 form-control" ng-model="vm.selectedCaseTypeId" ng-change="onCaseTypeChange();" required><option value="">Select Incident Type</option><option ng-repeat="caseType in vm.caseTypes" value="{{caseType.id}}">{{caseType.name}}</option></select></div></div></div><div class="form-group"><div class="col-sm-12" ng-show="vm.selectedCaseTypeId!=null"><label class="col-sm-3 control-label"><span>Select Incident</span></label><div class="col-sm-4"><select class="select2 form-control" name="case" ng-model="vm.selectedCaseId" required><option value="">Select Incident</option><option ng-repeat="case in vm.cases" value="{{case.id}}">{{case.name}}</option></select></div></div></div></div><div class="box-footer"><label class="col-sm-3 control-label"><span></span></label><div class="col-sm-2" ng-if="vm.selectedCaseId!=null"><button class="btn btn-primary" ng-disabled="reportForm.$invalid" ng-click="vm.downloadSplicingReport()">Download PDF Report <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/survey-report.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> &nbsp;<span> Survey Report</span></h3></div><form class="form-horizontal" name="entityForm"><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select City</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedMasterGeofenceId" ng-change="vm.onMasterChange();" required><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-show="vm.selectedMasterGeofenceId"><label class="col-md-3 control-label"><span>Select Geofence</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedGeofenceId" required><option value="">Select Geofence</option><option ng-repeat="item in vm.geofenceMini" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-if="vm.selectedGeofenceId && vm.statusType.length > 0"><label class="col-md-3 control-label"><span>Select Attributes</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><div isteven-multi-select input-model="vm.statusType" output-model="vm.selectedstatusType" button-label="value" item-label="value" tick-property="selected" group-property="msGroup" translation="vm.statuslabel" output-properties="value id" on-select-done="vm.savePriorityStatusFilter()" max-labels="2" max-height="280px" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedstatusType" name="vm.searchMini" style="display:none" required> <span id="noData" ng-if="vm.selectedPriorityList.length == 0 || vm.selectedStatusList.length == 0">* Select atleast one from each group.</span></div></div><div class="row" style="margin: 20px;"><button class="btn btn-primary btn-sm pull-right" ng-click="vm.downloadSurveyReport()" style="margin: 20px;" ng-disabled="entityForm.$invalid">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button ng-click="vm.surveyReport()" class="btn btn-primary btn-sm pull-right" ng-disabled="entityForm.$invalid">Submit</button></div></div></form><div class="col-md-12 table-responsive mt-10" ng-show="vm.surveyReportList.length > 0"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Total Length : {{(vm.surveyTotalLength).toFixed(2)}} Km</th></tr><tr><th>Asset Name</th><th>Asset Length (Km)</th><th ng-repeat="(key, value)  in vm.surveyReportList[0].attributeList" ng-if="key == \'terrain type\' || key == \'authority\' || key == \'activity type\' || key == \'existing infra\' ">{{key}}</th></tr></thead><tbody><tr ng-repeat="list in vm.surveyReportList | filter:search"><td>{{list.asset_name}}</td><td>{{(list.asset_length).toFixed(2)}}</td><td ng-repeat="(key, value) in list.attributeList" ng-if="key == \'terrain type\' || key == \'authority\' || key == \'activity type\' || key == \'existing infra\'">{{value}}</td></tr><tr><td colspan="10" ng-show="vm.surveyReportList == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/report/task-log-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> <span translate=" ">Task Log Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Download By</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" ng-model="vm.reportType" value="daily" ng-click="vm.selectedReport()">Daily Report</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.reportType" value="measurement" ng-click="vm.selectedReport()">Measurement Report</label></div></div><div class="form-group" ng-show="vm.reportType!=null"><label class="col-md-3 control-label"><span>Select Project</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedProjectId" ng-change="onProjectChange();" required><option value="">--- Select Project ---</option><option ng-repeat="item in vm.projects" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-show="vm.selectedProjectId>0 && (vm.reportType==\'daily\' || vm.reportType==\'measurement\')"><label class="col-md-3 control-label"><span>Select Routes</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedRouteId" ng-change="onRouteChange();" required><option value="">--- Select Route ---</option><option ng-repeat="item in vm.routes" value="{{item.id}}">{{item.name}}</option></select></div></div><div class="form-group" ng-show="vm.selectedRouteId>0 && (vm.reportType==\'measurement\')"><label class="col-md-3 control-label"><span>Select Section</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedSectionId" ng-change="onSectionChange();" required><option value="">--- Select Section ---</option><option ng-repeat="item in vm.sections" value="{{item.id}}">{{item.name}}</option></select></div></div><!-- <div class="form-group" ng-if="vm.selectedSectionId>0">\r\n                            <label class="col-md-3 control-label">\r\n                                <span>Select Task</span><sup><span class="required-icon"><i\r\n                                            class="fa fa-asterisk text-danger"></i></span>\r\n                            </label>\r\n                            <div class="col-md-3">\r\n                                <select class="form-control select2" ng-model="vm.selectedTaskId"\r\n                                    ng-change="onTaskChange();" required>\r\n                                    <option value="">\r\n                                        --- Select Task ---\r\n                                    </option>\r\n                                    <option ng-repeat="item in vm.tasks" value="{{item.id}}">\r\n                                        {{item.name}}\r\n                                    </option>\r\n                                </select>\r\n                            </div>\r\n                        </div> --><div class="form-group" ng-if="vm.selectedRouteId>0"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-1 control-label">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- <div class="form-group" ng-if="vm.userAgent == \'username\'">\r\n                            <label class="col-sm-2 control-label">\r\n                                <span></span>\r\n                            </label>\r\n                            <div class="col-sm-6">\r\n                                <select class="select2 form-control" name="search" required ng-model="vm.userid"\r\n                                    ng-options="item.id as item.login for item in vm.users">\r\n                                    <option value="">Select User</option>\r\n                                    <option ng-repeat="user in vm.users" value="user.id">\r\n                                        {{user.login}}\r\n                                    </option>\r\n                                </select>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class="form-group" ng-if="vm.userAgent == \'geofence\'">\r\n                            <label class="col-sm-2 control-label">\r\n                                <span></span>\r\n                            </label>\r\n                            <div class="col-sm-6">\r\n                                <select class="select2 form-control" name="search" required ng-model="vm.geofenceid"\r\n                                    ng-options="item.id as item.name for item in vm.userGeofences">\r\n                                    <option value="">Select Geofence</option>\r\n                                    <option ng-repeat="geofence in vm.userGeofences" value="geofence.id">\r\n                                        {{user.name}}\r\n                                    </option>\r\n                                </select>\r\n                            </div>\r\n                        </div> --></div><div class="box-footer"><div class="col-sm-3" ng-if="vm.reportType!=null"><!-- <div class="col-sm-3" ng-if="vm.reportType!=null"> --> <button class="btn btn-primary pull-right" style="margin: 10px;" ng-if=\'vm.selectedRouteId>0 && vm.reportType == "daily"\' ng-click="vm.showTaskLogReport()">Submit</button> <button class="btn btn-primary pull-right" style="margin: 10px;" ng-if=\'vm.selectedSectionId>0 && vm.reportType == "measurement"\' ng-click="vm.showTaskLogReport()">Submit</button> <button class="btn btn-primary pull-right" style="margin: 10px;" ng-if=\'vm.selectedRouteId>0 && vm.reportType == "daily"\' ng-click="vm.downloadTaskLogReport()">Download</button> <button class="btn btn-primary pull-right" style="margin: 10px;" ng-if=\'vm.selectedSectionId>0 && vm.reportType == "measurement"\' ng-click="vm.downloadTaskLogReport()">Download</button><!-- <button class="btn btn-primary pull-right" ng-disabled="reportForm.$invalid"\r\n                                ng-click="vm.downloadTaskLogReport()">\r\n                                Download</span>\r\n                            </button> --></div><div class="col-sm-12"><button class="btn btn-primary center-block" ng-click="getPdf()" ng-if="vm.isReportGenerated==true" style="margin: 10px;">Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div id="generatedHtmlContainer" style="width: calc(100% - 40px);overflow-x: auto;overflow-y: hidden;"></div></div></div></form></div></div></div></div>');
$templateCache.put('app/report/team-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate="trakeyeApp.teamreport.title">Incident TAT Report</span></h3></div><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-3"><select class="select2 form-control" name="search" ng-model="vm.reportUser"><option value="">Select UserName</option><option ng-repeat="item in vm.users" title="{{item.login}}" ng-selected="{{item.login == vm.reportUser}}" value="{{item.login}}">{{item.login}}</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="fromDate" required datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label teamReport_toDate">To Date</label><div class="col-sm-2"><div class="input-group"><input type="text" class="form-control" name="toDate" required datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div><div><button ng-if="vm.reportGenerated" class="btn btn-primary center-block" ng-click="download()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div><div class="content" style="overflow: scroll;overflow-x: scroll;overflow-y:hidden"><!-- <button class="btn btn-primary center-block"  ng-click="getPdf()"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="reportpdf"><div class="col-md-6" align="center" data-ng-bind-html="myhtml | trustFilter"></div></div>');
$templateCache.put('app/report/user-agent-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-vcard"></i> <span>User Agent Report</span></h3></div><!-- /.box-header --><!-- form start --><form class="form-horizontal" name="reportForm" ng-submit="report()"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="year" ng-click="vm.selecterange(\'year\')">One Year</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- Custom Field --><!-- useragent Report --><div class="form-group" ng-if="vm.reportType == \'agent\'"><label class="col-sm-3 control-label">User-Agent Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'agent\' && vm.userAgent==\'username\'"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><!-- useragent Report --><!-- Geofence Report --><div class="form-group" ng-if="vm.reportType == \'geofence\'"><label class="col-sm-3 control-label">Geofence Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="geofence" required ng-model="vm.geofence" value="geofence" ng-click="vm.select2()">Geofence Name</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.geofence" value="all">All Geofence</label></div></div><div class="form-group" ng-if="vm.reportType == \'geofence\' && vm.geofence == \'geofence\'"><label class="col-sm-3 control-label"><span>Select Geofence</span></label><div class="col-sm-7"><select class="form-control select2" name="search" required id="geofences" ng-model="vm.id" ng-options="item.id as item.name for item in vm.geofences"><option value="">Select Geofence</option></select></div></div><!--Geofence Report --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadUserAgentReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div><!-- <div class="col-md-12">\r\n\t\t\t<div class="box box-solid">\r\n\t\t\t\t<div class="box-header with-border">\r\n\t\t\t\t\t<h3 class="box-title">Uesr - Agent Reports</h3>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="box-body chart-responsive">\r\n\t\t\t\t\t<div class="chart" id="line-chart" style="height: 500px; position: relative;"></div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div> --></div><div class="row" ng-if="reporthide"><div class="col-md-10 col-md-offset-1"><!-- Map box --><div class="box box-solid"><div class="box-body"><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="login" ng-if="vm.reportType==\'agent\'"><span>Login </span><span class="fa fa-sort"></span></th><th jh-sort-by="created_cases"><span>Created Cases </span><span class="fa fa-sort"></span></th><th jh-sort-by="assigned_cases"><span>Assigned Cases </span><span class="fa fa-sort"></span></th><th jh-sort-by="resolved_cases"><span>Resolved Cases </span><span class="fa fa-sort"></span></th><th jh-sort-by="distance"><span>Total Distance </span><span class="fa fa-sort"></span></th><th jh-sort-by="distance_in" ng-if="vm.reportType==\'agent\'"><span>Distance Within Geofence </span><span class="fa fa-sort"></span></th><th jh-sort-by="distance_out" ng-if="vm.reportType==\'agent\'"><span>Distance Outside Geofence </span><span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td ng-if="vm.reportType==\'agent\'">{{record.login}}</td><td ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.created_cases}}</a></td><td ng-if="has_ROLE_VENDOR">{{record.created_cases}}</td><td ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assigned_cases}}</a></td><td ng-if="has_ROLE_VENDOR">{{record.assigned_cases}}</td><td ng-hide="has_ROLE_VENDOR"><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolved_cases}}</a></td><td ng-if="has_ROLE_VENDOR">{{record.resolved_cases}}</td><td>{{record.distance | number:2}} KM</td><td ng-if="vm.reportType==\'agent\'">{{record.distance_in | number:2}} KM</td><td ng-if="vm.reportType==\'agent\'">{{record.distance_out | number:2}} KM</td><td><a href="" ng-click="vm.detailedReport(record.id)"><i class="fa fa-eye"></i></a></td></tr></tbody></table></div></div></div></div></div><div class="row"><div id="report" class="col-md-10 col-md-offset-1" style="display: none;"><!-- box content--><div class="box box-solid"><div class="box-header box-info"><button type="button" class="close" ng-click="close()">&times;</button><h4 class="box-title text-left"><img ng-src="content/images/bharatnet_logo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'BSNL\'"> <img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'Fiberify\'"> <img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'Fiberify\'"></h4></div><button class="btn btn-primary center-block" ng-click="getPdf()">Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="box-body" ng-if="vm.reportType==\'geofence\'" id="reportpdf"><h4 class="text-center mt-5">Geofence Report for <b>{{vm.detailedReportCounts.name}}</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowCancelled}}</p></div></div></div></div></div><!-- <div class="box box-solid">\r\n                         Services \r\n                        <div class="box-header">\r\n                            <h3 class="box-title">Services</h3>\r\n                        </div>\r\n                        <div class="box-body">\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-danger">Critical</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-success">High</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-primary">Medium</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n\r\n                            <div class="col-sm-3">\r\n                                <h4 class="report-head text-warning">Low</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div> --><div class="box box-solid"><div class="box-header"><h3 class="box-title">Geofence</h3></div><div class="box-body"><div class="row"><div class="col-md-12"><div id="map_canvas" style="height:300px; width:100%;"></div></div></div></div></div></div><div class="box-body" ng-if="vm.reportType==\'agent\'" id="reportpdf"><!-- <div class="box-body" ng-if="vm.reportType==\'agent\'"> --><h4 class="text-center mt-5">Agent Report for <b>{{vm.detailedReportCounts.name}} ({{vm.detailedReportCounts.login}})</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Created by Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Cases Assigned to Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowCancelled}}</p></div></div></div></div></div><!-- Services --><!-- <div class="box box-solid">\r\n                        \r\n                        <div class="box-header">\r\n                            <h3 class="box-title">Services</h3>\r\n                        </div>\r\n                        <div class="box-body">\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-danger">Critical</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-success">High</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="col-sm-3 report-data">\r\n                                <h4 class="report-head text-primary">Medium</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n\r\n                            <div class="col-sm-3">\r\n                                <h4 class="report-head text-warning">Low</h4>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Inprogress</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Pending</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Closed</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="row">\r\n                                    <div class="col-sm-6 col-xs-6">\r\n                                        <p class="report-info">Cancelled</p>\r\n                                    </div>\r\n                                    <div class="col-sm-2 col-xs-2">\r\n                                        <p class="report-info">:</p>\r\n                                    </div>\r\n                                    <div class="col-sm-4 col-xs-4">\r\n                                        <p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div> --><div class="box box-solid"><div class="box-header"><h3 class="box-title">Distanc IN</h3>{{vm.detailedReportCounts.distance_in | number:2}} KM<h3 class="box-title">Distanc OUT</h3>{{vm.detailedReportCounts.distance_out | number:2}} KM</div><!-- <div class="box-body">\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">\r\n\t\t\t\t\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100%;"></div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div></div>');
$templateCache.put('app/report/user-attendance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span translate=" ">User Attendance Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-4 control-label">User-Attendance Type</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="userType" required ng-model="vm.userType" value="gpsUser">GPS-User</label> <label class="radio-inline"><input type="radio" name="userType" ng-model="vm.userType" value="mobileUser">Mobile-User</label></div></div><!-- user attendance type --><!-- user attendance Report --><div class="form-group" ng-if="vm.reportType == \'gpsUser\'"><label class="col-sm-4 control-label">User-Attendance Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.reportType == \'gpsUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span>Select User</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="gpsUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Name</span></th><th><span>Start Time</span></th><th><span>Start LatLng</span></th><th><span>End Time</span></th><th><span>End LatLng</span></th><th>Distance Within Geofence</th><th>Distance Outside Geofence</th><th>Total Distance</th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.totalDistance>0"><td>{{record.userName}}</td><td>{{record.startTime | date:\'medium\'}}</td><td>{{record.startLatLng}}</td><td>{{record.endTime | date:\'medium\'}}</td><td>{{record.endLatLng}}</td><td>{{record.distanceIn | number:2}} KM</td><td>{{record.distanceOut | number:2}} KM</td><td>{{record.totalDistance | number:2}} KM</td></tr></tbody></table></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="mobileUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Name</span></th><th><span>Check-In Time</span></th><th><span>Check-In Location</span></th><th><span>Check-In Address</span></th><th><span>Check-Out Time</span></th><th><span>Check-Out Location</span></th><th><span>Check-Out Address</span></th><th><span>Incident Created</span></th><th><span>Incident Assigned</span></th><th><span>Incident Resolved</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.checkInTime>0||record.createdCaseCount>0||record.assignedCaseCount>0||record.resolvedCaseCount>0"><td>{{record.userName}}</td><td ng-if="record.checkInTime>0">{{record.checkInTime | date:\'medium\'}}</td><td>{{record.checkInLocation}}</td><td title="{{record.checkInAddress}}">{{record.checkInAddress | limitTo: 20 }}{{record.checkInAddress.length > 20 ? \'...\' : \'\'}}</td><td ng-if="record.checkInTime==0">NA</td><td ng-if="record.checkOutTime>0">{{record.checkOutTime | date:\'medium\'}}</td><td>{{record.checkOutLocation}}</td><td title="{{record.checkOutAddress}}">{{record.checkOutAddress | limitTo: 20 }}{{record.checkOutAddress.length > 20 ? \'...\' : \'\'}}</td><td ng-if="record.checkOutTime==0">NA</td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'createdCaseCount\'})">{{record.createdCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'assignedCaseCount\'})">{{record.assignedCaseCount}}</a></td><td><a ui-sref="tr-case.attendance({login:record.id, fromTime:vm.fromTime, toTime:vm.toTime, caseStatus:\'resolvedCaseCount\'})">{{record.resolvedCaseCount}}</a></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/user-geofence-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-download"></i> <span translate=" ">User Geofence Dump</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-2 control-label">Download By</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User</label> <label class="radio-inline"><input type="radio" name="geofence" ng-model="vm.userAgent" value="geofence" ng-click="vm.select2()">Geofence</label></div></div><div class="form-group" ng-if="vm.userAgent == \'username\'"><label class="col-sm-2 control-label"><span></span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.userid" ng-options="item.id as item.login for item in vm.users"><option value="">Select User</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div><div class="form-group" ng-if="vm.userAgent == \'geofence\'"><label class="col-sm-2 control-label"><span></span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.geofenceid" ng-options="item.id as item.name for item in vm.userGeofences"><option value="">Select Geofence</option><option ng-repeat="geofence in vm.userGeofences" value="geofence.id">{{user.name}}</option></select></div></div></div><div class="box-footer"><div class="col-sm-3"><button class="btn btn-primary pull-right" ng-disabled="reportForm.$invalid" ng-click="vm.downloadUserGeofenceReport()">Download</button></div></div></form></div></div></div></div>');
$templateCache.put('app/report/user-login-history-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-calendar-plus-o"></i> <span translate=" ">User Last Log Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Select User</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">User-Agent Name</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Users</label></div></div><div class="form-group" ng-if="vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span></span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadUserLastLoginReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th>SL</th><th jh-sort-by="userName"><span>User Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="firstName"><span>Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="firstName"><span>District Name</span><span class="fa fa-sort"></span></th><th jh-sort-by="firstName"><span>Block Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="dateTime"><span>Login Date </span><span class="fa fa-sort"></span></th><th jh-sort-by="dateTime"><span>Login Time </span><span class="fa fa-sort"></span></th><th jh-sort-by="gpsImei"><span>GPS IMEI </span><span class="fa fa-sort"></span></th><th jh-sort-by="imei"><span>IMEI </span><span class="fa fa-sort"></span></th><th jh-sort-by="phone"><span>Phone </span><span class="fa fa-sort"></span></th><th jh-sort-by="reportMethod"><span>Report Method </span><span class="fa fa-sort"></span></th><th jh-sort-by="lastlog"><span>Last LatLng </span><span class="fa fa-sort"></span></th><th jh-sort-by="lastDateTime"><span>Last Date</span><span class="fa fa-sort"></span></th><th jh-sort-by="lastDateTime"><span>Last Time</span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search | startFrom:(vm.currentPage - 1) * vm.itemsPerPage | limitTo:vm.itemsPerPage track by $index"><td>{{$index+1}}</td><td>{{record.userLogin}}</td><td>{{record.userFirstName}} {{record.userLastName}}</td><td>{{record.districtName}}</td><td>{{record.block}}</td><td>{{record.dateTime | date:\'dd-MM-yyyy\'}}</td><td>{{record.dateTime | date:\'hh:mm:ss a\'}}</td><td>{{record.gpsimei}}</td><td>{{record.imei}}</td><td>{{record.phone}}</td><td>{{record.appVersion}}</td><td>{{record.userLatitude}},{{record.userLongitude}}</td><td>{{record.lastDateTime | date:\'dd-MM-yyyy\'}}</td><td>{{record.lastDateTime | date:\'hh:mm:ss a\'}}</td></tr></tbody></table><div class="row" ng-if="vm.totalItems > 10"><div class="col-md-12 text-center"><p>Total Items:-{{vm.totalItems}}</p><uib-pagination total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" max-size="5" boundary-links="true" first-text="\xAB" last-text="\xBB"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/report/user-reporting-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-calendar-plus-o"></i> <span translate=" ">User Reporting Status</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-3 control-label">Select Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="Date" required datetime-picker="mediumDate" enable-time="false" ng-model="vm.currentDate" ng-change="vm.calculateDate()" is-open="vm.datePickerOpenStatus.Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label"><span>Select User</span></label><div class="col-sm-4"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadAttendenceReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords.length > 0" style="margin: 20px"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th><span>Time</span></th><th><span>Status</span></th><th><span>Report Method</span></th><th><span>LatLng</span></th><th><span>Shift</span></th><th><span>Image</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td><b>{{record.dateTime | date:\'mediumTime\'}}</b></td><td><b>{{record.reportType}}</b></td><td><b>{{record.reportMethod}}</b></td><td>{{record.userLatitude}} , {{record.userLongitude}}</td><td>{{record.userShift}}</td><td><img data-toggle="modal" data-target="#myModalMap" ng-show="record.selfyImage != null" ng-src="data:image/jpeg;base64,{{record.selfyImage}}" ng-click="getImage(record.selfyImage)" style="width: 50px; height: 50px"></td></tr></tbody></table></div></div></div></div></div></div><div class="modal fade" id="myModalMap" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div id="imgZoom" style="background: url(\'data:image/jpeg;base64,{{vm.img}}\');background-size: cover"></div></div></div>');
$templateCache.put('app/report/user-stats-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-bar-chart"></i> <span translate=" ">User Statistics Report</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\'"><label class="col-sm-4 control-label">Select User</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()"> By user name</label><!-- <label class="radio-inline"><input type="radio" name="user"\r\n                                        ng-model="vm.userAgent" value="all">All Users </label> --></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span></span><!-- <label class="col-sm-4 control-label"> <span>Select User</span> --></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.login for item in vm.users"><option value="">Select UserName</option><option ng-repeat="user in vm.users" value="user.id">{{user.login}}</option></select></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadUserStatsReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="gpsUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="login"><span>Name </span><span class="fa fa-sort"></span></th><th jh-sort-by="geofenceName"><span>Geofence </span><span class="fa fa-sort"></span></th><th jh-sort-by="totalNumAssets"><span>Total Assets </span><span class="fa fa-sort"></span></th><th jh-sort-by="travelledNumAssets"><span>Assets Covered </span><span class="fa fa-sort"></span></th><th jh-sort-by="percentageDistance"><span>Distance Covered (%) </span><span class="fa fa-sort"></span></th><th><span>Distance Not Covered (%)</span></th><th jh-sort-by="timeSpent"><span>Time Spent ( HH:MM:SS ) </span><span class="fa fa-sort"></span></th><th jh-sort-by="averageSpeed"><span>Average Speed ( KMPH ) </span><span class="fa fa-sort"></span></th><th><span>Checked-IN Time</span></th><th><span>Checked-OUT Time</span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search"><td>{{record.login}}</td><td>{{record.geofenceName}}</td><td>{{record.totalNumAssets}}</td><td>{{record.travelledNumAssets}}</td><td>{{record.percentageDistance}} %</td><td>{{100-record.percentageDistance}} %</td><td>{{record.timeSpent}}</td><td>{{record.averageSpeed | number:2}}</td><td>{{record.userCheckInDateTime | date:\'medium\'}}</td><td>{{record.userCheckOutDateTime | date:\'medium\'}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/report/vehicle-distance-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-car"></i> <span translate=" ">Vehicle Distance Travelled</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-4 control-label">Date Range</label><div class="col-sm-8"><label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.selecterange(\'day\')">Present Day</label> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="week" ng-click="vm.selecterange(\'week\')">One Week</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="month" ng-click="vm.selecterange(\'month\')">One Month</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Custom</label></div></div><!-- user attendance type --><div class="form-group" ng-if="vm.dateRange == \'custom\'"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="fromDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.fromDate" ng-change="vm.calculateFromDate()" is-open="vm.datePickerOpenStatus.fromDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="col-sm-2 control-label">To Date</label><div class="col-sm-3"><div class="input-group"><input type="text" class="form-control" name="toDate" required disabled="disabled" datetime-picker="mediumDate" enable-time="false" ng-model="vm.toDate" ng-change="vm.calculateToDate()" is-open="vm.datePickerOpenStatus.toDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\'"><label class="col-sm-4 control-label">Vehicle Distance Report</label><div class="col-sm-6"><label class="radio-inline"><input type="radio" name="user" required ng-model="vm.userAgent" value="username" ng-click="vm.select2()">Vehicle License Plate</label> <label class="radio-inline"><input type="radio" name="user" ng-model="vm.userAgent" value="all">All Vehicles</label></div></div><div class="form-group" ng-if="vm.userType == \'gpsUser\' && vm.userAgent == \'username\'"><label class="col-sm-4 control-label"><span>Select Vehicle</span></label><div class="col-sm-6"><select class="select2 form-control" name="search" required ng-model="vm.id" ng-options="item.id as item.licensePlate for item in vm.vehicles"><option value="">Select Vehicle License Plate</option><option ng-repeat="vehicle in vm.vehicles" value="vehicle.id">{{vehicle.licensePlate}}</option></select></div></div></div><!-- user attendance Report --><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="reportForm.$invalid" translate="upload.submit" ng-click="vm.report()">Submit</button></div><div><button class="btn btn-primary center-block" ng-disabled="reportForm.$invalid" ng-click="vm.downloadVehicleDistanceReport()">Download Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form><div class="row" ng-show="vm.reportRecords" style="margin: 20px;"><div class="col-md-12"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search" ng-model="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-12 table-responsive mt-10" ng-if=\'vm.userType=="gpsUser"\'><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortResponse()"><th jh-sort-by="licensePlate"><span>License Plate </span><span class="fa fa-sort"></span></th><th jh-sort-by="gpsimei"><span>GPS IMEI</span><span class="fa fa-sort"></span></th><th jh-sort-by="startTime"><span>Start Time </span><span class="fa fa-sort"></span></th><th><span>Start LatLng</span></th><th jh-sort-by="endTime"><span>End Time </span><span class="fa fa-sort"></span></th><th><span>End LatLng</span></th><th><span>Description</span></th><th><span>Vendor</span></th><th jh-sort-by="totalDistance"><span>Total Distance </span><span class="fa fa-sort"></span></th></tr></thead><tbody><tr ng-repeat="record in vm.reportRecords | filter:search" ng-if="record.totalDistance>0"><td>{{record.licensePlate}}</td><td>{{record.gpsimei}}</td><td>{{record.startTime | date:\'medium\'}}</td><td>{{record.startLatLng}}</td><td>{{record.endTime | date:\'medium\'}}</td><td>{{record.endLatLng}}</td><td>{{record.description}}</td><td>{{record.vendor}}</td><td>{{record.totalDistance | number:2}} KM</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div class="content"><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ui-sref="login">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div class="content"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title" translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h3></div><form name="form" role="form" class="form-horizontal" novalidate ng-submit="vm.changePassword()" show-validation><div class="box-body"><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="form-group"><label class="col-md-3 control-label" for="password" translate="global.form.newpassword">New password</label><div class="col-md-6"><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div></div><div class="form-group"><label class="col-md-3 control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><div class="col-md-6"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div></div><div class="box-footer"><div class="col-md-3 col-md-offset-3 save-buttons"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-sm" translate="password.form.button">Save</button></div></div></form></div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="container"><div class="row"><nav class="navbar navbar-default" role="navigation"><div class="col-sm-4 mt-20"><div class="row"><div class="col-xs-9 col-sm-12"><img src="content/images/fy-fiberify-logo.png" alt="trakeye" class="img-responsive trakeye_logo" ng-if="vm.appName==\'Fiberify\'"> <img src="content/images/fy-fiberify-logo.png" alt="trakeye" class="img-responsive trakeye_logo" ng-if="vm.appName==\'Fiberify\'"> <img src="content/images/bharatnet_logo.png" alt="trakeye" class="img-responsive trakeye_logo" ng-if="vm.appName==\'BSNL\'"></div><!-- <div class="navbar-header col-xs-3">\r\n\t\t\t\t\t<button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">\r\n\t\t\t\t\t  <span class="sr-only">Toggle navigation</span>\r\n\t\t\t\t\t  <span class="icon-bar"></span>\r\n\t\t\t\t\t  <span class="icon-bar"></span>\r\n\t\t\t\t\t  <span class="icon-bar"></span>\r\n\t\t\t\t\t</button>\r\n\t\t\t\t  </div> --></div><!--row--></div><!--col-sm-4--><div class="col-sm-8 mt-20"><!-- Brand and toggle get grouped for better mobile display --><!-- Collect the nav links, forms, and other content for toggling --> <!-- <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">\r\n\t\t\t<ul class="nav navbar-nav navbar-right">\r\n\t\t\t   <li><a ui-sref="home">Home</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Solutions</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Industries</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Support</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Blog</a></li>\r\n\t\t\t\t\t\t<li><a ui-sref="">Contact Us</a></li>\r\n\t\t\t</ul>\r\n\t\t  </div> --><!-- /.navbar-collapse --></div><!--col-sm-8--></nav></div><!--row--><div class="tryitmain"><div class="row"><div class="col-sm-7"><div class="tryit-content"><h1 class="text-center tryit-head" ng-if="vm.appName==\'Fiberify\'">Welcome to Fiberify</h1><h1 class="text-center tryit-head" ng-if="vm.appName==\'Fiberify\'">Welcome to Fiberify</h1><p class="text-center">The most efficient services management apllication for your organization.</p><p class="text-center">Now control Manage and Monitor your field agents, Field activity and Field assets effectively in real-time.</p><h2 class="text-center tryit-head">Request for a free demo</h2></div></div><!--col-sm-7--><div class="col-sm-5"><div class="col-sm-10"><div class="alert alert-success" ng-show="vm.success" translate="register.messages.success"><strong>Thank you for your interest in Fiberify</strong> One of our team members will contact you shortly.</div><form ng-show="!vm.success" name="form" role="form" ng-submit="vm.register()" novalidate class="tryit-form" autocomplete="off"><!-- show-validation --><div class="form-group"><jhi-alert-error></jhi-alert-error><div><input type="firstname" class="form-control" name="firstname" id="firstName" placeholder="{{\'register.form.firstname.placeholder\' | translate}}" ng-model="vm.registerAccount.firstName" ng-minlength="3" ng-maxlength="50" ng-required="true"><div ng-show="form.firstname.$invalid"><p class="help-block" ng-show="form.firstname.$error.minlength" translate="register.messages.validate.firstname.minlength" translate-value-min="3">This field should be longer than 3 characters.</p><p class="help-block" ng-show="form.firstname.$error.maxlength" translate="register.messages.validate.firstname.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><div><input type="lastname" class="form-control" name="lastname" id="lastname" placeholder="{{\'register.form.lastname.placeholder\' | translate}}" ng-model="vm.registerAccount.lastName" ng-minlength="3" ng-maxlength="50" ng-required="true"><div ng-show="form.lastname.$invalid"><p class="help-block" ng-show="form.lastname.$error.minlength" translate="register.messages.validate.lastname.minlength" translate-value-min="3">This field should be longer than 3 characters.</p><p class="help-block" ng-show="form.last.$error.maxlength" translate="register.messages.validate.lastname.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><!-- <div class="form-group">\t\t\t\t\t \r\n\t\t\t\t\t\t  <div>\r\n\t\t\t\t\t\t \r\n\t\t\t\t\t\t\t<input type="lastname" class="form-control" name="login" id="login" placeholder="{{\'register.form.login.placeholder\' | translate}}"\r\n                           ng-model="vm.registerAccount.login" ng-minlength="3" ng-maxlength="50" ng-required="true">\r\n                                   <div ng-show="form.login.$invalid">\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.login.$error.minlength" translate="register.messages.validate.loginv.minlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\r\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 3 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.login.$error.maxlength" translate="register.messages.validate.loginv.maxlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\r\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n                        \r\n\t\t\t\t\t\t  </div>\r\n\t\t\t\t</div> --><div class="form-group"><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><div><input type="number" class="form-control" name="mobileno" id="mobileno" placeholder="{{\'register.form.mobileno.placeholder\' | translate}}" ng-model="vm.registerAccount.mobilePhone" ng-minlength="10" ng-maxlength="50" ng-required="true"><div ng-show="form.mobileno.$invalid"><p class="help-block" ng-show="form.mobileno.$error.minlength" translate="register.messages.validate.mobileno.minlength" translate-value-min="10">This field should be longer than 10 characters.</p><p class="help-block" ng-show="form.mobileno.$error.maxlength" translate="register.messages.validate.mobileno.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><!-- <div class="form-group">\t\t\t\t\t \r\n\t\t\t\t\t\t  <div>\r\n\t\t\t\t\t\t\t<input type="organization" class="form-control" name="organization" id="organization" placeholder="{{\'register.form.organization.placeholder\' | translate}}"\r\n                           ng-model="vm.registerAccount.organization" ng-minlength="3" ng-maxlength="50" ng-required="true">\r\n                           \r\n                           \t\t<div ng-show="form.organization.$invalid">\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.organization.$error.minlength" translate="register.messages.validate.organization.minlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\r\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 3 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.organization.$error.maxlength" translate="register.messages.validate.organization.maxlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\r\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n                        \r\n\t\t\t\t\t\t  </div>\r\n\t\t\t\t</div> --><!-- \t<div class="form-group">\t\t\t\t\t \r\n\t\t\t\t\t\t  <div>\r\n\t\t\t\t\t\t\t<select class="form-control countries" name="country" id="countryId sel1" ng-model="vm.registerAccount.country" ng-required="true">\r\n\t\t\t\t\t\t\t<option value="">Select Country</option>\r\n                           </select>\r\n                          \r\n\t\t\t\t\t\t  </div>\r\n\t\t\t\t</div>\r\n\t\t\t\t\r\n\t\t\t\t<div class="form-group">\t\t\t\t\t \r\n\t\t\t\t\t\t  <div>\r\n\t\t\t\t\t\t\t<select class="form-control states" name="state" id="sel12 stateId" ng-model="vm.registerAccount.state" ng-required="true">\r\n\t\t\t\t\t\t\t<option value="">Select State</option>\r\n                           </select>\r\n\r\n\t\t\t\t\t\t  </div>\r\n\t\t\t\t</div>\r\n\t\t\t\t\r\n\t\t\t\t<div class="form-group">\t\t\t\t\t \r\n\t\t\t\t\t\t  <div>\r\n\t\t\t\t\t\t\t<select  class="form-control cities" name="city" id="sel13 cityId" \r\n                           ng-model="vm.registerAccount.city" ng-required="true">\r\n                           \t<option value="">Select City</option>\r\n                           </select>\r\n\r\n\t\t\t\t\t\t  </div>\r\n\t\t\t\t</div> --><!-- <div class="form-group">\t\t\t\t\t \r\n\t\t\t\t\t\t  <div>\r\n\t\t\t\t\t\t \r\n\t\t\t\t\t\t\t<input type="text" class="form-control" name="city" id="city" placeholder="{{\'register.form.city.placeholder\' | translate}}"\r\n                           ng-model="vm.registerAccount.city" ng-minlength="3" ng-maxlength="50" ng-required="true">\r\n                                 <div ng-show="form.city.$invalid">\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.city.$error.minlength" translate="register.messages.validate.city.minlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\r\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 10 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.city.$error.maxlength" translate="register.messages.validate.city.maxlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\r\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t  </div>\r\n\t\t\t\t</div>\r\n\t\t\t\t\t<div class="form-group">\t\t\t\t\t \r\n\t\t\t\t\t\t  <div>\r\n\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<input type="text" class="form-control" name="state" id="state" placeholder="{{\'register.form.state.placeholder\' | translate}}"\r\n                           ng-model="vm.registerAccount.state" ng-minlength="3" ng-maxlength="50" ng-required="true">\r\n                                 <div ng-show="form.state.$invalid">\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.state.$error.minlength" translate="register.messages.validate.state.minlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\r\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 10 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.state.$error.maxlength" translate="register.messages.validate.state.maxlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\r\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n                           \r\n\t\t\t\t\t\t  </div>\r\n\t\t\t\t</div>\r\n\t\t\t\t\t<div class="form-group">\t\t\t\t\t \r\n\t\t\t\t\t\t  <div>\r\n\t\t\t\t\t\t \r\n\t\t\t\t\t\t\t<input type="text" class="form-control" name="country" id="country" placeholder="{{\'register.form.country.placeholder\' | translate}}"\r\n                           ng-model="vm.registerAccount.country" ng-minlength="3" ng-maxlength="50" ng-required="true">\r\n                                 <div ng-show="form.country.$invalid">\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.country.$error.minlength" translate="register.messages.validate.country.minlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-min="3">\r\n\t\t\t\t\t\t\t\t\t\tThis field should be longer than 10 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.country.$error.maxlength" translate="register.messages.validate.country.maxlength"\r\n\t\t\t\t\t\t\t\t\t   translate-value-max="50">\r\n\t\t\t\t\t\t\t\t\t\tThis field cannot be longer than 50 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n                          \r\n\t\t\t\t\t\t  </div>\r\n\t\t\t\t</div> --> <button type="submit" ng-disabled="form.$invalid" class="btn btn-warning btn-block" translate="\t">Contact Us</button></form></div><div class="col-sm-2"></div></div><!--col-sm-5--><!--            <div class="alert alert-danger" ng-show="vm.error" translate="register.messages.error.fail">\r\n                <strong>Registration failed!</strong> Please try again later.\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="vm.errorUserExists" translate="register.messages.error.userexists">\r\n                <strong>Login name already registered!</strong> Please choose another one.\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="vm.errorEmailExists" translate="register.messages.error.emailexists">\r\n                <strong>E-mail is already in use!</strong> Please choose another one.\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">\r\n                The password and its confirmation do not match!\r\n            </div> --></div></div></div><script src="http://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js"></script><script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script><script src="http://iamrohit.in/lab/js/location.js"></script></div>');
$templateCache.put('app/account/settings/settings.html','<div class="content"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title" translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for -<b>{{vm.settingsAccount.login}}</b></h3></div><form name="form" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label" for="firstName" translate="settings.form.firstname">First Name</label><div class="col-md-8"><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" for="lastName" translate="settings.form.lastname">Last Name</label><div class="col-md-8"><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" for="email" translate="global.form.email">E-mail</label><div class="col-md-8"><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100" readonly="readonly"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div></div><!--<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t<label for="langKey" class="col-md-3 control-label" translate="settings.form.language">Language</label>\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t<select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select>\r\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t</div>\t--></div><div class="box-footer"><div class="col-md-3 col-md-offset-3 save-buttons"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-sm" translate="settings.form.button">Save</button></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/amc-status-import/amc-status-import.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i><span> Import Amc Status</span></h3></div><div class="box-body"><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-6"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file ng-pattern="vm.importxlsx" accept="*.xlsx" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel file should be uploaded</p></div><div class="col-sm-2"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/admin/amc-status-import/asset-availability-import.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i><span> Import Asset Availability</span></h3></div><div class="box-body"><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-6"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file ng-pattern="vm.importxlsx" accept="*.xlsx" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel file should be uploaded</p></div><div class="col-sm-2"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/admin/asset-link/asset-link-request.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-link"></i><span> Asset Link Request</span></h3><!-- <div class="box-tools">\r\n                        <button class="btn btn-create btn-sm" ui-sref="entity-import.new">\r\n                            <span class="glyphicon glyphicon-plus"></span>\r\n                            <span>\r\n                                New\r\n                            </span>\r\n                        </button>\r\n                    </div> --></div><div class="box-body"><i class="fa fa-refresh" aria-hidden="true" style="font-size: 20px;cursor: pointer;color:#000" title="Refresh" ng-click="vm.refresh()"></i><div class="table-responsive mt-10"><table class="table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Entity Name</th><th><span>Status</span></th><th>Created Date</th></tr></thead><tbody><tr ng-repeat="list in vm.displayList track by list.id" ng-class="{greenyellow: $index === 0 && highlightAssetLink }"><!-- ng-class="{greenyellow: $index === 0 && vm.highlightRow }" --><td>{{list.id}}</td><td>{{list.entityName}}</td><td><span class="label label-info" ng-if="list.messageStatus == \'OPEN\'">{{list.messageStatus}}</span> <span class="label label-success" ng-if="list.messageStatus == \'COMPLETE\'">{{list.messageStatus}}</span> <span class="label label-danger" ng-if="list.messageStatus == \'FAILED\'">{{list.messageStatus}}</span> <span class="label label-warning" ng-if="list.messageStatus == \'IN-PROGRESS\'">IMPORT IN PROGRESS</span></td><td>{{list.createdDate | date: "dd/MM/yyyy \'at\' h:mma"}}</td></tr><tr><td colspan="10" ng-show="vm.displayList.length == 0"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/case-import/case-import-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span>Create New Request</span></h3></div><!-- /.box-header --><!-- form start --><div class="alert alert-success mt-5" ng-show="vm.showMessage"><strong>Import Successfull</strong> Your Tracking Id is {{vm.trackingId}}.</div><div class="col-md-12 mt-5"><span ui-sref="{{vm.currentState}}" class="fa fa-arrow-left" style="font-size: 15px;cursor: pointer;color:#000">Back</span></div><form class="form-horizontal" name="entityForm" ng-submit="vm.onSubmit()"><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select Entity</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="entity" ng-model="vm.entity" required><option value="">--- Select Entity ---</option><option value="Cases">Incidents</option><!-- <option value="NMS">NMS Incidents</option> --><!-- <option value="AMC">AMC Incidents</option> --></select></div></div><div class="form-group" ng-show="vm.entity==\'Cases\'"><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-4"><input type="file" name="uploadfile" id="uploadfile" class="filestyle" ng-pattern="vm.importxlsx" accept="*.xlsx||*.xls||*.kml" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel, kml and xml file should be uploaded</p></div></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm pull-right" ng-disabled="entityForm.$invalid">Submit</button></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/case-import/case-import.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i> <span>Import Incident</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="case-import.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><!-- REFRESH --> <i class="fa fa-refresh" style="font-size: 20px;cursor: pointer;color:#000" title="Refresh" ng-click="vm.refresh()"></i><!-- TABLE --><div class="table-responsive mt-10"><table class="table table-hover"><thead><tr><th></th><th>ID</th><th>Entity Name</th><th>Status</th><th>Created By</th><th>Created Date</th></tr></thead><tbody><tr ng-repeat-start="list in vm.displayList track by list.id"><!-- EXPAND --><td ng-click="vm.expand(list)" ng-if="(list.entityName == \'CASES\' || list.entityName == \'ASSETS\') && list.messageStatus == \'COMPLETE\'"><i class="fa" ng-class="{\'fa-plus-square\': !list.expand, \'fa-minus-square\': list.expand}"></i></td><td ng-if="!((list.entityName == \'CASES\' || list.entityName == \'ASSETS\') && list.messageStatus == \'COMPLETE\')"></td><td>{{list.id}}</td><!-- ENTITY NAME CHANGE --><td>{{vm.getEntityName(list.entityName)}}</td><td><span class="label label-success" ng-if="list.messageStatus == \'COMPLETE\'">{{list.messageStatus}} </span><span class="label label-danger" ng-if="list.messageStatus == \'FAILED\'">{{list.messageStatus}} </span><span class="label label-info" ng-if="list.messageStatus == \'OPEN\'">{{list.messageStatus}} </span><span class="label label-info" ng-if="list.messageStatus == \'IN-PROGRESS\'">{{list.messageStatus}}</span></td><td>{{list.createdBy}}</td><td>{{list.createdDate | date:"dd/MM/yyyy \'at\' h:mma"}}</td></tr><!-- EXPAND ROW --><tr ng-show="list.expand"><td colspan="10"><table style="width: 40%; margin-left: 3%;"><thead><tr><th>Sl No</th><th>File Name</th><th>Type</th></tr></thead><tbody><tr ng-repeat="item in vm.expandResponse"><td>{{$index+1}}</td><!-- <td>{{item.imageName}}</td> --><td ng-click="vm.download(item.imageId,item.trackerId,item.imageName)"><a>{{item.imageName}}</a></td><td>{{item.imageType}}</td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0"><h4>No data available</h4></td><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null"><h4>Loading...</h4></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr ng-if="vm.displayList.length == 0"><td colspan="10"><h4>No data available</h4></td></tr></tbody></table></div><!-- PAGINATION --><div class="row"><div class="col-md-4"><span>Total: {{vm.totalItems}}</span></div><div class="col-md-8"><div class="pull-right"><uib-pagination total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" max-size="5" boundary-links="true" class="pagination-sm" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title" translate="configuration.title">Configuration</h3><div class="box-tools"><form class="form-horizontal"><div class="form-group"><label class="col-md-6 control-label"><span translate="configuration.filter">Filter (by prefix)</span></label><div class="col-md-6"><input type="text" ng-model="filter" class="form-control input-sm"></div></div></form></div></div><div class="row"><div class="col-md-6"><div class="box-body"><div class="box box-solid"><div class="box-header"><h3 class="box-title" ng-hide="filteredConfig.length == 0">Spring configuration</h3></div></div><div class="table-responsive"><table class="jh-table table table-responsive table-hover" ng-hide="filtered.length == 0"><thead class="bg-default"><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table></div></div></div><div class="col-md-6"><div class="box-body"><div class="table-responsive" ng-repeat="(key, value) in vm.allConfiguration"><span class="profile-heading" ng-hide="filtered.length == 0"><b>{{key}}</b></span><div class="mt-5"></div><table class="jh-table table table-responsive table-hover" ng-hide="filteredConfig.length == 0"><thead class="bg-default"><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/customer-management/customer-management-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myUserLabel" ng-if="has_ROLE_SUPER_ADMIN"><span ng-if="!vm.customer.id" translate="customerManagement.home.create">Create</span> <span ng-if="vm.customer.id" translate="customerManagement.home.edit">Edit</span></h3></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.login">Login Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="login" ng-model="vm.customer.login" ng-required="vm.customer.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" ng-readonly="vm.customer.id"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.firstName">First Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="firstName" ng-model="vm.customer.firstName" ng-required="vm.customer.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" ng-readonly="vm.customer.id"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.lastName">Last Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="lastName" ng-model="vm.customer.lastName" ng-maxlength="50" ng-required="true" ng-readonly="vm.customer.id"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.email">Email</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="email" class="form-control" name="email" ng-model="vm.customer.email" required ng-maxlength="100" ng-pattern="EMAIL_REGEXP" ng-readonly="vm.customer.id"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.mobilephone">Phone</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="mobilePhone" ng-model="vm.customer.mobilePhone" ng-maxlength="14" ng-minlength="10" ng-pattern="PHONE_REGEXP" required ng-readonly="vm.customer.id"><p class="help-block" ng-show="editForm.mobilePhone.$error.maxlength" translate="global.messages.validate.mobilePhone.maxlength" translate-value-max="14">This field cannot be longer than 14 characters.</p><p class="help-block" ng-show="editForm.mobilePhone.$error.minlength" translate="global.messages.validate.mobilePhone.minlength" translate-value-max="10">This field cannot be lesser than 10 characters.</p><p class="help-block" ng-show="editForm.mobilePhone.$error.pattern" translate="global.messages.validate.mobilePhone.invalid">Your phone number is invalid.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.organization">Organization</span></label><div class="col-md-7"><input type="text" class="form-control" name="organization" ng-model="vm.customer.organization" ng-maxlength="50" ng-minlength="3" ng-readonly="vm.customer.id"><p class="help-block text-danger" ng-show="editForm.organization.$error.maxlength" translate="global.messages.validate.organization.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.organization.$error.minlength" translate="global.messages.validate.organization.minlength" translate-value-min="3">This field cannot be lesser than 3 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.city">City</span></label><div class="col-md-7"><input type="text" class="form-control" name="city" ng-model="vm.customer.city" ng-maxlength="50" ng-minlength="3" ng-readonly="vm.customer.id"><p class="help-block text-danger" ng-show="editForm.city.$error.maxlength" translate="global.messages.validate.city.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.city.$error.minlength" translate="global.messages.validate.city.minlength" translate-value-min="3">This field cannot be lesser than 3 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.state">State</span></label><div class="col-md-7"><input type="text" class="form-control" name="state" ng-model="vm.customer.state" ng-maxlength="50" ng-minlength="3" ng-readonly="vm.customer.id"><p class="help-block text-danger" ng-show="editForm.state.$error.maxlength" translate="global.messages.validate.state.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.state.$error.minlength" translate="global.messages.validate.state.minlength" translate-value-min="3">This field cannot be lesser than 3 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="customerManagement.country">Country</span></label><div class="col-md-7"><input type="text" class="form-control" name="country" ng-model="vm.customer.country" ng-maxlength="50" ng-minlength="3" ng-readonly="vm.customer.id"><p class="help-block text-danger" ng-show="editForm.country.$error.maxlength" translate="global.messages.validate.country.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.organization.$error.minlength" translate="global.messages.validate.organization.minlength" translate-value-min="3">This field cannot be lesser than 3 characters.</p></div></div><!-- \t\t\t\t\t\t <div class="form-group">\r\n\t\t\t\t\t\t \t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="customerManagement.gender">Gender</span> \t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-7">\r\n\t\t\t\t            <input type="text" class="form-control" name="gender"\r\n\t\t\t\t                   ng-model="vm.customer.gender" ng-readonly="vm.customer.id">\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t            </div>\r\n\t\t\t\t\t\t</div>   --><div class="form-group"><label class="col-md-3 control-label" translate="customerManagement.langKey">Lang Key</label><div class="col-md-7"><input type="langKey" class="form-control" name="langKey" ng-model="vm.customer.langKey" ng-readonly="vm.customer.id"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="customerManagement.status">Status</label><div class="col-md-7"><select class="form-control" value="vm.customer.status" selected="selected" name="status" ng-model="vm.customer.status" id="status" required><option disabled="disabled" selected="selected" value>--- Select Status ---</option><option value="NEW">NEW</option><option value="CREATED">CREATED</option></select></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button class="btn btn-default btn-sm" ui-sref="customer-management"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-edit"></span> <span translate="entity.action.edit">Edit</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/customer-management/customer-management.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-user"></span> <span translate="customerManagement.home.customerstitle" ng-if="has_ROLE_SUPER_ADMIN">Customers</span></h3><div class="box-tools"><!-- \t\t\t\t\t  <button class="btn btn-success btn-create" ui-sref="user-management.new">\r\n\t\t\t              <span class="glyphicon glyphicon-plus"></span> <span ng-if="has_ROLE_SUPER_ADMIN" translate="userManagement.home.createCustomerLabel">Create Customer</span>\r\n\t\t\t              <span ng-if="has_ROLE_USER_ADMIN" translate="userManagement.home.createUserLabel">Create Agent</span>\r\n\t\t\t              \r\n\t\t\t          </button> --></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-2 pull-right"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control input-sm ng-pristine ng-valid ng-empty ng-touched" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_]{3,}$/" placeholder="{{\'customerManagement.home.search\' | translate}}" aria-invalid="false"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="firstName"><span translate="customerManagement.firstName">First Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="lastName"><span translate="customerManagement.lastName">Last Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="email"><span translate="customerManagement.email">Email</span> <span class="fa fa-sort"></span></th><th jh-sort-by="mobilePhone"><span translate="customerManagement.mobilephone">Phone</span> <span class="fa fa-sort"></span></th><th jh-sort-by="organization"><span translate="customerManagement.organization">Organization</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="customerManagement.status">Status</span> <span class="fa fa-sort"></span></th><!-- \t\t\t\t\t                <th jh-sort-by="gender"><span translate="customerManagement.gender">Gender</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="customer in vm.customers   | filter :search track by customer.id"><td><a ui-sref="customer-management-detail({id:customer.id})">{{customer.firstName}}</a></td><td>{{customer.lastName}}</td><td>{{customer.email}}</td><td>{{customer.mobilePhone}}</td><!-- \t\t\t\t\t                 <td ng-if="has_ROLE_USER_ADMIN">{{user.imei}}</td>\r\n\t\t\t\t\t                 <td ng-if="has_ROLE_USER_ADMIN">{{user.operatingSystem}}</td>\r\n\t\t\t\t\t                 <td ng-if="has_ROLE_USER_ADMIN">{{user.applicationVersion}}</td> --><td>{{customer.organization}}</td><td>{{customer.status}}</td><td><div class="actions"><a ui-sref="customer-management-detail({id:customer.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><!-- \t\t\t\t\t                        <a ui-sref="customer-management.edit({id:customer.id})"\r\n\t\t\t\t\t                                class="actions-icons text-primary" title="Edit">\r\n\t\t\t\t\t                            <span class="fa fa-pencil-square"></span>\r\n\t\t\t\t\t                        </a>\r\n\t\t\t\t\t                        <a ui-sref="customer-management.delete({id:customer.id})"\r\n\t\t\t\t\t                                class="action-icons text-danger" ng-disabled="vm.currentAccount.id==customer.id">\r\n\t\t\t\t\t                            <span class="fa fa-times-circle"></span>\r\n\t\t\t\t\t                        </a> --></div></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/import/entity-import-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span>Create New Request</span></h3></div><!-- /.box-header --><!-- form start --><div class="alert alert-success mt-5" ng-show="vm.showMessage"><strong>Import Successfull</strong> Your Tracking Id is {{vm.trackingId}}.</div><div class="col-md-12 mt-5"><span ui-sref="{{vm.currentState}}" class="fa fa-arrow-left" style="font-size: 15px;cursor: pointer;color:#000">Back</span></div><form class="form-horizontal" name="entityForm" ng-submit="vm.onSubmit()"><div class="box-body border"><div class="form-group"><label class="col-md-3 control-label"><span>Select Entity</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="entity" ng-model="vm.entity" required><option value="">--- Select Entity ---</option><option value="Assets">Assets</option><!-- <option value="Cases">Incidents</option>\r\n\t\t\t\t\t\t\t\t\t<option value="Users">Geofences</option> --></select></div></div><!-- <div class="form-group"\r\n\t\t\t\t\t\t\tng-if="vm.entity==\'Assets\'">\r\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t<span>Select Asset Layout</span><sup><span class="required-icon"><i\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fa fa-asterisk text-danger"></i></span>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<select class="form-control" name="layout" ng-model="vm.entityLayout" required>\r\n\t\t\t\t\t\t\t\t\t<option value="">--- Select Asset Layout ---</option>\r\n\t\t\t\t\t                <option value="FIXED">FIXED</option>\r\n                                    <option value="SPREAD">SPREAD</option>\r\n\t\t\t\t\t            </select>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="form-group" ng-show="vm.entity==\'Assets\'"><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-4"><input type="file" name="uploadfile" id="uploadfile" class="filestyle" ng-pattern="vm.importxlsx" accept="*.xlsx||*.xls||*.kml" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel, kml and xml file should be uploaded</p></div></div></div><!-- <div class="form-group"\r\n\t\t\t\t\t\t\tng-if="vm.entity==\'Assets\' && vm.selectedAssettypeId.length > 0 &&(has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER)">\r\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t<span>Select File Format</span><sup><span class="required-icon"><i\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fa fa-asterisk text-danger"></i></span>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<select class="form-control" ng-model="vm.entityFileFormat" required>\r\n\t\t\t\t\t\t\t\t\t<option value="">--- Select File Format ---</option>\r\n\t\t\t\t\t                <option value="CSV">CSV</option>\r\n                                    <option value="KML">KML</option>\r\n\t\t\t\t\t\t\t\t\t<option value="EXCEL">EXCEL</option>\r\n\t\t\t\t\t            </select>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><!-- <div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessage">\r\n\t\t\t\t\t\t\t<h1>THANK YOU!</h1>\r\n\t\t\t\t\t\t\t<i class="fa fa-check main-content__checkmark" style="font-size:96px;color: green;"></i>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t<p>Your Tracking Id is {{vm.trackingId}} </p>\r\n\t\t\t\t\t\t</div> --><!-- <div class="col-sm-3" style="text-align: center;" ng-if="vm.showMessageError">\r\n\t\t\t\t\t\t\t<h1>Error</h1>\r\n\t\t\t\t\t\t\t<i class="fa fa-times main-content__checkmark" style="font-size:96px;color: red;"></i>\r\n\t\t\t\t\t\t\t<p>{{vm.errorMessage}}</p>\r\n\t\t\t\t\t\t</div>  --></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm pull-right" ng-disabled="entityForm.$invalid">Submit</button></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/import/entity-import.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i><span> Import Entity</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="entity-import.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><i class="fa fa-refresh" aria-hidden="true" style="font-size: 20px;cursor: pointer;color:#000" title="Refresh" ng-click="vm.refresh()"></i><div class="table-responsive mt-10"><table class="table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Entity Name</th><th><span>Status</span></th><th>Created Date</th></tr></thead><tbody><tr ng-repeat="list in vm.displayList track by list.id"><!-- ng-class="{greenyellow: $index === 0 && vm.highlightRow }" --><td>{{list.id}}</td><td>{{list.entityName}}</td><td><span class="label label-info" ng-if="list.messageStatus == \'OPEN\'">{{list.messageStatus}}</span> <span class="label label-success" ng-if="list.messageStatus == \'COMPLETE\'">{{list.messageStatus}}</span> <span class="label label-danger" ng-if="list.messageStatus == \'FAILED\'">{{list.messageStatus}}</span> <span class="label label-warning" ng-if="list.messageStatus == \'IN-PROGRESS\'">IMPORT IN PROGRESS</span></td><td>{{list.createdDate | date: "dd/MM/yyyy \'at\' h:mma"}}</td></tr><tr><td colspan="10" ng-show="vm.displayList.length == 0"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-body text-center mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="userManagement.detail.customertitle" ng-if="has_ROLE_SUPER_ADMIN">Customer</span> <span translate="userManagement.detail.agenttitle" ng-if="has_ROLE_USER_ADMIN">Agent</span> - {{vm.user.login}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="row"><!-- LEFT SIDE --><div class="col-md-6"><dl class="dl-horizontal jh-entity-details"><dt><span>User Name</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate="userManagement.phone">Phone</span></dt><dd>{{vm.user.phone}}</dd><dt><span>Mobile Device Tracking</span></dt><dd>{{vm.user.isMobileDeviceTracking}}</dd><!-- <dt\r\n                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                            <span translate="userManagement.imei">IMEI</span>\r\n                        </dt>\r\n                        <dd\r\n                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                            {{vm.user.imei}}</dd> --><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.gpsimei">GPS DEVICE IMEI</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">{{vm.user.gpsimei}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.operatingsystem">Operating System</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">{{vm.user.operatingSystem}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.applicationversion">Application Version</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">{{vm.user.applicationVersion}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.gpsstatus">GPS Status</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER" ng-show="vm.user.gpsStatus" class="dot dotOn"></dd><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER" ng-show="!vm.user.gpsStatus" class="dot dotOff"></dd><dt><span translate="userManagement.status">Status</span></dt><dd ng-show="vm.user.activated"><span class="label label-success" translate="userManagement.activated">Activated</span></dd><dd ng-show="!vm.user.activated"><span class="label label-danger" translate="userManagement.deactivated">Deactivated</span></dd><!-- <dt><span translate="userManagement.phone">Phone</span></dt>\r\n\t\t\t\t\t\t        <dd>{{vm.user.phone}}</dd>\r\n\t\t\t\t\t\t        <dt><span translate="userManagement.imsi">IMSI</span></dt>\r\n\t\t\t\t\t\t        <dd>{{vm.user.imsi}}</dd> --><!--<dt><span translate="userManagement.activated">Activated</span></dt>\r\n\t\t\t\t\t\t        <dd>{{vm.user.activated}}</dd>--></dl></div><div class="col-md-6"><dl class="dl-horizontal jh-entity-details"><dt><span translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.fromTime">From Time</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">{{vm.user.fromTime}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.toTime">To Time</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">{{vm.user.toTime}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.geofence">Geofence</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><input type="text" ng-model="vm.searchGeofence" placeholder="Search geofence" class="form-control" style="margin-bottom:8px; width: 95%;"><div style="max-height:150px; overflow-y:auto; padding:5px; border:1px solid #ddd; border-radius:4px;"><div ng-repeat="geofence in vm.user.geofenceNames | filter:vm.searchGeofence" style="margin-bottom:4px;"><span class="label label-default" style="display:inline-block; margin:2px;">{{ geofence }}</span></div><div ng-if="(vm.user.geofenceNames | filter:vm.searchGeofence).length === 0" style="color:#888; padding:5px;">No geofences found.</div></div></dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.vendor">Vendor</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span><div ng-repeat="vendor in vm.user.vendor"><span class="label label-default">{{vendor.name}}</span></div></span></dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.group">Group</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span><div ng-repeat="group in vm.user.groups"><span class="label label-default">{{ group.name}}</span></div></span></dd><dt><span translate="userManagement.profiles">Profiles</span></dt><dd><span><div ng-repeat="authority in vm.user.authorities"><span class="label label-primary">{{ authority }}</span><!-- <span ng-show="authority === \'ROLE_USER\'" class="label label-info">{{ authority }}</span> --></div></span></dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="userManagement.userimage">User Image</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><div class="col-md-2" ng-show="vm.user.userImage != null"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{vm.user.userImage}}" style="padding-bottom: 10px; width:40px;height:40px;"></div></dd></dl></div></div><div class="box-buttons"><a ui-sref="user-management" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="user-management.edit({login:vm.user.login})" class="btn btn-primary btn-sm pull-right" ng-if="!vm.has_ROLE_READONLY" ng-hide="has_ROLE_VENDOR"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myUserLabel" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span ng-if="!vm.user.id" translate="userManagement.home.createagent">Create</span> <span ng-if="vm.user.id" translate="userManagement.home.Editagent">Edit</span></h3><h3 class="box-title" id="myUserLabel" ng-if="has_ROLE_SUPER_ADMIN"><span ng-if="!vm.user.id" translate="userManagement.home.create">Create</span> <span ng-if="vm.user.id" translate="userManagement.home.Edit">Edit</span></h3></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span>User Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'@A-Za-z0-9-]*$/" ng-readonly="vm.user.id"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.pattern">special characters not allowed.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.firstName">First Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50" ng-required="true"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.lastName">Last Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50" ng-required="true"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.email">Email</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100" ng-pattern="EMAIL_REGEXP"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.phone">Phone</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="phone" ng-model="vm.user.phone" ng-maxlength="14" ng-minlength="10" ng-pattern="PHONE_REGEXP" required><p class="help-block" ng-show="editForm.phone.$error.maxlength" translate="global.messages.validate.phone.maxlength" translate-value-max="14">This field cannot be longer than 14 characters.</p><p class="help-block" ng-show="editForm.phone.$error.minlength" translate="global.messages.validate.phone.minlength" translate-value-max="10">This field cannot be lesser than 10 characters.</p><p class="help-block" ng-show="editForm.phone.$error.pattern" translate="global.messages.validate.phone.invalid">Your phone number is invalid.</p></div></div><!-- <div class="form-group"\r\n                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                            <label class="col-md-3 control-label">\r\n                                <span translate="userManagement.imei">IMEI</span>\r\n\r\n                            </label>\r\n                            <div class="col-md-7">\r\n                                <input type="text" class="form-control" name="imei" ng-model="vm.user.imei"\r\n                                    ng-maxlength="50" ng-minlength="15">\r\n\r\n                                <p class="help-block text-danger" ng-show="editForm.imei.$error.maxlength"\r\n                                    translate="global.messages.validate.imei.maxlength" translate-value-max="15">\r\n                                    This field cannot be longer than 15 characters.\r\n                                </p>\r\n                                <p class="help-block text-danger" ng-show="editForm.imei.$error.minlength"\r\n                                    translate="global.messages.validate.imei.minlength" translate-value-max="15">\r\n                                    This field cannot be lesser than 15 characters.\r\n                                </p>\r\n\r\n                            </div>\r\n                        </div> --><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.gpsimei">GPS IMEI</span></label><div class="col-md-7"><input type="text" class="form-control" name="gpsimei" ng-model="vm.user.gpsimei" ng-maxlength="50" ng-minlength="15" ng-disabled="!has_ROLE_USER_ADMIN"><p class="help-block text-danger" ng-show="editForm.gpsimei.$error.maxlength" translate="global.messages.validate.imei.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.gpsimei.$error.minlength" translate="global.messages.validate.imei.minlength" translate-value-max="15">This field cannot be lesser than 15 characters.</p></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.fromTime">Duty Start</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><select class="form-control" name="selectFrom" ng-model="vm.user.fromTime" ng-options="selectfrom as selectfrom for selectfrom in vm.selectfrom" required></select></div><label class="col-md-3 control-label user_endTime"><span translate="userManagement.toTime">End Time</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><select class="form-control" name="selectTo" ng-model="vm.user.toTime" ng-options="selectfrom as selectfrom for selectfrom in vm.selectfrom" required></select></div></div><div class="form-group" ng-if="vm.user.id"><label class="col-md-3 control-label" for="activated"><span translate="userManagement.activated">Activated</span></label><div class="col-md-2"><!--  ng-disabled="vm.user.id === null --> <input ng-disabled="!has_ROLE_USER_ADMIN" name="activated" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.user.activated"></div><label class="col-md-3 control-label"><span>Device Info</span></label><div class="col-md-2"><!-- ng-disabled="!hasDeviceInfo" --> <input ng-disabled="vm.deviceInfo" name="hasDeviceInfo" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.user.hasDeviceInfo"></div></div><div class="form-group" ng-if="vm.user.id"><label class="col-md-3 control-label" for="reportingStatus"><span translate="userManagement.reportingStatus">Reporting Status</span></label><div class="col-md-2"><!-- ng-disabled="vm.user.id === null" --> <input ng-disabled="!has_ROLE_USER_ADMIN" name="reportingStatus" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.user.reportingStatus"></div><label class="col-md-3 control-label"><span>Mobile Tracking</span></label><div class="col-md-2"><input ng-disabled="!has_ROLE_USER_ADMIN" name="isMobileDeviceTracking" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.user.isMobileDeviceTracking"></div></div><div class="form-group" ng-if="!vm.user.id"><label class="col-md-3 control-label"><span>Mobile Tracking</span></label><div class="col-md-2"><input ng-disabled="!has_ROLE_USER_ADMIN" name="isMobileDeviceTracking" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.user.isMobileDeviceTracking"></div></div><!-- <div class="form-group" ng-if="vm.user.id">\r\n                            <label class="col-md-3 control-label" for="checkinWithoutImage">\r\n                                <span translate="userManagement.allowCheckinWithoutSelfie">Allow Check-In without Selfie</span>\r\n                            </label>\r\n                            <div class="col-md-5">\r\n                                <input ng-disabled="vm.user.id === null" name="checkinWithoutImage" type="checkbox"\r\n                                    class="checkbox" id="field_escalated" ng-model="vm.user.checkinWithoutImage">\r\n                            </div>\r\n                        </div> --><div class="form-group" ng-hide="vm.user.id || !vm.user.id"><label class="col-md-3 control-label" translate="userManagement.langKey">Lang Key</label><div class="col-md-7"><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="userManagement.profiles">Profiles</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control" style="height:max-content;" name="authority"\r\n                                    ng-model="vm.user.authorities"\r\n                                    ng-options="authority for authority in vm.authorities" multiple required>\r\n                                </select> --> <select class="form-control" style="height:125px;" ng-model="vm.user.authorities" ng-disabled="!has_ROLE_USER_ADMIN" multiple="multiple" required><option ng-repeat="item in vm.authorities" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.geofence">Geofence</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control" multiple  name="geofences" ng-model="vm.user.geofences" required\r\n\t\t\t\t\t\t\t\t\t\tng-options="geofence.id as geofence.name for geofence in vm.geofences">\r\n\t\t\t\t\t\t\t\t\t      \r\n\t\t\t\t\t\t\t\t</select> --><div isteven-multi-select input-model="vm.multiGeofence" output-model="vm.user.geofences" helper-elements="all filter none" button-label="nameZone" item-label="nameZone" tick-property="ticked" output-properties="id selected" max-labels="3"></div><input type="text" ng-model="vm.user.geofences" name="fence" style="display:none" required><!-- <div>selected geofence id: {{vm.user.geofences}} </div> --></div><!-- <div class="col-md-3" ui-sref="geofence.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="userManagement.createGeofence">\r\n                                Create Geofence\r\n                            </div> --><!-- <div class="col-md-3" style="margin-top: 10px;">\r\n                                <i class="fa fa-plus-square" ng-click="vm.navigateGeofence();" style="cursor: pointer;" title=\'Create Geofence\'></i>\r\n                            </div> --></div><!-- <div class="form-group"\r\n                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                            <label class="col-md-3 control-label">\r\n                                <span translate="userManagement.group">Group</span>\r\n                            </label>\r\n                            <div class="col-md-3">\r\n                                <div isteven-multi-select input-model="vm.multiGroup" output-model="vm.user.groups"\r\n                                    button-label="name" item-label="name" helper-elements="all none" tick-property="ticked"\r\n                                    output-properties="id selected" max-labels="1">\r\n                                </div>\r\n                                <input type="text" ng-model="vm.user.groups" name="group" style="display:none"\r\n                                    required />\r\n                            </div>\r\n                            <div class="col-md-3" ui-sref="group-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="userManagement.createGroupType">\r\n                                Create Group Type\r\n                            </div>\r\n                            <div class="col-md-3" style="margin-top: 10px;">\r\n                                <i class="fa fa-plus-square" ng-click="vm.navigateGroupfromUserMng();" title=\'Create Group\' style="cursor: pointer;"></i>\r\n                            </div>\r\n                        </div> --><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span>Reports To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control" multiple  name="geofences" ng-model="vm.user.geofences" required\r\n\t\t\t\t\t\t\t\t\t\tng-options="geofence.id as geofence.name for geofence in vm.geofences">\r\n\t\t\t\t\t\t\t\t\t      \r\n\t\t\t\t\t\t\t\t</select> --><div is-disabled="vm.reportsEnable" isteven-multi-select input-model="vm.multiUser" output-model="vm.user.ownedBy" button-label="login" item-label="login" tick-property="ticked" selection-mode="single" output-properties="id selected"></div><input type="text" ng-model="vm.user.ownedBy" name="usreName" style="display:none" required><!-- <div>selected geofence id: {{vm.user.geofences}} </div> --></div></div><!-- <div class="form-group" ng-if="has_ROLE_USER_ADMIN">\r\n                            <label class="col-md-3 control-label">\r\n                                <span>Rollout Vendor</span>\r\n                            </label>\r\n                            <div class="col-md-7">\r\n                                <div isteven-multi-select input-model="vm.multiVendorEntity"\r\n                                    output-model="vm.user.vendor" helper-elements="all filter none" button-label="name" item-label="name"\r\n                                    tick-property="ticked" output-properties="id selected">\r\n                                </div>\r\n                                <input type="text" ng-model="vm.user.vendor" name="vendor" style="display:none" />\r\n                            </div>\r\n                        </div> --><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.vendor">Vendor Old</span></label><div class="col-md-7"><div isteven-multi-select input-model="vm.multiVendor" output-model="vm.user.vendors" button-label="login" item-label="login" tick-property="ticked" selection-mode="single" output-properties="id selected"></div><input type="text" ng-model="vm.user.vendors" name="usreName" style="display:none"></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label"><span translate="userManagement.trakeye">User Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="trakeyeType" ng-model="vm.user.trakeyeType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.trakeyeTypes track by item.id" required><option value="" translate="userManagement.selecttrakeye">---User Type---</option></select></div><!-- <div class="col-md-3" ui-sref="trakeye-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="userManagement.createFiberifyType">\r\n                                Create User Type\r\n                            </div> --><!-- <div class="col-md-3" style="margin-top: 10px;">\r\n                                <i class="fa fa-plus-square" ng-click="vm.navigateFiberifyTypefromGroup();" title=\'Create User Type\' style="cursor: pointer;"></i>\r\n                            </div> --></div><div ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><div class="form-group" ng-repeat="attribute in vm.user.trakeyeTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.trakeyeTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-if="attribute.trakeyeTypeAttribute.dataType == \'FLOAT\'" type="text" class="form-control" ng-value="attribute.trakeyeTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue" step="0.01"> <span ng-if="attribute.trakeyeTypeAttribute.dataType == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.trakeyeTypeAttribute.dataType == \'INTEGER\'" type="text" class="form-control" ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue" name="value{{$index+1}}" ng-value="attribute.trakeyeTypeAttribute.value" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.trakeyeTypeAttribute.dataType == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-if="attribute.trakeyeTypeAttribute.dataType == \'STRING\'" type="text" class="form-control" name="value{{$index+1}}" ng-value="attribute.trakeyeTypeAttribute.value" ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue"> <span ng-if="attribute.trakeyeTypeAttribute.dataType == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue" ng-init="vm.user.trakeyeTypeAttributeValues[$index].attributeValue = attribute.trakeyeTypeAttribute.value" ng-if="attribute.trakeyeTypeAttribute.dataType ==  \'BOOLEAN\' && !vm.user.id" class="form-control select2" name="value"><option value="true">True</option><option value="false">False</option></select> <select ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue" ng-init="vm.user.trakeyeTypeAttributeValues[$index].attributeValue == attribute.trakeyeTypeAttribute.value" ng-if="attribute.trakeyeTypeAttribute.dataType ==  \'BOOLEAN\' && vm.user.id" class="form-control select2" name="value"><option value="true">True</option><option value="false">False</option></select></div></div></div><div class="form-group" ng-show="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><label class="col-md-3 control-label" translate="userManagement.userimage">User Image</label><div class="col-md-6"><input type="file" name="file" class="filestyle" id="userImage" accept="image/*" ng-model="userImage" valid-file ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="assettype.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 userMngnt_showImg" ng-if="vm.user.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2" ng-show="vm.user.userImage != null"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{vm.user.userImage}}" style="padding-bottom: 10px;margin-left:250px; width:40px;height:40px;"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button class="btn btn-default btn-sm" ui-sref="user-management"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><span class="fa fa-user"></span> <span translate="userManagement.home.customerstitle" ng-if="has_ROLE_SUPER_ADMIN">Customers</span> <span translate="userManagement.home.userstitle" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">Agents</span></h3></div><div class="col-md-5 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)} " ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(1); " data-toggle="tab "><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(2)} " ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(2); " data-toggle="tab "><i class="fa fa-sitemap"></i><span class="header-view">Hierarchy</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(3)} " ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(3); " data-toggle="tab "><i class="fa fa-user-circle"></i><span class="header-view">Nearby</span> <span class="header_view">Agent</span></a></li></ul></div><div class="box-tools"><button class="btn btn-create" ui-sref="user-management.new " ng-if="has_ROLE_USER_ADMIN"><span class="glyphicon glyphicon-plus" ng-if="has_ROLE_SUPER_ADMIN "></span> <span ng-if="has_ROLE_SUPER_ADMIN " translate="userManagement.home.createCustomerLabel ">Create Customer</span> <span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><div class="row"><!-- <div class="col-md-1" ng-show="isSet(1)"  ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                            <button class="btn btn-primary center-block" ng-click="vm.downloadUsers()">\r\n                                Download All Users <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button>\r\n                        </div> --><div class="col-md-3 dropFilter" ng-show="isSet(1)" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD"><!-- <button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnListView()">\r\n                                <i class="fa fa-filter"></i>\r\n                            </button> --><div isteven-multi-select input-model=" vm.masterGeofences" output-model="vm.selectedGeofenceNearby" button-label="name" item-label="name" tick-property="ticked" translation="geofencelabel.list" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceNearby" name="vm.searchMini" style="display:none" required></div><!-- <div class="col-md-3 pull-right">\r\n                            <div class="input-group  ">\r\n                                <input type="text " ng-model="search " ng-change="vm.filterSearch() "\r\n                                    class="form-control  ng-pristine ng-valid ng-empty ng-touched "\r\n                                    ng-minlength="3 " ng-pattern="/^[a-zA-Z0-9_@ ]{3,}$/ " placeholder="{{ \'userManagement.home.search\'\r\n                                | translate}} " aria-invalid="false ">\r\n                                <span class="input-group-btn ">\r\n                                    <button type="button " class="btn btn-info btn-flat ">\r\n                                        <i class="fa fa-search "></i></button>\r\n                                </span>\r\n                            </div>\r\n                        </div> --><!-- <div class="col-md-3 pull-right" ng-show="isSet(1) ">\r\n                            <button class="btn btn-primary center-block" ng-click="vm.downloadUserManagementUserList()">\r\n                                Download\r\n                                Excel <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button>\r\n                        </div> --><div class="col-md-3 dropFilter" ng-show="isSet(3)"><!-- <button type="button" class="btn btn-info btn-flat"\r\n                                ng-click="vm.filterAssetsOnUserManagementMapView()">\r\n                                <i class="fa fa-filter"></i>\r\n                            </button> --><div isteven-multi-select input-model="vm.userGeofences" output-model="vm.selectedGeofenceNearby" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel.map" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceNearby" name="vm.searchMini" style="display:none" required> <span id="noData" ng-show="vm.selectedGeofenceNearby.length < 1">*Please Select Geofence</span></div><div class="col-md-2" ng-show="isSet(3) && vm.selectedGeofenceNearby.length >= 1"><!-- <label for="area" style="font-weight: normal;">Agent within </label> --> <select name="user_distance" id="user_distance"><!-- <option>---Select Distance---</option> --><option value="">Agent within</option><option value="250">250 m</option><option value="500">500 m</option><option value="1000" selected="selected">1 km</option><option value="5000">5 km</option><option value="10000">10 km</option><option value="20000">20 km</option><option value="50000">50 km</option><option value="100000">100 km</option></select></div><div class="col-md-2 pull-right" ng-show="isSet(2)"><button type="button" class="btn btn-info btn-flat" ng-click="vm.downloadImage()">Download</button></div><div class="col-md-2 selectAsset_drp pull-right" ng-show="isSet(3) && vm.selectedGeofenceNearby.length >= 1 "><select id="searchUsersOnMap" class="select2 form-control" name="search" style="width: 150px; height: 34px"><option value="">Search Agent</option><option ng-repeat="item in vm.usersList" value="{{item}}">{{item.login}}</option></select></div><div class="col-md-7 pull-right" ng-show="isSet(1)"><div ng-show="vm.selectedListGeofenceId!=0 && (has_ROLE_USER_ADMIN || has_ROLE_HOD)"><label class="col-md-2"><span>Search By Column</span></label><div class="col-md-6"><div isteven-multi-select input-model="vm.columnList" output-model="vm.selectedColumnList" helper-elements="all filter none" button-label="name" item-label="name" tick-property="ticked" output-properties="name selected"></div><input type="text" ng-model="vm.selectedColumnList" name="fence" style="display:none" required></div></div><div class="col-md-4 input-group pull-right"><input type="text " ng-model="search " placeholder="Search" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-minlength="2 " ng-pattern="/^[a-zA-Z0-9_@. ]{2,}$/ " aria-invalid="false "> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><!--users-tabs--><!-- <div class="userlisttab" ng-show="isSet(1) ">\r\n                        <jhi-alert></jhi-alert>\r\n                        <div class="table-responsive mt-10  table-scroll">\r\n                            <table class="jh-table table table-responsive table-hover "\r\n                                style=" width: 100%; border-spacing:0; margin:0; ">\r\n                                <thead class="bg-default ">\r\n                                    <tr>\r\n                                        <th style="width: 6%; "><span translate="userManagement.login">Login</span></th>\r\n                                        <th style="width: 6%; "><span translate="userManagement.reportto">Report\r\n                                                To</span></th>\r\n                                        <th style="width: 10%; "><span translate="userManagement.email ">Email</span>\r\n                                        </th>\r\n                                        <th style="width: 6%; "><span translate="userManagement.phone ">Phone</span>\r\n                                        </th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span translate="userManagement.imei ">IMEI</span>\r\n                                        </th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%;\r\n                                        "><span translate="userManagement.gpsimei ">GPS\r\n                                                IMEI</span></th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span\r\n                                                translate="userManagement.operatingsystem ">Operating System</span>\r\n                                        </th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span\r\n                                                translate="userManagement.applicationversion ">Application\r\n                                                Vesrion</span>\r\n                                        </th>\r\n                                        <th><span translate="userManagement.status " style="width: 6%; ">Status</span>\r\n                                        </th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span translate="userManagement.gpsstatus ">GPS\r\n                                                Status</span></th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span\r\n                                                translate="userManagement.geofence ">Geofences</span></th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 7%; "><span\r\n                                                translate="userManagement.profiles ">Profiles</span></th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span translate="userManagement.fromTime ">From\r\n                                                Time</span></th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span translate="userManagement.toTime ">To Time</span>\r\n                                        </th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span translate="userManagement.userimage ">User\r\n                                                Image</span></th>\r\n                                        <th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span>Checked In</span></th>\r\n                                        <th style="width: 5%; ">Actions</th>\r\n                                    </tr>\r\n                                </thead>\r\n                                <tbody>\r\n\r\n                                    <tr ng-repeat-start="user in vm.usersReporting | filter :search track by user.id ">\r\n                                        <td style="width: 6%; "><a\r\n                                                ui-sref="user-management-detail({login:user.login}) ">{{user.login}}</a>\r\n                                        </td>\r\n                                        <td style="width: 6%; ">{{user.ownedBy[0].login}}</td>\r\n                                        <td style="width: 10%; ">{{user.email}}</td>\r\n                                        <td style="width: 6%; ">{{user.phone}}</td>\r\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 8%; ">{{user.imei}}</td>\r\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; ">{{user.gpsimei}}</td>\r\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; "><span\r\n                                                class="admin-name ">{{user.operatingSystem}}</span></td>\r\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; ">{{user.applicationVersion}}</td>\r\n                                        <td style="width: 6%; ">\r\n                                            <span class="label label-danger " ng-show="!user.activated "\r\n                                                translate="userManagement.deactivated ">Deactivated</span>\r\n                                            <span class="label label-success " ng-show="user.activated "\r\n                                                translate="userManagement.activated ">Activated</span>\r\n                                        </td>\r\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; ">\r\n                                            <span ng-show="user.gpsStatus " translate="userManagement.gpson ">On</span>\r\n                                            <span ng-show="!user.gpsStatus "\r\n                                                translate="userManagement.gpsoff ">Off</span>\r\n                                        </td>\r\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; ">\r\n                                            <div ng-repeat="geofenceNames in user.geofenceNames ">\r\n                                                <span class="label label-default ">{{geofenceNames}}</span>\r\n                                            </div>\r\n                                        </td>\r\n\r\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT "\r\n                                            style="width:\r\n                                        7%; ">\r\n                                            <div ng-repeat="authority in user.authorities ">\r\n                                                <span ng-show="authority===\'ROLE_USER_ADMIN\' "\r\n                                                    class="label label-primary ">{{ authority }}</span>\r\n                                                <span ng-show="authority===\'ROLE_VENDOR_ADMIN\' "\r\n                                                    class="label label-primary ">{{ authority }}</span>\r\n                                                <span ng-show="authority===\'ROLE_HOD\' " class="label label-primary ">{{\r\n                                                    authority }}</span>\r\n                                                <span ng-show="authority===\'ROLE_CITY_MANAGER\' "\r\n                                                    class="label label-info ">{{ authority }}</span>\r\n                                                <span ng-show="authority===\'ROLE_CITY_PLANNER\' "\r\n                                                    class="label label-info ">{{ authority }}</span>\r\n                                                <span ng-show="authority===\'ROLE_ASSISTANT_MANAGER\' "\r\n                                                    class="label label-info ">{{ authority }}</span>\r\n                                                <span ng-show="authority===\'ROLE_TEAM_LEADER\' "\r\n                                                    class="label label-info ">{{ authority }}</span>\r\n                                                <span ng-show="authority===\'ROLE_NETWORK_ENGINEER\' "\r\n                                                    class="label label-info ">{{ authority }}</span>\r\n                                                <span ng-show="authority===\'ROLE_FRT\' " class="label label-info ">{{\r\n                                                    authority }}</span>\r\n                                                <span ng-show="authority===\'ROLE_PATROLLER\' "\r\n                                                    class="label label-info ">{{ authority }}</span>\r\n                                            </div>\r\n                                        </td>\r\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; ">{{getLocalhour(user.fromTime)}}</td>\r\n                                        <td ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "\r\n                                            style="width: 6%; ">{{getLocalhour(user.toTime)}}</td>\r\n                                        <td style="width: 6%; ">\r\n                                            <div class="col-md-10 ">\r\n                                                <img ng-show="user.userImage " class="img-responsive "\r\n                                                    ng-src="data:image/jpeg;base64,{{user.userImage}} "\r\n                                                    style="padding-bottom: 10px; height: 50px; width: 80px ">\r\n                                                <img ng-show="!user.userImage " class="img-responsive "\r\n                                                    ng-src="content/images/userimg.gif " style="padding-bottom: 10px; ">\r\n                                            </div>\r\n                                        </td>\r\n                                        <td style="width: 5%; "> {{ user.reportingStatus }}</td>\r\n                                        <td style="width: 5%; ">\r\n                                            <div class="actions ">\r\n                                                <a ui-sref="user-management-detail({login:user.login}) "\r\n                                                    class="action-icons text-info " title="View ">\r\n                                                    <span class="fa fa-eye "></span>\r\n                                                </a>\r\n                                                <a ui-sref="user-management.edit({login:user.login}) "\r\n                                                    class="actions-icons text-primary " title="Edit ">\r\n                                                    <span class="fa fa-pencil-square "></span>\r\n                                                </a>\r\n                                            </div>\r\n                                        </td>\r\n                                    </tr>\r\n                                    </tr>\r\n                                    <tr ng-repeat-end></tr>\r\n                                    <tr>\r\n                                        <td colspan="10 " ng-show="vm.users==0 " style="text-align: center; ">\r\n                                            <h4>No data available</h4>\r\n                                        </td>\r\n                                    </tr>\r\n\r\n                                </tbody>\r\n                            </table>\r\n                        </div>\r\n                    </div> --><div class="userlisttab" ng-show="isSet(1) "><jhi-alert></jhi-alert><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover" style="width: 100%; border-spacing:0; margin:0;"><thead class="bg-default"><tr jh-sort="vm.predicate " ascending="vm.reverse " callback="vm.transition() "><!-- <th style="width: 2%; "></th> --><th jh-sort-by="login "><span>User Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="login "><span>First Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="login "><span>Last Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="login "><span translate="userManagement.reportedto ">Reported To</span> <span class="fa fa-sort"></span></th><th jh-sort-by="email "><span translate="userManagement.email ">Email</span> <span class="fa fa-sort"></span></th><th jh-sort-by="phone "><span translate="userManagement.phone ">Phone</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="imei"\r\n                                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER ">\r\n                                            <span translate="userManagement.imei ">IMEI</span>\r\n                                            <span class="fa fa-sort"></span>\r\n                                        </th> --><th jh-sort-by="gps_imei " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span translate="userManagement.gpsimei ">GPS IMEI</span> <span class="fa fa-sort"></span></th><th jh-sort-by="operating_system " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span translate="userManagement.operatingsystem ">Operating System</span> <span class="fa fa-sort"></span></th><th jh-sort-by="application_version " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span translate="userManagement.applicationversion ">Application Vesrion</span> <span class="fa fa-sort"></span></th><th jh-sort-by="activated "><span translate="userManagement.status ">Status</span> <span class="fa fa-sort"></span></th><th jh-sort-by="gps_status " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span translate="userManagement.gpsstatus ">GPS Status</span> <span class="fa fa-sort"></span></th><!-- <th\r\n                                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER ">\r\n                                            <span translate="userManagement.geofence ">Geofences</span>\r\n                                        </th> --><th ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span translate="userManagement.profiles ">Profiles</span></th><th jh-sort-by="from_time " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span translate="userManagement.fromTime ">From Time</span> <span class="fa fa-sort"></span></th><th jh-sort-by="to_time " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span translate="userManagement.toTime ">To Time</span> <span class="fa fa-sort"></span></th><th ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span translate="userManagement.userimage ">User Image</span></th><th jh-sort-by="reporting_status " ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span>Checked In</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="user in vm.users"><!-- <td style="position:relative; padding-left: 1px;width: 2% ">\r\n                                            <button ng-click="vm.usersTable({id:user.firstName});expanded=! expanded "\r\n                                                expand style="padding: 4px 4px;position: absolute;margin-top: -6px; ">\r\n                                                <span ng-bind="expanded ? \'-\' : \'+\' "\r\n                                                    style="position: absolute;margin-top: -11px;margin-left: -4px; "></span>\r\n                                            </button>\r\n                                        </td> --><td><a ui-sref="user-management-detail({login:user.login}) ">{{user.login}}</a></td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.ownedBy[0].login}}</td><td>{{user.email}}</td><td>{{user.phone}}</td><!-- <td\r\n                                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER ">\r\n                                            {{user.imei}}</td> --><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER ">{{user.gpsimei}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span class="admin-name">{{user.operatingSystem}}</span></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER ">{{user.applicationVersion}}</td><td><span class="label label-danger" ng-show="!user.activated " translate="userManagement.deactivated ">Deactivated</span> <span class="label label-success" ng-show="user.activated " translate="userManagement.activated ">Activated</span></td><td style="text-align: center;padding-top: 14px" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER "><span ng-show="user.gpsStatus " class="dot dotOn"></span> <span ng-show="!user.gpsStatus " class="dot dotOff"></span></td><!-- <td\r\n                                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER ">\r\n                                            <div ng-repeat="geofenceNames in user.geofenceNames | limitTo:5">\r\n                                                <span class="label label-default ">{{geofenceNames}}</span>\r\n                                            </div>\r\n                                        </td> --><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT "><div ng-repeat="authority in user.authorities "><span ng-show="authority===\'ROLE_USER_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_VENDOR_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_VENDOR\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_HOD\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_CITY_MANAGER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_BA\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_CITY_PLANNER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_ASSISTANT_MANAGER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_OA\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_TEAM_LEADER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_NETWORK_ENGINEER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_FE\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_FRT\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_PATROLLER\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_PLAN_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_PLAN_INFRA\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_PLAN_SURVEY\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_ROLLOUT_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_ROLLOUT_INFRA\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_ROLLOUT_SURVEY\' " class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_ROLLOUT_FE\'" class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_ROLLOUT_MANAGER\'" class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_ROLLOUT_VENDOR\'" class="label label-info">{{ authority }}</span> <span ng-show="authority===\'ROLE_READONLY\' " class="label label-primary">{{ authority }}</span></div></td><td style="text-align: center;" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER ">{{user.fromTime}}</td><td style="text-align: center;" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER ">{{user.toTime}}</td><td><div class="col-md-10"><img ng-show="user.userImage " class="img-responsive" ng-src="data:image/jpeg;base64,{{user.userImage}} " style="height: 50px; width: 80px"> <img ng-show="!user.userImage " class="img-responsive" ng-src="content/images/userimg.gif "></div></td><td style="text-align: center;">{{ user.reportingStatus }}</td><td><div class="actions"><a ui-sref="user-management-detail({login:user.login}) " class="action-icons text-info" title="View "><span class="fa fa-eye"></span> </a><a ui-sref="user-management.edit({login:user.login}) " class="actions-icons text-primary" title="Edit " ng-if="!vm.has_ROLE_READONLY" ng-hide="has_ROLE_VENDOR"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-show="expanded "><td></td><td colspan="16"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 20px;"><thead><tr></tr></thead><tbody><tr ng-repeat-start="userData in vm.usersData "><td style="width: 7%;"><a ui-sref="user-management-detail({login:user.login}) ">{{userData.login}}</a></td><td style="width: 6%;">{{userData.createdBy}}</td><td style="width: 12%;">{{userData.email}}</td><td style="width: 6%;">{{userData.phone}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER " style="width: 6%;">{{userData.imei}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER " style="width: 8%;">{{userData.gpsimei}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER " style="width: 7%;"><span class="admin-name">{{userData.operatingSystem}}</span></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER " style="width: 6%;">{{userData.applicationVersion}}</td><td style="width: 6%;"><span class="label label-danger" ng-show="!userData.activated " translate="userManagement.deactivated ">Deactivated</span> <span class="label label-success" ng-show="userData.activated " translate="userManagement.activated ">Activated</span></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER " style="width: 6%;"><span ng-show="userData.gpsStatus " translate="userManagement.gpson ">On</span> <span ng-show="!userData.gpsStatus " translate="userManagement.gpsoff ">Off</span></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER " style="width: 6%;"><div ng-repeat="geofenceNames in userData.geofenceNames "><span class="label label-default">{{geofenceNames}}</span></div></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER " style="width: 7%;"><div ng-repeat="authority in userData.authorities "><span ng-show="authority===\'ROLE_USER_ADMIN\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_HOD\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_CITY_MANAGER\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_BA\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_CITY_PLANNER\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_BA\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_ASSISTANT_MANAGER\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_OA\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_TEAM_LEADER\' " class="label label-primary">{{ authority }}</span> <span ng-show="authority===\'ROLE_READONLY\' " class="label label-primary">{{ authority }}</span></div></td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER " style="width: 6%;">{{getLocalhour(userData.fromTime)}}</td><td ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER " style="width: 6%;">{{getLocalhour(userData.toTime)}}</td><td style="width: 6%;"><div class="col-md-10"><img ng-show="userData.userImage " class="img-responsive" ng-src="data:image/jpeg;base64,{{userData.userImage}} " style="padding-bottom: 10px; height: 50px; width: 80px"> <img ng-show="!userData.userImage " class="img-responsive" ng-src="content/images/userimg.gif " style="padding-bottom: 10px;"></div></td><td style="width: 5%;">{{ user.reportingStatus }}</td><td style="width: 6%;"><div class="actions"><a ui-sref="user-management-detail({login:userData.login}) " class="action-icons text-info" title="View "><span class="fa fa-eye"></span> </a><a ui-sref="user-management.edit({login:userData.login}) " class="actions-icons text-primary" title="Edit "><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.users==0 " style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-10"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page " total="vm.queryCount " items-per-page="vm.itemsPerPage "></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems " ng-model="vm.page " ng-change="vm.transition() "></uib-pagination></div></div></div></div><!--userlisttab--><div class="hierarchytab" ng-show="isSet(2) "><div id="body"></div></div><!--hierarchy View--><!--Nearest Users--><div class="map-view" ng-show="isSet(3) "><div class="row mt-5"><div class="col-md-12"><div id="map_canvas" style="height:{{mapHeight}}px; width:100%"></div></div></div></div><!--Nearest Users--></div></div></div></div></div><div id="listFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 70%;" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Master Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeListFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Master Geofence for List</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveListFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" style="color: red;font-weight: bold;" ng-show="vm.masterGeofences.length <= 1">* NO DATA</span><div style="margin-left: 35px;"><br><div ng-repeat="item in vm.masterGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedListGeofenceId" ng-value="{{item.id}}"> <label for="{{item.id}}" style="margin-left: 10px;font-size: medium;">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="mapFilterUserManagementModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 70%;" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeUserManagementMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveUserManagementGeofenceFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" style="color: red;font-weight: bold;" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div style="margin-left: 35px;"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" style="margin-left: 10px;font-size: medium;">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div>');
$templateCache.put('app/admin/vehicle-management/vehicle-management-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><span translate="vehicleManagement.detail.agenttitle" ng-if="has_ROLE_USER_ADMIN">Agent</span> - {{vm.user.login}}</div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vehicleManagement.licensePlate">License Plate</span></dt><dd><span>{{vm.vehicle.licensePlate}}</span></dd><dt><span translate="vehicleManagement.status">Status</span></dt><dd>{{vm.vehicle.status}}</dd><dt><span translate="vehicleManagement.vehicleType">Vehicle Type</span></dt><dd>{{vm.vehicle.vehicleType}}</dd><dt><span translate="vehicleManagement.vendor">Vendor</span></dt><dd>{{vm.vehicle.vendor}}</dd><dt><span translate="vehicleManagement.description">Description</span></dt><dd>{{vm.vehicle.description}}</dd><dt ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span translate="vehicleManagement.gpsimei">GPS DEVICE IMEI</span></dt><dd ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">{{vm.vehicle.gpsimei}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="vehicle-management" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="vehicle-management.edit({id:vm.vehicle.id}) " class="btn btn-primary btn-sm" ng-hide="has_ROLE_VENDOR"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/admin/vehicle-management/vehicle-management-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myVehicleLabel" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><span ng-if="!vm.vehicle.id" translate="vehicleManagement.home.createvehicle">Create</span> <span ng-if="vm.vehicle.id" translate="vehicleManagement.home.Editvehicle">Edit</span></h3></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label" for="field_status"><span translate="vehicleManagement.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="status" ng-model="vm.vehicle.status" id="field_status" required><option value="InService" translate="vehicleManagement.inservice">InService</option><option value="OutOfService" translate="vehicleManagement.outofservice">OutOfService</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_vehicleType"><span translate="vehicleManagement.vehicleType">Vehicle Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="vehicleType" ng-model="vm.vehicle.vehicleType" id="field_vehicleType" required><option value="DEFAULT" translate="vehicleManagement.default">DEFAULT</option><option value="FRT" translate="vehicleManagement.frt">FRT</option><option value="SOH" translate="vehicleManagement.soh">SOH</option><option value="CIVIL" translate="vehicleManagement.civil">CIVIL</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="vehicleManagement.licensePlate">License Plate</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="licensePlate" ng-model="vm.vehicle.licensePlate" ng-maxlength="100" ng-required="true"><div ng-show="editForm.licensePlate.$invalid"><p class="help-block" ng-show="editForm.licensePlate.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="vehicleManagement.gpsimei">GPS IMEI</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="gpsimei" ng-model="vm.vehicle.gpsimei" ng-maxlength="50" ng-minlength="15" required><p class="help-block text-danger" ng-show="editForm.gpsimei.$error.maxlength" translate="global.messages.validate.imei.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block text-danger" ng-show="editForm.gpsimei.$error.minlength" translate="global.messages.validate.imei.minlength" translate-value-max="15">This field cannot be lesser than 15 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Attached To </span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div isteven-multi-select input-model="vm.multiUser" output-model="vm.selectedUserId" button-label="login" item-label="login" tick-property="ticked" selection-mode="single" output-properties="id selected"></div><input type="text" ng-model="vm.selectedUserId" name="usreName" style="display:none" required></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="vehicleManagement.vendor">Vendor</span></label><div class="col-md-7"><input type="text" class="form-control" name="vendor" ng-model="vm.vehicle.vendor" ng-maxlength="100"><div ng-show="editForm.vendor.$invalid"><p class="help-block" ng-show="editForm.vendor.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="vehicleManagement.description">Description</span></label><div class="col-md-7"><textarea rows="2" type="text" class="form-control" name="description" ng-model="vm.vehicle.description" ng-maxlength="250"></textarea><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button class="btn btn-default btn-sm" ui-sref="vehicle-management"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/admin/vehicle-management/vehicle-management.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><span class="fa fa-car"></span> <span translate="vehicleManagement.home.customerstitle" ng-if="has_ROLE_SUPER_ADMIN">Customers</span> <span translate="vehicleManagement.home.vehiclestitle" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">Agents</span></h3></div><div class="col-md-6 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)} " ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(1); " data-toggle="tab "><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li></ul></div><div class="box-tools"><button class="btn btn-create" ui-sref="vehicle-management.new "><span class="glyphicon glyphicon-plus"></span> <span ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">New</span></button></div></div><div class="box-body"><div class="row"><div class="col-md-3 pull-right" ng-show="isSet(1)" style="margin-right: 20px;"><div class="input-group"><input type="text " ng-model="search " ng-change="vm.filterSearch() " class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-minlength="3 " ng-pattern="/^[a-zA-Z0-9_@ ]{3,}$/ " placeholder="{{\r\n                                    \'vehicleManagement.home.search\' | translate}} " aria-invalid="false "> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div></div><div class="vehiclelisttab" ng-show="isSet(1) "><jhi-alert></jhi-alert><div class="table-responsive table-header-fixed mt-10"><table class="jh-table table table-responsive table-hover" style="width: 100%; border-spacing:0; margin:0;"><thead class="bg-default"><tr jh-sort="vm.predicate " ascending="vm.reverse " callback="vm.transition() "><th jh-sort-by="gps_imei"><span translate="vehicleManagement.gpsimei ">GPS IMEI </span><span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="vehicleManagement.status ">Status </span><span class="fa fa-sort"></span></th><th jh-sort-by="vehicle_type"><span translate="vehicleManagement.vehicleType ">Vehicle Type </span><span class="fa fa-sort"></span></th><th jh-sort-by="license_plate"><span translate="vehicleManagement.licensePlate ">License Plate </span><span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="vehicleManagement.description ">Description </span><span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="vehicle in vm.vehicles"><td>{{vehicle.gpsimei}}</td><td>{{vehicle.status}}</td><td>{{vehicle.vehicleType}}</td><td>{{vehicle.licensePlate}}</td><td>{{vehicle.description}}</td><td style="width: 6%;"><div class="actions"><a ui-sref="vehicle-management-detail({id:vehicle.id}) " class="action-icons text-info" title="View "><span class="fa fa-eye"></span> </a><a ui-sref="vehicle-management.edit({id:vehicle.id}) " class="actions-icons text-primary" title="Edit "><span class="fa fa-pencil-square"></span></a></div></td></tr></tbody></table></div><div class="row mt-10"><div class="col-md-4"><div class="count-length"><jhi-item-count page=" vm.page " total=" vm.queryCount " items-per-page=" vm.itemsPerPage "></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items=" vm.totalItems " ng-model=" vm.page " ng-change=" vm.transition() "></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="container"><div class="content" ng-if="!vm.isAuthenticated()" ng-cloak><div class="row login-sizes"><div class="mt-45"></div><div class="col-md-7 col-sm-8 login-main"><div class="login-image"><img class="img-responsive1" ng-src="content/images/welcome-to-fiberify.png" ng-if="vm.appName==\'Fiberify\'"> <img class="img-responsive1" ng-src="content/images/welcome-to-fiberify.png" ng-if="vm.appName==\'Fiberify\'"></div></div><div class="col-md-4 col-sm-8 col-md-offset-1 col-sm-offset-2"><div class="mt-45"></div><div class="panel panel-primary login-panel"><div class="panel-heading"><span translate="login.title" class="signin-heading">Sign in</span></div><div class="panel-body"><form class="form-horizontal" role="form" ng-submit="vm.login($event)"><div class="form-group"><div class="col-md-12"><div class="alert alert-danger" ng-show="vm.authenticationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div></div><div class="form-group has-feedback"><div class="col-sm-12"><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"> <span class="fa fa-user form-control-feedback"></span></div></div><div class="form-group has-feedback"><div class="col-sm-12"><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"> <span class="fa fa-lock form-control-feedback"></span></div></div><div class="form-group"><label for="rememberMe" class="col-md-12"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span translate="login.form.rememberme">Remember me</span></label></div><div class="form-group"><div class="col-sm-12"><button type="submit" class="btn btn-info btn-sm btn-block" translate="login.form.button">Sign in</button></div></div></form><div class="mt-20"></div></div><div class="panel-footer bg-default text-center"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" translate="login.password.forgot">Did you forget your password?</a></div></div><div class="col-md-12 login-shadow"><div class="footer-shadow"><img ng-src="content/images/shadow.png" class="img-responsive"></div></div></div></div></div></div><div class="pt-76"></div>');
$templateCache.put('app/components/View/comments.html','<div id="comment-box" class="form-group col-md-8 mt-10"><input type="text" id="comment" ng-model="newComment" class="form-control" placeholder="Add a comment..." maxlength="255"> <button ng-click="addComment()" class="btn btn-primary btn-sm mt-5" ng-disabled="!newComment"><span class="fa fa-paper-plane" aria-hidden="true">Save</span></button></div><br><div id="comment-list" class="form-group col-md-8"><li ng-repeat="comment in comments | orderBy : \'-lastModifiedDate\' " class="comment"><div class="comment-info"><span><img ng-src="content/images/userimg.gif" class="img-circle" style="width: 30px; height: 30px" alt="user" aria-hidden="false"> <b>{{comment.lastModifiedBy}}</b></span> <span>{{comment.lastModifiedDate | date:\'dd-MM-yyyy h:mm a\'}}</span></div><div class="comment-text" ng-hide="comment.editing">{{comment.comment}}</div><div ng-if="comment.editing"><input type="text" class="edit-input" ng-model="comment.comment" class="form-control"> <button ng-click="saveEdit(comment)" class="btn btn-primary btn-sm">Save</button> <button ng-click="cancelEdit(comment)" class="btn btn-default btn-sm">Cancel</button></div><div class="comment-actions" ng-if="loginUserName == comment.lastModifiedBy"><span ng-if="!comment.editing" class="edit-btn" ng-click="startEditing(comment)">Edit</span> <span class="delete-btn" href="#" ng-click="deleteComment(comment.id)">Delete</span></div></li></div><div class="modal fade" id="deleteComment" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="closeModal(\'deleteComment\')"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Delete this comment?</h4></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="deleteCommentConfirm()" data-dismiss="modal"><span translate="entity.action.delete">Delete</span></button> <button type="button" class="btn btn-default" ng-click="closeModal(\'deleteComment\')" data-dismiss="modal"><span translate="entity.action.cancel">Cancel</span></button></div></div></div></div>');
$templateCache.put('app/components/View/materialTxnTab.html','<div class="mt-15"><button class="btn btn-create btn-sm" ui-sref="tr-section.materialTxndialog({ entityId : entityId , entityName : entityName, sectionId : sectionId })"><span class="glyphicon glyphicon-plus"></span> <span>Add Material Transactions</span></button></div><!-- <div class="col-md-12">\r\n    <div class="form-group">\r\n        <label class="col-md-2 control-label">\r\n            <span>Select Date</span>\r\n            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n            </sup>\r\n        </label>\r\n        <div class="col-md-3">\r\n            <select class="form-control select2" ng-model="selectedDate"\r\n                ng-options="item.id as item.name for item in dateList" required>\r\n                <option value="" >\r\n                    --- Select Date ---\r\n                </option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div> --><br><div class="table-responsive mt-10"><h3>Summary</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Name</th><th>Units of Measurement</th><th>Quantity</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  mtrlTxSummary"><td>{{task.materialName}}</td><td>{{task.unitOfMeasurementName}}</td><td>{{task.totalNoOfUnits}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="mtrlTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="table-responsive mt-10"><h3>Material Inventory Transaction</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th></th><th>Date</th><th>Total</th></tr></thead><tbody><tr ng-repeat-start="task in materialByDate"><td class="td__listViewRow" ng-click="toggleExpand(task)" expand><span ng-if="!task.isExpand" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true" ng-click="loadMaterialTxnByDates(task.timestamp)"></i> </span><span ng-if="task.isExpand" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{task.timestamp}}</td><td>{{task.total}}</td></tr><tr ng-if="task.isExpand"><td ng-if="materialTxnByDates.length > 0"></td><td colspan="4" ng-if="materialTxnByDates.length > 0"><table class="table__userNames"><thead><tr><th>SlNo</th><th>Date</th><th>Material-ID</th><th>Material-Name</th><th>Transaction-Id</th><th>No of Units</th><th>Transaction-Type</th><th>Action</th></tr></thead><tbody><tr ng-repeat="detail in materialTxnByDates"><td>{{$index + 1}}</td><td>{{detail.timestamp | date:\'dd-MM-yyyy\'}}</td><td>{{detail.materialId}}</td><td>{{detail.materialName}}</td><td>{{detail.mtrlTxNumber}}</td><td>{{detail.count}}</td><td>{{detail.transactionType}}</td><td><div class="action"><a class="action-icons text-primary" title="Edit Transaction" ng-click="openTransactionModal(detail)"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td colspan="7"><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="txnPage" total="txnQueryCount" items-per-page="txnItemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="txnTotalItems" ng-model="txnPage" ng-change="loadMaterialTxnByDates(task.timestamp)"></uib-pagination></div></div></div></td></tr></tbody></table></td><td colspan="13" ng-if="materialTxnByDates.length == 0"><table class="table__userNames"><thead><tr><th></th><th>No transaction found</th></tr></thead></table></td></tr><tr ng-repeat-end></tr><tr ng-show="materialByDate.length == 0"><td colspan="3"><h4>No Transaction Available</h4></td></tr></tbody></table><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="summaryPage" total="summaryQueryCount" items-per-page="summaryItemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="summaryTotalItems" ng-model="summaryPage" ng-change="loadMaterialTxnDate()"></uib-pagination></div></div></div><div class="modals" ng-if="isModalOpen"><div class="modal-contents"><h4>Edit Transaction</h4><form name="editForm"><table class="modal-table"><tr><td><label>Transaction ID:</label></td><td><input type="text" ng-model="selectedTransaction.mtrlTxNumber" disabled="disabled"></td></tr><tr><td><label>Select Date:</label></td><td><input type="datetime-local" max="{{ options.maxDate | date:\'yyyy-MM-dd\' }}" ng-model="selectedTransaction.transactionDate"></td></tr><tr ng-if="selectedTransaction.transactionDate"><td><label>Material Name:</label></td><td><input type="text" ng-model="selectedTransaction.materialName"></td></tr><tr ng-if="selectedTransaction.materialName"><td><label>Material ID:</label></td><td><input type="text" ng-model="selectedTransaction.materialId"></td></tr><tr ng-if="selectedTransaction.materialId"><td><label>No of Units:</label></td><td><input type="text" ng-model="selectedTransaction.noOfUnits"></td></tr><tr ng-if="selectedTransaction.noOfUnits"><td><label>Transaction Type:</label></td><td><select ng-model="selectedTransaction.transactionType"><option value="">--- Select ---</option><option ng-repeat="item in transactionType" value="{{item}}">{{item}}</option></select></td></tr></table><div class="modal-actions"><button type="button" class="btn btn-default btn-sm" ng-click="cancelTransaction()">Cancel</button> <button type="button" class="btn btn-primary btn-sm" ng-click="saveTransaction()" ng-disabled="!selectedTransaction.transactionDate || \r\n\t\t\t\t\t!selectedTransaction.materialName || \r\n\t\t\t\t\t!selectedTransaction.materialId || \r\n\t\t\t\t\t!selectedTransaction.noOfUnits || \r\n\t\t\t\t\t!selectedTransaction.transactionType">Save</button></div></form></div></div></div>');
$templateCache.put('app/components/View/resourceTxnTab.html','<div class="mt-15"><button class="btn btn-create btn-sm" ui-sref="tr-section.resourceTxndialog({ entityId : entityId , entityName : entityName, sectionId : sectionId })"><span class="glyphicon glyphicon-plus"></span> <span>Add Resource Transactions</span></button></div><!-- <div class="col-md-12">\r\n    <div class="form-group">\r\n        <label class="col-md-2 control-label">\r\n            <span>Select Date</span>\r\n            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n            </sup>\r\n        </label>\r\n        <div class="col-md-3">\r\n            <select class="form-control select2" ng-model="selectedDate"\r\n                ng-options="item.id as item.name for item in dateList" required>\r\n                <option value="" >\r\n                    --- Select Date ---\r\n                </option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div> --><br><div class="table-responsive mt-10"><h3>Resources</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Resource Name</th><th>No of Resource</th><th>No of Work Hours</th><th>Remarks</th><th>Transaction Type</th><th>Transaction Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="resource in  resourceTxListView"><td>{{resource.resourceName}}</td><td>{{resource.noOfResources}}</td><td>{{resource.numberOfHours}}</td><td>{{resource.remarks}}</td><td>{{resource.transactionType}}</td><td>{{resource.transactionDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><a ui-sref="tr-section.resourceTxndialog({id:resource.id, sectionId:resource.sectionId })" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="page" total="queryCount" items-per-page="itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="totalItems" ng-model="page" ng-change="transition()"></uib-pagination></div></div></div></div><div class="table-responsive mt-10"><h3>Summary</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Name</th><th>Total no of Resources</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  resTxSummary"><td>{{task.resourceName}}</td><td>{{task.totalNoOfResources}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="resTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><!-- <div class="table-responsive mt-10">\r\n    <h3>Resource Transaction</h3>\r\n    <table class="jh-table table table-responsive table-hover">\r\n        <thead class="bg-default">\r\n            <tr>\r\n                <th></th>\r\n                <th>Date</th>\r\n                <th>Total</th>\r\n            </tr>\r\n        </thead>\r\n        <tbody>\r\n            <tr ng-repeat-start="task in materialByDate">\r\n                <td class="td__listViewRow" ng-click="toggleExpand(task)" expand>\r\n                    <span ng-if="!task.isExpand" class="span__listViewRow">\r\n                        <i class="fa fa-plus-square" aria-hidden="true"\r\n                            ng-click="loadMaterialTxnByDates(task.timestamp)"></i>\r\n                    </span>\r\n                    <span ng-if="task.isExpand" class="span__listViewRow">\r\n                        <i class="fa fa-minus-square" aria-hidden="true"></i>\r\n                    </span>\r\n                </td>\r\n                <td>{{task.timestamp}}</td>\r\n                <td>{{task.total}}</td>\r\n            </tr>\r\n            <tr ng-if="task.isExpand">\r\n                <td ng-if="materialTxnByDates.length > 0"></td>\r\n                <td colspan="4" ng-if="materialTxnByDates.length > 0">\r\n                    <table class="table__userNames">\r\n                        <thead>\r\n                            <tr>\r\n                                <th>SlNo</th>\r\n                                <th>Date</th>\r\n                                <th>Material-ID</th>\r\n                                <th>Material-Name</th>\r\n                                <th>Material-Type</th>\r\n                                <th>No of Units</th>\r\n                                <th>Transaction-Type</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr ng-repeat="detail in materialTxnByDates">\r\n                                <td>{{$index + 1}}</td>\r\n                                <td>{{detail.timestamp | date:\'dd-MM-yyyy\'}}</td>\r\n                                <td>{{detail.transactionId}}</td>\r\n                                <td>{{detail.transactionName}}</td>\r\n                                <td>{{detail.transactionType}}</td>\r\n                                <td>{{detail.count}}</td>\r\n                                <td>{{detail.status}}</td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td colspan="7">\r\n                                    <div class="row mt-15">\r\n                                        <div class="col-md-4">\r\n                                            <div class="count-length">\r\n                                                <jhi-item-count page="page" total="queryCount"\r\n                                                    items-per-page="itemsPerPage"></jhi-item-count>\r\n                                            </div>\r\n                                        </div>\r\n                                        <div class="col-md-8">\r\n                                            <div class="pagination-list pull-right">\r\n                                                <uib-pagination class="pagination-sm" total-items="totalItems"\r\n                                                    ng-model="page" ng-change="loadMaterialTxnByDates(task.timestamp)">\r\n                                                </uib-pagination>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </td>\r\n                <td colspan="13" ng-if="materialTxnByDates.length == 0">\r\n                    <table class="table__userNames">\r\n                        <thead>\r\n                            <tr>\r\n                                <th></th>\r\n                                <th>No transaction found</th>\r\n                            </tr>\r\n                        </thead>\r\n                    </table>\r\n                </td>\r\n            </tr>\r\n            <tr ng-repeat-end></tr>\r\n            <tr ng-show="materialByDate.length == 0">\r\n                <td colspan="3">\r\n                    <h4>No Transaction Available</h4>\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n    </table>\r\n    <div class="row mt-15">\r\n        <div class="col-md-4">\r\n            <div class="count-length">\r\n                <jhi-item-count page="page" total="queryCount" items-per-page="itemsPerPage"></jhi-item-count>\r\n            </div>\r\n        </div>\r\n        <div class="col-md-8">\r\n            <div class="pagination-list pull-right">\r\n                <uib-pagination class="pagination-sm" total-items="totalItems" ng-model="page"\r\n                    ng-change="loadMaterialTxnDate()">\r\n                </uib-pagination>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/components/View/routeImage.html','<div class="modal fade" id="mediaCarouselModal" tabindex="-1" role="dialog"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header ml-3" style="display: flex;"><h5 class="modal-title">{{routeName}}_{{imgLatitude}},{{imgLongitude}}</h5><div class="carousel-downloads"><button class="btn btn-primary btn-sm" ng-click="downloadMedia()">Download</button> <button class="btn btn-primary btn-sm" ng-click="downloadAllMedia()">Download All</button></div><button id="maximizeBtn" type="button" style="border:none" ng-click="toggleMaximize()"><span class="fa fa-window-maximize" aria-hidden="true"></span></button> <button id="minimizeBtn" type="button" style="display:none;border:none" ng-click="toggleMaximize()"><span class="fa fa-window-minimize" aria-hidden="true"></span></button> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="closeModal(\'mediaCarouselModal\')"><span aria-hidden="true">&times;</span></button></div><div id="loading-bar-spinner" style="display: none;"><div class="spinner-icon"></div></div><div class="modal-body text-center"><div class="position-relative d-flex justify-content-center align-items-center my-3"><i class="fa fa-arrow-left nav-button prevs" ng-click="prevMedia()" aria-hidden="true" style="font-size: 2rem; cursor: pointer; margin-right: 20px;"></i><div id="carouselMediaContainer" class="carousel-display mx-3"></div><i class="fa fa-arrow-right nav-button nexts" ng-click="nextMedia()" aria-hidden="true" style="font-size: 2rem; cursor: pointer; margin-left: 20px;"></i></div><div class="thumbnails_container"><div ng-repeat="media in mediaImagesIds" ng-class="{\'selected-thumbnail\': $index === currentIndex}" style="display: inline-block; margin: 5px; cursor: pointer;" ng-click="jumpToMedia($index)"><img ng-if="media.imageType !== \'MP4\'" ng-src="content/images/image_icon.png" style="width: 50px; height: 50px;"> <img ng-if="media.imageType === \'MP4\'" ng-src="content/images/video_icon.png" style="width: 50px; height: 50px;"></div></div></div></div></div></div><div id="mediaModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog modal-lg" role="document" style="max-width: 80%; width:auto"><div class="modal-content"><div class="modal-header" style="display: flex; justify-content: flex-end; align-items: center; height: 60px; position: relative;"><h5 class="modal-title" style="flex-grow: 1;">{{imgLatitude}},{{imgLongitude}}</h5><div class="modal-controls" style="display: flex; align-items: center;"><button id="maximizeBtn" type="button" style="border:none"><span class="fa fa-window-maximize" aria-hidden="true"></span></button> <button id="minimizeBtn" type="button" style="display:none;border:none"><span class="fa fa-window-minimize" aria-hidden="true"></span></button> <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="margin-left: 10px;"><span aria-hidden="true">&times;</span></button></div></div><div class="modal-body" id="mediaModalContent" style="text-align: center; background-color: white;"></div></div></div></div><div id="modalAssetAttributes" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameAssetAttributes" class="span__modal-header">Asset Attributes</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="closeAssetAttributesModal()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body" style="overflow-y: scroll; height: 80vh"><div id="assetAttributeTable"></div></div></form></div></div></div><div id="marker_Attr_edit" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="markerAttrEdit"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header bg-primary text-white"><h4 class="modal-title" id="markerAttrEdit"><i class="fa fa-map-marker"></i> Attribute Edit</h4><button type="button" class="close text-white" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div style="width: 100%; height: 50vh; padding-top: 7px;" class="modal-body"><div class="row"><div class="col-md-12"><div class="box-body"><div class="row"><table style="width: 100%;"><tbody><tr><td style="padding: 8px; width:30%;"><label>LHS Offset</label></td><td style="padding: 8px; width: 70%"><input type="number" class="form-control" id="lhsOffset"></td></tr><tr><td style="padding: 8px; width:30%;"><label>RHS Offset</label></td><td style="padding: 8px; width: 70%"><input type="number" class="form-control" id="rhsOffset"></td></tr><tr><td style="padding: 8px; width:30%;"><label>Road Type</label></td><td style="padding: 8px; width: 70%"><select class="form-control" id="roadType"><option value="">-- Select Road Type --</option><option value="BITUMINOUS">BITUMINOUS</option><option value="CONCRETE">CONCRETE</option><option value="COBBLE">COBBLE</option><option value="MUD">MUD</option></select></td></tr><tr><td style="padding: 8px; width:30%;"><label>Road Width</label></td><td style="padding: 8px; width: 70%"><input type="number" class="form-control" id="roadWidth" step="0.1"></td></tr><tr><td style="padding: 8px; width:30%;"><label>Land Mark</label></td><td style="padding: 8px; width: 70%"><input type="text" class="form-control" id="landMark"></td></tr><tr><td style="padding: 8px; width:30%;"><label>RodoMeter Length</label></td><td style="padding: 8px; width: 70%"><input type="number" class="form-control" id="rodometerLength"></td></tr></tbody></table></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button> <button type="button" class="btn btn-primary" id="saveMarkerAttr">Save</button></div></div></div></div>');
$templateCache.put('app/components/View/tablePagination.html','<div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th ng-repeat="display in headers">{{display}}</th></tr></thead><tbody><tr ng-repeat="resource in  resourceTxListView"></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="page" total="queryCount" items-per-page="itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="totalItems" ng-model="page" ng-change="transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-addition.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.asset.id" translate="trakeyeApp.asset.home.create">Create</span> <span ng-if="vm.asset.id" translate="trakeyeApp.asset.home.update">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div><label class="col-md-3 control-label asset_parent"><span>Select Asset</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7 asset_parent"><div isteven-multi-select input-model="vm.multiassets" output-model="vm.asset.ownedBy" button-label="name" item-label="name" tick-property="ticked" selection-mode="single" output-properties="id selected"></div><input type="text" ng-model="vm.asset.ownedBy" name="assetName" id="input__none"><br></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.coordinates">Coordinates</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><div class="input-group"><input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled="disabled" ng-model="vm.asset.assetCoordinates" required> <span class="input-group-btn" ng-if="vm.asset.id==null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Create</button> </span><span class="input-group-btn" ng-if="vm.asset.id!=null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">View or Edit</button> </span><span class="input-group-btn" ng-if="vm.asset.id!=null"><button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm">Destroy and Create</button></span></div><br><div id="map_canvas" class="div__map-canvas"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="asset"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button><!-- ng-disabled="editForm.$invalid || vm.isSaving" --><!-- \t\t\t\t        <button type="submit"  class="btn btn-primary btn-sm"> --><!-- <button onclick="topFunction()" id="myBtn" type="submit"\r\n\t\t\t\t\t\t\t\tclass="btn btn-primary btn-sm pull-left">\r\n\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-save"></span>&nbsp;<span\r\n\t\t\t\t\t\t\t\t\ttranslate="entity.action.save">Save</span>\r\n\t\t\t\t\t\t\t</button> --></div><script>//Get the button\r\n\t\t\t\t\t\t\tvar mybutton = document.getElementById("myBtn");\r\n\r\n\t\t\t\t\t\t\t// When the user scrolls down 20px from the top of the document, show the button\r\n\t\t\t\t\t\t\twindow.onscroll = function() {\r\n\t\t\t\t\t\t\t\tscrollFunction()\r\n\t\t\t\t\t\t\t};\r\n\r\n\t\t\t\t\t\t\tfunction scrollFunction() {\r\n\t\t\t\t\t\t\t\t/* if (document.body.scrollTop\r\n\t\t\t\t\t\t\t\t\t\t|| document.documentElement.scrollTop) {\r\n\t\t\t\t\t\t\t\t\tmybutton.style.display = "block";\r\n\t\t\t\t\t\t\t\t} else {\r\n\t\t\t\t\t\t\t\t\tmybutton.style.display = "none";\r\n\t\t\t\t\t\t\t\t} */\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t// When the user clicks on the button, scroll to the top of the document\r\n\t\t\t\t\t\t\tfunction topFunction() {\r\n\t\t\t\t\t\t\t\tdocument.body.scrollTop = 0;\r\n\t\t\t\t\t\t\t\tdocument.documentElement.scrollTop = 0;\r\n\t\t\t\t\t\t\t}</script></div></form></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-connect.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.asset.id">Connect Two Sites</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div class="col-md-10"><div class="col-md-2"><span><b>Connect Type :</b></span></div><div class="col-md-4"><fieldset data-role="controlgroup" data-type="horizontal" name="connecttype" id="connecttype" style="margin-left: -38px;"><span><input name="connectTypeRdo" id="connectTypeRadio1" value="Automatic" type="radio"> <label for="connectTypeRadio1">Automatic</label> </span>&nbsp;&nbsp;&nbsp; <span><input name="connectTypeRdo" id="connectTypeRadio2" value="Manual" type="radio"> <label for="connectTypeRadio2">Manual</label></span></fieldset></div><div class="col-md-2"><span><b>Road Side :</b></span></div><div class="col-md-4"><fieldset data-role="controlgroup" data-type="horizontal" name="roadside" id="roadside" style="margin-left: -63px;"><span><input name="RoadSideRdo" id="roadSideRadio1" value="Left" type="radio"> <label for="roadSideRadio1">Left</label> </span>&nbsp;&nbsp;&nbsp; <span><input name="RoadSideRdo" id="RoadSiteRdo" value="Right" type="radio"> <label for="roadSideRadio2">Right</label></span></fieldset></div></div><br><br><div style="margin-top: 8px; margin-left: 36px;"><label class="col-md-2"><span>Fiber Owner</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-4"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.fiberowner" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><br><br><div style="margin-top: 8px; margin-left: 36px;"><div class="col-md-1 select_asset" style="text-align: right"><label style="padding-top: 6px;">Site A</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;"><select id="fromAssetsView" class="select2 form-control" name="search" style="width:\r\n                                    220px; height: 40px"><option value="">--Select Site A--</option><option ng-repeat="item in vm.multiassets" value="{{item.id}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px; margin-left: 93px;"><label style="padding-top: 6px;">Site B</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;margin-left: -15px;"><select id="toAssetsView" class="select2 form-control" name="search" style="width:\r\n                                    220px; height: 40px;"><option value="">--Select Site B--</option><option ng-repeat="item in vm.multiassets" value="{{item.id}}">{{item.name}}</option></select></div><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Connect</button></div><div class="form-group"><div class="col-md-11" style="margin: 20px"><div id="map_canvas" style="height:360px;"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="asset"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button><!-- type="submit" ng-disabled="editForm.$invalid || vm.isSaving" --> <button class="btn btn-primary btn-sm" ng-click="vm.save()" type="button" class="btn btn-primary btn-sm pull-right" ng-disabled="vm.isSaving"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button><!-- <button type="button" class="btn btn-default btn-sm"\r\n                                ui-sref="asset">\r\n                                <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span\r\n                                    translate="entity.action.cancel">Cancel</span>\r\n                            </button>\r\n                            <button ng-click="vm.save()" type="button" class="btn btn-primary btn-sm pull-right" ng-disabled="vm.isEnabled">\r\n                                <span class="glyphicon glyphicon-save"></span>&nbsp;<span\r\n                                    translate="entity.action.save">Save</span>\r\n                            </button> --></div><script>//Get the button\r\n                            var mybutton = document.getElementById("myBtn");\r\n\r\n                            // When the user scrolls down 20px from the top of the document, show the button\r\n                            window.onscroll = function() {\r\n                                scrollFunction()\r\n                            };\r\n\r\n                            function scrollFunction() {\r\n                                if (document.body.scrollTop ||\r\n                                    document.documentElement.scrollTop) {\r\n                                    mybutton.style.display = "block";\r\n                                } else {\r\n                                    mybutton.style.display = "none";\r\n                                }\r\n                            }\r\n\r\n                            // When the user clicks on the button, scroll to the top of the document\r\n                            function topFunction() {\r\n                                document.body.scrollTop = 0;\r\n                                document.documentElement.scrollTop = 0;\r\n                            }</script></div></form></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.asset.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.asset.delete.question" translate-values="{id: \'{{vm.asset.name}}\'}">Are you sure you want to delete this Asset?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/asset/asset-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" ng-hide=\'vm.asset.assetType.layout == "SPREAD"\'><span translate="trakeyeApp.asset.detail.title">Asset</span> - {{vm.asset.name}}</h3><button type="button" ng-click="vm.showImages()" class="btn btn-primary btn-sm pull-right" style="margin-left: 10px;">show Media</button> <button type="button" ng-click="vm.toggleMap()" class="btn btn-primary btn-sm pull-right" style="margin-left: 10px;">{{ vm.isMapVisible ? \'Hide Map\' : \'Show Map\' }}</button><div class="col-md-4 col-sm-2 headerTab30" ng-show=\'vm.asset.assetType.layout == "SPREAD"\'><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab"><i class="fa fa-info-circle"></i><span class="header-view">Asset</span> <span class="header_view">Details</span></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2);" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Linked Fixed</span> <span class="header_view">Assets</span></a></li></ul></div></div><div ng-show="isSet(1)"><div class="col-md-6"><h4 class="box-title" style="text-align:center"><span style="font-weight:600;">Asset Details</span></h4><div class="box-body"><!-- <jhi-alert-error></jhi-alert-error> --><dl class="dl-horizontal jh-entity-details"><!-- <dt>\r\n                                    <span>Id</span>\r\n                                </dt>\r\n                                <dd>\r\n                                    <span>{{vm.asset.id}}</span>\r\n                                </dd> --><dt><span translate="trakeyeApp.asset.name">Name</span></dt><dd><span>{{vm.asset.name}}</span></dd><dt><span translate="trakeyeApp.asset.description">Description</span></dt><dd><span>{{vm.asset.description}}</span></dd><!-- <dt><span translate="trakeyeApp.geofence.coordinates">Coordinates</span></dt>\r\n                                    <dd>\r\n                                    <div id="map_canvas" style="width:100%;height:400px;    margin-bottom: 10px;"></div>\r\n                                    </dd> --><dt><span>Health Indicator</span></dt><dd><span><input type="checkbox" style="margin-left: 5px;\r\n                                                width: 17px;\r\n                                                height: 17px;\r\n                                                cursor: not-allowed" onclick="return false" ng-checked="vm.asset.healthIndicator"></span></dd><dt><span>Health Remarks</span></dt><dd><span>{{vm.asset.healthRemarks}}</span></dd><dt><span translate="trakeyeApp.asset.assetType">Asset Type</span></dt><dd><span><a ui-sref="asset-type-detail({id:vm.asset.assetType.id})">{{vm.asset.assetType.name}}</a></span></dd><dd ng-if="has_ROLE_USER">{{vm.asset.assetType.name}}</dd><dt ng-show=\'vm.asset.assetType.layout == "SPREAD"\'><span>Length (mtrs)</span></dt><dd ng-show=\'vm.asset.assetType.layout == "SPREAD"\'><span>{{(vm.asset.assetLength * 1000).toFixed(2)}}</span></dd><dt><span>Accessible</span></dt><dd><span><!-- <input\r\n                                            type="checkbox"                                   \r\n                                            style="\r\n                                                margin-left: 5px;\r\n                                                width: 17px;\r\n                                                height: 17px;\r\n                                                cursor: not-allowed\r\n                                            "onclick="return false"\r\n                                            ng-checked="vm.asset.accessible"                                    \r\n                                    /> --><label class="switch"><input type="checkbox" style="margin-top: 10px;\r\n                                        margin-left: 15px;\r\n                                        cursor: not-allowed" onclick="return false" ng-checked="vm.asset.accessible"> <span class="slider round" style="cursor: not-allowed;"></span></label></span></dd><dt ng-show=\'vm.asset.assetTypeName == "Chamber"\'><span>Buried Chamber</span></dt><dd ng-show=\'vm.asset.assetTypeName == "Chamber"\'><span><label class="switch"><input type="checkbox" style="margin-top: 10px;\r\n                                        margin-left: 15px;\r\n                                        cursor: not-allowed" onclick="return false" ng-checked="vm.asset.burried"> <span class="slider round" style="cursor: not-allowed;"></span></label></span></dd><dt ng-show="vm.asset.phase != null"><span>Phase</span></dt><dd ng-show="vm.asset.phase != null"><span>{{vm.asset.phase}}</span></dd><dt><span translate="trakeyeApp.asset.user">User</span></dt><dd><span>{{vm.asset.userIdDTO.login}}</span></dd><dt><span translate="trakeyeApp.asset.createDate">Create Date</span></dt><dd><span>{{vm.asset.createDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.asset.updateDate">Update Date</span></dt><dd><span>{{vm.asset.updateDate | date:\'medium\'}}</span></dd></dl></div></div><div class="col-md-6"><h4 class="box-title" style="text-align:center"><span style="font-weight: 600;">Additional Details</span></h4><div class="table-scroll box-body"><div class="form-group div--form-group"><dl class="dl-horizontal jh-entity-details" ng-repeat="item in vm.asset.assetTypeAttributeValues"><!-- <dt>\r\n                                        <span>Asset Value </span><span>\r\n                                            {{$index + 1}}</span>\r\n                                            \r\n                                    </dt> --><dt><span><b>{{item.assetTypeAttribute.name}}</b></span></dt><dd><span>{{item.attributeValue}}</span> <span ng-if="item.assetAttributeImages.length > 0" ng-click="showAllImages(item.assetAttributeImages, \'reference\')" style="color: #3c8dbc; cursor: pointer; margin-left: 10px;">Show Images</span></dd></dl><dl class="dl-horizontal jh-entity-details" ng-repeat="item in vm.assetRefAttributes"><!-- <dt>\r\n                                    <span>Asset Value </span><span>\r\n                                        {{$index + 1}}</span>\r\n                                        \r\n                                </dt> --><dt ng-show="item.attributeDataType.name != \'IMAGE\'"><span><b>{{item.name}}</b></span></dt><dt ng-show="item.attributeDataType.name == \'IMAGE\' && item.imageId != null"><span><b>{{item.name}}</b></span></dt><dd ng-show="item.attributeDataType.name != \'IMAGE\'"><span>{{item.attributeValue}}</span></dd><dd ng-show="item.attributeDataType.name == \'IMAGE\' && item.imageId != null"><p ng-show="item.attributeName != null" ng-click="newTabDisplay(item.imageId,\'reference\')" style="color: #3c8dbc;">{{item.attributeName}}</p></dd></dl></div></div></div></div></div><div class="case-table" ng-show="isSet(2)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span translate="trakeyeApp.asset.name">Name</span> <span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.asset.assetType">Asset Type</span></th><th><span>ID</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.listMappedAssets track by asset.id"><td>{{asset.name}}</td><td>{{asset.assetTypeName}}</td><td><a ui-sref="asset-detail({id:asset.id})">{{asset.id}}</a></td></tr><tr><td colspan="10" ng-show="!vm.listMappedAssets"><h4>No data available</h4></td></tr></tbody></table></div><div class="row row__div--pagination" ng-show="vm.listMappedAssets"><!-- <div class="col-md-2 pull-left row__div--pagesize">\r\n                            <label for="area">Page size </label>\r\n                            <select name="page_size" id="page_size">\r\n                                <option value="10">10</option>\r\n                                <option value="20">20</option>\r\n                                <option value="50">50</option>\r\n                            </select>\r\n                        </div> --><div class="col-md-3 row__div--showingnoitems"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><!-- <div class="col-md-2">\r\n                            <label>Go To </label>\r\n                            <input type="text" id="pagenum" oninput="this.value|=0"\r\n                                onkeyup="if(this.value<0){this.value= this.value * -1}" maxlength="4" />\r\n                            <button type="button " ng-click="vm.goToPage()" class="button__goto">\r\n                                <i class="fa fa-caret-right"></i>\r\n                            </button>\r\n                        </div> --><div class="col-md-4 pull-right"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div><div class="col-md-12" ng-show="vm.isMapVisible"><div id="map_canvas" style="height: 60vh;margin: 20px;"></div></div><div class="col-md-12" ng-show="isSet(1)"><a onclick="history.back()" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="asset-detail.edit({id:vm.asset.id})" class="btn btn-primary pull-right" ng-if="!vm.has_ROLE_READONLY"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div><div class="modal fade" id="imageCarouselModal" tabindex="-1" role="dialog"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header ml-3" style="display: flex;"><h5 class="modal-title">{{vm.asset.name}}-GP</h5><div class="carousel-downloads"><button class="btn btn-primary btn-sm" onclick="downloadCurrentImage()">Download File</button> <button class="btn btn-primary btn-sm" onclick="downloadAllImages()">Download All</button></div><button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="closeCarousel()"><span aria-hidden="true">&times;</span></button></div><div id="loading-bar-spinner" style="display: none;"><div class="spinner-icon"></div></div><div class="modal-body text-center"><div class="position-relative d-flex justify-content-center align-items-center"><i class="fa fa-arrow-left nav-button prevs" onclick="changeImage(-1)" aria-hidden="true" style="font-size: 2rem; cursor: pointer;"></i><div id="carouselDisplayContainers" class="carousel-displays mx-3"></div><i class="fa fa-arrow-right nav-button nexts" onclick="changeImage(1)" aria-hidden="true" style="font-size: 2rem; cursor: pointer;"></i></div><div class="carousel-thumbnails mt-3 d-flex justify-content-start overflow-auto" style="white-space: nowrap; max-width: 100%;" id="carouselThumbnails"></div></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.asset.id" translate="trakeyeApp.asset.home.create">Create</span> <span ng-if="vm.asset.id" translate="trakeyeApp.asset.home.update">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!-- \t<div class="form-group" ng-show="vm.asset.id">\r\n\t\t\t\t\t            <label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label>\r\n\t\t\t\t\t            <div class="col-md-7">\r\n\t\t\t\t\t            \t<input type="text" class="form-control" id="id" name="id"\r\n\t\t\t\t\t                    ng-model="vm.asset.id" readonly />\r\n\t\t\t\t\t            </div>\r\n\t\t\t\t\t            \t\r\n\t\t\t\t\t        </div> --><!--  <div class="form-group" ng-if="vm.asset.id">\r\n                                <label for="id" class="col-md-3 control-label" translate="global.field.id">Id</label>\r\n                                <div class="col-md-8">\r\n                                    <input type="text" class="form-control" id="id" name="id" ng-model="vm.asset.id"\r\n                                        readonly />\r\n                                </div>\r\n                            </div> --><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.name" for="field_name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.asset.name" required ng-minlength="2" ng-maxlength="200"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div></div><div class="form-group"><!--   <label class="col-md-3 control-label" translate="trakeyeApp.asset.description" for="field_description">Description</label> --> <label class="col-md-3 control-label" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.asset.description"></textarea></div></div><!--<div class="form-group">\r\n\t\t\t\t\t\t\t<label class="col-md-3 control-label" translate="trakeyeApp.asset.networkId" for="field_networkId">Network ID</label>\r\n\t\t\t\t\t\t   <div class="col-md-7">\r\n\t\t\t\t\t\t\t\t<input type="text"  class="form-control" name="networkId" id="field_networkId" ng-model="vm.asset.networkId"></textarea>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>--><!-- <div class="row">\r\n                            <div class="col-md-3 control-label asset_parent">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.asset.ownedby">Owner</span> \r\n                                </div>\r\n                            <div class="col-md-3 asset_parent" style="margin-bottom: 16px;">\r\n                                <div isteven-multi-select input-model="vm.multiassets" output-model="vm.asset.ownedBy" button-label="name" item-label="name" tick-property="ticked" output-properties="id selected">\r\n                                </div>\r\n                                <input type="text" ng-model="vm.asset.ownedBy" name="assetName" style="display:none" />\r\n                            </div>\r\n                            <div class="col-md-3" style="margin-top: 10px;">\r\n                                <i class="fa fa-plus-square" ng-click="vm.navigateCreateAsset();" style="cursor: pointer;" title=\'Create Asset\'></i>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-3 control-label" for="field_parentAsset"><!-- <span translate="trakeyeApp.asset.ownedby">Owner</span> --> <span>Link to Asset</span><!-- 508 --></label><div class="col-md-8"><input list="parentAsset" class="form-control" id="field_selectParentAsset" placeholder="Search parent asset" type="text" ng-model="vm.selectedParent" autocomplete="off" name="seletedParent" ng-change="vm.filterParentAssets()"><datalist id="parentAsset" class="form-control1"><option ng-repeat="parent in vm.parentAssets" value="{{parent.name}}"></option></datalist></div></div><div class="form-group row"><div class="col-md-3 control-label"><span>Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3"><div isteven-multi-select input-model="vm.multiGroup" output-model="vm.asset.groups" button-label="name" item-label="name" helper-elements="all none" tick-property="ticked" output-properties="id selected"></div><input type="text" ng-model="vm.asset.groups" name="group" id="input__none" required></div><!-- <div class="col-md-3" ui-sref="group-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="trakeyeApp.asset.home.createNewGroupType">\r\n                                    Create Group\r\n                            </div> --><!-- <div class="col-md-3" style="margin-top: 10px;">\r\n                                <i class="fa fa-plus-square" ng-click="vm.navigateCreateGroup();" style="cursor: pointer;" title=\'Create Group\'></i>\r\n                            </div> --></div><div class="form-group" ng-show="vm.roleAccess && vm.groupAccess && vm.asset.phase"><label class="col-md-3 control-label"><span>Phase</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup> --></label><div class="col-md-3"><!--  <div isteven-multi-select input-model="vm.phases" output-model="vm.asset.phase"\r\n                                button-label="configKey" item-label="configKey" helper-elements="all none" tick-property="ticked"\r\n                                output-properties="configKey" selection-mode="single" on-item-click="vm.onSelectPhase()" disable-property="roleRolloutAdmin"></div>\r\n                            <input type="text" ng-model="vm.asset.phase" name="configKey" id="input__none" required /> --> <select class="form-control" name="status" ng-model="vm.asset.phase" ng-disabled="!vm.roleRolloutAdmin"><option value="">--- Select Phase ---</option><option ng-repeat="item in vm.phases" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><!--<div class="form-group" >\r\n\t\t\t\t\t\t\t<label class="col-md-3 control-label col-xs-2 asset_active" for="activated">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.asset.active">Active</span> \r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-5 col-xs-6 active_checkbox">\r\n\t\t\t\t\t\t\t\t<input  name="activated" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.asset.status">\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>--><div class="form-group" ng-show=\'vm.asset.assetType.layout == "SPREAD"\'><label class="col-md-3 control-label"><span>Length (mtrs)</span></label><div class="col-md-8" style="margin-top: 7px;"><span>{{(vm.asset.assetLength * 1000).toFixed(2)}}</span></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Accessible</span></label><!-- <input type="checkbox" style="margin-top: 10px; margin-left: 10px" ng-model="vm.asset.accessible" /> --><div class="col-md-8"><label class="switch" style="margin-top: 7px;"><input type="checkbox" style="margin-top: 10px;\r\n                                             margin-left: 15px;" ng-model="vm.asset.accessible"> <span class="slider round"></span></label></div></div><div class="form-group" ng-if="vm.asset.id"><!-- 508 --> <label class="col-md-3 control-label"><span>Health Indicator</span></label><div class="col-md-7"><input type="checkbox" style="margin-top: 10px; margin-left: 10px" ng-model="vm.asset.healthIndicator"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Is Existing</span></label><div class="col-md-7"><input type="checkbox" style="margin-top: 10px; margin-left: 10px" ng-model="vm.asset.isExisting"></div></div><div class="form-group" ng-if="vm.asset.id"><!-- 508 --> <label class="col-md-3 control-label" for="health_Remarks">Health Remarks</label><div class="col-md-7"><textarea rows="2" class="form-control" name="healthRemarks" id="health_Remarks" ng-model="vm.asset.healthRemarks"></textarea></div></div><div class="form-group row"><div class="col-md-3 control-label"><span translate="trakeyeApp.asset.assetType" for="field_assetType">Asset Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3"><!-- <select class="form-control" id="field_assetType" name="assetType" ng-model="vm.asset.assetTypeId" ng-options="assetType.id as assetType.name for assetType in vm.assettypes"            >\r\n\t\t\t\t\t                <option value=""></option>\r\n\t\t\t\t\t            </select> --> <select class="form-control select2" name="assetType" ng-model="vm.assetType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.assettypes track by item.id" required><option value="">--- Select AssetType ---</option></select></div><!-- <div class="col-md-3" ui-sref="asset-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="trakeyeApp.asset.home.createNewAssetType">\r\n                                    Create Asset Type\r\n                            </div> --><div class="col-md-3 div__mt-10"><i class="fa fa-plus-square i__fa-plus-square" ng-click="vm.navigateAssetType();" title="Create Asset Type"></i></div></div><div class="form-group" ng-show="vm.assetType.name == \'Chamber\'"><label class="col-md-3 control-label"><span>Buried Chamber</span></label><div class="col-md-8"><label class="switch" style="margin-top: 7px;"><input type="checkbox" style="margin-top: 10px;\r\n                                             margin-left: 15px;" ng-model="vm.asset.burried"> <span class="slider round"></span></label></div></div><div class="form-group" ng-repeat="attribute in vm.asset.assetTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.assetTypeAttribute.name}}</span> <span>- </span><span>{{attribute.assetTypeAttribute.assetAttributeTypes}}</span></label><div class="col-md-7"><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-disabled="(!Roles.NO_OF_DUCT || !Roles.NO_OF_CABLE) && \r\n                                    (attribute.assetTypeAttribute.name == \'No of Duct\' || attribute.assetTypeAttribute.name == \'No of Cable\')"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/" ng-disabled="(!Roles.NO_OF_DUCT || !Roles.NO_OF_CABLE) && \r\n                                    (attribute.assetTypeAttribute.name == \'No of Duct\' || attribute.assetTypeAttribute.name == \'No of Cable\')"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-disabled="(!Roles.NO_OF_DUCT || !Roles.NO_OF_CABLE) && \r\n                                    (attribute.assetTypeAttribute.name == \'No of Duct\' || attribute.assetTypeAttribute.name == \'No of Cable\')"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue == attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select><div ng-if="attribute.assetTypeAttribute.assetTypeImage == true"><input type="file" multiple="multiple" class="filestyle" accept="image/png, image/jpeg, video/mp4" file-style file-change="vm.processAssetAttribFile($files, $index)"> <span ng-if="!vm.assetTypeAtterImageWarning">Supported Attachment Format - PNG, JPG/JPEG, MP4. </span><span id="noData" ng-if="vm.assetTypeAtterImageWarning">Please upload PNG, JPG/JPEG, MP4 format with maximum size of 2.5MB/2560KB. </span><!-- Image Preview --><div ng-if="attribute.assetAttributeImages != null && vm.asset.id" class="mt-2"><div ng-if="attribute.assetAttributeImages.length > 0"><p ng-click="showAllImages(attribute.assetAttributeImages, \'reference\')" style="color: #3c8dbc; cursor: pointer;">Show Images</p></div></div></div></div></div><div class="form-group" ng-repeat="attribute in  vm.assetRefAttributes track by $index"><div><label class="col-md-3 control-label"><span>{{attribute.name}}</span><br></label><div class="col-md-7"><input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'STRING\'" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name != \'STRING\' && attribute.attributeDataType.name != \'FLOAT\' && attribute.attributeDataType.name != \'INTEGER\' && attribute.attributeDataType.name != \'IMAGE\'" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.attributeDataType.name]">{{atttype.value}}</option></select><div><input type="file" ng-model="attribute.attributeValue" file-model="attribute.attributeValue" class="filestyle" ng-if="attribute.attributeDataType.name == \'IMAGE\'" file-style><!-- <img src="data:image/jpeg;base64,{{attribute.image}}" height="50px" width="50px" ng-show="attribute.attributeDataType.name == \'IMAGE\' && attribute.attributeValue != null" ng-click="vm.imageInNewTab(attribute.attributeValue)"/> --><p ng-show="attribute.attributeName != null && attribute.imageId != null" ng-click="newTabDisplay(attribute.imageId,\'reference\')" style="color: #3c8dbc;">Existing Image Name - {{attribute.attributeName}}</p></div><!-- <input type="file" ng-if="attribute.attributeDataType.name == \'IMAGE\'" ng-model="attribute.id"  class="filestyle" id="attribute.id" file-style/>\r\n                                     <button ng-if="attribute.attributeDataType.name == \'IMAGE\'" ng-click="handleFileSelect(attribute.id, attribute)"> ADD</button> \r\n                                   <input type="file" name="file" ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'IMAGE\'" class="filestyle" id="attribute.id" ng-click="vm.referenceImagesClick(attribute.id)"\r\n                                   file-style/> --><!--  \r\n                                    <span ng-if="!vm.referenceWarning">Supported Attachment Format - PNG,JPG/JPEG.</span>\r\n                                    <span id="noData" ng-if="vm.referenceWarning">Please upload PNG,JPG/JPEG format with maximum size of 2.5MB/2560KB</span>  --></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.coordinates">Coordinates</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><div class="input-group"><input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled="disabled" ng-model="vm.asset.assetCoordinates"><!--<span class="input-group-btn" ng-if="vm.asset.id==null">\r\n                                \t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Enter LatLng</button>\r\n                                \t\t\t\t\t\t\t\t   </span>--> <span class="input-group-btn" ng-if="vm.asset.id==null && !vm.isSite"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Select On Map</button> </span><span ng-show="vm.selectAssetCordinates"><span class="help-block span__help-block"><b>*</b>Asset coordinates should not be empty </span></span><span class="input-group-btn" ng-if="vm.asset.id!=null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Edit</button> </span><span class="input-group-btn" ng-if="vm.asset.id!=null"><button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm">Recreate</button></span></div><div id="map_canvas" class="div__map-canvas"></div></div><br><div class="col-md-1"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnMapView()" ng-show="vm.showFilter"><i class="fa fa-filter"></i></button><!-- <button style="color: gray;" type="button" class="btn btn-info btn-flat"\r\n                                    ng-show="vm.canFilter == false">\r\n                                    <i class="fa fa-filter"></i>\r\n                                </button>--></div></div></div><div class="form-group asset_images"><label class="col-md-3 control-label">Images</label><div class="col-md-4"><input type="file" name="file" multiple="multiple" class="filestyle" id="assetImages"> <span ng-if="!vm.imageWarning">Supported Attachment Format - PNG,JPG/JPEG,MP4.</span> <span id="noData" ng-if="vm.imageWarning">Please upload PNG,JPG/JPEG,MP4 format with maximum size of 2.5MB/2560KB</span></div><div class="col-md-1 assetType_showImage"><a class="btn btn-sm btn-primary" ng-click="toggle(\'images\')">Preview</a></div><div class="col-md-2 caseType_showImg" ng-if="vm.asset.id"><a class="btn btn-sm btn-primary" ng-click="toggle(\'existingImg\')"><span ng-hide="vm.showImg">Show Existing Images</span> <span ng-show="vm.showImg">Hide Existing Images</span></a></div></div><div class="form-group" ng-if="allimages"><label class="col-md-3 control-label">Selected Images/Video</label><div class="col-md-6"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                        margin-right: auto;"><tr><th>Image</th><th>Name</th><th>Delete</th></tr><tr ng-repeat="img in vm.asset.assetImages" ng-hide="img.imageType == \'PDF\'"><td><img class="img-responsive img__img-responsive width60" ng-src="data:image/jpeg;base64,{{img.image}}" ng-if="img.imageType != \'MP4\'"><video ng-if="img.imageType == \'MP4\'" class="img-responsive width60" controls><source ng-src="{{\'data:\' + img.imageType + \';base64,\' + img.image}}" type="{{img.imageType}}">Your browser does not support the video tag.</video></td><td>{{img.imageName}}</td><td ng-click="deleteDisplayImage($index)"><span class="fa fa-trash-o" style="color: red"></span></td></tr></table></div><!-- <div class="row">\r\n                            <div class="col-md-8 col-md-offset-3">\r\n                                <div class="col-md-3" ng-repeat="img in vm.asset.assetImages">\r\n                                    <img class="img-responsive img__img-responsive"\r\n                                        ng-src="data:image/jpeg;base64,{{img.image}}" />\r\n                                </div>\r\n                            </div>\r\n                        </div> --></div><div class="form-group" ng-if="vm.showExistingImage"><label class="col-md-3 control-label">List of Existing Images/Videos</label><div class="col-md-6 table-scroll --header-height"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                        margin-right: auto;"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.nameImages"><td ng-show="image.imageName != null && image.imageType != \'PDF\'" ng-click="newTabDisplay(image.imageId,null,image.imageType)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null && image.imageType != \'PDF\'">{{image.imageType}}</td></tr></table></div></div><div class="form-group asset_images"><label class="col-md-3 control-label">Attachments</label><div class="col-md-4"><input type="file" name="file" multiple="multiple" class="filestyle" id="assetAttachment"> <span ng-if="!vm.fileWarning">Supported Attachment Format - PDF.</span> <span id="noData" ng-if="vm.fileWarning">Please upload PDF format with maximum size of 2.5MB/2560KB</span></div><div class="col-md-2 caseType_showImg" ng-if="vm.asset.id"><a class="btn btn-sm btn-primary" ng-click="toggle(\'pdf\')"><span ng-hide="vm.showPdf">Show Attachments</span> <span ng-show="vm.showPdf">Hide Attachments</span></a></div></div><div class="form-group" ng-if="vm.showAttachments"><label class="col-md-3 control-label">List of Existing Attachments</label><div class="col-md-6 table-scroll --header-height"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                        margin-right: auto;"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.nameImages"><td ng-show="image.imageName != null && image.imageType == \'PDF\'" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null && image.imageType == \'PDF\'">{{image.imageType}}</td></tr></table></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="asset"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button onclick="topFunction()" id="myBtn" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm pull-left"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div><script>var mybutton = document.getElementById("myBtn");\r\n\r\n                            // When the user scrolls down 20px from the top of the document, show the button\r\n                            window.onscroll = function () {\r\n                                scrollFunction();\r\n                            };\r\n\r\n                            function scrollFunction() {\r\n                                if (\r\n                                    document.body.scrollTop ||\r\n                                    document.documentElement.scrollTop\r\n                                ) {\r\n                                    mybutton.style.display = "block";\r\n                                } else {\r\n                                    mybutton.style.display = "none";\r\n                                }\r\n                            }\r\n\r\n                            // When the user clicks on the button, scroll to the top of the document\r\n                            function topFunction() {\r\n                                document.body.scrollTop = 0;\r\n                                document.documentElement.scrollTop = 0;\r\n                            }</script></div></form></div></div></div></div><div id="mapFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Assets Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="row div__done"><button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilter()"><span><b>Done</b></span></button></div><span class="span__title">Select Geofence</span><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-import.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i>Import Assets</h3><div class="box-tools ng-scope"><button class="btn btn-create"><span class="fa fa-download"></span> <a id="a__text" href="content/images/SampleAssets.xlsx" download>Sample File</a></button></div></div><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file ng-pattern="vm.importxlsx" accept="*.xlsx||*.xls||*.kml" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel & kml file should be uploaded</p></div></div><div class="form-group"><label class="col-sm-3 control-label">Asset Type</label><div class="col-md-8"><select class="form-control select2" name="assetType" ng-model="vm.importassettype" ng-change="vm.assetTypeSelect()" ng-options="item as item.name for item in vm.assettypes track by item.id" required><option value="">--- Select Asset Type ---</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-route.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-cubes"></i> <span>Assets View</span></h3></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row" style="margin: 5px;"><div class="row"><div class="col-md-2" ng-show="vm.projectList.length > 0" style="text-align: center;"><span style="color: #fd7a24;font-weight: bold;">Project</span></div><div class="col-md-2" ng-show="vm.routeList.length > 0" style="text-align: center;"><span style="color: #fd7a24;font-weight: bold;">Route</span></div><div class="col-md-2" ng-show="vm.stateList.length > 0" style="text-align: center;"><span style="color: #fd7a24;font-weight: bold;">State</span></div><div class="col-md-2" ng-show="vm.districtList.length > 0" style="text-align: center;"><span style="color: #fd7a24;font-weight: bold;">District</span></div><div class="col-md-2" ng-show="vm.blockList.length > 0" style="text-align: center;"><span style="color: #fd7a24;font-weight: bold;">Block</span></div><div class="col-md-2 search-top pull-right" ng-mouseleave="hideAssetList()" ng-show="vm.fixedAssets.length>0"><div class="input-group"><input type="text" ng-model="searchAsset" ng-mouseenter="complete()" ng-keyup="complete()" class="form-control clear" placeholder="Search Assets"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click=""><i class="fa fa-search"></i></button></span></div><ul class="list-group searchList" ng-model="hidethis" ng-hide="hidethis"><li class="list-group-item list-groupBorder" value="{{item}}" ng-repeat="item in vm.fixedAssets | filter : searchAsset" ng-if="item.assetCoordinates.length > 0" ng-click="fillTextbox(item)">{{item.name}}</li></ul></div></div><div class="row"><div class="col-md-2 dropFilter" ng-show="vm.projectList.length > 0"><div isteven-multi-select input-model="vm.projectList" output-model="vm.selectedProjectId" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="vm.projectSelectBtn()" max-height="170px"></div><input type="text" ng-model="vm.selectedProjectId" name="vm.searchProject" style="display:none" required> <span id="noData" ng-if="vm.selectedProjectId.length < 1">*Please Select Project</span></div><div class="col-md-2 dropFilter" ng-show="vm.routeList.length > 0"><div isteven-multi-select input-model="vm.routeList" output-model="vm.selectedRouteIds" button-label="name" item-label="name icon" tick-property="ticked" max-height="236px" on-select-done="vm.routeSelectBtn()" max-labels="1" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedRouteIds" name="vm.searchRoute" style="display:none" required> <span id="noData" ng-if="vm.selectedRouteIds.length < 1">*Please Select Route</span></div><div class="col-md-2 dropFilter" ng-show="vm.stateList.length > 0"><div isteven-multi-select input-model="vm.stateList" output-model="vm.selectedStates" button-label="name" item-label="name icon" tick-property="ticked" max-height="236px" on-item-click="vm.onStateChange()" max-labels="1" selection-mode="single" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedStates" name="vm.searchState" style="display:none"> <span id="noData" ng-if="vm.selectedStates.length < 1">*Please Select State</span></div><div class="col-md-2 dropFilter" ng-show="vm.districtList.length > 0"><div isteven-multi-select input-model="vm.districtList" output-model="vm.selectedDistrict" button-label="name" item-label="name icon" tick-property="ticked" max-height="236px" on-item-click="vm.onDistrictChange()" max-labels="1" selection-mode="single" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedDistrict" name="vm.searchState" style="display:none"> <span id="noData" ng-if="vm.selectedDistrict.length < 1">*Please Select District</span></div><div class="col-md-2 dropFilter" ng-show="vm.blockList.length > 0"><div isteven-multi-select input-model="vm.blockList" output-model="vm.selectedBlock" button-label="name" item-label="name icon" tick-property="ticked" max-height="236px" on-item-click="vm.onBlockChange()" max-labels="1" selection-mode="single" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedBlock" name="vm.searchBlock" style="display:none"> <span id="noData" ng-if="vm.selectedBlock.length < 1">*Please Select Block</span></div></div></div><div class="row"><div id="map_view"></div><div class="col-md-8" id="distance-chart" style="height: 400px;text-align: center;" ng-show="vm.distractChartVisible==true"></div><div class="col-md-8" id="count-chart" style="height: 400px;text-align: center;" ng-show="vm.countChartVisible==true"></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/asset/asset-type-site-report.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-briefcase"></i> <span>Site Asset Reports</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ng-if="has_ROLE_USER_ADMIN"><span class="fa fa-download"></span> <span>Download Excel</span></button></div></div><!-- /.box-header --><!-- form start --></div></div><div class="col-md-3 search-top pull-right"><div class="input-group"><input type="text" ng-model="searchText" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="row div__mt-10"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-body"><div class="table-responsive mt-10"><table class="myTable myTable-zebra myTable-horizontal"><thead class="table-head"><tr class="tr__row"><th style="text-align:center;vertical-align:middle;"><span>Site Code</span></th><th style="text-align:center;vertical-align:middle;"><span>Site Name</span></th><th style="text-align:center;vertical-align:middle;"><span>WDM</span></th><th style="text-align:center;vertical-align:middle;"><span>NTTN</span></th><th style="text-align:center;vertical-align:middle;"><span>Router</span></th><th style="text-align:center;vertical-align:middle;"><span>BackToBack</span></th><th style="text-align:center;vertical-align:middle;"><span>Others</span></th></tr></thead><tbody class="table-body"><tr class="table-row" ng-repeat="asset in vm.multiassets | filter : searchText"><td style="text-align:center;vertical-align:middle; min-width: 120px;width:120px;">{{asset.id}}</td><td style="text-align:center;vertical-align:middle; min-width: 150px;width:150px;">{{asset.name}}</td><td style="text-align:center;vertical-align:middle; min-width: 100px;width:100px;">{{asset.WDM}}</td><td style="text-align:center;vertical-align:middle; min-width: 130px;width:130px;">{{asset.NTTN}}</td><td style="text-align:center;vertical-align:middle; min-width: 120px;width:120px;">{{asset.Router}}</td><td style="text-align:center;vertical-align:middle; min-width: 135px;width:135px;">{{asset.BackToBack}}</td><td style="text-align:center;vertical-align:middle; min-width: 125px;width:125px;">{{asset.Others}}</td><!--\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.WDM > 0) ? true: false}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.NTTN > 0) ? true: false}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.Router > 0) ? true: false}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.BackToBack > 0) ? true: false}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t<td style=\'text-align:center;vertical-align:middle\'>{{(asset.Others > 0) ? true: false}}</td>--></tr></tbody></table></div><div class="row" style="margin:10px;"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div><div class="row"><div id="report" class="col-md-10 col-md-offset-1" style="display: none;"><!-- box content--><div class="box box-solid"><div class="box-header box-info"><button type="button" class="btn btn-info btn-flat pull-right" ng-click="close()">Close</button><h4 class="box-title text-left"><img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'Fiberify\'"> <img ng-src="content/images/newlogo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'Fiberify\'"> <img ng-src="content/images/bharatnet_logo.png" class="img-responsive report-logo" style="height: 30px;" ng-if="vm.appName==\'BSNL\'"></h4></div><button class="btn btn-primary center-block" ng-click="getPdf()">Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button><div class="box-body" ng-if="vm.reportType==\'geofence\'" id="reportpdf"><h4 class="text-center mt-5">Geofence Report for <b>{{vm.detailedReportCounts.name}}</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Incidents</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Services --><div class="box-header"><h3 class="box-title">Services</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><div class="box-header"><h3 class="box-title">Geofence</h3></div><div class="box-body"><div class="row"><div class="col-md-12"><div id="map_canvas" style="height:300px; width:100%;"></div></div></div></div></div></div><div class="box-body" ng-if="vm.reportType==\'agent\'" id="reportpdf"><!-- <div class="box-body" ng-if="vm.reportType==\'agent\'"> --><h4 class="text-center mt-5">Agent Report for <b>{{vm.detailedReportCounts.name}} ({{vm.detailedReportCounts.login}})</b></h4><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Incidents Created by Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesCreatedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Cases --><div class="box-header"><h3 class="box-title">Incidents Assigned to Agent</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">New</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowNew}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Assigned</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowAssigned}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Resolved</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowResolved}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.casesAssignedLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><!-- Services --><div class="box-header"><h3 class="box-title">Services</h3></div><div class="box-body"><div class="col-sm-3 report-data"><h4 class="report-head text-danger">Critical</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesCriticalCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-success">High</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesHighCancelled}}</p></div></div></div><div class="col-sm-3 report-data"><h4 class="report-head text-primary">Medium</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesMediumCancelled}}</p></div></div></div><div class="col-sm-3"><h4 class="report-head text-warning">Low</h4><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Inprogress</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowInprogress}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Pending</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowPending}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Closed</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowClosed}}</p></div></div><div class="row"><div class="col-sm-6 col-xs-6"><p class="report-info">Cancelled</p></div><div class="col-sm-2 col-xs-2"><p class="report-info">:</p></div><div class="col-sm-4 col-xs-4"><p class="report-info">{{vm.detailedReportCounts.counts.servicesLowCancelled}}</p></div></div></div></div></div><div class="box box-solid"><div class="box-header"><h3 class="box-title">Distanc IN</h3>{{vm.detailedReportCounts.distance_in | number:2}} KM<h3 class="box-title">Distanc OUT</h3>{{vm.detailedReportCounts.distance_out | number:2}} KM</div><!-- <div class="box-body">\r\n\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">\r\n\t\t\t\t\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100%;"></div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div></div>');
$templateCache.put('app/entities/asset/assets.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-cubes"></i> <span translate="trakeyeApp.asset.home.title">Assets</span></h3></div><div class="col-md-5 col-sm-3 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(6)}"><a href ng-click="setTab(6); search = null" data-toggle="tab"><i class="fa fa-map"></i><span class="header-view">Block Map</span> <span class="header_view">View</span></a></li><li ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER" ng-class="{active:isSet(3)}"><a href ng-click="setTab(3); search = null" data-toggle="tab"><i class="fa fa-globe"></i><span class="header-view">District Map</span> <span class="header_view">View</span></a></li><!-- <li ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER"\r\n                                ng-class="{active:isSet(4)}">\r\n\r\n                                <a href ng-click="setTab(4); search = null" data-toggle="tab"><i\r\n                                        class="fa fa-globe"></i><span class="header-view">AMC</span> <span\r\n                                        class="header_view">Status</span></a>\r\n                            </li> --></ul></div><div class="box-tools"><button ng-hide="vm.isAssetImport" class="btn btn-create btn-sm" ui-sref="asset.import"><span class="glyphicon glyphicon-plus"></span> <span>Import</span></button> <button ng-if="vm.isAssetImport" class="btn btn-create btn-sm" ui-sref="entity-import.new"><span class="glyphicon glyphicon-plus"></span> <span>Import</span></button> <button class="btn btn-create btn-sm" ng-click="vm.createAsset()"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><!-- <script src="https://unpkg.com/measuretool-googlemaps-v3"></script> --><!-- <script src="https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js"></script> --><jhi-alert></jhi-alert><div class="row"><!-- <div class="col-md-5">\r\n                            <ul class="nav nav-pills nav-justified">\r\n                                <li ng-class="{active:isSet(1)}">\r\n                                    <a href ng-click="setTab(1); search = null" data-toggle="tab">List View</a>\r\n                                </li>\r\n                                <li ng-class="{active:isSet(2)}">\r\n                                    <a href ng-click="setTab(2); search = null" data-toggle="tab">Map View</a>\r\n                                </li>\r\n                                <li ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER"\r\n                                    ng-class="{active:isSet(3)}">\r\n                                    <a href ng-click="setTab(3); search = null" data-toggle="tab">City View</a>\r\n                                </li>\r\n                            </ul>\r\n                        </div>\r\n                        <div class="div--filter pull-right" ng-show="isSet(1)">\r\n                            <button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnListView()">\r\n                                <i class="fa fa-filter"></i>\r\n                            </button>\r\n                        </div> --><div class="col-md-4 pull-left dropFilter" ng-show="isSet(1) && vm.countLength > 0"><div isteven-multi-select input-model="vm.geofencesListView" output-model="vm.selectedGeofence" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceId" name="vm.searchMini" style="display:none" required></div><div class="col-md-3 dropFilter" ng-show="isSet(6)"><div isteven-multi-select input-model="vm.userAllGeofences" output-model="vm.selectedMapGeofence" button-label="name" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" max-height="170px" on-item-click="vm.onGeofenceSelect()"></div><input type="text" ng-model="vm.userSelectedGeofenceId" style="display:none" required> <span id="noData" ng-show="!vm.selectedMapGeofence || vm.selectedMapGeofence.length < 1">*Please Select Block Filter</span></div><div class="col-md-3 dropFilter" ng-show="isSet(6)"><div isteven-multi-select input-model="vm.filterAssetType" output-model="vm.selectedAsset" button-label="name" item-label="name icon" tick-property="ticked" translation="type.assetTypeLabel" max-height="236px" on-select-done="vm.sync()" max-labels="1" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedAsset" name="vm.searchMini" style="display:none" required></div><div class="col-md-3 dropFilter" ng-show="isSet(6) && vm.displayCaseType"><div isteven-multi-select input-model="vm.caseTypes" output-model="vm.selectedCase" button-label="name" item-label="displayName" output-properties="id" tick-property="showInAssetsView" translation="type.caseTypeLabel" max-height="236px" on-select-done="vm.showCases()" max-labels="1" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedCase" name="vm.searchMini" style="display:none" required></div><!-- <div class="col-md-3 dropFilter" ng-show="isSet(2) && !vm.tempLength && vm.selectedMapGeofence.length > 0">\r\n                            <span id="noData">*Incident Types Not Available</span>\r\n                        </div> --><!-- <div class="col-md-2 mt-5" ng-show="isSet(2) && vm.tempLength">\r\n                            <label>\r\n                                <span>Incidents</span>\r\n                            </label>\r\n                            <label class="switch">\r\n                                <input type="checkbox" style="\r\n                                         margin-top: 10px;\r\n                                         margin-left: 15px;\r\n                                     " ng-model="vm.boolCase"\r\n                                     ng-change="vm.showCases()" /> \r\n                                 <span class="slider round"></span>\r\n                            </label>\r\n                        </div> --><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(3)"><select id="masterGeofence" class="select2 form-control" ng-model="vm.masterGeofence"><option value=" ">Select District</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select> <span id="noData" ng-if="vm.userGeofencesCity.length < 1">*Please Select District</span></div><!-- <span id="noData" ng-show="isSet(3) && vm.cityLength">* NO\r\n                            DATA Available in Selected City.</span> --><div class="col-md-3 dropFilter" ng-show="isSet(3) && vm.userGeofencesCity.length > 0"><div isteven-multi-select input-model="vm.userGeofencesCity" output-model="vm.selectedAssetCity" button-label="label" item-label="name" tick-property="ticked" translation="GeofenceCity" on-select-done="vm.saveFilterCity()" max-labels="1" helper-elements="all none Done filter" max-height="170px"></div><input type="text" ng-model="vm.selectedAssetCity" name="vm.searchMini" style="display:none" required></div><!-- <div class="col-md-2 selectAsset_drp div--searchasset pull-right" ng-show="isSet(2) && vm.selectedGeofence.length > 0">\r\n                            <select id="searchAssetsOnMap" class="select2 form-control"\r\n                                name="search">\r\n                                <option value="">Search Asset</option>\r\n                                <option ng-repeat="item in vm.mapAssets" value="{{item}}">\r\n                                    {{item.name}}\r\n                                </option>\r\n                            </select>\r\n                        </div> --><div class="col-md-3 dropFilter" ng-show="isSet(3) && vm.userGeofencesCity.length > 0"><div isteven-multi-select input-model="vm.filterAssetTypesCity" output-model="vm.selectedAssetTypeCity" button-label="name" item-label="name" tick-property="ticked" translation="type.assetTypeLabel" on-open="centerCapture()" on-select-done="vm.saveAssetTypeFilterCity()" max-labels="1" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedAssetTypeCity" name="vm.searchMini" style="display:none" required> <span id="noData" ng-show="vm.filterAssetTypesCity.length < 1">*Asset Types Not Available</span></div><div class="col-md-3 search-top pull-right" ng-mouseleave="hideAssetList()" ng-show="isSet(3) && vm.mapAssetsCity.length>0"><div class="input-group"><input type="text" ng-model="searchAssetCity" ng-mouseenter="complete()" ng-keyup="complete()" class="form-control clear" placeholder="Search Assets"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click=""><i class="fa fa-search"></i></button></span></div><ul class="list-group searchList" ng-model="hidethis" ng-hide="hidethis"><li class="list-group-item list-groupBorder" value="{{item}}" ng-repeat="item in vm.mapAssetsCity | filter : searchAssetCity" ng-click="searchAssetsOnMapCity(item)">{{item.name}}</li></ul></div><!-- <div class="col-md-2 selectAsset_drp div--searchasset"\r\n                            ng-show="isSet(3) && vm.mapAssetsCity.length>0">\r\n                            <select id="searchAssetsOnMapCity" class="select2 form-control" name="search">\r\n                                <option value="">Search Asset</option>\r\n                                <option ng-repeat="item in vm.mapAssetsCity" value="{{item}}">\r\n                                    {{item.name}}\r\n                                </option>\r\n                            </select>\r\n                        </div> --><div class="col-md-3 search-top pull-right" ng-show="isSet(6)"><div class="input-group"><input type="text" ng-model="vm.searchAsset" ng-focus="vm.showAssetList = true" ng-blur="vm.hideAssetListDelayed()" class="form-control clear" placeholder="Search Assets"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div><ul class="list-group searchList" ng-show="vm.showAssetList && (vm.allAssets | filter:vm.searchAsset).length > 0"><li class="list-group-item list-groupBorder" ng-repeat="item in vm.allAssets | filter:vm.searchAsset" ng-click="vm.selectAssetFromSearch(item)">{{item.name}}</li></ul></div><!-- <div class=" ml-10 mt-0 div--filter" ng-show="isSet(2)">\r\n                            <button type="button" value="Layers" class="btn btn-info btn-flat"\r\n                                ng-click="vm.showLayers()">\r\n                                Layers\r\n                            </button>\r\n                        </div> --><!--   <div ng-show="isSet(2)" class="modal-body div__modal-body">\r\n                            <span id="noData" ng-show="vm.filterAssetTypes <= 1">* NO DATA</span>\r\n                            <p ng-repeat="item in vm.filterAssetTypes" class="item"\r\n                                class="p--filterassettypes">\r\n                                <input type="checkbox" ng-init="initial(item)" id="{{item.id}}" ng-change="sync(bool,item)" ng-model="bool" />\r\n                                <label for="{{item.id}}">{{item.name}}</label>\r\n                            </p>\r\n                        </div>  \r\n                          <div class="row div__done" ng-show="isSet(2) && vm.filterAssetTypes.length > 0">\r\n                            <button class="btn btn-info btn-flat button__done" ng-click="vm.saveAssetTypeFilter()">\r\n                                <span><b>Done</b></span>\r\n                            </button>\r\n                        </div>  --><!-- <div class="col-md-1" ng-show="isSet(2)">\r\n                            <button type="button" value="GOTO" class="btn btn-info btn-flat"\r\n                                ng-click="vm.gotoLatitute()">\r\n                                GO TO\r\n                            </button>\r\n                        </div> --><div class="col-md-3 search-top pull-right" ng-show="isSet(1)"><div class="input-group"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3" placeholder="{{\'trakeyeApp.asset.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.getAssetsForListView()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(4)"><select id="masterGeofenceAmc" class="select2 form-control" ng-model="vm.masterGeofenceAmc"><option value=" ">Select District</option><option ng-repeat="item in vm.userMasterGeofencesAmc" value="{{item.id}}">{{item.name}}</option></select> <span id="noData" ng-if="vm.userGeofencesCityAmc.length < 1">*Please Select District</span></div><!-- <span id="noData" ng-show="isSet(3) && vm.cityLength">* NO\r\n                            DATA Available in Selected City.</span> --><div class="col-md-3 dropFilter" ng-show="isSet(4) && vm.userGeofencesCityAmc.length > 0"><div isteven-multi-select input-model="vm.userGeofencesCityAmc" output-model="vm.selectedAssetCityAmc" button-label="label" item-label="name" tick-property="ticked" translation="GeofenceCity" on-select-done="vm.saveFilterCityAmc()" max-labels="1" helper-elements="all none Done filter" max-height="170px"></div><input type="text" ng-model="vm.selectedAssetCityAmc" name="vm.searchMini" style="display:none" required></div><div class="col-md-3 dropFilter" ng-show="isSet(4) && vm.userGeofencesCityAmc.length > 0"><div isteven-multi-select input-model="vm.filterAssetTypesCityAmc" output-model="vm.selectedAssetTypeCityAmc" button-label="name" item-label="name" tick-property="ticked" translation="type.assetTypeLabel" on-open="centerCaptureAmc()" on-select-done="vm.saveAssetTypeFilterCityAmc()" max-labels="1" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedAssetTypeCityAmc" name="vm.searchMini" style="display:none" required> <span id="noData" ng-show="vm.filterAssetTypesCityAmc.length < 1">*Asset Types Not Available</span></div><div class="col-md-3 search-top pull-right" ng-mouseleave="hideAssetList()" ng-show="isSet(4) && vm.mapAssetsCityAmc.length>0"><div class="input-group"><input type="text" ng-model="searchAssetCityAmc" ng-mouseenter="complete()" ng-keyup="complete()" class="form-control clear" placeholder="Search Assets"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click=""><i class="fa fa-search"></i></button></span></div><ul class="list-group searchList" ng-model="hidethis" ng-hide="hidethis"><li class="list-group-item list-groupBorder" value="{{item}}" ng-repeat="item in vm.mapAssetsCityAmc | filter : searchAssetCityAmc" ng-click="searchAssetsOnMapCityAmc(item)">{{item.name}}</li></ul></div><!--  <div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(3)">\r\n                            <select id="masterGeofence" class="select2 form-control" ng-model="vm.masterGeofence">\r\n                                <option value="">Select City</option>\r\n                                <option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">\r\n                                    {{item.name}}\r\n                                </option>\r\n                            </select>\r\n                        </div> --><!-- <div class="col-md-2" ng-show="isSet(2) && vm.health">\r\n                            <label>Health:</label>\r\n                            <input type="checkbox" ng-model="variableHealth" ng-click="check()">\r\n                        </div> --><!-- <div class="col-md-1" ng-show="isSet(3)">\r\n                            <button type="button" value="GOTO" class="btn btn-info btn-flat"\r\n                                ng-click="vm.gotoLatituteCity()">\r\n                                GO TO\r\n                            </button>\r\n                        </div> --><!-- <div class="pull-right ml-10 mt-0 div--filter" ng-show="isSet(2)">\r\n                            <button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnMapView()"\r\n                                >\r\n                                <i class="fa fa-filter"></i>\r\n                            </button>\r\n                            <button type="button" value="Layers" class="btn btn-info btn-flat"\r\n                                ng-click="vm.showLayers()">\r\n                                Layers\r\n                            </button>\r\n                        </div> --><!-- <div class="ml-10 mt-0 div--filter"\r\n                            ng-show="isSet(3)  && vm.selectedMasterGeofenceId>0">\r\n                             <button type="button" class="btn btn-info btn-flat"\r\n                                ng-click="vm.filterAssetsOnMapViewCity()">\r\n                                <i class="fa fa-filter"></i>\r\n                            </button> \r\n                    \r\n                            <button type="button" value="Layers" class="btn btn-info btn-flat"\r\n                                ng-click="vm.showLayersCity()">\r\n                                Layers\r\n                            </button>\r\n                        </div> --><!-- <div class="col-md-5 selectAsset_drp mt-10" ng-show="isSet(2)">\r\n                            <div class="search-bar-align">\r\n                                <select id="searchAssetsOnMap" class="select2 form-control" name="search"\r\n                                    style="width: 220px; height: 40px">\r\n                                    <option value="">Search Asset</option>\r\n                                    <option ng-repeat="item in vm.mapAssets" value="{{item}}">{{item.name}}</option>\r\n                                </select>\r\n                                \r\n                            </div>\r\n                        </div> --></div><div class="ml-5 mt-5" ng-show="isSet(1)"><div class="pull-left" ng-show="vm.showAssetDelete"><button class="btn btn-danger button--showassetdelete" ng-click="vm.confirmDelete()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></div></div><div class="case-table" ng-show="isSet(1)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><input type="checkbox" ng-click="vm.selectAllAssets()" ng-model="vm.isAllAssetSelected"></th><th></th><!--  <th>Id</th> --><th jh-sort-by="name"><span translate="trakeyeApp.asset.name">Name</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="description">\r\n                                        <span translate="trakeyeApp.asset.description">Description</span><span\r\n                                            class="fa fa-sort"></span>\r\n                                    </th> --><th><span>Geofence</span></th><th><span translate="trakeyeApp.asset.assetType">Asset Type</span></th><th>Length (mtrs)</th><th>Accessible</th><th>Buried Chamber</th><th>Graphical Id</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="asset in vm.assetsForListView track by asset.id" ng-class="{selected: asset.isChecked}"><td><input type="checkbox" ng-model="asset.isChecked" ng-change="vm.selectAssetEntity(asset)"></td><td class="td__listViewRow" ng-click="vm.assetMarkerTable(asset);" ng-show="asset.assetTypeLayout==\'SPREAD\'" expand><span ng-if="!asset.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="asset.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td ng-show="asset.assetTypeLayout!=\'SPREAD\'"></td><td><a ui-sref="asset-detail({id:asset.id})">{{asset.name}}</a></td><!-- <td>{{asset.name}}</td> --><!-- <td>{{asset.description}}</td> --><td><div ng-repeat="geofenceVal in asset.geofenceIdNameList"><span style="overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">{{geofenceVal.name}}</span></div></td><td>{{asset.assetTypeName}}</td><td ng-if=\'asset.assetTypeLayout=="FIXED"\'></td><td ng-if=\'asset.assetTypeLayout=="SPREAD"\'>{{(asset.assetLength * 1000).toFixed(2)}}</td><td><label class="switch"><input type="checkbox" style="margin-top: 10px;\r\n                                                margin-left: 15px;" data-toggle="modal" data-target="#myModal" id="{{asset.id}}" ng-checked="asset.accessible" ng-model="asset.accessible" ng-change="accessibleCheckChange(asset)"> <span class="slider round"></span></label></td><td ng-show="asset.assetTypeName == \'Chamber\'"><label class="switch"><input type="checkbox" style="margin-top: 10px;\r\n                                                margin-left: 15px;" data-toggle="modal" data-target="#myModalBuried" id="{{asset.id + \'0\'}}" ng-checked="asset.burried" ng-model="asset.burried" ng-change="vm.onChangeBuried(asset)"> <span class="slider round"></span></label></td><td ng-if=\'asset.assetTypeName != "Chamber"\'></td><td><div ng-repeat="attrData in asset.assetAttributeList"><span ng-if="attrData.attributeName == \'GRAPHICAL ID\'">{{attrData.attributeValue}}</span></div></td><td><div class="action"><!-- <a ng-if ="vm.showAssetImage" class="action-icons text-info" ng-click="vm.imageUpload({id:asset.id})"\r\n                                            title="Upload"><span class="fa fa-upload"></span></a> --> <a ui-sref="asset-detail({id:asset.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span></a> <a ui-sref="asset.edit({id:asset.id})" ng-if="!vm.has_ROLE_READONLY||has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ROLLOUT_ADMIN || has_ROLE_ROLLOUT_INFRA" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ui-sref="asset.delete({id:asset.id})" class="action-icons text-primary" title="Delete" ng-if="!vm.has_ROLE_READONLY||has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ROLLOUT_ADMIN || has_ROLE_ROLLOUT_INFRA"><span class="fa fa-trash-o"></span> </a><a ng-if=\'asset.assetTypeLayout=="SPREAD"\' class="action-icons text-primary" ng-click="vm.assetMarkerUpload({id:asset.id})" title="Upload"><span class="fa fa-upload"></span></a> <a class="action-icons text-primary" ng-click="vm.onNavigate(asset,asset.geofenceIdNameList)" title="Navigate To Map View"><span class="fa fa-map-marker"></span></a></div></td></tr><tr ng-show="asset.isExpanded"><td></td><td colspan="13" ng-show="vm.assetMarkers.length > 0"><table class="table__userNames"><thead><th>SL No.</th><!-- <th>Id</th> --><th>Name</th><th>Marker Type</th><th>Created Date</th><th ng-repeat="header  in vm.assetMarkers[0].assetMarkerTypeAttributeValues">{{header.assetMarkerTypeAttribute.name}}</th></thead><tbody><tr ng-repeat="assetMarkers in vm.assetMarkers"><td>{{assetMarkers.no}}</td><!-- <td>{{assetMarkers.id}}</td> --><td>{{assetMarkers.name}}</td><td>{{assetMarkers.assetMarkerType.name}}</td><td>{{assetMarkers.createDate| date:\'dd/MM/yy h a\'}}</td><td ng-repeat="value in assetMarkers.assetMarkerTypeAttributeValues">{{value.attributeValue}}</td><td><div class="actions" style="width: fit-content;" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a class="action-icons text-info" title="View" ng-click="vm.showAssetMarkerDetails(assetMarkers)"><span class="fa fa-eye"></span> </a><a id="editlink" class="action-icons text-primary" title="Edit" ng-click="vm.editAssetMarker(assetMarkers)"><span class="fa fa-pencil-square"></span> </a><!-- <a id="editlink" \r\n                                                                class="action-icons text-primary"\r\n                                                                title="Delete">\r\n                                                                <span class="fa fa-trash-o"></span>\r\n                                                            </a> --></div></td><td style="width: 20%;"></td></tr></tbody></table></td><td colspan="2" ng-show="vm.assetMarkers.length == 0"><h4>No data available</h4></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.assetsForListView.length == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row row__div--pagination"><div class="col-md-2 pull-left row__div--pagesize"><label for="area">Page size</label> <select name="page_size" id="page_size"><option value="10">10</option><option value="20">20</option><option value="50">50</option></select></div><div class="col-md-3 row__div--showingnoitems"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-2"><label>Go To</label> <input type="text" id="pagenum" oninput="this.value|=0" onkeyup="if(this.value<0){this.value= this.value * -1}" maxlength="4"> <button type="button " ng-click="vm.goToPage()" class="button__goto"><i class="fa fa-caret-right"></i></button></div><div class="col-md-4 pull-right"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><div class="map-view" ng-show="isSet(6) "><div class="row mt-5"><div class="col-md-12"><div id="map_asset" style="height:65vh"></div></div><div class="pull-right" ng-show="isSet(6)"><span id="myspan">Zoom :</span></div><!-- <div class="row mt-3" ng-if="vm.assetLegends.length > 0">\r\n                            <div class="col-md-12">\r\n                                <div class="asset-legend-container">\r\n\r\n                                    <div class="legends-item" ng-repeat="legend in vm.assetLegends">\r\n\r\n                                        <img ng-src="{{legend.coloredIcon}}"\r\n                                            width="22"\r\n                                            height="22" />\r\n\r\n                                        <span>\r\n                                            {{legend.name}}\r\n                                            <small ng-if="legend.status != \'NO-STATUS\'">\r\n                                                ({{legend.status}})\r\n                                            </small>\r\n                                        </span>\r\n\r\n                                    </div>\r\n\r\n                                </div>\r\n                            </div>\r\n                        </div> --></div><div class="legendsAssetType"><div class="flex-item" ng-repeat="item in vm.filterAssetType" ng-show="vm.selectedMapGeofence.length"><img class="square" ng-style="{\'background-color\': item.code}" ng-show="item.layout == \'SPREAD\'"> <img src="{{item.code}}" class="fixedImg" ng-show="item.layout == \'FIXED\'"> {{item.name}}<br></div></div></div><div class="map-view" ng-show="isSet(3)"><div class="row mt-5"><div class="col-md-12"><div id="map_canva" style="height:{{mapHeight}}px;"></div></div><div class="pull-right" ng-show="isSet(3)"><span id="myspanCity">Zoom :</span></div><!-- <div class="row mt-3" ng-if="vm.cityAssetLegends.length > 0">\r\n    <div class="col-md-12">\r\n        <div class="asset-legend-container">\r\n\r\n            <div class="legends-item"\r\n                 ng-repeat="legend in vm.cityAssetLegends">\r\n\r\n                <img ng-src="{{legend.coloredIcon}}"\r\n                     width="22"\r\n                     height="22" />\r\n\r\n                <span>\r\n                    {{legend.name}}\r\n                    <small ng-if="legend.status != \'NO-STATUS\'">\r\n                        ({{legend.status}})\r\n                    </small>\r\n                </span>\r\n\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n</div> --></div></div><div class="map-view" ng-show="isSet(4)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas_amc" style="height:{{mapHeight}}px;"></div></div><div class="pull-right" ng-show="isSet(4)"><span id="myspanCityAmc">Zoom :</span></div></div></div></div></div></div></div><div id="mapFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div ng-show="isSet(2)" class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div ng-show="isSet(3)" class="modal-header"><span class="span__modal-header">Block Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModalCity()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div ng-show="isSet(2)" class="row div__done"><span class="span__title">Select Block</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilter()"><span><b>Done</b></span></button></div></div><div class="col-md-12"><div ng-show="isSet(3)" class="row div__done"><span class="span__title">Select Block</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilterCity()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div ng-show="isSet(2)" class="row"><span id="noData" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div><div ng-show="isSet(3)" class="row"><br><span id="noData" ng-show="vm.userGeofencesCity.length == 0" style="margin-left:25px">* NO DATA</span><div ng-show="vm.userGeofencesCity.length > 0" class="div__list"><input type="checkbox" ng-model="selectAll" ng-change="toggleAll()"> <label class="label__item" for="chk-all">Select All</label></div><br><div class="div__list" ng-repeat="item in vm.userGeofencesCity"><input type="checkbox" ng-model="options[$index]" ng-change="toggleUserGeofences($index)"> <label class="label__item" for="chk-{{item.id}}">{{item.name}}</label></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="assetEditModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetEditName" class="span__modal-header">Asset</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeEditAssetModal()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" style="height: 70vh; overflow-y: auto"><form class="form-horizontal" role="form" style="margin-bottom: 10px"><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.name" for="field_name">Name</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.assetToEdit.name" ng-minlength="2"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Asset Type</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.assetToEdit.assetType.name" ng-minlength="2" disabled="disabled"></div></div><div class="form-group" ng-repeat="attribute in vm.assetToEdit.assetTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.assetTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.assetToEdit.id" type="text" class="form-control" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.assetToEdit.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.assetToEdit.id" type="text" class="form-control" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.assetToEdit.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && !vm.assetToEdit.id" type="text" class="form-control" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && vm.assetToEdit.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.assetToEdit.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.assetToEdit.assetTypeAttributeValues[$index].attributeValue == attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.assetToEdit.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div><div class="form-group" ng-repeat="attribute in  vm.assetRefAttributes track by $index"><div><label class="col-md-3 control-label"><span>{{attribute.name}}</span></label><div class="col-md-7"><input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name == \'STRING\'" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="attribute.attributeValue" ng-if="attribute.attributeDataType.name != \'STRING\' && attribute.attributeDataType.name != \'FLOAT\' && attribute.attributeDataType.name != \'INTEGER\' && attribute.attributeDataType.name != \'IMAGE\'" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.attributeDataType.name]">{{atttype.value}}</option></select><div><input type="file" ng-model="attribute.attributeValue" file-model="attribute.attributeValue" class="filestyle" ng-if="attribute.attributeDataType.name == \'IMAGE\'" file-style><!--  <img src="data:image/jpeg;base64,{{attribute.attributeValue}}" height="50px"\r\n                                        width="50px"\r\n                                        ng-show="attribute.attributeDataType.name == \'IMAGE\' && attribute.attributeValue != null"\r\n                                        ng-click="vm.imageInNewTab(attribute.attributeValue)" /> --><p ng-show="attribute.attributeName != null && attribute.imageId != null" ng-click="newTabDisplay(attribute.imageId,\'reference\')" style="color: #3c8dbc;">Existing Image Name - {{attribute.attributeName}}</p></div></div></div></div></form></div><div class="modal-footer"><div style="margin-left: 120px"><button ng-click="vm.saveEditAssetModal()" id="myBtn" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm pull-left"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default btn-sm pull-left" ng-click="vm.closeEditAssetModal()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="assetMarkerEditModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetMarkerEditName" class="span__modal-header">Edit Asset Marker</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeEditAssetMarkerModal()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" style="height: 70vh; overflow-y: auto"><form class="form-horizontal" role="form" style="margin-bottom: 10px"><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.name" for="field_name">Name</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.markerAssetToEdit.name" ng-minlength="2"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Asset MarkerType</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.markerAssetToEdit.assetMarkerType.name" ng-minlength="2" disabled="disabled"></div></div><div class="form-group" ng-repeat="attribute in vm.markerAssetToEdit.assetMarkerTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.assetMarkerTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.markerAssetToEdit.id" type="text" class="form-control" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue = attribute.assetMarkerTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.markerAssetToEdit.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.markerAssetToEdit.id" type="text" class="form-control" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue = attribute.assetMarkerTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.markerAssetToEdit.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'STRING\' && !vm.markerAssetToEdit.id" type="text" class="form-control" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue = attribute.assetMarkerTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'STRING\' && vm.markerAssetToEdit.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue = attribute.assetMarkerTypeAttribute.defaultValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetMarkerTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetMarkerTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.markerAssetToEdit.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetMarkerTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue" ng-init="vm.markerAssetToEdit.assetMarkerTypeAttributeValues[$index].attributeValue == attribute.assetMarkerTypeAttribute.defaultValue" ng-if="attribute.assetMarkerTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetMarkerTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetMarkerTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.markerAssetToEdit.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetMarkerTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></form></div><div class="modal-footer"><div style="margin-left: 120px"><button ng-click="vm.saveEditMarkerAssetModal()" id="myBtn" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm pull-left"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default btn-sm pull-left" ng-click="vm.closeEditAssetMarkerModal()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="assetMarkerViewModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetMarkerViewName" class="span__modal-header">Asset Marker Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeViewAssetMarkerModal()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" style="height: 70vh; overflow-y: auto"><form class="form-horizontal" role="form" style="margin-bottom: 10px"><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.asset.name" for="field_name">Name</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.markerAssetToView.name" ng-minlength="2"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Asset MarkerType</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.markerAssetToView.assetMarkerType.name" ng-minlength="2" disabled="disabled"></div></div><div class="form-group table-scroll box-body"><div class="col-md-3"></div><div class="col-md-7"><dl ng-repeat="item in vm.markerAssetToView.assetMarkerTypeAttributeValues"><dt><span><b>{{item.assetMarkerTypeAttribute.name}}</b></span></dt><dd><span>{{item.attributeValue}}</span></dd></dl></div></div></form></div><div class="modal-footer"><div style="margin-left: 120px"><button type="button" class="btn btn-default btn-sm pull-left" ng-click="vm.closeViewAssetMarkerModal()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="listFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeListFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence for List</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveListFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.countLength == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.geofencesListView"><input type="radio" id="{{item.id}}" ng-model="vm.selectedListGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="listFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Asset Type Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeListFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="row div__done"><button class="btn btn-info btn-flat button__done" ng-click="vm.saveListFilter()"><span><b>Done</b></span></button></div><span class="span__title">Select Geofence for List</span><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.geofencesListView.length <= 1">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.geofencesListView"><input type="radio" id="{{item.id}}" ng-model="vm.selectedListGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label--geofencelistview">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form ng-show="isSet(2) || isSet(3)" name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.showZoomLocation()" show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label"><span translate=" ">Enter the co-ordinates :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLat" id="field_pinLat" ng-model="vm.getLocationCoordinate" required></div></div><!--  <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span translate=" ">Longitude :</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                        </label>\r\n                        <div class="col-md-8">\r\n                            <input type="number" class="form-control" placeholder="enter the co-ordinates" name="pinLat" id="field_pinLat"\r\n                                ng-model="vm.pinLatLong" required />\r\n                        </div>\r\n                    </div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">OK</button></div></form><!-- <form ng-show="isSet(3)" name="editForm" role="form" class="form-horizontal" novalidate\r\n                ng-submit="vm.showZoomLocationCity()" show-validation>\r\n                <div class="modal-body">\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span translate=" ">Pin Lat</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                        </label>\r\n                        <div class="col-md-8">\r\n                            <input type="number" class="form-control" name="pinLat" id="field_pinLat"\r\n                                ng-model="vm.pinLatitude" required />\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span translate=" ">Pin Long</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                        </label>\r\n                        <div class="col-md-8">\r\n                            <input type="number" class="form-control" name="pinLat" id="field_pinLat"\r\n                                ng-model="vm.pinLatLong" required />\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="modal-footer">\r\n                    <button type="button" class="btn btn-default" data-dismiss="modal"\r\n                        ng-click="vm.closeGotoLatituteCity()">\r\n                        Cancel\r\n                    </button>\r\n                    <button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">\r\n                        OK\r\n                    </button>\r\n                </div>\r\n            </form> --></div></div></div><div id="modalAssetAttributes" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameAssetAttributes" class="span__modal-header">Asset Attributes</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeAssetAttributesModal()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body" style="overflow-y: scroll;height: 80vh"><div id="assetAttributeTable"></div></div></form></div></div></div><div id="modalThreePointReference" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameThreePointReference" class="span__modal-header">3 Point Reference</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeThreePointReference()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body"><div id="threePointReferenceTable"></div><!-- <table class="jh-table table table-responsive table-hover" \r\n                    style="margin-left: auto;\r\n                    margin-right: auto;">\r\n                        <tr>\r\n                            <th ng-repeat="img in vm.referenceAttribute">Image</th>\r\n                        </tr>\r\n                        <tr ng-repeat="img in vm.referenceAttribute">\r\n                            <td>\r\n                                <img class="img-responsive img__img-responsive width60"\r\n                                ng-src="data:image/jpeg;base64,{{img.image}}"  />\r\n                            </td>\r\n                            <td>\r\n                                {{img.imageName}}\r\n                            </td>\r\n                            <td  ng-click="deleteDisplayImage($index)">\r\n                                <span class="fa fa-trash-o" style="\r\n                                color: red"></span>\r\n                            </td>\r\n                        </tr>\r\n                    </table> --></div></form></div></div></div><div id="modalLayer" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Filter By Asset Type</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeLayers()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div ng-show="isSet(2)" class="modal-body div__modal-body"><span id="noData" ng-show="vm.filterAssetTypes <= 1">* NO DATA</span><p ng-repeat="item in vm.filterAssetTypes" class="item" class="p--filterassettypes"><input type="checkbox" ng-init="initial(item)" id="{{item.id}}" ng-change="sync(bool,item)" ng-model="bool"> <label for="{{item.id}}">{{item.name}}</label></p></div><div ng-show="isSet(3)" class="modal-body div__modal-body"><span id="noData" ng-show="vm.filterAssetTypesCity <= 1">* NO DATA</span><p ng-repeat="item in vm.filterAssetTypesCity" class="item" class="p--filterassettypes"><input type="checkbox" ng-model="item.isChecked" id="{{item.id}}"> <label for="{{item.id}}">{{item.name}}</label></p></div><div class="row div__done" ng-show="isSet(2) && vm.filterAssetTypes.length > 0"><button class="btn btn-info btn-flat button__done" ng-click="vm.saveAssetTypeFilter()"><span><b>Done</b></span></button></div><div class="row div__done" ng-show="isSet(3) && vm.filterAssetTypesCity.length > 0"><button class="btn btn-info btn-flat button__done" ng-click="vm.saveAssetTypeFilterCity()"><span><b>Done</b></span></button></div></form></div></div></div><div class="modal fade" id="modalAttachment" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'modalAttachment\')"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Attachments - {{vm.assetTitle}}</span></div><form name="editForm" class="form-horizontal"><div class="modal-body" style="overflow-y: scroll;overflow-x: hidden;height: 40vh"><div class="form-group asset_images" ng-show="vm.showAssetImage"><label class="col-md-3 control-label">Attachments</label><div class="col-md-6 mb-5"><input type="file" name="file" multiple="multiple" class="filestyle" id="assetImages"> <span ng-if="!vm.fileWarning">Supported Attachment Format - PNG,JPG/JPEG,PDF.</span> <span id="noData" ng-if="vm.fileWarning">Please upload PNG,JPG/JPEG,PDF format with maximum size of 2.5MB/2560KB</span></div><div class="col-md-2 assetType_showImage"><a class="btn btn-sm btn-primary" ng-click="toggle()"><span><i class="fa fa-plus"></i></span> Add</a></div></div><div class="form-group" ng-show="allimages && vm.assetAttachments.assetImages.length > 0"><label class="col-md-3 control-label">Selected Attachments</label><div class="col-md-7"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                            margin-right: auto;"><tr><th>Thumbnail</th><th>Name</th><th>Delete</th></tr><tr ng-repeat="img in vm.assetAttachments.assetImages"><td><img class="img-responsive img__img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" width="50" height="50" ng-show="img.imageType != \'PDF\'"> <i class="fa fa-file-pdf-o pdf-icon" ng-show="img.imageType == \'PDF\'"></i></td><td>{{img.imageName}}</td><td ng-click="deleteDisplayImage($index)"><span class="fa fa-trash-o" style="color: red"></span></td></tr></table></div></div><div class="form-group"><label class="col-md-3 control-label">List of Existing Attachments</label><div class="col-md-6 mt-5"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                                margin-right: auto;"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.nameImages"><td ng-show="image.imageName != null" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null">{{image.imageType}}</td></tr></table></div></div></div><div class="modal-footer"><div class="col-md-4 col-md-offset-3 save-buttons pull-right"><button type="button" class="btn btn-default btn-sm" ng-click="vm.closeModal(\'modalAttachment\')"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button> <button class="btn btn-primary btn-sm pull-left" ng-show="vm.showAssetImage" ng-click="vm.saveAttachments()"><span class="fa fa-upload"></span>&nbsp;<span>Upload</span></button></div></div></form></div></div></div><div class="modal fade" id="myModalUpload" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeImageUpload()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Upload Attachment</span></div><div class="modal-body"><div class="form-group asset_images"><label class="col-md-3 control-label">Attachments</label><div class="col-md-8"><input type="file" name="file" class="filestyle" id="assetImages"> <span ng-if="!vm.fileWarning">Supported Attachment Format - PNG,JPG/JPEG,PDF.</span> <span id="noData" ng-if="vm.fileWarning">Please upload PNG,JPG/JPEG,PDF format.</span></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.saveImage()" class="btn btn-primary btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-save"></i> Save</button> <button type="button" ng-click="vm.closeImageUpload()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button></div></div></div></div><div class="modal fade" id="successImage" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="col-lg-12 col-sm-12 col-xs-12 alert alert-success"><strong>Upload Successfull</strong></div></div></div></div><div class="modal fade" id="errorImage" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="col-lg-12 col-sm-12 col-xs-12 alert alert-danger"><strong>Error</strong></div></div></div></div><div class="modal fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" id="close-button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Change Asset Status</span></div><div class="modal-body">Are you sure you want to change Asset Status to {{vm.changeAcessibleStatus}}?</div><div class="modal-footer"><button type="button" id="remove-button" class="btn btn-default" data-dismiss="modal">No</button> <button type="button" id="yes-button" class="btn btn-primary" data-dismiss="modal">Yes</button></div></div></div></div><div class="modal fade" id="deleteAsset" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute(\'deleteAsset\')"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body">Are you sure you want to delete Asset?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.closeGotoLatitute(\'deleteAsset\')" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-danger" ng-click="vm.selectAsets()" data-dismiss="modal"><span class="glyphicon glyphicon-remove-circle"></span> <span translate="entity.action.delete">Delete</span></button></div></div></div></div><div class="modal fade" id="myModalMap" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" id="closeButton" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Change Asset Status</span></div><div class="modal-body">Are you sure you want to change <b>{{vm.assetTitle}}</b> Status to {{vm.changeAcessible}}?</div><div class="modal-footer"><button type="button" id="noButton" class="btn btn-default" data-dismiss="modal">No</button> <button type="button" id="yesButton" class="btn btn-primary" data-dismiss="modal">Yes</button></div></div></div></div><div class="modal fade" id="myModalBuried" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" id="closeButtonBurried" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'myModalBuried\')"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Change Asset Status</span></div><div class="modal-body">Are you sure you want to change <b>{{vm.assetTitle}}</b> Buried Status?</div><div class="modal-footer"><button type="button" id="noButtonBurried" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'myModalBuried\')">No</button> <button type="button" id="yesButtonBurried" class="btn btn-primary" data-dismiss="modal">Yes</button></div></div></div></div><div class="modal fade" id="markerUploadModal" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeAssetMarkerModal()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Upload Asset Markers</span></div><div class="modal-body"><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.uploadAssetMarker()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file ng-pattern="vm.importxlsx" accept="*.csv" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel & kml file should be uploaded</p></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.closeAssetMarkerModal()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button> <button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></form></div></div></div></div>');
$templateCache.put('app/entities/asset-type/asset-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.assetType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.assetType.delete.question" translate-values="{id: \'{{vm.assetType.id}}\'}">Are you sure you want to delete this Asset Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/asset-type/asset-type-detail.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate="trakeyeApp.assetType.detail.title">Asset Type</span> - {{vm.assetType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.assetType.name">Name</span></dt><dd><span>{{vm.assetType.name}}</span></dd><dt><span translate="trakeyeApp.assetType.description">Description</span></dt><dd><span>{{vm.assetType.description}}</span></dd><dt><span translate="trakeyeApp.assetType.layout">Layout</span></dt><dd><span translate="{{\'trakeyeApp.Layout.\' + vm.assetType.layout}}">{{vm.assetType.layout}}</span></dd><dt><span>Asset Visibility</span></dt><dd><span>{{vm.assetType.zoomLevel}}</span></dd><!-- <dt ng-show="vm.assetType.layout == \'FIXED\'"><span>Asset Label Visibility</span></dt>\r\n\t\t\t\t\t\t\t<dd ng-show="vm.assetType.layout == \'FIXED\'">\r\n\t\t\t\t\t\t\t\t<span>{{vm.assetType.zoomLevelLabel}}</span>\r\n\t\t\t\t\t\t\t</dd> --><dt ng-show="{{vm.assetType.colorcode != null}}"><span translate="trakeyeApp.assetType.colorcode">Colorcode</span></dt><dd ng-show="{{vm.assetType.colorcode != null}}"><span><div class="square" style="background-color: {{vm.assetType.colorcode}}"></div></span></dd><dt ng-show="{{vm.assetType.image != null}}"><span translate="trakeyeApp.assetType.assetimage">Asset Image</span></dt><dd ng-show="{{vm.assetType.image != null}}"><div class="col-md-3"><img class="img-responsive img__assetImage" ng-src="data:image/jpeg;base64,{{vm.assetType.image}}"></div></dd><dt><span translate="trakeyeApp.assetType.createDate">Create Date</span></dt><dd><span>{{vm.assetType.createDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.assetType.updateDate">Update Date</span></dt><dd><span>{{vm.assetType.updateDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.assetType.user">User</span></dt><dd><span>{{vm.assetType.createdBy}}</span></dd><div class="form-group div__attribute" ng-repeat="item in vm.assetType.assetTypeAttributes"><dt><span>Non-Reference Attribute</span><span> {{$index + 1}}</span></dt><div class="col-md-6"><span>{{item.name}}</span><span class="span__attribute">{{item.defaultValue}}</span></div></div><div class="form-group div__attribute" ng-repeat="item in  vm.referenceAttribute"><dt><span>Reference Attribute</span><span> {{$index + 1}}</span></dt><div class="col-md-6"><span>{{item.name}}</span><span class="span__attribute">{{item.defaultValue}}</span></div></div></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="asset-type-detail.edit({id:vm.assetType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/asset-type/asset-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.assetType.id" translate="trakeyeApp.assetType.home.create">Create</span> <span ng-if="vm.assetType.id" translate="trakeyeApp.assetType.home.edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group" ng-show="vm.assetType.id">\r\n\t\t\t\t\t            <label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label>\r\n\t\t\t\t\t            <div class="col-md-7">\r\n\t\t\t\t\t            \t<input type="text" class="form-control" id="id" name="id"\r\n\t\t\t\t\t                    ng-model="vm.assetType.id" readonly />\r\n\t\t\t\t\t            </div>\r\n\t\t\t\t\t            \t\r\n\t\t\t\t\t        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.assetType.name" for="field_name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><input type="text" id="xyz" class="form-control" name="name" id="field_name" ng-model="vm.assetType.name" required ng-minlength="2" ng-maxlength="50" ng-disabled="vm.assetType.id!=null"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.assetType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.assetType.description"></textarea></div></div><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.assetType.layout" for="field_layout">Layout</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9" ng-show="vm.assetType.layout == null"><select class="form-control" name="layout" ng-model="vm.assetType.layout" id="field_layout" required><option value="FIXED" translate="trakeyeApp.assetType.Layout.FIXED">FIXED</option><option value="SPREAD" translate="trakeyeApp.assetType.Layout.SPREAD">SPREAD</option></select></div><div class="col-md-9" ng-show="vm.assetType.layout != null"><select class="form-control" name="layout" ng-model="vm.assetType.layout" id="field_layout" ng-disabled="vm.assetType.layout != null"><option value="FIXED" translate="trakeyeApp.assetType.Layout.FIXED">FIXED</option><option value="SPREAD" translate="trakeyeApp.assetType.Layout.SPREAD">SPREAD</option></select></div></div><div class="form-group" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="col-md-2 control-label" translate="trakeyeApp.assetType.selectcolor" for="field_description">Select Color</label><div class="col-md-9"><div class="square--CYAN square" ng-click="vm.colorcode(\'CYAN\')"></div>&nbsp;&nbsp;<div class="square--BLACK square" ng-click="vm.colorcode(\'BLACK\')"></div>&nbsp;&nbsp;<div class="square--BLUE square" ng-click="vm.colorcode(\'BLUE\')"></div>&nbsp;&nbsp;<div class="square--BLUEVIOLET square" ng-click="vm.colorcode(\'BLUEVIOLET\')"></div>&nbsp;&nbsp;<div class="square--BROWN square" ng-click="vm.colorcode(\'BROWN\')"></div>&nbsp;&nbsp;<div class="square--CHARTREUSE square" ng-click="vm.colorcode(\'CHARTREUSE\')"></div>&nbsp;&nbsp;<div class="square--CRIMSON square" ng-click="vm.colorcode(\'CRIMSON\')"></div>&nbsp;&nbsp;<div class="square--YELLOW square" ng-click="vm.colorcode(\'YELLOW\')"></div>&nbsp;&nbsp;<div class="square--MAGENTA square" ng-click="vm.colorcode(\'MAGENTA\')"></div>&nbsp;&nbsp;<div class="square--DEEPPINK square" ng-click="vm.colorcode(\'DEEPPINK\')"></div>&nbsp;&nbsp;<div class="square--LIGHTCORAL square" ng-click="vm.colorcode(\'LIGHTCORAL\')"></div>&nbsp;&nbsp;<div class="square--DARKORANGE square" ng-click="vm.colorcode(\'DARKORANGE\')"></div></div></div><div class="form-group" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="col-md-2 control-label"><span translate="trakeyeApp.assetType.colorcode" for="field_colorcode">Colorcode</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><input type="text" class="form-control" name="colorcode" id="field_colorcode" ng-model="vm.assetType.colorcode" readonly="readonly" required></div></div><div class="form-group"><label class="col-md-2 control-label"><span>ROLE</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><div isteven-multi-select input-model="vm.multiAuthorities" output-model="vm.authorities" button-label="name" item-label="name" tick-property="ticked" helper-elements="all none" output-properties="name selected"></div><input type="text" ng-model="vm.authorities" name="fence" id="input__none" required></div></div><div class="form-group" ng-if="vm.assetType.layout==\'FIXED\'"><label class="col-md-2 control-label"><span>Cluster</span></label><div class="col-md-9"><label class="switch" style="margin-top: 7px;"><input type="checkbox" style="margin-top: 10px;\r\n                                             margin-left: 15px;" ng-model="vm.assetType.isSeniorElement"> <span class="slider round"></span></label></div></div><div class="form-group" ng-hide="vm.assetType.isSeniorElement"><label class="col-md-2 control-label">Zoom Level</label> <select class="col-md-1" id="zoomlevel" ng-show="vm.assetType.layout==\'SPREAD\'"><!-- <option>10</option>\r\n\t\t\t\t\t\t\t\t<option>11</option> --><!-- <option>08</option>\r\n\t\t\t\t\t\t\t\t<option>09</option>\r\n\t\t\t\t\t\t\t\t<option>10</option>\r\n\t\t\t\t\t\t\t\t<option>11</option> --><option>12</option><option>13</option><option>14</option></select> <select class="col-md-1" id="zoomlevelFixed" ng-show="vm.assetType.layout==\'FIXED\'"><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option></select></div><!-- <div class="form-group" ng-show="vm.assetType.layout==\'FIXED\'">\r\n                            <label class="col-md-2  control-label">Asset Label Visibility</label>\r\n\t\t\t\t\t\t\t<select class="col-md-1"  id="zoomlevelLabel" >\r\n\t\t\t\t\t\t\t\t<option>18</option>\r\n\t\t\t\t\t\t\t\t<option>19</option>\r\n\t\t\t\t\t\t\t\t<option>20</option>\r\n\t\t\t\t\t\t\t</select>\r\n                        </div> --><div class="form-group" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="col-md-2 control-label">Link Width</label> <select class="col-md-1" id="lineWidth"><option>20</option><option>40</option><option>60</option><option>80</option><option>100</option><option>120</option><option>140</option><option>160</option><option>180</option><option>200</option><option>220</option><option>240</option><option>260</option><option>280</option><option>300</option><option>320</option><option>340</option><option>360</option><option>380</option><option>400</option></select></div><div class="form-group" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="col-md-2 control-label">Opacity</label> <select class="col-md-1" id="transparency"><option>20</option><option>40</option><option>60</option><option>80</option><option>100</option></select></div><div class="form-group" ng-show="vm.assetType.layout==\'FIXED\'"><label class="col-md-2 control-label"><span translate="trakeyeApp.assetType.assetimage" for="field_assetimage">Asset Image</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="assetImage" id="assetImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.assetType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 assetType_showImage" ng-if="vm.assetType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-3"><!-- <img class="img-responsive " ng-src="data:image/jpeg;base64,{{vm.assetType.image}}" style="padding-bottom: 10px; width:55px; height:55px; margin-left:250px;"> --> <img class="img-responsive img__showImage" ng-src="{{assetType.imagePath}}"></div></div></div><!--  <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.assetType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-7">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t<div class="col-md-2 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t               </div> --><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t       \r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.assetType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.assetType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType"  class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in attributetypes">{{atttype }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.assetType.defaultValue">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input  type="number" ng-if="item.dataType == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.defaultValue">\r\n\t\t\t\t\t\t\t\t<input  ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input  ng-if="item.dataType == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input  ng-if="item.dataType == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.defaultValue"  required  >\r\n\t\t\t\t\t\t\t\t<p ng-if="item.dataType == \'float\'" class="help-block"\r\n\t\t\t\t\t\t\t\t   ng-show="editForm.types.$error.pattern">\r\n\t\t\t\t\t\t\t\t\tInvalid.\r\n\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t    <select ng-model="item.defaultValue"  ng-if="item.dataType == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t --><div class="form-group caseType_repeat"><br><div class="container"><div class="row text-center"><label class="col-md-10 col-sm-3 mb-5"><span><u>Non-Reference</u></span></label></div><div class="row"><label class="col-md-2 col-sm-3"><span translate="trakeyeApp.assetType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2 col-sm-3"><span translate="trakeyeApp.assetType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2 col-sm-2"><span translate="trakeyeApp.assetType.defaultValue">Default Value</span></label> <label class="col-md-2 col-sm-2"><span>Attribute Type</span></label> <label class="col-md-1 col-sm-1" ng-if="vm.assetType.layout==\'SPREAD\'"><span>Popup Display</span></label><!-- <label class="col-md-1  col-sm-1 ">\r\n\t\t\t\t\t\t\t\t\t\t<span>List View Display</span>\r\n\t\t\t\t\t\t\t\t\t</label> --> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <button type="button" class="btn btn-xs btn-primary add-more" ng-hide="vm.items.length > 0" ng-click="vm.addNonReferenceAttribute($index)"><i class="fa fa-plus"></i></button> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Attach image</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div><br><div class="row" ng-repeat="item in vm.items"><div class="col-md-2 col-sm-3"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><div class="col-md-2 col-sm-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customAssetTypeAttributes track by item.id"></select></div><div class="col-md-2 col-sm-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue"> <select ng-model="item.defaultValue" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-2 col-sm-2"><select ng-model="item.assetAttributeTypes" class="form-control"><option value="NON_REFERENCE">NON_REFERENCE</option><option value="THREE_PNT_REFERENCE">THREE_PNT_REFERENCE</option><option value="OFC_LAYER">OFC_LAYER</option><option value="SPAN_LAYER">SPAN_LAYER</option></select></div><div class="col-md-1 col-sm-1" ng-if="vm.assetType.layout==\'SPREAD\'"><label class="switch"><input type="checkbox" style="margin-top: 10px;\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t margin-left: 15px;" ng-model="item.assetTypePopupDisplay"> <span class="slider round"></span></label></div><!-- <div class="col-md-1 col-sm-1">\r\n\t\t\t\t\t\t\t\t\t\t<label class="switch">\r\n\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" style="\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t margin-top: 10px;\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t margin-left: 15px;\r\n\t\t\t\t\t\t\t\t\t\t\t\t " \r\n\t\t\t\t\t\t\t\t\t\t\t\t \r\n\t\t\t\t\t\t\t\t\t\t\t\t ng-model="item.assetTypeListViewDisplay"\r\n\t\t\t\t\t\t\t\t\t\t\t\t  /> \r\n\t\t\t\t\t\t\t\t\t\t\t <span class="slider round"></span>\r\n\t\t\t\t\t\t\t\t\t\t\t </label>\r\n\t\t\t\t\t\t\t\t\t</div> --><div class="col-md-1"><input type="text" class="form-control" ng-model="item.assetTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-1"><select ng-model="item.assetTypeImage" ng-options="value.value as value.label for value in [{label:\'Yes\', value:true}, {label:\'No\', value:false}]"><option value="">Select</option></select></div><div class="col-md-1 col-sm-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div></div></div><hr><div class="form-group caseType_repeat" ng-if="vm.assetType.layout==\'FIXED\'"><br><div class="container"><div class="row text-center"><label class="col-md-10 col-sm-3 mb-5"><span><u>Reference</u></span></label></div><div class="row"><label class="col-md-2 col-sm-3"><span translate="trakeyeApp.assetType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2 col-sm-3"><span translate="trakeyeApp.assetType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2 col-sm-2"><span translate="trakeyeApp.assetType.defaultValue">Default Value</span></label><!-- <label class="col-md-2  col-sm-2 ">\r\n\t\t\t\t\t\t\t\t\t\t<span>Attribute Type</span>\r\n\t\t\t\t\t\t\t\t\t</label> --><!-- <label class="col-md-1  col-sm-1 " ng-if="vm.assetType.layout==\'SPREAD\'">\r\n\t\t\t\t\t\t\t\t\t\t<span>Popup Display</span>\r\n\t\t\t\t\t\t\t\t\t</label> --> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <button type="button" class="btn btn-xs btn-primary add-more" ng-hide="vm.referenceAttribute.length > 0" ng-click="vm.addNewReferenceAttribute($index)"><i class="fa fa-plus"></i></button></div><br><div class="row" ng-repeat="item in vm.referenceAttribute"><div class="col-md-2 col-sm-3"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><div class="col-md-2 col-sm-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customAssetTypeAttributes track by item.id"></select></div><div class="col-md-2 col-sm-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue"> <select ng-model="item.defaultValue" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1" ng-if="( $index + 1) % 3 === 0"><!-- 1039 change % 2 to % 3--> <input type="text" class="form-control" ng-model="item.assetTypeRfrncAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><div class="col-md-1 col-sm-1" ng-if="( $index + 1) % 3 === 0"><!-- 1039 change % 2 to % 3--> <button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addReferenceAttribute($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="removeRow($index)" ng-disabled="vm.referenceAttribute.length <= 3"><i class="fa fa-minus"></i></button></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="asset-type"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/asset-type/asset-types.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-suitcase"></i> <span translate="trakeyeApp.assetType.home.title">Asset Types</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ng-click="vm.navigateCreateAssetType();"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.assetType.home.createLabel">Create new Asset Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.assetType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span> \r\n\t\t\t\t\t\t\t\t\t\t<span class="fa fa-sort"></span></th>--><th jh-sort-by="name"><span translate="trakeyeApp.assetType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.assetType.description">Description</span><span class="fa fa-sort"></span></th><th jh-sort-by="layout"><span translate="trakeyeApp.assetType.layout">Layout</span><span class="fa fa-sort"></span></th><th jh-sort-by="colorcode"><span translate="trakeyeApp.assetType.colorcode">Colorcode</span><span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.assetType.assetimage">Asset Image</span></th><!-- <th><span translate="trakeyeApp.assetType.createDate">Create Date</span><span class="fa fa-sort"></span></th>\r\n\t\t\t\t\t\t\t\t\t<th><span translate="trakeyeApp.assetType.updateDate">Update Date</span><span class="fa fa-sort"></span></th> --><th><span translate="trakeyeApp.assetType.user">User</span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="assetType in vm.assetTypes track by assetType.id "><!-- <td><a ui-sref="asset-type-detail({id:assetType.id})">{{assetType.id}}</a></td> --><td>{{assetType.name}}</td><td>{{assetType.description}}</td><td translate="{{\'trakeyeApp.Layout.\' + assetType.layout}}">{{assetType.layout}}</td><!-- <td>{{assetType.colorcode}}</td>  --><td><div class="square" style="background-color: {{assetType.colorcode}}"></div></td><!-- <td> --><!-- <img ng-src={{assetType.assetImage}} style="width: 15px; height: 25px;" ng-show="{{assetType.assetImage != null}}"/> --><td><!-- <img ng-src={{assetType.assetImage}} style="width: 15px; height: 25px;" ng-show="{{assetType.assetImage != null}}"/> --><!-- <div class="col-md-9"\r\n\t\t\t\t\t\t\t\t\t\t\tng-show="{{assetType.imagePath != null}}">\r\n\t\t\t\t\t\t\t\t\t\t\t<img class="img-responsive"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-src="data:image/jpeg;base64,{{assetType.imagePath}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\tstyle="width: 40px; height: 40px;">\r\n\t\t\t\t\t\t\t\t\t\t</div> --><div class="col-md-9" ng-show="{{assetType.imagePath != null}}"><img class="img-responsive img__assetImage" ng-src="{{assetType.imagePath}}"></div><!--  <img class="img-responsive" ng-src="{{assetType.imagePath}}" style="padding-bottom: 10px;">--></td><!-- <td>{{assetType.createDate| date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{assetType.updateDate| date:\'medium\'}}</td> --><td>{{assetType.createdBy}}</td><td><div class="action"><a ui-sref="asset-type-detail({id:assetType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="asset-type.edit({id:assetType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><!--<a ui-sref="asset-type.delete({id:assetType.id})"\r\n\t\t\t\t\t\t\t\t\t\t\t\tclass="action-icons text-primary" title="Edit">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="fa fa-trash"></span> \r\n\t\t\t\t\t\t\t\t\t\t\t</a>--></div></td></tr><tr><td colspan="10" ng-show="vm.assetTypes == 0" class="td__noDataAvailable"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/attributeMapping/attribute-mapping-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Attribute Mapping ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/attributeMapping/attribute-mapping-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomCaseTypeAttributeLabel"><span ng-if="!vm.customCaseTypeAttribute.id">Create a new Attribute Mapping</span><!-- <span ng-if="vm.customCaseTypeAttribute.id">Edit</span> --></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span>Select Parent Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-4 dropFilter"><div isteven-multi-select input-model="vm.category" output-model="vm.selectedCategoryLeft" button-label="name" item-label="name" output-properties="id name customCaseTypeAttributeValues" tick-property="ticked" on-item-click="funcCategoryLeft()" disable-property="disabledLeft" max-height="236px" selection-mode="single" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedCategoryLeft" name="vm.searchMini" style="display:none" required></div><div ng-show="vm.selectedCategoryLeft.length > 0"><label class="col-md-2 control-label"><span>Select Parent Sub-Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-4 dropFilter"><div isteven-multi-select input-model="vm.category" output-model="vm.selectedCategoryRight" button-label="name" item-label="name" output-properties="id name customCaseTypeAttributeValues" tick-property="selected" on-item-click="funcCategoryRight()" max-height="236px" selection-mode="single" helper-elements="all none Done filter" disable-property="disabledRight"></div><input type="text" ng-model="vm.selectedCategoryRight" name="vm.searchMini" style="display:none" required></div></div></div><div class="form-group" ng-show="vm.selectedCategoryLeft.length > 0 && vm.selectedCategoryRight.length > 0"><label class="col-md-2 control-label"><span>Select Incident-Type Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-4 dropFilter"><div isteven-multi-select input-model="vm.subCategoryLeft" output-model="vm.selectedSubCategoryLeft" button-label="value" item-label="value" output-properties="id value" tick-property="ticked" max-height="236px" selection-mode="single" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedSubCategoryLeft" name="vm.searchMini" style="display:none" required></div><div ng-show="vm.selectedCategoryRight.length > 0 && vm.selectedSubCategoryLeft.length > 0"><label class="col-md-2 control-label"><span>Select Incident-Type Sub-Category </span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-4 dropFilter"><div isteven-multi-select input-model="vm.subCategoryRight" output-model="vm.selectedSubCategoryRight" button-label="value" item-label="value" output-properties="id value" tick-property="ticked" max-height="236px" helper-elements="all none filter"></div><input type="text" ng-model="vm.selectedSubCategoryRight" name="vm.searchMini" style="display:none" required></div></div></div><!-- <div class="form-group">\r\n\t\t\t\t\t\t\t<div  ng-show="vm.selectedSubCategoryLeft.length > 0">\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="attribute-mapping"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/attributeMapping/attribute-mapping.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span>Attribute Mapping</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="attribute-mapping.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><!-- <div class="row">\r\n\t\t\t\t\t\t\t<div class="col-md-3 pull-right">\r\n\t\t\t\t\t\t\t\t<div class="input-group ">\r\n\t\t\t\t\t\t\t\t<input  type="text"  ng-model="search" class="form-control " ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.attributeMap.home.search\' | translate}}">\r\n\t\t\t\t\t\t\t\t\t<span class="input-group-btn">\r\n\t\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-info btn-flat"  ng-click="vm.filterSearch()">\r\n\t\t\t\t\t\t\t\t\t\t<i class="fa fa-search"></i></button>\r\n\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th><span>Parent Incident Type Category</span> <span class="fa fa-arrow-right"></span></th><th><span class="fa fa-arrow-left"></span> <span>Parent Incident Type Sub Category</span></th><th><span>Incident Type Category</span> <span class="fa fa-arrow-right"></span></th><th><span class="fa fa-arrow-left"></span> <span>Incident Type Sub Category</span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="attributeMap in vm.attributeMappingList  | filter :search track by attributeMap.id"><td><a ui-sref="custom-case-type-attribute-detail({id:attributeMap.id})">{{attributeMap.id}}</a></td><td>{{attributeMap.parentCaseTypeCategory.name}}</td><td>{{attributeMap.parentCaseTypeSubCategory.name}}</td><td>{{attributeMap.caseTypeCategory.value}}</td><td>{{attributeMap.caseTypeSubCategory.value}}</td><td><div class="actions"><!-- <a ui-sref="custom-case-type-attribute-detail({id:attributeMap.id})"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="action-icons text-info" title="View">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="fa fa-eye"></span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t  </a> --><!-- <a ui-sref="custom-case-type-attribute.edit({id:attributeMap.id})"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="action-icons text-primary" title="Edit">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="fa fa-pencil-square"></span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a> --> <a ui-sref="attribute-mapping.delete({id:attributeMap.id})" ng-click="passDeleteId(attributeMap.id)" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.attributeMappingList == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/case-type/case-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.caseType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.caseType.delete.question" translate-values="{id: \'{{vm.caseType.id}}\'}">Are you sure you want to delete this Incident Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/case-type/case-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.caseType.detail.title">Incident Type</span> {{vm.caseType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.caseType.name">Name</span></dt><dd><span>{{vm.caseType.name}}</span></dd><dt><span translate="trakeyeApp.caseType.description">Description</span></dt><dd><span>{{vm.caseType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.caseType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.caseType.createdDate">Created Date</span></dt><dd><span>{{vm.caseType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.caseType.updateDate">Update Date</span></dt><dd><span>{{vm.caseType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.caseType.user">User</span></dt><dd>{{vm.caseType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="case-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="case-type.edit({id:vm.caseType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/case-type/case-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCaseTypeLabel"><span ng-if="!vm.caseType.id" translate="trakeyeApp.caseType.home.create">Create</span> <span ng-if="vm.caseType.id" translate="trakeyeApp.caseType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.caseType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.caseType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.caseType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.caseType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.caseType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.caseType.casetypeimage" for="field_assetimage">CaseType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="caseTypeImage" id="caseTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.caseType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 caseType_showImg" ng-if="vm.caseType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageCase" ng-src="data:image/jpeg;base64,{{vm.caseType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customCaseTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.caseType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.caseType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.caseType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group caseType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customCaseTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.caseCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.caseTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.caseType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="case-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/case-type/case-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.caseType.home.title">Incident Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="case-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.caseType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.caseType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.caseType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.caseType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.caseType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="caseType in vm.caseTypes  | filter : search  track   by caseType.id"><!--  <td><a ui-sref="case-type-detail({id:caseType.id})">{{caseType.id}}</a></td> --><td>{{caseType.name}}</td><td>{{caseType.description}}</td><!--  <td>{{caseType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{caseType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{caseType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="case-type-detail({id:caseType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="case-type.edit({id:caseType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.caseTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/config/config-dialog.html','<div class="modal-body"><form name="editForm" novalidate><div class="form-group"><label>Category Name</label> <input type="text" class="form-control" ng-model="vm.config.configCategoryName" required></div><div class="form-group"><label>Config Key</label> <input type="text" class="form-control" ng-model="vm.config.configKey" required></div><div class="form-group"><label>Config Value</label> <input type="text" class="form-control" ng-model="vm.config.configValue" required></div><div class="form-group"><label>Value Order</label> <input type="number" class="form-control" ng-model="vm.config.configValueOrder"></div><div class="form-group"><label>Created By</label> <input type="text" class="form-control" ng-model="vm.config.createdBy" required></div><button type="button" class="btn btn-primary" ng-click="vm.save()">Save</button> <button type="button" class="btn btn-default" ng-click="vm.clear()">Cancel</button></form></div>');
$templateCache.put('app/entities/config/configs.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cog"></i> <span>Configuration Settings</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="config.new"><span class="glyphicon glyphicon-plus"></span> <span>Create New Configuration</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" placeholder="Search Configurations"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterConfigSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id">ID <span class="fa fa-sort"></span></th><th jh-sort-by="configCategoryName">Category <span class="fa fa-sort"></span></th><th jh-sort-by="configKey">Key <span class="fa fa-sort"></span></th><th jh-sort-by="configValue">Value <span class="fa fa-sort"></span></th><th>Order</th><!-- <th>Actions</th> --></tr></thead><tbody><tr ng-repeat="config in vm.configs track by config.id"><td><a ui-sref="config.edit({id: config.id})">{{config.id}}</a></td><td>{{config.configCategoryName}}</td><td>{{config.configKey}}</td><td>{{config.configValue}}</td><td>{{config.configValueOrder}}</td><!-- <td>\r\n                                        <a ui-sref="config-detail({id: config.id})" class="action-icons text-info" title="View">\r\n                                            <span class="fa fa-eye"></span>\r\n                                        </a>\r\n                                        <a ui-sref="config.edit({id: config.id})" class="action-icons text-primary" title="Edit">\r\n                                            <span class="fa fa-pencil-square"></span>\r\n                                        </a>\r\n                                    </td> --></tr><tr ng-show="vm.configs.length == 0"><td colspan="7" class="text-center"><h4>No configurations available</h4></td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div class="col-md-8 text-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/custom-asset-type-attribute/custom-asset-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customAssetTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customAssetTypeAttribute.delete.question" translate-values="{id: \'{{vm.customAssetTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Asset Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-asset-type-attribute/custom-asset-type-attribute-detail.html','<div class="custom_assetType"><h2><span data-translate="trakeyeApp.customAssetTypeAttribute.detail.title">Custom Asset Type Attribute</span> {{vm.customAssetTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span></dt><dd><span>{{vm.customAssetTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customAssetTypeAttribute.description">Description</span></dt><dd><span>{{vm.customAssetTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-asset-type-attribute.edit({id:vm.customAssetTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-asset-type-attribute/custom-asset-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="mycustomAssetTypeAttributeLabel"><span ng-if="!vm.customAssetTypeAttribute.id" translate="trakeyeApp.customAssetTypeAttribute.home.create">Create</span> <span ng-if="vm.customAssetTypeAttribute.id" translate="trakeyeApp.customAssetTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customAssetTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customAssetTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customAssetTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customAssetTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-asset-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- <form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomAssetTypeAttributeLabel" data-translate="trakeyeApp.customAssetTypeAttribute.home.createOrEditLabel">Create or edit a Custom Asset Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customAssetTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customAssetTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customAssetTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customAssetTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customAssetTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customAssetTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-asset-type-attribute/custom-asset-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customAssetTypeAttribute.home.title">Incident Type Attribute DataTypes</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="custom-asset-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customAssetTypeAttribute.home.createLabel">Create new Incident Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customAssetTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customAssetTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customAssetTypeAttribute in vm.customAssetTypeAttributes | filter:search track by customAssetTypeAttribute.id"><td><a ui-sref="custom-case-type-attribute-detail({id:customAssetTypeAttribute.id})">{{customAssetTypeAttribute.id}}</a></td><td>{{customAssetTypeAttribute.name}}</td><td>{{customAssetTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-asset-type-attribute-detail({id:customAssetTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-asset-type-attribute.edit({id:customAssetTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-asset-type-attribute.delete({id:customAssetTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customAssetTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customAssetTypeAttribute.home.title">Custom Incident Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-case-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customAssetTypeAttribute.home.createLabel">\r\n                        Create new Custom Incident Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customAssetTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customAssetTypeAttribute in vm.customAssetTypeAttributes track by customAssetTypeAttribute.id">\r\n                    <td><a ui-sref="custom-case-type-attribute-detail({id:customAssetTypeAttribute.id})">{{customAssetTypeAttribute.id}}</a></td>\r\n                    <td>{{customAssetTypeAttribute.name}}</td>\r\n                    <td>{{customAssetTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-case-type-attribute-detail({id:customAssetTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-case-type-attribute.edit({id:customAssetTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-case-type-attribute.delete({id:customAssetTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> --><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customAssetTypeAttribute.home.title">Custom Asset Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-asset-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customAssetTypeAttribute.home.createLabel">\r\n                        Create new Custom Asset Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customAssetTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customAssetTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customAssetTypeAttribute in vm.customAssetTypeAttributes track by customAssetTypeAttribute.id">\r\n                    <td><a ui-sref="custom-asset-type-attribute-detail({id:customAssetTypeAttribute.id})">{{customAssetTypeAttribute.id}}</a></td>\r\n                    <td>{{customAssetTypeAttribute.name}}</td>\r\n                    <td>{{customAssetTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-asset-type-attribute-detail({id:customAssetTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-asset-type-attribute.edit({id:customAssetTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-asset-type-attribute.delete({id:customAssetTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/custom-case-type-attribute/custom-case-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customCaseTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customCaseTypeAttribute.delete.question" translate-values="{id: \'{{vm.customCaseTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Incident Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-case-type-attribute/custom-case-type-attribute-detail.html','<div class="custom_caseType"><h2><span data-translate="trakeyeApp.customCaseTypeAttribute.detail.title">Custom Incident Type Attribute</span> {{vm.customCaseTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customCaseTypeAttribute.name">Name</span></dt><dd><span>{{vm.customCaseTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customCaseTypeAttribute.description">Description</span></dt><dd><span>{{vm.customCaseTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-case-type-attribute.edit({id:vm.customCaseTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomCaseTypeAttributeLabel"><span ng-if="!vm.customCaseTypeAttribute.id" translate="trakeyeApp.customCaseTypeAttribute.home.create">Create</span> <span ng-if="vm.customCaseTypeAttribute.id" translate="trakeyeApp.customCaseTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customCaseTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customCaseTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customCaseTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customCaseTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customCaseTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-case-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomCaseTypeAttributeLabel" data-translate="trakeyeApp.customCaseTypeAttribute.home.createOrEditLabel">Create or edit a Custom Incident Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customCaseTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customCaseTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customCaseTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customCaseTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customCaseTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customCaseTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-case-type-attribute/custom-case-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customCaseTypeAttribute.home.title">Incident Type Attribute DataTypes</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="custom-case-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customCaseTypeAttribute.home.createLabel">Create new Incident Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customCaseTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customCaseTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customCaseTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customCaseTypeAttribute in vm.customCaseTypeAttributes  | filter :search track by customCaseTypeAttribute.id"><td><a ui-sref="custom-case-type-attribute-detail({id:customCaseTypeAttribute.id})">{{customCaseTypeAttribute.id}}</a></td><td>{{customCaseTypeAttribute.name}}</td><td>{{customCaseTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-case-type-attribute-detail({id:customCaseTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-case-type-attribute.edit({id:customCaseTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-case-type-attribute.delete({id:customCaseTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customCaseTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customCaseTypeAttribute.home.title">Custom Incident Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-case-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customCaseTypeAttribute.home.createLabel">\r\n                        Create new Custom Incident Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customCaseTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customCaseTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customCaseTypeAttribute in vm.customCaseTypeAttributes track by customCaseTypeAttribute.id">\r\n                    <td><a ui-sref="custom-case-type-attribute-detail({id:customCaseTypeAttribute.id})">{{customCaseTypeAttribute.id}}</a></td>\r\n                    <td>{{customCaseTypeAttribute.name}}</td>\r\n                    <td>{{customCaseTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-case-type-attribute-detail({id:customCaseTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-case-type-attribute.edit({id:customCaseTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-case-type-attribute.delete({id:customCaseTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/custom-group-type-attribute/custom-group-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customGroupTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customGroupTypeAttribute.delete.question" translate-values="{id: \'{{vm.customGroupTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Group Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-group-type-attribute/custom-group-type-attribute-detail.html','<div class="custom_groupType"><h2><span data-translate="trakeyeApp.customGroupTypeAttribute.detail.title">Custom Group Type Attribute</span> {{vm.customGroupTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span></dt><dd><span>{{vm.customGroupTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customGroupTypeAttribute.description">Description</span></dt><dd><span>{{vm.customGroupTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-group-type-attribute.edit({id:vm.customGroupTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-group-type-attribute/custom-group-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="mycustomGroupTypeAttributeLabel"><span ng-if="!vm.customGroupTypeAttribute.id" translate="trakeyeApp.customGroupTypeAttribute.home.create">Create</span> <span ng-if="vm.customGroupTypeAttribute.id" translate="trakeyeApp.customGroupTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customGroupTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customGroupTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customGroupTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customGroupTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-group-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- <form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomGroupTypeAttributeLabel" data-translate="trakeyeApp.customGroupTypeAttribute.home.createOrEditLabel">Create or edit a Custom Group Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customGroupTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customGroupTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customGroupTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customGroupTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customGroupTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customGroupTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-group-type-attribute/custom-group-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customGroupTypeAttribute.home.title">Incident Type Attribute DataTypes</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="custom-group-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customGroupTypeAttribute.home.createLabel">Create new Incident Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customGroupTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customGroupTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customGroupTypeAttribute in vm.customGroupTypeAttributes | filter:search track by customGroupTypeAttribute.id"><td><a ui-sref="custom-case-type-attribute-detail({id:customGroupTypeAttribute.id})">{{customGroupTypeAttribute.id}}</a></td><td>{{customGroupTypeAttribute.name}}</td><td>{{customGroupTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-group-type-attribute-detail({id:customGroupTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-group-type-attribute.edit({id:customGroupTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-group-type-attribute.delete({id:customGroupTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customGroupTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customGroupTypeAttribute.home.title">Custom Incident Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-case-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customGroupTypeAttribute.home.createLabel">\r\n                        Create new Custom Incident Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customGroupTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customGroupTypeAttribute in vm.customGroupTypeAttributes track by customGroupTypeAttribute.id">\r\n                    <td><a ui-sref="custom-case-type-attribute-detail({id:customGroupTypeAttribute.id})">{{customGroupTypeAttribute.id}}</a></td>\r\n                    <td>{{customGroupTypeAttribute.name}}</td>\r\n                    <td>{{customGroupTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-case-type-attribute-detail({id:customGroupTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-case-type-attribute.edit({id:customGroupTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-case-type-attribute.delete({id:customGroupTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> --><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customGroupTypeAttribute.home.title">Custom Group Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-group-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customGroupTypeAttribute.home.createLabel">\r\n                        Create new Custom Group Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customGroupTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customGroupTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customGroupTypeAttribute in vm.customGroupTypeAttributes track by customGroupTypeAttribute.id">\r\n                    <td><a ui-sref="custom-group-type-attribute-detail({id:customGroupTypeAttribute.id})">{{customGroupTypeAttribute.id}}</a></td>\r\n                    <td>{{customGroupTypeAttribute.name}}</td>\r\n                    <td>{{customGroupTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-group-type-attribute-detail({id:customGroupTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-group-type-attribute.edit({id:customGroupTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-group-type-attribute.delete({id:customGroupTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/custom-log-type-attribute/custom-log-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customLogTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customLogTypeAttribute.delete.question" translate-values="{id: \'{{vm.customLogTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Log Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-log-type-attribute/custom-log-type-attribute-detail.html','<div class="custom_logType"><h2><span data-translate="trakeyeApp.customLogTypeAttribute.detail.title">Custom Log Type Attribute</span> {{vm.customLogTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customLogTypeAttribute.name">Name</span></dt><dd><span>{{vm.customLogTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customLogTypeAttribute.description">Description</span></dt><dd><span>{{vm.customLogTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-log-type-attribute.edit({id:vm.customLogTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-log-type-attribute/custom-log-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomLogTypeAttributeLabel"><span ng-if="!vm.customLogTypeAttribute.id" translate="trakeyeApp.customLogTypeAttribute.home.create">Create</span> <span ng-if="vm.customLogTypeAttribute.id" translate="trakeyeApp.customLogTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customLogTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customLogTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customLogTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customLogTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customLogTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-log-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomLogTypeAttributeLabel" data-translate="trakeyeApp.customLogTypeAttribute.home.createOrEditLabel">Create or edit a Custom Log Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customLogTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customLogTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customLogTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customLogTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customLogTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customLogTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-log-type-attribute/custom-log-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customLogTypeAttribute.home.title">Log Type Attribute DataTypes</span></h3><div class="box-tools custom_LogTypeAttr"><button class="btn btn-create" ui-sref="custom-log-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customLogTypeAttribute.home.createLabel">Create new Log Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customLogTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customLogTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customLogTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customLogTypeAttribute in vm.customLogTypeAttributes  | filter :search track by customLogTypeAttribute.id"><td><a ui-sref="custom-log-type-attribute-detail({id:customLogTypeAttribute.id})">{{customLogTypeAttribute.id}}</a></td><td>{{customLogTypeAttribute.name}}</td><td>{{customLogTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-log-type-attribute-detail({id:customLogTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-log-type-attribute.edit({id:customLogTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-log-type-attribute.delete({id:customLogTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customLogTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customLogTypeAttribute.home.title">Custom Log Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-log-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customLogTypeAttribute.home.createLabel">\r\n                        Create new Custom Log Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customLogTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customLogTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customLogTypeAttribute in vm.customLogTypeAttributes track by customLogTypeAttribute.id">\r\n                    <td><a ui-sref="custom-log-type-attribute-detail({id:customLogTypeAttribute.id})">{{customLogTypeAttribute.id}}</a></td>\r\n                    <td>{{customLogTypeAttribute.name}}</td>\r\n                    <td>{{customLogTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-log-type-attribute-detail({id:customLogTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-log-type-attribute.edit({id:customLogTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-log-type-attribute.delete({id:customLogTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/custom-material-type-attribute/custom-material-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customMaterialTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customMaterialTypeAttribute.delete.question" translate-values="{id: \'{{vm.customMaterialTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Material Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-material-type-attribute/custom-material-type-attribute-detail.html','<div class="custom_materialType"><h2><span data-translate="trakeyeApp.customMaterialTypeAttribute.detail.title">Custom Material Type Attribute</span> {{vm.customMaterialTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customMaterialTypeAttribute.name">Name</span></dt><dd><span>{{vm.customMaterialTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customMaterialTypeAttribute.description">Description</span></dt><dd><span>{{vm.customMaterialTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-material-type-attribute.edit({id:vm.customMaterialTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomMaterialTypeAttributeLabel"><span ng-if="!vm.customMaterialTypeAttribute.id" translate="trakeyeApp.customMaterialTypeAttribute.home.create">Create</span> <span ng-if="vm.customMaterialTypeAttribute.id" translate="trakeyeApp.customMaterialTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customMaterialTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customMaterialTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customMaterialTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customMaterialTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customMaterialTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-material-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomMaterialTypeAttributeLabel" data-translate="trakeyeApp.customMaterialTypeAttribute.home.createOrEditLabel">Create or edit a Custom Material Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customMaterialTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customMaterialTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customMaterialTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customMaterialTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customMaterialTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customMaterialTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-material-type-attribute/custom-material-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customMaterialTypeAttribute.home.title">Material Type Attribute DataTypes</span></h3><div class="box-tools custom_MaterialTypeAttr"><button class="btn btn-create" ui-sref="custom-material-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customMaterialTypeAttribute.home.createLabel">Create new Material Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customMaterialTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customMaterialTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customMaterialTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customMaterialTypeAttribute in vm.customMaterialTypeAttributes  | filter :search track by customMaterialTypeAttribute.id"><td><a ui-sref="custom-material-type-attribute-detail({id:customMaterialTypeAttribute.id})">{{customMaterialTypeAttribute.id}}</a></td><td>{{customMaterialTypeAttribute.name}}</td><td>{{customMaterialTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-material-type-attribute-detail({id:customMaterialTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-material-type-attribute.edit({id:customMaterialTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-material-type-attribute.delete({id:customMaterialTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customMaterialTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/custom-project-type-attribute/custom-project-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customProjectTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customProjectTypeAttribute.delete.question" translate-values="{id: \'{{vm.customProjectTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Project Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-project-type-attribute/custom-project-type-attribute-detail.html','<div class="custom_projectType"><h2><span data-translate="trakeyeApp.customProjectTypeAttribute.detail.title">Custom Project Type Attribute</span> {{vm.customProjectTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customProjectTypeAttribute.name">Name</span></dt><dd><span>{{vm.customProjectTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customProjectTypeAttribute.description">Description</span></dt><dd><span>{{vm.customProjectTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-project-type-attribute.edit({id:vm.customProjectTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-project-type-attribute/custom-project-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomProjectTypeAttributeLabel"><span ng-if="!vm.customProjectTypeAttribute.id" translate="trakeyeApp.customProjectTypeAttribute.home.create">Create</span> <span ng-if="vm.customProjectTypeAttribute.id" translate="trakeyeApp.customProjectTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customProjectTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customProjectTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customProjectTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customProjectTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customProjectTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-project-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomProjectTypeAttributeLabel" data-translate="trakeyeApp.customProjectTypeAttribute.home.createOrEditLabel">Create or edit a Custom Project Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customProjectTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customProjectTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customProjectTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customProjectTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customProjectTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customProjectTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-project-type-attribute/custom-project-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customProjectTypeAttribute.home.title">Project Type Attribute DataTypes</span></h3><div class="box-tools custom_ProjectTypeAttr"><button class="btn btn-create" ui-sref="custom-project-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customProjectTypeAttribute.home.createLabel">Create new Project Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customProjectTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customProjectTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customProjectTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customProjectTypeAttribute in vm.customProjectTypeAttributes  | filter :search track by customProjectTypeAttribute.id"><td><a ui-sref="custom-project-type-attribute-detail({id:customProjectTypeAttribute.id})">{{customProjectTypeAttribute.id}}</a></td><td>{{customProjectTypeAttribute.name}}</td><td>{{customProjectTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-project-type-attribute-detail({id:customProjectTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-project-type-attribute.edit({id:customProjectTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-project-type-attribute.delete({id:customProjectTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customProjectTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/custom-resource-type-attribute/custom-resource-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customResourceTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customResourceTypeAttribute.delete.question" translate-values="{id: \'{{vm.customResourceTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Resource Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-resource-type-attribute/custom-resource-type-attribute-detail.html','<div class="custom_resourceType"><h2><span data-translate="trakeyeApp.customResourceTypeAttribute.detail.title">Custom Resource Type Attribute</span> {{vm.customResourceTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customResourceTypeAttribute.name">Name</span></dt><dd><span>{{vm.customResourceTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customResourceTypeAttribute.description">Description</span></dt><dd><span>{{vm.customResourceTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-resource-type-attribute.edit({id:vm.customResourceTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-resource-type-attribute/custom-resource-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomResourceTypeAttributeLabel"><span ng-if="!vm.customResourceTypeAttribute.id" translate="trakeyeApp.customResourceTypeAttribute.home.create">Create</span> <span ng-if="vm.customResourceTypeAttribute.id" translate="trakeyeApp.customResourceTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customResourceTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customResourceTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customResourceTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customResourceTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customResourceTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-resource-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomResourceTypeAttributeLabel" data-translate="trakeyeApp.customResourceTypeAttribute.home.createOrEditLabel">Create or edit a Custom Resource Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customResourceTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customResourceTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customResourceTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customResourceTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customResourceTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customResourceTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-resource-type-attribute/custom-resource-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customResourceTypeAttribute.home.title">Resource Type Attribute DataTypes</span></h3><div class="box-tools custom_ResourceTypeAttr"><button class="btn btn-create" ui-sref="custom-resource-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customResourceTypeAttribute.home.createLabel">Create new Resource Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customResourceTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customResourceTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customResourceTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customResourceTypeAttribute in vm.customResourceTypeAttributes  | filter :search track by customResourceTypeAttribute.id"><td><a ui-sref="custom-resource-type-attribute-detail({id:customResourceTypeAttribute.id})">{{customResourceTypeAttribute.id}}</a></td><td>{{customResourceTypeAttribute.name}}</td><td>{{customResourceTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-resource-type-attribute-detail({id:customResourceTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-resource-type-attribute.edit({id:customResourceTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-resource-type-attribute.delete({id:customResourceTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customResourceTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/custom-route-type-attribute/custom-route-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customRouteTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customRouteTypeAttribute.delete.question" translate-values="{id: \'{{vm.customRouteTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Route Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-route-type-attribute/custom-route-type-attribute-detail.html','<div class="custom_routeType"><h2><span data-translate="trakeyeApp.customRouteTypeAttribute.detail.title">Custom Route Type Attribute</span> {{vm.customRouteTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customRouteTypeAttribute.name">Name</span></dt><dd><span>{{vm.customRouteTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customRouteTypeAttribute.description">Description</span></dt><dd><span>{{vm.customRouteTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-route-type-attribute.edit({id:vm.customRouteTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-route-type-attribute/custom-route-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomRouteTypeAttributeLabel"><span ng-if="!vm.customRouteTypeAttribute.id" translate="trakeyeApp.customRouteTypeAttribute.home.create">Create</span> <span ng-if="vm.customRouteTypeAttribute.id" translate="trakeyeApp.customRouteTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customRouteTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customRouteTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customRouteTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customRouteTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customRouteTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-route-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomRouteTypeAttributeLabel" data-translate="trakeyeApp.customRouteTypeAttribute.home.createOrEditLabel">Create or edit a Custom Route Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customRouteTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customRouteTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customRouteTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customRouteTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customRouteTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customRouteTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-route-type-attribute/custom-route-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customRouteTypeAttribute.home.title">Route Type Attribute DataTypes</span></h3><div class="box-tools custom_RouteTypeAttr"><button class="btn btn-create" ui-sref="custom-route-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customRouteTypeAttribute.home.createLabel">Create new Route Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customRouteTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customRouteTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customRouteTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customRouteTypeAttribute in vm.customRouteTypeAttributes  | filter :search track by customRouteTypeAttribute.id"><td><a ui-sref="custom-route-type-attribute-detail({id:customRouteTypeAttribute.id})">{{customRouteTypeAttribute.id}}</a></td><td>{{customRouteTypeAttribute.name}}</td><td>{{customRouteTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-route-type-attribute-detail({id:customRouteTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-route-type-attribute.edit({id:customRouteTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-route-type-attribute.delete({id:customRouteTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customRouteTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/custom-row-type-attribute/custom-row-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customRowTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customRowTypeAttribute.delete.question" translate-values="{id: \'{{vm.customRowTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Row Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-row-type-attribute/custom-row-type-attribute-detail.html','<div class="custom_rowType"><h2><span data-translate="trakeyeApp.customRowTypeAttribute.detail.title">Custom Row Type Attribute</span> {{vm.customRowTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customRowTypeAttribute.name">Name</span></dt><dd><span>{{vm.customRowTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customRowTypeAttribute.description">Description</span></dt><dd><span>{{vm.customRowTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-row-type-attribute.edit({id:vm.customRowTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-row-type-attribute/custom-row-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomRowTypeAttributeLabel"><span ng-if="!vm.customRowTypeAttribute.id" translate="trakeyeApp.customRowTypeAttribute.home.create">Create</span> <span ng-if="vm.customRowTypeAttribute.id" translate="trakeyeApp.customRowTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customRowTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customRowTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customRowTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customRowTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customRowTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-row-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomRowTypeAttributeLabel" data-translate="trakeyeApp.customRowTypeAttribute.home.createOrEditLabel">Create or edit a Custom Row Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customRowTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customRowTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customRowTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customRowTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customRowTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customRowTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-row-type-attribute/custom-row-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customRowTypeAttribute.home.title">Row Type Attribute DataTypes</span></h3><div class="box-tools custom_RowTypeAttr"><button class="btn btn-create" ui-sref="custom-row-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customRowTypeAttribute.home.createLabel">Create new Row Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customRowTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customRowTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customRowTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customRowTypeAttribute in vm.customRowTypeAttributes  | filter :search track by customRowTypeAttribute.id"><td><a ui-sref="custom-row-type-attribute-detail({id:customRowTypeAttribute.id})">{{customRowTypeAttribute.id}}</a></td><td>{{customRowTypeAttribute.name}}</td><td>{{customRowTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-row-type-attribute-detail({id:customRowTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-row-type-attribute.edit({id:customRowTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-row-type-attribute.delete({id:customRowTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customRowTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customRowTypeAttribute.home.title">Custom Row Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-row-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customRowTypeAttribute.home.createLabel">\r\n                        Create new Custom Row Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customRowTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customRowTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customRowTypeAttribute in vm.customRowTypeAttributes track by customRowTypeAttribute.id">\r\n                    <td><a ui-sref="custom-row-type-attribute-detail({id:customRowTypeAttribute.id})">{{customRowTypeAttribute.id}}</a></td>\r\n                    <td>{{customRowTypeAttribute.name}}</td>\r\n                    <td>{{customRowTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-row-type-attribute-detail({id:customRowTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-row-type-attribute.edit({id:customRowTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-row-type-attribute.delete({id:customRowTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/custom-section-type-attribute/custom-section-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customSectionTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customSectionTypeAttribute.delete.question" translate-values="{id: \'{{vm.customSectionTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Section Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-section-type-attribute/custom-section-type-attribute-detail.html','<div class="custom_sectionType"><h2><span data-translate="trakeyeApp.customSectionTypeAttribute.detail.title">Custom Section Type Attribute</span> {{vm.customSectionTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customSectionTypeAttribute.name">Name</span></dt><dd><span>{{vm.customSectionTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customSectionTypeAttribute.description">Description</span></dt><dd><span>{{vm.customSectionTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-section-type-attribute.edit({id:vm.customSectionTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-section-type-attribute/custom-section-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomSectionTypeAttributeLabel"><span ng-if="!vm.customSectionTypeAttribute.id" translate="trakeyeApp.customSectionTypeAttribute.home.create">Create</span> <span ng-if="vm.customSectionTypeAttribute.id" translate="trakeyeApp.customSectionTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customSectionTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customSectionTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customSectionTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customSectionTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customSectionTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-section-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomSectionTypeAttributeLabel" data-translate="trakeyeApp.customSectionTypeAttribute.home.createOrEditLabel">Create or edit a Custom Section Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customSectionTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customSectionTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customSectionTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customSectionTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customSectionTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customSectionTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-section-type-attribute/custom-section-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customSectionTypeAttribute.home.title">Section Type Attribute DataTypes</span></h3><div class="box-tools custom_SectionTypeAttr"><button class="btn btn-create" ui-sref="custom-section-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customSectionTypeAttribute.home.createLabel">Create new Section Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customSectionTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customSectionTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customSectionTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customSectionTypeAttribute in vm.customSectionTypeAttributes  | filter :search track by customSectionTypeAttribute.id"><td><a ui-sref="custom-section-type-attribute-detail({id:customSectionTypeAttribute.id})">{{customSectionTypeAttribute.id}}</a></td><td>{{customSectionTypeAttribute.name}}</td><td>{{customSectionTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-section-type-attribute-detail({id:customSectionTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-section-type-attribute.edit({id:customSectionTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-section-type-attribute.delete({id:customSectionTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customSectionTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/custom-service-type-attribute/custom-service-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customServiceTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customServiceTypeAttribute.delete.question" translate-values="{id: \'{{vm.customServiceTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Service Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-service-type-attribute/custom-service-type-attribute-detail.html','<div class="customSer_label"><h2><span data-translate="trakeyeApp.customServiceTypeAttribute.detail.title">Custom Service Type Attribute</span> {{vm.customServiceTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customServiceTypeAttribute.name">Name</span></dt><dd><span>{{vm.customServiceTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customServiceTypeAttribute.description">Description</span></dt><dd><span>{{vm.customServiceTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-service-type-attribute.edit({id:vm.customServiceTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="mycustomServiceTypeAttributeLabel"><span ng-if="!vm.customServiceTypeAttribute.id" translate="trakeyeApp.customServiceTypeAttribute.home.create">Create</span> <span ng-if="vm.customServiceTypeAttribute.id" translate="trakeyeApp.customServiceTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customServiceTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customServiceTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customServiceTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customServiceTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customServiceTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-service-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- <form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomServiceTypeAttributeLabel" data-translate="trakeyeApp.customServiceTypeAttribute.home.createOrEditLabel">Create or edit a Custom Service Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customServiceTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customServiceTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customServiceTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customServiceTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customServiceTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customServiceTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-service-type-attribute/custom-service-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customServiceTypeAttribute.home.title">Custom Service Type Attribute DataTypes</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="custom-service-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customServiceTypeAttribute.home.createLabel">Create new service Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customServiceTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customServiceTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customServiceTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customServiceTypeAttribute in vm.customServiceTypeAttributes  | filter :search track by customServiceTypeAttribute.id"><td><a ui-sref="custom-service-type-attribute-detail({id:customServiceTypeAttribute.id})">{{customServiceTypeAttribute.id}}</a></td><td>{{customServiceTypeAttribute.name}}</td><td>{{customServiceTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-service-type-attribute-detail({id:customServiceTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-service-type-attribute.edit({id:customServiceTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-service-type-attribute.delete({id:customServiceTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customServiceTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customServiceTypeAttribute.home.title">Custom Service Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-service-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customServiceTypeAttribute.home.createLabel">\r\n                        Create new Custom Service Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customServiceTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customServiceTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customServiceTypeAttribute in vm.customServiceTypeAttributes track by customServiceTypeAttribute.id">\r\n                    <td><a ui-sref="custom-service-type-attribute-detail({id:customServiceTypeAttribute.id})">{{customServiceTypeAttribute.id}}</a></td>\r\n                    <td>{{customServiceTypeAttribute.name}}</td>\r\n                    <td>{{customServiceTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-service-type-attribute-detail({id:customServiceTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-service-type-attribute.edit({id:customServiceTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-service-type-attribute.delete({id:customServiceTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/custom-task-type-attribute/custom-task-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customTaskTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customTaskTypeAttribute.delete.question" translate-values="{id: \'{{vm.customTaskTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Task Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-task-type-attribute/custom-task-type-attribute-detail.html','<div class="custom_taskType"><h2><span data-translate="trakeyeApp.customTaskTypeAttribute.detail.title">Custom Task Type Attribute</span> {{vm.customTaskTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customTaskTypeAttribute.name">Name</span></dt><dd><span>{{vm.customTaskTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customTaskTypeAttribute.description">Description</span></dt><dd><span>{{vm.customTaskTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-task-type-attribute.edit({id:vm.customTaskTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-task-type-attribute/custom-task-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomTaskTypeAttributeLabel"><span ng-if="!vm.customTaskTypeAttribute.id" translate="trakeyeApp.customTaskTypeAttribute.home.create">Create</span> <span ng-if="vm.customTaskTypeAttribute.id" translate="trakeyeApp.customTaskTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customTaskTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customTaskTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customTaskTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customTaskTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customTaskTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-task-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomTaskTypeAttributeLabel" data-translate="trakeyeApp.customTaskTypeAttribute.home.createOrEditLabel">Create or edit a Custom Task Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customTaskTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customTaskTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customTaskTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customTaskTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customTaskTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customTaskTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-task-type-attribute/custom-task-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customTaskTypeAttribute.home.title">Task Type Attribute DataTypes</span></h3><div class="box-tools custom_TaskTypeAttr"><button class="btn btn-create" ui-sref="custom-task-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customTaskTypeAttribute.home.createLabel">Create new Task Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customTaskTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customTaskTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customTaskTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customTaskTypeAttribute in vm.customTaskTypeAttributes  | filter :search track by customTaskTypeAttribute.id"><td><a ui-sref="custom-task-type-attribute-detail({id:customTaskTypeAttribute.id})">{{customTaskTypeAttribute.id}}</a></td><td>{{customTaskTypeAttribute.name}}</td><td>{{customTaskTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-task-type-attribute-detail({id:customTaskTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-task-type-attribute.edit({id:customTaskTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-task-type-attribute.delete({id:customTaskTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customTaskTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customTaskTypeAttribute.home.title">Custom Task Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-task-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customTaskTypeAttribute.home.createLabel">\r\n                        Create new Custom Task Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customTaskTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customTaskTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customTaskTypeAttribute in vm.customTaskTypeAttributes track by customTaskTypeAttribute.id">\r\n                    <td><a ui-sref="custom-task-type-attribute-detail({id:customTaskTypeAttribute.id})">{{customTaskTypeAttribute.id}}</a></td>\r\n                    <td>{{customTaskTypeAttribute.name}}</td>\r\n                    <td>{{customTaskTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-task-type-attribute-detail({id:customTaskTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-task-type-attribute.edit({id:customTaskTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-task-type-attribute.delete({id:customTaskTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customTerrainTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customTerrainTypeAttribute.delete.question" translate-values="{id: \'{{vm.customTerrainTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Terrain Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-detail.html','<div class="custom_terrainType"><h2><span data-translate="trakeyeApp.customTerrainTypeAttribute.detail.title">Custom Terrain Type Attribute</span> {{vm.customTerrainTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customTerrainTypeAttribute.name">Name</span></dt><dd><span>{{vm.customTerrainTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customTerrainTypeAttribute.description">Description</span></dt><dd><span>{{vm.customTerrainTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-terrain-type-attribute.edit({id:vm.customTerrainTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomTerrainTypeAttributeLabel"><span ng-if="!vm.customTerrainTypeAttribute.id" translate="trakeyeApp.customTerrainTypeAttribute.home.create">Create</span> <span ng-if="vm.customTerrainTypeAttribute.id" translate="trakeyeApp.customTerrainTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customTerrainTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customTerrainTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customTerrainTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customTerrainTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customTerrainTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-terrain-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomTerrainTypeAttributeLabel" data-translate="trakeyeApp.customTerrainTypeAttribute.home.createOrEditLabel">Create or edit a Custom Terrain Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customTerrainTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customTerrainTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customTerrainTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customTerrainTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customTerrainTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customTerrainTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-terrain-type-attribute/custom-terrain-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customTerrainTypeAttribute.home.title">Terrain Type Attribute DataTypes</span></h3><div class="box-tools custom_TerrainTypeAttr"><button class="btn btn-create" ui-sref="custom-terrain-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customTerrainTypeAttribute.home.createLabel">Create new Terrain Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customTerrainTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customTerrainTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customTerrainTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customTerrainTypeAttribute in vm.customTerrainTypeAttributes  | filter :search track by customTerrainTypeAttribute.id"><td><a ui-sref="custom-terrain-type-attribute-detail({id:customTerrainTypeAttribute.id})">{{customTerrainTypeAttribute.id}}</a></td><td>{{customTerrainTypeAttribute.name}}</td><td>{{customTerrainTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-terrain-type-attribute-detail({id:customTerrainTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-terrain-type-attribute.edit({id:customTerrainTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-terrain-type-attribute.delete({id:customTerrainTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customTerrainTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customTerrainTypeAttribute.home.title">Custom Terrain Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-terrain-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customTerrainTypeAttribute.home.createLabel">\r\n                        Create new Custom Terrain Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customTerrainTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customTerrainTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customTerrainTypeAttribute in vm.customTerrainTypeAttributes track by customTerrainTypeAttribute.id">\r\n                    <td><a ui-sref="custom-terrain-type-attribute-detail({id:customTerrainTypeAttribute.id})">{{customTerrainTypeAttribute.id}}</a></td>\r\n                    <td>{{customTerrainTypeAttribute.name}}</td>\r\n                    <td>{{customTerrainTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-terrain-type-attribute-detail({id:customTerrainTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-terrain-type-attribute.edit({id:customTerrainTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-terrain-type-attribute.delete({id:customTerrainTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customTrWorkOrderTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customTrWorkOrderTypeAttribute.delete.question" translate-values="{id: \'{{vm.customTrWorkOrderTypeAttribute.id}}\'}">Are you sure you want to delete this Custom TrWorkOrder Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-detail.html','<div class="custom_trworkorderType"><h2><span data-translate="trakeyeApp.customTrWorkOrderTypeAttribute.detail.title">Custom TrWorkOrder Type Attribute</span> {{vm.customTrWorkOrderTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customTrWorkOrderTypeAttribute.name">Name</span></dt><dd><span>{{vm.customTrWorkOrderTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customTrWorkOrderTypeAttribute.description">Description</span></dt><dd><span>{{vm.customTrWorkOrderTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-workorder-type-attribute.edit({id:vm.customTrWorkOrderTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomTrWorkOrderTypeAttributeLabel"><span ng-if="!vm.customTrWorkOrderTypeAttribute.id" translate="trakeyeApp.customWorkOrderTypeAttribute.home.create">Create</span> <span ng-if="vm.customTrWorkOrderTypeAttribute.id" translate="trakeyeApp.customWorkOrderTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customTrWorkOrderTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customWorkOrderTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customTrWorkOrderTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customWorkOrderTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-workorder-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div><!-- \r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCustomTrWorkOrderTypeAttributeLabel" data-translate="trakeyeApp.customWorkOrderTypeAttribute.home.createOrEditLabel">Create or edit a Custom TrWorkOrder Type Attribute</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.customTrWorkOrderTypeAttribute.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.customTrWorkOrderTypeAttribute.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customWorkOrderTypeAttribute.name" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.customTrWorkOrderTypeAttribute.name"\r\n                    required/>\r\n            <div ng-show="editForm.name.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.name.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.customWorkOrderTypeAttribute.description" for="field_description">Description</label>\r\n            <input type="text" class="form-control" name="description" id="field_description"\r\n                    ng-model="vm.customTrWorkOrderTypeAttribute.description"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form> -->');
$templateCache.put('app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customWorkOrderTypeAttribute.home.title">Work Order Type Attribute DataTypes</span></h3><div class="box-tools custom_TrWorkOrderTypeAttr"><button class="btn btn-create" ui-sref="custom-trworkorder-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customWorkOrderTypeAttribute.home.createLabel">Create new Work Order Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customWorkOrderTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customTrWorkOrderTypeAttribute in vm.customTrWorkOrderTypeAttributes  | filter :search track by customTrWorkOrderTypeAttribute.id"><td><a ui-sref="custom-trworkorder-type-attribute-detail({id:customTrWorkOrderTypeAttribute.id})">{{customTrWorkOrderTypeAttribute.id}}</a></td><td>{{customTrWorkOrderTypeAttribute.name}}</td><td>{{customTrWorkOrderTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-trworkorder-type-attribute-detail({id:customTrWorkOrderTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-trworkorder-type-attribute.edit({id:customTrWorkOrderTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-trworkorder-type-attribute.delete({id:customTrWorkOrderTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customTrWorkOrderTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.customWorkOrderTypeAttribute.home.title">Custom TrWorkOrder Type Attributes</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="custom-trworkorder-type-attribute.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.customWorkOrderTypeAttribute.home.createLabel">\r\n                        Create new Custom TrWorkOrder Type Attribute\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="name"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="description"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="customTrWorkOrderTypeAttribute in vm.customTrWorkOrderTypeAttributes track by customTrWorkOrderTypeAttribute.id">\r\n                    <td><a ui-sref="custom-trworkorder-type-attribute-detail({id:customTrWorkOrderTypeAttribute.id})">{{customTrWorkOrderTypeAttribute.id}}</a></td>\r\n                    <td>{{customTrWorkOrderTypeAttribute.name}}</td>\r\n                    <td>{{customTrWorkOrderTypeAttribute.description}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="custom-trworkorder-type-attribute-detail({id:customTrWorkOrderTypeAttribute.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-trworkorder-type-attribute.edit({id:customTrWorkOrderTypeAttribute.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="custom-trworkorder-type-attribute.delete({id:customTrWorkOrderTypeAttribute.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customWorkFlowTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customWorkFlowTypeAttribute.delete.question" translate-values="{id: \'{{vm.customWorkFlowTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Work Flow Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-detail.html','<div><h2><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.detail.title">Custom Work Flow Type Attribute</span> {{vm.customWorkFlowTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.name">Name</span></dt><dd><span>{{vm.customWorkFlowTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.description">Description</span></dt><dd><span>{{vm.customWorkFlowTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-work-flow-type-attribute.edit({id:vm.customWorkFlowTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomWorkFlowTypeAttributeLabel"><span ng-if="!vm.customWorkFlowTypeAttribute.id" translate="trakeyeApp.customWorkFlowTypeAttribute.home.create">Create</span> <span ng-if="vm.customWorkFlowTypeAttribute.id" translate="trakeyeApp.customWorkFlowTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customWorkFlowTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customWorkFlowTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customWorkFlowTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customWorkFlowTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-work-flow-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customWorkFlowTypeAttribute.home.title">WorkFlow Type Attribute DataTypes</span></h3><div class="box-tools custom_WorkFlowTypeAttr"><button class="btn btn-create" ui-sref="custom-work-flow-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customWorkFlowTypeAttribute.home.createLabel">Create new WorkFlow Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customWorkFlowTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customWorkFlowTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customWorkFlowTypeAttribute in vm.customWorkFlowTypeAttributes  | filter :search track by customWorkFlowTypeAttribute.id"><td><a ui-sref="custom-work-flow-type-attribute-detail({id:customWorkFlowTypeAttribute.id})">{{customWorkFlowTypeAttribute.id}}</a></td><td>{{customWorkFlowTypeAttribute.name}}</td><td>{{customWorkFlowTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-work-flow-type-attribute-detail({id:customWorkFlowTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-work-flow-type-attribute.edit({id:customWorkFlowTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-work-flow-type-attribute.delete({id:customWorkFlowTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.customWorkFlowTypeAttributes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customWorkOrderTypeAttribute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.customWorkOrderTypeAttribute.delete.question" translate-values="{id: \'{{vm.customWorkOrderTypeAttribute.id}}\'}">Are you sure you want to delete this Custom Work Order Type Attribute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-detail.html','<div class="custom_workOrderType"><h2><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.detail.title">Custom Work Order Type Attribute</span> {{vm.customWorkOrderTypeAttribute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.name">Name</span></dt><dd><span>{{vm.customWorkOrderTypeAttribute.name}}</span></dd><dt><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.description">Description</span></dt><dd><span>{{vm.customWorkOrderTypeAttribute.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-workorder-type-attribute.edit({id:vm.customWorkOrderTypeAttribute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-workorder-type-attribute/custom-workorder-type-attribute-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myCustomWorkOrderTypeAttributeLabel"><span ng-if="!vm.customWorkOrderTypeAttribute.id" translate="trakeyeApp.customWorkOrderTypeAttribute.home.create">Create</span> <span ng-if="vm.customWorkOrderTypeAttribute.id" translate="trakeyeApp.customWorkOrderTypeAttribute.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.customWorkOrderTypeAttribute.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="trakeyeApp.customWorkOrderTypeAttribute.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.customWorkOrderTypeAttribute.description"></textarea></div></div><div class="form-group" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.customWorkOrderTypeAttribute.typeValue">Type Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.value" required></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="custom-workorder-type-attribute"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/custom-workorder-type-attribute/custom-workorder-type-attributes.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span data-translate="trakeyeApp.customWorkOrderTypeAttribute.home.title">Work Order Type Attribute DataTypes</span></h3><div class="box-tools custom_WorkOrderTypeAttr"><button class="btn btn-create" ui-sref="custom-workorder-type-attribute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.customWorkOrderTypeAttribute.home.createLabel">Create new Work Order Type Attribute Data Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control input-sm" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.customWorkOrderTypeAttribute.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="name"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span data-translate="trakeyeApp.customWorkOrderTypeAttribute.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="customWorkOrderTypeAttribute in vm.customWorkOrderTypeAttributes  | filter :search track by customWorkOrderTypeAttribute.id"><td><a ui-sref="custom-workorder-type-attribute-detail({id:customWorkOrderTypeAttribute.id})">{{customWorkOrderTypeAttribute.id}}</a></td><td>{{customWorkOrderTypeAttribute.name}}</td><td>{{customWorkOrderTypeAttribute.description}}</td><td><div class="actions"><a ui-sref="custom-workorder-type-attribute-detail({id:customWorkOrderTypeAttribute.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="custom-workorder-type-attribute.edit({id:customWorkOrderTypeAttribute.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="custom-workorder-type-attribute.delete({id:customWorkOrderTypeAttribute.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.customWorkOrderTypeAttributes == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/feasibility-check/feasibility-check-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.feasibilityCheck.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.feasibilityCheck.delete.question" translate-values="{id: \'{{vm.feasibilityCheck.id}}\'}">Are you sure you want to delete this Feasibility Check?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/feasibility-check/feasibility-check-detail.html','<div><h2><span data-translate="trakeyeApp.feasibilityCheck.detail.title">Feasibility Check</span> {{vm.feasibilityCheck.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="trakeyeApp.feasibilityCheck.requestId">Request Id</span></dt><dd><span>{{vm.feasibilityCheck.requestId}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.customerName">Customer Name</span></dt><dd><span>{{vm.feasibilityCheck.customerName}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.phone">Phone</span></dt><dd><span>{{vm.feasibilityCheck.phone}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.email">Email</span></dt><dd><span>{{vm.feasibilityCheck.email}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.createDate">Create Date</span></dt><dd><span>{{vm.feasibilityCheck.createDate}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.updateDate">Update Date</span></dt><dd><span>{{vm.feasibilityCheck.updateDate}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.notes">Notes</span></dt><dd><span>{{vm.feasibilityCheck.notes}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.latitude">Latitude</span></dt><dd><span>{{vm.feasibilityCheck.latitude}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.longitude">Longitude</span></dt><dd><span>{{vm.feasibilityCheck.longitude}}</span></dd><dt><span data-translate="trakeyeApp.feasibilityCheck.address">Address</span></dt><dd><span>{{vm.feasibilityCheck.address}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="feasibility-check-detail.edit({id:vm.feasibilityCheck.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/feasibility-check/feasibility-check-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFeasibilityCheckLabel" data-translate="trakeyeApp.feasibilityCheck.home.createOrEditLabel">Create or edit a Feasibility Check</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group" ng-show="vm.feasibilityCheck.id">\r\n            <label for="id" data-translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.feasibilityCheck.id" readonly />\r\n        </div> --><div class="form-group"><label for="field_requestId"><span translate="trakeyeApp.feasibilityCheck.requestId">Request Id</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <input type="text" class="form-control" name="requestId" id="field_requestId" ng-model="vm.feasibilityCheck.requestId" required><!-- <div ng-show="editForm.requestId.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.requestId.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div> --></div><div class="form-group"><label class="control-label" data-translate="trakeyeApp.feasibilityCheck.customerName" for="field_customerName">Customer Name</label> <input type="text" class="form-control" name="customerName" id="field_customerName" ng-model="vm.feasibilityCheck.customerName"></div><div class="form-group"><label for="field_phone"><span translate="trakeyeApp.feasibilityCheck.phone">Phone</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.feasibilityCheck.phone" ng-maxlength="14" ng-minlength="10" ng-pattern="PHONE_REGEXP" required><p class="help-block" ng-show="editForm.phone.$error.maxlength" translate="global.messages.validate.phone.maxlength" translate-value-max="14">This field cannot be longer than 14 characters.</p><p class="help-block" ng-show="editForm.phone.$error.minlength" translate="global.messages.validate.phone.minlength" translate-value-max="10">This field cannot be lesser than 10 characters.</p><p class="help-block" ng-show="editForm.phone.$error.pattern" translate="global.messages.validate.phone.invalid">Your phone number is invalid.</p><!-- <div ng-show="editForm.phone.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n            </div> --></div><div class="form-group"><label class="control-label" data-translate="trakeyeApp.feasibilityCheck.email" for="field_email">Email</label> <input type="email" class="form-control" name="email" id="field_email" ng-model="vm.feasibilityCheck.email" ng-pattern="EMAIL_REGEXP"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><!-- <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.createDate" for="field_createDate">Create Date</label>\r\n            <input type="number" class="form-control" name="createDate" id="field_createDate"\r\n                    ng-model="vm.feasibilityCheck.createDate"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.updateDate" for="field_updateDate">Update Date</label>\r\n            <input type="number" class="form-control" name="updateDate" id="field_updateDate"\r\n                    ng-model="vm.feasibilityCheck.updateDate"\r\n                    />\r\n        </div> --><div class="form-group"><label class="control-label" data-translate="trakeyeApp.feasibilityCheck.notes" for="field_notes">Notes</label> <input type="text" class="form-control" name="notes" id="field_notes" ng-model="vm.feasibilityCheck.notes"></div><!-- <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.latitude" for="field_latitude">Latitude</label>\r\n            <input type="number" class="form-control" name="latitude" id="field_latitude"\r\n                    ng-model="vm.feasibilityCheck.latitude"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.longitude" for="field_longitude">Longitude</label>\r\n            <input type="number" class="form-control" name="longitude" id="field_longitude"\r\n                    ng-model="vm.feasibilityCheck.longitude"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" data-translate="trakeyeApp.feasibilityCheck.address" for="field_address">Address</label>\r\n            <input type="text" class="form-control" name="address" id="field_address"\r\n                    ng-model="vm.feasibilityCheck.address"\r\n                    />\r\n        </div> --><div class="form-group"><label class="control-label" data-translate="trakeyeApp.feasibilityCheck.notificationType" for="field_notificationType">Notification Type</label> <select class="form-control" name="notificationType" ng-model="vm.feasibilityCheck.notificationType" id="field_notificationType"><option value="EMAIL" data-translate="trakeyeApp.AlertType.EMAIL">EMAIL</option><option value="SMS" data-translate="trakeyeApp.AlertType.SMS">SMS</option></select></div><!-- <div class="form-group">\r\n            <label data-translate="trakeyeApp.feasibilityCheck.user" for="field_user">User</label>\r\n            <select class="form-control" id="field_user" name="user" ng-model="vm.feasibilityCheck.userId" ng-options="user.id as user.login for user in vm.users"            >\r\n                <option value=""></option>\r\n            </select>\r\n        </div>\r\n        <div class="form-group">\r\n            <label data-translate="trakeyeApp.feasibilityCheck.tenant" for="field_tenant">Tenant</label>\r\n            <select class="form-control" id="field_tenant" name="tenant" ng-model="vm.feasibilityCheck.tenantId" ng-options="tenant.id as tenant.id for tenant in vm.tenants"            >\r\n                <option value=""></option>\r\n            </select>\r\n        </div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/feasibility-check/feasibility-checks.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-asterisk"></i> <span translate="trakeyeApp.feasibilityCheck.home.title">Feasibility Checks</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create btn-sm" ui-sref="feasibility-check.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.feasibilityCheck.home.createLabel">Create new Feasibility Check</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.feasibilityCheck.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="requestId"><span data-translate="trakeyeApp.feasibilityCheck.requestId">Request Id</span> <span class="fa fa-sort"></span></th><th jh-sort-by="customerName"><span data-translate="trakeyeApp.feasibilityCheck.customerName">Customer Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="latitude"><span data-translate="trakeyeApp.feasibilityCheck.latitude">Latitude</span> <span class="fa fa-sort"></span></th><th jh-sort-by="longitude"><span data-translate="trakeyeApp.feasibilityCheck.longitude">Longitude</span> <span class="fa fa-sort"></span></th><th jh-sort-by="address"><span data-translate="trakeyeApp.feasibilityCheck.address">Address</span> <span class="fa fa-sort"></span></th><th jh-sort-by="phone"><span data-translate="trakeyeApp.feasibilityCheck.phone">Phone</span> <span class="fa fa-sort"></span></th><th jh-sort-by="email"><span data-translate="trakeyeApp.feasibilityCheck.email">Email</span> <span class="fa fa-sort"></span></th><th jh-sort-by="createDate"><span data-translate="trakeyeApp.feasibilityCheck.createDate">Create Date</span> <span class="fa fa-sort"></span></th><th jh-sort-by="updateDate"><span data-translate="trakeyeApp.feasibilityCheck.updateDate">Update Date</span> <span class="fa fa-sort"></span></th><th jh-sort-by="notes"><span data-translate="trakeyeApp.feasibilityCheck.notes">Notes</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="feasibilityCheck in vm.feasibilityChecks track by feasibilityCheck.id"><!-- <td><a ui-sref="feasibility-check-detail({id:feasibilityCheck.id})">{{feasibilityCheck.id}}</a></td> --><td>{{feasibilityCheck.requestId}}</td><td>{{feasibilityCheck.customerName}}</td><td>{{feasibilityCheck.latitude}}</td><td>{{feasibilityCheck.longitude}}</td><td>{{feasibilityCheck.address}}</td><td>{{feasibilityCheck.phone}}</td><td>{{feasibilityCheck.email}}</td><td>{{feasibilityCheck.createDate | date:\'medium\'}}</td><td>{{feasibilityCheck.updateDate |date:\'medium\'}}</td><td>{{feasibilityCheck.notes}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="feasibility-check-detail({id:feasibilityCheck.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="feasibility-check.edit({id:feasibilityCheck.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="feasibility-check.delete({id:feasibilityCheck.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.feasibilityChecks == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 data-translate="trakeyeApp.feasibilityCheck.home.title">Feasibility Checks</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="feasibility-check.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  data-translate="trakeyeApp.feasibilityCheck.home.createLabel">\r\n                        Create new Feasibility Check\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="requestId"><span data-translate="trakeyeApp.feasibilityCheck.requestId">Request Id</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="customerName"><span data-translate="trakeyeApp.feasibilityCheck.customerName">Customer Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="latitude"><span data-translate="trakeyeApp.feasibilityCheck.latitude">Latitude</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="longitude"><span data-translate="trakeyeApp.feasibilityCheck.longitude">Longitude</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="address"><span data-translate="trakeyeApp.feasibilityCheck.address">Address</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="phone"><span data-translate="trakeyeApp.feasibilityCheck.phone">Phone</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="email"><span data-translate="trakeyeApp.feasibilityCheck.email">Email</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="createDate"><span data-translate="trakeyeApp.feasibilityCheck.createDate">Create Date</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="updateDate"><span data-translate="trakeyeApp.feasibilityCheck.updateDate">Update Date</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="notes"><span data-translate="trakeyeApp.feasibilityCheck.notes">Notes</span> <span class="fa fa-sort"></span></th>\r\n                   <th jh-sort-by="notificationType"><span data-translate="trakeyeApp.feasibilityCheck.notificationType">Notification Type</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="userLogin"><span data-translate="trakeyeApp.feasibilityCheck.user">User</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="tenantId"><span data-translate="trakeyeApp.feasibilityCheck.tenant">Tenant</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="feasibilityCheck in vm.feasibilityChecks track by feasibilityCheck.id">\r\n                    <td><a ui-sref="feasibility-check-detail({id:feasibilityCheck.id})">{{feasibilityCheck.id}}</a></td>\r\n                    <td>{{feasibilityCheck.requestId}}</td>\r\n                    <td>{{feasibilityCheck.customerName}}</td>\r\n                    <td>{{feasibilityCheck.latitude}}</td>\r\n                    <td>{{feasibilityCheck.longitude}}</td>\r\n                    <td>{{feasibilityCheck.address}}</td>\r\n                    <td>{{feasibilityCheck.phone}}</td>\r\n                    <td>{{feasibilityCheck.email}}</td>\r\n                    <td>{{feasibilityCheck.createDate}}</td>\r\n                    <td>{{feasibilityCheck.updateDate}}</td>\r\n                    <td>{{feasibilityCheck.notes}}</td>\r\n                    \r\n                    <td data-translate="{{\'trakeyeApp.AlertType.\' + feasibilityCheck.notificationType}}">{{feasibilityCheck.notificationType}}</td>\r\n                    <td>\r\n                        {{feasibilityCheck.userLogin}}\r\n                    </td>\r\n                    <td>\r\n                        <a ui-sref="tenant-detail({id:feasibilityCheck.tenantId})">{{feasibilityCheck.tenantId}}</a>\r\n                    </td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="feasibility-check-detail({id:feasibilityCheck.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="feasibility-check.edit({id:feasibilityCheck.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="feasibility-check.delete({id:feasibilityCheck.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div>\r\n -->');
$templateCache.put('app/entities/geofence/geofence-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.geofence.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.geofence.delete.question" translate-values="{id: \'{{vm.geofence.id}}\'}">Are you sure you want to delete this Geofence?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/geofence/geofence-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate="trakeyeApp.geofence.detail.title">Geofence</span> - {{vm.geofence.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-4"><dl class="dl-horizontal jh-entity-details"><dt>Name</dt><dd>{{vm.geofence.name}}</dd><dt>Description</dt><dd>{{vm.geofence.description||"NA"}}</dd><dt>Assets</dt><dd><div ng-repeat="asset in vm.geofence.assets"><span class="label label-default">{{asset.name||"NA"}}</span></div></dd><dt>Owner</dt><dd><div ng-repeat="ownedBy in vm.geofence.ownedBy"><span class="label label-default">{{ownedBy.login}}</span></div></dd><dt>Type</dt><dd>{{vm.geofence.geofenceType}}</dd></dl></div><div class="col-md-8"><div id="map_canvas" class="div__map--canvas"></div></div></div><div class="box-buttons"><a ui-sref="{{ vm.previousState }}" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span> Back </a><a ui-sref="geofence.edit({id:vm.geofence.id})" class="btn btn-primary btn-sm pull-right" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER"><span class="glyphicon glyphicon-pencil"></span> Edit</a></div></div></div></div></div></div>');
$templateCache.put('app/entities/geofence/geofence-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.geofence.id" translate="trakeyeApp.geofence.home.create">Create</span> <span ng-if="vm.geofence.id" translate="trakeyeApp.geofence.home.Edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.geofence.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.geofence.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.geofence.description"></textarea></div></div><div class="form-group"><!-- <label class="col-md-3 control-label"> <span\r\n\t\t\t\t\t\t\t\t\ttranslate="trakeyeApp.geofence.assets">assets</span>\r\n\t\t\t\t\t\t\t\t\t<sup><span\r\n\t\t\t\t\t\t\t\t\t\tclass="required-icon"><i\r\n\t\t\t\t\t\t\t\t\t\t\tclass="fa fa-asterisk text-danger"></i></span> </sup>\r\n\t\t\t\t\t\t\t\t</label> --><!--  <div class="col-md-3">\r\n                                    <div isteven-multi-select input-model="vm.multiassets" output-model="vm.geofence.assets" button-label="name" item-label="name" tick-property="ticked" output-properties="id selected">\r\n                                    </div>\r\n                                    <input type="text" ng-model="vm.geofence.assets" name="fence" style="display:none" />\r\n                                </div> --><!-- <div class="col-md-3" ui-sref="asset.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="trakeyeApp.geofence.home.CreateAssetInGeo">\r\n                                    Create Asset\r\n\t\t\t\t\t\t\t\t</div> --><!-- <div class="col-md-3" style="margin-top: 10px;">\r\n                                    <i class="fa fa-plus-square" ng-click="vm.navigateCreateAssetGeo();" style="cursor: pointer;" title=\'Create Asset\'></i>\r\n                                </div> --></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.ownedby">Owner</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control" multiple  name="ownedBy" ng-model="vm.geofence.ownedBy" \r\n\t\t\t\t\t\t\t\t\t\tng-options="user.id as user.login for user in vm.users  track by user.id">\r\n\t\t\t\t\t\t\t\t</select> --><div isteven-multi-select input-model="vm.multiuser" output-model="vm.geofence.ownedBy" button-label="login" item-label="login" tick-property="ticked" helper-elements="all none" output-properties="id selected"></div><input type="text" ng-model="vm.geofence.ownedBy" name="owner" id="input__none" required></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.geofenceType" for="field_type">Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="layout" ng-model="vm.geofenceType" id="field_layout" required><option value="">---Select Geofence Type---</option><option value="MASTER" translate="trakeyeApp.geofence.type.MASTER">MASTER</option><option value="MINI" translate="trakeyeApp.geofence.type.MINI">MINI</option><option value="BUFFER" translate="trakeyeApp.geofence.type.BUFFER">BUFFER</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.coordinates">Coordinates</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><div class="input-group"><input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled="disabled" ng-model="vm.geofence.coordinates" required> <span class="input-group-btn" ng-if="vm.geofence.id==null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Create</button> </span><span class="input-group-btn" ng-if="vm.geofence.id!=null"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">View or Edit</button> </span><span class="input-group-btn" ng-if="vm.geofence.id!=null"><button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm">Destroy and Create</button></span></div><br><div id="map_canvas" class="div__map-canvas" ng-if="vm.geofence.layout!=null || vm.geofence.coordinates != \'\'"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="geofence"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div>');
$templateCache.put('app/entities/geofence/geofence-import.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i>Import Geofences</h3><div class="box-tools ng-scope"><button class="btn btn-create"><span class="fa fa-download"></span> <a href="content/images/geofences.kml" download id="a__text">Sample File</a></button></div></div><!-- /.box-header --><!-- form start --><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file accept="*.kml||*.kml" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only KML file should be uploaded</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.geofence.geofenceType" for="field_type">Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="layout" ng-model="vm.geofencetype" onchange="vm.setGeofenceType()" id="field_layout" required><option value="">---Select Geofence Type---</option><option value="MASTER" translate="trakeyeApp.geofence.type.MASTER">MASTER</option><option value="MINI" translate="trakeyeApp.geofence.type.MINI">MINI</option><option value="BUFFER" translate="trakeyeApp.geofence.type.BUFFER">BUFFER</option></select></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/geofence/geofences.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-street-view"></i> <span>Geofences</span><!-- translate="trakeyeApp.geofence.home.title" --></h3></div><div class="col-md-5 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1); search = null" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2); search = null" data-toggle="tab"><i class="fa fa-map"></i><span class="header-view">Map</span> <span class="header_view">View</span></a></li><!-- <li ng-class="{active:isSet(3)}" ng-click="vm.getGeofenceList()"><a href ng-click="setTab(3); search = null"\r\n                                    data-toggle="tab"><i class="fa fa-briefcase"></i><span class="header-view">Material</span> <span class="header_view">Transaction</span></a></li> --></ul></div><div class="box-tools geofence_labels" ng-if="(isSet(1) || isSet(2)) && (has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER)"><button class="btn btn-create btn-sm" ui-sref="geofence.import"><span class="glyphicon glyphicon-plus"></span> <span>Import</span></button> <button class="btn btn-create btn-sm" ui-sref="geofence.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="alert alert-success" ng-show="vm.success"><p>Request Sent, To Track Your Request Click Here - <a ui-sref="asset-link">Asset Link</a></p></div><div class="row"><div class="col-md-3 pull-right" ng-show="isSet(1)"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" placeholder="{{\'trakeyeApp.geofence.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div><!-- <div class="col-md-3 search-top" ng-show="isSet(2)">\r\n                            <div class="input-group ">\r\n                                <input type="text" ng-model="search" class="form-control " ng-minlength="0"\r\n                                    ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/"\r\n                                    placeholder="{{\'trakeyeApp.geofence.home.search\' | translate}}">\r\n                                <span class="input-group-btn">\r\n                                    <button type="button" class="btn btn-info btn-flat"\r\n                                        ng-click="vm.filterGeofenceSearchMap()">\r\n                                        <i class="fa fa-search"></i></button>\r\n                                </span>\r\n                            </div>\r\n                        </div> --><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(2)"><select id="masterGeofence" class="select2 form-control" ng-model="vm.masterGeofence"><option value="">Select District</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select> <span id="noData" ng-if="!vm.selectCityFilter">*Please Select District</span></div><!-- <div class="col-md-1" ng-show="isSet(2)">\r\n                            <button\r\n                                type="button"\r\n                                value="GOTO"\r\n                                class="btn btn-info btn-flat"\r\n                                ng-click="vm.gotoLatitute()"\r\n                            >\r\n                                GO TO\r\n                            </button>\r\n                        </div> --><div class="col-md-3 dropFilter div--filter" ng-show="isSet(2) && vm.selectCityFilter"><!-- <button type="button" class="btn btn-info btn-flat"\r\n                                ng-click="vm.filterAssetsOnGeofenveMapView()">\r\n                                <i class="fa fa-filter"></i>\r\n                            </button> --><div isteven-multi-select input-model="vm.userGeofences" output-model="vm.selectedGeofence" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceMap()" max-height="150px"></div><input type="text" ng-model="vm.selectedGeofence" name="vm.searchMini" style="display:none" required> <span id="noData" ng-if="vm.selectedGeofence.length < 1">*Please Select Block</span></div><div class="row" ng-show="isSet(1)"><div class="pull-right" ng-show="vm.canDownload"><button class="btn btn-primary button__downloadCsv" ng-click="vm.downloadAttendenceReport()"><span class="glyphicon glyphicon-download"></span>&nbsp;<span translate="entity.action.downloadcsv">Download CSV</span></button> <button class="btn btn-primary button__downloadKml" ng-click="vm.downloadAttendenceReportKml()"><span class="glyphicon glyphicon-download"></span>&nbsp;<span translate="entity.action.downloadkml">Download KML</span></button></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fa fa-sort"></span></th> --><th><input type="checkbox" ng-click="vm.selectAllGeofences()" ng-model="vm.isAllGeofencesSelected"></th><th></th><th jh-sort-by="name"><span translate="trakeyeApp.geofence.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.geofence.description">Description</span></th><th><span>Parent</span> <span class="fa fa-sort"></span></th><th>Geofence Type</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="geofence in vm.geofences | filter: users track by geofence.id" ng-class="{selected: geofence.isChecked}"><!-- <td><a ui-sref="geofence-detail({id:geofence.id})">{{geofence.id}}</a></td> --><td><input type="checkbox" ng-model="geofence.isChecked" ng-change="vm.selectGeofenceEntity(geofence)"></td><!-- <td class="td__listViewRow">\r\n                                        <button class="button__listViewRow" ng-click="vm.geofencesTable(geofence);" expand>\r\n                                            <span class="span__listViewRow" ng-bind="geofence.isExpanded ? \'-\' : \'+\'" ></span>\r\n                                        </button>\r\n                                    </td> --><td class="td__listViewRow" ng-click="vm.geofencesTable(geofence);" expand><span ng-if="!geofence.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="geofence.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{geofence.name}}</td><td>{{geofence.description}}</td><td>{{geofence.parentGeofence[0].name}}</td><td>{{geofence.geofenceType}}</td><td><div class="action"><a ui-sref="geofence-detail({id:geofence.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="geofence.edit({id:geofence.id})" class="action-icons text-primary" title="Edit" ng-if="!vm.has_ROLE_READONLY||has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER"><span class="fa fa-pencil-square"></span> </a><!-- <a ng-if="geofence.geofenceType == \'MINI\'" ng-click="vm.sendAssetLinkRequest(geofence.id,geofence.name)"\r\n                                                class="action-icons text-info" title="Send Asset Link Request">\r\n                                                <span class="fa fa-link"></span>\r\n                                            </a> --></div></td></tr><tr ng-show="geofence.isExpanded"><td></td><td colspan="13"><table class="table__userNames"><thead><th></th><th>UserNames</th></thead><tbody><tr ng-repeat="users in vm.geofenceChildUsers"><td>{{}}</td><td>{{users.login}}</td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.geofences == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><div class="map-view" ng-show="isSet(2)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas1" style="height:{{mapHeight}}px; width:100%"></div></div></div></div></div></div></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.showZoomLocation()" show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label"><span translate=" ">Enter the co-ordinates :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLat" id="field_pinLat" ng-model="vm.getLocationCoordinate" required></div></div><!-- <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span translate=" ">Longitude :</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                        </label>\r\n                        <div class="col-md-8">\r\n                            <input type="number" class="form-control" placeholder="enter the co-ordinates" name="pinLat" id="field_pinLat"\r\n                                ng-model="vm.pinLatLong" required />\r\n                        </div>\r\n                    </div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeGotoLatitute()">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">OK</button></div></form></div></div></div><div id="mapFilterGeofenceModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Block Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done" ng-show="vm.userGeofences.length >= 1"><span class="span__title" ng-show="vm.userGeofences.length >= 1">Select Block</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveGeofenceFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div class="modal fade" id="mappingFixed" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.mappingFixed()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Map Fixed Assets to Spread</span></div><div class="modal-body"><b>Are you sure you want to Map Fixed Asset to Spread Asset in {{vm.geoName}} Geofence ?</b></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.mappingFixed()">No</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.postRequest()">Yes</button></div></div></div></div>');
$templateCache.put('app/entities/group/group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.group.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.group.delete.question" translate-values="{id: \'{{vm.group.id}}\'}">Are you sure you want to delete this Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/group/group-detail.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate="trakeyeApp.group.detail.title">Group</span> - {{vm.group.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.group.name">Name</span></dt><dd><span>{{vm.group.name}}</span></dd><dt><span translate="trakeyeApp.group.description">Description</span></dt><dd><span>{{vm.group.description}}</span></dd><dt><span translate="trakeyeApp.group.createDate">Create Date</span></dt><dd><span>{{vm.group.groupType.createDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.group.updateDate">Update Date</span></dt><dd><span>{{vm.group.groupType.updateDate| date:\'medium\'}}</span></dd><dt><span translate="User">User</span></dt><dd><span>{{vm.group.createdBy}}</span></dd><!--     <dt ><span translate="trakeyeApp.group.ownedby">Owner</span></dt>\r\n\t\t\t\t\t\t        <dd ><span><div ng-repeat="ownedBy in vm.group.ownedBy">\r\n\t\t\t\t\t                        <span class="label label-default">{{ ownedBy.login}}</span>\r\n\t\t\t\t\t                    </div></span></dd> --></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="group.edit({id:vm.group.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/group/group-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.group.id" translate="trakeyeApp.group.home.create">Create</span> <span ng-if="vm.group.id" translate="trakeyeApp.group.home.Edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.group.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.group.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.group.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.group.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.group.groupType" for="field_groupType">Group Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="groupType" ng-model="vm.groupType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.grouptypes track by item.id" required><!-- <option value="">--- Select GroupType ---</option> --><option value="">{{vm.group.groupType.name}}</option></select></div><!-- <div class="col-md-3" ui-sref="group-type.new" style="cursor: pointer; color: -webkit-link; text-decoration: underline;" translate="trakeyeApp.group.home.create">\r\n                                    Create Group Type\r\n                                </div> --><div class="col-md-3 div__mt-10"><i class="fa fa-plus-square i__fa-plus-square" ng-click="vm.navigateGroupTypefromGroup();" title="Create Group Type"></i></div></div><div class="form-group" ng-repeat="attribute in vm.group.groupTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.groupTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.group.id" type="text" class="form-control" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue = attribute.groupTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.group.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span class="span__valid" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.group.id" type="text" class="form-control" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue = attribute.groupTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.group.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span class="span__valid" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern">Enter a Valid Number </span><input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'STRING\' && !vm.group.id" type="text" class="form-control" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue = attribute.groupTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'STRING\' && vm.group.id" type="text" class="form-control" name="value{{$index+1}}"> <span class="span__valid" ng-if="attribute.groupTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern">Enter a Message</span> <select ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue = attribute.groupTypeAttribute.defaultValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name != \'STRING\' && attribute.groupTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.groupTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.group.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.groupTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.group.groupTypeAttributeValues[$index].attributeValue" ng-init="vm.group.groupTypeAttributeValues[$index].attributeValue == attribute.groupTypeAttribute.defaultValue" ng-if="attribute.groupTypeAttribute.attributeDataType.name != \'STRING\' && attribute.groupTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.groupTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.group.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.groupTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="group"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div>');
$templateCache.put('app/entities/group/groups.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-group"></i> <span translate="trakeyeApp.group.home.title">Groups</span></h3><div class="box-tools group_labels"><!-- <button class="btn btn-create btn-sm" ui-sref="group.import" ng-if="has_ROLE_USER_ADMIN">\r\n\t\t\t\t\t\t\t<span class="glyphicon glyphicon-plus"></span> <span > Import </span>\r\n\t\t\t\t\t\t</button> --> <button class="btn btn-create btn-sm" ui-sref="group.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.group.home.createLabel">Create new Group</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.group.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span>\r\n\t\t\t\t\t\t\t\t\t\t<span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.group.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.group.description">Description</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="group in vm.groups | filter: users track by group.id"><!-- <td><a ui-sref="group-detail({id:group.id})">{{group.id}}</a></td> --><td>{{group.name}}</td><td>{{group.description}}</td><td><div class="action"><a ui-sref="group-detail({id:group.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="group.edit({id:group.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.groups == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/group-type/group-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.groupType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.groupType.delete.question" translate-values="{id: \'{{vm.groupType.id}}\'}">Are you sure you want to delete this Group Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/group-type/group-type-detail.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span translate="trakeyeApp.groupType.detail.title">Group Type</span> - {{vm.groupType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.groupType.name">Name</span></dt><dd><span>{{vm.groupType.name}}</span></dd><dt><span translate="trakeyeApp.groupType.description">Description</span></dt><dd><span>{{vm.groupType.description}}</span></dd><dt ng-show="{{vm.groupType.colorcode != null}}"><span translate="trakeyeApp.groupType.colorcode">Colorcode</span></dt><dd ng-show="{{vm.groupType.colorcode != null}}"><span><div class="square" style="background-color: {{vm.groupType.colorcode}}"></div></span></dd><dt ng-show="{{vm.groupType.image != null}}"><span translate="trakeyeApp.groupType.groupimage">Group Image</span></dt><dd ng-show="{{vm.groupType.image != null}}"><div class="col-md-3"><img class="img-responsive img__assetImage" ng-src="data:image/jpeg;base64,{{vm.groupType.image}}"></div></dd><dt><span translate="trakeyeApp.groupType.createDate">Create Date</span></dt><dd><span>{{vm.groupType.createDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.groupType.updateDate">Update Date</span></dt><dd><span>{{vm.groupType.updateDate| date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.groupType.user">User</span></dt><dd><span>{{vm.groupType.createdBy}}</span></dd><div class="form-group div__attribute" ng-repeat="item in vm.groupType.groupTypeAttributes"><dt><span translate="trakeyeApp.groupType.attribute">Attribute</span><span> {{$index + 1}}</span></dt><div class="col-md-6"><span>{{item.name}}</span><span class="span__attribute">{{item.defaultValue}}</span></div></div></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="group-type-detail.edit({id:vm.groupType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/group-type/group-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.groupType.id" translate="trakeyeApp.groupType.home.create">Create</span> <span ng-if="vm.groupType.id" translate="trakeyeApp.groupType.home.edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.groupType.name" for="field_name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-9"><input type="text" id="xyz" class="form-control" name="name" id="field_name" ng-model="vm.groupType.name" required ng-minlength="3" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.groupType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.groupType.description"></textarea></div></div><div class="form-group caseType_repeat" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.groupType.attribute">Attribute</span><span> {{$index + 1}}</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><label class="col-md-1 control-label"><span translate="trakeyeApp.groupType.dataType">Data Type</span><span> {{$index + 1}}</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customGroupTypeAttributes track by item.id"></select></div><label class="col-md-2 control-label"><span translate="trakeyeApp.groupType.defaultValue">Dafault Value</span><span> {{$index + 1}}</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01" required> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/" required> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" required> <select ng-model="item.defaultValue" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="group-type"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/group-type/group-types.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-suitcase"></i> <span translate="trakeyeApp.groupType.home.title">Group Types</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="group-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.groupType.home.createLabel">Create new Group Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.groupType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span> \r\n\t\t\t\t\t\t\t\t\t\t<span class="fa fa-sort"></span></th>--><th jh-sort-by="name"><span translate="trakeyeApp.groupType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.groupType.description">Description</span><span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.groupType.user">User</span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="groupType in vm.groupTypes track by groupType.id "><!-- <td><a ui-sref="group-type-detail({id:groupType.id})">{{groupType.id}}</a></td> --><td>{{groupType.name}}</td><td>{{groupType.description}}</td><td>{{groupType.createdBy}}</td><td><div class="action"><a ui-sref="group-type-detail({id:groupType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="group-type.edit({id:groupType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.groupTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/location-log/location-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.locationLog.id)"><div class="modal-header bg-primary"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body text-center"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.locationLog.delete.question" translate-values="{id: \'{{vm.locationLog.id}}\'}">Are you sure you want to delete this Location Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/location-log/location-log-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.locationLog.detail.title">Location Log</span> {{vm.locationLog.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.locationLog.latitude">Latitude</span></dt><dd><span>{{vm.locationLog.latitude}}</span></dd><dt><span translate="trakeyeApp.locationLog.longitude">Longitude</span></dt><dd><span>{{vm.locationLog.longitude}}</span></dd><dt><span translate="trakeyeApp.locationLog.address">Address</span></dt><dd><span>{{vm.locationLog.address}}</span></dd><dt><span translate="trakeyeApp.locationLog.logSource">Log Source</span></dt><dd><span translate="{{\'trakeyeApp.LogSource.\' + vm.locationLog.logSource}}">{{vm.locationLog.logSource}}</span></dd><dt><span translate="trakeyeApp.locationLog.createdDateTime">Created Date Time</span></dt><dd><span>{{vm.locationLog.createdDateTime | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.locationLog.user">User</span></dt><dd>{{vm.locationLog.userId}}</dd></dl><div class="box-buttons pull-right"><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="location-log-detail.edit({id:vm.locationLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/location-log/location-log-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header bg-primary"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLocationLogLabel" translate="trakeyeApp.locationLog.home.createOrEditLabel">Create or edit a Location Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.locationLog.id"><label class="col-md-3 control-label" for="id" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.locationLog.id" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.locationLog.latitude" for="field_latitude">Latitude</label><div class="col-md-8"><input type="number" class="form-control" name="latitude" id="field_latitude" ng-model="vm.locationLog.latitude" required><div ng-show="editForm.latitude.$invalid"><p class="help-block" ng-show="editForm.latitude.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.latitude.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.locationLog.longitude" for="field_longitude">Longitude</label><div class="col-md-8"><input type="number" class="form-control" name="longitude" id="field_longitude" ng-model="vm.locationLog.longitude" required><div ng-show="editForm.longitude.$invalid"><p class="help-block" ng-show="editForm.longitude.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.longitude.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.locationLog.address" for="field_address">Address</label><div class="col-md-8"><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.locationLog.address"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.locationLog.logSource" for="field_logSource">Log Source</label><div class="col-md-8"><select class="form-control" name="logSource" ng-model="vm.locationLog.logSource" id="field_logSource" required><option value="NP" translate="trakeyeApp.LogSource.NP">NP</option><option value="GPS" translate="trakeyeApp.LogSource.GPS">GPS</option></select><div ng-show="editForm.logSource.$invalid"><p class="help-block" ng-show="editForm.logSource.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/location-log/location-logs.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-map-marker"></i> <span translate="trakeyeApp.locationLog.home.title">Live Monitoring</span></h3></div><!-- <div class="box-tools" has-authority="ROLE_USER">\r\n\t\t\t\t\t\t  <button class="btn btn-create" ui-sref="location-log.new" >\r\n\t\t\t                    <span class="glyphicon glyphicon-plus"></span>\r\n\t\t\t                    <span  translate="trakeyeApp.locationLog.home.createLabel">\r\n\t\t\t                        Create Location Log\r\n\t\t\t                    </span>\r\n\t\t\t                </button>\r\n\t\t\t\t\t</div>\t--><!-- <div class="col-md-4 headerTab">\r\n\t\t\t\t\t\t<ul class="nav nav-pills nav-justified">\r\n\t\t\t\t\t\t\t<li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab"><i class="fa fa-map"></i><span class="header-view">Map</span> <span class="header_view">View</span></a></li>\r\n\t\t\t\t\t\t\t<li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2);" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li>\r\n\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t</div> --></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 search-top pull-right" ng-show="isSet(2)"><div class="input-group"><input type="text" ng-model="users" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="Search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-3 dropFilter" ng-show="isSet(1)"><!-- <button type="button" class="btn btn-info btn-flat"\r\n\t\t\t\t\t\t\t\tng-click="vm.filterAssetsLocationOnMapView()">\r\n\t\t\t\t\t\t\t\t<i class="fa fa-filter"></i>\r\n\t\t\t\t\t\t\t</button> --><div isteven-multi-select input-model="vm.allGeofences" output-model="vm.selectedGeofence" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceMapview()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofence" name="vm.searchMini" style="display:none" required></div><div class="col-md-2" ng-if="vm.geofenceCaseMarkers.length>0"><label style="margin-left:10px;"><input type="checkbox" ng-model="vm.showGeofenceCases" ng-change="vm.toggleGeofenceCaseMarkers()" checked="checked"> Show Incident</label></div><!-- <div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(1)">\r\n\t\t\t\t\t\t\t<select id="searchOnMap" class="select2 form-control" name="search">\r\n\t\t\t\t\t\t\t\t<option value="">Search Vehicle</option>\r\n\t\t\t\t\t\t\t\t<option ng-repeat="item in vm.vehicles" value="{{item}}">{{item.licenseplate}}</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div> --><div class="col-md-3 search-top pull-right" ng-show="isSet(1)" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n\t\t\t\t\t\t\t|| has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT"><div class="input-group"><input type="text" ng-model="vm.searchUser" class="form-control" placeholder="Search User" ng-keyup="vm.onUserSearchChange()"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterUsers()"><i class="fa fa-search"></i></button></span><ul class="search-suggestion" ng-show="vm.showSuggestions"><li ng-repeat="user in vm.filteredUsers" ng-click="vm.selectUser(user)">{{user.login}}</li></ul></div></div></div><div class="row mt-5" ng-show="isSet(1)"><div class="row"><div class="col-md-8" ng-if="has_ROLE_USER_ADMIN||has_ROLE_BA||has_ROLE_OA||has_ROLE_FE"><a ng-click="vm.all()" class="btn btn-md" ng-class="{\'btn-info\':vm.selectedLogs==\'ALL\',\'btn-default\':vm.selectedLogs!=\'ALL\'}"><i class="fa text-info fa-map-marker"></i> All : {{alllength}} users </a><a ng-click="vm.active()" class="btn btn-md" ng-class="{\'btn-success\':vm.selectedLogs==\'ACTIVE\',\'btn-default\':vm.selectedLogs!=\'ACTIVE\'}"><i class="fa text-success fa-map-marker"></i> Active : {{activelength}} users </a><a ng-click="vm.inactive()" class="btn btn-md" ng-class="{\'inactive-bg\':vm.selectedLogs==\'INACTIVE\',\'btn-default\':vm.selectedLogs!=\'INACTIVE\'}"><i class="fa inactive fa-map-marker"></i> Inactive : {{inactivelength}} users </a><a ng-click="vm.idle()" class="btn btn-md" ng-class="{\'btn-warning\':vm.selectedLogs==\'IDLE\',\'btn-default\':vm.selectedLogs!=\'IDLE\'}"><i class="fa fa-map-marker yellow"></i> Idle : {{idlelength}} users </a><a ng-click="vm.absent()" class="btn btn-md" ng-class="{\'btn-warning\':vm.selectedLogs==\'ABSENT\',\'btn-default\':vm.selectedLogs!=\'ABSENT\'}"><i class="fa fa-map-marker grey"></i> Absent : {{absentlength}} users</a></div><div class="col-md-4 text-right"><div class="legend-wrappers"><ul class="legend-lists"><li><span class="legend-boxs legend-actives"></span>Active</li><li><span class="legend-boxs legend-inactives"></span>Inactive</li><li><span class="legend-boxs legend-idles"></span>Idle</li><li><span class="legend-boxs legend-inactives"></span>Absent</li></ul><ul class="legend-lists"><li><img src="content/images/frt_car.png" class="legend-icons">FRT</li><li><img src="content/images/patroller_bike.png" class="legend-icons">PAT</li><li><img src="content/images/fe_icon.png" class="legend-icons">FE</li></ul></div></div></div><div class="row"><div class="col-md-12"><div id="map_canvas" style="height:{{mapHeight}}px; width:100%;"></div></div><!-- <div class="col-md-4" ng-if="locations.length>0">\r\n\t\t\t\t\t\t\t\t\t<div class="table-responsive scroll_table">\r\n\t\t\t\t\t\t\t\t\t\t<table class="jh-table table table-hover">\r\n\t\t\t\t\t\t\t\t\t\t\t<thead class="bg-default">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th>User Name</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th>User ID</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Address</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t</thead>\r\n\t\t\t\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<tr ng-repeat="locationLog in locations \r\n               | filter:{ login: vm.searchUser } \r\n               track by locationLog.userid"ng-mouseenter="highlightUser(locationLog.userid)"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-mouseleave="removeHighlight(locationLog.userid)">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="ellipsis">{{locationLog.firstName}} {{locationLog.lastName}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{locationLog.login}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="ellipsis">{{locationLog.address}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --></div></div></div></div></div></div><!-- \t<div class="row">\r\n\t\t<div class="col-md-12">\r\n\t\t\t<div class="box box-info">\r\n\t\t\t\t <div class="box-header">\r\n\t\t\t\t\t<h3 class="box-title"></h3>\r\n\t\t\t\t</div>\r\n\t\t\t\t  <div class="box-body">\r\n\t\t\t\t\t<div class="table-responsive">\t\t\t\t\t \r\n\t\t\t\t  <table class="jh-table table table-responsive table-hover">\r\n\t\t\t\t\t<thead class="bg-default">\r\n\t\t\t\t\t\t <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n\t\t                    <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n\t\t                    <th jh-sort-by="latitude"><span translate="trakeyeApp.locationLog.latitude">Latitude</span> <span class="fa fa-sort"></span></th>\r\n\t\t                    <th jh-sort-by="longitude"><span translate="trakeyeApp.locationLog.longitude">Longitude</span> <span class="fa fa-sort"></span></th>\r\n\t\t                    <th jh-sort-by="address"><span translate="trakeyeApp.locationLog.address">Address</span> <span class="fa fa-sort"></span></th>\r\n\t\t                    <th jh-sort-by="logSource"><span translate="trakeyeApp.locationLog.logSource">Log Source</span> <span class="fa fa-sort"></span></th>\r\n\t\t                    <th jh-sort-by="createdDateTime"><span translate="trakeyeApp.locationLog.createdDateTime">Created Date Time</span> <span class="fa fa-sort"></span></th>\r\n\t\t                    <th jh-sort-by="createdDateTime"><span>Updated Date Time</span> <span class="fa fa-sort"></span></th>\r\n\t\t                    <th jh-sort-by="userId"><span translate="trakeyeApp.locationLog.user">User</span> <span class="fa fa-sort"></span></th>\r\n\t\t                    <th>Actions</th>\r\n\t\t                </tr>\r\n\t\t            </thead>\r\n\t\t            <tbody>\r\n\t\t                <tr ng-repeat="locationLog in vm.locationLogs | filter : users  track by locationLog.id">\r\n\t\t                    <td><a ui-sref="location-log-detail({id:locationLog.id})">{{locationLog.id}}</a></td>\r\n\t\t                    <td>{{locationLog.latitude}}</td>\r\n\t\t                    <td>{{locationLog.longitude}}</td>\r\n\t\t                    <td>{{locationLog.address}}</td>\r\n\t\t                    <td translate="{{\'trakeyeApp.LogSource.\' + locationLog.logSource}}">{{locationLog.logSource}}</td>\r\n\t\t                    <td>{{locationLog.createdDateTime | date:\'medium\'}}</td>\r\n\t\t                    <td>{{locationLog.updatedDateTime | date:\'medium\'}}</td>\r\n\t\t                    <td>\r\n\t\t                        {{locationLog.userName}}\r\n\t\t                    </td>\r\n\t\t                    <td>\r\n\t\t                        <div class="actions">\r\n\t\t                            <a type="submit"\r\n\t\t                                    ui-sref="location-log-detail({id:locationLog.id})"\r\n\t\t                                    class="btn btn-info btn-sm" ng-if="has_ROLE_USER">\r\n\t\t                                <span class="glyphicon glyphicon-eye-open"></span>\r\n\t\t                            </a>\r\n\t\t                            <a type="submit"\r\n\t\t                                    ui-sref="location-log.edit({id:locationLog.id})"\r\n\t\t                                    class="btn btn-primary btn-sm" ng-if="has_ROLE_USER">\r\n\t\t                                <span class="glyphicon glyphicon-pencil"></span>\r\n\t\t                            </a>\r\n\t\t                            \r\n\t\t                        </div>\r\n\t\t                    </td>\r\n\t\t                </tr>\r\n\t\t\t\t\t</tbody>\r\n\t\t\t\t</table>\r\n\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>--><!-- Modal --><div id="userPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div--travelMap"><!-- Modal content--><div class="modal-content" style="margin-top: 5vh !important;"><div class="modal-header modal-info"><!-- Close Button --> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="reset()"><span aria-hidden="true">&times;</span></button><div style="display:flex; justify-content:space-between; align-items:center; width:100%;"><!-- LEFT SIDE --><div><div class="span__modal-header" style="font-weight:600;">{{vm.userPathName}} - Travel Path</div><div class="span__modal-header">Phone Number - {{vm.userPhoneNumber}}</div></div><!-- RIGHT SIDE --><div style="display:flex; align-items:center; gap:15px;"><label><input type="checkbox" ng-model="vm.showAssets" ng-change="vm.toggleAssets()" checked="checked"> Hide Assets</label><!-- KML Button --> <button type="button" class="btn btn-info btn-flat" ng-click="vm.downloadLoadPath()" style="padding:4px 10px;margin-right: 30px;"><i class="fa fa-download"></i> Download Path (KML)</button><!-- Block Dropdown --> <span style="font-weight:600;">Block:</span> <select style="border:1px solid black;\r\n\t\t\t\t                           color:black;\r\n\t\t\t\t                           height:34px;\r\n\t\t\t\t                           padding:4px 8px;\r\n\t\t\t\t                           border-radius:4px;\r\n\t\t\t\t                           min-width:200px;\r\n\t\t\t\t                           cursor:pointer;" ng-model="vm.selectedUserGeofenceId" ng-change="geofenceTravelledPath()" ng-options="geo.id as geo.name for geo in vm.assetFilterGeofences" required></select></div></div></div><div class="modal-body"><div class="one-line"><label class="control-label">Date Range :</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="day" ng-click="vm.selecterange()">Today</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom" ng-click="vm.customRange()">Custom Date</label><!-- Custom Date Section --><div ng-show="vm.dateRange == \'custom\'" class="form-group one-line"><div><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')">From <i class="glyphicon glyphicon-calendar"></i></button> </span><input type="text" class="form-control" ng-model="vm.fromDate" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.fromDate" enable-time="false" required></div></div><div><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')">To <i class="glyphicon glyphicon-calendar"></i></button> </span><input type="text" class="form-control" ng-model="vm.toDate" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.toDate" enable-time="false" required></div></div><div><button type="button" class="btn btn-info btn-flat" ng-click="vm.onChangeDate()">OK</button></div></div><!-- Distance Info --><div><label class="distance-label">Total Distance : {{vm.totalDistance | number:2}} Km</label> <label class="distance-label">{{totalDistanceTravelled | number:2}}</label><!-- <label class="distance-label">Calculating : {{vm.inProgressDistance}} Km</label> --></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t<label class="control-label col-md-4 location_labels" >Total Distance : {{vm.totalDistance}} KM</label>\r\n\t\t\t\t\t\t<label class="control-label col-md-6 location_labels">{{totalDistanceTravelled}}</label>\r\n\t\t\t\t\t</div> --><div class="row"><div class="col-md-12"><div id="userPath_map_canvas"></div></div></div></div></div></div></div><div id="mapFilterLocationModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Block Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapLocationFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Block</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveLocationFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.allGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.allGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="mapFilterLoadPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">User Block Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapLoadPathFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select User Block</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveLoadPathFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal"><div class="row"><span id="noData" ng-show="vm.assetFilterGeofences.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.assetFilterGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedUserGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div>');
$templateCache.put('app/entities/log-type/log-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.taskType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.taskType.delete.question" translate-values="{id: \'{{vm.taskType.id}}\'}">Are you sure you want to delete this Task Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/log-type/log-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.logType.detail.title">Log Type</span> {{vm.logType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.logType.name">Name</span></dt><dd><span>{{vm.logType.name}}</span></dd><dt><span translate="trakeyeApp.logType.description">Description</span></dt><dd><span>{{vm.logType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.logType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.logType.createdDate">Created Date</span></dt><dd><span>{{vm.logType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.logType.updateDate">Update Date</span></dt><dd><span>{{vm.logType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.logType.user">User</span></dt><dd>{{vm.logType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="log-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="log-type.edit({id:vm.logType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/log-type/log-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myLogTypeLabel"><span ng-if="!vm.logType.id" translate="trakeyeApp.logType.home.create">Create</span> <span ng-if="vm.logType.id" translate="trakeyeApp.logType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.logType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.logType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.logType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.logType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.logType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.logType.logtypeimage" for="field_assetimage">LogType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="logTypeImage" id="logTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.logType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 logType_showImg" ng-if="vm.logType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageLog" ng-src="data:image/jpeg;base64,{{vm.logType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.logType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.logType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customLogTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.logType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.logType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.logType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.logType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span></label> <label class="col-md-2"><span>Category</span></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group logType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.logType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.logType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customLogTypeAttributes track by item.id" required></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.logCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.logTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" required></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.logType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="log-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/log-type/log-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.logType.home.title">Log Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="log-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.logType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.logType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.logType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.logType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.logType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="logType in vm.logTypes  | filter : search  track   by logType.id"><!--  <td><a ui-sref="log-type-detail({id:logType.id})">{{logType.id}}</a></td> --><td>{{logType.name}}</td><td>{{logType.description}}</td><!--  <td>{{logType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{logType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{logType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="log-type-detail({id:logType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="log-type.edit({id:logType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.logTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/material-type/material-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.materialType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.materialType.delete.question" translate-values="{id: \'{{vm.materialType.id}}\'}">Are you sure you want to delete this Material Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/material-type/material-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.materialType.detail.title">Material Type</span> {{vm.materialType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.materialType.name">Name</span></dt><dd><span>{{vm.materialType.name}}</span></dd><dt><span translate="trakeyeApp.materialType.description">Description</span></dt><dd><span>{{vm.materialType.description}}</span></dd><dt>Physical Quantity Type</dt><dd><span>{{vm.materialType.trUnitOfMeasurement.physicalQuantityType}}</span></dd><dt>Units of Measurement</dt><dd><span>{{vm.materialType.trUnitOfMeasurement.unitsOfMeasurement}}</span></dd><dt>Symbol</dt><dd><span>{{vm.materialType.trUnitOfMeasurement.symbol}}</span></dd><!-- \r\n\t\t\t\t\t\t\t<dt><span translate="trakeyeApp.materialType.UoM_Name">UoM Name</span></dt>\r\n\t\t\t\t\t        <dd>\r\n\t\t\t\t\t            <span>{{vm.materialType.trUnitOfMeasurement.name}}</span>\r\n\t\t\t\t\t        </dd> \r\n\r\n\t\t\t\t\t\t\t<dt><span translate="trakeyeApp.materialType.unitsOfMeasurement">Units Of Measurement</span></dt>\r\n\t\t\t\t\t        <dd>\r\n\t\t\t\t\t            <span>{{vm.materialType.trUnitOfMeasurement.unitsOfMeasurement}}</span>\r\n\t\t\t\t\t        </dd> --><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.materialType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.materialType.createdDate">Created Date</span></dt><dd><span>{{vm.materialType.createDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.materialType.updateDate">Update Date</span></dt><dd><span>{{vm.materialType.updateDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><!--  <dt><span translate="trakeyeApp.materialType.user">User</span></dt>\r\n\t\t\t\t\t        <dd>\r\n\t\t\t\t\t            {{vm.materialType.user.login}}\r\n\t\t\t\t\t        </dd>  --></dl><div class="box-buttons pull-right"><a ui-sref="material-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="material-type.edit({id:vm.materialType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/material-type/material-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myMaterialTypeLabel"><span ng-if="!vm.materialType.id" translate="trakeyeApp.materialType.home.create">Create</span> <span ng-if="vm.materialType.id" translate="trakeyeApp.materialType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.materialType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-4"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.materialType.name" ng-maxlength="20" required><p class="help-block" ng-show="editForm.name.$error.maxlength">maximum 20 characters allowed.</p></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.materialType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.materialType.description"></textarea></div></div><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.materialType.unitsOfMeasurement">Units Of Measurement</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-6"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>UoM</th><th>Physical Quantity</th><th>Symbol</th></tr></thead><tbody><tr><td><select class="form-control select2" ng-model="vm.materialType.trUnitOfMeasurement.id" ng-options="item.id as item.unitsOfMeasurement\r\n\t\t\t\t\t\t\t\t\t\t\t\tfor item in vm.optionsUoM" required><option value="">--- Select UoM ---</option></select></td><td><select class="form-control" ng-model="vm.materialType.trUnitOfMeasurement.id" ng-options="item.id as item.physicalQuantityType\r\n\t\t\t\t\t\t\t\t\t\t\t\tfor item in vm.optionsUoM" disabled="disabled"><!-- <option value="" >\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t--- Select Quantity ---\r\n\t\t\t\t\t\t\t\t\t\t\t\t</option> --></select></td><td><select class="form-control" ng-model="vm.materialType.trUnitOfMeasurement.id" ng-options="item.id as item.symbol\r\n\t\t\t\t\t\t\t\t\t\t\t\tfor item in vm.optionsUoM" disabled="disabled"></select></td></tr><td colspan="2" ng-show="vm.optionsUoM.length == 0"><h4>No Data available</h4></td></tbody></table><!-- <select class="form-control select2" ng-model="vm.materialType.trUnitOfMeasurement.id" required>\r\n\t\t\t\t\t\t\t\t<option value="" >\r\n\t\t\t\t\t\t\t\t\t--- Select UoM ---\r\n\t\t\t\t\t\t\t\t</option>\r\n\r\n\t\t\t\t\t\t\t</select> --></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.materialType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><!-- <div class="form-group" >\r\n\t\t\t\t\t\t  \r\n\t\t\t\t\t\t   <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.materialType.materialtypeimage" for="field_assetimage">MaterialType Image</span> \r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t   <div class="col-md-7">\r\n\t\t\t\t\t\t   <input type="file" name="file" ng-model="materialTypeImage" id="materialTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP">\r\n\t\t\t\t\t       <p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.materialType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p>\r\n\t\t\t\t\t      \r\n\t\t\t\t\t\t   </div>\r\n\t\t\t\t\t\t    <div class="col-md-2 materialType_showImg" ng-if="vm.materialType.id">\r\n\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<div class="form-group" ng-if="allimages">\r\n\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t<div class="col-md-2 col-md-offset-2">\r\n\t\t\t\t\t\t   \t\t<img class="img-responsive img__showImageMaterial" ng-src="data:image/jpeg;base64,{{vm.materialType.image}}">\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t</div> --><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.materialType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.materialType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customMaterialTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.materialType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.materialType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.materialType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.materialType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group materialType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.materialType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.materialType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customMaterialTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.materialCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.materialTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.materialType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="material-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/material-type/material-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.materialType.home.title">Material Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="material-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.materialType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.materialType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.materialType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.materialType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.materialType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="materialType in vm.materialTypes  | filter : search  track   by materialType.id"><!--  <td><a ui-sref="material-type-detail({id:materialType.id})">{{materialType.id}}</a></td> --><td>{{materialType.name}}</td><td>{{materialType.description}}</td><!--  <td>{{materialType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{materialType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{materialType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="material-type-detail({id:materialType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="material-type.edit({id:materialType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.materialTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/project-type/project-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.projectType.delete.question" translate-values="{id: \'{{vm.projectType.id}}\'}">Are you sure you want to delete this Project Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project-type/project-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.projectType.detail.title">Project Type</span> {{vm.projectType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.projectType.name">Name</span></dt><dd><span>{{vm.projectType.name}}</span></dd><dt><span translate="trakeyeApp.projectType.description">Description</span></dt><dd><span>{{vm.projectType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.projectType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.projectType.createdDate">Created Date</span></dt><dd><span>{{vm.projectType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.projectType.updateDate">Update Date</span></dt><dd><span>{{vm.projectType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.projectType.user">User</span></dt><dd>{{vm.projectType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="project-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="project-type.edit({id:vm.projectType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/project-type/project-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myProjectTypeLabel"><span ng-if="!vm.projectType.id" translate="trakeyeApp.projectType.home.create">Create</span> <span ng-if="vm.projectType.id" translate="trakeyeApp.projectType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.projectType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.projectType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.projectType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.projectType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.projectType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.projectType.projecttypeimage" for="field_assetimage">ProjectType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="projectTypeImage" id="projectTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.projectType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 projectType_showImg" ng-if="vm.projectType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageProject" ng-src="data:image/jpeg;base64,{{vm.projectType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.projectType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.projectType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customProjectTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.projectType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.projectType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.projectType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.projectType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group projectType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.projectType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.projectType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customProjectTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.projectCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.projectTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.projectType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="project-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/project-type/project-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.projectType.home.title">Project Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="project-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.projectType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.projectType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.projectType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.projectType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.projectType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="projectType in vm.projectTypes  | filter : search  track   by projectType.id"><!--  <td><a ui-sref="project-type-detail({id:projectType.id})">{{projectType.id}}</a></td> --><td>{{projectType.name}}</td><td>{{projectType.description}}</td><!--  <td>{{projectType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{projectType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{projectType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="project-type-detail({id:projectType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="project-type.edit({id:projectType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.projectTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/resource-type/resource-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.resourceType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.resourceType.delete.question" translate-values="{id: \'{{vm.resourceType.id}}\'}">Are you sure you want to delete this Resource Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/resource-type/resource-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.resourceType.detail.title">Resource Type</span> {{vm.resourceType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.resourceType.name">Name</span></dt><dd><span>{{vm.resourceType.name}}</span></dd><dt><span translate="trakeyeApp.resourceType.description">Description</span></dt><dd><span>{{vm.resourceType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.resourceType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.resourceType.createdDate">Created Date</span></dt><dd><span>{{vm.resourceType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.resourceType.updateDate">Update Date</span></dt><dd><span>{{vm.resourceType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.resourceType.user">User</span></dt><dd>{{vm.resourceType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="resource-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="resource-type.edit({id:vm.resourceType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/resource-type/resource-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myResourceTypeLabel"><span ng-if="!vm.resourceType.id" translate="trakeyeApp.resourceType.home.create">Create</span> <span ng-if="vm.resourceType.id" translate="trakeyeApp.resourceType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.resourceType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.resourceType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.resourceType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.resourceType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.resourceType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.resourceType.resourcetypeimage" for="field_assetimage">ResourceType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="resourceTypeImage" id="resourceTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.resourceType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 resourceType_showImg" ng-if="vm.resourceType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageResource" ng-src="data:image/jpeg;base64,{{vm.resourceType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.resourceType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.resourceType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customResourceTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.resourceType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.resourceType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.resourceType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.resourceType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group resourceType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.resourceType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.resourceType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customResourceTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.resourceCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.resourceTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.resourceType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="resource-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/resource-type/resource-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.resourceType.home.title">Project Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="resource-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.resourceType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.resourceType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.resourceType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.resourceType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.resourceType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="resourceType in vm.resourceTypes  | filter : search  track   by resourceType.id"><!--  <td><a ui-sref="resource-type-detail({id:resourceType.id})">{{resourceType.id}}</a></td> --><td>{{resourceType.name}}</td><td>{{resourceType.description}}</td><!--  <td>{{resourceType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{resourceType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{resourceType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="resource-type-detail({id:resourceType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="resource-type.edit({id:resourceType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.resourceTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/route-type/route-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.routeType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.routeType.delete.question" translate-values="{id: \'{{vm.routeType.id}}\'}">Are you sure you want to delete this Route Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/route-type/route-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.routeType.detail.title">Route Type</span> {{vm.routeType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.routeType.name">Name</span></dt><dd><span>{{vm.routeType.name}}</span></dd><dt><span translate="trakeyeApp.routeType.description">Description</span></dt><dd><span>{{vm.routeType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.routeType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.routeType.createdDate">Created Date</span></dt><dd><span>{{vm.routeType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.routeType.updateDate">Update Date</span></dt><dd><span>{{vm.routeType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.routeType.user">User</span></dt><dd>{{vm.routeType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="route-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="route-type.edit({id:vm.routeType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/route-type/route-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myRouteTypeLabel"><span ng-if="!vm.routeType.id" translate="trakeyeApp.routeType.home.create">Create</span> <span ng-if="vm.routeType.id" translate="trakeyeApp.routeType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.routeType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.routeType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.routeType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.routeType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.routeType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.routeType.routetypeimage" for="field_assetimage">RouteType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="routeTypeImage" id="routeTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.routeType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 routeType_showImg" ng-if="vm.routeType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageRoute" ng-src="data:image/jpeg;base64,{{vm.routeType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.routeType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.routeType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customRouteTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.routeType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.routeType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.routeType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.routeType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group routeType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.routeType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.routeType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customRouteTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.routeCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.routeTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.routeType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="route-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/route-type/route-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.routeType.home.title">Route Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="route-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.routeType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.routeType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.routeType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.routeType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.routeType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="routeType in vm.routeTypes  | filter : search  track   by routeType.id"><!--  <td><a ui-sref="route-type-detail({id:routeType.id})">{{routeType.id}}</a></td> --><td>{{routeType.name}}</td><td>{{routeType.description}}</td><!--  <td>{{routeType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{routeType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{routeType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="route-type-detail({id:routeType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="route-type.edit({id:routeType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.routeTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/row-type/row-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rowType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.rowType.delete.question" translate-values="{id: \'{{vm.rowType.id}}\'}">Are you sure you want to delete this Row Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/row-type/row-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.rowType.detail.title">Row Type</span> {{vm.rowType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.rowType.name">Name</span></dt><dd><span>{{vm.rowType.name}}</span></dd><dt><span translate="trakeyeApp.rowType.description">Description</span></dt><dd><span>{{vm.rowType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.rowType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.rowType.createdDate">Created Date</span></dt><dd><span>{{vm.rowType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.rowType.updateDate">Update Date</span></dt><dd><span>{{vm.rowType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.rowType.user">User</span></dt><dd>{{vm.rowType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="row-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="row-type.edit({id:vm.rowType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/row-type/row-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myRowTypeLabel"><span ng-if="!vm.rowType.id" translate="trakeyeApp.rowType.home.create">Create</span> <span ng-if="vm.rowType.id" translate="trakeyeApp.rowType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.rowType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.rowType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.rowType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.rowType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.rowType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.rowType.rowtypeimage" for="field_assetimage">RowType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="rowTypeImage" id="rowTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.rowType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 rowType_showImg" ng-if="vm.rowType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageRow" ng-src="data:image/jpeg;base64,{{vm.rowType.image}}"></div></div></div><div class="form-group"><label class="col-md-2 control-label" for="field_description">Select Color <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <input class="ml-15" type="color" ng-model="vm.rowType.colorcode"><!-- <div class="col-md-9 mt-5">\r\n\t\t\t\t\t\t\t\t<div class="square--CYAN square" ng-click="vm.colorcode(\'CYAN\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--BLACK square" ng-click="vm.colorcode(\'BLACK\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--BLUE square" ng-click="vm.colorcode(\'BLUE\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--BLUEVIOLET square" ng-click="vm.colorcode(\'BLUEVIOLET\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--BROWN square" ng-click="vm.colorcode(\'BROWN\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--CHARTREUSE square" ng-click="vm.colorcode(\'CHARTREUSE\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--CRIMSON square" ng-click="vm.colorcode(\'CRIMSON\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--YELLOW square" ng-click="vm.colorcode(\'YELLOW\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--MAGENTA square" ng-click="vm.colorcode(\'MAGENTA\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--DEEPPINK square" ng-click="vm.colorcode(\'DEEPPINK\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--LIGHTCORAL square" ng-click="vm.colorcode(\'LIGHTCORAL\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--DARKORANGE square" ng-click="vm.colorcode(\'DARKORANGE\')"></div>\r\n\t\t\t\t\t\t\t</div> --></div><!-- <div class="form-group" ng-show="vm.rowType.colorcode"></div>\r\n\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t<span for="field_colorcode">Colorcode</span>\r\n\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n\t\t\t\t\t\t\t</sup>\r\n\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t<input type="text" class="form-control" name="colorcode" id="field_name"\r\n\t\t\t\t\t\t\t\tng-model="vm.rowType.colorcode" required readonly>\r\n\t\t\t\t\t\t</div> --></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.rowType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.rowType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customRowTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.rowType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.rowType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.rowType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.rowType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span></label> <label class="col-md-2"><span>Category</span></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group rowType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.rowType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.rowType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customRowTypeAttributes track by item.id" required></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue"> <select ng-model="item.defaultValue" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.defaultValue }}" ng-if="item.defaultValue" disabled="disabled" selected="selected">{{ item.defaultValue }}</option><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.rowCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.rowTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" required></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.rowType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="row-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/row-type/row-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.rowType.home.title">Row Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="row-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.rowType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.rowType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.rowType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.rowType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.rowType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="rowType in vm.rowTypes  | filter : search  track   by rowType.id"><!--  <td><a ui-sref="row-type-detail({id:rowType.id})">{{rowType.id}}</a></td> --><td>{{rowType.name}}</td><td>{{rowType.description}}</td><!--  <td>{{rowType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{rowType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{rowType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="row-type-detail({id:rowType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="row-type.edit({id:rowType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.rowTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/section-type/section-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sectionType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.sectionType.delete.question" translate-values="{id: \'{{vm.sectionType.id}}\'}">Are you sure you want to delete this Section Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/section-type/section-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.sectionType.detail.title">Section Type</span> {{vm.sectionType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.sectionType.name">Name</span></dt><dd><span>{{vm.sectionType.name}}</span></dd><dt><span translate="trakeyeApp.sectionType.description">Description</span></dt><dd><span>{{vm.sectionType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.sectionType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.sectionType.createdDate">Created Date</span></dt><dd><span>{{vm.sectionType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.sectionType.updateDate">Update Date</span></dt><dd><span>{{vm.sectionType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.sectionType.user">User</span></dt><dd>{{vm.sectionType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="section-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="section-type.edit({id:vm.sectionType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/section-type/section-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="mySectionTypeLabel"><span ng-if="!vm.sectionType.id" translate="trakeyeApp.sectionType.home.create">Create</span> <span ng-if="vm.sectionType.id" translate="trakeyeApp.sectionType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.sectionType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.sectionType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.sectionType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.sectionType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.sectionType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.sectionType.sectiontypeimage" for="field_assetimage">SectionType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="sectionTypeImage" id="sectionTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.sectionType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 sectionType_showImg" ng-if="vm.sectionType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageSection" ng-src="data:image/jpeg;base64,{{vm.sectionType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.sectionType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.sectionType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customSectionTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.sectionType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.sectionType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.sectionType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.sectionType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group sectionType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.sectionType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.sectionType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customSectionTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.sectionCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.sectionTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.sectionType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="section-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/section-type/section-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.sectionType.home.title">Section Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="section-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.sectionType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.sectionType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.sectionType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.sectionType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.sectionType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="sectionType in vm.sectionTypes  | filter : search  track   by sectionType.id"><!--  <td><a ui-sref="section-type-detail({id:sectionType.id})">{{sectionType.id}}</a></td> --><td>{{sectionType.name}}</td><td>{{sectionType.description}}</td><!--  <td>{{sectionType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{sectionType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{sectionType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="section-type-detail({id:sectionType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="section-type.edit({id:sectionType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.sectionTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/service-type/service-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.serviceType.id)"><div class="modal-body text-center mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.serviceType.delete.question" translate-values="{id: \'{{vm.serviceType.id}}\'}">Are you sure you want to delete this Service Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-type/service-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.serviceType.detail.title">Service Type</span> {{vm.serviceType.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.serviceType.name">Name</span></dt><dd><span>{{vm.serviceType.name}}</span></dd><dt><span translate="trakeyeApp.serviceType.description">Description</span></dt><dd><span>{{vm.serviceType.description}}</span></dd><dt><span translate="trakeyeApp.serviceType.createdDate">Created Date</span></dt><dd><span>{{vm.serviceType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.serviceType.updatedDate">Updated Date</span></dt><dd><span>{{vm.serviceType.updatedDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.serviceType.user">User</span></dt><dd>{{vm.serviceType.createdBy}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="service-type.edit({id:vm.serviceType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/service-type/service-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span ng-if="!vm.serviceType.id" translate="trakeyeApp.serviceType.home.create">Create</span> <span ng-if="vm.serviceType.id" translate="trakeyeApp.serviceType.home.Edit">Edit</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group" ng-show="vm.serviceType.id">\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label" for="id" translate="global.field.id">ID</label>\r\n\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t <input type="text" class="form-control" id="id" name="id" ng-model="vm.serviceType.id" readonly>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.serviceType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.serviceType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.serviceType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.serviceType.description"></textarea></div></div><!--  <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" placeholder="item{{$index + 1}}"   required id="field_key" name="field" ng-readonly="item.name == \'SLA\'"  ng-model="item.name">\r\n\t\t\t\t\t\t\t</div> \r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.value">Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_value" name="field"  ng-model="item.value"  required>\r\n\t\t\t\t\t\t\t</div>   \r\n\t\t\t\t\t\t\t<div class="col-md-2 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div> --><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t       \r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null"  ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in attributetypes">{{atttype }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.serviceType.home.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t --><div class="form-group caseType_repeat" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.serviceType.home.attribute">Attribute</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><label class="col-md-1 control-label"><span translate="trakeyeApp.serviceType.home.dataType">Data Type</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customServiceTypeAttributes track by item.id"></select></div><label class="col-md-2 control-label"><span translate="trakeyeApp.serviceType.home.value">Dafault Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="number" ng-if="item.attributeDataType.name == \'\'" class="form-control" id="field_value" name="types" ng-model="item.value"> <input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/" required> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" required> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select><!-- <select ng-model="item.value"  ng-if="item.dataType == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select> --></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="service-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/service-type/service-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-paper-plane"></span> <span translate="trakeyeApp.serviceType.home.title">Incident Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="service-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.serviceType.home.createLabel">Create Service Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.serviceType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.serviceType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.serviceType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.serviceType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="serviceType in vm.serviceTypes | filter :search track by serviceType.id"><!--  <td><a ui-sref="service-type-detail({id:serviceType.id})">{{serviceType.id}}</a></td> --><td>{{serviceType.name}}</td><td>{{serviceType.description}}</td><!--  <td>\r\n\t\t\t\t                        {{serviceType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="service-type-detail({id:serviceType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a type="submit" ui-sref="service-type.edit({id:serviceType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.serviceTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/task-log/task-log.dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-tasks"></i> <span ng-if="!vm.taskLogs.id">Create {{vm.labelLog}} </span><span ng-if="vm.taskLogs.id">Edit {{vm.labelLog}}</span></h3></div></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><!-- <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>Task Name</span>\r\n                    </label>\r\n                    <div class="col-md-7">\r\n                        <input type="text" class="form-control" name="name" id="field_name"\r\n                            ng-model="vm.routeName.name" disabled />\r\n                    </div>\r\n                </div> --><div class="form-group" ng-if="vm.taskLogs.taskLogType == \'PROGRESS\'"><label class="col-md-3 control-label"><span>Work Date</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'workDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_serviceDate" type="text" class="form-control" name="workDate" ng-model="vm.taskLogs.workDate" datetime-picker="dd/MM/yyyy hh:mm a " is-open="vm.datePickerOpenStatus.workDate" datepicker-options="vm.options" required><!-- <input type="date" class="form-control"\r\n                                name="workDate" ng-model="vm.taskLogs.workDate" id="dateInput" required>   --></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Select Log</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <button type="button" class="btn btn-primary btn-sm ml-5" ng-click="vm.removeMarker()" title="Clear Selected Points"><span class="fa fa-refresh"></span></button><div id="map_canvasStart" class="div__map-canvas col-md-8"></div><div class="pull-right"><span id="myspan">Zoom : {{vm.objectRouteImg.zoomLevel}}</span></div><!--  <div class="col-md-6">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>To Route</span>\r\n                            </label>\r\n                                <div id="map_canvasEnd" class="div__map-canvas"></div>\r\n                    </div> --></div><!-- <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span >From Point</span>\r\n                    </label>\r\n                    <div class="col-md-2">\r\n                        <input type="number" class="form-control" name="pinLat" id="field_pinLat"\r\n                            ng-model="vm.pinLat"  disabled />\r\n                    </div>\r\n                    <div class="col-md-1">\r\n                        <button type="button" class="btn btn-primary btn-sm" \r\n                            ng-click="vm.addMarker(\'from\')" title="Clear">\r\n                            <span class="fa fa-refresh"></span>\r\n                        </button>\r\n                    </div>\r\n                    <label class="col-md-2 control-label">\r\n                        <span>To Point</span>\r\n                    </label>\r\n                    <div class="col-md-2">\r\n                        <input type="number" class="form-control" name="pinLong" id="field_pinLong"\r\n                            ng-model="vm.pinLong" disabled />\r\n                    </div>\r\n                    <div class="col-md-1">\r\n                        <button type="button" class="btn btn-primary btn-sm" \r\n                            ng-click="vm.addMarker(\'to\')" title="Clear">\r\n                            <span class="fa fa-refresh"></span>\r\n                        </button>\r\n                    </div>\r\n                </div> --><div class="form-group"><label class="col-md-3 control-label"><span ng-if="vm.taskLogs.taskLogType == \'PROGRESS\'">Work Length (mtrs)</span> <span ng-if="vm.taskLogs.taskLogType == \'OBSTACLE\'">Obstacle Length (mtrs)</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><input type="number" class="form-control" name="name" ng-model="vm.taskLogs.workLength" required min="0"></div></div><div class="form-group" ng-if="vm.taskLogs.taskLogType == \'OBSTACLE\'"><label class="col-md-3 control-label"><span>Reason</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><textarea name="comment" maxlength="255" placeholder="Type your reason here..." ng-model="vm.taskLogs.reason" class="form-control reasonComment" required></textarea></div></div><div class="form-group" ng-if="vm.taskLogs.taskLogType == \'PROGRESS\'"><label class="col-md-3 control-label"><span>No of Work Hours</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><input type="number" class="form-control" name="numberOfHours" ng-model="vm.taskLogs.numberOfHours" ng-max="maxNoOfWorkingHours" min="0" required></div></div><div class="form-group" ng-if="(vm.taskLogs.id && vm.taskLogs.taskLogType == \'OBSTACLE\') && (has_ROLE_VENDOR_ADMIN || has_ROLE_ROLLOUT_MANAGER ||\r\n                has_ROLE_ROLLOUT_VENDOR || has_ROLE_ROLLOUT_FE)"><label class="col-md-3 control-label"><span>Task Type</span></label><div class="col-md-3"><select class="form-control" name="status" ng-model="vm.taskLogs.taskLogType" required><option value="OBSTACLE">OBSTACLE</option><option value="PROGRESS">PROGRESS</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Log Type</span><!-- <sup><span class="required-icon"><i\r\n                                            class="fa fa-asterisk text-danger"></i></span></sup> --></label><div class="col-md-4"><select class="form-control select2" name="logType" ng-model="vm.logType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                    vm.logTypes track by item.id" ng-disabled="!Roles.logType" style="width: 100%"><option value="">--- Select LogType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.taskLogs.logTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.logTypeAttribute.name}}</span></label><div class="col-md-4"><input ng-model="vm.taskLogs.logTypeAttributeValues[$index].attributeValue" ng-if="attribute.logTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.taskLogs.id" type="text" class="form-control" ng-init="vm.taskLogs.logTypeAttributeValues[$index].attributeValue = attribute.logTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.taskLogs.logTypeAttributeValues[$index].attributeValue" ng-if="attribute.logTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.taskLogs.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.logTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.taskLogs.logTypeAttributeValues[$index].attributeValue" ng-if="attribute.logTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.taskLogs.id" type="text" class="form-control" ng-init="vm.taskLogs.logTypeAttributeValues[$index].attributeValue = attribute.logTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.taskLogs.logTypeAttributeValues[$index].attributeValue" ng-if="attribute.logTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.taskLogs.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.logTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.taskLogs.logTypeAttributeValues[$index].attributeValue" ng-if="attribute.logTypeAttribute.attributeDataType.name == \'STRING\' && !vm.taskLogs.id" type="text" class="form-control" ng-init="vm.taskLogs.logTypeAttributeValues[$index].attributeValue = attribute.logTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.taskLogs.logTypeAttributeValues[$index].attributeValue" ng-if="attribute.logTypeAttribute.attributeDataType.name == \'STRING\' && vm.taskLogs.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.logTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.taskLogs.logTypeAttributeValues[$index].attributeValue" ng-init="vm.taskLogs.logTypeAttributeValues[$index].attributeValue = attribute.logTypeAttribute.defaultValue" ng-if="attribute.logTypeAttribute.attributeDataType.name != \'STRING\' && attribute.logTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.logTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.taskLogs.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.logTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.taskLogs.logTypeAttributeValues[$index].attributeValue" ng-init="vm.taskLogs.logTypeAttributeValues[$index].attributeValue == attribute.logTypeAttribute.defaultValue" ng-if="attribute.logTypeAttribute.attributeDataType.name != \'STRING\' && attribute.logTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.logTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.taskLogs.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.logTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div><div class="form-group" ng-if="vm.taskLogs.id"><label class="col-md-3 control-label" for="field_verified">Verified</label><div class="col-md-8"><input type="checkbox" class="checkbox" name="verified" id="field_verified" ng-model="vm.taskLogs.verified" ng-true-value="true" ng-false-value="false" ng-disabled="!Roles.TASK_VERIFIED"></div></div><!-- <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>Status</span>\r\n                        <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                        </sup>\r\n                    </label>\r\n                    <div class="col-md-3">\r\n                        <select class="form-control" name="status" ng-model="vm.taskLogs.status" \r\n                    required>\r\n                    <option value="NEW" >NEW</option>\r\n                                    <option value="INPROGRESS" >IN PROGRESS</option>\r\n                                    <option value="PENDING" >PENDING</option>\r\n                                    <option value="ASSIGNED" >ASSIGNED</option>\r\n                                    <option value="RESOLVED" >RESOLVED</option>\r\n\t\t\t\t\t\t\t\t\t<option value="CANCELLED">CANCELLED</option>\r\n                    </select>\r\n                    </div> \r\n             </div> --><!-- <div class="form-group">\r\n                <label class="col-md-3 control-label">\r\n                    <span>Approved By</span>\r\n                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                    </sup>\r\n                </label>\r\n                <div class="col-md-3">\r\n                    <select class="form-control" name="status" ng-model="vm.taskLogs.approvedByUserId" id="field_status"\r\n                required>\r\n                <option value=\'2431\' > User </option>\r\n            </select>\r\n                </div>\r\n\r\n                \r\n            </div> --></div><div class="box-footer"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" onclick="history.back()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form><!-- \r\n       <form ng-show="vm.isEnableStep" name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()"\r\n                        show-validation>\r\n            <div class="box-body">\r\n                <div class="containerwf">\t\r\n                    <div class="wrapperwf">\t\r\n                    <div class="arrow-steps clearfix">\r\n                              <div class="step current"> <span>Task Log</span> </div>\r\n                              <div class="step"> <span>Material</span> </div>\r\n                              <div class="step"> <span>Resource</span> </div>\r\n                    </div>\r\n                </div> </div>\r\n\r\n                <div ng-show="isSet(1)">\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Select Route</span>\r\n                          <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <button type="button" class="btn btn-primary btn-sm ml-5" \r\n                            ng-click="vm.removeMarker()" title="Clear">\r\n                            <span class="fa fa-refresh"></span>\r\n                        </button>\r\n                            <div id="map_canvasStart" class="div__map-canvas col-md-8"></div>\r\n                    \r\n                </div>\r\n\r\n                <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>Work Date</span>\r\n                        <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                        </sup>\r\n                    </label>\r\n                    <div class="col-md-3">\r\n                        <div class="input-group">\r\n                                <input type="date" class="form-control"\r\n                                name="workDate" ng-model="vm.taskLogs.workDate" id="dateInput" required> \r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>Work Length (meter)</span>\r\n                        <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                        </sup>\r\n                    </label>\r\n                    <div class="col-md-3">\r\n                        <input type="number" class="form-control" name="name" \r\n                            ng-model="vm.taskLogs.workLength" required min="0" />\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>No of Work Hours</span>\r\n                        <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                        </sup>\r\n                    </label>\r\n                    <div class="col-md-3">\r\n                        <input type="number" class="form-control" name="numberOfHours" \r\n                            ng-model="vm.taskLogs.numberOfHours" max="8" min="0" required />\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>Status</span>\r\n                        <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                        </sup>\r\n                    </label>\r\n                    <div class="col-md-3">\r\n                        <select class="form-control" name="status" ng-model="vm.taskLogs.status" \r\n                    required>\r\n                    <option value="NEW" >NEW</option>\r\n                                    <option value="INPROGRESS" >IN PROGRESS</option>\r\n                                    <option value="PENDING" >PENDING</option>\r\n                                    <option value="ASSIGNED" >ASSIGNED</option>\r\n                                    <option value="RESOLVED" >RESOLVED</option>\r\n\t\t\t\t\t\t\t\t\t<option value="CANCELLED">CANCELLED</option>\r\n                    </select>\r\n                    </div> \r\n                </div>\r\n\r\n\r\n             <div class="form-group">\r\n                <label class="col-md-3 control-label">\r\n                    <span>Approved By</span>\r\n                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                    </sup>\r\n                </label>\r\n                <div class="col-md-3">\r\n                    <select class="form-control" name="status" ng-model="vm.taskLogs.approvedByUserId" id="field_status"\r\n                required>\r\n                <option value=\'2431\' > User </option>\r\n            </select>\r\n                </div>\r\n            </div>\r\n                </div>\r\n\r\n                <div ng-show="isSet(2)">\r\n\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Transaction Type</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <select class="form-control" name="status" ng-model="vm.taskLogsMaterial.transactionType" \r\n                        required>\r\n                        \r\n                       <option ng-repeat="item in vm.transactionType" value="{{item}}">{{item}}</option>\r\n                        </select>\r\n                        </div> \r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Transaction Date</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <div class="input-group">\r\n                                    <input type="date" class="form-control"\r\n                                    name="workDate" ng-model="vm.taskLogsMaterial.transactionDate" id="dateInput" required> \r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n    \r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>No of Units</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <input type="number" class="form-control" name="name" \r\n                                ng-model="vm.taskLogsMaterial.noOfUnits" required min="0" />\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Innvoice Number</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <input type="text" class="form-control" name="name" \r\n                                ng-model="vm.taskLogsMaterial.invoiceNumber" required min="0" />\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Remarks</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <input type="text" class="form-control" name="name" \r\n                                ng-model="vm.taskLogsMaterial.remarks" required min="0" />\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Material</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <select class="form-control" name="status" ng-model="vm.taskLogsMaterial.material" \r\n                        required>\r\n                        \r\n                       <option ng-repeat="item in vm.materials" value="{{item.id}}">{{item.name}}</option>\r\n                        </select>\r\n                        </div> \r\n                    </div>\r\n\r\n\r\n\r\n                </div>\r\n                \r\n            </div>\r\n            <jhi-alert></jhi-alert>\r\n            <div class="box-footer" >\r\n                <div class="col-md-12 next-button" ng-show="isSet(1)"\r\n\t\t\t\t\t\t\tstyle="text-align:right;margin-right:20px;">\r\n\t\t\t\t\t\t\t<button type="button" class="btn btn-primary btn-sm next"\r\n\t\t\t\t\t\t\t\tng-disabled="editForm.$invalid" ng-click="setTab(2)" >\r\n\t\t\t\t\t\t\t\t<span>Next</span>\r\n\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-arrow-right"></span>\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="col-md-12 next-button" ng-show="isSet(2)"\r\n\t\t\t\t\t\t\tstyle="text-align:right; margin-right:20px;">\r\n\t\t\t\t\t\t\t<button type="button" class="prev btn btn-primary btn-sm pull-left" ng-click="setTab(1)">\r\n\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-arrow-left"></span>\r\n\t\t\t\t\t\t\t\t<span> Back </span>\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t<button type="button" class="btn btn-primary btn-sm next"\r\n\t\t\t\t\t\t\t    ng-click="setTab(3)">\r\n\t\t\t\t\t\t\t\t<span>Next</span>\r\n\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-arrow-right"></span>\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="col-md-12 save-buttons " ng-show="isSet(3)"\r\n\t\t\t\t\t\t\tstyle="text-align:right;margin-right:20px;">\r\n\t\t\t\t\t\t\t<button type="button" class="prev btn btn-primary btn-sm pull-left" ng-click="setTab(2)">\r\n\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-arrow-left"></span>\r\n\t\t\t\t\t\t\t\t<span>Back</span>\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t<button type="submit" ng-disabled="editForm.$invalid"\r\n                        class="btn btn-primary btn-sm">\r\n                        <span class="glyphicon glyphicon-save"></span>\r\n                        <span translate="entity.action.save">Save</span>\r\n                    </button>\r\n\t\t\t\t\t\t</div>\r\n            </div>\r\n        </form> --></div></div></div></div><route-image obj="vm.objectRouteImg"></route-image><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form name="pinForm" role="form" class="form-horizontal" novalidate show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label" for="pinA"><span translate=" ">Point A :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinA" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateA" required></div></div><div class="form-group"><label class="col-md-4 control-label" for="pinB"><span translate=" ">Point B :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinB" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateB" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'modalLatLongs\')">Cancel</button> <button type="button" class="btn btn-primary" ng-disabled="!vm.getLocationCoordinateA || !vm.getLocationCoordinateB" ng-click="vm.onLocationCoordinates()">OK</button></div></form></div></div></div>');
$templateCache.put('app/entities/task-log/task-log.html','<!-- <div class="content">\r\n    <div class="row">\r\n        <div class="col-md-12">\r\n          <div class="box box-solid">\r\n            <div class="box-header">\r\n                <div class="pull-left">\r\n                    <h3 class="box-title"><i class="fa fa-tasks"></i>\r\n                        <span translate="dailyTaskLogs.title"></span>\r\n                    </h3>\r\n                </div>\r\n            </div>\r\n            <div class="box-body">\r\n                <jhi-alert></jhi-alert>\r\n                <div class="table-responsive mt-10">\r\n                    <table class="jh-table table table-responsive table-hover">\r\n                        <thead class="bg-default">\r\n                            <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                                <th>Work Date</th>\r\n                                <th>Work Length (meter)</th>\r\n                                <th>Actions</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr ng-repeat-start="task in  vm.taskLogs" >\r\n                                <td>{{task.workDate}}</td>\r\n                                <td>{{task.workLength}}</td>\r\n                                <td>\r\n                                    <div class="action">\r\n                                        <a ui-sref="task-log-detail({id:task.id})"\r\n                                            class="action-icons text-info" title="View">\r\n                                            <span class="fa fa-eye"></span>\r\n                                        </a>\r\n                                    </div>\r\n                                </td>\r\n                            </tr>\r\n                            <tr ng-repeat-end></tr>\r\n                            <tr>\r\n                                <td class="td__noDataAvailable" colspan="10" ng-show=" vm.taskLogs == 0">\r\n                                    <h4>No data available</h4>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                    <div class="row">\r\n                        <div class="col-md-4">\r\n                            <div class="count-length">\r\n                                <jhi-item-count page="vm.page" total="vm.queryCount"\r\n                                    items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n                            </div>\r\n                        </div>\r\n                        <div class="col-md-8">\r\n                            <div class="pagination-list pull-right">\r\n                                <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page"\r\n                                    ng-change="vm.transition()"></uib-pagination>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            </div>\r\n          </div>\r\n      </div>\r\n</div> -->');
$templateCache.put('app/entities/task-type/task-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.taskType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.taskType.delete.question" translate-values="{id: \'{{vm.taskType.id}}\'}">Are you sure you want to delete this Task Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/task-type/task-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.taskType.detail.title">Task Type</span> {{vm.taskType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.taskType.name">Name</span></dt><dd><span>{{vm.taskType.name}}</span></dd><dt><span translate="trakeyeApp.taskType.description">Description</span></dt><dd><span>{{vm.taskType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.taskType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.taskType.createdDate">Created Date</span></dt><dd><span>{{vm.taskType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.taskType.updateDate">Update Date</span></dt><dd><span>{{vm.taskType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.taskType.user">User</span></dt><dd>{{vm.taskType.user.login}}</dd><dt><span>Task Type Order</span></dt><dd>{{vm.taskType.taskTypeOrder}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="task-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="task-type.edit({id:vm.taskType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/task-type/task-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTaskTypeLabel"><span ng-if="!vm.taskType.id" translate="trakeyeApp.taskType.home.create">Create</span> <span ng-if="vm.taskType.id" translate="trakeyeApp.taskType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.taskType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.taskType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.taskType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.taskType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.taskType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.taskType.tasktypeimage" for="field_assetimage">TaskType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="taskTypeImage" id="taskTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.taskType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 taskType_showImg" ng-if="vm.taskType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageTask" ng-src="data:image/jpeg;base64,{{vm.taskType.image}}"></div></div></div><div class="form-group"><label class="col-md-2 control-label"><span>Task Type Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.taskType.taskTypeOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" required></div></div><div class="form-group"><label class="col-md-2 control-label"><span>Task Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.taskType.taskCategory" ng-options="item.key as item.value for item in vm.storeConfig[\'ROLLOUT_TASK_CATEGORY\']" required><option value="">--- Select Task Category ---</option></select></div></div><div class="form-group"><label class="col-md-2 control-label"><span>Task Stage</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.taskType.taskStage" ng-options="item.key as item.value for item in vm.storeConfig[\'ROLLOUT_TASK_STAGE\']" required><option value="">--- Select Task Stage ---</option></select></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.taskType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.taskType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customTaskTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.taskType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.taskType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.taskType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.taskType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span></label> <label class="col-md-2"><span>Category</span></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group taskType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.taskType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.taskType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customTaskTypeAttributes track by item.id" required></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.taskCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.taskTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" required></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.taskType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="task-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/task-type/task-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.taskType.home.title">Task Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="task-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.taskType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.taskType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.taskType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.taskType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.taskType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="taskType in vm.taskTypes  | filter : search  track   by taskType.id"><!--  <td><a ui-sref="task-type-detail({id:taskType.id})">{{taskType.id}}</a></td> --><td>{{taskType.name}}</td><td>{{taskType.description}}</td><!--  <td>{{taskType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{taskType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{taskType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="task-type-detail({id:taskType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="task-type.edit({id:taskType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.taskTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tenant/tenant-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tenant.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.tenant.delete.question" translate-values="{id: \'{{vm.tenant.id}}\'}">Are you sure you want to delete this Tenant?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tenant/tenant-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.tenant.detail.title">Tenant</span> - {{vm.tenant.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.tenant.organization">Organization</span></dt><dd><span>{{vm.tenant.organization}}</span></dd><dt><span translate="trakeyeApp.tenant.loginName">Login Name</span></dt><dd><span>{{vm.tenant.loginName}}</span></dd><dt><span translate="trakeyeApp.tenant.email">Email</span></dt><dd><span>{{vm.tenant.email}}</span></dd><dt><span translate="trakeyeApp.tenant.phone">Phone</span></dt><dd><span>{{vm.tenant.phone}}</span></dd><dt><span translate="trakeyeApp.tenant.city">City</span></dt><dd><span>{{vm.tenant.city}}</span></dd><dt><span translate="trakeyeApp.tenant.address">Address</span></dt><dd><span>{{vm.tenant.address}}</span></dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tenant-detail.edit({id:vm.tenant.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div><!-- <div>\r\n    <h2><span translate="trakeyeApp.tenant.detail.title">Tenant</span> {{vm.tenant.id}}</h2>\r\n    <hr>\r\n    <jhi-alert-error></jhi-alert-error>\r\n    <dl class="dl-horizontal jh-entity-details">\r\n        <dt><span translate="trakeyeApp.tenant.organization">Organization</span></dt>\r\n        <dd>\r\n            <span>{{vm.tenant.organization}}</span>\r\n        </dd>\r\n        <dt><span translate="trakeyeApp.tenant.loginName">Login Name</span></dt>\r\n        <dd>\r\n            <span>{{vm.tenant.loginName}}</span>\r\n        </dd>\r\n        <dt><span translate="trakeyeApp.tenant.email">Email</span></dt>\r\n        <dd>\r\n            <span>{{vm.tenant.email}}</span>\r\n        </dd>\r\n        <dt><span translate="trakeyeApp.tenant.phone">Phone</span></dt>\r\n        <dd>\r\n            <span>{{vm.tenant.phone}}</span>\r\n        </dd>\r\n        <dt><span translate="trakeyeApp.tenant.city">City</span></dt>\r\n        <dd>\r\n            <span>{{vm.tenant.city}}</span>\r\n        </dd>\r\n        <dt><span translate="trakeyeApp.tenant.address">Address</span></dt>\r\n        <dd>\r\n            <span>{{vm.tenant.address}}</span>\r\n        </dd>\r\n        <dt><span translate="trakeyeApp.tenant.createdDate">Created Date</span></dt>\r\n        <dd>\r\n            <span>{{vm.tenant.createdDate}}</span>\r\n        </dd>\r\n        <dt><span translate="trakeyeApp.tenant.updatedDate">Updated Date</span></dt>\r\n        <dd>\r\n            <span>{{vm.tenant.updatedDate}}</span>\r\n        </dd>\r\n    </dl>\r\n\r\n    <button type="submit"\r\n            ui-sref="{{ vm.previousState }}"\r\n            class="btn btn-info">\r\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span>\r\n    </button>\r\n\r\n    <button type="button" ui-sref="tenant-detail.edit({id:vm.tenant.id})" class="btn btn-primary">\r\n        <span class="glyphicon glyphicon-pencil"></span>\r\n        <span class="hidden-xs hidden-sm" translate="entity.action.edit"> Edit</span>\r\n    </button>\r\n</div> -->');
$templateCache.put('app/entities/tenant/tenant-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myUserLabel"><span ng-if="!vm.tenant.id" translate="trakeyeApp.tenant.home.create">Create</span> <span ng-if="vm.tenant.id" translate="trakeyeApp.tenant.home.edit">Edit</span></h3></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tenant.id"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-7"><input type="text" class="form-control" id="id" name="id" ng-model="vm.tenant.id" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.tenant.organization">Organization</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="organization" id="field_organization" ng-model="vm.tenant.organization" ng-required ng-minlength="3" ng-maxlength="50" ng-pattern="/^[a-zA-Z0-9]*$/"><div ng-show="editForm.organization.$invalid"><p class="help-block" ng-show="editForm.organization.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.organization.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.organization.$error.pattern" translate="entity.validation.pattern">This field should follow pattern "^[a-zA-Z0-9]*$".</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.tenant.loginName">Login Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="loginName" id="field_loginName" ng-model="vm.tenant.loginName" ng-minlength="3" ng-maxlength="50" ng-pattern="/^[a-zA-Z0-9]*$/" ng-readonly="vm.tenant.id" ng-required><div ng-show="editForm.loginName.$invalid"><p class="help-block" ng-show="editForm.loginName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.loginName.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.loginName.$error.pattern" translate="entity.validation.pattern">This field should follow pattern "/^[a-zA-Z0-9]*$/".</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.tenant.email">Email</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.tenant.email" ng-pattern="EMAIL_REGEXP" ng-required ng-maxlength="100" ng-readonly="vm.tenant.id"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.tenant.phone">Phone</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-7"><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.tenant.phone" ng-maxlength="14" ng-minlength="10" ng-pattern="PHONE_REGEXP" required><p class="help-block" ng-show="editForm.phone.$error.maxlength" translate="global.messages.validate.phone.maxlength" translate-value-max="14">This field cannot be longer than 14 characters.</p><p class="help-block" ng-show="editForm.phone.$error.minlength" translate="global.messages.validate.phone.minlength" translate-value-max="10">This field cannot be lesser than 10 characters.</p><p class="help-block" ng-show="editForm.phone.$error.pattern" translate="global.messages.validate.phone.invalid">Your phone number is invalid.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span ttranslate="trakeyeApp.tenant.city">City</span></label><div class="col-md-7"><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.tenant.city"></div></div><div class="form-group"><label class="col-md-3 control-label"><span ttranslate="trakeyeApp.tenant.address">Address</span></label><div class="col-md-7"><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.tenant.address"></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button class="btn btn-default btn-sm" ui-sref="tenant"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div><!-- <form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myTenantLabel" translate="trakeyeApp.tenant.home.createOrEditLabel">Create or edit a Tenant</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.tenant.id">\r\n            <label for="id" translate="global.field.id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.tenant.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" translate="trakeyeApp.tenant.organization" for="field_organization">Organization</label>\r\n            <input type="text" class="form-control" name="organization" id="field_organization"\r\n                    ng-model="vm.tenant.organization"\r\n                    required ng-minlength="3" ng-maxlength="50" ng-pattern="/^[a-zA-Z0-9]*$/" />\r\n            <div ng-show="editForm.organization.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.organization.$error.required" translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n                <p class="help-block"\r\n                    ng-show="editForm.organization.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">\r\n                    This field is required to be at least 3 characters.\r\n                </p>\r\n                <p class="help-block"\r\n                    ng-show="editForm.organization.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">\r\n                    This field cannot be longer than 50 characters.\r\n                </p>\r\n                <p class="help-block"\r\n                    ng-show="editForm.organization.$error.pattern" translate="entity.validation.pattern" translate-value-pattern="^[a-zA-Z0-9]*$">\r\n                    This field should follow pattern "^[a-zA-Z0-9]*$".\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" translate="trakeyeApp.tenant.loginName" for="field_loginName">Login Name</label>\r\n            <input type="text" class="form-control" name="loginName" id="field_loginName"\r\n                    ng-model="vm.tenant.loginName"\r\n                    required ng-minlength="3" ng-maxlength="50" ng-pattern="/^[a-zA-Z0-9]*$/" />\r\n            <div ng-show="editForm.loginName.$invalid">\r\n                <p class="help-block"\r\n                    ng-show="editForm.loginName.$error.required" translate="entity.validation.required">\r\n                    This field is required.\r\n                </p>\r\n                <p class="help-block"\r\n                    ng-show="editForm.loginName.$error.minlength" translate="entity.validation.minlength" translate-value-min="3">\r\n                    This field is required to be at least 3 characters.\r\n                </p>\r\n                <p class="help-block"\r\n                    ng-show="editForm.loginName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">\r\n                    This field cannot be longer than 50 characters.\r\n                </p>\r\n                <p class="help-block"\r\n                    ng-show="editForm.loginName.$error.pattern" translate="entity.validation.pattern" translate-value-pattern="^[a-zA-Z0-9]*$">\r\n                    This field should follow pattern "^[a-zA-Z0-9]*$".\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" translate="trakeyeApp.tenant.email" for="field_email">Email</label>\r\n            <input type="text" class="form-control" name="email" id="field_email"\r\n                    ng-model="vm.tenant.email" ng-pattern="EMAIL_REGEXP"\r\n                     />\r\n            <div ng-show="editForm.email.$invalid">\r\n\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t   ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength"\r\n\t\t\t\t\t\t\t\t   translate-value-max="100">\r\n\t\t\t\t\t\t\t\t\tThis field cannot be longer than 100 characters.\r\n\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t   ng-show="editForm.email.$error.pattern" translate="global.messages.validate.email.invalid">\r\n\t\t\t\t\t\t\t\t\tYour e-mail is invalid.\r\n\t\t\t\t\t\t\t\t</p>  \r\n\t\t\t\t\t\t\t</div>         \r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" translate="trakeyeApp.tenant.phone" for="field_phone">Phone</label>\r\n            <input type="text" class="form-control" name="phone" id="field_phone"\r\n                    ng-model="vm.tenant.phone"\r\n                     />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" translate="trakeyeApp.tenant.city" for="field_city">City</label>\r\n            <input type="text" class="form-control" name="city" id="field_city"\r\n                    ng-model="vm.tenant.city"\r\n                     />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" translate="trakeyeApp.tenant.address" for="field_address">Address</label>\r\n            <input type="text" class="form-control" name="address" id="field_address"\r\n                    ng-model="vm.tenant.address"\r\n                     />\r\n        </div>\r\n       <div class="form-group">\r\n            <label class="control-label" translate="trakeyeApp.tenant.createdDate" for="field_createdDate">Created Date</label>\r\n            <input type="number" class="form-control" name="createdDate" id="field_createdDate"\r\n                    ng-model="vm.tenant.createdDate"\r\n                     />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" translate="trakeyeApp.tenant.updatedDate" for="field_updatedDate">Updated Date</label>\r\n            <input type="number" class="form-control" name="updatedDate" id="field_updatedDate"\r\n                    ng-model="vm.tenant.updatedDate"\r\n                     />\r\n        </div>  \r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n -->');
$templateCache.put('app/entities/tenant/tenants.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-user"></span> <span translate="trakeyeApp.tenant.home.title">Tenants</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="tenant.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.tenant.home.createLabel">Create Tenant</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-2 pull-right"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_]{3,}$/" placeholder="{{\'trakeyeApp.tenant.home.search\' | translate}}" aria-invalid="false"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="organization"><span translate="trakeyeApp.tenant.organization">Organization</span> <span class="fa fa-sort"></span></th><th jh-sort-by="loginName"><span translate="trakeyeApp.tenant.loginName">Login Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="email"><span translate="trakeyeApp.tenant.email">Email</span> <span class="fa fa-sort"></span></th><th jh-sort-by="phone"><span translate="trakeyeApp.tenant.phone">Phone</span> <span class="fa fa-sort"></span></th><th jh-sort-by="city"><span translate="trakeyeApp.tenant.city">City</span> <span class="fa fa-sort"></span></th><th jh-sort-by="address"><span translate="trakeyeApp.tenant.address">Address</span> <span class="fa fa-sort"></span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="tenant in vm.tenants   | filter :search track by tenant.id"><td><a ui-sref="tenant-detail({id:tenant.id})">{{tenant.id}}</a></td><td>{{tenant.organization}}</td><td>{{tenant.loginName}}</td><td>{{tenant.email}}</td><td>{{tenant.phone}}</td><td>{{tenant.city}}</td><td>{{tenant.address}}</td><td><div class="actions"><a ui-sref="tenant-detail({id:tenant.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="tenant.edit({id:tenant.id})" class="actions-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><!--<a ui-sref="tenant.delete({id:tenant.id})"\r\n\t\t\t\t\t                                class="action-icons text-danger">\r\n\t\t\t\t\t                            <span class="fa fa-times-circle"></span>\r\n\t\t\t\t\t                        </a>--></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.tenants == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><!-- <div>\r\n    <h2 translate="trakeyeApp.tenant.home.title">Tenants</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="tenant.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span  translate="trakeyeApp.tenant.home.createLabel">\r\n                        Create new Tenant\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="organization"><span translate="trakeyeApp.tenant.organization">Organization</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="loginName"><span translate="trakeyeApp.tenant.loginName">Login Name</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="email"><span translate="trakeyeApp.tenant.email">Email</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="phone"><span translate="trakeyeApp.tenant.phone">Phone</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="city"><span translate="trakeyeApp.tenant.city">City</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="address"><span translate="trakeyeApp.tenant.address">Address</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="createdDate"><span translate="trakeyeApp.tenant.createdDate">Created Date</span> <span class="fa fa-sort"></span></th>\r\n                    <th jh-sort-by="updatedDate"><span translate="trakeyeApp.tenant.updatedDate">Updated Date</span> <span class="fa fa-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="tenant in vm.tenants track by tenant.id">\r\n                    <td><a ui-sref="tenant-detail({id:tenant.id})">{{tenant.id}}</a></td>\r\n                    <td>{{tenant.organization}}</td>\r\n                    <td>{{tenant.loginName}}</td>\r\n                    <td>{{tenant.email}}</td>\r\n                    <td>{{tenant.phone}}</td>\r\n                    <td>{{tenant.city}}</td>\r\n                    <td>{{tenant.address}}</td>\r\n                    <td>{{tenant.createdDate}}</td>\r\n                    <td>{{tenant.updatedDate}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="tenant-detail({id:tenant.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-xs hidden-sm" translate="entity.action.view"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="tenant.edit({id:tenant.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="tenant.delete({id:tenant.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div> -->');
$templateCache.put('app/entities/terrain-type/terrain-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.terrainType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.terrainType.delete.question" translate-values="{id: \'{{vm.terrainType.id}}\'}">Are you sure you want to delete this Terrain Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/terrain-type/terrain-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.terrainType.detail.title">Terrain Type</span> {{vm.terrainType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.terrainType.name">Name</span></dt><dd><span>{{vm.terrainType.name}}</span></dd><dt><span translate="trakeyeApp.terrainType.description">Description</span></dt><dd><span>{{vm.terrainType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.terrainType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span translate="trakeyeApp.terrainType.createdDate">Created Date</span></dt><dd><span>{{vm.terrainType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.terrainType.updateDate">Update Date</span></dt><dd><span>{{vm.terrainType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.terrainType.user">User</span></dt><dd>{{vm.terrainType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="terrain-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="terrain-type.edit({id:vm.terrainType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/terrain-type/terrain-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTerrainTypeLabel"><span ng-if="!vm.terrainType.id" translate="trakeyeApp.terrainType.home.create">Create</span> <span ng-if="vm.terrainType.id" translate="trakeyeApp.terrainType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.terrainType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.terrainType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.terrainType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.terrainType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.terrainType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.terrainType.terraintypeimage" for="field_assetimage">TerrainType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="terrainTypeImage" id="terrainTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.terrainType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 terrainType_showImg" ng-if="vm.terrainType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageTerrain" ng-src="data:image/jpeg;base64,{{vm.terrainType.image}}"></div></div></div><div class="form-group"><label class="col-md-2 control-label" for="field_description">Select Color <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <input class="ml-15" type="color" ng-model="vm.terrainType.colorcode"><!-- <div class="col-md-9 mt-5">\r\n\t\t\t\t\t\t\t\t<div class="square--CYAN square" ng-click="vm.colorcode(\'CYAN\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--BLACK square" ng-click="vm.colorcode(\'BLACK\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--BLUE square" ng-click="vm.colorcode(\'BLUE\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--BLUEVIOLET square" ng-click="vm.colorcode(\'BLUEVIOLET\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--BROWN square" ng-click="vm.colorcode(\'BROWN\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--CHARTREUSE square" ng-click="vm.colorcode(\'CHARTREUSE\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--CRIMSON square" ng-click="vm.colorcode(\'CRIMSON\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--YELLOW square" ng-click="vm.colorcode(\'YELLOW\')"></div>&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--MAGENTA square" ng-click="vm.colorcode(\'MAGENTA\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--DEEPPINK square" ng-click="vm.colorcode(\'DEEPPINK\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--LIGHTCORAL square" ng-click="vm.colorcode(\'LIGHTCORAL\')"></div>\r\n\t\t\t\t\t\t\t\t&nbsp;&nbsp;\r\n\t\t\t\t\t\t\t\t<div class="square--DARKORANGE square" ng-click="vm.colorcode(\'DARKORANGE\')"></div>\r\n\t\t\t\t\t\t\t</div> --></div><!-- <div class="form-group" ng-show="vm.terrainType.colorcode">\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span for="field_colorcode">Colorcode</span>\r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n\t\t\t\t\t\t\t\t</sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" name="colorcode" id="field_name"\r\n\t\t\t\t\t\t\t\t\tng-model="vm.terrainType.colorcode" required readonly>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.terrainType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.terrainType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customTerrainTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.terrainType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.terrainType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.terrainType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.terrainType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span></label> <label class="col-md-2"><span>Category</span></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group terrainType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.terrainType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.terrainType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customTerrainTypeAttributes track by item.id" required></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue"> <select ng-model="item.defaultValue" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{ atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.terrainCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.terrainTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" required></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.terrainType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="terrain-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/terrain-type/terrain-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.terrainType.home.title">Terrain Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="terrain-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.terrainType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.terrainType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.terrainType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.terrainType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.terrainType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="terrainType in vm.terrainTypes  | filter : search  track   by terrainType.id"><!--  <td><a ui-sref="terrain-type-detail({id:terrainType.id})">{{terrainType.id}}</a></td> --><td>{{terrainType.name}}</td><td>{{terrainType.description}}</td><!--  <td>{{terrainType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{terrainType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{terrainType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="terrain-type-detail({id:terrainType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="terrain-type.edit({id:terrainType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.terrainTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-case/show-hide-case.html','<div class="content"><div class="row" id="genericReport"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-check-square-o"></i> <span translate=" ">Show/Hide Incident</span></h3></div><form class="form-horizontal" name="reportForm"><div class="box-body border"><div class="form-group"><label class="col-sm-2 control-label"><span>Enter Incident Id</span></label><div class="col-sm-4"><input type="number" ng-model="vm.caseId" ng-pattern="/^[0-9]*$/" required></div></div><div class="col-sm-3 td__noDataAvailable" ng-if="vm.status == 200" ng-hide="vm.status == 0"><h3>Incident Updated successfully</h3><i class="fa fa-check main-content__checkmark fs9_cG"></i></div><div class="col-sm-3 td__noDataAvailable" ng-if="vm.status != 200" ng-hide="vm.status == 0"><h3>Please Enter Valid CaseId</h3><i class="fa fa-times main-content__checkmark fs9_cR"></i></div></div><div class="col-md-12 box-footer"><div class="col-md-2"><button class="btn btn-primary" ng-disabled="reportForm.$invalid" ng-click="vm.showCase()">Show Incident <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div><div class="col-md-2"></div><div class="col-md-2"><button class="btn btn-primary" ng-disabled="reportForm.$invalid" ng-click="vm.hideCase()">Hide Incident <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trCase.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this incident needs to be deleted before deleting incident</p><p translate="trakeyeApp.trCase.delete.question" translate-values="{id: \'{{vm.trCase.id}}\'}">Are you sure you want to delete this Incident?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-case/tr-case-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.trCase.detail.title">Incident</span> {{vm.trCase.id}}</h3><button class="btn btn-primary btn-sm pull-right" ng-click="showCaseImages()" style="margin-left: 8px;">Show Images</button> <button class="btn btn-primary btn-sm pull-right" ng-click="vm.showHistory()" style="margin-left: 8px;">Show History</button> <button class="btn btn-primary btn-sm pull-right" ng-click="vm.showMaterial()" style="margin-left: 8px;">Show Material</button> <button class="btn btn-primary btn-sm pull-right" ng-click="vm.toggleMap()" ng-disabled="vm.isMapRefreshing"><span ng-if="!vm.isMapRefreshing">{{ vm.mapButtonText }}</span> <span ng-if="vm.isMapRefreshing"><span class="glyphicon glyphicon-refresh glyphicon-spin"></span> Loading...</span></button></div><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-6"><dl class="dl-horizontal jh-entity-details"><dt ng-show="vm.trCase.caseAssets.length"><span>Asset Name</span></dt><dd ng-show="vm.trCase.caseAssets.length"><span class="node" ui-sref="asset-detail({id:vm.trCase.caseAssets[0].id})">{{vm.trCase.caseAssets[0].name}}</span></dd><dt><span>{{ vm.trCase.title ?(\'trakeyeApp.trCase.title\' | translate) :(\'trakeyeApp.trCase.description\' | translate) }}</span></dt><dd><span>{{ vm.trCase.title || vm.trCase.description || \'NA\' }}</span></dd><dt><span translate="trakeyeApp.trCase.status">Status</span></dt><dd><span ng-if="vm.trCase.status !== \'PENDING\'">{{ vm.trCase.status }} </span><span ng-if="vm.trCase.status === \'PENDING\'">OUT OF SCOPE</span></dd><!-- <dt><span translate="trakeyeApp.trCase.escalated">Escalated</span></dt>\r\n\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t<span ng-if="vm.trCase.escalated">YES</span>\r\n\t\t\t\t\t\t\t<span ng-if="!vm.trCase.escalated">NO</span>\r\n\t\t\t\t\t\t</dd> --><dt><span translate="trakeyeApp.trCase.verified">Verified</span></dt><dd><span ng-if="vm.trCase.verified">YES</span> <span ng-if="!vm.trCase.verified">NO</span></dd><dt><span translate="trakeyeApp.trCase.address">Address</span></dt><dd><span>{{vm.trCase.address}}</span><!-- <a ui-sref="case-type-detail({id:vm.trCase.address})">{{vm.trCase.address}}</a> --></dd><dt><span>Pin Lat</span></dt><dd><span>{{vm.trCase.pinLat}}</span><!-- <a ui-sref="case-type-detail({id:vm.trCase.address})">{{vm.trCase.address}}</a> --></dd><dt><span>Pin Long</span></dt><dd><span>{{vm.trCase.pinLong}}</span><!-- <a ui-sref="case-type-detail({id:vm.trCase.address})">{{vm.trCase.address}}</a> --></dd><dt><span translate="trakeyeApp.trCase.assignedTo">Assigned To</span></dt><dd><span ng-if="vm.trCase.id == 80834932">fiberifyinc</span> <span ng-if="vm.trCase.id != 80834932">{{vm.trCase.assignedToUser}}</span></dd><dt><span>Created By</span></dt><dd><span ng-if="vm.trCase.id == 80834932">fib_snoc</span> <span ng-if="vm.trCase.id != 80834932">{{vm.trCase.reportedByUser}}</span></dd><dt><span translate="trakeyeApp.trCase.updatedBy">Updated By</span></dt><dd><span ng-if="vm.trCase.id == 80834932">kol_fe</span> <span ng-if="vm.trCase.id != 80834932">{{vm.trCase.updatedByUser}}</span></dd><dt><span translate="trakeyeApp.trCase.assignedBy">Assigned By</span></dt><dd><span ng-if="vm.trCase.id == 80834932">kol_fe</span> <span ng-if="vm.trCase.id != 80834932">{{vm.trCase.assignedByUser}}</span></dd><dt>Alarm Category</dt><dd>{{vm.trCase.alarmCategory}}</dd><dt>Alarm Date</dt><dd>{{vm.trCase.alarmDate| date:\'medium\'}}</dd><dt>Alarm Type</dt><dd>{{vm.trCase.alarmType}}</dd><dt>Nms Name</dt><dd>{{vm.trCase.nmsName}}</dd><dt>Nms Version</dt><dd>{{vm.trCase.nmsVersion}}</dd><dt>ETR Comment</dt><dd><span ng-if="vm.trCase.id == 80834932">5hrs</span> <span ng-if="vm.trCase.id != 80834932">{{vm.trCase.eta || \'-\'}}</span></dd></dl></div><div class="col-md-6"><dl class="dl-horizontal jh-entity-details"><dt><span>Incident Number</span></dt><dd>{{vm.trCase.caseNumber}}</dd><dt><span>RCA</span></dt><dd>{{vm.trCase.rca||"-"}}</dd><dt><span translate="trakeyeApp.trCase.createDate">Create Date</span></dt><dd><span ng-if="vm.trCase.id == 80834932">Jan 28, 2026 14:02:15 PM</span> <span ng-if="vm.trCase.id != 80834932">{{vm.trCase.createDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trCase.updateDate">Update Date</span></dt><dd><span ng-if="vm.trCase.id == 80834932">Jan 28, 2026 16:10:19 PM</span> <span ng-if="vm.trCase.id != 80834932">{{vm.trCase.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trCase.caseType">Incident Type</span></dt><dd ng-if="has_ROLE_USER_ADMIN"><!--  <a ui-sref="case-type-detail({id:vm.trCase.caseType.id})">{{vm.trCase.caseType.name}}</a> --> {{vm.trCase.caseType.name}}</dd><dd ng-if="has_ROLE_USER">{{vm.trCase.caseType.name}}</dd><!--  <dt><span translate="trakeyeApp.trCase.pinLat">Pin Lat</span></dt>\r\n\t\t\t\t\t        <dd>\r\n\t\t\t\t\t            <span>{{vm.trCase.pinLat}}</span>\r\n\t\t\t\t\t        </dd>\r\n\t\t\t\t\t        <dt><span translate="trakeyeApp.trCase.pinLong">Pin Long</span></dt>\r\n\t\t\t\t\t        <dd>\r\n\t\t\t\t\t            <span>{{vm.trCase.pinLong}}</span>\r\n\t\t\t\t\t        </dd> --><div class="case-attribute-scroll"><div class="form-group" ng-repeat="attribute in vm.trCase.caseTypeAttributeValues"><!-- <dt><span >{{attribute.caseTypeAttribute.name}}</span></dt>\r\n\t\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t\t\t<span >{{vm.trCase.caseTypeAttributeValues[$index].attributeValue}}</span></dt>\r\n\t\t\t\t\t\t\t\t</dd> --><div ng-repeat="attributeValue in vm.trCase.caseTypeAttributeValues track by $index"><div ng-if="attributeValue.caseTypeAttribute.id == attribute.caseTypeAttribute.id"><dt><span>{{attribute.caseTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></div></div></div></div><hr><!--  <dt><span translate="trakeyeApp.trCase.caseImages">Incident Images</span></dt> --><dt ng-if="vm.trCase.caseType.name == \'Splicing Details\'"><div class="col-md-2"><a class="btn btn-sm btn-primary" ng-click="toggle(\'cable\')"><span ng-hide="vm.showCable">Show Cable Details</span> <span ng-show="vm.showCable">Hide Cable Details</span></a></div></dt><dd ng-if="cableDetails"><div class="form-group pull-left"><div class="row"><div class="col-md-12"><table class="jh-table table table-responsive table-hover"><tr><th>Cable Name</th><th>JE Availability</th><th>Cable Capacity</th><th>Drum Number</th><th>From Direction</th><th>Approx Loop Length</th></tr><tr ng-repeat="list in vm.trCase.cableDetails"><td>{{list.cableName}}</td><td>{{list.jeAvailability}}</td><td>{{list.cableCapacity}}</td><td>{{list.drumNumber}}</td><td>{{list.fromDirection}}</td><td>{{list.approxLoopLength}}</td></tr></table></div></div></div></dd><dt ng-if="vm.trCase.caseType.name == \'Splicing Details\'"><div class="col-md-2"><a class="btn btn-sm btn-primary" ng-click="toggle(\'splicing\')"><span ng-hide="vm.showSplicing">Show Splicing Details</span> <span ng-show="vm.showSplicing">Hide Splicing Details</span></a></div></dt><dd ng-if="splicingDetails"><div class="form-group pull-left"><div class="row"><div class="col-md-12"><table class="jh-table table table-responsive table-hover"><tr><th>JE Number</th><th>Cable A Side</th><th>Tube A Side</th><th>Core A Start</th><th>Core A End</th><th>Cable B Side</th><th>Tube B Side</th><th>Core B Start</th><th>Core B End</th><th>Number of Splice</th><th>Utilization</th></tr><tr ng-repeat="list in vm.trCase.splicingDetails"><td>{{list.jeNumber}}</td><td>{{list.fromFiber.cableSide}}</td><td>{{list.fromFiber.tubeSide}}</td><td>{{list.fromFiber.coreStart}}</td><td>{{list.fromFiber.coreEnd}}</td><td>{{list.toFiber.cableSide}}</td><td>{{list.toFiber.tubeSide}}</td><td>{{list.toFiber.coreStart}}</td><td>{{list.toFiber.coreEnd}}</td><td>{{list.numberOfSplice}}</td><td>{{list.utilization}}</td></tr></table></div></div></div></dd><dt ng-if="vm.trCase.caseType.name == \'Termination Details\'"><div class="col-md-2"><a class="btn btn-sm btn-primary" ng-click="toggle(\'fms\')"><span ng-hide="vm.showFMS">Show FMS & Cable Details</span> <span ng-show="vm.showFMS">Hide FMS & Cable Details</span></a></div></dt><dd ng-if="fmsDetails"><div class="form-group"><div class="row"><div class="col-md-12" style="overflow-x: scroll;"><table class="jh-table table table-responsive table-hover"><tr><th>FMS Number</th><th>FMS Capacity</th><th>Cable Number A Side</th><th>Drum Number A Side</th><th>Cable Number B Side</th><th>Drum Number B Side</th><th>From Chamber ID / Location for C1</th><th>To Chamber ID / Location for C2</th></tr><tr ng-repeat="list in vm.trCase.fmsAndCableDetails"><td>{{list.fmsNumber}}</td><td>{{list.fmsCapacity}}</td><td>{{list.sideACable.cableNumber}}</td><td>{{list.sideACable.drumNumber}}</td><td>{{list.sideBCable.cableNumber}}</td><td>{{list.sideBCable.drumNumber}}</td><td>{{list.fromChamberId}}</td><td>{{list.toChamberId}}</td></tr></table></div></div></div></dd><dt ng-if="vm.trCase.caseType.name == \'Termination Details\'"><div class="col-md-2"><a class="btn btn-sm btn-primary" ng-click="toggle(\'termination\')"><span ng-hide="vm.showTermination">Show Termination Details</span> <span ng-show="vm.showTermination">Hide Termination Details</span></a></div></dt><dd ng-if="terminationDetails"><div class="form-group"><div class="row"><div class="col-md-12" style="overflow-x: scroll;"><table class="jh-table table table-responsive table-hover"><tr><th>FMS</th><th>Type</th><th>Port Number Start</th><th>Port Number End</th><th>Cable Number A Side</th><th>Core Number A Side Start</th><th>Core Number A Side End</th><th>Number of Splice</th><th>Port used for</th><th>Cable Number B Side</th><th>Core Number B Side Start</th><th>Core Number B Side End</th></tr><tr class="ws-nowrap" ng-repeat="list in vm.trCase.terminationDetails"><td>{{list.fms}}</td><td>{{list.type}}</td><td>{{list.portNumberStart}}</td><td>{{list.portNumberEnd}}</td><td>{{list.sideACable.cableNumber}}</td><td>{{list.sideACable.coreNumberStart}}</td><td>{{list.sideACable.coreNumberEnd}}</td><td>{{list.numberOfSplice}}</td><td>{{list.portUsedFor}}</td><td>{{list.sideBCable.cableNumber}}</td><td>{{list.sideBCable.coreNumberStart}}</td><td>{{list.sideBCable.coreNumberEnd}}</td></tr></table></div></div></div></dd><dd ng-if="allimages"><div class="form-group"><div class="row"><div class="col-md-8"><div class="col-md-3" ng-repeat="img in vm.caseImages"><img ng-if="img.image != null" class="img-responsive img__img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" ng-click="vm.imageInNewTab(img.image)"><br><span class="fs_s" ng-show="img.imgDescription != null"><b>Description :</b> {{img.imgDescription}}</span><br><span class="fs_s" ng-show="img.imgLat != null && img.imgLong != null"><b>LatLng :</b> {{img.imgLat}},{{img.imgLong}}</span></div></div></div></div></dd><dt><div class="col-md-2 trCase_showImgDiv" ng-if="vm.trCase.id && vm.showCaseAttachment"><a class="btn btn-sm btn-primary" ng-click="toggle(\'pdf\')"><span ng-hide="vm.showPdf">Show Attachments</span> <span ng-show="vm.showPdf">Hide Attachments</span></a></div></dt><!-- <div >\r\n\t\t\t\t\t\t\t\t<div class="col-md-3" ng-repeat="img in vm.trCase.caseImages ">\r\n\t\t\t\t\t\t\t\t <img class="img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" style="padding-bottom: 10px;"> \r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t        </div> --><!-- \t\t\t\t\t\t\t\t\t<button id="audioplay" ng-click="playAudio()">Play</button> --><dd ng-if="allpdf"><div class="form-group"><div class="row"><h4 class="box-title" style="text-align: unset"><span>Attachments</span></h4><div class="table-scroll" style="height: max-content;"><div class="form-group"><table class="jh-table table table-responsive table-hover"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.attachments"><td ng-show="image.imageName != null" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null">{{image.imageType}}</td></tr></table></div></div></div></div></dd></dl></div></div><div id="audioLayout"></div><div class="col-md-12" ng-show="vm.isMapVisible"><div id="map_canvas" style="height: 60vh; margin-bottom: 20px;"></div></div><div class="box-buttons"><a href="javascript:void(0);" ui-sref="tr-case" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-case.edit({id:vm.trCase.id})" ng-if="!vm.has_ROLE_READONLY" class="btn btn-primary btn-sm pull-right" ng-hide="has_ROLE_VENDOR && vm.trCase.caseType.name!=\'Vendor Civil Work\' || hideCaseEditBtn"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div><div class="modal fade" id="caseHistoryModal" tabindex="-1" role="dialog" aria-labelledby="caseHistoryModalLabel" aria-hidden="true"><div class="modal-dialog modal-lg custom-media-modal" role="document"><div class="modal-content"><div class="modal-header" style="padding: 5px;"><h4 class="modal-title" id="caseHistoryModalLabel">Incident History</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><div id="loading-bar-spinner" style="display: none; text-align: center; margin: 15px 0;"><div class="spinner-icon"></div></div><div class="row" ng-if="vm.historyList.length"><div class="col-md-12 table-scroll"><table class="table table-bordered table-striped table-condensed" ng-if="vm.historyList.length"><thead><tr><th>NAME</th><th>USER</th><th>ROLE</th><th>STATUS</th><th>RCA</th><th>COMMENT</th><th>UPDATED AT</th><th>LAST MODIFIED DATE</th><th>ETR</th><th>MEDIA</th></tr></thead><tbody><tr ng-repeat="item in vm.historyList"><td>{{ item.name || \'-\' }}</td><td>{{ item.user || \'-\' }}</td><td>{{ item.role || \'-\' }}</td><td>{{ item.status === \'PENDING\' ? \'OUT OF SCOPE\' : (item.status || \'-\') }}</td><td>{{ item.rca || \'-\' }}</td><td>{{ item.statusReason || \'-\' }}</td><td>{{item.updatedLatLong || \'-\'}}</td><td>{{ item.lastModifiedDate ? (item.lastModifiedDate | date:\'dd MMM yyyy, hh:mm a\') : \'-\' }}</td><td>{{ item.eta || \'-\' }}</td><td><button ng-if="item.media" class="btn btn-link p-0" ng-click="vm.onMediaClick(item)" style>Show Media</button> <span ng-if="!item.media">-</span></td></tr></tbody></table></div></div><div class="text-center text-muted" ng-if="!vm.historyList.length">No history available</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div><div class="modal fade" id="mediaCarouselModal" tabindex="-1" role="dialog"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header ml-3" style="display: flex;"><h5 ng-show="vm.showdownloadButton" class="modal-title">{{routeName}}_{{imgLatitude}},{{imgLongitude}}</h5><div ng-show="vm.showhistoryDetailMedia" class="container mt-2 text-left"><div class="row"><div class="col-md-5"><b>Status:</b> {{vm.mediaHistoryDetails.status === \'PENDING\' ? \'OUT OF SCOPE\' : (vm.mediaHistoryDetails.status) }}</div><div class="col-md-2"><b>ETA:</b> {{vm.mediaHistoryDetails.eta}}</div><div class="col-md-5"><b>Comment:</b> {{vm.mediaHistoryDetails.statusReason}}</div></div><div class="row mt-2"><div class="col-md-5"><b>RCA:</b> {{vm.mediaHistoryDetails.rca}}</div><div class="col-md-2"><b>Role:</b> {{vm.mediaHistoryDetails.role}}</div><div class="col-md-5"><b>Last Updated:</b> {{vm.mediaHistoryDetails.lastModifiedDate}}</div></div></div><div class="carousel-downloads"><button ng-show="vm.showdownloadButton" class="btn btn-primary btn-sm" ng-click="downloadMedia()">Download</button> <button ng-show="vm.showdownloadButton" class="btn btn-primary btn-sm" ng-click="downloadAllMedia()">Download All</button></div><button id="maximizeBtn" type="button" style="border: none" ng-click="toggleMaximize()"><span class="fa fa-window-maximize" aria-hidden="true"></span></button> <button id="minimizeBtn" type="button" style="display: none; border: none" ng-click="toggleMaximize()"><span class="fa fa-window-minimize" aria-hidden="true"></span></button> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="closeModal(\'mediaCarouselModal\')"><span aria-hidden="true">&times;</span></button></div><div id="loading-bar-spinner" style="display: none;"><div class="spinner-icon"></div></div><div class="modal-body text-center"><div class="position-relative d-flex justify-content-center align-items-center"><i class="fa fa-arrow-left nav-button prevs" ng-click="prevMedia()" style="font-size: 2rem; cursor: pointer"></i><div id="carouselMediaContainer" class="carousel-displays mx-3"></div><i class="fa fa-arrow-right nav-button nexts" ng-click="nextMedia()" style="font-size: 2rem; cursor: pointer"></i></div><div class="thumbnails_container mt-3" style="white-space: nowrap; overflow-x: auto"><div ng-repeat="media in mediaImagesIds track by $index" ng-class="{\'selected-thumbnail\': $index === currentIndex}" style="display: inline-block; margin: 5px; cursor: pointer" ng-click="jumpToMedia($index)"><img ng-src="data:image/png;base64,{{media.base64}}" style="width: 50px; height: 50px; object-fit: cover; border-radius: 4px"></div></div></div></div></div></div><div class="modal fade" id="caseMaterialModal" tabindex="-1" role="dialog" aria-labelledby="caseMaterialModalLabel" aria-hidden="true"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header" style="padding: 5px;"><h4 class="modal-title" id="caseMaterialModalLabel">Incident Material</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><div id="loading-bar-spinner" style="display: none; text-align: center; margin: 15px 0;"><div class="spinner-icon"></div></div><h4>Transaction Details</h4><div class="row" ng-if="vm.materialTxnList.length"><div class="col-md-12 material-scroll"><table class="table table-bordered table-striped table-condensed"><thead><tr><th>Date</th><th>Material Name</th><th>Transaction Type</th><th class="text-right">Quantity</th><th>Created By</th><th ng-if="has_ROLE_BA||has_ROLE_FE||has_ROLE_NETWORK_ENGINEER||has_ROLE_USER_ADMIN||has_ROLE_SUPER_ADMIN||has_ROLE_PLAN_ADMIN">Action</th></tr></thead><tbody><tr ng-repeat="txn in vm.materialTxnList"><td>{{ txn.transactionDate | date:\'dd-MM-yyyy\' }}</td><td>{{ txn.materialName }}</td><td>{{ txn.transactionType }}</td><td class="text-right">{{ txn.noOfUnits }}</td><td>{{ txn.createdByUserFName }} {{ txn.createdByUserLName }}</td><td ng-if="has_ROLE_BA||has_ROLE_FE||has_ROLE_NETWORK_ENGINEER||has_ROLE_USER_ADMIN||has_ROLE_SUPER_ADMIN||has_ROLE_PLAN_ADMIN"><span class="fa fa-pencil-square" title="edit" ng-click="vm.editMaterial(txn)"></span> <span class="fa fa-trash-o" title="delete" ng-click="vm.openDeleteMaterialModal(txn, $index)"></span></td></tr></tbody></table></div></div><div class="row" ng-if="vm.materialTxnList.length"><div class="col-md-6"><jhi-item-count page="vm.incUiPage" total="vm.incTotalItems" items-per-page="vm.incItemsPerPage"></jhi-item-count></div><div class="col-md-6 text-right"><uib-pagination total-items="vm.incTotalItems" ng-model="vm.incUiPage" items-per-page="vm.incItemsPerPage" max-size="5" boundary-links="true" ng-change="vm.incPageChanged()" class="pagination-sm"></uib-pagination></div></div><hr><h4>Cumulative Summary&nbsp;<i class="fa fa-download" ng-click="vm.downloadCumulativeCSV()"></i></h4><div class="row" ng-if="vm.cumulativeData.length"><div class="col-md-12 table-responsive"><table class="table table-bordered table-striped table-condensed"><thead><tr><th>Date</th><th>Material Name</th><th>REQUESTED</th><th>RECEIVED</th><th>UTILIZED</th><!-- <th>WASTAGE</th> --><th>RECOVERED</th><th>STOCK</th></tr></thead><tbody><tr ng-repeat="item in vm.cumulativeData"><td>{{ vm.today | date:\'dd-MM-yyyy\' }}</td><td>{{ item.materialName }}</td><td>{{ item.REQUESTED}}</td><td>{{ item.RECEIVED }}</td><td>{{ item.UTILIZED }}</td><!-- <td>{{ m.WASTAGE}}</td> --><td>{{ item.RECOVERED}}</td><td>{{ item.REQUESTED + item.RECOVERED}}</td></tr></tbody></table></div></div><div class="text-center text-muted" ng-if="!vm.materialTxnList.length && !vm.loading">No material transactions found</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div><div id="deleteModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog modal-sm"><div class="modal-content"><form name="deleteForm" ng-submit="vm.confirmDeleteMaterial()" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clearDelete()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><p class="text-danger" ng-if="vm.deletefail">Services for this material need to be deleted before deleting the material</p><p>Are you sure you want to delete this material?</p><p><strong>{{ vm.selectedMaterial.materialName }}-{{vm.selectedMaterial.noOfUnits}} No\'s</strong></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clearDelete()">Cancel</button> <button type="submit" class="btn btn-danger btn-sm" ng-disabled="deleteForm.$invalid">Delete</button></div></form></div></div></div><div id="editModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><form name="editForm" ng-submit="vm.confirmEditMaterial()" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clearEdit()">&times;</button><h4 class="modal-title">Edit Material</h4></div><div class="modal-body"><div class="form-group"><label>Material Name</label> <input type="text" class="form-control" ng-model="vm.editMaterialData.materialName" disabled="disabled"></div><div class="form-group"><label>Transaction Type</label> <input type="text" class="form-control" ng-model="vm.editMaterialData.transactionType" disabled="disabled"></div><div class="form-group"><label>No Of Units</label> <input type="number" class="form-control" ng-model="vm.editMaterialData.noOfUnits" min="1" required></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clearEdit()">Cancel</button> <button type="submit" class="btn btn-primary btn-sm" ng-disabled="editForm.$invalid || vm.updating">Update</button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><!-- <span ng-if="!vm.trCase.id">Create Incident  <span ng-show="!vm.trCase.id && createCaseFromAssetMap.length"><a>\r\n                                <span ui-sref="asset-detail({id:createCaseFromAssetMap[0].id})" ng-bind="vm.assetNameInCreate">Create</span>\r\n                            </a></span></span>\r\n\r\n                            <span ng-if="vm.trCase.id">Edit Incident  <span ng-show="vm.trCase.id && vm.trCase.caseAssets.length"><a>\r\n                                        <span ui-sref="asset-detail({id:vm.trCase.caseAssets[0].id})" ng-bind="vm.assetName">Edit</span>\r\n                                    </a></span></span> --> <span ng-if="!vm.trCase.id" translate="trakeyeApp.trCase.home.create">Create</span> <span ng-if="vm.trCase.id" translate="trakeyeApp.trCase.home.EditLabel">Edit</span></h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.trCase.id"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.trCase.id" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.trCase.title">Title</span><!-- <sup\r\n                                    ><span class="required-icon"\r\n                                        ><i\r\n                                            class="fa fa-asterisk text-danger"\r\n                                        ></i\r\n                                    ></span>\r\n                                </sup> --></label><div class="col-md-8"><textarea class="form-control" rows="2" name="description" id="field_description" ng-model="vm.trCase.title" ng-required="true"></textarea></div></div><div class="form-group" ng-show="!vm.trCase.id"><label class="col-md-3 control-label">Select Coordinates</label><div class="col-md-8"><div id="map_canvas" style="height: 300px"></div></div><div class="col-md-1"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterAssetsOnMapView()"><i class="fa fa-filter"></i></button><!-- <button style="color: gray;" type="button" class="btn btn-info btn-flat"\r\n                                    ng-show="vm.canFilter == false">\r\n                                    <i class="fa fa-filter"></i>\r\n                                </button> --></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.pinLat">Pin Lat</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><input type="number" class="form-control" name="pinLat" id="field_pinLat" ng-model="vm.trCase.pinLat" required></div><label class="col-md-2 control-label"><span translate="trakeyeApp.trCase.pinLong">Pin Long</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><input type="number" class="form-control" name="pinLong" id="field_pinLong" ng-model="vm.trCase.pinLong" required></div><div class="col-md-1"><button type="button" class="btn btn-primary btn-sm" ng-disabled="vm.showAddressAddress" ng-click="vm.getAssetAddress()"><span class="fa fa-refresh"></span></button></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.address">Address</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><textarea rows="2" class="form-control" name="address" id="field_address" ng-model="vm.trCase.address" readonly="readonly" required></textarea></div></div><!-- <div class="form-group">\r\n                            <label\r\n                                class="col-md-3 control-label"\r\n                                translate="trakeyeApp.trCase.escalated"\r\n                                for="field_escalated"\r\n                                >Escalated</label\r\n                            >\r\n                            <div class="col-md-8">\r\n                                <input\r\n                                    type="checkbox"\r\n                                    class="checkbox"\r\n                                    name="escalated"\r\n                                    id="field_escalated"\r\n                                    ng-model="vm.trCase.escalated"\r\n                                    ng-true-value="true"\r\n                                    ng-false-value="false"\r\n                                />\r\n                            </div>\r\n                        </div> --><div class="form-group" ng-if="has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA || has_ROLE_TEAM_LEADER || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_CITY_PLANNER"><label class="col-md-3 control-label" translate="trakeyeApp.trCase.verified" for="field_verified">Verified</label><div class="col-md-8"><input type="checkbox" class="checkbox" name="verified" id="field_verified" ng-model="vm.trCase.verified" ng-true-value="true" ng-false-value="false"></div></div><div class="form-group" ng-if="vm.trCase.id"><label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.trCase.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" id="field_status" ng-model="vm.trCase.status" ng-options="status.configValue as status.configKey \r\n                                    for status in vm.incidentStatuses \r\n                                    | filter:{ configValue:\'!NEW\' } \r\n                                    | filter:{ configValue:\'!CANCELLED\' }" required><option value="">-- Select Status --</option></select></div></div><div class="form-group" ng-if="vm.trCase.id &&(vm.trCase.status==\'INPROGRESS\'|| vm.trCase.status==\'PENDING\'|| vm.trCase.status==\'RESOLVED\')"><label class="col-md-3 control-label" for="field_rca"><span translate="trakeyeApp.trCase.rca">RCA</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="rca" id="field_rca" ng-model="vm.trCase.rca" ng-options="rca.configValue as rca.configValue for rca in vm.incidentRCAstatus" required><option value="">-- Select RCA --</option></select></div></div><div class="form-group row"><div class="col-md-3 control-label"><span translate="trakeyeApp.trCase.group">Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3"><div isteven-multi-select input-model="vm.multiGroup" output-model="vm.trCase.groups" button-label="name" item-label="name" tick-property="ticked" output-properties="id selected" selection-mode="single" on-item-click="vm.callGroup()"></div><!-- <input type="text" ng-model="vm.trCase.groups" name="group" style="display:none" /> --> <span id="noData" ng-if="vm.trCase.groups.length == 0">**Please Select Group</span> <input type="text" ng-model="vm.trCase.groups" name="group" style="display: none" required></div></div><div class="form-group" ng-if="(has_ROLE_USER_ADMIN||has_ROLE_OA||has_ROLE_BA) && vm.trCase.id!=null"><label class="col-md-3 control-label"><span>Select Geofence</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" ng-model="vm.selectedMiniGeofence" ng-change="selectingGeofence()" ng-options="item as item.name for item in vm.geofences track by item.id" style="width: 100%" ng-show="vm.geofences.length>0"><option value="" selected="selected">--- Select Geofence ---</option></select></div></div><div class="form-group" ng-if="vm.selectedMiniGeofence==null && vm.trCase.id!=null"><label class="col-md-3 control-label"><span>Geofence</span></label><div class="col-md-8"><span style="text-align: left;"><p style="font-weight: bold;">{{ vm.trCase.geofences[0].name }}</p></span></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN||has_ROLE_OA||has_ROLE_BA"><div ng-if="vm.selectedMiniGeofence!=null && vm.activatedusers.length==0"><label class="col-md-3 control-label"></label> <span><p id="noData" style="font-weight: bold;margin-left: 20px;">No Users for selected Geofence</p></span></div><div ng-if="vm.selectedMiniGeofence!=null && vm.activatedusers.length>0"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.assignedTo">Assigned To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" ng-model="vm.trCase.assignedToUser" required><option value="">-- Select User --</option><option ng-repeat="user in vm.activatedusers" value="{{user.login}}" ng-style="vm.getUserStyle(user)">{{user.firstName}} - {{user.login}} - {{vm.getUserStatus(user)}}</option></select> <span id="noData" ng-if="vm.trCase.assignedToUser == null">**Please Select</span></div></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN||has_ROLE_OA||has_ROLE_BA" ng-show="vm.selectedMiniGeofence==null"><label class="col-md-3 control-label" ng-if="vm.trCase.assignedToUser != null"><span translate="trakeyeApp.trCase.assignedTo">Assigned To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><span ng-if="vm.trCase.assignedToUser != null" style="text-align: left;"><p style="font-weight: bold;">{{vm.trCase.assignedToUser}}</p></span></div></div><div class="form-group" ng-if="has_ROLE_FE"><div ng-if="vm.activatedusers.length==0"><label class="col-md-3 control-label"></label> <span><p id="noData" style="font-weight: bold;margin-left: 20px;">Users Not Available</p></span></div><div ng-if="vm.activatedusers.length>0"><label class="col-md-3 control-label" for="field_assignedTo"><span translate="trakeyeApp.trCase.assignedTo">Assigned To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" ng-model="vm.trCase.assignedToUser" required><option value="">-- Select User --</option><option ng-repeat="user in vm.activatedusers" value="{{user.login}}" ng-style="vm.getUserStyle(user)">{{user.firstName}} - {{user.login}} - {{vm.getUserStatus(user)}}</option></select> <span id="noData" ng-if="vm.trCase.assignedToUser == null">**Please Select</span></div></div></div><!-- <div class="form-group"\r\n                            ng-if="vm.trCase.id==null(has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA || has_ROLE_TEAM_LEADER || has_ROLE_FE || (has_ROLE_NETWORK_ENGINEER && vm.caseType.name != \'Vendor Civil Work\'))">\r\n                            <label class="col-md-3 control-label" for="field_assignedTo">\r\n                                <span translate="trakeyeApp.trCase.assignedTo">Assigned To</span>\r\n                                <sup><span class="required-icon">\r\n                                        <i class="fa fa-asterisk text-danger"></i> </span></sup>\r\n                            </label>\r\n                            <div class="col-md-8">\r\n                                <input list="userslist" class="form-control" id="field_assignedToUser"\r\n                                    placeholder="Search user login name" type="text" ng-model="vm.trCase.assignedToUser"\r\n                                    autocomplete="off" name="assignedToUser" ng-change="vm.filterActivatedUser()"\r\n                                    ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA || has_ROLE_TEAM_LEADER || has_ROLE_FE || (has_ROLE_NETWORK_ENGINEER && vm.caseType.name != \'Vendor Civil Work\')"\r\n                                    required />\r\n                                <datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1">\r\n                                    <option ng-repeat="user in\r\n                                        vm.activatedusers" value="{{user.login}}"></option>\r\n                                </datalist>\r\n                                <span id="noData" ng-if="vm.trCase.assignedToUser == null">**Please Select</span>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.caseType">caseType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="caseType" ng-model="vm.caseType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                    vm.caseTypes track by item.id" ng-disabled="vm.trCase.id!=null" required style="width: 100%"><option value="" translate="trakeyeApp.trCase.selectcase">--- Select CaseType ---</option></select></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-3 control-label" for="field_asset">\r\n\t\t            \t<span  translate="trakeyeApp.trCase.asset">Asset</span>\r\n\t\t            </label>\r\n                            <div class="col-md-8">\r\n                                <input list="assetlist" class="form-control" id="asset_list" placeholder="Search Asset" type="text" ng-model="vm.trCase.asset.name" autocomplete="off" name="assetList" ng-change="vm.filterAssetsList()">\r\n                                <datalist ng-hide="vm.assetList" id="assetlist" class="form-control1">\t\t            \r\n\t\t\t\t\t\t\t<option ng-repeat="asset in vm.assetList" value="{{asset.name}}"/>\r\n\t           \t\t\t \t\r\n\t\t            </datalist>\r\n                            </div> --></div><div class="form-group" ng-repeat="attribute in\r\n                        vm.trCase.caseTypeAttributeValues" ng-class="{\r\n                        \'has-error\' : userIntForm.value.$invalid }"><div class="row"><label class="col-md-3 control-label" ng-show="((!vm.trCase.id && (attribute.caseTypeAttribute.caseCategory==\'CATEGORY1\'||attribute.caseTypeAttribute.caseCategory==\'DEFAULT\'||attribute.caseTypeAttribute.caseCategory==null))\r\n                            ||(vm.trCase.id && ((vm.prevStatus!=\'ASSIGNED\' && vm.prevStatus==\'NEW\') || (vm.prevStatus!=\'NEW\' && vm.prevStatus==\'ASSIGNED\')) && (attribute.caseTypeAttribute.caseCategory==\'CATEGORY1\'||attribute.caseTypeAttribute.caseCategory==\'DEFAULT\'||attribute.caseTypeAttribute.caseCategory==null))\r\n                            ||(vm.trCase.id && vm.prevStatus!=\'ASSIGNED\' && vm.prevStatus!=\'NEW\') || (vm.trCase.id && vm.prevStatus==\'ASSIGNED\' && has_ROLE_FRT && vm.trCase.caseType.name==\'Incident Management\'))\r\n                            ||(vm.trCase.id && vm.prevStatus==\'ASSIGNED\' && (vm.trCase.caseType.name!=\'Issue on Field\' && vm.trCase.caseType.name!=\'Asset Safety Related\' && vm.trCase.caseType.name!=\'Productivity & NTP\' && vm.trCase.caseType.name!=\'PM Activity\' && vm.trCase.caseType.name!=\'UG OH Declaration\' && vm.trCase.caseType.name!=\'Fiber Provisioning\' && vm.trCase.caseType.name!=\'Chamber Declaration\' && vm.trCase.caseType.name!=\'Vendor Civil Work\' && vm.trCase.caseType.name!=\'Incident Management\'))"><span>{{attribute.caseTypeAttribute.name}} </span><sup><span class="required-icon" ng-show="attribute.caseTypeAttribute.mandatory == true"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><div ng-repeat="attributeValue in\r\n                            vm.trCase.caseTypeAttributeValues track by $index" ng-show="((!vm.trCase.id && (attribute.caseTypeAttribute.caseCategory==\'CATEGORY1\'||attribute.caseTypeAttribute.caseCategory==\'DEFAULT\'||attribute.caseTypeAttribute.caseCategory==null))\r\n                            ||(vm.trCase.id && ((vm.prevStatus!=\'ASSIGNED\' && vm.prevStatus==\'NEW\') || (vm.prevStatus!=\'NEW\' && vm.prevStatus==\'ASSIGNED\')) && (attribute.caseTypeAttribute.caseCategory==\'CATEGORY1\'||attribute.caseTypeAttribute.caseCategory==\'DEFAULT\'||attribute.caseTypeAttribute.caseCategory==null))\r\n                            ||(vm.trCase.id && vm.prevStatus!=\'ASSIGNED\' && vm.prevStatus!=\'NEW\') || (vm.trCase.id && vm.prevStatus==\'ASSIGNED\' && has_ROLE_FRT && vm.trCase.caseType.name==\'Incident Management\'))\r\n                            ||(vm.trCase.id && vm.prevStatus==\'ASSIGNED\' && (vm.trCase.caseType.name!=\'Issue on Field\' && vm.trCase.caseType.name!=\'Asset Safety Related\' && vm.trCase.caseType.name!=\'Productivity & NTP\' && vm.trCase.caseType.name!=\'PM Activity\' && vm.trCase.caseType.name!=\'UG OH Declaration\' && vm.trCase.caseType.name!=\'Fiber Provisioning\' && vm.trCase.caseType.name!=\'Chamber Declaration\' && vm.trCase.caseType.name!=\'Vendor Civil Work\' && vm.trCase.caseType.name!=\'Incident Management\'))"><div ng-if=" attributeValue.caseTypeAttribute.id==attribute.caseTypeAttribute.id"><input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                    == \'FLOAT\' && !vm.trCase.id" type="text" class="form-control" ng-init="attributeValue.attributeValue=\r\n                                    attribute.caseTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                    == \'FLOAT\' && vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <span ng-if="attribute.caseTypeAttribute.dataType\r\n                                    == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                    == \'INTEGER\' && !vm.trCase.id" type="text" class="form-control" ng-model="attributeValue.attributeValue" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\r\n                                    attribute.caseTypeAttribute.value" oninput="this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\');"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                    == \'INTEGER\' && vm.trCase.id" type="text" class="form-control" ng-model="attributeValue.attributeValue" name="value{{$index+1}}" oninput="this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\');"> <span ng-if="attribute.caseTypeAttribute.dataType\r\n                                    == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Valid Number </span><input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                    == \'STRING\' && !vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\r\n                                    attribute.caseTypeAttribute.value" ng-model="attributeValue.attributeValue"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                    == \'STRING\' && vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="attributeValue.attributeValue"> <span ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                    == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Message</span> <select ng-model="attributeValue.attributeValue" ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                != \'STRING\' &&\r\n                                attribute.caseTypeAttribute.attributeDataType.name\r\n                                != \'FLOAT\' &&\r\n                                attribute.caseTypeAttribute.attributeDataType.name\r\n                                != \'INTEGER\'" class="form-control select2" ng-change="attributeMappingChange(attributeValue)"><!--  --><option value="">-- Select Value --</option><option value="{{atttype.value}}" ng-repeat="atttype in\r\n                                    vm.customAttributesMap[attribute.caseTypeAttribute.attributeDataType.name]">{{atttype.value}}</option></select></div></div></div></div></div><div class="form-group" ng-show="vm.showCableSplice"><label class="col-md-3 control-label">Cable Details <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="toggle(\'cable\')"><span ng-hide="vm.showCable">Show Cable Details</span> <span ng-show="vm.showCable">Hide Cable Details</span></a></div><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="addDetails(\'cableDetails\')"><span class="fa fa-plus"></span> Add</a></div></div><div class="form-group" ng-if="cableDetails"><div class="row"><div class="col-md-8 col-md-offset-3"><table class="jh-table table table-responsive table-hover" style="margin-left: 17%;\r\n                        margin-right: auto;"><tr><th>Cable Name</th><th>JE Availability</th><th>Cable Capacity</th><th>Drum Number</th><th>From Direction</th><th>Approx Loop Length</th><th>Actions</th></tr><tr ng-repeat="list in vm.trCase.cableDetails"><td>{{list.cableName}}</td><td>{{list.jeAvailability}}</td><td>{{list.cableCapacity}}</td><td>{{list.drumNumber}}</td><td>{{list.fromDirection}}</td><td>{{list.approxLoopLength}}</td><td><a ng-click="editDetails($index,\'cableDetails\')" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ng-click="removeDetails($index,\'cableDetails\')" class="action-icons text-primary" title="Remove"><span class="fa fa-minus"></span></a></td></tr></table></div></div></div><div class="form-group" ng-show="vm.showCableSplice"><label class="col-md-3 control-label">Splicing Details <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="toggle(\'splicing\')"><span ng-hide="vm.showSplicing">Show Splicing Details</span> <span ng-show="vm.showSplicing">Hide Splicing Details</span></a></div><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="addDetails(\'splicingDetails\')"><span class="fa fa-plus"></span> Add</a></div></div><div class="form-group" ng-if="splicingDetails"><div class="row"><div class="col-md-8 col-md-offset-3"><table class="jh-table table table-responsive table-hover" style="margin-left: 17%;\r\n                        margin-right: auto;"><tr><th>JE Number</th><th>Cable A Side</th><th>Tube A Side</th><th>Core A Start</th><th>Core A End</th><th>Cable B Side</th><th>Tube B Side</th><th>Core B Start</th><th>Core B End</th><th>Number of Splice</th><th>Utilization</th><th>Actions</th></tr><tr ng-repeat="list in vm.trCase.splicingDetails"><td>{{list.jeNumber}}</td><td>{{list.fromFiber.cableSide}}</td><td>{{list.fromFiber.tubeSide}}</td><td>{{list.fromFiber.coreStart}}</td><td>{{list.fromFiber.coreEnd}}</td><td>{{list.toFiber.cableSide}}</td><td>{{list.toFiber.tubeSide}}</td><td>{{list.toFiber.coreStart}}</td><td>{{list.toFiber.coreEnd}}</td><td>{{list.numberOfSplice}}</td><td>{{list.utilization}}</td><td><a ng-click="editDetails($index,\'splicingDetails\')" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ng-click="removeDetails($index,\'splicingDetails\')" class="action-icons text-primary" title="Remove"><span class="fa fa-minus"></span></a></td></tr></table></div></div></div><div class="form-group" ng-show="vm.showFmsTermination"><label class="col-md-3 control-label">FMS & Cable Details <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="toggle(\'fms\')"><span ng-hide="vm.showFMS">Show FMS & Cable Details</span> <span ng-show="vm.showFMS">Hide FMS & Cable Details</span></a></div><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="addDetails(\'fmsDetails\')"><span class="fa fa-plus"></span> Add</a></div></div><div class="form-group" ng-if="fmsDetails"><div class="row"><div class="col-md-11 col-md-offset-3" style="overflow-x: scroll;"><table class="jh-table table table-responsive table-hover" style="margin-right: auto;"><tr><th>FMS Number</th><th>FMS Capacity</th><th>Cable Number A Side</th><th>Drum Number A Side</th><th>Cable Number B Side</th><th>Drum Number B Side</th><th>From Chamber ID / Location for C1</th><th>To Chamber ID / Location for C2</th><th>Actions</th></tr><tr ng-repeat="list in vm.trCase.fmsAndCableDetails"><td>{{list.fmsNumber}}</td><td>{{list.fmsCapacity}}</td><td>{{list.sideACable.cableNumber}}</td><td>{{list.sideACable.drumNumber}}</td><td>{{list.sideBCable.cableNumber}}</td><td>{{list.sideBCable.drumNumber}}</td><td>{{list.fromChamberId}}</td><td>{{list.toChamberId}}</td><td><a ng-click="editDetails($index,\'fmsDetails\')" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ng-click="removeDetails($index,\'fmsDetails\')" class="action-icons text-primary" title="Remove"><span class="fa fa-minus"></span></a></td></tr></table></div></div></div><div class="form-group" ng-show="vm.showFmsTermination"><label class="col-md-3 control-label">Termination Details <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="toggle(\'termination\')"><span ng-hide="vm.showTermination">Show Termination Details</span> <span ng-show="vm.showTermination">Hide Termination Details</span></a></div><div class="col-md-2 mt-5 caseType_showImg"><a class="btn btn-sm btn-primary" ng-click="addDetails(\'terminationDetails\')"><span class="fa fa-plus"></span> Add</a></div></div><div class="form-group" ng-if="terminationDetails"><div class="row"><div class="col-md-11 col-md-offset-3" style="overflow-x: scroll;"><table class="jh-table table table-responsive table-hover" style="margin-right: auto;"><tr><th>FMS</th><th>Type</th><th>Port Number Start</th><th>Port Number End</th><th>Cable Number A Side</th><th>Core Number A Side Start</th><th>Core Number A Side End</th><th>Number of Splice</th><th>Port used for</th><th>Cable Number B Side</th><th>Core Number B Side Start</th><th>Core Number B Side End</th><th>Actions</th></tr><tr class="ws-nowrap" ng-repeat="list in vm.trCase.terminationDetails"><td>{{list.fms}}</td><td>{{list.type}}</td><td>{{list.portNumberStart}}</td><td>{{list.portNumberEnd}}</td><td>{{list.sideACable.cableNumber}}</td><td>{{list.sideACable.coreNumberStart}}</td><td>{{list.sideACable.coreNumberEnd}}</td><td>{{list.numberOfSplice}}</td><td>{{list.portUsedFor}}</td><td>{{list.sideBCable.cableNumber}}</td><td>{{list.sideBCable.coreNumberStart}}</td><td>{{list.sideBCable.coreNumberEnd}}</td><td><a ng-click="editDetails($index,\'terminationDetails\')" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a> <a ng-click="removeDetails($index,\'terminationDetails\')" class="action-icons text-primary" title="Remove"><span class="fa fa-minus"></span></a></td></tr></table></div></div></div><div class="form-group" ng-hide="vm.showCableSplice || vm.showFmsTermination"><label class="col-md-3 control-label" for="field_priority"><span translate="trakeyeApp.trCase.priority">Priority</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="priority" ng-model="vm.trCase.priority" id="field_priority"><option disabled="disabled" selected="selected" value>--- Select Priority ---</option><option value="LOW">LOW</option><option value="MEDIUM">MEDIUM</option><option value="HIGH" selected="selected" value>HIGH</option><option value="CRITICAL">CRITICAL</option></select></div></div><div class="form-group" ng-show="!vm.trCase.id && createCaseFromAssetMap.length"><label class="col-md-3 control-label"><span>Asset Name</span></label><div class="col-md-8 node" ui-sref="asset-detail({id:createCaseFromAssetMap[0].id})"><input type="text" class="form-control node" ng-model="createCaseFromAssetMap[0].name" readonly="readonly"></div></div><div class="form-group" ng-show="vm.trCase.id && vm.trCase.caseAssets.length"><label class="col-md-3 control-label"><span>Asset Name</span></label><div class="col-md-8 node" ui-sref="asset-detail({id:vm.trCase.caseAssets[0].id})"><input type="text" class="form-control node" ng-model="vm.trCase.caseAssets[0].name" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.trCase.caseImages">images</label><div class="col-md-6"><input type="file" name="file" multiple="multiple" class="filestyle" id="caseImages" accept="image/*"> <span id="noData" ng-if="vm.fileWarning">Please upload PNG,JPG/JPEG format with maximum size of 2.5MB/2560KB</span></div><div class="col-md-2 caseType_showImg" ng-if="vm.trCase.id"><a class="btn btn-sm btn-primary" ng-click="toggle(\'image\')"><span ng-hide="vm.showImages">Show Images</span> <span ng-show="vm.showImages">Hide Images</span></a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-8 col-md-offset-3"><div class="col-md-3" ng-repeat="img in\r\n                                    vm.caseImages"><img ng-if="img.image != null" class="img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" ng-click="getImage(img.image)" style="padding-bottom: 10px"> <span ng-show="img.imgDescription != null">Description : {{img.imgDescription}}</span> <span ng-show="img.imgLat != null && img.imgLong != null">LatLng : {{img.imgLat}},{{img.imgLong}}</span></div></div></div></div><div class="form-group" ng-show="vm.trCase.id && vm.showCaseAttachment"><label class="col-md-3 control-label">Attachments</label><div class="col-md-6"><input type="file" name="file" class="filestyle" id="attachmentFile" accept="application/pdf"> <span id="noData" ng-if="vm.fileWarnings">Please upload PDF format with maximum size of 2.5MB/2560KB</span></div><div class="col-md-2 mt-5 caseType_showImg" ng-if="vm.trCase.id"><a class="btn btn-sm btn-primary" ng-click="toggle(\'pdf\')"><span ng-hide="vm.showPdf">Show Attachments</span> <span ng-show="vm.showPdf">Hide Attachments</span></a></div></div><div class="form-group" ng-if="allpdf"><label class="col-md-3 control-label">Attachment Display</label><div class="col-md-6"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                        margin-right: auto;"><tr><th>Name</th><th>Type</th></tr><tr ng-repeat="image in vm.attachments"><td ng-show="image.imageName != null" ng-click="newTabDisplay(image.imageId)" style="color: #3c8dbc;">{{image.imageName}}</td><td ng-show="image.imageName != null">{{image.imageType}}</td></tr></table></div></div><!-- <div class="form-group" ng-if="a">\r\n                        <label class="col-md-3 control-label" >Selected Images</label>\r\n                        <div class="col-md-6"> \r\n                            <table class="jh-table table table-responsive table-hover" \r\n                        style="margin-left: auto;\r\n                        margin-right: auto;">\r\n                            <tr>\r\n                                <th>Image</th>\r\n                                <th>Image Name</th>\r\n                                <th>Delete</th>\r\n                            </tr>\r\n                            <tr ng-repeat="img in vm.trCase.caseImages">\r\n                                <td>\r\n                                    <img class="img-responsive img__img-responsive"\r\n                                    ng-src="data:image/jpeg;base64,{{img.image}}" />\r\n                                </td>\r\n                                <td>\r\n                                    {{img.imageName}}\r\n                                </td>\r\n                                <td  ng-click="deleteDisplayImage($index)">\r\n                                    <span class="fa fa-trash-o" style="\r\n                                    color: red"></span>\r\n                                </td>\r\n                            </tr>\r\n                        </table>\r\n                        </div>\r\n                    </div> --><div><div class="col-md-2"></div><div class="col-md-6"><div class="btn btn-create btn-sm" ng-if="vm.trCase.asset"><a style="margin-bottom: 10px; color: white" ng-click="openAssetMapModal()">Show Map</a></div></div></div><!-- <div ng-show="vm.ugAlertGreen" class="col-md-12"> \r\n                        <span class="ugAlertGreen"> <i class=\'fa fa-check-circle\'></i> No existing assets nearby</span>\r\n                    </div> --><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-case"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button ng-hide="vm.saveHide" type="submit" ng-disabled="editForm.$invalid\r\n                                || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button><!-- <button\r\n                                ng-show="vm.existingAsset"\r\n                                type="button"\r\n                                ng-disabled="editForm.$invalid\r\n                                || vm.isSaving"\r\n                                class="btn btn-info btn-flat"\r\n                                ng-click="vm.showExisting()"\r\n                            >\r\n                                <span\r\n                                    >Check for Existing Assets</span\r\n                                >\r\n                            </button> --><!-- <button type="submit" ng-disabled="editForm.$invalid\r\n                                || vm.isSaving" class="btn btn-primary btn-sm"\r\n                                ng-if="!vm.trCase.id || (vm.trCase.id && !has_ROLE_FRT && !has_ROLE_PATROLLER)">\r\n                                <span class="glyphicon glyphicon-save"></span>\r\n                                <span translate="entity.action.save">Save</span>\r\n                            </button> --><!-- <button ng-disabled="editForm.$invalid\r\n                                || vm.isSaving" class="btn btn-primary btn-sm" ng-click="vm.submit()"\r\n                                ng-if="vm.trCase.id">\r\n                                <span class="glyphicon glyphicon-save"></span>\r\n                                <span>Submit</span>\r\n                            </button> --></div></div></div></form></div></div></div><div id="assetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div style="width: 100%; height: 580px; padding-top: 7px" class="modal-body"><div class="row"><div class="col-md-12 modal_body_map"><div class="location-map-assets"><div style="width: 100%;\r\n                                    height: 510px;\r\n                                    display: inline-block;" id="map_canvas_assets"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><div id="mapFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 70%" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Assets Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal(\'mapFilterModal\')"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.userGeofences.length == 0">* NO DATA</span><div style="margin-left: 35px"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" style="margin-left: 10px; font-size: medium">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div class="modal fade" id="myModalMap" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div id="imgZoom" style="background: url(\'data:image/jpeg;base64,{{vm.img}}\');"></div></div></div><div id="existingAsset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40%; height: 30vh" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal(\'existingAsset\')"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Existing Assets</span></div><div style="color: black;\r\n                    font-weight: bold;\r\n                    text-align: center;\r\n                    font-size: larger;" class="modal-body"><div class="row"><div class="col-md-12"><span class="ug-alert"><i class="fa fa-exclamation-circle"></i> There is an existing UG OH asset nearby</span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" ng-click="vm.closeMapFilterModal(\'existingAsset\')"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.showExisting()"><span class="glyphicon glyphicon-save"></span> <span>OK</span></button></div></div></div></div><!-- <div\r\n    id="handlingError"\r\n    class="fade modal"\r\n    role="dialog"\r\n    data-keyboard="true"\r\n    tabindex="-1"\r\n>\r\n    <div\r\n        class="modal-dialog modal-fluid"\r\n        style="width: 40%; height: 30vh"\r\n        role="document"\r\n    >\r\n        \r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                 <button\r\n                    type="button"\r\n                    class="close"\r\n                    data-dismiss="modal"\r\n                    aria-label="Close"\r\n                    ng-click="vm.closeMapFilterModal(\'handlingError\')"\r\n                >\r\n                    <span aria-hidden="true">&times;</span>\r\n                </button> \r\n                <span class="span__modal-header">\r\n                    {{vm.handlingError}} Error\r\n                </span>\r\n            </div>\r\n            <div\r\n                style="\r\n                    color: black;\r\n                    text-align: center;\r\n                    font-size: larger;\r\n                "\r\n                class="modal-body"\r\n            >\r\n                <div class="row">\r\n                    <div  class="col-md-12"> \r\n                        <span class="ug-alert"> <i class=\'fa fa-exclamation-triangle\'></i> Please verify entered details</span>\r\n                    </div>\r\n                </div>\r\n                \r\n            </div>\r\n            <div class="modal-footer">\r\n                <button\r\n                    type="button"\r\n                    class="btn btn-danger btn-sm"\r\n                    ng-click="vm.closeMapFilterModal(\'handlingError\')"\r\n                >\r\n                <span>OK</span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div> --><div id="popupDialogModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40%; height: 30vh" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Mandatory Attributes</span></div><div style="color: black;\r\n                    font-weight: bold;\r\n                    text-align: center;\r\n                    font-size: larger;" class="modal-body"><div class="row"><span id="alertMessage"></span></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.closePopupDialogModal()"><span>OK</span></button></div></div></div></div><div id="cableDetails" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Cable Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'cableDetails\')"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.saveDetails(\'cableDetails\')" show-validation><div class="modal-body" style="max-height: 65vh;"><div class="form-group"><label class="col-md-3 control-label"><span for="Cable">Cable Name</span></label><div class="col-md-7"><select class="form-control" name="Cable" ng-model="vm.trCase.cableDetails[vm.selectedCable].cableName"><option value="">Select Value</option><option ng-repeat="item in vm.cableName" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="jeAvailability">JE Availability</span></label><div class="col-md-7"><select class="form-control" name="jeAvailability" ng-model="vm.trCase.cableDetails[vm.selectedCable].jeAvailability"><option value="">Select Value</option><option ng-repeat="item in vm.jeAvailability" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableCapacity">Cable Capacity</span></label><div class="col-md-7"><select class="form-control" name="cableCapacity" ng-model="vm.trCase.cableDetails[vm.selectedCable].cableCapacity"><option value="">Select Value</option><option ng-repeat="item in vm.cableCapacity" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Drum">Drum Number</span></label><div class="col-md-7"><input type="text" class="form-control" name="Drum" ng-model="vm.trCase.cableDetails[vm.selectedCable].drumNumber"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Direction">From Direction</span></label><div class="col-md-7"><input type="text" class="form-control" name="Direction" ng-model="vm.trCase.cableDetails[vm.selectedCable].fromDirection"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Length">Approx Loop Length</span></label><div class="col-md-7"><input type="number" min="0" oninput="this.value = Math.abs(this.value)" class="form-control" name="Length" ng-model="vm.trCase.cableDetails[vm.selectedCable].approxLoopLength"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'cableDetails\')">Cancel</button> <button type="submit" class="btn btn-primary">Save</button></div></form></div></div></div><div id="splicingDetails" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Splicing Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'splicingDetails\')"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.saveDetails(\'splicingDetails\')" show-validation><div class="modal-body" id="scrollTop" style="max-height: 65vh;\r\n                overflow: auto;overflow-x: hidden"><div class="form-group"><label class="col-md-3 control-label"><span for="jeNumber">JE Number</span></label><div class="col-md-6"><select class="form-control" name="jeNumber" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].jeNumber"><option value="">Select Value</option><option ng-repeat="item in vm.jeNumber" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableSide">Cable A Side</span></label><div class="col-md-6"><select class="form-control" name="cableSide" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].fromFiber.cableSide"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="tubeSide">Tube A Side</span></label><div class="col-md-6"><select class="form-control" name="tubeSide" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].fromFiber.tubeSide"><option value="">Select Value</option><option ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="CoreStart">Core A Start</span></label><div class="col-md-6"><input type="text" class="form-control" name="CoreStart" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].fromFiber.coreStart"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreEnd">Core A End</span></label><div class="col-md-6"><input type="text" class="form-control" name="coreEnd" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].fromFiber.coreEnd"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableSide">Cable B Side</span></label><div class="col-md-6"><select class="form-control" name="cableSide" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].toFiber.cableSide"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="tubeSide">Tube B Side</span></label><div class="col-md-6"><select class="form-control" name="tubeSide" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].toFiber.tubeSide"><option value="">Select Value</option><option ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreStartb">Core B Start</span></label><div class="col-md-6"><input type="text" class="form-control" name="coreStartb" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].toFiber.coreStart"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreEndb">Core B End</span></label><div class="col-md-6"><input type="text" class="form-control" name="coreEndb" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].toFiber.coreEnd"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="numberOfSplice">Number of Splice</span></label><div class="col-md-6"><input type="number" min="0" oninput="this.value = Math.abs(this.value)" class="form-control" name="numberOfSplice" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].numberOfSplice"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="utilization">Utilization</span></label><div class="col-md-6"><input type="text" class="form-control" name="utilization" ng-model="vm.trCase.splicingDetails[vm.selectedSlicing].utilization"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'splicingDetails\')">Cancel</button> <button type="submit" class="btn btn-primary">Save</button></div></form></div></div></div><div id="fmsDetails" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">FMS & Cable Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'fmsDetails\')"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.saveDetails(\'fmsDetails\')" show-validation><div class="modal-body" id="scrollTop" style="max-height: 65vh;\r\n                overflow: auto;overflow-x: hidden"><div class="form-group"><label class="col-md-3 control-label"><span for="fmsNumber">FMS Number</span></label><div class="col-md-6"><select class="form-control" name="fmsNumber" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].fmsNumber"><option value="">Select Value</option><option ng-repeat="item in vm.fmsNumber" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Capacity">FMS Capacity</span></label><div class="col-md-6"><select class="form-control" name="Capacity" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].fmsCapacity"><option value="">Select Value</option><option ng-repeat="item in vm.fmsCapacity" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Number1">Cable Number A Side</span></label><div class="col-md-6"><select class="form-control" name="Number1" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].sideACable.cableNumber"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Drum1">Drum Number A Side</span></label><div class="col-md-6"><input type="text" class="form-control" name="Drum1" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].sideACable.drumNumber"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Number2">Cable Number B Side</span></label><div class="col-md-6"><select class="form-control" name="Number2" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].sideBCable.cableNumber"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Drum2">Drum Number B Side</span></label><div class="col-md-6"><input type="text" class="form-control" name="Drum2" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].sideBCable.drumNumber"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="From">From Chamber ID / Location for C1</span></label><div class="col-md-6"><input type="text" class="form-control" name="From" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].fromChamberId"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="To">To Chamber ID / Location for C2</span></label><div class="col-md-6"><input type="text" class="form-control" name="To" ng-model="vm.trCase.fmsAndCableDetails[vm.selectedFms].toChamberId"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'fmsDetails\')">Cancel</button> <button type="submit" class="btn btn-primary">Save</button></div></form></div></div></div><div id="terminationDetails" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Termination Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'terminationDetails\')"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.saveDetails(\'terminationDetails\')" show-validation><div class="modal-body" id="scrollTop" style="max-height: 65vh;\r\n                overflow: auto;overflow-x: hidden"><div class="form-group"><label class="col-md-3 control-label"><span for="FMS">FMS</span></label><div class="col-md-6"><select class="form-control" name="FMS" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].fms"><option value="">Select Value</option><option ng-repeat="item in vm.fms" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Type">Type</span></label><div class="col-md-6"><select class="form-control" name="Type" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].type"><option value="">Select Value</option><option ng-repeat="item in vm.type" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="Port">Port Number Start</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="Port" id="field_name" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portNumberStart"></div><!-- <div class="col-md-6">\r\n                                <select class="form-control" name="Port" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portNumberStart"  \r\n                                >\r\n                                <option  value="">Select Value</option>\r\n                                <option  ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select>\r\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="PortEnd">Port Number End</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="PortEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portNumberEnd"></div><!-- <div class="col-md-6">\r\n                                <select class="form-control" name="PortEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portNumberEnd"  \r\n                                >\r\n                                <option  value="">Select Value</option>\r\n                                <option  ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select>\r\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableNumber1">Cable Number A Side</span></label><div class="col-md-6"><select class="form-control" name="cableNumber1" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.cableNumber"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreStart">Core Number A Side Start</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="coreStart" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.coreNumberStart"></div><!-- <div class="col-md-6">\r\n                                <select class="form-control" name="coreStart" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.coreNumberStart"  \r\n                                >\r\n                                <option  value="">Select Value</option>\r\n                                <option  ng-repeat="item in vm.cableNumber" value="{{item.configKey}}">{{item.configValue}}</option></select>\r\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreEnd">Core Number A Side End</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="coreEnd" id="field_name" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.coreNumberEnd"></div><!-- <div class="col-md-6">\r\n                                <select class="form-control" name="coreEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideACable.coreNumberEnd"  \r\n                                >\r\n                                <option  value="">Select Value</option>\r\n                                <option  ng-repeat="item in vm.cableNumber" value="{{item.configKey}}">{{item.configValue}}</option></select>\r\n\r\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="numberOfSplice">Number of Splice</span></label><div class="col-md-6"><input type="number" min="0" oninput="this.value = Math.abs(this.value)" class="form-control" name="numberOfSplice" id="field_name" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].numberOfSplice"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="portUsedFor">Port used for</span></label><div class="col-md-6"><input type="text" class="form-control" name="portUsedFor" id="field_name" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].portUsedFor"></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="cableNumber">Cable Number B Side</span></label><div class="col-md-6"><select class="form-control" name="cableNumber" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.cableNumber"><option value="">Select Value</option><option ng-repeat="item in vm.cableSide" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreNumberStart">Core Number B Side Start</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="coreNumberStart" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.coreNumberStart"></div><!-- <div class="col-md-6">\r\n                                <select class="form-control" name="coreNumberStart" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.coreNumberStart"  \r\n                                >\r\n                                <option  value="">Select Value</option>\r\n                                <option  ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select>\r\n                        </div> --></div><div class="form-group"><label class="col-md-3 control-label"><span for="coreNumberEnd">Core Number B Side End</span></label><div class="col-md-6"><input type="text" oninput="this.value = this.value.replace(/^[0-0]|[^0-9]|9[7-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');" maxlength="2" class="form-control" name="coreNumberEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.coreNumberEnd"></div><!-- <div class="col-md-6">\r\n                                <select class="form-control" name="coreNumberEnd" ng-model="vm.trCase.terminationDetails[vm.selectedTermination].sideBCable.coreNumberEnd"  \r\n                                >\r\n                                <option  value="">Select Value</option>\r\n                                <option  ng-repeat="item in vm.tubeSide" value="{{item.configKey}}">{{item.configValue}}</option></select>\r\n                        </div> --></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'terminationDetails\')">Cancel</button> <button type="submit" class="btn btn-primary">Save</button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-fiber-core.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate=" "></span>Fiber Core Map View</h3></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="map-view"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas" style="height:600px; width:100%"></div></div></div></div></div></div></div></div></div><div id="userPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 50%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">Fiber Core Cable Details</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="hideEditModal()"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="myEditAssetText"></span></div><div style="width: 100%; height: 500px; padding-top: 7px;" class="modal-body"><div class="row"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label" for="field_Id"><span translate="">Cable Id</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_id" ng-model="vm.cableId" required ng-minlength="3" ng-maxlength="50"></div></div><br><br><div class="form-group"><label class="col-md-3 control-label" for="field_search"><span translate="">Select Cable Type</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><select class="form-control" name="status" ng-model="vm.coreType" id="field_color" required><!-- <option value="blue" translate=" ">All</option> --><option value="blue" translate=" ">{{vm.selectedTube.madalTube.tubeType}}</option><option value="Orange" translate=" ">{{vm.selectedTube.coreTube[0].tubeType}}</option><option value="Green" translate=" ">{{vm.selectedTube.coreTube[1].tubeType}}</option><option value="Brown" translate=" ">{{vm.selectedTube.coreTubeChildA.tubeType}}</option><option value="Slate" translate=" ">{{vm.selectedTube.coreTubeChildB.tubeType}}</option><option value="White" translate=" ">{{vm.selectedTube.coreTubeChildBZ.tubeType}}</option><option value="Red" translate=" ">{{vm.selectedTube.coreTubeChildAZ.tubeType}}</option></select></div></div><br><br><div class="form-group"><label class="col-md-3 control-label" for="field_search"><span translate="">Fiber Core Cable</span></label><div class="col-md-7"><img class="img-responsive col-md-1" ng-show="vm.tube01" ng-src="content/images/tube01.png" ng-click="vm.coreColor()" style="float:left; display: inline-flex; width: 15%; padding:0px; outline:none;"> <img class="img-responsive col-md-1" ng-show="vm.tube02" ng-src="content/images/tube02.png" ng-click="vm.coreColor()" style="float:left; display: inline-flex; width: 13%; padding:0px; outline:none;"> <img class="img-responsive col-md-1" ng-show="vm.tube03" ng-src="content/images/tube03.png" ng-click="vm.coreColor()" style="float:left; display: inline-flex; width: 15%; padding:0px; outline:none;margin-left: 3px;"> <img class="img-responsive col-md-1" ng-show="vm.tube04" ng-src="content/images/tube04.png" ng-click="vm.coreColor()" style="float:left; display: inline-flex; width: 15%; padding:0px; outline:none;margin-left: 3px;"></div></div><br><br><div class="form-group" ng-if="showSelectColor"><label class="col-md-3 control-label" for="field_search"></label><div class="col-md-7" style="text-align: right;"><div style="font-size:14px;margin-right: 17px; color: green;">&#9733; : Used Cables</div><div style="font-size:14px; color: red;">&#9734; : Available Cables</div></div></div><br><br><div class="form-group" ng-if="showSelectColor"><label class="col-md-3 control-label" translate=" " for="field_description">core Colors</label><ol class="col-md-7" type="1" ng-click="vm.closeTubeColors()" style="margin-top: 8px; outline: 1cm;"><li class="rectangle" style="height: 15px;width: 400px;background-color: blue;" ng-if="vm.coreSize > 11"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: orange;" ng-if="vm.coreSize > 10"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: green;" ng-if="vm.coreSize > 9"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: brown;" ng-if="vm.coreSize > 8"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: slategray;" ng-if="vm.coreSize > 7"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color:snow" ng-if="vm.coreSize > 6"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: red;" ng-if="vm.coreSize > 5"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: green;">&#9733;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: black;" ng-if="vm.coreSize > 4"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: yellow;" ng-if="vm.coreSize > 3"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: violet;" ng-if="vm.coreSize > 2"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: rosybrown;" ng-if="vm.coreSize > 1"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li><li class="rectangle" style="height: 15px;width: 400px;background-color: aqua;" ng-if="vm.coreSize > 0"><span style="float: right;margin-right: -13px; margin-top: -3px;font-size:12px; color: red;">&#9734;</span></li></ol></div><!-- <div style="height: 40px; width: 98%;" class="col-md-12 modal_body_content">\r\n                            <button class="btn btn-info btn-flat"\r\n                                style="float: right; border-radius: 5px; padding: 6px 25px; border: none"\r\n                                ng-click="saveEditAsset()">\r\n                                <span><b>Save</b></span>\r\n                            </button>\r\n                        </div> --><!-- <div style="height: 40px; width: 98%;" class="col-md-12 modal_body_content">\r\n                        <button class="btn btn-info btn-flat" style="float: right; border-radius: 5px; padding: 6px 25px; border: none"\r\n                            ng-click="EditAsset()">\r\n                            <span><b>Edit</b></span>\r\n                        </button>\r\n                    </div> --></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-import.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i>Import Incidents</h3><div class="box-tools ng-scope"><button class="btn btn-create"><span class="fa fa-download"></span> <a href="content/images/SampleCases.xlsx" download id="a__text">Sample File</a></button></div></div><!-- /.box-header --><!-- form start --><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file accept="*.xlsx||*.xls" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel file should be uploaded</p></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-case-work-flow.html','<div class="content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrCaseLabel"><span ng-if="!vm.trCase.id">Create Work Flow</span> <span ng-if="vm.trCase.id" translate="trakeyeApp.trCase.home.EditLabel">Edit</span></h3></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-8"><button type="button" ng-click="setTab(1)" ng-class="{\'btn-primary\' : vm.toggleFirst, \'btn-default\':!vm.toggleFirst }" style="width: 30%; height: 40px;"><span>Work Flow Details</span></button> <button type="button" ng-disabled="editForm.$invalid ||  vm.isSaving" ng-click="setTab(2)" ng-class="{\'btn-primary\' : vm.toggleSecond, \'btn-default\': !vm.toggleSecond}" style="width: 30%; height: 40px;"><span>Plan Activity</span></button> <button type="button" ng-disabled="editForm.$invalid || vm.isShowing" ng-click="setTab(3)" ng-class="{\'btn-primary\' :vm.toggleThird, \'btn-default\': !vm.toggleThird}" style="width: 30%; height: 40px;"><span>Save Work Flow</span></button></div><div class="pull-right" ng-show="isSet(2)" style="margin-right:15px;margin-left:5px;"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.refreshPage()"><span class="fa fa-refresh"></span></button></div><div class="pull-right" ng-show="isSet(2) && vm.mappedAssetsList.length > 1" style="margin-left:5px;"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.connectSelectedAssets()"><span><b>Connect Two Assets<b></b></b></span></button></div></div></div><br><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.trCase.id" ng-show="isSet(1)"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.trCase.id"></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.trCase.description">Description</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><textarea class="form-control" rows="2" name="description" id="field_description" ng-model="vm.trCase.description" required></textarea></div></div><div class="form-group" ng-if="vm.trCase.id" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.trCase.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.trCase.status" id="field_status" required><!-- <option value="NEW" translate="trakeyeApp.CaseStatus.NEW">NEW</option>\r\n                                    <option value="INPROGRESS" translate="trakeyeApp.CaseStatus.INPROGRESS">IN PROGRESS</option>\r\n                                    <option value="PENDING" translate="trakeyeApp.CaseStatus.PENDING">PENDING</option>\r\n                                    <option value="ASSIGNED" translate="trakeyeApp.CaseStatus.ASSIGNED">ASSIGNED</option>\r\n                                    <option value="RESOLVED" translate="trakeyeApp.CaseStatus.RESOLVED">RESOLVED</option>\r\n\t\t\t\t\t\t\t\t\t<option value="CANCELLED" translate="trakeyeApp.CaseStatus.CANCELLED">CANCELLED</option> --><option value="NEW">PLANNING PHASE</option><option value="INPROGRESS">ROLL-OUT PHASE</option><option value="PENDING">PENDING</option><option value="ASSIGNED">ASSIGNED</option><option value="RESOLVED">OPERATION PHASE</option><option value="CANCELLED">CANCELLED</option></select></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_priority"><span translate="trakeyeApp.trCase.priority">Priority</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="priority" ng-model="vm.trCase.priority" id="field_priority" required><option disabled="disabled" selected="selected" value>--- Select Priority ---</option><option value="LOW">LOW</option><option value="MEDIUM">MEDIUM</option><option value="HIGH" selected="selected" value>HIGH</option><option value="CRITICAL">CRITICAL</option></select></div></div><!-- <div class="form-group" ng-if="has_ROLE_USER_ADMIN" ng-show="isSet(1)">\r\n                            <label class="col-md-3 control-label" for="field_parent">\r\n\t\t\t\t\t\t\t\t<span>Parent Cases</span>\r\n                                <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                            </label>\r\n                            <div class="col-md-8">\r\n                                <input list="userslist" class="form-control" id="field_parent" placeholder="Search incident name" type="text" \r\n                                \tng-model="vm.trCase.parent" autocomplete="off" name="parent" ng-change="vm.filterActivatedcases()" required>\r\n                                <datalist ng-hide="!vm.childAssets" id="caselist" class="form-control1">\r\n                                    <option ng-repeat="child in vm.childAssets" value="{{child.name}}"></option>\r\n                                </datalist>\r\n                            </div>\r\n                        </div> --><div class="form-group" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN" ng-show="isSet(1)"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.group">Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div isteven-multi-select input-model="vm.multigroup" output-model="vm.trCase.groups" button-label="name" on-item-click="vm.selectedGroup(vm.trCase.groups)" item-label="name" tick-property="ticked" output-properties="id selected" selection-mode="single"></div><input type="text" ng-model="vm.trCase.groups" name="group" style="display: none"></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_assignedTo"><span translate="trakeyeApp.trCase.assignedTo">Assigned To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input list="userslist" class="form-control" ng-disabled="vm.hideUser" id="field_assignedToUser" placeholder="Search user login name" type="text" ng-model="vm.trCase.assignedToUser" autocomplete="off" name="assignedToUser" ng-change="vm.filterActivatedUser()" required><datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1"><option ng-repeat="user in vm.activatedusers" value="{{user.login}}"></option></datalist></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label"><span translate="trakeyeApp.trCase.caseType">caseType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="caseType" ng-model="vm.caseType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.caseTypes track by item.id" ng-disabled="vm.trCase.id!=null" required style="width: 100%;"><option value="" translate="trakeyeApp.trCase.selectcase">--- Select WorkFlowType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.trCase.caseTypeAttributeValues | orderBy: \'caseTypeAttribute.id\' track by $index" ng-class="{\'has-error\' : userIntForm.value.$invalid }" ng-show="isSet(1)"><label class="col-md-3 control-label"><span>{{attribute.caseTypeAttribute.name}}</span></label><div class="col-md-8" ng-repeat="attributeValue\r\n                                    in vm.trCase.caseTypeAttributeValues track\r\n                                    by $index"><div ng-if="attributeValue.caseTypeAttribute.id\r\n                                        == attribute.caseTypeAttribute.id"><input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                            == \'FLOAT\' && !vm.trCase.id" type="text" class="form-control" ng-init="attributeValue.attributeValue=\r\n                                            attribute.caseTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                            == \'FLOAT\' && vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <span ng-if="attribute.caseTypeAttribute.dataType\r\n                                            == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                            == \'INTEGER\' && !vm.trCase.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\r\n                                            attribute.caseTypeAttribute.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                            == \'INTEGER\' && vm.trCase.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.caseTypeAttribute.dataType\r\n                                            == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                            == \'STRING\' && !vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\r\n                                            attribute.caseTypeAttribute.value" ng-model="attributeValue.attributeValue"> <input ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                            == \'STRING\' && vm.trCase.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="attributeValue.attributeValue"> <span ng-if="attribute.caseTypeAttribute.attributeDataType.name\r\n                                            == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="attributeValue.attributeValue" ng-init="attributeValue.attributeValue = attribute.caseTypeAttribute.value" ng-if="attribute.caseTypeAttribute.attributeDataType.name != \'STRING\' && attribute.caseTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.caseTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trCase.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.caseTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="attributeValue.attributeValue" ng-init="attributeValue.attributeValue == attribute.caseTypeAttribute.attributeValue" ng-if="attribute.caseTypeAttribute.attributeDataType.name != \'STRING\' && attribute.caseTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.caseTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trCase.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.caseTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><div class="map-view row mt-5" ng-show="isSet(2)"><div class="column col-md-8" id="map_canvas_planning" style="height:75vh;width:77%;margin-left: 30px;"></div><div class="column col-md-4" style="width:20%;height:75vh"><div class="row input-group input-group-sm" style="margin-top:3px;margin-left: 5px;"><input type="text" placeholder="Search" ng-model="searchText" class="search-box"></div><br><div class="row"><div class="box-body scrollbar" id="style-3" style="width: 90%;"><table class="jh-table table table-responsive table-hover" style="background-color: #eae9e9;"><thead class="thead-light"><tr><th>Asset Type</th><th>Type</th></tr></thead><tbody><tr ng-repeat="item in vm.assetType | filter : searchText" ng-click="vm.createAssetModal(item)"><td>{{item.name}}</td><td ng-show="{{item.imagePath != null}}"><img class="img-responsive" ng-src="{{item.imagePath}}" style="width: 24px; height: 24px;"></td><td ng-show="{{item.colorcode != null}}"><img class="square" style="background-color:{{item.colorcode}};"></td></tr></tbody></table></div></div><div class="row"><div class="box-body scrollbar" id="style-3" style="width: 90%;"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr><th></th><th><span>Name</span></th><th><span>Actions</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.mappedAssetsList track by asset.name" ng-class="{selected: asset.isChecked}"><td><input type="checkbox" ng-model="asset.isChecked" ng-change="selectEntity(asset)"></td><td>{{asset.name}}</td><td><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a id="editlink" ng-click="vm.editAsset(asset)" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="link" ng-click="vm.deleteAssetModal(asset.name)" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.mappedAssetsList.length==0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div></div><div class="form-group" style="margin:20px;" ng-show="isSet(3)"><jhi-alert-error></jhi-alert-error><div ng-if="vm.previousId"><button class="btn btn-primary btn-sm pull-right" type="button" class="btn btn-primary btn-sm" ng-click="vm.recalculate()"><span>Recalculate</span></button></div><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.trCase.description" ng-if="vm.trCase.description">Description</span></dt><dd><span>{{vm.trCase.description}}</span></dd><dt><span translate="trakeyeApp.trCase.caseType" ng-if="vm.trCase.caseType">Incident Type</span></dt><dd ng-if="vm.trCase.caseType">{{vm.trCase.caseType.name}}</dd></dl><!-- <div ng-repeat="attributeValue in vm.trCase.caseTypeAttributeValues track by $index">\r\n                                    <div ng-if="attributeValue.caseTypeAttribute.id == attribute.caseTypeAttribute.id">\r\n                                        <span style="margin-left: 20%"><b>{{attribute.caseTypeAttribute.name}}</b>\r\n                                        <span style="margin-left: 20px;">{{attribute.attributeValue}}</span></span>\r\n                                    </div>\r\n\t\t\t\t\t\t\t\t</div>  --><div class="form-group" ng-if="vm.trCase.caseType" style="height:200px;overflow:scroll;width: 50%;margin-left: 200px;"><table class="jh-table table table-responsive table-hover" style="width:100%;"><thead class="thead-light"><tr><th style="font-weight: 600;font-size: 12px;color: #26292b;text-align: left;border: 1px solid #dddddd;background:#eee;position: sticky;top: 0;z-index: 10;">Name</th><th style="font-weight: 600;font-size: 12px;color: #26292b;text-align: left;border: 1px solid #dddddd;background: #eee;position: sticky;top: 0;z-index: 10;">Value</th></tr></thead><tbody ng-repeat="attribute in vm.trCase.caseTypeAttributeValues | orderBy: \'caseTypeAttribute.id\'"><tr ng-repeat="attributeValue in vm.trCase.caseTypeAttributeValues track by $index"><td ng-if="attributeValue.caseTypeAttribute.id == attribute.caseTypeAttribute.id" style="border: 1px solid #dddddd;">{{attribute.caseTypeAttribute.name}}</td><td ng-if="attributeValue.caseTypeAttribute.id == attribute.caseTypeAttribute.id" style="border: 1px solid #dddddd;">{{attribute.attributeValue}}</td></tr></tbody></table></div><div class="col-md-12"><div class="col-md-9" id="map_canvas_deployed" style="height:500px; width: 100%;"></div></div></div><div class="box-footer"><div class="col-md-12 next-button" ng-show="isSet(1)" style="text-align:right;margin-right:20px;"><button type="button" class="btn btn-primary btn-sm" ng-disabled="editForm.$invalid ||  vm.isSaving || vm.validUser" ng-click="setTab(2)"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 next-button" ng-show="isSet(2)" style="text-align:right; margin-right:20px;"><button type="button" class="btn btn-primary btn-sm" ng-click="setTab(1)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="button" class="btn btn-primary btn-sm" ng-disabled="editForm.$invalid || vm.isShowing" ng-click="setTab(3)"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 save-buttons" ng-show="isSet(3)" style="text-align:right;margin-right:20px;"><button type="button" class="btn btn-primary btn-sm" ng-click="setTab(2)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon"></span> <span>Submit</span></button></div></div></div></form></div></div></div><!--Modal for editing asset--><div id="userPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="myEditAssetText"></span></div><div style="width: 100%; height: 80vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="row"><div class="col-md-12"><div class="box-body"><button class="btn btn-info btn-flat" style="float: right; border: none; margin-right: 20px" ng-click="vm.saveEditAsset()"><span><b>Save</b></span></button><div class="row" style="margin:20px"><label class="col-md-3 control-label"><span>Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.asset.name" ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row" style="margin: 20px;"><div class="col-md-3 control-label"><span>Asset Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3 control-label"><span>{{vm.asset.assetType.name}}</span></div></div><div class="row" ng-repeat="attribute in vm.asset.assetTypeAttributeValues track by $index" style="margin: 20px;"><label class="col-md-3 control-label"><span>{{attribute.assetTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue == attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value}}</option></select></div></div><div class="row" style="margin: 20px;"><!--<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t\t\t\t<span>Coordinates</span> \r\n\t\t\t\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup>\r\n\t\t\t\t\t\t\t\t\t\t</label>--><div class="col-md-9"><!--<div class="input-group">\r\n\t\t\t                                    <input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled ng-model="vm.asset.assetCoordinates" />\r\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id==null && !vm.isSite">\r\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Select On Map</button>\r\n\t\t\t\t\t\t\t\t\t\t\t   </span>\r\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id!=null">\r\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Edit</button>\r\n\t\t\t\t\t\t\t\t\t\t\t   </span>\r\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id!=null">\r\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm" >Recreate</button>\r\n\t\t\t\t\t\t\t\t\t\t\t   </span>\r\n\t\t\t                                </div>\r\n\t\t\t                                <br/>>\r\n\t\t\t                                <h4>{{vm.siteLatLng}}</h4>--><div id="map_canvas_edit_asset" style="height:300px;"></div></div></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">Connect Two Assets</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.hideConnectSitesModal()"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="connectAssetsText"></span></div><!-- Modal body--><div style="width: 100%; height: 80vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="row"><div style="margin-top: 8px; margin-left: 36px;"><div class="col-md-1 select_asset" style="text-align: right"><label style="padding-top: 6px;">Site A</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;"><select id="fromAssetsView" class="select2 form-control" name="search" style="width:220px; height: 40px"><option value="">--Select Site A--</option><option ng-repeat="item in vm.mappedAssetsList" value="{{item.name}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px; margin-left: 93px;"><label style="padding-top: 6px;">Site B</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;margin-left: -15px;"><select id="toAssetsView" class="select2 form-control" name="search" style="width:220px; height: 40px;"><option value="">--Select Site B--</option><option ng-repeat="item in vm.mappedAssetsList" value="{{item.name}}">{{item.name}}</option></select></div><button type="button" ng-click="vm.connectAssets()" class="btn btn-primary btn-sm">Connect</button></div><div class="form-group"><div class="col-md-11" style="margin: 20px"><div id="map_canvas_connect_assets" style="width: 100%;height:560px;"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectMultipleAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="vm.hideConnectMultipleAssetsModal()" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle; font-weight: 125;" id="connectAssetsText">Select site to connect</span></div><!-- Modal body--><div style="width: 100%; height: 80vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="col-md-12"><div id="map_canvas_connect_multiple_assets" style="width: 100%;height:68vh;margin-top: 10px;"></div></div><div class="col-md-12"><button class="btn btn-primary btn-sm pull-right" type="button" ng-click="vm.saveLinkPits()" style="margin: 10px;">Save</button></div></div></div></div></div><!-- Modal for delete asset   --><div id="delete-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40%; margin: 200px auto;" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cleardeleteAsset()">&times;</button></div><div class="modal-body"><h4>Are you sure you want to delete this asset?</h4></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.cleardeleteAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm" ng-click="vm.confirmDeleteAsset()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></div></div></div></div><!-- Modal for create asset   --><div id="create-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 45%; margin: 100px auto;"><div class="modal-content"><form name="form" class="css-form" novalidate><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">Asset Creation Form of Type {{vm.CreateAssetName}}</span> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clearCreateAsset()">&times;</button></div><div class="modal-body"><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-2 control-label" style="width: 17%;"><span style="vertical-align: center;">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7" style="width: 71%"><input type="text" name="name" ng-model="vm.assetNameVal" ng-change="vm.searchAssetName()" class="form-control" placeholder="Please Enter AssetName" style="padding: 6px;" required><div ng-show="vm.assetExisting"><div class="help-block" ng-show="form.name.$error">AssetName is already exist</div></div></div></div></div><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-2 control-label" style="width: 17%;"><span>Lat</span></label><div class="col-md-3"><input name="Lat" ng-model="vm.assetLat" type="text" style="width: 120%; padding: 6px;"></div><label class="col-md-2"><span style="padding: 13px;">Long</span></label><div class="col-md-3"><input name="Long" ng-model="vm.assetLong" type="text" style="width: 120%; padding: 6px;"></div></div></div><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-4 control-label" style="width: 17%;"><span style="vertical-align: center;">ParentSite</span></label><div class="col-md-8" style="width: 71%"><select class="form-control" name="asset" id="asset" ng-model="vm.parentAsset"><!-- <option value="">Select Parent Site </option> --><option ng-repeat="site in vm.mappedAssetsList" ng-if="site.assetType.name == \'Site\'" value="{{site.name}}">{{site.name}}</option></select></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clearCreateAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.createAsset()" ng-disabled="vm.showAssetCreation"><span>OK</span></button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-case/tr-cases.html','<div class="content"><div class="row"><div ng-show="vm.showCasesFilter"><div class="col-md-3 caseType_showImg mb-5"><label style="margin-right: 10px;">Incidents Filter :</label><!-- 6 months\r\n                                    <label class="switch">\r\n                                       \r\n                                        <input type="checkbox" style="\r\n                                                 margin-top: 10px;\r\n                                                 margin-left: 15px;\r\n                                             " data-toggle="modal" data-target="#myModal" id="{{asset.id}}"\r\n                                             ng-checked="asset.accessible" ng-model="asset.accessible"\r\n                                             ng-change="accessibleCheckChange(asset)" /> \r\n                                         <span class="slider round"></span>\r\n                                         \r\n                                         </label>\r\n                                         Custom Date --> <label class="radio-inline"><input type="radio" name="dateRange" required ng-model="vm.dateRange" value="day" ng-click="vm.newCases()">New</label> <label class="radio-inline"><input type="radio" name="dateRange" ng-model="vm.dateRange" value="custom">Old</label></div><div class="form-group col-md-9" ng-show="vm.dateRange == \'custom\'"><div class="col-md-3"><!-- <label class="control-label">From\r\n                        :</label> --><!-- \t<input type="date" class=" form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required/> --><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')">From <i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_serviceDate" type="text" class="form-control" name="fromDate" ng-model="vm.fromDate" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.fromDate" enable-time="false" datepicker-options="options" required></div><span id="noData" ng-show="vm.fromDate == null">*select from date</span></div><div class="col-md-3"><!-- <label class="control-label location_labels">To :</label> --><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')">To <i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_toDate" type="text" class="form-control" name="toDate" ng-model="vm.toDate" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.toDate" enable-time="false" datepicker-options="options" required></div></div><div class="col-md-2"><!--  <label class="control-label location_labels"></label> --><div class="input-group"><a class="btn btn-info btn-flat" ng-click="submitDate()"><span>Submit</span></a></div></div></div></div><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><!--<h3 class="box-title"><i class="fa fa-th-large"></i> <span translate="trakeyeApp.trCase.home.title"> Incident </span></h3>--><div class="pull-left"><h3 class="box-title"><i class="fa fa-th-large"></i> <span translate="trakeyeApp.trCase.home.title">Incidents</span></h3></div><div class="col-md-6 headerTab"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}" ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(1); search = null" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">List</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(2)}" ng-hide="has_ROLE_VENDOR"><a href ng-click="setTab(2); search = null" data-toggle="tab"><i class="fa fa-map"></i><span class="header-view">Map</span> <span class="header_view">View</span></a></li><li ng-class="{active:isSet(3)}" ng-hide="has_ROLE_VENDOR" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><a href ng-click="setTab(3);" data-toggle="tab"><i class="fa fa-user-circle"></i><span class="header-view">Find</span> <span class="header_view">Nearby</span></a></li><!-- <li ng-class="{active:isSet(4)}" ng-hide="has_ROLE_VENDOR"\r\n                                        ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                                        <a href ng-click="setTab(4);" data-toggle="tab"><i class="fa fa-globe"></i><span class="header-view">Region</span> <span class="header_view">View</span></a>\r\n                                    </li> --><!-- <li ng-class="{active:isSet(5)}" ng-hide="has_ROLE_VENDOR"\r\n                                        ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                                        <a href ng-click="setTab(5);" data-toggle="tab"><i class="fa fa-briefcase"></i><span class="header-view">Material</span></a>\r\n                                    </li> --></ul></div><div class="box-tools"><!-- <button class="btn btn-create btn-sm " title="Incidents Date Filter"  ng-click="vm.showHideFilter()">\r\n                            <span>\r\n                                <i class="fa fa-calendar" aria-hidden="true"></i> {{vm.textFilter}} Filter\r\n                            </span>\r\n                        </button> --><!-- <button class="btn btn-create btn-sm" ui-sref="tr-case.import" ng-if="has_ROLE_USER_ADMIN">\r\n                            <span class="glyphicon glyphicon-plus"></span> <span> Import </span>\r\n                        </button> --> <button class="btn btn-create btn-sm" ui-sref="tr-case.new" ng-hide="has_ROLE_VENDOR"><span class="glyphicon glyphicon-plus"></span> <span>Create</span></button><!-- <button class="btn btn-create btn-sm" ui-sref="tr-case.fibercore">\r\n                            <span class="glyphicon glyphicon-plus"></span>\r\n                            <span translate=""></span>\r\n                            <span> Fiber Core Map View </span>\r\n                        </button> --><!--<button class="btn btn-create btn-sm" ui-sref="tr-case.new">\r\n                            <span class="glyphicon glyphicon-plus"></span>\r\n                            <span translate="trakeyeApp.trCase.home.createLabel">\r\n                                Create Incident\r\n                            </span>\r\n                        </button>--></div></div><div class="box-body"><jhi-alert></jhi-alert><!-- Filters for List View - Copied from Incident Dashboard --><div class="row mb-3" ng-show="isSet(1) && vm.showNewListFilterMode"><div class="col-md-12"><div class="row" style="display: flex; align-items: flex-end; gap: 10px;"><!-- AMC Status --><div class="col-12 col-sm-6 col-lg-1" style="flex: 0 0 auto;"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Status</label> <select class="form-select form-select-sm" ng-model="vm.selectedAMCStatusList" ng-change="vm.onAMCStatusChangeList(vm.selectedAMCStatusList)" title="Status" style="height: 32px; width: 100%;" ng-options="status.id as status.name for status in vm.amcStatusListView"><option value="">-- Select Status --</option></select></div><!-- Package --><div class="col-12 col-sm-6 col-lg-1" style="flex: 0 0 auto;"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Package</label> <select class="form-select form-select-sm" ng-model="vm.selectedPackageList" ng-change="vm.onPackageChangeList(vm.selectedPackageList)" title="Package" ng-disabled="!vm.packageListView || vm.packageListView.length === 0" style="height: 32px; width: 100%;" ng-options="package.id as package.name for package in vm.packageListView"><option value="">-- Select Package --</option></select></div><!-- State --><div class="col-12 col-sm-6 col-lg-1" style="flex: 0 0 auto;"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">State</label> <select class="form-select form-select-sm" ng-model="vm.selectedStateList" ng-change="vm.onStateChangeList(vm.selectedStateList)" title="State" ng-disabled="!vm.stateListView || vm.stateListView.length === 0" style="height: 32px; width: 100%;" ng-options="state.id as state.name for state in vm.stateListView"><option value="">-- Select State --</option></select></div><!-- BUSINESS AREA --><div class="col-12 col-sm-6 col-lg-1" style="flex: 0 0 auto;"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Business Area</label> <select class="form-select form-select-sm" ng-model="vm.selectedBusinessAreaList" ng-change="vm.onBusinessAreaChangeList(vm.selectedBusinessAreaList)" title="Business Area" ng-disabled="!vm.businessAreaListView || vm.businessAreaListView.length === 0" style="height: 32px; width: 100%;" ng-options="businessArea.id as businessArea.businessAreaName for businessArea in vm.businessAreaListView"><option value="">-- Select Business Area --</option></select></div><!-- OPERATIONAL AREA --><div class="col-12 col-sm-6 col-lg-1" style="flex: 0 0 auto;"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Operational Area</label> <select class="form-select form-select-sm" ng-model="vm.selectedOperationalAreaList" ng-change="vm.onOperationalAreaChangeList(vm.selectedOperationalAreaList)" ng-disabled="!vm.operationalAreaListView || vm.operationalAreaListView.length === 0" title="Operational Area" style="height: 32px; width: 100%;"><option value="">-- Select Operational Area --</option><option ng-repeat="op in vm.operationalAreaListView" ng-value="op.id">{{op.opAreaName}}</option></select></div><!-- District --><div class="col-12 col-sm-6 col-lg-1" style="flex: 0 0 auto;"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">District</label> <select class="form-select form-select-sm" ng-model="vm.selectedDistrictList" ng-change="vm.onDistrictChangeList(vm.selectedDistrictList)" title="District" ng-disabled="!vm.districtListView || vm.districtListView.length === 0" style="height: 32px; width: 100%;"><option value="">-- Select District --</option><option ng-repeat="district in vm.districtListView" ng-value="district.id">{{district.name}}</option></select></div><!-- Block --><div class="col-12 col-sm-6 col-lg-1" style="flex: 0 0 auto;"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Block</label> <select class="form-select form-select-sm" ng-model="vm.selectedBlockList" ng-change="vm.onBlockChangeList(vm.selectedBlockList)" title="Block" ng-disabled="!vm.blockListView || vm.blockListView.length === 0" style="height: 32px; width: 100%;"><option value="">-- Select Block --</option><option ng-repeat="block in vm.blockListView" ng-value="block.id">{{block.name}}</option></select></div><!-- GP --><div class="col-12 col-sm-6 col-lg-1" style="flex: 0 0 auto;"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">GP</label> <select class="form-select form-select-sm" ng-model="vm.selectedGPList" ng-change="vm.onGPChangeList(vm.selectedGPList)" title="GP" ng-disabled="!vm.gpListView || vm.gpListView.length === 0" style="height: 32px; width: 100%;"><option value="">-- Select GP --</option><option ng-repeat="gp in vm.gpListView" ng-value="gp.id">{{gp.name}}</option></select></div><!-- Search Bar - Spacer and Search --><div style="flex: 1;"></div><div style="flex: 0 0 auto; min-width: 200px;"><label class="form-label mb-1" style="font-size: 10px; font-weight: 600;margin-bottom: 0px;">Search</label><div class="input-group" style="height: 32px;"><input type="text" ng-model="search" class="form-control form-control-sm" ng-minlength="0" ng-change="vm.onSearchInputChange()" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search Incidents" style="height: 32px;"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm" ng-click="vm.filterTrcaseSearch()" style="height: 32px;"><i class="fa fa-search"></i></button></span></div></div></div></div></div><div class="row"><!-- <div class="col-md-6">\r\n                            <ul class="nav nav-pills nav-justified">\r\n                                <li ng-class="{active:isSet(1)}" ng-hide="has_ROLE_VENDOR"><a href\r\n                                        ng-click="setTab(1); search = null" data-toggle="tab">List View</a></li>\r\n                                <li ng-class="{active:isSet(2)}" ng-hide="has_ROLE_VENDOR"><a href\r\n                                        ng-click="setTab(2); search = null" data-toggle="tab">Map View</a></li>\r\n                                <li ng-class="{active:isSet(3)}" ng-hide="has_ROLE_VENDOR"\r\n                                    ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                                    <a href ng-click="setTab(3);" data-toggle="tab">Find Nearby</a>\r\n                                </li>\r\n                                <li ng-class="{active:isSet(4)}" ng-hide="has_ROLE_VENDOR"\r\n                                    ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                                    <a href ng-click="setTab(4);" data-toggle="tab">Region View</a>\r\n                                </li>\r\n                             </ul>\r\n                        </div> --><div class="col-md-3 dropFilter" ng-show="isSet(1) && vm.showLegacyListFilterMode"><div isteven-multi-select input-model="vm.geofencesListView" output-model="vm.selectedGeofenceId" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceId" name="vm.searchMini" style="display:none" required></div><div class="col-md-3 search-top pull-right" ng-show="isSet(1) && vm.showLegacyListFilterMode"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search Incidents"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterTrcaseSearch()"><i class="fa fa-search"></i></button></span></div></div><!-- commented  --><div class="col-md-2 selectAsset_drp div--searchasset" ng-show="isSet(4)"><select id="masterGeofence" class="select2 form-control" ng-model="vm.masterGeofence"><option value="">Select City</option><option ng-repeat="item in vm.userMasterGeofences" value="{{item.id}}">{{item.name}}</option></select> <span id="noData" ng-if="vm.selectedMasterGeofenceId == 0">*Please Select City</span></div><div class="col-md-3 dropFilter" ng-show="isSet(2) || isSet(3) || (isSet(4) && vm.selectedMasterGeofenceId > 0)"><!-- <button type="button" class="btn btn-info btn-flat"\r\n                                    ng-click="vm.filterAssetsOnMapView()">\r\n                                    <i class="fa fa-filter"></i>\r\n                                </button> --><div isteven-multi-select input-model="vm.userGeofences" output-model="vm.selectedGeofenceMap" button-label="label" item-label="name" tick-property="ticked" translation="geofencelabel" output-properties="id" selection-mode="single" helper-elements="filter" on-item-click="geofenceListView()" max-height="170px"></div><input type="text" ng-model="vm.selectedGeofenceMap" name="vm.searchMini" style="display:none" required> <span id="noData" ng-if="vm.selectedGeofenceMap.length < 1">*Please Select Block</span><!-- <button type="button" value="Layers" class="btn btn-info btn-flat" ng-click="vm.showPriorityStatusFilter()">\r\n                                    Status Filter\r\n                                </button> --></div><div class="col-md-3 dropFilter" ng-show="(isSet(2) && vm.selectedGeofenceMap.length > 0) || (isSet(3) && vm.selectedGeofenceMap.length > 0) || (isSet(4) && vm.selectedGeofenceMap.length > 0)"><div isteven-multi-select input-model="vm.statusType" output-model="vm.selectedstatusType" button-label="name" item-label="name" tick-property="selected" group-property="msGroup" translation="statuslabel" output-properties="name value" on-select-done="savePriorityStatusFilter()" max-labels="2" max-height="280px" helper-elements="all none Done filter"></div><input type="text" ng-model="vm.selectedstatusType" name="vm.searchMini" style="display:none" required> <span id="noData" ng-if="vm.selectedPriorityList.length == 0 || vm.selectedStatusList.length == 0">* Select atleast one from each group.</span></div><div class="col-md-3 search-top pull-right" ng-show="isSet(2)"><div class=""><div class="input-group"><input type="number" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search Incidents by Id"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.dateFilterTrCaseSearchMap()"><i class="fa fa-search"></i></button></span></div></div></div><div class="col-md-3 selectAsset_drp" ng-show="isSet(3)"><select id="searchOnMap" class="select2 form-control" name="search"><option value="">Search User</option><option ng-repeat="item in vm.usersList" value="{{item}}">{{item.userName}}</option></select></div><div class="col-md-3 pull-right" ng-show="isSet(3)"><div class="input-group"><input type="number" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search Incidents"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.dateFilterTrCaseSearchMap()"><i class="fa fa-search"></i></button></span></div></div><!-- <div class="col-md-1 pull-right" ng-show="isSet(3)">\r\n                            <button type="button" class="btn btn-info btn-flat"\r\n                                ng-click="vm.filterAssetsOnMapView()">\r\n                                <i class="fa fa-filter"></i>\r\n                            </button>\r\n                        </div> --></div><div class="row div--attributes" ng-show="isSet(1)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th><input type="checkbox" ng-click="vm.selectAllAssets()" ng-model="vm.isAllAssetSelected"></th> --><th ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"></th><th jh-sort-by="create_date"><span>Created Date &amp; Time </span><span class="fa fa-sort"></span></th><!-- <th jh-sort-by="case_number"><span>Ticket Id </span><span class="fa fa-sort"></span></th> --><th jh-sort-by="id"><span>Ticket Id</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="description"><span translate="trakeyeApp.trCase.description">Description</span> <span\r\n                                                class="fa fa-sort"></span></th> --><th><span translate="trakeyeApp.trCase.title">Title</span></th><!-- <th jh-sort-by="address" class="table-size"><span translate="trakeyeApp.trCase.address">Address</span> <span\r\n                                                class="fa fa-sort"></span></th> --><th jh-sort-by="case_type_id"><span translate="trakeyeApp.trCase.caseType">Incident Type </span><span class="fa fa-sort"></span></th><th jh-sort-by="priority"><span translate="trakeyeApp.trCase.priority">Priority </span><span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="trakeyeApp.trCase.status">Status</span> <span class="fa fa-sort"></span></th><th jh-sort-by="verified"><span translate="trakeyeApp.trCase.verified">Verified</span> <span class="fa fa-sort"></span></th><th><span>User Name</span></th><!--<th jh-sort-by="escalated"><span translate="trakeyeApp.trCase.escalated">Escalated</span> <span class="fa fa-sort"></span></th>--><!-- <th jh-sort-by="reported_by_id"><span translate="trakeyeApp.trCase.createdBy">CreatedBy </span>\r\n                                            <span class="fa fa-sort"></span>\r\n                                        </th> --><th jh-sort-by="assigned_to_id"><span translate="trakeyeApp.trCase.assignedTo">Assigned To </span><span class="fa fa-sort"></span></th><!-- <th><span translate="">Distance(km)</span> </th> --><!-- <th><span>Fiber Status</span></th> --><!-- <th><span translate="trakeyeApp.trCase.geofence">Geofence</span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="trCase in vm.trCases track by trCase.id"><!-- <td><input type="checkbox" ng-model="trCase.isChecked" ng-change="vm.selectAssetEntity()"></td> --><td class="td__listViewRow" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER" ng-click=" vm.usersTable(trCase);" expand><span ng-if="!trCase.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="trCase.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td><span ng-if="trCase.id == 80834932">28-01-2026 14:02:15</span> <span ng-if="trCase.id != 80834932">{{trCase.createDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</span></td><td><span ng-if="trCase.id == 80834932">262200950</span> <span ng-if="trCase.id != 80834932">{{trCase.caseNumber}}</span></td><!-- <td>{{trCase.description | limitTo:40}}</td> --><td>{{(trCase.title && trCase.title.trim())? trCase.title: (trCase.description || \'NA\')| limitTo:40}}</td><!-- <td title="{{trCase.address}}">{{trCase.address | limitTo: 8\r\n                                            }}{{trCase.address.length > 20 ? \'...\' : \'\'}}</td> --><td>{{trCase.caseTypeName}}</td><td><span class="priority-badge" ng-class="vm.priorityClass(trCase.priority)">{{ (trCase.priority || \'\').charAt(0).toUpperCase() }}</span></td><td><span class="status-badge" title="{{ trCase.status === \'PENDING\' ? \'Out of Scope\' : trCase.status }}" ng-class="{\r\n                                                    \'status_pending\': trCase.status === \'PENDING\',\r\n                                                    \'status_resolved\': trCase.status === \'RESOLVED\',\r\n                                                    \'status_assigned\': trCase.status === \'ASSIGNED\',\r\n                                                    \'status_inprogress\': trCase.status === \'INPROGRESS\',\r\n                                                    \'status_tobeassigned\': trCase.status === \'TOBEASSIGNED\',\r\n                                                    \'status_closed\': trCase.status === \'CLOSED\'\r\n                                                }">{{ trCase.status === \'PENDING\' ? \'O\' : trCase.status.charAt(0) }}</span></td><td><span ng-if="trCase.verified">Yes</span> <span ng-if="!trCase.verified">No</span></td><!-- <td>{{trCase.address}}</td> --><!--<td>\r\n                                                                                <div ng-if="trCase.escalated">YES</div>\r\n                                                                                <div ng-if="!trCase.escalated">NO</div>--><!-- <td>{{trCase.reportedByUser}}</td> --><!--  <td>\r\n                                    \t\t\t\t                        {{trCase.reportedByUser}}\r\n                                    \t\t\t\t                        </td> --><td>{{trCase.assignedToUserFirstName||"NA"}} {{trCase.assignedToUserLastName||"NA"}}</td><td>{{trCase.assignedToUser}}</td><!-- <td ng-if="has_ROLE_USER_ADMIN">\r\n                                                                                <a ui-sref="case-type-detail({id:trCase.caseType.id})">{{trCase.caseType.name}}</a> {{trCase.caseTypeName}}\r\n                                                                            </td> --><!-- <td>{{}}</td> --><!-- <td>{{trCase.geofenceName}}</td> --><td><div class="actions"><!-- <a ng-if="vm.showCaseAttachment" class="action-icons text-info" ng-click="vm.imageUpload({id:trCase.id})"\r\n                                                                                  title="Upload PDF"><span class="fa fa-upload"></span></a> --> <a ui-sref="tr-case-detail({id:trCase.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ng-click="vm.addComment(trCase.id)" class="action-icons text-success" title="Add Comment"><span class="fa fa-comment"></span> </a><a id="editlink" ng-if="!vm.has_ROLE_READONLY" ui-sref="tr-case.edit({id:trCase.id})" class="action-icons text-primary" title="Edit" ng-hide="has_ROLE_READONLY||has_ROLE_VENDOR && trCase.caseTypeName!=\'Vendor Civil Work\'"><span class="fa fa-pencil-square"></span> </a><a id="editlink" ng-if="!vm.has_ROLE_READONLY" ui-sref="tr-case.delete({id:trCase.id})" class="action-icons text-primary" title="Delete" ng-hide="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER"><span class="fa fa-trash-o"></span> </a><a id="editlink" ng-click="vm.downloadPdfButton(trCase.id)" class="action-icons text-primary" title="Download PDF" ng-if="(trCase.caseTypeName==\'Termination Details\' || trCase.caseTypeName==\'Splicing Details\') && (has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER)"><span class="fa fa-download"></span> </a><!-- <img src="content/images/map_img.png" ng-click="caseLocation(trCase)" /> --></div></td></tr><tr ng-show="trCase.isExpanded"><td ng-if="vm.caseAroundUsers.length>0"></td><td colspan="13" ng-if="vm.caseAroundUsers.length>0"><table class="table__userNames"><thead><th></th><th>Nearby users within 30 min</th></thead><tbody><tr ng-repeat-start="users in vm.caseAroundUsers"><td>{{}}</td><td>{{users.login}}</td><td>{{users.visitedDateTime | date:\'medium\'}}</td><td class="td--w7"><div ng-repeat="authority in users.authoritieList "><span class="label label-primary">{{ authority }}</span></div></td></tr><tr ng-repeat-end></tr></tbody></table></td><td colspan="13" ng-if="vm.caseAroundUsers.length==0"><table class="table__userNames"><thead><th></th><th>No nearby users within 30 min</th></thead></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.trCases == 0" class="td__noDataAvailable"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><div class="map-view" ng-show="isSet(2)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas1" style="height:{{mapHeight}}px; width:100%"></div></div></div></div><div class="map-view" ng-show="isSet(3)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas2" style="height:{{mapHeight}}px; width:100%"></div></div></div></div><div class="map-view" ng-show="isSet(4)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas4" style="height:{{mapHeight}}px; width:100%"></div></div></div></div></div></div></div></div><div class="donut-common-legend mb-2 mt-0" ng-if="vm.trCases.length>0" ng-show="isSet(1)"><div class="legend-container"><div class="legend-block"><div class="legend-title"><strong>Priority</strong></div><div class="legend-items"><span><span style="color:#a10000;">\u25CF</span> Critical</span> <span><span style="color:#FF0000;">\u25CF</span> High</span> <span><span style="color:#00e658;">\u25CF</span> Medium</span> <span><span style="color:#7bc9de;">\u25CF</span> Low</span></div></div><div class="legend-block"><div class="legend-title"><strong>Status</strong></div><div class="legend-items"><span><span style="color:#FF9800;">\u25CF</span> To Be Assigned</span> <span><span style="color:#2196F3;">\u25CF</span> Assigned</span> <span><span style="color:#9C27B0;">\u25CF</span> In Progress</span> <span><span style="color:#00e658;">\u25CF</span> Resolved</span> <span><span style="color:#6C757D;">\u25CF</span> Closed</span> <span><span style="color:#F44336;">\u25CF</span> Out of Scope</span></div></div></div></div></div><div class="modal fade" id="myModalUpload" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeImageUpload()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Upload PDF</span></div><div class="modal-body"><div class="form-group asset_images"><label class="col-md-3 control-label">PDF</label><div class="col-md-8"><input type="file" name="file" class="filestyle" id="assetImages" accept="application/pdf"> <span ng-if="!vm.fileWarning">Supported Format - PDF.</span> <span id="noData" ng-if="vm.fileWarning">Please upload PDF format.</span></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.saveImage()" class="btn btn-primary btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-save"></i> Save</button> <button type="button" ng-click="vm.closeImageUpload()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button></div></div></div></div><div class="modal fade" id="successImage" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="col-lg-12 col-sm-12 col-xs-12 alert alert-success"><strong>PDF Saved Successfully</strong></div></div></div></div><div class="modal fade" id="errorImage" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="col-lg-12 col-sm-12 col-xs-12 alert alert-danger"><strong>Error</strong></div></div></div></div><div id="listFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeListFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence for List</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveListFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.geofencesListView.length == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.geofencesListView"><input type="radio" id="{{item.id}}" ng-model="vm.selectedListGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><!--Modal for editing asset--><div id="caseLocationModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div--travelMap" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header" id="myEditAssetText"></span></div><div class="modal-body div__map_canvas_case_location"><div class="row"><div class="col-md-12 modal_body_map"><div class="location-map-case-location" id="location-map-edit"><div id="map_canvas_case_location"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!-- Modal --><div id="assigncaseModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header modal-info"><button type="button" class="close" ng-click="reset()" data-dismiss="modal">&times;</button><h4 class="modal-title text-left">Assign case to {{edituserLogin}}</h4></div><div class="modal-body"><div class="row"><form name="editCaseForm" role="form" class="form-horizontal" novalidate ng-submit="vm.editcase()"><div class="form-group"><label class="col-md-3 control-label" translate="entity.action.selectcase">Select Incident Id</label><!-- <div class="col-md-6">\r\n\t\t\t\t\t<select class="form-control select2" id="field_caseId" name="caseId"  \r\n\t\t            \tng-options=" case.id for case in trallcases" ng-model="vm.editCase"  required>\r\n\t\t            \t<option value="" translate="entity.action.selectcase">--- Select Incident ---</option>\r\n\t\t            \t</select>\r\n\t\t\t\t</div> --><div class="col-md-8"><!-- <select class="form-control select2" id="field_caseId" name="caseId"  ng-options=" case.id for case in trallcases" ng-model="vm.editCase" \r\n\t\t              ng-change="vm.selectattributes()" style="width: 100%" required>\r\n\t\t\t\t\t \t<option value="" translate="entity.action.selectcase">--- Select Incident Id ---</option>\r\n\t\t\t\t\t \t</select> --> <input list="caseslist" class="form-control" id="field_caseId" ng-pattern="/^[0-9]+$/" placeholder="Search case id" type="text" ng-model="vm.seachCaseId" autocomplete="off" name="caseId" ng-change="vm.filterTrcasesId()" required><datalist ng-hide="!vm.caseIds" id="caseslist" class="form-control1"><option ng-repeat="case in vm.caseIds" value="{{case.id}}"></option></datalist><p class="help-block" ng-show="editCaseForm.caseId.$error.pattern" translate="trakeyeApp.trCase.caseiderror">Enter only numeric values for case id</p></div></div><div class="form-group"><div class="col-md-3 col-md-offset-3"><button type="submit" ng-disabled="editCaseForm.$invalid" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.assigncase">Assign Incident</span></button></div></div></form><p class="text-success text-center" ng-show="vm.success" translate-compile>Incident {{vm.editCase.id}} has been assigned successfully to user {{edituserLogin}}.</p><p class="text-danger text-center" ng-show="vm.error" translate-compile>{{vm.error}}</p></div></div></div></div></div><div id="mapFilterModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Geofence Filter</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeMapFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="col-md-12"><div class="row div__done"><span class="span__title">Select Geofence</span> <button class="btn btn-info btn-flat button__done" ng-click="vm.saveFilter()"><span><b>Done</b></span></button></div></div><div class="modal-body div__modal-body"><div class="row"><span id="noData" ng-show="vm.countUserGeofences == 0">* NO DATA</span><div class="div__list"><br><div ng-repeat="item in vm.userGeofences"><input type="radio" id="{{item.id}}" ng-model="vm.selectedGeofenceId" value="{{item.id}}"> <label for="{{item.id}}" class="label__item">{{item.name}}</label></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="priorityStatusfilterModal" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Filter By Priority / Status</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closePriorityStatusFilterModal()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div class="row div__priorityType"><div><label ng-repeat="priorityType in vm.priorityType" class="label__priorityType"><input class="coupon_question input__priorityType" name="coupon_question" type="checkbox" value="{{priorityType}}" ng-checked="vm.selectedPriorityType.indexOf(priorityType)>-1" ng-click="togglePriorityTypeSelection(priorityType)"> {{priorityType}}</label></div><div><ol class="ol__list"><li ng-repeat="priorityList in vm.priorityList" class="label__priorityType"><input class="input__priorityType" type="checkbox" value="{{priorityList}}" id="{{priorityList}}" ng-checked="vm.selectedPriorityList.indexOf(priorityList)>-1" ng-click="togglePriorityListSelection(priorityList)"> <label for="{{priorityList}}">{{priorityList}}</label></li></ol></div><div><label ng-repeat="statusType in vm.statusType" class="label__priorityType"><input class="coupon_question input__priorityType" name="coupon_question" type="checkbox" value="{{statusType}}" ng-checked="vm.selectedStatusType.indexOf(statusType)>-1" ng-click="toggleStatusTypeSelection(statusType)"> {{statusType}}</label></div><div><ol class="ol__list"><li ng-repeat="statusList in vm.statusList" class="label__priorityType"><input class="input__priorityType" type="checkbox" value="{{statusList}}" id="{{statusList}}" ng-checked="vm.selectedStatusList.indexOf(statusList)>-1" ng-click="toggleStatusListSelection(statusList)"> <label for="{{statusList}}">{{statusList}}</label></li></ol></div><span id="noData" ng-if="vm.selectedPriorityList==0||vm.selectedStatusList==0">* Select atleast one from each group.</span><div class="col-md-12 modal_body_content div__btn_done"><button class="btn btn-info btn-flat button__done" ng-click="savePriorityStatusFilter()"><span><b>Done</b></span></button></div></div></div></div></div></div><!-- Add Comment Modal --><div id="addCommentModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeCommentModal()"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Add Comment - Ticket ID: {{vm.selectedTicketId}} | Incident ID: {{vm.selectedCaseId}}</span></div><div class="modal-body"><!-- Comments Section --><div class="row"><div class="col-md-12"><h5 style="margin-bottom: 10px; font-weight: bold;">Previous Comments</h5><div style="height: 300px; overflow-y: auto; margin-bottom: 20px; border: 1px solid #ddd; padding: 10px; border-radius: 4px; background-color: #f9f9f9;"><!-- Existing Comments --><div ng-if="vm.existingComments && vm.existingComments.length > 0"><div ng-repeat="comment in vm.existingComments | orderBy:\'-createdDate\'" style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #e0e0e0;"><div style="margin-bottom: 5px; display: flex; justify-content: space-between; align-items: center;"><strong style="color: #333;">{{comment.createdBy}}</strong> <span style="color: #666; font-size: 14px; font-weight: 500;">{{comment.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</span></div><div style="color: #555; white-space: pre-wrap;">{{comment.comment}}</div><div ng-if="comment.commentMedia && comment.commentMedia.length > 0" style="margin-top: 10px; display: flex; flex-wrap: wrap; gap: 10px;"><div ng-repeat="media in comment.commentMedia" style="width: 120px;"><a ng-if="media.previewUrl" ng-href="{{media.previewUrl}}" target="_blank" title="{{media.imageName}}"><img ng-if="media.imageType === \'PNG\' || media.imageType === \'JPG\' || media.imageType === \'JPEG\'" ng-src="{{media.previewUrl}}" alt="{{media.imageName}}" style="width: 120px; height: 90px; object-fit: cover; border: 1px solid #ddd; border-radius: 4px;"><div ng-if="media.imageType !== \'PNG\' && media.imageType !== \'JPG\' && media.imageType !== \'JPEG\'" style="width: 120px; height: 90px; border: 1px solid #ddd; border-radius: 4px; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #666; background-color: #f5f5f5;"><i class="fa fa-file" style="font-size: 22px;"></i> <span style="font-size: 11px; margin-top: 4px;">{{media.imageType}}</span></div></a><div ng-if="!media.previewUrl" style="width: 120px; height: 90px; border: 1px solid #ddd; border-radius: 4px; display: flex; align-items: center; justify-content: center; color: #999; background-color: #f5f5f5;">Loading...</div><div style="font-size: 11px; color: #666; margin-top: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" title="{{media.imageName}}">{{media.imageName}}</div></div></div></div></div><!-- No Comments Message --><div ng-if="!vm.existingComments || vm.existingComments.length === 0" style="display: flex; align-items: center; justify-content: center; height: 100%;"><div style="text-align: center; color: #999;">No previous comments</div></div></div></div></div><!-- Success/Error Messages --><div class="row" ng-if="vm.commentSuccess || vm.commentError"><div class="col-md-12"><div class="alert alert-success" ng-if="vm.commentSuccess" style="margin-bottom: 15px;"><i class="fa fa-check-circle"></i> {{vm.commentSuccess}}</div><div class="alert alert-danger" ng-if="vm.commentError" style="margin-bottom: 15px;"><i class="fa fa-exclamation-circle"></i> {{vm.commentError}}</div></div></div><!-- Add New Comment Section --><div class="row"><div class="col-md-12"><form name="commentForm" role="form" novalidate><div class="form-group"><label class="control-label" for="commentText">Comment</label> <textarea class="form-control" id="commentText" name="commentText" rows="5" ng-model="vm.commentText" placeholder="Enter your comment here (optional if adding media)..." maxlength="1000"></textarea> <small class="text-muted">{{vm.commentText ? vm.commentText.length : 0}}/1000 characters</small></div><!-- Media Attachment Section --><div class="form-group"><label class="control-label">Attach Media (Optional)</label><div><input type="file" id="commentMediaFiles" name="commentMediaFiles" class="filestyle" accept="image/png,image/jpg,image/jpeg,video/mp4" multiple="multiple"> <small class="text-muted" style="display: block; margin-top: 5px;">Supported formats: PNG, JPG, JPEG, MP4 (Max 10 images and 3 videos)</small></div><!-- Upload Progress --><div ng-if="vm.uploadingMedia" style="margin-top: 10px;"><div class="alert alert-info"><i class="fa fa-spinner fa-spin"></i> {{vm.uploadProgress}}</div></div><!-- Selected Files List --><div ng-if="vm.selectedMediaFiles.length > 0" style="margin-top: 10px;"><strong>Selected Files:</strong><ul style="list-style: none; padding-left: 0; margin-top: 5px;"><li ng-repeat="file in vm.selectedMediaFiles" style="padding: 5px; background-color: #f5f5f5; margin-bottom: 5px; border-radius: 3px; display: flex; justify-content: space-between; align-items: center;"><span><i class="fa" ng-class="{\'fa-file-image-o\': file.type.indexOf(\'image\') > -1, \'fa-file-video-o\': file.type.indexOf(\'video\') > -1}"></i> {{file.name}} ({{(file.size / 1024 / 1024).toFixed(2)}} MB) </span><button type="button" class="btn btn-danger btn-xs" ng-click="vm.removeMediaFile($index)" ng-disabled="vm.uploadingMedia"><i class="fa fa-times"></i></button></li></ul></div></div></form></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.saveComment()" ng-disabled="vm.uploadingMedia || ((!vm.commentText || vm.commentText.trim().length === 0) && vm.selectedMediaFiles.length === 0)"><i class="glyphicon glyphicon-save"></i> <span ng-if="!vm.uploadingMedia">Save Comment</span><span ng-if="vm.uploadingMedia">Uploading...</span></button> <button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.closeCommentModal()" ng-disabled="vm.uploadingMedia"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button></div></div></div></div>');
$templateCache.put('app/entities/tr-material/geofence-materialTxn.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><form class="form-horizontal"><div class="box-body border" style="padding:10px;"><div class="form-group row" style="margin-bottom:5px;"><div class="col-sm-3"><label class="control-label">Select Block</label> <select class="form-control select2" ng-model="vm.selectedGeofenceId" ng-options="g.id as g.nameZone for g in vm.geofencesList"><option value="">Select</option></select></div><!-- <div class="col-sm-3" style="padding-top:25px;">\r\n                                <button type="button" class="btn btn-primary" ng-if="vm.resTxSummary.length"\r\n                                    ng-click="vm.downloadCSV()">\r\n                                    Download CSV\r\n                                    <i class="fa fa-spinner fa-spin" ng-show="vm.loading" style="margin-left:6px;"></i>\r\n                                </button>\r\n                            </div> --></div></div></form><div ng-if="vm.visibleIncidents.length"><h4 style="margin:8px 12px;">Material Transactions &nbsp;<i class="fa fa-download" ng-click="vm.downloadCSV()"></i></h4><table class="table table-hover table-condensed table-bordered"><thead><tr class="bg-light"><th style="width:40px;"></th><th>Ticket ID</th><th style="width:110px;">Date</th><!-- <th>Transaction Type</th> --><th>Block Name</th><th>Business Area</th><th>Operational Area</th><th>First Name</th><th>Report To</th></tr></thead><tbody><tr ng-repeat-start="inc in vm.visibleIncidents track by $index"><td class="text-center"><a href="" ng-click="vm.toggleIncident(inc)"><i class="fa" ng-class="inc.expanded ? \'fa-minus-square\' : \'fa-plus-square\'" style="color:#686665;"></i></a></td><td><a ui-sref="tr-case-detail({id:inc.caseId})">{{ inc.caseId }}</a></td><td>{{ inc.mainDate | date:\'dd-MM-yyyy\' }}</td><!-- <td>{{ inc.transactionTypes || \'-\' }}</td> --><td>{{ vm.selectedGeofenceName }}</td><td>{{ inc.businessArea || \'-\' }}</td><td>{{ inc.operationalArea || \'-\' }}</td><td>{{ inc.firstName || \'-\' }}</td><td>-</td></tr><tr ng-repeat-end ng-if="inc.expanded"><td colspan="9" style="background:#fafafa;padding:10px 15px;"><table class="table table-bordered table-condensed"><thead><tr><th>Sl No</th><th>Material Name</th><th>Unit</th><th>REQUESTED</th><th>RECEIVED</th><th>UTILIZED</th><!-- <th>WASTAGE</th> --><th>RECOVERED</th><th>STOCK</th><th>Action</th></tr></thead><tbody><tr ng-repeat="m in inc.materialList track by $index"><td>{{$index + 1}}</td><td>{{ m.materialName }}</td><td>{{ m.unit }}</td><td>{{ m.REQUESTED }}</td><td>{{ m.RECEIVED }}</td><td>{{ m.UTILIZED }}</td><!-- <td>{{ m.WASTAGE }}</td> --><td>{{ m.RECOVERED }}</td><td>{{ m.STOCK }}</td><td ng-if="has_ROLE_BA||has_ROLE_FE||has_ROLE_NETWORK_ENGINEER||has_ROLE_USER_ADMIN||has_ROLE_SUPER_ADMIN||has_ROLE_PLAN_ADMIN"><span class="fa fa-pencil-square" title="edit" ng-click="vm.editMaterial(m, inc)"></span> <span class="fa fa-trash-o" title="delete" ng-click="vm.openDeleteMaterialModal(m, inc)"></span></td></tr></tbody></table></td></tr></tbody></table><div class="row" style="margin-top:5px;"><div class="col-md-6"><jhi-item-count page="vm.incUiPage" total="vm.incTotalItems" items-per-page="vm.incItemsPerPage"></jhi-item-count></div><div class="col-md-6 text-right"><uib-pagination total-items="vm.incTotalItems" ng-model="vm.incUiPage" items-per-page="vm.incItemsPerPage" max-size="5" boundary-links="true" ng-change="vm.incPageChanged()" class="pagination-sm"></uib-pagination></div></div></div><div ng-if="vm.loading" style="padding:12px;"><i class="fa fa-spinner fa-spin"></i> Loading...</div><div ng-if="!vm.loading && !vm.visibleIncidents.length && vm.selectedGeofenceId" style="padding:12px;"><h5>No Summary Available</h5></div><hr><div ng-if="vm.cumulativeData.length" class="table-responsive" style="padding:12px;"><h4 style="margin:8px 12px;">Cumulative Report &nbsp;<i class="fa fa-download" ng-click="vm.downloadCumulativeCSV()"></i></h4><table class="table table-bordered table-condensed"><thead><tr><th>Till Date</th><th>Material Name</th><th>REQUESTED</th><th>RECEIVED</th><th>UTILIZED</th><!-- <th>WASTAGE</th> --><th>RECOVERED</th><th>STOCK</th></tr></thead><tbody><tr ng-repeat="m in vm.cumulativeData"><td>{{ vm.today | date:\'dd-MM-yyyy\' }}</td><td>{{ m.materialName }}</td><td>{{ m.REQUESTED}}</td><td>{{ m.RECEIVED }}</td><td>{{ m.UTILIZED }}</td><!-- <td>{{ m.WASTAGE}}</td> --><td>{{ m.RECOVERED}}</td><td>{{ m.REQUESTED + m.RECOVERED}}</td></tr></tbody></table></div></div></div></div></div><div id="deleteModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog modal-sm"><div class="modal-content"><form name="deleteForm" ng-submit="vm.confirmDeleteMaterial()" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clearDelete()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><p class="text-danger" ng-if="vm.deletefail">Services for this material need to be deleted before deleting the material</p><p>Are you sure you want to delete this material?</p><p><strong>{{ vm.selectedMaterial.materialName }}-{{vm.selectedMaterial.noOfUnits}}No\'s</strong></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clearDelete()">Cancel</button> <button type="submit" class="btn btn-danger btn-sm" ng-disabled="deleteForm.$invalid">Delete</button></div></form></div></div></div><div id="editModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><form name="editForm" ng-submit="vm.confirmEditMaterial()" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clearEdit()">&times;</button><h4 class="modal-title">Edit Material</h4></div><div class="modal-body"><div class="form-group"><label>Material Name</label> <input type="text" class="form-control" ng-model="vm.editMaterialData.materialName" disabled="disabled"></div><div class="form-group"><label>Transaction Type</label> <select class="form-control" ng-model="vm.editMaterialData.transactionType" required><option value="REQUESTED">REQUESTED</option><option value="RECEIVED">RECEIVED</option><option value="UTILIZED">UTILIZED</option><option value="WASTAGE">WASTAGE</option><option value="RECOVERED">RECOVERED</option></select></div><div class="form-group"><label>No Of Units</label> <input type="number" class="form-control" ng-model="vm.editMaterialData.noOfUnits" min="1" required></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clearEdit()">Cancel</button> <button type="submit" class="btn btn-primary btn-sm" ng-disabled="editForm.$invalid || vm.updating">Update</button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-material/tr-material-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this material needs to be deleted before deleting material</p><p translate="trakeyeApp.task.delete.question" translate-values="{id: \'{{vm.trTask.id}}\'}">Are you sure you want to delete this Tr Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-material/tr-material-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.material.detail.title">Tr Material</span> {{vm.trMaterial.name}} - {{vm.trMaterial.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><a href="javascript:void(0);" ui-sref="tr-material" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-material.edit({id:vm.trMaterial.id})" class="btn btn-primary btn-sm pull-right" ng-if="Roles.MATERIAL_EDIT"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a><dl class="dl-horizontal jh-entity-details mt-5"><dt ng-show="vm.trMaterial.materialAssets.length"><span>Asset Name</span></dt><dd ng-show="vm.trMaterial.materialAssets.length"><span class="node" ui-sref="asset-detail({id:vm.trMaterial.materialAssets[0].id})">{{vm.trMaterial.materialAssets[0].name}}</span></dd><dt><span translate="trakeyeApp.material.description">Description</span></dt><dd><span>{{vm.trMaterial.description}}</span></dd><!-- <dt>\r\n\t\t\t\t\t\t\t<span translate="trakeyeApp.material.createDate">Create Date</span>\r\n\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t<span>{{vm.trMaterial.createdDate | date:\'medium\'}}</span>\r\n\t\t\t\t\t\t</dd>\r\n\t\t\t\t\t\t<dt>\r\n\t\t\t\t\t\t\t<span translate="trakeyeApp.material.updateDate">Update Date</span>\r\n\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t<span>{{vm.trMaterial.lastModifiedDate |\r\n\t\t\t\t\t\t\t\tdate:\'medium\'}}</span>\r\n\t\t\t\t\t\t</dd> --><dt><span translate="trakeyeApp.material.materialType">Material Type</span></dt><dd><!--  <a ui-sref="material-type-detail({id:vm.trMaterial.materialType.id})">{{vm.trMaterial.materialType.name}}</a> --> {{vm.trMaterial.materialType.name}}</dd><div class="form-group" ng-repeat="attribute in vm.trMaterial.materialTypeAttributeValues"><div ng-repeat="attributeValue in vm.trMaterial.materialTypeAttributeValues track by $index"><div ng-if="attributeValue.materialTypeAttribute.id == attribute.materialTypeAttribute.id"><dt><span>{{attribute.materialTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></div></div></div><!-- <dt>\r\n\t\t\t\t\t\t\t<div class="col-md-2 trMaterial_showImgDiv" ng-if="vm.trMaterial.id">\r\n\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'image\')">\r\n\t\t\t\t\t\t\t\t\t<span ng-hide="vm.showImages">Show Images</span>\r\n\t\t\t\t\t\t\t\t\t<span ng-show="vm.showImages">Hide Images</span></a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t<dd ng-if="allimages">\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-3" ng-repeat="img in vm.materialImages">\r\n\t\t\t\t\t\t\t\t\t\t\t<img ng-if="img.image != null" class="img-responsive img__img-responsive"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-src="data:image/jpeg;base64,{{img.image}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.imageInNewTab(img.image)" /><br />\r\n\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s" ng-show="img.imgDescription != null"><b>Description :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgDescription}}</span><br />\r\n\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-show="img.imgLat != null && img.imgLong != null"><b>LatLng :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgLat}},{{img.imgLong}}</span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dd> --></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tr-material/tr-material-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrMaterialLabel"><span ng-if="!vm.trMaterial.id" translate="trakeyeApp.material.home.create">Create</span> <span ng-if="vm.trMaterial.id">Edit Material</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.material.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trMaterial.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.material.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trMaterial.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.material.materialType">materialType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="materialType" ng-model="vm.materialType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                        vm.materialTypes track by item.id" ng-disabled="vm.trMaterial.id!=null" required style="width: 100%"><option value="" translate="trakeyeApp.material.selectmaterial">--- Select MaterialType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.trMaterial.materialTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.materialTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue" ng-if="attribute.materialTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trMaterial.id" type="text" class="form-control" ng-init="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue = attribute.materialTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue" ng-if="attribute.materialTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.trMaterial.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.materialTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue" ng-if="attribute.materialTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trMaterial.id" type="text" class="form-control" ng-init="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue = attribute.materialTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue" ng-if="attribute.materialTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trMaterial.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.materialTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue" ng-if="attribute.materialTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trMaterial.id" type="text" class="form-control" ng-init="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue = attribute.materialTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue" ng-if="attribute.materialTypeAttribute.attributeDataType.name == \'STRING\' && vm.trMaterial.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.materialTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue" ng-init="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue = attribute.materialTypeAttribute.defaultValue" ng-if="attribute.materialTypeAttribute.attributeDataType.name != \'STRING\' && attribute.materialTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.materialTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trMaterial.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.materialTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue" ng-init="vm.trMaterial.materialTypeAttributeValues[$index].attributeValue == attribute.materialTypeAttribute.defaultValue" ng-if="attribute.materialTypeAttribute.attributeDataType.name != \'STRING\' && attribute.materialTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.materialTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trMaterial.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.materialTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-material"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div>');
$templateCache.put('app/entities/tr-material/tr-materials.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-materials"></i> <span>Materials</span></h3></div><div class="box-tools material_labels" ng-if="Roles.MATERIAL_CREATE"><button class="btn btn-create btn-sm" ui-sref="tr-material.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="description"><span\r\n                                            translate="trakeyeApp.material.description">Description</span> --><th>Material Type</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="material in vm.materials | filter: users track by material.id" ng-class="{selected: material.isChecked}"><td><a ui-sref="tr-material-detail({id:material.id})">{{material.name}}</a></td><!-- <td>{{material.description}}</td> --><td>{{material.materialTypeName}}</td><td><div class="action"><a ui-sref="tr-material-detail({id:material.id})" class="action-icons text-info" title="View" ng-if="Roles.MATERIAL_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-material.edit({id:material.id})" class="action-icons text-primary" title="Edit" ng-if="Roles.MATERIAL_EDIT"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.materials == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-notification/tr-notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trNotification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><span>&times;</span></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="trakeyeApp.trNotification.delete.question" translate-values="{id: \'{{vm.trNotification.id}}\'}">Are you sure you want to delete this Tr Notification?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-notification/tr-notification-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.trNotification.detail.title">Tr Notification</span> {{vm.trNotification.description}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.trNotification.subject">Subject</span></dt><dd><span>{{vm.trNotification.subject}}</span></dd><dt><span translate="trakeyeApp.trNotification.description">Description</span></dt><dd><span>{{vm.trNotification.description}}</span></dd><dt><span translate="trakeyeApp.trNotification.status">Status</span></dt><dd><span translate="{{\'trakeyeApp.NotificationStatus.\' + vm.trNotification.status}}">{{vm.trNotification.status}}</span></dd><dt><span translate="trakeyeApp.trNotification.alertType">Alert Type</span></dt><dd><span translate="{{\'trakeyeApp.AlertType.\' + vm.trNotification.alertType}}">{{vm.trNotification.alertType}}</span></dd><dt><span translate="trakeyeApp.trNotification.fromUser">From User</span></dt><dd>{{vm.trNotification.fromUserName}}</dd><dt><span translate="trakeyeApp.trNotification.toUser">To User</span></dt><dd>{{vm.trNotification.toUserName}}</dd><dt><span translate="trakeyeApp.trNotification.trCase">Incident</span></dt><dd><a ui-sref="tr-case-detail({id:vm.trNotification.trCaseId})">{{vm.trNotification.trCaseId}}</a></dd><dt><span translate="trakeyeApp.trNotification.createdDate">Created Date</span></dt><dd><span>{{vm.trNotification.createdDate | date:\'medium\'}}</span></dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><!-- <a ng-if="has_ROLE_USER_ADMIN" ui-sref="tr-notification.edit({id:vm.trNotification.id})" class="btn btn-primary btn-sm">\r\n\t\t\t\t\t\t        <span class="glyphicon glyphicon-pencil"></span>\r\n\t\t\t\t\t\t        <span translate="entity.action.edit"> Edit</span>\r\n\t\t\t\t\t\t    </a> --></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-notification/tr-notification-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" ng-if="!vm.trNotification.id" translate="trakeyeApp.trNotification.home.create">Create</h3><h3 class="box-title" ng-if="vm.trNotification.id" translate="trakeyeApp.trNotification.home.Edit">Edit</h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!--  <div class="form-group" ng-if="vm.trNotification.id">\r\n\t\t\t\t            <label class="col-md-3 control-label" for="id" translate="global.field.id">ID</label>\r\n\t\t\t\t            <div class="col-md-8">\r\n\t\t\t\t            <input type="text" class="form-control" id="id" name="id"\r\n\t\t\t\t                    ng-model="vm.trNotification.id" readonly >\r\n\t\t\t\t            </div>\r\n\t\t\t\t        </div> --><div class="form-group"><!--  <label class="col-md-3 control-label" translate="trakeyeApp.trNotification.description" for="field_description">Description</label> --> <label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.trNotification.description">Description</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><textarea class="form-control" rows="2" name="description" id="field_description" required ng-model="vm.trNotification.description" ng-readonly="vm.trNotification.id">\r\n\t\t\t\t            \t</textarea></div></div><div class="form-group"><!--  <label class="col-md-3 control-label" translate="trakeyeApp.trNotification.status" for="field_status">Status</label> --> <label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.trNotification.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" required ng-model="vm.trNotification.status" id="field_status" ng-readonly="vm.trNotification.status == \'DELIVERED\'"><option value="SENT" translate="trakeyeApp.NotificationStatus.SENT">SENT</option><option value="RECIEVED" translate="trakeyeApp.NotificationStatus.RECIEVED">RECIEVED</option><option value="DELIVERED" translate="trakeyeApp.NotificationStatus.DELIVERED">DELIVERED</option><option value="FAILED" translate="trakeyeApp.NotificationStatus.FAILED">FAILED</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.trNotification.subject">Subject</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" name="subject" id="field_subject" ng-model="vm.trNotification.subject" required ng-readonly="vm.trNotification.id"></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_alertType"><span translate="trakeyeApp.trNotification.alertType">Alert Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="alertType" ng-model="vm.trNotification.alertType" id="field_alertType" required ng-readonly="vm.trNotification.id"><option value="" translate="trakeyeApp.trNotification.selectType"></option><option value="EMAIL" translate="trakeyeApp.AlertType.EMAIL">EMAIL</option><option value="SMS" translate="trakeyeApp.AlertType.SMS">SMS</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_toUser"><span translate="trakeyeApp.trNotification.toUser">Recipient</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><!-- <select class="form-control" id="field_toUser" name="toUser" ng-model="vm.trNotification.toUserId" ng-options="user.id as user.login for user in vm.users">\r\n\t\t\t\t                <option value="" translate="trakeyeApp.trNotification.selectRecipient"></option>\r\n\t\t\t\t            </select> --> <input list="userslist" class="form-control" id="field_toUser" placeholder="Search user login name" type="text" ng-model="vm.trNotification.toUserId" autocomplete="off" name="toUser" ng-change="vm.filterActivatedUser()" required ng-readonly="vm.trNotification.id"><datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1"><option ng-repeat="user in vm.activatedusers" value="{{user.login}}"></option></datalist></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_trCase"><span translate="trakeyeApp.trNotification.trCase">Incident</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><!-- <select class="form-control" id="field_trCase" name="trCase" ng-model="vm.trNotification.trCaseId" ng-options="trCase.id as trCase.id for trCase in vm.trcases">\r\n\t\t\t\t                <option value="" translate="trakeyeApp.trNotification.selectCase"></option>\r\n\t\t\t\t            </select> --> <input list="caseslist" class="form-control" id="field_trCase" ng-pattern="/^[0-9]+$/" placeholder="Search case id" type="text" ng-model="vm.trNotification.trCaseId" autocomplete="off" name="trCase" ng-change="vm.filtertrcasesid()" required ng-readonly="vm.trNotification.id"><datalist ng-hide="!vm.caseids" id="caseslist" class="form-control1"><option ng-repeat="case in vm.caseids" value="{{case.id}}"></option></datalist><p class="help-block" ng-show="editForm.trCase.$error.pattern" translate="trakeyeApp.trNotification.caseiderror">Enter only numeric values for case id</p></div></div></div><div class="box-footer"><div class="col-md-3 col-md-offset-3 save-buttons"><button type="button" ui-sref="tr-notification" class="btn btn-default btn-sm"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/tr-notification/tr-notifications.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-bell"></i> <span translate="trakeyeApp.trNotification.home.title">Tr Notifications</span></h3><!-- <div class="box-tools" ng-if="has_ROLE_USER_ADMIN">\r\n\t\t\t\t\t\t <button class="btn btn-create" ui-sref="tr-notification.new">\r\n\t\t\t\t\t\t <span class="glyphicon glyphicon-plus"></span>\r\n\t\t                    <span  translate="trakeyeApp.trNotification.home.createLabel">\r\n\t\t                        Create Tr Notification\r\n\t\t                    </span>\r\n\t\t                </button>\r\n\t\t\t\t\t</div> --></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.trNotification.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--   <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="subject"><span translate="trakeyeApp.trNotification.subject">Subject</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="trakeyeApp.trNotification.status">Status</span> <span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.trNotification.type">Type</span></th><th><span translate="trakeyeApp.trNotification.alertType">Alert Type</span></th><th><span translate="trakeyeApp.trNotification.toUser">To User</span></th><th><span translate="trakeyeApp.trNotification.trCase">Incident</span></th><th><span translate="trakeyeApp.trNotification.createdDate">Created Date</span></th><th ng-if="has_ROLE_USER"><span translate="trakeyeApp.trNotification.downloadApp">Download App</span><span class="fa fa-sort"></span></th><th ng-if="has_ROLE_USER_ADMIN"><span translate="trakeyeApp.trNotification.action">Actions</span></th></tr></thead><tbody><tr ng-repeat="trNotification in vm.trNotifications | filter: search track by trNotification.id"><!--  <td><a ui-sref="tr-notification-detail({id:trNotification.id})">{{trNotification.id}}</a></td> --><td>{{trNotification.subject}}</td><td translate="{{\'trakeyeApp.NotificationStatus.\' + trNotification.status}}">{{trNotification.status}}</td><td>{{trNotification.notificationType}}</td><td translate="{{\'trakeyeApp.AlertType.\' + trNotification.alertType}}">{{trNotification.alertType}}</td><td>{{trNotification.toUserName}}</td><td><a ui-sref="tr-case-detail({id:trNotification.trCaseId})">{{trNotification.trCaseId}}</a></td><td>{{trNotification.createdDate | date:\'medium\'}}</td><td ng-if="has_ROLE_USER && trNotification.downloadLink!=null"><a href="{{trNotification.downloadLink}}" target="blank">Trakeye Apk Link</a></td><td ng-if="has_ROLE_USER_ADMIN"><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a ui-sref="tr-notification-detail({id:trNotification.id})" class="action-icons text-info"><span class="fa fa-eye" title="View"></span> </a><!-- <a ui-sref="tr-notification.edit({id:trNotification.id})"\r\n\t\t\t\t                                    class="action-icons text-primary" title="Edit">\r\n\t\t\t\t                                <span class="fa fa-pencil-square"></span>\r\n\t\t\t\t                            </a> --> <a ui-sref="tr-notification.delete({id:trNotification.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.trNotifications == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-project/project-tree.html','<div class="content"><h4 style="border-bottom: 2px solid #FD7A24;\r\n        padding-bottom: 10px;\r\n        margin-bottom: 20px;\r\n        font-weight: bold;\r\n        color: #333;"><i class="fa fa-sitemap" style="margin-right: 10px; color: #FD7A24;"></i> Project Tree</h4><div class="row"><div class="dropFilter ml-10" ng-if="vm.filterOptions.length>0"><div isteven-multi-select input-model="vm.filterOptions" output-model="vm.selectedFilters" button-label="name" item-label="name" tick-property="selected" output-properties="name type" helper-elements="all none done" max-height="200px" max-labels="2" on-select-done="vm.applyUnifiedFilter()"></div></div><div class="col-md-3"><div class="box-body"><div class="table-responsive tab-scroll" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th></th><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat-start="project in vm.projects | filter: users track by project.id" ng-class="{selected: project.isChecked}"><td class="td__listViewRow" ng-click="vm.expand(project,\'project\');" expand><span ng-if="!project.project" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Routes Expand"></i></span> <span ng-if="project.project" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Routes Close"></i></span></td><td>{{project.name}}</td></tr><tr ng-show="project.project" style="height: auto;\r\n                                border-left: 4px solid #666;"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><i class="fa fa-long-arrow-right" aria-hidden="true" style="color: #666;"></i> <b style="text-decoration: underline;\r\n\t\t\t\t\t\t\t               text-decoration-thickness: 4px;\r\n\t\t\t\t\t\t\t               text-decoration-color: #FD7A24;">Routes</b><h5 ng-show="!vm.routePlanResponse.length">No data available</h5></tr><tr ng-show="vm.routePlanResponse.length"><th></th></tr></thead><tbody><tr ng-repeat-start="item in vm.routePlanResponse"><td class="td__listViewRow" ng-click="vm.expand(item,\'routeBundles\');" expand><span ng-if="!item.routeBundles" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Sections Expand"></i></span> <span ng-if="item.routeBundles" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Sections Close"></i></span></td><td ng-repeat="header in vm.headers" style="padding-left: 10px;"><a ng-click="vm.getRoutePath(item.id)" target="_blank">{{ item[header.key] }}</a></td></tr><tr ng-show="item.routeBundles" style="height: auto;\r\n\t\t\t\t\t\t\t           border-left: 4px solid #FD7A24;"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><i class="fa fa-long-arrow-right" aria-hidden="true" style="color: #666;"></i> <b style="text-decoration: underline;\r\n                                                    text-decoration-thickness: 4px;\r\n                                                    text-decoration-color: #FD7A24;">Rings/Path</b><h5 ng-show="!vm.routeResponse.length">No data available</h5></tr><tr ng-show="vm.routeResponse.length"><th></th><!--  <th ng-repeat="header in vm.headers">{{ header.display }}</th> --></tr></thead><tbody><tr ng-repeat-start="item in vm.routeResponse"><td class="td__listViewRow" ng-click="vm.expand(item,\'route\');" expand></td><td ng-repeat="header in vm.headers"><a ng-click="vm.getRingPath(item.id)" target="_blank">{{ item[header.key] }}</a></td></tr><tr ng-show="item.route" style="height: auto;\r\n                                                border-left: 4px solid #FD7A24;"></tr><tr ng-repeat-end></tr></tbody></table><tr ng-repeat-end></tr></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.projects == 0"><h4>No data available</h4></td></tr></tbody></table></div></div><div class="row"><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><div class="col-md-9"><div class="box box-solid"><div id="map_view" style="height: 65vh; width: 100%;"></div></div></div></div></div>');
$templateCache.put('app/entities/tr-project/tr-project-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this project needs to be deleted before deleting project</p><p translate="trakeyeApp.task.delete.question" translate-values="{id: \'{{vm.trTask.id}}\'}">Are you sure you want to delete this Tr Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-project/tr-project-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><!-- <h3 class="box-title pull-left">\r\n\t\t\t\t\t\t<span translate="trakeyeApp.project.detail.title">Tr Project</span>\r\n\t\t\t\t\t\t{{vm.trProject.id}}\r\n\t\t\t\t\t</h3> --><div class="col-md-6 col-sm-2"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab"><i class="fa fa-info-circle"></i><span class="header-view"></span> <span class="header_view">Details</span></a></li><!--  <li ng-class="{active:isSet(2)}">\r\n\t\t\t\t\t\t\t\t<a href ng-click="setTab(2); search = null;" data-toggle="tab"><i\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-map"></i><span class="header-view">Map</span> <span\r\n\t\t\t\t\t\t\t\t\t\tclass="header_view">View</span></a>\r\n\t\t\t\t\t\t\t</li> --><li ng-class="{active:(isSet(3) || isSet(4) || isSet(5) || isSet(6) || isSet(7))}"><a href ng-click="setTab(3); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view"> Summary</span></a></li><li ng-class="{active:isSet(8)}" ng-show="Roles.TASKMAP_CONFIGURATION"><a href ng-click="setTab(8); search = null;" data-toggle="tab"><i class="fa fa-briefcase"></i><span class="header-view"> Configuration</span></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2); search = null" data-toggle="tab"><i class="fa fa-commenting"></i><span class="header-view">Comments</span></a></li></ul></div></div><!-- <jhi-alert-error></jhi-alert-error> --><jhi-alert></jhi-alert><div class="box-body" ng-show="isSet(1)"><a href="javascript:void(0);" ui-sref="tr-project" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-project.edit({id:vm.trProject.id})" class="btn btn-primary btn-sm pull-right" ng-if="Roles.PROJECT_EDIT"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a><div class="row mt-5"><div class="col-md-5"><dl class="dl-horizontal jh-entity-details mt-5"><dt ng-show="vm.trProject.projectAssets.length"><span>Asset Name</span></dt><dd ng-show="vm.trProject.projectAssets.length"><span class="node" ui-sref="asset-detail({id:vm.trProject.projectAssets[0].id})">{{vm.trProject.projectAssets[0].name}}</span></dd><dt><span>Name</span></dt><dd><span>{{vm.trProject.name}}</span></dd><dt><span translate="trakeyeApp.project.description">Description</span></dt><dd><span>{{vm.trProject.description}}</span></dd><dt><span>Start Date</span></dt><dd><span>{{vm.trProject.startDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span>End Date</span></dt><dd><span>{{vm.trProject.endDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span>RAG Status</span></dt><dd><span class="square square--{{vm.trProject.ragStatus}} mt-5"></span> {{vm.trProject.ragStatus}}</dd><dt><span>Phase</span></dt><dd><span>{{vm.trProject.phase}}</span></dd><dt><span translate="trakeyeApp.project.status">Status</span></dt><dd><!-- <span translate="{{\'trakeyeApp.ProjectStatus.\' + vm.trProject.status}}">{{vm.trProject.status}}</span> --> <span>{{vm.trProject.status}}</span></dd><dt><span translate="trakeyeApp.project.createDate">Create Date</span></dt><dd><span>{{vm.trProject.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.project.updateDate">Update Date</span></dt><dd><span>{{vm.trProject.lastModifiedDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><!-- <dt>\r\n\t\t\t\t\t\t\t\t\t<span translate="trakeyeApp.project.projectType">Project Type</span>\r\n\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t\t\t{{vm.trProject.projectType.name}}\r\n\t\t\t\t\t\t\t\t</dd> \r\n\t\t\t\t\t\t\t\t<div class="form-group" ng-repeat="attribute in vm.trProject.projectTypeAttributeValues">\r\n\t\t\t\t\t\t\t\t\t<div ng-repeat="attributeValue in vm.trProject.projectTypeAttributeValues track by $index">\r\n\t\t\t\t\t\t\t\t\t\t<div ng-if="attributeValue.projectTypeAttribute.id == attribute.projectTypeAttribute.id">\r\n\t\t\t\t\t\t\t\t\t\t\t<dt>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span>{{attribute.projectTypeAttribute.name}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span>{{attributeValue.attributeValue}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</dd>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --><!-- <dt ng-if="vm.trProject.projectType.name == \'Termination Details\'">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'termination\')"><span\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-hide="vm.showTermination">Show Termination Details</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span ng-show="vm.showTermination">Hide Termination Details</span></a>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</dt>\r\n\t\t\r\n\t\t\t\t\t\t\t\t<dd ng-if="terminationDetails">\r\n\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-12" style="overflow-x: scroll">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<table class="jh-table table table-responsive table-hover">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>FMS</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Type</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Port Number Start</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Port Number End</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Cable Number A Side</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCore Number A Side Start\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Core Number A Side End</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Number of Splice</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Port used for</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Cable Number B Side</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCore Number B Side Start\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Core Number B Side End</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tr class="ws-nowrap" ng-repeat="list in vm.trProject.terminationDetails">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.fms}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.type}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.portNumberStart}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.portNumberEnd}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideACable.cableNumber}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideACable.coreNumberStart}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideACable.coreNumberEnd}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.numberOfSplice}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.portUsedFor}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideBCable.cableNumber}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideBCable.coreNumberStart}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideBCable.coreNumberEnd}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</dd> --><!-- <dt>\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-2 trProject_showImgDiv" ng-if="vm.trProject.id">\r\n\t\t\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'image\')">\r\n\t\t\t\t\t\t\t\t\t\t\t<span ng-hide="vm.showImages">Show Images</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span ng-show="vm.showImages">Hide Images</span></a>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t<dd ng-if="allimages">\r\n\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-3" ng-repeat="img in vm.projectImages">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img ng-if="img.image != null" class="img-responsive img__img-responsive"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-src="data:image/jpeg;base64,{{img.image}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.imageInNewTab(img.image)" /><br />\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s" ng-show="img.imgDescription != null"><b>Description :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgDescription}}</span><br />\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-show="img.imgLat != null && img.imgLong != null"><b>LatLng :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgLat}},{{img.imgLong}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</dd> --></dl><div class="dropdownSurvey"><button class="dropdownSurvey-button">Download Survey Report</button><div class="dropdownSurvey-content"><button class="btn btn-primary pull-left" style="margin: 10px;" ng-if="vm.trProject.id" ng-click="vm.downloadSurveyReport()">Format 1</button> <button class="btn btn-primary pull-left" style="margin: 10px;" ng-if="vm.trProject.id" ng-click="vm.downloadProjectSurveyExcel()">Format 2</button></div></div></div><div class="col-md-7"><div id="map_canvas" class="div__map-canvas"></div></div></div></div><div class="mt-10 col-md-12 row" ng-show="isSet(8)"><div class="col-md-5" style="border-right: 2px solid #FD7A24;\r\n\t\t\t\t\tmin-height: 250px;"><h3>Existing Terrain Configuration</h3><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>No</th><th>Terrain Type Name</th><th>Task Type Name</th></tr></thead><tbody><tr ng-repeat="(tree, sub) in groupedData"><td>{{$index + 1}}</td><td>{{tree}}</td><td><div ng-repeat="task in sub"><span style="display: block;width: 250px;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">{{task}}</span></div></td></tr><td ng-show="vm.existingMap.length == 0"><h4>No Data Available</h4></td></tbody></table></div></div><div></div><div class="col-md-7"><h3>New Terrain Configuration</h3><!-- <label class="col-md-1 control-label mt-5">\r\n\t\t\t\t\t\t\t\t<span>    &nbsp; </span>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-4"><select ng-model="vm.selectedTerrain" class="select2 form-control" id="selectedTerrain" ng-change="vm.terrainChange()" ng-options="item as item.name for item in vm.terrainTypes"><option value="">Select Terrain Type</option></select><!-- <select id="masterGeofence" class="select2 form-control" ng-model="vm.terrainTypeId">\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<option ng-repeat="item in vm.terrainTypes" value="{{item.id}},{{item.name}}">\r\n\t\t\t\t\t\t\t\t\t\t{{item.name}}\r\n\t\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t\t</select> --></div><div class="col-md-5 dropFilter ml-5" ng-show="vm.selectedTerrain"><div isteven-multi-select input-model="vm.taskTypes" output-model="vm.selectedTaskType" button-label="name" item-label="name" tick-property="ticked" translation="terrain.taskType" output-properties="id name" helper-elements="all none done filter" max-height="170px" max-labels="1" on-select-done="vm.clickSection(\'terrain\')"></div></div><br><div class="table-responsive col-md-12 mt-10" ng-if="vm.mappedTypes.length"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>No</th><th>Terrain Type Name</th><th>Task Type Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="map in vm.mappedTypes"><td>{{$index + 1}}</td><td>{{map.terrain.name}}</td><td><div ng-repeat="task in map.task"><span style="display: block;width: 250px;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">{{task.name}}</span></div></td><td class="action-icons text-primary" ng-click="deleteMap($index,\'terrain\')"><span class="fa fa-trash-o"></span></td></tr></tbody></table><div class="box-footer pull-right"><button ng-click="vm.submitMap(\'terrain\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span>Submit</span></button></div></div></div></div><div class="mt-20 col-md-12 row" ng-show="isSet(8)"><div class="col-md-5" style="border-right: 2px solid #FD7A24;"><h3>Existing Row Configuration</h3><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>No</th><th>Row Type Name</th><th>Task Type Name</th></tr></thead><tbody><tr ng-repeat="(tree, sub) in groupedDataRow"><td>{{$index + 1}}</td><td>{{tree}}</td><td><div ng-repeat="task in sub"><span style="display: block;width: 250px;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">{{task}}</span></div></td></tr><td ng-show="vm.existingMapRow.length == 0"><h4>No Data Available</h4></td></tbody></table></div></div><div></div><div class="col-md-7"><h3>New Row Configuration</h3><!-- <label class="col-md-1 control-label mt-5">\r\n\t\t\t\t\t\t\t\t<span>    &nbsp; </span>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-4"><select ng-model="vm.selectedRoW" class="select2 form-control" id="selectRow" ng-change="vm.rowChange()" ng-options="item as item.name for item in vm.rowTypes"><option value="">Select Row Type</option></select><!-- <select id="masterGeofence" class="select2 form-control" ng-model="vm.RoWTypeId">\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<option ng-repeat="item in vm.RoWTypes" value="{{item.id}},{{item.name}}">\r\n\t\t\t\t\t\t\t\t\t\t{{item.name}}\r\n\t\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t\t</select> --></div><div class="col-md-5 dropFilter openOptiontop ml-5" ng-show="vm.selectedRoW"><div isteven-multi-select input-model="vm.taskTypesRow" output-model="vm.selectedTaskTypeRow" button-label="name" item-label="name" tick-property="selected" translation="row.taskType" output-properties="id name" helper-elements="all none done filter" max-height="170px" max-labels="1" on-select-done="vm.clickSection(\'row\')"></div></div><br><div class="table-responsive col-md-12 mt-10" ng-if="vm.mappedTypesRow.length"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>No</th><th>Row Type Name</th><th>Task Type Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="map in vm.mappedTypesRow"><td>{{$index + 1}}</td><td>{{map.row.name}}</td><td><div ng-repeat="task in map.task"><span style="display: block;width: 250px;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;">{{task.name}}</span></div></td><td class="action-icons text-primary" ng-click="deleteMap($index,\'row\')"><span class="fa fa-trash-o"></span></td></tr></tbody></table><div class="box-footer pull-right"><button ng-click="vm.submitMap(\'row\')" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span>Submit</span></button></div></div></div></div><comments obj="vm.objectComments" ng-if="isSet(2)"></comments><div class="mt-10" ng-show="isSet(3) ||isSet(4)|| isSet(5) ||isSet(6) || isSet(7)"><div class="col-md-3 col-sm-3" style="padding: 5px;\r\n\t\t\t\t\tmargin: 5px;"><ul class="nav nav-pills"><li ng-class="{active:isSet(3) || isSet(4) || isSet(7)}"><a href ng-click="setTab(3); search = null;" data-toggle="tab"><span class="header-view">Task</span> <!-- <span\r\n\t\t\t\t\t\t\t\t\t\tclass="header_view">Log</span> --></a></li><li ng-class="{active:isSet(5)}"><a href ng-click="setTab(5); search = null" data-toggle="tab"><span class="header-view">Material</span></a></li><li ng-class="{active:isSet(6)}"><a href ng-click="setTab(6); search = null" data-toggle="tab"><span class="header-view">Resource</span></a></li></ul></div></div><br><br><br><!-- <div class="mt-10 col-md-6 col-sm-3" ng-show="isSet(3) || isSet(4) || isSet(7)  ">\r\n\t<div  style="\r\n\tpadding: 5px;\r\n\tmargin: 5px;\r\n">\r\n\t\t<ul class="nav nav-pills">\r\n\t\t\t<li ng-class="{active:isSet(3)}" ng-if="vm.dailyLogsTxSummary.routeTasks.length">\r\n\t\t\t\t<a href ng-click="setTab(4); search = null;" data-toggle="tab"><span class="header-view">Route</span></a>\r\n\t\t\t</li>\r\n\t\t\t<li ng-class="{active:isSet(3)}" ng-if="vm.dailyLogsTxSummary.sectionTasks.length">\r\n\t\t\t\t<a href ng-click="setTab(7); search = null" data-toggle="tab"><span class="header-view">Section</span></a>\r\n\t\t\t</li>\r\n\t\t</ul>\r\n\r\n\t</div>\r\n</div> --><div class="col-sm-12" ng-show="isSet(4) || isSet(3)"><!-- <button class="btn btn-primary center-block" ng-click="getPdf()" ng-if=\'vm.isReportGenerated==true\' style="margin: 10px;"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="generatedHtmlContainer" style="width: calc(100% - 40px);overflow-x: auto;overflow-y: hidden;"></div></div><div class="table-responsive col-md-8 mt-10" ng-show="isSet(4) || isSet(3) "><h3>Logs Under Routes</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Name</th><th>Total Work Length (mtrs)</th><th>Total Number of Hours</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsTxSummary.routeTasks"><td><a ui-sref="tr-task-detail({id:task.taskId})" target="_blank">{{task.taskId}}</a></td><td>{{task.taskName}}</td><td>{{task.workLength}}</td><td>{{task.noOfHours}}</td></tr><td colspan="2" ng-show="vm.dailyLogsTxSummary.routeTasks.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="table-responsive col-md-8 mt-10" ng-show="isSet(7) "><h3>Logs Under Sections</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Name</th><th>Total Work Length (mtrs)</th><th>Total Number of Hours</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsTxSummary.sectionTasks"><td><a ui-sref="tr-task-detail({id:task.taskId})" target="_blank">{{task.taskId}}</a></td><td>{{task.taskName}}</td><td>{{task.workLength}}</td><td>{{task.noOfHours}}</td></tr><td colspan="2" ng-show="vm.dailyLogsTxSummary.sectionTasks.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="table-responsive mt-10" ng-show="isSet(5)"><h3>Summary</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th>ID</th> --><th>Name</th><th>Units of Measurement</th><th>Quantity</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.mtrlTxSummary"><!-- <td>\r\n\t\t\t\t\t\t\t\t\t{{task.materialId}}\r\n\t\t\t\t\t\t\t\t</td> --><td>{{task.materialName}}</td><td>{{task.unitOfMeasurementName}}</td><td>{{task.totalNoOfUnits}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="vm.mtrlTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table><div class="table-responsive mt-10"><h3>Material Inventory Transaction</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th></th><th>Date</th><th>Total</th></tr></thead><tbody><tr ng-repeat-start="task in vm.materialByDate"><td class="td__listViewRow" ng-click="vm.toggleExpand(task)" expand><span ng-if="!task.isExpand" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true" ng-click="vm.loadMaterialTxnByDates(task.timestamp)"></i> </span><span ng-if="task.isExpand" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{task.timestamp | date:\'dd-MM-yyyy\'}}</td><td>{{task.total}}</td></tr><tr ng-if="task.isExpand"><td></td><td colspan="4"><table class="table__userNames"><thead><tr><th>SlNo</th><th>Date</th><th>Material-ID</th><th>Material-Name</th><th>Material-Type</th><th>No of Units</th><th>Transaction-Type</th></tr></thead><tbody><tr ng-repeat="detail in vm.materialTxnByDates"><td>{{$index + 1}}</td><td>{{detail.timestamp | date:\'dd-MM-yyyy\'}}</td><td>{{detail.transactionId}}</td><td>{{detail.transactionName}}</td><td>{{detail.transactionType}}</td><td>{{detail.count}}</td><td>{{detail.status}}</td></tr><tr><td colspan="7"><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadMaterialTxnByDates(task.timestamp)"></uib-pagination></div></div></div></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr ng-show="vm.materialByDate.length == 0"><td colspan="3"><h4>No Transaction Available</h4></td></tr></tbody></table><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.mtrpage" total="vm.QueryCount" items-per-page="vm.mtrPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.TotalItems" ng-model="vm.mtrpage" ng-change="vm.loadMaterialTxnDate()"></uib-pagination></div></div></div></div></div><div class="table-responsive mt-10" ng-show="isSet(6)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th>ID</th> --><th>Name</th><th>Total no of Resources</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.resTxSummary"><!-- <td>\r\n\t\t\t\t\t\t\t\t\t{{task.materialId}}\r\n\t\t\t\t\t\t\t\t</td> --><td>{{task.resourceName}}</td><td>{{task.totalNoOfResources}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="vm.resTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/tr-project/tr-project-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrProjectLabel"><span ng-if="!vm.trProject.id">Create Project</span> <span ng-if="vm.trProject.id">Edit - {{vm.trProject.name}}</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.project.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trProject.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.project.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trProject.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label">Start Date<!--  <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup> --></label><div class="input-group col-md-3"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')">Start <i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_serviceDate" type="text" class="form-control" name="fromDate" ng-model="vm.startDate" ng-change="vm.calculateFromDate()" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.fromDate" enable-time="false"></div></div><div class="form-group"><label class="col-md-3 control-label">End Date<!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup> --></label><div class="input-group col-md-3"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')">End <i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_toDate" type="text" class="form-control" name="toDate" ng-model="vm.endDate" ng-change="vm.calculateToDate()" datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.toDate" enable-time="false"></div></div><!-- <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span translate="trakeyeApp.project.projectType">projectType</span>\r\n                                    <sup><span class="required-icon"><i\r\n                                                class="fa fa-asterisk text-danger"></i></span></sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <select class="form-control select2" name="projectType" ng-model="vm.projectType"\r\n                                        ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                        vm.projectTypes track by item.id" ng-disabled="vm.trProject.id!=null" required\r\n                                        style="width: 100%">\r\n                                        <option value="" translate="trakeyeApp.project.selectproject">\r\n                                            --- Select ProjectType ---\r\n                                        </option>\r\n                                    </select>\r\n                                </div>\r\n                            </div> --><!--  <div class="form-group"\r\n                                ng-repeat="attribute in vm.trProject.projectTypeAttributeValues track by $index">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>{{attribute.projectTypeAttribute.name}}</span>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <input ng-model="vm.trProject.projectTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.projectTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trProject.id"\r\n                                        type="text" class="form-control"\r\n                                        ng-init="vm.trProject.projectTypeAttributeValues[$index].attributeValue = attribute.projectTypeAttribute.defaultValue"\r\n                                        name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" />\r\n                                    <input ng-model="vm.trProject.projectTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.projectTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.trProject.id"\r\n                                        type="text" class="form-control" name="value{{$index+1}}"\r\n                                        ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" />\r\n                                    <span ng-if="attribute.projectTypeAttribute.attributeDataType.name == \'FLOAT\'"\r\n                                        ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">\r\n                                        Enter a Valid Number (Ex:1.00)</span>\r\n\r\n                                    <input ng-model="vm.trProject.projectTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.projectTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trProject.id"\r\n                                        type="text" class="form-control"\r\n                                        ng-init="vm.trProject.projectTypeAttributeValues[$index].attributeValue = attribute.projectTypeAttribute.defaultValue"\r\n                                        name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/" />\r\n                                    <input ng-model="vm.trProject.projectTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.projectTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trProject.id"\r\n                                        type="text" class="form-control" name="value{{$index+1}}"\r\n                                        ng-pattern="/^[0-9]{1,7}$/" />\r\n                                    <span ng-if="attribute.projectTypeAttribute.attributeDataType.name == \'INTEGER\'"\r\n                                        ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">\r\n                                        Enter a Valid Number\r\n                                    </span>\r\n\r\n                                    <input ng-model="vm.trProject.projectTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.projectTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trProject.id"\r\n                                        type="text" class="form-control"\r\n                                        ng-init="vm.trProject.projectTypeAttributeValues[$index].attributeValue = attribute.projectTypeAttribute.defaultValue"\r\n                                        name="value{{$index+1}}" />\r\n                                    <input ng-model="vm.trProject.projectTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.projectTypeAttribute.attributeDataType.name == \'STRING\' && vm.trProject.id"\r\n                                        type="text" class="form-control" name="value{{$index+1}}" />\r\n                                    <span ng-if="attribute.projectTypeAttribute.attributeDataType.name == \'STRING\'"\r\n                                        ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">\r\n                                        Enter a Message</span>\r\n\r\n                                    <select ng-model="vm.trProject.projectTypeAttributeValues[$index].attributeValue"\r\n                                        ng-init="vm.trProject.projectTypeAttributeValues[$index].attributeValue = attribute.projectTypeAttribute.defaultValue"\r\n                                        ng-if="attribute.projectTypeAttribute.attributeDataType.name != \'STRING\' && attribute.projectTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.projectTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trProject.id"\r\n                                        class="form-control select2" name="value{{$index+1}}">\r\n                                        <option value="{{ atttype.value  }}"\r\n                                            ng-repeat="atttype in vm.customAttributesMap[attribute.projectTypeAttribute.attributeDataType.name]">\r\n                                            {{atttype.value }}\r\n                                        </option>\r\n                                    </select>\r\n                                    <select ng-model="vm.trProject.projectTypeAttributeValues[$index].attributeValue"\r\n                                        ng-init="vm.trProject.projectTypeAttributeValues[$index].attributeValue == attribute.projectTypeAttribute.defaultValue"\r\n                                        ng-if="attribute.projectTypeAttribute.attributeDataType.name != \'STRING\' && attribute.projectTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.projectTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trProject.id"\r\n                                        class="form-control select2" name="value{{$index+1}}">\r\n                                        <option value="{{ atttype.value  }}"\r\n                                            ng-repeat="atttype in vm.customAttributesMap[attribute.projectTypeAttribute.attributeDataType.name]">\r\n                                            {{atttype.value }}\r\n                                        </option>\r\n                                    </select>\r\n                                </div>\r\n                            </div> --><!-- <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Cost Center</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <input type="text" class="form-control" name="name" id="field_name"\r\n                                        ng-model="vm.trProject.name" required />\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Start Date</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <div class="input-group">\r\n                                        <span class="input-group-btn">\r\n                                            <button type="button" class="btn btn-default"\r\n                                                ng-click="vm.openCalendar(\'fromDate\')">From <i\r\n                                                    class="glyphicon glyphicon-calendar"></i></button>\r\n                                        </span>\r\n                                        <input id="field_serviceDate" type="text" class="form-control"\r\n                                            name="fromDate" ng-model="vm.fromDate" \r\n                                            datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.fromDate"\r\n                                            enable-time="false" datepicker-options="options" required />\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>End Date</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <div class="input-group">\r\n                                        <span class="input-group-btn">\r\n                                            <button type="button" class="btn btn-default"\r\n                                                ng-click="vm.openCalendar(\'toDate\')">to <i\r\n                                                    class="glyphicon glyphicon-calendar"></i></button>\r\n                                        </span>\r\n                                        <input id="field_toDate" type="text" class="form-control" name="toDate"\r\n                                            ng-model="vm.toDate" \r\n                                            datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.toDate"\r\n                                            enable-time="false" datepicker-options="options" required />\r\n                                    </div>\r\n                                </div>\r\n                            </div> --><div class="form-group"><label class="col-md-3 control-label"><span>Select Coordinate</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <button type="button" class="btn btn-primary btn-sm ml-5 pull-right" ng-click="vm.removeMarker()" title="Clear Selected Point"><span class="fa fa-refresh"></span></button><div class="col-md-8"><div id="map_canvas" class="div__map-canvas"></div><!-- <span id="noData" class="mt-5" ng-if="vm.isSaving">*Please Add Project</span> --></div><!-- <div class="pull-right">\r\n                                        <span id="myspan"> Zoom : {{vm.objectRouteImg.zoomLevel}}</span>\r\n                                    </div>  --></div><div class="form-group"><label class="col-md-3 control-label"><span>RAG Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3 mt-10"><!--  <select class="form-control" name="ragStatus" ng-model="vm.trProject.ragStatus" \r\n\t\t\t\t\t\t\t\trequired>\r\n                                <option value="">\r\n                                    --- Select RAG Status ---\r\n                                </option>\r\n\t\t\t\t\t\t\t\t<option value="RED" >\r\n                                   RED <span ></span>\r\n                                </option>\r\n                                <option value="" >\r\n                                    AMBER\r\n                                 </option>\r\n                                 <option value="">\r\n                                    GREEN\r\n                                 </option>\r\n\t\t\t\t\t\t\t</select> --><div class="square--RED square" ng-click="vm.colorcode(\'RED\')" title="RED"></div>&nbsp;&nbsp;<div class="square--AMBER square" ng-click="vm.colorcode(\'AMBER\')" title="AMBER"></div>&nbsp;&nbsp; <span class="square--GREEN square" ng-click="vm.colorcode(\'GREEN\')" title="GREEN"></span>&nbsp;&nbsp; <span><input type="text" class="form-control" name="colorcode" id="field_colorcode" ng-model="vm.trProject.ragStatus" readonly="readonly" required></span></div></div><!-- <div class="form-group" >\r\n\t\t\t\t\t\t\t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t<span  for="field_colorcode">Colorcode</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t   \r\n\t\t\t\t\t\t</div> --><div class="form-group" ng-if="vm.trProject.id"><label class="col-md-3 control-label"><span>Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="status" ng-model="vm.trProject.status" id="field_status" required><option value="">--- Select Status ---</option><option ng-repeat="item in vm.rolloutTaskStatus" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Phase</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="status" ng-model="vm.trProject.phase" ng-disabled="!has_ROLE_PLAN_ADMIN" required><option value="">--- Select Phase ---</option><option ng-repeat="item in vm.workFlowPhase" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><!-- <div class="box box-solid" style="margin-top: 5%;">\r\n                                <div class="box-header">\r\n                                    <div class="pull-left">\r\n                                        <h3 class="box-title"><i class="fa fa-routes"></i>\r\n                                            <span>Routes</span>\r\n                                        </h3>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="box-body">\r\n                                    <jhi-alert></jhi-alert>\r\n                                    <div class="table-responsive mt-10" >\r\n                                        <table class="jh-table table table-responsive table-hover">\r\n                                            <thead class="bg-default">\r\n                                                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                                                    <th></th>\r\n                                                    <th jh-sort-by="name"><span>Name</span> <span\r\n                                                            class="fa fa-sort"></span></th>\r\n                                                    <th>Route Type</th>\r\n                                                </tr>\r\n                                            </thead>\r\n                                            <tbody>\r\n                                                <tr ng-repeat-start="route in vm.routes | filter: users track by route.id" ng-class="{selected: route.isChecked}">\r\n                                                    <td><input type="checkbox" ng-model="route.isChecked"\r\n                                                        ng-change="vm.selectEntity(route)"></td>\r\n                                                    <td>{{route.name}}</td>\r\n                                                    <td>{{route.routeType.name}}</td>\r\n                                                </tr>\r\n                                                <tr ng-repeat-end></tr>\r\n                                                <tr>\r\n                                                    <td class="td__noDataAvailable" colspan="10" ng-show="vm.routes.length == 0">\r\n                                                        <h4>No data available</h4>\r\n                                                    </td>\r\n                                                </tr>\r\n                                            </tbody>\r\n                                        </table>\r\n                                    </div>\r\n                                </div> \r\n                            </div>  --></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-project"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm" id="disableBtn"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div>');
$templateCache.put('app/entities/tr-project/tr-projects.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-projects"></i> <span>Projects</span></h3></div><div class="box-tools project_labels" ng-show="Roles.PROJECT_CREATE"><button class="btn btn-create btn-sm" ui-sref="tr-project.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th></th><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><th>Start Date</th><th>End Date</th><th>RAG Status</th><!-- <th jh-sort-by="description"><span\r\n                                            translate="trakeyeApp.project.description">Description</span> --><!-- <th>Project Type</th> --><th>Created Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="project in vm.projects | filter: users track by project.id" ng-class="{selected: project.isChecked}"><td class="td__listViewRow" ng-click="vm.expand(project,\'project\');" expand><span ng-if="!project.project" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Routes Expand"></i></span> <span ng-if="project.project" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Routes Close"></i></span></td><td><a ui-sref="tr-project-detail({id:project.id})">{{project.name}}</a></td><td>{{project.startDate | date:\'dd-MM-yyyy\'}}</td><td>{{project.endDate | date:\'dd-MM-yyyy\'}}</td><td><div class="square square--{{project.ragStatus}} mt-5" title="{{project.ragStatus}}"></div></td><!-- <td>{{project.description}}</td> --><!-- <td>{{project.projectType}}</td> --><td>{{project.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><div class="action"><a ui-sref="tr-project-detail({id:project.id})" class="action-icons text-info" title="View" ng-show="Roles.PROJECT_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-project.edit({id:project.id})" class="action-icons text-primary" title="Edit" ng-show="Roles.PROJECT_EDIT"><span class="fa fa-pencil-square"></span></a></div></td></tr><!-- FRoute --><tr ng-show="project.project" style="height: auto;\r\n                                border-left: 4px solid #666;"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><i class="fa fa-long-arrow-right" aria-hidden="true" style="color: #666;"></i> <b style="text-decoration: underline;\r\n\t\t\t\t\t\t\t               text-decoration-thickness: 4px;\r\n\t\t\t\t\t\t\t               text-decoration-color: #FD7A24;">Routes</b><h5 ng-show="!vm.routePlanResponse.length">No data available</h5></tr><tr ng-show="vm.routePlanResponse.length"><th></th><!--  <th ng-repeat="header in vm.headers">{{ header.display }}</th> --></tr></thead><tbody><tr ng-repeat-start="item in vm.routePlanResponse"><td class="td__listViewRow" ng-click="vm.expand(item,\'routeBundles\');" expand><span ng-if="!item.routeBundles" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Sections Expand"></i></span> <span ng-if="item.routeBundles" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Sections Close"></i></span></td><td ng-repeat="header in vm.headers"><a ui-sref="tr-route-plan-detail({id:item.id})" target="_blank">{{ item[header.key] }}</a></td></tr><tr ng-show="item.routeBundles" style="height: auto;\r\n\t\t\t\t\t\t\t           border-left: 4px solid #FD7A24;"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><i class="fa fa-long-arrow-right" aria-hidden="true" style="color: #666;"></i> <b style="text-decoration: underline;\r\n                                                    text-decoration-thickness: 4px;\r\n                                                    text-decoration-color: #FD7A24;">Rings/Path</b><h5 ng-show="!vm.routeResponse.length">No data available</h5></tr><tr ng-show="vm.routeResponse.length"><th></th><!--  <th ng-repeat="header in vm.headers">{{ header.display }}</th> --></tr></thead><tbody><tr ng-repeat-start="item in vm.routeResponse"><td class="td__listViewRow" ng-click="vm.expand(item,\'route\');" expand><span ng-if="!item.route" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Sections Expand"></i></span> <span ng-if="item.route" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Sections Close"></i></span></td><td ng-repeat="header in vm.headers"><a ui-sref="tr-route-detail({id:item.id})" target="_blank">{{ item[header.key] }}</a></td></tr><tr ng-show="item.route" style="height: auto;\r\n                                                border-left: 4px solid #FD7A24;"><td colspan="11"><!-- FSection --><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><i class="fa fa-long-arrow-right" aria-hidden="true" style="color: #FD7A24;"></i> <b style="text-decoration: underline;\r\n                                                    text-decoration-thickness: 4px;\r\n                                                    text-decoration-color: blue;">Sections</b><h5 ng-show="!vm.sectionResponse.length">No data available</h5></tr><tr ng-show="vm.sectionResponse.length"><th></th><!--  <th ng-repeat="header in vm.sectionheaders">{{ header.display }}</th> --></tr></thead><tbody><tr ng-repeat-start="section in vm.sectionResponse"><td class="td__listViewRow" ng-click="vm.expand(section,\'section\');" expand><span ng-if="!section.section" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Sections Expand"></i></span> <span ng-if="section.section" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Sections Close"></i></span></td><td ng-repeat="header in vm.sectionheaders"><a ui-sref="tr-section-detail({id:section.sectionId,routeId:section.routeId})" target="_blank">{{ section[header.key] }}</a></td></tr><!-- FsectionTasks --><tr ng-show="section.section" style="height: auto;\r\n                                                                border-left: 4px solid blue;"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><i class="fa fa-long-arrow-right" aria-hidden="true" style="color: blue;"></i> <b>Section Tasks</b><h5 ng-show="!vm.sectionTaskResponse.length">No data available</h5></tr><tr ng-show="vm.sectionTaskResponse.length"><!--  <th></th> --><!-- <th ng-repeat="header in vm.sectionTaskheaders">{{ header.display }}</th> --></tr></thead><tbody><tr ng-repeat-start="sTask in vm.sectionTaskResponse"><!-- <td class="td__listViewRow" ng-click="vm.expand(sTask,\'sectionTask\');" expand>\r\n                                                                                        <span ng-if="!sTask.sectionTask" class="span__listViewRow"><i\r\n                                                                                                class="fa fa-expand" aria-hidden="true" title="Section Tasks Expand"></i></span>\r\n                                                                                        <span ng-if="sTask.sectionTask" class="span__listViewRow"><i\r\n                                                                                                class="fa fa-compress" aria-hidden="true"\r\n                                                                                                title="Section Tasks Close"></i></span>\r\n                                                                                        </td> --><td ng-repeat="header in vm.sectionTaskheaders"><a ui-sref="tr-task-detail({id:sTask.id})" target="_blank">{{ sTask[header.key] }}</a></td></tr><!-- FSectionTaskLogs --><!--    <tr ng-show="sTask.sectionTask" style="\r\n                                                                height: auto;\r\n                                                                border-left: 4px solid red;\r\n                                                            ">\r\n                                                                    <td colspan="11">\r\n                                                                        <table style=" width: 100%; height:100%; border-spacing:0; margin-left: 5%;">\r\n                                                                            <thead>\r\n                                                                                <tr>\r\n                                                                                    <b>Logs</b>\r\n                                                                                </tr>\r\n                                                                                <tr>\r\n                                                                                    <th ng-repeat="header in vm.logsheaders">{{ header.display }}</th>\r\n                                                                                </tr>\r\n                                                                            </thead>\r\n                                                                            <tbody>\r\n                                                                                <tr ng-repeat="log in vm.logsResponse">\r\n                                                                                    \r\n                                                                                    <td ng-repeat="header in vm.logsheaders" >\r\n                                                                                        {{ log[header.key] }}\r\n                                                                                    </td>\r\n                                                                                </tr>\r\n                                                                                <tr>\r\n                                                                                    <td class="td__noDataAvailable" colspan="10"\r\n                                                                                        ng-show="vm.logsResponse.length == 0">\r\n                                                                                        <h4>No data available</h4>\r\n                                                                                    </td>\r\n                                                                                    <td class="td__noDataAvailable" colspan="10"\r\n                                                                                        ng-show="vm.logsResponse ==  null">\r\n                                                                                        <h4>Loading...</h4>\r\n                                                                                    </td>\r\n                                                                                </tr>\r\n                                                                                \r\n                                                                            </tbody>\r\n                                                                        </table>\r\n                \r\n                \r\n                \r\n                \r\n                                                                    </td>\r\n                                                                </tr> --><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr></tbody></table><!-- FTerrain  --><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;" ng-if="vm.terrainResponse.length"><thead><tr><i class="fa fa-long-arrow-right" aria-hidden="true" style="color: #FD7A24;"></i> <b>Terrains</b><h5 ng-show="!vm.terrainResponse.length">No data available</h5></tr><tr ng-show="vm.terrainResponse.length"><!--  <th></th> --><!-- <th ng-repeat="header in vm.terrainsheaders">{{ header.display }}</th> --></tr></thead><tbody><tr ng-repeat="terrain in vm.terrainResponse"><!-- <td class="td__listViewRow" ng-click="vm.expand(terrain,\'terrain\');" expand>\r\n                                                                        <span ng-if="!terrain.terrain" class="span__listViewRow"><i\r\n                                                                                class="fa fa-expand" aria-hidden="true" title="Terrain Expand"></i></span>\r\n                                                                        <span ng-if="terrain.terrain" class="span__listViewRow"><i\r\n                                                                                class="fa fa-compress" aria-hidden="true"\r\n                                                                                title="Terrain Close"></i></span>\r\n                                                                        </td> --><td ng-repeat="header in vm.terrainsheaders"><a ui-sref="tr-terrain-detail({id:terrain.id})" target="_blank">{{ terrain[header.key] }}</a></td></tr><!-- <tr>\r\n                                                                    <td class="td__noDataAvailable" colspan="10"\r\n                                                                        ng-show="vm.terrainResponse.length == 0">\r\n                                                                        <h4>No data available</h4>\r\n                                                                    </td>\r\n                                                                </tr> --></tbody></table><!--\r\n                                                        FRoW   --><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;" ng-if="vm.rowResponse.length"><thead><tr><i class="fa fa-long-arrow-right" aria-hidden="true" style="color: #FD7A24;"></i> <b>Row</b><h5 ng-show="!vm.rowResponse.length">No data available</h5></tr><!-- <tr>\r\n                                                                    <th ng-repeat="header in vm.rowsheaders">{{ header.display }}</th>\r\n                                                                </tr> --></thead><tbody><tr ng-repeat="row in vm.rowResponse"><!-- <td class="td__listViewRow" ng-click="vm.expand(row,\'row\');" expand>\r\n                                                                        <span ng-if="!row.row" class="span__listViewRow"><i\r\n                                                                                class="fa fa-expand" aria-hidden="true" title="Row Expand"></i></span>\r\n                                                                        <span ng-if="row.row" class="span__listViewRow"><i\r\n                                                                                class="fa fa-compress" aria-hidden="true"\r\n                                                                                title="Row Close"></i></span>\r\n                                                                        </td> --><td><a ui-sref="tr-row-detail({id:row.id})" target="_blank">{{ row.name }}</a></td></tr><!-- <tr>\r\n                                                                    <td class="td__noDataAvailable" colspan="10"\r\n                                                                        ng-show="vm.rowResponse.length == 0">\r\n                                                                        <h4>No data available</h4>\r\n                                                                    </td>\r\n                                                                    <td class="td__noDataAvailable" colspan="10"\r\n                                                                        ng-show="vm.rowResponse ==  null">\r\n                                                                        <h4>Loading...</h4>\r\n                                                                    </td>\r\n                                                                </tr> --></tbody></table><!-- FRouteTask --><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;" ng-if="vm.routeTaskResponse.length"><thead><tr><i class="fa fa-long-arrow-right" aria-hidden="true" style="color: #FD7A24;"></i> <b>Route Tasks</b><h5 ng-show="!vm.routeTaskResponse.length">No data available</h5></tr><tr ng-show="vm.routeTaskResponse.length"><!--  <th></th> --><!-- <th ng-repeat="header in vm.routeTaskheaders">{{ header.display }}</th> --></tr></thead><tbody><tr ng-repeat-start="rTask in vm.routeTaskResponse"><!-- <td class="td__listViewRow" ng-click="vm.expand(rTask,\'routeTask\');" expand>\r\n                                                                        <span ng-if="!rTask.routeTask" class="span__listViewRow"><i\r\n                                                                                class="fa fa-expand" aria-hidden="true" title="Tasks Expand"></i></span>\r\n                                                                        <span ng-if="rTask.routeTask" class="span__listViewRow"><i\r\n                                                                                class="fa fa-compress" aria-hidden="true"\r\n                                                                                title="Tasks Close"></i></span>\r\n                                                                        </td> --><td ng-repeat="header in vm.routeTaskheaders"><a ui-sref="tr-task-detail({id:rTask.id})" target="_blank">{{ rTask[header.key] }}</a></td></tr><!-- FRouteTaskLogs --><!-- <tr ng-show="rTask.routeTask" style="\r\n                                                                 height: auto;\r\n                                                                 border-left: 4px solid red;\r\n                                                             ">\r\n                                                                     <td colspan="11">\r\n                                                                         <table style=" width: 100%; height:100%; border-spacing:0; margin-left: 5%;">\r\n                                                                             <thead>\r\n                                                                                 <tr>\r\n                                                                                     <b>Logs</b>\r\n                                                                                 </tr>\r\n                                                                                 <tr>\r\n                                                                                     <th ng-repeat="header in vm.logsheaders">{{ header.display }}</th>\r\n                                                                                 </tr>\r\n                                                                             </thead>\r\n                                                                             <tbody>\r\n                                                                                 <tr ng-repeat="log in vm.logsrResponse">\r\n                                                                                     \r\n                                                                                     <td ng-repeat="header in vm.logsheaders" >\r\n                                                                                         {{ log[header.key] }}\r\n                                                                                     </td>\r\n                                                                                 </tr>\r\n                                                                                 <tr>\r\n                                                                                     <td class="td__noDataAvailable" colspan="10"\r\n                                                                                         ng-show="vm.logsrResponse.length == 0">\r\n                                                                                         <h4>No data available</h4>\r\n                                                                                     </td>\r\n                                                                                     <td class="td__noDataAvailable" colspan="10"\r\n                                                                                         ng-show="vm.logsrResponse ==  null">\r\n                                                                                         <h4>Loading...</h4>\r\n                                                                                     </td>\r\n                                                                                 </tr>\r\n                                                                                 \r\n                                                                             </tbody>\r\n                                                                         </table>\r\n                 \r\n                 \r\n                 \r\n                 \r\n                                                                     </td>\r\n                                                                 </tr> --><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr></tbody></table><tr ng-repeat-end></tr></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.projects == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-resource/tr-resource-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this resource needs to be deleted before deleting resource</p><p translate="trakeyeApp.task.delete.question" translate-values="{id: \'{{vm.trTask.id}}\'}">Are you sure you want to delete this Tr Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-resource/tr-resource-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.resource.detail.title">Tr Resource</span> {{vm.trResource.name}} - {{vm.trResource.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><a href="javascript:void(0);" ui-sref="tr-resource" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-resource.edit({id:vm.trResource.id})" class="btn btn-primary btn-sm pull-right" ng-if="Roles.RESOURCE_EDIT"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a><dl class="dl-horizontal jh-entity-details mt-5"><dt ng-show="vm.trResource.resourceAssets.length"><span>Asset Name</span></dt><dd ng-show="vm.trResource.resourceAssets.length"><span class="node" ui-sref="asset-detail({id:vm.trResource.resourceAssets[0].id})">{{vm.trResource.resourceAssets[0].name}}</span></dd><dt><span translate="trakeyeApp.resource.description">Description</span></dt><dd><span>{{vm.trResource.description}}</span></dd><!-- <dt>\r\n\t\t\t\t\t\t\t<span translate="trakeyeApp.resource.createDate">Create Date</span>\r\n\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t<span>{{vm.trResource.createdDate | date:\'medium\'}}</span>\r\n\t\t\t\t\t\t</dd>\r\n\t\t\t\t\t\t<dt>\r\n\t\t\t\t\t\t\t<span translate="trakeyeApp.resource.updateDate">Update Date</span>\r\n\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t<span>{{vm.trResource.lastModifiedDate |\r\n\t\t\t\t\t\t\t\tdate:\'medium\'}}</span>\r\n\t\t\t\t\t\t</dd> --><dt><span translate="trakeyeApp.resource.resourceType">Resource Type</span></dt><dd><!--  <a ui-sref="resource-type-detail({id:vm.trResource.resourceType.id})">{{vm.trResource.resourceType.name}}</a> --> {{vm.trResource.resourceType.name}}</dd><div class="form-group" ng-repeat="attribute in vm.trResource.resourceTypeAttributeValues"><div ng-repeat="attributeValue in vm.trResource.resourceTypeAttributeValues track by $index"><div ng-if="attributeValue.resourceTypeAttribute.id == attribute.resourceTypeAttribute.id"><dt><span>{{attribute.resourceTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></div></div></div><!-- <dt ng-if="vm.trResource.resourceType.name == \'Termination Details\'">\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'termination\')"><span\r\n\t\t\t\t\t\t\t\t\t\tng-hide="vm.showTermination">Show Termination Details</span>\r\n\t\t\t\t\t\t\t\t\t<span ng-show="vm.showTermination">Hide Termination Details</span></a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dt>\r\n\r\n\t\t\t\t\t\t<dd ng-if="terminationDetails">\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-12" style="overflow-x: scroll">\r\n\t\t\t\t\t\t\t\t\t\t<table class="jh-table table table-responsive table-hover">\r\n\t\t\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>FMS</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Type</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Port Number Start</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Port Number End</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Cable Number A Side</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tCore Number A Side Start\r\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Core Number A Side End</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Number of Splice</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Port used for</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Cable Number B Side</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tCore Number B Side Start\r\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Core Number B Side End</th>\r\n\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t<tr class="ws-nowrap" ng-repeat="list in vm.trResource.terminationDetails">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.fms}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.type}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.portNumberStart}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.portNumberEnd}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideACable.cableNumber}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideACable.coreNumberStart}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideACable.coreNumberEnd}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.numberOfSplice}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.portUsedFor}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideBCable.cableNumber}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideBCable.coreNumberStart}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideBCable.coreNumberEnd}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dd> --><!-- <dt>\r\n\t\t\t\t\t\t\t<div class="col-md-2 trResource_showImgDiv" ng-if="vm.trResource.id">\r\n\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'image\')">\r\n\t\t\t\t\t\t\t\t\t<span ng-hide="vm.showImages">Show Images</span>\r\n\t\t\t\t\t\t\t\t\t<span ng-show="vm.showImages">Hide Images</span></a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t<dd ng-if="allimages">\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-3" ng-repeat="img in vm.resourceImages">\r\n\t\t\t\t\t\t\t\t\t\t\t<img ng-if="img.image != null" class="img-responsive img__img-responsive"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-src="data:image/jpeg;base64,{{img.image}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.imageInNewTab(img.image)" /><br />\r\n\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s" ng-show="img.imgDescription != null"><b>Description :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgDescription}}</span><br />\r\n\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-show="img.imgLat != null && img.imgLong != null"><b>LatLng :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgLat}},{{img.imgLong}}</span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dd> --></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tr-resource/tr-resource-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrResourceLabel"><span ng-if="!vm.trResource.id" translate="trakeyeApp.resource.home.create">Create</span> <span ng-if="vm.trResource.id">Edit Resource</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.resource.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trResource.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.resource.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trResource.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.resource.resourceType">resourceType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="resourceType" ng-model="vm.resourceType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                        vm.resourceTypes track by item.id" ng-disabled="vm.trResource.id!=null" required style="width: 100%"><option value="" translate="trakeyeApp.resource.selectresource">--- Select ResourceType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.trResource.resourceTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.resourceTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.trResource.resourceTypeAttributeValues[$index].attributeValue" ng-if="attribute.resourceTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trResource.id" type="text" class="form-control" ng-init="vm.trResource.resourceTypeAttributeValues[$index].attributeValue = attribute.resourceTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.trResource.resourceTypeAttributeValues[$index].attributeValue" ng-if="attribute.resourceTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.trResource.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.resourceTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.trResource.resourceTypeAttributeValues[$index].attributeValue" ng-if="attribute.resourceTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trResource.id" type="text" class="form-control" ng-init="vm.trResource.resourceTypeAttributeValues[$index].attributeValue = attribute.resourceTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.trResource.resourceTypeAttributeValues[$index].attributeValue" ng-if="attribute.resourceTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trResource.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.resourceTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.trResource.resourceTypeAttributeValues[$index].attributeValue" ng-if="attribute.resourceTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trResource.id" type="text" class="form-control" ng-init="vm.trResource.resourceTypeAttributeValues[$index].attributeValue = attribute.resourceTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.trResource.resourceTypeAttributeValues[$index].attributeValue" ng-if="attribute.resourceTypeAttribute.attributeDataType.name == \'STRING\' && vm.trResource.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.resourceTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.trResource.resourceTypeAttributeValues[$index].attributeValue" ng-init="vm.trResource.resourceTypeAttributeValues[$index].attributeValue = attribute.resourceTypeAttribute.defaultValue" ng-if="attribute.resourceTypeAttribute.attributeDataType.name != \'STRING\' && attribute.resourceTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.resourceTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trResource.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.resourceTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.trResource.resourceTypeAttributeValues[$index].attributeValue" ng-init="vm.trResource.resourceTypeAttributeValues[$index].attributeValue == attribute.resourceTypeAttribute.defaultValue" ng-if="attribute.resourceTypeAttribute.attributeDataType.name != \'STRING\' && attribute.resourceTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.resourceTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trResource.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.resourceTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-resource"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div>');
$templateCache.put('app/entities/tr-resource/tr-resources.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-resources"></i> <span>Resources</span></h3></div><div class="box-tools resource_labels" ng-if="Roles.RESOURCE_CREATE"><button class="btn btn-create btn-sm" ui-sref="tr-resource.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="description"><span\r\n                                            translate="trakeyeApp.resource.description">Description</span> --><th>Resource Type</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="resource in vm.resources | filter: users track by resource.id" ng-class="{selected: resource.isChecked}"><td><a ui-sref="tr-resource-detail({id:resource.id})">{{resource.name}}</a></td><!-- <td>{{resource.description}}</td> --><td>{{resource.resourceTypeName}}</td><td><div class="action"><a ui-sref="tr-resource-detail({id:resource.id})" class="action-icons text-info" title="View" ng-if="Roles.RESOURCE_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-resource.edit({id:resource.id})" class="action-icons text-primary" title="Edit" ng-if="Roles.RESOURCE_EDIT"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.resources == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-route/tr-route-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this route needs to be deleted before deleting route</p><p translate="trakeyeApp.task.delete.question" translate-values="{id: \'{{vm.trTask.id}}\'}">Are you sure you want to delete this Tr Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-route/tr-route-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><!-- <h3 class="box-title pull-left">\r\n\t\t\t\t\t\tRoute\r\n\t\t\t\t\t</h3>  --><div class="col-md-10 col-sm-3"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab"><i class="fa fa-info-circle"></i><span class="header-view">Ring</span> <!-- <span class="header_view">Details</span> --></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2); search = null;vm.getSectionPath()" data-toggle="tab" ng-if="vm.showRingDetailWorkProgressTab"><i class="fa fa-list"></i><span class="header-view">Work Progress</span> <span class="header_view"></span></a></li><li ng-class="{active:isSet(9)}" ng-click=" vm.fetchTerrain()"><a href ng-click="setTab(9); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Terrains</span> <span class="header_view"></span></a></li><li ng-class="{active:isSet(10)}" ng-click=" vm.fetchRow()"><a href ng-click="setTab(10); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Row</span> <span class="header_view"></span></a></li><li ng-class="{active:isSet(3)}"><a href ng-click="setTab(3);vm.getRouteTask(); search = null" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Tasks</span></a></li><li ng-class="{active:(isSet(4) || isSet(5) || isSet(6) || isSet(7))}"><a href ng-click="setTab(4); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view"> Summary</span></a></li><li ng-class="{active:isSet(8)}"><a href ng-click="setTab(8); search = null" data-toggle="tab"><i class="fa fa-commenting"></i><span class="header-view">Comments</span></a></li><li ng-class="{active:isSet(11)}"><a href ng-click="setTab(11); search = null;vm.createSection()" ng-if="vm.assets.length>0 && vm.surveyPhase==\'SURVEY\'" data-toggle="tab"><i class="fa fa-columns"></i><span class="header-view">Section</span></a></li></ul></div></div><!-- <jhi-alert></jhi-alert> --><!-- <jhi-alert-error></jhi-alert-error> --><div id="loading-bar-spinner" style="display: none;"><div class="spinner-icon"></div></div><div class="box-body" ng-show="isSet(1)"><div class="flexeven mb-5"><a href="javascript:void(0);" ui-sref="tr-route" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><!-- <button class="btn btn-primary pull-right" ng-click="downloadExcelSurveyReport()">\r\n\t\t\t\t\t\t\t<span class="glyphicon glyphicon-download"></span>&nbsp;<span>Download Report</span>\r\n\t\t\t\t\t\t</button> --><div class="dropdown"><button class="btn btn-primary btn-sm dropdown-toggle" id="dropdownMenu" ng-disabled="showDropDown" data-toggle="dropdown" ng-click="vm.showLayers()" title="Layers"><img src="content/images/layerIcon.png" alt="Connect Icon" style="width:20px; height:20px;">&nbsp; <span>Layers</span></button><ul class="dropdown-menu layer-scroll" aria-labelledby="dropdownMenu" style="padding: 10px;"><li style="padding: 0px; text-align: center;"><button class="btn btn-link" ng-click="vm.toggleAllLayers()">{{ vm.toggleCheckAll ? \'Check All\' : \'Uncheck All\' }}</button></li><li class="dropdown-item" ng-repeat="item in vm.layerItems" style="padding: 5px;"><label style="width: 100%; font-family:\'Source Sans Pro\', sans-serif;"><input type="checkbox" ng-model="item.selected" ng-change="vm.updateSelectedLayers()"> {{ item.name }} Layer</label></li><li style="padding: 5px;" ng-if="vm.objectRouteImg.draggedOnce"><label style="width: 100%; font-family:\'Source Sans Pro\', sans-serif;"><input type="checkbox" ng-model="vm.objectRouteImg.hideRoutemarker" ng-change="vm.updateImageMarkerVisibility()"> Media Layer</label></li><li style="padding: 5px;" ng-if="vm.objectRouteImg.draggedOnce"><label style="width: 100%; font-family:\'Source Sans Pro\', sans-serif;"><input type="checkbox" ng-model="vm.objectRouteImg.hidemarker" ng-change="vm.updateMarkerVisibility()"> Marker Layer</label></li></ul></div><button class="btn btn-primary pull-right" ng-click="vm.downloadRouteKml()"><span class="glyphicon glyphicon-download"></span>&nbsp;<span translate="entity.action.downloadkml">Download KML</span></button> <button class="btn btn-primary pull-right" ng-click="vm.downloadGpReport()" ng-if="vm.showRingDetailGpReport"><span class="glyphicon glyphicon-download"></span>&nbsp;<span>GP Report</span></button> <button class="btn btn-primary pull-right" ng-click="vm.downloadJointReport()" ng-if="vm.showRingDetailJointReport"><span class="glyphicon glyphicon-download"></span>&nbsp;<span>Joint Report</span></button> <button class="btn btn-primary pull-left" ng-if="vm.trRoute.id && vm.showRingDetailSurveyReport" ng-click="vm.downloadProjectSurveyExcel(false)"><span class="glyphicon glyphicon-download"></span>&nbsp;<span>Survey Report</span></button> <button class="btn btn-primary pull-left" ng-if="vm.trRoute.id && vm.showRingDetailSurveyReport" ng-click="vm.downloadProjectSurveyExcel(true)"><span class="glyphicon glyphicon-download"></span>&nbsp;<span>Agg Survey Report</span></button> <a ui-sref="tr-route.edit({id:vm.trRoute.id})" class="btn btn-primary btn-sm pull-right" ng-if="Roles.ROUTE_EDIT"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div><div class="row mt-5"><div class="col-md-4"><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.trRoute.name}}</span></dd><dt><span>Route Name</span></dt><dd><span>{{vm.trRoute.routeBundleName}}</span></dd><dt><span>Project Name</span></dt><dd><span>{{vm.trRoute.projectName}}</span></dd><dt><span translate="trakeyeApp.route.description">Description</span></dt><dd><span>{{vm.trRoute.description}}</span></dd><dt><span>Route Length (mtrs)</span></dt><dd><span>{{vm.trRoute.routeLength}}</span></dd><dt><span>Create Date</span></dt><dd><span>{{vm.trRoute.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.route.status">Status</span></dt><dd><span>{{vm.trRoute.status}}</span></dd><dt><span>Phase</span></dt><dd><span>{{vm.trRoute.phase}}</span></dd><!--\r\n\t\t\t\t\t\t\t\t\t<dt>\r\n\t\t\t\t\t\t\t\t\t\t<span translate="trakeyeApp.route.updateDate">Update Date</span>\r\n\t\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t\t\t\t<span>{{vm.trRoute.lastModifiedDate |\r\n\t\t\t\t\t\t\t\t\t\t\tdate:\'medium\'}}</span>\r\n\t\t\t\t\t\t\t\t\t</dd> --><!-- <dt>\r\n\t\t\t\t\t\t\t\t\t\t<span translate="trakeyeApp.route.routeType">Route Type</span>\r\n\t\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t\t\t\t{{vm.trRoute.routeType.name}}\r\n\t\t\t\t\t\t\t\t\t</dd>\r\n\t\t\t\t\t\t\t\t\t<div class="form-group" ng-repeat="attribute in vm.trRoute.routeTypeAttributeValues">\r\n\t\t\t\t\t\t\t\t\t\t<div ng-repeat="attributeValue in vm.trRoute.routeTypeAttributeValues track by $index">\r\n\t\t\t\t\t\t\t\t\t\t\t<div ng-if="attributeValue.routeTypeAttribute.id == attribute.routeTypeAttribute.id">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<dt>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span>{{attribute.routeTypeAttribute.name}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span>{{attributeValue.attributeValue}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</dd>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div> --></dl></div><div class="col-md-8"><div id="map_canvasStart" class="div__map-canvas"></div><!-- <div class="col-md-8 dropFilter pull-left openOptiontop" ng-show="vm.isShowFilter">\r\n\t\t\t\t\t\t\t\t<div isteven-multi-select input-model="vm.mapFilterList" group-property="msGroup"\r\n\t\t\t\t\t\t\t\t\toutput-model="vm.selectedTerrainName" button-label="name"\r\n\t\t\t\t\t\t\t\t\titem-label="name strokeColor" tick-property="visible" translation="type.terrain"\r\n\t\t\t\t\t\t\t\t\toutput-properties="name visible" helper-elements="all none Done filter"\r\n\t\t\t\t\t\t\t\t\ton-select-done="togglePolyline()" max-height="170px" max-labels="1"\r\n\t\t\t\t\t\t\t\t\tdisable-property="routeDisable">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div> --><div class="flex" style="display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 10px;"><div class="col-md-8 dropFilter pull-left openOptiontop mt-5"><div isteven-multi-select input-model="vm.phaseFilter" output-model="vm.selectedPhase" button-label="name" item-label="name strokeColor" tick-property="selected" translation="type.phase" output-properties="name selected" helper-elements="all none Done filter" on-select-done="togglePhase()" max-height="170px" max-labels="1"></div></div><div ng-if="vm.sectionNameResponse.length>0"><button class="btn btn-primary mt-5" ng-click="vm.getSections()">Sections</button></div><div><button class="btn btn-primary mt-5" ng-click="vm.toggleStatistics()">{{ vm.showStatistics ? \'Hide Statistics\' : \'Show Statistics\' }}</button></div><div class="mt-5"><span id="myspan">Zoom : {{vm.objectRouteImg.zoomLevel}}</span></div></div><!-- <div class="pull-left" >\r\n\t\t\t\t\t\t\t\t<span id="noData" ng-hide="vm.zoomLevel >=  14">*Zoom in 14 for Images</span>\r\n\t\t\t\t\t\t\t\t<button class="btn btn-primary btn-sm" ng-click="vm.getRoutePoints()" ng-show="vm.zoomLevel >=  14">\r\n\t\t\t\t\t\t\t\t\t<span> Image List </span>\r\n\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t</div>  --></div></div><!-- <div class="box-header">\r\n\t\t\t\t\t\t<div class="col-md-5 col-sm-3" >\r\n\t\t\t\t\t\t\t<ul class="nav nav-pills nav-justified">\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</ul>\r\n\t\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div> --><div class="box-body chart-responsive mt-10" style="text-align:center;" ng-show="vm.showStatistics"><!-- Flex container --><div style="display: flex; align-items: center; justify-content: space-between;"><!-- Left: Filter --><div style="flex: 1; text-align: left;"><label for="userFilter">Select User</label> <select id="userFilter" ng-click="vm.filterRouteStatus()"><option value="All">All</option></select></div><!-- Center: Heading --><div style="flex: 1; text-align: center;"><h3 class="mb-5" style="margin: 0;">Data Statistics</h3></div><!-- Right: Empty (for spacing balance) --><div style="flex: 1;"></div></div><!-- Chart --><div id="sync-chart" class="mt-5" style="min-height: 300px; position: relative; overflow-x:auto;"></div></div></div><div class="box-body p2" ng-show="isSet(2)"><div class="flex" style="display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 10px;"><div style="display: flex; align-items: center; gap: 10px;"><span id="myspan">Section under Route</span><div class="input-group" style="margin: 0;"><input type="text" ng-model="search" class="form-control" placeholder="Search Section..." ng-minlength="3"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-create btn-sm" ui-sref="tr-section.new({routeId:vm.trRoute.id})" title="Create Section" ng-if="Roles.SECTION_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Section</span></button></div><div class="col-md-4"><div class="table-responsive"><div class="scroll_table"><table class="jh-table table table-responsive table-hover"><thead style="width:100%" class="bg-default"><tr><th>Sl No</th><th>Section</th><th>Task</th><th>Worked-Length(mtrs)</th><th>Total-Length(mtrs)</th><th>Obstacle-Length(mtrs)</th><th>Vendor</th><th>Start</th><th>End</th></tr></thead><tbody colspan="12"><tr ng-repeat="task in vm.mergedArray| orderBy:\'-totalLength\'"><td>{{$index+1}}</td><td>{{task.sectionName}}</td><td>{{task.TaskName}}</td><td>{{task.totalLength}}</td><td>{{task.taskLength}}</td><td>{{task.obstacleLength}}</td><td>{{task.vendorName}}</td><td>{{task.fromLatlng}}</td><td>{{task.toLatlng}}</td></tr></tbody></table></div></div></div><div class="col-md-8" style="padding: 0px;"><div id="SectionMap_canvasStart" class="div__map-canvas"></div></div><div><ul class="legends pull-right"><li><span class="barSquare" style="background-color:#c89f9c ;stroke-opacity: 0.4;"></span> WORK NOT STARTED</li><li><span class="barSquare" style="background-color:#00e658;"></span> WORK-PROGRESSED</li><li><span class="barSquare" style="background-color:#ff0000;"></span> OBSTACLE</li></ul></div><div class="material_Scroll"><div class="material-header"><h3 ng-if="vm.tasksWithMaterials.length > 0">Cumulative Material List for Route &nbsp; <i class="fa fa-download" aria-hidden="true" ng-click="vm.downloadMaterialTnx()" ng-if="vm.showRingDetailSummaryTabMxDownload" title="Download Material Summary"></i></h3></div><table class="jh-table table table-responsive table-hover" ng-if="vm.tasksWithMaterials.length > 0"><thead class="bg-default"><tr><th>Sl No</th><th>Section Name</th><th>Task Name</th><th>Material Name</th><th>Unit</th><th>Requested</th><th>Received</th><th>Utilized</th><th>Reconciled</th></tr></thead><tbody><tr ng-repeat="material in vm.tasksWithMaterials track by $index"><td>{{ $index + 1 }}</td><td>{{ material.sectionName }}</td><td>{{ material.TaskName }}</td><td>{{ material.materialName }}</td><td ng-if=" material.unitOfMeasurementName==\'Length\'">Meter</td><td ng-if=" material.unitOfMeasurementName==\'Count\'">Number</td><td>{{ material.Requested || 0 }}</td><td>{{ material.Received || 0 }}</td><td>{{ material.Utilized || 0 }}</td><td>{{ material.Reconciled || 0 }}</td></tr></tbody></table></div></div><div class="box-body" ng-show="isSet(9)"><div class="flex" style="display: flex; align-items: center; justify-content: space-between; gap: 10px;"><div style="display: flex; align-items: center;"><span id="myspan">Terrain Under Route</span><div class="input-group" style="margin: 0;"><input type="text" ng-model="search" class="form-control" placeholder="Search Terrains..." ng-minlength="3"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-create btn-sm" ui-sref="tr-terrain.new({routeId:vm.trRoute.id})" title="Create Terrain" ng-if="Roles.TERRAIN_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Terrain</span></button></div><div class="row mt-5"><div class="table-responsive col-md-4"><div class="scroll_table"><table class="jh-table table table-striped table-hover fitContentTable"><thead class="bg-default"><tr><th>Terrain Name</th><th>Length (m)</th><th>Verified</th><th>Deviation</th><th>Actions</th><th><i class="fa fa-filter" style="cursor: pointer;" ng-click="vm.isFilterMenuOpen = !vm.isFilterMenuOpen"></i></th></tr></thead><tbody><tr id="terrain-{{terrain.id}}" ng-repeat="terrain in vm.filteredTerrainList | filter:search | orderBy:\'name\'" ng-mouseenter="vm.highlightTerrain(terrain.id)" ng-mouseleave="vm.resetTerrain()"><td><a ui-sref="tr-terrain-detail({id: terrain.id})">{{ terrain.name }}</a></td><td>{{ terrain.length | number: 2 }}</td><td>{{ terrain.isVerified ? \'YES\' : \'NO\' }}</td><td>{{ terrain.isDeviated ? \'YES\' : \'NO\' }}</td><td><a ui-sref="tr-terrain.edit({id: terrain.id})" class="action-icons text-primary" title="Edit" ng-if="Roles.TERRAIN_CREATE"><i class="fa fa-pencil-square"></i></a></td></tr><tr ng-if="vm.filteredTerrainList.length == 0"><td colspan="5" class="text-center"><h4>No Terrain Available</h4></td></tr></tbody></table></div><div class="pull-left" ng-if="vm.totalTerrain"><span id="myspan">Total Terrain Length : {{vm.totalTerrain|number:1}}mtrs</span></div><div class="filter-menu" ng-show="vm.isFilterMenuOpen"><ul><li><label>Phase</label></li><li ng-repeat="phase in vm.uniquePhases"><input type="checkbox" ng-model="phase.selected" ng-change="vm.updateTerrainTypes()"> {{ phase.phase }}</li></ul><ul><li><label>Verified Status</label></li><li><input type="checkbox" ng-model="vm.isVerifiedFilter" ng-change="vm.updateTerrainTypes()"> Verified <input type="checkbox" ng-model="vm.isNotVerifiedFilter" ng-change="vm.updateTerrainTypes()"> Not Verified</li></ul><ul><li><label>Deviated</label></li><li><input type="checkbox" ng-model="vm.isDeviatedFilter" ng-change="vm.updateTerrainTypes()"> Deviated</li></ul><ul><li ng-if="vm.uniqueTerrainTypes.length > 0"><label>Terrain Type</label></li><li ng-repeat="terrainType in vm.uniqueTerrainTypes"><input type="checkbox" ng-model="terrainType.selected"> {{ terrainType.typeName }} <span class="color-box" ng-style="{ \'background-color\': terrainType.colorcode }"></span></li></ul><div class="filter-menu-buttons"><button class="btn btn-secondary" ng-click="vm.closeFilters()">Close</button> <button class="btn btn-secondary" ng-click="vm.resetFilters()"><i class="fa fa-refresh"></i></button> <button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="!vm.areFiltersSelected()">Filter</button></div></div></div><div class="col-md-8" style="padding: 0px;" ng-if="vm.terrainListResponse.length>0"><div id="map_canvasStarts" class="div__map-canvas"></div></div><div><ul class="legends pull-left"><!-- <li ng-if="vm.totalTerrain>0"><span>\r\n\t\t\t\t\t\t\t\t\t\tTotal Terrain Length :\r\n\t\t\t\t\t\t\t\t\t\t{{vm.totalTerrain|number:1}}mtrs\r\n\t\t\t\t\t\t\t\t\t</span></li> --><li ng-if="vm.plannedPathLength>0"><span>Planned Route Length : {{vm.plannedPathLength|number:1}}mtrs</span></li><li ng-if="vm.proposedPathLength>0"><span>Survey Route Length : {{vm.proposedPathLength|number:1}}mtrs</span></li></ul></div></div><!-- <div class="flex-container">\r\n\t\t\t\t\t\t<ul class="list-inline">\r\n\t\t\t\t\t\t\t<li ng-repeat="terrain in vm.uniqueTerrainTypes" class="list-inline-item">\r\n\t\t\t\t\t\t\t\t{{ terrain.typeName }}\r\n\t\t\t\t\t\t\t\t<span class="color-box"\r\n\t\t\t\t\t\t\t\t\tng-style="{ \'background-color\': vm.terrainTypeColors[terrain.typeName] }"></span>\r\n\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t</div> --></div><div class="box-body" ng-show="isSet(10)"><div class="flex" style="display: flex; align-items: center; justify-content: space-between; gap: 10px;"><div style="display: flex; align-items: center; gap: 10px;"><span id="myspan" style="margin: 0;">Row Under Route</span><div class="input-group" style="margin: 0;"><input type="text" ng-model="search" class="form-control" placeholder="Search Rows..." ng-minlength="3"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></div><button class="btn btn-create btn-sm" ui-sref="tr-row.new({routeId:vm.trRoute.id})" title="Create Terrain" ng-if="Roles.TERRAIN_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Row</span></button></div><div class="row mt-5"><div class="table-responsive col-md-4"><div class="scroll_table"><table class="jh-table table table-responsive table-hover fitContentTable"><thead class="bg-default"><tr><th>Row Name</th><th>Length(mtrs)</th><!-- <th>VerifiedBy</th> --><th>Verified</th><th>Deviation</th><th>Actions</th><th><span class="fa fa-filter" style="font-size: 20px;" ng-click="vm.toggleFilterMenu()"></span></th></tr></thead><tbody><tr id="row-{{row.id}}" ng-repeat="row in  vm.filteredRowList | filter:search| orderBy:\'name\'" ng-mouseenter="vm.highlightRow(row.id)" ng-mouseleave="vm.resetRow()"><td><a ui-sref="tr-row-detail({id:row.id})">{{row.name}}</a></td><td>{{row.length|number:2}}</td><!-- <td>{{row.verifiedBy}}</td> --><td ng-if="row.isVerified==true">YES</td><td ng-if="row.isVerified==false||row.isVerified==null">NO</td><td ng-if="row.isDeviated==true">YES</td><td ng-if="row.isDeviated==false||row.isDeviated==null">NO</td><td><a ui-sref="tr-row.edit({id:row.id })" class="action-icons text-primary" title="Edit" ng-if="Roles.ROW_CREATE"><span class="fa fa-pencil-square"></span></a></td><td></td></tr><tr><td colspan="2" ng-show="vm.rowListResponse.length == 0"><h4>No Row available</h4></td></tr></tbody></table></div><div class="pull-left" ng-if="vm.totalRow"><span id="myspan">Total Row Length : {{vm.totalRow|number:1}}mtrs</span></div><div ng-show="vm.isFilterMenuOpen" class="filter-menu"><ul><li><label>Phase</label></li><li ng-repeat="phase in vm.uniquePhases"><input type="checkbox" ng-model="phase.selected" ng-change="vm.updateRowTypes()">{{phase.phase}}</li></ul><ul></ul><li><label>Verified Status</label></li><li><input type="checkbox" ng-model="vm.isVerifiedFilter" ng-change="vm.updateRowTypes()"> Verified <input type="checkbox" ng-model="vm.isNotVerifiedFilter" ng-change="vm.updateRowTypes()"> Not Verified</li><ul><li><label>Deviated</label></li><li><input type="checkbox" ng-model="vm.isDeviatedFilter" ng-change="vm.updateRowTypes()"> Deviated</li></ul><ul><li><label for="" ng-if="vm.uniqueRowTypes.length>0">Row Type</label></li><li ng-repeat="rowType in vm.uniqueRowTypes"><input type="checkbox" ng-model="rowType.selected"> {{ rowType.typeName }} <span class="color-box" ng-style="{ \'background-color\': rowType.colorcode}"></span></li></ul><div class="filter-menu-buttons"><button class="btn btn-secondary" ng-click="vm.closeFilters()">Close</button> <button class="btn btn-secondary" ng-click="vm.resetFilters()"><span class="fa fa-refresh"></span></button> <button class="btn btn-primary" ng-click="vm.applyFilters()" ng-disabled="!vm.areFiltersSelected()">Filter</button></div></div></div><div class="col-md-8" style="padding: 0px;" ng-if="vm.rowListResponse.length>0"><div id="map_canvasStartss" class="div__map-canvas"></div></div><div><ul class="legends pull-left"><!-- <li ng-if="vm.totalRow>0"><span>\r\n\t\t\t\t\t\t\t\t\t\tTotal Row Length :\r\n\t\t\t\t\t\t\t\t\t\t{{vm.totalRow|number:1}}mtrs\r\n\t\t\t\t\t\t\t\t\t</span></li> --><li ng-if="vm.plannedPathLength>0"><span>Planned Route Length : {{vm.plannedPathLength|number:1}}mtrs</span></li><li ng-if="vm.proposedPathLength>0"><span>Survey Route Length : {{vm.proposedPathLength|number:1}}mtrs</span></li></ul></div></div><!-- <div class="flex-container"></div>\r\n\t\t\t\t\t\t<ul class="list-inline">\r\n\t\t\t\t\t\t\t<li ng-repeat="row in vm.uniqueRowTypes" class="list-inline-item">\r\n\t\t\t\t\t\t\t\t{{ row.typeName }}\r\n\t\t\t\t\t\t\t\t<span class="color-box"\r\n\t\t\t\t\t\t\t\t\tng-style="{ \'background-color\': vm.rowTypeColors[row.typeName] }"></span>\r\n\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t</div> --></div><div class="box-body" ng-show="isSet(11)"><div class="flex" style="display: flex; justify-content: flex-start; align-items: center; gap: 10px; margin-left: 10px;"><div isteven-multi-select input-model="vm.ofcFilterOptions" output-model="vm.selectedOFCFilters" button-label="name" item-label="name" tick-property="selected" helper-elements="all none" on-close="vm.applyOFCFilter()" translation="type.phase" max-height="170px" max-labels="1" style="white-space: normal; line-height: 1.5em; display: block; word-wrap: break-word;"></div><button ng-if="vm.sectionNameResponse.length > 0" class="btn btn-primary btn-sm mb-5" ng-click="vm.getSections()">Sections</button></div><div id="create_section_map" class="div__map-canvas" style="width: 100%;"></div><div class="box-footer"><div class="row save-buttons" style="display: flex; justify-content: space-between;"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-route"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary btn-sm" ng-click="vm.sectionSave()"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form ng-show="isSet(10)|| isSet(9)|| isSet(1)" name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.showZoomLocation()" show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label"><span translate=" ">Enter the co-ordinates :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLat" id="field_pinLat" ng-model="vm.getLocationCoordinate" required></div></div><!--  <div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span translate=" ">Longitude :</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n\t\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="number" class="form-control" placeholder="enter the co-ordinates" name="pinLat" id="field_pinLat"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-model="vm.pinLatLong" required />\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">OK</button></div></form><!-- <form ng-show="isSet(3)" name="editForm" role="form" class="form-horizontal" novalidate\r\n\t\t\t\t\t\t\t\t\tng-submit="vm.showZoomLocationCity()" show-validation>\r\n\t\t\t\t\t\t\t\t\t<div class="modal-body">\r\n\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span translate=" ">Pin Lat</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n\t\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="number" class="form-control" name="pinLat" id="field_pinLat"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-model="vm.pinLatitude" required />\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span translate=" ">Pin Long</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n\t\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="number" class="form-control" name="pinLat" id="field_pinLat"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-model="vm.pinLatLong" required />\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class="modal-footer">\r\n\t\t\t\t\t\t\t\t\t\t<button type="button" class="btn btn-default" data-dismiss="modal"\r\n\t\t\t\t\t\t\t\t\t\t\tng-click="vm.closeGotoLatituteCity()">\r\n\t\t\t\t\t\t\t\t\t\t\tCancel\r\n\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\t<button type="submit" class="btn btn-primary" ng-disabled="vm.isShowing">\r\n\t\t\t\t\t\t\t\t\t\t\tOK\r\n\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</form> --></div></div></div><div class="box-body" ng-show="isSet(3)"><button class="btn btn-create btn-sm" ui-sref="tr-task.new({routeId:vm.trRoute.id, sectionId : null})" title="Create Task" ng-if="Roles.TASK_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Task</span></button><div class="table-responsive"><h3>Task Details</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Name</th><th>Type</th><th>Status</th><!-- <th>Route</th> --><!--  <th>Section</th>  --><!-- <th ng-if="Roles.DAILYLOG_CREATE">Daily Task Logs</th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="task in  vm.taskResponse"><td><a ui-sref="tr-task-detail({id:task.id})">{{task.name}}</a></td><td>{{task.taskType.name}}</td><td>{{task.status}}</td><!-- <td>{{task.routeTask[0].routeId}}</td> --><!-- <td>{{task.sectionTask[0].sectionId}}</td> --><!-- <td ng-if="Roles.DAILYLOG_CREATE"> <a ui-sref="task-log.dialog({taskId:task.id, sectionId : task.sectionTask[0].sectionId, routeId : task.routeTask[0].routeId })"\r\n                                        class="action-icons text-primary" title="Create">\r\n                                        <span class="glyphicon glyphicon-plus"></span>\r\n                                    </a></td> --><td><div class="action"><a ui-sref="tr-task-detail({id:task.id})" class="action-icons text-info" title="View" ng-if="Roles.TASK_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-task.edit({id:task.id})" class="action-icons text-primary" title="Edit" ng-if="Roles.TASK_EDIT"><span class="fa fa-pencil-square"></span></a></div></td></tr><td colspan="2" ng-show="vm.taskResponse.length == 0"><h4>No Tasks available</h4></td></tbody></table></div></div><div class="mt-10" ng-show="isSet(4) || isSet(5) ||isSet(6) || isSet(7) "><div class="col-md-3 col-sm-3" style="padding: 5px;\r\n\t\t\t\t\tmargin: 5px;"><ul class="nav nav-pills"><li ng-class="{active:isSet(4) || isSet(7) || isSet(3)}"><a href ng-click="setTab(4); search = null;" data-toggle="tab"><span class="header-view">Task</span> <!-- <span\r\n\t\t\t\t\t\t\t\t\t\tclass="header_view">Log</span> --></a></li><li ng-class="{active:isSet(5)}"><a href ng-click="setTab(5); search = null" data-toggle="tab"><span class="header-view">Material</span></a></li><li ng-class="{active:isSet(6)}"><a href ng-click="setTab(6); search = null" data-toggle="tab"><span class="header-view">Resource</span></a></li></ul></div></div><comments obj="vm.objectComments" ng-if="isSet(8)"></comments><br><br><br><!-- <div class="mt-10 col-md-6 col-sm-3" ng-show=" isSet(4) || isSet(7)">\r\n\t<div  style="\r\n\tpadding: 5px;\r\n\tmargin: 5px;\r\n">\r\n\t\t<ul class="nav nav-pills">\r\n\t\t\t<li ng-class="{active:isSet(4) || isSet(3)}" ng-show="vm.dailyLogsTxSummary.routeTasks.length">\r\n\t\t\t\t<a href ng-click="setTab(4); search = null;" data-toggle="tab"><span class="header-view">Route</span></a>\r\n\t\t\t</li>\r\n\t\t\t<li ng-class="{active:isSet(7)}" ng-show="vm.dailyLogsTxSummary.sectionTasks.length">\r\n\t\t\t\t<a href ng-click="setTab(7); search = null" data-toggle="tab"><span class="header-view">Section</span></a>\r\n\t\t\t</li>\r\n\t\t</ul>\r\n\r\n\t</div>\r\n</div> --><div class="col-sm-12" ng-show="isSet(7)"><!-- <button class="btn btn-primary center-block" ng-click="getPdf()" ng-if=\'vm.isReportGenerated==true\' style="margin: 10px;"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="generatedHtmlContainer" style="width: calc(100% - 40px);overflow-x: auto;overflow-y: hidden;"></div></div><div class="table-responsive col-md-8 mt-10" ng-show="isSet(4)"><h3>Logs Under Route</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Name</th><th>Total Work Length (mtrs)</th><th>Total Number of Hours</th><th>Log Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsTxSummary.routeTasks"><td><a ui-sref="tr-task-detail({id:task.taskId})" target="_blank">{{task.taskId}}</a></td><td>{{task.taskName}}</td><td>{{task.workLength}}</td><td>{{task.noOfHours}}</td><td>{{task.taskLogType}}</td></tr><td colspan="2" ng-show="vm.dailyLogsTxSummary.routeTasks.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="table-responsive col-md-8 mt-10" ng-show="isSet(7)"><h3>Logs Under Sections</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Name</th><th>Total Work Length (mtrs)</th><th>Total Number of Hours</th><th>Log Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsTxSummary.sectionTasks"><td><a ui-sref="tr-task-detail({id:task.taskId})" target="_blank">{{task.taskId}}</a></td><td>{{task.taskName}}</td><td>{{task.workLength}}</td><td>{{task.noOfHours}}</td><td>{{task.taskLogType}}</td></tr><td colspan="2" ng-show="vm.dailyLogsTxSummary.sectionTasks.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="table-responsive mt-10" ng-show="isSet(5)"><h3>Summary &nbsp; <i class="fa fa-download" aria-hidden="true" ng-click="vm.downloadMaterial()" ng-if="vm.showRingDetailSummaryTabMxDownload" title="Download Material Summary"></i></h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th>ID</th> --><th>Name</th><th>Units of Measurement</th><th>Quantity</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.mtrlTxSummary"><!-- <td>\r\n\t\t\t\t\t\t\t\t\t{{task.materialId}}\r\n\t\t\t\t\t\t\t\t</td> --><td>{{task.materialName}}</td><td>{{task.unitOfMeasurementName}}</td><td>{{task.totalNoOfUnits}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="vm.mtrlTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table><div class="table-responsive mt-10"><h3>Material Inventory Transaction</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th></th><th>Date</th><th>Total</th></tr></thead><tbody><tr ng-repeat-start="task in vm.materialByDate"><td class="td__listViewRow" ng-click="vm.toggleExpand(task)" expand><span ng-if="!task.isExpand" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true" ng-click="vm.loadMaterialTxnByDates(task.timestamp)"></i> </span><span ng-if="task.isExpand" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{task.timestamp | date:\'dd-MM-yyyy\'}}</td><td>{{task.total}}</td></tr><tr ng-if="task.isExpand"><td></td><td colspan="4"><table class="table__userNames"><thead><tr><th>SlNo</th><th>Date</th><th>Material-ID</th><th>Material-Name</th><th>Transaction-Id</th><th>No of Units</th><th>Transaction-Type</th></tr></thead><tbody><tr ng-repeat="detail in vm.materialTxnByDates"><td>{{$index + 1}}</td><td>{{detail.timestamp | date:\'dd-MM-yyyy\'}}</td><td>{{detail.materialId}}</td><td>{{detail.transactionName}}</td><td><a>{{detail.transactionId}}</a></td><td>{{detail.count}}</td><td>{{detail.status}}</td></tr><tr><td colspan="7"><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadMaterialTxnByDates(task.timestamp)"></uib-pagination></div></div></div></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr ng-show="vm.materialByDate.length == 0"><td colspan="3"><h4>No Transaction Available</h4></td></tr></tbody></table><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.mtrpage" total="vm.QueryCount" items-per-page="vm.mtrPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.TotalItems" ng-model="vm.mtrpage" ng-change="vm.loadMaterialTxnDate()"></uib-pagination></div></div></div></div></div><div class="table-responsive mt-10" ng-show="isSet(6)"><h3>Summary &nbsp; <i class="fa fa-download" aria-hidden="true" ng-click="vm.downloadResource()" ng-if="vm.showRingDetailSummaryTabRxDownload" title="Download Resource Summary"></i></h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th>ID</th> --><th>Name</th><th>Total no of Resources</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.resTxSummary"><!-- <td>\r\n\t\t\t\t\t\t\t\t\t{{task.materialId}}\r\n\t\t\t\t\t\t\t\t</td> --><td>{{task.resourceName}}</td><td>{{task.totalNoOfResources}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="vm.resTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table></div></div></div></div></div><route-image obj="vm.objectRouteImg"></route-image><div id="modalAssetAttributes" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameAssetAttributes" class="span__modal-header">Asset Attributes</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeAssetAttributesModal()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body" style="overflow-y: scroll; height: 80vh"><div id="assetAttributeTable"></div></div></form></div></div></div><div class="modal fade" id="modalAttachments" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="closeModal(\'modalAttachments\')"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">{{imgName}} - {{imgLatitude}},{{imgLongitude}}</span></div><form name="editForm" class="form-horizontal"><div class="modal-body" style="overflow-y: scroll;overflow-x: hidden;height: 40vh"><!-- <script src="https://aframe.io/releases/1.2.0/aframe.min.js"></script> --><div class="form-group"><!--  <jhi-alert-error></jhi-alert-error> --><div class="col-md-8 mt-5"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                                margin-right: auto;"><tr><th>Name</th><th>Created Date</th><th>Created By</th></tr><tr ng-repeat="image in nameImages"><td ng-click="vm.newTabDisplay(image.rID,image.imageId,image.imageType);closeModal(\'modalAttachments\')" style="color: #3c8dbc;"><span ng-if="image.imageName != null">{{image.imageName}}</span> <span ng-if="image.imageName == null">Image</span></td><td>{{image.createdDate | date:\'medium\'}}</td><td>{{image.createdBy}}</td></tr></table></div></div></div></form></div></div></div><div id="mediaModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog modal-lg" role="document" style="max-width: 80%; width:auto"><div class="modal-content"><div class="modal-header" style="display: flex; justify-content: flex-end; align-items: center; height: 60px; position: relative;"><h5 class="modal-title" style="flex-grow: 1;">Media Player</h5><div class="modal-controls" style="display: flex; align-items: center;"><button id="maximizeBtn" type="button" style="border:none"><span class="fa fa-window-maximize" aria-hidden="true"></span></button> <button id="minimizeBtn" type="button" style="display:none;border:none"><span class="fa fa-window-minimize" aria-hidden="true"></span></button> <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="margin-left: 10px;"><span aria-hidden="true">&times;</span></button></div></div><div class="modal-body" id="mediaModalContent" style="text-align: center; background-color: white;"></div></div></div></div><div class="modal fade" id="imageCarouselModal" tabindex="-1" role="dialog"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header ml-3" style="display: flex;"><h5 class="modal-title">{{vm.assetName}}-{{vm.assetTypeName}}</h5><div class="carousel-downloads"><button class="btn btn-primary btn-sm" onclick="downloadCurrentImage()">Download File</button> <button class="btn btn-primary btn-sm" onclick="downloadAllImages()">Download All</button></div><button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="closeCarousel()"><span aria-hidden="true">&times;</span></button></div><div id="loading-bar-spinner" style="display: none;"><div class="spinner-icon"></div></div><div class="modal-body text-center"><div class="position-relative d-flex justify-content-center align-items-center"><i class="fa fa-arrow-left nav-button prevs" onclick="changeImage(-1)" aria-hidden="true" style="font-size: 2rem; cursor: pointer;"></i><div id="carouselDisplayContainers" class="carousel-displays mx-3"></div><i class="fa fa-arrow-right nav-button nexts" onclick="changeImage(1)" aria-hidden="true" style="font-size: 2rem; cursor: pointer;"></i></div><div class="carousel-thumbnails mt-3 d-flex justify-content-start overflow-auto" style="white-space: nowrap; max-width: 100%;" id="carouselThumbnails"></div></div></div></div></div><!--Modal for editing survey path--><div id="editSurveyPath" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90vw" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span class="span__header">Edit Survey Path</span><div style="display: flex; align-items: center; justify-content: flex-end; gap: 10px; margin-right: 20px; flex-wrap: wrap; font-family:\'Source Sans Pro\', sans-serif;"><!-- <label style="margin: 0;">\r\n\t\t\t\t\t\t<input id="toggleGpAssetsCheckbox" type="checkbox" ng-click="vm.toggleGpAssets()"\r\n\t\t\t\t\t\t\tng-checked="vm.gpAssetsVisible" />\r\n\t\t\t\t\t\t{{ vm.gpAssetsVisible ? \'Show Markers\' : \'Hide Markers\' }}\r\n\t\t\t\t\t</label> --><div class="dropdown"><button class="btn btn-primary btn-sm dropdown-toggle" id="dropdownMenu" ng-disabled="showDropDown" data-toggle="dropdown" title="Layers"><img src="content/images/layerIcon.png" alt="Connect Icon" style="width:20px; height:20px;">&nbsp; <span>Layers</span></button><ul class="dropdown-menu layer-scroll" aria-labelledby="dropdownMenu" style="padding: 10px;"><li style="padding: 5px;" ng-if="vm.objectRouteImg.draggedOnce"><label style="width: 100%; font-family:\'Source Sans Pro\', sans-serif;"><input type="checkbox" ng-model="vm.objectRouteImg.hideRoutemarker" ng-change="vm.updatePlanedPathVisibilitysuveyEdit()"> Marker Layer</label></li><li style="padding: 5px;" ng-if="vm.objectRouteImg.draggedOnce"><label style="width: 100%; font-family:\'Source Sans Pro\', sans-serif;"><input type="checkbox" ng-model="vm.objectRouteImg.hidemarker" ng-change="vm.updateMarkerVisibilitySurveyEdit()"> Planned path Layer</label></li><li style="padding: 5px;" ng-if="vm.objectRouteImg.draggedOnce"><label style="width: 100%; font-family:\'Source Sans Pro\', sans-serif;"><input type="checkbox" ng-model="vm.objectRouteImg.hidesurveyRoutemarker" ng-change="vm.updateRouteMarkerVisibilitySurveyEdit()"> Route and media Markers</label></li></ul></div><button class="btn btn-primary btn-flat" ng-click="vm.toggleDrawingPath()"><b>{{ vm.drawingPolyline ? \'Finish\' : \'Draw Path\' }}</b></button> <button class="btn btn-warning btn-flat" ng-click="vm.undoLastPoint()" ng-disabled="vm.drawCoordinates.length === 0"><b>Undo Marker</b></button> <button class="btn btn-danger btn-flat" ng-click="vm.resetDrawing()" ng-disabled="!vm.drawingPolyline"><b>Reset</b></button> <button class="btn btn-info btn-flat" ng-click="vm.saveEditSurveyPath()"><b>Save</b></button> <button type="button" class="close" ng-click="vm.returnToHome()" style="font-size: 24px; line-height: 1;"><span aria-hidden="true">&times;</span></button></div></div><div style="width: 100%; height: 80vh;" class="modal-body"><div class="row"><div class="col-md-12"><div id="map_canvas_edit_survey_path" style="height: 78vh;"></div></div></div></div></div></div></div><div class="modal fade" id="showRingsSections" tabindex="-1" role="dialog"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header ml-3" style="display: flex;"><h5 class="modal-title">Section List</h5><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="margin-left: auto;"><span aria-hidden="true">&times;</span></button></div><div id="loading-bar-spinner" style="display: none;"><div class="spinner-icon"></div></div><div class="modal-body"><div ng-if="vm.sectionNameResponse.length"><div class="table-responsive"><table class="jh-table table table-hover"><thead class="bg-default"><tr><th>Name</th><th>Length</th><th>Status</th><th>Phase</th></tr></thead><tbody><tr ng-repeat="section in vm.sectionNameResponse"><td><a ui-sref="tr-section-detail({id:section.id})">{{section.name}}</a></td><td>{{section.sectionLength}} mtrs</td><td>{{section.status}}</td><td>{{section.phase}}</td></tr></tbody></table></div></div><div ng-if="!vm.sectionNameResponse.length"><h4>No Section available</h4></div></div></div></div></div><!-- Confirmation Modal --><div id="confirmModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog modal-sm" role="document"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">Confirm Terrain And ROW</h4></div><div class="modal-body"><p>Do you want to create terrain and row?</p></div><div class="modal-footer"><button type="button" class="btn btn-create btn-sm" ng-click="vm.returnToHome()">No</button> <button type="button" class="btn btn-info btn-flat" ng-click="vm.createTerrainRow()">Yes</button></div></div></div></div><!-- terrain row --><div id="terrainRow" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="terrainRowLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header bg-primary text-white"><h4 class="modal-title" id="terrainRowLabel"><i class="fa fa-map-marker"></i> Terrain & Row Details</h4><button type="button" class="close text-white" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><!-- Terrain Form --><form name="editForm" class="form-horizontal" role="form" novalidate><div class="box-body"><h5 class="text-primary"><strong>Terrain Details</strong></h5><hr><div class="form-group row"><label class="col-md-3 col-form-label">Terrain Type <sup><i class="fa fa-asterisk text-danger"></i></sup></label><div class="col-md-7"><select class="form-control select2" name="terrainType" ng-model="vm.terrainType" ng-options="item as item.name for item in vm.terrainTypes track by item.id" ng-disabled="vm.trTerrain.id != null" required><option value="" disabled="disabled">--- Select TerrainType ---</option></select></div></div></div></form><!-- Row Form --><form name="editForm2" class="form-horizontal mt-4" role="form" novalidate><div class="box-body"><h5 class="text-primary"><strong>Row Details</strong></h5><hr><div class="form-group row"><label class="col-md-3 col-form-label">Row Type <sup><i class="fa fa-asterisk text-danger"></i></sup></label><div class="col-md-7"><select class="form-control select2" name="rowType" ng-model="vm.rowType" ng-options="item as item.name for item in vm.rowTypes track by item.id" ng-disabled="vm.trRow.id != null" required><option value="" disabled="disabled">--- Select RowType ---</option></select></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-create btn-sm" ng-click="vm.returnToHome()"><i class="fa fa-times"></i> Cancel</button> <button type="button" class="btn btn-info btn-flat" ng-click="vm.saveTerrainRow()"><i class="fa fa-check"></i> Save</button></div></div></div></div>');
$templateCache.put('app/entities/tr-route/tr-route-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrRouteLabel"><span ng-if="!vm.trRoute.id" translate="trakeyeApp.route.home.create">Create</span> <span ng-if="vm.trRoute.id">Edit Ring</span></h3><div class="box-tools route_labels" ng-show="vm.projects.length"><span class="btn btn-create btn-sm" ng-click="vm.openImport()" ng-if="!vm.trRoute.id"><span class="glyphicon glyphicon-plus"></span> <span>Import</span></span></div></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body" ng-show="vm.projects.length"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span>Select Project</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.trRoute.projectId" ng-options="item.id as item.name for item in vm.projects" required><option value="">--- Select Project ---</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.route.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trRoute.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.route.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trRoute.description"></textarea></div></div><!--  <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span translate="trakeyeApp.route.routeType">routeType</span>\r\n                                    <sup><span class="required-icon"><i\r\n                                                class="fa fa-asterisk text-danger"></i></span></sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <select class="form-control select2" name="routeType" ng-model="vm.routeType"\r\n                                        ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                        vm.routeTypes track by item.id" ng-disabled="vm.trRoute.id!=null" required\r\n                                        style="width: 100%">\r\n                                        <option value="" translate="trakeyeApp.route.selectroute">\r\n                                            --- Select RouteType ---\r\n                                        </option>\r\n                                    </select>\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group"\r\n                                ng-repeat="attribute in vm.trRoute.routeTypeAttributeValues track by $index">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>{{attribute.routeTypeAttribute.name}}</span>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <input ng-model="vm.trRoute.routeTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.routeTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trRoute.id"\r\n                                        type="text" class="form-control"\r\n                                        ng-init="vm.trRoute.routeTypeAttributeValues[$index].attributeValue = attribute.routeTypeAttribute.defaultValue"\r\n                                        name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" />\r\n                                    <input ng-model="vm.trRoute.routeTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.routeTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.trRoute.id"\r\n                                        type="text" class="form-control" name="value{{$index+1}}"\r\n                                        ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" />\r\n                                    <span ng-if="attribute.routeTypeAttribute.attributeDataType.name == \'FLOAT\'"\r\n                                        ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">\r\n                                        Enter a Valid Number (Ex:1.00)</span>\r\n\r\n                                    <input ng-model="vm.trRoute.routeTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.routeTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trRoute.id"\r\n                                        type="text" class="form-control"\r\n                                        ng-init="vm.trRoute.routeTypeAttributeValues[$index].attributeValue = attribute.routeTypeAttribute.defaultValue"\r\n                                        name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/" />\r\n                                    <input ng-model="vm.trRoute.routeTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.routeTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trRoute.id"\r\n                                        type="text" class="form-control" name="value{{$index+1}}"\r\n                                        ng-pattern="/^[0-9]{1,7}$/" />\r\n                                    <span ng-if="attribute.routeTypeAttribute.attributeDataType.name == \'INTEGER\'"\r\n                                        ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">\r\n                                        Enter a Valid Number\r\n                                    </span>\r\n\r\n                                    <input ng-model="vm.trRoute.routeTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.routeTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trRoute.id"\r\n                                        type="text" class="form-control"\r\n                                        ng-init="vm.trRoute.routeTypeAttributeValues[$index].attributeValue = attribute.routeTypeAttribute.defaultValue"\r\n                                        name="value{{$index+1}}" />\r\n                                    <input ng-model="vm.trRoute.routeTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.routeTypeAttribute.attributeDataType.name == \'STRING\' && vm.trRoute.id"\r\n                                        type="text" class="form-control" name="value{{$index+1}}" />\r\n                                    <span ng-if="attribute.routeTypeAttribute.attributeDataType.name == \'STRING\'"\r\n                                        ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">\r\n                                        Enter a Message</span>\r\n\r\n                                    <select ng-model="vm.trRoute.routeTypeAttributeValues[$index].attributeValue"\r\n                                        ng-init="vm.trRoute.routeTypeAttributeValues[$index].attributeValue = attribute.routeTypeAttribute.defaultValue"\r\n                                        ng-if="attribute.routeTypeAttribute.attributeDataType.name != \'STRING\' && attribute.routeTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.routeTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trRoute.id"\r\n                                        class="form-control select2" name="value{{$index+1}}">\r\n                                        <option value="{{ atttype.value  }}"\r\n                                            ng-repeat="atttype in vm.customAttributesMap[attribute.routeTypeAttribute.attributeDataType.name]">\r\n                                            {{atttype.value }}\r\n                                        </option>\r\n                                    </select>\r\n                                    <select ng-model="vm.trRoute.routeTypeAttributeValues[$index].attributeValue"\r\n                                        ng-init="vm.trRoute.routeTypeAttributeValues[$index].attributeValue == attribute.routeTypeAttribute.defaultValue"\r\n                                        ng-if="attribute.routeTypeAttribute.attributeDataType.name != \'STRING\' && attribute.routeTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.routeTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trRoute.id"\r\n                                        class="form-control select2" name="value{{$index+1}}">\r\n                                        <option value="{{ atttype.value  }}"\r\n                                            ng-repeat="atttype in vm.customAttributesMap[attribute.routeTypeAttribute.attributeDataType.name]">\r\n                                            {{atttype.value }}\r\n                                        </option>\r\n                                    </select>\r\n                                </div>\r\n                            </div> --><div class="form-group"><div class="col-md-9" style="margin-left: 5%;"><span id="noData" ng-show="vm.isSaving">*Please Add Route</span><div id="map_canvas" class="div__map-canvas"></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Route Length (mtrs)</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><input type="number" class="form-control" name="length" ng-model="vm.trRoute.routeLength" required min="0"></div></div><div class="form-group" ng-if="vm.trRoute.id"><label class="col-md-3 control-label"><span>Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="status" ng-model="vm.trRoute.status" id="field_status" required><option value="">--- Select Status ---</option><option ng-repeat="item in vm.rolloutTaskStatus" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-if="vm.trRoute.id"><label class="col-md-3 control-label"><span>Phase</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup> --></label><div class="col-md-3"><select class="form-control" name="status" ng-model="vm.trRoute.phase" ng-disabled="!has_ROLE_PLAN_ADMIN"><option value="">--- Select Phase ---</option><option ng-repeat="item in vm.workFlowPhase" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div></div><div class="box-body" ng-show="!vm.projects.length"><h4 id="noData">No Existing Project Available</h4><button class="btn btn-create btn-sm" ui-sref="tr-project.new"><span class="glyphicon glyphicon-plus"></span> <span>Create Project</span></button></div><div class="box-footer" ng-show="vm.projects.length"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-route"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div><div class="modal fade" id="importRouter" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeModal(\'importRouter\')" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Import</span></div><div class="modal-body"><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.importRoute()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file ng-pattern="vm.importxlsx" accept="*.csv" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel & kml file should be uploaded</p></div></div><div class="form-group"><div class="col-md-3"></div><div class="col-sm-8"><select class="form-control" name="status" ng-model="vm.importRouteType" id="field_status" required><option value="" selected="selected">-- Select Type --</option><option value="CHAINAGE">CHAINAGE</option><option value="MARKER">MARKER</option><option value="COORDINATE">COORDINATE</option></select></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.closeModal(\'importRouter\')" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button> <button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" ng-click="vm.loadKmlOnMap(\'importRouter\')">Save</button></div></form></div></div></div></div>');
$templateCache.put('app/entities/tr-route/tr-routes.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-routes"></i> <span>Rings/Path</span></h3></div><div class="box-tools route_labels" ng-if="Roles.ROUTE_CREATE"><button class="btn btn-create btn-sm" ui-sref="tr-route.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="description"><span\r\n                                            translate="trakeyeApp.route.description">Description</span> --><th>Route Length (mtrs)</th><th>Route</th><th>Project</th><!-- <th>Route Type</th> --><th ng-if="Roles.SECTION_CREATE">Create Section</th><th ng-if="Roles.TASK_CREATE">Create Task</th><th>Created Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="route in vm.routes | filter: users track by route.id" ng-class="{selected: route.isChecked}"><td><a ui-sref="tr-route-detail({id:route.id})">{{route.name}}</a></td><!--  <td>{{route.description}}</td> --><td>{{route.routeLength}}</td><td>{{route.routeBundleName}}</td><td>{{route.projectName}}</td><!-- <td>{{route.routeType.name}}</td> --><td ng-if="Roles.SECTION_CREATE"><a ui-sref="tr-section.new({routeId:route.id})" class="action-icons text-primary" title="Create Section"><span class="glyphicon glyphicon-plus"></span></a></td><td ng-if="Roles.TASK_CREATE"><a ui-sref="tr-task.new({routeId:route.id, sectionId : null})" class="action-icons text-primary" title="Create Task"><span class="glyphicon glyphicon-plus"></span></a></td><td>{{route.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><div class="action"><a ui-sref="tr-route-detail({id:route.id})" class="action-icons text-info" title="View" ng-if="Roles.ROUTE_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-route.edit({id:route.id})" class="action-icons text-primary" title="Edit" ng-if="Roles.ROUTE_EDIT"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.routes == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-route-plan/tr-route-plan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this route needs to be deleted before deleting route</p><p translate="trakeyeApp.task.delete.question" translate-values="{id: \'{{vm.trTask.id}}\'}">Are you sure you want to delete this Tr Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-route-plan/tr-route-plan-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><!-- <h3 class="box-title pull-left">\r\n\t\t\t\t\t\tRoute\r\n\t\t\t\t\t</h3>  --><div class="col-md-8 col-sm-2"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab"><i class="fa fa-info-circle"></i><span class="header-view">Route</span> <!-- <span class="header_view">Details</span> --></a></li><!-- <li ng-class="{active:isSet(2)}" ng-if="vm.showRouteDetailSectionTab">\r\n\t\t\t\t\t\t\t\t<a href ng-click="setTab(2); search = null;" data-toggle="tab"><i\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-list"></i><span class="header-view">Sections</span> <span\r\n\t\t\t\t\t\t\t\t\t\tclass="header_view"></span></a>\r\n\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t<li ng-class="{active:isSet(9)}" ng-if="vm.showRouteDetailTerrainsTab">\r\n\t\t\t\t\t\t\t\t<a href ng-click="setTab(9); search = null;" data-toggle="tab"><i\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-list"></i><span class="header-view">Terrains</span> <span\r\n\t\t\t\t\t\t\t\t\t\tclass="header_view"></span></a>\r\n\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t<li ng-class="{active:isSet(10)}" ng-if="vm.showRouteDetailRowsTab">\r\n\t\t\t\t\t\t\t\t<a href ng-click="setTab(10); search = null;" data-toggle="tab"><i\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-list"></i><span class="header-view">Row</span> <span\r\n\t\t\t\t\t\t\t\t\t\tclass="header_view"></span></a>\r\n\t\t\t\t\t\t\t</li> \r\n\t\t\t\t\t\t\t<li ng-class="{active:isSet(3)}" ng-if="vm.showRouteDetailTasksTab">\r\n\t\t\t\t\t\t\t\t<a href ng-click="setTab(3); search = null" data-toggle="tab"><i\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-list"></i><span class="header-view">Tasks</span></a>\r\n\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t<li ng-class="{active:(isSet(4) || isSet(5) || isSet(6) || isSet(7))}" ng-if="vm.showRouteDetailSummaryTab">\r\n\t\t\t\t\t\t\t\t<a href ng-click="setTab(4); search = null;" data-toggle="tab"><i\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-list"></i><span class="header-view"> Summary</span> </a>\r\n\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t<li ng-class="{active:isSet(8)}">\r\n\t\t\t\t\t\t\t\t<a href ng-click="setTab(8); search = null" data-toggle="tab"  ng-if="vm.showRouteDetailCommentsTab"><i\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-commenting"></i><span class="header-view">Comments</span></a>\r\n\t\t\t\t\t\t\t</li> --></ul></div></div><div id="loading-bar-spinner" style="display: none;"><div class="spinner-icon"></div></div><!-- <jhi-alert></jhi-alert> --><jhi-alert-error></jhi-alert-error><div class="box-body" ng-show="isSet(1)"><div class="flexeven mb-5"><a href="javascript:void(0);" ui-sref="tr-route-plan" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span></a><div class="dropdown"><button class="btn btn-primary btn-sm dropdown-toggle" id="dropdownMenu" data-toggle="dropdown" ng-click="vm.showLayers()" title="Layers"><img src="content/images/layerIcon.png" alt="Connect Icon" style="width:20px; height:20px;">&nbsp; <span>Layers</span></button><ul class="dropdown-menu layer-scroll" aria-labelledby="dropdownMenu" style="padding: 10px;"><li class="dropdown-item" ng-repeat="item in vm.layerItems" style="padding: 5px;"><label style="width: 100%; font-family:\'Source Sans Pro\', sans-serif;"><input type="checkbox" ng-model="item.selected" ng-change="vm.updateSelectedLayers()"> {{ item.name }} Layer</label></li></ul></div><button class="btn btn-primary pull-right" ng-click="downloadExcelBoqSoq()" ng-if="vm.showRouteDetailBoQSoQ"><span class="glyphicon glyphicon-download"></span>&nbsp;<span>Download BoQ&SoQ</span></button> <button class="btn btn-primary pull-right" ng-click="downloadLinkBudgetReport()" ng-if="vm.showRouteDetailLinkBudget"><span class="glyphicon glyphicon-download"></span>&nbsp;<span>Link Budget</span></button> <button class="btn btn-primary pull-right" ng-click="vm.downloadRouteBundleKml()"><span class="glyphicon glyphicon-download"></span>&nbsp;<span translate="entity.action.downloadkml">Download KML</span></button><!-- <button class="btn btn-primary pull-left" ng-if=\'vm.trRoute.id!=null\'\r\n\t\t\t\t\t\t\tng-click="vm.downloadSurveyReportExcel()">\r\n\t\t\t\t\t\t\t<span class="glyphicon glyphicon-download"></span>&nbsp;<span>Survey Report</span>\r\n\t\t\t\t\t\t</button> --> <a ui-sref="tr-route-plan.edit({id:vm.trRoute.id})" class="btn btn-primary btn-sm pull-right" ng-if="Roles.ROUTE_EDIT"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div><div class="row mt-5"><div class="col-md-4"><div class="card"><div class="card-header"><button type="button" class="btn btn-primary" ng-click="vm.toggleSection(\'route\')">{{ vm.isSectionVisible(\'route\') ? \'Hide Route Details\' : \'Show Route Details\' }}</button></div><div class="card-body" ng-show="vm.isSectionVisible(\'route\')"><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.trRoute.name}}</span></dd><dt><span>Project Name</span></dt><dd><span>{{vm.trRoute.projectName}}</span></dd><dt><span translate="trakeyeApp.route.description">Description</span></dt><dd><span>{{vm.trRoute.description}}</span></dd><dt><span>Route Length (mtrs)</span></dt><dd><span ng-if="vm.trRoute.id != 11693877 && vm.trRoute.id != 11669974">{{ vm.trRoute.routeLength }} </span><span ng-if="vm.trRoute.id == 11693877">155.15 km</span> <span ng-if="vm.trRoute.id == 11669974">165.84 Km</span></dd><dt><span>Create Date</span></dt><dd><span>{{vm.trRoute.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.route.status">Status</span></dt><dd><span>{{vm.trRoute.status}}</span></dd><dt><span>Phase</span></dt><dd><span>{{vm.trRoute.phase}}</span></dd><dt><span translate="trakeyeApp.route.updateDate">Update Date</span></dt><dd><span>{{vm.trRoute.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.route.routeType">Route Type</span></dt><dd>{{vm.trRoute.routeType.name}}</dd><div class="form-group" ng-repeat="attribute in vm.trRoute.routeTypeAttributeValues"><div ng-repeat="attributeValue in vm.trRoute.routeTypeAttributeValues track by $index"><div ng-if="attributeValue.routeTypeAttribute.id == attribute.routeTypeAttribute.id"><dt><span>{{attribute.routeTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></div></div></div></dl></div></div><div class="card"><div class="card-header"><button type="button" class="btn btn-primary" ng-click="vm.toggleSection(\'rings\')">{{ vm.isSectionVisible(\'rings\') ? \'Hide Available Rings\' : \'Show Available Rings\' }}</button></div><div class="card-body table-scroll" style="max-height: 53vh" ng-show="vm.isSectionVisible(\'rings\')"><table class="jh-table table table-hover ringTable" ng-show="vm.ringRouteAssets.length"><thead><tr><th style="width:20px"></th><th>Ring Name</th><th>Length(km)</th></tr></thead><tbody><tr ng-repeat="asset in vm.ringRouteAssets" ng-class="{\'active-row\': vm.selectedAssetId === asset.id}" ng-click="vm.selectAsset(asset)"><td><input type="checkbox" ng-model="asset.isOption" title="Highlight Ring" ng-change="vm.updateSelectedAssets(asset)"></td><td title="{{asset.name}}">{{asset.name}}</td><td>{{asset.sectionLength | number:2}}</td></tr></tbody></table></div></div></div><div class="col-md-8"><div id="map_canvasStart" class="div__map-canvas"></div><div class="col-md-8 dropFilter pull-left openOptiontop" ng-show="vm.isShowFilter"><div isteven-multi-select input-model="vm.mapFilterList" group-property="msGroup" output-model="vm.selectedTerrainName" button-label="name" item-label="name strokeColor" tick-property="visible" translation="type.terrain" output-properties="name visible" helper-elements="all none Done filter" on-select-done="togglePolyline()" max-height="170px" max-labels="1" disable-property="routeDisable"></div></div><div class="col-md-8 dropFilter pull-left openOptiontop mt-5"><div class="col-md-6" isteven-multi-select input-model="vm.phaseFilter" output-model="vm.selectedPhase" button-label="name" item-label="name strokeColor" tick-property="selected" translation="type.phase" output-properties="name selected" helper-elements="all none Done filter" on-select-done="togglePhase()" max-height="170px" max-labels="1"></div><div class="col-md-6" isteven-multi-select input-model="vm.blockFilter" output-model="vm.selectedBlock" button-label="name" item-label="name" tick-property="selected" translation="type.block" output-properties="name selected" helper-elements="all none Done filter" on-select-done="toggleBlock()" max-height="170px" max-labels="1"></div></div><!-- <div class="pull-left" >\r\n\t\t\t\t\t\t\t\t<span id="noData" ng-hide="vm.zoomLevel >=  14">*Zoom in 14 for Images</span>\r\n\t\t\t\t\t\t\t\t<button class="btn btn-primary btn-sm" ng-click="vm.getRoutePoints()" ng-show="vm.zoomLevel >=  14">\r\n\t\t\t\t\t\t\t\t\t<span> Image List </span>\r\n\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t</div>  --></div></div><!-- <div class="box-header">\r\n\t\t\t\t\t\t<div class="col-md-5 col-sm-3" >\r\n\t\t\t\t\t\t\t<ul class="nav nav-pills nav-justified">\r\n\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</ul>\r\n\t\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div> --></div><h4 ng-show="isSet(11)" class="mt-15">No data available</h4><div class="box-body" ng-show="isSet(2)"><button class="btn btn-create btn-sm" ui-sref="tr-section.new({routeId:vm.trRoute.id})" title="Create Section" ng-if="Roles.SECTION_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Section</span></button><div class="table-responsive"><h3>Sections Under Route</h3><!-- <table class="jh-table table table-responsive table-hover">\r\n\t\t\t\t\t\t\t <thead class="bg-default">\r\n\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t<th>Name</th>\r\n\t\t\t\t\t\t\t\t\t<th> Material Transaction</th>\r\n                                    <th> Resource Transaction</th> \r\n                                    <th>Task</th>\r\n\t\t\t\t\t\t\t\t\t<th>Actions</th>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t</thead>\r\n\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t<tr ng-repeat-start="section in  vm.sectionResponse" >\r\n\t\t\t\t\t\t\t\t\t<td><a ui-sref="tr-section-detail({id:section.id})">{{section.name}}</a></td>\r\n\t\t\t\t\t\t\t\t\t\r\n\r\n\t\t\t\t\t\t\t\t\t<td class="td__listViewRow" ng-click="vm.expand(section,\'material\');" expand>\r\n                                        <span ng-if="!section.material" class="span__listViewRow"><i class="fa fa-plus-square"\r\n                                                aria-hidden="true" title="Details"></i></span>\r\n                                        <span ng-if="section.material" class="span__listViewRow"><i class="fa fa-minus-square"\r\n                                                aria-hidden="true" title="Details"></i></span>\r\n                                    </td>\r\n                                    <td class="td__listViewRow" ng-click="vm.expand(section,\'resource\');" expand>\r\n                                        <span ng-if="!section.resource" class="span__listViewRow"><i class="fa fa-plus-square"\r\n                                                aria-hidden="true" title="Details"></i></span>\r\n                                        <span ng-if="section.resource" class="span__listViewRow"><i class="fa fa-minus-square"\r\n                                                aria-hidden="true" title="Details"></i></span>\r\n                                    </td> \r\n                                   <td class="td__listViewRow" ng-click="vm.expand(section,\'tasks\');" expand>\r\n                                        <span ng-if="!section.tasks" class="span__listViewRow"><i class="fa fa-plus-square"\r\n                                                aria-hidden="true" title="Details"></i></span>\r\n                                        <span ng-if="section.tasks" class="span__listViewRow"><i class="fa fa-minus-square"\r\n                                                aria-hidden="true" title="Details"></i></span>\r\n                                    </td> \r\n\r\n\t\t\t\t\t\t\t\t\t<td>\r\n                                        <div class="action">\r\n                                            <a ui-sref="tr-section-detail({id:section.id})"\r\n                                                class="action-icons text-info" title="View" ng-if="Roles.SECTION_DETAIL">\r\n                                                <span class="fa fa-eye"></span>\r\n                                            </a>\r\n                                            <a ui-sref="tr-section.edit({id:section.id,routeId:section.vm.trRoute.id})"\r\n                                                class="action-icons text-primary" title="Edit" ng-if="Roles.SECTION_EDIT">\r\n                                                <span class="fa fa-pencil-square"></span>\r\n                                            </a>\r\n                                        </div>\r\n                                    </td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t<tr ng-show="section.material">\r\n                                    <td colspan="11">\r\n                                        <table\r\n                                            style=" width: 100%; height:100%; border-spacing:0; margin-left: 5%;">\r\n                                            <thead>\r\n                                                <tr>\r\n                                                    <th ng-repeat="header in vm.headers">{{ header.display }}</th>\r\n                                                </tr>\r\n                                            </thead>\r\n                                            <tbody>\r\n                                                <tr ng-repeat="item in vm.expandResponse">\r\n                                                    <td ng-repeat="header in vm.headers">\r\n                                                        <span ng-if="header.key == \'transactionDate\'">\r\n                                                        {{ item[header.key] | date:\'mediumDate\' }}\r\n                                                      </span>\r\n                                                      <span ng-hide="header.key == \'transactionDate\'">\r\n                                                        {{ item[header.key] }}\r\n                                                      </span></td>\r\n                                                </tr> \r\n                                                <tr>\r\n                                                    <td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0">\r\n                                                        <h4>No data available</h4>\r\n                                                    </td>\r\n                                                    <td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null">\r\n                                                        <h4>Loading...</h4>\r\n                                                    </td>\r\n                                                </tr>\r\n                                            </tbody>\r\n                                        </table>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr ng-show="section.resource">\r\n                                    <td colspan="11">\r\n                                        <table\r\n                                            style=" width: 100%; height:100%; border-spacing:0; margin-left: 5%;">\r\n                                            <thead>\r\n                                                <tr>\r\n                                                    <th ng-repeat="header in vm.headers">{{ header.display }}</th>\r\n                                                </tr>\r\n                                            </thead>\r\n                                            <tbody>\r\n                                                <tr ng-repeat="item in vm.expandResponse">\r\n                                                    <td ng-repeat="header in vm.headers">\r\n                                                        <span ng-if="header.key == \'transactionDate\'">\r\n                                                        {{ item[header.key] | date:\'mediumDate\' }}\r\n                                                      </span>\r\n                                                      <span ng-hide="header.key == \'transactionDate\'">\r\n                                                        {{ item[header.key] }}\r\n                                                      </span></td>\r\n                                                </tr> \r\n                                                <tr>\r\n                                                    <td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0">\r\n                                                        <h4>No data available</h4>\r\n                                                    </td>\r\n                                                    <td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null">\r\n                                                        <h4>Loading...</h4>\r\n                                                    </td>\r\n                                                </tr>\r\n                                            </tbody>\r\n                                        </table>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr ng-show="section.tasks">\r\n                                    <td colspan="11">\r\n                                        <table\r\n                                            style=" width: 100%; height:100%; border-spacing:0; margin-left: 5%;">\r\n                                            <thead>\r\n                                                <tr>\r\n                                                    <th ng-repeat="header in vm.headers">{{ header.display }}</th>\r\n                                                </tr>\r\n                                            </thead>\r\n                                            <tbody>\r\n                                                <tr ng-repeat="item in vm.expandResponse">\r\n                                                    <td>{{item.name}}</td>\r\n                                                    <td>{{item.taskType.name}}</td>\r\n                                                </tr>\r\n                                                <tr>\r\n                                                    <td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0">\r\n                                                        <h4>No data available</h4>\r\n                                                    </td>\r\n                                                    <td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null">\r\n                                                        <h4>Loading...</h4>\r\n                                                    </td>\r\n                                                </tr> \r\n                                            </tbody>\r\n                                        </table>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr ng-repeat-end></tr>\r\n\t\t\t\t\t\t\t\t<td colspan="2" ng-show="vm.sectionResponse.length == 0">\r\n\t\t\t\t\t\t\t\t\t<h4>No Sections available</h4>\r\n\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t</tbody> \r\n\t\t\t\t\t\t</table>  --><table class="jh-table table table-responsive table-hover fitContentTable"><thead class="bg-default"><tr><th></th><th>Section Name</th><th>Work Order Name</th><th>Vendor Name</th></tr></thead><tbody><tr ng-repeat-start="section in  vm.sectionResponse"><td class="td__listViewRow" ng-click="vm.expand(section,\'tasks\');" expand><span ng-if="!section.tasks" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Open"></i></span> <span ng-if="section.tasks" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Close"></i></span></td><td><a ui-sref="tr-section-detail({id:section.sectionId,routeId:section.routeId})">{{section.sectionName}}</a></td><td><a ui-sref="tr-workorder-detail({id:section.workOrderId})">{{section.workOrderName}}</a></td><td><a ui-sref="tr-vendor-detail({id:section.vendorId})">{{section.vendorName}}</a></td></tr><tr ng-show="section.tasks"><td colspan="11"><table style="width: 60%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><th ng-repeat="header in vm.headers">{{ header.display }}</th></tr></thead><tbody><tr ng-repeat="item in vm.expandResponse"><td><a ui-sref="tr-task-detail({id:item.taskId})">{{item.taskName}}</a></td><td>{{item.userLogin}}</td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0"><h4>No data available</h4></td><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null"><h4>Loading...</h4></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><td colspan="2" ng-show="vm.sectionResponse.length == 0"><h4>No Sections available</h4></td></tbody></table></div></div><div class="box-body" ng-show="isSet(9)"><button class="btn btn-create btn-sm" ui-sref="tr-terrain.new" title="Create Terrain" ng-if="Roles.TERRAIN_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Terrain</span></button><div class="table-responsive"><h3>Terrains Under Route</h3><table class="jh-table table table-responsive table-hover fitContentTable"><thead class="bg-default"><tr><th>Terrain Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="terrain in  vm.terrainListResponse"><td><a ui-sref="tr-terrain-detail({id:terrain.id})">{{terrain.name}}</a></td><td><a ui-sref="tr-terrain.edit({id:terrain.id })" class="action-icons text-primary" title="Edit" ng-if="Roles.TERRAIN_CREATE"><span class="fa fa-pencil-square"></span></a></td></tr><td colspan="2" ng-show="vm.terrainListResponse.length == 0"><h4>No Terrains available</h4></td></tbody></table></div></div><div class="box-body" ng-show="isSet(10)"><button class="btn btn-create btn-sm" ui-sref="tr-row.new" title="Create Row" ng-if="Roles.ROW_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Row</span></button><div class="table-responsive"><h3>Row Under Route</h3><table class="jh-table table table-responsive table-hover fitContentTable"><thead class="bg-default"><tr><th>Row Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="row in  vm.rowListResponse"><td><a ui-sref="tr-row-detail({id:row.id})">{{row.name}}</a></td><td><a ui-sref="tr-row.edit({id:row.id })" class="action-icons text-primary" title="Edit" ng-if="Roles.ROW_CREATE"><span class="fa fa-pencil-square"></span></a></td></tr><td colspan="2" ng-show="vm.rowListResponse.length == 0"><h4>No Row available</h4></td></tbody></table></div></div><div class="box-body" ng-show="isSet(3)"><button class="btn btn-create btn-sm" ui-sref="tr-task.new({routeId:vm.trRoute.id, sectionId : null})" title="Create Task" ng-if="Roles.TASK_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Task</span></button><div class="table-responsive"><h3>Task Details</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Name</th><th>Type</th><th>Status</th><!-- <th>Route</th> --><!--  <th>Section</th>  --><!-- <th ng-if="Roles.DAILYLOG_CREATE">Daily Task Logs</th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="task in  vm.taskResponse"><td><a ui-sref="tr-task-detail({id:task.id})">{{task.name}}</a></td><td>{{task.taskType.name}}</td><td>{{task.status}}</td><td><div class="action"><a ui-sref="tr-task-detail({id:task.id})" class="action-icons text-info" title="View" ng-if="Roles.TASK_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-task.edit({id:task.id, routeId :task.routeTask[0].routeId,sectionId:null })" class="action-icons text-primary" title="Edit" ng-if="Roles.TASK_EDIT && task.routeTask.length && task.sectionTask.length == 0"><span class="fa fa-pencil-square"></span> </a><a ui-sref="tr-task.edit({id:task.id, sectionId : task.sectionTask[0].sectionId, routeId : task.sectionTask[0].routeId})" class="action-icons text-primary" title="Edit" ng-if="Roles.TASK_EDIT && task.sectionTask.length"><span class="fa fa-pencil-square"></span></a></div></td></tr><td colspan="2" ng-show="vm.taskResponse.length == 0"><h4>No Tasks available</h4></td></tbody></table></div></div><div class="mt-10" ng-show="isSet(4) || isSet(5) ||isSet(6) || isSet(7) "><div class="col-md-3 col-sm-3" style="padding: 5px;\r\n\t\t\t\t\tmargin: 5px;"><ul class="nav nav-pills"><li ng-class="{active:isSet(4) || isSet(7) || isSet(3)}"><a href ng-click="setTab(4); search = null;" data-toggle="tab"><span class="header-view">Task</span> <!-- <span\r\n\t\t\t\t\t\t\t\t\t\tclass="header_view">Log</span> --></a></li><li ng-class="{active:isSet(5)}"><a href ng-click="setTab(5); search = null" data-toggle="tab"><span class="header-view">Material</span></a></li><li ng-class="{active:isSet(6)}"><a href ng-click="setTab(6); search = null" data-toggle="tab"><span class="header-view">Resource</span></a></li></ul></div></div><comments obj="vm.objectComments" ng-if="isSet(8)"></comments><br><br><br><!-- <div class="mt-10 col-md-6 col-sm-3" ng-show=" isSet(4) || isSet(7)">\r\n\t<div  style="\r\n\tpadding: 5px;\r\n\tmargin: 5px;\r\n">\r\n\t\t<ul class="nav nav-pills">\r\n\t\t\t<li ng-class="{active:isSet(4) || isSet(3)}" ng-show="vm.dailyLogsTxSummary.routeTasks.length">\r\n\t\t\t\t<a href ng-click="setTab(4); search = null;" data-toggle="tab"><span class="header-view">Route</span></a>\r\n\t\t\t</li>\r\n\t\t\t<li ng-class="{active:isSet(7)}" ng-show="vm.dailyLogsTxSummary.sectionTasks.length">\r\n\t\t\t\t<a href ng-click="setTab(7); search = null" data-toggle="tab"><span class="header-view">Section</span></a>\r\n\t\t\t</li>\r\n\t\t</ul>\r\n\r\n\t</div>\r\n</div> --><div class="col-sm-12" ng-show="isSet(7)"><!-- <button class="btn btn-primary center-block" ng-click="getPdf()" ng-if=\'vm.isReportGenerated==true\' style="margin: 10px;"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="generatedHtmlContainer" style="width: calc(100% - 40px);overflow-x: auto;overflow-y: hidden;"></div></div><div class="table-responsive col-md-8 mt-10" ng-show="isSet(4)"><h3>Logs Under Route</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Name</th><th>Total Work Length (mtrs)</th><th>Total Number of Hours</th><th>Log Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsTxSummary.routeTasks"><td><a ui-sref="tr-task-detail({id:task.taskId})" target="_blank">{{task.taskId}}</a></td><td>{{task.taskName}}</td><td>{{task.workLength}}</td><td>{{task.noOfHours}}</td><td>{{task.taskLogType}}</td></tr><td colspan="2" ng-show="vm.dailyLogsTxSummary.routeTasks.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="table-responsive col-md-8 mt-10" ng-show="isSet(7)"><h3>Logs Under Sections</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Name</th><th>Total Work Length (mtrs)</th><th>Total Number of Hours</th><th>Log Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsTxSummary.sectionTasks"><td><a ui-sref="tr-task-detail({id:task.taskId})" target="_blank">{{task.taskId}}</a></td><td>{{task.taskName}}</td><td>{{task.workLength}}</td><td>{{task.noOfHours}}</td><td>{{task.taskLogType}}</td></tr><td colspan="2" ng-show="vm.dailyLogsTxSummary.sectionTasks.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="table-responsive mt-10" ng-show="isSet(5)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th>ID</th> --><th>Name</th><th>Units of Measurement</th><th>Quantity</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.mtrlTxSummary"><!-- <td>\r\n\t\t\t\t\t\t\t\t\t{{task.materialId}}\r\n\t\t\t\t\t\t\t\t</td> --><td>{{task.materialName}}</td><td>{{task.unitOfMeasurementName}}</td><td>{{task.totalNoOfUnits}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="vm.mtrlTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="table-responsive mt-10" ng-show="isSet(6)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th>ID</th> --><th>Name</th><th>Total no of Resources</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.resTxSummary"><!-- <td>\r\n\t\t\t\t\t\t\t\t\t{{task.materialId}}\r\n\t\t\t\t\t\t\t\t</td> --><td>{{task.resourceName}}</td><td>{{task.totalNoOfResources}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="vm.resTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table></div></div></div></div></div><div id="modalAssetAttributes" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameAssetAttributes" class="span__modal-header">Asset Attributes</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeAssetAttributesModal()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body" style="overflow-y: scroll;height: 80vh"><div id="assetAttributeTable"></div></div></form></div></div></div><div id="modalThreePointReference" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameThreePointReference" class="span__modal-header">3 Point Reference</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeThreePointReference()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body"><div id="threePointReferenceTable"></div><!-- <table class="jh-table table table-responsive table-hover" \r\n\t\t\t\tstyle="margin-left: auto;\r\n\t\t\t\tmargin-right: auto;">\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<th ng-repeat="img in vm.referenceAttribute">Image</th>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr ng-repeat="img in vm.referenceAttribute">\r\n\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t<img class="img-responsive img__img-responsive width60"\r\n\t\t\t\t\t\t\tng-src="data:image/jpeg;base64,{{img.image}}"  />\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t{{img.imageName}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td  ng-click="deleteDisplayImage($index)">\r\n\t\t\t\t\t\t\t<span class="fa fa-trash-o" style="\r\n\t\t\t\t\t\t\tcolor: red"></span>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</table> --></div></form></div></div></div>');
$templateCache.put('app/entities/tr-route-plan/tr-route-plan-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" class="form-horizontal" novalidate show-validation onkeydown="return event.key != \'Enter\';"><div class="box box-info"><div class="box-header"><div class="pull-left"><h3 class="box-title" id="myTrRouteLabel"><span ng-if="!vm.trRoute.id" translate="trakeyeApp.route.home.create">Create</span> <span ng-if="vm.trRoute.id">Route - {{vm.trRoute.name}}</span></h3></div><div class="box-tools route_labels"><!-- <button ng-if="vm.trRoute.id" title="Tools Menu" ng-show="isSet(2)" class="app-button" id="togglePopup"><img src="./content/images/circleMenu.png"></button> --> <button ng-if="vm.trRoute.id" title="Tools Menu" ng-show="isSet(2)" class="btn btn-primary btn-sm dropdown-toggle" id="togglePopup" style="height: auto;">{{ vm.popupMenuShow ? \'Hide Menu\' : \'Show Menu\' }}</button></div></div><div class="box-body"><div class="row"><div class="col-md-12"><div class="containerwf"><div class="wrapperwf"><div class="arrow-steps clearfix"><div ng-class="{ \'step\' : true, \'current\': tab == \'1\'}"><span>Route Details</span></div><div ng-class="{ \'step\' : true, \'current\': tab == \'4\' }"><span>Import</span></div><div ng-class="{ \'step\' : true, \'current\': tab == \'2\' }"><span>Route Planning</span></div><div ng-class="{ \'step\' : true, \'current\': tab == \'3\' }"><span>Preview Route</span></div></div></div></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)" style="overflow-x: hidden"><div class="form-group"><label class="col-md-3 control-label"><span>Select Project</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.trRoute.projectId" ng-options="item.id as item.name for item in vm.projects" required><option value="">--- Select Project ---</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.route.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trRoute.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.route.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trRoute.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="status" ng-model="vm.trRoute.status" id="field_status" required ng-disabled="!vm.trRoute.id"><option value="">--- Select Status ---</option><option ng-repeat="item in vm.rolloutTaskStatus" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div></div><div class="map-view row" ng-show="isSet(2)"><div class="col-md-12 popup-menu mb-5" id="popupMenu"><div class="d-flex dropFilter"><div isteven-multi-select input-model="vm.assetType" output-model="item" button-label="name icon" item-label="name icon" tick-property="ticked" translation="label.assetTypeLabel" selection-mode="single" helper-elements="filter" on-item-click="vm.createAssetModal(item[0])" max-height="170px" style="display: inline-block"></div><div ng-show="isSet(2)" style="margin-left: 5px; display: inline-block"><button type="button" class="btn btn-primary" title="Refresh" ng-click="vm.refreshPage()"><span class="fa fa-refresh"></span><!-- <span>Refresh</span> --></button></div><div ng-show=" isSet(2) && vm.mappedAssetsList.length> 1" style="margin-left: 5px; display: inline-block"><button type="button" class="btn btn-primary" title="Connect Two Assets" ng-click="vm.connectSelectedAssets()"><img src="content/images/connectIcon.png" alt="Connect Icon" style="width:20px; height:20px;"><!-- <span>Connect Two Assets</span> --></button></div><div ng-show="isSet(2) && vm.tempStoreAssets.length>0" style="margin-left:5px;display:inline-block"><button type="button" class="btn btn-primary btn-sm" title="Identify Ring Paths" ng-click="vm.ringModal()"><img src="content/images/polygonIcon.png" alt="Connect Icon" style="width:20px; height:20px;"><!-- <span> Identify Ring Paths</span> --></button><!-- <div isteven-multi-select input-model="vm.ringSize" output-model="vm.selectedRingSize"\r\n\t\t\t\t\t\t\t\t\t             button-label="name" item-label="name" tick-property="ticked"\r\n\t\t\t\t\t\t\t\t\t              translation="label.ringSizeLabel" selection-mode="single" helper-elements="filter"\r\n\t\t\t\t\t\t\t\t\t              on-item-click="vm.onSelectedRingSize()" max-height="170px"\r\n\t\t\t\t\t\t\t\t\t             style="display:inline-block" ng-if="vm.mappedAssetsList.length"> </div> --></div><div style="margin-left: 5px; display: inline-block" ng-show="vm.mappedAssetsList.length > 1"><button type="button" class="btn btn-primary btn-sm" title="Show Anomaly" ng-click="toggleAnomaly()"><img src="content/images/anomalyIcon.png" alt="Connect Icon" style="width:20px; height:20px;"></button></div><!-- <div style="margin-left: 5px; display: inline-block"\r\n                                        ng-show="vm.mappedAssetsList.length > 1">\r\n                                        <button type="button" class="btn btn-primary" ng-click="vm.showlayers()">\r\n                                            <span>Layers</span>\r\n                                        </button>\r\n                                    </div> --><div style="margin-left: 5px; display: inline-block" ng-show="vm.mappedAssetsList.length > 1"><button type="button" class="btn btn-primary btn-sm" title="Show Optimal Path" ng-click="toggleMinCost()"><img src="content/images/polylineIcon.png" alt="Connect Icon" style="width:20px; height:20px;"></button></div><div style="margin-left: 5px; display: inline-block" ng-show="vm.mappedAssetsList.length > 1"><button class="btn btn-primary btn-sm" ng-click="vm.showLinerPaths()" ng-if="has_ROLE_PLAN_ADMIN" ng-disabled="vm.showLinerPths || vm.mappedAssetsList.length <=0"><img src="content/images/polylineIcon.png" alt="Connect Icon" style="width:20px; height:20px;" title="Find Linear Paths"><!-- <span>{{ vm.showPathsClicked ? \'Paths are shown\' : \'Find Linear Paths\'}}</span> --></button></div><div class="dropdown" ng-show="isSet(2) && vm.tempStoreAssets.length > 0" style="margin-left:5px;display:inline-block"><button class="btn btn-primary btn-sm dropdown-toggle" title="Show Optimal Path" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="content/images/multiconnectIcon.png" alt="Connect Icon" style="width:20px; height:20px;" title="Connect Multi Paths"><!-- <span> Connect Paths</span> --></button><ul class="dropdown-menu table-scroll" aria-labelledby="dropdownMenu2" style="padding: 10px;"><li class="dropdown-item" ng-if="vm.dropdownItems.length==0">No Paths Available</li><li class="dropdown-item" ng-repeat="item in vm.dropdownItems" style="padding: 5px;"><label style="width: 100%;font-family:\'Source Sans Pro\', sans-serif;"><input type="checkbox" ng-model="item.selected"> {{ item.display }}</label></li><div style="margin-left: 5px; display: inline-block; white-space: nowrap;"><span class="dropdown-item" style="text-align: center; border-top: 1px solid #ccc; margin-top: 5px; display: inline-block;"><button class="btn btn-primary" ng-click="vm.connectSelectedPaths()">Connect</button> <button class="btn btn-warning" ng-click="vm.reverseSelected()" style="margin: 5px;">Reverse Path</button> </span><span class="dropdown-item" style="text-align: center; margin-top: 5px; display: inline-block;"><button class="btn btn-danger" ng-click="vm.clearConnected()">Clear Paths</button></span></div></ul></div><div class="dropdown" style="margin-left: 5px; display: inline-block" ng-show="isSet(2) && vm.tempStoreAssets.length > 0"><button type="button" class="btn btn-primary btn-sm dropdown-toggle" id="dropdownMenu2" data-toggle="dropdown" ng-click="vm.showLayers()" title="Layers"><img src="content/images/layerIcon.png" alt="Connect Icon" style="width:20px; height:20px;"></button><ul class="dropdown-menu layer-scroll" aria-labelledby="dropdownMenu2" style="padding: 10px;"><li class="dropdown-item" ng-repeat="item in vm.layerItems" style="padding: 5px;"><label style="width: 100%; font-family:\'Source Sans Pro\', sans-serif;"><input type="checkbox" ng-model="item.selected" ng-change="vm.updateSelectedLayers()"> {{ item.name }} Layer</label></li></ul></div><div style="margin-left: 20rem; display:inline-block;" ng-show="vm.mappedAssetsList.length > 1"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.toggleAssetTable()">{{ vm.isSidebarVisible ? \'Hide Sidebar\' : \'Show Sidebar\' }}</button></div></div></div><div class="col-md-12"><div ng-class="{\'col-md-12\': !vm.isSidebarVisible, \'col-md-9\': vm.isSidebarVisible}" style="padding:0px 5px 0px 0px;"><div class="column" id="map_canvas_planning" style="height: 68vh"></div><!--<div class="col-md-12 legendsAssetType"\r\n                                        style="margin-left: -30px; flex-wrap: nowrap">\r\n                                        <div class="flex-item" ng-repeat="item in vm.legend"\r\n                                            ng-show="vm.mappedAssetsList.length">\r\n                                            <img class="square" ng-style="{\'background-color\': item.code}" />\r\n                                            {{item.name}}\r\n                                            <br />\r\n                                        </div>\r\n                                    </div>--></div><div class="column col-md-3" ng-if="vm.isSidebarVisible"><input type="text" ng-model="searchQuery" ng-show="isSetTable(11);isSetTable(10)" placeholder="Search" style="font-size: 14px; width: 100%; padding: 4px"><div class="box-header mt-5"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSetTable(10)}"><a href ng-click="setTabTable(10)" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Assets</span> <span class="header_view"></span></a></li><li ng-class="{active:isSetTable(11)}"><a href ng-click="setTabTable(11);vm.getRouteSections()" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Ring</span> <span class="header_view"></span></a></li><li ng-class="{active:isSetTable(12)}" ng-if="vm.ringResponse.length>0"><a href ng-click="setTabTable(12);vm.showNotConnected()" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Ring Options</span> <span class="header_view"></span></a></li></ul></div><div ng-show="isSetTable(11)" class="mt-5"><input type="text" ng-model="vm.routePayload.name"> <button type="button" class="btn btn-primary btn-sm next" ng-disabled="!vm.routePayload.name || !vm.routePayload.assets.length" ng-click="vm.ringSaveValidation()"><span>Save Ring</span></button></div><div class="table-scroll" style="max-height: 53vh"><table class="jh-table table table-responsive table-hover" ng-show="isSetTable(10)"><thead class="thead-light"><tr><th></th><th><span>Span/GP Name</span></th><th><span>Block Name</span></th><th><span>Status</span></th><th><span>Length</span></th><th><span>Actions</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.mappedAssetsList | filter: searchQuery" ng-class="{selected: asset.isOption}"><td><input type="checkbox" ng-model="asset.isOption" ng-change="vm.onChangeTopology(asset)" ng-if="asset.id == \'True\' || asset.id == \'anomaly\'"></td><td style="font-size: 12px" class="node" ng-click="vm.navigate(asset)">{{asset.name}}</td><td><span ng-if="asset.block">{{asset.block}} </span><span ng-if="!asset.block">-</span></td><td><span ng-if="asset.assetType.layout == \'SPREAD\'"><img class="square" ng-style="{\'background-color\': \'#ff0025\'}" ng-if="asset.isExisting == false"> <img class="square" ng-style="{\'background-color\': \'#00A36C\'}" ng-if="asset.isExisting == true && asset.isUsed == true"></span><img class="square" ng-style="{\'background-color\': \'#FFAE42\'}" ng-if="asset.isExisting == true && asset.isUsed == false"><span ng-hide="asset.assetType.layout == \'SPREAD\'">NA</span></td><td><span ng-if="asset.assetLength">{{asset.assetLength | number : 2}} km</span> <span ng-if="!asset.assetLength">-</span></td><td><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a id="editlink" ng-click="vm.editAsset(asset)" class="action-icons text-primary" title="Edit" ng-if="asset.assetType.layout == \'SPREAD\'"><span style="font-size: 12px" class="fa fa-pencil-square"></span> </a><a id="link" ng-click="vm.deleteAssetModal(asset.name,asset.id)" class="action-icons text-primary" title="Delete"><span style="font-size: 12px" class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.mappedAssetsList.length==0" style="text-align: center"><h4>No data available</h4></td></tr></tbody></table><span ng-show="isSetTable(11) && vm.routePayload.assets.length !=0">Ring Total Length : {{vm.totalLength | number :2}} km</span><table class="jh-table table table-responsive table-hover" style="max-height: 200px; overflow-y: auto;" ng-show="isSetTable(11)  && vm.routePayload.assets.length !=0"><thead class="thead-light"><tr><th></th><th><span>Span/GP Name</span></th><th><span>Length</span></th><th><span>Actions</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.routePayload.assets | filter: searchQuery"><td></td><td ng-click="vm.navigate(asset)">{{asset.name}}</td><td><span ng-if="asset.assetLength">{{asset.assetLength | number :2}} km</span> <span ng-if="!asset.assetLength">-</span></td><td><a class="action-icons text-primary" title="Delete" ng-click="vm.deleteSpanOrGpAsset($index,asset)"><span class="fa fa-trash-o"></span></a></td></tr><tr><td colspan="10" ng-show="vm.routePayload.assets.length==0" style="text-align: center"><h4>No data available</h4></td></tr></tbody></table><table class="jh-table table table-responsive table-hover ringTable" ng-show="isSetTable(11) && vm.ringRouteAssets !=0"><thead class="thead-light"><tr><th style="width:20px"></th><th style="width:140px"><span>Ring</span></th><th><span>Length(km)</span></th><th><span>Actions</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.ringRouteAssets" ng-class="{\'active-row\': vm.selectedAssetId === asset.id}" ng-click="vm.selectAsset(asset)"><td><input type="checkbox" ng-model="asset.isOption" title="Highlight Ring" ng-change="vm.updateSelectedAssets(asset)"></td><td class="fixed-width" title="{{asset.name}}">{{asset.name}}</td><td>{{asset.sectionLength | number :2}}</td><td><a ng-click="vm.getSecAssetDetails(asset.id);vm.getSecAssetCount(asset.id);vm.getFixedAssets(asset.id);vm.selectOnlyThisAsset(asset);" class="action-icons text-primary" title="View Details"><span class="fa fa-eye"></span></a> <a ng-click="vm.updateRingName(asset.id)" class="action-icons text-primary" title="Edit Ring Name"><span class="fa fa-pencil-square"></span></a></td></tr></tbody></table><table class="jh-table table table-responsive table-hover" ng-show="isSetTable(12)"><thead class="thead-light"><tr><th></th><th><span>Span/GP Name</span></th><th><span>Length</span></th><!-- <th><span>Action</span></th> --></tr></thead><tbody><tr ng-repeat="asset in vm.ringList" ng-class="{selected: asset.isOption}"><td><input type="checkbox" ng-model="asset.isOption" ng-change="vm.onChangeTopology(asset)" ng-if="asset.id == \'True\' || asset.id == \'anomaly\'"></td><td style="font-size: 12px" class="node" ng-click="vm.navigate(asset)">{{asset.name}}</td><td><span ng-if="asset.assetLength">{{asset.assetLength | number : 2}} km</span> <span ng-if="!asset.assetLength">-</span></td><!-- <td>\r\n                                                        <div class="actions"\r\n                                                            ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER">\r\n                                                            <a id="editlink" ng-click="vm.editAsset(asset)"\r\n                                                                class="action-icons text-primary" title="Edit"\r\n                                                                ng-if="asset.assetType.layout == \'SPREAD\'">\r\n                                                                <span style="font-size: 12px"\r\n                                                                    class="fa fa-pencil-square"></span>\r\n                                                            </a>\r\n                                                            <a id="link"\r\n                                                                ng-click="vm.deleteAssetModal(asset.name,asset.id)"\r\n                                                                class="action-icons text-primary" title="Delete">\r\n                                                                <span style="font-size: 12px"\r\n                                                                    class="fa fa-trash-o"></span>\r\n                                                            </a>\r\n                                                        </div>\r\n                                                    </td> --></tr><tr><td colspan="10" ng-show="vm.nodeList.length==0" style="text-align: center"><h4>No data available</h4></td></tr></tbody></table></div></div><div ng-if="vm.mappedAssetsList.length" class="col-md-12 d-flex"><!-- <span>\r\n                                        Min cost path :\r\n                                        <b ng-if="vm.trRoute.id!=11693877 && vm.trRoute.id!=11669974">{{vm.minCostTotalLength\r\n                                            | number : 2}} km.</b>\r\n                                        <b ng-if="vm.trRoute.id==11693877">142.16 km.</b>\r\n                                        <b ng-if="vm.trRoute.id==11669974">147.83 km.</b>\r\n\r\n                                    </span>\r\n                                    &nbsp; &nbsp; &nbsp; --> <span><b>Existing OFC</b> : <span>Total : <b>{{ vm.connectedLength | number: 2 }} km</b></span> &nbsp; | &nbsp; <span>Used : <b>{{ vm.ExistingUsed | number: 2 }} km</b></span> &nbsp; | &nbsp; <span>Unused : <b>{{ vm.ExistingUnused | number: 2 }} km</b></span> </span><span>&nbsp; &nbsp; &nbsp; New OFC : <b>{{vm.newOFCLength | number : 2}} km.</b></span> &nbsp; &nbsp; &nbsp; <span>Total length : <b ng-if="vm.trRoute.id != 11693877 && vm.trRoute.id != 11669974">{{ vm.routePlanningTotalLength | number : 2 }} km.</b> <b ng-if="vm.trRoute.id == 11693877">155.15 km.</b> <b ng-if="vm.trRoute.id == 11669974">165.84 km.</b> &nbsp; &nbsp; &nbsp;</span></div></div></div><div class="col-md-12" ng-show="isSetTable(11) && isSet(2) && (vm.displayRingDetails === \'true\')" ng-if="vm.isSidebarVisible"><h3>Ring Details</h3><div class="row"><div class="col-md-6 table-scroll" style="max-height: 44vh"><table class="jh-table table table-responsive table-hover" ng-show="isSetTable(11)" style="border-collapse: collapse; border: 1px solid black"><thead><tr><th>Span</th><th>Length(km)</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="asset in vm.sectionAssetDetails"><td>{{ asset.name}}</td><td>{{ asset.assetLength | number:2 }}</td><td><a id="link" ng-click="vm.deleteRingAssetas(asset.id)" class="action-icons text-primary" title="Delete"><span style="font-size: 12px" class="fa fa-trash-o"></span></a></td></tr><tr><td colspan="10" ng-show="vm.sectionAssetDetails==0" style="text-align: center"><h4>No data available</h4></td></tr></tbody></table></div><!-- Second Table --><div class="col-md-3 table-scroll" style="max-height: 44vh"><table class="jh-table table table-responsive table-hover" ng-show="isSetTable(11)" style="border-collapse: collapse; border: 1px solid black"><thead><tr><th>GP</th><!--  <th>Actions</th> --></tr></thead><tbody><tr ng-repeat="fixedAsset in vm.routeFixedAssets"><td>{{ fixedAsset.name}}</td><!--  <td>{{ asset.assetLength | number:2 }}</td>\r\n                                                <td>\r\n                                                    <a id="link" ng-click="vm.deleteRingAssetas(asset.id)"\r\n                                                        class="action-icons text-primary" title="Delete">\r\n                                                        <span style="font-size: 12px" class="fa fa-trash-o"></span>\r\n                                                    </a>\r\n                                                </td> --></tr><tr><td colspan="10" ng-show="vm.routeFixedAssets==0" style="text-align: center"><h4>No data available</h4></td></tr></tbody></table></div><div class="col-md-3"><table class="jh-table table table-responsive table-hover" ng-show="isSetTable(11)" style="border-collapse: collapse; border: 1px solid black;max-height: 35vh"><thead><tr><th>Asset Type</th><th>Count</th></tr></thead><tbody><tr ng-repeat="asset in vm.sectionAssetCount"><td>{{ asset.assetTypeName }}</td><td>{{ asset.count }}</td></tr><tr><td colspan="10" ng-show="vm.sectionAssetCount==0" style="text-align: center"><h4>No data available</h4></td></tr></tbody></table></div></div></div><div class="row mt-5" ng-show="isSet(4)"><div class="col-md-12" style="display: inline-flex"><div class="box-tools route_labels"><span class="btn btn-primary btn-sm" ng-click="vm.openImportExcel()" ng-disabled="vm.isUpdateProgress" ng-if=" has_ROLE_PLAN_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span>Import Excel</span></span></div><div class="box-tools route_labels" style="margin-left: 5px; display: inline-block"><span class="btn btn-primary btn-sm" ng-click="vm.openImportKml()" ng-disabled="vm.isUpdateProgress" ng-if=" has_ROLE_PLAN_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span>Import Kml</span></span></div><span class="btn btn-primary btn-sm" style="margin-left: 5px; display: inline-block" ng-click="vm.showPaths()" ng-if="has_ROLE_PLAN_ADMIN" ng-disabled="vm.showPathsClicked || vm.mappedAssetsList.length <=0"><img src="content/images/polylineIcon.png" alt="Connect Icon" style="width:20px; height:20px;" title="Find Linear Paths"><!-- <span>{{ vm.showPathsClicked ? \'Paths are shown\' : \'Find Linear Paths\'}}</span> --> </span><span class="btn btn-primary btn-sm" style="margin-left: 5px; display: inline-block" ng-click="vm.showDirection()" ng-if="has_ROLE_PLAN_ADMIN" ng-disabled="vm.showDirectionClicked || vm.mappedAssetsList.length <=0"><img src="content/images/alternativeIcon.png" alt="Connect Icon" style="width:23px; height:23px;" title="Find Alternative path"></span></div><div class="col-md-12 mt-5"><div class="column mt-5" id="map_import_planning" style="height: 66vh"></div><span ng-if="vm.isShowTotalLengthImport">Total Length : <b>{{vm.optimalTotalLength | number : 2}} km</b></span></div></div><div class="form-group" ng-show="isSet(3)"><div ng-if="vm.previousId"><button class="btn btn-primary btn-sm pull-right" type="button" class="btn btn-primary btn-sm" ng-click="vm.recalculate()"><span>Recalculate</span></button></div><div class="col-md-12"><div class="col-md-12" id="map_canvas_deployed" style="height: 66vh; width: 100%"></div></div></div><div class="box-footer"><div class="col-md-12 next-button" ng-show="isSet(1)" style="text-align: right; margin-right: 20px"><button type="button" class="btn btn-primary btn-sm next" ng-disabled="editForm.$invalid" ng-click="vm.saveRoute()"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 next-button" ng-show="isSet(4)" style="text-align: right; margin-right: 20px"><button type="button" class="prev btn btn-primary btn-sm pull-left" ng-click="setTab(1)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="button" class="btn btn-primary btn-sm next" ng-click="setTab(2)" ng-disabled="vm.isDisableNext" ng-hide="vm.showSaveButton"><span>{{vm.labelSaveNext}}</span> <span class="glyphicon glyphicon-arrow-right"></span></button> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.processing()" ng-show="vm.showSaveButton"><span>Save</span></button></div><div class="col-md-12 next-button" ng-show="isSet(2)" style="text-align: right; margin-right: 20px"><button type="button" class="prev btn btn-primary btn-sm pull-left" ng-click="setTab(4)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="button" ng-disabled="vm.assetsLoaded" class="btn btn-primary btn-sm next" ng-click="setTab(3)"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 save-buttons" ng-show="isSet(3)" style="text-align: right; margin-right: 20px"><button type="button" class="prev btn btn-primary btn-sm pull-left" ng-click="setTab(2)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button ng-disabled="editForm.$invalid" class="btn btn-primary btn-sm" ng-click="vm.save()"><span class="glyphicon glyphicon"></span> <span>Save</span></button></div></div></div></div></form></div></div></div><!--Modal for editing asset--><div id="userPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 80vw" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span class="span__header">Edit Asset</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left;\r\n            color: white;\r\n            font-weight: bold;\r\n            vertical-align: middle;" id="myEditAssetText"></span></div><div style="width: 100%; height: 78vh; padding-top: 7px; overflow: auto" class="modal-body"><div class="row"><div class="col-md-12"><div class="box-body"><div style="float: right; border: none; margin-right: 20px"><button class="btn btn-info btn-flat" ng-click="vm.saveEditAsset()"><span><b>Save</b></span></button></div><div class="row" style="margin: 20px"><label class="col-md-3 control-label"><span>Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.asset.name" ng-minlength="2" ng-maxlength="50" disabled="disabled"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row" style="margin: 20px"><div class="col-md-3 control-label"><span>Asset Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3 control-label"><span>{{vm.asset.assetType.name}}</span></div><div class="col-md-3 control-label"><span>Is Existing</span> <input type="checkbox" ng-model="vm.asset.isExisting"></div><div class="col-md-3 control-label"><div ng-repeat="item in vm.asset.assetTypeAttributeValues"><span ng-if="item.assetTypeAttribute.name === \'Type\'">Type <input type="text" ng-model="item.attributeValue"></span></div></div></div><div class="row" style="margin: 20px"><div class="col-md-9" style="margin-left: 25%;"><div id="map_canvas_edit_asset" style="height: 380px"></div></div></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 80vw" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span class="span__header">Connect Two Assets</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.hideConnectSitesModal()"><span aria-hidden="true">&times;</span></button> <span style="text-align: left;\r\n            color: white;\r\n            font-weight: bold;\r\n            vertical-align: middle;" id="connectAssetsText"></span></div><!-- Modal body--><div style="width: 80vw; height: 77vh; padding-top: 7px" class="modal-body"><div class="row"><div style="margin-top: 8px"><div class="col-md-1 select_asset" style="text-align: right"><label style="padding-top: 6px">Site A</label></div><div class="col-md-2 selectAsset_drp" style="text-align: center; margin-right: 85px"><select id="fromAssetsView" class="select2 form-control dropwidthHeight" name="search"><option value="">--Select Site A--</option><option ng-repeat="item in vm.connectTwoAssets" value="{{item.name}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px"><label style="padding-top: 6px">Site B</label></div><div class="col-md-2 selectAsset_drp" style="text-align: center; margin-right: 85px; margin-left: -15px"><select id="toAssetsView" class="select2 form-control dropwidthHeight" name="search"><option value="">--Select Site B--</option><option ng-repeat="item in vm.connectTwoAssets" value="{{item.name}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px"><label style="padding-top: 6px">Path</label></div><div class="col-md-2"><select id="travelMode" class="form-control" name="travelMode"><option value="DRIVING">DEFAULT</option><option value="BICYCLING">ALTERNATIVE 1</option><option value="WALKING">ALTERNATIVE 2</option></select></div><button type="button" ng-click="vm.connectAssets()" class="btn btn-primary btn-sm">Connect</button></div><div class="form-group"><div class="col-md-12 mt-5"><div id="map_canvas_connect_assets" style="width: 100%; height: 63vh"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectMultipleAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="vm.hideConnectMultipleAssetsModal()" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left;\r\n            color: white;\r\n            font-weight: bold;\r\n            vertical-align: middle;\r\n            font-weight: 125;" id="connectAssetsText">Select site to connect</span></div><!-- Modal body--><div style="width: 100%; height: 80vh; padding-top: 7px; overflow: auto" class="modal-body"><div class="col-md-12"><div id="map_canvas_connect_multiple_assets" style="width: 100%; height: 68vh; margin-top: 10px"></div></div><div class="col-md-12"><button class="btn btn-primary btn-sm pull-right" type="button" ng-click="vm.saveLinkPits()" style="margin: 10px">Save</button></div></div></div></div></div><!-- Modal for delete asset   --><div id="delete-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40%; margin: 200px auto" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cleardeleteAsset()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><h4>Are you sure you want to delete this asset?</h4></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.cleardeleteAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm" ng-click="vm.confirmDeleteAsset()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></div></div></div></div><!-- Modal for create asset   --><div id="create-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 45%; margin: 100px auto"><div class="modal-content"><form name="form" class="css-form" novalidate><div class="modal-header"><span class="span__header">Asset Creation Form of Type {{vm.CreateAssetName}}</span> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clearCreateAsset()">&times;</button></div><div class="modal-body"><div class="row" style="margin: 20px"><div class="form-group"><label class="col-md-3 control-label" style="width: 139px"><span style="vertical-align: center">Name </span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7" style="width: 71%"><input type="text" name="name" ng-model="vm.assetNameVal" class="form-control" placeholder="Please Enter Name" style="padding: 6px" required><div ng-show="vm.assetExisting"><div class="help-block" ng-show="form.name.$error">Name is already exist</div></div></div></div></div><div class="row" style="margin: 20px"><label class="col-md-3 control-label"><span translate=" ">Coordinates</span></label><div class="col-md-7"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLatLng" id="field_pinLat" ng-model="vm.getLocationCoordinate"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clearCreateAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.createAsset()" ng-disabled="!vm.assetNameVal"><span ng-show="vm.getLocationCoordinate.length > 0">OK</span> <span ng-hide="vm.getLocationCoordinate.length > 0">Select Location on Map</span></button></div></form></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form ng-show="isSet(2)" name="editForm1" role="form" class="form-horizontal" novalidate ng-submit="vm.showZoomLocation()" show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label"><span translate=" ">Enter the co-ordinates :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLat" ng-model="vm.getLocationCoordinates" id="field_pinLat" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')">Cancel</button> <button class="btn btn-primary">OK</button></div></form></div></div></div><div class="modal fade" id="importExcelFixed" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeImportExcelFixedModal()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Import Fixed Assets</span></div><div class="modal-body"><form name="uploadFormFixed" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-8"><input type="file" name="uploadfileAssetFixed" ng-model="uploadfileAssetFixed" ng-file-select="uploadfileAssetFixed" id="uploadfileAssetFixed" class="filestyle" valid-file agent-file ng-pattern="vm.importxl" accept="*.xlsx" required><p class="text-danger" ng-if="uploadFormFixed.uploadfileAssetFixed.$error.pattern">Only Excel file should be uploaded</p></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.closeImportExcelFixedModal()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button> <button class="btn btn-primary btn-sm" ng-disabled="uploadFormFixed.$invalid" ng-click="vm.uploadFixedAssets()">Import</button></div></form></div></div></div></div><div class="modal fade" id="importKml" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeImportKmlModal()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Import Kml Assets</span></div><div class="modal-body"><form name="uploadFormKML" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-8"><input type="file" name="uploadkmlfileAsset" ng-model="uploadkmlfileAsset" ng-file-select="uploadkmlfileAsset" id="uploadkmlfileAsset" class="filestyle" valid-file agent-file ng-pattern="vm.importkml" accept="*.kml" required><p class="text-danger" ng-if="uploadFormKML.uploadkmlfileAsset.$error.pattern">Only KML file should be uploaded</p></div></div><!-- Asset Type Selection --><div class="form-group"><label class="col-sm-3 control-label">Asset Type</label><div class="col-sm-8"><select class="form-control select2" id="assettypeDropdown" name="assetType" ng-model="vm.importkmlassettype" ng-options="item as item.name for item in vm.storeAssetTypes track by item.id" required><option value="">--- Select Asset Type ---</option></select></div></div><!-- <div class="form-group">\r\n                            <label class="col-sm-3 control-label">Existing</label>\r\n                            <div class="col-sm-8">\r\n                                <select class="form-control" name="existing" ng-model="vm.importkmlexisting" required>\r\n                                    <option value="">--- Existing? ---</option>\r\n                                    <option value="true">TRUE</option>\r\n                                    <option value="false">FALSE</option>\r\n                                </select>\r\n                            </div>\r\n                        </div>\r\n                        <select ng-model="vm.user.trakeyeTypeAttributeValues[$index].attributeValue"\r\n                            ng-init="vm.user.trakeyeTypeAttributeValues[$index].attributeValue = attribute.trakeyeTypeAttribute.value"\r\n                            ng-if="attribute.trakeyeTypeAttribute.dataType ==  \'BOOLEAN\' && !vm.user.id"\r\n                            class="form-control select2" name="value">\r\n                            <option value="true">True</option>\r\n                            <option value="false">False</option>\r\n                        </select> --></div><div class="modal-footer"><button type="button" ng-click="vm.closeImportKmlModal()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button> <button class="btn btn-primary btn-sm" ng-disabled="uploadFormKML.$invalid || !uploadkmlfileAsset || !vm.importkmlassettype" ng-click="vm.uploadKmlAssets()">Import</button></div></form></div></div></div></div><div id="ringTopology" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40vw; height: 40vh" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span class="span__header">Suggest Ring Paths </span><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeRingModal()"><span aria-hidden="true">&times;</span></button> <span style="text-align: left;\r\n            color: white;\r\n            font-weight: bold;\r\n            vertical-align: middle;" id="connectAssetsText"></span></div><div class="modal-body"><form name="ringModal" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data"><div class="box-body"><div class="form-group"><label class="col-md-5 mt-5">Select Number of Nodes</label><div class="col-md-4"><select class="form-control select2" id="ringDropdown" name="status" ng-model="vm.selectedRingSize" required><option value="" selected="selected">Select</option><option ng-repeat="item in  vm.ringSize" value="{{item.name}}">{{item.name}}</option></select></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.closeRingModal()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button> <button class="btn btn-primary btn-sm" ng-disabled="ringModal.$invalid" ng-click="vm.onSelectedRingSize()">Ok</button></div></form></div></div></div></div><div id="processing" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1" style="background: rgba(0, 0, 0, 0.8)"><div class="modal-dialog modal-fluid" style="margin-top: 15%; width: 40vw; height: 40vh" role="document"><!-- Modal content--><div class="modal-content" style="min-height: 15vh"><div class="modal-header"><span class="span__header"><b>Assets Processing</b></span></div><div class="modal-body"><div class="progress mr-15" style="width: 38vw"><div class="barProgress" ng-style="{\'width\': vm.updateProgress + \'%\'}"><p class="percent" style="margin-left: 80%"></p></div></div></div></div></div></div><div id="modalAssetAttributes" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameAssetAttributes" class="span__modal-header">Asset Attributes</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeAssetAttributesModal()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body" style="overflow-y: scroll; height: 80vh"><div id="assetAttributeTable"></div></div></form></div></div></div><div id="Exist-Ring" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="addAssetExistRing" class="span__modal-header">Add To Existing Ring</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeAssetExistRing()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div id="existRingTable" class="table-scroll" style="max-height: 50vh"></div></div></div></div></div><div id="Exist-Ring-name" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="ringNameAlreadyExist" class="span__modal-header">Ring name already exist</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeRingNameAlreadyExist()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div id="existRingNamePopup" class="table-scroll" style="max-height: 23vh"><div class="modal-body text-center"><h4 class="text-danger font-weight-bold">Duplicate Ring Name Not Allowed, Please Provide New Name</h4><div class="form-group"><input type="text" class="form-control mx-auto text-center ring-input" ng-model="vm.routePayload.name" placeholder="Enter new ring name"></div><button class="btn btn-primary" ng-click="vm.ringSaveValidation()">Save</button> <button class="btn btn-secondary" ng-click="vm.closeRingNameAlreadyExist()">Cancel</button></div></div></div></div></div></div><div id="updateRingNameModel" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="updateRingName" class="span__modal-header">Update Ring Name</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeUpdateRingNameModel()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div id="updateRingNamePopup" class="table-scroll" style="max-height: 23vh"><div class="modal-body text-center"><h4 ng-if="vm.duplicateName" class="text-danger font-weight-bold">Duplicate Ring Name Not Allowed, Please Provide New Name</h4><div class="form-group"><input type="text" class="form-control mx-auto text-center ring-input" id="updateRingName" ng-model="vm.newRingName" placeholder="Enter ring name"></div><button class="btn btn-primary" ng-click="vm.updateRingNameValidation()">update</button> <button class="btn btn-secondary" ng-click="vm.closeUpdateRingNameModel()">Cancel</button></div></div></div></div></div></div><div id="assetEditModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid div__modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span id="assetEditName" class="span__modal-header">Edit Asset</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeEditAssetModal()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" style="height: 70vh; overflow-y: auto"><form class="form-horizontal" role="form" style="margin-bottom: 10px"><div class="form-group"><label class="col-md-3 control-label"><span for="field_name">Name</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.assetToEdit.name" ng-minlength="2" disabled="disabled"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Asset Type</span></label><div class="col-md-7"><input type="text" class="form-control" name="assetTypeName" id="field_assetTypeName" ng-model="vm.assetToEdit.assetTypeName" ng-minlength="2" disabled="disabled"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>State</span></label><div class="col-md-7"><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.assetToEdit.state" ng-minlength="2"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>District</span></label><div class="col-md-7"><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.assetToEdit.district" ng-minlength="2"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Block</span></label><div class="col-md-7"><input type="text" class="form-control" name="block" id="field_block" ng-model="vm.assetToEdit.block" ng-minlength="2"></div></div></form></div><div class="modal-footer"><div style="margin-left: 120px"><button ng-click="vm.saveEditAssetModal()" id="myBtn" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm pull-left"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default btn-sm pull-left" ng-click="vm.closeEditAssetModal()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div><div id="modalNearBy" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" style="margin-right: 20px;width: 300px; margin-top: 70px;" role="document"><div class="modal-content"><div class="modal-header"><span id="assetNameAssetAttributes" class="span__modal-header">Near-By Gp\'s</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeAssetAttributesModal()"><span aria-hidden="true">&times;</span></button></div><form name="editForm" role="form" class="form-horizontal" novalidate><div class="modal-body" style="overflow-y: scroll; height: 60vh"><table align="center" style="border: 1px solid black; width: 70%;"><tr><th style="border: 1px solid black; text-align: center;">Select</th><th style="border: 1px solid black; text-align: center;">Gp Name</th></tr><tr ng-repeat="item in vm.nearByGps"><td style="border: 1px solid black; text-align: center;"><input type="checkbox" ng-model="item.selected"></td><td style="border: 1px solid black; text-align: center;">{{item.name || "N/A"}}</td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="vm.clearSelected()">Clear</button> <button type="button" class="btn btn-primary" ng-click="vm.connectSelected()">Connect</button></div></form></div></div></div><div id="editAssetAttributeModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 80vw" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span class="span__header">Edit Asset Attributes - {{vm.asset.name}}</span><div style="float: right; border: none; margin-right: 20px"><button class="btn btn-info btn-flat" style="margin-right: 16px" ng-click="vm.saveEditAssetAttribute()"><span><b>Save</b></span></button> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeEditAssetAttributeModal()"><span aria-hidden="true">&times;</span></button></div><span style="text-align: left;color: white;font-weight: bold;vertical-align: middle;" id="editAssetAttributeText"></span></div><div style="width: 100%; height: 78vh; padding-top: 7px; overflow: auto" class="modal-body"><div class="row"><div class="col-md-12"><div class="box-body"><div class="row" style="margin: 20px"><table style="width: 100%;"><tbody><tr ng-repeat="item in vm.asset.assetTypeAttributeValues"><td style="padding: 8px; width: 25%;"><label>{{ item.assetTypeAttribute.name }}</label></td><td style="padding: 8px; width: 75%;"><input type="text" class="form-control" ng-model="item.attributeValue"></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-route-plan/tr-routes-plan.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-routes"></i> <span>Route</span></h3></div><div class="box-tools route_labels" ng-if="Roles.ROUTE_CREATE"><button class="btn btn-create btn-sm" ui-sref="tr-route-plan.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="description"><span\r\n                                            translate="trakeyeApp.route.description">Description</span> --><!-- <th>Route Length (mtrs)</th> --><th>Project</th><!-- <th>Route Type</th> --><th ng-if="Roles.SECTION_CREATE">Create Section</th><th ng-if="Roles.TASK_CREATE">Create Task</th><th>Created Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="route in vm.routes | filter: users track by route.id" ng-class="{selected: route.isChecked}"><td><a ui-sref="tr-route-plan-detail({id:route.id})">{{route.name}}</a></td><!--  <td>{{route.description}}</td> --><!-- <td>{{route.routeLength}}</td> --><td>{{route.projectName}}</td><!-- <td>{{route.routeType.name}}</td> --><td ng-if="Roles.SECTION_CREATE"><a ui-sref="tr-section.new({routeId:route.id})" class="action-icons text-primary" title="Create Section"><span class="glyphicon glyphicon-plus"></span></a></td><td ng-if="Roles.TASK_CREATE"><a ui-sref="tr-task.new({routeId:route.id, sectionId : null})" class="action-icons text-primary" title="Create Task"><span class="glyphicon glyphicon-plus"></span></a></td><td>{{route.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><div class="action"><a ui-sref="tr-route-plan-detail({id:route.id})" class="action-icons text-info" title="View" ng-if="Roles.ROUTE_DETAIL"><span class="fa fa-eye"></span> </a><a class="action-icons text-info" ng-click="vm.downloadSurveyReport(route.id)" title="Download Survey Report" ng-if="Roles.ROUTE_DETAIL"><span class="fa fa-download"></span> </a><a ui-sref="tr-route-plan.edit({id:route.id})" class="action-icons text-primary" title="Edit" ng-if="Roles.ROUTE_EDIT"><span class="fa fa-pencil-square"></span> </a><a ng-click="vm.showLinkAsset(route.id)" class="action-icons text-info" title="Assets Link" ng-if="Roles.ROUTE_EDIT"><span class="fa fa-link"></span></a></div></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.routes == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div><div class="modal fade" id="linkasset" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'linkasset\')"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Asset Network Topology - {{vm.labelStatus}}</h4></div><div class="modal-body vh-15"><div class="form-group"><div class="col-md-3 control-label loaderCircle ml-40" ng-style="vm.getProgressBarColor()"></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-row/tr-row-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.row.detail.title">Tr Row</span> {{vm.trRow.name}} - {{vm.trRow.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><a href="javascript:void(0);" ui-sref="tr-row" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-row.edit({id:vm.trRow.id})" class="btn btn-primary btn-sm pull-right" ng-if="Roles.ROW_CREATE"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a><dl class="dl-horizontal jh-entity-details mt-5"><dt><span translate="trakeyeApp.row.description">Description</span></dt><dd><span>{{vm.trRow.description}}</span></dd><dt><span translate="trakeyeApp.row.createDate">Create Date</span></dt><dd><span>{{vm.trRow.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.row.updateDate">Update Date</span></dt><dd><span>{{vm.trRow.lastModifiedDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.row.rowType">Row Type</span></dt><dd><!--  <a ui-sref="row-type-detail({id:vm.trRow.rowType.id})">{{vm.trRow.rowType.name}}</a> --> {{vm.trRow.rowType.name}}</dd><dt><span>VerifiedBy</span></dt><dd><span>{{vm.trRow.verifiedBy}}</span></dd><dt><span>Verified</span></dt><dd><span ng-if="vm.trRow.isVerified==true">YES</span> <span ng-if="vm.trRow.isVerified==false||vm.trRow.isVerified==null">NO</span></dd><div class="form-group" ng-repeat="attribute in vm.trRow.rowTypeAttributeValues"><div ng-repeat="attributeValue in vm.trRow.rowTypeAttributeValues track by $index"><div ng-if="attributeValue.rowTypeAttribute.id == attribute.rowTypeAttribute.id"><dt><span>{{attribute.rowTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></div></div></div></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tr-row/tr-row-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrRowLabel"><span ng-if="!vm.trRow.id">Create</span> <span ng-if="vm.trRow.id">Edit - {{vm.trRow.id}}</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div class="form-group"><label class="col-md-3 control-label"><span>Route Name</span></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.trRow.routeId" ng-options="item.id as item.name for item in vm.routes" ng-disabled="true" required></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.row.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trRow.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.row.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trRow.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Select Row Points</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <button type="button" class="btn btn-primary btn-sm ml-5" ng-click="vm.removeMarker()" title="Clear Selected Points"><span class="fa fa-refresh"></span></button><div id="map_canvasStart" class="div__map-canvas col-md-8"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Row Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control select2" name="rowType" ng-model="vm.rowType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                        vm.rowTypes track by item.id" ng-disabled="vm.trRow.id!=null" required style="width: 100%"><option value="" translate="trakeyeApp.row.selectrow">--- Select RowType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.trRow.rowTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.rowTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.trRow.rowTypeAttributeValues[$index].attributeValue" ng-if="attribute.rowTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trRow.id" type="text" class="form-control" ng-init="vm.trRow.rowTypeAttributeValues[$index].attributeValue = attribute.rowTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.trRow.rowTypeAttributeValues[$index].attributeValue" ng-if="attribute.rowTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.trRow.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.rowTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.trRow.rowTypeAttributeValues[$index].attributeValue" ng-if="attribute.rowTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trRow.id" type="text" class="form-control" ng-init="vm.trRow.rowTypeAttributeValues[$index].attributeValue = attribute.rowTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.trRow.rowTypeAttributeValues[$index].attributeValue" ng-if="attribute.rowTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trRow.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.rowTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.trRow.rowTypeAttributeValues[$index].attributeValue" ng-if="attribute.rowTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trRow.id" type="text" class="form-control" ng-init="vm.trRow.rowTypeAttributeValues[$index].attributeValue = attribute.rowTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.trRow.rowTypeAttributeValues[$index].attributeValue" ng-if="attribute.rowTypeAttribute.attributeDataType.name == \'STRING\' && vm.trRow.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.rowTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.trRow.rowTypeAttributeValues[$index].attributeValue" ng-init="vm.trRow.rowTypeAttributeValues[$index].attributeValue = attribute.rowTypeAttribute.defaultValue" ng-if="attribute.rowTypeAttribute.attributeDataType.name != \'STRING\' && attribute.rowTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.rowTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trRow.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.rowTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.trRow.rowTypeAttributeValues[$index].attributeValue" ng-init="vm.trRow.rowTypeAttributeValues[$index].attributeValue == attribute.rowTypeAttribute.defaultValue" ng-if="attribute.rowTypeAttribute.attributeDataType.name != \'STRING\' && attribute.rowTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.rowTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trRow.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.rowTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div><div class="form-group" ng-if="vm.trRow.id"><label class="col-md-3 control-label"><span>Phase</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="status" ng-model="vm.trRow.phase" ng-disabled="!has_ROLE_PLAN_ADMIN"><option value="">--- Select Phase ---</option><option ng-repeat="item in vm.workFlowPhase" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-if="vm.trRow.id"><label class="col-md-3 control-label"><span>Verify</span></label><div class="col-md-7"><select class="form-control" ng-model="vm.trRow.isVerified" required><option value="false">NO</option><option value="true">YES</option></select></div></div></div><jhi-alert></jhi-alert><div class="box-footer"><jhi-alert-error></jhi-alert-error><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-row"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form name="pinForm" role="form" class="form-horizontal" novalidate show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label" for="pinA"><span translate=" ">Point A :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinA" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateA" required></div></div><div class="form-group"><label class="col-md-4 control-label" for="pinB"><span translate=" ">Point B :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinB" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateB" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'modalLatLongs\')">Cancel</button> <button type="button" class="btn btn-primary" ng-disabled="!vm.getLocationCoordinateA || !vm.getLocationCoordinateB" ng-click="vm.onLocationCoordinates()">OK</button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-row/tr-rows.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-rows"></i> <span>Rows</span></h3></div><div class="box-tools row_labels" ng-if="Roles.ROW_CREATE"><button class="btn btn-create btn-sm" ng-click="vm.createRow()"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><th>Row Type</th><th>Route</th><th>Phase</th><th>Created Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="row in vm.rows | filter: users track by row.id" ng-class="{selected: row.isChecked}"><td><a ui-sref="tr-row-detail({id:row.id})">{{row.name}}</a></td><td>{{row.rowTypeName}}</td><td>{{row.routeName}}</td><td>{{row.phase}}</td><td>{{row.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><div class="action"><a ui-sref="tr-row-detail({id:row.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="tr-row.edit({id:row.id })" class="action-icons text-primary" title="Edit" ng-if="Roles.ROW_CREATE"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.rows == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-section/material-txn.dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-tasks"></i> <span ng-if="!vm.isShow">Create</span> <span ng-if="vm.isShow">Edit</span> Material Transaction</h3></div><!--  <div class="box-tools" ng-if="!vm.isShow" >\r\n                    <button class="btn btn-create btn-sm" ng-disabled="editForm.$invalid" ng-click="addDetails()">\r\n                        <span class="glyphicon glyphicon-plus"></span>\r\n                        <span>\r\n                            Add\r\n                        </span>\r\n                    </button>\r\n                </div> --></div><div class="box-body"><form name="editForm" class="form-horizontal" role="form" novalidate show-validation><div class="box-body"><!--  <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Material</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <select class="form-control select2" ng-model="vm.materialTxn.materialId"\r\n                                ng-options="item.id as item.name for item in vm.materials" required>\r\n    \r\n                                <option value="" >\r\n                                    --- Select Material ---\r\n                                </option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n    \r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>No of Units</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <input type="number" class="form-control" name="name" \r\n                                ng-model="vm.materialTxn.noOfUnits" required min="0" />\r\n                        </div>\r\n                    </div>\r\n    \r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Invoice Number</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <input type="text" class="form-control" name="name" \r\n                                ng-model="vm.materialTxn.invoiceNumber"  />\r\n                        </div>\r\n                    </div>\r\n    \r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Remarks</span>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <input type="text" class="form-control" name="name" \r\n                                ng-model="vm.materialTxn.remarks"  />\r\n                        </div>\r\n                    </div>\r\n    \r\n                        <div class="form-group">\r\n                            <label class="col-md-3 control-label">\r\n                                <span>Transaction Date</span>\r\n                                <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                </sup>\r\n                            </label>\r\n                            <div class="col-md-3">\r\n                                <div class="input-group">\r\n                                     <span class="input-group-btn">\r\n                                        <button type="button" class="btn btn-default"\r\n                                            ng-click="vm.openCalendar(\'workDate\')"> <i\r\n                                                class="glyphicon glyphicon-calendar"></i></button>\r\n                                    </span>\r\n                                   <input id="field_serviceDate" type="text" class="form-control"\r\n                                        name="workDate" ng-model="vm.materialTxn.txnDate" \r\n                                        datetime-picker="dd/MM/yyyy hh:mm a " is-open="vm.datePickerOpenStatus.workDate"\r\n                                         datepicker-options="vm.options" required /> \r\n                                         \r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n    \r\n                        <div class="form-group">\r\n                            <label class="col-md-3 control-label">\r\n                                <span>Transaction Type</span>\r\n                                <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                </sup>\r\n                            </label>\r\n                            <div class="col-md-3">\r\n                                <select class="form-control" name="status" ng-model="vm.materialTxn.transactionType" \r\n                            required>\r\n                            \r\n                           <option ng-repeat="item in vm.transactionType" value="{{item}}">{{item}}</option>\r\n                            </select>\r\n                            </div> \r\n                        </div> --><div class="col-md-12" ng-if="!vm.isShow"><div class="form-group col-md-3 mr-10-cent"><label class="control-label"><span>Select Date</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <input type="datetime-local" class="form-control" name="selectDate" ng-model="vm.selectDate" id="dateInput" max="{{ vm.options.maxDate | date:\'yyyy-MM-dd\' }}" ng-change="vm.onSelectedMaterial()" required><!--  <input type="time" class="form-control" name="selectTime" ng-model="vm.selectTime" id="timeInput" min="00:00"\r\n                                    max="23:59" ng-if="vm.selectDate" required> --></div><div class="form-group col-md-2 mr-10-cent" ng-if="vm.selectDate"><label class="control-label"><span>Transaction Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <select class="form-control" name="status" ng-model="vm.selectTransactionType" required ng-change="vm.onSelectedMaterial()"><option value="">--- Select ---</option><option ng-repeat="item in vm.transactionType" value="{{item}}">{{item}}</option></select></div><div class="dropFilter col-md-4 mr-10-cent" ng-if="vm.selectTransactionType && vm.selectDate"><label class="control-label"><span>Select Materials</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div isteven-multi-select input-model="vm.materials" output-model="vm.selectedMaterial" button-label="name" item-label="name" tick-property="ticked" on-select-done="vm.onSelectedMaterial()" output-properties="id" translation="type.materials" max-height="236px" max-labels="1" helper-elements="all none Done filter"></div></div><!-- <div class="col-md-1" ng-if="vm.selectedMaterial.length">\r\n                                <label class="control-label">\r\n                                   \r\n                                </label>\r\n                                <button type="button" \r\n                                class="btn btn-primary btn-sm"  on-select-done="vm.onSelectedMaterial()">\r\n                                <span>Done</span>\r\n                            </button> --></div></div><table class="jh-table table table-responsive table-hover" ng-if="vm.materialTxn.length ||  vm.isShow"><tr><th>No</th><th>Material<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></th><th>Units of Measurement</th><th>Quantity<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></th><th>Invoice Number</th><th>Remarks</th><!--  <th>Transaction Date<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></th>\r\n                                <th>Transaction Type<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></th> --></tr><tr ng-repeat="list in vm.materialTxn track by $index"><td>{{$index+1}}</td><td><select class="form-control select2" ng-model="list.materialId" ng-options="item.id as item.name for item in vm.materials" ng-change="vm.onChangeUom(list.materialId,$index)" ng-disabled="true" required><option value="">--- Select Material ---</option></select></td><td><input type="text" class="form-control" name="uom" ng-model="list.unitOfMeasurement" disabled="disabled"></td><td><input type="number" class="form-control" name="name" ng-model="list.noOfUnits" required min="0"></td><td><input type="text" class="form-control" name="name" ng-model="list.invoiceNumber"></td><td><input type="text" class="form-control" name="name" ng-model="list.remarks"></td><!-- <td>\r\n                                     <input type="date" class="form-control" ng-change="vm.dateChanged($index)"\r\n                                name="workDate" ng-model="list.transactionDate" id="dateInput"  max="{{ vm.options.maxDate | date:\'yyyy-MM-dd\' }}"required>\r\n                                </td>\r\n                                <td>\r\n                                    <select class="form-control select2" name="status" ng-model="list.transactionType" \r\n                            required>\r\n                            <option value="" >\r\n                                --- Select ---\r\n                            </option>\r\n                           <option ng-repeat="item in vm.transactionType" value="{{item}}">{{item}}</option>\r\n                            </select>\r\n                                </td> --><td ng-if="!vm.materialTxn[0].id"><!--  <a ng-click="editDetails($index,\'cableDetails\')"\r\n                                        class="action-icons text-primary" title="Edit"><span\r\n                                            class="fa fa-pencil-square"></span></a> --> <a ng-click="removeDetails($index)" class="action-icons text-primary" title="Remove"><span class="fa fa-trash-o"></span></a></td></tr></table></form></div><div class="box-footer"><jhi-alert></jhi-alert><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" onclick="history.back()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-section/resource-txn.dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-tasks"></i> <span ng-if="!vm.isShow">Create</span> <span ng-if="vm.isShow">Edit</span> Resource Transaction</h3></div><!-- <div class="box-tools" ng-if="!vm.isShow" >\r\n                    <button class="btn btn-create btn-sm" ng-disabled="editForm.$invalid" ng-click="addDetails()">\r\n                        <span class="glyphicon glyphicon-plus"></span>\r\n                        <span>\r\n                            Add\r\n                        </span>\r\n                    </button>\r\n                </div> --></div><div class="box-body"><form name="editForm" class="form-horizontal" role="form" novalidate show-validation><div class="box-body"><!-- <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>Resources</span>\r\n                        <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                        </sup>\r\n                    </label>\r\n\r\n                    <div class="col-md-3">\r\n                        <select class="form-control select2" ng-model="vm.resourceTxn.resourceId"\r\n                            ng-options="item.id as item.name for item in vm.resources" required>\r\n\r\n                            <option value="" >\r\n                                --- Select Resource ---\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                    \r\n                </div>\r\n\r\n                <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>No of Resource</span>\r\n                        <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                        </sup>\r\n                    </label>\r\n                    <div class="col-md-3">\r\n                        <input type="number" class="form-control" name="name" \r\n                            ng-model="vm.resourceTxn.noOfResources" required min="0" />\r\n                    </div>\r\n                </div>\r\n\r\n                \r\n\r\n                <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>No of Work Hours</span>\r\n                        <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                        </sup>\r\n                    </label>\r\n                    <div class="col-md-3">\r\n                        <input type="number" class="form-control" name="numberOfHours" \r\n                            ng-model="vm.resourceTxn.numberOfHours" ng-max="maxNoOfWorkingHours" min="0" required />\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>Remarks</span>\r\n                    </label>\r\n                    <div class="col-md-3">\r\n                        <input type="text" class="form-control" name="name" \r\n                            ng-model="vm.resourceTxn.remarks"  />\r\n                    </div>\r\n                </div>\r\n\r\n                   \r\n\r\n                <div class="form-group">\r\n                    <label class="col-md-3 control-label">\r\n                        <span>Transaction Date</span>\r\n                        <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                        </sup>\r\n                    </label>\r\n                    <div class="col-md-3">\r\n                        <div class="input-group">\r\n                             <span class="input-group-btn">\r\n                                <button type="button" class="btn btn-default"\r\n                                    ng-click="vm.openCalendar(\'workDate\')"> <i\r\n                                        class="glyphicon glyphicon-calendar"></i></button>\r\n                            </span>\r\n                           <input id="field_serviceDate" type="text" class="form-control"\r\n                                name="workDate" ng-model="vm.resourceTxn.transactionDate" \r\n                                datetime-picker="dd/MM/yyyy hh:mm a " is-open="vm.datePickerOpenStatus.workDate"\r\n                                 datepicker-options="vm.options" required /> \r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                    <div class="form-group">\r\n                        <label class="col-md-3 control-label">\r\n                            <span>Transaction Type</span>\r\n                            <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                            </sup>\r\n                        </label>\r\n                        <div class="col-md-3">\r\n                            <select class="form-control" name="status" ng-model="vm.resourceTxn.transactionType" \r\n                        required>\r\n                        \r\n                       <option ng-repeat="item in vm.transactionType" value="{{item}}">{{item}}</option>\r\n                        </select>\r\n                        </div> \r\n                    </div> --><div class="col-md-12" ng-if="!vm.isShow"><div class="form-group col-md-3 mr-10-cent"><label class="control-label"><span>Select Date</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <input type="datetime-local" class="form-control" name="selectDate" ng-model="vm.selectDate" id="dateInput" max="{{ vm.options.maxDate | date:\'yyyy-MM-dd\' }}" ng-change="vm.onSelectedMaterial()" required></div><div class="form-group col-md-2 mr-10-cent" ng-if="vm.selectDate"><label class="control-label"><span>Transaction Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <select class="form-control" name="status" ng-model="vm.selectTransactionType" required ng-change="vm.onSelectedResource()"><option value="">--- Select ---</option><option ng-repeat="item in vm.transactionType" value="{{item}}">{{item}}</option></select></div><div class="dropFilter col-md-4 mr-10-cent" ng-if="vm.selectTransactionType && vm.selectDate"><label class="control-label"><span>Select Resources</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div isteven-multi-select input-model="vm.resources" output-model="vm.selectedResource" button-label="name" item-label="name" tick-property="ticked" on-select-done="vm.onSelectedResource()" output-properties="id" translation="type.resources" max-height="236px" max-labels="1" helper-elements="all none Done filter"></div></div><!-- <div class="col-md-1" ng-if="vm.selectedMaterial.length">\r\n                            <label class="control-label">\r\n                               \r\n                            </label>\r\n                            <button type="button" \r\n                            class="btn btn-primary btn-sm"  on-select-done="vm.onSelectedMaterial()">\r\n                            <span>Done</span>\r\n                        </button> --></div></div><table class="jh-table table table-responsive table-hover" ng-if="vm.resourceTxn.length ||  vm.isShow"><tr><th>No</th><th>Resources<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></th><th>No of Resource<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></th><th ng-hide="vm.selectTransactionType == \'REQUESTED\'">No of Work Hours<!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> --></th><th>Remarks</th><!-- <th>Transaction Date<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></th>\r\n                            <th>Transaction Type<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></th> --></tr><tr ng-repeat="list in vm.resourceTxn track by $index"><td>{{$index+1}}</td><td><select class="form-control select2" ng-model="list.resourceId" ng-options="item.id as item.name for item in vm.resources" ng-disabled="true" required><option value="">--- Select Resource ---</option></select></td><td><input type="number" class="form-control" name="name" ng-model="list.noOfResources" required min="0"></td><td ng-hide="vm.selectTransactionType == \'REQUESTED\'"><input type="number" class="form-control" name="numberOfHours" ng-model="list.numberOfHours" ng-max="maxNoOfWorkingHours" min="0"></td><td><input type="text" class="form-control" name="name" ng-model="list.remarks"></td><!-- <td>\r\n                                 <input type="date" class="form-control" ng-change="vm.dateChanged($index)"\r\n                            name="workDate" ng-model="list.transactionDate" id="dateInput"  max="{{ vm.options.maxDate | date:\'yyyy-MM-dd\' }}"required>\r\n                            </td>\r\n                            <td>\r\n                                <select class="form-control" name="status" ng-model="list.transactionType" \r\n                        required>\r\n                        <option value="" >\r\n                            --- Select ---\r\n                        </option>\r\n                       <option ng-repeat="item in vm.transactionType" value="{{item}}">{{item}}</option>\r\n                        </select>\r\n                            </td> --><td ng-if="!vm.resourceTxn[0].id"><!--  <a ng-click="editDetails($index,\'cableDetails\')"\r\n                                    class="action-icons text-primary" title="Edit"><span\r\n                                        class="fa fa-pencil-square"></span></a> --> <a ng-click="removeDetails($index)" class="action-icons text-primary" title="Remove"><span class="fa fa-trash-o"></span></a></td></tr></table></form></div><div class="box-footer"><jhi-alert></jhi-alert><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" onclick="history.back()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-section/tr-section-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this section needs to be deleted before deleting section</p><p translate="trakeyeApp.task.delete.question" translate-values="{id: \'{{vm.trTask.id}}\'}">Are you sure you want to delete this Tr Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-section/tr-section-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><!-- <h3 class="box-title pull-left">\r\n\t\t\t\t\t\tSection\r\n\t\t\t\t\t</h3> --><div class="col-md-7 col-sm-2"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab"><i class="fa fa-info-circle"></i><span class="header-view"></span> <span class="header_view">Details</span></a></li><!--  <li ng-class="{active:isSet(2)}">\r\n\t\t\t\t\t\t\t\t<a href ng-click="setTab(2); search = null;" data-toggle="tab"><i\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-map"></i><span class="header-view">Map</span> <span\r\n\t\t\t\t\t\t\t\t\t\tclass="header_view">View</span></a>\r\n\t\t\t\t\t\t\t</li> --><!-- <li ng-class="{active:isSet(4)}">\r\n\t\t\t\t\t\t\t\t<a href ng-click="setTab(4); search = null;" data-toggle="tab"><i\r\n\t\t\t\t\t\t\t\t\t\tclass="fa fa-list"></i><span class="header-view"> Work Progress</span> </a>\r\n\t\t\t\t\t\t\t</li> --><li ng-class="{active:(isSet(3) || isSet(5) || isSet(6))}"><a href ng-click="setTab(3); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view"> Summary</span></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2); search = null" data-toggle="tab"><i class="fa fa-commenting"></i><span class="header-view">Comments</span></a></li></ul></div></div><div class="box-body" ng-show="isSet(1)"><!-- <jhi-alert-error></jhi-alert-error> --><jhi-alert></jhi-alert><div class="flexeven mb-5"><a href="javascript:void(0);" onclick="history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><button class="btn btn-create btn-sm" ng-click="vm.autoGenerateTask()" ng-show="Roles.TASK_CREATE"><span class="fa fa-cog"></span> <span>Auto-Generate Task</span></button> <button class="btn btn-create btn-sm" ui-sref="tr-task.new({routeId:vm.trSection.routeId, sectionId : vm.trSection.id })" ng-show="Roles.TASK_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Task</span></button> <button class="btn btn-create btn-sm" ui-sref="tr-section.materialTxndialog({entityId : vm.trSection.id , entityName : \'sectionId\' })" ng-show="Roles.MATERIALTX_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Material Transactions</span></button> <button class="btn btn-create btn-sm" ui-sref="tr-section.resourceTxndialog({entityId : vm.trSection.id , entityName : \'sectionId\' })" ng-show="Roles.RESOURCETX_CREATE"><span class="glyphicon glyphicon-plus"></span> <span>Add Resource Transactions</span></button> <a ui-sref="tr-section.edit({id:vm.trSection.id,routeId:vm.trSection.routeId})" class="btn btn-primary btn-sm" ng-show="Roles.SECTION_EDIT"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div><div class="row mt-15"><div class="col-md-4"><dl class="dl-horizontal jh-entity-details mt-5"><dt><span>Section Name</span></dt><dd><span>{{vm.trSection.name}}</span></dd><dt><span>Project Name</span></dt><dd><span>{{vm.trSection.projectName}}</span></dd><dt><span>Route Name</span></dt><dd><span>{{vm.trSection.routeName}}</span></dd><dt><span translate="trakeyeApp.section.description">Description</span></dt><dd><span>{{vm.trSection.description}}</span></dd><dt><span>Section Length (mtrs)</span></dt><dd><span>{{vm.trSection.sectionLength}}</span></dd><dt><span translate="trakeyeApp.section.status">Status</span></dt><dd><!-- <span translate="{{\'trakeyeApp.SectionStatus.\' + vm.trSection.status}}">{{vm.trSection.status}}</span> --> <span>{{vm.trSection.status}}</span></dd><dt><span>Create Date</span></dt><dd><span>{{vm.trSection.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><!-- \r\n\t\t\t\t\t\t\t\t<dt>\r\n\t\t\t\t\t\t\t\t\t<span translate="trakeyeApp.section.updateDate">Update Date</span>\r\n\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t\t\t<span>{{vm.trSection.lastModifiedDate |\r\n\t\t\t\t\t\t\t\t\t\tdate:\'mediumDate\'}}</span>\r\n\t\t\t\t\t\t\t\t</dd> --><dt><span translate="trakeyeApp.section.sectionType">Section Type</span></dt><dd ng-if="has_ROLE_USER_ADMIN">{{vm.trSection.sectionType.name}}</dd><dd ng-if="has_ROLE_USER">{{vm.trSection.sectionType.name}}</dd><div class="form-group" ng-repeat="attribute in vm.trSection.sectionTypeAttributeValues"><div ng-repeat="attributeValue in vm.trSection.sectionTypeAttributeValues track by $index"><div ng-if="attributeValue.sectionTypeAttribute.id == attribute.sectionTypeAttribute.id"><dt><span>{{attribute.sectionTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></div></div></div><!-- <dt>\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-2 trSection_showImgDiv" ng-if="vm.trSection.id">\r\n\t\t\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'image\')">\r\n\t\t\t\t\t\t\t\t\t\t\t<span ng-hide="vm.showImages">Show Images</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span ng-show="vm.showImages">Hide Images</span></a>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t<dd ng-if="allimages">\r\n\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="col-md-3" ng-repeat="img in vm.sectionImages">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img ng-if="img.image != null" class="img-responsive img__img-responsive"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-src="data:image/jpeg;base64,{{img.image}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.imageInNewTab(img.image)" /><br />\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s" ng-show="img.imgDescription != null"><b>Description :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgDescription}}</span><br />\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-show="img.imgLat != null && img.imgLong != null"><b>LatLng :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgLat}},{{img.imgLong}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</dd> --></dl></div><div class="col-md-8"><div id="map_canvasStart" class="div__map-canvas"></div><div class="pull-right"><span id="myspan">Zoom : {{vm.objectRouteImg.zoomLevel}}</span></div></div></div><!-- <div id="audioLayout"></div>\r\n\t\t\t\t\t<div class="box-buttons pull-right">\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t</div> --><div class="col-md-12" ng-show="vm.taskResponse.length"><a class="btn btn-sm btn-primary" ng-click="toggle(\'task\')"><span ng-hide="vm.showTask">Show Task </span><span ng-show="vm.showTask">Hide Task</span></a><div class="table-responsive" ng-if="vm.showTask"><h3>Task Details</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Name</th><th>Task Type</th><th>Status</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="task in  vm.taskResponse"><td><a ui-sref="tr-task-detail({id:task.id})">{{task.name}}</a></td><td>{{task.taskType.name}}</td><td>{{task.status}}</td><td><a ui-sref="tr-task-detail({id:task.id})" class="action-icons text-info" title="View" ng-if="Roles.TASK_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-task.edit({id:task.id, routeId :vm.trSection.routeId,sectionId:vm.trSection.id })" class="action-icons text-primary" title="Edit" ng-if="Roles.TASK_EDIT"><span class="fa fa-pencil-square"></span></a></td></tr><td colspan="2" ng-show="vm.taskResponse.length == 0"><h4>No Tasks available</h4></td></tbody></table></div></div><h4 ng-show="!vm.taskResponse.length">No Task available</h4><br><div class="col-md-12 mt-5" ng-show="vm.sectionMaterial.length"><a class="btn btn-sm btn-primary" ng-click="toggle(\'material\')"><span ng-hide="vm.showMaterial">Show Material Transaction</span> <span ng-show="vm.showMaterial">Hide Material Transaction</span></a><div class="table-responsive mt-10" ng-show="vm.showMaterial"><h3>Material</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Invoice Number</th><th>Material Name</th><th>Units of Measurement</th><th>Quantity</th><th>Remarks</th><th>Transaction Type</th><th>Transaction Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="material in  vm.sectionMaterial"><td>{{material.invoiceNumber}}</td><td>{{material.materialName}}</td><td>{{material.unitOfMeasurement}}</td><td>{{material.noOfUnits}}</td><td>{{material.remarks}}</td><td>{{material.transactionType}}</td><td>{{material.transactionDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><a ui-sref="tr-section.materialTxndialog({id:material.id, entityId :material.sectionId, entityName : \'sectionId\'  })" class="action-icons text-primary" title="Edit" ng-if="Roles.MATERIALTX_EDIT"><span class="fa fa-pencil-square"></span></a></td></tr></tbody></table></div></div><h4 ng-show="!vm.sectionMaterial.length">No Material Transactions available</h4><br><div class="col-md-12 mt-5" ng-show="vm.sectionResource.length"><a class="btn btn-sm btn-primary" ng-click="toggle(\'resource\')"><span ng-hide="vm.showResource">Show Resource Transaction</span> <span ng-show="vm.showResource">Hide Resource Transaction</span></a><div class="table-responsive mt-10" ng-if="vm.showResource"><h3>Resource</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Resource Name</th><th>No of Resource</th><th>No of Work Hours</th><th>Remarks</th><th>Transaction Type</th><th>Transaction Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat="resource in  vm.sectionResource"><td>{{resource.resourceName}}</td><td>{{resource.noOfResources}}</td><td>{{resource.numberOfHours}}</td><td>{{resource.remarks}}</td><td>{{resource.transactionType}}</td><td>{{resource.transactionDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><a ui-sref="tr-section.resourceTxndialog({id:resource.id, sectionId:resource.sectionId })" class="action-icons text-primary" title="Edit" ng-if="Roles.RESOURCETX_EDIT"><span class="fa fa-pencil-square"></span></a></td></tr></tbody></table></div></div><h4 ng-show="!vm.sectionResource.length">No Resource Transactions available</h4><br></div><!-- <div class="box-body" ng-show="isSet(2)">\r\n\t\t\t\t\t\r\n\t\t\t\t</div> --><comments obj="vm.objectComments" ng-if="isSet(2)"></comments><div class="mt-10" ng-show="isSet(3) || isSet(5) ||isSet(6) "><div class="col-md-3 col-sm-3" style="padding: 5px;\r\n\t\t\t\t\t\tmargin: 5px;"><ul class="nav nav-pills"><li ng-class="{active:isSet(3)}"><a href ng-click="setTab(3); search = null;" data-toggle="tab"><span class="header-view">Tasks</span><!--  <span\r\n\t\t\t\t\t\t\t\t\t\t\tclass="header_view">Log</span> --></a></li><li ng-class="{active:isSet(5)}"><a href ng-click="setTab(5); search = null" data-toggle="tab"><span class="header-view">Material</span></a></li><li ng-class="{active:isSet(6)}"><a href ng-click="setTab(6); search = null" data-toggle="tab"><span class="header-view">Resource</span></a></li></ul></div></div><div class="col-sm-12" ng-show="isSet(3)"><!-- <button class="btn btn-primary center-block" ng-click="getPdf()" ng-if=\'vm.isReportGenerated==true\' style="margin: 10px;"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="generatedHtmlContainer" style="width: calc(100% - 40px);overflow-x: auto;overflow-y: hidden;"></div></div><div class="table-responsive mt-10" ng-show="isSet(3)"><h3>Logs</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Name</th><th>Total Work Length (mtrs)</th><th>Total Number of Hours</th><th>Log Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsTxSummary"><td><a ui-sref="tr-task-detail({id:task.taskId})" target="_blank">{{task.taskId}}</a></td><td>{{task.taskName}}</td><td>{{task.workLength}}</td><td>{{task.noOfHours}}</td><td>{{task.taskLogType}}</td></tr><td colspan="2" ng-show="vm.dailyLogsTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="box-body mt-0" ng-show="isSet(4)"><div class="row mt-5"><div class="table-responsive col-md-5"><div class="scroll_dailyTask"><h3>Task Details</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Logs</th><th>Name</th><th>Length</th><th>Task Type</th><th>Status</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="task in vm.taskLogResponse" ng-mouseover="vm.highlightTask(task.id)" ng-mouseleave=" vm.resetTask()"><td class="td__listViewRow" expand ng-click="vm.expand(task)"><span ng-if="!task.isExpanded" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Open"></i> </span><span ng-if="task.isExpanded" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Close"></i></span></td><td><a ui-sref="tr-task-detail({id:task.id})">{{task.name}}</a></td><td></td><td>{{task.taskType}}</td><td>{{task.status}}</td><td><a ui-sref="tr-task-detail({id:task.id})" class="action-icons text-info" title="View" ng-if="Roles.TASK_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-task.edit({id:task.id, routeId: vm.trSection.routeId, sectionId: vm.trSection.id})" class="action-icons text-primary" title="Edit" ng-if="Roles.TASK_EDIT"><span class="fa fa-pencil-square"></span></a></td></tr><tr ng-if="task.isExpanded"><td colspan="11"><div class="scroll_logs"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>SlNo</th><th>Work Date</th><th>Work Length (mtrs)</th><th>Number of Hours</th><th>Start (Lat,Lng)</th><th>End (Lat,Lng)</th><th>Created Date</th><th>Created By</th></tr></thead><tbody><tr ng-repeat="dailyLog in vm.dailyLogs" ng-mouseover="vm.highlightLog(dailyLog.id)" ng-mouseleave="vm.resetLog()"><td>{{$index + 1}}</td><td>{{dailyLog.workDate | date:\'dd-MM-yyyy h:mma\'}}</td><td>{{dailyLog.workLength}}</td><td>{{dailyLog.numberOfHours}}</td><td>{{dailyLog.fromRoutePointLat | limitTo: 6}},{{dailyLog.fromRoutePointLng | limitTo: 6}}</td><td>{{dailyLog.toRoutePointLat | limitTo: 6}},{{dailyLog.toRoutePointLng | limitTo: 6}}</td><td>{{dailyLog.createdDate | date:\'dd-MM-yyyy h:mma\'}}</td><td>{{dailyLog.createdBy}}</td></tr><td colspan="4" ng-show="vm.dailyLogs.length == 0"><h4>No Logs Available</h4></td></tbody></table></div></td></tr><tr ng-repeat-end></tr><td colspan="2" ng-show="vm.taskLogResponse.length == 0"><h4>No Task Available</h4></td></tbody></table></div></div><div class="col-md-7"><div id="map_canvasStart1" class="div__map-canvas"></div></div></div></div><br><br><br><div class="table-responsive mt-10" ng-show="isSet(5)"><h3>Summary</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th>ID</th> --><th>Name</th><th>Units of Measurement</th><th>Quantity</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.mtrlTxSummary"><!-- <td>\r\n\t\t\t\t\t\t\t\t\t\t{{task.materialId}}\r\n\t\t\t\t\t\t\t\t\t</td> --><td>{{task.materialName}}</td><td>{{task.unitOfMeasurementName}}</td><td>{{task.totalNoOfUnits}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="vm.mtrlTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table><div class="table-responsive mt-10"><h3>Material Inventory Transaction</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th></th><th>Date</th><th>Total</th></tr></thead><tbody><tr ng-repeat-start="task in vm.materialByDate"><td class="td__listViewRow" ng-click="vm.toggleExpand(task)" expand><span ng-if="!task.isExpand" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true" ng-click="vm.loadMaterialTxnByDates(task.timestamp)"></i> </span><span ng-if="task.isExpand" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{task.timestamp | date:\'dd-MM-yyyy\'}}</td><td>{{task.total}}</td></tr><tr ng-if="task.isExpand"><td></td><td colspan="4"><table class="table__userNames"><thead><tr><th>SlNo</th><th>Date</th><th>Material-ID</th><th>Material-Name</th><th>TransactionId</th><th>No of Units</th><th>Transaction-Type</th><th>Action</th></tr></thead><tbody><tr ng-repeat="detail in vm.materialTxnByDates"><td>{{$index + 1}}</td><td>{{detail.timestamp | date:\'dd-MM-yyyy\'}}</td><td>{{detail.materialId}}</td><td>{{detail.materialName}}</td><td>{{detail.mtrlTxNumber}}</td><td>{{detail.count}}</td><td>{{detail.status}}</td><td><div class="action"><a class="action-icons text-primary" title="Edit Transaction" ng-click="vm.openTransactionModal(detail)"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td colspan="7"><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadMaterialTxnByDates(task.timestamp)"></uib-pagination></div></div></div></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr ng-show="vm.materialByDate.length == 0"><td colspan="3"><h4>No Transaction Available</h4></td></tr></tbody></table><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.mtrpage" total="vm.QueryCount" items-per-page="vm.mtrPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.TotalItems" ng-model="vm.mtrpage" ng-change="vm.loadMaterialTxnDate()"></uib-pagination></div></div></div></div></div><br><br><br><div class="table-responsive mt-10" ng-show="isSet(6)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th>ID</th> --><th>Name</th><th>Total no of Resources</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.resTxSummary"><!-- <td>\r\n\t\t\t\t\t\t\t\t\t\t{{task.materialId}}\r\n\t\t\t\t\t\t\t\t\t</td> --><td>{{task.resourceName}}</td><td>{{task.totalNoOfResources}}</td><td>{{task.transactionType}}</td></tr><td colspan="2" ng-show="vm.resTxSummary.length == 0"><h4>No Summary Available</h4></td></tbody></table></div></div></div></div><div class="modals" ng-if="vm.isModalOpen"><div class="modal-contents"><h4>Edit Transaction</h4><form name="editForm"><table class="modal-table"><tr><td><label>Transaction ID:</label></td><td><input type="text" ng-model="vm.selectedTransaction.mtrlTxNumber" disabled="disabled"></td></tr><tr><td><label>Select Date:</label></td><td><input type="datetime-local" max="{{ vm.options.maxDate | date:\'yyyy-MM-dd\' }}" ng-model="vm.selectedTransaction.transactionDate"></td></tr><tr ng-if="vm.selectedTransaction.transactionDate"><td><label>Material Name:</label></td><td><input type="text" ng-model="vm.selectedTransaction.materialName"></td></tr><tr ng-if="vm.selectedTransaction.materialName"><td><label>Material ID:</label></td><td><input type="text" ng-model="vm.selectedTransaction.materialId"></td></tr><tr ng-if="vm.selectedTransaction.materialId"><td><label>No of Units:</label></td><td><input type="text" ng-model="vm.selectedTransaction.noOfUnits"></td></tr><tr ng-if="vm.selectedTransaction.noOfUnits"><td><label>Transaction Type:</label></td><td><select ng-model="vm.selectedTransaction.transactionType"><option value="">--- Select ---</option><option ng-repeat="item in vm.transactionType" value="{{item}}">{{item}}</option></select></td></tr></table><div class="modal-actions"><button type="button" class="btn btn-default btn-sm" ng-click="vm.cancelTransaction()">Cancel</button> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.saveTransaction()" ng-disabled="!vm.selectedTransaction.transactionDate || \r\n\t\t\t\t\t!vm.selectedTransaction.materialName || \r\n\t\t\t\t\t!vm.selectedTransaction.materialId || \r\n\t\t\t\t\t!vm.selectedTransaction.noOfUnits || \r\n\t\t\t\t\t!vm.selectedTransaction.transactionType">Save</button></div></form></div></div></div><!-- <route-image obj="vm.objectRouteImg"></route-image> -->');
$templateCache.put('app/entities/tr-section/tr-section-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrSectionLabel"><span ng-if="!vm.trSection.id">Create</span> <span ng-if="vm.trSection.id">Edit Section - {{vm.trSection.name}} - {{vm.trSection.id}}</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div class="form-group"><label class="col-md-3 control-label"><span>Route Name</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trSection.routeName" disabled="disabled"></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.section.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trSection.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.section.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trSection.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Select Section</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <button type="button" class="btn btn-primary btn-sm ml-5" ng-click="vm.removeMarker()" title="Clear Selected Points"><span class="fa fa-refresh"></span></button><div id="map_canvasStart" class="div__map-canvas col-md-8"></div><div class="pull-right"><span id="myspan">Zoom : {{vm.objectRouteImg.zoomLevel}}</span></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Section Length (mtrs)</span></label><div class="col-md-3"><input type="number" class="form-control" name="length" ng-model="vm.sectionDistance" readonly="readonly" min="0"></div></div><!-- <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>End Marker</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <div id="map_canvasEnd" class="div__map-canvas"></div>\r\n                                </div>\r\n                            </div>  --><div class="form-group"><label class="col-md-3 control-label"><span>Section Type</span> <sup ng-show="!vm.trSection.id"><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control select2" name="sectionType" ng-model="vm.sectionType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                        vm.sectionTypes track by item.id" ng-disabled="vm.trSection.id!=null" ng-required="!vm.trSection.id" style="width: 100%"><option value="" translate="trakeyeApp.section.selectsection">--- Select SectionType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.trSection.sectionTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.sectionTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.trSection.sectionTypeAttributeValues[$index].attributeValue" ng-if="attribute.sectionTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trSection.id" type="text" class="form-control" ng-init="vm.trSection.sectionTypeAttributeValues[$index].attributeValue = attribute.sectionTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.trSection.sectionTypeAttributeValues[$index].attributeValue" ng-if="attribute.sectionTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.trSection.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.sectionTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.trSection.sectionTypeAttributeValues[$index].attributeValue" ng-if="attribute.sectionTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trSection.id" type="text" class="form-control" ng-init="vm.trSection.sectionTypeAttributeValues[$index].attributeValue = attribute.sectionTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.trSection.sectionTypeAttributeValues[$index].attributeValue" ng-if="attribute.sectionTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trSection.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.sectionTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.trSection.sectionTypeAttributeValues[$index].attributeValue" ng-if="attribute.sectionTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trSection.id" type="text" class="form-control" ng-init="vm.trSection.sectionTypeAttributeValues[$index].attributeValue = attribute.sectionTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.trSection.sectionTypeAttributeValues[$index].attributeValue" ng-if="attribute.sectionTypeAttribute.attributeDataType.name == \'STRING\' && vm.trSection.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.sectionTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.trSection.sectionTypeAttributeValues[$index].attributeValue" ng-init="vm.trSection.sectionTypeAttributeValues[$index].attributeValue = attribute.sectionTypeAttribute.defaultValue" ng-if="attribute.sectionTypeAttribute.attributeDataType.name != \'STRING\' && attribute.sectionTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.sectionTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trSection.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.sectionTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.trSection.sectionTypeAttributeValues[$index].attributeValue" ng-init="vm.trSection.sectionTypeAttributeValues[$index].attributeValue == attribute.sectionTypeAttribute.defaultValue" ng-if="attribute.sectionTypeAttribute.attributeDataType.name != \'STRING\' && attribute.sectionTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.sectionTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trSection.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.sectionTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div><div class="form-group" ng-if="vm.trSection.id"><label class="col-md-3 control-label"><span>Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="status" ng-model="vm.trSection.status" id="field_status" required><option value="">--- Select Status ---</option><option ng-repeat="item in vm.rolloutTaskStatus" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-if="vm.trRoute.id"><label class="col-md-3 control-label"><span>Phase</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control" name="status" ng-model="vm.trSection.phase" ng-disabled="!has_ROLE_PLAN_ADMIN" required><option value="">--- Select Phase ---</option><option value="PLANNING">PLANNING</option><option value="SURVEY">SURVEY</option><option value="PRE_PLANNING">PRE_PLANNING</option><option value="POST_PLANNING">POST_PLANNING</option><option value="PROPOSED">PROPOSED</option><option value="PRE_ROLLOUT">PRE_ROLLOUT</option><option value="ROLLOUT">ROLLOUT</option><option value="POST_ROLLOUT">POST_ROLLOUT</option><option value="MAINTENANCE">MAINTENANCE</option></select></div></div></div><!-- <jhi-alert></jhi-alert> --><jhi-alert-error></jhi-alert-error><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-section"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div><route-image obj="vm.objectRouteImg"></route-image><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form name="pinForm" role="form" class="form-horizontal" novalidate show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label" for="pinA"><span translate=" ">Point A :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinA" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateA" required></div></div><div class="form-group"><label class="col-md-4 control-label" for="pinB"><span translate=" ">Point B :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinB" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateB" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'modalLatLongs\')">Cancel</button> <button type="button" class="btn btn-primary" ng-disabled="!vm.getLocationCoordinateA || !vm.getLocationCoordinateB" ng-click="vm.onLocationCoordinates()">OK</button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-section/tr-sections.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-sections"></i> <span>Sections</span></h3></div><!-- <div class="box-tools section_labels" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER">\r\n                        <button class="btn btn-create btn-sm" ui-sref="tr-section.new">\r\n                            <span class="glyphicon glyphicon-plus"></span> <span>\r\n                                New</span>\r\n                        </button>\r\n                    </div> --></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="description"><span\r\n                                            translate="trakeyeApp.section.description">Description</span> </th> --><th>Section Length (mtrs)</th><th>Route Name</th><th>Project Name</th><!-- <th>Section Type</th> --><th>Material Transaction</th><th>Resource Transaction</th><th>Task</th><th>Created Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="section in vm.sections | filter: users track by section.id" ng-class="{selected: section.isChecked}"><td><a ui-sref="tr-section-detail({id:section.id,routeId:section.routeId})">{{section.name}}</a></td><td>{{section.sectionLength}}</td><td>{{section.routeName}}</td><td>{{section.projectName}}</td><!-- <td>{{section.description}}</td> --><!-- <td>{{section.sectionType.name}}</td>  --><td class="td__listViewRow" ng-click="vm.expand(section,\'material\');" expand><span ng-if="!section.material" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Open"></i></span> <span ng-if="section.material" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Close"></i></span></td><td class="td__listViewRow" ng-click="vm.expand(section,\'resource\');" expand><span ng-if="!section.resource" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Open"></i></span> <span ng-if="section.resource" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Close"></i></span></td><td class="td__listViewRow" ng-click="vm.expand(section,\'tasks\');" expand><span ng-if="!section.tasks" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Open"></i></span> <span ng-if="section.tasks" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Close"></i></span></td><!-- <td> <a ui-sref="tr-section.materialTxndialog({sectionId:section.id})"\r\n                                        class="action-icons text-primary" title="Create" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER">\r\n                                        <span class="glyphicon glyphicon-plus"></span>\r\n                                    </a></td>\r\n\r\n                                   <td> <a ui-sref="tr-section.resourceTxndialog({sectionId:section.id})"\r\n                                        class="action-icons text-primary" title="Create" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER">\r\n                                        <span class="glyphicon glyphicon-plus"></span>\r\n                                    </a></td> \r\n\r\n                                    <td> <a ui-sref="tr-task.new({sectionId:section.id,routeId : section.routeId})"\r\n                                        class="action-icons text-primary" title="Create" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_PLANNER">\r\n                                        <span class="glyphicon glyphicon-plus"></span>\r\n                                    </a></td> --><td>{{section.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><div class="action"><a ui-sref="tr-section-detail({id:section.id,routeId:section.routeId})" class="action-icons text-info" title="View" ng-if="Roles.SECTION_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-section.edit({id:section.id,routeId:section.routeId})" class="action-icons text-primary" title="Edit" ng-if="Roles.SECTION_EDIT"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-show="section.material"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><th ng-repeat="header in vm.headers">{{ header.display }}</th></tr></thead><tbody><tr ng-repeat="item in vm.expandResponse"><td ng-repeat="header in vm.headers"><span ng-if="header.key == \'transactionDate\'">{{ item[header.key] | date:\'mediumDate\' }} </span><!-- If it\'s not the date key, display the value as is --> <span ng-hide="header.key == \'transactionDate\'">{{ item[header.key] }}</span></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0"><h4>No data available</h4></td><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null"><h4>Loading...</h4></td></tr></tbody></table></td></tr><tr ng-show="section.resource"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><th ng-repeat="header in vm.headers">{{ header.display }}</th></tr></thead><tbody><tr ng-repeat="item in vm.expandResponse"><td ng-repeat="header in vm.headers"><span ng-if="header.key == \'transactionDate\'">{{ item[header.key] | date:\'mediumDate\' }} </span><!-- If it\'s not the date key, display the value as is --> <span ng-hide="header.key == \'transactionDate\'">{{ item[header.key] }}</span></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0"><h4>No data available</h4></td><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null"><h4>Loading...</h4></td></tr></tbody></table></td></tr><tr ng-show="section.tasks"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><tr><th ng-repeat="header in vm.headers">{{ header.display }}</th></tr></thead><tbody><tr ng-repeat="item in vm.expandResponse"><td>{{item.name}}</td><td>{{item.taskType.name}}</td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0"><h4>No data available</h4></td><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null"><h4>Loading...</h4></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.sections.length == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-service/tr-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Notifications for this service needs to be deleted before deleting service</p><p translate="trakeyeApp.trService.delete.question" translate-values="{id: \'{{vm.trService.id}}\'}">Are you sure you want to delete this Tr Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-service/tr-service-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.trService.detail.title">Tr Service</span> {{vm.trService.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.trService.description">Description</span></dt><dd><span>{{vm.trService.description}}</span></dd><dt><span translate="trakeyeApp.trService.serviceDate">Service Date</span></dt><dd><span>{{vm.trService.serviceDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trService.status">Status</span></dt><dd><span translate="{{\'trakeyeApp.ServiceStatus.\' + vm.trService.status}}">{{vm.trService.status}}</span></dd><dt><span translate="trakeyeApp.trService.user">User</span></dt><dd>{{vm.trService.trCase.assignedToUser}}</dd><dt><span translate="trakeyeApp.trService.createdDate">Created Date</span></dt><dd><span>{{vm.trService.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trService.modifiedDate">Modified Date</span></dt><dd><span>{{vm.trService.modifiedDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trService.trCase">Incident</span></dt><dd><a ui-sref="tr-case-detail({id:vm.trService.trCase.id})">{{vm.trService.trCase.description}}</a></dd><div class="form-group" ng-repeat="attribute in vm.trService.serviceTypeAttributeValues track by $index"><dt><span>{{attribute.serviceTypeAttribute.name}}</span></dt><dd><span>{{vm.trService.serviceTypeAttributeValues[$index].attributeValue}}</span></dd></div><dt><span translate="trakeyeApp.trService.serviceImages">Service Images</span></dt><dd><div><div class="col-md-3" ng-repeat="img in vm.trService.serviceImages track by img.id"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" style="padding-bottom: 10px;"></div></div></dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-service.edit({id:vm.trService.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-service/tr-service-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrServiceLabel"><span ng-if="!vm.trService.id" translate="trakeyeApp.trService.home.create">Create</span> <span ng-if="vm.trService.id" translate="trakeyeApp.trService.home.EditLabel">Edit</span></h3></div><div class="box-body"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.trService.id"><label class="col-md-3 control-label" for="id" translate="global.field.id">ID</label><div class="col-md-7"><input type="text" class="form-control" id="id" name="id" ng-model="vm.trService.id" ng-readonly="true"></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.trService.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trService.description" ng-readonly="vm.trService.id"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trService.trCase">Incident</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control select2" name="trcases" ng-model="vm.trService.trCase.id"\r\n\t\t\t\t\t\t             ng-options="trCase.id as trCase.description for trCase in vm.trcases" required ng-disabled="!has_ROLE_USER_ADMIN">\r\n\t\t\t\t\t\t             <option value="" translate="trakeyeApp.trService.selectCase">Select Incident</option>\r\n\t\t\t\t\t\t            </select>  --> <input list="caseslist" class="form-control" id="field_caseid" placeholder="Search case id" type="text" ng-model="vm.trService.trCase.id" autocomplete="off" name="trcases" ng-change="vm.filtertrcasesid()" required ng-pattern="/^[0-9]+$/"><datalist ng-hide="!vm.caseids" id="caseslist" class="form-control1"><option ng-repeat="case in vm.caseids" value="{{case.id}}"></option></datalist><p class="help-block" ng-show="editForm.trcases.$error.pattern" translate="trakeyeApp.trService.caseiderror">Enter only numeric values for case id</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trService.serviceDate" for="field_serviceDate">Service Date</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div class="input-group"><input id="field_serviceDate" type="text" class="form-control" name="serviceDate" datetime-picker="{{dateformat}}" ng-model="vm.trService.serviceDate" ng-change="vm.checkDate()" is-open="vm.datePickerOpenStatus.serviceDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'serviceDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span ng-if="vm.errorDate" class="text-danger">Service date should be greater than case created date</span></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trService.status">status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="status" ng-model="vm.trService.status" id="field_status" required><option value="INPROGRESS" translate="trakeyeApp.ServiceStatus.INPROGRESS">INPROGRESS</option><option value="PENDING" translate="trakeyeApp.ServiceStatus.PENDING">PENDING</option><option value="CLOSED" translate="trakeyeApp.ServiceStatus.CLOSED">CLOSED</option><option value="CANCELLED" translate="trakeyeApp.ServiceStatus.CANCELLED">CANCELLED</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.trService.notes" for="field_notes">Notes</label><div class="col-md-7"><input type="text" class="form-control" name="notes" id="field_notes" ng-model="vm.trService.notes"></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.trService.trServicetype">Tr Service</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control select2" name="trakeyeType" ng-model="vm.serviceType" ng-change="vm.selectattributes()" ng-disabled="vm.trService.id" ng-options="item as item.name for item in vm.serviceTypes track by item.id" required><option value="" translate="trakeyeApp.trService.selectType">Select ServiceType</option></select></div></div><div><div class="form-group" ng-repeat="attribute in vm.trService.serviceTypeAttributeValues track by $index"><label class="col-md-3 control-label">{{attribute.serviceTypeAttribute.name}}</label><div class="col-md-7"><input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trService.id" type="text" class="form-control" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue = attribute.serviceTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" step="0.01"> <input ng-if="attribute.serviceTypeAttribute.attributeDataType.name== \'FLOAT\' && vm.trService.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" step="0.01"> <span ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trService.id" type="text" class="form-control" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue = attribute.serviceTypeAttribute.value" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trService.id" type="text" class="form-control" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Valid Number </span><input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trService.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue = attribute.serviceTypeAttribute.value" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue"> <input ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'STRING\' && vm.trService.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue"> <span ng-if="attribute.serviceTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color: red">Enter a Message</span><!-- <select ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue = attribute.serviceTypeAttribute.value" \r\n\t\t\t\t\t\t\t    ng-if="attribute.serviceTypeAttribute.dataType ==  \'BOOLEAN\' && !vm.trService.id" class="form-control select2" name="value" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false" >False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t   <select ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" ng-init="vm.trService.serviceTypeAttributeValues[$index].attributeValue == attribute.serviceTypeAttribute.value" \r\n\t\t\t\t\t\t\t   ng-if="attribute.serviceTypeAttribute.dataType ==  \'BOOLEAN\' && vm.trService.id" class="form-control select2" name="value" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false" >False</option>\r\n\t\t\t\t\t\t\t   </select> --> <select ng-model="vm.trService.serviceTypeAttributeValues[$index].attributeValue" ng-if="attribute.serviceTypeAttribute.attributeDataType.name != \'STRING\' && attribute.serviceTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.serviceTypeAttribute.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.serviceTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.trService.serviceImages">images</label><div class="col-md-7"><input type="file" name="file" multiple="multiple" class="filestyle" id="serviceImages" accept="image/*"></div><div class="col-md-2" ng-if="vm.trService.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Images</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-8 col-md-offset-3"><div class="col-md-3" ng-repeat="img in vm.serviceImages track by img.id"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{img.image}}" style="padding-bottom: 10px;"></div></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-service"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.errorDate" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tr-service/tr-services.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><i class="fa fa-server"></i><h3 class="box-title" translate="trakeyeApp.trService.home.title">Tr Services</h3><div class="box-tools"><button class="btn btn-create" ui-sref="tr-service.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.trService.home.createLabel">Create Tr Service</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab">List View</a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2);" data-toggle="tab">Map View</a></li></ul></div><div class="col-md-3 search-top pull-right" ng-show="isSet(1)"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.trService.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-3 search-top pull-right" ng-show="isSet(2)"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="Service Id "> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterTrSevices()"><i class="fa fa-search"></i></button></span></div></div></div><div class="case-table" ng-show="isSet(1)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th><input type="checkbox" ng-click="vm.selectAllAssets()" ng-model="vm.isAllAssetSelected"></th> --><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.trService.description">Description</span> <span class="fa fa-sort"></span></th><th jh-sort-by="service_date"><span translate="trakeyeApp.trService.serviceDate">Service Date</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span translate="trakeyeApp.trService.status">Status</span> <span class="fa fa-sort"></span></th><th><span translate="trakeyeApp.trService.assignedTo">Assigned To</span></th><th><span translate="trakeyeApp.trService.trCase">Incident</span></th><th>Actions</th></tr></thead><tbody><tr ng-repeat="trService in vm.trServices track by trService.id"><!-- <td><input type="checkbox" ng-model="trService.isChecked" ng-change="vm.selectAssetEntity()"></td> --><td><a ui-sref="tr-service-detail({id:trService.id})">{{trService.id}}</a></td><td>{{trService.description}}</td><td>{{trService.serviceDate | date:\'medium\'}}</td><td translate="{{\'trakeyeApp.ServiceStatus.\' + trService.status}}">{{trService.status}}</td><td>{{trService.trCase.assignedToUser}}</td><td><a ui-sref="tr-case-detail({id:trService.trCase.id})">{{trService.trCase.description}}</a></td><td><div class="actions"><a ui-sref="tr-service-detail({id:trService.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="tr-service.edit({id:trService.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a ui-sref="tr-service.delete({id:trService.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.trServices == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><div class="map-view" ng-show="isSet(2)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas" style="height:{{mapHeight}}px; width:100%"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-task/tr-task-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this task needs to be deleted before deleting task</p><p translate="trakeyeApp.task.delete.question" translate-values="{id: \'{{vm.trTask.id}}\'}">Are you sure you want to delete this Tr Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-task/tr-task-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><!-- <h3 class="box-title">\r\n\t\t\t\t\t\t<span translate="trakeyeApp.task.detail.title">Tr Task</span>\r\n\t\t\t\t\t\t - {{vm.trTask.name}} - {{vm.trTask.id}}\r\n\t\t\t\t\t</h3> --><div class="col-md-8 col-sm-3"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(6)}"><a href ng-click="setTab(6); search = null" data-toggle="tab"><i class="fa fa-info-circle"></i><span class="header-view"></span> <span class="header_view">Details</span></a></li><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Daily Logs</span> <span class="header_view"></span></a></li><li ng-class="{active:isSet(5)}"><a href ng-click="setTab(5); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Obstacle Logs</span> <span class="header_view"></span></a></li><li ng-class="{active:isSet(7)}"><a href ng-click="setTab(7); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Materials</span> <span class="header_view"></span></a></li><li ng-class="{active:isSet(8)}"><a href ng-click="setTab(8); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view">Resources</span> <span class="header_view"></span></a></li><li ng-class="{active:isSet(3) || isSet(4)}"><a href ng-click="setTab(3);" data-toggle="tab" ng-show="vm.dailyLogsTxSummary.sectionTasks.length == 0"><i class="fa fa-list"></i><span class="header-view"> Summary</span></a> <a href ng-click="setTab(4);" data-toggle="tab" ng-show="vm.dailyLogsTxSummary.sectionTasks.length"><i class="fa fa-list"></i><span class="header-view"> Summary</span></a></li><li ng-class="{active:isSet(2)}" ng-if="vm.isShowComment"><a href ng-click="setTab(2); search = null" data-toggle="tab"><i class="fa fa-commenting"></i><span class="header-view">Comments</span></a></li></ul></div></div><div class="box-body" ng-show="isSet(6)"><!-- <jhi-alert-error></jhi-alert-error> --><div class="flexeven"><a href="javascript:void(0);" onclick="history.back()" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><button class="btn btn-create btn-sm mb-5" ui-sref="task-log.dialog({taskId:vm.trTask.id, sectionId : null, routeId : vm.trTask.routeTask[0].routeId, str:\'PROGRESS\'  })" title="Create Daily Log" ng-if="Roles.DAILYLOG_CREATE && vm.trTask.routeTask.length && vm.trTask.sectionTask.length == 0"><span class="glyphicon glyphicon-plus"></span> <span>Add Daily Log</span></button> <button class="btn btn-create btn-sm mb-5" ui-sref="task-log.dialog({taskId:vm.trTask.id, sectionId : vm.trTask.sectionTask[0].sectionId, routeId : vm.trTask.sectionTask[0].routeId ,str:\'PROGRESS\' })" title="Create Daily Log" ng-if="Roles.DAILYLOG_CREATE && vm.trTask.sectionTask.length"><span class="glyphicon glyphicon-plus"></span> <span>Add Daily Log</span></button> <button class="btn btn-create btn-sm mb-5" ui-sref="task-log.dialog({taskId:vm.trTask.id, sectionId : null, routeId : vm.trTask.routeTask[0].routeId ,str:\'OBSTACLE\'})" title="Create Obstacle Log" ng-if="Roles.DAILYLOG_CREATE && vm.trTask.routeTask.length && vm.trTask.sectionTask.length == 0"><span class="glyphicon glyphicon-plus"></span> <span>Add Obstacle Log</span></button> <button class="btn btn-create btn-sm mb-5" ui-sref="task-log.dialog({taskId:vm.trTask.id, sectionId : vm.trTask.sectionTask[0].sectionId, routeId : vm.trTask.sectionTask[0].routeId ,str:\'OBSTACLE\'})" title="Create Obstacle Log" ng-if="Roles.DAILYLOG_CREATE && vm.trTask.sectionTask.length"><span class="glyphicon glyphicon-plus"></span> <span>Add Obstacle Log</span></button> <button class="btn btn-create btn-sm mb-5" title="Comments" ng-click="vm.logComment(vm.trTask.id,\'TASK\')"><span class="fa fa-commenting"></span> <span>Comments</span></button> <a ui-sref="tr-task.edit({id:vm.trTask.id, routeId :vm.trTask.routeTask[0].routeId,sectionId:null })" class="btn btn-primary btn-sm" title="Edit" ng-if="Roles.TASK_EDIT && vm.trTask.routeTask.length && vm.trTask.sectionTask.length == 0"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span> </a><a ui-sref="tr-task.edit({id:vm.trTask.id, sectionId : vm.trTask.sectionTask[0].sectionId, routeId : vm.trTask.sectionTask[0].routeId})" class="btn btn-primary btn-sm" title="Edit" ng-if="Roles.TASK_EDIT && vm.trTask.sectionTask.length"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div><div class="row mt-15"><div class="col-md-4"><dl class="dl-horizontal jh-entity-details mt-5"><dt><span>Task Name</span></dt><dd><span>{{vm.trTask.name}}</span></dd><dt><span>Project Name</span></dt><dd><span ng-if="vm.trTask.sectionTask.length == 0">{{vm.trTask.routeTask[0].projectName}}</span> <span ng-if="vm.trTask.sectionTask.length">{{vm.trTask.sectionTask[0].projectName}}</span></dd><dt><span>Ring Name</span></dt><dd><span ng-if="vm.trTask.sectionTask.length == 0">{{vm.trTask.routeTask[0].routeName}}</span> <span ng-if="vm.trTask.sectionTask.length">{{vm.trTask.sectionTask[0].routeName}}</span></dd><dt><span>Route Name</span></dt><dd><span ng-if="vm.trTask.sectionTask.length == 0">{{vm.trTask.routeTask[0].routeBundleName}}</span> <span ng-if="vm.trTask.sectionTask.length">{{vm.trTask.sectionTask[0].routeBundleName}}</span></dd><dt ng-show="vm.trTask.sectionTask.length"><span>Section Name</span></dt><dd ng-show="vm.trTask.sectionTask.length"><span>{{vm.trTask.sectionTask[0].sectionName}}</span></dd><dt><span>Task Description</span></dt><dd><span>{{vm.trTask.description}}</span></dd><dt><span>Task Length (mtrs)</span></dt><dd><span>{{vm.trTask.taskLength}}</span></dd><dt><span translate="trakeyeApp.task.status">Status</span></dt><dd><!-- <span translate="{{\'trakeyeApp.TaskStatus.\' + vm.trTask.status}}">{{vm.trTask.status}}</span> --> <span>{{vm.trTask.status}}</span></dd><dt><span>Verified</span></dt><dd><!-- <span translate="{{\'trakeyeApp.TaskStatus.\' + vm.trTask.status}}">{{vm.trTask.status}}</span> --> <span ng-if="!vm.trTask.verified">No</span> <span ng-if="vm.trTask.verified">Yes</span></dd><!-- <dt ng-show="vm.trTask.approvedByUserName">\r\n\t\t\t\t\t\t\t\t\t<span>Approved By</span>\r\n\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t<dd ng-show="vm.trTask.approvedByUserName">\r\n\t\t\t\t\t\t\t\t\t<span>{{vm.trTask.approvedByUserName}}</span>\r\n\t\t\t\t\t\t\t\t</dd> --><dt ng-show="vm.trTask.assignedByUser"><span>Assigned By</span></dt><dd ng-show="vm.trTask.assignedByUser"><span>{{vm.trTask.assignedByUser}}</span></dd><dt ng-show="vm.trTask.assignedToUser"><span>Assigned To</span></dt><dd ng-show="vm.trTask.assignedToUser"><span>{{vm.trTask.assignedToUser}}</span></dd><dt ng-if="vm.trTask.assignee"><span>Assigned To</span></dt><dd ng-if="vm.trTask.assignee"><span>{{vm.trTask.assignee}}</span></dd><dt><span translate="trakeyeApp.task.createDate">Create Date</span></dt><dd><span>{{vm.trTask.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.task.updateDate">Update Date</span></dt><dd><span>{{vm.trTask.lastModifiedDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.task.taskType">Task Type</span></dt><dd><!--  <a ui-sref="task-type-detail({id:vm.trTask.taskType.id})">{{vm.trTask.taskType.name}}</a> --> {{vm.trTask.taskType.name}}</dd><div class="form-group" ng-repeat="attribute in vm.trTask.taskTypeAttributeValues"><div ng-repeat="attributeValue in vm.trTask.taskTypeAttributeValues track by $index"><div ng-if="attributeValue.taskTypeAttribute.id == attribute.taskTypeAttribute.id"><dt><span>{{attribute.taskTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></div></div></div><hr><!-- <dt ng-if="vm.trTask.taskType.name == \'Termination Details\'">\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'termination\')"><span\r\n\t\t\t\t\t\t\t\t\t\tng-hide="vm.showTermination">Show Termination Details</span>\r\n\t\t\t\t\t\t\t\t\t<span ng-show="vm.showTermination">Hide Termination Details</span></a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dt>\r\n\r\n\t\t\t\t\t\t<dd ng-if="terminationDetails">\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-12" style="overflow-x: scroll">\r\n\t\t\t\t\t\t\t\t\t\t<table class="jh-table table table-responsive table-hover">\r\n\t\t\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>FMS</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Type</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Port Number Start</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Port Number End</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Cable Number A Side</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tCore Number A Side Start\r\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Core Number A Side End</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Number of Splice</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Port used for</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Cable Number B Side</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tCore Number B Side Start\r\n\t\t\t\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<th>Core Number B Side End</th>\r\n\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t<tr class="ws-nowrap" ng-repeat="list in vm.trTask.terminationDetails">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.fms}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.type}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.portNumberStart}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.portNumberEnd}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideACable.cableNumber}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideACable.coreNumberStart}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideACable.coreNumberEnd}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.numberOfSplice}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{list.portUsedFor}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideBCable.cableNumber}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideBCable.coreNumberStart}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.sideBCable.coreNumberEnd}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dd> --><!-- <dt>\r\n\t\t\t\t\t\t\t<div class="col-md-2 trTask_showImgDiv" ng-if="vm.trTask.id">\r\n\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'image\')">\r\n\t\t\t\t\t\t\t\t\t<span ng-hide="vm.showImages">Show Images</span>\r\n\t\t\t\t\t\t\t\t\t<span ng-show="vm.showImages">Hide Images</span></a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dt> --><!-- <dd ng-if="allimages">\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-3" ng-repeat="img in vm.taskImages">\r\n\t\t\t\t\t\t\t\t\t\t\t<img ng-if="img.image != null" class="img-responsive img__img-responsive"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-src="data:image/jpeg;base64,{{img.image}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.imageInNewTab(img.image)" /><br />\r\n\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s" ng-show="img.imgDescription != null"><b>Description :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgDescription}}</span><br />\r\n\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-show="img.imgLat != null && img.imgLong != null"><b>LatLng :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgLat}},{{img.imgLong}}</span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dd> --></dl></div><div class="col-md-8"><div id="map_canvasStart" class="div__map-canvas"></div><div class="pull-right"><span id="myspan">Zoom : {{vm.objectRouteImg.zoomLevel}}</span></div></div></div></div><div class="box-body" ng-show="isSet(1)"><div class="row mt-5"><div class="table-responsive col-md-6"><h3>Daily Logs Details</h3><div class="scroll_dailyLogs"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>Work Date</th><th>Work Length (mtrs)</th><th>Number of Hours</th><th>Start (Lat,Lng)</th><th>End (Lat,Lng)</th><th>Created Date</th><th>Created By</th><!-- <th>Status</th> --><th ng-if="Roles.DAILYLOG_EDIT || Roles.DAILYLOG_DELETE">Actions</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsList" ng-mouseover="vm.highlightLog(task.id)" ng-mouseleave="vm.resetLog()"><td>{{task.workDate | date:\'dd-MM-yyyy h:mma\'}}</td><td>{{task.workLength}}</td><td>{{task.numberOfHours}}</td><td>{{task.fromRoutePointLat | limitTo: 6}},{{task.fromRoutePointLng | limitTo: 6}}</td><td>{{task.toRoutePointLat | limitTo: 6}},{{task.toRoutePointLng | limitTo: 6}}</td><td>{{task.createdDate | date:\'dd-MM-yyyy h:mma\'}}</td><td>{{task.createdBy}}</td><!-- <td>\r\n\t\t\t\t\t\t\t\t\t{{task.status}}\r\n\t\t\t\t\t\t\t\t</td> --><td><div class="action"><a ui-sref="task-log.dialog({id:task.id , sectionId : null, routeId : vm.trTask.routeTask[0].routeId, taskId:task.task.id, str: task.taskLogType  })" class="action-icons text-primary" title="Edit" ng-if="Roles.DAILYLOG_EDIT && vm.trTask.routeTask.length && vm.trTask.sectionTask.length == 0"><span class="fa fa-pencil-square"></span></a> <a ui-sref="task-log.dialog({id:task.id , sectionId : vm.trTask.sectionTask[0].sectionId, routeId : vm.trTask.sectionTask[0].routeId, taskId:task.task.id, str: task.taskLogType  })" class="action-icons text-primary" title="Edit" ng-if="Roles.DAILYLOG_EDIT && vm.trTask.sectionTask.length"><span class="fa fa-pencil-square"></span></a> <a ng-click="vm.logComment(task.id,\'PROGRESSLOG\')" class="action-icons text-primary" title="Comments"><span class="fa fa-commenting"></span> </a><a ng-click="vm.showModal(task.id)" class="action-icons text-primary" title="Delete" ng-if="Roles.DAILYLOG_DELETE"><span class="fa fa-trash-o"></span></a></div></td></tr><td colspan="2" ng-show="vm.dailyLogsList.length == 0"><h4>No Logs Available</h4></td></tbody></table></div><!-- <div class="row">\r\n\t\t\t\t\t\t<div class="col-md-4">\r\n\t\t\t\t\t\t\t<div class="count-length">\r\n\t\t\t\t\t\t\t\t<jhi-item-count page="vm.page" total="vm.progressqueryCount"\r\n\t\t\t\t\t\t\t\t\titems-per-page="vm.progressitemsPerPage"></jhi-item-count>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t<div class="pagination-list pull-right">\r\n\t\t\t\t\t\t\t\t<uib-pagination class="pagination-sm" total-items="vm.progresstotalItems" ng-model="vm.progresspage"\r\n\t\t\t\t\t\t\t\t\tng-change="vm.progresstransition()"></uib-pagination>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div> --><div class="row row__div--pagination"><!-- <div class="col-md-2 pull-left row__div--pagesize">\r\n                            <label for="area">Page size </label>\r\n                            <select name="page_size" id="page_size" ng-model="vm.itemsPerPage" ng-change="vm.progresstransition()">\r\n                                <option value="10">10</option>\r\n                                <option value="20">20</option>\r\n                                <option value="50">50</option>\r\n                            </select>\r\n                        </div>--><div class="col-md-6 row__div--showingnoitems"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-6 pull-right"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.progresstransition()"></uib-pagination></div></div></div></div><div class="col-md-6" style="margin-top: 70px;" ng-show="vm.dailyLogsList.length>0"><div id="map_canvasStart1" class="div__map-canvas"></div></div></div></div><div class="table-responsive mt-10" ng-show="isSet(5)"><h3>Obstacle Logs Details</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><!-- <th>Work Date</th> --><th style="width: 200px;">Reason</th><th>Length (mtrs)</th><th>Start (Lat,Lng)</th><th>End (Lat,Lng)</th><th>Created Date</th><th>Created By</th><!-- <th>Status</th> --><th ng-if="Roles.DAILYLOG_EDIT || Roles.DAILYLOG_DELETE">Actions</th></tr></thead><tbody><tr ng-repeat="task in  vm.obstacleLogsList"><!-- <td>{{task.workDate | date:\'medium\'}}</td> --><td title="{{task.reason}}" style="width: 200px;">{{task.reason }}</td><td>{{task.workLength}}</td><td>{{task.fromRoutePointLat | limitTo: 6}},{{task.fromRoutePointLng | limitTo: 6}}</td><td>{{task.toRoutePointLat | limitTo: 6}},{{task.toRoutePointLng | limitTo: 6}}</td><td>{{task.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td>{{task.createdBy}}</td><!-- <td>\r\n\t\t\t\t\t\t\t\t\t{{task.status}}\r\n\t\t\t\t\t\t\t\t</td> --><td><div class="action"><a ui-sref="task-log.dialog({id:task.id , sectionId : null, routeId : vm.trTask.routeTask[0].routeId, taskId:task.task.id, str: task.taskLogType  })" class="action-icons text-primary" title="Edit" ng-if="Roles.DAILYLOG_EDIT && vm.trTask.routeTask.length && vm.trTask.sectionTask.length == 0"><span class="fa fa-pencil-square"></span></a> <a ui-sref="task-log.dialog({id:task.id , sectionId : vm.trTask.sectionTask[0].sectionId, routeId : vm.trTask.sectionTask[0].routeId, taskId:task.task.id, str: task.taskLogType  })" class="action-icons text-primary" title="Edit" ng-if="Roles.DAILYLOG_EDIT && vm.trTask.sectionTask.length"><span class="fa fa-pencil-square"></span></a> <a ng-click="vm.logComment(task.id,\'OBSTACLELOG\')" class="action-icons text-primary" title="Comments"><span class="fa fa-commenting"></span> </a><a ng-click="vm.showModal(task.id)" class="action-icons text-primary" title="Delete" ng-if="Roles.DAILYLOG_DELETE"><span class="fa fa-trash-o"></span></a></div></td></tr><td colspan="2" ng-show="vm.obstacleLogsList.length == 0"><h4>No Logs Available</h4></td></tbody></table><div class="row row__div--pagination"><!-- <div class="col-md-2 pull-left row__div--pagesize">\r\n                            <label for="area">Page size </label>\r\n                            <select name="page_size" id="page_size" ng-model="vm.itemsPerPage" ng-change="vm.progresstransition()">\r\n                                <option value="10">10</option>\r\n                                <option value="20">20</option>\r\n                                <option value="50">50</option>\r\n                            </select>\r\n                        </div> --><div class="col-md-3 row__div--showingnoitems"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-4 pull-right"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.progresstransition()"></uib-pagination></div></div></div><!-- <div class="row">\r\n\t\t\t\t\t\t<div class="col-md-4">\r\n\t\t\t\t\t\t\t<div class="count-length">\r\n\t\t\t\t\t\t\t\t<jhi-item-count page="vm.obstaclepage" total="vm.obstaclequeryCount"\r\n\t\t\t\t\t\t\t\t\titems-per-page="vm.obstacleitemsPerPage"></jhi-item-count>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t<div class="pagination-list pull-right">\r\n\t\t\t\t\t\t\t\t<uib-pagination class="pagination-sm" total-items="vm.obstacletotalItems" ng-model="vm.obstaclepage"\r\n\t\t\t\t\t\t\t\t\tng-change="vm.obstacletransition()"></uib-pagination>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div> --></div><!-- Comment Box --><comments obj="vm.objectComments" ng-if="vm.isShowComment"></comments><div class="col-md-6 col-sm-3" ng-show="isSet(3) || isSet(4)"><div style="padding: 5px;\r\n\t\t\t\tmargin: 5px;"><ul class="nav nav-pills"><li ng-class="{active: isSet(3)}" ng-show="vm.dailyLogsTxSummary.sectionTasks.length == 0"><a href ng-click="setTab(3); search = null;" data-toggle="tab"><span class="header-view">Route</span></a></li><li ng-class="{active:isSet(4)}" ng-show="vm.dailyLogsTxSummary.sectionTasks.length"><a href ng-click="setTab(4); search = null" data-toggle="tab"><span class="header-view">Section</span></a></li></ul></div></div><div class="col-sm-12" ng-show="isSet(4)"><!-- <button class="btn btn-primary center-block" ng-click="getPdf()" ng-if=\'vm.isReportGenerated==true\' style="margin: 10px;"> Download Pdf <span ng-show="loader"><i class="fa fa-spinner fa-spin"></i></span> </button> --><div id="generatedHtmlContainer" style="width: calc(100% - 40px);overflow-x: auto;overflow-y: hidden;"></div></div><div class="table-responsive col-md-8 mt-10" ng-show="isSet(3)"><h3>Logs</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Name</th><th>Total Work Length (mtrs)</th><th>Total Number of Hours</th><th>Log Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsTxSummary.routeTasks"><td><a ui-sref="tr-task-detail({id:task.taskId})" target="_blank">{{task.taskId}}</a></td><td>{{task.taskName}}</td><td>{{task.workLength}}</td><td>{{task.noOfHours}}</td><td>{{task.taskLogType}}</td></tr><td colspan="2" ng-show="vm.dailyLogsTxSummary.routeTasks.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div class="table-responsive col-md-8 mt-10" ng-show="isSet(4) "><h3>Logs</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th>ID</th><th>Name</th><th>Total Work Length (mtrs)</th><th>Total Number of Hours</th><th>Log Type</th></tr></thead><tbody><tr ng-repeat="task in  vm.dailyLogsTxSummary.sectionTasks"><td><a ui-sref="tr-task-detail({id:task.taskId})" target="_blank">{{task.taskId}}</a></td><td>{{task.taskName}}</td><td>{{task.workLength}}</td><td>{{task.noOfHours}}</td><td>{{task.taskLogType}}</td></tr><td colspan="2" ng-show="vm.dailyLogsTxSummary.sectionTasks.length == 0"><h4>No Summary Available</h4></td></tbody></table></div><div ng-if="isSet(7)  && Roles.MATERIALTX_CREATE"><material-txn-tab obj="vm.objectMaterialTxnTab"></material-txn-tab></div><div ng-if="isSet(8)  && Roles.RESOURCETX_CREATE"><resource-txn-tab obj="vm.objectResourceTxnTab"></resource-txn-tab></div></div></div></div></div><div class="modal fade" id="deleteLogs" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'deleteLogs\')"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Delete this Log ?</h4></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.deleteLogs()" data-dismiss="modal"><span translate="entity.action.delete">Delete</span></button> <button type="button" class="btn btn-default" ng-click="vm.closeModal(\'deleteLogs\')" data-dismiss="modal"><span translate="entity.action.cancel">Cancel</span></button></div></div></div></div><route-image obj="vm.objectRouteImg"></route-image><div class="modal fade" id="modalAttachmentLogImage" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'modalAttachmentLogImage\')"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header"><!--  {{imgName}} - {{imgLatitude}},{{imgLongitude}} --> Attachments</span></div><form name="editForm" class="form-horizontal"><div class="modal-body" style="overflow-y: scroll;overflow-x: hidden;height: 40vh"><div class="form-group"><!--  <jhi-alert-error></jhi-alert-error> --><div class="col-md-8 mt-5"><table class="jh-table table table-responsive table-hover" style="margin-left: auto;\r\n                                margin-right: auto;"><tr><th>Name</th></tr><tr ng-repeat="image in vm.nameImages">{{image}}<td ng-click="vm.newTabDisplayLogs(image.rID,image.imageId,image.imageType)" style="color: #3c8dbc;"><span ng-if="image.imageName != null">{{image.imageName}}</span> <span ng-if="image.imageName == null">Image {{$index + 1}}</span></td></tr></table></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/tr-task/tr-task-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrTaskLabel"><span ng-if="!vm.trTask.id" translate="trakeyeApp.task.home.create">Create</span> <span ng-if="vm.trTask.id">Edit Task</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Route Name</span>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <input type="text" class="form-control" name="name" id="field_name"\r\n                                        ng-model="vm.routeName.name" disabled />\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Section Name</span>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <input type="text" class="form-control" name="name" id="field_name"\r\n                                        ng-model="vm.routeName.name" disabled />\r\n                                </div>\r\n                            </div> --><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.task.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trTask.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.task.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trTask.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Select Task Points</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <button type="button" class="btn btn-primary btn-sm ml-5" ng-click="vm.removeMarker()" title="Clear Selected Points"><span class="fa fa-refresh"></span></button><div id="map_canvasStart" class="div__map-canvas col-md-8"></div><div class="pull-right"><span id="myspan">Zoom : {{vm.objectRouteImg.zoomLevel}}</span></div></div><!-- <div class="form-group"\r\n                                ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER || (has_ROLE_NETWORK_ENGINEER && vm.caseType.name != \'Vendor Civil Work\')">\r\n                                <label class="col-md-3 control-label" for="field_assignedTo">\r\n                                    <span translate="trakeyeApp.task.assignedTo">Assigned To</span>\r\n                                    <sup><span class="required-icon">\r\n                                            <i class="fa fa-asterisk text-danger"></i> </span></sup>\r\n                                </label>\r\n                                <div class="col-md-8">\r\n                                    <input list="userslist" class="form-control" id="field_assignedToUser"\r\n                                        placeholder="Search user login name" type="text"\r\n                                        ng-model="vm.trTask.assignedToUser" autocomplete="off" name="assignedToUser"\r\n                                        ng-change="vm.filterActivatedUser()"\r\n                                        required />\r\n                                    <datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1">\r\n                                        <option ng-repeat="user in\r\n                                        vm.activatedusers" value="{{user.login}}"></option>\r\n                                    </datalist>\r\n                                    <span id="noData" ng-if="vm.trTask.assignedToUser == null">**Please Select</span>\r\n                                </div>\r\n                            </div> --><div class="form-group"><label class="col-md-3 control-label"><span>Task Length (mtrs)</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><input type="number" class="form-control" name="name" ng-model="vm.trTask.taskLength" required min="0"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Task Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-5"><select class="form-control select2" name="taskType" ng-model="vm.taskType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                        vm.taskTypes track by item.id" ng-disabled="vm.trTask.id!=null" required style="width: 100%"><option value="" translate="trakeyeApp.task.selecttask">--- Select TaskType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.trTask.taskTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.taskTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.trTask.taskTypeAttributeValues[$index].attributeValue" ng-if="attribute.taskTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trTask.id" type="text" class="form-control" ng-init="vm.trTask.taskTypeAttributeValues[$index].attributeValue = attribute.taskTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.trTask.taskTypeAttributeValues[$index].attributeValue" ng-if="attribute.taskTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.trTask.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.taskTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.trTask.taskTypeAttributeValues[$index].attributeValue" ng-if="attribute.taskTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trTask.id" type="text" class="form-control" ng-init="vm.trTask.taskTypeAttributeValues[$index].attributeValue = attribute.taskTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.trTask.taskTypeAttributeValues[$index].attributeValue" ng-if="attribute.taskTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trTask.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.taskTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.trTask.taskTypeAttributeValues[$index].attributeValue" ng-if="attribute.taskTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trTask.id" type="text" class="form-control" ng-init="vm.trTask.taskTypeAttributeValues[$index].attributeValue = attribute.taskTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.trTask.taskTypeAttributeValues[$index].attributeValue" ng-if="attribute.taskTypeAttribute.attributeDataType.name == \'STRING\' && vm.trTask.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.taskTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.trTask.taskTypeAttributeValues[$index].attributeValue" ng-init="vm.trTask.taskTypeAttributeValues[$index].attributeValue = attribute.taskTypeAttribute.defaultValue" ng-if="attribute.taskTypeAttribute.attributeDataType.name != \'STRING\' && attribute.taskTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.taskTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trTask.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.taskTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.trTask.taskTypeAttributeValues[$index].attributeValue" ng-init="vm.trTask.taskTypeAttributeValues[$index].attributeValue == attribute.taskTypeAttribute.defaultValue" ng-if="attribute.taskTypeAttribute.attributeDataType.name != \'STRING\' && attribute.taskTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.taskTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trTask.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.taskTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div><!--  <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Route</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <select class="form-control" name="status" ng-model="vm.workFlow.status" id="field_status"\r\n\t\t\t\t\t\t\t\trequired>\r\n\t\t\t\t\t\t\t\t<option ng-repeat="item in vm.routeOption" value="{{item.id}}">{{item.name}}</option> \r\n\t\t\t\t\t\t\t</select>\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Section</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <select class="form-control" name="status" ng-model="vm.workFlow.phase" ng-disabled="vm.phaseAccess" \r\n\t\t\t\t\t\t\t\trequired>\r\n\t\t\t\t\t\t\t\t<option  ng-repeat="item in vm.sectionOption" value="{{item.configKey}}">{{item.configKey}}</option> \r\n\t\t\t\t\t\t\t</select>\r\n                                </div>\r\n                            </div> \r\n\r\n                            <div class="form-group" >\r\n                                <label class="col-md-3 control-label" for="field_assignedTo">\r\n                                    <span>Assigned To</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <input list="userslist" class="form-control" \r\n                                        id="field_assignedToUser" placeholder="Search user login name" type="text"\r\n                                        ng-model="vm.workFlow.assignedToUser" autocomplete="off" name="assignedToUser"\r\n                                        ng-change="vm.filterActivatedUser()" required>\r\n                                    <datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1">\r\n                                        <option ng-repeat="user in vm.activatedusers" value="{{user.login}}"></option>\r\n                                    </datalist>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Start Date</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <div class="input-group">\r\n                                        <span class="input-group-btn">\r\n                                            <button type="button" class="btn btn-default"\r\n                                                ng-click="vm.openCalendar(\'fromDate\')">From <i\r\n                                                    class="glyphicon glyphicon-calendar"></i></button>\r\n                                        </span>\r\n                                        <input id="field_serviceDate" type="text" class="form-control"\r\n                                            name="fromDate" ng-model="vm.fromDate" \r\n                                            datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.fromDate"\r\n                                            enable-time="false" datepicker-options="options" required />\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>End Date</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <div class="input-group">\r\n                                        <span class="input-group-btn">\r\n                                            <button type="button" class="btn btn-default"\r\n                                                ng-click="vm.openCalendar(\'toDate\')">to <i\r\n                                                    class="glyphicon glyphicon-calendar"></i></button>\r\n                                        </span>\r\n                                        <input id="field_toDate" type="text" class="form-control" name="toDate"\r\n                                            ng-model="vm.toDate" \r\n                                            datetime-picker="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.toDate"\r\n                                            enable-time="false" datepicker-options="options" required />\r\n                                    </div>\r\n                                </div>\r\n                            </div> --><div class="form-group" ng-if="vm.trTask.id"><label class="col-md-3 control-label"><span>Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control" name="status" ng-model="vm.trTask.status" ng-disabled="!Roles.taskStatusUpdate" id="field_status"><option value="">--- Select Status ---</option><option ng-repeat="item in vm.rolloutTaskStatus" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-show="(has_ROLE_USER_ADMIN || has_ROLE_ROLLOUT_MANAGER || has_ROLE_PLAN_ADMIN)"><label class="col-md-3 control-label"><span>Vendor</span></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedVendor" ng-change="vm.findUsers()" ng-options="item.id as item.name for item in vm.vendorList"><option value="">--- Select Vendor ---</option></select></div></div><div class="form-group" ng-show="(has_ROLE_USER_ADMIN || has_ROLE_ROLLOUT_MANAGER || has_ROLE_PLAN_ADMIN) && vm.selectedVendor"><label class="col-md-3 control-label"><span>User</span></label><div class="col-md-4"><select class="form-control select2" ng-model="vm.trTask.assignedUserId" ng-options="item.id as item.name for item in vm.userList"><option value="">--- Select User ---</option></select></div></div><div class="form-group" ng-if="vm.trTask.id"><label class="col-md-3 control-label" for="field_verified">Verified</label><div class="col-md-8"><input type="checkbox" class="checkbox" name="verified" id="field_verified" ng-model="vm.trTask.verified" ng-true-value="true" ng-false-value="false" ng-disabled="!Roles.TASK_VERIFIED"></div></div><!-- <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Phase</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <select class="form-control" name="status" ng-model="vm.workFlow.phase" ng-disabled="vm.phaseAccess" \r\n\t\t\t\t\t\t\t\trequired>\r\n\t\t\t\t\t\t\t\t<option  ng-repeat="item in vm.workFlowPhase" value="{{item.configKey}}">{{item.configKey}}</option> \r\n\t\t\t\t\t\t\t</select>\r\n                                </div>\r\n                            </div> --><!-- \r\n                            <div class="form-group" ng-if="vm.trTask.id">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Assignee</span>\r\n                                </label>\r\n                                <div class="col-md-3">\r\n                                    <div class="autocomplete-container">\r\n                                        <input type="text" ng-model="vm.trTask.assignedToUser" class="form-control" ng-change="vm.filterActivatedUser()" \r\n                                        ng-disabled="!has_ROLE_VENDOR_ADMIN" placeholder="Assign to">\r\n                                        <ul ng-if="showResults" class="autocomplete-list">\r\n                                            <li ng-repeat="result in vm.activatedusers" ng-click="assignUser(result.login)">\r\n                                                <img ng-src="content/images/userimg.gif" alt="{{result.login[0]}}" class="autocomplete-list-image">\r\n                                                <span>{{result.login}}</span>\r\n                                            </li>\r\n                                        </ul>\r\n                                    </div>\r\n                                </div>\r\n                            </div> --></div><jhi-alert></jhi-alert><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-task"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div><route-image obj="vm.objectRouteImg"></route-image><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form name="pinForm" role="form" class="form-horizontal" novalidate show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label" for="pinA"><span translate=" ">Point A :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinA" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateA" required></div></div><div class="form-group"><label class="col-md-4 control-label" for="pinB"><span translate=" ">Point B :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinB" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateB" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'modalLatLongs\')">Cancel</button> <button type="button" class="btn btn-primary" ng-disabled="!vm.getLocationCoordinateA || !vm.getLocationCoordinateB" ng-click="vm.onLocationCoordinates()">OK</button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-task/tr-tasks.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-tasks"></i> <span>Tasks</span></h3></div><div class="box-tools route_labels"><span class="btn btn-create btn-sm" ng-click="vm.openLogs()" ng-if="has_ROLE_PLAN_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span>Import Logs</span></span></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="row"><label class="col-md-1 control-label"><span>Filters :</span></label><div class="col-md-3 dropFilter"><div isteven-multi-select input-model="vm.projects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" translation="type.project" output-properties="id" selection-mode="single" helper-elements="filter" max-height="170px" on-item-click="vm.clickProject()"></div></div><div class="col-md-3 dropFilter" ng-show="vm.selectedProject.length"><div ng-if="vm.routes.length >= 2" isteven-multi-select input-model="vm.routes" output-model="vm.selectedRoute" button-label="name" item-label="name" tick-property="ticked" translation="type.route" output-properties="id" helper-elements="all none Done filter" max-height="170px" max-labels="1" on-select-done="vm.clickRoute()"></div><div ng-if="vm.routes.length <=1" isteven-multi-select input-model="vm.routes" output-model="vm.selectedRoute" button-label="name" selection-mode="single" item-label="name" helper-elements="filter" tick-property="ticked" translation="type.route" output-properties="id" max-height="170px" max-labels="1" on-item-click="vm.clickRoute()"></div><span id="noData" ng-if="vm.selectedProject.length && !vm.selectedRoute.length">*Please Select Route</span></div><div class="col-md-3 dropFilter" ng-show="vm.selectedProject.length"><div isteven-multi-select input-model="vm.sections" output-model="vm.selectedSection" button-label="name" item-label="name" tick-property="ticked" translation="type.section" output-properties="id" helper-elements="all none Done filter" max-height="170px" max-labels="1" on-select-done="vm.clickSection()"></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th ng-repeat="header in vm.headers">{{ header.display }}</th></tr></thead><tbody ng-if="has_ROLE_VENDOR_ADMIN"><tr ng-repeat-start="task in vm.tasks track by task.userTaskId" ng-class="{selected: task.isChecked}"><td><a ui-sref="tr-task-detail({id:task.id})">{{task.name}}</a></td><td><span ng-show="task.routeName">{{task.routeName}}</span></td><td>{{task.routeBundleName}}</td><td><span ng-show="task.sectionName">{{task.sectionName}}</span></td><td>{{task.userLogin}}</td><td>{{task.taskLength}}</td><td><span ng-show="task.taskTypeName">{{task.taskTypeName}}</span> <span ng-show="task.taskType.name">{{task.taskType.name}}</span></td><td>{{task.status}}</td><td ng-if="vm.searchTask">{{task.projectName}}</td><td class="td__listViewRow" ng-click="vm.expand(task,task.id);" expand><span ng-if="!task.expand" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Open"></i></span> <span ng-if="task.expand" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Close"></i></span></td><td>{{task.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><div class="action"><a ui-sref="tr-task-detail({id:task.id})" class="action-icons text-info" title="View" ng-if="Roles.TASK_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-task.edit({id:task.id, routeId :task.routeTask[0].routeId,sectionId:null })" class="action-icons text-primary" title="Edit" ng-if="Roles.TASK_EDIT && task.routeTask.length && task.sectionTask.length == 0"><span class="fa fa-pencil-square"></span> </a><a ui-sref="tr-task.edit({id:task.id, sectionId : task.sectionTask[0].sectionId, routeId : task.sectionTask[0].routeId})" class="action-icons text-primary" title="Edit" ng-if="Roles.TASK_EDIT && task.sectionTask.length"><span class="fa fa-pencil-square"></span> </a><a ng-click="vm.taskUserAssign(task)" class="action-icons text-info" title="Assign To" ng-if="has_ROLE_VENDOR_ADMIN"><span class="fa fa-user"></span></a></div></td></tr><tr ng-show="task.expand"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><button class="btn btn-create btn-sm pull-right mb-5 mr-5" ui-sref="task-log.dialog({taskId:task.id, sectionId : null, routeId : task.routeTask[0].routeId, str:\'PROGRESS\' })" title="Create Task Log" ng-if="Roles.DAILYLOG_CREATE && task.routeTask.length && task.sectionTask.length == 0"><span class="glyphicon glyphicon-plus"></span> <span>Add Task Log</span></button> <button class="btn btn-create btn-sm pull-right mb-5 mr-5" ui-sref="task-log.dialog({taskId:task.id, sectionId : task.sectionTask[0].sectionId, routeId : task.sectionTask[0].routeId,str:\'PROGRESS\' })" title="Create Task Log" ng-if="Roles.DAILYLOG_CREATE && task.sectionTask.length"><span class="glyphicon glyphicon-plus"></span> <span>Add Task Log</span></button> <button class="btn btn-create btn-sm mb-5" ui-sref="task-log.dialog({taskId:task.id, sectionId : null, routeId : task.routeTask[0].routeId ,str:\'OBSTACLE\'})" title="Create Obstacle Log" ng-if="Roles.DAILYLOG_CREATE && task.routeTask.length && task.sectionTask.length == 0"><span class="glyphicon glyphicon-plus"></span> <span>Add Obstacle Log</span></button> <button class="btn btn-create btn-sm mb-5" ui-sref="task-log.dialog({taskId:task.id, sectionId : task.sectionTask[0].sectionId, routeId : task.sectionTask[0].routeId ,str:\'OBSTACLE\'})" title="Create Obstacle Log" ng-if="Roles.DAILYLOG_CREATE && task.sectionTask.length"><span class="glyphicon glyphicon-plus"></span> <span>Add Obstacle Log</span></button><tr><th>Work Date</th><th>Work Length (mtrs)</th><th>Number of Hours</th><th>Log Type</th><th>Created Date</th><th>Created By</th><!-- <th>Status</th> --></tr></thead><tbody><tr ng-repeat="item in vm.expandResponse"><td>{{item.workDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td>{{item.workLength}}</td><td>{{item.numberOfHours}}</td><td>{{item.taskLogType}}</td><td>{{item.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td>{{item.createdBy}}</td><!-- <td>\r\n                                                        {{item.status}}\r\n                                                    </td> --></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0"><h4>No data available</h4></td><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null"><h4>Loading...</h4></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.tasks == 0"><h4>No data available</h4></td></tr></tbody><tbody ng-if="!has_ROLE_VENDOR_ADMIN"><tr ng-repeat-start="task in vm.tasks | filter: users track by $index" ng-class="{selected: task.isChecked}"><td><a ui-sref="tr-task-detail({id:task.id})">{{task.name}}</a></td><td><span ng-show="task.routeName">{{task.routeName}}</span></td><td>{{task.routeBundleName}}</td><td><span ng-show="task.sectionName">{{task.sectionName}}</span></td><td>{{task.userLogin}}</td><td>{{task.taskLength}}</td><td><span ng-show="task.taskTypeName">{{task.taskTypeName}}</span> <span ng-show="task.taskType.name">{{task.taskType.name}}</span></td><td>{{task.status}}</td><td ng-if="vm.searchTask">{{task.projectName}}</td><td class="td__listViewRow" ng-click="vm.expand(task,task.id);" expand><span ng-if="!task.expand" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Open"></i></span> <span ng-if="task.expand" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Close"></i></span></td><td>{{task.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><div class="action"><a ui-sref="tr-task-detail({id:task.id})" class="action-icons text-info" title="View" ng-if="Roles.TASK_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-task.edit({id:task.id, routeId :task.routeTask[0].routeId,sectionId:null })" class="action-icons text-primary" title="Edit" ng-if="Roles.TASK_EDIT && task.routeTask.length && task.sectionTask.length == 0"><span class="fa fa-pencil-square"></span> </a><a ui-sref="tr-task.edit({id:task.id, sectionId : task.sectionTask[0].sectionId, routeId : task.sectionTask[0].routeId})" class="action-icons text-primary" title="Edit" ng-if="Roles.TASK_EDIT && task.sectionTask.length"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-show="task.expand"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 5%;"><thead><button class="btn btn-create btn-sm pull-right mb-5 mr-5" ui-sref="task-log.dialog({taskId:task.id, sectionId : null, routeId : task.routeTask[0].routeId, str:\'PROGRESS\' })" title="Create Task Log" ng-if="Roles.DAILYLOG_CREATE && task.routeTask.length && task.sectionTask.length == 0"><span class="glyphicon glyphicon-plus"></span> <span>Add Task Log</span></button> <button class="btn btn-create btn-sm pull-right mb-5 mr-5" ui-sref="task-log.dialog({taskId:task.id, sectionId : task.sectionTask[0].sectionId, routeId : task.sectionTask[0].routeId,str:\'PROGRESS\' })" title="Create Task Log" ng-if="Roles.DAILYLOG_CREATE && task.sectionTask.length"><span class="glyphicon glyphicon-plus"></span> <span>Add Task Log</span></button> <button class="btn btn-create btn-sm mb-5" ui-sref="task-log.dialog({taskId:task.id, sectionId : null, routeId : task.routeTask[0].routeId ,str:\'OBSTACLE\'})" title="Create Obstacle Log" ng-if="Roles.DAILYLOG_CREATE && task.routeTask.length && task.sectionTask.length == 0"><span class="glyphicon glyphicon-plus"></span> <span>Add Obstacle Log</span></button> <button class="btn btn-create btn-sm mb-5" ui-sref="task-log.dialog({taskId:task.id, sectionId : task.sectionTask[0].sectionId, routeId : task.sectionTask[0].routeId ,str:\'OBSTACLE\'})" title="Create Obstacle Log" ng-if="Roles.DAILYLOG_CREATE && task.sectionTask.length"><span class="glyphicon glyphicon-plus"></span> <span>Add Obstacle Log</span></button><tr><th>Work Date</th><th>Work Length (mtrs)</th><th>Number of Hours</th><th>Log Type</th><th>Created Date</th><th>Created By</th><!-- <th>Status</th> --></tr></thead><tbody><tr ng-repeat="item in vm.expandResponse"><td>{{item.workDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td>{{item.workLength}}</td><td>{{item.numberOfHours}}</td><td>{{item.taskLogType}}</td><td>{{item.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td>{{item.createdBy}}</td><!-- <td>\r\n                                                        {{item.status}}\r\n                                                    </td> --></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse.length == 0"><h4>No data available</h4></td><td class="td__noDataAvailable" colspan="10" ng-show="vm.expandResponse ==  null"><h4>Loading...</h4></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.tasks == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div><div class="modal fade" id="markerUploadModal" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeAssetMarkerModal()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Assign To</span></div><div class="modal-body"><form name="uploadForm" class="form-horizontal" id="upload-file-form1" ng-submit="vm.saveAssignTo()" method="POST"><div class="box-body"><!--  <div class="alert alert-success" ng-show="vm.success">\r\n                            <p>File has been uploaded successfully</p>\r\n                        </div> --><div class="form-group"><label class="col-md-3 control-label"><span>Task Name</span></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trTask.name" disabled="disabled"></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Assignee</span></label><div class="col-md-5"><span id="noData" ng-if="vm.trTask.userId == null">**Please Select</span><div class="autocomplete-container"><input type="text" ng-model="vm.trTask.userLogin" class="form-control" ng-change="vm.filterActivatedUser()" ng-disabled="!has_ROLE_VENDOR_ADMIN" placeholder="Assign to" required><ul ng-if="showResults" class="autocomplete-list"><li ng-repeat="result in vm.activatedusers" ng-click="assignUser(result.login, result.id)"><img ng-src="content/images/userimg.gif" alt="{{result.login[0]}}" class="autocomplete-list-image"> <span>{{result.login}}</span></li></ul></div></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.closeAssetMarkerModal()" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button> <button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid || vm.trTask.userId == null"><span class="glyphicon glyphicon-save"></span> Assign To</button></div></form></div></div></div></div><div class="modal fade" id="importTaskLogs" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" ng-click="vm.closeModal(\'importTaskLogs\')" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span class="span__modal-header">Import Task Logs</span></div><div class="modal-body"><form name="uploadFormFixed" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-sm-8"><input type="file" name="uploadfileTaskLog" ng-model="uploadfileTaskLog" ng-file-select="uploadfileTaskLog" id="uploadfileTaskLog" class="filestyle" valid-file agent-file ng-pattern="vm.importxl" accept="*.xlsx" required><p class="text-danger" ng-if="uploadFormFixed.uploadfileTaskLog.$error.pattern">Only kml file should be uploaded</p></div></div></div><div class="modal-footer"><button type="button" ng-click="vm.closeModal(\'importTaskLogs\')" class="btn btn-default btn-sm" data-dismiss="modal"><i class="glyphicon glyphicon-ban-circle"></i> Cancel</button> <button class="btn btn-primary btn-sm" ng-disabled="uploadFormFixed.$invalid" ng-click="vm.uploadTaskLogs()">Import</button></div></form></div></div></div></div>');
$templateCache.put('app/entities/tr-terrain/tr-terrain-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><!-- <h3 class="box-title pull-left">\r\n\t\t\t\t\t\t{{vm.trTerrain.name}} - {{vm.trTerrain.id}}\r\n\t\t\t\t\t</h3> --><div class="col-md-7 col-sm-3"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1); search = null" data-toggle="tab"><i class="fa fa-info-circle"></i><span class="header-view"></span> <span class="header_view">Details</span></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2); search = null" data-toggle="tab"><i class="fa fa-commenting"></i><span class="header-view">Comments</span></a></li></ul></div></div><div class="box-body" ng-if="isSet(1)"><jhi-alert-error></jhi-alert-error><a href="javascript:void(0);" ui-sref="tr-terrain" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-terrain.edit({id:vm.trTerrain.id})" class="btn btn-primary btn-sm pull-right" ng-if="Roles.TERRAIN_CREATE"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a><div class="row mt-15"><dl class="dl-horizontal jh-entity-details mt-5"><dt><span>Name</span></dt><dd><span>{{vm.trTerrain.name}}</span></dd><dt><span translate="trakeyeApp.terrain.description">Description</span></dt><dd><span>{{vm.trTerrain.description}}</span></dd><dt><span translate="trakeyeApp.terrain.createDate">Create Date</span></dt><dd><span>{{vm.trTerrain.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.terrain.updateDate">Update Date</span></dt><dd><span>{{vm.trTerrain.lastModifiedDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span translate="trakeyeApp.terrain.terrainType">Terrain Type</span></dt><dd><!--  <a ui-sref="terrain-type-detail({id:vm.trTerrain.terrainType.id})">{{vm.trTerrain.terrainType.name}}</a> --> {{vm.trTerrain.terrainType.name}}</dd><dt><span>VerifiedBy</span></dt><dd><span>{{vm.trTerrain.verifiedBy}}</span></dd><dt><span>Verified</span></dt><dd><span ng-if="vm.trTerrain.isVerified==true">YES</span> <span ng-if="vm.trTerrain.isVerified==false||vm.trTerrain.isVerified==null">NO</span></dd><div class="form-group" ng-repeat="attribute in vm.trTerrain.terrainTypeAttributeValues"><div ng-repeat="attributeValue in vm.trTerrain.terrainTypeAttributeValues track by $index"><div ng-if="attributeValue.terrainTypeAttribute.id == attribute.terrainTypeAttribute.id"><dt><span>{{attribute.terrainTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></div></div></div></dl></div></div><comments obj="vm.objectComments" ng-if="isSet(2)"></comments></div></div></div></div>');
$templateCache.put('app/entities/tr-terrain/tr-terrain-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrTerrainLabel"><img ng-src="content/images/terrainIcon.png" class="terrainImg"> <span ng-if="!vm.trTerrain.id">Create</span> <span ng-if="vm.trTerrain.id">Edit - {{vm.trTerrain.id}}</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div class="form-group"><label class="col-md-3 control-label"><span>Route Name</span></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.trTerrain.routeId" ng-options="item.id as item.name for item in vm.routes" ng-disabled="true" required></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.terrain.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trTerrain.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" translate="trakeyeApp.terrain.description" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trTerrain.description"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Select Terrain Points</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label> <button type="button" class="btn btn-primary btn-sm ml-5" ng-click="vm.removeMarker()" title="Clear Selected Points"><span class="fa fa-refresh"></span></button><div id="map_canvasStart" class="div__map-canvas col-md-8"></div><div class="pull-right"><span id="myspan"></span></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Terrain Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><select class="form-control select2" name="terrainType" ng-model="vm.terrainType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                        vm.terrainTypes track by item.id" ng-disabled="vm.trTerrain.id!=null" required style="width: 100%"><option value="" translate="trakeyeApp.terrain.selectterrain">--- Select TerrainType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.trTerrain.terrainTypeAttributeValues track by $index"><label class="col-md-3 control-label"><span>{{attribute.terrainTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue" ng-if="attribute.terrainTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trTerrain.id" type="text" class="form-control" ng-init="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue = attribute.terrainTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue" ng-if="attribute.terrainTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.trTerrain.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.terrainTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue" ng-if="attribute.terrainTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trTerrain.id" type="text" class="form-control" ng-init="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue = attribute.terrainTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue" ng-if="attribute.terrainTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trTerrain.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.terrainTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Valid Number </span><input ng-model="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue" ng-if="attribute.terrainTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trTerrain.id" type="text" class="form-control" ng-init="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue = attribute.terrainTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue" ng-if="attribute.terrainTypeAttribute.attributeDataType.name == \'STRING\' && vm.trTerrain.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.terrainTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">Enter a Message</span> <select ng-model="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue" ng-init="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue = attribute.terrainTypeAttribute.defaultValue" ng-if="attribute.terrainTypeAttribute.attributeDataType.name != \'STRING\' && attribute.terrainTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.terrainTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trTerrain.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.terrainTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue" ng-init="vm.trTerrain.terrainTypeAttributeValues[$index].attributeValue == attribute.terrainTypeAttribute.defaultValue" ng-if="attribute.terrainTypeAttribute.attributeDataType.name != \'STRING\' && attribute.terrainTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.terrainTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trTerrain.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.terrainTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div><div class="form-group" ng-if="vm.trTerrain.id"><label class="col-md-3 control-label"><span>Phase</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><!-- <select class="form-control" name="status" ng-model="vm.trTerrain.phase" required>\r\n                                        <option value="PLANNING">PLANNING</option>\r\n                                        <option value="SURVEY">SURVEY</option>\r\n                                        <option value="PRE_PLANNING">PRE_PLANNING</option>\r\n                                        <option value="POST_PLANNING">POST_PLANNING</option>\r\n                                        <option value="PROPOSED">PROPOSED</option>\r\n                                        <option value="PRE_ROLLOUT">PRE_ROLLOUT</option>\r\n                                        <option value="ROLLOUT">ROLLOUT</option>\r\n                                        <option value="POST_ROLLOUT">POST_ROLLOUT</option>\r\n                                        <option value="MAINTENANCE">MAINTENANCE</option>\r\n                                    </select> --> <select class="form-control" name="status" ng-model="vm.trTerrain.phase" ng-disabled="!has_ROLE_PLAN_ADMIN"><option value="">--- Select Phase ---</option><option ng-repeat="item in vm.workFlowPhase" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-if="vm.trTerrain.id"><label class="col-md-3 control-label"><span>Verify</span></label><div class="col-md-7"><select class="form-control" ng-model="vm.trTerrain.isVerified" required><option value="false">NO</option><option value="true">YES</option></select></div></div></div><jhi-alert></jhi-alert><div class="box-footer"><jhi-alert-error></jhi-alert-error><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-terrain"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form name="pinForm" role="form" class="form-horizontal" novalidate show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label" for="pinA"><span translate=" ">Point A :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinA" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateA" required></div></div><div class="form-group"><label class="col-md-4 control-label" for="pinB"><span translate=" ">Point B :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinB" id="field_pinLat" ng-pattern="/^[0-9,\\.\\s]*$/" ng-model="vm.getLocationCoordinateB" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal(\'modalLatLongs\')">Cancel</button> <button type="button" class="btn btn-primary" ng-disabled="!vm.getLocationCoordinateA || !vm.getLocationCoordinateB" ng-click="vm.onLocationCoordinates()">OK</button></div></form></div></div></div>');
$templateCache.put('app/entities/tr-terrain/tr-terrains.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-terrains"></i> <img ng-src="content/images/terrainIcon.png" class="terrainImg"> <span>Terrains</span></h3></div><div class="box-tools terrain_labels" ng-if="Roles.TERRAIN_CREATE"><button class="btn btn-create btn-sm" ng-click="vm.createTerrain()"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><th>Terrain Type</th><th>Route</th><th>Phase</th><th>Created Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="terrain in vm.terrains | filter: users track by terrain.id" ng-class="{selected: terrain.isChecked}"><td><a ui-sref="tr-terrain-detail({id:terrain.id})">{{terrain.name}}</a></td><td>{{terrain.terrainTypeName}}</td><td>{{terrain.routeName}}</td><td>{{terrain.phase}}</td><td>{{terrain.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><td><div class="action"><a ui-sref="tr-terrain-detail({id:terrain.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="tr-terrain.edit({id:terrain.id })" class="action-icons text-primary" title="Edit" ng-if="Roles.TERRAIN_CREATE"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.terrains == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-vendor/tr-vendor-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><!-- <h3 class="box-title">\r\n                        <span >Vendor</span> -\r\n                        {{vm.trVendor.name}}\r\n                    </h3> --><div class="col-md-6 col-sm-2"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(1)}"><a href ng-click="setTab(1);" data-toggle="tab"><i class="fa fa-info-circle"></i><span class="header-view"></span> <span class="header_view">Details</span></a></li><li ng-class="{active:isSet(2)}"><a href ng-click="setTab(2); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view"> Materials</span></a></li><li ng-class="{active:isSet(3)}"><a href ng-click="setTab(3); search = null;" data-toggle="tab"><i class="fa fa-list"></i><span class="header-view"> Resources</span></a></li></ul></div></div><div class="box-body" ng-show="isSet(1)"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.trVendor.name}}</span></dd><dt><span>Email</span></dt><dd>{{vm.trVendor.email}}</dd><dt><span>Phone</span></dt><dd>{{vm.trVendor.mobilePhone}}</dd><dt><span>City</span></dt><dd>{{vm.trVendor.city}}</dd><dt><span>State</span></dt><dd>{{vm.trVendor.state}}</dd><dt><span>Country</span></dt><dd>{{vm.trVendor.country}}</dd><dt><span>Pin Code</span></dt><dd>{{vm.trVendor.pin}}</dd><dt><span>Active</span></dt><dd ng-show="vm.trVendor.active"><span class="label label-success">True</span></dd><dd ng-show="!vm.trVendor.active"><span class="label label-danger">False</span></dd></dl><div class="box-buttons pull-right"><a ui-sref="tr-vendor" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-vendor.edit({id:vm.trVendor.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div><div class="table-responsive mt-10" ng-show="isSet(2)"><h3>Summary</h3><div class="table-responsive mt-10" ng-show="vm.groupedMaterialTxn.length"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th></th><th>Project Name</th></tr></thead><tbody><tr ng-repeat-start="task in vm.groupedMaterialTxn"><td class="td__listViewRow" ng-click="vm.expand(task,\'material\');" expand><span ng-if="!task.expand" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Open"></i></span> <span ng-if="task.expand" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Close"></i></span></td><td>{{task.projectName}}</td></tr><tr ng-show="task.expand"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 1%;"><thead><tr><th>Material Name</th><th>Material Type</th><th>Unit of measurement</th><th>No of Units</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="item in task.details"><td>{{item.materialName}}</td><td>{{item.materialTypeName}}</td><td>{{item.unitOfMeasurementName}}</td><td>{{item.totalNoOfUnits}}</td><td>{{item.transactionType}}</td></tr></tbody></table></td></tr><tr ng-repeat-end></tr></tbody></table></div><h4 ng-show="!vm.groupedMaterialTxn.length">No data available</h4><div class="table-responsive mt-10"><h3>Material Inventory Transaction</h3><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th></th><th>Date</th><th>Total</th></tr></thead><tbody><tr ng-repeat-start="task in vm.materialByDate"><td class="td__listViewRow" ng-click="vm.toggleExpand(task)" expand><span ng-if="!task.isExpand" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true" ng-click="vm.loadMaterialTxnByDates(task.timestamp)"></i> </span><span ng-if="task.isExpand" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td>{{task.timestamp | date:\'dd-MM-yyyy\'}}</td><td>{{task.total}}</td></tr><tr ng-if="task.isExpand"><td></td><td colspan="4"><table class="table__userNames"><thead><tr><th>SlNo</th><th>Date</th><th>Material-ID</th><th>Material-Name</th><th>Material-Type</th><th>No of Units</th><th>Transaction-Type</th></tr></thead><tbody><tr ng-repeat="detail in vm.materialTxnByDates"><td>{{$index + 1}}</td><td>{{detail.timestamp | date:\'dd-MM-yyyy\'}}</td><td>{{detail.transactionId}}</td><td>{{detail.transactionName}}</td><td>{{detail.transactionType}}</td><td>{{detail.count}}</td><td>{{detail.status}}</td></tr><tr><td colspan="7"><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadMaterialTxnByDates(task.timestamp)"></uib-pagination></div></div></div></td></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr ng-show="materialByDate.length == 0"><td colspan="3"><h4>No Transaction Available</h4></td></tr></tbody></table><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="totalItems" ng-model="page" ng-change="vm.loadMaterialTxnDate()"></uib-pagination></div></div></div></div></div><div class="table-responsive mt-10" ng-show="isSet(3)"><h3>Summary</h3><div class="table-responsive mt-10" ng-show="vm.groupedResourceTxn.length"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr><th></th><th>Project Name</th></tr></thead><tbody><tr ng-repeat-start="task in vm.groupedResourceTxn"><td class="td__listViewRow" ng-click="vm.expand(task,\'resource\');" expand><span ng-if="!task.expand" class="span__listViewRow"><i class="fa fa-expand" aria-hidden="true" title="Open"></i></span> <span ng-if="task.expand" class="span__listViewRow"><i class="fa fa-compress" aria-hidden="true" title="Close"></i></span></td><td>{{task.projectName}}</td></tr><tr ng-show="task.expand"><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 1%;"><thead><tr><th>Name</th><th>Total no of Resources</th><th>Transaction Type</th></tr></thead><tbody><tr ng-repeat="item in task.details"><td>{{item.resourceName}}</td><td>{{item.totalNoOfResources}}</td><td>{{item.transactionType}}</td></tr></tbody></table></td></tr><tr ng-repeat-end></tr></tbody></table></div><h4 ng-show="!vm.groupedResourceTxn.length">No data available</h4></div></div></div></div></div>');
$templateCache.put('app/entities/tr-vendor/tr-vendor-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrVendorLabel"><span ng-if="!vm.trVendor.id" translate="trakeyeApp.vendor.home.create">Create</span> <span ng-if="vm.trVendor.id">Edit Vendor</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span>Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" ng-model="vm.trVendor.name" ng-required="vm.trVendor.id == null" ng-minlength="1" ng-maxlength="50" ng-readonly="vm.trVendor.id"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.pattern">special characters not allowed.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Email</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="email" class="form-control" name="email" ng-model="vm.trVendor.email" required ng-maxlength="100" ng-pattern="EMAIL_REGEXP"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.pattern">Your e-mail is invalid.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Phone</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="mobilePhone" ng-model="vm.trVendor.mobilePhone" ng-maxlength="14" ng-minlength="10" ng-pattern="PHONE_REGEXP" required><p class="help-block" ng-show="editForm.mobilePhone.$error.maxlength" translate-value-max="14">This field cannot be longer than 14 characters.</p><p class="help-block" ng-show="editForm.mobilePhone.$error.minlength" translate-value-max="10">This field cannot be lesser than 10 characters.</p><p class="help-block" ng-show="editForm.mobilePhone.$error.pattern">Your phone number is invalid.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span>City</span></label><div class="col-md-7"><input type="text" class="form-control" name="city" ng-model="vm.trVendor.city" ng-maxlength="20"><p class="help-block text-danger" ng-show="editForm.city.$error.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span>State</span></label><div class="col-md-7"><input type="text" class="form-control" name="state" ng-model="vm.trVendor.state" ng-maxlength="20"><p class="help-block text-danger" ng-show="editForm.state.$error.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Country</span></label><div class="col-md-7"><input type="text" class="form-control" name="country" ng-model="vm.trVendor.country" ng-maxlength="20"><p class="help-block text-danger" ng-show="editForm.country.$error.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Pin Code</span></label><div class="col-md-7"><input type="text" class="form-control" name="pin" ng-model="vm.trVendor.pin" ng-pattern="/^[0-9]*$/" ng-maxlength="6"><p class="help-block text-danger" ng-show="editForm.pin.$error.maxlength" translate-value-max="6">This field cannot be longer than 6 characters.</p></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Active</span></label><div class="col-md-5"><input name="active" type="checkbox" class="checkbox" id="field_escalated" ng-model="vm.trVendor.active"></div></div></div><jhi-alert></jhi-alert><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-vendor"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div>');
$templateCache.put('app/entities/tr-vendor/tr-vendors.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-vendors"></i> <span>Vendors</span></h3></div><div class="box-tools vendor_labels"><button class="btn btn-create btn-sm" ng-click="vm.createVendor()"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><th>Email</th><!--   <th>Phone</th> --><th>City</th><th>Active</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="vendor in vm.vendors | filter: users track by vendor.id" ng-class="{selected: vendor.isChecked}"><td><a ui-sref="tr-vendor-detail({id:vendor.id})">{{vendor.name}}</a></td><td>{{vendor.email}}</td><!-- <td>{{vendor.mobilePhone}}</td> --><td>{{vendor.city}}</td><td>{{vendor.active}}</td><td><div class="action"><a ui-sref="tr-vendor-detail({id:vendor.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="tr-vendor.edit({id:vendor.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.vendors == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tr-workorder/tr-workorder-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trWorkOrder.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services for this Work Order needs to be deleted before deleting WorkOrder</p><p translate="trakeyeApp.trWorkOrder.delete.question" translate-values="{id: \'{{vm.trWorkOrder.id}}\'}">Are you sure you want to delete this Tr WorkOrder?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tr-workorder/tr-workorder-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span>Work Order</span></h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><a href="javascript:void(0);" onclick="history.back()" class="btn btn-primary btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="tr-workorder.edit({id:vm.trWorkOrder.id})" class="btn btn-primary btn-sm pull-right" ng-if="Roles.WORKORDER_EDIT"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a><dl class="dl-horizontal jh-entity-details"><dt ng-show="vm.trWorkOrder.trWorkOrderAssets.length"><span>Asset Name</span></dt><dd ng-show="vm.trWorkOrder.trWorkOrderAssets.length"><span class="node" ui-sref="asset-detail({id:vm.trWorkOrder.trWorkOrderAssets[0].id})">{{vm.trWorkOrder.trWorkOrderAssets[0].name}}</span></dd><dt><span>Name</span></dt><dd><span>{{vm.trWorkOrder.name}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.trWorkOrder.description}}</span></dd><!-- <dt>\r\n\t\t\t\t\t\t\t<span >Status</span>\r\n\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t<span>{{vm.trWorkOrder.status}}</span>\r\n\t\t\t\t\t\t</dd> --><dt><span>Vendor</span></dt><dd><span>{{vm.trWorkOrder.vendor.name}}</span></dd><dt><span>Create Date</span></dt><dd><span>{{vm.trWorkOrder.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><dt><span>Update Date</span></dt><dd><span>{{vm.trWorkOrder.lastModifiedDate | date:\'dd-MM-yyyy h:mm a\'}}</span></dd><!-- <dt>\r\n\t\t\t\t\t\t\t<span >Work Order Type</span>\r\n\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t<dd ng-if="has_ROLE_USER_ADMIN">\r\n\t\t\t\t\t\t\t{{vm.trWorkOrder.trWorkOrderType.name}}\r\n\t\t\t\t\t\t</dd>\r\n\t\t\t\t\t\t<dd ng-if="has_ROLE_USER">\r\n\t\t\t\t\t\t\t{{vm.trWorkOrder.trWorkOrderType.name}}\r\n\t\t\t\t\t\t</dd>\r\n\t\t\t\t\t\t<div class="form-group" ng-repeat="attribute in vm.trWorkOrder.trWorkOrderTypeAttributeValues">\r\n\t\t\t\t\t\t\t<div ng-repeat="attributeValue in vm.trWorkOrder.trWorkOrderTypeAttributeValues track by $index">\r\n\t\t\t\t\t\t\t\t<div ng-if="attributeValue.trWorkOrderTypeAttribute.id == attribute.trWorkOrderTypeAttribute.id">\r\n\t\t\t\t\t\t\t\t\t<dt>\r\n\t\t\t\t\t\t\t\t\t\t<span>{{attribute.trWorkOrderTypeAttribute.name}}</span>\r\n\t\t\t\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t\t\t\t\t\t<span>{{attributeValue.attributeValue}}</span>\r\n\t\t\t\t\t\t\t\t\t</dd>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<hr /> --><dt><span>Project Name</span></dt><dd><span>{{vm.trWorkOrder.project.name}}</span></dd><dt><span>Route Name</span></dt><dd><span>{{vm.trWorkOrder.route.name}}</span></dd><dt>Sections</dt><dd><table class="jh-table table table-responsive table-hover" style="display: block"><thead class="thead-light"><tr><th><span>Name</span></th><th>Section Length (mtrs)</th></tr></thead><tbody><!-- orderBy:\'isChecked\' --><tr ng-repeat="section in vm.trWorkOrder.sections track by section.id " ng-class="{selected: section.isChecked}"><td><a ui-sref="tr-section-detail({id:section.id,routeId:section.routeId}) " target="_blank">{{section.name}}</a></td><td>{{section.sectionLength}}</td></tr><tr><td colspan="10" ng-show="vm.trWorkOrder.length == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></dd><!-- <dt>\r\n\t\t\t\t\t\t\t<div class="col-md-2 trWorkOrder_showImgDiv" ng-if="vm.trWorkOrder.id">\r\n\t\t\t\t\t\t\t\t<a class="btn btn-sm btn-primary" ng-click="toggle(\'image\')">\r\n\t\t\t\t\t\t\t\t\t<span ng-hide="vm.showImages">Show Images</span>\r\n\t\t\t\t\t\t\t\t\t<span ng-show="vm.showImages">Hide Images</span></a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dt>\r\n\t\t\t\t\t\t<dd ng-if="allimages">\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t\t<div class="col-md-3" ng-repeat="img in vm.trWorkOrderImages">\r\n\t\t\t\t\t\t\t\t\t\t\t<img ng-if="img.image != null" class="img-responsive img__img-responsive"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-src="data:image/jpeg;base64,{{img.image}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.imageInNewTab(img.image)" /><br />\r\n\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s" ng-show="img.imgDescription != null"><b>Description :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgDescription}}</span><br />\r\n\t\t\t\t\t\t\t\t\t\t\t<span class="fs_s"\r\n\t\t\t\t\t\t\t\t\t\t\t\tng-show="img.imgLat != null && img.imgLong != null"><b>LatLng :</b>\r\n\t\t\t\t\t\t\t\t\t\t\t\t{{img.imgLat}},{{img.imgLong}}</span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</dd> --></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tr-workorder/tr-workorder-dialog.html','<div class="content"><div class="row"><div class="col-md-10 col-md-offset-1"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrWorkOrderLabel"><span ng-if="!vm.trWorkOrder.id">Create Work Order</span> <span ng-if="vm.trWorkOrder.id">Edit Work Order</span></h3></div><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label"><span>Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trWorkOrder.name" required></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_description">Description</label><div class="col-md-7"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trWorkOrder.description"></textarea></div></div><!-- <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Work Order Type</span>\r\n                                    <sup><span class="required-icon"><i\r\n                                                class="fa fa-asterisk text-danger"></i></span></sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <select class="form-control select2" name="trWorkOrderType"\r\n                                        ng-model="vm.trWorkOrderType" ng-change="vm.selectAttributes()" ng-options="item as item.name for item in\r\n                                        vm.trWorkOrderTypes track by item.id" ng-disabled="vm.trWorkOrder.id!=null"\r\n                                        required style="width: 100%">\r\n                                        <option value="">\r\n                                            --- Select WorkOrderType ---\r\n                                        </option>\r\n                                    </select>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class="form-group"\r\n                                ng-repeat="attribute in vm.trWorkOrder.trWorkOrderTypeAttributeValues track by $index">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>{{attribute.trWorkOrderTypeAttribute.name}}</span>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <input\r\n                                        ng-model="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.trWorkOrder.id"\r\n                                        type="text" class="form-control"\r\n                                        ng-init="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue = attribute.trWorkOrderTypeAttribute.defaultValue"\r\n                                        name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" />\r\n                                    <input\r\n                                        ng-model="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.trWorkOrder.id"\r\n                                        type="text" class="form-control" name="value{{$index+1}}"\r\n                                        ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" />\r\n                                    <span ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name == \'FLOAT\'"\r\n                                        ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">\r\n                                        Enter a Valid Number (Ex:1.00)</span>\r\n\r\n                                    <input\r\n                                        ng-model="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.trWorkOrder.id"\r\n                                        type="text" class="form-control"\r\n                                        ng-init="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue = attribute.trWorkOrderTypeAttribute.defaultValue"\r\n                                        name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/" />\r\n                                    <input\r\n                                        ng-model="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.trWorkOrder.id"\r\n                                        type="text" class="form-control" name="value{{$index+1}}"\r\n                                        ng-pattern="/^[0-9]{1,7}$/" />\r\n                                    <span ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name == \'INTEGER\'"\r\n                                        ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">\r\n                                        Enter a Valid Number\r\n                                    </span>\r\n\r\n                                    <input\r\n                                        ng-model="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name == \'STRING\' && !vm.trWorkOrder.id"\r\n                                        type="text" class="form-control"\r\n                                        ng-init="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue = attribute.trWorkOrderTypeAttribute.defaultValue"\r\n                                        name="value{{$index+1}}" />\r\n                                    <input\r\n                                        ng-model="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue"\r\n                                        ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name == \'STRING\' && vm.trWorkOrder.id"\r\n                                        type="text" class="form-control" name="value{{$index+1}}" />\r\n                                    <span ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name == \'STRING\'"\r\n                                        ng-show="editForm.value{{$index+1}}.$error.pattern" class="span__valid">\r\n                                        Enter a Message</span>\r\n\r\n                                    <select\r\n                                        ng-model="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue"\r\n                                        ng-init="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue = attribute.trWorkOrderTypeAttribute.defaultValue"\r\n                                        ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name != \'STRING\' && attribute.trWorkOrderTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.trWorkOrderTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.trWorkOrder.id"\r\n                                        class="form-control select2" name="value{{$index+1}}">\r\n                                        <option value="{{ atttype.value  }}"\r\n                                            ng-repeat="atttype in vm.customAttributesMap[attribute.trWorkOrderTypeAttribute.attributeDataType.name]">\r\n                                            {{atttype.value }}\r\n                                        </option>\r\n                                    </select>\r\n                                    <select\r\n                                        ng-model="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue"\r\n                                        ng-init="vm.trWorkOrder.trWorkOrderTypeAttributeValues[$index].attributeValue == attribute.trWorkOrderTypeAttribute.defaultValue"\r\n                                        ng-if="attribute.trWorkOrderTypeAttribute.attributeDataType.name != \'STRING\' && attribute.trWorkOrderTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.trWorkOrderTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.trWorkOrder.id"\r\n                                        class="form-control select2" name="value{{$index+1}}">\r\n                                        <option value="{{ atttype.value  }}"\r\n                                            ng-repeat="atttype in vm.customAttributesMap[attribute.trWorkOrderTypeAttribute.attributeDataType.name]">\r\n                                            {{atttype.value }}\r\n                                        </option>\r\n                                    </select>\r\n                                </div>\r\n                            </div> --><div class="form-group" ng-show="has_ROLE_USER_ADMIN || has_ROLE_ROLLOUT_MANAGER"><label class="col-md-3 control-label"><span>Vendor</span></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedVendor" ng-options="item.id as item.name for item in vm.vendorList" required><option value="">--- Select Vendor ---</option></select></div></div><div class="form-group"><label class="col-md-3 control-label"><span>Select Project</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedProjectId" ng-show="!vm.trWorkOrder.id" ng-change="onProjectChange();" ng-disabled="vm.trWorkOrder.id" ng-options="item.id as item.name for item in vm.projects" required><option value="">--- Select Project ---</option></select><!-- <span ng-if="vm.trWorkOrder.id">{{vm.project.name}}</span> --></div></div><div class="form-group" ng-show="vm.selectedProjectId>0"><label class="col-md-3 control-label"><span>Select Routes</span><sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" ng-model="vm.selectedRouteId" ng-show="!vm.trWorkOrder.id" ng-change="onRouteChange();" ng-options="item.id as item.name for item in vm.routes" ng-disabled="vm.trWorkOrder.id" required><option value="">--- Select Route ---</option></select><!-- <span ng-if="vm.trWorkOrder.id">{{vm.route.name}}</span> --></div></div><div class="form-group" ng-if="vm.selectedRouteId>0"><label class="col-md-3 control-label"><span>Select Sections</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3" ng-if="vm.trWorkOrder.id"><span class="label label-default" ng-repeat="section in vm.trWorkOrder.sections">{{ section.name}}<br></span></div><div class="col-md-5 workflow-table" ng-if="!vm.trWorkOrder.id"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr><th></th><th><span>Name</span></th><th>Section Length (mtrs)</th></tr></thead><tbody><tr ng-repeat="section in vm.sections | filter : searchText  track by section.id  " ng-class="{selected: section.isChecked}"><td><input type="checkbox" ng-model="section.isChecked" ng-change="selectEntity()"></td><td><a ui-sref="tr-section-detail({id:section.id,routeId:section.routeId}) " target="_blank">{{section.name}}</a></td><td>{{section.sectionLength}}</td></tr><tr><td colspan="2" ng-show="vm.sections.length == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody><!-- <div class="col-md-5 input-group input-group-sm pull-right">\r\n                                                <input type="text" ng-model="searchText" class="form-control"\r\n                                                    ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/"\r\n                                                    placeholder="Search">\r\n                                                <span class="input-group-btn">\r\n                                                    <button type="button" class="btn btn-info btn-flat"><i\r\n                                                            class="fa fa-search"></i></button>\r\n                                                </span>\r\n                                            </div> --></table></div></div></div><!--  <div class="form-group">\r\n                                <label class="col-md-3 control-label">\r\n                                    <span>Status</span>\r\n                                    <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span>\r\n                                    </sup>\r\n                                </label>\r\n                                <div class="col-md-7">\r\n                                    <select class="form-control" name="status" ng-model="vm.trWorkOrder.status"\r\n                                        id="field_status" required>\r\n                                        <option value="NEW">NEW</option>\r\n                                        <option value="INPROGRESS">IN PROGRESS</option>\r\n                                        <option value="PENDING">PENDING</option>\r\n                                        <option value="ASSIGNED">ASSIGNED</option>\r\n                                        <option value="RESOLVED">RESOLVED</option>\r\n                                        <option value="CANCELLED">CANCELLED</option>\r\n                                    </select>\r\n                                </div>\r\n                            </div> --></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="tr-workorder"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></form></div></div></div>');
$templateCache.put('app/entities/tr-workorder/tr-workorders.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><div class="pull-left"><h3 class="box-title"><i class="fa fa-tasks"></i> <span>Work Orders</span></h3></div><div class="box-tools trWorkOrder_labels" ng-if="Roles.WORKORDER_CREATE"><button class="btn btn-create btn-sm" ui-sref="tr-workorder.new"><span class="glyphicon glyphicon-plus"></span> <span>New</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-7 pull-right" ng-show="isSet(1)"><div class="col-md-4 input-group pull-right"><input type="text" ng-model="search" class="form-control clear" ng-minlength="3"> <span class="input-group-btn"><button type="button " class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10" ng-show="isSet(1)"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="description"><span\r\n                                            translate="trakeyeApp.trWorkOrder.description">Description</span> --><th>Project</th><th>Route</th><th>Vendor</th><!-- <th>Work Order Type</th> --><th>Created Date</th><th>Actions</th></tr></thead><tbody><tr ng-repeat-start="trWorkOrder in vm.trWorkOrders | filter: users track by trWorkOrder.id" ng-class="{selected: trWorkOrder.isChecked}"><td><a ui-sref="tr-workorder-detail({id:trWorkOrder.id})">{{trWorkOrder.name}}</a></td><!--  <td>{{trWorkOrder.description}}</td> --><td>{{trWorkOrder.projectName}}</td><td>{{trWorkOrder.routeName}}</td><td>{{trWorkOrder.vendorName}}</td><td>{{trWorkOrder.createdDate | date:\'dd-MM-yyyy h:mm a\'}}</td><!-- <td>{{trWorkOrder.workOrderTypeName}}</td> --><td><div class="action"><a ui-sref="tr-workorder-detail({id:trWorkOrder.id})" class="action-icons text-info" title="View" ng-if="Roles.WORKORDER_DETAIL"><span class="fa fa-eye"></span> </a><a ui-sref="tr-workorder.edit({id:trWorkOrder.id})" class="action-icons text-primary" title="Edit" ng-if="Roles.WORKORDER_EDIT"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr ng-repeat-end></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.trWorkOrders == 0"><h4>No data available</h4></td></tr></tbody></table><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/trakeye-type/trakeye-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trakeyeType.id)"><div class="modal-body text-center mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.trakeyeType.delete.question" translate-values="{id: \'{{vm.trakeyeType.id}}\'}">Are you sure you want to delete this Trakeye Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/trakeye-type/trakeye-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.trakeyeType.detail.title">User Type</span> {{vm.trakeyeType.id}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.trakeyeType.name">Name</span></dt><dd><span>{{vm.trakeyeType.name}}</span></dd><dt><span translate="trakeyeApp.trakeyeType.description">Description</span></dt><dd><span>{{vm.trakeyeType.description}}</span></dd><dt><span translate="trakeyeApp.trakeyeType.createdDate">Created Date</span></dt><dd><span>{{vm.trakeyeType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trakeyeType.updatedDate">Updated Date</span></dt><dd><span>{{vm.trakeyeType.updatedDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.trakeyeType.user">User</span></dt><dd>{{vm.trakeyeType.createdBy}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="{{ vm.previousState }}" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="trakeye-type.edit({id:vm.trakeyeType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/trakeye-type/trakeye-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title"><span ng-if="!vm.trakeyeType.id" translate="trakeyeApp.trakeyeType.home.create">Create</span> <span ng-if="vm.trakeyeType.id" translate="trakeyeApp.trakeyeType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><!-- <div class="form-group" ng-if="vm.trakeyeType.id">\r\n\t\t\t\t\t         <label for="id" class="col-md-2 control-label" translate="global.field.id">ID</label>\r\n\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" id="id" name="id" ng-model="vm.trakeyeType.id" readonly >\r\n\t\t\t\t\t\t\t\t</div>           \r\n\t\t\t\t\t        </div> --><div class="form-group"><label class="col-md-2 control-label" for="field_description"><span translate="trakeyeApp.trakeyeType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trakeyeType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" for="field_description"><span translate="trakeyeApp.trakeyeType.description">Description</span></label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trakeyeType.description"></textarea></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t        \t<label class="col-md-2 control-label">\r\n\t\t\t\t\t          \t\t<span translate="trakeyeApp.trakeyeType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t          \t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t          \t</label>\r\n\t\t\t\t\t\t\t\t<div class="col-md-8">\r\n\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" placeholder="item{{$index + 1}}"  required id="field_key" name="field" ng-model="item.name">\r\n\t\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\t<div class="col-md-2 mt-5">\r\n\t\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t                     ng-click="vm.addmore()" >\r\n\t\t\t\t\t                  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t                  </button>\r\n\t\t\t\t\t                  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t                     ng-click="vm.remove()" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t                    >\r\n\t\t\t\t\t                  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t                  </button>\r\n\t\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t        </div>\t --><div class="form-group caseType_repeat" ng-repeat="item in vm.items"><label class="col-md-2 control-label"><span translate="trakeyeApp.trakeyeType.attribute">Attribute</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" ng-readonly="item.name == \'SLA\'" required></div><label class="col-md-1 control-label"><span translate="trakeyeApp.trakeyeType.dataType">Data Type</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><select ng-disabled="item.id!=null" ng-model="item.dataType" class="form-control select2" ng-change="dataTypeValue()"><option value="{{ atttype  }}" ng-repeat="atttype in attributetypes">{{atttype }}</option></select></div><label class="col-md-2 control-label"><span translate="trakeyeApp.trakeyeType.defaultValue">Dafault Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="number" ng-if="item.dataType == \'\'" class="form-control" id="field_value" name="types" ng-model="item.defaultValue"> <input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.defaultValue" step="0.01" required> <input ng-if="item.dataType == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" ng-pattern="/^[0-9]{1,7}$/" required> <input ng-if="item.dataType == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.defaultValue" required><!--\t<p ng-if="item.dataType == \'float\'" class="help-block"\r\n\t\t\t\t\t\t\t\t   ng-show="editForm.types.$error.pattern">\r\n\t\t\t\t\t\t\t\t\tInvalid.\r\n\t\t\t\t\t\t\t\t</p> --> <select ng-model="item.defaultValue" ng-if="item.dataType == \'BOOLEAN\'" class="form-control select2"><option value="true">True</option><option value="false">False</option></select></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div></div><div class="box-footer"><div class="col-md-3 col-md-offset-2 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="trakeye-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/trakeye-type/trakeye-types.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-eye"></i> <span translate="trakeyeApp.trakeyeType.home.title">User Types</span></h3><div class="box-tools custom_CaseTypeAttr"><button class="btn btn-create" ui-sref="trakeye-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.trakeyeType.home.createLabel">Create User Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.trakeyeType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.trakeyeType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.trakeyeType.description">Description</span> <span class="fa fa-sort"></span></th><!-- <th jh-sort-by="user.login"><span translate="trakeyeApp.trakeyeType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="trakeyeType in vm.trakeyeTypes | filter : users track by trakeyeType.id "><!--  <td><a ui-sref="trakeye-type-detail({id:trakeyeType.id})">{{trakeyeType.id}}</a></td> --><td>{{trakeyeType.name}}</td><td>{{trakeyeType.description}}</td><!-- <td>\r\n\t\t\t\t                        {{trakeyeType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="trakeye-type-detail({id:trakeyeType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="trakeye-type.edit({id:trakeyeType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.trakeyeTypes == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/trworkorder-type/trworkorder-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trWorkOrderType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.trWorkOrderType.delete.question" translate-values="{id: \'{{vm.trWorkOrderType.id}}\'}">Are you sure you want to delete this TrWorkOrder Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/trworkorder-type/trworkorder-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span>Work Order Type</span> {{vm.trWorkOrderType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.trWorkOrderType.name}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.trWorkOrderType.description}}</span></dd><!-- <dt><span>Asset Map View</span></dt>\r\n\t\t\t\t\t\t\t<dd>\r\n\t\t\t\t\t            <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.trWorkOrderType.showInAssetsView" onclick="return false"/> \r\n                                     <span class="slider round" style="cursor: not-allowed;"></span>\r\n                                </label>\r\n\t\t\t\t\t        </dd> --><dt><span>Created Date</span></dt><dd><span>{{vm.trWorkOrderType.createdDate | date:\'medium\'}}</span></dd><dt><span>Update Date</span></dt><dd><span>{{vm.trWorkOrderType.updateDate | date:\'medium\'}}</span></dd><dt><span>User</span></dt><dd>{{vm.trWorkOrderType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="trworkorder-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="trworkorder-type.edit({id:vm.trWorkOrderType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/trworkorder-type/trworkorder-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrWorkOrderTypeLabel"><span ng-if="!vm.trWorkOrderType.id">Create</span> <span ng-if="vm.trWorkOrderType.id">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span>Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.trWorkOrderType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.trWorkOrderType.description"></textarea></div></div><!-- <div class="form-group">\r\n                            <label class="col-md-2 control-label">\r\n                                <span>Asset Map View</span>\r\n                            </label>\r\n                            <div class="col-md-9">\r\n                                <label class="switch" style="margin-top: 7px;">\r\n                                    <input type="checkbox" style="\r\n                                             margin-top: 10px;\r\n                                             margin-left: 15px;\r\n                                         " ng-model="vm.trWorkOrderType.showInAssetsView" /> \r\n                                     <span class="slider round"></span>\r\n                                </label>\r\n                            </div>\r\n                        </div> --><div class="form-group"><label class="col-md-2 control-label"><span for="field_assetimage">Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="trWorkOrderTypeImage" id="trWorkOrderTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 trWorkOrderType_showImg" ng-if="vm.trWorkOrderType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageTrWorkOrder" ng-src="data:image/jpeg;base64,{{vm.trWorkOrderType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.trWorkOrderType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.trWorkOrderType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customTrWorkOrderTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.trWorkOrderType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span>Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span>Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group trWorkOrderType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.trWorkOrderType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.trWorkOrderType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customTrWorkOrderTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.trWorkOrderCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.trWorkOrderTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.trWorkOrderType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="trworkorder-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/trworkorder-type/trworkorder-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span>Work Order Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="trworkorder-type.new"><span class="glyphicon glyphicon-plus"></span> <span>Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="search"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span>Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span>Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.workOrderType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="trWorkOrderType in vm.trWorkOrderTypes  | filter : search  track   by trWorkOrderType.id"><!--  <td><a ui-sref="trworkorder-type-detail({id:trWorkOrderType.id})">{{trWorkOrderType.id}}</a></td> --><td>{{trWorkOrderType.name}}</td><td>{{trWorkOrderType.description}}</td><!--  <td>{{trWorkOrderType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{trWorkOrderType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{trWorkOrderType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="trworkorder-type-detail({id:trWorkOrderType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="trworkorder-type.edit({id:trWorkOrderType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.trWorkOrderTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-flow-type/work-flow-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.caseType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.caseType.delete.question" translate-values="{id: \'{{vm.caseType.id}}\'}">Are you sure you want to delete this Incident Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/work-flow-type/work-flow-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.workFlowType.detail.title">Incident Type</span> {{vm.workFlowType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.workFlowType.name">Name</span></dt><dd><span>{{vm.workFlowType.name}}</span></dd><dt><span translate="trakeyeApp.workFlowType.description">Description</span></dt><dd><span>{{vm.workFlowType.description}}</span></dd><dt><span translate="trakeyeApp.workFlowType.createdDate">Created Date</span></dt><dd><span>{{vm.workFlowType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workFlowType.updateDate">Update Date</span></dt><dd><span>{{vm.workFlowType.updateDate | date:\'medium\'}}</span></dd><!-- <dt><span translate="trakeyeApp.workFlowType.user">User</span></dt> --><!-- <dd>\r\n\t\t\t\t\t\t\t{{vm.workFlowType.user.login}}\r\n\t\t\t\t\t\t</dd> --></dl><div class="box-buttons pull-right"><a ui-sref="work-flow-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="work-flow-type.edit({id:vm.workFlowType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-flow-type/work-flow-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myWorkFlowTypeLabel"><span ng-if="!vm.workFlowType.id" translate="trakeyeApp.workFlowType.home.create">Create</span> <span ng-if="vm.workFlowType.id" translate="trakeyeApp.workFlowType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.workFlowType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.workFlowType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.workFlowType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.workFlowType.description"></textarea></div></div><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.workFlowType.workFlowtypeimage" for="field_assetimage">WorkFlowType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="workFlowTypeImage" id="workFlowTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.workFlowType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 workFlowType_showImg" ng-if="vm.workFlowType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive img__showImageWorkFlow" ng-src="data:image/jpeg;base64,{{vm.workFlowType.image}}"></div></div></div><!-- <div class="form-group" ng-repeat="item in vm.items">\r\n\t\t\t\t\t  \t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control"  id="field_key" name="field"  ng-model="item.name" ng-readonly="item.name == \'SLA\'"  required>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t <label class="col-md-1 control-label plr-5">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t<select ng-disabled="item.id!=null" ng-model="item.dataType" ng-disabled="item.name == \'SLA\'" class="form-control select2" ng-change="dataTypeValue()">\r\n\t\t\t\t\t\t\t  \r\n\t\t\t\t\t\t\t<option value="{{ atttype  }}" ng-repeat="atttype in vm.customWorkFlowTypeAttributes">{{atttype.name }} \r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-2">\r\n\t\t\t\t\t\t\t   <input type="number" ng-if="item.dataType.name == \'\'" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value">\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType == \'FLOAT\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"  ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'INTEGER\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"     ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"  required  >\r\n\t\t\t\t\t\t\t\t<input ng-if="item.dataType.name == \'STRING\'" type="text" class="form-control"  id="field_value" \r\n\t\t\t\t\t\t\t\tname="types"   ng-model="item.value"  required  >\r\n\t\t\t\t\t\t\t    <select ng-model="item.value"  ng-if="item.dataType.name == \'BOOLEAN\'" class="form-control select2" >\r\n\t\t\t\t\t\t\t\t\t<option value="true">True</option>\r\n\t\t\t\t\t\t\t\t    <option value="false">False</option>\r\n\t\t\t\t\t\t\t   </select>\r\n\t\t\t\t\t\t\t</div>  \r\n\t\t\t\t\t\t\t\r\n       \r\n\t\t\t\t\t\t\t<div class="col-md-1 mt-5">\r\n\t\t\t\t\t\t\t\t<button type="button" class="btn btn-xs btn-primary add-more"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.addmore()" >\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-plus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\r\n\t\t\t\t\t\t\t\t  <button type="button" class="btn btn-xs btn-danger remove"\r\n\t\t\t\t\t\t\t\t\t ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t  <i class="fa fa-minus"></i>\r\n\t\t\t\t\t\t\t\t  </button>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>             \r\n\t\t\t\t\t\t</div>\t\r\n\t\t\t\t\t\t --><div class="form-group div__attributes"><div class="row"><label class="col-md-2"><span translate="trakeyeApp.workFlowType.attribute">Attribute</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-3"><span translate="trakeyeApp.workFlowType.dataType">Data Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span translate="trakeyeApp.workFlowType.value">Default Value</span></label> <label class="col-md-1"><span>isMandatory</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-2"><span>Category</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label> <label class="col-md-1"><span>Order</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label></div></div><div class="form-group workFlowType_repeat" ng-repeat="item in vm.items"><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.attribute">Attribute</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><!-- <label class="col-md-1 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.dataType">Data Type</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-3"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customWorkFlowTypeAttributes track by item.id"></select></div><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01"> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value"> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1"><input type="checkbox" class="checkbox input__checkbox" name="isMandatory" id="field_isMandatory" ng-model="item.mandatory" ng-true-value="true" ng-false-value="false"></div><div class="col-md-2"><select ng-model="item.workFlowCategory" class="form-control"><option value="DEFAULT">DEFAULT</option><option value="CATEGORY1">CATEGORY1</option><option value="CATEGORY2">CATEGORY2</option><option value="CATEGORY3">CATEGORY3</option></select></div><div class="col-md-1"><input type="text" class="form-control" ng-model="item.workFlowTypeAttribOrder" maxlength="2" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*?)\\..*/g, \'$1\');"></div><!-- <label class="col-md-2 control-label">\r\n\t\t\t\t\t\t\t\t<span translate="trakeyeApp.workFlowType.value">Dafault Value</span><span> {{$index + 1}}</span> \r\n\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup>\r\n\t\t\t\t\t\t\t</label> --><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore($index)"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="work-flow-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/work-flow-type/work-flow-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.workFlowType.home.title">Work Flow Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="work-flow-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.workFlowType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.workFlowType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.workFlowType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.workFlowType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.workFlowType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="workFlowType in vm.workFlowTypes  | filter : search  track   by workFlowType.id"><!--  <td><a ui-sref="work-flow-type-detail({id:workFlowType.id})">{{workFlowType.id}}</a></td> --><td>{{workFlowType.name}}</td><td>{{workFlowType.description}}</td><!--  <td>{{workFlowType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{workFlowType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{workFlowType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="work-flow-type-detail({id:workFlowType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="work-flow-type.edit({id:workFlowType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td class="td__noDataAvailable" colspan="10" ng-show="vm.workFlowTypes == 0"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-order/work-order-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.workOrder.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><!-- <jhi-alert-error></jhi-alert-error> --><p ng-show="deletefail">Services and notifications for this workorder needs to be deleted before deleting workorder</p><p translate="trakeyeApp.workOrder.delete.question" translate-values="{id: \'{{vm.workOrder.id}}\'}">Are you sure you want to delete this Tr WorkOrder?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/work-order/work-order-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.workOrder.detail.title">Work Order </span>- {{vm.workOrder.id}}</h3></div><div class="col-md-12 mt-5"><a ui-sref="work-order.edit({id:vm.workOrder.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Work Order Details</span></h4><div class="box-body table-scroll"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.workOrder.description">Description</span></dt><dd><span>{{vm.workOrder.description}}</span></dd><dt><span translate="trakeyeApp.workOrder.status">Status</span></dt><dd><!-- <span translate="{{\'trakeyeApp.WorkOrderStatus.\' + vm.workOrder.status}}">{{vm.workOrder.status}}</span> --> <span>{{vm.workOrder.status}}</span></dd><dt><span translate="trakeyeApp.workOrder.workFlows">Associated Work Flows</span></dt><dd><ul><li ng-repeat="workorder in vm.workOrder.workOrderCases">{{workorder.description}}</li></ul></dd><dt><span translate="trakeyeApp.workOrder.workOrderType">Work Order Type</span></dt><dd ng-if="has_ROLE_USER_ADMIN">{{vm.workOrder.workOrderType.name}}</dd><dd ng-if="has_ROLE_USER">{{vm.workOrder.workOrderType.name}}</dd><!-- <div class="col-md-8">\r\n\t\t\t\t\t\t\t<div id="map_canvas" style="height:300px; width:100;"></div>\r\n\t\t\t\t\t\t</div> --><dt><span translate="trakeyeApp.workOrder.assignedTo">Assigned To</span></dt><dd>{{vm.workOrder.assignedToUser}}</dd><dt><span translate="trakeyeApp.workOrder.assignedBy">Assigned By</span></dt><dd>{{vm.workOrder.assignedByUser}}</dd><dt><span translate="trakeyeApp.workOrder.reportedBy">Reported By</span></dt><dd>{{vm.workOrder.reportedByUser}}</dd><dt><span translate="trakeyeApp.workOrder.updatedBy">Updated By</span></dt><dd>{{vm.workOrder.updatedByUser}}</dd><dt><span translate="trakeyeApp.workOrder.createDate">Create Date</span></dt><dd><span>{{vm.workOrder.createDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workOrder.updateDate">Update Date</span></dt><dd><span>{{vm.workOrder.updateDate | date:\'medium\'}}</span></dd></dl></div></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Additional Details</span></h4><div class="box-body table-scroll"><div class="form-group" style="margin-left: 20px" ng-repeat="attribute in vm.workOrder.workOrderTypeAttributeValues | orderBy: \'workOrderTypeAttribute.id\' "><div ng-repeat="attributeValue in vm.workOrder.workOrderTypeAttributeValues track by $index"><div ng-if="attributeValue.workOrderTypeAttribute.id == attribute.workOrderTypeAttribute.id"><dl class="dl-horizontal jh-entity-details"><dt><span>{{attribute.workOrderTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></dl></div></div></div></div></div><div class="box-footer"><div id="audioLayout"><div class="col-md-12"><a href="javascript:void(0);" ng-click="go_back()" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-order/work-order-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myWorkOrderLabel"><span ng-if="!vm.workOrder.id" translate="trakeyeApp.workOrder.home.create">Create</span> <span ng-if="vm.workOrder.id" translate="trakeyeApp.workOrder.home.EditLabel">Edit</span></h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.workOrder.id"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.workOrder.id" readonly="readonly"></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_description"><span translate="trakeyeApp.workOrder.description">Description</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><textarea class="form-control" rows="2" name="description" id="field_description" ng-model="vm.workOrder.description" required></textarea></div></div><div class="form-group" ng-if="vm.workOrder.id"><label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.workOrder.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.workOrder.status" id="field_status" required><!--<option value="NEW" translate="trakeyeApp.WorkOrderStatus.NEW">NEW</option>\r\n\t\t                <option value="INPROGRESS" translate="trakeyeApp.WorkOrderStatus.INPROGRESS">IN PROGRESS</option>\r\n\t\t                <option value="PENDING" translate="trakeyeApp.WorkOrderStatus.PENDING">PENDING</option>\r\n\t\t                <option value="ASSIGNED" translate="trakeyeApp.WorkOrderStatus.ASSIGNED">ASSIGNED</option>\r\n\t\t                <option value="RESOLVED" translate="trakeyeApp.WorkOrderStatus.RESOLVED">RESOLVED</option>\r\n                        <option value="CANCELLED" translate="trakeyeApp.WorkOrderStatus.CANCELLED">CANCELLED</option> --><!-- <option value="NEW">PLANNING PHASE</option>\r\n                                    <option value="INPROGRESS">ROLL-OUT PHASE</option>\r\n                                    <option value="PENDING">PENDING</option>\r\n                                    <option value="ASSIGNED">ASSIGNED</option>\r\n                                    <option value="RESOLVED">OPERATION PHASE</option>\r\n                                    <option value="CANCELLED">CANCELLED</option> --><option ng-repeat="item in vm.workOrderStatus" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-if="vm.workOrder.id"><label class="col-md-3 control-label"><span>Phase</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.workOrder.phase" ng-disabled="vm.phaseAccess" required><option ng-repeat="item in vm.phases" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group"><label class="col-md-3 control-label" for="field_priority"><span translate="trakeyeApp.workOrder.priority">Priority</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="priority" ng-model="vm.workOrder.priority" id="field_priority" required><option disabled="disabled" selected="selected" value>--- Select Priority ---</option><option value="LOW">LOW</option><option value="MEDIUM">MEDIUM</option><option value="HIGH" selected="selected" value>HIGH</option><option value="CRITICAL">CRITICAL</option></select></div></div><div class="form-group" ng-if="(!vm.workOrder.id) && (has_ROLE_USER ||  has_ROLE_USER_ADMIN)"><label class="col-md-3 control-label"><span translate="trakeyeApp.workOrder.group">Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><div is-disabled="true" isteven-multi-select input-model="vm.multigroup" output-model="vm.workOrder.groups" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><input type="text" ng-model="vm.workOrder.groups" name="group" style="display:none" required></div><div class="col-md-3" style="margin-top: 10px;"><i class="fa fa-plus-square" ng-click="vm.navigateGroupfromWorkOrder();" style="cursor: pointer;" title="Create Group"></i></div></div></div><div class="form-group"><label class="col-md-3 control-label"><span translate="trakeyeApp.workOrder.workOrderType">workOrderType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-3"><select class="form-control select2" name="workOrderType" ng-model="vm.workOrderType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.workOrderTypes track by item.id" ng-disabled="vm.workOrder.id!=null" required style="width: 100%;"><option value="" translate="trakeyeApp.workOrder.selectworkorder">--- Select WorkOrderType ---</option></select></div><div class="col-md-3" style="margin-top: 10px;"><i class="fa fa-plus-square" ng-click="vm.navigateWorkOrderTypefromWorkOrder();" style="cursor: pointer;" title="Create Work Order Type"></i></div></div><div class="form-group" ng-repeat="attribute in vm.workOrder.workOrderTypeAttributeValues | orderBy: \'workOrderTypeAttribute.id\' track by $index" ng-class="{ \'has-error\' : userIntForm.value.$invalid }"><label class="col-md-3 control-label"><span>{{attribute.workOrderTypeAttribute.name}}</span></label><div class="col-md-8" ng-repeat="attributeValue in vm.workOrder.workOrderTypeAttributeValues track by $index"><div ng-if="attributeValue.workOrderTypeAttribute.id == attribute.workOrderTypeAttribute.id"><input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'FLOAT\'  && !vm.workOrder.id" type="text" class="form-control" ng-init="attributeValue.attributeValue = attribute.workOrderTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.workOrder.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <span ng-if="attribute.workOrderTypeAttribute.dataType == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.workOrder.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-init="attributeValue.attributeValue = attribute.workOrderTypeAttribute.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.workOrder.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.workOrderTypeAttribute.dataType == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'STRING\' && !vm.workOrder.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="attributeValue.attributeValue = attribute.workOrderTypeAttribute.value" ng-model="attributeValue.attributeValue"> <input ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'STRING\' && vm.workOrder.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="attributeValue.attributeValue"> <span ng-if="attribute.workOrderTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="attributeValue.attributeValue" ng-if="attribute.workOrderTypeAttribute.attributeDataType.name != \'STRING\' && attribute.workOrderTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.workOrderTypeAttribute.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.workOrderTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div><!--<div class="form-group" style="margin-top: 30px;">\r\n                        <div class="col-md-3"></div>\r\n                        \r\n                    </div>\r\n                     <div class="form-group">\r\n                        <div class="col-md-3 search-top" style="margin-left: 20px;">\r\n\r\n                        </div>\r\n                    </div> --><div class="form-group"><!-- <div class="col-md-6">\r\n                            <span  ng-if="vm.asset.id==null && !vm.isSite">\r\n                                <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm"> Nearby Workflows</button>\r\n                            </span>\r\n                        </div> --><div class="col-md-4 workflow-table" style="margin-left: 87px;"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover table-scroll" style="display: block"><thead class="thead-light"><tr><th></th><th><span translate="global.field.id">ID</span></th><th><span translate="trakeyeApp.workOrder.description">Discription</span></th><th><span>Status</span></th><!-- <th><span translate="">BOQ</span></th> --><!-- \t\t\t\t\t\t\t\t\t\t\t<th><span translate="">PB(dBm)</span></th> --><th><span translate="">Distance (kms)</span></th></tr></thead><tbody><tr ng-repeat="workFlow in vm.workFlows | filter : searchText  track by workFlow.id  " ng-class="{selected: workFlow.isChecked}"><td><input type="checkbox" ng-model="workFlow.isChecked" ng-change="selectEntity()"></td><td><a ui-sref="work-flow-detail({id:workFlow.id})">{{workFlow.id}}</a></td><td>{{workFlow.description}}</td><td>{{workFlow.status}}</td><!-- <td>{{workFlow.cost}}</td> --><!-- \t\t\t\t\t\t\t\t\t\t\t<td>{{workFlow.powerBudget}}</td> --><td>{{workFlow.fiberDistance}}</td></tr><tr><td colspan="10" ng-show="vm.workFlows == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody><span ng-if="vm.asset.id==null && !vm.isSite"><button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm">Nearby Workflows</button></span><div class="col-md-5 input-group input-group-sm pull-right"><input type="text" ng-model="searchText" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="Search WorkFlows,ID\'s"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button></span></div></table></div></div><div class="col-md-6"><div id="map_canvas" style="height:400px; width:100%; margin: 10px"></div></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-3 save-buttons"><button type="button" class="btn btn-default btn-sm" ui-sref="work-order"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div><div id="workflowsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 80vw" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Select radius</span> <select name="workflow_distance" id="workflow_distance"><option value="100" selected="selected">100 m</option><option value="150">150 m</option><option value="200">200 m</option><option value="250">250 m</option><option value="500">500 m</option><option value="1000">1 km</option><option value="5000">5 km</option><option value="10000">10 km</option><option value="100000">100 km</option></select> <span class="span__modal-header">and Click on Map to get nearby workflows</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div style="width: 100%;padding-top: 7px;" class="modal-body"><div class="row"><div class="col-md-12 modal_body_map"><div class="location-map-workflows"><div style="width: 100%; height: 72vh; display: inline-block;" id="map_canvas_workflows"></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-order/work-order-import.html','<div class="content"><div class="row"><!-- For user admin --><div class="col-md-8 col-md-offset-2"><div class="box box-info"><div class="box-header"><h3 class="box-title"><i class="fa fa-cloud-upload"></i>Import WorkOrders</h3><div class="box-tools ng-scope"><button class="btn btn-create"><span class="fa fa-download"></span> <a href="content/images/SampleWorkOrders.xlsx" download style="color: #fff">Sample File</a></button></div></div><!-- /.box-header --><!-- form start --><jhi-alert-error></jhi-alert-error><form name="uploadForm" class="form-horizontal" id="upload-file-form1" enctype="multipart/form-data" ng-submit="vm.upload()" method="POST"><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><p>File has been uploaded successfully</p></div><div class="form-group"><label for="upload" class="col-sm-3 control-label">Import File</label><div class="col-sm-8"><input type="file" name="uploadfile" ng-model="uploadfile" ng-file-select="uploadfile" id="uploadfile" class="filestyle" valid-file agent-file accept="*.xlsx||*.xls" required><p class="text-danger" ng-if="uploadForm.uploadfile.$error.pattern">Only excel file should be uploaded</p></div></div></div><div class="box-footer"><div class="col-md-2 col-md-offset-3"><button type="submit" class="btn btn-primary btn-sm" ng-disabled="uploadForm.$invalid" translate="upload.submit"><i class="fa fa-cloud-upload"></i> Upload</button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/work-order/work-orders.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-th-large"></i> <span>Work Orders</span></h3><div class="box-tools" ng-show="vm.createAccess"><button class="btn btn-create btn-sm" ui-sref="work-order.new"><span class="glyphicon glyphicon-plus"></span> <span>New1</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-8" ng-hide="true"><ul class="nav nav-pills nav-justified"><li ng-class="{active:isSet(4)}"><a href ng-click="setTab(4);" data-toggle="tab">Table View</a></li></ul></div><div class="col-md-3 search-top pull-right" ng-show="isSet(1) || isSet(4)"><div class="input-group"><input type="text" ng-model="search" ng-change="vm.searchWorkOrders()" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="{{\'trakeyeApp.workOrder.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterWorkOrderSearch()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-3 search-top pull-right" ng-show="isSet(2) || isSet(5)"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="{{\'trakeyeApp.workOrder.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearchMap()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-3 search-top pull-right" ng-show="isSet(3)"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="{{\'trakeyeApp.workOrder.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearchMap()"><i class="fa fa-search"></i></button></span></div></div></div><div class="row" ng-show="isSet(4)" style="float: right; margin-top: 1px;"><div class="actions dropdown" style="margin-right: 160px;"><div class="dropdown dropdown-scroll" ng-hide="vm.showActions"><button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown">Actions <span class="caret"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" ng-repeat="item in vm.items" ng-click="vm.selectedWorkOrders(item.name)">{{item.name}}</li></ul></div></div><div class="groups dropdown" style="float: right; margin-right:169px; margin-top: -34px;"><div class="dropdown dropdown-scroll" ng-hide="vm.groupOrders" style="margin-right: -190px;"><button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown">Groups <span class="caret"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" ng-repeat="group in vm.multgroup" ng-click="vm.updateWorkOrderGroup(group.name)">{{group.name}}</li></ul></div></div></div><div class="row" ng-show="isSet(4)" style="margin: 25px 0px 0px;"><div class="workOrder-table" ng-show="isSet(4)"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="width: 2%;"><input type="checkbox" ng-click="vm.selectAllWorkOrder()" ng-model="vm.isAllSelected"></th><th style="width: 2%;"></th><th jh-sort-by="id" style="width: 8%;"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description" style="width: 12%;"><span translate="trakeyeApp.workOrder.description">Description</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status" style="width: 8%;"><span translate="trakeyeApp.workOrder.status">Status</span> <span class="fa fa-sort"></span></th><th style="width: 12%;"><span>Phase</span></th><th style="width: 12%;"><span>Completed(%)</span></th><th style="width: 12%;"><span>Rolled Out (km)</span></th><th style="width: 12%;"><span>In Progress (km)</span></th><th style="width: 12%;"><span>Total Distance (km)</span></th><!--<th><span translate="trakeyeApp.workOrder.createdBy">CreatedBy</span></th>--><!-- <th style="width: 14%;"><span>Group</span></th> --><!-- <th><span>Completed (%)</span></th>\r\n                                                            <th><span>Resolved (km)</span></th>\r\n                                                            <th><span>Unresolved (km)</span></th> --><!-- <th style="width: 11%;"><span>Total Distance (km)</span></th> --><!-- <th style="width: 12%;"><span>BOQ</span></th> --><!--                                             <th style="width: 12%;"><span>PB(dBm)</span></th> --><th style="width: 8%;">Actions</th></tr></thead><tbody><tr ng-repeat-start="workOrder in vm.workOrders track by workOrder.id" ng-class="{selected: workOrder.isChecked}"><td style="width: 2%;"><input type="checkbox" ng-model="workOrder.isChecked" ng-change="vm.selectWorkOrderEntity(workOrder)"></td><!-- <td style="position:relative; padding-left: 1px;width: 2%">\r\n                                                <button ng-click="vm.workflowTable(workOrder);" expand\r\n                                                    style="padding: 4px 4px;position: absolute;margin-top: -6px;">\r\n                                                    <span ng-bind="workOrder.isExpanded ? \'-\' : \'+\'"\r\n                                                        style="position: absolute;margin-top: -11px;margin-left: -4px;"></span>\r\n                                                </button>\r\n                                            </td> --><td class="td__listViewRow" ng-click="vm.workflowTable(workOrder);" expand><span ng-if="!workOrder.isExpanded" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="workOrder.isExpanded" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td style="width: 8%;"><a ui-sref="work-order-detail({id:workOrder.id})">{{workOrder.id}}</a></td><td style="width: 12%;">{{workOrder.description}}</td><!-- <td translate="{{\'trakeyeApp.WorkOrderStatus.\' + workOrder.status}}" style="width: 12%;">{{workOrder.status}}</td> --><td style="width: 8%;">{{workOrder.status}}</td><td style="width: 16%;">{{workOrder.phase}}</td><td style="width: 16%;">{{workOrder.percentdistance}}%</td><td style="width: 16%;">{{workOrder.resolved}}</td><td style="width: 16%;">{{workOrder.unresolved}}</td><td style="width: 16%;">{{workOrder.totalDistance}}</td><!-- <td style="width: 14%;">{{workOrder.groups[0].name}}</td> --><!-- <td>{{workOrder.percentdistance}}%</td>\r\n                                                            <td>{{workOrder.resolved}}</td> --><!--<td>{{workOrder.reportedByUser}}</td>--><!-- <td>{{workOrder.unresolved}}</td> --><!-- <td style="width: 11%;">{{workOrder.totalDistance}}</td> --><!-- <td style="width: 12%;"><a\r\n                                                    ng-click="vm.showWorkOrderBreakUps(workOrder)">{{workOrder.Cost}}</a>\r\n                                            </td> --><!--                                             <td style="width: 12%;"><a ng-click="vm.showWorkOrderPowerBudgetBreakUps(workOrder)">{{workOrder.pb}}</a> --><td style="width: 8%;"><div class="actions"><a ui-sref="work-order-detail({id:workOrder.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a id="editlink" ui-sref="work-order.edit({id:workOrder.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="editlink" ui-sref="work-order.delete({id:workOrder.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span> </a><!-- <img src="content/images/map_img.png"\r\n                                                        ng-click="workOrderLocation(workOrder)" /> --></div></td></tr><tr ng-show="workOrder.isExpanded"><td></td><td colspan="11"><table style="width: 100%; height:100%; border-spacing:0; margin-left: 27px;"><thead><tr></tr></thead><tbody><tr ng-repeat-start="child in vm.workflowAssets"><td style="width: 2%;"><!--<input type="checkbox">--></td><!-- <td style="position:relative;width: 2%;">\r\n                                                                <button\r\n                                                                    ng-click="vm.assetsTable({id:child.id});expanding = !expanding"\r\n                                                                    expand\r\n                                                                    style="padding: 4px 4px;position: absolute;margin-top: -6px;">\r\n                                                                    <span ng-bind="expanding ? \'-\' : \'+\'"\r\n                                                                        style="position: absolute;margin-top: -11px;margin-left: -4px;"></span>\r\n                                                                </button>\r\n                                                            </td> --><td style="position:relative;width: 2%;" ng-click="vm.assetsTable({id:child.id});expanding = !expanding" expand><span ng-if="!expanding" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="expanding" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td style="width: 8%;"><a ui-sref="tr-case-detail({id:child.id})">{{child.id}}</a></td><td style="width: 13%;">{{child.description}}</td><!-- <td translate="{{\'trakeyeApp.WorkOrderStatus.\' + workOrder.status}}" style="width: 13%;">{{child.Address}}</td> --><td style="width: 14%;">{{child.status}}</td><td style="width: 12%;">{{child.phase}}</td><td style="width: 13%;">{{child.totalDistance}}</td><td></td><!--                                                             <td style="width: 13%;"><a --><!--                                                                     ng-click="">{{child.pb}}</a></td> --><td style="width: 8%;"><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a ui-sref="tr-case-detail({id:child.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a id="editlink" ui-sref="tr-case.edit({id:child.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="editlink" ui-sref="tr-case.delete({id:child.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span> </a><!-- <img src="content/images/map_img.png"\r\n                                                                        ng-click="workOrderLocation(child)" /> --></div></td></tr><tr ng-show="expanding"><td></td><td colspan="12"><table style="width: 100%; height:100%; border-spacing:0;margin-left: 15px;"><thead><tr></tr></thead><tbody><tr ng-repeat-start="subChild in vm.serviceAssets"><!-- <td style="width: 3%;">\r\n                                                                            </td> --><!-- <td style="position:relative;width: 2%;">\r\n                                                                                <button\r\n                                                                                    ng-click="vm.subChildTable({id:child.id});grandExpand = !grandExpand"\r\n                                                                                    expand\r\n                                                                                    style="padding: 4px 4px;position: absolute;margin-top: -6px;">\r\n                                                                                    <span\r\n                                                                                        ng-bind="grandExpand ? \'-\' : \'+\'"\r\n                                                                                        style="position: absolute;margin-top: -11px;margin-left: -4px;"></span>\r\n                                                                                </button>\r\n                                                                            </td> --><td style="position:relative;width: 2%;" ng-click="vm.subChildTable({id:child.id});grandExpand = !grandExpand" expand><span ng-if="!grandExpand" class="span__listViewRow"><i class="fa fa-plus-square" aria-hidden="true"></i></span> <span ng-if="grandExpand" class="span__listViewRow"><i class="fa fa-minus-square" aria-hidden="true"></i></span></td><td style="width: 10%;"><a ui-sref="asset-detail({id:subChild.id})">{{subChild.id}}</a></td><td style="width: 15%;">{{subChild.description}}</td><!-- <td translate="{{\'trakeyeApp.WorkOrderStatus.\' + workOrder.status}}" style="width: 13%;">{{subChild.Address}}</td> --><td style="width: 13%;">{{subChild.status}}</td><td style="width: 12%;">{{subChild.phase}}</td><td style="width: 13%;">{{subChild.totalDistance}}</td><td></td><!--                                                                             <td style="width: 14%;"><a --><!--                                                                                     ng-click="">{{subChild.pb}}</a> --><!--                                                                             </td> --><td style="width: 11%;"><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a ui-sref="asset-detail({id:subChild.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a id="editlink" ui-sref="asset.edit({id:subChild.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="editlink" ui-sref="asset.delete({id:subChild.id})" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span> </a><!-- <img src="content/images/map_img.png"\r\n                                                                                        ng-click="workOrderLocation(subChild)" /> --></div></td></tr><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr></tbody></table></td></tr><tr ng-repeat-end></tr><tr><td colspan="10" ng-show="vm.workOrders == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div><div class="map-view" ng-show="isSet(2) || isSet(5)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas1" style="height:{{mapHeight}}px; width:100%"></div></div></div></div><div class="map-view" ng-show="isSet(3)"><div class="row mt-5"><div class="col-md-12"><div id="map_canvas2" style="height:{{mapHeight}}px; width:100%"></div></div></div></div></div></div></div></div></div><!--Modal for editing asset--><div id="workOrderLocationModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="myEditAssetText"></span></div><div style="width: 100%; height: 680px; padding-top: 7px;" class="modal-body"><div class="row"><div class="col-md-12 modal_body_map"><div class="location-map-workorder-location" id="location-map-edit"><div style="width: 100%; height: 500px; display: inline-block;" id="map_canvas_workorder_location"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!-- Modal --><div id="assignworkorderModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header modal-info"><button type="button" class="close" ng-click="reset()" data-dismiss="modal">&times;</button><h4 class="modal-title text-left">Assign workorder to {{edituserLogin}}</h4></div><div class="modal-body"><div class="row"><form name="editWorkOrderForm" role="form" class="form-horizontal" novalidate ng-submit="vm.editworkorder()"><div class="form-group"><label class="col-md-3 control-label" translate="entity.action.selectworkorder">Select Work Order Id</label><!-- <div class="col-md-6">\r\n\t\t\t\t\t<select class="form-control select2" id="field_workorderId" name="workorderId"  \r\n\t\t            \tng-options=" workorder.id for workorder in trallworkorders" ng-model="vm.editWorkOrder"  required>\r\n\t\t            \t<option value="" translate="entity.action.selectworkorder">--- Select Work Order ---</option>\r\n\t\t            \t</select>\r\n\t\t\t\t</div> --><div class="col-md-8"><!-- <select class="form-control select2" id="field_workorderId" name="workorderId"  ng-options=" workorder.id for workorder in trallworkorders" ng-model="vm.editWorkOrder" \r\n\t\t              ng-change="vm.selectattributes()" style="width: 100%" required>\r\n\t\t\t\t\t \t<option value="" translate="entity.action.selectworkorder">--- Select Work Order Id ---</option>\r\n\t\t\t\t\t \t</select> --> <input list="workorderslist" class="form-control" id="field_workorderId" ng-pattern="/^[0-9]+$/" placeholder="Search workorder id" type="text" ng-model="vm.seachWorkOrderId" autocomplete="off" name="workorderId" ng-change="vm.filterTrworkordersId()" required><datalist ng-hide="!vm.workorderIds" id="workorderslist" class="form-control1"><option ng-repeat="workorder in vm.workorderIds" value="{{workorder.id}}"></option></datalist><p class="help-block" ng-show="editWorkOrderForm.workorderId.$error.pattern" translate="trakeyeApp.workOrder.workorderiderror">Enter only numeric values for workorder id</p></div></div><div class="form-group"><div class="col-md-3 col-md-offset-3"><button type="submit" ng-disabled="editWorkOrderForm.$invalid" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.assignworkorder">Assign WorkOrder</span></button></div></div></form><p class="text-success text-center" ng-show="vm.success" translate-compile>WorkOrder {{vm.editWorkOrder.id}} has been assigned successfully to user {{edituserLogin}}.</p><p class="text-danger text-center" ng-show="vm.error" translate-compile>{{vm.error}}</p></div></div></div></div></div><div id="workOrderBreakUpModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 50%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">WorkOrder BreakUp({{vm.workOrderName}})</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.hideWorkOrderModal()"><span aria-hidden="true">&times;</span></button></div><div style="width: 100%;padding-top: 7px; height: 300px;" class="modal-body scrollbar"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="description"><span>Work Flow</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span>Date</span> <span class="fa fa-sort"></span></th><th><span>Distance</span></th><th><span>BOQ</span></th></tr></thead><tbody><tr ng-repeat="work in vm.workBreakUps track by work.id"><td>{{work.description}}</td><td>{{work.createDate}}</td><td></td><td>{{work.Cost}}</td></tr><tr><td colspan="10" ng-show="vm.workBreakUps == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><div id="PBWorkOrderBreakUp" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 50%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span style="text-align: left; color: white; font-weight: bold; vertical-align: middle">WorkOrder BreakUp({{vm.workOrderName}})</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.hideWorkOrderPBModal()"><span aria-hidden="true">&times;</span></button></div><div style="width: 100%;padding-top: 7px; height: 300px;" class="modal-body scrollbar"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="description"><span>Work Flow</span> <span class="fa fa-sort"></span></th><th jh-sort-by="status"><span>Date</span> <span class="fa fa-sort"></span></th><th><span>Distance</span></th><!--                                 <th><span>PB(dBm)</span></th> --></tr></thead><tbody><tr ng-repeat="work in vm.workBreakUps track by work.id"><td>{{work.description}}</td><td>{{work.createDate}}</td><td></td><!--                                 <td>{{work.pb}}</td> --></tr><tr><td colspan="10" ng-show="vm.workBreakUps == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-flow/work-flow-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.workFlow.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="trakeyeApp.workFlow.delete.question" translate-values="{id: \'{{vm.workFlow.id}}\'}">Are you sure you want to delete this Work Flow?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/work-flow/work-flow-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.workFlow.detail.title">Work Flow</span> - {{vm.workFlow.id}}</h3></div><div class="col-md-12 mt-5"><a ui-sref="work-flow.edit({id:vm.workFlow.id})" class="btn btn-primary btn-sm" ng-hide="has_ROLE_VENDOR && vm.workFlow.workFlowType.name!=\'Vendor Civil Work\'"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Workflow Details</span></h4><div class="box-body table-scroll"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.workFlow.description">Description</span></dt><dd><span>{{vm.workFlow.description}}</span></dd><dt><span translate="trakeyeApp.workFlow.status">Status</span></dt><dd><span>{{vm.workFlow.status}}</span></dd><dt><span translate="trakeyeApp.workFlow.workFlowType">Incident Type</span></dt><dd>{{vm.workFlow.workFlowType.name}}</dd><dt><span translate="trakeyeApp.workFlow.escalated">Escalated</span></dt><dd><span ng-if="vm.workFlow.escalated">YES</span> <span ng-if="!vm.workFlow.escalated">NO</span></dd><dt><span translate="trakeyeApp.workFlow.verified">Verified</span></dt><dd><span ng-if="vm.workFlow.verified">YES</span> <span ng-if="!vm.workFlow.verified">NO</span></dd><dt><span>Pin Lat</span></dt><dd><span>{{vm.workFlow.pinLat}}</span><!-- <a ui-sref="workflow-type-detail({id:vm.workFlow.address})">{{vm.workFlow.address}}</a> --></dd><dt><span>Pin Long</span></dt><dd><span>{{vm.workFlow.pinLong}}</span><!-- <a ui-sref="workflow-type-detail({id:vm.workFlow.address})">{{vm.workFlow.address}}</a> --></dd><dt><span translate="trakeyeApp.workFlow.assignedTo">Assigned To</span></dt><dd>{{vm.workFlow.assignedToUser}}</dd><dt><span translate="trakeyeApp.workFlow.reportedBy">Reported By</span></dt><dd>{{vm.workFlow.reportedByUser}}</dd><dt><span translate="trakeyeApp.workFlow.updatedBy">Updated By</span></dt><dd>{{vm.workFlow.updatedByUser}}</dd><dt><span translate="trakeyeApp.workFlow.assignedBy">Assigned By</span></dt><dd>{{vm.workFlow.assignedByUser}}</dd><dt><span translate="trakeyeApp.workFlow.createDate">Create Date</span></dt><dd><span>{{vm.workFlow.createDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workFlow.updateDate">Update Date</span></dt><dd><span>{{vm.workFlow.updateDate | date:\'medium\'}}</span></dd></dl></div></div><div class="col-md-6"><h4 class="box-title" style="text-align:unset"><span>Additional Details</span></h4><div class="box-body table-scroll"><div class="form-group" ng-repeat="attribute in vm.workFlow.workFlowTypeAttributeValues"><div ng-repeat="attributeValue in vm.workFlow.workFlowTypeAttributeValues track by $index"><div ng-if="attributeValue.workFlowTypeAttribute.id == attribute.workFlowTypeAttribute.id"><dl class="dl-horizontal jh-entity-details"><dt><span>{{attribute.workFlowTypeAttribute.name}}</span></dt><dd><span>{{attributeValue.attributeValue}}</span></dd></dl></div></div></div></div></div><div class="col-md-12"><div id="audioLayout"></div><div class="box-buttons"><a href="javascript:void(0);" ng-click="go_back()" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/work-flow/work-flow-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" class="form-horizontal" novalidate show-validation><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myTrWorkFlowLabel"><span ng-if="!vm.workFlow.id">Create Workflow</span> <span ng-if="vm.workFlow.id" translate="trakeyeApp.workFlow.home.EditLabel">Edit</span></h3></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><div class="containerwf"><div class="wrapperwf"><div class="arrow-steps clearfix"><div class="step current"><span>Workflow Details</span></div><div class="step"><span>Asset Planning</span></div><div class="step"><span>Save Workflow</span></div></div></div><!-- <button type="button" ng-click="setTab(1)"\r\n\t\t\t\t\t\t\t\t\tng-class="{\'btn-primary\' : vm.toggleFirst, \'btn-default\':!vm.toggleFirst }"\r\n\t\t\t\t\t\t\t\t\tstyle="width: 30%; height: 40px;">\r\n\t\t\t\t\t\t\t\t\t<span>Work Flow Details</span>\r\n\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t<button type="button" ng-disabled="editForm.$invalid ||  vm.isSaving"\r\n\t\t\t\t\t\t\t\t\tng-click="setTab(2)"\r\n\t\t\t\t\t\t\t\t\tng-class="{\'btn-primary\' : vm.toggleSecond, \'btn-default\': !vm.toggleSecond}"\r\n\t\t\t\t\t\t\t\t\tstyle="width: 30%; height: 40px;">\r\n\t\t\t\t\t\t\t\t\t<span>Plan Activity</span>\r\n\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t<button type="button" ng-disabled="editForm.$invalid || vm.isShowing"\r\n\t\t\t\t\t\t\t\t\tng-click="setTab(3)"\r\n\t\t\t\t\t\t\t\t\tng-class="{\'btn-primary\' :vm.toggleThird, \'btn-default\': !vm.toggleThird}"\r\n\t\t\t\t\t\t\t\t\tstyle="width: 30%; height: 40px;">\r\n\t\t\t\t\t\t\t\t\t<span>Save Work Flow</span>\r\n\t\t\t\t\t\t\t\t</button> --></div></div></div><div class="table-responsive table-scroll" ng-show="isSet(1)" style="overflow-x: hidden;"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.workFlow.id" ng-show="isSet(1)"><label for="id" class="col-md-3 control-label" translate="global.field.id">ID</label><div class="col-md-8"><input type="text" class="form-control" id="id" name="id" ng-model="vm.workFlow.id" ng-disabled="vm.workFlow.id!=null"></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_description"><span>Workflow Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input class="form-control" name="description" id="field_description" ng-model="vm.workFlow.description" required ng-disabled="vm.workFlow.id!=null"></div></div><div class="form-group" ng-if="vm.workFlow.id" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_status"><span translate="trakeyeApp.workFlow.status">Status</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.workFlow.status" id="field_status" required><!-- <option value="NEW" translate="trakeyeApp.WorkFlowStatus.NEW">NEW</option>\r\n                                    <option value="INPROGRESS" translate="trakeyeApp.WorkFlowStatus.INPROGRESS">IN PROGRESS</option>\r\n                                    <option value="PENDING" translate="trakeyeApp.WorkFlowStatus.PENDING">PENDING</option>\r\n                                    <option value="ASSIGNED" translate="trakeyeApp.WorkFlowStatus.ASSIGNED">ASSIGNED</option>\r\n                                    <option value="RESOLVED" translate="trakeyeApp.WorkFlowStatus.RESOLVED">RESOLVED</option>\r\n\t\t\t\t\t\t\t\t\t<option value="CANCELLED" translate="trakeyeApp.WorkFlowStatus.CANCELLED">CANCELLED</option> --><!-- <option value="NEW">PLANNING PHASE</option>\r\n\t\t\t\t\t\t\t\t<option value="INPROGRESS">ROLL-OUT PHASE</option>\r\n\t\t\t\t\t\t\t\t<option value="PENDING">PENDING</option>\r\n\t\t\t\t\t\t\t\t<option value="ASSIGNED">ASSIGNED</option>\r\n\t\t\t\t\t\t\t\t<option value="RESOLVED">OPERATION PHASE</option>\r\n\t\t\t\t\t\t\t\t<option value="CANCELLED">CANCELLED</option> --><option ng-repeat="item in vm.workFlowStatus" value="{{item.configKey}}">{{item.configValue}}</option></select></div></div><div class="form-group" ng-show="isSet(1)" ng-if="vm.workFlow.id"><label class="col-md-3 control-label"><span>Phase</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control" name="status" ng-model="vm.workFlow.phase" ng-disabled="vm.phaseAccess" required><option ng-repeat="item in vm.workFlowPhase" value="{{item.configKey}}">{{item.configKey}}</option></select></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_priority"><span translate="trakeyeApp.workFlow.priority">Priority</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><label class="radio-inline"><input type="radio" name="type" ng-model="vm.workFlow.priority" value="CRITICAL" required>CRITICAL</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.workFlow.priority" value="HIGH">HIGH</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.workFlow.priority" value="MEDIUM">MEDIUM</label> <label class="radio-inline"><input type="radio" name="type" ng-model="vm.workFlow.priority" value="LOW">LOW</label><!-- <select class="form-control" name="priority" ng-model="vm.workFlow.priority"\r\n\t\t\t\t\t\t\t\tid="field_priority" required>\r\n\t\t\t\t\t\t\t\t<option disabled selected value> --- Select Priority --- </option>\r\n\t\t\t\t\t\t\t\t<option value="LOW">LOW</option>\r\n\t\t\t\t\t\t\t\t<option value="MEDIUM">MEDIUM</option>\r\n\t\t\t\t\t\t\t\t<option value="HIGH" selected value>HIGH</option>\r\n\t\t\t\t\t\t\t\t<option value="CRITICAL">CRITICAL</option>\r\n\t\t\t\t\t\t\t</select> --></div></div><!-- <div class="form-group" ng-if="has_ROLE_USER_ADMIN" ng-show="isSet(1)">\r\n                            <label class="col-md-3 control-label" for="field_parent">\r\n\t\t\t\t\t\t\t\t<span>Parent WorkFlows</span>\r\n                                <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup>\r\n                            </label>\r\n                            <div class="col-md-8">\r\n                                <input list="userslist" class="form-control" id="field_parent" placeholder="Search workFlow name" type="text" \r\n                                \tng-model="vm.workFlow.parent" autocomplete="off" name="parent" ng-change="vm.filterActivatedworkFlows()" required>\r\n                                <datalist ng-hide="!vm.childAssets" id="workFlowlist" class="form-control1">\r\n                                    <option ng-repeat="child in vm.childAssets" value="{{child.name}}"></option>\r\n                                </datalist>\r\n                            </div>\r\n                        </div> --><div class="form-group" ng-if="(!vm.workFlow.id) && (has_ROLE_USER || has_ROLE_USER_ADMIN)" ng-show="isSet(1)"><label class="col-md-3 control-label"><span translate="trakeyeApp.workFlow.group">Group</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><div is-disabled="true" isteven-multi-select input-model="vm.multigroup" output-model="vm.workFlow.groups" button-label="name" on-item-click="vm.selectedGroup(vm.workFlow.groups)" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><input type="text" ng-model="vm.workFlow.groups" name="group" style="display: none"></div></div><div class="form-group" ng-if="has_ROLE_USER_ADMIN" ng-show="isSet(1)"><label class="col-md-3 control-label" for="field_assignedTo"><span translate="trakeyeApp.workFlow.assignedTo">Assigned To</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input list="userslist" class="form-control" id="field_assignedToUser" placeholder="Search user login name" type="text" ng-model="vm.workFlow.assignedToUser" autocomplete="off" name="assignedToUser" ng-change="vm.filterActivatedUser()" required><datalist ng-hide="!vm.activatedusers" id="userslist" class="form-control1"><option ng-repeat="user in vm.activatedusers" value="{{user.login}}"></option></datalist></div></div><div class="form-group" ng-show="isSet(1)"><label class="col-md-3 control-label"><span translate="trakeyeApp.workFlow.workFlowType">workFlowType</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><select class="form-control select2" name="workFlowType" ng-model="vm.workFlowType" ng-change="vm.selectattributes()" ng-options="item as item.name for item in vm.workFlowTypes track by item.id" ng-disabled="vm.workFlow.id!=null" required style="width: 100%;"><option value="" translate="trakeyeApp.workFlow.selectWorkFlow">--- Select WorkFlowType ---</option></select></div></div><div class="form-group" ng-repeat="attribute in vm.workFlow.workFlowTypeAttributeValues | orderBy: \'workFlowTypeAttribute.id\' track by $index" ng-class="{\'has-error\' : userIntForm.value.$invalid }" ng-show="isSet(1)"><label class="col-md-3 control-label"><span>{{attribute.workFlowTypeAttribute.name}}</span></label><div class="col-md-8" ng-repeat="attributeValue\r\n                                    in vm.workFlow.workFlowTypeAttributeValues track\r\n                                    by $index"><div ng-if="attributeValue.workFlowTypeAttribute.id\r\n                                        == attribute.workFlowTypeAttribute.id"><input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'FLOAT\' && !vm.workFlow.id" type="text" class="form-control" ng-init="attributeValue.attributeValue=\r\n                                            attribute.workFlowTypeAttribute.value" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'FLOAT\' && vm.workFlow.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="attributeValue.attributeValue" step="0.01"> <span ng-if="attribute.workFlowTypeAttribute.dataType\r\n                                            == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'INTEGER\' && !vm.workFlow.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\r\n                                            attribute.workFlowTypeAttribute.value" ng-pattern="/^[0-9]{1,7}$/"> <input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'INTEGER\' && vm.workFlow.id" type="text" class="form-control" ng-model="attributeValue.attributeValue.attributeValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.workFlowTypeAttribute.dataType\r\n                                            == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'STRING\' && !vm.workFlow.id" type="text" class="form-control" name="value{{$index+1}}" ng-init="attributeValue.attributeValue=\r\n                                            attribute.workFlowTypeAttribute.value" ng-model="attributeValue.attributeValue"> <input ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'STRING\' && vm.workFlow.id" type="text" class="form-control" name="value{{$index+1}}" ng-model="attributeValue.attributeValue"> <span ng-if="attribute.workFlowTypeAttribute.attributeDataType.name\r\n                                            == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="attributeValue.attributeValue" ng-init="attributeValue.attributeValue = attribute.workFlowTypeAttribute.value" ng-if="attribute.workFlowTypeAttribute.attributeDataType.name != \'STRING\' && attribute.workFlowTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.workFlowTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.workFlow.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.workFlowTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="attributeValue.attributeValue" ng-init="attributeValue.attributeValue == attribute.workFlowTypeAttribute.attributeValue" ng-if="attribute.workFlowTypeAttribute.attributeDataType.name != \'STRING\' && attribute.workFlowTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.workFlowTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.workFlow.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.workFlowTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select></div></div></div></div><div class="map-view row mt-5" ng-show="isSet(2)"><div class="col-md-9 mt-5 dropFilter"><div isteven-multi-select input-model="vm.assetType" output-model="item" button-label="name icon" item-label="name icon" tick-property="ticked" translation="assetTypeLabel" selection-mode="single" helper-elements="filter" on-item-click="vm.createAssetModal(item[0])" max-height="170px" style="display:inline-block"></div><div ng-show="isSet(2)" style="margin-left:5px;display:inline-block"><button type="button" class="btn btn-primary" ng-click="vm.refreshPage()"><span class="fa fa-refresh"></span> <span>Refresh</span></button></div><div ng-show="isSet(2) && vm.mappedAssetsList.length > 1" style="margin-left:5px;display:inline-block"><button type="button" class="btn btn-primary" ng-click="vm.connectSelectedAssets()"><span><b>Connect Two Assets<b></b></b></span></button></div><div class="column mt-5" id="map_canvas_planning" style="height:58vh;"></div></div><div class="column col-md-3" style="height:60vh"><!-- <div class="row input-group input-group-sm" style="margin-top:3px;margin-left: 5px;">\r\n\t\t\t\t\t\t\t\t\t<input type="text" placeholder="Search" ng-model="searchText" class="search-box">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<br>\r\n\t\t\t\t\t\t\t\t<div class="row">\r\n\t\t\t\t\t\t\t\t\t<div class="box-body scrollbar" id="style-3" style="width: 90%;">\r\n\t\t\t\t\t\t\t\t\t\t<table class="jh-table table table-responsive table-hover"\r\n\t\t\t\t\t\t\t\t\t\t\tstyle="background-color: #eae9e9;">\r\n\t\t\t\t\t\t\t\t\t\t\t<thead class="thead-light">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Asset Type</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th>Type</th>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t</thead>\r\n\t\t\t\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<tr ng-repeat="item in vm.assetType | filter : searchText"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.createAssetModal(item)">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>{{item.name}}</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-show="{{item.imagePath != null}}">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img class="img-responsive" ng-src="{{item.imagePath}}"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tstyle="width: 24px; height: 24px;">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-show="{{item.colorcode != null}}">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img class="square" style="background-color:{{item.colorcode}};">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div> --><div class="table-scroll"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr><th></th><th><span>Name</span></th><th><span>Actions</span></th></tr></thead><tbody><tr ng-repeat="asset in vm.mappedAssetsList" ng-class="{selected: asset.isChecked}"><td><input type="checkbox" ng-model="asset.isChecked" ng-change="selectEntity(asset)"></td><td>{{asset.name}}</td><td><div class="actions" ng-if="has_ROLE_USER_ADMIN || has_ROLE_USER"><a id="editlink" ng-click="vm.editAsset(asset)" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><a id="link" ng-click="vm.deleteAssetModal(asset.name)" class="action-icons text-primary" title="Delete"><span class="fa fa-trash-o"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.mappedAssetsList.length==0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div></div></div><div class="form-group" ng-show="isSet(3)"><jhi-alert-error></jhi-alert-error><div ng-if="vm.previousId"><button class="btn btn-primary btn-sm pull-right" type="button" class="btn btn-primary btn-sm" ng-click="vm.recalculate()"><span>Recalculate</span></button></div><div class="col-md-6"><dl class="dl-horizontal jh-entity-details"><dt><span ng-if="vm.workFlow.description">Workflow Name</span></dt><dd><span>{{vm.workFlow.description}}</span></dd><dt><span translate="trakeyeApp.workFlow.workFlowType" ng-if="vm.workFlow.workFlowType">WorkFlow Type</span></dt><dd ng-if="vm.workFlow.workFlowType">{{vm.workFlow.workFlowType.name}}</dd></dl><!-- <div ng-repeat="attributeValue in vm.workFlow.workFlowTypeAttributeValues track by $index">\r\n\t\t\t\t\t\t\t\t\t\t<div ng-if="attributeValue.workFlowTypeAttribute.id == attribute.workFlowTypeAttribute.id">\r\n\t\t\t\t\t\t\t\t\t\t\t<span style="margin-left: 20%"><b>{{attribute.workFlowTypeAttribute.name}}</b>\r\n\t\t\t\t\t\t\t\t\t\t\t<span style="margin-left: 20px;">{{attribute.attributeValue}}</span></span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>  --><div class="form-group" ng-if="vm.workFlow.workFlowType" style="max-height:39vh;overflow-y:scroll;margin-left: 2px;"><table class="jh-table table table-responsive table-hover" style="width:100%;"><thead class="thead-light"><tr><th style="font-weight: 600;font-size: 12px;color: #26292b;text-align: left;border: 1px solid #dddddd;background:#eee;position: sticky;top: 0;z-index: 10;">Name</th><th style="font-weight: 600;font-size: 12px;color: #26292b;text-align: left;border: 1px solid #dddddd;background: #eee;position: sticky;top: 0;z-index: 10;">Value</th></tr></thead><tbody ng-repeat="attribute in vm.workFlow.workFlowTypeAttributeValues | orderBy: \'workFlowTypeAttribute.id\'"><tr ng-repeat="attributeValue in vm.workFlow.workFlowTypeAttributeValues track by $index"><td ng-if="attributeValue.workFlowTypeAttribute.id == attribute.workFlowTypeAttribute.id" style="border: 1px solid #dddddd;">{{attribute.workFlowTypeAttribute.name}}</td><td ng-if="attributeValue.workFlowTypeAttribute.id == attribute.workFlowTypeAttribute.id" style="border: 1px solid #dddddd;">{{attribute.attributeValue}}</td></tr></tbody></table></div></div><div class="col-md-6"><div class="col-md-9" id="map_canvas_deployed" style="height:57vh; width: 100%;"></div></div></div><div class="box-footer"><div class="col-md-12 next-button" ng-show="isSet(1)" style="text-align:right;margin-right:20px;"><button type="button" class="btn btn-primary btn-sm next" ng-disabled="editForm.$invalid" ng-click="setTab(2)"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 next-button" ng-show="isSet(2)" style="text-align:right; margin-right:20px;"><button type="button" class="prev btn btn-primary btn-sm pull-left" ng-click="setTab(1)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="button" class="btn btn-primary btn-sm next" ng-disabled="editForm.$invalid || vm.isShowing" ng-click="setTab(3)"><span>Next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><div class="col-md-12 save-buttons" ng-show="isSet(3)" style="text-align:right;margin-right:20px;"><button type="button" class="prev btn btn-primary btn-sm pull-left" ng-click="setTab(2)"><span class="glyphicon glyphicon-arrow-left"></span> <span>Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm" ng-click="vm.save()"><span class="glyphicon glyphicon"></span> <span>Submit</span></button></div></div></div></div></form></div></div></div><!--Modal for editing asset--><div id="userPathModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 80vw" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span class="span__header">Edit Asset</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="myEditAssetText"></span></div><div style="width: 100%; height: 78vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="row"><div class="col-md-12"><div class="box-body"><button class="btn btn-info btn-flat" style="float: right; border: none; margin-right: 20px" ng-click="vm.saveEditAsset()"><span><b>Save</b></span></button><div class="row" style="margin:20px"><label class="col-md-3 control-label"><span>Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.asset.name" ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row" style="margin: 20px;"><div class="col-md-3 control-label"><span>Asset Type</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></div><div class="col-md-3 control-label"><span>{{vm.asset.assetType.name}}</span></div></div><div class="row" ng-repeat="attribute in vm.asset.assetTypeAttributeValues track by $index" style="margin: 20px;"><label class="col-md-3 control-label"><span>{{attribute.assetTypeAttribute.name}}</span></label><div class="col-md-7"><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'FLOAT\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number (Ex:1.00)</span> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}" ng-pattern="/^[0-9]{1,7}$/"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'INTEGER\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Valid Number </span><input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && !vm.asset.id" type="text" class="form-control" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" name="value{{$index+1}}"> <input ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\' && vm.asset.id" type="text" class="form-control" name="value{{$index+1}}"> <span ng-if="attribute.assetTypeAttribute.attributeDataType.name == \'STRING\'" ng-show="editForm.value{{$index+1}}.$error.pattern" style="color:red">Enter a Message</span> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue = attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\' && !vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value }}</option></select> <select ng-model="vm.asset.assetTypeAttributeValues[$index].attributeValue" ng-init="vm.asset.assetTypeAttributeValues[$index].attributeValue == attribute.assetTypeAttribute.defaultValue" ng-if="attribute.assetTypeAttribute.attributeDataType.name != \'STRING\' && attribute.assetTypeAttribute.attributeDataType.name != \'FLOAT\' && attribute.assetTypeAttribute.attributeDataType.name != \'INTEGER\'  && vm.asset.id" class="form-control select2" name="value{{$index+1}}"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[attribute.assetTypeAttribute.attributeDataType.name]">{{atttype.value}}</option></select></div></div><div class="row" style="margin: 20px;"><!--<label class="col-md-3 control-label">\r\n\t\t\t\t\t\t\t\t\t\t\t<span>Coordinates</span> \r\n\t\t\t\t\t\t\t\t\t\t\t<sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup>\r\n\t\t\t\t\t\t\t\t\t\t</label>--><div class="col-md-9"><!--<div class="input-group">\r\n\t\t\t                                    <input type="text" class="form-control hide" name="coordinates" id="field_coordinates" disabled ng-model="vm.asset.assetCoordinates" />\r\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id==null && !vm.isSite">\r\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Select On Map</button>\r\n\t\t\t\t\t\t\t\t\t\t\t   </span>\r\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id!=null">\r\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createfence()" class="btn btn-primary btn-sm" >Edit</button>\r\n\t\t\t\t\t\t\t\t\t\t\t   </span>\r\n\t\t\t                                    <span class="input-group-btn" ng-if="vm.asset.id!=null">\r\n\t\t\t\t\t\t\t\t\t\t\t\t   <button type="button" ng-click="vm.createNewFence()" class="btn btn-danger btn-sm" >Recreate</button>\r\n\t\t\t\t\t\t\t\t\t\t\t   </span>\r\n\t\t\t                                </div>\r\n\t\t\t                                <br/>>\r\n\t\t\t                                <h4>{{vm.siteLatLng}}</h4>--><div id="map_canvas_edit_asset" style="height:300px;"></div></div></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 80vw" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><span class="span__header">Connect Two Assets</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.hideConnectSitesModal()"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle" id="connectAssetsText"></span></div><!-- Modal body--><div style="width: 80vw; height: 77vh; padding-top: 7px;" class="modal-body"><div class="row"><div style="margin-top: 8px;"><div class="col-md-1 select_asset" style="text-align: right"><label style="padding-top: 6px;">Site A</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;"><select id="fromAssetsView" class="select2 form-control dropwidthHeight" name="search"><option value="">--Select Site A--</option><option ng-repeat="item in vm.mappedAssetsList" value="{{item.name}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px;"><label style="padding-top: 6px;">Site B</label></div><div class="col-md-2 selectAsset_drp" style="text-align:center; margin-right:85px;margin-left: -15px;"><select id="toAssetsView" class="select2 form-control dropwidthHeight" name="search"><option value="">--Select Site B--</option><option ng-repeat="item in vm.mappedAssetsList" value="{{item.name}}">{{item.name}}</option></select></div><div class="col-md-1 select_asset" style="text-align: center; padding: 0px;"><label style="padding-top: 6px;">Spread Type</label></div><div class="col-md-2 selectAsset_drp spreadTypeWidth"><select class="select2 form-control dropwidthHeight" id="spreadType" ng-model="vm.selectedAssetType"><option value=" ">--Select Type--</option><option ng-repeat="item in vm.assetTypeResponse" value="{{item.name}}">{{item.name}}</option></select></div><button type="button" ng-click="vm.connectAssets()" ng-disabled="!vm.selectedAssetType" class="btn btn-primary btn-sm">Connect</button></div><div class="form-group"><div class="col-md-12 mt-5"><div id="map_canvas_connect_assets" style="width: 100%;height:63vh;"></div></div></div></div><div class="row"><div class="col-md-12 modal_body_end"></div></div></div></div></div></div><!--Modal for connecting assets--><div id="connectMultipleAssetsModal" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 90%" role="document"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="vm.hideConnectMultipleAssetsModal()" aria-label="Close"><span aria-hidden="true">&times;</span></button> <span style="text-align: left; color: white; font-weight: bold; vertical-align: middle; font-weight: 125;" id="connectAssetsText">Select site to connect</span></div><!-- Modal body--><div style="width: 100%; height: 80vh; padding-top: 7px; overflow: auto;" class="modal-body"><div class="col-md-12"><div id="map_canvas_connect_multiple_assets" style="width: 100%;height:68vh;margin-top: 10px;"></div></div><div class="col-md-12"><button class="btn btn-primary btn-sm pull-right" type="button" ng-click="vm.saveLinkPits()" style="margin: 10px;">Save</button></div></div></div></div></div><!-- Modal for delete asset   --><div id="delete-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 40%; margin: 200px auto;" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cleardeleteAsset()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><h4>Are you sure you want to delete this asset?</h4></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.cleardeleteAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm" ng-click="vm.confirmDeleteAsset()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></div></div></div></div><!-- Modal for create asset   --><div id="create-asset" class="fade modal" role="dialog" data-keyboard="true" tabindex="-1"><div class="modal-dialog modal-fluid" style="width: 45%; margin: 100px auto;"><div class="modal-content"><form name="form" class="css-form" novalidate><div class="modal-header"><span class="span__header">Asset Creation Form of Type {{vm.CreateAssetName}}</span> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clearCreateAsset()">&times;</button></div><div class="modal-body"><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-2 control-label" style="width: 17%;"><span style="vertical-align: center;">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-7" style="width: 71%"><input type="text" name="name" ng-model="vm.assetNameVal" ng-change="vm.searchAssetName()" class="form-control" placeholder="Please Enter AssetName" style="padding: 6px;" required><div ng-show="vm.assetExisting"><div class="help-block" ng-show="form.name.$error">AssetName is already exist</div></div></div></div></div><div class="row" style="margin: 20px;"><!-- <div class="form-group">\r\n\t\t\t\t\t\t\t<label class="col-md-2 control-label" style="width: 17%;">\r\n\t\t\t\t\t\t\t\t<span>Latitude</span>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<input name="Lat" ng-model="vm.assetLat" type="text" style="width: 120%;">\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<label class="col-md-2">\r\n\t\t\t\t\t\t\t\t<span style="padding: 13px;">Longitude</span>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<div class="col-md-3">\r\n\t\t\t\t\t\t\t\t<input name="Long" ng-model="vm.assetLong" type="text"\r\n\t\t\t\t\t\t\t\t\tstyle="width: 120%;">\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div> --> <label class="col-md-2 control-label"><span translate=" ">Co-ordinates</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLatLng" id="field_pinLat" ng-model="vm.getLocationCoordinate" required></div></div><div class="row" style="margin: 20px;"><div class="form-group"><label class="col-md-4 control-label" style="width: 17%;"><span style="vertical-align: center;">ParentSite</span></label><div class="col-md-8" style="width: 71%"><select class="form-control" name="asset" id="asset" ng-model="vm.parentAsset"><!-- <option value="">Select Parent Site </option> --><option ng-repeat="site in vm.mappedAssetsList" ng-if="site.assetType.name == \'Site\'" value="{{site.name}}">{{site.name}}</option></select></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clearCreateAsset()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-primary btn-sm" ng-click="vm.createAsset()" ng-disabled="vm.showAssetCreation"><span ng-show="vm.getLocationCoordinate.length > 0">OK</span> <span ng-hide="vm.getLocationCoordinate.length > 0">Select Location on Map</span></button></div></form></div></div></div><div id="modalLatLongs" class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><span class="span__modal-header">Location Co-ordinates</span> <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')"><span aria-hidden="true">&times;</span></button></div><form ng-show="isSet(2)" name="editForm1" role="form" class="form-horizontal" novalidate ng-submit="vm.showZoomLocation()" show-validation><div class="modal-body"><h4>Please Enter Your Location Co-ordinates</h4><div class="form-group"><label class="col-md-4 control-label"><span translate=" ">Enter the co-ordinates :</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span></sup></label><div class="col-md-8"><input type="text" class="form-control" placeholder="latitude, longitude " name="pinLat" ng-model="vm.getLocationCoordinates" id="field_pinLat" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeGotoLatitute(\'modalLatLongs\')">Cancel</button> <button type="submit" class="btn btn-primary">OK</button></div></form></div></div></div>');
$templateCache.put('app/entities/work-flow/work-flows.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header"><h3 class="box-title"><i class="fa fa-cubes"></i> <span translate="trakeyeApp.workFlow.home.title">Work Flows</span></h3><div class="box-tools"><button class="btn btn-create btn-sm" ui-sref="work-flow.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="trakeyeApp.workFlow.home.createLabel">Create new Work Flow</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 search-top pull-right"><div class="input-group"><input type="text" ng-model="search" class="form-control" ng-minlength="0" ng-pattern="/^[a-zA-Z0-9_ ]{0,}$/" placeholder="{{\'trakeyeApp.workFlow.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterWorkFlowSearch()"><i class="fa fa-search"></i></button></span></div></div></div></div><div class="workflow-table"><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="thead-light"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.workFlow.description">Description</span> <span class="fa fa-sort"></span></th><!--<th jh-sort-by="address" class="table-size"><span translate="trakeyeApp.workFlow.address">Address</span> <span class="fa fa-sort"></span></th>--><!--<th jh-sort-by="escalated"><span translate="trakeyeApp.workFlow.escalated">Escalated</span> <span class="fa fa-sort"></span></th>--><th jh-sort-by="status"><span translate="trakeyeApp.workFlow.status">Status</span> <span class="fa fa-sort"></span></th><th><span>Phase</span></th><!-- <th><span>Group</span></th> --><th><span>Distance</span></th><th><span translate="trakeyeApp.workFlow.assignedTo">Assigned To</span></th><!--<th><span translate="trakeyeApp.workFlow.workFlowType">WorkFlow Type</span> </th>--><th><span translate="trakeyeApp.workFlow.createdBy">CreatedBy</span></th><!-- <th><span>Fiber Status</span></th> --><!--<th><span translate="trakeyeApp.workFlow.geofence">Geofence</span></th>--><th>Actions</th></tr></thead><tbody><tr ng-repeat="workFlow in vm.workFlows track by workFlow.id"><td><a ui-sref="work-flow.edit({id:workFlow.id})">{{workFlow.id}}</a></td><td>{{workFlow.description}}</td><!--<td>{{workFlow.address}}</td>--><!--<td>\r\n                                        <div ng-if="workFlow.escalated">YES</div>\r\n                                        <div ng-if="!workFlow.escalated">NO</div>--><td>{{workFlow.status}}</td><td>{{workFlow.phase}}</td><!-- <td>{{workFlow.groups[0].name}}</td> --><td>{{workFlow.distance}}</td><!--  <td>\r\n                                    {{workFlow.reportedByUser}}\r\n                                </td> --><td>{{workFlow.assignedToUser}}</td><!--<td ng-if="has_ROLE_USER_ADMIN">\r\n                                        <a ui-sref="workflow-type-detail({id:workFlow.workFlowType.id})" >{{workFlow.workFlowType.name}}</a>\r\n                                        {{workFlow.workFlowTypeName}}\r\n                                    </td>--><!--<td ng-if="has_ROLE_USER">\r\n                                        {{workFlow.workFlowTypeName}}\r\n                                    </td>--><td>{{workFlow.reportedByUser}}</td><!-- <td>{{workFlow.fiberStatus}}</td> --><!--<td>{{workFlow.geofenceName}}</td>--><td><div class="actions"><a ui-sref="work-flow-detail({id:workFlow.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a id="editlink" ui-sref="work-flow.edit({id:workFlow.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span> </a><!--  <a id="editlink" ui-sref="work-flow.delete({id:workFlow.id})" class="action-icons text-primary" title="Delete">\r\n                                                <span class="fa fa-trash-o"></span>\r\n                                            </a> --><!-- <img src="content/images/map_img.png" ng-click="workFlowLocation(workFlow)" /> --></div></td></tr><tr><td colspan="10" ng-show="vm.workFlows == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row mt-15"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div><!-- <div class="table-responsive mt-10">\r\n                        <table class="jh-table table table-responsive table-hover">\r\n                            <thead class="bg-default">\r\n                                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span\r\n                                            class="glyphicon glyphicon-sort"></span></th>\r\n                                    <th jh-sort-by="name"><span data-translate="trakeyeApp.workFlow.name">Name</span>\r\n                                        <span class="glyphicon glyphicon-sort"></span>\r\n                                    </th>\r\n                                    <th jh-sort-by="description"><span\r\n                                            data-translate="trakeyeApp.workFlow.description">Description</span> <span\r\n                                            class="glyphicon glyphicon-sort"></span></th>\r\n                                    <th jh-sort-by="createDate"><span\r\n                                            data-translate="trakeyeApp.workFlow.createDate">Create Date</span>\r\n                                        <span class="glyphicon glyphicon-sort"></span>\r\n                                    </th>\r\n                                    <th jh-sort-by="updateDate"><span\r\n                                            data-translate="trakeyeApp.workFlow.updateDate">Update Date</span>\r\n                                        <span class="glyphicon glyphicon-sort"></span>\r\n                                    </th>\r\n                                    <th jh-sort-by="reportedByLogin"><span\r\n                                            data-translate="trakeyeApp.workFlow.reportedBy">Reported\r\n                                            By</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                                    <th jh-sort-by="assignedToLogin"><span\r\n                                            data-translate="trakeyeApp.workFlow.assignedTo">Assigned\r\n                                            To</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                                    <th jh-sort-by="updatedByLogin"><span\r\n                                            data-translate="trakeyeApp.workFlow.updatedBy">Updated\r\n                                            By</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                                    <th jh-sort-by="assignedByLogin"><span\r\n                                            data-translate="trakeyeApp.workFlow.assignedBy">Assigned\r\n                                            By</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                                    <th jh-sort-by="workFlowTypeId"><span\r\n                                            data-translate="trakeyeApp.workFlow.workFlowType">Work Flow\r\n                                            Type</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                                    <th jh-sort-by="workOrderId"><span\r\n                                            data-translate="trakeyeApp.workFlow.workOrder">Work Order</span>\r\n                                        <span class="glyphicon glyphicon-sort"></span>\r\n                                    </th>\r\n                                    <th jh-sort-by="tenantId"><span\r\n                                            data-translate="trakeyeApp.workFlow.tenant">Tenant</span> <span\r\n                                            class="glyphicon glyphicon-sort"></span></th>\r\n                                    <th></th>\r\n                                </tr>\r\n                            </thead>\r\n                            <tbody>\r\n                                <tr ng-repeat="workFlow in vm.workFlows track by workFlow.id">\r\n                                    <td><a ui-sref="work-flow-detail({id:workFlow.id})">{{workFlow.id}}</a></td>\r\n                                    <td>{{workFlow.name}}</td>\r\n                                    <td>{{workFlow.description}}</td>\r\n                                    <td>{{workFlow.createDate}}</td>\r\n                                    <td>{{workFlow.updateDate}}</td>\r\n                                    <td>\r\n                                        {{workFlow.reportedByLogin}}\r\n                                    </td>\r\n                                    <td>\r\n                                        {{workFlow.assignedToLogin}}\r\n                                    </td>\r\n                                    <td>\r\n                                        {{workFlow.updatedByLogin}}\r\n                                    </td>\r\n                                    <td>\r\n                                        {{workFlow.assignedByLogin}}\r\n                                    </td>\r\n                                    <td>\r\n                                        <a\r\n                                            ui-sref="work-flow-type-detail({id:workFlow.workFlowTypeId})">{{workFlow.workFlowTypeId}}</a>\r\n                                    </td>\r\n                                    <td>\r\n                                        <a\r\n                                            ui-sref="work-order-detail({id:workFlow.workOrderId})">{{workFlow.workOrderId}}</a>\r\n                                    </td>\r\n                                    <td>\r\n                                        <a ui-sref="tenant-detail({id:workFlow.tenantId})">{{workFlow.tenantId}}</a>\r\n                                    </td>\r\n                                    <td class="text-right">\r\n                                        <div class="btn-group flex-btn-group-container">\r\n                                            <button type="submit" ui-sref="work-flow-detail({id:workFlow.id})"\r\n                                                class="btn btn-info btn-sm">\r\n                                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                                            </button>\r\n                                            <button type="submit" ui-sref="work-flow.edit({id:vm.workFlow.id})"\r\n                                                class="btn btn-primary btn-sm">\r\n                                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                                            </button>\r\n                                            <button type="submit" ui-sref="work-flow.delete({id:workFlow.id})"\r\n                                                class="btn btn-danger btn-sm">\r\n                                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                                <span class="hidden-sm-down"\r\n                                                    data-translate="entity.action.delete"></span>\r\n                                            </button>\r\n                                        </div>\r\n                                    </td>\r\n                                </tr>\r\n                            </tbody>\r\n                        </table>\r\n                    </div>\r\n                    <div class="text-center">\r\n                        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage">\r\n                        </jhi-item-count>\r\n                        <uib-pagination class="pagination-sm" total-items="vm.totalItems"\r\n                            items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()">\r\n                        </uib-pagination>\r\n                    </div> --></div></div></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div class="content" ng-cloak><div class="row"><div class="col-md-6 col-md-offset-3"><h1 translate="error.title" class="text-center">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/entities/workorder-type/workorder-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.workOrderType.id)"><div class="modal-body mt-20"><jhi-alert-error></jhi-alert-error><p class="text-danger" translate="trakeyeApp.workOrderType.delete.question" translate-values="{id: \'{{vm.workOrderType.id}}\'}">Are you sure you want to delete this Work Order Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/workorder-type/workorder-type-detail.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title"><span translate="trakeyeApp.workOrderType.detail.title">Work Order Type</span> {{vm.workOrderType.name}}</h3></div><div class="box-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="trakeyeApp.workOrderType.name">Name</span></dt><dd><span>{{vm.workOrderType.name}}</span></dd><dt><span translate="trakeyeApp.workOrderType.description">Description</span></dt><dd><span>{{vm.workOrderType.description}}</span></dd><dt><span translate="trakeyeApp.workOrderType.createdDate">Created Date</span></dt><dd><span>{{vm.workOrderType.createdDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workOrderType.updateDate">Update Date</span></dt><dd><span>{{vm.workOrderType.updateDate | date:\'medium\'}}</span></dd><dt><span translate="trakeyeApp.workOrderType.user">User</span></dt><dd>{{vm.workOrderType.user.login}}</dd></dl><div class="box-buttons pull-right"><a ui-sref="workorder-type" class="btn btn-info btn-sm mr5"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span> </a><a ui-sref="workorder-type.edit({id:vm.workOrderType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span translate="entity.action.edit">Edit</span></a></div></div></div></div></div></div>');
$templateCache.put('app/entities/workorder-type/workorder-type-dialog.html','<div class="content"><div class="row"><div class="col-md-12"><div class="box box-info"><div class="box-header"><h3 class="box-title" id="myWorkOrderTypeLabel"><span ng-if="!vm.workOrderType.id" translate="trakeyeApp.workOrderType.home.create">Create</span> <span ng-if="vm.workOrderType.id" translate="trakeyeApp.workOrderType.home.Edit">Edit</span></h3></div><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.workOrderType.name">Name</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-9"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.workOrderType.name" required></div></div><div class="form-group"><label class="col-md-2 control-label" translate="trakeyeApp.workOrderType.description" for="field_description">Description</label><div class="col-md-9"><textarea rows="2" class="form-control" name="description" id="field_description" ng-model="vm.workOrderType.description"></textarea></div></div><div class="form-group"><label class="col-md-2 control-label"><span translate="trakeyeApp.workOrderType.workOrdertypeimage" for="field_assetimage">WorkOrderType Image</span><!-- <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> </sup> --></label><div class="col-md-7"><!--  Donot add required condistion for this inou type. If it is added , then it will not allow to create spread asset type --> <input type="file" name="file" ng-model="workOrderTypeImage" id="workOrderTypeImage" class="filestyle" valid-file accept="image/*" ng-pattern="IMAGE_EXT_REGEXP"><p class="text-danger" ng-if="editForm.file.$error.pattern" translate="trakeyeApp.workOrderType.patternerror">Only image file(jpg, jpeg, png) should be uploaded</p></div><div class="col-md-2 workOrderType_showImg" ng-if="vm.workOrderType.id"><a class="btn btn-sm btn-info" ng-click="toggle()">Show Image</a></div></div><div class="form-group" ng-if="allimages"><div class="row"><div class="col-md-2 col-md-offset-2"><img class="img-responsive" ng-src="data:image/jpeg;base64,{{vm.workOrderType.image}}" style="padding-bottom: 10px;  height:55px;margin-left:15px;"></div></div></div><div class="form-group workOrderType_repeat" ng-repeat="item in vm.items | orderBy: \'id\'"><label class="col-md-2 control-label"><span translate="trakeyeApp.workOrderType.attribute">Attribute</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input type="text" class="form-control" id="field_key" name="field" ng-model="item.name" required></div><label class="col-md-1 control-label"><span translate="trakeyeApp.workOrderType.dataType">Data Type</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><select ng-model="item.attributeDataType" class="form-control select2" ng-options="item as item.name for item in vm.customWorkOrderTypeAttributes track by item.id"></select></div><label class="col-md-2 control-label"><span translate="trakeyeApp.workOrderType.value">Dafault Value</span><span> {{$index + 1}}</span> <sup><span class="required-icon"><i class="fa fa-asterisk text-danger"></i></span> <sup></sup></sup></label><div class="col-md-2"><input ng-if="item.attributeDataType.name == \'FLOAT\'" type="text" class="form-control" id="field_value" name="types" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-model="item.value" step="0.01" required> <input ng-if="item.attributeDataType.name == \'INTEGER\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" ng-pattern="/^[0-9]{1,7}$/" required> <input ng-if="item.attributeDataType.name == \'STRING\'" type="text" class="form-control" id="field_value" name="types" ng-model="item.value" required> <select ng-model="item.value" ng-if="item.attributeDataType.name != \'STRING\' && item.attributeDataType.name != \'FLOAT\' && item.attributeDataType.name != \'INTEGER\'" class="form-control select2"><option value="{{ atttype.value  }}" ng-repeat="atttype in vm.customAttributesMap[item.attributeDataType.name]">{{atttype.value }}</option></select></div><div class="col-md-1 mt-5"><button type="button" class="btn btn-xs btn-primary add-more" ng-click="vm.addmore()"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-xs btn-danger remove" ng-click="vm.remove($index)" ng-disabled="vm.items.length <= 1"><i class="fa fa-minus"></i></button></div></div><div class="box-footer"><div class="col-md-4 col-md-offset-2 save-buttons"><button class="btn btn-default btn-sm" ui-sref="workorder-type"><span class="glyphicon glyphicon-ban-circle"></span> <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-save"></span> <span translate="entity.action.save">Save</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/workorder-type/workorder-types.html','<div class="content"><div class="row"><div class="col-md-12"><!-- Map box --><div class="box box-solid"><div class="box-header"><h3 class="box-title"><span class="fa fa-briefcase"></span> <span translate="trakeyeApp.workOrderType.home.title">Work Order Types</span></h3><div class="box-tools"><button class="btn btn-create" ui-sref="workorder-type.new"><span class="glyphicon glyphicon-plus"></span> <span translate="trakeyeApp.workOrderType.home.createLabel">Create Type</span></button></div></div><div class="box-body"><jhi-alert></jhi-alert><div class="row"><div class="col-md-3 pull-right"><div class="input-group input-group-sm"><input type="text" ng-model="search" class="form-control input-sm" ng-minlength="3" ng-pattern="/^[a-zA-Z0-9_ ]{3,}$/" placeholder="{{\'trakeyeApp.workOrderType.home.search\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="vm.filterSearch()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive mt-10"><table class="jh-table table table-responsive table-hover"><thead class="bg-default"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--  <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="fa fa-sort"></span></th> --><th jh-sort-by="name"><span translate="trakeyeApp.workOrderType.name">Name</span> <span class="fa fa-sort"></span></th><th jh-sort-by="description"><span translate="trakeyeApp.workOrderType.description">Description</span> <span class="fa fa-sort"></span></th><!--  <th jh-sort-by="user.login"><span translate="trakeyeApp.workOrderType.user">User</span> <span class="fa fa-sort"></span></th> --><th>Actions</th></tr></thead><tbody><tr ng-repeat="workOrderType in vm.workOrderTypes  | filter : search  track   by workOrderType.id"><!--  <td><a ui-sref="workorder-type-detail({id:workOrderType.id})">{{workOrderType.id}}</a></td> --><td>{{workOrderType.name}}</td><td>{{workOrderType.description}}</td><!--  <td>{{workOrderType.createdDate | date:\'medium\'}}</td>\r\n\t\t\t\t                    <td>{{workOrderType.updateDate | date:\'medium\'}}</td>--><!-- <td>\r\n\t\t\t\t                        {{workOrderType.createdBy}}\r\n\t\t\t\t                    </td> --><td><div class="actions"><a ui-sref="workorder-type-detail({id:workOrderType.id})" class="action-icons text-info" title="View"><span class="fa fa-eye"></span> </a><a ui-sref="workorder-type.edit({id:workOrderType.id})" class="action-icons text-primary" title="Edit"><span class="fa fa-pencil-square"></span></a></div></td></tr><tr><td colspan="10" ng-show="vm.workOrderTypes == 0" style="text-align: center;"><h4>No data available</h4></td></tr></tbody></table></div><div class="row"><div class="col-md-4"><div class="count-length"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div><div class="col-md-8"><div class="pagination-list pull-right"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<div ng-switch="vm.isAuthenticated()"><!-- After Login --><header class="main-header application-logo" role="navigation" ng-switch-when="true"><a ui-sref="#/" class="logo"><span class="logo-mini"><center><img ng-src="content/images/fy-logo.png" class="imd-responsive sidebarlogo" ng-if="APP_NAME==\'Fiberify\'"></center></span><span class="logo-lg"><center><img ng-src="content/images/fiberify-logo.png" class="img-responsive sidebarlogo" ng-if="APP_NAME==\'Fiberify\'"></center></span></a><nav class="navbar navbar-static-top"><div class="navBar"><a class="sidebar-toggle" data-toggle="offcanvas" role="button"><span class="sr-only">Toggle navigation</span> </a><!-- <div class="c-wrapper2">\r\n                    <div ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                    || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN">\r\n                        <button ui-sref="tr-notification" type="button" class="icon-button">\r\n                            <span class="fa fa-bell notify"></span>\r\n                            <span class="icon-button__badge"></span>\r\n                        </button>\r\n                    </div>\r\n                </div> --><div class="navbar-custom-menu c-wrapper2" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav"><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><img ng-show="image" ng-src="data:image/jpeg;base64,{{image}}" class="img-circle" style="width: 35px; height: 35px" alt="{{userName}}"> <img ng-show="!image" ng-src="content/images/userimg.gif" class="img-circle" style="width: 35px; height: 35px" alt="{{userName}}"> <span><span class="admin-name">{{userName}} </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings"><span class="fa fa-wrench"></span> <span translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password"><span class="fa fa-unlock"></span> <span translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="fa fa-sign-in"></span> <span translate="global.menu.account.logout">Sign out</span></a></li></ul></li></ul></div></div><!-- <h3\r\n                id="dashboardtitle"\r\n                ng-init="vm.dashboardtitle()"\r\n                ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n            || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN"\r\n            >\r\n                <i class="fa fa-home"></i>\r\n                <span>Dashboard</span>\r\n            </h3> --><!-- <span id="dashboardtitle" ng-init="vm.dashboardtitle()">Dashboard</span> --></nav></header><!-- Before Login --><header class="main-header" ng-switch-when="false"><nav class="navbar navbar-inverse navbar-static-top"><div class="container"><div class="row"><!-- <div class="col-sm-6">\r\n                        <a href="http://www.tresbu.com" class="navlogo sidelogo" target="_blank">\r\n                        <span class="mainlogo"> Tresbu.com</span>\r\n                      </a>\r\n                    </div> --><div class="col-sm-12 side-menu-right navbar-top-custom"><ul class="nav navbar-nav navbar-right"><!-- <li ui-sref-active="active" >\r\n                               <a ui-ref="" ng-click="vm.login()" id="login">\r\n                                   <span class="fa fa-log-in"></span>\r\n                                   <span translate="global.menu.account.login">Sign in</span>\r\n                               </a>\r\n                           </li>--><!-- <li class="nav_phn">\r\n                                <a><i class="fa fa-mobile" aria-hidden="true"></i>\r\n                                    +91 9845692420</a>\r\n                            </li> --><!--<li class="nav_phn"><a> <i class="fa fa-phone" aria-hidden="true"></i> +91 804 111 4634 / <i class="fa fa-mobile" aria-hidden="true"></i> +91 9845692420</a></li>--><li ui-sref-active="active"><a ui-sref="login" id="login"><span translate="global.menu.account.login">Sign In</span></a></li><!-- <li><span class="line-login">|</span></li> --><!-- <li ui-sref-active="active">\r\n                                <a ui-sref="register" id="register">\r\n                                    <span translate="global.menu.account.demo">Demo</span>\r\n                                </a>\r\n                            </li> --></ul></div></div></div></nav></header></div><div class="" ng-switch="vm.isAuthenticated()"><aside class="main-sidebar nav-side-bar" ng-switch-when="true" style="height: 100%"><section class="sidebar scrollbar" style="height: 100%"><ul class="sidebar-menu"><li ng-class="{active:  vm.$state.includes(\'dashboard\') || vm.$state.includes(\'dashboard-rollout\')  }" class="treeview" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                    || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_PLAN_ADMIN\r\n                    || has_ROLE_ROLLOUT_ADMIN || has_ROLE_ROLLOUT_MANAGER"><a ng-click="vm.toggleNavbar(\'dashboard\')"><i class="fa fa-home"></i> <span class="">Dashboards</span> <span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span> </a><!--    \r\n                    <a ng-click="vm.toggleNavbar(\'dashboards\')" ng-hide="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                    || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN">\r\n                        <i class="fa fa-home"></i>\r\n                        <span class="">Dashboards</span>\r\n                        <span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span>\r\n                    </a> --><ul class="treeview-menu" ng-style="close"><li ng-class="{active: vm.$state.includes(\'dashboard\') }" class="treeview" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                            || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER"><a ui-sref="dashboard" id="Monitoring"><i class="fa fa-desktop"></i> <span class="">Monitoring Dashboard</span> <span class="pull-right-container"><i></i></span></a></li><!-- <li ui-sref-active="active" ng-if="vm.showRolloutDashboard && (has_ROLE_PLAN_ADMIN\r\n                || has_ROLE_ROLLOUT_ADMIN || has_ROLE_ROLLOUT_MANAGER)"\r\n                            ng-class="{active:  vm.$state.includes(\'dashboard-rollout\')  }">\r\n                            <a ui-sref="dashboard-rollout">\r\n                                <i class="fa fa-home"></i>\r\n                                <span class="">Rollout Dashboard</span>\r\n                            </a>\r\n                        </li> --><li ui-sref-active="active" ng-if="(has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                            || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER|| has_ROLE_READONLY)" ng-class="{active:  vm.$state.includes(\'dashboard-rollout\')  }"><a ui-sref="incident-dashboard"><i class="fa fa-th-large"></i> <span class="">Incidents Dashboard</span></a></li></ul><hr></li><li ng-class="{active: vm.$state.includes(\'tr-case\') || vm.$state.includes(\'asset\') || vm.$state.includes(\'geofence\') \r\n                        || vm.$state.includes(\'location-log\') || vm.$state.includes(\'user-management\') || vm.$state.includes(\'vehicle-management\') }" class="treeview" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                        || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER "><a href="" id="Monitoring" ng-click="vm.toggleNavbar(\'Monitoring\')"><i class="fa fa-desktop"></i> <span class="">Monitoring Management</span> <span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                                    || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN"><a ui-sref="tr-case"><i class="fa fa-th-large"></i> <span translate="global.menu.entities.trCase">Incident</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN || has_ROLE_ROLLOUT_ADMIN || has_ROLE_PLAN_ADMIN"><a ui-sref="asset"><i class="fa fa-cubes"></i> <span translate="global.menu.entities.asset">Assets</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><a ui-sref="geofence"><i class="fa fa-street-view"></i> <span>Geofences</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN || has_ROLE_ROLLOUT_ADMIN || has_ROLE_PLAN_ADMIN"><a ui-sref="geofence-material"><i class="fa fa-briefcase"></i> <span>Material Inventory</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n            || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN"><a ui-sref="location-log"><i class="fa fa-map-marker"></i> <span translate="global.menu.entities.locationLog">Live Monitoring</span></a></li><!-- <li\r\n                ui-sref-active="active"\r\n                ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n            || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN"\r\n            >\r\n                <a ui-sref="tr-notification" ng-click="vm.collapseNavbar()">\r\n                    <i class="fa fa-bell"></i>\r\n                    <span translate="global.menu.entities.trNotification"\r\n                        >Tr Notification</span\r\n                    >\r\n                </a>\r\n            </li> --><!--  <hr ng-if="has_ROLE_USER_ADMIN || has_ROLE_TEAM_LEADER" /> --><li ng-class="{active: vm.$state.includes(\'admin\')}" class="treeview" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                 || has_ROLE_VENDOR_ADMIN"><a href="" id="admin" ng-click="vm.toggleNavbar(\'admin\')"><i class="fa fa-user-plus"></i> <span class="">Admin </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_VENDOR || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><a ui-sref="user-management"><i class="fa fa-user"></i><!--  translate="global.menu.admin.userManagement" --> <span class="">User Management</span></a></li><!-- <li ui-sref-active="active"\r\n                                    ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_VENDOR || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                                    <a ui-sref="vehicle-management">\r\n                                        <i class="fa fa-car"></i>\r\n                                        translate="global.menu.admin.vehicleManagement"\r\n                                        <span class="">Vehicle Management</span>\r\n                                    </a>\r\n                                </li> --><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA"><a ui-sref="upload"><i class="fa fa-cloud-upload"></i> <span translate="global.menu.admin.upload">Upload</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><a ui-sref="asset-history"><i class="glyphicon glyphicon-time"></i> <span>Asset History</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN && vm.showEntityImport"><a ui-sref="entity-import"><i class="fa fa-cloud-upload"></i> <span>Import Entity</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN && vm.showCaseImport"><a ui-sref="case-import"><i class="fa fa-cloud-upload"></i> <span>Import Incident</span></a></li><li ui-sref-active="active"><a ui-sref="amc-status-import"><i class="fa fa-cloud-upload"></i> <span>Import Amc Status</span></a></li><li ui-sref-active="active"><a ui-sref="asset-availability-import"><i class="fa fa-cloud-upload"></i> <span>Import Asset Availability</span></a></li><li ui-sref-active="active" ng-show="Roles.MATERIAL_SIDEBAR"><a ui-sref="tr-material"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.trMaterial">Tr Material</span></a></li><!-- <li ui-sref-active="active"\r\n                                    ng-if="has_ROLE_USER_ADMIN && vm.showAssetLinkRequest">\r\n                                    <a ui-sref="asset-link">\r\n                                        <i class="fa fa-link"></i>\r\n                                        <span>Asset Link Request </span>\r\n                                    </a>\r\n                                </li>  --><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!-- <hr ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                            ||  has_ROLE_VENDOR_ADMIN" /> --><li ng-class="{active: vm.$state.includes(\'report-menu\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><a href="" id="report-menu" ng-click="vm.toggleNavbar(\'report-menu\')"><i class="fa fa-database"></i> <span class="" translate="global.menu.report">Reports </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="battery-report">\r\n                                        <i class="fa fa-battery-full"></i>\r\n                                        <span translate="global.menu.battery-report"> Battery Report</span>\r\n                                    </a>\r\n                                </li>\r\n                                <li ui-sref-active="active">\r\n                                    <a ui-sref="case-aging-report">\r\n                                        <i class="fa fa-bar-chart"></i>\r\n                                        <span translate="global.menu.reportcharts.case-aging-report">\r\n                                            Incident Aging Report\r\n                                        </span>\r\n                                    </a>\r\n                                </li>  --><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="case-tat-report">\r\n                                        <i class="fa fa-bandcamp"></i>\r\n                                        <span translate="global.menu.reportcharts.case-tat-report"> Incident TAT Report </span>\r\n                                    </a>\r\n                                </li> --><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="user-agent-report">\r\n                                        <i class="fa fa-vcard"></i>\r\n                                        <span> User Agent Report </span>\r\n                                    </a>\r\n                                </li> --><!--<li ui-sref-active="active">\r\n                                    <a ui-sref="fiber-status-report">\r\n                                        <i class="fa fa-bandcamp"></i>\r\n                                        <span> Fiber Report </span>\r\n                                    </a>\r\n                                </li>--><!--<li ui-sref-active="active">\r\n                                    <a ui-sref="site-status-report">\r\n                                        <i class="fa fa-bandcamp"></i>\r\n                                        <span> Site Incident Report </span>\r\n                                    </a>\r\n                                </li>--><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="asset-type-site-report">\r\n                                        <i class="fa fa-briefcase"></i>\r\n                                        <span> Site Assets Report </span>\r\n                                    </a>\r\n                                </li> --><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="geofence-report">\r\n                                        <i class="fa fa-briefcase"></i>\r\n                                        <span> Geofence Report </span>\r\n                                    </a>\r\n                                </li> --><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="battery-report">\r\n                                        <i class="fa fa-battery-full"></i>\r\n                                        <span translate="global.menu.battery-report"> Battery Report</span>\r\n                                    </a>\r\n                                </li> --><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="distance-travelled">\r\n                                        <i class="fa fa-motorcycle"></i>\r\n                                        <span translate="global.menu.distance-travelled"> Distance Travelled </span>\r\n                                    </a>\r\n                                </li> --><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="case-type-report">\r\n                                        <i class="fa fa-bandcamp"></i>\r\n                                        <span translate=""> IncidentType Report </span>\r\n                                    </a>\r\n                                </li> --><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="user-attendance-report">\r\n                                        <i class="fa fa-bandcamp"></i>\r\n                                        <span translate=""> User Attendance Report </span>\r\n                                    </a>\r\n                                </li> --><li ui-sref-active="active"><a ui-sref="mobile-user-attendance-report"><i class="fa fa-briefcase"></i> <span translate="">User Attendance Report</span></a></li><li ui-sref-active="active"><a ui-sref="gps-user-attendance-report"><i class="fa fa-motorcycle"></i> <span translate="">Distance Travelled Report</span></a></li><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="vehicle-distance-report">\r\n                                        <i class="fa fa-car"></i>\r\n                                        <span translate="">Vehicle Distance Travelled\r\n                                        </span>\r\n                                    </a>\r\n                                </li> --><li ui-sref-active="active"><a ui-sref="user-reporting-report"><i class="fa fa-calendar-plus-o"></i> <span translate="">User Reporting Status</span></a></li><li ui-sref-active="active"><a ui-sref="user-login-history-report"><i class="fa fa-calendar-plus-o"></i> <span translate="">User Last Log Report</span></a></li><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="user-stats-report">\r\n                                        <i class="fa fa-bar-chart"></i>\r\n                                        <span translate="">User Statistics Report </span>\r\n                                    </a>\r\n                                </li> --><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="asset-health-report">\r\n                                        <i class="fa fa-heartbeat"></i>\r\n                                        <span translate="">Asset Health Report </span>\r\n                                    </a>\r\n                                </li> --><!-- <li ui-sref-active="active" ng-if="vm.showAssetHealthStatus">\r\n                                    <a ui-sref="asset-health-status-report">\r\n                                        <i class="fa fa-heartbeat"></i>\r\n                                        <span translate="">Asset Health Status Report </span>\r\n                                    </a>\r\n                                </li> --><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER"><a ui-sref="entity-dump"><i class="glyphicon glyphicon-envelope"></i> <span translate="">Entity Dump</span></a></li><!-- <li ui-sref-active="active" ng-if="vm.showMonitoringSurveyReport">\r\n                                    <a ui-sref="survey-report">\r\n                                        <i class="fa fa-download"></i>\r\n                                        <span translate="">Survey Report </span>\r\n                                    </a>\r\n                                </li> --><!-- <li\r\n                                    ui-sref-active="active"\r\n                                    ng-if="has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER">\r\n                                    <a ui-sref="cases-dump-report">\r\n                                        <i class="fa fa-download"></i>\r\n                                        <span translate="">Incidents Dump </span>\r\n                                    </a>\r\n                                </li> --><li ui-sref-active="active" ng-if="vm.showMonitoringGeofenceDump && has_ROLE_USER_ADMIN"><a ui-sref="geofence-dump"><i class="fa fa-download"></i> <span translate="">Geofence Dump</span></a></li><!-- <li ui-sref-active="active"\r\n                                    ng-if="(has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER) && vm.showMonitoringSplicingReport">\r\n                                    <a ui-sref="splicing-report">\r\n                                        <i class="fa fa-download"></i>\r\n                                        <span translate="">Splicing Report </span>\r\n                                    </a>\r\n                                </li> --><li ui-sref-active="active" ng-if="(has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER) && vm.showMonitoringUserGeofenceDump"><a ui-sref="user-geofence-report"><i class="fa fa-download"></i> <span translate="">User Geofence Dump</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="incidents-report"><i class="fa fa-download"></i> <span translate="">Incident Report</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="noc-alerts-report"><i class="fa fa-download"></i> <span translate="">NOC Alerts Report</span></a></li><!-- <li ui-sref-active="active"\r\n                                    ng-if="(has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER) && vm.showMonitoringUserGeofenceDump">\r\n                                    <a ui-sref="daily-survey-report">\r\n                                        <i class="fa fa-download"></i>\r\n                                        <span translate="">Daily Survey Report</span>\r\n                                    </a>\r\n                                </li> --><!--<li ui-sref-active="active">\r\n                                    <a ui-sref="asset-report">\r\n                                        <i class="fa fa-bandcamp"></i>\r\n                                        <span translate="global.menu.asset-report"> Asset Report </span>\r\n                                    </a>\r\n                                </li>--><!--<li ui-sref-active="active">\r\n                                    <a ui-sref="asset-case-report">\r\n                                        <i class="fa fa-bandcamp"></i>\r\n                                        <span translate="global.menu.asset-case-report"> Asset Incident Report </span>\r\n                                    </a>\r\n                                </li>--></ul></li><!--  <hr\r\n                                ng-if="has_ROLE_USER_ADMIN || vm.accessRoleRolloutAdmin || vm.accessRolePlanningAdmin" /> --><li ng-class="{active: vm.$state.includes(\'entity-menu\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN || vm.accessRoleRolloutAdmin || vm.accessRolePlanningAdmin"><a href="" id="entity-menu" ng-click="vm.toggleNavbar(\'entity-menu\')"><i class="fa fa-th-list"></i> <span class="" translate="global.menu.entities.main">Entities </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="geofence">\r\n                                        <i class="fa fa-street-view"></i>\r\n                                        <span translate="global.menu.entities.geofence">Geofence</span>\r\n                                    </a>\r\n                                </li> --><li ng-class="{active: vm.$state.includes(\'case-type\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="case-type" id="case-type" ng-click="vm.toggleNavbar(\'case-type\')"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.caseType">Incident Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-case-type-attribute"><i class="fa fa-briefcase"></i> <span>Incident Type Attributes</span><!-- translate="global.menu.entities.customCaseTypeAttribute" --></a></li><li ui-sref-active="active"><a ui-sref="attribute-mapping"><i class="fa fa-briefcase"></i> <span>Attribute Mapping</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'asset-type\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="asset-type" id="asset-type" ng-click="vm.toggleNavbar(\'asset-type\')"><i class="fa fa-suitcase"></i> <span translate="global.menu.entities.assetType">Asset Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-asset-type-attribute"><i class="fa fa-briefcase"></i> <span>Asset Type Attributes</span><!-- translate="global.menu.entities.customAssetTypeAttribute" --></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'material-type\')}" class="treeview" ng-if="!has_ROLE_USER_ADMIN"><a ui-sref="material-type" id="material-type" ng-click="vm.toggleNavbar(\'material-type\')"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.materialType">Material Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-material-type-attribute"><i class="fa fa-briefcase"></i> <span>Material Type Attributes</span></a></li></ul></li><!-- <li ng-class="{active: vm.$state.includes(\'group-type\')}" class="treeview"\r\n                                    ng-if="has_ROLE_USER_ADMIN">\r\n                                    <a ui-sref="group-type" id="group" ng-click="vm.toggleNavbar(\'group\')">\r\n                                        <i class="fa fa-suitcase"></i>\r\n                                        <span translate="global.menu.entities.groupType">Group Type</span>\r\n                                        <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span>\r\n                                    </a>\r\n                                    <ul class="treeview-menu" ng-style="close">\r\n                                        <li ui-sref-active="active">\r\n                                            <a ui-sref="group">\r\n                                                <i class="fa fa-group"></i>\r\n                                                <span>Groups</span>\r\n\r\n                                            </a>\r\n                                        </li>\r\n                                        <li ui-sref-active="active">\r\n                                            <a ui-sref="custom-group-type-attribute">\r\n                                                <i class="fa fa-briefcase"></i>\r\n                                                <span>Group Type Attributes</span>\r\n\r\n                                            </a>\r\n                                        </li>\r\n                                    </ul>\r\n                                </li> --><li ng-class="{active: vm.$state.includes(\'work-flow-type\')}" ng-if="vm.accessRoleRolloutAdmin || vm.accessRolePlanningAdmin" class="treeview"><a ui-sref="work-flow-type"><i class="fa fa-suitcase"></i> <span translate="global.menu.entities.workFlowType">Work Flow Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-work-flow-type-attribute"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.customWorkFlowTypeAttribute">Custom Work Flow Type Attribute</span></a></li></ul></li><!--  <li ng-class="{active: vm.$state.includes(\'workorder-type\')}" class="treeview"\r\n                                    ng-if="vm.accessRolePlanningAdmin">\r\n                                    <a ui-sref="workorder-type">\r\n                                        <i class="fa fa-suitcase"></i>\r\n                                        <span translate="global.menu.entities.workorderType">Work Order Type</span>\r\n                                        <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span>\r\n                                    </a>\r\n                                    <ul class="treeview-menu" ng-style="close">\r\n                                        <li ui-sref-active="active">\r\n                                            <a ui-sref="custom-workorder-type-attribute">\r\n                                                <i class="fa fa-briefcase"></i>\r\n                                                <span translate="global.menu.entities.customWorkOrderTypeAttribute">Custom work\r\n                                                    order Type Attribute</span>\r\n                                            </a>\r\n                                        </li>\r\n                                    </ul>\r\n                                </li> --><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="show-hide-case"><i class="fa fa-check-square-o"></i> <span translate="">Show/Hide Incident</span></a></li><li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN"><a ui-sref="trakeye-type"><i class="fa fa-eye"></i> <span translate="global.menu.entities.trakeyeType">User Type</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li></ul><hr></li><li ng-class="{active: vm.$state.includes(\'tr-project\') || vm.$state.includes(\'tr-route\') || vm.$state.includes(\'tr-section\') \r\n                        || vm.$state.includes(\'tr-resource\') || vm.$state.includes(\'tr-vendor\')\r\n                        || vm.$state.includes(\'tr-terrain\') || vm.$state.includes(\'tr-row\') || vm.$state.includes(\'tr-material\') || vm.$state.includes(\'tr-task\') || vm.$state.includes(\'tr-workorder\') }" class="treeview" ng-if="Roles.PROJECT_SIDEBAR"><!-- ng-show="Roles.PROJECT_SIDEBAR"> Need to hide Rollout management--> <a href="" id="rollout" ng-click="vm.toggleNavbar(\'rollout\')"><i class="fa fa-th"></i> <span class="">Rollout Management</span> <span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><!-- <li ui-sref-active="active">\r\n                            <a ui-sref="asset-route">\r\n                                <i class="fa fa-cubes"></i>\r\n                                <span>Assets View</span>\r\n                            </a>\r\n                        </li> --><!-- <li ui-sref-active="active">\r\n                            <a ui-sref="project-tree">\r\n                                <i class="fa fa-cubes"></i>\r\n                                <span>Project Tree</span>\r\n                            </a>\r\n                        </li> --><li ui-sref-active="active" ng-show="Roles.PROJECT_SIDEBAR"><a ui-sref="tr-project"><i class="fa fa-file"></i> <span translate="global.menu.entities.trProject">Tr Project</span></a></li><li ui-sref-active="active" ng-show="Roles.ROUTE_SIDEBAR"><a ui-sref="tr-route-plan"><i class="fa fa-code-fork"></i> <span>Routes</span></a></li><li ui-sref-active="active" ng-show="Roles.ROUTE_SIDEBAR"><a ui-sref="tr-route"><i class="fa fa-code-fork"></i> <span>Rings/Path</span></a></li><li ui-sref-active="active" ng-show="Roles.SECTION_SIDEBAR"><a ui-sref="tr-section"><i class="fa fa-columns"></i> <span translate="global.menu.entities.trSection">Tr Section</span></a></li><li ui-sref-active="active" ng-show="Roles.TASK_SIDEBAR"><a ui-sref="tr-task"><i class="fa fa-tasks"></i> <span translate="global.menu.entities.trTask">Tr Task</span></a></li><li ui-sref-active="active" ng-show="Roles.VENDOR_SIDEBAR"><a ui-sref="tr-vendor"><i class="fa fa-tasks"></i> <span>Vendor</span></a></li><!--  <li ui-sref-active="active" ng-show="Roles.SECTION_SIDEBAR">\r\n                            <a ui-sref="tr-terrain">\r\n                                <img ng-src="content/images/terrainIcon.png" class="terrainImg" />\r\n                                <span>Terrain</span>\r\n                            </a>\r\n                        </li> --><!-- <li ui-sref-active="active" ng-show="Roles.SECTION_SIDEBAR">\r\n                            <a ui-sref="tr-row">\r\n                                <i class="fa fa-tasks"></i>\r\n                                <span>ROW</span>\r\n                            </a>\r\n                        </li> --><li ui-sref-active="active" ng-show="Roles.WORKORDER_SIDEBAR"><a ui-sref="tr-workorder"><i class="fa fa-file"></i> <span>Work Order</span></a></li><li ui-sref-active="active" ng-show="Roles.RESOURCE_SIDEBAR"><a ui-sref="tr-resource"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.trResource">Tr Resource</span></a></li><li ui-sref-active="active" ng-show="Roles.MATERIAL_SIDEBAR"><a ui-sref="tr-material"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.trMaterial">Tr Material</span></a></li><li ng-class="{active: vm.$state.includes(\'entity-menu\')}" class="treeview" ng-show="Roles.ENTITY_CONFIGURATION"><a href="" id="entity-menu" ng-click="vm.toggleNavbar(\'entity-menu\')"><i class="fa fa-th-list"></i> <span class="" translate="global.menu.entities.main">Entities </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><!-- <li ui-sref-active="active">\r\n                                    <a ui-sref="geofence">\r\n                                        <i class="fa fa-street-view"></i>\r\n                                        <span translate="global.menu.entities.geofence">Geofence</span>\r\n                                    </a>\r\n                                </li> --><!-- <li ng-class="{active: vm.$state.includes(\'trworkorder-type\')}" class="treeview"\r\n                                           >\r\n                                            <a ui-sref="trworkorder-type" id="project-type"\r\n                                                ng-click="vm.toggleNavbar(\'trworkorder-type\')">\r\n                                                <i class="fa fa-briefcase"></i>\r\n                                                <span translate="global.menu.entities.trworkorder-type">TrWorkOrder\r\n                                                    Type</span>\r\n                                                <span class="pull-right-container"><i\r\n                                                        class="fa fa-plus pull-right"></i></span>\r\n                                            </a>\r\n                                            <ul class="treeview-menu" ng-style="close">\r\n                                                <li ui-sref-active="active">\r\n                                                    <a ui-sref="custom-trworkorder-type-attribute">\r\n                                                        <i class="fa fa-briefcase"></i>\r\n                                                        <span>Work Order Type Attributes</span>\r\n                                                    </a>\r\n                                                </li>\r\n                                            </ul>\r\n                                        </li> --><!-- <li ng-class="{active: vm.$state.includes(\'project-type\')}" class="treeview"\r\n                                            >\r\n                                            <a ui-sref="project-type" id="project-type"\r\n                                                ng-click="vm.toggleNavbar(\'project-type\')">\r\n                                                <i class="fa fa-briefcase"></i>\r\n                                                <span translate="global.menu.entities.projectType">Project Type</span>\r\n                                                <span class="pull-right-container"><i\r\n                                                        class="fa fa-plus pull-right"></i></span>\r\n                                            </a>\r\n                                            <ul class="treeview-menu" ng-style="close">\r\n                                                <li ui-sref-active="active">\r\n                                                    <a ui-sref="custom-project-type-attribute">\r\n                                                        <i class="fa fa-briefcase"></i>\r\n                                                        <span>Project Type Attributes</span>\r\n                                                    </a>\r\n                                                </li>\r\n                                            </ul>\r\n                                        </li> --><!-- <li ng-class="{active: vm.$state.includes(\'route-type\')}" class="treeview"\r\n                                            >\r\n                                            <a ui-sref="route-type" id="route-type"\r\n                                                ng-click="vm.toggleNavbar(\'route-type\')">\r\n                                                <i class="fa fa-briefcase"></i>\r\n                                                <span translate="global.menu.entities.routeType">Route Type</span>\r\n                                                <span class="pull-right-container"><i\r\n                                                        class="fa fa-plus pull-right"></i></span>\r\n                                            </a>\r\n                                            <ul class="treeview-menu" ng-style="close">\r\n                                                <li ui-sref-active="active">\r\n                                                    <a ui-sref="custom-route-type-attribute">\r\n                                                        <i class="fa fa-briefcase"></i>\r\n                                                        <span>Route Type Attributes</span>\r\n                                                    </a>\r\n                                                </li>\r\n                                            </ul>\r\n                                        </li> --><li ng-class="{active: vm.$state.includes(\'section-type\')}" class="treeview" ng-show="Roles.ENTITY_CONFIGURATION"><a ui-sref="section-type" id="section-type" ng-click="vm.toggleNavbar(\'section-type\')"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.sectionType">Section Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-section-type-attribute"><i class="fa fa-briefcase"></i> <span>Section Type Attributes</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'resource-type\')}" class="treeview"><a ui-sref="resource-type" id="resource-type" ng-click="vm.toggleNavbar(\'resource-type\')"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.resourceType">Resource Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-resource-type-attribute"><i class="fa fa-briefcase"></i> <span>Resource Type Attributes</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'material-type\')}" class="treeview"><a ui-sref="material-type" id="material-type" ng-click="vm.toggleNavbar(\'material-type\')"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.materialType">Material Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-material-type-attribute"><i class="fa fa-briefcase"></i> <span>Material Type Attributes</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'task-type\')}" class="treeview"><a ui-sref="task-type" id="task-type" ng-click="vm.toggleNavbar(\'task-type\')"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.taskType">Task Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-task-type-attribute"><i class="fa fa-briefcase"></i> <span>Task Type Attributes</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'log-type\')}" class="treeview"><a ui-sref="log-type" id="log-type" ng-click="vm.toggleNavbar(\'log-type\')"><i class="fa fa-briefcase"></i> <span translate="global.menu.entities.logType">Log Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-log-type-attribute"><i class="fa fa-briefcase"></i> <span>Log Type Attributes</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'terrain-type\')}" class="treeview"><a ui-sref="terrain-type" id="terrain-type" ng-click="vm.toggleNavbar(\'terrain-type\')"><i class="fa fa-area-chart"></i> <span translate="global.menu.entities.terrainType">Terrain Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-terrain-type-attribute"><i class="fa fa-briefcase"></i> <span>Terrain Type Attributes</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'row-type\')}" class="treeview"><a ui-sref="row-type" id="row-type" ng-click="vm.toggleNavbar(\'row-type\')"><i class="fa fa-area-chart"></i> <span translate="global.menu.entities.rowType">Row Type</span> <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="custom-row-type-attribute"><i class="fa fa-briefcase"></i> <span>Row Type Attributes</span></a></li></ul></li><!--  <li ng-class="{active: vm.$state.includes(\'work-flow-type\')}"\r\n                                            ng-if="vm.accessRoleRolloutAdmin || vm.accessRolePlanningAdmin"\r\n                                            class="treeview">\r\n                                            <a ui-sref="work-flow-type">\r\n                                                <i class="fa fa-suitcase"></i>\r\n                                                <span translate="global.menu.entities.workFlowType">Work Flow\r\n                                                    Type</span>\r\n                                                <span class="pull-right-container"><i\r\n                                                        class="fa fa-plus pull-right"></i></span>\r\n                                            </a>\r\n                                            <ul class="treeview-menu" ng-style="close">\r\n                                                <li ui-sref-active="active">\r\n                                                    <a ui-sref="custom-work-flow-type-attribute">\r\n                                                        <i class="fa fa-briefcase"></i>\r\n                                                        <span\r\n                                                            translate="global.menu.entities.customWorkFlowTypeAttribute">Custom\r\n                                                            Work\r\n                                                            Flow Type Attribute</span>\r\n                                                    </a>\r\n                                                </li>\r\n                                            </ul>\r\n                                        </li> --><!--  <li ng-class="{active: vm.$state.includes(\'workorder-type\')}" class="treeview"\r\n                                    ng-if="vm.accessRolePlanningAdmin">\r\n                                    <a ui-sref="workorder-type">\r\n                                        <i class="fa fa-suitcase"></i>\r\n                                        <span translate="global.menu.entities.workorderType">Work Order Type</span>\r\n                                        <span class="pull-right-container"><i class="fa fa-plus pull-right"></i></span>\r\n                                    </a>\r\n                                    <ul class="treeview-menu" ng-style="close">\r\n                                        <li ui-sref-active="active">\r\n                                            <a ui-sref="custom-workorder-type-attribute">\r\n                                                <i class="fa fa-briefcase"></i>\r\n                                                <span translate="global.menu.entities.customWorkOrderTypeAttribute">Custom work\r\n                                                    order Type Attribute</span>\r\n                                            </a>\r\n                                        </li>\r\n                                    </ul>\r\n                                </li> --><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'report-menu\')}" class="treeview"><a href="" id="report-menu" ng-click="vm.toggleNavbar(\'report-menu\')" ng-if="vm.showRolloutReport"><i class="fa fa-database"></i> <span class="" translate="global.menu.report">Reports </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close" ng-if="vm.showRolloutTaskLogReport"><li ui-sref-active="active"><a ui-sref="task-log-report"><i class="fa fa-download"></i> <span translate="">Task Log Report</span></a></li></ul></li></ul></li><!--  <hr ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA\r\n                ||  has_ROLE_VENDOR_ADMIN || vm.accessRolePlanningAdmin" /> --><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!-- <li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN">\r\n                    <a ui-sref="feasibility-check" ng-click="vm.collapseNavbar()">\r\n                        <i class="fa fa-cog" aria-hidden="true"></i>\r\n                        <span data-translate="global.menu.entities.feasibilityCheck">Feasibility Check</span>\r\n                    </a>\r\n                </li> --><!--<li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN">\r\n                    <a ui-sref="tr-case" ng-click="vm.collapseNavbar()">\r\n                        <i class="fa fa-th-large"></i>\r\n                        <span translate="global.menu.entities.trCase">Incident</span>\r\n                    </a>\r\n                </li>--><!--  <li ui-sref-active="active" ng-if="vm.accessRolePlanning">\r\n                    <a ui-sref="work-order" ng-click="vm.collapseNavbar()">\r\n                        <i class="fa fa-th-large"></i>\r\n                        <span>Work Orders</span>\r\n                    </a>\r\n                </li> --><!-- <li ui-sref-active="active" ng-if="vm.accessRoleRollout || vm.accessRolePlanning">\r\n                    <a ui-sref="work-flow" ng-click="vm.collapseNavbar()">\r\n                        <i class="fa fa-th-large"></i>\r\n                        <span>Workflows</span>\r\n                    </a>\r\n                </li> --><!--  <li ui-sref-active="active" ng-if="has_ROLE_USER || has_ROLE_USER_ADMIN || has_ROLE_VENDOR || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER || has_ROLE_VENDOR_ADMIN">\r\n                    <a ui-sref="task-log" ng-click="vm.collapseNavbar()">\r\n                        <i class="fa fa-tasks"></i>\r\n                        <span translate="dailyTaskLogs.title"></span>\r\n                    </a>\r\n                </li> --><!-- <li ui-sref-active="active" ng-if="has_ROLE_USER_ADMIN || has_ROLE_HOD || has_ROLE_CITY_MANAGER || has_ROLE_BA || has_ROLE_CITY_PLANNER || has_ROLE_ASSISTANT_MANAGER || has_ROLE_OA|| has_ROLE_TEAM_LEADER \r\n                || has_ROLE_NETWORK_ENGINEER || has_ROLE_FE || has_ROLE_FRT || has_ROLE_PATROLLER ">\r\n                    <a ui-sref="tr-service" ng-click="vm.collapseNavbar()">\r\n                        <i class="fa fa-server"></i>\r\n                        <span translate="global.menu.entities.trService">Tr Service</span>\r\n                    </a>\r\n                </li> --><!-- <li ng-class="{active: vm.$state.includes(\'admin\')}" ui-sref-active="active" ng-if="has_ROLE_USER" class="treeview">\r\n                    <a ui-sref="location-log" ng-click="vm.collapseNavbar()">\r\n                        <i class="fa fa-map-marker"></i>\r\n                        <span translate="global.menu.entities.locationLog">Location Log</span>\r\n                    </a>\r\n                </li> --><li ng-class="{active: vm.$state.includes(\'admin\')}" class="treeview" ng-if="has_ROLE_SUPER_ADMIN"><a href="" id="entity-menu" ng-click="vm.toggleNavbar(\'entity-menu\')"><i class="fa fa-university"></i> <span class="" translate="global.menu.admin.main">Administration </span><span class="pull-right-container"><i class="fa fa-chevron-down rotate pull-right"></i></span></a><ul class="treeview-menu" ng-style="close"><li ui-sref-active="active"><a ui-sref="tenant"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.tenant">Tenant</span></a></li><!-- <li ui-sref-active="active">\r\n                            <a ui-sref="customer-management">\r\n                                <i class="fa fa-user"></i>\r\n                                <span translate="global.menu.admin.customerManagement">Customer management</span>\r\n                            </a>\r\n                        </li> --><li ui-sref-active="active"><a ui-sref="jhi-metrics"><i class="fa fa-dashboard"></i> <span translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health"><i class="fa fa-heart"></i> <span translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration"><i class="fa fa-list-alt"></i> <span translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits"><i class="fa fa-bell"></i> <span translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs"><i class="fa fa-tasks"></i> <span translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs"><i class="fa fa-book"></i> <span translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex"><i class="fa fa-refresh"></i> <span translate="global.menu.admin.elasticsearch-reindex">Elasticsearch Reindex</span></a></li><li ui-sref-active="active"><a ui-sref="asset-geofence-mapping"><i class="fa fa-refresh"></i> <span translate="global.menu.admin.asset-geo-mapping">Asset Geo Mapping</span></a></li><li ui-sref-active="active"><a ui-sref="config"><i class="fa fa-briefcase"></i> <span translate="">Config</span></a></li><!-- <li ui-sref-active="active">\r\n                            <a ui-sref="reassociate-asset-geofence">\r\n                                <i class="fa fa-link"></i>\r\n                                <span translate="global.menu.admin.reassociate-asset-geofence">Reassociate Asset\r\n                                    Geofence\r\n                                    Reindex</span>\r\n                            </a>\r\n                        </li> /--><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!--                 <li ng-class="{active: vm.$state.includes(\'report\')}" class="treeview" ng-if="has_ROLE_USER_ADMIN"> --><!--                     <a href="" id="report-menu" ng-click="vm.toggleNavbar()"> --><!--                         <i class="fa fa-database"></i> --><!--                         <span class="" translate="global.menu.reportcharts.report-charts"> --><!--                             Report Charts --><!--                         </span> --><!--                         <span class="pull-right-container"><i class="fa fa-chevron-down pull-right"></i></span> --><!--                     </a> --><!--                     <ul class="treeview-menu" ng-style="close"> --><!--                         <li ui-sref-active="active"> --><!--                             <a ui-sref="case-report"> --><!--                                 <i class="fa fa-bandcamp"></i> --><!--                                 <span translate="global.menu.reportcharts.case-report"> Incident Report </span> --><!--                             </a> --><!--                         </li> --><!--                         <li ui-sref-active="active"> --><!--                             <a ui-sref="distance-report"> --><!--                                 <i class="fa fa-bandcamp"></i> --><!--                                 <span translate="global.menu.reportcharts.distance-report"> Distance Report </span> --><!--                             </a> --><!--                         </li> --><!--                     </ul> --><!--                 </li> --><!--<li ui-sref-active="active" class="treeview" ng-controller="JhiLanguageController as languageVm">\r\n                    <a href="" ng-if="languageVm.languages.length > 1">\r\n                            <i class="fa fa-flag"></i>\r\n                            <span translate="global.menu.language">Language</span>\r\n                            <span class="pull-right-container"><i class="fa fa-chevron-down pull-right"></i></span>\r\n                    </a>\r\n                    <ul class="treeview-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1">\r\n                        <li active-menu="{{language}}" ng-repeat="language in languageVm.languages">\r\n                            <a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a>\r\n                        </li>\r\n                    </ul>\r\n                </li>--></ul></section><!-- /.sidebar --></aside><div class="col-md-12 col-sm-12 text-center footerLogin" ng-switch-when="false"><!--  <strong>Copyright &copy; {{vm.currYear}} Polycab All\r\n            rights reserved\r\n        </strong> --><center><!--  <img ng-src="content/images/xcentricFiberify.png" class="img-responsive sidebarlogo" style="height:32px" /> --></center></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div class="content"><div class="row"><div class="col-md-6 col-md-offset-3"><jhi-alert-error></jhi-alert-error></div><div class="col-md-4 col-md-offset-4"><div class="box box-info login-panel" ng-if="vm.verifyaccount != \'true\'"><div class="alert alert-danger"><p translate="reset.finish.messages.emaillinkinvalid">Email link is invalid. Please use latest email link.</p></div></div><div class="box box-info login-panel" ng-if="vm.verifyaccount"><div class="box-header"><h3 class="box-title" translate="reset.finish.title">Set Password</h3></div><div class="box-body"><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><!-- <div class="alert alert-danger" ng-show="vm.error">\r\n                <p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p>\r\n            </div> --><!-- <div class="alert alert-danger" ng-show="vm.emaillinkinvalid">\r\n                <p translate="reset.finish.messages.emaillinkinvalid">Email link is invalid. Please use latest email link.</p>\r\n            </div> --><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" ui-sref="login">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">password</label> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><div class="form-group"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-block" translate="reset.finish.form.button">Set Password</button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="content"><div class="row"><div class="col-md-6 col-md-offset-3"><jhi-alert-error></jhi-alert-error></div></div><div class="row mt-45"><div class="col-md-4 col-md-offset-4"><div class="box box-info login-panel"><div class="box-header"><h3 class="box-title" translate="reset.request.title">Reset your password</h3></div><form name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="box-body"><jhi-alert></jhi-alert><div class="alert-messages mt-20"><!-- <div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists">\r\n\t\t\t                <strong>Username isn\'t registered!</strong> Please check and try again.\r\n\t\t\t            </div>\r\n\t\t\t            <div class="alert alert-danger" translate="reset.request.messages.userdeactivated" ng-show="vm.errorUserDeactivate">\r\n\t\t\t                <strong>User is deactivated. </strong>\r\n\t\t\t            </div>\r\n\t\t\t            <div class="alert alert-danger" translate="reset.request.messages.countExceeded" ng-show="vm.countExceeded">\r\n\t\t\t                <strong>Reset password count is exceeded for the day. </strong>\r\n\t\t\t            </div>  --><!-- <div class="alert alert-success" ng-show="vm.success == \'OK\'">\r\n\t\t\t                <p translate="reset.request.messages.success">Password reset link has been sent to your email.</p>\r\n\t\t\t            </div> --></div><div class="form-group"><input type="text" class="form-control" id="username" name="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.resetAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.username.$invalid"><!-- <p class="help-block"\r\n\t\t\t\t\t\t\t   ng-show="form.username.$error.required" translate="global.messages.validate.username.required">\r\n\t\t\t\t\t\t\t\tYour username is required.\r\n\t\t\t\t\t\t\t</p> --><p class="help-block" ng-show="form.username.$error.maxlength" translate="global.messages.validate.username.maxlength">Your username cannot be longer than 50 characters.</p></div></div><div class="form-group mt-20"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-block btn-sm" translate="reset.request.form.button">Reset</button></div></div><div class="box-footer bg-default text-center"><a class="alert-link ng-scope" ui-sref="login" translate="reset.request.form.signin">Go Back to login</a></div></form></div></div></div></div>');
$templateCache.put('app/account/feasibility/verify/finish/feasibility.verify.finish.html','<div class="content"><div class="row"><div class="col-md-6 col-md-offset-3"><jhi-alert-error></jhi-alert-error></div><div class="col-md-4 col-md-offset-4"><div class="box box-info login-panel"><div class="box-header"><h3 class="box-title" translate="trakeyeApp.feasibilityVerify.home.title">Verify Feasib</h3></div><div class="alert alert-success" ng-show="vm.success"><p translate="trakeyeApp.feasibilityVerify.home.success" translate-compile><strong>Feasibility Success.</strong></p></div><div><form name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><button type="submit" class="btn btn-primary btn-block" translate="trakeyeApp.feasibilityVerify.home.button">Verify Feasibility</button></div></form></div><div><p translate="trakeyeApp.feasibilityVerify.home.note">Note</p></div></div></div></div></div>');}]);})();